
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredbf1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredbf1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4d82739dd229d539$var$Mg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Ng = null, $4d82739dd229d539$var$Og = null, $4d82739dd229d539$var$Pg = null;
function $4d82739dd229d539$var$Qg() {
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Ng = null;
}
function $4d82739dd229d539$var$Rg(a) {
    var b = $4d82739dd229d539$var$Mg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Mg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$Tg(a, b) {
    $4d82739dd229d539$var$Ng = a;
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$Ug = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$Vg(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Og) {
            if (null === $4d82739dd229d539$var$Ng) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Og = a;
            $4d82739dd229d539$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Og.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$Wg = null;
function $4d82739dd229d539$var$Xg(a) {
    null === $4d82739dd229d539$var$Wg ? $4d82739dd229d539$var$Wg = [
        a
    ] : $4d82739dd229d539$var$Wg.push(a);
}
function $4d82739dd229d539$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$Zg(a, d);
}
function $4d82739dd229d539$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$$g = !1;
function $4d82739dd229d539$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$Zg(a, c);
}
function $4d82739dd229d539$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$jh = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$L(), d = $4d82739dd229d539$var$lh(a), e = $4d82739dd229d539$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$dh(a, e, d);
        null !== b && ($4d82739dd229d539$var$mh(b, a, d, c), $4d82739dd229d539$var$eh(b, a, d));
    }
};
function $4d82739dd229d539$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Vg(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$jh;
    $4d82739dd229d539$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Vg(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$nh.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4d82739dd229d539$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$sh(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$sh(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$zh(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Bh = $4d82739dd229d539$var$vh(!0), $4d82739dd229d539$var$Ch = $4d82739dd229d539$var$vh(!1), $4d82739dd229d539$var$Dh = {}, $4d82739dd229d539$var$Eh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh);
function $4d82739dd229d539$var$Hh(a) {
    if (a === $4d82739dd229d539$var$Dh) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$Ih(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Gh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, $4d82739dd229d539$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, b);
}
function $4d82739dd229d539$var$Jh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Gh);
}
function $4d82739dd229d539$var$Kh(a) {
    $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
    var b = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, c));
}
function $4d82739dd229d539$var$Lh(a) {
    $4d82739dd229d539$var$Fh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$Eh), $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh));
}
var $4d82739dd229d539$var$M = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nh = [];
function $4d82739dd229d539$var$Oh() {
    for(var a = 0; a < $4d82739dd229d539$var$Nh.length; a++)$4d82739dd229d539$var$Nh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Nh.length = 0;
}
var $4d82739dd229d539$var$Ph = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Qh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Rh = 0, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$P = null, $4d82739dd229d539$var$Sh = !1, $4d82739dd229d539$var$Th = !1, $4d82739dd229d539$var$Uh = 0, $4d82739dd229d539$var$Vh = 0;
function $4d82739dd229d539$var$Q() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Xh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Rh = f;
    $4d82739dd229d539$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Ph.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Yh : $4d82739dd229d539$var$Zh;
    a = c(d, e);
    if ($4d82739dd229d539$var$Th) {
        f = 0;
        do {
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$$h;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Th);
    }
    $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
    b = null !== $4d82739dd229d539$var$O && null !== $4d82739dd229d539$var$O.next;
    $4d82739dd229d539$var$Rh = 0;
    $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
    $4d82739dd229d539$var$Sh = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$bi() {
    var a = 0 !== $4d82739dd229d539$var$Uh;
    $4d82739dd229d539$var$Uh = 0;
    return a;
}
function $4d82739dd229d539$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$di() {
    if (null === $4d82739dd229d539$var$O) {
        var a = $4d82739dd229d539$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$O.next;
    var b = null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState : $4d82739dd229d539$var$P.next;
    if (null !== b) $4d82739dd229d539$var$P = b, $4d82739dd229d539$var$O = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$O = a;
        a = {
            memoizedState: $4d82739dd229d539$var$O.memoizedState,
            baseState: $4d82739dd229d539$var$O.baseState,
            baseQueue: $4d82739dd229d539$var$O.baseQueue,
            queue: $4d82739dd229d539$var$O.queue,
            next: null
        };
        null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    }
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$N.lanes |= m;
                $4d82739dd229d539$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$N.lanes |= f, $4d82739dd229d539$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$gi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$hi() {}
function $4d82739dd229d539$var$ii(a, b) {
    var c = $4d82739dd229d539$var$N, d = $4d82739dd229d539$var$di(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$Ug = !0);
    d = d.queue;
    $4d82739dd229d539$var$ji($4d82739dd229d539$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$P && $4d82739dd229d539$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
}
function $4d82739dd229d539$var$ki(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
    });
}
function $4d82739dd229d539$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$pi(a) {
    var b = $4d82739dd229d539$var$Zg(a, 1);
    null !== b && $4d82739dd229d539$var$mh(b, a, 1, -1);
}
function $4d82739dd229d539$var$qi(a) {
    var b = $4d82739dd229d539$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ri.bind(null, $4d82739dd229d539$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$si() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$ti(a, b, c, d) {
    var e = $4d82739dd229d539$var$ci();
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$ui(a, b, c, d) {
    var e = $4d82739dd229d539$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$O) {
        var g = $4d82739dd229d539$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Wh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$li(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, f, d);
}
function $4d82739dd229d539$var$vi(a, b) {
    return $4d82739dd229d539$var$ti(8390656, 8, a, b);
}
function $4d82739dd229d539$var$ji(a, b) {
    return $4d82739dd229d539$var$ui(2048, 8, a, b);
}
function $4d82739dd229d539$var$wi(a, b) {
    return $4d82739dd229d539$var$ui(4, 2, a, b);
}
function $4d82739dd229d539$var$xi(a, b) {
    return $4d82739dd229d539$var$ui(4, 4, a, b);
}
function $4d82739dd229d539$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$ui(4, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$Ai() {}
function $4d82739dd229d539$var$Bi(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Ci(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Di(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$Ug = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$N.lanes |= c, $4d82739dd229d539$var$hh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$Ei(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Qh.transition;
    $4d82739dd229d539$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Qh.transition = d;
    }
}
function $4d82739dd229d539$var$Fi() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, c);
    else if (c = $4d82739dd229d539$var$Yg(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$L();
        $4d82739dd229d539$var$mh(c, a, d, e);
        $4d82739dd229d539$var$Ji(c, b, d);
    }
}
function $4d82739dd229d539$var$ri(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$Yg(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$L(), $4d82739dd229d539$var$mh(c, a, d, e), $4d82739dd229d539$var$Ji(c, b, d));
    }
}
function $4d82739dd229d539$var$Hi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$N || null !== b && b === $4d82739dd229d539$var$N;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$ai = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Q,
    useContext: $4d82739dd229d539$var$Q,
    useEffect: $4d82739dd229d539$var$Q,
    useImperativeHandle: $4d82739dd229d539$var$Q,
    useInsertionEffect: $4d82739dd229d539$var$Q,
    useLayoutEffect: $4d82739dd229d539$var$Q,
    useMemo: $4d82739dd229d539$var$Q,
    useReducer: $4d82739dd229d539$var$Q,
    useRef: $4d82739dd229d539$var$Q,
    useState: $4d82739dd229d539$var$Q,
    useDebugValue: $4d82739dd229d539$var$Q,
    useDeferredValue: $4d82739dd229d539$var$Q,
    useTransition: $4d82739dd229d539$var$Q,
    useMutableSource: $4d82739dd229d539$var$Q,
    useSyncExternalStore: $4d82739dd229d539$var$Q,
    useId: $4d82739dd229d539$var$Q,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Yh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ti(4194308, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$Gi.bind(null, $4d82739dd229d539$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$qi,
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$qi(!1), b = a[0];
        a = $4d82739dd229d539$var$Ei.bind(null, a[1]);
        $4d82739dd229d539$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$N, e = $4d82739dd229d539$var$ci();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$vi($4d82739dd229d539$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$ci(), b = $4d82739dd229d539$var$R.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Zh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$fi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$$h = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$gi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return null === $4d82739dd229d539$var$O ? b.memoizedState = a : $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Oi(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Pi || ($4d82739dd229d539$var$Pi = !0, $4d82739dd229d539$var$Qi = d);
        $4d82739dd229d539$var$Mi(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Mi(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Si ? $4d82739dd229d539$var$Si = new Set([
            this
        ]) : $4d82739dd229d539$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$ch(-1, 1), b.tag = 2, $4d82739dd229d539$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Xi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$Ug = !1;
function $4d82739dd229d539$var$Yi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Ch(b, null, c, d) : $4d82739dd229d539$var$Bh(b, a.child, c, d);
}
function $4d82739dd229d539$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Tg(b, e);
    d = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$cj(a, b, f, d, e);
        a = $4d82739dd229d539$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$Ug = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$$i(a, b, e);
        }
    }
    return $4d82739dd229d539$var$dj(a, b, c, d, e);
}
function $4d82739dd229d539$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj);
            $4d82739dd229d539$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= d;
    $4d82739dd229d539$var$Yi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$dj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$Tg(b, e);
    c = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$Tg(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$jj(a, b), $4d82739dd229d539$var$ph(b, c, d), $4d82739dd229d539$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$Vg(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$qh(b, g, d, l);
        $4d82739dd229d539$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof m && ($4d82739dd229d539$var$kh(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Vg(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$qh(b, g, d, k);
        $4d82739dd229d539$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof y && ($4d82739dd229d539$var$kh(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$kj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$kj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$$i(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Bh(b, a.child, null, f), b.child = $4d82739dd229d539$var$Bh(b, null, h, f)) : $4d82739dd229d539$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$Ih(a, b.containerInfo);
}
function $4d82739dd229d539$var$mj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Yi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$qj(g, d, 0, null), a = $4d82739dd229d539$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$oj(c), b.memoizedState = $4d82739dd229d539$var$nj, a) : $4d82739dd229d539$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$wh(h, f) : (f = $4d82739dd229d539$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$rj(a, b) {
    b = $4d82739dd229d539$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$tj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Bh(b, a.child, null, c);
    a = $4d82739dd229d539$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$oj(g);
        b.memoizedState = $4d82739dd229d539$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Li(f, d, void 0);
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$Ug || h) {
        d = $4d82739dd229d539$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$Zg(a, e), $4d82739dd229d539$var$mh(d, a, e, -1));
        }
        $4d82739dd229d539$var$uj();
        d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$Sg(a.return, b, c);
}
function $4d82739dd229d539$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Yi(a, b, d.children, c);
    d = $4d82739dd229d539$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$wj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$lj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Kh(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$pj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
                a = $4d82739dd229d539$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$ej(a, b, c);
    }
    return $4d82739dd229d539$var$$i(a, b, c);
}
var $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj, $4d82739dd229d539$var$Dj;
$4d82739dd229d539$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Bj = function() {};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Ej(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$Jh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Bj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Lh(b);
            var e = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
                $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$M.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$Bj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Ej(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Hj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$M.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$gj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Jj(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Lh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$M), null;
        case 4:
            return $4d82739dd229d539$var$Jh(), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Kj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Oj = !1;
function $4d82739dd229d539$var$Pj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Oj;
    $4d82739dd229d539$var$Oj = !1;
    return n;
}
function $4d82739dd229d539$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Xj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Xj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Yj = !1;
function $4d82739dd229d539$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$ak(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$ak(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Mj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Yj = !0;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Nj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Zj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Zj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Zj(a, b, c);
    }
}
function $4d82739dd229d539$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Lj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Yj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$ak(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$ek(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Qj(3, a, a.return), $4d82739dd229d539$var$Rj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Qj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            break;
        case 13:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$gk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$fk(a);
    }
}
function $4d82739dd229d539$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$jk(a, b, c);
}
function $4d82739dd229d539$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Kj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Kj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$kk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$kk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$jk(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Kj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$lk(a, b, c);
    }
}
function $4d82739dd229d539$var$lk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Sj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$hk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$mk = Math.ceil, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$pk = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$gj = 0, $4d82739dd229d539$var$fj = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$qk = null, $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = 0, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$gk = 0, $4d82739dd229d539$var$Hj = Infinity, $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Pi = !1, $4d82739dd229d539$var$Qi = null, $4d82739dd229d539$var$Si = null, $4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = null, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, $4d82739dd229d539$var$Bk = -1, $4d82739dd229d539$var$Ck = 0;
function $4d82739dd229d539$var$L() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Bk ? $4d82739dd229d539$var$Bk : $4d82739dd229d539$var$Bk = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Ck && ($4d82739dd229d539$var$Ck = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Ck;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$mh(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$zk) throw $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$R) a === $4d82739dd229d539$var$R && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$rk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Ek(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Ek(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Fk.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Fk.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Gk(c, $4d82739dd229d539$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Hk(a, b) {
    $4d82739dd229d539$var$Bk = -1;
    $4d82739dd229d539$var$Ck = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Ik() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Jk(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Kk();
        if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Lk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Mk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Nk(a, h);
        }
        $4d82739dd229d539$var$Qg();
        $4d82739dd229d539$var$nk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Ok(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Pk(e) && (b = $4d82739dd229d539$var$Jk(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Ok(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$gk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Hk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Ok(a, b) {
    var c = $4d82739dd229d539$var$tk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Lk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Jk(a, b);
    2 !== a && (b = $4d82739dd229d539$var$uk, $4d82739dd229d539$var$uk = c, null !== b && $4d82739dd229d539$var$Gj(b));
    return a;
}
function $4d82739dd229d539$var$Gj(a) {
    null === $4d82739dd229d539$var$uk ? $4d82739dd229d539$var$uk = a : $4d82739dd229d539$var$uk.push.apply($4d82739dd229d539$var$uk, a);
}
function $4d82739dd229d539$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Dk(a, b) {
    b &= ~$4d82739dd229d539$var$sk;
    b &= ~$4d82739dd229d539$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Fk(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Ok(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, b), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Rk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Sk(a) {
    null !== $4d82739dd229d539$var$xk && 0 === $4d82739dd229d539$var$xk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$pk.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$pk.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Ij() {
    $4d82739dd229d539$var$gj = $4d82739dd229d539$var$fj.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$fj);
}
function $4d82739dd229d539$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$Jh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Oh();
                break;
            case 5:
                $4d82739dd229d539$var$Lh(d);
                break;
            case 4:
                $4d82739dd229d539$var$Jh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 10:
                $4d82739dd229d539$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Ij();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$R = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$wh(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$gj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$qk = null;
    $4d82739dd229d539$var$sk = $4d82739dd229d539$var$rk = $4d82739dd229d539$var$hh = 0;
    $4d82739dd229d539$var$uk = $4d82739dd229d539$var$tk = null;
    if (null !== $4d82739dd229d539$var$Wg) {
        for(b = 0; b < $4d82739dd229d539$var$Wg.length; b++)if (c = $4d82739dd229d539$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$Wg = null;
    }
    return a;
}
function $4d82739dd229d539$var$Nk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$Qg();
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
            if ($4d82739dd229d539$var$Sh) {
                for(var d = $4d82739dd229d539$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Sh = !1;
            }
            $4d82739dd229d539$var$Rh = 0;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            $4d82739dd229d539$var$ok.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$qk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Ti(f, l, b);
                            $4d82739dd229d539$var$uj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Wi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ki(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = [
                    f
                ] : $4d82739dd229d539$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Oi(f, k, b);
                            $4d82739dd229d539$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Ri(f, h, b);
                                $4d82739dd229d539$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Tk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Kk() {
    var a = $4d82739dd229d539$var$nk.current;
    $4d82739dd229d539$var$nk.current = $4d82739dd229d539$var$ai;
    return null === a ? $4d82739dd229d539$var$ai : a;
}
function $4d82739dd229d539$var$uj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$R || 0 === ($4d82739dd229d539$var$hh & 268435455) && 0 === ($4d82739dd229d539$var$rk & 268435455) || $4d82739dd229d539$var$Dk($4d82739dd229d539$var$R, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Jk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Kk();
    if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Lk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Uk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Nk(a, e);
    }
    $4d82739dd229d539$var$Qg();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$nk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$R = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Uk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Mk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Vk(a) {
    var b = $4d82739dd229d539$var$Wk(a.alternate, a, $4d82739dd229d539$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Tk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$ok.current = null;
}
function $4d82739dd229d539$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Fj(c, b, $4d82739dd229d539$var$gj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Qk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$pk.transition;
    try {
        $4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Xk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$pk.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Xk(a, b, c, d) {
    do $4d82739dd229d539$var$Ik();
    while (null !== $4d82739dd229d539$var$xk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$R && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$wk || ($4d82739dd229d539$var$wk = !0, $4d82739dd229d539$var$Gk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$pk.transition;
        $4d82739dd229d539$var$pk.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$ok.current = null;
        $4d82739dd229d539$var$Pj(a, c);
        $4d82739dd229d539$var$ek(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$ik(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$pk.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$wk && ($4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = a, $4d82739dd229d539$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Si = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Pi) throw $4d82739dd229d539$var$Pi = !1, a = $4d82739dd229d539$var$Qi, $4d82739dd229d539$var$Qi = null, a;
    0 !== ($4d82739dd229d539$var$yk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$zk++ : ($4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = a) : $4d82739dd229d539$var$zk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Ik() {
    if (null !== $4d82739dd229d539$var$xk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$yk), b = $4d82739dd229d539$var$pk.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$pk.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$xk) var d = !1;
            else {
                a = $4d82739dd229d539$var$xk;
                $4d82739dd229d539$var$xk = null;
                $4d82739dd229d539$var$yk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Tj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$pk.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Yk(a, b, c) {
    b = $4d82739dd229d539$var$Ki(c, b);
    b = $4d82739dd229d539$var$Oi(a, b, 1);
    a = $4d82739dd229d539$var$dh(a, b, 1);
    b = $4d82739dd229d539$var$L();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Ek(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(d))) {
                a = $4d82739dd229d539$var$Ki(c, a);
                a = $4d82739dd229d539$var$Ri(b, a, 1);
                b = $4d82739dd229d539$var$dh(b, a, 1);
                a = $4d82739dd229d539$var$L();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$R === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$gk ? $4d82739dd229d539$var$Lk(a, 0) : $4d82739dd229d539$var$sk |= c);
    $4d82739dd229d539$var$Ek(a, b);
}
function $4d82739dd229d539$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$L();
    a = $4d82739dd229d539$var$Zg(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Ek(a, c));
}
function $4d82739dd229d539$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Zk(a, c);
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Zk(a, c);
}
var $4d82739dd229d539$var$Wk;
$4d82739dd229d539$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$zj(a, b, c);
            $4d82739dd229d539$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$jj(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$Tg(b, c);
            e = $4d82739dd229d539$var$Xh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$ah(b), e.updater = $4d82739dd229d539$var$nh, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$rh(b, d, a, c), b = $4d82739dd229d539$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$$k(d);
                a = $4d82739dd229d539$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$aj(null, b, d, $4d82739dd229d539$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$lj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$bh(a, b);
                $4d82739dd229d539$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$$i(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Kh(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$hj(a, b), $4d82739dd229d539$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$pj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Bh(b, null, d, c) : $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$Zi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$Tg(b, c), e = $4d82739dd229d539$var$Vg(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Lg(d, b.pendingProps), e = $4d82739dd229d539$var$Lg(d.type, e), $4d82739dd229d539$var$aj(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$jj(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$Tg(b, c), $4d82739dd229d539$var$ph(b, d, e), $4d82739dd229d539$var$rh(b, d, e, c), $4d82739dd229d539$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$yj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$ej(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Gk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$al(a, b, c, d);
}
function $4d82739dd229d539$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$$k(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Ah(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Ah(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$qj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$xh(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$zh(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$ah(f);
    return a;
}
function $4d82739dd229d539$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$el(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$el(null);
    c = a.current;
    d = $4d82739dd229d539$var$L();
    e = $4d82739dd229d539$var$lh(c);
    f = $4d82739dd229d539$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$dh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Ek(a, d);
    return a;
}
function $4d82739dd229d539$var$gl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$L(), g = $4d82739dd229d539$var$lh(e);
    c = $4d82739dd229d539$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$dh(e, b, g);
    null !== a && ($4d82739dd229d539$var$mh(a, e, g, f), $4d82739dd229d539$var$eh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$jl(a, b) {
    $4d82739dd229d539$var$il(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$il(a, b);
}
function $4d82739dd229d539$var$kl() {
    return null;
}
var $4d82739dd229d539$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.render = $4d82739dd229d539$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$gl(a, b, null, null);
};
$4d82739dd229d539$var$nl.prototype.unmount = $4d82739dd229d539$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Sk(function() {
            $4d82739dd229d539$var$gl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$nl(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$ql() {}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$hl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$fl(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$ql);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$hl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$cl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$ql);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$gl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$hl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$gl(b, g, a, e);
    } else g = $4d82739dd229d539$var$rl(c, b, a, e, d);
    return $4d82739dd229d539$var$hl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Ek(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Sk(function() {
                var b = $4d82739dd229d539$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$L();
                    $4d82739dd229d539$var$mh(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$jl(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$jl(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$lh(a), c = $4d82739dd229d539$var$Zg(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(c, a, b, d);
        }
        $4d82739dd229d539$var$jl(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Sk;
var $4d82739dd229d539$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Rk
    ]
}, $4d82739dd229d539$var$ul = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$vl = {
    bundleType: $4d82739dd229d539$var$ul.bundleType,
    version: $4d82739dd229d539$var$ul.version,
    rendererPackageName: $4d82739dd229d539$var$ul.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$ul.findFiberByHostInstance || $4d82739dd229d539$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$wl.isDisabled && $4d82739dd229d539$var$wl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$wl.inject($4d82739dd229d539$var$vl), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$wl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$tl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$dl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Sk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$nl(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$pl(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$pl(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$sl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});




parcelRegister("fqI9u", function(module, exports) {
"use strict";
var $b3bb886ae10e07d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createState = module.exports.createDerivedState = module.exports.DerivedState = void 0;

var $aMwRj = parcelRequire("aMwRj");

var $b3bb886ae10e07d9$var$useState_1 = $b3bb886ae10e07d9$var$__importDefault((parcelRequire("9bPvI")));

var $b3bb886ae10e07d9$var$useReducer_1 = $b3bb886ae10e07d9$var$__importDefault((parcelRequire("9QSlj")));
var $b3bb886ae10e07d9$var$State = /** @class */ function() {
    function State(initialValue) {
        if (typeof initialValue === "function") this.value = initialValue();
        else this.value = initialValue;
        this.subscribers = [];
    }
    State.prototype.getValue = function(selector) {
        if (selector) return selector(this.value);
        return this.value;
    };
    State.prototype.refresh = function() {
        this.subscribers.forEach(function(subscriber) {
            if (subscriber.refresh) subscriber.refresh();
        });
    };
    State.prototype.setValue = function(newValue, config) {
        if (config === void 0) config = {};
        if (newValue === undefined) this.__updateValue(function(draftVal) {
            return $aMwRj.nothing;
        }, config);
        else if (typeof newValue === 'function') {
            var reducer = newValue;
            this.setValue(reducer(this.getValue(config.selector)), config);
        } else this.__updateValue(function(draftVal) {
            return newValue;
        }, config);
    };
    State.prototype.updateValue = function(stateModifier, config) {
        if (config === void 0) config = {};
        var stateModifierWrapper = function(draftState) {
            // This wrapper is for disabling setting returned value
            // We don't allow returned value to be set(just return undefined)
            stateModifier(draftState);
        };
        this.__updateValue(stateModifierWrapper, config);
    };
    State.prototype.__updateValue = function(stateUpdater, config) {
        // No need to do a lot of type checking here bcuz this is an internal method
        var selector = config.selector;
        var patcher = config.patcher;
        var oldState = this.value;
        var newState;
        if (selector && patcher) {
            // Update the selected node first and get its value
            var selectedNodeValue_1 = (0, $aMwRj.produce)(selector(oldState), stateUpdater);
            // Here we're patching back the updated selected node to the main state
            newState = (0, $aMwRj.produce)(oldState, function(draftCurrentState) {
                // Avoid setting returns
                patcher(draftCurrentState, selectedNodeValue_1);
            });
        } else newState = (0, $aMwRj.produce)(oldState, stateUpdater);
        this.value = newState;
        if (newState !== oldState) // There's a new update
        this.subscribers.forEach(function(subscriber) {
            if (subscriber.selector(newState) !== subscriber.selector(oldState)) // Node value has changed
            subscriber.observer(subscriber.selector(newState));
        });
    };
    State.prototype.subscribe = function(itemToSubscribe) {
        var _this = this;
        var _itemToSubscribe;
        if (typeof itemToSubscribe === 'function') {
            var selector = function(state) {
                return state;
            };
            _itemToSubscribe = {
                observer: itemToSubscribe,
                selector: selector
            };
        } else _itemToSubscribe = itemToSubscribe;
        if (this.subscribers.indexOf(_itemToSubscribe) === -1) // Subscribe a component to this state
        this.subscribers.push(_itemToSubscribe);
        var unsubscribe = function() {
            _this.subscribers = _this.subscribers.filter(function(subscriber) {
                return subscriber !== _itemToSubscribe;
            });
        };
        return unsubscribe;
    };
    State.prototype.select = function(selector) {
        return $b3bb886ae10e07d9$var$createDerivedState(this, selector);
    };
    State.prototype.useState = function(config) {
        if (config === void 0) config = {};
        return (0, $b3bb886ae10e07d9$var$useState_1.default)(this, config);
    };
    State.prototype.useReducer = function(reducer, config) {
        if (config === void 0) config = {};
        return (0, $b3bb886ae10e07d9$var$useReducer_1.default)(reducer, this, config);
    };
    return State;
}();
module.exports.default = $b3bb886ae10e07d9$var$State;
var $b3bb886ae10e07d9$var$DerivedState = /** @class */ function() {
    function DerivedState(State, selector) {
        this.State = State;
        this.selector = selector;
    }
    DerivedState.prototype.getValue = function() {
        return this.State.getValue(this.selector);
    };
    DerivedState.prototype.subscribe = function(observer, refresh) {
        var itemToSubscribe = {
            observer: observer,
            selector: this.selector,
            refresh: refresh
        };
        return this.State.subscribe(itemToSubscribe);
    };
    return DerivedState;
}();
module.exports.DerivedState = $b3bb886ae10e07d9$var$DerivedState;
function $b3bb886ae10e07d9$var$createDerivedState(State, selector) {
    return new $b3bb886ae10e07d9$var$DerivedState(State, selector);
}
module.exports.createDerivedState = $b3bb886ae10e07d9$var$createDerivedState;
function $b3bb886ae10e07d9$var$createState(initialValue) {
    return new $b3bb886ae10e07d9$var$State(initialValue);
}
module.exports.createState = $b3bb886ae10e07d9$var$createState;

});
parcelRegister("aMwRj", function(module, exports) {

$parcel$export(module.exports, "nothing", function () { return $7d97e02cb028d0b8$export$45b790e32b2810ee; });
$parcel$export(module.exports, "produce", function () { return $7d97e02cb028d0b8$export$b46cabe22e78bc00; });
var $7d97e02cb028d0b8$var$__defProp = Object.defineProperty;
var $7d97e02cb028d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d97e02cb028d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d97e02cb028d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d97e02cb028d0b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d97e02cb028d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d97e02cb028d0b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d97e02cb028d0b8$var$__hasOwnProp.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    if ($7d97e02cb028d0b8$var$__getOwnPropSymbols) {
        for (var prop of $7d97e02cb028d0b8$var$__getOwnPropSymbols(b))if ($7d97e02cb028d0b8$var$__propIsEnum.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7d97e02cb028d0b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7d97e02cb028d0b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7d97e02cb028d0b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7d97e02cb028d0b8$var$errors = [];
function $7d97e02cb028d0b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7d97e02cb028d0b8$var$getPrototypeOf = Object.getPrototypeOf;
function $7d97e02cb028d0b8$export$541ac630993a4c84(value) {
    return !!value && !!value[$7d97e02cb028d0b8$var$DRAFT_STATE];
}
function $7d97e02cb028d0b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7d97e02cb028d0b8$var$isPlainObject(value) || Array.isArray(value) || !!value[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$7d97e02cb028d0b8$export$6ee2082928bcb0ee]) || $7d97e02cb028d0b8$var$isMap(value) || $7d97e02cb028d0b8$var$isSet(value);
}
var $7d97e02cb028d0b8$var$objectCtorString = Object.prototype.constructor.toString();
function $7d97e02cb028d0b8$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7d97e02cb028d0b8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7d97e02cb028d0b8$var$objectCtorString;
}
function $7d97e02cb028d0b8$export$22e8af3f75a010e3(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(15, value);
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].base_;
}
function $7d97e02cb028d0b8$var$each(obj, iter) {
    if ($7d97e02cb028d0b8$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7d97e02cb028d0b8$var$getArchtype(thing) {
    const state = thing[$7d97e02cb028d0b8$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7d97e02cb028d0b8$var$isMap(thing) ? 2 /* Map */  : $7d97e02cb028d0b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7d97e02cb028d0b8$var$has(thing, prop) {
    return $7d97e02cb028d0b8$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7d97e02cb028d0b8$var$get(thing, prop) {
    return $7d97e02cb028d0b8$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7d97e02cb028d0b8$var$set(thing, propOrOldValue, value) {
    const t = $7d97e02cb028d0b8$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7d97e02cb028d0b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7d97e02cb028d0b8$var$isMap(target) {
    return target instanceof Map;
}
function $7d97e02cb028d0b8$var$isSet(target) {
    return target instanceof Set;
}
function $7d97e02cb028d0b8$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7d97e02cb028d0b8$var$shallowCopy(base, strict) {
    if ($7d97e02cb028d0b8$var$isMap(base)) return new Map(base);
    if ($7d97e02cb028d0b8$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $7d97e02cb028d0b8$var$isPlainObject(base)) {
        if (!$7d97e02cb028d0b8$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $7d97e02cb028d0b8$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($7d97e02cb028d0b8$var$getPrototypeOf(base), descriptors);
}
function $7d97e02cb028d0b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($7d97e02cb028d0b8$var$isFrozen(obj) || $7d97e02cb028d0b8$export$541ac630993a4c84(obj) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
    if ($7d97e02cb028d0b8$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7d97e02cb028d0b8$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $7d97e02cb028d0b8$var$each(obj, (_key, value)=>$7d97e02cb028d0b8$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $7d97e02cb028d0b8$var$dontMutateFrozenCollections() {
    $7d97e02cb028d0b8$var$die(2);
}
function $7d97e02cb028d0b8$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7d97e02cb028d0b8$var$plugins = {};
function $7d97e02cb028d0b8$var$getPlugin(pluginKey) {
    const plugin = $7d97e02cb028d0b8$var$plugins[pluginKey];
    if (!plugin) $7d97e02cb028d0b8$var$die(0, pluginKey);
    return plugin;
}
function $7d97e02cb028d0b8$var$loadPlugin(pluginKey, implementation) {
    if (!$7d97e02cb028d0b8$var$plugins[pluginKey]) $7d97e02cb028d0b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7d97e02cb028d0b8$var$currentScope;
function $7d97e02cb028d0b8$var$getCurrentScope() {
    return $7d97e02cb028d0b8$var$currentScope;
}
function $7d97e02cb028d0b8$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7d97e02cb028d0b8$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7d97e02cb028d0b8$var$revokeScope(scope) {
    $7d97e02cb028d0b8$var$leaveScope(scope);
    scope.drafts_.forEach($7d97e02cb028d0b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $7d97e02cb028d0b8$var$leaveScope(scope) {
    if (scope === $7d97e02cb028d0b8$var$currentScope) $7d97e02cb028d0b8$var$currentScope = scope.parent_;
}
function $7d97e02cb028d0b8$var$enterScope(immer2) {
    return $7d97e02cb028d0b8$var$currentScope = $7d97e02cb028d0b8$var$createScope($7d97e02cb028d0b8$var$currentScope, immer2);
}
function $7d97e02cb028d0b8$var$revokeDraft(draft) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7d97e02cb028d0b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_) {
            $7d97e02cb028d0b8$var$revokeScope(scope);
            $7d97e02cb028d0b8$var$die(4);
        }
        if ($7d97e02cb028d0b8$export$16e3aed3edb85946(result)) {
            result = $7d97e02cb028d0b8$var$finalize(scope, result);
            if (!scope.parent_) $7d97e02cb028d0b8$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7d97e02cb028d0b8$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7d97e02cb028d0b8$var$finalize(scope, baseDraft, []);
    $7d97e02cb028d0b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7d97e02cb028d0b8$export$45b790e32b2810ee ? result : void 0;
}
function $7d97e02cb028d0b8$var$finalize(rootScope, value, path) {
    if ($7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (!state) {
        $7d97e02cb028d0b8$var$each(value, (key, childValue)=>$7d97e02cb028d0b8$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7d97e02cb028d0b8$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7d97e02cb028d0b8$var$each(resultEach, (key, childValue)=>$7d97e02cb028d0b8$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7d97e02cb028d0b8$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7d97e02cb028d0b8$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7d97e02cb028d0b8$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7d97e02cb028d0b8$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7d97e02cb028d0b8$var$finalize(rootScope, childValue, path);
        $7d97e02cb028d0b8$var$set(targetObject, prop, res);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7d97e02cb028d0b8$export$16e3aed3edb85946(childValue) && !$7d97e02cb028d0b8$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7d97e02cb028d0b8$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $7d97e02cb028d0b8$var$maybeFreeze(rootScope, childValue);
    }
}
function $7d97e02cb028d0b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7d97e02cb028d0b8$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7d97e02cb028d0b8$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7d97e02cb028d0b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7d97e02cb028d0b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $7d97e02cb028d0b8$var$DRAFT_STATE) return state;
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (!$7d97e02cb028d0b8$var$has(source, prop)) return $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
        if (value === $7d97e02cb028d0b8$var$peek(state.base_, prop)) {
            $7d97e02cb028d0b8$var$prepareCopy(state);
            return state.copy_[prop] = $7d97e02cb028d0b8$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7d97e02cb028d0b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7d97e02cb028d0b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto($7d97e02cb028d0b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7d97e02cb028d0b8$var$peek($7d97e02cb028d0b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7d97e02cb028d0b8$var$is(value, current2) && (value !== void 0 || $7d97e02cb028d0b8$var$has(state.base_, prop))) return true;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7d97e02cb028d0b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7d97e02cb028d0b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7d97e02cb028d0b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $7d97e02cb028d0b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7d97e02cb028d0b8$var$die(12);
    }
};
var $7d97e02cb028d0b8$var$arrayTraps = {};
$7d97e02cb028d0b8$var$each($7d97e02cb028d0b8$var$objectTraps, (key, fn)=>{
    $7d97e02cb028d0b8$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7d97e02cb028d0b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7d97e02cb028d0b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7d97e02cb028d0b8$var$arrayTraps.set = function(state, prop, value) {
    return $7d97e02cb028d0b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7d97e02cb028d0b8$var$peek(draft, prop) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    const source = state ? $7d97e02cb028d0b8$var$latest(state) : draft;
    return source[prop];
}
function $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7d97e02cb028d0b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7d97e02cb028d0b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7d97e02cb028d0b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7d97e02cb028d0b8$var$markChanged(state.parent_);
    }
}
function $7d97e02cb028d0b8$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7d97e02cb028d0b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7d97e02cb028d0b8$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7d97e02cb028d0b8$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7d97e02cb028d0b8$var$die(7);
            let result;
            if ($7d97e02cb028d0b8$export$16e3aed3edb85946(base)) {
                const scope = $7d97e02cb028d0b8$var$enterScope(this);
                const proxy = $7d97e02cb028d0b8$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7d97e02cb028d0b8$var$revokeScope(scope);
                    else $7d97e02cb028d0b8$var$leaveScope(scope);
                }
                $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
                return $7d97e02cb028d0b8$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7d97e02cb028d0b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7d97e02cb028d0b8$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7d97e02cb028d0b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(base)) $7d97e02cb028d0b8$var$die(8);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) base = $7d97e02cb028d0b8$export$97aac956da55dae9(base);
        const scope = $7d97e02cb028d0b8$var$enterScope(this);
        const proxy = $7d97e02cb028d0b8$var$createProxy(base, void 0);
        proxy[$7d97e02cb028d0b8$var$DRAFT_STATE].isManual_ = true;
        $7d97e02cb028d0b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7d97e02cb028d0b8$var$die(9);
        const { scope_: scope } = state;
        $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
        return $7d97e02cb028d0b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7d97e02cb028d0b8$var$getPlugin("Patches").applyPatches_;
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $7d97e02cb028d0b8$var$createProxy(value, parent) {
    const draft = $7d97e02cb028d0b8$var$isMap(value) ? $7d97e02cb028d0b8$var$getPlugin("MapSet").proxyMap_(value, parent) : $7d97e02cb028d0b8$var$isSet(value) ? $7d97e02cb028d0b8$var$getPlugin("MapSet").proxySet_(value, parent) : $7d97e02cb028d0b8$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7d97e02cb028d0b8$export$97aac956da55dae9(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(10, value);
    return $7d97e02cb028d0b8$var$currentImpl(value);
}
function $7d97e02cb028d0b8$var$currentImpl(value) {
    if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || $7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7d97e02cb028d0b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7d97e02cb028d0b8$var$shallowCopy(value, true);
    $7d97e02cb028d0b8$var$each(copy, (key, childValue)=>{
        $7d97e02cb028d0b8$var$set(copy, key, $7d97e02cb028d0b8$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7d97e02cb028d0b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7d97e02cb028d0b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7d97e02cb028d0b8$var$get(base_, key);
            const value = $7d97e02cb028d0b8$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7d97e02cb028d0b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7d97e02cb028d0b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7d97e02cb028d0b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7d97e02cb028d0b8$var$die(errorOffset + 3);
                base = $7d97e02cb028d0b8$var$get(base, p);
                if (typeof base !== "object") $7d97e02cb028d0b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7d97e02cb028d0b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7d97e02cb028d0b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7d97e02cb028d0b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7d97e02cb028d0b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7d97e02cb028d0b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7d97e02cb028d0b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7d97e02cb028d0b8$var$has(obj, $7d97e02cb028d0b8$export$6ee2082928bcb0ee)) cloned[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] = obj[$7d97e02cb028d0b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7d97e02cb028d0b8$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7d97e02cb028d0b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7d97e02cb028d0b8$var$latest(state).has(key) || $7d97e02cb028d0b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7d97e02cb028d0b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            $7d97e02cb028d0b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7d97e02cb028d0b8$var$latest(state).get(key);
            if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7d97e02cb028d0b8$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) {
                    const draft = $7d97e02cb028d0b8$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7d97e02cb028d0b8$var$die(3, JSON.stringify($7d97e02cb028d0b8$var$latest(state)));
    }
    $7d97e02cb028d0b8$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7d97e02cb028d0b8$var$immer = new $7d97e02cb028d0b8$export$aaadc6ff0f822719();
var $7d97e02cb028d0b8$export$b46cabe22e78bc00 = $7d97e02cb028d0b8$var$immer.produce;
var $7d97e02cb028d0b8$export$4da66d41c9492c78 = $7d97e02cb028d0b8$var$immer.produceWithPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$573f26f60825c493 = $7d97e02cb028d0b8$var$immer.setAutoFreeze.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$333ce65961cbe047 = $7d97e02cb028d0b8$var$immer.setUseStrictShallowCopy.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$a8b8e03e6bbe5473 = $7d97e02cb028d0b8$var$immer.applyPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$3c3214997190395f = $7d97e02cb028d0b8$var$immer.createDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c60f5e69c521b528 = $7d97e02cb028d0b8$var$immer.finishDraft.bind($7d97e02cb028d0b8$var$immer);
function $7d97e02cb028d0b8$export$c05b21e3257751e5(value) {
    return value;
}
function $7d97e02cb028d0b8$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("9bPvI", function(module, exports) {
"use strict";
var $6b0d19105ace4772$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6b0d19105ace4772$var$useReducer_1 = $6b0d19105ace4772$var$__importDefault((parcelRequire("9QSlj")));
function $6b0d19105ace4772$var$useState(state, config) {
    if (config === void 0) config = {};
    function reducer(currentState, newState) {
        return newState;
    }
    var _a = (0, $6b0d19105ace4772$var$useReducer_1.default)(reducer, state, config), stateValue = _a[0], setStateValue = _a[1], stateObject = _a[2];
    function updateStateValue(updater) {
        stateObject.updateValue(updater, config);
    }
    return [
        stateValue,
        setStateValue,
        updateStateValue,
        stateObject
    ];
}
module.exports.default = $6b0d19105ace4772$var$useState;

});
parcelRegister("9QSlj", function(module, exports) {
"use strict";
var $72c31fb717b4f425$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $72c31fb717b4f425$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $72c31fb717b4f425$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $72c31fb717b4f425$var$__createBinding(result, mod, k);
    }
    $72c31fb717b4f425$var$__setModuleDefault(result, mod);
    return result;
};
var $72c31fb717b4f425$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $72c31fb717b4f425$var$react_1 = $72c31fb717b4f425$var$__importDefault((parcelRequire("7fPBF")));

var $72c31fb717b4f425$var$State_1 = $72c31fb717b4f425$var$__importStar((parcelRequire("fqI9u")));
function $72c31fb717b4f425$var$useStateObject(state) {
    // This is for internal use only
    var localStateRef = $72c31fb717b4f425$var$react_1.default.useMemo(function() {
        if (state instanceof $72c31fb717b4f425$var$State_1.default) // We have a global state, so we'll simply pass it out
        return null;
        else // We have a local state, so we create state obj and keep its ref for futer renders
        return (0, $72c31fb717b4f425$var$State_1.createState)(state);
    }, []);
    var stateObject;
    if (localStateRef instanceof $72c31fb717b4f425$var$State_1.default) stateObject = localStateRef;
    else stateObject = state;
    return stateObject;
}
function $72c31fb717b4f425$var$useReducer(reducer, state, config) {
    if (config === void 0) config = {};
    var _a = $72c31fb717b4f425$var$react_1.default.useState(null), setState = _a[1];
    var isMounted = $72c31fb717b4f425$var$react_1.default.useRef(false);
    var stateObject = $72c31fb717b4f425$var$useStateObject(state);
    var currentState = stateObject.getValue(config.selector);
    function reRender() {
        // re-render if the component is mounted
        if (isMounted.current) setState({});
    }
    function observer(newState) {
        if (currentState === newState) ;
        else reRender();
    }
    var subscription = {
        observer: observer,
        selector: config.selector ? config.selector : function(state) {
            return state;
        },
        refresh: reRender
    };
    $72c31fb717b4f425$var$react_1.default.useEffect(function() {
        var unsubscribe = stateObject.subscribe(subscription);
        isMounted.current = true;
        return function() {
            unsubscribe();
            isMounted.current = false;
        };
    }, [
        currentState,
        $72c31fb717b4f425$var$State_1.default
    ]);
    function dispatch(action) {
        var newState = reducer(currentState, action);
        stateObject.setValue(newState, config);
    }
    return [
        currentState,
        dispatch,
        stateObject
    ];
}
module.exports.default = $72c31fb717b4f425$var$useReducer;

});



parcelRegister("l29zL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStore = void 0;

var $fqI9u = parcelRequire("fqI9u");
var $f50136700a2c19e0$var$notImplementedErrorMsg = [
    "You must implement 'loadState' and 'saveState' to be able ",
    'to save state to your preffered storage. E.g \n',
    'store.persist({ \n',
    '    saveState: function(key, state, isInitialSet){/*logics to save state to storage*/}, \n',
    '    loadState: function(key, noState){/*logics to load state from storage*/} \n',
    '}) \n'
].join("");
var $f50136700a2c19e0$var$Empty = /** @class */ function() {
    function Empty() {}
    return Empty;
}(); // Class for empty state/value
var $f50136700a2c19e0$var$EMPTY = new $f50136700a2c19e0$var$Empty();
var $f50136700a2c19e0$var$PersistentStorage = /** @class */ function() {
    function PersistentStorage() {
        this.SHOULD_PERSIST_BY_DEFAULT = false;
    }
    PersistentStorage.prototype.loadState = function(key, noState) {
        throw TypeError($f50136700a2c19e0$var$notImplementedErrorMsg);
    };
    PersistentStorage.prototype.saveState = function(key, state, isInitialSet) {
        throw TypeError($f50136700a2c19e0$var$notImplementedErrorMsg);
    };
    return PersistentStorage;
}();
var $f50136700a2c19e0$var$Store = /** @class */ function() {
    function Store(storeInitializer) {
        this.states = new Map();
        this.subscribers = [];
        this.persistentStorage = new $f50136700a2c19e0$var$PersistentStorage();
        if (storeInitializer) {
            if (typeof storeInitializer === "function") storeInitializer = storeInitializer();
            for(var key in storeInitializer)if (storeInitializer.hasOwnProperty(key)) this.setState(key, storeInitializer[key]);
        }
    }
    Store.prototype.subscribe = function(observer) {
        var _this = this;
        if (this.subscribers.indexOf(observer) === -1) // Subscribe a component to this store
        this.subscribers.push(observer);
        var unsubscribe = function() {
            _this.subscribers = _this.subscribers.filter(function(subscriber) {
                return subscriber !== observer;
            });
        };
        return unsubscribe;
    };
    Store.prototype.onStoreUpdate = function(key, value) {
        this.subscribers.forEach(function(subscriber) {
            subscriber(key, value);
        });
    };
    Store.prototype.persist = function(config) {
        if (config.saveState) this.persistentStorage.saveState = config.saveState;
        if (config.loadState) this.persistentStorage.loadState = config.loadState;
        if (config.removeState) this.persistentStorage.removeState = config.removeState;
        if (config.clear) this.persistentStorage.clear = config.clear;
        if (config.PERSIST_ENTIRE_STORE) this.persistentStorage.SHOULD_PERSIST_BY_DEFAULT = config.PERSIST_ENTIRE_STORE;
    };
    Store.prototype.setState = function(key, initialValue, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, persist = _b.persist;
        var shouldPersist = persist === undefined ? this.persistentStorage.SHOULD_PERSIST_BY_DEFAULT : persist;
        var shouldSaveToPersistentStorage = false;
        if (shouldPersist) {
            // Try to load state from persistent storage
            var savedState = this.persistentStorage.loadState(key, $f50136700a2c19e0$var$EMPTY);
            if (savedState !== $f50136700a2c19e0$var$EMPTY) // We have a saved state, so we use it as the initialValue
            initialValue = savedState;
            else // We don't have a saved state so we have to set/save it
            // Here we set this flag to true but we'll save later after creating a state successfully
            shouldSaveToPersistentStorage = true;
        }
        var onStateChange = function(newValue) {
            // Note key & persist variables depends on scope
            _this.onStoreUpdate(key, newValue);
            if (shouldPersist) _this.persistentStorage.saveState(key, newValue, false);
        };
        // Create a state
        var state = (0, $fqI9u.createState)(initialValue);
        var unsubscribe = state.subscribe({
            observer: onStateChange,
            selector: function(st) {
                return st;
            }
        });
        var storeState = {
            "state": state,
            "unsubscribe": unsubscribe,
            "persist": shouldPersist
        };
        // Add state to the store
        this.states.set(key, storeState);
        if (shouldSaveToPersistentStorage) // Saving state to persistent storage after we've created it successfully
        this.persistentStorage.saveState(key, state.getValue(), true);
    };
    Store.prototype.getState = function(key, config) {
        if (config === void 0) config = {};
        var defaultValue;
        if (config.hasOwnProperty('default')) // Use has set default explicitly
        defaultValue = config.default;
        else // No default value
        defaultValue = $f50136700a2c19e0$var$EMPTY;
        // Get key based state
        if (!this.has(key)) {
            if (defaultValue !== $f50136700a2c19e0$var$EMPTY) // Create a state and use defaultValue as the initial value
            this.setState(key, defaultValue, {
                persist: config.persist
            });
            else {
                // state is not found and the default value is not specified
                var errorMsg = [
                    "There is no state with the key '".concat(key, "', "),
                    "You are either trying to access a ",
                    "state that doesn't exist or it was deleted."
                ];
                throw Error(errorMsg.join(""));
            }
        }
        return this.states.get(key).state;
    };
    Store.prototype.has = function(key) {
        // Check if we have a state in a store
        return this.states.has(key);
    };
    Store.prototype.items = function() {
        var storeItems = [];
        this.states.forEach(function(storeState, key) {
            storeItems.push([
                key,
                storeState.state.getValue(),
                storeState.persist
            ]);
        });
        return storeItems;
    };
    Store.prototype.getStateValue = function(key, selector) {
        var state = this.getState(key);
        return state.getValue(selector);
    };
    Store.prototype.clear = function(fn) {
        var _this = this;
        // Copy store
        var storeCopy = this.states;
        // Clear store
        this.states = new Map();
        if (this.persistentStorage.clear) this.persistentStorage.clear();
        if (fn) // Run store re-initialization
        fn();
        storeCopy.forEach(function(oldState, key) {
            // Unsubscribe from an old state 
            oldState.unsubscribe();
            // Notify subscribers to a store that a state has been removed
            if (_this.has(key)) {
                var newState = _this.getState(key);
                _this.onStoreUpdate(key, newState.getValue());
            }
            // Rerender all components using this state
            oldState.state.refresh();
        });
    };
    Store.prototype.remove = function(Statekey, fn) {
        var _this = this;
        var keys = [];
        if (typeof Statekey === 'string') keys = [
            Statekey
        ];
        else keys = Statekey;
        var StatesToRemove = new Map();
        keys.forEach(function(key) {
            // Copy state to remove from a store
            StatesToRemove.set(key, _this.states.get(key));
            // Remove state from a store
            _this.states.delete(key);
            if (StatesToRemove.get(key).persist && // Is state persisted
            _this.persistentStorage.removeState && // Is removeState Implemented
            _this.persistentStorage.loadState(key, $f50136700a2c19e0$var$EMPTY) !== $f50136700a2c19e0$var$EMPTY // Is state to remove available
            ) _this.persistentStorage.removeState(key);
        });
        if (fn) // Run state re-initialization
        fn();
        StatesToRemove.forEach(function(oldState, key) {
            // Unsubscribe from an old state 
            oldState.unsubscribe();
            // Notify subscribers to a store that a state has been removed
            if (_this.has(key)) {
                var newState = _this.getState(key);
                _this.onStoreUpdate(key, newState.getValue());
            }
            // Rerender all components depending on this state
            oldState.state.refresh();
        });
    };
    Store.prototype.useState = function(key, config) {
        if (config === void 0) config = {};
        var storeStateConfig = config;
        var stateConfig = config;
        var state = this.getState(key, storeStateConfig);
        return state.useState(stateConfig);
    };
    Store.prototype.useReducer = function(reducer, key, config) {
        if (config === void 0) config = {};
        var storeStateConfig = config;
        var stateConfig = config;
        var state = this.getState(key, storeStateConfig);
        return state.useReducer(reducer, stateConfig);
    };
    return Store;
}();
module.exports.default = $f50136700a2c19e0$var$Store;
function $f50136700a2c19e0$var$createStore(storeInitializer) {
    // Create a store for key based state
    return new $f50136700a2c19e0$var$Store(storeInitializer);
}
module.exports.createStore = $f50136700a2c19e0$var$createStore;

});

parcelRegister("gSkQi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.0';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            // https://github.com/lodash/lodash/security/advisories/GHSA-w36w-cm3g-pc62
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("1ZNeQ", function(module, exports) {

$parcel$export(module.exports, "FormikProvider", function () { return FormikProvider; });
$parcel$export(module.exports, "getIn", function () { return getIn; });
$parcel$export(module.exports, "useFormik", function () { return useFormik; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "FieldArray", function () { return FieldArray; });

var $165JS = parcelRequire("165JS");

var $jvrjc = parcelRequire("jvrjc");

var $hVVj1 = parcelRequire("hVVj1");

var $7fPBF = parcelRequire("7fPBF");

var $iC4RG = parcelRequire("iC4RG");

var $8knIu = parcelRequire("8knIu");

var $2eESg = parcelRequire("2eESg");

var $5yFbH = parcelRequire("5yFbH");

var $8Ae2G = parcelRequire("8Ae2G");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $7fPBF.useContext)(FormikContext);
    !!!formik && (0, $8knIu.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $7fPBF.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $5yFbH.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $2eESg.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $5yFbH.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $2eESg.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $7fPBF.useRef)(props.initialValues);
    var initialErrors = (0, $7fPBF.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $7fPBF.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $7fPBF.useRef)(props.initialStatus);
    var isMounted = (0, $7fPBF.useRef)(false);
    var fieldRegistry = (0, $7fPBF.useRef)({});
    (0, $7fPBF.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $7fPBF.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $7fPBF.useRef)({
        values: (0, $hVVj1.default)(props.initialValues),
        errors: (0, $hVVj1.default)(props.initialErrors) || emptyErrors,
        touched: (0, $hVVj1.default)(props.initialTouched) || emptyTouched,
        status: (0, $hVVj1.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $7fPBF.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $7fPBF.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $7fPBF.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $7fPBF.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $7fPBF.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $7fPBF.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $165JS.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $7fPBF.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $7fPBF.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $7fPBF.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $7fPBF.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $7fPBF.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $7fPBF.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $7fPBF.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $7fPBF.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $7fPBF.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $7fPBF.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $7fPBF.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $7fPBF.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $7fPBF.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $7fPBF.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $7fPBF.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $7fPBF.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $7fPBF.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $7fPBF.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $7fPBF.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $7fPBF.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $jvrjc.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $jvrjc.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $165JS.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $165JS.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function useEventCallback(fn) {
    var ref = (0, $7fPBF.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $7fPBF.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $8knIu.default)(false);
    var fieldHelpers = (0, $7fPBF.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $7fPBF.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $7fPBF.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $7fPBF.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $7fPBF.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $7fPBF.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $7fPBF.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $7fPBF.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $7fPBF.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $7fPBF.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $7fPBF.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $8knIu.default)(false);
            return (0, $7fPBF.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $hVVj1.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $7fPBF.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $7fPBF.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $7fPBF.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $7fPBF.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $7fPBF.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $8knIu.default)(false);
        !!(component && render) && (0, $8knIu.default)(false);
        !!(is && children && isFunction(children)) && (0, $8knIu.default)(false);
        !!(component && children && isFunction(children)) && (0, $8knIu.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $8knIu.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $7fPBF.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $7fPBF.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $7fPBF.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $7fPBF.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $7fPBF.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("165JS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ccacd99d8913d86$export$2e2bcd8739ae039; });
var $0ccacd99d8913d86$var$isMergeableObject = function isMergeableObject(value) {
    return $0ccacd99d8913d86$var$isNonNullObject(value) && !$0ccacd99d8913d86$var$isSpecial(value);
};
function $0ccacd99d8913d86$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $0ccacd99d8913d86$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $0ccacd99d8913d86$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $0ccacd99d8913d86$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $0ccacd99d8913d86$var$REACT_ELEMENT_TYPE = $0ccacd99d8913d86$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $0ccacd99d8913d86$var$isReactElement(value) {
    return value.$$typeof === $0ccacd99d8913d86$var$REACT_ELEMENT_TYPE;
}
function $0ccacd99d8913d86$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $0ccacd99d8913d86$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $0ccacd99d8913d86$var$deepmerge($0ccacd99d8913d86$var$emptyTarget(value), value, options) : value;
}
function $0ccacd99d8913d86$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $0ccacd99d8913d86$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $0ccacd99d8913d86$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $0ccacd99d8913d86$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $0ccacd99d8913d86$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $0ccacd99d8913d86$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $0ccacd99d8913d86$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $0ccacd99d8913d86$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $0ccacd99d8913d86$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $0ccacd99d8913d86$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $0ccacd99d8913d86$var$mergeObject(target, source, options);
}
$0ccacd99d8913d86$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $0ccacd99d8913d86$var$deepmerge(prev, next, options);
    }, {});
};
var $0ccacd99d8913d86$var$deepmerge_1 = $0ccacd99d8913d86$var$deepmerge;
var $0ccacd99d8913d86$export$2e2bcd8739ae039 = $0ccacd99d8913d86$var$deepmerge_1;

});

parcelRegister("jvrjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3361884a25afbc9$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $4Quro = parcelRequire("4Quro");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $e3361884a25afbc9$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e3361884a25afbc9$var$funcProto = Function.prototype, $e3361884a25afbc9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e3361884a25afbc9$var$funcToString = $e3361884a25afbc9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e3361884a25afbc9$var$hasOwnProperty = $e3361884a25afbc9$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e3361884a25afbc9$var$objectCtorString = $e3361884a25afbc9$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e3361884a25afbc9$var$isPlainObject(value) {
    if (!(0, $1KYPq.default)(value) || (0, $cy2CN.default)(value) != $e3361884a25afbc9$var$objectTag) return false;
    var proto = (0, $4Quro.default)(value);
    if (proto === null) return true;
    var Ctor = $e3361884a25afbc9$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $e3361884a25afbc9$var$funcToString.call(Ctor) == $e3361884a25afbc9$var$objectCtorString;
}
var $e3361884a25afbc9$export$2e2bcd8739ae039 = $e3361884a25afbc9$var$isPlainObject;

});
parcelRegister("cy2CN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922ab23a0aa3fa49$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");

var $jeqtU = parcelRequire("jeqtU");

var $lpgZt = parcelRequire("lpgZt");
/** `Object#toString` result references. */ var $922ab23a0aa3fa49$var$nullTag = '[object Null]', $922ab23a0aa3fa49$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $922ab23a0aa3fa49$var$symToStringTag = (0, $aojMU.default) ? (0, $aojMU.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $922ab23a0aa3fa49$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $922ab23a0aa3fa49$var$undefinedTag : $922ab23a0aa3fa49$var$nullTag;
    return $922ab23a0aa3fa49$var$symToStringTag && $922ab23a0aa3fa49$var$symToStringTag in Object(value) ? (0, $jeqtU.default)(value) : (0, $lpgZt.default)(value);
}
var $922ab23a0aa3fa49$export$2e2bcd8739ae039 = $922ab23a0aa3fa49$var$baseGetTag;

});
parcelRegister("aojMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790b7ebfd2aaf0d6$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Built-in value references. */ var $790b7ebfd2aaf0d6$var$Symbol = (0, $lQuKh.default).Symbol;
var $790b7ebfd2aaf0d6$export$2e2bcd8739ae039 = $790b7ebfd2aaf0d6$var$Symbol;

});
parcelRegister("lQuKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe764daf825b3bb5$export$2e2bcd8739ae039; });

var $ggtzD = parcelRequire("ggtzD");
/** Detect free variable `self`. */ var $fe764daf825b3bb5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fe764daf825b3bb5$var$root = (0, $ggtzD.default) || $fe764daf825b3bb5$var$freeSelf || Function('return this')();
var $fe764daf825b3bb5$export$2e2bcd8739ae039 = $fe764daf825b3bb5$var$root;

});
parcelRegister("ggtzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd7514b88a803907$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $bd7514b88a803907$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bd7514b88a803907$export$2e2bcd8739ae039 = $bd7514b88a803907$var$freeGlobal;

});



parcelRegister("jeqtU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e003ddc4e0072000$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");
/** Used for built-in method references. */ var $e003ddc4e0072000$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e003ddc4e0072000$var$hasOwnProperty = $e003ddc4e0072000$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e003ddc4e0072000$var$nativeObjectToString = $e003ddc4e0072000$var$objectProto.toString;
/** Built-in value references. */ var $e003ddc4e0072000$var$symToStringTag = (0, $aojMU.default) ? (0, $aojMU.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e003ddc4e0072000$var$getRawTag(value) {
    var isOwn = $e003ddc4e0072000$var$hasOwnProperty.call(value, $e003ddc4e0072000$var$symToStringTag), tag = value[$e003ddc4e0072000$var$symToStringTag];
    try {
        value[$e003ddc4e0072000$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e003ddc4e0072000$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e003ddc4e0072000$var$symToStringTag] = tag;
        else delete value[$e003ddc4e0072000$var$symToStringTag];
    }
    return result;
}
var $e003ddc4e0072000$export$2e2bcd8739ae039 = $e003ddc4e0072000$var$getRawTag;

});

parcelRegister("lpgZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9591cc02ad348d1$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $f9591cc02ad348d1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f9591cc02ad348d1$var$nativeObjectToString = $f9591cc02ad348d1$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f9591cc02ad348d1$var$objectToString(value) {
    return $f9591cc02ad348d1$var$nativeObjectToString.call(value);
}
var $f9591cc02ad348d1$export$2e2bcd8739ae039 = $f9591cc02ad348d1$var$objectToString;

});


parcelRegister("4Quro", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3873a1a9e0dd270c$export$2e2bcd8739ae039; });

var $4qlTy = parcelRequire("4qlTy");
/** Built-in value references. */ var $3873a1a9e0dd270c$var$getPrototype = (0, $4qlTy.default)(Object.getPrototypeOf, Object);
var $3873a1a9e0dd270c$export$2e2bcd8739ae039 = $3873a1a9e0dd270c$var$getPrototype;

});
parcelRegister("4qlTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $338a930bf5729178$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $338a930bf5729178$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $338a930bf5729178$export$2e2bcd8739ae039 = $338a930bf5729178$var$overArg;

});


parcelRegister("1KYPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1479459b2ec79a29$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1479459b2ec79a29$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $1479459b2ec79a29$export$2e2bcd8739ae039 = $1479459b2ec79a29$var$isObjectLike;

});


parcelRegister("hVVj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0e4364422aa32a9$export$2e2bcd8739ae039; });

var $3kFHB = parcelRequire("3kFHB");
/** Used to compose bitmasks for cloning. */ var $d0e4364422aa32a9$var$CLONE_DEEP_FLAG = 1, $d0e4364422aa32a9$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d0e4364422aa32a9$var$cloneDeep(value) {
    return (0, $3kFHB.default)(value, $d0e4364422aa32a9$var$CLONE_DEEP_FLAG | $d0e4364422aa32a9$var$CLONE_SYMBOLS_FLAG);
}
var $d0e4364422aa32a9$export$2e2bcd8739ae039 = $d0e4364422aa32a9$var$cloneDeep;

});
parcelRegister("3kFHB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26d396936dd7aae9$export$2e2bcd8739ae039; });

var $4lrQq = parcelRequire("4lrQq");

var $e2HqO = parcelRequire("e2HqO");

var $63H9W = parcelRequire("63H9W");

var $bkn5s = parcelRequire("bkn5s");

var $kdWVV = parcelRequire("kdWVV");

var $eWRTU = parcelRequire("eWRTU");

var $axhnQ = parcelRequire("axhnQ");

var $QlRlC = parcelRequire("QlRlC");

var $94uxN = parcelRequire("94uxN");

var $kjGCi = parcelRequire("kjGCi");

var $boZAC = parcelRequire("boZAC");

var $1if5w = parcelRequire("1if5w");

var $1VLyO = parcelRequire("1VLyO");

var $5JrOR = parcelRequire("5JrOR");

var $cFFwt = parcelRequire("cFFwt");

var $21thZ = parcelRequire("21thZ");

var $9VzRR = parcelRequire("9VzRR");

var $jgOzT = parcelRequire("jgOzT");

var $1i0Jy = parcelRequire("1i0Jy");

var $c6ppW = parcelRequire("c6ppW");

var $5Hbw4 = parcelRequire("5Hbw4");

var $kKvqE = parcelRequire("kKvqE");
/** Used to compose bitmasks for cloning. */ var $26d396936dd7aae9$var$CLONE_DEEP_FLAG = 1, $26d396936dd7aae9$var$CLONE_FLAT_FLAG = 2, $26d396936dd7aae9$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $26d396936dd7aae9$var$argsTag = '[object Arguments]', $26d396936dd7aae9$var$arrayTag = '[object Array]', $26d396936dd7aae9$var$boolTag = '[object Boolean]', $26d396936dd7aae9$var$dateTag = '[object Date]', $26d396936dd7aae9$var$errorTag = '[object Error]', $26d396936dd7aae9$var$funcTag = '[object Function]', $26d396936dd7aae9$var$genTag = '[object GeneratorFunction]', $26d396936dd7aae9$var$mapTag = '[object Map]', $26d396936dd7aae9$var$numberTag = '[object Number]', $26d396936dd7aae9$var$objectTag = '[object Object]', $26d396936dd7aae9$var$regexpTag = '[object RegExp]', $26d396936dd7aae9$var$setTag = '[object Set]', $26d396936dd7aae9$var$stringTag = '[object String]', $26d396936dd7aae9$var$symbolTag = '[object Symbol]', $26d396936dd7aae9$var$weakMapTag = '[object WeakMap]';
var $26d396936dd7aae9$var$arrayBufferTag = '[object ArrayBuffer]', $26d396936dd7aae9$var$dataViewTag = '[object DataView]', $26d396936dd7aae9$var$float32Tag = '[object Float32Array]', $26d396936dd7aae9$var$float64Tag = '[object Float64Array]', $26d396936dd7aae9$var$int8Tag = '[object Int8Array]', $26d396936dd7aae9$var$int16Tag = '[object Int16Array]', $26d396936dd7aae9$var$int32Tag = '[object Int32Array]', $26d396936dd7aae9$var$uint8Tag = '[object Uint8Array]', $26d396936dd7aae9$var$uint8ClampedTag = '[object Uint8ClampedArray]', $26d396936dd7aae9$var$uint16Tag = '[object Uint16Array]', $26d396936dd7aae9$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $26d396936dd7aae9$var$cloneableTags = {};
$26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$argsTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$arrayTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$arrayBufferTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$dataViewTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$boolTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$dateTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$float32Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$float64Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int8Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int16Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int32Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$mapTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$numberTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$objectTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$regexpTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$setTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$stringTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$symbolTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint8Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint8ClampedTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint16Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint32Tag] = true;
$26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$errorTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$funcTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $26d396936dd7aae9$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $26d396936dd7aae9$var$CLONE_DEEP_FLAG, isFlat = bitmask & $26d396936dd7aae9$var$CLONE_FLAT_FLAG, isFull = bitmask & $26d396936dd7aae9$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $1i0Jy.default)(value)) return value;
    var isArr = (0, $21thZ.default)(value);
    if (isArr) {
        result = (0, $1VLyO.default)(value);
        if (!isDeep) return (0, $axhnQ.default)(value, result);
    } else {
        var tag = (0, $1if5w.default)(value), isFunc = tag == $26d396936dd7aae9$var$funcTag || tag == $26d396936dd7aae9$var$genTag;
        if ((0, $9VzRR.default)(value)) return (0, $eWRTU.default)(value, isDeep);
        if (tag == $26d396936dd7aae9$var$objectTag || tag == $26d396936dd7aae9$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $cFFwt.default)(value);
            if (!isDeep) return isFlat ? (0, $94uxN.default)(value, (0, $kdWVV.default)(result, value)) : (0, $QlRlC.default)(value, (0, $bkn5s.default)(result, value));
        } else {
            if (!$26d396936dd7aae9$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $5JrOR.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $4lrQq.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $c6ppW.default)(value)) value.forEach(function(subValue) {
        result.add($26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $jgOzT.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $boZAC.default) : (0, $kjGCi.default) : isFlat ? (0, $kKvqE.default) : (0, $5Hbw4.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $e2HqO.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $63H9W.default)(result, key, $26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $26d396936dd7aae9$export$2e2bcd8739ae039 = $26d396936dd7aae9$var$baseClone;

});
parcelRegister("4lrQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329eb8ed43809560$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");

var $01rnI = parcelRequire("01rnI");

var $a7ip8 = parcelRequire("a7ip8");

var $cteQy = parcelRequire("cteQy");

var $coII5 = parcelRequire("coII5");

var $1oC4I = parcelRequire("1oC4I");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $329eb8ed43809560$var$Stack(entries) {
    var data = this.__data__ = new (0, $lizsJ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$329eb8ed43809560$var$Stack.prototype.clear = (0, $01rnI.default);
$329eb8ed43809560$var$Stack.prototype['delete'] = (0, $a7ip8.default);
$329eb8ed43809560$var$Stack.prototype.get = (0, $cteQy.default);
$329eb8ed43809560$var$Stack.prototype.has = (0, $coII5.default);
$329eb8ed43809560$var$Stack.prototype.set = (0, $1oC4I.default);
var $329eb8ed43809560$export$2e2bcd8739ae039 = $329eb8ed43809560$var$Stack;

});
parcelRegister("lizsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f816c97fdc0dadbf$export$2e2bcd8739ae039; });

var $izEq5 = parcelRequire("izEq5");

var $3GHv2 = parcelRequire("3GHv2");

var $gUBS1 = parcelRequire("gUBS1");

var $fz72Y = parcelRequire("fz72Y");

var $cxUY4 = parcelRequire("cxUY4");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f816c97fdc0dadbf$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f816c97fdc0dadbf$var$ListCache.prototype.clear = (0, $izEq5.default);
$f816c97fdc0dadbf$var$ListCache.prototype['delete'] = (0, $3GHv2.default);
$f816c97fdc0dadbf$var$ListCache.prototype.get = (0, $gUBS1.default);
$f816c97fdc0dadbf$var$ListCache.prototype.has = (0, $fz72Y.default);
$f816c97fdc0dadbf$var$ListCache.prototype.set = (0, $cxUY4.default);
var $f816c97fdc0dadbf$export$2e2bcd8739ae039 = $f816c97fdc0dadbf$var$ListCache;

});
parcelRegister("izEq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d85ad9618b6314ee$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d85ad9618b6314ee$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $d85ad9618b6314ee$export$2e2bcd8739ae039 = $d85ad9618b6314ee$var$listCacheClear;

});

parcelRegister("3GHv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2af70975b2fe03d4$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/** Used for built-in method references. */ var $2af70975b2fe03d4$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $2af70975b2fe03d4$var$splice = $2af70975b2fe03d4$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2af70975b2fe03d4$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $2af70975b2fe03d4$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $2af70975b2fe03d4$export$2e2bcd8739ae039 = $2af70975b2fe03d4$var$listCacheDelete;

});
parcelRegister("lyoRX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb101074f47c2985$export$2e2bcd8739ae039; });

var $8rNNR = parcelRequire("8rNNR");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $fb101074f47c2985$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $8rNNR.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $fb101074f47c2985$export$2e2bcd8739ae039 = $fb101074f47c2985$var$assocIndexOf;

});
parcelRegister("8rNNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62677a336a9cd77c$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $62677a336a9cd77c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $62677a336a9cd77c$export$2e2bcd8739ae039 = $62677a336a9cd77c$var$eq;

});



parcelRegister("gUBS1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ff4092158a4a3a$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c4ff4092158a4a3a$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $c4ff4092158a4a3a$export$2e2bcd8739ae039 = $c4ff4092158a4a3a$var$listCacheGet;

});

parcelRegister("fz72Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b54f97418d5bd4aa$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b54f97418d5bd4aa$var$listCacheHas(key) {
    return (0, $lyoRX.default)(this.__data__, key) > -1;
}
var $b54f97418d5bd4aa$export$2e2bcd8739ae039 = $b54f97418d5bd4aa$var$listCacheHas;

});

parcelRegister("cxUY4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9224c1c0e6c7b89e$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $9224c1c0e6c7b89e$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $9224c1c0e6c7b89e$export$2e2bcd8739ae039 = $9224c1c0e6c7b89e$var$listCacheSet;

});


parcelRegister("01rnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0045557d5d97eb5b$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0045557d5d97eb5b$var$stackClear() {
    this.__data__ = new (0, $lizsJ.default);
    this.size = 0;
}
var $0045557d5d97eb5b$export$2e2bcd8739ae039 = $0045557d5d97eb5b$var$stackClear;

});

parcelRegister("a7ip8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75d8d5907d975735$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $75d8d5907d975735$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $75d8d5907d975735$export$2e2bcd8739ae039 = $75d8d5907d975735$var$stackDelete;

});

parcelRegister("cteQy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9143b5b6048cd4b0$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9143b5b6048cd4b0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $9143b5b6048cd4b0$export$2e2bcd8739ae039 = $9143b5b6048cd4b0$var$stackGet;

});

parcelRegister("coII5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906a686a69714ba8$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $906a686a69714ba8$var$stackHas(key) {
    return this.__data__.has(key);
}
var $906a686a69714ba8$export$2e2bcd8739ae039 = $906a686a69714ba8$var$stackHas;

});

parcelRegister("1oC4I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $104591422169f56c$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");

var $bYE5r = parcelRequire("bYE5r");

var $5fToR = parcelRequire("5fToR");
/** Used as the size to enable large array optimizations. */ var $104591422169f56c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $104591422169f56c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $lizsJ.default)) {
        var pairs = data.__data__;
        if (!(0, $bYE5r.default) || pairs.length < $104591422169f56c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5fToR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $104591422169f56c$export$2e2bcd8739ae039 = $104591422169f56c$var$stackSet;

});
parcelRegister("bYE5r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b8464aec82723f3$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $8b8464aec82723f3$var$Map = (0, $4sTIN.default)((0, $lQuKh.default), 'Map');
var $8b8464aec82723f3$export$2e2bcd8739ae039 = $8b8464aec82723f3$var$Map;

});
parcelRegister("4sTIN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $340500181cf2f6f1$export$2e2bcd8739ae039; });

var $j51oq = parcelRequire("j51oq");

var $k1l8b = parcelRequire("k1l8b");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $340500181cf2f6f1$var$getNative(object, key) {
    var value = (0, $k1l8b.default)(object, key);
    return (0, $j51oq.default)(value) ? value : undefined;
}
var $340500181cf2f6f1$export$2e2bcd8739ae039 = $340500181cf2f6f1$var$getNative;

});
parcelRegister("j51oq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3f908d22f72c13$export$2e2bcd8739ae039; });

var $7A1Sy = parcelRequire("7A1Sy");

var $jpzrG = parcelRequire("jpzrG");

var $1i0Jy = parcelRequire("1i0Jy");

var $e6A8i = parcelRequire("e6A8i");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $de3f908d22f72c13$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $de3f908d22f72c13$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $de3f908d22f72c13$var$funcProto = Function.prototype, $de3f908d22f72c13$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $de3f908d22f72c13$var$funcToString = $de3f908d22f72c13$var$funcProto.toString;
/** Used to check objects for own properties. */ var $de3f908d22f72c13$var$hasOwnProperty = $de3f908d22f72c13$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $de3f908d22f72c13$var$reIsNative = RegExp('^' + $de3f908d22f72c13$var$funcToString.call($de3f908d22f72c13$var$hasOwnProperty).replace($de3f908d22f72c13$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $de3f908d22f72c13$var$baseIsNative(value) {
    if (!(0, $1i0Jy.default)(value) || (0, $jpzrG.default)(value)) return false;
    var pattern = (0, $7A1Sy.default)(value) ? $de3f908d22f72c13$var$reIsNative : $de3f908d22f72c13$var$reIsHostCtor;
    return pattern.test((0, $e6A8i.default)(value));
}
var $de3f908d22f72c13$export$2e2bcd8739ae039 = $de3f908d22f72c13$var$baseIsNative;

});
parcelRegister("7A1Sy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $584d5a4a611d056a$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1i0Jy = parcelRequire("1i0Jy");
/** `Object#toString` result references. */ var $584d5a4a611d056a$var$asyncTag = '[object AsyncFunction]', $584d5a4a611d056a$var$funcTag = '[object Function]', $584d5a4a611d056a$var$genTag = '[object GeneratorFunction]', $584d5a4a611d056a$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $584d5a4a611d056a$var$isFunction(value) {
    if (!(0, $1i0Jy.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $cy2CN.default)(value);
    return tag == $584d5a4a611d056a$var$funcTag || tag == $584d5a4a611d056a$var$genTag || tag == $584d5a4a611d056a$var$asyncTag || tag == $584d5a4a611d056a$var$proxyTag;
}
var $584d5a4a611d056a$export$2e2bcd8739ae039 = $584d5a4a611d056a$var$isFunction;

});
parcelRegister("1i0Jy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f080a9b60d5ea3a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0f080a9b60d5ea3a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $0f080a9b60d5ea3a$export$2e2bcd8739ae039 = $0f080a9b60d5ea3a$var$isObject;

});


parcelRegister("jpzrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e21bd8d98d624893$export$2e2bcd8739ae039; });

var $tHLfN = parcelRequire("tHLfN");
/** Used to detect methods masquerading as native. */ var $e21bd8d98d624893$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $tHLfN.default) && (0, $tHLfN.default).keys && (0, $tHLfN.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e21bd8d98d624893$var$isMasked(func) {
    return !!$e21bd8d98d624893$var$maskSrcKey && $e21bd8d98d624893$var$maskSrcKey in func;
}
var $e21bd8d98d624893$export$2e2bcd8739ae039 = $e21bd8d98d624893$var$isMasked;

});
parcelRegister("tHLfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0594a79a4b211c30$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Used to detect overreaching core-js shims. */ var $0594a79a4b211c30$var$coreJsData = (0, $lQuKh.default)['__core-js_shared__'];
var $0594a79a4b211c30$export$2e2bcd8739ae039 = $0594a79a4b211c30$var$coreJsData;

});


parcelRegister("e6A8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44da776de597c7a$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $a44da776de597c7a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $a44da776de597c7a$var$funcToString = $a44da776de597c7a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $a44da776de597c7a$var$toSource(func) {
    if (func != null) {
        try {
            return $a44da776de597c7a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $a44da776de597c7a$export$2e2bcd8739ae039 = $a44da776de597c7a$var$toSource;

});


parcelRegister("k1l8b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9344acc6d14c1ad$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e9344acc6d14c1ad$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e9344acc6d14c1ad$export$2e2bcd8739ae039 = $e9344acc6d14c1ad$var$getValue;

});



parcelRegister("5fToR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d3953c0fbb00239$export$2e2bcd8739ae039; });

var $5WmXr = parcelRequire("5WmXr");

var $4SNgz = parcelRequire("4SNgz");

var $ahaWr = parcelRequire("ahaWr");

var $aEyWN = parcelRequire("aEyWN");

var $8IZ52 = parcelRequire("8IZ52");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d3953c0fbb00239$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3d3953c0fbb00239$var$MapCache.prototype.clear = (0, $5WmXr.default);
$3d3953c0fbb00239$var$MapCache.prototype['delete'] = (0, $4SNgz.default);
$3d3953c0fbb00239$var$MapCache.prototype.get = (0, $ahaWr.default);
$3d3953c0fbb00239$var$MapCache.prototype.has = (0, $aEyWN.default);
$3d3953c0fbb00239$var$MapCache.prototype.set = (0, $8IZ52.default);
var $3d3953c0fbb00239$export$2e2bcd8739ae039 = $3d3953c0fbb00239$var$MapCache;

});
parcelRegister("5WmXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45342d6f20752fbb$export$2e2bcd8739ae039; });

var $dDo32 = parcelRequire("dDo32");

var $lizsJ = parcelRequire("lizsJ");

var $bYE5r = parcelRequire("bYE5r");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $45342d6f20752fbb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $dDo32.default),
        'map': new ((0, $bYE5r.default) || (0, $lizsJ.default)),
        'string': new (0, $dDo32.default)
    };
}
var $45342d6f20752fbb$export$2e2bcd8739ae039 = $45342d6f20752fbb$var$mapCacheClear;

});
parcelRegister("dDo32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed1924d94124fa1$export$2e2bcd8739ae039; });

var $3opPB = parcelRequire("3opPB");

var $3I1q4 = parcelRequire("3I1q4");

var $hRJag = parcelRequire("hRJag");

var $4odqQ = parcelRequire("4odqQ");

var $Zsusm = parcelRequire("Zsusm");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9ed1924d94124fa1$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9ed1924d94124fa1$var$Hash.prototype.clear = (0, $3opPB.default);
$9ed1924d94124fa1$var$Hash.prototype['delete'] = (0, $3I1q4.default);
$9ed1924d94124fa1$var$Hash.prototype.get = (0, $hRJag.default);
$9ed1924d94124fa1$var$Hash.prototype.has = (0, $4odqQ.default);
$9ed1924d94124fa1$var$Hash.prototype.set = (0, $Zsusm.default);
var $9ed1924d94124fa1$export$2e2bcd8739ae039 = $9ed1924d94124fa1$var$Hash;

});
parcelRegister("3opPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2787a690a3f7b66b$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2787a690a3f7b66b$var$hashClear() {
    this.__data__ = (0, $lsHgg.default) ? (0, $lsHgg.default)(null) : {};
    this.size = 0;
}
var $2787a690a3f7b66b$export$2e2bcd8739ae039 = $2787a690a3f7b66b$var$hashClear;

});
parcelRegister("lsHgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9fdc54930057611$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");
/* Built-in method references that are verified to be native. */ var $f9fdc54930057611$var$nativeCreate = (0, $4sTIN.default)(Object, 'create');
var $f9fdc54930057611$export$2e2bcd8739ae039 = $f9fdc54930057611$var$nativeCreate;

});


parcelRegister("3I1q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b36951009b4c955$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2b36951009b4c955$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2b36951009b4c955$export$2e2bcd8739ae039 = $2b36951009b4c955$var$hashDelete;

});

parcelRegister("hRJag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d01a6ba3c47b6536$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used to stand-in for `undefined` hash values. */ var $d01a6ba3c47b6536$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d01a6ba3c47b6536$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d01a6ba3c47b6536$var$hasOwnProperty = $d01a6ba3c47b6536$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d01a6ba3c47b6536$var$hashGet(key) {
    var data = this.__data__;
    if (0, $lsHgg.default) {
        var result = data[key];
        return result === $d01a6ba3c47b6536$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d01a6ba3c47b6536$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d01a6ba3c47b6536$export$2e2bcd8739ae039 = $d01a6ba3c47b6536$var$hashGet;

});

parcelRegister("4odqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3323d2a00560ea07$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used for built-in method references. */ var $3323d2a00560ea07$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3323d2a00560ea07$var$hasOwnProperty = $3323d2a00560ea07$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3323d2a00560ea07$var$hashHas(key) {
    var data = this.__data__;
    return (0, $lsHgg.default) ? data[key] !== undefined : $3323d2a00560ea07$var$hasOwnProperty.call(data, key);
}
var $3323d2a00560ea07$export$2e2bcd8739ae039 = $3323d2a00560ea07$var$hashHas;

});

parcelRegister("Zsusm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b8bcc2fac715fe4$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used to stand-in for `undefined` hash values. */ var $0b8bcc2fac715fe4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0b8bcc2fac715fe4$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $lsHgg.default) && value === undefined ? $0b8bcc2fac715fe4$var$HASH_UNDEFINED : value;
    return this;
}
var $0b8bcc2fac715fe4$export$2e2bcd8739ae039 = $0b8bcc2fac715fe4$var$hashSet;

});



parcelRegister("4SNgz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e26bce601ec806$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $38e26bce601ec806$var$mapCacheDelete(key) {
    var result = (0, $cJjTF.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $38e26bce601ec806$export$2e2bcd8739ae039 = $38e26bce601ec806$var$mapCacheDelete;

});
parcelRegister("cJjTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94491f1df2e31ee9$export$2e2bcd8739ae039; });

var $bGJ4J = parcelRequire("bGJ4J");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $94491f1df2e31ee9$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $bGJ4J.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $94491f1df2e31ee9$export$2e2bcd8739ae039 = $94491f1df2e31ee9$var$getMapData;

});
parcelRegister("bGJ4J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882694fcdc1bf07f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $882694fcdc1bf07f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $882694fcdc1bf07f$export$2e2bcd8739ae039 = $882694fcdc1bf07f$var$isKeyable;

});



parcelRegister("ahaWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01ee41faaac1d9d4$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $01ee41faaac1d9d4$var$mapCacheGet(key) {
    return (0, $cJjTF.default)(this, key).get(key);
}
var $01ee41faaac1d9d4$export$2e2bcd8739ae039 = $01ee41faaac1d9d4$var$mapCacheGet;

});

parcelRegister("aEyWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c18bf9970ec6687$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7c18bf9970ec6687$var$mapCacheHas(key) {
    return (0, $cJjTF.default)(this, key).has(key);
}
var $7c18bf9970ec6687$export$2e2bcd8739ae039 = $7c18bf9970ec6687$var$mapCacheHas;

});

parcelRegister("8IZ52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65a1d010d8cc020c$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $65a1d010d8cc020c$var$mapCacheSet(key, value) {
    var data = (0, $cJjTF.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $65a1d010d8cc020c$export$2e2bcd8739ae039 = $65a1d010d8cc020c$var$mapCacheSet;

});




parcelRegister("e2HqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a392f12cc24a8c1b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a392f12cc24a8c1b$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $a392f12cc24a8c1b$export$2e2bcd8739ae039 = $a392f12cc24a8c1b$var$arrayEach;

});

parcelRegister("63H9W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4694806cb0ba57b2$export$2e2bcd8739ae039; });

var $9tesX = parcelRequire("9tesX");

var $8rNNR = parcelRequire("8rNNR");
/** Used for built-in method references. */ var $4694806cb0ba57b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4694806cb0ba57b2$var$hasOwnProperty = $4694806cb0ba57b2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4694806cb0ba57b2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($4694806cb0ba57b2$var$hasOwnProperty.call(object, key) && (0, $8rNNR.default)(objValue, value)) || value === undefined && !(key in object)) (0, $9tesX.default)(object, key, value);
}
var $4694806cb0ba57b2$export$2e2bcd8739ae039 = $4694806cb0ba57b2$var$assignValue;

});
parcelRegister("9tesX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e520b264f53a5d8$export$2e2bcd8739ae039; });

var $aLJRA = parcelRequire("aLJRA");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $6e520b264f53a5d8$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $aLJRA.default)) (0, $aLJRA.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $6e520b264f53a5d8$export$2e2bcd8739ae039 = $6e520b264f53a5d8$var$baseAssignValue;

});
parcelRegister("aLJRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d71dea847c6593c$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");
var $7d71dea847c6593c$var$defineProperty = function() {
    try {
        var func = (0, $4sTIN.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $7d71dea847c6593c$export$2e2bcd8739ae039 = $7d71dea847c6593c$var$defineProperty;

});



parcelRegister("bkn5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f3789711a9d613$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $5Hbw4 = parcelRequire("5Hbw4");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $83f3789711a9d613$var$baseAssign(object, source) {
    return object && (0, $eV9Y6.default)(source, (0, $5Hbw4.default)(source), object);
}
var $83f3789711a9d613$export$2e2bcd8739ae039 = $83f3789711a9d613$var$baseAssign;

});
parcelRegister("eV9Y6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adce1f12e2c6ad03$export$2e2bcd8739ae039; });

var $63H9W = parcelRequire("63H9W");

var $9tesX = parcelRequire("9tesX");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $adce1f12e2c6ad03$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $9tesX.default)(object, key, newValue);
        else (0, $63H9W.default)(object, key, newValue);
    }
    return object;
}
var $adce1f12e2c6ad03$export$2e2bcd8739ae039 = $adce1f12e2c6ad03$var$copyObject;

});

parcelRegister("5Hbw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4259e6c7f3fa1298$export$2e2bcd8739ae039; });

var $kde2o = parcelRequire("kde2o");

var $12xWQ = parcelRequire("12xWQ");

var $22VAg = parcelRequire("22VAg");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $4259e6c7f3fa1298$var$keys(object) {
    return (0, $22VAg.default)(object) ? (0, $kde2o.default)(object) : (0, $12xWQ.default)(object);
}
var $4259e6c7f3fa1298$export$2e2bcd8739ae039 = $4259e6c7f3fa1298$var$keys;

});
parcelRegister("kde2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb6fe91d4b74a437$export$2e2bcd8739ae039; });

var $a0aAr = parcelRequire("a0aAr");

var $hgDUC = parcelRequire("hgDUC");

var $21thZ = parcelRequire("21thZ");

var $9VzRR = parcelRequire("9VzRR");

var $5J62f = parcelRequire("5J62f");

var $dayQm = parcelRequire("dayQm");
/** Used for built-in method references. */ var $eb6fe91d4b74a437$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb6fe91d4b74a437$var$hasOwnProperty = $eb6fe91d4b74a437$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $eb6fe91d4b74a437$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $21thZ.default)(value), isArg = !isArr && (0, $hgDUC.default)(value), isBuff = !isArr && !isArg && (0, $9VzRR.default)(value), isType = !isArr && !isArg && !isBuff && (0, $dayQm.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $a0aAr.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $eb6fe91d4b74a437$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $5J62f.default)(key, length)))) result.push(key);
    return result;
}
var $eb6fe91d4b74a437$export$2e2bcd8739ae039 = $eb6fe91d4b74a437$var$arrayLikeKeys;

});
parcelRegister("a0aAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74821dcb2e8e1d08$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $74821dcb2e8e1d08$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $74821dcb2e8e1d08$export$2e2bcd8739ae039 = $74821dcb2e8e1d08$var$baseTimes;

});

parcelRegister("hgDUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c922e408c6d5687e$export$2e2bcd8739ae039; });

var $e81IW = parcelRequire("e81IW");

var $1KYPq = parcelRequire("1KYPq");
/** Used for built-in method references. */ var $c922e408c6d5687e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c922e408c6d5687e$var$hasOwnProperty = $c922e408c6d5687e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $c922e408c6d5687e$var$propertyIsEnumerable = $c922e408c6d5687e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $c922e408c6d5687e$var$isArguments = (0, $e81IW.default)(function() {
    return arguments;
}()) ? (0, $e81IW.default) : function(value) {
    return (0, $1KYPq.default)(value) && $c922e408c6d5687e$var$hasOwnProperty.call(value, 'callee') && !$c922e408c6d5687e$var$propertyIsEnumerable.call(value, 'callee');
};
var $c922e408c6d5687e$export$2e2bcd8739ae039 = $c922e408c6d5687e$var$isArguments;

});
parcelRegister("e81IW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4932660b886c172$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $a4932660b886c172$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a4932660b886c172$var$baseIsArguments(value) {
    return (0, $1KYPq.default)(value) && (0, $cy2CN.default)(value) == $a4932660b886c172$var$argsTag;
}
var $a4932660b886c172$export$2e2bcd8739ae039 = $a4932660b886c172$var$baseIsArguments;

});


parcelRegister("21thZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $179264f9ce543aee$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $179264f9ce543aee$var$isArray = Array.isArray;
var $179264f9ce543aee$export$2e2bcd8739ae039 = $179264f9ce543aee$var$isArray;

});

parcelRegister("9VzRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a5427e4a118ab7$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");

var $gS81E = parcelRequire("gS81E");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $lQuKh.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $gS81E.default);
var $73a5427e4a118ab7$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("gS81E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c487ea32e66aaed6$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $c487ea32e66aaed6$var$stubFalse() {
    return false;
}
var $c487ea32e66aaed6$export$2e2bcd8739ae039 = $c487ea32e66aaed6$var$stubFalse;

});


parcelRegister("5J62f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b5d6334d9a7bef$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $42b5d6334d9a7bef$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $42b5d6334d9a7bef$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $42b5d6334d9a7bef$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $42b5d6334d9a7bef$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $42b5d6334d9a7bef$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $42b5d6334d9a7bef$export$2e2bcd8739ae039 = $42b5d6334d9a7bef$var$isIndex;

});

parcelRegister("dayQm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99673cbd809f8ae2$export$2e2bcd8739ae039; });

var $fmFRo = parcelRequire("fmFRo");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $99673cbd809f8ae2$var$nodeIsTypedArray = (0, $9nRTT.default) && (0, $9nRTT.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $99673cbd809f8ae2$var$isTypedArray = $99673cbd809f8ae2$var$nodeIsTypedArray ? (0, $5vqVN.default)($99673cbd809f8ae2$var$nodeIsTypedArray) : (0, $fmFRo.default);
var $99673cbd809f8ae2$export$2e2bcd8739ae039 = $99673cbd809f8ae2$var$isTypedArray;

});
parcelRegister("fmFRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f961a53998d846$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $WvlOx = parcelRequire("WvlOx");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $b2f961a53998d846$var$argsTag = '[object Arguments]', $b2f961a53998d846$var$arrayTag = '[object Array]', $b2f961a53998d846$var$boolTag = '[object Boolean]', $b2f961a53998d846$var$dateTag = '[object Date]', $b2f961a53998d846$var$errorTag = '[object Error]', $b2f961a53998d846$var$funcTag = '[object Function]', $b2f961a53998d846$var$mapTag = '[object Map]', $b2f961a53998d846$var$numberTag = '[object Number]', $b2f961a53998d846$var$objectTag = '[object Object]', $b2f961a53998d846$var$regexpTag = '[object RegExp]', $b2f961a53998d846$var$setTag = '[object Set]', $b2f961a53998d846$var$stringTag = '[object String]', $b2f961a53998d846$var$weakMapTag = '[object WeakMap]';
var $b2f961a53998d846$var$arrayBufferTag = '[object ArrayBuffer]', $b2f961a53998d846$var$dataViewTag = '[object DataView]', $b2f961a53998d846$var$float32Tag = '[object Float32Array]', $b2f961a53998d846$var$float64Tag = '[object Float64Array]', $b2f961a53998d846$var$int8Tag = '[object Int8Array]', $b2f961a53998d846$var$int16Tag = '[object Int16Array]', $b2f961a53998d846$var$int32Tag = '[object Int32Array]', $b2f961a53998d846$var$uint8Tag = '[object Uint8Array]', $b2f961a53998d846$var$uint8ClampedTag = '[object Uint8ClampedArray]', $b2f961a53998d846$var$uint16Tag = '[object Uint16Array]', $b2f961a53998d846$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $b2f961a53998d846$var$typedArrayTags = {};
$b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$float32Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$float64Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int8Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int16Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int32Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint8Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint8ClampedTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint16Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint32Tag] = true;
$b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$argsTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$arrayTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$arrayBufferTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$boolTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$dataViewTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$dateTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$errorTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$funcTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$mapTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$numberTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$objectTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$regexpTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$setTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$stringTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $b2f961a53998d846$var$baseIsTypedArray(value) {
    return (0, $1KYPq.default)(value) && (0, $WvlOx.default)(value.length) && !!$b2f961a53998d846$var$typedArrayTags[(0, $cy2CN.default)(value)];
}
var $b2f961a53998d846$export$2e2bcd8739ae039 = $b2f961a53998d846$var$baseIsTypedArray;

});
parcelRegister("WvlOx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0afdbc84c9df65f0$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $0afdbc84c9df65f0$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0afdbc84c9df65f0$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0afdbc84c9df65f0$var$MAX_SAFE_INTEGER;
}
var $0afdbc84c9df65f0$export$2e2bcd8739ae039 = $0afdbc84c9df65f0$var$isLength;

});


parcelRegister("5vqVN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4024bcf711d20cd7$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4024bcf711d20cd7$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $4024bcf711d20cd7$export$2e2bcd8739ae039 = $4024bcf711d20cd7$var$baseUnary;

});

parcelRegister("9nRTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c35b234f7d6a31$export$2e2bcd8739ae039; });

var $ggtzD = parcelRequire("ggtzD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $ggtzD.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $01c35b234f7d6a31$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("12xWQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c204fb9bba198f6$export$2e2bcd8739ae039; });

var $aWscJ = parcelRequire("aWscJ");

var $KMimB = parcelRequire("KMimB");
/** Used for built-in method references. */ var $0c204fb9bba198f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c204fb9bba198f6$var$hasOwnProperty = $0c204fb9bba198f6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0c204fb9bba198f6$var$baseKeys(object) {
    if (!(0, $aWscJ.default)(object)) return (0, $KMimB.default)(object);
    var result = [];
    for(var key in Object(object))if ($0c204fb9bba198f6$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $0c204fb9bba198f6$export$2e2bcd8739ae039 = $0c204fb9bba198f6$var$baseKeys;

});
parcelRegister("aWscJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f7532f83b2b457d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7f7532f83b2b457d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7f7532f83b2b457d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $7f7532f83b2b457d$var$objectProto;
    return value === proto;
}
var $7f7532f83b2b457d$export$2e2bcd8739ae039 = $7f7532f83b2b457d$var$isPrototype;

});

parcelRegister("KMimB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c9c2692486085b$export$2e2bcd8739ae039; });

var $4qlTy = parcelRequire("4qlTy");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $08c9c2692486085b$var$nativeKeys = (0, $4qlTy.default)(Object.keys, Object);
var $08c9c2692486085b$export$2e2bcd8739ae039 = $08c9c2692486085b$var$nativeKeys;

});


parcelRegister("22VAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17d86fa7581565f0$export$2e2bcd8739ae039; });

var $7A1Sy = parcelRequire("7A1Sy");

var $WvlOx = parcelRequire("WvlOx");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $17d86fa7581565f0$var$isArrayLike(value) {
    return value != null && (0, $WvlOx.default)(value.length) && !(0, $7A1Sy.default)(value);
}
var $17d86fa7581565f0$export$2e2bcd8739ae039 = $17d86fa7581565f0$var$isArrayLike;

});



parcelRegister("kdWVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb92bc726751f5ff$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $kKvqE = parcelRequire("kKvqE");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $eb92bc726751f5ff$var$baseAssignIn(object, source) {
    return object && (0, $eV9Y6.default)(source, (0, $kKvqE.default)(source), object);
}
var $eb92bc726751f5ff$export$2e2bcd8739ae039 = $eb92bc726751f5ff$var$baseAssignIn;

});
parcelRegister("kKvqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b07baa806f24aa$export$2e2bcd8739ae039; });

var $kde2o = parcelRequire("kde2o");

var $4jo4S = parcelRequire("4jo4S");

var $22VAg = parcelRequire("22VAg");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $f1b07baa806f24aa$var$keysIn(object) {
    return (0, $22VAg.default)(object) ? (0, $kde2o.default)(object, true) : (0, $4jo4S.default)(object);
}
var $f1b07baa806f24aa$export$2e2bcd8739ae039 = $f1b07baa806f24aa$var$keysIn;

});
parcelRegister("4jo4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $323b9d1774e2a53a$export$2e2bcd8739ae039; });

var $1i0Jy = parcelRequire("1i0Jy");

var $aWscJ = parcelRequire("aWscJ");

var $gPG8d = parcelRequire("gPG8d");
/** Used for built-in method references. */ var $323b9d1774e2a53a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $323b9d1774e2a53a$var$hasOwnProperty = $323b9d1774e2a53a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $323b9d1774e2a53a$var$baseKeysIn(object) {
    if (!(0, $1i0Jy.default)(object)) return (0, $gPG8d.default)(object);
    var isProto = (0, $aWscJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$323b9d1774e2a53a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $323b9d1774e2a53a$export$2e2bcd8739ae039 = $323b9d1774e2a53a$var$baseKeysIn;

});
parcelRegister("gPG8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4121738b9afa34f$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c4121738b9afa34f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $c4121738b9afa34f$export$2e2bcd8739ae039 = $c4121738b9afa34f$var$nativeKeysIn;

});




parcelRegister("eWRTU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae204b0fcd037a62$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $lQuKh.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $ae204b0fcd037a62$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("axhnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aba7877210b4da7$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7aba7877210b4da7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $7aba7877210b4da7$export$2e2bcd8739ae039 = $7aba7877210b4da7$var$copyArray;

});

parcelRegister("QlRlC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d5d0461fd2f821$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $ertEb = parcelRequire("ertEb");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $09d5d0461fd2f821$var$copySymbols(source, object) {
    return (0, $eV9Y6.default)(source, (0, $ertEb.default)(source), object);
}
var $09d5d0461fd2f821$export$2e2bcd8739ae039 = $09d5d0461fd2f821$var$copySymbols;

});
parcelRegister("ertEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83a9596b02d4cea$export$2e2bcd8739ae039; });

var $9W7yx = parcelRequire("9W7yx");

var $6QHKG = parcelRequire("6QHKG");
/** Used for built-in method references. */ var $a83a9596b02d4cea$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a83a9596b02d4cea$var$propertyIsEnumerable = $a83a9596b02d4cea$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a83a9596b02d4cea$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a83a9596b02d4cea$var$getSymbols = !$a83a9596b02d4cea$var$nativeGetSymbols ? (0, $6QHKG.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9W7yx.default)($a83a9596b02d4cea$var$nativeGetSymbols(object), function(symbol) {
        return $a83a9596b02d4cea$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $a83a9596b02d4cea$export$2e2bcd8739ae039 = $a83a9596b02d4cea$var$getSymbols;

});
parcelRegister("9W7yx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73bf644ceb877fe7$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $73bf644ceb877fe7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $73bf644ceb877fe7$export$2e2bcd8739ae039 = $73bf644ceb877fe7$var$arrayFilter;

});

parcelRegister("6QHKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc989a067b78028$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $4fc989a067b78028$var$stubArray() {
    return [];
}
var $4fc989a067b78028$export$2e2bcd8739ae039 = $4fc989a067b78028$var$stubArray;

});



parcelRegister("94uxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ac2e392040bbd6$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $a9Xh9 = parcelRequire("a9Xh9");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $69ac2e392040bbd6$var$copySymbolsIn(source, object) {
    return (0, $eV9Y6.default)(source, (0, $a9Xh9.default)(source), object);
}
var $69ac2e392040bbd6$export$2e2bcd8739ae039 = $69ac2e392040bbd6$var$copySymbolsIn;

});
parcelRegister("a9Xh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7658b99138951991$export$2e2bcd8739ae039; });

var $hoU2e = parcelRequire("hoU2e");

var $4Quro = parcelRequire("4Quro");

var $ertEb = parcelRequire("ertEb");

var $6QHKG = parcelRequire("6QHKG");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7658b99138951991$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7658b99138951991$var$getSymbolsIn = !$7658b99138951991$var$nativeGetSymbols ? (0, $6QHKG.default) : function(object) {
    var result = [];
    while(object){
        (0, $hoU2e.default)(result, (0, $ertEb.default)(object));
        object = (0, $4Quro.default)(object);
    }
    return result;
};
var $7658b99138951991$export$2e2bcd8739ae039 = $7658b99138951991$var$getSymbolsIn;

});
parcelRegister("hoU2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cab024f002660c74$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cab024f002660c74$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $cab024f002660c74$export$2e2bcd8739ae039 = $cab024f002660c74$var$arrayPush;

});



parcelRegister("kjGCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca6a3c3cc1072ab$export$2e2bcd8739ae039; });

var $aWyrS = parcelRequire("aWyrS");

var $ertEb = parcelRequire("ertEb");

var $5Hbw4 = parcelRequire("5Hbw4");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $eca6a3c3cc1072ab$var$getAllKeys(object) {
    return (0, $aWyrS.default)(object, (0, $5Hbw4.default), (0, $ertEb.default));
}
var $eca6a3c3cc1072ab$export$2e2bcd8739ae039 = $eca6a3c3cc1072ab$var$getAllKeys;

});
parcelRegister("aWyrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f7a0af3faa3ac35$export$2e2bcd8739ae039; });

var $hoU2e = parcelRequire("hoU2e");

var $21thZ = parcelRequire("21thZ");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7f7a0af3faa3ac35$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $21thZ.default)(object) ? result : (0, $hoU2e.default)(result, symbolsFunc(object));
}
var $7f7a0af3faa3ac35$export$2e2bcd8739ae039 = $7f7a0af3faa3ac35$var$baseGetAllKeys;

});


parcelRegister("boZAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d1b60390f8fc47$export$2e2bcd8739ae039; });

var $aWyrS = parcelRequire("aWyrS");

var $a9Xh9 = parcelRequire("a9Xh9");

var $kKvqE = parcelRequire("kKvqE");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $84d1b60390f8fc47$var$getAllKeysIn(object) {
    return (0, $aWyrS.default)(object, (0, $kKvqE.default), (0, $a9Xh9.default));
}
var $84d1b60390f8fc47$export$2e2bcd8739ae039 = $84d1b60390f8fc47$var$getAllKeysIn;

});

parcelRegister("1if5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f132d13782e2bd7$export$2e2bcd8739ae039; });

var $5bQpt = parcelRequire("5bQpt");

var $bYE5r = parcelRequire("bYE5r");

var $6yTOP = parcelRequire("6yTOP");

var $3F07B = parcelRequire("3F07B");

var $jx2Eb = parcelRequire("jx2Eb");

var $cy2CN = parcelRequire("cy2CN");

var $e6A8i = parcelRequire("e6A8i");
/** `Object#toString` result references. */ var $0f132d13782e2bd7$var$mapTag = '[object Map]', $0f132d13782e2bd7$var$objectTag = '[object Object]', $0f132d13782e2bd7$var$promiseTag = '[object Promise]', $0f132d13782e2bd7$var$setTag = '[object Set]', $0f132d13782e2bd7$var$weakMapTag = '[object WeakMap]';
var $0f132d13782e2bd7$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $0f132d13782e2bd7$var$dataViewCtorString = (0, $e6A8i.default)((0, $5bQpt.default)), $0f132d13782e2bd7$var$mapCtorString = (0, $e6A8i.default)((0, $bYE5r.default)), $0f132d13782e2bd7$var$promiseCtorString = (0, $e6A8i.default)((0, $6yTOP.default)), $0f132d13782e2bd7$var$setCtorString = (0, $e6A8i.default)((0, $3F07B.default)), $0f132d13782e2bd7$var$weakMapCtorString = (0, $e6A8i.default)((0, $jx2Eb.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0f132d13782e2bd7$var$getTag = (0, $cy2CN.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $5bQpt.default) && $0f132d13782e2bd7$var$getTag(new (0, $5bQpt.default)(new ArrayBuffer(1))) != $0f132d13782e2bd7$var$dataViewTag || (0, $bYE5r.default) && $0f132d13782e2bd7$var$getTag(new (0, $bYE5r.default)) != $0f132d13782e2bd7$var$mapTag || (0, $6yTOP.default) && $0f132d13782e2bd7$var$getTag((0, $6yTOP.default).resolve()) != $0f132d13782e2bd7$var$promiseTag || (0, $3F07B.default) && $0f132d13782e2bd7$var$getTag(new (0, $3F07B.default)) != $0f132d13782e2bd7$var$setTag || (0, $jx2Eb.default) && $0f132d13782e2bd7$var$getTag(new (0, $jx2Eb.default)) != $0f132d13782e2bd7$var$weakMapTag) $0f132d13782e2bd7$var$getTag = function(value) {
    var result = (0, $cy2CN.default)(value), Ctor = result == $0f132d13782e2bd7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $e6A8i.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $0f132d13782e2bd7$var$dataViewCtorString:
            return $0f132d13782e2bd7$var$dataViewTag;
        case $0f132d13782e2bd7$var$mapCtorString:
            return $0f132d13782e2bd7$var$mapTag;
        case $0f132d13782e2bd7$var$promiseCtorString:
            return $0f132d13782e2bd7$var$promiseTag;
        case $0f132d13782e2bd7$var$setCtorString:
            return $0f132d13782e2bd7$var$setTag;
        case $0f132d13782e2bd7$var$weakMapCtorString:
            return $0f132d13782e2bd7$var$weakMapTag;
    }
    return result;
};
var $0f132d13782e2bd7$export$2e2bcd8739ae039 = $0f132d13782e2bd7$var$getTag;

});
parcelRegister("5bQpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c76a2572c0f23d7$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $3c76a2572c0f23d7$var$DataView = (0, $4sTIN.default)((0, $lQuKh.default), 'DataView');
var $3c76a2572c0f23d7$export$2e2bcd8739ae039 = $3c76a2572c0f23d7$var$DataView;

});

parcelRegister("6yTOP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c71378715b84423$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $4c71378715b84423$var$Promise = (0, $4sTIN.default)((0, $lQuKh.default), 'Promise');
var $4c71378715b84423$export$2e2bcd8739ae039 = $4c71378715b84423$var$Promise;

});

parcelRegister("3F07B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aa54b957a373224$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $2aa54b957a373224$var$Set = (0, $4sTIN.default)((0, $lQuKh.default), 'Set');
var $2aa54b957a373224$export$2e2bcd8739ae039 = $2aa54b957a373224$var$Set;

});

parcelRegister("jx2Eb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e383270dab653f5b$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $e383270dab653f5b$var$WeakMap = (0, $4sTIN.default)((0, $lQuKh.default), 'WeakMap');
var $e383270dab653f5b$export$2e2bcd8739ae039 = $e383270dab653f5b$var$WeakMap;

});


parcelRegister("1VLyO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $168001db92f1aea0$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $168001db92f1aea0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $168001db92f1aea0$var$hasOwnProperty = $168001db92f1aea0$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $168001db92f1aea0$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $168001db92f1aea0$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $168001db92f1aea0$export$2e2bcd8739ae039 = $168001db92f1aea0$var$initCloneArray;

});

parcelRegister("5JrOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c6bc11fc33d96c$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");

var $ci3fc = parcelRequire("ci3fc");

var $8KQwf = parcelRequire("8KQwf");

var $eMHiy = parcelRequire("eMHiy");

var $gFp2c = parcelRequire("gFp2c");
/** `Object#toString` result references. */ var $42c6bc11fc33d96c$var$boolTag = '[object Boolean]', $42c6bc11fc33d96c$var$dateTag = '[object Date]', $42c6bc11fc33d96c$var$mapTag = '[object Map]', $42c6bc11fc33d96c$var$numberTag = '[object Number]', $42c6bc11fc33d96c$var$regexpTag = '[object RegExp]', $42c6bc11fc33d96c$var$setTag = '[object Set]', $42c6bc11fc33d96c$var$stringTag = '[object String]', $42c6bc11fc33d96c$var$symbolTag = '[object Symbol]';
var $42c6bc11fc33d96c$var$arrayBufferTag = '[object ArrayBuffer]', $42c6bc11fc33d96c$var$dataViewTag = '[object DataView]', $42c6bc11fc33d96c$var$float32Tag = '[object Float32Array]', $42c6bc11fc33d96c$var$float64Tag = '[object Float64Array]', $42c6bc11fc33d96c$var$int8Tag = '[object Int8Array]', $42c6bc11fc33d96c$var$int16Tag = '[object Int16Array]', $42c6bc11fc33d96c$var$int32Tag = '[object Int32Array]', $42c6bc11fc33d96c$var$uint8Tag = '[object Uint8Array]', $42c6bc11fc33d96c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $42c6bc11fc33d96c$var$uint16Tag = '[object Uint16Array]', $42c6bc11fc33d96c$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $42c6bc11fc33d96c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $42c6bc11fc33d96c$var$arrayBufferTag:
            return (0, $8e2Q0.default)(object);
        case $42c6bc11fc33d96c$var$boolTag:
        case $42c6bc11fc33d96c$var$dateTag:
            return new Ctor(+object);
        case $42c6bc11fc33d96c$var$dataViewTag:
            return (0, $ci3fc.default)(object, isDeep);
        case $42c6bc11fc33d96c$var$float32Tag:
        case $42c6bc11fc33d96c$var$float64Tag:
        case $42c6bc11fc33d96c$var$int8Tag:
        case $42c6bc11fc33d96c$var$int16Tag:
        case $42c6bc11fc33d96c$var$int32Tag:
        case $42c6bc11fc33d96c$var$uint8Tag:
        case $42c6bc11fc33d96c$var$uint8ClampedTag:
        case $42c6bc11fc33d96c$var$uint16Tag:
        case $42c6bc11fc33d96c$var$uint32Tag:
            return (0, $gFp2c.default)(object, isDeep);
        case $42c6bc11fc33d96c$var$mapTag:
            return new Ctor;
        case $42c6bc11fc33d96c$var$numberTag:
        case $42c6bc11fc33d96c$var$stringTag:
            return new Ctor(object);
        case $42c6bc11fc33d96c$var$regexpTag:
            return (0, $8KQwf.default)(object);
        case $42c6bc11fc33d96c$var$setTag:
            return new Ctor;
        case $42c6bc11fc33d96c$var$symbolTag:
            return (0, $eMHiy.default)(object);
    }
}
var $42c6bc11fc33d96c$export$2e2bcd8739ae039 = $42c6bc11fc33d96c$var$initCloneByTag;

});
parcelRegister("8e2Q0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd1d50b63be2ebc$export$2e2bcd8739ae039; });

var $4jys5 = parcelRequire("4jys5");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $5fd1d50b63be2ebc$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $4jys5.default)(result).set(new (0, $4jys5.default)(arrayBuffer));
    return result;
}
var $5fd1d50b63be2ebc$export$2e2bcd8739ae039 = $5fd1d50b63be2ebc$var$cloneArrayBuffer;

});
parcelRegister("4jys5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3243a934d462e803$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Built-in value references. */ var $3243a934d462e803$var$Uint8Array = (0, $lQuKh.default).Uint8Array;
var $3243a934d462e803$export$2e2bcd8739ae039 = $3243a934d462e803$var$Uint8Array;

});


parcelRegister("ci3fc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f29aeb55987107c$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $8f29aeb55987107c$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $8e2Q0.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $8f29aeb55987107c$export$2e2bcd8739ae039 = $8f29aeb55987107c$var$cloneDataView;

});

parcelRegister("8KQwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65fb5bd4f46ae094$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $65fb5bd4f46ae094$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $65fb5bd4f46ae094$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $65fb5bd4f46ae094$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $65fb5bd4f46ae094$export$2e2bcd8739ae039 = $65fb5bd4f46ae094$var$cloneRegExp;

});

parcelRegister("eMHiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac37228034dd7306$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");
/** Used to convert symbols to primitives and strings. */ var $ac37228034dd7306$var$symbolProto = (0, $aojMU.default) ? (0, $aojMU.default).prototype : undefined, $ac37228034dd7306$var$symbolValueOf = $ac37228034dd7306$var$symbolProto ? $ac37228034dd7306$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $ac37228034dd7306$var$cloneSymbol(symbol) {
    return $ac37228034dd7306$var$symbolValueOf ? Object($ac37228034dd7306$var$symbolValueOf.call(symbol)) : {};
}
var $ac37228034dd7306$export$2e2bcd8739ae039 = $ac37228034dd7306$var$cloneSymbol;

});

parcelRegister("gFp2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c223e5036c1d56c3$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c223e5036c1d56c3$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $8e2Q0.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $c223e5036c1d56c3$export$2e2bcd8739ae039 = $c223e5036c1d56c3$var$cloneTypedArray;

});


parcelRegister("cFFwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939985e73ed3ed8e$export$2e2bcd8739ae039; });

var $ewghx = parcelRequire("ewghx");

var $4Quro = parcelRequire("4Quro");

var $aWscJ = parcelRequire("aWscJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $939985e73ed3ed8e$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $aWscJ.default)(object) ? (0, $ewghx.default)((0, $4Quro.default)(object)) : {};
}
var $939985e73ed3ed8e$export$2e2bcd8739ae039 = $939985e73ed3ed8e$var$initCloneObject;

});
parcelRegister("ewghx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a920af115c4db8d5$export$2e2bcd8739ae039; });

var $1i0Jy = parcelRequire("1i0Jy");
/** Built-in value references. */ var $a920af115c4db8d5$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a920af115c4db8d5$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $1i0Jy.default)(proto)) return {};
        if ($a920af115c4db8d5$var$objectCreate) return $a920af115c4db8d5$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $a920af115c4db8d5$export$2e2bcd8739ae039 = $a920af115c4db8d5$var$baseCreate;

});


parcelRegister("jgOzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e076bea9d687c597$export$2e2bcd8739ae039; });

var $5wiMM = parcelRequire("5wiMM");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $e076bea9d687c597$var$nodeIsMap = (0, $9nRTT.default) && (0, $9nRTT.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e076bea9d687c597$var$isMap = $e076bea9d687c597$var$nodeIsMap ? (0, $5vqVN.default)($e076bea9d687c597$var$nodeIsMap) : (0, $5wiMM.default);
var $e076bea9d687c597$export$2e2bcd8739ae039 = $e076bea9d687c597$var$isMap;

});
parcelRegister("5wiMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404e8359b4044d6f$export$2e2bcd8739ae039; });

var $1if5w = parcelRequire("1if5w");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $404e8359b4044d6f$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $404e8359b4044d6f$var$baseIsMap(value) {
    return (0, $1KYPq.default)(value) && (0, $1if5w.default)(value) == $404e8359b4044d6f$var$mapTag;
}
var $404e8359b4044d6f$export$2e2bcd8739ae039 = $404e8359b4044d6f$var$baseIsMap;

});


parcelRegister("c6ppW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cf9c2ee70d3c1fc$export$2e2bcd8739ae039; });

var $k7W4N = parcelRequire("k7W4N");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $8cf9c2ee70d3c1fc$var$nodeIsSet = (0, $9nRTT.default) && (0, $9nRTT.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8cf9c2ee70d3c1fc$var$isSet = $8cf9c2ee70d3c1fc$var$nodeIsSet ? (0, $5vqVN.default)($8cf9c2ee70d3c1fc$var$nodeIsSet) : (0, $k7W4N.default);
var $8cf9c2ee70d3c1fc$export$2e2bcd8739ae039 = $8cf9c2ee70d3c1fc$var$isSet;

});
parcelRegister("k7W4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea7182d8a356a8ca$export$2e2bcd8739ae039; });

var $1if5w = parcelRequire("1if5w");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $ea7182d8a356a8ca$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ea7182d8a356a8ca$var$baseIsSet(value) {
    return (0, $1KYPq.default)(value) && (0, $1if5w.default)(value) == $ea7182d8a356a8ca$var$setTag;
}
var $ea7182d8a356a8ca$export$2e2bcd8739ae039 = $ea7182d8a356a8ca$var$baseIsSet;

});




parcelRegister("iC4RG", function(module, exports) {
'use strict';
var $d8cf8ca5172c2b64$var$isArray = Array.isArray;
var $d8cf8ca5172c2b64$var$keyList = Object.keys;
var $d8cf8ca5172c2b64$var$hasProp = Object.prototype.hasOwnProperty;
var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== 'undefined';
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $d8cf8ca5172c2b64$var$isArray(a), arrB = $d8cf8ca5172c2b64$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $d8cf8ca5172c2b64$var$keyList(a);
        length = keys.length;
        if (length !== $d8cf8ca5172c2b64$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$d8cf8ca5172c2b64$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("8knIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6102969760a10d5a$export$2e2bcd8739ae039; });
var $6102969760a10d5a$var$isProduction = true;
function $6102969760a10d5a$var$warning(condition, message) {
    if (!$6102969760a10d5a$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $6102969760a10d5a$export$2e2bcd8739ae039 = $6102969760a10d5a$var$warning;

});

parcelRegister("2eESg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a0c985f32b80dd3$export$2e2bcd8739ae039; });

var $3kFHB = parcelRequire("3kFHB");
/** Used to compose bitmasks for cloning. */ var $1a0c985f32b80dd3$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $1a0c985f32b80dd3$var$clone(value) {
    return (0, $3kFHB.default)(value, $1a0c985f32b80dd3$var$CLONE_SYMBOLS_FLAG);
}
var $1a0c985f32b80dd3$export$2e2bcd8739ae039 = $1a0c985f32b80dd3$var$clone;

});

parcelRegister("5yFbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40c013bde851d67f$export$2e2bcd8739ae039; });

var $69ERV = parcelRequire("69ERV");

var $axhnQ = parcelRequire("axhnQ");

var $21thZ = parcelRequire("21thZ");

var $bOFLd = parcelRequire("bOFLd");

var $f9EQJ = parcelRequire("f9EQJ");

var $5K1Jf = parcelRequire("5K1Jf");

var $6qWbV = parcelRequire("6qWbV");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $40c013bde851d67f$var$toPath(value) {
    if ((0, $21thZ.default)(value)) return (0, $69ERV.default)(value, (0, $5K1Jf.default));
    return (0, $bOFLd.default)(value) ? [
        value
    ] : (0, $axhnQ.default)((0, $f9EQJ.default)((0, $6qWbV.default)(value)));
}
var $40c013bde851d67f$export$2e2bcd8739ae039 = $40c013bde851d67f$var$toPath;

});
parcelRegister("69ERV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47b34906cca9b943$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $47b34906cca9b943$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $47b34906cca9b943$export$2e2bcd8739ae039 = $47b34906cca9b943$var$arrayMap;

});

parcelRegister("bOFLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a4c1ff51648a4e$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $89a4c1ff51648a4e$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $89a4c1ff51648a4e$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $1KYPq.default)(value) && (0, $cy2CN.default)(value) == $89a4c1ff51648a4e$var$symbolTag;
}
var $89a4c1ff51648a4e$export$2e2bcd8739ae039 = $89a4c1ff51648a4e$var$isSymbol;

});

parcelRegister("f9EQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02d8e4ade81a7510$export$2e2bcd8739ae039; });

var $6ZrRy = parcelRequire("6ZrRy");
/** Used to match property names within property paths. */ var $02d8e4ade81a7510$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $02d8e4ade81a7510$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $02d8e4ade81a7510$var$stringToPath = (0, $6ZrRy.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($02d8e4ade81a7510$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($02d8e4ade81a7510$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $02d8e4ade81a7510$export$2e2bcd8739ae039 = $02d8e4ade81a7510$var$stringToPath;

});
parcelRegister("6ZrRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516e0d8dc866f6a9$export$2e2bcd8739ae039; });

var $hahxe = parcelRequire("hahxe");
/** Used as the maximum memoize cache size. */ var $516e0d8dc866f6a9$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $516e0d8dc866f6a9$var$memoizeCapped(func) {
    var result = (0, $hahxe.default)(func, function(key) {
        if (cache.size === $516e0d8dc866f6a9$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $516e0d8dc866f6a9$export$2e2bcd8739ae039 = $516e0d8dc866f6a9$var$memoizeCapped;

});
parcelRegister("hahxe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7f0f8eefb3fb63a$export$2e2bcd8739ae039; });

var $5fToR = parcelRequire("5fToR");
/** Error message constants. */ var $c7f0f8eefb3fb63a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c7f0f8eefb3fb63a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c7f0f8eefb3fb63a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c7f0f8eefb3fb63a$var$memoize.Cache || (0, $5fToR.default));
    return memoized;
}
// Expose `MapCache`.
$c7f0f8eefb3fb63a$var$memoize.Cache = (0, $5fToR.default);
var $c7f0f8eefb3fb63a$export$2e2bcd8739ae039 = $c7f0f8eefb3fb63a$var$memoize;

});



parcelRegister("5K1Jf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42e296ef19650489$export$2e2bcd8739ae039; });

var $bOFLd = parcelRequire("bOFLd");
/** Used as references for various `Number` constants. */ var $42e296ef19650489$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $42e296ef19650489$var$toKey(value) {
    if (typeof value == 'string' || (0, $bOFLd.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$42e296ef19650489$var$INFINITY ? '-0' : result;
}
var $42e296ef19650489$export$2e2bcd8739ae039 = $42e296ef19650489$var$toKey;

});

parcelRegister("6qWbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4af24f5a0f17e4e4$export$2e2bcd8739ae039; });

var $6EH8L = parcelRequire("6EH8L");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4af24f5a0f17e4e4$var$toString(value) {
    return value == null ? '' : (0, $6EH8L.default)(value);
}
var $4af24f5a0f17e4e4$export$2e2bcd8739ae039 = $4af24f5a0f17e4e4$var$toString;

});
parcelRegister("6EH8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d87f1452cbb9b8a$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");

var $69ERV = parcelRequire("69ERV");

var $21thZ = parcelRequire("21thZ");

var $bOFLd = parcelRequire("bOFLd");
/** Used as references for various `Number` constants. */ var $4d87f1452cbb9b8a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $4d87f1452cbb9b8a$var$symbolProto = (0, $aojMU.default) ? (0, $aojMU.default).prototype : undefined, $4d87f1452cbb9b8a$var$symbolToString = $4d87f1452cbb9b8a$var$symbolProto ? $4d87f1452cbb9b8a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $4d87f1452cbb9b8a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $21thZ.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $69ERV.default)(value, $4d87f1452cbb9b8a$var$baseToString) + '';
    if ((0, $bOFLd.default)(value)) return $4d87f1452cbb9b8a$var$symbolToString ? $4d87f1452cbb9b8a$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$4d87f1452cbb9b8a$var$INFINITY ? '-0' : result;
}
var $4d87f1452cbb9b8a$export$2e2bcd8739ae039 = $4d87f1452cbb9b8a$var$baseToString;

});



parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $j2VHG = parcelRequire("j2VHG");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($j2VHG.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("j2VHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("45MkT"));

});
parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});




parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("eDIlW", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $aa871cc94a608bc6$export$a7c73072b1a182ae; }, function (v) { return $aa871cc94a608bc6$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $aa871cc94a608bc6$export$9f27bc3417b4524d; }, function (v) { return $aa871cc94a608bc6$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $aa871cc94a608bc6$export$db77ccec0bb4ccac; }, function (v) { return $aa871cc94a608bc6$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $aa871cc94a608bc6$export$8392c0c9d3dcbd35; }, function (v) { return $aa871cc94a608bc6$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $aa871cc94a608bc6$export$ffb0004e005737fa; }, function (v) { return $aa871cc94a608bc6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $aa871cc94a608bc6$export$b624eff549462981; }, function (v) { return $aa871cc94a608bc6$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $aa871cc94a608bc6$export$7897aa7841a5380c; }, function (v) { return $aa871cc94a608bc6$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $aa871cc94a608bc6$export$602eac185826482c; }, function (v) { return $aa871cc94a608bc6$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $aa871cc94a608bc6$export$e2c29f18771995cb; }, function (v) { return $aa871cc94a608bc6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $aa871cc94a608bc6$export$5f8d39834fd61797; }, function (v) { return $aa871cc94a608bc6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $aa871cc94a608bc6$export$74bf444e3cd11ea5; }, function (v) { return $aa871cc94a608bc6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $aa871cc94a608bc6$export$998bcd577473dd93; }, function (v) { return $aa871cc94a608bc6$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $aa871cc94a608bc6$export$92387174baf9b227; }, function (v) { return $aa871cc94a608bc6$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $aa871cc94a608bc6$export$ec112efeb987d9c6; }, function (v) { return $aa871cc94a608bc6$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $aa871cc94a608bc6$export$b706b080d889d2c9; }, function (v) { return $aa871cc94a608bc6$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $aa871cc94a608bc6$export$5be5a87408f70ddc; }, function (v) { return $aa871cc94a608bc6$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $aa871cc94a608bc6$export$45a5e7f76e0caa8d; }, function (v) { return $aa871cc94a608bc6$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $aa871cc94a608bc6$export$455c2e768291efa6; }, function (v) { return $aa871cc94a608bc6$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $aa871cc94a608bc6$export$9522e17588c12572; }, function (v) { return $aa871cc94a608bc6$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $aa871cc94a608bc6$export$2110ac352bb060b9; }, function (v) { return $aa871cc94a608bc6$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $aa871cc94a608bc6$export$56885ab8b9c456ab; }, function (v) { return $aa871cc94a608bc6$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $aa871cc94a608bc6$export$d927fcb6adf8f9de; }, function (v) { return $aa871cc94a608bc6$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $aa871cc94a608bc6$export$b82d16f27459e05a; }, function (v) { return $aa871cc94a608bc6$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $aa871cc94a608bc6$export$522c17b4f5e123e8; }, function (v) { return $aa871cc94a608bc6$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $aa871cc94a608bc6$export$1aabd8a0274ecfd6; }, function (v) { return $aa871cc94a608bc6$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $aa871cc94a608bc6$export$3d6c20d97e46b957; }, function (v) { return $aa871cc94a608bc6$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $aa871cc94a608bc6$export$9b621391a187a31a; }, function (v) { return $aa871cc94a608bc6$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $aa871cc94a608bc6$export$f5bbd400c2f4426f; }, function (v) { return $aa871cc94a608bc6$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa871cc94a608bc6$export$a7c73072b1a182ae;
var $aa871cc94a608bc6$export$9f27bc3417b4524d;
var $aa871cc94a608bc6$export$db77ccec0bb4ccac;
var $aa871cc94a608bc6$export$8392c0c9d3dcbd35;
var $aa871cc94a608bc6$export$ffb0004e005737fa;
var $aa871cc94a608bc6$export$b624eff549462981;
var $aa871cc94a608bc6$export$7897aa7841a5380c;
var $aa871cc94a608bc6$export$602eac185826482c;
var $aa871cc94a608bc6$export$e2c29f18771995cb;
var $aa871cc94a608bc6$export$5f8d39834fd61797;
var $aa871cc94a608bc6$export$74bf444e3cd11ea5;
var $aa871cc94a608bc6$export$998bcd577473dd93;
var $aa871cc94a608bc6$export$92387174baf9b227;
var $aa871cc94a608bc6$export$ec112efeb987d9c6;
var $aa871cc94a608bc6$export$b706b080d889d2c9;
var $aa871cc94a608bc6$export$5be5a87408f70ddc;
var $aa871cc94a608bc6$export$45a5e7f76e0caa8d;
var $aa871cc94a608bc6$export$455c2e768291efa6;
var $aa871cc94a608bc6$export$9522e17588c12572;
var $aa871cc94a608bc6$export$2110ac352bb060b9;
var $aa871cc94a608bc6$export$56885ab8b9c456ab;
var $aa871cc94a608bc6$export$d927fcb6adf8f9de;
var $aa871cc94a608bc6$export$b82d16f27459e05a;
var $aa871cc94a608bc6$export$522c17b4f5e123e8;
var $aa871cc94a608bc6$export$1aabd8a0274ecfd6;
var $aa871cc94a608bc6$export$3d6c20d97e46b957;
var $aa871cc94a608bc6$export$9b621391a187a31a;
var $aa871cc94a608bc6$export$f5bbd400c2f4426f;
'use strict';
var $aa871cc94a608bc6$var$b = Symbol.for("react.element"), $aa871cc94a608bc6$var$c = Symbol.for("react.portal"), $aa871cc94a608bc6$var$d = Symbol.for("react.fragment"), $aa871cc94a608bc6$var$e = Symbol.for("react.strict_mode"), $aa871cc94a608bc6$var$f = Symbol.for("react.profiler"), $aa871cc94a608bc6$var$g = Symbol.for("react.provider"), $aa871cc94a608bc6$var$h = Symbol.for("react.context"), $aa871cc94a608bc6$var$k = Symbol.for("react.server_context"), $aa871cc94a608bc6$var$l = Symbol.for("react.forward_ref"), $aa871cc94a608bc6$var$m = Symbol.for("react.suspense"), $aa871cc94a608bc6$var$n = Symbol.for("react.suspense_list"), $aa871cc94a608bc6$var$p = Symbol.for("react.memo"), $aa871cc94a608bc6$var$q = Symbol.for("react.lazy"), $aa871cc94a608bc6$var$t = Symbol.for("react.offscreen"), $aa871cc94a608bc6$var$u;
$aa871cc94a608bc6$var$u = Symbol.for("react.module.reference");
function $aa871cc94a608bc6$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aa871cc94a608bc6$var$b:
                switch(a = a.type, a){
                    case $aa871cc94a608bc6$var$d:
                    case $aa871cc94a608bc6$var$f:
                    case $aa871cc94a608bc6$var$e:
                    case $aa871cc94a608bc6$var$m:
                    case $aa871cc94a608bc6$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aa871cc94a608bc6$var$k:
                            case $aa871cc94a608bc6$var$h:
                            case $aa871cc94a608bc6$var$l:
                            case $aa871cc94a608bc6$var$q:
                            case $aa871cc94a608bc6$var$p:
                            case $aa871cc94a608bc6$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aa871cc94a608bc6$var$c:
                return r;
        }
    }
}
$aa871cc94a608bc6$export$a7c73072b1a182ae = $aa871cc94a608bc6$var$h;
$aa871cc94a608bc6$export$9f27bc3417b4524d = $aa871cc94a608bc6$var$g;
$aa871cc94a608bc6$export$db77ccec0bb4ccac = $aa871cc94a608bc6$var$b;
$aa871cc94a608bc6$export$8392c0c9d3dcbd35 = $aa871cc94a608bc6$var$l;
$aa871cc94a608bc6$export$ffb0004e005737fa = $aa871cc94a608bc6$var$d;
$aa871cc94a608bc6$export$b624eff549462981 = $aa871cc94a608bc6$var$q;
$aa871cc94a608bc6$export$7897aa7841a5380c = $aa871cc94a608bc6$var$p;
$aa871cc94a608bc6$export$602eac185826482c = $aa871cc94a608bc6$var$c;
$aa871cc94a608bc6$export$e2c29f18771995cb = $aa871cc94a608bc6$var$f;
$aa871cc94a608bc6$export$5f8d39834fd61797 = $aa871cc94a608bc6$var$e;
$aa871cc94a608bc6$export$74bf444e3cd11ea5 = $aa871cc94a608bc6$var$m;
$aa871cc94a608bc6$export$998bcd577473dd93 = $aa871cc94a608bc6$var$n;
$aa871cc94a608bc6$export$92387174baf9b227 = function() {
    return !1;
};
$aa871cc94a608bc6$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aa871cc94a608bc6$export$b706b080d889d2c9 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$h;
};
$aa871cc94a608bc6$export$5be5a87408f70ddc = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$g;
};
$aa871cc94a608bc6$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aa871cc94a608bc6$var$b;
};
$aa871cc94a608bc6$export$455c2e768291efa6 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$l;
};
$aa871cc94a608bc6$export$9522e17588c12572 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$d;
};
$aa871cc94a608bc6$export$2110ac352bb060b9 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$q;
};
$aa871cc94a608bc6$export$56885ab8b9c456ab = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$p;
};
$aa871cc94a608bc6$export$d927fcb6adf8f9de = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$c;
};
$aa871cc94a608bc6$export$b82d16f27459e05a = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$f;
};
$aa871cc94a608bc6$export$522c17b4f5e123e8 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$e;
};
$aa871cc94a608bc6$export$1aabd8a0274ecfd6 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$m;
};
$aa871cc94a608bc6$export$3d6c20d97e46b957 = function(a) {
    return $aa871cc94a608bc6$var$v(a) === $aa871cc94a608bc6$var$n;
};
$aa871cc94a608bc6$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aa871cc94a608bc6$var$d || a === $aa871cc94a608bc6$var$f || a === $aa871cc94a608bc6$var$e || a === $aa871cc94a608bc6$var$m || a === $aa871cc94a608bc6$var$n || a === $aa871cc94a608bc6$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aa871cc94a608bc6$var$q || a.$$typeof === $aa871cc94a608bc6$var$p || a.$$typeof === $aa871cc94a608bc6$var$g || a.$$typeof === $aa871cc94a608bc6$var$h || a.$$typeof === $aa871cc94a608bc6$var$l || a.$$typeof === $aa871cc94a608bc6$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aa871cc94a608bc6$export$f5bbd400c2f4426f = $aa871cc94a608bc6$var$v;

});

parcelRegister("lONZV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $75qWJ = parcelRequire("75qWJ");
function $fe250d03cb1b809e$var$emptyFunction() {}
function $fe250d03cb1b809e$var$emptyFunctionWithReset() {}
$fe250d03cb1b809e$var$emptyFunctionWithReset.resetWarningCache = $fe250d03cb1b809e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $75qWJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $fe250d03cb1b809e$var$emptyFunctionWithReset,
        resetWarningCache: $fe250d03cb1b809e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("75qWJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $528de7070c869f35$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $528de7070c869f35$var$ReactPropTypesSecret;

});


parcelRegister("hROw0", function(module, exports) {

$parcel$export(module.exports, "BrowserLevel", function () { return $d01e922b87eec60d$export$a4f8bbd8583bb849; }, function (v) { return $d01e922b87eec60d$export$a4f8bbd8583bb849 = v; });
/* global indexedDB */ var $d01e922b87eec60d$export$a4f8bbd8583bb849;
'use strict';

var $iFQn2 = parcelRequire("iFQn2");
var $d01e922b87eec60d$require$AbstractLevel = $iFQn2.AbstractLevel;

var $b73to = parcelRequire("b73to");

var $eXXMq = parcelRequire("eXXMq");

var $51CIL = parcelRequire("51CIL");
var $d01e922b87eec60d$require$fromCallback = $51CIL.fromCallback;

var $jSRvk = parcelRequire("jSRvk");
var $d01e922b87eec60d$require$Iterator = $jSRvk.Iterator;

var $fGWjq = parcelRequire("fGWjq");

var $OphiR = parcelRequire("OphiR");

var $k7nM2 = parcelRequire("k7nM2");
// Keep as-is for compatibility with existing level-js databases
const $d01e922b87eec60d$var$DEFAULT_PREFIX = 'level-js-';
const $d01e922b87eec60d$var$kIDB = Symbol('idb');
const $d01e922b87eec60d$var$kNamePrefix = Symbol('namePrefix');
const $d01e922b87eec60d$var$kLocation = Symbol('location');
const $d01e922b87eec60d$var$kVersion = Symbol('version');
const $d01e922b87eec60d$var$kStore = Symbol('store');
const $d01e922b87eec60d$var$kOnComplete = Symbol('onComplete');
const $d01e922b87eec60d$var$kPromise = Symbol('promise');
class $d01e922b87eec60d$var$BrowserLevel extends $d01e922b87eec60d$require$AbstractLevel {
    constructor(location, options, _){
        // To help migrating to abstract-level
        if (typeof options === 'function' || typeof _ === 'function') throw new $b73to('The levelup-style callback argument has been removed', {
            code: 'LEVEL_LEGACY'
        });
        const { prefix: prefix, version: version, ...forward } = options || {};
        super({
            encodings: {
                view: true
            },
            snapshots: false,
            createIfMissing: false,
            errorIfExists: false,
            seek: true
        }, forward);
        if (typeof location !== 'string') throw new Error('constructor requires a location string argument');
        // TODO (next major): remove default prefix
        this[$d01e922b87eec60d$var$kLocation] = location;
        this[$d01e922b87eec60d$var$kNamePrefix] = prefix == null ? $d01e922b87eec60d$var$DEFAULT_PREFIX : prefix;
        this[$d01e922b87eec60d$var$kVersion] = parseInt(version || 1, 10);
        this[$d01e922b87eec60d$var$kIDB] = null;
    }
    get location() {
        return this[$d01e922b87eec60d$var$kLocation];
    }
    get namePrefix() {
        return this[$d01e922b87eec60d$var$kNamePrefix];
    }
    get version() {
        return this[$d01e922b87eec60d$var$kVersion];
    }
    // Exposed for backwards compat and unit tests
    get db() {
        return this[$d01e922b87eec60d$var$kIDB];
    }
    get type() {
        return 'browser-level';
    }
    _open(options, callback) {
        const req = indexedDB.open(this[$d01e922b87eec60d$var$kNamePrefix] + this[$d01e922b87eec60d$var$kLocation], this[$d01e922b87eec60d$var$kVersion]);
        req.onerror = function() {
            callback(req.error || new Error('unknown error'));
        };
        req.onsuccess = ()=>{
            this[$d01e922b87eec60d$var$kIDB] = req.result;
            callback();
        };
        req.onupgradeneeded = (ev)=>{
            const db = ev.target.result;
            if (!db.objectStoreNames.contains(this[$d01e922b87eec60d$var$kLocation])) db.createObjectStore(this[$d01e922b87eec60d$var$kLocation]);
        };
    }
    [$d01e922b87eec60d$var$kStore](mode) {
        const transaction = this[$d01e922b87eec60d$var$kIDB].transaction([
            this[$d01e922b87eec60d$var$kLocation]
        ], mode);
        return transaction.objectStore(this[$d01e922b87eec60d$var$kLocation]);
    }
    [$d01e922b87eec60d$var$kOnComplete](request, callback) {
        const transaction = request.transaction;
        // Take advantage of the fact that a non-canceled request error aborts
        // the transaction. I.e. no need to listen for "request.onerror".
        transaction.onabort = function() {
            callback(transaction.error || new Error('aborted by user'));
        };
        transaction.oncomplete = function() {
            callback(null, request.result);
        };
    }
    _get(key, options, callback) {
        const store = this[$d01e922b87eec60d$var$kStore]('readonly');
        let req;
        try {
            req = store.get(key);
        } catch (err) {
            return this.nextTick(callback, err);
        }
        this[$d01e922b87eec60d$var$kOnComplete](req, function(err, value) {
            if (err) return callback(err);
            if (value === undefined) return callback(new $b73to('Entry not found', {
                code: 'LEVEL_NOT_FOUND'
            }));
            callback(null, $fGWjq(value));
        });
    }
    _getMany(keys, options, callback) {
        const store = this[$d01e922b87eec60d$var$kStore]('readonly');
        const tasks = keys.map((key)=>(next)=>{
                let request;
                try {
                    request = store.get(key);
                } catch (err) {
                    return next(err);
                }
                request.onsuccess = ()=>{
                    const value = request.result;
                    next(null, value === undefined ? value : $fGWjq(value));
                };
                request.onerror = (ev)=>{
                    ev.stopPropagation();
                    next(request.error);
                };
            });
        $eXXMq(tasks, 16, callback);
    }
    _del(key, options, callback) {
        const store = this[$d01e922b87eec60d$var$kStore]('readwrite');
        let req;
        try {
            req = store.delete(key);
        } catch (err) {
            return this.nextTick(callback, err);
        }
        this[$d01e922b87eec60d$var$kOnComplete](req, callback);
    }
    _put(key, value, options, callback) {
        const store = this[$d01e922b87eec60d$var$kStore]('readwrite');
        let req;
        try {
            // Will throw a DataError or DataCloneError if the environment
            // does not support serializing the key or value respectively.
            req = store.put(value, key);
        } catch (err) {
            return this.nextTick(callback, err);
        }
        this[$d01e922b87eec60d$var$kOnComplete](req, callback);
    }
    // TODO: implement key and value iterators
    _iterator(options) {
        return new $d01e922b87eec60d$require$Iterator(this, this[$d01e922b87eec60d$var$kLocation], options);
    }
    _batch(operations, options, callback) {
        const store = this[$d01e922b87eec60d$var$kStore]('readwrite');
        const transaction = store.transaction;
        let index = 0;
        let error;
        transaction.onabort = function() {
            callback(error || transaction.error || new Error('aborted by user'));
        };
        transaction.oncomplete = function() {
            callback();
        };
        // Wait for a request to complete before making the next, saving CPU.
        function loop() {
            const op = operations[index++];
            const key = op.key;
            let req;
            try {
                req = op.type === 'del' ? store.delete(key) : store.put(op.value, key);
            } catch (err) {
                error = err;
                transaction.abort();
                return;
            }
            if (index < operations.length) req.onsuccess = loop;
            else if (typeof transaction.commit === 'function') // Commit now instead of waiting for auto-commit
            transaction.commit();
        }
        loop();
    }
    _clear(options, callback) {
        let keyRange;
        let req;
        try {
            keyRange = $k7nM2(options);
        } catch (e) {
            // The lower key is greater than the upper key.
            // IndexedDB throws an error, but we'll just do nothing.
            return this.nextTick(callback);
        }
        if (options.limit >= 0) // IDBObjectStore#delete(range) doesn't have such an option.
        // Fall back to cursor-based implementation.
        return $OphiR(this, this[$d01e922b87eec60d$var$kLocation], keyRange, options, callback);
        try {
            const store = this[$d01e922b87eec60d$var$kStore]('readwrite');
            req = keyRange ? store.delete(keyRange) : store.clear();
        } catch (err) {
            return this.nextTick(callback, err);
        }
        this[$d01e922b87eec60d$var$kOnComplete](req, callback);
    }
    _close(callback) {
        this[$d01e922b87eec60d$var$kIDB].close();
        this.nextTick(callback);
    }
}
$d01e922b87eec60d$var$BrowserLevel.destroy = function(location, prefix, callback) {
    if (typeof prefix === 'function') {
        callback = prefix;
        prefix = $d01e922b87eec60d$var$DEFAULT_PREFIX;
    }
    callback = $d01e922b87eec60d$require$fromCallback(callback, $d01e922b87eec60d$var$kPromise);
    const request = indexedDB.deleteDatabase(prefix + location);
    request.onsuccess = function() {
        callback();
    };
    request.onerror = function(err) {
        callback(err);
    };
    return callback[$d01e922b87eec60d$var$kPromise];
};
$d01e922b87eec60d$export$a4f8bbd8583bb849 = $d01e922b87eec60d$var$BrowserLevel;

});
parcelRegister("iFQn2", function(module, exports) {

$parcel$export(module.exports, "AbstractLevel", function () { return $d984ae0ec189c5ca$export$3e2c6c8f6c478102; }, function (v) { return $d984ae0ec189c5ca$export$3e2c6c8f6c478102 = v; });
$parcel$export(module.exports, "AbstractIterator", function () { return $d984ae0ec189c5ca$export$bddce72536e51c3d; }, function (v) { return $d984ae0ec189c5ca$export$bddce72536e51c3d = v; });
var $d984ae0ec189c5ca$export$3e2c6c8f6c478102;
var $d984ae0ec189c5ca$export$f506436e248a22a5;
var $d984ae0ec189c5ca$export$bddce72536e51c3d;
var $d984ae0ec189c5ca$export$f2a6a3524a0d1895;
var $d984ae0ec189c5ca$export$745e971bb830fb44;
var $d984ae0ec189c5ca$export$b7cc577567d0e62c;
'use strict';

$d984ae0ec189c5ca$export$3e2c6c8f6c478102 = (parcelRequire("49HoT")).AbstractLevel;

$d984ae0ec189c5ca$export$f506436e248a22a5 = (parcelRequire("49HoT")).AbstractSublevel;

$d984ae0ec189c5ca$export$bddce72536e51c3d = (parcelRequire("glCWx")).AbstractIterator;

$d984ae0ec189c5ca$export$f2a6a3524a0d1895 = (parcelRequire("glCWx")).AbstractKeyIterator;

$d984ae0ec189c5ca$export$745e971bb830fb44 = (parcelRequire("glCWx")).AbstractValueIterator;

$d984ae0ec189c5ca$export$b7cc577567d0e62c = (parcelRequire("1iIdo")).AbstractChainedBatch;

});
parcelRegister("49HoT", function(module, exports) {

$parcel$export(module.exports, "AbstractLevel", function () { return $3069ab1cfe611dc8$export$3e2c6c8f6c478102; }, function (v) { return $3069ab1cfe611dc8$export$3e2c6c8f6c478102 = v; });
$parcel$export(module.exports, "AbstractSublevel", function () { return $3069ab1cfe611dc8$export$f506436e248a22a5; }, function (v) { return $3069ab1cfe611dc8$export$f506436e248a22a5 = v; });
var $3069ab1cfe611dc8$export$3e2c6c8f6c478102;
var $3069ab1cfe611dc8$export$f506436e248a22a5;
'use strict';

var $fNuHe = parcelRequire("fNuHe");
var $3069ab1cfe611dc8$require$supports = $fNuHe.supports;

var $dT4fT = parcelRequire("dT4fT");
var $3069ab1cfe611dc8$require$Transcoder = $dT4fT.Transcoder;

var $fzCxw = parcelRequire("fzCxw");
var $3069ab1cfe611dc8$require$EventEmitter = $fzCxw.EventEmitter;

var $6uHRl = parcelRequire("6uHRl");
var $3069ab1cfe611dc8$require$fromCallback = $6uHRl.fromCallback;

var $b73to = parcelRequire("b73to");

var $glCWx = parcelRequire("glCWx");
var $3069ab1cfe611dc8$require$AbstractIterator = $glCWx.AbstractIterator;

var $9M4hz = parcelRequire("9M4hz");
var $3069ab1cfe611dc8$require$DefaultKeyIterator = $9M4hz.DefaultKeyIterator;
var $3069ab1cfe611dc8$require$DefaultValueIterator = $9M4hz.DefaultValueIterator;

var $6Upf3 = parcelRequire("6Upf3");
var $3069ab1cfe611dc8$require$DeferredIterator = $6Upf3.DeferredIterator;
var $3069ab1cfe611dc8$require$DeferredKeyIterator = $6Upf3.DeferredKeyIterator;
var $3069ab1cfe611dc8$require$DeferredValueIterator = $6Upf3.DeferredValueIterator;

var $bv6n5 = parcelRequire("bv6n5");
var $3069ab1cfe611dc8$require$DefaultChainedBatch = $bv6n5.DefaultChainedBatch;

var $jgLDB = parcelRequire("jgLDB");
var $3069ab1cfe611dc8$require$getCallback = $jgLDB.getCallback;
var $3069ab1cfe611dc8$require$getOptions = $jgLDB.getOptions;

var $2aDUz = parcelRequire("2aDUz");
const $3069ab1cfe611dc8$var$kPromise = Symbol('promise');
const $3069ab1cfe611dc8$var$kLanded = Symbol('landed');
const $3069ab1cfe611dc8$var$kResources = Symbol('resources');
const $3069ab1cfe611dc8$var$kCloseResources = Symbol('closeResources');
const $3069ab1cfe611dc8$var$kOperations = Symbol('operations');
const $3069ab1cfe611dc8$var$kUndefer = Symbol('undefer');
const $3069ab1cfe611dc8$var$kDeferOpen = Symbol('deferOpen');
const $3069ab1cfe611dc8$var$kOptions = Symbol('options');
const $3069ab1cfe611dc8$var$kStatus = Symbol('status');
const $3069ab1cfe611dc8$var$kDefaultOptions = Symbol('defaultOptions');
const $3069ab1cfe611dc8$var$kTranscoder = Symbol('transcoder');
const $3069ab1cfe611dc8$var$kKeyEncoding = Symbol('keyEncoding');
const $3069ab1cfe611dc8$var$kValueEncoding = Symbol('valueEncoding');
const $3069ab1cfe611dc8$var$noop = ()=>{};
class $3069ab1cfe611dc8$var$AbstractLevel extends $3069ab1cfe611dc8$require$EventEmitter {
    constructor(manifest, options){
        super();
        if (typeof manifest !== 'object' || manifest === null) throw new TypeError("The first argument 'manifest' must be an object");
        options = $3069ab1cfe611dc8$require$getOptions(options);
        const { keyEncoding: keyEncoding, valueEncoding: valueEncoding, passive: passive, ...forward } = options;
        this[$3069ab1cfe611dc8$var$kResources] = new Set();
        this[$3069ab1cfe611dc8$var$kOperations] = [];
        this[$3069ab1cfe611dc8$var$kDeferOpen] = true;
        this[$3069ab1cfe611dc8$var$kOptions] = forward;
        this[$3069ab1cfe611dc8$var$kStatus] = 'opening';
        this.supports = $3069ab1cfe611dc8$require$supports(manifest, {
            status: true,
            promises: true,
            clear: true,
            getMany: true,
            deferredOpen: true,
            // TODO (next major): add seek
            snapshots: manifest.snapshots !== false,
            permanence: manifest.permanence !== false,
            // TODO: remove from level-supports because it's always supported
            keyIterator: true,
            valueIterator: true,
            iteratorNextv: true,
            iteratorAll: true,
            encodings: manifest.encodings || {},
            events: Object.assign({}, manifest.events, {
                opening: true,
                open: true,
                closing: true,
                closed: true,
                put: true,
                del: true,
                batch: true,
                clear: true
            })
        });
        this[$3069ab1cfe611dc8$var$kTranscoder] = new $3069ab1cfe611dc8$require$Transcoder($3069ab1cfe611dc8$var$formats(this));
        this[$3069ab1cfe611dc8$var$kKeyEncoding] = this[$3069ab1cfe611dc8$var$kTranscoder].encoding(keyEncoding || 'utf8');
        this[$3069ab1cfe611dc8$var$kValueEncoding] = this[$3069ab1cfe611dc8$var$kTranscoder].encoding(valueEncoding || 'utf8');
        // Add custom and transcoder encodings to manifest
        for (const encoding of this[$3069ab1cfe611dc8$var$kTranscoder].encodings())if (!this.supports.encodings[encoding.commonName]) this.supports.encodings[encoding.commonName] = true;
        this[$3069ab1cfe611dc8$var$kDefaultOptions] = {
            empty: Object.freeze({}),
            entry: Object.freeze({
                keyEncoding: this[$3069ab1cfe611dc8$var$kKeyEncoding].commonName,
                valueEncoding: this[$3069ab1cfe611dc8$var$kValueEncoding].commonName
            }),
            key: Object.freeze({
                keyEncoding: this[$3069ab1cfe611dc8$var$kKeyEncoding].commonName
            })
        };
        // Let subclass finish its constructor
        this.nextTick(()=>{
            if (this[$3069ab1cfe611dc8$var$kDeferOpen]) this.open({
                passive: false
            }, $3069ab1cfe611dc8$var$noop);
        });
    }
    get status() {
        return this[$3069ab1cfe611dc8$var$kStatus];
    }
    keyEncoding(encoding) {
        return this[$3069ab1cfe611dc8$var$kTranscoder].encoding(encoding != null ? encoding : this[$3069ab1cfe611dc8$var$kKeyEncoding]);
    }
    valueEncoding(encoding) {
        return this[$3069ab1cfe611dc8$var$kTranscoder].encoding(encoding != null ? encoding : this[$3069ab1cfe611dc8$var$kValueEncoding]);
    }
    open(options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = {
            ...this[$3069ab1cfe611dc8$var$kOptions],
            ...$3069ab1cfe611dc8$require$getOptions(options)
        };
        options.createIfMissing = options.createIfMissing !== false;
        options.errorIfExists = !!options.errorIfExists;
        const maybeOpened = (err)=>{
            if (this[$3069ab1cfe611dc8$var$kStatus] === 'closing' || this[$3069ab1cfe611dc8$var$kStatus] === 'opening') // Wait until pending state changes are done
            this.once($3069ab1cfe611dc8$var$kLanded, err ? ()=>maybeOpened(err) : maybeOpened);
            else if (this[$3069ab1cfe611dc8$var$kStatus] !== 'open') callback(new $b73to('Database is not open', {
                code: 'LEVEL_DATABASE_NOT_OPEN',
                cause: err
            }));
            else callback();
        };
        if (options.passive) {
            if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') this.once($3069ab1cfe611dc8$var$kLanded, maybeOpened);
            else this.nextTick(maybeOpened);
        } else if (this[$3069ab1cfe611dc8$var$kStatus] === 'closed' || this[$3069ab1cfe611dc8$var$kDeferOpen]) {
            this[$3069ab1cfe611dc8$var$kDeferOpen] = false;
            this[$3069ab1cfe611dc8$var$kStatus] = 'opening';
            this.emit('opening');
            this._open(options, (err)=>{
                if (err) {
                    this[$3069ab1cfe611dc8$var$kStatus] = 'closed';
                    // Resources must be safe to close in any db state
                    this[$3069ab1cfe611dc8$var$kCloseResources](()=>{
                        this.emit($3069ab1cfe611dc8$var$kLanded);
                        maybeOpened(err);
                    });
                    this[$3069ab1cfe611dc8$var$kUndefer]();
                    return;
                }
                this[$3069ab1cfe611dc8$var$kStatus] = 'open';
                this[$3069ab1cfe611dc8$var$kUndefer]();
                this.emit($3069ab1cfe611dc8$var$kLanded);
                // Only emit public event if pending state changes are done
                if (this[$3069ab1cfe611dc8$var$kStatus] === 'open') this.emit('open');
                // TODO (next major): remove this alias
                if (this[$3069ab1cfe611dc8$var$kStatus] === 'open') this.emit('ready');
                maybeOpened();
            });
        } else if (this[$3069ab1cfe611dc8$var$kStatus] === 'open') this.nextTick(maybeOpened);
        else this.once($3069ab1cfe611dc8$var$kLanded, ()=>this.open(options, callback));
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _open(options, callback) {
        this.nextTick(callback);
    }
    close(callback) {
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        const maybeClosed = (err)=>{
            if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening' || this[$3069ab1cfe611dc8$var$kStatus] === 'closing') // Wait until pending state changes are done
            this.once($3069ab1cfe611dc8$var$kLanded, err ? maybeClosed(err) : maybeClosed);
            else if (this[$3069ab1cfe611dc8$var$kStatus] !== 'closed') callback(new $b73to('Database is not closed', {
                code: 'LEVEL_DATABASE_NOT_CLOSED',
                cause: err
            }));
            else callback();
        };
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'open') {
            this[$3069ab1cfe611dc8$var$kStatus] = 'closing';
            this.emit('closing');
            const cancel = (err)=>{
                this[$3069ab1cfe611dc8$var$kStatus] = 'open';
                this[$3069ab1cfe611dc8$var$kUndefer]();
                this.emit($3069ab1cfe611dc8$var$kLanded);
                maybeClosed(err);
            };
            this[$3069ab1cfe611dc8$var$kCloseResources](()=>{
                this._close((err)=>{
                    if (err) return cancel(err);
                    this[$3069ab1cfe611dc8$var$kStatus] = 'closed';
                    this[$3069ab1cfe611dc8$var$kUndefer]();
                    this.emit($3069ab1cfe611dc8$var$kLanded);
                    // Only emit public event if pending state changes are done
                    if (this[$3069ab1cfe611dc8$var$kStatus] === 'closed') this.emit('closed');
                    maybeClosed();
                });
            });
        } else if (this[$3069ab1cfe611dc8$var$kStatus] === 'closed') this.nextTick(maybeClosed);
        else this.once($3069ab1cfe611dc8$var$kLanded, ()=>this.close(callback));
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    [$3069ab1cfe611dc8$var$kCloseResources](callback) {
        if (this[$3069ab1cfe611dc8$var$kResources].size === 0) return this.nextTick(callback);
        let pending = this[$3069ab1cfe611dc8$var$kResources].size;
        let sync = true;
        const next = ()=>{
            if (--pending === 0) {
                // We don't have tests for generic resources, so dezalgo
                if (sync) this.nextTick(callback);
                else callback();
            }
        };
        // In parallel so that all resources know they are closed
        for (const resource of this[$3069ab1cfe611dc8$var$kResources])resource.close(next);
        sync = false;
        this[$3069ab1cfe611dc8$var$kResources].clear();
    }
    _close(callback) {
        this.nextTick(callback);
    }
    get(key, options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].entry);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.get(key, options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        const err = this._checkKey(key);
        if (err) {
            this.nextTick(callback, err);
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        const keyEncoding = this.keyEncoding(options.keyEncoding);
        const valueEncoding = this.valueEncoding(options.valueEncoding);
        const keyFormat = keyEncoding.format;
        const valueFormat = valueEncoding.format;
        // Forward encoding options to the underlying store
        if (options.keyEncoding !== keyFormat || options.valueEncoding !== valueFormat) // Avoid spread operator because of https://bugs.chromium.org/p/chromium/issues/detail?id=1204540
        options = Object.assign({}, options, {
            keyEncoding: keyFormat,
            valueEncoding: valueFormat
        });
        this._get(this.prefixKey(keyEncoding.encode(key), keyFormat), options, (err, value)=>{
            if (err) {
                // Normalize not found error for backwards compatibility with abstract-leveldown and level(up)
                if (err.code === 'LEVEL_NOT_FOUND' || err.notFound || /NotFound/i.test(err)) {
                    if (!err.code) err.code = 'LEVEL_NOT_FOUND' // Preferred way going forward
                    ;
                    if (!err.notFound) err.notFound = true // Same as level-errors
                    ;
                    if (!err.status) err.status = 404 // Same as level-errors
                    ;
                }
                return callback(err);
            }
            try {
                value = valueEncoding.decode(value);
            } catch (err) {
                return callback(new $b73to('Could not decode value', {
                    code: 'LEVEL_DECODE_ERROR',
                    cause: err
                }));
            }
            callback(null, value);
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _get(key, options, callback) {
        this.nextTick(callback, new Error('NotFound'));
    }
    getMany(keys, options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].entry);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.getMany(keys, options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        if (!Array.isArray(keys)) {
            this.nextTick(callback, new TypeError("The first argument 'keys' must be an array"));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if (keys.length === 0) {
            this.nextTick(callback, null, []);
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        const keyEncoding = this.keyEncoding(options.keyEncoding);
        const valueEncoding = this.valueEncoding(options.valueEncoding);
        const keyFormat = keyEncoding.format;
        const valueFormat = valueEncoding.format;
        // Forward encoding options
        if (options.keyEncoding !== keyFormat || options.valueEncoding !== valueFormat) options = Object.assign({}, options, {
            keyEncoding: keyFormat,
            valueEncoding: valueFormat
        });
        const mappedKeys = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const err = this._checkKey(key);
            if (err) {
                this.nextTick(callback, err);
                return callback[$3069ab1cfe611dc8$var$kPromise];
            }
            mappedKeys[i] = this.prefixKey(keyEncoding.encode(key), keyFormat);
        }
        this._getMany(mappedKeys, options, (err, values)=>{
            if (err) return callback(err);
            try {
                for(let i = 0; i < values.length; i++)if (values[i] !== undefined) values[i] = valueEncoding.decode(values[i]);
            } catch (err) {
                return callback(new $b73to(`Could not decode one or more of ${values.length} value(s)`, {
                    code: 'LEVEL_DECODE_ERROR',
                    cause: err
                }));
            }
            callback(null, values);
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _getMany(keys, options, callback) {
        this.nextTick(callback, null, new Array(keys.length).fill(undefined));
    }
    put(key, value, options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].entry);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.put(key, value, options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        const err = this._checkKey(key) || this._checkValue(value);
        if (err) {
            this.nextTick(callback, err);
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        const keyEncoding = this.keyEncoding(options.keyEncoding);
        const valueEncoding = this.valueEncoding(options.valueEncoding);
        const keyFormat = keyEncoding.format;
        const valueFormat = valueEncoding.format;
        // Forward encoding options
        if (options.keyEncoding !== keyFormat || options.valueEncoding !== valueFormat) options = Object.assign({}, options, {
            keyEncoding: keyFormat,
            valueEncoding: valueFormat
        });
        const mappedKey = this.prefixKey(keyEncoding.encode(key), keyFormat);
        const mappedValue = valueEncoding.encode(value);
        this._put(mappedKey, mappedValue, options, (err)=>{
            if (err) return callback(err);
            this.emit('put', key, value);
            callback();
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _put(key, value, options, callback) {
        this.nextTick(callback);
    }
    del(key, options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].key);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.del(key, options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        const err = this._checkKey(key);
        if (err) {
            this.nextTick(callback, err);
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        const keyEncoding = this.keyEncoding(options.keyEncoding);
        const keyFormat = keyEncoding.format;
        // Forward encoding options
        if (options.keyEncoding !== keyFormat) options = Object.assign({}, options, {
            keyEncoding: keyFormat
        });
        this._del(this.prefixKey(keyEncoding.encode(key), keyFormat), options, (err)=>{
            if (err) return callback(err);
            this.emit('del', key);
            callback();
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _del(key, options, callback) {
        this.nextTick(callback);
    }
    batch(operations, options, callback) {
        if (!arguments.length) {
            if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') return new $3069ab1cfe611dc8$require$DefaultChainedBatch(this);
            if (this[$3069ab1cfe611dc8$var$kStatus] !== 'open') throw new $b73to('Database is not open', {
                code: 'LEVEL_DATABASE_NOT_OPEN'
            });
            return this._chainedBatch();
        }
        if (typeof operations === 'function') callback = operations;
        else callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].empty);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.batch(operations, options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        if (!Array.isArray(operations)) {
            this.nextTick(callback, new TypeError("The first argument 'operations' must be an array"));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if (operations.length === 0) {
            this.nextTick(callback);
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        const mapped = new Array(operations.length);
        const { keyEncoding: ke, valueEncoding: ve, ...forward } = options;
        for(let i = 0; i < operations.length; i++){
            if (typeof operations[i] !== 'object' || operations[i] === null) {
                this.nextTick(callback, new TypeError('A batch operation must be an object'));
                return callback[$3069ab1cfe611dc8$var$kPromise];
            }
            const op = Object.assign({}, operations[i]);
            if (op.type !== 'put' && op.type !== 'del') {
                this.nextTick(callback, new TypeError("A batch operation must have a type property that is 'put' or 'del'"));
                return callback[$3069ab1cfe611dc8$var$kPromise];
            }
            const err = this._checkKey(op.key);
            if (err) {
                this.nextTick(callback, err);
                return callback[$3069ab1cfe611dc8$var$kPromise];
            }
            const db = op.sublevel != null ? op.sublevel : this;
            const keyEncoding = db.keyEncoding(op.keyEncoding || ke);
            const keyFormat = keyEncoding.format;
            op.key = db.prefixKey(keyEncoding.encode(op.key), keyFormat);
            op.keyEncoding = keyFormat;
            if (op.type === 'put') {
                const valueErr = this._checkValue(op.value);
                if (valueErr) {
                    this.nextTick(callback, valueErr);
                    return callback[$3069ab1cfe611dc8$var$kPromise];
                }
                const valueEncoding = db.valueEncoding(op.valueEncoding || ve);
                op.value = valueEncoding.encode(op.value);
                op.valueEncoding = valueEncoding.format;
            }
            // Prevent double prefixing
            if (db !== this) op.sublevel = null;
            mapped[i] = op;
        }
        this._batch(mapped, forward, (err)=>{
            if (err) return callback(err);
            this.emit('batch', operations);
            callback();
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _batch(operations, options, callback) {
        this.nextTick(callback);
    }
    sublevel(name, options) {
        return this._sublevel(name, $3069ab1cfe611dc8$var$AbstractSublevel.defaults(options));
    }
    _sublevel(name, options) {
        return new $3069ab1cfe611dc8$var$AbstractSublevel(this, name, options);
    }
    prefixKey(key, keyFormat) {
        return key;
    }
    clear(options, callback) {
        callback = $3069ab1cfe611dc8$require$getCallback(options, callback);
        callback = $3069ab1cfe611dc8$require$fromCallback(callback, $3069ab1cfe611dc8$var$kPromise);
        options = $3069ab1cfe611dc8$require$getOptions(options, this[$3069ab1cfe611dc8$var$kDefaultOptions].empty);
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') {
            this.defer(()=>this.clear(options, callback));
            return callback[$3069ab1cfe611dc8$var$kPromise];
        }
        if ($3069ab1cfe611dc8$var$maybeError(this, callback)) return callback[$3069ab1cfe611dc8$var$kPromise];
        const original = options;
        const keyEncoding = this.keyEncoding(options.keyEncoding);
        options = $2aDUz(options, keyEncoding);
        options.keyEncoding = keyEncoding.format;
        if (options.limit === 0) this.nextTick(callback);
        else this._clear(options, (err)=>{
            if (err) return callback(err);
            this.emit('clear', original);
            callback();
        });
        return callback[$3069ab1cfe611dc8$var$kPromise];
    }
    _clear(options, callback) {
        this.nextTick(callback);
    }
    iterator(options) {
        const keyEncoding = this.keyEncoding(options && options.keyEncoding);
        const valueEncoding = this.valueEncoding(options && options.valueEncoding);
        options = $2aDUz(options, keyEncoding);
        options.keys = options.keys !== false;
        options.values = options.values !== false;
        // We need the original encoding options in AbstractIterator in order to decode data
        options[$3069ab1cfe611dc8$require$AbstractIterator.keyEncoding] = keyEncoding;
        options[$3069ab1cfe611dc8$require$AbstractIterator.valueEncoding] = valueEncoding;
        // Forward encoding options to private API
        options.keyEncoding = keyEncoding.format;
        options.valueEncoding = valueEncoding.format;
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') return new $3069ab1cfe611dc8$require$DeferredIterator(this, options);
        else if (this[$3069ab1cfe611dc8$var$kStatus] !== 'open') throw new $b73to('Database is not open', {
            code: 'LEVEL_DATABASE_NOT_OPEN'
        });
        return this._iterator(options);
    }
    _iterator(options) {
        return new $3069ab1cfe611dc8$require$AbstractIterator(this, options);
    }
    keys(options) {
        // Also include valueEncoding (though unused) because we may fallback to _iterator()
        const keyEncoding = this.keyEncoding(options && options.keyEncoding);
        const valueEncoding = this.valueEncoding(options && options.valueEncoding);
        options = $2aDUz(options, keyEncoding);
        // We need the original encoding options in AbstractKeyIterator in order to decode data
        options[$3069ab1cfe611dc8$require$AbstractIterator.keyEncoding] = keyEncoding;
        options[$3069ab1cfe611dc8$require$AbstractIterator.valueEncoding] = valueEncoding;
        // Forward encoding options to private API
        options.keyEncoding = keyEncoding.format;
        options.valueEncoding = valueEncoding.format;
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') return new $3069ab1cfe611dc8$require$DeferredKeyIterator(this, options);
        else if (this[$3069ab1cfe611dc8$var$kStatus] !== 'open') throw new $b73to('Database is not open', {
            code: 'LEVEL_DATABASE_NOT_OPEN'
        });
        return this._keys(options);
    }
    _keys(options) {
        return new $3069ab1cfe611dc8$require$DefaultKeyIterator(this, options);
    }
    values(options) {
        const keyEncoding = this.keyEncoding(options && options.keyEncoding);
        const valueEncoding = this.valueEncoding(options && options.valueEncoding);
        options = $2aDUz(options, keyEncoding);
        // We need the original encoding options in AbstractValueIterator in order to decode data
        options[$3069ab1cfe611dc8$require$AbstractIterator.keyEncoding] = keyEncoding;
        options[$3069ab1cfe611dc8$require$AbstractIterator.valueEncoding] = valueEncoding;
        // Forward encoding options to private API
        options.keyEncoding = keyEncoding.format;
        options.valueEncoding = valueEncoding.format;
        if (this[$3069ab1cfe611dc8$var$kStatus] === 'opening') return new $3069ab1cfe611dc8$require$DeferredValueIterator(this, options);
        else if (this[$3069ab1cfe611dc8$var$kStatus] !== 'open') throw new $b73to('Database is not open', {
            code: 'LEVEL_DATABASE_NOT_OPEN'
        });
        return this._values(options);
    }
    _values(options) {
        return new $3069ab1cfe611dc8$require$DefaultValueIterator(this, options);
    }
    defer(fn) {
        if (typeof fn !== 'function') throw new TypeError('The first argument must be a function');
        this[$3069ab1cfe611dc8$var$kOperations].push(fn);
    }
    [$3069ab1cfe611dc8$var$kUndefer]() {
        if (this[$3069ab1cfe611dc8$var$kOperations].length === 0) return;
        const operations = this[$3069ab1cfe611dc8$var$kOperations];
        this[$3069ab1cfe611dc8$var$kOperations] = [];
        for (const op of operations)op();
    }
    // TODO: docs and types
    attachResource(resource) {
        if (typeof resource !== 'object' || resource === null || typeof resource.close !== 'function') throw new TypeError('The first argument must be a resource object');
        this[$3069ab1cfe611dc8$var$kResources].add(resource);
    }
    // TODO: docs and types
    detachResource(resource) {
        this[$3069ab1cfe611dc8$var$kResources].delete(resource);
    }
    _chainedBatch() {
        return new $3069ab1cfe611dc8$require$DefaultChainedBatch(this);
    }
    _checkKey(key) {
        if (key === null || key === undefined) return new $b73to('Key cannot be null or undefined', {
            code: 'LEVEL_INVALID_KEY'
        });
    }
    _checkValue(value) {
        if (value === null || value === undefined) return new $b73to('Value cannot be null or undefined', {
            code: 'LEVEL_INVALID_VALUE'
        });
    }
}

// Expose browser-compatible nextTick for dependents
// TODO: after we drop node 10, also use queueMicrotask in node
$3069ab1cfe611dc8$var$AbstractLevel.prototype.nextTick = (parcelRequire("iWtrV"));

const { AbstractSublevel: $3069ab1cfe611dc8$var$AbstractSublevel } = (parcelRequire("jc3Dc"))({
    AbstractLevel: $3069ab1cfe611dc8$var$AbstractLevel
});
$3069ab1cfe611dc8$export$3e2c6c8f6c478102 = $3069ab1cfe611dc8$var$AbstractLevel;
$3069ab1cfe611dc8$export$f506436e248a22a5 = $3069ab1cfe611dc8$var$AbstractSublevel;
const $3069ab1cfe611dc8$var$maybeError = function(db, callback) {
    if (db[$3069ab1cfe611dc8$var$kStatus] !== 'open') {
        db.nextTick(callback, new $b73to('Database is not open', {
            code: 'LEVEL_DATABASE_NOT_OPEN'
        }));
        return true;
    }
    return false;
};
const $3069ab1cfe611dc8$var$formats = function(db) {
    return Object.keys(db.supports.encodings).filter((k)=>!!db.supports.encodings[k]);
};

});
parcelRegister("fNuHe", function(module, exports) {

$parcel$export(module.exports, "supports", function () { return $b8033e4907c06a14$export$cde6a56f9669daf6; }, function (v) { return $b8033e4907c06a14$export$cde6a56f9669daf6 = v; });
var $b8033e4907c06a14$export$cde6a56f9669daf6;
'use strict';
$b8033e4907c06a14$export$cde6a56f9669daf6 = function supports(...manifests) {
    const manifest = manifests.reduce((acc, m)=>Object.assign(acc, m), {});
    return Object.assign(manifest, {
        snapshots: manifest.snapshots || false,
        permanence: manifest.permanence || false,
        seek: manifest.seek || false,
        clear: manifest.clear || false,
        getMany: manifest.getMany || false,
        keyIterator: manifest.keyIterator || false,
        valueIterator: manifest.valueIterator || false,
        iteratorNextv: manifest.iteratorNextv || false,
        iteratorAll: manifest.iteratorAll || false,
        status: manifest.status || false,
        createIfMissing: manifest.createIfMissing || false,
        errorIfExists: manifest.errorIfExists || false,
        deferredOpen: manifest.deferredOpen || false,
        promises: manifest.promises || false,
        streams: manifest.streams || false,
        encodings: Object.assign({}, manifest.encodings),
        events: Object.assign({}, manifest.events),
        additionalMethods: Object.assign({}, manifest.additionalMethods)
    });
};

});

parcelRegister("dT4fT", function(module, exports) {

$parcel$export(module.exports, "Transcoder", function () { return $a1c3b66ac21a1728$export$e2114814f080eac8; }, function (v) { return $a1c3b66ac21a1728$export$e2114814f080eac8 = v; });
var $a1c3b66ac21a1728$export$e2114814f080eac8;
'use strict';

var $b73to = parcelRequire("b73to");

var $cvZzy = parcelRequire("cvZzy");

var $dj2Ig = parcelRequire("dj2Ig");
var $a1c3b66ac21a1728$require$Encoding = $dj2Ig.Encoding;

var $85KkJ = parcelRequire("85KkJ");
var $a1c3b66ac21a1728$require$BufferFormat = $85KkJ.BufferFormat;
var $a1c3b66ac21a1728$require$ViewFormat = $85KkJ.ViewFormat;
var $a1c3b66ac21a1728$require$UTF8Format = $85KkJ.UTF8Format;
const $a1c3b66ac21a1728$var$kFormats = Symbol('formats');
const $a1c3b66ac21a1728$var$kEncodings = Symbol('encodings');
const $a1c3b66ac21a1728$var$validFormats = new Set([
    'buffer',
    'view',
    'utf8'
]);
/** @template T */ class $a1c3b66ac21a1728$var$Transcoder {
    /**
   * @param {Array<'buffer'|'view'|'utf8'>} formats
   */ constructor(formats){
        if (!Array.isArray(formats)) throw new TypeError("The first argument 'formats' must be an array");
        else if (!formats.every((f)=>$a1c3b66ac21a1728$var$validFormats.has(f))) // Note: we only only support aliases in key- and valueEncoding options (where we already did)
        throw new TypeError("Format must be one of 'buffer', 'view', 'utf8'");
        /** @type {Map<string|MixedEncoding<any, any, any>, Encoding<any, any, any>>} */ this[$a1c3b66ac21a1728$var$kEncodings] = new Map();
        this[$a1c3b66ac21a1728$var$kFormats] = new Set(formats);
        // Register encodings (done early in order to populate encodings())
        for(const k in $cvZzy)try {
            this.encoding(k);
        } catch (err) {
            /* istanbul ignore if: assertion */ if (err.code !== 'LEVEL_ENCODING_NOT_SUPPORTED') throw err;
        }
    }
    /**
   * @returns {Array<Encoding<any,T,any>>}
   */ encodings() {
        return Array.from(new Set(this[$a1c3b66ac21a1728$var$kEncodings].values()));
    }
    /**
   * @param {string|MixedEncoding<any, any, any>} encoding
   * @returns {Encoding<any, T, any>}
   */ encoding(encoding) {
        let resolved = this[$a1c3b66ac21a1728$var$kEncodings].get(encoding);
        if (resolved === undefined) {
            if (typeof encoding === 'string' && encoding !== '') {
                resolved = $a1c3b66ac21a1728$var$lookup[encoding];
                if (!resolved) throw new $b73to(`Encoding '${encoding}' is not found`, {
                    code: 'LEVEL_ENCODING_NOT_FOUND'
                });
            } else if (typeof encoding !== 'object' || encoding === null) throw new TypeError("First argument 'encoding' must be a string or object");
            else resolved = $a1c3b66ac21a1728$var$from(encoding);
            const { name: name, format: format } = resolved;
            if (!this[$a1c3b66ac21a1728$var$kFormats].has(format)) {
                if (this[$a1c3b66ac21a1728$var$kFormats].has('view')) resolved = resolved.createViewTranscoder();
                else if (this[$a1c3b66ac21a1728$var$kFormats].has('buffer')) resolved = resolved.createBufferTranscoder();
                else if (this[$a1c3b66ac21a1728$var$kFormats].has('utf8')) resolved = resolved.createUTF8Transcoder();
                else throw new $b73to(`Encoding '${name}' cannot be transcoded`, {
                    code: 'LEVEL_ENCODING_NOT_SUPPORTED'
                });
            }
            for (const k of [
                encoding,
                name,
                resolved.name,
                resolved.commonName
            ])this[$a1c3b66ac21a1728$var$kEncodings].set(k, resolved);
        }
        return resolved;
    }
}
$a1c3b66ac21a1728$export$e2114814f080eac8 = $a1c3b66ac21a1728$var$Transcoder;
/**
 * @param {MixedEncoding<any, any, any>} options
 * @returns {Encoding<any, any, any>}
 */ function $a1c3b66ac21a1728$var$from(options) {
    if (options instanceof $a1c3b66ac21a1728$require$Encoding) return options;
    // Loosely typed for ecosystem compatibility
    const maybeType = 'type' in options && typeof options.type === 'string' ? options.type : undefined;
    const name = options.name || maybeType || `anonymous-${$a1c3b66ac21a1728$var$anonymousCount++}`;
    switch($a1c3b66ac21a1728$var$detectFormat(options)){
        case 'view':
            return new $a1c3b66ac21a1728$require$ViewFormat({
                ...options,
                name: name
            });
        case 'utf8':
            return new $a1c3b66ac21a1728$require$UTF8Format({
                ...options,
                name: name
            });
        case 'buffer':
            return new $a1c3b66ac21a1728$require$BufferFormat({
                ...options,
                name: name
            });
        default:
            throw new TypeError("Format must be one of 'buffer', 'view', 'utf8'");
    }
}
/**
 * If format is not provided, fallback to detecting `level-codec`
 * or `multiformats` encodings, else assume a format of buffer.
 * @param {MixedEncoding<any, any, any>} options
 * @returns {string}
 */ function $a1c3b66ac21a1728$var$detectFormat(options) {
    if ('format' in options && options.format !== undefined) return options.format;
    else if ('buffer' in options && typeof options.buffer === 'boolean') return options.buffer ? 'buffer' : 'utf8' // level-codec
    ;
    else if ('code' in options && Number.isInteger(options.code)) return 'view' // multiformats
    ;
    else return 'buffer';
}
/**
 * @typedef {import('./lib/encoding').MixedEncoding<TIn,TFormat,TOut>} MixedEncoding
 * @template TIn, TFormat, TOut
 */ /**
 * @type {Object.<string, Encoding<any, any, any>>}
 */ const $a1c3b66ac21a1728$var$aliases = {
    binary: $cvZzy.buffer,
    'utf-8': $cvZzy.utf8
};
/**
 * @type {Object.<string, Encoding<any, any, any>>}
 */ const $a1c3b66ac21a1728$var$lookup = {
    ...$cvZzy,
    ...$a1c3b66ac21a1728$var$aliases
};
let $a1c3b66ac21a1728$var$anonymousCount = 0;

});
parcelRegister("b73to", function(module, exports) {
'use strict';
module.exports = class ModuleError extends Error {
    /**
   * @param {string} message Error message
   * @param {{ code?: string, cause?: Error, expected?: boolean, transient?: boolean }} [options]
   */ constructor(message, options){
        super(message || '');
        if (typeof options === 'object' && options !== null) {
            if (options.code) this.code = String(options.code);
            if (options.expected) this.expected = true;
            if (options.transient) this.transient = true;
            if (options.cause) this.cause = options.cause;
        }
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    }
};

});

parcelRegister("cvZzy", function(module, exports) {

$parcel$export(module.exports, "utf8", function () { return $91c82447637a3ded$export$74329b762b589566; }, function (v) { return $91c82447637a3ded$export$74329b762b589566 = v; });
$parcel$export(module.exports, "json", function () { return $91c82447637a3ded$export$7b419323e6ed4f31; }, function (v) { return $91c82447637a3ded$export$7b419323e6ed4f31 = v; });
$parcel$export(module.exports, "buffer", function () { return $91c82447637a3ded$export$ab1029bcae9ddb4a; }, function (v) { return $91c82447637a3ded$export$ab1029bcae9ddb4a = v; });
$parcel$export(module.exports, "view", function () { return $91c82447637a3ded$export$c4ddc81c7b2c8d7a; }, function (v) { return $91c82447637a3ded$export$c4ddc81c7b2c8d7a = v; });
$parcel$export(module.exports, "hex", function () { return $91c82447637a3ded$export$834dfc94dde4b3d8; }, function (v) { return $91c82447637a3ded$export$834dfc94dde4b3d8 = v; });
$parcel$export(module.exports, "base64", function () { return $91c82447637a3ded$export$b3b2de96497acc47; }, function (v) { return $91c82447637a3ded$export$b3b2de96497acc47 = v; });
/**
 * @type {typeof import('./encodings').utf8}
 */ var $91c82447637a3ded$export$74329b762b589566;
/**
 * @type {typeof import('./encodings').json}
 */ var $91c82447637a3ded$export$7b419323e6ed4f31;
/**
 * @type {typeof import('./encodings').buffer}
 */ var $91c82447637a3ded$export$ab1029bcae9ddb4a;
/**
 * @type {typeof import('./encodings').view}
 */ var $91c82447637a3ded$export$c4ddc81c7b2c8d7a;
/**
 * @type {typeof import('./encodings').hex}
 */ var $91c82447637a3ded$export$834dfc94dde4b3d8;
/**
 * @type {typeof import('./encodings').base64}
 */ var $91c82447637a3ded$export$b3b2de96497acc47;
'use strict';

const { Buffer: $91c82447637a3ded$var$Buffer } = (parcelRequire("bdjQ6")) || {
    Buffer: {
        isBuffer: ()=>false
    }
};

const { textEncoder: $91c82447637a3ded$var$textEncoder, textDecoder: $91c82447637a3ded$var$textDecoder } = (parcelRequire("dQe5k"))();

var $85KkJ = parcelRequire("85KkJ");
var $91c82447637a3ded$require$BufferFormat = $85KkJ.BufferFormat;
var $91c82447637a3ded$require$ViewFormat = $85KkJ.ViewFormat;
var $91c82447637a3ded$require$UTF8Format = $85KkJ.UTF8Format;
/** @type {<T>(v: T) => v} */ const $91c82447637a3ded$var$identity = (v)=>v;
$91c82447637a3ded$export$74329b762b589566 = new $91c82447637a3ded$require$UTF8Format({
    encode: function(data) {
        // On node 16.9.1 buffer.toString() is 5x faster than TextDecoder
        return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data.toString('utf8') : ArrayBuffer.isView(data) ? $91c82447637a3ded$var$textDecoder.decode(data) : String(data);
    },
    decode: $91c82447637a3ded$var$identity,
    name: 'utf8',
    createViewTranscoder () {
        return new $91c82447637a3ded$require$ViewFormat({
            encode: function(data) {
                return ArrayBuffer.isView(data) ? data : $91c82447637a3ded$var$textEncoder.encode(data);
            },
            decode: function(data) {
                return $91c82447637a3ded$var$textDecoder.decode(data);
            },
            name: `${this.name}+view`
        });
    },
    createBufferTranscoder () {
        return new $91c82447637a3ded$require$BufferFormat({
            encode: function(data) {
                return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data : ArrayBuffer.isView(data) ? $91c82447637a3ded$var$Buffer.from(data.buffer, data.byteOffset, data.byteLength) : $91c82447637a3ded$var$Buffer.from(String(data), 'utf8');
            },
            decode: function(data) {
                return data.toString('utf8');
            },
            name: `${this.name}+buffer`
        });
    }
});
$91c82447637a3ded$export$7b419323e6ed4f31 = new $91c82447637a3ded$require$UTF8Format({
    encode: JSON.stringify,
    decode: JSON.parse,
    name: 'json'
});
$91c82447637a3ded$export$ab1029bcae9ddb4a = new $91c82447637a3ded$require$BufferFormat({
    encode: function(data) {
        return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data : ArrayBuffer.isView(data) ? $91c82447637a3ded$var$Buffer.from(data.buffer, data.byteOffset, data.byteLength) : $91c82447637a3ded$var$Buffer.from(String(data), 'utf8');
    },
    decode: $91c82447637a3ded$var$identity,
    name: 'buffer',
    createViewTranscoder () {
        return new $91c82447637a3ded$require$ViewFormat({
            encode: function(data) {
                return ArrayBuffer.isView(data) ? data : $91c82447637a3ded$var$Buffer.from(String(data), 'utf8');
            },
            decode: function(data) {
                return $91c82447637a3ded$var$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            },
            name: `${this.name}+view`
        });
    }
});
$91c82447637a3ded$export$c4ddc81c7b2c8d7a = new $91c82447637a3ded$require$ViewFormat({
    encode: function(data) {
        return ArrayBuffer.isView(data) ? data : $91c82447637a3ded$var$textEncoder.encode(data);
    },
    decode: $91c82447637a3ded$var$identity,
    name: 'view',
    createBufferTranscoder () {
        return new $91c82447637a3ded$require$BufferFormat({
            encode: function(data) {
                return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data : ArrayBuffer.isView(data) ? $91c82447637a3ded$var$Buffer.from(data.buffer, data.byteOffset, data.byteLength) : $91c82447637a3ded$var$Buffer.from(String(data), 'utf8');
            },
            decode: $91c82447637a3ded$var$identity,
            name: `${this.name}+buffer`
        });
    }
});
$91c82447637a3ded$export$834dfc94dde4b3d8 = new $91c82447637a3ded$require$BufferFormat({
    encode: function(data) {
        return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data : $91c82447637a3ded$var$Buffer.from(String(data), 'hex');
    },
    decode: function(buffer) {
        return buffer.toString('hex');
    },
    name: 'hex'
});
$91c82447637a3ded$export$b3b2de96497acc47 = new $91c82447637a3ded$require$BufferFormat({
    encode: function(data) {
        return $91c82447637a3ded$var$Buffer.isBuffer(data) ? data : $91c82447637a3ded$var$Buffer.from(String(data), 'base64');
    },
    decode: function(buffer) {
        return buffer.toString('base64');
    },
    name: 'base64'
});

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a; }, function (v) { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $82a04c4ec6982288$export$599f31c3813fae4d; }, function (v) { return $82a04c4ec6982288$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("dQe5k", function(module, exports) {
'use strict';
/** @type {{ textEncoder: TextEncoder, textDecoder: TextDecoder }|null} */ let $a13b0eb03b2f3fe7$var$lazy = null;
/**
 * Get semi-global instances of TextEncoder and TextDecoder.
 * @returns {{ textEncoder: TextEncoder, textDecoder: TextDecoder }}
 */ module.exports = function() {
    if ($a13b0eb03b2f3fe7$var$lazy === null) $a13b0eb03b2f3fe7$var$lazy = {
        textEncoder: new TextEncoder(),
        textDecoder: new TextDecoder()
    };
    return $a13b0eb03b2f3fe7$var$lazy;
};

});

parcelRegister("85KkJ", function(module, exports) {

$parcel$export(module.exports, "BufferFormat", function () { return $01853491449109e2$export$afc196e41db7fec9; }, function (v) { return $01853491449109e2$export$afc196e41db7fec9 = v; });
$parcel$export(module.exports, "ViewFormat", function () { return $01853491449109e2$export$61e75b7c84532614; }, function (v) { return $01853491449109e2$export$61e75b7c84532614 = v; });
$parcel$export(module.exports, "UTF8Format", function () { return $01853491449109e2$export$10e2ff5c3ee6b9dc; }, function (v) { return $01853491449109e2$export$10e2ff5c3ee6b9dc = v; });
var $01853491449109e2$export$afc196e41db7fec9;
var $01853491449109e2$export$61e75b7c84532614;
var $01853491449109e2$export$10e2ff5c3ee6b9dc/**
 * @typedef {import('./encoding').IEncoding<TIn,TFormat,TOut>} IEncoding
 * @template TIn, TFormat, TOut
 */ ;
'use strict';

const { Buffer: $01853491449109e2$var$Buffer } = (parcelRequire("bdjQ6")) || {};

var $dj2Ig = parcelRequire("dj2Ig");
var $01853491449109e2$require$Encoding = $dj2Ig.Encoding;

var $dQe5k = parcelRequire("dQe5k");
/**
 * @template TIn, TOut
 * @extends {Encoding<TIn,Buffer,TOut>}
 */ class $01853491449109e2$var$BufferFormat extends $01853491449109e2$require$Encoding {
    /**
   * @param {Omit<IEncoding<TIn, Buffer, TOut>, 'format'>} options
   */ constructor(options){
        super({
            ...options,
            format: 'buffer'
        });
    }
    /** @override */ createViewTranscoder() {
        return new $01853491449109e2$var$ViewFormat({
            encode: this.encode,
            decode: (data)=>this.decode($01853491449109e2$var$Buffer.from(data.buffer, data.byteOffset, data.byteLength)),
            name: `${this.name}+view`
        });
    }
    /** @override */ createBufferTranscoder() {
        return this;
    }
}
/**
 * @extends {Encoding<TIn,Uint8Array,TOut>}
 * @template TIn, TOut
 */ class $01853491449109e2$var$ViewFormat extends $01853491449109e2$require$Encoding {
    /**
   * @param {Omit<IEncoding<TIn, Uint8Array, TOut>, 'format'>} options
   */ constructor(options){
        super({
            ...options,
            format: 'view'
        });
    }
    /** @override */ createBufferTranscoder() {
        return new $01853491449109e2$var$BufferFormat({
            encode: (data)=>{
                const view = this.encode(data);
                return $01853491449109e2$var$Buffer.from(view.buffer, view.byteOffset, view.byteLength);
            },
            decode: this.decode,
            name: `${this.name}+buffer`
        });
    }
    /** @override */ createViewTranscoder() {
        return this;
    }
}
/**
 * @extends {Encoding<TIn,string,TOut>}
 * @template TIn, TOut
 */ class $01853491449109e2$var$UTF8Format extends $01853491449109e2$require$Encoding {
    /**
   * @param {Omit<IEncoding<TIn, string, TOut>, 'format'>} options
   */ constructor(options){
        super({
            ...options,
            format: 'utf8'
        });
    }
    /** @override */ createBufferTranscoder() {
        return new $01853491449109e2$var$BufferFormat({
            encode: (data)=>$01853491449109e2$var$Buffer.from(this.encode(data), 'utf8'),
            decode: (data)=>this.decode(data.toString('utf8')),
            name: `${this.name}+buffer`
        });
    }
    /** @override */ createViewTranscoder() {
        const { textEncoder: textEncoder, textDecoder: textDecoder } = $dQe5k();
        return new $01853491449109e2$var$ViewFormat({
            encode: (data)=>textEncoder.encode(this.encode(data)),
            decode: (data)=>this.decode(textDecoder.decode(data)),
            name: `${this.name}+view`
        });
    }
    /** @override */ createUTF8Transcoder() {
        return this;
    }
}
$01853491449109e2$export$afc196e41db7fec9 = $01853491449109e2$var$BufferFormat;
$01853491449109e2$export$61e75b7c84532614 = $01853491449109e2$var$ViewFormat;
$01853491449109e2$export$10e2ff5c3ee6b9dc = $01853491449109e2$var$UTF8Format;

});
parcelRegister("dj2Ig", function(module, exports) {

$parcel$export(module.exports, "Encoding", function () { return $9aff276bca336270$export$72958ca7c468c63b; }, function (v) { return $9aff276bca336270$export$72958ca7c468c63b = v; });
var $9aff276bca336270$export$72958ca7c468c63b/**
 * @typedef {import('./encoding').IEncoding<TIn,TFormat,TOut>} IEncoding
 * @template TIn, TFormat, TOut
 */ /**
 * @typedef {import('./formats').BufferFormat<TIn,TOut>} BufferFormat
 * @template TIn, TOut
 */ /**
 * @typedef {import('./formats').ViewFormat<TIn,TOut>} ViewFormat
 * @template TIn, TOut
 */ /**
 * @typedef {import('./formats').UTF8Format<TIn,TOut>} UTF8Format
 * @template TIn, TOut
 */ ;
'use strict';

var $b73to = parcelRequire("b73to");
const $9aff276bca336270$var$formats = new Set([
    'buffer',
    'view',
    'utf8'
]);
/**
 * @template TIn, TFormat, TOut
 * @abstract
 */ class $9aff276bca336270$var$Encoding {
    /**
   * @param {IEncoding<TIn,TFormat,TOut>} options
   */ constructor(options){
        /** @type {(data: TIn) => TFormat} */ this.encode = options.encode || this.encode;
        /** @type {(data: TFormat) => TOut} */ this.decode = options.decode || this.decode;
        /** @type {string} */ this.name = options.name || this.name;
        /** @type {string} */ this.format = options.format || this.format;
        if (typeof this.encode !== 'function') throw new TypeError("The 'encode' property must be a function");
        if (typeof this.decode !== 'function') throw new TypeError("The 'decode' property must be a function");
        this.encode = this.encode.bind(this);
        this.decode = this.decode.bind(this);
        if (typeof this.name !== 'string' || this.name === '') throw new TypeError("The 'name' property must be a string");
        if (typeof this.format !== 'string' || !$9aff276bca336270$var$formats.has(this.format)) throw new TypeError("The 'format' property must be one of 'buffer', 'view', 'utf8'");
        if (options.createViewTranscoder) this.createViewTranscoder = options.createViewTranscoder;
        if (options.createBufferTranscoder) this.createBufferTranscoder = options.createBufferTranscoder;
        if (options.createUTF8Transcoder) this.createUTF8Transcoder = options.createUTF8Transcoder;
    }
    get commonName() {
        return /** @type {string} */ this.name.split('+')[0];
    }
    /** @return {BufferFormat<TIn,TOut>} */ createBufferTranscoder() {
        throw new $b73to(`Encoding '${this.name}' cannot be transcoded to 'buffer'`, {
            code: 'LEVEL_ENCODING_NOT_SUPPORTED'
        });
    }
    /** @return {ViewFormat<TIn,TOut>} */ createViewTranscoder() {
        throw new $b73to(`Encoding '${this.name}' cannot be transcoded to 'view'`, {
            code: 'LEVEL_ENCODING_NOT_SUPPORTED'
        });
    }
    /** @return {UTF8Format<TIn,TOut>} */ createUTF8Transcoder() {
        throw new $b73to(`Encoding '${this.name}' cannot be transcoded to 'utf8'`, {
            code: 'LEVEL_ENCODING_NOT_SUPPORTED'
        });
    }
}
$9aff276bca336270$export$72958ca7c468c63b = $9aff276bca336270$var$Encoding;

});




parcelRegister("fzCxw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b5680518dd48c196$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b5680518dd48c196$var$ReflectApply = $b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.apply === 'function' ? $b5680518dd48c196$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b5680518dd48c196$var$ReflectOwnKeys;
if ($b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.ownKeys === 'function') $b5680518dd48c196$var$ReflectOwnKeys = $b5680518dd48c196$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b5680518dd48c196$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b5680518dd48c196$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b5680518dd48c196$var$EventEmitter() {
    $b5680518dd48c196$var$EventEmitter.init.call(this);
}
module.exports = $b5680518dd48c196$var$EventEmitter;
module.exports.once = $b5680518dd48c196$var$once;
// Backwards-compat with node 0.10.x
$b5680518dd48c196$var$EventEmitter.EventEmitter = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$var$EventEmitter.prototype._events = undefined;
$b5680518dd48c196$var$EventEmitter.prototype._eventsCount = 0;
$b5680518dd48c196$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b5680518dd48c196$var$defaultMaxListeners = 10;
function $b5680518dd48c196$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b5680518dd48c196$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b5680518dd48c196$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b5680518dd48c196$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b5680518dd48c196$var$defaultMaxListeners = arg;
    }
});
$b5680518dd48c196$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b5680518dd48c196$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b5680518dd48c196$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b5680518dd48c196$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b5680518dd48c196$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b5680518dd48c196$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b5680518dd48c196$var$_getMaxListeners(this);
};
$b5680518dd48c196$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b5680518dd48c196$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b5680518dd48c196$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b5680518dd48c196$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b5680518dd48c196$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b5680518dd48c196$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b5680518dd48c196$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b5680518dd48c196$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b5680518dd48c196$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, false);
};
$b5680518dd48c196$var$EventEmitter.prototype.on = $b5680518dd48c196$var$EventEmitter.prototype.addListener;
$b5680518dd48c196$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, true);
};
function $b5680518dd48c196$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b5680518dd48c196$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b5680518dd48c196$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b5680518dd48c196$var$EventEmitter.prototype.once = function once(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.on(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.prependListener(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b5680518dd48c196$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b5680518dd48c196$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b5680518dd48c196$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.off = $b5680518dd48c196$var$EventEmitter.prototype.removeListener;
$b5680518dd48c196$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b5680518dd48c196$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b5680518dd48c196$var$unwrapListeners(evlistener) : $b5680518dd48c196$var$arrayClone(evlistener, evlistener.length);
}
$b5680518dd48c196$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, true);
};
$b5680518dd48c196$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, false);
};
$b5680518dd48c196$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b5680518dd48c196$var$listenerCount.call(emitter, type);
};
$b5680518dd48c196$var$EventEmitter.prototype.listenerCount = $b5680518dd48c196$var$listenerCount;
function $b5680518dd48c196$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b5680518dd48c196$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b5680518dd48c196$var$ReflectOwnKeys(this._events) : [];
};
function $b5680518dd48c196$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b5680518dd48c196$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b5680518dd48c196$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b5680518dd48c196$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("6uHRl", function(module, exports) {

$parcel$export(module.exports, "fromCallback", function () { return $4ba790fadbbf8edb$export$d0deb4828877173; }, function (v) { return $4ba790fadbbf8edb$export$d0deb4828877173 = v; });
var $4ba790fadbbf8edb$export$d0deb4828877173;
var $4ba790fadbbf8edb$export$60f45028237c39d1;
'use strict';

var $ch63Q = parcelRequire("ch63Q");
$4ba790fadbbf8edb$export$d0deb4828877173 = function(callback, symbol) {
    if (callback === undefined) {
        var promise = new Promise(function(resolve, reject) {
            callback = function(err, res) {
                if (err) reject(err);
                else resolve(res);
            };
        });
        callback[symbol !== undefined ? symbol : 'promise'] = promise;
    } else if (typeof callback !== 'function') throw new TypeError('Callback must be a function');
    return callback;
};
$4ba790fadbbf8edb$export$60f45028237c39d1 = function(promise, callback) {
    if (callback === undefined) return promise;
    promise.then(function(res) {
        $ch63Q(()=>callback(null, res));
    }).catch(function(err) {
        $ch63Q(()=>callback(err));
    });
};

});
parcelRegister("ch63Q", function(module, exports) {
module.exports = typeof queueMicrotask === 'function' ? queueMicrotask : (fn)=>Promise.resolve().then(fn);

});


parcelRegister("glCWx", function(module, exports) {

$parcel$export(module.exports, "AbstractIterator", function () { return $0312456ea7695fae$export$bddce72536e51c3d; }, function (v) { return $0312456ea7695fae$export$bddce72536e51c3d = v; });
$parcel$export(module.exports, "AbstractKeyIterator", function () { return $0312456ea7695fae$export$f2a6a3524a0d1895; }, function (v) { return $0312456ea7695fae$export$f2a6a3524a0d1895 = v; });
$parcel$export(module.exports, "AbstractValueIterator", function () { return $0312456ea7695fae$export$745e971bb830fb44; }, function (v) { return $0312456ea7695fae$export$745e971bb830fb44 = v; });
var $0312456ea7695fae$export$bddce72536e51c3d;
var $0312456ea7695fae$export$f2a6a3524a0d1895;
var $0312456ea7695fae$export$745e971bb830fb44;
'use strict';

var $6uHRl = parcelRequire("6uHRl");
var $0312456ea7695fae$require$fromCallback = $6uHRl.fromCallback;

var $b73to = parcelRequire("b73to");

var $jgLDB = parcelRequire("jgLDB");
var $0312456ea7695fae$require$getOptions = $jgLDB.getOptions;
var $0312456ea7695fae$require$getCallback = $jgLDB.getCallback;
const $0312456ea7695fae$var$kPromise = Symbol('promise');
const $0312456ea7695fae$var$kCallback = Symbol('callback');
const $0312456ea7695fae$var$kWorking = Symbol('working');
const $0312456ea7695fae$var$kHandleOne = Symbol('handleOne');
const $0312456ea7695fae$var$kHandleMany = Symbol('handleMany');
const $0312456ea7695fae$var$kAutoClose = Symbol('autoClose');
const $0312456ea7695fae$var$kFinishWork = Symbol('finishWork');
const $0312456ea7695fae$var$kReturnMany = Symbol('returnMany');
const $0312456ea7695fae$var$kClosing = Symbol('closing');
const $0312456ea7695fae$var$kHandleClose = Symbol('handleClose');
const $0312456ea7695fae$var$kClosed = Symbol('closed');
const $0312456ea7695fae$var$kCloseCallbacks = Symbol('closeCallbacks');
const $0312456ea7695fae$var$kKeyEncoding = Symbol('keyEncoding');
const $0312456ea7695fae$var$kValueEncoding = Symbol('valueEncoding');
const $0312456ea7695fae$var$kAbortOnClose = Symbol('abortOnClose');
const $0312456ea7695fae$var$kLegacy = Symbol('legacy');
const $0312456ea7695fae$var$kKeys = Symbol('keys');
const $0312456ea7695fae$var$kValues = Symbol('values');
const $0312456ea7695fae$var$kLimit = Symbol('limit');
const $0312456ea7695fae$var$kCount = Symbol('count');
const $0312456ea7695fae$var$emptyOptions = Object.freeze({});
const $0312456ea7695fae$var$noop = ()=>{};
let $0312456ea7695fae$var$warnedEnd = false;
// This class is an internal utility for common functionality between AbstractIterator,
// AbstractKeyIterator and AbstractValueIterator. It's not exported.
class $0312456ea7695fae$var$CommonIterator {
    constructor(db, options, legacy){
        if (typeof db !== 'object' || db === null) {
            const hint = db === null ? 'null' : typeof db;
            throw new TypeError(`The first argument must be an abstract-level database, received ${hint}`);
        }
        if (typeof options !== 'object' || options === null) throw new TypeError('The second argument must be an options object');
        this[$0312456ea7695fae$var$kClosed] = false;
        this[$0312456ea7695fae$var$kCloseCallbacks] = [];
        this[$0312456ea7695fae$var$kWorking] = false;
        this[$0312456ea7695fae$var$kClosing] = false;
        this[$0312456ea7695fae$var$kAutoClose] = false;
        this[$0312456ea7695fae$var$kCallback] = null;
        this[$0312456ea7695fae$var$kHandleOne] = this[$0312456ea7695fae$var$kHandleOne].bind(this);
        this[$0312456ea7695fae$var$kHandleMany] = this[$0312456ea7695fae$var$kHandleMany].bind(this);
        this[$0312456ea7695fae$var$kHandleClose] = this[$0312456ea7695fae$var$kHandleClose].bind(this);
        this[$0312456ea7695fae$var$kKeyEncoding] = options[$0312456ea7695fae$var$kKeyEncoding];
        this[$0312456ea7695fae$var$kValueEncoding] = options[$0312456ea7695fae$var$kValueEncoding];
        this[$0312456ea7695fae$var$kLegacy] = legacy;
        this[$0312456ea7695fae$var$kLimit] = Number.isInteger(options.limit) && options.limit >= 0 ? options.limit : Infinity;
        this[$0312456ea7695fae$var$kCount] = 0;
        // Undocumented option to abort pending work on close(). Used by the
        // many-level module as a temporary solution to a blocked close().
        // TODO (next major): consider making this the default behavior. Native
        // implementations should have their own logic to safely close iterators.
        this[$0312456ea7695fae$var$kAbortOnClose] = !!options.abortOnClose;
        this.db = db;
        this.db.attachResource(this);
        this.nextTick = db.nextTick;
    }
    get count() {
        return this[$0312456ea7695fae$var$kCount];
    }
    get limit() {
        return this[$0312456ea7695fae$var$kLimit];
    }
    next(callback) {
        let promise;
        if (callback === undefined) promise = new Promise((resolve, reject)=>{
            callback = (err, key, value)=>{
                if (err) reject(err);
                else if (!this[$0312456ea7695fae$var$kLegacy]) resolve(key);
                else if (key === undefined && value === undefined) resolve();
                else resolve([
                    key,
                    value
                ]);
            };
        });
        else if (typeof callback !== 'function') throw new TypeError('Callback must be a function');
        if (this[$0312456ea7695fae$var$kClosing]) this.nextTick(callback, new $b73to('Iterator is not open: cannot call next() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
        else if (this[$0312456ea7695fae$var$kWorking]) this.nextTick(callback, new $b73to('Iterator is busy: cannot call next() until previous call has completed', {
            code: 'LEVEL_ITERATOR_BUSY'
        }));
        else {
            this[$0312456ea7695fae$var$kWorking] = true;
            this[$0312456ea7695fae$var$kCallback] = callback;
            if (this[$0312456ea7695fae$var$kCount] >= this[$0312456ea7695fae$var$kLimit]) this.nextTick(this[$0312456ea7695fae$var$kHandleOne], null);
            else this._next(this[$0312456ea7695fae$var$kHandleOne]);
        }
        return promise;
    }
    _next(callback) {
        this.nextTick(callback);
    }
    nextv(size, options, callback) {
        callback = $0312456ea7695fae$require$getCallback(options, callback);
        callback = $0312456ea7695fae$require$fromCallback(callback, $0312456ea7695fae$var$kPromise);
        options = $0312456ea7695fae$require$getOptions(options, $0312456ea7695fae$var$emptyOptions);
        if (!Number.isInteger(size)) {
            this.nextTick(callback, new TypeError("The first argument 'size' must be an integer"));
            return callback[$0312456ea7695fae$var$kPromise];
        }
        if (this[$0312456ea7695fae$var$kClosing]) this.nextTick(callback, new $b73to('Iterator is not open: cannot call nextv() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
        else if (this[$0312456ea7695fae$var$kWorking]) this.nextTick(callback, new $b73to('Iterator is busy: cannot call nextv() until previous call has completed', {
            code: 'LEVEL_ITERATOR_BUSY'
        }));
        else {
            if (size < 1) size = 1;
            if (this[$0312456ea7695fae$var$kLimit] < Infinity) size = Math.min(size, this[$0312456ea7695fae$var$kLimit] - this[$0312456ea7695fae$var$kCount]);
            this[$0312456ea7695fae$var$kWorking] = true;
            this[$0312456ea7695fae$var$kCallback] = callback;
            if (size <= 0) this.nextTick(this[$0312456ea7695fae$var$kHandleMany], null, []);
            else this._nextv(size, options, this[$0312456ea7695fae$var$kHandleMany]);
        }
        return callback[$0312456ea7695fae$var$kPromise];
    }
    _nextv(size, options, callback) {
        const acc = [];
        const onnext = (err, key, value)=>{
            if (err) return callback(err);
            else if (this[$0312456ea7695fae$var$kLegacy] ? key === undefined && value === undefined : key === undefined) return callback(null, acc);
            acc.push(this[$0312456ea7695fae$var$kLegacy] ? [
                key,
                value
            ] : key);
            if (acc.length === size) callback(null, acc);
            else this._next(onnext);
        };
        this._next(onnext);
    }
    all(options, callback) {
        callback = $0312456ea7695fae$require$getCallback(options, callback);
        callback = $0312456ea7695fae$require$fromCallback(callback, $0312456ea7695fae$var$kPromise);
        options = $0312456ea7695fae$require$getOptions(options, $0312456ea7695fae$var$emptyOptions);
        if (this[$0312456ea7695fae$var$kClosing]) this.nextTick(callback, new $b73to('Iterator is not open: cannot call all() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
        else if (this[$0312456ea7695fae$var$kWorking]) this.nextTick(callback, new $b73to('Iterator is busy: cannot call all() until previous call has completed', {
            code: 'LEVEL_ITERATOR_BUSY'
        }));
        else {
            this[$0312456ea7695fae$var$kWorking] = true;
            this[$0312456ea7695fae$var$kCallback] = callback;
            this[$0312456ea7695fae$var$kAutoClose] = true;
            if (this[$0312456ea7695fae$var$kCount] >= this[$0312456ea7695fae$var$kLimit]) this.nextTick(this[$0312456ea7695fae$var$kHandleMany], null, []);
            else this._all(options, this[$0312456ea7695fae$var$kHandleMany]);
        }
        return callback[$0312456ea7695fae$var$kPromise];
    }
    _all(options, callback) {
        // Must count here because we're directly calling _nextv()
        let count = this[$0312456ea7695fae$var$kCount];
        const acc = [];
        const nextv = ()=>{
            // Not configurable, because implementations should optimize _all().
            const size = this[$0312456ea7695fae$var$kLimit] < Infinity ? Math.min(1e3, this[$0312456ea7695fae$var$kLimit] - count) : 1e3;
            if (size <= 0) this.nextTick(callback, null, acc);
            else this._nextv(size, $0312456ea7695fae$var$emptyOptions, onnextv);
        };
        const onnextv = (err, items)=>{
            if (err) callback(err);
            else if (items.length === 0) callback(null, acc);
            else {
                acc.push.apply(acc, items);
                count += items.length;
                nextv();
            }
        };
        nextv();
    }
    [$0312456ea7695fae$var$kFinishWork]() {
        const cb = this[$0312456ea7695fae$var$kCallback];
        // Callback will be null if work was aborted on close
        if (this[$0312456ea7695fae$var$kAbortOnClose] && cb === null) return $0312456ea7695fae$var$noop;
        this[$0312456ea7695fae$var$kWorking] = false;
        this[$0312456ea7695fae$var$kCallback] = null;
        if (this[$0312456ea7695fae$var$kClosing]) this._close(this[$0312456ea7695fae$var$kHandleClose]);
        return cb;
    }
    [$0312456ea7695fae$var$kReturnMany](cb, err, items) {
        if (this[$0312456ea7695fae$var$kAutoClose]) this.close(cb.bind(null, err, items));
        else cb(err, items);
    }
    seek(target, options) {
        options = $0312456ea7695fae$require$getOptions(options, $0312456ea7695fae$var$emptyOptions);
        if (this[$0312456ea7695fae$var$kClosing]) ;
        else if (this[$0312456ea7695fae$var$kWorking]) throw new $b73to('Iterator is busy: cannot call seek() until next() has completed', {
            code: 'LEVEL_ITERATOR_BUSY'
        });
        else {
            const keyEncoding = this.db.keyEncoding(options.keyEncoding || this[$0312456ea7695fae$var$kKeyEncoding]);
            const keyFormat = keyEncoding.format;
            if (options.keyEncoding !== keyFormat) options = {
                ...options,
                keyEncoding: keyFormat
            };
            const mapped = this.db.prefixKey(keyEncoding.encode(target), keyFormat);
            this._seek(mapped, options);
        }
    }
    _seek(target, options) {
        throw new $b73to('Iterator does not support seek()', {
            code: 'LEVEL_NOT_SUPPORTED'
        });
    }
    close(callback) {
        callback = $0312456ea7695fae$require$fromCallback(callback, $0312456ea7695fae$var$kPromise);
        if (this[$0312456ea7695fae$var$kClosed]) this.nextTick(callback);
        else if (this[$0312456ea7695fae$var$kClosing]) this[$0312456ea7695fae$var$kCloseCallbacks].push(callback);
        else {
            this[$0312456ea7695fae$var$kClosing] = true;
            this[$0312456ea7695fae$var$kCloseCallbacks].push(callback);
            if (!this[$0312456ea7695fae$var$kWorking]) this._close(this[$0312456ea7695fae$var$kHandleClose]);
            else if (this[$0312456ea7695fae$var$kAbortOnClose]) {
                // Don't wait for work to finish. Subsequently ignore the result.
                const cb = this[$0312456ea7695fae$var$kFinishWork]();
                cb(new $b73to('Aborted on iterator close()', {
                    code: 'LEVEL_ITERATOR_NOT_OPEN'
                }));
            }
        }
        return callback[$0312456ea7695fae$var$kPromise];
    }
    _close(callback) {
        this.nextTick(callback);
    }
    [$0312456ea7695fae$var$kHandleClose]() {
        this[$0312456ea7695fae$var$kClosed] = true;
        this.db.detachResource(this);
        const callbacks = this[$0312456ea7695fae$var$kCloseCallbacks];
        this[$0312456ea7695fae$var$kCloseCallbacks] = [];
        for (const cb of callbacks)cb();
    }
    async *[Symbol.asyncIterator]() {
        try {
            let item;
            while((item = await this.next()) !== undefined)yield item;
        } finally{
            if (!this[$0312456ea7695fae$var$kClosed]) await this.close();
        }
    }
}
// For backwards compatibility this class is not (yet) called AbstractEntryIterator.
class $0312456ea7695fae$var$AbstractIterator extends $0312456ea7695fae$var$CommonIterator {
    constructor(db, options){
        super(db, options, true);
        this[$0312456ea7695fae$var$kKeys] = options.keys !== false;
        this[$0312456ea7695fae$var$kValues] = options.values !== false;
    }
    [$0312456ea7695fae$var$kHandleOne](err, key, value) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return cb(err);
        try {
            key = this[$0312456ea7695fae$var$kKeys] && key !== undefined ? this[$0312456ea7695fae$var$kKeyEncoding].decode(key) : undefined;
            value = this[$0312456ea7695fae$var$kValues] && value !== undefined ? this[$0312456ea7695fae$var$kValueEncoding].decode(value) : undefined;
        } catch (err) {
            return cb(new $0312456ea7695fae$var$IteratorDecodeError('entry', err));
        }
        if (!(key === undefined && value === undefined)) this[$0312456ea7695fae$var$kCount]++;
        cb(null, key, value);
    }
    [$0312456ea7695fae$var$kHandleMany](err, entries) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return this[$0312456ea7695fae$var$kReturnMany](cb, err);
        try {
            for (const entry of entries){
                const key = entry[0];
                const value = entry[1];
                entry[0] = this[$0312456ea7695fae$var$kKeys] && key !== undefined ? this[$0312456ea7695fae$var$kKeyEncoding].decode(key) : undefined;
                entry[1] = this[$0312456ea7695fae$var$kValues] && value !== undefined ? this[$0312456ea7695fae$var$kValueEncoding].decode(value) : undefined;
            }
        } catch (err) {
            return this[$0312456ea7695fae$var$kReturnMany](cb, new $0312456ea7695fae$var$IteratorDecodeError('entries', err));
        }
        this[$0312456ea7695fae$var$kCount] += entries.length;
        this[$0312456ea7695fae$var$kReturnMany](cb, null, entries);
    }
    end(callback) {
        if (!$0312456ea7695fae$var$warnedEnd && typeof console !== 'undefined') {
            $0312456ea7695fae$var$warnedEnd = true;
            console.warn(new $b73to('The iterator.end() method was renamed to close() and end() is an alias that will be removed in a future version', {
                code: 'LEVEL_LEGACY'
            }));
        }
        return this.close(callback);
    }
}
class $0312456ea7695fae$var$AbstractKeyIterator extends $0312456ea7695fae$var$CommonIterator {
    constructor(db, options){
        super(db, options, false);
    }
    [$0312456ea7695fae$var$kHandleOne](err, key) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return cb(err);
        try {
            key = key !== undefined ? this[$0312456ea7695fae$var$kKeyEncoding].decode(key) : undefined;
        } catch (err) {
            return cb(new $0312456ea7695fae$var$IteratorDecodeError('key', err));
        }
        if (key !== undefined) this[$0312456ea7695fae$var$kCount]++;
        cb(null, key);
    }
    [$0312456ea7695fae$var$kHandleMany](err, keys) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return this[$0312456ea7695fae$var$kReturnMany](cb, err);
        try {
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                keys[i] = key !== undefined ? this[$0312456ea7695fae$var$kKeyEncoding].decode(key) : undefined;
            }
        } catch (err) {
            return this[$0312456ea7695fae$var$kReturnMany](cb, new $0312456ea7695fae$var$IteratorDecodeError('keys', err));
        }
        this[$0312456ea7695fae$var$kCount] += keys.length;
        this[$0312456ea7695fae$var$kReturnMany](cb, null, keys);
    }
}
class $0312456ea7695fae$var$AbstractValueIterator extends $0312456ea7695fae$var$CommonIterator {
    constructor(db, options){
        super(db, options, false);
    }
    [$0312456ea7695fae$var$kHandleOne](err, value) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return cb(err);
        try {
            value = value !== undefined ? this[$0312456ea7695fae$var$kValueEncoding].decode(value) : undefined;
        } catch (err) {
            return cb(new $0312456ea7695fae$var$IteratorDecodeError('value', err));
        }
        if (value !== undefined) this[$0312456ea7695fae$var$kCount]++;
        cb(null, value);
    }
    [$0312456ea7695fae$var$kHandleMany](err, values) {
        const cb = this[$0312456ea7695fae$var$kFinishWork]();
        if (err) return this[$0312456ea7695fae$var$kReturnMany](cb, err);
        try {
            for(let i = 0; i < values.length; i++){
                const value = values[i];
                values[i] = value !== undefined ? this[$0312456ea7695fae$var$kValueEncoding].decode(value) : undefined;
            }
        } catch (err) {
            return this[$0312456ea7695fae$var$kReturnMany](cb, new $0312456ea7695fae$var$IteratorDecodeError('values', err));
        }
        this[$0312456ea7695fae$var$kCount] += values.length;
        this[$0312456ea7695fae$var$kReturnMany](cb, null, values);
    }
}
// Internal utility, not typed or exported
class $0312456ea7695fae$var$IteratorDecodeError extends $b73to {
    constructor(subject, cause){
        super(`Iterator could not decode ${subject}`, {
            code: 'LEVEL_DECODE_ERROR',
            cause: cause
        });
    }
}
// To help migrating to abstract-level
for (const k of [
    '_ended property',
    '_nexting property',
    '_end method'
])Object.defineProperty($0312456ea7695fae$var$AbstractIterator.prototype, k.split(' ')[0], {
    get () {
        throw new $b73to(`The ${k} has been removed`, {
            code: 'LEVEL_LEGACY'
        });
    },
    set () {
        throw new $b73to(`The ${k} has been removed`, {
            code: 'LEVEL_LEGACY'
        });
    }
});
// Exposed so that AbstractLevel can set these options
$0312456ea7695fae$var$AbstractIterator.keyEncoding = $0312456ea7695fae$var$kKeyEncoding;
$0312456ea7695fae$var$AbstractIterator.valueEncoding = $0312456ea7695fae$var$kValueEncoding;
$0312456ea7695fae$export$bddce72536e51c3d = $0312456ea7695fae$var$AbstractIterator;
$0312456ea7695fae$export$f2a6a3524a0d1895 = $0312456ea7695fae$var$AbstractKeyIterator;
$0312456ea7695fae$export$745e971bb830fb44 = $0312456ea7695fae$var$AbstractValueIterator;

});
parcelRegister("jgLDB", function(module, exports) {

$parcel$export(module.exports, "getCallback", function () { return $e07476d5bf2f24fc$export$2a88462d58de88be; }, function (v) { return $e07476d5bf2f24fc$export$2a88462d58de88be = v; });
$parcel$export(module.exports, "getOptions", function () { return $e07476d5bf2f24fc$export$d2312e68e1f5ad00; }, function (v) { return $e07476d5bf2f24fc$export$d2312e68e1f5ad00 = v; });
var $e07476d5bf2f24fc$export$2a88462d58de88be;
var $e07476d5bf2f24fc$export$d2312e68e1f5ad00;
'use strict';
$e07476d5bf2f24fc$export$2a88462d58de88be = function(options, callback) {
    return typeof options === 'function' ? options : callback;
};
$e07476d5bf2f24fc$export$d2312e68e1f5ad00 = function(options, def) {
    if (typeof options === 'object' && options !== null) return options;
    if (def !== undefined) return def;
    return {};
};

});


parcelRegister("9M4hz", function(module, exports) {

$parcel$export(module.exports, "DefaultKeyIterator", function () { return $71dbeb23e3444f8d$export$decb5386bca9f326; }, function (v) { return $71dbeb23e3444f8d$export$decb5386bca9f326 = v; });
$parcel$export(module.exports, "DefaultValueIterator", function () { return $71dbeb23e3444f8d$export$80f5e55585f13446; }, function (v) { return $71dbeb23e3444f8d$export$80f5e55585f13446 = v; });
// Internal utilities, should be typed as AbstractKeyIterator and AbstractValueIterator
var $71dbeb23e3444f8d$export$decb5386bca9f326;
var $71dbeb23e3444f8d$export$80f5e55585f13446;
'use strict';

var $glCWx = parcelRequire("glCWx");
var $71dbeb23e3444f8d$require$AbstractKeyIterator = $glCWx.AbstractKeyIterator;
var $71dbeb23e3444f8d$require$AbstractValueIterator = $glCWx.AbstractValueIterator;
const $71dbeb23e3444f8d$var$kIterator = Symbol('iterator');
const $71dbeb23e3444f8d$var$kCallback = Symbol('callback');
const $71dbeb23e3444f8d$var$kHandleOne = Symbol('handleOne');
const $71dbeb23e3444f8d$var$kHandleMany = Symbol('handleMany');
class $71dbeb23e3444f8d$var$DefaultKeyIterator extends $71dbeb23e3444f8d$require$AbstractKeyIterator {
    constructor(db, options){
        super(db, options);
        this[$71dbeb23e3444f8d$var$kIterator] = db.iterator({
            ...options,
            keys: true,
            values: false
        });
        this[$71dbeb23e3444f8d$var$kHandleOne] = this[$71dbeb23e3444f8d$var$kHandleOne].bind(this);
        this[$71dbeb23e3444f8d$var$kHandleMany] = this[$71dbeb23e3444f8d$var$kHandleMany].bind(this);
    }
}
class $71dbeb23e3444f8d$var$DefaultValueIterator extends $71dbeb23e3444f8d$require$AbstractValueIterator {
    constructor(db, options){
        super(db, options);
        this[$71dbeb23e3444f8d$var$kIterator] = db.iterator({
            ...options,
            keys: false,
            values: true
        });
        this[$71dbeb23e3444f8d$var$kHandleOne] = this[$71dbeb23e3444f8d$var$kHandleOne].bind(this);
        this[$71dbeb23e3444f8d$var$kHandleMany] = this[$71dbeb23e3444f8d$var$kHandleMany].bind(this);
    }
}
for (const Iterator of [
    $71dbeb23e3444f8d$var$DefaultKeyIterator,
    $71dbeb23e3444f8d$var$DefaultValueIterator
]){
    const keys = Iterator === $71dbeb23e3444f8d$var$DefaultKeyIterator;
    const mapEntry = keys ? (entry)=>entry[0] : (entry)=>entry[1];
    Iterator.prototype._next = function(callback) {
        this[$71dbeb23e3444f8d$var$kCallback] = callback;
        this[$71dbeb23e3444f8d$var$kIterator].next(this[$71dbeb23e3444f8d$var$kHandleOne]);
    };
    Iterator.prototype[$71dbeb23e3444f8d$var$kHandleOne] = function(err, key, value) {
        const callback = this[$71dbeb23e3444f8d$var$kCallback];
        if (err) callback(err);
        else callback(null, keys ? key : value);
    };
    Iterator.prototype._nextv = function(size, options, callback) {
        this[$71dbeb23e3444f8d$var$kCallback] = callback;
        this[$71dbeb23e3444f8d$var$kIterator].nextv(size, options, this[$71dbeb23e3444f8d$var$kHandleMany]);
    };
    Iterator.prototype._all = function(options, callback) {
        this[$71dbeb23e3444f8d$var$kCallback] = callback;
        this[$71dbeb23e3444f8d$var$kIterator].all(options, this[$71dbeb23e3444f8d$var$kHandleMany]);
    };
    Iterator.prototype[$71dbeb23e3444f8d$var$kHandleMany] = function(err, entries) {
        const callback = this[$71dbeb23e3444f8d$var$kCallback];
        if (err) callback(err);
        else callback(null, entries.map(mapEntry));
    };
    Iterator.prototype._seek = function(target, options) {
        this[$71dbeb23e3444f8d$var$kIterator].seek(target, options);
    };
    Iterator.prototype._close = function(callback) {
        this[$71dbeb23e3444f8d$var$kIterator].close(callback);
    };
}
$71dbeb23e3444f8d$export$decb5386bca9f326 = $71dbeb23e3444f8d$var$DefaultKeyIterator;
$71dbeb23e3444f8d$export$80f5e55585f13446 = $71dbeb23e3444f8d$var$DefaultValueIterator;

});

parcelRegister("6Upf3", function(module, exports) {

$parcel$export(module.exports, "DeferredIterator", function () { return $507b8d8389baa03d$export$6ae0bcf995348886; }, function (v) { return $507b8d8389baa03d$export$6ae0bcf995348886 = v; });
$parcel$export(module.exports, "DeferredKeyIterator", function () { return $507b8d8389baa03d$export$50b78b566fc3c3ea; }, function (v) { return $507b8d8389baa03d$export$50b78b566fc3c3ea = v; });
$parcel$export(module.exports, "DeferredValueIterator", function () { return $507b8d8389baa03d$export$b94128d7bc1e8567; }, function (v) { return $507b8d8389baa03d$export$b94128d7bc1e8567 = v; });
var $507b8d8389baa03d$export$6ae0bcf995348886;
var $507b8d8389baa03d$export$50b78b566fc3c3ea;
var $507b8d8389baa03d$export$b94128d7bc1e8567;
'use strict';

var $glCWx = parcelRequire("glCWx");
var $507b8d8389baa03d$require$AbstractIterator = $glCWx.AbstractIterator;
var $507b8d8389baa03d$require$AbstractKeyIterator = $glCWx.AbstractKeyIterator;
var $507b8d8389baa03d$require$AbstractValueIterator = $glCWx.AbstractValueIterator;

var $b73to = parcelRequire("b73to");
const $507b8d8389baa03d$var$kNut = Symbol('nut');
const $507b8d8389baa03d$var$kUndefer = Symbol('undefer');
const $507b8d8389baa03d$var$kFactory = Symbol('factory');
class $507b8d8389baa03d$var$DeferredIterator extends $507b8d8389baa03d$require$AbstractIterator {
    constructor(db, options){
        super(db, options);
        this[$507b8d8389baa03d$var$kNut] = null;
        this[$507b8d8389baa03d$var$kFactory] = ()=>db.iterator(options);
        this.db.defer(()=>this[$507b8d8389baa03d$var$kUndefer]());
    }
}
class $507b8d8389baa03d$var$DeferredKeyIterator extends $507b8d8389baa03d$require$AbstractKeyIterator {
    constructor(db, options){
        super(db, options);
        this[$507b8d8389baa03d$var$kNut] = null;
        this[$507b8d8389baa03d$var$kFactory] = ()=>db.keys(options);
        this.db.defer(()=>this[$507b8d8389baa03d$var$kUndefer]());
    }
}
class $507b8d8389baa03d$var$DeferredValueIterator extends $507b8d8389baa03d$require$AbstractValueIterator {
    constructor(db, options){
        super(db, options);
        this[$507b8d8389baa03d$var$kNut] = null;
        this[$507b8d8389baa03d$var$kFactory] = ()=>db.values(options);
        this.db.defer(()=>this[$507b8d8389baa03d$var$kUndefer]());
    }
}
for (const Iterator of [
    $507b8d8389baa03d$var$DeferredIterator,
    $507b8d8389baa03d$var$DeferredKeyIterator,
    $507b8d8389baa03d$var$DeferredValueIterator
]){
    Iterator.prototype[$507b8d8389baa03d$var$kUndefer] = function() {
        if (this.db.status === 'open') this[$507b8d8389baa03d$var$kNut] = this[$507b8d8389baa03d$var$kFactory]();
    };
    Iterator.prototype._next = function(callback) {
        if (this[$507b8d8389baa03d$var$kNut] !== null) this[$507b8d8389baa03d$var$kNut].next(callback);
        else if (this.db.status === 'opening') this.db.defer(()=>this._next(callback));
        else this.nextTick(callback, new $b73to('Iterator is not open: cannot call next() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
    };
    Iterator.prototype._nextv = function(size, options, callback) {
        if (this[$507b8d8389baa03d$var$kNut] !== null) this[$507b8d8389baa03d$var$kNut].nextv(size, options, callback);
        else if (this.db.status === 'opening') this.db.defer(()=>this._nextv(size, options, callback));
        else this.nextTick(callback, new $b73to('Iterator is not open: cannot call nextv() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
    };
    Iterator.prototype._all = function(options, callback) {
        if (this[$507b8d8389baa03d$var$kNut] !== null) this[$507b8d8389baa03d$var$kNut].all(callback);
        else if (this.db.status === 'opening') this.db.defer(()=>this._all(options, callback));
        else this.nextTick(callback, new $b73to('Iterator is not open: cannot call all() after close()', {
            code: 'LEVEL_ITERATOR_NOT_OPEN'
        }));
    };
    Iterator.prototype._seek = function(target, options) {
        if (this[$507b8d8389baa03d$var$kNut] !== null) // TODO: explain why we need _seek() rather than seek() here
        this[$507b8d8389baa03d$var$kNut]._seek(target, options);
        else if (this.db.status === 'opening') this.db.defer(()=>this._seek(target, options));
    };
    Iterator.prototype._close = function(callback) {
        if (this[$507b8d8389baa03d$var$kNut] !== null) this[$507b8d8389baa03d$var$kNut].close(callback);
        else if (this.db.status === 'opening') this.db.defer(()=>this._close(callback));
        else this.nextTick(callback);
    };
}
$507b8d8389baa03d$export$6ae0bcf995348886 = $507b8d8389baa03d$var$DeferredIterator;
$507b8d8389baa03d$export$50b78b566fc3c3ea = $507b8d8389baa03d$var$DeferredKeyIterator;
$507b8d8389baa03d$export$b94128d7bc1e8567 = $507b8d8389baa03d$var$DeferredValueIterator;

});

parcelRegister("bv6n5", function(module, exports) {

$parcel$export(module.exports, "DefaultChainedBatch", function () { return $85f7883009726b5b$export$39c12306b982e2e7; }, function (v) { return $85f7883009726b5b$export$39c12306b982e2e7 = v; });
var $85f7883009726b5b$export$39c12306b982e2e7;
'use strict';

var $1iIdo = parcelRequire("1iIdo");
var $85f7883009726b5b$require$AbstractChainedBatch = $1iIdo.AbstractChainedBatch;

var $b73to = parcelRequire("b73to");
const $85f7883009726b5b$var$kEncoded = Symbol('encoded');
// Functional default for chained batch, with support of deferred open
class $85f7883009726b5b$var$DefaultChainedBatch extends $85f7883009726b5b$require$AbstractChainedBatch {
    constructor(db){
        super(db);
        this[$85f7883009726b5b$var$kEncoded] = [];
    }
    _put(key, value, options) {
        this[$85f7883009726b5b$var$kEncoded].push({
            ...options,
            type: 'put',
            key: key,
            value: value
        });
    }
    _del(key, options) {
        this[$85f7883009726b5b$var$kEncoded].push({
            ...options,
            type: 'del',
            key: key
        });
    }
    _clear() {
        this[$85f7883009726b5b$var$kEncoded] = [];
    }
    // Assumes this[kEncoded] cannot change after write()
    _write(options, callback) {
        if (this.db.status === 'opening') this.db.defer(()=>this._write(options, callback));
        else if (this.db.status === 'open') {
            if (this[$85f7883009726b5b$var$kEncoded].length === 0) this.nextTick(callback);
            else this.db._batch(this[$85f7883009726b5b$var$kEncoded], options, callback);
        } else this.nextTick(callback, new $b73to('Batch is not open: cannot call write() after write() or close()', {
            code: 'LEVEL_BATCH_NOT_OPEN'
        }));
    }
}
$85f7883009726b5b$export$39c12306b982e2e7 = $85f7883009726b5b$var$DefaultChainedBatch;

});
parcelRegister("1iIdo", function(module, exports) {

$parcel$export(module.exports, "AbstractChainedBatch", function () { return $0f29c511f98e57a1$export$b7cc577567d0e62c; }, function (v) { return $0f29c511f98e57a1$export$b7cc577567d0e62c = v; });
var $0f29c511f98e57a1$export$b7cc577567d0e62c;
'use strict';

var $6uHRl = parcelRequire("6uHRl");
var $0f29c511f98e57a1$require$fromCallback = $6uHRl.fromCallback;

var $b73to = parcelRequire("b73to");

var $jgLDB = parcelRequire("jgLDB");
var $0f29c511f98e57a1$require$getCallback = $jgLDB.getCallback;
var $0f29c511f98e57a1$require$getOptions = $jgLDB.getOptions;
const $0f29c511f98e57a1$var$kPromise = Symbol('promise');
const $0f29c511f98e57a1$var$kStatus = Symbol('status');
const $0f29c511f98e57a1$var$kOperations = Symbol('operations');
const $0f29c511f98e57a1$var$kFinishClose = Symbol('finishClose');
const $0f29c511f98e57a1$var$kCloseCallbacks = Symbol('closeCallbacks');
class $0f29c511f98e57a1$var$AbstractChainedBatch {
    constructor(db){
        if (typeof db !== 'object' || db === null) {
            const hint = db === null ? 'null' : typeof db;
            throw new TypeError(`The first argument must be an abstract-level database, received ${hint}`);
        }
        this[$0f29c511f98e57a1$var$kOperations] = [];
        this[$0f29c511f98e57a1$var$kCloseCallbacks] = [];
        this[$0f29c511f98e57a1$var$kStatus] = 'open';
        this[$0f29c511f98e57a1$var$kFinishClose] = this[$0f29c511f98e57a1$var$kFinishClose].bind(this);
        this.db = db;
        this.db.attachResource(this);
        this.nextTick = db.nextTick;
    }
    get length() {
        return this[$0f29c511f98e57a1$var$kOperations].length;
    }
    put(key, value, options) {
        if (this[$0f29c511f98e57a1$var$kStatus] !== 'open') throw new $b73to('Batch is not open: cannot call put() after write() or close()', {
            code: 'LEVEL_BATCH_NOT_OPEN'
        });
        const err = this.db._checkKey(key) || this.db._checkValue(value);
        if (err) throw err;
        const db = options && options.sublevel != null ? options.sublevel : this.db;
        const original = options;
        const keyEncoding = db.keyEncoding(options && options.keyEncoding);
        const valueEncoding = db.valueEncoding(options && options.valueEncoding);
        const keyFormat = keyEncoding.format;
        // Forward encoding options
        options = {
            ...options,
            keyEncoding: keyFormat,
            valueEncoding: valueEncoding.format
        };
        // Prevent double prefixing
        if (db !== this.db) options.sublevel = null;
        const mappedKey = db.prefixKey(keyEncoding.encode(key), keyFormat);
        const mappedValue = valueEncoding.encode(value);
        this._put(mappedKey, mappedValue, options);
        this[$0f29c511f98e57a1$var$kOperations].push({
            ...original,
            type: 'put',
            key: key,
            value: value
        });
        return this;
    }
    _put(key, value, options) {}
    del(key, options) {
        if (this[$0f29c511f98e57a1$var$kStatus] !== 'open') throw new $b73to('Batch is not open: cannot call del() after write() or close()', {
            code: 'LEVEL_BATCH_NOT_OPEN'
        });
        const err = this.db._checkKey(key);
        if (err) throw err;
        const db = options && options.sublevel != null ? options.sublevel : this.db;
        const original = options;
        const keyEncoding = db.keyEncoding(options && options.keyEncoding);
        const keyFormat = keyEncoding.format;
        // Forward encoding options
        options = {
            ...options,
            keyEncoding: keyFormat
        };
        // Prevent double prefixing
        if (db !== this.db) options.sublevel = null;
        this._del(db.prefixKey(keyEncoding.encode(key), keyFormat), options);
        this[$0f29c511f98e57a1$var$kOperations].push({
            ...original,
            type: 'del',
            key: key
        });
        return this;
    }
    _del(key, options) {}
    clear() {
        if (this[$0f29c511f98e57a1$var$kStatus] !== 'open') throw new $b73to('Batch is not open: cannot call clear() after write() or close()', {
            code: 'LEVEL_BATCH_NOT_OPEN'
        });
        this._clear();
        this[$0f29c511f98e57a1$var$kOperations] = [];
        return this;
    }
    _clear() {}
    write(options, callback) {
        callback = $0f29c511f98e57a1$require$getCallback(options, callback);
        callback = $0f29c511f98e57a1$require$fromCallback(callback, $0f29c511f98e57a1$var$kPromise);
        options = $0f29c511f98e57a1$require$getOptions(options);
        if (this[$0f29c511f98e57a1$var$kStatus] !== 'open') this.nextTick(callback, new $b73to('Batch is not open: cannot call write() after write() or close()', {
            code: 'LEVEL_BATCH_NOT_OPEN'
        }));
        else if (this.length === 0) this.close(callback);
        else {
            this[$0f29c511f98e57a1$var$kStatus] = 'writing';
            this._write(options, (err)=>{
                this[$0f29c511f98e57a1$var$kStatus] = 'closing';
                this[$0f29c511f98e57a1$var$kCloseCallbacks].push(()=>callback(err));
                // Emit after setting 'closing' status, because event may trigger a
                // db close which in turn triggers (idempotently) closing this batch.
                if (!err) this.db.emit('batch', this[$0f29c511f98e57a1$var$kOperations]);
                this._close(this[$0f29c511f98e57a1$var$kFinishClose]);
            });
        }
        return callback[$0f29c511f98e57a1$var$kPromise];
    }
    _write(options, callback) {}
    close(callback) {
        callback = $0f29c511f98e57a1$require$fromCallback(callback, $0f29c511f98e57a1$var$kPromise);
        if (this[$0f29c511f98e57a1$var$kStatus] === 'closing') this[$0f29c511f98e57a1$var$kCloseCallbacks].push(callback);
        else if (this[$0f29c511f98e57a1$var$kStatus] === 'closed') this.nextTick(callback);
        else {
            this[$0f29c511f98e57a1$var$kCloseCallbacks].push(callback);
            if (this[$0f29c511f98e57a1$var$kStatus] !== 'writing') {
                this[$0f29c511f98e57a1$var$kStatus] = 'closing';
                this._close(this[$0f29c511f98e57a1$var$kFinishClose]);
            }
        }
        return callback[$0f29c511f98e57a1$var$kPromise];
    }
    _close(callback) {
        this.nextTick(callback);
    }
    [$0f29c511f98e57a1$var$kFinishClose]() {
        this[$0f29c511f98e57a1$var$kStatus] = 'closed';
        this.db.detachResource(this);
        const callbacks = this[$0f29c511f98e57a1$var$kCloseCallbacks];
        this[$0f29c511f98e57a1$var$kCloseCallbacks] = [];
        for (const cb of callbacks)cb();
    }
}
$0f29c511f98e57a1$export$b7cc577567d0e62c = $0f29c511f98e57a1$var$AbstractChainedBatch;

});


parcelRegister("2aDUz", function(module, exports) {
'use strict';

var $b73to = parcelRequire("b73to");
const $194b798705ff8aa0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $194b798705ff8aa0$var$rangeOptions = new Set([
    'lt',
    'lte',
    'gt',
    'gte'
]);
module.exports = function(options, keyEncoding) {
    const result = {};
    for(const k in options){
        if (!$194b798705ff8aa0$var$hasOwnProperty.call(options, k)) continue;
        if (k === 'keyEncoding' || k === 'valueEncoding') continue;
        if (k === 'start' || k === 'end') throw new $b73to(`The legacy range option '${k}' has been removed`, {
            code: 'LEVEL_LEGACY'
        });
        else if (k === 'encoding') // To help migrating to abstract-level
        throw new $b73to("The levelup-style 'encoding' alias has been removed, use 'valueEncoding' instead", {
            code: 'LEVEL_LEGACY'
        });
        if ($194b798705ff8aa0$var$rangeOptions.has(k)) // Note that we don't reject nullish and empty options here. While
        // those types are invalid as keys, they are valid as range options.
        result[k] = keyEncoding.encode(options[k]);
        else result[k] = options[k];
    }
    result.reverse = !!result.reverse;
    result.limit = Number.isInteger(result.limit) && result.limit >= 0 ? result.limit : -1;
    return result;
};

});

parcelRegister("iWtrV", function(module, exports) {
'use strict';

var $b0hsY = parcelRequire("b0hsY");
module.exports = function(fn, ...args) {
    if (args.length === 0) $b0hsY(fn);
    else $b0hsY(()=>fn(...args));
};

});
parcelRegister("b0hsY", function(module, exports) {
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $802d3e413adf9e8f$var$promise;
module.exports = typeof queueMicrotask === 'function' ? queueMicrotask.bind(typeof window !== 'undefined' ? window : $parcel$global) : (cb)=>($802d3e413adf9e8f$var$promise || ($802d3e413adf9e8f$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));

});


parcelRegister("jc3Dc", function(module, exports) {
'use strict';

var $b73to = parcelRequire("b73to");

const { Buffer: $df91f4608baec9cb$var$Buffer } = (parcelRequire("bdjQ6")) || {};

var $Fx96I = parcelRequire("Fx96I");
var $df91f4608baec9cb$require$AbstractSublevelIterator = $Fx96I.AbstractSublevelIterator;
var $df91f4608baec9cb$require$AbstractSublevelKeyIterator = $Fx96I.AbstractSublevelKeyIterator;
var $df91f4608baec9cb$require$AbstractSublevelValueIterator = $Fx96I.AbstractSublevelValueIterator;
const $df91f4608baec9cb$var$kPrefix = Symbol('prefix');
const $df91f4608baec9cb$var$kUpperBound = Symbol('upperBound');
const $df91f4608baec9cb$var$kPrefixRange = Symbol('prefixRange');
const $df91f4608baec9cb$var$kParent = Symbol('parent');
const $df91f4608baec9cb$var$kUnfix = Symbol('unfix');
const $df91f4608baec9cb$var$textEncoder = new TextEncoder();
const $df91f4608baec9cb$var$defaults = {
    separator: '!'
};
// Wrapped to avoid circular dependency
module.exports = function({ AbstractLevel: AbstractLevel }) {
    class AbstractSublevel extends AbstractLevel {
        static defaults(options) {
            // To help migrating from subleveldown to abstract-level
            if (typeof options === 'string') throw new $b73to('The subleveldown string shorthand for { separator } has been removed', {
                code: 'LEVEL_LEGACY'
            });
            else if (options && options.open) throw new $b73to('The subleveldown open option has been removed', {
                code: 'LEVEL_LEGACY'
            });
            if (options == null) return $df91f4608baec9cb$var$defaults;
            else if (!options.separator) return {
                ...options,
                separator: '!'
            };
            else return options;
        }
        // TODO: add autoClose option, which if true, does parent.attachResource(this)
        constructor(db, name, options){
            // Don't forward AbstractSublevel options to AbstractLevel
            const { separator: separator, manifest: manifest, ...forward } = AbstractSublevel.defaults(options);
            name = $df91f4608baec9cb$var$trim(name, separator);
            // Reserve one character between separator and name to give us an upper bound
            const reserved = separator.charCodeAt(0) + 1;
            const parent = db[$df91f4608baec9cb$var$kParent] || db;
            // Keys should sort like ['!a!', '!a!!a!', '!a"', '!aa!', '!b!'].
            // Use ASCII for consistent length between string, Buffer and Uint8Array
            if (!$df91f4608baec9cb$var$textEncoder.encode(name).every((x)=>x > reserved && x < 127)) throw new $b73to(`Prefix must use bytes > ${reserved} < ${127}`, {
                code: 'LEVEL_INVALID_PREFIX'
            });
            super($df91f4608baec9cb$var$mergeManifests(parent, manifest), forward);
            const prefix = (db.prefix || '') + separator + name + separator;
            const upperBound = prefix.slice(0, -1) + String.fromCharCode(reserved);
            this[$df91f4608baec9cb$var$kParent] = parent;
            this[$df91f4608baec9cb$var$kPrefix] = new $df91f4608baec9cb$var$MultiFormat(prefix);
            this[$df91f4608baec9cb$var$kUpperBound] = new $df91f4608baec9cb$var$MultiFormat(upperBound);
            this[$df91f4608baec9cb$var$kUnfix] = new $df91f4608baec9cb$var$Unfixer();
            this.nextTick = parent.nextTick;
        }
        prefixKey(key, keyFormat) {
            if (keyFormat === 'utf8') return this[$df91f4608baec9cb$var$kPrefix].utf8 + key;
            else if (key.byteLength === 0) // Fast path for empty key (no copy)
            return this[$df91f4608baec9cb$var$kPrefix][keyFormat];
            else if (keyFormat === 'view') {
                const view = this[$df91f4608baec9cb$var$kPrefix].view;
                const result = new Uint8Array(view.byteLength + key.byteLength);
                result.set(view, 0);
                result.set(key, view.byteLength);
                return result;
            } else {
                const buffer = this[$df91f4608baec9cb$var$kPrefix].buffer;
                return $df91f4608baec9cb$var$Buffer.concat([
                    buffer,
                    key
                ], buffer.byteLength + key.byteLength);
            }
        }
        // Not exposed for now.
        [$df91f4608baec9cb$var$kPrefixRange](range, keyFormat) {
            if (range.gte !== undefined) range.gte = this.prefixKey(range.gte, keyFormat);
            else if (range.gt !== undefined) range.gt = this.prefixKey(range.gt, keyFormat);
            else range.gte = this[$df91f4608baec9cb$var$kPrefix][keyFormat];
            if (range.lte !== undefined) range.lte = this.prefixKey(range.lte, keyFormat);
            else if (range.lt !== undefined) range.lt = this.prefixKey(range.lt, keyFormat);
            else range.lte = this[$df91f4608baec9cb$var$kUpperBound][keyFormat];
        }
        get prefix() {
            return this[$df91f4608baec9cb$var$kPrefix].utf8;
        }
        get db() {
            return this[$df91f4608baec9cb$var$kParent];
        }
        _open(options, callback) {
            // The parent db must open itself or be (re)opened by the user because
            // a sublevel should not initiate state changes on the rest of the db.
            this[$df91f4608baec9cb$var$kParent].open({
                passive: true
            }, callback);
        }
        _put(key, value, options, callback) {
            this[$df91f4608baec9cb$var$kParent].put(key, value, options, callback);
        }
        _get(key, options, callback) {
            this[$df91f4608baec9cb$var$kParent].get(key, options, callback);
        }
        _getMany(keys, options, callback) {
            this[$df91f4608baec9cb$var$kParent].getMany(keys, options, callback);
        }
        _del(key, options, callback) {
            this[$df91f4608baec9cb$var$kParent].del(key, options, callback);
        }
        _batch(operations, options, callback) {
            this[$df91f4608baec9cb$var$kParent].batch(operations, options, callback);
        }
        _clear(options, callback) {
            // TODO (refactor): move to AbstractLevel
            this[$df91f4608baec9cb$var$kPrefixRange](options, options.keyEncoding);
            this[$df91f4608baec9cb$var$kParent].clear(options, callback);
        }
        _iterator(options) {
            // TODO (refactor): move to AbstractLevel
            this[$df91f4608baec9cb$var$kPrefixRange](options, options.keyEncoding);
            const iterator = this[$df91f4608baec9cb$var$kParent].iterator(options);
            const unfix = this[$df91f4608baec9cb$var$kUnfix].get(this[$df91f4608baec9cb$var$kPrefix].utf8.length, options.keyEncoding);
            return new $df91f4608baec9cb$require$AbstractSublevelIterator(this, options, iterator, unfix);
        }
        _keys(options) {
            this[$df91f4608baec9cb$var$kPrefixRange](options, options.keyEncoding);
            const iterator = this[$df91f4608baec9cb$var$kParent].keys(options);
            const unfix = this[$df91f4608baec9cb$var$kUnfix].get(this[$df91f4608baec9cb$var$kPrefix].utf8.length, options.keyEncoding);
            return new $df91f4608baec9cb$require$AbstractSublevelKeyIterator(this, options, iterator, unfix);
        }
        _values(options) {
            this[$df91f4608baec9cb$var$kPrefixRange](options, options.keyEncoding);
            const iterator = this[$df91f4608baec9cb$var$kParent].values(options);
            return new $df91f4608baec9cb$require$AbstractSublevelValueIterator(this, options, iterator);
        }
    }
    return {
        AbstractSublevel: AbstractSublevel
    };
};
const $df91f4608baec9cb$var$mergeManifests = function(parent, manifest) {
    return {
        // Inherit manifest of parent db
        ...parent.supports,
        // Disable unsupported features
        createIfMissing: false,
        errorIfExists: false,
        // Unset additional events because we're not forwarding them
        events: {},
        // Unset additional methods (like approximateSize) which we can't support here unless
        // the AbstractSublevel class is overridden by an implementation of `abstract-level`.
        additionalMethods: {},
        // Inherit manifest of custom AbstractSublevel subclass. Such a class is not
        // allowed to override encodings.
        ...manifest,
        encodings: {
            utf8: $df91f4608baec9cb$var$supportsEncoding(parent, 'utf8'),
            buffer: $df91f4608baec9cb$var$supportsEncoding(parent, 'buffer'),
            view: $df91f4608baec9cb$var$supportsEncoding(parent, 'view')
        }
    };
};
const $df91f4608baec9cb$var$supportsEncoding = function(parent, encoding) {
    // Prefer a non-transcoded encoding for optimal performance
    return parent.supports.encodings[encoding] ? parent.keyEncoding(encoding).name === encoding : false;
};
class $df91f4608baec9cb$var$MultiFormat {
    constructor(key){
        this.utf8 = key;
        this.view = $df91f4608baec9cb$var$textEncoder.encode(key);
        this.buffer = $df91f4608baec9cb$var$Buffer ? $df91f4608baec9cb$var$Buffer.from(this.view.buffer, 0, this.view.byteLength) : {};
    }
}
class $df91f4608baec9cb$var$Unfixer {
    constructor(){
        this.cache = new Map();
    }
    get(prefixLength, keyFormat) {
        let unfix = this.cache.get(keyFormat);
        if (unfix === undefined) {
            if (keyFormat === 'view') unfix = (function(prefixLength, key) {
                // Avoid Uint8Array#slice() because it copies
                return key.subarray(prefixLength);
            }).bind(null, prefixLength);
            else unfix = (function(prefixLength, key) {
                // Avoid Buffer#subarray() because it's slow
                return key.slice(prefixLength);
            }).bind(null, prefixLength);
            this.cache.set(keyFormat, unfix);
        }
        return unfix;
    }
}
const $df91f4608baec9cb$var$trim = function(str, char) {
    let start = 0;
    let end = str.length;
    while(start < end && str[start] === char)start++;
    while(end > start && str[end - 1] === char)end--;
    return str.slice(start, end);
};

});
parcelRegister("Fx96I", function(module, exports) {

$parcel$export(module.exports, "AbstractSublevelIterator", function () { return $07cd8a8892bce7c9$export$fd27250e0fb5251; }, function (v) { return $07cd8a8892bce7c9$export$fd27250e0fb5251 = v; });
$parcel$export(module.exports, "AbstractSublevelKeyIterator", function () { return $07cd8a8892bce7c9$export$11349d6250f70779; }, function (v) { return $07cd8a8892bce7c9$export$11349d6250f70779 = v; });
$parcel$export(module.exports, "AbstractSublevelValueIterator", function () { return $07cd8a8892bce7c9$export$92adca8d16da9bec; }, function (v) { return $07cd8a8892bce7c9$export$92adca8d16da9bec = v; });
var $07cd8a8892bce7c9$export$fd27250e0fb5251;
var $07cd8a8892bce7c9$export$11349d6250f70779;
var $07cd8a8892bce7c9$export$92adca8d16da9bec;
'use strict';

var $glCWx = parcelRequire("glCWx");
var $07cd8a8892bce7c9$require$AbstractIterator = $glCWx.AbstractIterator;
var $07cd8a8892bce7c9$require$AbstractKeyIterator = $glCWx.AbstractKeyIterator;
var $07cd8a8892bce7c9$require$AbstractValueIterator = $glCWx.AbstractValueIterator;
const $07cd8a8892bce7c9$var$kUnfix = Symbol('unfix');
const $07cd8a8892bce7c9$var$kIterator = Symbol('iterator');
const $07cd8a8892bce7c9$var$kHandleOne = Symbol('handleOne');
const $07cd8a8892bce7c9$var$kHandleMany = Symbol('handleMany');
const $07cd8a8892bce7c9$var$kCallback = Symbol('callback');
// TODO: unfix natively if db supports it
class $07cd8a8892bce7c9$var$AbstractSublevelIterator extends $07cd8a8892bce7c9$require$AbstractIterator {
    constructor(db, options, iterator, unfix){
        super(db, options);
        this[$07cd8a8892bce7c9$var$kIterator] = iterator;
        this[$07cd8a8892bce7c9$var$kUnfix] = unfix;
        this[$07cd8a8892bce7c9$var$kHandleOne] = this[$07cd8a8892bce7c9$var$kHandleOne].bind(this);
        this[$07cd8a8892bce7c9$var$kHandleMany] = this[$07cd8a8892bce7c9$var$kHandleMany].bind(this);
        this[$07cd8a8892bce7c9$var$kCallback] = null;
    }
    [$07cd8a8892bce7c9$var$kHandleOne](err, key, value) {
        const callback = this[$07cd8a8892bce7c9$var$kCallback];
        if (err) return callback(err);
        if (key !== undefined) key = this[$07cd8a8892bce7c9$var$kUnfix](key);
        callback(err, key, value);
    }
    [$07cd8a8892bce7c9$var$kHandleMany](err, entries) {
        const callback = this[$07cd8a8892bce7c9$var$kCallback];
        if (err) return callback(err);
        for (const entry of entries){
            const key = entry[0];
            if (key !== undefined) entry[0] = this[$07cd8a8892bce7c9$var$kUnfix](key);
        }
        callback(err, entries);
    }
}
class $07cd8a8892bce7c9$var$AbstractSublevelKeyIterator extends $07cd8a8892bce7c9$require$AbstractKeyIterator {
    constructor(db, options, iterator, unfix){
        super(db, options);
        this[$07cd8a8892bce7c9$var$kIterator] = iterator;
        this[$07cd8a8892bce7c9$var$kUnfix] = unfix;
        this[$07cd8a8892bce7c9$var$kHandleOne] = this[$07cd8a8892bce7c9$var$kHandleOne].bind(this);
        this[$07cd8a8892bce7c9$var$kHandleMany] = this[$07cd8a8892bce7c9$var$kHandleMany].bind(this);
        this[$07cd8a8892bce7c9$var$kCallback] = null;
    }
    [$07cd8a8892bce7c9$var$kHandleOne](err, key) {
        const callback = this[$07cd8a8892bce7c9$var$kCallback];
        if (err) return callback(err);
        if (key !== undefined) key = this[$07cd8a8892bce7c9$var$kUnfix](key);
        callback(err, key);
    }
    [$07cd8a8892bce7c9$var$kHandleMany](err, keys) {
        const callback = this[$07cd8a8892bce7c9$var$kCallback];
        if (err) return callback(err);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (key !== undefined) keys[i] = this[$07cd8a8892bce7c9$var$kUnfix](key);
        }
        callback(err, keys);
    }
}
class $07cd8a8892bce7c9$var$AbstractSublevelValueIterator extends $07cd8a8892bce7c9$require$AbstractValueIterator {
    constructor(db, options, iterator){
        super(db, options);
        this[$07cd8a8892bce7c9$var$kIterator] = iterator;
    }
}
for (const Iterator of [
    $07cd8a8892bce7c9$var$AbstractSublevelIterator,
    $07cd8a8892bce7c9$var$AbstractSublevelKeyIterator
]){
    Iterator.prototype._next = function(callback) {
        this[$07cd8a8892bce7c9$var$kCallback] = callback;
        this[$07cd8a8892bce7c9$var$kIterator].next(this[$07cd8a8892bce7c9$var$kHandleOne]);
    };
    Iterator.prototype._nextv = function(size, options, callback) {
        this[$07cd8a8892bce7c9$var$kCallback] = callback;
        this[$07cd8a8892bce7c9$var$kIterator].nextv(size, options, this[$07cd8a8892bce7c9$var$kHandleMany]);
    };
    Iterator.prototype._all = function(options, callback) {
        this[$07cd8a8892bce7c9$var$kCallback] = callback;
        this[$07cd8a8892bce7c9$var$kIterator].all(options, this[$07cd8a8892bce7c9$var$kHandleMany]);
    };
}
for (const Iterator of [
    $07cd8a8892bce7c9$var$AbstractSublevelValueIterator
]){
    Iterator.prototype._next = function(callback) {
        this[$07cd8a8892bce7c9$var$kIterator].next(callback);
    };
    Iterator.prototype._nextv = function(size, options, callback) {
        this[$07cd8a8892bce7c9$var$kIterator].nextv(size, options, callback);
    };
    Iterator.prototype._all = function(options, callback) {
        this[$07cd8a8892bce7c9$var$kIterator].all(options, callback);
    };
}
for (const Iterator of [
    $07cd8a8892bce7c9$var$AbstractSublevelIterator,
    $07cd8a8892bce7c9$var$AbstractSublevelKeyIterator,
    $07cd8a8892bce7c9$var$AbstractSublevelValueIterator
]){
    Iterator.prototype._seek = function(target, options) {
        this[$07cd8a8892bce7c9$var$kIterator].seek(target, options);
    };
    Iterator.prototype._close = function(callback) {
        this[$07cd8a8892bce7c9$var$kIterator].close(callback);
    };
}
$07cd8a8892bce7c9$export$fd27250e0fb5251 = $07cd8a8892bce7c9$var$AbstractSublevelIterator;
$07cd8a8892bce7c9$export$11349d6250f70779 = $07cd8a8892bce7c9$var$AbstractSublevelKeyIterator;
$07cd8a8892bce7c9$export$92adca8d16da9bec = $07cd8a8892bce7c9$var$AbstractSublevelValueIterator;

});




parcelRegister("eXXMq", function(module, exports) {
/*! run-parallel-limit. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ module.exports = $ae54f273875cb337$var$runParallelLimit;

var $b0hsY = parcelRequire("b0hsY");
function $ae54f273875cb337$var$runParallelLimit(tasks, limit, cb) {
    if (typeof limit !== 'number') throw new Error('second argument must be a Number');
    let results, len, pending, keys, isErrored;
    let isSync = true;
    let next;
    if (Array.isArray(tasks)) {
        results = [];
        pending = len = tasks.length;
    } else {
        keys = Object.keys(tasks);
        results = {};
        pending = len = keys.length;
    }
    function done(err) {
        function end() {
            if (cb) cb(err, results);
            cb = null;
        }
        if (isSync) $b0hsY(end);
        else end();
    }
    function each(i, err, result) {
        results[i] = result;
        if (err) isErrored = true;
        if (--pending === 0 || err) done(err);
        else if (!isErrored && next < len) {
            let key;
            if (keys) {
                key = keys[next];
                next += 1;
                tasks[key](function(err, result) {
                    each(key, err, result);
                });
            } else {
                key = next;
                next += 1;
                tasks[key](function(err, result) {
                    each(key, err, result);
                });
            }
        }
    }
    next = limit;
    if (!pending) // empty
    done(null);
    else if (keys) // object
    keys.some(function(key, i) {
        tasks[key](function(err, result) {
            each(key, err, result);
        });
        if (i === limit - 1) return true // early return
        ;
        return false;
    });
    else // array
    tasks.some(function(task, i) {
        task(function(err, result) {
            each(i, err, result);
        });
        if (i === limit - 1) return true // early return
        ;
        return false;
    });
    isSync = false;
}

});

parcelRegister("51CIL", function(module, exports) {

$parcel$export(module.exports, "fromCallback", function () { return $3a8b14ecf2d3831b$export$d0deb4828877173; }, function (v) { return $3a8b14ecf2d3831b$export$d0deb4828877173 = v; });
var $3a8b14ecf2d3831b$export$d0deb4828877173;
var $3a8b14ecf2d3831b$export$60f45028237c39d1;
'use strict';

var $lXdFE = parcelRequire("lXdFE");
$3a8b14ecf2d3831b$export$d0deb4828877173 = function(callback, symbol) {
    if (callback === undefined) {
        var promise = new Promise(function(resolve, reject) {
            callback = function(err, res) {
                if (err) reject(err);
                else resolve(res);
            };
        });
        callback[symbol !== undefined ? symbol : 'promise'] = promise;
    } else if (typeof callback !== 'function') throw new TypeError('Callback must be a function');
    return callback;
};
$3a8b14ecf2d3831b$export$60f45028237c39d1 = function(promise, callback) {
    if (callback === undefined) return promise;
    promise.then(function(res) {
        $lXdFE(()=>callback(null, res));
    }).catch(function(err) {
        $lXdFE(()=>callback(err));
    });
};

});
parcelRegister("lXdFE", function(module, exports) {
module.exports = typeof queueMicrotask === 'function' ? queueMicrotask : (fn)=>Promise.resolve().then(fn);

});


parcelRegister("jSRvk", function(module, exports) {

$parcel$export(module.exports, "Iterator", function () { return $e79c904845624aff$export$b67e82436e407e40; }, function (v) { return $e79c904845624aff$export$b67e82436e407e40 = v; });
var $e79c904845624aff$export$b67e82436e407e40;
'use strict';

var $iFQn2 = parcelRequire("iFQn2");
var $e79c904845624aff$require$AbstractIterator = $iFQn2.AbstractIterator;

var $k7nM2 = parcelRequire("k7nM2");

var $fGWjq = parcelRequire("fGWjq");
const $e79c904845624aff$var$kCache = Symbol('cache');
const $e79c904845624aff$var$kFinished = Symbol('finished');
const $e79c904845624aff$var$kOptions = Symbol('options');
const $e79c904845624aff$var$kCurrentOptions = Symbol('currentOptions');
const $e79c904845624aff$var$kPosition = Symbol('position');
const $e79c904845624aff$var$kLocation = Symbol('location');
const $e79c904845624aff$var$kFirst = Symbol('first');
const $e79c904845624aff$var$emptyOptions = {};
class $e79c904845624aff$var$Iterator extends $e79c904845624aff$require$AbstractIterator {
    constructor(db, location, options){
        super(db, options);
        this[$e79c904845624aff$var$kCache] = [];
        this[$e79c904845624aff$var$kFinished] = this.limit === 0;
        this[$e79c904845624aff$var$kOptions] = options;
        this[$e79c904845624aff$var$kCurrentOptions] = {
            ...options
        };
        this[$e79c904845624aff$var$kPosition] = undefined;
        this[$e79c904845624aff$var$kLocation] = location;
        this[$e79c904845624aff$var$kFirst] = true;
    }
    // Note: if called by _all() then size can be Infinity. This is an internal
    // detail; by design AbstractIterator.nextv() does not support Infinity.
    _nextv(size, options, callback) {
        this[$e79c904845624aff$var$kFirst] = false;
        if (this[$e79c904845624aff$var$kFinished]) return this.nextTick(callback, null, []);
        else if (this[$e79c904845624aff$var$kCache].length > 0) {
            // TODO: mixing next and nextv is not covered by test suite
            size = Math.min(size, this[$e79c904845624aff$var$kCache].length);
            return this.nextTick(callback, null, this[$e79c904845624aff$var$kCache].splice(0, size));
        }
        // Adjust range by what we already visited
        if (this[$e79c904845624aff$var$kPosition] !== undefined) {
            if (this[$e79c904845624aff$var$kOptions].reverse) {
                this[$e79c904845624aff$var$kCurrentOptions].lt = this[$e79c904845624aff$var$kPosition];
                this[$e79c904845624aff$var$kCurrentOptions].lte = undefined;
            } else {
                this[$e79c904845624aff$var$kCurrentOptions].gt = this[$e79c904845624aff$var$kPosition];
                this[$e79c904845624aff$var$kCurrentOptions].gte = undefined;
            }
        }
        let keyRange;
        try {
            keyRange = $k7nM2(this[$e79c904845624aff$var$kCurrentOptions]);
        } catch (_) {
            // The lower key is greater than the upper key.
            // IndexedDB throws an error, but we'll just return 0 results.
            this[$e79c904845624aff$var$kFinished] = true;
            return this.nextTick(callback, null, []);
        }
        const transaction = this.db.db.transaction([
            this[$e79c904845624aff$var$kLocation]
        ], 'readonly');
        const store = transaction.objectStore(this[$e79c904845624aff$var$kLocation]);
        const entries = [];
        if (!this[$e79c904845624aff$var$kOptions].reverse) {
            let keys;
            let values;
            const complete = ()=>{
                // Wait for both requests to complete
                if (keys === undefined || values === undefined) return;
                const length = Math.max(keys.length, values.length);
                if (length === 0 || size === Infinity) this[$e79c904845624aff$var$kFinished] = true;
                else this[$e79c904845624aff$var$kPosition] = keys[length - 1];
                // Resize
                entries.length = length;
                // Merge keys and values
                for(let i = 0; i < length; i++){
                    const key = keys[i];
                    const value = values[i];
                    entries[i] = [
                        this[$e79c904845624aff$var$kOptions].keys && key !== undefined ? $fGWjq(key) : undefined,
                        this[$e79c904845624aff$var$kOptions].values && value !== undefined ? $fGWjq(value) : undefined
                    ];
                }
                $e79c904845624aff$var$maybeCommit(transaction);
            };
            // If keys were not requested and size is Infinity, we don't have to keep
            // track of position and can thus skip getting keys.
            if (this[$e79c904845624aff$var$kOptions].keys || size < Infinity) store.getAllKeys(keyRange, size < Infinity ? size : undefined).onsuccess = (ev)=>{
                keys = ev.target.result;
                complete();
            };
            else {
                keys = [];
                this.nextTick(complete);
            }
            if (this[$e79c904845624aff$var$kOptions].values) store.getAll(keyRange, size < Infinity ? size : undefined).onsuccess = (ev)=>{
                values = ev.target.result;
                complete();
            };
            else {
                values = [];
                this.nextTick(complete);
            }
        } else {
            // Can't use getAll() in reverse, so use a slower cursor that yields one item at a time
            // TODO: test if all target browsers support openKeyCursor
            const method = !this[$e79c904845624aff$var$kOptions].values && store.openKeyCursor ? 'openKeyCursor' : 'openCursor';
            store[method](keyRange, 'prev').onsuccess = (ev)=>{
                const cursor = ev.target.result;
                if (cursor) {
                    const { key: key, value: value } = cursor;
                    this[$e79c904845624aff$var$kPosition] = key;
                    entries.push([
                        this[$e79c904845624aff$var$kOptions].keys && key !== undefined ? $fGWjq(key) : undefined,
                        this[$e79c904845624aff$var$kOptions].values && value !== undefined ? $fGWjq(value) : undefined
                    ]);
                    if (entries.length < size) cursor.continue();
                    else $e79c904845624aff$var$maybeCommit(transaction);
                } else this[$e79c904845624aff$var$kFinished] = true;
            };
        }
        // If an error occurs (on the request), the transaction will abort.
        transaction.onabort = ()=>{
            callback(transaction.error || new Error('aborted by user'));
            callback = null;
        };
        transaction.oncomplete = ()=>{
            callback(null, entries);
            callback = null;
        };
    }
    _next(callback) {
        if (this[$e79c904845624aff$var$kCache].length > 0) {
            const [key, value] = this[$e79c904845624aff$var$kCache].shift();
            this.nextTick(callback, null, key, value);
        } else if (this[$e79c904845624aff$var$kFinished]) this.nextTick(callback);
        else {
            let size = Math.min(100, this.limit - this.count);
            if (this[$e79c904845624aff$var$kFirst]) {
                // It's common to only want one entry initially or after a seek()
                this[$e79c904845624aff$var$kFirst] = false;
                size = 1;
            }
            this._nextv(size, $e79c904845624aff$var$emptyOptions, (err, entries)=>{
                if (err) return callback(err);
                this[$e79c904845624aff$var$kCache] = entries;
                this._next(callback);
            });
        }
    }
    _all(options, callback) {
        this[$e79c904845624aff$var$kFirst] = false;
        // TODO: mixing next and all is not covered by test suite
        const cache = this[$e79c904845624aff$var$kCache].splice(0, this[$e79c904845624aff$var$kCache].length);
        const size = this.limit - this.count - cache.length;
        if (size <= 0) return this.nextTick(callback, null, cache);
        this._nextv(size, $e79c904845624aff$var$emptyOptions, (err, entries)=>{
            if (err) return callback(err);
            if (cache.length > 0) entries = cache.concat(entries);
            callback(null, entries);
        });
    }
    _seek(target, options) {
        this[$e79c904845624aff$var$kFirst] = true;
        this[$e79c904845624aff$var$kCache] = [];
        this[$e79c904845624aff$var$kFinished] = false;
        this[$e79c904845624aff$var$kPosition] = undefined;
        // TODO: not covered by test suite
        this[$e79c904845624aff$var$kCurrentOptions] = {
            ...this[$e79c904845624aff$var$kOptions]
        };
        let keyRange;
        try {
            keyRange = $k7nM2(this[$e79c904845624aff$var$kOptions]);
        } catch (_) {
            this[$e79c904845624aff$var$kFinished] = true;
            return;
        }
        if (keyRange !== null && !keyRange.includes(target)) this[$e79c904845624aff$var$kFinished] = true;
        else if (this[$e79c904845624aff$var$kOptions].reverse) this[$e79c904845624aff$var$kCurrentOptions].lte = target;
        else this[$e79c904845624aff$var$kCurrentOptions].gte = target;
    }
}
$e79c904845624aff$export$b67e82436e407e40 = $e79c904845624aff$var$Iterator;
function $e79c904845624aff$var$maybeCommit(transaction) {
    // Commit (meaning close) now instead of waiting for auto-commit
    if (typeof transaction.commit === 'function') transaction.commit();
}

});
parcelRegister("k7nM2", function(module, exports) {
/* global IDBKeyRange */ 'use strict';
module.exports = function createKeyRange(options) {
    const lower = options.gte !== undefined ? options.gte : options.gt !== undefined ? options.gt : undefined;
    const upper = options.lte !== undefined ? options.lte : options.lt !== undefined ? options.lt : undefined;
    const lowerExclusive = options.gte === undefined;
    const upperExclusive = options.lte === undefined;
    if (lower !== undefined && upper !== undefined) return IDBKeyRange.bound(lower, upper, lowerExclusive, upperExclusive);
    else if (lower !== undefined) return IDBKeyRange.lowerBound(lower, lowerExclusive);
    else if (upper !== undefined) return IDBKeyRange.upperBound(upper, upperExclusive);
    else return null;
};

});

parcelRegister("fGWjq", function(module, exports) {
'use strict';
const $b6c802dbe832bcc4$var$textEncoder = new TextEncoder();
module.exports = function(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else // Non-binary data stored with an old version (level-js < 5.0.0)
    return $b6c802dbe832bcc4$var$textEncoder.encode(data);
};

});


parcelRegister("OphiR", function(module, exports) {
'use strict';
module.exports = function clear(db, location, keyRange, options, callback) {
    if (options.limit === 0) return db.nextTick(callback);
    const transaction = db.db.transaction([
        location
    ], 'readwrite');
    const store = transaction.objectStore(location);
    let count = 0;
    transaction.oncomplete = function() {
        callback();
    };
    transaction.onabort = function() {
        callback(transaction.error || new Error('aborted by user'));
    };
    // A key cursor is faster (skips reading values) but not supported by IE
    // TODO: we no longer support IE. Test others
    const method = store.openKeyCursor ? 'openKeyCursor' : 'openCursor';
    const direction = options.reverse ? 'prev' : 'next';
    store[method](keyRange, direction).onsuccess = function(ev) {
        const cursor = ev.target.result;
        if (cursor) // Wait for a request to complete before continuing, saving CPU.
        store.delete(cursor.key).onsuccess = function() {
            if (options.limit <= 0 || ++count < options.limit) cursor.continue();
        };
    };
};

});


parcelRegister("4hOUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31f03e75d43045cb$var$_react = $31f03e75d43045cb$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $31f03e75d43045cb$var$_useScript = $31f03e75d43045cb$var$_interopRequireDefault((parcelRequire("4fzdz")));

var $31f03e75d43045cb$var$_appleAuthHelpers = $31f03e75d43045cb$var$_interopRequireDefault((parcelRequire("bAzs1")));
var $31f03e75d43045cb$var$_excluded = [
    "onSuccess",
    "onError",
    "skipScript",
    "authOptions",
    "iconProps",
    "render",
    "uiType",
    "className",
    "noDefaultStyle",
    "buttonExtraChildren"
];
function $31f03e75d43045cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31f03e75d43045cb$var$_extends() {
    $31f03e75d43045cb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $31f03e75d43045cb$var$_extends.apply(this, arguments);
}
function $31f03e75d43045cb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $31f03e75d43045cb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $31f03e75d43045cb$var$ownKeys(Object(source), true).forEach(function(key) {
            $31f03e75d43045cb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $31f03e75d43045cb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $31f03e75d43045cb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $31f03e75d43045cb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $31f03e75d43045cb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $31f03e75d43045cb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/** css styles */ var $31f03e75d43045cb$var$_style = "\n.react-apple-signin-auth-btn {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 0 8px 0 2px;\n  font-size: 14px;\n  font-size: 1em;\n  line-height: 1;\n  border: 1px solid #000;\n  overflow: hidden;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.react-apple-signin-auth-btn-light {\n  background-color: #FFF;\n  color: #000;\n  border-color: #000;\n}\n.react-apple-signin-auth-btn-dark {\n  background-color: #000;\n  color: #FFF;\n  border-color: #FFF;\n}".replace(/ {2}|\n/g, '');
var $31f03e75d43045cb$var$AppleSigninButton = function AppleSigninButton(_ref) {
    var onSuccess = _ref.onSuccess, onError = _ref.onError, _ref$skipScript = _ref.skipScript, skipScript = _ref$skipScript === void 0 ? false : _ref$skipScript, authOptions = _ref.authOptions, iconProps = _ref.iconProps, render = _ref.render, _ref$uiType = _ref.uiType, uiType = _ref$uiType === void 0 ? 'dark' : _ref$uiType, className = _ref.className, _ref$noDefaultStyle = _ref.noDefaultStyle, noDefaultStyle = _ref$noDefaultStyle === void 0 ? false : _ref$noDefaultStyle, _ref$buttonExtraChild = _ref.buttonExtraChildren, buttonExtraChildren = _ref$buttonExtraChild === void 0 ? 'Continue with Apple' : _ref$buttonExtraChild, rest = $31f03e75d43045cb$var$_objectWithoutProperties(_ref, $31f03e75d43045cb$var$_excluded);
    /** load script if neccessary */ (0, $31f03e75d43045cb$var$_useScript.default)(skipScript ? null : $31f03e75d43045cb$var$_appleAuthHelpers.default.APPLE_SCRIPT_SRC);
    /** Button click handler */ var handleClick = function handleClick(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        $31f03e75d43045cb$var$_appleAuthHelpers.default.signIn({
            authOptions: authOptions,
            onSuccess: onSuccess,
            onError: onError
        });
    };
    /** common props */ var props = $31f03e75d43045cb$var$_objectSpread({
        children: /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement($31f03e75d43045cb$var$_react.default.Fragment, null, /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("svg", $31f03e75d43045cb$var$_extends({
            width: "24px",
            height: "44px",
            viewBox: "0 0 24 44"
        }, iconProps), /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd"
        }, /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("rect", {
            fill: uiType === 'light' ? '#FFF' : '#000',
            x: "0",
            y: "0",
            width: "24",
            height: "44"
        }), /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("path", {
            d: "M12.2337427,16.9879688 C12.8896607,16.9879688 13.7118677,16.5445313 14.2014966,15.9532812 C14.6449341,15.4174609 14.968274,14.6691602 14.968274,13.9208594 C14.968274,13.8192383 14.9590357,13.7176172 14.9405591,13.6344727 C14.2107349,13.6621875 13.3330982,14.1241016 12.8065162,14.7430664 C12.3907935,15.2142188 12.012024,15.9532812 12.012024,16.7108203 C12.012024,16.8216797 12.0305005,16.9325391 12.0397388,16.9694922 C12.0859302,16.9787305 12.1598365,16.9879688 12.2337427,16.9879688 Z M9.92417241,28.1662891 C10.8202857,28.1662891 11.2175318,27.5658008 12.3353638,27.5658008 C13.4716724,27.5658008 13.721106,28.1478125 14.7188404,28.1478125 C15.6980982,28.1478125 16.3540162,27.2424609 16.972981,26.3555859 C17.6658521,25.339375 17.9522388,24.3416406 17.9707154,24.2954492 C17.9060474,24.2769727 16.0306763,23.5101953 16.0306763,21.3576758 C16.0306763,19.491543 17.5088013,18.6508594 17.5919459,18.5861914 C16.612688,17.1819727 15.1253248,17.1450195 14.7188404,17.1450195 C13.6194849,17.1450195 12.7233716,17.8101758 12.1598365,17.8101758 C11.5501099,17.8101758 10.7463794,17.1819727 9.79483648,17.1819727 C7.98413335,17.1819727 6.14571538,18.6785742 6.14571538,21.5054883 C6.14571538,23.2607617 6.8293482,25.1176563 7.67003179,26.3186328 C8.39061773,27.3348438 9.01882085,28.1662891 9.92417241,28.1662891 Z",
            fill: uiType === 'light' ? '#000' : '#FFF',
            fillRule: "nonzero"
        }))), buttonExtraChildren),
        onClick: handleClick
    }, rest);
    /** use render function if passed */ if (render) return render(props);
    /** render button */ return /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement($31f03e75d43045cb$var$_react.default.Fragment, null, /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("button", $31f03e75d43045cb$var$_extends({
        className: "".concat(noDefaultStyle ? '' : "react-apple-signin-auth-btn react-apple-signin-auth-btn-".concat(uiType)).concat(className ? " ".concat(className) : ''),
        type: "button",
        "aria-label": "Signin with apple ID"
    }, props)), noDefaultStyle ? null : /*#__PURE__*/ $31f03e75d43045cb$var$_react.default.createElement("style", null, $31f03e75d43045cb$var$_style));
};
var $31f03e75d43045cb$var$_default = $31f03e75d43045cb$var$AppleSigninButton;
module.exports.default = $31f03e75d43045cb$var$_default;

});
parcelRegister("4fzdz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fPBF = parcelRequire("7fPBF");
/**
 * useScript hook
 *
 * https://usehooks.com/useScript
 */ function $3183e1b12329837f$var$useScript(src) {
    (0, $7fPBF.useEffect)(function() {
        // Allow falsy src value if waiting on other data needed for
        // constructing the script URL passed to this hook.
        if (!src) return;
         // Fetch existing script element by src
        // It may have been added by another intance of this hook
        var script = document.querySelectorAll("script[src=\"".concat(src, "\"]"))[0];
        if (!script) {
            // Create script
            script = document.createElement('script');
            script.src = src;
            script.async = true; // Add script to document body
            document.body.appendChild(script);
        }
    }, [
        src
    ] // Only re-run effect if script src changes
    );
}
var $3183e1b12329837f$var$_default = $3183e1b12329837f$var$useScript;
module.exports.default = $3183e1b12329837f$var$_default;

});

parcelRegister("bAzs1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86fe8e53497cc621$var$_waitForVar = $86fe8e53497cc621$var$_interopRequireDefault((parcelRequire("lOswr")));
function $86fe8e53497cc621$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $86fe8e53497cc621$var$APPLE_SCRIPT_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
/**
 * Performs an apple ID signIn operation
 */ var $86fe8e53497cc621$var$signIn = function signIn(_ref) {
    var authOptions = _ref.authOptions, onSuccess = _ref.onSuccess, onError = _ref.onError;
    return /** wait for apple sript to load */ (0, $86fe8e53497cc621$var$_waitForVar.default)('AppleID').then(function() {
        /** Handle if appleID script was not loaded -- log + throw error to be caught below */ if (!window.AppleID) console.error(new Error('Error loading apple script'));
        /** Init apple auth */ window.AppleID.auth.init(authOptions);
        /** Signin to appleID */ return window.AppleID.auth.signIn().then(function(response) {
            /** This is only called in case usePopup is true */ if (onSuccess) onSuccess(response);
            /** resolve with the reponse */ return response;
        }).catch(function(err) {
            if (onError) /** Call onError catching the error */ onError(err);
            else /** Log the error to help debug */ console.error(err);
            return null;
        });
    }).catch(function(err) {
        if (onError) /** Call onError catching the error */ onError(err);
        else /** Log the error to help debug */ console.error(err);
        return null;
    });
};
var $86fe8e53497cc621$var$_default = {
    APPLE_SCRIPT_SRC: $86fe8e53497cc621$var$APPLE_SCRIPT_SRC,
    signIn: $86fe8e53497cc621$var$signIn
};
module.exports.default = $86fe8e53497cc621$var$_default;

});
parcelRegister("lOswr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Async wait for a variable till it gets defined in a parent
 *
 * • Usage Example: Waiting for async window.FB var to be initialized
 * - eg: `waitForVar('FB').then(FB => FB.test())`
 * - eg: `waitForVar('FB', { pollFrequency: 500, retries: 2, parent: window || global }).then(FB => FB.test())`
 * - eg: `waitForVar('FB', { retries: ({ retries } => retries * 500) }).then(FB => FB.test())`
 */ var $fe14646f3f4b6394$var$waitForVar = function waitForVar(name) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        pollFrequency: 1000,
        retries: 100,
        parent: window
    }, _ref$pollFrequency = _ref.pollFrequency, pollFrequency = _ref$pollFrequency === void 0 ? 1000 : _ref$pollFrequency, _ref$retries = _ref.retries, inRetries = _ref$retries === void 0 ? 100 : _ref$retries, _ref$parent = _ref.parent, parent = _ref$parent === void 0 ? window : _ref$parent;
    // eslint-disable-next-line no-prototype-builtins
    if (parent && parent.hasOwnProperty(name)) return Promise.resolve(parent[name]);
    if (!inRetries) return Promise.resolve(undefined);
    var retries = inRetries - 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, typeof pollFrequency === 'function' ? pollFrequency({
            retries: retries
        }) : pollFrequency);
    }).then(function() {
        return waitForVar(name, {
            pollFrequency: pollFrequency,
            parent: parent,
            retries: retries
        });
    });
};
var $fe14646f3f4b6394$var$_default = $fe14646f3f4b6394$var$waitForVar;
module.exports.default = $fe14646f3f4b6394$var$_default;

});



parcelRegister("i5uoL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d2b0461a7763531f$export$bf730a2d8bf68b42; }, function (v) { return $d2b0461a7763531f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2b0461a7763531f$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $d2b0461a7763531f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2b0461a7763531f$var$objectIs = "function" === typeof Object.is ? Object.is : $d2b0461a7763531f$var$is, $d2b0461a7763531f$var$useSyncExternalStore = $7fPBF.useSyncExternalStore, $d2b0461a7763531f$var$useRef = $7fPBF.useRef, $d2b0461a7763531f$var$useEffect = $7fPBF.useEffect, $d2b0461a7763531f$var$useMemo = $7fPBF.useMemo, $d2b0461a7763531f$var$useDebugValue = $7fPBF.useDebugValue;
$d2b0461a7763531f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2b0461a7763531f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2b0461a7763531f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2b0461a7763531f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2b0461a7763531f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2b0461a7763531f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2b0461a7763531f$var$useDebugValue(value);
    return value;
};

});

parcelRegister("SlX8h", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $0a36129e83321387$var$PropTypes = $0a36129e83321387$var$_interopRequireWildcard((parcelRequire("ipO2C")));

var $0a36129e83321387$var$_addClass = $0a36129e83321387$var$_interopRequireDefault((parcelRequire("iXTVh")));

var $0a36129e83321387$var$_removeClass = $0a36129e83321387$var$_interopRequireDefault((parcelRequire("eJV2F")));

var $0a36129e83321387$var$_react = $0a36129e83321387$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0a36129e83321387$var$_Transition = $0a36129e83321387$var$_interopRequireDefault((parcelRequire("a9NWs")));

function $0a36129e83321387$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a36129e83321387$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $0a36129e83321387$var$_extends() {
    $0a36129e83321387$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a36129e83321387$var$_extends.apply(this, arguments);
}
function $0a36129e83321387$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $0a36129e83321387$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $0a36129e83321387$var$_addClass.default)(node, c);
    });
};
var $0a36129e83321387$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $0a36129e83321387$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $0a36129e83321387$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $0a36129e83321387$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            $0a36129e83321387$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            $0a36129e83321387$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            $0a36129e83321387$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            $0a36129e83321387$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $0a36129e83321387$var$removeClass(node, className);
        activeClassName && $0a36129e83321387$var$removeClass(node, activeClassName);
        doneClassName && $0a36129e83321387$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $0a36129e83321387$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $0a36129e83321387$var$_extends({}, this.props);
        delete props.classNames;
        return $0a36129e83321387$var$_react.default.createElement($0a36129e83321387$var$_Transition.default, $0a36129e83321387$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($0a36129e83321387$var$_react.default.Component);
$0a36129e83321387$var$CSSTransition.defaultProps = {
    classNames: ''
};
$0a36129e83321387$var$CSSTransition.propTypes = {};
var $0a36129e83321387$var$_default = $0a36129e83321387$var$CSSTransition;
module.exports.default = $0a36129e83321387$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("ipO2C", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d68160edeace9807$var$ReactIs, $d68160edeace9807$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("djpVb"))();

});
parcelRegister("djpVb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7ejc7 = parcelRequire("7ejc7");
function $9b1128241ca27abf$var$emptyFunction() {}
function $9b1128241ca27abf$var$emptyFunctionWithReset() {}
$9b1128241ca27abf$var$emptyFunctionWithReset.resetWarningCache = $9b1128241ca27abf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7ejc7) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9b1128241ca27abf$var$emptyFunctionWithReset,
        resetWarningCache: $9b1128241ca27abf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7ejc7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5438bad231418d0a$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5438bad231418d0a$var$ReactPropTypesSecret;

});



parcelRegister("iXTVh", function(module, exports) {
"use strict";

var $3K9Sc = parcelRequire("3K9Sc");
module.exports.__esModule = true;
module.exports.default = $dce91dc8274d9282$var$addClass;

var $dce91dc8274d9282$var$_hasClass = $3K9Sc((parcelRequire("bAmcy")));
function $dce91dc8274d9282$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dce91dc8274d9282$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("3K9Sc", function(module, exports) {
function $2b9d5399f9941da4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $2b9d5399f9941da4$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("bAmcy", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $86f4473eba1cf82f$var$hasClass;
function $86f4473eba1cf82f$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("eJV2F", function(module, exports) {
'use strict';
function $abb184095c6243b3$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $abb184095c6243b3$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $abb184095c6243b3$var$replaceClassName(element.className && element.className.baseVal || '', className));
};

});

parcelRegister("a9NWs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $76517c0d4d0884b6$export$1e511d4a378977f5; }, function (v) { return $76517c0d4d0884b6$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $76517c0d4d0884b6$export$2e2bcd8739ae039; }, function (v) { return $76517c0d4d0884b6$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $76517c0d4d0884b6$export$4aacc83d4d59139f; }, function (v) { return $76517c0d4d0884b6$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $76517c0d4d0884b6$export$78e9e6e3e014d60a; }, function (v) { return $76517c0d4d0884b6$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $76517c0d4d0884b6$export$df38205c966be359; }, function (v) { return $76517c0d4d0884b6$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $76517c0d4d0884b6$export$84cbff306f539230; }, function (v) { return $76517c0d4d0884b6$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $76517c0d4d0884b6$export$bb38bb9a1161268; }, function (v) { return $76517c0d4d0884b6$export$bb38bb9a1161268 = v; });
var $76517c0d4d0884b6$export$1e511d4a378977f5;
var $76517c0d4d0884b6$export$2e2bcd8739ae039;
var $76517c0d4d0884b6$export$4aacc83d4d59139f;
var $76517c0d4d0884b6$export$78e9e6e3e014d60a;
var $76517c0d4d0884b6$export$df38205c966be359;
var $76517c0d4d0884b6$export$84cbff306f539230;
var $76517c0d4d0884b6$export$bb38bb9a1161268;
"use strict";
$76517c0d4d0884b6$export$1e511d4a378977f5 = true;
$76517c0d4d0884b6$export$2e2bcd8739ae039 = $76517c0d4d0884b6$export$4aacc83d4d59139f = $76517c0d4d0884b6$export$78e9e6e3e014d60a = $76517c0d4d0884b6$export$df38205c966be359 = $76517c0d4d0884b6$export$84cbff306f539230 = $76517c0d4d0884b6$export$bb38bb9a1161268 = void 0;

var $76517c0d4d0884b6$var$PropTypes = $76517c0d4d0884b6$var$_interopRequireWildcard((parcelRequire("ipO2C")));

var $76517c0d4d0884b6$var$_react = $76517c0d4d0884b6$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $76517c0d4d0884b6$var$_reactDom = $76517c0d4d0884b6$var$_interopRequireDefault((parcelRequire("fw0lo")));

var $gerGz = parcelRequire("gerGz");

function $76517c0d4d0884b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76517c0d4d0884b6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $76517c0d4d0884b6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $76517c0d4d0884b6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $76517c0d4d0884b6$var$UNMOUNTED = 'unmounted';
$76517c0d4d0884b6$export$bb38bb9a1161268 = $76517c0d4d0884b6$var$UNMOUNTED;
var $76517c0d4d0884b6$var$EXITED = 'exited';
$76517c0d4d0884b6$export$84cbff306f539230 = $76517c0d4d0884b6$var$EXITED;
var $76517c0d4d0884b6$var$ENTERING = 'entering';
$76517c0d4d0884b6$export$df38205c966be359 = $76517c0d4d0884b6$var$ENTERING;
var $76517c0d4d0884b6$var$ENTERED = 'entered';
$76517c0d4d0884b6$export$78e9e6e3e014d60a = $76517c0d4d0884b6$var$ENTERED;
var $76517c0d4d0884b6$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $76517c0d4d0884b6$export$4aacc83d4d59139f = $76517c0d4d0884b6$var$EXITING;
var $76517c0d4d0884b6$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $76517c0d4d0884b6$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $76517c0d4d0884b6$var$EXITED;
                _this.appearStatus = $76517c0d4d0884b6$var$ENTERING;
            } else initialStatus = $76517c0d4d0884b6$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $76517c0d4d0884b6$var$UNMOUNTED;
        else initialStatus = $76517c0d4d0884b6$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $76517c0d4d0884b6$var$UNMOUNTED) return {
            status: $76517c0d4d0884b6$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $76517c0d4d0884b6$var$ENTERING && status !== $76517c0d4d0884b6$var$ENTERED) nextStatus = $76517c0d4d0884b6$var$ENTERING;
            } else if (status === $76517c0d4d0884b6$var$ENTERING || status === $76517c0d4d0884b6$var$ENTERED) nextStatus = $76517c0d4d0884b6$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $76517c0d4d0884b6$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $76517c0d4d0884b6$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $76517c0d4d0884b6$var$EXITED) this.setState({
            status: $76517c0d4d0884b6$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $76517c0d4d0884b6$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $76517c0d4d0884b6$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $76517c0d4d0884b6$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $76517c0d4d0884b6$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $76517c0d4d0884b6$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $76517c0d4d0884b6$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $76517c0d4d0884b6$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $76517c0d4d0884b6$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $76517c0d4d0884b6$var$_react.default.Children.only(children);
        return $76517c0d4d0884b6$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($76517c0d4d0884b6$var$_react.default.Component);
$76517c0d4d0884b6$var$Transition.contextTypes = {
    transitionGroup: $76517c0d4d0884b6$var$PropTypes.object
};
$76517c0d4d0884b6$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$76517c0d4d0884b6$var$Transition.propTypes = {};
function $76517c0d4d0884b6$var$noop() {}
$76517c0d4d0884b6$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $76517c0d4d0884b6$var$noop,
    onEntering: $76517c0d4d0884b6$var$noop,
    onEntered: $76517c0d4d0884b6$var$noop,
    onExit: $76517c0d4d0884b6$var$noop,
    onExiting: $76517c0d4d0884b6$var$noop,
    onExited: $76517c0d4d0884b6$var$noop
};
$76517c0d4d0884b6$var$Transition.UNMOUNTED = 0;
$76517c0d4d0884b6$var$Transition.EXITED = 1;
$76517c0d4d0884b6$var$Transition.ENTERING = 2;
$76517c0d4d0884b6$var$Transition.ENTERED = 3;
$76517c0d4d0884b6$var$Transition.EXITING = 4;
var $76517c0d4d0884b6$var$_default = (0, $gerGz.polyfill)($76517c0d4d0884b6$var$Transition);
$76517c0d4d0884b6$export$2e2bcd8739ae039 = $76517c0d4d0884b6$var$_default;

});
parcelRegister("gerGz", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $bd136de90080c1b8$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $bd136de90080c1b8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $bd136de90080c1b8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $bd136de90080c1b8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$bd136de90080c1b8$var$componentWillMount.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $bd136de90080c1b8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $bd136de90080c1b8$var$componentWillMount;
        prototype.componentWillReceiveProps = $bd136de90080c1b8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $bd136de90080c1b8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("er0Gn", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $a8241dd11a590bff$var$_propTypes = $a8241dd11a590bff$var$_interopRequireDefault((parcelRequire("ipO2C")));

var $a8241dd11a590bff$var$_react = $a8241dd11a590bff$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fw0lo = parcelRequire("fw0lo");

var $a8241dd11a590bff$var$_TransitionGroup = $a8241dd11a590bff$var$_interopRequireDefault((parcelRequire("3heAx")));
function $a8241dd11a590bff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8241dd11a590bff$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a8241dd11a590bff$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $a8241dd11a590bff$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $a8241dd11a590bff$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $a8241dd11a590bff$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $fw0lo.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $a8241dd11a590bff$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $a8241dd11a590bff$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $a8241dd11a590bff$var$_react.default.createElement($a8241dd11a590bff$var$_TransitionGroup.default, props, inProp ? $a8241dd11a590bff$var$_react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $a8241dd11a590bff$var$_react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($a8241dd11a590bff$var$_react.default.Component);
$a8241dd11a590bff$var$ReplaceTransition.propTypes = {};
var $a8241dd11a590bff$var$_default = $a8241dd11a590bff$var$ReplaceTransition;
module.exports.default = $a8241dd11a590bff$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("3heAx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $262e468f3dbfd63f$var$_propTypes = $262e468f3dbfd63f$var$_interopRequireDefault((parcelRequire("ipO2C")));

var $262e468f3dbfd63f$var$_react = $262e468f3dbfd63f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $gerGz = parcelRequire("gerGz");

var $05IZX = parcelRequire("05IZX");
function $262e468f3dbfd63f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $262e468f3dbfd63f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $262e468f3dbfd63f$var$_extends() {
    $262e468f3dbfd63f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $262e468f3dbfd63f$var$_extends.apply(this, arguments);
}
function $262e468f3dbfd63f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $262e468f3dbfd63f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $262e468f3dbfd63f$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $262e468f3dbfd63f$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var $262e468f3dbfd63f$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $262e468f3dbfd63f$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($262e468f3dbfd63f$var$_assertThisInitialized($262e468f3dbfd63f$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $05IZX.getInitialChildMapping)(nextProps, handleExited) : (0, $05IZX.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $05IZX.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $262e468f3dbfd63f$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $262e468f3dbfd63f$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $262e468f3dbfd63f$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $262e468f3dbfd63f$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($262e468f3dbfd63f$var$_react.default.Component);
$262e468f3dbfd63f$var$TransitionGroup.childContextTypes = {
    transitionGroup: $262e468f3dbfd63f$var$_propTypes.default.object.isRequired
};
$262e468f3dbfd63f$var$TransitionGroup.propTypes = {};
$262e468f3dbfd63f$var$TransitionGroup.defaultProps = $262e468f3dbfd63f$var$defaultProps;
var $262e468f3dbfd63f$var$_default = (0, $gerGz.polyfill)($262e468f3dbfd63f$var$TransitionGroup);
module.exports.default = $262e468f3dbfd63f$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("05IZX", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $000471062de31223$export$bbc8a025727ea824; }, function (v) { return $000471062de31223$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $000471062de31223$export$fa71e2345c31d7a2; }, function (v) { return $000471062de31223$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $000471062de31223$export$36fd1af28d383ec0; }, function (v) { return $000471062de31223$export$36fd1af28d383ec0 = v; });
var $000471062de31223$export$1e511d4a378977f5;
var $000471062de31223$export$bbc8a025727ea824;
var $000471062de31223$export$7a874f95ccf533dd;
var $000471062de31223$export$fa71e2345c31d7a2;
var $000471062de31223$export$36fd1af28d383ec0;
"use strict";
$000471062de31223$export$1e511d4a378977f5 = true;
$000471062de31223$export$bbc8a025727ea824 = $000471062de31223$var$getChildMapping;
$000471062de31223$export$7a874f95ccf533dd = $000471062de31223$var$mergeChildMappings;
$000471062de31223$export$fa71e2345c31d7a2 = $000471062de31223$var$getInitialChildMapping;
$000471062de31223$export$36fd1af28d383ec0 = $000471062de31223$var$getNextChildMapping;

var $7fPBF = parcelRequire("7fPBF");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $000471062de31223$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $7fPBF.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $000471062de31223$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $000471062de31223$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $000471062de31223$var$getInitialChildMapping(props, onExited) {
    return $000471062de31223$var$getChildMapping(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $000471062de31223$var$getProp(child, 'appear', props),
            enter: $000471062de31223$var$getProp(child, 'enter', props),
            exit: $000471062de31223$var$getProp(child, 'exit', props)
        });
    });
}
function $000471062de31223$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $000471062de31223$var$getChildMapping(nextProps.children);
    var children = $000471062de31223$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $000471062de31223$var$getProp(child, 'exit', nextProps),
            enter: $000471062de31223$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $000471062de31223$var$getProp(child, 'exit', nextProps),
            enter: $000471062de31223$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});



parcelRegister("3oOYd", function(module, exports) {

var $2Znjj = parcelRequire("2Znjj");

var $6FlKk = parcelRequire("6FlKk");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2Znjj.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6FlKk;
module.exports = isBuffer;

});
parcelRegister("2Znjj", function(module, exports) {

var $2EL9N = parcelRequire("2EL9N");
/** Detect free variable `self`. */ var $22d35c42c98f8918$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $22d35c42c98f8918$var$root = $2EL9N || $22d35c42c98f8918$var$freeSelf || Function('return this')();
module.exports = $22d35c42c98f8918$var$root;

});
parcelRegister("2EL9N", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1ef3e59d442ed5e4$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1ef3e59d442ed5e4$var$freeGlobal;

});


parcelRegister("6FlKk", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4da770c5a8514d70$var$stubFalse() {
    return false;
}
module.exports = $4da770c5a8514d70$var$stubFalse;

});


parcelRegister("lpZqS", function(module, exports) {

var $2EL9N = parcelRequire("2EL9N");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2EL9N.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("3kQXm", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("8R7yp"));

});
parcelRegister("8R7yp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_tickFormat.default;
    }
});

var $6729220e2c6ee091$var$_band = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("5r6E7")));

var $6729220e2c6ee091$var$_identity = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("jIfCN")));

var $6729220e2c6ee091$var$_linear = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("4FaxR")));

var $6729220e2c6ee091$var$_log = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("flmZz")));

var $6729220e2c6ee091$var$_symlog = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("ag3bX")));

var $6729220e2c6ee091$var$_ordinal = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("h52bg")));

var $6729220e2c6ee091$var$_pow = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("hGubV")));

var $6729220e2c6ee091$var$_radial = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("lcGR9")));

var $6729220e2c6ee091$var$_quantile = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("cOhVl")));

var $6729220e2c6ee091$var$_quantize = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("gAc3H")));

var $6729220e2c6ee091$var$_threshold = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("g6pLk")));

var $6729220e2c6ee091$var$_time = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("liuou")));

var $6729220e2c6ee091$var$_utcTime = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("7owcD")));

var $6729220e2c6ee091$var$_sequential = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("eI3Nr")));

var $6729220e2c6ee091$var$_sequentialQuantile = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("het6D")));

var $6729220e2c6ee091$var$_diverging = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("3tpu0")));

var $6729220e2c6ee091$var$_tickFormat = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("k0wsE")));
function $6729220e2c6ee091$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6729220e2c6ee091$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6729220e2c6ee091$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6729220e2c6ee091$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6729220e2c6ee091$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("5r6E7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f54a12a49a408b8$var$band;
module.exports.point = $3f54a12a49a408b8$var$point;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");

var $3f54a12a49a408b8$var$_ordinal = $3f54a12a49a408b8$var$_interopRequireDefault((parcelRequire("h52bg")));
function $3f54a12a49a408b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f54a12a49a408b8$var$band() {
    var scale = (0, $3f54a12a49a408b8$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $4GZnA.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $3f54a12a49a408b8$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $2ynOw.initRange.apply(rescale(), arguments);
}
function $3f54a12a49a408b8$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $3f54a12a49a408b8$var$pointish(copy());
    };
    return scale;
}
function $3f54a12a49a408b8$var$point() {
    return $3f54a12a49a408b8$var$pointish($3f54a12a49a408b8$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("4GZnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $a99Jc.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $hhirN.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $hhirN.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $a99Jc.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $a99Jc.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_zip.default;
    }
});

var $36aab2530ad1af8c$var$_bisect = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("4M7Uz")));

var $36aab2530ad1af8c$var$_ascending = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $36aab2530ad1af8c$var$_bisector = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dkE5I")));

var $36aab2530ad1af8c$var$_count = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $36aab2530ad1af8c$var$_cross = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("4xqnz")));

var $36aab2530ad1af8c$var$_cumsum = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ctqkx")));

var $36aab2530ad1af8c$var$_descending = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dm1k6")));

var $36aab2530ad1af8c$var$_deviation = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ceJJg")));

var $36aab2530ad1af8c$var$_extent = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3npVv")));

var $a99Jc = parcelRequire("a99Jc");

var $36aab2530ad1af8c$var$_group = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("bSznb")));

var $36aab2530ad1af8c$var$_groupSort = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("kR7qy")));

var $36aab2530ad1af8c$var$_bin = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("aqqXO")));

var $36aab2530ad1af8c$var$_freedmanDiaconis = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8P0oX")));

var $36aab2530ad1af8c$var$_scott = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("vtl6K")));

var $36aab2530ad1af8c$var$_sturges = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hksbO")));

var $36aab2530ad1af8c$var$_max = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("vbPSg")));

var $36aab2530ad1af8c$var$_maxIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("7xRpL")));

var $36aab2530ad1af8c$var$_mean = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("Gwq9r")));

var $36aab2530ad1af8c$var$_median = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("4bAsu")));

var $36aab2530ad1af8c$var$_merge = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("2ZjwD")));

var $36aab2530ad1af8c$var$_min = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("1hOTq")));

var $36aab2530ad1af8c$var$_minIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("eFUjb")));

var $36aab2530ad1af8c$var$_mode = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("bB075")));

var $36aab2530ad1af8c$var$_nice = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("1h8vr")));

var $36aab2530ad1af8c$var$_pairs = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3nwtE")));

var $36aab2530ad1af8c$var$_permute = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("gTjer")));

var $36aab2530ad1af8c$var$_quantile = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("bhvsA")));

var $36aab2530ad1af8c$var$_quickselect = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dxKAb")));

var $36aab2530ad1af8c$var$_range = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("d5xzE")));

var $36aab2530ad1af8c$var$_rank = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ehEFf")));

var $36aab2530ad1af8c$var$_least = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("j03gz")));

var $36aab2530ad1af8c$var$_leastIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("bEZCr")));

var $36aab2530ad1af8c$var$_greatest = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3JjDZ")));

var $36aab2530ad1af8c$var$_greatestIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8H1FG")));

var $36aab2530ad1af8c$var$_scan = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hYxed")));

var $36aab2530ad1af8c$var$_shuffle = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("82rhF")));

var $36aab2530ad1af8c$var$_sum = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("xtV25")));

var $36aab2530ad1af8c$var$_ticks = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("kOhXV")));

var $36aab2530ad1af8c$var$_transpose = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("kDL1M")));

var $36aab2530ad1af8c$var$_variance = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("fW2SY")));

var $36aab2530ad1af8c$var$_zip = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("k40UO")));

var $36aab2530ad1af8c$var$_every = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("Y6qD3")));

var $36aab2530ad1af8c$var$_some = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("gd6yj")));

var $36aab2530ad1af8c$var$_filter = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("iRlqI")));

var $36aab2530ad1af8c$var$_map = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("9E9DK")));

var $36aab2530ad1af8c$var$_reduce = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("eZC5Z")));

var $36aab2530ad1af8c$var$_reverse = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hG6O3")));

var $36aab2530ad1af8c$var$_sort = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hgC45")));

var $36aab2530ad1af8c$var$_difference = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("b6Lvf")));

var $36aab2530ad1af8c$var$_disjoint = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("en2ry")));

var $36aab2530ad1af8c$var$_intersection = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("i2gjq")));

var $36aab2530ad1af8c$var$_subset = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("f4rHD")));

var $36aab2530ad1af8c$var$_superset = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8VkGe")));

var $36aab2530ad1af8c$var$_union = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8bE4f")));

var $hhirN = parcelRequire("hhirN");
function $36aab2530ad1af8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36aab2530ad1af8c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36aab2530ad1af8c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36aab2530ad1af8c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36aab2530ad1af8c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("4M7Uz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $37a1c82852dde731$var$_ascending = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $37a1c82852dde731$var$_bisector = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("dkE5I")));

var $37a1c82852dde731$var$_number = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("7i5Zp")));
function $37a1c82852dde731$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $37a1c82852dde731$var$ascendingBisect = (0, $37a1c82852dde731$var$_bisector.default)($37a1c82852dde731$var$_ascending.default);
const $37a1c82852dde731$var$bisectRight = $37a1c82852dde731$var$ascendingBisect.right;
module.exports.bisectRight = $37a1c82852dde731$var$bisectRight;
const $37a1c82852dde731$var$bisectLeft = $37a1c82852dde731$var$ascendingBisect.left;
module.exports.bisectLeft = $37a1c82852dde731$var$bisectLeft;
const $37a1c82852dde731$var$bisectCenter = (0, $37a1c82852dde731$var$_bisector.default)($37a1c82852dde731$var$_number.default).center;
module.exports.bisectCenter = $37a1c82852dde731$var$bisectCenter;
var $37a1c82852dde731$var$_default = $37a1c82852dde731$var$bisectRight;
module.exports.default = $37a1c82852dde731$var$_default;

});
parcelRegister("2lEQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b5d3b6847600917$var$ascending;
function $1b5d3b6847600917$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("dkE5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b4c3de18292214c$var$bisector;

var $9b4c3de18292214c$var$_ascending = $9b4c3de18292214c$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $9b4c3de18292214c$var$_descending = $9b4c3de18292214c$var$_interopRequireDefault((parcelRequire("dm1k6")));
function $9b4c3de18292214c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b4c3de18292214c$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $9b4c3de18292214c$var$_ascending.default;
        compare2 = (d, x)=>(0, $9b4c3de18292214c$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $9b4c3de18292214c$var$_ascending.default || f === $9b4c3de18292214c$var$_descending.default ? f : $9b4c3de18292214c$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $9b4c3de18292214c$var$zero() {
    return 0;
}

});
parcelRegister("dm1k6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b8e5b36101417ff$var$descending;
function $9b8e5b36101417ff$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("7i5Zp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54eedc354d42d77a$var$number;
module.exports.numbers = $54eedc354d42d77a$var$numbers;
function $54eedc354d42d77a$var$number(x) {
    return x === null ? NaN : +x;
}
function* $54eedc354d42d77a$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("hRGKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0188c04fdffb31d$var$count;
function $d0188c04fdffb31d$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("4xqnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34deb4dd747ec6fa$var$cross;
function $34deb4dd747ec6fa$var$length(array) {
    return array.length | 0;
}
function $34deb4dd747ec6fa$var$empty(length) {
    return !(length > 0);
}
function $34deb4dd747ec6fa$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $34deb4dd747ec6fa$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $34deb4dd747ec6fa$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $34deb4dd747ec6fa$var$reducer(values.pop());
    values = values.map($34deb4dd747ec6fa$var$arrayify);
    const lengths = values.map($34deb4dd747ec6fa$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($34deb4dd747ec6fa$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("ctqkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $914c9e21f2d92e7b$var$cumsum;
function $914c9e21f2d92e7b$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("ceJJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e8a43aeed62cf45$var$deviation;

var $8e8a43aeed62cf45$var$_variance = $8e8a43aeed62cf45$var$_interopRequireDefault((parcelRequire("fW2SY")));
function $8e8a43aeed62cf45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8e8a43aeed62cf45$var$deviation(values, valueof) {
    const v = (0, $8e8a43aeed62cf45$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("fW2SY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b99e82d2da32169b$var$variance;
function $b99e82d2da32169b$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3npVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2757a189477a9784$var$extent;
function $2757a189477a9784$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("a99Jc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $76324a701e783bf0$var$fcumsum;
module.exports.fsum = $76324a701e783bf0$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $76324a701e783bf0$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $76324a701e783bf0$var$Adder;
function $76324a701e783bf0$var$fsum(values, valueof) {
    const adder = new $76324a701e783bf0$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $76324a701e783bf0$var$fcumsum(values, valueof) {
    const adder = new $76324a701e783bf0$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("bSznb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a602d299971b506$var$group;
module.exports.flatGroup = $8a602d299971b506$var$flatGroup;
module.exports.flatRollup = $8a602d299971b506$var$flatRollup;
module.exports.groups = $8a602d299971b506$var$groups;
module.exports.index = $8a602d299971b506$var$index;
module.exports.indexes = $8a602d299971b506$var$indexes;
module.exports.rollup = $8a602d299971b506$var$rollup;
module.exports.rollups = $8a602d299971b506$var$rollups;

var $hhirN = parcelRequire("hhirN");

var $8a602d299971b506$var$_identity = $8a602d299971b506$var$_interopRequireDefault((parcelRequire("jERUI")));
function $8a602d299971b506$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a602d299971b506$var$group(values, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, $8a602d299971b506$var$_identity.default, keys);
}
function $8a602d299971b506$var$groups(values, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, $8a602d299971b506$var$_identity.default, keys);
}
function $8a602d299971b506$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8a602d299971b506$var$flatGroup(values, ...keys) {
    return $8a602d299971b506$var$flatten($8a602d299971b506$var$groups(values, ...keys), keys);
}
function $8a602d299971b506$var$flatRollup(values, reduce, ...keys) {
    return $8a602d299971b506$var$flatten($8a602d299971b506$var$rollups(values, reduce, ...keys), keys);
}
function $8a602d299971b506$var$rollup(values, reduce, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, reduce, keys);
}
function $8a602d299971b506$var$rollups(values, reduce, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, reduce, keys);
}
function $8a602d299971b506$var$index(values, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, $8a602d299971b506$var$unique, keys);
}
function $8a602d299971b506$var$indexes(values, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, $8a602d299971b506$var$unique, keys);
}
function $8a602d299971b506$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8a602d299971b506$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $hhirN.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("hhirN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $033f0160e9b7bb24$var$InternMap extends Map {
    constructor(entries, key = $033f0160e9b7bb24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($033f0160e9b7bb24$var$intern_get(this, key));
    }
    has(key) {
        return super.has($033f0160e9b7bb24$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($033f0160e9b7bb24$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($033f0160e9b7bb24$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $033f0160e9b7bb24$var$InternMap;
class $033f0160e9b7bb24$var$InternSet extends Set {
    constructor(values, key = $033f0160e9b7bb24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($033f0160e9b7bb24$var$intern_get(this, value));
    }
    add(value) {
        return super.add($033f0160e9b7bb24$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($033f0160e9b7bb24$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $033f0160e9b7bb24$var$InternSet;
function $033f0160e9b7bb24$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $033f0160e9b7bb24$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $033f0160e9b7bb24$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $033f0160e9b7bb24$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("jERUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4fb92dffce86d8a$var$identity;
function $e4fb92dffce86d8a$var$identity(x) {
    return x;
}

});


parcelRegister("kR7qy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2ee84cf0f5d5024$var$groupSort;

var $f2ee84cf0f5d5024$var$_ascending = $f2ee84cf0f5d5024$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $f2ee84cf0f5d5024$var$_group = $f2ee84cf0f5d5024$var$_interopRequireWildcard((parcelRequire("bSznb")));

var $f2ee84cf0f5d5024$var$_sort = $f2ee84cf0f5d5024$var$_interopRequireDefault((parcelRequire("hgC45")));
function $f2ee84cf0f5d5024$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2ee84cf0f5d5024$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2ee84cf0f5d5024$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2ee84cf0f5d5024$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f2ee84cf0f5d5024$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2ee84cf0f5d5024$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $f2ee84cf0f5d5024$var$_sort.default)((0, $f2ee84cf0f5d5024$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $f2ee84cf0f5d5024$var$_ascending.default)(av, bv) || (0, $f2ee84cf0f5d5024$var$_ascending.default)(ak, bk)) : (0, $f2ee84cf0f5d5024$var$_sort.default)((0, $f2ee84cf0f5d5024$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $f2ee84cf0f5d5024$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("hgC45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $033e79a1d1467d65$var$ascendingDefined;
module.exports.compareDefined = $033e79a1d1467d65$var$compareDefined;
module.exports.default = $033e79a1d1467d65$var$sort;

var $033e79a1d1467d65$var$_ascending = $033e79a1d1467d65$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $033e79a1d1467d65$var$_permute = $033e79a1d1467d65$var$_interopRequireDefault((parcelRequire("gTjer")));
function $033e79a1d1467d65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $033e79a1d1467d65$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $033e79a1d1467d65$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$033e79a1d1467d65$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $033e79a1d1467d65$var$_permute.default)(values, index);
    }
    return values.sort($033e79a1d1467d65$var$compareDefined(f));
}
function $033e79a1d1467d65$var$compareDefined(compare = $033e79a1d1467d65$var$_ascending.default) {
    if (compare === $033e79a1d1467d65$var$_ascending.default) return $033e79a1d1467d65$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $033e79a1d1467d65$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("gTjer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4c0b3735af93600$var$permute;
function $c4c0b3735af93600$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("aqqXO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79713f82feaa4be7$var$bin;

var $2MAwv = parcelRequire("2MAwv");

var $79713f82feaa4be7$var$_bisect = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("4M7Uz")));

var $79713f82feaa4be7$var$_constant = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("bGo2G")));

var $79713f82feaa4be7$var$_extent = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("3npVv")));

var $79713f82feaa4be7$var$_identity = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("jERUI")));

var $79713f82feaa4be7$var$_nice = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("1h8vr")));

var $79713f82feaa4be7$var$_ticks = $79713f82feaa4be7$var$_interopRequireWildcard((parcelRequire("kOhXV")));

var $79713f82feaa4be7$var$_sturges = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("hksbO")));
function $79713f82feaa4be7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($79713f82feaa4be7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $79713f82feaa4be7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $79713f82feaa4be7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $79713f82feaa4be7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79713f82feaa4be7$var$bin() {
    var value = $79713f82feaa4be7$var$_identity.default, domain = $79713f82feaa4be7$var$_extent.default, threshold = $79713f82feaa4be7$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $79713f82feaa4be7$var$_extent.default) [x0, x1] = (0, $79713f82feaa4be7$var$_nice.default)(x0, x1, tn);
            tz = (0, $79713f82feaa4be7$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $79713f82feaa4be7$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $79713f82feaa4be7$var$_extent.default) {
                    const step = (0, $79713f82feaa4be7$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $79713f82feaa4be7$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $79713f82feaa4be7$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $79713f82feaa4be7$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $79713f82feaa4be7$var$_constant.default)($2MAwv.slice.call(_)) : (0, $79713f82feaa4be7$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("2MAwv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $206c653bb511c5d8$var$array = Array.prototype;
var $206c653bb511c5d8$var$slice = $206c653bb511c5d8$var$array.slice;
module.exports.slice = $206c653bb511c5d8$var$slice;
var $206c653bb511c5d8$var$map = $206c653bb511c5d8$var$array.map;
module.exports.map = $206c653bb511c5d8$var$map;

});

parcelRegister("bGo2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88164442c1958e67$var$constant;
function $88164442c1958e67$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("1h8vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0eddfa20e4e2d516$var$nice;

var $kOhXV = parcelRequire("kOhXV");
function $0eddfa20e4e2d516$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $kOhXV.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("kOhXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f26669c3fa600501$var$ticks;
module.exports.tickIncrement = $f26669c3fa600501$var$tickIncrement;
module.exports.tickStep = $f26669c3fa600501$var$tickStep;
var $f26669c3fa600501$var$e10 = Math.sqrt(50), $f26669c3fa600501$var$e5 = Math.sqrt(10), $f26669c3fa600501$var$e2 = Math.sqrt(2);
function $f26669c3fa600501$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $f26669c3fa600501$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $f26669c3fa600501$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $f26669c3fa600501$var$e10 ? 10 : error >= $f26669c3fa600501$var$e5 ? 5 : error >= $f26669c3fa600501$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $f26669c3fa600501$var$e10 ? 10 : error >= $f26669c3fa600501$var$e5 ? 5 : error >= $f26669c3fa600501$var$e2 ? 2 : 1);
}
function $f26669c3fa600501$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $f26669c3fa600501$var$e10) step1 *= 10;
    else if (error >= $f26669c3fa600501$var$e5) step1 *= 5;
    else if (error >= $f26669c3fa600501$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("hksbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9da2bc89b5a15f8$var$thresholdSturges;

var $c9da2bc89b5a15f8$var$_count = $c9da2bc89b5a15f8$var$_interopRequireDefault((parcelRequire("hRGKw")));
function $c9da2bc89b5a15f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9da2bc89b5a15f8$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $c9da2bc89b5a15f8$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("8P0oX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66c365e8c897f2dc$var$thresholdFreedmanDiaconis;

var $66c365e8c897f2dc$var$_count = $66c365e8c897f2dc$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $66c365e8c897f2dc$var$_quantile = $66c365e8c897f2dc$var$_interopRequireDefault((parcelRequire("bhvsA")));
function $66c365e8c897f2dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $66c365e8c897f2dc$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $66c365e8c897f2dc$var$_quantile.default)(values, 0.75) - (0, $66c365e8c897f2dc$var$_quantile.default)(values, 0.25)) * Math.pow((0, $66c365e8c897f2dc$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("bhvsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8369af8e0b9f9379$var$quantile;
module.exports.quantileSorted = $8369af8e0b9f9379$var$quantileSorted;

var $8369af8e0b9f9379$var$_max = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("vbPSg")));

var $8369af8e0b9f9379$var$_min = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("1hOTq")));

var $8369af8e0b9f9379$var$_quickselect = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("dxKAb")));

var $8369af8e0b9f9379$var$_number = $8369af8e0b9f9379$var$_interopRequireWildcard((parcelRequire("7i5Zp")));
function $8369af8e0b9f9379$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8369af8e0b9f9379$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8369af8e0b9f9379$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8369af8e0b9f9379$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8369af8e0b9f9379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8369af8e0b9f9379$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $8369af8e0b9f9379$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $8369af8e0b9f9379$var$_min.default)(values);
    if (p >= 1) return (0, $8369af8e0b9f9379$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $8369af8e0b9f9379$var$_max.default)((0, $8369af8e0b9f9379$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $8369af8e0b9f9379$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $8369af8e0b9f9379$var$quantileSorted(values, p, valueof = $8369af8e0b9f9379$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("vbPSg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05dc13af475ff7cb$var$max;
function $05dc13af475ff7cb$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("1hOTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0efedb439da19086$var$min;
function $0efedb439da19086$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("dxKAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dc27dc6445ab9e8$var$quickselect;

var $hgC45 = parcelRequire("hgC45");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $9dc27dc6445ab9e8$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $hgC45.ascendingDefined : (0, $hgC45.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $9dc27dc6445ab9e8$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $9dc27dc6445ab9e8$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $9dc27dc6445ab9e8$var$swap(array, left, right);
        while(i < j){
            $9dc27dc6445ab9e8$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $9dc27dc6445ab9e8$var$swap(array, left, j);
        else ++j, $9dc27dc6445ab9e8$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $9dc27dc6445ab9e8$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("vtl6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05e9a791a39a53a5$var$thresholdScott;

var $05e9a791a39a53a5$var$_count = $05e9a791a39a53a5$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $05e9a791a39a53a5$var$_deviation = $05e9a791a39a53a5$var$_interopRequireDefault((parcelRequire("ceJJg")));
function $05e9a791a39a53a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05e9a791a39a53a5$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $05e9a791a39a53a5$var$_count.default)(values)) / (3.49 * (0, $05e9a791a39a53a5$var$_deviation.default)(values)));
}

});

parcelRegister("7xRpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57e50c7b5f45144c$var$maxIndex;
function $57e50c7b5f45144c$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("Gwq9r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07fd1274087ca853$var$mean;
function $07fd1274087ca853$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("4bAsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30c478680551cdd7$var$median;

var $30c478680551cdd7$var$_quantile = $30c478680551cdd7$var$_interopRequireDefault((parcelRequire("bhvsA")));
function $30c478680551cdd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30c478680551cdd7$var$median(values, valueof) {
    return (0, $30c478680551cdd7$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("2ZjwD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22d06c9e9e3c5040$var$merge;
function* $22d06c9e9e3c5040$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $22d06c9e9e3c5040$var$merge(arrays) {
    return Array.from($22d06c9e9e3c5040$var$flatten(arrays));
}

});

parcelRegister("eFUjb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aaf092b80f23fae3$var$minIndex;
function $aaf092b80f23fae3$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("bB075", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87133ceb39874fd1$var$mode;

var $hhirN = parcelRequire("hhirN");
function $87133ceb39874fd1$var$mode(values, valueof) {
    const counts = new $hhirN.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("3nwtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $275cb6627da79e21$var$pairs;
module.exports.pair = $275cb6627da79e21$var$pair;
function $275cb6627da79e21$var$pairs(values, pairof = $275cb6627da79e21$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $275cb6627da79e21$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("d5xzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9875c915027cc5b4$var$range;
function $9875c915027cc5b4$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ehEFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a66232503b32746d$var$rank;

var $a66232503b32746d$var$_ascending = $a66232503b32746d$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $hgC45 = parcelRequire("hgC45");
function $a66232503b32746d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a66232503b32746d$var$rank(values, valueof = $a66232503b32746d$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $a66232503b32746d$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $a66232503b32746d$var$_ascending.default ? (i, j)=>(0, $hgC45.ascendingDefined)(V[i], V[j]) : (0, $hgC45.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("j03gz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd508d08dceb6479$var$least;

var $dd508d08dceb6479$var$_ascending = $dd508d08dceb6479$var$_interopRequireDefault((parcelRequire("2lEQV")));
function $dd508d08dceb6479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd508d08dceb6479$var$least(values, compare = $dd508d08dceb6479$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $dd508d08dceb6479$var$_ascending.default)(value, minValue) < 0 : (0, $dd508d08dceb6479$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("bEZCr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87d33a5da3f0ca4f$var$leastIndex;

var $87d33a5da3f0ca4f$var$_ascending = $87d33a5da3f0ca4f$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $87d33a5da3f0ca4f$var$_minIndex = $87d33a5da3f0ca4f$var$_interopRequireDefault((parcelRequire("eFUjb")));
function $87d33a5da3f0ca4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $87d33a5da3f0ca4f$var$leastIndex(values, compare = $87d33a5da3f0ca4f$var$_ascending.default) {
    if (compare.length === 1) return (0, $87d33a5da3f0ca4f$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("3JjDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b74cff9bd6ebfaa$var$greatest;

var $2b74cff9bd6ebfaa$var$_ascending = $2b74cff9bd6ebfaa$var$_interopRequireDefault((parcelRequire("2lEQV")));
function $2b74cff9bd6ebfaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2b74cff9bd6ebfaa$var$greatest(values, compare = $2b74cff9bd6ebfaa$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $2b74cff9bd6ebfaa$var$_ascending.default)(value, maxValue) > 0 : (0, $2b74cff9bd6ebfaa$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("8H1FG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6543a2c6b692da2d$var$greatestIndex;

var $6543a2c6b692da2d$var$_ascending = $6543a2c6b692da2d$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $6543a2c6b692da2d$var$_maxIndex = $6543a2c6b692da2d$var$_interopRequireDefault((parcelRequire("7xRpL")));
function $6543a2c6b692da2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6543a2c6b692da2d$var$greatestIndex(values, compare = $6543a2c6b692da2d$var$_ascending.default) {
    if (compare.length === 1) return (0, $6543a2c6b692da2d$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("hYxed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d161d0b6657a65bd$var$scan;

var $d161d0b6657a65bd$var$_leastIndex = $d161d0b6657a65bd$var$_interopRequireDefault((parcelRequire("bEZCr")));
function $d161d0b6657a65bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d161d0b6657a65bd$var$scan(values, compare) {
    const index = (0, $d161d0b6657a65bd$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("82rhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $5da3acad04524181$var$shuffler;
var $5da3acad04524181$var$_default = $5da3acad04524181$var$shuffler(Math.random);
module.exports.default = $5da3acad04524181$var$_default;
function $5da3acad04524181$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("xtV25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $064a4a72ceabc92d$var$sum;
function $064a4a72ceabc92d$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("kDL1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f06bede725d46639$var$transpose;

var $f06bede725d46639$var$_min = $f06bede725d46639$var$_interopRequireDefault((parcelRequire("1hOTq")));
function $f06bede725d46639$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f06bede725d46639$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f06bede725d46639$var$_min.default)(matrix, $f06bede725d46639$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f06bede725d46639$var$length(d) {
    return d.length;
}

});

parcelRegister("k40UO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9b4e41c1f1c3269$var$zip;

var $e9b4e41c1f1c3269$var$_transpose = $e9b4e41c1f1c3269$var$_interopRequireDefault((parcelRequire("kDL1M")));
function $e9b4e41c1f1c3269$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9b4e41c1f1c3269$var$zip() {
    return (0, $e9b4e41c1f1c3269$var$_transpose.default)(arguments);
}

});

parcelRegister("Y6qD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b4a9746ee71c635$var$every;
function $0b4a9746ee71c635$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("gd6yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcd2f16f9fa05fcb$var$some;
function $bcd2f16f9fa05fcb$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("iRlqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbadccc7df010b81$var$filter;
function $dbadccc7df010b81$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("9E9DK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $705f53ca570d5396$var$map;
function $705f53ca570d5396$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("eZC5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aea450313d534631$var$reduce;
function $aea450313d534631$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("hG6O3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdeba38505919fca$var$reverse;
function $cdeba38505919fca$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("b6Lvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81651a59e36a351d$var$difference;

var $hhirN = parcelRequire("hhirN");
function $81651a59e36a351d$var$difference(values, ...others) {
    values = new $hhirN.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("en2ry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7651be7664c341c$var$disjoint;

var $hhirN = parcelRequire("hhirN");
function $a7651be7664c341c$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $hhirN.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("i2gjq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2151130835778ed$var$intersection;

var $hhirN = parcelRequire("hhirN");
function $d2151130835778ed$var$intersection(values, ...others) {
    values = new $hhirN.InternSet(values);
    others = others.map($d2151130835778ed$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $d2151130835778ed$var$set(values) {
    return values instanceof $hhirN.InternSet ? values : new $hhirN.InternSet(values);
}

});

parcelRegister("f4rHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af8cb7f1ba53bcc0$var$subset;

var $af8cb7f1ba53bcc0$var$_superset = $af8cb7f1ba53bcc0$var$_interopRequireDefault((parcelRequire("8VkGe")));
function $af8cb7f1ba53bcc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $af8cb7f1ba53bcc0$var$subset(values, other) {
    return (0, $af8cb7f1ba53bcc0$var$_superset.default)(other, values);
}

});
parcelRegister("8VkGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67f3b0441a9d5c76$var$superset;
function $67f3b0441a9d5c76$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $67f3b0441a9d5c76$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $67f3b0441a9d5c76$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $67f3b0441a9d5c76$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("8bE4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f5e6e66c5756b5e$var$union;

var $hhirN = parcelRequire("hhirN");
function $5f5e6e66c5756b5e$var$union(...others) {
    const set = new $hhirN.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("2ynOw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $1dc13ab4490075d6$var$initInterpolator;
module.exports.initRange = $1dc13ab4490075d6$var$initRange;
function $1dc13ab4490075d6$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1dc13ab4490075d6$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("h52bg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6f4985c245b8576$var$ordinal;
module.exports.implicit = void 0;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
const $c6f4985c245b8576$var$implicit = Symbol("implicit");
module.exports.implicit = $c6f4985c245b8576$var$implicit;
function $c6f4985c245b8576$var$ordinal() {
    var index = new $4GZnA.InternMap(), domain = [], range = [], unknown = $c6f4985c245b8576$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $c6f4985c245b8576$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $4GZnA.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c6f4985c245b8576$var$ordinal(domain, range).unknown(unknown);
    };
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("jIfCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e59e3f1fcb9d7f56$var$identity;

var $4FaxR = parcelRequire("4FaxR");

var $e59e3f1fcb9d7f56$var$_number = $e59e3f1fcb9d7f56$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $e59e3f1fcb9d7f56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e59e3f1fcb9d7f56$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $e59e3f1fcb9d7f56$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $e59e3f1fcb9d7f56$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $e59e3f1fcb9d7f56$var$_number.default) : [
        0,
        1
    ];
    return (0, $4FaxR.linearish)(scale);
}

});
parcelRegister("4FaxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36532bd00b31e75f$var$linear;
module.exports.linearish = $36532bd00b31e75f$var$linearish;

var $4GZnA = parcelRequire("4GZnA");

var $36532bd00b31e75f$var$_continuous = $36532bd00b31e75f$var$_interopRequireWildcard((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $36532bd00b31e75f$var$_tickFormat = $36532bd00b31e75f$var$_interopRequireDefault((parcelRequire("k0wsE")));
function $36532bd00b31e75f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36532bd00b31e75f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36532bd00b31e75f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36532bd00b31e75f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36532bd00b31e75f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $36532bd00b31e75f$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $4GZnA.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $36532bd00b31e75f$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $4GZnA.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $36532bd00b31e75f$var$linear() {
    var scale = (0, $36532bd00b31e75f$var$_continuous.default)();
    scale.copy = function() {
        return (0, $36532bd00b31e75f$var$_continuous.copy)(scale, $36532bd00b31e75f$var$linear());
    };
    $2ynOw.initRange.apply(scale, arguments);
    return $36532bd00b31e75f$var$linearish(scale);
}

});
parcelRegister("3biM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $2510f628bcc35e7c$var$copy;
module.exports.default = $2510f628bcc35e7c$var$continuous;
module.exports.identity = $2510f628bcc35e7c$var$identity;
module.exports.transformer = $2510f628bcc35e7c$var$transformer;

var $4GZnA = parcelRequire("4GZnA");

var $bz0rV = parcelRequire("bz0rV");

var $2510f628bcc35e7c$var$_constant = $2510f628bcc35e7c$var$_interopRequireDefault((parcelRequire("8pt7I")));

var $2510f628bcc35e7c$var$_number = $2510f628bcc35e7c$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $2510f628bcc35e7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2510f628bcc35e7c$var$unit = [
    0,
    1
];
function $2510f628bcc35e7c$var$identity(x) {
    return x;
}
function $2510f628bcc35e7c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $2510f628bcc35e7c$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $2510f628bcc35e7c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $2510f628bcc35e7c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $2510f628bcc35e7c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $2510f628bcc35e7c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $2510f628bcc35e7c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $2510f628bcc35e7c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $4GZnA.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $2510f628bcc35e7c$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $2510f628bcc35e7c$var$transformer() {
    var domain = $2510f628bcc35e7c$var$unit, range = $2510f628bcc35e7c$var$unit, interpolate = $bz0rV.interpolate, transform, untransform, unknown, clamp = $2510f628bcc35e7c$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $2510f628bcc35e7c$var$identity) clamp = $2510f628bcc35e7c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $2510f628bcc35e7c$var$polymap : $2510f628bcc35e7c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $bz0rV.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $2510f628bcc35e7c$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $bz0rV.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $2510f628bcc35e7c$var$identity, rescale()) : clamp !== $2510f628bcc35e7c$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $2510f628bcc35e7c$var$continuous() {
    return $2510f628bcc35e7c$var$transformer()($2510f628bcc35e7c$var$identity, $2510f628bcc35e7c$var$identity);
}

});
parcelRegister("bz0rV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $9DSJ2.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $9DSJ2.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_quantize.default;
    }
});

var $86b34fd171bfa729$var$_value = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("krToF")));

var $86b34fd171bfa729$var$_array = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("hqZ5Y")));

var $86b34fd171bfa729$var$_basis = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("6Uq4F")));

var $86b34fd171bfa729$var$_basisClosed = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("7Sfex")));

var $86b34fd171bfa729$var$_date = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("liOzy")));

var $86b34fd171bfa729$var$_discrete = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("gHnr2")));

var $86b34fd171bfa729$var$_hue = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("bbChc")));

var $86b34fd171bfa729$var$_number = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $86b34fd171bfa729$var$_numberArray = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("aasbI")));

var $86b34fd171bfa729$var$_object = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("8YYHC")));

var $86b34fd171bfa729$var$_round = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("6mXAE")));

var $86b34fd171bfa729$var$_string = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("iWrr1")));

var $9DSJ2 = parcelRequire("9DSJ2");

var $86b34fd171bfa729$var$_zoom = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("dCTOn")));

var $86b34fd171bfa729$var$_rgb = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("juHTK")));

var $86b34fd171bfa729$var$_hsl = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("1BBX0")));

var $86b34fd171bfa729$var$_lab = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("2yIWn")));

var $86b34fd171bfa729$var$_hcl = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("13cFy")));

var $86b34fd171bfa729$var$_cubehelix = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("kDPUk")));

var $86b34fd171bfa729$var$_piecewise = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("4M1Jk")));

var $86b34fd171bfa729$var$_quantize = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("2F9Z0")));
function $86b34fd171bfa729$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($86b34fd171bfa729$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $86b34fd171bfa729$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $86b34fd171bfa729$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $86b34fd171bfa729$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("krToF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee314cee8b851bb7$var$_default;

var $7nMqJ = parcelRequire("7nMqJ");

var $ee314cee8b851bb7$var$_rgb = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("juHTK")));

var $hqZ5Y = parcelRequire("hqZ5Y");

var $ee314cee8b851bb7$var$_date = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("liOzy")));

var $ee314cee8b851bb7$var$_number = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $ee314cee8b851bb7$var$_object = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("8YYHC")));

var $ee314cee8b851bb7$var$_string = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("iWrr1")));

var $ee314cee8b851bb7$var$_constant = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("jOQo6")));

var $ee314cee8b851bb7$var$_numberArray = $ee314cee8b851bb7$var$_interopRequireWildcard((parcelRequire("aasbI")));
function $ee314cee8b851bb7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ee314cee8b851bb7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ee314cee8b851bb7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ee314cee8b851bb7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ee314cee8b851bb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee314cee8b851bb7$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ee314cee8b851bb7$var$_constant.default)(b) : (t === "number" ? $ee314cee8b851bb7$var$_number.default : t === "string" ? (c = (0, $7nMqJ.color)(b)) ? (b = c, $ee314cee8b851bb7$var$_rgb.default) : $ee314cee8b851bb7$var$_string.default : b instanceof $7nMqJ.color ? $ee314cee8b851bb7$var$_rgb.default : b instanceof Date ? $ee314cee8b851bb7$var$_date.default : (0, $ee314cee8b851bb7$var$_numberArray.isNumberArray)(b) ? $ee314cee8b851bb7$var$_numberArray.default : Array.isArray(b) ? $hqZ5Y.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $ee314cee8b851bb7$var$_object.default : $ee314cee8b851bb7$var$_number.default)(a, b);
}

});
parcelRegister("7nMqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.rgb;
    }
});

var $56003f985569a82b$var$_color = $56003f985569a82b$var$_interopRequireWildcard((parcelRequire("jst6s")));

var $56003f985569a82b$var$_lab = $56003f985569a82b$var$_interopRequireWildcard((parcelRequire("hYvKz")));

var $56003f985569a82b$var$_cubehelix = $56003f985569a82b$var$_interopRequireDefault((parcelRequire("hcDPw")));
function $56003f985569a82b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56003f985569a82b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($56003f985569a82b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $56003f985569a82b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $56003f985569a82b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jst6s", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("gkBHR")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("gkBHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be3bc355a3a2784d$var$_default;
module.exports.extend = $be3bc355a3a2784d$var$extend;
function $be3bc355a3a2784d$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $be3bc355a3a2784d$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("hYvKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $d160ab31cd9c50d2$var$Hcl;
module.exports.Lab = $d160ab31cd9c50d2$var$Lab;
module.exports.default = $d160ab31cd9c50d2$var$lab;
module.exports.gray = $d160ab31cd9c50d2$var$gray;
module.exports.hcl = $d160ab31cd9c50d2$var$hcl;
module.exports.lch = $d160ab31cd9c50d2$var$lch;

var $d160ab31cd9c50d2$var$_define = $d160ab31cd9c50d2$var$_interopRequireWildcard((parcelRequire("gkBHR")));

var $jst6s = parcelRequire("jst6s");

var $jD5Rl = parcelRequire("jD5Rl");
function $d160ab31cd9c50d2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d160ab31cd9c50d2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d160ab31cd9c50d2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d160ab31cd9c50d2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $d160ab31cd9c50d2$var$K = 18, $d160ab31cd9c50d2$var$Xn = 0.96422, $d160ab31cd9c50d2$var$Yn = 1, $d160ab31cd9c50d2$var$Zn = 0.82521, $d160ab31cd9c50d2$var$t0 = 4 / 29, $d160ab31cd9c50d2$var$t1 = 6 / 29, $d160ab31cd9c50d2$var$t2 = 3 * $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1, $d160ab31cd9c50d2$var$t3 = $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1;
function $d160ab31cd9c50d2$var$labConvert(o) {
    if (o instanceof $d160ab31cd9c50d2$var$Lab) return new $d160ab31cd9c50d2$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $d160ab31cd9c50d2$var$Hcl) return $d160ab31cd9c50d2$var$hcl2lab(o);
    if (!(o instanceof $jst6s.Rgb)) o = (0, $jst6s.rgbConvert)(o);
    var r = $d160ab31cd9c50d2$var$rgb2lrgb(o.r), g = $d160ab31cd9c50d2$var$rgb2lrgb(o.g), b = $d160ab31cd9c50d2$var$rgb2lrgb(o.b), y = $d160ab31cd9c50d2$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $d160ab31cd9c50d2$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $d160ab31cd9c50d2$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $d160ab31cd9c50d2$var$Xn);
        z = $d160ab31cd9c50d2$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $d160ab31cd9c50d2$var$Zn);
    }
    return new $d160ab31cd9c50d2$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $d160ab31cd9c50d2$var$gray(l, opacity) {
    return new $d160ab31cd9c50d2$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$labConvert(l) : new $d160ab31cd9c50d2$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $d160ab31cd9c50d2$var$_define.default)($d160ab31cd9c50d2$var$Lab, $d160ab31cd9c50d2$var$lab, (0, $d160ab31cd9c50d2$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        return new $d160ab31cd9c50d2$var$Lab(this.l + $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $d160ab31cd9c50d2$var$Lab(this.l - $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $d160ab31cd9c50d2$var$Xn * $d160ab31cd9c50d2$var$lab2xyz(x);
        y = $d160ab31cd9c50d2$var$Yn * $d160ab31cd9c50d2$var$lab2xyz(y);
        z = $d160ab31cd9c50d2$var$Zn * $d160ab31cd9c50d2$var$lab2xyz(z);
        return new $jst6s.Rgb($d160ab31cd9c50d2$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $d160ab31cd9c50d2$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $d160ab31cd9c50d2$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $d160ab31cd9c50d2$var$xyz2lab(t) {
    return t > $d160ab31cd9c50d2$var$t3 ? Math.pow(t, 1 / 3) : t / $d160ab31cd9c50d2$var$t2 + $d160ab31cd9c50d2$var$t0;
}
function $d160ab31cd9c50d2$var$lab2xyz(t) {
    return t > $d160ab31cd9c50d2$var$t1 ? t * t * t : $d160ab31cd9c50d2$var$t2 * (t - $d160ab31cd9c50d2$var$t0);
}
function $d160ab31cd9c50d2$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $d160ab31cd9c50d2$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $d160ab31cd9c50d2$var$hclConvert(o) {
    if (o instanceof $d160ab31cd9c50d2$var$Hcl) return new $d160ab31cd9c50d2$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $d160ab31cd9c50d2$var$Lab)) o = $d160ab31cd9c50d2$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $d160ab31cd9c50d2$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $jD5Rl.degrees;
    return new $d160ab31cd9c50d2$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $d160ab31cd9c50d2$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$hclConvert(l) : new $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$hclConvert(h) : new $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $d160ab31cd9c50d2$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $d160ab31cd9c50d2$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $jD5Rl.radians;
    return new $d160ab31cd9c50d2$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $d160ab31cd9c50d2$var$_define.default)($d160ab31cd9c50d2$var$Hcl, $d160ab31cd9c50d2$var$hcl, (0, $d160ab31cd9c50d2$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        return new $d160ab31cd9c50d2$var$Hcl(this.h, this.c, this.l + $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $d160ab31cd9c50d2$var$Hcl(this.h, this.c, this.l - $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $d160ab31cd9c50d2$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("jD5Rl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $e4a6346126171274$var$radians = Math.PI / 180;
module.exports.radians = $e4a6346126171274$var$radians;
const $e4a6346126171274$var$degrees = 180 / Math.PI;
module.exports.degrees = $e4a6346126171274$var$degrees;

});


parcelRegister("hcDPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $c862741113fdf2e7$var$Cubehelix;
module.exports.default = $c862741113fdf2e7$var$cubehelix;

var $c862741113fdf2e7$var$_define = $c862741113fdf2e7$var$_interopRequireWildcard((parcelRequire("gkBHR")));

var $jst6s = parcelRequire("jst6s");

var $jD5Rl = parcelRequire("jD5Rl");
function $c862741113fdf2e7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c862741113fdf2e7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c862741113fdf2e7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c862741113fdf2e7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c862741113fdf2e7$var$A = -0.14861, $c862741113fdf2e7$var$B = 1.78277, $c862741113fdf2e7$var$C = -0.29227, $c862741113fdf2e7$var$D = -0.90649, $c862741113fdf2e7$var$E = 1.97294, $c862741113fdf2e7$var$ED = $c862741113fdf2e7$var$E * $c862741113fdf2e7$var$D, $c862741113fdf2e7$var$EB = $c862741113fdf2e7$var$E * $c862741113fdf2e7$var$B, $c862741113fdf2e7$var$BC_DA = $c862741113fdf2e7$var$B * $c862741113fdf2e7$var$C - $c862741113fdf2e7$var$D * $c862741113fdf2e7$var$A;
function $c862741113fdf2e7$var$cubehelixConvert(o) {
    if (o instanceof $c862741113fdf2e7$var$Cubehelix) return new $c862741113fdf2e7$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $jst6s.Rgb)) o = (0, $jst6s.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($c862741113fdf2e7$var$BC_DA * b + $c862741113fdf2e7$var$ED * r - $c862741113fdf2e7$var$EB * g) / ($c862741113fdf2e7$var$BC_DA + $c862741113fdf2e7$var$ED - $c862741113fdf2e7$var$EB), bl = b - l, k = ($c862741113fdf2e7$var$E * (g - l) - $c862741113fdf2e7$var$C * bl) / $c862741113fdf2e7$var$D, s = Math.sqrt(k * k + bl * bl) / ($c862741113fdf2e7$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $jD5Rl.degrees - 120 : NaN;
    return new $c862741113fdf2e7$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $c862741113fdf2e7$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $c862741113fdf2e7$var$cubehelixConvert(h) : new $c862741113fdf2e7$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $c862741113fdf2e7$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $c862741113fdf2e7$var$_define.default)($c862741113fdf2e7$var$Cubehelix, $c862741113fdf2e7$var$cubehelix, (0, $c862741113fdf2e7$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        k = k == null ? $jst6s.brighter : Math.pow($jst6s.brighter, k);
        return new $c862741113fdf2e7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $jst6s.darker : Math.pow($jst6s.darker, k);
        return new $c862741113fdf2e7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $jD5Rl.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $jst6s.Rgb(255 * (l + a * ($c862741113fdf2e7$var$A * cosh + $c862741113fdf2e7$var$B * sinh)), 255 * (l + a * ($c862741113fdf2e7$var$C * cosh + $c862741113fdf2e7$var$D * sinh)), 255 * (l + a * ($c862741113fdf2e7$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("juHTK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $e312dee9e21fb749$var$_basis = $e312dee9e21fb749$var$_interopRequireDefault((parcelRequire("6Uq4F")));

var $e312dee9e21fb749$var$_basisClosed = $e312dee9e21fb749$var$_interopRequireDefault((parcelRequire("7Sfex")));

var $e312dee9e21fb749$var$_color = $e312dee9e21fb749$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $e312dee9e21fb749$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e312dee9e21fb749$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e312dee9e21fb749$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e312dee9e21fb749$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e312dee9e21fb749$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e312dee9e21fb749$var$_default = function rgbGamma(y) {
    var color = (0, $e312dee9e21fb749$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7nMqJ.rgb)(start)).r, (end = (0, $7nMqJ.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $e312dee9e21fb749$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $e312dee9e21fb749$var$_default;
function $e312dee9e21fb749$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7nMqJ.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e312dee9e21fb749$var$rgbBasis = $e312dee9e21fb749$var$rgbSpline($e312dee9e21fb749$var$_basis.default);
module.exports.rgbBasis = $e312dee9e21fb749$var$rgbBasis;
var $e312dee9e21fb749$var$rgbBasisClosed = $e312dee9e21fb749$var$rgbSpline($e312dee9e21fb749$var$_basisClosed.default);
module.exports.rgbBasisClosed = $e312dee9e21fb749$var$rgbBasisClosed;

});
parcelRegister("6Uq4F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $507c32dd6d405317$var$basis;
module.exports.default = $507c32dd6d405317$var$_default;
function $507c32dd6d405317$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $507c32dd6d405317$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $507c32dd6d405317$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7Sfex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5bb96499a60f4742$var$_default;

var $6Uq4F = parcelRequire("6Uq4F");
function $5bb96499a60f4742$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6Uq4F.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("fBD2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5c898eeabbd4f34$var$nogamma;
module.exports.gamma = $b5c898eeabbd4f34$var$gamma;
module.exports.hue = $b5c898eeabbd4f34$var$hue;

var $b5c898eeabbd4f34$var$_constant = $b5c898eeabbd4f34$var$_interopRequireDefault((parcelRequire("jOQo6")));
function $b5c898eeabbd4f34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5c898eeabbd4f34$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $b5c898eeabbd4f34$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $b5c898eeabbd4f34$var$hue(a, b) {
    var d = b - a;
    return d ? $b5c898eeabbd4f34$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
}
function $b5c898eeabbd4f34$var$gamma(y) {
    return (y = +y) === 1 ? $b5c898eeabbd4f34$var$nogamma : function(a, b) {
        return b - a ? $b5c898eeabbd4f34$var$exponential(a, b, y) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $b5c898eeabbd4f34$var$nogamma(a, b) {
    var d = b - a;
    return d ? $b5c898eeabbd4f34$var$linear(a, d) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("jOQo6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e6db52f1e1498ecd$var$_default = (x)=>()=>x;
module.exports.default = $e6db52f1e1498ecd$var$_default;

});



parcelRegister("hqZ5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb1441a2fd2df01e$var$_default;
module.exports.genericArray = $cb1441a2fd2df01e$var$genericArray;

var $cb1441a2fd2df01e$var$_value = $cb1441a2fd2df01e$var$_interopRequireDefault((parcelRequire("krToF")));

var $cb1441a2fd2df01e$var$_numberArray = $cb1441a2fd2df01e$var$_interopRequireWildcard((parcelRequire("aasbI")));
function $cb1441a2fd2df01e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cb1441a2fd2df01e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cb1441a2fd2df01e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cb1441a2fd2df01e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cb1441a2fd2df01e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb1441a2fd2df01e$var$_default(a, b) {
    return ((0, $cb1441a2fd2df01e$var$_numberArray.isNumberArray)(b) ? $cb1441a2fd2df01e$var$_numberArray.default : $cb1441a2fd2df01e$var$genericArray)(a, b);
}
function $cb1441a2fd2df01e$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $cb1441a2fd2df01e$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("aasbI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01e90b29a675ec69$var$_default;
module.exports.isNumberArray = $01e90b29a675ec69$var$isNumberArray;
function $01e90b29a675ec69$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $01e90b29a675ec69$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("liOzy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f822820c65d6518b$var$_default;
function $f822820c65d6518b$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("j6Yv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de9d81ecd97de908$var$_default;
function $de9d81ecd97de908$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("8YYHC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68a3039a2958df79$var$_default;

var $68a3039a2958df79$var$_value = $68a3039a2958df79$var$_interopRequireDefault((parcelRequire("krToF")));
function $68a3039a2958df79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68a3039a2958df79$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $68a3039a2958df79$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("iWrr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dca2ecc010113468$var$_default;

var $dca2ecc010113468$var$_number = $dca2ecc010113468$var$_interopRequireDefault((parcelRequire("j6Yv4")));
function $dca2ecc010113468$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dca2ecc010113468$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $dca2ecc010113468$var$reB = new RegExp($dca2ecc010113468$var$reA.source, "g");
function $dca2ecc010113468$var$zero(b) {
    return function() {
        return b;
    };
}
function $dca2ecc010113468$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $dca2ecc010113468$var$_default(a, b) {
    var bi = $dca2ecc010113468$var$reA.lastIndex = $dca2ecc010113468$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $dca2ecc010113468$var$reA.exec(a)) && (bm = $dca2ecc010113468$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $dca2ecc010113468$var$_number.default)(am, bm)
            });
        }
        bi = $dca2ecc010113468$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $dca2ecc010113468$var$one(q[0].x) : $dca2ecc010113468$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("gHnr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c282d73c25c942d9$var$_default;
function $c282d73c25c942d9$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("bbChc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $824e69b3e0110570$var$_default;

var $fBD2K = parcelRequire("fBD2K");
function $824e69b3e0110570$var$_default(a, b) {
    var i = (0, $fBD2K.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("6mXAE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a3305827e38b263$var$_default;
function $4a3305827e38b263$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9DSJ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $705234ec199f0b5b$var$_number = $705234ec199f0b5b$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $kOb2X = parcelRequire("kOb2X");
function $705234ec199f0b5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $705234ec199f0b5b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $705234ec199f0b5b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $705234ec199f0b5b$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $705234ec199f0b5b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $705234ec199f0b5b$var$interpolateTransformCss = $705234ec199f0b5b$var$interpolateTransform($kOb2X.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $705234ec199f0b5b$var$interpolateTransformCss;
var $705234ec199f0b5b$var$interpolateTransformSvg = $705234ec199f0b5b$var$interpolateTransform($kOb2X.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $705234ec199f0b5b$var$interpolateTransformSvg;

});
parcelRegister("kOb2X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $f2610bd1ef2f5885$var$parseCss;
module.exports.parseSvg = $f2610bd1ef2f5885$var$parseSvg;

var $f2610bd1ef2f5885$var$_decompose = $f2610bd1ef2f5885$var$_interopRequireWildcard((parcelRequire("dMHn8")));
function $f2610bd1ef2f5885$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2610bd1ef2f5885$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2610bd1ef2f5885$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2610bd1ef2f5885$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $f2610bd1ef2f5885$var$svgNode;
/* eslint-disable no-undef */ function $f2610bd1ef2f5885$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $f2610bd1ef2f5885$var$_decompose.identity : (0, $f2610bd1ef2f5885$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $f2610bd1ef2f5885$var$parseSvg(value) {
    if (value == null) return $f2610bd1ef2f5885$var$_decompose.identity;
    if (!$f2610bd1ef2f5885$var$svgNode) $f2610bd1ef2f5885$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $f2610bd1ef2f5885$var$svgNode.setAttribute("transform", value);
    if (!(value = $f2610bd1ef2f5885$var$svgNode.transform.baseVal.consolidate())) return $f2610bd1ef2f5885$var$_decompose.identity;
    value = value.matrix;
    return (0, $f2610bd1ef2f5885$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("dMHn8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a09166e25dfdcba9$var$_default;
module.exports.identity = void 0;
var $a09166e25dfdcba9$var$degrees = 180 / Math.PI;
var $a09166e25dfdcba9$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $a09166e25dfdcba9$var$identity;
function $a09166e25dfdcba9$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $a09166e25dfdcba9$var$degrees,
        skewX: Math.atan(skewX) * $a09166e25dfdcba9$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("dCTOn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9eba1df5c12e8184$var$epsilon2 = 1e-12;
function $9eba1df5c12e8184$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $9eba1df5c12e8184$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $9eba1df5c12e8184$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $9eba1df5c12e8184$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $9eba1df5c12e8184$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $9eba1df5c12e8184$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $9eba1df5c12e8184$var$tanh(rho * s + r0) - $9eba1df5c12e8184$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $9eba1df5c12e8184$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $9eba1df5c12e8184$var$_default;

});

parcelRegister("1BBX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $12b6af5a694aca58$var$_color = $12b6af5a694aca58$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $12b6af5a694aca58$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($12b6af5a694aca58$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $12b6af5a694aca58$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $12b6af5a694aca58$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $12b6af5a694aca58$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7nMqJ.hsl)(start)).h, (end = (0, $7nMqJ.hsl)(end)).h), s = (0, $12b6af5a694aca58$var$_color.default)(start.s, end.s), l = (0, $12b6af5a694aca58$var$_color.default)(start.l, end.l), opacity = (0, $12b6af5a694aca58$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $12b6af5a694aca58$var$_default = $12b6af5a694aca58$var$hsl($12b6af5a694aca58$var$_color.hue);
module.exports.default = $12b6af5a694aca58$var$_default;
var $12b6af5a694aca58$var$hslLong = $12b6af5a694aca58$var$hsl($12b6af5a694aca58$var$_color.default);
module.exports.hslLong = $12b6af5a694aca58$var$hslLong;

});

parcelRegister("2yIWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dd19dffc683f201$var$lab;

var $7nMqJ = parcelRequire("7nMqJ");

var $1dd19dffc683f201$var$_color = $1dd19dffc683f201$var$_interopRequireDefault((parcelRequire("fBD2K")));
function $1dd19dffc683f201$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1dd19dffc683f201$var$lab(start, end) {
    var l = (0, $1dd19dffc683f201$var$_color.default)((start = (0, $7nMqJ.lab)(start)).l, (end = (0, $7nMqJ.lab)(end)).l), a = (0, $1dd19dffc683f201$var$_color.default)(start.a, end.a), b = (0, $1dd19dffc683f201$var$_color.default)(start.b, end.b), opacity = (0, $1dd19dffc683f201$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("13cFy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $0c3fe61bcf596cba$var$_color = $0c3fe61bcf596cba$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $0c3fe61bcf596cba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0c3fe61bcf596cba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0c3fe61bcf596cba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0c3fe61bcf596cba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0c3fe61bcf596cba$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7nMqJ.hcl)(start)).h, (end = (0, $7nMqJ.hcl)(end)).h), c = (0, $0c3fe61bcf596cba$var$_color.default)(start.c, end.c), l = (0, $0c3fe61bcf596cba$var$_color.default)(start.l, end.l), opacity = (0, $0c3fe61bcf596cba$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0c3fe61bcf596cba$var$_default = $0c3fe61bcf596cba$var$hcl($0c3fe61bcf596cba$var$_color.hue);
module.exports.default = $0c3fe61bcf596cba$var$_default;
var $0c3fe61bcf596cba$var$hclLong = $0c3fe61bcf596cba$var$hcl($0c3fe61bcf596cba$var$_color.default);
module.exports.hclLong = $0c3fe61bcf596cba$var$hclLong;

});

parcelRegister("kDPUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $f06fb6ebc8929a60$var$_color = $f06fb6ebc8929a60$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $f06fb6ebc8929a60$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f06fb6ebc8929a60$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f06fb6ebc8929a60$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f06fb6ebc8929a60$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f06fb6ebc8929a60$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $7nMqJ.cubehelix)(start)).h, (end = (0, $7nMqJ.cubehelix)(end)).h), s = (0, $f06fb6ebc8929a60$var$_color.default)(start.s, end.s), l = (0, $f06fb6ebc8929a60$var$_color.default)(start.l, end.l), opacity = (0, $f06fb6ebc8929a60$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $f06fb6ebc8929a60$var$_default = $f06fb6ebc8929a60$var$cubehelix($f06fb6ebc8929a60$var$_color.hue);
module.exports.default = $f06fb6ebc8929a60$var$_default;
var $f06fb6ebc8929a60$var$cubehelixLong = $f06fb6ebc8929a60$var$cubehelix($f06fb6ebc8929a60$var$_color.default);
module.exports.cubehelixLong = $f06fb6ebc8929a60$var$cubehelixLong;

});

parcelRegister("4M1Jk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $379cfca9f678715d$var$piecewise;

var $379cfca9f678715d$var$_value = $379cfca9f678715d$var$_interopRequireDefault((parcelRequire("krToF")));
function $379cfca9f678715d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $379cfca9f678715d$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $379cfca9f678715d$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("2F9Z0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f0727849e9b558d$var$_default;
function $1f0727849e9b558d$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("8pt7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61f73fd39961967a$var$constants;
function $61f73fd39961967a$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("7lxKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5594ad34133bb211$var$number;
function $5594ad34133bb211$var$number(x) {
    return +x;
}

});


parcelRegister("k0wsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e90cfcd9d440e77b$var$tickFormat;

var $4GZnA = parcelRequire("4GZnA");

var $iu2fv = parcelRequire("iu2fv");
function $e90cfcd9d440e77b$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $4GZnA.tickStep)(start, stop, count), precision;
    specifier = (0, $iu2fv.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $iu2fv.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $iu2fv.format)(specifier);
}

});
parcelRegister("iu2fv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionRound.default;
    }
});

var $d74cc5f1f4bf5c68$var$_defaultLocale = $d74cc5f1f4bf5c68$var$_interopRequireWildcard((parcelRequire("VtQmC")));

var $d74cc5f1f4bf5c68$var$_locale = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("kveGI")));

var $d74cc5f1f4bf5c68$var$_formatSpecifier = $d74cc5f1f4bf5c68$var$_interopRequireWildcard((parcelRequire("5oDyj")));

var $d74cc5f1f4bf5c68$var$_precisionFixed = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("4Vhlo")));

var $d74cc5f1f4bf5c68$var$_precisionPrefix = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("bi9b1")));

var $d74cc5f1f4bf5c68$var$_precisionRound = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("7sZ1T")));
function $d74cc5f1f4bf5c68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d74cc5f1f4bf5c68$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d74cc5f1f4bf5c68$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d74cc5f1f4bf5c68$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d74cc5f1f4bf5c68$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("VtQmC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0acc794c9056a273$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $0acc794c9056a273$var$_locale = $0acc794c9056a273$var$_interopRequireDefault((parcelRequire("kveGI")));
function $0acc794c9056a273$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0acc794c9056a273$var$locale;
var $0acc794c9056a273$var$format;
module.exports.format = $0acc794c9056a273$var$format;
var $0acc794c9056a273$var$formatPrefix;
module.exports.formatPrefix = $0acc794c9056a273$var$formatPrefix;
$0acc794c9056a273$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $0acc794c9056a273$var$defaultLocale(definition) {
    $0acc794c9056a273$var$locale = (0, $0acc794c9056a273$var$_locale.default)(definition);
    module.exports.format = $0acc794c9056a273$var$format = $0acc794c9056a273$var$locale.format;
    module.exports.formatPrefix = $0acc794c9056a273$var$formatPrefix = $0acc794c9056a273$var$locale.formatPrefix;
    return $0acc794c9056a273$var$locale;
}

});
parcelRegister("kveGI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eed2189d51001e9d$var$_default;

var $eed2189d51001e9d$var$_exponent = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("6aXnW")));

var $eed2189d51001e9d$var$_formatGroup = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("8HiWC")));

var $eed2189d51001e9d$var$_formatNumerals = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("gltmT")));

var $eed2189d51001e9d$var$_formatSpecifier = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("5oDyj")));

var $eed2189d51001e9d$var$_formatTrim = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("eRShH")));

var $eed2189d51001e9d$var$_formatTypes = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("dHAst")));

var $6U7P4 = parcelRequire("6U7P4");

var $eed2189d51001e9d$var$_identity = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("cy8R9")));
function $eed2189d51001e9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eed2189d51001e9d$var$map = Array.prototype.map, $eed2189d51001e9d$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $eed2189d51001e9d$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $eed2189d51001e9d$var$_identity.default : (0, $eed2189d51001e9d$var$_formatGroup.default)($eed2189d51001e9d$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $eed2189d51001e9d$var$_identity.default : (0, $eed2189d51001e9d$var$_formatNumerals.default)($eed2189d51001e9d$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $eed2189d51001e9d$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$eed2189d51001e9d$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $eed2189d51001e9d$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $eed2189d51001e9d$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $eed2189d51001e9d$var$prefixes[8 + $6U7P4.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $eed2189d51001e9d$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $eed2189d51001e9d$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $eed2189d51001e9d$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("6aXnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47f1bde8fe5d07b8$var$_default;

var $8795b = parcelRequire("8795b");
function $47f1bde8fe5d07b8$var$_default(x) {
    return x = (0, $8795b.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("8795b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e8605c69fa1d0e0$var$_default;
module.exports.formatDecimalParts = $5e8605c69fa1d0e0$var$formatDecimalParts;
function $5e8605c69fa1d0e0$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $5e8605c69fa1d0e0$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("8HiWC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $655108d9cb0353fe$var$_default;
function $655108d9cb0353fe$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("gltmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be65636d4b319db0$var$_default;
function $be65636d4b319db0$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("5oDyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $3edddfe92a5cb96a$var$FormatSpecifier;
module.exports.default = $3edddfe92a5cb96a$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $3edddfe92a5cb96a$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $3edddfe92a5cb96a$var$formatSpecifier(specifier) {
    if (!(match = $3edddfe92a5cb96a$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $3edddfe92a5cb96a$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$3edddfe92a5cb96a$var$formatSpecifier.prototype = $3edddfe92a5cb96a$var$FormatSpecifier.prototype; // instanceof
function $3edddfe92a5cb96a$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$3edddfe92a5cb96a$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("eRShH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad301fab84749b83$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $ad301fab84749b83$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("dHAst", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f9b925f823c468a$var$_formatDecimal = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("8795b")));

var $9f9b925f823c468a$var$_formatPrefixAuto = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("6U7P4")));

var $9f9b925f823c468a$var$_formatRounded = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("3HqvL")));
function $9f9b925f823c468a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9f9b925f823c468a$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $9f9b925f823c468a$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $9f9b925f823c468a$var$_formatRounded.default)(x * 100, p),
    "r": $9f9b925f823c468a$var$_formatRounded.default,
    "s": $9f9b925f823c468a$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $9f9b925f823c468a$var$_default;

});
parcelRegister("6U7P4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $506e0a7c5780768a$var$_default;
module.exports.prefixExponent = void 0;

var $8795b = parcelRequire("8795b");
var $506e0a7c5780768a$var$prefixExponent;
module.exports.prefixExponent = $506e0a7c5780768a$var$prefixExponent;
function $506e0a7c5780768a$var$_default(x, p) {
    var d = (0, $8795b.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $506e0a7c5780768a$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $8795b.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("3HqvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b19f3d267add45a$var$_default;

var $8795b = parcelRequire("8795b");
function $2b19f3d267add45a$var$_default(x, p) {
    var d = (0, $8795b.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cy8R9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $922f87b24a082dd8$var$_default;
function $922f87b24a082dd8$var$_default(x) {
    return x;
}

});



parcelRegister("4Vhlo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3959f07794f973d4$var$_default;

var $3959f07794f973d4$var$_exponent = $3959f07794f973d4$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $3959f07794f973d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3959f07794f973d4$var$_default(step) {
    return Math.max(0, -(0, $3959f07794f973d4$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("bi9b1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83887e7bb3549342$var$_default;

var $83887e7bb3549342$var$_exponent = $83887e7bb3549342$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $83887e7bb3549342$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $83887e7bb3549342$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $83887e7bb3549342$var$_exponent.default)(value) / 3))) * 3 - (0, $83887e7bb3549342$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("7sZ1T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56fa7d21d861321e$var$_default;

var $56fa7d21d861321e$var$_exponent = $56fa7d21d861321e$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $56fa7d21d861321e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56fa7d21d861321e$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $56fa7d21d861321e$var$_exponent.default)(max) - (0, $56fa7d21d861321e$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("flmZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2baa6eb7899db10$var$log;
module.exports.loggish = $b2baa6eb7899db10$var$loggish;

var $4GZnA = parcelRequire("4GZnA");

var $iu2fv = parcelRequire("iu2fv");

var $b2baa6eb7899db10$var$_nice = $b2baa6eb7899db10$var$_interopRequireDefault((parcelRequire("e1xvL")));

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $b2baa6eb7899db10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2baa6eb7899db10$var$transformLog(x) {
    return Math.log(x);
}
function $b2baa6eb7899db10$var$transformExp(x) {
    return Math.exp(x);
}
function $b2baa6eb7899db10$var$transformLogn(x) {
    return -Math.log(-x);
}
function $b2baa6eb7899db10$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $b2baa6eb7899db10$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $b2baa6eb7899db10$var$powp(base) {
    return base === 10 ? $b2baa6eb7899db10$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $b2baa6eb7899db10$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $b2baa6eb7899db10$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $b2baa6eb7899db10$var$loggish(transform) {
    const scale = transform($b2baa6eb7899db10$var$transformLog, $b2baa6eb7899db10$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $b2baa6eb7899db10$var$logp(base), pows = $b2baa6eb7899db10$var$powp(base);
        if (domain()[0] < 0) {
            logs = $b2baa6eb7899db10$var$reflect(logs), pows = $b2baa6eb7899db10$var$reflect(pows);
            transform($b2baa6eb7899db10$var$transformLogn, $b2baa6eb7899db10$var$transformExpn);
        } else transform($b2baa6eb7899db10$var$transformLog, $b2baa6eb7899db10$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $4GZnA.ticks)(u, v, n);
        } else z = (0, $4GZnA.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $iu2fv.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $iu2fv.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $b2baa6eb7899db10$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $b2baa6eb7899db10$var$log() {
    const scale = $b2baa6eb7899db10$var$loggish((0, $3biM0.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $3biM0.copy)(scale, $b2baa6eb7899db10$var$log()).base(scale.base());
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("e1xvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35b2756e0b1bbda$var$nice;
function $a35b2756e0b1bbda$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("ag3bX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $777ddfd1aa877f09$var$symlog;
module.exports.symlogish = $777ddfd1aa877f09$var$symlogish;

var $4FaxR = parcelRequire("4FaxR");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $777ddfd1aa877f09$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $777ddfd1aa877f09$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $777ddfd1aa877f09$var$symlogish(transform) {
    var c = 1, scale = transform($777ddfd1aa877f09$var$transformSymlog(c), $777ddfd1aa877f09$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($777ddfd1aa877f09$var$transformSymlog(c = +_), $777ddfd1aa877f09$var$transformSymexp(c)) : c;
    };
    return (0, $4FaxR.linearish)(scale);
}
function $777ddfd1aa877f09$var$symlog() {
    var scale = $777ddfd1aa877f09$var$symlogish((0, $3biM0.transformer)());
    scale.copy = function() {
        return (0, $3biM0.copy)(scale, $777ddfd1aa877f09$var$symlog()).constant(scale.constant());
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("hGubV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdfdc74eb2c00924$var$pow;
module.exports.powish = $cdfdc74eb2c00924$var$powish;
module.exports.sqrt = $cdfdc74eb2c00924$var$sqrt;

var $4FaxR = parcelRequire("4FaxR");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $cdfdc74eb2c00924$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $cdfdc74eb2c00924$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $cdfdc74eb2c00924$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $cdfdc74eb2c00924$var$powish(transform) {
    var scale = transform($3biM0.identity, $3biM0.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($3biM0.identity, $3biM0.identity) : exponent === 0.5 ? transform($cdfdc74eb2c00924$var$transformSqrt, $cdfdc74eb2c00924$var$transformSquare) : transform($cdfdc74eb2c00924$var$transformPow(exponent), $cdfdc74eb2c00924$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4FaxR.linearish)(scale);
}
function $cdfdc74eb2c00924$var$pow() {
    var scale = $cdfdc74eb2c00924$var$powish((0, $3biM0.transformer)());
    scale.copy = function() {
        return (0, $3biM0.copy)(scale, $cdfdc74eb2c00924$var$pow()).exponent(scale.exponent());
    };
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}
function $cdfdc74eb2c00924$var$sqrt() {
    return $cdfdc74eb2c00924$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("lcGR9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6fbf650578f84fb$var$radial;

var $f6fbf650578f84fb$var$_continuous = $f6fbf650578f84fb$var$_interopRequireDefault((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $f6fbf650578f84fb$var$_number = $f6fbf650578f84fb$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $f6fbf650578f84fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6fbf650578f84fb$var$square(x) {
    return Math.sign(x) * x * x;
}
function $f6fbf650578f84fb$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $f6fbf650578f84fb$var$radial() {
    var squared = (0, $f6fbf650578f84fb$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $f6fbf650578f84fb$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($f6fbf650578f84fb$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $f6fbf650578f84fb$var$_number.default)).map($f6fbf650578f84fb$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f6fbf650578f84fb$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $2ynOw.initRange.apply(scale, arguments);
    return (0, $4FaxR.linearish)(scale);
}

});

parcelRegister("cOhVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95380ee05b1658a2$var$quantile;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
function $95380ee05b1658a2$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $4GZnA.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $4GZnA.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($4GZnA.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $95380ee05b1658a2$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("gAc3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1295cbc119c6c8f$var$quantize;

var $4GZnA = parcelRequire("4GZnA");

var $4FaxR = parcelRequire("4FaxR");

var $2ynOw = parcelRequire("2ynOw");
function $c1295cbc119c6c8f$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4GZnA.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $c1295cbc119c6c8f$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply((0, $4FaxR.linearish)(scale), arguments);
}

});

parcelRegister("g6pLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb9130bc7ad2d518$var$threshold;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
function $bb9130bc7ad2d518$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4GZnA.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bb9130bc7ad2d518$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("liuou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $f812db0c35c64a41$var$calendar;
module.exports.default = $f812db0c35c64a41$var$time;

var $5hUYw = parcelRequire("5hUYw");

var $2ew5Z = parcelRequire("2ew5Z");

var $f812db0c35c64a41$var$_continuous = $f812db0c35c64a41$var$_interopRequireWildcard((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $f812db0c35c64a41$var$_nice = $f812db0c35c64a41$var$_interopRequireDefault((parcelRequire("e1xvL")));
function $f812db0c35c64a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f812db0c35c64a41$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f812db0c35c64a41$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f812db0c35c64a41$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f812db0c35c64a41$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f812db0c35c64a41$var$date(t) {
    return new Date(t);
}
function $f812db0c35c64a41$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $f812db0c35c64a41$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f812db0c35c64a41$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $f812db0c35c64a41$var$number)) : domain().map($f812db0c35c64a41$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $f812db0c35c64a41$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f812db0c35c64a41$var$_continuous.copy)(scale, $f812db0c35c64a41$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $f812db0c35c64a41$var$time() {
    return $2ynOw.initRange.apply($f812db0c35c64a41$var$calendar($5hUYw.timeTicks, $5hUYw.timeTickInterval, $5hUYw.timeYear, $5hUYw.timeMonth, $5hUYw.timeWeek, $5hUYw.timeDay, $5hUYw.timeHour, $5hUYw.timeMinute, $5hUYw.timeSecond, $2ew5Z.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("5hUYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $ah8ax.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $ah8ax.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $ah8ax.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $ah8ax.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $ah8ax.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $ah8ax.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $ah8ax.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $ah8ax.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $tUMUf.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $tUMUf.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $ah8ax.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $ah8ax.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $ah8ax.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $ah8ax.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $tUMUf.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $tUMUf.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcYear.utcYears;
    }
});

var $3d9abc5caa349abb$var$_interval = $3d9abc5caa349abb$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $3d9abc5caa349abb$var$_millisecond = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("cK28E")));

var $3d9abc5caa349abb$var$_second = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("jeQEd")));

var $3d9abc5caa349abb$var$_minute = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("kQUOO")));

var $3d9abc5caa349abb$var$_hour = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("6xt90")));

var $3d9abc5caa349abb$var$_day = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("iEyEO")));

var $ah8ax = parcelRequire("ah8ax");

var $3d9abc5caa349abb$var$_month = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("b5xm0")));

var $3d9abc5caa349abb$var$_year = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("hrPSp")));

var $3d9abc5caa349abb$var$_utcMinute = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("d9Trb")));

var $3d9abc5caa349abb$var$_utcHour = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("6XsZh")));

var $3d9abc5caa349abb$var$_utcDay = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("8vTWn")));

var $k4peM = parcelRequire("k4peM");

var $3d9abc5caa349abb$var$_utcMonth = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("lhWn5")));

var $3d9abc5caa349abb$var$_utcYear = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("4w90J")));

var $tUMUf = parcelRequire("tUMUf");
function $3d9abc5caa349abb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3d9abc5caa349abb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3d9abc5caa349abb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3d9abc5caa349abb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3d9abc5caa349abb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("5UfBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44ce484d430577ea$var$newInterval;
var $44ce484d430577ea$var$t0 = new Date(), $44ce484d430577ea$var$t1 = new Date();
function $44ce484d430577ea$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $44ce484d430577ea$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $44ce484d430577ea$var$t0.setTime(+start), $44ce484d430577ea$var$t1.setTime(+end);
            floori($44ce484d430577ea$var$t0), floori($44ce484d430577ea$var$t1);
            return Math.floor(count($44ce484d430577ea$var$t0, $44ce484d430577ea$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("cK28E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $946b7093b1f356c8$var$_interval = $946b7093b1f356c8$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $946b7093b1f356c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $946b7093b1f356c8$var$millisecond = (0, $946b7093b1f356c8$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$946b7093b1f356c8$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $946b7093b1f356c8$var$millisecond;
    return (0, $946b7093b1f356c8$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $946b7093b1f356c8$var$_default = $946b7093b1f356c8$var$millisecond;
module.exports.default = $946b7093b1f356c8$var$_default;
var $946b7093b1f356c8$var$milliseconds = $946b7093b1f356c8$var$millisecond.range;
module.exports.milliseconds = $946b7093b1f356c8$var$milliseconds;

});

parcelRegister("jeQEd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e01829d60cf3b45c$var$_interval = $e01829d60cf3b45c$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $e01829d60cf3b45c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e01829d60cf3b45c$var$second = (0, $e01829d60cf3b45c$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationSecond);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e01829d60cf3b45c$var$_default = $e01829d60cf3b45c$var$second;
module.exports.default = $e01829d60cf3b45c$var$_default;
var $e01829d60cf3b45c$var$seconds = $e01829d60cf3b45c$var$second.range;
module.exports.seconds = $e01829d60cf3b45c$var$seconds;

});
parcelRegister("eX1Lo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $ae27f18f92bd2054$var$durationSecond = 1000;
module.exports.durationSecond = $ae27f18f92bd2054$var$durationSecond;
const $ae27f18f92bd2054$var$durationMinute = $ae27f18f92bd2054$var$durationSecond * 60;
module.exports.durationMinute = $ae27f18f92bd2054$var$durationMinute;
const $ae27f18f92bd2054$var$durationHour = $ae27f18f92bd2054$var$durationMinute * 60;
module.exports.durationHour = $ae27f18f92bd2054$var$durationHour;
const $ae27f18f92bd2054$var$durationDay = $ae27f18f92bd2054$var$durationHour * 24;
module.exports.durationDay = $ae27f18f92bd2054$var$durationDay;
const $ae27f18f92bd2054$var$durationWeek = $ae27f18f92bd2054$var$durationDay * 7;
module.exports.durationWeek = $ae27f18f92bd2054$var$durationWeek;
const $ae27f18f92bd2054$var$durationMonth = $ae27f18f92bd2054$var$durationDay * 30;
module.exports.durationMonth = $ae27f18f92bd2054$var$durationMonth;
const $ae27f18f92bd2054$var$durationYear = $ae27f18f92bd2054$var$durationDay * 365;
module.exports.durationYear = $ae27f18f92bd2054$var$durationYear;

});


parcelRegister("kQUOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $f2e4bcfb5452915b$var$_interval = $f2e4bcfb5452915b$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $f2e4bcfb5452915b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f2e4bcfb5452915b$var$minute = (0, $f2e4bcfb5452915b$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eX1Lo.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationMinute);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $f2e4bcfb5452915b$var$_default = $f2e4bcfb5452915b$var$minute;
module.exports.default = $f2e4bcfb5452915b$var$_default;
var $f2e4bcfb5452915b$var$minutes = $f2e4bcfb5452915b$var$minute.range;
module.exports.minutes = $f2e4bcfb5452915b$var$minutes;

});

parcelRegister("6xt90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $4c2c6e9859205f83$var$_interval = $4c2c6e9859205f83$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $4c2c6e9859205f83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c2c6e9859205f83$var$hour = (0, $4c2c6e9859205f83$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eX1Lo.durationSecond - date.getMinutes() * $eX1Lo.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationHour);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationHour;
}, function(date) {
    return date.getHours();
});
var $4c2c6e9859205f83$var$_default = $4c2c6e9859205f83$var$hour;
module.exports.default = $4c2c6e9859205f83$var$_default;
var $4c2c6e9859205f83$var$hours = $4c2c6e9859205f83$var$hour.range;
module.exports.hours = $4c2c6e9859205f83$var$hours;

});

parcelRegister("iEyEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $d946d89e1c77f855$var$_interval = $d946d89e1c77f855$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $d946d89e1c77f855$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d946d89e1c77f855$var$day = (0, $d946d89e1c77f855$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eX1Lo.durationMinute) / $eX1Lo.durationDay, (date)=>date.getDate() - 1);
var $d946d89e1c77f855$var$_default = $d946d89e1c77f855$var$day;
module.exports.default = $d946d89e1c77f855$var$_default;
var $d946d89e1c77f855$var$days = $d946d89e1c77f855$var$day.range;
module.exports.days = $d946d89e1c77f855$var$days;

});

parcelRegister("ah8ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $77b1d41ad42b9c2e$var$_interval = $77b1d41ad42b9c2e$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $77b1d41ad42b9c2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $77b1d41ad42b9c2e$var$weekday(i) {
    return (0, $77b1d41ad42b9c2e$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eX1Lo.durationMinute) / $eX1Lo.durationWeek;
    });
}
var $77b1d41ad42b9c2e$var$sunday = $77b1d41ad42b9c2e$var$weekday(0);
module.exports.sunday = $77b1d41ad42b9c2e$var$sunday;
var $77b1d41ad42b9c2e$var$monday = $77b1d41ad42b9c2e$var$weekday(1);
module.exports.monday = $77b1d41ad42b9c2e$var$monday;
var $77b1d41ad42b9c2e$var$tuesday = $77b1d41ad42b9c2e$var$weekday(2);
module.exports.tuesday = $77b1d41ad42b9c2e$var$tuesday;
var $77b1d41ad42b9c2e$var$wednesday = $77b1d41ad42b9c2e$var$weekday(3);
module.exports.wednesday = $77b1d41ad42b9c2e$var$wednesday;
var $77b1d41ad42b9c2e$var$thursday = $77b1d41ad42b9c2e$var$weekday(4);
module.exports.thursday = $77b1d41ad42b9c2e$var$thursday;
var $77b1d41ad42b9c2e$var$friday = $77b1d41ad42b9c2e$var$weekday(5);
module.exports.friday = $77b1d41ad42b9c2e$var$friday;
var $77b1d41ad42b9c2e$var$saturday = $77b1d41ad42b9c2e$var$weekday(6);
module.exports.saturday = $77b1d41ad42b9c2e$var$saturday;
var $77b1d41ad42b9c2e$var$sundays = $77b1d41ad42b9c2e$var$sunday.range;
module.exports.sundays = $77b1d41ad42b9c2e$var$sundays;
var $77b1d41ad42b9c2e$var$mondays = $77b1d41ad42b9c2e$var$monday.range;
module.exports.mondays = $77b1d41ad42b9c2e$var$mondays;
var $77b1d41ad42b9c2e$var$tuesdays = $77b1d41ad42b9c2e$var$tuesday.range;
module.exports.tuesdays = $77b1d41ad42b9c2e$var$tuesdays;
var $77b1d41ad42b9c2e$var$wednesdays = $77b1d41ad42b9c2e$var$wednesday.range;
module.exports.wednesdays = $77b1d41ad42b9c2e$var$wednesdays;
var $77b1d41ad42b9c2e$var$thursdays = $77b1d41ad42b9c2e$var$thursday.range;
module.exports.thursdays = $77b1d41ad42b9c2e$var$thursdays;
var $77b1d41ad42b9c2e$var$fridays = $77b1d41ad42b9c2e$var$friday.range;
module.exports.fridays = $77b1d41ad42b9c2e$var$fridays;
var $77b1d41ad42b9c2e$var$saturdays = $77b1d41ad42b9c2e$var$saturday.range;
module.exports.saturdays = $77b1d41ad42b9c2e$var$saturdays;

});

parcelRegister("b5xm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $812a08bcacbfff65$var$_interval = $812a08bcacbfff65$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $812a08bcacbfff65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $812a08bcacbfff65$var$month = (0, $812a08bcacbfff65$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $812a08bcacbfff65$var$_default = $812a08bcacbfff65$var$month;
module.exports.default = $812a08bcacbfff65$var$_default;
var $812a08bcacbfff65$var$months = $812a08bcacbfff65$var$month.range;
module.exports.months = $812a08bcacbfff65$var$months;

});

parcelRegister("hrPSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $cb3d32e37fc2d75c$var$_interval = $cb3d32e37fc2d75c$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $cb3d32e37fc2d75c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cb3d32e37fc2d75c$var$year = (0, $cb3d32e37fc2d75c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$cb3d32e37fc2d75c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cb3d32e37fc2d75c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $cb3d32e37fc2d75c$var$_default = $cb3d32e37fc2d75c$var$year;
module.exports.default = $cb3d32e37fc2d75c$var$_default;
var $cb3d32e37fc2d75c$var$years = $cb3d32e37fc2d75c$var$year.range;
module.exports.years = $cb3d32e37fc2d75c$var$years;

});

parcelRegister("d9Trb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $99471e540da24c53$var$_interval = $99471e540da24c53$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $99471e540da24c53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $99471e540da24c53$var$utcMinute = (0, $99471e540da24c53$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationMinute);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $99471e540da24c53$var$_default = $99471e540da24c53$var$utcMinute;
module.exports.default = $99471e540da24c53$var$_default;
var $99471e540da24c53$var$utcMinutes = $99471e540da24c53$var$utcMinute.range;
module.exports.utcMinutes = $99471e540da24c53$var$utcMinutes;

});

parcelRegister("6XsZh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $510ebd0d7d95ad5a$var$_interval = $510ebd0d7d95ad5a$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $510ebd0d7d95ad5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $510ebd0d7d95ad5a$var$utcHour = (0, $510ebd0d7d95ad5a$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationHour);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $510ebd0d7d95ad5a$var$_default = $510ebd0d7d95ad5a$var$utcHour;
module.exports.default = $510ebd0d7d95ad5a$var$_default;
var $510ebd0d7d95ad5a$var$utcHours = $510ebd0d7d95ad5a$var$utcHour.range;
module.exports.utcHours = $510ebd0d7d95ad5a$var$utcHours;

});

parcelRegister("8vTWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $632c9c9a11501eaf$var$_interval = $632c9c9a11501eaf$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $632c9c9a11501eaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $632c9c9a11501eaf$var$utcDay = (0, $632c9c9a11501eaf$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $632c9c9a11501eaf$var$_default = $632c9c9a11501eaf$var$utcDay;
module.exports.default = $632c9c9a11501eaf$var$_default;
var $632c9c9a11501eaf$var$utcDays = $632c9c9a11501eaf$var$utcDay.range;
module.exports.utcDays = $632c9c9a11501eaf$var$utcDays;

});

parcelRegister("k4peM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $e9c7c1fdf84a26e0$var$_interval = $e9c7c1fdf84a26e0$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $e9c7c1fdf84a26e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9c7c1fdf84a26e0$var$utcWeekday(i) {
    return (0, $e9c7c1fdf84a26e0$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $eX1Lo.durationWeek;
    });
}
var $e9c7c1fdf84a26e0$var$utcSunday = $e9c7c1fdf84a26e0$var$utcWeekday(0);
module.exports.utcSunday = $e9c7c1fdf84a26e0$var$utcSunday;
var $e9c7c1fdf84a26e0$var$utcMonday = $e9c7c1fdf84a26e0$var$utcWeekday(1);
module.exports.utcMonday = $e9c7c1fdf84a26e0$var$utcMonday;
var $e9c7c1fdf84a26e0$var$utcTuesday = $e9c7c1fdf84a26e0$var$utcWeekday(2);
module.exports.utcTuesday = $e9c7c1fdf84a26e0$var$utcTuesday;
var $e9c7c1fdf84a26e0$var$utcWednesday = $e9c7c1fdf84a26e0$var$utcWeekday(3);
module.exports.utcWednesday = $e9c7c1fdf84a26e0$var$utcWednesday;
var $e9c7c1fdf84a26e0$var$utcThursday = $e9c7c1fdf84a26e0$var$utcWeekday(4);
module.exports.utcThursday = $e9c7c1fdf84a26e0$var$utcThursday;
var $e9c7c1fdf84a26e0$var$utcFriday = $e9c7c1fdf84a26e0$var$utcWeekday(5);
module.exports.utcFriday = $e9c7c1fdf84a26e0$var$utcFriday;
var $e9c7c1fdf84a26e0$var$utcSaturday = $e9c7c1fdf84a26e0$var$utcWeekday(6);
module.exports.utcSaturday = $e9c7c1fdf84a26e0$var$utcSaturday;
var $e9c7c1fdf84a26e0$var$utcSundays = $e9c7c1fdf84a26e0$var$utcSunday.range;
module.exports.utcSundays = $e9c7c1fdf84a26e0$var$utcSundays;
var $e9c7c1fdf84a26e0$var$utcMondays = $e9c7c1fdf84a26e0$var$utcMonday.range;
module.exports.utcMondays = $e9c7c1fdf84a26e0$var$utcMondays;
var $e9c7c1fdf84a26e0$var$utcTuesdays = $e9c7c1fdf84a26e0$var$utcTuesday.range;
module.exports.utcTuesdays = $e9c7c1fdf84a26e0$var$utcTuesdays;
var $e9c7c1fdf84a26e0$var$utcWednesdays = $e9c7c1fdf84a26e0$var$utcWednesday.range;
module.exports.utcWednesdays = $e9c7c1fdf84a26e0$var$utcWednesdays;
var $e9c7c1fdf84a26e0$var$utcThursdays = $e9c7c1fdf84a26e0$var$utcThursday.range;
module.exports.utcThursdays = $e9c7c1fdf84a26e0$var$utcThursdays;
var $e9c7c1fdf84a26e0$var$utcFridays = $e9c7c1fdf84a26e0$var$utcFriday.range;
module.exports.utcFridays = $e9c7c1fdf84a26e0$var$utcFridays;
var $e9c7c1fdf84a26e0$var$utcSaturdays = $e9c7c1fdf84a26e0$var$utcSaturday.range;
module.exports.utcSaturdays = $e9c7c1fdf84a26e0$var$utcSaturdays;

});

parcelRegister("lhWn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $f7f876d9c48e45cf$var$_interval = $f7f876d9c48e45cf$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $f7f876d9c48e45cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f7f876d9c48e45cf$var$utcMonth = (0, $f7f876d9c48e45cf$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $f7f876d9c48e45cf$var$_default = $f7f876d9c48e45cf$var$utcMonth;
module.exports.default = $f7f876d9c48e45cf$var$_default;
var $f7f876d9c48e45cf$var$utcMonths = $f7f876d9c48e45cf$var$utcMonth.range;
module.exports.utcMonths = $f7f876d9c48e45cf$var$utcMonths;

});

parcelRegister("4w90J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $34a123f17451a027$var$_interval = $34a123f17451a027$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $34a123f17451a027$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34a123f17451a027$var$utcYear = (0, $34a123f17451a027$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$34a123f17451a027$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $34a123f17451a027$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $34a123f17451a027$var$_default = $34a123f17451a027$var$utcYear;
module.exports.default = $34a123f17451a027$var$_default;
var $34a123f17451a027$var$utcYears = $34a123f17451a027$var$utcYear.range;
module.exports.utcYears = $34a123f17451a027$var$utcYears;

});

parcelRegister("tUMUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $4GZnA = parcelRequire("4GZnA");

var $eX1Lo = parcelRequire("eX1Lo");

var $059ec26ca7291d3f$var$_millisecond = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("cK28E")));

var $059ec26ca7291d3f$var$_second = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("jeQEd")));

var $059ec26ca7291d3f$var$_minute = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("kQUOO")));

var $059ec26ca7291d3f$var$_hour = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("6xt90")));

var $059ec26ca7291d3f$var$_day = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("iEyEO")));

var $ah8ax = parcelRequire("ah8ax");

var $059ec26ca7291d3f$var$_month = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("b5xm0")));

var $059ec26ca7291d3f$var$_year = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("hrPSp")));

var $059ec26ca7291d3f$var$_utcMinute = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("d9Trb")));

var $059ec26ca7291d3f$var$_utcHour = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("6XsZh")));

var $059ec26ca7291d3f$var$_utcDay = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("8vTWn")));

var $k4peM = parcelRequire("k4peM");

var $059ec26ca7291d3f$var$_utcMonth = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("lhWn5")));

var $059ec26ca7291d3f$var$_utcYear = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("4w90J")));
function $059ec26ca7291d3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $059ec26ca7291d3f$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $059ec26ca7291d3f$var$_second.default,
            1,
            $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            5,
            5 * $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            15,
            15 * $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            30,
            30 * $eX1Lo.durationSecond
        ],
        [
            minute,
            1,
            $eX1Lo.durationMinute
        ],
        [
            minute,
            5,
            5 * $eX1Lo.durationMinute
        ],
        [
            minute,
            15,
            15 * $eX1Lo.durationMinute
        ],
        [
            minute,
            30,
            30 * $eX1Lo.durationMinute
        ],
        [
            hour,
            1,
            $eX1Lo.durationHour
        ],
        [
            hour,
            3,
            3 * $eX1Lo.durationHour
        ],
        [
            hour,
            6,
            6 * $eX1Lo.durationHour
        ],
        [
            hour,
            12,
            12 * $eX1Lo.durationHour
        ],
        [
            day,
            1,
            $eX1Lo.durationDay
        ],
        [
            day,
            2,
            2 * $eX1Lo.durationDay
        ],
        [
            week,
            1,
            $eX1Lo.durationWeek
        ],
        [
            month,
            1,
            $eX1Lo.durationMonth
        ],
        [
            month,
            3,
            3 * $eX1Lo.durationMonth
        ],
        [
            year,
            1,
            $eX1Lo.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $4GZnA.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $4GZnA.tickStep)(start / $eX1Lo.durationYear, stop / $eX1Lo.durationYear, count));
        if (i === 0) return $059ec26ca7291d3f$var$_millisecond.default.every(Math.max((0, $4GZnA.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$059ec26ca7291d3f$var$utcTicks, $059ec26ca7291d3f$var$utcTickInterval] = $059ec26ca7291d3f$var$ticker($059ec26ca7291d3f$var$_utcYear.default, $059ec26ca7291d3f$var$_utcMonth.default, $k4peM.utcSunday, $059ec26ca7291d3f$var$_utcDay.default, $059ec26ca7291d3f$var$_utcHour.default, $059ec26ca7291d3f$var$_utcMinute.default);
module.exports.utcTickInterval = $059ec26ca7291d3f$var$utcTickInterval;
module.exports.utcTicks = $059ec26ca7291d3f$var$utcTicks;
const [$059ec26ca7291d3f$var$timeTicks, $059ec26ca7291d3f$var$timeTickInterval] = $059ec26ca7291d3f$var$ticker($059ec26ca7291d3f$var$_year.default, $059ec26ca7291d3f$var$_month.default, $ah8ax.sunday, $059ec26ca7291d3f$var$_day.default, $059ec26ca7291d3f$var$_hour.default, $059ec26ca7291d3f$var$_minute.default);
module.exports.timeTickInterval = $059ec26ca7291d3f$var$timeTickInterval;
module.exports.timeTicks = $059ec26ca7291d3f$var$timeTicks;

});


parcelRegister("2ew5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.utcParse;
    }
});

var $1a05c914172ea909$var$_defaultLocale = $1a05c914172ea909$var$_interopRequireWildcard((parcelRequire("fpsX8")));

var $1a05c914172ea909$var$_locale = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("5OdpA")));

var $1a05c914172ea909$var$_isoFormat = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("1b1Mb")));

var $1a05c914172ea909$var$_isoParse = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("b6iYw")));
function $1a05c914172ea909$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a05c914172ea909$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1a05c914172ea909$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1a05c914172ea909$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1a05c914172ea909$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("fpsX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b37fa63933b96409$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $b37fa63933b96409$var$_locale = $b37fa63933b96409$var$_interopRequireDefault((parcelRequire("5OdpA")));
function $b37fa63933b96409$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b37fa63933b96409$var$locale;
var $b37fa63933b96409$var$timeFormat;
module.exports.timeFormat = $b37fa63933b96409$var$timeFormat;
var $b37fa63933b96409$var$timeParse;
module.exports.timeParse = $b37fa63933b96409$var$timeParse;
var $b37fa63933b96409$var$utcFormat;
module.exports.utcFormat = $b37fa63933b96409$var$utcFormat;
var $b37fa63933b96409$var$utcParse;
module.exports.utcParse = $b37fa63933b96409$var$utcParse;
$b37fa63933b96409$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $b37fa63933b96409$var$defaultLocale(definition) {
    $b37fa63933b96409$var$locale = (0, $b37fa63933b96409$var$_locale.default)(definition);
    module.exports.timeFormat = $b37fa63933b96409$var$timeFormat = $b37fa63933b96409$var$locale.format;
    module.exports.timeParse = $b37fa63933b96409$var$timeParse = $b37fa63933b96409$var$locale.parse;
    module.exports.utcFormat = $b37fa63933b96409$var$utcFormat = $b37fa63933b96409$var$locale.utcFormat;
    module.exports.utcParse = $b37fa63933b96409$var$utcParse = $b37fa63933b96409$var$locale.utcParse;
    return $b37fa63933b96409$var$locale;
}

});
parcelRegister("5OdpA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $43ac068a3cc4c089$var$formatLocale;

var $5hUYw = parcelRequire("5hUYw");
function $43ac068a3cc4c089$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $43ac068a3cc4c089$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $43ac068a3cc4c089$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $43ac068a3cc4c089$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $43ac068a3cc4c089$var$formatRe(locale_periods), periodLookup = $43ac068a3cc4c089$var$formatLookup(locale_periods), weekdayRe = $43ac068a3cc4c089$var$formatRe(locale_weekdays), weekdayLookup = $43ac068a3cc4c089$var$formatLookup(locale_weekdays), shortWeekdayRe = $43ac068a3cc4c089$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $43ac068a3cc4c089$var$formatLookup(locale_shortWeekdays), monthRe = $43ac068a3cc4c089$var$formatRe(locale_months), monthLookup = $43ac068a3cc4c089$var$formatLookup(locale_months), shortMonthRe = $43ac068a3cc4c089$var$formatRe(locale_shortMonths), shortMonthLookup = $43ac068a3cc4c089$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $43ac068a3cc4c089$var$formatDayOfMonth,
        "e": $43ac068a3cc4c089$var$formatDayOfMonth,
        "f": $43ac068a3cc4c089$var$formatMicroseconds,
        "g": $43ac068a3cc4c089$var$formatYearISO,
        "G": $43ac068a3cc4c089$var$formatFullYearISO,
        "H": $43ac068a3cc4c089$var$formatHour24,
        "I": $43ac068a3cc4c089$var$formatHour12,
        "j": $43ac068a3cc4c089$var$formatDayOfYear,
        "L": $43ac068a3cc4c089$var$formatMilliseconds,
        "m": $43ac068a3cc4c089$var$formatMonthNumber,
        "M": $43ac068a3cc4c089$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $43ac068a3cc4c089$var$formatUnixTimestamp,
        "s": $43ac068a3cc4c089$var$formatUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$formatSeconds,
        "u": $43ac068a3cc4c089$var$formatWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$formatWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$formatWeekNumberISO,
        "w": $43ac068a3cc4c089$var$formatWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $43ac068a3cc4c089$var$formatYear,
        "Y": $43ac068a3cc4c089$var$formatFullYear,
        "Z": $43ac068a3cc4c089$var$formatZone,
        "%": $43ac068a3cc4c089$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $43ac068a3cc4c089$var$formatUTCDayOfMonth,
        "e": $43ac068a3cc4c089$var$formatUTCDayOfMonth,
        "f": $43ac068a3cc4c089$var$formatUTCMicroseconds,
        "g": $43ac068a3cc4c089$var$formatUTCYearISO,
        "G": $43ac068a3cc4c089$var$formatUTCFullYearISO,
        "H": $43ac068a3cc4c089$var$formatUTCHour24,
        "I": $43ac068a3cc4c089$var$formatUTCHour12,
        "j": $43ac068a3cc4c089$var$formatUTCDayOfYear,
        "L": $43ac068a3cc4c089$var$formatUTCMilliseconds,
        "m": $43ac068a3cc4c089$var$formatUTCMonthNumber,
        "M": $43ac068a3cc4c089$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $43ac068a3cc4c089$var$formatUnixTimestamp,
        "s": $43ac068a3cc4c089$var$formatUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$formatUTCSeconds,
        "u": $43ac068a3cc4c089$var$formatUTCWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$formatUTCWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$formatUTCWeekNumberISO,
        "w": $43ac068a3cc4c089$var$formatUTCWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $43ac068a3cc4c089$var$formatUTCYear,
        "Y": $43ac068a3cc4c089$var$formatUTCFullYear,
        "Z": $43ac068a3cc4c089$var$formatUTCZone,
        "%": $43ac068a3cc4c089$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $43ac068a3cc4c089$var$parseDayOfMonth,
        "e": $43ac068a3cc4c089$var$parseDayOfMonth,
        "f": $43ac068a3cc4c089$var$parseMicroseconds,
        "g": $43ac068a3cc4c089$var$parseYear,
        "G": $43ac068a3cc4c089$var$parseFullYear,
        "H": $43ac068a3cc4c089$var$parseHour24,
        "I": $43ac068a3cc4c089$var$parseHour24,
        "j": $43ac068a3cc4c089$var$parseDayOfYear,
        "L": $43ac068a3cc4c089$var$parseMilliseconds,
        "m": $43ac068a3cc4c089$var$parseMonthNumber,
        "M": $43ac068a3cc4c089$var$parseMinutes,
        "p": parsePeriod,
        "q": $43ac068a3cc4c089$var$parseQuarter,
        "Q": $43ac068a3cc4c089$var$parseUnixTimestamp,
        "s": $43ac068a3cc4c089$var$parseUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$parseSeconds,
        "u": $43ac068a3cc4c089$var$parseWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$parseWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$parseWeekNumberISO,
        "w": $43ac068a3cc4c089$var$parseWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $43ac068a3cc4c089$var$parseYear,
        "Y": $43ac068a3cc4c089$var$parseFullYear,
        "Z": $43ac068a3cc4c089$var$parseZone,
        "%": $43ac068a3cc4c089$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $43ac068a3cc4c089$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $43ac068a3cc4c089$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $43ac068a3cc4c089$var$utcDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $5hUYw.utcMonday.ceil(week) : (0, $5hUYw.utcMonday)(week);
                    week = $5hUYw.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $43ac068a3cc4c089$var$localDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $5hUYw.timeMonday.ceil(week) : (0, $5hUYw.timeMonday)(week);
                    week = $5hUYw.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $43ac068a3cc4c089$var$utcDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)).getUTCDay() : $43ac068a3cc4c089$var$localDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $43ac068a3cc4c089$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $43ac068a3cc4c089$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $43ac068a3cc4c089$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $43ac068a3cc4c089$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $43ac068a3cc4c089$var$numberRe = /^\s*\d+/, // note: ignores next directive
$43ac068a3cc4c089$var$percentRe = /^%/, $43ac068a3cc4c089$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $43ac068a3cc4c089$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $43ac068a3cc4c089$var$requote(s) {
    return s.replace($43ac068a3cc4c089$var$requoteRe, "\\$&");
}
function $43ac068a3cc4c089$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($43ac068a3cc4c089$var$requote).join("|") + ")", "i");
}
function $43ac068a3cc4c089$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $43ac068a3cc4c089$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberSunday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberISO(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberMonday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseFullYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseQuarter(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMonthNumber(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseDayOfMonth(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseDayOfYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseHour24(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMinutes(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseSeconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMilliseconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMicroseconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseLiteralPercent(d, string, i) {
    var n = $43ac068a3cc4c089$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $43ac068a3cc4c089$var$parseUnixTimestamp(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$formatDayOfMonth(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getDate(), p, 2);
}
function $43ac068a3cc4c089$var$formatHour24(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getHours(), p, 2);
}
function $43ac068a3cc4c089$var$formatHour12(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $43ac068a3cc4c089$var$formatDayOfYear(d, p) {
    return $43ac068a3cc4c089$var$pad(1 + $5hUYw.timeDay.count((0, $5hUYw.timeYear)(d), d), p, 3);
}
function $43ac068a3cc4c089$var$formatMilliseconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMilliseconds(), p, 3);
}
function $43ac068a3cc4c089$var$formatMicroseconds(d, p) {
    return $43ac068a3cc4c089$var$formatMilliseconds(d, p) + "000";
}
function $43ac068a3cc4c089$var$formatMonthNumber(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMonth() + 1, p, 2);
}
function $43ac068a3cc4c089$var$formatMinutes(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMinutes(), p, 2);
}
function $43ac068a3cc4c089$var$formatSeconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getSeconds(), p, 2);
}
function $43ac068a3cc4c089$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $43ac068a3cc4c089$var$formatWeekNumberSunday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.timeSunday.count((0, $5hUYw.timeYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $5hUYw.timeThursday)(d) : $5hUYw.timeThursday.ceil(d);
}
function $43ac068a3cc4c089$var$formatWeekNumberISO(d, p) {
    d = $43ac068a3cc4c089$var$dISO(d);
    return $43ac068a3cc4c089$var$pad($5hUYw.timeThursday.count((0, $5hUYw.timeYear)(d), d) + ((0, $5hUYw.timeYear)(d).getDay() === 4), p, 2);
}
function $43ac068a3cc4c089$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $43ac068a3cc4c089$var$formatWeekNumberMonday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.timeMonday.count((0, $5hUYw.timeYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$formatYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatYearISO(d, p) {
    d = $43ac068a3cc4c089$var$dISO(d);
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatFullYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $5hUYw.timeThursday)(d) : $5hUYw.timeThursday.ceil(d);
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $43ac068a3cc4c089$var$pad(z / 60 | 0, "0", 2) + $43ac068a3cc4c089$var$pad(z % 60, "0", 2);
}
function $43ac068a3cc4c089$var$formatUTCDayOfMonth(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCDate(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCHour24(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCHours(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCHour12(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCDayOfYear(d, p) {
    return $43ac068a3cc4c089$var$pad(1 + $5hUYw.utcDay.count((0, $5hUYw.utcYear)(d), d), p, 3);
}
function $43ac068a3cc4c089$var$formatUTCMilliseconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $43ac068a3cc4c089$var$formatUTCMicroseconds(d, p) {
    return $43ac068a3cc4c089$var$formatUTCMilliseconds(d, p) + "000";
}
function $43ac068a3cc4c089$var$formatUTCMonthNumber(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCMinutes(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMinutes(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCSeconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCSeconds(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberSunday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.utcSunday.count((0, $5hUYw.utcYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $5hUYw.utcThursday)(d) : $5hUYw.utcThursday.ceil(d);
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberISO(d, p) {
    d = $43ac068a3cc4c089$var$UTCdISO(d);
    return $43ac068a3cc4c089$var$pad($5hUYw.utcThursday.count((0, $5hUYw.utcYear)(d), d) + ((0, $5hUYw.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberMonday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.utcMonday.count((0, $5hUYw.utcYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCYearISO(d, p) {
    d = $43ac068a3cc4c089$var$UTCdISO(d);
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCFullYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $5hUYw.utcThursday)(d) : $5hUYw.utcThursday.ceil(d);
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatUTCZone() {
    return "+0000";
}
function $43ac068a3cc4c089$var$formatLiteralPercent() {
    return "%";
}
function $43ac068a3cc4c089$var$formatUnixTimestamp(d) {
    return +d;
}
function $43ac068a3cc4c089$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("1b1Mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $fpsX8 = parcelRequire("fpsX8");
var $0db8323d2d47ca89$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $0db8323d2d47ca89$var$isoSpecifier;
function $0db8323d2d47ca89$var$formatIsoNative(date) {
    return date.toISOString();
}
var $0db8323d2d47ca89$var$formatIso = Date.prototype.toISOString ? $0db8323d2d47ca89$var$formatIsoNative : (0, $fpsX8.utcFormat)($0db8323d2d47ca89$var$isoSpecifier);
var $0db8323d2d47ca89$var$_default = $0db8323d2d47ca89$var$formatIso;
module.exports.default = $0db8323d2d47ca89$var$_default;

});

parcelRegister("b6iYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b1Mb = parcelRequire("1b1Mb");

var $fpsX8 = parcelRequire("fpsX8");
function $814ef9521af54613$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $814ef9521af54613$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $814ef9521af54613$var$parseIsoNative : (0, $fpsX8.utcParse)($1b1Mb.isoSpecifier);
var $814ef9521af54613$var$_default = $814ef9521af54613$var$parseIso;
module.exports.default = $814ef9521af54613$var$_default;

});



parcelRegister("7owcD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5623c11cad01957e$var$utcTime;

var $5hUYw = parcelRequire("5hUYw");

var $2ew5Z = parcelRequire("2ew5Z");

var $liuou = parcelRequire("liuou");

var $2ynOw = parcelRequire("2ynOw");
function $5623c11cad01957e$var$utcTime() {
    return $2ynOw.initRange.apply((0, $liuou.calendar)($5hUYw.utcTicks, $5hUYw.utcTickInterval, $5hUYw.utcYear, $5hUYw.utcMonth, $5hUYw.utcWeek, $5hUYw.utcDay, $5hUYw.utcHour, $5hUYw.utcMinute, $5hUYw.utcSecond, $2ew5Z.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("eI3Nr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $ab581ea304ac323d$var$copy;
module.exports.default = $ab581ea304ac323d$var$sequential;
module.exports.sequentialLog = $ab581ea304ac323d$var$sequentialLog;
module.exports.sequentialPow = $ab581ea304ac323d$var$sequentialPow;
module.exports.sequentialSqrt = $ab581ea304ac323d$var$sequentialSqrt;
module.exports.sequentialSymlog = $ab581ea304ac323d$var$sequentialSymlog;

var $bz0rV = parcelRequire("bz0rV");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $flmZz = parcelRequire("flmZz");

var $ag3bX = parcelRequire("ag3bX");

var $hGubV = parcelRequire("hGubV");
function $ab581ea304ac323d$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $3biM0.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($bz0rV.interpolate);
    scale.rangeRound = range($bz0rV.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $ab581ea304ac323d$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $ab581ea304ac323d$var$sequential() {
    var scale = (0, $4FaxR.linearish)($ab581ea304ac323d$var$transformer()($3biM0.identity));
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequential());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialLog() {
    var scale = (0, $flmZz.loggish)($ab581ea304ac323d$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialLog()).base(scale.base());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialSymlog() {
    var scale = (0, $ag3bX.symlogish)($ab581ea304ac323d$var$transformer());
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialSymlog()).constant(scale.constant());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialPow() {
    var scale = (0, $hGubV.powish)($ab581ea304ac323d$var$transformer());
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialPow()).exponent(scale.exponent());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialSqrt() {
    return $ab581ea304ac323d$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("het6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8ba525192978e45$var$sequentialQuantile;

var $4GZnA = parcelRequire("4GZnA");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $c8ba525192978e45$var$sequentialQuantile() {
    var domain = [], interpolator = $3biM0.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $4GZnA.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($4GZnA.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $4GZnA.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $c8ba525192978e45$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("3tpu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2877d8e7670f63da$var$diverging;
module.exports.divergingLog = $2877d8e7670f63da$var$divergingLog;
module.exports.divergingPow = $2877d8e7670f63da$var$divergingPow;
module.exports.divergingSqrt = $2877d8e7670f63da$var$divergingSqrt;
module.exports.divergingSymlog = $2877d8e7670f63da$var$divergingSymlog;

var $bz0rV = parcelRequire("bz0rV");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $flmZz = parcelRequire("flmZz");

var $eI3Nr = parcelRequire("eI3Nr");

var $ag3bX = parcelRequire("ag3bX");

var $hGubV = parcelRequire("hGubV");
function $2877d8e7670f63da$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $3biM0.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $bz0rV.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($bz0rV.interpolate);
    scale.rangeRound = range($bz0rV.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $2877d8e7670f63da$var$diverging() {
    var scale = (0, $4FaxR.linearish)($2877d8e7670f63da$var$transformer()($3biM0.identity));
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$diverging());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingLog() {
    var scale = (0, $flmZz.loggish)($2877d8e7670f63da$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingLog()).base(scale.base());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingSymlog() {
    var scale = (0, $ag3bX.symlogish)($2877d8e7670f63da$var$transformer());
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingSymlog()).constant(scale.constant());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingPow() {
    var scale = (0, $hGubV.powish)($2877d8e7670f63da$var$transformer());
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingPow()).exponent(scale.exponent());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingSqrt() {
    return $2877d8e7670f63da$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("7L7R7", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("6pud6"));

});
parcelRegister("6pud6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $4Yn4E.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $4Yn4E.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $hCVBb.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $hCVBb.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $7YO12.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $7YO12.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $7YO12.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $7YO12.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsStroke;
    }
});

var $4aac8301f976ca8e$var$_arc = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kl2vr")));

var $4aac8301f976ca8e$var$_area = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("jGAyt")));

var $4aac8301f976ca8e$var$_line = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("htDHw")));

var $4aac8301f976ca8e$var$_pie = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("c04R4")));

var $4aac8301f976ca8e$var$_areaRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7E7UH")));

var $4aac8301f976ca8e$var$_lineRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("by6KN")));

var $4aac8301f976ca8e$var$_pointRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("aq3nR")));

var $7YO12 = parcelRequire("7YO12");

var $4aac8301f976ca8e$var$_symbol = $4aac8301f976ca8e$var$_interopRequireWildcard((parcelRequire("kasLt")));

var $4aac8301f976ca8e$var$_asterisk = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kiHGx")));

var $4aac8301f976ca8e$var$_circle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("g0D51")));

var $4aac8301f976ca8e$var$_cross = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("hQIus")));

var $4aac8301f976ca8e$var$_diamond = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("bo4UX")));

var $4aac8301f976ca8e$var$_diamond2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fzOQV")));

var $4aac8301f976ca8e$var$_plus = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("khQ6z")));

var $4aac8301f976ca8e$var$_square = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("8sNtG")));

var $4aac8301f976ca8e$var$_square2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("59KED")));

var $4aac8301f976ca8e$var$_star = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7v7Tn")));

var $4aac8301f976ca8e$var$_triangle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("Pah0X")));

var $4aac8301f976ca8e$var$_triangle2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("gCNbI")));

var $4aac8301f976ca8e$var$_wye = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kIjqz")));

var $4aac8301f976ca8e$var$_x = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("hYg78")));

var $4aac8301f976ca8e$var$_basisClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("ay5fE")));

var $4aac8301f976ca8e$var$_basisOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("jpU7n")));

var $4aac8301f976ca8e$var$_basis = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("80A8B")));

var $4Yn4E = parcelRequire("4Yn4E");

var $4aac8301f976ca8e$var$_bundle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("ghvUH")));

var $4aac8301f976ca8e$var$_cardinalClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fdmsb")));

var $4aac8301f976ca8e$var$_cardinalOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("1GDiO")));

var $4aac8301f976ca8e$var$_cardinal = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7uyVd")));

var $4aac8301f976ca8e$var$_catmullRomClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fO1Lc")));

var $4aac8301f976ca8e$var$_catmullRomOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("f5m8h")));

var $4aac8301f976ca8e$var$_catmullRom = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("iA1KK")));

var $4aac8301f976ca8e$var$_linearClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("4MkXx")));

var $4aac8301f976ca8e$var$_linear = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("agyVG")));

var $hCVBb = parcelRequire("hCVBb");

var $4aac8301f976ca8e$var$_natural = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("c3UhF")));

var $4aac8301f976ca8e$var$_step = $4aac8301f976ca8e$var$_interopRequireWildcard((parcelRequire("kfzkQ")));

var $4aac8301f976ca8e$var$_stack = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("g1Flh")));

var $4aac8301f976ca8e$var$_expand = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("arwOB")));

var $4aac8301f976ca8e$var$_diverging = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("1e8r2")));

var $4aac8301f976ca8e$var$_none = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("3lLHy")));

var $4aac8301f976ca8e$var$_silhouette = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("4UXaU")));

var $4aac8301f976ca8e$var$_wiggle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("dD9Jn")));

var $4aac8301f976ca8e$var$_appearance = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("04gi8")));

var $4aac8301f976ca8e$var$_ascending = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("frzzp")));

var $4aac8301f976ca8e$var$_descending = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("5YYHh")));

var $4aac8301f976ca8e$var$_insideOut = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("zSdMD")));

var $4aac8301f976ca8e$var$_none2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("cBi4y")));

var $4aac8301f976ca8e$var$_reverse = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("gCYnW")));
function $4aac8301f976ca8e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4aac8301f976ca8e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4aac8301f976ca8e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4aac8301f976ca8e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4aac8301f976ca8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("kl2vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ece7b67664089e10$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $ece7b67664089e10$var$_constant = $ece7b67664089e10$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $8sqRt = parcelRequire("8sqRt");
function $ece7b67664089e10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ece7b67664089e10$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $ece7b67664089e10$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $ece7b67664089e10$var$arcStartAngle(d) {
    return d.startAngle;
}
function $ece7b67664089e10$var$arcEndAngle(d) {
    return d.endAngle;
}
function $ece7b67664089e10$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $ece7b67664089e10$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $8sqRt.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $ece7b67664089e10$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8sqRt.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8sqRt.sqrt)((0, $8sqRt.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $ece7b67664089e10$var$_default() {
    var innerRadius = $ece7b67664089e10$var$arcInnerRadius, outerRadius = $ece7b67664089e10$var$arcOuterRadius, cornerRadius = (0, $ece7b67664089e10$var$_constant.default)(0), padRadius = null, startAngle = $ece7b67664089e10$var$arcStartAngle, endAngle = $ece7b67664089e10$var$arcEndAngle, padAngle = $ece7b67664089e10$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $8sqRt.halfPi, a1 = endAngle.apply(this, arguments) - $8sqRt.halfPi, da = (0, $8sqRt.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $eHOaT.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $8sqRt.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $8sqRt.tau - $8sqRt.epsilon) {
            context.moveTo(r1 * (0, $8sqRt.cos)(a0), r1 * (0, $8sqRt.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $8sqRt.epsilon) {
                context.moveTo(r0 * (0, $8sqRt.cos)(a1), r0 * (0, $8sqRt.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $8sqRt.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $8sqRt.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8sqRt.min)((0, $8sqRt.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $8sqRt.epsilon) {
                var p0 = (0, $8sqRt.asin)(rp / r0 * (0, $8sqRt.sin)(ap)), p1 = (0, $8sqRt.asin)(rp / r1 * (0, $8sqRt.sin)(ap));
                if ((da0 -= p0 * 2) > $8sqRt.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $8sqRt.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8sqRt.cos)(a01), y01 = r1 * (0, $8sqRt.sin)(a01), x10 = r0 * (0, $8sqRt.cos)(a10), y10 = r0 * (0, $8sqRt.sin)(a10); // Apply rounded corners?
            if (rc > $8sqRt.epsilon) {
                var x11 = r1 * (0, $8sqRt.cos)(a11), y11 = r1 * (0, $8sqRt.sin)(a11), x00 = r0 * (0, $8sqRt.cos)(a00), y00 = r0 * (0, $8sqRt.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $8sqRt.pi && (oc = $ece7b67664089e10$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8sqRt.sin)((0, $8sqRt.acos)((ax * bx + ay * by) / ((0, $8sqRt.sqrt)(ax * ax + ay * ay) * (0, $8sqRt.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8sqRt.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8sqRt.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8sqRt.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $8sqRt.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $8sqRt.epsilon) {
                t0 = $ece7b67664089e10$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $ece7b67664089e10$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8sqRt.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8sqRt.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8sqRt.atan2)(t1.y11, t1.x11), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $8sqRt.epsilon) || !(da0 > $8sqRt.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $8sqRt.epsilon) {
                t0 = $ece7b67664089e10$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $ece7b67664089e10$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8sqRt.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8sqRt.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8sqRt.atan2)(t1.y11, t1.x11), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $8sqRt.pi / 2;
        return [
            (0, $8sqRt.cos)(a) * r,
            (0, $8sqRt.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("eHOaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $ab4c00801d0558d1$var$_path.default;
    }
});

var $ab4c00801d0558d1$var$_path = $ab4c00801d0558d1$var$_interopRequireDefault((parcelRequire("2E2TP")));
function $ab4c00801d0558d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2E2TP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $1ed190f6c26c53bc$var$pi = Math.PI, $1ed190f6c26c53bc$var$tau = 2 * $1ed190f6c26c53bc$var$pi, $1ed190f6c26c53bc$var$epsilon = 1e-6, $1ed190f6c26c53bc$var$tauEpsilon = $1ed190f6c26c53bc$var$tau - $1ed190f6c26c53bc$var$epsilon;
function $1ed190f6c26c53bc$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $1ed190f6c26c53bc$var$path() {
    return new $1ed190f6c26c53bc$var$Path();
}
$1ed190f6c26c53bc$var$Path.prototype = $1ed190f6c26c53bc$var$path.prototype = {
    constructor: $1ed190f6c26c53bc$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $1ed190f6c26c53bc$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $1ed190f6c26c53bc$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($1ed190f6c26c53bc$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $1ed190f6c26c53bc$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $1ed190f6c26c53bc$var$epsilon || Math.abs(this._y1 - y0) > $1ed190f6c26c53bc$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $1ed190f6c26c53bc$var$tau + $1ed190f6c26c53bc$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $1ed190f6c26c53bc$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $1ed190f6c26c53bc$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $1ed190f6c26c53bc$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $1ed190f6c26c53bc$var$_default = $1ed190f6c26c53bc$var$path;
module.exports.default = $1ed190f6c26c53bc$var$_default;

});


parcelRegister("1IHDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $140bbed001c70dbe$var$_default;
function $140bbed001c70dbe$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("8sqRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $6285c6685753927d$var$acos;
module.exports.asin = $6285c6685753927d$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $6285c6685753927d$var$abs = Math.abs;
module.exports.abs = $6285c6685753927d$var$abs;
const $6285c6685753927d$var$atan2 = Math.atan2;
module.exports.atan2 = $6285c6685753927d$var$atan2;
const $6285c6685753927d$var$cos = Math.cos;
module.exports.cos = $6285c6685753927d$var$cos;
const $6285c6685753927d$var$max = Math.max;
module.exports.max = $6285c6685753927d$var$max;
const $6285c6685753927d$var$min = Math.min;
module.exports.min = $6285c6685753927d$var$min;
const $6285c6685753927d$var$sin = Math.sin;
module.exports.sin = $6285c6685753927d$var$sin;
const $6285c6685753927d$var$sqrt = Math.sqrt;
module.exports.sqrt = $6285c6685753927d$var$sqrt;
const $6285c6685753927d$var$epsilon = 1e-12;
module.exports.epsilon = $6285c6685753927d$var$epsilon;
const $6285c6685753927d$var$pi = Math.PI;
module.exports.pi = $6285c6685753927d$var$pi;
const $6285c6685753927d$var$halfPi = $6285c6685753927d$var$pi / 2;
module.exports.halfPi = $6285c6685753927d$var$halfPi;
const $6285c6685753927d$var$tau = 2 * $6285c6685753927d$var$pi;
module.exports.tau = $6285c6685753927d$var$tau;
function $6285c6685753927d$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $6285c6685753927d$var$pi : Math.acos(x);
}
function $6285c6685753927d$var$asin(x) {
    return x >= 1 ? $6285c6685753927d$var$halfPi : x <= -1 ? -$6285c6685753927d$var$halfPi : Math.asin(x);
}

});


parcelRegister("jGAyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e54e4b9c9682336a$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $e54e4b9c9682336a$var$_array = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("02pi9")));

var $e54e4b9c9682336a$var$_constant = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $e54e4b9c9682336a$var$_linear = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("agyVG")));

var $e54e4b9c9682336a$var$_line = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("htDHw")));

var $ehs93 = parcelRequire("ehs93");
function $e54e4b9c9682336a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e54e4b9c9682336a$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $e54e4b9c9682336a$var$_constant.default)(true), context = null, curve = $e54e4b9c9682336a$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ehs93.x : (0, $e54e4b9c9682336a$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e54e4b9c9682336a$var$_constant.default)(0) : (0, $e54e4b9c9682336a$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ehs93.y : (0, $e54e4b9c9682336a$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $e54e4b9c9682336a$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $e54e4b9c9682336a$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("02pi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0073ce7100ec5fea$var$_default;
module.exports.slice = void 0;
var $0073ce7100ec5fea$var$slice = Array.prototype.slice;
module.exports.slice = $0073ce7100ec5fea$var$slice;
function $0073ce7100ec5fea$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("agyVG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $77967e463370f151$var$_default;
function $77967e463370f151$var$Linear(context) {
    this._context = context;
}
$77967e463370f151$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $77967e463370f151$var$_default(context) {
    return new $77967e463370f151$var$Linear(context);
}

});

parcelRegister("htDHw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb93f0e79c8b00d6$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $cb93f0e79c8b00d6$var$_array = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("02pi9")));

var $cb93f0e79c8b00d6$var$_constant = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $cb93f0e79c8b00d6$var$_linear = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("agyVG")));

var $ehs93 = parcelRequire("ehs93");
function $cb93f0e79c8b00d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb93f0e79c8b00d6$var$_default(x, y) {
    var defined = (0, $cb93f0e79c8b00d6$var$_constant.default)(true), context = null, curve = $cb93f0e79c8b00d6$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ehs93.x : (0, $cb93f0e79c8b00d6$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ehs93.y : (0, $cb93f0e79c8b00d6$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $cb93f0e79c8b00d6$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ehs93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $a6587c38a0b2a0e4$var$x;
module.exports.y = $a6587c38a0b2a0e4$var$y;
function $a6587c38a0b2a0e4$var$x(p) {
    return p[0];
}
function $a6587c38a0b2a0e4$var$y(p) {
    return p[1];
}

});



parcelRegister("c04R4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bc9403dbd6fca96$var$_default;

var $8bc9403dbd6fca96$var$_array = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("02pi9")));

var $8bc9403dbd6fca96$var$_constant = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $8bc9403dbd6fca96$var$_descending = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("ikEF1")));

var $8bc9403dbd6fca96$var$_identity = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("lsuiq")));

var $8sqRt = parcelRequire("8sqRt");
function $8bc9403dbd6fca96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc9403dbd6fca96$var$_default() {
    var value = $8bc9403dbd6fca96$var$_identity.default, sortValues = $8bc9403dbd6fca96$var$_descending.default, sort = null, startAngle = (0, $8bc9403dbd6fca96$var$_constant.default)(0), endAngle = (0, $8bc9403dbd6fca96$var$_constant.default)($8sqRt.tau), padAngle = (0, $8bc9403dbd6fca96$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $8bc9403dbd6fca96$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($8sqRt.tau, Math.max(-$8sqRt.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("ikEF1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d589a2a10e7fb4e9$var$_default;
function $d589a2a10e7fb4e9$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("lsuiq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9f3b6adb0340953$var$_default;
function $f9f3b6adb0340953$var$_default(d) {
    return d;
}

});


parcelRegister("7E7UH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59126847c663c507$var$_default;

var $59126847c663c507$var$_radial = $59126847c663c507$var$_interopRequireWildcard((parcelRequire("deEsU")));

var $59126847c663c507$var$_area = $59126847c663c507$var$_interopRequireDefault((parcelRequire("jGAyt")));

var $by6KN = parcelRequire("by6KN");
function $59126847c663c507$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59126847c663c507$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59126847c663c507$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59126847c663c507$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59126847c663c507$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $59126847c663c507$var$_default() {
    var a = (0, $59126847c663c507$var$_area.default)().curve($59126847c663c507$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $by6KN.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $by6KN.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $by6KN.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $by6KN.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $59126847c663c507$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("deEsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9a2bf8b690bcc18e$var$curveRadial;

var $9a2bf8b690bcc18e$var$_linear = $9a2bf8b690bcc18e$var$_interopRequireDefault((parcelRequire("agyVG")));
function $9a2bf8b690bcc18e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9a2bf8b690bcc18e$var$curveRadialLinear = $9a2bf8b690bcc18e$var$curveRadial($9a2bf8b690bcc18e$var$_linear.default);
module.exports.curveRadialLinear = $9a2bf8b690bcc18e$var$curveRadialLinear;
function $9a2bf8b690bcc18e$var$Radial(curve) {
    this._curve = curve;
}
$9a2bf8b690bcc18e$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9a2bf8b690bcc18e$var$curveRadial(curve) {
    function radial(context) {
        return new $9a2bf8b690bcc18e$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("by6KN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86881bda33151dda$var$_default;
module.exports.lineRadial = $86881bda33151dda$var$lineRadial;

var $86881bda33151dda$var$_radial = $86881bda33151dda$var$_interopRequireWildcard((parcelRequire("deEsU")));

var $86881bda33151dda$var$_line = $86881bda33151dda$var$_interopRequireDefault((parcelRequire("htDHw")));
function $86881bda33151dda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86881bda33151dda$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($86881bda33151dda$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $86881bda33151dda$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $86881bda33151dda$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $86881bda33151dda$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $86881bda33151dda$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $86881bda33151dda$var$_default() {
    return $86881bda33151dda$var$lineRadial((0, $86881bda33151dda$var$_line.default)().curve($86881bda33151dda$var$_radial.curveRadialLinear));
}

});


parcelRegister("aq3nR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $795ef50988f7751a$var$_default;
function $795ef50988f7751a$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("7YO12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $5cf4ef0fe6d88181$var$link;
module.exports.linkHorizontal = $5cf4ef0fe6d88181$var$linkHorizontal;
module.exports.linkRadial = $5cf4ef0fe6d88181$var$linkRadial;
module.exports.linkVertical = $5cf4ef0fe6d88181$var$linkVertical;

var $eHOaT = parcelRequire("eHOaT");

var $02pi9 = parcelRequire("02pi9");

var $5cf4ef0fe6d88181$var$_constant = $5cf4ef0fe6d88181$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $4Yn4E = parcelRequire("4Yn4E");

var $ehs93 = parcelRequire("ehs93");
function $5cf4ef0fe6d88181$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5cf4ef0fe6d88181$var$linkSource(d) {
    return d.source;
}
function $5cf4ef0fe6d88181$var$linkTarget(d) {
    return d.target;
}
function $5cf4ef0fe6d88181$var$link(curve) {
    let source = $5cf4ef0fe6d88181$var$linkSource;
    let target = $5cf4ef0fe6d88181$var$linkTarget;
    let x = $ehs93.x;
    let y = $ehs93.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $02pi9.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5cf4ef0fe6d88181$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5cf4ef0fe6d88181$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $5cf4ef0fe6d88181$var$linkHorizontal() {
    return $5cf4ef0fe6d88181$var$link($4Yn4E.bumpX);
}
function $5cf4ef0fe6d88181$var$linkVertical() {
    return $5cf4ef0fe6d88181$var$link($4Yn4E.bumpY);
}
function $5cf4ef0fe6d88181$var$linkRadial() {
    const l = $5cf4ef0fe6d88181$var$link($4Yn4E.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("4Yn4E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $39eeaa07ef6e11bb$var$bumpRadial;
module.exports.bumpX = $39eeaa07ef6e11bb$var$bumpX;
module.exports.bumpY = $39eeaa07ef6e11bb$var$bumpY;

var $39eeaa07ef6e11bb$var$_pointRadial = $39eeaa07ef6e11bb$var$_interopRequireDefault((parcelRequire("aq3nR")));
function $39eeaa07ef6e11bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $39eeaa07ef6e11bb$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $39eeaa07ef6e11bb$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $39eeaa07ef6e11bb$var$bumpX(context) {
    return new $39eeaa07ef6e11bb$var$Bump(context, true);
}
function $39eeaa07ef6e11bb$var$bumpY(context) {
    return new $39eeaa07ef6e11bb$var$Bump(context, false);
}
function $39eeaa07ef6e11bb$var$bumpRadial(context) {
    return new $39eeaa07ef6e11bb$var$BumpRadial(context);
}

});


parcelRegister("kasLt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eaeb0de66ae9c254$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $eHOaT = parcelRequire("eHOaT");

var $eaeb0de66ae9c254$var$_constant = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $eaeb0de66ae9c254$var$_asterisk = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("kiHGx")));

var $eaeb0de66ae9c254$var$_circle = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("g0D51")));

var $eaeb0de66ae9c254$var$_cross = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("hQIus")));

var $eaeb0de66ae9c254$var$_diamond = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("bo4UX")));

var $eaeb0de66ae9c254$var$_diamond2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("fzOQV")));

var $eaeb0de66ae9c254$var$_plus = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("khQ6z")));

var $eaeb0de66ae9c254$var$_square = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("8sNtG")));

var $eaeb0de66ae9c254$var$_square2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("59KED")));

var $eaeb0de66ae9c254$var$_star = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("7v7Tn")));

var $eaeb0de66ae9c254$var$_triangle = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("Pah0X")));

var $eaeb0de66ae9c254$var$_triangle2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("gCNbI")));

var $eaeb0de66ae9c254$var$_wye = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("kIjqz")));

var $eaeb0de66ae9c254$var$_x = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("hYg78")));
function $eaeb0de66ae9c254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $eaeb0de66ae9c254$var$symbolsFill = [
    $eaeb0de66ae9c254$var$_circle.default,
    $eaeb0de66ae9c254$var$_cross.default,
    $eaeb0de66ae9c254$var$_diamond.default,
    $eaeb0de66ae9c254$var$_square.default,
    $eaeb0de66ae9c254$var$_star.default,
    $eaeb0de66ae9c254$var$_triangle.default,
    $eaeb0de66ae9c254$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $eaeb0de66ae9c254$var$symbolsFill;
const $eaeb0de66ae9c254$var$symbolsStroke = [
    $eaeb0de66ae9c254$var$_circle.default,
    $eaeb0de66ae9c254$var$_plus.default,
    $eaeb0de66ae9c254$var$_x.default,
    $eaeb0de66ae9c254$var$_triangle2.default,
    $eaeb0de66ae9c254$var$_asterisk.default,
    $eaeb0de66ae9c254$var$_square2.default,
    $eaeb0de66ae9c254$var$_diamond2.default
];
module.exports.symbolsStroke = $eaeb0de66ae9c254$var$symbolsStroke;
function $eaeb0de66ae9c254$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $eaeb0de66ae9c254$var$_constant.default)(type || $eaeb0de66ae9c254$var$_circle.default);
    size = typeof size === "function" ? size : (0, $eaeb0de66ae9c254$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $eHOaT.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $eaeb0de66ae9c254$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $eaeb0de66ae9c254$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("kiHGx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $ec77600d052ca50f$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $ec77600d052ca50f$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size + (0, $8sqRt.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $ec77600d052ca50f$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $ec77600d052ca50f$var$_default;

});

parcelRegister("g0D51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $ba7af5e75b2015a4$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / $8sqRt.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $8sqRt.tau);
    }
};
module.exports.default = $ba7af5e75b2015a4$var$_default;

});

parcelRegister("hQIus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $cfe9cdd43a4cfd19$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $cfe9cdd43a4cfd19$var$_default;

});

parcelRegister("bo4UX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $84a5c024b727ed84$var$tan30 = (0, $8sqRt.sqrt)(1 / 3);
const $84a5c024b727ed84$var$tan30_2 = $84a5c024b727ed84$var$tan30 * 2;
var $84a5c024b727ed84$var$_default = {
    draw (context, size) {
        const y = (0, $8sqRt.sqrt)(size / $84a5c024b727ed84$var$tan30_2);
        const x = y * $84a5c024b727ed84$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $84a5c024b727ed84$var$_default;

});

parcelRegister("fzOQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $b571922a462d91b4$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $b571922a462d91b4$var$_default;

});

parcelRegister("khQ6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $ec4dd0241f3ddc46$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size - (0, $8sqRt.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $ec4dd0241f3ddc46$var$_default;

});

parcelRegister("8sNtG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $6297517f739c41c6$var$_default = {
    draw (context, size) {
        const w = (0, $8sqRt.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $6297517f739c41c6$var$_default;

});

parcelRegister("59KED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $3c11fb9628daf769$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $3c11fb9628daf769$var$_default;

});

parcelRegister("7v7Tn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $57618cda1a24a70a$var$ka = 0.89081309152928522810;
const $57618cda1a24a70a$var$kr = (0, $8sqRt.sin)($8sqRt.pi / 10) / (0, $8sqRt.sin)(7 * $8sqRt.pi / 10);
const $57618cda1a24a70a$var$kx = (0, $8sqRt.sin)($8sqRt.tau / 10) * $57618cda1a24a70a$var$kr;
const $57618cda1a24a70a$var$ky = -(0, $8sqRt.cos)($8sqRt.tau / 10) * $57618cda1a24a70a$var$kr;
var $57618cda1a24a70a$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size * $57618cda1a24a70a$var$ka);
        const x = $57618cda1a24a70a$var$kx * r;
        const y = $57618cda1a24a70a$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $8sqRt.tau * i / 5;
            const c = (0, $8sqRt.cos)(a);
            const s = (0, $8sqRt.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $57618cda1a24a70a$var$_default;

});

parcelRegister("Pah0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $099cbb9f98da7333$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $099cbb9f98da7333$var$_default = {
    draw (context, size) {
        const y = -(0, $8sqRt.sqrt)(size / ($099cbb9f98da7333$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$099cbb9f98da7333$var$sqrt3 * y, -y);
        context.lineTo($099cbb9f98da7333$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $099cbb9f98da7333$var$_default;

});

parcelRegister("gCNbI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $c1a659a465768725$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $c1a659a465768725$var$_default = {
    draw (context, size) {
        const s = (0, $8sqRt.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $c1a659a465768725$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $c1a659a465768725$var$_default;

});

parcelRegister("kIjqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $f146fc9a2e510f06$var$c = -0.5;
const $f146fc9a2e510f06$var$s = (0, $8sqRt.sqrt)(3) / 2;
const $f146fc9a2e510f06$var$k = 1 / (0, $8sqRt.sqrt)(12);
const $f146fc9a2e510f06$var$a = ($f146fc9a2e510f06$var$k / 2 + 1) * 3;
var $f146fc9a2e510f06$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / $f146fc9a2e510f06$var$a);
        const x0 = r / 2, y0 = r * $f146fc9a2e510f06$var$k;
        const x1 = x0, y1 = r * $f146fc9a2e510f06$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($f146fc9a2e510f06$var$c * x0 - $f146fc9a2e510f06$var$s * y0, $f146fc9a2e510f06$var$s * x0 + $f146fc9a2e510f06$var$c * y0);
        context.lineTo($f146fc9a2e510f06$var$c * x1 - $f146fc9a2e510f06$var$s * y1, $f146fc9a2e510f06$var$s * x1 + $f146fc9a2e510f06$var$c * y1);
        context.lineTo($f146fc9a2e510f06$var$c * x2 - $f146fc9a2e510f06$var$s * y2, $f146fc9a2e510f06$var$s * x2 + $f146fc9a2e510f06$var$c * y2);
        context.lineTo($f146fc9a2e510f06$var$c * x0 + $f146fc9a2e510f06$var$s * y0, $f146fc9a2e510f06$var$c * y0 - $f146fc9a2e510f06$var$s * x0);
        context.lineTo($f146fc9a2e510f06$var$c * x1 + $f146fc9a2e510f06$var$s * y1, $f146fc9a2e510f06$var$c * y1 - $f146fc9a2e510f06$var$s * x1);
        context.lineTo($f146fc9a2e510f06$var$c * x2 + $f146fc9a2e510f06$var$s * y2, $f146fc9a2e510f06$var$c * y2 - $f146fc9a2e510f06$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $f146fc9a2e510f06$var$_default;

});

parcelRegister("hYg78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $d1548a2d68fe530a$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size - (0, $8sqRt.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $d1548a2d68fe530a$var$_default;

});


parcelRegister("ay5fE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ae12728b04d5625$var$_default;

var $7ae12728b04d5625$var$_noop = $7ae12728b04d5625$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $80A8B = parcelRequire("80A8B");
function $7ae12728b04d5625$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ae12728b04d5625$var$BasisClosed(context) {
    this._context = context;
}
$7ae12728b04d5625$var$BasisClosed.prototype = {
    areaStart: $7ae12728b04d5625$var$_noop.default,
    areaEnd: $7ae12728b04d5625$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $80A8B.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7ae12728b04d5625$var$_default(context) {
    return new $7ae12728b04d5625$var$BasisClosed(context);
}

});
parcelRegister("3uxUV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28ae7ba8744bfca2$var$_default;
function $28ae7ba8744bfca2$var$_default() {}

});

parcelRegister("80A8B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $5d4a5b0586bcf64a$var$Basis;
module.exports.default = $5d4a5b0586bcf64a$var$_default;
module.exports.point = $5d4a5b0586bcf64a$var$point;
function $5d4a5b0586bcf64a$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $5d4a5b0586bcf64a$var$Basis(context) {
    this._context = context;
}
$5d4a5b0586bcf64a$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $5d4a5b0586bcf64a$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $5d4a5b0586bcf64a$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5d4a5b0586bcf64a$var$_default(context) {
    return new $5d4a5b0586bcf64a$var$Basis(context);
}

});


parcelRegister("jpU7n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e22be1f5d12a4d94$var$_default;

var $80A8B = parcelRequire("80A8B");
function $e22be1f5d12a4d94$var$BasisOpen(context) {
    this._context = context;
}
$e22be1f5d12a4d94$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $80A8B.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $e22be1f5d12a4d94$var$_default(context) {
    return new $e22be1f5d12a4d94$var$BasisOpen(context);
}

});

parcelRegister("ghvUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80A8B = parcelRequire("80A8B");
function $bda6fd378d42be19$var$Bundle(context, beta) {
    this._basis = new $80A8B.Basis(context);
    this._beta = beta;
}
$bda6fd378d42be19$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $bda6fd378d42be19$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $80A8B.Basis(context) : new $bda6fd378d42be19$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $bda6fd378d42be19$var$_default;

});

parcelRegister("fdmsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $b1397cb8deedcc73$var$CardinalClosed;
module.exports.default = void 0;

var $b1397cb8deedcc73$var$_noop = $b1397cb8deedcc73$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $7uyVd = parcelRequire("7uyVd");
function $b1397cb8deedcc73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1397cb8deedcc73$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b1397cb8deedcc73$var$CardinalClosed.prototype = {
    areaStart: $b1397cb8deedcc73$var$_noop.default,
    areaEnd: $b1397cb8deedcc73$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $7uyVd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b1397cb8deedcc73$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $b1397cb8deedcc73$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $b1397cb8deedcc73$var$_default;

});
parcelRegister("7uyVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $57466c7c1136f8d8$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $57466c7c1136f8d8$var$point;
function $57466c7c1136f8d8$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $57466c7c1136f8d8$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$57466c7c1136f8d8$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $57466c7c1136f8d8$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $57466c7c1136f8d8$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $57466c7c1136f8d8$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $57466c7c1136f8d8$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $57466c7c1136f8d8$var$_default;

});


parcelRegister("1GDiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $13a833525c2a2b71$var$CardinalOpen;
module.exports.default = void 0;

var $7uyVd = parcelRequire("7uyVd");
function $13a833525c2a2b71$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$13a833525c2a2b71$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $7uyVd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $13a833525c2a2b71$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $13a833525c2a2b71$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $13a833525c2a2b71$var$_default;

});

parcelRegister("fO1Lc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdmsb = parcelRequire("fdmsb");

var $b81ce4102c6d02ab$var$_noop = $b81ce4102c6d02ab$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $iA1KK = parcelRequire("iA1KK");
function $b81ce4102c6d02ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b81ce4102c6d02ab$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$b81ce4102c6d02ab$var$CatmullRomClosed.prototype = {
    areaStart: $b81ce4102c6d02ab$var$_noop.default,
    areaEnd: $b81ce4102c6d02ab$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iA1KK.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b81ce4102c6d02ab$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $b81ce4102c6d02ab$var$CatmullRomClosed(context, alpha) : new $fdmsb.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $b81ce4102c6d02ab$var$_default;

});
parcelRegister("iA1KK", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $8sqRt = parcelRequire("8sqRt");

var $7uyVd = parcelRequire("7uyVd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $8sqRt.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $8sqRt.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $7uyVd.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("f5m8h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1GDiO = parcelRequire("1GDiO");

var $iA1KK = parcelRequire("iA1KK");
function $afb87daecdf11967$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$afb87daecdf11967$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $iA1KK.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $afb87daecdf11967$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $afb87daecdf11967$var$CatmullRomOpen(context, alpha) : new $1GDiO.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $afb87daecdf11967$var$_default;

});

parcelRegister("4MkXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37abe72de26638cf$var$_default;

var $37abe72de26638cf$var$_noop = $37abe72de26638cf$var$_interopRequireDefault((parcelRequire("3uxUV")));
function $37abe72de26638cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37abe72de26638cf$var$LinearClosed(context) {
    this._context = context;
}
$37abe72de26638cf$var$LinearClosed.prototype = {
    areaStart: $37abe72de26638cf$var$_noop.default,
    areaEnd: $37abe72de26638cf$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $37abe72de26638cf$var$_default(context) {
    return new $37abe72de26638cf$var$LinearClosed(context);
}

});

parcelRegister("hCVBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $cd52aa2edc8e71c1$var$monotoneX;
module.exports.monotoneY = $cd52aa2edc8e71c1$var$monotoneY;
function $cd52aa2edc8e71c1$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cd52aa2edc8e71c1$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cd52aa2edc8e71c1$var$sign(s0) + $cd52aa2edc8e71c1$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $cd52aa2edc8e71c1$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cd52aa2edc8e71c1$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cd52aa2edc8e71c1$var$MonotoneX(context) {
    this._context = context;
}
$cd52aa2edc8e71c1$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cd52aa2edc8e71c1$var$point(this, this._t0, $cd52aa2edc8e71c1$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cd52aa2edc8e71c1$var$point(this, $cd52aa2edc8e71c1$var$slope2(this, t1 = $cd52aa2edc8e71c1$var$slope3(this, x, y)), t1);
                break;
            default:
                $cd52aa2edc8e71c1$var$point(this, this._t0, t1 = $cd52aa2edc8e71c1$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cd52aa2edc8e71c1$var$MonotoneY(context) {
    this._context = new $cd52aa2edc8e71c1$var$ReflectContext(context);
}
($cd52aa2edc8e71c1$var$MonotoneY.prototype = Object.create($cd52aa2edc8e71c1$var$MonotoneX.prototype)).point = function(x, y) {
    $cd52aa2edc8e71c1$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cd52aa2edc8e71c1$var$ReflectContext(context) {
    this._context = context;
}
$cd52aa2edc8e71c1$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cd52aa2edc8e71c1$var$monotoneX(context) {
    return new $cd52aa2edc8e71c1$var$MonotoneX(context);
}
function $cd52aa2edc8e71c1$var$monotoneY(context) {
    return new $cd52aa2edc8e71c1$var$MonotoneY(context);
}

});

parcelRegister("c3UhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c816caf23d6aa90$var$_default;
function $8c816caf23d6aa90$var$Natural(context) {
    this._context = context;
}
$8c816caf23d6aa90$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $8c816caf23d6aa90$var$controlPoints(x), py = $8c816caf23d6aa90$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $8c816caf23d6aa90$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $8c816caf23d6aa90$var$_default(context) {
    return new $8c816caf23d6aa90$var$Natural(context);
}

});

parcelRegister("kfzkQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebe09e38718963e6$var$_default;
module.exports.stepAfter = $ebe09e38718963e6$var$stepAfter;
module.exports.stepBefore = $ebe09e38718963e6$var$stepBefore;
function $ebe09e38718963e6$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$ebe09e38718963e6$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $ebe09e38718963e6$var$_default(context) {
    return new $ebe09e38718963e6$var$Step(context, 0.5);
}
function $ebe09e38718963e6$var$stepBefore(context) {
    return new $ebe09e38718963e6$var$Step(context, 0);
}
function $ebe09e38718963e6$var$stepAfter(context) {
    return new $ebe09e38718963e6$var$Step(context, 1);
}

});

parcelRegister("g1Flh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $baaccf104d1882d1$var$_default;

var $baaccf104d1882d1$var$_array = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("02pi9")));

var $baaccf104d1882d1$var$_constant = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $baaccf104d1882d1$var$_none = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("3lLHy")));

var $baaccf104d1882d1$var$_none2 = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $baaccf104d1882d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $baaccf104d1882d1$var$stackValue(d, key) {
    return d[key];
}
function $baaccf104d1882d1$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $baaccf104d1882d1$var$_default() {
    var keys = (0, $baaccf104d1882d1$var$_constant.default)([]), order = $baaccf104d1882d1$var$_none2.default, offset = $baaccf104d1882d1$var$_none.default, value = $baaccf104d1882d1$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $baaccf104d1882d1$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $baaccf104d1882d1$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $baaccf104d1882d1$var$_none2.default : typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $baaccf104d1882d1$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("3lLHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $270855c54030ca6c$var$_default;
function $270855c54030ca6c$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("cBi4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92c6f5866308065d$var$_default;
function $92c6f5866308065d$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("arwOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79a5e1645cb2e014$var$_default;

var $79a5e1645cb2e014$var$_none = $79a5e1645cb2e014$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $79a5e1645cb2e014$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79a5e1645cb2e014$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $79a5e1645cb2e014$var$_none.default)(series, order);
}

});

parcelRegister("1e8r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e4da44a140a0318$var$_default;
function $0e4da44a140a0318$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4UXaU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $394a4b4b05691a26$var$_default;

var $394a4b4b05691a26$var$_none = $394a4b4b05691a26$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $394a4b4b05691a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $394a4b4b05691a26$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $394a4b4b05691a26$var$_none.default)(series, order);
}

});

parcelRegister("dD9Jn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ec6773c97a19344$var$_default;

var $9ec6773c97a19344$var$_none = $9ec6773c97a19344$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $9ec6773c97a19344$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ec6773c97a19344$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $9ec6773c97a19344$var$_none.default)(series, order);
}

});

parcelRegister("04gi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00cd030253fcb90b$var$_default;

var $00cd030253fcb90b$var$_none = $00cd030253fcb90b$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $00cd030253fcb90b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $00cd030253fcb90b$var$_default(series) {
    var peaks = series.map($00cd030253fcb90b$var$peak);
    return (0, $00cd030253fcb90b$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $00cd030253fcb90b$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("frzzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3e4f8231c023254$var$_default;
module.exports.sum = $b3e4f8231c023254$var$sum;

var $b3e4f8231c023254$var$_none = $b3e4f8231c023254$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $b3e4f8231c023254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3e4f8231c023254$var$_default(series) {
    var sums = series.map($b3e4f8231c023254$var$sum);
    return (0, $b3e4f8231c023254$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $b3e4f8231c023254$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("5YYHh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45b1a38313034e43$var$_default;

var $45b1a38313034e43$var$_ascending = $45b1a38313034e43$var$_interopRequireDefault((parcelRequire("frzzp")));
function $45b1a38313034e43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $45b1a38313034e43$var$_default(series) {
    return (0, $45b1a38313034e43$var$_ascending.default)(series).reverse();
}

});

parcelRegister("zSdMD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06bd5438e85e0f42$var$_default;

var $06bd5438e85e0f42$var$_appearance = $06bd5438e85e0f42$var$_interopRequireDefault((parcelRequire("04gi8")));

var $frzzp = parcelRequire("frzzp");
function $06bd5438e85e0f42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06bd5438e85e0f42$var$_default(series) {
    var n = series.length, i, j, sums = series.map($frzzp.sum), order = (0, $06bd5438e85e0f42$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("gCYnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1af09290d860e32$var$_default;

var $c1af09290d860e32$var$_none = $c1af09290d860e32$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $c1af09290d860e32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c1af09290d860e32$var$_default(series) {
    return (0, $c1af09290d860e32$var$_none.default)(series).reverse();
}

});



parcelRegister("hOaao", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("9h7xK"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("9h7xK", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("kCtUf"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("kCtUf", function(module, exports) {
/**
 * Helpers.
 */ var $f02e8dfd559184b8$var$s = 1000;
var $f02e8dfd559184b8$var$m = $f02e8dfd559184b8$var$s * 60;
var $f02e8dfd559184b8$var$h = $f02e8dfd559184b8$var$m * 60;
var $f02e8dfd559184b8$var$d = $f02e8dfd559184b8$var$h * 24;
var $f02e8dfd559184b8$var$y = $f02e8dfd559184b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $f02e8dfd559184b8$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $f02e8dfd559184b8$var$fmtLong(val) : $f02e8dfd559184b8$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $f02e8dfd559184b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $f02e8dfd559184b8$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $f02e8dfd559184b8$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $f02e8dfd559184b8$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $f02e8dfd559184b8$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $f02e8dfd559184b8$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f02e8dfd559184b8$var$fmtShort(ms) {
    if (ms >= $f02e8dfd559184b8$var$d) return Math.round(ms / $f02e8dfd559184b8$var$d) + 'd';
    if (ms >= $f02e8dfd559184b8$var$h) return Math.round(ms / $f02e8dfd559184b8$var$h) + 'h';
    if (ms >= $f02e8dfd559184b8$var$m) return Math.round(ms / $f02e8dfd559184b8$var$m) + 'm';
    if (ms >= $f02e8dfd559184b8$var$s) return Math.round(ms / $f02e8dfd559184b8$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f02e8dfd559184b8$var$fmtLong(ms) {
    return $f02e8dfd559184b8$var$plural(ms, $f02e8dfd559184b8$var$d, 'day') || $f02e8dfd559184b8$var$plural(ms, $f02e8dfd559184b8$var$h, 'hour') || $f02e8dfd559184b8$var$plural(ms, $f02e8dfd559184b8$var$m, 'minute') || $f02e8dfd559184b8$var$plural(ms, $f02e8dfd559184b8$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $f02e8dfd559184b8$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



var $da09a384d596f1df$exports = {};
$parcel$extendImportMap({
    "b4Vu0": "delete-album-en.bc550f72.png",
    "hHlnj": "create-album-en.96b68a7f.png",
    "kB2u8": "import-discogs-en.402b7aaf.png",
    "k7I11": "filter-bar-image.1722c4e4.png",
    "iqhtb": "filter-order-en.7690f9ab.png",
    "bFc01": "filter-elements-en.710babe4.png",
    "kgL0o": "order-album-prefs-en.b1619666.png",
    "8iVUz": "unordered-album-en.ef444828.png",
    "emNxK": "album-list-en.79c44a35.png",
    "96hBn": "AppStoreButton_EN.f4b7da25.svg",
    "hYbJU": "sign-up-third-party-en.6360d242.png",
    "dE85W": "new-user-en.3acfe5bc.png",
    "9UoDG": "options-en.0043e8c8.png",
    "jvSqO": "sign-in-drawer-en.0e6eb7c1.png",
    "1wDfg": "main-buttons-toolbar.c7d01fbe.png",
    "aSdts": "album-remove-filtered-en.c797ffce.png",
    "eIPzL": "collection-remove-en.85d82072.png",
    "9AXbS": "collection-button-en.de1c3465.png",
    "kXPqS": "mark-albums-en.851221b9.png",
    "72JCb": "delete-album-es.d70a1c1d.png",
    "cqy1E": "create-album-es.c7258b6b.png",
    "4cR7I": "import-discogs-es.a80acff3.png",
    "8bFtC": "filter-order-es.4bf68df9.png",
    "c5dbU": "filter-elements-es.36613dbd.png",
    "eRJHG": "order-album-prefs-es.dcbf0b2b.png",
    "4lJ6x": "unordered-album-es.c33dd623.png",
    "aYKZN": "album-list-es.15362d51.png",
    "7Osfj": "AppStoreButton_ES.6abd34c6.svg",
    "dyKZb": "sign-up-third-party-es.51a9ec0d.png",
    "jyahE": "new-user-es.1d2323e6.png",
    "a0kao": "options-es.caaa4e2f.png",
    "gQGMc": "sign-in-drawer-es.a0c7f46f.png",
    "aedb7": "album-remove-filtered-es.4ac71cef.png",
    "6JkMp": "collection-remove-es.af3f5c3e.png",
    "jDw8t": "collection-button-es.1f748673.png",
    "cT718": "mark-albums-es.57c47ce2.png",
    "bJ9BN": "android-logo-white.59a431dd.png",
    "cOFaM": "piper-text.8c41f237.png",
    "9QdzW": "P-white.d96d7444.png",
    "6YVjm": "P-black.29378606.png",
    "lFOja": "P-black&white.81f622c6.png",
    "7CmyW": "generic_sleeve.6c7b5d2b.jpg",
    "eIDQB": "generic_spine.60d3804d.png",
    "8TPrx": "collection.4463ae4e.jpg",
    "1JVAr": "generic_artist.7f0599df.png",
    "jDFcd": "generic_image_placeholder.2c4c9be9.png",
    "8k5Db": "generic_label.3bf91ca4.png",
    "7ogYR": "generic_back.d1a6524a.jpg",
    "iQT4v": "shelving_cedar.57f948e9.jpg",
    "dFx9T": "shelving_oak.74715e7d.jpg",
    "aluYv": "shelving_ebony.f034ea0b.jpg",
    "6J1M0": "shelving_walnut.62bd647c.jpg",
    "2j2Zy": "shelving_blue.e930fd3a.jpg",
    "2h11H": "QR-AppStore-Black.177a31f1.png",
    "iMG6b": "QR-AppStore-White.cb9b7f80.png",
    "9KDAZ": "generic_shelf_segment.96ee6674.png"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;





parcelRequire("7fPBF");
/**
 * react-router v7.18.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
var $d42da6e692e216cc$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-BV7QT456.mjs"
});
var $d42da6e692e216cc$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $d42da6e692e216cc$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $d42da6e692e216cc$var$__typeError("Cannot " + msg);
var $d42da6e692e216cc$var$__privateGet = (obj, member, getter)=>($d42da6e692e216cc$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $d42da6e692e216cc$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $d42da6e692e216cc$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $d42da6e692e216cc$var$__privateSet = (obj, member, value, setter)=>($d42da6e692e216cc$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $d42da6e692e216cc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $d42da6e692e216cc$export$825a82322d91916e = /^[\\/]{2}/;
function $d42da6e692e216cc$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $d42da6e692e216cc$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($d42da6e692e216cc$export$e19cd5f9376f8cee || {});
var $d42da6e692e216cc$var$PopStateEventType = "popstate";
function $d42da6e692e216cc$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $d42da6e692e216cc$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $d42da6e692e216cc$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $d42da6e692e216cc$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $d42da6e692e216cc$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $d42da6e692e216cc$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $d42da6e692e216cc$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $d42da6e692e216cc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to);
    }
    return $d42da6e692e216cc$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $d42da6e692e216cc$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d42da6e692e216cc$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d42da6e692e216cc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d42da6e692e216cc$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $d42da6e692e216cc$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d42da6e692e216cc$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d42da6e692e216cc$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $d42da6e692e216cc$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $d42da6e692e216cc$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $d42da6e692e216cc$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d42da6e692e216cc$var$createKey(),
        mask: mask
    };
    return location;
}
function $d42da6e692e216cc$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $d42da6e692e216cc$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d42da6e692e216cc$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $d42da6e692e216cc$var$isLocation(to) ? to : $d42da6e692e216cc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d42da6e692e216cc$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $d42da6e692e216cc$var$isLocation(to) ? to : $d42da6e692e216cc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d42da6e692e216cc$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $d42da6e692e216cc$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($d42da6e692e216cc$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($d42da6e692e216cc$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $d42da6e692e216cc$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $d42da6e692e216cc$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $d42da6e692e216cc$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $d42da6e692e216cc$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $d42da6e692e216cc$var$_map;
var $d42da6e692e216cc$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $d42da6e692e216cc$var$__privateAdd(this, $d42da6e692e216cc$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_map).has(context)) return $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_map).set(context, value);
    }
};
$d42da6e692e216cc$var$_map = new WeakMap();
var $d42da6e692e216cc$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d42da6e692e216cc$var$isUnsupportedLazyRouteObjectKey(key) {
    return $d42da6e692e216cc$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $d42da6e692e216cc$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $d42da6e692e216cc$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $d42da6e692e216cc$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $d42da6e692e216cc$var$isIndexRoute(route) {
    return route.index === true;
}
function $d42da6e692e216cc$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d42da6e692e216cc$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $d42da6e692e216cc$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($d42da6e692e216cc$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $d42da6e692e216cc$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $d42da6e692e216cc$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $d42da6e692e216cc$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $d42da6e692e216cc$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $d42da6e692e216cc$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $d42da6e692e216cc$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $d42da6e692e216cc$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d42da6e692e216cc$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $d42da6e692e216cc$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $d42da6e692e216cc$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d42da6e692e216cc$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $d42da6e692e216cc$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $d42da6e692e216cc$var$flattenAndRankRoutes(routes) {
    let branches = $d42da6e692e216cc$var$flattenRoutes(routes);
    $d42da6e692e216cc$var$rankRouteBranches(branches);
    return branches;
}
function $d42da6e692e216cc$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $d42da6e692e216cc$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d42da6e692e216cc$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $d42da6e692e216cc$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $d42da6e692e216cc$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d42da6e692e216cc$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $d42da6e692e216cc$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $d42da6e692e216cc$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $d42da6e692e216cc$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d42da6e692e216cc$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d42da6e692e216cc$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $d42da6e692e216cc$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $d42da6e692e216cc$var$paramRe = /^:[\w-]+$/;
var $d42da6e692e216cc$var$dynamicSegmentValue = 3;
var $d42da6e692e216cc$var$indexRouteValue = 2;
var $d42da6e692e216cc$var$emptySegmentValue = 1;
var $d42da6e692e216cc$var$staticSegmentValue = 10;
var $d42da6e692e216cc$var$splatPenalty = -2;
var $d42da6e692e216cc$var$isSplat = (s)=>s === "*";
function $d42da6e692e216cc$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d42da6e692e216cc$var$isSplat)) initialScore += $d42da6e692e216cc$var$splatPenalty;
    if (index) initialScore += $d42da6e692e216cc$var$indexRouteValue;
    return segments.filter((s)=>!$d42da6e692e216cc$var$isSplat(s)).reduce((score, segment)=>score + ($d42da6e692e216cc$var$paramRe.test(segment) ? $d42da6e692e216cc$var$dynamicSegmentValue : segment === "" ? $d42da6e692e216cc$var$emptySegmentValue : $d42da6e692e216cc$var$staticSegmentValue), initialScore);
}
function $d42da6e692e216cc$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d42da6e692e216cc$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $d42da6e692e216cc$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $d42da6e692e216cc$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d42da6e692e216cc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d42da6e692e216cc$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d42da6e692e216cc$var$normalizePathname($d42da6e692e216cc$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d42da6e692e216cc$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $d42da6e692e216cc$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d42da6e692e216cc$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $d42da6e692e216cc$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $d42da6e692e216cc$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d42da6e692e216cc$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $d42da6e692e216cc$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $d42da6e692e216cc$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $d42da6e692e216cc$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $d42da6e692e216cc$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d42da6e692e216cc$var$compilePath(path, caseSensitive = false, end = true) {
    $d42da6e692e216cc$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $d42da6e692e216cc$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d42da6e692e216cc$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $d42da6e692e216cc$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $d42da6e692e216cc$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $d42da6e692e216cc$var$joinPaths([
        basename,
        pathname
    ]);
}
var $d42da6e692e216cc$var$isAbsoluteUrl = (url)=>$d42da6e692e216cc$var$ABSOLUTE_URL_REGEX.test(url);
function $d42da6e692e216cc$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $d42da6e692e216cc$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $d42da6e692e216cc$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $d42da6e692e216cc$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $d42da6e692e216cc$var$normalizeSearch(search),
        hash: $d42da6e692e216cc$var$normalizeHash(hash)
    };
}
function $d42da6e692e216cc$var$resolvePathname(relativePath, fromPathname) {
    let segments = $d42da6e692e216cc$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d42da6e692e216cc$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $d42da6e692e216cc$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $d42da6e692e216cc$var$getResolveToMatches(matches) {
    let pathMatches = $d42da6e692e216cc$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $d42da6e692e216cc$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $d42da6e692e216cc$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $d42da6e692e216cc$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $d42da6e692e216cc$var$getInvalidPathError("?", "pathname", "search", to));
        $d42da6e692e216cc$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $d42da6e692e216cc$var$getInvalidPathError("#", "pathname", "hash", to));
        $d42da6e692e216cc$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $d42da6e692e216cc$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d42da6e692e216cc$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $d42da6e692e216cc$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $d42da6e692e216cc$var$joinPaths = (paths)=>$d42da6e692e216cc$var$removeDoubleSlashes(paths.join("/"));
function $d42da6e692e216cc$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $d42da6e692e216cc$var$normalizePathname = (pathname)=>$d42da6e692e216cc$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $d42da6e692e216cc$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $d42da6e692e216cc$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $d42da6e692e216cc$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $d42da6e692e216cc$export$4051a07651545597(data2, init) {
    return new $d42da6e692e216cc$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $d42da6e692e216cc$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $d42da6e692e216cc$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d42da6e692e216cc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $d42da6e692e216cc$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $d42da6e692e216cc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $d42da6e692e216cc$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $d42da6e692e216cc$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $d42da6e692e216cc$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $d42da6e692e216cc$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $d42da6e692e216cc$var$joinPaths(parts) || "/";
}
var $d42da6e692e216cc$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $d42da6e692e216cc$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$d42da6e692e216cc$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($d42da6e692e216cc$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $d42da6e692e216cc$export$825a82322d91916e.test(to) ? new URL($d42da6e692e216cc$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $d42da6e692e216cc$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $d42da6e692e216cc$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $d42da6e692e216cc$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $d42da6e692e216cc$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $d42da6e692e216cc$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $d42da6e692e216cc$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$d42da6e692e216cc$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $d42da6e692e216cc$var$wrapImpl(aggregated[key], original, (...args)=>$d42da6e692e216cc$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$d42da6e692e216cc$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$d42da6e692e216cc$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $d42da6e692e216cc$var$wrapImpl(aggregated.middleware, original, (...args)=>$d42da6e692e216cc$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$d42da6e692e216cc$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $d42da6e692e216cc$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$d42da6e692e216cc$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $d42da6e692e216cc$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $d42da6e692e216cc$export$fe53371bee54353d(to) : ".",
                ...$d42da6e692e216cc$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$d42da6e692e216cc$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$d42da6e692e216cc$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $d42da6e692e216cc$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$d42da6e692e216cc$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$d42da6e692e216cc$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $d42da6e692e216cc$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $d42da6e692e216cc$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $d42da6e692e216cc$var$getReadonlyRequest(request),
            context: context != null ? $d42da6e692e216cc$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $d42da6e692e216cc$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $d42da6e692e216cc$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $d42da6e692e216cc$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $d42da6e692e216cc$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $d42da6e692e216cc$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $d42da6e692e216cc$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $d42da6e692e216cc$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $d42da6e692e216cc$var$getReadonlyContext(context)
    };
}
function $d42da6e692e216cc$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $d42da6e692e216cc$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $d42da6e692e216cc$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $d42da6e692e216cc$var$getReadonlyContext(context) {
    if ($d42da6e692e216cc$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $d42da6e692e216cc$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $d42da6e692e216cc$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $d42da6e692e216cc$var$objectProtoNames;
}
// lib/router/navigation.ts
var $d42da6e692e216cc$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $d42da6e692e216cc$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $d42da6e692e216cc$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $d42da6e692e216cc$var$DEFAULT_NAVIGATION_URL;
    }
}
function $d42da6e692e216cc$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $d42da6e692e216cc$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $d42da6e692e216cc$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$d42da6e692e216cc$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$d42da6e692e216cc$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$d42da6e692e216cc$var$isExplicitUrl(original, originalUrl) || !$d42da6e692e216cc$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $d42da6e692e216cc$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $d42da6e692e216cc$var$validMutationMethods = new Set($d42da6e692e216cc$var$validMutationMethodsArr);
var $d42da6e692e216cc$var$validRequestMethodsArr = [
    "GET",
    ...$d42da6e692e216cc$var$validMutationMethodsArr
];
var $d42da6e692e216cc$var$validRequestMethods = new Set($d42da6e692e216cc$var$validRequestMethodsArr);
var $d42da6e692e216cc$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $d42da6e692e216cc$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $d42da6e692e216cc$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d42da6e692e216cc$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d42da6e692e216cc$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $d42da6e692e216cc$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $d42da6e692e216cc$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $d42da6e692e216cc$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $d42da6e692e216cc$var$_routes, $d42da6e692e216cc$var$_branches, $d42da6e692e216cc$var$_hmrRoutes, $d42da6e692e216cc$var$_hmrBranches;
var $d42da6e692e216cc$var$DataRoutes = class {
    constructor(routes){
        $d42da6e692e216cc$var$__privateAdd(this, $d42da6e692e216cc$var$_routes);
        $d42da6e692e216cc$var$__privateAdd(this, $d42da6e692e216cc$var$_branches);
        $d42da6e692e216cc$var$__privateAdd(this, $d42da6e692e216cc$var$_hmrRoutes);
        $d42da6e692e216cc$var$__privateAdd(this, $d42da6e692e216cc$var$_hmrBranches);
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_routes, routes);
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_branches, $d42da6e692e216cc$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrRoutes) ?? $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrBranches) ?? $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_branches);
    }
    get hasHMRRoutes() {
        return $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_routes, routes);
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_branches, $d42da6e692e216cc$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_hmrRoutes, routes);
        $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_hmrBranches, $d42da6e692e216cc$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrRoutes)) {
            $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_routes, $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrRoutes));
            $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_branches, $d42da6e692e216cc$var$__privateGet(this, $d42da6e692e216cc$var$_hmrBranches));
            $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_hmrRoutes, void 0);
            $d42da6e692e216cc$var$__privateSet(this, $d42da6e692e216cc$var$_hmrBranches, void 0);
        }
    }
};
$d42da6e692e216cc$var$_routes = new WeakMap();
$d42da6e692e216cc$var$_branches = new WeakMap();
$d42da6e692e216cc$var$_hmrRoutes = new WeakMap();
$d42da6e692e216cc$var$_hmrBranches = new WeakMap();
function $d42da6e692e216cc$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $d42da6e692e216cc$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $d42da6e692e216cc$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$d42da6e692e216cc$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $d42da6e692e216cc$var$DataRoutes($d42da6e692e216cc$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $d42da6e692e216cc$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $d42da6e692e216cc$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$d42da6e692e216cc$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $d42da6e692e216cc$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $d42da6e692e216cc$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $d42da6e692e216cc$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d42da6e692e216cc$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $d42da6e692e216cc$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d42da6e692e216cc$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d42da6e692e216cc$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $d42da6e692e216cc$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d42da6e692e216cc$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d42da6e692e216cc$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $d42da6e692e216cc$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $d42da6e692e216cc$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $d42da6e692e216cc$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $d42da6e692e216cc$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($d42da6e692e216cc$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $d42da6e692e216cc$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $d42da6e692e216cc$export$fe53371bee54353d(opts.mask), $d42da6e692e216cc$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $d42da6e692e216cc$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $d42da6e692e216cc$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $d42da6e692e216cc$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d42da6e692e216cc$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $d42da6e692e216cc$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $d42da6e692e216cc$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d42da6e692e216cc$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $d42da6e692e216cc$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $d42da6e692e216cc$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $d42da6e692e216cc$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d42da6e692e216cc$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d42da6e692e216cc$var$isErrorResult(result) && $d42da6e692e216cc$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d42da6e692e216cc$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $d42da6e692e216cc$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$d42da6e692e216cc$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $d42da6e692e216cc$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $d42da6e692e216cc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $d42da6e692e216cc$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $d42da6e692e216cc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d42da6e692e216cc$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $d42da6e692e216cc$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($d42da6e692e216cc$var$isErrorResult(result)) {
            let boundaryMatch = $d42da6e692e216cc$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $d42da6e692e216cc$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $d42da6e692e216cc$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $d42da6e692e216cc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $d42da6e692e216cc$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$d42da6e692e216cc$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $d42da6e692e216cc$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $d42da6e692e216cc$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $d42da6e692e216cc$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d42da6e692e216cc$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $d42da6e692e216cc$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $d42da6e692e216cc$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d42da6e692e216cc$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d42da6e692e216cc$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $d42da6e692e216cc$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d42da6e692e216cc$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d42da6e692e216cc$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d42da6e692e216cc$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d42da6e692e216cc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $d42da6e692e216cc$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $d42da6e692e216cc$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($d42da6e692e216cc$var$isRedirectResult(actionResult) || $d42da6e692e216cc$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($d42da6e692e216cc$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d42da6e692e216cc$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($d42da6e692e216cc$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d42da6e692e216cc$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $d42da6e692e216cc$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $d42da6e692e216cc$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $d42da6e692e216cc$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $d42da6e692e216cc$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $d42da6e692e216cc$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $d42da6e692e216cc$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $d42da6e692e216cc$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $d42da6e692e216cc$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $d42da6e692e216cc$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d42da6e692e216cc$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $d42da6e692e216cc$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d42da6e692e216cc$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d42da6e692e216cc$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d42da6e692e216cc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $d42da6e692e216cc$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(void 0));
            return;
        }
        if ($d42da6e692e216cc$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($d42da6e692e216cc$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $d42da6e692e216cc$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $d42da6e692e216cc$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $d42da6e692e216cc$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $d42da6e692e216cc$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($d42da6e692e216cc$var$isAbsoluteUrl(location)) {
                const url = $d42da6e692e216cc$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d42da6e692e216cc$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d42da6e692e216cc$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($d42da6e692e216cc$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $d42da6e692e216cc$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $d42da6e692e216cc$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $d42da6e692e216cc$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$d42da6e692e216cc$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($d42da6e692e216cc$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $d42da6e692e216cc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $d42da6e692e216cc$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $d42da6e692e216cc$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $d42da6e692e216cc$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $d42da6e692e216cc$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $d42da6e692e216cc$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $d42da6e692e216cc$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $d42da6e692e216cc$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $d42da6e692e216cc$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $d42da6e692e216cc$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d42da6e692e216cc$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d42da6e692e216cc$export$386d57f03f0b2883;
        $d42da6e692e216cc$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $d42da6e692e216cc$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d42da6e692e216cc$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $d42da6e692e216cc$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$d42da6e692e216cc$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $d42da6e692e216cc$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($d42da6e692e216cc$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $d42da6e692e216cc$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $d42da6e692e216cc$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $d42da6e692e216cc$export$3336b097a6fbc59a(routes, opts) {
    $d42da6e692e216cc$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $d42da6e692e216cc$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$d42da6e692e216cc$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $d42da6e692e216cc$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $d42da6e692e216cc$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $d42da6e692e216cc$var$defaultNormalizePath;
        let method = request.method;
        let location = $d42da6e692e216cc$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $d42da6e692e216cc$export$b8d3e69d4b3eff04();
        if (!$d42da6e692e216cc$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d42da6e692e216cc$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $d42da6e692e216cc$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d42da6e692e216cc$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $d42da6e692e216cc$export$f5708dca728d7177(requestContext instanceof $d42da6e692e216cc$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $d42da6e692e216cc$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $d42da6e692e216cc$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $d42da6e692e216cc$var$createDataFunctionUrl(request, location),
                    pattern: $d42da6e692e216cc$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($d42da6e692e216cc$export$6e80290866a84dd4(error)) return error;
                    if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $d42da6e692e216cc$export$f2680fa305b734ca(error.status, error.statusText, await $d42da6e692e216cc$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($d42da6e692e216cc$export$e0163cfdf7bc9cfa(error)) error = $d42da6e692e216cc$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $d42da6e692e216cc$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $d42da6e692e216cc$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $d42da6e692e216cc$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $d42da6e692e216cc$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $d42da6e692e216cc$var$defaultNormalizePath;
        let method = request.method;
        let location = $d42da6e692e216cc$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $d42da6e692e216cc$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $d42da6e692e216cc$export$b8d3e69d4b3eff04();
        if (!$d42da6e692e216cc$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d42da6e692e216cc$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d42da6e692e216cc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d42da6e692e216cc$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d42da6e692e216cc$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $d42da6e692e216cc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $d42da6e692e216cc$export$f5708dca728d7177(requestContext instanceof $d42da6e692e216cc$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $d42da6e692e216cc$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $d42da6e692e216cc$var$runServerMiddlewarePipeline({
                request: request,
                url: $d42da6e692e216cc$var$createDataFunctionUrl(request, location),
                pattern: $d42da6e692e216cc$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $d42da6e692e216cc$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($d42da6e692e216cc$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($d42da6e692e216cc$var$dataWithResponseInitToResponse(error));
                if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $d42da6e692e216cc$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d42da6e692e216cc$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $d42da6e692e216cc$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $d42da6e692e216cc$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($d42da6e692e216cc$var$isDataStrategyResult(e) && $d42da6e692e216cc$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($d42da6e692e216cc$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d42da6e692e216cc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $d42da6e692e216cc$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($d42da6e692e216cc$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($d42da6e692e216cc$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($d42da6e692e216cc$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d42da6e692e216cc$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $d42da6e692e216cc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d42da6e692e216cc$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d42da6e692e216cc$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $d42da6e692e216cc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $d42da6e692e216cc$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $d42da6e692e216cc$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $d42da6e692e216cc$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $d42da6e692e216cc$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $d42da6e692e216cc$var$callDataStrategyImpl(dataStrategy || $d42da6e692e216cc$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($d42da6e692e216cc$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $d42da6e692e216cc$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($d42da6e692e216cc$export$e0163cfdf7bc9cfa(result.result)) throw $d42da6e692e216cc$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $d42da6e692e216cc$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $d42da6e692e216cc$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $d42da6e692e216cc$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $d42da6e692e216cc$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $d42da6e692e216cc$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $d42da6e692e216cc$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $d42da6e692e216cc$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $d42da6e692e216cc$var$resolveTo(to ? to : ".", $d42da6e692e216cc$var$getResolveToMatches(contextualMatches), $d42da6e692e216cc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $d42da6e692e216cc$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $d42da6e692e216cc$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $d42da6e692e216cc$export$fe53371bee54353d(path);
}
function $d42da6e692e216cc$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$d42da6e692e216cc$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d42da6e692e216cc$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d42da6e692e216cc$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d42da6e692e216cc$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $d42da6e692e216cc$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$d42da6e692e216cc$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$d42da6e692e216cc$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d42da6e692e216cc$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d42da6e692e216cc$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d42da6e692e216cc$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d42da6e692e216cc$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d42da6e692e216cc$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($d42da6e692e216cc$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $d42da6e692e216cc$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $d42da6e692e216cc$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $d42da6e692e216cc$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $d42da6e692e216cc$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $d42da6e692e216cc$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$d42da6e692e216cc$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $d42da6e692e216cc$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($d42da6e692e216cc$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($d42da6e692e216cc$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $d42da6e692e216cc$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $d42da6e692e216cc$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $d42da6e692e216cc$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $d42da6e692e216cc$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($d42da6e692e216cc$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $d42da6e692e216cc$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $d42da6e692e216cc$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$d42da6e692e216cc$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $d42da6e692e216cc$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $d42da6e692e216cc$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d42da6e692e216cc$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $d42da6e692e216cc$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $d42da6e692e216cc$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$d42da6e692e216cc$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $d42da6e692e216cc$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $d42da6e692e216cc$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $d42da6e692e216cc$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$d42da6e692e216cc$var$isSameRoute(aChild, bChild))) ?? false;
}
var $d42da6e692e216cc$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $d42da6e692e216cc$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $d42da6e692e216cc$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $d42da6e692e216cc$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $d42da6e692e216cc$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $d42da6e692e216cc$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $d42da6e692e216cc$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $d42da6e692e216cc$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $d42da6e692e216cc$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $d42da6e692e216cc$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $d42da6e692e216cc$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $d42da6e692e216cc$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $d42da6e692e216cc$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $d42da6e692e216cc$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $d42da6e692e216cc$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $d42da6e692e216cc$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $d42da6e692e216cc$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $d42da6e692e216cc$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $d42da6e692e216cc$var$isNonNullable(value) {
    return value !== void 0;
}
function $d42da6e692e216cc$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $d42da6e692e216cc$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($d42da6e692e216cc$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $d42da6e692e216cc$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $d42da6e692e216cc$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $d42da6e692e216cc$var$defaultDataStrategy(args);
    return $d42da6e692e216cc$var$runClientMiddlewarePipeline(args, ()=>$d42da6e692e216cc$var$defaultDataStrategy(args));
}
function $d42da6e692e216cc$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $d42da6e692e216cc$var$runMiddlewarePipeline(args, handler, processResult, $d42da6e692e216cc$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $d42da6e692e216cc$export$e0163cfdf7bc9cfa(result) ? $d42da6e692e216cc$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $d42da6e692e216cc$var$runClientMiddlewarePipeline(args, handler) {
    return $d42da6e692e216cc$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($d42da6e692e216cc$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $d42da6e692e216cc$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $d42da6e692e216cc$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $d42da6e692e216cc$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $d42da6e692e216cc$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $d42da6e692e216cc$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $d42da6e692e216cc$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $d42da6e692e216cc$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $d42da6e692e216cc$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $d42da6e692e216cc$var$loadLazyRoute(match.route, $d42da6e692e216cc$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $d42da6e692e216cc$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $d42da6e692e216cc$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $d42da6e692e216cc$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $d42da6e692e216cc$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$d42da6e692e216cc$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($d42da6e692e216cc$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $d42da6e692e216cc$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $d42da6e692e216cc$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $d42da6e692e216cc$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $d42da6e692e216cc$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $d42da6e692e216cc$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $d42da6e692e216cc$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $d42da6e692e216cc$var$createDataFunctionUrl(request, path),
        pattern: $d42da6e692e216cc$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $d42da6e692e216cc$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $d42da6e692e216cc$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $d42da6e692e216cc$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $d42da6e692e216cc$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d42da6e692e216cc$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d42da6e692e216cc$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d42da6e692e216cc$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $d42da6e692e216cc$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $d42da6e692e216cc$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $d42da6e692e216cc$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($d42da6e692e216cc$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $d42da6e692e216cc$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $d42da6e692e216cc$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $d42da6e692e216cc$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($d42da6e692e216cc$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $d42da6e692e216cc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $d42da6e692e216cc$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d42da6e692e216cc$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d42da6e692e216cc$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $d42da6e692e216cc$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $d42da6e692e216cc$export$961a3ef7a4da3a39(location) {
    try {
        return $d42da6e692e216cc$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $d42da6e692e216cc$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($d42da6e692e216cc$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $d42da6e692e216cc$export$825a82322d91916e.test(normalizedLocation) ? new URL($d42da6e692e216cc$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($d42da6e692e216cc$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $d42da6e692e216cc$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $d42da6e692e216cc$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($d42da6e692e216cc$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $d42da6e692e216cc$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d42da6e692e216cc$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d42da6e692e216cc$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $d42da6e692e216cc$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d42da6e692e216cc$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $d42da6e692e216cc$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d42da6e692e216cc$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d42da6e692e216cc$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $d42da6e692e216cc$export$f5708dca728d7177(!$d42da6e692e216cc$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d42da6e692e216cc$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $d42da6e692e216cc$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $d42da6e692e216cc$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $d42da6e692e216cc$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d42da6e692e216cc$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $d42da6e692e216cc$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $d42da6e692e216cc$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($d42da6e692e216cc$var$isErrorResult(result)) {
            let boundaryMatch = $d42da6e692e216cc$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($d42da6e692e216cc$var$isRedirectResult(result)) $d42da6e692e216cc$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $d42da6e692e216cc$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d42da6e692e216cc$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $d42da6e692e216cc$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d42da6e692e216cc$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d42da6e692e216cc$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $d42da6e692e216cc$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d42da6e692e216cc$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d42da6e692e216cc$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $d42da6e692e216cc$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $d42da6e692e216cc$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($d42da6e692e216cc$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $d42da6e692e216cc$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(path) : path;
    return $d42da6e692e216cc$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $d42da6e692e216cc$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $d42da6e692e216cc$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $d42da6e692e216cc$var$dataWithResponseInitToErrorResponse(data2) {
    return new $d42da6e692e216cc$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $d42da6e692e216cc$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $d42da6e692e216cc$var$isDataStrategyResult(value));
}
function $d42da6e692e216cc$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $d42da6e692e216cc$var$isRedirectDataStrategyResult(result) {
    return $d42da6e692e216cc$export$3f1eb41d9a6a6a27(result.result) && $d42da6e692e216cc$var$redirectStatusCodes.has(result.result.status);
}
function $d42da6e692e216cc$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $d42da6e692e216cc$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $d42da6e692e216cc$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d42da6e692e216cc$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d42da6e692e216cc$export$794b2760043cf8cd(statusCode) {
    return $d42da6e692e216cc$var$redirectStatusCodes.has(statusCode);
}
function $d42da6e692e216cc$export$6e80290866a84dd4(result) {
    return $d42da6e692e216cc$export$3f1eb41d9a6a6a27(result) && $d42da6e692e216cc$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $d42da6e692e216cc$var$isValidMethod(method) {
    return $d42da6e692e216cc$var$validRequestMethods.has(method.toUpperCase());
}
function $d42da6e692e216cc$export$cbae47800eb95bc3(method) {
    return $d42da6e692e216cc$var$validMutationMethods.has(method.toUpperCase());
}
function $d42da6e692e216cc$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d42da6e692e216cc$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d42da6e692e216cc$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $d42da6e692e216cc$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d42da6e692e216cc$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $d42da6e692e216cc$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $d42da6e692e216cc$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d42da6e692e216cc$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $d42da6e692e216cc$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $d42da6e692e216cc$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $d42da6e692e216cc$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d42da6e692e216cc$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $d42da6e692e216cc$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d42da6e692e216cc$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d42da6e692e216cc$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $d42da6e692e216cc$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $d42da6e692e216cc$export$2eeee58951ff3c1c = $7fPBF.createContext(null);
$d42da6e692e216cc$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $d42da6e692e216cc$export$315e3ffb01f217 = $7fPBF.createContext(null);
$d42da6e692e216cc$export$315e3ffb01f217.displayName = "DataRouterState";
var $d42da6e692e216cc$export$717f757c655223f1 = $7fPBF.createContext(false);
function $d42da6e692e216cc$var$useIsRSCRouterContext() {
    return $7fPBF.useContext($d42da6e692e216cc$export$717f757c655223f1);
}
var $d42da6e692e216cc$export$3681f408decb40d1 = $7fPBF.createContext({
    isTransitioning: false
});
$d42da6e692e216cc$export$3681f408decb40d1.displayName = "ViewTransition";
var $d42da6e692e216cc$export$cb3f1df1bef00a39 = $7fPBF.createContext(/* @__PURE__ */ new Map());
$d42da6e692e216cc$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $d42da6e692e216cc$var$AwaitContext = $7fPBF.createContext(null);
$d42da6e692e216cc$var$AwaitContext.displayName = "Await";
var $d42da6e692e216cc$export$2666c20e15407622 = (props)=>$7fPBF.createElement($d42da6e692e216cc$var$AwaitContext.Provider, props);
var $d42da6e692e216cc$export$3044ab7fdabeaee6 = $7fPBF.createContext(null);
$d42da6e692e216cc$export$3044ab7fdabeaee6.displayName = "Navigation";
var $d42da6e692e216cc$export$e6a44b110a0c44d3 = $7fPBF.createContext(null);
$d42da6e692e216cc$export$e6a44b110a0c44d3.displayName = "Location";
var $d42da6e692e216cc$export$aac280ed165a4397 = $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$d42da6e692e216cc$export$aac280ed165a4397.displayName = "Route";
var $d42da6e692e216cc$var$RouteErrorContext = $7fPBF.createContext(null);
$d42da6e692e216cc$var$RouteErrorContext.displayName = "RouteError";
var $d42da6e692e216cc$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $d42da6e692e216cc$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $d42da6e692e216cc$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $d42da6e692e216cc$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $d42da6e692e216cc$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$d42da6e692e216cc$var$ERROR_DIGEST_BASE}:${$d42da6e692e216cc$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $d42da6e692e216cc$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$d42da6e692e216cc$var$ERROR_DIGEST_BASE}:${$d42da6e692e216cc$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $d42da6e692e216cc$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $d42da6e692e216cc$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $d42da6e692e216cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $d42da6e692e216cc$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $d42da6e692e216cc$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d42da6e692e216cc$export$e6a44b110a0c44d3) != null;
}
function $d42da6e692e216cc$export$45d76561a5302f2b() {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7fPBF.useContext($d42da6e692e216cc$export$e6a44b110a0c44d3).location;
}
function $d42da6e692e216cc$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d42da6e692e216cc$export$e6a44b110a0c44d3).navigationType;
}
function $d42da6e692e216cc$export$6c330e8992e8a295(pattern) {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $d42da6e692e216cc$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>$d42da6e692e216cc$export$81336c211d5ff295(pattern, $d42da6e692e216cc$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $d42da6e692e216cc$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $d42da6e692e216cc$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7fPBF.useLayoutEffect(cb);
}
function $d42da6e692e216cc$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    return isDataRoute ? $d42da6e692e216cc$var$useNavigateStable() : $d42da6e692e216cc$var$useNavigateUnstable();
}
function $d42da6e692e216cc$var$useNavigateUnstable() {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let { matches: matches } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d42da6e692e216cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($d42da6e692e216cc$var$getResolveToMatches(matches));
    let activeRef = $7fPBF.useRef(false);
    $d42da6e692e216cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback((to, options = {})=>{
        $d42da6e692e216cc$var$warning(activeRef.current, $d42da6e692e216cc$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $d42da6e692e216cc$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d42da6e692e216cc$var$joinPaths([
            basename,
            path.pathname
        ]);
        $d42da6e692e216cc$export$6c8e41f66e7aa990(typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to), navigator.createHref(path), $d42da6e692e216cc$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $d42da6e692e216cc$var$OutletContext = $7fPBF.createContext(null);
function $d42da6e692e216cc$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d42da6e692e216cc$var$OutletContext);
}
function $d42da6e692e216cc$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397).outlet;
    return $7fPBF.useMemo(()=>outlet && /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $d42da6e692e216cc$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $d42da6e692e216cc$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d42da6e692e216cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($d42da6e692e216cc$var$getResolveToMatches(matches));
    return $7fPBF.useMemo(()=>$d42da6e692e216cc$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $d42da6e692e216cc$export$5d3fca4a98652595(routes, locationArg) {
    return $d42da6e692e216cc$var$useRoutesImpl(routes, locationArg);
}
function $d42da6e692e216cc$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($d42da6e692e216cc$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $d42da6e692e216cc$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $d42da6e692e216cc$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $d42da6e692e216cc$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $d42da6e692e216cc$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $d42da6e692e216cc$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($d42da6e692e216cc$export$945fecf35a8ef089) {
        $d42da6e692e216cc$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $d42da6e692e216cc$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $d42da6e692e216cc$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $d42da6e692e216cc$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $d42da6e692e216cc$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d42da6e692e216cc$var$DefaultErrorComponent() {
    let error = $d42da6e692e216cc$export$ed527bf60f6e05f2();
    let message = $d42da6e692e216cc$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($d42da6e692e216cc$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7fPBF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $d42da6e692e216cc$var$defaultErrorElement = /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$DefaultErrorComponent, null);
var $d42da6e692e216cc$var$RenderErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $d42da6e692e216cc$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$d42da6e692e216cc$var$RenderErrorBoundary.contextType = $d42da6e692e216cc$export$717f757c655223f1;
var $d42da6e692e216cc$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $d42da6e692e216cc$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $d42da6e692e216cc$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $d42da6e692e216cc$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $d42da6e692e216cc$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $d42da6e692e216cc$export$6c8e41f66e7aa990(redirect2.location, target, $d42da6e692e216cc$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($d42da6e692e216cc$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($d42da6e692e216cc$var$isBrowser && !$d42da6e692e216cc$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $d42da6e692e216cc$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7fPBF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $d42da6e692e216cc$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $d42da6e692e216cc$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $d42da6e692e216cc$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $d42da6e692e216cc$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $d42da6e692e216cc$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d42da6e692e216cc$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $d42da6e692e216cc$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $d42da6e692e216cc$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    $d42da6e692e216cc$export$f5708dca728d7177(ctx, $d42da6e692e216cc$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $d42da6e692e216cc$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d42da6e692e216cc$export$315e3ffb01f217);
    $d42da6e692e216cc$export$f5708dca728d7177(state, $d42da6e692e216cc$var$getDataRouterConsoleError(hookName));
    return state;
}
function $d42da6e692e216cc$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    $d42da6e692e216cc$export$f5708dca728d7177(route, $d42da6e692e216cc$var$getDataRouterConsoleError(hookName));
    return route;
}
function $d42da6e692e216cc$var$useCurrentRouteId(hookName) {
    let route = $d42da6e692e216cc$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $d42da6e692e216cc$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $d42da6e692e216cc$var$useRouteId() {
    return $d42da6e692e216cc$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $d42da6e692e216cc$export$d0fd4b7106de2769() {
    let state = $d42da6e692e216cc$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7fPBF.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $d42da6e692e216cc$export$600dc272ed516c15() {
    let dataRouterContext = $d42da6e692e216cc$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $d42da6e692e216cc$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7fPBF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7fPBF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $d42da6e692e216cc$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d42da6e692e216cc$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7fPBF.useMemo(()=>matches.map((m)=>$d42da6e692e216cc$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $d42da6e692e216cc$export$1448a5050d252c4d() {
    let state = $d42da6e692e216cc$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $d42da6e692e216cc$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $d42da6e692e216cc$export$fd5d37484eab868d(routeId) {
    let state = $d42da6e692e216cc$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $d42da6e692e216cc$export$fdc00f3f26066d5e() {
    let state = $d42da6e692e216cc$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $d42da6e692e216cc$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $d42da6e692e216cc$export$ed527bf60f6e05f2() {
    let error = $7fPBF.useContext($d42da6e692e216cc$var$RouteErrorContext);
    let state = $d42da6e692e216cc$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $d42da6e692e216cc$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $d42da6e692e216cc$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d42da6e692e216cc$var$AwaitContext);
    return value?._data;
}
function $d42da6e692e216cc$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d42da6e692e216cc$var$AwaitContext);
    return value?._error;
}
var $d42da6e692e216cc$var$blockerId = 0;
function $d42da6e692e216cc$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d42da6e692e216cc$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $d42da6e692e216cc$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $d42da6e692e216cc$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $d42da6e692e216cc$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7fPBF.useEffect(()=>{
        let key = String(++$d42da6e692e216cc$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $d42da6e692e216cc$export$386d57f03f0b2883;
}
function $d42da6e692e216cc$var$useNavigateStable() {
    let { router: router } = $d42da6e692e216cc$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $d42da6e692e216cc$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7fPBF.useRef(false);
    $d42da6e692e216cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(async (to, options = {})=>{
        $d42da6e692e216cc$var$warning(activeRef.current, $d42da6e692e216cc$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $d42da6e692e216cc$var$alreadyWarned = {};
function $d42da6e692e216cc$var$warningOnce(key, cond, message) {
    if (!cond && !$d42da6e692e216cc$var$alreadyWarned[key]) {
        $d42da6e692e216cc$var$alreadyWarned[key] = true;
        $d42da6e692e216cc$var$warning(false, message);
    }
}
function $d42da6e692e216cc$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $d42da6e692e216cc$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $d42da6e692e216cc$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $d42da6e692e216cc$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $d42da6e692e216cc$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $d42da6e692e216cc$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7fPBF.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$d42da6e692e216cc$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $7fPBF.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$d42da6e692e216cc$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $7fPBF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $d42da6e692e216cc$var$alreadyWarned2 = {};
function $d42da6e692e216cc$export$5b28268982f175ba(condition, message) {
    if (!condition && !$d42da6e692e216cc$var$alreadyWarned2[message]) {
        $d42da6e692e216cc$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $d42da6e692e216cc$var$USE_OPTIMISTIC = "useOptimistic";
var $d42da6e692e216cc$var$useOptimisticImpl = $7fPBF[$d42da6e692e216cc$var$USE_OPTIMISTIC];
var $d42da6e692e216cc$var$stableUseOptimisticSetter = ()=>void 0;
function $d42da6e692e216cc$var$useOptimisticSafe(val) {
    if ($d42da6e692e216cc$var$useOptimisticImpl) return $d42da6e692e216cc$var$useOptimisticImpl(val);
    else return [
        val,
        $d42da6e692e216cc$var$stableUseOptimisticSetter
    ];
}
function $d42da6e692e216cc$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($d42da6e692e216cc$export$945fecf35a8ef089) {
            if (route.element) $d42da6e692e216cc$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7fPBF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($d42da6e692e216cc$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $d42da6e692e216cc$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7fPBF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($d42da6e692e216cc$export$945fecf35a8ef089) {
            if (route.errorElement) $d42da6e692e216cc$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7fPBF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $d42da6e692e216cc$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $d42da6e692e216cc$export$f30f7e456d254e83(routes, opts) {
    return $d42da6e692e216cc$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d42da6e692e216cc$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $d42da6e692e216cc$export$e2fd2c03906469db,
        mapRouteProperties: $d42da6e692e216cc$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $d42da6e692e216cc$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $d42da6e692e216cc$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $d42da6e692e216cc$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7fPBF.useState(router.state);
    let [state, setOptimisticState] = $d42da6e692e216cc$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(/* @__PURE__ */ new Map());
    let setState = $7fPBF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $d42da6e692e216cc$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $d42da6e692e216cc$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $d42da6e692e216cc$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7fPBF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$d42da6e692e216cc$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d42da6e692e216cc$var$Deferred());
    }, [
        vtContext
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7fPBF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$d42da6e692e216cc$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $d42da6e692e216cc$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $d42da6e692e216cc$var$MemoizedDataRoutes = $7fPBF.memo($d42da6e692e216cc$var$DataRoutes2);
function $d42da6e692e216cc$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $d42da6e692e216cc$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $d42da6e692e216cc$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $d42da6e692e216cc$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d42da6e692e216cc$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $d42da6e692e216cc$export$f5708dca728d7177($d42da6e692e216cc$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    $d42da6e692e216cc$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d42da6e692e216cc$export$45d76561a5302f2b();
    let navigate = $d42da6e692e216cc$export$9770f232ac06a008();
    let path = $d42da6e692e216cc$var$resolveTo(to, $d42da6e692e216cc$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $d42da6e692e216cc$export$6c8e41f66e7aa990(typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to), navigator.createHref(path), $d42da6e692e216cc$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $d42da6e692e216cc$export$910ae8079b2c2852(props) {
    return $d42da6e692e216cc$export$a3be3530d8e40d0b(props.context);
}
function $d42da6e692e216cc$export$e7b0ac011bb776c6(props) {
    $d42da6e692e216cc$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $d42da6e692e216cc$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $d42da6e692e216cc$export$f5708dca728d7177(!$d42da6e692e216cc$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $d42da6e692e216cc$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = $d42da6e692e216cc$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $d42da6e692e216cc$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $d42da6e692e216cc$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $d42da6e692e216cc$export$5d3fca4a98652595($d42da6e692e216cc$export$16da398f5434bdec(children), location);
}
function $d42da6e692e216cc$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7fPBF.useContext($d42da6e692e216cc$export$315e3ffb01f217);
    let onError = $7fPBF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $d42da6e692e216cc$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$ResolveAwait, null, children));
}
var $d42da6e692e216cc$var$AwaitErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $d42da6e692e216cc$var$ResolveAwait({ children: children }) {
    let data2 = $d42da6e692e216cc$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
function $d42da6e692e216cc$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!$7fPBF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            routes.push.apply(routes, $d42da6e692e216cc$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $d42da6e692e216cc$export$f5708dca728d7177(element.type === $d42da6e692e216cc$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $d42da6e692e216cc$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d42da6e692e216cc$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $d42da6e692e216cc$export$9b5b6d122dea0c88 = $d42da6e692e216cc$export$16da398f5434bdec;
function $d42da6e692e216cc$export$daf73786167a7f72(matches) {
    return $d42da6e692e216cc$var$_renderMatches(matches);
}
function $d42da6e692e216cc$var$useRouteComponentProps() {
    return {
        params: $d42da6e692e216cc$export$99eaa27ddbbb95ef(),
        loaderData: $d42da6e692e216cc$export$1448a5050d252c4d(),
        actionData: $d42da6e692e216cc$export$fdc00f3f26066d5e(),
        matches: $d42da6e692e216cc$export$2378eb7f5ff86053()
    };
}
function $d42da6e692e216cc$export$6c4f3826290c37af({ children: children }) {
    const props = $d42da6e692e216cc$var$useRouteComponentProps();
    return $7fPBF.cloneElement(children, props);
}
function $d42da6e692e216cc$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $d42da6e692e216cc$var$useRouteComponentProps();
        return $7fPBF.createElement(Component4, props);
    };
}
function $d42da6e692e216cc$var$useHydrateFallbackProps() {
    return {
        params: $d42da6e692e216cc$export$99eaa27ddbbb95ef(),
        loaderData: $d42da6e692e216cc$export$1448a5050d252c4d(),
        actionData: $d42da6e692e216cc$export$fdc00f3f26066d5e()
    };
}
function $d42da6e692e216cc$export$f8cff34f39c1932a({ children: children }) {
    const props = $d42da6e692e216cc$var$useHydrateFallbackProps();
    return $7fPBF.cloneElement(children, props);
}
function $d42da6e692e216cc$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $d42da6e692e216cc$var$useHydrateFallbackProps();
        return $7fPBF.createElement(HydrateFallback, props);
    };
}
function $d42da6e692e216cc$var$useErrorBoundaryProps() {
    return {
        params: $d42da6e692e216cc$export$99eaa27ddbbb95ef(),
        loaderData: $d42da6e692e216cc$export$1448a5050d252c4d(),
        actionData: $d42da6e692e216cc$export$fdc00f3f26066d5e(),
        error: $d42da6e692e216cc$export$ed527bf60f6e05f2()
    };
}
function $d42da6e692e216cc$export$e5afde5c4b6d747b({ children: children }) {
    const props = $d42da6e692e216cc$var$useErrorBoundaryProps();
    return $7fPBF.cloneElement(children, props);
}
function $d42da6e692e216cc$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $d42da6e692e216cc$var$useErrorBoundaryProps();
        return $7fPBF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $d42da6e692e216cc$var$defaultMethod = "get";
var $d42da6e692e216cc$var$defaultEncType = "application/x-www-form-urlencoded";
function $d42da6e692e216cc$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $d42da6e692e216cc$var$isButtonElement(object) {
    return $d42da6e692e216cc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d42da6e692e216cc$var$isFormElement(object) {
    return $d42da6e692e216cc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d42da6e692e216cc$var$isInputElement(object) {
    return $d42da6e692e216cc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d42da6e692e216cc$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d42da6e692e216cc$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d42da6e692e216cc$var$isModifiedEvent(event);
}
function $d42da6e692e216cc$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d42da6e692e216cc$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d42da6e692e216cc$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $d42da6e692e216cc$var$_formDataSupportsSubmitter = null;
function $d42da6e692e216cc$var$isFormDataSubmitterSupported() {
    if ($d42da6e692e216cc$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d42da6e692e216cc$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d42da6e692e216cc$var$_formDataSupportsSubmitter = true;
    }
    return $d42da6e692e216cc$var$_formDataSupportsSubmitter;
}
var $d42da6e692e216cc$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d42da6e692e216cc$var$getFormEncType(encType) {
    if (encType != null && !$d42da6e692e216cc$var$supportedFormEncTypes.has(encType)) {
        $d42da6e692e216cc$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$d42da6e692e216cc$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $d42da6e692e216cc$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d42da6e692e216cc$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $d42da6e692e216cc$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $d42da6e692e216cc$var$defaultMethod;
        encType = $d42da6e692e216cc$var$getFormEncType(target.getAttribute("enctype")) || $d42da6e692e216cc$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d42da6e692e216cc$var$isButtonElement(target) || $d42da6e692e216cc$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $d42da6e692e216cc$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d42da6e692e216cc$var$defaultMethod;
        encType = $d42da6e692e216cc$var$getFormEncType(target.getAttribute("formenctype")) || $d42da6e692e216cc$var$getFormEncType(form.getAttribute("enctype")) || $d42da6e692e216cc$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$d42da6e692e216cc$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d42da6e692e216cc$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $d42da6e692e216cc$var$defaultMethod;
        action = null;
        encType = $d42da6e692e216cc$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $d42da6e692e216cc$var$HOLE = -1;
var $d42da6e692e216cc$var$NAN = -2;
var $d42da6e692e216cc$var$NEGATIVE_INFINITY = -3;
var $d42da6e692e216cc$var$NEGATIVE_ZERO = -4;
var $d42da6e692e216cc$var$NULL = -5;
var $d42da6e692e216cc$var$POSITIVE_INFINITY = -6;
var $d42da6e692e216cc$var$UNDEFINED = -7;
var $d42da6e692e216cc$var$TYPE_BIGINT = "B";
var $d42da6e692e216cc$var$TYPE_DATE = "D";
var $d42da6e692e216cc$var$TYPE_ERROR = "E";
var $d42da6e692e216cc$var$TYPE_MAP = "M";
var $d42da6e692e216cc$var$TYPE_NULL_OBJECT = "N";
var $d42da6e692e216cc$var$TYPE_PROMISE = "P";
var $d42da6e692e216cc$var$TYPE_REGEXP = "R";
var $d42da6e692e216cc$var$TYPE_SET = "S";
var $d42da6e692e216cc$var$TYPE_SYMBOL = "Y";
var $d42da6e692e216cc$var$TYPE_URL = "U";
var $d42da6e692e216cc$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $d42da6e692e216cc$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $d42da6e692e216cc$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $d42da6e692e216cc$var$TIME_LIMIT_MS = 1;
var $d42da6e692e216cc$var$getNow = ()=>Date.now();
var $d42da6e692e216cc$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $d42da6e692e216cc$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $d42da6e692e216cc$var$UNDEFINED;
    if (input === null) return $d42da6e692e216cc$var$NULL;
    if (Number.isNaN(input)) return $d42da6e692e216cc$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $d42da6e692e216cc$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $d42da6e692e216cc$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $d42da6e692e216cc$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $d42da6e692e216cc$var$stringify.call(this, stack);
    return index;
}
async function $d42da6e692e216cc$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $d42da6e692e216cc$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $d42da6e692e216cc$var$UNDEFINED;
        if (value === null) return $d42da6e692e216cc$var$NULL;
        if (Number.isNaN(value)) return $d42da6e692e216cc$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $d42da6e692e216cc$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $d42da6e692e216cc$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $d42da6e692e216cc$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $d42da6e692e216cc$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $d42da6e692e216cc$var$TIME_LIMIT_MS) {
            await $d42da6e692e216cc$var$yieldToMain();
            lastYieldTime = $d42da6e692e216cc$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$d42da6e692e216cc$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$d42da6e692e216cc$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$d42da6e692e216cc$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $d42da6e692e216cc$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$d42da6e692e216cc$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$d42da6e692e216cc$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$d42da6e692e216cc$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$d42da6e692e216cc$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$d42da6e692e216cc$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$d42da6e692e216cc$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$d42da6e692e216cc$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$d42da6e692e216cc$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$d42da6e692e216cc$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$d42da6e692e216cc$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($d42da6e692e216cc$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $d42da6e692e216cc$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $d42da6e692e216cc$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $d42da6e692e216cc$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $d42da6e692e216cc$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $d42da6e692e216cc$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $d42da6e692e216cc$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $d42da6e692e216cc$var$hydrate.call(this, startIndex);
}
function $d42da6e692e216cc$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $d42da6e692e216cc$var$UNDEFINED:
                set(void 0);
                continue;
            case $d42da6e692e216cc$var$NULL:
                set(null);
                continue;
            case $d42da6e692e216cc$var$NAN:
                set(NaN);
                continue;
            case $d42da6e692e216cc$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $d42da6e692e216cc$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $d42da6e692e216cc$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $d42da6e692e216cc$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $d42da6e692e216cc$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $d42da6e692e216cc$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $d42da6e692e216cc$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $d42da6e692e216cc$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $d42da6e692e216cc$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $d42da6e692e216cc$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $d42da6e692e216cc$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $d42da6e692e216cc$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $d42da6e692e216cc$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $d42da6e692e216cc$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $d42da6e692e216cc$var$globalObj && $d42da6e692e216cc$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $d42da6e692e216cc$var$globalObj && typeof $d42da6e692e216cc$var$globalObj[errorType] === "function" ? new $d42da6e692e216cc$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $d42da6e692e216cc$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $d42da6e692e216cc$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $d42da6e692e216cc$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $d42da6e692e216cc$var$Deferred2();
    const reader = readable.pipeThrough($d42da6e692e216cc$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $d42da6e692e216cc$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $d42da6e692e216cc$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $d42da6e692e216cc$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $d42da6e692e216cc$var$unflatten.call(this, line)
    };
}
async function $d42da6e692e216cc$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $d42da6e692e216cc$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $d42da6e692e216cc$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $d42da6e692e216cc$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $d42da6e692e216cc$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $d42da6e692e216cc$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $d42da6e692e216cc$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $d42da6e692e216cc$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_PROMISE}${deferredId}:[["${$d42da6e692e216cc$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $d42da6e692e216cc$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_ERROR}${deferredId}:[["${$d42da6e692e216cc$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$d42da6e692e216cc$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $d42da6e692e216cc$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $d42da6e692e216cc$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $d42da6e692e216cc$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $d42da6e692e216cc$export$4cf11838cdc2a8a8(html) {
    return html.replace($d42da6e692e216cc$var$ESCAPE_REGEX, (match)=>$d42da6e692e216cc$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $d42da6e692e216cc$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $d42da6e692e216cc$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $d42da6e692e216cc$var$SingleFetchNoResultError = class extends Error {
};
var $d42da6e692e216cc$export$ae9272e641ead836 = 202;
var $d42da6e692e216cc$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $d42da6e692e216cc$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$d42da6e692e216cc$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $d42da6e692e216cc$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $d42da6e692e216cc$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $d42da6e692e216cc$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $d42da6e692e216cc$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $d42da6e692e216cc$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $d42da6e692e216cc$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $d42da6e692e216cc$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $d42da6e692e216cc$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $d42da6e692e216cc$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $d42da6e692e216cc$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $d42da6e692e216cc$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $d42da6e692e216cc$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($d42da6e692e216cc$export$3f1eb41d9a6a6a27(result.result) || $d42da6e692e216cc$export$972111febbeef05b(result.result) || $d42da6e692e216cc$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $d42da6e692e216cc$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $d42da6e692e216cc$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $d42da6e692e216cc$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $d42da6e692e216cc$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$d42da6e692e216cc$var$createDeferred2());
    let singleFetchDfd = $d42da6e692e216cc$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $d42da6e692e216cc$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $d42da6e692e216cc$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $d42da6e692e216cc$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $d42da6e692e216cc$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $d42da6e692e216cc$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $d42da6e692e216cc$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $d42da6e692e216cc$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $d42da6e692e216cc$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $d42da6e692e216cc$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $d42da6e692e216cc$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $d42da6e692e216cc$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$d42da6e692e216cc$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$d42da6e692e216cc$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $d42da6e692e216cc$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $d42da6e692e216cc$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $d42da6e692e216cc$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $d42da6e692e216cc$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $d42da6e692e216cc$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $d42da6e692e216cc$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($d42da6e692e216cc$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $d42da6e692e216cc$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $d42da6e692e216cc$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($d42da6e692e216cc$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$d42da6e692e216cc$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $d42da6e692e216cc$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $d42da6e692e216cc$export$4023ad4ecd4126a2(body, global) {
    return $d42da6e692e216cc$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $d42da6e692e216cc$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $d42da6e692e216cc$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$d42da6e692e216cc$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $d42da6e692e216cc$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $d42da6e692e216cc$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $d42da6e692e216cc$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $d42da6e692e216cc$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $d42da6e692e216cc$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $d42da6e692e216cc$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $d42da6e692e216cc$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $d42da6e692e216cc$var$getModuleLinkHrefs(matches, manifest);
    return $d42da6e692e216cc$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $d42da6e692e216cc$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $d42da6e692e216cc$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $d42da6e692e216cc$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($d42da6e692e216cc$var$prefetchStyleLink));
}
async function $d42da6e692e216cc$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$d42da6e692e216cc$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$d42da6e692e216cc$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$d42da6e692e216cc$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($d42da6e692e216cc$var$prefetchStyleLink));
}
async function $d42da6e692e216cc$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $d42da6e692e216cc$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $d42da6e692e216cc$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $d42da6e692e216cc$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $d42da6e692e216cc$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $d42da6e692e216cc$var$dedupeLinkDescriptors(links.flat(1).filter($d42da6e692e216cc$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $d42da6e692e216cc$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $d42da6e692e216cc$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $d42da6e692e216cc$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $d42da6e692e216cc$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $d42da6e692e216cc$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $d42da6e692e216cc$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$d42da6e692e216cc$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($d42da6e692e216cc$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $d42da6e692e216cc$var$_isPreloadSupported;
function $d42da6e692e216cc$var$isPreloadSupported() {
    if ($d42da6e692e216cc$var$_isPreloadSupported !== void 0) return $d42da6e692e216cc$var$_isPreloadSupported;
    let el = document.createElement("link");
    $d42da6e692e216cc$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $d42da6e692e216cc$var$_isPreloadSupported;
}
function $d42da6e692e216cc$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $d42da6e692e216cc$var$useFrameworkContext();
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $d42da6e692e216cc$export$945fecf35a8ef089 ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $d42da6e692e216cc$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $d42da6e692e216cc$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $d42da6e692e216cc$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $d42da6e692e216cc$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RemixRootDefaultErrorBoundary, {
            error: $d42da6e692e216cc$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $d42da6e692e216cc$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $d42da6e692e216cc$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $d42da6e692e216cc$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$d42da6e692e216cc$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $d42da6e692e216cc$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $d42da6e692e216cc$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $d42da6e692e216cc$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $d42da6e692e216cc$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $d42da6e692e216cc$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $d42da6e692e216cc$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $d42da6e692e216cc$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $d42da6e692e216cc$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $d42da6e692e216cc$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $d42da6e692e216cc$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $d42da6e692e216cc$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $d42da6e692e216cc$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $d42da6e692e216cc$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$d42da6e692e216cc$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $d42da6e692e216cc$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $d42da6e692e216cc$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $d42da6e692e216cc$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $d42da6e692e216cc$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $d42da6e692e216cc$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $d42da6e692e216cc$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $d42da6e692e216cc$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $d42da6e692e216cc$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $d42da6e692e216cc$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $d42da6e692e216cc$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $d42da6e692e216cc$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $d42da6e692e216cc$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $d42da6e692e216cc$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $d42da6e692e216cc$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $d42da6e692e216cc$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $d42da6e692e216cc$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $d42da6e692e216cc$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $d42da6e692e216cc$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $d42da6e692e216cc$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $d42da6e692e216cc$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $d42da6e692e216cc$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $d42da6e692e216cc$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $d42da6e692e216cc$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $d42da6e692e216cc$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $d42da6e692e216cc$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $d42da6e692e216cc$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $d42da6e692e216cc$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $d42da6e692e216cc$var$nextPaths = /* @__PURE__ */ new Set();
var $d42da6e692e216cc$var$discoveredPathsMaxSize = 1e3;
var $d42da6e692e216cc$var$discoveredPaths = /* @__PURE__ */ new Set();
var $d42da6e692e216cc$export$b5915cf27fa06b9f = 7680;
function $d42da6e692e216cc$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $d42da6e692e216cc$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $d42da6e692e216cc$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $d42da6e692e216cc$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $d42da6e692e216cc$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$d42da6e692e216cc$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($d42da6e692e216cc$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $d42da6e692e216cc$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $d42da6e692e216cc$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $d42da6e692e216cc$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7fPBF.useEffect(()=>{
        if (!$d42da6e692e216cc$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$d42da6e692e216cc$var$discoveredPaths.has(pathname)) $d42da6e692e216cc$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($d42da6e692e216cc$var$nextPaths.keys()).filter((path)=>{
                if ($d42da6e692e216cc$var$discoveredPaths.has(path)) {
                    $d42da6e692e216cc$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $d42da6e692e216cc$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $d42da6e692e216cc$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $d42da6e692e216cc$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $d42da6e692e216cc$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $d42da6e692e216cc$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $d42da6e692e216cc$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $d42da6e692e216cc$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($d42da6e692e216cc$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $d42da6e692e216cc$export$b5915cf27fa06b9f) {
        $d42da6e692e216cc$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($d42da6e692e216cc$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($d42da6e692e216cc$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($d42da6e692e216cc$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$d42da6e692e216cc$var$addToFifoQueue(p, $d42da6e692e216cc$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $d42da6e692e216cc$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $d42da6e692e216cc$var$addToFifoQueue(path, queue) {
    if (queue.size >= $d42da6e692e216cc$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $d42da6e692e216cc$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $d42da6e692e216cc$var$useDataRouterContext2() {
    let context = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    $d42da6e692e216cc$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $d42da6e692e216cc$var$useDataRouterStateContext() {
    let context = $7fPBF.useContext($d42da6e692e216cc$export$315e3ffb01f217);
    $d42da6e692e216cc$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $d42da6e692e216cc$export$208d6a3bc3aa62bd = $7fPBF.createContext(void 0);
$d42da6e692e216cc$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $d42da6e692e216cc$var$useFrameworkContext() {
    let context = $7fPBF.useContext($d42da6e692e216cc$export$208d6a3bc3aa62bd);
    $d42da6e692e216cc$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $d42da6e692e216cc$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7fPBF.useContext($d42da6e692e216cc$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7fPBF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7fPBF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7fPBF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $d42da6e692e216cc$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $d42da6e692e216cc$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $d42da6e692e216cc$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $d42da6e692e216cc$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $d42da6e692e216cc$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $d42da6e692e216cc$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $d42da6e692e216cc$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$d42da6e692e216cc$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $d42da6e692e216cc$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $d42da6e692e216cc$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $d42da6e692e216cc$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $d42da6e692e216cc$var$useDataRouterStateContext();
    let matches = $d42da6e692e216cc$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7fPBF.useMemo(()=>$d42da6e692e216cc$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7fPBF.createElement("style", {
        [$d42da6e692e216cc$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7fPBF.createElement("link", {
        [$d42da6e692e216cc$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$d42da6e692e216cc$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $d42da6e692e216cc$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $d42da6e692e216cc$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $d42da6e692e216cc$var$useFrameworkContext();
    let { router: router } = $d42da6e692e216cc$var$useDataRouterContext2();
    let matches = $7fPBF.useMemo(()=>$d42da6e692e216cc$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $d42da6e692e216cc$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $d42da6e692e216cc$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7fPBF.useState([]);
    $7fPBF.useEffect(()=>{
        let interrupted = false;
        $d42da6e692e216cc$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $d42da6e692e216cc$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let { future: future } = $d42da6e692e216cc$var$useFrameworkContext();
    let { basename: basename } = $d42da6e692e216cc$var$useDataRouterContext2();
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $d42da6e692e216cc$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $d42da6e692e216cc$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $d42da6e692e216cc$var$useFrameworkContext();
    let { basename: basename } = $d42da6e692e216cc$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $d42da6e692e216cc$var$useDataRouterStateContext();
    let newMatchesForData = $7fPBF.useMemo(()=>$d42da6e692e216cc$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7fPBF.useMemo(()=>$d42da6e692e216cc$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $d42da6e692e216cc$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7fPBF.useMemo(()=>$d42da6e692e216cc$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $d42da6e692e216cc$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $d42da6e692e216cc$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $d42da6e692e216cc$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $d42da6e692e216cc$var$useDataRouterStateContext();
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let _matches = $d42da6e692e216cc$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$d42da6e692e216cc$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7fPBF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7fPBF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7fPBF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $d42da6e692e216cc$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $d42da6e692e216cc$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $d42da6e692e216cc$var$isHydrated = false;
function $d42da6e692e216cc$export$3be068dde909e563() {
    $d42da6e692e216cc$var$isHydrated = true;
}
function $d42da6e692e216cc$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $d42da6e692e216cc$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $d42da6e692e216cc$var$useDataRouterContext2();
    let { matches: routerMatches } = $d42da6e692e216cc$var$useDataRouterStateContext();
    let isRSCRouterContext = $d42da6e692e216cc$var$useIsRSCRouterContext();
    let enableFogOfWar = $d42da6e692e216cc$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $d42da6e692e216cc$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7fPBF.useEffect(()=>{
        $d42da6e692e216cc$export$3be068dde909e563();
    }, []);
    let initialScripts = $7fPBF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $d42da6e692e216cc$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($d42da6e692e216cc$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $d42da6e692e216cc$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($d42da6e692e216cc$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $d42da6e692e216cc$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $d42da6e692e216cc$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7fPBF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $d42da6e692e216cc$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $d42da6e692e216cc$export$32e57f52df4b6e34 = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $d42da6e692e216cc$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $d42da6e692e216cc$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($d42da6e692e216cc$export$972111febbeef05b(error)) return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $d42da6e692e216cc$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $d42da6e692e216cc$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $d42da6e692e216cc$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7fPBF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7fPBF.createElement("head", null, /* @__PURE__ */ $7fPBF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7fPBF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7fPBF.createElement("title", null, title)), /* @__PURE__ */ $7fPBF.createElement("body", null, /* @__PURE__ */ $7fPBF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$ff0bf87698939488, null) : null)));
}
var $d42da6e692e216cc$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($d42da6e692e216cc$var$isBrowser2) window.__reactRouterVersion = "7.18.3";
} catch (e) {}
function $d42da6e692e216cc$export$1f3f55432a00e06d(routes, opts) {
    return $d42da6e692e216cc$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d42da6e692e216cc$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $d42da6e692e216cc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $d42da6e692e216cc$export$9269a41d8c4635e,
        hydrationRouteProperties: $d42da6e692e216cc$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $d42da6e692e216cc$export$1ba7ed8a3a7b3765(routes, opts) {
    return $d42da6e692e216cc$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d42da6e692e216cc$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $d42da6e692e216cc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $d42da6e692e216cc$export$9269a41d8c4635e,
        hydrationRouteProperties: $d42da6e692e216cc$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $d42da6e692e216cc$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $d42da6e692e216cc$var$deserializeErrors(state.errors)
    };
    return state;
}
function $d42da6e692e216cc$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $d42da6e692e216cc$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $d42da6e692e216cc$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $d42da6e692e216cc$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $d42da6e692e216cc$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d42da6e692e216cc$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $d42da6e692e216cc$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d42da6e692e216cc$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$d42da6e692e216cc$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $d42da6e692e216cc$export$a6c7ac8248d6e38a = $7fPBF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $d42da6e692e216cc$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $d42da6e692e216cc$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $d42da6e692e216cc$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $d42da6e692e216cc$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $d42da6e692e216cc$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $d42da6e692e216cc$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $d42da6e692e216cc$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7fPBF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $d42da6e692e216cc$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, link, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$d42da6e692e216cc$export$a6c7ac8248d6e38a.displayName = "Link";
var $d42da6e692e216cc$export$b0d92dbee9b5b60d = $7fPBF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $d42da6e692e216cc$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let routerState = $7fPBF.useContext($d42da6e692e216cc$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d42da6e692e216cc$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $d42da6e692e216cc$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$d42da6e692e216cc$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $d42da6e692e216cc$export$a7fed597f4b8afd8 = $7fPBF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $d42da6e692e216cc$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let submit = $d42da6e692e216cc$export$47c85c6e3a081d3();
    let formAction = $d42da6e692e216cc$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $d42da6e692e216cc$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7fPBF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7fPBF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$d42da6e692e216cc$export$a7fed597f4b8afd8.displayName = "Form";
function $d42da6e692e216cc$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7fPBF.useContext($d42da6e692e216cc$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let matches = $d42da6e692e216cc$export$2378eb7f5ff86053();
    $d42da6e692e216cc$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7fPBF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $d42da6e692e216cc$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $7fPBF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$d42da6e692e216cc$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $d42da6e692e216cc$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$d42da6e692e216cc$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$d42da6e692e216cc$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $d42da6e692e216cc$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $d42da6e692e216cc$var$useDataRouterContext3(hookName) {
    let ctx = $7fPBF.useContext($d42da6e692e216cc$export$2eeee58951ff3c1c);
    $d42da6e692e216cc$export$f5708dca728d7177(ctx, $d42da6e692e216cc$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $d42da6e692e216cc$var$useDataRouterState2(hookName) {
    let state = $7fPBF.useContext($d42da6e692e216cc$export$315e3ffb01f217);
    $d42da6e692e216cc$export$f5708dca728d7177(state, $d42da6e692e216cc$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $d42da6e692e216cc$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $d42da6e692e216cc$export$9770f232ac06a008();
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let path = $d42da6e692e216cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($d42da6e692e216cc$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $d42da6e692e216cc$export$fe53371bee54353d(location) === $d42da6e692e216cc$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7fPBF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $d42da6e692e216cc$export$f1a78c17382fe22a(defaultInit) {
    $d42da6e692e216cc$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7fPBF.useRef($d42da6e692e216cc$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d42da6e692e216cc$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $d42da6e692e216cc$export$9770f232ac06a008();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d42da6e692e216cc$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $d42da6e692e216cc$var$fetcherId = 0;
var $d42da6e692e216cc$var$getUniqueFetcherId = ()=>`__${String(++$d42da6e692e216cc$var$fetcherId)}__`;
function $d42da6e692e216cc$export$47c85c6e3a081d3() {
    let { router: router } = $d42da6e692e216cc$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let currentRouteId = $d42da6e692e216cc$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7fPBF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d42da6e692e216cc$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d42da6e692e216cc$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $d42da6e692e216cc$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let routeContext = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    $d42da6e692e216cc$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$d42da6e692e216cc$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $d42da6e692e216cc$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $d42da6e692e216cc$export$fe53371bee54353d(path);
}
function $d42da6e692e216cc$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $d42da6e692e216cc$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $d42da6e692e216cc$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7fPBF.useContext($d42da6e692e216cc$export$cb3f1df1bef00a39);
    let route = $7fPBF.useContext($d42da6e692e216cc$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $d42da6e692e216cc$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $d42da6e692e216cc$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $d42da6e692e216cc$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7fPBF.useId();
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7fPBF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7fPBF.useCallback(async (href, opts)=>{
        $d42da6e692e216cc$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $d42da6e692e216cc$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7fPBF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm2 = $7fPBF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $d42da6e692e216cc$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $d42da6e692e216cc$export$fa996778a3a31087() {
    let state = $d42da6e692e216cc$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7fPBF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $d42da6e692e216cc$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $d42da6e692e216cc$var$savedScrollPositions = {};
function $d42da6e692e216cc$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $d42da6e692e216cc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $d42da6e692e216cc$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $d42da6e692e216cc$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d42da6e692e216cc$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7fPBF.useContext($d42da6e692e216cc$export$3044ab7fdabeaee6);
    let location = $d42da6e692e216cc$export$45d76561a5302f2b();
    let matches = $d42da6e692e216cc$export$2378eb7f5ff86053();
    let navigation = $d42da6e692e216cc$export$d0fd4b7106de2769();
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $d42da6e692e216cc$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $d42da6e692e216cc$var$getScrollRestorationKey(location, matches, basename, getKey);
            $d42da6e692e216cc$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d42da6e692e216cc$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d42da6e692e216cc$var$savedScrollPositions));
        } catch (error) {
            $d42da6e692e216cc$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d42da6e692e216cc$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d42da6e692e216cc$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($d42da6e692e216cc$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$d42da6e692e216cc$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $d42da6e692e216cc$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $d42da6e692e216cc$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $d42da6e692e216cc$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $d42da6e692e216cc$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $d42da6e692e216cc$export$b273b3273281a049(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $d42da6e692e216cc$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7fPBF.useContext($d42da6e692e216cc$export$3681f408decb40d1);
    $d42da6e692e216cc$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $d42da6e692e216cc$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $d42da6e692e216cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $d42da6e692e216cc$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $d42da6e692e216cc$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $d42da6e692e216cc$export$81336c211d5ff295(path.pathname, nextPath) != null || $d42da6e692e216cc$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $d42da6e692e216cc$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $d42da6e692e216cc$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $d42da6e692e216cc$var$getStatelessNavigator();
    return /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $d42da6e692e216cc$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $d42da6e692e216cc$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $d42da6e692e216cc$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $d42da6e692e216cc$var$serializeErrors(context.errors)
        };
        let json = $d42da6e692e216cc$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7fPBF.createElement($d42da6e692e216cc$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7fPBF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $d42da6e692e216cc$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($d42da6e692e216cc$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $d42da6e692e216cc$var$getStatelessNavigator() {
    return {
        createHref: $d42da6e692e216cc$var$createHref,
        encodeLocation: $d42da6e692e216cc$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $d42da6e692e216cc$export$69163f0b72ec60d9(routes, opts) {
    return $d42da6e692e216cc$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $d42da6e692e216cc$export$9269a41d8c4635e
    });
}
function $d42da6e692e216cc$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $d42da6e692e216cc$export$87cb1a9238dc3fba(routes, $d42da6e692e216cc$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $d42da6e692e216cc$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $d42da6e692e216cc$var$createHref,
        encodeLocation: $d42da6e692e216cc$var$encodeLocation,
        getFetcher () {
            return $d42da6e692e216cc$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $d42da6e692e216cc$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $d42da6e692e216cc$var$createHref(to) {
    return typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to);
}
function $d42da6e692e216cc$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $d42da6e692e216cc$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $d42da6e692e216cc$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}




var $7fPBF = parcelRequire("7fPBF");

const $5ac8335867650de3$export$12d836cf94aabb97 = {
    home: ()=>"/",
    signIn: ()=>"/signIn",
    albums: {
        list: ()=>"/albums"
    },
    attributes: {
        manage: ()=>"/attributes"
    },
    userProfile: ()=>"/profile",
    stats: ()=>"/stats",
    guest: ()=>"/guest",
    marketplace: ()=>"/marketplace",
    listeningSessions: ()=>"/sessions",
    layout: ()=>"/layout",
    admin: ()=>"/admin",
    share: ()=>"/share",
    private: ()=>"/private",
    payment: ()=>"/payment",
    paymentPatreon: ()=>"/paymentPatreon",
    notFound: ()=>"/notFound",
    maintenance: ()=>"/maintenance",
    documentation: {
        home: ()=>"/doc",
        about: (at)=>`/about${at ? `#${at}` : ""}`,
        users: {
            home: ()=>"/users",
            signUp: (at)=>`/users/signUp${at ? `#${at}` : ""}`,
            guest: ()=>"/users/guest",
            recoverPassword: ()=>"/users/recoverPassword"
        },
        album: {
            home: (at)=>`/album${at ? `#${at}` : ""}`,
            filterAlbums: ()=>"/album/filter",
            orderAlbums: ()=>"/album/order",
            markingAlbums: ()=>"/album/marks",
            scanBarcode: ()=>"/album/scanBarcode",
            importFromDiscogs: ()=>"/album/importFromDiscogs",
            importFromExcel: ()=>"/album/importFromSpreadsheet",
            imageGallery: ()=>"/album/imageGallery",
            removeFilteredAlbums: ()=>"/album/removeFiltered"
        },
        albumAttributes: {
            home: ()=>"/albumAttributes",
            artists: ()=>"/albumAttributes/artists"
        },
        collections: {
            home: (at)=>`/collections${at ? `#${at}` : ""}`,
            attributes: (at)=>`/collections/attributes${at ? `#${at}` : ""}`,
            publicCollections: ()=>"/collections/public"
        },
        userProfile: (at)=>`/userProfile${at ? `#${at}` : ""}`,
        purchases: (at)=>`/purchases${at ? `#${at}` : ""}`,
        subscriptions: {
            home: ()=>`/subscriptions`,
            mercadoPago: ()=>"/subscriptions/mercadoPago"
        },
        policy: ()=>"/policy",
        terms: ()=>"/terms"
    }
};



parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $bcf0b749eb2c1823$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    UserRole["admin"] = "admin";
    UserRole["common"] = "common";
    UserRole["collector"] = "collector";
    UserRole["premium"] = "premium";
    UserRole["guest"] = "guest";
    return UserRole;
}({});


var $acb616c6cdb93ae1$exports = {};

$parcel$export($acb616c6cdb93ae1$exports, "extract", function () { return $acb616c6cdb93ae1$export$f9380c9a627682d3; });
$parcel$export($acb616c6cdb93ae1$exports, "parse", function () { return $acb616c6cdb93ae1$export$98e6a39c04603d36; });
$parcel$export($acb616c6cdb93ae1$exports, "stringify", function () { return $acb616c6cdb93ae1$export$fac44ee5b035f737; });
$parcel$export($acb616c6cdb93ae1$exports, "parseUrl", function () { return $acb616c6cdb93ae1$export$7a5253c0f62e0150; });
$parcel$export($acb616c6cdb93ae1$exports, "stringifyUrl", function () { return $acb616c6cdb93ae1$export$a8c1621ea79325d3; });
$parcel$export($acb616c6cdb93ae1$exports, "pick", function () { return $acb616c6cdb93ae1$export$357523c63a2253b9; });
$parcel$export($acb616c6cdb93ae1$exports, "exclude", function () { return $acb616c6cdb93ae1$export$44c361b8ec72ef7f; });
const $67b1249d88ff3c9a$var$token = '%[a-f0-9]{2}';
const $67b1249d88ff3c9a$var$singleMatcher = new RegExp('(' + $67b1249d88ff3c9a$var$token + ')|([^%]+?)', 'gi');
const $67b1249d88ff3c9a$var$multiMatcher = new RegExp('(' + $67b1249d88ff3c9a$var$token + ')+', 'gi');
function $67b1249d88ff3c9a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $67b1249d88ff3c9a$var$decodeComponents(left), $67b1249d88ff3c9a$var$decodeComponents(right));
}
function $67b1249d88ff3c9a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($67b1249d88ff3c9a$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $67b1249d88ff3c9a$var$decodeComponents(tokens, i).join('');
            tokens = input.match($67b1249d88ff3c9a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $67b1249d88ff3c9a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    let match = $67b1249d88ff3c9a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $67b1249d88ff3c9a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $67b1249d88ff3c9a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    return input;
}
function $67b1249d88ff3c9a$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $67b1249d88ff3c9a$var$customDecodeURIComponent(encodedURI);
    }
}


function $55900e79e16017b8$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (string === '' || separator === '') return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $3b9588f478f30ba8$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $3b9588f478f30ba8$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $3b9588f478f30ba8$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $3b9588f478f30ba8$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $acb616c6cdb93ae1$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $acb616c6cdb93ae1$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $acb616c6cdb93ae1$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $acb616c6cdb93ae1$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            '[',
                            $acb616c6cdb93ae1$var$encode(index, options),
                            ']=',
                            $acb616c6cdb93ae1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            '[]=',
                            $acb616c6cdb93ae1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            ':list=',
                            $acb616c6cdb93ae1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $acb616c6cdb93ae1$var$encode(key, options),
                                keyValueSep,
                                $acb616c6cdb93ae1$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $acb616c6cdb93ae1$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $acb616c6cdb93ae1$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $acb616c6cdb93ae1$var$encode(key, options),
                            '=',
                            $acb616c6cdb93ae1$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $acb616c6cdb93ae1$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $acb616c6cdb93ae1$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $acb616c6cdb93ae1$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$acb616c6cdb93ae1$var$decode(item, options)) : value === null ? value : $acb616c6cdb93ae1$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $acb616c6cdb93ae1$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$acb616c6cdb93ae1$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $acb616c6cdb93ae1$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $acb616c6cdb93ae1$var$encode(value, options) {
    if (options.encode) return options.strict ? $acb616c6cdb93ae1$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $acb616c6cdb93ae1$var$decode(value, options) {
    if (options.decode) return (0, $67b1249d88ff3c9a$export$2e2bcd8739ae039)(value);
    return value;
}
function $acb616c6cdb93ae1$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $acb616c6cdb93ae1$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $acb616c6cdb93ae1$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $acb616c6cdb93ae1$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $acb616c6cdb93ae1$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $acb616c6cdb93ae1$export$f9380c9a627682d3(input) {
    input = $acb616c6cdb93ae1$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $acb616c6cdb93ae1$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $acb616c6cdb93ae1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $acb616c6cdb93ae1$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== 'string') return returnValue;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return returnValue;
    for (const parameter of query.split('&')){
        if (parameter === '') continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;
        let [key, value] = (0, $55900e79e16017b8$export$2e2bcd8739ae039)(parameter_, '=');
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $acb616c6cdb93ae1$var$decode(value, options);
        formatter($acb616c6cdb93ae1$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === 'object' && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $acb616c6cdb93ae1$var$parseValue(value2, options);
        else returnValue[key] = $acb616c6cdb93ae1$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $acb616c6cdb93ae1$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $acb616c6cdb93ae1$export$fac44ee5b035f737(object, options) {
    if (!object) return '';
    options = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        ...options
    };
    $acb616c6cdb93ae1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $acb616c6cdb93ae1$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $acb616c6cdb93ae1$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $acb616c6cdb93ae1$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $acb616c6cdb93ae1$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $acb616c6cdb93ae1$var$encode(key, options) + '=' + $acb616c6cdb93ae1$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
}
function $acb616c6cdb93ae1$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $55900e79e16017b8$export$2e2bcd8739ae039)(url, '#');
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split('?')?.[0] ?? '',
        query: $acb616c6cdb93ae1$export$98e6a39c04603d36($acb616c6cdb93ae1$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $acb616c6cdb93ae1$var$decode(hash, options)
        } : {}
    };
}
function $acb616c6cdb93ae1$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$acb616c6cdb93ae1$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $acb616c6cdb93ae1$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $acb616c6cdb93ae1$export$f9380c9a627682d3(object.url);
    const query = {
        ...$acb616c6cdb93ae1$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $acb616c6cdb93ae1$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $acb616c6cdb93ae1$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$acb616c6cdb93ae1$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $acb616c6cdb93ae1$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$acb616c6cdb93ae1$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $acb616c6cdb93ae1$export$7a5253c0f62e0150(input, options);
    return $acb616c6cdb93ae1$export$a8c1621ea79325d3({
        url: url,
        query: (0, $3b9588f478f30ba8$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $acb616c6cdb93ae1$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $acb616c6cdb93ae1$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $8cc3d14fcf9888ac$export$2e2bcd8739ae039 = $acb616c6cdb93ae1$exports;


const $225b141716ede244$export$7dc6752a22ab011a = {
    url: "https://piper-cloud-run-xefokvu6ea-ue.a.run.app",
    relyingParty: "piper.ldelosheros.com"
};




/**
 * Return the current interface language
 * If the navigator object is defined it returns the current navigator language
 * otherwise it falls back to 'en-US'
 * Works in browsers
 */ function $f28455d3f9b87a3b$export$7d2b86a77789ad19() {
    const defaultLang = 'en-US';
    if (typeof navigator === 'undefined') return defaultLang;
    const nav = navigator; // eslint-disable-line no-undef
    if (nav) {
        if (nav.language) return nav.language;
        if (!!nav.languages && !!nav.languages[0]) return nav.languages[0];
        if (nav.userLanguage) return nav.userLanguage;
        if (nav.browserLanguage) return nav.browserLanguage;
    }
    return defaultLang;
}
function $f28455d3f9b87a3b$export$382445f9a978e799(language, props) {
    // If an object with the passed language key exists return it
    if (props[language]) return language;
    // if the string is composed try to find a match with only the first language identifiers (en-US --> en)
    const idx = language.indexOf('-');
    const auxLang = idx >= 0 ? language.substring(0, idx) : language;
    return props[auxLang] ? auxLang : Object.keys(props)[0];
}
function $f28455d3f9b87a3b$export$26479fd75c7787bf(translationKeys) {
    const reservedNames = [
        '_interfaceLanguage',
        '_language',
        '_defaultLanguage',
        '_defaultLanguageFirstLevelKeys',
        '_props'
    ];
    translationKeys.forEach((key)=>{
        if (reservedNames.indexOf(key) !== -1) throw new Error(`${key} cannot be used as a key. It is a reserved word.`);
    });
}
function $f28455d3f9b87a3b$export$28e5fcf410cf1540(len) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for(let i = 0; i < len; i += 1)text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}


/**
 * Simple module to localize the React interface using the same syntax
 * used in the ReactNativeLocalization module
 * (https://github.com/stefalda/ReactNativeLocalization)
 *
 * Originally developed by Stefano Falda (stefano.falda@gmail.com)
 *
 * It uses a call to the Navigator/Browser object to get the current interface language,
 * then display the correct language strings or the default language (the first
 * one if a match is not found).
 *
 * How to use:
 * Check the instructions at:
 * https://github.com/stefalda/localized-strings
 */ const $353b7894a13e12ef$var$placeholderReplaceRegex = /(\{[\d|\w]+\})/;
const $353b7894a13e12ef$var$placeholderReferenceRegex = /(\$ref\{[\w|.]+\})/;
class $353b7894a13e12ef$export$2e2bcd8739ae039 {
    /**
   * Constructor used to provide the strings objects in various language and the optional callback to get
   * the interface language
   * @param {*} props - the strings object
   * @param {Function} options.customLanguageInterface - the optional method to use to get the InterfaceLanguage
   * @param {Boolean} options.pseudo - convert all strings to pseudo, helpful when implementing
   * @param {Boolean} options.pseudoMultipleLanguages - add 40% to pseudo, helps with translations in the future
   * @param {Boolean} options.logsEnabled - Enable/Disable console.log outputs (default=true)
   */ constructor(props, options){
        // Compatibility fix with previous version
        if (typeof options === "function") /* eslint-disable no-param-reassign */ options = {
            customLanguageInterface: options
        };
        this._opts = Object.assign({}, {
            customLanguageInterface: $f28455d3f9b87a3b$export$7d2b86a77789ad19,
            pseudo: false,
            pseudoMultipleLanguages: false,
            logsEnabled: true
        }, options);
        this._interfaceLanguage = this._opts.customLanguageInterface();
        this._language = this._interfaceLanguage;
        this.setContent(props);
    }
    /**
   * Set the strings objects based on the parameter passed in the constructor
   * @param {*} props
   */ setContent(props) {
        const [defaultLang] = Object.keys(props);
        this._defaultLanguage = defaultLang;
        this._defaultLanguageFirstLevelKeys = [];
        // Store locally the passed strings
        this._props = props;
        $f28455d3f9b87a3b$export$26479fd75c7787bf(Object.keys(props[this._defaultLanguage]));
        // Store first level keys (for identifying missing translations)
        Object.keys(this._props[this._defaultLanguage]).forEach((key)=>{
            if (typeof this._props[this._defaultLanguage][key] === "string") this._defaultLanguageFirstLevelKeys.push(key);
        });
        // Set language to its default value (the interface)
        this.setLanguage(this._interfaceLanguage);
        // Developermode with pseudo
        if (this._opts.pseudo) this._pseudoAllValues(this._props);
    }
    /**
   * Replace all strings to pseudo value
   * @param {Object} obj - Loopable object
   */ _pseudoAllValues(obj) {
        Object.keys(obj).forEach((property)=>{
            if (typeof obj[property] === "object") this._pseudoAllValues(obj[property]);
            else if (typeof obj[property] === "string") {
                if (obj[property].indexOf("[") === 0 && obj[property].lastIndexOf("]") === obj[property].length - 1) // already psuedo fixed
                return;
                // @TODO must be a way to get regex to find all replaceble strings except our replacement variables
                const strArr = obj[property].split(" ");
                for(let i = 0; i < strArr.length; i += 1){
                    if (strArr[i].match($353b7894a13e12ef$var$placeholderReplaceRegex)) ;
                    else if (strArr[i].match($353b7894a13e12ef$var$placeholderReferenceRegex)) ;
                    else {
                        let len = strArr[i].length;
                        if (this._opts.pseudoMultipleLanguages) len = parseInt(len * 1.4, 10); // add length with 40%
                        strArr[i] = $f28455d3f9b87a3b$export$28e5fcf410cf1540(len);
                    }
                }
                obj[property] = `[${strArr.join(" ")}]`; // eslint-disable-line no-param-reassign
            }
        });
    }
    /**
   * Can be used from ouside the class to force a particular language
   * indipendently from the interface one
   * @param {*} language
   */ setLanguage(language) {
        // Check if exists a translation for the current language or if the default
        // should be used
        const bestLanguage = $f28455d3f9b87a3b$export$382445f9a978e799(language, this._props);
        const defaultLanguage = Object.keys(this._props)[0];
        this._language = bestLanguage;
        // Associate the language object to the this object
        if (this._props[bestLanguage]) {
            // delete default propery values to identify missing translations
            for(let i = 0; i < this._defaultLanguageFirstLevelKeys.length; i += 1)delete this[this._defaultLanguageFirstLevelKeys[i]];
            let localizedStrings = Object.assign({}, this._props[this._language]);
            Object.keys(localizedStrings).forEach((key)=>{
                this[key] = localizedStrings[key];
            });
            // Now add any string missing from the translation but existing in the default language
            if (defaultLanguage !== this._language) {
                localizedStrings = this._props[defaultLanguage];
                this._fallbackValues(localizedStrings, this);
            }
        }
    }
    /**
   * Load fallback values for missing translations
   * @param {*} defaultStrings
   * @param {*} strings
   */ _fallbackValues(defaultStrings, strings) {
        Object.keys(defaultStrings).forEach((key)=>{
            if (Object.prototype.hasOwnProperty.call(defaultStrings, key) && !strings[key] && strings[key] !== "") {
                strings[key] = defaultStrings[key]; // eslint-disable-line no-param-reassign
                if (this._opts.logsEnabled) console.log(`\u{1F6A7} \u{1F477} key '${key}' not found in localizedStrings for language ${this._language} \u{1F6A7}`);
            } else if (typeof strings[key] !== "string") // It's an object
            this._fallbackValues(defaultStrings[key], strings[key]);
        });
    }
    /**
   * The current language displayed (could differ from the interface language
   * if it has been forced manually and a matching translation has been found)
   */ getLanguage() {
        return this._language;
    }
    /**
   * The current interface language (could differ from the language displayed)
   */ getInterfaceLanguage() {
        return this._interfaceLanguage;
    }
    /**
   * Return an array containing the available languages passed as props in the constructor
   */ getAvailableLanguages() {
        if (!this._availableLanguages) {
            this._availableLanguages = [];
            Object.keys(this._props).forEach((key)=>{
                this._availableLanguages.push(key);
            });
        }
        return this._availableLanguages;
    }
    // Format the passed string replacing the numbered or tokenized placeholders
    // eg. 1: I'd like some {0} and {1}, or just {0}
    // eg. 2: I'd like some {bread} and {butter}, or just {bread}
    // eg. 3: I'd like some $ref{bread} and $ref{butter}, or just $ref{bread}
    // Use example:
    // eg. 1: strings.formatString(strings.question, strings.bread, strings.butter)
    // eg. 2: strings.formatString(strings.question, { bread: strings.bread, butter: strings.butter })
    // eg. 3: strings.formatString(strings.question)
    formatString(str, ...valuesForPlaceholders) {
        let input = str || "";
        if (typeof input === "string") input = this.getString(str, null, true) || input;
        const ref = input.split($353b7894a13e12ef$var$placeholderReferenceRegex).filter((textPart)=>!!textPart).map((textPart)=>{
            if (textPart.match($353b7894a13e12ef$var$placeholderReferenceRegex)) {
                const matchedKey = textPart.slice(5, -1);
                const referenceValue = this.getString(matchedKey);
                if (referenceValue) return referenceValue;
                if (this._opts.logsEnabled) console.log(`No Localization ref found for '${textPart}' in string '${str}'`);
                // lets print it another way so next replacer doesn't find it
                return `$ref(id:${matchedKey})`;
            }
            return textPart;
        }).join("");
        return ref.split($353b7894a13e12ef$var$placeholderReplaceRegex).filter((textPart)=>!!textPart).map((textPart)=>{
            if (textPart.match($353b7894a13e12ef$var$placeholderReplaceRegex)) {
                const matchedKey = textPart.slice(1, -1);
                let valueForPlaceholder = valuesForPlaceholders[matchedKey];
                // If no value found, check if working with an object instead
                if (valueForPlaceholder === undefined) {
                    const valueFromObjectPlaceholder = valuesForPlaceholders[0][matchedKey];
                    if (valueFromObjectPlaceholder !== undefined) valueForPlaceholder = valueFromObjectPlaceholder;
                    else // If value still isn't found, then it must have been undefined/null
                    return valueForPlaceholder;
                }
                return valueForPlaceholder;
            }
            return textPart;
        }).join("");
    }
    // Return a string with the passed key in a different language or defalt if not set
    // We allow deep . notation for finding strings
    getString(key, language, omitWarning = false) {
        try {
            let current = this._props[language || this._language];
            const paths = key.split(".");
            for(let i = 0; i < paths.length; i += 1){
                if (current[paths[i]] === undefined) throw Error(paths[i]);
                current = current[paths[i]];
            }
            return current;
        } catch (ex) {
            if (!omitWarning && this._opts.logsEnabled) console.log(`No localization found for key '${key}' and language '${language}', failed on ${ex.message}`);
        }
        return null;
    }
    /**
   * The current props (locale object)
   */ getContent() {
        return this._props;
    }
}


var $2a93defe0440ad2b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2a93defe0440ad2b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2a93defe0440ad2b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2a93defe0440ad2b$export$2e2bcd8739ae039 = $2a93defe0440ad2b$var$formatDistance;


function $55e1f9cf760fc530$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $a6fa3c1fbba4fd67$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a6fa3c1fbba4fd67$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a6fa3c1fbba4fd67$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a6fa3c1fbba4fd67$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a6fa3c1fbba4fd67$export$2e2bcd8739ae039 = $a6fa3c1fbba4fd67$var$formatLong;


var $5f9228dede0d6aa7$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $5f9228dede0d6aa7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5f9228dede0d6aa7$var$formatRelativeLocale[token];
};
var $5f9228dede0d6aa7$export$2e2bcd8739ae039 = $5f9228dede0d6aa7$var$formatRelative;


function $457628062959e556$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $0ff1d0e06551a5c1$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $0ff1d0e06551a5c1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0ff1d0e06551a5c1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $0ff1d0e06551a5c1$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $0ff1d0e06551a5c1$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $0ff1d0e06551a5c1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $0ff1d0e06551a5c1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $0ff1d0e06551a5c1$var$localize = {
    ordinalNumber: $0ff1d0e06551a5c1$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0ff1d0e06551a5c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0ff1d0e06551a5c1$export$2e2bcd8739ae039 = $0ff1d0e06551a5c1$var$localize;


function $f58f09468deb70ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f58f09468deb70ae$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f58f09468deb70ae$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f58f09468deb70ae$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f58f09468deb70ae$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ed51bd2201b1ffe0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $7cafbb556cfb2776$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7cafbb556cfb2776$var$parseOrdinalNumberPattern = /\d+/i;
var $7cafbb556cfb2776$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7cafbb556cfb2776$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7cafbb556cfb2776$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7cafbb556cfb2776$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7cafbb556cfb2776$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7cafbb556cfb2776$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7cafbb556cfb2776$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7cafbb556cfb2776$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7cafbb556cfb2776$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $7cafbb556cfb2776$var$matchOrdinalNumberPattern,
        parsePattern: $7cafbb556cfb2776$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7cafbb556cfb2776$export$2e2bcd8739ae039 = $7cafbb556cfb2776$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $fbb6af908147d006$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2a93defe0440ad2b$export$2e2bcd8739ae039),
    formatLong: (0, $a6fa3c1fbba4fd67$export$2e2bcd8739ae039),
    formatRelative: (0, $5f9228dede0d6aa7$export$2e2bcd8739ae039),
    localize: (0, $0ff1d0e06551a5c1$export$2e2bcd8739ae039),
    match: (0, $7cafbb556cfb2776$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fbb6af908147d006$export$2e2bcd8739ae039 = $fbb6af908147d006$var$locale;


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}


const $85ebbb99b2811e17$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $ae7ac3a23918bc42$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    fieldClearLabel: 'Clear value',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $ae7ac3a23918bc42$export$1af4c7e47ad72f44 = $ae7ac3a23918bc42$var$enUSPickers;
const $ae7ac3a23918bc42$export$137380d9ce54f7f = (0, $85ebbb99b2811e17$export$67c96d35a1b010b3)($ae7ac3a23918bc42$var$enUSPickers);


var $14f2e0a8857acb20$exports = {};
$14f2e0a8857acb20$exports = $parcel$resolve("b4Vu0");


const $9daa41d3b051bf64$var$deleteImage = new URL($14f2e0a8857acb20$exports).href;
var $925ac09cdd03a6ca$exports = {};
$925ac09cdd03a6ca$exports = $parcel$resolve("hHlnj");


const $9daa41d3b051bf64$var$createImage = new URL($925ac09cdd03a6ca$exports).href;
const $9daa41d3b051bf64$export$8cca8d1e3e513d09 = {
    title: "Albums",
    home_title: "Manage your albums",
    description: `We call an album to the group of audio recordings issued on vinyl discs, compact discs, cassettes, etc. Albums on Piper have different attributes fully customizable so you can manage your collection the way it best suits you. You count with a lot of sorting and filtering options for your albums so you can view them by artist, label and more.
  
  You can also organize your albums by multiple collections and review statistics independently for each one.
  
  Think big! Add to your collection all your vinyl, CD's, or even albums you own on digital format. Personalize your collection to suit your needs.

`,
    create_title: "Add an album",
    create_image: $9daa41d3b051bf64$var$createImage,
    create_description: `
  In order to add a new album you just need to click on the '+' button on the toolbar in the 'My albums' page.
  
  A new dialog will appear where you can enter all the attributes for the new album. You can navigate through the fields by clicking them or using the TAB key and the ENTER key when a selection is required.
  
  To modify the image you can drag and drop the new one, or just click on the old image to select the new one.
  
  Once you confirm, a red text will appear below any missing required field. If all the mandatory fields are completed, then the album will be created.
  
`,
    delete_image: $9daa41d3b051bf64$var$deleteImage,
    delete_title: "Delete an album",
    delete_description: `To delete an album, right click on it from the album list and select the option to delete it. A confirmation dialog will appear so you can double check the album name before removing it.
  
  This process is irreversible, so make sure you are removing the right album. The deleted album will be unassigned from all the collections it was assigned to. If someone had access to a shared link of the removed album, they will still be able to see the public collection and the album will simply not load.

`
};


var $d188bb65eaf96896$exports = {};
$d188bb65eaf96896$exports = $parcel$resolve("kB2u8");


const $fc466607539d580f$var$importDiscogsImage = new URL($d188bb65eaf96896$exports).href;
const $fc466607539d580f$export$c41fffa845e1b6ab = {
    title: "Import albums from Discogs",
    import_image: $fc466607539d580f$var$importDiscogsImage,
    description: `If you have a Discogs account you can import your albums to Piper. Just select the option from the menu drawer and a dialog will open.
  
  If it's your first time doing it, the browser will redirect to Discogs so you can sign in and grant permission to Piper to see your collection.
  
  After giving permission you will be able to select which Discogs folder will be imported. This is especially useful if you want to import only some of your albums. If you already have a part of your collection imported you can check the option to skip albums with same release ID. This will make sure that those albums are not duplicated during this process
  
  If you have a premium subscription plan, you can also check the option to retrieve the album images directly from Discogs (only the front cover). This comes with the drawback of making the process last longer.
  
  Once a Discogs folder is selected you can optionally select a collection to which these albums will be assigned. Either way, you will always find the albums on the 'All albums' collection.
  
  Take into account that the import process can take several minutes depending on the number of albums that have to be imported. The process will be executed in our servers so you can close the window and keep using the app while the import runs. If you go back to the import dialog you can check the progress or cancel.
  
  The imported albums will have some missing parameters, so you will have to review them and make any modifications you feel necessary.

`
};


const $cdc28c7e83edddec$export$b5ad9a92648612e5 = {
    title: "Privacy Policy",
    title_short: "P. Policy",
    block1: `One of our main priorities at Piper is the privacy of our users. This Privacy Policy document contains types of information that is collected and recorded by Piper and how we use it.
  
  If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
  
  This Privacy Policy applies only to our online activities and is valid for users of our app in regard to the information that they shared and/or collect in Piper. This policy is not applicable to any information collected offline or via channels other than this app.
  
  `,
    consent_title: "Consent",
    consent: `By using our app, you hereby consent to our Privacy Policy and agree to its terms.
  
  `,
    info_collect_title: "Information we collect",
    info_collect: `The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
  If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
  When you register for an Account we will only ask for your email address and a password.
  
  `,
    sensitive_info_title: "Sensitive information",
    sensitive_info_description: `We consider sensitive information your password, access tokens, and private messages you send to other users. All of those fields are saved encrypted in our database, so no one can read that data without the encryption key.
  
  `,
    info_use_title: "How we use your information",
    info_use: `We use the information we collect in various ways, including to:
  `,
    info_use_1: "Provide, operate, and maintain our app.",
    info_use_2: "Improve, personalize, and expand our app.",
    info_use_3: "Understand and analyze how you use our app.",
    info_use_4: "Develop new products, services, features, and functionalities.",
    info_use_5: "Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the app, and for marketing and promotional purposes.",
    info_use_6: "Send you emails.",
    info_use_7: `Find and prevent fraud.
  
  `,
    log_files_title: "Log Files",
    log_files: `Piper follows a standard procedure of using log files. These files log visitors when they visit and use our app. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
  
  `,
    cookies_title: "Cookies",
    cookies: `Like any other website, Piper uses "cookies". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
  
  `,
    third_parties_title: "Third Party Privacy Policies",
    third_parties: `Piper's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.

  You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
  
  `,
    ai_info_title: "Use of AI-Powered Features",
    ai_info: `Piper includes one feature (Album insights) that uses artificial intelligence (AI) services provided by a third-party vendor, OpenAI. When you use this feature, the app submits the following information of the album: name, artist, label, catalog number, gradings, origin, format, release year, tags, and Discogs release ID. This data is transmitted to OpenAI\u{2019}s API solely for the purpose of generating the requested output. We strongly recommend that you don't include any personal information on any of these fields.

The AI service is used only to support this specific feature and is not used elsewhere in the application. We do not sell personal data, and we do not permit OpenAI to use your data for any purpose other than providing this service to us.

Data processed through the AI feature is handled in accordance with this Privacy Policy and OpenAI\u{2019}s applicable data protection and security practices. AI-generated output may be inaccurate and should not be relied upon as professional advice or treated as truthful.

By using this AI-powered feature, you consent to the processing of your data as described above.

  `,
    ccpa_rights_title: "CCPA Privacy Rights (Do Not Sell My Personal Information)",
    ccpa_rights: `Under the CCPA, among other rights, California consumers have the right to:
  `,
    ccpa_rights_1: "Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.",
    ccpa_rights_2: "Request that a business delete any personal data about the consumer that a business has collected.",
    ccpa_rights_3: "Request that a business that sells a consumer's personal data, not sell the consumer's personal data.",
    ccpa_rights_end: `
  If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
  
  `,
    gdpr_rights_title: "GDPR Data Protection Rights",
    gdpr_rights: `We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
  `,
    gdpr_rights_1: "The right to access \u2013 You have the right to request copies of your personal data. We may charge you a fee for this service.",
    gdpr_rights_2: "The right to rectification \u2013 You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.",
    gdpr_rights_3: "The right to erasure \u2013 You have the right to request that we erase your personal data, under certain conditions.",
    gdpr_rights_4: "The right to restrict processing \u2013 You have the right to request that we restrict the processing of your personal data, under certain conditions.",
    gdpr_rights_5: "The right to object to processing \u2013 You have the right to object to our processing of your personal data, under certain conditions.",
    gdpr_rights_6: "The right to data portability \u2013 You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.",
    gdpr_rights_end: `
  If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
  
  `,
    children_title: "Children's Information",
    children: `Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
  
  Piper does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
  
  `,
    changes_title: "Changes to this Privacy Policy",
    changes: `We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.
  
  `,
    contact_title: "Contact us",
    contact: `If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
  
  
  `,
    last_update: "Last update: January 12th, 2026"
};


const $40fb39c427f4dba8$export$db20c90c7e082a55 = {
    title: "Terms of Service",
    title_short: "T. of Service",
    block1: `Piper started as a personal project that gradually grew and continues to do so day by day. Piper and its domain ldelosheros.com are owned by Lautaro de los Heros ("Piper", "The application", "The app", "We", "Our, "Us") and it's provided to you ("The user", "You", "Your) under these terms of service. The conditions in this Terms of Service document apply to all users who use the application, both in its web and mobile versions.
  
  If you have additional questions or require more information about these terms, do not hesitate to contact us.
  
  `,
    consent_title: "Consent",
    consent: `By using our app you agree to our terms of service without objection.
  
  `,
    service_title: "About the service",
    service: `Piper is an application that allows its users to upload information about their music collection, such as albums, artists, record labels and more, as well as certain personal data protected according to our Privacy Policy.
  
  Piper also offers its users the possibility to freely share content from their collections with other users.
  
  `,
    data_title: "About the data",
    data: `All data stored in Piper has a backup that is updated every day, except for errors or causes beyond Piper's control. This backup serves as a return point in case of extreme need or to search for historical data of a user who so requires. This does not mean that this information is available at all times, but you can get in touch for more details.
  
  You can consult our Privacy Policy to find out how we handle your data.
  
  Piper's responsibilities with respect to this data are specified in these terms of service below.
  
  `,
    ai_info_title: "AI-powered features",
    ai_info: `Piper includes a limited feature (Album insights) that uses artificial intelligence (AI) to generate automated output based on an album. This feature is provided for informational and assistive purposes only. AI-generated output may be inaccurate and should not be relied upon as professional advice or treated as truthful.

You are solely responsible for how you use any output generated by the AI feature. We make no warranties regarding the accuracy, completeness, or reliability of such output and disclaim all liability arising from reliance on it. We may modify, suspend, or discontinue the AI feature at any time.

  `,
    subscriptions_title: "About purchases and subscriptions",
    subscriptions: `Purchases and subscriptions are the only way to cover Piper's production costs and keep the app ad-free.

Purchases are one-time payments that extend the user's access to various Piper resources. They are credited immediately after a successful payment.

All subscriptions are automatically debited within the specified period. The exact payment method and date vary depending on the payment platform chosen when signing up for the subscription.

The current purchase or subscription amount is refundable only if the user expresses their intention to request a refund up to 48 hours after the purchase or subscription is charged, and provided the terms of service in this document are met. In the event of a refund, the purchase or subscription will be automatically canceled, and the user will no longer receive the benefits of the purchase or subscription at that time.

If the user wishes to cancel the subscription, they can do so from the payment platform or by contacting support. In this case, the subscription is canceled, and no further payments will be processed from that date, but the user will be able to continue using the subscription benefits until the expiration date. In the event of subscription cancellation, a refund is not available.

The amount of each purchase may be modified without prior notice. It will be visible in the corresponding menu at the time of purchase.
 
Subscription fees may be modified, and any changes will be announced through Piper's official communications channel up to 7 days in advance. The new amount will apply to all new subscriptions and will be charged to active subscriptions at the next applicable billing date.

Subscription fees may be subject to a temporary discount. This discount may be modified, and any changes will be announced through Piper's official communications channel up to 7 days in advance. The new amount will apply to all new subscriptions and will be charged to active subscriptions at the next applicable billing date.

User resource limits may be modified without prior notice if any abuse or attempt to violate the purchasing system is detected. This may be grounds for a temporary or permanent ban or suspension of the user.
 
  `,
    users_title: "About the users",
    users: `In order to be a Piper user, the following requirements must be met without exception:
  `,
    users_1: "Be over 13 years of age (or the legal minimum age in your territory).",
    users_2: "Always act in good faith.",
    users_3: "Always provide true information and that it does not go against good taste and good ethics, or that violates the rights of third parties.",
    users_4: "Under no circumstances is it allowed to attempt to violate or deceive the system.",
    users_5: "The contact and complaint channels must not be abused or misused.",
    users_6: "No data should be accessed or collected from our system in an automated manner or without proper permission.",
    users_7: "You must not exchange or request usernames and/or passwords from other users or appropriate access tokens.",
    users_8: "It is prohibited to sell or license products purchased from this application.",
    users_9: "You must not engage in abuse, aggression, or any type of aggressive action against any other user, whether by messaging or any relevant means.",
    users_10: "You must stop using the application immediately if you commit any illegal, deceptive, discriminatory or fraudulent act, or in the case of helping a third party to do so.",
    users_11: `You must not violate any of the points established in these terms of service.
  
  `,
    warranties_title: "Disclaimer of warranties",
    warranties: `By using this application you accept and understand that:
  `,
    warranties_1: `You use the service at your own risk. The service is offered "as is" and "as available", we disclaim any type of explicit or implicit warranty.`,
    warranties_2: "We make no warranty of any kind that the service will meet your expectations, that the service will be uninterrupted, timely, secure or error-free, that the results obtained from the use of the service will be accurate or reliable.",
    warranties_3: "We do not offer any warranty regarding the quality of the product, its services or the information provided, or that the material purchased or obtained through the service will meet your expectations.",
    warranties_4: "We do not offer a warranty that the errors present in the system will be fixed at some point.",
    warranties_5: `We do not promote or endorse any ideas or messages in user-generated content on the service.
  
  `,
    rights_title: "Rights and responsibilities",
    rights: `Piper reserves the right to temporarily or permanently ban or suspend any user who does not comply with any of the terms expressed in this document.
  
  Piper reserves the right to remove any content that it deems inappropriate or that does not comply with any of the terms expressed in this document.
  
  Piper reserves the right to partially or totally modify any username if a situation of identity theft is identified or for any other reason that is deemed pertinent, informing the user involved in a pertinent manner.
  
  Piper reserves the right to cancel the user's subscription if it deems appropriate, notifying the user accordingly.
  
  Piper reserves the right to decide whether or not to grant a refund, evaluating the particular case of the user.
  
  Piper reserves all rights not expressly granted.
  
  Piper provides its products "as is", and to the extent permitted by law, we do not guarantee that our services will function securely or without error, interruption, delay or imperfection. Similarly, to the extent permitted by law, WE DISCLAIM ALL LIABILITY, WHETHER EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. We have no control or influence over what people do or say. Furthermore, we are not responsible for their behavior or actions, whether online or offline, or for the content they share, including content that may be offensive, inappropriate, obscene, illegal, or objectionable.
  
  Piper limits its liability to the fullest extent permitted by applicable law, and under no circumstances will we be liable for any loss of profit, revenue, information or data; and for consequential, special, indirect, exemplary, punitive, or incidental damages arising out of these Terms of Service (from any cause and from any liability, including negligence), even if we have been advised of the possibility of such damages.
  
  `,
    maintenance_title: "Maintenance",
    maintenance: `The application may enter maintenance mode for an indefinite period of time, at any time, and without prior notice. In this event, users will not be able to access the application's content until the situation is rectified.
  
  `,
    links_title: "Links",
    links_description: "We and others related to the application may provide links to external websites or resources. Because Piper have no control over such websites and resources, you acknowledge and agree that we are not responsible for the availability of such external websites or resources, and do not endorse and are not responsible or liable for any content, advertising, products, or other materials on or available from such websites or resources. You further acknowledge and agree that Piper shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party website or resource. For example, Piper uses YouTube API Services to provide access to YouTube content. When using the YouTube player on the app, you are agreeing to be bound by the ",
    links_youtube_terms: "YouTube Terms of Service",
    changes_title: "Changes to these Terms of Service",
    changes: `We may update our Terms of Service from time to time. Therefore, we recommend that you check this page periodically for any changes. We will notify you of any changes by posting the new Terms of Service on this page. These changes are effective immediately after they are posted on this page, any user who continues to use the app after the changes are posted will be bound by the new terms.
  
  `,
    contact_title: "Contact us",
    contact: `If you have any questions or suggestions about our Terms of Service, feel free to contact us.
  
  If you witness any situation that may go against these terms you can report it using the same contact channel.
  
  
  `,
    last_update: "Last update: January 11th, 2026"
};


var $254be896c9064069$exports = {};
$254be896c9064069$exports = $parcel$resolve("k7I11");


const $ab029a9301c21c13$var$barImage = new URL($254be896c9064069$exports).href;
var $b93df82e2d4857a4$exports = {};
$b93df82e2d4857a4$exports = $parcel$resolve("iqhtb");


const $ab029a9301c21c13$var$orderImage = new URL($b93df82e2d4857a4$exports).href;
var $fc184b18128a03cc$exports = {};
$fc184b18128a03cc$exports = $parcel$resolve("bFc01");


const $ab029a9301c21c13$var$elementsImage = new URL($fc184b18128a03cc$exports).href;
const $ab029a9301c21c13$export$3388bd10fad0f1dc = {
    title: "Albums filter",
    home_title: "Filter your albums",
    bar_image: $ab029a9301c21c13$var$barImage,
    order_image: $ab029a9301c21c13$var$orderImage,
    elements_image: $ab029a9301c21c13$var$elementsImage,
    description: `Piper offers a powerful filter to view and organize your collection from different perspectives, so you can analyze the data from different angles. To open the filter window just click on the filter button on the toolbar.
  
`,
    order_description: `The first field allow you to select in which order your album list will be displayed. The default option is by artist, and the albums inside each artist will be displayed sorted by your own defined order (See the 'Order your albums' documentation.) The other order options include by label, purchase price, revenue, length, etc. In these cases, the albums will be grouped by the option selected and will be sorted by year and name inside each section.
  
  The second field will let you decide if the option selected will be applied in ascending or descending order.
  
`,
    elements_description: `The next section displays two tables. The one on the left displays all the possible filter options that can be applied. These allow you to select a specific label, year, sale price, that you want to restrict you album list to. In order to effectively apply any of these filter elements, select the checkbox of all the elements you want to apply and click on the right arrow. On the same note, select any elements you want to remove from the filter from the table on the right and click on the left arrow. You can also enter the desired value on any of the filter elements and they will be applied automatically.
  
  Each filter element will be required in the search criteria so, for example, if you have selected artist 'X' and label 'Y' the albums displayed will be the ones having artist 'X' AND having label 'X'.
  
  This is not true if you select multiple elements of the same kind though, in that case the search criteria will include all the albums that match any of those elements. So, for example, if you select artist 'X' and artist 'Y' the albums displayed will be the ones having artist 'X' OR having artist 'Y'.
  
`
};


var $9d0ff0e91bf5f2d5$exports = {};
$9d0ff0e91bf5f2d5$exports = $parcel$resolve("kgL0o");


const $0ff13c13bd4f75f8$var$prefsImage = new URL($9d0ff0e91bf5f2d5$exports).href;
var $8800d26772c19bcd$exports = {};
$8800d26772c19bcd$exports = $parcel$resolve("8iVUz");


const $0ff13c13bd4f75f8$var$albumImage = new URL($8800d26772c19bcd$exports).href;
const $0ff13c13bd4f75f8$export$373197abd871bcf9 = {
    title: "Ordering albums",
    home_title: "Order your albums",
    prefs_image: $0ff13c13bd4f75f8$var$prefsImage,
    album_image: $0ff13c13bd4f75f8$var$albumImage,
    description: `Once you create a new album, the album list will get updated showing the new album inside the artist section sorted at the bottom by default. This behavior can be customized on your user profile with the 'Order new albums automatically' preference. If you set this to 'NO', then when you create a new album it will be displayed at the top of the artist list with a warning. This means that album has yet to be ordered, since in the background it was assigned with an order equal to -1. This is helpful if you care about keeping your albums sorted by your preferred criteria, since this warning will only disappear when you manually give an order to the album.
  
`,
    drag_description: `To manually give order to your albums, simply drag and drop them on the albums list. This task can only be performed when you don't have any filters applied, or if the only filter elements at play are artist's ones.
  
`
};


const $ccb801b8c23cc74a$export$6dd379fc6e5f35de = {
    title: "Piper docs",
    description: `Thanks for using Piper! Here you can find several documents that explain all the things you can do with this app. You can navigate through the docs using the index right below.
  
`
};


const $c0bb94a33946a800$export$ed761d2fe331cbb3 = {
    title: "Subscriptions",
    home_title: "How subscriptions work",
    description: `To keep Piper up to date and free of advertisements we rely on our purchases and subscription systems. Users can use our app for free with certain limitations and can opt to subscribe using one of our available plans to support the app and access new functionalities.
  
  You can choose from these 3 plans we have available:
  
  `,
    free_plan: "Free plan: ",
    free_plan_description: `The free plan allows you to continue using Piper normally, but you won't have access to the additional features of other subscription plans.
  
  `,
    collector_plan: "Collector plan: ",
    collector_plan_description: `This plan does not include any additional features for now. With the 'Collector' subscription, you will be helping Piper grow and remain ad-free. This subscription does not have the benefits of the 'Premium' subscription.

Pay once per month. Cancel at any time.
  
  `,
    premium_plan: "Premium plan: ",
    premium_plan_description: `The 'Premium' subscription unlocks the following features:
  
  `,
    premium_plan_body_1: "Upload additional images for your albums using the image gallery.",
    premium_plan_body_2: `Use images from Discogs when importing albums.
  
  `,
    premium_plan_end: "Pay once per month. Cancel at any time.",
    access: `
  
To access the status of your current subscription or purchase another one, you can go to your user profile.
  
`
};


const $aee53751086b7b95$export$958dad51223257d7 = {
    title: "Subscribe using Mercado Pago",
    description: `Piper is integrated with Mercado Pago so you can pay your subscription using that platform. This kind of payment is available only on some countries of South America.
  
  If you have an account on Mercado Pago you can choose to pay using your existing account and you will be able to select any of your cards or even pay using your available funds. It's important that once the payment is done you use the button to go back to the site so we can register the subscription in our database. If you fail to do so you won't see the subscription on Piper, but don't worry, just contact us in that case and we will fix it for you as soon as possible. 
  
  The subscription can be managed entirely in the Mercado Pago platform. You can review your payments, when will your next charge be, cancel the subscription and more.
  
  The subscriptions are charged on the first day of each month. When you make the first payment, the amount paid will be proportional to the number of days left to the first day of the next month.
  
  If you cancel your subscription at any time you will still have your privileges until the first day of the next month.
  
`
};


var $c5f6139531464167$exports = {};
$c5f6139531464167$exports = $parcel$resolve("emNxK");


const $31f8457cd442d71b$var$albumListImage = new URL($c5f6139531464167$exports).href;
var $94b738799bb8a885$exports = {};
$94b738799bb8a885$exports = $parcel$resolve("96hBn");


const $31f8457cd442d71b$var$appStoreButton = new URL($94b738799bb8a885$exports).href;
const $31f8457cd442d71b$export$e2ab8fcb1ba5dc0e = {
    title: "What is Piper?",
    block1: `Thanks for using Piper! Here you will find a quick summary of what you can do with this app, how you can manage your music collection, make it your own, and maybe even share it with the world! Remember that you can always sign in as a guest and see for yourself an example of what a complete collection looks like on Piper.
  
  `,
    album_list_image: $31f8457cd442d71b$var$albumListImage,
    block2: `With Piper you will be able to add one by one all your albums in your collection. Or if you have your collection on Discogs already, you can import it in just a few steps.
  
  For each album track its artist, label, track list, sleeve and media conditions, notes and more!
  
  Use the powerful Layout page to add different shelving units and place your albums just as you have them organized in your room. You can choose the number of shelves and segments for each one of your shelving units, creating an exact replica of your real furniture.
  
  If you use a currency other than USD, you will also be able to input purchase prices, sale prices in your own currency and then calculate all your financial information adjusted by inflation using exchange rates. Piper let's you group albums in selling value categories, so you just need to update the price in one place and all your albums in that group will get updated, all defined in dollars so it will get automatically updated using the current exchange rate. 
  
  Use the powerful filter offered by Piper to search among your albums combining attributes, or even changing the grouping and order criterias. You will be able to order your collection by year, purchase price, artist, length, and more!
  
  Organize your albums by different collections, and define them as private or public so other users can see a part of your collection.
  
  Have a look at the statistics section to get to know better your collection, from totals and averages to complete graphs.
  
  Scan an album's barcode and add it to your Piper collection automatically! You can also search by text directly on the Discogs database and add albums that way.
  
  Generate private or public QR codes (and links) to quickly access to an album or collection.
  
  Play any song or album directly through Piper using YouTube.
  
  Explore albums and collections from other users using the exhibition section.
  
  
  And it doesn't end there, continue exploring the rest of the documentation (still in progress) to see all you can do or, even better, start using Piper to discover all it has to offer.
  
  `,
    mobile_title: "Use Piper on your phone!",
    mobile_description: `You can use Piper on mobile as well! See below how you can access the application depending on your platform of choice:
  
  `,
    android_title: "Android",
    android_description_1: `In order to use Piper on Android open your web browser and navigate to `,
    android_description_2: `
  Once the page loaded, search on your settings for an option to save the app icon on your desktop.
  
  Close the web browser and open Piper using the newly added app icon.
  
  `,
    ios_title: "iOS",
    ios_description: `Piper is available on the App Store!
  
  Scan this code and download the app or use the button:
`,
    app_store_button: $31f8457cd442d71b$var$appStoreButton
};


var $f7ae65108e8736d2$exports = {};
$f7ae65108e8736d2$exports = $parcel$resolve("hYbJU");


const $9655a299f310e708$var$signUpThirdPartyImage = new URL($f7ae65108e8736d2$exports).href;
var $b5c5d66f5e5fe3a6$exports = {};
$b5c5d66f5e5fe3a6$exports = $parcel$resolve("dE85W");


const $9655a299f310e708$var$newUserImage = new URL($b5c5d66f5e5fe3a6$exports).href;
const $9655a299f310e708$export$c71c41faa1de24b1 = {
    title: "Create a new user",
    title_users: "User account",
    home_title: "Sign up",
    description: `To use Piper you first need a user. You have three options for this:
  `,
    description_1: "Create a user using Piper.",
    description_2: "Sign up with Google.",
    description_3: "Sign up with Apple.",
    sign_up_third_party_title: "Sign up with Google/Apple",
    sign_up_third_party_image: $9655a299f310e708$var$signUpThirdPartyImage,
    sign_up_third_party_description: `The easiest way to sign up is to use one of the buttons to continue with Google or Apple. You will just have to log in using your existing credentials for any of those services and you will automatically get signed into Piper. It's that simple!
  
  The created user will have your email as a username but you can change it right away through your user profile. Any time you have to sign in again you can use the same button you used before, or you can create a password and sign in using it as well, all authentication methods are interchangeable.
  
`,
    sign_up_piper_title: "Sign up with Piper",
    sign_up_piper_image: $9655a299f310e708$var$newUserImage,
    sign_up_piper_description: `To sign up with Piper select the "create a new user" button, or select the same option on the drawer menu.
  
  A new window will open where you can enter your email address and a password. Once you enter those fields and accept the terms of service, a verification code will be sent to your email.
  
  When you try to sign in for the first time, the system will ask you for the verification code. Once you enter it you will be good to go!
  
  If you didn't get the code or you lost it you can ask for a new one using the resend button.
  
`
};


var $2c0c1f4317f65c7f$exports = {};
$2c0c1f4317f65c7f$exports = $parcel$resolve("9UoDG");


const $c66928e3a171c71c$var$optionsImage = new URL($2c0c1f4317f65c7f$exports).href;
var $fbd9aa9ce32a4c65$exports = {};
$fbd9aa9ce32a4c65$exports = $parcel$resolve("jvSqO");


const $c66928e3a171c71c$var$drawerImage = new URL($fbd9aa9ce32a4c65$exports).href;
const $c66928e3a171c71c$export$7b1ce76ed3f82777 = {
    title: "Sign in as guest",
    options_image: $c66928e3a171c71c$var$optionsImage,
    drawer_image: $c66928e3a171c71c$var$drawerImage,
    description: `You can sign in as a guest using the option inside the menu drawer. You won't need a password, you will get right into Piper with a pre-created collection full of albums, artists and more.
  
  While being a guest you won't be able to make any changes, but feel free to explore through the collection and check all the things you could do with your own collection. The only blocked section will be Statistics.
  
  Whenever you want to sign in with your own account, just close the guest session and you will be presented with the sign in page once again.
  
`
};


const $94d5f33e5857513d$export$d5426d5fe7dfc3b8 = {
    title: "Recover password",
    description: `If you ever forget your password you can reset it using the "Forgot your password?" button in the sign in page, or the "Recover password" option on the drawer menu.
  
  A new window will ask you to enter your email address and a new password. After confirming that a verification code will be sent to your email that you will have to enter in the next step.
  
  Once the code is validated you will be able to sign in normally sing the new password.
  
  You can always opt to sign in using Google or Apple using your existing account for either one.
  
`
};


var $377b631a94a0445e$exports = {};
$377b631a94a0445e$exports = $parcel$resolve("1wDfg");


const $418721900505f3ff$var$mainButtonsToolbarImage = new URL($377b631a94a0445e$exports).href;
const $418721900505f3ff$export$f27ef69adc960c33 = {
    title: "Scan barcode and search",
    home_title: "Add albums from a barcode or search",
    description: `Piper has the option to scan an album barcode directly from the jacket and search for it on Discogs. In the same manner you can search on the Discogs database using the free text search field by specifying part of a title, artist name, catalog number, etc.
  
  Use the "Add from barcode or search" option on the drawer menu o the scan button on the main toolbar to open the search window.
  
`,
    main_buttons_toolbar_image: $418721900505f3ff$var$mainButtonsToolbarImage,
    scan_title: "Scan a barcode",
    scan_description: `Select the camera button to toggle the camera on and off. Put the barcode in front of the camera until it is recognized and the window starts loading.
  
  The app will search on Discogs for the barcode and show any results.
  
  Select the desired album to automatically create it on Piper.
  
`,
    search_title: "Search for an album",
    search_description: `You can specify any kind of information about an album on the search bar and we will attempt to find any matches on the Discogs database.
  
  Once you entered the desired text use the 'start search' button to begin searching. The results, if any, will appear on a list below.
  
  Select the desired album to automatically create it on Piper.
  
`
};


const $36016b20ce653c88$export$cb5c3ea7ba53f1c9 = {
    title: "Image gallery",
    description: `If you have a 'Premium' account you can use the image gallery to further customize your albums. You will be able to add the back cover and spine images and up to 50 additional images for each one of your albums.
  
  The images will also be available on the exhibition for every album that is associated to a public collection.
  
  To edit an image just select it, or right click (hold press on mobile) and select the edit option. You can also drag and drop the new image into the old one to update it.
  
  Using the right click context menu you can also reorder the images, see its detail, or change the display name.
  
  `
};


const $5b6c76474f1d5514$export$51be0acb28ba999e = {
    title: "User profile",
    home_title: "User profile",
    description: `You can customize your user profile by selecting the profile card on the top right corner of the screen, or selecting the option on the drawer menu.
  
`,
    notifications_title: "Notifications",
    notifications_description: `Inside the user profile page you will find the notifications button. There you will find any official notifications sent to you, regarding general information, pricing changes or breaking news.
  
`,
    update_avatar_title: "Update your avatar",
    update_avatar_description: `To update your avatar just select it. The system will ask for a new image. The image size shall not be bigger than 10MiB.
  
`,
    username_title: "Update your username",
    username_description: `After you create your account, you will get a random username by default. You can update your username inside the user profile page. The new username has to be between 8 and 20 characters long, has to start with a letter and can't have special characters except for underscores.
  
`,
    email_title: "Update your email",
    email_description: `You can change your current email address inside the user profile page. Enter the new email address on the bottom text field and then select the save button. The new email will then be pending confirmation. If it passed some time since your last sign in, the system may ask you to enter your credentials again.
  
  At this stage, your email is still not changed, to do so you need to click on the verify button and enter the code we sent to your new email address. Once the code is verified, the new email will override the current one and you will be ready to go.
  
`,
    password_title: "Update your password",
    password_description: `Select the password field inside the user profile page to change it for a new one. A new dialog will ask for the current password and a new one that you will need to enter twice to prevent typing errors. If it passed some time since your last sign in, the system may ask you to enter your credentials again.
  
`,
    bio_title: "Bio",
    bio_description: `You can enter any information about you and your collection in your bio. This will be available to everyone on the Exhibition. If you search for your username on the Exhibition and select your profile you will see your public profile and what everyone is able to see about yourself.
  
`,
    currency_title: "Currency",
    currency_description: `Inside your user profile you will be able to change your currency. This will have effect on your whole collection and all your public collections will use this currency to show any monetary amounts if you decided to show them. Take into account that changing the currency will not update any amounts, only the currency symbol and code displayed.
  
  This currency will also be the one specified on your exchange rates, but take into account that changing the currency will not update in any way the amount of the exchange rates, only the currency symbol and code.
  
`,
    decimals_title: "Decimals for monetary amounts",
    decimals_description: `With this option you can decide whether the amounts displayed with your currency show decimals or not.
  
`,
    impacts_description_title: "Show rating descriptions",
    impacts_description_description: `With this option you can decide whether you want ratings to show their description alongside the star rating, or just the stars.
  
`,
    album_id_title: "Show album ID",
    album_id_description: `If you activate this option the internal album ID will be displayed at the bottom of each album detail. You can use this for personal reference or to refer to an album when contacting support.
  
`,
    colors_title: "Colors for non-colored discs",
    colors_description: `Enter here all the colors that you don't want to be counted as 'Colored albums' on your statistics. Enter each color individually and exactly as you entered on the albums.
    
`
};


const $0ff58104970c8294$export$7122114fca46c41 = {
    title: "Import albums from a spreadsheet",
    description_1: `You can import your albums to Piper from a spreadsheet file. Just select the option from the menu drawer and a dialog will open.
  
  Once inside the import window, select a file with the 'xlsx' extension. Spreadsheet files can be exported to this format in most programs.
  
  This file needs to have each album on a separate row, and its attributes have to be positioned on each column on a specific order. Each column can be either mandatory (this column needs to have data on each row), or optional (this column can be empty for some or all rows, but it has to be present, so leave an empty column if you don't use that attribute for your albums.)
  
  IMPORTANT: The first row of the file will be skipped, so use it if you want to put headers on each column. Put all albums inside a unique table. Avoid having trailing empty rows.
  
  All attributes that apply will be matched by name with what you have on Piper. If it already exists, it will be used. Otherwise, a new one will be created.
  
  You can use the following template and fill it with your albums:
`,
    description_2: `The columns inside the file are explained below. Only the first two are mandatory.
  `,
    column_1: `Album name (Mandatory)
The name of the album. It can't be empty.
  `,
    column_2: `Artist name (Mandatory)
The name of the artist for this album. It can't be empty.
  `,
    column_3: `Label name (Optional)
The name of the label for this album.
  `,
    column_4: `Catalog number (Optional)
The catalog number for this album.
  `,
    column_5: `Original year (Optional)
The original release year for this album.
  `,
    column_6: `Release year (Optional)
The specific release year for this album.
  `,
    column_7: `Origin (Optional)
The origin for this album.
  `,
    column_8: `Sleeve condition (Optional)
The grading for the album's sleeve in numerical points. This follows the standard Golmine grading system with the following criteria, enter any of the following numbers or leave it blank:
    
    (1) = P-
    (2) = P
    (3) = G-
    (4) = G
    (5) = G+
    (6) = VG
    (7) = VG+
    (8) = VG++
    (9) = NM-
    (10) = NM
    (11) = M
  `,
    column_9: `Media condition (Optional)
The grading for the album's disc in numerical points. This follows the standard Golmine grading system with the following criteria, enter any of the following numbers or leave it blank:
    
    (1) = P-
    (2) = P
    (3) = G-
    (4) = G
    (5) = G+
    (6) = VG
    (7) = VG+
    (8) = VG++
    (9) = NM-
    (10) = NM
    (11) = M
  `,
    column_10: `Played (Optional)
Whether the album is played or not. Fill the cell with anything for YES, or leave it blank for NO.
  `,
    column_11: `Insert (Optional)
Whether the album has insert or not. Fill the cell with anything for YES, or leave it blank for NO.
  `,
    column_12: `Lyrics (Optional)
Whether the album has lyrics or not. Fill the cell with anything for YES, or leave it blank for NO.
  `,
    column_13: `Gatefold (Optional)
Whether the album is gatefold or not. Fill the cell with anything for YES, or leave it blank for NO.
  `,
    column_14: `Purchase price (Optional)
The price of the album at the time of purchase. Enter the number in your local currency without the currency symbol.
  `,
    column_15: `Sale price (Optional)
The name of the sale price group for this album.
  `,
    column_16: `Purchase date (Optional)
The date when the album was purchased. Make sure this cell has the date format.
  `,
    column_17: `Store (Optional)
The store where the album was purchased.
  `,
    column_18: `Number of discs (Optional)
The number of discs for this album.
  `,
    column_19: `Disc color (Optional)
The color of the disc for this album.
  `,
    column_20: `Format (Optional)
The complete name of the album's format. For example: 'Long Play.'
  `,
    column_21: `Album type (Optional)
The name of the album's type. For example: 'Demo.'
  `,
    column_22: `Number of tracks (Optional)
The number of tracks for this album.
  `,
    column_23: `Length (Optional)
The length of the album in seconds.
  `,
    column_24: `Rating (Optional)
The rating given to the album. Enter the number of stars as seen below:

    (1) = \u{2606}\u{2606}\u{2606}\u{2606}\u{2605}
    (2) = \u{2606}\u{2606}\u{2606}\u{2605}\u{2605}
    (3) = \u{2606}\u{2606}\u{2605}\u{2605}\u{2605}
    (4) = \u{2606}\u{2605}\u{2605}\u{2605}\u{2605}
    (5) = \u{2605}\u{2605}\u{2605}\u{2605}\u{2605}
  `,
    column_25: `Notes (Optional)
Enter here any notes for this album.
  `
};


var $2a0aee35fb69e0df$exports = {};
$2a0aee35fb69e0df$exports = $parcel$resolve("aSdts");


const $27a4ed32271cf519$var$optionImage = new URL($2a0aee35fb69e0df$exports).href;
const $27a4ed32271cf519$export$742374044b5fde90 = {
    title: "Remove multiple albums at once",
    option_image: $27a4ed32271cf519$var$optionImage,
    description: `If you right click on the 'clear filter' button on the toolbar you will get the option to remove all filtered albums.
  
  This process will check for the current filter and, after confirmation, it will remove all albums that fall under that filter.
  
  If no filter is currently applied, this will remove ALL YOUR ALBUMS.
  
  If you did this by mistake, contact support. We will look into your case and see if we can restore some of the removed albums.
  
  `
};


var $3a39a8f294c88195$exports = {};
$3a39a8f294c88195$exports = $parcel$resolve("eIPzL");


const $7562db84c161b9cc$var$deleteImage = new URL($3a39a8f294c88195$exports).href;
var $4cc235d074fbe15c$exports = {};
$4cc235d074fbe15c$exports = $parcel$resolve("9AXbS");


const $7562db84c161b9cc$var$image = new URL($4cc235d074fbe15c$exports).href;
const $7562db84c161b9cc$export$ca4e0bc9e4e6041c = {
    title: "Collections",
    home_title: "What are collections?",
    image: $7562db84c161b9cc$var$image,
    description: `You can divide your main collection into different collections. Each collection can show a different aspect of your albums, you will have separate statistics for each one and you can also filter them individually.
  
  An album can be part of none, one, or many collections, but the album's instance is unique. In other words, assigning an album to multiple collections won't duplicate the album.
  
  The 'All albums' collection will always contain all the albums you have, so if you remove or change collections you will never lose the reference to an album.
  
  Create collections by physical location, genre, personal taste, you name it. Think of collections as different windows to your main collection, each window showing a different view.
  
`,
    create_title: "Add a collection",
    create_description: `In order to add a new collection you just need to click on the collection button on the toolbar in the 'My albums' page.
  
  A new dialog will appear where you can see all collections you have, and at the toolbar you will have the plus button to add a new one.
  
  When you are adding a new collection, you can modify its image, name, and description.
  
  Once you confirm, a red text will appear below any missing required field. If all the mandatory fields are completed, then the collection will be created.
  
  When you are updating an existing collection, a new set of attributes will be available. You will be able to set the collection as 'public' and make it available at the Exhibition. And if you do so, make sure to check the banned fields attribute, and select any attributes you want to hide to the rest of the users.
  
`,
    delete_image: $7562db84c161b9cc$var$deleteImage,
    delete_title: "Delete a collection",
    delete_description: `To delete an collection, right click on it from the collections list and select the option to delete it. A confirmation dialog will appear so you can double check the collection name before removing it.
  
  This process is irreversible, so make sure you are removing the right collection. All albums assigned to that collection will be unassigned automatically. If someone had access to a shared link of the removed collection, they won't be able to access it anymore.

`
};


const $35e05c171c00f4ec$export$2addc290eb3bb210 = {
    title: "Public collections",
    description: `Public collections are the same as private collections except that they can be shared with other users using links and QR codes, and they can be found at the Exhibition.

  Users can star your public collection and each visit will increment the visits counter.  

  All albums inside a public collection can be accessed by any user and they will be able to see all its data except for the banned fields that you defined for the collection.

  Each day, the public collection and its albums have a chance to appear at the highlight lists on the Exhibition main page.  
  
  `
};


const $24216a93aa855f85$export$ec948778fd5dc767 = {
    title: "Collection attributes",
    home_title: "Attributes",
    description: `Find below the list of attributes that belong to a collection and a short description for each one.
  
  `,
    name_title: "Name",
    name_description: `Each collection needs a name. Use a name that represents the albums inside it. Take into account that this name will be visible for other users if the collection is public.
  
  `,
    image_title: "Image",
    image_description: `There's an image by default assign to collections, but you can change it for one of your own. The collection image is displayed in a dynamic size that is dependant on the screen resolution, so it's best to use images that don't suffer from stretches. The approximate aspect ratio that goes best with the image is 5:1.
  
  `,
    visibility_title: "Visibility",
    visibility_description: `This attribute is not available the first time you create a collection, since all collections are private at first. You will be able to see this attribute only when you go to edit a collection.
  
  There are two possible options for visibility: private or public.
  
  Private collections can only be accessed by you, no one will be able to see that collection.
  
  Public collections are publicly available to all users, since they can be searched for at the Exhibition, and you can even share public links and QR codes. For a collection to be public, it has to have some albums assigned to it.
  
  `,
    banned_fields_title: "Hidden fields",
    banned_fields_description: `This attribute is not available the first time you create a collection, since all collections are private at first. You will be able to see this attribute only when you go to edit a collection.
  
  Enter here any album attributes that you want to hide from other users when they see this collection at the Exhibition, or through public links and QR codes.
  
  `,
    discount_title: "Discount",
    discount_description: `You can set a discount percentage that will affect all albums on this collection.
  
  For each album, the sale price will be displayed adjusted by this discounted percentage.
  
  If you chose to hide the sale price for a public collection, then only the discount percentage will be visible.
  
  `,
    description_title: "Description",
    description_description: `Use this field to describe the collection, explain what is it about, your appreciations, selling terms or anything you want to express about it.
  
  `
};


const $9632185a00f8a913$export$c277dc1020bd891c = {
    title: "Artists",
    description: `Each album has an artist, it's the only required attribute besides the album name.
  
  Use the artist to represent bands, soloists, collaborations, or anything in between.
  
`
};


const $0764ba5d288fb087$export$f1e81a3f7ddd0c0c = {
    title: "Album attributes",
    home_title: "General attributes",
    description: `In this section you will find all the attributes you can manage for each album, what they mean, and how you can use them.
  
  Let's start with the simplest ones here and you can find the rest of them in a list at the bottom.
  
`,
    name_title: "Name",
    name_description: `The album name. It can't be larger than 512 characters. This is the only mandatory attribute.
  
`,
    image_title: "Image",
    image_description: `You can change the front cover image of the album. If you have a premium subscription plan, you can also add images for the back cover, spine, and up to 50 additional images of the album.
  
`,
    country_title: "Origin",
    country_description: `The origin for this specific release, where it was originally distributed or manufactured.
  
`,
    original_year_title: "Original year",
    original_year_description: `Enter the year when the album originally came out.
  
`,
    release_year_title: "Release year",
    release_year_description: `Enter the year when this specific release came out. This will probably match with the original year for first editions and will differ for re-issues.
  
`,
    catalogue_number_title: "Catalog number",
    catalogue_number_description: `The catalog number from the label for this release.
  
`,
    discogs_id_title: "Discogs ID",
    discogs_id_description: `The Discogs release ID for this particular release. You can find this number at the release page on Discogs at the top right corner or inside the URL.
  
  This ID can be used to later retrieve the album's track list automatically. It also enables a direct link to the release page on Discogs.
  
`,
    purchase_date_title: "Purchase date",
    purchase_date_description: `The date when you purchased this album. This date will be used to automatically calculate the purchase price using the closest exchange rate.
  
`,
    purchase_price_title: "Purchase price",
    purchase_price_description: `The price that you payed when you purchased this album.
  
  The amount has to be expressed in your own currency (The one you selected in your user profile). Once you update this value, the amount will be converted using the last exchange rate and the closest exchange rate to the purchase date, and it will be displayed that way. It will also display the amount in USD.
  
`,
    track_count_title: "Number of tracks",
    track_count_description: `The number of tracks for this album. 
  
`,
    length_title: "Length",
    length_description: `The album length in this format: HH:mm:ss.
  
  For example, if an album has a length of 33 minutes and 2 seconds you have to enter: '00:33:02'.
  
`,
    collections_title: "Collections",
    collections_description: `Use this attribute to assign an album to one or multiple collections. Assigning an album to a collection doesn't duplicate it. You can assign and unassign albums as you want without fearing to lose any data.
  
  Refer to the collections section on this documentation for more info.
  
`,
    played_title: "Played",
    played_description: `Whether you already played this album. This can be helpful if you want to keep track of the albums that you already listened or not.
  
`,
    has_insert_title: "Has insert",
    has_insert_description: `Whether this album has the original insert/inner sleeve or not.
  
`,
    has_lyrics_title: "Has lyrics",
    has_lyrics_description: `Whether this album has printed lyrics. Sometimes lyrics are included in the insert, the inner sleeve, or the back cover. 
  
`,
    gatefold_title: "Gatefold",
    gatefold_description: `Whether this album's sleeve is a gatefold jacket or not. Gatefold jackets fold like a book or a wallet.
  
`,
    sleeve_grade_title: "Sleeve condition",
    sleeve_grade_description: `The preservation status for the album's sleeve. This uses the Goldmine grading system.
  
`,
    media_grade_title: "Media condition",
    media_grade_description: `The preservation status for the album's disc/s. This uses the Goldmine grading system.
  
`,
    impact_title: "Rating",
    impact_description: `A personal rating you can give to the album, from 0 to 5 stars.
  
`,
    notes_title: "Notes",
    notes_description: `A free text field where you can put anything you want about the album.
  
`,
    more_attributes: "More attributes"
};


var $55e5321a2f0b5fc0$exports = {};
$55e5321a2f0b5fc0$exports = $parcel$resolve("kXPqS");


const $d9cb1fd05a798d96$var$image = new URL($55e5321a2f0b5fc0$exports).href;
const $d9cb1fd05a798d96$export$603ecef77541051a = {
    title: "Marking albums",
    image: $d9cb1fd05a798d96$var$image,
    description: `You can mark your albums to add some visual indications to the album list. Each type of marking will have a different aspect on the list so try them all and use them to your convenience.
  
  Markings are specially useful for public collections that you use to sell your albums, since you can easily communicate if an album is already reserved, if it has been sold, or if it's only available to pre-order.
  
  `
};


const $985645e8fabe37c3$export$fb93cc3c82e16db8 = {
    title: "Purchases",
    description_1: `As a free Piper user, you have the following limitations on each of these resources:
`,
    limit_albums: "300 albums",
    limit_collections: "3 collections",
    limit_shelvings: "2 shelving units",
    limit_artists: "200 artists",
    limit_labels: "200 labels",
    limit_album_formats: "10 album formats",
    limit_album_types: "10 album types",
    limit_tags: "30 tags",
    limit_stores: "50 stores",
    limit_sell_values: "50 sale prices",
    limit_exchange_rates: "100 exchange rates",
    description_2: `
When you reach any of these limits, the system will notify you that you have reached the maximum for that resource when you want to add a new item. You always have the option to delete an item to add a different one at any time.

If you want to extend any of these limits, you can make a purchase. Each resource has different packages that, when purchased, will extend the limit by a certain amount. You can find the purchase menu for each resource in your user profile, in the table that indicates your current limits.

The new limit is credited immediately once the payment is successful.

To use Apple Pay, you must use the native iOS app available on the App Store. The amount may differ between payment methods.

If you have any problems with a purchase, please do not hesitate to contact support so we can correct your situation as soon as possible.
  
`
};


const $38926892ea158544$export$37cef7dde5bf419 = {
    locale: "en-US",
    currencyLocale: "en-US",
    fnsLocale: (0, $fbb6af908147d006$export$2e2bcd8739ae039),
    datePickerLocale: (0, $ae7ac3a23918bc42$export$137380d9ce54f7f),
    minDate: "1800-01-01",
    app_name: "Piper",
    /* General */ yes: "Yes",
    no: "No",
    none: "None",
    not_in: "Not in",
    menu: "Menu",
    save: "Save",
    close: "Close",
    help: "Help",
    delete: "Delete",
    expand: "Expand",
    shrink: "Shrink",
    discount: "OFF",
    new: "New",
    horizontal: "Horizontal",
    vertical: "Vertical",
    refresh_list: "Refresh list",
    alert_accept: "OK",
    alert_cancel: "Cancel",
    alert_cancel_confirmation: "Are you sure you want to cancel this operation?",
    alert_confirm: "Confirm",
    alert_modify: "Modify",
    alert_delete: "Delete",
    alert_exit: "Exit",
    session_expired: "Your session has expired. Please sign in again.",
    album_singular: "album",
    albums_plural: "albums",
    albums_plural_title: "Albums",
    disc_singular: "disc",
    plural_indicator: "s",
    search: "Search",
    unknown: "Unknown",
    mint: "Mint",
    missing_purchase_date: "Missing purchase date",
    date_missing: "Select a date",
    field_missing: "You have to complete this field",
    field_missing_short: "Complete this",
    field_invalid: "The field is invalid",
    not_number_error: "This field has to be a number",
    open_on_discogs: "View on Discogs",
    open_on_private_collection: "Open on my private collection",
    open_on_layout: "Show inside shelving unit",
    mark_as_title: "Mark as...",
    remove_mark_title: "Remove mark",
    refresh_image: "Refresh image",
    copy_value: "Copy value",
    copy_value_success_notification: "Value copied to the clipboard",
    clear_value: "Clear value",
    clear_values: "Clear values",
    start_date: "Start date",
    end_date: "End date",
    generic_attribute_filter_description: "Enter the value you are looking for:",
    generic_track_name: "New track",
    no_value: "No value",
    currency_title: "Currency",
    share_link_notification: "Link copied to the clipboard!",
    image_upload_success: "Image updated successfully!",
    image_upload_error: "There was an error updating that image. Please try again later.",
    upload_multiple_files_error: "Please select only one file to upload.",
    upload_multiple_images_error: "Please select only one image to upload.",
    album_update_success: "Album updated successfully!",
    album_update_error: "There was an error updating the album. Please try again later.",
    album_created: "The album was added successfully!",
    album_deleted: "The album was removed successfully",
    generic_update_success: "The operation was successful",
    generic_update_error: "The operation could not be completed, please try again later.",
    generic_error: "An unexpected error occurred. Please verify your connection and try again.",
    clear_filter: "Clear filter",
    clear_search: "Clear search",
    order_warning: "\u26A0\uFE0F Unordered",
    back_to_app: "Go back to the app",
    general_queries: "If you have any questions please reach out:",
    network_online_message: "You are back online!",
    network_offline_message: "It seems you are not connected to the internet. Check your connection.",
    qr_code: "QR code",
    qr_code_public_title: "Public QR code",
    qr_code_public_message: "You can share this QR code with other people",
    qr_code_private_title: "Private QR code",
    qr_code_private_message: "This QR code will only work for you",
    download: "Download",
    toggle_style: "Toggle style",
    no_results: "The search didn't bring any results",
    edit_profile_description: "Enter the profile below:",
    edit_description_description: "Enter the description below:",
    about_app_title: "About",
    dropzone_placeholder: "Drop a file here, or tap to select one.",
    more_info: "More info",
    description_title: "Description",
    optional_attributes: "Optional attributes",
    push_notifications_permission_notice: "Would you like to receive notifications from Piper?",
    status_title: "Status",
    status_active: "Active",
    status_inactive: "Inactive",
    /* NotFoundPage */ greetings: "Hey there!",
    not_found_subtitle: "We couldn't find\nwhat you are looking for",
    not_found_message: "Click the button below to go back to the app:",
    not_found_queries: "If you think this is a mistake or you have any questions, please reach out:",
    /* MaintenancePage */ maintenance_message: "The app is under maintenance, it will be available again soon.",
    /* SignupViewController */ signup_title: "New user",
    signup_subtitle: "Fill out this form",
    signup_description: "You will need to confirm your email address",
    signup_repeat_password_placeholder: "Repeat your password",
    signup_success_title: "Your user is ready!",
    signup_success_message: "Check your inbox and enter the code we sent you when you sign in to the app.\n\nWe sent a verification code to {0}",
    recover_password_form_title: "Enter your email and a new password",
    recover_password_form_subtitle: "We will send you a code you will need to enter in the next step",
    recover_password_email_not_found: "That email is not registered, you can create a new user with it.",
    /* CreateAlbumViewController */ ca_title: "New album",
    ca_all_fields: "all required fields",
    ca_name: "the name",
    ca_artist: "the artist",
    ca_country: "the origin",
    ca_catalogue_number: "the catalog number",
    ca_color: "the color",
    ca_store: "the store",
    ca_label: "the label",
    ca_missing_message: "You have to complete {0} of the new album.",
    new_box_set_title: "New box set",
    /* AlbumsTableViewController */ add_album: "Add album",
    add_box_set: "Add box set",
    album_title: "Album",
    albums_title: "My albums",
    option_attributes: "Attributes",
    option_stats: "Statistics",
    option_marketplace: "Exhibition",
    option_close_session: "Close session",
    option_preferences: "Preferences",
    option_go_to_app: "Go to Piper",
    option_refresh_albums: "Refresh albums",
    option_fetch_all_albums: "Fetch all albums",
    option_reorder_albums: "Reorder albums",
    option_filter_albums: "Filter albums",
    option_show_index: "Show index",
    option_random_albums: "Random albums",
    option_reel: "Reel view",
    option_search_albums: "Search albums",
    option_view_detail: "See detail",
    option_discogs_import: "Import from Discogs",
    option_excel_import: "Import from spreadsheet",
    option_scan_barcode: "Add from barcode or search",
    random_albums_message: "Enter the number of albums:",
    play_from_youtube: "Play from YouTube",
    album_delete_all: "Remove all filtered albums",
    album_delete_all_confirmation_message: "You are about to remove ALL your albums on the currently selected collection. THIS CAN'T BE UNDONE! If you are really sure you want to do this, please write 'Remove all albums' below and confirm.",
    album_delete_all_filter_confirmation_message: "You are about to remove ALL albums that are currently filtered on the selected collection. THIS CAN'T BE UNDONE! The albums that fall out of the filter will be untouched. If you are really sure you want to do this, please write 'Remove all albums' below and confirm.",
    album_delete_all_placeholder: "Remove all albums",
    album_delete_confirmation: "Are you sure you want to remove the album {0}? This will remove it from ALL collections and you can't reverse it. If you want to remove this album from a specific collection you can do so by going to the album's detail and then to the collections list.",
    box_set_delete_confirmation: "Are you sure you want to remove the box set {0}? This will remove it from ALL collections and you can't reverse it. If you want to remove this box set from a specific collection you can do so by going to its detail and then to the collections list.\n\nThis won't remove the albums inside the box set.",
    album_remove_from_box_set_confirmation: "Are you sure you want to remove the album {0} from this box set? This won't remove the album itself or its details.",
    album_remove_from_box_set: "Remove from box set",
    no_albums_error: "You can't use this functionality without albums.",
    options: "Options",
    album_options: "Album options",
    album_sleeve_grade: "Sleeve:",
    box_set_sleeve_grade: "Box:",
    album_media_grade: "Media:",
    open_drawer: "Open menu",
    open_attributes_list: "Open attributes list",
    open_albums_list: "Open albums list",
    add: "Add",
    add_attribute: "Add new",
    album_highlighted: "Highlight",
    album_sold: "Sold",
    album_upcoming: "Upcoming",
    album_new: "New",
    album_reserved: "Reserved",
    /* AlbumDetailViewController */ exchange_rate_title: "Exchange rate",
    sell_value_title: "Sale price",
    purchase_price_title: "Purchase price",
    purchase_price_detail: "Price at the time of purchase: {0}",
    purchase_price_detail_dollars: "Price at the time of purchase: {0} ({1})",
    purchase_price_placeholder: "Price at the time of purchase",
    purchase_price_message: "Enter the price at the time of the purchase:",
    artist_title: "Artist",
    label_title: "Label",
    original_year_title: "Original year",
    original_year_message: "Enter the original year of the album:",
    release_year_title: "Release year",
    release_year_message: "Enter the year of this release:",
    sleeve_grade_title: "Sleeve condition",
    sleeve_grade_box_set_title: "Box condition",
    media_grade_plural_title: "Media condition",
    media_grade_singular_title: "Media condition",
    revenue_title: "Revenue",
    purchase_date_title: "Purchase date",
    store_title: "Store",
    catalogue_number_title: "Catalog number",
    catalogue_number_message: "Enter the catalog number of this release:",
    disc_count_title: "Number of discs",
    disc_count_message: "Enter the number of discs:",
    disc_color_plural_title: "Discs color",
    disc_color_singular_title: "Disc color",
    disc_color_plural_message: "Enter the discs color:",
    disc_color_singular_message: "Enter the disc color:",
    album_format_title: "Format",
    album_type_title: "Album type",
    add_track: "Add track",
    track_count_title: "Number of tracks",
    track_count_title_big: "Tracks",
    track_count_message: "Enter the number of tracks:",
    album_length_title: "Length",
    album_length_title_big: "Length",
    album_length_message: "Enter the length of this album:",
    discogs_id_title: "Discogs ID",
    discogs_id_title_big: "Discogs ID",
    discogs_id_message: "Enter the release ID from Discogs:",
    impact_title: "Rating",
    random_title: "Random",
    notes_title: "Notes",
    notes_detail: "Enter notes for the album:",
    notes_placeholder: "Album notes",
    edit_album_name: "Edit name",
    change_artist: "Change artist",
    change_label: "Change label",
    name_title: "Name",
    name_detail: "Enter the name of the album:",
    name_placeholder: "Example: Slow turning",
    box_set_name_placeholder: "Example: The Definitive Collection",
    artist_placeholder: "Example: John Hiatt",
    country_placeholder: "Example: USA",
    original_year_placeholder: "Example: 1988",
    release_year_placeholder: "Example: 2018",
    catalogue_number_placeholder: "Example: B0027601-01",
    disc_color_placeholder: "Example: Black",
    impact_placeholder: "\u2606\u2606\u2606\u2606\u2606",
    sleeve_grade_placeholder: "Example: VG+",
    media_grade_placeholder: "Example: NM",
    no_album_selected: "Select an album to see its detail",
    album_no_collections: "This album doesn't have any particular collections associated to it yet",
    album_no_location: "This album doesn't have a location yet",
    share_album: "Share album",
    get_private_link: "Get private link",
    get_album_insights: "Get album insights",
    copy_album: "Copy album",
    copy_box_set: "Copy box set",
    album_shared_loading: "Loading content...",
    /* Image Gallery */ image_gallery: "Image gallery",
    add_new_image: "Add new image",
    front_cover: "Front cover",
    back_cover: "Back cover",
    spine: "Spine",
    image_name: "Image name",
    image_name_message: "Enter a name for this image. It can only be 30 characters or less.",
    image_name_placeholder: "Example: Insert front",
    option_view_image: "View image detail",
    modify_front_image: "Edit front image",
    modify_image: "Edit image",
    move_left: "Move to the left",
    move_right: "Move to the right",
    move_up: "Move upwards",
    move_down: "Move downwards",
    edit_image_name: "Edit name",
    image_delete_confirmation: "Are you sure you want to remove this image?",
    image_fetch_confirmation: "This will overwrite your current image for this album, are you sure?",
    album_3d_model: "3D view",
    rotation_reset: "Reset rotation",
    /* TrackListDialog */ track_list_title: "Tracklist",
    fetch_from_discogs: "Fetch from Discogs",
    fetch_image_from_discogs: "Fetch front image from Discogs",
    fetch_from_discogs_disabled: "You need to set the Discogs ID on this album to use this functionality",
    track_extra_artists_placeholder: "Track credits",
    track_name_title: "Name",
    track_name_description: "Enter the track name:",
    track_name_placeholder: "Example: Telegraph Road",
    track_position_title: "Position",
    track_position_description: 'Enter the position for track "{0}":',
    track_position_placeholder: "Example: A1",
    track_length_title: "Length",
    track_length_description: 'Enter the length for track "{0}":',
    track_extra_artists_title: "Credits",
    track_extra_artists_description: 'Enter the credits for track "{0}":',
    fetch_tracks_from_discogs_confirmation: "Are you sure you want us to fetch the tracks for this album from Discogs? This will overwrite any custom changes you have made to the tracklist.",
    /* AlbumsFilterViewController */ filter_left_title: "Available filter elements",
    filter_right_title: "Filter to apply",
    order_by_title: "Order by",
    order_direction_title: "Direction",
    order_desc_title: "Descendant",
    order_asc_title: "Ascendant",
    filter_is: "Is",
    filter_is_not: "Is not",
    filter_album_search_text_title: "Search text",
    filter_album_format_title: "Format",
    filter_album_type_title: "Album type",
    filter_tag_title: "Tag",
    filter_gatefold_title: "Gatefold",
    filter_insert_title: "Insert",
    filter_lyrics_title: "Lyrics",
    filter_clean_title: "Played",
    filter_box_set_title: "Is box set",
    filter_artist_title: "Artist",
    filter_store_title: "Store",
    filter_label_title: "Label",
    filter_impact_title: "Rating",
    filter_sleeve_grade_title: "Sleeve condition",
    filter_media_grade_title: "Media condition",
    filter_sell_value_title: "Sale price",
    filter_country_title: "Origin",
    filter_color_title: "Color",
    filter_original_year_title: "Original year",
    filter_release_year_title: "Release year",
    filter_sell_status_title: "Marked as...",
    filter_confirm: "Apply filter",
    sort_by_sell_value: "Sale price (Name)",
    sort_by_sell_value_dollars: "Sale price (Value)",
    add_to_filter: "Add to filter",
    remove_from_filter: "Remove from filter",
    /* AttributeListCollectionViewController */ attribute_artists_title: "Artists",
    attribute_stores_title: "Stores",
    attribute_labels_title: "Labels",
    attribute_exchange_rates_title: "Exchange rates",
    attribute_sell_values_title: "Sale prices",
    attribute_impacts_title: "Ratings",
    attribute_countries_title: "Flags",
    attribute_sleeve_grades_title: "Sleeve condition",
    attribute_media_grades_title: "Media condition",
    attribute_album_types_title: "Album types",
    attribute_album_formats_title: "Formats",
    artist_edit: "Edit artist",
    artist_view: "View artist",
    label_edit: "Edit label",
    label_view: "View label",
    gear_item_edit: "Edit gear item",
    gear_item_view: "View gear item",
    equipment_edit: "Edit equipment",
    equipment_view: "View equipment",
    empty_artists: "You don't have any artists yet",
    empty_stores: "You don't have any stores yet",
    empty_tags: "You don't have any tags yet",
    empty_origin_countries: "You don't have any origins yet",
    empty_labels: "You don't have any labels yet",
    empty_exchange_rates: "You don't have any exchange rates yet",
    empty_sell_values: "You don't have any sale prices yet",
    empty_gear_items: "You don't have any gear items yet",
    empty_equipments: "You don't have any equipments yet",
    empty_equipment_gear_items: "This equipment don't have gear items",
    empty_impacts: "Ratings couldn't be retrieved",
    empty_countries: "Flags couldn't be retrieved",
    empty_sleeve_grades: "Sleeve conditions couldn't be retrieved",
    empty_media_grades: "Media conditions couldn't be retrieved",
    empty_album_types: "You don't have any album types yet",
    empty_album_formats: "You don't have any formats yet",
    empty_artists_public: "There are no artists to filter from",
    empty_stores_public: "There are no stores to filter from",
    empty_tags_public: "There are no tags to filter from",
    empty_origin_countries_public: "There are no origins to filter from",
    empty_labels_public: "There are no labels to filter from",
    empty_exchange_rates_public: "There are no exchange rates to filter from",
    empty_sell_values_public: "There are no sale prices to filter from",
    empty_album_types_public: "There are no album types to filter from",
    empty_album_formats_public: "There are no album formats to filter from",
    empty_collections: "You don't have any collections yet",
    empty_user_notifications: "You don't have new notifications",
    empty_tracklist: "There are no tracks to show",
    empty_attribute_description: "Start by adding a new one!",
    empty_search_title: `No results for "{0}"`,
    empty_search_description: "Check the spelling or try a new search",
    add_exchange_rate_by_time_lapse: "Add by time lapse",
    add_exchange_rate_by_time_lapse_disabled: "To add exchange rates by a time lapse please upgrade your account subscription.",
    /* Email General */ email_used: "This address is already in use \u274C",
    email_valid: "This address is available \uD83D\uDC4D",
    email_invalid: "This address doesn't look correct \u274C",
    email_error_invalid: "The email address is invalid. Please verify it and try again.",
    email_error_duplicated: "The email address is already in use by another user.",
    /* Password General */ password_very_weak: "The password is too weak \u274C",
    password_weak: "The password is weak \u274C",
    password_valid: "The password is acceptable \uD83D\uDC4D",
    password_strong: "The password is strong \uD83D\uDC4D",
    password_match: "The passwords match \uD83D\uDC4D",
    password_mismatch: "The passwords don't match \u274C",
    password_missing: "Enter your password.",
    password_repeat_missing: "Repeat the password you entered on the last field.",
    password_mismatch_error: "The passwords don't match. Please verify them and try again.",
    password_weak_error: "The password you entered doesn't meet the minimum security requirements. It must have 8 characters minimum and contain lowercase, uppercase, numbers, and/or special characters. Please verify it and try again.",
    /* LoginViewController */ login_unknown_error: "We could't sign you in. Please try again later.",
    login_create_user: "Create a new user",
    login_create_user_or_login: "Create a new user\nor sign in",
    login_guest: "Sign in as guest",
    login_preferences: "Preferences",
    login_again: "Sign back in",
    login_again_subtitle: "We need you to enter your password again",
    login_again_message: "We need you to sign in again in order to perform this action",
    login_wrong_credentials: "The credentials seem to be incorrect. Please verify your inputs and try again.",
    login_title: "Welcome!",
    login_email: "Username or email",
    login_password: "Password",
    login_submit: "Sign in",
    login_subtitle: "Enter your credentials or",
    login_new_user_button: "create a new user",
    login_guest_info: "You can also sign in as a guest",
    login_recover_password: "Recover password",
    login_forgot_password: "Forgot your password?",
    guest_title: "Guest",
    signin_with_google: "Continue with Google",
    signin_with_apple: "Continue with Apple",
    signin_with_passkey: "Sign in with passkey",
    signin_with_passkey_long: "Sign in with a passkey",
    signup_email: "Email",
    signup_oauth_intro: `You are one step away from creating your account! Please just confirm you agree to the statement below:
    `,
    signup_accept_first: "I accept the ",
    signup_accept_second: " and I agree to the ",
    signup_accept_third: ", and I am at least 13 years old.",
    /* SignupSuccessViewController */ verification_code_sent: "We sent a code to\n{0}",
    /* ArtistDetailViewController */ artist_death_date: "DEATH DATE",
    /* AVAudioPlayerViewController */ player_unknown_error: "An unknown error occurred",
    player_autoplay_on: "Autoplay is now on",
    player_autoplay_off: "Autoplay is now off",
    /* SettingsTableViewController */ settings_user_title: "User",
    settings_preferences_title: "Preferences",
    settings_advanced_title: "Application",
    settings_cache_confirmation: "You are about to delete all images and data stored in the cache memory.",
    settings_should_show_impact_descriptions: "Show rating descriptions",
    settings_should_show_album_id: "Show album ID",
    settings_order_new_albums: "Order new albums automatically",
    settings_show_decimals: "Show decimal places on certain financial amounts",
    settings_receive_email_notifications: "Receive notifications by email",
    settings_show_3d_model: "Use 3D model in album detail",
    my_external_systems_title: "Already associated apps",
    catering_external_systems_title: "Available apps",
    confirm_external_system_deletion: 'Are you sure you want to dissociate the app "{0}"?',
    /* EmailTableViewController */ email_current_title: "Current email address",
    email_pending_title: "Email pending confirmation",
    email_confirm_new: "Confirm new address",
    email_discard_new: "Discard new address",
    email_new_title: "New email address",
    email_confirmed: "Verified \uD83C\uDF89",
    email_pending: "Pending \u26A0\uFE0F",
    /* ChangePasswordViewController */ password_new_mismatch: "The current password doesn't match, please check and try again.",
    password_update_success: "The password was updated successfully.",
    password_update_error_current: "Enter your current password.",
    password_update_error_new: "Enter a new password.",
    password_update_error_repeat: "Repeat the new password.",
    /* VerifyEmailCodeViewController */ vec_title: "Verify email",
    vec_subtitle: "Check your inbox and enter the code we sent you",
    vec_code_placeholder: "Code",
    vec_resend_code: "Resend verification code",
    vec_confirmation: "We sent a new verification code and it should arrive in the next minutes. Please check your inbox.",
    vec_invalid_code: "The code you entered is incorrect. Verify it and try again.",
    vec_success: "Your new email address was confirmed successfully.",
    recover_password_success: "Your new password is set!",
    /* StatsViewController */ stats_guest_error: "You're currently a guest. Create your own account to view statistics about your collection!",
    stats_clean_title: "PLAYED",
    stats_gatefold_title: "GATEFOLD",
    stats_insert_title: "INSERT",
    stats_lyrics_title: "LYRICS",
    stats_impacts_title: "RATINGS",
    stats_sleeve_grades_title: "SLEEVE CONDITION",
    stats_media_grades_title: "MEDIA CONDITION",
    stats_pie_yes: "YES",
    stats_pie_no: "NO",
    stats_last_updated: "Last updated",
    stats_loading: "This can take some time for large collections, please be patient...",
    stats_error: "There was an error fetching your stats for this collection. Please try again later.",
    /* Attributes General */ attributes_title: "Attributes",
    /* ModifyExchangeRateViewController */ mer_new_title: "New exchange rate",
    mer_delete_confirmation: "Are you sure you want to delete this exchange rate?",
    mer_format_error: "The exchange rate must be a positive number greater than zero.",
    mer_rate_title: "Exchange rate (USD -> {0})",
    mer_rate_placeholder: "1 USD equals to # {0}",
    mer_date_title: "Date",
    date_range_title: "Date range",
    mer_tl_title: "Fetch exchange rates automatically",
    mer_tl_description: "Enter below a range of dates and we will automatically fetch an exchange rate every 7 days. Make sure you don't pick a range of more than a year. If you want to load more than a year worth of exchange rates, please repeat this process as many times as you need.",
    /* ModifyLabelViewController */ ml_new_title: "New label",
    ml_delete_confirmation: "Are you sure you want to delete this label?",
    ml_missing_error: "Enter the name of the new label.",
    ml_placeholder: "Example: Asylum Records",
    ml_field_title: "Label name",
    ml_image_title: "Label logo",
    /* ModifyStoreViewController */ ms_new_title: "New store",
    ms_delete_confirmation: "Are you sure you want to delete this store?",
    ms_missing_error: "Enter the name of the new store.",
    ms_placeholder: "Example: Ebay",
    ms_field_title: "Store name",
    ms_address_title: "Address",
    ms_address_placeholder: "Address",
    /* ModifySellValueViewController */ msv_new_title: "New sale price",
    msv_delete_confirmation: "Are you sure you want to delete this sale price?",
    msv_missing_error: "Enter all the required fields.",
    msv_group_title: "Group name",
    msv_group_placeholder: "Examples: A, 4, 3.2",
    msv_dollars_title: "Price [USD]",
    msv_dollars_placeholder: "Sale price in USD",
    msv_description_title: "Group description",
    msv_description_placeholder: "Example: Rare albums in pretty good shape",
    msv_group: "Group",
    /* ModifyArtistViewController */ ma_new_title: "New artist",
    ma_delete_confirmation: "Are you sure you want to delete this artist?",
    ma_missing_error: "Enter the name of the artist.",
    ma_name_title: "Artistic name",
    ma_name_placeholder: "Example: Little Richard",
    ma_real_name_title: "Real name",
    ma_real_name_placeholder: "Example: Richard Wayne Penniman",
    ma_website_title: "Website",
    ma_website_button_title: "Visit website",
    ma_website_placeholder: "Example: https://piper.ldelosheros.com",
    ma_discogs_id_title: "Discogs ID",
    ma_discogs_id_placeholder: "Example: 12345",
    ma_profile_title: "Profile",
    ma_profile_placeholder: "Profile",
    ma_birth_date_title: "Birth date",
    ma_death_date_title: "Death date",
    ma_image_title: "Picture",
    /* ModifyTimeLengthAlertController */ mtl_title: "Album length",
    mtl_message: "Enter the album length:",
    mtl_missing_error: "Enter the new album length.",
    mtl_calculate: "Calculate from tracklist",
    /* ModifyAlbumTypeViewController */ mat_new_title: "New album type",
    mat_delete_confirmation: "Are you sure you want to delete this album type?",
    mat_missing_error: "Enter the name of the new album type.",
    mat_field_title: "Album type name",
    mat_placeholder: "Examples: Studio, Compilation",
    mat_show_on_album_list_title: "Show on album list",
    /* ModifyAlbumFormatViewController */ maf_new_title: "New format",
    maf_delete_confirmation: "Are you sure you want to delete this format?",
    maf_missing_error: "Enter the name and short name of the new format.",
    maf_name_title: "Name",
    maf_name_placeholder: "Example: Long Play",
    maf_short_name_title: "Short name",
    maf_short_name_placeholder: "Example: LP",
    /* Album contents */ album_contents_title: "Content",
    add_content: "Add content",
    album_content_disc: "Disc / Media",
    album_content_other: "Other",
    playback_speed: "Playback speed",
    album_content_quantity: "Quantity",
    album_content_type: "Type of content",
    album_content_delete_confirmation: "Are you sure you want to remove this album content?",
    /* Album identifiers */ album_identifier_title: "Identifier",
    album_identifiers_title: "Identifiers",
    add_identifier: "Add identifier",
    album_identifier_catalogue: "Catalog number",
    album_identifier_matrix: "Matrix code",
    album_identifier_value: "Value",
    album_identifier_value_description: "Enter a value for this identifier",
    album_identifier_matrix_part: "Add segment",
    album_identifier_barcode: "Barcode",
    album_identifier_other: "Other",
    album_identifier_type: "Type of identifier",
    album_identifier_delete_confirmation: "Are you sure you want to remove this album identifier?",
    /* Tags */ tag_title: "Tag",
    new_tag_title: "New tag",
    tags_title: "Tags",
    /* Origin Countries */ origin_country_title: "Origin",
    new_origin_country_title: "New origin",
    origin_countries_title: "Origins",
    origin_country_flag_title: "Flag",
    /* Gear Items */ gear_item_title: "Gear item",
    gear_items_title: "Gear items",
    new_gear_item_title: "New gear item",
    add_gear_item: "Add gear item",
    gear_item_delete_confirmation: "Are you sure you want to delete this gear item?",
    gear_item_name_title: "Gear item name",
    gear_item_name_placeholder: "Example: Amplifier",
    gear_item_brand_title: "Brand / Model",
    gear_item_brand_placeholder: "Example: Marantz PM6007",
    gear_item_image_title: "Picture",
    /* Equipments */ equipment_title: "Equipment",
    equipments_title: "Equipments",
    new_equipment_title: "New equipment",
    equipment_name_title: "Equipment name",
    equipment_name_placeholder: "Example: Living room setup",
    /* UpdateEmailDialog */ update_email_title: "Email",
    new_email_title: "NEW EMAIL ADDRESS",
    new_email_placeholder: "New email address",
    email_pending_message: "Check your inbox, we sent a verification code to {0}",
    /* UpdatePasswordDialog */ update_password_title: "Password",
    old_password_title: "Current password",
    old_password_placeholder: "Current password",
    new_password_title: "New password",
    new_password_placeholder: "New password",
    repeat_password_placeholder: "Repeat the new password",
    /* Stats */ stats_general_title: "General",
    stats_financials_title: "Finances",
    stats_album_total: "Albums",
    stats_box_set_total: "Box sets",
    stats_clean_total: "Played albums",
    stats_gatefold_total: "Gatefold albums",
    stats_insert_total: "Albums with insert",
    stats_lyrics_total: "Albums with lyrics",
    stats_colored_total: "Colored albums",
    stats_average_original_year: "Average original year",
    stats_average_release_year: "Average release year",
    stats_discs_total: "Number of discs",
    stats_length_total: "Total length",
    stats_average_album_length: "Average album length",
    stats_average_disc_length: "Average disc length",
    stats_average_track_length: "Average track length",
    stats_tracks_by_album: "Tracks by album",
    stats_artist_total: "Number of artists",
    stats_artist_most_albums: "Artist with most albums",
    stats_store_most_albums: "Store with most albums",
    stats_label_most_albums: "Label with most albums",
    stats_purchase_price_total: "Total purchase price",
    stats_sell_value_total: "Total sale price",
    stats_revenue_total: "Total revenue",
    /* DiscogsImport */ import_from_discogs: "Import from Discogs",
    discogs_import_collection_folders_title: "Collection folders",
    discogs_import_collection_import: "Collection import",
    discogs_import_cancel_confirmation: "Are you sure you want to cancel the import process? You will only lose the albums pending to be imported.",
    discogs_import_subtitle: "Your collection is being imported!",
    discogs_import_description: "You can track the progress below. The import process will sleep for around one minute once in a while. This is due to Discogs' service restrictions and is completely normal.",
    discogs_import_info: 'We are importing all albums from the folder named "{0}", with a total of {1} albums.',
    cancel_import: "Cancel import",
    discogs_folders_subtitle: "Select the folder from which you want to import albums",
    discogs_folders_description: "Next, you\u2019ll be able to choose the Piper collection where they will be imported\n\nYou can cancel this process and organize your folders on Discogs first if needed",
    discogs_folders_confirmation: 'You are about to import {0} albums from the folder "{1}" into the collection "{2}". We will try to complete as much information as possible but some fields will have to be completed or corrected manually.\n\nThis process will add new albums, artists, labels and formats as necessary, trying to match by name with the ones you already have. All your previous data will remain untouched.\n\nThe average duration of this process can be estimated to 2 minutes per 50 albums, always depending on current demand. You can cancel it at anytime and you will be able to keep the albums that were already imported.',
    discogs_import_cancelled: "You cancelled the import process.",
    discogs_import_errored: "An error occurred while importing your albums. You may try again later.",
    discogs_import_created: "The process is in the queue and will start soon. Once it begins, you\u2019ll be able to follow its progress here.",
    discogs_import_finished: "The process was completed successfully!",
    discogs_import_disclaimer: "You can close this window and check back at any time.",
    discogs_import_disclaimer_finished: "You may close this window to go back to your collection.",
    discogs_auth_message: "In order to import your collection from Discogs we need you to give permission to Piper on the Discogs web page. Please click the following button to open Discogs in a new tab and then come back here once the access is granted.",
    discogs_auth_button: "Go to Discogs",
    discogs_auth_retry: "Retry",
    discogs_should_skip_duplicates: "Skip albums with same release ID",
    discogs_should_skip_duplicates_help: "This will avoid duplicating albums you already imported",
    discogs_should_upload_image: "Upload images from Discogs",
    discogs_should_upload_image_non_premium: "Only for premium users",
    discogs_should_upload_image_help: "This will increase the process duration a bit",
    /* ExcelImport */ excel_import_title: "Import from spreadsheet",
    excel_import_message: `Select a spreadsheet file with the 'xlsx' extension. The albums inside the spreadsheet have to comply to a specific format, select the help button on the top right corner of this window to know more.
  
After confirmation you will be able to select the Piper collection you want to import them to.

You can use the following template and fill it with your albums:
  `,
    excel_import_confirmation: `You are about to import all albums from the file "{0}" into the collection "{1}". If any row doesn't comply with the required format, the import process will skip that album.\n\nThis process will add new albums, artists, labels and other attributes as necessary, trying to match by name with the ones you already have. All your previous data will remain untouched.`,
    excel_import_download_template: "Download template",
    excel_import_template_url: "https://piper-public-images.s3.us-east-2.amazonaws.com/Piper-Template.xlsx",
    excel_import_problems: `We encountered some albums with problems, but the rest were successfully added to your collection. Find below a list of the albums that couldn't be imported:
  
{0}
  `,
    excel_import_description: "You can track the progress below.",
    /* Collections */ collection_title: "Collection",
    collection_new_title: "New collection",
    add_collection: "Add collection",
    share_collection: "Share collection",
    star_collection: "Star collection",
    unstar_collection: "Remove star",
    collections_title: "Collections",
    collections_tease: "Soon you'll be able to manage multiple collections!",
    collection_delete_confirmation: 'Are you sure you want to remove the collection named "{0}"? All albums associated with this collection will still be available on the "All albums" collection.',
    private_collection: "Private",
    public_collection: "Public",
    collection_missing_field: "You have to complete {0} of the collection.",
    collection_assign_filtered_albums: "Assign filtered albums to this collection",
    collection_assign_filtered_albums_confirm: "Are you sure you want to assign the currently filtered albums to this collection? This will only add the albums that were previously not present on the selected collection.",
    collection_assign_filtered_albums_success: "The albums were assigned successfully!",
    collection_all_albums: "All albums",
    collection_associate: "Associate collection",
    collection_disassociate: "Disassociate",
    collection_disassociate_confirmation: 'Are you sure you want to disassociate this album from the collection named "{0}"?',
    album_view_on_exhibition: "View at the exhibition",
    collection_description: "Description",
    collection_discount: "Discount",
    collection_create_visibility: "You will be able to convert this to a public collection once you associated some albums to it.",
    collection_visibility: "Visibility",
    collection_banned_fields: "Hidden fields",
    collection_banned_fields_description: "Select a field to hide when other people browse this collection (Only for public collections)",
    collection_banned_field_is_clean: "Played",
    collection_banned_field_is_gatefold: "Gatefold",
    collections_manage_title: "Collections",
    collection_modify: "Edit collection",
    collection_name_placeholder: "Example: Albums on sale",
    collection_image_info: "For best results, try to use images with an aspect ratio similar to 5:1.",
    /* Box Sets */ box_set_title: "Box set",
    box_set_albums_title: "Box set albums",
    box_set_no_albums_title: "This box set has no albums",
    box_set_no_albums_description: "Drag the albums that come in this box set and drop them here",
    box_set_unique_error: "This album is already part of a box set.",
    /* PreferencesViewController */ email_title: "Email",
    theme_option: "Interface style",
    dark_mode: "Gray",
    black_mode: "Night",
    light_mode: "Light",
    blue_mode: "Blue",
    coffee_mode: "Coffee",
    language_title: "Language",
    language_global_title: "Idioma",
    app_version_title: "App version",
    clear_cache_title: "Clear cache",
    about_title: "About this app",
    contact_us: "Contact",
    contact_support_title: "Contact support",
    support_mail: "piper.support@ldelosheros.com",
    reorder_tutorial: `To reorder your albums, drag and drop them to the desired position on the list. You can only reorder albums within the same artist.
  
Make sure you have the 'All albums' collection selected in order to reorder your album list. You also need that the list is ordered by artist with no filters, or only artists filtered.
  
Since this functionality brings performance issues in some devices, this is disabled on mobile. Please use the desktop app or the iOS native app to reorder your albums.
  `,
    credits: "\xa9 2026 Lautaro de los Heros, Piper\u2122",
    credits_short: "\xa9 2026 Piper\u2122",
    /* User Profile */ user_profile_title: "User profile",
    username_title: "Username",
    modify_username_message: "Enter your username. It has to start with a letter and be 8-20 characters long. No special characters allowed except for underscores.",
    no_color_name_title: "New color",
    no_color_names_title: "Colors for non-colored discs",
    no_color_name_message: "Enter a color so it does not count as a colored disc in your statistics:",
    no_color_name_removal_confirmation: 'Are you sure you want to remove the color "{0}"?',
    bio_title: "Bio",
    bio_message: "Enter your bio. It will be visible to other users.",
    resource_limits_title: "Limits",
    public_collections_title: "Public collections",
    remove_account_title: "Remove my account",
    remove_account_confirmation_message: "You are about to remove your user account permanently. THIS CAN'T BE UNDONE! All your albums, attributes, images, and profile will be gone forever. If you are really sure you want to do this, please write 'Remove my account' below and confirm.",
    /* User Role */ update_role_title: "Subscription plan",
    role_admin: "Administrator",
    role_guest: "No plan",
    role_common: "No plan",
    role_collector: "Collector",
    role_premium: "Premium",
    subscription_free: "FREE",
    subscription_pay_info: "You will be charged on the first day of every month except for the first payment that will be done whenever you subscribe. The price of the first installment will be adjusted accordingly depending on the amount of days remaining.",
    subscription_pay_info_apple: "Pay using the Piper app available on the App Store for Apple devices. The subscription is managed by Apple.",
    subscription_pay_info_patreon: "Pay using the Patreon platform. The subscription is managed by Patreon.",
    total: "Total",
    subscription_pay_with_card: "Pay with credit card",
    subscription_pay_with_mercadopago: "Pay with Mercado Pago",
    subscription_pay_with_mercadopago_alert: `We are going to redirect you to Mercado Pago where you will be able to complete your payment.
    
IMPORTANT: It's important that you come back to Piper using the button they provide at the end of the process so we can associate your subscription to our app. If you fail to do so you won't see the subscription on Piper, but don't worry, just contact us in that case and we will fix it for you as soon as possible.`,
    subscription_pay_with_apple: "Pay with the App Store",
    subscription_pay_with_patreon: "Pay with Patreon",
    subscription_payment_method_title: "Payment method",
    per_month: "per month",
    pay_option: "Option",
    pay_option_mercado_pago: "Mercado Pago",
    pay_option_apple: "Apple",
    pay_option_patreon: "Patreon",
    subscription_success: "Your new subscription is ready! Please enter your credentials again to continue.",
    /* My Subscription */ my_subscription_title: "My subscription",
    subscription_manage_in_mercadopago: "Manage in Mercado Pago",
    subscription_manage_in_apple: "Manage in App Store",
    subscription_manage_in_patreon: "Manage in Patreon",
    subscription_status: "Subscription status",
    subscription_end_date: "Your subscription will end",
    subscription_change: "Change my subscription",
    subscription_renew: "Subscribe again",
    payment_last_status: "Last payment status",
    payment_next_date: "Next payment",
    payment_last_update: "Last updated",
    payment_approved: "Approved",
    payment_authorized: "Authorized",
    payment_cancelled: "Cancelled",
    payment_charged_back: "Charged back",
    payment_in_mediation: "In mediation",
    payment_in_process: "Processing",
    payment_pending: "Pending",
    payment_refunded: "Refunded",
    payment_rejected: "Rejected",
    payment_paused: "Paused",
    payment_is_processing_message: "Your payment is being processed. Check back in a few hours to see its status.",
    /* Products */ purchase_alert: "Purchase more",
    purchase_info: "Your limit will be updated once the purchase is confirmed.",
    purchase_info_apple: "Pay using the Piper app available on the App Store for Apple devices.",
    purchase_success: "Your purchase is ready! Enjoy using Piper with your new limit.",
    purchase_empty_list_error: "For your protection, please re-enter your credentials to continue.",
    bundles_title: "Bundles",
    /* Marketplace */ highlighted_collections_title: "Collections",
    highlighted_albums_title: "Albums",
    highlighted_users_title: "Users",
    public_username_prefix: "Collection from",
    marketplace_search_placeholder: "Albums, collections, users",
    no_public_collections: "No public collections to show",
    /* UserProfileDialog */ edit_avatar: "Edit avatar",
    user_since_title: "User since",
    /* Shortcuts */ shortcuts_title: "Shortcuts",
    shortcuts_add_albums: "Add a new album",
    shortcuts_scan_barcode: "Add an album from a barcode or search",
    shortcuts_discogs_import: "Import albums from my Discogs account",
    shortcuts_excel_import: "Import albums from a spreadsheet",
    shortcuts_stats: "See statistics of my albums",
    shortcuts_albums: "See my albums",
    shortcuts_attributes: "Add a new artist, label, exchange rate and more...",
    shortcuts_marketplace: "Explore collections from other users",
    shortcuts_filter: "Filter my albums on this collection",
    shortcuts_filter_public: "Filter the albums on this collection",
    shortcuts_random_albums: "Get a random album from this collection",
    shortcuts_change_collection: "View albums from a different collection",
    shortcuts_create_user: "Create a new user or sign in",
    shortcuts_search_title: "There are no albums to show",
    shortcuts_documentation: "Check the documentation for help or tips",
    shortcuts_edit_profile: "Customize my user profile",
    shortcuts_layout: "Organize the physical location of my albums",
    /* User Notifications */ user_notifications_title: "Notifications",
    mark_as_read: "Mark as read",
    mark_as_unread: "Mark as unread",
    /* ScanBarcode */ scan_barcode_title: "Scan the barcode present on the album",
    scan_barcode_description: "Alternatively, enter the barcode manually or any information about the album",
    camera_title: "Scan a barcode",
    flashlight: "Flashlight",
    open_camera: "Open camera",
    switch_camera: "Switch camera",
    /* Messages */ messages_title: "Comments",
    messages_new_title: "New comment",
    messages_reply: "Reply",
    messages_more: "More comments",
    messages_replying_to: "You are replying to a comment from {0}",
    messages_reply_more: "1  reply",
    messages_replies_more: "{0}  replies",
    message_removed: "<<Message removed>>",
    album_no_messages: "This album doesn't have comments yet",
    view_message: "View comment",
    messages_private_notice: "If you want to reply to a comment visit this album at the exhibition.",
    messages_confirm_removal: `Are you sure you want to remove the message from {0} and all its replies? The message says:
  
  "{1}"`,
    messages_report: "Report message",
    /* Insights */ insights_title: "Album insights",
    suggested_price_title: "Suggested sale price",
    genres_title: "Music genres",
    rarity_title: "Release rarity",
    credits_title: "Credits",
    insights_tags_title: "Suggested tags",
    insights_disclaimer: "Generated by OpenAI. Information can be inaccurate or false.",
    insights_refresh: "Regenerate insights",
    /* Reports */ report_new: "New report",
    report_description: "Tell us more about this report:",
    report_success: "Report sent successfully! Thanks for your support.",
    /* Chats */ chats_title: "Conversations",
    chat_placeholder: "Type your message here...",
    chat_send: "Send message",
    chat_new: "Send a message",
    chat_select: "Select a conversation",
    chat_new_user: "Start a new conversation",
    chat_empty_title: "You don't have any conversations yet",
    chat_empty_description: "Start chatting with other users by using the button on the toolbar",
    chat_messages_empty_title: "There are no messages to display yet",
    chat_messages_empty_description: "You will see here your message history with this user once you start chatting",
    public_user_profiles_empty: "Type a username in the search bar to find users",
    chat_new_message_notification: "You have a new message",
    open_chats_list: "Open conversations list",
    /* Layout */ layout_title: "Layout",
    shelving_title: "Shelving unit",
    shelvings_title: "Shelving units",
    shelving_new_title: "New shelving unit",
    shelving_tutorial: "Drag the spine of the album you see in the list to any of the segments to locate it. Drag the spines within the segment to rearrange them. Click on any album to select it and see its position on the shelving unit, or right click to access its detail.",
    shelf_title: "Shelf",
    shelf_new_title: "New shelf",
    shelf_segment_title: "Segment",
    shelf_segment_new_title: "New segment",
    shelf_segment_position_title: "Position",
    shelf_segment_image_title: "Background image",
    highlight_filtered_albums: "Highlight filtered albums",
    shelving_edit_title: "Edit shelving unit",
    shelf_edit_title: "Edit shelf",
    shelf_segment_edit_title: "Edit segment",
    shelving_orientation: "Shelving unit orientation",
    shelving_theme: "Shelving unit material",
    shelving_every_album_same_size: "Extend albums to take full size",
    shelving_cedar: "Cedar",
    shelving_oak: "Oak",
    shelving_ebony: "Ebony",
    shelving_walnut: "Walnut",
    shelving_blue: "Blue",
    shelving_name_placeholder: "Example: Main vinyl storage",
    shelving_delete_confirmation: `Are you sure you want to remove the shelving unit named "{0}"? You won't lose any albums associated with this shelving unit.`,
    shelf_name_placeholder: "Example: Top shelf",
    shelf_delete_confirmation: `Are you sure you want to remove the shelf named "{0}"? You won't lose any albums associated with this shelf.`,
    shelf_segment_name_placeholder: "Example: First segment",
    shelf_segment_delete_confirmation: `Are you sure you want to remove the segment named "{0}" from the shelf "{1}"? You won't lose any albums associated with this segment.`,
    empty_shelvings: "Select a shelving unit to display it here",
    empty_shelvings_subtitle: "Or add a new one using the button below",
    shelf_album_added_message: "Album added to the shelf segment successfully",
    shelf_album_removed_message: "Album removed from the shelf segment successfully",
    shelf_album_duplicate_error: "You already have that album on that shelf segment!",
    shelf_remove_album: "Remove from shelf segment",
    shelf_remove_all_albums: "Remove all albums from segment",
    shelf_segment_album_shape_title: "Album's shape",
    shelf_segment_album_shape_long_play: "12\u2033",
    shelf_segment_album_shape_ten_inches: "10\u2033",
    shelf_segment_album_shape_single: "7\u2033",
    shelf_segment_album_shape_cd: "CD",
    shelf_segment_album_shape_box_set: "Box set",
    shelf_segment_assign_filtered_albums: "Assign filtered albums to this segment",
    shelf_segment_add_album_title: "Adding albums",
    shelf_segment_focus_option: "Focus on this segment",
    album_location_title: "Location",
    album_position_title: "Position",
    layout_cannot_move_message: "To make modifications to this shelving unit, go to the Layout page.",
    shelving_albums_stats_title: "Shelving unit albums",
    shelf_albums_stats_title: "Shelf albums",
    shelf_segment_albums_stats_title: "Segment albums",
    layout_remove_from_all_segments: "Remove from all previous locations",
    /* Listening Sessions */ listening_sessions_title: "Listening sessions",
    open_listening_sessions_list: "Open listening sessions list",
    /* Passkeys */ passkeys_title: "Passkeys",
    passkey_title: "Passkey",
    passkeys_description: "All your passkeys registered on Piper are on this list. If you removed any of them from your Password Manager, it is safe to remove them from here as well.",
    add_passkey: "Add new passkey",
    empty_passkeys: "You don't have any passkeys set for your account",
    passkey_register_success: "Passkey created successfully!",
    passkey_authentication_error: "There was an error trying to sign in with your passkey.\n\nPlease make sure that your passkey was not removed from Piper. If that's the case, you will need to create a new passkey.",
    passkey_registration_error: "There was an error while trying to create the passkey. Bear in mind that if you see the new passkey on your Password Manager it won't work, so please remove it and try again.",
    passkeys_delete_confirmation_message: "You are about to delete this passkey from Piper's servers, which means it will stop working even if you still see it available on your Password Manager.",
    /* Documentation */ documentation: "Documentation",
    doc_home: (0, $ccb801b8c23cc74a$export$6dd379fc6e5f35de),
    doc_users_sign_up: (0, $9655a299f310e708$export$c71c41faa1de24b1),
    doc_users_guest: (0, $c66928e3a171c71c$export$7b1ce76ed3f82777),
    doc_users_recover_password: (0, $94d5f33e5857513d$export$d5426d5fe7dfc3b8),
    doc_albums: (0, $9daa41d3b051bf64$export$8cca8d1e3e513d09),
    doc_filter_albums: (0, $ab029a9301c21c13$export$3388bd10fad0f1dc),
    doc_order_albums: (0, $0ff13c13bd4f75f8$export$373197abd871bcf9),
    doc_import_from_discogs: (0, $fc466607539d580f$export$c41fffa845e1b6ab),
    doc_import_from_excel: (0, $0ff58104970c8294$export$7122114fca46c41),
    doc_image_gallery: (0, $36016b20ce653c88$export$cb5c3ea7ba53f1c9),
    doc_marking_albums: (0, $d9cb1fd05a798d96$export$603ecef77541051a),
    doc_remove_filtered_albums: (0, $27a4ed32271cf519$export$742374044b5fde90),
    doc_albums_add_barcode: (0, $418721900505f3ff$export$f27ef69adc960c33),
    doc_album_attributes: (0, $0764ba5d288fb087$export$f1e81a3f7ddd0c0c),
    doc_artists: (0, $9632185a00f8a913$export$c277dc1020bd891c),
    doc_collections: (0, $7562db84c161b9cc$export$ca4e0bc9e4e6041c),
    doc_collections_attributes: (0, $24216a93aa855f85$export$ec948778fd5dc767),
    doc_collections_public_collections: (0, $35e05c171c00f4ec$export$2addc290eb3bb210),
    doc_user_profile: (0, $5b6c76474f1d5514$export$51be0acb28ba999e),
    doc_subscriptions: (0, $c0bb94a33946a800$export$ed761d2fe331cbb3),
    doc_purchases: (0, $985645e8fabe37c3$export$fb93cc3c82e16db8),
    doc_mercado_pago_subscriptions: (0, $aee53751086b7b95$export$958dad51223257d7),
    doc_more_options_title: "More things you can do",
    about_piper: (0, $31f8457cd442d71b$export$e2ab8fcb1ba5dc0e),
    privacy_policy: (0, $cdc28c7e83edddec$export$b5ad9a92648612e5),
    terms: (0, $40fb39c427f4dba8$export$db20c90c7e082a55),
    tutorial_video_id: "KYEkl_BWJ4I"
};


var $3f38977a95bdc37b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $3f38977a95bdc37b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3f38977a95bdc37b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $3f38977a95bdc37b$export$2e2bcd8739ae039 = $3f38977a95bdc37b$var$formatDistance;



var $e0827d09e1890ff5$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $e0827d09e1890ff5$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e0827d09e1890ff5$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e0827d09e1890ff5$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $e0827d09e1890ff5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $e0827d09e1890ff5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $e0827d09e1890ff5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e0827d09e1890ff5$export$2e2bcd8739ae039 = $e0827d09e1890ff5$var$formatLong;


var $ef723e96194b0a6f$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $ef723e96194b0a6f$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $ef723e96194b0a6f$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $ef723e96194b0a6f$var$formatRelativeLocalePlural[token];
    else return $ef723e96194b0a6f$var$formatRelativeLocale[token];
};
var $ef723e96194b0a6f$export$2e2bcd8739ae039 = $ef723e96194b0a6f$var$formatRelative;



var $0793f5c5ac77ee04$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $0793f5c5ac77ee04$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $0793f5c5ac77ee04$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $0793f5c5ac77ee04$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $0793f5c5ac77ee04$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $0793f5c5ac77ee04$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $0793f5c5ac77ee04$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $0793f5c5ac77ee04$var$localize = {
    ordinalNumber: $0793f5c5ac77ee04$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0793f5c5ac77ee04$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0793f5c5ac77ee04$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0793f5c5ac77ee04$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0793f5c5ac77ee04$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0793f5c5ac77ee04$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0793f5c5ac77ee04$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0793f5c5ac77ee04$export$2e2bcd8739ae039 = $0793f5c5ac77ee04$var$localize;




var $ba13f018c6a5e187$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $ba13f018c6a5e187$var$parseOrdinalNumberPattern = /\d+/i;
var $ba13f018c6a5e187$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $ba13f018c6a5e187$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $ba13f018c6a5e187$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $ba13f018c6a5e187$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ba13f018c6a5e187$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $ba13f018c6a5e187$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $ba13f018c6a5e187$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $ba13f018c6a5e187$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $ba13f018c6a5e187$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $ba13f018c6a5e187$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $ba13f018c6a5e187$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $ba13f018c6a5e187$var$matchOrdinalNumberPattern,
        parsePattern: $ba13f018c6a5e187$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $ba13f018c6a5e187$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba13f018c6a5e187$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $ba13f018c6a5e187$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba13f018c6a5e187$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $ba13f018c6a5e187$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba13f018c6a5e187$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $ba13f018c6a5e187$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba13f018c6a5e187$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $ba13f018c6a5e187$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ba13f018c6a5e187$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ba13f018c6a5e187$export$2e2bcd8739ae039 = $ba13f018c6a5e187$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $00427cc67faa552f$var$locale = {
    code: 'es',
    formatDistance: (0, $3f38977a95bdc37b$export$2e2bcd8739ae039),
    formatLong: (0, $e0827d09e1890ff5$export$2e2bcd8739ae039),
    formatRelative: (0, $ef723e96194b0a6f$export$2e2bcd8739ae039),
    localize: (0, $0793f5c5ac77ee04$export$2e2bcd8739ae039),
    match: (0, $ba13f018c6a5e187$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $00427cc67faa552f$export$2e2bcd8739ae039 = $00427cc67faa552f$var$locale;


var $a2d7b34b16d763a9$exports = {};
$a2d7b34b16d763a9$exports = $parcel$resolve("72JCb");


const $63faa905ff85dcab$var$deleteImage = new URL($a2d7b34b16d763a9$exports).href;
var $5068ff0f4c69f10b$exports = {};
$5068ff0f4c69f10b$exports = $parcel$resolve("cqy1E");


const $63faa905ff85dcab$var$createImage = new URL($5068ff0f4c69f10b$exports).href;
const $63faa905ff85dcab$export$d84822a6728c7be5 = {
    title: "\xc1lbumes",
    home_title: "Manejar tus \xe1lbumes",
    description: `Llamamos \xe1lbum al conjunto de grabaciones musicales que puede estar representado en un disco de vinilo, disco compacto, cassette, etc. En Piper los \xe1lbumes cuentan con distintos atributos totalmente personalizables para que puedas administrar tu colecci\xf3n de la manera que prefieras. Tambi\xe9n ten\xe9s varias opciones para ordenar y organizar tus \xe1lbumes por artista, sello discogr\xe1fico y mucho m\xe1s.
  
  Existe tambi\xe9n la posibilidad de organizar los \xe1lbumes en distintas colecciones y revisar estad\xedsticas independientemente para cada una de ellas.

  \xa1Pens\xe1 en grande! Agreg\xe1 a tu colecci\xf3n todos tus vinilos, CD's, o incluso \xe1lbumes que tengas en formato digital. Personaliz\xe1 tu colecci\xf3n de manera que cumpla con tus necesidades.

`,
    create_title: "Agregar un \xe1lbum",
    create_image: $63faa905ff85dcab$var$createImage,
    create_description: `
  Para agregar un nuevo \xe1lbum basta con hacer click en el bot\xf3n de '+' en la barra de herramientas de la p\xe1gina de 'Mis \xe1lbumes'.

  Un nuevo di\xe1logo se va a abrir donde se pueden ingresar todos los atributos del nuevo \xe1lbum. Se puede navegar haciendo click en cada campo o presionando la tecla TAB y presionando ENTER en los campos donde se requiere selecci\xf3n.
  
  Para modificar la imagen basta con arrastrar la nueva imagen sobre la vieja, o hacer click sobre la imagen y seleccionar una nueva.
  
  Una vez confirmes, un texto rojo va a aparecer debajo de los campos obligatorios que no est\xe9n llenados. Si todos los campos mandatorios est\xe1n completos entonces el \xe1lbum va a ser creado.

`,
    delete_image: $63faa905ff85dcab$var$deleteImage,
    delete_title: "Eliminar un \xe1lbum",
    delete_description: `Para eliminar un \xe1lbum, hac\xe9 click derecho sobre \xe9l en la lista de \xe1lbumes y seleccion\xe1 la opci\xf3n de eliminar. Un di\xe1logo de confirmaci\xf3n va a aparecer para que puedas chequear el nombre del \xe1lbum antes de eliminarlo.
  
  Esta operaci\xf3n es irreversible, as\xed que asegurate de estar eliminando el \xe1lbum correcto. El \xe1lbum eliminado va a ser desasignado autom\xe1ticamente de todas las colecciones a las que estaba asignado. Si alguien accede a un link compartido del \xe1lbum eliminado, van a poder seguir viendo la colecci\xf3n p\xfablica y simplemente el \xe1lbum no va a ser cargado.
  
`
};


var $1ee115ae90c23323$exports = {};
$1ee115ae90c23323$exports = $parcel$resolve("4cR7I");


const $aac53b980a1af387$var$importDiscogsImage = new URL($1ee115ae90c23323$exports).href;
const $aac53b980a1af387$export$8ab68e0958b3d3bd = {
    title: "Importar \xe1lbumes desde Discogs",
    import_image: $aac53b980a1af387$var$importDiscogsImage,
    description: `Si ten\xe9s una cuenta en Discogs pod\xe9s importar tus \xe1lbumes a Piper. Seleccion\xe1 la opci\xf3n desde el men\xfa desplegable y un di\xe1logo se va a abrir.
  
  Si es la primera vez que lo hac\xe9s el navegador te va a redirigir a Discogs para que inicies sesi\xf3n y des permiso a Piper para poder ver tu colecci\xf3n.
  
  Luego de aceptar vas a poder elegir de qu\xe9 carpeta de Discogs importar tus \xe1lbumes. Esto es especialmente \xfatil si quer\xe9s importar solamente algunos de tus \xe1lbumes. Si ya ten\xe9s una parte de tu colecci\xf3n importada pod\xe9s seleccionar la opci\xf3n de saltear los \xe1lbumes con el mismo ID de release. Esto va a asegurar que esos \xe1lbumes no se dupliquen en el proceso.
  
  Si ten\xe9s un plan de suscripci\xf3n premium, pod\xe9s seleccionar la opci\xf3n para traer las im\xe1genes de los \xe1lbumes directamente desde Discogs (s\xf3lo la tapa). Esto tambi\xe9n va a hacer que el proceso sea m\xe1s lento.
  
  Una vez seleccionada la carpeta de Discogs vas a poder seleccionar opcionalmente una colecci\xf3n en particular donde se asignar\xe1n todos los \xe1lbumes importados. De cualquier manera siempre los vas a encontrar en la colecci\xf3n de 'Todos los \xe1lbumes'.
  
  Ten\xe9 en cuenta que la importaci\xf3n puede tardar algunos minutos dependiendo de la cantidad de \xe1lbumes a importar. El proceso se va a ejecutar en nuestros servidores por lo que pod\xe9s cerrar la ventana y seguir usando la aplicaci\xf3n mientras la importaci\xf3n sigue su curso. Si volv\xe9s a ingresar a la opci\xf3n de importaci\xf3n vas a poder ver el progreso o cancelar.
  
  Los \xe1lbumes importados no van a tener todos los par\xe1metros cargados, as\xed que vas a tener que revisarlos para hacer las \xfaltimas modificaciones a tu gusto.
  
`
};


const $b156c324d3b025b1$export$5913f56a875a5231 = {
    title: "T\xe9rminos de Servicio",
    title_short: "T. de Servicio",
    block1: `Piper comenz\xf3 como un proyecto personal que poco a poco fue creciendo y sigue haci\xe9ndolo d\xeda a d\xeda. Tanto Piper como su dominio ldelosheros.com son propiedad de Lautaro de los Heros ("Piper", "Nosotros", "Nuestro") y es provisto a vos ("El usuario", "Vos", "Tu") bajo estos t\xe9rminos de servicio. Las condiciones en este documento de T\xe9rminos de Servicio rigen para todos los usuarios que utilicen la aplicaci\xf3n, tanto en su versi\xf3n web como m\xf3vil.
  
  Si ten\xe9s preguntas adicionales o requer\xeds m\xe1s informaci\xf3n sobre estos t\xe9rminos, no dudes en contactarnos.
  
  `,
    consent_title: "Consentimiento",
    consent: `Al usar nuestra aplicaci\xf3n acept\xe1s nuestros t\xe9rminos de servicio sin objeciones.
  
  `,
    service_title: "Sobre el servicio",
    service: `Piper es una aplicaci\xf3n que permite a sus usuarios cargar informaci\xf3n acerca de su colecci\xf3n de m\xfasica, como ser \xe1lbumes, artistas, sellos discogr\xe1ficos y m\xe1s, as\xed como tambi\xe9n de ciertos datos personales resguardados seg\xfan nuestra Pol\xedtica de Privacidad.
  
  Piper ofrece tambi\xe9n la posibilidad a sus usuarios de compartir de forma libre contenidos de sus colecciones con otros usuarios.
  
  `,
    data_title: "Sobre los datos",
    data: `Todos los datos guardados en Piper cuentan con un respaldo que es actualizado todos los d\xedas, salvo error o causas ajenas a Piper. Este respaldo sirve como punto de retorno en caso de extrema necesidad o para buscar datos hist\xf3ricos de alg\xfan usuario que as\xed lo requiriera. Esto no significa que esta informaci\xf3n est\xe9 disponible para su consulta, pero pod\xe9s ponerte en contacto por m\xe1s detalles.
  
  Pod\xe9s consultar nuestra Pol\xedtica de Privacidad para saber c\xf3mo manejamos tus datos.
  
  Las responsabilidades de Piper respecto a estos datos se especifican en estos t\xe9rminos de servicio m\xe1s adelante.
  
  `,
    ai_info_title: "Funciones impulsadas por IA",
    ai_info: `Piper incluye una funci\xf3n limitada (Informaci\xf3n del \xe1lbum) que utiliza inteligencia artificial (IA) para generar resultados automatizados basados en un \xe1lbum. Esta funci\xf3n se ofrece \xfanicamente con fines informativos y de asistencia. Los resultados generados por IA pueden ser inexactos y no deben considerarse como asesoramiento profesional ni como veraces.

Vos sos el \xfanico responsable del uso que hagas de los resultados generados por la funci\xf3n de IA. No garantizamos la exactitud, integridad ni fiabilidad de dichos resultados y declinamos toda responsabilidad derivada de su confianza. Podemos modificar, suspender o interrumpir la funci\xf3n de IA en cualquier momento.

`,
    users_title: "Sobre los usuarios",
    users: `Para poder ser un usuario de Piper se deben cumplir los siguientes requisitos sin excepci\xf3n:
  `,
    users_1: "Ser mayor de 13 a\xf1os (o la edad m\xednima legal en su territorio).",
    users_2: "Siempre actuar de buena fe.",
    users_3: "Siempre proporcionar informaci\xf3n verdadera y que no vaya en contra del buen gusto y la buena \xe9tica, o que vulnere derechos de terceros.",
    users_4: "Bajo ning\xfan caso se permite intentar vulnerar o enga\xf1ar al sistema.",
    users_5: "No se debe abusar ni usar de manera indebida los canales de contacto y denuncia.",
    users_6: "No se debe acceder ni recoger datos de nuestro sistema de manera automatizada o sin el permiso correspondiente.",
    users_7: "No se debe intercambiar o solicitar nombres de usuario y/o contrase\xf1as a otros usuarios ni apropiarse de indentificadores de acceso.",
    users_8: "Est\xe1 prohibido vender o conceder licencias sobre productos adquiridos desde esta aplicaci\xf3n.",
    users_9: "No se debe incurrir en abuso, agresiones, o cualquier tipo de acci\xf3n agresiva contra cualquier otro usuario, ya sea por mensajer\xeda o cualquier medio pertinente.",
    users_10: "Se debe cesar el uso de la aplicaci\xf3n inmediatamente si se incurre en cualquier acto ilegal, enga\xf1oso, discriminatorio o fraudulento, o en el caso de ayudar a un tercero a hacerlo.",
    users_11: `No se debe infringir ninguno de los puntos establecidos en estos t\xe9rminos de servicio.
  
  `,
    subscriptions_title: "Sobre las compras y suscripciones",
    subscriptions: `Las compras y suscripciones son el \xfanico medio para afrontar los gastos productivos de Piper y as\xed poder mantener a la aplicaci\xf3n libre de publicidades. 

Las compras son pagos de una \xfanica vez que extienden los l\xedmites de los distintos recursos que posee el usuario en Piper. Su acreditaci\xf3n es inmediata luego de un cobro exitoso.

Todas las suscripciones tienen un cobro por d\xe9bito autom\xe1tico en el per\xedodo especificado por cada una. La modalidad y fecha exacta del cobro var\xeda seg\xfan la plataforma de pago que se haya elegido al momento de alta de la suscripci\xf3n. 

El monto de compra o suscripci\xf3n vigente es reembolsable \xfanicamente si el usuario manifiesta su intenci\xf3n de reembolso hasta 48 horas posteriores al cobro de la compra o suscripci\xf3n, y siempre que se est\xe9n cumpliendo los t\xe9rminos de servicio de este documento. En caso de reembolso, la compra o suscripci\xf3n quedar\xe1 cancelada autom\xe1ticamente y el usuario dejar\xe1 de contar con los beneficios de la compra o suscripci\xf3n en ese mismo instante. 

Si el usuario desea cancelar la suscripci\xf3n puede hacerlo desde la plataforma de pagos o contactando a soporte. En este caso la suscripci\xf3n queda cancelada y no se procesar\xe1n m\xe1s pagos a partir de la fecha, pero el usuario podr\xe1 seguir utilizando los beneficios de la suscripci\xf3n hasta la fecha de vencimiento del per\xedodo ya pagado. En caso de cancelaci\xf3n de suscripci\xf3n no existe la posibilidad de reembolso. 

El monto de cada compra puede ser modificado sin previo aviso. El mismo estar\xe1 visible en el men\xfa correspondiente al momento de la compra. 

El monto de cuota de las suscripciones puede ser modificado, y su modificaci\xf3n ser\xe1 informada a trav\xe9s del canal oficial de comunicaciones de Piper con hasta 7 d\xedas de anticipaci\xf3n. El nuevo monto estar\xe1 vigente para todas las nuevas suscripciones y se cobrar\xe1 a las suscripciones activas en el pr\xf3ximo cobro aplicable. 

El monto de las suscripciones puede contar con un descuento temporal. Este descuento puede ser modificado y su modificaci\xf3n ser\xe1 informada a trav\xe9s del canal oficial de comunicaciones de Piper con hasta 7 d\xedas de anticipaci\xf3n. El nuevo monto estar\xe1 vigente para todas las nuevas suscripciones y se cobrar\xe1 a las suscripciones activas en el pr\xf3ximo cobro aplicable. 

Los l\xedmites en los recursos de cada usuario podr\xe1n ser modificados sin previo aviso en caso de detectarse cualquier aprovechamiento o intento de vulnerar el sistema de compras, pudiendo ser motivo suficiente para la inhabilitaci\xf3n o suspensi\xf3n del usuario de manera temporal o permanente.

`,
    warranties_title: "Descargo de garant\xedas",
    warranties: `Al usar esta aplicaci\xf3n acept\xe1s y entend\xe9s que:
  `,
    warranties_1: `Us\xe1s el servicio bajo tu propio riesgo. El servicio se ofrece "tal cual" y "seg\xfan disponibilidad", nosotros renunciamos a cualquier tipo de garant\xeda expl\xedcita o impl\xedcita.`,
    warranties_2: "No ofrecemos garant\xeda de ning\xfan tipo de que el servicio vaya a cumplir con tus expectativas, que el servicio sea interrumpido, oportuno, seguro o libre de errores, de que los resultados obtenidos por la utilizaci\xf3n del servicio sean precisos o confiables.",
    warranties_3: "No ofrecemos garant\xeda alguna respecto a la calidad del producto, sus servicios o la informaci\xf3n brindada, o que el material comprado u obtenido a trav\xe9s del servicio cumpla con tus expectativas.",
    warranties_4: "No ofrecemos garant\xeda que los errores presentes en el sistema sean arreglados en alg\xfan momento.",
    warranties_5: `No promovemos ni aprobamos ideas o mensajes en el contenido generado por los usuarios del servicio.
  
  `,
    rights_title: "Derechos y responsabilidades",
    rights: `Piper se reserva el derecho de inhabilitar o suspender de manera temporal o permanente a cualquier usuario que no cumpla con cualquiera de los t\xe9rminos expresados en este documento.
  
  Piper se reserva el derecho de eliminar cualquier contenido que crea inapropiado o que no cumpla con cualquiera de los t\xe9rminos expresados en este documento.
  
  Piper se reserva el derecho de modificar de manera parcial o total cualquier nombre de usuario si se identificara una situaci\xf3n de usurpaci\xf3n de identidad o cualquier otra raz\xf3n que se crea pertinente, informando de manera pertinente al usuario involucrado.
  
  Piper se reserva el derecho de cancelar la suscripci\xf3n del usuario si as\xed lo considere apropiado, notificando al usuario de forma pertinente.
  
  Piper se reserva el derecho de decisi\xf3n sobre tanto otorgar o no otorgar un reembolso evaluando el caso particular del usuario.
  
  Piper se reserva todos los derechos que no se hayan concedido de manera expresa.
  
  Piper ofrece sus productos "tal cual", por lo cual, en la medida en que la ley lo permita, no garantizamos que nuestros servicios funcionen de forma segura y sin errores, interrupciones, demoras o imperfecciones. De la misma manera, en la medida en que la ley lo permita, NOS EXIMIMOS DE TODA RESPONSABILIDAD, YA SEA EXPL\xcdCITA O IMPL\xcdCITA, INCLUIDAS LAS GARANT\xcdAS IMPL\xcdCITAS DE COMERCIALIZACI\xd3N, ADECUACI\xd3N A UN USO CONCRETO, T\xcdTULO Y NO INFRACCI\xd3N. No tenemos control ni influencia sobre lo que las personas hacen o dicen. Asimismo, no somos responsables de sus comportamientos o acciones, ya sea dentro o fuera de internet, ni del contenido que comparten, incluido aquel que pueda resultar ofensivo, inapropiado, obsceno, ilegal o cuestionable. 
  
  Piper limita su responsabilidad en la m\xe1xima medida en que la ley aplicable lo permita, y bajo ninguna circunstancia asumiremos responsabilidad alguna por la p\xe9rdida de ganancias, ingresos, informaci\xf3n o datos; y por los da\xf1os consecuenciales, especiales, indirectos, ejemplares, punitivos o eventuales que surjan como consecuencia de estos T\xe9rminos de Servicio (por cualquier causa y cualquier tipo de responsabilidad, incluida la negligencia), incluso en el caso de que se nos haya advertido de la posibilidad de que se produzcan dichos da\xf1os.
  
  `,
    maintenance_title: "Mantenimiento",
    maintenance: `La aplicaci\xf3n puede entrar en modo de mantenimiento por tiempo indefinido, en cualquier momento, y sin previo aviso. Ante este acontecimiento, los usuarios no podr\xe1n acceder a los contenidos de la aplicaci\xf3n hasta que se regularice la situaci\xf3n.
  
  `,
    links_title: "Links",
    links_description: "Nosotros y otras personas relacionadas con la aplicaci\xf3n podemos proporcionar enlaces a sitios web o recursos externos. Dado que Piper no tiene control sobre dichos sitios web y recursos, el usuario reconoce y acepta que no somos responsables de la disponibilidad de dichos sitios web o recursos externos, y no respaldamos ni nos hacemos responsables de ning\xfan contenido, publicidad, productos u otros materiales en o disponibles a trav\xe9s de dichos sitios web o recursos. Adem\xe1s, el usuario reconoce y acepta que Piper no ser\xe1 responsable, directa ni indirectamente, de ning\xfan da\xf1o o p\xe9rdida causados o presuntamente causados por o en relaci\xf3n con el uso o la confianza en dicho contenido, bienes o servicios disponibles en o a trav\xe9s de dichos sitios web o recursos de terceros. Por ejemplo, Piper utiliza los Servicios API de YouTube para proporcionar acceso al contenido de YouTube. Al usar el reproductor de YouTube en la aplicaci\xf3n, el usuario acepta estar sujeto a los ",
    links_youtube_terms: "T\xe9rminos de Servicio de YouTube",
    changes_title: "Cambios en estos T\xe9rminos de Servicio",
    changes: `Es posible que actualicemos nuestros T\xe9rminos de Servicio de vez en cuando. Por lo tanto, te recomendamos que revises esta p\xe1gina peri\xf3dicamente por cualquier cambio. Te notificaremos cualquier cambio publicando los nuevos T\xe9rminos de Servicio en esta p\xe1gina. Estos cambios entran en vigencia inmediatamente despu\xe9s de que se publiquen en esta p\xe1gina, cualquier usuario que contin\xfae utilizando la aplicaci\xf3n luego de la publicaci\xf3n de los cambios quedar\xe1 sujeto a los nuevos t\xe9rminos.
  
  `,
    contact_title: "Contactanos",
    contact: `Si ten\xe9s alguna pregunta o sugerencia sobre nuestros T\xe9rminos de Servicio, no dudes en ponerte en contacto con nosotros.
  
  Si detect\xe1s alguna situaci\xf3n en la cual no se est\xe9n cumpliendo estos t\xe9rminos pod\xe9s denunciarlo por el mismo canal de contacto.
  
  
  `,
    last_update: "\xdaltima actualizaci\xf3n: 11 de enero, 2026"
};


const $edd66397ac9d909c$export$5cc920282035c3b9 = {
    title: "Pol\xedtica de Privacidad",
    title_short: "P. de Privacidad",
    block1: `Una de nuestras principales prioridades en Piper es la privacidad de nuestros usuarios. Este documento de Pol\xedtica de Privacidad contiene tipos de informaci\xf3n que Piper recopila y registra y c\xf3mo usamos esa informaci\xf3n.
  
  Si ten\xe9s preguntas adicionales o requer\xeds m\xe1s informaci\xf3n sobre nuestra Pol\xedtica de Privacidad, no dudes en contactarnos.
  
  Esta Pol\xedtica de Privacidad se aplica s\xf3lo a nuestras actividades en l\xednea y es v\xe1lida para los usuarios de nuestra aplicaci\xf3n con respecto a la informaci\xf3n que compartieron y/o recopilaron en Piper. Esta pol\xedtica no se aplica a ninguna informaci\xf3n recopilada fuera de l\xednea o a trav\xe9s de canales que no sean esta aplicaci\xf3n.
  
  `,
    consent_title: "Consentimiento",
    consent: `Al usar nuestra aplicaci\xf3n acept\xe1s nuestra Pol\xedtica de Privacidad y acept\xe1s sus t\xe9rminos.
  
  `,
    info_collect_title: "Informaci\xf3n que recopilamos",
    info_collect: `La informaci\xf3n personal que te solicitamos proporcionar, y las razones por las que se te la solicita, se te aclarar\xe1n en el momento en que te solicitemos que proporciones tu informaci\xf3n personal.
  Si te comunic\xe1s con nosotros directamente, podemos recibir informaci\xf3n adicional sobre tu persona, como tu nombre, direcci\xf3n de correo electr\xf3nico, n\xfamero de tel\xe9fono, el contenido del mensaje y/o los archivos adjuntos que nos env\xedes, y cualquier otra informaci\xf3n que elijas proporcionar.
  Cuando te registres para una Cuenta, s\xf3lo te vamos a pedir tu direcci\xf3n de correo electr\xf3nico y una contrase\xf1a.
  
  `,
    sensitive_info_title: "Informaci\xf3n sensible",
    sensitive_info_description: `Consideramos informaci\xf3n sensible a tu contrase\xf1a, tokens de acceso, y mensajes privados que env\xedes a otros usuarios. Todos esos campos se guardan encriptados en nuestra base de datos, de forma que nadie pueda leer esos datos sin la llave de encriptaci\xf3n.
  
  `,
    info_use_title: "C\xf3mo usamos tu informaci\xf3n",
    info_use: `Usamos la informaci\xf3n que recopilamos de varias maneras, incluso para:
  `,
    info_use_1: "Proporcionar, operar y mantener nuestra aplicaci\xf3n.",
    info_use_2: "Mejorar, personalizar y ampliar nuestra aplicaci\xf3n.",
    info_use_3: "Comprender y analizar c\xf3mo us\xe1s nuestra aplicaci\xf3n.",
    info_use_4: "Desarrollar nuevos productos, servicios, caracter\xedsticas y funcionalidades.",
    info_use_5: "Comunicarnos con vos, ya sea directamente o a trav\xe9s de uno de nuestros socios, incluido el servicio de atenci\xf3n al cliente, para brindarte actualizaciones y otra informaci\xf3n relacionada con la aplicaci\xf3n, y con fines promocionales y de marketing.",
    info_use_6: "Enviarte correos electr\xf3nicos.",
    info_use_7: `Encontrar y prevenir el fraude.
  
  `,
    log_files_title: "Archivos de registro",
    log_files: `Piper sigue un procedimiento est\xe1ndar de uso de archivos de registro. Estos archivos registran a los visitantes cuando visitan y usan nuestra aplicaci\xf3n. La informaci\xf3n recopilada por los archivos de registro incluye direcciones de protocolo de Internet (IP), tipo de navegador, proveedor de servicios de Internet (ISP), marca de fecha y hora, p\xe1ginas de referencia/salida y, posiblemente, la cantidad de clics. Estos no est\xe1n vinculados a ninguna informaci\xf3n que sea personalmente identificable. El prop\xf3sito de la informaci\xf3n es analizar tendencias, administrar el sitio, rastrear el movimiento de los usuarios en el sitio web y recopilar informaci\xf3n demogr\xe1fica.
  
  `,
    cookies_title: "Cookies",
    cookies: `Como cualquier otro sitio web, Piper utiliza "cookies". Estas cookies se utilizan para almacenar informaci\xf3n, incluidas las preferencias de los visitantes y las p\xe1ginas del sitio web a las que accedi\xf3 o visit\xf3 el visitante. La informaci\xf3n se utiliza para optimizar la experiencia de los usuarios al personalizar el contenido de nuestra p\xe1gina web seg\xfan el tipo de navegador de los visitantes y/u otra informaci\xf3n.
  
  `,
    third_parties_title: "Pol\xedticas de Privacidad de terceros",
    third_parties: `La Pol\xedtica de privacidad de Piper no se aplica a otros anunciantes o sitios web. Por lo tanto, te recomendamos que consultes las Pol\xedticas de Privacidad respectivas de estos servidores de anuncios de terceros para obtener informaci\xf3n m\xe1s detallada. Puede incluir sus pr\xe1cticas e instrucciones sobre c\xf3mo excluir ciertas opciones.

  Pod\xe9s optar por deshabilitar las cookies a trav\xe9s de las opciones de tu navegador. Para conocer informaci\xf3n m\xe1s detallada sobre la gesti\xf3n de cookies con navegadores web espec\xedficos, pod\xe9s consultar los sitios web respectivos de esos navegadores.
  
  `,
    ai_info_title: "Uso de funciones impulsadas por IA",
    ai_info: `Piper incluye una funci\xf3n (Informaci\xf3n del \xe1lbum) que utiliza servicios de inteligencia artificial (IA) proporcionados por OpenAI, un proveedor externo. Al usar esta funci\xf3n, la aplicaci\xf3n env\xeda la siguiente informaci\xf3n del \xe1lbum: nombre, artista, sello, n\xfamero de cat\xe1logo, graduaciones, origen, formato, a\xf1o de edici\xf3n, etiquetas, y ID de Discogs. Estos datos se transmiten a la API de OpenAI con el \xfanico fin de generar el resultado solicitado. Te recomendamos encarecidamente que no incluyas informaci\xf3n personal en ninguno de estos campos.

El servicio de IA se utiliza \xfanicamente para esta funci\xf3n espec\xedfica y no se utiliza en ninguna otra parte de la aplicaci\xf3n. No vendemos datos personales ni permitimos que OpenAI utilice sus datos para ning\xfan otro fin que no sea el de proporcionarnos este servicio.

Los datos procesados a trav\xe9s de la funci\xf3n de IA se gestionan de acuerdo con esta Pol\xedtica de Privacidad y las pr\xe1cticas de protecci\xf3n y seguridad de datos aplicables de OpenAI. Los resultados generados por IA pueden ser inexactos y no deben considerarse asesoramiento profesional ni considerarse veraces.

Al utilizar esta funci\xf3n impulsada por IA, acept\xe1s el procesamiento de tus datos como se describe anteriormente.

  `,
    ccpa_rights_title: "Derechos de privacidad de CCPA (No vender mi informaci\xf3n personal)",
    ccpa_rights: `Seg\xfan la CCPA, entre otros derechos, los consumidores de California tienen derecho a:
  `,
    ccpa_rights_1: "Solicitar que una empresa que recopila datos personales de un consumidor divulgue las categor\xedas y piezas espec\xedficas de datos personales que una empresa ha recopilado sobre los consumidores.",
    ccpa_rights_2: "Solicitar que una empresa elimine cualquier dato personal sobre el consumidor que haya recopilado una empresa.",
    ccpa_rights_3: "Solicitar que una empresa que vende los datos personales de un consumidor, no venda los datos personales del consumidor.",
    ccpa_rights_end: `
  Si realiz\xe1s una solicitud, tenemos un mes para responderte. Si dese\xe1s ejercer alguno de estos derechos, ponete en contacto con nosotros.

  `,
    gdpr_rights_title: "Derechos de protecci\xf3n de datos RGPD",
    gdpr_rights: `Nos gustar\xeda asegurarnos de que conoc\xe9s todos tus derechos de protecci\xf3n de datos. Todo usuario tiene derecho a lo siguiente:
  `,
    gdpr_rights_1: "El derecho de acceso: ten\xe9s derecho a solicitar copias de tus datos personales. Es posible que te cobremos una tarifa por este servicio.",
    gdpr_rights_2: "El derecho a la rectificaci\xf3n: ten\xe9s derecho a solicitar que corrijamos cualquier informaci\xf3n que creas que es inexacta. Tambi\xe9n ten\xe9s derecho a solicitar que completemos la informaci\xf3n que creas que est\xe1 incompleta.",
    gdpr_rights_3: "El derecho a borrar: ten\xe9s derecho a solicitar que borremos tus datos personales, bajo ciertas condiciones.",
    gdpr_rights_4: "El derecho a restringir el procesamiento: ten\xe9s derecho a solicitar que restrinjamos el procesamiento de tus datos personales, bajo ciertas condiciones.",
    gdpr_rights_5: "El derecho a oponerse al procesamiento: ten\xe9s derecho a oponerte a que procesemos tus datos personales, bajo ciertas condiciones.",
    gdpr_rights_6: "El derecho a la portabilidad de datos: ten\xe9s derecho a solicitar que transfiramos los datos que hayamos recopilado a otra organizaci\xf3n, o directamente a vos, bajo ciertas condiciones.",
    gdpr_rights_end: `
  Si realiz\xe1s una solicitud, tenemos un mes para responderte. Si dese\xe1s ejercer alguno de estos derechos, ponete en contacto con nosotros.
  
  `,
    children_title: "Informaci\xf3n de los ni\xf1os",
    children: `Otra de nuestras prioridades es agregar protecci\xf3n para los ni\xf1os mientras usan Internet. Alentamos a los padres y tutores a observar, participar y/o monitorear y guiar su actividad en l\xednea.
  
  Piper no recopila a sabiendas ninguna Informaci\xf3n de identificaci\xf3n personal de ni\xf1os menores de 13 a\xf1os. Si cre\xe9s que tu hijo proporcion\xf3 este tipo de informaci\xf3n en nuestro sitio web, te recomendamos encarecidamente que te comuniques con nosotros de inmediato y haremos todo lo posible para eliminar dicha informaci\xf3n de nuestros registros.
  
  `,
    changes_title: "Cambios en esta Pol\xedtica de Privacidad",
    changes: `Es posible que actualicemos nuestra Pol\xedtica de privacidad de vez en cuando. Por lo tanto, te recomendamos que revises esta p\xe1gina peri\xf3dicamente por cualquier cambio. Te notificaremos cualquier cambio publicando la nueva Pol\xedtica de Privacidad en esta p\xe1gina. Estos cambios entran en vigencia inmediatamente despu\xe9s de que se publiquen en esta p\xe1gina.
  
  `,
    contact_title: "Contactanos",
    contact: `Si ten\xe9s alguna pregunta o sugerencia sobre nuestra Pol\xedtica de Privacidad, no dudes en ponerte en contacto con nosotros.
  
  
  `,
    last_update: "\xdaltima actualizaci\xf3n: 12 de enero, 2026"
};



const $c45459b96187f140$var$barImage = new URL($254be896c9064069$exports).href;
var $323294de8cdb5311$exports = {};
$323294de8cdb5311$exports = $parcel$resolve("8bFtC");


const $c45459b96187f140$var$orderImage = new URL($323294de8cdb5311$exports).href;
var $25a52c34601d8976$exports = {};
$25a52c34601d8976$exports = $parcel$resolve("c5dbU");


const $c45459b96187f140$var$elementsImage = new URL($25a52c34601d8976$exports).href;
const $c45459b96187f140$export$af9591c244d34ec9 = {
    title: "Filtro de \xe1lbumes",
    home_title: "Filtrar tus \xe1lbumes",
    bar_image: $c45459b96187f140$var$barImage,
    order_image: $c45459b96187f140$var$orderImage,
    elements_image: $c45459b96187f140$var$elementsImage,
    description: `Piper ofrece un poderoso filtro para revisar y organizar tu colecci\xf3n usando distintas perspectivas, as\xed pod\xe9s analizar los datos desde distintos \xe1ngulos. Para abrir la ventana del filtro basta con hacer click en el bot\xf3n de la barra de herramientas.
  
`,
    order_description: `El primer campo te permite elegir el \xf3rden de agrupamiento en el cual va a mostrarse la lista de \xe1lbumes. La opci\xf3n por defecto es la de por artista, y los \xe1lbumes dentro de cada artista van a mostrarse ordenados por tu propio \xf3rden definido previamente (Ver la documentaci\xf3n de 'Ordenar tus \xe1lbumes'). Las dem\xe1s opciones incluyen por sello, precio de compra, ganancia, duraci\xf3n, etc. En esos casos, los \xe1lbumes van a ser agrupados por la opci\xf3n seleccionada y van a estar ordenados por a\xf1o y nombre dentro de cada secci\xf3n.
  
  El segundo campo va a permitirte decidir si la opci\xf3n seleccionada va a ser aplicada en order ascendente o descendente.
  
`,
    elements_description: `La siguiente secci\xf3n cuenta con dos tablas. La tabla de la izquierda muestra todos las opciones de filtro que pueden ser aplicadas. \xc9stas te permiten seleccionar un sello en espec\xedfico, a\xf1o, precio de venta, que quer\xe9s restringir en tu lista de \xe1lbumes. Para hacer efectiva la selecci\xf3n, hac\xe9 click en el checkbox de todos los elementos que quieras aplicar y hac\xe9 click en la flecha que apunta a la derecha. De la misma forma, seleccion\xe1 los elementos que quieras remover del filtro de la tabla de la derecha y hac\xe9 click en la flecha que apunta a la izquierda. Tambi\xe9n pod\xe9s ingresar el valor deseado en cualquier elemento de la tabla de la izquierda y va a ser aplicado autom\xe1ticamente en la derecha.
  
  Cada elemento del filtro va a ser requerido en el criterio de b\xfasqueda as\xed que, por ejemplo, si seleccionaste el artista 'A' y el sello 'B' los \xe1lbumes mostrados van a ser los que pertenezcan al artista 'A' Y los que pertenezcan al sello 'B'.
  
  Esto no es cierto en el caso que selecciones m\xfaltiples elementos del mismo tipo, en ese caso el criterio de b\xfasqueda va a incluir a todos los \xe1lbumes que cumplan con cualquiera de esos elementos. As\xed, por ejemplo, si seleccionaste el artista 'A' y el artista 'B' los \xe1lbumes mostrados van a ser los que pertenezcan al artista 'A' O los que pertenezcan al artista 'B'.
  
`
};


var $92fd53e0bddfd841$exports = {};
$92fd53e0bddfd841$exports = $parcel$resolve("eRJHG");


const $b956a4500e8ce022$var$prefsImage = new URL($92fd53e0bddfd841$exports).href;
var $fc987a383c2c4679$exports = {};
$fc987a383c2c4679$exports = $parcel$resolve("4lJ6x");


const $b956a4500e8ce022$var$albumImage = new URL($fc987a383c2c4679$exports).href;
const $b956a4500e8ce022$export$eb28e192c07f3632 = {
    title: "Ordenando \xe1lbumes",
    home_title: "Ordenar tus \xe1lbumes",
    prefs_image: $b956a4500e8ce022$var$prefsImage,
    album_image: $b956a4500e8ce022$var$albumImage,
    description: `Una vez que cre\xe1s un nuevo \xe1lbum, la lista de \xe1lbumes se actualiza mostrando el \xe1lbum nuevo al final de la secci\xf3n del artista. Este comportamiento puede cambiarse en tu perfil de usuario con la opci\xf3n 'Ordenar autom\xe1ticamente \xe1lbumes nuevos'. Si la cambi\xe1s a 'NO' entonces cuando agregues un nuevo \xe1lbum va a mostrarse al inicio de la secci\xf3n del artista con una advertencia. Esto significa que es \xe1lbum todav\xeda no est\xe1 ordenado, ya que por detr\xe1s le fue asignado un \xf3rden igual a -1. Esto es \xfatil especialmente si te preocupa tener tus \xe1lbumes ordenados por tu criterio favorito, ya que esta advertencia s\xf3lo va a desaparecer cuando ordenes manualmente el \xe1lbum.
  
`,
    drag_description: `Para odenar manualmente tus \xe1lbumes, simplemente arrastralos en la lista de \xe1lbumes. Esta operaci\xf3n s\xf3lo puede ser ejecutada cuando no haya ning\xfan filtro aplicado, o cuando los \xfanicos elementos de filtro sean de artistas.
  
`
};


const $240a7a9c42bccc59$export$13b2a7302de30c2 = {
    title: "Documentaci\xf3n de Piper",
    description: `\xa1Gracias por usar Piper! Ac\xe1 vas a poder encontrar varios documentos explicando las distintas cosas que pod\xe9s hacer con esta aplicaci\xf3n. Pod\xe9s navegar por las distintas p\xe1ginas usando el \xedndice abajo.
    
`
};


const $cf1de416c50c095e$export$98cf6ad246dd9743 = {
    title: "Suscripciones",
    home_title: "C\xf3mo funcionan las suscripciones",
    description: `Para mantener Piper actualizado y libre de publicidad dependemos de nuestros sistemas de compras y suscripciones. Todos los usuarios pueden usar Piper de forma gratuita con ciertas limitaciones y pueden optar por uno de nuestros planes disponibles para apoyar a la aplicaci\xf3n y acceder a nuevas funcionalidades.
  
  Pod\xe9s elegir entre estos 3 planes que tenemos disponibles:
  
  `,
    free_plan: "Plan gratuito: ",
    free_plan_description: `El plan gratuito te permite seguir usando Piper con normalidad, pero no vas a tener acceso a las funcionalidades adicionales de otros planes de suscripci\xf3n.
  
  `,
    collector_plan: "Plan Coleccionista: ",
    collector_plan_description: `No incluye funcionalidades adicionales. Con la suscripci\xf3n de 'Coleccionista' vas a estar ayudando a que Piper crezca y siga siendo libre de publicidad. Esta suscripci\xf3n no cuenta con los beneficios de la suscripci\xf3n 'Premium'.
  
Pag\xe1 una vez por mes. Cancel\xe1 cuando quieras.
  
  `,
    premium_plan: "Plan Premium: ",
    premium_plan_description: `La suscripci\xf3n 'Premium' cuenta con las siguientes funcionalidades:
  
  `,
    premium_plan_body_1: "Cargar im\xe1genes adicionales para tus \xe1lbumes usando la galer\xeda de im\xe1genes.",
    premium_plan_body_2: `Usar im\xe1genes de Discogs al importar \xe1lbumes.
  
  `,
    premium_plan_end: "Pag\xe1 una vez por mes. Cancel\xe1 cuando quieras.",
    access: `
  
Para acceder al estado de tu suscripci\xf3n actual o comprar otra suscripci\xf3n, pod\xe9s ir a tu perfil de usuario.
  
`
};


const $7bc39b19ecaa4764$export$da647baf202096e0 = {
    title: "Suscribirse usando Mercado Pago",
    description: `Piper est\xe1 integrado con Mercado Pago para que puedas pagar tu suscripci\xf3n usando la plataforma. Este tipo de pago est\xe1 disponible solamente en algunos pa\xedses de Sudam\xe9rica.

  Si ya ten\xe9s una cuenta de Mercado Pago vas a poder elegir pagar con tu cuenta existente y vas a tener disponibles todas tus tarjetas, as\xed como tambi\xe9n los fondos en tu cuenta. Es importante que una vez que se realiz\xf3 el pago uses el bot\xf3n que se muestra para volver al sitio para que podamos registrar la suscripci\xf3n en nuestra base de datos. Si no hac\xe9s este paso no vas a ver la suscripci\xf3n en Piper, pero no te preocupes, en ese caso contactanos y vamos a solucionar el inconveniente lo antes posible.  
  
  La suscripci\xf3n se puede administrar en su totalidad en la plataforma de Mercado Pago. Pod\xe9s revisar tus pagos, cu\xe1ndo va a ser el pr\xf3ximo cobro, cancelar la suscripci\xf3n y m\xe1s.

  Las suscripciones son cobradas el primer d\xeda de cada mes. Cuando hac\xe9s el primer pago, el monto va a ser proporcional a la cantidad de d\xedas que restan al primer d\xeda del pr\xf3ximo mes.  

  Si cancel\xe1s tu suscripci\xf3n en cualquier momento vas a poder seguir disfrutando de tus privilegios hasta el primer d\xeda del mes siguiente.  
  
`
};


var $d41ee4acfce2fd6c$exports = {};
$d41ee4acfce2fd6c$exports = $parcel$resolve("aYKZN");


const $7b7caaeb7367b9d5$var$albumListImage = new URL($d41ee4acfce2fd6c$exports).href;
var $bde8753dd76a23b8$exports = {};
$bde8753dd76a23b8$exports = $parcel$resolve("7Osfj");


const $7b7caaeb7367b9d5$var$appStoreButton = new URL($bde8753dd76a23b8$exports).href;
const $7b7caaeb7367b9d5$export$91de5eab64071bb0 = {
    title: "\xbfQu\xe9 es Piper?",
    block1: `\xa1Gracias por usar Piper! Ac\xe1 vas  apoder encontrar un resumen de todo lo que pod\xe9s hacer con esta aplicaci\xf3n, c\xf3mo pod\xe9s administrar tu colecci\xf3n de m\xfasica, hacerla personal, e incluso compartirla con el resto del mundo. Record\xe1 que siempre pod\xe9s ingresar como un invitado y ver c\xf3mo luce una colecci\xf3n completa en Piper.
  
  `,
    album_list_image: $7b7caaeb7367b9d5$var$albumListImage,
    block2: `Con Piper vas a poder agregar uno a uno todos los \xe1lbumes pertenecientes a tu colecci\xf3n. O si ya ten\xe9s tu colecci\xf3n cargada en Discogs vas a poder importarla directamente en pocos pasos.
  
  Por cada \xe1lbum vas a poder dar seguimiento de su artista, sello discogr\xe1fico, lista de canciones, notas y m\xe1s.
  
  Us\xe1 la poderosa herramienta del Mobiliario para cargar muebles, en los cuales vas a poder ubicar tus \xe1lbumes tal cual los ten\xe9s organizados en tu habitaci\xf3n. Pod\xe9s definir a tu gusto la cantidad de estantes y segmentos de cada uno de tus muebles, para que sean una r\xe9plica exacta de tu mueble real.
  
  Si tu moneda es distinta a USD vas a poder cargar precios de compra y venta en tu moneda local y luego el sistema va a recalcular toda la informaci\xf3n ajustada por inflaci\xf3n usando cambios de moneda. Piper te permite definir escalas de precios de venta para que puedas categorizar tus \xe1lbumes y as\xed ajustar el precio en un s\xf3lo lugar, y definido en d\xf3lares, as\xed que se va a ajustar autom\xe1ticamente al \xfaltimo cambio de moneda.
  
  Us\xe1 el poderoso filtro de Piper para buscar entre tus \xe1lbumes combinando atributos, e incluso cambiando el criterio de agrupaci\xf3n y el orden. Vas a poder ordenar toda tu colecci\xf3n por a\xf1o, precio de compra, artista, duraci\xf3n, \xa1y m\xe1s!
  
  Organiz\xe1 tus \xe1lbumes en distintas colecciones, y definilas entre privadas o p\xfablicas para que los dem\xe1s usuarios puedan ver una parte de tu colecci\xf3n.
  
  En la secci\xf3n de estad\xedsticas vas a poder conocer mejor a tu colecci\xf3n, teniendo la posibilidad de revisar totales, promedios y gr\xe1ficos completos.
  
  Escane\xe1 el c\xf3digo de barras de un \xe1lbum para agregarlo a Piper autom\xe1ticamente. Tambi\xe9n pod\xe9s hacer b\xfasquedas por texto directamente en la base de datos de Discogs y agregar \xe1lbumes de esa manera.
  
  Gener\xe1 c\xf3digos QR (y links) privados o p\xfablicos para acceder r\xe1pidamente a un \xe1lbum o colecci\xf3n.
  
  Reproduc\xed directamente desde Piper cualquiera de tus \xe1lbumes usando YouTube.
  
  Explor\xe1 \xe1lbumes y colecciones de otros usuarios desde la secci\xf3n de exhibici\xf3n.
  
  
  Y no termina ah\xed. Explor\xe1 el resto de la documentaci\xf3n (todav\xeda en progreso) para saber todo lo que pod\xe9s hacer o, mejor a\xfan, empez\xe1 a usar Piper para descubrir todo lo que tiene para ofrecer.
  
  `,
    mobile_title: "\xa1Us\xe1 Piper desde tu tel\xe9fono!",
    mobile_description: `Piper tambi\xe9n funciona en tu dispositivo m\xf3vil. A continuaci\xf3n te explicamos c\xf3mo pod\xe9s acceder dependiendo de la plataforma que elijas: 
  
  `,
    android_title: "Android",
    android_description_1: `Para usar Piper en Android abr\xed tu navegador web y naveg\xe1 a `,
    android_description_2: `
  Una vez que carg\xf3 la p\xe1gina busc\xe1 en las opciones del navegador por la opci\xf3n para guardar el \xedcono de aplicaci\xf3n en tu escritorio.
  
  Cerr\xe1 el navegador y abr\xed Piper desde el nuevo \xedcono.
  
  `,
    ios_title: "iOS",
    ios_description: `\xa1Piper est\xe1 disponible en App Store!
  
  Escane\xe1 el c\xf3digo y descarg\xe1 la aplicaci\xf3n o us\xe1 el bot\xf3n:
`,
    app_store_button: $7b7caaeb7367b9d5$var$appStoreButton
};


var $05d71c7e62fbbb8d$exports = {};
$05d71c7e62fbbb8d$exports = $parcel$resolve("dyKZb");


const $f56327b2ce3647c8$var$signUpThirdPartyImage = new URL($05d71c7e62fbbb8d$exports).href;
var $3d1bca5d25dfe60e$exports = {};
$3d1bca5d25dfe60e$exports = $parcel$resolve("jyahE");


const $f56327b2ce3647c8$var$newUserImage = new URL($3d1bca5d25dfe60e$exports).href;
const $f56327b2ce3647c8$export$581328f093eda6a9 = {
    title: "Crear un nuevo usuario",
    title_users: "Cuenta de usuario",
    home_title: "Registrarse",
    description: `Para usar Piper primero necesit\xe1s un usuario. Para esto ten\xe9s tres opciones:
`,
    description_1: "Crear un usuario con Piper.",
    description_2: "Ingresar con Google.",
    description_3: "Ingresar con Apple.",
    sign_up_third_party_title: "Ingresar con Google/Apple",
    sign_up_third_party_image: $f56327b2ce3647c8$var$signUpThirdPartyImage,
    sign_up_third_party_description: `La forma m\xe1s sencilla para registrarse es usar uno de los botones para ingresar con Google o Apple. Simplemente vas a tener que usar tus credenciales existentes para alguno de esos servicios y autom\xe1ticamente vas a estar registrado en Piper. \xa1Es as\xed de f\xe1cil!

  El usuario creado va a tener tu correo electr\xf3nico como nombre de usuario pero vas a poder cambiarlo a trav\xe9s de tu perfil de usuario. Cuando tengas que volver a ingresar pod\xe9s usar nuevamente el mismo bot\xf3n que antes, o pod\xe9s crear una contrase\xf1a e ingresar us\xe1ndola tambi\xe9n, todos los m\xe9todos de autenticaci\xf3n son intercambiables.  
  
`,
    sign_up_piper_title: "Crear un usuario con Piper",
    sign_up_piper_image: $f56327b2ce3647c8$var$newUserImage,
    sign_up_piper_description: `Para registrarse en Piper seleccion\xe1 el bot\xf3n de "crear un nuevo usuario", o seleccion\xe1 esa opci\xf3n desde el men\xfa desplegable.

  Una ventana va a aparecer donde vas a tener que ingresar una direcci\xf3n de correo electr\xf3nico y una contrase\xf1a. Una vez que ingreses esos campos y aceptes los t\xe9rminos de servicio, se va a enviar un c\xf3digo de verificaci\xf3n a tu correo electr\xf3nico.

  Cuando intentes ingresar por primera vez, el sistema te va a pedir que ingreses el c\xf3digo de verificaci\xf3n. \xa1Una vez que lo ingreses vas a estar listo para empezar!
  
  Si no recibiste el c\xf3digo o lo perdiste pod\xe9s pedir que se env\xede uno nuevo usando el bot\xf3n de reenviar.  
  
`
};


var $d28d428c03fa2bb4$exports = {};
$d28d428c03fa2bb4$exports = $parcel$resolve("a0kao");


const $58d94f35e9b68ab3$var$optionsImage = new URL($d28d428c03fa2bb4$exports).href;
var $af822c920c76a63b$exports = {};
$af822c920c76a63b$exports = $parcel$resolve("gQGMc");


const $58d94f35e9b68ab3$var$drawerImage = new URL($af822c920c76a63b$exports).href;
const $58d94f35e9b68ab3$export$80be07eabf9d7c7e = {
    title: "Ingresar como invitado",
    options_image: $58d94f35e9b68ab3$var$optionsImage,
    drawer_image: $58d94f35e9b68ab3$var$drawerImage,
    description: `Pod\xe9s ingresar a Piper como invitado usando la opci\xf3n dentro del men\xfa desplegable. No vas a necesitar ninguna contrase\xf1a, vas a ingresar directamente a una colecci\xf3n pre-creada llena de \xe1lbumes, artistas y m\xe1s.
  
  Mientras seas un invitado no vas a poder hacer modificaciones, pero sentite libre de explorar y revisar todas las cosas que podr\xedas hacer con tu propia colecci\xf3n. La \xfanica secci\xf3n bloqueada va a ser la de Estad\xedsticas.
  
  Cuando quieras ingresar con tu propia cuenta, simplemente cerr\xe1 la sesi\xf3n de invitado y se te va a mostrar la p\xe1gina de ingreso nuevamente.
    
`
};


const $8b51cd73284c72a9$export$89ff519bf1b4dd9d = {
    title: "Recuperar contrase\xf1a",
    description: `Si en alg\xfan momento te olvid\xe1s tu constrase\xf1a pod\xe9s reiniciarla usando el bot\xf3n de "\xbfOlvidaste tu contrase\xf1a?" en la pantalla de inicio, o la opci\xf3n de "Recuperar contrase\xf1a" en el men\xfa desplegable.
  
  Una nueva ventana te va a pedir que ingreses tu direcci\xf3n de correo electr\xf3nico y una contrase\xf1a nueva. Despu\xe9s de confirmar esa informaci\xf3n se va a enviar un c\xf3digo de verificaci\xf3n a tu correo que vas a tener que ingresar en el pr\xf3ximo paso.  

  Una vez que el c\xf3digo fue validado vas a poder ingresar normalmente usando tu nueva contrase\xf1a.  

  Acordate que siempre pod\xe9s optar por ingresar con tu cuenta de Google o Apple sin tener que usar otra contrase\xf1a.  
  
`
};



const $15e2e4f7850fc401$var$mainButtonsToolbarImage = new URL($377b631a94a0445e$exports).href;
const $15e2e4f7850fc401$export$22486095b44254df = {
    title: "Escanear c\xf3digo de barras y buscar",
    home_title: "Agregar \xe1lbumes desde c\xf3digo de barras o b\xfasqueda",
    description: `Piper tiene la opci\xf3n de escanear el c\xf3digo de barras de un \xe1lbum directo de su sobre y buscarlo en Discogs. De la mism forma pod\xe9s buscar en la base de datos de Discogs usando el campo de texto libre especificando parte de un t\xedtulo, nombre de artista, n\xfamero de cat\xe1logo, etc.
  
  Us\xe1 el bot\xf3n de "Agregar desde c\xf3digo de barras o buscar" en el men\xfa desplegable o el bot\xf3n de esc\xe1ner en la barra de herramientas para abrir la ventana de b\xfasqueda.  
  
`,
    main_buttons_toolbar_image: $15e2e4f7850fc401$var$mainButtonsToolbarImage,
    scan_title: "Escanear un c\xf3digo de barras",
    scan_description: `Seleccion\xe1 el bot\xf3n de la c\xe1mara para encenderla o apagarla. Pon\xe9 el c\xf3digo de barras frente a la c\xe1mara hasta que sea reconocido y la ventana empiece a cargar.

  La aplicaci\xf3n va a buscar en Discogs el c\xf3digo de barras y mostrar los resultados.  

  Seleccion\xe1 el \xe1lbum que quieras y va a ser agregado a Piper autom\xe1ticamente.  
  
`,
    search_title: "Buscar un \xe1lbum",
    search_description: `Pod\xe9s especificar cualquier tipo de informaci\xf3n sobre un \xe1lbum en el campo de b\xfasqueda y vamos a intentar encontrar resultados en la base de datos de Discogs.
  
  Una vez que ingreses el texto deseado seleccion\xe1 el bot\xf3n de 'iniciar b\xfasqueda'. Los resultados, si es que hay, van a aparecer en una lista debajo.
  
  Seleccion\xe1 el \xe1lbum que quieras y va a ser agregado a Piper autom\xe1ticamente. 
  
`
};


const $64cb46ca12d83509$export$8a0c644edba3a537 = {
    title: "Galer\xeda de im\xe1genes",
    description: `Si ten\xe9s una cuenta 'Premium' pod\xe9s usar la galer\xeda de im\xe1genes para personalizar aun m\xe1s tus \xe1lbumes. Vas a poder agregar im\xe1genes de contratapa y lomo y hasta 50 im\xe1genes adicionales para cada uno de tus \xe1lbumes.
  
  Las im\xe1genes van a estar disponibles tambi\xe9n en la exhibici\xf3n para cada \xe1lbum que est\xe9 asociado a una colecci\xf3n p\xfablica.
  
  Para editar una imagen simplemente seleccionala, o hac\xe9 click derecho (manten\xe9 presionado en el tel\xe9fono) y eleg\xed la opci\xf3n de editar. Tambi\xe9n pod\xe9s arrastrar la imagen nueva sobre la vieja para actualizarla.
  
  Usando el men\xfa contextual del click derecho tambi\xe9n pod\xe9s reordenar las im\xe1genes, ver su detalle, o cambiar el nombre.
  
  `
};


const $4b3016ae7c9d97e4$export$ea0c4b45a6294ec7 = {
    title: "Perfil de usuario",
    home_title: "Perfil de usuario",
    description: `Pod\xe9s personalizar tu perfil de usuario seleccionando la tarjeta de perfil en la esquina superior derecha de la pantalla, o seleccionando la opci\xf3n desde el men\xfa desplegable.
  
`,
    notifications_title: "Notificaciones",
    notifications_description: `Dentro de la p\xe1gina de perfil de usuario vas a encontrar el bot\xf3n de notificaciones. Ah\xed vas a encontrar todas las notificaciones oficiales que recibiste, acerca de informaci\xf3n en general, cambios de precios, o noticias de \xfaltima hora.
  
`,
    update_avatar_title: "Actualizar tu avatar",
    update_avatar_description: `Para actualizar tu avatar simplemente seleccionalo. El sistema te va a pedir una nueva imagen. El tama\xf1o de la imagen no debe superar los 10MiB.
  
`,
    username_title: "Actualizar tu nombre de usuario",
    username_description: `Despu\xe9s de crear tu cuenta se te va a asignar un nombre de usuario aleatorio por defecto. Pod\xe9s cambiarlo dentro de la p\xe1gina de perfil de usuario. El nuevo nombre de usuario tiene que tener entre 8 y 20 caracteres, tiene que empezar con una letra y no puede tener caracteres especiales excepto guiones bajos.
  
`,
    email_title: "Actualizar tu correo electr\xf3nico",
    email_description: `Pod\xe9s cambiar tu correo electr\xf3nico actual dentro de la p\xe1gina de perfil de usuario. Ingres\xe1 la nueva direcci\xf3n de correo electr\xf3nico en el \xfaltimo campo y luego seleccion\xe1 el bot\xf3n de guardar. En ese momento el nuevo correo queda pendiente de confirmaci\xf3n. Si pas\xf3 un tiempo desde tu \xfaltimo ingreso a la aplicaci\xf3n, el sistema puede requerir que ingreses tus credenciales otra vez.

  En esta etapa, tu correo electr\xf3nico todav\xeda no cambi\xf3, para terminar el proceso ten\xe9s que seleccionar el bot\xf3n de verificar e ingresar el c\xf3digo que enviamos a tu nueva direcci\xf3n de correo electr\xf3nico. Una vez que el c\xf3digo est\xe1 verificado, el nuevo correo va a reemplazar el actual y el proceso quedar\xe1 terminado.
  
`,
    password_title: "Actualizar tu contrase\xf1a",
    password_description: `Seleccion\xe1 el campo de constrase\xf1a dentro de la p\xe1gina de perfil de usuario para cambiarla por una nueva. Un nuevo di\xe1logo va a pedirte ingresar la contrase\xf1a actual y la nueva que vas a tener que repetir para evitar errores de tipeo. Si pas\xf3 un tiempo desde tu \xfaltimo ingreso a la aplicaci\xf3n, el sistema puede requerir que ingreses tus credenciales otra vez.
  
`,
    bio_title: "Biograf\xeda",
    bio_description: `Pod\xe9s ingresar cualquier informaci\xf3n sobre vos o tu colecci\xf3n en tu biograf\xeda. \xc9sta va a estar disponible para todos los usuarios en la Exhibici\xf3n. Si busc\xe1s tu nombre de usuario en la Exhibici\xf3n y seleccion\xe1s tu perfil vas a poder ver tu perfil p\xfablico y qu\xe9 es lo que todo el mundo puede ver sobre vos.
  
`,
    currency_title: "Moneda",
    currency_description: `Dentro de tu perfil de usuario vas a poder cambiar tu moneda. Esto va a afectar a toda tu colecci\xf3n y todas tus colecciones p\xfablicas pasar\xe1n a usar la nueva moneda para mostrar cualquier monto que hayas decidido exponer. Ten\xe9 en cuenta que cambiar la moneda no va a actualizar los montos de ninguna forma, solamente el s\xedmbolo y c\xf3digo de moneda mostrado. Los valores van a seguir siendo calculados seg\xfan tus cambios de moneda.
  
  Esta moneda va a ser tambi\xe9n la especificada en todos tus cambios de moneda, pero ten\xe9 en cuenta que cambiar la moneda no va a actualizar los montos de los cambios de moneda de ninguna forma, solamente el s\xedmbolo y c\xf3digo de moneda.
  
`,
    decimals_title: "Decimales en importes financieros",
    decimals_description: `Con esta opci\xf3n pod\xe9s decidir si quer\xe9s que se muestren decimales en los montos mostrados con tu moneda.
  
`,
    impacts_description_title: "Mostrar descripci\xf3n de calificaciones",
    impacts_description_description: `Con esta opci\xf3n pod\xe9s decidir si quer\xe9s que se muestren las calificaciones con sus descripciones adem\xe1s de las estrellas, o solo las estrellas.
  
`,
    album_id_title: "Mostrar ID del \xe1lbum",
    album_id_description: `Si activ\xe1s esta opci\xf3n se va a mostrar el identificador interno de cada \xe1lbum al fondo de su detalle. Pod\xe9s usar esto como referencia personal o para referirte a un \xe1lbum en espec\xedfico cuando contactes a soporte.
  
`,
    colors_title: "Colores de discos sin color",
    colors_description: `Ingres\xe1 ac\xe1 todos los colores que no quieras que cuenten como '\xc1lbumes de color' en tus estad\xedsticas. Ingres\xe1 individualmente cada color exactamente como los ingresaste en los \xe1lbumes.
    
`
};


const $71b1ee7ee982d577$export$24eac8f96dd07037 = {
    title: "Importar \xe1lbumes desde una planilla de c\xe1lculo",
    description_1: `Pod\xe9s importar tus \xe1lbumes a Piper desde una planilla de c\xe1lculo. Seleccion\xe1 esta opci\xf3n desde el men\xfa desplehable y va a aparecer una nueva ventana.

  Dentro de la ventana de importaci\xf3n, seleccion\xe1 un archivo con la extensi\xf3n 'xlsx'. La mayor\xeda de los programas pueden importar planillas de c\xe1lculo en este formato.

  El archivo tiene que tener un \xe1lbum por fila, y sus atributos tienen que estar posicionados en cada columna en un \xf3rden espec\xedfico. Cada columna puede ser mandatoria (esta columna tiene que estar completa para cada fila), u opcional (esta columna puede estar vac\xeda para alguna o todas las filas, pero tiene que estar presente, as\xed que dej\xe1 una columna en blanco si no us\xe1s ese atributo para tus \xe1lbumes).

  IMPORTANTE: La primera fila del archivo es ignorada por el proceso, as\xed que usala como encabezado para ponerle t\xedtulos a las columnas. Ubic\xe1 todos los \xe1lbumes en una tabla \xfanica. Evit\xe1 tener filas en blanco al final de la tabla.  

  Todos los atributos que apliquen van a ser comparados por nombre con los que ya tengas en Piper. Si alguno ya existe, \xe9se va a ser usado. De otro modo, se va a crear uno nuevo.  

  Pod\xe9s usar la siguiente plantilla para llenarla con tus \xe1lbumes:
`,
    description_2: `Las columnas dentro del archivo se explican abajo. Solamente las dos primeras son mandatorias.
  `,
    column_1: `Nombre del \xe1lbum (Mandatoria)
El nombre del \xe1lbum. No puede estar vac\xedo.
  `,
    column_2: `Nombre del artista (Mandatoria)
El nombre del artista del \xe1lbum. No puede estar vac\xedo.
  `,
    column_3: `Nombre del sello (Opcional)
El nombre del sello discogr\xe1fico del \xe1lbum.
  `,
    column_4: `N\xfamero de cat\xe1logo (Opcional)
El n\xfamero de cat\xe1logo del \xe1lbum.
  `,
    column_5: `A\xf1o original (Opcional)
El a\xf1o de la primera edici\xf3n del \xe1lbum.
  `,
    column_6: `A\xf1o de edici\xf3n (Opcional)
El a\xf1o espec\xedfico de la edici\xf3n del \xe1lbum.
  `,
    column_7: `Origen (Opcional)
El origen del \xe1lbum.
  `,
    column_8: `Condici\xf3n del sobre (Opcional)
La condici\xf3n del sobre del \xe1lbum en puntos num\xe9ricos. La nota se basa en el est\xe1ndar de graduaci\xf3n Goldmine y sigue el siguiente criterio, ingres\xe1 alguno de los siguientes n\xfameros o dej\xe1 el campo vac\xedo:
    
    (1) = P-
    (2) = P
    (3) = G-
    (4) = G
    (5) = G+
    (6) = VG
    (7) = VG+
    (8) = VG++
    (9) = NM-
    (10) = NM
    (11) = M
  `,
    column_9: `Condici\xf3n del disco (Opcional)
La condici\xf3n del disco(s) del \xe1lbum en puntos num\xe9ricos. La nota se basa en el est\xe1ndar de graduaci\xf3n Goldmine y sigue el siguiente criterio, ingres\xe1 alguno de los siguientes n\xfameros o dej\xe1 el campo vac\xedo:
    
    (1) = P-
    (2) = P
    (3) = G-
    (4) = G
    (5) = G+
    (6) = VG
    (7) = VG+
    (8) = VG++
    (9) = NM-
    (10) = NM
    (11) = M
  `,
    column_10: `Escuchado (Opcional)
Indica si el \xe1lbum fue escuchado o no. Llen\xe1 el campo con cualquier contenido para S\xcd, o dejalo vac\xedo para NO.
  `,
    column_11: `Insert (Opcional)
Indica si el \xe1lbum tiene insert o no. Llen\xe1 el campo con cualquier contenido para S\xcd, o dejalo vac\xedo para NO.
  `,
    column_12: `Letras (Opcional)
Indica si el \xe1lbum tiene letras de las canciones o no. Llen\xe1 el campo con cualquier contenido para S\xcd, o dejalo vac\xedo para NO.
  `,
    column_13: `Gatefold (Opcional)
Indica si el \xe1lbum es gatefold o no. Llen\xe1 el campo con cualquier contenido para S\xcd, o dejalo vac\xedo para NO.
  `,
    column_14: `Precio de compra (Opcional)
El precio de compra del \xe1lbum al momento de la compra. Ingres\xe1 el n\xfamero en tu moneda local sin el s\xedmbolo de la moneda.
  `,
    column_15: `Precio de venta (Opcional)
El nombre del grupo del precio de venta del \xe1lbum.
  `,
    column_16: `Fecha de compra (Opcional)
La fecha de compra del \xe1lbum. Asegurate que la celda tenga el formato de fecha.
  `,
    column_17: `Tienda (Opcional)
La tienda donde se compr\xf3 el \xe1lbum.
  `,
    column_18: `N\xfamero de discos (Opcional)
El n\xfamero de discos que tiene el \xe1lbum.
  `,
    column_19: `Color del disco (Opcional)
El color del disco del \xe1lbum.
  `,
    column_20: `Formato (Opcional)
El nombre completo del formato del \xe1lbum. Por ejemplo: 'Long Play'.
  `,
    column_21: `Tipo de \xe1lbum (Opcional)
El nombre del tipo de \xe1lbum. Por ejemplo: 'Demo'.
  `,
    column_22: `N\xfamero de pistas (Opcional)
El n\xfamero de pistas en el \xe1lbum.
  `,
    column_23: `Duraci\xf3n (Opcional)
La duraci\xf3n del \xe1lbum en segundos.
  `,
    column_24: `Calificaci\xf3n (Opcional)
La calificaci\xf3n para el \xe1lbum. Ingres\xe1 el n\xfamero de estrellas como se ve abajo:

    (1) = \u{2606}\u{2606}\u{2606}\u{2606}\u{2605}
    (2) = \u{2606}\u{2606}\u{2606}\u{2605}\u{2605}
    (3) = \u{2606}\u{2606}\u{2605}\u{2605}\u{2605}
    (4) = \u{2606}\u{2605}\u{2605}\u{2605}\u{2605}
    (5) = \u{2605}\u{2605}\u{2605}\u{2605}\u{2605}
  `,
    column_25: `Notas (Opcional)
Ingres\xe1 las notas que quieras para el \xe1lbum.
  `
};


var $4370c9f0ff4ff51e$exports = {};
$4370c9f0ff4ff51e$exports = $parcel$resolve("aedb7");


const $6da4a647e299eaec$var$optionImage = new URL($4370c9f0ff4ff51e$exports).href;
const $6da4a647e299eaec$export$33014d40429a6813 = {
    title: "Eliminar varios \xe1lbumes",
    option_image: $6da4a647e299eaec$var$optionImage,
    description: `Si hac\xe9s click derecho sobre el bot\xf3n de 'limpiar filtro' vas a ver la opci\xf3n de eliminar todos los \xe1lbumes filtrados.
  
  Este proceso va a verificar el filtro actualmente aplicado y, despu\xe9s de una confirmaci\xf3n, va a eliminar todos los \xe1lbumes que caen dentro de ese filtro.
  
  Si no hay ning\xfan filtro aplicado, esto va a eliminar TODOS TUS \xc1LBUMES.
  
  Si realizaste este proceso por error, contact\xe1 a soporte. Vamos a revisar tu caso y ver si es posible recuperar parte de los \xe1lbumes eliminados.
  
  `
};


const $24d2bdced51c67ba$export$f19dded810f125bc = {
    title: "Colecciones p\xfablicas",
    description: `Las colecciones p\xfablicas son iguales que las privadas excepto que pueden ser compartidas con otros usuarios usando links y c\xf3digos QR, y adem\xe1s pueden ser encontradas en la Exhibici\xf3n.
  
  Los usuarios pueden dar estrellas a tu colecci\xf3n p\xfablica y cada visita va a incrementar el contador de visitas.
  
  Todos los \xe1lbumes dentro de una colecci\xf3n p\xfablica pueden ser accedidos por cualquier usuario y van a poder ver toda la informaci\xf3n cargada excepto por los campos ocultos que hayas definido para la colecci\xf3n.
  
  Cada d\xeda, tanto la colecci\xf3n p\xfablica como sus \xe1lbumes tienen probabilidad de ser destacadas en la p\xe1gina principal de la Exhibici\xf3n.
  
  `
};


var $7d4dbd6b9c9cb2e3$exports = {};
$7d4dbd6b9c9cb2e3$exports = $parcel$resolve("6JkMp");


const $d5e1fcc9d8f35578$var$deleteImage = new URL($7d4dbd6b9c9cb2e3$exports).href;
var $894b68ae5cfa81eb$exports = {};
$894b68ae5cfa81eb$exports = $parcel$resolve("jDw8t");


const $d5e1fcc9d8f35578$var$image = new URL($894b68ae5cfa81eb$exports).href;
const $d5e1fcc9d8f35578$export$c2ab2927acb653be = {
    title: "Colecciones",
    home_title: "\xbfQu\xe9 son las colecciones?",
    image: $d5e1fcc9d8f35578$var$image,
    description: `Pod\xe9s dividir tu colecci\xf3n princial en diferentes colecciones. Cada colecci\xf3n puede mostrar un aspecto distinto de tus \xe1lbumes, vas a tener estad\xedsticas por separado para cada una y vas a poder filtrarlas individualmente.

  Un \xe1lbum puede ser parte de ninguna, una, o m\xfaltiples colecciones, pero la instancia del \xe1lbum es \xfanica. Esto significa que asignar un \xe1lbum a m\xfaltiples colecciones no duplica el \xe1lbum.

  La colecci\xf3n de 'Todos los \xe1lbumes' siempre va a contener a todos los \xe1lbumes que tengas, as\xed que si elimin\xe1s o cambi\xe1s colecciones nunca vas a perder la referencia a un \xe1lbum.  

  Cre\xe1 colecciones por ubicaci\xf3n f\xedsica, por g\xe9nero, gusto personal, lo que quieras. Pens\xe1 en las colecciones como ventanas a tu colecci\xf3n princial, donde cada ventana muestra una vista distinta.  
  
`,
    create_title: "Agregar una colecci\xf3n",
    create_description: `Para crear una nueva colecci\xf3n seleccion\xe1 el bot\xf3n de colecci\xf3n en la barra de herramientas en la p\xe1gina de 'Mis \xe1lbumes'.

  Se va a abrir una nueva ventana donde vas a poder ver la lista de colecciones que ten\xe9s, y en la barra de herramientas vas a encontrar el bot\xf3n para agregar una nueva.  
  
  Cuando est\xe1s creando una nueva colecci\xf3n pod\xe9s modificar su imagen, nombre y descripci\xf3n.  

  Una vez que confirm\xe1s, un texto rojo va a aparecer debajo de cualquier campo mandatorio que no est\xe9 completo. Una vez que todos los campos mandatorios est\xe9n completos, la colecci\xf3n va a ser agregada.  

  Cuando est\xe1s actualizando una colecci\xf3n existente, van a estar disponibles unos atributos adicionales. Vas a poder establecer a la colecci\xf3n como 'p\xfablica' y as\xed dejarla disponible en la Exhibici\xf3n. Si hac\xe9s eso, asegurate de verificar el atributo de campos ocultos, y seleccion\xe1 todos los atributos que quieras ocultar del resto de los usuarios.  
  
`,
    delete_image: $d5e1fcc9d8f35578$var$deleteImage,
    delete_title: "Eliminar una colecci\xf3n",
    delete_description: `Para eliminar una colecci\xf3n, hacele click derecho desde la lista de colecciones y seleccion\xe1 la opci\xf3n para eliminarla. Va a aparecer un di\xe1logo de confirmaci\xf3n donde pod\xe9s verificar que el nombre corresponda con la colecci\xf3n que quer\xe9s eliminar.

  Este proceso es irreversible, as\xed que asegurate de estar eliminando la colecci\xf3n correcta. Todos los \xe1lbumes asignados a esa colecci\xf3n van a ser desasignados autom\xe1ticamente. Si alguien ten\xeda acceso a un link compartido de la colecci\xf3n eliminada, ya no va a poder acceder.
  
`
};


const $4f6798881ea73695$export$6471ddaa182c0cf2 = {
    title: "Atributos de una colecci\xf3n",
    home_title: "Atributos",
    description: `Abajo vas a encontrar una list de los atributos que pertenecen a una colecci\xf3n y una breve descripci\xf3n de cada uno.
  
  `,
    name_title: "Nombre",
    name_description: `Cada colecci\xf3n necesita un nombre. Us\xe1 un nombre que represente a los \xe1lbumes dentro de ella. Ten\xe9 en cuenta que este nombre va a ser visible por otros usuarios si la colecci\xf3n es p\xfablica.
  
  `,
    image_title: "Imagen",
    image_description: `Hay una imagen por defecto asignada a la colecci\xf3n, pero pod\xe9s cambiarla por una tuya. La imagen de las colecciones es mostrada en un tama\xf1o din\xe1mico dependiendo de la resoluci\xf3n de la pantalla, as\xed que es mejor usar im\xe1genes que no sufran mucho al ser deformadas. La relaci\xf3n de aspecto promedio que va mejor con esta imagen es 5:1.
  
  `,
    visibility_title: "Visibilidad",
    visibility_description: `Este atributo no est\xe1 disponible la primera vez que cre\xe1s una colecci\xf3n, ya que todas las colecciones son privadas en un principio. Vas a poder ver este atributo cuando vayas a editar la colecci\xf3n.

  Hay dos opciones posibles para la visibilidad: privada o p\xfablica.

  Las colecciones privadas son pueden ser accedidas por vos, nadie m\xe1s va a poder ver esta colecci\xf3n.  

  Las colecciones p\xfablicas van a estar p\xfablicamente disponibles a todos los usuarios, ya que van a poder buscarlas en la Exhibici\xf3n, e incluso vas a poder compartir links p\xfablicos y c\xf3digos QR. Para que una colecci\xf3n pueda ser p\xfablica debe tener algunos \xe1lbumes asignados.  
  
  `,
    banned_fields_title: "Campos ocultos",
    banned_fields_description: `Este atributo no est\xe1 disponible la primera vez que cre\xe1s una colecci\xf3n, ya que todas las colecciones son privadas en un principio. Vas a poder ver este atributo cuando vayas a editar la colecci\xf3n.
  
  Ingres\xe1 ac\xe1 todos los atributos del \xe1lbum que quieras ocultar de los dem\xe1s usuarios cuando vean esta colecci\xf3n en la Exhibici\xf3n, o desde links p\xfablicos y c\xf3digos QR.
  
  `,
    discount_title: "Descuento",
    discount_description: `Pod\xe9s asignar un porcentaje de descuento que va a afectar a todos los \xe1lbumes en esta colecci\xf3n.

  Por cada \xe1lbum, el precio de venta va a ser mostrado ajustado por ese porcentaje de descuento.  

  Si eleg\xeds ocultar el precio de venta para una colecci\xf3n p\xfablica, entonces solamente va a ser visible el porcentaje de descuento.  
  
  `,
    description_title: "Descripci\xf3n",
    description_description: `Us\xe1 este campo para describir tu colecci\xf3n, explicar de qu\xe9 se trata, mostrar tus apreciaciones, t\xe9rminos de venta, o cualquier cosa que quieras expresar sobre ella.
  
  `
};


const $5efd0962a8d08b80$export$c00be0528feef104 = {
    title: "Artistas",
    description: `Cada \xe1lbum tiene un artista, es el \xfanico atributo requerido aparte del nombre del \xe1lbum.

  Us\xe1 al artista para representar bandas, solistas, colaboraciones, o cualquier cosa intermedia.  
  
`
};


const $c9143242e05fe1a1$export$c09c6fa0036dcab = {
    title: "Atributos de los \xe1lbumes",
    home_title: "Atributos generales",
    description: `En esta secci\xf3n vas a encontrar todos los atributos que pod\xe9s manejar para cada \xe1lbum, qu\xe9 significan, y c\xf3mo pod\xe9s usarlos.

  Empecemos con los m\xe1s simples debajo y vas a encontrar el resto en una lista en el fondo de la secci\xf3n.
  
`,
    name_title: "Nombre",
    name_description: `El nombre del \xe1lbum. No puede tener m\xe1s de 512 caracteres. Este es el \xfanico campo mandatorio.
  
`,
    image_title: "Imagen",
    image_description: `Pod\xe9s cambiar la imagen de la tapa del \xe1lbum. Si ten\xe9s una suscripci\xf3n premium entonces tambi\xe9n pod\xe9s agregar im\xe1genes de la contratapa, lomo, y hasta 50 im\xe1genes adicionales del \xe1lbum.
  
`,
    country_title: "Origen",
    country_description: `El origen para esta edici\xf3n en espec\xedfico, donde fue distribu\xedda originalmente o donde fue fabricada.
  
`,
    original_year_title: "A\xf1o original",
    original_year_description: `Ingres\xe1 el a\xf1o en el que el \xe1lbum sali\xf3 originalmente.
  
`,
    release_year_title: "A\xf1o de edici\xf3n",
    release_year_description: `Ingres\xe1 el a\xf1o en el que esta edici\xf3n fue lanzada. Probablemente este a\xf1o va a coincidir con el a\xf1o original para primeras ediciones y va a ser diferente para reediciones.
  
`,
    catalogue_number_title: "N\xfamero de cat\xe1logo",
    catalogue_number_description: `El n\xfamero de cat\xe1logo del sello para esta edici\xf3n.
  
`,
    discogs_id_title: "ID de Discogs",
    discogs_id_description: `El Release ID de Discogs para esta edici\xf3n en particular. Pod\xe9s encontrar este n\xfamero en la p\xe1gina de Discogs como 'Release ID' en la esquina superior derecha o dentro de la URL.

  Este ID puede usarse luego para cargar autom\xe1ticamente la lista de canciones del \xe1lbum. Tambi\xe9n habilita un link directo con la p\xe1gina de Discogs.  
  
`,
    purchase_date_title: "Fecha de compra",
    purchase_date_description: `La fecha en la que compraste el \xe1lbum. Esta fecha va a ser usada para calcular autom\xe1ticamente el precio de compra usando el cambio de moneda m\xe1s pr\xf3ximo.
  
`,
    purchase_price_title: "Precio de compra",
    purchase_price_description: `El precio que pagaste cuando compraste el \xe1lbum.

  El monto tiene que estar expresado en tu propia moneda (La que seleccionaste en tu perfil de usuario). Una vez que actualiz\xe1s este valor, el monto se va a convertir usando el \xfaltimo cambio de moneda y el cambio de moneda m\xe1s pr\xf3ximo a la fecha de compra, y va a ser mostrado de esa manera. Tambi\xe9n se va a mostrar en USD.  
  
`,
    track_count_title: "N\xfamero de canciones",
    track_count_description: `El n\xfamero de canciones para este \xe1lbum.
  
`,
    length_title: "Duraci\xf3n",
    length_description: `La duraci\xf3n del \xe1lbum en el siguiente formato: HH:mm:ss.
  
  Por ejemplo, si un \xe1lbum tiene una duraci\xf3n de 33 minutos y 2 segundos ten\xe9s que ingresar: '00:33:02'.
    
`,
    collections_title: "Colecciones",
    collections_description: `Us\xe1 este atributo para asignar un \xe1lbum a una o m\xe1s colecciones. El hecho de asignar un \xe1lbum a una colecci\xf3n no lo duplica. Pod\xe9s asignar o desasignar \xe1lbumes las veces que quieras sin temer a perder informaci\xf3n.

  Referite a la secci\xf3n de colecciones en esta documentaci\xf3n para m\xe1s informaci\xf3n.  
  
`,
    played_title: "Escuchado",
    played_description: `Indica si el \xe1lbum fue escuchado o no. Esto puede ayudarte a dar un seguimiento de los \xe1lbumes que reprodujiste y los que no.
  
`,
    has_insert_title: "Con insert",
    has_insert_description: `Indica si el \xe1lbum incluye el insert/sobre interno original o no.
  
`,
    has_lyrics_title: "Con letras",
    has_lyrics_description: `Indica si el \xe1lbum incluye las letras de las canciones o no. A veces las letras est\xe1n impresas en el insert, en el sobre interno, o en la contratapa.
  
`,
    gatefold_title: "Gatefold",
    gatefold_description: `Indica si el sobre externo es de tipo Gatefold o no. Los sobres de tipo Gatefold se despliegan como un libro o una billetera.
  
`,
    sleeve_grade_title: "Condici\xf3n del sobre",
    sleeve_grade_description: `El estado de preservaci\xf3n del sobre externo del \xe1lbum. Se usa el sistema de graduaci\xf3n Goldmine.
  
`,
    media_grade_title: "Condici\xf3n del disco",
    media_grade_description: `El estado de preservaci\xf3n de el/los discos del \xe1lbum. Se usa el sistema de graduaci\xf3n Goldmine.
  
`,
    impact_title: "Calificaci\xf3n",
    impact_description: `Una calificaci\xf3n personal que pod\xe9s darle al \xe1lbum, de 0 a 5 estrellas.
  
`,
    notes_title: "Notas",
    notes_description: `Un campo de texto libre para que puedas poner lo que quieras sobre el \xe1lbum.
  
`,
    more_attributes: "M\xe1s atributos"
};


var $a684efb00e0c1010$exports = {};
$a684efb00e0c1010$exports = $parcel$resolve("cT718");


const $049adb4a51fd8915$var$image = new URL($a684efb00e0c1010$exports).href;
const $049adb4a51fd8915$export$868a633de15e25dc = {
    title: "Marcando \xe1lbumes",
    image: $049adb4a51fd8915$var$image,
    description: `Pod\xe9s marcar tus \xe1lbumes para indicar de una forma visual su estado en la lista de \xe1lbumes. Cada tipo de marca va a tener un aspecto distinto en la lista as\xed que probalos todos y usalos seg\xfan tu conveniencia.

  Las marcas son especialmente \xfatiles para las colecciones p\xfablicas que uses para vender tus \xe1lbumes, ya que de esta menera pod\xe9s comunicar de una forma sencilla si un \xe1lbum ya est\xe1 reservado, si fue vendido, o si est\xe1 disponible para una pre venta.
  
  `
};



const $aed7cea5f35cca3b$var$views = {
    hours: 'las horas',
    minutes: 'los minutos',
    seconds: 'los segundos',
    meridiem: 'meridiano'
};
const $aed7cea5f35cca3b$var$esESPickers = {
    // Calendar navigation
    previousMonth: "\xdaltimo mes",
    nextMonth: "Pr\xf3ximo mes",
    // View navigation
    openPreviousView: "abrir la \xfaltima vista",
    openNextView: 'abrir la siguiente vista',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? "la vista del a\xf1o est\xe1 abierta, cambie a la vista de calendario" : "la vista de calendario est\xe1 abierta, cambie a la vista del a\xf1o",
    // DateRange placeholders
    start: 'Empezar',
    end: 'Terminar',
    // Action bar
    cancelButtonLabel: 'Cancelar',
    clearButtonLabel: 'Limpiar',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Hoy',
    // Toolbar titles
    datePickerToolbarTitle: 'Seleccionar fecha',
    dateTimePickerToolbarTitle: 'Seleccionar fecha y hora',
    timePickerToolbarTitle: 'Seleccionar hora',
    dateRangePickerToolbarTitle: 'Seleccionar rango de fecha',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Seleccione ${$aed7cea5f35cca3b$var$views[view]}. ${time === null ? 'No hay hora seleccionada' : `La hora seleccionada es ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} horas`,
    minutesClockNumberText: (minutes)=>`${minutes} minutos`,
    secondsClockNumberText: (seconds)=>`${seconds} segundos`,
    // Digital clock labels
    selectViewText: (view)=>`Seleccionar ${$aed7cea5f35cca3b$var$views[view]}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "N\xfamero de semana",
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Semana ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Elige fecha, la fecha elegida es ${utils.format(value, 'fullDate')}` : 'Elige fecha',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Elige hora, la hora elegida es ${utils.format(value, 'fullTime')}` : 'Elige hora',
    fieldClearLabel: 'Limpiar valor',
    // Table labels
    timeTableLabel: 'elige hora',
    dateTableLabel: 'elige fecha',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'A'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $aed7cea5f35cca3b$export$e3f6634382f135e9 = (0, $85ebbb99b2811e17$export$67c96d35a1b010b3)($aed7cea5f35cca3b$var$esESPickers);


const $b0993d1439cdfed4$export$cce887d9234dd4d5 = {
    title: "Compras",
    description_1: `Como usuario gratuito de Piper ten\xe9s las siguientes limitaciones en cada uno de estos recursos:
`,
    limit_albums: "300 \xe1lbumes",
    limit_collections: "3 colecciones",
    limit_shelvings: "2 muebles",
    limit_artists: "200 artistas",
    limit_labels: "200 sellos",
    limit_album_formats: "10 formatos de \xe1lbum",
    limit_album_types: "10 tipos de \xe1lbum",
    limit_tags: "30 etiquetas",
    limit_stores: "50 tiendas",
    limit_sell_values: "50 valores de venta",
    limit_exchange_rates: "100 cambios de moneda",
    description_2: `
En el momento que llegues a cualquiera de estos l\xedmites, el sistema te va a avisar que llegaste al m\xe1ximo para ese recurso cuando quieras agregar un nuevo \xedtem. Siempre ten\xe9s la opci\xf3n de eliminar un \xedtem para agregar uno distinto en cualquier momento.

Si quer\xe9s extender cualquiera de estos l\xedmites, ten\xe9s la posibilidad de realizar una compra. Cada recurso cuenta con distintos paquetes que, al comprarlos, van a extender el l\xedmite en determinada cantidad. Vas a poder encontrar el men\xfa de compra de cada recurso en tu perfil de usuario, en la tabla que indica tus l\xedmites actuales.

La acreditaci\xf3n del nuevo l\xedmite es inmediata una vez que se realiza el pago de forma exitosa.

Para usar el medio de pago de Apple Pay es necesario que uses la aplicaci\xf3n nativa de iOS disponible en App Store. El monto puede diferir entre medios de pago.

Ante cualquier problema con una compra, no dudes en consultar a soporte para que podamos corregir tu situaci\xf3n lo antes posible.

`
};


const $f5d4eb6bcdfda324$export$213dfde9ccf1e1f1 = {
    locale: "es-ES",
    currencyLocale: "es-AR",
    fnsLocale: (0, $00427cc67faa552f$export$2e2bcd8739ae039),
    datePickerLocale: (0, $aed7cea5f35cca3b$export$e3f6634382f135e9),
    minDate: "1800-01-01",
    app_name: "Piper",
    /* General */ yes: "S\xed",
    no: "No",
    none: "Ninguno",
    not_in: "No en",
    menu: "Men\xfa",
    save: "Guardar",
    close: "Cerrar",
    delete: "Eliminar",
    expand: "Expandir",
    shrink: "Contraer",
    discount: "OFF",
    new: "Nuevo",
    horizontal: "Horizontal",
    vertical: "Vertical",
    help: "Ayuda",
    refresh_list: "Recargar lista",
    alert_accept: "Aceptar",
    alert_cancel: "Cancelar",
    alert_confirm: "Confirmar",
    alert_modify: "Modificar",
    alert_delete: "Eliminar",
    alert_exit: "Salir",
    alert_cancel_confirmation: "\xbfQuer\xe9s cancelar la operaci\xf3n?",
    session_expired: "Tu sesi\xf3n expir\xf3. Por favor ingres\xe1 nuevamente.",
    album_singular: "\xe1lbum",
    albums_plural: "\xe1lbumes",
    albums_plural_title: "\xc1lbumes",
    disc_singular: "disco",
    plural_indicator: "s",
    search: "Buscar",
    unknown: "Desconocido",
    mint: "Mint",
    missing_purchase_date: "Falta la fecha de compra",
    date_missing: "Seleccionar fecha",
    field_missing: "Ten\xe9s que completar el campo",
    field_missing_short: "Complet\xe1 esto",
    field_invalid: "El campo es inv\xe1lido",
    not_number_error: "Este campo tiene que ser un n\xfamero",
    open_on_discogs: "Ver en Discogs",
    open_on_private_collection: "Ver en mi colecci\xf3n privada",
    open_on_layout: "Ver en el estante",
    mark_as_title: "Marcar como...",
    remove_mark_title: "Quitar marca",
    refresh_image: "Recargar imagen",
    copy_value: "Copiar valor",
    copy_value_success_notification: "Valor copiado al portapapeles",
    clear_value: "Limpiar valor",
    clear_values: "Limpiar valores",
    start_date: "Fecha inicio",
    end_date: "Fecha fin",
    generic_attribute_filter_description: "Ingres\xe1 el valor que est\xe1s buscando:",
    generic_track_name: "Nueva pista",
    no_value: "Sin valor",
    currency_title: "Moneda",
    share_link_notification: "\xa1Link copiado al portapapeles!",
    image_upload_success: "\xa1Imagen actualizada exitosamente!",
    image_upload_error: "Ocurri\xf3 un error actualizando la imagen. Por favor intent\xe1 nuevamente.",
    upload_multiple_files_error: "Por favor seleccion\xe1 solamente un archivo.",
    upload_multiple_images_error: "Por favor seleccion\xe1 solamente una imagen.",
    album_update_success: "\xa1\xc1lbum actualizado exitosamente!",
    album_update_error: "Ocurri\xf3 un error actualizando el \xe1lbum. Por favor intent\xe1 nuevamente.",
    album_created: "\xa1El \xe1lbum se agreg\xf3 correctamente!",
    album_deleted: "El \xe1lbum se elimin\xf3 correctamente",
    generic_update_success: "La operaci\xf3n fue exitosa",
    generic_update_error: "No se pudo completar la operaci\xf3n, por favor intent\xe1 de nuevo m\xe1s tarde.",
    generic_error: "Ocurri\xf3 un error inesperado. Por favor revis\xe1 tu conexi\xf3n e intent\xe1 de nuevo.",
    clear_filter: "Limpiar filtro",
    clear_search: "Limpiar b\xfasqueda",
    order_warning: "\u26A0\uFE0F Sin \xf3rden",
    back_to_app: "Volver a la aplicaci\xf3n",
    general_queries: "Si ten\xe9s alguna duda por favor contactanos:",
    network_online_message: "\xa1Volvi\xf3 la conexi\xf3n a internet!",
    network_offline_message: "Parece que no est\xe1s conectado a internet. Cheque\xe1 tu conexi\xf3n.",
    qr_code: "C\xf3digo QR",
    qr_code_public_title: "C\xf3digo QR p\xfablico",
    qr_code_public_message: "Pod\xe9s compartir este c\xf3digo QR con otras personas",
    qr_code_private_title: "C\xf3digo QR privado",
    qr_code_private_message: "Este c\xf3digo QR s\xf3lo te va a funcionar a vos",
    download: "Descargar",
    toggle_style: "Cambiar estilo",
    no_results: "La b\xfasqueda no trajo resultados",
    edit_profile_description: "Ingres\xe1 el perfil debajo:",
    edit_description_description: "Ingres\xe1 la descripci\xf3n debajo:",
    about_app_title: "Acerca de",
    dropzone_placeholder: "Arrastr\xe1 un archivo, o toc\xe1 para seleccionar uno.",
    more_info: "M\xe1s informaci\xf3n",
    description_title: "Descripci\xf3n",
    optional_attributes: "Atributos opcionales",
    push_notifications_permission_notice: "\xbfTe gustar\xeda recibir notificaciones de Piper?",
    status_title: "Estado",
    status_active: "Activo",
    status_inactive: "Inactivo",
    /* Policies */ privacy_policy_link: "Pol\xedtica de Privacidad",
    terms_link: "T\xe9rminos de Servicio",
    /* MobileAlert */ greetings: "\xa1Hola!",
    not_found_subtitle: "No pudimos encontrar lo que est\xe1s buscando",
    not_found_message: "Hac\xe9 clic en este bot\xf3n para volver a la aplicaci\xf3n:",
    not_found_queries: "Si cre\xe9s que esto es un error o ten\xe9s alguna pregunta, por favor comunicate:",
    /* MaintenancePage */ maintenance_message: "La aplicaci\xf3n se encuentra en mantenimiento, pronto va a estar nuevamente disponible.",
    /* SignupViewController */ signup_title: "Nuevo usuario",
    signup_subtitle: "Ingres\xe1 estos datos",
    signup_description: "Vas a necesitar confirmar la direcci\xf3n de correo electr\xf3nico",
    signup_repeat_password_placeholder: "Repet\xed la contrase\xf1a",
    signup_success_title: "\xa1Tu usuario est\xe1 listo!",
    signup_success_message: "Revis\xe1 tu bandeja de entrada e ingres\xe1 el c\xf3digo alfanum\xe9rico que te enviamos al momento de ingresar a la aplicaci\xf3n.\n\nEnviamos el c\xf3digo de verificaci\xf3n a {0}",
    recover_password_form_title: "Ingres\xe1 tu correo electr\xf3nico y una nueva contrase\xf1a",
    recover_password_form_subtitle: "Te vamos a enviar un c\xf3digo que vas a ingresar en el pr\xf3ximo paso",
    recover_password_email_not_found: "Ese correo electr\xf3nico no est\xe1 registrado, pod\xe9s usarlo para crear un nuevo usuario.",
    /* CreateAlbumViewController */ ca_title: "Nuevo \xe1lbum",
    ca_all_fields: "todos los campos requeridos",
    ca_name: "el nombre",
    ca_artist: "el artista",
    ca_country: "el origen",
    ca_catalogue_number: "el n\xfamero de cat\xe1logo",
    ca_color: "el color",
    ca_store: "la tienda",
    ca_label: "el sello",
    ca_missing_message: "Ten\xe9s que completar {0} del nuevo \xe1lbum.",
    new_box_set_title: "Nuevo box set",
    /* AlbumsTableViewController */ add_album: "Agregar \xe1lbum",
    add_box_set: "Agregar box set",
    album_title: "\xc1lbum",
    albums_title: "Mis \xe1lbumes",
    option_attributes: "Atributos",
    option_stats: "Estad\xedsticas",
    option_marketplace: "Exhibici\xf3n",
    option_close_session: "Cerrar sesi\xf3n",
    option_preferences: "Preferencias",
    option_go_to_app: "Ir a Piper",
    option_refresh_albums: "Actualizar \xe1lbumes",
    option_fetch_all_albums: "Traer todos los \xe1lbumes",
    option_reorder_albums: "Reordenar \xe1lbumes",
    option_filter_albums: "Filtrar \xe1lbumes",
    option_show_index: "Mostrar \xedndice",
    option_random_albums: "\xc1lbumes aleatorios",
    option_reel: "Vista de carrete",
    option_search_albums: "Buscar \xe1lbumes",
    option_view_detail: "Ver detalle",
    option_discogs_import: "Importar desde Discogs",
    option_excel_import: "Importar desde planilla de c\xe1lculo",
    option_scan_barcode: "Agregar desde c\xf3digo de barras o b\xfasqueda",
    random_albums_message: "Ingres\xe1 la cantidad de \xe1lbumes:",
    play_from_youtube: "Reproducir desde YouTube",
    album_delete_all: "Eliminar todos los \xe1lbumes filtrados",
    album_delete_all_confirmation_message: "Est\xe1s por eliminar TODOS tus \xe1lbumes en la colecci\xf3n actual. \xa1ESTO NO PUEDE DESHACERSE! Si est\xe1s seguro de querer hacer esto, por favor escrib\xed 'Eliminar todos los \xe1lbumes' abajo y confirm\xe1.",
    album_delete_all_filter_confirmation_message: "Est\xe1s por eliminar TODOS los \xe1lbumes filtrados en la colecci\xf3n actual. \xa1ESTO NO PUEDE DESHACERSE! Los \xe1lbumes que caen fuera del filtro no van a modificarse. Si est\xe1s seguro de querer hacer esto, por favor escrib\xed 'Eliminar todos los \xe1lbumes' abajo y confirm\xe1.",
    album_delete_all_placeholder: "Eliminar todos los \xe1lbumes",
    album_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar el \xe1lbum {0}? Esto va a eliminar el \xe1lbum de TODAS las colecciones y no es reversible. Si solamente quer\xe9s eliminarlo de una colecci\xf3n pod\xe9s hacerlo desde el detalle del \xe1lbum en la lista de colecciones.",
    box_set_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar el box set {0}? Esto va a eliminar el box set de TODAS las colecciones y no es reversible. Si solamente quer\xe9s eliminarlo de una colecci\xf3n pod\xe9s hacerlo desde el detalle del box set en la lista de colecciones.\n\nEsto no va a eliminar ning\xfan \xe1lbum que pertenezca al box set.",
    album_remove_from_box_set_confirmation: "\xbfEst\xe1s seguro de querer eliminar el \xe1lbum {0} de este box set? Esto no va a eliminar el \xe1lbum propiamente dicho o sus atributos.",
    album_remove_from_box_set: "Eliminar del box set",
    no_albums_error: "Agreg\xe1 alg\xfan \xe1lbum para poder usar esta funcionalidad.",
    options: "Opciones",
    album_options: "Opciones de \xe1lbumes",
    album_sleeve_grade: "Sobre:",
    box_set_sleeve_grade: "Caja:",
    album_media_grade: "Disco:",
    open_drawer: "Abrir men\xfa",
    open_attributes_list: "Abrir lista de atributos",
    open_albums_list: "Abrir lista de \xe1lbumes",
    add: "Agregar",
    add_attribute: "Agregar nuevo",
    album_highlighted: "Destacado",
    album_sold: "Vendido",
    album_upcoming: "Pr\xf3ximamente",
    album_new: "Novedad",
    album_reserved: "Reservado",
    /* AlbumDetailViewController */ exchange_rate_title: "Cambio de moneda",
    sell_value_title: "Precio de venta",
    sell_value_detail: "Grupo {0} ({1} USD)",
    purchase_price_title: "Precio de compra",
    purchase_price_detail: "Precio al momento de la compra: {0}",
    purchase_price_detail_dollars: "Precio al momento de la compra: {0} ({1})",
    purchase_price_placeholder: "Precio al momento de la compra",
    purchase_price_message: "Ingres\xe1 el precio al momento de la compra del \xe1lbum:",
    artist_title: "Artista",
    label_title: "Sello",
    original_year_title: "A\xf1o original",
    original_year_message: "Ingres\xe1 el a\xf1o original del \xe1lbum:",
    release_year_title: "A\xf1o de edici\xf3n",
    release_year_message: "Ingres\xe1 el a\xf1o de esta edici\xf3n:",
    sleeve_grade_title: "Condici\xf3n del sobre",
    sleeve_grade_box_set_title: "Condici\xf3n de la caja",
    media_grade_plural_title: "Condici\xf3n de los discos",
    media_grade_singular_title: "Condici\xf3n del disco",
    revenue_title: "Ganancia",
    purchase_date_title: "Fecha de compra",
    store_title: "Tienda",
    catalogue_number_title: "N\xfamero de cat\xe1logo",
    catalogue_number_message: "Ingres\xe1 el n\xfamero de cat\xe1logo de esta edici\xf3n:",
    disc_count_title: "Cantidad de discos",
    disc_count_message: "Ingres\xe1 la cantidad de discos:",
    disc_color_plural_title: "Color de los discos",
    disc_color_singular_title: "Color del disco",
    disc_color_plural_message: "Ingres\xe1 el color de los discos:",
    disc_color_singular_message: "Ingres\xe1 el color del disco:",
    album_format_title: "Formato",
    album_type_title: "Tipo de \xe1lbum",
    add_track: "Agregar pista",
    track_count_title: "Cantidad de canciones",
    track_count_title_big: "Pistas",
    track_count_message: "Ingres\xe1 la cantidad de canciones:",
    album_length_title: "Duraci\xf3n",
    album_length_title_big: "Duraci\xf3n",
    album_length_message: "Ingres\xe1 la duraci\xf3n del \xe1lbum:",
    discogs_id_title: "ID de Discogs",
    discogs_id_title_big: "ID de Discogs",
    discogs_id_message: "Ingres\xe1 el ID de release de Discogs:",
    impact_title: "Calificaci\xf3n",
    random_title: "Aleatorio",
    notes_title: "Notas",
    notes_detail: "Ingres\xe1 notas para el \xe1lbum:",
    notes_placeholder: "Notas del \xe1lbum",
    edit_album_name: "Editar nombre",
    change_artist: "Cambiar artista",
    change_label: "Cambiar sello",
    name_title: "Nombre",
    name_detail: "Ingres\xe1 el nombre del \xe1lbum:",
    name_placeholder: "Ejemplo: Slow Turning",
    box_set_name_placeholder: "Ejemplo: The Definitive Collection",
    artist_placeholder: "Ejemplo: John Hiatt",
    country_placeholder: "Ejemplo: USA",
    original_year_placeholder: "Ejemplo: 1988",
    release_year_placeholder: "Ejemplo: 2018",
    catalogue_number_placeholder: "Ejemplo: B0027601-01",
    disc_color_placeholder: "Ejemplo: Negro",
    impact_placeholder: "\u2606\u2606\u2606\u2606\u2606",
    sleeve_grade_placeholder: "Ejemplo: VG+",
    media_grade_placeholder: "Ejemplo: NM",
    no_album_selected: "Seleccion\xe1 un \xe1lbum para ver su detalle",
    album_no_collections: "Este \xe1lbum todav\xeda no tiene ninguna colecci\xf3n en particular asociada",
    album_no_location: "Este \xe1lbum todav\xeda no tiene ubicaci\xf3n",
    share_album: "Compartir \xe1lbum",
    get_private_link: "Obtener link privado",
    get_album_insights: "Obtener informaci\xf3n del \xe1lbum",
    copy_album: "Copiar \xe1lbum",
    copy_box_set: "Copiar box set",
    album_shared_loading: "Cargando contenido...",
    /* Image Gallery */ image_gallery: "Galer\xeda de im\xe1genes",
    add_new_image: "Agregar imagen",
    front_cover: "Tapa",
    back_cover: "Contratapa",
    spine: "Lomo",
    image_name: "Nombre de la imagen",
    image_name_message: "Ingres\xe1 un nombre para esta imagen. S\xf3lo puede tener 30 caracteres o menos.",
    image_name_placeholder: "Ejemplo: Frente del insert",
    option_view_image: "Ver detalle de la imagen",
    modify_front_image: "Editar imagen del frente",
    modify_image: "Editar imagen",
    move_left: "Mover a la izquierda",
    move_right: "Mover a la derecha",
    move_up: "Mover arriba",
    move_down: "Mover abajo",
    edit_image_name: "Editar nombre",
    image_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar esta imagen?",
    image_fetch_confirmation: "Esto va a sobreescribir la imagen actual para este \xe1lbum, \xbfest\xe1s seguro?",
    album_3d_model: "Vista 3D",
    rotation_reset: "Reiniciar rotaci\xf3n",
    /* TrackListDialog */ track_list_title: "Lista de canciones",
    fetch_from_discogs: "Traer desde Discogs",
    fetch_image_from_discogs: "Traer imagen del frente desde Discogs",
    fetch_from_discogs_disabled: "Ten\xe9s que completar el Discogs ID de este \xe1lbum para usar esta funcionalidad",
    track_extra_artists_placeholder: "Cr\xe9ditos de la canci\xf3n",
    track_name_title: "Nombre",
    track_name_description: "Ingres\xe1 el nombre de la canci\xf3n:",
    track_name_placeholder: "Ejemplo: Telegraph Road",
    track_position_title: "Posici\xf3n",
    track_position_description: 'Ingres\xe1 la posici\xf3n de la canci\xf3n "{0}":',
    track_position_placeholder: "Ejemplo: A1",
    track_length_title: "Duraci\xf3n",
    track_length_description: 'Ingres\xe1 la duraci\xf3n de la canci\xf3n "{0}":',
    track_extra_artists_title: "Cr\xe9ditos",
    track_extra_artists_description: 'Ingres\xe1 los cr\xe9ditos de la canci\xf3n "{0}":',
    fetch_tracks_from_discogs_confirmation: "\xbfEst\xe1s seguro de querer traer la lista de canciones de este \xe1lbum desde Discogs? Esto va a sobreescribir cualquier cambio que hayas hecho a la lista de canciones.",
    /* AlbumsFilterViewController */ order_by_title: "Ordenado por",
    order_direction_title: "Direcci\xf3n",
    order_desc_title: "Descendente",
    order_asc_title: "Ascendente",
    filter_is: "Es",
    filter_is_not: "No es",
    filter_album_search_text_title: "Texto de b\xfasqueda",
    filter_album_format_title: "Formato",
    filter_album_type_title: "Tipo de \xe1lbum",
    filter_tag_title: "Etiqueta",
    filter_gatefold_title: "Gatefold",
    filter_insert_title: "Insert",
    filter_lyrics_title: "Letras",
    filter_clean_title: "Escuchado",
    filter_box_set_title: "Es box set",
    filter_artist_title: "Artista",
    filter_store_title: "Tienda",
    filter_label_title: "Sello",
    filter_impact_title: "Calificaci\xf3n",
    filter_sleeve_grade_title: "Condici\xf3n del sobre",
    filter_media_grade_title: "Condici\xf3n del disco",
    filter_sell_value_title: "Precio de venta",
    filter_country_title: "Origen",
    filter_color_title: "Color",
    filter_original_year_title: "A\xf1o original",
    filter_release_year_title: "A\xf1o de edici\xf3n",
    filter_sell_status_title: "Marcado como...",
    filter_confirm: "Aplicar filtro",
    sort_by_sell_value: "Precio de venta (Nombre)",
    sort_by_sell_value_dollars: "Precio de venta (Valor)",
    add_to_filter: "Agregar al filtro",
    remove_from_filter: "Remover del filtro",
    /* AttributeListCollectionViewController */ filter_left_title: "Filtros disponibles",
    filter_right_title: "Filtro a aplicar",
    attribute_artists_title: "Artistas",
    attribute_stores_title: "Tiendas",
    attribute_labels_title: "Sellos",
    attribute_exchange_rates_title: "Cambios de moneda",
    attribute_sell_values_title: "Valores de venta",
    attribute_impacts_title: "Calificaciones",
    attribute_countries_title: "Banderas",
    attribute_sleeve_grades_title: "Condici\xf3n de sobres",
    attribute_media_grades_title: "Condici\xf3n de discos",
    attribute_album_types_title: "Tipos de \xe1lbum",
    attribute_album_formats_title: "Formatos",
    artist_edit: "Editar artista",
    artist_view: "Ver artista",
    label_edit: "Editar sello",
    label_view: "Ver sello",
    gear_item_edit: "Editar pieza de equipo",
    gear_item_view: "Ver pieza de equipo",
    equipment_edit: "Editar equipo",
    equipment_view: "Ver equipo",
    empty_artists: "Todav\xeda no ten\xe9s artistas",
    empty_stores: "Todav\xeda no ten\xe9s tiendas",
    empty_tags: "Todav\xeda no ten\xe9s etiquetas",
    empty_origin_countries: "Todav\xeda no ten\xe9s or\xedgenes",
    empty_labels: "Todav\xeda no ten\xe9s sellos",
    empty_exchange_rates: "Todav\xeda no ten\xe9s cambios de moneda",
    empty_sell_values: "Todav\xeda no ten\xe9s valores de venta",
    empty_gear_items: "Todav\xeda no ten\xe9s piezas de equipo",
    empty_equipments: "Todav\xeda no ten\xe9s equipos",
    empty_equipment_gear_items: "Este equipo no tiene piezas de equipo",
    empty_impacts: "No se pudieron cargar las calificaciones",
    empty_countries: "No se pudieron cargar las banderas",
    empty_sleeve_grades: "No se pudieron cargar las condiciones de sobres",
    empty_media_grades: "No se pudieron cargar las condiciones de discos",
    empty_album_types: "Todav\xeda no ten\xe9s tipos de \xe1lbum",
    empty_album_formats: "Todav\xeda no ten\xe9s formatos",
    empty_artists_public: "No hay artistas para filtrar",
    empty_stores_public: "No hay tiendas para filtrar",
    empty_tags_public: "No hay etiquetas para filtrar",
    empty_origin_countries_public: "No hay or\xedgenes para filtrar",
    empty_labels_public: "No hay sellos para filtrar",
    empty_exchange_rates_public: "No hay cambios de moneda para filtrar",
    empty_sell_values_public: "No hay valores de venta para filtrar",
    empty_album_types_public: "No hay tipos de \xe1lbumes para filtrar",
    empty_album_formats_public: "No hay formatos para filtrar",
    empty_collections: "Todav\xeda no ten\xe9s colecciones",
    empty_tracklist: "No hay pistas que mostrar",
    empty_attribute_description: "\xa1Empez\xe1 a agregar para que aparezcan en esta lista!",
    empty_search_title: `No hay resultados sobre "{0}"`,
    empty_search_description: "Revis\xe1 la ortograf\xeda o intent\xe1 hacer otra b\xfasqueda",
    empty_user_notifications: "No ten\xe9s notificaciones nuevas",
    add_exchange_rate_by_time_lapse: "Agregar por lapso de tiempo",
    add_exchange_rate_by_time_lapse_disabled: "Para agregar cambios de moneda por lapso de tiempo por favor mejor\xe1 la suscripci\xf3n de tu cuenta.",
    /* Email General */ email_used: "Este correo ya est\xe1 en uso \u274C",
    email_valid: "Este correo est\xe1 disponible \uD83D\uDC4D\uFE0F",
    email_invalid: "La direcci\xf3n ingresada no parece v\xe1lida \u274C",
    email_error_invalid: "La direcci\xf3n de correo electr\xf3nico no es v\xe1lida. Por favor revisala e intent\xe1 nuevamente.",
    email_error_duplicated: "El correo electr\xf3nico ingresado ya est\xe1 en uso por otro usuario.",
    /* Password General */ password_very_weak: "La contrase\xf1a es muy d\xe9bil \u274C",
    password_weak: "La contrase\xf1a es d\xe9bil \u274C",
    password_valid: "La contrase\xf1a es aceptable \uD83D\uDC4D",
    password_strong: "La contrase\xf1a es fuerte \uD83D\uDC4D",
    password_match: "Las contrase\xf1as coinciden \uD83D\uDC4D",
    password_mismatch: "Las contrase\xf1as no coinciden \u274C",
    password_missing: "Ingres\xe1 tu contrase\xf1a.",
    password_repeat_missing: "Repet\xed la contrase\xf1a que ingresaste en el \xfaltimo campo.",
    password_mismatch_error: "Las constrase\xf1as no coinciden. Por favor revisalo e intent\xe1 nuevamente.",
    password_weak_error: "La contrase\xf1a ingresada no cumple con los requisitos m\xednimos. Debe tener un m\xednimo de 8 caracteres y contener min\xfasculas, may\xfasculas, n\xfameros y/o caracteres especiales. Por favor revisala e intent\xe1 nuevamente.",
    /* LoginViewController */ login_unknown_error: "No pudimos ingresarte. Por favor intent\xe1 de nuevo m\xe1s tarde.",
    login_create_user: "Crear nuevo usuario",
    login_create_user_or_login: "Crear nuevo usuario\no ingresar",
    login_guest: "Ingresar como invitado",
    login_preferences: "Preferencias",
    login_again: "Volver a ingresar",
    login_again_subtitle: "Necesitamos que vuelvas a ingresar tu contrase\xf1a",
    login_again_message: "Necesitamos que vuelvas a ingresar tus credenciales para realizar esta acci\xf3n",
    login_wrong_credentials: "Las credenciales son incorrectas. Por favor verific\xe1 los datos ingresados e intent\xe1 nuevamente.",
    login_title: "\xa1Bienvenido!",
    login_email: "Usuario o correo",
    login_password: "Contrase\xf1a",
    login_submit: "Ingresar",
    login_subtitle: "Ingres\xe1 tus credenciales o bien",
    login_new_user_button: "cre\xe1 un nuevo usuario",
    login_guest_info: "Tambi\xe9n pod\xe9s ingresar como invitado",
    login_recover_password: "Recuperar contrase\xf1a",
    login_forgot_password: "\xbfOlvidaste tu contrase\xf1a?",
    guest_title: "Invitado",
    signin_with_google: "Continuar con Google",
    signin_with_apple: "Continuar con Apple",
    signin_with_passkey: "Llave de acceso",
    signin_with_passkey_long: "Ingresar con una llave de acceso",
    signup_email: "Correo electr\xf3nico",
    signup_oauth_intro: `\xa1Est\xe1s a un paso de crear tu nueva cuenta! Por favor confirm\xe1 que est\xe1s de acuerdo con lo siguiente:
    `,
    signup_accept_first: "Acepto la ",
    signup_accept_second: " y estoy de acuerdo con los ",
    signup_accept_third: ", y soy mayor de 13 a\xf1os.",
    /* SignupSuccessViewController */ verification_code_sent: "Enviamos el c\xf3digo a\n{0}",
    /* ArtistDetailViewController */ artist_death_date: "FECHA DE MUERTE",
    /* AVAudioPlayerViewController */ player_unknown_error: "Ocurri\xf3 un error inesperado",
    player_autoplay_on: "Reproducci\xf3n autom\xe1tica activada",
    player_autoplay_off: "Reproducci\xf3n autom\xe1tica desactivada",
    /* SettingsTableViewController */ settings_user_title: "Usuario",
    settings_preferences_title: "Preferencias",
    settings_advanced_title: "Aplicaci\xf3n",
    settings_cache_confirmation: "Est\xe1s por eliminar todas las im\xe1genes y datos guardados en la memoria cach\xe9.",
    settings_should_show_impact_descriptions: "Mostrar descripci\xf3n de calificaciones",
    settings_should_show_album_id: "Mostrar ID del \xe1lbum",
    settings_order_new_albums: "Ordenar autom\xe1ticamente \xe1lbumes nuevos",
    settings_show_decimals: "Mostrar decimales en ciertos importes financieros",
    settings_receive_email_notifications: "Recibir notificaciones por correo",
    settings_show_3d_model: "Usar modelo 3D en el detalle del \xe1lbum",
    my_external_systems_title: "Apps ya asociadas",
    catering_external_systems_title: "Apps disponibles",
    confirm_external_system_deletion: '\xbfEst\xe1s seguro de querer desasociar la app "{0}"?',
    /* EmailTableViewController */ email_current_title: "Correo electr\xf3nico actual",
    email_pending_title: "Correo pendiente de confirmaci\xf3n",
    email_confirm_new: "Confirmar correo nuevo",
    email_discard_new: "Descartar correo nuevo",
    email_new_title: "Nuevo correo electr\xf3nico",
    email_confirmed: "Confirmado \uD83C\uDF89",
    email_pending: "Pendiente \u26A0\uFE0F",
    /* ChangePasswordViewController */ password_new_mismatch: "La contrase\xf1a actual no coincide, por favor revisala.",
    password_update_success: "La contrase\xf1a fue actualizada con \xe9xito.",
    password_update_error_current: "Ingres\xe1 tu contrase\xf1a actual.",
    password_update_error_new: "Ingres\xe1 una nueva contrase\xf1a.",
    password_update_error_repeat: "Repet\xed la nueva contrase\xf1a.",
    /* VerifyEmailCodeViewController */ vec_title: "Verificar correo",
    vec_subtitle: "Revis\xe1 tu bandeja de entrada e ingres\xe1 el c\xf3digo que te enviamos",
    vec_code_placeholder: "C\xf3digo",
    vec_resend_code: "Reenviar c\xf3digo de verificaci\xf3n",
    vec_confirmation: "Se envi\xf3 un nuevo c\xf3digo de verificaci\xf3n y deber\xeda llegar en los pr\xf3ximos minutos, revis\xe1 tu bandeja de entrada.",
    vec_invalid_code: "El c\xf3digo ingresado es incorrecto. Revisalo e intent\xe1 nuevamente.",
    vec_success: "Tu nueva direcci\xf3n de correo electr\xf3nico fue confirmada con \xe9xito.",
    recover_password_success: "\xa1Tu contrase\xf1a fue modificada con \xe9xito!",
    /* StatsViewController */ stats_guest_error: "Ahora mismo sos un invitado. \xa1Cre\xe1 tu propia cuenta para ver estad\xedsticas de tu colecci\xf3n!",
    stats_clean_title: "ESCUCHADOS",
    stats_gatefold_title: "GATEFOLD",
    stats_insert_title: "CON INSERT",
    stats_lyrics_title: "CON LETRAS",
    stats_impacts_title: "CALIFICACIONES",
    stats_sleeve_grades_title: "CONDICI\xd3N DE SOBRES",
    stats_media_grades_title: "CONDICI\xd3N DE DISCOS",
    stats_pie_yes: "S\xcd",
    stats_pie_no: "NO",
    stats_last_updated: "\xdaltima actualizaci\xf3n",
    stats_loading: "Esto puede demorar un poco para colecciones grandes, ten\xe9 paciencia por favor...",
    stats_error: "Hubo un error trayendo las estad\xedsticas de esta colecci\xf3n. Por favor intent\xe1 de nuevo m\xe1s tarde.",
    /* Attributes General */ attributes_title: "Atributos",
    /* ModifyExchangeRateViewController */ mer_new_title: "Nuevo cambio de moneda",
    mer_delete_confirmation: "\xbfQuer\xe9s eliminar este cambio de moneda?",
    mer_format_error: "El factor de conversi\xf3n debe ser un n\xfamero positivo mayor a cero.",
    mer_rate_title: "Factor de conversi\xf3n (USD -> {0})",
    mer_rate_placeholder: "1 USD equivale a # {0}",
    mer_date_title: "Fecha",
    date_range_title: "Rango de fechas",
    mer_tl_title: "Obtener cambios de moneda autom\xe1ticamente",
    mer_tl_description: "Ingres\xe1 un rango de fechas a continuaci\xf3n y vamos a cargar autom\xe1ticamente un cambio de moneda cada 7 d\xedas. Asegurate de no exceder un rango de 1 a\xf1o. Si quer\xe9s cargar m\xe1s de 1 a\xf1o de cambios de moneda, por favor repet\xed esta operaci\xf3n las veces que sean necesarias.",
    /* ModifyLabelViewController */ ml_new_title: "Nuevo sello",
    ml_delete_confirmation: "\xbfQuer\xe9s eliminar este sello?",
    ml_missing_error: "Complet\xe1 el nombre del nuevo sello.",
    ml_placeholder: "Ejemplo: Asylum Records",
    ml_field_title: "Nombre del sello",
    ml_image_title: "Logo del sello",
    /* ModifyStoreViewController */ ms_new_title: "Nueva tienda",
    ms_delete_confirmation: "\xbfQuer\xe9s eliminar esta tienda?",
    ms_missing_error: "Complet\xe1 el nombre de la nueva tienda.",
    ms_placeholder: "Ejemplo: Ebay",
    ms_field_title: "Nombre de la tienda",
    ms_address_title: "Direcci\xf3n de la tienda",
    ms_address_placeholder: "Direcci\xf3n de la tienda",
    /* ModifySellValueViewController */ msv_new_title: "Nuevo precio de venta",
    msv_delete_confirmation: "\xbfQuer\xe9s eliminar este precio de venta?",
    msv_missing_error: "Complet\xe1 todos los campos.",
    msv_group_title: "Nombre del grupo",
    msv_group_placeholder: "Ejemplos: A, 4, 3.2",
    msv_dollars_title: "Precio [USD]",
    msv_dollars_placeholder: "Precio de venta en USD",
    msv_description_title: "Descripci\xf3n del grupo",
    msv_description_placeholder: "Ejemplo: \xc1lbumes raros en buen estado",
    msv_group: "Grupo",
    /* ModifyArtistViewController */ ma_new_title: "Nuevo artista",
    ma_delete_confirmation: "\xbfQuer\xe9s eliminar este artista?",
    ma_missing_error: "Complet\xe1 el nombre del artista.",
    ma_name_title: "Nombre art\xedstico",
    ma_name_placeholder: "Ejemplo: Little Richard",
    ma_real_name_title: "Nombre real",
    ma_real_name_placeholder: "Ejemplo: Richard Wayne Penniman",
    ma_website_title: "P\xe1gina web",
    ma_website_button_title: "Visitar p\xe1gina web",
    ma_website_placeholder: "Ejemplo: https://piper.ldelosheros.com",
    ma_discogs_id_title: "ID de Discogs",
    ma_discogs_id_placeholder: "Ejemplo: 12345",
    ma_profile_title: "Perfil",
    ma_profile_placeholder: "Perfil",
    ma_birth_date_title: "Fecha de nacimiento",
    ma_death_date_title: "Fecha de muerte",
    ma_image_title: "Foto",
    /* ModifyTimeLengthAlertController */ mtl_title: "Duraci\xf3n",
    mtl_message: "Ingres\xe1 la duraci\xf3n del \xe1lbum:",
    mtl_missing_error: "Complet\xe1 la duraci\xf3n del \xe1lbum.",
    mtl_calculate: "Calcular desde las canciones",
    /* ModifyAlbumTypeViewController */ mat_new_title: "Nuevo tipo de \xe1lbum",
    mat_delete_confirmation: "\xbfQuer\xe9s eliminar este tipo de \xe1lbum?",
    mat_missing_error: "Complet\xe1 el nombre del tipo de \xe1lbum.",
    mat_field_title: "Nombre del tipo de \xe1lbum",
    mat_placeholder: "Ejemplos: Estudio, Compilado",
    mat_show_on_album_list_title: "Mostrar en la lista de \xe1lbumes",
    /* ModifyAlbumFormatViewController */ maf_new_title: "Nuevo formato",
    maf_delete_confirmation: "\xbfQuer\xe9s eliminar este formato?",
    maf_missing_error: "Complet\xe1 el nombre y nombre corto del formato.",
    maf_name_title: "Nombre",
    maf_name_placeholder: "Ejemplo: Long Play",
    maf_short_name_title: "Nombre corto",
    maf_short_name_placeholder: "Ejemplo: LP",
    /* Album contents */ album_contents_title: "Contenido",
    add_content: "Agregar contenido",
    album_content_disc: "Disco",
    album_content_other: "Otro",
    playback_speed: "Velocidad de reproducci\xf3n",
    album_content_quantity: "Cantidad",
    album_content_type: "Tipo de contenido",
    album_content_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar este contenido del \xe1lbum?",
    /* Album identifiers */ album_identifier_title: "Identificador",
    album_identifiers_title: "Identificadores",
    add_identifier: "Agregar identificador",
    album_identifier_catalogue: "N\xfamero de cat\xe1logo",
    album_identifier_matrix: "C\xf3digo de matriz",
    album_identifier_value: "Valor",
    album_identifier_value_description: "Ingres\xe1 un valor para este identificador",
    album_identifier_matrix_part: "Agregar segmento",
    album_identifier_barcode: "C\xf3digo de barras",
    album_identifier_other: "Otro",
    album_identifier_type: "Tipo de identificador",
    album_identifier_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar este identificador del \xe1lbum?",
    /* Tags */ tag_title: "Etiqueta",
    new_tag_title: "Nueva etiqueta",
    tags_title: "Etiquetas",
    /* Origin Countries */ origin_country_title: "Origen",
    new_origin_country_title: "Nuevo origen",
    origin_countries_title: "Or\xedgenes",
    origin_country_flag_title: "Bandera",
    /* Gear Items */ gear_item_title: "Pieza de equipo",
    gear_items_title: "Piezas de equipo",
    new_gear_item_title: "Nueva pieza de equipo",
    add_gear_item: "Agregar pieza de equipo",
    gear_item_delete_confirmation: "\xbfEst\xe1s seguro de querer eliminar esta pieza de equipo?",
    gear_item_name_title: "Nombre de la pieza de equipo",
    gear_item_name_placeholder: "Ejemplo: Amplificador",
    gear_item_brand_title: "Marca / Modelo",
    gear_item_brand_placeholder: "Ejemplo: Marantz PM6007",
    gear_item_image_title: "Foto",
    /* Equipments */ equipment_title: "Equipo",
    equipments_title: "Equipos",
    new_equipment_title: "Nuevo equipo",
    equipment_name_title: "Nombre del equipo",
    equipment_name_placeholder: "Ejemplo: Equipo de la sala de estar",
    /* UpdateEmailDialog */ update_email_title: "Correo",
    new_email_title: "NUEVO CORREO ELECTR\xd3NICO",
    new_email_placeholder: "Nuevo correo electr\xf3nico",
    email_pending_message: "Revis\xe1 tu bandeja de entrada, enviamos un c\xf3digo de verificaci\xf3n a {0}",
    /* UpdatePasswordDialog */ update_password_title: "Contrase\xf1a",
    old_password_title: "Contrase\xf1a actual",
    old_password_placeholder: "Contrase\xf1a actual",
    new_password_title: "Nueva contrase\xf1a",
    new_password_placeholder: "Nueva contrase\xf1a",
    repeat_password_placeholder: "Repet\xed la nueva contrase\xf1a",
    /* Stats */ stats_general_title: "General",
    stats_financials_title: "Finanzas",
    stats_album_total: "\xc1lbumes",
    stats_box_set_total: "Box sets",
    stats_clean_total: "\xc1lbumes escuchados",
    stats_gatefold_total: "\xc1lbumes gatefold",
    stats_insert_total: "\xc1lbumes con insert",
    stats_lyrics_total: "\xc1lbumes con letra",
    stats_colored_total: "\xc1lbumes de color",
    stats_average_original_year: "A\xf1o original promedio",
    stats_average_release_year: "A\xf1o de edici\xf3n promedio",
    stats_discs_total: "Cantidad de discos",
    stats_length_total: "Duraci\xf3n total",
    stats_average_album_length: "Duraci\xf3n \xe1lbum promedio",
    stats_average_disc_length: "Duraci\xf3n disco promedio",
    stats_average_track_length: "Duraci\xf3n canci\xf3n promedio",
    stats_tracks_by_album: "Canciones por \xe1lbum",
    stats_artist_total: "Cantidad de artistas",
    stats_artist_most_albums: "Artista con m\xe1s \xe1lbumes",
    stats_store_most_albums: "Tienda con m\xe1s \xe1lbumes",
    stats_label_most_albums: "Sello con m\xe1s \xe1lbumes",
    stats_purchase_price_total: "Precio de compra total",
    stats_sell_value_total: "Precio de venta total",
    stats_revenue_total: "Ganancia total",
    /* DiscogsImport */ import_from_discogs: "Importar desde Discogs",
    discogs_import_collection_folders_title: "Carpetas de Discogs",
    discogs_import_collection_import: "Importaci\xf3n desde Discogs",
    discogs_import_cancel_confirmation: "\xbfEst\xe1s seguro de querer cancelar el proceso de importaci\xf3n? Solamente vas a perder los \xe1lbumes que todav\xeda no fueron importados.",
    discogs_import_subtitle: "\xa1Estamos importando tu colecci\xf3n!",
    discogs_import_description: "Pod\xe9s seguir el progreso desde esta pantalla. El proceso puede tomarse descansos de hasta un minuto de vez en cuando. Esto se debe a las limitaciones impuestas por el servicio de Discogs y es completamente normal.",
    discogs_import_info: 'Estamos importando todos los \xe1lbumes de la carpeta "{0}", con un total de {1} \xe1lbumes.',
    cancel_import: "Cancelar proceso",
    discogs_folders_subtitle: "Seleccion\xe1 la carpeta desde la cual quer\xe9s importar tus \xe1lbumes",
    discogs_folders_description: "Despu\xe9s vas a poder elegir a qu\xe9 colecci\xf3n de Piper importarlos\n\nPod\xe9s cancelar el proceso cuando quieras y dirigirte a Discogs para modificar las carpetas de tu colecci\xf3n",
    discogs_folders_confirmation: 'Est\xe1s a punto de importar {0} \xe1lbumes desde la carpeta "{1}" a la colecci\xf3n "{2}". Vamos a tratar de completar la mayor cantidad de informaci\xf3n posible pero algunos campos van a tener que ser completados o corregidos manualmente.\n\nEste proceso va a crear nuevos \xe1lbumes, artistas, sellos y formatos como sea necesario, tratando de coincidir por nombre con cualquiera que hayas cargado previamente. No va a modificarse ninguno de los datos existentes.\n\nLa duraci\xf3n promedio de este proceso puede estimarse en 2 minutos por cada 50 \xe1lbumes, siempre dependiendo de la demanda actual. Pod\xe9s cancelarlo en cualquier momento y vas a poder mantener todos los \xe1lbumes que se hubiesen importado hasta el momento.',
    discogs_import_cancelled: "Cancelaste el proceso de importaci\xf3n.",
    discogs_import_errored: "Ocurri\xf3 un error mientras se importaban tus \xe1lbumes. Intent\xe1 de nuevo m\xe1s tarde.",
    discogs_import_created: "El proceso est\xe1 en espera para comenzar pronto. Una vez que empiece vas a poder revisar su progreso en esta ventana.",
    discogs_import_finished: "\xa1Todos los \xe1lbumes fueron importados!",
    discogs_import_disclaimer: "Pod\xe9s cerrar esta ventana y volver en cualquier momento.",
    discogs_import_disclaimer_finished: "Cerr\xe1 esta ventana para volver a tu colecci\xf3n.",
    discogs_auth_message: "Para importar tu colecci\xf3n de Discogs necesitamos que autorices a Piper en la p\xe1gina de Discogs. Hac\xe9 click en el bot\xf3n de abajo para abrir Discogs en una nueva pesta\xf1a y volv\xe9 ac\xe1 cuando hayas permitido el acceso.",
    discogs_auth_button: "Ir a Discogs",
    discogs_auth_retry: "Reintentar",
    discogs_should_skip_duplicates: "Saltear \xe1lbumes con el mismo ID de release",
    discogs_should_skip_duplicates_help: "Esto va a evitar duplicar \xe1lbumes que ya hab\xedas importado",
    discogs_should_upload_image: "Usar im\xe1genes de Discogs",
    discogs_should_upload_image_non_premium: "S\xf3lo para usuarios premium",
    discogs_should_upload_image_help: "Esto va a incrementar un poco la duraci\xf3n del proceso",
    /* ExcelImport */ excel_import_title: "Importar desde planilla de c\xe1lculo",
    excel_import_message: `Seleccion\xe1 un archivo con la extensi\xf3n 'xlsx'. Los \xe1lbumes dentro de la planilla de c\xe1lculo tienen que seguir un formato espec\xedfico, seleccion\xe1 el bot\xf3n de ayuda en la esquina superior derecha de esta ventana para conocer m\xe1s.
  
Despu\xe9s de confirmar vas a poder elegir a qu\xe9 colecci\xf3n de Piper importarlos.

Pod\xe9s usar la siguiente plantilla y llenarla con tus \xe1lbumes:
  `,
    excel_import_confirmation: `Est\xe1s a punto de importar todos los \xe1lbumes en el archivo "{0}" a la colecci\xf3n "{1}". Si alguna fila no cumple con el formato requerido, el proceso de importaci\xf3n va a saltear ese \xe1lbum.

Este proceso va a crear nuevos \xe1lbumes, artistas, sellos y otros atributos como sea necesario, tratando de coincidir por nombre con cualquiera que hayas cargado previamente. No va a modificarse ninguno de los datos existentes.`,
    excel_import_download_template: "Descargar plantilla",
    excel_import_template_url: "https://piper-public-images.s3.us-east-2.amazonaws.com/Piper-Plantilla.xlsx",
    excel_import_problems: `Encontramos algunos \xe1lbumes con problemas, pero el resto fue agregado exitosamente a tu colecci\xf3n. Abajo vas a encontrar la lista de \xe1lbumes que no pudieron ser importados:
  
{0}
  `,
    excel_import_description: "Pod\xe9s seguir el progreso desde esta pantalla.",
    /* Collections */ collection_title: "Colecci\xf3n",
    collection_new_title: "Nueva colecci\xf3n",
    add_collection: "Agregar colecci\xf3n",
    share_collection: "Compartir colecci\xf3n",
    star_collection: "Dar estrella",
    unstar_collection: "Quitar estrella",
    collections_title: "Colecciones",
    collections_tease: "\xa1Pr\xf3ximamente vas a poder manejar m\xfaltiples colecciones!",
    collection_delete_confirmation: '\xbfEst\xe1s seguro de querer eliminar la colecci\xf3n "{0}"? Todos los \xe1lbumes asociados a esta colecci\xf3n van a seguir estando disponibles en la colecci\xf3n de todos los \xe1lbumes.',
    private_collection: "Privada",
    public_collection: "P\xfablica",
    collection_missing_field: "Ten\xe9s que completar {0} de la colecci\xf3n.",
    collection_assign_filtered_albums: "Asignar \xe1lbumes filtrados a esta colecci\xf3n",
    collection_assign_filtered_albums_confirm: "\xbfEst\xe1s seguro de querer asignar los \xe1lbumes actualmente filtrados a esta colecci\xf3n? Esto solamente va a agregar los \xe1lbumes que no estaban previamente presentes en la colecci\xf3n seleccionada.",
    collection_assign_filtered_albums_success: "\xa1Asignamos los \xe1lbumes exitosamente!",
    collection_all_albums: "Todos los \xe1lbumes",
    collection_associate: "Asociar colecci\xf3n",
    collection_disassociate: "Desasociar",
    collection_disassociate_confirmation: '\xbfEst\xe1s seguro de querer desasociar este \xe1lbum de la colecci\xf3n "{0}"?',
    album_view_on_exhibition: "Ver en la exhibici\xf3n",
    collection_create_visibility: "Vas a poder convertirla en una colecci\xf3n p\xfablica cuando asocies algunos \xe1lbumes a la colecci\xf3n.",
    collection_visibility: "Visibilidad",
    collection_description: "Descripci\xf3n",
    collection_discount: "Descuento",
    collection_banned_fields: "Campos ocultos",
    collection_banned_fields_description: "Seleccion\xe1 un campo para ocultar cuando otras personas revisen esta colecci\xf3n (S\xf3lo para colecciones p\xfablicas)",
    collection_banned_field_is_clean: "Escuchado",
    collection_banned_field_is_gatefold: "Gatefold",
    collections_manage_title: "Colecciones",
    collection_modify: "Editar colecci\xf3n",
    collection_name_placeholder: "Ejemplo: \xc1lbumes a la venta",
    collection_image_info: "Para mejores resultados, trat\xe1 de usar im\xe1genes con una relaci\xf3n de aspecto similar a 5:1.",
    /* Box Sets */ box_set_title: "Box set",
    box_set_albums_title: "\xc1lbumes del box set",
    box_set_no_albums_title: "Este box set no tiene \xe1lbumes",
    box_set_no_albums_description: "Arrastr\xe1 los \xe1lbumes que pertenecen a este box set y soltalos en esta secci\xf3n",
    box_set_unique_error: "Este \xe1lbum ya es parte de un box set.",
    /* PreferencesViewController */ email_title: "Correo",
    theme_option: "Apariencia",
    dark_mode: "Gris",
    light_mode: "Claro",
    black_mode: "Noche",
    blue_mode: "Azul",
    coffee_mode: "Caf\xe9",
    language_title: "Idioma",
    language_global_title: "Language",
    app_version_title: "Versi\xf3n de la aplicaci\xf3n",
    clear_cache_title: "Limpiar memoria cach\xe9",
    about_title: "Acerca de esta aplicaci\xf3n",
    contact_us: "Contacto",
    contact_support_title: "Contactar a soporte",
    support_mail: "piper.soporte@ldelosheros.com",
    reorder_tutorial: `Para reordenar tus \xe1lbumes arrastralos hasta la posici\xf3n deseada y soltalos. S\xf3lo se pueden reordenar \xe1lbumes dentro del mismo artista.
  
Asegurate de tener seleccionada la colecci\xf3n de 'Todos los \xe1lbumes' para poder reordenar tu lista de \xe1lbumes. Tambi\xe9n ten\xe9s que tener la lista ordenada por artista y sin filtros, o solamente filtrado por artista.
  
Como esta funcionalidad trae problemas de rendimiento en algunos dispositivos, est\xe1 deshabilitada en tel\xe9fonos. Por favor us\xe1 la aplicaci\xf3n de escritorio o la app nativa de iOS para reordenar tus \xe1lbumes.
  `,
    credits: "\xa9 2026 Lautaro de los Heros, Piper\u2122",
    credits_short: "\xa9 2026 Piper\u2122",
    /* User Profile */ user_profile_title: "Perfil de usuario",
    username_title: "Nombre de usuario",
    modify_username_message: "Ingres\xe1 tu nombre de usuario. Tiene que empezar con una letra y tener 8-20 caracteres de largo. No se permiten caracteres especiales excepto guiones bajos.",
    no_color_name_title: "Nuevo color",
    no_color_names_title: "Colores de discos sin color",
    no_color_name_message: "Ingres\xe1 un color que no quieras que cuente como disco coloreado en tus estad\xedsticas:",
    no_color_name_removal_confirmation: '\xbfEst\xe1s seguro de querer eliminar el color "{0}"?',
    bio_title: "Biograf\xeda",
    bio_message: "Ingres\xe1 tu biograf\xeda. Va a ser visible para los dem\xe1s usuarios.",
    resource_limits_title: "L\xedmites",
    public_collections_title: "Colecciones p\xfablicas",
    remove_account_title: "Eliminar mi cuenta",
    remove_account_confirmation_message: "Est\xe1s por eliminar tu cuenta de usuario de forma permanente. \xa1ESTO NO PUEDE DESHACERSE! Todos tus \xe1lbumes, atributos, im\xe1genes, y perfil van a desaparecer para siempre. Si est\xe1s seguro de querer hacer esto, por favor escrib\xed 'Eliminar mi cuenta' abajo y confirm\xe1.",
    /* User Role */ update_role_title: "Plan de suscripci\xf3n",
    role_admin: "Administrador",
    role_guest: "Sin plan",
    role_common: "Sin plan",
    role_collector: "Coleccionista",
    role_premium: "Premium",
    subscription_free: "GRATIS",
    subscription_pay_info: "El cobro va a realizarse el primer d\xeda de cada mes excepto por el primer pago que va a hacerse en el momento que te suscribas. El precio de la primera cuota va a ser ajustado dependiendo de cu\xe1ntos d\xedas quedan pendientes.",
    subscription_pay_info_apple: "Pag\xe1 usando la aplicaci\xf3n de Piper disponible en App Store para dispositivos Apple. La suscripci\xf3n es administrada por Apple.",
    subscription_pay_info_patreon: "Pag\xe1 usando la plataforma Patreon. La suscripci\xf3n es administrada por Patreon.",
    total: "Total",
    subscription_pay_with_card: "Pagar con tarjeta de cr\xe9dito",
    subscription_pay_with_mercadopago: "Pagar con Mercado Pago",
    subscription_pay_with_mercadopago_alert: `Te vamos a redirigir a Mercado Pago para que puedas completar el pago.
  
IMPORTANTE: Es importante que uses el bot\xf3n para volver al sitio que se muestra una vez finalizado el proceso as\xed podemos asociar tu suscripci\xf3n con nuestra aplicaci\xf3n. Si no hac\xe9s este paso no vas a ver la suscripci\xf3n en Piper, pero no te preocupes, en ese caso contactanos y vamos a solucionar el inconveniente lo antes posible.`,
    subscription_pay_with_apple: "Pagar en App Store",
    subscription_pay_with_patreon: "Pagar con Patreon",
    subscription_payment_method_title: "M\xe9todo de pago",
    per_month: "por mes",
    pay_option: "Opci\xf3n",
    pay_option_mercado_pago: "Mercado Pago",
    pay_option_apple: "Apple",
    pay_option_patreon: "Patreon",
    subscription_success: "\xa1Tu nueva suscripci\xf3n est\xe1 lista! Por favor ingres\xe1 tus credenciales para continuar.",
    /* My Subscription */ my_subscription_title: "Mi suscripci\xf3n",
    subscription_manage_in_mercadopago: "Administrar en Mercado Pago",
    subscription_manage_in_apple: "Administrar en App Store",
    subscription_manage_in_patreon: "Administrar en Patreon",
    subscription_status: "Estado de la suscripci\xf3n",
    subscription_end_date: "Tu suscripci\xf3n va a terminar el",
    subscription_change: "Cambiar mi suscripci\xf3n",
    subscription_renew: "Volver a suscribirse",
    payment_last_status: "Estado del \xfaltimo pago",
    payment_next_date: "Pr\xf3ximo pago",
    payment_last_update: "\xdaltima actualizaci\xf3n",
    payment_approved: "Aprobado",
    payment_authorized: "Autorizado",
    payment_cancelled: "Cancelado",
    payment_charged_back: "Devuelto",
    payment_in_mediation: "En mediaci\xf3n",
    payment_in_process: "Procesando",
    payment_pending: "Pendiente",
    payment_refunded: "Reintegrado",
    payment_rejected: "Rechazado",
    payment_paused: "Pausado",
    payment_is_processing_message: "Tu pago se est\xe1 procesando. Volv\xe9 a consultar en unas horas para ver su estado.",
    /* Products */ purchase_alert: "Comprar m\xe1s",
    purchase_info: "Tu l\xedmite se va a actualizar una vez que se confirme la compra.",
    purchase_info_apple: "Pag\xe1 usando la aplicaci\xf3n de Piper disponible en App Store para dispositivos Apple.",
    purchase_success: "\xa1Tu compra est\xe1 lista! Segu\xed disfrutando de Piper con tu nuevo l\xedmite.",
    purchase_empty_list_error: "Para tu protecci\xf3n, por favor ingres\xe1 nuevamente tus credenciales para continuar.",
    bundles_title: "Paquetes",
    /* Marketplace */ highlighted_collections_title: "Colecciones",
    highlighted_albums_title: "\xc1lbumes",
    highlighted_users_title: "Usuarios",
    public_username_prefix: "Colecci\xf3n de",
    marketplace_search_placeholder: "\xc1lbumes, colecciones, usuarios",
    no_public_collections: "No hay colecciones p\xfablicas para mostrar",
    /* UserProfileDialog */ edit_avatar: "Editar avatar",
    user_since_title: "Usuario desde",
    /* Shortcuts */ shortcuts_title: "Accesos directos",
    shortcuts_add_albums: "Agregar un nuevo \xe1lbum",
    shortcuts_scan_barcode: "Agregar un \xe1lbum desde un c\xf3digo de barras o una b\xfasqueda",
    shortcuts_discogs_import: "Importar \xe1lbumes desde mi cuenta de Discogs",
    shortcuts_excel_import: "Importar \xe1lbumes desde una planilla de c\xe1lculo",
    shortcuts_stats: "Ver estad\xedsticas de mis \xe1lbumes",
    shortcuts_albums: "Ver mis \xe1lbumes",
    shortcuts_attributes: "Agregar un nuevo artista, sello, cambio de moneda y m\xe1s...",
    shortcuts_marketplace: "Explorar colecciones de otros usuarios",
    shortcuts_filter: "Filtrar mis \xe1lbumes en esta colecci\xf3n",
    shortcuts_filter_public: "Filtrar los \xe1lbumes en esta colecci\xf3n",
    shortcuts_random_albums: "Ver un \xe1lbum aleatorio de esta colecci\xf3n",
    shortcuts_change_collection: "Ver \xe1lbumes de una colecci\xf3n distinta",
    shortcuts_create_user: "Crear un usuario o ingresar",
    shortcuts_search_title: "No hay \xe1lbumes para mostrar",
    shortcuts_documentation: "Ver la documentaci\xf3n por ayuda o consejos",
    shortcuts_edit_profile: "Personalizar mi perfil de usuario",
    shortcuts_layout: "Organizar la ubicaci\xf3n f\xedsica de mis \xe1lbumes",
    /* User Notifications */ user_notifications_title: "Notificaciones",
    mark_as_read: "Marcar como le\xeddo",
    mark_as_unread: "Marcar como no le\xeddo",
    /* ScanBarcode */ scan_barcode_title: "Escane\xe1 el c\xf3digo de barras presente en el \xe1lbum",
    scan_barcode_description: "Opcionalmente, ingres\xe1 el c\xf3digo de barras de forma manual o cualquier otra informaci\xf3n sobre el \xe1lbum",
    camera_title: "Escanear un c\xf3digo de barras",
    flashlight: "Linterna",
    open_camera: "Abrir c\xe1mara",
    switch_camera: "Cambiar c\xe1mara",
    /* Messages */ messages_title: "Comentarios",
    messages_new_title: "Nuevo comentario",
    messages_reply: "Responder",
    messages_more: "M\xe1s comentarios",
    messages_replying_to: "Est\xe1s respondiendo a un comentario de {0}",
    messages_reply_more: "1  respuesta",
    messages_replies_more: "{0}  respuestas",
    message_removed: "<<Mensaje eliminado>>",
    album_no_messages: "Este \xe1lbum todav\xeda no tiene comentarios",
    view_message: "Ver comentario",
    messages_private_notice: "Si quer\xe9s responder a un comentario visit\xe1 este \xe1lbum en la exhibici\xf3n.",
    messages_confirm_removal: `\xbfEst\xe1s seguro que quer\xe9s eliminar el mensaje de {0} y todas sus respuestas? El mensaje dice:
  
  "{1}"`,
    messages_report: "Reportar mensaje",
    /* Insights */ insights_title: "Informaci\xf3n del \xe1lbum",
    suggested_price_title: "Precio de venta sugerido",
    genres_title: "G\xe9neros musicales",
    rarity_title: "Rareza de la edici\xf3n",
    credits_title: "Cr\xe9ditos",
    insights_tags_title: "Etiquetas sugeridas",
    insights_disclaimer: "Generado por OpenAI. La informaci\xf3n puede ser inexacta o incorrecta.",
    insights_refresh: "Regenerar informaci\xf3n",
    /* Reports */ report_new: "Nuevo reporte",
    report_description: "Contanos m\xe1s acerca de este reporte:",
    report_success: "\xa1Reporte enviado! Gracias por tu aporte.",
    /* Chats */ chats_title: "Conversaciones",
    chat_placeholder: "Escrib\xed ac\xe1 tu mensaje...",
    chat_send: "Enviar mensaje",
    chat_new: "Enviar un mensaje",
    chat_select: "Seleccion\xe1 una conversaci\xf3n",
    chat_new_user: "Empezar una nueva conversaci\xf3n",
    chat_empty_title: "Todav\xeda no ten\xe9s conversaciones",
    chat_empty_description: "Empez\xe1 a chatear con otros usuarios usando el bot\xf3n en la barra de herramientas",
    public_user_profiles_empty: "Ingres\xe1 un nombre de usuario en la barra de b\xfasqueda para encontrar usuarios",
    chat_messages_empty_title: "Todav\xeda no hay mensajes para mostrar",
    chat_messages_empty_description: "Vas a ver tu historial de mensajes con este usuario cuando empieces la conversaci\xf3n",
    chat_new_message_notification: "Ten\xe9s un nuevo mensaje",
    open_chats_list: "Abrir lista de conversaciones",
    /* Layout */ layout_title: "Mobiliario",
    shelving_title: "Mueble",
    shelvings_title: "Muebles",
    shelving_new_title: "Nuevo mueble",
    shelving_tutorial: "Arrastr\xe1 el lomo del \xe1lbum que ves en la lista hacia cualquiera de los segmentos del mueble para ubicarlo. Arrastr\xe1 los lomos dentro del segmento para reordenarlos. Hac\xe9 click en cualquier \xe1lbum para seleccionarlo y ver su posici\xf3n en el mueble, o click derecho para ver su detalle.",
    shelf_title: "Estante",
    shelf_new_title: "Nuevo estante",
    shelf_segment_title: "Segmento",
    shelf_segment_new_title: "Nuevo segmento",
    shelf_segment_position_title: "Posici\xf3n",
    shelf_segment_image_title: "Imagen de fondo",
    highlight_filtered_albums: "Resaltar \xe1lbumes filtrados",
    shelving_edit_title: "Editar mueble",
    shelf_edit_title: "Editar estante",
    shelf_segment_edit_title: "Editar segmento",
    shelving_orientation: "Orientaci\xf3n del mueble",
    shelving_theme: "Material del mueble",
    shelving_every_album_same_size: "Extender \xe1lbumes para ocupar todo el espacio",
    shelving_cedar: "Cedro",
    shelving_oak: "Roble",
    shelving_ebony: "\xc9bano",
    shelving_walnut: "Nogal",
    shelving_blue: "Azul",
    shelving_name_placeholder: "Ejemplo: Mueble de vinilos",
    shelving_delete_confirmation: `\xbfEst\xe1s seguro de querer eliminar el mueble "{0}"? No vas a perder ning\xfan \xe1lbum asociado a este mueble.`,
    shelf_name_placeholder: "Ejemplo: Estante de arriba",
    shelf_delete_confirmation: `\xbfEst\xe1s seguro de querer eliminar el estante "{0}"? No vas a perder ning\xfan \xe1lbum asociado a este estante.`,
    shelf_segment_name_placeholder: "Ejemplo: Primer segmento",
    shelf_segment_delete_confirmation: `\xbfEst\xe1s seguro de querer eliminar el segmento "{0}" del estante "{1}"? No vas a perder ning\xfan \xe1lbum asociado a este segmento.`,
    empty_shelvings: "Seleccion\xe1 un mueble para mostrarlo",
    empty_shelvings_subtitle: "O agreg\xe1 uno nuevo usando el bot\xf3n de abajo",
    shelf_album_added_message: "\xc1lbum agregado al segmento exitosamente",
    shelf_album_removed_message: "\xc1lbum removido del segmento exitosamente",
    shelf_album_duplicate_error: "\xa1Ya ten\xe9s ese \xe1lbum en ese segmento!",
    shelf_remove_album: "Remover del segmento",
    shelf_remove_all_albums: "Remover todos los \xe1lbumes del segmento",
    shelf_segment_album_shape_title: "Forma del \xe1lbum",
    shelf_segment_album_shape_long_play: "12\u2033",
    shelf_segment_album_shape_ten_inches: "10\u2033",
    shelf_segment_album_shape_single: "7\u2033",
    shelf_segment_album_shape_cd: "CD",
    shelf_segment_album_shape_box_set: "Box set",
    shelf_segment_assign_filtered_albums: "Asignar \xe1lbumes filtrados a este segmento",
    shelf_segment_add_album_title: "Agregar \xe1lbumes",
    shelf_segment_focus_option: "Hacer foco en este segmento",
    album_location_title: "Ubicaci\xf3n",
    album_position_title: "Posici\xf3n",
    layout_cannot_move_message: "Para hacer modificaciones a este mueble, dirigite al Mobiliario.",
    shelving_albums_stats_title: "\xc1lbumes en mueble",
    shelf_albums_stats_title: "\xc1lbumes en estante",
    shelf_segment_albums_stats_title: "\xc1lbumes en segmento",
    layout_remove_from_all_segments: "Eliminar de todas las ubicaciones anteriores",
    /* Listening Sessions */ listening_sessions_title: "Sesiones de escucha",
    open_listening_sessions_list: "Abrir lista de sesiones de escucha",
    /* Passkeys */ passkeys_title: "Llaves de acceso",
    passkey_title: "Llave de acceso",
    passkeys_description: "Todas tus llaves de acceso registradas en Piper est\xe1n en esta lista. Si eliminaste alguna de tu Administrador de Contrase\xf1as, es seguro eliminarlas de esta tabla tambi\xe9n.",
    add_passkey: "Agregar nueva llave de acceso",
    empty_passkeys: "No ten\xe9s llaves de acceso asociadas con tu cuenta",
    passkey_register_success: "\xa1Llave de acceso creada correctamente!",
    passkey_authentication_error: "Ocurri\xf3 un error al intentar ingresar con tu llave de acceso.\n\nAsegurate de que la llave de acceso no haya sido eliminada en Piper. Si es as\xed, vas a tener que crear una nueva llave de acceso.",
    passkey_registration_error: "Ocurri\xf3 un error al intentar crear la llave de acceso. Ten\xe9 en cuenta que si ves la llave de acceso en tu Administrador de Contrase\xf1as igualmente no va a funcionar, as\xed que por favor eliminala e intent\xe1 de nuevo.",
    passkeys_delete_confirmation_message: "Est\xe1s por eliminar esta llave de acceso de los servidores de Piper, lo que significa que va a dejar de funcionar aunque la sigas viendo en tu Administrador de Contrase\xf1as.",
    /* Texts */ documentation: "Documentaci\xf3n",
    doc_home: (0, $240a7a9c42bccc59$export$13b2a7302de30c2),
    doc_albums: (0, $63faa905ff85dcab$export$d84822a6728c7be5),
    doc_users_sign_up: (0, $f56327b2ce3647c8$export$581328f093eda6a9),
    doc_users_guest: (0, $58d94f35e9b68ab3$export$80be07eabf9d7c7e),
    doc_users_recover_password: (0, $8b51cd73284c72a9$export$89ff519bf1b4dd9d),
    doc_filter_albums: (0, $c45459b96187f140$export$af9591c244d34ec9),
    doc_order_albums: (0, $b956a4500e8ce022$export$eb28e192c07f3632),
    doc_import_from_discogs: (0, $aac53b980a1af387$export$8ab68e0958b3d3bd),
    doc_import_from_excel: (0, $71b1ee7ee982d577$export$24eac8f96dd07037),
    doc_image_gallery: (0, $64cb46ca12d83509$export$8a0c644edba3a537),
    doc_marking_albums: (0, $049adb4a51fd8915$export$868a633de15e25dc),
    doc_remove_filtered_albums: (0, $6da4a647e299eaec$export$33014d40429a6813),
    doc_albums_add_barcode: (0, $15e2e4f7850fc401$export$22486095b44254df),
    doc_album_attributes: (0, $c9143242e05fe1a1$export$c09c6fa0036dcab),
    doc_artists: (0, $5efd0962a8d08b80$export$c00be0528feef104),
    doc_collections: (0, $d5e1fcc9d8f35578$export$c2ab2927acb653be),
    doc_collections_attributes: (0, $4f6798881ea73695$export$6471ddaa182c0cf2),
    doc_collections_public_collections: (0, $24d2bdced51c67ba$export$f19dded810f125bc),
    doc_user_profile: (0, $4b3016ae7c9d97e4$export$ea0c4b45a6294ec7),
    doc_subscriptions: (0, $cf1de416c50c095e$export$98cf6ad246dd9743),
    doc_purchases: (0, $b0993d1439cdfed4$export$cce887d9234dd4d5),
    doc_mercado_pago_subscriptions: (0, $7bc39b19ecaa4764$export$da647baf202096e0),
    doc_more_options_title: "M\xe1s cosas que pod\xe9s hacer",
    about_piper: (0, $7b7caaeb7367b9d5$export$91de5eab64071bb0),
    privacy_policy: (0, $edd66397ac9d909c$export$5cc920282035c3b9),
    terms: (0, $b156c324d3b025b1$export$5913f56a875a5231),
    tutorial_video_id: "hBKdnR8effU"
};


const $37bec70ed65ed924$export$21c51bc433c16634 = new (0, $353b7894a13e12ef$export$2e2bcd8739ae039)({
    en: (0, $38926892ea158544$export$37cef7dde5bf419),
    es: (0, $f5d4eb6bcdfda324$export$213dfde9ccf1e1f1)
});


const $669f05caedcc95b9$export$d0fb02d81f923119 = {
    isSuccessful: (statusCode)=>{
        return statusCode >= 200 && statusCode <= 299;
    },
    isSessionExpired: (statusCode)=>{
        return statusCode == 444;
    },
    isOnMaintenance: (statusCode)=>{
        return statusCode == 503;
    },
    isDuplicatedResource: (statusCode)=>{
        return statusCode == 520;
    },
    isLimitReached: (statusCode)=>{
        return statusCode == 403;
    }
};



var $f3eb771fc47795e7$exports = {};
"use strict";
var $f3eb771fc47795e7$var$__createBinding = $f3eb771fc47795e7$exports && $f3eb771fc47795e7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f3eb771fc47795e7$var$__setModuleDefault = $f3eb771fc47795e7$exports && $f3eb771fc47795e7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f3eb771fc47795e7$var$__importStar = $f3eb771fc47795e7$exports && $f3eb771fc47795e7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f3eb771fc47795e7$var$__createBinding(result, mod, k);
    }
    $f3eb771fc47795e7$var$__setModuleDefault(result, mod);
    return result;
};
var $f3eb771fc47795e7$var$__importDefault = $f3eb771fc47795e7$exports && $f3eb771fc47795e7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f3eb771fc47795e7$exports, "__esModule", {
    value: true
});
$f3eb771fc47795e7$exports.createDerivedState = $f3eb771fc47795e7$exports.DerivedState = $f3eb771fc47795e7$exports.useReducer = $f3eb771fc47795e7$exports.useState = $f3eb771fc47795e7$exports.createStore = $f3eb771fc47795e7$exports.Store = $f3eb771fc47795e7$exports.createState = $f3eb771fc47795e7$exports.State = void 0;

var $f3eb771fc47795e7$var$State_1 = $f3eb771fc47795e7$var$__importStar((parcelRequire("fqI9u")));
$f3eb771fc47795e7$exports.State = $f3eb771fc47795e7$var$State_1.default;
Object.defineProperty($f3eb771fc47795e7$exports, "createState", {
    enumerable: true,
    get: function() {
        return $f3eb771fc47795e7$var$State_1.createState;
    }
});
Object.defineProperty($f3eb771fc47795e7$exports, "DerivedState", {
    enumerable: true,
    get: function() {
        return $f3eb771fc47795e7$var$State_1.DerivedState;
    }
});
Object.defineProperty($f3eb771fc47795e7$exports, "createDerivedState", {
    enumerable: true,
    get: function() {
        return $f3eb771fc47795e7$var$State_1.createDerivedState;
    }
});

var $f3eb771fc47795e7$var$Store_1 = $f3eb771fc47795e7$var$__importStar((parcelRequire("l29zL")));
$f3eb771fc47795e7$exports.Store = $f3eb771fc47795e7$var$Store_1.default;
Object.defineProperty($f3eb771fc47795e7$exports, "createStore", {
    enumerable: true,
    get: function() {
        return $f3eb771fc47795e7$var$Store_1.createStore;
    }
});

var $f3eb771fc47795e7$var$useReducer_1 = $f3eb771fc47795e7$var$__importDefault((parcelRequire("9QSlj")));
$f3eb771fc47795e7$exports.useReducer = $f3eb771fc47795e7$var$useReducer_1.default;

var $f3eb771fc47795e7$var$useState_1 = $f3eb771fc47795e7$var$__importDefault((parcelRequire("9bPvI")));
$f3eb771fc47795e7$exports.useState = $f3eb771fc47795e7$var$useState_1.default;
$f3eb771fc47795e7$exports.default = {
    State: $f3eb771fc47795e7$var$State_1.default,
    createState: $f3eb771fc47795e7$var$State_1.createState,
    Store: $f3eb771fc47795e7$var$Store_1.default,
    createStore: $f3eb771fc47795e7$var$Store_1.createStore,
    useState: $f3eb771fc47795e7$var$useState_1.default,
    useReducer: $f3eb771fc47795e7$var$useReducer_1.default,
    DerivedState: $f3eb771fc47795e7$var$State_1.DerivedState,
    createDerivedState: $f3eb771fc47795e7$var$State_1.createDerivedState
};




var $7fPBF = parcelRequire("7fPBF");
const $6e65290b51df31d1$export$4e5a5cc2a3ddf055 = (0, $f3eb771fc47795e7$exports.createState)(()=>{
    const collectionString = localStorage.getItem("currentCollection");
    if (collectionString != null) return JSON.parse(collectionString);
});
const $6e65290b51df31d1$export$e1cfc0d114fc8345 = (0, $f3eb771fc47795e7$exports.createState)(undefined);
const $6e65290b51df31d1$export$1da6a00f03e1826a = ()=>{
    const [currentPrivateCollection] = $6e65290b51df31d1$export$4e5a5cc2a3ddf055.useState();
    const [currentPublicCollection] = $6e65290b51df31d1$export$e1cfc0d114fc8345.useState();
    (0, $7fPBF.useEffect)(()=>{
        if (currentPrivateCollection === undefined) localStorage.removeItem("currentCollection");
        else localStorage.setItem("currentCollection", JSON.stringify(currentPrivateCollection));
    }, [
        currentPrivateCollection
    ]);
    const getCurrentCollection = (isPublic)=>{
        return isPublic ? currentPublicCollection : currentPrivateCollection;
    };
    const isCurrentCollectionShareable = (isPublic)=>{
        if (isPublic) return currentPublicCollection?.visibility == "public";
        return currentPrivateCollection?.visibility == "public";
    };
    return {
        getCurrentCollection: getCurrentCollection,
        isCurrentCollectionShareable: isCurrentCollectionShareable
    };
};




var $7fPBF = parcelRequire("7fPBF");

var $039fe4ac9c9107fb$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($039fe4ac9c9107fb$exports) {
        classNames.default = classNames;
        $039fe4ac9c9107fb$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $16e698ac2bde8f17$export$f04a61298a47a40f = ({ type: type, className: className, style: style, filled: filled = false })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("material-symbols-rounded", className),
        style: {
            fontVariationSettings: `'FILL' ${filled ? 1 : 0}`,
            ...style
        },
        children: type
    });
};


var $d46459dc9cce808d$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["AccountBox"] = "account_box";
    IconType["AccountCircle"] = "account_circle";
    IconType["AccountCircleOff"] = "account_circle_off";
    IconType["Add"] = "add";
    IconType["AddAd"] = "add_ad";
    IconType["AddCircle"] = "add_circle";
    IconType["Album"] = "album";
    IconType["AreaChart"] = "area_chart";
    IconType["ArrowDownwardAlt"] = "arrow_downward_alt";
    IconType["ArrowLeftAlt"] = "arrow_left_alt";
    IconType["ArrowUpwardAlt"] = "arrow_upward_alt";
    IconType["Article"] = "article";
    IconType["Artist"] = "artist";
    IconType["Assignment"] = "assignment";
    IconType["AssignmentInd"] = "assignment_ind";
    IconType["AudioVideoReceiver"] = "audio_video_receiver";
    IconType["Book2"] = "book_2";
    IconType["Box"] = "box";
    IconType["BoxAdd"] = "box_add";
    IconType["BusinessCenter"] = "business_center";
    IconType["Calculate"] = "calculate";
    IconType["CalendarMonth"] = "calendar_month";
    IconType["CameraSwitch"] = "cameraswitch";
    IconType["Campaign"] = "campaign";
    IconType["CardsStar"] = "cards_star";
    IconType["ChatAddOn"] = "chat_add_on";
    IconType["Check"] = "check";
    IconType["CheckBox"] = "check_box";
    IconType["CheckCircle"] = "check_circle";
    IconType["ChevronRight"] = "chevron_right";
    IconType["Close"] = "close";
    IconType["CloudDownload"] = "cloud_download";
    IconType["Compress"] = "compress";
    IconType["ContactEmergency"] = "contact_emergency";
    IconType["ContactMail"] = "contact_mail";
    IconType["ContentCopy"] = "content_copy";
    IconType["ControlCamera"] = "control_camera";
    IconType["CurrencyExchange"] = "currency_exchange";
    IconType["DecimalIncrease"] = "decimal_increase";
    IconType["DeleteForever"] = "delete_forever";
    IconType["DeleteSweep"] = "delete_sweep";
    IconType["Die"] = "ifl";
    IconType["Download"] = "download";
    IconType["Drafts"] = "drafts";
    IconType["DragIndicator"] = "drag_indicator";
    IconType["EditSquare"] = "edit_square";
    IconType["Event"] = "event";
    IconType["Expand"] = "expand";
    IconType["ExpandAll"] = "expand_all";
    IconType["FeatureSearch"] = "feature_search";
    IconType["FilterAlt"] = "filter_alt";
    IconType["FilterAltOff"] = "filter_alt_off";
    IconType["FinanceChip"] = "finance_chip";
    IconType["Flag"] = "flag";
    IconType["Flare"] = "flare";
    IconType["Folder"] = "folder";
    IconType["FormatListNumbered"] = "format_list_numbered";
    IconType["FormsAddOn"] = "forms_add_on";
    IconType["FrameInspect"] = "frame_inspect";
    IconType["GalleryThumbnail"] = "gallery_thumbnail";
    IconType["Genres"] = "genres";
    IconType["Hardware"] = "hardware";
    IconType["Headphones"] = "headphones";
    IconType["Hearing"] = "hearing";
    IconType["Help"] = "help";
    IconType["HistoryEdu"] = "history_edu";
    IconType["ImageSearch"] = "image_search";
    IconType["ImportContacts"] = "import_contacts";
    IconType["Inbox"] = "inbox";
    IconType["Info"] = "info";
    IconType["Keep"] = "keep";
    IconType["KeepOff"] = "keep_off";
    IconType["Key"] = "key";
    IconType["KeyboardArrowDown"] = "keyboard_arrow_down";
    IconType["KeyboardArrowUp"] = "keyboard_arrow_up";
    IconType["KeyboardDoubleArrowDown"] = "keyboard_double_arrow_down";
    IconType["KeyboardDoubleArrowLeft"] = "keyboard_double_arrow_left";
    IconType["KeyboardDoubleArrowRight"] = "keyboard_double_arrow_right";
    IconType["KeyboardDoubleArrowUp"] = "keyboard_double_arrow_up";
    IconType["KidStar"] = "kid_star";
    IconType["LaptopMac"] = "laptop_mac";
    IconType["LayersClear"] = "layers_clear";
    IconType["LibraryAdd"] = "library_add";
    IconType["ListAlt"] = "list_alt";
    IconType["LocalMall"] = "local_mall";
    IconType["Login"] = "login";
    IconType["Logout"] = "logout";
    IconType["Lyrics"] = "lyrics";
    IconType["Mail"] = "mail";
    IconType["MarkAsUnread"] = "mark_as_unread";
    IconType["Memory"] = "memory";
    IconType["Menu"] = "menu";
    IconType["MenuOpen"] = "menu_open";
    IconType["ModelTraining"] = "model_training";
    IconType["MoreVertical"] = "more_vert";
    IconType["MusicCast"] = "music_cast";
    IconType["OpenInNew"] = "open_in_new";
    IconType["Paid"] = "paid";
    IconType["Palette"] = "palette";
    IconType["Passkey"] = "passkey";
    IconType["PersonAdd"] = "person_add";
    IconType["Photo"] = "photo";
    IconType["PhotoCamera"] = "photo_camera";
    IconType["Pin"] = "pin";
    IconType["PlayCircle"] = "play_circle";
    IconType["PlaylistAdd"] = "playlist_add";
    IconType["PriceChange"] = "price_change";
    IconType["Public"] = "public";
    IconType["QRCode2"] = "qr_code_2";
    IconType["QRCode2Add"] = "qr_code_2_add";
    IconType["Refresh"] = "refresh";
    IconType["Remove"] = "remove";
    IconType["Reply"] = "reply";
    IconType["Rotate90DegreesCcw"] = "rotate_90_degrees_ccw";
    IconType["Routine"] = "routine";
    IconType["Save"] = "save";
    IconType["Search"] = "search";
    IconType["Sell"] = "sell";
    IconType["Settings"] = "settings";
    IconType["Share"] = "share";
    IconType["Shelves"] = "shelves";
    IconType["ShoppingBasket"] = "shopping_basket";
    IconType["SpeakerGroup"] = "speaker_group";
    IconType["Stacks"] = "stacks";
    IconType["Star"] = "star";
    IconType["Store"] = "store";
    IconType["TabInactive"] = "tab_inactive";
    IconType["ThreeDimensionalRotation"] = "3d_rotation";
    IconType["Timer"] = "timer";
    IconType["Today"] = "today";
    IconType["Translate"] = "translate";
    IconType["TravelExplore"] = "travel_explore";
    IconType["Visibility"] = "visibility";
    IconType["Wallet"] = "wallet";
    IconType["ZoomIn"] = "zoom_in";
    return IconType;
}({});




class $6768c4f2093234f5$export$8b8c5dbc2df0a942 {
    constructor(title, filterType, isFromCatering, canBeNegated, elementId, textValue, placeholder){
        this.title = title;
        this.placeholder = placeholder;
        this.filterType = filterType;
        this.elementId = elementId;
        this.textValue = textValue;
        this.isFromCatering = isFromCatering;
        this.canBeNegated = canBeNegated;
        this.iconType = $6768c4f2093234f5$export$3894ae6cb770fb5d[filterType];
    }
    static copy(filterElement) {
        return new $6768c4f2093234f5$export$8b8c5dbc2df0a942(filterElement.title, filterElement.filterType, false, filterElement.canBeNegated, filterElement.elementId, filterElement.textValue, filterElement.placeholder);
    }
    static queryItems(filterElements, sortOption, sortOrder) {
        const queryItems = {
            sortOption: sortOption ?? "artist",
            sortOrder: sortOrder ?? "asc"
        };
        filterElements.forEach((filterElement)=>{
            const value = filterElement.elementId;
            if (value === undefined && filterElement.filterType != "searchText") {
                queryItems.isNull = queryItems.isNull === undefined ? filterElement.filterType : queryItems.isNull + `,${filterElement.filterType}`;
                return;
            }
            const oldValue = queryItems[filterElement.filterType];
            if (oldValue) {
                if (Array.isArray(oldValue)) queryItems[filterElement.filterType] = [
                    ...oldValue,
                    value
                ];
                else queryItems[filterElement.filterType] = [
                    oldValue,
                    value
                ];
            } else queryItems[filterElement.filterType] = value;
        });
        return queryItems;
    }
}
var $6768c4f2093234f5$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["IS_GATEFOLD"] = "isGatefold";
    FilterType["HAS_INSERT"] = "hasInsert";
    FilterType["HAS_LYRICS"] = "hasLyrics";
    FilterType["IS_CLEAN"] = "isClean";
    FilterType["STORE"] = "storeId";
    FilterType["LABEL"] = "labelId";
    FilterType["IMPACT"] = "impactId";
    FilterType["SLEEVE_GRADE"] = "sleeveGradeId";
    FilterType["MEDIA_GRADE"] = "mediaGradeId";
    FilterType["SELL_VALUE"] = "sellValueId";
    FilterType["ARTIST"] = "artistId";
    FilterType["ALBUM_TYPE"] = "albumTypeId";
    FilterType["ALBUM_FORMAT"] = "albumFormatId";
    FilterType["COUNTRY"] = "originCountryId";
    FilterType["RELEASE_YEAR"] = "releaseYear";
    FilterType["ORIGINAL_YEAR"] = "originalYear";
    FilterType["SELL_STATUS"] = "sellStatus";
    FilterType["TAG"] = "tagId";
    FilterType["SEARCH_TEXT"] = "searchText";
    FilterType["BOX_SET"] = "isBoxSet";
    return FilterType;
}({});
const $6768c4f2093234f5$export$3894ae6cb770fb5d = {
    ["artistId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Artist,
    ["labelId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MusicCast,
    ["albumFormatId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ControlCamera,
    ["albumTypeId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Album,
    ["sleeveGradeId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CheckBox,
    ["mediaGradeId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CheckCircle,
    ["storeId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Store,
    ["sellValueId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PriceChange,
    ["impactId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Star,
    ["tagId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Sell,
    ["originCountryId"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Flag,
    ["isGatefold"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ImportContacts,
    ["isClean"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Hearing,
    ["hasInsert"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Photo,
    ["hasLyrics"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Lyrics,
    ["releaseYear"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Event,
    ["originalYear"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Event,
    ["sellStatus"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Keep,
    ["isBoxSet"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Box,
    ["searchText"]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Search
};
var $6768c4f2093234f5$export$269d0e320e5ce63c = /*#__PURE__*/ function(FilterSortOption) {
    FilterSortOption["ARTIST"] = "artist";
    FilterSortOption["LABEL"] = "label";
    FilterSortOption["ORIGINAL_YEAR"] = "originalYear";
    FilterSortOption["RELEASE_YEAR"] = "releaseYear";
    FilterSortOption["STORE"] = "store";
    FilterSortOption["COUNTRY"] = "originCountry";
    FilterSortOption["PURCHASE_PRICE"] = "purchasePrice";
    FilterSortOption["SELL_VALUE"] = "sellValue";
    FilterSortOption["SELL_VALUE_DOLLARS"] = "sellValueDollars";
    FilterSortOption["REVENUE"] = "revenue";
    FilterSortOption["PURCHASE_DATE"] = "purchaseDate";
    FilterSortOption["TRACK_COUNT"] = "trackCount";
    FilterSortOption["LENGTH"] = "length";
    FilterSortOption["RANDOM"] = "random";
    return FilterSortOption;
}({});
var $6768c4f2093234f5$export$145a24076dc97919 = /*#__PURE__*/ function(FilterSortOrder) {
    FilterSortOrder["ASCENDANT"] = "asc";
    FilterSortOrder["DESCENDANT"] = "desc";
    return FilterSortOrder;
}({});



var $7fPBF = parcelRequire("7fPBF");
function $3c32b049e9065866$export$79f3cf326dbd2413(array, fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
}
function $3c32b049e9065866$export$874a2b636708da2d(array, fromIndex, toIndex) {
    array = [
        ...array
    ];
    $3c32b049e9065866$export$79f3cf326dbd2413(array, fromIndex, toIndex);
    return array;
}





const $4e580a0edacd4a22$export$f22e7fe56db8ae03 = (str, ...args)=>str.replace(/{(\d+)}/g, (match, index)=>args[index] || "");
const $4e580a0edacd4a22$export$d07f57595c356899 = (string)=>{
    return string.charAt(0).toUpperCase() + string.slice(1);
};
const $4e580a0edacd4a22$export$bdfef6425db7c64 = (input)=>{
    // Create a hash from the string
    let hash = 0;
    for(let i = 0; i < input.length; i++)hash = input.charCodeAt(i) + ((hash << 5) - hash);
    // Convert hash to HSL values
    const hue = Math.abs(hash) % 360; // Full hue range
    const saturation = 40; // Low saturation = pastel
    const lightness = 40; // High lightness = pastel
    return $4e580a0edacd4a22$var$hslToHex(hue, saturation, lightness);
};
const $4e580a0edacd4a22$var$hslToHex = (h, s, l)=>{
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    const r = Math.round(255 * f(0));
    const g = Math.round(255 * f(8));
    const b = Math.round(255 * f(4));
    return `#${[
        r,
        g,
        b
    ].map((x)=>x.toString(16).padStart(2, "0")).join("")}`;
};




var $gSkQi = parcelRequire("gSkQi");
const $ed2696669ec840aa$export$b6b6f25bf8e344eb = {
    getRevenue: (album)=>{
        if (album.purchasePriceToday === undefined || album.sellValue?.pesos === undefined) return undefined;
        return album.sellValue.pesos - album.purchasePriceToday;
    },
    getSubtitle: (album)=>{
        const quantitiesSubtitle = $ed2696669ec840aa$export$b6b6f25bf8e344eb.getQuantitiesSubtitle(album);
        let yearSubtitle = album.originalYear ?? undefined;
        if (album.releaseYear && album.releaseYear != album.originalYear) {
            if (yearSubtitle) yearSubtitle += ` (${album.releaseYear})`;
            else yearSubtitle = `(${album.releaseYear})`;
        }
        let albumTypeSubtitle = undefined;
        if (album.albumType && album.albumType.showOnAlbumList) albumTypeSubtitle = album.albumType.name;
        let countrySubtitle = undefined;
        if (album.originCountry) countrySubtitle = album.originCountry.country?.isoCode ?? album.originCountry.name;
        const subtitles = [
            quantitiesSubtitle,
            yearSubtitle,
            albumTypeSubtitle,
            countrySubtitle
        ].filter((element)=>element !== undefined);
        return subtitles.join(" \u2022 ");
    },
    getQuantitiesSubtitle: (album)=>{
        const discs = album.albumContents?.filter((albumContent)=>albumContent.type == "disc");
        const elements = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).groupBy(discs, (albumContent)=>albumContent.albumFormatId);
        let result = album.isBoxSet ? $ed2696669ec840aa$export$b6b6f25bf8e344eb.getBoxSetQuantitiesSubtitle(album) : "";
        for(const key in elements){
            const discs = elements[key];
            const quantity = discs.reduce((a, b)=>a + b.quantity, 0);
            const albumFormat = discs[0].albumFormat;
            let albumFormatString = albumFormat?.shortName ?? (0, $4e580a0edacd4a22$export$d07f57595c356899)((0, $37bec70ed65ed924$export$21c51bc433c16634).disc_singular);
            if (quantity > 1) albumFormatString += (0, $37bec70ed65ed924$export$21c51bc433c16634).plural_indicator;
            const quantityText = quantity > 0 ? `${quantity}\xd7` : "";
            result += `${quantityText}${albumFormatString} + `;
        }
        if (result == "") return undefined;
        return result.slice(0, -3);
    },
    getBoxSetQuantitiesSubtitle: (album)=>{
        if (album.boxSetAlbums?.length == 0) return "";
        const albumsString = album.boxSetAlbums?.length == 1 ? (0, $37bec70ed65ed924$export$21c51bc433c16634).album_title : (0, $4e580a0edacd4a22$export$d07f57595c356899)((0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural);
        return `${album.boxSetAlbums?.length}\xd7${albumsString} + `;
    },
    getAllSellStatuses: ()=>{
        return [
            "reserved",
            "sold",
            "upcoming",
            "new",
            "highlighted"
        ];
    },
    getSellStatusDescription: (sellStatus)=>{
        switch(sellStatus){
            case "highlighted":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_highlighted;
            case "new":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_new;
            case "reserved":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_reserved;
            case "sold":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_sold;
            case "upcoming":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_upcoming;
        }
    },
    getSellStatusBackgroundColor: (theme, sellStatus)=>{
        switch(sellStatus){
            case "highlighted":
                return theme.palette.colors?.discount;
            case "new":
                return theme.palette.colors?.discount;
            case "reserved":
                return theme.palette.colors?.disabled;
            case "sold":
                return theme.palette.colors?.remove;
            case "upcoming":
                return theme.palette.colors?.discount;
        }
    },
    isOwner: (album, user)=>{
        return user.role == "admin" && album.userId == null || album.userId == user.uuid;
    },
    getShapeRelativeSize: (shape)=>{
        switch(shape){
            case "longPlay":
                return "96%";
            case "tenInches":
                return "80%";
            case "boxSet":
                return "98%";
            case "single":
                return "56%";
            case "compactDisc":
                return "40%";
        }
    },
    getSpineImage: (album)=>{
        return album.albumImages?.filter((albumImage)=>albumImage.kind == "spine")[0];
    }
};


const $9814b23db5adb339$var$zeroPad = (number, places)=>String(number).padStart(places, "0");
const $9814b23db5adb339$export$8bb95198b45adaac = {
    getSeconds: (formattedTime)=>{
        const split = formattedTime.split(":");
        let seconds = 0;
        let multiplier = 1;
        while(split.length > 0){
            seconds += multiplier * parseInt(split.pop() ?? "", 10);
            multiplier *= 60;
        }
        return seconds;
    },
    getStringForDisplay: (seconds)=>{
        // 1 hour
        if (seconds >= 3600) return $9814b23db5adb339$export$8bb95198b45adaac.toHHMMSS(seconds);
        return $9814b23db5adb339$export$8bb95198b45adaac.toMMSS(seconds);
    },
    toHHMMSS: (seconds)=>{
        const hours = Math.floor(seconds / 3600);
        const aux = seconds % 3600;
        const minutes = Math.floor(aux / 60);
        const newSeconds = seconds % 60;
        return `${$9814b23db5adb339$var$zeroPad(hours, 2)}:${$9814b23db5adb339$var$zeroPad(minutes, 2)}:${$9814b23db5adb339$var$zeroPad(newSeconds, 2)}`;
    },
    toMMSS: (seconds)=>{
        const minutes = Math.floor(seconds / 60);
        const newSeconds = seconds % 60;
        return `${minutes}:${$9814b23db5adb339$var$zeroPad(newSeconds, 2)}`;
    },
    getCanonicalTimestamp: (unixTimestamp)=>{
        if (!unixTimestamp) return undefined;
        const date = new Date(unixTimestamp * 1000);
        date.setHours(0, 0, 0, 0);
        return date.getTime();
    }
};



const $0c219628a05c8d21$export$b30eb83740a1d47a = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderAlbums = (albums)=>{
        const sortedUuids = albums.map((album)=>album.uuid);
        return post("albums/reorder", {
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderAlbums: reorderAlbums
    };
};



var $7fPBF = parcelRequire("7fPBF");
function $9eb0bebc322427c8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $9eb0bebc322427c8$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $9eb0bebc322427c8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $9eb0bebc322427c8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9eb0bebc322427c8$export$2e2bcd8739ae039 = $9eb0bebc322427c8$export$4f5d2d50c9deca37;


"use client";
var $040541d7bfcee3b2$var$L = (t)=>typeof t == "number" && !isNaN(t), $040541d7bfcee3b2$var$N = (t)=>typeof t == "string", $040541d7bfcee3b2$var$P = (t)=>typeof t == "function", $040541d7bfcee3b2$var$ut = (t)=>$040541d7bfcee3b2$var$N(t) || $040541d7bfcee3b2$var$L(t), $040541d7bfcee3b2$var$z = (t)=>$040541d7bfcee3b2$var$N(t) || $040541d7bfcee3b2$var$P(t) ? t : null, $040541d7bfcee3b2$var$yt = (t, o)=>t === !1 || $040541d7bfcee3b2$var$L(t) && t > 0 ? t : o, $040541d7bfcee3b2$var$F = (t)=>(0, $7fPBF.isValidElement)(t) || $040541d7bfcee3b2$var$N(t) || $040541d7bfcee3b2$var$P(t) || $040541d7bfcee3b2$var$L(t);
function $040541d7bfcee3b2$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $040541d7bfcee3b2$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $7fPBF.useRef)(0);
        return (0, $7fPBF.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $7fPBF.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $040541d7bfcee3b2$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, s);
    };
}
function $040541d7bfcee3b2$var$tt(t, o) {
    return {
        content: $040541d7bfcee3b2$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $040541d7bfcee3b2$var$ot(t, o, e = !1) {
    return (0, $7fPBF.isValidElement)(t) && !$040541d7bfcee3b2$var$N(t.type) ? (0, $7fPBF.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $040541d7bfcee3b2$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $040541d7bfcee3b2$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $040541d7bfcee3b2$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $040541d7bfcee3b2$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $040541d7bfcee3b2$var$Qt = 1, $040541d7bfcee3b2$var$st = ()=>`${$040541d7bfcee3b2$var$Qt++}`;
function $040541d7bfcee3b2$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($040541d7bfcee3b2$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($040541d7bfcee3b2$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $040541d7bfcee3b2$var$z(n.className || f.toastClassName),
                progressClassName: $040541d7bfcee3b2$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $040541d7bfcee3b2$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $040541d7bfcee3b2$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $040541d7bfcee3b2$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $040541d7bfcee3b2$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $040541d7bfcee3b2$var$I = new Map, $040541d7bfcee3b2$var$U = [], $040541d7bfcee3b2$var$rt = new Set, $040541d7bfcee3b2$var$Wt = (t)=>$040541d7bfcee3b2$var$rt.forEach((o)=>o(t)), $040541d7bfcee3b2$var$ht = ()=>$040541d7bfcee3b2$var$I.size > 0;
function $040541d7bfcee3b2$var$Gt() {
    $040541d7bfcee3b2$var$U.forEach((t)=>$040541d7bfcee3b2$var$nt(t.content, t.options)), $040541d7bfcee3b2$var$U = [];
}
var $040541d7bfcee3b2$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $040541d7bfcee3b2$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $040541d7bfcee3b2$var$X(t, o) {
    var r;
    if (o) return !!((r = $040541d7bfcee3b2$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $040541d7bfcee3b2$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $040541d7bfcee3b2$var$xt(t) {
    if (!$040541d7bfcee3b2$var$ht()) {
        $040541d7bfcee3b2$var$U = $040541d7bfcee3b2$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $040541d7bfcee3b2$var$ut(t)) $040541d7bfcee3b2$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $040541d7bfcee3b2$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $040541d7bfcee3b2$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $040541d7bfcee3b2$var$Et = (t = {})=>{
    $040541d7bfcee3b2$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $040541d7bfcee3b2$var$nt(t, o) {
    $040541d7bfcee3b2$var$F(t) && ($040541d7bfcee3b2$var$ht() || $040541d7bfcee3b2$var$U.push({
        content: t,
        options: o
    }), $040541d7bfcee3b2$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $040541d7bfcee3b2$var$Pt(t) {
    var o;
    (o = $040541d7bfcee3b2$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $040541d7bfcee3b2$var$it(t, o) {
    $040541d7bfcee3b2$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $040541d7bfcee3b2$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $040541d7bfcee3b2$var$vt(o, t, $040541d7bfcee3b2$var$Wt);
            $040541d7bfcee3b2$var$I.set(o, r);
            let a = r.observe(e);
            return $040541d7bfcee3b2$var$Gt(), ()=>{
                a(), $040541d7bfcee3b2$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $040541d7bfcee3b2$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $040541d7bfcee3b2$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $040541d7bfcee3b2$var$St(t) {
    return $040541d7bfcee3b2$var$rt.add(t), ()=>{
        $040541d7bfcee3b2$var$rt.delete(t);
    };
}
function $040541d7bfcee3b2$var$qt(t) {
    return t && ($040541d7bfcee3b2$var$N(t.toastId) || $040541d7bfcee3b2$var$L(t.toastId)) ? t.toastId : $040541d7bfcee3b2$var$st();
}
function $040541d7bfcee3b2$var$H(t, o) {
    return $040541d7bfcee3b2$var$nt(t, o), o.toastId;
}
function $040541d7bfcee3b2$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $040541d7bfcee3b2$var$qt(o)
    };
}
function $040541d7bfcee3b2$var$W(t) {
    return (o, e)=>$040541d7bfcee3b2$var$H(o, $040541d7bfcee3b2$var$Q(t, e));
}
function $040541d7bfcee3b2$export$b410431fab84fa58(t, o) {
    return $040541d7bfcee3b2$var$H(t, $040541d7bfcee3b2$var$Q("default", o));
}
$040541d7bfcee3b2$export$b410431fab84fa58.loading = (t, o)=>$040541d7bfcee3b2$var$H(t, $040541d7bfcee3b2$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $040541d7bfcee3b2$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $040541d7bfcee3b2$var$N(o) ? $040541d7bfcee3b2$export$b410431fab84fa58.loading(o, a) : $040541d7bfcee3b2$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $040541d7bfcee3b2$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $040541d7bfcee3b2$var$N(g) ? {
            render: g
        } : g;
        return l ? $040541d7bfcee3b2$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $040541d7bfcee3b2$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $040541d7bfcee3b2$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$040541d7bfcee3b2$export$b410431fab84fa58.promise = $040541d7bfcee3b2$var$Kt;
$040541d7bfcee3b2$export$b410431fab84fa58.success = $040541d7bfcee3b2$var$W("success");
$040541d7bfcee3b2$export$b410431fab84fa58.info = $040541d7bfcee3b2$var$W("info");
$040541d7bfcee3b2$export$b410431fab84fa58.error = $040541d7bfcee3b2$var$W("error");
$040541d7bfcee3b2$export$b410431fab84fa58.warning = $040541d7bfcee3b2$var$W("warning");
$040541d7bfcee3b2$export$b410431fab84fa58.warn = $040541d7bfcee3b2$export$b410431fab84fa58.warning;
$040541d7bfcee3b2$export$b410431fab84fa58.dark = (t, o)=>$040541d7bfcee3b2$var$H(t, $040541d7bfcee3b2$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $040541d7bfcee3b2$var$Yt(t) {
    $040541d7bfcee3b2$var$xt(t);
}
$040541d7bfcee3b2$export$b410431fab84fa58.dismiss = $040541d7bfcee3b2$var$Yt;
$040541d7bfcee3b2$export$b410431fab84fa58.clearWaitingQueue = $040541d7bfcee3b2$var$Et;
$040541d7bfcee3b2$export$b410431fab84fa58.isActive = $040541d7bfcee3b2$var$X;
$040541d7bfcee3b2$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $040541d7bfcee3b2$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $040541d7bfcee3b2$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $040541d7bfcee3b2$var$H(s, l);
    }
};
$040541d7bfcee3b2$export$b410431fab84fa58.done = (t)=>{
    $040541d7bfcee3b2$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$040541d7bfcee3b2$export$b410431fab84fa58.onChange = $040541d7bfcee3b2$var$St;
$040541d7bfcee3b2$export$b410431fab84fa58.play = (t)=>$040541d7bfcee3b2$var$it(!0, t);
$040541d7bfcee3b2$export$b410431fab84fa58.pause = (t)=>$040541d7bfcee3b2$var$it(!1, t);
function $040541d7bfcee3b2$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $7fPBF.useRef)($040541d7bfcee3b2$var$It(t)).current;
    r(t);
    let a = (s = (0, $7fPBF.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $040541d7bfcee3b2$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $040541d7bfcee3b2$var$Nt(t) {
    let [o, e] = (0, $7fPBF.useState)(!1), [r, a] = (0, $7fPBF.useState)(!1), l = (0, $7fPBF.useRef)(null), s = (0, $7fPBF.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $040541d7bfcee3b2$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $7fPBF.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $040541d7bfcee3b2$var$G = typeof window != "undefined" ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
var $040541d7bfcee3b2$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $040541d7bfcee3b2$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $040541d7bfcee3b2$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $040541d7bfcee3b2$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $040541d7bfcee3b2$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $040541d7bfcee3b2$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $040541d7bfcee3b2$export$4f13f83fd8bb1dac = {
    info: $040541d7bfcee3b2$var$no,
    warning: $040541d7bfcee3b2$var$ro,
    success: $040541d7bfcee3b2$var$io,
    error: $040541d7bfcee3b2$var$lo,
    spinner: $040541d7bfcee3b2$var$fo
}, $040541d7bfcee3b2$var$co = (t)=>t in $040541d7bfcee3b2$export$4f13f83fd8bb1dac;
function $040541d7bfcee3b2$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($040541d7bfcee3b2$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $7fPBF.isValidElement)(r) ? a = (0, $7fPBF.cloneElement)(r, l) : e ? a = $040541d7bfcee3b2$export$4f13f83fd8bb1dac.spinner() : $040541d7bfcee3b2$var$co(o) && (a = $040541d7bfcee3b2$export$4f13f83fd8bb1dac[o](l))), a;
}
var $040541d7bfcee3b2$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $040541d7bfcee3b2$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $040541d7bfcee3b2$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)(M, E), mt = $040541d7bfcee3b2$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($040541d7bfcee3b2$var$P(s) ? V = s(Z) : (0, $7fPBF.isValidElement)(s) ? V = (0, $7fPBF.cloneElement)(s, Z) : V = $040541d7bfcee3b2$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $040541d7bfcee3b2$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $040541d7bfcee3b2$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $040541d7bfcee3b2$export$d20e79fdc3899e95 = $040541d7bfcee3b2$export$3ff7dc44d332d222($040541d7bfcee3b2$var$j("bounce", !0)), $040541d7bfcee3b2$export$d8dc01b5c85a37b9 = $040541d7bfcee3b2$export$3ff7dc44d332d222($040541d7bfcee3b2$var$j("slide", !0)), $040541d7bfcee3b2$export$65cfd44a2050f99 = $040541d7bfcee3b2$export$3ff7dc44d332d222($040541d7bfcee3b2$var$j("zoom")), $040541d7bfcee3b2$export$4d2fae537bd90431 = $040541d7bfcee3b2$export$3ff7dc44d332d222($040541d7bfcee3b2$var$j("flip"));
var $040541d7bfcee3b2$var$vo = {
    position: "top-right",
    transition: $040541d7bfcee3b2$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $040541d7bfcee3b2$var$dt(t) {
    let o = {
        ...$040541d7bfcee3b2$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $7fPBF.useState)(!0), l = (0, $7fPBF.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $040541d7bfcee3b2$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $040541d7bfcee3b2$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $9eb0bebc322427c8$export$2e2bcd8739ae039)(p, $040541d7bfcee3b2$var$z(T));
    }
    function E() {
        e && (a(!0), $040541d7bfcee3b2$export$b410431fab84fa58.play());
    }
    return $040541d7bfcee3b2$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $7fPBF.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $040541d7bfcee3b2$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $040541d7bfcee3b2$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $040541d7bfcee3b2$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $040541d7bfcee3b2$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $040541d7bfcee3b2$var$$t = new Map, $040541d7bfcee3b2$var$Rt = (t, o)=>{
    $040541d7bfcee3b2$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $040541d7bfcee3b2$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $040541d7bfcee3b2$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $040541d7bfcee3b2$export$f2815235e76a62b9(t) {
    return $040541d7bfcee3b2$var$Rt($040541d7bfcee3b2$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($040541d7bfcee3b2$var$dt, {
        ...t
    });
}



const $c4f51e0bfb342785$export$30e3b84d95295bc3 = (isActive, mode, isFiltering, isNegated, pageSize, backendRequest, onLoading, onError, shareLink, filterElements, sortOption, sortOrder, dependencies = [])=>{
    const [albums, setAlbums] = (0, $7fPBF.useState)(undefined);
    const [currentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [lastUuid, setLastUuid] = (0, $7fPBF.useState)();
    const [isFetching, setIsFetching] = (0, $7fPBF.useState)(false);
    const [noMoreAlbums, setNoMoreAlbums] = (0, $7fPBF.useState)(false);
    const { reorderAlbums: reorderAlbums } = (0, $0c219628a05c8d21$export$b30eb83740a1d47a)();
    const sortAlbums = (body)=>{
        switch(sortOption){
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST:
                sortAlbumsByArtist(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LABEL:
                sortAlbumsByLabel(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ORIGINAL_YEAR:
                sortAlbumsByOriginalYear(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RELEASE_YEAR:
                sortAlbumsByReleaseYear(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).STORE:
                sortAlbumsByStore(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).COUNTRY:
                sortAlbumsByCountry(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_PRICE:
                sortAlbumsByPurchasePrice(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE:
                sortAlbumsBySellValue(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE_DOLLARS:
                sortAlbumsBySellValueDollars(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).REVENUE:
                sortAlbumsByRevenue(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_DATE:
                sortAlbumsByPurchaseDate(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).TRACK_COUNT:
                sortAlbumsByTrackCount(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LENGTH:
                sortAlbumsByLength(body);
                break;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM:
                sortAlbumsByRandom(body);
                break;
            case undefined:
                sortAlbumsByArtist(body);
                break;
        }
    };
    const sortAlbumsByArtist = (body)=>{
        let lastArtist = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastArtist = newAlbums[lastSection - 1][0].artist?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastArtist != (album.artist?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastArtist = album.artist?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByRandom = (body)=>{
        if (albums) return;
        const newAlbums = [];
        if (body.length > 0) newAlbums[0] = body;
        setAlbums(newAlbums);
        setNoMoreAlbums(true);
    };
    const sortAlbumsByLabel = (body)=>{
        let lastLabel = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastLabel = newAlbums[lastSection - 1][0].label?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastLabel != (album.label?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastLabel = album.label?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByOriginalYear = (body)=>{
        let lastOriginalYear = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastOriginalYear = newAlbums[lastSection - 1][0].originalYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastOriginalYear != (album.originalYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastOriginalYear = album.originalYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByReleaseYear = (body)=>{
        let lastReleaseYear = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastReleaseYear = newAlbums[lastSection - 1][0].releaseYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastReleaseYear != (album.releaseYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastReleaseYear = album.releaseYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByStore = (body)=>{
        let lastStore = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastStore = newAlbums[lastSection - 1][0].store?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastStore != (album.store?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastStore = album.store?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByCountry = (body)=>{
        let lastCountry = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastCountry = newAlbums[lastSection - 1][0].originCountry?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastCountry != (album.originCountry?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastCountry = album.originCountry?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByPurchasePrice = (body)=>{
        let lastPurchasePrice = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastPurchasePrice = newAlbums[lastSection - 1][0].purchasePriceDollars?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastPurchasePrice != (album.purchasePriceDollars?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastPurchasePrice = album.purchasePriceDollars?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsBySellValue = (body)=>{
        let lastSellValue = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastSellValue = newAlbums[lastSection - 1][0].sellValue?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastSellValue != (album.sellValue?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastSellValue = album.sellValue?.uuid ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsBySellValueDollars = (body)=>{
        let lastDollars = -1;
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastDollars = newAlbums[lastSection - 1][0].sellValue?.dollars ?? 0;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastDollars != (album.sellValue?.dollars ?? 0)) {
                lastDollars = album.sellValue?.dollars ?? 0;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByRevenue = (body)=>{
        let lastRevenue = "";
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastRevenue = (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getRevenue(newAlbums[lastSection - 1][0])?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastRevenue != ((0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getRevenue(album)?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown)) {
                lastRevenue = (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getRevenue(album)?.toFixed() ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByPurchaseDate = (body)=>{
        let lastPurchaseDate = -1;
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastPurchaseDate = (0, $9814b23db5adb339$export$8bb95198b45adaac).getCanonicalTimestamp(newAlbums[lastSection - 1][0].purchaseDate) ?? 0;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastPurchaseDate !== ((0, $9814b23db5adb339$export$8bb95198b45adaac).getCanonicalTimestamp(album.purchaseDate) ?? 0)) {
                lastPurchaseDate = (0, $9814b23db5adb339$export$8bb95198b45adaac).getCanonicalTimestamp(album.purchaseDate) ?? 0;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByTrackCount = (body)=>{
        let lastTrackCount = -1;
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastTrackCount = newAlbums[lastSection - 1][0].tracks ?? 0;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastTrackCount != (album.tracks ?? 0)) {
                lastTrackCount = album.tracks ?? 0;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    const sortAlbumsByLength = (body)=>{
        let lastLength = -1;
        let section = -1;
        const lastSection = albums?.length ?? 0;
        const newAlbums = albums ?? [];
        if (lastSection > 0) {
            lastLength = newAlbums[lastSection - 1][0].length ?? 0;
            section = lastSection - 1;
        }
        body.forEach((album)=>{
            if (lastLength != (album.length ?? 0)) {
                lastLength = album.length ?? 0;
                section += 1;
            }
            if (newAlbums[section]) newAlbums[section]?.push(album);
            else newAlbums[section] = [
                album
            ];
        });
        setAlbums(newAlbums);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isFetching || noMoreAlbums || !isActive) return;
        switch(mode){
            case "private":
                fetchAlbums(currentPrivateCollection);
                break;
            case "public":
                if (!shareLink) return;
                const publicCollection = currentPublicCollection;
                if (publicCollection) fetchAlbums(publicCollection);
                break;
            case "desktop":
                fetchAlbums(undefined);
                break;
        }
    }, dependencies);
    const fetchAlbums = (collection)=>{
        let ignoreResponse = false;
        setIsFetching(true);
        onLoading(true);
        backendRequest({
            lastUuid: lastUuid,
            pageSize: pageSize,
            collectionId: collection?.uuid,
            isFiltering: isFiltering,
            isNegated: isNegated
        }, (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942).queryItems(filterElements, sortOption, sortOrder)).then(({ body: body, status: status })=>{
            if (ignoreResponse) return;
            if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                onLoading(false);
                onError(body);
                setNoMoreAlbums(true);
                setIsFetching(false);
                return;
            }
            if (!body) return;
            if (body.length > 0) setLastUuid(body.slice(-1)[0].uuid);
            setNoMoreAlbums(body.length < pageSize);
            sortAlbums(body);
            setIsFetching(false);
            onLoading(false);
        });
        return ()=>{
            ignoreResponse = true;
        };
    };
    const resetAlbumStorage = ()=>{
        setNoMoreAlbums(false);
        setAlbums(undefined);
        setLastUuid(undefined);
    };
    const moveAlbum = async (section, source, destination)=>{
        if (!albums) return;
        (0, $3c32b049e9065866$export$79f3cf326dbd2413)(albums[section], source, destination);
        onLoading(true);
        const { status: status } = await reorderAlbums(albums[section]);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setAlbums(albums.map((albumList, index)=>{
                if (index == section) return albumList.map((album, index)=>{
                    album.order = index;
                    return album;
                });
                return albumList;
            }));
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_error);
            (0, $3c32b049e9065866$export$79f3cf326dbd2413)(albums[section], destination, source);
        }
        onLoading(false);
    };
    const deleteAlbum = (section, row)=>{
        if (!albums) return;
        albums[section].splice(row, 1);
        if (albums[section].length == 0) albums.splice(section, 1);
    };
    return [
        albums,
        setAlbums,
        resetAlbumStorage,
        moveAlbum,
        deleteAlbum,
        noMoreAlbums,
        isFetching
    ];
};
const $c4f51e0bfb342785$export$83592602d06445ed = ()=>structuredClone({
        collectionId: false,
        artistId: false,
        albumFormatId: false,
        sleeveGradeId: false,
        mediaGradeId: false,
        tagId: false,
        sellStatus: false,
        labelId: false,
        albumTypeId: false,
        storeId: false,
        impactId: false,
        sellValueId: false,
        originCountryId: false,
        originalYear: false,
        releaseYear: false
    });



const $228a7d38c61fd0fd$var$useLocalStoredState = (name, defaultValue)=>(0, $f3eb771fc47795e7$exports.createState)(()=>{
        const stringValue = localStorage.getItem(name);
        if (stringValue != null) return JSON.parse(stringValue) ?? defaultValue;
        return defaultValue;
    });
const $228a7d38c61fd0fd$export$a0e69501e318daaa = $228a7d38c61fd0fd$var$useLocalStoredState("currentFilterElements", []);
const $228a7d38c61fd0fd$export$4c3e6e907095cf64 = $228a7d38c61fd0fd$var$useLocalStoredState("currentIsNegated", (0, $c4f51e0bfb342785$export$83592602d06445ed)());
const $228a7d38c61fd0fd$export$8c2d3154064d3bf7 = $228a7d38c61fd0fd$var$useLocalStoredState("currentFilterSortOption", (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
const $228a7d38c61fd0fd$export$3f798b32817b3210 = $228a7d38c61fd0fd$var$useLocalStoredState("currentFilterSortOrder", (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
const $228a7d38c61fd0fd$export$8a1fe1ebdf138401 = $228a7d38c61fd0fd$var$useLocalStoredState("currentLayoutFilterElements", []);
const $228a7d38c61fd0fd$export$97019f29ebdf2a0e = $228a7d38c61fd0fd$var$useLocalStoredState("currentLayoutIsNegated", (0, $c4f51e0bfb342785$export$83592602d06445ed)());
const $228a7d38c61fd0fd$export$4d06867b1d41e1a = $228a7d38c61fd0fd$var$useLocalStoredState("currentLayoutFilterSortOption", (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
const $228a7d38c61fd0fd$export$b6e481a7c7bbce9a = $228a7d38c61fd0fd$var$useLocalStoredState("currentLayoutFilterSortOrder", (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
const $228a7d38c61fd0fd$export$1fa08d0344d4319f = (isLayout)=>{
    const [currentFilterElements] = isLayout ? $228a7d38c61fd0fd$export$8a1fe1ebdf138401.useState() : $228a7d38c61fd0fd$export$a0e69501e318daaa.useState();
    const [currentIsNegated] = isLayout ? $228a7d38c61fd0fd$export$97019f29ebdf2a0e.useState() : $228a7d38c61fd0fd$export$4c3e6e907095cf64.useState();
    const [currentFilterSortOption] = isLayout ? $228a7d38c61fd0fd$export$4d06867b1d41e1a.useState() : $228a7d38c61fd0fd$export$8c2d3154064d3bf7.useState();
    const [currentFilterSortOrder] = isLayout ? $228a7d38c61fd0fd$export$b6e481a7c7bbce9a.useState() : $228a7d38c61fd0fd$export$3f798b32817b3210.useState();
    (0, $7fPBF.useEffect)(()=>{
        const key = isLayout ? "currentLayoutFilterElements" : "currentFilterElements";
        if (currentFilterElements.length == 0) localStorage.removeItem(key);
        else localStorage.setItem(key, JSON.stringify(currentFilterElements));
    }, [
        currentFilterElements
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const key = isLayout ? "currentLayoutIsNegated" : "currentIsNegated";
        localStorage.setItem(key, JSON.stringify(currentIsNegated));
    }, [
        currentIsNegated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const key = isLayout ? "currentLayoutFilterSortOption" : "currentFilterSortOption";
        if (currentFilterSortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST) localStorage.removeItem(key);
        else localStorage.setItem(key, JSON.stringify(currentFilterSortOption));
    }, [
        currentFilterSortOption
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const key = isLayout ? "currentLayoutFilterSortOrder" : "currentFilterSortOrder";
        if (currentFilterSortOrder == (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT) localStorage.removeItem(key);
        else localStorage.setItem(key, JSON.stringify(currentFilterSortOrder));
    }, [
        currentFilterSortOrder
    ]);
    const getCurrentFilterElements = ()=>structuredClone(currentFilterElements);
    const getCurrentIsNegated = ()=>currentIsNegated;
    const getCurrentFilterSortOption = ()=>currentFilterSortOption;
    const getCurrentFilterSortOrder = ()=>currentFilterSortOrder;
    const getFilterElementsWithSearchText = (searchText, filterElements)=>{
        const newFilterElements = filterElements.filter((filterElement)=>filterElement.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SEARCH_TEXT);
        if (searchText) newFilterElements.unshift(new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_album_search_text_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SEARCH_TEXT, false, false, searchText, searchText));
        return newFilterElements;
    };
    const getSearchText = (filterElements)=>{
        const searchTextFilterElement = filterElements.filter((filterElement)=>filterElement.filterType == (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SEARCH_TEXT);
        if (searchTextFilterElement[0]) return searchTextFilterElement[0].elementId;
        return "";
    };
    return {
        getCurrentFilterElements: getCurrentFilterElements,
        getCurrentIsNegated: getCurrentIsNegated,
        getCurrentFilterSortOption: getCurrentFilterSortOption,
        getCurrentFilterSortOrder: getCurrentFilterSortOrder,
        getFilterElementsWithSearchText: getFilterElementsWithSearchText,
        getSearchText: getSearchText
    };
};




const $3e1655feb131ddb8$export$9d3256d72c51d563 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getAlbum = (albumUuid)=>get(`albums/${albumUuid}`);
    return {
        getAlbum: getAlbum
    };
};




const $2738696e81957cce$export$93582110ed982a24 = (isActive, mode, isFiltering, isNegated, pageSize, onLoading, onError, shareLink, filterElements, sortOption, sortOrder, dependencies = [])=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const searchAlbums = (parameters, filters)=>post("albums/search", {
            ...parameters,
            ...filters
        });
    const searchPublicAlbums = (parameters, filters)=>post("albums/search/shared/public", {
            ...parameters,
            ...filters
        });
    const [albums, setAlbums, resetAlbumStorage, moveAlbum, deleteAlbum, noMoreAlbums, isFetchingAlbums] = (0, $c4f51e0bfb342785$export$30e3b84d95295bc3)(isActive, mode, isFiltering, isNegated, pageSize, mode === "public" ? searchPublicAlbums : searchAlbums, onLoading, onError, shareLink, filterElements, sortOption, sortOrder, dependencies);
    return [
        albums,
        setAlbums,
        resetAlbumStorage,
        moveAlbum,
        deleteAlbum,
        noMoreAlbums,
        isFetchingAlbums
    ];
};





const $f7059bbf3f33120d$export$90ac1c435e11dc37 = {
    dateNowInSeconds: ()=>{
        const now = Date.now();
        return (now - now % 1000) / 1000;
    }
};


class $a8465eea29ce6625$export$e95767ffe2e60cec {
    static #_ = this.expirationTimeInSeconds = 1800 // 30 minutes
    ;
    static #_2 = this.artistStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_3 = this.labelStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_4 = this.storeStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_5 = this.albumTypeStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_6 = this.albumFormatStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_7 = this.sellValueStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_8 = this.exchangeRateStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_9 = this.tagStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_10 = this.originCountryStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_11 = this.gearItemStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_12 = this.equipmentsStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_13 = this.listeningSessionsStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_14 = this.shelvingStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_15 = this.collectionStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_16 = this.userProfileStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(false);
    static #_17 = this.userNotificationStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_18 = this.publicCollectionStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_19 = this.impactsStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_20 = this.countriesStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_21 = this.sleeveGradeStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_22 = this.mediaGradeStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_23 = this.highlightedCollectionStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    static #_24 = this.highlightedAlbumStorage = new $a8465eea29ce6625$export$e95767ffe2e60cec(true);
    constructor(isEnabled){
        this.isEnabled = isEnabled;
    }
    static reset() {
        $a8465eea29ce6625$export$e95767ffe2e60cec.resetAttributeData();
        $a8465eea29ce6625$export$e95767ffe2e60cec.shelvingStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.collectionStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.userProfileStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.userNotificationStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.publicCollectionStorage.data = undefined;
    }
    static resetAttributeData() {
        $a8465eea29ce6625$export$e95767ffe2e60cec.artistStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.labelStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.storeStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.albumTypeStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.albumFormatStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.sellValueStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.exchangeRateStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.tagStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.originCountryStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.gearItemStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.equipmentsStorage.data = undefined;
        $a8465eea29ce6625$export$e95767ffe2e60cec.listeningSessionsStorage.data = undefined;
    }
    setData(data, isPublic, collectionId) {
        this.isPublic = isPublic;
        this.collectionId = collectionId;
        this.data = data;
    }
    getData(isPublic, collectionId) {
        if (!this.isEnabled) return undefined;
        if ((0, $f7059bbf3f33120d$export$90ac1c435e11dc37).dateNowInSeconds() - this.lastSetted > $a8465eea29ce6625$export$e95767ffe2e60cec.expirationTimeInSeconds) return undefined;
        if (this.isPublic == isPublic) {
            if (isPublic && this.collectionId == collectionId) return this.data;
            else if (!isPublic) return this.data;
        }
        return undefined;
    }
}


const $f3e21a44c8405b5b$export$c8308480b6dfe6db = (0, $f3eb771fc47795e7$exports.createState)(undefined);
const $f3e21a44c8405b5b$export$69ba603ca46caf3c = (0, $f3eb771fc47795e7$exports.createState)(undefined);
const $f3e21a44c8405b5b$export$23bbbc4533528f03 = (0, $f3eb771fc47795e7$exports.createState)(undefined);
const $f3e21a44c8405b5b$export$5220458fb0348f0 = ()=>{
    const [user, setUser] = $f3e21a44c8405b5b$export$23bbbc4533528f03.useState();
    const [, setCurrentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const [, setCurrentPrivateFilterElements] = (0, $228a7d38c61fd0fd$export$a0e69501e318daaa).useState();
    const [, setCurrentPrivateIsNegated] = (0, $228a7d38c61fd0fd$export$4c3e6e907095cf64).useState();
    const [, setCurrentPrivateFilterSortOption] = (0, $228a7d38c61fd0fd$export$8c2d3154064d3bf7).useState();
    const [, setCurrentPrivateFilterSortOrder] = (0, $228a7d38c61fd0fd$export$3f798b32817b3210).useState();
    const [, setCurrentLayoutFilterElements] = (0, $228a7d38c61fd0fd$export$8a1fe1ebdf138401).useState();
    const [, setCurrentLayoutIsNegated] = (0, $228a7d38c61fd0fd$export$97019f29ebdf2a0e).useState();
    const [, setCurrentLayoutFilterSortOption] = (0, $228a7d38c61fd0fd$export$4d06867b1d41e1a).useState();
    const [, setCurrentLayoutFilterSortOrder] = (0, $228a7d38c61fd0fd$export$b6e481a7c7bbce9a).useState();
    const getToken = ()=>{
        const tokenString = localStorage.getItem("token");
        if (tokenString != null) {
            const token = JSON.parse(tokenString);
            return token?.token;
        }
        return null;
    };
    const setToken = (token)=>{
        localStorage.setItem("token", JSON.stringify(token));
    };
    const isCurrentUserPremium = ()=>{
        if (!user?.role) return false;
        return [
            (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium,
            (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).admin,
            (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).guest
        ].includes(user.role);
    };
    const isCurrentUserAdmin = ()=>{
        if (!user?.role) return false;
        return user.role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).admin;
    };
    const closeSession = ()=>{
        (0, $a8465eea29ce6625$export$e95767ffe2e60cec).reset();
        setCurrentPrivateCollection(undefined);
        setCurrentPrivateFilterElements([]);
        setCurrentPrivateIsNegated((0, $c4f51e0bfb342785$export$83592602d06445ed)());
        setCurrentPrivateFilterSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
        setCurrentPrivateFilterSortOrder((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
        setCurrentLayoutFilterElements([]);
        setCurrentLayoutIsNegated((0, $c4f51e0bfb342785$export$83592602d06445ed)());
        setCurrentLayoutFilterSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
        setCurrentLayoutFilterSortOrder((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
        setUser(undefined);
        $f3e21a44c8405b5b$export$c8308480b6dfe6db.setValue(undefined);
        localStorage.removeItem("token");
    };
    return {
        getToken: getToken,
        setToken: setToken,
        isCurrentUserPremium: isCurrentUserPremium,
        isCurrentUserAdmin: isCurrentUserAdmin,
        closeSession: closeSession
    };
};







const $5109476473fc2594$var$commonHeaders = (token)=>{
    return {
        "Piper-JWT-Token": token,
        "Piper-Locale": (0, $37bec70ed65ed924$export$21c51bc433c16634).locale,
        "Piper-App": "Web"
    };
};
const $5109476473fc2594$export$b9191a7363a9cdf8 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const { getToken: getToken, setToken: setToken, closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const processResponse = async (response)=>{
        const body = await response.json();
        if (response.headers.has("Piper-Renewed-JWT-Token")) {
            const token = response.headers.get("Piper-Renewed-JWT-Token") ?? "";
            setToken({
                token: token,
                expires: 0,
                issued: 0
            });
        }
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(response.status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message, {
                toastId: "expiredSession"
            });
            closeSession();
            navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
        } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isOnMaintenance(response.status)) navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).maintenance());
        return {
            body: body,
            status: response.status
        };
    };
    const get = async (endpoint, query)=>{
        const stringifiedQuery = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).stringify(query || {}, {
            arrayFormat: "bracket"
        });
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}?${stringifiedQuery}`, {
            method: "GET",
            headers: new Headers($5109476473fc2594$var$commonHeaders(token))
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch(()=>{
            return {
                body: {
                    message: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_error
                },
                status: 500
            };
        });
    };
    const post = async (endpoint, params, query)=>{
        const stringifiedQuery = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).stringify(query || {}, {
            arrayFormat: "bracket"
        });
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}?${stringifiedQuery}`, {
            method: "POST",
            headers: {
                ...$5109476473fc2594$var$commonHeaders(token),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch(()=>{
            return {
                body: {
                    message: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_error
                },
                status: 500
            };
        });
    };
    const put = async (endpoint, params)=>{
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}`, {
            method: "PUT",
            headers: {
                ...$5109476473fc2594$var$commonHeaders(token),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch(()=>{
            return {
                body: {
                    message: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_error
                },
                status: 500
            };
        });
    };
    const patch = async (endpoint, params)=>{
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}`, {
            method: "PATCH",
            headers: {
                ...$5109476473fc2594$var$commonHeaders(token),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch(()=>{
            return {
                body: {
                    message: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_error
                },
                status: 500
            };
        });
    };
    const deleteRequest = async (endpoint, params)=>{
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}`, {
            method: "DELETE",
            headers: {
                ...$5109476473fc2594$var$commonHeaders(token),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch(()=>{
            return {
                body: {
                    message: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_error
                },
                status: 500
            };
        });
    };
    const upload = async (endpoint, filename, file, extraKey, extraArguments)=>{
        const form = new FormData();
        form.append("image", file, filename);
        if (extraKey) form.append(extraKey, extraArguments ?? "");
        const token = getToken();
        return fetch(`${(0, $225b141716ede244$export$7dc6752a22ab011a).url}/${endpoint}`, {
            method: "POST",
            headers: $5109476473fc2594$var$commonHeaders(token),
            body: form
        }).then(async (response)=>{
            return await processResponse(response);
        }).catch((error)=>{
            return {
                body: error,
                status: 500
            };
        });
    };
    return {
        get: get,
        post: post,
        put: put,
        patch: patch,
        deleteRequest: deleteRequest,
        upload: upload
    };
};






const $543c1a3d82f8abfe$export$d4e22f05f73ea56b = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const login = (parameters)=>post("login", parameters);
    return {
        login: login
    };
};



const $284e3996d2c13603$export$da8941e4c91255e0 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const signup = (parameters)=>post("signup", parameters);
    return {
        signup: signup
    };
};



const $eb25f080350ae646$export$ca21f09267ba8ef = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const updatePassword = (parameters)=>put("user/password", parameters);
    return {
        updatePassword: updatePassword
    };
};






parcelRequire("7fPBF");

var $54e9f41e0add89be$exports = {};

$parcel$export($54e9f41e0add89be$exports, "mainContent", function () { return $54e9f41e0add89be$export$ad430d422a89f9f0; }, function (v) { return $54e9f41e0add89be$export$ad430d422a89f9f0 = v; });
$parcel$export($54e9f41e0add89be$exports, "mainContentWide", function () { return $54e9f41e0add89be$export$4c7f04e4c1fb047d; }, function (v) { return $54e9f41e0add89be$export$4c7f04e4c1fb047d = v; });
var $54e9f41e0add89be$export$ad430d422a89f9f0;
var $54e9f41e0add89be$export$4c7f04e4c1fb047d;
$54e9f41e0add89be$export$ad430d422a89f9f0 = `xKFI2a_mainContent`;
$54e9f41e0add89be$export$4c7f04e4c1fb047d = `xKFI2a_mainContentWide`;


const $9f0628080e21c26d$export$5c0547b091a4b556 = ({ className: className, showingPersistentDrawer: showingPersistentDrawer, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(showingPersistentDrawer ? (0, (/*@__PURE__*/$parcel$interopDefault($54e9f41e0add89be$exports))).mainContentWide : (0, (/*@__PURE__*/$parcel$interopDefault($54e9f41e0add89be$exports))).mainContent, className),
        children: children
    });
};


var $ee7d17efa71a278b$exports = {};

$parcel$export($ee7d17efa71a278b$exports, "credits", function () { return $ee7d17efa71a278b$export$68c7321cb43cac49; }, function (v) { return $ee7d17efa71a278b$export$68c7321cb43cac49 = v; });
$parcel$export($ee7d17efa71a278b$exports, "creditsMobile", function () { return $ee7d17efa71a278b$export$afcc3cebfa8978b6; }, function (v) { return $ee7d17efa71a278b$export$afcc3cebfa8978b6 = v; });
$parcel$export($ee7d17efa71a278b$exports, "creditsText", function () { return $ee7d17efa71a278b$export$597eee7a03a2c4a0; }, function (v) { return $ee7d17efa71a278b$export$597eee7a03a2c4a0 = v; });
$parcel$export($ee7d17efa71a278b$exports, "drawerButton", function () { return $ee7d17efa71a278b$export$7dce97e5a31ec15b; }, function (v) { return $ee7d17efa71a278b$export$7dce97e5a31ec15b = v; });
$parcel$export($ee7d17efa71a278b$exports, "emailField", function () { return $ee7d17efa71a278b$export$b60f3aad14353aa5; }, function (v) { return $ee7d17efa71a278b$export$b60f3aad14353aa5 = v; });
$parcel$export($ee7d17efa71a278b$exports, "emailInput", function () { return $ee7d17efa71a278b$export$19732eed08316548; }, function (v) { return $ee7d17efa71a278b$export$19732eed08316548 = v; });
$parcel$export($ee7d17efa71a278b$exports, "form", function () { return $ee7d17efa71a278b$export$6210fa4921d2a466; }, function (v) { return $ee7d17efa71a278b$export$6210fa4921d2a466 = v; });
$parcel$export($ee7d17efa71a278b$exports, "googleButton", function () { return $ee7d17efa71a278b$export$42243f34c2f401d5; }, function (v) { return $ee7d17efa71a278b$export$42243f34c2f401d5 = v; });
$parcel$export($ee7d17efa71a278b$exports, "guestArrow", function () { return $ee7d17efa71a278b$export$d94a1e96350ae15f; }, function (v) { return $ee7d17efa71a278b$export$d94a1e96350ae15f = v; });
$parcel$export($ee7d17efa71a278b$exports, "guestCard", function () { return $ee7d17efa71a278b$export$4e3e9baf4503b7a0; }, function (v) { return $ee7d17efa71a278b$export$4e3e9baf4503b7a0 = v; });
$parcel$export($ee7d17efa71a278b$exports, "guestCardHidden", function () { return $ee7d17efa71a278b$export$785c217e912678a4; }, function (v) { return $ee7d17efa71a278b$export$785c217e912678a4 = v; });
$parcel$export($ee7d17efa71a278b$exports, "guestCardShown", function () { return $ee7d17efa71a278b$export$69ad86257d445c81; }, function (v) { return $ee7d17efa71a278b$export$69ad86257d445c81 = v; });
$parcel$export($ee7d17efa71a278b$exports, "iconApple", function () { return $ee7d17efa71a278b$export$677b5c5558de4e1d; }, function (v) { return $ee7d17efa71a278b$export$677b5c5558de4e1d = v; });
$parcel$export($ee7d17efa71a278b$exports, "loginContainer", function () { return $ee7d17efa71a278b$export$99b3c6ebb418c9f9; }, function (v) { return $ee7d17efa71a278b$export$99b3c6ebb418c9f9 = v; });
$parcel$export($ee7d17efa71a278b$exports, "loginContainerMinimalist", function () { return $ee7d17efa71a278b$export$ffd56a356a826221; }, function (v) { return $ee7d17efa71a278b$export$ffd56a356a826221 = v; });
$parcel$export($ee7d17efa71a278b$exports, "logoImage", function () { return $ee7d17efa71a278b$export$3ba0bfd74bc3a6fe; }, function (v) { return $ee7d17efa71a278b$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($ee7d17efa71a278b$exports, "newUserButton", function () { return $ee7d17efa71a278b$export$49e34a0d6ca042d2; }, function (v) { return $ee7d17efa71a278b$export$49e34a0d6ca042d2 = v; });
$parcel$export($ee7d17efa71a278b$exports, "passwordInput", function () { return $ee7d17efa71a278b$export$48d6f7351f788047; }, function (v) { return $ee7d17efa71a278b$export$48d6f7351f788047 = v; });
$parcel$export($ee7d17efa71a278b$exports, "submitButtonContainer", function () { return $ee7d17efa71a278b$export$b907078050f5b19a; }, function (v) { return $ee7d17efa71a278b$export$b907078050f5b19a = v; });
$parcel$export($ee7d17efa71a278b$exports, "subtitle", function () { return $ee7d17efa71a278b$export$c96745152eb2740f; }, function (v) { return $ee7d17efa71a278b$export$c96745152eb2740f = v; });
var $ee7d17efa71a278b$export$68c7321cb43cac49;
var $ee7d17efa71a278b$export$afcc3cebfa8978b6;
var $ee7d17efa71a278b$export$597eee7a03a2c4a0;
var $ee7d17efa71a278b$export$7dce97e5a31ec15b;
var $ee7d17efa71a278b$export$b60f3aad14353aa5;
var $ee7d17efa71a278b$export$19732eed08316548;
var $ee7d17efa71a278b$export$6210fa4921d2a466;
var $ee7d17efa71a278b$export$42243f34c2f401d5;
var $ee7d17efa71a278b$export$d94a1e96350ae15f;
var $ee7d17efa71a278b$export$4e3e9baf4503b7a0;
var $ee7d17efa71a278b$export$785c217e912678a4;
var $ee7d17efa71a278b$export$69ad86257d445c81;
var $ee7d17efa71a278b$export$677b5c5558de4e1d;
var $ee7d17efa71a278b$export$99b3c6ebb418c9f9;
var $ee7d17efa71a278b$export$ffd56a356a826221;
var $ee7d17efa71a278b$export$3ba0bfd74bc3a6fe;
var $ee7d17efa71a278b$export$49e34a0d6ca042d2;
var $ee7d17efa71a278b$export$48d6f7351f788047;
var $ee7d17efa71a278b$export$b907078050f5b19a;
var $ee7d17efa71a278b$export$c96745152eb2740f;
$ee7d17efa71a278b$export$68c7321cb43cac49 = `HdLVgW_credits`;
$ee7d17efa71a278b$export$afcc3cebfa8978b6 = `HdLVgW_creditsMobile`;
$ee7d17efa71a278b$export$597eee7a03a2c4a0 = `HdLVgW_creditsText`;
$ee7d17efa71a278b$export$7dce97e5a31ec15b = `HdLVgW_drawerButton`;
$ee7d17efa71a278b$export$b60f3aad14353aa5 = `HdLVgW_emailField`;
$ee7d17efa71a278b$export$19732eed08316548 = `HdLVgW_emailInput`;
$ee7d17efa71a278b$export$6210fa4921d2a466 = `HdLVgW_form`;
$ee7d17efa71a278b$export$42243f34c2f401d5 = `HdLVgW_googleButton`;
$ee7d17efa71a278b$export$d94a1e96350ae15f = `HdLVgW_guestArrow`;
$ee7d17efa71a278b$export$4e3e9baf4503b7a0 = `HdLVgW_guestCard`;
$ee7d17efa71a278b$export$785c217e912678a4 = `HdLVgW_guestCardHidden`;
$ee7d17efa71a278b$export$69ad86257d445c81 = `HdLVgW_guestCardShown`;
$ee7d17efa71a278b$export$677b5c5558de4e1d = `HdLVgW_iconApple`;
$ee7d17efa71a278b$export$99b3c6ebb418c9f9 = `HdLVgW_loginContainer`;
$ee7d17efa71a278b$export$ffd56a356a826221 = `HdLVgW_loginContainerMinimalist`;
$ee7d17efa71a278b$export$3ba0bfd74bc3a6fe = `HdLVgW_logoImage`;
$ee7d17efa71a278b$export$49e34a0d6ca042d2 = `HdLVgW_newUserButton`;
$ee7d17efa71a278b$export$48d6f7351f788047 = `HdLVgW_passwordInput`;
$ee7d17efa71a278b$export$b907078050f5b19a = `HdLVgW_submitButtonContainer`;
$ee7d17efa71a278b$export$c96745152eb2740f = `HdLVgW_subtitle`;



var $1ZNeQ = parcelRequire("1ZNeQ");

parcelRequire("7fPBF");

var $1ZNeQ = parcelRequire("1ZNeQ");


function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $7fPBF = parcelRequire("7fPBF");

function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;


function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF['useId'.toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}




/**
 * @mui/styled-engine v5.15.7
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

var $7fPBF = parcelRequire("7fPBF");
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $7fPBF = parcelRequire("7fPBF");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $474a93eda108ec7a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $474a93eda108ec7a$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $474a93eda108ec7a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($474a93eda108ec7a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $474a93eda108ec7a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)) break;
        (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)();
    }
    return (0, $83f8df0fc4bef2f6$export$58adb3bec8346d0f)(begin, (0, $83f8df0fc4bef2f6$export$5880b8b5730aff45));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $83f8df0fc4bef2f6$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $83f8df0fc4bef2f6$export$45918ac1574455b1)($0bb108cf9f15301b$var$toRules((0, $83f8df0fc4bef2f6$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $0bb108cf9f15301b$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $0bb108cf9f15301b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($0bb108cf9f15301b$var$ignoreFlag) > -1;
};
var $0bb108cf9f15301b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($0bb108cf9f15301b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $0bb108cf9f15301b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $0bb108cf9f15301b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$0bb108cf9f15301b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $0bb108cf9f15301b$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $0bb108cf9f15301b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$0bb108cf9f15301b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    } else if ($0bb108cf9f15301b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $83f8df0fc4bef2f6$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, 'stretch') ? $0bb108cf9f15301b$var$prefix((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, (0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 3 - (~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                    (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                        value: (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (element.length) return (0, $83f8df0fc4bef2f6$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $83f8df0fc4bef2f6$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737),
        (0, $83f8df0fc4bef2f6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $474a93eda108ec7a$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};


var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $26c7bf120a29b208$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c7bf120a29b208$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $26c7bf120a29b208$var$hyphenateRegex = /[A-Z]|^ms/g;
var $26c7bf120a29b208$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $26c7bf120a29b208$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $26c7bf120a29b208$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $26c7bf120a29b208$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $26c7bf120a29b208$var$isCustomProperty(styleName) ? styleName : styleName.replace($26c7bf120a29b208$var$hyphenateRegex, '-$&').toLowerCase();
});
var $26c7bf120a29b208$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($26c7bf120a29b208$var$animationRegex, function(match, p1, p2) {
                $26c7bf120a29b208$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $26c7bf120a29b208$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$26c7bf120a29b208$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $26c7bf120a29b208$var$contentValuePattern, $26c7bf120a29b208$var$contentValues, $26c7bf120a29b208$var$oldProcessStyleValue, $26c7bf120a29b208$var$msPattern, $26c7bf120a29b208$var$hyphenPattern, $26c7bf120a29b208$var$hyphenatedCache;
var $26c7bf120a29b208$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $26c7bf120a29b208$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $26c7bf120a29b208$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $26c7bf120a29b208$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $26c7bf120a29b208$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $26c7bf120a29b208$var$cursor;
                var result = interpolation(mergedProps);
                $26c7bf120a29b208$var$cursor = previousCursor;
                return $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($26c7bf120a29b208$var$isProcessableValue(value)) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($26c7bf120a29b208$var$isProcessableValue(value[_i])) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $26c7bf120a29b208$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $26c7bf120a29b208$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $26c7bf120a29b208$var$cursor;
var $26c7bf120a29b208$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $26c7bf120a29b208$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $26c7bf120a29b208$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $26c7bf120a29b208$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $26c7bf120a29b208$var$cursor
    };
};



var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $4df9e939738a7402$export$23f2a1d2818174ef = true;
var $4df9e939738a7402$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4df9e939738a7402$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4df9e939738a7402$export$e7094788287c5e9b = $4df9e939738a7402$var$EmotionCacheContext.Provider;
var $4df9e939738a7402$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
};
var $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4df9e939738a7402$export$23f2a1d2818174ef) $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4df9e939738a7402$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4df9e939738a7402$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
};
var $4df9e939738a7402$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4df9e939738a7402$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $4df9e939738a7402$var$getTheme(outerTheme, theme);
    });
});
var $4df9e939738a7402$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4df9e939738a7402$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4df9e939738a7402$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $c80ca66c64e3fad5$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4df9e939738a7402$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $4df9e939738a7402$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]);
    return undefined;
};
var $4df9e939738a7402$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4df9e939738a7402$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $4df9e939738a7402$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $4df9e939738a7402$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4df9e939738a7402$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4df9e939738a7402$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4df9e939738a7402$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4df9e939738a7402$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $4df9e939738a7402$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4df9e939738a7402$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4df9e939738a7402$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4df9e939738a7402$var$Emotion = /* #__PURE__ */ $4df9e939738a7402$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4df9e939738a7402$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $4df9e939738a7402$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4df9e939738a7402$export$a9c23c6ac3fc3eca = $4df9e939738a7402$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");




var $91b5651481cc9d5c$exports = {};
function $91b5651481cc9d5c$var$_extends() {
    $91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports;
    return $91b5651481cc9d5c$var$_extends.apply(this, arguments);
}
$91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports;




parcelRequire("8Ae2G");
var $84f3fdd51733d70b$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4df9e939738a7402$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4df9e939738a7402$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4df9e939738a7402$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
var $84f3fdd51733d70b$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4df9e939738a7402$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $4df9e939738a7402$export$971d5caa766a69d7)));
    if (!(0, $4df9e939738a7402$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $26c7bf120a29b208$export$6321afa313b251b5)(args);
}
var $84f3fdd51733d70b$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4df9e939738a7402$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $4df9e939738a7402$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $84f3fdd51733d70b$var$isBrowser, $84f3fdd51733d70b$var$isTestEnv, $84f3fdd51733d70b$var$globalContext, $84f3fdd51733d70b$var$globalKey;





var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $742aea85e4e67b26$export$2e2bcd8739ae039);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $4df9e939738a7402$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $4df9e939738a7402$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("7fPBF");





var $8de346382d86c747$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2078ce513e00dfd7$export$2e2bcd8739ae039).bind();
$8de346382d86c747$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});




parcelRequire("7fPBF");



'use client';
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84f3fdd51733d70b$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}


'use client';
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8de346382d86c747$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};



function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (!$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, target) : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && key in target && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}







const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}


const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;







function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;


const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $38ced3a04f47cab4$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;


/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui-internal/babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }


function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;



function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $40d4ff9e66a5531b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $40d4ff9e66a5531b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $a08eb3ea758ca121$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $0d575c74131361b5$export$2aa3fd96c49a84a8)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $38ced3a04f47cab4$export$2e2bcd8739ae039), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;


function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $40d4ff9e66a5531b$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}










function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $38ced3a04f47cab4$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;




function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8543e3d4e0a2f626$var$createBorderStyle(prop, transform) {
    return (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = $8543e3d4e0a2f626$var$createBorderStyle('border', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = $8543e3d4e0a2f626$var$createBorderStyle('borderTop', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = $8543e3d4e0a2f626$var$createBorderStyle('borderRight', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = $8543e3d4e0a2f626$var$createBorderStyle('borderBottom', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$47658cca1a909427 = $8543e3d4e0a2f626$var$createBorderStyle('borderLeft', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = $8543e3d4e0a2f626$var$createBorderStyle('borderColor');
const $8543e3d4e0a2f626$export$126a92c968acdb85 = $8543e3d4e0a2f626$var$createBorderStyle('borderTopColor');
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = $8543e3d4e0a2f626$var$createBorderStyle('borderRightColor');
const $8543e3d4e0a2f626$export$340b0327727f6d1a = $8543e3d4e0a2f626$var$createBorderStyle('borderBottomColor');
const $8543e3d4e0a2f626$export$60beef91a985b4bf = $8543e3d4e0a2f626$var$createBorderStyle('borderLeftColor');
const $8543e3d4e0a2f626$export$f9258c55612cbed7 = $8543e3d4e0a2f626$var$createBorderStyle('outline', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$621fe586efeb64b9 = $8543e3d4e0a2f626$var$createBorderStyle('outlineColor');
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $40d4ff9e66a5531b$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8543e3d4e0a2f626$var$borders = (0, $aa0baa79cee865b3$export$2e2bcd8739ae039)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2, $8543e3d4e0a2f626$export$f9258c55612cbed7, $8543e3d4e0a2f626$export$621fe586efeb64b9);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;







const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $40d4ff9e66a5531b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $40d4ff9e66a5531b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $40d4ff9e66a5531b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $792b4bc41110be3c$var$grid = (0, $aa0baa79cee865b3$export$2e2bcd8739ae039)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;




function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $aa0baa79cee865b3$export$2e2bcd8739ae039)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;





function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $91ad95ac62846a03$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $0d575c74131361b5$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $661b7ffebb8ef134$var$sizing = (0, $aa0baa79cee865b3$export$2e2bcd8739ae039)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;


const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $8543e3d4e0a2f626$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $8543e3d4e0a2f626$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $fb4327c08e40e84e$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $fb4327c08e40e84e$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $fb4327c08e40e84e$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $40d4ff9e66a5531b$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $40d4ff9e66a5531b$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $792b4bc41110be3c$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $792b4bc41110be3c$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $792b4bc41110be3c$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $661b7ffebb8ef134$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $661b7ffebb8ef134$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $661b7ffebb8ef134$export$8afece71750ec241)
    },
    height: {
        transform: (0, $661b7ffebb8ef134$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $661b7ffebb8ef134$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $661b7ffebb8ef134$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;


function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $0d575c74131361b5$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $0d575c74131361b5$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $0d575c74131361b5$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $91ad95ac62846a03$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $d138c1b003d294d5$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $91ad95ac62846a03$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $38ced3a04f47cab4$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $38ced3a04f47cab4$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $38ced3a04f47cab4$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $91ad95ac62846a03$export$8922c90b6e020726)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $dd33892704fa9f8b$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $0808b5e3ab0ab6d4$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $f637f3037d6dee04$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $3b88b157d6186746$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $d138c1b003d294d5$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $663795ec7cbfcd06$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;




const $f2bb3328370663ea$var$_excluded = [
    "variant"
];
function $f2bb3328370663ea$var$isEmpty(string) {
    return string.length === 0;
}
function $f2bb3328370663ea$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f2bb3328370663ea$var$_excluded);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $f2bb3328370663ea$var$isEmpty(classKey) ? props[key] : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(props[key]);
        else classKey += `${$f2bb3328370663ea$var$isEmpty(classKey) ? key : (0, $d8da749d88f71122$export$2e2bcd8739ae039)(key)}${(0, $d8da749d88f71122$export$2e2bcd8739ae039)(props[key].toString())}`;
    });
    return classKey;
}



const $0aa19929000e58fe$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0aa19929000e58fe$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0aa19929000e58fe$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $0aa19929000e58fe$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $0aa19929000e58fe$var$transformVariants = (variants)=>{
    let numOfCallbacks = 0;
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        let key = '';
        if (typeof definition.props === 'function') {
            key = `callback${numOfCallbacks}`;
            numOfCallbacks += 1;
        } else key = (0, $f2bb3328370663ea$export$2e2bcd8739ae039)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $0aa19929000e58fe$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $0aa19929000e58fe$var$transformVariants(variants);
};
const $0aa19929000e58fe$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    let numOfCallbacks = 0;
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        if (typeof variant.props === 'function') {
            const propsToCheck = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, ownerState);
            isMatch = variant.props(propsToCheck);
        } else Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) {
            if (typeof variant.props === 'function') variantsStyles.push(styles[`callback${numOfCallbacks}`]);
            else variantsStyles.push(styles[(0, $f2bb3328370663ea$export$2e2bcd8739ae039)(variant.props)]);
        }
        if (typeof variant.props === 'function') numOfCallbacks += 1;
    });
    return variantsStyles;
};
const $0aa19929000e58fe$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $0aa19929000e58fe$var$variantsResolver(props, styles, themeVariants);
};
function $0aa19929000e58fe$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $0aa19929000e58fe$export$35e57303dbd8a66 = (0, $1f34940f58017e5f$export$2e2bcd8739ae039)();
const $0aa19929000e58fe$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0aa19929000e58fe$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0aa19929000e58fe$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0aa19929000e58fe$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $0aa19929000e58fe$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        theme: $0aa19929000e58fe$var$resolveTheme((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $0aa19929000e58fe$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0aa19929000e58fe$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $663795ec7cbfcd06$export$2e2bcd8739ae039)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            theme: $0aa19929000e58fe$var$resolveTheme((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $450fe936b88a7a32$export$e00380445f2b9e0c)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0aa19929000e58fe$var$defaultOverridesResolver($0aa19929000e58fe$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(inputOptions, $0aa19929000e58fe$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0aa19929000e58fe$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0aa19929000e58fe$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $450fe936b88a7a32$export$2e2bcd8739ae039)(tag, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg) return (props)=>$0aa19929000e58fe$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $291e2c063c5d6173$export$53b83ca8eaab0383)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $291e2c063c5d6173$export$53b83ca8eaab0383)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === 'function' && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$0aa19929000e58fe$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $0aa19929000e58fe$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $0aa19929000e58fe$var$themeVariantsResolver(props, $0aa19929000e58fe$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}









function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}







function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $92041da11764723e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(value, min, max);
}
function $92041da11764723e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $92041da11764723e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $92041da11764723e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $92041da11764723e$export$677b39864803984e($92041da11764723e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $92041da11764723e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $92041da11764723e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $92041da11764723e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $92041da11764723e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $92041da11764723e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $92041da11764723e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $92041da11764723e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$92041da11764723e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $92041da11764723e$export$29fb7152bd3f781a(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $92041da11764723e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $92041da11764723e$export$c852d90bf7403b62(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $92041da11764723e$export$677b39864803984e($92041da11764723e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $92041da11764723e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $92041da11764723e$export$c852d90bf7403b62(foreground);
    const lumB = $92041da11764723e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $92041da11764723e$export$58f0f39f63f3cf42(color, value) {
    color = $92041da11764723e$export$677b39864803984e(color);
    value = $92041da11764723e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $92041da11764723e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$4b073707ff63303(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$c0816ed86df316af(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $92041da11764723e$export$c852d90bf7403b62(color) > 0.5 ? $92041da11764723e$export$4b073707ff63303(color, coefficient) : $92041da11764723e$export$c0816ed86df316af(color, coefficient);
}
function $92041da11764723e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}


const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;


const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;


const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;


const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;


const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;


const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;


const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;


const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;


const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        default: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $92041da11764723e$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $92041da11764723e$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[200],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[50],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[700],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[200],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[50],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[500],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[300],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[500],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[300],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[400],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[400],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[300],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[500],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[400],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[300],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[800],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[500],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[400],
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[300],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[500],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $92041da11764723e$export$d061e26956a60b0a)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $47d3f19e39b3b144$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $1baba9d0f229a247$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}





const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $291e2c063c5d6173$export$2e2bcd8739ae039)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;




const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;


const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(18));
    const palette = (0, $07e9efd96a5c6f8a$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $1f34940f58017e5f$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $04aa49c3b5b31b02$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $26a3ee12a0d43232$export$2e2bcd8739ae039).slice(),
        typography: (0, $4027cd084802bc60$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $ec94076b9ecccee1$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $ab06614e124e32b2$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $291e2c063c5d6173$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $d138c1b003d294d5$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $663795ec7cbfcd06$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;


'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;


var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';


'use client';
const $f0645ef192f222f7$export$effb20ecdbf4d6aa = (prop)=>(0, $0aa19929000e58fe$export$3ba67b570e26eea0)(prop) && prop !== 'classes';
const $f0645ef192f222f7$export$f10c5a10d27438e5 = (0, $0aa19929000e58fe$export$3ba67b570e26eea0);
const $f0645ef192f222f7$var$styled = (0, $0aa19929000e58fe$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $726fe1d2377a5002$export$2e2bcd8739ae039,
    rootShouldForwardProp: $f0645ef192f222f7$export$effb20ecdbf4d6aa
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;



function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $7fPBF = parcelRequire("7fPBF");

'use client';
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $4df9e939738a7402$export$971d5caa766a69d7));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;


'use client';
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $1f34940f58017e5f$export$2e2bcd8739ae039)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;


'use client';
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $249f9015c4a2303b$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}




'use client';
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $71102aa90e2b2620$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $726fe1d2377a5002$export$2e2bcd8739ae039,
        themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
    });
}





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");



/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $59c589404b20ab2d$export$e28348cc2430497(element) {
    return typeof element === 'string';
}




var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;


var $7fPBF = parcelRequire("7fPBF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



'use client';
const $9907d957cc1b52b6$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $9907d957cc1b52b6$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $9907d957cc1b52b6$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $9907d957cc1b52b6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $9907d957cc1b52b6$export$d1710922ecaf577a = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $9907d957cc1b52b6$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $7fPBF.useRef(null);
    const renders = $7fPBF.useRef(0);
    const [state, setState] = $7fPBF.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $7fPBF.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingBottom) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingTop);
        const border = $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderBottomWidth) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $7fPBF.useCallback(()=>{
        const newState = getUpdatedState();
        if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $fw0lo.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $c285f587ed4585eb$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $7fPBF.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? 'hidden' : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $9907d957cc1b52b6$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;



var $7fPBF = parcelRequire("7fPBF");

'use client';
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $f29d66cab44a33c0$export$2e2bcd8739ae039));
}





var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $d8da749d88f71122$export$2e2bcd8739ae039);



'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039);



'use client';
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039);



parcelRequire("7fPBF");

parcelRequire("7fPBF");




'use client';
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fd51bd676aa60b7$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;





'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        defaultTheme: (0, $726fe1d2377a5002$export$2e2bcd8739ae039),
        themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}


const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;


const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}


function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;



'use client';
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b15682cef07fc0a$export$ef57d5c8ca2278f6), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $9907d957cc1b52b6$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Input, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;








function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;




'use client';
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $aadd2b32ac43594b$export$cdb270390122322b), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}, .${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = 'Input';
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;





var $7fPBF = parcelRequire("7fPBF");










function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;




'use client';
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $c2b262889cde4af1$export$3331e419f1a48437), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}, .${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = 'Input';
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;





var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");



'use client';
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('fieldset', {
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('legend', {
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}









function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;





'use client';
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fbe32ff46b8bf823$export$89922944c7227687), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $ba9f7182d6802613$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).error} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).disabled} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ae700d9709d2b786$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = 'Input';
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");










function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;



'use client';
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $94ffd68a66aaae7e$export$f7d501e40371cd17), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;







function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;



'use client';
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b0d2ae144238f59$export$c1c4b4545ad2ea5f), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $90370d1df15229dd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
function $de2da0b284b1a3c2$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $de2da0b284b1a3c2$export$2e2bcd8739ae039);





function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;



'use client';
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6fa629ce89e8ad57$export$149c8b8bab2289d1), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, styles.root, styles[`margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props, true) || (0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;





var $7fPBF = parcelRequire("7fPBF");









function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;




'use client';
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $10a7abfeb1405549$export$a394fa61b1d583a9), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $0321a2cb63129955$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0321a2cb63129955$var$FormHelperTextRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");
var $952d96b3f7fc8a13$exports = {};
'use strict';

$952d96b3f7fc8a13$exports = (parcelRequire("eDIlW"));







var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039);






var $7fPBF = parcelRequire("7fPBF");









function $465892a610f5fa03$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $59c589404b20ab2d$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherProps, {
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherProps.ownerState, ownerState)
    });
}




/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $676085a836f199f4$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $38b4de40642d32ce$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $27e8a811df72cf86$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $029d34f88c9482cd$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}


'use client';
const $699e2a22f1708389$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $699e2a22f1708389$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(parameters, $699e2a22f1708389$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $029d34f88c9482cd$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $27e8a811df72cf86$export$b01d1e419b049226)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(elementType, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;




function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiList', slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;



'use client';
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d56e26d1d10ff784$export$c6bd6795ed6e3203), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fb70212a09473954$var$ListRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            as: component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $5f729e410b274c00$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $5f729e410b274c00$export$2e2bcd8739ae039);





'use client';
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $15bf9ba27fbfc052$export$2e2bcd8739ae039)((0, $9502daaf177b272b$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;





var $7fPBF = parcelRequire("7fPBF");







var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $c285f587ed4585eb$export$2e2bcd8739ae039);




var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $c1e4563498af7952$export$2e2bcd8739ae039);






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $890b21ec8e20082a$export$2e2bcd8739ae039)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $1d2095ad20314533$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


function $e279fb69073314ca$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $2052c3bedb5e080c$export$2e2bcd8739ae039(o, p) {
    $2052c3bedb5e080c$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2052c3bedb5e080c$export$2e2bcd8739ae039(o, p);
}


function $dd20db312c2129e6$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $2052c3bedb5e080c$export$2e2bcd8739ae039)(subClass, superClass);
}


var $b4e0393918eafe5a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b4e0393918eafe5a$var$ReactIs, $b4e0393918eafe5a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$b4e0393918eafe5a$exports = (parcelRequire("lONZV"))();



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);


var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dd20db312c2129e6$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $e279fb69073314ca$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;


parcelRequire("7fPBF");



'use client';
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)((0, $726fe1d2377a5002$export$2e2bcd8739ae039));
    return theme[0, $e35ef6915a224202$export$2e2bcd8739ae039] || theme;
}


const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




'use client';
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $d6e7ffad706c848e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $7fPBF = parcelRequire("7fPBF");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;




// Is a vertical scrollbar displayed?
function $0cc83ef1bfdc25eb$var$isOverflowing(container) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $0cc83ef1bfdc25eb$var$getPaddingRight(element) {
    return parseInt((0, $c1e4563498af7952$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show);
    });
}
function $0cc83ef1bfdc25eb$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0cc83ef1bfdc25eb$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $5f729e410b274c00$export$2e2bcd8739ae039)((0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0cc83ef1bfdc25eb$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0cc83ef1bfdc25eb$var$getHiddenSiblings(container);
        $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $0aaff92e83b421f6$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $0aaff92e83b421f6$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $0aaff92e83b421f6$var$defaultManager = new (0, $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67)();
function $0aaff92e83b421f6$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $0aaff92e83b421f6$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $0aaff92e83b421f6$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $0aaff92e83b421f6$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsEventHandlers, otherHandlers);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}




var $7fPBF = parcelRequire("7fPBF");



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $820d2e8c6ed0c158$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $820d2e8c6ed0c158$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $820d2e8c6ed0c158$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $820d2e8c6ed0c158$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $820d2e8c6ed0c158$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($820d2e8c6ed0c158$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $820d2e8c6ed0c158$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $820d2e8c6ed0c158$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $820d2e8c6ed0c158$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $820d2e8c6ed0c158$var$defaultGetTabbable, isEnabled: isEnabled = $820d2e8c6ed0c158$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



'use client';
function $af6f301d1bc38583$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $af6f301d1bc38583$export$602eac185826482c = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($af6f301d1bc38583$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode
    });
});







var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");







'use client';
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;




function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;



'use client';
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $36421d1d94159248$export$9927a91fd93152bd), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;




function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;



'use client';
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1581382eb39c1df6$export$67960e22b12a638d), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a65b89a1133e1fe4$var$_excluded);
    const propsWithDefaults = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0aaff92e83b421f6$export$33ffd74ebf07f060)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af6f301d1bc38583$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BackdropSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $820d2e8c6ed0c158$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;





var $7fPBF = parcelRequire("7fPBF");






// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;






function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



'use client';
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $92041da11764723e$export$58f0f39f63f3cf42)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $92041da11764723e$export$58f0f39f63f3cf42)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($74e245c78e363f11$var$PaperRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;




function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;



'use client';
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5a68170633995c3$export$88f455dd56c95edb), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9502daaf177b272b$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;







function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;



'use client';
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a942fdfc6e6c5d42$export$2cf86a63a84fe23d), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;





var $7fPBF = parcelRequire("7fPBF");







function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;




'use client';
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5651256592f6f65$export$1ee13051fd9e2ab5), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;






var $7fPBF = parcelRequire("7fPBF");
'use client';
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $bc6c881cebb96954$export$2e2bcd8739ae039);




function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;



'use client';
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $7a6261f84c63d345$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $7a6261f84c63d345$export$e7a817afd12a40d0));
const $59b8977b1194262f$var$SelectNativeInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$f10c5a10d27438e5)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9afc3518733c6a5e$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectSelect, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, MenuProps.slotProps, {
                    paper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, paperProps, {
                        style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;




parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");








function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;



'use client';
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $50c5d2f6ad13a504$export$c7c50641356bdfa5), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;



'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}



'use client';
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');










'use client';
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $e07ff65b28ac412d$var$_excluded2 = [
    "root"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e07ff65b28ac412d$var$StyledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $faf35b44bb61ebfd$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7cc16c93aade5bc5$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $7a6261f84c63d345$export$2e2bcd8739ae039) : (0, $59b8977b1194262f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(classes, $e07ff65b28ac412d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = 'Select';
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;




function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;



'use client';
const $afe2b905acb8b9f6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039),
    filled: (0, $faf35b44bb61ebfd$export$2e2bcd8739ae039),
    outlined: (0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $16716b95f6c79ff6$export$c1bdcbaf0596aeda), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $afe2b905acb8b9f6$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($afe2b905acb8b9f6$var$TextFieldRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0321a2cb63129955$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;



var $1ZNeQ = parcelRequire("1ZNeQ");
function $042baa64c3dff8f0$export$16034cc9d16002bb({ disabled: disabled, field: { onBlur: fieldOnBlur, ...field }, form: { isSubmitting: isSubmitting, touched: touched, errors: errors }, onBlur: onBlur, helperText: helperText, ...props }) {
    const fieldError = (0, $1ZNeQ.getIn)(errors, field.name);
    const showError = (0, $1ZNeQ.getIn)(touched, field.name) && !!fieldError;
    return {
        error: showError,
        helperText: showError ? fieldError : helperText,
        disabled: disabled ?? isSubmitting,
        onBlur: onBlur ?? function(e) {
            fieldOnBlur(e ?? field.name);
        },
        ...field,
        ...props
    };
}
function $042baa64c3dff8f0$export$2c73285ae9390cec({ children: children, ...props }) {
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        ...$042baa64c3dff8f0$export$16034cc9d16002bb(props),
        children: children
    });
}
$042baa64c3dff8f0$export$2c73285ae9390cec.displayName = "FormikMaterialUITextField";


var $62356530d5141c13$exports = {};

$parcel$export($62356530d5141c13$exports, "input", function () { return $62356530d5141c13$export$b7e3ae3d7c15e42e; }, function (v) { return $62356530d5141c13$export$b7e3ae3d7c15e42e = v; });
$parcel$export($62356530d5141c13$exports, "maskedStyle", function () { return $62356530d5141c13$export$184fa9136650486c; }, function (v) { return $62356530d5141c13$export$184fa9136650486c = v; });
$parcel$export($62356530d5141c13$exports, "textField", function () { return $62356530d5141c13$export$c54b92c0bb02ba64; }, function (v) { return $62356530d5141c13$export$c54b92c0bb02ba64 = v; });
var $62356530d5141c13$export$b7e3ae3d7c15e42e;
var $62356530d5141c13$export$184fa9136650486c;
var $62356530d5141c13$export$c54b92c0bb02ba64;
$62356530d5141c13$export$b7e3ae3d7c15e42e = `y17Bqa_input`;
$62356530d5141c13$export$184fa9136650486c = `y17Bqa_maskedStyle`;
$62356530d5141c13$export$c54b92c0bb02ba64 = `y17Bqa_textField`;




var $gSkQi = parcelRequire("gSkQi");


var $c6e7443fe8b63e98$exports = {};

!function(e, t) {
    $c6e7443fe8b63e98$exports = t((parcelRequire("7fPBF")));
}($c6e7443fe8b63e98$exports, function(e) {
    return function(e) {
        function t(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.p = "", t(0);
    }([
        function(e, t, r) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function o(e, t) {
                var r = {};
                for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r;
            }
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function a(e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }
            function u(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.conformToMask = void 0;
            var s = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, l = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }(), f = r(3);
            Object.defineProperty(t, "conformToMask", {
                enumerable: !0,
                get: function() {
                    return n(f).default;
                }
            });
            var c = r(11), p = n(c), d = r(9), h = n(d), v = r(5), y = n(v), m = r(2), b = function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var r = arguments.length, n = Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                    var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [
                        this
                    ].concat(n)));
                    return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
                }
                return u(t, e), l(t, [
                    {
                        key: "setRef",
                        value: function(e) {
                            this.inputElement = e;
                        }
                    },
                    {
                        key: "initTextMask",
                        value: function() {
                            var e = this.props, t = this.props.value;
                            this.textMaskInputElement = (0, y.default)(s({
                                inputElement: this.inputElement
                            }, e)), this.textMaskInputElement.update(t);
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.initTextMask();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            var t = this.props, r = t.value, n = t.pipe, o = t.mask, i = t.guide, a = t.placeholderChar, u = t.showMask, s = {
                                guide: i,
                                placeholderChar: a,
                                showMask: u
                            }, l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe), f = o.toString() !== e.mask.toString(), c = Object.keys(s).some(function(t) {
                                return s[t] !== e[t];
                            }) || f || l, p = r !== this.inputElement.value;
                            (p || c) && this.initTextMask();
                        }
                    },
                    {
                        key: "render",
                        value: function e() {
                            var t = this.props, e = t.render, r = o(t, [
                                "render"
                            ]);
                            return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
                                onBlur: this.onBlur,
                                onChange: this.onChange,
                                defaultValue: this.props.value
                            }, r));
                        }
                    },
                    {
                        key: "onChange",
                        value: function(e) {
                            this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
                        }
                    },
                    {
                        key: "onBlur",
                        value: function(e) {
                            "function" == typeof this.props.onBlur && this.props.onBlur(e);
                        }
                    }
                ]), t;
            }(p.default.PureComponent);
            t.default = b, b.propTypes = {
                mask: h.default.oneOfType([
                    h.default.array,
                    h.default.func,
                    h.default.bool,
                    h.default.shape({
                        mask: h.default.oneOfType([
                            h.default.array,
                            h.default.func
                        ]),
                        pipe: h.default.func
                    })
                ]).isRequired,
                guide: h.default.bool,
                value: h.default.oneOfType([
                    h.default.string,
                    h.default.number
                ]),
                pipe: h.default.func,
                placeholderChar: h.default.string,
                keepCharPositions: h.default.bool,
                showMask: h.default.bool
            }, b.defaultProps = {
                render: function(e, t) {
                    return p.default.createElement("input", s({
                        ref: e
                    }, t));
                }
            };
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.placeholderChar = "_", t.strFunction = "function";
        },
        function(e, t, r) {
            "use strict";
            function n() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
                if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
                if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
                return e.map(function(e) {
                    return e instanceof RegExp ? t : e;
                }).join("");
            }
            function o(e) {
                return Array.isArray && Array.isArray(e) || e instanceof Array;
            }
            function i(e) {
                return "string" == typeof e || e instanceof String;
            }
            function a(e) {
                return "number" == typeof e && void 0 === e.length && !isNaN(e);
            }
            function u(e) {
                return "undefined" == typeof e || null === e;
            }
            function s(e) {
                for(var t = [], r = void 0; r = e.indexOf(c), r !== -1;)t.push(r), e.splice(r, 1);
                return {
                    maskWithoutCaretTraps: e,
                    indexes: t
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
            var l = r(1), f = [], c = "[]";
        },
        function(e, t, r) {
            "use strict";
            function n() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!(0, i.isArray)(t)) {
                    if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
                    t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
                }
                var n = r.guide, l = void 0 === n || n, f = r.previousConformedValue, c = void 0 === f ? s : f, p = r.placeholderChar, d = void 0 === p ? a.placeholderChar : p, h = r.placeholder, v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h, y = r.currentCaretPosition, m = r.keepCharPositions, b = l === !1 && void 0 !== c, g = e.length, k = c.length, C = v.length, O = t.length, T = g - k, P = T > 0, x = y + (P ? -T : 0), w = x + Math.abs(T);
                if (m === !0 && !P) {
                    for(var S = s, _ = x; _ < w; _++)v[_] === d && (S += d);
                    e = e.slice(0, x) + S + e.slice(x, g);
                }
                for(var M = e.split(s).map(function(e, t) {
                    return {
                        char: e,
                        isNew: t >= x && t < w
                    };
                }), j = g - 1; j >= 0; j--){
                    var E = M[j].char;
                    if (E !== d) {
                        var R = j >= x && k === O;
                        E === v[R ? j - T : j] && M.splice(j, 1);
                    }
                }
                var V = s, N = !1;
                e: for(var A = 0; A < C; A++){
                    var B = v[A];
                    if (B === d) {
                        if (M.length > 0) for(; M.length > 0;){
                            var I = M.shift(), F = I.char, q = I.isNew;
                            if (F === d && b !== !0) {
                                V += d;
                                continue e;
                            }
                            if (t[A].test(F)) {
                                if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                                    for(var D = M.length, L = null, W = 0; W < D; W++){
                                        var J = M[W];
                                        if (J.char !== d && J.isNew === !1) break;
                                        if (J.char === d) {
                                            L = W;
                                            break;
                                        }
                                    }
                                    null !== L ? (V += F, M.splice(L, 1)) : A--;
                                } else V += F;
                                continue e;
                            }
                            N = !0;
                        }
                        b === !1 && (V += v.substr(A, C));
                        break;
                    }
                    V += B;
                }
                if (b && P === !1) {
                    for(var U = null, H = 0; H < V.length; H++)v[H] === d && (U = H);
                    V = null !== U ? V.substr(0, U + 1) : s;
                }
                return {
                    conformedValue: V,
                    meta: {
                        someCharsRejected: N
                    }
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.default = n;
            var i = r(2), a = r(1), u = [], s = "";
        },
        function(e, t) {
            "use strict";
            function r(e) {
                var t = e.previousConformedValue, r = void 0 === t ? o : t, i = e.previousPlaceholder, a = void 0 === i ? o : i, u = e.currentCaretPosition, s = void 0 === u ? 0 : u, l = e.conformedValue, f = e.rawValue, c = e.placeholderChar, p = e.placeholder, d = e.indexesOfPipedChars, h = void 0 === d ? n : d, v = e.caretTrapIndexes, y = void 0 === v ? n : v;
                if (0 === s || !f.length) return 0;
                var m = f.length, b = r.length, g = p.length, k = l.length, C = m - b, O = C > 0, T = 0 === b, P = C > 1 && !O && !T;
                if (P) return s;
                var x = O && (r === l || l === p), w = 0, S = void 0, _ = void 0;
                if (x) w = s - C;
                else {
                    var M = l.toLowerCase(), j = f.toLowerCase(), E = j.substr(0, s).split(o), R = E.filter(function(e) {
                        return M.indexOf(e) !== -1;
                    });
                    _ = R[R.length - 1];
                    var V = a.substr(0, R.length).split(o).filter(function(e) {
                        return e !== c;
                    }).length, N = p.substr(0, R.length).split(o).filter(function(e) {
                        return e !== c;
                    }).length, A = N !== V, B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
                    !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);
                    for(var I = h.map(function(e) {
                        return M[e];
                    }), F = I.filter(function(e) {
                        return e === _;
                    }).length, q = R.filter(function(e) {
                        return e === _;
                    }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function(e, t) {
                        return e === _ && f[t] !== e;
                    }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++){
                        var U = M[J];
                        if (w = J + 1, U === _ && W++, W >= L) break;
                    }
                }
                if (O) {
                    for(var H = w, Y = w; Y <= g; Y++)if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
                } else if (S) {
                    for(var z = w - 1; z >= 0; z--)if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
                } else for(var G = w; G >= 0; G--)if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = r;
            var n = [], o = "";
        },
        function(e, t, r) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function o(e) {
                var t = {
                    previousConformedValue: void 0,
                    previousPlaceholder: void 0
                };
                return {
                    state: t,
                    update: function(r) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e, o = n.inputElement, l = n.mask, c = n.guide, y = n.pipe, b = n.placeholderChar, g = void 0 === b ? h.placeholderChar : b, k = n.keepCharPositions, C = void 0 !== k && k, O = n.showMask, T = void 0 !== O && O;
                        if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
                            ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
                            var P = void 0, x = void 0;
                            if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
                                var w = a(r), S = o.selectionEnd, _ = t.previousConformedValue, M = t.previousPlaceholder, j = void 0;
                                if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                                    if (x = l(w, {
                                        currentCaretPosition: S,
                                        previousConformedValue: _,
                                        placeholderChar: g
                                    }), x === !1) return;
                                    var E = (0, d.processCaretTraps)(x), R = E.maskWithoutCaretTraps, V = E.indexes;
                                    x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
                                } else x = l;
                                var N = {
                                    previousConformedValue: _,
                                    guide: c,
                                    placeholderChar: g,
                                    pipe: y,
                                    placeholder: P,
                                    currentCaretPosition: S,
                                    keepCharPositions: C
                                }, A = (0, p.default)(w, x, N), B = A.conformedValue, I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction, F = {};
                                I && (F = y(B, u({
                                    rawValue: w
                                }, N)), F === !1 ? F = {
                                    value: _,
                                    rejected: !0
                                } : (0, d.isString)(F) && (F = {
                                    value: F
                                }));
                                var q = I ? F.value : B, D = (0, f.default)({
                                    previousConformedValue: _,
                                    previousPlaceholder: M,
                                    conformedValue: q,
                                    placeholder: P,
                                    rawValue: w,
                                    currentCaretPosition: S,
                                    placeholderChar: g,
                                    indexesOfPipedChars: F.indexesOfPipedChars,
                                    caretTrapIndexes: j
                                }), L = q === P && 0 === D, W = T ? P : v, J = L ? W : q;
                                t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
                            }
                        }
                    }
                };
            }
            function i(e, t) {
                document.activeElement === e && (b ? g(function() {
                    return e.setSelectionRange(t, t, y);
                }, 0) : e.setSelectionRange(t, t, y));
            }
            function a(e) {
                if ((0, d.isString)(e)) return e;
                if ((0, d.isNumber)(e)) return String(e);
                if (void 0 === e || null === e) return v;
                throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.default = o;
            var l = r(4), f = n(l), c = r(3), p = n(c), d = r(2), h = r(1), v = "", y = "none", m = "object", b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent), g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
        },
        function(e, t) {
            "use strict";
            function r(e) {
                return function() {
                    return e;
                };
            }
            var n = function() {};
            n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function() {
                return this;
            }, n.thatReturnsArgument = function(e) {
                return e;
            }, e.exports = n;
        },
        function(e, t, r) {
            "use strict";
            function n(e, t, r, n, i, a, u, s) {
                if (o(t), !e) {
                    var l;
                    if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                    else {
                        var f = [
                            r,
                            n,
                            i,
                            a,
                            u,
                            s
                        ], c = 0;
                        l = new Error(t.replace(/%s/g, function() {
                            return f[c++];
                        })), l.name = "Invariant Violation";
                    }
                    throw l.framesToPop = 1, l;
                }
            }
            var o = function(e) {};
            e.exports = n;
        },
        function(e, t, r) {
            "use strict";
            var n = r(6), o = r(7), i = r(10);
            e.exports = function() {
                function e(e, t, r, n, a, u) {
                    u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t
                };
                return r.checkPropTypes = n, r.PropTypes = r, r;
            };
        },
        function(e, t, r) {
            "use strict";
            "function" == typeof Symbol && typeof Symbol.iterator, e.exports = r(8)();
        },
        function(e, t) {
            "use strict";
            var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            e.exports = r;
        },
        function(t, r) {
            t.exports = e;
        }
    ]);
});


const $b122b6f4c2345d49$export$7557bbfc76b67c44 = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { InputProps: InputProps, ...other } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6e7443fe8b63e98$exports))), {
        ...other
    });
};


const $120e0807a5c1834c$export$2c73285ae9390cec = ({ enterAction: enterAction, forceWhite: forceWhite, autocomplete: autocomplete, ...props })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const inputProps = props.component === "textarea" ? undefined : {
        InputProps: {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(props.inputstyles, (0, (/*@__PURE__*/$parcel$interopDefault($62356530d5141c13$exports))).input),
            readOnly: props.readOnly,
            autoComplete: autocomplete,
            style: {
                color: forceWhite ? "white" : theme.palette.primary.main
            }
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.Field), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($62356530d5141c13$exports))).textField, props.className, props.mask ? (0, (/*@__PURE__*/$parcel$interopDefault($62356530d5141c13$exports))).maskedStyle : undefined),
        component: props.mask ? (0, $b122b6f4c2345d49$export$7557bbfc76b67c44) : (0, $042baa64c3dff8f0$export$2c73285ae9390cec),
        variant: "outlined",
        size: "small",
        onKeyDown: (event)=>{
            if (event.key === "Enter") {
                if (enterAction) {
                    event.preventDefault();
                    enterAction();
                }
            }
        },
        ...inputProps,
        ...(0, $gSkQi.omit)(props, "className", "inputstyles")
    });
};


var $62f86c6ad1e80146$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $62f86c6ad1e80146$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$62f86c6ad1e80146$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$62f86c6ad1e80146$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$62f86c6ad1e80146$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $62f86c6ad1e80146$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $62f86c6ad1e80146$var$DIGIT_REGEX = /^\d+$/, $62f86c6ad1e80146$var$LEAD_DIGIT_REGEX = /^\d/, $62f86c6ad1e80146$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $62f86c6ad1e80146$var$MAX_CACHE_SIZE = 512;
var $62f86c6ad1e80146$var$pathCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$setCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$getCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE);
var $62f86c6ad1e80146$var$config;
$62f86c6ad1e80146$exports = {
    Cache: $62f86c6ad1e80146$var$Cache,
    split: $62f86c6ad1e80146$var$split,
    normalizePath: $62f86c6ad1e80146$var$normalizePath,
    setter: function(path) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$setCache.get(path) || $62f86c6ad1e80146$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$getCache.get(path) || $62f86c6ad1e80146$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($62f86c6ad1e80146$var$isQuoted(part) || $62f86c6ad1e80146$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $62f86c6ad1e80146$var$forEach(Array.isArray(path) ? path : $62f86c6ad1e80146$var$split(path), cb, thisArg);
    }
};
function $62f86c6ad1e80146$var$normalizePath(path) {
    return $62f86c6ad1e80146$var$pathCache.get(path) || $62f86c6ad1e80146$var$pathCache.set(path, $62f86c6ad1e80146$var$split(path).map(function(part) {
        return part.replace($62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $62f86c6ad1e80146$var$split(path) {
    return path.match($62f86c6ad1e80146$var$SPLIT_REGEX) || [
        ''
    ];
}
function $62f86c6ad1e80146$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($62f86c6ad1e80146$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $62f86c6ad1e80146$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $62f86c6ad1e80146$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $62f86c6ad1e80146$var$hasLeadingNumber(part) {
    return part.match($62f86c6ad1e80146$var$LEAD_DIGIT_REGEX) && !part.match($62f86c6ad1e80146$var$DIGIT_REGEX);
}
function $62f86c6ad1e80146$var$hasSpecialChars(part) {
    return $62f86c6ad1e80146$var$SPEC_CHAR_REGEX.test(part);
}
function $62f86c6ad1e80146$var$shouldBeQuoted(part) {
    return !$62f86c6ad1e80146$var$isQuoted(part) && ($62f86c6ad1e80146$var$hasLeadingNumber(part) || $62f86c6ad1e80146$var$hasSpecialChars(part));
}


var $4bca57257e8cec66$exports = {};
const $4bca57257e8cec66$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $4bca57257e8cec66$var$words = (str)=>str.match($4bca57257e8cec66$var$reWords) || [];
const $4bca57257e8cec66$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $4bca57257e8cec66$var$join = (str, d)=>$4bca57257e8cec66$var$words(str).join(d).toLowerCase();
const $4bca57257e8cec66$var$camelCase = (str)=>$4bca57257e8cec66$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $4bca57257e8cec66$var$pascalCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$camelCase(str));
const $4bca57257e8cec66$var$snakeCase = (str)=>$4bca57257e8cec66$var$join(str, '_');
const $4bca57257e8cec66$var$kebabCase = (str)=>$4bca57257e8cec66$var$join(str, '-');
const $4bca57257e8cec66$var$sentenceCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$join(str, ' '));
const $4bca57257e8cec66$var$titleCase = (str)=>$4bca57257e8cec66$var$words(str).map($4bca57257e8cec66$var$upperFirst).join(' ');
$4bca57257e8cec66$exports = {
    words: $4bca57257e8cec66$var$words,
    upperFirst: $4bca57257e8cec66$var$upperFirst,
    camelCase: $4bca57257e8cec66$var$camelCase,
    pascalCase: $4bca57257e8cec66$var$pascalCase,
    snakeCase: $4bca57257e8cec66$var$snakeCase,
    kebabCase: $4bca57257e8cec66$var$kebabCase,
    sentenceCase: $4bca57257e8cec66$var$sentenceCase,
    titleCase: $4bca57257e8cec66$var$titleCase
};


var $8818e0f94c57edd0$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $8818e0f94c57edd0$exports = function(edges) {
    return $8818e0f94c57edd0$var$toposort($8818e0f94c57edd0$var$uniqueNodes(edges), edges);
};
$8818e0f94c57edd0$exports.array = $8818e0f94c57edd0$var$toposort;
function $8818e0f94c57edd0$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $8818e0f94c57edd0$var$makeOutgoingEdges(edges), nodesHash = $8818e0f94c57edd0$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $8818e0f94c57edd0$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $8818e0f94c57edd0$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $8818e0f94c57edd0$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $57e52f3b537dfd4b$var$toString = Object.prototype.toString;
const $57e52f3b537dfd4b$var$errorToString = Error.prototype.toString;
const $57e52f3b537dfd4b$var$regExpToString = RegExp.prototype.toString;
const $57e52f3b537dfd4b$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $57e52f3b537dfd4b$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $57e52f3b537dfd4b$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $57e52f3b537dfd4b$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $57e52f3b537dfd4b$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $57e52f3b537dfd4b$var$symbolToString.call(val).replace($57e52f3b537dfd4b$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $57e52f3b537dfd4b$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $57e52f3b537dfd4b$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $57e52f3b537dfd4b$var$regExpToString.call(val);
    return null;
}
function $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $57e52f3b537dfd4b$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $57e52f3b537dfd4b$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $57e52f3b537dfd4b$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $57e52f3b537dfd4b$var$_Symbol$toStringTag;
let $57e52f3b537dfd4b$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$57e52f3b537dfd4b$var$_Symbol$toStringTag = Symbol.toStringTag;
class $57e52f3b537dfd4b$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($57e52f3b537dfd4b$var$strReg, (_, key)=>$57e52f3b537dfd4b$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this[$57e52f3b537dfd4b$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $57e52f3b537dfd4b$var$toArray(errorOrErrors).forEach((err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (!disableStack && Error.captureStackTrace) Error.captureStackTrace(this, $57e52f3b537dfd4b$export$2191b9da168c6cf0);
    }
}
let $57e52f3b537dfd4b$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $57e52f3b537dfd4b$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $57e52f3b537dfd4b$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $57e52f3b537dfd4b$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $57e52f3b537dfd4b$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $57e52f3b537dfd4b$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $57e52f3b537dfd4b$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $57e52f3b537dfd4b$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError($57e52f3b537dfd4b$var$mixed.notType, params);
    }
};
var $57e52f3b537dfd4b$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $57e52f3b537dfd4b$var$mixed,
    string: $57e52f3b537dfd4b$var$string,
    number: $57e52f3b537dfd4b$var$number,
    date: $57e52f3b537dfd4b$var$date,
    object: $57e52f3b537dfd4b$var$object,
    array: $57e52f3b537dfd4b$var$array,
    boolean: $57e52f3b537dfd4b$var$boolean,
    tuple: $57e52f3b537dfd4b$var$tuple
});
const $57e52f3b537dfd4b$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $57e52f3b537dfd4b$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $57e52f3b537dfd4b$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $57e52f3b537dfd4b$var$prefixes = {
    context: '$',
    value: '.'
};
function $57e52f3b537dfd4b$export$eff4d24c3ff7876e(key, options) {
    return new $57e52f3b537dfd4b$var$Reference(key, options);
}
class $57e52f3b537dfd4b$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $57e52f3b537dfd4b$var$prefixes.context;
        this.isValue = this.key[0] === $57e52f3b537dfd4b$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $57e52f3b537dfd4b$var$prefixes.context : this.isValue ? $57e52f3b537dfd4b$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $62f86c6ad1e80146$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$57e52f3b537dfd4b$var$Reference.prototype.__isYupRef = true;
const $57e52f3b537dfd4b$var$isAbsent = (value)=>value == null;
function $57e52f3b537dfd4b$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $57e52f3b537dfd4b$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            var _overrides$disableSta;
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $57e52f3b537dfd4b$export$2191b9da168c6cf0($57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, (_overrides$disableSta = overrides.disableStackTrace) != null ? _overrides$disableSta : disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $57e52f3b537dfd4b$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $57e52f3b537dfd4b$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $62f86c6ad1e80146$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $57e52f3b537dfd4b$export$cfedb76369cc7782(obj, path, value, context) {
    return $57e52f3b537dfd4b$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $57e52f3b537dfd4b$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($57e52f3b537dfd4b$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $57e52f3b537dfd4b$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $57e52f3b537dfd4b$var$clone(src, seen = new Map()) {
    if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $57e52f3b537dfd4b$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $57e52f3b537dfd4b$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this._blacklist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $57e52f3b537dfd4b$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $57e52f3b537dfd4b$var$isAbsent(result)) return result;
            let formattedValue = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value);
            let formattedResult = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${value ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $57e52f3b537dfd4b$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $57e52f3b537dfd4b$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $57e52f3b537dfd4b$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $57e52f3b537dfd4b$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $57e52f3b537dfd4b$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $57e52f3b537dfd4b$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $57e52f3b537dfd4b$var$toArray(keys).map((key)=>new $57e52f3b537dfd4b$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $57e52f3b537dfd4b$var$Condition(deps, options) : $57e52f3b537dfd4b$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $57e52f3b537dfd4b$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $57e52f3b537dfd4b$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $57e52f3b537dfd4b$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.notOneOf;
const $57e52f3b537dfd4b$var$returnsTrue = ()=>true;
function $57e52f3b537dfd4b$export$9b30b6294c1449a8(spec) {
    return new $57e52f3b537dfd4b$export$1e88358c94ddec71(spec);
}
class $57e52f3b537dfd4b$export$1e88358c94ddec71 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $57e52f3b537dfd4b$var$returnsTrue
        }, spec));
    }
}
$57e52f3b537dfd4b$export$9b30b6294c1449a8.prototype = $57e52f3b537dfd4b$export$1e88358c94ddec71.prototype;
function $57e52f3b537dfd4b$export$87b259aa03e3d267() {
    return new $57e52f3b537dfd4b$export$c7980688f11e1f49();
}
class $57e52f3b537dfd4b$export$c7980688f11e1f49 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$57e52f3b537dfd4b$export$87b259aa03e3d267.prototype = $57e52f3b537dfd4b$export$c7980688f11e1f49.prototype;
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $57e52f3b537dfd4b$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $57e52f3b537dfd4b$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $57e52f3b537dfd4b$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $57e52f3b537dfd4b$var$isTrimmed = (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.trim();
let $57e52f3b537dfd4b$var$objStringTag = ({}).toString();
function $57e52f3b537dfd4b$export$22b082955e083ec3() {
    return new $57e52f3b537dfd4b$export$49bf8b2ede5138eb();
}
class $57e52f3b537dfd4b$export$49bf8b2ede5138eb extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $57e52f3b537dfd4b$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $57e52f3b537dfd4b$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $57e52f3b537dfd4b$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $57e52f3b537dfd4b$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $57e52f3b537dfd4b$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $57e52f3b537dfd4b$var$string.email) {
        return this.matches($57e52f3b537dfd4b$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $57e52f3b537dfd4b$var$string.url) {
        return this.matches($57e52f3b537dfd4b$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $57e52f3b537dfd4b$var$string.uuid) {
        return this.matches($57e52f3b537dfd4b$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $57e52f3b537dfd4b$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $57e52f3b537dfd4b$var$isTrimmed
        });
    }
    lowercase(message = $57e52f3b537dfd4b$var$string.lowercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $57e52f3b537dfd4b$var$string.uppercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$57e52f3b537dfd4b$export$22b082955e083ec3.prototype = $57e52f3b537dfd4b$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $57e52f3b537dfd4b$var$isNaN$1 = (value)=>value != +value;
function $57e52f3b537dfd4b$export$98e628dec113755e() {
    return new $57e52f3b537dfd4b$export$f192ec5e9228ab19();
}
class $57e52f3b537dfd4b$export$f192ec5e9228ab19 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$57e52f3b537dfd4b$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $57e52f3b537dfd4b$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $57e52f3b537dfd4b$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $57e52f3b537dfd4b$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $57e52f3b537dfd4b$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $57e52f3b537dfd4b$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $57e52f3b537dfd4b$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$57e52f3b537dfd4b$export$98e628dec113755e.prototype = $57e52f3b537dfd4b$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $57e52f3b537dfd4b$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $57e52f3b537dfd4b$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
function $57e52f3b537dfd4b$var$parseIsoDate(date) {
    const regexResult = $57e52f3b537dfd4b$var$isoReg.exec(date);
    if (!regexResult) return Date.parse ? Date.parse(date) : Number.NaN;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    const struct = {
        year: $57e52f3b537dfd4b$var$toNumber(regexResult[1]),
        month: $57e52f3b537dfd4b$var$toNumber(regexResult[2], 1) - 1,
        day: $57e52f3b537dfd4b$var$toNumber(regexResult[3], 1),
        hour: $57e52f3b537dfd4b$var$toNumber(regexResult[4]),
        minute: $57e52f3b537dfd4b$var$toNumber(regexResult[5]),
        second: $57e52f3b537dfd4b$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $57e52f3b537dfd4b$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[10]),
        minuteOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[11])
    };
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
let $57e52f3b537dfd4b$var$invalidDate = new Date('');
let $57e52f3b537dfd4b$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $57e52f3b537dfd4b$export$324d90190a8b822a() {
    return new $57e52f3b537dfd4b$export$18ec3cc5a157503f();
}
class $57e52f3b537dfd4b$export$18ec3cc5a157503f extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $57e52f3b537dfd4b$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $57e52f3b537dfd4b$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$57e52f3b537dfd4b$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $57e52f3b537dfd4b$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
$57e52f3b537dfd4b$export$324d90190a8b822a.prototype = $57e52f3b537dfd4b$export$18ec3cc5a157503f.prototype;
$57e52f3b537dfd4b$export$324d90190a8b822a.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
// @ts-expect-error
function $57e52f3b537dfd4b$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $62f86c6ad1e80146$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($57e52f3b537dfd4b$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($8818e0f94c57edd0$exports))).array(Array.from(nodes), edges).reverse();
}
function $57e52f3b537dfd4b$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $57e52f3b537dfd4b$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $57e52f3b537dfd4b$var$findIndex(keys, a) - $57e52f3b537dfd4b$var$findIndex(keys, b);
    };
}
const $57e52f3b537dfd4b$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $57e52f3b537dfd4b$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $57e52f3b537dfd4b$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $57e52f3b537dfd4b$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($57e52f3b537dfd4b$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $57e52f3b537dfd4b$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $62f86c6ad1e80146$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $62f86c6ad1e80146$exports.getter)((0, $62f86c6ad1e80146$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $57e52f3b537dfd4b$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $57e52f3b537dfd4b$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $57e52f3b537dfd4b$var$defaultSort = $57e52f3b537dfd4b$var$sortByKeyOrder([]);
function $57e52f3b537dfd4b$export$be5493f9613cbbe(spec) {
    return new $57e52f3b537dfd4b$export$18b4fc70ec7eccf8(spec);
}
class $57e52f3b537dfd4b$export$18b4fc70ec7eccf8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $57e52f3b537dfd4b$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $57e52f3b537dfd4b$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $57e52f3b537dfd4b$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$57e52f3b537dfd4b$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $57e52f3b537dfd4b$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $57e52f3b537dfd4b$var$sortFields(shape, excludedEdges);
        next._sortErrors = $57e52f3b537dfd4b$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $57e52f3b537dfd4b$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $62f86c6ad1e80146$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($57e52f3b537dfd4b$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    noUnknown(noAllow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $57e52f3b537dfd4b$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $4bca57257e8cec66$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $4bca57257e8cec66$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $4bca57257e8cec66$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$57e52f3b537dfd4b$export$be5493f9613cbbe.prototype = $57e52f3b537dfd4b$export$18b4fc70ec7eccf8.prototype;
function $57e52f3b537dfd4b$export$2f23118c22fb2630(type) {
    return new $57e52f3b537dfd4b$export$4347112b8447a7d(type);
}
class $57e52f3b537dfd4b$export$4347112b8447a7d extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $57e52f3b537dfd4b$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $57e52f3b537dfd4b$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $57e52f3b537dfd4b$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $57e52f3b537dfd4b$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$57e52f3b537dfd4b$export$2f23118c22fb2630.prototype = $57e52f3b537dfd4b$export$4347112b8447a7d.prototype;
// @ts-ignore
function $57e52f3b537dfd4b$export$65e3907585753458(schemas) {
    return new $57e52f3b537dfd4b$export$411c3b3687e8ecc8(schemas);
}
class $57e52f3b537dfd4b$export$411c3b3687e8ecc8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$57e52f3b537dfd4b$export$65e3907585753458.prototype = $57e52f3b537dfd4b$export$411c3b3687e8ecc8.prototype;
function $57e52f3b537dfd4b$export$488013bae63b21da(builder) {
    return new $57e52f3b537dfd4b$var$Lazy(builder);
}
class $57e52f3b537dfd4b$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $57e52f3b537dfd4b$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $57e52f3b537dfd4b$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $57e52f3b537dfd4b$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $57e52f3b537dfd4b$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}





var $7fPBF = parcelRequire("7fPBF");






const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $d138c1b003d294d5$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $291e2c063c5d6173$export$53b83ca8eaab0383)(result)) return systemProps;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, systemProps, result);
    };
    else finalSx = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, systemProps, inSx);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherProps, {
        sx: finalSx
    });
}




'use client';
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $450fe936b88a7a32$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $663795ec7cbfcd06$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BoxRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            as: component,
            ref: ref,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}







const $9dbabfa00f5ea67f$var$boxClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;


'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
const $77ec199cefd4182a$var$Box = (0, $bd7b6b8695507478$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $9dbabfa00f5ea67f$export$2e2bcd8739ae039).root,
    generateClassName: (0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;




var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");








'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

'use client';
let $52b16131f46e7800$var$hadKeyboardEvent = true;
let $52b16131f46e7800$var$hadFocusVisibleRecently = false;
const $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout = new (0, $9a1088a9a7141b09$export$786b4da70f00938b)();
const $52b16131f46e7800$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $52b16131f46e7800$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $52b16131f46e7800$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $52b16131f46e7800$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $52b16131f46e7800$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $52b16131f46e7800$var$handlePointerDown() {
    $52b16131f46e7800$var$hadKeyboardEvent = false;
}
function $52b16131f46e7800$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($52b16131f46e7800$var$hadFocusVisibleRecently) $52b16131f46e7800$var$hadKeyboardEvent = true;
    }
}
function $52b16131f46e7800$var$prepare(doc) {
    doc.addEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $52b16131f46e7800$var$hadKeyboardEvent || $52b16131f46e7800$var$focusTriggersKeyboardModality(target);
}
function $52b16131f46e7800$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $52b16131f46e7800$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $52b16131f46e7800$var$hadFocusVisibleRecently = true;
            $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $52b16131f46e7800$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($52b16131f46e7800$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $52b16131f46e7800$export$2e2bcd8739ae039);





var $7fPBF = parcelRequire("7fPBF");


function $69eb4698d21449e4$export$2e2bcd8739ae039() {
    $69eb4698d21449e4$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69eb4698d21449e4$export$2e2bcd8739ae039.apply(this, arguments);
}


function $ef13fb65f0a6c2b7$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $dd20db312c2129e6$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $ef13fb65f0a6c2b7$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $69eb4698d21449e4$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $e279fb69073314ca$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;








var $7fPBF = parcelRequire("7fPBF");



'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;




function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



'use client';
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;




function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



'use client';
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: ComponentProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $824c049f32d4395d$exports.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;





function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



'use client';
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            color === 'inherit' && 'colorInherit',
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'startIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'endIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;




var $7fPBF = parcelRequire("7fPBF");









function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;



'use client';
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $833ef9b800b82ea7$export$f3b76d2cce458caa), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bfb223886c302418$var$CardRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;




var $7fPBF = parcelRequire("7fPBF");











function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;



'use client';
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0bca18aab596affa$export$5e8702d71474f093), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;




var $7fPBF = parcelRequire("7fPBF");







function $dc304ab6922390a3$export$b12cb262231eef32(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiToolbar', slot);
}
const $dc304ab6922390a3$var$toolbarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $dc304ab6922390a3$export$2e2bcd8739ae039 = $dc304ab6922390a3$var$toolbarClasses;



'use client';
const $4356b5696745688a$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $4356b5696745688a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $dc304ab6922390a3$export$b12cb262231eef32), classes);
};
const $4356b5696745688a$var$ToolbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $4356b5696745688a$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $4356b5696745688a$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $4356b5696745688a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4356b5696745688a$var$ToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $4356b5696745688a$export$2e2bcd8739ae039 = $4356b5696745688a$var$Toolbar;




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");












function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;



'use client';
const $37a9e765f5011e1f$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $37a9e765f5011e1f$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $37a9e765f5011e1f$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5af8cd7874d684d8$export$c09531d8563c67a5), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $37a9e765f5011e1f$var$ListItemButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $37a9e765f5011e1f$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $37a9e765f5011e1f$var$ListItemButton = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $37a9e765f5011e1f$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $37a9e765f5011e1f$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($37a9e765f5011e1f$var$ListItemButtonRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $37a9e765f5011e1f$export$2e2bcd8739ae039 = $37a9e765f5011e1f$var$ListItemButton;




var $7fPBF = parcelRequire("7fPBF");







function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;




'use client';
const $3b977dfc67db1ec5$var$_excluded = [
    "className"
];
const $3b977dfc67db1ec5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $7a8a9052410fb062$export$81478e24460c57f2), classes);
};
const $3b977dfc67db1ec5$var$ListItemIconRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $3b977dfc67db1ec5$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $3b977dfc67db1ec5$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $3b977dfc67db1ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3b977dfc67db1ec5$var$ListItemIconRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $3b977dfc67db1ec5$export$2e2bcd8739ae039 = $3b977dfc67db1ec5$var$ListItemIcon;




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");









function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



'use client';
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;







function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;



'use client';
const $9dc4208e00f56723$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $9dc4208e00f56723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2a8a1c268392e331$export$1061006a0db3aeb5), classes);
};
const $9dc4208e00f56723$var$ListItemTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $9dc4208e00f56723$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $9dc4208e00f56723$var$_excluded);
    const { dense: dense } = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $9dc4208e00f56723$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($9dc4208e00f56723$var$ListItemTextRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $9dc4208e00f56723$export$2e2bcd8739ae039 = $9dc4208e00f56723$var$ListItemText;




var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");




var $7fPBF = parcelRequire("7fPBF");



'use client';
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/base-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/base-ui/react-no-ssr/components-api/#no-ssr)
 */ function $3fe268735c467f6a$export$24fbf80485c43cdb(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $7fPBF.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
        children: mountedState ? children : fallback
    });
}





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");









'use client';
const $a3f6f5762623b961$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a3f6f5762623b961$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a3f6f5762623b961$var$resolveContainer(containerProp);
    const transform = $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a3f6f5762623b961$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a3f6f5762623b961$var$_excluded);
    const childrenRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7fPBF.useCallback(()=>{
        if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                ref: handleRef,
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $a3f6f5762623b961$export$2e2bcd8739ae039 = $a3f6f5762623b961$var$Slide;









function $fb88ab4f6dbff241$export$b801318a856c9cd2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDrawer', slot);
}
const $fb88ab4f6dbff241$var$drawerClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $fb88ab4f6dbff241$export$2e2bcd8739ae039 = $fb88ab4f6dbff241$var$drawerClasses;



'use client';
const $fc202f2249b2dd6f$var$_excluded = [
    "BackdropProps"
], $fc202f2249b2dd6f$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $fc202f2249b2dd6f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $fc202f2249b2dd6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchor)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fb88ab4f6dbff241$export$b801318a856c9cd2), classes);
};
const $fc202f2249b2dd6f$var$DrawerRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $fc202f2249b2dd6f$var$DrawerDockedRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $fc202f2249b2dd6f$var$DrawerPaper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $fc202f2249b2dd6f$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === 'rtl' && $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) ? $fc202f2249b2dd6f$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $fc202f2249b2dd6f$var$Drawer = /*#__PURE__*/ $7fPBF.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $a3f6f5762623b961$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props.ModalProps, $fc202f2249b2dd6f$var$_excluded), other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fc202f2249b2dd6f$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $fc202f2249b2dd6f$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fc202f2249b2dd6f$var$DrawerPaper, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        in: open,
        direction: $fc202f2249b2dd6f$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fc202f2249b2dd6f$var$DrawerRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        BackdropProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $fc202f2249b2dd6f$export$2e2bcd8739ae039 = $fc202f2249b2dd6f$var$Drawer;












var $7fPBF = parcelRequire("7fPBF");






'use client';
const $5ada1aefe210ba69$var$_excluded = [
    "anchor",
    "classes",
    "className",
    "width",
    "style"
];
const $5ada1aefe210ba69$var$SwipeAreaRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1
    }, ownerState.anchor === 'left' && {
        right: 'auto'
    }, ownerState.anchor === 'right' && {
        left: 'auto',
        right: 0
    }, ownerState.anchor === 'top' && {
        bottom: 'auto',
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        bottom: 0,
        right: 0
    }));
/**
 * @ignore - internal component.
 */ const $5ada1aefe210ba69$var$SwipeArea = /*#__PURE__*/ $7fPBF.forwardRef(function SwipeArea(props, ref) {
    const { anchor: anchor, classes: classes = {}, className: className, width: width, style: style } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5ada1aefe210ba69$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5ada1aefe210ba69$var$SwipeAreaRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchor)}`], className),
        ref: ref,
        style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            [(0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor) ? 'width' : 'height']: width
        }, style),
        ownerState: ownerState
    }, other));
});
var $5ada1aefe210ba69$export$2e2bcd8739ae039 = $5ada1aefe210ba69$var$SwipeArea;



'use client';
const $a2822b215697a959$var$_excluded = [
    "BackdropProps"
], $a2822b215697a959$var$_excluded2 = [
    "anchor",
    "disableBackdropTransition",
    "disableDiscovery",
    "disableSwipeToOpen",
    "hideBackdrop",
    "hysteresis",
    "allowSwipeInChildren",
    "minFlingVelocity",
    "ModalProps",
    "onClose",
    "onOpen",
    "open",
    "PaperProps",
    "SwipeAreaProps",
    "swipeAreaWidth",
    "transitionDuration",
    "variant"
];
const $a2822b215697a959$var$UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const $a2822b215697a959$var$DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let $a2822b215697a959$var$claimedSwipeInstance = null;
function $a2822b215697a959$export$aad8462122ac592b() {
    $a2822b215697a959$var$claimedSwipeInstance = null;
}
function $a2822b215697a959$var$calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function $a2822b215697a959$var$calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function $a2822b215697a959$var$getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function $a2822b215697a959$var$getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function $a2822b215697a959$var$getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function $a2822b215697a959$var$computeHasNativeHandler({ domTreeShapes: domTreeShapes, start: start, current: current, anchor: anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const $a2822b215697a959$var$iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const $a2822b215697a959$var$SwipeableDrawer = /*#__PURE__*/ $7fPBF.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, $71102aa90e2b2620$export$2e2bcd8739ae039)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchor = 'left', disableBackdropTransition: disableBackdropTransition = false, disableDiscovery: disableDiscovery = false, disableSwipeToOpen: disableSwipeToOpen = $a2822b215697a959$var$iOS, hideBackdrop: hideBackdrop, hysteresis: hysteresis = 0.52, allowSwipeInChildren: allowSwipeInChildren = false, minFlingVelocity: minFlingVelocity = 450, ModalProps: { BackdropProps: BackdropProps } = {}, onClose: onClose, onOpen: onOpen, open: open = false, PaperProps: PaperProps = {}, SwipeAreaProps: SwipeAreaProps, swipeAreaWidth: swipeAreaWidth = 20, transitionDuration: transitionDuration = transitionDurationDefault, variant: variant = 'temporary' // Mobile first.
     } = props, ModalPropsProp = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props.ModalProps, $a2822b215697a959$var$_excluded), other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a2822b215697a959$var$_excluded2);
    const [maybeSwiping, setMaybeSwiping] = $7fPBF.useState(false);
    const swipeInstance = $7fPBF.useRef({
        isSwiping: null
    });
    const swipeAreaRef = $7fPBF.useRef();
    const backdropRef = $7fPBF.useRef();
    const paperRef = $7fPBF.useRef();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(PaperProps.ref, paperRef);
    const touchDetected = $7fPBF.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = $7fPBF.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = $7fPBF.useCallback((translate, options = {})=>{
        const { mode: mode = null, changeTransition: changeTransition = true } = options;
        const anchorRtl = (0, $fc202f2249b2dd6f$export$830f4f08342d299e)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].indexOf(anchorRtl) !== -1 ? 1 : -1;
        const horizontalSwipe = (0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.webkitTransform = transform;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode: mode
        }));
        if (changeTransition) {
            drawerStyle.webkitTransition = transition;
            drawerStyle.transition = transition;
        }
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / $a2822b215697a959$var$getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) {
                backdropStyle.webkitTransition = transition;
                backdropStyle.transition = transition;
            }
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (!touchDetected.current) return;
        $a2822b215697a959$var$claimedSwipeInstance = null;
        touchDetected.current = false;
        $fw0lo.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, $fc202f2249b2dd6f$export$830f4f08342d299e)(theme, anchor);
        const horizontal = (0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor);
        let current;
        if (horizontal) current = $a2822b215697a959$var$calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, $9502daaf177b272b$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        else current = $a2822b215697a959$var$calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = $a2822b215697a959$var$getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = $a2822b215697a959$var$getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition($a2822b215697a959$var$getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) $fw0lo.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition($a2822b215697a959$var$getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -$a2822b215697a959$var$DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if ($a2822b215697a959$var$claimedSwipeInstance !== null && $a2822b215697a959$var$claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, $fc202f2249b2dd6f$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor);
        const currentX = $a2822b215697a959$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $9502daaf177b272b$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const currentY = $a2822b215697a959$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        if (open && paperRef.current.contains(nativeEvent.target) && $a2822b215697a959$var$claimedSwipeInstance === null) {
            const domTreeShapes = $a2822b215697a959$var$getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = $a2822b215697a959$var$computeHasNativeHandler({
                domTreeShapes: domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor: anchor
            });
            if (hasNativeHandler) {
                $a2822b215697a959$var$claimedSwipeInstance = true;
                return;
            }
            $a2822b215697a959$var$claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > $a2822b215697a959$var$UNCERTAINTY_THRESHOLD : dy > dx && dy > $a2822b215697a959$var$UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > $a2822b215697a959$var$UNCERTAINTY_THRESHOLD : dx > $a2822b215697a959$var$UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= $a2822b215697a959$var$DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= $a2822b215697a959$var$DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = $a2822b215697a959$var$getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = $a2822b215697a959$var$getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) return;
        const anchorRtl = (0, $fc202f2249b2dd6f$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $fc202f2249b2dd6f$export$2a62b49acb270576)(anchor);
        const currentX = $a2822b215697a959$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $9502daaf177b272b$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const currentY = $a2822b215697a959$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        if (!open) {
            var _paperRef$current;
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || (_paperRef$current = paperRef.current) != null && _paperRef$current.contains(nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        $a2822b215697a959$var$claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    $7fPBF.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    $7fPBF.useEffect(()=>()=>{
            // We need to release the lock.
            if ($a2822b215697a959$var$claimedSwipeInstance === swipeInstance.current) $a2822b215697a959$var$claimedSwipeInstance = null;
        }, []);
    $7fPBF.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fc202f2249b2dd6f$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    BackdropProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, BackdropProps, {
                        ref: backdropRef
                    })
                }, variant === 'temporary' && {
                    keepMounted: true
                }, ModalPropsProp),
                hideBackdrop: hideBackdrop,
                PaperProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, PaperProps, {
                    style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                    }, PaperProps.style),
                    ref: handleRef
                }),
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref
            }, other)),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fe268735c467f6a$export$24fbf80485c43cdb), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ada1aefe210ba69$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    anchor: anchor,
                    ref: swipeAreaRef,
                    width: swipeAreaWidth
                }, SwipeAreaProps))
            })
        ]
    });
});
var $a2822b215697a959$export$2e2bcd8739ae039 = $a2822b215697a959$var$SwipeableDrawer;





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");







function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;




function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;



'use client';
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $64f614045184fa19$export$61b0ee1f05fb344e), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $18611d95980659c6$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;


var $4ea5bc7634d29699$exports = {};

$parcel$export($4ea5bc7634d29699$exports, "credits", function () { return $4ea5bc7634d29699$export$68c7321cb43cac49; }, function (v) { return $4ea5bc7634d29699$export$68c7321cb43cac49 = v; });
$parcel$export($4ea5bc7634d29699$exports, "itemDiv", function () { return $4ea5bc7634d29699$export$64c46d98173ac23d; }, function (v) { return $4ea5bc7634d29699$export$64c46d98173ac23d = v; });
$parcel$export($4ea5bc7634d29699$exports, "section", function () { return $4ea5bc7634d29699$export$fe2e36411d703b3d; }, function (v) { return $4ea5bc7634d29699$export$fe2e36411d703b3d = v; });
$parcel$export($4ea5bc7634d29699$exports, "switchListItem", function () { return $4ea5bc7634d29699$export$187ffba5827d73c1; }, function (v) { return $4ea5bc7634d29699$export$187ffba5827d73c1 = v; });
var $4ea5bc7634d29699$export$68c7321cb43cac49;
var $4ea5bc7634d29699$export$64c46d98173ac23d;
var $4ea5bc7634d29699$export$fe2e36411d703b3d;
var $4ea5bc7634d29699$export$187ffba5827d73c1;
$4ea5bc7634d29699$export$68c7321cb43cac49 = `_6bD44q_credits`;
$4ea5bc7634d29699$export$64c46d98173ac23d = `_6bD44q_itemDiv`;
$4ea5bc7634d29699$export$fe2e36411d703b3d = `_6bD44q_section`;
$4ea5bc7634d29699$export$187ffba5827d73c1 = `_6bD44q_switchListItem`;




parcelRequire("7fPBF");
var $398befd0219a83fb$exports = {};

$parcel$export($398befd0219a83fb$exports, "detailImage", function () { return $398befd0219a83fb$export$1261c05e3402cdf2; }, function (v) { return $398befd0219a83fb$export$1261c05e3402cdf2 = v; });
$parcel$export($398befd0219a83fb$exports, "detailImageContainer", function () { return $398befd0219a83fb$export$89fdba67c3a1110d; }, function (v) { return $398befd0219a83fb$export$89fdba67c3a1110d = v; });
$parcel$export($398befd0219a83fb$exports, "detailPrimary", function () { return $398befd0219a83fb$export$ca81f6971b143cb4; }, function (v) { return $398befd0219a83fb$export$ca81f6971b143cb4 = v; });
$parcel$export($398befd0219a83fb$exports, "detailSecondary", function () { return $398befd0219a83fb$export$4a89720b38d5f13; }, function (v) { return $398befd0219a83fb$export$4a89720b38d5f13 = v; });
$parcel$export($398befd0219a83fb$exports, "itemDiv", function () { return $398befd0219a83fb$export$64c46d98173ac23d; }, function (v) { return $398befd0219a83fb$export$64c46d98173ac23d = v; });
$parcel$export($398befd0219a83fb$exports, "itemWithDetailImage", function () { return $398befd0219a83fb$export$886c112e510b9adc; }, function (v) { return $398befd0219a83fb$export$886c112e510b9adc = v; });
$parcel$export($398befd0219a83fb$exports, "listItemText", function () { return $398befd0219a83fb$export$2ab83cbe0c8c2a2e; }, function (v) { return $398befd0219a83fb$export$2ab83cbe0c8c2a2e = v; });
$parcel$export($398befd0219a83fb$exports, "loadingDiv", function () { return $398befd0219a83fb$export$dded2af20345efaa; }, function (v) { return $398befd0219a83fb$export$dded2af20345efaa = v; });
$parcel$export($398befd0219a83fb$exports, "titlePrimary", function () { return $398befd0219a83fb$export$786f5116b95ed990; }, function (v) { return $398befd0219a83fb$export$786f5116b95ed990 = v; });
$parcel$export($398befd0219a83fb$exports, "titleSecondary", function () { return $398befd0219a83fb$export$8c60335655810146; }, function (v) { return $398befd0219a83fb$export$8c60335655810146 = v; });
var $398befd0219a83fb$export$1261c05e3402cdf2;
var $398befd0219a83fb$export$89fdba67c3a1110d;
var $398befd0219a83fb$export$ca81f6971b143cb4;
var $398befd0219a83fb$export$4a89720b38d5f13;
var $398befd0219a83fb$export$64c46d98173ac23d;
var $398befd0219a83fb$export$886c112e510b9adc;
var $398befd0219a83fb$export$2ab83cbe0c8c2a2e;
var $398befd0219a83fb$export$dded2af20345efaa;
var $398befd0219a83fb$export$786f5116b95ed990;
var $398befd0219a83fb$export$8c60335655810146;
$398befd0219a83fb$export$1261c05e3402cdf2 = `YDK1ma_detailImage`;
$398befd0219a83fb$export$89fdba67c3a1110d = `YDK1ma_detailImageContainer`;
$398befd0219a83fb$export$ca81f6971b143cb4 = `YDK1ma_detailPrimary`;
$398befd0219a83fb$export$4a89720b38d5f13 = `YDK1ma_detailSecondary`;
$398befd0219a83fb$export$64c46d98173ac23d = `YDK1ma_itemDiv`;
$398befd0219a83fb$export$886c112e510b9adc = `YDK1ma_itemWithDetailImage`;
$398befd0219a83fb$export$2ab83cbe0c8c2a2e = `YDK1ma_listItemText`;
$398befd0219a83fb$export$dded2af20345efaa = `YDK1ma_loadingDiv`;
$398befd0219a83fb$export$786f5116b95ed990 = `YDK1ma_titlePrimary`;
$398befd0219a83fb$export$8c60335655810146 = `YDK1ma_titleSecondary`;




parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");










function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;



'use client';
const $d513166e63c42433$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $d513166e63c42433$var$_ = (t)=>t, $d513166e63c42433$var$_t, $d513166e63c42433$var$_t2, $d513166e63c42433$var$_t3, $d513166e63c42433$var$_t4;
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($d513166e63c42433$var$_t || ($d513166e63c42433$var$_t = $d513166e63c42433$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $d513166e63c42433$var$circularDashKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($d513166e63c42433$var$_t2 || ($d513166e63c42433$var$_t2 = $d513166e63c42433$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $978389e4a0c045ec$export$29cad1383b3f235d), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($d513166e63c42433$var$_t3 || ($d513166e63c42433$var$_t3 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $d513166e63c42433$var$circularRotateKeyframe));
const $d513166e63c42433$var$CircularProgressSVG = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($d513166e63c42433$var$_t4 || ($d513166e63c42433$var$_t4 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $d513166e63c42433$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d513166e63c42433$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;


var $6a0893274e26732d$exports = {};

$parcel$export($6a0893274e26732d$exports, "circularProgress", function () { return $6a0893274e26732d$export$c4b0f5819f6a6663; }, function (v) { return $6a0893274e26732d$export$c4b0f5819f6a6663 = v; });
var $6a0893274e26732d$export$c4b0f5819f6a6663;
$6a0893274e26732d$export$c4b0f5819f6a6663 = `XD-SPW_circularProgress`;


const $dd361f89d7477c83$export$9fdd0c2f06d5e539 = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        style: props.style,
        sx: {
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6a0893274e26732d$exports))).circularProgress,
            ...props,
            color: "primary"
        })
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $7edaedb19f2ab30e$exports = {};

$parcel$export($7edaedb19f2ab30e$exports, "container", function () { return $7edaedb19f2ab30e$export$34e0f9847d4c02dd; }, function (v) { return $7edaedb19f2ab30e$export$34e0f9847d4c02dd = v; });
$parcel$export($7edaedb19f2ab30e$exports, "image", function () { return $7edaedb19f2ab30e$export$5c452ff88e35e47d; }, function (v) { return $7edaedb19f2ab30e$export$5c452ff88e35e47d = v; });
$parcel$export($7edaedb19f2ab30e$exports, "spineImage", function () { return $7edaedb19f2ab30e$export$5c2b763bdde0a23d; }, function (v) { return $7edaedb19f2ab30e$export$5c2b763bdde0a23d = v; });
var $7edaedb19f2ab30e$export$34e0f9847d4c02dd;
var $7edaedb19f2ab30e$export$5c452ff88e35e47d;
var $7edaedb19f2ab30e$export$5c2b763bdde0a23d;
$7edaedb19f2ab30e$export$34e0f9847d4c02dd = `CgT2uq_container`;
$7edaedb19f2ab30e$export$5c452ff88e35e47d = `CgT2uq_image`;
$7edaedb19f2ab30e$export$5c2b763bdde0a23d = `CgT2uq_spineImage`;



var $eb9c074921a9f549$exports = {};

(()=>{
    var e = {
        296: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, b = function() {
                return a.Date.now();
            };
            function d(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (d(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = d(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, c, u, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, c = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = b();
                    if (O(e)) return g(e);
                    u = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return u = void 0, v && o ? m(e) : (o = n = void 0, c);
                }
                function P() {
                    var e = b(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === u) return function(e) {
                            return l = e, u = setTimeout(w, t), a ? m(e) : c;
                        }(s);
                        if (f) return u = setTimeout(w, t), m(s);
                    }
                    return void 0 === u && (u = setTimeout(w, t)), c;
                }
                return t = h(t) || 0, d(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
                }, P.flush = function() {
                    return void 0 === u ? c : g(b());
                }, P;
            };
        },
        96: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", c = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), b = Object.prototype.toString, d = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && b.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, c, u, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function b(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, u = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= c;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, c - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? b(e) : (n = i = void 0, u);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? b(e) : u;
                            }(l);
                            if (p) return s = setTimeout(g, t), b(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), u;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? d(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? u : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        703: (e, t, r)=>{
            "use strict";
            var o = r(414);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, c) {
                    if (c !== o) {
                        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw u.name = "Invariant Violation", u;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        697: (e, t, r)=>{
            e.exports = r(703)();
        },
        414: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>Y,
            LazyLoadImage: ()=>ne,
            trackWindowScroll: ()=>D
        });
        const e = (parcelRequire("7fPBF"));
        var t = r.n(e), n = r(697);
        function i() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function c(e) {
            return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, c(e);
        }
        function u(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function s(e, t, r) {
            return (t = a(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function l(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, a(o.key), o);
            }
        }
        function a(e) {
            var t = function(e, t) {
                if ("object" !== c(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== c(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === c(t) ? t : String(t);
        }
        function f(e, t) {
            return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, f(e, t);
        }
        function p(e) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, p(e);
        }
        var y = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, b = {}, d = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && f(e, t);
            }(h, e);
            var r, o, n, a, d = (n = h, a = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = p(n);
                if (a) {
                    var r = p(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === c(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function h(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, h), (t = d.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && i(), t.supportsObserver) {
                    var r = e.threshold;
                    t.observer = function(e) {
                        return b[e] = b[e] || new IntersectionObserver(y, {
                            rootMargin: e + "px"
                        }), b[e];
                    }(r);
                }
                return t;
            }
            return r = h, o = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = this.placeholder.style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, c = t.x + window.innerWidth, u = t.y;
                        return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, c = r.style, l = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var a = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? u(Object(r), !0).forEach(function(t) {
                                    s(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, c);
                        return void 0 !== l && (a.width = l), void 0 !== n && (a.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: a
                        }, i);
                    }
                }
            ], o && l(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), h;
        }(t().Component);
        d.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, d.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const h = d;
        var v = r(296), m = r.n(v), O = r(96), w = r.n(O), g = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const P = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(g(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function j(e) {
            return j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, j(e);
        }
        var T = [
            "delayMethod",
            "delayTime"
        ];
        function S() {
            return S = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, S.apply(this, arguments);
        }
        function E(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== j(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== j(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === j(n) ? n : String(n)), o);
            }
            var n;
        }
        function L(e, t) {
            return L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, L(e, t);
        }
        function _(e, t) {
            if (t && ("object" === j(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return I(e);
        }
        function I(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function x(e) {
            return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, x(e);
        }
        var R = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, k = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const D = function(e) {
            var r = function(r) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && L(e, t);
                }(l, r);
                var o, n, c, u, s = (c = l, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = x(c);
                    if (u) {
                        var r = x(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return _(this, e);
                });
                function l(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, l), (r = s.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && i(), r.useIntersectionObserver) return _(r);
                    var o = r.onChangeScroll.bind(I(r));
                    return "debounce" === e.delayMethod ? r.delayedScroll = m()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = w()(o, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: R(),
                            y: k()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                return o = l, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || P(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = P(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: R(),
                                    y: k()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r, o, n = {}, i = Object.keys(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                    return n;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, T)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, S({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], E(o.prototype, n), Object.defineProperty(o, "prototype", {
                    writable: !1
                }), l;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function C(e) {
            return C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, C(e);
        }
        function B(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== C(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== C(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === C(n) ? n : String(n)), o);
            }
            var n;
        }
        function M(e, t) {
            return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, M(e, t);
        }
        function N(e) {
            return N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, N(e);
        }
        var V = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && M(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = N(n);
                if (i) {
                    var r = N(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === C(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), c.call(this, e);
            }
            return r = u, o = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(h, this.props);
                    }
                }
            ], B(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        const W = D(V);
        function z(e) {
            return z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, z(e);
        }
        function $(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== z(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== z(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === z(n) ? n : String(n)), o);
            }
            var n;
        }
        function U(e, t) {
            return U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, U(e, t);
        }
        function F(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function q(e) {
            return q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, q(e);
        }
        var H = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && U(e, t);
            }(s, e);
            var r, o, n, c, u = (n = s, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = q(n);
                if (c) {
                    var r = q(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === z(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return F(e);
                }(this, e);
            });
            function s(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, s), t = u.call(this, e);
                var r = e.afterLoad, o = e.beforeLoad, n = e.scrollPosition, i = e.visibleByDefault;
                return t.state = {
                    visible: i
                }, i && (o(), r()), t.onVisible = t.onVisible.bind(F(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
            }
            return r = s, o = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && i() ? t().createElement(h, {
                            className: r,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement(W, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], $(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), s;
        }(t().Component);
        H.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, H.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const Y = H;
        function X(e) {
            return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, X(e);
        }
        var A = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function G(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function J(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? G(Object(r), !0).forEach(function(t) {
                    K(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function K(e, t, r) {
            return (t = ee(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function Q() {
            return Q = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, Q.apply(this, arguments);
        }
        function Z(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ee(o.key), o);
            }
        }
        function ee(e) {
            var t = function(e, t) {
                if ("object" !== X(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== X(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === X(t) ? t : String(t);
        }
        function te(e, t) {
            return te = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, te(e, t);
        }
        function re(e) {
            return re = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, re(e);
        }
        var oe = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && te(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = re(n);
                if (i) {
                    var r = re(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === X(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (t = c.call(this, e)).state = {
                    loaded: !1
                }, t;
            }
            return r = u, o = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r, o, n = {}, i = Object.keys(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                return n;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, A));
                        return t().createElement("img", Q({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(Y, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: c,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, c = r.width, u = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", Q({
                            className: u + " lazy-load-image-background " + o + a,
                            style: J(J({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: c
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, c = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
                    }
                }
            ], Z(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        oe.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, oe.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const ne = oe;
    })(), $eb9c074921a9f549$exports = o;
})();



const $74a5752378f7da5e$export$734d4481083c9058 = {
    rotate: (image, angle)=>{
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = angle % 180 === 0 ? image.width : image.height;
        canvas.height = angle % 180 === 0 ? image.height : image.width;
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(angle * Math.PI / 180);
        ctx.drawImage(image, image.width / -2, image.height / -2);
        return canvas.toDataURL();
    },
    getDominantColor: (img, sampleSize = 64)=>{
        const canvas = document.createElement("canvas");
        canvas.width = sampleSize;
        canvas.height = sampleSize;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, sampleSize, sampleSize);
        const { data: data } = ctx.getImageData(0, 0, sampleSize, sampleSize);
        let r = 0, g = 0, b = 0, count = 0;
        for(let i = 0; i < data.length; i += 4){
            const alpha = data[i + 3];
            if (alpha < 128) continue; // skip transparent pixels
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
            count += 1;
        }
        if (count === 0) return "#000";
        r = Math.round(r / count);
        g = Math.round(g / count);
        b = Math.round(b / count);
        return "#" + [
            r,
            g,
            b
        ].map((v)=>v.toString(16).padStart(2, "0")).join("");
    }
};


const $d382a64001e41b44$export$ecab9f5b11b61692 = ({ className: className, imageClassName: imageClassName, style: style, thumbnail: thumbnail, image: image, defaultImage: defaultImage, beforeLoad: beforeLoad, imageStyle: imageStyle, alt: alt, canMagnify: canMagnify, forceHorizontal: forceHorizontal, forceVertical: forceVertical, tintColor: tintColor, waitUntilImageIsFinal: waitUntilImageIsFinal })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [[x, y], setXY] = (0, $7fPBF.useState)([
        0,
        0
    ]);
    const [[imgWidth, imgHeight], setSize] = (0, $7fPBF.useState)([
        0,
        0
    ]);
    const [showMagnifier, setShowMagnifier] = (0, $7fPBF.useState)(false);
    const [finalImage, setFinalImage] = (0, $7fPBF.useState)({
        image: defaultImage,
        isSpine: false,
        isFinal: false
    });
    const magnifierHeight = 200;
    const magnifierWidth = 200;
    const zoomLevel = 3;
    const updateDimensions = (source)=>{
        const image = new Image();
        image.src = source;
        image.onload = function() {
            if (forceVertical && image.height < image.width) setFinalImage({
                image: (0, $74a5752378f7da5e$export$734d4481083c9058).rotate(image, 90),
                isSpine: true,
                isFinal: true
            });
            else if (forceHorizontal && image.height > image.width) setFinalImage({
                image: (0, $74a5752378f7da5e$export$734d4481083c9058).rotate(image, -90),
                isSpine: false,
                isFinal: true
            });
            else setFinalImage({
                image: source,
                isSpine: image.height > image.width,
                isFinal: true
            });
        };
    };
    (0, $7fPBF.useEffect)(()=>{
        const imageData = image ? `data:image/png;base64,${image}` : undefined;
        const thumbnailData = thumbnail ? `data:image/png;base64,${thumbnail}` : undefined;
        updateDimensions(imageData ?? thumbnailData ?? defaultImage);
    }, [
        image,
        thumbnail,
        defaultImage,
        forceHorizontal,
        forceVertical
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7edaedb19f2ab30e$exports))).container, className),
        style: {
            opacity: !waitUntilImageIsFinal || finalImage.isFinal ? 1 : 0,
            backgroundColor: "transparent",
            cursor: canMagnify ? "none" : "auto",
            ...style
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $eb9c074921a9f549$exports.LazyLoadComponent), {
            style: {
                display: "flex"
            },
            beforeLoad: beforeLoad,
            placeholder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(finalImage.isSpine ? (0, (/*@__PURE__*/$parcel$interopDefault($7edaedb19f2ab30e$exports))).spineImage : (0, (/*@__PURE__*/$parcel$interopDefault($7edaedb19f2ab30e$exports))).image, imageClassName),
                style: imageStyle,
                src: thumbnail ? `data:image/png;base64,${thumbnail}` : defaultImage,
                alt: alt
            }),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(finalImage.isSpine ? (0, (/*@__PURE__*/$parcel$interopDefault($7edaedb19f2ab30e$exports))).spineImage : (0, (/*@__PURE__*/$parcel$interopDefault($7edaedb19f2ab30e$exports))).image, imageClassName),
                    style: imageStyle,
                    src: finalImage.image,
                    alt: alt,
                    onMouseEnter: (event)=>{
                        const element = event.currentTarget;
                        const { width: width, height: height } = element.getBoundingClientRect();
                        setSize([
                            width,
                            height
                        ]);
                        setShowMagnifier(true);
                    },
                    onMouseMove: (event)=>{
                        const element = event.currentTarget;
                        const { top: top, left: left } = element.getBoundingClientRect();
                        const x = event.pageX - left - window.scrollX;
                        const y = event.pageY - top - window.scrollY;
                        setXY([
                            x,
                            y
                        ]);
                    },
                    onMouseLeave: ()=>setShowMagnifier(false)
                }),
                tintColor && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backgroundColor: tintColor,
                        opacity: 0.5,
                        top: 0
                    }
                }),
                canMagnify && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        display: showMagnifier ? "" : "none",
                        position: "absolute",
                        pointerEvents: "none",
                        height: `${magnifierHeight}px`,
                        width: `${magnifierWidth}px`,
                        top: `${y - magnifierHeight / 2}px`,
                        left: `${x - magnifierWidth / 2}px`,
                        opacity: "1",
                        border: `1px solid ${theme.palette.secondary.main}`,
                        backgroundColor: theme.palette.background.default,
                        backgroundImage: `url(data:image/png;base64,${image})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
                        backgroundPositionX: `${-x * zoomLevel + magnifierWidth / 2}px`,
                        backgroundPositionY: `${-y * zoomLevel + magnifierHeight / 2}px`
                    }
                })
            ]
        })
    });
};



const $e4955c42ad8c479d$export$b91134a44a869282 = ({ title: title, style: style, detail: detail, subtitle: subtitle, leftSubtitle: leftSubtitle, titleColor: titleColor, textColor: textColor, isLoading: isLoading, onClick: onClick, iconType: iconType, theNewIconType: theNewIconType, rightIconType: rightIconType, detailImage: detailImage, disabled: disabled, boldTitle: boldTitle, detailBlurred: detailBlurred, children: children })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
        className: detailImage ? (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).itemWithDetailImage : (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).itemWithoutDetailImage,
        sx: {
            opacity: "1 !important"
        },
        style: style,
        onClick: (event)=>{
            if (onClick) onClick(event);
        },
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).itemDiv,
                children: [
                    iconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: iconType
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                        primary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).titlePrimary,
                            component: "div",
                            style: {
                                color: titleColor ?? theme.palette.primary.main,
                                fontWeight: boldTitle ? "bold" : "normal"
                            },
                            children: title
                        }),
                        secondary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).titleSecondary,
                            component: "div",
                            style: {
                                color: theme.palette.primary.subtitle
                            },
                            children: leftSubtitle
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).loadingDiv,
                        children: isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : theNewIconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: theNewIconType
                            })
                        })
                    }),
                    children,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).listItemText,
                        primary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).detailPrimary,
                            component: "div",
                            style: {
                                color: textColor ?? theme.palette.primary.main,
                                filter: detailBlurred ? "blur(4px)" : undefined
                            },
                            children: detail
                        }),
                        secondary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).detailSecondary,
                            component: "div",
                            style: {
                                color: theme.palette.primary.subtitle
                            },
                            children: subtitle
                        }),
                        sx: {
                            textAlign: "right"
                        }
                    }),
                    rightIconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: rightIconType
                        })
                    })
                ]
            }),
            detailImage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($398befd0219a83fb$exports))).detailImageContainer,
                image: detailImage,
                defaultImage: detailImage,
                alt: "Image"
            })
        ]
    });
};



parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");







function $38158dbfc23b097a$export$5e57a444791c63be(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $38158dbfc23b097a$var$dialogActionsClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $38158dbfc23b097a$export$2e2bcd8739ae039 = $38158dbfc23b097a$var$dialogActionsClasses;



'use client';
const $6282a3c293a0d8c9$var$_excluded = [
    "className",
    "disableSpacing"
];
const $6282a3c293a0d8c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $38158dbfc23b097a$export$5e57a444791c63be), classes);
};
const $6282a3c293a0d8c9$var$DialogActionsRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $6282a3c293a0d8c9$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $6282a3c293a0d8c9$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $6282a3c293a0d8c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6282a3c293a0d8c9$var$DialogActionsRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6282a3c293a0d8c9$export$2e2bcd8739ae039 = $6282a3c293a0d8c9$var$DialogActions;




parcelRequire("7fPBF");
var $8c3d96a917851320$exports = {};

$parcel$export($8c3d96a917851320$exports, "box", function () { return $8c3d96a917851320$export$827f4ee28efc37; }, function (v) { return $8c3d96a917851320$export$827f4ee28efc37 = v; });
$parcel$export($8c3d96a917851320$exports, "title", function () { return $8c3d96a917851320$export$fb184b623420d9be; }, function (v) { return $8c3d96a917851320$export$fb184b623420d9be = v; });
var $8c3d96a917851320$export$827f4ee28efc37;
var $8c3d96a917851320$export$fb184b623420d9be;
$8c3d96a917851320$export$827f4ee28efc37 = `ZP4AHW_box`;
$8c3d96a917851320$export$fb184b623420d9be = `ZP4AHW_title`;



var $gSkQi = parcelRequire("gSkQi");


var $54c85b66bdf890a3$exports = {};

$parcel$export($54c85b66bdf890a3$exports, "toolbarBox", function () { return $54c85b66bdf890a3$export$6e129a9598cc724e; }, function (v) { return $54c85b66bdf890a3$export$6e129a9598cc724e = v; });
var $54c85b66bdf890a3$export$6e129a9598cc724e;
$54c85b66bdf890a3$export$6e129a9598cc724e = `_8pCylW_toolbarBox`;


parcelRequire("7fPBF");


const $a57daef9e4523bb5$export$722e774c4f28559d = (props)=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($54c85b66bdf890a3$exports))).toolbarBox, props.className),
        style: {
            borderColor: theme.palette.colors?.disabled,
            backgroundColor: theme.palette.background.paper,
            ...props.style
        },
        children: props.children
    });
};



const $9c151e77ba8a9caa$export$c46226a4a6fbd741 = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8c3d96a917851320$exports))).box, props.className),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                height: "100%"
            },
            ...(0, $gSkQi.omit)(props, "className", "children"),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8c3d96a917851320$exports))).title,
                    children: props.children
                })
            })
        })
    });
};


var $ebc70349c033878f$exports = {};

$parcel$export($ebc70349c033878f$exports, "button", function () { return $ebc70349c033878f$export$2ba01fb71ed41cb6; }, function (v) { return $ebc70349c033878f$export$2ba01fb71ed41cb6 = v; });
$parcel$export($ebc70349c033878f$exports, "imageAttachment", function () { return $ebc70349c033878f$export$1196603ada856bfb; }, function (v) { return $ebc70349c033878f$export$1196603ada856bfb = v; });
$parcel$export($ebc70349c033878f$exports, "message", function () { return $ebc70349c033878f$export$a8ecead220dd38a6; }, function (v) { return $ebc70349c033878f$export$a8ecead220dd38a6 = v; });
var $ebc70349c033878f$export$2ba01fb71ed41cb6;
var $ebc70349c033878f$export$1196603ada856bfb;
var $ebc70349c033878f$export$a8ecead220dd38a6;
$ebc70349c033878f$export$2ba01fb71ed41cb6 = `MIm2VG_button`;
$ebc70349c033878f$export$1196603ada856bfb = `MIm2VG_imageAttachment`;
$ebc70349c033878f$export$a8ecead220dd38a6 = `MIm2VG_message`;



var $c13e2e91f6e38286$exports = {};

$parcel$export($c13e2e91f6e38286$exports, "loadingIndicator", function () { return $c13e2e91f6e38286$export$f10e6b4aaa94c253; }, function (v) { return $c13e2e91f6e38286$export$f10e6b4aaa94c253 = v; });
$parcel$export($c13e2e91f6e38286$exports, "toolbarButton", function () { return $c13e2e91f6e38286$export$9c7d691958d83aa0; }, function (v) { return $c13e2e91f6e38286$export$9c7d691958d83aa0 = v; });
var $c13e2e91f6e38286$export$f10e6b4aaa94c253;
var $c13e2e91f6e38286$export$9c7d691958d83aa0;
$c13e2e91f6e38286$export$f10e6b4aaa94c253 = `HCnWkW_loadingIndicator`;
$c13e2e91f6e38286$export$9c7d691958d83aa0 = `HCnWkW_toolbarButton`;


parcelRequire("7fPBF");



var $20ec281264ab8a5d$exports = {};

$parcel$export($20ec281264ab8a5d$exports, "loadingIndicator", function () { return $20ec281264ab8a5d$export$f10e6b4aaa94c253; }, function (v) { return $20ec281264ab8a5d$export$f10e6b4aaa94c253 = v; });
$parcel$export($20ec281264ab8a5d$exports, "span", function () { return $20ec281264ab8a5d$export$afc1bfabebaf28a2; }, function (v) { return $20ec281264ab8a5d$export$afc1bfabebaf28a2 = v; });
$parcel$export($20ec281264ab8a5d$exports, "toolbarButton", function () { return $20ec281264ab8a5d$export$9c7d691958d83aa0; }, function (v) { return $20ec281264ab8a5d$export$9c7d691958d83aa0 = v; });
var $20ec281264ab8a5d$export$f10e6b4aaa94c253;
var $20ec281264ab8a5d$export$afc1bfabebaf28a2;
var $20ec281264ab8a5d$export$9c7d691958d83aa0;
$20ec281264ab8a5d$export$f10e6b4aaa94c253 = `dNcJ7q_loadingIndicator`;
$20ec281264ab8a5d$export$afc1bfabebaf28a2 = `dNcJ7q_span`;
$20ec281264ab8a5d$export$9c7d691958d83aa0 = `dNcJ7q_toolbarButton`;


parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");















var $7fPBF = parcelRequire("7fPBF");

function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules






const $a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX = 'base';
function $a3c689a96a013a98$var$buildStateClass(state) {
    return `${$a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $a3c689a96a013a98$var$buildSlotClass(componentName, slot) {
    return `${$a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $a3c689a96a013a98$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $ea3dfa6b173640a4$export$9d6b9120de57c54)[slot];
    return globalStateClass ? $a3c689a96a013a98$var$buildStateClass(globalStateClass) : $a3c689a96a013a98$var$buildSlotClass(componentName, slot);
}
function $a3c689a96a013a98$export$34c0130b1f3e8ae3(slot) {
    return (0, $ea3dfa6b173640a4$export$9d6b9120de57c54)[slot] !== undefined;
}



function $1d6f6a7ecf017320$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $a3c689a96a013a98$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $d3e903795686cbee$var$COMPONENT_NAME = 'Popper';
function $d3e903795686cbee$export$1b69b6cd0fa638a1(slot) {
    return (0, $a3c689a96a013a98$export$1d132570e11858b0)($d3e903795686cbee$var$COMPONENT_NAME, slot);
}
const $d3e903795686cbee$export$b6aa214021e734b0 = (0, $1d6f6a7ecf017320$export$de4f15803c389669)($d3e903795686cbee$var$COMPONENT_NAME, [
    'root'
]);




var $7fPBF = parcelRequire("7fPBF");

'use client';
const $6169d433b17180d2$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6169d433b17180d2$var$ClassNameConfiguratorContext = /*#__PURE__*/ $7fPBF.createContext($6169d433b17180d2$var$defaultContextValue);
function $6169d433b17180d2$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $7fPBF.useContext($6169d433b17180d2$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return '';
        return generateUtilityClass(slot);
    };
}
function $6169d433b17180d2$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $7fPBF.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6169d433b17180d2$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



'use client';
const $53db6a0252cebd95$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $53db6a0252cebd95$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $53db6a0252cebd95$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $53db6a0252cebd95$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $53db6a0252cebd95$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $53db6a0252cebd95$var$isVirtualElement(element) {
    return !$53db6a0252cebd95$var$isHTMLElement(element);
}
const $53db6a0252cebd95$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6169d433b17180d2$export$b0f7603cd2f9ee15)((0, $d3e903795686cbee$export$1b69b6cd0fa638a1)));
};
const $53db6a0252cebd95$var$defaultPopperOptions = {};
const $53db6a0252cebd95$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $53db6a0252cebd95$var$_excluded);
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $53db6a0252cebd95$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $7fPBF.useState($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $7fPBF.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $53db6a0252cebd95$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $53db6a0252cebd95$export$badac9ada3a0bdf9 = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $53db6a0252cebd95$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $53db6a0252cebd95$var$_excluded2);
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $53db6a0252cebd95$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $53db6a0252cebd95$var$isHTMLElement(resolvedAnchorEl) ? (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af6f301d1bc38583$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($53db6a0252cebd95$var$PopperTooltip, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});






var $7fPBF = parcelRequire("7fPBF");


'use client';
const $2ecffc9bd505b8cc$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2ecffc9bd505b8cc$var$PopperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $53db6a0252cebd95$export$badac9ada3a0bdf9), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2ecffc9bd505b8cc$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)();
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $2ecffc9bd505b8cc$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2ecffc9bd505b8cc$var$PopperRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2ecffc9bd505b8cc$export$2e2bcd8739ae039 = $2ecffc9bd505b8cc$var$Popper;





'use client';
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $46f5b561912058f9$export$2e2bcd8739ae039);






function $684603ff395d34b1$export$837848f5f6cee923(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $684603ff395d34b1$var$tooltipClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $684603ff395d34b1$export$2e2bcd8739ae039 = $684603ff395d34b1$var$tooltipClasses;



'use client';
const $ea99f2520fe8509d$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $ea99f2520fe8509d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ea99f2520fe8509d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $684603ff395d34b1$export$837848f5f6cee923), classes);
};
const $ea99f2520fe8509d$var$TooltipPopper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $ea99f2520fe8509d$var$TooltipTooltip = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$ea99f2520fe8509d$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $ea99f2520fe8509d$var$TooltipArrow = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $ea99f2520fe8509d$var$hystersisOpen = false;
const $ea99f2520fe8509d$var$hystersisTimer = new (0, $9a1088a9a7141b09$export$786b4da70f00938b)();
let $ea99f2520fe8509d$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ea99f2520fe8509d$export$b9ee5a7ace0541f8() {
    $ea99f2520fe8509d$var$hystersisOpen = false;
    $ea99f2520fe8509d$var$hystersisTimer.clear();
}
function $ea99f2520fe8509d$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $ea99f2520fe8509d$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $ea99f2520fe8509d$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const enterTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const touchTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $7fPBF.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.clear();
        $ea99f2520fe8509d$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $ea99f2520fe8509d$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $ea99f2520fe8509d$var$hystersisOpen && enterNextDelay) enterTimer.start($ea99f2520fe8509d$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ea99f2520fe8509d$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, nameOrDescProps, other, children.props, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ea99f2520fe8509d$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ea99f2520fe8509d$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ea99f2520fe8509d$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ea99f2520fe8509d$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $7fPBF.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $ea99f2520fe8509d$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $ea99f2520fe8509d$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $ea99f2520fe8509d$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $ea99f2520fe8509d$var$TooltipArrow;
    const popperProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(PopperComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(TooltipComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(ArrowComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PopperComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ea99f2520fe8509d$var$cursorPosition.y,
                            left: $ea99f2520fe8509d$var$cursorPosition.x,
                            right: $ea99f2520fe8509d$var$cursorPosition.x,
                            bottom: $ea99f2520fe8509d$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(TooltipComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ArrowComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $ea99f2520fe8509d$export$2e2bcd8739ae039 = $ea99f2520fe8509d$var$Tooltip;




var $7fPBF = parcelRequire("7fPBF");
const $e0f71d8009cff55c$export$2b96349243a56116 = ()=>{
    const [width, setWidth] = (0, $7fPBF.useState)(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    (0, $7fPBF.useEffect)(()=>{
        window.addEventListener("resize", handleWindowSizeChange);
        return ()=>{
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    return width <= 1024;
};
const $e0f71d8009cff55c$export$5d9aa80f0e322840 = ()=>window.navigator.userAgent.includes("Piper-iOS/ldelosheros");



const $3703c5b066166561$export$c41a54ed40f40346 = ({ loading: loading, disabled: disabled, color: color, highlighted: highlighted, href: href, target: target, tooltip: tooltip, onClick: onClick, onContextMenu: onContextMenu, filled: filled, iconType: iconType, iconClassName: iconClassName, buttonClassName: buttonClassName })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
        title: isMobile ? "" : tooltip,
        onContextMenu: onContextMenu,
        arrow: true,
        disableInteractive: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($20ec281264ab8a5d$exports))).span,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                className: buttonClassName,
                sx: {
                    minWidth: 40,
                    minHeight: 36,
                    color: color,
                    backgroundColor: highlighted ? theme.palette.colors?.highlightButton : undefined,
                    borderRadius: 0,
                    height: "100% !important",
                    width: "100% !important"
                },
                disabled: disabled,
                onClick: onClick,
                href: href ?? "",
                target: target,
                children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($20ec281264ab8a5d$exports))).loadingIndicator
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                    className: iconClassName,
                    type: iconType,
                    filled: filled
                })
            })
        })
    });
};


const $4d0c3d96fa46bd11$export$e5c1a33878e86e9e = ({ className: className, style: style, ...props })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c13e2e91f6e38286$exports))).toolbarButton, className),
        style: style,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
            ...props
        })
    });
};






var $7fPBF = parcelRequire("7fPBF");












function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;





'use client';
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8523c8ab2139cf2c$export$2177af0aa15c34c2), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $74e245c78e363f11$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40596d25b0f9c334$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;


parcelRequire("7fPBF");
const $fdfba42518310a74$export$7e3fda4dbdd091fa = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        ...props,
        TransitionComponent: (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039),
        children: children
    });
};



const $4a4c57566cf3307e$export$de466dd8317b0b75 = ({ title: title, message: message, isConfirm: isConfirm, open: open, setOpen: setOpen, onConfirm: onConfirm, onCancel: onCancel, confirmTitle: confirmTitle, cancelTitle: cancelTitle, helpLink: helpLink, link: link, imageUrl: imageUrl, linkButtonText: linkButtonText, hasCloseButton: hasCloseButton, maxWidth: maxWidth })=>{
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        open: open,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: title ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    helpLink && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${helpLink}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    hasCloseButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebc70349c033878f$exports))).message,
                        children: message
                    }),
                    link && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebc70349c033878f$exports))).moreInfoButton,
                        href: link,
                        children: linkButtonText ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).more_info
                    }),
                    imageUrl && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebc70349c033878f$exports))).imageAttachment,
                        src: imageUrl,
                        alt: "Attachment"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                children: [
                    isConfirm && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebc70349c033878f$exports))).button,
                        onClick: ()=>{
                            if (onCancel) onCancel();
                            handleClose();
                        },
                        children: cancelTitle ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel
                    }),
                    !hasCloseButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebc70349c033878f$exports))).button,
                        onClick: ()=>{
                            if (onConfirm) onConfirm();
                            handleClose();
                        },
                        children: isConfirm ? confirmTitle ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm : (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_accept
                    })
                ]
            })
        ]
    });
};


var $0b5cedac77958dbe$export$ca664994d1d54bff;

$0b5cedac77958dbe$export$ca664994d1d54bff = (parcelRequire("hROw0")).BrowserLevel;



class $b2aa90a9d667a20c$export$51adf995cb4f5799 {
    static #_ = this.shared = new $b2aa90a9d667a20c$export$51adf995cb4f5799();
    constructor(){
        try {
            this.db = new (0, $0b5cedac77958dbe$export$ca664994d1d54bff)("images-db");
        } catch  {
            return;
        }
    }
    async getCachedImage(name) {
        try {
            return await this.db?.get(name);
        } catch  {
            return undefined;
        }
    }
    async saveImage(name, image) {
        try {
            await this.db?.put(name, image);
            return true;
        } catch  {
            return false;
        }
    }
    async removeImage(name) {
        try {
            await this.db?.del(name);
            return true;
        } catch  {
            return false;
        }
    }
    async clear() {
        try {
            await this.db?.clear();
            localStorage.setItem("lastImageCacheClearance", String((0, $f7059bbf3f33120d$export$90ac1c435e11dc37).dateNowInSeconds()));
            return true;
        } catch  {
            return false;
        }
    }
    isCacheOlderThan(unixTimestamp) {
        const lastImageCacheClearance = localStorage.getItem("lastImageCacheClearance") ?? "0";
        return +lastImageCacheClearance < unixTimestamp;
    }
    static #_2 = this.smallAlbumImageSize = 120;
    static #_3 = this.bigAlbumImageSize = 1000;
    static #_4 = this.smallArtistImageSize = 160;
    static #_5 = this.bigArtistImageSize = 600;
    static #_6 = this.smallLabelImageSize = 60;
    static #_7 = this.bigLabelImageSize = 300;
    static #_8 = this.smallAvatarImageSize = 160;
    static #_9 = this.bigAvatarImageSize = 320;
    static #_10 = this.smallCollectionImageWidth = 600;
    static #_11 = this.smallCollectionImageHeight = 240;
    static #_12 = this.bigCollectionImageWidth = 1000;
    static #_13 = this.bigCollectionImageHeight = 400;
    static #_14 = this.smallShelfSegmentImageWidth = 600;
    static #_15 = this.smallShelfSegmentImageHeight = 240;
    static #_16 = this.bigShelfSegmentImageWidth = 1400;
    static #_17 = this.bigShelfSegmentImageHeight = 600;
}


const $0a3e798b1875b36f$export$f29ae926b020bfea = {
    getLanguage: ()=>{
        return localStorage.getItem("language");
    },
    setLanguage: (language)=>{
        localStorage.setItem("language", language);
    }
};



const $9664e7b9b5995a6a$export$3e936a8db52a10a0 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        mode: "dark",
        background: {
            default: "#303030",
            paper: "#424242"
        },
        primary: {
            main: "#ffffff",
            subtitle: "#d3d3d3"
        },
        secondary: {
            main: "#d3d3d3"
        },
        action: {
            disabledBackground: "#d3d3d3",
            disabled: "#808080"
        },
        colors: {
            main: "#40403f",
            appBar: "#484848",
            highlight: "#1c1c1c",
            disabled: "#808080",
            gradeNumberBackground: "#40403f",
            buttonBackground: "#707070",
            buttonHover: "#909090",
            counterBackground: "#707070",
            warning: "#ffbf00",
            remove: "#f35f5f",
            discount: "#1788ce",
            mercadoPagoBackgroundColor: "#171E2E",
            qrCodeBackground: "#000000",
            goldmineGray: "#696969",
            goldmineRed: "#c55006",
            goldmineGreen: "#1aa626",
            goldmineBlue: "#2a9bd7",
            goldmineMint: "#2d51e0",
            highlightBorder: "#2a9bd7",
            highlightButton: "#2a2a2a",
            highlightSpine: "#ece81f",
            breadcrumb: "#d3d3d3",
            pricingNotification: "rgba(255,251,19,1)",
            criticalNotification: "rgba(255,19,19,1)",
            messageNotification: "rgba(19,165,255,1)",
            progressRunning: "rgb(10,71,204)",
            progressError: "rgb(185,14,14)",
            progressSuccess: "rgb(9,131,28)",
            border: "#626262",
            ownChat: "#2c376e",
            otherChat: "#1a1c1c",
            chatSubheader: "#444444",
            drawerBackgroundColor: "#333333",
            divider: "#303030",
            filterHeaderBackground: "#252525"
        }
    },
    typography: {
        fontFamily: `"Inter", sans-serif`,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 1000
    }
});
const $9664e7b9b5995a6a$export$f30cb9bc4f736419 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        mode: "light",
        background: {
            default: "#f5f6fa",
            paper: "#ffffff"
        },
        primary: {
            main: "#1a1a1a",
            subtitle: "#555555"
        },
        secondary: {
            main: "#6e6e6e"
        },
        action: {
            disabledBackground: "#e0e0e0",
            disabled: "#9e9e9e"
        },
        colors: {
            main: "#f5f6fa",
            appBar: "#ffffff",
            highlight: "#e9eef5",
            disabled: "#9e9e9e",
            gradeNumberBackground: "#eeeeee",
            buttonBackground: "#ffffff",
            buttonHover: "#e0e0e0",
            counterBackground: "#f0f0f0",
            warning: "#ff9800",
            remove: "#d32f2f",
            discount: "#4196ec",
            mercadoPagoBackgroundColor: "#e8f0ff",
            qrCodeBackground: "#ffffff",
            goldmineGray: "#afafaf",
            goldmineRed: "#f65a5a",
            goldmineGreen: "#2cde3c",
            goldmineBlue: "#7bcbff",
            goldmineMint: "#7a7ff3",
            highlightBorder: "#1976d2",
            highlightButton: "#e9eef5",
            highlightSpine: "#c6c200",
            breadcrumb: "#666666",
            pricingNotification: "rgb(200,198,40)",
            criticalNotification: "rgb(183,28,28)",
            messageNotification: "rgb(25,118,210)",
            progressRunning: "rgb(53,106,229)",
            progressError: "rgb(231,72,72)",
            progressSuccess: "rgb(38,187,61)",
            border: "#dddddd",
            ownChat: "#e8eaf6",
            otherChat: "#f5f6fa",
            chatSubheader: "#ffffff",
            drawerBackgroundColor: "#ffffff",
            divider: "#e0e0e0",
            filterHeaderBackground: "#f0f0f0"
        }
    },
    typography: {
        fontFamily: `"Inter", sans-serif`,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 1000
    }
});
const $9664e7b9b5995a6a$export$2555c6f697986fe0 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        mode: "dark",
        background: {
            default: "#201f26",
            paper: "#2c2b34"
        },
        primary: {
            main: "#ffffff",
            subtitle: "#cccccc"
        },
        secondary: {
            main: "#939393"
        },
        action: {
            disabledBackground: "#b2b2b2",
            disabled: "#808080"
        },
        colors: {
            main: "#201f26",
            appBar: "#0f0e17",
            highlight: "#0f0e17",
            disabled: "#808080",
            gradeNumberBackground: "#2b2b2b",
            buttonBackground: "#201f26",
            buttonHover: "#909090",
            counterBackground: "#201f26",
            warning: "#ffbf00",
            remove: "#e63946",
            discount: "#0c88e0",
            mercadoPagoBackgroundColor: "#171E2E",
            qrCodeBackground: "#000000",
            goldmineGray: "#696969",
            goldmineRed: "#ab4e13",
            goldmineGreen: "#229828",
            goldmineBlue: "#2888b2",
            goldmineMint: "#2d51e0",
            highlightBorder: "#0776a4",
            highlightButton: "#0f0e17",
            highlightSpine: "#ece81f",
            breadcrumb: "#d3d3d3",
            pricingNotification: "rgb(168,166,8)",
            criticalNotification: "rgb(161,3,3)",
            messageNotification: "rgb(9,114,180)",
            progressRunning: "rgb(10,71,204)",
            progressError: "rgb(185,14,14)",
            progressSuccess: "rgb(9,131,28)",
            border: "#444444",
            ownChat: "#3b3a49",
            otherChat: "#201f26",
            chatSubheader: "#201f26",
            drawerBackgroundColor: "#201f26",
            divider: "#201f26",
            filterHeaderBackground: "#0d0c10"
        }
    },
    typography: {
        fontFamily: `"Inter", sans-serif`,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 1000
    }
});
const $9664e7b9b5995a6a$export$e7bda06a234c58f5 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        mode: "dark",
        background: {
            default: "#0f172a",
            paper: "#16213e"
        },
        primary: {
            main: "#e6f1ff",
            subtitle: "#9fb3d1"
        },
        secondary: {
            main: "#6c8db8"
        },
        action: {
            disabledBackground: "#334155",
            disabled: "#64748b"
        },
        colors: {
            main: "#0f172a",
            appBar: "#00002f",
            highlight: "#1e293b",
            disabled: "#64748b",
            gradeNumberBackground: "#1e293b",
            buttonBackground: "#16213e",
            buttonHover: "#243b55",
            counterBackground: "#1a2238",
            warning: "#fbbf24",
            remove: "#ef4444",
            discount: "#2689b2",
            mercadoPagoBackgroundColor: "#0e1a2f",
            qrCodeBackground: "#000814",
            goldmineGray: "#94a3b8",
            goldmineRed: "#d97706",
            goldmineGreen: "#22c55e",
            goldmineBlue: "#3b82f6",
            goldmineMint: "#6366f1",
            highlightBorder: "#38bdf8",
            highlightButton: "#1e293b",
            highlightSpine: "#fde047",
            breadcrumb: "#94a3b8",
            pricingNotification: "rgb(234,179,8)",
            criticalNotification: "rgb(185,28,28)",
            messageNotification: "rgb(56,189,248)",
            progressRunning: "rgb(10,71,204)",
            progressError: "rgb(185,14,14)",
            progressSuccess: "rgb(9,131,28)",
            border: "#22304a",
            ownChat: "#1e293b",
            otherChat: "#0f172a",
            chatSubheader: "#16213e",
            drawerBackgroundColor: "#0f172a",
            divider: "#0f172a",
            filterHeaderBackground: "#0b1220"
        }
    },
    typography: {
        fontFamily: `"Inter", sans-serif`,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 1000
    }
});
const $9664e7b9b5995a6a$export$e16c2d85f8dc2f73 = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        mode: "dark",
        background: {
            default: "#1a120b",
            paper: "#24180f"
        },
        primary: {
            main: "#fff4e6",
            subtitle: "#e0bfa8"
        },
        secondary: {
            main: "#c89b7b"
        },
        action: {
            disabledBackground: "#3a2a1f",
            disabled: "#8c6b55"
        },
        colors: {
            main: "#1a120b",
            appBar: "#120c07",
            highlight: "#2b1d13",
            disabled: "#8c6b55",
            gradeNumberBackground: "#2b1d13",
            buttonBackground: "#24180f",
            buttonHover: "#3a2a1f",
            counterBackground: "#2a1c12",
            warning: "#ffb703",
            remove: "#e63946",
            discount: "#be6e11",
            mercadoPagoBackgroundColor: "#1c140d",
            qrCodeBackground: "#000000",
            goldmineGray: "#a1887f",
            goldmineRed: "#ef0808",
            goldmineGreen: "#419d4b",
            goldmineBlue: "#2ba6ea",
            goldmineMint: "#2d51e0",
            highlightBorder: "#fb8500",
            highlightButton: "#2b1d13",
            highlightSpine: "#ffd60a",
            breadcrumb: "#c89b7b",
            pricingNotification: "rgb(251,191,36)",
            criticalNotification: "rgb(180,35,24)",
            messageNotification: "rgb(251,133,0)",
            progressRunning: "rgb(10,71,204)",
            progressError: "rgb(185,14,14)",
            progressSuccess: "rgb(9,131,28)",
            border: "#3a2a1f",
            ownChat: "#2b1d13",
            otherChat: "#1a120b",
            chatSubheader: "#24180f",
            drawerBackgroundColor: "#1a120b",
            divider: "#1a120b",
            filterHeaderBackground: "#120c07"
        }
    },
    typography: {
        fontFamily: `"Inter", sans-serif`,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 1000
    }
});



const $6b29b0e94aa6dd73$export$5510f7c459d7063c = {
    currentTheme: ()=>{
        switch(localStorage.getItem("themeMode")){
            case "light":
                return 0, $9664e7b9b5995a6a$export$f30cb9bc4f736419;
            case "dark":
                return 0, $9664e7b9b5995a6a$export$3e936a8db52a10a0;
            case "black":
                return 0, $9664e7b9b5995a6a$export$2555c6f697986fe0;
            case "blue":
                return 0, $9664e7b9b5995a6a$export$e7bda06a234c58f5;
            case "coffee":
                return 0, $9664e7b9b5995a6a$export$e16c2d85f8dc2f73;
            default:
                return 0, $9664e7b9b5995a6a$export$2555c6f697986fe0;
        }
    },
    currentThemeMode: ()=>{
        return localStorage.getItem("themeMode") ?? "black";
    },
    setTheme: (themeMode)=>{
        localStorage.setItem("themeMode", themeMode);
    },
    listOfThemeNames: ()=>{
        return [
            (0, $37bec70ed65ed924$export$21c51bc433c16634).black_mode,
            (0, $37bec70ed65ed924$export$21c51bc433c16634).dark_mode,
            (0, $37bec70ed65ed924$export$21c51bc433c16634).light_mode,
            (0, $37bec70ed65ed924$export$21c51bc433c16634).blue_mode,
            (0, $37bec70ed65ed924$export$21c51bc433c16634).coffee_mode
        ];
    },
    listOfThemeModes: ()=>{
        return [
            "black",
            "dark",
            "light",
            "blue",
            "coffee"
        ];
    }
};



parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");














function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;






var $7fPBF = parcelRequire("7fPBF");








function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;



'use client';
const $a4e848490d2ab66f$var$_excluded = [
    "className"
];
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $90836af743b99227$export$ccdb26aeba48a86e), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a4e848490d2ab66f$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;



'use client';
const $2c1b031ce0fa2278$var$_excluded = [
    "className"
], $2c1b031ce0fa2278$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0ca5a1e6788dced6$export$5682c366c0c669d9), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props.ContainerProps, $2c1b031ce0fa2278$var$_excluded), other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $2c1b031ce0fa2278$var$_excluded2);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                as: ContainerComponent,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
            ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4e848490d2ab66f$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;




var $7fPBF = parcelRequire("7fPBF");












function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;






function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;



'use client';
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $81e9a11bd449f186$export$515f8c67b5305377), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;


var $433ff4d32450dc13$exports = {};

$parcel$export($433ff4d32450dc13$exports, "item", function () { return $433ff4d32450dc13$export$7061c75fc5af8b7e; }, function (v) { return $433ff4d32450dc13$export$7061c75fc5af8b7e = v; });
$parcel$export($433ff4d32450dc13$exports, "itemDiv", function () { return $433ff4d32450dc13$export$64c46d98173ac23d; }, function (v) { return $433ff4d32450dc13$export$64c46d98173ac23d = v; });
$parcel$export($433ff4d32450dc13$exports, "subtitle", function () { return $433ff4d32450dc13$export$c96745152eb2740f; }, function (v) { return $433ff4d32450dc13$export$c96745152eb2740f = v; });
$parcel$export($433ff4d32450dc13$exports, "title", function () { return $433ff4d32450dc13$export$fb184b623420d9be; }, function (v) { return $433ff4d32450dc13$export$fb184b623420d9be = v; });
var $433ff4d32450dc13$export$7061c75fc5af8b7e;
var $433ff4d32450dc13$export$64c46d98173ac23d;
var $433ff4d32450dc13$export$c96745152eb2740f;
var $433ff4d32450dc13$export$fb184b623420d9be;
$433ff4d32450dc13$export$7061c75fc5af8b7e = `ElYCJa_item`;
$433ff4d32450dc13$export$64c46d98173ac23d = `ElYCJa_itemDiv`;
$433ff4d32450dc13$export$c96745152eb2740f = `ElYCJa_subtitle`;
$433ff4d32450dc13$export$fb184b623420d9be = `ElYCJa_title`;



const $81012e6d1ba93698$export$414c12bb580eacc1 = ({ iconType: iconType, title: title, subtitle: subtitle, labels: labels, values: values, value: value, handleChange: handleChange, disabled: disabled })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($433ff4d32450dc13$exports))).itemDiv,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: iconType
                    })
                }),
                title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                    disableTypography: true,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($433ff4d32450dc13$exports))).title,
                    primary: title,
                    secondary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($433ff4d32450dc13$exports))).subtitle,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: subtitle
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                    value: value,
                    disabled: disabled,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($433ff4d32450dc13$exports))).item,
                    onChange: handleChange,
                    sx: {
                        height: "30px"
                    },
                    children: labels.map((label, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                            value: values[index],
                            children: label
                        }, `item_${index}`))
                })
            ]
        })
    });
};



var $a34583a1dc34992b$exports = {};

$parcel$export($a34583a1dc34992b$exports, "credits", function () { return $a34583a1dc34992b$export$68c7321cb43cac49; }, function (v) { return $a34583a1dc34992b$export$68c7321cb43cac49 = v; });
var $a34583a1dc34992b$export$68c7321cb43cac49;
$a34583a1dc34992b$export$68c7321cb43cac49 = `WutSNa_credits`;



parcelRequire("7fPBF");




const $068306612f3a60ef$export$f8654fb7542a0d8a = ({ className: className, textClassName: textClassName })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const isPiperiOSApp = (0, $e0f71d8009cff55c$export$5d9aa80f0e322840)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a34583a1dc34992b$exports))).credits, className),
        style: {
            visibility: isPiperiOSApp ? "hidden" : "visible"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.about()}`,
                target: "_blank",
                className: textClassName,
                style: {
                    color: theme.palette.primary.subtitle
                },
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_app_title
            }),
            "   ",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.policy()}`,
                target: "_blank",
                className: textClassName,
                style: {
                    color: theme.palette.primary.subtitle
                },
                children: isMobile ? (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title_short : (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title
            }),
            "   ",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.terms()}`,
                target: "_blank",
                className: textClassName,
                style: {
                    color: theme.palette.primary.subtitle
                },
                children: isMobile ? (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title_short : (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title
            }),
            "   ",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: `mailto: ${(0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail}`,
                className: textClassName,
                style: {
                    color: theme.palette.primary.subtitle
                },
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).contact_us
            }),
            "   ",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: textClassName,
                style: {
                    color: theme.palette.primary.subtitle
                },
                children: isMobile ? (0, $37bec70ed65ed924$export$21c51bc433c16634).credits_short : (0, $37bec70ed65ed924$export$21c51bc433c16634).credits
            })
        ]
    });
};







const $7f5f220fbae066de$export$208c5536a0cffe90 = (props)=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$a6c7ac8248d6e38a), {
        ...props,
        style: {
            textDecoration: "none",
            color: theme.palette.primary.main,
            pointerEvents: props.disabled ? "none" : "auto"
        }
    });
};




const $f924c10c16776c66$export$27528f92c95949eb = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteUser = ()=>deleteRequest("user");
    return {
        deleteUser: deleteUser
    };
};



parcelRequire("7fPBF");
var $8ff3bb87ae191dd6$exports = {};

$parcel$export($8ff3bb87ae191dd6$exports, "cancelButton", function () { return $8ff3bb87ae191dd6$export$4ededb8e5b56a6fb; }, function (v) { return $8ff3bb87ae191dd6$export$4ededb8e5b56a6fb = v; });
$parcel$export($8ff3bb87ae191dd6$exports, "description", function () { return $8ff3bb87ae191dd6$export$6d59db4903f20f7d; }, function (v) { return $8ff3bb87ae191dd6$export$6d59db4903f20f7d = v; });
$parcel$export($8ff3bb87ae191dd6$exports, "textField", function () { return $8ff3bb87ae191dd6$export$c54b92c0bb02ba64; }, function (v) { return $8ff3bb87ae191dd6$export$c54b92c0bb02ba64 = v; });
var $8ff3bb87ae191dd6$export$4ededb8e5b56a6fb;
var $8ff3bb87ae191dd6$export$6d59db4903f20f7d;
var $8ff3bb87ae191dd6$export$c54b92c0bb02ba64;
$8ff3bb87ae191dd6$export$4ededb8e5b56a6fb = `Xim0xq_cancelButton`;
$8ff3bb87ae191dd6$export$6d59db4903f20f7d = `Xim0xq_description`;
$8ff3bb87ae191dd6$export$c54b92c0bb02ba64 = `Xim0xq_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");








const $8e401ce2c8a9fd10$export$663fca43e57db29d = ({ title: title, description: description, placeholder: placeholder, missingText: missingText, canClear: canClear, open: open, onClose: onClose, isNumber: isNumber, value: value, onChange: onChange, onClearValue: onClearValue, matchText: matchText })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        value: isNumber ? $57e52f3b537dfd4b$export$98e628dec113755e().typeError((0, $37bec70ed65ed924$export$21c51bc433c16634).not_number_error).required(missingText).nullable() : $57e52f3b537dfd4b$export$22b082955e083ec3().required(missingText).nullable()
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            value: value ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ value: value })=>{
            if (matchText && value != matchText) return;
            if (formik.dirty && value) {
                onChange(value);
                onClose();
            }
        },
        validationSchema: validationSchema
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
            fullWidth: true,
            maxWidth: "xs",
            open: open,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        canClear && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>{
                                onClearValue?.();
                                onClose();
                            },
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_value,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                            color: theme.palette.colors?.remove
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: onClose,
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                            sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8ff3bb87ae191dd6$exports))).description,
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8ff3bb87ae191dd6$exports))).textField,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                        id: "value",
                                        name: "value",
                                        size: "small",
                                        autoFocus: !isMobile,
                                        placeholder: placeholder,
                                        value: formik.values.value,
                                        onChange: formik.handleChange
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                type: "submit",
                                onClick: (event)=>{
                                    event.preventDefault();
                                    formik.handleSubmit();
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                            })
                        })
                    ]
                })
            ]
        })
    });
};



// Generated file. Do not edit
var $74d09775b34cce5b$export$efd5569f873811b1;
(function(StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */ StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */ StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */ StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */ StatusCodes[StatusCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */ StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */ StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */ StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */ StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */ StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */ StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */ StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */ StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */ StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */ StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */ StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */ StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */ StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */ StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */ StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */ StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */ StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */ StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */ StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */ StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */ StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */ StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */ StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */ StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */ StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */ StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */ StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */ StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */ StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */ StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */ StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */ StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */ StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */ StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */ StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */ StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */ StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */ StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */ StatusCodes[StatusCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */ StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */ StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */ StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */ StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */ StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */ StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */ StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */ StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */ StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */ StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */ StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */ StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($74d09775b34cce5b$export$efd5569f873811b1 || ($74d09775b34cce5b$export$efd5569f873811b1 = {}));



parcelRequire("7fPBF");



const $92691db20f9c9ecc$export$846b26828376608 = ({ isOpen: isOpen, setIsOpen: setIsOpen, closeOnTouch: closeOnTouch, loginCallback: loginCallback })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        maxWidth: "md",
        open: isOpen,
        onClose: ()=>{
            if (closeOnTouch ?? true) setIsOpen(false);
        },
        PaperProps: {
            sx: {
                borderRadius: "20px !important"
            }
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
            style: {
                padding: 0,
                overflow: "hidden",
                minWidth: 480
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $616fd80ec2a913ff$export$dad1da3cda010137), {
                isMinimalist: true,
                loginCallback: loginCallback
            })
        })
    });
};










var $7fPBF = parcelRequire("7fPBF");








'use client';
const $04d237a94a6557e6$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $04d237a94a6557e6$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $be601d991ccbe49a$export$46f01d01378ec5a2), classes);
};
const $04d237a94a6557e6$var$DividerRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $04d237a94a6557e6$var$DividerWrapper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $04d237a94a6557e6$var$Divider = /*#__PURE__*/ $7fPBF.forwardRef(function Divider(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $04d237a94a6557e6$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $04d237a94a6557e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($04d237a94a6557e6$var$DividerRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($04d237a94a6557e6$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $04d237a94a6557e6$var$Divider.muiSkipListHighlight = true;
var $04d237a94a6557e6$export$2e2bcd8739ae039 = $04d237a94a6557e6$var$Divider;


parcelRequire("7fPBF");
const $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d = ({ variant: variant, style: style, color: color })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
        variant: variant,
        style: style,
        sx: {
            borderColor: color ?? theme.palette.colors?.divider,
            borderWidth: "1px"
        }
    });
};


const $6558c6f63077fa19$export$7125afe2279fb9f3 = ({ isOpen: isOpen, setIsOpen: setIsOpen, canRemoveAccount: canRemoveAccount })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { deleteUser: deleteUser } = (0, $f924c10c16776c66$export$27528f92c95949eb)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isCacheAlertOpen, setIsCacheAlertOpen] = (0, $7fPBF.useState)(false);
    const [isCacheLoading, setIsCacheLoading] = (0, $7fPBF.useState)(false);
    const [isDeleteAccountDialogOpen, setIsDeleteAccountDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const handleClose = ()=>{
        if (isLoading) return;
        setIsOpen(false);
    };
    const handleThemeChange = (event)=>{
        const newValue = event.target.value;
        (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).setTheme(newValue);
    };
    const handleLanguageChange = (event)=>{
        const isEnglish = event.target.value;
        if (isEnglish !== null) {
            (0, $0a3e798b1875b36f$export$f29ae926b020bfea).setLanguage(isEnglish ? "en-US" : "es-ES");
            window.location.reload();
        }
    };
    const deleteAccount = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteUser();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            closeSession();
            navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        open: isOpen,
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_preferences_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: isLoading,
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                style: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ea5bc7634d29699$exports))).section,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81012e6d1ba93698$export$414c12bb580eacc1), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Routine,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).theme_option,
                                labels: (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).listOfThemeNames(),
                                values: (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).listOfThemeModes(),
                                value: (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).currentThemeMode(),
                                handleChange: handleThemeChange,
                                disabled: isLoading
                            }, "appearance"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81012e6d1ba93698$export$414c12bb580eacc1), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Translate,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).language_title,
                                subtitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).language_global_title,
                                labels: [
                                    "English",
                                    "Espa\xf1ol"
                                ],
                                values: [
                                    true,
                                    false
                                ],
                                value: (0, $37bec70ed65ed924$export$21c51bc433c16634).locale == "en-US",
                                handleChange: handleLanguageChange,
                                disabled: isLoading
                            }, "language")
                        ]
                    }),
                    currentUser && canRemoveAccount && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ea5bc7634d29699$exports))).section,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AccountCircleOff,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_account_title,
                            titleColor: theme.palette.colors?.remove,
                            onClick: ()=>setIsDeleteAccountDialogOpen(true),
                            disabled: isLoading
                        }, "remove_account")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ea5bc7634d29699$exports))).section,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: `mailto: ${(0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail}`,
                            style: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Mail,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).contact_support_title,
                                leftSubtitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail,
                                disabled: isLoading
                            }, "mail_support")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ea5bc7634d29699$exports))).section,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Memory,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_cache_title,
                                detail: "",
                                isLoading: isCacheLoading,
                                onClick: ()=>{
                                    setIsCacheAlertOpen(true);
                                },
                                disabled: isLoading
                            }, "clear_cache"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: `${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.about()}`,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Info,
                                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_title,
                                    disabled: isLoading
                                }, "about")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LaptopMac,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).app_version_title,
                                detail: "2.7.43",
                                disabled: isLoading
                            }, "app_version")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ea5bc7634d29699$exports))).credits
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_cache_confirmation,
                open: isCacheAlertOpen,
                setOpen: setIsCacheAlertOpen,
                isConfirm: true,
                onConfirm: async ()=>{
                    setIsCacheLoading(true);
                    await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.clear();
                    (0, $a8465eea29ce6625$export$e95767ffe2e60cec).reset();
                    setIsCacheLoading(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_account_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_account_confirmation_message,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_account_title,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing_short,
                canClear: false,
                open: isDeleteAccountDialogOpen,
                onClose: ()=>setIsDeleteAccountDialogOpen(false),
                isNumber: false,
                onChange: deleteAccount,
                matchText: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_account_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    await deleteAccount();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name,
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};


var $900d04858a6780f6$exports = {};

$parcel$export($900d04858a6780f6$exports, "itemTitle", function () { return $900d04858a6780f6$export$19d20253129869a; }, function (v) { return $900d04858a6780f6$export$19d20253129869a = v; });
$parcel$export($900d04858a6780f6$exports, "list", function () { return $900d04858a6780f6$export$8837f4fc672e936d; }, function (v) { return $900d04858a6780f6$export$8837f4fc672e936d = v; });
$parcel$export($900d04858a6780f6$exports, "listItem", function () { return $900d04858a6780f6$export$76c7e83ecc9cdf05; }, function (v) { return $900d04858a6780f6$export$76c7e83ecc9cdf05 = v; });
$parcel$export($900d04858a6780f6$exports, "sectionCard", function () { return $900d04858a6780f6$export$43491ff49b5e45cc; }, function (v) { return $900d04858a6780f6$export$43491ff49b5e45cc = v; });
var $900d04858a6780f6$export$19d20253129869a;
var $900d04858a6780f6$export$8837f4fc672e936d;
var $900d04858a6780f6$export$76c7e83ecc9cdf05;
var $900d04858a6780f6$export$43491ff49b5e45cc;
$900d04858a6780f6$export$19d20253129869a = `e4Li6G_itemTitle`;
$900d04858a6780f6$export$8837f4fc672e936d = `e4Li6G_list`;
$900d04858a6780f6$export$76c7e83ecc9cdf05 = `e4Li6G_listItem`;
$900d04858a6780f6$export$43491ff49b5e45cc = `e4Li6G_sectionCard`;





var $a1ac146ca1b997dc$exports = {};

$parcel$export($a1ac146ca1b997dc$exports, "androidButton", function () { return $a1ac146ca1b997dc$export$a2a2b6c462f01eb6; }, function (v) { return $a1ac146ca1b997dc$export$a2a2b6c462f01eb6 = v; });
$parcel$export($a1ac146ca1b997dc$exports, "androidButtonContainer", function () { return $a1ac146ca1b997dc$export$5d3529ab0d5e6606; }, function (v) { return $a1ac146ca1b997dc$export$5d3529ab0d5e6606 = v; });
$parcel$export($a1ac146ca1b997dc$exports, "androidButtonImage", function () { return $a1ac146ca1b997dc$export$f456c25566cd02e2; }, function (v) { return $a1ac146ca1b997dc$export$f456c25566cd02e2 = v; });
$parcel$export($a1ac146ca1b997dc$exports, "androidButtonTitle", function () { return $a1ac146ca1b997dc$export$ee7a3a9fa6f5fd18; }, function (v) { return $a1ac146ca1b997dc$export$ee7a3a9fa6f5fd18 = v; });
$parcel$export($a1ac146ca1b997dc$exports, "appStoreButton", function () { return $a1ac146ca1b997dc$export$751fd1e782c48928; }, function (v) { return $a1ac146ca1b997dc$export$751fd1e782c48928 = v; });
var $a1ac146ca1b997dc$export$a2a2b6c462f01eb6;
var $a1ac146ca1b997dc$export$5d3529ab0d5e6606;
var $a1ac146ca1b997dc$export$f456c25566cd02e2;
var $a1ac146ca1b997dc$export$ee7a3a9fa6f5fd18;
var $a1ac146ca1b997dc$export$751fd1e782c48928;
$a1ac146ca1b997dc$export$a2a2b6c462f01eb6 = `qP8U8W_androidButton`;
$a1ac146ca1b997dc$export$5d3529ab0d5e6606 = `qP8U8W_androidButtonContainer`;
$a1ac146ca1b997dc$export$f456c25566cd02e2 = `qP8U8W_androidButtonImage`;
$a1ac146ca1b997dc$export$ee7a3a9fa6f5fd18 = `qP8U8W_androidButtonTitle`;
$a1ac146ca1b997dc$export$751fd1e782c48928 = `qP8U8W_appStoreButton`;


parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");




const $81df530a7daa801f$var$styled = (0, $0aa19929000e58fe$export$2e2bcd8739ae039)();
var $81df530a7daa801f$export$2e2bcd8739ae039 = $81df530a7daa801f$var$styled;








const $dbad31c7655ddfe7$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $dbad31c7655ddfe7$var$defaultTheme = (0, $1f34940f58017e5f$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $dbad31c7655ddfe7$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $dbad31c7655ddfe7$var$useThemePropsDefault(props) {
    return (0, $71102aa90e2b2620$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $dbad31c7655ddfe7$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dbad31c7655ddfe7$var$joinChildren(children, separator) {
    const childrenArray = $7fPBF.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $7fPBF.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dbad31c7655ddfe7$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $dbad31c7655ddfe7$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
        theme: theme
    }, (0, $91ad95ac62846a03$export$980e6a259d807490)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $40d4ff9e66a5531b$export$1def6f833384e3d1)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$dbad31c7655ddfe7$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $40d4ff9e66a5531b$export$bf7199a9ebcb84a9)(transformer, propValue)
                }
            };
        };
        styles = (0, $291e2c063c5d6173$export$2e2bcd8739ae039)(styles, (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $91ad95ac62846a03$export$b89a003a1e05c0ee)(theme.breakpoints, styles);
    return styles;
};
function $dbad31c7655ddfe7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dbad31c7655ddfe7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dbad31c7655ddfe7$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dbad31c7655ddfe7$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $dbad31c7655ddfe7$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(StackRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: divider ? $dbad31c7655ddfe7$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}




'use client';
const $cde6d60726777b50$var$Stack = (0, $dbad31c7655ddfe7$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $cde6d60726777b50$export$2e2bcd8739ae039 = $cde6d60726777b50$var$Stack;


var $8f7f3d7e825df94f$exports = {};
$8f7f3d7e825df94f$exports = $parcel$resolve("bJ9BN");


const $e09141a590dfb9a7$export$590eb9e8e9b3ae5e = ()=>{
    const androidLogo = new URL($8f7f3d7e825df94f$exports).href;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        width: "fit-content",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a1ac146ca1b997dc$exports))).appStoreButton,
                target: "_blank",
                href: "https://apple.co/3P2tpt7",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    alt: "App Store",
                    src: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.app_store_button
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a1ac146ca1b997dc$exports))).androidButtonContainer,
                target: "_blank",
                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.about("android")}`,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a1ac146ca1b997dc$exports))).androidButton,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a1ac146ca1b997dc$exports))).androidButtonImage,
                            alt: "Android",
                            src: androidLogo
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a1ac146ca1b997dc$exports))).androidButtonTitle,
                            children: "Android"
                        })
                    ]
                })
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $cf2e80b2696feb66$exports = {};

$parcel$export($cf2e80b2696feb66$exports, "closeButton", function () { return $cf2e80b2696feb66$export$efe229eab43a9869; }, function (v) { return $cf2e80b2696feb66$export$efe229eab43a9869 = v; });
$parcel$export($cf2e80b2696feb66$exports, "closeButtonBox", function () { return $cf2e80b2696feb66$export$ccb9e63d7abd1f6e; }, function (v) { return $cf2e80b2696feb66$export$ccb9e63d7abd1f6e = v; });
$parcel$export($cf2e80b2696feb66$exports, "logoImage", function () { return $cf2e80b2696feb66$export$3ba0bfd74bc3a6fe; }, function (v) { return $cf2e80b2696feb66$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($cf2e80b2696feb66$exports, "preferencesButton", function () { return $cf2e80b2696feb66$export$bf9405cc74dd3c8d; }, function (v) { return $cf2e80b2696feb66$export$bf9405cc74dd3c8d = v; });
var $cf2e80b2696feb66$export$efe229eab43a9869;
var $cf2e80b2696feb66$export$ccb9e63d7abd1f6e;
var $cf2e80b2696feb66$export$3ba0bfd74bc3a6fe;
var $cf2e80b2696feb66$export$bf9405cc74dd3c8d;
$cf2e80b2696feb66$export$efe229eab43a9869 = `XlsoFa_closeButton`;
$cf2e80b2696feb66$export$ccb9e63d7abd1f6e = `XlsoFa_closeButtonBox`;
$cf2e80b2696feb66$export$3ba0bfd74bc3a6fe = `XlsoFa_logoImage`;
$cf2e80b2696feb66$export$bf9405cc74dd3c8d = `XlsoFa_preferencesButton`;





var $7fPBF = parcelRequire("7fPBF");









function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiAppBar', slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;



'use client';
const $5c04bc14285128b0$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(position)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8f7c5161bc7a509f$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.position)}`],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: 'var(--AppBar-background)',
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5c04bc14285128b0$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5c04bc14285128b0$var$AppBarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;







var $3e80ee69e0c45c78$exports = {};
$3e80ee69e0c45c78$exports = $parcel$resolve("cOFaM");


const $9dde9f7568b19476$export$bb68d554ded258ea = ({ setIsOpen: setIsOpen })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = (0, $7fPBF.useState)(false);
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
        position: "sticky",
        sx: {
            backgroundColor: theme.palette.colors?.appBar
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                sx: {
                    position: "relative",
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cf2e80b2696feb66$exports))).closeButtonBox,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MenuOpen,
                            onClick: ()=>setIsOpen(false),
                            buttonClassName: (0, (/*@__PURE__*/$parcel$interopDefault($cf2e80b2696feb66$exports))).closeButton
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cf2e80b2696feb66$exports))).logoImage,
                        style: {
                            margin: 8,
                            height: 44,
                            alignSelf: "center"
                        },
                        src: piperTextImage,
                        alt: "Piper"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cf2e80b2696feb66$exports))).preferencesButton,
                        onClick: ()=>setIsPreferencesDialogOpen(true),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_preferences_title,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Settings
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6558c6f63077fa19$export$7125afe2279fb9f3), {
                isOpen: isPreferencesDialogOpen,
                setIsOpen: setIsPreferencesDialogOpen,
                canRemoveAccount: false
            })
        ]
    });
};



var $6073332749a2ff62$exports = {};

$parcel$export($6073332749a2ff62$exports, "buyMeACoffeeButton", function () { return $6073332749a2ff62$export$230352bedd3b2a4f; }, function (v) { return $6073332749a2ff62$export$230352bedd3b2a4f = v; });
$parcel$export($6073332749a2ff62$exports, "buyMeACoffeeLink", function () { return $6073332749a2ff62$export$f30ec368551f139; }, function (v) { return $6073332749a2ff62$export$f30ec368551f139 = v; });
var $6073332749a2ff62$export$230352bedd3b2a4f;
var $6073332749a2ff62$export$f30ec368551f139;
$6073332749a2ff62$export$230352bedd3b2a4f = `M6WFbW_buyMeACoffeeButton`;
$6073332749a2ff62$export$f30ec368551f139 = `M6WFbW_buyMeACoffeeLink`;


parcelRequire("7fPBF");

const $960198875259ceb3$export$6ff27d755f78f4a0 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        width: "fit-content",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("script", {
                type: "text/javascript",
                src: "https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js",
                "data-name": "bmc-button",
                "data-slug": "ldelosheros"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6073332749a2ff62$exports))).buyMeACoffeeLink,
                href: "https://www.buymeacoffee.com/ldelosheros",
                target: "_blank",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6073332749a2ff62$exports))).buyMeACoffeeButton,
                    src: "https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png",
                    alt: "Buy Me A Coffee"
                })
            })
        ]
    });
};




const $6816ad538b5b25d4$export$31c1e889f27fdf83 = ({ isOpen: isOpen, setIsOpen: setIsOpen, onClickLoginAsGuest: onClickLoginAsGuest, onClickCreateNewUser: onClickCreateNewUser, onClickRecoverPassword: onClickRecoverPassword, onClickExplore: onClickExplore, onClickPasskey: onClickPasskey })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = (0, $7fPBF.useState)(false);
    const list = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                width: 310,
                height: "100%",
                overflow: "auto",
                backgroundColor: theme.palette.colors?.drawerBackgroundColor
            },
            role: "presentation",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).list,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                                onClick: onClickCreateNewUser,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PersonAdd
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_create_user
                                    })
                                ]
                            }, "NewUser"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                                onClick: onClickRecoverPassword,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Key
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_recover_password
                                    })
                                ]
                            }, "RecoverPassword"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                                onClick: onClickLoginAsGuest,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AssignmentInd
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_guest
                                    })
                                ]
                            }, "Guest")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).sectionCard,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                            onClick: onClickPasskey,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Passkey
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                    disableTypography: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                    primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).signin_with_passkey_long
                                })
                            ]
                        }, "Passkey")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).sectionCard,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                            onClick: onClickExplore,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Public
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                    disableTypography: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                    primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_marketplace
                                })
                            ]
                        }, "Explore")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                                onClick: ()=>{
                                    setIsPreferencesDialogOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Settings
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_preferences
                                    })
                                ]
                            }, "Preferences"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).listItem,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Book2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($900d04858a6780f6$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).documentation
                                        })
                                    ]
                                }, "Documentation")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e09141a590dfb9a7$export$590eb9e8e9b3ae5e), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $960198875259ceb3$export$6ff27d755f78f4a0), {})
                ]
            })
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a2822b215697a959$export$2e2bcd8739ae039), {
                anchor: "left",
                open: isOpen,
                onOpen: ()=>setIsOpen(true),
                onClose: ()=>setIsOpen(false),
                variant: "temporary",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dde9f7568b19476$export$bb68d554ded258ea), {
                        setIsOpen: setIsOpen
                    }),
                    list()
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6558c6f63077fa19$export$7125afe2279fb9f3), {
                isOpen: isPreferencesDialogOpen,
                setIsOpen: setIsPreferencesDialogOpen,
                canRemoveAccount: false
            })
        ]
    });
};






var $7fPBF = parcelRequire("7fPBF");
var $f3feab8f7f410714$exports = {};

$parcel$export($f3feab8f7f410714$exports, "cancelButton", function () { return $f3feab8f7f410714$export$4ededb8e5b56a6fb; }, function (v) { return $f3feab8f7f410714$export$4ededb8e5b56a6fb = v; });
$parcel$export($f3feab8f7f410714$exports, "description", function () { return $f3feab8f7f410714$export$6d59db4903f20f7d; }, function (v) { return $f3feab8f7f410714$export$6d59db4903f20f7d = v; });
$parcel$export($f3feab8f7f410714$exports, "loadingDiv", function () { return $f3feab8f7f410714$export$dded2af20345efaa; }, function (v) { return $f3feab8f7f410714$export$dded2af20345efaa = v; });
$parcel$export($f3feab8f7f410714$exports, "subtitle", function () { return $f3feab8f7f410714$export$c96745152eb2740f; }, function (v) { return $f3feab8f7f410714$export$c96745152eb2740f = v; });
$parcel$export($f3feab8f7f410714$exports, "textField", function () { return $f3feab8f7f410714$export$c54b92c0bb02ba64; }, function (v) { return $f3feab8f7f410714$export$c54b92c0bb02ba64 = v; });
var $f3feab8f7f410714$export$4ededb8e5b56a6fb;
var $f3feab8f7f410714$export$6d59db4903f20f7d;
var $f3feab8f7f410714$export$dded2af20345efaa;
var $f3feab8f7f410714$export$c96745152eb2740f;
var $f3feab8f7f410714$export$c54b92c0bb02ba64;
$f3feab8f7f410714$export$4ededb8e5b56a6fb = `vL556W_cancelButton`;
$f3feab8f7f410714$export$6d59db4903f20f7d = `vL556W_description`;
$f3feab8f7f410714$export$dded2af20345efaa = `vL556W_loadingDiv`;
$f3feab8f7f410714$export$c96745152eb2740f = `vL556W_subtitle`;
$f3feab8f7f410714$export$c54b92c0bb02ba64 = `vL556W_textField`;





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");











function $5928be47f00793d2$export$baa0faa0c7ad8085(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $5928be47f00793d2$var$switchBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $5928be47f00793d2$export$2e2bcd8739ae039 = $5928be47f00793d2$var$switchBaseClasses;



'use client';
const $69935e2350f58c79$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $69935e2350f58c79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5928be47f00793d2$export$baa0faa0c7ad8085), classes);
};
const $69935e2350f58c79$var$SwitchBaseRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $69935e2350f58c79$var$SwitchBaseInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $69935e2350f58c79$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $69935e2350f58c79$var$_excluded);
    const [checked, setCheckedState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $69935e2350f58c79$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($69935e2350f58c79$var$SwitchBaseRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        component: "span",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($69935e2350f58c79$var$SwitchBaseInput, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $69935e2350f58c79$export$2e2bcd8739ae039 = $69935e2350f58c79$var$SwitchBase;


parcelRequire("7fPBF");


'use client';
var $4f4e3692f5c75417$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("7fPBF");


'use client';
var $dc941e595b205c8e$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("7fPBF");


'use client';
var $d54af422e767409d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');







function $5350254b5a4e1ee2$export$6c57c6e16b4063b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $5350254b5a4e1ee2$var$checkboxClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $5350254b5a4e1ee2$export$2e2bcd8739ae039 = $5350254b5a4e1ee2$var$checkboxClasses;



'use client';
const $4d99e6d55ec7d57a$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $4d99e6d55ec7d57a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5350254b5a4e1ee2$export$6c57c6e16b4063b), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $4d99e6d55ec7d57a$var$CheckboxRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$effb20ecdbf4d6aa)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).checked}, &.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $4d99e6d55ec7d57a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc941e595b205c8e$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f4e3692f5c75417$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d54af422e767409d$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $4d99e6d55ec7d57a$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $4d99e6d55ec7d57a$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $4d99e6d55ec7d57a$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $4d99e6d55ec7d57a$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $4d99e6d55ec7d57a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d99e6d55ec7d57a$var$CheckboxRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        type: "checkbox",
        inputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $4d99e6d55ec7d57a$export$2e2bcd8739ae039 = $4d99e6d55ec7d57a$var$Checkbox;




var $7fPBF = parcelRequire("7fPBF");












function $7d55f5085d222c99$export$717666c39ec07e12(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $7d55f5085d222c99$var$formControlLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $7d55f5085d222c99$export$2e2bcd8739ae039 = $7d55f5085d222c99$var$formControlLabelClasses;




'use client';
const $206020d7e70b2617$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $206020d7e70b2617$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $7d55f5085d222c99$export$717666c39ec07e12), classes);
};
const $206020d7e70b2617$export$1b479270917a5676 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $206020d7e70b2617$var$AsteriskComponent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $206020d7e70b2617$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $206020d7e70b2617$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $206020d7e70b2617$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($206020d7e70b2617$export$1b479270917a5676, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($206020d7e70b2617$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $206020d7e70b2617$export$2e2bcd8739ae039 = $206020d7e70b2617$var$FormControlLabel;



var $1ZNeQ = parcelRequire("1ZNeQ");








const $ae1d7eb186718c87$export$af575fbbe23696a0 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (email)=>{
        const { status: status, body: body } = await post("checkEmail", {
            email: email
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) return body.isUsed;
        else return undefined;
    };
};




var $0fb6069f42f36b16$exports = {};

!function(e, t) {
    $0fb6069f42f36b16$exports = t((parcelRequire("7fPBF")));
}("undefined" != typeof self ? self : $0fb6069f42f36b16$exports, (e)=>(()=>{
        "use strict";
        var t = {
            156: (t)=>{
                t.exports = e;
            }
        }, r = {};
        function o(e) {
            var n = r[e];
            if (void 0 !== n) return n.exports;
            var s = r[e] = {
                exports: {}
            };
            return t[e](s, s.exports, o), s.exports;
        }
        o.d = (e, t)=>{
            for(var r in t)o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, o.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), o.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            o.r(n), o.d(n, {
                default: ()=>l,
                useStopwatch: ()=>u,
                useTime: ()=>m,
                useTimer: ()=>c
            });
            var e = o(156);
            class t {
                static expiryTimestamp(e) {
                    const t = new Date(e).getTime() > 0;
                    return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                }
                static onExpire(e) {
                    const t = e && "function" == typeof e;
                    return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                }
            }
            class r {
                static getTimeFromSeconds(e) {
                    const t = Math.ceil(e), r = Math.floor(t / 86400), o = Math.floor(t % 86400 / 3600), n = Math.floor(t % 3600 / 60);
                    return {
                        totalSeconds: t,
                        seconds: Math.floor(t % 60),
                        minutes: n,
                        hours: o,
                        days: r
                    };
                }
                static getSecondsFromExpiry(e, t) {
                    const r = e - (new Date).getTime();
                    if (r > 0) {
                        const e = r / 1e3;
                        return t ? Math.round(e) : e;
                    }
                    return 0;
                }
                static getSecondsFromPrevTime(e, t) {
                    const r = (new Date).getTime() - e;
                    if (r > 0) {
                        const e = r / 1e3;
                        return t ? Math.round(e) : e;
                    }
                    return 0;
                }
                static getSecondsFromTimeNow() {
                    const e = new Date;
                    return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                }
                static getFormattedTimeFromSeconds(e, t) {
                    const { seconds: o, minutes: n, hours: s } = r.getTimeFromSeconds(e);
                    let i = "", a = s;
                    return "12-hour" === t && (i = s >= 12 ? "pm" : "am", a = s % 12), {
                        seconds: o,
                        minutes: n,
                        hours: a,
                        ampm: i
                    };
                }
            }
            function s(t, r) {
                const o = (0, e.useRef)();
                (0, e.useEffect)(()=>{
                    o.current = t;
                }), (0, e.useEffect)(()=>{
                    if (!r) return ()=>{};
                    const e = setInterval(()=>{
                        o.current && o.current();
                    }, r);
                    return ()=>clearInterval(e);
                }, [
                    r
                ]);
            }
            const i = 1e3;
            function a(e) {
                if (!t.expiryTimestamp(e)) return null;
                const o = r.getSecondsFromExpiry(e), n = Math.floor(1e3 * (o - Math.floor(o)));
                return n > 0 ? n : i;
            }
            function c() {
                let { expiryTimestamp: o, onExpire: n, autoStart: c = !0 } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [u, m] = (0, e.useState)(o), [l, d] = (0, e.useState)(r.getSecondsFromExpiry(u)), [p, f] = (0, e.useState)(c), [g, S] = (0, e.useState)(c), [T, y] = (0, e.useState)(a(u)), h = (0, e.useCallback)(()=>{
                    t.onExpire(n) && n(), f(!1), y(null);
                }, [
                    n
                ]), x = (0, e.useCallback)(()=>{
                    f(!1);
                }, []), v = (0, e.useCallback)(function(e) {
                    let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    y(a(e)), S(t), f(t), m(e), d(r.getSecondsFromExpiry(e));
                }, []), F = (0, e.useCallback)(()=>{
                    const e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * l), v(e);
                }, [
                    l,
                    v
                ]), b = (0, e.useCallback)(()=>{
                    g ? (d(r.getSecondsFromExpiry(u)), f(!0)) : F();
                }, [
                    u,
                    g,
                    F
                ]);
                return s(()=>{
                    T !== i && y(i);
                    const e = r.getSecondsFromExpiry(u);
                    d(e), e <= 0 && h();
                }, p ? T : null), {
                    ...r.getTimeFromSeconds(l),
                    start: b,
                    pause: x,
                    resume: F,
                    restart: v,
                    isRunning: p
                };
            }
            function u() {
                let { autoStart: t, offsetTimestamp: o } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [n, i] = (0, e.useState)(r.getSecondsFromExpiry(o, !0) || 0), [a, c] = (0, e.useState)(new Date), [u, m] = (0, e.useState)(n + r.getSecondsFromPrevTime(a || 0, !0)), [l, d] = (0, e.useState)(t);
                s(()=>{
                    m(n + r.getSecondsFromPrevTime(a, !0));
                }, l ? 1e3 : null);
                const p = (0, e.useCallback)(()=>{
                    const e = new Date;
                    c(e), d(!0), m(n + r.getSecondsFromPrevTime(e, !0));
                }, [
                    n
                ]), f = (0, e.useCallback)(()=>{
                    i(u), d(!1);
                }, [
                    u
                ]), g = (0, e.useCallback)(function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    const o = r.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                    c(n), i(o), d(t), m(o + r.getSecondsFromPrevTime(n, !0));
                }, []);
                return {
                    ...r.getTimeFromSeconds(u),
                    start: p,
                    pause: f,
                    reset: g,
                    isRunning: l
                };
            }
            function m() {
                let { format: t } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [o, n] = (0, e.useState)(r.getSecondsFromTimeNow());
                return s(()=>{
                    n(r.getSecondsFromTimeNow());
                }, 1e3), {
                    ...r.getFormattedTimeFromSeconds(o, t)
                };
            }
            function l(t) {
                if ((0, e.useEffect)(()=>{
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), t.expiryTimestamp) {
                    const e = c(t);
                    return {
                        ...e,
                        startTimer: e.start,
                        stopTimer: e.pause,
                        resetTimer: ()=>{}
                    };
                }
                const r = u(t);
                return {
                    ...r,
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                };
            }
        })(), n;
    })());




const $f1a2075848500a5a$export$7df20d9398f482b8 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (password)=>{
        const { status: status, body: body } = await post("checkPassword", {
            password: password
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) return body;
        else return undefined;
    };
};






const $2b839f0c0fee3dd9$export$75783458d9cb311b = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const recoverPassword = (parameters)=>post("recoverPassword", parameters);
    return {
        recoverPassword: recoverPassword
    };
};




var $d55d61d22c14f925$exports = {};

$parcel$export($d55d61d22c14f925$exports, "mainDiv", function () { return $d55d61d22c14f925$export$16666caf1c4e1af1; }, function (v) { return $d55d61d22c14f925$export$16666caf1c4e1af1 = v; });
var $d55d61d22c14f925$export$16666caf1c4e1af1;
$d55d61d22c14f925$export$16666caf1c4e1af1 = `cdqlRa_mainDiv`;



parcelRequire("7fPBF");


const $e3307a4fe3100649$export$bc4cade09cb8859c = ({ withIntro: withIntro })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d55d61d22c14f925$exports))).mainDiv,
        children: [
            withIntro && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_oauth_intro
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                children: [
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_accept_first,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.policy()}`,
                        target: "_blank",
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title
                    }),
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_accept_second,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.terms()}`,
                        target: "_blank",
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title
                    }),
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_accept_third
                ]
            })
        ]
    });
};




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $706eb2584c77c6e1$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $706eb2584c77c6e1$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $706eb2584c77c6e1$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $706eb2584c77c6e1$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $706eb2584c77c6e1$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $706eb2584c77c6e1$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $706eb2584c77c6e1$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $706eb2584c77c6e1$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($706eb2584c77c6e1$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $706eb2584c77c6e1$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $706eb2584c77c6e1$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $706eb2584c77c6e1$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $706eb2584c77c6e1$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $706eb2584c77c6e1$var$stringToByteArray$1(str);
    return $706eb2584c77c6e1$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $706eb2584c77c6e1$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $706eb2584c77c6e1$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $706eb2584c77c6e1$export$c62426fdd000a97e = function(str) {
    try {
        return $706eb2584c77c6e1$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $706eb2584c77c6e1$export$6c40052bed430212(value) {
    return $706eb2584c77c6e1$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $706eb2584c77c6e1$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$706eb2584c77c6e1$var$isValidKey(prop)) continue;
        target[prop] = $706eb2584c77c6e1$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $706eb2584c77c6e1$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $706eb2584c77c6e1$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $706eb2584c77c6e1$var$getDefaultsFromGlobal = ()=>$706eb2584c77c6e1$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $706eb2584c77c6e1$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $706eb2584c77c6e1$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $706eb2584c77c6e1$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $706eb2584c77c6e1$export$212bb2fc580a90a8 = ()=>{
    try {
        return $706eb2584c77c6e1$var$getDefaultsFromGlobal() || $706eb2584c77c6e1$var$getDefaultsFromEnvVariable() || $706eb2584c77c6e1$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $706eb2584c77c6e1$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $706eb2584c77c6e1$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $706eb2584c77c6e1$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $706eb2584c77c6e1$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $706eb2584c77c6e1$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $706eb2584c77c6e1$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $706eb2584c77c6e1$export$4b5284a3025a455(JSON.stringify(header)),
        $706eb2584c77c6e1$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $706eb2584c77c6e1$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $706eb2584c77c6e1$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($706eb2584c77c6e1$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $706eb2584c77c6e1$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $706eb2584c77c6e1$export$4e09c449d6c407f7() {
    return typeof self === 'object' && self.self === self;
}
function $706eb2584c77c6e1$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $706eb2584c77c6e1$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $706eb2584c77c6e1$export$f2f6a8999f8ebd30() {
    return $706eb2584c77c6e1$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $706eb2584c77c6e1$export$7e7b1a9668aaed8() {
    const ua = $706eb2584c77c6e1$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $706eb2584c77c6e1$export$202944b2d2824246() {
    return $706eb2584c77c6e1$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $706eb2584c77c6e1$export$5d1d834fbbf8bab7() {
    return $706eb2584c77c6e1$export$588c7fdda06fbb0a.NODE_CLIENT === true || $706eb2584c77c6e1$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $706eb2584c77c6e1$export$95df08bae54cb4df() {
    return !$706eb2584c77c6e1$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $706eb2584c77c6e1$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $706eb2584c77c6e1$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $706eb2584c77c6e1$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $706eb2584c77c6e1$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $706eb2584c77c6e1$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $706eb2584c77c6e1$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $706eb2584c77c6e1$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $706eb2584c77c6e1$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $706eb2584c77c6e1$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $706eb2584c77c6e1$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $706eb2584c77c6e1$var$replaceTemplate(template, data) {
    return template.replace($706eb2584c77c6e1$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $706eb2584c77c6e1$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $706eb2584c77c6e1$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $706eb2584c77c6e1$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $706eb2584c77c6e1$export$c5a53ce6a17cf18d($706eb2584c77c6e1$export$c62426fdd000a97e(parts[0]) || '');
        claims = $706eb2584c77c6e1$export$c5a53ce6a17cf18d($706eb2584c77c6e1$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$5f870fcca7ae6a88 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$701c661ec91095f2 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $706eb2584c77c6e1$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$fc970ed23da99565 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $706eb2584c77c6e1$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $706eb2584c77c6e1$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $706eb2584c77c6e1$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $706eb2584c77c6e1$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($706eb2584c77c6e1$var$isObject(aProp) && $706eb2584c77c6e1$var$isObject(bProp)) {
            if (!$706eb2584c77c6e1$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $706eb2584c77c6e1$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $706eb2584c77c6e1$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $706eb2584c77c6e1$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $706eb2584c77c6e1$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $706eb2584c77c6e1$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $706eb2584c77c6e1$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $706eb2584c77c6e1$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $706eb2584c77c6e1$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $706eb2584c77c6e1$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $706eb2584c77c6e1$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($706eb2584c77c6e1$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $706eb2584c77c6e1$var$noop;
        if (observer.error === undefined) observer.error = $706eb2584c77c6e1$var$noop;
        if (observer.complete === undefined) observer.complete = $706eb2584c77c6e1$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $706eb2584c77c6e1$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $706eb2584c77c6e1$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $706eb2584c77c6e1$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $706eb2584c77c6e1$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $706eb2584c77c6e1$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $706eb2584c77c6e1$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $706eb2584c77c6e1$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $706eb2584c77c6e1$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $706eb2584c77c6e1$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $706eb2584c77c6e1$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $706eb2584c77c6e1$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $706eb2584c77c6e1$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $706eb2584c77c6e1$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $706eb2584c77c6e1$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $706eb2584c77c6e1$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $706eb2584c77c6e1$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $706eb2584c77c6e1$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $706eb2584c77c6e1$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $706eb2584c77c6e1$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($706eb2584c77c6e1$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $706eb2584c77c6e1$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $706eb2584c77c6e1$var$indicator(i);
}
function $706eb2584c77c6e1$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $83e41358bca2e3f4$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $83e41358bca2e3f4$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $706eb2584c77c6e1$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($83e41358bca2e3f4$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $83e41358bca2e3f4$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $83e41358bca2e3f4$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $83e41358bca2e3f4$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $83e41358bca2e3f4$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $83e41358bca2e3f4$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $72e7953bca38524c$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $72e7953bca38524c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($72e7953bca38524c$export$243e62d78d3b544d || ($72e7953bca38524c$export$243e62d78d3b544d = {}));
const $72e7953bca38524c$var$levelStringToEnum = {
    'debug': $72e7953bca38524c$export$243e62d78d3b544d.DEBUG,
    'verbose': $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE,
    'info': $72e7953bca38524c$export$243e62d78d3b544d.INFO,
    'warn': $72e7953bca38524c$export$243e62d78d3b544d.WARN,
    'error': $72e7953bca38524c$export$243e62d78d3b544d.ERROR,
    'silent': $72e7953bca38524c$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $72e7953bca38524c$var$defaultLogLevel = $72e7953bca38524c$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $72e7953bca38524c$var$ConsoleMethod = {
    [$72e7953bca38524c$export$243e62d78d3b544d.DEBUG]: 'log',
    [$72e7953bca38524c$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$72e7953bca38524c$export$243e62d78d3b544d.INFO]: 'info',
    [$72e7953bca38524c$export$243e62d78d3b544d.WARN]: 'warn',
    [$72e7953bca38524c$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $72e7953bca38524c$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $72e7953bca38524c$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $72e7953bca38524c$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $72e7953bca38524c$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $72e7953bca38524c$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $72e7953bca38524c$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $72e7953bca38524c$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $72e7953bca38524c$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $72e7953bca38524c$export$c622e99c0ce7b1c9(level) {
    $72e7953bca38524c$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $72e7953bca38524c$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $72e7953bca38524c$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $72e7953bca38524c$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $72e7953bca38524c$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $5f31840df4fad724$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $5f31840df4fad724$var$idbProxyableTypes;
let $5f31840df4fad724$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $5f31840df4fad724$var$getIdbProxyableTypes() {
    return $5f31840df4fad724$var$idbProxyableTypes || ($5f31840df4fad724$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $5f31840df4fad724$var$getCursorAdvanceMethods() {
    return $5f31840df4fad724$var$cursorAdvanceMethods || ($5f31840df4fad724$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $5f31840df4fad724$var$cursorRequestMap = new WeakMap();
const $5f31840df4fad724$var$transactionDoneMap = new WeakMap();
const $5f31840df4fad724$var$transactionStoreNamesMap = new WeakMap();
const $5f31840df4fad724$var$transformCache = new WeakMap();
const $5f31840df4fad724$export$407448d2b89b1813 = new WeakMap();
function $5f31840df4fad724$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($5f31840df4fad724$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $5f31840df4fad724$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $5f31840df4fad724$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $5f31840df4fad724$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($5f31840df4fad724$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $5f31840df4fad724$var$transactionDoneMap.set(tx, done);
}
let $5f31840df4fad724$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $5f31840df4fad724$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $5f31840df4fad724$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $5f31840df4fad724$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $5f31840df4fad724$export$43caf9889c228507(callback) {
    $5f31840df4fad724$var$idbProxyTraps = callback($5f31840df4fad724$var$idbProxyTraps);
}
function $5f31840df4fad724$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($5f31840df4fad724$export$3b14a55fb2447963(this), storeNames, ...args);
        $5f31840df4fad724$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $5f31840df4fad724$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($5f31840df4fad724$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($5f31840df4fad724$export$3b14a55fb2447963(this), args);
        return $5f31840df4fad724$export$efccba1c4a2ef57b($5f31840df4fad724$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $5f31840df4fad724$export$efccba1c4a2ef57b(func.apply($5f31840df4fad724$export$3b14a55fb2447963(this), args));
    };
}
function $5f31840df4fad724$var$transformCachableValue(value) {
    if (typeof value === 'function') return $5f31840df4fad724$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $5f31840df4fad724$var$cacheDonePromiseForTransaction(value);
    if ($5f31840df4fad724$export$23f2a1d2818174ef(value, $5f31840df4fad724$var$getIdbProxyableTypes())) return new Proxy(value, $5f31840df4fad724$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $5f31840df4fad724$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $5f31840df4fad724$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($5f31840df4fad724$var$transformCache.has(value)) return $5f31840df4fad724$var$transformCache.get(value);
    const newValue = $5f31840df4fad724$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $5f31840df4fad724$var$transformCache.set(value, newValue);
        $5f31840df4fad724$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $5f31840df4fad724$export$3b14a55fb2447963 = (value)=>$5f31840df4fad724$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $2178381af1cf984e$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $2178381af1cf984e$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $2178381af1cf984e$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $2178381af1cf984e$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $2178381af1cf984e$var$cachedMethods = new Map();
function $2178381af1cf984e$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($2178381af1cf984e$var$cachedMethods.get(prop)) return $2178381af1cf984e$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $2178381af1cf984e$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $2178381af1cf984e$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $2178381af1cf984e$var$cachedMethods.set(prop, method);
    return method;
}
(0, $5f31840df4fad724$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$2178381af1cf984e$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$2178381af1cf984e$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c682bcd2a19f8af3$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($c682bcd2a19f8af3$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $c682bcd2a19f8af3$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $c682bcd2a19f8af3$var$name$o = "@firebase/app";
const $c682bcd2a19f8af3$var$version$1 = "0.9.29";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$logger = new (0, $72e7953bca38524c$export$efa9a398d6368992)('@firebase/app');
const $c682bcd2a19f8af3$var$name$n = "@firebase/app-compat";
const $c682bcd2a19f8af3$var$name$m = "@firebase/analytics-compat";
const $c682bcd2a19f8af3$var$name$l = "@firebase/analytics";
const $c682bcd2a19f8af3$var$name$k = "@firebase/app-check-compat";
const $c682bcd2a19f8af3$var$name$j = "@firebase/app-check";
const $c682bcd2a19f8af3$var$name$i = "@firebase/auth";
const $c682bcd2a19f8af3$var$name$h = "@firebase/auth-compat";
const $c682bcd2a19f8af3$var$name$g = "@firebase/database";
const $c682bcd2a19f8af3$var$name$f = "@firebase/database-compat";
const $c682bcd2a19f8af3$var$name$e = "@firebase/functions";
const $c682bcd2a19f8af3$var$name$d = "@firebase/functions-compat";
const $c682bcd2a19f8af3$var$name$c = "@firebase/installations";
const $c682bcd2a19f8af3$var$name$b = "@firebase/installations-compat";
const $c682bcd2a19f8af3$var$name$a = "@firebase/messaging";
const $c682bcd2a19f8af3$var$name$9 = "@firebase/messaging-compat";
const $c682bcd2a19f8af3$var$name$8 = "@firebase/performance";
const $c682bcd2a19f8af3$var$name$7 = "@firebase/performance-compat";
const $c682bcd2a19f8af3$var$name$6 = "@firebase/remote-config";
const $c682bcd2a19f8af3$var$name$5 = "@firebase/remote-config-compat";
const $c682bcd2a19f8af3$var$name$4 = "@firebase/storage";
const $c682bcd2a19f8af3$var$name$3 = "@firebase/storage-compat";
const $c682bcd2a19f8af3$var$name$2 = "@firebase/firestore";
const $c682bcd2a19f8af3$var$name$1 = "@firebase/firestore-compat";
const $c682bcd2a19f8af3$var$name = "firebase";
const $c682bcd2a19f8af3$var$version = "10.9.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $c682bcd2a19f8af3$export$9f30fa0c10967f7f = '[DEFAULT]';
const $c682bcd2a19f8af3$var$PLATFORM_LOG_STRING = {
    [$c682bcd2a19f8af3$var$name$o]: 'fire-core',
    [$c682bcd2a19f8af3$var$name$n]: 'fire-core-compat',
    [$c682bcd2a19f8af3$var$name$l]: 'fire-analytics',
    [$c682bcd2a19f8af3$var$name$m]: 'fire-analytics-compat',
    [$c682bcd2a19f8af3$var$name$j]: 'fire-app-check',
    [$c682bcd2a19f8af3$var$name$k]: 'fire-app-check-compat',
    [$c682bcd2a19f8af3$var$name$i]: 'fire-auth',
    [$c682bcd2a19f8af3$var$name$h]: 'fire-auth-compat',
    [$c682bcd2a19f8af3$var$name$g]: 'fire-rtdb',
    [$c682bcd2a19f8af3$var$name$f]: 'fire-rtdb-compat',
    [$c682bcd2a19f8af3$var$name$e]: 'fire-fn',
    [$c682bcd2a19f8af3$var$name$d]: 'fire-fn-compat',
    [$c682bcd2a19f8af3$var$name$c]: 'fire-iid',
    [$c682bcd2a19f8af3$var$name$b]: 'fire-iid-compat',
    [$c682bcd2a19f8af3$var$name$a]: 'fire-fcm',
    [$c682bcd2a19f8af3$var$name$9]: 'fire-fcm-compat',
    [$c682bcd2a19f8af3$var$name$8]: 'fire-perf',
    [$c682bcd2a19f8af3$var$name$7]: 'fire-perf-compat',
    [$c682bcd2a19f8af3$var$name$6]: 'fire-rc',
    [$c682bcd2a19f8af3$var$name$5]: 'fire-rc-compat',
    [$c682bcd2a19f8af3$var$name$4]: 'fire-gcs',
    [$c682bcd2a19f8af3$var$name$3]: 'fire-gcs-compat',
    [$c682bcd2a19f8af3$var$name$2]: 'fire-fst',
    [$c682bcd2a19f8af3$var$name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [$c682bcd2a19f8af3$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $c682bcd2a19f8af3$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c682bcd2a19f8af3$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $c682bcd2a19f8af3$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($c682bcd2a19f8af3$export$9566bce3835c0f28.has(componentName)) {
        $c682bcd2a19f8af3$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $c682bcd2a19f8af3$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $c682bcd2a19f8af3$export$b4e3c36c855b14b5.values())$c682bcd2a19f8af3$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $c682bcd2a19f8af3$export$9f30fa0c10967f7f) {
    $c682bcd2a19f8af3$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$3685d89b9c3cdfaf() {
    $c682bcd2a19f8af3$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const $c682bcd2a19f8af3$var$ERROR_FACTORY = new (0, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40)('app', 'Firebase', $c682bcd2a19f8af3$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c682bcd2a19f8af3$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $c682bcd2a19f8af3$export$31499a9cd224b78c = $c682bcd2a19f8af3$var$version;
function $c682bcd2a19f8af3$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $c682bcd2a19f8af3$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $706eb2584c77c6e1$export$3dfb6827a9f89756)());
    if (!options) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $c682bcd2a19f8af3$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $706eb2584c77c6e1$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $706eb2584c77c6e1$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $83e41358bca2e3f4$export$436a80eea5d5c0c5)(name);
    for (const component of $c682bcd2a19f8af3$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $c682bcd2a19f8af3$var$FirebaseAppImpl(options, config, container);
    $c682bcd2a19f8af3$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$f9962582c9e66d99(name = $c682bcd2a19f8af3$export$9f30fa0c10967f7f) {
    const app = $c682bcd2a19f8af3$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $c682bcd2a19f8af3$export$9f30fa0c10967f7f && (0, $706eb2584c77c6e1$export$3dfb6827a9f89756)()) return $c682bcd2a19f8af3$export$c55cfd413944906d();
    if (!app) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $c682bcd2a19f8af3$export$68ddedf7d44b3bdf() {
    return Array.from($c682bcd2a19f8af3$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $c682bcd2a19f8af3$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($c682bcd2a19f8af3$export$b4e3c36c855b14b5.has(name)) {
        $c682bcd2a19f8af3$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $c682bcd2a19f8af3$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $c682bcd2a19f8af3$var$logger.warn(warning.join(' '));
        return;
    }
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $72e7953bca38524c$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $c682bcd2a19f8af3$export$c622e99c0ce7b1c9(logLevel) {
    (0, $72e7953bca38524c$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$DB_NAME = 'firebase-heartbeat-database';
const $c682bcd2a19f8af3$var$DB_VERSION = 1;
const $c682bcd2a19f8af3$var$STORE_NAME = 'firebase-heartbeat-store';
let $c682bcd2a19f8af3$var$dbPromise = null;
function $c682bcd2a19f8af3$var$getDbPromise() {
    if (!$c682bcd2a19f8af3$var$dbPromise) $c682bcd2a19f8af3$var$dbPromise = (0, $2178381af1cf984e$export$ca0ed41b1a2af7e)($c682bcd2a19f8af3$var$DB_NAME, $c682bcd2a19f8af3$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($c682bcd2a19f8af3$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $c682bcd2a19f8af3$var$dbPromise;
}
async function $c682bcd2a19f8af3$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $c682bcd2a19f8af3$var$getDbPromise();
        const tx = db.transaction($c682bcd2a19f8af3$var$STORE_NAME);
        const result = await tx.objectStore($c682bcd2a19f8af3$var$STORE_NAME).get($c682bcd2a19f8af3$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56)) $c682bcd2a19f8af3$var$logger.warn(e.message);
        else {
            const idbGetError = $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $c682bcd2a19f8af3$var$logger.warn(idbGetError.message);
        }
    }
}
async function $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $c682bcd2a19f8af3$var$getDbPromise();
        const tx = db.transaction($c682bcd2a19f8af3$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($c682bcd2a19f8af3$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $c682bcd2a19f8af3$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56)) $c682bcd2a19f8af3$var$logger.warn(e.message);
        else {
            const idbGetError = $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $c682bcd2a19f8af3$var$logger.warn(idbGetError.message);
        }
    }
}
function $c682bcd2a19f8af3$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $c682bcd2a19f8af3$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $c682bcd2a19f8af3$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $c682bcd2a19f8af3$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container.getProvider('platform-logger').getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $c682bcd2a19f8af3$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $c682bcd2a19f8af3$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
        const date = $c682bcd2a19f8af3$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $c682bcd2a19f8af3$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $706eb2584c77c6e1$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $c682bcd2a19f8af3$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $c682bcd2a19f8af3$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $c682bcd2a19f8af3$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($c682bcd2a19f8af3$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($c682bcd2a19f8af3$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $c682bcd2a19f8af3$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $706eb2584c77c6e1$export$3865db50535c2055)()) return false;
        else return (0, $706eb2584c77c6e1$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $c682bcd2a19f8af3$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $c682bcd2a19f8af3$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $706eb2584c77c6e1$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c682bcd2a19f8af3$var$registerCoreComponents(variant) {
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('platform-logger', (container)=>new $c682bcd2a19f8af3$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('heartbeat', (container)=>new $c682bcd2a19f8af3$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $c682bcd2a19f8af3$export$d29d5299a7137abc($c682bcd2a19f8af3$var$name$o, $c682bcd2a19f8af3$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $c682bcd2a19f8af3$export$d29d5299a7137abc($c682bcd2a19f8af3$var$name$o, $c682bcd2a19f8af3$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $c682bcd2a19f8af3$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $c682bcd2a19f8af3$var$registerCoreComponents('');





const $4f47a76551f5e858$var$name = "@firebase/installations";
const $4f47a76551f5e858$var$version = "0.6.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$PENDING_TIMEOUT_MS = 10000;
const $4f47a76551f5e858$var$PACKAGE_VERSION = `w:${$4f47a76551f5e858$var$version}`;
const $4f47a76551f5e858$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $4f47a76551f5e858$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $4f47a76551f5e858$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $4f47a76551f5e858$var$SERVICE = 'installations';
const $4f47a76551f5e858$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $4f47a76551f5e858$var$ERROR_FACTORY = new (0, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40)($4f47a76551f5e858$var$SERVICE, $4f47a76551f5e858$var$SERVICE_NAME, $4f47a76551f5e858$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $4f47a76551f5e858$var$isServerError(error) {
    return error instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4f47a76551f5e858$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$4f47a76551f5e858$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $4f47a76551f5e858$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $4f47a76551f5e858$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $4f47a76551f5e858$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $4f47a76551f5e858$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $4f47a76551f5e858$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $4f47a76551f5e858$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $4f47a76551f5e858$var$getHeaders(appConfig);
    headers.append('Authorization', $4f47a76551f5e858$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $4f47a76551f5e858$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $4f47a76551f5e858$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $4f47a76551f5e858$var$getAuthorizationHeader(refreshToken) {
    return `${$4f47a76551f5e858$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4f47a76551f5e858$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $4f47a76551f5e858$var$getInstallationsEndpoint(appConfig);
    const headers = $4f47a76551f5e858$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $4f47a76551f5e858$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $4f47a76551f5e858$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $4f47a76551f5e858$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $4f47a76551f5e858$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $4f47a76551f5e858$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $4f47a76551f5e858$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4f47a76551f5e858$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $4f47a76551f5e858$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $4f47a76551f5e858$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $4f47a76551f5e858$var$encode(fidByteArray);
        return $4f47a76551f5e858$var$VALID_FID_PATTERN.test(fid) ? fid : $4f47a76551f5e858$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $4f47a76551f5e858$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $4f47a76551f5e858$var$encode(fidByteArray) {
    const b64String = $4f47a76551f5e858$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $4f47a76551f5e858$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $4f47a76551f5e858$var$fidChanged(appConfig, fid) {
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    $4f47a76551f5e858$var$callFidChangeCallbacks(key, fid);
    $4f47a76551f5e858$var$broadcastFidChange(key, fid);
}
function $4f47a76551f5e858$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $4f47a76551f5e858$var$getBroadcastChannel();
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    let callbackSet = $4f47a76551f5e858$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $4f47a76551f5e858$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $4f47a76551f5e858$var$removeCallback(appConfig, callback) {
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    const callbackSet = $4f47a76551f5e858$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $4f47a76551f5e858$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $4f47a76551f5e858$var$closeBroadcastChannel();
}
function $4f47a76551f5e858$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $4f47a76551f5e858$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $4f47a76551f5e858$var$broadcastFidChange(key, fid) {
    const channel = $4f47a76551f5e858$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $4f47a76551f5e858$var$closeBroadcastChannel();
}
let $4f47a76551f5e858$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $4f47a76551f5e858$var$getBroadcastChannel() {
    if (!$4f47a76551f5e858$var$broadcastChannel && 'BroadcastChannel' in self) {
        $4f47a76551f5e858$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $4f47a76551f5e858$var$broadcastChannel.onmessage = (e)=>{
            $4f47a76551f5e858$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $4f47a76551f5e858$var$broadcastChannel;
}
function $4f47a76551f5e858$var$closeBroadcastChannel() {
    if ($4f47a76551f5e858$var$fidChangeCallbacks.size === 0 && $4f47a76551f5e858$var$broadcastChannel) {
        $4f47a76551f5e858$var$broadcastChannel.close();
        $4f47a76551f5e858$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$DATABASE_NAME = 'firebase-installations-database';
const $4f47a76551f5e858$var$DATABASE_VERSION = 1;
const $4f47a76551f5e858$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $4f47a76551f5e858$var$dbPromise = null;
function $4f47a76551f5e858$var$getDbPromise() {
    if (!$4f47a76551f5e858$var$dbPromise) $4f47a76551f5e858$var$dbPromise = (0, $2178381af1cf984e$export$ca0ed41b1a2af7e)($4f47a76551f5e858$var$DATABASE_NAME, $4f47a76551f5e858$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($4f47a76551f5e858$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $4f47a76551f5e858$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $4f47a76551f5e858$var$set(appConfig, value) {
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    const db = await $4f47a76551f5e858$var$getDbPromise();
    const tx = db.transaction($4f47a76551f5e858$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($4f47a76551f5e858$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $4f47a76551f5e858$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $4f47a76551f5e858$var$remove(appConfig) {
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    const db = await $4f47a76551f5e858$var$getDbPromise();
    const tx = db.transaction($4f47a76551f5e858$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($4f47a76551f5e858$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $4f47a76551f5e858$var$update(appConfig, updateFn) {
    const key = $4f47a76551f5e858$var$getKey(appConfig);
    const db = await $4f47a76551f5e858$var$getDbPromise();
    const tx = db.transaction($4f47a76551f5e858$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($4f47a76551f5e858$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $4f47a76551f5e858$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $4f47a76551f5e858$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $4f47a76551f5e858$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $4f47a76551f5e858$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $4f47a76551f5e858$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $4f47a76551f5e858$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $4f47a76551f5e858$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $4f47a76551f5e858$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $4f47a76551f5e858$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $4f47a76551f5e858$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($4f47a76551f5e858$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $4f47a76551f5e858$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $4f47a76551f5e858$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $4f47a76551f5e858$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $4f47a76551f5e858$var$createInstallationRequest(installations, installationEntry);
        return $4f47a76551f5e858$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($4f47a76551f5e858$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $4f47a76551f5e858$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $4f47a76551f5e858$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $4f47a76551f5e858$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $4f47a76551f5e858$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $4f47a76551f5e858$var$sleep(100);
        entry = await $4f47a76551f5e858$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $4f47a76551f5e858$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $4f47a76551f5e858$var$updateInstallationRequest(appConfig) {
    return $4f47a76551f5e858$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $4f47a76551f5e858$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $4f47a76551f5e858$var$clearTimedOutRequest(oldEntry);
    });
}
function $4f47a76551f5e858$var$clearTimedOutRequest(entry) {
    if ($4f47a76551f5e858$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $4f47a76551f5e858$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $4f47a76551f5e858$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4f47a76551f5e858$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $4f47a76551f5e858$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $4f47a76551f5e858$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $4f47a76551f5e858$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $4f47a76551f5e858$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $4f47a76551f5e858$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $4f47a76551f5e858$var$getErrorFromResponse('Generate Auth Token', response);
}
function $4f47a76551f5e858$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$4f47a76551f5e858$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $4f47a76551f5e858$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $4f47a76551f5e858$var$update(installations.appConfig, (oldEntry)=>{
        if (!$4f47a76551f5e858$var$isEntryRegistered(oldEntry)) throw $4f47a76551f5e858$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $4f47a76551f5e858$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $4f47a76551f5e858$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $4f47a76551f5e858$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $4f47a76551f5e858$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $4f47a76551f5e858$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $4f47a76551f5e858$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $4f47a76551f5e858$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $4f47a76551f5e858$var$sleep(100);
        entry = await $4f47a76551f5e858$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $4f47a76551f5e858$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $4f47a76551f5e858$var$updateAuthTokenRequest(appConfig) {
    return $4f47a76551f5e858$var$update(appConfig, (oldEntry)=>{
        if (!$4f47a76551f5e858$var$isEntryRegistered(oldEntry)) throw $4f47a76551f5e858$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($4f47a76551f5e858$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $4f47a76551f5e858$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $4f47a76551f5e858$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $4f47a76551f5e858$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($4f47a76551f5e858$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $4f47a76551f5e858$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $4f47a76551f5e858$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $4f47a76551f5e858$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $4f47a76551f5e858$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$4f47a76551f5e858$var$isAuthTokenExpired(authToken);
}
function $4f47a76551f5e858$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $4f47a76551f5e858$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $4f47a76551f5e858$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $4f47a76551f5e858$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $4f47a76551f5e858$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $4f47a76551f5e858$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $4f47a76551f5e858$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $4f47a76551f5e858$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $4f47a76551f5e858$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $4f47a76551f5e858$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $4f47a76551f5e858$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $4f47a76551f5e858$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $4f47a76551f5e858$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4f47a76551f5e858$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $4f47a76551f5e858$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $4f47a76551f5e858$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $4f47a76551f5e858$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $4f47a76551f5e858$var$getErrorFromResponse('Delete Installation', response);
}
function $4f47a76551f5e858$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$4f47a76551f5e858$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $4f47a76551f5e858$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $4f47a76551f5e858$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $4f47a76551f5e858$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $4f47a76551f5e858$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $4f47a76551f5e858$var$deleteInstallationRequest(appConfig, entry);
                await $4f47a76551f5e858$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $4f47a76551f5e858$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $4f47a76551f5e858$var$addCallback(appConfig, callback);
    return ()=>{
        $4f47a76551f5e858$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $4f47a76551f5e858$export$9bfc115e43431ff5(app = (0, $c682bcd2a19f8af3$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4f47a76551f5e858$var$extractAppConfig(app) {
    if (!app || !app.options) throw $4f47a76551f5e858$var$getMissingValueError('App Configuration');
    if (!app.name) throw $4f47a76551f5e858$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $4f47a76551f5e858$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $4f47a76551f5e858$var$getMissingValueError(valueName) {
    return $4f47a76551f5e858$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4f47a76551f5e858$var$INSTALLATIONS_NAME = 'installations';
const $4f47a76551f5e858$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $4f47a76551f5e858$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $4f47a76551f5e858$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $4f47a76551f5e858$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)(app, $4f47a76551f5e858$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$4f47a76551f5e858$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$4f47a76551f5e858$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $4f47a76551f5e858$var$registerInstallations() {
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)($4f47a76551f5e858$var$INSTALLATIONS_NAME, $4f47a76551f5e858$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)($4f47a76551f5e858$var$INSTALLATIONS_NAME_INTERNAL, $4f47a76551f5e858$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $4f47a76551f5e858$var$registerInstallations();
(0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($4f47a76551f5e858$var$name, $4f47a76551f5e858$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($4f47a76551f5e858$var$name, $4f47a76551f5e858$var$version, 'esm2017');






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5f3bee57d2d66924$var$DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const $5f3bee57d2d66924$var$DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const $5f3bee57d2d66924$var$DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const $5f3bee57d2d66924$var$ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const $5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const $5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const $5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */ const $5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var $5f3bee57d2d66924$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($5f3bee57d2d66924$var$MessageType$1 || ($5f3bee57d2d66924$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $5f3bee57d2d66924$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($5f3bee57d2d66924$var$MessageType || ($5f3bee57d2d66924$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5f3bee57d2d66924$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $5f3bee57d2d66924$var$base64ToArray(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5f3bee57d2d66924$var$OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $5f3bee57d2d66924$var$OLD_DB_VERSION = 5;
const $5f3bee57d2d66924$var$OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function $5f3bee57d2d66924$var$migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($5f3bee57d2d66924$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $2178381af1cf984e$export$ca0ed41b1a2af7e)($5f3bee57d2d66924$var$OLD_DB_NAME, $5f3bee57d2d66924$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            var _a;
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($5f3bee57d2d66924$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($5f3bee57d2d66924$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : $5f3bee57d2d66924$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.auth),
                        p256dh: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.auth),
                        p256dh: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $5f3bee57d2d66924$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $2178381af1cf984e$export$9d6df0ac66a98bb2)($5f3bee57d2d66924$var$OLD_DB_NAME);
    await (0, $2178381af1cf984e$export$9d6df0ac66a98bb2)('fcm_vapid_details_db');
    await (0, $2178381af1cf984e$export$9d6df0ac66a98bb2)('undefined');
    return $5f3bee57d2d66924$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $5f3bee57d2d66924$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
const $5f3bee57d2d66924$var$DATABASE_NAME = 'firebase-messaging-database';
const $5f3bee57d2d66924$var$DATABASE_VERSION = 1;
const $5f3bee57d2d66924$var$OBJECT_STORE_NAME = 'firebase-messaging-store';
let $5f3bee57d2d66924$var$dbPromise = null;
function $5f3bee57d2d66924$var$getDbPromise() {
    if (!$5f3bee57d2d66924$var$dbPromise) $5f3bee57d2d66924$var$dbPromise = (0, $2178381af1cf984e$export$ca0ed41b1a2af7e)($5f3bee57d2d66924$var$DATABASE_NAME, $5f3bee57d2d66924$var$DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore($5f3bee57d2d66924$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $5f3bee57d2d66924$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ async function $5f3bee57d2d66924$var$dbGet(firebaseDependencies) {
    const key = $5f3bee57d2d66924$var$getKey(firebaseDependencies);
    const db = await $5f3bee57d2d66924$var$getDbPromise();
    const tokenDetails = await db.transaction($5f3bee57d2d66924$var$OBJECT_STORE_NAME).objectStore($5f3bee57d2d66924$var$OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await $5f3bee57d2d66924$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $5f3bee57d2d66924$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $5f3bee57d2d66924$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $5f3bee57d2d66924$var$getKey(firebaseDependencies);
    const db = await $5f3bee57d2d66924$var$getDbPromise();
    const tx = db.transaction($5f3bee57d2d66924$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($5f3bee57d2d66924$var$OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $5f3bee57d2d66924$var$dbRemove(firebaseDependencies) {
    const key = $5f3bee57d2d66924$var$getKey(firebaseDependencies);
    const db = await $5f3bee57d2d66924$var$getDbPromise();
    const tx = db.transaction($5f3bee57d2d66924$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($5f3bee57d2d66924$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $5f3bee57d2d66924$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5f3bee57d2d66924$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: 'FCM returned no token when subscribing the user to push.',
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const $5f3bee57d2d66924$var$ERROR_FACTORY = new (0, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40)('messaging', 'Messaging', $5f3bee57d2d66924$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $5f3bee57d2d66924$var$getHeaders(firebaseDependencies);
    const body = $5f3bee57d2d66924$var$getBody(subscriptionOptions);
    const subscribeOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($5f3bee57d2d66924$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $5f3bee57d2d66924$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $5f3bee57d2d66924$var$getHeaders(firebaseDependencies);
    const body = $5f3bee57d2d66924$var$getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$5f3bee57d2d66924$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $5f3bee57d2d66924$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $5f3bee57d2d66924$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers: headers
    };
    try {
        const response = await fetch(`${$5f3bee57d2d66924$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function $5f3bee57d2d66924$var$getEndpoint({ projectId: projectId }) {
    return `${$5f3bee57d2d66924$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $5f3bee57d2d66924$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
function $5f3bee57d2d66924$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey }) {
    const body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $5f3bee57d2d66924$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $5f3bee57d2d66924$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $5f3bee57d2d66924$var$getTokenInternal(messaging) {
    const pushSubscription = await $5f3bee57d2d66924$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $5f3bee57d2d66924$var$arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: $5f3bee57d2d66924$var$arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await $5f3bee57d2d66924$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $5f3bee57d2d66924$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$5f3bee57d2d66924$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $5f3bee57d2d66924$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $5f3bee57d2d66924$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $5f3bee57d2d66924$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $5f3bee57d2d66924$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ async function $5f3bee57d2d66924$var$deleteTokenInternal(messaging) {
    const tokenDetails = await $5f3bee57d2d66924$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await $5f3bee57d2d66924$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await $5f3bee57d2d66924$var$dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $5f3bee57d2d66924$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $5f3bee57d2d66924$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await $5f3bee57d2d66924$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        await $5f3bee57d2d66924$var$deleteTokenInternal(messaging);
        throw e;
    }
}
async function $5f3bee57d2d66924$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $5f3bee57d2d66924$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $5f3bee57d2d66924$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $5f3bee57d2d66924$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $5f3bee57d2d66924$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $5f3bee57d2d66924$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5f3bee57d2d66924$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $5f3bee57d2d66924$var$propagateNotificationPayload(payload, internalPayload);
    $5f3bee57d2d66924$var$propagateDataPayload(payload, internalPayload);
    $5f3bee57d2d66924$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $5f3bee57d2d66924$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $5f3bee57d2d66924$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $5f3bee57d2d66924$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) return;
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5f3bee57d2d66924$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && $5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $5f3bee57d2d66924$var$_mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
$5f3bee57d2d66924$var$_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function $5f3bee57d2d66924$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5f3bee57d2d66924$var$extractAppConfig(app) {
    if (!app || !app.options) throw $5f3bee57d2d66924$var$getMissingValueError('App Configuration Object');
    if (!app.name) throw $5f3bee57d2d66924$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $5f3bee57d2d66924$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $5f3bee57d2d66924$var$getMissingValueError(valueName) {
    return $5f3bee57d2d66924$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5f3bee57d2d66924$var$MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = $5f3bee57d2d66924$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($5f3bee57d2d66924$var$DEFAULT_SW_PATH, {
            scope: $5f3bee57d2d66924$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
    } catch (e) {
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $5f3bee57d2d66924$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $5f3bee57d2d66924$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$getToken$1(messaging, options) {
    if (!navigator) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $5f3bee57d2d66924$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $5f3bee57d2d66924$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $5f3bee57d2d66924$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$logToScion(messaging, messageType, data) {
    const eventType = $5f3bee57d2d66924$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $5f3bee57d2d66924$var$getEventType(messageType) {
    switch(messageType){
        case $5f3bee57d2d66924$var$MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case $5f3bee57d2d66924$var$MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $5f3bee57d2d66924$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') messaging.onMessageHandler($5f3bee57d2d66924$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($5f3bee57d2d66924$var$externalizePayload(internalPayload));
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($5f3bee57d2d66924$var$isConsoleMessage(dataPayload) && dataPayload[$5f3bee57d2d66924$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') await $5f3bee57d2d66924$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
const $5f3bee57d2d66924$var$name = "@firebase/messaging";
const $5f3bee57d2d66924$var$version = "0.12.6";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5f3bee57d2d66924$var$WindowMessagingFactory = (container)=>{
    const messaging = new $5f3bee57d2d66924$var$MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', (e)=>$5f3bee57d2d66924$var$messageEventListener(messaging, e));
    return messaging;
};
const $5f3bee57d2d66924$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider('messaging').getImmediate();
    const messagingInternal = {
        getToken: (options)=>$5f3bee57d2d66924$var$getToken$1(messaging, options)
    };
    return messagingInternal;
};
function $5f3bee57d2d66924$var$registerMessagingInWindow() {
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('messaging', $5f3bee57d2d66924$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('messaging-internal', $5f3bee57d2d66924$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($5f3bee57d2d66924$var$name, $5f3bee57d2d66924$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($5f3bee57d2d66924$var$name, $5f3bee57d2d66924$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $5f3bee57d2d66924$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $706eb2584c77c6e1$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== 'undefined' && (0, $706eb2584c77c6e1$export$3865db50535c2055)() && (0, $706eb2584c77c6e1$export$f172b7eb6cf60599)() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5f3bee57d2d66924$var$deleteToken$1(messaging) {
    if (!navigator) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $5f3bee57d2d66924$var$registerDefaultSw(messaging);
    return $5f3bee57d2d66924$var$deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5f3bee57d2d66924$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $5f3bee57d2d66924$export$f74c3c76482a8451(app = (0, $c682bcd2a19f8af3$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $5f3bee57d2d66924$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $5f3bee57d2d66924$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)((0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */ async function $5f3bee57d2d66924$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(messaging);
    return $5f3bee57d2d66924$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */ function $5f3bee57d2d66924$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(messaging);
    return $5f3bee57d2d66924$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $5f3bee57d2d66924$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(messaging);
    return $5f3bee57d2d66924$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $5f3bee57d2d66924$var$registerMessagingInWindow();





var $d41cf46441fcb495$var$name = "firebase";
var $d41cf46441fcb495$var$version = "10.9.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($d41cf46441fcb495$var$name, $d41cf46441fcb495$var$version, 'app');







/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $4df547b39bed1276$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $4df547b39bed1276$var$GA_FID_KEY = 'firebase_id';
const $4df547b39bed1276$var$ORIGIN_KEY = 'origin';
const $4df547b39bed1276$var$FETCH_TIMEOUT_MILLIS = 60000;
const $4df547b39bed1276$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $4df547b39bed1276$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4df547b39bed1276$var$logger = new (0, $72e7953bca38524c$export$efa9a398d6368992)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4df547b39bed1276$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $4df547b39bed1276$var$ERROR_FACTORY = new (0, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40)('analytics', 'Analytics', $4df547b39bed1276$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $4df547b39bed1276$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($4df547b39bed1276$var$GTAG_URL)) {
        const err = $4df547b39bed1276$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $4df547b39bed1276$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $4df547b39bed1276$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $4df547b39bed1276$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $4df547b39bed1276$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $4df547b39bed1276$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $4df547b39bed1276$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$4df547b39bed1276$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $4df547b39bed1276$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $4df547b39bed1276$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $4df547b39bed1276$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $4df547b39bed1276$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $4df547b39bed1276$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $4df547b39bed1276$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $4df547b39bed1276$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $4df547b39bed1276$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $4df547b39bed1276$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $4df547b39bed1276$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , 'update', gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $4df547b39bed1276$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $4df547b39bed1276$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $4df547b39bed1276$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $4df547b39bed1276$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($4df547b39bed1276$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $4df547b39bed1276$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $4df547b39bed1276$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $4df547b39bed1276$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $4df547b39bed1276$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $4df547b39bed1276$var$defaultRetryData = new $4df547b39bed1276$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $4df547b39bed1276$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $4df547b39bed1276$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $4df547b39bed1276$var$getHeaders(apiKey)
    };
    const appUrl = $4df547b39bed1276$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $4df547b39bed1276$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $4df547b39bed1276$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $4df547b39bed1276$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $4df547b39bed1276$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $4df547b39bed1276$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $4df547b39bed1276$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $4df547b39bed1276$var$FETCH_TIMEOUT_MILLIS);
    return $4df547b39bed1276$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $4df547b39bed1276$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $4df547b39bed1276$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $4df547b39bed1276$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $4df547b39bed1276$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $4df547b39bed1276$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$4df547b39bed1276$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $4df547b39bed1276$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $706eb2584c77c6e1$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $4df547b39bed1276$var$LONG_RETRY_FACTOR) : (0, $706eb2584c77c6e1$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $4df547b39bed1276$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $4df547b39bed1276$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $4df547b39bed1276$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($4df547b39bed1276$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $4df547b39bed1276$var$isRetriableError(e) {
    if (!(e instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $4df547b39bed1276$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $4df547b39bed1276$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $4df547b39bed1276$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $4df547b39bed1276$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $4df547b39bed1276$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $4df547b39bed1276$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $4df547b39bed1276$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($4df547b39bed1276$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $4df547b39bed1276$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $4df547b39bed1276$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $4df547b39bed1276$var$_setConsentDefaultForInit(consentSettings) {
    $4df547b39bed1276$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $4df547b39bed1276$var$_setDefaultEventParametersForInit(customParams) {
    $4df547b39bed1276$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4df547b39bed1276$var$validateIndexedDB() {
    if (!(0, $706eb2584c77c6e1$export$3865db50535c2055)()) {
        $4df547b39bed1276$var$logger.warn($4df547b39bed1276$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $706eb2584c77c6e1$export$a8a3018f3d187a4d)();
    } catch (e) {
        $4df547b39bed1276$var$logger.warn($4df547b39bed1276$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $4df547b39bed1276$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $4df547b39bed1276$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $4df547b39bed1276$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$4df547b39bed1276$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $4df547b39bed1276$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$4df547b39bed1276$var$findGtagScriptOnPage(dataLayerName)) $4df547b39bed1276$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($4df547b39bed1276$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $4df547b39bed1276$var$defaultConsentSettingsForInit);
        $4df547b39bed1276$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$4df547b39bed1276$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$4df547b39bed1276$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($4df547b39bed1276$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $4df547b39bed1276$var$defaultEventParametersForInit);
        $4df547b39bed1276$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $4df547b39bed1276$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $4df547b39bed1276$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $4df547b39bed1276$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $4df547b39bed1276$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $4df547b39bed1276$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $4df547b39bed1276$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $4df547b39bed1276$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $4df547b39bed1276$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $4df547b39bed1276$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $4df547b39bed1276$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $4df547b39bed1276$export$a5a6e0b888b2c992(options) {
    if ($4df547b39bed1276$var$globalInitDone) throw $4df547b39bed1276$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $4df547b39bed1276$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $4df547b39bed1276$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $4df547b39bed1276$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $706eb2584c77c6e1$export$caa8774a9107a58e)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $706eb2584c77c6e1$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $4df547b39bed1276$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $4df547b39bed1276$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $4df547b39bed1276$var$factory(app, installations, options) {
    $4df547b39bed1276$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $4df547b39bed1276$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $4df547b39bed1276$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $4df547b39bed1276$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($4df547b39bed1276$var$initializationPromisesMap[appId] != null) throw $4df547b39bed1276$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$4df547b39bed1276$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $4df547b39bed1276$var$getOrCreateDataLayer($4df547b39bed1276$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $4df547b39bed1276$var$wrapOrCreateGtag($4df547b39bed1276$var$initializationPromisesMap, $4df547b39bed1276$var$dynamicConfigPromisesList, $4df547b39bed1276$var$measurementIdToAppId, $4df547b39bed1276$var$dataLayerName, $4df547b39bed1276$var$gtagName);
        $4df547b39bed1276$var$wrappedGtagFunction = wrappedGtag;
        $4df547b39bed1276$var$gtagCoreFunction = gtagCore;
        $4df547b39bed1276$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $4df547b39bed1276$var$initializationPromisesMap[appId] = $4df547b39bed1276$var$_initializeAnalytics(app, $4df547b39bed1276$var$dynamicConfigPromisesList, $4df547b39bed1276$var$measurementIdToAppId, installations, $4df547b39bed1276$var$gtagCoreFunction, $4df547b39bed1276$var$dataLayerName, options);
    const analyticsInstance = new $4df547b39bed1276$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $4df547b39bed1276$export$b0297573c90085aa(app = (0, $c682bcd2a19f8af3$export$f9962582c9e66d99)()) {
    app = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)(app, $4df547b39bed1276$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $4df547b39bed1276$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $4df547b39bed1276$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)(app, $4df547b39bed1276$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $706eb2584c77c6e1$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $4df547b39bed1276$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $4df547b39bed1276$export$48c17662a6902497() {
    if ((0, $706eb2584c77c6e1$export$caa8774a9107a58e)()) return false;
    if (!(0, $706eb2584c77c6e1$export$f172b7eb6cf60599)()) return false;
    if (!(0, $706eb2584c77c6e1$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $706eb2584c77c6e1$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $4df547b39bed1276$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    $4df547b39bed1276$var$setCurrentScreen$1($4df547b39bed1276$var$wrappedGtagFunction, $4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$4df547b39bed1276$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $4df547b39bed1276$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    return $4df547b39bed1276$var$internalGetGoogleAnalyticsClientId($4df547b39bed1276$var$wrappedGtagFunction, $4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $4df547b39bed1276$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    $4df547b39bed1276$var$setUserId$1($4df547b39bed1276$var$wrappedGtagFunction, $4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$4df547b39bed1276$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $4df547b39bed1276$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    $4df547b39bed1276$var$setUserProperties$1($4df547b39bed1276$var$wrappedGtagFunction, $4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$4df547b39bed1276$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $4df547b39bed1276$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    $4df547b39bed1276$var$setAnalyticsCollectionEnabled$1($4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$4df547b39bed1276$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $4df547b39bed1276$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($4df547b39bed1276$var$wrappedGtagFunction) $4df547b39bed1276$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $4df547b39bed1276$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $4df547b39bed1276$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(analyticsInstance);
    $4df547b39bed1276$var$logEvent$1($4df547b39bed1276$var$wrappedGtagFunction, $4df547b39bed1276$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$4df547b39bed1276$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $4df547b39bed1276$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($4df547b39bed1276$var$wrappedGtagFunction) $4df547b39bed1276$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $4df547b39bed1276$var$_setConsentDefaultForInit(consentSettings);
}
const $4df547b39bed1276$var$name = "@firebase/analytics";
const $4df547b39bed1276$var$version = "0.10.1";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $4df547b39bed1276$var$registerAnalytics() {
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)($4df547b39bed1276$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $4df547b39bed1276$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($4df547b39bed1276$var$name, $4df547b39bed1276$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($4df547b39bed1276$var$name, $4df547b39bed1276$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($4df547b39bed1276$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$4df547b39bed1276$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $4df547b39bed1276$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$4df547b39bed1276$var$registerAnalytics();




const $c29a9b87accbd89a$var$firebaseConfig = {
    apiKey: "AIzaSyCS_4OshPphmdHKyMMGb7l4J3wWVznJZ7Q",
    authDomain: "my-collection-314721.firebaseapp.com",
    projectId: "my-collection-314721",
    storageBucket: "my-collection-314721.appspot.com",
    messagingSenderId: "264809982498",
    appId: "1:264809982498:web:ec899c27db6def3ec6787b",
    measurementId: "G-VDGZQSF70T"
};
class $c29a9b87accbd89a$export$447fa9cb0c946c58 {
    static #_ = this.shared = new $c29a9b87accbd89a$export$447fa9cb0c946c58("serviceWorker" in navigator);
    // Initialize Firebase
    constructor(isSupported){
        if (!isSupported) return;
        this.app = (0, $c682bcd2a19f8af3$export$c55cfd413944906d)($c29a9b87accbd89a$var$firebaseConfig);
        this.messaging = (0, $5f3bee57d2d66924$export$f74c3c76482a8451)(this.app);
    }
    requestPermission() {
        Notification.requestPermission().then();
    }
    getFCMToken(callback) {
        if (!this.messaging) return;
        (0, $5f3bee57d2d66924$export$257b2d10b709d8ef)(this.messaging, {
            vapidKey: "BOwRBk54tu5pClZVry-rcQjIpIAF8IPbMk4GyLKBUvhus_3ycmPVqy-6a1Uhv9Eq-mfzmlSWMxZy-__vqDgocj0"
        }).then(callback).catch((error)=>{
            if (error.code !== "messaging/permission-blocked") callback(undefined);
        });
    }
    logFirebaseEvent(eventName, eventParams) {
        try {
            const analytics = (0, $4df547b39bed1276$export$b0297573c90085aa)();
            if (!analytics) return;
            (0, $4df547b39bed1276$export$5e9eec8001665ac5)(analytics, eventName, eventParams);
        } catch  {
            console.log("Analytics throws");
        }
    }
}






const $509749b5346a2b9f$export$506615b74913b200 = ({ open: open, setOpen: setOpen, callback: callback, onClose: onClose, title: title, subtitle: subtitle, description: description, behavior: behavior })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { signup: signup } = (0, $284e3996d2c13603$export$da8941e4c91255e0)();
    const { recoverPassword: recoverPassword } = (0, $2b839f0c0fee3dd9$export$75783458d9cb311b)();
    const checkEmail = (0, $ae1d7eb186718c87$export$af575fbbe23696a0)();
    const checkPassword = (0, $f1a2075848500a5a$export$7df20d9398f482b8)();
    const [isEmailUsed, setIsEmailUsed] = (0, $7fPBF.useState)(false);
    const [isPasswordWeak, setIsPasswordWeak] = (0, $7fPBF.useState)(false);
    const [acceptedTerms, setAcceptedTerms] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const handleClose = ()=>{
        if (isLoading) return;
        if (onClose) onClose();
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        email: $57e52f3b537dfd4b$export$22b082955e083ec3().email((0, $37bec70ed65ed924$export$21c51bc433c16634).email_invalid).required((0, $37bec70ed65ed924$export$21c51bc433c16634).email_invalid).test("isUsed", (0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_duplicated, ()=>!isEmailUsed),
        password: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_missing).test("isPasswordWeak", (0, $37bec70ed65ed924$export$21c51bc433c16634).password_weak, ()=>!isPasswordWeak),
        repeatPassword: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_repeat_missing).oneOf([
            $57e52f3b537dfd4b$export$eff4d24c3ff7876e("password"),
            ""
        ], (0, $37bec70ed65ed924$export$21c51bc433c16634).password_mismatch)
    });
    const initialValues = {
        email: "",
        password: "",
        repeatPassword: ""
    };
    const performSignup = async (email, password)=>{
        setIsLoading(true);
        const { body: body, status: status } = await signup({
            email: email,
            password: password
        });
        setIsLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("new_user_manual");
            if (callback != undefined) callback(email, password);
            handleClose();
        } else {
            if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).BAD_REQUEST) {
                if (body.field == "email") setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_invalid);
                else setAlertMessage(body.message);
            } else if (status == 520) setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_duplicated);
            else setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const performRecoverPassword = async (email, password)=>{
        setIsLoading(true);
        const { body: body, status: status } = await recoverPassword({
            email: email
        });
        setIsLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("reset_password");
            if (callback != undefined) callback(email, password);
            handleClose();
        } else {
            if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).NOT_FOUND) setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).recover_password_email_not_found);
            else setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: initialValues,
        onSubmit: async ({ email: email, password: password })=>{
            if (!acceptedTerms) return;
            if (behavior == "signup") await performSignup(email, password);
            else await performRecoverPassword(email, password);
        },
        validationSchema: validationSchema
    });
    const expiryTimestamp = ()=>{
        const date = new Date();
        date.setSeconds(date.getSeconds() + 1);
        return date;
    };
    const { pause: stopEmailTimer, restart: restartEmailTimer } = (0, $0fb6069f42f36b16$exports.useTimer)({
        expiryTimestamp: expiryTimestamp(),
        onExpire: ()=>{
            // Check duplicated email only on sign up
            if (behavior == "signup") checkEmail(formik.values.email).then((isEmailUsed)=>{
                setIsEmailUsed(isEmailUsed);
            });
        }
    });
    const { pause: stopPasswordTimer, restart: restartPasswordTimer } = (0, $0fb6069f42f36b16$exports.useTimer)({
        expiryTimestamp: expiryTimestamp(),
        onExpire: ()=>{
            checkPassword(formik.values.password).then((result)=>{
                setIsPasswordWeak([
                    0,
                    1
                ].includes(result?.id ?? -1));
            });
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        stopEmailTimer();
        stopPasswordTimer();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        setIsEmailUsed(false);
        if (formik.values.email.length < 5 || formik.errors.email != undefined) {
            stopEmailTimer();
            return;
        }
        restartEmailTimer(expiryTimestamp());
    }, [
        formik.values.email
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setIsPasswordWeak(false);
        if (formik.values.password == "" || formik.errors.password != undefined) {
            stopPasswordTimer();
            return;
        }
        restartPasswordTimer(expiryTimestamp());
    }, [
        formik.values.password
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setAcceptedTerms(false);
        formik.resetForm();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${behavior == "signup" ? (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.signUp() : (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.recoverPassword()}`,
                                target: "_blank",
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: handleClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f3feab8f7f410714$exports))).subtitle,
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f3feab8f7f410714$exports))).description,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: description
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 2,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f3feab8f7f410714$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_email,
                                    value: formik.values.email,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f3feab8f7f410714$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_password,
                                    value: formik.values.password,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f3feab8f7f410714$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "repeatPassword",
                                    name: "repeatPassword",
                                    type: "password",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_repeat_password_placeholder,
                                    value: formik.values.repeatPassword,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "auto"
                                },
                                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                    checked: acceptedTerms,
                                    onChange: ()=>{
                                        setAcceptedTerms((state)=>!state);
                                    }
                                }),
                                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3307a4fe3100649$export$bc4cade09cb8859c), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};






var $7fPBF = parcelRequire("7fPBF");
var $85dbfe6c7a494f29$exports = {};

$parcel$export($85dbfe6c7a494f29$exports, "cancelButton", function () { return $85dbfe6c7a494f29$export$4ededb8e5b56a6fb; }, function (v) { return $85dbfe6c7a494f29$export$4ededb8e5b56a6fb = v; });
$parcel$export($85dbfe6c7a494f29$exports, "countdown", function () { return $85dbfe6c7a494f29$export$f52e29715bba3529; }, function (v) { return $85dbfe6c7a494f29$export$f52e29715bba3529 = v; });
$parcel$export($85dbfe6c7a494f29$exports, "loadingDiv", function () { return $85dbfe6c7a494f29$export$dded2af20345efaa; }, function (v) { return $85dbfe6c7a494f29$export$dded2af20345efaa = v; });
$parcel$export($85dbfe6c7a494f29$exports, "resendButton", function () { return $85dbfe6c7a494f29$export$a41c5ce9b6b66bf2; }, function (v) { return $85dbfe6c7a494f29$export$a41c5ce9b6b66bf2 = v; });
$parcel$export($85dbfe6c7a494f29$exports, "subtitle", function () { return $85dbfe6c7a494f29$export$c96745152eb2740f; }, function (v) { return $85dbfe6c7a494f29$export$c96745152eb2740f = v; });
var $85dbfe6c7a494f29$export$4ededb8e5b56a6fb;
var $85dbfe6c7a494f29$export$f52e29715bba3529;
var $85dbfe6c7a494f29$export$dded2af20345efaa;
var $85dbfe6c7a494f29$export$a41c5ce9b6b66bf2;
var $85dbfe6c7a494f29$export$c96745152eb2740f;
$85dbfe6c7a494f29$export$4ededb8e5b56a6fb = `MM5Mua_cancelButton`;
$85dbfe6c7a494f29$export$f52e29715bba3529 = `MM5Mua_countdown`;
$85dbfe6c7a494f29$export$dded2af20345efaa = `MM5Mua_loadingDiv`;
$85dbfe6c7a494f29$export$a41c5ce9b6b66bf2 = `MM5Mua_resendButton`;
$85dbfe6c7a494f29$export$c96745152eb2740f = `MM5Mua_subtitle`;




var $1ZNeQ = parcelRequire("1ZNeQ");




const $8f6f7f643c1442e1$export$e46d478b8fcca92e = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const verifyEmailCode = (parameters)=>post("emailVerificationCode", parameters);
    return {
        verifyEmailCode: verifyEmailCode
    };
};



const $fc12db331f8440fa$export$c901c290dc3e9a3e = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const resendVerificationCode = (parameters)=>put("emailVerificationCode", parameters);
    return {
        resendVerificationCode: resendVerificationCode
    };
};









const $08c92dc36ffbc237$export$beb39e5a218dbbf2 = ({ email: email, password: password, open: open, setOpen: setOpen, callback: callback, onClose: onClose })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [, setCurrentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { verifyEmailCode: verifyEmailCode } = (0, $8f6f7f643c1442e1$export$e46d478b8fcca92e)();
    const { resendVerificationCode: resendVerificationCode } = (0, $fc12db331f8440fa$export$c901c290dc3e9a3e)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [countdown, setCountdown] = (0, $7fPBF.useState)(0);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const handleClose = ()=>{
        if (isLoading) return;
        if (onClose) onClose();
        setOpen(false);
    };
    const initialValues = {
        code: ""
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: initialValues,
        validateOnBlur: false,
        onSubmit: async ({ code: code })=>{
            setIsLoading(true);
            const { body: body, status: status } = await verifyEmailCode({
                email: email,
                password: password,
                code: code.toUpperCase()
            });
            setIsLoading(false);
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                if (callback != undefined) callback();
                setCurrentUser(body);
                handleClose();
            } else if (status == 510) {
                setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).vec_invalid_code);
                setIsAlertOpen(true);
            } else {
                setAlertMessage(body.message);
                setIsAlertOpen(true);
            }
        }
    });
    const onResendVerificationCode = async ()=>{
        setIsLoading(true);
        const { body: body, status: status } = await resendVerificationCode({
            email: email
        });
        if (status == 511) {
            // Leeway time not yet elapsed
            const { body: errorBody } = body;
            const { timeElapsed: timeElapsed, leeway: leeway } = errorBody;
            setCountdown(leeway - timeElapsed);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (countdown <= 0) return;
        const interval = setInterval(()=>{
            setCountdown(countdown - 1);
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        countdown
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                maxWidth: "sm",
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).vec_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: handleClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($85dbfe6c7a494f29$exports))).subtitle,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).vec_subtitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                spacing: 2,
                                direction: "row",
                                sx: {
                                    alignItems: "center",
                                    marginBottom: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                        id: "code",
                                        name: "code",
                                        size: "small",
                                        placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).vec_code_placeholder,
                                        value: formik.values.code.toUpperCase(),
                                        onChange: formik.handleChange
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).vec_resend_code,
                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Refresh,
                                        disabled: isLoading || countdown > 0,
                                        onClick: onResendVerificationCode
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($85dbfe6c7a494f29$exports))).countdown,
                                hidden: countdown <= 0,
                                children: (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(countdown)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");
'use client';
function $50d7f780bd888ae8$var$useLoadGsiScript(options = {}) {
    const { nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, $7fPBF.useState)(false);
    const onScriptLoadSuccessRef = (0, $7fPBF.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, $7fPBF.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, $7fPBF.useEffect)(()=>{
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = ()=>{
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 || _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = ()=>{
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 || _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return ()=>{
            document.body.removeChild(scriptTag);
        };
    }, [
        nonce
    ]);
    return scriptLoadedSuccessfully;
}
const $50d7f780bd888ae8$var$GoogleOAuthContext = (0, $7fPBF.createContext)(null);
function $50d7f780bd888ae8$export$a325976a38f291f5({ clientId: clientId, nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError, children: children }) {
    const scriptLoadedSuccessfully = $50d7f780bd888ae8$var$useLoadGsiScript({
        nonce: nonce,
        onScriptLoadSuccess: onScriptLoadSuccess,
        onScriptLoadError: onScriptLoadError
    });
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            clientId: clientId,
            scriptLoadedSuccessfully: scriptLoadedSuccessfully
        }), [
        clientId,
        scriptLoadedSuccessfully
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($50d7f780bd888ae8$var$GoogleOAuthContext.Provider, {
        value: contextValue
    }, children);
}
function $50d7f780bd888ae8$export$795f6ef1d297dd73() {
    const context = (0, $7fPBF.useContext)($50d7f780bd888ae8$var$GoogleOAuthContext);
    if (!context) throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    return context;
}
function $50d7f780bd888ae8$var$extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}
const $50d7f780bd888ae8$var$containerHeightMap = {
    large: 40,
    medium: 32,
    small: 20
};
function $50d7f780bd888ae8$export$a795a627e512102a({ onSuccess: onSuccess, onError: onError, useOneTap: useOneTap, promptMomentNotification: promptMomentNotification, type: type = 'standard', theme: theme = 'outline', size: size = 'large', text: text, shape: shape, logo_alignment: logo_alignment, width: width, locale: locale, click_listener: click_listener, containerProps: containerProps, ...props }) {
    const btnContainerRef = (0, $7fPBF.useRef)(null);
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $50d7f780bd888ae8$export$795f6ef1d297dd73();
    const onSuccessRef = (0, $7fPBF.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $7fPBF.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $7fPBF.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $7fPBF.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $50d7f780bd888ae8$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            ...props
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.renderButton(btnContainerRef.current, {
            type: type,
            theme: theme,
            size: size,
            text: text,
            shape: shape,
            logo_alignment: logo_alignment,
            width: width,
            locale: locale,
            click_listener: click_listener
        });
        if (useOneTap) (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            if (useOneTap) (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ...containerProps,
        ref: btnContainerRef,
        style: {
            height: $50d7f780bd888ae8$var$containerHeightMap[size],
            ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style
        }
    });
}
function $50d7f780bd888ae8$export$64c51800d55c1202() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.disableAutoSelect();
}
/* eslint-disable import/export */ function $50d7f780bd888ae8$export$6ca4c5d94f9e170b({ flow: flow = 'implicit', scope: scope = '', onSuccess: onSuccess, onError: onError, onNonOAuthError: onNonOAuthError, overrideScope: overrideScope, state: state, ...props }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $50d7f780bd888ae8$export$795f6ef1d297dd73();
    const clientRef = (0, $7fPBF.useRef)();
    const onSuccessRef = (0, $7fPBF.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $7fPBF.useRef)(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = (0, $7fPBF.useRef)(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    (0, $7fPBF.useEffect)(()=>{
        var _a, _b;
        if (!scriptLoadedSuccessfully) return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response)=>{
                var _a, _b;
                if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 || _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError)=>{
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 || _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state: state,
            ...props
        });
        clientRef.current = client;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        flow,
        scope,
        state
    ]);
    const loginImplicitFlow = (0, $7fPBF.useCallback)((overrideConfig)=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
    }, []);
    const loginAuthCodeFlow = (0, $7fPBF.useCallback)(()=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
    }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}
function $50d7f780bd888ae8$export$7ab2d3f76b55c251({ onSuccess: onSuccess, onError: onError, promptMomentNotification: promptMomentNotification, cancel_on_tap_outside: cancel_on_tap_outside, prompt_parent_id: prompt_parent_id, state_cookie_domain: state_cookie_domain, hosted_domain: hosted_domain, use_fedcm_for_prompt: use_fedcm_for_prompt = false, disabled: disabled, auto_select: auto_select }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $50d7f780bd888ae8$export$795f6ef1d297dd73();
    const onSuccessRef = (0, $7fPBF.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $7fPBF.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $7fPBF.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $7fPBF.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $50d7f780bd888ae8$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            hosted_domain: hosted_domain,
            cancel_on_tap_outside: cancel_on_tap_outside,
            prompt_parent_id: prompt_parent_id,
            state_cookie_domain: state_cookie_domain,
            use_fedcm_for_prompt: use_fedcm_for_prompt,
            auto_select: auto_select
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        use_fedcm_for_prompt,
        disabled,
        auto_select
    ]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */ function $50d7f780bd888ae8$export$dfe7cd07eac17bc5(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false;
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */ function $50d7f780bd888ae8$export$3413c85423c3f1d0(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false;
}



const $222dd01b487cbb78$export$3706f89f26f007e0 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const signInWithGoogleCode = (parameters)=>post("login/googleCode", parameters);
    return {
        signInWithGoogleCode: signInWithGoogleCode
    };
};
const $222dd01b487cbb78$export$e9b4fd1bd6672627 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const signUpWithGoogle = (parameters)=>post("signup/google", parameters);
    return {
        signUpWithGoogle: signUpWithGoogle
    };
};


var $ec025fc1fb34f187$exports = {};
"use strict";
Object.defineProperty($ec025fc1fb34f187$exports, "__esModule", {
    value: true
});
Object.defineProperty($ec025fc1fb34f187$exports, "appleAuthHelpers", {
    enumerable: true,
    get: function get() {
        return $ec025fc1fb34f187$var$_appleAuthHelpers.default;
    }
});
Object.defineProperty($ec025fc1fb34f187$exports, "useScript", {
    enumerable: true,
    get: function get() {
        return $ec025fc1fb34f187$var$_useScript.default;
    }
});
$ec025fc1fb34f187$exports.default = void 0;

var $ec025fc1fb34f187$var$_AppleSigninButton = $ec025fc1fb34f187$var$_interopRequireDefault((parcelRequire("4hOUK")));

var $ec025fc1fb34f187$var$_appleAuthHelpers = $ec025fc1fb34f187$var$_interopRequireDefault((parcelRequire("bAzs1")));

var $ec025fc1fb34f187$var$_useScript = $ec025fc1fb34f187$var$_interopRequireDefault((parcelRequire("4fzdz")));
function $ec025fc1fb34f187$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ec025fc1fb34f187$var$_default = $ec025fc1fb34f187$var$_AppleSigninButton.default;
$ec025fc1fb34f187$exports.default = $ec025fc1fb34f187$var$_default;



const $50831523e9b47ede$export$ba3a2726430ca62 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const signInWithApple = (parameters)=>post("login/apple", parameters);
    return {
        signInWithApple: signInWithApple
    };
};
const $50831523e9b47ede$export$6669cc635e2ca506 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const signUpWithApple = (parameters)=>post("signup/apple", parameters);
    return {
        signUpWithApple: signUpWithApple
    };
};









parcelRequire("7fPBF");
var $6d3dcdab61a1840d$exports = {};

$parcel$export($6d3dcdab61a1840d$exports, "buttonOAuth", function () { return $6d3dcdab61a1840d$export$7225f857e32a3586; }, function (v) { return $6d3dcdab61a1840d$export$7225f857e32a3586 = v; });
$parcel$export($6d3dcdab61a1840d$exports, "iconOAuth", function () { return $6d3dcdab61a1840d$export$90e8aebe0e5e84c7; }, function (v) { return $6d3dcdab61a1840d$export$90e8aebe0e5e84c7 = v; });
$parcel$export($6d3dcdab61a1840d$exports, "imageContainer", function () { return $6d3dcdab61a1840d$export$63e82393dc8977bf; }, function (v) { return $6d3dcdab61a1840d$export$63e82393dc8977bf = v; });
$parcel$export($6d3dcdab61a1840d$exports, "textContainer", function () { return $6d3dcdab61a1840d$export$2cedfd664bb3bd01; }, function (v) { return $6d3dcdab61a1840d$export$2cedfd664bb3bd01 = v; });
var $6d3dcdab61a1840d$export$7225f857e32a3586;
var $6d3dcdab61a1840d$export$90e8aebe0e5e84c7;
var $6d3dcdab61a1840d$export$63e82393dc8977bf;
var $6d3dcdab61a1840d$export$2cedfd664bb3bd01;
$6d3dcdab61a1840d$export$7225f857e32a3586 = `T2oP4a_buttonOAuth`;
$6d3dcdab61a1840d$export$90e8aebe0e5e84c7 = `T2oP4a_iconOAuth`;
$6d3dcdab61a1840d$export$63e82393dc8977bf = `T2oP4a_imageContainer`;
$6d3dcdab61a1840d$export$2cedfd664bb3bd01 = `T2oP4a_textContainer`;



const $a47cc4b5ddb49d26$export$27142e2581b43071 = ({ className: className, props: props, iconClassName: iconClassName, imageSrc: imageSrc, buttonText: buttonText, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6d3dcdab61a1840d$exports))).buttonOAuth, className),
        onClick: onClick,
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d3dcdab61a1840d$exports))).imageContainer,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6d3dcdab61a1840d$exports))).iconOAuth, iconClassName),
                    src: imageSrc,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d3dcdab61a1840d$exports))).textContainer,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: buttonText
                    })
                })
            })
        ]
    });
};



var $7fPBF = parcelRequire("7fPBF");
const $e9acbcfc91ab58e9$export$94550b4bf4daa21a = ()=>{
    const [width, setWidth] = (0, $7fPBF.useState)(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    (0, $7fPBF.useEffect)(()=>{
        window.addEventListener("resize", handleWindowSizeChange);
        return ()=>{
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    return width >= 1600;
};







const $c45fe08e0ab13395$export$d98b03b9c3d1292f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("passkeys/registration");
    };
};


/**
 * Convert the given array buffer into a Base64URL-encoded string. Ideal for converting various
 * credential response ArrayBuffers to string for sending back to the server as JSON.
 *
 * Helper method to compliment `base64URLStringToBuffer`
 */ function $e4ad73bd174a95be$export$a2e0e37897ea77dc(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const charCode of bytes)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}


/**
 * Convert from a Base64URL-encoded string to an Array Buffer. Best used when converting a
 * credential ID from a JSON string to an ArrayBuffer, like in allowCredentials or
 * excludeCredentials
 *
 * Helper method to compliment `bufferToBase64URLString`
 */ function $dc6b4bb28152213e$export$5fed9f4baa53df29(base64URLString) {
    // Convert from Base64URL to Base64
    const base64 = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
    /**
     * Pad with '=' until it's a multiple of four
     * (4 - (85 % 4 = 1) = 3) % 4 = 3 padding
     * (4 - (86 % 4 = 2) = 2) % 4 = 2 padding
     * (4 - (87 % 4 = 3) = 1) % 4 = 1 padding
     * (4 - (88 % 4 = 0) = 4) % 4 = 0 padding
     */ const padLength = (4 - base64.length % 4) % 4;
    const padded = base64.padEnd(base64.length + padLength, '=');
    // Convert to a binary string
    const binary = atob(padded);
    // Convert binary string to buffer
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return buffer;
}


/**
 * Determine if the browser is capable of Webauthn
 */ function $4fe7b2c42fb39efb$export$21f8045e1be8a25d() {
    return $4fe7b2c42fb39efb$export$8b1c3c4214204e67.stubThis(globalThis?.PublicKeyCredential !== undefined && typeof globalThis.PublicKeyCredential === 'function');
}
const $4fe7b2c42fb39efb$export$8b1c3c4214204e67 = {
    stubThis: (value)=>value
};



function $efeffacaee4a165b$export$6e9dda8f9869899d(descriptor) {
    const { id: id } = descriptor;
    return {
        ...descriptor,
        id: (0, $dc6b4bb28152213e$export$5fed9f4baa53df29)(id),
        /**
         * `descriptor.transports` is an array of our `AuthenticatorTransportFuture` that includes newer
         * transports that TypeScript's DOM lib is ignorant of. Convince TS that our list of transports
         * are fine to pass to WebAuthn since browsers will recognize the new value.
         */ transports: descriptor.transports
    };
}


/**
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * A "valid domain" is defined here: https://url.spec.whatwg.org/#valid-domain
 *
 * Regex was originally sourced from here, then remixed to add punycode support:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 */ function $826287eafa7c0d06$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || // Support punycode (ACE) or ascii labels and domains
    /^((xn--[a-z0-9-]+|[a-z0-9]+(-[a-z0-9]+)*)\.)+([a-z]{2,}|xn--[a-z0-9-]+)$/i.test(hostname));
}


/**
 * A custom Error used to return a more nuanced error detailing _why_ one of the eight documented
 * errors in the spec was raised after calling `navigator.credentials.create()` or
 * `navigator.credentials.get()`:
 *
 * - `AbortError`
 * - `ConstraintError`
 * - `InvalidStateError`
 * - `NotAllowedError`
 * - `NotSupportedError`
 * - `SecurityError`
 * - `TypeError`
 * - `UnknownError`
 *
 * Error messages were determined through investigation of the spec to determine under which
 * scenarios a given error would be raised.
 */ class $1bc60e53627051fd$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name ?? cause.name;
        this.code = code;
    }
}


function $8a4ff26c1d137596$export$1c18a773f8a28a92({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (publicKey.authenticatorSelection?.requireResidentKey === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && publicKey.authenticatorSelection?.userVerification === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (publicKey.authenticatorSelection?.userVerification === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = globalThis.location.hostname;
        if (!(0, $826287eafa7c0d06$export$59e759560deddc3c)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: `${globalThis.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return error;
}


class $085b9ead1175d44c$var$BaseWebAuthnAbortService {
    constructor(){
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $085b9ead1175d44c$export$442ada5d34ca6e87 = new $085b9ead1175d44c$var$BaseWebAuthnAbortService();


const $2f5c54131c2c8ae2$var$attachments = [
    'cross-platform',
    'platform'
];
function $2f5c54131c2c8ae2$export$a7e79abca43712d0(attachment) {
    if (!attachment) return;
    if ($2f5c54131c2c8ae2$var$attachments.indexOf(attachment) < 0) return;
    return attachment;
}


async function $716c71820a75e679$export$20d6f277a113c2ce(options) {
    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
    if (!options.optionsJSON && options.challenge) {
        console.warn('startRegistration() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.');
        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
        options = {
            optionsJSON: options
        };
    }
    const { optionsJSON: optionsJSON, useAutoRegister: useAutoRegister = false } = options;
    if (!(0, $4fe7b2c42fb39efb$export$21f8045e1be8a25d)()) throw new Error('WebAuthn is not supported in this browser');
    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
    const publicKey = {
        ...optionsJSON,
        challenge: (0, $dc6b4bb28152213e$export$5fed9f4baa53df29)(optionsJSON.challenge),
        user: {
            ...optionsJSON.user,
            id: (0, $dc6b4bb28152213e$export$5fed9f4baa53df29)(optionsJSON.user.id)
        },
        excludeCredentials: optionsJSON.excludeCredentials?.map((0, $efeffacaee4a165b$export$6e9dda8f9869899d))
    };
    // Prepare options for `.create()`
    const createOptions = {};
    /**
     * Try to use conditional create to register a passkey for the user with the password manager
     * the user just used to authenticate with. The user won't be shown any prominent UI by the
     * browser.
     */ if (useAutoRegister) // @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
    createOptions.mediation = 'conditional';
    // Finalize options
    createOptions.publicKey = publicKey;
    // Set up the ability to cancel this request if the user attempts another
    createOptions.signal = (0, $085b9ead1175d44c$export$442ada5d34ca6e87).createNewAbortSignal();
    // Wait for the user to complete attestation
    let credential;
    try {
        credential = await navigator.credentials.create(createOptions);
    } catch (err) {
        throw (0, $8a4ff26c1d137596$export$1c18a773f8a28a92)({
            error: err,
            options: createOptions
        });
    }
    if (!credential) throw new Error('Registration was not completed');
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    // Continue to play it safe with `getTransports()` for now, even when L3 types say it's required
    let transports = undefined;
    if (typeof response.getTransports === 'function') transports = response.getTransports();
    // L3 says this is required, but browser and webview support are still not guaranteed.
    let responsePublicKeyAlgorithm = undefined;
    if (typeof response.getPublicKeyAlgorithm === 'function') try {
        responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
    } catch (error) {
        $716c71820a75e679$var$warnOnBrokenImplementation('getPublicKeyAlgorithm()', error);
    }
    let responsePublicKey = undefined;
    if (typeof response.getPublicKey === 'function') try {
        const _publicKey = response.getPublicKey();
        if (_publicKey !== null) responsePublicKey = (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(_publicKey);
    } catch (error) {
        $716c71820a75e679$var$warnOnBrokenImplementation('getPublicKey()', error);
    }
    // L3 says this is required, but browser and webview support are still not guaranteed.
    let responseAuthenticatorData;
    if (typeof response.getAuthenticatorData === 'function') try {
        responseAuthenticatorData = (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.getAuthenticatorData());
    } catch (error) {
        $716c71820a75e679$var$warnOnBrokenImplementation('getAuthenticatorData()', error);
    }
    return {
        id: id,
        rawId: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(rawId),
        response: {
            attestationObject: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.attestationObject),
            clientDataJSON: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.clientDataJSON),
            transports: transports,
            publicKeyAlgorithm: responsePublicKeyAlgorithm,
            publicKey: responsePublicKey,
            authenticatorData: responseAuthenticatorData
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: (0, $2f5c54131c2c8ae2$export$a7e79abca43712d0)(credential.authenticatorAttachment)
    };
}
/**
 * Visibly warn when we detect an issue related to a passkey provider intercepting WebAuthn API
 * calls
 */ function $716c71820a75e679$var$warnOnBrokenImplementation(methodName, cause) {
    console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${methodName}. You should report this error to them.\n`, cause);
}






function $dd8ca41d694caecb$export$18d4f667a5042852() {
    if (!(0, $4fe7b2c42fb39efb$export$21f8045e1be8a25d)()) return $dd8ca41d694caecb$export$6e4f15da96b8fc8.stubThis(new Promise((resolve)=>resolve(false)));
    /**
     * I don't like the `as unknown` here but there's a `declare var PublicKeyCredential` in
     * TS' DOM lib that's making it difficult for me to just go `as PublicKeyCredentialFuture` as I
     * want. I think I'm fine with this for now since it's _supposed_ to be temporary, until TS types
     * have a chance to catch up.
     */ const globalPublicKeyCredential = globalThis.PublicKeyCredential;
    if (globalPublicKeyCredential?.isConditionalMediationAvailable === undefined) return $dd8ca41d694caecb$export$6e4f15da96b8fc8.stubThis(new Promise((resolve)=>resolve(false)));
    return $dd8ca41d694caecb$export$6e4f15da96b8fc8.stubThis(globalPublicKeyCredential.isConditionalMediationAvailable());
}
const $dd8ca41d694caecb$export$6e4f15da96b8fc8 = {
    stubThis: (value)=>value
};





function $066f7b17289a9f64$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = globalThis.location.hostname;
        if (!(0, $826287eafa7c0d06$export$59e759560deddc3c)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: `${globalThis.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new (0, $1bc60e53627051fd$export$90f0c14a652de832)({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return error;
}




async function $cdb1b21445ff884d$export$c4f13730a14de143(options) {
    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
    if (!options.optionsJSON && options.challenge) {
        console.warn('startAuthentication() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.');
        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
        options = {
            optionsJSON: options
        };
    }
    const { optionsJSON: optionsJSON, useBrowserAutofill: useBrowserAutofill = false, verifyBrowserAutofillInput: verifyBrowserAutofillInput = true } = options;
    if (!(0, $4fe7b2c42fb39efb$export$21f8045e1be8a25d)()) throw new Error('WebAuthn is not supported in this browser');
    // We need to avoid passing empty array to avoid blocking retrieval
    // of public key
    let allowCredentials;
    if (optionsJSON.allowCredentials?.length !== 0) allowCredentials = optionsJSON.allowCredentials?.map((0, $efeffacaee4a165b$export$6e9dda8f9869899d));
    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
    const publicKey = {
        ...optionsJSON,
        challenge: (0, $dc6b4bb28152213e$export$5fed9f4baa53df29)(optionsJSON.challenge),
        allowCredentials: allowCredentials
    };
    // Prepare options for `.get()`
    const getOptions = {};
    /**
     * Set up the page to prompt the user to select a credential for authentication via the browser's
     * input autofill mechanism.
     */ if (useBrowserAutofill) {
        if (!await (0, $dd8ca41d694caecb$export$18d4f667a5042852)()) throw Error('Browser does not support WebAuthn autofill');
        // Check for an <input> with "webauthn" in its `autocomplete` attribute
        const eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
        // WebAuthn autofill requires at least one valid input
        if (eligibleInputs.length < 1 && verifyBrowserAutofillInput) throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
        // `CredentialMediationRequirement` doesn't know about "conditional" yet as of
        // typescript@4.6.3
        getOptions.mediation = 'conditional';
        // Conditional UI requires an empty allow list
        publicKey.allowCredentials = [];
    }
    // Finalize options
    getOptions.publicKey = publicKey;
    // Set up the ability to cancel this request if the user attempts another
    getOptions.signal = (0, $085b9ead1175d44c$export$442ada5d34ca6e87).createNewAbortSignal();
    // Wait for the user to complete assertion
    let credential;
    try {
        credential = await navigator.credentials.get(getOptions);
    } catch (err) {
        throw (0, $066f7b17289a9f64$export$9b62fd498befe529)({
            error: err,
            options: getOptions
        });
    }
    if (!credential) throw new Error('Authentication was not completed');
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    let userHandle = undefined;
    if (response.userHandle) userHandle = (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.userHandle);
    // Convert values to base64 to make it easier to send back to the server
    return {
        id: id,
        rawId: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(rawId),
        response: {
            authenticatorData: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.authenticatorData),
            clientDataJSON: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.clientDataJSON),
            signature: (0, $e4ad73bd174a95be$export$a2e0e37897ea77dc)(response.signature),
            userHandle: userHandle
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: (0, $2f5c54131c2c8ae2$export$a7e79abca43712d0)(credential.authenticatorAttachment)
    };
}




function $5caf429b341fcc2c$export$d2e10ee5223ea44b() {
    if (!(0, $4fe7b2c42fb39efb$export$21f8045e1be8a25d)()) return new Promise((resolve)=>resolve(false));
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}












const $63008bf85cdc8e55$export$4e932e642e243f43 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (attestationObject)=>{
        return await post("passkeys/registration", attestationObject);
    };
};



const $f11e243a11702b0d$export$45bccaf4350859c0 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("passkeys/authentication");
    };
};



const $86f603027ade0622$export$35df2d9fa6d3f6cd = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (challenge, authenticationResponse)=>{
        return await post(`passkeys/authentication`, {
            challenge: challenge,
            authenticationResponse: authenticationResponse
        });
    };
};



const $de36d9deb0a855aa$export$60838eccc434628e = ()=>{
    const getPasskeyRegistrationOptions = (0, $c45fe08e0ab13395$export$d98b03b9c3d1292f)();
    const getPasskeyAuthenticationOptions = (0, $f11e243a11702b0d$export$45bccaf4350859c0)();
    const verifyRegistration = (0, $63008bf85cdc8e55$export$4e932e642e243f43)();
    const verifyAuthentication = (0, $86f603027ade0622$export$35df2d9fa6d3f6cd)();
    const registerPasskey = async (onSuccess, onError)=>{
        const { status: status, body: body } = await getPasskeyRegistrationOptions();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) try {
            const credentialResponse = await (0, $716c71820a75e679$export$20d6f277a113c2ce)({
                optionsJSON: body
            });
            await performRegistration(credentialResponse, onSuccess, onError);
        } catch (error) {
            if (error.name && [
                "NotAllowedError",
                "AbortError"
            ].includes(error.name)) // Ignore, since user canceled the request
            return;
            onError((0, $37bec70ed65ed924$export$21c51bc433c16634).passkey_registration_error);
        }
        else onError(body.message);
    };
    const performRegistration = async (credentialResponse, onSuccess, onError)=>{
        const { status: status, body: body } = await verifyRegistration(credentialResponse);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) onSuccess();
        else onError(body.message);
    };
    const authenticatePasskey = async (setLoading, onError, callback, useBrowserAutofill)=>{
        const { status: status, body: body } = await getPasskeyAuthenticationOptions();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) try {
            const authenticationResponse = await (0, $cdb1b21445ff884d$export$c4f13730a14de143)({
                optionsJSON: body,
                useBrowserAutofill: useBrowserAutofill
            });
            await performAuthentication(body.challenge, authenticationResponse, setLoading, onError, callback);
        } catch (error) {
            if (error.name && [
                "NotAllowedError",
                "AbortError"
            ].includes(error.name)) // Ignore, since user canceled the request
            return;
            onError((0, $37bec70ed65ed924$export$21c51bc433c16634).passkey_authentication_error);
        }
    };
    const performAuthentication = async (challenge, authenticationResponse, setLoading, onError, callback)=>{
        setLoading(true);
        const { status: status, body: body } = await verifyAuthentication(challenge, authenticationResponse);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) callback(body);
        else onError(body.message);
        setLoading(false);
    };
    return {
        registerPasskey: registerPasskey,
        authenticatePasskey: authenticatePasskey
    };
};



const $69290e1c184f1467$export$21a94553ffa41578 = ({ isMinimalist: isMinimalist, loginCallback: loginCallback })=>{
    (0, $7fPBF.useEffect)(()=>{
        if (isMinimalist) return;
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).login_submit}`;
    }, []);
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { login: login } = (0, $543c1a3d82f8abfe$export$d4e22f05f73ea56b)();
    const { setToken: setToken } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const { signInWithGoogleCode: signInWithGoogleCode } = (0, $222dd01b487cbb78$export$3706f89f26f007e0)();
    const { signInWithApple: signInWithApple } = (0, $50831523e9b47ede$export$ba3a2726430ca62)();
    const { signUpWithGoogle: signUpWithGoogle } = (0, $222dd01b487cbb78$export$e9b4fd1bd6672627)();
    const { signUpWithApple: signUpWithApple } = (0, $50831523e9b47ede$export$6669cc635e2ca506)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(false);
    const [isShowingGuestCard, setIsShowingGuestCard] = (0, $7fPBF.useState)(false);
    const [isSignupDialogOpen, setIsSignupDialogOpen] = (0, $7fPBF.useState)(false);
    const [isRecoverPasswordDialogOpen, setIsRecoverPasswordDialogOpen] = (0, $7fPBF.useState)(false);
    const [isGoogleAcceptanceAlertOpen, setIsGoogleAcceptanceAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAppleAcceptanceAlertOpen, setIsAppleAcceptanceAlertOpen] = (0, $7fPBF.useState)(false);
    const [oAuthToken, setOAuthToken] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertTitle, setAlertTitle] = (0, $7fPBF.useState)(undefined);
    const [isVerifyEmailCodeDialogOpen, setIsVerifyEmailCodeDialogOpen] = (0, $7fPBF.useState)(false);
    const [isVerifyRecoverPasswordCodeDialogOpen, setIsVerifyRecoverPasswordCodeDialogOpen] = (0, $7fPBF.useState)(false);
    const [enteredEmail, setEnteredEmail] = (0, $7fPBF.useState)("");
    const [newPassword, setNewPassword] = (0, $7fPBF.useState)("");
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    const { authenticatePasskey: authenticatePasskey } = (0, $de36d9deb0a855aa$export$60838eccc434628e)();
    (0, $7fPBF.useEffect)(()=>{
        authenticatePasskey(setLoading, showError, processLogin, true).then();
    }, []);
    const loginWithGoogle = (0, $50d7f780bd888ae8$export$6ca4c5d94f9e170b)({
        flow: "auth-code",
        onSuccess: async (codeResponse)=>{
            const { code: code } = codeResponse;
            if (!code || code.length == 0) {
                showError();
                return;
            }
            setLoading(true);
            const { status: status, body: body } = await signInWithGoogleCode({
                code: code,
                validateEmail: currentUser?.email
            });
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await processLogin(body);
            else if (status == 515) {
                // Should register new user
                setOAuthToken(body.token);
                setIsGoogleAcceptanceAlertOpen(true);
            } else {
                showError(body.message);
                setLoading(false);
            }
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        new Promise((r)=>setTimeout(r, 2000)).then(()=>setIsShowingGuestCard(true));
        new Promise((r)=>setTimeout(r, 12000)).then(()=>setIsShowingGuestCard(false));
        // If the URL is from a share link, login as guest automatically
        if ((0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search).link || location.pathname.includes("guest")) performLogin("guest", "guest").then();
    }, []);
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        email: $57e52f3b537dfd4b$export$22b082955e083ec3().required(" "),
        password: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_missing)
    });
    const processLogin = async (token)=>{
        setToken(token);
        if (loginCallback) loginCallback();
        else if (window.location.pathname == (0, $5ac8335867650de3$export$12d836cf94aabb97).signIn()) navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
        else window.location.reload();
    };
    const performLogin = async (email, password)=>{
        if (email == "" || password == "") return;
        setLoading(true);
        const { body: body, status: status } = await login({
            email: email,
            password: password
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await processLogin(body);
        else if ([
            (0, $74d09775b34cce5b$export$efd5569f873811b1).UNAUTHORIZED,
            (0, $74d09775b34cce5b$export$efd5569f873811b1).NOT_FOUND
        ].includes(status)) showError((0, $37bec70ed65ed924$export$21c51bc433c16634).login_wrong_credentials);
        else if (status == 510) {
            setEnteredEmail(email);
            setIsVerifyEmailCodeDialogOpen(true);
        } else showError(body.message);
        setLoading(false);
    };
    const showSignupDialog = ()=>{
        setIsSignupDialogOpen(true);
    };
    const showRecoverPasswordDialog = ()=>{
        setIsRecoverPasswordDialogOpen(true);
    };
    const showError = (message)=>{
        setAlertTitle(undefined);
        setAlertMessage(message ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).login_unknown_error);
        setIsAlertOpen(true);
    };
    const registerUserWithGoogle = async (token)=>{
        const { status: status, body: body } = await signUpWithGoogle({
            token: token
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            await processLogin(body);
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("new_user_google");
        } else {
            showError();
            setLoading(false);
        }
    };
    const registerUserWithApple = async (token)=>{
        const { status: status, body: body } = await signUpWithApple({
            token: token
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            await processLogin(body);
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("new_user_apple");
        } else {
            showError();
            setLoading(false);
        }
    };
    const appleResponse = async (response)=>{
        setLoading(true);
        const { status: status, body: body } = await signInWithApple({
            token: response.authorization.id_token,
            validateEmail: currentUser?.email
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await processLogin(body);
        else if (status == 515) {
            // Should register new user
            setOAuthToken(response.authorization.id_token);
            setIsAppleAcceptanceAlertOpen(true);
        } else {
            showError(body.message);
            setLoading(false);
        }
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            email: isMinimalist ? currentUser?.email ?? "" : "",
            password: ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ()=>{
            return;
        },
        validationSchema: validationSchema
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
            className: isMinimalist ? (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).loginContainer, (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).loginContainerMinimalist) : (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).loginContainer,
            showingPersistentDrawer: isScreenWide && isDrawerOpen && !isMinimalist,
            children: [
                isMinimalist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%"
                    }
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        (!isDrawerOpen || !isScreenWide) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).drawerButton,
                            sx: {
                                color: "white"
                            },
                            style: {
                                textTransform: "none"
                            },
                            size: "large",
                            startIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Menu
                            }),
                            onClick: ()=>setIsDrawerOpen(true),
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).options
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: isShowingGuestCard ? (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).guestCardShown : (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).guestCardHidden,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).guestCard,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).guestArrow,
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ArrowLeftAlt
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h5", {
                                        style: {
                                            marginRight: 16
                                        },
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_guest_info
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6816ad538b5b25d4$export$31c1e889f27fdf83), {
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            onClickLoginAsGuest: async ()=>{
                                await performLogin("guest", "guest");
                            },
                            onClickCreateNewUser: showSignupDialog,
                            onClickRecoverPassword: showRecoverPasswordDialog,
                            onClickExplore: async ()=>{
                                loginCallback = ()=>{
                                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).marketplace());
                                };
                                await performLogin("guest", "guest");
                            },
                            onClickPasskey: ()=>authenticatePasskey(setLoading, showError, processLogin, false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                    style: {
                        height: 80,
                        width: 180,
                        alignSelf: "center"
                    },
                    onClick: ()=>{
                        setIsDrawerOpen(true);
                    },
                    disableRipple: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).logoImage,
                        style: {
                            maxWidth: "100%",
                            maxHeight: "100%"
                        },
                        src: piperTextImage,
                        alt: "Piper"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).form,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                            style: {
                                color: "white"
                            },
                            children: isMinimalist ? (0, $37bec70ed65ed924$export$21c51bc433c16634).login_again : (0, $37bec70ed65ed924$export$21c51bc433c16634).login_title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).subtitle,
                            children: isMinimalist ? (0, $37bec70ed65ed924$export$21c51bc433c16634).login_again_subtitle : (0, $37bec70ed65ed924$export$21c51bc433c16634).login_subtitle
                        }),
                        !isMinimalist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).newUserButton,
                            type: "button",
                            onClick: showSignupDialog,
                            disabled: loading,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_new_user_button
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).emailField,
                            style: {
                                width: 300
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                inputstyles: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).emailInput,
                                id: "email",
                                name: "email",
                                type: "email",
                                size: "small",
                                autocomplete: "username webauthn",
                                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_email,
                                onChange: formik.handleChange,
                                value: formik.values.email,
                                disabled: isMinimalist || loading,
                                forceWhite: true
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            style: {
                                width: 300
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                inputstyles: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).passwordInput,
                                id: "password",
                                name: "password",
                                type: "password",
                                size: "small",
                                autocomplete: "current-password",
                                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_password,
                                onChange: formik.handleChange,
                                value: formik.values.password,
                                disabled: loading,
                                forceWhite: true
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).submitButtonContainer,
                            children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: async (event)=>{
                                    event.preventDefault();
                                    await formik.validateForm();
                                    const email = formik.values.email;
                                    const password = formik.values.password;
                                    await performLogin(email, password);
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_submit
                            })
                        }),
                        !isMinimalist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).newUserButton,
                            style: {
                                marginBottom: 12
                            },
                            type: "button",
                            onClick: showRecoverPasswordDialog,
                            disabled: loading,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_forgot_password
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/GoogleGLogo.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).signin_with_google,
                            onClick: loginWithGoogle,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).googleButton
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ec025fc1fb34f187$exports))), {
                            authOptions: {
                                clientId: "com.ldelosheros.mycollection.service" ?? "",
                                scope: "email",
                                redirectURI: window.location.href,
                                usePopup: true
                            },
                            uiType: "light",
                            noDefaultStyle: false,
                            buttonExtraChildren: (0, $37bec70ed65ed924$export$21c51bc433c16634).signin_with_apple,
                            onSuccess: appleResponse,
                            /** Skips loading the apple script if true */ skipScript: false,
                            render: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                                    props: props,
                                    iconClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).iconApple,
                                    imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/AppleLogo.svg",
                                    buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).signin_with_apple
                                }),
                            onError: ()=>{
                            // Do nothing
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/Passkey.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).signin_with_passkey,
                            onClick: ()=>authenticatePasskey(setLoading, showError, processLogin, false),
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).googleButton
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $509749b5346a2b9f$export$506615b74913b200), {
                            open: isSignupDialogOpen,
                            setOpen: setIsSignupDialogOpen,
                            callback: (email)=>{
                                setAlertTitle((0, $37bec70ed65ed924$export$21c51bc433c16634).signup_success_title);
                                setAlertMessage((0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).signup_success_message, email));
                                setIsAlertOpen(true);
                            },
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_title,
                            subtitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_subtitle,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).signup_description,
                            behavior: "signup"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $509749b5346a2b9f$export$506615b74913b200), {
                            open: isRecoverPasswordDialogOpen,
                            setOpen: setIsRecoverPasswordDialogOpen,
                            callback: (email, password)=>{
                                setEnteredEmail(email);
                                setNewPassword(password);
                                setIsVerifyRecoverPasswordCodeDialogOpen(true);
                            },
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_recover_password,
                            subtitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).recover_password_form_title,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).recover_password_form_subtitle,
                            behavior: "recoverPassword"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08c92dc36ffbc237$export$beb39e5a218dbbf2), {
                            email: enteredEmail,
                            open: isVerifyEmailCodeDialogOpen,
                            setOpen: setIsVerifyEmailCodeDialogOpen,
                            callback: async ()=>{
                                await performLogin(formik.values.email, formik.values.password);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08c92dc36ffbc237$export$beb39e5a218dbbf2), {
                            email: enteredEmail,
                            password: newPassword,
                            open: isVerifyRecoverPasswordCodeDialogOpen,
                            setOpen: setIsVerifyRecoverPasswordCodeDialogOpen,
                            callback: ()=>{
                                setAlertTitle((0, $37bec70ed65ed924$export$21c51bc433c16634).signup_success_title);
                                setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).recover_password_success);
                                setIsAlertOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                            title: alertTitle,
                            message: alertMessage,
                            open: isAlertOpen,
                            setOpen: setIsAlertOpen
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                            message: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3307a4fe3100649$export$bc4cade09cb8859c), {
                                withIntro: true
                            }),
                            open: isGoogleAcceptanceAlertOpen,
                            setOpen: setIsGoogleAcceptanceAlertOpen,
                            isConfirm: true,
                            onConfirm: ()=>registerUserWithGoogle(oAuthToken),
                            onCancel: ()=>setLoading(false)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                            message: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3307a4fe3100649$export$bc4cade09cb8859c), {
                                withIntro: true
                            }),
                            open: isAppleAcceptanceAlertOpen,
                            setOpen: setIsAppleAcceptanceAlertOpen,
                            isConfirm: true,
                            onConfirm: ()=>registerUserWithApple(oAuthToken),
                            onCancel: ()=>setLoading(false)
                        })
                    ]
                }),
                !isMinimalist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).creditsMobile : (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).credits,
                    textClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ee7d17efa71a278b$exports))).creditsText
                })
            ]
        })
    });
};


const $616fd80ec2a913ff$export$dad1da3cda010137 = ({ isMinimalist: isMinimalist, loginCallback: loginCallback })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69290e1c184f1467$export$21a94553ffa41578), {
        isMinimalist: isMinimalist,
        loginCallback: loginCallback
    });
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $41963598944a220e$exports = {};

$parcel$export($41963598944a220e$exports, "albumDetail", function () { return $41963598944a220e$export$c2274dd6506dc2c4; }, function (v) { return $41963598944a220e$export$c2274dd6506dc2c4 = v; });
$parcel$export($41963598944a220e$exports, "albumListContainer", function () { return $41963598944a220e$export$343bfb6a13fbcc80; }, function (v) { return $41963598944a220e$export$343bfb6a13fbcc80 = v; });
$parcel$export($41963598944a220e$exports, "appBar", function () { return $41963598944a220e$export$d0a9b8580e71599c; }, function (v) { return $41963598944a220e$export$d0a9b8580e71599c = v; });
$parcel$export($41963598944a220e$exports, "cancelButton", function () { return $41963598944a220e$export$4ededb8e5b56a6fb; }, function (v) { return $41963598944a220e$export$4ededb8e5b56a6fb = v; });
$parcel$export($41963598944a220e$exports, "collectionTitle", function () { return $41963598944a220e$export$eb877aaaf03a6de7; }, function (v) { return $41963598944a220e$export$eb877aaaf03a6de7 = v; });
$parcel$export($41963598944a220e$exports, "collectionTitleText", function () { return $41963598944a220e$export$3835f5851904f547; }, function (v) { return $41963598944a220e$export$3835f5851904f547 = v; });
$parcel$export($41963598944a220e$exports, "expandIcon", function () { return $41963598944a220e$export$577bdbd696b473b5; }, function (v) { return $41963598944a220e$export$577bdbd696b473b5 = v; });
$parcel$export($41963598944a220e$exports, "loadingIndicator", function () { return $41963598944a220e$export$f10e6b4aaa94c253; }, function (v) { return $41963598944a220e$export$f10e6b4aaa94c253 = v; });
$parcel$export($41963598944a220e$exports, "mainBody", function () { return $41963598944a220e$export$f239b04fc1a0c7e1; }, function (v) { return $41963598944a220e$export$f239b04fc1a0c7e1 = v; });
$parcel$export($41963598944a220e$exports, "mobileCloseButton", function () { return $41963598944a220e$export$bf3694b705f1b48b; }, function (v) { return $41963598944a220e$export$bf3694b705f1b48b = v; });
$parcel$export($41963598944a220e$exports, "piperLogo", function () { return $41963598944a220e$export$8cacecdcbcc49d33; }, function (v) { return $41963598944a220e$export$8cacecdcbcc49d33 = v; });
$parcel$export($41963598944a220e$exports, "resizeHandle", function () { return $41963598944a220e$export$8e36b812ea421d73; }, function (v) { return $41963598944a220e$export$8e36b812ea421d73 = v; });
$parcel$export($41963598944a220e$exports, "searchBar", function () { return $41963598944a220e$export$f2ea4ab276c3e3fa; }, function (v) { return $41963598944a220e$export$f2ea4ab276c3e3fa = v; });
$parcel$export($41963598944a220e$exports, "shareBox", function () { return $41963598944a220e$export$f8375613696bf6bf; }, function (v) { return $41963598944a220e$export$f8375613696bf6bf = v; });
$parcel$export($41963598944a220e$exports, "shareButtonIcon", function () { return $41963598944a220e$export$fc5b830dde428e2e; }, function (v) { return $41963598944a220e$export$fc5b830dde428e2e = v; });
$parcel$export($41963598944a220e$exports, "toolbar", function () { return $41963598944a220e$export$f727f52c778e92d5; }, function (v) { return $41963598944a220e$export$f727f52c778e92d5 = v; });
$parcel$export($41963598944a220e$exports, "toolbarIcon", function () { return $41963598944a220e$export$e23b0c89a201934e; }, function (v) { return $41963598944a220e$export$e23b0c89a201934e = v; });
var $41963598944a220e$export$c2274dd6506dc2c4;
var $41963598944a220e$export$343bfb6a13fbcc80;
var $41963598944a220e$export$d0a9b8580e71599c;
var $41963598944a220e$export$4ededb8e5b56a6fb;
var $41963598944a220e$export$eb877aaaf03a6de7;
var $41963598944a220e$export$3835f5851904f547;
var $41963598944a220e$export$577bdbd696b473b5;
var $41963598944a220e$export$f10e6b4aaa94c253;
var $41963598944a220e$export$f239b04fc1a0c7e1;
var $41963598944a220e$export$bf3694b705f1b48b;
var $41963598944a220e$export$8cacecdcbcc49d33;
var $41963598944a220e$export$8e36b812ea421d73;
var $41963598944a220e$export$f2ea4ab276c3e3fa;
var $41963598944a220e$export$f8375613696bf6bf;
var $41963598944a220e$export$fc5b830dde428e2e;
var $41963598944a220e$export$f727f52c778e92d5;
var $41963598944a220e$export$e23b0c89a201934e;
$41963598944a220e$export$c2274dd6506dc2c4 = `_9yNNKW_albumDetail`;
$41963598944a220e$export$343bfb6a13fbcc80 = `_9yNNKW_albumListContainer`;
$41963598944a220e$export$d0a9b8580e71599c = `_9yNNKW_appBar`;
$41963598944a220e$export$4ededb8e5b56a6fb = `_9yNNKW_cancelButton`;
$41963598944a220e$export$eb877aaaf03a6de7 = `_9yNNKW_collectionTitle`;
$41963598944a220e$export$3835f5851904f547 = `_9yNNKW_collectionTitleText`;
$41963598944a220e$export$577bdbd696b473b5 = `_9yNNKW_expandIcon`;
$41963598944a220e$export$f10e6b4aaa94c253 = `_9yNNKW_loadingIndicator`;
$41963598944a220e$export$f239b04fc1a0c7e1 = `_9yNNKW_mainBody`;
$41963598944a220e$export$bf3694b705f1b48b = `_9yNNKW_mobileCloseButton`;
$41963598944a220e$export$8cacecdcbcc49d33 = `_9yNNKW_piperLogo`;
$41963598944a220e$export$8e36b812ea421d73 = `_9yNNKW_resizeHandle`;
$41963598944a220e$export$f2ea4ab276c3e3fa = `_9yNNKW_searchBar`;
$41963598944a220e$export$f8375613696bf6bf = `_9yNNKW_shareBox`;
$41963598944a220e$export$fc5b830dde428e2e = `_9yNNKW_shareButtonIcon`;
$41963598944a220e$export$f727f52c778e92d5 = `_9yNNKW_toolbar`;
$41963598944a220e$export$e23b0c89a201934e = `_9yNNKW_toolbarIcon`;






var $7fPBF = parcelRequire("7fPBF");
var $ac3a4be76d66fd9b$exports = {};

$parcel$export($ac3a4be76d66fd9b$exports, "albumItemContainer", function () { return $ac3a4be76d66fd9b$export$4005a991a08b6cf8; }, function (v) { return $ac3a4be76d66fd9b$export$4005a991a08b6cf8 = v; });
$parcel$export($ac3a4be76d66fd9b$exports, "mainDiv", function () { return $ac3a4be76d66fd9b$export$16666caf1c4e1af1; }, function (v) { return $ac3a4be76d66fd9b$export$16666caf1c4e1af1 = v; });
$parcel$export($ac3a4be76d66fd9b$exports, "mainList", function () { return $ac3a4be76d66fd9b$export$21810f025a8548aa; }, function (v) { return $ac3a4be76d66fd9b$export$21810f025a8548aa = v; });
$parcel$export($ac3a4be76d66fd9b$exports, "noSelectionDiv", function () { return $ac3a4be76d66fd9b$export$47d0c9314a8d5020; }, function (v) { return $ac3a4be76d66fd9b$export$47d0c9314a8d5020 = v; });
$parcel$export($ac3a4be76d66fd9b$exports, "shortcutsTitle", function () { return $ac3a4be76d66fd9b$export$a181c7b826173297; }, function (v) { return $ac3a4be76d66fd9b$export$a181c7b826173297 = v; });
var $ac3a4be76d66fd9b$export$4005a991a08b6cf8;
var $ac3a4be76d66fd9b$export$16666caf1c4e1af1;
var $ac3a4be76d66fd9b$export$21810f025a8548aa;
var $ac3a4be76d66fd9b$export$47d0c9314a8d5020;
var $ac3a4be76d66fd9b$export$a181c7b826173297;
$ac3a4be76d66fd9b$export$4005a991a08b6cf8 = `BvMXqq_albumItemContainer`;
$ac3a4be76d66fd9b$export$16666caf1c4e1af1 = `BvMXqq_mainDiv`;
$ac3a4be76d66fd9b$export$21810f025a8548aa = `BvMXqq_mainList`;
$ac3a4be76d66fd9b$export$47d0c9314a8d5020 = `BvMXqq_noSelectionDiv`;
$ac3a4be76d66fd9b$export$a181c7b826173297 = `BvMXqq_shortcutsTitle`;





var $7fPBF = parcelRequire("7fPBF");








function $0842d99f651a305f$export$6816d4fc0981ec7(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListSubheader', slot);
}
const $0842d99f651a305f$var$listSubheaderClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $0842d99f651a305f$export$2e2bcd8739ae039 = $0842d99f651a305f$var$listSubheaderClasses;



'use client';
const $f6a8c189b782c624$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $f6a8c189b782c624$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0842d99f651a305f$export$6816d4fc0981ec7), classes);
};
const $f6a8c189b782c624$var$ListSubheaderRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $f6a8c189b782c624$var$ListSubheader = /*#__PURE__*/ $7fPBF.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f6a8c189b782c624$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $f6a8c189b782c624$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f6a8c189b782c624$var$ListSubheaderRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$f6a8c189b782c624$var$ListSubheader.muiSkipListHighlight = true;
var $f6a8c189b782c624$export$2e2bcd8739ae039 = $f6a8c189b782c624$var$ListSubheader;




var $7fPBF = parcelRequire("7fPBF");
var $af6df54ec5939313$exports = {};

$parcel$export($af6df54ec5939313$exports, "albumImage", function () { return $af6df54ec5939313$export$24acac6e69ce1287; }, function (v) { return $af6df54ec5939313$export$24acac6e69ce1287 = v; });
$parcel$export($af6df54ec5939313$exports, "backgroundCircle", function () { return $af6df54ec5939313$export$5bb2c6667794e5f8; }, function (v) { return $af6df54ec5939313$export$5bb2c6667794e5f8 = v; });
$parcel$export($af6df54ec5939313$exports, "container", function () { return $af6df54ec5939313$export$34e0f9847d4c02dd; }, function (v) { return $af6df54ec5939313$export$34e0f9847d4c02dd = v; });
$parcel$export($af6df54ec5939313$exports, "gradeText", function () { return $af6df54ec5939313$export$5d5479b86b5470e; }, function (v) { return $af6df54ec5939313$export$5d5479b86b5470e = v; });
$parcel$export($af6df54ec5939313$exports, "highlightTag", function () { return $af6df54ec5939313$export$514478e6351b4af6; }, function (v) { return $af6df54ec5939313$export$514478e6351b4af6 = v; });
$parcel$export($af6df54ec5939313$exports, "highlightText", function () { return $af6df54ec5939313$export$8e93e90112ff7488; }, function (v) { return $af6df54ec5939313$export$8e93e90112ff7488 = v; });
$parcel$export($af6df54ec5939313$exports, "hoverButton", function () { return $af6df54ec5939313$export$b0260c0afbf48c57; }, function (v) { return $af6df54ec5939313$export$b0260c0afbf48c57 = v; });
$parcel$export($af6df54ec5939313$exports, "hoverButtonRadius", function () { return $af6df54ec5939313$export$68d9146667c74d00; }, function (v) { return $af6df54ec5939313$export$68d9146667c74d00 = v; });
$parcel$export($af6df54ec5939313$exports, "hoverButtonsStack", function () { return $af6df54ec5939313$export$a8eacba2c33c9f28; }, function (v) { return $af6df54ec5939313$export$a8eacba2c33c9f28 = v; });
$parcel$export($af6df54ec5939313$exports, "name", function () { return $af6df54ec5939313$export$a8ff84c12d48cfa6; }, function (v) { return $af6df54ec5939313$export$a8ff84c12d48cfa6 = v; });
$parcel$export($af6df54ec5939313$exports, "newPrice", function () { return $af6df54ec5939313$export$bf2b2c68f2d3892d; }, function (v) { return $af6df54ec5939313$export$bf2b2c68f2d3892d = v; });
$parcel$export($af6df54ec5939313$exports, "oldPrice", function () { return $af6df54ec5939313$export$9853811e0e64ec55; }, function (v) { return $af6df54ec5939313$export$9853811e0e64ec55 = v; });
$parcel$export($af6df54ec5939313$exports, "orderWarning", function () { return $af6df54ec5939313$export$826b3606ca0a14b; }, function (v) { return $af6df54ec5939313$export$826b3606ca0a14b = v; });
$parcel$export($af6df54ec5939313$exports, "reservedBox", function () { return $af6df54ec5939313$export$da357abc86b0c05e; }, function (v) { return $af6df54ec5939313$export$da357abc86b0c05e = v; });
$parcel$export($af6df54ec5939313$exports, "reservedText", function () { return $af6df54ec5939313$export$c94b5db9c187c61a; }, function (v) { return $af6df54ec5939313$export$c94b5db9c187c61a = v; });
$parcel$export($af6df54ec5939313$exports, "rightContainer", function () { return $af6df54ec5939313$export$3280a108d7f81d56; }, function (v) { return $af6df54ec5939313$export$3280a108d7f81d56 = v; });
$parcel$export($af6df54ec5939313$exports, "subtitle", function () { return $af6df54ec5939313$export$c96745152eb2740f; }, function (v) { return $af6df54ec5939313$export$c96745152eb2740f = v; });
$parcel$export($af6df54ec5939313$exports, "upcomingBox", function () { return $af6df54ec5939313$export$f0f4addd87dfefa7; }, function (v) { return $af6df54ec5939313$export$f0f4addd87dfefa7 = v; });
$parcel$export($af6df54ec5939313$exports, "upcomingPerimeter", function () { return $af6df54ec5939313$export$6bed4238f002259f; }, function (v) { return $af6df54ec5939313$export$6bed4238f002259f = v; });
$parcel$export($af6df54ec5939313$exports, "upcomingText", function () { return $af6df54ec5939313$export$b91a3c72dc814419; }, function (v) { return $af6df54ec5939313$export$b91a3c72dc814419 = v; });
var $af6df54ec5939313$export$24acac6e69ce1287;
var $af6df54ec5939313$export$5bb2c6667794e5f8;
var $af6df54ec5939313$export$34e0f9847d4c02dd;
var $af6df54ec5939313$export$5d5479b86b5470e;
var $af6df54ec5939313$export$514478e6351b4af6;
var $af6df54ec5939313$export$8e93e90112ff7488;
var $af6df54ec5939313$export$b0260c0afbf48c57;
var $af6df54ec5939313$export$68d9146667c74d00;
var $af6df54ec5939313$export$a8eacba2c33c9f28;
var $af6df54ec5939313$export$a8ff84c12d48cfa6;
var $af6df54ec5939313$export$bf2b2c68f2d3892d;
var $af6df54ec5939313$export$9853811e0e64ec55;
var $af6df54ec5939313$export$826b3606ca0a14b;
var $af6df54ec5939313$export$da357abc86b0c05e;
var $af6df54ec5939313$export$c94b5db9c187c61a;
var $af6df54ec5939313$export$3280a108d7f81d56;
var $af6df54ec5939313$export$c96745152eb2740f;
var $af6df54ec5939313$export$f0f4addd87dfefa7;
var $af6df54ec5939313$export$6bed4238f002259f;
var $af6df54ec5939313$export$b91a3c72dc814419;
$af6df54ec5939313$export$24acac6e69ce1287 = `CJxJDa_albumImage`;
$af6df54ec5939313$export$5bb2c6667794e5f8 = `CJxJDa_backgroundCircle`;
$af6df54ec5939313$export$34e0f9847d4c02dd = `CJxJDa_container`;
$af6df54ec5939313$export$5d5479b86b5470e = `CJxJDa_gradeText`;
$af6df54ec5939313$export$514478e6351b4af6 = `CJxJDa_highlightTag`;
$af6df54ec5939313$export$8e93e90112ff7488 = `CJxJDa_highlightText`;
$af6df54ec5939313$export$b0260c0afbf48c57 = `CJxJDa_hoverButton`;
$af6df54ec5939313$export$68d9146667c74d00 = `CJxJDa_hoverButtonRadius`;
$af6df54ec5939313$export$a8eacba2c33c9f28 = `CJxJDa_hoverButtonsStack`;
$af6df54ec5939313$export$a8ff84c12d48cfa6 = `CJxJDa_name`;
$af6df54ec5939313$export$bf2b2c68f2d3892d = `CJxJDa_newPrice`;
$af6df54ec5939313$export$9853811e0e64ec55 = `CJxJDa_oldPrice`;
$af6df54ec5939313$export$826b3606ca0a14b = `CJxJDa_orderWarning`;
$af6df54ec5939313$export$da357abc86b0c05e = `CJxJDa_reservedBox`;
$af6df54ec5939313$export$c94b5db9c187c61a = `CJxJDa_reservedText`;
$af6df54ec5939313$export$3280a108d7f81d56 = `CJxJDa_rightContainer`;
$af6df54ec5939313$export$c96745152eb2740f = `CJxJDa_subtitle`;
$af6df54ec5939313$export$f0f4addd87dfefa7 = `CJxJDa_upcomingBox`;
$af6df54ec5939313$export$6bed4238f002259f = `CJxJDa_upcomingPerimeter`;
$af6df54ec5939313$export$b91a3c72dc814419 = `CJxJDa_upcomingText`;







const $823474252ad79741$export$b6122de96ced3cd9 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getImage = async (parameters)=>{
        const name = `${parameters.name}_${parameters.width}_${parameters.height}`;
        const cachedImage = await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.getCachedImage(name);
        if (cachedImage) return {
            status: (0, $74d09775b34cce5b$export$efd5569f873811b1).OK,
            body: cachedImage
        };
        else {
            const { status: status, body: body } = await get("images", parameters);
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.saveImage(name, body);
            return {
                status: status,
                body: body
            };
        }
    };
    return {
        getImage: getImage
    };
};







const $32bf7b326240a873$export$a470b679ab90b0b4 = ()=>{
    const { upload: upload } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const uploadImage = async (parameters, bigWidth, bigHeight, smallWidth, smallHeight)=>{
        const { status: status, body: body } = await upload("images", `${parameters.name}.png`, parameters.file);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).image_upload_success);
            await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.removeImage(`${parameters.name}_${bigWidth}_${bigHeight}`);
            await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.removeImage(`${parameters.name}_${smallWidth}_${smallHeight}`);
            return body.thumbnail;
        }
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).image_upload_error);
        return undefined;
    };
    return {
        uploadImage: uploadImage
    };
};





var $7f6425aca1147a92$exports = {};

$parcel$export($7f6425aca1147a92$exports, "card", function () { return $7f6425aca1147a92$export$aa3e815946b80764; }, function (v) { return $7f6425aca1147a92$export$aa3e815946b80764 = v; });
$parcel$export($7f6425aca1147a92$exports, "description", function () { return $7f6425aca1147a92$export$6d59db4903f20f7d; }, function (v) { return $7f6425aca1147a92$export$6d59db4903f20f7d = v; });
var $7f6425aca1147a92$export$aa3e815946b80764;
var $7f6425aca1147a92$export$6d59db4903f20f7d;
$7f6425aca1147a92$export$aa3e815946b80764 = `MyYKkW_card`;
$7f6425aca1147a92$export$6d59db4903f20f7d = `MyYKkW_description`;



var $7fPBF = parcelRequire("7fPBF");


const $8c0a3cf7f5050c0a$export$c76d9c7d80725567 = ({ className: className, points: points, goldmineGrading: goldmineGrading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const color = (0, $7fPBF.useMemo)(()=>{
        if (points == 0) return theme.palette.colors?.goldmineGray;
        else if (points < 6) return theme.palette.colors?.goldmineRed;
        else if (points < 9) return theme.palette.colors?.goldmineGreen;
        else if (points <= 10) return theme.palette.colors?.goldmineBlue;
        else return theme.palette.colors?.goldmineMint;
    }, [
        points,
        theme.palette
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7f6425aca1147a92$exports))).card, className),
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: color
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7f6425aca1147a92$exports))).description,
            children: goldmineGrading
        })
    });
};










var $7fPBF = parcelRequire("7fPBF");
function $491ef7492701bdf5$var$preventDefault(e) {
    if (!$491ef7492701bdf5$export$c4dfce035d43d1e0(e)) return;
    if (e.touches.length < 2 && e.preventDefault) e.preventDefault();
}
function $491ef7492701bdf5$export$c4dfce035d43d1e0(e) {
    return e && "touches" in e;
}
function $491ef7492701bdf5$export$2e2bcd8739ae039({ onLongPress: onLongPress }, { delay: delay = 300, shouldPreventDefault: shouldPreventDefault = true } = {}) {
    const [longPressTriggered, setLongPressTriggered] = (0, $7fPBF.useState)(false);
    const timeout = (0, $7fPBF.useRef)();
    const target = (0, $7fPBF.useRef)();
    const start = (0, $7fPBF.useCallback)((e)=>{
        e.persist();
        const clonedEvent = {
            ...e
        };
        if (shouldPreventDefault && e.target) {
            e.target.addEventListener("touchend", $491ef7492701bdf5$var$preventDefault, {
                passive: false
            });
            target.current = e.target;
        }
        timeout.current = setTimeout(()=>{
            onLongPress(clonedEvent);
            setLongPressTriggered(true);
        }, delay);
    }, [
        onLongPress,
        delay,
        shouldPreventDefault
    ]);
    const clear = (0, $7fPBF.useCallback)(()=>{
        if (timeout.current) clearTimeout(timeout.current);
        setLongPressTriggered(false);
        if (shouldPreventDefault && target.current) target.current.removeEventListener("touchend", $491ef7492701bdf5$var$preventDefault);
    }, [
        shouldPreventDefault,
        longPressTriggered
    ]);
    return {
        onTouchStart: (e)=>start(e),
        onTouchEnd: ()=>clear(),
        onTouchCancel: ()=>clear(),
        onTouchEndCapture: ()=>clear(),
        onTouchMove: ()=>clear(),
        onTouchMoveCapture: ()=>clear()
    };
}




const $2262e5d71d677a84$export$98d63ead59c21b7b = ()=>{
    const format = (number, userProfile, isPublic, maximumFractionDigits = 0, forcedCurrency, forceFractionDigits)=>{
        if (number === undefined || userProfile === undefined) return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
        const minimumFractionDigitsByProfile = userProfile?.showDecimals ? number % 1 == 0 ? 0 : Math.min(2, maximumFractionDigits) : 0;
        const maximumFractionDigitsByProfile = userProfile?.showDecimals ? maximumFractionDigits : 0;
        const formatter = new Intl.NumberFormat((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale, {
            style: "currency",
            currency: forcedCurrency ? forcedCurrency : userProfile?.currency?.code ?? "USD",
            currencyDisplay: forcedCurrency || isPublic ? "code" : "narrowSymbol",
            currencySign: "accounting",
            minimumFractionDigits: forceFractionDigits ? maximumFractionDigits : minimumFractionDigitsByProfile,
            maximumFractionDigits: forceFractionDigits ? maximumFractionDigits : maximumFractionDigitsByProfile
        });
        return formatter.format(number).replace(/^(\D+)/, "$1 ").replace(/\s+/, " ");
    };
    const decimalFormat = (number)=>{
        if (number === undefined) return "-";
        const formatter = new Intl.NumberFormat((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale, {
            style: "decimal"
        });
        return formatter.format(number);
    };
    return {
        format: format,
        decimalFormat: decimalFormat
    };
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
function $b0dbf033e6a04143$var$isTouchEvent(e) {
    return e && "touches" in e;
}
function $b0dbf033e6a04143$var$isMouseEvent(e) {
    return e && "screenX" in e;
}
const $b0dbf033e6a04143$export$2464060fb1e12fa6 = ()=>{
    const [contextMenu, setContextMenu] = (0, $7fPBF.useState)(null);
    const handleContextMenu = (0, $7fPBF.useCallback)((event)=>{
        if (event.preventDefault) event.preventDefault();
        let x = 0;
        let y = 0;
        if ($b0dbf033e6a04143$var$isMouseEvent(event)) {
            x = event.nativeEvent.clientX;
            y = event.nativeEvent.clientY;
        }
        if ($b0dbf033e6a04143$var$isTouchEvent(event)) {
            x = event.nativeEvent.touches[0].clientX;
            y = event.nativeEvent.touches[0].clientY;
        }
        setContextMenu(contextMenu === null ? {
            mouseX: x - 2,
            mouseY: y - 4
        } : null);
    }, []);
    const handleMenuClose = (0, $7fPBF.useCallback)(()=>{
        setContextMenu(null);
    }, []);
    const menuProps = (0, $7fPBF.useMemo)(()=>{
        return {
            open: contextMenu !== null,
            onClose: handleMenuClose,
            anchorReference: "anchorPosition",
            anchorPosition: contextMenu !== null ? {
                top: contextMenu.mouseY,
                left: contextMenu.mouseX
            } : undefined
        };
    }, [
        contextMenu
    ]);
    return {
        menuProps: menuProps,
        handleContextMenu: handleContextMenu,
        handleMenuClose: handleMenuClose
    };
};








const $af828632625b31bb$export$64a84caa05affe34 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (query)=>{
        const curatedQuery = encodeURIComponent(query);
        const { status: status, body: body } = await get(`youtube/${curatedQuery}`);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) return body.items[0]?.id.videoId;
        else return undefined;
    };
};


const $935530e1b4d603d2$export$3a220a9dac4bee11 = ()=>{
    const getVideoId = (0, $af828632625b31bb$export$64a84caa05affe34)();
    return async (trackList, albumName, artistName)=>{
        const videoIds = [];
        for (const track of trackList){
            const videoId = await getVideoId(`${artistName} ${albumName} ${track.name}`);
            if (videoId) videoIds.push(videoId);
        }
        return videoIds;
    };
};



const $19e5276cf99ccb6e$export$2c6b92c80f456539 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getPrivateLink = (parameters)=>get("share/privateLink", parameters);
    return {
        getPrivateLink: getPrivateLink
    };
};





var $7fPBF = parcelRequire("7fPBF");

var $9efca8d7db7deffa$exports = {};
"use strict";
var $bf5d44ad608cda66$exports = {};
$bf5d44ad608cda66$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $9efca8d7db7deffa$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $9efca8d7db7deffa$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $9efca8d7db7deffa$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $9efca8d7db7deffa$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $bf5d44ad608cda66$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $9efca8d7db7deffa$var$clipboardToIE11Formatting[options.format] || $9efca8d7db7deffa$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $9efca8d7db7deffa$var$format("message" in options ? options.message : $9efca8d7db7deffa$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$9efca8d7db7deffa$exports = $9efca8d7db7deffa$var$copy;





const $222a4bd740860170$export$6c80620349828bf = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getShareLink = (parameters)=>get("share/shareLink", parameters);
    return {
        getShareLink: getShareLink
    };
};



var $7fPBF = parcelRequire("7fPBF");

var $145a83a98778bf73$exports = {};
!function(t, e) {
    $145a83a98778bf73$exports = e();
}(self, function() {
    return (()=>{
        var t = {
            192: (t, e)=>{
                var r, n, o = function() {
                    var t = function(t, e) {
                        var r = t, n = a[e], o = null, i = 0, u = null, v = [], w = {}, m = function(t, e) {
                            o = function(t) {
                                for(var e = new Array(t), r = 0; r < t; r += 1){
                                    e[r] = new Array(t);
                                    for(var n = 0; n < t; n += 1)e[r][n] = null;
                                }
                                return e;
                            }(i = 4 * r + 17), b(0, 0), b(i - 7, 0), b(0, i - 7), x(), _(), M(t, e), r >= 7 && S(t), null == u && (u = A(r, n, v)), C(u, e);
                        }, b = function(t, e) {
                            for(var r = -1; r <= 7; r += 1)if (!(t + r <= -1 || i <= t + r)) for(var n = -1; n <= 7; n += 1)e + n <= -1 || i <= e + n || (o[t + r][e + n] = 0 <= r && r <= 6 && (0 == n || 6 == n) || 0 <= n && n <= 6 && (0 == r || 6 == r) || 2 <= r && r <= 4 && 2 <= n && n <= 4);
                        }, _ = function() {
                            for(var t = 8; t < i - 8; t += 1)null == o[t][6] && (o[t][6] = t % 2 == 0);
                            for(var e = 8; e < i - 8; e += 1)null == o[6][e] && (o[6][e] = e % 2 == 0);
                        }, x = function() {
                            for(var t = s.getPatternPosition(r), e = 0; e < t.length; e += 1)for(var n = 0; n < t.length; n += 1){
                                var i = t[e], a = t[n];
                                if (null == o[i][a]) for(var u = -2; u <= 2; u += 1)for(var h = -2; h <= 2; h += 1)o[i + u][a + h] = -2 == u || 2 == u || -2 == h || 2 == h || 0 == u && 0 == h;
                            }
                        }, S = function(t) {
                            for(var e = s.getBCHTypeNumber(r), n = 0; n < 18; n += 1){
                                var a = !t && 1 == (e >> n & 1);
                                o[Math.floor(n / 3)][n % 3 + i - 8 - 3] = a;
                            }
                            for(n = 0; n < 18; n += 1)a = !t && 1 == (e >> n & 1), o[n % 3 + i - 8 - 3][Math.floor(n / 3)] = a;
                        }, M = function(t, e) {
                            for(var r = n << 3 | e, a = s.getBCHTypeInfo(r), u = 0; u < 15; u += 1){
                                var h = !t && 1 == (a >> u & 1);
                                u < 6 ? o[u][8] = h : u < 8 ? o[u + 1][8] = h : o[i - 15 + u][8] = h;
                            }
                            for(u = 0; u < 15; u += 1)h = !t && 1 == (a >> u & 1), u < 8 ? o[8][i - u - 1] = h : u < 9 ? o[8][15 - u - 1 + 1] = h : o[8][15 - u - 1] = h;
                            o[i - 8][8] = !t;
                        }, C = function(t, e) {
                            for(var r = -1, n = i - 1, a = 7, u = 0, h = s.getMaskFunction(e), c = i - 1; c > 0; c -= 2)for(6 == c && (c -= 1);;){
                                for(var l = 0; l < 2; l += 1)if (null == o[n][c - l]) {
                                    var d = !1;
                                    u < t.length && (d = 1 == (t[u] >>> a & 1)), h(n, c - l) && (d = !d), o[n][c - l] = d, -1 == (a -= 1) && (u += 1, a = 7);
                                }
                                if ((n += r) < 0 || i <= n) {
                                    n -= r, r = -r;
                                    break;
                                }
                            }
                        }, A = function(t, e, r) {
                            for(var n = c.getRSBlocks(t, e), o = l(), i = 0; i < r.length; i += 1){
                                var a = r[i];
                                o.put(a.getMode(), 4), o.put(a.getLength(), s.getLengthInBits(a.getMode(), t)), a.write(o);
                            }
                            var u = 0;
                            for(i = 0; i < n.length; i += 1)u += n[i].dataCount;
                            if (o.getLengthInBits() > 8 * u) throw "code length overflow. (" + o.getLengthInBits() + ">" + 8 * u + ")";
                            for(o.getLengthInBits() + 4 <= 8 * u && o.put(0, 4); o.getLengthInBits() % 8 != 0;)o.putBit(!1);
                            for(; !(o.getLengthInBits() >= 8 * u || (o.put(236, 8), o.getLengthInBits() >= 8 * u));)o.put(17, 8);
                            return function(t, e) {
                                for(var r = 0, n = 0, o = 0, i = new Array(e.length), a = new Array(e.length), u = 0; u < e.length; u += 1){
                                    var c = e[u].dataCount, l = e[u].totalCount - c;
                                    n = Math.max(n, c), o = Math.max(o, l), i[u] = new Array(c);
                                    for(var d = 0; d < i[u].length; d += 1)i[u][d] = 255 & t.getBuffer()[d + r];
                                    r += c;
                                    var f = s.getErrorCorrectPolynomial(l), g = h(i[u], f.getLength() - 1).mod(f);
                                    for(a[u] = new Array(f.getLength() - 1), d = 0; d < a[u].length; d += 1){
                                        var p = d + g.getLength() - a[u].length;
                                        a[u][d] = p >= 0 ? g.getAt(p) : 0;
                                    }
                                }
                                var v = 0;
                                for(d = 0; d < e.length; d += 1)v += e[d].totalCount;
                                var w = new Array(v), y = 0;
                                for(d = 0; d < n; d += 1)for(u = 0; u < e.length; u += 1)d < i[u].length && (w[y] = i[u][d], y += 1);
                                for(d = 0; d < o; d += 1)for(u = 0; u < e.length; u += 1)d < a[u].length && (w[y] = a[u][d], y += 1);
                                return w;
                            }(o, n);
                        };
                        w.addData = function(t, e) {
                            var r = null;
                            switch(e = e || "Byte"){
                                case "Numeric":
                                    r = d(t);
                                    break;
                                case "Alphanumeric":
                                    r = f(t);
                                    break;
                                case "Byte":
                                    r = g(t);
                                    break;
                                case "Kanji":
                                    r = p(t);
                                    break;
                                default:
                                    throw "mode:" + e;
                            }
                            v.push(r), u = null;
                        }, w.isDark = function(t, e) {
                            if (t < 0 || i <= t || e < 0 || i <= e) throw t + "," + e;
                            return o[t][e];
                        }, w.getModuleCount = function() {
                            return i;
                        }, w.make = function() {
                            if (r < 1) {
                                for(var t = 1; t < 40; t++){
                                    for(var e = c.getRSBlocks(t, n), o = l(), i = 0; i < v.length; i++){
                                        var a = v[i];
                                        o.put(a.getMode(), 4), o.put(a.getLength(), s.getLengthInBits(a.getMode(), t)), a.write(o);
                                    }
                                    var u = 0;
                                    for(i = 0; i < e.length; i++)u += e[i].dataCount;
                                    if (o.getLengthInBits() <= 8 * u) break;
                                }
                                r = t;
                            }
                            m(!1, function() {
                                for(var t = 0, e = 0, r = 0; r < 8; r += 1){
                                    m(!0, r);
                                    var n = s.getLostPoint(w);
                                    (0 == r || t > n) && (t = n, e = r);
                                }
                                return e;
                            }());
                        }, w.createTableTag = function(t, e) {
                            t = t || 2;
                            var r = "";
                            r += '<table style="', r += " border-width: 0px; border-style: none;", r += " border-collapse: collapse;", r += " padding: 0px; margin: " + (e = void 0 === e ? 4 * t : e) + "px;", r += '">', r += "<tbody>";
                            for(var n = 0; n < w.getModuleCount(); n += 1){
                                r += "<tr>";
                                for(var o = 0; o < w.getModuleCount(); o += 1)r += '<td style="', r += " border-width: 0px; border-style: none;", r += " border-collapse: collapse;", r += " padding: 0px; margin: 0px;", r += " width: " + t + "px;", r += " height: " + t + "px;", r += " background-color: ", r += w.isDark(n, o) ? "#000000" : "#ffffff", r += ";", r += '"/>';
                                r += "</tr>";
                            }
                            return (r += "</tbody>") + "</table>";
                        }, w.createSvgTag = function(t, e, r, n) {
                            var o = {};
                            "object" == typeof arguments[0] && (t = (o = arguments[0]).cellSize, e = o.margin, r = o.alt, n = o.title), t = t || 2, e = void 0 === e ? 4 * t : e, (r = "string" == typeof r ? {
                                text: r
                            } : r || {}).text = r.text || null, r.id = r.text ? r.id || "qrcode-description" : null, (n = "string" == typeof n ? {
                                text: n
                            } : n || {}).text = n.text || null, n.id = n.text ? n.id || "qrcode-title" : null;
                            var i, a, s, u, h = w.getModuleCount() * t + 2 * e, c = "";
                            for(u = "l" + t + ",0 0," + t + " -" + t + ",0 0,-" + t + "z ", c += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"', c += o.scalable ? "" : ' width="' + h + 'px" height="' + h + 'px"', c += ' viewBox="0 0 ' + h + " " + h + '" ', c += ' preserveAspectRatio="xMinYMin meet"', c += n.text || r.text ? ' role="img" aria-labelledby="' + k([
                                n.id,
                                r.id
                            ].join(" ").trim()) + '"' : "", c += ">", c += n.text ? '<title id="' + k(n.id) + '">' + k(n.text) + "</title>" : "", c += r.text ? '<description id="' + k(r.id) + '">' + k(r.text) + "</description>" : "", c += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>', c += '<path d="', a = 0; a < w.getModuleCount(); a += 1)for(s = a * t + e, i = 0; i < w.getModuleCount(); i += 1)w.isDark(a, i) && (c += "M" + (i * t + e) + "," + s + u);
                            return (c += '" stroke="transparent" fill="black"/>') + "</svg>";
                        }, w.createDataURL = function(t, e) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var r = w.getModuleCount() * t + 2 * e, n = e, o = r - e;
                            return y(r, r, function(e, r) {
                                if (n <= e && e < o && n <= r && r < o) {
                                    var i = Math.floor((e - n) / t), a = Math.floor((r - n) / t);
                                    return w.isDark(a, i) ? 0 : 1;
                                }
                                return 1;
                            });
                        }, w.createImgTag = function(t, e, r) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var n = w.getModuleCount() * t + 2 * e, o = "";
                            return o += "<img", o += ' src="', o += w.createDataURL(t, e), o += '"', o += ' width="', o += n, o += '"', o += ' height="', o += n, o += '"', r && (o += ' alt="', o += k(r), o += '"'), o + "/>";
                        };
                        var k = function(t) {
                            for(var e = "", r = 0; r < t.length; r += 1){
                                var n = t.charAt(r);
                                switch(n){
                                    case "<":
                                        e += "&lt;";
                                        break;
                                    case ">":
                                        e += "&gt;";
                                        break;
                                    case "&":
                                        e += "&amp;";
                                        break;
                                    case '"':
                                        e += "&quot;";
                                        break;
                                    default:
                                        e += n;
                                }
                            }
                            return e;
                        };
                        return w.createASCII = function(t, e) {
                            if ((t = t || 1) < 2) return function(t) {
                                t = void 0 === t ? 2 : t;
                                var e, r, n, o, i, a = 1 * w.getModuleCount() + 2 * t, s = t, u = a - t, h = {
                                    "\u2588\u2588": "\u2588",
                                    "\u2588 ": "\u2580",
                                    " \u2588": "\u2584",
                                    "  ": " "
                                }, c = {
                                    "\u2588\u2588": "\u2580",
                                    "\u2588 ": "\u2580",
                                    " \u2588": " ",
                                    "  ": " "
                                }, l = "";
                                for(e = 0; e < a; e += 2){
                                    for(n = Math.floor((e - s) / 1), o = Math.floor((e + 1 - s) / 1), r = 0; r < a; r += 1)i = "\u2588", s <= r && r < u && s <= e && e < u && w.isDark(n, Math.floor((r - s) / 1)) && (i = " "), s <= r && r < u && s <= e + 1 && e + 1 < u && w.isDark(o, Math.floor((r - s) / 1)) ? i += " " : i += "\u2588", l += t < 1 && e + 1 >= u ? c[i] : h[i];
                                    l += "\n";
                                }
                                return a % 2 && t > 0 ? l.substring(0, l.length - a - 1) + Array(a + 1).join("\u2580") : l.substring(0, l.length - 1);
                            }(e);
                            t -= 1, e = void 0 === e ? 2 * t : e;
                            var r, n, o, i, a = w.getModuleCount() * t + 2 * e, s = e, u = a - e, h = Array(t + 1).join("\u2588\u2588"), c = Array(t + 1).join("  "), l = "", d = "";
                            for(r = 0; r < a; r += 1){
                                for(o = Math.floor((r - s) / t), d = "", n = 0; n < a; n += 1)i = 1, s <= n && n < u && s <= r && r < u && w.isDark(o, Math.floor((n - s) / t)) && (i = 0), d += i ? h : c;
                                for(o = 0; o < t; o += 1)l += d + "\n";
                            }
                            return l.substring(0, l.length - 1);
                        }, w.renderTo2dContext = function(t, e) {
                            e = e || 2;
                            for(var r = w.getModuleCount(), n = 0; n < r; n++)for(var o = 0; o < r; o++)t.fillStyle = w.isDark(n, o) ? "black" : "white", t.fillRect(n * e, o * e, e, e);
                        }, w;
                    };
                    t.stringToBytes = (t.stringToBytesFuncs = {
                        default: function(t) {
                            for(var e = [], r = 0; r < t.length; r += 1){
                                var n = t.charCodeAt(r);
                                e.push(255 & n);
                            }
                            return e;
                        }
                    }).default, t.createStringToBytes = function(t, e) {
                        var r = function() {
                            for(var r = w(t), n = function() {
                                var t = r.read();
                                if (-1 == t) throw "eof";
                                return t;
                            }, o = 0, i = {};;){
                                var a = r.read();
                                if (-1 == a) break;
                                var s = n(), u = n() << 8 | n();
                                i[String.fromCharCode(a << 8 | s)] = u, o += 1;
                            }
                            if (o != e) throw o + " != " + e;
                            return i;
                        }(), n = "?".charCodeAt(0);
                        return function(t) {
                            for(var e = [], o = 0; o < t.length; o += 1){
                                var i = t.charCodeAt(o);
                                if (i < 128) e.push(i);
                                else {
                                    var a = r[t.charAt(o)];
                                    "number" == typeof a ? (255 & a) == a ? e.push(a) : (e.push(a >>> 8), e.push(255 & a)) : e.push(n);
                                }
                            }
                            return e;
                        };
                    };
                    var e, r, n, o, i, a = {
                        L: 1,
                        M: 0,
                        Q: 3,
                        H: 2
                    }, s = (e = [
                        [],
                        [
                            6,
                            18
                        ],
                        [
                            6,
                            22
                        ],
                        [
                            6,
                            26
                        ],
                        [
                            6,
                            30
                        ],
                        [
                            6,
                            34
                        ],
                        [
                            6,
                            22,
                            38
                        ],
                        [
                            6,
                            24,
                            42
                        ],
                        [
                            6,
                            26,
                            46
                        ],
                        [
                            6,
                            28,
                            50
                        ],
                        [
                            6,
                            30,
                            54
                        ],
                        [
                            6,
                            32,
                            58
                        ],
                        [
                            6,
                            34,
                            62
                        ],
                        [
                            6,
                            26,
                            46,
                            66
                        ],
                        [
                            6,
                            26,
                            48,
                            70
                        ],
                        [
                            6,
                            26,
                            50,
                            74
                        ],
                        [
                            6,
                            30,
                            54,
                            78
                        ],
                        [
                            6,
                            30,
                            56,
                            82
                        ],
                        [
                            6,
                            30,
                            58,
                            86
                        ],
                        [
                            6,
                            34,
                            62,
                            90
                        ],
                        [
                            6,
                            28,
                            50,
                            72,
                            94
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98,
                            122
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126
                        ],
                        [
                            6,
                            26,
                            52,
                            78,
                            104,
                            130
                        ],
                        [
                            6,
                            30,
                            56,
                            82,
                            108,
                            134
                        ],
                        [
                            6,
                            34,
                            60,
                            86,
                            112,
                            138
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118,
                            146
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126,
                            150
                        ],
                        [
                            6,
                            24,
                            50,
                            76,
                            102,
                            128,
                            154
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106,
                            132,
                            158
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110,
                            136,
                            162
                        ],
                        [
                            6,
                            26,
                            54,
                            82,
                            110,
                            138,
                            166
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142,
                            170
                        ]
                    ], r = 1335, n = 7973, i = function(t) {
                        for(var e = 0; 0 != t;)e += 1, t >>>= 1;
                        return e;
                    }, (o = {}).getBCHTypeInfo = function(t) {
                        for(var e = t << 10; i(e) - i(r) >= 0;)e ^= r << i(e) - i(r);
                        return 21522 ^ (t << 10 | e);
                    }, o.getBCHTypeNumber = function(t) {
                        for(var e = t << 12; i(e) - i(n) >= 0;)e ^= n << i(e) - i(n);
                        return t << 12 | e;
                    }, o.getPatternPosition = function(t) {
                        return e[t - 1];
                    }, o.getMaskFunction = function(t) {
                        switch(t){
                            case 0:
                                return function(t, e) {
                                    return (t + e) % 2 == 0;
                                };
                            case 1:
                                return function(t, e) {
                                    return t % 2 == 0;
                                };
                            case 2:
                                return function(t, e) {
                                    return e % 3 == 0;
                                };
                            case 3:
                                return function(t, e) {
                                    return (t + e) % 3 == 0;
                                };
                            case 4:
                                return function(t, e) {
                                    return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
                                };
                            case 5:
                                return function(t, e) {
                                    return t * e % 2 + t * e % 3 == 0;
                                };
                            case 6:
                                return function(t, e) {
                                    return (t * e % 2 + t * e % 3) % 2 == 0;
                                };
                            case 7:
                                return function(t, e) {
                                    return (t * e % 3 + (t + e) % 2) % 2 == 0;
                                };
                            default:
                                throw "bad maskPattern:" + t;
                        }
                    }, o.getErrorCorrectPolynomial = function(t) {
                        for(var e = h([
                            1
                        ], 0), r = 0; r < t; r += 1)e = e.multiply(h([
                            1,
                            u.gexp(r)
                        ], 0));
                        return e;
                    }, o.getLengthInBits = function(t, e) {
                        if (1 <= e && e < 10) switch(t){
                            case 1:
                                return 10;
                            case 2:
                                return 9;
                            case 4:
                            case 8:
                                return 8;
                            default:
                                throw "mode:" + t;
                        }
                        else if (e < 27) switch(t){
                            case 1:
                                return 12;
                            case 2:
                                return 11;
                            case 4:
                                return 16;
                            case 8:
                                return 10;
                            default:
                                throw "mode:" + t;
                        }
                        else {
                            if (!(e < 41)) throw "type:" + e;
                            switch(t){
                                case 1:
                                    return 14;
                                case 2:
                                    return 13;
                                case 4:
                                    return 16;
                                case 8:
                                    return 12;
                                default:
                                    throw "mode:" + t;
                            }
                        }
                    }, o.getLostPoint = function(t) {
                        for(var e = t.getModuleCount(), r = 0, n = 0; n < e; n += 1)for(var o = 0; o < e; o += 1){
                            for(var i = 0, a = t.isDark(n, o), s = -1; s <= 1; s += 1)if (!(n + s < 0 || e <= n + s)) for(var u = -1; u <= 1; u += 1)o + u < 0 || e <= o + u || 0 == s && 0 == u || a == t.isDark(n + s, o + u) && (i += 1);
                            i > 5 && (r += 3 + i - 5);
                        }
                        for(n = 0; n < e - 1; n += 1)for(o = 0; o < e - 1; o += 1){
                            var h = 0;
                            t.isDark(n, o) && (h += 1), t.isDark(n + 1, o) && (h += 1), t.isDark(n, o + 1) && (h += 1), t.isDark(n + 1, o + 1) && (h += 1), 0 != h && 4 != h || (r += 3);
                        }
                        for(n = 0; n < e; n += 1)for(o = 0; o < e - 6; o += 1)t.isDark(n, o) && !t.isDark(n, o + 1) && t.isDark(n, o + 2) && t.isDark(n, o + 3) && t.isDark(n, o + 4) && !t.isDark(n, o + 5) && t.isDark(n, o + 6) && (r += 40);
                        for(o = 0; o < e; o += 1)for(n = 0; n < e - 6; n += 1)t.isDark(n, o) && !t.isDark(n + 1, o) && t.isDark(n + 2, o) && t.isDark(n + 3, o) && t.isDark(n + 4, o) && !t.isDark(n + 5, o) && t.isDark(n + 6, o) && (r += 40);
                        var c = 0;
                        for(o = 0; o < e; o += 1)for(n = 0; n < e; n += 1)t.isDark(n, o) && (c += 1);
                        return r + Math.abs(100 * c / e / e - 50) / 5 * 10;
                    }, o), u = function() {
                        for(var t = new Array(256), e = new Array(256), r = 0; r < 8; r += 1)t[r] = 1 << r;
                        for(r = 8; r < 256; r += 1)t[r] = t[r - 4] ^ t[r - 5] ^ t[r - 6] ^ t[r - 8];
                        for(r = 0; r < 255; r += 1)e[t[r]] = r;
                        return {
                            glog: function(t) {
                                if (t < 1) throw "glog(" + t + ")";
                                return e[t];
                            },
                            gexp: function(e) {
                                for(; e < 0;)e += 255;
                                for(; e >= 256;)e -= 255;
                                return t[e];
                            }
                        };
                    }();
                    function h(t, e) {
                        if (void 0 === t.length) throw t.length + "/" + e;
                        var r = function() {
                            for(var r = 0; r < t.length && 0 == t[r];)r += 1;
                            for(var n = new Array(t.length - r + e), o = 0; o < t.length - r; o += 1)n[o] = t[o + r];
                            return n;
                        }(), n = {
                            getAt: function(t) {
                                return r[t];
                            },
                            getLength: function() {
                                return r.length;
                            },
                            multiply: function(t) {
                                for(var e = new Array(n.getLength() + t.getLength() - 1), r = 0; r < n.getLength(); r += 1)for(var o = 0; o < t.getLength(); o += 1)e[r + o] ^= u.gexp(u.glog(n.getAt(r)) + u.glog(t.getAt(o)));
                                return h(e, 0);
                            },
                            mod: function(t) {
                                if (n.getLength() - t.getLength() < 0) return n;
                                for(var e = u.glog(n.getAt(0)) - u.glog(t.getAt(0)), r = new Array(n.getLength()), o = 0; o < n.getLength(); o += 1)r[o] = n.getAt(o);
                                for(o = 0; o < t.getLength(); o += 1)r[o] ^= u.gexp(u.glog(t.getAt(o)) + e);
                                return h(r, 0).mod(t);
                            }
                        };
                        return n;
                    }
                    var c = function() {
                        var t = [
                            [
                                1,
                                26,
                                19
                            ],
                            [
                                1,
                                26,
                                16
                            ],
                            [
                                1,
                                26,
                                13
                            ],
                            [
                                1,
                                26,
                                9
                            ],
                            [
                                1,
                                44,
                                34
                            ],
                            [
                                1,
                                44,
                                28
                            ],
                            [
                                1,
                                44,
                                22
                            ],
                            [
                                1,
                                44,
                                16
                            ],
                            [
                                1,
                                70,
                                55
                            ],
                            [
                                1,
                                70,
                                44
                            ],
                            [
                                2,
                                35,
                                17
                            ],
                            [
                                2,
                                35,
                                13
                            ],
                            [
                                1,
                                100,
                                80
                            ],
                            [
                                2,
                                50,
                                32
                            ],
                            [
                                2,
                                50,
                                24
                            ],
                            [
                                4,
                                25,
                                9
                            ],
                            [
                                1,
                                134,
                                108
                            ],
                            [
                                2,
                                67,
                                43
                            ],
                            [
                                2,
                                33,
                                15,
                                2,
                                34,
                                16
                            ],
                            [
                                2,
                                33,
                                11,
                                2,
                                34,
                                12
                            ],
                            [
                                2,
                                86,
                                68
                            ],
                            [
                                4,
                                43,
                                27
                            ],
                            [
                                4,
                                43,
                                19
                            ],
                            [
                                4,
                                43,
                                15
                            ],
                            [
                                2,
                                98,
                                78
                            ],
                            [
                                4,
                                49,
                                31
                            ],
                            [
                                2,
                                32,
                                14,
                                4,
                                33,
                                15
                            ],
                            [
                                4,
                                39,
                                13,
                                1,
                                40,
                                14
                            ],
                            [
                                2,
                                121,
                                97
                            ],
                            [
                                2,
                                60,
                                38,
                                2,
                                61,
                                39
                            ],
                            [
                                4,
                                40,
                                18,
                                2,
                                41,
                                19
                            ],
                            [
                                4,
                                40,
                                14,
                                2,
                                41,
                                15
                            ],
                            [
                                2,
                                146,
                                116
                            ],
                            [
                                3,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                36,
                                16,
                                4,
                                37,
                                17
                            ],
                            [
                                4,
                                36,
                                12,
                                4,
                                37,
                                13
                            ],
                            [
                                2,
                                86,
                                68,
                                2,
                                87,
                                69
                            ],
                            [
                                4,
                                69,
                                43,
                                1,
                                70,
                                44
                            ],
                            [
                                6,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                6,
                                43,
                                15,
                                2,
                                44,
                                16
                            ],
                            [
                                4,
                                101,
                                81
                            ],
                            [
                                1,
                                80,
                                50,
                                4,
                                81,
                                51
                            ],
                            [
                                4,
                                50,
                                22,
                                4,
                                51,
                                23
                            ],
                            [
                                3,
                                36,
                                12,
                                8,
                                37,
                                13
                            ],
                            [
                                2,
                                116,
                                92,
                                2,
                                117,
                                93
                            ],
                            [
                                6,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                46,
                                20,
                                6,
                                47,
                                21
                            ],
                            [
                                7,
                                42,
                                14,
                                4,
                                43,
                                15
                            ],
                            [
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                59,
                                37,
                                1,
                                60,
                                38
                            ],
                            [
                                8,
                                44,
                                20,
                                4,
                                45,
                                21
                            ],
                            [
                                12,
                                33,
                                11,
                                4,
                                34,
                                12
                            ],
                            [
                                3,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                4,
                                64,
                                40,
                                5,
                                65,
                                41
                            ],
                            [
                                11,
                                36,
                                16,
                                5,
                                37,
                                17
                            ],
                            [
                                11,
                                36,
                                12,
                                5,
                                37,
                                13
                            ],
                            [
                                5,
                                109,
                                87,
                                1,
                                110,
                                88
                            ],
                            [
                                5,
                                65,
                                41,
                                5,
                                66,
                                42
                            ],
                            [
                                5,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                11,
                                36,
                                12,
                                7,
                                37,
                                13
                            ],
                            [
                                5,
                                122,
                                98,
                                1,
                                123,
                                99
                            ],
                            [
                                7,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                15,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                3,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                1,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                10,
                                74,
                                46,
                                1,
                                75,
                                47
                            ],
                            [
                                1,
                                50,
                                22,
                                15,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                17,
                                43,
                                15
                            ],
                            [
                                5,
                                150,
                                120,
                                1,
                                151,
                                121
                            ],
                            [
                                9,
                                69,
                                43,
                                4,
                                70,
                                44
                            ],
                            [
                                17,
                                50,
                                22,
                                1,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                19,
                                43,
                                15
                            ],
                            [
                                3,
                                141,
                                113,
                                4,
                                142,
                                114
                            ],
                            [
                                3,
                                70,
                                44,
                                11,
                                71,
                                45
                            ],
                            [
                                17,
                                47,
                                21,
                                4,
                                48,
                                22
                            ],
                            [
                                9,
                                39,
                                13,
                                16,
                                40,
                                14
                            ],
                            [
                                3,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                3,
                                67,
                                41,
                                13,
                                68,
                                42
                            ],
                            [
                                15,
                                54,
                                24,
                                5,
                                55,
                                25
                            ],
                            [
                                15,
                                43,
                                15,
                                10,
                                44,
                                16
                            ],
                            [
                                4,
                                144,
                                116,
                                4,
                                145,
                                117
                            ],
                            [
                                17,
                                68,
                                42
                            ],
                            [
                                17,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                19,
                                46,
                                16,
                                6,
                                47,
                                17
                            ],
                            [
                                2,
                                139,
                                111,
                                7,
                                140,
                                112
                            ],
                            [
                                17,
                                74,
                                46
                            ],
                            [
                                7,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                34,
                                37,
                                13
                            ],
                            [
                                4,
                                151,
                                121,
                                5,
                                152,
                                122
                            ],
                            [
                                4,
                                75,
                                47,
                                14,
                                76,
                                48
                            ],
                            [
                                11,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                16,
                                45,
                                15,
                                14,
                                46,
                                16
                            ],
                            [
                                6,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                6,
                                73,
                                45,
                                14,
                                74,
                                46
                            ],
                            [
                                11,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                30,
                                46,
                                16,
                                2,
                                47,
                                17
                            ],
                            [
                                8,
                                132,
                                106,
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                75,
                                47,
                                13,
                                76,
                                48
                            ],
                            [
                                7,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                10,
                                142,
                                114,
                                2,
                                143,
                                115
                            ],
                            [
                                19,
                                74,
                                46,
                                4,
                                75,
                                47
                            ],
                            [
                                28,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                33,
                                46,
                                16,
                                4,
                                47,
                                17
                            ],
                            [
                                8,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                22,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                8,
                                53,
                                23,
                                26,
                                54,
                                24
                            ],
                            [
                                12,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                3,
                                147,
                                117,
                                10,
                                148,
                                118
                            ],
                            [
                                3,
                                73,
                                45,
                                23,
                                74,
                                46
                            ],
                            [
                                4,
                                54,
                                24,
                                31,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                31,
                                46,
                                16
                            ],
                            [
                                7,
                                146,
                                116,
                                7,
                                147,
                                117
                            ],
                            [
                                21,
                                73,
                                45,
                                7,
                                74,
                                46
                            ],
                            [
                                1,
                                53,
                                23,
                                37,
                                54,
                                24
                            ],
                            [
                                19,
                                45,
                                15,
                                26,
                                46,
                                16
                            ],
                            [
                                5,
                                145,
                                115,
                                10,
                                146,
                                116
                            ],
                            [
                                19,
                                75,
                                47,
                                10,
                                76,
                                48
                            ],
                            [
                                15,
                                54,
                                24,
                                25,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                25,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                3,
                                146,
                                116
                            ],
                            [
                                2,
                                74,
                                46,
                                29,
                                75,
                                47
                            ],
                            [
                                42,
                                54,
                                24,
                                1,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115
                            ],
                            [
                                10,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                10,
                                54,
                                24,
                                35,
                                55,
                                25
                            ],
                            [
                                19,
                                45,
                                15,
                                35,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                21,
                                75,
                                47
                            ],
                            [
                                29,
                                54,
                                24,
                                19,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                6,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                44,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                59,
                                46,
                                16,
                                1,
                                47,
                                17
                            ],
                            [
                                12,
                                151,
                                121,
                                7,
                                152,
                                122
                            ],
                            [
                                12,
                                75,
                                47,
                                26,
                                76,
                                48
                            ],
                            [
                                39,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                41,
                                46,
                                16
                            ],
                            [
                                6,
                                151,
                                121,
                                14,
                                152,
                                122
                            ],
                            [
                                6,
                                75,
                                47,
                                34,
                                76,
                                48
                            ],
                            [
                                46,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                2,
                                45,
                                15,
                                64,
                                46,
                                16
                            ],
                            [
                                17,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                29,
                                74,
                                46,
                                14,
                                75,
                                47
                            ],
                            [
                                49,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                24,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                4,
                                152,
                                122,
                                18,
                                153,
                                123
                            ],
                            [
                                13,
                                74,
                                46,
                                32,
                                75,
                                47
                            ],
                            [
                                48,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                42,
                                45,
                                15,
                                32,
                                46,
                                16
                            ],
                            [
                                20,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                40,
                                75,
                                47,
                                7,
                                76,
                                48
                            ],
                            [
                                43,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                10,
                                45,
                                15,
                                67,
                                46,
                                16
                            ],
                            [
                                19,
                                148,
                                118,
                                6,
                                149,
                                119
                            ],
                            [
                                18,
                                75,
                                47,
                                31,
                                76,
                                48
                            ],
                            [
                                34,
                                54,
                                24,
                                34,
                                55,
                                25
                            ],
                            [
                                20,
                                45,
                                15,
                                61,
                                46,
                                16
                            ]
                        ], e = function(t, e) {
                            var r = {};
                            return r.totalCount = t, r.dataCount = e, r;
                        }, r = {
                            getRSBlocks: function(r, n) {
                                var o = function(e, r) {
                                    switch(r){
                                        case a.L:
                                            return t[4 * (e - 1) + 0];
                                        case a.M:
                                            return t[4 * (e - 1) + 1];
                                        case a.Q:
                                            return t[4 * (e - 1) + 2];
                                        case a.H:
                                            return t[4 * (e - 1) + 3];
                                        default:
                                            return;
                                    }
                                }(r, n);
                                if (void 0 === o) throw "bad rs block @ typeNumber:" + r + "/errorCorrectionLevel:" + n;
                                for(var i = o.length / 3, s = [], u = 0; u < i; u += 1)for(var h = o[3 * u + 0], c = o[3 * u + 1], l = o[3 * u + 2], d = 0; d < h; d += 1)s.push(e(c, l));
                                return s;
                            }
                        };
                        return r;
                    }(), l = function() {
                        var t = [], e = 0, r = {
                            getBuffer: function() {
                                return t;
                            },
                            getAt: function(e) {
                                var r = Math.floor(e / 8);
                                return 1 == (t[r] >>> 7 - e % 8 & 1);
                            },
                            put: function(t, e) {
                                for(var n = 0; n < e; n += 1)r.putBit(1 == (t >>> e - n - 1 & 1));
                            },
                            getLengthInBits: function() {
                                return e;
                            },
                            putBit: function(r) {
                                var n = Math.floor(e / 8);
                                t.length <= n && t.push(0), r && (t[n] |= 128 >>> e % 8), e += 1;
                            }
                        };
                        return r;
                    }, d = function(t) {
                        var e = t, r = {
                            getMode: function() {
                                return 1;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var r = e, o = 0; o + 2 < r.length;)t.put(n(r.substring(o, o + 3)), 10), o += 3;
                                o < r.length && (r.length - o == 1 ? t.put(n(r.substring(o, o + 1)), 4) : r.length - o == 2 && t.put(n(r.substring(o, o + 2)), 7));
                            }
                        }, n = function(t) {
                            for(var e = 0, r = 0; r < t.length; r += 1)e = 10 * e + o(t.charAt(r));
                            return e;
                        }, o = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            throw "illegal char :" + t;
                        };
                        return r;
                    }, f = function(t) {
                        var e = t, r = {
                            getMode: function() {
                                return 2;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var r = e, o = 0; o + 1 < r.length;)t.put(45 * n(r.charAt(o)) + n(r.charAt(o + 1)), 11), o += 2;
                                o < r.length && t.put(n(r.charAt(o)), 6);
                            }
                        }, n = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            if ("A" <= t && t <= "Z") return t.charCodeAt(0) - "A".charCodeAt(0) + 10;
                            switch(t){
                                case " ":
                                    return 36;
                                case "$":
                                    return 37;
                                case "%":
                                    return 38;
                                case "*":
                                    return 39;
                                case "+":
                                    return 40;
                                case "-":
                                    return 41;
                                case ".":
                                    return 42;
                                case "/":
                                    return 43;
                                case ":":
                                    return 44;
                                default:
                                    throw "illegal char :" + t;
                            }
                        };
                        return r;
                    }, g = function(e) {
                        var r = t.stringToBytes(e);
                        return {
                            getMode: function() {
                                return 4;
                            },
                            getLength: function(t) {
                                return r.length;
                            },
                            write: function(t) {
                                for(var e = 0; e < r.length; e += 1)t.put(r[e], 8);
                            }
                        };
                    }, p = function(e) {
                        var r = t.stringToBytesFuncs.SJIS;
                        if (!r) throw "sjis not supported.";
                        !function(t, e) {
                            var n = r("\u53CB");
                            if (2 != n.length || 38726 != (n[0] << 8 | n[1])) throw "sjis not supported.";
                        }();
                        var n = r(e);
                        return {
                            getMode: function() {
                                return 8;
                            },
                            getLength: function(t) {
                                return ~~(n.length / 2);
                            },
                            write: function(t) {
                                for(var e = n, r = 0; r + 1 < e.length;){
                                    var o = (255 & e[r]) << 8 | 255 & e[r + 1];
                                    if (33088 <= o && o <= 40956) o -= 33088;
                                    else {
                                        if (!(57408 <= o && o <= 60351)) throw "illegal char at " + (r + 1) + "/" + o;
                                        o -= 49472;
                                    }
                                    o = 192 * (o >>> 8 & 255) + (255 & o), t.put(o, 13), r += 2;
                                }
                                if (r < e.length) throw "illegal char at " + (r + 1);
                            }
                        };
                    }, v = function() {
                        var t = [], e = {
                            writeByte: function(e) {
                                t.push(255 & e);
                            },
                            writeShort: function(t) {
                                e.writeByte(t), e.writeByte(t >>> 8);
                            },
                            writeBytes: function(t, r, n) {
                                r = r || 0, n = n || t.length;
                                for(var o = 0; o < n; o += 1)e.writeByte(t[o + r]);
                            },
                            writeString: function(t) {
                                for(var r = 0; r < t.length; r += 1)e.writeByte(t.charCodeAt(r));
                            },
                            toByteArray: function() {
                                return t;
                            },
                            toString: function() {
                                var e = "";
                                e += "[";
                                for(var r = 0; r < t.length; r += 1)r > 0 && (e += ","), e += t[r];
                                return e + "]";
                            }
                        };
                        return e;
                    }, w = function(t) {
                        var e = t, r = 0, n = 0, o = 0, i = {
                            read: function() {
                                for(; o < 8;){
                                    if (r >= e.length) {
                                        if (0 == o) return -1;
                                        throw "unexpected end of file./" + o;
                                    }
                                    var t = e.charAt(r);
                                    if (r += 1, "=" == t) return o = 0, -1;
                                    t.match(/^\s$/) || (n = n << 6 | a(t.charCodeAt(0)), o += 6);
                                }
                                var i = n >>> o - 8 & 255;
                                return o -= 8, i;
                            }
                        }, a = function(t) {
                            if (65 <= t && t <= 90) return t - 65;
                            if (97 <= t && t <= 122) return t - 97 + 26;
                            if (48 <= t && t <= 57) return t - 48 + 52;
                            if (43 == t) return 62;
                            if (47 == t) return 63;
                            throw "c:" + t;
                        };
                        return i;
                    }, y = function(t, e, r) {
                        for(var n = function(t, e) {
                            var r = t, n = e, o = new Array(t * e), i = {
                                setPixel: function(t, e, n) {
                                    o[e * r + t] = n;
                                },
                                write: function(t) {
                                    t.writeString("GIF87a"), t.writeShort(r), t.writeShort(n), t.writeByte(128), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(255), t.writeByte(255), t.writeByte(255), t.writeString(","), t.writeShort(0), t.writeShort(0), t.writeShort(r), t.writeShort(n), t.writeByte(0);
                                    var e = a(2);
                                    t.writeByte(2);
                                    for(var o = 0; e.length - o > 255;)t.writeByte(255), t.writeBytes(e, o, 255), o += 255;
                                    t.writeByte(e.length - o), t.writeBytes(e, o, e.length - o), t.writeByte(0), t.writeString(";");
                                }
                            }, a = function(t) {
                                for(var e = 1 << t, r = 1 + (1 << t), n = t + 1, i = s(), a = 0; a < e; a += 1)i.add(String.fromCharCode(a));
                                i.add(String.fromCharCode(e)), i.add(String.fromCharCode(r));
                                var u, h, c, l = v(), d = (u = l, h = 0, c = 0, {
                                    write: function(t, e) {
                                        if (t >>> e != 0) throw "length over";
                                        for(; h + e >= 8;)u.writeByte(255 & (t << h | c)), e -= 8 - h, t >>>= 8 - h, c = 0, h = 0;
                                        c |= t << h, h += e;
                                    },
                                    flush: function() {
                                        h > 0 && u.writeByte(c);
                                    }
                                });
                                d.write(e, n);
                                var f = 0, g = String.fromCharCode(o[f]);
                                for(f += 1; f < o.length;){
                                    var p = String.fromCharCode(o[f]);
                                    f += 1, i.contains(g + p) ? g += p : (d.write(i.indexOf(g), n), i.size() < 4095 && (i.size() == 1 << n && (n += 1), i.add(g + p)), g = p);
                                }
                                return d.write(i.indexOf(g), n), d.write(r, n), d.flush(), l.toByteArray();
                            }, s = function() {
                                var t = {}, e = 0, r = {
                                    add: function(n) {
                                        if (r.contains(n)) throw "dup key:" + n;
                                        t[n] = e, e += 1;
                                    },
                                    size: function() {
                                        return e;
                                    },
                                    indexOf: function(e) {
                                        return t[e];
                                    },
                                    contains: function(e) {
                                        return void 0 !== t[e];
                                    }
                                };
                                return r;
                            };
                            return i;
                        }(t, e), o = 0; o < e; o += 1)for(var i = 0; i < t; i += 1)n.setPixel(i, o, r(i, o));
                        var a = v();
                        n.write(a);
                        for(var s = function() {
                            var t = 0, e = 0, r = 0, n = "", o = {}, i = function(t) {
                                n += String.fromCharCode(a(63 & t));
                            }, a = function(t) {
                                if (t < 0) ;
                                else {
                                    if (t < 26) return 65 + t;
                                    if (t < 52) return t - 26 + 97;
                                    if (t < 62) return t - 52 + 48;
                                    if (62 == t) return 43;
                                    if (63 == t) return 47;
                                }
                                throw "n:" + t;
                            };
                            return o.writeByte = function(n) {
                                for(t = t << 8 | 255 & n, e += 8, r += 1; e >= 6;)i(t >>> e - 6), e -= 6;
                            }, o.flush = function() {
                                if (e > 0 && (i(t << 6 - e), t = 0, e = 0), r % 3 != 0) for(var o = 3 - r % 3, a = 0; a < o; a += 1)n += "=";
                            }, o.toString = function() {
                                return n;
                            }, o;
                        }(), u = a.toByteArray(), h = 0; h < u.length; h += 1)s.writeByte(u[h]);
                        return s.flush(), "data:image/gif;base64," + s;
                    };
                    return t;
                }();
                o.stringToBytesFuncs["UTF-8"] = function(t) {
                    return function(t) {
                        for(var e = [], r = 0; r < t.length; r++){
                            var n = t.charCodeAt(r);
                            n < 128 ? e.push(n) : n < 2048 ? e.push(192 | n >> 6, 128 | 63 & n) : n < 55296 || n >= 57344 ? e.push(224 | n >> 12, 128 | n >> 6 & 63, 128 | 63 & n) : (r++, n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(r)), e.push(240 | n >> 18, 128 | n >> 12 & 63, 128 | n >> 6 & 63, 128 | 63 & n));
                        }
                        return e;
                    }(t);
                }, void 0 === (n = "function" == typeof (r = function() {
                    return o;
                }) ? r.apply(e, []) : r) || (t.exports = n);
            },
            676: (t, e, r)=>{
                "use strict";
                r.d(e, {
                    default: ()=>q
                });
                var n = function() {
                    return (n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }).apply(this, arguments);
                }, o = function() {
                    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
                    var n = Array(t), o = 0;
                    for(e = 0; e < r; e++)for(var i = arguments[e], a = 0, s = i.length; a < s; a++, o++)n[o] = i[a];
                    return n;
                }, i = function(t) {
                    return !!t && "object" == typeof t && !Array.isArray(t);
                };
                function a(t) {
                    for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                    if (!e.length) return t;
                    var s = e.shift();
                    return void 0 !== s && i(t) && i(s) ? (t = n({}, t), Object.keys(s).forEach(function(e) {
                        var r = t[e], n = s[e];
                        Array.isArray(r) && Array.isArray(n) ? t[e] = n : i(r) && i(n) ? t[e] = a(Object.assign({}, r), n) : t[e] = n;
                    }), a.apply(void 0, o([
                        t
                    ], e))) : t;
                }
                function s(t, e) {
                    var r = document.createElement("a");
                    r.download = e, r.href = t, document.body.appendChild(r), r.click(), document.body.removeChild(r);
                }
                function u(t) {
                    var e, r, n, o;
                    return e = this, r = void 0, o = function() {
                        return function(t, e) {
                            var r, n, o, i, a = {
                                label: 0,
                                sent: function() {
                                    if (1 & o[0]) throw o[1];
                                    return o[1];
                                },
                                trys: [],
                                ops: []
                            };
                            return i = {
                                next: s(0),
                                throw: s(1),
                                return: s(2)
                            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                return this;
                            }), i;
                            function s(i) {
                                return function(s) {
                                    return function(i) {
                                        if (r) throw new TypeError("Generator is already executing.");
                                        for(; a;)try {
                                            if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                                            switch(n = 0, o && (i = [
                                                2 & i[0],
                                                o.value
                                            ]), i[0]){
                                                case 0:
                                                case 1:
                                                    o = i;
                                                    break;
                                                case 4:
                                                    return a.label++, {
                                                        value: i[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    a.label++, n = i[1], i = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    i = a.ops.pop(), a.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                        a = 0;
                                                        continue;
                                                    }
                                                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                                        a.label = i[1];
                                                        break;
                                                    }
                                                    if (6 === i[0] && a.label < o[1]) {
                                                        a.label = o[1], o = i;
                                                        break;
                                                    }
                                                    if (o && a.label < o[2]) {
                                                        a.label = o[2], a.ops.push(i);
                                                        break;
                                                    }
                                                    o[2] && a.ops.pop(), a.trys.pop();
                                                    continue;
                                            }
                                            i = e.call(t, a);
                                        } catch (t) {
                                            i = [
                                                6,
                                                t
                                            ], n = 0;
                                        } finally{
                                            r = o = 0;
                                        }
                                        if (5 & i[0]) throw i[1];
                                        return {
                                            value: i[0] ? i[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        i,
                                        s
                                    ]);
                                };
                            }
                        }(this, function(e) {
                            return [
                                2,
                                new Promise(function(e) {
                                    var r = new XMLHttpRequest;
                                    r.onload = function() {
                                        var t = new FileReader;
                                        t.onloadend = function() {
                                            e(t.result);
                                        }, t.readAsDataURL(r.response);
                                    }, r.open("GET", t), r.responseType = "blob", r.send();
                                })
                            ];
                        });
                    }, new (n = void 0, n = Promise)(function(t, i) {
                        function a(t) {
                            try {
                                u(o.next(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(o.throw(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function u(e) {
                            var r;
                            e.done ? t(e.value) : (r = e.value, r instanceof n ? r : new n(function(t) {
                                t(r);
                            })).then(a, s);
                        }
                        u((o = o.apply(e, r || [])).next());
                    });
                }
                const h = {
                    L: .07,
                    M: .15,
                    Q: .25,
                    H: .3
                };
                var c = function() {
                    return (c = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }).apply(this, arguments);
                };
                const l = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        var o;
                        switch(this._type){
                            case "dots":
                                o = this._drawDot;
                                break;
                            case "classy":
                                o = this._drawClassy;
                                break;
                            case "classy-rounded":
                                o = this._drawClassyRounded;
                                break;
                            case "rounded":
                                o = this._drawRounded;
                                break;
                            case "extra-rounded":
                                o = this._drawExtraRounded;
                                break;
                            case "square":
                            default:
                                o = this._drawSquare;
                        }
                        o.call(this, {
                            x: t,
                            y: e,
                            size: r,
                            getNeighbor: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, o = t.size, i = t.rotation, a = void 0 === i ? 0 : i, s = r + o / 2, u = n + o / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), e._element.setAttribute("cx", String(n + r / 2)), e._element.setAttribute("cy", String(o + r / 2)), e._element.setAttribute("r", String(r / 2));
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), e._element.setAttribute("x", String(n)), e._element.setAttribute("y", String(o)), e._element.setAttribute("width", String(r)), e._element.setAttribute("height", String(r));
                            }
                        }));
                    }, t.prototype._basicSideRounded = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + o + "v " + r + "h " + r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, 0 " + -r);
                            }
                        }));
                    }, t.prototype._basicCornerRounded = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + o + "v " + r + "h " + r + "v " + -r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + -r / 2 + " " + -r / 2);
                            }
                        }));
                    }, t.prototype._basicCornerExtraRounded = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + o + "v " + r + "h " + r + "a " + r + " " + r + ", 0, 0, 0, " + -r + " " + -r);
                            }
                        }));
                    }, t.prototype._basicCornersRounded = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(c(c({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + o + "v " + r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + r / 2 + " " + r / 2 + "h " + r / 2 + "v " + -r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + -r / 2 + " " + -r / 2);
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.getNeighbor, i = o ? +o(-1, 0) : 0, a = o ? +o(1, 0) : 0, s = o ? +o(0, -1) : 0, u = o ? +o(0, 1) : 0, h = i + a + s + u;
                        if (0 !== h) {
                            if (h > 2 || i && a || s && u) this._basicSquare({
                                x: e,
                                y: r,
                                size: n,
                                rotation: 0
                            });
                            else {
                                if (2 === h) {
                                    var c = 0;
                                    return i && s ? c = Math.PI / 2 : s && a ? c = Math.PI : a && u && (c = -Math.PI / 2), void this._basicCornerRounded({
                                        x: e,
                                        y: r,
                                        size: n,
                                        rotation: c
                                    });
                                }
                                if (1 === h) return c = 0, s ? c = Math.PI / 2 : a ? c = Math.PI : u && (c = -Math.PI / 2), void this._basicSideRounded({
                                    x: e,
                                    y: r,
                                    size: n,
                                    rotation: c
                                });
                            }
                        } else this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawExtraRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.getNeighbor, i = o ? +o(-1, 0) : 0, a = o ? +o(1, 0) : 0, s = o ? +o(0, -1) : 0, u = o ? +o(0, 1) : 0, h = i + a + s + u;
                        if (0 !== h) {
                            if (h > 2 || i && a || s && u) this._basicSquare({
                                x: e,
                                y: r,
                                size: n,
                                rotation: 0
                            });
                            else {
                                if (2 === h) {
                                    var c = 0;
                                    return i && s ? c = Math.PI / 2 : s && a ? c = Math.PI : a && u && (c = -Math.PI / 2), void this._basicCornerExtraRounded({
                                        x: e,
                                        y: r,
                                        size: n,
                                        rotation: c
                                    });
                                }
                                if (1 === h) return c = 0, s ? c = Math.PI / 2 : a ? c = Math.PI : u && (c = -Math.PI / 2), void this._basicSideRounded({
                                    x: e,
                                    y: r,
                                    size: n,
                                    rotation: c
                                });
                            }
                        } else this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawClassy = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.getNeighbor, i = o ? +o(-1, 0) : 0, a = o ? +o(1, 0) : 0, s = o ? +o(0, -1) : 0, u = o ? +o(0, 1) : 0;
                        0 !== i + a + s + u ? i || s ? a || u ? this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        }) : this._basicCornerRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        }) : this._basicCornerRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: -Math.PI / 2
                        }) : this._basicCornersRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        });
                    }, t.prototype._drawClassyRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.getNeighbor, i = o ? +o(-1, 0) : 0, a = o ? +o(1, 0) : 0, s = o ? +o(0, -1) : 0, u = o ? +o(0, 1) : 0;
                        0 !== i + a + s + u ? i || s ? a || u ? this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        }) : this._basicCornerExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        }) : this._basicCornerExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: -Math.PI / 2
                        }) : this._basicCornersRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        });
                    }, t;
                }();
                var d = function() {
                    return (d = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }).apply(this, arguments);
                };
                const f = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        var o;
                        switch(this._type){
                            case "square":
                                o = this._drawSquare;
                                break;
                            case "extra-rounded":
                                o = this._drawExtraRounded;
                                break;
                            case "dot":
                            default:
                                o = this._drawDot;
                        }
                        o.call(this, {
                            x: t,
                            y: e,
                            size: r,
                            rotation: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, o = t.size, i = t.rotation, a = void 0 === i ? 0 : i, s = r + o / 2, u = n + o / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y, i = r / 7;
                        this._rotateFigure(d(d({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + (n + r / 2) + " " + o + "a " + r / 2 + " " + r / 2 + " 0 1 0 0.1 0zm 0 " + i + "a " + (r / 2 - i) + " " + (r / 2 - i) + " 0 1 1 -0.1 0Z");
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y, i = r / 7;
                        this._rotateFigure(d(d({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + n + " " + o + "v " + r + "h " + r + "v " + -r + "zM " + (n + i) + " " + (o + i) + "h " + (r - 2 * i) + "v " + (r - 2 * i) + "h " + (2 * i - r) + "z");
                            }
                        }));
                    }, t.prototype._basicExtraRounded = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y, i = r / 7;
                        this._rotateFigure(d(d({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + n + " " + (o + 2.5 * i) + "v " + 2 * i + "a " + 2.5 * i + " " + 2.5 * i + ", 0, 0, 0, " + 2.5 * i + " " + 2.5 * i + "h " + 2 * i + "a " + 2.5 * i + " " + 2.5 * i + ", 0, 0, 0, " + 2.5 * i + " " + 2.5 * -i + "v " + -2 * i + "a " + 2.5 * i + " " + 2.5 * i + ", 0, 0, 0, " + 2.5 * -i + " " + 2.5 * -i + "h " + -2 * i + "a " + 2.5 * i + " " + 2.5 * i + ", 0, 0, 0, " + 2.5 * -i + " " + 2.5 * i + "M " + (n + 2.5 * i) + " " + (o + i) + "h " + 2 * i + "a " + 1.5 * i + " " + 1.5 * i + ", 0, 0, 1, " + 1.5 * i + " " + 1.5 * i + "v " + 2 * i + "a " + 1.5 * i + " " + 1.5 * i + ", 0, 0, 1, " + 1.5 * -i + " " + 1.5 * i + "h " + -2 * i + "a " + 1.5 * i + " " + 1.5 * i + ", 0, 0, 1, " + 1.5 * -i + " " + 1.5 * -i + "v " + -2 * i + "a " + 1.5 * i + " " + 1.5 * i + ", 0, 0, 1, " + 1.5 * i + " " + 1.5 * -i);
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.rotation;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: o
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.rotation;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: o
                        });
                    }, t.prototype._drawExtraRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.rotation;
                        this._basicExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: o
                        });
                    }, t;
                }();
                var g = function() {
                    return (g = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }).apply(this, arguments);
                };
                const p = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        var o;
                        switch(this._type){
                            case "square":
                                o = this._drawSquare;
                                break;
                            case "dot":
                            default:
                                o = this._drawDot;
                        }
                        o.call(this, {
                            x: t,
                            y: e,
                            size: r,
                            rotation: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, o = t.size, i = t.rotation, a = void 0 === i ? 0 : i, s = r + o / 2, u = n + o / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(g(g({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), e._element.setAttribute("cx", String(n + r / 2)), e._element.setAttribute("cy", String(o + r / 2)), e._element.setAttribute("r", String(r / 2));
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, o = t.y;
                        this._rotateFigure(g(g({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), e._element.setAttribute("x", String(n)), e._element.setAttribute("y", String(o)), e._element.setAttribute("width", String(r)), e._element.setAttribute("height", String(r));
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.rotation;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: o
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size, o = t.rotation;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: o
                        });
                    }, t;
                }(), v = "circle";
                var w = function(t, e, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function a(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(a, s);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, y = function(t, e) {
                    var r, n, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function s(i) {
                        return function(s) {
                            return function(i) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                                    switch(n = 0, o && (i = [
                                        2 & i[0],
                                        o.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            o = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < o[1]) {
                                                a.label = o[1], o = i;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(i);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = e.call(t, a);
                                } catch (t) {
                                    i = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = o = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                s
                            ]);
                        };
                    }
                }, m = [
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ]
                ], b = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                const _ = function() {
                    function t(t) {
                        this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("width", String(t.width)), this._element.setAttribute("height", String(t.height)), this._defs = document.createElementNS("http://www.w3.org/2000/svg", "defs"), this._element.appendChild(this._defs), this._options = t;
                    }
                    return Object.defineProperty(t.prototype, "width", {
                        get: function() {
                            return this._options.width;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "height", {
                        get: function() {
                            return this._options.height;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.getElement = function() {
                        return this._element;
                    }, t.prototype.drawQR = function(t) {
                        return w(this, void 0, void 0, function() {
                            var e, r, n, o, i, a, s, u, c, l, d = this;
                            return y(this, function(f) {
                                switch(f.label){
                                    case 0:
                                        return e = t.getModuleCount(), r = Math.min(this._options.width, this._options.height) - 2 * this._options.margin, n = this._options.shape === v ? r / Math.sqrt(2) : r, o = Math.floor(n / e), i = {
                                            hideXDots: 0,
                                            hideYDots: 0,
                                            width: 0,
                                            height: 0
                                        }, this._qr = t, this._options.image ? [
                                            4,
                                            this.loadImage()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        if (f.sent(), !this._image) return [
                                            2
                                        ];
                                        a = this._options, s = a.imageOptions, u = a.qrOptions, c = s.imageSize * h[u.errorCorrectionLevel], l = Math.floor(c * e * e), i = function(t) {
                                            var e = t.originalHeight, r = t.originalWidth, n = t.maxHiddenDots, o = t.maxHiddenAxisDots, i = t.dotSize, a = {
                                                x: 0,
                                                y: 0
                                            }, s = {
                                                x: 0,
                                                y: 0
                                            };
                                            if (e <= 0 || r <= 0 || n <= 0 || i <= 0) return {
                                                height: 0,
                                                width: 0,
                                                hideYDots: 0,
                                                hideXDots: 0
                                            };
                                            var u = e / r;
                                            return a.x = Math.floor(Math.sqrt(n / u)), a.x <= 0 && (a.x = 1), o && o < a.x && (a.x = o), a.x % 2 == 0 && a.x--, s.x = a.x * i, a.y = 1 + 2 * Math.ceil((a.x * u - 1) / 2), s.y = Math.round(s.x * u), (a.y * a.x > n || o && o < a.y) && (o && o < a.y ? (a.y = o, a.y % 2 == 0 && a.x--) : a.y -= 2, s.y = a.y * i, a.x = 1 + 2 * Math.ceil((a.y / u - 1) / 2), s.x = Math.round(s.y / u)), {
                                                height: s.y,
                                                width: s.x,
                                                hideYDots: a.y,
                                                hideXDots: a.x
                                            };
                                        }({
                                            originalWidth: this._image.width,
                                            originalHeight: this._image.height,
                                            maxHiddenDots: l,
                                            maxHiddenAxisDots: e - 14,
                                            dotSize: o
                                        }), f.label = 2;
                                    case 2:
                                        return this.drawBackground(), this.drawDots(function(t, r) {
                                            var n, o, a, s, u, h;
                                            return !(d._options.imageOptions.hideBackgroundDots && t >= (e - i.hideXDots) / 2 && t < (e + i.hideXDots) / 2 && r >= (e - i.hideYDots) / 2 && r < (e + i.hideYDots) / 2 || (null === (n = m[t]) || void 0 === n ? void 0 : n[r]) || (null === (o = m[t - e + 7]) || void 0 === o ? void 0 : o[r]) || (null === (a = m[t]) || void 0 === a ? void 0 : a[r - e + 7]) || (null === (s = b[t]) || void 0 === s ? void 0 : s[r]) || (null === (u = b[t - e + 7]) || void 0 === u ? void 0 : u[r]) || (null === (h = b[t]) || void 0 === h ? void 0 : h[r - e + 7]));
                                        }), this.drawCorners(), this._options.image ? [
                                            4,
                                            this.drawImage({
                                                width: i.width,
                                                height: i.height,
                                                count: e,
                                                dotSize: o
                                            })
                                        ] : [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        f.sent(), f.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype.drawBackground = function() {
                        var t, e, r, n = this._element, o = this._options;
                        if (n) {
                            var i = null === (t = o.backgroundOptions) || void 0 === t ? void 0 : t.gradient, a = null === (e = o.backgroundOptions) || void 0 === e ? void 0 : e.color;
                            if ((i || a) && this._createColor({
                                options: i,
                                color: a,
                                additionalRotation: 0,
                                x: 0,
                                y: 0,
                                height: o.height,
                                width: o.width,
                                name: "background-color"
                            }), null === (r = o.backgroundOptions) || void 0 === r ? void 0 : r.round) {
                                var s = Math.min(o.width, o.height), u = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                                this._backgroundClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._backgroundClipPath.setAttribute("id", "clip-path-background-color"), this._defs.appendChild(this._backgroundClipPath), u.setAttribute("x", String((o.width - s) / 2)), u.setAttribute("y", String((o.height - s) / 2)), u.setAttribute("width", String(s)), u.setAttribute("height", String(s)), u.setAttribute("rx", String(s / 2 * o.backgroundOptions.round)), this._backgroundClipPath.appendChild(u);
                            }
                        }
                    }, t.prototype.drawDots = function(t) {
                        var e, r, n = this;
                        if (!this._qr) throw "QR code is not defined";
                        var o = this._options, i = this._qr.getModuleCount();
                        if (i > o.width || i > o.height) throw "The canvas is too small.";
                        var a = Math.min(o.width, o.height) - 2 * o.margin, s = o.shape === v ? a / Math.sqrt(2) : a, u = Math.floor(s / i), h = Math.floor((o.width - i * u) / 2), c = Math.floor((o.height - i * u) / 2), d = new l({
                            svg: this._element,
                            type: o.dotsOptions.type
                        });
                        this._dotsClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._dotsClipPath.setAttribute("id", "clip-path-dot-color"), this._defs.appendChild(this._dotsClipPath), this._createColor({
                            options: null === (e = o.dotsOptions) || void 0 === e ? void 0 : e.gradient,
                            color: o.dotsOptions.color,
                            additionalRotation: 0,
                            x: 0,
                            y: 0,
                            height: o.height,
                            width: o.width,
                            name: "dot-color"
                        });
                        for(var f = function(e) {
                            for(var o = function(o) {
                                return t && !t(e, o) ? "continue" : (null === (r = g._qr) || void 0 === r ? void 0 : r.isDark(e, o)) ? (d.draw(h + e * u, c + o * u, u, function(r, a) {
                                    return !(e + r < 0 || o + a < 0 || e + r >= i || o + a >= i) && !(t && !t(e + r, o + a)) && !!n._qr && n._qr.isDark(e + r, o + a);
                                }), void (d._element && g._dotsClipPath && g._dotsClipPath.appendChild(d._element))) : "continue";
                            }, a = 0; a < i; a++)o(a);
                        }, g = this, p = 0; p < i; p++)f(p);
                        if (o.shape === v) {
                            var w = Math.floor((a / u - i) / 2), y = i + 2 * w, m = h - w * u, b = c - w * u, _ = [], x = Math.floor(y / 2);
                            for(p = 0; p < y; p++){
                                _[p] = [];
                                for(var S = 0; S < y; S++)p >= w - 1 && p <= y - w && S >= w - 1 && S <= y - w || Math.sqrt((p - x) * (p - x) + (S - x) * (S - x)) > x ? _[p][S] = 0 : _[p][S] = this._qr.isDark(S - 2 * w < 0 ? S : S >= i ? S - 2 * w : S - w, p - 2 * w < 0 ? p : p >= i ? p - 2 * w : p - w) ? 1 : 0;
                            }
                            var M = function(t) {
                                for(var e = function(e) {
                                    if (!_[t][e]) return "continue";
                                    d.draw(m + t * u, b + e * u, u, function(r, n) {
                                        var o;
                                        return !!(null === (o = _[t + r]) || void 0 === o ? void 0 : o[e + n]);
                                    }), d._element && C._dotsClipPath && C._dotsClipPath.appendChild(d._element);
                                }, r = 0; r < y; r++)e(r);
                            }, C = this;
                            for(p = 0; p < y; p++)M(p);
                        }
                    }, t.prototype.drawCorners = function() {
                        var t = this;
                        if (!this._qr) throw "QR code is not defined";
                        var e = this._element, r = this._options;
                        if (!e) throw "Element code is not defined";
                        var n = this._qr.getModuleCount(), o = Math.min(r.width, r.height) - 2 * r.margin, i = r.shape === v ? o / Math.sqrt(2) : o, a = Math.floor(i / n), s = 7 * a, u = 3 * a, h = Math.floor((r.width - n * a) / 2), c = Math.floor((r.height - n * a) / 2);
                        [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                1,
                                0,
                                Math.PI / 2
                            ],
                            [
                                0,
                                1,
                                -Math.PI / 2
                            ]
                        ].forEach(function(e) {
                            var o, i, d, g, v, w, y, _, x, S, M, C, A = e[0], k = e[1], O = e[2], D = h + A * a * (n - 7), P = c + k * a * (n - 7), z = t._dotsClipPath, B = t._dotsClipPath;
                            if (((null === (o = r.cornersSquareOptions) || void 0 === o ? void 0 : o.gradient) || (null === (i = r.cornersSquareOptions) || void 0 === i ? void 0 : i.color)) && ((z = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-square-color-" + A + "-" + k), t._defs.appendChild(z), t._cornersSquareClipPath = t._cornersDotClipPath = B = z, t._createColor({
                                options: null === (d = r.cornersSquareOptions) || void 0 === d ? void 0 : d.gradient,
                                color: null === (g = r.cornersSquareOptions) || void 0 === g ? void 0 : g.color,
                                additionalRotation: O,
                                x: D,
                                y: P,
                                height: s,
                                width: s,
                                name: "corners-square-color-" + A + "-" + k
                            })), null === (v = r.cornersSquareOptions) || void 0 === v ? void 0 : v.type) {
                                var q = new f({
                                    svg: t._element,
                                    type: r.cornersSquareOptions.type
                                });
                                q.draw(D, P, s, O), q._element && z && z.appendChild(q._element);
                            } else for(var I = new l({
                                svg: t._element,
                                type: r.dotsOptions.type
                            }), E = function(t) {
                                for(var e = function(e) {
                                    if (!(null === (w = m[t]) || void 0 === w ? void 0 : w[e])) return "continue";
                                    I.draw(D + t * a, P + e * a, a, function(r, n) {
                                        var o;
                                        return !!(null === (o = m[t + r]) || void 0 === o ? void 0 : o[e + n]);
                                    }), I._element && z && z.appendChild(I._element);
                                }, r = 0; r < m[t].length; r++)e(r);
                            }, L = 0; L < m.length; L++)E(L);
                            if (((null === (y = r.cornersDotOptions) || void 0 === y ? void 0 : y.gradient) || (null === (_ = r.cornersDotOptions) || void 0 === _ ? void 0 : _.color)) && ((B = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-dot-color-" + A + "-" + k), t._defs.appendChild(B), t._cornersDotClipPath = B, t._createColor({
                                options: null === (x = r.cornersDotOptions) || void 0 === x ? void 0 : x.gradient,
                                color: null === (S = r.cornersDotOptions) || void 0 === S ? void 0 : S.color,
                                additionalRotation: O,
                                x: D + 2 * a,
                                y: P + 2 * a,
                                height: u,
                                width: u,
                                name: "corners-dot-color-" + A + "-" + k
                            })), null === (M = r.cornersDotOptions) || void 0 === M ? void 0 : M.type) {
                                var R = new p({
                                    svg: t._element,
                                    type: r.cornersDotOptions.type
                                });
                                R.draw(D + 2 * a, P + 2 * a, u, O), R._element && B && B.appendChild(R._element);
                            } else {
                                I = new l({
                                    svg: t._element,
                                    type: r.dotsOptions.type
                                });
                                var N = function(t) {
                                    for(var e = function(e) {
                                        if (!(null === (C = b[t]) || void 0 === C ? void 0 : C[e])) return "continue";
                                        I.draw(D + t * a, P + e * a, a, function(r, n) {
                                            var o;
                                            return !!(null === (o = b[t + r]) || void 0 === o ? void 0 : o[e + n]);
                                        }), I._element && B && B.appendChild(I._element);
                                    }, r = 0; r < b[t].length; r++)e(r);
                                };
                                for(L = 0; L < b.length; L++)N(L);
                            }
                        });
                    }, t.prototype.loadImage = function() {
                        var t = this;
                        return new Promise(function(e, r) {
                            var n = t._options, o = new Image;
                            if (!n.image) return r("Image is not defined");
                            "string" == typeof n.imageOptions.crossOrigin && (o.crossOrigin = n.imageOptions.crossOrigin), t._image = o, o.onload = function() {
                                e();
                            }, o.src = n.image;
                        });
                    }, t.prototype.drawImage = function(t) {
                        var e = t.width, r = t.height, n = t.count, o = t.dotSize;
                        return w(this, void 0, void 0, function() {
                            var t, i, a, s, h, c, l, d, f;
                            return y(this, function(g) {
                                switch(g.label){
                                    case 0:
                                        return t = this._options, i = Math.floor((t.width - n * o) / 2), a = Math.floor((t.height - n * o) / 2), s = i + t.imageOptions.margin + (n * o - e) / 2, h = a + t.imageOptions.margin + (n * o - r) / 2, c = e - 2 * t.imageOptions.margin, l = r - 2 * t.imageOptions.margin, (d = document.createElementNS("http://www.w3.org/2000/svg", "image")).setAttribute("x", String(s)), d.setAttribute("y", String(h)), d.setAttribute("width", c + "px"), d.setAttribute("height", l + "px"), [
                                            4,
                                            u(t.image || "")
                                        ];
                                    case 1:
                                        return f = g.sent(), d.setAttribute("href", f || ""), this._element.appendChild(d), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype._createColor = function(t) {
                        var e = t.options, r = t.color, n = t.additionalRotation, o = t.x, i = t.y, a = t.height, s = t.width, u = t.name, h = s > a ? s : a, c = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                        if (c.setAttribute("x", String(o)), c.setAttribute("y", String(i)), c.setAttribute("height", String(a)), c.setAttribute("width", String(s)), c.setAttribute("clip-path", "url('#clip-path-" + u + "')"), e) {
                            var l;
                            if ("radial" === e.type) (l = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient")).setAttribute("id", u), l.setAttribute("gradientUnits", "userSpaceOnUse"), l.setAttribute("fx", String(o + s / 2)), l.setAttribute("fy", String(i + a / 2)), l.setAttribute("cx", String(o + s / 2)), l.setAttribute("cy", String(i + a / 2)), l.setAttribute("r", String(h / 2));
                            else {
                                var d = ((e.rotation || 0) + n) % (2 * Math.PI), f = (d + 2 * Math.PI) % (2 * Math.PI), g = o + s / 2, p = i + a / 2, v = o + s / 2, w = i + a / 2;
                                f >= 0 && f <= .25 * Math.PI || f > 1.75 * Math.PI && f <= 2 * Math.PI ? (g -= s / 2, p -= a / 2 * Math.tan(d), v += s / 2, w += a / 2 * Math.tan(d)) : f > .25 * Math.PI && f <= .75 * Math.PI ? (p -= a / 2, g -= s / 2 / Math.tan(d), w += a / 2, v += s / 2 / Math.tan(d)) : f > .75 * Math.PI && f <= 1.25 * Math.PI ? (g += s / 2, p += a / 2 * Math.tan(d), v -= s / 2, w -= a / 2 * Math.tan(d)) : f > 1.25 * Math.PI && f <= 1.75 * Math.PI && (p += a / 2, g += s / 2 / Math.tan(d), w -= a / 2, v -= s / 2 / Math.tan(d)), (l = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient")).setAttribute("id", u), l.setAttribute("gradientUnits", "userSpaceOnUse"), l.setAttribute("x1", String(Math.round(g))), l.setAttribute("y1", String(Math.round(p))), l.setAttribute("x2", String(Math.round(v))), l.setAttribute("y2", String(Math.round(w)));
                            }
                            e.colorStops.forEach(function(t) {
                                var e = t.offset, r = t.color, n = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                                n.setAttribute("offset", 100 * e + "%"), n.setAttribute("stop-color", r), l.appendChild(n);
                            }), c.setAttribute("fill", "url('#" + u + "')"), this._defs.appendChild(l);
                        } else r && c.setAttribute("fill", r);
                        this._element.appendChild(c);
                    }, t;
                }(), x = "canvas";
                for(var S = {}, M = 0; M <= 40; M++)S[M] = M;
                const C = {
                    type: x,
                    shape: "square",
                    width: 300,
                    height: 300,
                    data: "",
                    margin: 0,
                    qrOptions: {
                        typeNumber: S[0],
                        mode: void 0,
                        errorCorrectionLevel: "Q"
                    },
                    imageOptions: {
                        hideBackgroundDots: !0,
                        imageSize: .4,
                        crossOrigin: void 0,
                        margin: 0
                    },
                    dotsOptions: {
                        type: "square",
                        color: "#000"
                    },
                    backgroundOptions: {
                        round: 0,
                        color: "#fff"
                    }
                };
                var A = function() {
                    return (A = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }).apply(this, arguments);
                };
                function k(t) {
                    var e = A({}, t);
                    if (!e.colorStops || !e.colorStops.length) throw "Field 'colorStops' is required in gradient";
                    return e.rotation ? e.rotation = Number(e.rotation) : e.rotation = 0, e.colorStops = e.colorStops.map(function(t) {
                        return A(A({}, t), {
                            offset: Number(t.offset)
                        });
                    }), e;
                }
                function O(t) {
                    var e = A({}, t);
                    return e.width = Number(e.width), e.height = Number(e.height), e.margin = Number(e.margin), e.imageOptions = A(A({}, e.imageOptions), {
                        hideBackgroundDots: Boolean(e.imageOptions.hideBackgroundDots),
                        imageSize: Number(e.imageOptions.imageSize),
                        margin: Number(e.imageOptions.margin)
                    }), e.margin > Math.min(e.width, e.height) && (e.margin = Math.min(e.width, e.height)), e.dotsOptions = A({}, e.dotsOptions), e.dotsOptions.gradient && (e.dotsOptions.gradient = k(e.dotsOptions.gradient)), e.cornersSquareOptions && (e.cornersSquareOptions = A({}, e.cornersSquareOptions), e.cornersSquareOptions.gradient && (e.cornersSquareOptions.gradient = k(e.cornersSquareOptions.gradient))), e.cornersDotOptions && (e.cornersDotOptions = A({}, e.cornersDotOptions), e.cornersDotOptions.gradient && (e.cornersDotOptions.gradient = k(e.cornersDotOptions.gradient))), e.backgroundOptions && (e.backgroundOptions = A({}, e.backgroundOptions), e.backgroundOptions.gradient && (e.backgroundOptions.gradient = k(e.backgroundOptions.gradient))), e;
                }
                var D = r(192), P = r.n(D), z = function(t, e, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function a(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(a, s);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, B = function(t, e) {
                    var r, n, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function s(i) {
                        return function(s) {
                            return function(i) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                                    switch(n = 0, o && (i = [
                                        2 & i[0],
                                        o.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            o = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < o[1]) {
                                                a.label = o[1], o = i;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(i);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = e.call(t, a);
                                } catch (t) {
                                    i = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = o = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                s
                            ]);
                        };
                    }
                };
                const q = function() {
                    function t(t) {
                        this._options = t ? O(a(C, t)) : C, this.update();
                    }
                    return t._clearContainer = function(t) {
                        t && (t.innerHTML = "");
                    }, t.prototype._setupSvg = function() {
                        var t = this;
                        if (this._qr) {
                            var e = new _(this._options);
                            this._svg = e.getElement(), this._svgDrawingPromise = e.drawQR(this._qr).then(function() {
                                var r;
                                t._svg && (null === (r = t._extension) || void 0 === r || r.call(t, e.getElement(), t._options));
                            });
                        }
                    }, t.prototype._setupCanvas = function() {
                        var t, e = this;
                        this._qr && (this._canvas = document.createElement("canvas"), this._canvas.width = this._options.width, this._canvas.height = this._options.height, this._setupSvg(), this._canvasDrawingPromise = null === (t = this._svgDrawingPromise) || void 0 === t ? void 0 : t.then(function() {
                            if (e._svg) {
                                var t = e._svg, r = (new XMLSerializer).serializeToString(t), n = "data:image/svg+xml;base64," + btoa(r), o = new Image;
                                return new Promise(function(t) {
                                    o.onload = function() {
                                        var r, n;
                                        null === (n = null === (r = e._canvas) || void 0 === r ? void 0 : r.getContext("2d")) || void 0 === n || n.drawImage(o, 0, 0), t();
                                    }, o.src = n;
                                });
                            }
                        }));
                    }, t.prototype._getElement = function(t) {
                        return void 0 === t && (t = "png"), z(this, void 0, void 0, function() {
                            return B(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return "svg" !== t.toLowerCase() ? [
                                            3,
                                            2
                                        ] : (this._svg && this._svgDrawingPromise || this._setupSvg(), [
                                            4,
                                            this._svgDrawingPromise
                                        ]);
                                    case 1:
                                        return e.sent(), [
                                            2,
                                            this._svg
                                        ];
                                    case 2:
                                        return this._canvas && this._canvasDrawingPromise || this._setupCanvas(), [
                                            4,
                                            this._canvasDrawingPromise
                                        ];
                                    case 3:
                                        return e.sent(), [
                                            2,
                                            this._canvas
                                        ];
                                }
                            });
                        });
                    }, t.prototype.update = function(e) {
                        t._clearContainer(this._container), this._options = e ? O(a(this._options, e)) : this._options, this._options.data && (this._qr = P()(this._options.qrOptions.typeNumber, this._options.qrOptions.errorCorrectionLevel), this._qr.addData(this._options.data, this._options.qrOptions.mode || function(t) {
                            switch(!0){
                                case /^[0-9]*$/.test(t):
                                    return "Numeric";
                                case /^[0-9A-Z $%*+\-./:]*$/.test(t):
                                    return "Alphanumeric";
                                default:
                                    return "Byte";
                            }
                        }(this._options.data)), this._qr.make(), this._options.type === x ? this._setupCanvas() : this._setupSvg(), this.append(this._container));
                    }, t.prototype.append = function(t) {
                        if (t) {
                            if ("function" != typeof t.appendChild) throw "Container should be a single DOM node";
                            this._options.type === x ? this._canvas && t.appendChild(this._canvas) : this._svg && t.appendChild(this._svg), this._container = t;
                        }
                    }, t.prototype.applyExtension = function(t) {
                        if (!t) throw "Extension function should be defined.";
                        this._extension = t, this.update();
                    }, t.prototype.deleteExtension = function() {
                        this._extension = void 0, this.update();
                    }, t.prototype.getRawData = function(t) {
                        return void 0 === t && (t = "png"), z(this, void 0, void 0, function() {
                            var e, r, n;
                            return B(this, function(o) {
                                switch(o.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return [
                                            4,
                                            this._getElement(t)
                                        ];
                                    case 1:
                                        return (e = o.sent()) ? "svg" === t.toLowerCase() ? (r = new XMLSerializer, n = r.serializeToString(e), [
                                            2,
                                            new Blob([
                                                '<?xml version="1.0" standalone="no"?>\r\n' + n
                                            ], {
                                                type: "image/svg+xml"
                                            })
                                        ]) : [
                                            2,
                                            new Promise(function(r) {
                                                return e.toBlob(r, "image/" + t, 1);
                                            })
                                        ] : [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                    }, t.prototype.download = function(t) {
                        return z(this, void 0, void 0, function() {
                            var e, r, n, o, i;
                            return B(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return e = "png", r = "qr", "string" == typeof t ? (e = t, console.warn("Extension is deprecated as argument for 'download' method, please pass object { name: '...', extension: '...' } as argument")) : "object" == typeof t && null !== t && (t.name && (r = t.name), t.extension && (e = t.extension)), [
                                            4,
                                            this._getElement(e)
                                        ];
                                    case 1:
                                        return (n = a.sent()) ? ("svg" === e.toLowerCase() ? (o = new XMLSerializer, i = '<?xml version="1.0" standalone="no"?>\r\n' + (i = o.serializeToString(n)), s("data:image/svg+xml;charset=utf-8," + encodeURIComponent(i), r + ".svg")) : s(n.toDataURL("image/" + e), r + "." + e), [
                                            2
                                        ]) : [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t;
                }();
            }
        }, e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
                exports: {}
            };
            return t[n](o, o.exports, r), o.exports;
        }
        return r.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return r.d(e, {
                a: e
            }), e;
        }, r.d = (t, e)=>{
            for(var n in e)r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), r(676);
    })().default;
});


var $1c20129566e1ba0b$exports = {};
$1c20129566e1ba0b$exports = $parcel$resolve("9QdzW");


var $ac2797b5bbc5350a$exports = {};
$ac2797b5bbc5350a$exports = $parcel$resolve("6YVjm");


var $f6ad70429dc80df2$exports = {};
$f6ad70429dc80df2$exports = $parcel$resolve("lFOja");


const $5b3bbf73e4bcc8de$export$d5b925c9bda2a95f = (data, noStyle)=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [qrBase64, setQRBase64] = (0, $7fPBF.useState)("");
    const pWhiteImage = new URL($1c20129566e1ba0b$exports).href;
    const pBlackImage = new URL($ac2797b5bbc5350a$exports).href;
    const pBlackAndWhite = new URL($f6ad70429dc80df2$exports).href;
    const qrOptions = {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "M"
    };
    const dotsOptions = {
        type: noStyle ? "square" : "rounded",
        color: noStyle ? "black" : theme.palette.primary.main
    };
    const backgroundOptions = {
        color: noStyle ? "white" : theme.palette.colors?.qrCodeBackground
    };
    const cornersSquareOptions = {
        type: noStyle ? "square" : "extra-rounded",
        color: noStyle ? "black" : theme.palette.primary.main
    };
    const cornersDotOptions = {
        type: noStyle ? "square" : "dot",
        color: noStyle ? "black" : theme.palette.primary.main
    };
    const imageOptions = {
        hideBackgroundDots: true,
        imageSize: 0.5,
        margin: 0
    };
    const blobToBase64 = async (blob)=>{
        return new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };
    const qrCode = new (0, (/*@__PURE__*/$parcel$interopDefault($145a83a98778bf73$exports)))({
        width: 1000,
        height: 1000,
        margin: 20,
        image: noStyle ? pBlackAndWhite : theme.palette.mode == "light" ? pWhiteImage : pBlackImage,
        qrOptions: qrOptions,
        imageOptions: imageOptions,
        dotsOptions: dotsOptions,
        backgroundOptions: backgroundOptions,
        cornersSquareOptions: cornersSquareOptions,
        cornersDotOptions: cornersDotOptions
    });
    (0, $7fPBF.useEffect)(()=>{
        setQRBase64("");
        if (data == "") return;
        qrCode.update({
            data: data
        });
        qrCode.getRawData("png").then((blob)=>{
            if (!blob) return;
            blobToBase64(blob).then((result)=>{
                if (!result || result instanceof ArrayBuffer) return;
                setQRBase64(result.split(",")[1]);
            });
        });
    }, [
        data,
        noStyle
    ]);
    return qrBase64;
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");




function $fa82c24039cb02ec$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $fa82c24039cb02ec$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $fa82c24039cb02ec$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $fa82c24039cb02ec$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $fa82c24039cb02ec$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $fa82c24039cb02ec$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $fa82c24039cb02ec$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}






function $9766df26003dc3cf$export$c987db9fc844f86(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSkeleton', slot);
}
const $9766df26003dc3cf$var$skeletonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $9766df26003dc3cf$export$2e2bcd8739ae039 = $9766df26003dc3cf$var$skeletonClasses;



'use client';
const $76ada7aef489324c$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $76ada7aef489324c$var$_ = (t)=>t, $76ada7aef489324c$var$_t, $76ada7aef489324c$var$_t2, $76ada7aef489324c$var$_t3, $76ada7aef489324c$var$_t4;
const $76ada7aef489324c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $9766df26003dc3cf$export$c987db9fc844f86), classes);
};
const $76ada7aef489324c$var$pulseKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($76ada7aef489324c$var$_t || ($76ada7aef489324c$var$_t = $76ada7aef489324c$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $76ada7aef489324c$var$waveKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($76ada7aef489324c$var$_t2 || ($76ada7aef489324c$var$_t2 = $76ada7aef489324c$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $76ada7aef489324c$var$SkeletonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $fa82c24039cb02ec$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $fa82c24039cb02ec$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($76ada7aef489324c$var$_t3 || ($76ada7aef489324c$var$_t3 = $76ada7aef489324c$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $76ada7aef489324c$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($76ada7aef489324c$var$_t4 || ($76ada7aef489324c$var$_t4 = $76ada7aef489324c$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $76ada7aef489324c$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $76ada7aef489324c$var$Skeleton = /*#__PURE__*/ $7fPBF.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $76ada7aef489324c$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $76ada7aef489324c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($76ada7aef489324c$var$SkeletonRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            width: width,
            height: height
        }, style)
    }));
});
var $76ada7aef489324c$export$2e2bcd8739ae039 = $76ada7aef489324c$var$Skeleton;


var $716ffc2abd28b43e$exports = {};

$parcel$export($716ffc2abd28b43e$exports, "content", function () { return $716ffc2abd28b43e$export$a7db06668cad9adb; }, function (v) { return $716ffc2abd28b43e$export$a7db06668cad9adb = v; });
$parcel$export($716ffc2abd28b43e$exports, "message", function () { return $716ffc2abd28b43e$export$a8ecead220dd38a6; }, function (v) { return $716ffc2abd28b43e$export$a8ecead220dd38a6 = v; });
$parcel$export($716ffc2abd28b43e$exports, "toolbarBox", function () { return $716ffc2abd28b43e$export$6e129a9598cc724e; }, function (v) { return $716ffc2abd28b43e$export$6e129a9598cc724e = v; });
var $716ffc2abd28b43e$export$a7db06668cad9adb;
var $716ffc2abd28b43e$export$a8ecead220dd38a6;
var $716ffc2abd28b43e$export$6e129a9598cc724e;
$716ffc2abd28b43e$export$a7db06668cad9adb = `JgljTW_content`;
$716ffc2abd28b43e$export$a8ecead220dd38a6 = `JgljTW_message`;
$716ffc2abd28b43e$export$6e129a9598cc724e = `JgljTW_toolbarBox`;




var $4790ed25bc1bcdfa$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($4790ed25bc1bcdfa$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $4790ed25bc1bcdfa$exports = g;
});





var $bdjQ6 = parcelRequire("bdjQ6");




const $5e366bf10703ef59$export$d85e1122ca9efc5f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getImageSignedUrl = async (name)=>{
        const cachedImage = await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.getCachedImage(name);
        if (cachedImage) return {
            status: (0, $74d09775b34cce5b$export$efd5569f873811b1).OK,
            body: cachedImage
        };
        else {
            const { status: status, body: body } = await get("images/signedUrl", {
                name: name
            });
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.saveImage(name, body);
            return {
                status: status,
                body: body
            };
        }
    };
    return {
        getImageSignedUrl: getImageSignedUrl
    };
};





const $b13b03cfea5b48d2$export$688f021bd576577 = ({ isPublic: isPublic, uuid: uuid, title: title, message: message, isOpen: isOpen, setIsOpen: setIsOpen, image: image, filename: filename, onStyleButtonClicked: onStyleButtonClicked })=>{
    const [styleToggle, setStyleToggle] = (0, $7fPBF.useState)(true);
    const [isLoadingDownload, setIsLoadingDownload] = (0, $7fPBF.useState)(false);
    const { getImageSignedUrl: getImageSignedUrl } = (0, $5e366bf10703ef59$export$d85e1122ca9efc5f)();
    const downloadImage = async ()=>{
        if (!image) return;
        if (isPublic) {
            const buffer = (0, $bdjQ6.Buffer).from(image, "base64");
            const blob = new Blob([
                new Uint8Array(buffer)
            ], {
                type: "image/png"
            });
            (0, $4790ed25bc1bcdfa$exports.saveAs)(blob, filename);
        } else await startDownload();
    };
    const startDownload = async ()=>{
        setIsLoadingDownload(true);
        const { status: status, body: body } = await getImageSignedUrl(uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) (0, $4790ed25bc1bcdfa$exports.saveAs)(body, filename);
        setIsLoadingDownload(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($716ffc2abd28b43e$exports))).toolbarBox,
                        children: [
                            onStyleButtonClicked && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).toggle_style,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Palette,
                                filled: styleToggle,
                                onClick: ()=>{
                                    setStyleToggle((state)=>!state);
                                    onStyleButtonClicked();
                                }
                            }),
                            onStyleButtonClicked && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                orientation: "vertical",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                onClick: ()=>downloadImage(),
                                loading: isLoadingDownload,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).download,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Download
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                orientation: "vertical",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                onClick: ()=>setIsOpen(false),
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                loading: !image,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($716ffc2abd28b43e$exports))).content,
                children: [
                    message && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($716ffc2abd28b43e$exports))).message,
                        children: message
                    }),
                    image ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        alt: "image",
                        image: image,
                        defaultImage: image,
                        canMagnify: true
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            aspectRatio: "1",
                            height: "auto"
                        }
                    })
                ]
            })
        ]
    });
};




const $bed6df3ee0929f14$export$cc4cb9d785f3b827 = (fileName)=>{
    const [qrCodeTitle, setQRCodeTitle] = (0, $7fPBF.useState)("");
    const [qrCodeMessage, setQRCodeMessage] = (0, $7fPBF.useState)("");
    const [qrCodeData, setQRCodeData] = (0, $7fPBF.useState)("");
    const [qrCodeWithoutStyle, setQRCodeWithoutStyle] = (0, $7fPBF.useState)(false);
    const qrBase64 = (0, $5b3bbf73e4bcc8de$export$d5b925c9bda2a95f)(qrCodeData, qrCodeWithoutStyle);
    const [isImageDetailDialogOpen, setIsImageDetailDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const { getPrivateLink: getPrivateLink } = (0, $19e5276cf99ccb6e$export$2c6b92c80f456539)();
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const fetchShareLink = async (collectionId, albumId)=>{
        setIsLoading(true);
        const { status: status, body: body } = await getShareLink({
            albumId: albumId,
            collectionId: collectionId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setQRCodeTitle((0, $37bec70ed65ed924$export$21c51bc433c16634).qr_code_public_title);
            setQRCodeMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).qr_code_public_message);
            processLink(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
            setIsLoading(false);
        }
    };
    const fetchPrivateLink = async (albumId)=>{
        setIsLoading(true);
        const { status: status, body: body } = await getPrivateLink({
            albumId: albumId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setQRCodeTitle((0, $37bec70ed65ed924$export$21c51bc433c16634).qr_code_private_title);
            setQRCodeMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).qr_code_private_message);
            processLink(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
            setIsLoading(false);
        }
    };
    const processLink = (body)=>{
        const shareLink = body.shareLink;
        (0, (/*@__PURE__*/$parcel$interopDefault($9efca8d7db7deffa$exports)))(shareLink);
        setQRCodeData(shareLink);
        setIsImageDetailDialogOpen(true);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).share_link_notification);
    };
    const shareLinkComponents = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b13b03cfea5b48d2$export$688f021bd576577), {
                    isPublic: true,
                    uuid: qrBase64,
                    title: qrCodeTitle,
                    message: qrCodeMessage,
                    isOpen: isImageDetailDialogOpen,
                    setIsOpen: (isOpen)=>{
                        if (!isOpen) setIsLoading(false);
                        setIsImageDetailDialogOpen(isOpen);
                    },
                    image: qrBase64,
                    filename: `QR-${fileName}.png`,
                    onStyleButtonClicked: ()=>setQRCodeWithoutStyle((state)=>!state)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                    message: alertMessage,
                    open: isAlertOpen,
                    setOpen: setIsAlertOpen
                })
            ]
        });
    return [
        shareLinkComponents,
        fetchShareLink,
        fetchPrivateLink,
        isLoading
    ];
};





const $dcddb67333294827$export$7579a5b4bf37ae6f = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbum = (parameters)=>deleteRequest("albums", parameters);
    return {
        deleteAlbum: deleteAlbum
    };
};




const $a41b2b51b84e686f$export$6e059a7e11b5975e = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumToBoxSet = (parameters)=>put("boxSets", parameters);
    return {
        addAlbumToBoxSet: addAlbumToBoxSet
    };
};



const $2e8286f94e8feada$export$707988506c253900 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderBoxSetAlbums = (boxSetAlbumId, boxSetAlbums)=>{
        const sortedUuids = boxSetAlbums.map((boxSetAlbum)=>boxSetAlbum.albumId);
        return post("boxSets/reorder", {
            boxSetAlbumId: boxSetAlbumId,
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderBoxSetAlbums: reorderBoxSetAlbums
    };
};



const $30c0373d7beeeeba$export$6a176bd51c16112b = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const removeAlbumFromBoxSet = (parameters)=>deleteRequest("boxSets", parameters);
    return {
        removeAlbumFromBoxSet: removeAlbumFromBoxSet
    };
};




const $00bb9c939a9b16c4$export$44e38f87d0f6eb89 = ()=>{
    const openInNewTab = (url)=>{
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };
    const openInSameTab = (url)=>{
        window.open(url, "_self");
    };
    return {
        openInNewTab: openInNewTab,
        openInSameTab: openInSameTab
    };
};





const $31bf917e4d2874f2$export$2a7b51d5dc98980 = ({ isPublic: isPublic, className: className, buttonClassName: buttonClassName, style: style, album: album, userEvent: userEvent, onCopy: onCopy, onPlayFromYouTube: onPlayFromYouTube, onMarkAs: onMarkAs, onOpenInLayout: onOpenInLayout, onDelete: onDelete, onDeleteFromBoxSet: onDeleteFromBoxSet, isForLayout: isForLayout, isBoxSetAlbum: isBoxSetAlbum, boxSetAlbumId: boxSetAlbumId, setExternalLoading: setExternalLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const isPiperiOSApp = (0, $e0f71d8009cff55c$export$5d9aa80f0e322840)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const { getCurrentCollection: getCurrentCollection, isCurrentCollectionShareable: isCurrentCollectionShareable } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const { getCurrentIsNegated: getCurrentIsNegated } = (0, $228a7d38c61fd0fd$export$1fa08d0344d4319f)(isForLayout);
    const [qrFilename, setQRFilename] = (0, $7fPBF.useState)("");
    const { deleteAlbum: deleteAlbum } = (0, $dcddb67333294827$export$7579a5b4bf37ae6f)();
    const { removeAlbumFromBoxSet: removeAlbumFromBoxSet } = (0, $30c0373d7beeeeba$export$6a176bd51c16112b)();
    const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = (0, $7fPBF.useState)(false);
    const [isOpenDeleteFromBoxSetConfirmation, setIsOpenDeleteFromBoxSetConfirmation] = (0, $7fPBF.useState)(false);
    const [shareLinkComponents, fetchShareLink, fetchPrivateLink, isShareLoading] = (0, $bed6df3ee0929f14$export$cc4cb9d785f3b827)(qrFilename);
    const getVideoIds = (0, $935530e1b4d603d2$export$3a220a9dac4bee11)();
    const { getPrivateLink: getPrivateLink } = (0, $19e5276cf99ccb6e$export$2c6b92c80f456539)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    (0, $7fPBF.useEffect)(()=>{
        if (!userEvent || isShareLoading) return;
        handleContextMenu(userEvent);
    }, [
        userEvent
    ]);
    (0, $7fPBF.useEffect)(()=>setLoading(isShareLoading), [
        isShareLoading
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (setExternalLoading) setExternalLoading(loading);
    }, [
        loading
    ]);
    const { menuProps: reservedMenuProps, handleContextMenu: reservedHandleContextMenu, handleMenuClose: reservedHandleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const shareAlbum = async ()=>{
        const collectionId = getCurrentCollection(isPublic)?.uuid;
        if (!collectionId) return;
        setQRFilename(album.name);
        await fetchShareLink(collectionId, album.uuid);
    };
    const playFromYouTube = async ()=>{
        if (!album.trackList) return;
        setLoading(true);
        const videoIds = await getVideoIds(album.trackList, album.name, album.artist?.name);
        setLoading(false);
        if (videoIds.length > 0) onPlayFromYouTube?.(videoIds);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).player_unknown_error);
    };
    const openOnDiscogs = ()=>{
        if (!album.discogsReleaseId) return;
        openInNewTab(`https://www.discogs.com/release/${album.discogsReleaseId}`);
    };
    const openOnPrivateCollection = async ()=>{
        setLoading(true);
        const { status: status, body: body } = await getPrivateLink({
            albumId: album.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) openInNewTab(body.shareLink);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
        setLoading(false);
    };
    const { openInNewTab: openInNewTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical,
                onClick: handleContextMenu,
                loading: loading || isShareLoading,
                buttonClassName: buttonClassName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    isForLayout && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onOpenInLayout();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Shelves
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_layout
                        ]
                    }, "OpenInLayout"),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setQRFilename(album.name);
                            fetchPrivateLink(album.uuid).then();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).get_private_link
                        ]
                    }, "PrivateLink"),
                    isCurrentCollectionShareable(isPublic) && !isBoxSetAlbum && (isPublic || !getCurrentIsNegated().collectionId) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            shareAlbum().then();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Share
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).share_album
                        ]
                    }, "Share"),
                    !isForLayout && !isBoxSetAlbum && onCopy && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            onCopy?.();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).TabInactive
                                })
                            }),
                            album.isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).copy_box_set : (0, $37bec70ed65ed924$export$21c51bc433c16634).copy_album
                        ]
                    }, "Copy"),
                    onMarkAs && !isPublic && !isForLayout && (album.sellStatus ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            onMarkAs(null);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeepOff
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_mark_title
                        ]
                    }, "RemoveMark") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: reservedHandleContextMenu,
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Keep
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).mark_as_title
                        ]
                    }, "AddMark")),
                    !isMobile && album.trackList && album.trackList.length > 0 && onPlayFromYouTube && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await playFromYouTube();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PlayCircle
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).play_from_youtube
                        ]
                    }, "Play"),
                    album.discogsReleaseId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openOnDiscogs();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).OpenInNew
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_discogs
                        ]
                    }, "Discogs"),
                    !isPiperiOSApp && (isPublic || isForLayout) && currentUser && ((0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).isOwner(album, currentUser) || isForLayout) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await openOnPrivateCollection();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            isForLayout ? (0, $37bec70ed65ed924$export$21c51bc433c16634).option_view_detail : (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_private_collection
                        ]
                    }, "OpenOnPrivateCollection"),
                    !isPublic && !isForLayout && !isBoxSetAlbum && onDelete && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsOpenDeleteConfirmation(true);
                        },
                        sx: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_delete
                        ]
                    }, "Remove"),
                    !isPublic && !isForLayout && isBoxSetAlbum && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsOpenDeleteFromBoxSetConfirmation(true);
                        },
                        sx: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).album_remove_from_box_set
                        ]
                    }, "RemoveFromBoxSet")
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...reservedMenuProps,
                children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getAllSellStatuses().map((sellStatus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            reservedHandleMenuClose();
                            onMarkAs(sellStatus);
                        },
                        dense: true,
                        children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(sellStatus)
                    }, `${sellStatus}`))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: album.isBoxSet ? (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_delete_confirmation, album.name) : (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_confirmation, album.name),
                open: isOpenDeleteConfirmation,
                setOpen: setIsOpenDeleteConfirmation,
                isConfirm: true,
                onConfirm: async ()=>{
                    setLoading(true);
                    const { status: status, body: body } = await deleteAlbum({
                        uuid: album.uuid
                    });
                    if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                        setAlertMessage(body.message);
                        setAlertIsOpen(true);
                    } else onDelete?.();
                    setLoading(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).album_remove_from_box_set_confirmation, album.name),
                open: isOpenDeleteFromBoxSetConfirmation,
                setOpen: setIsOpenDeleteFromBoxSetConfirmation,
                isConfirm: true,
                onConfirm: async ()=>{
                    if (!boxSetAlbumId) return;
                    setLoading(true);
                    const { status: status, body: body } = await removeAlbumFromBoxSet({
                        boxSetAlbumId: boxSetAlbumId,
                        albumId: album.uuid
                    });
                    if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                        setAlertMessage(body.message);
                        setAlertIsOpen(true);
                    } else onDeleteFromBoxSet?.(body);
                    setLoading(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            shareLinkComponents()
        ]
    });
};



var $f3dc95464e643b42$exports = {};
$f3dc95464e643b42$exports = $parcel$resolve("7CmyW");


const $d6ce18dcd0d17afb$export$6ed96040651a3597 = ({ isPublic: isPublic, sortOption: sortOption, album: album, highlighted: highlighted, onClick: onClick, onDelete: onDelete, onDeleteFromBoxSet: onDeleteFromBoxSet, onCopy: onCopy, onMarkAs: onMarkAs, onOpenInLayout: onOpenInLayout, onPlayFromYouTube: onPlayFromYouTube, sectionLength: sectionLength, isForLayout: isForLayout, isBoxSetList: isBoxSetList, boxSetAlbumId: boxSetAlbumId, isFirst: isFirst, isLast: isLast, setLoading: setLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [userProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const collectionManager = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [albumImage, setAlbumImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const [userEvent, setUserEvent] = (0, $7fPBF.useState)();
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    const sellValueDetail = ()=>{
        if (!album.sellValue?.pesos) return;
        const currentCollection = collectionManager.getCurrentCollection(isPublic);
        if (currentCollection && currentCollection.discount > 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).oldPrice,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: currencyFormatter.format(album.sellValue?.pesos, userProfile, isPublic, 2)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).newPrice,
                    style: {
                        color: theme.palette.primary.main
                    },
                    children: currencyFormatter.format((album.sellValue?.pesos ?? 0) * (1 - currentCollection.discount), userProfile, isPublic, 2)
                })
            ]
        });
        else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).newPrice,
            style: {
                color: theme.palette.primary.main
            },
            children: currencyFormatter.format(album.sellValue?.pesos, userProfile, isPublic, 2)
        });
    };
    const fetchAlbumImage = async ()=>{
        if (!album.hasImage) return;
        const response = await getImage({
            name: album.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setAlbumImage(response.body);
    };
    const subtitle = (0, $7fPBF.useMemo)(()=>{
        return (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSubtitle(album);
    }, [
        album.name,
        album.albumContents,
        album.albumContents?.length,
        album.originalYear,
        album.releaseYear,
        album.albumType,
        album.order,
        album.sleeveGrade,
        album.mediaGrade,
        album.originCountry
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setAlbumImage(undefined);
            fetchAlbumImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        album.thumbnail,
        album.hasImage
    ]);
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: setUserEvent
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        onContextMenu: setUserEvent,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).container,
        ...handleLongPress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                onClick: onClick,
                sx: {
                    height: "100%",
                    paddingRight: isForLayout ? "40px !important" : undefined,
                    borderTopRightRadius: isFirst ? "4px" : undefined,
                    borderBottomRightRadius: isLast ? "4px" : undefined,
                    backgroundColor: highlighted ? theme.palette.colors?.highlight : isBoxSetList ? undefined : theme.palette.background.paper
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).albumImage,
                        image: albumImage,
                        thumbnail: album.thumbnail,
                        defaultImage: genericSleeveImage,
                        beforeLoad: fetchAlbumImage,
                        alt: album.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).rightContainer,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).name,
                                        style: {
                                            color: theme.palette.primary.main
                                        },
                                        children: album.name
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        flexGrow: 1
                                    }),
                                    isPublic && sellValueDetail()
                                ]
                            }),
                            album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).subtitle,
                                style: {
                                    color: theme.palette.primary.subtitle,
                                    fontWeight: "bold"
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).subtitle,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: subtitle
                            }),
                            !isPublic && !isBoxSetList && sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST && sectionLength > 1 && album.order == -1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).orderWarning,
                                style: {
                                    color: theme.palette.colors?.warning
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).order_warning
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: "0.3rem",
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: 1,
                                    marginTop: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).gradeText,
                                        style: {
                                            color: theme.palette.primary.main
                                        },
                                        children: album.isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_sleeve_grade : (0, $37bec70ed65ed924$export$21c51bc433c16634).album_sleeve_grade
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                                        points: album.sleeveGrade?.points ?? 0,
                                        goldmineGrading: album.sleeveGrade?.goldmineGrade ?? "-"
                                    }),
                                    !album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).gradeText,
                                                style: {
                                                    color: theme.palette.primary.main
                                                },
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_media_grade
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                                                points: album.mediaGrade?.points ?? 0,
                                                goldmineGrading: album.mediaGrade?.goldmineGrade ?? "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).hoverButtonsStack,
                style: {
                    visibility: isForLayout ? "hidden" : undefined
                },
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31bf917e4d2874f2$export$2a7b51d5dc98980), {
                    isPublic: isPublic,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).hoverButton, (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).hoverButtonRadius),
                    buttonClassName: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).hoverButtonRadius,
                    style: {
                        backgroundColor: theme.palette.colors?.counterBackground
                    },
                    album: album,
                    userEvent: userEvent,
                    onCopy: onCopy,
                    onPlayFromYouTube: onPlayFromYouTube,
                    onMarkAs: onMarkAs,
                    onOpenInLayout: onOpenInLayout,
                    onDelete: onDelete,
                    onDeleteFromBoxSet: onDeleteFromBoxSet,
                    isForLayout: isForLayout,
                    isBoxSetAlbum: isBoxSetList,
                    boxSetAlbumId: boxSetAlbumId,
                    setExternalLoading: setLoading
                })
            }),
            album.sellStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    [
                        "new",
                        "highlighted"
                    ].includes(album.sellStatus) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).highlightTag,
                        style: {
                            backgroundColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus),
                            color: theme.palette.primary.main
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).highlightText,
                            children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(album.sellStatus)
                        })
                    }),
                    [
                        "upcoming"
                    ].includes(album.sellStatus) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).upcomingPerimeter,
                                style: {
                                    borderColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus)
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).upcomingBox,
                                style: {
                                    color: theme.palette.primary.main
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).backgroundCircle,
                                    style: {
                                        backgroundColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus)
                                    },
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).upcomingText,
                                        children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(album.sellStatus)
                                    })
                                })
                            })
                        ]
                    }),
                    [
                        "reserved",
                        "sold"
                    ].includes(album.sellStatus) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).reservedBox,
                        style: {
                            backgroundColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus),
                            color: theme.palette.primary.main
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($af6df54ec5939313$exports))).reservedText,
                            children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(album.sellStatus)
                        })
                    })
                ]
            })
        ]
    });
};



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
// src/utils/formatProdErrorMessage.ts
function $78916fc80cd27125$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $78916fc80cd27125$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $78916fc80cd27125$var$symbol_observable_default = $78916fc80cd27125$var$$$observable;
// src/utils/actionTypes.ts
var $78916fc80cd27125$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $78916fc80cd27125$var$ActionTypes = {
    INIT: `@@redux/INIT${$78916fc80cd27125$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$78916fc80cd27125$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$78916fc80cd27125$var$randomString()}`
};
var $78916fc80cd27125$export$4219e499db7ca678 = $78916fc80cd27125$var$ActionTypes;
// src/utils/isPlainObject.ts
function $78916fc80cd27125$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $78916fc80cd27125$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($78916fc80cd27125$var$isDate(val)) return "date";
    if ($78916fc80cd27125$var$isError(val)) return "error";
    const constructorName = $78916fc80cd27125$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $78916fc80cd27125$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $78916fc80cd27125$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $78916fc80cd27125$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $78916fc80cd27125$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(1));
        return enhancer($78916fc80cd27125$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$78916fc80cd27125$export$53b83ca8eaab0383(action)) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $78916fc80cd27125$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$78916fc80cd27125$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $78916fc80cd27125$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$78916fc80cd27125$var$symbol_observable_default]: observable
    };
    return store;
}
function $78916fc80cd27125$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $78916fc80cd27125$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $78916fc80cd27125$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $78916fc80cd27125$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$78916fc80cd27125$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$78916fc80cd27125$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $78916fc80cd27125$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $78916fc80cd27125$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(13));
    });
}
function $78916fc80cd27125$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $78916fc80cd27125$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $78916fc80cd27125$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $78916fc80cd27125$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $78916fc80cd27125$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $78916fc80cd27125$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $78916fc80cd27125$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $78916fc80cd27125$export$b956e38827fca970(action) {
    return $78916fc80cd27125$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $7fPBF = parcelRequire("7fPBF");
var $c1c6d595ff42d79c$exports = {};
'use strict';

$c1c6d595ff42d79c$exports = (parcelRequire("i5uoL"));


var $f30b917334351296$var$__defProp = Object.defineProperty;
var $f30b917334351296$var$__defProps = Object.defineProperties;
var $f30b917334351296$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f30b917334351296$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f30b917334351296$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f30b917334351296$var$__defNormalProp = (obj, key, value)=>key in obj ? $f30b917334351296$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f30b917334351296$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f30b917334351296$var$__hasOwnProp.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    if ($f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(b))if ($f30b917334351296$var$__propIsEnum.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f30b917334351296$var$__spreadProps = (a, b)=>$f30b917334351296$var$__defProps(a, $f30b917334351296$var$__getOwnPropDescs(b));
var $f30b917334351296$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f30b917334351296$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f30b917334351296$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $f30b917334351296$var$IS_REACT_19 = /* @__PURE__ */ $7fPBF.version.startsWith("19");
var $f30b917334351296$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($f30b917334351296$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $f30b917334351296$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $f30b917334351296$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $f30b917334351296$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $f30b917334351296$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $f30b917334351296$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $f30b917334351296$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $f30b917334351296$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $f30b917334351296$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $f30b917334351296$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $f30b917334351296$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $f30b917334351296$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $f30b917334351296$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $f30b917334351296$var$ForwardRef = $f30b917334351296$var$REACT_FORWARD_REF_TYPE;
var $f30b917334351296$var$Memo = $f30b917334351296$var$REACT_MEMO_TYPE;
function $f30b917334351296$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $f30b917334351296$var$REACT_FRAGMENT_TYPE || type === $f30b917334351296$var$REACT_PROFILER_TYPE || type === $f30b917334351296$var$REACT_STRICT_MODE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE || type === $f30b917334351296$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $f30b917334351296$var$REACT_LAZY_TYPE || type.$$typeof === $f30b917334351296$var$REACT_MEMO_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONTEXT_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONSUMER_TYPE || type.$$typeof === $f30b917334351296$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $f30b917334351296$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $f30b917334351296$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f30b917334351296$var$REACT_FRAGMENT_TYPE:
                    case $f30b917334351296$var$REACT_PROFILER_TYPE:
                    case $f30b917334351296$var$REACT_STRICT_MODE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f30b917334351296$var$REACT_CONTEXT_TYPE:
                            case $f30b917334351296$var$REACT_FORWARD_REF_TYPE:
                            case $f30b917334351296$var$REACT_LAZY_TYPE:
                            case $f30b917334351296$var$REACT_MEMO_TYPE:
                                return object;
                            case $f30b917334351296$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f30b917334351296$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $f30b917334351296$var$isContextConsumer(object) {
    return $f30b917334351296$var$IS_REACT_19 ? $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONSUMER_TYPE : $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONTEXT_TYPE;
}
function $f30b917334351296$var$isMemo(object) {
    return $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f30b917334351296$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f30b917334351296$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f30b917334351296$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f30b917334351296$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f30b917334351296$var$verify(mapStateToProps, "mapStateToProps");
    $f30b917334351296$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f30b917334351296$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f30b917334351296$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f30b917334351296$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f30b917334351296$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f30b917334351296$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f30b917334351296$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f30b917334351296$var$isPlainObject(value)) $f30b917334351296$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f30b917334351296$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f30b917334351296$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f30b917334351296$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f30b917334351296$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f30b917334351296$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f30b917334351296$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f30b917334351296$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f30b917334351296$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f30b917334351296$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f30b917334351296$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f30b917334351296$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f30b917334351296$var$defaultMergeProps : typeof mergeProps === "function" ? $f30b917334351296$var$wrapMergePropsFunc(mergeProps) : $f30b917334351296$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f30b917334351296$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f30b917334351296$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f30b917334351296$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f30b917334351296$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f30b917334351296$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f30b917334351296$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f30b917334351296$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f30b917334351296$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f30b917334351296$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f30b917334351296$var$isDOM = /* @__PURE__ */ $f30b917334351296$var$canUseDOM();
var $f30b917334351296$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $f30b917334351296$var$isReactNative = /* @__PURE__ */ $f30b917334351296$var$isRunningInReactNative();
var $f30b917334351296$var$getUseIsomorphicLayoutEffect = ()=>$f30b917334351296$var$isDOM || $f30b917334351296$var$isReactNative ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f30b917334351296$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $f30b917334351296$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $f30b917334351296$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f30b917334351296$export$d36bdfa510afb180(objA, objB) {
    if ($f30b917334351296$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f30b917334351296$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f30b917334351296$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f30b917334351296$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f30b917334351296$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$TYPE_STATICS = {
    [$f30b917334351296$var$ForwardRef]: $f30b917334351296$var$FORWARD_REF_STATICS,
    [$f30b917334351296$var$Memo]: $f30b917334351296$var$MEMO_STATICS
};
function $f30b917334351296$var$getStatics(component) {
    if ($f30b917334351296$var$isMemo(component)) return $f30b917334351296$var$MEMO_STATICS;
    return $f30b917334351296$var$TYPE_STATICS[component["$$typeof"]] || $f30b917334351296$var$REACT_STATICS;
}
var $f30b917334351296$var$defineProperty = Object.defineProperty;
var $f30b917334351296$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f30b917334351296$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f30b917334351296$var$getPrototypeOf = Object.getPrototypeOf;
var $f30b917334351296$var$objectPrototype = Object.prototype;
function $f30b917334351296$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f30b917334351296$var$objectPrototype) {
            const inheritedComponent = $f30b917334351296$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f30b917334351296$var$objectPrototype) $f30b917334351296$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f30b917334351296$var$getOwnPropertyNames(sourceComponent);
        if ($f30b917334351296$var$getOwnPropertySymbols) keys = keys.concat($f30b917334351296$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f30b917334351296$var$getStatics(targetComponent);
        const sourceStatics = $f30b917334351296$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f30b917334351296$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f30b917334351296$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f30b917334351296$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $f30b917334351296$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $f30b917334351296$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f30b917334351296$var$getContext() {
    var _a;
    if (!$7fPBF.createContext) return {};
    const contextMap = (_a = $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey]) != null ? _a : $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($7fPBF.createContext);
    if (!realContext) {
        realContext = $7fPBF.createContext(null);
        contextMap.set($7fPBF.createContext, realContext);
    }
    return realContext;
}
var $f30b917334351296$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f30b917334351296$var$getContext();
// src/components/connect.tsx
var $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f30b917334351296$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f30b917334351296$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f30b917334351296$var$strictEqual(a, b) {
    return a === b;
}
var $f30b917334351296$var$hasWarnedAboutDeprecatedPureOption = false;
function $f30b917334351296$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f30b917334351296$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f30b917334351296$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f30b917334351296$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f30b917334351296$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f30b917334351296$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f30b917334351296$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7fPBF.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f30b917334351296$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $7fPBF.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $7fPBF.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7fPBF.useMemo(()=>{
                return $f30b917334351296$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7fPBF.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f30b917334351296$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $7fPBF.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $7fPBF.useRef(void 0);
            const lastWrapperProps = $7fPBF.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7fPBF.useRef(void 0);
            const renderIsScheduled = $7fPBF.useRef(false);
            const isMounted = $7fPBF.useRef(false);
            const latestSubscriptionCallbackError = $7fPBF.useRef(void 0);
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7fPBF.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $7fPBF.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs($f30b917334351296$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7fPBF.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $7fPBF.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $7fPBF.createElement(WrappedComponent, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $7fPBF.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $7fPBF.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7fPBF.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7fPBF.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $7fPBF.createElement(Connect, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f30b917334351296$export$64605811ab45167f = $f30b917334351296$var$connect;
// src/components/Provider.tsx
function $f30b917334351296$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $7fPBF.useMemo(()=>{
        const subscription = $f30b917334351296$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $7fPBF.useMemo(()=>store.getState(), [
        store
    ]);
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f30b917334351296$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $7fPBF.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f30b917334351296$export$2881499e37b75b9a = $f30b917334351296$var$Provider;
// src/hooks/useReduxContext.ts
function $f30b917334351296$var$createReduxContextHook(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $7fPBF.useContext(context);
        return contextValue;
    };
}
var $f30b917334351296$var$useReduxContext = /* @__PURE__ */ $f30b917334351296$var$createReduxContextHook();
// src/hooks/useStore.ts
function $f30b917334351296$export$671dba69185d0304(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : // @ts-ignore
    $f30b917334351296$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f30b917334351296$export$6ccbb43953eebf8 = /* @__PURE__ */ $f30b917334351296$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f30b917334351296$export$bc9b55530897c558(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$export$6ccbb43953eebf8 : $f30b917334351296$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f30b917334351296$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f30b917334351296$export$bc9b55530897c558();
var $f30b917334351296$var$refEquality = (a, b)=>a === b;
function $f30b917334351296$export$2b53f90d2bd1cbfb(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : $f30b917334351296$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f30b917334351296$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $7fPBF.useRef(true);
        const wrappedSelector = $7fPBF.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $c1c6d595ff42d79c$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $7fPBF.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f30b917334351296$export$2105062e25df4afe = /* @__PURE__ */ $f30b917334351296$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $f30b917334351296$export$712ea50be43a7858 = $f30b917334351296$var$defaultNoopBatch;


var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? $80ee8fc99f5202eb$var$prefix + ": " + provided : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}


var $81e8d04f0c2ee44f$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $81e8d04f0c2ee44f$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $81e8d04f0c2ee44f$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $81e8d04f0c2ee44f$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $81e8d04f0c2ee44f$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $81e8d04f0c2ee44f$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $81e8d04f0c2ee44f$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $81e8d04f0c2ee44f$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $81e8d04f0c2ee44f$var$noSpacing : _ref2$padding;
    var marginBox = $81e8d04f0c2ee44f$export$4b834cebd9e5cebe($81e8d04f0c2ee44f$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $81e8d04f0c2ee44f$export$4b834cebd9e5cebe($81e8d04f0c2ee44f$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $81e8d04f0c2ee44f$export$4b834cebd9e5cebe($81e8d04f0c2ee44f$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $81e8d04f0c2ee44f$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $81e8d04f0c2ee44f$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    return result;
};
var $81e8d04f0c2ee44f$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $81e8d04f0c2ee44f$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $81e8d04f0c2ee44f$var$shift(borderBox, change);
    return $81e8d04f0c2ee44f$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $81e8d04f0c2ee44f$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $81e8d04f0c2ee44f$var$getWindowScroll();
    return $81e8d04f0c2ee44f$export$cc800923e997bb8(original, scroll);
};
var $81e8d04f0c2ee44f$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $81e8d04f0c2ee44f$var$parse(styles.marginTop),
        right: $81e8d04f0c2ee44f$var$parse(styles.marginRight),
        bottom: $81e8d04f0c2ee44f$var$parse(styles.marginBottom),
        left: $81e8d04f0c2ee44f$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $81e8d04f0c2ee44f$var$parse(styles.paddingTop),
        right: $81e8d04f0c2ee44f$var$parse(styles.paddingRight),
        bottom: $81e8d04f0c2ee44f$var$parse(styles.paddingBottom),
        left: $81e8d04f0c2ee44f$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $81e8d04f0c2ee44f$var$parse(styles.borderTopWidth),
        right: $81e8d04f0c2ee44f$var$parse(styles.borderRightWidth),
        bottom: $81e8d04f0c2ee44f$var$parse(styles.borderBottomWidth),
        left: $81e8d04f0c2ee44f$var$parse(styles.borderLeftWidth)
    };
    return $81e8d04f0c2ee44f$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $81e8d04f0c2ee44f$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $81e8d04f0c2ee44f$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $c15db151bfb9ee49$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c15db151bfb9ee49$export$2e2bcd8739ae039 = $c15db151bfb9ee49$var$rafSchd;


function $322affb888b76d16$export$2e2bcd8739ae039() {
    return $322affb888b76d16$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $322affb888b76d16$export$2e2bcd8739ae039.apply(null, arguments);
}


const $e69fa77bf557686c$var$isProduction$1 = true;
const $e69fa77bf557686c$var$spacesAndTabs = /[ \t]{2,}/g;
const $e69fa77bf557686c$var$lineStartWithSpaces = /^[ \t]*/gm;
const $e69fa77bf557686c$var$clean$2 = (value)=>value.replace($e69fa77bf557686c$var$spacesAndTabs, ' ').replace($e69fa77bf557686c$var$lineStartWithSpaces, '').trim();
const $e69fa77bf557686c$var$getDevMessage = (message)=>$e69fa77bf557686c$var$clean$2(`
  %c@hello-pangea/dnd

  %c${$e69fa77bf557686c$var$clean$2(message)}

  %c\u{1F477}\u{200D} This is a development only message. It will be removed in production builds.
`);
const $e69fa77bf557686c$var$getFormattedMessage = (message)=>[
        $e69fa77bf557686c$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
const $e69fa77bf557686c$var$isDisabledFlag = '__@hello-pangea/dnd-disable-dev-warnings';
function $e69fa77bf557686c$var$log(type, message) {
    if ($e69fa77bf557686c$var$isProduction$1) return;
    if (typeof window !== 'undefined' && window[$e69fa77bf557686c$var$isDisabledFlag]) return;
    console[type](...$e69fa77bf557686c$var$getFormattedMessage(message));
}
const $e69fa77bf557686c$var$warning = $e69fa77bf557686c$var$log.bind(null, 'warn');
const $e69fa77bf557686c$var$error = $e69fa77bf557686c$var$log.bind(null, 'error');
function $e69fa77bf557686c$var$noop$2() {}
function $e69fa77bf557686c$var$getOptions(shared, fromBinding) {
    return {
        ...shared,
        ...fromBinding
    };
}
function $e69fa77bf557686c$var$bindEvents(el, bindings, sharedOptions) {
    const unbindings = bindings.map((binding)=>{
        const options = $e69fa77bf557686c$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach((unbind)=>{
            unbind();
        });
    };
}
const $e69fa77bf557686c$var$isProduction = true;
const $e69fa77bf557686c$var$prefix$1 = 'Invariant failed';
class $e69fa77bf557686c$var$RbdInvariant extends Error {
}
$e69fa77bf557686c$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $e69fa77bf557686c$var$invariant(condition, message) {
    if ($e69fa77bf557686c$var$isProduction) throw new $e69fa77bf557686c$var$RbdInvariant($e69fa77bf557686c$var$prefix$1);
    else throw new $e69fa77bf557686c$var$RbdInvariant(`${$e69fa77bf557686c$var$prefix$1}: ${message || ''}`);
}
class $e69fa77bf557686c$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    constructor(...args){
        super(...args);
        this.callbacks = null;
        this.unbind = $e69fa77bf557686c$var$noop$2;
        this.onWindowError = (event)=>{
            const callbacks = this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            const err = event.error;
            if (err instanceof $e69fa77bf557686c$var$RbdInvariant) event.preventDefault();
        };
        this.getCallbacks = ()=>{
            if (!this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return this.callbacks;
        };
        this.setCallbacks = (callbacks)=>{
            this.callbacks = callbacks;
        };
    }
    componentDidMount() {
        this.unbind = $e69fa77bf557686c$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    }
    componentDidCatch(err) {
        if (err instanceof $e69fa77bf557686c$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    }
    componentWillUnmount() {
        this.unbind();
    }
    render() {
        return this.props.children(this.setCallbacks);
    }
}
const $e69fa77bf557686c$var$dragHandleUsageInstructions = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`;
const $e69fa77bf557686c$var$position = (index)=>index + 1;
const $e69fa77bf557686c$var$onDragStart = (start)=>`
  You have lifted an item in position ${$e69fa77bf557686c$var$position(start.source.index)}
`;
const $e69fa77bf557686c$var$withLocation = (source, destination)=>{
    const isInHomeList = source.droppableId === destination.droppableId;
    const startPosition = $e69fa77bf557686c$var$position(source.index);
    const endPosition = $e69fa77bf557686c$var$position(destination.index);
    if (isInHomeList) return `
      You have moved the item from position ${startPosition}
      to position ${endPosition}
    `;
    return `
    You have moved the item from position ${startPosition}
    in list ${source.droppableId}
    to list ${destination.droppableId}
    in position ${endPosition}
  `;
};
const $e69fa77bf557686c$var$withCombine = (id, source, combine)=>{
    const inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return `
      The item ${id}
      has been combined with ${combine.draggableId}`;
    return `
      The item ${id}
      in list ${source.droppableId}
      has been combined with ${combine.draggableId}
      in list ${combine.droppableId}
    `;
};
const $e69fa77bf557686c$var$onDragUpdate = (update)=>{
    const location = update.destination;
    if (location) return $e69fa77bf557686c$var$withLocation(update.source, location);
    const combine = update.combine;
    if (combine) return $e69fa77bf557686c$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
const $e69fa77bf557686c$var$returnedToStart = (source)=>`
  The item has returned to its starting position
  of ${$e69fa77bf557686c$var$position(source.index)}
`;
const $e69fa77bf557686c$var$onDragEnd = (result)=>{
    if (result.reason === 'CANCEL') return `
      Movement cancelled.
      ${$e69fa77bf557686c$var$returnedToStart(result.source)}
    `;
    const location = result.destination;
    const combine = result.combine;
    if (location) return `
      You have dropped the item.
      ${$e69fa77bf557686c$var$withLocation(result.source, location)}
    `;
    if (combine) return `
      You have dropped the item.
      ${$e69fa77bf557686c$var$withCombine(result.draggableId, result.source, combine)}
    `;
    return `
    The item has been dropped while not over a drop area.
    ${$e69fa77bf557686c$var$returnedToStart(result.source)}
  `;
};
const $e69fa77bf557686c$var$preset = {
    dragHandleUsageInstructions: $e69fa77bf557686c$var$dragHandleUsageInstructions,
    onDragStart: $e69fa77bf557686c$var$onDragStart,
    onDragUpdate: $e69fa77bf557686c$var$onDragUpdate,
    onDragEnd: $e69fa77bf557686c$var$onDragEnd
};
function $e69fa77bf557686c$var$isEqual$2(first, second) {
    if (first === second) return true;
    if (Number.isNaN(first) && Number.isNaN(second)) return true;
    return false;
}
function $e69fa77bf557686c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(let i = 0; i < newInputs.length; i++){
        if (!$e69fa77bf557686c$var$isEqual$2(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e69fa77bf557686c$var$useMemo(getResult, inputs) {
    const initial = (0, $7fPBF.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }))[0];
    const isFirstRun = (0, $7fPBF.useRef)(true);
    const committed = (0, $7fPBF.useRef)(initial);
    const useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $e69fa77bf557686c$var$areInputsEqual(inputs, committed.current.inputs));
    const cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $7fPBF.useEffect)(()=>{
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $e69fa77bf557686c$var$useCallback(callback, inputs) {
    return $e69fa77bf557686c$var$useMemo(()=>callback, inputs);
}
const $e69fa77bf557686c$var$origin = {
    x: 0,
    y: 0
};
const $e69fa77bf557686c$var$add = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $e69fa77bf557686c$var$subtract = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
const $e69fa77bf557686c$var$isEqual$1 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $e69fa77bf557686c$var$negate = (point)=>({
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    });
const $e69fa77bf557686c$var$patch = (line, value, otherValue = 0)=>{
    if (line === 'x') return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
const $e69fa77bf557686c$var$distance = (point1, point2)=>Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
const $e69fa77bf557686c$var$closest$1 = (target, points)=>Math.min(...points.map((point)=>$e69fa77bf557686c$var$distance(target, point)));
const $e69fa77bf557686c$var$apply = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
var $e69fa77bf557686c$var$executeClip = (frame, subject)=>{
    const result = (0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
const $e69fa77bf557686c$var$offsetByPosition = (spacing, point)=>({
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    });
const $e69fa77bf557686c$var$getCorners = (spacing)=>[
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
const $e69fa77bf557686c$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $e69fa77bf557686c$var$scroll$1 = (target, frame)=>{
    if (!frame) return target;
    return $e69fa77bf557686c$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
const $e69fa77bf557686c$var$increase = (target, axis, withPlaceholder)=>{
    if (withPlaceholder && withPlaceholder.increasedBy) return {
        ...target,
        [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line]
    };
    return target;
};
const $e69fa77bf557686c$var$clip = (target, frame)=>{
    if (frame && frame.shouldClipSubject) return $e69fa77bf557686c$var$executeClip(frame.pageMarginBox, target);
    return (0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)(target);
};
var $e69fa77bf557686c$var$getSubject = ({ page: page, withPlaceholder: withPlaceholder, axis: axis, frame: frame })=>{
    const scrolled = $e69fa77bf557686c$var$scroll$1(page.marginBox, frame);
    const increased = $e69fa77bf557686c$var$increase(scrolled, axis, withPlaceholder);
    const clipped = $e69fa77bf557686c$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $e69fa77bf557686c$var$scrollDroppable = (droppable, newScroll)=>{
    !droppable.frame && $e69fa77bf557686c$var$invariant();
    const scrollable = droppable.frame;
    const scrollDiff = $e69fa77bf557686c$var$subtract(newScroll, scrollable.scroll.initial);
    const scrollDisplacement = $e69fa77bf557686c$var$negate(scrollDiff);
    const frame = {
        ...scrollable,
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    };
    const subject = $e69fa77bf557686c$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    const result = {
        ...droppable,
        frame: frame,
        subject: subject
    };
    return result;
};
function $e69fa77bf557686c$var$memoizeOne(resultFn, isEqual = $e69fa77bf557686c$var$areInputsEqual) {
    let cache = null;
    function memoized(...newArgs) {
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        const lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}
const $e69fa77bf557686c$var$toDroppableMap = $e69fa77bf557686c$var$memoizeOne((droppables)=>droppables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $e69fa77bf557686c$var$toDraggableMap = $e69fa77bf557686c$var$memoizeOne((draggables)=>draggables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $e69fa77bf557686c$var$toDroppableList = $e69fa77bf557686c$var$memoizeOne((droppables)=>Object.values(droppables));
const $e69fa77bf557686c$var$toDraggableList = $e69fa77bf557686c$var$memoizeOne((draggables)=>Object.values(draggables));
var $e69fa77bf557686c$var$getDraggablesInsideDroppable = $e69fa77bf557686c$var$memoizeOne((droppableId, draggables)=>{
    const result = $e69fa77bf557686c$var$toDraggableList(draggables).filter((draggable)=>droppableId === draggable.descriptor.droppableId).sort((a, b)=>a.descriptor.index - b.descriptor.index);
    return result;
});
function $e69fa77bf557686c$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $e69fa77bf557686c$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $e69fa77bf557686c$var$removeDraggableFromList = $e69fa77bf557686c$var$memoizeOne((remove, list)=>list.filter((item)=>item.descriptor.id !== remove.descriptor.id));
var $e69fa77bf557686c$var$moveToNextCombine = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact })=>{
    if (!destination.isCombineEnabled) return null;
    const location = $e69fa77bf557686c$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        const at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return {
            ...previousImpact,
            at: at
        };
    }
    const all = previousImpact.displaced.all;
    const closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    const withoutDraggable = $e69fa77bf557686c$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        const last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    const indexOfClosest = withoutDraggable.findIndex((d)=>d.descriptor.id === closestId);
    !(indexOfClosest !== -1) && $e69fa77bf557686c$var$invariant();
    const proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    const before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $e69fa77bf557686c$var$isHomeOf = (draggable, destination)=>draggable.descriptor.droppableId === destination.descriptor.id;
const $e69fa77bf557686c$var$noDisplacedBy = {
    point: $e69fa77bf557686c$var$origin,
    value: 0
};
const $e69fa77bf557686c$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
const $e69fa77bf557686c$var$noImpact = {
    displaced: $e69fa77bf557686c$var$emptyGroups,
    displacedBy: $e69fa77bf557686c$var$noDisplacedBy,
    at: null
};
var $e69fa77bf557686c$var$isWithin = (lowerBound, upperBound)=>(value)=>lowerBound <= value && value <= upperBound;
var $e69fa77bf557686c$var$isPartiallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $e69fa77bf557686c$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $e69fa77bf557686c$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        const isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        const isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        const isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        const isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        const isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        const isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        const isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $e69fa77bf557686c$var$isTotallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $e69fa77bf557686c$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $e69fa77bf557686c$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
const $e69fa77bf557686c$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
const $e69fa77bf557686c$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $e69fa77bf557686c$var$isTotallyVisibleThroughFrameOnAxis = (axis)=>(frame)=>{
        const isWithinVertical = $e69fa77bf557686c$var$isWithin(frame.top, frame.bottom);
        const isWithinHorizontal = $e69fa77bf557686c$var$isWithin(frame.left, frame.right);
        return (subject)=>{
            if (axis === $e69fa77bf557686c$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
const $e69fa77bf557686c$var$getDroppableDisplaced = (target, destination)=>{
    const displacement = destination.frame ? destination.frame.scroll.diff.displacement : $e69fa77bf557686c$var$origin;
    return $e69fa77bf557686c$var$offsetByPosition(target, displacement);
};
const $e69fa77bf557686c$var$isVisibleInDroppable = (target, destination, isVisibleThroughFrameFn)=>{
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
const $e69fa77bf557686c$var$isVisibleInViewport = (target, viewport, isVisibleThroughFrameFn)=>isVisibleThroughFrameFn(viewport)(target);
const $e69fa77bf557686c$var$isVisible$1 = ({ target: toBeDisplaced, destination: destination, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, isVisibleThroughFrameFn: isVisibleThroughFrameFn })=>{
    const displacedTarget = withDroppableDisplacement ? $e69fa77bf557686c$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $e69fa77bf557686c$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $e69fa77bf557686c$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
const $e69fa77bf557686c$var$isPartiallyVisible = (args)=>$e69fa77bf557686c$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $e69fa77bf557686c$var$isPartiallyVisibleThroughFrame
    });
const $e69fa77bf557686c$var$isTotallyVisible = (args)=>$e69fa77bf557686c$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $e69fa77bf557686c$var$isTotallyVisibleThroughFrame
    });
const $e69fa77bf557686c$var$isTotallyVisibleOnAxis = (args)=>$e69fa77bf557686c$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $e69fa77bf557686c$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    });
const $e69fa77bf557686c$var$getShouldAnimate = (id, last, forceShouldAnimate)=>{
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    const { invisible: invisible, visible: visible } = last;
    if (invisible[id]) return false;
    const previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $e69fa77bf557686c$var$getTarget(draggable, displacedBy) {
    const marginBox = draggable.page.marginBox;
    const expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)((0, $81e8d04f0c2ee44f$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $e69fa77bf557686c$var$getDisplacementGroups({ afterDragging: afterDragging, destination: destination, displacedBy: displacedBy, viewport: viewport, forceShouldAnimate: forceShouldAnimate, last: last }) {
    return afterDragging.reduce(function process(groups, draggable) {
        const target = $e69fa77bf557686c$var$getTarget(draggable, displacedBy);
        const id = draggable.descriptor.id;
        groups.all.push(id);
        const isVisible = $e69fa77bf557686c$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        const shouldAnimate = $e69fa77bf557686c$var$getShouldAnimate(id, last, forceShouldAnimate);
        const displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $e69fa77bf557686c$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    const indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $e69fa77bf557686c$var$goAtEnd({ insideDestination: insideDestination, inHomeList: inHomeList, displacedBy: displacedBy, destination: destination }) {
    const newIndex = $e69fa77bf557686c$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $e69fa77bf557686c$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $e69fa77bf557686c$var$calculateReorderImpact({ draggable: draggable, insideDestination: insideDestination, destination: destination, viewport: viewport, displacedBy: displacedBy, last: last, index: index, forceShouldAnimate: forceShouldAnimate }) {
    const inHomeList = $e69fa77bf557686c$var$isHomeOf(draggable, destination);
    if (index == null) return $e69fa77bf557686c$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const match = insideDestination.find((item)=>item.descriptor.index === index);
    if (!match) return $e69fa77bf557686c$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const withoutDragging = $e69fa77bf557686c$var$removeDraggableFromList(draggable, insideDestination);
    const sliceFrom = insideDestination.indexOf(match);
    const impacted = withoutDragging.slice(sliceFrom);
    const displaced = $e69fa77bf557686c$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $e69fa77bf557686c$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $e69fa77bf557686c$var$fromCombine = ({ isMovingForward: isMovingForward, destination: destination, draggables: draggables, combine: combine, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const combineId = combine.draggableId;
    const combineWith = draggables[combineId];
    const combineWithIndex = combineWith.descriptor.index;
    const didCombineWithStartAfterCritical = $e69fa77bf557686c$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $e69fa77bf557686c$var$fromReorder = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, insideDestination: insideDestination, location: location })=>{
    if (!insideDestination.length) return null;
    const currentIndex = location.index;
    const proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    const firstIndex = insideDestination[0].descriptor.index;
    const lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    const upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $e69fa77bf557686c$var$moveToNextIndex = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, draggable: draggable, draggables: draggables, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const wasAt = previousImpact.at;
    !wasAt && $e69fa77bf557686c$var$invariant();
    if (wasAt.type === 'REORDER') {
        const newIndex = $e69fa77bf557686c$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (newIndex == null) return null;
        return $e69fa77bf557686c$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    const newIndex = $e69fa77bf557686c$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $e69fa77bf557686c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $e69fa77bf557686c$var$getCombinedItemDisplacement = ({ displaced: displaced, afterCritical: afterCritical, combineWith: combineWith, displacedBy: displacedBy })=>{
    const isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($e69fa77bf557686c$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $e69fa77bf557686c$var$origin : $e69fa77bf557686c$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $e69fa77bf557686c$var$origin;
};
var $e69fa77bf557686c$var$whenCombining = ({ afterCritical: afterCritical, impact: impact, draggables: draggables })=>{
    const combine = $e69fa77bf557686c$var$tryGetCombine(impact);
    !combine && $e69fa77bf557686c$var$invariant();
    const combineWith = combine.draggableId;
    const center = draggables[combineWith].page.borderBox.center;
    const displaceBy = $e69fa77bf557686c$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $e69fa77bf557686c$var$add(center, displaceBy);
};
const $e69fa77bf557686c$var$distanceFromStartToBorderBoxCenter = (axis, box)=>box.margin[axis.start] + box.borderBox[axis.size] / 2;
const $e69fa77bf557686c$var$distanceFromEndToBorderBoxCenter = (axis, box)=>box.margin[axis.end] + box.borderBox[axis.size] / 2;
const $e69fa77bf557686c$var$getCrossAxisBorderBoxCenter = (axis, target, isMoving)=>target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
const $e69fa77bf557686c$var$goAfter = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$e69fa77bf557686c$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $e69fa77bf557686c$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $e69fa77bf557686c$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $e69fa77bf557686c$var$goBefore = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$e69fa77bf557686c$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $e69fa77bf557686c$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $e69fa77bf557686c$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $e69fa77bf557686c$var$goIntoStart = ({ axis: axis, moveInto: moveInto, isMoving: isMoving })=>$e69fa77bf557686c$var$patch(axis.line, moveInto.contentBox[axis.start] + $e69fa77bf557686c$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $e69fa77bf557686c$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
var $e69fa77bf557686c$var$whenReordering = ({ impact: impact, draggable: draggable, draggables: draggables, droppable: droppable, afterCritical: afterCritical })=>{
    const insideDestination = $e69fa77bf557686c$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const draggablePage = draggable.page;
    const axis = droppable.axis;
    if (!insideDestination.length) return $e69fa77bf557686c$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    const { displaced: displaced, displacedBy: displacedBy } = impact;
    const closestAfter = displaced.all[0];
    if (closestAfter) {
        const closest = draggables[closestAfter];
        if ($e69fa77bf557686c$var$didStartAfterCritical(closestAfter, afterCritical)) return $e69fa77bf557686c$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        const withDisplacement = (0, $81e8d04f0c2ee44f$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $e69fa77bf557686c$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    const last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($e69fa77bf557686c$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        const page = (0, $81e8d04f0c2ee44f$export$cc800923e997bb8)(last.page, $e69fa77bf557686c$var$negate(afterCritical.displacedBy.point));
        return $e69fa77bf557686c$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $e69fa77bf557686c$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $e69fa77bf557686c$var$withDroppableDisplacement = (droppable, point)=>{
    const frame = droppable.frame;
    if (!frame) return point;
    return $e69fa77bf557686c$var$add(point, frame.scroll.diff.displacement);
};
const $e69fa77bf557686c$var$getResultWithoutDroppableDisplacement = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, afterCritical: afterCritical })=>{
    const original = draggable.page.borderBox.center;
    const at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $e69fa77bf557686c$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $e69fa77bf557686c$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $e69fa77bf557686c$var$getPageBorderBoxCenterFromImpact = (args)=>{
    const withoutDisplacement = $e69fa77bf557686c$var$getResultWithoutDroppableDisplacement(args);
    const droppable = args.droppable;
    const withDisplacement = droppable ? $e69fa77bf557686c$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $e69fa77bf557686c$var$scrollViewport = (viewport, newScroll)=>{
    const diff = $e69fa77bf557686c$var$subtract(newScroll, viewport.scroll.initial);
    const displacement = $e69fa77bf557686c$var$negate(diff);
    const frame = (0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    const updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $e69fa77bf557686c$var$getDraggables$1(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
function $e69fa77bf557686c$var$tryGetVisible(id, groups) {
    for(let i = 0; i < groups.length; i++){
        const displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $e69fa77bf557686c$var$speculativelyIncrease = ({ impact: impact, viewport: viewport, destination: destination, draggables: draggables, maxScrollChange: maxScrollChange })=>{
    const scrolledViewport = $e69fa77bf557686c$var$scrollViewport(viewport, $e69fa77bf557686c$var$add(viewport.scroll.current, maxScrollChange));
    const scrolledDroppable = destination.frame ? $e69fa77bf557686c$var$scrollDroppable(destination, $e69fa77bf557686c$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    const last = impact.displaced;
    const withViewportScroll = $e69fa77bf557686c$var$getDisplacementGroups({
        afterDragging: $e69fa77bf557686c$var$getDraggables$1(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const withDroppableScroll = $e69fa77bf557686c$var$getDisplacementGroups({
        afterDragging: $e69fa77bf557686c$var$getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const invisible = {};
    const visible = {};
    const groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach((id)=>{
        const displacement = $e69fa77bf557686c$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    const newImpact = {
        ...impact,
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    };
    return newImpact;
};
var $e69fa77bf557686c$var$withViewportDisplacement = (viewport, point)=>$e69fa77bf557686c$var$add(viewport.scroll.diff.displacement, point);
var $e69fa77bf557686c$var$getClientFromPageBorderBoxCenter = ({ pageBorderBoxCenter: pageBorderBoxCenter, draggable: draggable, viewport: viewport })=>{
    const withoutPageScrollChange = $e69fa77bf557686c$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    const offset = $e69fa77bf557686c$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $e69fa77bf557686c$var$add(draggable.client.borderBox.center, offset);
};
var $e69fa77bf557686c$var$isTotallyVisibleInNewLocation = ({ draggable: draggable, destination: destination, newPageBorderBoxCenter: newPageBorderBoxCenter, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, onlyOnMainAxis: onlyOnMainAxis = false })=>{
    const changeNeeded = $e69fa77bf557686c$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    const shifted = $e69fa77bf557686c$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    const args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $e69fa77bf557686c$var$isTotallyVisibleOnAxis(args) : $e69fa77bf557686c$var$isTotallyVisible(args);
};
var $e69fa77bf557686c$var$moveToNextPlace = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, draggables: draggables, previousImpact: previousImpact, viewport: viewport, previousPageBorderBoxCenter: previousPageBorderBoxCenter, previousClientSelection: previousClientSelection, afterCritical: afterCritical })=>{
    if (!destination.isEnabled) return null;
    const insideDestination = $e69fa77bf557686c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const isInHomeList = $e69fa77bf557686c$var$isHomeOf(draggable, destination);
    const impact = $e69fa77bf557686c$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $e69fa77bf557686c$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $e69fa77bf557686c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const isVisibleInNewLocation = $e69fa77bf557686c$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        const clientSelection = $e69fa77bf557686c$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    const distance = $e69fa77bf557686c$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    const cautious = $e69fa77bf557686c$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
const $e69fa77bf557686c$var$getKnownActive = (droppable)=>{
    const rect = droppable.subject.active;
    !rect && $e69fa77bf557686c$var$invariant();
    return rect;
};
var $e69fa77bf557686c$var$getBestCrossAxisDroppable = ({ isMovingForward: isMovingForward, pageBorderBoxCenter: pageBorderBoxCenter, source: source, droppables: droppables, viewport: viewport })=>{
    const active = source.subject.active;
    if (!active) return null;
    const axis = source.axis;
    const isBetweenSourceClipped = $e69fa77bf557686c$var$isWithin(active[axis.start], active[axis.end]);
    const candidates = $e69fa77bf557686c$var$toDroppableList(droppables).filter((droppable)=>droppable !== source).filter((droppable)=>droppable.isEnabled).filter((droppable)=>Boolean(droppable.subject.active)).filter((droppable)=>$e69fa77bf557686c$var$isPartiallyVisibleThroughFrame(viewport.frame)($e69fa77bf557686c$var$getKnownActive(droppable))).filter((droppable)=>{
        const activeOfTarget = $e69fa77bf557686c$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter((droppable)=>{
        const activeOfTarget = $e69fa77bf557686c$var$getKnownActive(droppable);
        const isBetweenDestinationClipped = $e69fa77bf557686c$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort((a, b)=>{
        const first = $e69fa77bf557686c$var$getKnownActive(a)[axis.crossAxisStart];
        const second = $e69fa77bf557686c$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter((droppable, index, array)=>$e69fa77bf557686c$var$getKnownActive(droppable)[axis.crossAxisStart] === $e69fa77bf557686c$var$getKnownActive(array[0])[axis.crossAxisStart]);
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const contains = candidates.filter((droppable)=>{
        const isWithinDroppable = $e69fa77bf557686c$var$isWithin($e69fa77bf557686c$var$getKnownActive(droppable)[axis.start], $e69fa77bf557686c$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort((a, b)=>$e69fa77bf557686c$var$getKnownActive(a)[axis.start] - $e69fa77bf557686c$var$getKnownActive(b)[axis.start])[0];
    return candidates.sort((a, b)=>{
        const first = $e69fa77bf557686c$var$closest$1(pageBorderBoxCenter, $e69fa77bf557686c$var$getCorners($e69fa77bf557686c$var$getKnownActive(a)));
        const second = $e69fa77bf557686c$var$closest$1(pageBorderBoxCenter, $e69fa77bf557686c$var$getCorners($e69fa77bf557686c$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $e69fa77bf557686c$var$getKnownActive(a)[axis.start] - $e69fa77bf557686c$var$getKnownActive(b)[axis.start];
    })[0];
};
const $e69fa77bf557686c$var$getCurrentPageBorderBoxCenter = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox.center;
    return $e69fa77bf557686c$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $e69fa77bf557686c$var$subtract(original, afterCritical.displacedBy.point) : original;
};
const $e69fa77bf557686c$var$getCurrentPageBorderBox = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox;
    return $e69fa77bf557686c$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $e69fa77bf557686c$var$offsetByPosition(original, $e69fa77bf557686c$var$negate(afterCritical.displacedBy.point)) : original;
};
var $e69fa77bf557686c$var$getClosestDraggable = ({ pageBorderBoxCenter: pageBorderBoxCenter, viewport: viewport, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    const sorted = insideDestination.filter((draggable)=>$e69fa77bf557686c$var$isTotallyVisible({
            target: $e69fa77bf557686c$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        })).sort((a, b)=>{
        const distanceToA = $e69fa77bf557686c$var$distance(pageBorderBoxCenter, $e69fa77bf557686c$var$withDroppableDisplacement(destination, $e69fa77bf557686c$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        const distanceToB = $e69fa77bf557686c$var$distance(pageBorderBoxCenter, $e69fa77bf557686c$var$withDroppableDisplacement(destination, $e69fa77bf557686c$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $e69fa77bf557686c$var$getDisplacedBy = $e69fa77bf557686c$var$memoizeOne(function getDisplacedBy(axis, displaceBy) {
    const displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $e69fa77bf557686c$var$patch(axis.line, displacement)
    };
});
const $e69fa77bf557686c$var$getRequiredGrowthForPlaceholder = (droppable, placeholderSize, draggables)=>{
    const axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $e69fa77bf557686c$var$patch(axis.line, placeholderSize[axis.line]);
    const availableSpace = droppable.subject.page.contentBox[axis.size];
    const insideDroppable = $e69fa77bf557686c$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const spaceUsed = insideDroppable.reduce((sum, dimension)=>sum + dimension.client.marginBox[axis.size], 0);
    const requiredSpace = spaceUsed + placeholderSize[axis.line];
    const needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $e69fa77bf557686c$var$patch(axis.line, needsToGrowBy);
};
const $e69fa77bf557686c$var$withMaxScroll = (frame, max)=>({
        ...frame,
        scroll: {
            ...frame.scroll,
            max: max
        }
    });
const $e69fa77bf557686c$var$addPlaceholder = (droppable, draggable, draggables)=>{
    const frame = droppable.frame;
    !!$e69fa77bf557686c$var$isHomeOf(draggable, droppable) && $e69fa77bf557686c$var$invariant();
    !!droppable.subject.withPlaceholder && $e69fa77bf557686c$var$invariant();
    const placeholderSize = $e69fa77bf557686c$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    const requiredGrowth = $e69fa77bf557686c$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    const added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        const subject = $e69fa77bf557686c$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const maxScroll = requiredGrowth ? $e69fa77bf557686c$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    const newFrame = $e69fa77bf557686c$var$withMaxScroll(frame, maxScroll);
    const subject = $e69fa77bf557686c$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
const $e69fa77bf557686c$var$removePlaceholder = (droppable)=>{
    const added = droppable.subject.withPlaceholder;
    !added && $e69fa77bf557686c$var$invariant();
    const frame = droppable.frame;
    if (!frame) {
        const subject = $e69fa77bf557686c$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $e69fa77bf557686c$var$invariant();
    const newFrame = $e69fa77bf557686c$var$withMaxScroll(frame, oldMaxScroll);
    const subject = $e69fa77bf557686c$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
var $e69fa77bf557686c$var$moveToNewDroppable = ({ previousPageBorderBoxCenter: previousPageBorderBoxCenter, moveRelativeTo: moveRelativeTo, insideDestination: insideDestination, draggable: draggable, draggables: draggables, destination: destination, viewport: viewport, afterCritical: afterCritical })=>{
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        const proposed = {
            displaced: $e69fa77bf557686c$var$emptyGroups,
            displacedBy: $e69fa77bf557686c$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        const proposedPageBorderBoxCenter = $e69fa77bf557686c$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        const withPlaceholder = $e69fa77bf557686c$var$isHomeOf(draggable, destination) ? destination : $e69fa77bf557686c$var$addPlaceholder(destination, draggable, draggables);
        const isVisibleInNewLocation = $e69fa77bf557686c$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    const isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    const proposedIndex = (()=>{
        const relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    })();
    const displacedBy = $e69fa77bf557686c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $e69fa77bf557686c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $e69fa77bf557686c$var$emptyGroups,
        index: proposedIndex
    });
};
var $e69fa77bf557686c$var$moveCrossAxis = ({ isMovingForward: isMovingForward, previousPageBorderBoxCenter: previousPageBorderBoxCenter, draggable: draggable, isOver: isOver, draggables: draggables, droppables: droppables, viewport: viewport, afterCritical: afterCritical })=>{
    const destination = $e69fa77bf557686c$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    const insideDestination = $e69fa77bf557686c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const moveRelativeTo = $e69fa77bf557686c$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    const impact = $e69fa77bf557686c$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $e69fa77bf557686c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const clientSelection = $e69fa77bf557686c$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $e69fa77bf557686c$var$whatIsDraggedOver = (impact)=>{
    const at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
const $e69fa77bf557686c$var$getDroppableOver$1 = (impact, droppables)=>{
    const id = $e69fa77bf557686c$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $e69fa77bf557686c$var$moveInDirection = ({ state: state, type: type })=>{
    const isActuallyOver = $e69fa77bf557686c$var$getDroppableOver$1(state.impact, state.dimensions.droppables);
    const isMainAxisMovementAllowed = Boolean(isActuallyOver);
    const home = state.dimensions.droppables[state.critical.droppable.id];
    const isOver = isActuallyOver || home;
    const direction = isOver.axis.direction;
    const isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    const isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    const { draggables: draggables, droppables: droppables } = state.dimensions;
    return isMovingOnMainAxis ? $e69fa77bf557686c$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $e69fa77bf557686c$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $e69fa77bf557686c$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $e69fa77bf557686c$var$isPositionInFrame(frame) {
    const isWithinVertical = $e69fa77bf557686c$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $e69fa77bf557686c$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $e69fa77bf557686c$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $e69fa77bf557686c$var$getFurthestAway({ pageBorderBox: pageBorderBox, draggable: draggable, candidates: candidates }) {
    const startCenter = draggable.page.borderBox.center;
    const sorted = candidates.map((candidate)=>{
        const axis = candidate.axis;
        const target = $e69fa77bf557686c$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $e69fa77bf557686c$var$distance(startCenter, target)
        };
    }).sort((a, b)=>b.distance - a.distance);
    return sorted[0] ? sorted[0].id : null;
}
function $e69fa77bf557686c$var$getDroppableOver({ pageBorderBox: pageBorderBox, draggable: draggable, droppables: droppables }) {
    const candidates = $e69fa77bf557686c$var$toDroppableList(droppables).filter((item)=>{
        if (!item.isEnabled) return false;
        const active = item.subject.active;
        if (!active) return false;
        if (!$e69fa77bf557686c$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($e69fa77bf557686c$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        const axis = item.axis;
        const childCenter = active.center[axis.crossAxisLine];
        const crossAxisStart = pageBorderBox[axis.crossAxisStart];
        const crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        const isContained = $e69fa77bf557686c$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        const isStartContained = isContained(crossAxisStart);
        const isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $e69fa77bf557686c$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
const $e69fa77bf557686c$var$offsetRectByPosition = (rect, point)=>(0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)($e69fa77bf557686c$var$offsetByPosition(rect, point));
var $e69fa77bf557686c$var$withDroppableScroll = (droppable, area)=>{
    const frame = droppable.frame;
    if (!frame) return area;
    return $e69fa77bf557686c$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $e69fa77bf557686c$var$getIsDisplaced({ displaced: displaced, id: id }) {
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $e69fa77bf557686c$var$atIndex({ draggable: draggable, closest: closest, inHomeList: inHomeList }) {
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $e69fa77bf557686c$var$getReorderImpact = ({ pageBorderBoxWithDroppableScroll: targetRect, draggable: draggable, destination: destination, insideDestination: insideDestination, last: last, viewport: viewport, afterCritical: afterCritical })=>{
    const axis = destination.axis;
    const displacedBy = $e69fa77bf557686c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $e69fa77bf557686c$var$removeDraggableFromList(draggable, insideDestination);
    const closest = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childCenter = child.page.borderBox.center[axis.line];
        const didStartAfterCritical$1 = $e69fa77bf557686c$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $e69fa77bf557686c$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    const newIndex = $e69fa77bf557686c$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $e69fa77bf557686c$var$isHomeOf(draggable, destination)
    });
    return $e69fa77bf557686c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
const $e69fa77bf557686c$var$combineThresholdDivisor = 4;
var $e69fa77bf557686c$var$getCombineImpact = ({ draggable: draggable, pageBorderBoxWithDroppableScroll: targetRect, previousImpact: previousImpact, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const axis = destination.axis;
    const displacedBy = $e69fa77bf557686c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $e69fa77bf557686c$var$removeDraggableFromList(draggable, insideDestination);
    const combineWith = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childRect = child.page.borderBox;
        const childSize = childRect[axis.size];
        const threshold = childSize / $e69fa77bf557686c$var$combineThresholdDivisor;
        const didStartAfterCritical$1 = $e69fa77bf557686c$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $e69fa77bf557686c$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    const impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $e69fa77bf557686c$var$getDragImpact = ({ pageOffset: pageOffset, draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBox = $e69fa77bf557686c$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    const destinationId = $e69fa77bf557686c$var$getDroppableOver({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $e69fa77bf557686c$var$noImpact;
    const destination = droppables[destinationId];
    const insideDestination = $e69fa77bf557686c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const pageBorderBoxWithDroppableScroll = $e69fa77bf557686c$var$withDroppableScroll(destination, pageBorderBox);
    return $e69fa77bf557686c$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $e69fa77bf557686c$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $e69fa77bf557686c$var$patchDroppableMap = (droppables, updated)=>({
        ...droppables,
        [updated.descriptor.id]: updated
    });
const $e69fa77bf557686c$var$clearUnusedPlaceholder = ({ previousImpact: previousImpact, impact: impact, droppables: droppables })=>{
    const last = $e69fa77bf557686c$var$whatIsDraggedOver(previousImpact);
    const now = $e69fa77bf557686c$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    const lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    const updated = $e69fa77bf557686c$var$removePlaceholder(lastDroppable);
    return $e69fa77bf557686c$var$patchDroppableMap(droppables, updated);
};
var $e69fa77bf557686c$var$recomputePlaceholders = ({ draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, impact: impact })=>{
    const cleaned = $e69fa77bf557686c$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    const isOver = $e69fa77bf557686c$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    const droppable = droppables[isOver];
    if ($e69fa77bf557686c$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    const patched = $e69fa77bf557686c$var$addPlaceholder(droppable, draggable, draggables);
    return $e69fa77bf557686c$var$patchDroppableMap(cleaned, patched);
};
var $e69fa77bf557686c$var$update = ({ state: state, clientSelection: forcedClientSelection, dimensions: forcedDimensions, viewport: forcedViewport, impact: forcedImpact, scrollJumpRequest: scrollJumpRequest })=>{
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const clientSelection = forcedClientSelection || state.current.client.selection;
    const offset = $e69fa77bf557686c$var$subtract(clientSelection, state.initial.client.selection);
    const client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $e69fa77bf557686c$var$add(state.initial.client.borderBoxCenter, offset)
    };
    const page = {
        selection: $e69fa77bf557686c$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $e69fa77bf557686c$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $e69fa77bf557686c$var$add(client.offset, viewport.scroll.diff.value)
    };
    const current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return {
        ...state,
        dimensions: dimensions,
        viewport: viewport,
        current: current
    };
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const newImpact = forcedImpact || $e69fa77bf557686c$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    const withUpdatedPlaceholders = $e69fa77bf557686c$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    const result = {
        ...state,
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    };
    return result;
};
function $e69fa77bf557686c$var$getDraggables(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
var $e69fa77bf557686c$var$recompute = ({ impact: impact, viewport: viewport, draggables: draggables, destination: destination, forceShouldAnimate: forceShouldAnimate })=>{
    const last = impact.displaced;
    const afterDragging = $e69fa77bf557686c$var$getDraggables(last.all, draggables);
    const displaced = $e69fa77bf557686c$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return {
        ...impact,
        displaced: displaced
    };
};
var $e69fa77bf557686c$var$getClientBorderBoxCenter = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBoxCenter = $e69fa77bf557686c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $e69fa77bf557686c$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $e69fa77bf557686c$var$refreshSnap = ({ state: state, dimensions: forcedDimensions, viewport: forcedViewport })=>{
    !(state.movementMode === 'SNAP') && $e69fa77bf557686c$var$invariant();
    const needsVisibilityCheck = state.impact;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const { draggables: draggables, droppables: droppables } = dimensions;
    const draggable = draggables[state.critical.draggable.id];
    const isOver = $e69fa77bf557686c$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $e69fa77bf557686c$var$invariant();
    const destination = droppables[isOver];
    const impact = $e69fa77bf557686c$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    const clientSelection = $e69fa77bf557686c$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $e69fa77bf557686c$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $e69fa77bf557686c$var$getHomeLocation = (descriptor)=>({
        index: descriptor.index,
        droppableId: descriptor.droppableId
    });
var $e69fa77bf557686c$var$getLiftEffect = ({ draggable: draggable, home: home, draggables: draggables, viewport: viewport })=>{
    const displacedBy = $e69fa77bf557686c$var$getDisplacedBy(home.axis, draggable.displaceBy);
    const insideHome = $e69fa77bf557686c$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    const rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $e69fa77bf557686c$var$invariant();
    const afterDragging = insideHome.slice(rawIndex + 1);
    const effected = afterDragging.reduce((previous, item)=>{
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    const afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    const displaced = $e69fa77bf557686c$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    const impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $e69fa77bf557686c$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $e69fa77bf557686c$var$patchDimensionMap = (dimensions, updated)=>({
        draggables: dimensions.draggables,
        droppables: $e69fa77bf557686c$var$patchDroppableMap(dimensions.droppables, updated)
    });
const $e69fa77bf557686c$var$start = (key)=>{};
const $e69fa77bf557686c$var$finish = (key)=>{};
var $e69fa77bf557686c$var$offsetDraggable = ({ draggable: draggable, offset: offset$1, initialWindowScroll: initialWindowScroll })=>{
    const client = (0, $81e8d04f0c2ee44f$export$cc800923e997bb8)(draggable.client, offset$1);
    const page = (0, $81e8d04f0c2ee44f$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    const moved = {
        ...draggable,
        placeholder: {
            ...draggable.placeholder,
            client: client
        },
        client: client,
        page: page
    };
    return moved;
};
var $e69fa77bf557686c$var$getFrame = (droppable)=>{
    const frame = droppable.frame;
    !frame && $e69fa77bf557686c$var$invariant();
    return frame;
};
var $e69fa77bf557686c$var$adjustAdditionsForScrollChanges = ({ additions: additions, updatedDroppables: updatedDroppables, viewport: viewport })=>{
    const windowScrollChange = viewport.scroll.diff.value;
    return additions.map((draggable)=>{
        const droppableId = draggable.descriptor.droppableId;
        const modified = updatedDroppables[droppableId];
        const frame = $e69fa77bf557686c$var$getFrame(modified);
        const droppableScrollChange = frame.scroll.diff.value;
        const totalChange = $e69fa77bf557686c$var$add(windowScrollChange, droppableScrollChange);
        const moved = $e69fa77bf557686c$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $e69fa77bf557686c$var$publishWhileDraggingInVirtual = ({ state: state, published: published })=>{
    $e69fa77bf557686c$var$start();
    const withScrollChange = published.modified.map((update)=>{
        const existing = state.dimensions.droppables[update.droppableId];
        const scrolled = $e69fa77bf557686c$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    const droppables = {
        ...state.dimensions.droppables,
        ...$e69fa77bf557686c$var$toDroppableMap(withScrollChange)
    };
    const updatedAdditions = $e69fa77bf557686c$var$toDraggableMap($e69fa77bf557686c$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    const draggables = {
        ...state.dimensions.draggables,
        ...updatedAdditions
    };
    published.removals.forEach((id)=>{
        delete draggables[id];
    });
    const dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    const wasOverId = $e69fa77bf557686c$var$whatIsDraggedOver(state.impact);
    const wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const home = dimensions.droppables[state.critical.droppable.id];
    const { impact: onLiftImpact, afterCritical: afterCritical } = $e69fa77bf557686c$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    });
    const previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    const impact = $e69fa77bf557686c$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $e69fa77bf557686c$var$finish();
    const draggingState = {
        ...state,
        phase: 'DRAGGING',
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    };
    if (state.phase === 'COLLECTING') return draggingState;
    const dropPending = {
        ...draggingState,
        phase: 'DROP_PENDING',
        reason: state.reason,
        isWaiting: false
    };
    return dropPending;
};
const $e69fa77bf557686c$var$isSnapping = (state)=>state.movementMode === 'SNAP';
const $e69fa77bf557686c$var$postDroppableChange = (state, updated, isEnabledChanging)=>{
    const dimensions = $e69fa77bf557686c$var$patchDimensionMap(state.dimensions, updated);
    if (!$e69fa77bf557686c$var$isSnapping(state) || isEnabledChanging) return $e69fa77bf557686c$var$update({
        state: state,
        dimensions: dimensions
    });
    return $e69fa77bf557686c$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $e69fa77bf557686c$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return {
        ...state,
        scrollJumpRequest: null
    };
    return state;
}
const $e69fa77bf557686c$var$idle$2 = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $e69fa77bf557686c$var$reducer = (state = $e69fa77bf557686c$var$idle$2, action)=>{
    if (action.type === 'FLUSH') return {
        ...$e69fa77bf557686c$var$idle$2,
        shouldFlush: true
    };
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $e69fa77bf557686c$var$invariant();
        const { critical: critical, clientSelection: clientSelection, viewport: viewport, dimensions: dimensions, movementMode: movementMode } = action.payload;
        const draggable = dimensions.draggables[critical.draggable.id];
        const home = dimensions.droppables[critical.droppable.id];
        const client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $e69fa77bf557686c$var$origin
        };
        const initial = {
            client: client,
            page: {
                selection: $e69fa77bf557686c$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $e69fa77bf557686c$var$add(client.selection, viewport.scroll.initial),
                offset: $e69fa77bf557686c$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        const isWindowScrollAllowed = $e69fa77bf557686c$var$toDroppableList(dimensions.droppables).every((item)=>!item.isFixedOnPage);
        const { impact: impact, afterCritical: afterCritical } = $e69fa77bf557686c$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        });
        const result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $e69fa77bf557686c$var$invariant();
        const result = {
            ...state,
            phase: 'COLLECTING'
        };
        return result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $e69fa77bf557686c$var$invariant();
        return $e69fa77bf557686c$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$e69fa77bf557686c$var$isMovementAllowed(state) && $e69fa77bf557686c$var$invariant();
        const { client: clientSelection } = action.payload;
        if ($e69fa77bf557686c$var$isEqual$1(clientSelection, state.current.client.selection)) return state;
        return $e69fa77bf557686c$var$update({
            state: state,
            clientSelection: clientSelection,
            impact: $e69fa77bf557686c$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $e69fa77bf557686c$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $e69fa77bf557686c$var$removeScrollJumpRequest(state);
        !$e69fa77bf557686c$var$isMovementAllowed(state) && $e69fa77bf557686c$var$invariant();
        const { id: id, newScroll: newScroll } = action.payload;
        const target = state.dimensions.droppables[id];
        if (!target) return state;
        const scrolled = $e69fa77bf557686c$var$scrollDroppable(target, newScroll);
        return $e69fa77bf557686c$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$e69fa77bf557686c$var$isMovementAllowed(state) && $e69fa77bf557686c$var$invariant();
        const { id: id, isEnabled: isEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $e69fa77bf557686c$var$invariant();
        !(target.isEnabled !== isEnabled) && $e69fa77bf557686c$var$invariant();
        const updated = {
            ...target,
            isEnabled: isEnabled
        };
        return $e69fa77bf557686c$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$e69fa77bf557686c$var$isMovementAllowed(state) && $e69fa77bf557686c$var$invariant();
        const { id: id, isCombineEnabled: isCombineEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $e69fa77bf557686c$var$invariant();
        !(target.isCombineEnabled !== isCombineEnabled) && $e69fa77bf557686c$var$invariant();
        const updated = {
            ...target,
            isCombineEnabled: isCombineEnabled
        };
        return $e69fa77bf557686c$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$e69fa77bf557686c$var$isMovementAllowed(state) && $e69fa77bf557686c$var$invariant();
        !state.isWindowScrollAllowed && $e69fa77bf557686c$var$invariant();
        const newScroll = action.payload.newScroll;
        if ($e69fa77bf557686c$var$isEqual$1(state.viewport.scroll.current, newScroll)) return $e69fa77bf557686c$var$removeScrollJumpRequest(state);
        const viewport = $e69fa77bf557686c$var$scrollViewport(state.viewport, newScroll);
        if ($e69fa77bf557686c$var$isSnapping(state)) return $e69fa77bf557686c$var$refreshSnap({
            state: state,
            viewport: viewport
        });
        return $e69fa77bf557686c$var$update({
            state: state,
            viewport: viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$e69fa77bf557686c$var$isMovementAllowed(state)) return state;
        const maxScroll = action.payload.maxScroll;
        if ($e69fa77bf557686c$var$isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        const withMaxScroll = {
            ...state.viewport,
            scroll: {
                ...state.viewport.scroll,
                max: maxScroll
            }
        };
        return {
            ...state,
            viewport: withMaxScroll
        };
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $e69fa77bf557686c$var$invariant();
        const result = $e69fa77bf557686c$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!result) return state;
        return $e69fa77bf557686c$var$update({
            state: state,
            impact: result.impact,
            clientSelection: result.clientSelection,
            scrollJumpRequest: result.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        const reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $e69fa77bf557686c$var$invariant();
        const newState = {
            ...state,
            phase: 'DROP_PENDING',
            isWaiting: true,
            reason: reason
        };
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        const { completed: completed, dropDuration: dropDuration, newHomeClientOffset: newHomeClientOffset } = action.payload;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $e69fa77bf557686c$var$invariant();
        const result = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result;
    }
    if (action.type === 'DROP_COMPLETE') {
        const { completed: completed } = action.payload;
        return {
            phase: 'IDLE',
            completed: completed,
            shouldFlush: false
        };
    }
    return state;
};
function $e69fa77bf557686c$var$guard(action, predicate) {
    return action instanceof Object && 'type' in action && action.type === predicate;
}
const $e69fa77bf557686c$var$beforeInitialCapture = (args)=>({
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    });
const $e69fa77bf557686c$var$lift$1 = (args)=>({
        type: 'LIFT',
        payload: args
    });
const $e69fa77bf557686c$var$initialPublish = (args)=>({
        type: 'INITIAL_PUBLISH',
        payload: args
    });
const $e69fa77bf557686c$var$publishWhileDragging = (args)=>({
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    });
const $e69fa77bf557686c$var$collectionStarting = ()=>({
        type: 'COLLECTION_STARTING',
        payload: null
    });
const $e69fa77bf557686c$var$updateDroppableScroll = (args)=>({
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    });
const $e69fa77bf557686c$var$updateDroppableIsEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    });
const $e69fa77bf557686c$var$updateDroppableIsCombineEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    });
const $e69fa77bf557686c$var$move = (args)=>({
        type: 'MOVE',
        payload: args
    });
const $e69fa77bf557686c$var$moveByWindowScroll = (args)=>({
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    });
const $e69fa77bf557686c$var$updateViewportMaxScroll = (args)=>({
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    });
const $e69fa77bf557686c$var$moveUp = ()=>({
        type: 'MOVE_UP',
        payload: null
    });
const $e69fa77bf557686c$var$moveDown = ()=>({
        type: 'MOVE_DOWN',
        payload: null
    });
const $e69fa77bf557686c$var$moveRight = ()=>({
        type: 'MOVE_RIGHT',
        payload: null
    });
const $e69fa77bf557686c$var$moveLeft = ()=>({
        type: 'MOVE_LEFT',
        payload: null
    });
const $e69fa77bf557686c$var$flush = ()=>({
        type: 'FLUSH',
        payload: null
    });
const $e69fa77bf557686c$var$animateDrop = (args)=>({
        type: 'DROP_ANIMATE',
        payload: args
    });
const $e69fa77bf557686c$var$completeDrop = (args)=>({
        type: 'DROP_COMPLETE',
        payload: args
    });
const $e69fa77bf557686c$var$drop = (args)=>({
        type: 'DROP',
        payload: args
    });
const $e69fa77bf557686c$var$dropPending = (args)=>({
        type: 'DROP_PENDING',
        payload: args
    });
const $e69fa77bf557686c$var$dropAnimationFinished = ()=>({
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    });
function $e69fa77bf557686c$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    const indexes = insideDestination.map((d)=>d.descriptor.index);
    const errors = {};
    for(let i = 1; i < indexes.length; i++){
        const current = indexes[i];
        const previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    const formatted = indexes.map((index)=>{
        const hasError = Boolean(errors[index]);
        return hasError ? `[\u{1F525}${index}]` : `${index}`;
    }).join(', ');
}
function $e69fa77bf557686c$var$validateDimensions(critical, dimensions) {}
var $e69fa77bf557686c$var$lift = (marshal)=>({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
                if (!$e69fa77bf557686c$var$guard(action, 'LIFT')) {
                    next(action);
                    return;
                }
                const { id: id, clientSelection: clientSelection, movementMode: movementMode } = action.payload;
                const initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($e69fa77bf557686c$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $e69fa77bf557686c$var$invariant();
                dispatch($e69fa77bf557686c$var$flush());
                dispatch($e69fa77bf557686c$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                const scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                const request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                const { critical: critical, dimensions: dimensions, viewport: viewport } = marshal.startPublishing(request);
                $e69fa77bf557686c$var$validateDimensions(critical, dimensions);
                dispatch($e69fa77bf557686c$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
var $e69fa77bf557686c$var$style = (marshal)=>()=>(next)=>(action)=>{
                if ($e69fa77bf557686c$var$guard(action, 'INITIAL_PUBLISH')) marshal.dragging();
                if ($e69fa77bf557686c$var$guard(action, 'DROP_ANIMATE')) marshal.dropping(action.payload.completed.result.reason);
                if ($e69fa77bf557686c$var$guard(action, 'FLUSH') || $e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE')) marshal.resting();
                next(action);
            };
const $e69fa77bf557686c$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
const $e69fa77bf557686c$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
const $e69fa77bf557686c$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
const $e69fa77bf557686c$var$outOfTheWayTiming = `${$e69fa77bf557686c$var$timings.outOfTheWay}s ${$e69fa77bf557686c$var$curves.outOfTheWay}`;
const $e69fa77bf557686c$var$transitions = {
    fluid: `opacity ${$e69fa77bf557686c$var$outOfTheWayTiming}`,
    snap: `transform ${$e69fa77bf557686c$var$outOfTheWayTiming}, opacity ${$e69fa77bf557686c$var$outOfTheWayTiming}`,
    drop: (duration)=>{
        const timing = `${duration}s ${$e69fa77bf557686c$var$curves.drop}`;
        return `transform ${timing}, opacity ${timing}`;
    },
    outOfTheWay: `transform ${$e69fa77bf557686c$var$outOfTheWayTiming}`,
    placeholder: `height ${$e69fa77bf557686c$var$outOfTheWayTiming}, width ${$e69fa77bf557686c$var$outOfTheWayTiming}, margin ${$e69fa77bf557686c$var$outOfTheWayTiming}`
};
const $e69fa77bf557686c$var$moveTo = (offset)=>$e69fa77bf557686c$var$isEqual$1(offset, $e69fa77bf557686c$var$origin) ? undefined : `translate(${offset.x}px, ${offset.y}px)`;
const $e69fa77bf557686c$var$transforms = {
    moveTo: $e69fa77bf557686c$var$moveTo,
    drop: (offset, isCombining)=>{
        const translate = $e69fa77bf557686c$var$moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return `${translate} scale(${$e69fa77bf557686c$var$combine.scale.drop})`;
    }
};
const { minDropTime: $e69fa77bf557686c$var$minDropTime, maxDropTime: $e69fa77bf557686c$var$maxDropTime } = $e69fa77bf557686c$var$timings;
const $e69fa77bf557686c$var$dropTimeRange = $e69fa77bf557686c$var$maxDropTime - $e69fa77bf557686c$var$minDropTime;
const $e69fa77bf557686c$var$maxDropTimeAtDistance = 1500;
const $e69fa77bf557686c$var$cancelDropModifier = 0.6;
var $e69fa77bf557686c$var$getDropDuration = ({ current: current, destination: destination, reason: reason })=>{
    const distance$1 = $e69fa77bf557686c$var$distance(current, destination);
    if (distance$1 <= 0) return $e69fa77bf557686c$var$minDropTime;
    if (distance$1 >= $e69fa77bf557686c$var$maxDropTimeAtDistance) return $e69fa77bf557686c$var$maxDropTime;
    const percentage = distance$1 / $e69fa77bf557686c$var$maxDropTimeAtDistance;
    const duration = $e69fa77bf557686c$var$minDropTime + $e69fa77bf557686c$var$dropTimeRange * percentage;
    const withDuration = reason === 'CANCEL' ? duration * $e69fa77bf557686c$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $e69fa77bf557686c$var$getNewHomeClientOffset = ({ impact: impact, draggable: draggable, dimensions: dimensions, viewport: viewport, afterCritical: afterCritical })=>{
    const { draggables: draggables, droppables: droppables } = dimensions;
    const droppableId = $e69fa77bf557686c$var$whatIsDraggedOver(impact);
    const destination = droppableId ? droppables[droppableId] : null;
    const home = droppables[draggable.descriptor.droppableId];
    const newClientCenter = $e69fa77bf557686c$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    const offset = $e69fa77bf557686c$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $e69fa77bf557686c$var$getDropImpact = ({ draggables: draggables, reason: reason, lastImpact: lastImpact, home: home, viewport: viewport, onLiftImpact: onLiftImpact })=>{
    if (!lastImpact.at || reason !== 'DROP') {
        const recomputedHomeImpact = $e69fa77bf557686c$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    const withoutMovement = {
        ...lastImpact,
        displaced: $e69fa77bf557686c$var$emptyGroups
    };
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
const $e69fa77bf557686c$var$dropMiddleware = ({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
            if (!$e69fa77bf557686c$var$guard(action, 'DROP')) {
                next(action);
                return;
            }
            const state = getState();
            const reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($e69fa77bf557686c$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            const isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $e69fa77bf557686c$var$invariant();
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $e69fa77bf557686c$var$invariant();
            const critical = state.critical;
            const dimensions = state.dimensions;
            const draggable = dimensions.draggables[state.critical.draggable.id];
            const { impact: impact, didDropInsideDroppable: didDropInsideDroppable } = $e69fa77bf557686c$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            });
            const destination = didDropInsideDroppable ? $e69fa77bf557686c$var$tryGetDestination(impact) : null;
            const combine = didDropInsideDroppable ? $e69fa77bf557686c$var$tryGetCombine(impact) : null;
            const source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            const result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            const newHomeClientOffset = $e69fa77bf557686c$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            const completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            const isAnimationRequired = !$e69fa77bf557686c$var$isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($e69fa77bf557686c$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            const dropDuration = $e69fa77bf557686c$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            const args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($e69fa77bf557686c$var$animateDrop(args));
        };
var $e69fa77bf557686c$var$getWindowScroll = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });
function $e69fa77bf557686c$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: (event)=>{
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $e69fa77bf557686c$var$getScrollListener({ onWindowScroll: onWindowScroll }) {
    function updateScroll() {
        onWindowScroll($e69fa77bf557686c$var$getWindowScroll());
    }
    const scheduled = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(updateScroll);
    const binding = $e69fa77bf557686c$var$getWindowScrollBinding(scheduled);
    let unbind = $e69fa77bf557686c$var$noop$2;
    function isActive() {
        return unbind !== $e69fa77bf557686c$var$noop$2;
    }
    function start() {
        !!isActive() && $e69fa77bf557686c$var$invariant();
        unbind = $e69fa77bf557686c$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $e69fa77bf557686c$var$invariant();
        scheduled.cancel();
        unbind();
        unbind = $e69fa77bf557686c$var$noop$2;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
const $e69fa77bf557686c$var$shouldStop$1 = (action)=>$e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE') || $e69fa77bf557686c$var$guard(action, 'DROP_ANIMATE') || $e69fa77bf557686c$var$guard(action, 'FLUSH');
const $e69fa77bf557686c$var$scrollListener = (store)=>{
    const listener = $e69fa77bf557686c$var$getScrollListener({
        onWindowScroll: (newScroll)=>{
            store.dispatch($e69fa77bf557686c$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return (next)=>(action)=>{
            if (!listener.isActive() && $e69fa77bf557686c$var$guard(action, 'INITIAL_PUBLISH')) listener.start();
            if (listener.isActive() && $e69fa77bf557686c$var$shouldStop$1(action)) listener.stop();
            next(action);
        };
};
var $e69fa77bf557686c$var$getExpiringAnnounce = (announce)=>{
    let wasCalled = false;
    let isExpired = false;
    const timeoutId = setTimeout(()=>{
        isExpired = true;
    });
    const result = (message)=>{
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = ()=>wasCalled;
    return result;
};
var $e69fa77bf557686c$var$getAsyncMarshal = ()=>{
    const entries = [];
    const execute = (timerId)=>{
        const index = entries.findIndex((item)=>item.timerId === timerId);
        !(index !== -1) && $e69fa77bf557686c$var$invariant();
        const [entry] = entries.splice(index, 1);
        entry.callback();
    };
    const add = (fn)=>{
        const timerId = setTimeout(()=>execute(timerId));
        const entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    const flush = ()=>{
        if (!entries.length) return;
        const shallow = [
            ...entries
        ];
        entries.length = 0;
        shallow.forEach((entry)=>{
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
const $e69fa77bf557686c$var$areLocationsEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
const $e69fa77bf557686c$var$isCombineEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
const $e69fa77bf557686c$var$isCriticalEqual = (first, second)=>{
    if (first === second) return true;
    const isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    const isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
const $e69fa77bf557686c$var$withTimings = (key, fn)=>{
    $e69fa77bf557686c$var$start();
    fn();
    $e69fa77bf557686c$var$finish();
};
const $e69fa77bf557686c$var$getDragStart = (critical, mode)=>({
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    });
function $e69fa77bf557686c$var$execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    const willExpire = $e69fa77bf557686c$var$getExpiringAnnounce(announce);
    const provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var $e69fa77bf557686c$var$getPublisher = (getResponders, announce)=>{
    const asyncMarshal = $e69fa77bf557686c$var$getAsyncMarshal();
    let dragging = null;
    const beforeCapture = (draggableId, mode)=>{
        !!dragging && $e69fa77bf557686c$var$invariant();
        $e69fa77bf557686c$var$withTimings('onBeforeCapture', ()=>{
            const fn = getResponders().onBeforeCapture;
            if (fn) {
                const before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    const beforeStart = (critical, mode)=>{
        !!dragging && $e69fa77bf557686c$var$invariant();
        $e69fa77bf557686c$var$withTimings('onBeforeDragStart', ()=>{
            const fn = getResponders().onBeforeDragStart;
            if (fn) fn($e69fa77bf557686c$var$getDragStart(critical, mode));
        });
    };
    const start = (critical, mode)=>{
        !!dragging && $e69fa77bf557686c$var$invariant();
        const data = $e69fa77bf557686c$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(()=>{
            $e69fa77bf557686c$var$withTimings('onDragStart', ()=>$e69fa77bf557686c$var$execute(getResponders().onDragStart, data, announce, $e69fa77bf557686c$var$preset.onDragStart));
        });
    };
    const update = (critical, impact)=>{
        const location = $e69fa77bf557686c$var$tryGetDestination(impact);
        const combine = $e69fa77bf557686c$var$tryGetCombine(impact);
        !dragging && $e69fa77bf557686c$var$invariant();
        const hasCriticalChanged = !$e69fa77bf557686c$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        const hasLocationChanged = !$e69fa77bf557686c$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        const hasGroupingChanged = !$e69fa77bf557686c$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        const data = {
            ...$e69fa77bf557686c$var$getDragStart(critical, dragging.mode),
            combine: combine,
            destination: location
        };
        asyncMarshal.add(()=>{
            $e69fa77bf557686c$var$withTimings('onDragUpdate', ()=>$e69fa77bf557686c$var$execute(getResponders().onDragUpdate, data, announce, $e69fa77bf557686c$var$preset.onDragUpdate));
        });
    };
    const flush = ()=>{
        !dragging && $e69fa77bf557686c$var$invariant();
        asyncMarshal.flush();
    };
    const drop = (result)=>{
        !dragging && $e69fa77bf557686c$var$invariant();
        dragging = null;
        $e69fa77bf557686c$var$withTimings('onDragEnd', ()=>$e69fa77bf557686c$var$execute(getResponders().onDragEnd, result, announce, $e69fa77bf557686c$var$preset.onDragEnd));
    };
    const abort = ()=>{
        if (!dragging) return;
        const result = {
            ...$e69fa77bf557686c$var$getDragStart(dragging.lastCritical, dragging.mode),
            combine: null,
            destination: null,
            reason: 'CANCEL'
        };
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $e69fa77bf557686c$var$responders = (getResponders, announce)=>{
    const publisher = $e69fa77bf557686c$var$getPublisher(getResponders, announce);
    return (store)=>(next)=>(action)=>{
                if ($e69fa77bf557686c$var$guard(action, 'BEFORE_INITIAL_CAPTURE')) {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if ($e69fa77bf557686c$var$guard(action, 'INITIAL_PUBLISH')) {
                    const critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if ($e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE')) {
                    const result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if ($e69fa77bf557686c$var$guard(action, 'FLUSH')) {
                    publisher.abort();
                    return;
                }
                const state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
};
const $e69fa77bf557686c$var$dropAnimationFinishMiddleware = (store)=>(next)=>(action)=>{
            if (!$e69fa77bf557686c$var$guard(action, 'DROP_ANIMATION_FINISHED')) {
                next(action);
                return;
            }
            const state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $e69fa77bf557686c$var$invariant();
            store.dispatch($e69fa77bf557686c$var$completeDrop({
                completed: state.completed
            }));
        };
const $e69fa77bf557686c$var$dropAnimationFlushOnScrollMiddleware = (store)=>{
    let unbind = null;
    let frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return (next)=>(action)=>{
            if ($e69fa77bf557686c$var$guard(action, 'FLUSH') || $e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE') || $e69fa77bf557686c$var$guard(action, 'DROP_ANIMATION_FINISHED')) clear();
            next(action);
            if (!$e69fa77bf557686c$var$guard(action, 'DROP_ANIMATE')) return;
            const binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    const state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($e69fa77bf557686c$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                unbind = $e69fa77bf557686c$var$bindEvents(window, [
                    binding
                ]);
            });
        };
};
var $e69fa77bf557686c$var$dimensionMarshalStopper = (marshal)=>()=>(next)=>(action)=>{
                if ($e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE') || $e69fa77bf557686c$var$guard(action, 'FLUSH') || $e69fa77bf557686c$var$guard(action, 'DROP_ANIMATE')) marshal.stopPublishing();
                next(action);
            };
var $e69fa77bf557686c$var$focus = (marshal)=>{
    let isWatching = false;
    return ()=>(next)=>(action)=>{
                if ($e69fa77bf557686c$var$guard(action, 'INITIAL_PUBLISH')) {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if ($e69fa77bf557686c$var$guard(action, 'FLUSH')) {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if ($e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE')) {
                    isWatching = false;
                    const result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
};
const $e69fa77bf557686c$var$shouldStop = (action)=>$e69fa77bf557686c$var$guard(action, 'DROP_COMPLETE') || $e69fa77bf557686c$var$guard(action, 'DROP_ANIMATE') || $e69fa77bf557686c$var$guard(action, 'FLUSH');
var $e69fa77bf557686c$var$autoScroll = (autoScroller)=>(store)=>(next)=>(action)=>{
                if ($e69fa77bf557686c$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if ($e69fa77bf557686c$var$guard(action, 'INITIAL_PUBLISH')) {
                    next(action);
                    const state = store.getState();
                    !(state.phase === 'DRAGGING') && $e69fa77bf557686c$var$invariant();
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
const $e69fa77bf557686c$var$pendingDrop = (store)=>(next)=>(action)=>{
            next(action);
            if (!$e69fa77bf557686c$var$guard(action, 'PUBLISH_WHILE_DRAGGING')) return;
            const postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($e69fa77bf557686c$var$drop({
                reason: postActionState.reason
            }));
        };
const $e69fa77bf557686c$var$composeEnhancers = (0, $78916fc80cd27125$export$f672e0b6f7222cd7);
var $e69fa77bf557686c$var$createStore = ({ dimensionMarshal: dimensionMarshal, focusMarshal: focusMarshal, styleMarshal: styleMarshal, getResponders: getResponders, announce: announce, autoScroller: autoScroller })=>(0, $78916fc80cd27125$export$f51a9068ac82ea43)($e69fa77bf557686c$var$reducer, $e69fa77bf557686c$var$composeEnhancers((0, $78916fc80cd27125$export$9ff26e0402cc7b7)($e69fa77bf557686c$var$style(styleMarshal), $e69fa77bf557686c$var$dimensionMarshalStopper(dimensionMarshal), $e69fa77bf557686c$var$lift(dimensionMarshal), $e69fa77bf557686c$var$dropMiddleware, $e69fa77bf557686c$var$dropAnimationFinishMiddleware, $e69fa77bf557686c$var$dropAnimationFlushOnScrollMiddleware, $e69fa77bf557686c$var$pendingDrop, $e69fa77bf557686c$var$autoScroll(autoScroller), $e69fa77bf557686c$var$scrollListener, $e69fa77bf557686c$var$focus(focusMarshal), $e69fa77bf557686c$var$responders(getResponders, announce))));
const $e69fa77bf557686c$var$clean$1 = ()=>({
        additions: {},
        removals: {},
        modified: {}
    });
function $e69fa77bf557686c$var$createPublisher({ registry: registry, callbacks: callbacks }) {
    let staging = $e69fa77bf557686c$var$clean$1();
    let frameId = null;
    const collect = ()=>{
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            $e69fa77bf557686c$var$start();
            const { additions: additions, removals: removals, modified: modified } = staging;
            const added = Object.keys(additions).map((id)=>registry.draggable.getById(id).getDimension($e69fa77bf557686c$var$origin)).sort((a, b)=>a.descriptor.index - b.descriptor.index);
            const updated = Object.keys(modified).map((id)=>{
                const entry = registry.droppable.getById(id);
                const scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            const result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $e69fa77bf557686c$var$clean$1();
            $e69fa77bf557686c$var$finish();
            callbacks.publish(result);
        });
    };
    const add = (entry)=>{
        const id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    const remove = (entry)=>{
        const descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    const stop = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $e69fa77bf557686c$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $e69fa77bf557686c$var$getMaxScroll = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = $e69fa77bf557686c$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $e69fa77bf557686c$var$getDocumentElement = ()=>{
    const doc = document.documentElement;
    !doc && $e69fa77bf557686c$var$invariant();
    return doc;
};
var $e69fa77bf557686c$var$getMaxWindowScroll = ()=>{
    const doc = $e69fa77bf557686c$var$getDocumentElement();
    const maxScroll = $e69fa77bf557686c$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $e69fa77bf557686c$var$getViewport = ()=>{
    const scroll = $e69fa77bf557686c$var$getWindowScroll();
    const maxScroll = $e69fa77bf557686c$var$getMaxWindowScroll();
    const top = scroll.y;
    const left = scroll.x;
    const doc = $e69fa77bf557686c$var$getDocumentElement();
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    const right = left + width;
    const bottom = top + height;
    const frame = (0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $e69fa77bf557686c$var$origin,
                displacement: $e69fa77bf557686c$var$origin
            }
        }
    };
    return viewport;
};
var $e69fa77bf557686c$var$getInitialPublish = ({ critical: critical, scrollOptions: scrollOptions, registry: registry })=>{
    $e69fa77bf557686c$var$start();
    const viewport = $e69fa77bf557686c$var$getViewport();
    const windowScroll = viewport.scroll.current;
    const home = critical.droppable;
    const droppables = registry.droppable.getAllByType(home.type).map((entry)=>entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions));
    const draggables = registry.draggable.getAllByType(critical.draggable.type).map((entry)=>entry.getDimension(windowScroll));
    const dimensions = {
        draggables: $e69fa77bf557686c$var$toDraggableMap(draggables),
        droppables: $e69fa77bf557686c$var$toDroppableMap(droppables)
    };
    $e69fa77bf557686c$var$finish();
    const result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $e69fa77bf557686c$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    const home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $e69fa77bf557686c$var$createDimensionMarshal = (registry, callbacks)=>{
    let collection = null;
    const publisher = $e69fa77bf557686c$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    const updateDroppableIsEnabled = (id, isEnabled)=>{
        !registry.droppable.exists(id) && $e69fa77bf557686c$var$invariant();
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    const updateDroppableIsCombineEnabled = (id, isCombineEnabled)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $e69fa77bf557686c$var$invariant();
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    const updateDroppableScroll = (id, newScroll)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $e69fa77bf557686c$var$invariant();
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    const scrollDroppable = (id, change)=>{
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    const stopPublishing = ()=>{
        if (!collection) return;
        publisher.stop();
        const home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach((entry)=>entry.callbacks.dragStopped());
        collection.unsubscribe();
        collection = null;
    };
    const subscriber = (event)=>{
        !collection && $e69fa77bf557686c$var$invariant();
        const dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($e69fa77bf557686c$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($e69fa77bf557686c$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    const startPublishing = (request)=>{
        !!collection && $e69fa77bf557686c$var$invariant();
        const entry = registry.draggable.getById(request.draggableId);
        const home = registry.droppable.getById(entry.descriptor.droppableId);
        const critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        const unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $e69fa77bf557686c$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    const marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $e69fa77bf557686c$var$canStartDrag = (state, id)=>{
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $e69fa77bf557686c$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $e69fa77bf557686c$var$getScrollableDroppables = $e69fa77bf557686c$var$memoizeOne((droppables)=>$e69fa77bf557686c$var$toDroppableList(droppables).filter((droppable)=>{
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    }));
const $e69fa77bf557686c$var$getScrollableDroppableOver = (target, droppables)=>{
    const maybe = $e69fa77bf557686c$var$getScrollableDroppables(droppables).find((droppable)=>{
        !droppable.frame && $e69fa77bf557686c$var$invariant();
        return $e69fa77bf557686c$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var $e69fa77bf557686c$var$getBestScrollableDroppable = ({ center: center, destination: destination, droppables: droppables })=>{
    if (destination) {
        const dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    const dimension = $e69fa77bf557686c$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
const $e69fa77bf557686c$var$defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: (percentage)=>percentage ** 2,
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var $e69fa77bf557686c$var$getDistanceThresholds = (container, axis, getAutoScrollerOptions = ()=>$e69fa77bf557686c$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    const maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $e69fa77bf557686c$var$getPercentage = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};
var $e69fa77bf557686c$var$minScroll = 1;
var $e69fa77bf557686c$var$getValueFromDistance = (distanceToEdge, thresholds, getAutoScrollerOptions = ()=>$e69fa77bf557686c$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $e69fa77bf557686c$var$minScroll;
    const percentageFromMaxScrollValueAt = $e69fa77bf557686c$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $e69fa77bf557686c$var$dampenValueByTime = (proposedScroll, dragStartTime, getAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    const stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    const startOfRange = dragStartTime;
    const endOfRange = stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return $e69fa77bf557686c$var$minScroll;
    const betweenAccelerateAtAndStopAtPercentage = $e69fa77bf557686c$var$getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $e69fa77bf557686c$var$getValue = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $e69fa77bf557686c$var$getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($e69fa77bf557686c$var$dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), $e69fa77bf557686c$var$minScroll);
};
var $e69fa77bf557686c$var$getScrollOnAxis = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const thresholds = $e69fa77bf557686c$var$getDistanceThresholds(container, axis, getAutoScrollerOptions);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $e69fa77bf557686c$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return -1 * $e69fa77bf557686c$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
};
var $e69fa77bf557686c$var$adjustForSizeLimits = ({ container: container, subject: subject, proposedScroll: proposedScroll })=>{
    const isTooBigVertically = subject.height > container.height;
    const isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
const $e69fa77bf557686c$var$clean = $e69fa77bf557686c$var$apply((value)=>value === 0 ? 0 : value);
var $e69fa77bf557686c$var$getScroll$1 = ({ dragStartTime: dragStartTime, container: container, subject: subject, center: center, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    const y = $e69fa77bf557686c$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $e69fa77bf557686c$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const x = $e69fa77bf557686c$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $e69fa77bf557686c$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const required = $e69fa77bf557686c$var$clean({
        x: x,
        y: y
    });
    if ($e69fa77bf557686c$var$isEqual$1(required, $e69fa77bf557686c$var$origin)) return null;
    const limited = $e69fa77bf557686c$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $e69fa77bf557686c$var$isEqual$1(limited, $e69fa77bf557686c$var$origin) ? null : limited;
};
const $e69fa77bf557686c$var$smallestSigned = $e69fa77bf557686c$var$apply((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $e69fa77bf557686c$var$getOverlap = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = $e69fa77bf557686c$var$add(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($e69fa77bf557686c$var$isEqual$1(overlap, $e69fa77bf557686c$var$origin)) return null;
        return overlap;
    };
})();
const $e69fa77bf557686c$var$canPartiallyScroll = ({ max: rawMax, current: current, change: change })=>{
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    const smallestChange = $e69fa77bf557686c$var$smallestSigned(change);
    const overlap = $e69fa77bf557686c$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $e69fa77bf557686c$var$canScrollWindow = (viewport, change)=>$e69fa77bf557686c$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $e69fa77bf557686c$var$getWindowOverlap = (viewport, change)=>{
    if (!$e69fa77bf557686c$var$canScrollWindow(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $e69fa77bf557686c$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
const $e69fa77bf557686c$var$canScrollDroppable = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return false;
    return $e69fa77bf557686c$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
const $e69fa77bf557686c$var$getDroppableOverlap = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return null;
    if (!$e69fa77bf557686c$var$canScrollDroppable(droppable, change)) return null;
    return $e69fa77bf557686c$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $e69fa77bf557686c$var$getWindowScrollChange = ({ viewport: viewport, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $e69fa77bf557686c$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $e69fa77bf557686c$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $e69fa77bf557686c$var$getDroppableScrollChange = ({ droppable: droppable, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const frame = droppable.frame;
    if (!frame) return null;
    const scroll = $e69fa77bf557686c$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $e69fa77bf557686c$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $e69fa77bf557686c$var$scroll = ({ state: state, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const center = state.current.page.borderBoxCenter;
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        const viewport = state.viewport;
        const change = $e69fa77bf557686c$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    const droppable = $e69fa77bf557686c$var$getBestScrollableDroppable({
        center: center,
        destination: $e69fa77bf557686c$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    const change = $e69fa77bf557686c$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $e69fa77bf557686c$var$createFluidScroller = ({ scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions = ()=>$e69fa77bf557686c$var$defaultAutoScrollerOptions })=>{
    const scheduleWindowScroll = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(scrollWindow);
    const scheduleDroppableScroll = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(scrollDroppable);
    let dragging = null;
    const tryScroll = (state)=>{
        !dragging && $e69fa77bf557686c$var$invariant();
        const { shouldUseTimeDampening: shouldUseTimeDampening, dragStartTime: dragStartTime } = dragging;
        $e69fa77bf557686c$var$scroll({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
    };
    const start$1 = (state)=>{
        $e69fa77bf557686c$var$start();
        !!dragging && $e69fa77bf557686c$var$invariant();
        const dragStartTime = Date.now();
        let wasScrollNeeded = false;
        const fakeScrollCallback = ()=>{
            wasScrollNeeded = true;
        };
        $e69fa77bf557686c$var$scroll({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $e69fa77bf557686c$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    const stop = ()=>{
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $e69fa77bf557686c$var$createJumpScroller = ({ move: move, scrollDroppable: scrollDroppable, scrollWindow: scrollWindow })=>{
    const moveByOffset = (state, offset)=>{
        const client = $e69fa77bf557686c$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    const scrollDroppableAsMuchAsItCan = (droppable, change)=>{
        if (!$e69fa77bf557686c$var$canScrollDroppable(droppable, change)) return change;
        const overlap = $e69fa77bf557686c$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        const whatTheDroppableCanScroll = $e69fa77bf557686c$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        const remainder = $e69fa77bf557686c$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    const scrollWindowAsMuchAsItCan = (isWindowScrollAllowed, viewport, change)=>{
        if (!isWindowScrollAllowed) return change;
        if (!$e69fa77bf557686c$var$canScrollWindow(viewport, change)) return change;
        const overlap = $e69fa77bf557686c$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        const whatTheWindowCanScroll = $e69fa77bf557686c$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        const remainder = $e69fa77bf557686c$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    const jumpScroller = (state)=>{
        const request = state.scrollJumpRequest;
        if (!request) return;
        const destination = $e69fa77bf557686c$var$whatIsDraggedOver(state.impact);
        !destination && $e69fa77bf557686c$var$invariant();
        const droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        const viewport = state.viewport;
        const windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $e69fa77bf557686c$var$createAutoScroller = ({ scrollDroppable: scrollDroppable, scrollWindow: scrollWindow, move: move, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const fluidScroller = $e69fa77bf557686c$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const jumpScroll = $e69fa77bf557686c$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    const scroll = (state)=>{
        const autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    const scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
const $e69fa77bf557686c$var$prefix = 'data-rfd';
const $e69fa77bf557686c$var$dragHandle = (()=>{
    const base = `${$e69fa77bf557686c$var$prefix}-drag-handle`;
    return {
        base: base,
        draggableId: `${base}-draggable-id`,
        contextId: `${base}-context-id`
    };
})();
const $e69fa77bf557686c$var$draggable = (()=>{
    const base = `${$e69fa77bf557686c$var$prefix}-draggable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $e69fa77bf557686c$var$droppable = (()=>{
    const base = `${$e69fa77bf557686c$var$prefix}-droppable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $e69fa77bf557686c$var$scrollContainer = {
    contextId: `${$e69fa77bf557686c$var$prefix}-scroll-container-context-id`
};
const $e69fa77bf557686c$var$makeGetSelector = (context)=>(attribute)=>`[${attribute}="${context}"]`;
const $e69fa77bf557686c$var$getStyles = (rules, property)=>rules.map((rule)=>{
        const value = rule.styles[property];
        if (!value) return '';
        return `${rule.selector} { ${value} }`;
    }).join(' ');
const $e69fa77bf557686c$var$noPointerEvents = 'pointer-events: none;';
var $e69fa77bf557686c$var$getStyles$1 = (contextId)=>{
    const getSelector = $e69fa77bf557686c$var$makeGetSelector(contextId);
    const dragHandle$1 = (()=>{
        const grabCursor = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
        return {
            selector: getSelector($e69fa77bf557686c$var$dragHandle.contextId),
            styles: {
                always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
                resting: grabCursor,
                dragging: $e69fa77bf557686c$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    })();
    const draggable$1 = (()=>{
        const transition = `
      transition: ${$e69fa77bf557686c$var$transitions.outOfTheWay};
    `;
        return {
            selector: getSelector($e69fa77bf557686c$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    })();
    const droppable$1 = {
        selector: getSelector($e69fa77bf557686c$var$droppable.contextId),
        styles: {
            always: `overflow-anchor: none;`
        }
    };
    const body = {
        selector: 'body',
        styles: {
            dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
        }
    };
    const rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $e69fa77bf557686c$var$getStyles(rules, 'always'),
        resting: $e69fa77bf557686c$var$getStyles(rules, 'resting'),
        dragging: $e69fa77bf557686c$var$getStyles(rules, 'dragging'),
        dropAnimating: $e69fa77bf557686c$var$getStyles(rules, 'dropAnimating'),
        userCancel: $e69fa77bf557686c$var$getStyles(rules, 'userCancel')
    };
};
const $e69fa77bf557686c$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
const $e69fa77bf557686c$var$getHead = ()=>{
    const head = document.querySelector('head');
    !head && $e69fa77bf557686c$var$invariant();
    return head;
};
const $e69fa77bf557686c$var$createStyleEl = (nonce)=>{
    const el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $e69fa77bf557686c$var$useStyleMarshal(contextId, nonce) {
    const styles = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$getStyles$1(contextId), [
        contextId
    ]);
    const alwaysRef = (0, $7fPBF.useRef)(null);
    const dynamicRef = (0, $7fPBF.useRef)(null);
    const setDynamicStyle = $e69fa77bf557686c$var$useCallback($e69fa77bf557686c$var$memoizeOne((proposed)=>{
        const el = dynamicRef.current;
        !el && $e69fa77bf557686c$var$invariant();
        el.textContent = proposed;
    }), []);
    const setAlwaysStyle = $e69fa77bf557686c$var$useCallback((proposed)=>{
        const el = alwaysRef.current;
        !el && $e69fa77bf557686c$var$invariant();
        el.textContent = proposed;
    }, []);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        !(!alwaysRef.current && !dynamicRef.current) && $e69fa77bf557686c$var$invariant();
        const always = $e69fa77bf557686c$var$createStyleEl(nonce);
        const dynamic = $e69fa77bf557686c$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(`${$e69fa77bf557686c$var$prefix}-always`, contextId);
        dynamic.setAttribute(`${$e69fa77bf557686c$var$prefix}-dynamic`, contextId);
        $e69fa77bf557686c$var$getHead().appendChild(always);
        $e69fa77bf557686c$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return ()=>{
            const remove = (ref)=>{
                const current = ref.current;
                !current && $e69fa77bf557686c$var$invariant();
                $e69fa77bf557686c$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    const dragging = $e69fa77bf557686c$var$useCallback(()=>setDynamicStyle(styles.dragging), [
        setDynamicStyle,
        styles.dragging
    ]);
    const dropping = $e69fa77bf557686c$var$useCallback((reason)=>{
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    const resting = $e69fa77bf557686c$var$useCallback(()=>{
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    const marshal = $e69fa77bf557686c$var$useMemo(()=>({
            dragging: dragging,
            dropping: dropping,
            resting: resting
        }), [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function $e69fa77bf557686c$var$querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var $e69fa77bf557686c$var$getWindowFromEl = (el)=>{
    if (el && el.ownerDocument && el.ownerDocument.defaultView) return el.ownerDocument.defaultView;
    return window;
};
function $e69fa77bf557686c$var$isHtmlElement(el) {
    return el instanceof $e69fa77bf557686c$var$getWindowFromEl(el).HTMLElement;
}
function $e69fa77bf557686c$var$findDragHandle(contextId, draggableId) {
    const selector = `[${$e69fa77bf557686c$var$dragHandle.contextId}="${contextId}"]`;
    const possible = $e69fa77bf557686c$var$querySelectorAll(document, selector);
    if (!possible.length) return null;
    const handle = possible.find((el)=>{
        return el.getAttribute($e69fa77bf557686c$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$e69fa77bf557686c$var$isHtmlElement(handle)) return null;
    return handle;
}
function $e69fa77bf557686c$var$useFocusMarshal(contextId) {
    const entriesRef = (0, $7fPBF.useRef)({});
    const recordRef = (0, $7fPBF.useRef)(null);
    const restoreFocusFrameRef = (0, $7fPBF.useRef)(null);
    const isMountedRef = (0, $7fPBF.useRef)(false);
    const register = $e69fa77bf557686c$var$useCallback(function register(id, focus) {
        const entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            const entries = entriesRef.current;
            const current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    const tryGiveFocus = $e69fa77bf557686c$var$useCallback(function tryGiveFocus(tryGiveFocusTo) {
        const handle = $e69fa77bf557686c$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    const tryShiftRecord = $e69fa77bf557686c$var$useCallback(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    const tryRestoreFocusRecorded = $e69fa77bf557686c$var$useCallback(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(()=>{
            restoreFocusFrameRef.current = null;
            const record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    const tryRecordFocus = $e69fa77bf557686c$var$useCallback(function tryRecordFocus(id) {
        recordRef.current = null;
        const focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($e69fa77bf557686c$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            const frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    const marshal = $e69fa77bf557686c$var$useMemo(()=>({
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        }), [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $e69fa77bf557686c$var$createRegistry() {
    const entries = {
        draggables: {},
        droppables: {}
    };
    const subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            const index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach((cb)=>cb(event));
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        const entry = findDraggableById(id);
        !entry && $e69fa77bf557686c$var$invariant();
        return entry;
    }
    const draggableAPI = {
        register: (entry)=>{
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: (entry, last)=>{
            const current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const draggableId = entry.descriptor.id;
            const current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: (id)=>Boolean(findDraggableById(id)),
        getAllByType: (type)=>Object.values(entries.draggables).filter((entry)=>entry.descriptor.type === type)
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        const entry = findDroppableById(id);
        !entry && $e69fa77bf557686c$var$invariant();
        return entry;
    }
    const droppableAPI = {
        register: (entry)=>{
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: (id)=>Boolean(findDroppableById(id)),
        getAllByType: (type)=>Object.values(entries.droppables).filter((entry)=>entry.descriptor.type === type)
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $e69fa77bf557686c$var$useRegistry() {
    const registry = $e69fa77bf557686c$var$useMemo($e69fa77bf557686c$var$createRegistry, []);
    (0, $7fPBF.useEffect)(()=>{
        return function unmount() {
            registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var $e69fa77bf557686c$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
var $e69fa77bf557686c$var$getBodyElement = ()=>{
    const body = document.body;
    !body && $e69fa77bf557686c$var$invariant();
    return body;
};
const $e69fa77bf557686c$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
const $e69fa77bf557686c$var$getId = (contextId)=>`rfd-announcement-${contextId}`;
function $e69fa77bf557686c$var$useAnnouncer(contextId) {
    const id = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$getId(contextId), [
        contextId
    ]);
    const ref = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function setup() {
        const el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        (0, $322affb888b76d16$export$2e2bcd8739ae039)(el.style, $e69fa77bf557686c$var$visuallyHidden);
        $e69fa77bf557686c$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                const body = $e69fa77bf557686c$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    const announce = $e69fa77bf557686c$var$useCallback((message)=>{
        const el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
const $e69fa77bf557686c$var$defaults = {
    separator: '::'
};
function $e69fa77bf557686c$var$useUniqueId(prefix, options = $e69fa77bf557686c$var$defaults) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId();
    return $e69fa77bf557686c$var$useMemo(()=>`${prefix}${options.separator}${id}`, [
        options.separator,
        prefix,
        id
    ]);
}
function $e69fa77bf557686c$var$getElementId({ contextId: contextId, uniqueId: uniqueId }) {
    return `rfd-hidden-text-${contextId}-${uniqueId}`;
}
function $e69fa77bf557686c$var$useHiddenTextElement({ contextId: contextId, text: text }) {
    const uniqueId = $e69fa77bf557686c$var$useUniqueId('hidden-text', {
        separator: '-'
    });
    const id = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        }), [
        uniqueId,
        contextId
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        const el = document.createElement('div');
        el.id = id;
        el.textContent = text;
        el.style.display = 'none';
        $e69fa77bf557686c$var$getBodyElement().appendChild(el);
        return function unmount() {
            const body = $e69fa77bf557686c$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $e69fa77bf557686c$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
var $e69fa77bf557686c$var$peerDependencies = {
    react: "^18.0.0 || ^19.0.0"
};
const $e69fa77bf557686c$var$semver = /(\d+)\.(\d+)\.(\d+)/;
const $e69fa77bf557686c$var$getVersion = (value)=>{
    const result = $e69fa77bf557686c$var$semver.exec(value);
    !(result != null) && $e69fa77bf557686c$var$invariant();
    const major = Number(result[1]);
    const minor = Number(result[2]);
    const patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
const $e69fa77bf557686c$var$isSatisfied = (expected, actual)=>{
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $e69fa77bf557686c$var$checkReactVersion = (peerDepValue, actualValue)=>{
    const peerDep = $e69fa77bf557686c$var$getVersion(peerDepValue);
    const actual = $e69fa77bf557686c$var$getVersion(actualValue);
    if ($e69fa77bf557686c$var$isSatisfied(peerDep, actual)) return;
};
const $e69fa77bf557686c$var$suffix = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var $e69fa77bf557686c$var$checkDoctype = (doc)=>{
    const doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $e69fa77bf557686c$var$useDev(useHook) {}
function $e69fa77bf557686c$var$useDevSetupWarning(fn, inputs) {
    $e69fa77bf557686c$var$useDev(()=>{
        (0, $7fPBF.useEffect)(()=>{
            try {
                fn();
            } catch (e) {
                $e69fa77bf557686c$var$error(`
          A setup problem was encountered.

          > ${e.message}
        `);
            }
        }, inputs);
    });
}
function $e69fa77bf557686c$var$useStartupValidation() {
    $e69fa77bf557686c$var$useDevSetupWarning(()=>{
        $e69fa77bf557686c$var$checkReactVersion($e69fa77bf557686c$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).version);
        $e69fa77bf557686c$var$checkDoctype(document);
    }, []);
}
function $e69fa77bf557686c$var$usePrevious(current) {
    const ref = (0, $7fPBF.useRef)(current);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = current;
    });
    return ref;
}
function $e69fa77bf557686c$var$create() {
    let lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $e69fa77bf557686c$var$invariant();
        const newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $e69fa77bf557686c$var$invariant();
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
function $e69fa77bf557686c$var$isDragging(state) {
    if (state.phase === 'IDLE' || state.phase === 'DROP_ANIMATING') return false;
    return state.isDragging;
}
const $e69fa77bf557686c$var$tab = 9;
const $e69fa77bf557686c$var$enter = 13;
const $e69fa77bf557686c$var$escape = 27;
const $e69fa77bf557686c$var$space = 32;
const $e69fa77bf557686c$var$pageUp = 33;
const $e69fa77bf557686c$var$pageDown = 34;
const $e69fa77bf557686c$var$end = 35;
const $e69fa77bf557686c$var$home = 36;
const $e69fa77bf557686c$var$arrowLeft = 37;
const $e69fa77bf557686c$var$arrowUp = 38;
const $e69fa77bf557686c$var$arrowRight = 39;
const $e69fa77bf557686c$var$arrowDown = 40;
const $e69fa77bf557686c$var$preventedKeys = {
    [$e69fa77bf557686c$var$enter]: true,
    [$e69fa77bf557686c$var$tab]: true
};
var $e69fa77bf557686c$var$preventStandardKeyEvents = (event)=>{
    if ($e69fa77bf557686c$var$preventedKeys[event.keyCode]) event.preventDefault();
};
const $e69fa77bf557686c$var$supportedEventName = (()=>{
    const base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        `ms${base}`,
        `webkit${base}`,
        `moz${base}`,
        `o${base}`
    ];
    const supported = candidates.find((eventName)=>`on${eventName}` in document);
    return supported || base;
})();
const $e69fa77bf557686c$var$primaryButton = 0;
const $e69fa77bf557686c$var$sloppyClickThreshold = 5;
function $e69fa77bf557686c$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $e69fa77bf557686c$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $e69fa77bf557686c$var$sloppyClickThreshold;
}
const $e69fa77bf557686c$var$idle$1 = {
    type: 'IDLE'
};
function $e69fa77bf557686c$var$getCaptureBindings({ cancel: cancel, completed: completed, getPhase: getPhase, setPhase: setPhase }) {
    return [
        {
            eventName: 'mousemove',
            fn: (event)=>{
                const { button: button, clientX: clientX, clientY: clientY } = event;
                if (button !== $e69fa77bf557686c$var$primaryButton) return;
                const point = {
                    x: clientX,
                    y: clientY
                };
                const phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $e69fa77bf557686c$var$invariant();
                const pending = phase.point;
                if (!$e69fa77bf557686c$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                const actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: (event)=>{
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $e69fa77bf557686c$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: ()=>{
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && $e69fa77bf557686c$var$invariant();
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $e69fa77bf557686c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e69fa77bf557686c$export$2f59cd992b42195a(api) {
    const phaseRef = (0, $7fPBF.useRef)($e69fa77bf557686c$var$idle$1);
    const unbindEventsRef = (0, $7fPBF.useRef)($e69fa77bf557686c$var$noop$2);
    const startCaptureBinding = $e69fa77bf557686c$var$useMemo(()=>({
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $e69fa77bf557686c$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                const point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const preventForcePressBinding = $e69fa77bf557686c$var$useMemo(()=>({
            eventName: 'webkitmouseforcewillbegin',
            fn: (event)=>{
                if (event.defaultPrevented) return;
                const id = api.findClosestDraggableId(event);
                if (!id) return;
                const options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        }), [
        api
    ]);
    const listenForCapture = $e69fa77bf557686c$var$useCallback(function listenForCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $e69fa77bf557686c$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    const stop = $e69fa77bf557686c$var$useCallback(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $e69fa77bf557686c$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    const cancel = $e69fa77bf557686c$var$useCallback(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = $e69fa77bf557686c$var$useCallback(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const bindings = $e69fa77bf557686c$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: ()=>phaseRef.current,
            setPhase: (phase)=>{
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $e69fa77bf557686c$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    const startPendingDrag = $e69fa77bf557686c$var$useCallback(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $e69fa77bf557686c$var$invariant();
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function $e69fa77bf557686c$var$noop$1() {}
const $e69fa77bf557686c$var$scrollJumpKeys = {
    [$e69fa77bf557686c$var$pageDown]: true,
    [$e69fa77bf557686c$var$pageUp]: true,
    [$e69fa77bf557686c$var$home]: true,
    [$e69fa77bf557686c$var$end]: true
};
function $e69fa77bf557686c$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (event.keyCode === $e69fa77bf557686c$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($e69fa77bf557686c$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $e69fa77bf557686c$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $e69fa77bf557686c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e69fa77bf557686c$export$42b74264faad0714(api) {
    const unbindEventsRef = (0, $7fPBF.useRef)($e69fa77bf557686c$var$noop$1);
    const startCaptureBinding = $e69fa77bf557686c$var$useMemo(()=>({
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $e69fa77bf557686c$var$space) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                let isCapturing = true;
                const actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $e69fa77bf557686c$var$invariant();
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $e69fa77bf557686c$var$bindEvents(window, $e69fa77bf557686c$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        }), [
        api
    ]);
    const listenForCapture = $e69fa77bf557686c$var$useCallback(function tryStartCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $e69fa77bf557686c$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
const $e69fa77bf557686c$var$idle = {
    type: 'IDLE'
};
const $e69fa77bf557686c$var$timeForLongPress = 120;
const $e69fa77bf557686c$var$forcePressThreshold = 0.15;
function $e69fa77bf557686c$var$getWindowBindings({ cancel: cancel, getPhase: getPhase }) {
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: (event)=>{
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $e69fa77bf557686c$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $e69fa77bf557686c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e69fa77bf557686c$var$getHandleBindings({ cancel: cancel, completed: completed, getPhase: getPhase }) {
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                const { clientX: clientX, clientY: clientY } = event.touches[0];
                const point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && $e69fa77bf557686c$var$invariant();
                const touch = event.touches[0];
                if (!touch) return;
                const isForcePress = touch.force >= $e69fa77bf557686c$var$forcePressThreshold;
                if (!isForcePress) return;
                const shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $e69fa77bf557686c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e69fa77bf557686c$export$ac235fd3a7bcf7b4(api) {
    const phaseRef = (0, $7fPBF.useRef)($e69fa77bf557686c$var$idle);
    const unbindEventsRef = (0, $7fPBF.useRef)($e69fa77bf557686c$var$noop$2);
    const getPhase = $e69fa77bf557686c$var$useCallback(function getPhase() {
        return phaseRef.current;
    }, []);
    const setPhase = $e69fa77bf557686c$var$useCallback(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    const startCaptureBinding = $e69fa77bf557686c$var$useMemo(()=>({
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                const touch = event.touches[0];
                const { clientX: clientX, clientY: clientY } = touch;
                const point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const listenForCapture = $e69fa77bf557686c$var$useCallback(function listenForCapture() {
        const options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $e69fa77bf557686c$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    const stop = $e69fa77bf557686c$var$useCallback(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($e69fa77bf557686c$var$idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    const cancel = $e69fa77bf557686c$var$useCallback(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = $e69fa77bf557686c$var$useCallback(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        const unbindTarget = $e69fa77bf557686c$var$bindEvents(window, $e69fa77bf557686c$var$getHandleBindings(args), options);
        const unbindWindow = $e69fa77bf557686c$var$bindEvents(window, $e69fa77bf557686c$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    const startDragging = $e69fa77bf557686c$var$useCallback(function startDragging() {
        const phase = getPhase();
        !(phase.type === 'PENDING') && $e69fa77bf557686c$var$invariant();
        const actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    const startPendingDrag = $e69fa77bf557686c$var$useCallback(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $e69fa77bf557686c$var$invariant();
        const longPressTimerId = setTimeout(startDragging, $e69fa77bf557686c$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            const phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($e69fa77bf557686c$var$idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(function webkitHack() {
        const unbind = $e69fa77bf557686c$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: ()=>{},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $e69fa77bf557686c$var$useValidateSensorHooks(sensorHooks) {
    $e69fa77bf557686c$var$useDev(()=>{
        const previousRef = $e69fa77bf557686c$var$usePrevious(sensorHooks);
        $e69fa77bf557686c$var$useDevSetupWarning(()=>{
            !(previousRef.current.length === sensorHooks.length) && $e69fa77bf557686c$var$invariant(false);
        });
    });
}
const $e69fa77bf557686c$var$interactiveTagNames = [
    'input',
    'button',
    'textarea',
    'select',
    'option',
    'optgroup',
    'video',
    'audio'
];
function $e69fa77bf557686c$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    const hasAnInteractiveTag = $e69fa77bf557686c$var$interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    const attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $e69fa77bf557686c$var$isAnInteractiveElement(parent, current.parentElement);
}
function $e69fa77bf557686c$var$isEventInInteractiveElement(draggable, event) {
    const target = event.target;
    if (!$e69fa77bf557686c$var$isHtmlElement(target)) return false;
    return $e69fa77bf557686c$var$isAnInteractiveElement(draggable, target);
}
var $e69fa77bf557686c$var$getBorderBoxCenterPosition = (el)=>(0, $81e8d04f0c2ee44f$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
function $e69fa77bf557686c$var$isElement(el) {
    return el instanceof $e69fa77bf557686c$var$getWindowFromEl(el).Element;
}
const $e69fa77bf557686c$var$supportedMatchesName = (()=>{
    const base = 'matches';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    const value = candidates.find((name)=>name in Element.prototype);
    return value || base;
})();
function $e69fa77bf557686c$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$e69fa77bf557686c$var$supportedMatchesName](selector)) return el;
    return $e69fa77bf557686c$var$closestPonyfill(el.parentElement, selector);
}
function $e69fa77bf557686c$var$closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return $e69fa77bf557686c$var$closestPonyfill(el, selector);
}
function $e69fa77bf557686c$var$getSelector(contextId) {
    return `[${$e69fa77bf557686c$var$dragHandle.contextId}="${contextId}"]`;
}
function $e69fa77bf557686c$var$findClosestDragHandleFromEvent(contextId, event) {
    const target = event.target;
    if (!$e69fa77bf557686c$var$isElement(target)) return null;
    const selector = $e69fa77bf557686c$var$getSelector(contextId);
    const handle = $e69fa77bf557686c$var$closest(target, selector);
    if (!handle) return null;
    if (!$e69fa77bf557686c$var$isHtmlElement(handle)) return null;
    return handle;
}
function $e69fa77bf557686c$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    const handle = $e69fa77bf557686c$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($e69fa77bf557686c$var$dragHandle.draggableId);
}
function $e69fa77bf557686c$var$findDraggable(contextId, draggableId) {
    const selector = `[${$e69fa77bf557686c$var$draggable.contextId}="${contextId}"]`;
    const possible = $e69fa77bf557686c$var$querySelectorAll(document, selector);
    const draggable$1 = possible.find((el)=>{
        return el.getAttribute($e69fa77bf557686c$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$e69fa77bf557686c$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $e69fa77bf557686c$var$preventDefault(event) {
    event.preventDefault();
}
function $e69fa77bf557686c$var$isActive({ expected: expected, phase: phase, isLockActive: isLockActive, shouldWarn: shouldWarn }) {
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $e69fa77bf557686c$var$canStart({ lockAPI: lockAPI, store: store, registry: registry, draggableId: draggableId }) {
    if (lockAPI.isClaimed()) return false;
    const entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$e69fa77bf557686c$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $e69fa77bf557686c$var$tryStart({ lockAPI: lockAPI, contextId: contextId, store: store, registry: registry, draggableId: draggableId, forceSensorStop: forceSensorStop, sourceEvent: sourceEvent }) {
    const shouldStart = $e69fa77bf557686c$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    const entry = registry.draggable.getById(draggableId);
    const el = $e69fa77bf557686c$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $e69fa77bf557686c$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    const lock = lockAPI.claim(forceSensorStop || $e69fa77bf557686c$var$noop$2);
    let phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($e69fa77bf557686c$var$isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    const tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            $e69fa77bf557686c$var$invariant();
        }
        store.dispatch($e69fa77bf557686c$var$lift$1(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options = {
            shouldBlockNextClick: false
        }) {
            args.cleanup();
            if (options.shouldBlockNextClick) {
                const unbind = $e69fa77bf557686c$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $e69fa77bf557686c$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($e69fa77bf557686c$var$drop({
                reason: reason
            }));
        }
        return {
            isActive: ()=>$e69fa77bf557686c$var$isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                }),
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: (options)=>finish('DROP', options),
            cancel: (options)=>finish('CANCEL', options),
            ...args.actions
        };
    }
    function fluidLift(clientSelection) {
        const move$1 = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)((client)=>{
            tryDispatchWhenDragging(()=>$e69fa77bf557686c$var$move({
                    client: client
                }));
        });
        const api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: ()=>move$1.cancel(),
            actions: {
                move: move$1
            }
        });
        return {
            ...api,
            move: move$1
        };
    }
    function snapLift() {
        const actions = {
            moveUp: ()=>tryDispatchWhenDragging($e69fa77bf557686c$var$moveUp),
            moveRight: ()=>tryDispatchWhenDragging($e69fa77bf557686c$var$moveRight),
            moveDown: ()=>tryDispatchWhenDragging($e69fa77bf557686c$var$moveDown),
            moveLeft: ()=>tryDispatchWhenDragging($e69fa77bf557686c$var$moveLeft)
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $e69fa77bf557686c$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $e69fa77bf557686c$var$noop$2,
            actions: actions
        });
    }
    function abortPreDrag() {
        const shouldRelease = $e69fa77bf557686c$var$isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    const preDrag = {
        isActive: ()=>$e69fa77bf557686c$var$isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            }),
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
const $e69fa77bf557686c$var$defaultSensors = [
    $e69fa77bf557686c$export$2f59cd992b42195a,
    $e69fa77bf557686c$export$42b74264faad0714,
    $e69fa77bf557686c$export$ac235fd3a7bcf7b4
];
function $e69fa77bf557686c$var$useSensorMarshal({ contextId: contextId, store: store, registry: registry, customSensors: customSensors, enableDefaultSensors: enableDefaultSensors }) {
    const useSensors = [
        ...enableDefaultSensors ? $e69fa77bf557686c$var$defaultSensors : [],
        ...customSensors || []
    ];
    const lockAPI = (0, $7fPBF.useState)(()=>$e69fa77bf557686c$var$create())[0];
    const tryAbandonLock = $e69fa77bf557686c$var$useCallback(function tryAbandonLock(previous, current) {
        if ($e69fa77bf557686c$var$isDragging(previous) && !$e69fa77bf557686c$var$isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(function listenToStore() {
        let previous = store.getState();
        const unsubscribe = store.subscribe(()=>{
            const current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    const canGetLock = $e69fa77bf557686c$var$useCallback((draggableId)=>{
        return $e69fa77bf557686c$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    const tryGetLock = $e69fa77bf557686c$var$useCallback((draggableId, forceStop, options)=>$e69fa77bf557686c$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        }), [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    const findClosestDraggableId = $e69fa77bf557686c$var$useCallback((event)=>$e69fa77bf557686c$var$tryGetClosestDraggableIdFromEvent(contextId, event), [
        contextId
    ]);
    const findOptionsForDraggable = $e69fa77bf557686c$var$useCallback((id)=>{
        const entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    const tryReleaseLock = $e69fa77bf557686c$var$useCallback(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== 'IDLE') store.dispatch($e69fa77bf557686c$var$flush());
    }, [
        lockAPI,
        store
    ]);
    const isLockClaimed = $e69fa77bf557686c$var$useCallback(()=>lockAPI.isClaimed(), [
        lockAPI
    ]);
    const api = $e69fa77bf557686c$var$useMemo(()=>({
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        }), [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $e69fa77bf557686c$var$useValidateSensorHooks(useSensors);
    for(let i = 0; i < useSensors.length; i++)useSensors[i](api);
}
const $e69fa77bf557686c$var$createResponders = (props)=>({
        onBeforeCapture: (t)=>{
            const onBeforeCapureCallback = ()=>{
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            (0, $fw0lo.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    });
const $e69fa77bf557686c$var$createAutoScrollerOptions = (props)=>({
        ...$e69fa77bf557686c$var$defaultAutoScrollerOptions,
        ...props.autoScrollerOptions,
        durationDampening: {
            ...$e69fa77bf557686c$var$defaultAutoScrollerOptions.durationDampening,
            ...props.autoScrollerOptions
        }
    });
function $e69fa77bf557686c$var$getStore(lazyRef) {
    !lazyRef.current && $e69fa77bf557686c$var$invariant();
    return lazyRef.current;
}
function $e69fa77bf557686c$var$App(props) {
    const { contextId: contextId, setCallbacks: setCallbacks, sensors: sensors, nonce: nonce, dragHandleUsageInstructions: dragHandleUsageInstructions } = props;
    const lazyStoreRef = (0, $7fPBF.useRef)(null);
    $e69fa77bf557686c$var$useStartupValidation();
    const lastPropsRef = $e69fa77bf557686c$var$usePrevious(props);
    const getResponders = $e69fa77bf557686c$var$useCallback(()=>{
        return $e69fa77bf557686c$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const getAutoScrollerOptions = $e69fa77bf557686c$var$useCallback(()=>{
        return $e69fa77bf557686c$var$createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const announce = $e69fa77bf557686c$var$useAnnouncer(contextId);
    const dragHandleUsageInstructionsId = $e69fa77bf557686c$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    const styleMarshal = $e69fa77bf557686c$var$useStyleMarshal(contextId, nonce);
    const lazyDispatch = $e69fa77bf557686c$var$useCallback((action)=>{
        $e69fa77bf557686c$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    const marshalCallbacks = $e69fa77bf557686c$var$useMemo(()=>(0, $78916fc80cd27125$export$aea084d96e84da92)({
            publishWhileDragging: $e69fa77bf557686c$var$publishWhileDragging,
            updateDroppableScroll: $e69fa77bf557686c$var$updateDroppableScroll,
            updateDroppableIsEnabled: $e69fa77bf557686c$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $e69fa77bf557686c$var$updateDroppableIsCombineEnabled,
            collectionStarting: $e69fa77bf557686c$var$collectionStarting
        }, lazyDispatch), [
        lazyDispatch
    ]);
    const registry = $e69fa77bf557686c$var$useRegistry();
    const dimensionMarshal = $e69fa77bf557686c$var$useMemo(()=>{
        return $e69fa77bf557686c$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    const autoScroller = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$createAutoScroller({
            scrollWindow: $e69fa77bf557686c$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions: getAutoScrollerOptions,
            ...(0, $78916fc80cd27125$export$aea084d96e84da92)({
                move: $e69fa77bf557686c$var$move
            }, lazyDispatch)
        }), [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    const focusMarshal = $e69fa77bf557686c$var$useFocusMarshal(contextId);
    const store = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        }), [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    const tryResetStore = $e69fa77bf557686c$var$useCallback(()=>{
        const current = $e69fa77bf557686c$var$getStore(lazyStoreRef);
        const state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($e69fa77bf557686c$var$flush());
    }, []);
    const isDragging = $e69fa77bf557686c$var$useCallback(()=>{
        const state = $e69fa77bf557686c$var$getStore(lazyStoreRef).getState();
        if (state.phase === 'DROP_ANIMATING') return true;
        if (state.phase === 'IDLE') return false;
        return state.isDragging;
    }, []);
    const appCallbacks = $e69fa77bf557686c$var$useMemo(()=>({
            isDragging: isDragging,
            tryAbort: tryResetStore
        }), [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    const getCanLift = $e69fa77bf557686c$var$useCallback((id)=>$e69fa77bf557686c$var$canStartDrag($e69fa77bf557686c$var$getStore(lazyStoreRef).getState(), id), []);
    const getIsMovementAllowed = $e69fa77bf557686c$var$useCallback(()=>$e69fa77bf557686c$var$isMovementAllowed($e69fa77bf557686c$var$getStore(lazyStoreRef).getState()), []);
    const appContext = $e69fa77bf557686c$var$useMemo(()=>({
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        }), [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $e69fa77bf557686c$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $7fPBF.useEffect)(()=>{
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f30b917334351296$export$2881499e37b75b9a), {
        context: $e69fa77bf557686c$var$StoreContext,
        store: store
    }, props.children));
}
function $e69fa77bf557686c$var$useUniqueContextId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId();
}
function $e69fa77bf557686c$export$237bd83162c14364(props) {
    const contextId = $e69fa77bf557686c$var$useUniqueContextId();
    const dragHandleUsageInstructions = props.dragHandleUsageInstructions || $e69fa77bf557686c$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$ErrorBoundary, null, (setCallbacks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children));
}
const $e69fa77bf557686c$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
const $e69fa77bf557686c$var$getDraggingTransition = (shouldAnimateDragMovement, dropping)=>{
    if (dropping) return $e69fa77bf557686c$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $e69fa77bf557686c$var$transitions.snap;
    return $e69fa77bf557686c$var$transitions.fluid;
};
const $e69fa77bf557686c$var$getDraggingOpacity = (isCombining, isDropAnimating)=>{
    if (!isCombining) return undefined;
    return isDropAnimating ? $e69fa77bf557686c$var$combine.opacity.drop : $e69fa77bf557686c$var$combine.opacity.combining;
};
const $e69fa77bf557686c$var$getShouldDraggingAnimate = (dragging)=>{
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $e69fa77bf557686c$var$getDraggingStyle(dragging) {
    const dimension = dragging.dimension;
    const box = dimension.client;
    const { offset: offset, combineWith: combineWith, dropping: dropping } = dragging;
    const isCombining = Boolean(combineWith);
    const shouldAnimate = $e69fa77bf557686c$var$getShouldDraggingAnimate(dragging);
    const isDropAnimating = Boolean(dropping);
    const transform = isDropAnimating ? $e69fa77bf557686c$var$transforms.drop(offset, isCombining) : $e69fa77bf557686c$var$transforms.moveTo(offset);
    const style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $e69fa77bf557686c$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $e69fa77bf557686c$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $e69fa77bf557686c$var$zIndexOptions.dropAnimating : $e69fa77bf557686c$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $e69fa77bf557686c$var$getSecondaryStyle(secondary) {
    return {
        transform: $e69fa77bf557686c$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : 'none'
    };
}
function $e69fa77bf557686c$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $e69fa77bf557686c$var$getDraggingStyle(mapped) : $e69fa77bf557686c$var$getSecondaryStyle(mapped);
}
function $e69fa77bf557686c$var$getDimension$1(descriptor, el, windowScroll = $e69fa77bf557686c$var$origin) {
    const computedStyles = window.getComputedStyle(el);
    const borderBox = el.getBoundingClientRect();
    const client = (0, $81e8d04f0c2ee44f$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    const page = (0, $81e8d04f0c2ee44f$export$1d0caec378d7d0ae)(client, windowScroll);
    const placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    const displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    const dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $e69fa77bf557686c$var$useDraggablePublisher(args) {
    const uniqueId = $e69fa77bf557686c$var$useUniqueId('draggable');
    const { descriptor: descriptor, registry: registry, getDraggableRef: getDraggableRef, canDragInteractiveElements: canDragInteractiveElements, shouldRespectForcePress: shouldRespectForcePress, isEnabled: isEnabled } = args;
    const options = $e69fa77bf557686c$var$useMemo(()=>({
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        }), [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    const getDimension = $e69fa77bf557686c$var$useCallback((windowScroll)=>{
        const el = getDraggableRef();
        !el && $e69fa77bf557686c$var$invariant();
        return $e69fa77bf557686c$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    const entry = $e69fa77bf557686c$var$useMemo(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        }), [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    const publishedRef = (0, $7fPBF.useRef)(entry);
    const isFirstPublishRef = (0, $7fPBF.useRef)(true);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        registry.draggable.register(publishedRef.current);
        return ()=>registry.draggable.unregister(publishedRef.current);
    }, [
        registry.draggable
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        const last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var $e69fa77bf557686c$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
function $e69fa77bf557686c$var$checkIsValidInnerRef(el) {
    !(el && $e69fa77bf557686c$var$isHtmlElement(el)) && $e69fa77bf557686c$var$invariant();
}
function $e69fa77bf557686c$var$useValidation$1(props, contextId, getRef) {
    $e69fa77bf557686c$var$useDevSetupWarning(()=>{
        function prefix(id) {
            return `Draggable[id: ${id}]: `;
        }
        const id = props.draggableId;
        !id && $e69fa77bf557686c$var$invariant(false);
        !(typeof id === 'string') && $e69fa77bf557686c$var$invariant(false);
        !Number.isInteger(props.index) && $e69fa77bf557686c$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $e69fa77bf557686c$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$e69fa77bf557686c$var$findDragHandle(contextId, id) && $e69fa77bf557686c$var$invariant(false);
    });
}
function $e69fa77bf557686c$var$useClonePropValidation(isClone) {
    $e69fa77bf557686c$var$useDev(()=>{
        const initialRef = (0, $7fPBF.useRef)(isClone);
        $e69fa77bf557686c$var$useDevSetupWarning(()=>{
            !(isClone === initialRef.current) && $e69fa77bf557686c$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $e69fa77bf557686c$var$useRequiredContext(Context) {
    const result = (0, $7fPBF.useContext)(Context);
    !result && $e69fa77bf557686c$var$invariant();
    return result;
}
function $e69fa77bf557686c$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
const $e69fa77bf557686c$var$Draggable = (props)=>{
    const ref = (0, $7fPBF.useRef)(null);
    const setRef = $e69fa77bf557686c$var$useCallback((el = null)=>{
        ref.current = el;
    }, []);
    const getRef = $e69fa77bf557686c$var$useCallback(()=>ref.current, []);
    const { contextId: contextId, dragHandleUsageInstructionsId: dragHandleUsageInstructionsId, registry: registry } = $e69fa77bf557686c$var$useRequiredContext($e69fa77bf557686c$var$AppContext);
    const { type: type, droppableId: droppableId } = $e69fa77bf557686c$var$useRequiredContext($e69fa77bf557686c$var$DroppableContext);
    const descriptor = $e69fa77bf557686c$var$useMemo(()=>({
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        }), [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    const { children: children, draggableId: draggableId, isEnabled: isEnabled, shouldRespectForcePress: shouldRespectForcePress, canDragInteractiveElements: canDragInteractiveElements, isClone: isClone, mapped: mapped, dropAnimationFinished: dropAnimationFinishedAction } = props;
    $e69fa77bf557686c$var$useValidation$1(props, contextId, getRef);
    $e69fa77bf557686c$var$useClonePropValidation(isClone);
    if (!isClone) {
        const forPublisher = $e69fa77bf557686c$var$useMemo(()=>({
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            }), [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $e69fa77bf557686c$var$useDraggablePublisher(forPublisher);
    }
    const dragHandleProps = $e69fa77bf557686c$var$useMemo(()=>isEnabled ? {
            tabIndex: 0,
            role: 'button',
            'aria-describedby': dragHandleUsageInstructionsId,
            'data-rfd-drag-handle-draggable-id': draggableId,
            'data-rfd-drag-handle-context-id': contextId,
            draggable: false,
            onDragStart: $e69fa77bf557686c$var$preventHtml5Dnd
        } : null, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    const onMoveEnd = $e69fa77bf557686c$var$useCallback((event)=>{
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        (0, $fw0lo.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    const provided = $e69fa77bf557686c$var$useMemo(()=>{
        const style = $e69fa77bf557686c$var$getStyle$1(mapped);
        const onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : undefined;
        const result = {
            innerRef: setRef,
            draggableProps: {
                'data-rfd-draggable-context-id': contextId,
                'data-rfd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    const rubric = $e69fa77bf557686c$var$useMemo(()=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }), [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var $e69fa77bf557686c$var$isStrictEqual = (a, b)=>a === b;
var $e69fa77bf557686c$var$whatIsDraggedOverFromResult = (result)=>{
    const { combine: combine, destination: destination } = result;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
const $e69fa77bf557686c$var$getCombineWithFromResult = (result)=>{
    return result.combine ? result.combine.draggableId : null;
};
const $e69fa77bf557686c$var$getCombineWithFromImpact = (impact)=>{
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $e69fa77bf557686c$var$getDraggableSelector() {
    const memoizedOffset = $e69fa77bf557686c$var$memoizeOne((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = $e69fa77bf557686c$var$memoizeOne((mode, isClone, draggingOver = null, combineWith = null, dropping = null)=>({
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        }));
    const getMemoizedProps = $e69fa77bf557686c$var$memoizeOne((offset, mode, dimension, isClone, draggingOver = null, combineWith = null, forceShouldAnimate = null)=>({
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        }));
    const selector = (state, ownProps)=>{
        if ($e69fa77bf557686c$var$isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            const offset = state.current.client.offset;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const draggingOver = $e69fa77bf557686c$var$whatIsDraggedOver(state.impact);
            const combineWith = $e69fa77bf557686c$var$getCombineWithFromImpact(state.impact);
            const forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            const isClone = ownProps.isClone;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const result = completed.result;
            const mode = result.mode;
            const draggingOver = $e69fa77bf557686c$var$whatIsDraggedOverFromResult(result);
            const combineWith = $e69fa77bf557686c$var$getCombineWithFromResult(result);
            const duration = state.dropDuration;
            const dropping = {
                duration: duration,
                curve: $e69fa77bf557686c$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith ? $e69fa77bf557686c$var$combine.opacity.drop : null,
                scale: combineWith ? $e69fa77bf557686c$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: dimension,
                    dropping: dropping,
                    draggingOver: draggingOver,
                    combineWith: combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $e69fa77bf557686c$var$getSecondarySnapshot(combineTargetFor = null) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
const $e69fa77bf557686c$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $e69fa77bf557686c$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $e69fa77bf557686c$var$getSecondarySnapshot(null)
    }
};
function $e69fa77bf557686c$var$getSecondarySelector() {
    const memoizedOffset = $e69fa77bf557686c$var$memoizeOne((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = $e69fa77bf557686c$var$memoizeOne($e69fa77bf557686c$var$getSecondarySnapshot);
    const getMemoizedProps = $e69fa77bf557686c$var$memoizeOne((offset, combineTargetFor = null, shouldAnimateDisplacement)=>({
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        }));
    const getFallback = (combineTargetFor)=>{
        return combineTargetFor ? getMemoizedProps($e69fa77bf557686c$var$origin, combineTargetFor, true) : null;
    };
    const getProps = (ownId, draggingId, impact, afterCritical)=>{
        const visualDisplacement = impact.displaced.visible[ownId];
        const isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        const combine = $e69fa77bf557686c$var$tryGetCombine(impact);
        const combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            const change = $e69fa77bf557686c$var$negate(afterCritical.displacedBy.point);
            const offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        const displaceBy = impact.displacedBy.point;
        const offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    const selector = (state, ownProps)=>{
        if ($e69fa77bf557686c$var$isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
const $e69fa77bf557686c$var$makeMapStateToProps$1 = ()=>{
    const draggingSelector = $e69fa77bf557686c$var$getDraggableSelector();
    const secondarySelector = $e69fa77bf557686c$var$getSecondarySelector();
    const selector = (state, ownProps)=>draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $e69fa77bf557686c$var$atRest;
    return selector;
};
const $e69fa77bf557686c$var$mapDispatchToProps$1 = {
    dropAnimationFinished: $e69fa77bf557686c$var$dropAnimationFinished
};
const $e69fa77bf557686c$var$ConnectedDraggable = (0, $f30b917334351296$export$64605811ab45167f)($e69fa77bf557686c$var$makeMapStateToProps$1, $e69fa77bf557686c$var$mapDispatchToProps$1, null, {
    context: $e69fa77bf557686c$var$StoreContext,
    areStatePropsEqual: $e69fa77bf557686c$var$isStrictEqual
})($e69fa77bf557686c$var$Draggable);
function $e69fa77bf557686c$var$PrivateDraggable(props) {
    const droppableContext = $e69fa77bf557686c$var$useRequiredContext($e69fa77bf557686c$var$DroppableContext);
    const isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$ConnectedDraggable, props);
}
function $e69fa77bf557686c$export$f2a139e5d18b9882(props) {
    const isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    const canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    const shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$PrivateDraggable, (0, $322affb888b76d16$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
const $e69fa77bf557686c$var$isEqual = (base)=>(value)=>base === value;
const $e69fa77bf557686c$var$isScroll = $e69fa77bf557686c$var$isEqual('scroll');
const $e69fa77bf557686c$var$isAuto = $e69fa77bf557686c$var$isEqual('auto');
const $e69fa77bf557686c$var$isVisible = $e69fa77bf557686c$var$isEqual('visible');
const $e69fa77bf557686c$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $e69fa77bf557686c$var$isBoth = (overflow, fn)=>fn(overflow.overflowX) && fn(overflow.overflowY);
const $e69fa77bf557686c$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $e69fa77bf557686c$var$isEither(overflow, $e69fa77bf557686c$var$isScroll) || $e69fa77bf557686c$var$isEither(overflow, $e69fa77bf557686c$var$isAuto);
};
const $e69fa77bf557686c$var$isBodyScrollable = ()=>{
    return false;
};
const $e69fa77bf557686c$var$getClosestScrollable = (el)=>{
    if (el == null) return null;
    if (el === document.body) return $e69fa77bf557686c$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$e69fa77bf557686c$var$isElementScrollable(el)) return $e69fa77bf557686c$var$getClosestScrollable(el.parentElement);
    return el;
};
var $e69fa77bf557686c$var$checkForNestedScrollContainers = (scrollable)=>{
    if (!scrollable) return;
    const anotherScrollParent = $e69fa77bf557686c$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $e69fa77bf557686c$var$getScroll = (el)=>({
        x: el.scrollLeft,
        y: el.scrollTop
    });
const $e69fa77bf557686c$var$getIsFixed = (el)=>{
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return $e69fa77bf557686c$var$getIsFixed(el.parentElement);
};
var $e69fa77bf557686c$var$getEnv = (start)=>{
    const closestScrollable = $e69fa77bf557686c$var$getClosestScrollable(start);
    const isFixedOnPage = $e69fa77bf557686c$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $e69fa77bf557686c$var$getDroppableDimension = ({ descriptor: descriptor, isEnabled: isEnabled, isCombineEnabled: isCombineEnabled, isFixedOnPage: isFixedOnPage, direction: direction, client: client, page: page, closest: closest })=>{
    const frame = (()=>{
        if (!closest) return null;
        const { scrollSize: scrollSize, client: frameClient } = closest;
        const maxScroll = $e69fa77bf557686c$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $e69fa77bf557686c$var$origin,
                    displacement: $e69fa77bf557686c$var$origin
                }
            }
        };
    })();
    const axis = direction === 'vertical' ? $e69fa77bf557686c$var$vertical : $e69fa77bf557686c$var$horizontal;
    const subject = $e69fa77bf557686c$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    const dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
const $e69fa77bf557686c$var$getClient = (targetRef, closestScrollable)=>{
    const base = (0, $81e8d04f0c2ee44f$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    const top = base.paddingBox.top - closestScrollable.scrollTop;
    const left = base.paddingBox.left - closestScrollable.scrollLeft;
    const bottom = top + closestScrollable.scrollHeight;
    const right = left + closestScrollable.scrollWidth;
    const paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    const borderBox = (0, $81e8d04f0c2ee44f$export$9f77e0932fb78f72)(paddingBox, base.border);
    const client = (0, $81e8d04f0c2ee44f$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $e69fa77bf557686c$var$getDimension = ({ ref: ref, descriptor: descriptor, env: env, windowScroll: windowScroll, direction: direction, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, shouldClipSubject: shouldClipSubject })=>{
    const closestScrollable = env.closestScrollable;
    const client = $e69fa77bf557686c$var$getClient(ref, closestScrollable);
    const page = (0, $81e8d04f0c2ee44f$export$1d0caec378d7d0ae)(client, windowScroll);
    const closest = (()=>{
        if (!closestScrollable) return null;
        const frameClient = (0, $81e8d04f0c2ee44f$export$34928e660d2a8702)(closestScrollable);
        const scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $81e8d04f0c2ee44f$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $e69fa77bf557686c$var$getScroll(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    })();
    const dimension = $e69fa77bf557686c$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
const $e69fa77bf557686c$var$immediate = {
    passive: false
};
const $e69fa77bf557686c$var$delayed = {
    passive: true
};
var $e69fa77bf557686c$var$getListenerOptions = (options)=>options.shouldPublishImmediately ? $e69fa77bf557686c$var$immediate : $e69fa77bf557686c$var$delayed;
const $e69fa77bf557686c$var$getClosestScrollableFromDrag = (dragging)=>dragging && dragging.env.closestScrollable || null;
function $e69fa77bf557686c$var$useDroppablePublisher(args) {
    const whileDraggingRef = (0, $7fPBF.useRef)(null);
    const appContext = $e69fa77bf557686c$var$useRequiredContext($e69fa77bf557686c$var$AppContext);
    const uniqueId = $e69fa77bf557686c$var$useUniqueId('droppable');
    const { registry: registry, marshal: marshal } = appContext;
    const previousRef = $e69fa77bf557686c$var$usePrevious(args);
    const descriptor = $e69fa77bf557686c$var$useMemo(()=>({
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        }), [
        args.droppableId,
        args.mode,
        args.type
    ]);
    const publishedDescriptorRef = (0, $7fPBF.useRef)(descriptor);
    const memoizedUpdateScroll = $e69fa77bf557686c$var$useMemo(()=>$e69fa77bf557686c$var$memoizeOne((x, y)=>{
            !whileDraggingRef.current && $e69fa77bf557686c$var$invariant();
            const scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        }), [
        descriptor.id,
        marshal
    ]);
    const getClosestScroll = $e69fa77bf557686c$var$useCallback(()=>{
        const dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $e69fa77bf557686c$var$origin;
        return $e69fa77bf557686c$var$getScroll(dragging.env.closestScrollable);
    }, []);
    const updateScroll = $e69fa77bf557686c$var$useCallback(()=>{
        const scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    const scheduleScrollUpdate = $e69fa77bf557686c$var$useMemo(()=>(0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(updateScroll), [
        updateScroll
    ]);
    const onClosestScroll = $e69fa77bf557686c$var$useCallback(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $e69fa77bf557686c$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $e69fa77bf557686c$var$invariant();
        const options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    const getDimensionAndWatchScroll = $e69fa77bf557686c$var$useCallback((windowScroll, options)=>{
        !!whileDraggingRef.current && $e69fa77bf557686c$var$invariant();
        const previous = previousRef.current;
        const ref = previous.getDroppableRef();
        !ref && $e69fa77bf557686c$var$invariant();
        const env = $e69fa77bf557686c$var$getEnv(ref);
        const dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        const dimension = $e69fa77bf557686c$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        const scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($e69fa77bf557686c$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $e69fa77bf557686c$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    const getScrollWhileDragging = $e69fa77bf557686c$var$useCallback(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $e69fa77bf557686c$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $e69fa77bf557686c$var$invariant();
        return $e69fa77bf557686c$var$getScroll(closest);
    }, []);
    const dragStopped = $e69fa77bf557686c$var$useCallback(()=>{
        const dragging = whileDraggingRef.current;
        !dragging && $e69fa77bf557686c$var$invariant();
        const closest = $e69fa77bf557686c$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($e69fa77bf557686c$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $e69fa77bf557686c$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    const scroll = $e69fa77bf557686c$var$useCallback((change)=>{
        const dragging = whileDraggingRef.current;
        !dragging && $e69fa77bf557686c$var$invariant();
        const closest = $e69fa77bf557686c$var$getClosestScrollableFromDrag(dragging);
        !closest && $e69fa77bf557686c$var$invariant();
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    const callbacks = $e69fa77bf557686c$var$useMemo(()=>{
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    const entry = $e69fa77bf557686c$var$useMemo(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        }), [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return ()=>{
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $e69fa77bf557686c$var$useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $e69fa77bf557686c$var$noop() {}
const $e69fa77bf557686c$var$empty = {
    width: 0,
    height: 0,
    margin: $e69fa77bf557686c$var$noSpacing
};
const $e69fa77bf557686c$var$getSize = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    if (isAnimatingOpenOnMount) return $e69fa77bf557686c$var$empty;
    if (animate === 'close') return $e69fa77bf557686c$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
const $e69fa77bf557686c$var$getStyle = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    const size = $e69fa77bf557686c$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $e69fa77bf557686c$var$transitions.placeholder : null
    };
};
const $e69fa77bf557686c$var$Placeholder = (props)=>{
    const animateOpenTimerRef = (0, $7fPBF.useRef)(null);
    const tryClearAnimateOpenTimer = $e69fa77bf557686c$var$useCallback(()=>{
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    const { animate: animate, onTransitionEnd: onTransitionEnd, onClose: onClose, contextId: contextId } = props;
    const [isAnimatingOpenOnMount, setIsAnimatingOpenOnMount] = (0, $7fPBF.useState)(props.animate === 'open');
    (0, $7fPBF.useEffect)(()=>{
        if (!isAnimatingOpenOnMount) return $e69fa77bf557686c$var$noop;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $e69fa77bf557686c$var$noop;
        }
        if (animateOpenTimerRef.current) return $e69fa77bf557686c$var$noop;
        animateOpenTimerRef.current = setTimeout(()=>{
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    const onSizeChangeEnd = $e69fa77bf557686c$var$useCallback((event)=>{
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    const style = $e69fa77bf557686c$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rfd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var $e69fa77bf557686c$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($e69fa77bf557686c$var$Placeholder);
function $e69fa77bf557686c$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $e69fa77bf557686c$var$runChecks(args, checks) {
    checks.forEach((check)=>check(args));
}
const $e69fa77bf557686c$var$shared = [
    function required({ props: props }) {
        !props.droppableId && $e69fa77bf557686c$var$invariant();
        !(typeof props.droppableId === 'string') && $e69fa77bf557686c$var$invariant();
    },
    function boolean({ props: props }) {
        !$e69fa77bf557686c$var$isBoolean(props.isDropDisabled) && $e69fa77bf557686c$var$invariant();
        !$e69fa77bf557686c$var$isBoolean(props.isCombineEnabled) && $e69fa77bf557686c$var$invariant();
        !$e69fa77bf557686c$var$isBoolean(props.ignoreContainerClipping) && $e69fa77bf557686c$var$invariant();
    },
    function ref({ getDroppableRef: getDroppableRef }) {
        $e69fa77bf557686c$var$checkIsValidInnerRef(getDroppableRef());
    }
];
const $e69fa77bf557686c$var$standard = [
    function placeholder({ props: props, getPlaceholderRef: getPlaceholderRef }) {
        if (!props.placeholder) return;
        const ref = getPlaceholderRef();
        if (ref) return;
    }
];
const $e69fa77bf557686c$var$virtual = [
    function hasClone({ props: props }) {
        !props.renderClone && $e69fa77bf557686c$var$invariant();
    },
    function hasNoPlaceholder({ getPlaceholderRef: getPlaceholderRef }) {
        !!getPlaceholderRef() && $e69fa77bf557686c$var$invariant();
    }
];
function $e69fa77bf557686c$var$useValidation(args) {
    $e69fa77bf557686c$var$useDevSetupWarning(()=>{
        $e69fa77bf557686c$var$runChecks(args, $e69fa77bf557686c$var$shared);
        if (args.props.mode === 'standard') $e69fa77bf557686c$var$runChecks(args, $e69fa77bf557686c$var$standard);
        if (args.props.mode === 'virtual') $e69fa77bf557686c$var$runChecks(args, $e69fa77bf557686c$var$virtual);
    });
}
class $e69fa77bf557686c$var$AnimateInOut extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            isVisible: Boolean(this.props.on),
            data: this.props.on,
            animate: this.props.shouldAnimate && this.props.on ? 'open' : 'none'
        };
        this.onClose = ()=>{
            if (this.state.animate !== 'close') return;
            this.setState({
                isVisible: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    }
    render() {
        if (!this.state.isVisible) return null;
        const provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    }
}
const $e69fa77bf557686c$var$Droppable = (props)=>{
    const appContext = (0, $7fPBF.useContext)($e69fa77bf557686c$var$AppContext);
    !appContext && $e69fa77bf557686c$var$invariant();
    const { contextId: contextId, isMovementAllowed: isMovementAllowed } = appContext;
    const droppableRef = (0, $7fPBF.useRef)(null);
    const placeholderRef = (0, $7fPBF.useRef)(null);
    const { children: children, droppableId: droppableId, type: type, mode: mode, direction: direction, ignoreContainerClipping: ignoreContainerClipping, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, snapshot: snapshot, useClone: useClone, updateViewportMaxScroll: updateViewportMaxScroll, getContainerForClone: getContainerForClone } = props;
    const getDroppableRef = $e69fa77bf557686c$var$useCallback(()=>droppableRef.current, []);
    const setDroppableRef = $e69fa77bf557686c$var$useCallback((value = null)=>{
        droppableRef.current = value;
    }, []);
    const getPlaceholderRef = $e69fa77bf557686c$var$useCallback(()=>placeholderRef.current, []);
    const setPlaceholderRef = $e69fa77bf557686c$var$useCallback((value = null)=>{
        placeholderRef.current = value;
    }, []);
    $e69fa77bf557686c$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    const onPlaceholderTransitionEnd = $e69fa77bf557686c$var$useCallback(()=>{
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $e69fa77bf557686c$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $e69fa77bf557686c$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    const placeholder = $e69fa77bf557686c$var$useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, ({ onClose: onClose, data: data, animate: animate })=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            })), [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    const provided = $e69fa77bf557686c$var$useMemo(()=>({
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rfd-droppable-id': droppableId,
                'data-rfd-droppable-context-id': contextId
            }
        }), [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    const isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    const droppableContext = $e69fa77bf557686c$var$useMemo(()=>({
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        }), [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        const { dragging: dragging, render: render } = useClone;
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, (draggableProvided, draggableSnapshot)=>render(draggableProvided, draggableSnapshot, dragging));
        return (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e69fa77bf557686c$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
function $e69fa77bf557686c$var$getBody() {
    !document.body && $e69fa77bf557686c$var$invariant();
    return document.body;
}
const $e69fa77bf557686c$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $e69fa77bf557686c$var$getBody
};
const $e69fa77bf557686c$var$attachDefaultPropsToOwnProps = (ownProps)=>{
    let mergedProps = {
        ...ownProps
    };
    let defaultPropKey;
    for(defaultPropKey in $e69fa77bf557686c$var$defaultProps)if (ownProps[defaultPropKey] === undefined) mergedProps = {
        ...mergedProps,
        [defaultPropKey]: $e69fa77bf557686c$var$defaultProps[defaultPropKey]
    };
    return mergedProps;
};
const $e69fa77bf557686c$var$isMatchingType = (type, critical)=>type === critical.droppable.type;
const $e69fa77bf557686c$var$getDraggable = (critical, dimensions)=>dimensions.draggables[critical.draggable.id];
const $e69fa77bf557686c$var$makeMapStateToProps = ()=>{
    const idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    const idleWithoutAnimation = {
        ...idleWithAnimation,
        shouldAnimatePlaceholder: false
    };
    const getDraggableRubric = $e69fa77bf557686c$var$memoizeOne((descriptor)=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }));
    const getMapProps = $e69fa77bf557686c$var$memoizeOne((id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone)=>{
        const draggableId = dragging.descriptor.id;
        const isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            const useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            const snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        const snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    const selector = (state, ownProps)=>{
        const ownPropsWithDefaultProps = $e69fa77bf557686c$var$attachDefaultPropsToOwnProps(ownProps);
        const id = ownPropsWithDefaultProps.droppableId;
        const type = ownPropsWithDefaultProps.type;
        const isEnabled = !ownPropsWithDefaultProps.isDropDisabled;
        const renderClone = ownPropsWithDefaultProps.renderClone;
        if ($e69fa77bf557686c$var$isDragging(state)) {
            const critical = state.critical;
            if (!$e69fa77bf557686c$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            const dragging = $e69fa77bf557686c$var$getDraggable(critical, state.dimensions);
            const isDraggingOver = $e69fa77bf557686c$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (!$e69fa77bf557686c$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const dragging = $e69fa77bf557686c$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $e69fa77bf557686c$var$whatIsDraggedOverFromResult(completed.result) === id, $e69fa77bf557686c$var$whatIsDraggedOver(completed.impact) === id, dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            const completed = state.completed;
            if (!$e69fa77bf557686c$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const wasOver = $e69fa77bf557686c$var$whatIsDraggedOver(completed.impact) === id;
            const wasCombining = Boolean(completed.impact.at && completed.impact.at.type === 'COMBINE');
            const isHome = completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
const $e69fa77bf557686c$var$mapDispatchToProps = {
    updateViewportMaxScroll: $e69fa77bf557686c$var$updateViewportMaxScroll
};
const $e69fa77bf557686c$export$423ec2075359570a = (0, $f30b917334351296$export$64605811ab45167f)($e69fa77bf557686c$var$makeMapStateToProps, $e69fa77bf557686c$var$mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
    return {
        ...$e69fa77bf557686c$var$attachDefaultPropsToOwnProps(ownProps),
        ...stateProps,
        ...dispatchProps
    };
}, {
    context: $e69fa77bf557686c$var$StoreContext,
    areStatePropsEqual: $e69fa77bf557686c$var$isStrictEqual
})($e69fa77bf557686c$var$Droppable);






function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}


function $f4ec6dc17078088c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $759553f6ee74cd0d$export$2e2bcd8739ae039(value) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $505ebcb184373782$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $05b104d2fa74b1c7$export$2e2bcd8739ae039(argument) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $505ebcb184373782$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $374216e389d08fec$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $759553f6ee74cd0d$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $c41ae7eb91efecef$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $bd716e10292c6930$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $34348cf8fa5b62a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $afb60d42de991571$var$MILLISECONDS_IN_DAY = 86400000;
function $afb60d42de991571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $afb60d42de991571$var$MILLISECONDS_IN_DAY) + 1;
}





function $365301764998b714$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $518eb844f291f762$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $41042352236130d1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $518eb844f291f762$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK = 604800000;
function $b0bdf1d2df59ff38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $365301764998b714$export$2e2bcd8739ae039)(date).getTime() - (0, $41042352236130d1$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK) + 1;
}







var $677412d78fecbb8b$var$defaultOptions = {};
function $677412d78fecbb8b$export$430a3269e24b912e() {
    return $677412d78fecbb8b$var$defaultOptions;
}
function $677412d78fecbb8b$export$95365be1b0704abc(newOptions) {
    $677412d78fecbb8b$var$defaultOptions = newOptions;
}


function $66392cbb34f04ad9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $bf632f7e6fcf0087$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $37d853466602e505$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK = 604800000;
function $57d2e8e06c23527b$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options).getTime() - (0, $37d853466602e505$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK) + 1;
}



function $598d25c1f2e4f194$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8845d2e14e26c506$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8845d2e14e26c506$export$2e2bcd8739ae039 = $8845d2e14e26c506$var$formatters;


var $71a1c96437171265$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $71a1c96437171265$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $518eb844f291f762$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $afb60d42de991571$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $71a1c96437171265$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(minutes, 2);
}
function $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter);
}
function $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $71a1c96437171265$export$2e2bcd8739ae039 = $71a1c96437171265$var$formatters;


var $eeef144218f64d7d$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $eeef144218f64d7d$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $eeef144218f64d7d$var$timeLongFormatter(timePattern, formatLong));
};
var $eeef144218f64d7d$var$longFormatters = {
    p: $eeef144218f64d7d$var$timeLongFormatter,
    P: $eeef144218f64d7d$var$dateTimeLongFormatter
};
var $eeef144218f64d7d$export$2e2bcd8739ae039 = $eeef144218f64d7d$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a197590075b6aa6e$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $12a3ea762b495ad3$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $12a3ea762b495ad3$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $12a3ea762b495ad3$export$c6cc36aa33304772(token) {
    return $12a3ea762b495ad3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$c6b49d6dceb604a1(token) {
    return $12a3ea762b495ad3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}






var $e94e6c2283c04dc4$export$2e2bcd8739ae039 = (0, $fbb6af908147d006$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0918c9925a326e99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0918c9925a326e99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0918c9925a326e99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0918c9925a326e99$var$doubleQuoteRegExp = /''/g;
var $0918c9925a326e99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0918c9925a326e99$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $374216e389d08fec$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0918c9925a326e99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($0918c9925a326e99$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0918c9925a326e99$var$cleanEscapedString(substring);
        var formatter = (0, $71a1c96437171265$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0918c9925a326e99$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0918c9925a326e99$var$cleanEscapedString(input) {
    var matched = input.match($0918c9925a326e99$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($0918c9925a326e99$var$doubleQuoteRegExp, "'");
}



parcelRequire("7fPBF");
var $f6e19cb76f766aa9$exports = {};

$parcel$export($f6e19cb76f766aa9$exports, "grades", function () { return $f6e19cb76f766aa9$export$b38e924bce9c0643; }, function (v) { return $f6e19cb76f766aa9$export$b38e924bce9c0643 = v; });
$parcel$export($f6e19cb76f766aa9$exports, "name", function () { return $f6e19cb76f766aa9$export$a8ff84c12d48cfa6; }, function (v) { return $f6e19cb76f766aa9$export$a8ff84c12d48cfa6 = v; });
$parcel$export($f6e19cb76f766aa9$exports, "subtitle", function () { return $f6e19cb76f766aa9$export$c96745152eb2740f; }, function (v) { return $f6e19cb76f766aa9$export$c96745152eb2740f = v; });
$parcel$export($f6e19cb76f766aa9$exports, "ul", function () { return $f6e19cb76f766aa9$export$b5023c870cb34848; }, function (v) { return $f6e19cb76f766aa9$export$b5023c870cb34848 = v; });
var $f6e19cb76f766aa9$export$b38e924bce9c0643;
var $f6e19cb76f766aa9$export$a8ff84c12d48cfa6;
var $f6e19cb76f766aa9$export$c96745152eb2740f;
var $f6e19cb76f766aa9$export$b5023c870cb34848;
$f6e19cb76f766aa9$export$b38e924bce9c0643 = `yNDAiG_grades`;
$f6e19cb76f766aa9$export$a8ff84c12d48cfa6 = `yNDAiG_name`;
$f6e19cb76f766aa9$export$c96745152eb2740f = `yNDAiG_subtitle`;
$f6e19cb76f766aa9$export$b5023c870cb34848 = `yNDAiG_ul`;




const $b1e446eddc14c9e3$export$e6d01a6f594c803 = ({ albumCount: albumCount, disableHeader: disableHeader })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            !disableHeader && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6a8c189b782c624$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6e19cb76f766aa9$exports))).subheader,
                sx: {
                    backgroundColor: theme.palette.background.default,
                    lineHeight: 2
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {})
            }),
            Array.from({
                length: albumCount ?? 20
            }, (_, number)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f6e19cb76f766aa9$exports))).ul,
                            style: {
                                backgroundColor: theme.palette.background.paper
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                style: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                        variant: "rectangular",
                                        width: 64,
                                        height: 64
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        flexGrow: 1,
                                        sx: {
                                            marginTop: "-4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6e19cb76f766aa9$exports))).name
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6e19cb76f766aa9$exports))).subtitle
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6e19cb76f766aa9$exports))).grades
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                    ]
                }, `li_${number}`))
        ]
    });
};



parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $3cb45b8a02634c3b$var$GridContext = /*#__PURE__*/ $7fPBF.createContext();
var $3cb45b8a02634c3b$export$2e2bcd8739ae039 = $3cb45b8a02634c3b$var$GridContext;




function $e896bfd9730b7f7a$export$9973ac5fd0181f33(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiGrid', slot);
}
const $e896bfd9730b7f7a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e896bfd9730b7f7a$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $e896bfd9730b7f7a$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $e896bfd9730b7f7a$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $e896bfd9730b7f7a$var$gridClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$e896bfd9730b7f7a$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$e896bfd9730b7f7a$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$e896bfd9730b7f7a$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $e896bfd9730b7f7a$export$2e2bcd8739ae039 = $e896bfd9730b7f7a$var$gridClasses;



'use client';
const $7fa4a4d669bc53fb$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $7fa4a4d669bc53fb$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $7fa4a4d669bc53fb$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $7fa4a4d669bc53fb$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $7fa4a4d669bc53fb$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $91ad95ac62846a03$export$980e6a259d807490)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $91ad95ac62846a03$export$88347efdb2e19abd)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $7fa4a4d669bc53fb$var$GridRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $7fa4a4d669bc53fb$export$71d4225eeb1bc13e, $7fa4a4d669bc53fb$export$380604d7c79f9e8f, $7fa4a4d669bc53fb$export$4315fba5128fb4a1, $7fa4a4d669bc53fb$export$ca2a698f6020fda);
function $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $7fa4a4d669bc53fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $e896bfd9730b7f7a$export$9973ac5fd0181f33), classes);
};
const $7fa4a4d669bc53fb$var$Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7fa4a4d669bc53fb$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $7fPBF.useContext((0, $3cb45b8a02634c3b$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $7fa4a4d669bc53fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3cb45b8a02634c3b$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fa4a4d669bc53fb$var$GridRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $7fa4a4d669bc53fb$export$2e2bcd8739ae039 = $7fa4a4d669bc53fb$var$Grid;


var $49542784eddf849d$exports = {};

$parcel$export($49542784eddf849d$exports, "grid", function () { return $49542784eddf849d$export$85fc379452d91af0; }, function (v) { return $49542784eddf849d$export$85fc379452d91af0 = v; });
var $49542784eddf849d$export$85fc379452d91af0;
$49542784eddf849d$export$85fc379452d91af0 = `hennza_grid`;



var $91fc3b1de0eb9034$exports = {};

$parcel$export($91fc3b1de0eb9034$exports, "card", function () { return $91fc3b1de0eb9034$export$aa3e815946b80764; }, function (v) { return $91fc3b1de0eb9034$export$aa3e815946b80764 = v; });
$parcel$export($91fc3b1de0eb9034$exports, "stack", function () { return $91fc3b1de0eb9034$export$a57ab32f40f83ea9; }, function (v) { return $91fc3b1de0eb9034$export$a57ab32f40f83ea9 = v; });
$parcel$export($91fc3b1de0eb9034$exports, "title", function () { return $91fc3b1de0eb9034$export$fb184b623420d9be; }, function (v) { return $91fc3b1de0eb9034$export$fb184b623420d9be = v; });
var $91fc3b1de0eb9034$export$aa3e815946b80764;
var $91fc3b1de0eb9034$export$a57ab32f40f83ea9;
var $91fc3b1de0eb9034$export$fb184b623420d9be;
$91fc3b1de0eb9034$export$aa3e815946b80764 = `uQswGq_card`;
$91fc3b1de0eb9034$export$a57ab32f40f83ea9 = `uQswGq_stack`;
$91fc3b1de0eb9034$export$fb184b623420d9be = `uQswGq_title`;


parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");







function $8c339d90f4d7b91b$export$ee5828fb8c43a48e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCardActionArea', slot);
}
const $8c339d90f4d7b91b$var$cardActionAreaClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $8c339d90f4d7b91b$export$2e2bcd8739ae039 = $8c339d90f4d7b91b$var$cardActionAreaClasses;




'use client';
const $fb3d4480a6f47f89$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $fb3d4480a6f47f89$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8c339d90f4d7b91b$export$ee5828fb8c43a48e), classes);
};
const $fb3d4480a6f47f89$var$CardActionAreaRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiCardActionArea',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${(0, $8c339d90f4d7b91b$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${(0, $8c339d90f4d7b91b$export$2e2bcd8739ae039).focusVisible} .${(0, $8c339d90f4d7b91b$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $fb3d4480a6f47f89$var$CardActionAreaFocusHighlight = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight',
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    }));
const $fb3d4480a6f47f89$var$CardActionArea = /*#__PURE__*/ $7fPBF.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fb3d4480a6f47f89$var$_excluded);
    const ownerState = props;
    const classes = $fb3d4480a6f47f89$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fb3d4480a6f47f89$var$CardActionAreaRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fb3d4480a6f47f89$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $fb3d4480a6f47f89$export$2e2bcd8739ae039 = $fb3d4480a6f47f89$var$CardActionArea;



const $8dd9fddf804095b6$export$3be6c17b609e7ce3 = ({ className: className, iconType: iconType, title: title, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        xs: true,
        className: className,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($91fc3b1de0eb9034$exports))).card,
            elevation: 5,
            sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.palette.background.default,
                borderRadius: "20px"
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                sx: {
                    padding: 3,
                    height: "100%"
                },
                onClick: onClick,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    spacing: 2,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($91fc3b1de0eb9034$exports))).stack,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: iconType
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($91fc3b1de0eb9034$exports))).title,
                            children: title
                        })
                    ]
                })
            })
        })
    });
};








var $bfb1968c11a59179$export$11b099a658b17995 = /*#__PURE__*/ function(ProductType) {
    ProductType[ProductType["ALBUMS"] = 0] = "ALBUMS";
    ProductType[ProductType["COLLECTIONS"] = 1] = "COLLECTIONS";
    ProductType[ProductType["SHELVINGS"] = 2] = "SHELVINGS";
    ProductType[ProductType["ARTISTS"] = 3] = "ARTISTS";
    ProductType[ProductType["LABELS"] = 4] = "LABELS";
    ProductType[ProductType["ALBUM_FORMATS"] = 5] = "ALBUM_FORMATS";
    ProductType[ProductType["ALBUM_TYPES"] = 6] = "ALBUM_TYPES";
    ProductType[ProductType["STORES"] = 7] = "STORES";
    ProductType[ProductType["SELL_VALUES"] = 8] = "SELL_VALUES";
    ProductType[ProductType["EXCHANGE_RATES"] = 9] = "EXCHANGE_RATES";
    ProductType[ProductType["TAGS"] = 10] = "TAGS";
    ProductType[ProductType["LISTENING_SESSIONS"] = 11] = "LISTENING_SESSIONS";
    ProductType[ProductType["BUNDLES"] = 12] = "BUNDLES";
    return ProductType;
}({});


const $c78153c289a31f2c$export$b5490b2533ba69dc = {
    [(0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CardsStar,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Stacks,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Shelves,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).ARTISTS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Artist,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).LABELS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MusicCast,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_FORMATS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ControlCamera,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_TYPES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Album,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).STORES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Store,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).SELL_VALUES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PriceChange,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).EXCHANGE_RATES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CurrencyExchange,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).TAGS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Sell,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).LISTENING_SESSIONS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Headphones,
    [(0, $bfb1968c11a59179$export$11b099a658b17995).BUNDLES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LocalMall
};




const $306f2255f4891854$export$408295e78e243e4b = ({ className: className, isPublic: isPublic, minimalist: minimalist, showAttributesShortcut: showAttributesShortcut, onNewAlbum: onNewAlbum, onImportFromDiscogs: onImportFromDiscogs, onImportFromExcel: onImportFromExcel, onFilterAlbums: onFilterAlbums, onRandomAlbums: onRandomAlbums, onChangeCollection: onChangeCollection, onEditProfile: onEditProfile, onScanBarcode: onScanBarcode })=>{
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($49542784eddf849d$exports))).grid, className),
        container: true,
        spacing: 2,
        children: [
            (!minimalist || isPublic) && currentUser?.role == "guest" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PersonAdd,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_create_user,
                onClick: ()=>{
                    closeSession();
                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
                }
            }),
            !isPublic && onNewAlbum && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddAd,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_add_albums,
                onClick: onNewAlbum
            }),
            !isPublic && onScanBarcode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2Add,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_scan_barcode,
                onClick: onScanBarcode
            }),
            !isPublic && onImportFromDiscogs && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_discogs_import,
                onClick: onImportFromDiscogs
            }),
            !isPublic && onImportFromExcel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FormsAddOn,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_excel_import,
                onClick: onImportFromExcel
            }),
            onFilterAlbums && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAlt,
                title: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_filter_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_filter,
                onClick: onFilterAlbums
            }),
            !minimalist && onRandomAlbums && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Die,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_random_albums,
                onClick: onRandomAlbums
            }),
            !isPublic && !minimalist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS],
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_layout,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).layout())
            }),
            !isPublic && !minimalist && currentUser?.role != "guest" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AreaChart,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_stats,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).stats())
            }),
            !isPublic && !minimalist && (showAttributesShortcut ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Assignment,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_attributes,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).attributes.manage())
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS],
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_albums,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list())
            })),
            !isPublic && onChangeCollection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS],
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_change_collection,
                onClick: onChangeCollection
            }),
            (!minimalist || isPublic) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Public,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_marketplace,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).marketplace())
            }),
            currentUser?.role != "guest" && onEditProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AccountCircle,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_edit_profile,
                onClick: onEditProfile
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Book2,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_documentation,
                onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home())
            })
        ]
    });
};





var $1c6978d6ee1a5249$exports = {};

$parcel$export($1c6978d6ee1a5249$exports, "spineDragHandleHorizontal", function () { return $1c6978d6ee1a5249$export$346d369dfb6291f3; }, function (v) { return $1c6978d6ee1a5249$export$346d369dfb6291f3 = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineDragHandleVertical", function () { return $1c6978d6ee1a5249$export$c02c3fba500470e1; }, function (v) { return $1c6978d6ee1a5249$export$c02c3fba500470e1 = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineDraggableDivHorizontal", function () { return $1c6978d6ee1a5249$export$8801059172d9f507; }, function (v) { return $1c6978d6ee1a5249$export$8801059172d9f507 = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineDraggableDivVertical", function () { return $1c6978d6ee1a5249$export$ee1286b1727062fc; }, function (v) { return $1c6978d6ee1a5249$export$ee1286b1727062fc = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineImageContainer", function () { return $1c6978d6ee1a5249$export$8f220b574fd527be; }, function (v) { return $1c6978d6ee1a5249$export$8f220b574fd527be = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineImageHorizontal", function () { return $1c6978d6ee1a5249$export$dc45b2af203f85b8; }, function (v) { return $1c6978d6ee1a5249$export$dc45b2af203f85b8 = v; });
$parcel$export($1c6978d6ee1a5249$exports, "spineImageVertical", function () { return $1c6978d6ee1a5249$export$c567f7337ed9f56d; }, function (v) { return $1c6978d6ee1a5249$export$c567f7337ed9f56d = v; });
var $1c6978d6ee1a5249$export$346d369dfb6291f3;
var $1c6978d6ee1a5249$export$c02c3fba500470e1;
var $1c6978d6ee1a5249$export$8801059172d9f507;
var $1c6978d6ee1a5249$export$ee1286b1727062fc;
var $1c6978d6ee1a5249$export$8f220b574fd527be;
var $1c6978d6ee1a5249$export$dc45b2af203f85b8;
var $1c6978d6ee1a5249$export$c567f7337ed9f56d;
$1c6978d6ee1a5249$export$346d369dfb6291f3 = `HXXdgq_spineDragHandleHorizontal`;
$1c6978d6ee1a5249$export$c02c3fba500470e1 = `HXXdgq_spineDragHandleVertical`;
$1c6978d6ee1a5249$export$8801059172d9f507 = `HXXdgq_spineDraggableDivHorizontal`;
$1c6978d6ee1a5249$export$ee1286b1727062fc = `HXXdgq_spineDraggableDivVertical`;
$1c6978d6ee1a5249$export$8f220b574fd527be = `HXXdgq_spineImageContainer`;
$1c6978d6ee1a5249$export$dc45b2af203f85b8 = `HXXdgq_spineImageHorizontal`;
$1c6978d6ee1a5249$export$c567f7337ed9f56d = `HXXdgq_spineImageVertical`;



var $7fPBF = parcelRequire("7fPBF");





var $2b6aa9ce287cc06c$exports = {};
$2b6aa9ce287cc06c$exports = $parcel$resolve("eIDQB");


const $00dc1b76c4a97a8b$export$d29b00f091fdde7b = ({ isDragDisabled: isDragDisabled, album: album, shelving: shelving, section: section, index: index })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const genericSpine = new URL($2b6aa9ce287cc06c$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        const thumbnail = album.thumbnail;
        if (!thumbnail) setTintColor(undefined);
        const image = new Image();
        image.src = `data:image/png;base64,${thumbnail}`;
        image.onload = function() {
            setTintColor((0, $74a5752378f7da5e$export$734d4481083c9058).getDominantColor(image));
        };
    }, [
        album.thumbnail
    ]);
    const [tintColor, setTintColor] = (0, $7fPBF.useState)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineImageContainer,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
            isDragDisabled: isDragDisabled,
            draggableId: `${section}_${index}`,
            index: index,
            children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: shelving?.orientation == "vertical" ? (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineDraggableDivVertical : (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineDraggableDivHorizontal,
                    ref: provided.innerRef,
                    ...provided.draggableProps,
                    ...provided.dragHandleProps,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: shelving?.orientation == "vertical" ? (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineDragHandleVertical : (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineDragHandleHorizontal,
                            style: {
                                borderColor: theme.palette.background.default,
                                visibility: isDragDisabled ? "hidden" : "visible"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                                style: {
                                    fontSize: "14px",
                                    backgroundColor: theme.palette.background.default,
                                    color: theme.palette.primary.main
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                            className: shelving?.orientation == "vertical" ? (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineImageVertical : (0, (/*@__PURE__*/$parcel$interopDefault($1c6978d6ee1a5249$exports))).spineImageHorizontal,
                            defaultImage: genericSpine,
                            alt: album.name,
                            forceVertical: shelving ? shelving.orientation == "horizontal" : true,
                            forceHorizontal: shelving ? shelving.orientation == "vertical" : false,
                            tintColor: tintColor,
                            waitUntilImageIsFinal: true
                        })
                    ]
                })
        }, `${album.uuid}_${index}`)
    });
};



const $5bf9b4cecdde85ae$export$ea09568aab55509f = ({ dragDropId: dragDropId, isPublic: isPublic, albums: albums, selectedAlbumId: selectedAlbumId, sortOption: sortOption, canMoveAlbums: canMoveAlbums, canDropAlbums: canDropAlbums, canLoadMoreAlbums: canLoadMoreAlbums, setNeedMoreAlbums: setNeedMoreAlbums, onAlbumSelected: onAlbumSelected, onAlbumDeleted: onAlbumDeleted, onAlbumDeletedFromBoxSet: onAlbumDeletedFromBoxSet, onAlbumCopy: onAlbumCopy, onAlbumMarkAs: onAlbumMarkAs, onOpenInLayout: onOpenInLayout, noMoreAlbums: noMoreAlbums, albumCount: albumCount, onNewAlbum: onNewAlbum, onScanBarcode: onScanBarcode, onFilterAlbums: onFilterAlbums, onImportFromDiscogs: onImportFromDiscogs, onImportFromExcel: onImportFromExcel, onChangeCollection: onChangeCollection, onEditProfile: onEditProfile, onPlayFromYouTube: onPlayFromYouTube, scrollToTopTrigger: scrollToTopTrigger, isForLayout: isForLayout, shelving: shelving, isBoxSetList: isBoxSetList, boxSetAlbumId: boxSetAlbumId, setLoading: setLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [currentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const userProfile = isPublic ? currentPublicUserProfile : currentUserProfile;
    const topReference = (0, $7fPBF.useRef)(null);
    const handleScroll = (element)=>{
        if (noMoreAlbums || !canLoadMoreAlbums) return;
        const shouldLoadMore = element.currentTarget.scrollHeight - element.currentTarget.scrollTop <= element.currentTarget.clientHeight * 4;
        if (shouldLoadMore) setNeedMoreAlbums();
    };
    (0, $7fPBF.useEffect)(()=>{
        topReference.current?.scrollIntoView();
    }, [
        scrollToTopTrigger
    ]);
    const getHeader = (album)=>{
        switch(sortOption){
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST:
                return album.artist?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LABEL:
                return album.label?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ORIGINAL_YEAR:
                return album.originalYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RELEASE_YEAR:
                return album.releaseYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).STORE:
                return album.store?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).COUNTRY:
                return album.originCountry?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_PRICE:
                if (album.purchasePriceToday == undefined) return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
                return `${currencyFormatter.format(album.purchasePriceToday, userProfile, isPublic, 2)} (${currencyFormatter.format(album.purchasePriceDollars, userProfile, isPublic, 2, "USD")})`;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE:
                return album.sellValue?.pesos ? `${album.sellValue.group} (${currencyFormatter.format(album.sellValue.pesos, userProfile, isPublic, 2)})` : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE_DOLLARS:
                return album.sellValue?.pesos ? `${currencyFormatter.format(album.sellValue?.pesos, userProfile, isPublic, 2)} (${currencyFormatter.format(album.sellValue?.dollars, userProfile, isPublic, 2, "USD")})` : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).REVENUE:
                const revenue = (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getRevenue(album);
                return currencyFormatter.format(revenue, userProfile, isPublic, 2);
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_DATE:
                if (album.purchaseDate) return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(album.purchaseDate * 1000, "d MMMM yyyy", {
                    locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                });
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).TRACK_COUNT:
                return album.tracks ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LENGTH:
                return album.length ? (0, $9814b23db5adb339$export$8bb95198b45adaac).toHHMMSS(album.length) : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
            case (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).option_random_albums;
        }
    };
    const albumListItem = (album, section, index, sectionAlbums)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6ce18dcd0d17afb$export$6ed96040651a3597), {
            isPublic: isPublic,
            sortOption: sortOption,
            album: album,
            isBoxSetList: isBoxSetList,
            highlighted: album.uuid == selectedAlbumId,
            onClick: ()=>onAlbumSelected(album),
            onDelete: onAlbumDeleted ? ()=>onAlbumDeleted(album, section, index) : undefined,
            onDeleteFromBoxSet: onAlbumDeletedFromBoxSet,
            onCopy: onAlbumCopy ? ()=>onAlbumCopy(album) : undefined,
            onMarkAs: onAlbumMarkAs ? (sellStatus)=>onAlbumMarkAs(album, sellStatus) : undefined,
            onOpenInLayout: ()=>onOpenInLayout(album),
            onPlayFromYouTube: onPlayFromYouTube ? (videoIds)=>onPlayFromYouTube(album.name, videoIds) : undefined,
            sectionLength: sectionAlbums.length,
            isForLayout: isForLayout,
            boxSetAlbumId: boxSetAlbumId,
            isFirst: index == 0,
            isLast: index == sectionAlbums.length - 1,
            setLoading: setLoading
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).mainDiv,
        children: albums?.length == 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).noSelectionDiv,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).shortcutsTitle,
                    style: {
                        color: theme.palette.primary.main
                    },
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_search_title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $306f2255f4891854$export$408295e78e243e4b), {
                    isPublic: isPublic,
                    showAttributesShortcut: true,
                    minimalist: true,
                    onNewAlbum: onNewAlbum,
                    onScanBarcode: onScanBarcode,
                    onImportFromDiscogs: onImportFromDiscogs,
                    onImportFromExcel: onImportFromExcel,
                    onFilterAlbums: onFilterAlbums,
                    onChangeCollection: onChangeCollection,
                    onEditProfile: onEditProfile
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
            disablePadding: true,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).mainList,
            onScroll: handleScroll,
            sx: {
                overflow: albums ? "auto" : "hidden"
            },
            children: [
                !isBoxSetList && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    ref: topReference
                }),
                albums && albums.length > 0 ? albums.map((sectionAlbums, section)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            height: sectionAlbums.length == 0 ? "100%" : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                style: {
                                    height: sectionAlbums.length == 0 ? "100%" : undefined
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$423ec2075359570a), {
                                    isDropDisabled: !canDropAlbums,
                                    droppableId: `dr_${section}_${dragDropId}`,
                                    children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).ul,
                                            style: {
                                                height: sectionAlbums.length == 0 ? "100%" : undefined
                                            },
                                            ref: provided.innerRef,
                                            ...provided.droppableProps,
                                            children: [
                                                !isBoxSetList && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6a8c189b782c624$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).subheader,
                                                    sx: {
                                                        backgroundColor: "background.default",
                                                        lineHeight: 2
                                                    },
                                                    children: getHeader(sectionAlbums[0])
                                                }, `sub_${section}_${dragDropId}`),
                                                sectionAlbums.map((album, index)=>{
                                                    return isForLayout ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).albumItemContainer,
                                                        children: [
                                                            albumListItem(album, section, index, sectionAlbums),
                                                            index < sectionAlbums.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00dc1b76c4a97a8b$export$d29b00f091fdde7b), {
                                                                isDragDisabled: !canMoveAlbums,
                                                                album: album,
                                                                shelving: shelving,
                                                                section: section,
                                                                index: index
                                                            })
                                                        ]
                                                    }, `div_${album.uuid}_${index}_${dragDropId}`) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
                                                        isDragDisabled: !canMoveAlbums,
                                                        draggableId: `${section}_${index}_${dragDropId}`,
                                                        index: index,
                                                        children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).albumItemContainer,
                                                                ref: provided.innerRef,
                                                                ...provided.draggableProps,
                                                                ...provided.dragHandleProps,
                                                                children: [
                                                                    albumListItem(album, section, index, sectionAlbums),
                                                                    index < sectionAlbums.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                                                                ]
                                                            })
                                                    }, `${album.uuid}_${index}_${dragDropId}`);
                                                }),
                                                provided.placeholder
                                            ]
                                        }, `ul_${section}_${dragDropId}`)
                                }, `drop_${section}_${dragDropId}`)
                            }, `li_album_${section}_${dragDropId}`),
                            !noMoreAlbums && section == albums.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1e446eddc14c9e3$export$e6d01a6f594c803), {
                                albumCount: 15,
                                disableHeader: true
                            }, "li_skeletons")
                        ]
                    }, `div_${section}_${dragDropId}`)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1e446eddc14c9e3$export$e6d01a6f594c803), {
                    albumCount: albumCount,
                    disableHeader: isBoxSetList
                })
            ]
        })
    });
};






var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $61ddbdba53ac770c$var$usePreviousProps = (value)=>{
    const ref = $7fPBF.useRef({});
    $7fPBF.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $61ddbdba53ac770c$export$2e2bcd8739ae039 = $61ddbdba53ac770c$var$usePreviousProps;




'use client';
function $d84a6b6441baa24e$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $61ddbdba53ac770c$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}





function $1f6ac09903fa2f15$export$ff8356348e0cc878(name) {
    return 0, $3dd0e9417d40119e$export$2e2bcd8739ae039;
}





function $02ea6fcaa7760459$export$aaccef17e6dab084(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiBadge', slot);
}
const $02ea6fcaa7760459$var$badgeClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $02ea6fcaa7760459$export$2e2bcd8739ae039 = $02ea6fcaa7760459$var$badgeClasses;



'use client';
const $a5e88fe2e369b9f6$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $a5e88fe2e369b9f6$var$RADIUS_STANDARD = 10;
const $a5e88fe2e369b9f6$var$RADIUS_DOT = 4;
const $a5e88fe2e369b9f6$var$useThemeProps = (0, $1f6ac09903fa2f15$export$ff8356348e0cc878)('MuiBadge');
const $a5e88fe2e369b9f6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(overlap)}`,
            `overlap${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(overlap)}`,
            color !== 'default' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $02ea6fcaa7760459$export$aaccef17e6dab084), classes);
};
const $a5e88fe2e369b9f6$var$BadgeRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $a5e88fe2e369b9f6$var$BadgeBadge = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $a5e88fe2e369b9f6$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $a5e88fe2e369b9f6$var$RADIUS_STANDARD * 2,
        borderRadius: $a5e88fe2e369b9f6$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $a5e88fe2e369b9f6$var$RADIUS_DOT,
                    height: $a5e88fe2e369b9f6$var$RADIUS_DOT * 2,
                    minWidth: $a5e88fe2e369b9f6$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $a5e88fe2e369b9f6$var$Badge = /*#__PURE__*/ $7fPBF.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = $a5e88fe2e369b9f6$var$useThemeProps({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a5e88fe2e369b9f6$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $d84a6b6441baa24e$export$6105a25a68f1d9ae)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $61ddbdba53ac770c$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $a5e88fe2e369b9f6$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a5e88fe2e369b9f6$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $a5e88fe2e369b9f6$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BadgeSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $a5e88fe2e369b9f6$export$2e2bcd8739ae039 = $a5e88fe2e369b9f6$var$Badge;





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");










function $f2578a24ef24aa6e$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiLinearProgress', slot);
}
const $f2578a24ef24aa6e$var$linearProgressClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $f2578a24ef24aa6e$export$2e2bcd8739ae039 = $f2578a24ef24aa6e$var$linearProgressClasses;



'use client';
const $f118c00f3c44eea4$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $f118c00f3c44eea4$var$_ = (t)=>t, $f118c00f3c44eea4$var$_t, $f118c00f3c44eea4$var$_t2, $f118c00f3c44eea4$var$_t3, $f118c00f3c44eea4$var$_t4, $f118c00f3c44eea4$var$_t5, $f118c00f3c44eea4$var$_t6;
const $f118c00f3c44eea4$var$TRANSITION_DURATION = 4; // seconds
const $f118c00f3c44eea4$var$indeterminate1Keyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($f118c00f3c44eea4$var$_t || ($f118c00f3c44eea4$var$_t = $f118c00f3c44eea4$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $f118c00f3c44eea4$var$indeterminate2Keyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($f118c00f3c44eea4$var$_t2 || ($f118c00f3c44eea4$var$_t2 = $f118c00f3c44eea4$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $f118c00f3c44eea4$var$bufferKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($f118c00f3c44eea4$var$_t3 || ($f118c00f3c44eea4$var$_t3 = $f118c00f3c44eea4$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $f118c00f3c44eea4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            variant === 'buffer' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $f2578a24ef24aa6e$export$bc8a6ea1eb17d7c6), classes);
};
const $f118c00f3c44eea4$var$getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $92041da11764723e$export$c0816ed86df316af)(theme.palette[color].main, 0.62) : (0, $92041da11764723e$export$4b073707ff63303)(theme.palette[color].main, 0.5);
};
const $f118c00f3c44eea4$var$LinearProgressRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const $f118c00f3c44eea4$var$LinearProgressDashed = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($f118c00f3c44eea4$var$_t4 || ($f118c00f3c44eea4$var$_t4 = $f118c00f3c44eea4$var$_`
    animation: ${0} 3s infinite linear;
  `), $f118c00f3c44eea4$var$bufferKeyframe));
const $f118c00f3c44eea4$var$LinearProgressBar1 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($f118c00f3c44eea4$var$_t5 || ($f118c00f3c44eea4$var$_t5 = $f118c00f3c44eea4$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $f118c00f3c44eea4$var$indeterminate1Keyframe));
const $f118c00f3c44eea4$var$LinearProgressBar2 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($f118c00f3c44eea4$var$_t6 || ($f118c00f3c44eea4$var$_t6 = $f118c00f3c44eea4$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $f118c00f3c44eea4$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $f118c00f3c44eea4$var$LinearProgress = /*#__PURE__*/ $7fPBF.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f118c00f3c44eea4$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $f118c00f3c44eea4$var$useUtilityClasses(ownerState);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (theme.direction === 'rtl') transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === 'rtl') transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f118c00f3c44eea4$var$LinearProgressRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f118c00f3c44eea4$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f118c00f3c44eea4$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f118c00f3c44eea4$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $f118c00f3c44eea4$export$2e2bcd8739ae039 = $f118c00f3c44eea4$var$LinearProgress;




var $21953d615b2440d9$exports = {};

$parcel$export($21953d615b2440d9$exports, "icon", function () { return $21953d615b2440d9$export$1ca1ec8b29a4ce27; }, function (v) { return $21953d615b2440d9$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($21953d615b2440d9$exports, "iconWrapper", function () { return $21953d615b2440d9$export$38e6d710c8ae6ec3; }, function (v) { return $21953d615b2440d9$export$38e6d710c8ae6ec3 = v; });
$parcel$export($21953d615b2440d9$exports, "input", function () { return $21953d615b2440d9$export$b7e3ae3d7c15e42e; }, function (v) { return $21953d615b2440d9$export$b7e3ae3d7c15e42e = v; });
$parcel$export($21953d615b2440d9$exports, "progressBar", function () { return $21953d615b2440d9$export$9d1298853f0e77f7; }, function (v) { return $21953d615b2440d9$export$9d1298853f0e77f7 = v; });
var $21953d615b2440d9$export$1ca1ec8b29a4ce27;
var $21953d615b2440d9$export$38e6d710c8ae6ec3;
var $21953d615b2440d9$export$b7e3ae3d7c15e42e;
var $21953d615b2440d9$export$9d1298853f0e77f7;
$21953d615b2440d9$export$1ca1ec8b29a4ce27 = `tdTooW_icon`;
$21953d615b2440d9$export$38e6d710c8ae6ec3 = `tdTooW_iconWrapper`;
$21953d615b2440d9$export$b7e3ae3d7c15e42e = `tdTooW_input`;
$21953d615b2440d9$export$9d1298853f0e77f7 = `tdTooW_progressBar`;





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const $1d2b2774d90ce7db$var$SearchIconWrapper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main
    }));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const $1d2b2774d90ce7db$var$StyledInputBase = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: "inherit",
        "& .MuiInputBase-input": {
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4, 0, 0, 0)})`,
            transition: theme.transitions.create("width"),
            color: theme.palette.primary.main,
            width: "100% !important",
            [theme.breakpoints.up("md")]: {
                width: "20ch"
            }
        }
    }));
const $1d2b2774d90ce7db$export$79d13b60110f33be = ({ className: className, style: style, placeholder: placeholder, onSearchRequested: onSearchRequested, onSearchDismissed: onSearchDismissed, timed: timed, minimumSearchLength: minimumSearchLength, onLoading: onLoading, disabled: disabled, autoFocus: autoFocus, forceThisText: forceThisText })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [lastSearchText, setLastSearchText] = (0, $7fPBF.useState)("");
    const [timerProgress, setTimerProgress] = (0, $7fPBF.useState)(0);
    const isSearchTextValid = (searchText)=>{
        return searchText.length >= (minimumSearchLength || 3) && searchText != lastSearchText;
    };
    const expiryTimestamp = ()=>{
        const date = new Date();
        date.setSeconds(date.getSeconds() + 3);
        return date;
    };
    const { pause: pauseTimer, restart: startTimer, isRunning: isTimerRunning } = (0, $0fb6069f42f36b16$exports.useTimer)({
        expiryTimestamp: expiryTimestamp(),
        onExpire: ()=>{
            const trimmedSearchText = searchText.trim();
            setLastSearchText(trimmedSearchText);
            onSearchRequested(trimmedSearchText);
        }
    });
    const stopTimer = ()=>{
        pauseTimer();
        setTimerProgress(0);
    };
    const restartTimer = (newExpiryTimestamp, autoStart)=>{
        startTimer(newExpiryTimestamp, autoStart);
        setTimerProgress(0);
    };
    const clearSearch = ()=>{
        setSearchText("");
        setLastSearchText("");
        onSearchDismissed();
    };
    (0, $7fPBF.useEffect)(()=>{
        setSearchText(forceThisText ?? "");
        setLastSearchText(forceThisText ?? "");
    }, [
        forceThisText
    ]);
    (0, $7fPBF.useEffect)(()=>{
        stopTimer();
    }, []);
    const handleChange = (event)=>{
        event.preventDefault();
        const searchText = event.target.value;
        setSearchText(searchText ?? "");
        const trimmedSearchText = searchText.trim();
        if (trimmedSearchText == "") {
            if (trimmedSearchText != lastSearchText) clearSearch();
            if (onLoading) onLoading(false);
            stopTimer();
            return;
        }
        if (timed) {
            if (isSearchTextValid(trimmedSearchText)) {
                if (onLoading) onLoading(true);
                restartTimer(expiryTimestamp());
            } else {
                if (onLoading) onLoading(false);
                stopTimer();
            }
        } else {
            setLastSearchText(trimmedSearchText);
            onSearchRequested(trimmedSearchText);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        const timer = setInterval(()=>{
            setTimerProgress((oldProgress)=>{
                if (oldProgress == 100) return 100;
                return oldProgress + 10;
            });
        }, 300);
        return ()=>{
            clearInterval(timer);
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        className: className,
        style: style,
        spacing: 0,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                style: {
                    marginTop: 4,
                    marginBottom: 0,
                    height: 36,
                    width: "auto",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1d2b2774d90ce7db$var$SearchIconWrapper, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($21953d615b2440d9$exports))).iconWrapper,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($21953d615b2440d9$exports))).icon,
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Search
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1d2b2774d90ce7db$var$StyledInputBase, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($21953d615b2440d9$exports))).input,
                        value: searchText,
                        placeholder: placeholder ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).search,
                        disabled: disabled,
                        autoFocus: autoFocus,
                        inputProps: {
                            "aria-label": "search"
                        },
                        onChange: handleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($21953d615b2440d9$exports))).progressBar,
                sx: {
                    width: isMobile ? "84%" : "93%",
                    backgroundColor: theme.palette.colors?.buttonBackground,
                    opacity: timed ? 0.5 : 0
                },
                variant: "determinate",
                value: isTimerRunning ? timerProgress : 0
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");








function $d5a8b4efc4b3e986$export$e4f04f80f2ce3fc0(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemAvatar', slot);
}
const $d5a8b4efc4b3e986$var$listItemAvatarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $d5a8b4efc4b3e986$export$2e2bcd8739ae039 = $d5a8b4efc4b3e986$var$listItemAvatarClasses;



'use client';
const $98facea847274680$var$_excluded = [
    "className"
];
const $98facea847274680$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d5a8b4efc4b3e986$export$e4f04f80f2ce3fc0), classes);
};
const $98facea847274680$var$ListItemAvatarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        minWidth: 56,
        flexShrink: 0
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $98facea847274680$var$ListItemAvatar = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $98facea847274680$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $98facea847274680$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($98facea847274680$var$ListItemAvatarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $98facea847274680$export$2e2bcd8739ae039 = $98facea847274680$var$ListItemAvatar;









var $7fPBF = parcelRequire("7fPBF");

var $1a4661cf4ef54e09$exports = {};

$parcel$export($1a4661cf4ef54e09$exports, "checkbox", function () { return $1a4661cf4ef54e09$export$b07e517d22efa1ca; }, function (v) { return $1a4661cf4ef54e09$export$b07e517d22efa1ca = v; });
$parcel$export($1a4661cf4ef54e09$exports, "checkboxHelpText", function () { return $1a4661cf4ef54e09$export$330001811d8770b3; }, function (v) { return $1a4661cf4ef54e09$export$330001811d8770b3 = v; });
$parcel$export($1a4661cf4ef54e09$exports, "dialog", function () { return $1a4661cf4ef54e09$export$518824cf31321346; }, function (v) { return $1a4661cf4ef54e09$export$518824cf31321346 = v; });
$parcel$export($1a4661cf4ef54e09$exports, "foldersCard", function () { return $1a4661cf4ef54e09$export$7a0bc86416a80667; }, function (v) { return $1a4661cf4ef54e09$export$7a0bc86416a80667 = v; });
$parcel$export($1a4661cf4ef54e09$exports, "message", function () { return $1a4661cf4ef54e09$export$a8ecead220dd38a6; }, function (v) { return $1a4661cf4ef54e09$export$a8ecead220dd38a6 = v; });
$parcel$export($1a4661cf4ef54e09$exports, "subtitle", function () { return $1a4661cf4ef54e09$export$c96745152eb2740f; }, function (v) { return $1a4661cf4ef54e09$export$c96745152eb2740f = v; });
var $1a4661cf4ef54e09$export$b07e517d22efa1ca;
var $1a4661cf4ef54e09$export$330001811d8770b3;
var $1a4661cf4ef54e09$export$518824cf31321346;
var $1a4661cf4ef54e09$export$7a0bc86416a80667;
var $1a4661cf4ef54e09$export$a8ecead220dd38a6;
var $1a4661cf4ef54e09$export$c96745152eb2740f;
$1a4661cf4ef54e09$export$b07e517d22efa1ca = `_3X75ea_checkbox`;
$1a4661cf4ef54e09$export$330001811d8770b3 = `_3X75ea_checkboxHelpText`;
$1a4661cf4ef54e09$export$518824cf31321346 = `_3X75ea_dialog`;
$1a4661cf4ef54e09$export$7a0bc86416a80667 = `_3X75ea_foldersCard`;
$1a4661cf4ef54e09$export$a8ecead220dd38a6 = `_3X75ea_message`;
$1a4661cf4ef54e09$export$c96745152eb2740f = `_3X75ea_subtitle`;






const $270dcd915b26fa7f$export$47b7eb5b551a2967 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("discogs/identity");
    };
};







const $417a0d905636137f$export$fcb4a8e0d23d040 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (parameters)=>{
        return await post("discogs/token", parameters);
    };
};



const $9005ae2db19e8aed$export$8b0e4b58a2fa65d2 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (username)=>{
        return await get(`discogs/collection/folders/${username}`);
    };
};




const $29c0042c0e15ba0b$export$790840efb3f23e76 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (parameters)=>{
        return await post("discogs/import", parameters);
    };
};



const $37af56cb7c0ea8a8$export$be749692235121b8 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("discogs/import");
    };
};



const $36980565bfddd274$export$9034aa1fba108aec = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await deleteRequest("discogs/import");
    };
};



const $dcbb615582e8205f$export$e255348dfc39e4fb = ()=>{
    const { patch: patch } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await patch("discogs/import");
    };
};




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");


const $4a3a848c64aaaaed$export$45cdd786984d49e3 = (pageSize, backendRequest, setLoading, storage, isPublic, isEnabled, collectionId, query)=>{
    const [items, setItems] = (0, $7fPBF.useState)([]);
    const [lastUuid, setLastUuid] = (0, $7fPBF.useState)();
    const [noMoreItems, setNoMoreItems] = (0, $7fPBF.useState)(false);
    const [forceFetch, setForceFetch] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (noMoreItems || !isEnabled) return;
        const currentData = storage.getData(isPublic, collectionId);
        if (!noMoreItems && lastUuid || !currentData || currentData.length == 0) fetchData();
        else {
            setItems(currentData);
            setNoMoreItems(true);
            setLoading(false);
        }
    }, [
        lastUuid,
        forceFetch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (noMoreItems) storage.setData(items, isPublic, collectionId);
    }, [
        items
    ]);
    const fetchData = ()=>{
        setLoading(true);
        backendRequest({
            pageSize: pageSize,
            lastUuid: lastUuid,
            collectionId: collectionId,
            query: query
        }).then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                const isLastPage = body.length < pageSize;
                if (isLastPage) setLoading(false);
                setNoMoreItems(isLastPage);
                if (body.length >= 0) {
                    setItems((oldArray)=>[
                            ...oldArray,
                            ...body
                        ]);
                    if (body.length > 0) setLastUuid(body.slice(-1)[0].uuid);
                }
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) {
                setNoMoreItems(true);
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
                setLoading(false);
            }
        });
    };
    const resetItems = ()=>{
        setItems([]);
        storage.setData(undefined, isPublic, collectionId);
        setNoMoreItems(false);
        if (lastUuid === undefined) setForceFetch((state)=>!state);
        else setLastUuid(undefined);
    };
    return [
        items,
        resetItems,
        setItems,
        noMoreItems
    ];
};



const $024c4fa431281881$export$bda6e9c83e7e0f97 = {
    albums: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 30 : 40,
    artists: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 30 : 30,
    albumFormats: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 20 : 20,
    albumTypes: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 20 : 20,
    tags: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 20 : 20,
    labels: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 30 : 30,
    stores: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 30 : 30,
    sellValues: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 20 : 30,
    exchangeRates: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 30 : 40,
    collections: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 3 : 20,
    shelvings: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 20,
    shelves: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 5,
    shelfSegments: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 5,
    gearItems: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 30,
    equipments: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 30,
    listeningSessions: (role)=>role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common ? 5 : 40,
    userNotifications: ()=>20,
    messages: ()=>3,
    chats: ()=>20,
    chatMessages: ()=>30,
    userProfiles: ()=>20
};





const $6e68763501edef32$export$f936d3bbf9c71f75 = (setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getCollections = (parameters)=>get("collections", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).collections(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), getCollections, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).collectionStorage, false, true, undefined);
};



const $cf21db7337005170$export$b2a3b32f7c207ac2 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addCollection = (parameters)=>post("collections", parameters);
    return {
        addCollection: addCollection
    };
};



const $22e1e8bc3e238174$export$1cef512c5f67dab4 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteCollection = (parameters)=>deleteRequest("collections", parameters);
    return {
        deleteCollection: deleteCollection
    };
};



const $c45b4f55dd4266e9$export$70661bc05950df9e = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyCollection = (parameters)=>put("collections", parameters);
    return {
        modifyCollection: modifyCollection
    };
};




var $7fPBF = parcelRequire("7fPBF");


const $b9ad2596dd9fb182$export$8477e982e5e6d50 = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).highlightedCollectionStorage;
    const [collections, setCollections] = (0, $7fPBF.useState)(storage.getData(true, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (collections && collections.length > 0) return;
        setLoading(true);
        get("collections/shared/highlights").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setCollections(body);
                storage.setData(body, true, "");
            }
            setLoading(false);
        });
    }, dependencies);
    return collections;
};





parcelRequire("7fPBF");
var $f4905ed3e4d480ea$exports = {};

$parcel$export($f4905ed3e4d480ea$exports, "actionArea", function () { return $f4905ed3e4d480ea$export$746dc5cb6bd7e71f; }, function (v) { return $f4905ed3e4d480ea$export$746dc5cb6bd7e71f = v; });
$parcel$export($f4905ed3e4d480ea$exports, "container", function () { return $f4905ed3e4d480ea$export$34e0f9847d4c02dd; }, function (v) { return $f4905ed3e4d480ea$export$34e0f9847d4c02dd = v; });
$parcel$export($f4905ed3e4d480ea$exports, "deleteButton", function () { return $f4905ed3e4d480ea$export$62f325dbfbc8f81; }, function (v) { return $f4905ed3e4d480ea$export$62f325dbfbc8f81 = v; });
$parcel$export($f4905ed3e4d480ea$exports, "description", function () { return $f4905ed3e4d480ea$export$6d59db4903f20f7d; }, function (v) { return $f4905ed3e4d480ea$export$6d59db4903f20f7d = v; });
$parcel$export($f4905ed3e4d480ea$exports, "dragIcon", function () { return $f4905ed3e4d480ea$export$57b20f32f7ac9ff6; }, function (v) { return $f4905ed3e4d480ea$export$57b20f32f7ac9ff6 = v; });
$parcel$export($f4905ed3e4d480ea$exports, "dragIconContainer", function () { return $f4905ed3e4d480ea$export$1eb71f20e076696e; }, function (v) { return $f4905ed3e4d480ea$export$1eb71f20e076696e = v; });
$parcel$export($f4905ed3e4d480ea$exports, "item", function () { return $f4905ed3e4d480ea$export$7061c75fc5af8b7e; }, function (v) { return $f4905ed3e4d480ea$export$7061c75fc5af8b7e = v; });
$parcel$export($f4905ed3e4d480ea$exports, "name", function () { return $f4905ed3e4d480ea$export$a8ff84c12d48cfa6; }, function (v) { return $f4905ed3e4d480ea$export$a8ff84c12d48cfa6 = v; });
$parcel$export($f4905ed3e4d480ea$exports, "positionContainer", function () { return $f4905ed3e4d480ea$export$4b16a1eee4ce71f1; }, function (v) { return $f4905ed3e4d480ea$export$4b16a1eee4ce71f1 = v; });
$parcel$export($f4905ed3e4d480ea$exports, "trailingContainer", function () { return $f4905ed3e4d480ea$export$2cf49afa9bd5c3f; }, function (v) { return $f4905ed3e4d480ea$export$2cf49afa9bd5c3f = v; });
$parcel$export($f4905ed3e4d480ea$exports, "visibility", function () { return $f4905ed3e4d480ea$export$91fa9ac3f4021ce4; }, function (v) { return $f4905ed3e4d480ea$export$91fa9ac3f4021ce4 = v; });
var $f4905ed3e4d480ea$export$746dc5cb6bd7e71f;
var $f4905ed3e4d480ea$export$34e0f9847d4c02dd;
var $f4905ed3e4d480ea$export$62f325dbfbc8f81;
var $f4905ed3e4d480ea$export$6d59db4903f20f7d;
var $f4905ed3e4d480ea$export$57b20f32f7ac9ff6;
var $f4905ed3e4d480ea$export$1eb71f20e076696e;
var $f4905ed3e4d480ea$export$7061c75fc5af8b7e;
var $f4905ed3e4d480ea$export$a8ff84c12d48cfa6;
var $f4905ed3e4d480ea$export$4b16a1eee4ce71f1;
var $f4905ed3e4d480ea$export$2cf49afa9bd5c3f;
var $f4905ed3e4d480ea$export$91fa9ac3f4021ce4;
$f4905ed3e4d480ea$export$746dc5cb6bd7e71f = `p2uw6W_actionArea`;
$f4905ed3e4d480ea$export$34e0f9847d4c02dd = `p2uw6W_container`;
$f4905ed3e4d480ea$export$62f325dbfbc8f81 = `p2uw6W_deleteButton`;
$f4905ed3e4d480ea$export$6d59db4903f20f7d = `p2uw6W_description`;
$f4905ed3e4d480ea$export$57b20f32f7ac9ff6 = `p2uw6W_dragIcon`;
$f4905ed3e4d480ea$export$1eb71f20e076696e = `p2uw6W_dragIconContainer`;
$f4905ed3e4d480ea$export$7061c75fc5af8b7e = `p2uw6W_item`;
$f4905ed3e4d480ea$export$a8ff84c12d48cfa6 = `p2uw6W_name`;
$f4905ed3e4d480ea$export$4b16a1eee4ce71f1 = `p2uw6W_positionContainer`;
$f4905ed3e4d480ea$export$2cf49afa9bd5c3f = `p2uw6W_trailingContainer`;
$f4905ed3e4d480ea$export$91fa9ac3f4021ce4 = `p2uw6W_visibility`;




var $be3365eee83ef047$exports = {};

$parcel$export($be3365eee83ef047$exports, "bottomStack", function () { return $be3365eee83ef047$export$c5901e776af18f46; }, function (v) { return $be3365eee83ef047$export$c5901e776af18f46 = v; });
$parcel$export($be3365eee83ef047$exports, "card", function () { return $be3365eee83ef047$export$aa3e815946b80764; }, function (v) { return $be3365eee83ef047$export$aa3e815946b80764 = v; });
$parcel$export($be3365eee83ef047$exports, "collectionStats", function () { return $be3365eee83ef047$export$1e5ecdb191a1c515; }, function (v) { return $be3365eee83ef047$export$1e5ecdb191a1c515 = v; });
$parcel$export($be3365eee83ef047$exports, "description", function () { return $be3365eee83ef047$export$6d59db4903f20f7d; }, function (v) { return $be3365eee83ef047$export$6d59db4903f20f7d = v; });
$parcel$export($be3365eee83ef047$exports, "discountBox", function () { return $be3365eee83ef047$export$846ba29c579fca64; }, function (v) { return $be3365eee83ef047$export$846ba29c579fca64 = v; });
$parcel$export($be3365eee83ef047$exports, "image", function () { return $be3365eee83ef047$export$5c452ff88e35e47d; }, function (v) { return $be3365eee83ef047$export$5c452ff88e35e47d = v; });
$parcel$export($be3365eee83ef047$exports, "name", function () { return $be3365eee83ef047$export$a8ff84c12d48cfa6; }, function (v) { return $be3365eee83ef047$export$a8ff84c12d48cfa6 = v; });
$parcel$export($be3365eee83ef047$exports, "nameContainer", function () { return $be3365eee83ef047$export$3b9d909fcd39d8ae; }, function (v) { return $be3365eee83ef047$export$3b9d909fcd39d8ae = v; });
$parcel$export($be3365eee83ef047$exports, "nameStack", function () { return $be3365eee83ef047$export$540cccdef47139d3; }, function (v) { return $be3365eee83ef047$export$540cccdef47139d3 = v; });
$parcel$export($be3365eee83ef047$exports, "visibility", function () { return $be3365eee83ef047$export$91fa9ac3f4021ce4; }, function (v) { return $be3365eee83ef047$export$91fa9ac3f4021ce4 = v; });
var $be3365eee83ef047$export$c5901e776af18f46;
var $be3365eee83ef047$export$aa3e815946b80764;
var $be3365eee83ef047$export$1e5ecdb191a1c515;
var $be3365eee83ef047$export$6d59db4903f20f7d;
var $be3365eee83ef047$export$846ba29c579fca64;
var $be3365eee83ef047$export$5c452ff88e35e47d;
var $be3365eee83ef047$export$a8ff84c12d48cfa6;
var $be3365eee83ef047$export$3b9d909fcd39d8ae;
var $be3365eee83ef047$export$540cccdef47139d3;
var $be3365eee83ef047$export$91fa9ac3f4021ce4;
$be3365eee83ef047$export$c5901e776af18f46 = `l8iIGG_bottomStack`;
$be3365eee83ef047$export$aa3e815946b80764 = `l8iIGG_card`;
$be3365eee83ef047$export$1e5ecdb191a1c515 = `l8iIGG_collectionStats`;
$be3365eee83ef047$export$6d59db4903f20f7d = `l8iIGG_description`;
$be3365eee83ef047$export$846ba29c579fca64 = `l8iIGG_discountBox`;
$be3365eee83ef047$export$5c452ff88e35e47d = `l8iIGG_image`;
$be3365eee83ef047$export$a8ff84c12d48cfa6 = `l8iIGG_name`;
$be3365eee83ef047$export$3b9d909fcd39d8ae = `l8iIGG_nameContainer`;
$be3365eee83ef047$export$540cccdef47139d3 = `l8iIGG_nameStack`;
$be3365eee83ef047$export$91fa9ac3f4021ce4 = `l8iIGG_visibility`;



var $7fPBF = parcelRequire("7fPBF");


const $40029fedba9c2cbf$export$3d1cf140a8db8fb3 = {
    getVisibilityDescription: (collection)=>{
        switch(collection.visibility){
            case "private":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).private_collection;
            case "public":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).public_collection;
        }
    },
    albumBelongsTo: (collection, album)=>{
        if (!collection) return false;
        const uuids = album.collections?.map((collection)=>collection.uuid);
        return uuids?.includes(collection.uuid);
    }
};







var $719b4c7a4ae9a20d$exports = {};

$parcel$export($719b4c7a4ae9a20d$exports, "mainDiv", function () { return $719b4c7a4ae9a20d$export$16666caf1c4e1af1; }, function (v) { return $719b4c7a4ae9a20d$export$16666caf1c4e1af1 = v; });
$parcel$export($719b4c7a4ae9a20d$exports, "visits", function () { return $719b4c7a4ae9a20d$export$7a2d45e569f451b2; }, function (v) { return $719b4c7a4ae9a20d$export$7a2d45e569f451b2 = v; });
var $719b4c7a4ae9a20d$export$16666caf1c4e1af1;
var $719b4c7a4ae9a20d$export$7a2d45e569f451b2;
$719b4c7a4ae9a20d$export$16666caf1c4e1af1 = `eeil5q_mainDiv`;
$719b4c7a4ae9a20d$export$7a2d45e569f451b2 = `eeil5q_visits`;


parcelRequire("7fPBF");




const $d0ac51b8e7d1288b$export$6e86a3ec2d30d952 = ({ className: className, collection: collection })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($719b4c7a4ae9a20d$exports))).mainDiv, className),
        children: [
            collection.starCount !== undefined && collection.starCount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KidStar,
                        style: {
                            color: theme.palette.secondary.main,
                            fontSize: 16
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($719b4c7a4ae9a20d$exports))).visits,
                        style: {
                            color: theme.palette.secondary.main,
                            marginRight: 4
                        },
                        children: Intl.NumberFormat((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale, {
                            notation: "compact",
                            maximumFractionDigits: 1
                        }).format(collection.starCount)
                    })
                ]
            }),
            collection.visits > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Visibility,
                        style: {
                            color: theme.palette.secondary.main,
                            fontSize: 18
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($719b4c7a4ae9a20d$exports))).visits,
                        style: {
                            color: theme.palette.secondary.main
                        },
                        children: Intl.NumberFormat((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale, {
                            notation: "compact",
                            maximumFractionDigits: 1
                        }).format(collection.visits)
                    })
                ]
            })
        ]
    });
};




parcelRequire("7fPBF");
var $e62429565d57f093$exports = {};

$parcel$export($e62429565d57f093$exports, "discountBox", function () { return $e62429565d57f093$export$846ba29c579fca64; }, function (v) { return $e62429565d57f093$export$846ba29c579fca64 = v; });
var $e62429565d57f093$export$846ba29c579fca64;
$e62429565d57f093$export$846ba29c579fca64 = `hU02oq_discountBox`;




const $ed350f6794f06f61$export$3229296aace3d746 = ({ className: className, percentage: percentage })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e62429565d57f093$exports))).discountBox, className),
        style: {
            backgroundColor: theme.palette.colors?.discount
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
            children: [
                percentage * 100,
                "% ",
                (0, $37bec70ed65ed924$export$21c51bc433c16634).discount
            ]
        })
    });
};



var $a535e2e83d1fcdca$exports = {};
$a535e2e83d1fcdca$exports = $parcel$resolve("8TPrx");


const $f3b08aef6576b6da$export$d5597bfe96a524db = ({ className: className, style: style, collection: collection, disabled: disabled, onClick: onClick, onContextMenu: onContextMenu, children: children })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($a535e2e83d1fcdca$exports).href;
    const fetchImage = async ()=>{
        if (!collection.hasImage) return;
        const response = await getImage({
            name: collection.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageWidth,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageHeight
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        collection
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).card, className),
        style: style,
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.palette.background.default
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    justifyContent: "flex-start"
                },
                disabled: disabled,
                onClick: onClick,
                onContextMenu: onContextMenu,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).image,
                        image: image,
                        thumbnail: collection.thumbnail,
                        defaultImage: genericImage,
                        beforeLoad: fetchImage,
                        alt: collection.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).nameContainer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        direction: "row",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).nameStack,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).name,
                                children: collection.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            collection.discount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed350f6794f06f61$export$3229296aace3d746), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).discountBox,
                                percentage: collection.discount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).description,
                        style: {
                            color: theme.palette.secondary.main
                        },
                        children: collection.description
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).bottomStack,
                        direction: "row",
                        children: [
                            collection.visibility == "public" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).visibility,
                                style: {
                                    backgroundColor: theme.palette.colors?.divider
                                },
                                children: (0, $40029fedba9c2cbf$export$3d1cf140a8db8fb3).getVisibilityDescription(collection)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0ac51b8e7d1288b$export$6e86a3ec2d30d952), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($be3365eee83ef047$exports))).collectionStats,
                                collection: collection
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};



const $d77f9b1fcb3b7a4a$export$5b7f4051a57920d0 = ({ cardClassName: cardClassName, collection: collection, selected: selected, canMove: canMove, onContextMenu: onContextMenu, onSelection: onSelection, children: children })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f4905ed3e4d480ea$exports))).item,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f4905ed3e4d480ea$exports))).container,
            direction: "row",
            sx: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f4905ed3e4d480ea$exports))).dragIconContainer,
                    children: canMove && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f4905ed3e4d480ea$exports))).dragIcon,
                        style: {
                            color: theme.palette.secondary.main
                        },
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3b08aef6576b6da$export$d5597bfe96a524db), {
                    className: cardClassName,
                    style: {
                        borderColor: theme.palette.colors?.highlightBorder,
                        borderWidth: 4,
                        borderStyle: selected ? "double" : "none"
                    },
                    collection: collection,
                    onClick: onSelection,
                    onContextMenu: onContextMenu,
                    children: children
                })
            ]
        })
    });
};





var $7fPBF = parcelRequire("7fPBF");
const $09f494f72a25cae5$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};





var $7fPBF = parcelRequire("7fPBF");
var $dff48a3df5958394$exports = {};

$parcel$export($dff48a3df5958394$exports, "bannedFields", function () { return $dff48a3df5958394$export$9c4f0dc9637ce11e; }, function (v) { return $dff48a3df5958394$export$9c4f0dc9637ce11e = v; });
$parcel$export($dff48a3df5958394$exports, "cancelButton", function () { return $dff48a3df5958394$export$4ededb8e5b56a6fb; }, function (v) { return $dff48a3df5958394$export$4ededb8e5b56a6fb = v; });
$parcel$export($dff48a3df5958394$exports, "descriptionCard", function () { return $dff48a3df5958394$export$ea3c9f9ac820b913; }, function (v) { return $dff48a3df5958394$export$ea3c9f9ac820b913 = v; });
$parcel$export($dff48a3df5958394$exports, "dropzone", function () { return $dff48a3df5958394$export$585d0a7a39ed94ea; }, function (v) { return $dff48a3df5958394$export$585d0a7a39ed94ea = v; });
$parcel$export($dff48a3df5958394$exports, "freeTextFields", function () { return $dff48a3df5958394$export$fc15afe0ee03b9c1; }, function (v) { return $dff48a3df5958394$export$fc15afe0ee03b9c1 = v; });
$parcel$export($dff48a3df5958394$exports, "loadingDiv", function () { return $dff48a3df5958394$export$dded2af20345efaa; }, function (v) { return $dff48a3df5958394$export$dded2af20345efaa = v; });
$parcel$export($dff48a3df5958394$exports, "selectDiscount", function () { return $dff48a3df5958394$export$1fab6054d6ffebee; }, function (v) { return $dff48a3df5958394$export$1fab6054d6ffebee = v; });
$parcel$export($dff48a3df5958394$exports, "subtitle", function () { return $dff48a3df5958394$export$c96745152eb2740f; }, function (v) { return $dff48a3df5958394$export$c96745152eb2740f = v; });
$parcel$export($dff48a3df5958394$exports, "textField", function () { return $dff48a3df5958394$export$c54b92c0bb02ba64; }, function (v) { return $dff48a3df5958394$export$c54b92c0bb02ba64 = v; });
$parcel$export($dff48a3df5958394$exports, "visibility", function () { return $dff48a3df5958394$export$91fa9ac3f4021ce4; }, function (v) { return $dff48a3df5958394$export$91fa9ac3f4021ce4 = v; });
var $dff48a3df5958394$export$9c4f0dc9637ce11e;
var $dff48a3df5958394$export$4ededb8e5b56a6fb;
var $dff48a3df5958394$export$ea3c9f9ac820b913;
var $dff48a3df5958394$export$585d0a7a39ed94ea;
var $dff48a3df5958394$export$fc15afe0ee03b9c1;
var $dff48a3df5958394$export$dded2af20345efaa;
var $dff48a3df5958394$export$1fab6054d6ffebee;
var $dff48a3df5958394$export$c96745152eb2740f;
var $dff48a3df5958394$export$c54b92c0bb02ba64;
var $dff48a3df5958394$export$91fa9ac3f4021ce4;
$dff48a3df5958394$export$9c4f0dc9637ce11e = `vnR_YG_bannedFields`;
$dff48a3df5958394$export$4ededb8e5b56a6fb = `vnR_YG_cancelButton`;
$dff48a3df5958394$export$ea3c9f9ac820b913 = `vnR_YG_descriptionCard`;
$dff48a3df5958394$export$585d0a7a39ed94ea = `vnR_YG_dropzone`;
$dff48a3df5958394$export$fc15afe0ee03b9c1 = `vnR_YG_freeTextFields`;
$dff48a3df5958394$export$dded2af20345efaa = `vnR_YG_loadingDiv`;
$dff48a3df5958394$export$1fab6054d6ffebee = `vnR_YG_selectDiscount`;
$dff48a3df5958394$export$c96745152eb2740f = `vnR_YG_subtitle`;
$dff48a3df5958394$export$c54b92c0bb02ba64 = `vnR_YG_textField`;
$dff48a3df5958394$export$91fa9ac3f4021ce4 = `vnR_YG_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");







parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");











function $40bc34250bd2f060$export$21f89b560b65a301(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiToggleButton', slot);
}
const $40bc34250bd2f060$var$toggleButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $40bc34250bd2f060$export$2e2bcd8739ae039 = $40bc34250bd2f060$var$toggleButtonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $b598d796bbc64037$var$ToggleButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $b598d796bbc64037$export$2e2bcd8739ae039 = $b598d796bbc64037$var$ToggleButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $af51f037eb68958d$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $af51f037eb68958d$export$2e2bcd8739ae039 = $af51f037eb68958d$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $2f238e39c7e029a4$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



'use client';
const $e902733729c30441$var$_excluded = [
    "value"
], $e902733729c30441$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $e902733729c30441$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            color
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $40bc34250bd2f060$export$21f89b560b65a301), classes);
};
const $e902733729c30441$var$ToggleButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $e902733729c30441$var$ToggleButton = /*#__PURE__*/ $7fPBF.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $7fPBF.useContext((0, $b598d796bbc64037$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_React$useContext, $e902733729c30441$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $af51f037eb68958d$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, contextProps, {
        selected: (0, $2f238e39c7e029a4$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e902733729c30441$var$_excluded2);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $e902733729c30441$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e902733729c30441$var$ToggleButtonRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $e902733729c30441$export$2e2bcd8739ae039 = $e902733729c30441$var$ToggleButton;




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
function $c3429429cdbbe82f$export$2e2bcd8739ae039(children) {
    return $7fPBF.Children.toArray(children).filter((child)=>/*#__PURE__*/ $7fPBF.isValidElement(child));
}







function $3d158631ba0600aa$export$44aa3ae5b353cef1(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiToggleButtonGroup', slot);
}
const $3d158631ba0600aa$var$toggleButtonGroupClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $3d158631ba0600aa$export$2e2bcd8739ae039 = $3d158631ba0600aa$var$toggleButtonGroupClasses;






'use client';
const $17ed26c1f53c62f7$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $17ed26c1f53c62f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $3d158631ba0600aa$export$44aa3ae5b353cef1), classes);
};
const $17ed26c1f53c62f7$var$ToggleButtonGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).grouped}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).selected} + .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).grouped}.${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).selected} + .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).grouped}.${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).firstButton},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).lastButton},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).firstButton},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).lastButton},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).lastButton}.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).disabled},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).lastButton}.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).disabled},& .${(0, $3d158631ba0600aa$export$2e2bcd8739ae039).middleButton}.${(0, $40bc34250bd2f060$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $17ed26c1f53c62f7$var$ToggleButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $17ed26c1f53c62f7$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $17ed26c1f53c62f7$var$useUtilityClasses(ownerState);
    const handleChange = $7fPBF.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $7fPBF.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $7fPBF.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $c3429429cdbbe82f$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($17ed26c1f53c62f7$var$ToggleButtonGroupRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        role: "group",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b598d796bbc64037$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af51f037eb68958d$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $17ed26c1f53c62f7$export$2e2bcd8739ae039 = $17ed26c1f53c62f7$var$ToggleButtonGroup;


var $06c7622d6b0c930c$exports = {};

$parcel$export($06c7622d6b0c930c$exports, "itemDiv", function () { return $06c7622d6b0c930c$export$64c46d98173ac23d; }, function (v) { return $06c7622d6b0c930c$export$64c46d98173ac23d = v; });
$parcel$export($06c7622d6b0c930c$exports, "subtitle", function () { return $06c7622d6b0c930c$export$c96745152eb2740f; }, function (v) { return $06c7622d6b0c930c$export$c96745152eb2740f = v; });
$parcel$export($06c7622d6b0c930c$exports, "title", function () { return $06c7622d6b0c930c$export$fb184b623420d9be; }, function (v) { return $06c7622d6b0c930c$export$fb184b623420d9be = v; });
$parcel$export($06c7622d6b0c930c$exports, "toggleButton", function () { return $06c7622d6b0c930c$export$c3f9788a1ddcf2d9; }, function (v) { return $06c7622d6b0c930c$export$c3f9788a1ddcf2d9 = v; });
var $06c7622d6b0c930c$export$64c46d98173ac23d;
var $06c7622d6b0c930c$export$c96745152eb2740f;
var $06c7622d6b0c930c$export$fb184b623420d9be;
var $06c7622d6b0c930c$export$c3f9788a1ddcf2d9;
$06c7622d6b0c930c$export$64c46d98173ac23d = `WQbr7W_itemDiv`;
$06c7622d6b0c930c$export$c96745152eb2740f = `WQbr7W_subtitle`;
$06c7622d6b0c930c$export$fb184b623420d9be = `WQbr7W_title`;
$06c7622d6b0c930c$export$c3f9788a1ddcf2d9 = `WQbr7W_toggleButton`;




const $6a5dc8884ed9bccb$export$2a72185d43821ea9 = ({ className: className, iconType: iconType, title: title, subtitle: subtitle, labels: labels, values: values, value: value, fullWidth: fullWidth, disableGutters: disableGutters, handleChange: handleChange, helpHref: helpHref, disabled: disabled })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: className,
        disableGutters: disableGutters,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($06c7622d6b0c930c$exports))).itemDiv,
            children: [
                iconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: iconType
                    })
                }),
                title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                    disableTypography: true,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($06c7622d6b0c930c$exports))).title,
                    primary: title,
                    secondary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($06c7622d6b0c930c$exports))).subtitle,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: subtitle
                    })
                }),
                helpHref && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        sx: {
                            marginLeft: "4px"
                        },
                        href: helpHref,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    flexGrow: 1
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
                    value: value,
                    fullWidth: fullWidth,
                    exclusive: true,
                    onChange: handleChange,
                    disabled: disabled,
                    children: labels.map((label, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($06c7622d6b0c930c$exports))).toggleButton,
                            sx: {
                                color: theme.palette.colors?.disabled,
                                paddingTop: "4px !important",
                                paddingBottom: "4px !important"
                            },
                            value: values[index],
                            children: label
                        }, `toggle_${index}`))
                })
            ]
        })
    });
};



parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");




parcelRequire("7fPBF");


'use client';
var $7a7f4684365c8e73$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');










function $d358322d03e9d644$export$31444911e4ee6fdd(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $d358322d03e9d644$var$chipClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $d358322d03e9d644$export$2e2bcd8739ae039 = $d358322d03e9d644$var$chipClasses;



'use client';
const $1a9e4fb2f535b4c3$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $1a9e4fb2f535b4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}Color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d358322d03e9d644$export$31444911e4ee6fdd), classes);
};
const $1a9e4fb2f535b4c3$var$ChipRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}Color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $d358322d03e9d644$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $d358322d03e9d644$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $1a9e4fb2f535b4c3$var$ChipLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $1a9e4fb2f535b4c3$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $1a9e4fb2f535b4c3$var$_excluded);
    const chipRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $1a9e4fb2f535b4c3$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039) ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7a7f4684365c8e73$export$2e2bcd8739ae039), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($1a9e4fb2f535b4c3$var$ChipRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1a9e4fb2f535b4c3$var$ChipLabel, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $1a9e4fb2f535b4c3$export$2e2bcd8739ae039 = $1a9e4fb2f535b4c3$var$Chip;


var $a60996c7eb327506$exports = {};

$parcel$export($a60996c7eb327506$exports, "addButton", function () { return $a60996c7eb327506$export$76174c80c75f9baa; }, function (v) { return $a60996c7eb327506$export$76174c80c75f9baa = v; });
$parcel$export($a60996c7eb327506$exports, "addChip", function () { return $a60996c7eb327506$export$14691244fe1d934c; }, function (v) { return $a60996c7eb327506$export$14691244fe1d934c = v; });
$parcel$export($a60996c7eb327506$exports, "chip", function () { return $a60996c7eb327506$export$aa2a4c698c03a4c8; }, function (v) { return $a60996c7eb327506$export$aa2a4c698c03a4c8 = v; });
$parcel$export($a60996c7eb327506$exports, "chipBox", function () { return $a60996c7eb327506$export$70093755734ffdb9; }, function (v) { return $a60996c7eb327506$export$70093755734ffdb9 = v; });
$parcel$export($a60996c7eb327506$exports, "chipsCard", function () { return $a60996c7eb327506$export$cd3b51142feb4176; }, function (v) { return $a60996c7eb327506$export$cd3b51142feb4176 = v; });
$parcel$export($a60996c7eb327506$exports, "itemDiv", function () { return $a60996c7eb327506$export$64c46d98173ac23d; }, function (v) { return $a60996c7eb327506$export$64c46d98173ac23d = v; });
$parcel$export($a60996c7eb327506$exports, "loadingIndicator", function () { return $a60996c7eb327506$export$f10e6b4aaa94c253; }, function (v) { return $a60996c7eb327506$export$f10e6b4aaa94c253 = v; });
$parcel$export($a60996c7eb327506$exports, "title", function () { return $a60996c7eb327506$export$fb184b623420d9be; }, function (v) { return $a60996c7eb327506$export$fb184b623420d9be = v; });
var $a60996c7eb327506$export$76174c80c75f9baa;
var $a60996c7eb327506$export$14691244fe1d934c;
var $a60996c7eb327506$export$aa2a4c698c03a4c8;
var $a60996c7eb327506$export$70093755734ffdb9;
var $a60996c7eb327506$export$cd3b51142feb4176;
var $a60996c7eb327506$export$64c46d98173ac23d;
var $a60996c7eb327506$export$f10e6b4aaa94c253;
var $a60996c7eb327506$export$fb184b623420d9be;
$a60996c7eb327506$export$76174c80c75f9baa = `s-KHaW_addButton`;
$a60996c7eb327506$export$14691244fe1d934c = `s-KHaW_addChip`;
$a60996c7eb327506$export$aa2a4c698c03a4c8 = `s-KHaW_chip`;
$a60996c7eb327506$export$70093755734ffdb9 = `s-KHaW_chipBox`;
$a60996c7eb327506$export$cd3b51142feb4176 = `s-KHaW_chipsCard`;
$a60996c7eb327506$export$64c46d98173ac23d = `s-KHaW_itemDiv`;
$a60996c7eb327506$export$f10e6b4aaa94c253 = `s-KHaW_loadingIndicator`;
$a60996c7eb327506$export$fb184b623420d9be = `s-KHaW_title`;





const $504a3351cc023888$export$408fe8826c07eae7 = ({ className: className, disableGutters: disableGutters, iconType: iconType, title: title, chips: chips, isLoading: isLoading, onAdd: onAdd, onChipSelected: onChipSelected, onDelete: onDelete, helpHref: helpHref, addDisabled: addDisabled, removeDisabled: removeDisabled })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: className,
        disableGutters: disableGutters,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).itemDiv,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                sx: {
                    width: "100%"
                },
                children: [
                    iconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                        sx: {
                            alignSelf: "center"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: iconType
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        direction: "column",
                        sx: {
                            flexGrow: 1,
                            width: "100%"
                        },
                        spacing: helpHref ? 0 : 1,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).title,
                                        disableTypography: true,
                                        secondary: title
                                    }),
                                    helpHref && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                        arrow: true,
                                        disableInteractive: true,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginLeft: "4px"
                                            },
                                            href: helpHref,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        flexGrow: 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).chipsCard,
                                sx: {
                                    borderWidth: "1.5px",
                                    borderColor: theme.palette.background.paper,
                                    borderStyle: "solid"
                                },
                                children: [
                                    chips?.map((chip, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: chip.description,
                                            slotProps: {
                                                tooltip: {
                                                    sx: {
                                                        fontWeight: "normal"
                                                    }
                                                }
                                            },
                                            arrow: true,
                                            disableInteractive: true,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).chipBox,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).chip,
                                                    label: chip.name,
                                                    onClick: onChipSelected ? ()=>onChipSelected(index, chip) : undefined,
                                                    onDelete: removeDisabled ? undefined : ()=>onDelete(index, chip),
                                                    disabled: isLoading
                                                })
                                            }, `${title}_${index}`)
                                        }, `tooltip_${title}_${index}`)),
                                    !addDisabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
                                        arrow: true,
                                        disableInteractive: true,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).chipBox,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).addChip,
                                                icon: isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a60996c7eb327506$exports))).loadingIndicator
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                                                }),
                                                disabled: isLoading,
                                                onClick: onAdd,
                                                sx: {
                                                    width: "32px",
                                                    "& .MuiChip-label": {
                                                        display: "none"
                                                    },
                                                    "& .MuiChip-icon": {
                                                        marginLeft: 0,
                                                        marginRight: 0,
                                                        marginTop: "1px"
                                                    }
                                                }
                                            })
                                        }, "chip_add")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};



parcelRequire("7fPBF");
var $2b93b7aacf386886$exports = {};

$parcel$export($2b93b7aacf386886$exports, "description", function () { return $2b93b7aacf386886$export$6d59db4903f20f7d; }, function (v) { return $2b93b7aacf386886$export$6d59db4903f20f7d = v; });
$parcel$export($2b93b7aacf386886$exports, "fieldName", function () { return $2b93b7aacf386886$export$d57d50d329e176cd; }, function (v) { return $2b93b7aacf386886$export$d57d50d329e176cd = v; });
$parcel$export($2b93b7aacf386886$exports, "grid", function () { return $2b93b7aacf386886$export$85fc379452d91af0; }, function (v) { return $2b93b7aacf386886$export$85fc379452d91af0 = v; });
var $2b93b7aacf386886$export$6d59db4903f20f7d;
var $2b93b7aacf386886$export$d57d50d329e176cd;
var $2b93b7aacf386886$export$85fc379452d91af0;
$2b93b7aacf386886$export$6d59db4903f20f7d = `sLmfIG_description`;
$2b93b7aacf386886$export$d57d50d329e176cd = `sLmfIG_fieldName`;
$2b93b7aacf386886$export$85fc379452d91af0 = `sLmfIG_grid`;





class $e902f6ccf6183b97$export$f9add86e981d9e57 {
    static #_ = this.shared = new $e902f6ccf6183b97$export$f9add86e981d9e57();
    constructor(){
        this.bannedFields = ()=>[
                {
                    id: "label",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title
                },
                {
                    id: "store",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).store_title
                },
                {
                    id: "albumContents",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_contents_title
                },
                {
                    id: "tags",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title
                },
                {
                    id: "isGatefold",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_banned_field_is_gatefold
                },
                {
                    id: "isClean",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_banned_field_is_clean
                },
                {
                    id: "purchasePrice",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_title
                },
                {
                    id: "sellValue",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).sell_value_title
                },
                {
                    id: "revenue",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).revenue_title
                },
                {
                    id: "purchaseDate",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_date_title
                },
                {
                    id: "impact",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).impact_title
                },
                {
                    id: "notes",
                    name: (0, $37bec70ed65ed924$export$21c51bc433c16634).notes_title
                }
            ];
    }
    getNames(ids) {
        return ids.map((id)=>{
            for (const bannedField of this.bannedFields()){
                if (bannedField.id == id) return bannedField.name;
            }
            return "";
        });
    }
    getId(name) {
        for (const bannedField of this.bannedFields()){
            if (bannedField.name == name) return bannedField.id;
        }
        return "";
    }
}





const $dc2b2c39acc1c543$export$b196301fb8018490 = ({ open: open, setOpen: setOpen, onSelect: onSelect, alreadySelected: alreadySelected })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: open,
        onClose: ()=>setOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_banned_fields
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                        onClick: ()=>setOpen(false)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2b93b7aacf386886$exports))).description,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_banned_fields_description
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2b93b7aacf386886$exports))).grid,
                        children: (0, $e902f6ccf6183b97$export$f9add86e981d9e57).shared.bannedFields().map((bannedField)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                        sx: {
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            ":disabled": {
                                                color: theme.palette.colors?.disabled,
                                                opacity: 0.8
                                            }
                                        },
                                        disabled: alreadySelected.includes(bannedField.id),
                                        onClick: ()=>{
                                            onSelect(bannedField.id);
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2b93b7aacf386886$exports))).fieldName,
                                            children: bannedField.name
                                        })
                                    })
                                })
                            }, bannedField.id))
                    })
                ]
            })
        ]
    });
};





var $3678cf4d411f6f75$exports = {};

$parcel$export($3678cf4d411f6f75$exports, "fieldTitle", function () { return $3678cf4d411f6f75$export$e7b177dbdcaed6bd; }, function (v) { return $3678cf4d411f6f75$export$e7b177dbdcaed6bd = v; });
var $3678cf4d411f6f75$export$e7b177dbdcaed6bd;
$3678cf4d411f6f75$export$e7b177dbdcaed6bd = `yYWota_fieldTitle`;



const $65d5f5d9a9fdc48c$export$8931f415e35c77f4 = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3678cf4d411f6f75$exports))).fieldTitle, props.className),
        children: props.children
    });
};






parcelRequire("7fPBF");
var $c9212fcc20ea6f8e$exports = {};

$parcel$export($c9212fcc20ea6f8e$exports, "detail", function () { return $c9212fcc20ea6f8e$export$13a2d28b88853ef2; }, function (v) { return $c9212fcc20ea6f8e$export$13a2d28b88853ef2 = v; });
$parcel$export($c9212fcc20ea6f8e$exports, "icon", function () { return $c9212fcc20ea6f8e$export$1ca1ec8b29a4ce27; }, function (v) { return $c9212fcc20ea6f8e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($c9212fcc20ea6f8e$exports, "itemDiv", function () { return $c9212fcc20ea6f8e$export$64c46d98173ac23d; }, function (v) { return $c9212fcc20ea6f8e$export$64c46d98173ac23d = v; });
$parcel$export($c9212fcc20ea6f8e$exports, "itemDivWithoutTitle", function () { return $c9212fcc20ea6f8e$export$17579fe6e0df0c95; }, function (v) { return $c9212fcc20ea6f8e$export$17579fe6e0df0c95 = v; });
$parcel$export($c9212fcc20ea6f8e$exports, "loadingDiv", function () { return $c9212fcc20ea6f8e$export$dded2af20345efaa; }, function (v) { return $c9212fcc20ea6f8e$export$dded2af20345efaa = v; });
$parcel$export($c9212fcc20ea6f8e$exports, "title", function () { return $c9212fcc20ea6f8e$export$fb184b623420d9be; }, function (v) { return $c9212fcc20ea6f8e$export$fb184b623420d9be = v; });
var $c9212fcc20ea6f8e$export$13a2d28b88853ef2;
var $c9212fcc20ea6f8e$export$1ca1ec8b29a4ce27;
var $c9212fcc20ea6f8e$export$64c46d98173ac23d;
var $c9212fcc20ea6f8e$export$17579fe6e0df0c95;
var $c9212fcc20ea6f8e$export$dded2af20345efaa;
var $c9212fcc20ea6f8e$export$fb184b623420d9be;
$c9212fcc20ea6f8e$export$13a2d28b88853ef2 = `hCLGpq_detail`;
$c9212fcc20ea6f8e$export$1ca1ec8b29a4ce27 = `hCLGpq_icon`;
$c9212fcc20ea6f8e$export$64c46d98173ac23d = `hCLGpq_itemDiv`;
$c9212fcc20ea6f8e$export$17579fe6e0df0c95 = `hCLGpq_itemDivWithoutTitle`;
$c9212fcc20ea6f8e$export$dded2af20345efaa = `hCLGpq_loadingDiv`;
$c9212fcc20ea6f8e$export$fb184b623420d9be = `hCLGpq_title`;





const $af65e565b6be190c$export$2b4c8fd1120588cf = ({ title: title, detail: detail, isLoading: isLoading, onClick: onClick, iconType: iconType, disabled: disabled, maxLines: maxLines, hideTitle: hideTitle })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
        sx: {
            opacity: "1 !important"
        },
        onClick: onClick,
        disabled: disabled,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: title ? (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).itemDiv : (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).itemDivWithoutTitle,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                children: [
                    iconType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).icon,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: iconType
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        direction: "column",
                        children: [
                            !hideTitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).title,
                                        secondary: title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).loadingDiv,
                                        children: isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c9212fcc20ea6f8e$exports))).detail,
                                style: {
                                    color: theme.palette.primary.subtitle,
                                    WebkitLineClamp: maxLines
                                },
                                secondary: detail == "" ? "--" : detail
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $7676a003b473bd20$exports = {};

$parcel$export($7676a003b473bd20$exports, "description", function () { return $7676a003b473bd20$export$6d59db4903f20f7d; }, function (v) { return $7676a003b473bd20$export$6d59db4903f20f7d = v; });
$parcel$export($7676a003b473bd20$exports, "textField", function () { return $7676a003b473bd20$export$c54b92c0bb02ba64; }, function (v) { return $7676a003b473bd20$export$c54b92c0bb02ba64 = v; });
var $7676a003b473bd20$export$6d59db4903f20f7d;
var $7676a003b473bd20$export$c54b92c0bb02ba64;
$7676a003b473bd20$export$6d59db4903f20f7d = `yB-mbq_description`;
$7676a003b473bd20$export$c54b92c0bb02ba64 = `yB-mbq_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");

parcelRequire("7fPBF");
var $6c015238d769d37e$exports = {};

$parcel$export($6c015238d769d37e$exports, "textArea", function () { return $6c015238d769d37e$export$d72b0b1d2d0e0735; }, function (v) { return $6c015238d769d37e$export$d72b0b1d2d0e0735 = v; });
var $6c015238d769d37e$export$d72b0b1d2d0e0735;
$6c015238d769d37e$export$d72b0b1d2d0e0735 = `BOlvVq_textArea`;




var $gSkQi = parcelRequire("gSkQi");


const $6404516c91515038$export$9aae4d31a4cac70c = (props)=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
        component: "textarea",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6c015238d769d37e$exports))).textArea, props.className),
        style: {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.default
        },
        ...(0, $gSkQi.omit)(props, "className")
    });
};









const $a9634a717b986bba$export$486ad2a96c15885a = ({ title: title, description: description, placeholder: placeholder, open: open, onClose: onClose, value: value, onChange: onChange, onClearValue: onClearValue, onCancel: onCancel })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onCancelledByUser();
    };
    const onCancelledByUser = ()=>{
        formik.resetForm();
        onCancel?.();
        onClose();
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            value: value ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ value: value })=>{
            onChange(value);
            onClose();
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            onClearValue && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: ()=>{
                                    formik.resetForm();
                                    onClearValue?.();
                                    onClose();
                                },
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_value,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7676a003b473bd20$exports))).description,
                                children: description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6404516c91515038$export$9aae4d31a4cac70c), {
                                    id: "value",
                                    name: "value",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7676a003b473bd20$exports))).textField,
                                    autoFocus: !isMobile,
                                    placeholder: placeholder,
                                    value: formik.values.value,
                                    onChange: formik.handleChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onCancelledByUser,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92
};


var $aa42031db57b9246$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        'aac',
        'audio/aac'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'ico',
        'image/vnd.microsoft.icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'js',
        'text/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mjs',
        'text/javascript'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'opus',
        'audio/opus'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'ppt',
        'application/vnd.ms-powerpoint'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'rar',
        'application/vnd.rar'
    ],
    [
        'rtf',
        'application/rtf'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'wav',
        'audio/wav'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    // Others
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ]
]);
function $aa42031db57b9246$export$8cc09085015f0dc7(file, path) {
    var f = $aa42031db57b9246$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $aa42031db57b9246$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $aa42031db57b9246$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $febb6c601004d864$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $febb6c601004d864$export$a36e16046ae8f1bb(evt) {
    return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
            if ($febb6c601004d864$var$isObject(evt) && $febb6c601004d864$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($febb6c601004d864$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return 'getFile' in item && typeof item.getFile === 'function';
            })) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $febb6c601004d864$var$isDataTransfer(value) {
    return $febb6c601004d864$var$isObject(value);
}
function $febb6c601004d864$var$isChangeEvt(value) {
    return $febb6c601004d864$var$isObject(value) && $febb6c601004d864$var$isObject(value.target);
}
function $febb6c601004d864$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $febb6c601004d864$var$getInputFiles(evt) {
    return $febb6c601004d864$var$fromList(evt.target.files).map(function(file) {
        return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $febb6c601004d864$var$getFsHandleFiles(handles) {
    return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $febb6c601004d864$var$getDataTransferFiles(dt, type) {
    return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $febb6c601004d864$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($febb6c601004d864$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $febb6c601004d864$var$noIgnoredFiles($febb6c601004d864$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $febb6c601004d864$var$noIgnoredFiles($febb6c601004d864$var$fromList(dt.files).map(function(file) {
                            return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $febb6c601004d864$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $febb6c601004d864$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $febb6c601004d864$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $febb6c601004d864$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $febb6c601004d864$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $febb6c601004d864$var$fromDirEntry(entry);
    return $febb6c601004d864$var$fromDataTransferItem(item);
}
function $febb6c601004d864$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $1e2082910c54650f$export$1216008129fb82ed)((0, $1e2082910c54650f$export$1216008129fb82ed)([], (0, $1e2082910c54650f$export$8d051b38c9118094)(acc), false), (0, $1e2082910c54650f$export$8d051b38c9118094)(Array.isArray(files) ? $febb6c601004d864$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $febb6c601004d864$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $febb6c601004d864$var$fromEntry(entry) {
    return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $febb6c601004d864$var$fromDirEntry(entry) : $febb6c601004d864$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $febb6c601004d864$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $1e2082910c54650f$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($febb6c601004d864$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $febb6c601004d864$var$fromFileEntry(entry) {
    return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $d4bef793831b886e$export$1e511d4a378977f5;
var $d4bef793831b886e$export$2e2bcd8739ae039;
"use strict";
$d4bef793831b886e$export$1e511d4a378977f5 = true;
$d4bef793831b886e$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $64f375de9ad0fe46$var$_toConsumableArray(arr) {
    return $64f375de9ad0fe46$var$_arrayWithoutHoles(arr) || $64f375de9ad0fe46$var$_iterableToArray(arr) || $64f375de9ad0fe46$var$_unsupportedIterableToArray(arr) || $64f375de9ad0fe46$var$_nonIterableSpread();
}
function $64f375de9ad0fe46$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64f375de9ad0fe46$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $64f375de9ad0fe46$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $64f375de9ad0fe46$var$_arrayLikeToArray(arr);
}
function $64f375de9ad0fe46$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64f375de9ad0fe46$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $64f375de9ad0fe46$var$ownKeys(Object(source), !0).forEach(function(key) {
            $64f375de9ad0fe46$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $64f375de9ad0fe46$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64f375de9ad0fe46$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64f375de9ad0fe46$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $64f375de9ad0fe46$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $64f375de9ad0fe46$var$_typeof(obj);
}
function $64f375de9ad0fe46$var$_slicedToArray(arr, i) {
    return $64f375de9ad0fe46$var$_arrayWithHoles(arr) || $64f375de9ad0fe46$var$_iterableToArrayLimit(arr, i) || $64f375de9ad0fe46$var$_unsupportedIterableToArray(arr, i) || $64f375de9ad0fe46$var$_nonIterableRest();
}
function $64f375de9ad0fe46$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64f375de9ad0fe46$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $64f375de9ad0fe46$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $64f375de9ad0fe46$var$_arrayLikeToArray(o, minLen);
}
function $64f375de9ad0fe46$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $64f375de9ad0fe46$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $64f375de9ad0fe46$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $64f375de9ad0fe46$export$d2c35cc369247232 = "file-invalid-type";
var $64f375de9ad0fe46$export$d7bd1185abe1e87c = "file-too-large";
var $64f375de9ad0fe46$export$8bd5ec6ed990dc9 = "file-too-small";
var $64f375de9ad0fe46$export$3271ef1d2dd155f9 = "too-many-files";
var $64f375de9ad0fe46$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $64f375de9ad0fe46$export$d2c35cc369247232,
    FileTooLarge: $64f375de9ad0fe46$export$d7bd1185abe1e87c,
    FileTooSmall: $64f375de9ad0fe46$export$8bd5ec6ed990dc9,
    TooManyFiles: $64f375de9ad0fe46$export$3271ef1d2dd155f9
}; // File Errors
var $64f375de9ad0fe46$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $64f375de9ad0fe46$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $64f375de9ad0fe46$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $64f375de9ad0fe46$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $64f375de9ad0fe46$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $64f375de9ad0fe46$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $64f375de9ad0fe46$export$1e1e1b6120329fe = {
    code: $64f375de9ad0fe46$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $64f375de9ad0fe46$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $d4bef793831b886e$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $64f375de9ad0fe46$export$bc0bbda045f09b5a(accept)
    ];
}
function $64f375de9ad0fe46$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($64f375de9ad0fe46$var$isDefined(file.size)) {
        if ($64f375de9ad0fe46$var$isDefined(minSize) && $64f375de9ad0fe46$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $64f375de9ad0fe46$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $64f375de9ad0fe46$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($64f375de9ad0fe46$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $64f375de9ad0fe46$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($64f375de9ad0fe46$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $64f375de9ad0fe46$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $64f375de9ad0fe46$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $64f375de9ad0fe46$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $64f375de9ad0fe46$export$b511db3632effe58(file, accept), _fileAccepted2 = $64f375de9ad0fe46$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $64f375de9ad0fe46$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $64f375de9ad0fe46$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $64f375de9ad0fe46$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $64f375de9ad0fe46$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $64f375de9ad0fe46$export$f9006bf02b243736(item) {
    return $64f375de9ad0fe46$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $64f375de9ad0fe46$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $64f375de9ad0fe46$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $64f375de9ad0fe46$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $64f375de9ad0fe46$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $64f375de9ad0fe46$var$isIe(userAgent) || $64f375de9ad0fe46$var$isEdge(userAgent);
}
function $64f375de9ad0fe46$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$64f375de9ad0fe46$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $64f375de9ad0fe46$export$8d6d6472146de265(event);
        });
    };
}
function $64f375de9ad0fe46$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $64f375de9ad0fe46$export$8ce4bd13c494743e(accept) {
    if ($64f375de9ad0fe46$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $64f375de9ad0fe46$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$64f375de9ad0fe46$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($64f375de9ad0fe46$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $64f375de9ad0fe46$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $64f375de9ad0fe46$var$_objectSpread($64f375de9ad0fe46$var$_objectSpread({}, agg), {}, $64f375de9ad0fe46$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $64f375de9ad0fe46$export$1278288bcefb97b9(accept) {
    if ($64f375de9ad0fe46$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $64f375de9ad0fe46$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($64f375de9ad0fe46$var$_toConsumableArray(a), [
            mimeType
        ], $64f375de9ad0fe46$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $64f375de9ad0fe46$export$69c8ec3250e1cfbf(v) || $64f375de9ad0fe46$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $64f375de9ad0fe46$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $64f375de9ad0fe46$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $64f375de9ad0fe46$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $64f375de9ad0fe46$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $c08bbb67d1713114$var$_excluded = [
    "children"
], $c08bbb67d1713114$var$_excluded2 = [
    "open"
], $c08bbb67d1713114$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $c08bbb67d1713114$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $c08bbb67d1713114$var$_toConsumableArray(arr) {
    return $c08bbb67d1713114$var$_arrayWithoutHoles(arr) || $c08bbb67d1713114$var$_iterableToArray(arr) || $c08bbb67d1713114$var$_unsupportedIterableToArray(arr) || $c08bbb67d1713114$var$_nonIterableSpread();
}
function $c08bbb67d1713114$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c08bbb67d1713114$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c08bbb67d1713114$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c08bbb67d1713114$var$_arrayLikeToArray(arr);
}
function $c08bbb67d1713114$var$_slicedToArray(arr, i) {
    return $c08bbb67d1713114$var$_arrayWithHoles(arr) || $c08bbb67d1713114$var$_iterableToArrayLimit(arr, i) || $c08bbb67d1713114$var$_unsupportedIterableToArray(arr, i) || $c08bbb67d1713114$var$_nonIterableRest();
}
function $c08bbb67d1713114$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c08bbb67d1713114$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c08bbb67d1713114$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c08bbb67d1713114$var$_arrayLikeToArray(o, minLen);
}
function $c08bbb67d1713114$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c08bbb67d1713114$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c08bbb67d1713114$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c08bbb67d1713114$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c08bbb67d1713114$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c08bbb67d1713114$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c08bbb67d1713114$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c08bbb67d1713114$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c08bbb67d1713114$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c08bbb67d1713114$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c08bbb67d1713114$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c08bbb67d1713114$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $c08bbb67d1713114$var$Dropzone = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $c08bbb67d1713114$var$_objectWithoutProperties(_ref, $c08bbb67d1713114$var$_excluded);
    var _useDropzone = $c08bbb67d1713114$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $c08bbb67d1713114$var$_objectWithoutProperties(_useDropzone, $c08bbb67d1713114$var$_excluded2);
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, children($c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$c08bbb67d1713114$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $c08bbb67d1713114$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $febb6c601004d864$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$c08bbb67d1713114$var$Dropzone.defaultProps = $c08bbb67d1713114$var$defaultProps;
$c08bbb67d1713114$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $c08bbb67d1713114$export$2e2bcd8739ae039 = $c08bbb67d1713114$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $c08bbb67d1713114$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $c08bbb67d1713114$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $7fPBF.useMemo)(function() {
        return (0, $64f375de9ad0fe46$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $7fPBF.useMemo)(function() {
        return (0, $64f375de9ad0fe46$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $7fPBF.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $c08bbb67d1713114$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $7fPBF.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $c08bbb67d1713114$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $7fPBF.useRef)(null);
    var inputRef = (0, $7fPBF.useRef)(null);
    var _useReducer = (0, $7fPBF.useReducer)($c08bbb67d1713114$var$reducer, $c08bbb67d1713114$var$initialState), _useReducer2 = $c08bbb67d1713114$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $7fPBF.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $64f375de9ad0fe46$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $7fPBF.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $7fPBF.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $7fPBF.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $64f375de9ad0fe46$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $64f375de9ad0fe46$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $7fPBF.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $7fPBF.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($c08bbb67d1713114$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $64f375de9ad0fe46$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $64f375de9ad0fe46$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $7fPBF.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $64f375de9ad0fe46$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $c08bbb67d1713114$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $64f375de9ad0fe46$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $c08bbb67d1713114$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $64f375de9ad0fe46$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $64f375de9ad0fe46$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $7fPBF.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $64f375de9ad0fe46$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $64f375de9ad0fe46$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $7fPBF.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $7fPBF.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $64f375de9ad0fe46$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $7fPBF.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $c08bbb67d1713114$var$_objectWithoutProperties(_ref2, $c08bbb67d1713114$var$_excluded3);
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $7fPBF.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $7fPBF.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $c08bbb67d1713114$var$_objectWithoutProperties(_ref3, $c08bbb67d1713114$var$_excluded4);
            var inputProps = $c08bbb67d1713114$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $c08bbb67d1713114$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$initialState);
        default:
            return state;
    }
}
function $c08bbb67d1713114$var$noop() {}


var $51b7c6a31e30e7b4$exports = {};

$parcel$export($51b7c6a31e30e7b4$exports, "blurDiv", function () { return $51b7c6a31e30e7b4$export$d0ef6d37ab768eb4; }, function (v) { return $51b7c6a31e30e7b4$export$d0ef6d37ab768eb4 = v; });
$parcel$export($51b7c6a31e30e7b4$exports, "container", function () { return $51b7c6a31e30e7b4$export$34e0f9847d4c02dd; }, function (v) { return $51b7c6a31e30e7b4$export$34e0f9847d4c02dd = v; });
$parcel$export($51b7c6a31e30e7b4$exports, "image", function () { return $51b7c6a31e30e7b4$export$5c452ff88e35e47d; }, function (v) { return $51b7c6a31e30e7b4$export$5c452ff88e35e47d = v; });
$parcel$export($51b7c6a31e30e7b4$exports, "spineImage", function () { return $51b7c6a31e30e7b4$export$5c2b763bdde0a23d; }, function (v) { return $51b7c6a31e30e7b4$export$5c2b763bdde0a23d = v; });
var $51b7c6a31e30e7b4$export$d0ef6d37ab768eb4;
var $51b7c6a31e30e7b4$export$34e0f9847d4c02dd;
var $51b7c6a31e30e7b4$export$5c452ff88e35e47d;
var $51b7c6a31e30e7b4$export$5c2b763bdde0a23d;
$51b7c6a31e30e7b4$export$d0ef6d37ab768eb4 = `RyUAzG_blurDiv`;
$51b7c6a31e30e7b4$export$34e0f9847d4c02dd = `RyUAzG_container`;
$51b7c6a31e30e7b4$export$5c452ff88e35e47d = `RyUAzG_image`;
$51b7c6a31e30e7b4$export$5c2b763bdde0a23d = `RyUAzG_spineImage`;






var $7fPBF = parcelRequire("7fPBF");
const $ee02f4605e174339$export$c5623aa1c38918b6 = ()=>{
    const firstRender = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        firstRender.current = false;
    }, []);
    return firstRender.current;
};




const $2b304a23afa22224$export$bdb39032c3517208 = ({ disabled: disabled, className: className, style: style, onImageChanged: onImageChanged, initialImage: initialImage, placeholderImage: placeholderImage, isLoading: isLoading, shouldOpenFileDialog: shouldOpenFileDialog, onClick: onClick })=>{
    const firstRender = (0, $ee02f4605e174339$export$c5623aa1c38918b6)();
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [isSpine, setIsSpine] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setImageFile(undefined);
    }, [
        isLoading
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, open: open } = (0, $c08bbb67d1713114$export$cd49c0ecc5be9f36)({
        accept: {
            "image/*": []
        },
        disabled: disabled,
        noClick: true,
        maxFiles: 1,
        onDrop: (acceptedFiles, filesRejection)=>{
            if (filesRejection.length > 0) {
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).upload_multiple_images_error);
                return;
            }
            const file = Object.assign(acceptedFiles[0], {
                preview: URL.createObjectURL(acceptedFiles[0])
            });
            setImageFile(file);
            onImageChanged(file);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (firstRender) return;
        open();
    }, [
        shouldOpenFileDialog
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (imageFile) return ()=>URL.revokeObjectURL(imageFile.preview);
    }, [
        imageFile
    ]);
    const updateDimensions = (source)=>{
        const image = new Image();
        image.src = source;
        image.onload = function() {
            setIsSpine(image.height > image.width);
        };
    };
    (0, $7fPBF.useEffect)(()=>{
        updateDimensions(imageFile?.preview ?? initialImage ?? placeholderImage);
    }, [
        imageFile,
        initialImage,
        placeholderImage
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($51b7c6a31e30e7b4$exports))).container),
        ...getRootProps(),
        style: {
            ...style,
            backgroundColor: "transparent"
        },
        onClick: onClick ?? open,
        children: [
            isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($51b7c6a31e30e7b4$exports))).blurDiv,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: isSpine ? (0, (/*@__PURE__*/$parcel$interopDefault($51b7c6a31e30e7b4$exports))).spineImage : (0, (/*@__PURE__*/$parcel$interopDefault($51b7c6a31e30e7b4$exports))).image,
                src: imageFile?.preview ?? initialImage ?? placeholderImage,
                alt: "Image"
            })
        ]
    });
};







var $7fPBF = parcelRequire("7fPBF");


var $034ebb6e8311c3a0$exports = {};

$parcel$export($034ebb6e8311c3a0$exports, "cardContainer", function () { return $034ebb6e8311c3a0$export$6b2d426110a11d7a; }, function (v) { return $034ebb6e8311c3a0$export$6b2d426110a11d7a = v; });
$parcel$export($034ebb6e8311c3a0$exports, "collectionCard", function () { return $034ebb6e8311c3a0$export$63ab7202a5c80ed; }, function (v) { return $034ebb6e8311c3a0$export$63ab7202a5c80ed = v; });
$parcel$export($034ebb6e8311c3a0$exports, "contentCard", function () { return $034ebb6e8311c3a0$export$9261782d08389607; }, function (v) { return $034ebb6e8311c3a0$export$9261782d08389607 = v; });
$parcel$export($034ebb6e8311c3a0$exports, "loadingDiv", function () { return $034ebb6e8311c3a0$export$dded2af20345efaa; }, function (v) { return $034ebb6e8311c3a0$export$dded2af20345efaa = v; });
$parcel$export($034ebb6e8311c3a0$exports, "searchBar", function () { return $034ebb6e8311c3a0$export$f2ea4ab276c3e3fa; }, function (v) { return $034ebb6e8311c3a0$export$f2ea4ab276c3e3fa = v; });
var $034ebb6e8311c3a0$export$6b2d426110a11d7a;
var $034ebb6e8311c3a0$export$63ab7202a5c80ed;
var $034ebb6e8311c3a0$export$9261782d08389607;
var $034ebb6e8311c3a0$export$dded2af20345efaa;
var $034ebb6e8311c3a0$export$f2ea4ab276c3e3fa;
$034ebb6e8311c3a0$export$6b2d426110a11d7a = `_75iWDq_cardContainer`;
$034ebb6e8311c3a0$export$63ab7202a5c80ed = `_75iWDq_collectionCard`;
$034ebb6e8311c3a0$export$9261782d08389607 = `_75iWDq_contentCard`;
$034ebb6e8311c3a0$export$dded2af20345efaa = `_75iWDq_loadingDiv`;
$034ebb6e8311c3a0$export$f2ea4ab276c3e3fa = `_75iWDq_searchBar`;





var $7fPBF = parcelRequire("7fPBF");
var $ad3aa8d951271f66$exports = {};

$parcel$export($ad3aa8d951271f66$exports, "actionArea", function () { return $ad3aa8d951271f66$export$746dc5cb6bd7e71f; }, function (v) { return $ad3aa8d951271f66$export$746dc5cb6bd7e71f = v; });
$parcel$export($ad3aa8d951271f66$exports, "container", function () { return $ad3aa8d951271f66$export$34e0f9847d4c02dd; }, function (v) { return $ad3aa8d951271f66$export$34e0f9847d4c02dd = v; });
$parcel$export($ad3aa8d951271f66$exports, "description", function () { return $ad3aa8d951271f66$export$6d59db4903f20f7d; }, function (v) { return $ad3aa8d951271f66$export$6d59db4903f20f7d = v; });
$parcel$export($ad3aa8d951271f66$exports, "discountBox", function () { return $ad3aa8d951271f66$export$846ba29c579fca64; }, function (v) { return $ad3aa8d951271f66$export$846ba29c579fca64 = v; });
$parcel$export($ad3aa8d951271f66$exports, "item", function () { return $ad3aa8d951271f66$export$7061c75fc5af8b7e; }, function (v) { return $ad3aa8d951271f66$export$7061c75fc5af8b7e = v; });
$parcel$export($ad3aa8d951271f66$exports, "name", function () { return $ad3aa8d951271f66$export$a8ff84c12d48cfa6; }, function (v) { return $ad3aa8d951271f66$export$a8ff84c12d48cfa6 = v; });
$parcel$export($ad3aa8d951271f66$exports, "newPrice", function () { return $ad3aa8d951271f66$export$bf2b2c68f2d3892d; }, function (v) { return $ad3aa8d951271f66$export$bf2b2c68f2d3892d = v; });
$parcel$export($ad3aa8d951271f66$exports, "oldPrice", function () { return $ad3aa8d951271f66$export$9853811e0e64ec55; }, function (v) { return $ad3aa8d951271f66$export$9853811e0e64ec55 = v; });
$parcel$export($ad3aa8d951271f66$exports, "price", function () { return $ad3aa8d951271f66$export$321c0b1a406de31f; }, function (v) { return $ad3aa8d951271f66$export$321c0b1a406de31f = v; });
$parcel$export($ad3aa8d951271f66$exports, "readName", function () { return $ad3aa8d951271f66$export$ccff49e992952c96; }, function (v) { return $ad3aa8d951271f66$export$ccff49e992952c96 = v; });
$parcel$export($ad3aa8d951271f66$exports, "severityMark", function () { return $ad3aa8d951271f66$export$a070fdabc28e8418; }, function (v) { return $ad3aa8d951271f66$export$a070fdabc28e8418 = v; });
var $ad3aa8d951271f66$export$746dc5cb6bd7e71f;
var $ad3aa8d951271f66$export$34e0f9847d4c02dd;
var $ad3aa8d951271f66$export$6d59db4903f20f7d;
var $ad3aa8d951271f66$export$846ba29c579fca64;
var $ad3aa8d951271f66$export$7061c75fc5af8b7e;
var $ad3aa8d951271f66$export$a8ff84c12d48cfa6;
var $ad3aa8d951271f66$export$bf2b2c68f2d3892d;
var $ad3aa8d951271f66$export$9853811e0e64ec55;
var $ad3aa8d951271f66$export$321c0b1a406de31f;
var $ad3aa8d951271f66$export$ccff49e992952c96;
var $ad3aa8d951271f66$export$a070fdabc28e8418;
$ad3aa8d951271f66$export$746dc5cb6bd7e71f = `Z6Xnea_actionArea`;
$ad3aa8d951271f66$export$34e0f9847d4c02dd = `Z6Xnea_container`;
$ad3aa8d951271f66$export$6d59db4903f20f7d = `Z6Xnea_description`;
$ad3aa8d951271f66$export$846ba29c579fca64 = `Z6Xnea_discountBox`;
$ad3aa8d951271f66$export$7061c75fc5af8b7e = `Z6Xnea_item`;
$ad3aa8d951271f66$export$a8ff84c12d48cfa6 = `Z6Xnea_name`;
$ad3aa8d951271f66$export$bf2b2c68f2d3892d = `Z6Xnea_newPrice`;
$ad3aa8d951271f66$export$9853811e0e64ec55 = `Z6Xnea_oldPrice`;
$ad3aa8d951271f66$export$321c0b1a406de31f = `Z6Xnea_price`;
$ad3aa8d951271f66$export$ccff49e992952c96 = `Z6Xnea_readName`;
$ad3aa8d951271f66$export$a070fdabc28e8418 = `Z6Xnea_severityMark`;









parcelRequire("7fPBF");



var $aa700ea69b8bb860$exports = {};

$parcel$export($aa700ea69b8bb860$exports, "description", function () { return $aa700ea69b8bb860$export$6d59db4903f20f7d; }, function (v) { return $aa700ea69b8bb860$export$6d59db4903f20f7d = v; });
$parcel$export($aa700ea69b8bb860$exports, "price", function () { return $aa700ea69b8bb860$export$321c0b1a406de31f; }, function (v) { return $aa700ea69b8bb860$export$321c0b1a406de31f = v; });
$parcel$export($aa700ea69b8bb860$exports, "textStack", function () { return $aa700ea69b8bb860$export$f771374e88773462; }, function (v) { return $aa700ea69b8bb860$export$f771374e88773462 = v; });
var $aa700ea69b8bb860$export$6d59db4903f20f7d;
var $aa700ea69b8bb860$export$321c0b1a406de31f;
var $aa700ea69b8bb860$export$f771374e88773462;
$aa700ea69b8bb860$export$6d59db4903f20f7d = `mKZaQa_description`;
$aa700ea69b8bb860$export$321c0b1a406de31f = `mKZaQa_price`;
$aa700ea69b8bb860$export$f771374e88773462 = `mKZaQa_textStack`;



parcelRequire("7fPBF");


var $a9e9b9704a74bcd6$exports = {};

$parcel$export($a9e9b9704a74bcd6$exports, "card", function () { return $a9e9b9704a74bcd6$export$aa3e815946b80764; }, function (v) { return $a9e9b9704a74bcd6$export$aa3e815946b80764 = v; });
$parcel$export($a9e9b9704a74bcd6$exports, "description", function () { return $a9e9b9704a74bcd6$export$6d59db4903f20f7d; }, function (v) { return $a9e9b9704a74bcd6$export$6d59db4903f20f7d = v; });
$parcel$export($a9e9b9704a74bcd6$exports, "option", function () { return $a9e9b9704a74bcd6$export$a75d1723e6bda2ec; }, function (v) { return $a9e9b9704a74bcd6$export$a75d1723e6bda2ec = v; });
$parcel$export($a9e9b9704a74bcd6$exports, "payButton", function () { return $a9e9b9704a74bcd6$export$40e5bb4e8d1653e2; }, function (v) { return $a9e9b9704a74bcd6$export$40e5bb4e8d1653e2 = v; });
$parcel$export($a9e9b9704a74bcd6$exports, "price", function () { return $a9e9b9704a74bcd6$export$321c0b1a406de31f; }, function (v) { return $a9e9b9704a74bcd6$export$321c0b1a406de31f = v; });
var $a9e9b9704a74bcd6$export$aa3e815946b80764;
var $a9e9b9704a74bcd6$export$6d59db4903f20f7d;
var $a9e9b9704a74bcd6$export$a75d1723e6bda2ec;
var $a9e9b9704a74bcd6$export$40e5bb4e8d1653e2;
var $a9e9b9704a74bcd6$export$321c0b1a406de31f;
$a9e9b9704a74bcd6$export$aa3e815946b80764 = `ZXzP3W_card`;
$a9e9b9704a74bcd6$export$6d59db4903f20f7d = `ZXzP3W_description`;
$a9e9b9704a74bcd6$export$a75d1723e6bda2ec = `ZXzP3W_option`;
$a9e9b9704a74bcd6$export$40e5bb4e8d1653e2 = `ZXzP3W_payButton`;
$a9e9b9704a74bcd6$export$321c0b1a406de31f = `ZXzP3W_price`;





const $62a5eb8b234211c3$export$ccd7458029fb351d = ({ isSubscription: isSubscription, price: price, currency: currency, imageSrc: imageSrc, buttonText: buttonText, description: description, optionText: optionText, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a9e9b9704a74bcd6$exports))).card,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9e9b9704a74bcd6$exports))).option,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: [
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option,
                        " ",
                        optionText
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9e9b9704a74bcd6$exports))).price,
                    children: [
                        currencyFormatter.format(price, currentUserProfile, false, 2, currency, true),
                        " ",
                        isSubscription ? (0, $37bec70ed65ed924$export$21c51bc433c16634).per_month : ""
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9e9b9704a74bcd6$exports))).payButton,
                    imageSrc: imageSrc,
                    buttonText: buttonText,
                    onClick: onClick
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9e9b9704a74bcd6$exports))).description,
                    children: description
                })
            ]
        })
    });
};



const $8591708a48fb6166$export$7838429ae9015762 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const createMercadoPagoPurchasePreference = async (parameters)=>{
        return post("mercadopago/preference", parameters);
    };
    return {
        createMercadoPagoPurchasePreference: createMercadoPagoPurchasePreference
    };
};






const $f780354330c94133$export$f6c5aae7f7e3694 = ({ product: product, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const { openInNewTab: openInNewTab, openInSameTab: openInSameTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const { createMercadoPagoPurchasePreference: createMercadoPagoPurchasePreference } = (0, $8591708a48fb6166$export$7838429ae9015762)();
    const createPreference = async ()=>{
        const { status: status, body: body } = await createMercadoPagoPurchasePreference({
            productId: product.id
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) openInSameTab(body.init_point);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: product.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>{
                            setIsOpen(false);
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa700ea69b8bb860$exports))).textStack,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa700ea69b8bb860$exports))).description,
                            children: product.description
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62a5eb8b234211c3$export$ccd7458029fb351d), {
                            isSubscription: false,
                            price: product.finalPriceARS,
                            currency: "ARS",
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/MercadoPagoLogo.jpg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_mercadopago,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_info,
                            optionText: (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option_mercado_pago,
                            onClick: ()=>createPreference()
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62a5eb8b234211c3$export$ccd7458029fb351d), {
                            isSubscription: false,
                            price: product.finalPriceUSD,
                            currency: "USD",
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/AppleLogo.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_apple,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_info_apple,
                            optionText: (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option_apple,
                            onClick: ()=>openInNewTab(`https://apple.co/3P2tpt7`)
                        })
                    ]
                })
            })
        ]
    });
};




const $88ea1d1614cf2c4c$export$263af5efbaa94422 = ({ product: product, productType: productType })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).item,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).container,
                elevation: 5,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).actionArea, (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).positionContainer),
                        onClick: ()=>setIsPurchaseDialogOpen(true),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).severityMark,
                                style: {
                                    backgroundColor: theme.palette.colors.highlightBorder
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "100%",
                                    alignItems: "center"
                                },
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: product.type == "bundle" ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LocalMall : (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[productType]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).name,
                                                        children: product.name
                                                    }),
                                                    product.discountARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed350f6794f06f61$export$3229296aace3d746), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).discountBox,
                                                        percentage: product.discountARS
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).description, (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).description),
                                                children: product.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        flexGrow: 1
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).price,
                                        children: product.priceARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                product.discountARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).oldPrice,
                                                    style: {
                                                        color: theme.palette.secondary.main
                                                    },
                                                    children: currencyFormatter.format((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? product.priceARS : product.priceUSD, currentUserProfile, false, 2, (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? "ARS" : "USD", (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale !== "es-AR")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ad3aa8d951271f66$exports))).newPrice,
                                                    variant: "outlined",
                                                    label: currencyFormatter.format((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? product.finalPriceARS : product.finalPriceUSD, currentUserProfile, false, 2, (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? "ARS" : "USD", (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale !== "es-AR")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f780354330c94133$export$f6c5aae7f7e3694), {
                product: product,
                isOpen: isPurchaseDialogOpen,
                setIsOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};



var $0b1f770d48904c8d$exports = {};

$parcel$export($0b1f770d48904c8d$exports, "addButton", function () { return $0b1f770d48904c8d$export$76174c80c75f9baa; }, function (v) { return $0b1f770d48904c8d$export$76174c80c75f9baa = v; });
$parcel$export($0b1f770d48904c8d$exports, "noItems", function () { return $0b1f770d48904c8d$export$62bd5d1d7d32b664; }, function (v) { return $0b1f770d48904c8d$export$62bd5d1d7d32b664 = v; });
$parcel$export($0b1f770d48904c8d$exports, "noItemsIcon", function () { return $0b1f770d48904c8d$export$b7ee068d753b796e; }, function (v) { return $0b1f770d48904c8d$export$b7ee068d753b796e = v; });
$parcel$export($0b1f770d48904c8d$exports, "noItemsStack", function () { return $0b1f770d48904c8d$export$f7d912ec6b20b32d; }, function (v) { return $0b1f770d48904c8d$export$f7d912ec6b20b32d = v; });
$parcel$export($0b1f770d48904c8d$exports, "noItemsSubtitle", function () { return $0b1f770d48904c8d$export$e0007093cde6143a; }, function (v) { return $0b1f770d48904c8d$export$e0007093cde6143a = v; });
var $0b1f770d48904c8d$export$76174c80c75f9baa;
var $0b1f770d48904c8d$export$62bd5d1d7d32b664;
var $0b1f770d48904c8d$export$b7ee068d753b796e;
var $0b1f770d48904c8d$export$f7d912ec6b20b32d;
var $0b1f770d48904c8d$export$e0007093cde6143a;
$0b1f770d48904c8d$export$76174c80c75f9baa = `aWujzW_addButton`;
$0b1f770d48904c8d$export$62bd5d1d7d32b664 = `aWujzW_noItems`;
$0b1f770d48904c8d$export$b7ee068d753b796e = `aWujzW_noItemsIcon`;
$0b1f770d48904c8d$export$f7d912ec6b20b32d = `aWujzW_noItemsStack`;
$0b1f770d48904c8d$export$e0007093cde6143a = `aWujzW_noItemsSubtitle`;



var $7fPBF = parcelRequire("7fPBF");





const $645e76f99719d34f$export$a665da17a0bb552f = ({ isLoading: isLoading, defaultVisible: defaultVisible = false, items: items, emptyIconType: emptyIconType, emptyTitle: emptyTitle, emptyDescription: emptyDescription, addButtonTitle: addButtonTitle, searchText: searchText, onAddItem: onAddItem, canAdd: canAdd })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const visible = (0, $7fPBF.useMemo)(()=>{
        if (items === undefined || isLoading) return defaultVisible;
        return items.length == 0;
    }, [
        items
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: !items?.length && !isLoading && visible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($0b1f770d48904c8d$exports))).noItemsStack,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                    type: searchText ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Search : emptyIconType,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0b1f770d48904c8d$exports))).noItemsIcon,
                    style: {
                        color: theme.palette.primary.subtitle
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0b1f770d48904c8d$exports))).noItems,
                    children: searchText ? (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).empty_search_title, searchText) : emptyTitle
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0b1f770d48904c8d$exports))).noItemsSubtitle,
                    style: {
                        color: theme.palette.primary.subtitle
                    },
                    children: searchText ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_search_description : emptyDescription
                }),
                canAdd && !searchText && addButtonTitle && onAddItem && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd9fddf804095b6$export$3be6c17b609e7ce3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0b1f770d48904c8d$exports))).addButton,
                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle,
                    title: addButtonTitle,
                    onClick: onAddItem
                })
            ]
        })
    });
};



const $70f1decf562062da$export$160588f07102e32f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getAlbumProducts = ()=>get("products/albums");
    return {
        getAlbumProducts: getAlbumProducts
    };
};




const $19b911c5f4c5fbee$export$e9765f71b06e3735 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getCollectionProducts = ()=>get("products/collections");
    return {
        getCollectionProducts: getCollectionProducts
    };
};



const $0cd63aa88c6b7f09$export$8d979098e6d2cb96 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getShelvingProducts = ()=>get("products/shelvings");
    return {
        getShelvingProducts: getShelvingProducts
    };
};



const $9f32feb0f11b24c1$export$cd2e209c722a849f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getArtistProducts = ()=>get("products/artists");
    return {
        getArtistProducts: getArtistProducts
    };
};



const $6404ebde8c1771da$export$db23d748a26e9778 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getLabelProducts = ()=>get("products/labels");
    return {
        getLabelProducts: getLabelProducts
    };
};



const $0bd987a36f0f7b98$export$d28bdaec0951f43f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getAlbumFormatProducts = ()=>get("products/albumFormats");
    return {
        getAlbumFormatProducts: getAlbumFormatProducts
    };
};



const $f138074a5726060f$export$3dcd1eec6d88e909 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getAlbumTypeProducts = ()=>get("products/albumTypes");
    return {
        getAlbumTypeProducts: getAlbumTypeProducts
    };
};



const $8965aa5981806af7$export$4aabd152c61cc181 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getTagProducts = ()=>get("products/tags");
    return {
        getTagProducts: getTagProducts
    };
};



const $2c525c02b51c56d1$export$b756179b9fe07122 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getStoreProducts = ()=>get("products/stores");
    return {
        getStoreProducts: getStoreProducts
    };
};



const $914d7b0e2ef67c75$export$65acde2cd15fbbe2 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getSellValueProducts = ()=>get("products/sellValues");
    return {
        getSellValueProducts: getSellValueProducts
    };
};



const $5e81651fa32a884e$export$e227eae2bfd43b01 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getExchangeRateProducts = ()=>get("products/exchangeRates");
    return {
        getExchangeRateProducts: getExchangeRateProducts
    };
};






const $a040b02790afe721$export$4db7bd9a8ddfc9af = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getBundleProducts = ()=>get("products/bundles");
    return {
        getBundleProducts: getBundleProducts
    };
};





const $911a114a71cd31c6$export$5182b767b22aa742 = ({ productType: productType, open: open, setOpen: setOpen })=>{
    const [products, setProducts] = (0, $7fPBF.useState)();
    const { getAlbumProducts: getAlbumProducts } = (0, $70f1decf562062da$export$160588f07102e32f)();
    const { getCollectionProducts: getCollectionProducts } = (0, $19b911c5f4c5fbee$export$e9765f71b06e3735)();
    const { getShelvingProducts: getShelvingProducts } = (0, $0cd63aa88c6b7f09$export$8d979098e6d2cb96)();
    const { getArtistProducts: getArtistProducts } = (0, $9f32feb0f11b24c1$export$cd2e209c722a849f)();
    const { getLabelProducts: getLabelProducts } = (0, $6404ebde8c1771da$export$db23d748a26e9778)();
    const { getAlbumFormatProducts: getAlbumFormatProducts } = (0, $0bd987a36f0f7b98$export$d28bdaec0951f43f)();
    const { getAlbumTypeProducts: getAlbumTypeProducts } = (0, $f138074a5726060f$export$3dcd1eec6d88e909)();
    const { getTagProducts: getTagProducts } = (0, $8965aa5981806af7$export$4aabd152c61cc181)();
    const { getStoreProducts: getStoreProducts } = (0, $2c525c02b51c56d1$export$b756179b9fe07122)();
    const { getSellValueProducts: getSellValueProducts } = (0, $914d7b0e2ef67c75$export$65acde2cd15fbbe2)();
    const { getExchangeRateProducts: getExchangeRateProducts } = (0, $5e81651fa32a884e$export$e227eae2bfd43b01)();
    const { getBundleProducts: getBundleProducts } = (0, $a040b02790afe721$export$4db7bd9a8ddfc9af)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (open) getProducts().then();
    }, [
        open
    ]);
    const getProducts = async ()=>{
        setLoading(true);
        setProducts(undefined);
        const { status: status, body: body } = await request();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setProducts(body);
        else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) // User has to login again
        setIsSignInAgainDialogOpen(true);
        setLoading(false);
    };
    const title = ()=>{
        switch(productType){
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelvings_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ARTISTS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_artists_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).LABELS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_labels_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_FORMATS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_formats_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_TYPES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_types_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).STORES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_stores_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).SELL_VALUES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sell_values_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).EXCHANGE_RATES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_exchange_rates_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).TAGS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title;
            case (0, $bfb1968c11a59179$export$11b099a658b17995).BUNDLES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).bundles_title;
        }
    };
    const request = ()=>{
        switch(productType){
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS:
                return getAlbumProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS:
                return getCollectionProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS:
                return getShelvingProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ARTISTS:
                return getArtistProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).LABELS:
                return getLabelProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_FORMATS:
                return getAlbumFormatProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_TYPES:
                return getAlbumTypeProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).STORES:
                return getStoreProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).SELL_VALUES:
                return getSellValueProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).EXCHANGE_RATES:
                return getExchangeRateProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).TAGS:
                return getTagProducts();
            case (0, $bfb1968c11a59179$export$11b099a658b17995).BUNDLES:
                return getBundleProducts();
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: open,
        onClose: ()=>setOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: title()
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.purchases()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: loading,
                        onClick: ()=>{
                            setOpen(false);
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($034ebb6e8311c3a0$exports))).contentCard,
                children: [
                    products && products.map((product)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88ea1d1614cf2c4c$export$263af5efbaa94422), {
                            product: product,
                            productType: productType
                        }, product.id)),
                    loading && Array.from({
                        length: 3
                    }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($034ebb6e8311c3a0$exports))).cardContainer,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                height: 60,
                                variant: "rectangular",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($034ebb6e8311c3a0$exports))).collectionCard
                            })
                        }, index)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: loading,
                        items: products ?? [],
                        emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ShoppingBasket,
                        emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_empty_list_error,
                        emptyDescription: "",
                        searchText: "",
                        canAdd: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    await getProducts();
                }
            })
        ]
    });
};






const $fb7fbf5bdb01f904$export$244af3c518fd0ae1 = ({ open: open, onClose: onClose, collection: collection, callback: callback, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = collection ? (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_new_title;
    const { addCollection: addCollection } = (0, $cf21db7337005170$export$b2a3b32f7c207ac2)();
    const { modifyCollection: modifyCollection } = (0, $c45b4f55dd4266e9$export$70661bc05950df9e)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [bannedFieldsDialogOpen, setBannedFieldsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [purchaseAlertIsOpen, setPurchaseAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [purchaseDialogIsOpen, setPurchaseDialogIsOpen] = (0, $7fPBF.useState)(false);
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const genericImage = new URL($a535e2e83d1fcdca$exports).href;
    const possibleDiscounts = [
        0,
        0.1,
        0.2,
        0.3,
        0.4,
        0.5,
        0.6,
        0.7,
        0.8,
        0.9,
        1
    ];
    const fetchImage = async ()=>{
        if (!collection?.hasImage) return;
        const response = await getImage({
            name: collection.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigCollectionImageWidth,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigCollectionImageHeight
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setImage(undefined);
        setDidChangeImage(false);
        fetchImage().then();
    }, [
        open
    ]);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: collection?.name ?? "",
            description: collection?.description ?? "",
            visibility: collection?.visibility ?? "private",
            bannedFields: collection?.bannedFields ?? [],
            discount: collection?.discount ?? 0
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, description: description, visibility: visibility, bannedFields: bannedFields, discount: discount })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (collection) {
                const { status: status, body: body } = await modifyCollection({
                    uuid: collection.uuid,
                    name: name,
                    description: description,
                    visibility: visibility,
                    bannedFields: bannedFields,
                    discount: discount
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addCollection({
                    name: name,
                    description: description,
                    visibility: visibility,
                    bannedFields: bannedFields,
                    discount: discount
                });
                statusCode = status;
                responseBody = body;
            }
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("collection_action");
                if (didChangeImage && imageFile && responseBody.uuid) await uploadImage({
                    name: responseBody.uuid,
                    file: imageFile
                }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigCollectionImageWidth, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigCollectionImageHeight, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageWidth, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageHeight);
                callback?.();
                onClose();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(statusCode)) {
                setAlertMessage(responseBody.message);
                setPurchaseAlertIsOpen(true);
            } else {
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const handleVisibilityChange = (_event, visibility)=>{
        if (visibility !== null) formik.setFieldValue("visibility", visibility).then();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            collection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).dropzone,
                                onImageChanged: (file)=>{
                                    setImageFile(file);
                                    setDidChangeImage(true);
                                },
                                placeholderImage: genericImage,
                                initialImage: image ? `data:image/png;base64,${image}` : collection?.thumbnail ? `data:image/png;base64,${collection.thumbnail}` : undefined,
                                isLoading: false
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).subtitle,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_image_info
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_name_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_visibility
                            }),
                            !collection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).subtitle,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_create_visibility
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).visibility,
                                labels: [
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).private_collection,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).public_collection
                                ],
                                values: [
                                    "private",
                                    "public"
                                ],
                                value: formik.values.visibility,
                                fullWidth: true,
                                disableGutters: true,
                                disabled: collection === undefined,
                                handleChange: handleVisibilityChange
                            }),
                            collection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.FieldArray), {
                                name: "bannedFields",
                                render: (arrayHelpers)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_banned_fields
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).bannedFields,
                                                disableGutters: true,
                                                title: "",
                                                chips: (0, $e902f6ccf6183b97$export$f9add86e981d9e57).shared.getNames(formik.values.bannedFields).map((name)=>({
                                                        id: name,
                                                        name: name
                                                    })),
                                                onAdd: ()=>setBannedFieldsDialogOpen(true),
                                                onDelete: arrayHelpers.remove
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc2b2c39acc1c543$export$b196301fb8018490), {
                                                open: bannedFieldsDialogOpen,
                                                setOpen: setBannedFieldsDialogOpen,
                                                onSelect: (value)=>{
                                                    arrayHelpers.push(value);
                                                    setBannedFieldsDialogOpen(false);
                                                },
                                                alreadySelected: formik.values.bannedFields
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_discount
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: String(formik.values.discount),
                                renderValue: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: `${String(formik.values.discount * 100)} %`
                                    }),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).selectDiscount,
                                onChange: (event)=>formik.setFieldValue("discount", +event.target.value),
                                sx: {
                                    height: "36px",
                                    borderRadius: "12px"
                                },
                                children: possibleDiscounts.map((discount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: discount,
                                        children: `${String(discount * 100)} %`
                                    }, `item_${index}`))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($dff48a3df5958394$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: purchaseAlertIsOpen,
                setOpen: setPurchaseAlertIsOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setPurchaseDialogIsOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS,
                open: purchaseDialogIsOpen,
                setOpen: setPurchaseDialogIsOpen
            })
        ]
    });
};


var $0627f43e5d4731d7$exports = {};

$parcel$export($0627f43e5d4731d7$exports, "cardContainer", function () { return $0627f43e5d4731d7$export$6b2d426110a11d7a; }, function (v) { return $0627f43e5d4731d7$export$6b2d426110a11d7a = v; });
$parcel$export($0627f43e5d4731d7$exports, "collectionCard", function () { return $0627f43e5d4731d7$export$63ab7202a5c80ed; }, function (v) { return $0627f43e5d4731d7$export$63ab7202a5c80ed = v; });
$parcel$export($0627f43e5d4731d7$exports, "collectionCardSkeleton", function () { return $0627f43e5d4731d7$export$40ce61452aefd388; }, function (v) { return $0627f43e5d4731d7$export$40ce61452aefd388 = v; });
$parcel$export($0627f43e5d4731d7$exports, "contentCard", function () { return $0627f43e5d4731d7$export$9261782d08389607; }, function (v) { return $0627f43e5d4731d7$export$9261782d08389607 = v; });
$parcel$export($0627f43e5d4731d7$exports, "hoverButton", function () { return $0627f43e5d4731d7$export$b0260c0afbf48c57; }, function (v) { return $0627f43e5d4731d7$export$b0260c0afbf48c57 = v; });
$parcel$export($0627f43e5d4731d7$exports, "hoverButtonsStack", function () { return $0627f43e5d4731d7$export$a8eacba2c33c9f28; }, function (v) { return $0627f43e5d4731d7$export$a8eacba2c33c9f28 = v; });
$parcel$export($0627f43e5d4731d7$exports, "loadingDiv", function () { return $0627f43e5d4731d7$export$dded2af20345efaa; }, function (v) { return $0627f43e5d4731d7$export$dded2af20345efaa = v; });
$parcel$export($0627f43e5d4731d7$exports, "searchBar", function () { return $0627f43e5d4731d7$export$f2ea4ab276c3e3fa; }, function (v) { return $0627f43e5d4731d7$export$f2ea4ab276c3e3fa = v; });
var $0627f43e5d4731d7$export$6b2d426110a11d7a;
var $0627f43e5d4731d7$export$63ab7202a5c80ed;
var $0627f43e5d4731d7$export$40ce61452aefd388;
var $0627f43e5d4731d7$export$9261782d08389607;
var $0627f43e5d4731d7$export$b0260c0afbf48c57;
var $0627f43e5d4731d7$export$a8eacba2c33c9f28;
var $0627f43e5d4731d7$export$dded2af20345efaa;
var $0627f43e5d4731d7$export$f2ea4ab276c3e3fa;
$0627f43e5d4731d7$export$6b2d426110a11d7a = `Hca4Ha_cardContainer`;
$0627f43e5d4731d7$export$63ab7202a5c80ed = `Hca4Ha_collectionCard`;
$0627f43e5d4731d7$export$40ce61452aefd388 = `Hca4Ha_collectionCardSkeleton`;
$0627f43e5d4731d7$export$9261782d08389607 = `Hca4Ha_contentCard`;
$0627f43e5d4731d7$export$b0260c0afbf48c57 = `Hca4Ha_hoverButton`;
$0627f43e5d4731d7$export$a8eacba2c33c9f28 = `Hca4Ha_hoverButtonsStack`;
$0627f43e5d4731d7$export$dded2af20345efaa = `Hca4Ha_loadingDiv`;
$0627f43e5d4731d7$export$f2ea4ab276c3e3fa = `Hca4Ha_searchBar`;




const $efab9cd647f96e11$export$7d74ee58099cdcee = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const assignToCollectionByFilter = (parameters, filterElements)=>{
        const filters = (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942).queryItems(filterElements);
        if (!filters) return;
        return post("albums/assignToCollectionByFilter", {
            ...parameters,
            ...filters
        });
    };
    return {
        assignToCollectionByFilter: assignToCollectionByFilter
    };
};





var $7fPBF = parcelRequire("7fPBF");

const $aa7448fffa675006$export$e54459f29fd05b24 = (setLoading, isEnabled, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [collections, setCollections] = (0, $7fPBF.useState)();
    (0, $7fPBF.useEffect)(()=>{
        if (!isEnabled) return;
        if (collections && collections.length > 0) return;
        setLoading(true);
        get("collections/standard").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setCollections(body);
            setLoading(false);
        });
    }, dependencies);
    return collections;
};



const $63be976b14539011$export$f48dbd0560ac3be8 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderCollections = (collections)=>{
        const sortedUuids = collections.map((collection)=>collection.uuid);
        return post("collections/reorder", {
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderCollections: reorderCollections
    };
};
















var $7fPBF = parcelRequire("7fPBF");
function $7593599276fe6c36$export$80eb249dd6d36ef2() {
    const [state, setState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const [counter, setCounter] = (0, $7fPBF.useState)(0);
    const instanceId = (0, $7fPBF.useId)();
    const key = `${instanceId}-${counter}`;
    const openAdd = (0, $7fPBF.useCallback)(()=>{
        setCounter((c)=>c + 1);
        setState({
            mode: "add"
        });
    }, []);
    const openEdit = (0, $7fPBF.useCallback)((item)=>{
        setCounter((c)=>c + 1);
        setState({
            mode: "edit",
            item: item
        });
    }, []);
    const close = (0, $7fPBF.useCallback)(()=>{
        setState((prev)=>({
                mode: "closed",
                item: prev.item
            }));
    }, []);
    return {
        state: state,
        key: key,
        openAdd: openAdd,
        openEdit: openEdit,
        close: close
    };
}


const $b46d41cd3bcf7a1c$export$775ce5395441d9c3 = ({ open: open, setOpen: setOpen, isLayout: isLayout, canModifyCollections: canModifyCollections, displayStandardCollections: displayStandardCollections, onCollectionSelected: onCollectionSelected, selectedCollections: selectedCollections, forceLoading: forceLoading, canNegate: canNegate })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const { reorderCollections: reorderCollections } = (0, $63be976b14539011$export$f48dbd0560ac3be8)();
    const { assignToCollectionByFilter: assignToCollectionByFilter } = (0, $efab9cd647f96e11$export$7d74ee58099cdcee)();
    const { getCurrentFilterElements: getCurrentFilterElements, getCurrentIsNegated: getCurrentIsNegated } = (0, $228a7d38c61fd0fd$export$1fa08d0344d4319f)(isLayout);
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)(getCurrentIsNegated());
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [loadingStandardCollections, setLoadingStandardCollections] = (0, $7fPBF.useState)(false);
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAssignAlertOpen, setIsAssignAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const standardCollections = (0, $aa7448fffa675006$export$e54459f29fd05b24)(setLoadingStandardCollections, isMounted.current, [
        open
    ]);
    const [collections, resetCollections] = (0, $6e68763501edef32$export$f936d3bbf9c71f75)(setLoading);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const { deleteCollection: deleteCollection } = (0, $22e1e8bc3e238174$export$1cef512c5f67dab4)();
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [contextCollection, setContextCollection] = (0, $7fPBF.useState)();
    const [shareLinkComponents, fetchShareLink, , isShareLoading] = (0, $bed6df3ee0929f14$export$cc4cb9d785f3b827)(contextCollection?.name);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const onClose = ()=>{
        setOpen(false);
        setSearchText("");
    };
    const onError = (body)=>{
        if (isMounted.current) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const performDeletion = async (collection)=>{
        setLoading(true);
        const { status: status, body: body } = await deleteCollection(collection);
        setLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            resetCollections();
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
        } else onError(body);
    };
    const assignByFilter = async (collection)=>{
        if (!getCurrentFilterElements()) return;
        const request = assignToCollectionByFilter({
            assignToCollectionId: collection.uuid,
            collectionId: currentPrivateCollection?.uuid,
            isNegated: isNegated
        }, getCurrentFilterElements());
        if (!request) return;
        setLoading(true);
        const { status: status, body: body } = await request;
        setLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).collection_assign_filtered_albums_success);
        else setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    const filteredCollections = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return collections;
        return collections?.filter((collection)=>{
            return collection.name.toLowerCase().includes(searchText.toLowerCase()) || collection.description?.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        collections,
        searchText
    ]);
    const searchBar = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            direction: "row",
            alignItems: "center",
            children: [
                canNegate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: ()=>setIsNegated((isNegated)=>({
                                ...isNegated,
                                collectionId: !isNegated.collectionId
                            })),
                    sx: {
                        fontSize: "15px",
                        fontWeight: "normal",
                        padding: 0,
                        borderWidth: 1,
                        borderColor: theme.palette.colors?.border,
                        borderStyle: "solid",
                        borderRadius: "12px",
                        color: isNegated.collectionId ? theme.palette.colors.remove : undefined,
                        height: "40px !important"
                    },
                    children: isNegated.collectionId ? (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_is_not : (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_is
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).searchBar,
                    onSearchRequested: setSearchText,
                    onSearchDismissed: ()=>setSearchText(""),
                    timed: false,
                    minimumSearchLength: 0,
                    autoFocus: !isMobile
                })
            ]
        });
    const skeletons = ()=>Array.from({
            length: 5
        }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).cardContainer,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    height: 124,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).collectionCardSkeleton
                }, index)
            }, `div_${index}`));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: open,
        onClose: onClose,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                style: {
                    minHeight: "unset"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    style: {
                                        marginRight: 8
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    onClick: openAdd,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_collection,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.home()}`,
                                    target: "_blank",
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    loading: loading || isShareLoading || loadingStandardCollections,
                                    onClick: onClose,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                })
                            ]
                        }),
                        searchBar()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).contentCard,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$237bd83162c14364), {
                    onDragEnd: async (result)=>{
                        if (!collections || searchText != "") return;
                        if (!result.destination || result.source.index == result.destination.index) return;
                        (0, $3c32b049e9065866$export$79f3cf326dbd2413)(collections, result.source.index, result.destination.index);
                        setLoading(true);
                        const { status: status } = await reorderCollections(collections);
                        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_error);
                        setLoading(false);
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            padding: isMobile ? 0 : 1,
                            display: "flex",
                            flexDirection: "column",
                            minHeight: 450
                        },
                        children: [
                            displayStandardCollections && !forceLoading && standardCollections?.map((collection)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d77f9b1fcb3b7a4a$export$5b7f4051a57920d0), {
                                    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).collectionCard,
                                    collection: collection,
                                    canMove: false,
                                    selected: selectedCollections.includes(collection.uuid),
                                    onSelection: ()=>{
                                        if (onCollectionSelected) {
                                            onCollectionSelected(collection, isNegated);
                                            onClose();
                                        }
                                    }
                                }, `ci_${collection.uuid}`)),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$423ec2075359570a), {
                                droppableId: "collection",
                                isDropDisabled: loading,
                                children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            position: "relative",
                                            flexGrow: filteredCollections?.length == 0 ? 1 : 0
                                        },
                                        ref: provided.innerRef,
                                        ...provided.droppableProps,
                                        children: [
                                            filteredCollections && !loading && !forceLoading ? filteredCollections.map((collection, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
                                                    draggableId: collection.uuid,
                                                    index: index,
                                                    isDragDisabled: searchText != "",
                                                    children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).cardContainer,
                                                            ref: provided.innerRef,
                                                            ...provided.draggableProps,
                                                            ...provided.dragHandleProps,
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d77f9b1fcb3b7a4a$export$5b7f4051a57920d0), {
                                                                cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).collectionCard,
                                                                collection: collection,
                                                                selected: selectedCollections.includes(collection.uuid),
                                                                canMove: true,
                                                                onContextMenu: (event)=>{
                                                                    setContextCollection(collection);
                                                                    handleContextMenu(event);
                                                                },
                                                                onSelection: ()=>{
                                                                    if (canModifyCollections) openEdit(collection);
                                                                    else if (onCollectionSelected) {
                                                                        onCollectionSelected(collection, isNegated);
                                                                        onClose();
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).hoverButtonsStack,
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                                                                        arrow: true,
                                                                        disableInteractive: true,
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0627f43e5d4731d7$exports))).hoverButton,
                                                                            style: {
                                                                                backgroundColor: theme.palette.colors?.counterBackground
                                                                            },
                                                                            onClick: (event)=>{
                                                                                event.stopPropagation();
                                                                                setContextCollection(collection);
                                                                                handleContextMenu(event);
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }, `ci_${collection.uuid}`)
                                                        }, `div_${collection.uuid}`)
                                                }, collection.uuid)) : skeletons(),
                                            loading && skeletons(),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                                                isLoading: loading || forceLoading,
                                                items: filteredCollections,
                                                emptyIconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS],
                                                emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_collections,
                                                emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_attribute_description,
                                                addButtonTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_collection,
                                                onAddItem: openAdd,
                                                searchText: searchText,
                                                canAdd: true
                                            }),
                                            provided.placeholder
                                        ]
                                    }, "div_droppable")
                            }, "droppable")
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    contextCollection?.visibility == "public" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await fetchShareLink(contextCollection?.uuid, undefined);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Share
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).share_collection
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openEdit(contextCollection);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_modify
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsAssignAlertOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PlaylistAdd
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_assign_filtered_albums
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsDeleteAlertOpen(true);
                        },
                        style: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    style: {
                                        color: theme.palette.colors?.remove
                                    },
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).delete
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb7fbf5bdb01f904$export$244af3c518fd0ae1), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                collection: modifyDialogState.item,
                callback: resetCollections,
                onDelete: ()=>{
                    setIsDeleteAlertOpen(true);
                    setContextCollection(modifyDialogState.item);
                }
            }, modifyDialogKey),
            shareLinkComponents(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).collection_delete_confirmation, contextCollection?.name ?? ""),
                open: isDeleteAlertOpen,
                setOpen: setIsDeleteAlertOpen,
                onConfirm: async ()=>{
                    closeModifyDialog();
                    await performDeletion(contextCollection);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_assign_filtered_albums_confirm,
                open: isAssignAlertOpen,
                setOpen: setIsAssignAlertOpen,
                onConfirm: async ()=>{
                    if (!contextCollection) return;
                    await assignByFilter(contextCollection);
                }
            })
        ]
    });
};













const $4d2d7d1f645fafd0$export$63a7b6644a2527ea = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("discogs/token");
    };
};



const $80d0eef5d5d87b2a$export$f0302bce0203d803 = (setAlertMessage, setIsAlertOpen, setIsLoading, onSuccess)=>{
    const { openInSameTab: openInSameTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const getDiscogsIdentity = (0, $270dcd915b26fa7f$export$47b7eb5b551a2967)();
    const getDiscogsRequestToken = (0, $4d2d7d1f645fafd0$export$63a7b6644a2527ea)();
    const getDiscogsToken = async ()=>{
        const { body: body, status: status } = await getDiscogsRequestToken();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            localStorage.setItem("discogs_temp", body.secret);
            localStorage.setItem("discogs_level", body.authLevel);
            openInSameTab(body.authorizeUrl);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const checkDiscogsAccess = async ()=>{
        const { body: body, status: status } = await getDiscogsIdentity();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setIsLoading(false);
            onSuccess();
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).NOT_FOUND) await getDiscogsToken();
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
            setIsLoading(false);
        }
    };
    return {
        checkDiscogsAccess: checkDiscogsAccess,
        getDiscogsToken: getDiscogsToken
    };
};






parcelRequire("7fPBF");
var $27a486cd0e7b7170$exports = {};

$parcel$export($27a486cd0e7b7170$exports, "cancelButton", function () { return $27a486cd0e7b7170$export$4ededb8e5b56a6fb; }, function (v) { return $27a486cd0e7b7170$export$4ededb8e5b56a6fb = v; });
$parcel$export($27a486cd0e7b7170$exports, "message", function () { return $27a486cd0e7b7170$export$a8ecead220dd38a6; }, function (v) { return $27a486cd0e7b7170$export$a8ecead220dd38a6 = v; });
$parcel$export($27a486cd0e7b7170$exports, "progressBar", function () { return $27a486cd0e7b7170$export$9d1298853f0e77f7; }, function (v) { return $27a486cd0e7b7170$export$9d1298853f0e77f7 = v; });
$parcel$export($27a486cd0e7b7170$exports, "progressBarDiv", function () { return $27a486cd0e7b7170$export$884bb9af2f2b42bd; }, function (v) { return $27a486cd0e7b7170$export$884bb9af2f2b42bd = v; });
$parcel$export($27a486cd0e7b7170$exports, "progressText", function () { return $27a486cd0e7b7170$export$ba222f409b09c174; }, function (v) { return $27a486cd0e7b7170$export$ba222f409b09c174 = v; });
$parcel$export($27a486cd0e7b7170$exports, "subtitle", function () { return $27a486cd0e7b7170$export$c96745152eb2740f; }, function (v) { return $27a486cd0e7b7170$export$c96745152eb2740f = v; });
var $27a486cd0e7b7170$export$4ededb8e5b56a6fb;
var $27a486cd0e7b7170$export$a8ecead220dd38a6;
var $27a486cd0e7b7170$export$9d1298853f0e77f7;
var $27a486cd0e7b7170$export$884bb9af2f2b42bd;
var $27a486cd0e7b7170$export$ba222f409b09c174;
var $27a486cd0e7b7170$export$c96745152eb2740f;
$27a486cd0e7b7170$export$4ededb8e5b56a6fb = `_6kVVIG_cancelButton`;
$27a486cd0e7b7170$export$a8ecead220dd38a6 = `_6kVVIG_message`;
$27a486cd0e7b7170$export$9d1298853f0e77f7 = `_6kVVIG_progressBar`;
$27a486cd0e7b7170$export$884bb9af2f2b42bd = `_6kVVIG_progressBarDiv`;
$27a486cd0e7b7170$export$ba222f409b09c174 = `_6kVVIG_progressText`;
$27a486cd0e7b7170$export$c96745152eb2740f = `_6kVVIG_subtitle`;




const $43605039b0df3dda$export$d19be3e293cd17d2 = ({ task: task, subtitle: subtitle, runningDescription: runningDescription, disclaimer: disclaimer, isLoading: isLoading, onCancel: onCancel })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const progressBarColor = ()=>{
        switch(task?.status){
            case "created":
            case "running":
                return theme.palette.colors.progressRunning;
            case "finished":
                return theme.palette.colors.progressSuccess;
            case "cancelled":
            case "errored":
                return theme.palette.colors.progressError;
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        spacing: 4,
        alignItems: "center",
        display: "flex",
        style: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).subtitle,
                children: subtitle
            }),
            task.status === "running" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).message,
                children: runningDescription
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).message,
                children: disclaimer
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).progressBar,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).progressBarDiv,
                        style: {
                            color: theme.palette.background.default
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
                            color: "inherit",
                            size: 150,
                            variant: "determinate",
                            value: 100
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).progressBarDiv,
                        style: {
                            display: "flex",
                            position: "absolute",
                            color: progressBarColor()
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
                            color: "inherit",
                            size: 150,
                            variant: task.status == "created" ? "indeterminate" : "determinate",
                            value: task.progress * 100 / task.objective
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).progressText,
                        style: {
                            color: theme.palette.primary.main
                        },
                        children: task.status == "created" ? "" : task.progress
                    })
                ]
            }),
            [
                "created",
                "running"
            ].includes(task.status) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a486cd0e7b7170$exports))).cancelButton,
                disabled: isLoading,
                onClick: onCancel,
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).cancel_import
            })
        ]
    });
};



const $6d0bacaf36dedfbb$export$918f7645ec40dd7f = ({ isOpen: isOpen, setIsOpen: setIsOpen, isLayout: isLayout })=>{
    const [state, setState] = (0, $7fPBF.useState)("starting");
    let token = undefined;
    let verifier = undefined;
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [intervalId, setIntervalId] = (0, $7fPBF.useState)();
    const [selectedFolder, setSelectedFolder] = (0, $7fPBF.useState)();
    const [selectedCollection, setSelectedCollection] = (0, $7fPBF.useState)();
    const [username, setUsername] = (0, $7fPBF.useState)("");
    const [folders, setFolders] = (0, $7fPBF.useState)();
    const [task, setTask] = (0, $7fPBF.useState)();
    const [shouldSkipDuplicates, setShouldSkipDuplicates] = (0, $7fPBF.useState)(true);
    const [shouldUploadImage, setShouldUploadImage] = (0, $7fPBF.useState)(false);
    const getDiscogsIdentity = (0, $270dcd915b26fa7f$export$47b7eb5b551a2967)();
    const grantDiscogsAccess = (0, $417a0d905636137f$export$fcb4a8e0d23d040)();
    const getDiscogsFolders = (0, $9005ae2db19e8aed$export$8b0e4b58a2fa65d2)();
    const importDiscogsCollection = (0, $29c0042c0e15ba0b$export$790840efb3f23e76)();
    const getDiscogsImportStatus = (0, $37af56cb7c0ea8a8$export$be749692235121b8)();
    const cancelDiscogsImport = (0, $36980565bfddd274$export$9034aa1fba108aec)();
    const confirmDiscogsImport = (0, $dcbb615582e8205f$export$e255348dfc39e4fb)();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmImportAlertOpen, setIsConfirmImportAlertOpen] = (0, $7fPBF.useState)(false);
    const [isCancelImportAlertOpen, setIsCancelImportAlertOpen] = (0, $7fPBF.useState)(false);
    const { getDiscogsToken: getDiscogsToken } = (0, $80d0eef5d5d87b2a$export$f0302bce0203d803)(setAlertMessage, setIsAlertOpen, setIsLoading, ()=>{});
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const location = (0, $d42da6e692e216cc$export$45d76561a5302f2b)();
    const importSubtitle = ()=>{
        switch(task?.status){
            case "created":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_created;
            case "running":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_subtitle;
            case "finished":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_finished;
            case "cancelled":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_cancelled;
            case "errored":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_errored;
        }
    };
    const getCollectionFolders = async (username)=>{
        setState("folders");
        const { body: body, status: status } = await getDiscogsFolders(username);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setFolders(body);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const startUp = async ()=>{
        if (currentUser?.role == "guest") return;
        setIsLoading(true);
        const { body: body, status: status } = await getDiscogsImportStatus();
        (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("import_discogs_init");
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setTask(body);
            if (body.status != "confirmed") {
                setState("importing");
                setIsLoading(false);
            } else await checkDiscogsAccess();
        } else await checkDiscogsAccess();
    };
    const checkDiscogsAccess = async ()=>{
        const searchParams = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search);
        token = searchParams.oauth_token;
        verifier = searchParams.oauth_verifier;
        const { body: body, status: status } = await getDiscogsIdentity();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setUsername(body.username);
            await getCollectionFolders(body.username);
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).NOT_FOUND) {
            if (token && verifier) await grantAccess(token, verifier);
            else await getDiscogsToken();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
            setIsLoading(false);
        }
    };
    const grantAccess = async (token, verifier)=>{
        const secret = localStorage.getItem("discogs_temp");
        const authLevel = localStorage.getItem("discogs_level");
        if (secret == null || authLevel == null) return;
        localStorage.removeItem("discogs_temp");
        localStorage.removeItem("discogs_level");
        const { body: body, status: status } = await grantDiscogsAccess({
            token: token,
            secret: secret,
            authLevel: +authLevel,
            verifier: verifier
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await checkDiscogsAccess();
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
            setIsLoading(false);
        }
    };
    const getImportStatus = async ()=>{
        const { body: body, status: status } = await getDiscogsImportStatus();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setTask(body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (![
            "running",
            "created"
        ].includes(task?.status)) {
            clearTimer();
            return;
        }
        if (intervalId == undefined) {
            const id = setInterval(async ()=>{
                await getImportStatus();
            }, 2000);
            setIntervalId(Number(id));
        }
    }, [
        task
    ]);
    const clearTimer = ()=>{
        clearInterval(intervalId);
        setIntervalId(undefined);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen) return;
        setState("starting");
        startUp().then();
    }, [
        isOpen
    ]);
    const handleClose = async ()=>{
        if (isLoading) return;
        clearTimer();
        if (state == "importing" && task && ![
            "running",
            "created"
        ].includes(task.status)) {
            setIsLoading(true);
            await confirmDiscogsImport();
            setIsLoading(false);
        }
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).dialog,
        fullWidth: true,
        open: isOpen,
        onClose: handleClose,
        PaperProps: {
            style: {
                minHeight: "320px"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_discogs_import
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromDiscogs()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: isLoading,
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: [
                    state == "folders" && folders && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).subtitle,
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_folders_subtitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).message,
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_folders_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).foldersCard,
                                elevation: 5,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    children: folders.folders.map((folder, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Folder,
                                                    title: folder.name,
                                                    detail: `${folder.count} ${folder.count == 1 ? (0, $37bec70ed65ed924$export$21c51bc433c16634).album_singular : (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural}`,
                                                    disabled: isLoading,
                                                    onClick: ()=>{
                                                        setSelectedFolder(folder);
                                                        setIsCollectionsDialogOpen(true);
                                                    }
                                                }),
                                                index < folders.folders.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                                            ]
                                        }, folder.id))
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).checkbox,
                                sx: {
                                    width: "100%"
                                },
                                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                    checked: shouldSkipDuplicates,
                                    onChange: ()=>setShouldSkipDuplicates((state)=>!state)
                                }),
                                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_skip_duplicates
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).checkboxHelpText,
                                            style: {
                                                color: theme.palette.primary.subtitle
                                            },
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_skip_duplicates_help
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).checkbox,
                                sx: {
                                    width: "100%"
                                },
                                disabled: currentUser?.role != (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium,
                                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                    checked: shouldUploadImage,
                                    onChange: ()=>setShouldUploadImage((state)=>!state)
                                }),
                                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a4661cf4ef54e09$exports))).checkboxHelpText,
                                            style: {
                                                color: theme.palette.primary.subtitle
                                            },
                                            children: currentUser?.role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium ? (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image_help : (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image_non_premium
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    state == "importing" && task && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43605039b0df3dda$export$d19be3e293cd17d2), {
                        task: task,
                        subtitle: importSubtitle(),
                        runningDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_description,
                        disclaimer: [
                            "created",
                            "running"
                        ].includes(task.status) ? (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_disclaimer : (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_disclaimer_finished,
                        isLoading: isLoading,
                        onCancel: async ()=>{
                            setIsLoading(true);
                            const { body: body, status: status } = await cancelDiscogsImport();
                            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setTask(body);
                            else {
                                setAlertMessage(body.message);
                                setIsAlertOpen(true);
                            }
                            setIsLoading(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: isLayout,
                canModifyCollections: false,
                displayStandardCollections: true,
                onCollectionSelected: (collection)=>{
                    setSelectedCollection(collection);
                    setIsConfirmImportAlertOpen(true);
                },
                selectedCollections: [],
                forceLoading: false,
                canNegate: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_folders_confirmation, String(selectedFolder?.count), selectedFolder?.name ?? "", selectedCollection?.name ?? ""),
                open: isConfirmImportAlertOpen,
                setOpen: setIsConfirmImportAlertOpen,
                isConfirm: true,
                onConfirm: async ()=>{
                    setIsCollectionsDialogOpen(false);
                    setIsLoading(true);
                    const { body: body, status: status } = await importDiscogsCollection({
                        username: username,
                        folderId: selectedFolder?.id ?? 0,
                        collections: selectedCollection ? [
                            selectedCollection
                        ] : [],
                        shouldUploadImage: shouldUploadImage,
                        shouldSkipDuplicates: shouldSkipDuplicates
                    });
                    if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                        setTask(body);
                        setState("importing");
                    } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                        setAlertMessage(body.message);
                        setIsPurchaseAlertOpen(true);
                    } else {
                        setAlertMessage(body.message);
                        setIsAlertOpen(true);
                    }
                    setIsLoading(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_cancel_confirmation,
                open: isCancelImportAlertOpen,
                setOpen: setIsCancelImportAlertOpen,
                isConfirm: true,
                onConfirm: async ()=>{
                    setIsLoading(true);
                    const { body: body, status: status } = await cancelDiscogsImport();
                    if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setTask(body);
                    else {
                        setAlertMessage(body.message);
                        setIsAlertOpen(true);
                    }
                    setIsLoading(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};



var $714f9a721b631531$exports = {};

$parcel$export($714f9a721b631531$exports, "avatar", function () { return $714f9a721b631531$export$345c5736c8054f22; }, function (v) { return $714f9a721b631531$export$345c5736c8054f22 = v; });
$parcel$export($714f9a721b631531$exports, "betaTag", function () { return $714f9a721b631531$export$807066f14bb99cd3; }, function (v) { return $714f9a721b631531$export$807066f14bb99cd3 = v; });
$parcel$export($714f9a721b631531$exports, "itemTitle", function () { return $714f9a721b631531$export$19d20253129869a; }, function (v) { return $714f9a721b631531$export$19d20253129869a = v; });
$parcel$export($714f9a721b631531$exports, "list", function () { return $714f9a721b631531$export$8837f4fc672e936d; }, function (v) { return $714f9a721b631531$export$8837f4fc672e936d = v; });
$parcel$export($714f9a721b631531$exports, "listItem", function () { return $714f9a721b631531$export$76c7e83ecc9cdf05; }, function (v) { return $714f9a721b631531$export$76c7e83ecc9cdf05 = v; });
$parcel$export($714f9a721b631531$exports, "sectionCard", function () { return $714f9a721b631531$export$43491ff49b5e45cc; }, function (v) { return $714f9a721b631531$export$43491ff49b5e45cc = v; });
$parcel$export($714f9a721b631531$exports, "usernameTitle", function () { return $714f9a721b631531$export$af293c3c178c7697; }, function (v) { return $714f9a721b631531$export$af293c3c178c7697 = v; });
var $714f9a721b631531$export$345c5736c8054f22;
var $714f9a721b631531$export$807066f14bb99cd3;
var $714f9a721b631531$export$19d20253129869a;
var $714f9a721b631531$export$8837f4fc672e936d;
var $714f9a721b631531$export$76c7e83ecc9cdf05;
var $714f9a721b631531$export$43491ff49b5e45cc;
var $714f9a721b631531$export$af293c3c178c7697;
$714f9a721b631531$export$345c5736c8054f22 = `Txj9TG_avatar`;
$714f9a721b631531$export$807066f14bb99cd3 = `Txj9TG_betaTag`;
$714f9a721b631531$export$19d20253129869a = `Txj9TG_itemTitle`;
$714f9a721b631531$export$8837f4fc672e936d = `Txj9TG_list`;
$714f9a721b631531$export$76c7e83ecc9cdf05 = `Txj9TG_listItem`;
$714f9a721b631531$export$43491ff49b5e45cc = `Txj9TG_sectionCard`;
$714f9a721b631531$export$af293c3c178c7697 = `Txj9TG_usernameTitle`;




var $7fPBF = parcelRequire("7fPBF");




var $663f25ea26c699cf$exports = {};

$parcel$export($663f25ea26c699cf$exports, "avatar", function () { return $663f25ea26c699cf$export$345c5736c8054f22; }, function (v) { return $663f25ea26c699cf$export$345c5736c8054f22 = v; });
$parcel$export($663f25ea26c699cf$exports, "loadingIndicator", function () { return $663f25ea26c699cf$export$f10e6b4aaa94c253; }, function (v) { return $663f25ea26c699cf$export$f10e6b4aaa94c253 = v; });
var $663f25ea26c699cf$export$345c5736c8054f22;
var $663f25ea26c699cf$export$f10e6b4aaa94c253;
$663f25ea26c699cf$export$345c5736c8054f22 = `DlArWW_avatar`;
$663f25ea26c699cf$export$f10e6b4aaa94c253 = `DlArWW_loadingIndicator`;






var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");


'use client';
var $eb97585ed36aff99$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');




function $d660f45ac865db82$export$ffd560f22c0ecf04(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiAvatar', slot);
}
const $d660f45ac865db82$var$avatarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $d660f45ac865db82$export$2e2bcd8739ae039 = $d660f45ac865db82$var$avatarClasses;



'use client';
const $772e96a1af9615ac$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $772e96a1af9615ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d660f45ac865db82$export$ffd560f22c0ecf04), classes);
};
const $772e96a1af9615ac$var$AvatarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $772e96a1af9615ac$var$AvatarImg = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $772e96a1af9615ac$var$AvatarFallback = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $eb97585ed36aff99$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $772e96a1af9615ac$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $772e96a1af9615ac$var$Avatar = /*#__PURE__*/ $7fPBF.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $772e96a1af9615ac$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $772e96a1af9615ac$var$useLoaded((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $772e96a1af9615ac$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($772e96a1af9615ac$var$AvatarImg, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null && childrenProp !== '' && typeof childrenProp !== 'boolean') children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($772e96a1af9615ac$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($772e96a1af9615ac$var$AvatarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $772e96a1af9615ac$export$2e2bcd8739ae039 = $772e96a1af9615ac$var$Avatar;



const $79d5f228961267fd$export$6c0524ba53950d9f = ({ className: className, style: style, userProfile: userProfile, onClick: onClick })=>{
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const placeholderAvatar = new URL($f3dc95464e643b42$exports).href;
    const fetchImage = async ()=>{
        if (!isMounted.current) return;
        setImage(undefined);
        if (!userProfile || !userProfile.hasImage) return;
        const response = await getImage({
            name: userProfile.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) {
            if (!isMounted.current) return;
            setImage(response.body);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchImage().then();
    }, [
        userProfile
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: userProfile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $772e96a1af9615ac$export$2e2bcd8739ae039), {
            className: className,
            style: style,
            sx: {
                borderColor: theme.palette.primary.main,
                borderStyle: "solid"
            },
            onClick: onClick,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($663f25ea26c699cf$exports))).avatar,
                defaultImage: placeholderAvatar,
                thumbnail: userProfile.thumbnail,
                image: image,
                alt: "Avatar"
            })
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
            variant: "circular",
            className: className
        })
    });
};







var $7fPBF = parcelRequire("7fPBF");

var $a221347a71a87eae$exports = {};

$parcel$export($a221347a71a87eae$exports, "confirmButton", function () { return $a221347a71a87eae$export$7104031a6d2eee61; }, function (v) { return $a221347a71a87eae$export$7104031a6d2eee61 = v; });
$parcel$export($a221347a71a87eae$exports, "content", function () { return $a221347a71a87eae$export$a7db06668cad9adb; }, function (v) { return $a221347a71a87eae$export$a7db06668cad9adb = v; });
$parcel$export($a221347a71a87eae$exports, "dropzonePlaceholder", function () { return $a221347a71a87eae$export$f862937b8c0a43fe; }, function (v) { return $a221347a71a87eae$export$f862937b8c0a43fe = v; });
$parcel$export($a221347a71a87eae$exports, "message", function () { return $a221347a71a87eae$export$a8ecead220dd38a6; }, function (v) { return $a221347a71a87eae$export$a8ecead220dd38a6 = v; });
$parcel$export($a221347a71a87eae$exports, "templateButton", function () { return $a221347a71a87eae$export$539825656abb49f8; }, function (v) { return $a221347a71a87eae$export$539825656abb49f8 = v; });
var $a221347a71a87eae$export$7104031a6d2eee61;
var $a221347a71a87eae$export$a7db06668cad9adb;
var $a221347a71a87eae$export$f862937b8c0a43fe;
var $a221347a71a87eae$export$a8ecead220dd38a6;
var $a221347a71a87eae$export$539825656abb49f8;
$a221347a71a87eae$export$7104031a6d2eee61 = `Qe-iJW_confirmButton`;
$a221347a71a87eae$export$a7db06668cad9adb = `Qe-iJW_content`;
$a221347a71a87eae$export$f862937b8c0a43fe = `Qe-iJW_dropzonePlaceholder`;
$a221347a71a87eae$export$a8ecead220dd38a6 = `Qe-iJW_message`;
$a221347a71a87eae$export$539825656abb49f8 = `Qe-iJW_templateButton`;







const $5819c786b6f7bdd8$export$a20bcb60fa722848 = ()=>{
    const { upload: upload } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const importFromSpreadsheet = async (file, collections, userId)=>{
        const collectionsJson = JSON.stringify(collections);
        return upload("xlsx", `${userId}.xlsx`, file, "collections", collectionsJson);
    };
    return {
        importFromSpreadsheet: importFromSpreadsheet
    };
};















const $f69598dd6f9f3af8$export$794a5189271cb395 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("xlsx/import");
    };
};



const $03f6562ba6dd817e$export$173f2b3a24849dbf = ()=>{
    const { patch: patch } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await patch("xlsx/import");
    };
};



const $72b88e164e321ef7$export$169a8f71ca36e57e = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await deleteRequest("xlsx/import");
    };
};



const $4268e83a5286c690$export$7a06ad3068417c15 = ({ isOpen: isOpen, setIsOpen: setIsOpen, isLayout: isLayout })=>{
    const [state, setState] = (0, $7fPBF.useState)("starting");
    const [file, setFile] = (0, $7fPBF.useState)();
    const { importFromSpreadsheet: importFromSpreadsheet } = (0, $5819c786b6f7bdd8$export$a20bcb60fa722848)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [selectedCollection, setSelectedCollection] = (0, $7fPBF.useState)();
    const [isConfirmImportAlertOpen, setIsConfirmImportAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const getSpreadsheetImportStatus = (0, $f69598dd6f9f3af8$export$794a5189271cb395)();
    const confirmSpreadsheetImport = (0, $03f6562ba6dd817e$export$173f2b3a24849dbf)();
    const cancelSpreadsheetImport = (0, $72b88e164e321ef7$export$169a8f71ca36e57e)();
    const [task, setTask] = (0, $7fPBF.useState)();
    const [intervalId, setIntervalId] = (0, $7fPBF.useState)();
    const startUp = async ()=>{
        setIsLoading(true);
        const { body: body, status: status } = await getSpreadsheetImportStatus();
        (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("import_spreadsheet_init");
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setTask(body);
            if (body.status != "confirmed") setState("importing");
            else setState("uploading");
        } else setState("uploading");
        setIsLoading(false);
    };
    const getImportStatus = async ()=>{
        const { body: body, status: status } = await getSpreadsheetImportStatus();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setTask(body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (![
            "running",
            "created"
        ].includes(task?.status)) {
            clearTimer();
            return;
        }
        if (intervalId == undefined) {
            const id = setInterval(async ()=>{
                await getImportStatus();
            }, 2000);
            setIntervalId(Number(id));
        }
    }, [
        task
    ]);
    const clearTimer = ()=>{
        clearInterval(intervalId);
        setIntervalId(undefined);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen) return;
        setState("starting");
        setFile(undefined);
        startUp().then();
    }, [
        isOpen
    ]);
    const handleClose = async ()=>{
        if (isLoading) return;
        clearTimer();
        if (state == "importing" && task && ![
            "running",
            "created"
        ].includes(task.status)) {
            setIsLoading(true);
            await confirmSpreadsheetImport();
            setIsLoading(false);
        }
        setIsOpen(false);
    };
    const baseStyle = {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 20px 80px 20px",
        borderWidth: 2,
        borderRadius: 2,
        borderColor: "#eeeeee",
        borderStyle: "dashed",
        color: "#bdbdbd",
        outline: "none",
        transition: "border .24s ease-in-out"
    };
    const focusedStyle = {
        borderColor: "#2196f3"
    };
    const acceptStyle = {
        borderColor: "#00e676"
    };
    const rejectStyle = {
        borderColor: "#ff1744"
    };
    const importSubtitle = ()=>{
        switch(task?.status){
            case "created":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_created;
            case "running":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_subtitle;
            case "finished":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_finished;
            case "cancelled":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_cancelled;
            case "errored":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_errored;
        }
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps, isFocused: isFocused, isDragAccept: isDragAccept, isDragReject: isDragReject } = (0, $c08bbb67d1713114$export$cd49c0ecc5be9f36)({
        accept: {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": []
        },
        maxFiles: 1,
        onDrop: (acceptedFiles, filesRejection)=>{
            if (filesRejection.length > 0) {
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).upload_multiple_files_error);
                return;
            }
            const file = Object.assign(acceptedFiles[0], {
                preview: URL.createObjectURL(acceptedFiles[0])
            });
            setFile(file);
        }
    });
    const style = (0, $7fPBF.useMemo)(()=>({
            ...baseStyle,
            ...isFocused ? focusedStyle : {},
            ...isDragAccept ? acceptStyle : {},
            ...isDragReject ? rejectStyle : {}
        }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);
    const uploadFile = async ()=>{
        setIsCollectionsDialogOpen(false);
        setIsLoading(true);
        if (!file) return;
        const { status: status, body: body } = await importFromSpreadsheet(file, selectedCollection ? [
            selectedCollection
        ] : [], currentUser.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setTask(body);
            setState("importing");
        } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
            setAlertMessage(body.message);
            setIsPurchaseAlertOpen(true);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: handleClose,
        PaperProps: {
            style: {
                minHeight: "320px"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromExcel()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                        loading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a221347a71a87eae$exports))).content,
                children: state === "uploading" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a221347a71a87eae$exports))).message,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_message
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a221347a71a87eae$exports))).templateButton,
                            href: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_template_url,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_download_template
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                            ...getRootProps({
                                style: style
                            }),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    ...getInputProps()
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a221347a71a87eae$exports))).dropzonePlaceholder,
                                    children: file ? file.name : (0, $37bec70ed65ed924$export$21c51bc433c16634).dropzone_placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a221347a71a87eae$exports))).confirmButton,
                            disabled: file === undefined || isLoading,
                            onClick: ()=>setIsCollectionsDialogOpen(true),
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    ]
                }) : state === "importing" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43605039b0df3dda$export$d19be3e293cd17d2), {
                    task: task,
                    subtitle: importSubtitle(),
                    runningDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_description,
                    disclaimer: [
                        "created",
                        "running"
                    ].includes(task.status) ? (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_disclaimer : (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_import_disclaimer_finished,
                    isLoading: isLoading,
                    onCancel: async ()=>{
                        setIsLoading(true);
                        const { body: body, status: status } = await cancelSpreadsheetImport();
                        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setTask(body);
                        else {
                            setAlertMessage(body.message);
                            setIsAlertOpen(true);
                        }
                        setIsLoading(false);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: isLayout,
                canModifyCollections: false,
                displayStandardCollections: true,
                onCollectionSelected: (collection)=>{
                    setSelectedCollection(collection);
                    setIsConfirmImportAlertOpen(true);
                },
                selectedCollections: [],
                forceLoading: false,
                canNegate: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_confirmation, file?.name ?? "", selectedCollection?.name ?? ""),
                open: isConfirmImportAlertOpen,
                setOpen: setIsConfirmImportAlertOpen,
                isConfirm: true,
                onConfirm: async ()=>uploadFile()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};









const $d5cc58bd0a3c6b57$export$b04af7126011511f = ({ currentPage: currentPage, isOpen: isOpen, setIsOpen: setIsOpen, isLayout: isLayout, isOpenDiscogsImport: isOpenDiscogsImport, setIsOpenDiscogsImport: setIsOpenDiscogsImport, isOpenExcelImport: isOpenExcelImport, setIsOpenExcelImport: setIsOpenExcelImport, onFilterAlbumsClicked: onFilterAlbumsClicked, onRandomAlbumsClicked: onRandomAlbumsClicked, onNewAlbumClicked: onNewAlbumClicked, onNewBoxSetClicked: onNewBoxSetClicked, onBarcodeScanClicked: onBarcodeScanClicked })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const [isOpenManageCollectionsDialog, setIsOpenManageCollectionsDialog] = (0, $7fPBF.useState)(false);
    const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isReorderAlertOpen, setIsReorderAlertOpen] = (0, $7fPBF.useState)(false);
    const [isStatsGuestAlertOpen, setIsStatsGuestAlertOpen] = (0, $7fPBF.useState)(false);
    const list = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                width: 310,
                height: "100%",
                overflow: "auto",
                backgroundColor: theme.palette.colors?.drawerBackgroundColor
            },
            role: "presentation",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).list,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile(),
                                disabled: currentUser === undefined || currentUserProfile === undefined || currentUser?.role == "guest",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: currentPage == "profile",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98facea847274680$export$2e2bcd8739ae039), {
                                            style: {
                                                minWidth: "48px"
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039), {
                                                overlap: "circular",
                                                badgeContent: currentUserProfile?.unreadNotifications,
                                                color: "error",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).avatar,
                                                    userProfile: currentUserProfile
                                                })
                                            })
                                        }),
                                        currentUserProfile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).usernameTitle,
                                            primary: currentUser?.role != "guest" ? currentUserProfile.username : (0, $37bec70ed65ed924$export$21c51bc433c16634).guest_title
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            width: "100%",
                                            height: 20
                                        })
                                    ]
                                }, "User")
                            }),
                            currentUser?.role == "guest" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            currentUser?.role == "guest" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    closeSession();
                                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PersonAdd
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).login_create_user_or_login
                                    })
                                ]
                            }, "NewUser")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: currentPage == "albums",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CardsStar
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_title
                                        })
                                    ]
                                }, "Albums")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).layout(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: currentPage == "layout",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).layout_title
                                        })
                                    ]
                                }, "Layout")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    setIsOpenManageCollectionsDialog(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_manage_title
                                    })
                                ]
                            }, "Collections"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).attributes.manage(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: currentPage == "attributes",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Assignment
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_attributes
                                        })
                                    ]
                                }, "Attributes")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: currentUser?.role == "guest" ? undefined : (0, $5ac8335867650de3$export$12d836cf94aabb97).stats(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: currentPage == "stats",
                                    onClick: ()=>{
                                        if (currentUser?.role == "guest") setIsStatsGuestAlertOpen(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AreaChart
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats
                                        })
                                    ]
                                }, "Stats")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).marketplace(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    selected: [
                                        "marketplace",
                                        "publicAlbums"
                                    ].includes(currentPage),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Public
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_marketplace
                                        })
                                    ]
                                }, "Marketplace")
                            })
                        ]
                    }),
                    currentPage == "albums" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>onNewAlbumClicked(),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddAd
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).ca_title
                                        })
                                    ]
                                }, "NewAlbum"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>{
                                        if (onBarcodeScanClicked) onBarcodeScanClicked();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2Add
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_scan_barcode
                                        })
                                    ]
                                }, "BarcodeScan"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>onNewBoxSetClicked(),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).BoxAdd
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).new_box_set_title
                                        })
                                    ]
                                }, "NewBoxSet"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>setIsReorderAlertOpen(true),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FormatListNumbered
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_reorder_albums
                                        })
                                    ]
                                }, "Reorder"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>{
                                        if (onFilterAlbumsClicked) onFilterAlbumsClicked();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAlt
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_filter_albums
                                        })
                                    ]
                                }, "Filter"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    onClick: ()=>{
                                        if (onRandomAlbumsClicked) onRandomAlbumsClicked();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Die
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_random_albums
                                        })
                                    ]
                                }, "Random")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    setIsOpenDiscogsImport(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_discogs_import
                                    })
                                ]
                            }, "DiscogsImport"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    setIsOpenExcelImport(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FormsAddOn
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_excel_import
                                    })
                                ]
                            }, "ExcelImport")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    setIsPreferencesDialogOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Settings
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_preferences
                                    })
                                ]
                            }, "Preferences"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f5f220fbae066de$export$208c5536a0cffe90), {
                                to: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home(),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Book2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).documentation
                                        })
                                    ]
                                }, "Documentation")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                                onClick: ()=>{
                                    closeSession();
                                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Logout
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                        primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_close_session
                                    })
                                ]
                            }, "CloseSession")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e09141a590dfb9a7$export$590eb9e8e9b3ae5e), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $960198875259ceb3$export$6ff27d755f78f4a0), {}),
                    currentUser?.role == "admin" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).sectionCard,
                        style: {
                            marginTop: 200
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).listItem,
                            onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).admin()),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Hardware
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                    disableTypography: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($714f9a721b631531$exports))).itemTitle,
                                    primary: "Admin console"
                                })
                            ]
                        }, "admin")
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a2822b215697a959$export$2e2bcd8739ae039), {
                anchor: "left",
                open: isOpen,
                onOpen: ()=>setIsOpen(true),
                onClose: ()=>setIsOpen(false),
                variant: isScreenWide ? "persistent" : "temporary",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dde9f7568b19476$export$bb68d554ded258ea), {
                        setIsOpen: setIsOpen
                    }),
                    list()
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isOpenManageCollectionsDialog,
                setOpen: setIsOpenManageCollectionsDialog,
                isLayout: isLayout,
                canModifyCollections: true,
                displayStandardCollections: false,
                selectedCollections: [],
                forceLoading: false,
                canNegate: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6558c6f63077fa19$export$7125afe2279fb9f3), {
                isOpen: isPreferencesDialogOpen,
                setIsOpen: setIsPreferencesDialogOpen,
                canRemoveAccount: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6d0bacaf36dedfbb$export$918f7645ec40dd7f), {
                isOpen: isOpenDiscogsImport,
                setIsOpen: setIsOpenDiscogsImport,
                isLayout: isLayout
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4268e83a5286c690$export$7a06ad3068417c15), {
                isOpen: isOpenExcelImport,
                setIsOpen: setIsOpenExcelImport,
                isLayout: isLayout
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).reorder_tutorial,
                open: isReorderAlertOpen,
                setOpen: setIsReorderAlertOpen,
                helpLink: `${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.orderAlbums()}`,
                hasCloseButton: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_guest_error,
                open: isStatsGuestAlertOpen,
                setOpen: setIsStatsGuestAlertOpen,
                hasCloseButton: true
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $4e96c325254013e2$exports = {};

$parcel$export($4e96c325254013e2$exports, "albumId", function () { return $4e96c325254013e2$export$c8135f4cccd4dfde; }, function (v) { return $4e96c325254013e2$export$c8135f4cccd4dfde = v; });
$parcel$export($4e96c325254013e2$exports, "albumImage", function () { return $4e96c325254013e2$export$24acac6e69ce1287; }, function (v) { return $4e96c325254013e2$export$24acac6e69ce1287 = v; });
$parcel$export($4e96c325254013e2$exports, "albumImageCard", function () { return $4e96c325254013e2$export$e2235045d308946e; }, function (v) { return $4e96c325254013e2$export$e2235045d308946e = v; });
$parcel$export($4e96c325254013e2$exports, "cardDiv", function () { return $4e96c325254013e2$export$5b6b191f3c2fe4d2; }, function (v) { return $4e96c325254013e2$export$5b6b191f3c2fe4d2 = v; });
$parcel$export($4e96c325254013e2$exports, "firstItemCard", function () { return $4e96c325254013e2$export$f02f6ed487d8e098; }, function (v) { return $4e96c325254013e2$export$f02f6ed487d8e098 = v; });
$parcel$export($4e96c325254013e2$exports, "firstItemCardMobile", function () { return $4e96c325254013e2$export$4de7eb44b55ba314; }, function (v) { return $4e96c325254013e2$export$4de7eb44b55ba314 = v; });
$parcel$export($4e96c325254013e2$exports, "hoverButton", function () { return $4e96c325254013e2$export$b0260c0afbf48c57; }, function (v) { return $4e96c325254013e2$export$b0260c0afbf48c57 = v; });
$parcel$export($4e96c325254013e2$exports, "hoverButtonsStack", function () { return $4e96c325254013e2$export$a8eacba2c33c9f28; }, function (v) { return $4e96c325254013e2$export$a8eacba2c33c9f28 = v; });
$parcel$export($4e96c325254013e2$exports, "itemCard", function () { return $4e96c325254013e2$export$e0be3821d621a3a0; }, function (v) { return $4e96c325254013e2$export$e0be3821d621a3a0 = v; });
$parcel$export($4e96c325254013e2$exports, "itemCardMobile", function () { return $4e96c325254013e2$export$20450404b102fd6c; }, function (v) { return $4e96c325254013e2$export$20450404b102fd6c = v; });
$parcel$export($4e96c325254013e2$exports, "lastItemCard", function () { return $4e96c325254013e2$export$90787174b10be177; }, function (v) { return $4e96c325254013e2$export$90787174b10be177 = v; });
$parcel$export($4e96c325254013e2$exports, "lastItemCardMobile", function () { return $4e96c325254013e2$export$9653a5825aa1c526; }, function (v) { return $4e96c325254013e2$export$9653a5825aa1c526 = v; });
$parcel$export($4e96c325254013e2$exports, "list", function () { return $4e96c325254013e2$export$8837f4fc672e936d; }, function (v) { return $4e96c325254013e2$export$8837f4fc672e936d = v; });
$parcel$export($4e96c325254013e2$exports, "loadingStack", function () { return $4e96c325254013e2$export$5b8225885d80bccc; }, function (v) { return $4e96c325254013e2$export$5b8225885d80bccc = v; });
$parcel$export($4e96c325254013e2$exports, "mainContainer", function () { return $4e96c325254013e2$export$eccb60d5692f3f7d; }, function (v) { return $4e96c325254013e2$export$eccb60d5692f3f7d = v; });
$parcel$export($4e96c325254013e2$exports, "mainDiv", function () { return $4e96c325254013e2$export$16666caf1c4e1af1; }, function (v) { return $4e96c325254013e2$export$16666caf1c4e1af1 = v; });
$parcel$export($4e96c325254013e2$exports, "mobileList", function () { return $4e96c325254013e2$export$c156ee45eac38817; }, function (v) { return $4e96c325254013e2$export$c156ee45eac38817 = v; });
$parcel$export($4e96c325254013e2$exports, "noSelectionDiv", function () { return $4e96c325254013e2$export$47d0c9314a8d5020; }, function (v) { return $4e96c325254013e2$export$47d0c9314a8d5020 = v; });
$parcel$export($4e96c325254013e2$exports, "progressBar", function () { return $4e96c325254013e2$export$9d1298853f0e77f7; }, function (v) { return $4e96c325254013e2$export$9d1298853f0e77f7 = v; });
$parcel$export($4e96c325254013e2$exports, "publicCollectionCard", function () { return $4e96c325254013e2$export$168186cf222f73b5; }, function (v) { return $4e96c325254013e2$export$168186cf222f73b5 = v; });
$parcel$export($4e96c325254013e2$exports, "publicCollectionDescription", function () { return $4e96c325254013e2$export$f590cc4c158994c9; }, function (v) { return $4e96c325254013e2$export$f590cc4c158994c9 = v; });
$parcel$export($4e96c325254013e2$exports, "publicCollectionName", function () { return $4e96c325254013e2$export$6badaf7ab703768c; }, function (v) { return $4e96c325254013e2$export$6badaf7ab703768c = v; });
$parcel$export($4e96c325254013e2$exports, "reservedBox", function () { return $4e96c325254013e2$export$da357abc86b0c05e; }, function (v) { return $4e96c325254013e2$export$da357abc86b0c05e = v; });
$parcel$export($4e96c325254013e2$exports, "reservedText", function () { return $4e96c325254013e2$export$c94b5db9c187c61a; }, function (v) { return $4e96c325254013e2$export$c94b5db9c187c61a = v; });
$parcel$export($4e96c325254013e2$exports, "shortcutsGrid", function () { return $4e96c325254013e2$export$c0d082e4d02b6893; }, function (v) { return $4e96c325254013e2$export$c0d082e4d02b6893 = v; });
$parcel$export($4e96c325254013e2$exports, "shortcutsTitle", function () { return $4e96c325254013e2$export$a181c7b826173297; }, function (v) { return $4e96c325254013e2$export$a181c7b826173297 = v; });
$parcel$export($4e96c325254013e2$exports, "trackList", function () { return $4e96c325254013e2$export$e8648cd67fc3e661; }, function (v) { return $4e96c325254013e2$export$e8648cd67fc3e661 = v; });
$parcel$export($4e96c325254013e2$exports, "trackListMobile", function () { return $4e96c325254013e2$export$398e454deed1b59e; }, function (v) { return $4e96c325254013e2$export$398e454deed1b59e = v; });
$parcel$export($4e96c325254013e2$exports, "tracksHeader", function () { return $4e96c325254013e2$export$b65acf8fea7589a3; }, function (v) { return $4e96c325254013e2$export$b65acf8fea7589a3 = v; });
var $4e96c325254013e2$export$c8135f4cccd4dfde;
var $4e96c325254013e2$export$24acac6e69ce1287;
var $4e96c325254013e2$export$e2235045d308946e;
var $4e96c325254013e2$export$5b6b191f3c2fe4d2;
var $4e96c325254013e2$export$f02f6ed487d8e098;
var $4e96c325254013e2$export$4de7eb44b55ba314;
var $4e96c325254013e2$export$b0260c0afbf48c57;
var $4e96c325254013e2$export$a8eacba2c33c9f28;
var $4e96c325254013e2$export$e0be3821d621a3a0;
var $4e96c325254013e2$export$20450404b102fd6c;
var $4e96c325254013e2$export$90787174b10be177;
var $4e96c325254013e2$export$9653a5825aa1c526;
var $4e96c325254013e2$export$8837f4fc672e936d;
var $4e96c325254013e2$export$5b8225885d80bccc;
var $4e96c325254013e2$export$eccb60d5692f3f7d;
var $4e96c325254013e2$export$16666caf1c4e1af1;
var $4e96c325254013e2$export$c156ee45eac38817;
var $4e96c325254013e2$export$47d0c9314a8d5020;
var $4e96c325254013e2$export$9d1298853f0e77f7;
var $4e96c325254013e2$export$168186cf222f73b5;
var $4e96c325254013e2$export$f590cc4c158994c9;
var $4e96c325254013e2$export$6badaf7ab703768c;
var $4e96c325254013e2$export$da357abc86b0c05e;
var $4e96c325254013e2$export$c94b5db9c187c61a;
var $4e96c325254013e2$export$c0d082e4d02b6893;
var $4e96c325254013e2$export$a181c7b826173297;
var $4e96c325254013e2$export$e8648cd67fc3e661;
var $4e96c325254013e2$export$398e454deed1b59e;
var $4e96c325254013e2$export$b65acf8fea7589a3;
$4e96c325254013e2$export$c8135f4cccd4dfde = `-NLmsG_albumId`;
$4e96c325254013e2$export$24acac6e69ce1287 = `-NLmsG_albumImage`;
$4e96c325254013e2$export$e2235045d308946e = `-NLmsG_albumImageCard`;
$4e96c325254013e2$export$5b6b191f3c2fe4d2 = `-NLmsG_cardDiv`;
$4e96c325254013e2$export$f02f6ed487d8e098 = `-NLmsG_firstItemCard`;
$4e96c325254013e2$export$4de7eb44b55ba314 = `-NLmsG_firstItemCardMobile`;
$4e96c325254013e2$export$b0260c0afbf48c57 = `-NLmsG_hoverButton`;
$4e96c325254013e2$export$a8eacba2c33c9f28 = `-NLmsG_hoverButtonsStack`;
$4e96c325254013e2$export$e0be3821d621a3a0 = `-NLmsG_itemCard`;
$4e96c325254013e2$export$20450404b102fd6c = `-NLmsG_itemCardMobile`;
$4e96c325254013e2$export$90787174b10be177 = `-NLmsG_lastItemCard`;
$4e96c325254013e2$export$9653a5825aa1c526 = `-NLmsG_lastItemCardMobile`;
$4e96c325254013e2$export$8837f4fc672e936d = `-NLmsG_list`;
$4e96c325254013e2$export$5b8225885d80bccc = `-NLmsG_loadingStack`;
$4e96c325254013e2$export$eccb60d5692f3f7d = `-NLmsG_mainContainer`;
$4e96c325254013e2$export$16666caf1c4e1af1 = `-NLmsG_mainDiv`;
$4e96c325254013e2$export$c156ee45eac38817 = `-NLmsG_mobileList`;
$4e96c325254013e2$export$47d0c9314a8d5020 = `-NLmsG_noSelectionDiv`;
$4e96c325254013e2$export$9d1298853f0e77f7 = `-NLmsG_progressBar`;
$4e96c325254013e2$export$168186cf222f73b5 = `-NLmsG_publicCollectionCard`;
$4e96c325254013e2$export$f590cc4c158994c9 = `-NLmsG_publicCollectionDescription`;
$4e96c325254013e2$export$6badaf7ab703768c = `-NLmsG_publicCollectionName`;
$4e96c325254013e2$export$da357abc86b0c05e = `-NLmsG_reservedBox`;
$4e96c325254013e2$export$c94b5db9c187c61a = `-NLmsG_reservedText`;
$4e96c325254013e2$export$c0d082e4d02b6893 = `-NLmsG_shortcutsGrid`;
$4e96c325254013e2$export$a181c7b826173297 = `-NLmsG_shortcutsTitle`;
$4e96c325254013e2$export$e8648cd67fc3e661 = `-NLmsG_trackList`;
$4e96c325254013e2$export$398e454deed1b59e = `-NLmsG_trackListMobile`;
$4e96c325254013e2$export$b65acf8fea7589a3 = `-NLmsG_tracksHeader`;







var $7fPBF = parcelRequire("7fPBF");
var $1775968c0d4755f4$exports = {};

$parcel$export($1775968c0d4755f4$exports, "albumName", function () { return $1775968c0d4755f4$export$85c78588146f12bc; }, function (v) { return $1775968c0d4755f4$export$85c78588146f12bc = v; });
$parcel$export($1775968c0d4755f4$exports, "artistName", function () { return $1775968c0d4755f4$export$c1eadcaec78a8338; }, function (v) { return $1775968c0d4755f4$export$c1eadcaec78a8338 = v; });
$parcel$export($1775968c0d4755f4$exports, "loadingDiv", function () { return $1775968c0d4755f4$export$dded2af20345efaa; }, function (v) { return $1775968c0d4755f4$export$dded2af20345efaa = v; });
$parcel$export($1775968c0d4755f4$exports, "loadingIndicator", function () { return $1775968c0d4755f4$export$f10e6b4aaa94c253; }, function (v) { return $1775968c0d4755f4$export$f10e6b4aaa94c253 = v; });
$parcel$export($1775968c0d4755f4$exports, "shareButton", function () { return $1775968c0d4755f4$export$644913298ab745fc; }, function (v) { return $1775968c0d4755f4$export$644913298ab745fc = v; });
$parcel$export($1775968c0d4755f4$exports, "shareIcon", function () { return $1775968c0d4755f4$export$a2dbc589500a2539; }, function (v) { return $1775968c0d4755f4$export$a2dbc589500a2539 = v; });
var $1775968c0d4755f4$export$85c78588146f12bc;
var $1775968c0d4755f4$export$c1eadcaec78a8338;
var $1775968c0d4755f4$export$dded2af20345efaa;
var $1775968c0d4755f4$export$f10e6b4aaa94c253;
var $1775968c0d4755f4$export$644913298ab745fc;
var $1775968c0d4755f4$export$a2dbc589500a2539;
$1775968c0d4755f4$export$85c78588146f12bc = `K982Jq_albumName`;
$1775968c0d4755f4$export$c1eadcaec78a8338 = `K982Jq_artistName`;
$1775968c0d4755f4$export$dded2af20345efaa = `K982Jq_loadingDiv`;
$1775968c0d4755f4$export$f10e6b4aaa94c253 = `K982Jq_loadingIndicator`;
$1775968c0d4755f4$export$644913298ab745fc = `K982Jq_shareButton`;
$1775968c0d4755f4$export$a2dbc589500a2539 = `K982Jq_shareIcon`;






const $344d6f8e57c6af94$export$1675ec48d869475b = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const updateAlbum = (parameters)=>put("albums", parameters);
    return {
        updateAlbum: updateAlbum
    };
};





var $7fPBF = parcelRequire("7fPBF");








const $4b08d405fec2c9eb$export$15a65656f8532587 = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getArtists = (parameters)=>get("artists", parameters);
    const getPublicArtists = (parameters)=>get("artists/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).artists(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicArtists : getArtists, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).artistStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $5439746b6e17b6b4$exports = {};

$parcel$export($5439746b6e17b6b4$exports, "cancelButton", function () { return $5439746b6e17b6b4$export$4ededb8e5b56a6fb; }, function (v) { return $5439746b6e17b6b4$export$4ededb8e5b56a6fb = v; });
$parcel$export($5439746b6e17b6b4$exports, "dropzone", function () { return $5439746b6e17b6b4$export$585d0a7a39ed94ea; }, function (v) { return $5439746b6e17b6b4$export$585d0a7a39ed94ea = v; });
$parcel$export($5439746b6e17b6b4$exports, "loadingDiv", function () { return $5439746b6e17b6b4$export$dded2af20345efaa; }, function (v) { return $5439746b6e17b6b4$export$dded2af20345efaa = v; });
$parcel$export($5439746b6e17b6b4$exports, "profileCard", function () { return $5439746b6e17b6b4$export$56d7158379169459; }, function (v) { return $5439746b6e17b6b4$export$56d7158379169459 = v; });
$parcel$export($5439746b6e17b6b4$exports, "textField", function () { return $5439746b6e17b6b4$export$c54b92c0bb02ba64; }, function (v) { return $5439746b6e17b6b4$export$c54b92c0bb02ba64 = v; });
var $5439746b6e17b6b4$export$4ededb8e5b56a6fb;
var $5439746b6e17b6b4$export$585d0a7a39ed94ea;
var $5439746b6e17b6b4$export$dded2af20345efaa;
var $5439746b6e17b6b4$export$56d7158379169459;
var $5439746b6e17b6b4$export$c54b92c0bb02ba64;
$5439746b6e17b6b4$export$4ededb8e5b56a6fb = `_9nFbNq_cancelButton`;
$5439746b6e17b6b4$export$585d0a7a39ed94ea = `_9nFbNq_dropzone`;
$5439746b6e17b6b4$export$dded2af20345efaa = `_9nFbNq_loadingDiv`;
$5439746b6e17b6b4$export$56d7158379169459 = `_9nFbNq_profileCard`;
$5439746b6e17b6b4$export$c54b92c0bb02ba64 = `_9nFbNq_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $d33ea69830864955$export$ee674ce169687584 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addArtist = (parameters)=>post("artists", parameters);
    return {
        addArtist: addArtist
    };
};



const $ed4ed0b16377f25f$export$1710ab8e93c3f538 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyArtist = (parameters)=>put("artists", parameters);
    return {
        modifyArtist: modifyArtist
    };
};



const $cdde9272dcb8820b$export$9a4e28413d5e7fe8 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteArtist = (parameters)=>deleteRequest("artists", parameters);
    return {
        deleteArtist: deleteArtist
    };
};





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



const $c597a968c23d62fb$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
]);
var $c597a968c23d62fb$export$2e2bcd8739ae039 = $c597a968c23d62fb$var$refType;





var $7fPBF = parcelRequire("7fPBF");




parcelRequire("7fPBF");




const $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0 = 36;
const $f49d2ca225f7bed5$export$dde58b009b497666 = 2;
const $f49d2ca225f7bed5$export$ee46b8a74d6c94d3 = 320;
const $f49d2ca225f7bed5$export$73724491020e90c7 = 280;
const $f49d2ca225f7bed5$export$f2fef360e2df0cb7 = 334;
const $f49d2ca225f7bed5$export$1c2eabda4acea0e4 = 232;
const $f49d2ca225f7bed5$export$a462ceb9cfdb5d71 = 48;



const $52c169ad4ec0e8fd$var$PickersModalDialogRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $7f096abd658f7c85$export$2e2bcd8739ae039))({
    [`& .${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3)
    }
});
const $52c169ad4ec0e8fd$var$PickersModalDialogContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $52c169ad4ec0e8fd$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $52c169ad4ec0e8fd$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $68214be7242cbfc8$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Dialog, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($52c169ad4ec0e8fd$var$PickersModalDialogContent, {
            children: children
        })
    }));
}




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
const $97abccf8a6b96579$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $7fPBF.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $7fPBF.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $7fPBF.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $7fPBF.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



const $cbc6c65ed9f8bf86$var$_excluded = [
    "localeText"
];
const $cbc6c65ed9f8bf86$export$544976378534cf9 = /*#__PURE__*/ $7fPBF.createContext(null);
const $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(inProps, $cbc6c65ed9f8bf86$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $7fPBF.useContext($cbc6c65ed9f8bf86$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $7fPBF.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $7fPBF.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $7fPBF.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cbc6c65ed9f8bf86$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



const $6945e6366bb58773$export$4b5a24245de9f7f9 = ()=>{
    const localization = $7fPBF.useContext((0, $cbc6c65ed9f8bf86$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $ae7ac3a23918bc42$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $6945e6366bb58773$export$1163b47e39508a46 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().utils;
const $6945e6366bb58773$export$7c38da3a2e90fa83 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().defaultDates;
const $6945e6366bb58773$export$24fdeaa0f591a73e = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().localeText;
const $6945e6366bb58773$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $6945e6366bb58773$export$1163b47e39508a46();
    const now = $7fPBF.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};



var $7fPBF = parcelRequire("7fPBF");

function $31af76dae84b836c$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $7fPBF.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $7fPBF.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $7fPBF = parcelRequire("7fPBF");



const $a30ec645234d5ab0$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const firstDefaultValue = $7fPBF.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $7fPBF.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
    const valueWithTimezoneToRender = $7fPBF.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $a30ec645234d5ab0$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $a30ec645234d5ab0$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $476ea41559631918$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $476ea41559631918$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $476ea41559631918$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $476ea41559631918$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $7fPBF.useRef(inDefaultValue);
    const { current: isControlled } = $7fPBF.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const [selectedSections, setSelectedSections] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'usePickerValue',
        state: 'selectedSections'
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $97abccf8a6b96579$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $7fPBF.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $a30ec645234d5ab0$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $31af76dae84b836c$export$87fe492f99f25a20)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $476ea41559631918$var$shouldPublishValue(updaterParams);
        const shouldCommit = $476ea41559631918$var$shouldCommitValue(updaterParams);
        const shouldClose = $476ea41559631918$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === 'setValueFromField' ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            // TODO v7: Remove 2nd condition
            if (action.name === 'setValueFromShortcut' && action.shortcut != null) context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>setIsOpen(true));
    const handleClose = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>setIsOpen(false));
    const handleChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    // TODO v7: Make changeImportance and label mandatory.
    const handleSelectShortcut = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : 'accept',
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $7fPBF.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");


let $577bcba5433b0e3c$var$warnedOnceNotValidView = false;
function $577bcba5433b0e3c$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $7fPBF.useRef(openTo);
    const previousViews = $7fPBF.useRef(views);
    const defaultView = $7fPBF.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $7fPBF.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $7fPBF.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up to date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}


const $e85b1ef30fae45b1$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $e85b1ef30fae45b1$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI: The `views` prop must contain at least one view');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $cd9924d2cafbe16d$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $cd9924d2cafbe16d$export$8f04d380cefd5a0d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view);
const $cd9924d2cafbe16d$export$a3328136ac50623d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view) || view === 'meridiem';
const $cd9924d2cafbe16d$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $cd9924d2cafbe16d$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $cd9924d2cafbe16d$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $cd9924d2cafbe16d$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $cd9924d2cafbe16d$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $cd9924d2cafbe16d$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $cd9924d2cafbe16d$export$888a1ce13aa61986(dateLeft, utils) > $cd9924d2cafbe16d$export$888a1ce13aa61986(dateRight, utils);
    };
const $cd9924d2cafbe16d$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};


const $91b52a6f82eabdf2$var$_excluded = [
    "className",
    "sx"
];
const $91b52a6f82eabdf2$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $91b52a6f82eabdf2$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $577bcba5433b0e3c$export$9b46cba8f8ccd954)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = 'field';
            else if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $cd9924d2cafbe16d$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $7fPBF.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};




var $7fPBF = parcelRequire("7fPBF");

/* Use it instead of .includes method for IE support */ function $e21804eb4bb13208$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $e21804eb4bb13208$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $e21804eb4bb13208$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $e21804eb4bb13208$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e21804eb4bb13208$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $e21804eb4bb13208$export$9ae5b19305db48ce = '@media (pointer: fine)';


function $09cfc8723d2df359$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $09cfc8723d2df359$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $7fPBF.useState($09cfc8723d2df359$var$getOrientation);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($09cfc8723d2df359$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $e21804eb4bb13208$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $42c3212b5eaac64d$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $09cfc8723d2df359$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};


const $f75951614efca4a8$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $f75951614efca4a8$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


const $c317bbaffa35b5af$var$warnRenderInputIsDefined = (0, $f75951614efca4a8$export$baf331755d84b871)([
    'The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.',
    'You can replace it with the `textField` component slot in most cases.',
    'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).'
]);
const $c317bbaffa35b5af$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $476ea41559631918$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $91b52a6f82eabdf2$export$c0a71b697a2df210)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $42c3212b5eaac64d$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};






var $7fPBF = parcelRequire("7fPBF");






function $fca8ed2355aa4314$export$1671c31de798d429(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersLayout', slot);
}
const $fca8ed2355aa4314$export$7a6dac186703fe4c = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);



parcelRequire("7fPBF");




parcelRequire("7fPBF");





const $8facba742bfbb34f$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $8facba742bfbb34f$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8facba742bfbb34f$var$_excluded);
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}





parcelRequire("7fPBF");






const $7e72c47dc598913d$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $7e72c47dc598913d$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $7e72c47dc598913d$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7e72c47dc598913d$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $7e72c47dc598913d$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item))
            }, item.label);
        })
    }));
}



const $b677556a4855b45c$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};



function $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $8110d6ade26cbc5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fca8ed2355aa4314$export$1671c31de798d429), classes);
};
const $8110d6ade26cbc5c$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $b677556a4855b45c$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $8110d6ade26cbc5c$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $8facba742bfbb34f$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ],
            className: classes.actionBar
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionBar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Toolbar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Tabs, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $7e72c47dc598913d$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Shortcuts, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $8110d6ade26cbc5c$export$2e2bcd8739ae039 = $8110d6ade26cbc5c$var$usePickerLayout;



const $0ea30ea295446df9$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fca8ed2355aa4314$export$1671c31de798d429), classes);
};
const $0ea30ea295446df9$export$9a9363506c13836 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'grid',
        gridAutoColumns: 'max-content auto max-content',
        gridAutoRows: 'max-content auto max-content',
        [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        } : {
            gridColumn: '2 / 4',
            gridRow: 1
        },
        [`.${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: '2 / 4',
            gridRow: 1
        } : {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        },
        [`& .${(0, $fca8ed2355aa4314$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: '1 / 4',
            gridRow: 3
        }
    }));
$0ea30ea295446df9$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
    ])
};
const $0ea30ea295446df9$export$bc1494d918129235 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $0ea30ea295446df9$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $8110d6ade26cbc5c$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $0ea30ea295446df9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0ea30ea295446df9$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0ea30ea295446df9$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



const $d282c2379e3abcb7$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $d282c2379e3abcb7$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $d282c2379e3abcb7$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const internalInputRef = $7fPBF.useRef(null);
    const labelId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $c317bbaffa35b5af$export$fc3313977ac596c4)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $e21804eb4bb13208$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            name: name
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $0ea30ea295446df9$export$647f604ea2397c05);
    const handleInputRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Field, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52c169ad4ec0e8fd$export$99f83c99e1491f77), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Layout, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};




var $7fPBF = parcelRequire("7fPBF");




const $4d1fa529a9a32e76$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $4d1fa529a9a32e76$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $4d1fa529a9a32e76$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $4d1fa529a9a32e76$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $4d1fa529a9a32e76$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $4d1fa529a9a32e76$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $4d1fa529a9a32e76$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $4d1fa529a9a32e76$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const $4d1fa529a9a32e76$var$dateViews = [
    'year',
    'month',
    'day'
];
const $4d1fa529a9a32e76$export$b32dfef9f07dea64 = (view)=>$4d1fa529a9a32e76$var$dateViews.includes(view);
const $4d1fa529a9a32e76$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $e85b1ef30fae45b1$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $4d1fa529a9a32e76$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");





function $f7d55096f286ac82$export$b109c489973c3d80(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersToolbar', slot);
}
const $f7d55096f286ac82$export$59f09e5e2b3d9913 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersToolbar', [
    'root',
    'content'
]);



const $f6120d886b3f245b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $f7d55096f286ac82$export$b109c489973c3d80), classes);
};
const $f6120d886b3f245b$var$PickersToolbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $f6120d886b3f245b$var$PickersToolbarContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>{
    var _ownerState$landscape;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: ownerState.isLandscape ? 'flex-start' : 'space-between',
        flexDirection: ownerState.isLandscape ? (_ownerState$landscape = ownerState.landscapeDirection) != null ? _ownerState$landscape : 'column' : 'row',
        flex: 1,
        alignItems: ownerState.isLandscape ? 'flex-start' : 'center'
    };
});
const $f6120d886b3f245b$export$eb3c4d84783d6feb = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $f6120d886b3f245b$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f6120d886b3f245b$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f6120d886b3f245b$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    });
});




function $1f1136919bda5dde$export$a1c3879af2c3b694(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDatePickerToolbar', slot);
}
const $1f1136919bda5dde$export$2e35fa7d24ef4179 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




const $8c89a4c7302d5b4a$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views"
];
const $8c89a4c7302d5b4a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1f1136919bda5dde$export$a1c3879af2c3b694), classes);
};
const $8c89a4c7302d5b4a$var$DatePickerToolbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $f6120d886b3f245b$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $8c89a4c7302d5b4a$var$DatePickerToolbarTitle = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
const $8c89a4c7302d5b4a$export$21b7f8ea763109eb = /*#__PURE__*/ $7fPBF.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8c89a4c7302d5b4a$var$_excluded);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const classes = $8c89a4c7302d5b4a$var$useUtilityClasses(props);
    const dateText = $7fPBF.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $4d1fa529a9a32e76$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



function $53ebcde7c448f3c9$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const localeText = $7fPBF.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $b677556a4855b45c$export$ee17bc394843b249)(themeProps.components);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, {
        localeText: localeText
    }, (0, $e85b1ef30fae45b1$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            toolbar: (0, $8c89a4c7302d5b4a$export$21b7f8ea763109eb)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}



const $b39c207604afaad4$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};





var $7fPBF = parcelRequire("7fPBF");










const $03cf12356675f79b$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $03cf12356675f79b$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $03cf12356675f79b$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $03cf12356675f79b$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $03cf12356675f79b$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $03cf12356675f79b$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $03cf12356675f79b$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $03cf12356675f79b$var$roundDate(utils, granularity, (0, $4d1fa529a9a32e76$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $cd9924d2cafbe16d$export$fb87c80b35a46b89)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};




const $7692508c11d587c8$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $7692508c11d587c8$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $7692508c11d587c8$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $7692508c11d587c8$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, format);
        case 'meridiem':
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $7692508c11d587c8$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $7692508c11d587c8$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $7692508c11d587c8$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $7692508c11d587c8$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes)=>{
    const delta = $7692508c11d587c8$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$7692508c11d587c8$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === 'minutes' && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $7692508c11d587c8$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $7692508c11d587c8$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $7692508c11d587c8$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $7692508c11d587c8$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $7692508c11d587c8$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $7692508c11d587c8$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $7692508c11d587c8$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $7692508c11d587c8$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $7692508c11d587c8$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $7692508c11d587c8$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $7692508c11d587c8$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            {
                if ($7692508c11d587c8$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === '0001';
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === '01';
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $7692508c11d587c8$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $7692508c11d587c8$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = '';
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === '') return null;
        const sectionConfig = $7692508c11d587c8$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $7692508c11d587c8$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $7692508c11d587c8$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $7692508c11d587c8$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : '',
            endSeparator: '',
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $7692508c11d587c8$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length) // Sort to put longest word first
    .join('|')})`, 'g') // used to get access to lastIndex state
    ;
    let currentTokenValue = '';
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        const regExpMatch = isTokenStartRegExp.test(potentialToken);
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && regExpMatch) {
            currentTokenValue = potentialToken.slice(0, isTokenStartRegExp.lastIndex);
            i += isTokenStartRegExp.lastIndex - 1;
        } else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = '';
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $7692508c11d587c8$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($7692508c11d587c8$export$85daa91f6c6e875f(section, 'non-input'));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $7692508c11d587c8$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $7692508c11d587c8$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $7692508c11d587c8$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $7692508c11d587c8$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $7692508c11d587c8$var$warnedOnceInvalidSection = false;
const $7692508c11d587c8$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $7692508c11d587c8$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $7692508c11d587c8$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $7692508c11d587c8$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$7692508c11d587c8$var$reliableSectionModificationOrder[a.type] - $7692508c11d587c8$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $7692508c11d587c8$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $7692508c11d587c8$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf('android') > -1;
const $7692508c11d587c8$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ';
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};


const $841d6de1e4809c9b$var$_excluded = [
    "value",
    "referenceDate"
];
const $841d6de1e4809c9b$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $4d1fa529a9a32e76$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $841d6de1e4809c9b$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $03cf12356675f79b$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $4d1fa529a9a32e76$export$36ca889e039badd5),
    areValuesEqual: (0, $4d1fa529a9a32e76$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $841d6de1e4809c9b$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $7692508c11d587c8$export$8bb5d1c9951d10ca)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $7692508c11d587c8$export$e990c4332a617e3d),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");






const $ab6e023aa9d06979$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $a30ec645234d5ab0$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$360600f456ea7d5f)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $7fPBF.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $7692508c11d587c8$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $7fPBF.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $7692508c11d587c8$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $03cf12356675f79b$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSectionIndexes'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $7fPBF.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === 'all') return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === 'number') return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === 'string') {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $7692508c11d587c8$export$8bb5d1c9951d10ca)(newSections, isRTL);
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === '' ? 0 : 1);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, '');
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.date(new Date(''));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $7692508c11d587c8$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $7692508c11d587c8$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $7692508c11d587c8$export$b0c1bfd065bfe742)(utils, newActiveDateSections);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $7692508c11d587c8$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $7fPBF.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $7692508c11d587c8$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};




var $7fPBF = parcelRequire("7fPBF");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS = 5000;
const $de4ce65a55c75bbb$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $de4ce65a55c75bbb$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const [query, setQuery] = $7fPBF.useState(null);
    const resetQuery = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>setQuery(null));
    $7fPBF.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $7fPBF.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $7692508c11d587c8$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $7692508c11d587c8$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $7692508c11d587c8$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $7692508c11d587c8$export$ef88db4bceade9fd)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $7692508c11d587c8$export$78b5830e2dd2de49)(utils, timezone, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $7692508c11d587c8$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $7692508c11d587c8$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



const $2a09a13200d5a2c7$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error",
    "clearable",
    "onClear",
    "disabled"
];
const $2a09a13200d5a2c7$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $ab6e023aa9d06979$export$4e8d6353e50062e7)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error, clearable: clearable, onClear: onClear, disabled: disabled }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(params.forwardedProps, $2a09a13200d5a2c7$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $de4ce65a55c75bbb$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const focusTimeoutRef = $7fPBF.useRef(undefined);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const sectionOrder = $7fPBF.useMemo(()=>(0, $7692508c11d587c8$export$7725fd6fe0a2aadf)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick == null || onClick(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                // prevent default to avoid the input change handler being called
                event.preventDefault();
                return;
            }
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = (0, $7692508c11d587c8$export$cb0bbc88c7f09596)(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $7692508c11d587c8$export$cb0bbc88c7f09596)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $7692508c11d587c8$export$cb0bbc88c7f09596)(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $7692508c11d587c8$export$cb0bbc88c7f09596)(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $7692508c11d587c8$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            else {
                resetCharacterQuery();
                clearActiveSection();
            }
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === 'a' && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $7692508c11d587c8$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $31af76dae84b836c$export$87fe492f99f25a20)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $7fPBF.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $7fPBF.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections('all');
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $7fPBF.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $7fPBF.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $7fPBF.useMemo(()=>{
        if (selectedSectionIndexes == null) return 'text';
        if (state.sections[selectedSectionIndexes.startIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $e21804eb4bb13208$export$cd4e5573fbe2b576)(document);
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $7fPBF.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    const handleClearValue = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, ...args)=>{
        var _inputRef$current;
        event.preventDefault();
        onClear == null || onClear(event, ...args);
        clearValue();
        inputRef == null || (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
        setSelectedSections(0);
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        placeholder: placeholder,
        autoComplete: 'off',
        disabled: Boolean(disabled)
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? '' : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        onClear: handleClearValue,
        error: inputError,
        ref: handleRef,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    });
};






const $2ade22a6fd91393f$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $2ade22a6fd91393f$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableClock',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $2ade22a6fd91393f$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $2ade22a6fd91393f$var$VALIDATION_PROP_NAMES = [
    ...$2ade22a6fd91393f$export$430d9fc64cf058d6,
    ...$2ade22a6fd91393f$export$fd5e0f8b4115a8c7,
    ...$2ade22a6fd91393f$export$1df62d3ba2121371
];
const $2ade22a6fd91393f$export$5890f750904acddb = (props)=>$2ade22a6fd91393f$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $c36bb456184413d3$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'readOnly',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef'
];
const $c36bb456184413d3$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $c36bb456184413d3$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === 'date') (0, $2ade22a6fd91393f$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === 'time') (0, $2ade22a6fd91393f$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === 'date-time') {
        (0, $2ade22a6fd91393f$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $2ade22a6fd91393f$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $2ade22a6fd91393f$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};


const $da4099eec06cd7d9$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $da4099eec06cd7d9$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $da4099eec06cd7d9$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $c36bb456184413d3$export$cdde224d2939fd84)(props, 'date');
    return (0, $2a09a13200d5a2c7$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba),
        fieldValueManager: (0, $841d6de1e4809c9b$export$b602c94f557316b4),
        validator: (0, $b39c207604afaad4$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};





var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");










function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;




'use client';
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $3347e858a7e1bb40$export$4b135a4b3a6c4550), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $a1383c8904b71ac9$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;




var $7fPBF = parcelRequire("7fPBF");

const $27f114a7ae98fe28$export$ed0fe318cc298673 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $27f114a7ae98fe28$export$8afed21ef5c2afa5 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $27f114a7ae98fe28$export$9ca09caa9c849d9c = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $27f114a7ae98fe28$export$5fda1783bb83f57b = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $27f114a7ae98fe28$export$8099ab97743c966c = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $27f114a7ae98fe28$export$90a8eab2a2411720 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $27f114a7ae98fe28$export$7e95adcf912503e3 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $27f114a7ae98fe28$export$cefbac224a47f32 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');




const $f8c7cbeb7c9ac09c$var$_excluded = [
    "ownerState"
];
const $f8c7cbeb7c9ac09c$export$db9644cdb7e3d432 = ({ clearable: clearable, fieldProps: forwardedFieldProps, InputProps: ForwardedInputProps, onClear: onClear, slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps })=>{
    var _ref, _slots$clearButton, _slotProps$clearButto, _ref2, _slots$clearIcon, _slotProps$clearIcon;
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const IconButton = (_ref = (_slots$clearButton = slots == null ? void 0 : slots.clearButton) != null ? _slots$clearButton : components == null ? void 0 : components.ClearButton) != null ? _ref : (0, $67a243c492197f3b$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: IconButton,
        externalSlotProps: (_slotProps$clearButto = slotProps == null ? void 0 : slotProps.clearButton) != null ? _slotProps$clearButto : componentsProps == null ? void 0 : componentsProps.clearButton,
        ownerState: {},
        className: 'clearButton',
        additionalProps: {
            title: localeText.fieldClearLabel
        }
    }), iconButtonProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $f8c7cbeb7c9ac09c$var$_excluded);
    const EndClearIcon = (_ref2 = (_slots$clearIcon = slots == null ? void 0 : slots.clearIcon) != null ? _slots$clearIcon : components == null ? void 0 : components.ClearIcon) != null ? _ref2 : (0, $27f114a7ae98fe28$export$cefbac224a47f32);
    const endClearIconProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: EndClearIcon,
        externalSlotProps: (_slotProps$clearIcon = slotProps == null ? void 0 : slotProps.clearIcon) != null ? _slotProps$clearIcon : componentsProps == null ? void 0 : componentsProps.clearIcon,
        ownerState: {}
    });
    const InputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ForwardedInputProps, {
        endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
            children: [
                clearable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                    position: "end",
                    sx: {
                        marginRight: ForwardedInputProps != null && ForwardedInputProps.endAdornment ? -1 : -1.5
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, iconButtonProps, {
                        onClick: onClear,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(EndClearIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            fontSize: "small"
                        }, endClearIconProps))
                    }))
                }),
                ForwardedInputProps == null ? void 0 : ForwardedInputProps.endAdornment
            ]
        })
    });
    const fieldProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, forwardedFieldProps, {
        sx: [
            {
                '& .clearButton': {
                    opacity: 1
                },
                '@media (pointer: fine)': {
                    '& .clearButton': {
                        opacity: 0
                    },
                    '&:hover, &:focus-within': {
                        '.clearButton': {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(forwardedFieldProps.sx) ? forwardedFieldProps.sx : [
                forwardedFieldProps.sx
            ]
        ]
    });
    return {
        InputProps: InputProps,
        fieldProps: fieldProps
    };
};



const $5945f8b72dcc769b$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $5945f8b72dcc769b$var$_excluded2 = [
    "inputRef"
], $5945f8b72dcc769b$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "clearable",
    "onClear"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $5945f8b72dcc769b$export$d9781c7894a82487 = /*#__PURE__*/ $7fPBF.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(themeProps, $5945f8b72dcc769b$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $afe2b905acb8b9f6$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $5945f8b72dcc769b$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    const _useDateField = (0, $da4099eec06cd7d9$export$5591b0b878c1a989)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, clearable: clearable, onClear: onClear } = _useDateField, fieldProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useDateField, $5945f8b72dcc769b$var$_excluded3);
    const { InputProps: ProcessedInputProps, fieldProps: processedFieldProps } = (0, $f8c7cbeb7c9ac09c$export$db9644cdb7e3d432)({
        onClear: onClear,
        clearable: clearable,
        fieldProps: fieldProps,
        InputProps: fieldProps.InputProps,
        slots: slots,
        slotProps: slotProps,
        components: components,
        componentsProps: componentsProps
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TextField, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, processedFieldProps, {
        InputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ProcessedInputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});




parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


const $272960e2556e540f$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $6945e6366bb58773$export$4b5a24245de9f7f9)();
    return $7fPBF.useCallback((day)=>(0, $b39c207604afaad4$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $b7c44e28b3ec1424$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $b7c44e28b3ec1424$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const reducerFn = $7fPBF.useRef($b7c44e28b3ec1424$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $7fPBF.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $7fPBF.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: utils.isValid(value) ? value : now,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const handleChangeMonth = $7fPBF.useCallback((payload)=>{
        dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $7fPBF.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $272960e2556e540f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $7fPBF.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("7fPBF");






const $aaad891d0da306eb$export$5b0bb0174eb448ca = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', slot);
const $aaad891d0da306eb$export$1461f245817ac559 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', [
    'root'
]);



const $966d54c4b5737349$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $aaad891d0da306eb$export$5b0bb0174eb448ca), classes);
};
const $966d54c4b5737349$var$PickersFadeTransitionGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $966d54c4b5737349$export$5262185daf493fee(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $966d54c4b5737349$var$useUtilityClasses(props);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($966d54c4b5737349$var$PickersFadeTransitionGroupRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");








function $7704811ff6d1667b$export$4b25deb0350d3e53(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersDay', slot);
}
const $7704811ff6d1667b$export$68b221ad3c35e288 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



const $d64849e0226d1a8f$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $d64849e0226d1a8f$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $7704811ff6d1667b$export$4b25deb0350d3e53), classes);
};
const $d64849e0226d1a8f$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        height: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).disabled}:not(.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).disabled}&.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $f49d2ca225f7bed5$export$dde58b009b497666}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $7704811ff6d1667b$export$68b221ad3c35e288).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $d64849e0226d1a8f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $d64849e0226d1a8f$var$PickersDayRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})($d64849e0226d1a8f$var$styleArg);
const $d64849e0226d1a8f$var$PickersDayFiller = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $d64849e0226d1a8f$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $d64849e0226d1a8f$var$noop = ()=>{};
const $d64849e0226d1a8f$var$PickersDayRaw = /*#__PURE__*/ $7fPBF.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $d64849e0226d1a8f$var$noop, onBlur: onBlur = $d64849e0226d1a8f$var$noop, onKeyDown: onKeyDown = $d64849e0226d1a8f$var$noop, onMouseDown: onMouseDown = $d64849e0226d1a8f$var$noop, onMouseEnter: onMouseEnter = $d64849e0226d1a8f$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d64849e0226d1a8f$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $d64849e0226d1a8f$var$useUtilityClasses(ownerState);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const ref = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d64849e0226d1a8f$var$PickersDayFiller, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d64849e0226d1a8f$var$PickersDayRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $d64849e0226d1a8f$export$d7378e6e864346fa = /*#__PURE__*/ $7fPBF.memo($d64849e0226d1a8f$var$PickersDayRaw);







var $7fPBF = parcelRequire("7fPBF");







/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $7fPBF = parcelRequire("7fPBF");



var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1e3f901d29816e8c$export$2e2bcd8739ae039)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $89edc8a1840ff9c1$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $dd20db312c2129e6$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $e279fb69073314ca$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $623678cbb6daf054$export$2e2bcd8739ae039), (0, $69eb4698d21449e4$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;



const $b250f2b85e5b8968$export$e98c1b6c3bbc3c59 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersSlideTransition', slot);
const $b250f2b85e5b8968$export$d251a58673156a67 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



const $56e2eef78447d2ae$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $56e2eef78447d2ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b250f2b85e5b8968$export$e98c1b6c3bbc3c59), classes);
};
const $56e2eef78447d2ae$var$PickersSlideTransitionRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $b250f2b85e5b8968$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $56e2eef78447d2ae$export$e868fcc7557d3a06(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $56e2eef78447d2ae$var$_excluded);
    const classes = $56e2eef78447d2ae$var$useUtilityClasses(props);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($56e2eef78447d2ae$var$PickersSlideTransitionRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $7fPBF.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9e47e451b39ae9f$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





const $ae6a8d447141a6ad$export$fbe827982a69894a = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDayCalendar', slot);
const $ae6a8d447141a6ad$export$e0770f35b28ac552 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



const $c2d389da60812d08$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $c2d389da60812d08$var$_excluded2 = [
    "ownerState"
];
const $c2d389da60812d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $ae6a8d447141a6ad$export$fbe827982a69894a), classes);
};
const $c2d389da60812d08$var$weeksContainerHeight = ((0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0) + (0, $f49d2ca225f7bed5$export$dde58b009b497666) * 2) * 6;
const $c2d389da60812d08$var$PickersCalendarDayRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $c2d389da60812d08$var$PickersCalendarDayHeader = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $c2d389da60812d08$var$PickersCalendarWeekDayLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumberLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumber = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        height: (0, $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $f49d2ca225f7bed5$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $c2d389da60812d08$var$PickersCalendarLoadingContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarSlideTransition = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $56e2eef78447d2ae$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarWeekContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $c2d389da60812d08$var$PickersCalendarWeek = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $f49d2ca225f7bed5$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $c2d389da60812d08$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $c2d389da60812d08$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $d64849e0226d1a8f$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $c2d389da60812d08$var$_excluded2);
    const isDisabled = $7fPBF.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $7fPBF.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $7fPBF.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Day, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $c2d389da60812d08$export$8fb56b32a5df6314(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatterFromProps, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const classes = $c2d389da60812d08$var$useUtilityClasses(props);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    // before we could define this outside of the component scope, but now we need utils, which is only defined here
    const dayOfWeekFormatter = dayOfWeekFormatterFromProps || ((_day, date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase());
    const isDateDisabled = (0, $272960e2556e540f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $7fPBF.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $7fPBF.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $7fPBF.useMemo(()=>/*#__PURE__*/ $7fPBF.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $7fPBF.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    (0, $4d1fa529a9a32e76$export$24c38139da66592d)(utils, now).map((weekday, i)=>{
                        var _dayOfWeekFormatter;
                        const day = utils.format(weekday, 'weekdayShort');
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day, weekday)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarSlideTransition, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c2d389da60812d08$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c2d389da60812d08$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");



function $b78805cd45b35333$export$db90a620ac957a73(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersMonth', slot);
}
const $b78805cd45b35333$export$911e3973fa70a12b = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



const $e23e94166bf12d18$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const $e23e94166bf12d18$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b78805cd45b35333$export$db90a620ac957a73), classes);
};
const $e23e94166bf12d18$var$PickersMonthRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $e23e94166bf12d18$var$PickersMonthButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $b78805cd45b35333$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $e23e94166bf12d18$export$bc52fdb7f02f591a = /*#__PURE__*/ $7fPBF.memo(function PickersMonth(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e23e94166bf12d18$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $e23e94166bf12d18$var$useUtilityClasses(props);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e23e94166bf12d18$var$PickersMonthRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e23e94166bf12d18$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




function $1196436c7c3fe2c3$export$da0c97315339ebd9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMonthCalendar', slot);
}
const $1196436c7c3fe2c3$export$edf77d5566c7007c = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMonthCalendar', [
    'root'
]);








const $4bccd319eb983de3$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const $4bccd319eb983de3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1196436c7c3fe2c3$export$da0c97315339ebd9), classes);
};
function $4bccd319eb983de3$export$5b6e066572408095(props, name) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $4bccd319eb983de3$var$MonthCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box'
});
const $4bccd319eb983de3$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $7fPBF.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $4bccd319eb983de3$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $4bccd319eb983de3$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $4bccd319eb983de3$var$useUtilityClasses(ownerState);
    const todayMonth = $7fPBF.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $7fPBF.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $7fPBF.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bccd319eb983de3$var$MonthCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $4d1fa529a9a32e76$export$62591b96a734eacd)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e23e94166bf12d18$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");




function $a3ff649e8dd46250$export$183c9f339a61cd79(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersYear', slot);
}
const $a3ff649e8dd46250$export$4ef58a3d9c6f4296 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



const $0f4dbb6707104d23$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $0f4dbb6707104d23$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a3ff649e8dd46250$export$183c9f339a61cd79), classes);
};
const $0f4dbb6707104d23$var$PickersYearRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $0f4dbb6707104d23$var$PickersYearButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '6px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $a3ff649e8dd46250$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $0f4dbb6707104d23$export$261f3fbd5fd5814d = /*#__PURE__*/ $7fPBF.memo(function PickersYear(inProps) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $0f4dbb6707104d23$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $0f4dbb6707104d23$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $7fPBF.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0f4dbb6707104d23$var$PickersYearRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0f4dbb6707104d23$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




function $2249f5f50aa75a9e$export$4477acc520094dec(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiYearCalendar', slot);
}
const $2249f5f50aa75a9e$export$e42d427cd9fe5fd7 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiYearCalendar', [
    'root'
]);








const $5cb2e1cea88096ca$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const $5cb2e1cea88096ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2249f5f50aa75a9e$export$4477acc520094dec), classes);
};
function $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(props, name) {
    var _themeProps$yearsPerR;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: (_themeProps$yearsPerR = themeProps.yearsPerRow) != null ? _themeProps$yearsPerR : 3,
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5cb2e1cea88096ca$var$YearCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    maxHeight: (0, $f49d2ca225f7bed5$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative'
});
const $5cb2e1cea88096ca$export$657f9200591b2b71 = /*#__PURE__*/ $7fPBF.forwardRef(function YearCalendar(inProps, ref) {
    const props = $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5cb2e1cea88096ca$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const now = (0, $6945e6366bb58773$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $841d6de1e4809c9b$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $03cf12356675f79b$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $5cb2e1cea88096ca$var$useUtilityClasses(ownerState);
    const todayYear = $7fPBF.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $7fPBF.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $7fPBF.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, scrollerRef);
    $7fPBF.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cb2e1cea88096ca$var$YearCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f4dbb6707104d23$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});






var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");








function $6b883f9bf65a96c2$export$cef978c25740de90(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', slot);
}
const $6b883f9bf65a96c2$export$f8819209558cd362 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);



const $ea7213ea38575b9f$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $ea7213ea38575b9f$var$_excluded2 = [
    "ownerState"
], $ea7213ea38575b9f$var$_excluded3 = [
    "ownerState"
];
const $ea7213ea38575b9f$var$PickersArrowSwitcherRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $ea7213ea38575b9f$var$PickersArrowSwitcherSpacer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $ea7213ea38575b9f$var$PickersArrowSwitcherButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $ea7213ea38575b9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6b883f9bf65a96c2$export$cef978c25740de90), classes);
};
const $ea7213ea38575b9f$export$597b7cbdb7b2a24c = /*#__PURE__*/ $7fPBF.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $ea7213ea38575b9f$var$_excluded);
    const ownerState = props;
    const classes = $ea7213ea38575b9f$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $27f114a7ae98fe28$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $ea7213ea38575b9f$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $27f114a7ae98fe28$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps2, $ea7213ea38575b9f$var$_excluded3);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ea7213ea38575b9f$var$PickersArrowSwitcherRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PreviousIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ea7213ea38575b9f$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NextIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $7fPBF = parcelRequire("7fPBF");


function $5d866238f9e5c9d0$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    return $7fPBF.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    return $7fPBF.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const meridiemMode = (0, $cd9924d2cafbe16d$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $7fPBF.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $cd9924d2cafbe16d$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



const $ea834bcc9ade85be$export$457ac4d3a1ad92b4 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', slot);
const $ea834bcc9ade85be$export$63db7afb9247cb91 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



const $7d8eda0f006682a1$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone"
], $7d8eda0f006682a1$var$_excluded2 = [
    "ownerState"
];
const $7d8eda0f006682a1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $ea834bcc9ade85be$export$457ac4d3a1ad92b4), classes);
};
const $7d8eda0f006682a1$var$PickersCalendarHeaderRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabel = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        marginRight: 'auto'
    }, ownerState.view === 'year' && {
        [`.${(0, $ea834bcc9ade85be$export$63db7afb9247cb91).switchViewIcon}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $27f114a7ae98fe28$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $7d8eda0f006682a1$export$6801ffebb353f473 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersCalendarHeader(inProps, ref) {
    var _ref, _slots$switchViewButt, _ref2, _slots$switchViewIcon;
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, components: components, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7d8eda0f006682a1$var$_excluded);
    const ownerState = props;
    const classes = $7d8eda0f006682a1$var$useUtilityClasses(props);
    const SwitchViewButton = (_ref = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : components == null ? void 0 : components.SwitchViewButton) != null ? _ref : $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_ref2 = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : components == null ? void 0 : components.SwitchViewIcon) != null ? _ref2 : $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $7d8eda0f006682a1$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $5d866238f9e5c9d0$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $5d866238f9e5c9d0$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $966d54c4b5737349$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'monthAndYear'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d8eda0f006682a1$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, 'monthAndYear')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
                in: view === 'day',
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea7213ea38575b9f$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});





const $451797722941b1b3$export$512b066b8abdfde4 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div')({
    overflow: 'hidden',
    width: (0, $f49d2ca225f7bed5$export$ee46b8a74d6c94d3),
    maxHeight: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});



var $7fPBF = parcelRequire("7fPBF");


'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ee4a86a3270f4470$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore = $7fPBF.useSyncExternalStore;
function $ee4a86a3270f4470$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ee4a86a3270f4470$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $249f9015c4a2303b$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore !== undefined ? $ee4a86a3270f4470$var$useMediaQueryNew : $ee4a86a3270f4470$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


const $015921b28af57dd9$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $015921b28af57dd9$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $015921b28af57dd9$var$androidVersion = $015921b28af57dd9$var$mobileVersionMatches && $015921b28af57dd9$var$mobileVersionMatches[1] ? parseInt($015921b28af57dd9$var$mobileVersionMatches[1], 10) : null;
const $015921b28af57dd9$var$iOSVersion = $015921b28af57dd9$var$mobileVersionMatches && $015921b28af57dd9$var$mobileVersionMatches[2] ? parseInt($015921b28af57dd9$var$mobileVersionMatches[2], 10) : null;
const $015921b28af57dd9$export$7e3b2a595fb375e5 = $015921b28af57dd9$var$androidVersion && $015921b28af57dd9$var$androidVersion < 10 || $015921b28af57dd9$var$iOSVersion && $015921b28af57dd9$var$iOSVersion < 13 || false;
const $015921b28af57dd9$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $ee4a86a3270f4470$export$2e2bcd8739ae039)($015921b28af57dd9$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $015921b28af57dd9$export$7e3b2a595fb375e5;
};



const $eb26373463fec8d8$export$da8c2318897a6672 = (slot)=>(0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDateCalendar', slot);
const $eb26373463fec8d8$export$d0237e2bb9598e8d = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);






const $c515574e4bff3014$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c515574e4bff3014$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $eb26373463fec8d8$export$da8c2318897a6672), classes);
};
function $c515574e4bff3014$var$useDateCalendarDefaultizedProps(props, name) {
    var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const defaultDates = (0, $6945e6366bb58773$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $015921b28af57dd9$export$ce40fb97be7f02d9)();
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, {
        loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : 'day',
        views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
            'year',
            'day'
        ],
        reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
        renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: "..."
            }),
        minDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4d1fa529a9a32e76$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c515574e4bff3014$var$DateCalendarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $451797722941b1b3$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $f49d2ca225f7bed5$export$f2fef360e2df0cb7)
});
const $c515574e4bff3014$var$DateCalendarViewTransitionContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $966d54c4b5737349$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $c515574e4bff3014$export$68078fe5d2bf8909 = /*#__PURE__*/ $7fPBF.forwardRef(function DateCalendar(inProps, ref) {
    var _ref, _slots$calendarHeader, _slotProps$calendarHe;
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    const props = $c515574e4bff3014$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $c515574e4bff3014$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a30ec645234d5ab0$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $577bcba5433b0e3c$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $b7c44e28b3ec1424$export$6d095e787d2b5e1f)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : (0, $7d8eda0f006682a1$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: CalendarHeader,
        externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4d1fa529a9a32e76$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $4d1fa529a9a32e76$export$a98b123b8f29e004)(utils, day, value != null ? value : referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $7fPBF.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $c515574e4bff3014$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId
    };
    const prevOpenViewRef = $7fPBF.useRef(view);
    $7fPBF.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $7fPBF.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c515574e4bff3014$var$DateCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CalendarHeader, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c515574e4bff3014$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5cb2e1cea88096ca$export$657f9200591b2b71), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bccd319eb983de3$export$d7a7c85c0f5afc4a), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2d389da60812d08$export$8fb56b32a5df6314), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




const $02ad17f0efd035e0$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c515574e4bff3014$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $4d1fa529a9a32e76$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $4d1fa529a9a32e76$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $080f12ab26da8443$export$97b476d7a92fee62 = /*#__PURE__*/ $7fPBF.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $6945e6366bb58773$export$24fdeaa0f591a73e)();
    const utils = (0, $6945e6366bb58773$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $53ebcde7c448f3c9$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        day: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        month: (0, $02ad17f0efd035e0$export$69888ffe06193e5e),
        year: (0, $02ad17f0efd035e0$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $4d1fa529a9a32e76$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            field: (0, $5945f8b72dcc769b$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $029d34f88c9482cd$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $2ade22a6fd91393f$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $d282c2379e3abcb7$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $841d6de1e4809c9b$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $b39c207604afaad4$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$080f12ab26da8443$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $c597a968c23d62fb$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        3,
        4
    ])
};





/* eslint-disable class-methods-use-this */ 


function $bad15b7880e6f97c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $5956604521ea0197$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}





var $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE = 60000;
function $6d59b3906efd21bf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE);
}





var $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR = 3600000;
function $d58247d27eb0dbf7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR);
}





function $ef64b5b7aae137f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(dirtyDate, days);
}





function $b6e79fa3dbe621a2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $3b831424db570743$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}





function $3c454d4799b2e5e2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $36c4fb25c3bcff41$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $3a4e06016f5a1c64$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c454d4799b2e5e2$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $5df572e1c801b5e3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $5cd7293820fa2400$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $caa0de56b1948e3d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $583602322c3e1847$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(date).getTime() === (0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(date).getTime();
}


function $f6da14512b9613dc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $5df572e1c801b5e3$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $583602322c3e1847$export$2e2bcd8739ae039)((0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



var $5815698037663c71$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $5815698037663c71$var$defaultRoundingMethod = 'trunc';
function $5815698037663c71$export$b6474a47258c1211(method) {
    return method ? $5815698037663c71$var$roundingMap[method] : $5815698037663c71$var$roundingMap[$5815698037663c71$var$defaultRoundingMethod];
}


function $94905b8ecb1c8a63$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $f6da14512b9613dc$export$2e2bcd8739ae039)(dateLeft, dateRight) / 3;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}







function $e114ae87b2fb4d54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY = 86400000;
function $0ff83ae00b0d75a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $fcb7abc0fe52d209$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $0ff83ae00b0d75a6$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $a282d77fbef9d903$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $fcb7abc0fe52d209$export$2e2bcd8739ae039)(dateLeft, dateRight) / 7;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}



/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b22734c988ed96b7$export$dfd9b671c89acc8e = 7;
var $b22734c988ed96b7$export$3913210603d8e9ae = 365.2425;
var $b22734c988ed96b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b22734c988ed96b7$export$91246f0b9bd9beff = 60000;
var $b22734c988ed96b7$export$7f72910d6dfd237a = 3600000;
var $b22734c988ed96b7$export$397c2d5776aa9055 = 1000;
var $b22734c988ed96b7$export$4dec998e48f9c246 = -$b22734c988ed96b7$export$81caae6e1cc7a622;
var $b22734c988ed96b7$export$f2f5ae5a8e2d8f9f = 60;
var $b22734c988ed96b7$export$3c58128db900d44e = 3;
var $b22734c988ed96b7$export$80d7e435f744f319 = 12;
var $b22734c988ed96b7$export$4db7641526e3241f = 4;
var $b22734c988ed96b7$export$698aec755e92c695 = 3600;
var $b22734c988ed96b7$export$a77c1a7ebebe2a5a = 60;
var $b22734c988ed96b7$export$815a9362476d2fe3 = $b22734c988ed96b7$export$698aec755e92c695 * 24;
var $b22734c988ed96b7$export$34804a017b31e2fe = $b22734c988ed96b7$export$815a9362476d2fe3 * 7;
var $b22734c988ed96b7$export$7271e9e3478110d1 = $b22734c988ed96b7$export$815a9362476d2fe3 * $b22734c988ed96b7$export$3913210603d8e9ae;
var $b22734c988ed96b7$export$8e6600bbdee7dabb = $b22734c988ed96b7$export$7271e9e3478110d1 / 12;
var $b22734c988ed96b7$export$be1dccf2de902d31 = $b22734c988ed96b7$export$8e6600bbdee7dabb * 3;




function $656b09e1b179d990$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $8fffbc588a798f57$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $b22734c988ed96b7$export$7f72910d6dfd237a);
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $9a7a827aa3d7f832$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $b22734c988ed96b7$export$91246f0b9bd9beff);
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $3976f91395cc9929$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $ce8f943b2f1f7b6a$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}







function $3a7443c6796c86d0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $c6b92cd202ceada3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $4b40f36c6c4e8120$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}




function $1ba80981c4aaa361$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}




function $d0f608c42e15b075$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $6c0ddf6f2e376b6f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}




function $3e6008e0d859cbde$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}




function $128ac71efb3a2f51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $93c944119040e143$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}






function $580c0aebe042d20a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}







function $27a236e22d5cc772$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $0c7cd58575015cf1$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $27a236e22d5cc772$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $e77bd7a0f5da8fd6$var$MILLISECONDS_IN_WEEK = 604800000;
function $e77bd7a0f5da8fd6$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(date, options).getTime() - (0, $0c7cd58575015cf1$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e77bd7a0f5da8fd6$var$MILLISECONDS_IN_WEEK) + 1;
}




function $88155eb6456a8ca8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $3467188658b165bd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $8f5ca214877b2a80$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $0659d9ec4d7dbbf0$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $849043f97da8598e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $f3df37b4dec5127a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $61980f1dae65c9e0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $36601e4381c8841a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $8b16156dc6f0bfd4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}




function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
}


function $e24194a208e52c1b$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}





function $6f0e75fc27c44afd$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}


function $5236ac5195402c05$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}


function $b48febf76cf3d138$export$2e2bcd8739ae039(o) {
    $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b48febf76cf3d138$export$2e2bcd8739ae039(o);
}


function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cb0780e1471bbfb2$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $690e545d5a200a90$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $505ebcb184373782$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $298ff58efa174465$export$2e2bcd8739ae039)(self);
}


function $c2ec9395872a8e53$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $cb0780e1471bbfb2$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, result);
    };
}


function $009b183922525d46$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $27f18dd8fc16da3b$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $505ebcb184373782$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $381be8fad7784fe9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $381be8fad7784fe9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $381be8fad7784fe9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f8f535a8fee12b58$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Setter);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f8f535a8fee12b58$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);
var $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this2), "priority", $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);












var $d59a769c05ef4f32$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Parser);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $f8f535a8fee12b58$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $453e127a2cb59433$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $2f2b89d1b907546d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $2f2b89d1b907546d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $cac12873b21a7f06$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cac12873b21a7f06$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff) + seconds * (0, $b22734c988ed96b7$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$d931c43c4608a164(dateString) {
    return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $cac12873b21a7f06$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $cac12873b21a7f06$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cac12873b21a7f06$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $c1b2aad30ed081d9$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));












var $fd8a5a4d27b95514$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $b79f45105f4fc5bf$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $365301764998b714$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $d288b29c63f12ba7$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $f189536e19579fc7$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $235c501771f8f2c8$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $8cf9037af5c80a6b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $e2c6ed9eece38c05$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));















function $9f415d9aa929cb5f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $1390979b933b1e35$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)((0, $9f415d9aa929cb5f$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));















function $c23fbe21a3e9d7ec$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $51ad9c3a7ea45056$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $365301764998b714$export$2e2bcd8739ae039)((0, $c23fbe21a3e9d7ec$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $e79adff529ff7d87$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $df3cfb3868b5f2d9$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));













function $dad70b9d49228da0$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $59f2ba411bffa594$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $9fa34d129085f38e$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $10ea24d6b77d76b5$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));













function $782a867d325da60d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $9fafc31a4201a6f4$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $782a867d325da60d$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $f000735938cd3f06$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $a786258bf503f7be$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $08b08c6d5753cdfd$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $4b936300b1515974$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $fd3b98057917a9cb$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $50f15d1a322aa483$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $1f44a4cabb386e21$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $90a17725cd6a5e78$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $5849ee64b8145759$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $ad67721c76585871$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $f1ec95a2e92c6a8e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));











var $9f4e851982e313bd$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $d1d76f4ee5cb7969$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));










var $e4fe9dee5db1b18a$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));


var $a9a09c5462def3d7$export$19131010e7fd8373 = {
    G: new (0, $453e127a2cb59433$export$8e5a1d3f85a9688)(),
    y: new (0, $c1b2aad30ed081d9$export$48d352de7cd4a988)(),
    Y: new (0, $fd8a5a4d27b95514$export$b8ef38dfcf05d5db)(),
    R: new (0, $b79f45105f4fc5bf$export$951d1df011fde06f)(),
    u: new (0, $d288b29c63f12ba7$export$bad9d2ea38e8f1a)(),
    Q: new (0, $f189536e19579fc7$export$5cb0f701186dde1d)(),
    q: new (0, $235c501771f8f2c8$export$300c0c2990e20e6d)(),
    M: new (0, $8cf9037af5c80a6b$export$400dd8b40ef138a3)(),
    L: new (0, $e2c6ed9eece38c05$export$1d7eaa53eaa5deba)(),
    w: new (0, $1390979b933b1e35$export$c4005ffc174e07c0)(),
    I: new (0, $51ad9c3a7ea45056$export$6fc8dbedd560a6af)(),
    d: new (0, $e79adff529ff7d87$export$e8d4b28a20981dd2)(),
    D: new (0, $df3cfb3868b5f2d9$export$6cfe0d613455f615)(),
    E: new (0, $59f2ba411bffa594$export$1b03c8b76262f7bd)(),
    e: new (0, $9fa34d129085f38e$export$44d1c127ab42c480)(),
    c: new (0, $10ea24d6b77d76b5$export$e447a647caaaec1d)(),
    i: new (0, $9fafc31a4201a6f4$export$693fb1e525095b2a)(),
    a: new (0, $f000735938cd3f06$export$8d1e08492351df91)(),
    b: new (0, $a786258bf503f7be$export$73ca2bd0a17d273)(),
    B: new (0, $08b08c6d5753cdfd$export$bb9212adf05373db)(),
    h: new (0, $4b936300b1515974$export$8a04050a727a1756)(),
    H: new (0, $fd3b98057917a9cb$export$e56f4dea2c3e56dd)(),
    K: new (0, $50f15d1a322aa483$export$cbbe855312f87d77)(),
    k: new (0, $1f44a4cabb386e21$export$6008046d2b34b6a5)(),
    m: new (0, $90a17725cd6a5e78$export$2b52670d9e2be53)(),
    s: new (0, $5849ee64b8145759$export$94d46d540cf1366a)(),
    S: new (0, $ad67721c76585871$export$b8e6f8b2d70893b1)(),
    X: new (0, $f1ec95a2e92c6a8e$export$104d901d49fea29b)(),
    x: new (0, $9f4e851982e313bd$export$12910e5204b52b9)(),
    t: new (0, $d1d76f4ee5cb7969$export$2cd8bf877a05e96)(),
    T: new (0, $e4fe9dee5db1b18a$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e23ab16419322690$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e23ab16419322690$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e23ab16419322690$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e23ab16419322690$var$doubleQuoteRegExp = /''/g;
var $e23ab16419322690$var$notWhitespaceRegExp = /\S/;
var $e23ab16419322690$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e23ab16419322690$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($e23ab16419322690$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $eeef144218f64d7d$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e23ab16419322690$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $a9a09c5462def3d7$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($e23ab16419322690$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $e23ab16419322690$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $e23ab16419322690$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(date, (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6f0e75fc27c44afd$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $e23ab16419322690$var$cleanEscapedString(input) {
    return input.match($e23ab16419322690$var$escapedStringRegExp)[1].replace($e23ab16419322690$var$doubleQuoteRegExp, "'");
}





function $4918c57fb0877934$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}





function $ee39c98c5378a0a6$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $bdc3656b920d564d$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $5d7226012cddb1a9$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $1ba80981c4aaa361$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $88db1f07d3462e3c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $817a8c16f80f6cf9$export$2e2bcd8739ae039(dirtyDate, dirtyMilliseconds) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}





function $ae8d0a047d9558ed$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $e8b720dd7751e2f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}






function $eb08625b8e4078ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}





function $15a89f5e74b8913f$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $15a89f5e74b8913f$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $15a89f5e74b8913f$var$parseYear(dateStrings.date, additionalDigits);
        date = $15a89f5e74b8913f$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $15a89f5e74b8913f$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $15a89f5e74b8913f$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $15a89f5e74b8913f$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $15a89f5e74b8913f$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $15a89f5e74b8913f$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $15a89f5e74b8913f$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $15a89f5e74b8913f$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($15a89f5e74b8913f$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($15a89f5e74b8913f$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($15a89f5e74b8913f$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $15a89f5e74b8913f$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $15a89f5e74b8913f$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $15a89f5e74b8913f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($15a89f5e74b8913f$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $15a89f5e74b8913f$var$parseDateUnit(captures[1]);
    var month = $15a89f5e74b8913f$var$parseDateUnit(captures[2]) - 1;
    var day = $15a89f5e74b8913f$var$parseDateUnit(captures[3]);
    var week = $15a89f5e74b8913f$var$parseDateUnit(captures[4]);
    var dayOfWeek = $15a89f5e74b8913f$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$15a89f5e74b8913f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $15a89f5e74b8913f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$15a89f5e74b8913f$var$validateDate(year, month, day) || !$15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $15a89f5e74b8913f$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $15a89f5e74b8913f$var$parseTime(timeString) {
    var captures = timeString.match($15a89f5e74b8913f$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $15a89f5e74b8913f$var$parseTimeUnit(captures[1]);
    var minutes = $15a89f5e74b8913f$var$parseTimeUnit(captures[2]);
    var seconds = $15a89f5e74b8913f$var$parseTimeUnit(captures[3]);
    if (!$15a89f5e74b8913f$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff) + seconds * 1000;
}
function $15a89f5e74b8913f$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $15a89f5e74b8913f$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($15a89f5e74b8913f$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$15a89f5e74b8913f$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff));
}
function $15a89f5e74b8913f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $15a89f5e74b8913f$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $15a89f5e74b8913f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $15a89f5e74b8913f$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($15a89f5e74b8913f$var$daysInMonths[month] || ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 29 : 28));
}
function $15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 366 : 365);
}
function $15a89f5e74b8913f$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $15a89f5e74b8913f$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $15a89f5e74b8913f$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}





function $36d38c5e1565f0a6$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}




function $bbcd414b3c303484$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}



var $807e5074bec33cce$exports = {};
"use strict";
Object.defineProperty($807e5074bec33cce$exports, "__esModule", {
    value: true
});
$807e5074bec33cce$exports.default = void 0;
var $807e5074bec33cce$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $807e5074bec33cce$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $807e5074bec33cce$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $807e5074bec33cce$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $807e5074bec33cce$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $807e5074bec33cce$var$timeLongFormatter(timePattern, formatLong));
};
var $807e5074bec33cce$var$longFormatters = {
    p: $807e5074bec33cce$var$timeLongFormatter,
    P: $807e5074bec33cce$var$dateTimeLongFormatter
};
var $807e5074bec33cce$var$_default = $807e5074bec33cce$var$longFormatters;
$807e5074bec33cce$exports.default = $807e5074bec33cce$var$_default;
$807e5074bec33cce$exports = $807e5074bec33cce$exports.default;



/* eslint-disable class-methods-use-this */ const $d1c974ca6fc325ae$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $d1c974ca6fc325ae$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    fullDateWithWeekday: 'PPPP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    monthAndYear: 'LLLL yyyy',
    monthAndDate: 'MMMM d',
    fullTime: 'p',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    fullDateTime: 'PP p',
    fullDateTime12h: 'PP hh:mm aa',
    fullDateTime24h: 'PP HH:mm',
    keyboardDateTime: 'P p',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
class $d1c974ca6fc325ae$export$e330e9acbbe873f1 {
    constructor(props){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = 'date-fns';
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = $d1c974ca6fc325ae$var$formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.longFormatters = void 0;
        this.date = (value)=>{
            if (typeof value === 'undefined') return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.dateWithTimezone = (value)=>{
            return this.date(value);
        };
        this.getTimezone = ()=>{
            return 'default';
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.getCurrentLocaleCode = ()=>{
            var _this$locale;
            return ((_this$locale = this.locale) == null ? void 0 : _this$locale.code) || 'en-US';
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            if (this.locale) return /a/.test(this.locale.formatLong.time({
                width: 'short'
            }));
            // By default, date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === 'p' || firstCharacter === 'P') {
                    const longFormatter = this.longFormatters[firstCharacter];
                    return longFormatter(token, this.locale.formatLong);
                }
                return token;
            }).join('');
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, '(a|p)m').toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === 'am' ? 'AM' : 'PM';
        };
        const { locale: locale, formats: formats, longFormatters: longFormatters } = props;
        this.locale = locale;
        this.formats = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $d1c974ca6fc325ae$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
    }
}


class $082dc3e11d5a517d$export$81f56c0329a1921d extends (0, $d1c974ca6fc325ae$export$e330e9acbbe873f1) {
    constructor({ locale: locale, formats: formats } = {}){
        if (typeof (0, $bad15b7880e6f97c$export$2e2bcd8739ae039) !== 'function') throw new Error([
            'MUI: The `date-fns` package v3.x is not compatible with this adapter.',
            'Please, install v2.x of the package or use the `AdapterDateFnsV3` instead.'
        ].join('\n'));
        super({
            locale: locale != null ? locale : (0, $fbb6af908147d006$export$2e2bcd8739ae039),
            formats: formats,
            longFormatters: (/*@__PURE__*/$parcel$interopDefault($807e5074bec33cce$exports))
        });
        this.parseISO = (isoString)=>{
            return (0, $15a89f5e74b8913f$export$2e2bcd8739ae039)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $36d38c5e1565f0a6$export$2e2bcd8739ae039)(value, {
                format: 'extended'
            });
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return (0, $e23ab16419322690$export$2e2bcd8739ae039)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.isValid = (value)=>{
            return (0, $374216e389d08fec$export$2e2bcd8739ae039)(this.date(value));
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(value, formatString, {
                locale: this.locale
            });
        };
        this.getDiff = (value, comparing, unit)=>{
            switch(unit){
                case 'years':
                    return (0, $3a4e06016f5a1c64$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'quarters':
                    return (0, $94905b8ecb1c8a63$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'months':
                    return (0, $f6da14512b9613dc$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'weeks':
                    return (0, $a282d77fbef9d903$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'days':
                    return (0, $fcb7abc0fe52d209$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'hours':
                    return (0, $8fffbc588a798f57$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'minutes':
                    return (0, $9a7a827aa3d7f832$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'seconds':
                    return (0, $3976f91395cc9929$export$2e2bcd8739ae039)(value, this.date(comparing));
                default:
                    return (0, $656b09e1b179d990$export$2e2bcd8739ae039)(value, this.date(comparing));
            }
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return (0, $0659d9ec4d7dbbf0$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $f3df37b4dec5127a$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $61980f1dae65c9e0$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $849043f97da8598e$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $8b16156dc6f0bfd4$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, $bbcd414b3c303484$export$2e2bcd8739ae039)(value, {
                start: start,
                end: end
            });
        };
        this.startOfYear = (value)=>{
            return (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, $3b831424db570743$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, $ef64b5b7aae137f5$export$2e2bcd8739ae039)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, $d58247d27eb0dbf7$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, $6d59b3906efd21bf$export$2e2bcd8739ae039)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, $5956604521ea0197$export$2e2bcd8739ae039)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, $88155eb6456a8ca8$export$2e2bcd8739ae039)(value);
        };
        this.getMonth = (value)=>{
            return (0, $3e6008e0d859cbde$export$2e2bcd8739ae039)(value);
        };
        this.getDate = (value)=>{
            return (0, $4b40f36c6c4e8120$export$2e2bcd8739ae039)(value);
        };
        this.getHours = (value)=>{
            return (0, $d0f608c42e15b075$export$2e2bcd8739ae039)(value);
        };
        this.getMinutes = (value)=>{
            return (0, $6c0ddf6f2e376b6f$export$2e2bcd8739ae039)(value);
        };
        this.getSeconds = (value)=>{
            return (0, $128ac71efb3a2f51$export$2e2bcd8739ae039)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, $93c944119040e143$export$2e2bcd8739ae039)(value);
        };
        this.setYear = (value, year)=>{
            return (0, $ae8d0a047d9558ed$export$2e2bcd8739ae039)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, $5d7226012cddb1a9$export$2e2bcd8739ae039)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, $4918c57fb0877934$export$2e2bcd8739ae039)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, $ee39c98c5378a0a6$export$2e2bcd8739ae039)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, $bdc3656b920d564d$export$2e2bcd8739ae039)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, $88db1f07d3462e3c$export$2e2bcd8739ae039)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, $817a8c16f80f6cf9$export$2e2bcd8739ae039)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, $1ba80981c4aaa361$export$2e2bcd8739ae039)(value);
        };
        this.getNextMonth = (value)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(value);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return this.setSeconds(this.setMinutes(this.setHours(dateParam, this.getHours(timeParam)), this.getMinutes(timeParam)), this.getSeconds(timeParam));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $ce8f943b2f1f7b6a$export$2e2bcd8739ae039)({
                start: (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                }),
                end: (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, 'EEEEEE'));
        };
        this.getWeekArray = (value)=>{
            const start = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)((0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            const end = (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)((0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, $e77bd7a0f5da8fd6$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(start);
            const endDate = (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(end);
            const years = [];
            let current = startDate;
            while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, endDate)){
                years.push(current);
                current = (0, $3b831424db570743$export$2e2bcd8739ae039)(current, 1);
            }
            return years;
        };
    }
}


var $15c11b5d985bbfec$exports = {};

$parcel$export($15c11b5d985bbfec$exports, "input", function () { return $15c11b5d985bbfec$export$b7e3ae3d7c15e42e; }, function (v) { return $15c11b5d985bbfec$export$b7e3ae3d7c15e42e = v; });
var $15c11b5d985bbfec$export$b7e3ae3d7c15e42e;
$15c11b5d985bbfec$export$b7e3ae3d7c15e42e = `M5DVUW_input`;



var $gSkQi = parcelRequire("gSkQi");
const $513dd6ab73816bf5$export$34dc4cfa15ead1 = ({ className: className, value: value, onChange: onChange, format: format, views: views, disabled: disabled })=>{
    const [isDatePickerOpen, setIsDatePickerOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
        localeText: (0, $37bec70ed65ed924$export$21c51bc433c16634).datePickerLocale.components.MuiLocalizationProvider.defaultProps.localeText,
        dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
        adapterLocale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $080f12ab26da8443$export$97b476d7a92fee62), {
            slotProps: {
                actionBar: {
                    actions: [
                        "clear"
                    ]
                }
            },
            format: format ?? "d MMMM yyyy",
            views: views,
            value: value,
            onChange: onChange,
            open: isDatePickerOpen,
            minDate: new Date((0, $37bec70ed65ed924$export$21c51bc433c16634).minDate),
            onClose: ()=>setIsDatePickerOpen(false),
            closeOnSelect: true,
            slots: {
                textField: (params)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                        ...(0, $gSkQi.omit)(params, "onChange", "onError"),
                        className: className,
                        placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).date_missing,
                        variant: "outlined",
                        disabled: disabled,
                        sx: {
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "12px !important",
                            transition: "0.3s all",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.05)"
                            },
                            height: "40px"
                        },
                        onMouseDown: ()=>setIsDatePickerOpen(true),
                        inputProps: {
                            ...params.inputProps,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($15c11b5d985bbfec$exports))).input,
                            style: {
                                paddingTop: 9,
                                paddingBottom: 9,
                                borderRadius: "12px !important"
                            }
                        }
                    })
            }
        })
    });
};

















var $006388a94aa86c69$exports = {};
$006388a94aa86c69$exports = $parcel$resolve("1JVAr");


const $e7c5283b289d928b$export$f29aea8421c4a82e = ({ open: open, onClose: onClose, artist: artist, originalImageData: originalImageData, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = artist ? (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_new_title;
    const { addArtist: addArtist } = (0, $d33ea69830864955$export$ee674ce169687584)();
    const { modifyArtist: modifyArtist } = (0, $ed4ed0b16377f25f$export$1710ab8e93c3f538)();
    const { deleteArtist: deleteArtist } = (0, $cdde9272dcb8820b$export$9a4e28413d5e7fe8)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [isModifyProfileDialogOpen, setIsModifyProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const genericImage = new URL($006388a94aa86c69$exports).href;
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).ma_missing_error),
        birthDate: $57e52f3b537dfd4b$export$324d90190a8b822a(),
        deathDate: $57e52f3b537dfd4b$export$324d90190a8b822a()
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: artist?.name ?? "",
            realName: artist?.realName ?? "",
            website: artist?.website ?? "",
            discogsId: artist?.discogsArtistId ?? "",
            birthDate: artist?.birthDate ? new Date(artist.birthDate * 1000) : undefined,
            deathDate: artist?.deathDate ? new Date(artist.deathDate * 1000) : undefined,
            profile: artist?.profile ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, realName: realName, website: website, discogsId: discogsId, birthDate: birthDate, deathDate: deathDate, profile: profile })=>{
            setIsLoading(true);
            const birthDateNumber = birthDate ? birthDate.getTime() / 1000 : undefined;
            const deathDateNumber = deathDate ? deathDate.getTime() / 1000 : undefined;
            if (artist) {
                const { status: status, body: body } = await modifyArtist({
                    uuid: artist.uuid,
                    name: name,
                    realName: realName,
                    website: website,
                    discogsArtistId: discogsId,
                    birthDate: birthDateNumber,
                    deathDate: deathDateNumber,
                    hasImage: artist.hasImage,
                    profile: profile
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_artist_action", {
                        isNew: false
                    });
                    if (didChangeImage && imageFile && artist.uuid) {
                        const newThumbnail = await uploadImage({
                            name: artist.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addArtist({
                    name: name,
                    realName: realName,
                    website: website,
                    discogsArtistId: discogsId,
                    birthDate: birthDateNumber,
                    deathDate: deathDateNumber,
                    profile: profile
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_artist_action", {
                        isNew: true
                    });
                    if (didChangeImage && imageFile && body.uuid) {
                        const newThumbnail = await uploadImage({
                            name: body.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!artist) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteArtist({
            uuid: artist.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(artist);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setImageFile(undefined);
        setDidChangeImage(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            artist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_image_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).dropzone,
                                                onImageChanged: (file)=>{
                                                    setImageFile(file);
                                                    setDidChangeImage(true);
                                                },
                                                placeholderImage: genericImage,
                                                initialImage: originalImageData ? `data:image/png;base64,${originalImageData}` : artist?.thumbnail ? `data:image/png;base64,${artist.thumbnail}` : undefined,
                                                isLoading: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_name_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "name",
                                                    name: "name",
                                                    size: "small",
                                                    autoFocus: !isMobile,
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_name_placeholder,
                                                    value: formik.values.name,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_real_name_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "realName",
                                                    name: "realName",
                                                    size: "small",
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_real_name_placeholder,
                                                    value: formik.values.realName,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "website",
                                                    name: "website",
                                                    size: "small",
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_placeholder,
                                                    value: formik.values.website,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "discogsId",
                                                    name: "discogsId",
                                                    size: "small",
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_placeholder,
                                                    value: formik.values.discogsId,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                sx: {
                                    marginBottom: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_birth_date_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_birth_date_title,
                                                value: formik.values.birthDate ?? null,
                                                onChange: (newValue)=>formik.setFieldValue("birthDate", newValue)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_death_date_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_death_date_title,
                                                value: formik.values.deathDate ?? null,
                                                onChange: (newValue)=>formik.setFieldValue("deathDate", newValue)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5439746b6e17b6b4$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.profile ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyProfileDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_profile_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                value: formik.values.profile,
                open: isModifyProfileDialogOpen,
                onClose: ()=>setIsModifyProfileDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("profile", newValue),
                onClearValue: ()=>formik.setFieldValue("profile", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ARTISTS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};



var $67e609bcc0295b55$exports = {};

$parcel$export($67e609bcc0295b55$exports, "container", function () { return $67e609bcc0295b55$export$34e0f9847d4c02dd; }, function (v) { return $67e609bcc0295b55$export$34e0f9847d4c02dd = v; });
$parcel$export($67e609bcc0295b55$exports, "hoverButton", function () { return $67e609bcc0295b55$export$b0260c0afbf48c57; }, function (v) { return $67e609bcc0295b55$export$b0260c0afbf48c57 = v; });
$parcel$export($67e609bcc0295b55$exports, "hoverButtonsStack", function () { return $67e609bcc0295b55$export$a8eacba2c33c9f28; }, function (v) { return $67e609bcc0295b55$export$a8eacba2c33c9f28 = v; });
$parcel$export($67e609bcc0295b55$exports, "image", function () { return $67e609bcc0295b55$export$5c452ff88e35e47d; }, function (v) { return $67e609bcc0295b55$export$5c452ff88e35e47d = v; });
$parcel$export($67e609bcc0295b55$exports, "lazyImage", function () { return $67e609bcc0295b55$export$8a4fd0bcc66a2da1; }, function (v) { return $67e609bcc0295b55$export$8a4fd0bcc66a2da1 = v; });
$parcel$export($67e609bcc0295b55$exports, "name", function () { return $67e609bcc0295b55$export$a8ff84c12d48cfa6; }, function (v) { return $67e609bcc0295b55$export$a8ff84c12d48cfa6 = v; });
$parcel$export($67e609bcc0295b55$exports, "profile", function () { return $67e609bcc0295b55$export$4882ae973e0491e; }, function (v) { return $67e609bcc0295b55$export$4882ae973e0491e = v; });
$parcel$export($67e609bcc0295b55$exports, "rightContainer", function () { return $67e609bcc0295b55$export$3280a108d7f81d56; }, function (v) { return $67e609bcc0295b55$export$3280a108d7f81d56 = v; });
$parcel$export($67e609bcc0295b55$exports, "years", function () { return $67e609bcc0295b55$export$6fda41c7fb23acf9; }, function (v) { return $67e609bcc0295b55$export$6fda41c7fb23acf9 = v; });
var $67e609bcc0295b55$export$34e0f9847d4c02dd;
var $67e609bcc0295b55$export$b0260c0afbf48c57;
var $67e609bcc0295b55$export$a8eacba2c33c9f28;
var $67e609bcc0295b55$export$5c452ff88e35e47d;
var $67e609bcc0295b55$export$8a4fd0bcc66a2da1;
var $67e609bcc0295b55$export$a8ff84c12d48cfa6;
var $67e609bcc0295b55$export$4882ae973e0491e;
var $67e609bcc0295b55$export$3280a108d7f81d56;
var $67e609bcc0295b55$export$6fda41c7fb23acf9;
$67e609bcc0295b55$export$34e0f9847d4c02dd = `BsYVza_container`;
$67e609bcc0295b55$export$b0260c0afbf48c57 = `BsYVza_hoverButton`;
$67e609bcc0295b55$export$a8eacba2c33c9f28 = `BsYVza_hoverButtonsStack`;
$67e609bcc0295b55$export$5c452ff88e35e47d = `BsYVza_image`;
$67e609bcc0295b55$export$8a4fd0bcc66a2da1 = `BsYVza_lazyImage`;
$67e609bcc0295b55$export$a8ff84c12d48cfa6 = `BsYVza_name`;
$67e609bcc0295b55$export$4882ae973e0491e = `BsYVza_profile`;
$67e609bcc0295b55$export$3280a108d7f81d56 = `BsYVza_rightContainer`;
$67e609bcc0295b55$export$6fda41c7fb23acf9 = `BsYVza_years`;



var $7fPBF = parcelRequire("7fPBF");





const $5565eb1c8b78ac24$export$166ad33fd6bf82b1 = {
    getDatesString: (artist, monthStyle)=>{
        let birthDateString = undefined;
        let deathDateString = undefined;
        const formatter = new Intl.DateTimeFormat((0, $37bec70ed65ed924$export$21c51bc433c16634).locale, {
            day: "numeric",
            month: monthStyle,
            year: "numeric"
        });
        if (artist.birthDate) {
            const birthDate = new Date(artist.birthDate * 1000);
            birthDateString = formatter.format(birthDate);
        }
        if (artist.deathDate) {
            const deathDate = new Date(artist.deathDate * 1000);
            deathDateString = formatter.format(deathDate);
        }
        if (birthDateString) {
            if (deathDateString) return `${birthDateString} - ${deathDateString}`;
            return birthDateString;
        }
        if (deathDateString) return deathDateString;
    }
};






const $5045a389be4ea4ad$export$16c3e13019c01108 = ({ artist: artist, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($006388a94aa86c69$exports).href;
    const fetchImage = async ()=>{
        if (!artist.hasImage) return;
        const response = await getImage({
            name: artist.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallArtistImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        artist.uuid,
        artist.hasImage,
        artist.thumbnail
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).container,
        sx: {
            height: 90
        },
        elevation: 5,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "row"
                },
                style: {
                    borderColor: theme.palette.colors?.highlightBorder,
                    borderWidth: 4,
                    borderStyle: selected ? "double" : "none"
                },
                onContextMenu: (event)=>onContextMenu(event, image),
                onClick: (event)=>onClick(event, image),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).image,
                        imageStyle: {
                            borderRadius: "16px"
                        },
                        image: image,
                        thumbnail: artist.thumbnail,
                        defaultImage: genericImage,
                        beforeLoad: fetchImage,
                        alt: artist.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).rightContainer,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).name,
                                children: artist.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).years,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: (0, $5565eb1c8b78ac24$export$166ad33fd6bf82b1).getDatesString(artist, "short")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).profile,
                                children: artist.profile
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($67e609bcc0295b55$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>onContextMenu(event, image),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");

var $3a56747010ccf6dd$exports = {};

$parcel$export($3a56747010ccf6dd$exports, "artistDates", function () { return $3a56747010ccf6dd$export$3f899b467dbac2d; }, function (v) { return $3a56747010ccf6dd$export$3f899b467dbac2d = v; });
$parcel$export($3a56747010ccf6dd$exports, "dialog", function () { return $3a56747010ccf6dd$export$518824cf31321346; }, function (v) { return $3a56747010ccf6dd$export$518824cf31321346 = v; });
$parcel$export($3a56747010ccf6dd$exports, "image", function () { return $3a56747010ccf6dd$export$5c452ff88e35e47d; }, function (v) { return $3a56747010ccf6dd$export$5c452ff88e35e47d = v; });
$parcel$export($3a56747010ccf6dd$exports, "loadingDiv", function () { return $3a56747010ccf6dd$export$dded2af20345efaa; }, function (v) { return $3a56747010ccf6dd$export$dded2af20345efaa = v; });
$parcel$export($3a56747010ccf6dd$exports, "profile", function () { return $3a56747010ccf6dd$export$4882ae973e0491e; }, function (v) { return $3a56747010ccf6dd$export$4882ae973e0491e = v; });
$parcel$export($3a56747010ccf6dd$exports, "realName", function () { return $3a56747010ccf6dd$export$6d354f2c918c5662; }, function (v) { return $3a56747010ccf6dd$export$6d354f2c918c5662 = v; });
$parcel$export($3a56747010ccf6dd$exports, "redirectButton", function () { return $3a56747010ccf6dd$export$1459b0652d8256be; }, function (v) { return $3a56747010ccf6dd$export$1459b0652d8256be = v; });
$parcel$export($3a56747010ccf6dd$exports, "redirectGridItem", function () { return $3a56747010ccf6dd$export$45fc42605641ab16; }, function (v) { return $3a56747010ccf6dd$export$45fc42605641ab16 = v; });
$parcel$export($3a56747010ccf6dd$exports, "title", function () { return $3a56747010ccf6dd$export$fb184b623420d9be; }, function (v) { return $3a56747010ccf6dd$export$fb184b623420d9be = v; });
var $3a56747010ccf6dd$export$3f899b467dbac2d;
var $3a56747010ccf6dd$export$518824cf31321346;
var $3a56747010ccf6dd$export$5c452ff88e35e47d;
var $3a56747010ccf6dd$export$dded2af20345efaa;
var $3a56747010ccf6dd$export$4882ae973e0491e;
var $3a56747010ccf6dd$export$6d354f2c918c5662;
var $3a56747010ccf6dd$export$1459b0652d8256be;
var $3a56747010ccf6dd$export$45fc42605641ab16;
var $3a56747010ccf6dd$export$fb184b623420d9be;
$3a56747010ccf6dd$export$3f899b467dbac2d = `cST6dq_artistDates`;
$3a56747010ccf6dd$export$518824cf31321346 = `cST6dq_dialog`;
$3a56747010ccf6dd$export$5c452ff88e35e47d = `cST6dq_image`;
$3a56747010ccf6dd$export$dded2af20345efaa = `cST6dq_loadingDiv`;
$3a56747010ccf6dd$export$4882ae973e0491e = `cST6dq_profile`;
$3a56747010ccf6dd$export$6d354f2c918c5662 = `cST6dq_realName`;
$3a56747010ccf6dd$export$1459b0652d8256be = `cST6dq_redirectButton`;
$3a56747010ccf6dd$export$45fc42605641ab16 = `cST6dq_redirectGridItem`;
$3a56747010ccf6dd$export$fb184b623420d9be = `cST6dq_title`;















const $cb1a3a955a9c7e25$export$8d5fcdbc93b146b5 = ({ artist: artist, isOpen: isOpen, onClose: onClose, canEdit: canEdit, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [myArtist, setMyArtist] = (0, $7fPBF.useState)(artist);
    const [image, setImage] = (0, $7fPBF.useState)();
    const [thumbnail, setThumbnail] = (0, $7fPBF.useState)(artist.thumbnail);
    const [modifyDialogState, setModifyDialogState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const genericImage = new URL($006388a94aa86c69$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        setThumbnail(myArtist.thumbnail);
        fetchImage().then();
    }, [
        myArtist.uuid,
        myArtist.hasImage,
        myArtist.thumbnail
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setMyArtist(artist);
    }, [
        artist
    ]);
    const currentArtistUuid = (0, $7fPBF.useRef)("");
    const fetchImage = async ()=>{
        currentArtistUuid.current = myArtist.uuid;
        setImage(undefined);
        if (!myArtist.hasImage) return;
        const response = await getImage({
            name: myArtist.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigArtistImageSize
        });
        // Discard image if artist changed
        if (currentArtistUuid.current != myArtist.uuid) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).dialog,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: myArtist.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        canEdit && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>setModifyDialogState({
                                    mode: "edit",
                                    item: myArtist
                                }),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_edit,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: onClose,
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                dividers: true,
                children: myArtist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: isMobile ? "column" : "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).image,
                                    style: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    image: image,
                                    imageStyle: {
                                        borderRadius: "6%"
                                    },
                                    thumbnail: thumbnail,
                                    defaultImage: genericImage,
                                    alt: myArtist.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    style: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).redirectGridItem,
                                            children: [
                                                myArtist.realName && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                    spacing: 0,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).title,
                                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_real_name_title
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).realName,
                                                            children: myArtist.realName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).artistDates,
                                                    children: (0, $5565eb1c8b78ac24$export$166ad33fd6bf82b1).getDatesString(myArtist, "long")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                            container: true,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: true,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).redirectGridItem,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).redirectButton,
                                                        disabled: myArtist.discogsArtistId?.length === 0,
                                                        href: `https://www.discogs.com/artist/${myArtist.discogsArtistId}`,
                                                        target: "_blank",
                                                        component: "a",
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_discogs
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: true,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).redirectGridItem,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).redirectButton,
                                                        disabled: !myArtist.website || myArtist.website.length === 0,
                                                        href: myArtist.website,
                                                        target: "_blank",
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_button_title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            flexGrow: 1
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3a56747010ccf6dd$exports))).profile,
                            children: myArtist.profile
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    sx: {
                        height: 200
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7c5283b289d928b$export$f29aea8421c4a82e), {
                open: modifyDialogState.mode !== "closed",
                onClose: ()=>setModifyDialogState({
                        mode: "closed",
                        item: modifyDialogState.item
                    }),
                artist: modifyDialogState.item,
                originalImageData: image,
                onModifiedItem: (newItem)=>{
                    onModifiedItem?.(newItem);
                    setMyArtist(newItem);
                },
                onDeletedItem: onDeletedItem
            }, modifyDialogState.item?.uuid)
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $3f335d07f462d28e$exports = {};

$parcel$export($3f335d07f462d28e$exports, "container", function () { return $3f335d07f462d28e$export$34e0f9847d4c02dd; }, function (v) { return $3f335d07f462d28e$export$34e0f9847d4c02dd = v; });
$parcel$export($3f335d07f462d28e$exports, "grid", function () { return $3f335d07f462d28e$export$85fc379452d91af0; }, function (v) { return $3f335d07f462d28e$export$85fc379452d91af0 = v; });
$parcel$export($3f335d07f462d28e$exports, "gridCard", function () { return $3f335d07f462d28e$export$338e99bce4214043; }, function (v) { return $3f335d07f462d28e$export$338e99bce4214043 = v; });
$parcel$export($3f335d07f462d28e$exports, "nameField", function () { return $3f335d07f462d28e$export$b6f1a49de680b8fc; }, function (v) { return $3f335d07f462d28e$export$b6f1a49de680b8fc = v; });
$parcel$export($3f335d07f462d28e$exports, "searchBar", function () { return $3f335d07f462d28e$export$f2ea4ab276c3e3fa; }, function (v) { return $3f335d07f462d28e$export$f2ea4ab276c3e3fa = v; });
$parcel$export($3f335d07f462d28e$exports, "toolbar", function () { return $3f335d07f462d28e$export$f727f52c778e92d5; }, function (v) { return $3f335d07f462d28e$export$f727f52c778e92d5 = v; });
$parcel$export($3f335d07f462d28e$exports, "toolbarButton", function () { return $3f335d07f462d28e$export$9c7d691958d83aa0; }, function (v) { return $3f335d07f462d28e$export$9c7d691958d83aa0 = v; });
var $3f335d07f462d28e$export$34e0f9847d4c02dd;
var $3f335d07f462d28e$export$85fc379452d91af0;
var $3f335d07f462d28e$export$338e99bce4214043;
var $3f335d07f462d28e$export$b6f1a49de680b8fc;
var $3f335d07f462d28e$export$f2ea4ab276c3e3fa;
var $3f335d07f462d28e$export$f727f52c778e92d5;
var $3f335d07f462d28e$export$9c7d691958d83aa0;
$3f335d07f462d28e$export$34e0f9847d4c02dd = `Kyl3zW_container`;
$3f335d07f462d28e$export$85fc379452d91af0 = `Kyl3zW_grid`;
$3f335d07f462d28e$export$338e99bce4214043 = `Kyl3zW_gridCard`;
$3f335d07f462d28e$export$b6f1a49de680b8fc = `Kyl3zW_nameField`;
$3f335d07f462d28e$export$f2ea4ab276c3e3fa = `Kyl3zW_searchBar`;
$3f335d07f462d28e$export$f727f52c778e92d5 = `Kyl3zW_toolbar`;
$3f335d07f462d28e$export$9c7d691958d83aa0 = `Kyl3zW_toolbarButton`;









const $405aa383e1a6b7c5$export$bcf6a3aec37d1871 = ({ isPublic: isPublic, items: items, emptyIconType: emptyIconType, emptyString: emptyString, addItemString: addItemString, title: title, loading: loading, setLoading: setLoading, onSearchRequested: onSearchRequested, addAction: addAction, refreshAction: refreshAction, handleClose: handleClose, extraToolbarItems: extraToolbarItems, onClearValue: onClearValue, timed: timed, children: children })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)();
    const searchBar = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($3f335d07f462d28e$exports))).searchBar,
            style: {
                marginBottom: isMobile ? 12 : 0,
                marginLeft: isMobile ? 0 : 12
            },
            onSearchRequested: (text)=>{
                onSearchRequested(text);
                setSearchText(text);
            },
            onSearchDismissed: ()=>{
                onSearchRequested("");
                setSearchText(undefined);
            },
            timed: timed ?? false,
            minimumSearchLength: 0,
            autoFocus: !isMobile
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3f335d07f462d28e$exports))).container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3f335d07f462d28e$exports))).toolbar,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    style: {
                                        color: theme.palette.primary.main,
                                        flexShrink: 0
                                    },
                                    children: title
                                }),
                                !isMobile && searchBar(),
                                !isPublic && addAction && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    onClick: addAction,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                                }),
                                refreshAction && !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    onClick: ()=>{
                                        setLoading(true);
                                        refreshAction();
                                    },
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).refresh_list,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Refresh
                                }),
                                extraToolbarItems,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    sx: {
                                        flexGrow: 1
                                    }
                                }),
                                onClearValue && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    onClick: onClearValue,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_value,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                    color: theme.palette.colors?.remove
                                }),
                                (loading || handleClose) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    loading: loading,
                                    onClick: handleClose,
                                    tooltip: loading ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                })
                            ]
                        }),
                        isMobile && searchBar()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3f335d07f462d28e$exports))).gridCard,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: loading,
                        items: items,
                        emptyIconType: emptyIconType,
                        emptyTitle: emptyString,
                        emptyDescription: isPublic ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_attribute_description,
                        searchText: searchText,
                        addButtonTitle: addItemString,
                        onAddItem: addAction,
                        canAdd: !isPublic
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3f335d07f462d28e$exports))).grid,
                        children: children
                    })
                ]
            })
        ]
    });
};




var $ab7cff841afa1f1e$exports = {};

$parcel$export($ab7cff841afa1f1e$exports, "skeleton", function () { return $ab7cff841afa1f1e$export$2a0674ff2eb10214; }, function (v) { return $ab7cff841afa1f1e$export$2a0674ff2eb10214 = v; });
var $ab7cff841afa1f1e$export$2a0674ff2eb10214;
$ab7cff841afa1f1e$export$2a0674ff2eb10214 = `q8vRBG_skeleton`;




var $7fPBF = parcelRequire("7fPBF");
var $f76d3d95118008f0$exports = {};

$parcel$export($f76d3d95118008f0$exports, "listCard", function () { return $f76d3d95118008f0$export$d55f2978079ed3d7; }, function (v) { return $f76d3d95118008f0$export$d55f2978079ed3d7 = v; });
$parcel$export($f76d3d95118008f0$exports, "listCardWide", function () { return $f76d3d95118008f0$export$1635b972082ecfec; }, function (v) { return $f76d3d95118008f0$export$1635b972082ecfec = v; });
$parcel$export($f76d3d95118008f0$exports, "listItem", function () { return $f76d3d95118008f0$export$76c7e83ecc9cdf05; }, function (v) { return $f76d3d95118008f0$export$76c7e83ecc9cdf05 = v; });
$parcel$export($f76d3d95118008f0$exports, "mainList", function () { return $f76d3d95118008f0$export$21810f025a8548aa; }, function (v) { return $f76d3d95118008f0$export$21810f025a8548aa = v; });
$parcel$export($f76d3d95118008f0$exports, "title", function () { return $f76d3d95118008f0$export$fb184b623420d9be; }, function (v) { return $f76d3d95118008f0$export$fb184b623420d9be = v; });
var $f76d3d95118008f0$export$d55f2978079ed3d7;
var $f76d3d95118008f0$export$1635b972082ecfec;
var $f76d3d95118008f0$export$76c7e83ecc9cdf05;
var $f76d3d95118008f0$export$21810f025a8548aa;
var $f76d3d95118008f0$export$fb184b623420d9be;
$f76d3d95118008f0$export$d55f2978079ed3d7 = `_9QbjSG_listCard`;
$f76d3d95118008f0$export$1635b972082ecfec = `_9QbjSG_listCardWide`;
$f76d3d95118008f0$export$76c7e83ecc9cdf05 = `_9QbjSG_listItem`;
$f76d3d95118008f0$export$21810f025a8548aa = `_9QbjSG_mainList`;
$f76d3d95118008f0$export$fb184b623420d9be = `_9QbjSG_title`;







const $aca3ef2e377cd341$export$f632a70b7942a9ca = ({ onAttributeSelected: onAttributeSelected })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [selectedAttributeType, setSelectedAttributeType] = (0, $7fPBF.useState)();
    const attributes = [
        [
            0,
            2,
            6,
            7,
            11,
            10,
            1
        ],
        [
            5,
            9
        ],
        [
            3,
            4,
            8
        ]
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        disablePadding: true,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f76d3d95118008f0$exports))).mainList,
        sx: {
            backgroundColor: theme.palette.background.default
        },
        children: attributes.map((section, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($f76d3d95118008f0$exports))).listCard : (0, (/*@__PURE__*/$parcel$interopDefault($f76d3d95118008f0$exports))).listCardWide,
                children: section.map((attributeType, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f76d3d95118008f0$exports))).listItem,
                                selected: selectedAttributeType == attributeType,
                                onClick: ()=>{
                                    setSelectedAttributeType(attributeType);
                                    onAttributeSelected(attributeType);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $b62e530123cc4921$export$99fb0c285980a809)[attributeType]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f76d3d95118008f0$exports))).title,
                                        primary: (0, $b62e530123cc4921$export$465c3b2548d10f1a).getAttributeTitle(attributeType),
                                        sx: {
                                            color: theme.palette.primary.main
                                        }
                                    })
                                ]
                            }),
                            index + 1 < section.length && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                        ]
                    }, attributeType.valueOf()))
            }, index))
    });
};
var $aca3ef2e377cd341$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType[AttributeType["ARTISTS"] = 0] = "ARTISTS";
    AttributeType[AttributeType["STORES"] = 1] = "STORES";
    AttributeType[AttributeType["LABELS"] = 2] = "LABELS";
    AttributeType[AttributeType["SLEEVE_GRADES"] = 3] = "SLEEVE_GRADES";
    AttributeType[AttributeType["MEDIA_GRADES"] = 4] = "MEDIA_GRADES";
    AttributeType[AttributeType["SELL_VALUES"] = 5] = "SELL_VALUES";
    AttributeType[AttributeType["ALBUM_FORMATS"] = 6] = "ALBUM_FORMATS";
    AttributeType[AttributeType["ALBUM_TYPES"] = 7] = "ALBUM_TYPES";
    AttributeType[AttributeType["IMPACTS"] = 8] = "IMPACTS";
    AttributeType[AttributeType["EXCHANGE_RATES"] = 9] = "EXCHANGE_RATES";
    AttributeType[AttributeType["TAGS"] = 10] = "TAGS";
    AttributeType[AttributeType["ORIGIN_COUNTRIES"] = 11] = "ORIGIN_COUNTRIES";
    AttributeType[AttributeType["GEAR_ITEMS"] = 12] = "GEAR_ITEMS";
    AttributeType[AttributeType["EQUIPMENTS"] = 13] = "EQUIPMENTS";
    return AttributeType;
}({});




const $b62e530123cc4921$export$465c3b2548d10f1a = {
    getAttributeTitle: (attributeType)=>{
        switch(attributeType){
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ARTISTS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_artists_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).STORES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_stores_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).LABELS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_labels_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_FORMATS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_formats_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_TYPES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_types_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SLEEVE_GRADES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sleeve_grades_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).MEDIA_GRADES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_media_grades_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SELL_VALUES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sell_values_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).IMPACTS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_impacts_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EXCHANGE_RATES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_exchange_rates_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).TAGS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_countries_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).GEAR_ITEMS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_items_title;
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EQUIPMENTS:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).equipments_title;
        }
    },
    getGoldmineGradePoints: (points)=>{
        return points <= 10 ? points : (0, $37bec70ed65ed924$export$21c51bc433c16634).mint;
    }
};
const $b62e530123cc4921$export$99fb0c285980a809 = {
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ARTISTS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Artist,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).LABELS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MusicCast,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_FORMATS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ControlCamera,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_TYPES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Album,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SLEEVE_GRADES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CheckBox,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).MEDIA_GRADES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CheckCircle,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).STORES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Store,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SELL_VALUES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PriceChange,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).IMPACTS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Star,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EXCHANGE_RATES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CurrencyExchange,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).TAGS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Sell,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Flag,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).GEAR_ITEMS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AudioVideoReceiver,
    [(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EQUIPMENTS]: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).SpeakerGroup
};





const $d963a2e56ac79bd1$export$c45b630b80b4cbe8 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onArtistSelected: onArtistSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [artists, resetArtists, setArtists, noMoreArtists] = (0, $4b08d405fec2c9eb$export$15a65656f8532587)(isPublic, setLoading);
    const filteredArtists = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return artists;
        return artists?.filter((artist)=>{
            return artist.name.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        artists,
        searchText
    ]);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const { state: artistDialogState, key: artistDialogKey, openEdit: openArtistDialog, close: closeArtistDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [artistImageData, setArtistImageData] = (0, $7fPBF.useState)();
    const [contextArtist, setContextArtist] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const onModifiedArtist = (newArtist)=>{
        const newArtists = artists.map((artist)=>artist.uuid === newArtist.uuid ? newArtist : artist);
        newArtists.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                ignorePunctuation: true
            }));
        setArtists(newArtists);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    const onDeletedArtist = (deletedArtist)=>{
        const newArtists = artists.filter((artist)=>artist.uuid !== deletedArtist.uuid);
        setArtists(newArtists);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredArtists,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ARTISTS],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_artists_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_artists,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_artists_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: ()=>{
            setArtistImageData(undefined);
            openAdd();
        },
        refreshAction: resetArtists,
        onClearValue: onClearValue,
        children: [
            filteredArtists?.map((artist)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5045a389be4ea4ad$export$16c3e13019c01108), {
                        artist: artist,
                        selected: preselectedId == artist.uuid,
                        onClick: async (_event, imageData)=>{
                            setArtistImageData(imageData);
                            if (onArtistSelected) onArtistSelected(artist);
                            else openEdit(artist);
                        },
                        onContextMenu: async (event, imageData)=>{
                            setArtistImageData(imageData);
                            setContextArtist(artist);
                            handleContextMenu(event);
                        }
                    })
                }, artist.uuid)),
            (loading || !noMoreArtists) && Array.from({
                length: 20
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 90
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ab7cff841afa1f1e$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7c5283b289d928b$export$f29aea8421c4a82e), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                artist: modifyDialogState.item,
                originalImageData: artistImageData,
                onNewItem: (newArtist)=>{
                    const newArtists = [
                        ...artists,
                        newArtist
                    ];
                    newArtists.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setArtists(newArtists);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: onModifiedArtist,
                onDeletedItem: onDeletedArtist
            }, modifyDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openArtistDialog(contextArtist);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_view
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openEdit(contextArtist);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_edit
                        ]
                    })
                ]
            }),
            artistDialogState.item && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1a3a955a9c7e25$export$8d5fcdbc93b146b5), {
                artist: artistDialogState.item,
                isOpen: artistDialogState.mode !== "closed",
                onClose: closeArtistDialog,
                canEdit: true,
                onModifiedItem: onModifiedArtist,
                onDeletedItem: (deletedArtist)=>{
                    closeArtistDialog();
                    onDeletedArtist(deletedArtist);
                }
            }, artistDialogKey)
        ]
    });
};













parcelRequire("7fPBF");
var $813f804f350c3128$exports = {};

$parcel$export($813f804f350c3128$exports, "attributesDialog", function () { return $813f804f350c3128$export$ffbe18d9d8e56a1c; }, function (v) { return $813f804f350c3128$export$ffbe18d9d8e56a1c = v; });
var $813f804f350c3128$export$ffbe18d9d8e56a1c;
$813f804f350c3128$export$ffbe18d9d8e56a1c = `pA25za_attributesDialog`;



const $0a824bccb85d63e7$export$517a01c14baeae37 = ({ open: open, onClose: onClose, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($813f804f350c3128$exports))).attributesDialog,
        fullWidth: true,
        maxWidth: "md",
        open: open,
        onClose: onClose,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: children
    });
};




const $25855f1c176c9751$export$d8d2a58d08eff6f8 = ({ isPublic: isPublic, album: album, onNameUpdated: onNameUpdated, onArtistUpdated: onArtistUpdated })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [currentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const { getCurrentCollection: getCurrentCollection, isCurrentCollectionShareable: isCurrentCollectionShareable } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const { state: nameDialogState, key: nameDialogKey, openAdd: openNameDialog, close: closeNameDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isArtistDialogOpen, setIsArtistDialogOpen] = (0, $7fPBF.useState)(false);
    const [isArtistsDesktopOpen, setIsArtistsDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [shareLinkComponents, fetchShareLink, fetchPrivateLink, isShareLoading] = (0, $bed6df3ee0929f14$export$cc4cb9d785f3b827)(album.name);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const updateAlbumArtist = async (artist)=>{
        setIsArtistsDesktopOpen(false);
        setIsLoading(true);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            artistId: artist?.uuid ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album.artist = artist;
            onArtistUpdated();
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        sx: {
            padding: "0 !important"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                spacing: 0,
                flexGrow: 1,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                disabled: isPublic,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).albumName,
                                onClick: openNameDialog,
                                children: album.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).loadingDiv,
                                children: isLoading || isShareLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).loadingIndicator
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    sx: {
                                        height: "100%"
                                    },
                                    direction: "row",
                                    children: [
                                        isCurrentCollectionShareable(isPublic) && (isPublic || (0, $40029fedba9c2cbf$export$3d1cf140a8db8fb3).albumBelongsTo(currentPrivateCollection, album)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).share_album,
                                            arrow: true,
                                            disableInteractive: true,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).shareButton,
                                                onClick: ()=>{
                                                    const collectionId = getCurrentCollection(isPublic)?.uuid;
                                                    if (!collectionId) return;
                                                    fetchShareLink(collectionId, album.uuid).then();
                                                },
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).shareIcon,
                                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Share
                                                })
                                            })
                                        }),
                                        !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).get_private_link,
                                            arrow: true,
                                            disableInteractive: true,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).shareButton,
                                                onClick: ()=>{
                                                    fetchPrivateLink(album.uuid).then();
                                                },
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1775968c0d4755f4$exports))).artistName,
                        onClick: (event)=>{
                            if (album.isBoxSet) {
                                if (album.artist) setIsArtistDialogOpen(true);
                                return;
                            }
                            if (album.artist) {
                                if (isPublic) setIsArtistDialogOpen(true);
                                else handleContextMenu(event);
                            } else setIsArtistsDesktopOpen(true);
                        },
                        children: album.artist?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsArtistDialogOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Artist
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_view
                        ]
                    }),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsArtistsDesktopOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).change_artist
                        ]
                    })
                ]
            }),
            album.artist && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1a3a955a9c7e25$export$8d5fcdbc93b146b5), {
                artist: album.artist,
                isOpen: isArtistDialogOpen,
                onClose: ()=>setIsArtistDialogOpen(false),
                canEdit: !isPublic
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isArtistsDesktopOpen,
                onClose: ()=>setIsArtistsDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d963a2e56ac79bd1$export$c45b630b80b4cbe8), {
                    handleClose: ()=>{
                        setIsArtistsDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: album.artist?.uuid,
                    onArtistSelected: updateAlbumArtist,
                    onClearValue: ()=>updateAlbumArtist(null)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_detail,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: album.name,
                canClear: false,
                open: nameDialogState.mode !== "closed",
                onClose: closeNameDialog,
                isNumber: false,
                onChange: async (newValue)=>{
                    setIsLoading(true);
                    const { body: body, status: status } = await updateAlbum({
                        uuid: album.uuid,
                        name: newValue
                    });
                    if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                        setAlertMessage(body.message);
                        setIsAlertOpen(true);
                    } else {
                        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
                        onNameUpdated(body);
                    }
                    setIsLoading(false);
                }
            }, nameDialogKey),
            shareLinkComponents(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");








const $b2965f669c97cfca$export$b7386dc5f4cbabde = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getLabels = (parameters)=>get("labels", parameters);
    const getPublicLabels = (parameters)=>get("labels/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).labels(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicLabels : getLabels, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).labelStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $e1d66df2de8b1254$exports = {};

$parcel$export($e1d66df2de8b1254$exports, "cancelButton", function () { return $e1d66df2de8b1254$export$4ededb8e5b56a6fb; }, function (v) { return $e1d66df2de8b1254$export$4ededb8e5b56a6fb = v; });
$parcel$export($e1d66df2de8b1254$exports, "dropzone", function () { return $e1d66df2de8b1254$export$585d0a7a39ed94ea; }, function (v) { return $e1d66df2de8b1254$export$585d0a7a39ed94ea = v; });
$parcel$export($e1d66df2de8b1254$exports, "loadingDiv", function () { return $e1d66df2de8b1254$export$dded2af20345efaa; }, function (v) { return $e1d66df2de8b1254$export$dded2af20345efaa = v; });
$parcel$export($e1d66df2de8b1254$exports, "profileCard", function () { return $e1d66df2de8b1254$export$56d7158379169459; }, function (v) { return $e1d66df2de8b1254$export$56d7158379169459 = v; });
$parcel$export($e1d66df2de8b1254$exports, "textField", function () { return $e1d66df2de8b1254$export$c54b92c0bb02ba64; }, function (v) { return $e1d66df2de8b1254$export$c54b92c0bb02ba64 = v; });
var $e1d66df2de8b1254$export$4ededb8e5b56a6fb;
var $e1d66df2de8b1254$export$585d0a7a39ed94ea;
var $e1d66df2de8b1254$export$dded2af20345efaa;
var $e1d66df2de8b1254$export$56d7158379169459;
var $e1d66df2de8b1254$export$c54b92c0bb02ba64;
$e1d66df2de8b1254$export$4ededb8e5b56a6fb = `_3n2EyW_cancelButton`;
$e1d66df2de8b1254$export$585d0a7a39ed94ea = `_3n2EyW_dropzone`;
$e1d66df2de8b1254$export$dded2af20345efaa = `_3n2EyW_loadingDiv`;
$e1d66df2de8b1254$export$56d7158379169459 = `_3n2EyW_profileCard`;
$e1d66df2de8b1254$export$c54b92c0bb02ba64 = `_3n2EyW_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $9115a5478d40a888$export$36eeafb75308a374 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addLabel = (parameters)=>post("labels", parameters);
    return {
        addLabel: addLabel
    };
};



const $c4d49be301bfb337$export$a695fd83cb08e412 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyLabel = (parameters)=>put("labels", parameters);
    return {
        modifyLabel: modifyLabel
    };
};



const $3b1173b4390775a0$export$b9ad5942aac1b803 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteLabel = (parameters)=>deleteRequest("labels", parameters);
    return {
        deleteLabel: deleteLabel
    };
};


















var $95e659af2867daac$exports = {};
$95e659af2867daac$exports = $parcel$resolve("jDFcd");


const $1ee2f80a2251f96a$export$3d0c6182b847254f = ({ open: open, onClose: onClose, label: label, originalImageData: originalImageData, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = label ? (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_new_title;
    const { addLabel: addLabel } = (0, $9115a5478d40a888$export$36eeafb75308a374)();
    const { modifyLabel: modifyLabel } = (0, $c4d49be301bfb337$export$a695fd83cb08e412)();
    const { deleteLabel: deleteLabel } = (0, $3b1173b4390775a0$export$b9ad5942aac1b803)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [isModifyProfileDialogOpen, setIsModifyProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const genericImage = new URL($95e659af2867daac$exports).href;
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).ml_missing_error)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: label?.name ?? "",
            profile: label?.profile ?? "",
            discogsId: label?.discogsId ?? "",
            website: label?.website ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, profile: profile, discogsId: discogsId, website: website })=>{
            setIsLoading(true);
            if (label) {
                const { status: status, body: body } = await modifyLabel({
                    uuid: label.uuid,
                    name: name,
                    hasImage: label.hasImage,
                    profile: profile,
                    discogsId: discogsId,
                    website: website
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_label_action", {
                        isNew: false
                    });
                    if (didChangeImage && imageFile && label.uuid) {
                        const newThumbnail = await uploadImage({
                            name: label.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addLabel({
                    name: name,
                    profile: profile,
                    discogsId: discogsId,
                    website: website
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_label_action", {
                        isNew: true
                    });
                    if (didChangeImage && imageFile && body.uuid) {
                        const newThumbnail = await uploadImage({
                            name: body.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!label?.uuid) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteLabel({
            uuid: label.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(label);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setImageFile(undefined);
        setDidChangeImage(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            label && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_image_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e1d66df2de8b1254$exports))).dropzone,
                                                onImageChanged: (file)=>{
                                                    setImageFile(file);
                                                    setDidChangeImage(true);
                                                },
                                                placeholderImage: genericImage,
                                                initialImage: originalImageData ? `data:image/png;base64,${originalImageData}` : label?.thumbnail ? `data:image/png;base64,${label.thumbnail}` : undefined,
                                                isLoading: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_field_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e1d66df2de8b1254$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "name",
                                                    name: "name",
                                                    size: "small",
                                                    autoFocus: !isMobile,
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_placeholder,
                                                    value: formik.values.name,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e1d66df2de8b1254$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "website",
                                                    name: "website",
                                                    size: "small",
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_placeholder,
                                                    value: formik.values.website,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e1d66df2de8b1254$exports))).textField,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                id: "discogsId",
                                                name: "discogsId",
                                                size: "small",
                                                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_placeholder,
                                                value: formik.values.discogsId,
                                                onChange: formik.handleChange,
                                                enterAction: formik.submitForm
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e1d66df2de8b1254$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.profile ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyProfileDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_profile_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                value: formik.values.profile,
                open: isModifyProfileDialogOpen,
                onClose: ()=>setIsModifyProfileDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("profile", newValue),
                onClearValue: ()=>formik.setFieldValue("profile", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).LABELS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};





var $e4d55e0c8a74d081$exports = {};

$parcel$export($e4d55e0c8a74d081$exports, "container", function () { return $e4d55e0c8a74d081$export$34e0f9847d4c02dd; }, function (v) { return $e4d55e0c8a74d081$export$34e0f9847d4c02dd = v; });
$parcel$export($e4d55e0c8a74d081$exports, "hoverButton", function () { return $e4d55e0c8a74d081$export$b0260c0afbf48c57; }, function (v) { return $e4d55e0c8a74d081$export$b0260c0afbf48c57 = v; });
$parcel$export($e4d55e0c8a74d081$exports, "hoverButtonsStack", function () { return $e4d55e0c8a74d081$export$a8eacba2c33c9f28; }, function (v) { return $e4d55e0c8a74d081$export$a8eacba2c33c9f28 = v; });
$parcel$export($e4d55e0c8a74d081$exports, "image", function () { return $e4d55e0c8a74d081$export$5c452ff88e35e47d; }, function (v) { return $e4d55e0c8a74d081$export$5c452ff88e35e47d = v; });
$parcel$export($e4d55e0c8a74d081$exports, "name", function () { return $e4d55e0c8a74d081$export$a8ff84c12d48cfa6; }, function (v) { return $e4d55e0c8a74d081$export$a8ff84c12d48cfa6 = v; });
$parcel$export($e4d55e0c8a74d081$exports, "profile", function () { return $e4d55e0c8a74d081$export$4882ae973e0491e; }, function (v) { return $e4d55e0c8a74d081$export$4882ae973e0491e = v; });
$parcel$export($e4d55e0c8a74d081$exports, "rightContainer", function () { return $e4d55e0c8a74d081$export$3280a108d7f81d56; }, function (v) { return $e4d55e0c8a74d081$export$3280a108d7f81d56 = v; });
var $e4d55e0c8a74d081$export$34e0f9847d4c02dd;
var $e4d55e0c8a74d081$export$b0260c0afbf48c57;
var $e4d55e0c8a74d081$export$a8eacba2c33c9f28;
var $e4d55e0c8a74d081$export$5c452ff88e35e47d;
var $e4d55e0c8a74d081$export$a8ff84c12d48cfa6;
var $e4d55e0c8a74d081$export$4882ae973e0491e;
var $e4d55e0c8a74d081$export$3280a108d7f81d56;
$e4d55e0c8a74d081$export$34e0f9847d4c02dd = `TwlOFG_container`;
$e4d55e0c8a74d081$export$b0260c0afbf48c57 = `TwlOFG_hoverButton`;
$e4d55e0c8a74d081$export$a8eacba2c33c9f28 = `TwlOFG_hoverButtonsStack`;
$e4d55e0c8a74d081$export$5c452ff88e35e47d = `TwlOFG_image`;
$e4d55e0c8a74d081$export$a8ff84c12d48cfa6 = `TwlOFG_name`;
$e4d55e0c8a74d081$export$4882ae973e0491e = `TwlOFG_profile`;
$e4d55e0c8a74d081$export$3280a108d7f81d56 = `TwlOFG_rightContainer`;



var $7fPBF = parcelRequire("7fPBF");







var $7669f0eb53d19f41$exports = {};
$7669f0eb53d19f41$exports = $parcel$resolve("8k5Db");


const $a02049048d743482$export$f97bcdf295947f13 = ({ label: label, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($7669f0eb53d19f41$exports).href;
    const fetchImage = async ()=>{
        if (!label.hasImage) return;
        const response = await getImage({
            name: label.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        label
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).container,
        sx: {
            height: 60
        },
        elevation: 5,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "row"
                },
                style: {
                    borderColor: theme.palette.colors?.highlightBorder,
                    borderWidth: 4,
                    borderStyle: selected ? "double" : "none"
                },
                onContextMenu: (event)=>onContextMenu(event, image),
                onClick: (event)=>onClick(event, image),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).image,
                        imageStyle: {
                            borderRadius: "16px"
                        },
                        image: image,
                        thumbnail: label.thumbnail,
                        defaultImage: genericImage,
                        beforeLoad: fetchImage,
                        alt: label.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).rightContainer,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).name,
                                children: label.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).profile,
                                children: label.profile
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e4d55e0c8a74d081$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>onContextMenu(event, image),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");

var $f2e3349053a99be7$exports = {};

$parcel$export($f2e3349053a99be7$exports, "artistDates", function () { return $f2e3349053a99be7$export$3f899b467dbac2d; }, function (v) { return $f2e3349053a99be7$export$3f899b467dbac2d = v; });
$parcel$export($f2e3349053a99be7$exports, "dialog", function () { return $f2e3349053a99be7$export$518824cf31321346; }, function (v) { return $f2e3349053a99be7$export$518824cf31321346 = v; });
$parcel$export($f2e3349053a99be7$exports, "image", function () { return $f2e3349053a99be7$export$5c452ff88e35e47d; }, function (v) { return $f2e3349053a99be7$export$5c452ff88e35e47d = v; });
$parcel$export($f2e3349053a99be7$exports, "loadingDiv", function () { return $f2e3349053a99be7$export$dded2af20345efaa; }, function (v) { return $f2e3349053a99be7$export$dded2af20345efaa = v; });
$parcel$export($f2e3349053a99be7$exports, "profile", function () { return $f2e3349053a99be7$export$4882ae973e0491e; }, function (v) { return $f2e3349053a99be7$export$4882ae973e0491e = v; });
$parcel$export($f2e3349053a99be7$exports, "realName", function () { return $f2e3349053a99be7$export$6d354f2c918c5662; }, function (v) { return $f2e3349053a99be7$export$6d354f2c918c5662 = v; });
$parcel$export($f2e3349053a99be7$exports, "redirectButton", function () { return $f2e3349053a99be7$export$1459b0652d8256be; }, function (v) { return $f2e3349053a99be7$export$1459b0652d8256be = v; });
$parcel$export($f2e3349053a99be7$exports, "redirectGridItem", function () { return $f2e3349053a99be7$export$45fc42605641ab16; }, function (v) { return $f2e3349053a99be7$export$45fc42605641ab16 = v; });
$parcel$export($f2e3349053a99be7$exports, "title", function () { return $f2e3349053a99be7$export$fb184b623420d9be; }, function (v) { return $f2e3349053a99be7$export$fb184b623420d9be = v; });
var $f2e3349053a99be7$export$3f899b467dbac2d;
var $f2e3349053a99be7$export$518824cf31321346;
var $f2e3349053a99be7$export$5c452ff88e35e47d;
var $f2e3349053a99be7$export$dded2af20345efaa;
var $f2e3349053a99be7$export$4882ae973e0491e;
var $f2e3349053a99be7$export$6d354f2c918c5662;
var $f2e3349053a99be7$export$1459b0652d8256be;
var $f2e3349053a99be7$export$45fc42605641ab16;
var $f2e3349053a99be7$export$fb184b623420d9be;
$f2e3349053a99be7$export$3f899b467dbac2d = `PRbTdq_artistDates`;
$f2e3349053a99be7$export$518824cf31321346 = `PRbTdq_dialog`;
$f2e3349053a99be7$export$5c452ff88e35e47d = `PRbTdq_image`;
$f2e3349053a99be7$export$dded2af20345efaa = `PRbTdq_loadingDiv`;
$f2e3349053a99be7$export$4882ae973e0491e = `PRbTdq_profile`;
$f2e3349053a99be7$export$6d354f2c918c5662 = `PRbTdq_realName`;
$f2e3349053a99be7$export$1459b0652d8256be = `PRbTdq_redirectButton`;
$f2e3349053a99be7$export$45fc42605641ab16 = `PRbTdq_redirectGridItem`;
$f2e3349053a99be7$export$fb184b623420d9be = `PRbTdq_title`;














const $45147f742e486f78$export$c1117e0061a42ffc = ({ label: label, isOpen: isOpen, onClose: onClose, canEdit: canEdit, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [myLabel, setMyLabel] = (0, $7fPBF.useState)(label);
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [thumbnail, setThumbnail] = (0, $7fPBF.useState)(label.thumbnail);
    const [modifyDialogState, setModifyDialogState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const genericImage = new URL($7669f0eb53d19f41$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        setThumbnail(myLabel.thumbnail);
        fetchImage().then();
    }, [
        myLabel.uuid,
        myLabel.hasImage,
        myLabel.thumbnail
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setMyLabel(label);
    }, [
        label
    ]);
    const currentLabelUuid = (0, $7fPBF.useRef)("");
    const fetchImage = async ()=>{
        currentLabelUuid.current = myLabel.uuid;
        setImage(undefined);
        if (!myLabel.hasImage) return;
        const response = await getImage({
            name: myLabel.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize
        });
        // Discard image if label changed
        if (currentLabelUuid.current != myLabel.uuid) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).dialog,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: myLabel.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        canEdit && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>setModifyDialogState({
                                    mode: "edit",
                                    item: label
                                }),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).label_edit,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: onClose,
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                dividers: true,
                children: myLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: isMobile ? "column" : "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).image,
                                    style: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    imageStyle: {
                                        borderRadius: "6%"
                                    },
                                    image: image,
                                    thumbnail: thumbnail,
                                    defaultImage: genericImage,
                                    alt: myLabel.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    style: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                            container: true,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: true,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).redirectGridItem,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).redirectButton,
                                                        disabled: myLabel.discogsId?.length === 0,
                                                        href: `https://www.discogs.com/label/${myLabel.discogsId}`,
                                                        target: "_blank",
                                                        component: "a",
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_discogs
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: true,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).redirectGridItem,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).redirectButton,
                                                        disabled: !myLabel.website || myLabel.website.length === 0,
                                                        href: myLabel.website,
                                                        target: "_blank",
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_button_title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            flexGrow: 1
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f2e3349053a99be7$exports))).profile,
                            children: myLabel.profile
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    sx: {
                        height: 200
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ee2f80a2251f96a$export$3d0c6182b847254f), {
                open: modifyDialogState.mode !== "closed",
                onClose: ()=>setModifyDialogState({
                        mode: "closed",
                        item: modifyDialogState.item
                    }),
                label: modifyDialogState.item,
                originalImageData: image,
                onModifiedItem: (newItem)=>{
                    onModifiedItem?.(newItem);
                    setMyLabel(newItem);
                },
                onDeletedItem: onDeletedItem
            }, modifyDialogState.item?.uuid)
        ]
    });
};



var $7858d6b324ec6a88$exports = {};

$parcel$export($7858d6b324ec6a88$exports, "skeleton", function () { return $7858d6b324ec6a88$export$2a0674ff2eb10214; }, function (v) { return $7858d6b324ec6a88$export$2a0674ff2eb10214 = v; });
var $7858d6b324ec6a88$export$2a0674ff2eb10214;
$7858d6b324ec6a88$export$2a0674ff2eb10214 = `Lbq8jG_skeleton`;






const $2f56ce92a8b7d721$export$9451b0ecafcfb0be = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onLabelSelected: onLabelSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [labels, resetLabels, setLabels, noMoreLabels] = (0, $b2965f669c97cfca$export$b7386dc5f4cbabde)(isPublic, setLoading);
    const [imageData, setImageData] = (0, $7fPBF.useState)();
    const { state: labelDialogState, key: labelDialogKey, openEdit: openLabelDialog, close: closeLabelDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const { state: modifyLabelDialogState, key: modifyLabelDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyLabelDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextLabel, setContextLabel] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredLabels = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return labels;
        return labels?.filter((label)=>{
            return label.name.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        labels,
        searchText
    ]);
    const onModifiedLabel = (newLabel)=>{
        const newLabels = labels.map((label)=>label.uuid == newLabel.uuid ? newLabel : label);
        newLabels.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                ignorePunctuation: true
            }));
        setLabels(newLabels);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    const onDeletedLabel = (deletedLabel)=>{
        const newLabels = labels.filter((label)=>label.uuid != deletedLabel.uuid);
        setLabels(newLabels);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredLabels,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).LABELS],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_labels_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_labels,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_labels_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: ()=>{
            setImageData(undefined);
            openAdd();
        },
        refreshAction: resetLabels,
        onClearValue: onClearValue,
        children: [
            filteredLabels?.map((label)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a02049048d743482$export$f97bcdf295947f13), {
                        label: label,
                        selected: preselectedId == label.uuid,
                        onClick: (_event, imageData)=>{
                            setImageData(imageData);
                            if (onLabelSelected) onLabelSelected(label);
                            else openEdit(label);
                        },
                        onContextMenu: (event, imageData)=>{
                            setImageData(imageData);
                            setContextLabel(label);
                            handleContextMenu(event);
                        }
                    })
                }, label.uuid)),
            (loading || !noMoreLabels) && Array.from({
                length: 40
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 60
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7858d6b324ec6a88$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ee2f80a2251f96a$export$3d0c6182b847254f), {
                open: modifyLabelDialogState.mode !== "closed",
                onClose: closeModifyLabelDialog,
                label: modifyLabelDialogState.item,
                originalImageData: imageData,
                onNewItem: (newLabel)=>{
                    const newLabels = [
                        ...labels,
                        newLabel
                    ];
                    newLabels.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setLabels(newLabels);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: onModifiedLabel,
                onDeletedItem: onDeletedLabel
            }, modifyLabelDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openLabelDialog(contextLabel);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).label_view
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openEdit(contextLabel);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).label_edit
                        ]
                    })
                ]
            }),
            labelDialogState.item && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45147f742e486f78$export$c1117e0061a42ffc), {
                label: labelDialogState.item,
                isOpen: labelDialogState.mode !== "closed",
                onClose: closeLabelDialog,
                canEdit: true,
                onModifiedItem: onModifiedLabel,
                onDeletedItem: (deletedLabel)=>{
                    closeLabelDialog();
                    onDeletedLabel(deletedLabel);
                }
            }, labelDialogKey)
        ]
    });
};















parcelRequire("7fPBF");

var $1cb48210433795e7$exports = {};

$parcel$export($1cb48210433795e7$exports, "list", function () { return $1cb48210433795e7$export$8837f4fc672e936d; }, function (v) { return $1cb48210433795e7$export$8837f4fc672e936d = v; });
var $1cb48210433795e7$export$8837f4fc672e936d;
$1cb48210433795e7$export$8837f4fc672e936d = `oU69bq_list`;




var $7fPBF = parcelRequire("7fPBF");

var $cb3333330f4f358a$exports = {};

$parcel$export($cb3333330f4f358a$exports, "codePart", function () { return $cb3333330f4f358a$export$e017ad4f9a60b390; }, function (v) { return $cb3333330f4f358a$export$e017ad4f9a60b390 = v; });
$parcel$export($cb3333330f4f358a$exports, "codePartsDiv", function () { return $cb3333330f4f358a$export$3afaec09d45a039f; }, function (v) { return $cb3333330f4f358a$export$3afaec09d45a039f = v; });
$parcel$export($cb3333330f4f358a$exports, "container", function () { return $cb3333330f4f358a$export$34e0f9847d4c02dd; }, function (v) { return $cb3333330f4f358a$export$34e0f9847d4c02dd = v; });
$parcel$export($cb3333330f4f358a$exports, "description", function () { return $cb3333330f4f358a$export$6d59db4903f20f7d; }, function (v) { return $cb3333330f4f358a$export$6d59db4903f20f7d = v; });
$parcel$export($cb3333330f4f358a$exports, "hoverButton", function () { return $cb3333330f4f358a$export$b0260c0afbf48c57; }, function (v) { return $cb3333330f4f358a$export$b0260c0afbf48c57 = v; });
$parcel$export($cb3333330f4f358a$exports, "hoverButtonIcon", function () { return $cb3333330f4f358a$export$2a797adc03a2480; }, function (v) { return $cb3333330f4f358a$export$2a797adc03a2480 = v; });
$parcel$export($cb3333330f4f358a$exports, "hoverButtonsStack", function () { return $cb3333330f4f358a$export$a8eacba2c33c9f28; }, function (v) { return $cb3333330f4f358a$export$a8eacba2c33c9f28 = v; });
$parcel$export($cb3333330f4f358a$exports, "labelImage", function () { return $cb3333330f4f358a$export$35ca5faa3ab2a561; }, function (v) { return $cb3333330f4f358a$export$35ca5faa3ab2a561 = v; });
$parcel$export($cb3333330f4f358a$exports, "name", function () { return $cb3333330f4f358a$export$a8ff84c12d48cfa6; }, function (v) { return $cb3333330f4f358a$export$a8ff84c12d48cfa6 = v; });
$parcel$export($cb3333330f4f358a$exports, "type", function () { return $cb3333330f4f358a$export$bf9fb029d174d554; }, function (v) { return $cb3333330f4f358a$export$bf9fb029d174d554 = v; });
var $cb3333330f4f358a$export$e017ad4f9a60b390;
var $cb3333330f4f358a$export$3afaec09d45a039f;
var $cb3333330f4f358a$export$34e0f9847d4c02dd;
var $cb3333330f4f358a$export$6d59db4903f20f7d;
var $cb3333330f4f358a$export$b0260c0afbf48c57;
var $cb3333330f4f358a$export$2a797adc03a2480;
var $cb3333330f4f358a$export$a8eacba2c33c9f28;
var $cb3333330f4f358a$export$35ca5faa3ab2a561;
var $cb3333330f4f358a$export$a8ff84c12d48cfa6;
var $cb3333330f4f358a$export$bf9fb029d174d554;
$cb3333330f4f358a$export$e017ad4f9a60b390 = `kYmSAq_codePart`;
$cb3333330f4f358a$export$3afaec09d45a039f = `kYmSAq_codePartsDiv`;
$cb3333330f4f358a$export$34e0f9847d4c02dd = `kYmSAq_container`;
$cb3333330f4f358a$export$6d59db4903f20f7d = `kYmSAq_description`;
$cb3333330f4f358a$export$b0260c0afbf48c57 = `kYmSAq_hoverButton`;
$cb3333330f4f358a$export$2a797adc03a2480 = `kYmSAq_hoverButtonIcon`;
$cb3333330f4f358a$export$a8eacba2c33c9f28 = `kYmSAq_hoverButtonsStack`;
$cb3333330f4f358a$export$35ca5faa3ab2a561 = `kYmSAq_labelImage`;
$cb3333330f4f358a$export$a8ff84c12d48cfa6 = `kYmSAq_name`;
$cb3333330f4f358a$export$bf9fb029d174d554 = `kYmSAq_type`;













const $4017bbdcb7ed3d78$export$fbcc9649ded3becf = ({ isPublic: isPublic, albumIdentifier: albumIdentifier, onModify: onModify, canMoveDown: canMoveDown, canMoveUp: canMoveUp, onMoveDown: onMoveDown, onMoveUp: onMoveUp, onDelete: onDelete, canModify: canModify })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const { handleContextMenu: handleContextMenu, menuProps: menuProps, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    const typeName = (type)=>{
        switch(type){
            case "catalogue":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_catalogue;
            case "matrix":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_matrix;
            case "barcode":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_barcode;
        }
        return undefined;
    };
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [labelImage, setLabelImage] = (0, $7fPBF.useState)();
    const fetchLabelImage = async ()=>{
        const label = albumIdentifier.label;
        setLabelImage(label?.thumbnail);
        if (!label?.hasImage) return;
        const response = await getImage({
            name: label?.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) {
            if (label.uuid != albumIdentifier.label?.uuid) return;
            setLabelImage(response.body);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchLabelImage().then();
    }, [
        albumIdentifier.label
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).container,
        onContextMenu: handleContextMenu,
        ...handleLongPress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                disableGutters: true,
                onClick: ()=>setIsExpanded((state)=>!state),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    flexGrow: 1,
                    spacing: 1,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).type,
                                    children: typeName(albumIdentifier.type) ?? albumIdentifier.description
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).description,
                                    style: {
                                        color: theme.palette.secondary.main,
                                        WebkitLineClamp: isExpanded ? undefined : 1
                                    },
                                    children: typeName(albumIdentifier.type) === undefined ? "" : albumIdentifier.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).codePartsDiv,
                            children: albumIdentifier.codeParts.map((codePart, index)=>{
                                if (codePart !== "") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).codePart,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).name,
                                        children: codePart
                                    })
                                }, `${albumIdentifier.uuid}_codePart_${index}`);
                            })
                        }),
                        albumIdentifier.label && albumIdentifier.label.hasImage && albumIdentifier.type == "catalogue" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).labelImage,
                            defaultImage: labelImage,
                            image: labelImage,
                            alt: ""
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>{
                            event.stopPropagation();
                            handleContextMenu(event);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cb3333330f4f358a$exports))).hoverButtonIcon,
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    !isPublic && canModify && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            onModify();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            (0, (/*@__PURE__*/$parcel$interopDefault($9efca8d7db7deffa$exports)))(albumIdentifier.codeParts.join(" "));
                            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).copy_value_success_notification);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ContentCopy
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).copy_value
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsExpanded((state)=>!state);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: isExpanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Compress
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Expand
                                })
                            }),
                            isExpanded ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shrink : (0, $37bec70ed65ed924$export$21c51bc433c16634).expand
                        ]
                    }),
                    !isPublic && canMoveUp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onMoveUp();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowUp
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_up
                        ]
                    }),
                    !isPublic && canMoveDown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onMoveDown();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowDown
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_down
                        ]
                    }),
                    !isPublic && canModify && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onDelete();
                        },
                        sx: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_delete
                        ]
                    }, "Remove")
                ]
            })
        ]
    }, albumIdentifier.uuid);
};



const $a9516189d5e447c8$export$ef5922bb275bf862 = ({ isPublic: isPublic, album: album, onModify: onModify, onMoveDown: onMoveDown, onMoveUp: onMoveUp, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1cb48210433795e7$exports))).list,
        children: album.albumIdentifiers?.map((albumIdentifier, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4017bbdcb7ed3d78$export$fbcc9649ded3becf), {
                        isPublic: isPublic,
                        albumIdentifier: albumIdentifier,
                        onModify: ()=>onModify(albumIdentifier),
                        canModify: true,
                        canMoveDown: index < album.albumIdentifiers?.length - 1,
                        canMoveUp: index > 0,
                        onMoveDown: ()=>onMoveDown(index),
                        onMoveUp: ()=>onMoveUp(index),
                        onDelete: ()=>onDelete(albumIdentifier)
                    }),
                    index < album.albumIdentifiers?.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                        color: theme.palette.background.paper
                    })
                ]
            }, index))
    });
};



const $ec561a2e4c379c74$export$70c74bdd2fd89f6c = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumIdentifier = (parameters)=>deleteRequest("albumIdentifiers", parameters);
    return {
        deleteAlbumIdentifier: deleteAlbumIdentifier
    };
};



const $ff68ced4bef5fd3c$export$a5c38833883dc162 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderAlbumIdentifiers = (albumIdentifiers)=>{
        const sortedUuids = albumIdentifiers.map((albumContent)=>albumContent.uuid);
        return post("albumIdentifiers/reorder", {
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderAlbumIdentifiers: reorderAlbumIdentifiers
    };
};





var $7fPBF = parcelRequire("7fPBF");
var $92a323e3f9621ddd$exports = {};

$parcel$export($92a323e3f9621ddd$exports, "cancelButton", function () { return $92a323e3f9621ddd$export$4ededb8e5b56a6fb; }, function (v) { return $92a323e3f9621ddd$export$4ededb8e5b56a6fb = v; });
$parcel$export($92a323e3f9621ddd$exports, "chips", function () { return $92a323e3f9621ddd$export$9f51660fd8227d80; }, function (v) { return $92a323e3f9621ddd$export$9f51660fd8227d80 = v; });
$parcel$export($92a323e3f9621ddd$exports, "descriptionCard", function () { return $92a323e3f9621ddd$export$ea3c9f9ac820b913; }, function (v) { return $92a323e3f9621ddd$export$ea3c9f9ac820b913 = v; });
$parcel$export($92a323e3f9621ddd$exports, "loadingDiv", function () { return $92a323e3f9621ddd$export$dded2af20345efaa; }, function (v) { return $92a323e3f9621ddd$export$dded2af20345efaa = v; });
$parcel$export($92a323e3f9621ddd$exports, "selectDiscount", function () { return $92a323e3f9621ddd$export$1fab6054d6ffebee; }, function (v) { return $92a323e3f9621ddd$export$1fab6054d6ffebee = v; });
$parcel$export($92a323e3f9621ddd$exports, "subtitle", function () { return $92a323e3f9621ddd$export$c96745152eb2740f; }, function (v) { return $92a323e3f9621ddd$export$c96745152eb2740f = v; });
$parcel$export($92a323e3f9621ddd$exports, "textField", function () { return $92a323e3f9621ddd$export$c54b92c0bb02ba64; }, function (v) { return $92a323e3f9621ddd$export$c54b92c0bb02ba64 = v; });
$parcel$export($92a323e3f9621ddd$exports, "visibility", function () { return $92a323e3f9621ddd$export$91fa9ac3f4021ce4; }, function (v) { return $92a323e3f9621ddd$export$91fa9ac3f4021ce4 = v; });
var $92a323e3f9621ddd$export$4ededb8e5b56a6fb;
var $92a323e3f9621ddd$export$9f51660fd8227d80;
var $92a323e3f9621ddd$export$ea3c9f9ac820b913;
var $92a323e3f9621ddd$export$dded2af20345efaa;
var $92a323e3f9621ddd$export$1fab6054d6ffebee;
var $92a323e3f9621ddd$export$c96745152eb2740f;
var $92a323e3f9621ddd$export$c54b92c0bb02ba64;
var $92a323e3f9621ddd$export$91fa9ac3f4021ce4;
$92a323e3f9621ddd$export$4ededb8e5b56a6fb = `y0-JLW_cancelButton`;
$92a323e3f9621ddd$export$9f51660fd8227d80 = `y0-JLW_chips`;
$92a323e3f9621ddd$export$ea3c9f9ac820b913 = `y0-JLW_descriptionCard`;
$92a323e3f9621ddd$export$dded2af20345efaa = `y0-JLW_loadingDiv`;
$92a323e3f9621ddd$export$1fab6054d6ffebee = `y0-JLW_selectDiscount`;
$92a323e3f9621ddd$export$c96745152eb2740f = `y0-JLW_subtitle`;
$92a323e3f9621ddd$export$c54b92c0bb02ba64 = `y0-JLW_textField`;
$92a323e3f9621ddd$export$91fa9ac3f4021ce4 = `y0-JLW_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");
















const $a27340f82a687e36$export$646424b78494981c = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyAlbumIdentifier = (parameters)=>put("albumIdentifiers", parameters);
    return {
        modifyAlbumIdentifier: modifyAlbumIdentifier
    };
};



const $23c4cf02de952a47$export$e6e1470146024b5 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumIdentifier = (parameters)=>post("albumIdentifiers", parameters);
    return {
        addAlbumIdentifier: addAlbumIdentifier
    };
};






const $b23f520b0644a6dc$export$e4bd0d7888195650 = ({ albumId: albumId, open: open, onClose: onClose, albumIdentifier: albumIdentifier, onUpdate: onUpdate })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentCodePart, setCurrentCodePart] = (0, $7fPBF.useState)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isLabelDesktopOpen, setIsLabelDesktopOpen] = (0, $7fPBF.useState)(false);
    const { state: modifyValueDialogState, key: modifyValueDialogKey, openAdd: openAddValueDialog, openEdit: openModifyValueDialog, close: closeModifyValyeDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const { addAlbumIdentifier: addAlbumIdentifier } = (0, $23c4cf02de952a47$export$e6e1470146024b5)();
    const { modifyAlbumIdentifier: modifyAlbumIdentifier } = (0, $a27340f82a687e36$export$646424b78494981c)();
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            codeParts: albumIdentifier?.codeParts ?? [],
            type: albumIdentifier?.type ?? "catalogue",
            label: albumIdentifier?.label,
            description: albumIdentifier?.description ?? ""
        },
        enableReinitialize: true,
        onSubmit: async ({ codeParts: codeParts, label: label, description: description, type: type })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (albumIdentifier) {
                const { status: status, body: body } = await modifyAlbumIdentifier({
                    uuid: albumIdentifier.uuid,
                    albumId: albumId,
                    codeParts: codeParts,
                    description: description,
                    order: albumIdentifier.order,
                    type: type,
                    labelId: type == "catalogue" ? label?.uuid ?? null : undefined
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addAlbumIdentifier({
                    albumId: albumId,
                    codeParts: codeParts,
                    description: description,
                    labelId: label?.uuid,
                    type: type
                });
                statusCode = status;
                responseBody = body;
            }
            if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            } else {
                onUpdate(responseBody);
                onClose();
                formik.resetForm();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            }
            setIsLoading(false);
        }
    });
    const handleTypeChange = (_event, type)=>{
        if (type !== null) formik.setFieldValue("type", type).then();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_type
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($92a323e3f9621ddd$exports))).visibility,
                                labels: [
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_catalogue,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_matrix,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_barcode,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_other
                                ],
                                values: [
                                    "catalogue",
                                    "matrix",
                                    "barcode",
                                    "other"
                                ],
                                value: formik.values.type,
                                disabled: isLoading,
                                fullWidth: true,
                                disableGutters: true,
                                handleChange: handleTypeChange
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.FieldArray), {
                                name: "codeParts",
                                render: (arrayHelpers)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_value
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($92a323e3f9621ddd$exports))).chips,
                                                disableGutters: true,
                                                title: "",
                                                chips: formik.values.codeParts.map((name, index)=>({
                                                        id: String(index),
                                                        name: name
                                                    })),
                                                addDisabled: formik.values.codeParts.length >= 10,
                                                onAdd: openAddValueDialog,
                                                onChipSelected: (index, chip)=>{
                                                    setCurrentCodePart({
                                                        codePart: chip.name,
                                                        index: index
                                                    });
                                                    openModifyValueDialog(chip.name);
                                                },
                                                onDelete: arrayHelpers.remove
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_value,
                                                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_value_description,
                                                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_value,
                                                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                                                open: modifyValueDialogState.mode !== "closed",
                                                onClose: closeModifyValyeDialog,
                                                isNumber: false,
                                                canClear: false,
                                                value: modifyValueDialogState.item,
                                                onChange: (newValue)=>{
                                                    if (modifyValueDialogState.item !== undefined) arrayHelpers.replace(currentCodePart.index, newValue);
                                                    else arrayHelpers.push(newValue);
                                                }
                                            }, modifyValueDialogKey)
                                        ]
                                    })
                            }),
                            formik.values.type == "catalogue" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($92a323e3f9621ddd$exports))).textField,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                            id: "label",
                                            name: "label",
                                            size: "small",
                                            readOnly: true,
                                            disabled: isLoading,
                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_placeholder,
                                            value: formik.values.label?.name ?? "",
                                            onClick: ()=>setIsLabelDesktopOpen(true),
                                            enterAction: ()=>setIsLabelDesktopOpen(true)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($92a323e3f9621ddd$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    disabled: isLoading,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            disabled: isLoading,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isLabelDesktopOpen,
                onClose: ()=>setIsLabelDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f56ce92a8b7d721$export$9451b0ecafcfb0be), {
                    handleClose: ()=>setIsLabelDesktopOpen(false),
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: formik.values.label?.uuid,
                    onLabelSelected: async (label)=>{
                        setIsLabelDesktopOpen(false);
                        await formik.setFieldValue("label", label);
                    },
                    onClearValue: async ()=>{
                        setIsLabelDesktopOpen(false);
                        await formik.setFieldValue("label", null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: ()=>{
                    onClose();
                    formik.resetForm();
                },
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};


var $4ebf0d484b95486c$exports = {};

$parcel$export($4ebf0d484b95486c$exports, "header", function () { return $4ebf0d484b95486c$export$38e42c68cf43b5d4; }, function (v) { return $4ebf0d484b95486c$export$38e42c68cf43b5d4 = v; });
$parcel$export($4ebf0d484b95486c$exports, "switchListItem", function () { return $4ebf0d484b95486c$export$187ffba5827d73c1; }, function (v) { return $4ebf0d484b95486c$export$187ffba5827d73c1 = v; });
$parcel$export($4ebf0d484b95486c$exports, "tableDiv", function () { return $4ebf0d484b95486c$export$55f8f55da585078f; }, function (v) { return $4ebf0d484b95486c$export$55f8f55da585078f = v; });
$parcel$export($4ebf0d484b95486c$exports, "title", function () { return $4ebf0d484b95486c$export$fb184b623420d9be; }, function (v) { return $4ebf0d484b95486c$export$fb184b623420d9be = v; });
var $4ebf0d484b95486c$export$38e42c68cf43b5d4;
var $4ebf0d484b95486c$export$187ffba5827d73c1;
var $4ebf0d484b95486c$export$55f8f55da585078f;
var $4ebf0d484b95486c$export$fb184b623420d9be;
$4ebf0d484b95486c$export$38e42c68cf43b5d4 = `vpCRvG_header`;
$4ebf0d484b95486c$export$187ffba5827d73c1 = `vpCRvG_switchListItem`;
$4ebf0d484b95486c$export$55f8f55da585078f = `vpCRvG_tableDiv`;
$4ebf0d484b95486c$export$fb184b623420d9be = `vpCRvG_title`;



const $57fc72a256f9b57a$export$6cbc0d108846f901 = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isLabelDialogOpen, setIsLabelDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLabelsDesktopOpen, setIsLabelsDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingLabel, setIsLoadingLabel] = (0, $7fPBF.useState)(false);
    const { reorderAlbumIdentifiers: reorderAlbumIdentifiers } = (0, $ff68ced4bef5fd3c$export$a5c38833883dc162)();
    const { deleteAlbumIdentifier: deleteAlbumIdentifier } = (0, $ec561a2e4c379c74$export$70c74bdd2fd89f6c)();
    const [isAlbumIdentifierDeleteConfirmationAlertOpen, setIsAlbumIdentifierDeleteConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    const [albumIdentifierDialogState, setAlbumIdentifierDialogState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const [selectedAlbumIdentifier, setSelectedAlbumIdentifier] = (0, $7fPBF.useState)();
    const [isLoadingAlbumIdentifiers, setIsLoadingAlbumIdentifiers] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [labelImage, setLabelImage] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const fetchLabelImage = async ()=>{
        const label = album.label;
        setLabelImage(label?.thumbnail);
        if (!label?.hasImage) return;
        const response = await getImage({
            name: label?.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) {
            if (label.uuid != album.label?.uuid) return;
            setLabelImage(response.body);
        }
    };
    const updateLabel = async (newValue)=>{
        setIsLabelsDesktopOpen(false);
        setIsLoadingLabel(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            labelId: newValue?.uuid ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingLabel(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchLabelImage().then();
    }, [
        album.label
    ]);
    const createAlbumIdentifier = (newAlbumIdentifier)=>{
        if (album.albumIdentifiers) album.albumIdentifiers.push(newAlbumIdentifier);
        else album.albumIdentifiers = [
            newAlbumIdentifier
        ];
        onAttributeUpdated(album);
    };
    const updateAlbumIdentifier = (newAlbumIdentifier)=>{
        album.albumIdentifiers = album.albumIdentifiers?.map((albumIdentifier)=>albumIdentifier.uuid == newAlbumIdentifier.uuid ? newAlbumIdentifier : albumIdentifier);
        onAttributeUpdated(album);
    };
    const removeAlbumIdentifier = async ()=>{
        setIsLoadingAlbumIdentifiers(true);
        const { status: status, body: body } = await deleteAlbumIdentifier({
            uuid: selectedAlbumIdentifier.uuid
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            album.albumIdentifiers = album.albumIdentifiers?.filter((albumIdentifier)=>selectedAlbumIdentifier.uuid != albumIdentifier.uuid);
            onAttributeUpdated(album);
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
        }
        setIsLoadingAlbumIdentifiers(false);
    };
    const moveAlbumIdentifiers = async (fromIndex, toIndex)=>{
        const newlyOrderedAlbumIdentifiers = (0, $3c32b049e9065866$export$874a2b636708da2d)(album.albumIdentifiers, fromIndex, toIndex);
        setIsLoadingAlbumIdentifiers(true);
        const { status: status, body: body } = await reorderAlbumIdentifiers(newlyOrderedAlbumIdentifiers);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            album.albumIdentifiers = newlyOrderedAlbumIdentifiers;
            onAttributeUpdated(album);
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoadingAlbumIdentifiers(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            !(isPublic && album.label === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                        disabled: isPublic,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title,
                        detail: album.label?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                        detailImage: labelImage,
                        onClick: (event)=>{
                            if (album.label) handleContextMenu(event);
                            else setIsLabelsDesktopOpen(true);
                        },
                        isLoading: isLoadingLabel
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).tableDiv,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).header,
                        direction: "row",
                        spacing: 2,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).title,
                                secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifiers_title,
                                sx: {
                                    flexGrow: 0
                                }
                            }),
                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_identifier,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle,
                                loading: isLoadingAlbumIdentifiers,
                                onClick: ()=>setAlbumIdentifierDialogState({
                                        mode: "add"
                                    })
                            })
                        ]
                    }),
                    album.albumIdentifiers && album.albumIdentifiers.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        sx: {
                            width: "100%",
                            borderWidth: "1.5px",
                            borderColor: theme.palette.background.paper,
                            borderStyle: "solid"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9516189d5e447c8$export$ef5922bb275bf862), {
                            isPublic: isPublic,
                            album: album,
                            onModify: (albumIdentifier)=>setAlbumIdentifierDialogState({
                                    mode: "edit",
                                    item: albumIdentifier
                                }),
                            onMoveUp: (index)=>moveAlbumIdentifiers(index, index - 1),
                            onMoveDown: (index)=>moveAlbumIdentifiers(index, index + 1),
                            onDelete: (albumIdentifier)=>{
                                setSelectedAlbumIdentifier(albumIdentifier);
                                setIsAlbumIdentifierDeleteConfirmationAlertOpen(true);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsLabelDialogOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).label_view
                        ]
                    }),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsLabelsDesktopOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).change_label
                        ]
                    })
                ]
            }),
            album.label && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45147f742e486f78$export$c1117e0061a42ffc), {
                label: album.label,
                isOpen: isLabelDialogOpen,
                onClose: ()=>setIsLabelDialogOpen(false),
                canEdit: !isPublic
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isLabelsDesktopOpen,
                onClose: ()=>setIsLabelsDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f56ce92a8b7d721$export$9451b0ecafcfb0be), {
                    handleClose: ()=>{
                        setIsLabelsDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: album.label?.uuid,
                    onLabelSelected: updateLabel,
                    onClearValue: ()=>updateLabel(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b23f520b0644a6dc$export$e4bd0d7888195650), {
                albumIdentifier: albumIdentifierDialogState.item,
                albumId: album.uuid,
                open: albumIdentifierDialogState.mode !== "closed",
                onClose: ()=>setAlbumIdentifierDialogState({
                        mode: "closed",
                        item: albumIdentifierDialogState.item
                    }),
                onUpdate: albumIdentifierDialogState.mode === "add" ? createAlbumIdentifier : updateAlbumIdentifier
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_identifier_delete_confirmation,
                open: isAlbumIdentifierDeleteConfirmationAlertOpen,
                setOpen: setIsAlbumIdentifierDeleteConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: removeAlbumIdentifier
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");
var $b6b05eac160462bf$exports = {};

$parcel$export($b6b05eac160462bf$exports, "name", function () { return $b6b05eac160462bf$export$a8ff84c12d48cfa6; }, function (v) { return $b6b05eac160462bf$export$a8ff84c12d48cfa6 = v; });
$parcel$export($b6b05eac160462bf$exports, "skeleton", function () { return $b6b05eac160462bf$export$2a0674ff2eb10214; }, function (v) { return $b6b05eac160462bf$export$2a0674ff2eb10214 = v; });
var $b6b05eac160462bf$export$a8ff84c12d48cfa6;
var $b6b05eac160462bf$export$2a0674ff2eb10214;
$b6b05eac160462bf$export$a8ff84c12d48cfa6 = `_6oz3ca_name`;
$b6b05eac160462bf$export$2a0674ff2eb10214 = `_6oz3ca_skeleton`;






var $7fPBF = parcelRequire("7fPBF");
var $c1e67f9f24d98810$exports = {};

$parcel$export($c1e67f9f24d98810$exports, "cancelButton", function () { return $c1e67f9f24d98810$export$4ededb8e5b56a6fb; }, function (v) { return $c1e67f9f24d98810$export$4ededb8e5b56a6fb = v; });
$parcel$export($c1e67f9f24d98810$exports, "loadingDiv", function () { return $c1e67f9f24d98810$export$dded2af20345efaa; }, function (v) { return $c1e67f9f24d98810$export$dded2af20345efaa = v; });
$parcel$export($c1e67f9f24d98810$exports, "profileCard", function () { return $c1e67f9f24d98810$export$56d7158379169459; }, function (v) { return $c1e67f9f24d98810$export$56d7158379169459 = v; });
$parcel$export($c1e67f9f24d98810$exports, "textField", function () { return $c1e67f9f24d98810$export$c54b92c0bb02ba64; }, function (v) { return $c1e67f9f24d98810$export$c54b92c0bb02ba64 = v; });
var $c1e67f9f24d98810$export$4ededb8e5b56a6fb;
var $c1e67f9f24d98810$export$dded2af20345efaa;
var $c1e67f9f24d98810$export$56d7158379169459;
var $c1e67f9f24d98810$export$c54b92c0bb02ba64;
$c1e67f9f24d98810$export$4ededb8e5b56a6fb = `-1UMeq_cancelButton`;
$c1e67f9f24d98810$export$dded2af20345efaa = `-1UMeq_loadingDiv`;
$c1e67f9f24d98810$export$56d7158379169459 = `-1UMeq_profileCard`;
$c1e67f9f24d98810$export$c54b92c0bb02ba64 = `-1UMeq_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");









const $eb5e52d8f0eb8d44$export$d1774030618314bc = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addOriginCountry = (parameters)=>post("originCountries", parameters);
    return {
        addOriginCountry: addOriginCountry
    };
};



const $8d1323afa8630fa1$export$6f23c7eadc31abaa = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyOriginCountry = (parameters)=>put("originCountries", parameters);
    return {
        modifyOriginCountry: modifyOriginCountry
    };
};



const $2a26bfcde4469755$export$e5f4bb887c3dd830 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteOriginCountry = (parameters)=>deleteRequest("originCountries", parameters);
    return {
        deleteOriginCountry: deleteOriginCountry
    };
};





var $7fPBF = parcelRequire("7fPBF");
var $082f08034a57dd0e$exports = {};

$parcel$export($082f08034a57dd0e$exports, "flag", function () { return $082f08034a57dd0e$export$42405f212471e8a2; }, function (v) { return $082f08034a57dd0e$export$42405f212471e8a2 = v; });
$parcel$export($082f08034a57dd0e$exports, "isoCode", function () { return $082f08034a57dd0e$export$95b8526baebb372d; }, function (v) { return $082f08034a57dd0e$export$95b8526baebb372d = v; });
$parcel$export($082f08034a57dd0e$exports, "name", function () { return $082f08034a57dd0e$export$a8ff84c12d48cfa6; }, function (v) { return $082f08034a57dd0e$export$a8ff84c12d48cfa6 = v; });
$parcel$export($082f08034a57dd0e$exports, "skeleton", function () { return $082f08034a57dd0e$export$2a0674ff2eb10214; }, function (v) { return $082f08034a57dd0e$export$2a0674ff2eb10214 = v; });
var $082f08034a57dd0e$export$42405f212471e8a2;
var $082f08034a57dd0e$export$95b8526baebb372d;
var $082f08034a57dd0e$export$a8ff84c12d48cfa6;
var $082f08034a57dd0e$export$2a0674ff2eb10214;
$082f08034a57dd0e$export$42405f212471e8a2 = `QzVo_W_flag`;
$082f08034a57dd0e$export$95b8526baebb372d = `QzVo_W_isoCode`;
$082f08034a57dd0e$export$a8ff84c12d48cfa6 = `QzVo_W_name`;
$082f08034a57dd0e$export$2a0674ff2eb10214 = `QzVo_W_skeleton`;









var $7fPBF = parcelRequire("7fPBF");



const $883bdfc839eacb3e$export$be16c30b6123c219 = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).countriesStorage;
    const [countries, setCountries] = (0, $7fPBF.useState)(storage.getData(false, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (countries && countries.length > 0) return;
        setLoading(true);
        get("countries").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setCountries(body);
                storage.setData(body, false, "");
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
            setLoading(false);
        });
    }, dependencies);
    return countries;
};





var $0a0f1cafb91d3e49$exports = {};

$parcel$export($0a0f1cafb91d3e49$exports, "container", function () { return $0a0f1cafb91d3e49$export$34e0f9847d4c02dd; }, function (v) { return $0a0f1cafb91d3e49$export$34e0f9847d4c02dd = v; });
$parcel$export($0a0f1cafb91d3e49$exports, "defaultIcon", function () { return $0a0f1cafb91d3e49$export$ca2f546e21dcce87; }, function (v) { return $0a0f1cafb91d3e49$export$ca2f546e21dcce87 = v; });
$parcel$export($0a0f1cafb91d3e49$exports, "flag", function () { return $0a0f1cafb91d3e49$export$42405f212471e8a2; }, function (v) { return $0a0f1cafb91d3e49$export$42405f212471e8a2 = v; });
$parcel$export($0a0f1cafb91d3e49$exports, "isoCode", function () { return $0a0f1cafb91d3e49$export$95b8526baebb372d; }, function (v) { return $0a0f1cafb91d3e49$export$95b8526baebb372d = v; });
$parcel$export($0a0f1cafb91d3e49$exports, "name", function () { return $0a0f1cafb91d3e49$export$a8ff84c12d48cfa6; }, function (v) { return $0a0f1cafb91d3e49$export$a8ff84c12d48cfa6 = v; });
$parcel$export($0a0f1cafb91d3e49$exports, "rightContainer", function () { return $0a0f1cafb91d3e49$export$3280a108d7f81d56; }, function (v) { return $0a0f1cafb91d3e49$export$3280a108d7f81d56 = v; });
var $0a0f1cafb91d3e49$export$34e0f9847d4c02dd;
var $0a0f1cafb91d3e49$export$ca2f546e21dcce87;
var $0a0f1cafb91d3e49$export$42405f212471e8a2;
var $0a0f1cafb91d3e49$export$95b8526baebb372d;
var $0a0f1cafb91d3e49$export$a8ff84c12d48cfa6;
var $0a0f1cafb91d3e49$export$3280a108d7f81d56;
$0a0f1cafb91d3e49$export$34e0f9847d4c02dd = `v_5TvW_container`;
$0a0f1cafb91d3e49$export$ca2f546e21dcce87 = `v_5TvW_defaultIcon`;
$0a0f1cafb91d3e49$export$42405f212471e8a2 = `v_5TvW_flag`;
$0a0f1cafb91d3e49$export$95b8526baebb372d = `v_5TvW_isoCode`;
$0a0f1cafb91d3e49$export$a8ff84c12d48cfa6 = `v_5TvW_name`;
$0a0f1cafb91d3e49$export$3280a108d7f81d56 = `v_5TvW_rightContainer`;


parcelRequire("7fPBF");


const $8ac6c8046c56b99e$export$5ebe000e8d42749 = ({ name: name, isoCode: isoCode, emoji: emoji, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).container,
        sx: {
            height: 60
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onContextMenu: onContextMenu,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).defaultIcon,
                    children: emoji ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).flag,
                                children: emoji
                            }),
                            isoCode !== "XXX" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).isoCode,
                                children: isoCode
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Flag
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).rightContainer,
                    spacing: 1,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0a0f1cafb91d3e49$exports))).name,
                        children: name
                    })
                })
            ]
        })
    });
};


const $f9c7819de5385f10$export$8726e769abd3e5c3 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedIsoCode: preselectedIsoCode, onCountrySelected: onCountrySelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const countries = (0, $883bdfc839eacb3e$export$be16c30b6123c219)(setLoading, []);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const filteredCountries = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return countries;
        return countries?.filter((country)=>{
            return country.isoCode.toLowerCase().includes(searchText.toLowerCase()) || country.isoCode2.toLowerCase().includes(searchText.toLowerCase()) || country.name.toLowerCase().includes(searchText.toLowerCase()) || country.emoji.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        countries,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredCountries,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_countries,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_countries_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        onClearValue: onClearValue,
        children: [
            filteredCountries?.map((country)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        sx: {
                            borderRadius: "20px"
                        },
                        elevation: 5,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ac6c8046c56b99e$export$5ebe000e8d42749), {
                            name: country.name,
                            isoCode: country.isoCode,
                            emoji: country.emoji,
                            onClick: ()=>{
                                if (onCountrySelected) onCountrySelected(country);
                            },
                            onContextMenu: ()=>{},
                            selected: preselectedIsoCode == country.isoCode
                        })
                    })
                }, country.isoCode)),
            loading && Array.from({
                length: 50
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 100
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($082f08034a57dd0e$exports))).skeleton
                    })
                }, index))
        ]
    });
};




const $3ed61777765bc210$export$39fa8a8bf30f5c63 = ({ open: open, onClose: onClose, originCountry: originCountry, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = originCountry ? (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).new_origin_country_title;
    const { addOriginCountry: addOriginCountry } = (0, $eb5e52d8f0eb8d44$export$d1774030618314bc)();
    const { modifyOriginCountry: modifyOriginCountry } = (0, $8d1323afa8630fa1$export$6f23c7eadc31abaa)();
    const { deleteOriginCountry: deleteOriginCountry } = (0, $2a26bfcde4469755$export$e5f4bb887c3dd830)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isCountryDesktopOpen, setIsCountryDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: originCountry?.name ?? "",
            country: originCountry?.country
        },
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async ({ name: name, country: country })=>{
            setIsLoading(true);
            if (originCountry) {
                const { status: status, body: body } = await modifyOriginCountry({
                    uuid: originCountry.uuid,
                    name: name,
                    countryIsoCode: country?.isoCode
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_origin_country_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addOriginCountry({
                    name: name,
                    countryIsoCode: country?.isoCode
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_origin_country_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!originCountry) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteOriginCountry({
            uuid: originCountry.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(originCountry);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            originCountry && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c1e67f9f24d98810$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_flag_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c1e67f9f24d98810$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "flag",
                                    name: "flag",
                                    size: "small",
                                    readOnly: true,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_flag_title,
                                    value: formik.values.country ? `${formik.values.country?.name} ${formik.values.country?.emoji}` : "",
                                    onChange: formik.handleChange,
                                    onClick: ()=>setIsCountryDesktopOpen(true),
                                    enterAction: ()=>setIsCountryDesktopOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isCountryDesktopOpen,
                onClose: ()=>setIsCountryDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9c7819de5385f10$export$8726e769abd3e5c3), {
                    handleClose: ()=>setIsCountryDesktopOpen(false),
                    columnWidth: isMobile ? 6 : 3,
                    preselectedIsoCode: formik.values.country?.isoCode,
                    onCountrySelected: async (country)=>{
                        setIsCountryDesktopOpen(false);
                        await formik.setFieldValue("country", country);
                    },
                    onClearValue: async ()=>{
                        setIsCountryDesktopOpen(false);
                        await formik.setFieldValue("country", null);
                    }
                })
            })
        ]
    });
};















const $28c64f6e15966b2f$export$ed2ced743925d732 = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getOriginCountries = (parameters)=>get("originCountries", parameters);
    const getPublicOriginCountries = (parameters)=>get("originCountries/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).tags(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicOriginCountries : getOriginCountries, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).originCountryStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};






const $63c3726884ef77bb$export$7dfca6319ee13087 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onOriginCountrySelected: onOriginCountrySelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [originCountries, resetOriginCountries, setOriginCountries, noMoreOriginCountries] = (0, $28c64f6e15966b2f$export$ed2ced743925d732)(isPublic, setLoading);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextOriginCountry, setContextOriginCountry] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredOriginCountries = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return originCountries;
        return originCountries?.filter((originCountry)=>{
            return originCountry.name.toLowerCase().includes(searchText.toLowerCase()) || originCountry.country?.isoCode?.toLowerCase().includes(searchText.toLowerCase()) || originCountry.country?.isoCode2?.toLowerCase().includes(searchText.toLowerCase()) || originCountry.country?.emoji?.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        originCountries,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredOriginCountries,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_origin_countries_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_origin_countries,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_countries_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetOriginCountries,
        onClearValue: onClearValue,
        children: [
            filteredOriginCountries?.map((originCountry)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ac6c8046c56b99e$export$5ebe000e8d42749), {
                        name: originCountry.name,
                        isoCode: originCountry.country?.isoCode,
                        emoji: originCountry.country?.emoji,
                        onClick: ()=>{
                            if (onOriginCountrySelected) onOriginCountrySelected(originCountry);
                            else openEdit(originCountry);
                        },
                        onContextMenu: (event)=>{
                            setContextOriginCountry(originCountry);
                            handleContextMenu(event);
                        },
                        selected: preselectedId == originCountry.uuid
                    })
                }, originCountry.uuid)),
            (loading || !noMoreOriginCountries) && Array.from({
                length: 20
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 60
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b6b05eac160462bf$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextOriginCountry);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ed61777765bc210$export$39fa8a8bf30f5c63), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                originCountry: modifyDialogState.item,
                onNewItem: (newOriginCountry)=>{
                    const newOriginCountries = [
                        ...originCountries,
                        newOriginCountry
                    ];
                    newOriginCountries.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setOriginCountries(newOriginCountries);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newOriginCountry)=>{
                    const newOriginCountries = originCountries.map((originCountry)=>originCountry.uuid == newOriginCountry.uuid ? newOriginCountry : originCountry);
                    newOriginCountries.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setOriginCountries(newOriginCountries);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedItem)=>{
                    const newOriginCountries = originCountries.filter((originCountry)=>originCountry.uuid != deletedItem.uuid);
                    setOriginCountries(newOriginCountries);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyDialogKey)
        ]
    });
};




const $cb3b592d5ad813c9$export$ed5201021402c0b5 = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isLoadingOriginalYear, setIsLoadingOriginalYear] = (0, $7fPBF.useState)(false);
    const [isOriginalYearPickerOpen, setIsOriginalYearPickerOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingReleaseYear, setIsLoadingReleaseYear] = (0, $7fPBF.useState)(false);
    const [isReleaseYearPickerOpen, setIsReleaseYearPickerOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingCountry, setIsLoadingCountry] = (0, $7fPBF.useState)(false);
    const [isOriginCountriesDesktopOpen, setIsOriginCountriesDesktopOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const updateOriginalYear = async (newValue)=>{
        setIsLoadingOriginalYear(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            originalYear: newValue
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingOriginalYear(false);
    };
    const updateReleaseYear = async (newValue)=>{
        setIsLoadingReleaseYear(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            releaseYear: newValue
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingReleaseYear(false);
    };
    const updateOriginCountry = async (newValue)=>{
        setIsOriginCountriesDesktopOpen(false);
        setIsLoadingCountry(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            originCountryId: newValue?.uuid ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingCountry(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
                localeText: (0, $37bec70ed65ed924$export$21c51bc433c16634).datePickerLocale.components.MuiLocalizationProvider.defaultProps.localeText,
                dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
                adapterLocale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $080f12ab26da8443$export$97b476d7a92fee62), {
                    slotProps: {
                        actionBar: {
                            actions: [
                                "clear",
                                "cancel"
                            ]
                        }
                    },
                    views: [
                        "year"
                    ],
                    format: "yyyy",
                    minDate: new Date((0, $37bec70ed65ed924$export$21c51bc433c16634).minDate),
                    value: album.originalYear ? new Date(`${album.originalYear}-06`) : null,
                    closeOnSelect: true,
                    onAccept: async (date)=>{
                        const originalYear = date == null ? null : date.getFullYear();
                        await updateOriginalYear(originalYear ? String(originalYear) : null);
                    },
                    onClose: ()=>setIsOriginalYearPickerOpen(false),
                    open: isOriginalYearPickerOpen,
                    slots: {
                        field: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                disabled: isPublic,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).original_year_title,
                                detail: album.originalYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                                onClick: ()=>setIsOriginalYearPickerOpen(true),
                                isLoading: isLoadingOriginalYear
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
                localeText: (0, $37bec70ed65ed924$export$21c51bc433c16634).datePickerLocale.components.MuiLocalizationProvider.defaultProps.localeText,
                dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
                adapterLocale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $080f12ab26da8443$export$97b476d7a92fee62), {
                    slotProps: {
                        actionBar: {
                            actions: [
                                "clear",
                                "cancel"
                            ]
                        }
                    },
                    views: [
                        "year"
                    ],
                    format: "yyyy",
                    minDate: new Date((0, $37bec70ed65ed924$export$21c51bc433c16634).minDate),
                    closeOnSelect: true,
                    value: album.releaseYear ? new Date(`${album.releaseYear}-06`) : null,
                    onAccept: async (date)=>{
                        const releaseYear = date == null ? null : date.getFullYear();
                        await updateReleaseYear(releaseYear ? String(releaseYear) : null);
                    },
                    onClose: ()=>setIsReleaseYearPickerOpen(false),
                    open: isReleaseYearPickerOpen,
                    slots: {
                        field: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                disabled: isPublic,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).release_year_title,
                                detail: album.releaseYear ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                                onClick: ()=>setIsReleaseYearPickerOpen(true),
                                isLoading: isLoadingReleaseYear
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                disabled: isPublic,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_title,
                detail: album.originCountry ? `${album.originCountry.name} ${album.originCountry.country ? `   ${album.originCountry.country.emoji}` : ""}` : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                isLoading: isLoadingCountry,
                onClick: ()=>setIsOriginCountriesDesktopOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isOriginCountriesDesktopOpen,
                onClose: ()=>setIsOriginCountriesDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c3726884ef77bb$export$7dfca6319ee13087), {
                    handleClose: ()=>{
                        setIsOriginCountriesDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: album.originCountry?.uuid,
                    onOriginCountrySelected: updateOriginCountry,
                    onClearValue: ()=>updateOriginCountry(null)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");


var $28f526a312eb0ef8$exports = {};

$parcel$export($28f526a312eb0ef8$exports, "goldmineRatingCard", function () { return $28f526a312eb0ef8$export$b7de9168974e2390; }, function (v) { return $28f526a312eb0ef8$export$b7de9168974e2390 = v; });
$parcel$export($28f526a312eb0ef8$exports, "gradeNumber", function () { return $28f526a312eb0ef8$export$5c2eafd796db2f25; }, function (v) { return $28f526a312eb0ef8$export$5c2eafd796db2f25 = v; });
var $28f526a312eb0ef8$export$b7de9168974e2390;
var $28f526a312eb0ef8$export$5c2eafd796db2f25;
$28f526a312eb0ef8$export$b7de9168974e2390 = `uvHXYq_goldmineRatingCard`;
$28f526a312eb0ef8$export$5c2eafd796db2f25 = `uvHXYq_gradeNumber`;




var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



const $a32e75c5a7570fee$export$db4bdbb22a26c9b8 = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).sleeveGradeStorage;
    const [sleeveGrades, setSleeveGrades] = (0, $7fPBF.useState)(storage.getData(false, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (sleeveGrades && sleeveGrades.length > 0) return;
        setLoading(true);
        get("sleeveGrades").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setSleeveGrades(body);
                storage.setData(body, false, "");
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
            setLoading(false);
        });
    }, dependencies);
    return sleeveGrades;
};





var $edf0f0df30e174f5$exports = {};

$parcel$export($edf0f0df30e174f5$exports, "description", function () { return $edf0f0df30e174f5$export$6d59db4903f20f7d; }, function (v) { return $edf0f0df30e174f5$export$6d59db4903f20f7d = v; });
$parcel$export($edf0f0df30e174f5$exports, "points", function () { return $edf0f0df30e174f5$export$9f048bf86ee2e9d2; }, function (v) { return $edf0f0df30e174f5$export$9f048bf86ee2e9d2 = v; });
var $edf0f0df30e174f5$export$6d59db4903f20f7d;
var $edf0f0df30e174f5$export$9f048bf86ee2e9d2;
$edf0f0df30e174f5$export$6d59db4903f20f7d = `sAfibG_description`;
$edf0f0df30e174f5$export$9f048bf86ee2e9d2 = `sAfibG_points`;


parcelRequire("7fPBF");


const $34e77951820fa03d$export$89378911561b38a8 = ({ points: points, goldmineGrading: goldmineGrading, description: description, selected: selected, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        sx: {
            height: 132,
            borderRadius: "20px"
        },
        elevation: 5,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                padding: 2
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        paddingRight: 2,
                        alignItems: "center"
                    },
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($edf0f0df30e174f5$exports))).points,
                            style: {
                                backgroundColor: theme.palette.colors?.gradeNumberBackground
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: points <= 10 ? points : "M"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                            points: points,
                            goldmineGrading: goldmineGrading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($edf0f0df30e174f5$exports))).description,
                        children: description
                    })
                })
            ]
        })
    });
};



var $4d18057fd6006685$exports = {};

$parcel$export($4d18057fd6006685$exports, "skeleton", function () { return $4d18057fd6006685$export$2a0674ff2eb10214; }, function (v) { return $4d18057fd6006685$export$2a0674ff2eb10214 = v; });
var $4d18057fd6006685$export$2a0674ff2eb10214;
$4d18057fd6006685$export$2a0674ff2eb10214 = `L83KTa_skeleton`;




const $c47ca10f45510f06$export$95ad13dd87903477 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedId: preselectedId, onSleeveGradeSelected: onSleeveGradeSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const sleeveGrades = (0, $a32e75c5a7570fee$export$db4bdbb22a26c9b8)(setLoading, []);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const filteredSleeveGrades = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return sleeveGrades;
        return sleeveGrades?.filter((sleeveGrade)=>{
            return sleeveGrade.description.toLowerCase().includes(searchText.toLowerCase()) || +searchText == sleeveGrade.points || sleeveGrade.goldmineGrade.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        sleeveGrades,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredSleeveGrades,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SLEEVE_GRADES],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_sleeve_grades,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sleeve_grades_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        onClearValue: onClearValue,
        children: [
            filteredSleeveGrades?.map((sleeveGrade)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34e77951820fa03d$export$89378911561b38a8), {
                        points: sleeveGrade.points,
                        goldmineGrading: sleeveGrade.goldmineGrade,
                        description: sleeveGrade.description,
                        selected: preselectedId == sleeveGrade.id,
                        onClick: ()=>onSleeveGradeSelected(sleeveGrade)
                    })
                }, sleeveGrade.id)),
            loading && Array.from({
                length: 11
            }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 132
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4d18057fd6006685$exports))).skeleton
                    })
                }, index))
        ]
    });
};






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



const $2e2c1a66d5f0caf0$export$45b4e9f92d124b7b = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).mediaGradeStorage;
    const [mediaGrades, setMediaGrades] = (0, $7fPBF.useState)(storage.getData(false, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (mediaGrades && mediaGrades.length > 0) return;
        setLoading(true);
        get("mediaGrades").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setMediaGrades(body);
                storage.setData(body, false, "");
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
            setLoading(false);
        });
    }, dependencies);
    return mediaGrades;
};






var $5d78f7f9aadd21b2$exports = {};

$parcel$export($5d78f7f9aadd21b2$exports, "skeleton", function () { return $5d78f7f9aadd21b2$export$2a0674ff2eb10214; }, function (v) { return $5d78f7f9aadd21b2$export$2a0674ff2eb10214 = v; });
var $5d78f7f9aadd21b2$export$2a0674ff2eb10214;
$5d78f7f9aadd21b2$export$2a0674ff2eb10214 = `_AuOqq_skeleton`;




const $46069ed848225382$export$4360e90a91115162 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedId: preselectedId, onMediaGradeSelected: onMediaGradeSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const mediaGrades = (0, $2e2c1a66d5f0caf0$export$45b4e9f92d124b7b)(setLoading, []);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const filteredMediaGrades = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return mediaGrades;
        return mediaGrades?.filter((mediaGrade)=>{
            return mediaGrade.description.toLowerCase().includes(searchText.toLowerCase()) || +searchText == mediaGrade.points || mediaGrade.goldmineGrade.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        mediaGrades,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredMediaGrades,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).MEDIA_GRADES],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_media_grades,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_media_grades_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        onClearValue: onClearValue,
        children: [
            filteredMediaGrades?.map((mediaGrade)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34e77951820fa03d$export$89378911561b38a8), {
                        points: mediaGrade.points,
                        goldmineGrading: mediaGrade.goldmineGrade,
                        description: mediaGrade.description,
                        selected: preselectedId == mediaGrade.id,
                        onClick: ()=>onMediaGradeSelected?.(mediaGrade)
                    })
                }, mediaGrade.id)),
            loading && Array.from({
                length: 11
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 132
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5d78f7f9aadd21b2$exports))).skeleton
                    })
                }, index))
        ]
    });
};



parcelRequire("7fPBF");
var $ce5ee1831a0f7445$exports = {};

$parcel$export($ce5ee1831a0f7445$exports, "itemDiv", function () { return $ce5ee1831a0f7445$export$64c46d98173ac23d; }, function (v) { return $ce5ee1831a0f7445$export$64c46d98173ac23d = v; });
$parcel$export($ce5ee1831a0f7445$exports, "loadingIndicator", function () { return $ce5ee1831a0f7445$export$f10e6b4aaa94c253; }, function (v) { return $ce5ee1831a0f7445$export$f10e6b4aaa94c253 = v; });
$parcel$export($ce5ee1831a0f7445$exports, "title", function () { return $ce5ee1831a0f7445$export$fb184b623420d9be; }, function (v) { return $ce5ee1831a0f7445$export$fb184b623420d9be = v; });
$parcel$export($ce5ee1831a0f7445$exports, "toggleButton", function () { return $ce5ee1831a0f7445$export$c3f9788a1ddcf2d9; }, function (v) { return $ce5ee1831a0f7445$export$c3f9788a1ddcf2d9 = v; });
$parcel$export($ce5ee1831a0f7445$exports, "value", function () { return $ce5ee1831a0f7445$export$2ab9a8f9f1186f14; }, function (v) { return $ce5ee1831a0f7445$export$2ab9a8f9f1186f14 = v; });
var $ce5ee1831a0f7445$export$64c46d98173ac23d;
var $ce5ee1831a0f7445$export$f10e6b4aaa94c253;
var $ce5ee1831a0f7445$export$fb184b623420d9be;
var $ce5ee1831a0f7445$export$c3f9788a1ddcf2d9;
var $ce5ee1831a0f7445$export$2ab9a8f9f1186f14;
$ce5ee1831a0f7445$export$64c46d98173ac23d = `pFkcLW_itemDiv`;
$ce5ee1831a0f7445$export$f10e6b4aaa94c253 = `pFkcLW_loadingIndicator`;
$ce5ee1831a0f7445$export$fb184b623420d9be = `pFkcLW_title`;
$ce5ee1831a0f7445$export$c3f9788a1ddcf2d9 = `pFkcLW_toggleButton`;
$ce5ee1831a0f7445$export$2ab9a8f9f1186f14 = `pFkcLW_value`;






const $dabf552c7b045a24$export$171c84513d3b85f9 = ({ isPublic: isPublic, className: className, titleWeight: titleWeight, hideIsGatefold: hideIsGatefold, hideIsClean: hideIsClean, isCleanLoading: isCleanLoading, isGatefoldLoading: isGatefoldLoading, hasLyricsLoading: hasLyricsLoading, hasInsertLoading: hasInsertLoading, isGatefold: isGatefold, hasInsert: hasInsert, hasLyrics: hasLyrics, isClean: isClean, onIsGatefoldChanged: onIsGatefoldChanged, onHasInsertChanged: onHasInsertChanged, onHasLyricsChanged: onHasLyricsChanged, onIsCleanChanged: onIsCleanChanged })=>{
    const toggleIsClean = ()=>{
        if (isCleanLoading || isPublic) return;
        onIsCleanChanged(!isClean);
    };
    const toggleIsGatefold = ()=>{
        if (isGatefoldLoading || isPublic) return;
        onIsGatefoldChanged(!isGatefold);
    };
    const toggleHasInsert = ()=>{
        if (hasInsertLoading || isPublic) return;
        onHasInsertChanged(!hasInsert);
    };
    const toggleHasLyrics = ()=>{
        if (hasLyricsLoading || isPublic) return;
        onHasLyricsChanged(!hasLyrics);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).itemDiv,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                container: true,
                flexGrow: 1,
                spacing: 2,
                children: [
                    !hideIsClean && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).title,
                                    style: {
                                        fontWeight: titleWeight
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_clean_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                    style: {
                                        height: "32px"
                                    },
                                    onClick: toggleIsClean,
                                    children: isCleanLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).loadingIndicator
                                    }) : isClean ? (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes : (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).title,
                                    style: {
                                        fontWeight: titleWeight
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_insert_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                    style: {
                                        height: "32px"
                                    },
                                    onClick: toggleHasInsert,
                                    children: hasInsertLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).loadingIndicator
                                    }) : hasInsert ? (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes : (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).title,
                                    style: {
                                        fontWeight: titleWeight
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_lyrics_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                    style: {
                                        height: "32px"
                                    },
                                    onClick: toggleHasLyrics,
                                    children: hasLyricsLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).loadingIndicator
                                    }) : hasLyrics ? (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes : (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                })
                            ]
                        })
                    }),
                    !hideIsGatefold && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).title,
                                    style: {
                                        fontWeight: titleWeight
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_gatefold_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                    style: {
                                        height: "32px"
                                    },
                                    onClick: toggleIsGatefold,
                                    children: isGatefoldLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce5ee1831a0f7445$exports))).loadingIndicator
                                    }) : isGatefold ? (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes : (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};









const $ceb466222f534ad1$export$84cfd20e202eb3e8 = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [isCleanLoading, setIsCleanLoading] = (0, $7fPBF.useState)(false);
    const [isGatefoldLoading, setIsGatefoldLoading] = (0, $7fPBF.useState)(false);
    const [hasLyricsLoading, setHasLyricsLoading] = (0, $7fPBF.useState)(false);
    const [hasInsertLoading, setHasInsertLoading] = (0, $7fPBF.useState)(false);
    const [isSleeveGradeLoading, setIsSleeveGradeLoading] = (0, $7fPBF.useState)(false);
    const [isSleeveGradesDialogOpen, setIsSleeveGradesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isMediaGradeLoading, setIsMediaGradeLoading] = (0, $7fPBF.useState)(false);
    const [isMediaGradesDialogOpen, setIsMediaGradesDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const updateAlbumAttribute = async (parameters)=>{
        const { status: status, body: body } = await updateAlbum(parameters);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
    };
    const updateMediaGrade = async (newValue)=>{
        setIsMediaGradeLoading(true);
        setIsMediaGradesDialogOpen(false);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            mediaGradeId: newValue?.id ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsMediaGradeLoading(false);
    };
    const updateSleeveGrade = async (newValue)=>{
        setIsSleeveGradeLoading(true);
        setIsSleeveGradesDialogOpen(false);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            sleeveGradeId: newValue?.id ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsSleeveGradeLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                disabled: isPublic,
                title: album.isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).sleeve_grade_box_set_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).sleeve_grade_title,
                detail: album.sleeveGrade ? undefined : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                leftSubtitle: album.sleeveGrade?.description,
                isLoading: isSleeveGradeLoading,
                onClick: ()=>setIsSleeveGradesDialogOpen(true),
                children: album.sleeveGrade && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($28f526a312eb0ef8$exports))).gradeNumber,
                            children: (0, $b62e530123cc4921$export$465c3b2548d10f1a).getGoldmineGradePoints(album.sleeveGrade.points)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($28f526a312eb0ef8$exports))).goldmineRatingCard,
                            points: album.sleeveGrade.points,
                            goldmineGrading: album.sleeveGrade.goldmineGrade
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            !album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                        disabled: isPublic,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).media_grade_singular_title,
                        detail: album.mediaGrade ? undefined : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                        leftSubtitle: album.mediaGrade?.description,
                        isLoading: isMediaGradeLoading,
                        onClick: ()=>setIsMediaGradesDialogOpen(true),
                        children: album.mediaGrade && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($28f526a312eb0ef8$exports))).gradeNumber,
                                    children: (0, $b62e530123cc4921$export$465c3b2548d10f1a).getGoldmineGradePoints(album.mediaGrade.points)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($28f526a312eb0ef8$exports))).goldmineRatingCard,
                                    points: album.mediaGrade.points,
                                    goldmineGrading: album.mediaGrade.goldmineGrade
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dabf552c7b045a24$export$171c84513d3b85f9), {
                isPublic: isPublic,
                titleWeight: "regular",
                hideIsGatefold: isPublic && album.isGatefold === undefined || album.isBoxSet,
                hideIsClean: isPublic && album.isClean === undefined,
                isCleanLoading: isCleanLoading,
                isGatefoldLoading: isGatefoldLoading,
                hasLyricsLoading: hasLyricsLoading,
                hasInsertLoading: hasInsertLoading,
                onHasInsertChanged: async (newValue)=>{
                    setHasInsertLoading(true);
                    await updateAlbumAttribute({
                        uuid: album.uuid,
                        hasInsert: newValue
                    });
                    setHasInsertLoading(false);
                },
                onHasLyricsChanged: async (newValue)=>{
                    setHasLyricsLoading(true);
                    await updateAlbumAttribute({
                        uuid: album.uuid,
                        hasLyrics: newValue
                    });
                    setHasLyricsLoading(false);
                },
                onIsCleanChanged: async (newValue)=>{
                    setIsCleanLoading(true);
                    await updateAlbumAttribute({
                        uuid: album.uuid,
                        isClean: newValue
                    });
                    setIsCleanLoading(false);
                },
                onIsGatefoldChanged: async (newValue)=>{
                    setIsGatefoldLoading(true);
                    await updateAlbumAttribute({
                        uuid: album.uuid,
                        isGatefold: newValue
                    });
                    setIsGatefoldLoading(false);
                },
                isGatefold: album.isGatefold,
                hasInsert: album.hasInsert,
                hasLyrics: album.hasLyrics,
                isClean: album.isClean
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSleeveGradesDialogOpen,
                onClose: ()=>setIsSleeveGradesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c47ca10f45510f06$export$95ad13dd87903477), {
                    handleClose: ()=>{
                        setIsSleeveGradesDialogOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: album.sleeveGrade?.id,
                    onSleeveGradeSelected: updateSleeveGrade,
                    onClearValue: ()=>updateSleeveGrade(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isMediaGradesDialogOpen,
                onClose: ()=>setIsMediaGradesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46069ed848225382$export$4360e90a91115162), {
                    handleClose: ()=>{
                        setIsMediaGradesDialogOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: album.mediaGrade?.id,
                    onMediaGradeSelected: updateMediaGrade,
                    onClearValue: ()=>updateMediaGrade(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");




var $8474a4292f77e225$exports = {};

$parcel$export($8474a4292f77e225$exports, "newPrice", function () { return $8474a4292f77e225$export$bf2b2c68f2d3892d; }, function (v) { return $8474a4292f77e225$export$bf2b2c68f2d3892d = v; });
$parcel$export($8474a4292f77e225$exports, "oldPrice", function () { return $8474a4292f77e225$export$9853811e0e64ec55; }, function (v) { return $8474a4292f77e225$export$9853811e0e64ec55 = v; });
var $8474a4292f77e225$export$bf2b2c68f2d3892d;
var $8474a4292f77e225$export$9853811e0e64ec55;
$8474a4292f77e225$export$bf2b2c68f2d3892d = `HQLuba_newPrice`;
$8474a4292f77e225$export$9853811e0e64ec55 = `HQLuba_oldPrice`;




var $7fPBF = parcelRequire("7fPBF");
var $779da55ea61d8503$exports = {};

$parcel$export($779da55ea61d8503$exports, "name", function () { return $779da55ea61d8503$export$a8ff84c12d48cfa6; }, function (v) { return $779da55ea61d8503$export$a8ff84c12d48cfa6 = v; });
$parcel$export($779da55ea61d8503$exports, "skeleton", function () { return $779da55ea61d8503$export$2a0674ff2eb10214; }, function (v) { return $779da55ea61d8503$export$2a0674ff2eb10214 = v; });
var $779da55ea61d8503$export$a8ff84c12d48cfa6;
var $779da55ea61d8503$export$2a0674ff2eb10214;
$779da55ea61d8503$export$a8ff84c12d48cfa6 = `xEL1oW_name`;
$779da55ea61d8503$export$2a0674ff2eb10214 = `xEL1oW_skeleton`;










const $b875bd0c2fe4e8c9$export$73059e8069da4c15 = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getStores = (parameters)=>get("stores", parameters);
    const getPublicStores = (parameters)=>get("stores/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).stores(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicStores : getStores, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).storeStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $8bb24cd1f7000afb$exports = {};

$parcel$export($8bb24cd1f7000afb$exports, "cancelButton", function () { return $8bb24cd1f7000afb$export$4ededb8e5b56a6fb; }, function (v) { return $8bb24cd1f7000afb$export$4ededb8e5b56a6fb = v; });
$parcel$export($8bb24cd1f7000afb$exports, "loadingDiv", function () { return $8bb24cd1f7000afb$export$dded2af20345efaa; }, function (v) { return $8bb24cd1f7000afb$export$dded2af20345efaa = v; });
$parcel$export($8bb24cd1f7000afb$exports, "profileCard", function () { return $8bb24cd1f7000afb$export$56d7158379169459; }, function (v) { return $8bb24cd1f7000afb$export$56d7158379169459 = v; });
$parcel$export($8bb24cd1f7000afb$exports, "textField", function () { return $8bb24cd1f7000afb$export$c54b92c0bb02ba64; }, function (v) { return $8bb24cd1f7000afb$export$c54b92c0bb02ba64 = v; });
var $8bb24cd1f7000afb$export$4ededb8e5b56a6fb;
var $8bb24cd1f7000afb$export$dded2af20345efaa;
var $8bb24cd1f7000afb$export$56d7158379169459;
var $8bb24cd1f7000afb$export$c54b92c0bb02ba64;
$8bb24cd1f7000afb$export$4ededb8e5b56a6fb = `iSVoeW_cancelButton`;
$8bb24cd1f7000afb$export$dded2af20345efaa = `iSVoeW_loadingDiv`;
$8bb24cd1f7000afb$export$56d7158379169459 = `iSVoeW_profileCard`;
$8bb24cd1f7000afb$export$c54b92c0bb02ba64 = `iSVoeW_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $a76a3bd8f918412d$export$25013c23f574823d = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addStore = (parameters)=>post("stores", parameters);
    return {
        addStore: addStore
    };
};



const $b6b437e3076f1a88$export$cf3092f30e292afa = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyStore = (parameters)=>put("stores", parameters);
    return {
        modifyStore: modifyStore
    };
};



const $4738b56599a2bbf8$export$3680b90bc14d7c2 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteStore = (parameters)=>deleteRequest("stores", parameters);
    return {
        deleteStore: deleteStore
    };
};















const $e42c179537b46040$export$23caad1a0b1e80bf = ({ open: open, onClose: onClose, store: store, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = store ? (0, $37bec70ed65ed924$export$21c51bc433c16634).store_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).ms_new_title;
    const { addStore: addStore } = (0, $a76a3bd8f918412d$export$25013c23f574823d)();
    const { modifyStore: modifyStore } = (0, $b6b437e3076f1a88$export$cf3092f30e292afa)();
    const { deleteStore: deleteStore } = (0, $4738b56599a2bbf8$export$3680b90bc14d7c2)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isModifyProfileDialogOpen, setIsModifyProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).ms_missing_error)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: store?.name ?? "",
            address: store?.address ?? "",
            profile: store?.profile ?? "",
            website: store?.website ?? ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async ({ name: name, address: address, website: website, profile: profile })=>{
            setIsLoading(true);
            if (store) {
                const { status: status, body: body } = await modifyStore({
                    uuid: store.uuid,
                    name: name,
                    address: address,
                    website: website,
                    profile: profile
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_store_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addStore({
                    name: name,
                    address: address,
                    website: website,
                    profile: profile
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_store_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!store) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteStore({
            uuid: store.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(store);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            store && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ms_field_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bb24cd1f7000afb$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ms_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bb24cd1f7000afb$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "website",
                                    name: "website",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_website_placeholder,
                                    value: formik.values.website,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bb24cd1f7000afb$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.profile ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyProfileDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_profile_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_profile_placeholder,
                value: formik.values.profile,
                open: isModifyProfileDialogOpen,
                onClose: ()=>setIsModifyProfileDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("profile", newValue),
                onClearValue: ()=>formik.setFieldValue("profile", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).STORES,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};










var $281a85e4a42430c0$exports = {};

$parcel$export($281a85e4a42430c0$exports, "container", function () { return $281a85e4a42430c0$export$34e0f9847d4c02dd; }, function (v) { return $281a85e4a42430c0$export$34e0f9847d4c02dd = v; });
$parcel$export($281a85e4a42430c0$exports, "defaultIcon", function () { return $281a85e4a42430c0$export$ca2f546e21dcce87; }, function (v) { return $281a85e4a42430c0$export$ca2f546e21dcce87 = v; });
$parcel$export($281a85e4a42430c0$exports, "description", function () { return $281a85e4a42430c0$export$6d59db4903f20f7d; }, function (v) { return $281a85e4a42430c0$export$6d59db4903f20f7d = v; });
$parcel$export($281a85e4a42430c0$exports, "hoverButton", function () { return $281a85e4a42430c0$export$b0260c0afbf48c57; }, function (v) { return $281a85e4a42430c0$export$b0260c0afbf48c57 = v; });
$parcel$export($281a85e4a42430c0$exports, "hoverButtonIcon", function () { return $281a85e4a42430c0$export$2a797adc03a2480; }, function (v) { return $281a85e4a42430c0$export$2a797adc03a2480 = v; });
$parcel$export($281a85e4a42430c0$exports, "hoverButtonsStack", function () { return $281a85e4a42430c0$export$a8eacba2c33c9f28; }, function (v) { return $281a85e4a42430c0$export$a8eacba2c33c9f28 = v; });
$parcel$export($281a85e4a42430c0$exports, "name", function () { return $281a85e4a42430c0$export$a8ff84c12d48cfa6; }, function (v) { return $281a85e4a42430c0$export$a8ff84c12d48cfa6 = v; });
$parcel$export($281a85e4a42430c0$exports, "rightContainer", function () { return $281a85e4a42430c0$export$3280a108d7f81d56; }, function (v) { return $281a85e4a42430c0$export$3280a108d7f81d56 = v; });
var $281a85e4a42430c0$export$34e0f9847d4c02dd;
var $281a85e4a42430c0$export$ca2f546e21dcce87;
var $281a85e4a42430c0$export$6d59db4903f20f7d;
var $281a85e4a42430c0$export$b0260c0afbf48c57;
var $281a85e4a42430c0$export$2a797adc03a2480;
var $281a85e4a42430c0$export$a8eacba2c33c9f28;
var $281a85e4a42430c0$export$a8ff84c12d48cfa6;
var $281a85e4a42430c0$export$3280a108d7f81d56;
$281a85e4a42430c0$export$34e0f9847d4c02dd = `K4MibW_container`;
$281a85e4a42430c0$export$ca2f546e21dcce87 = `K4MibW_defaultIcon`;
$281a85e4a42430c0$export$6d59db4903f20f7d = `K4MibW_description`;
$281a85e4a42430c0$export$b0260c0afbf48c57 = `K4MibW_hoverButton`;
$281a85e4a42430c0$export$2a797adc03a2480 = `K4MibW_hoverButtonIcon`;
$281a85e4a42430c0$export$a8eacba2c33c9f28 = `K4MibW_hoverButtonsStack`;
$281a85e4a42430c0$export$a8ff84c12d48cfa6 = `K4MibW_name`;
$281a85e4a42430c0$export$3280a108d7f81d56 = `K4MibW_rightContainer`;


parcelRequire("7fPBF");


const $f5d31b57003e7100$export$24f2ebac89abe3ec = ({ store: store, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($281a85e4a42430c0$exports))).container,
        sx: {
            height: 60
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onContextMenu: onContextMenu,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($281a85e4a42430c0$exports))).defaultIcon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Store
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($281a85e4a42430c0$exports))).rightContainer,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($281a85e4a42430c0$exports))).name,
                            children: store.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($281a85e4a42430c0$exports))).description,
                            children: store.profile
                        })
                    ]
                })
            ]
        })
    });
};


const $5c0c8fd0aacbcfe9$export$1f4e316d688f3260 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onStoreSelected: onStoreSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [stores, resetStores, setStores, noMoreStores] = (0, $b875bd0c2fe4e8c9$export$73059e8069da4c15)(isPublic, setLoading);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextStore, setContextStore] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredStores = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return stores;
        return stores?.filter((store)=>{
            return store.name.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        stores,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredStores,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).STORES],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_stores_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_stores,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_stores_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetStores,
        onClearValue: onClearValue,
        children: [
            filteredStores?.map((store)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5d31b57003e7100$export$24f2ebac89abe3ec), {
                        store: store,
                        selected: preselectedId === store.uuid,
                        onClick: ()=>{
                            if (onStoreSelected) onStoreSelected(store);
                            else openEdit(store);
                        },
                        onContextMenu: (event)=>{
                            setContextStore(store);
                            handleContextMenu(event);
                        }
                    })
                }, store.uuid)),
            (loading || !noMoreStores) && Array.from({
                length: 40
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 60
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($779da55ea61d8503$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextStore);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e42c179537b46040$export$23caad1a0b1e80bf), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                store: modifyDialogState.item,
                onNewItem: (newStore)=>{
                    const newStores = [
                        ...stores,
                        newStore
                    ];
                    newStores.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setStores(newStores);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newStore)=>{
                    const newStores = stores.map((store)=>store.uuid == newStore.uuid ? newStore : store);
                    newStores.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setStores(newStores);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedStore)=>{
                    const newStores = stores.filter((store)=>store.uuid != deletedStore.uuid);
                    setStores(newStores);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyDialogKey)
        ]
    });
};







var $7fPBF = parcelRequire("7fPBF");








const $d5ab2b75dd4fca3e$export$7b284debd6c5f39a = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getSellValues = (parameters)=>get("sellValues", parameters);
    const getPublicSellValues = (parameters)=>get("sellValues/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).sellValues(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicSellValues : getSellValues, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).sellValueStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $4e841c2014238500$exports = {};

$parcel$export($4e841c2014238500$exports, "cancelButton", function () { return $4e841c2014238500$export$4ededb8e5b56a6fb; }, function (v) { return $4e841c2014238500$export$4ededb8e5b56a6fb = v; });
$parcel$export($4e841c2014238500$exports, "loadingDiv", function () { return $4e841c2014238500$export$dded2af20345efaa; }, function (v) { return $4e841c2014238500$export$dded2af20345efaa = v; });
$parcel$export($4e841c2014238500$exports, "profileCard", function () { return $4e841c2014238500$export$56d7158379169459; }, function (v) { return $4e841c2014238500$export$56d7158379169459 = v; });
$parcel$export($4e841c2014238500$exports, "textField", function () { return $4e841c2014238500$export$c54b92c0bb02ba64; }, function (v) { return $4e841c2014238500$export$c54b92c0bb02ba64 = v; });
var $4e841c2014238500$export$4ededb8e5b56a6fb;
var $4e841c2014238500$export$dded2af20345efaa;
var $4e841c2014238500$export$56d7158379169459;
var $4e841c2014238500$export$c54b92c0bb02ba64;
$4e841c2014238500$export$4ededb8e5b56a6fb = `gmynLq_cancelButton`;
$4e841c2014238500$export$dded2af20345efaa = `gmynLq_loadingDiv`;
$4e841c2014238500$export$56d7158379169459 = `gmynLq_profileCard`;
$4e841c2014238500$export$c54b92c0bb02ba64 = `gmynLq_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $9422bc51a61518cb$export$6e23619631a0173a = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addSellValue = (parameters)=>post("sellValues", parameters);
    return {
        addSellValue: addSellValue
    };
};



const $8787b074026d0989$export$bf49ef66b8b33e2d = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifySellValue = (parameters)=>put("sellValues", parameters);
    return {
        modifySellValue: modifySellValue
    };
};



const $4ee26d6ab3fd5b7b$export$60591af1ca4326a0 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteSellValue = (parameters)=>deleteRequest("sellValues", parameters);
    return {
        deleteSellValue: deleteSellValue
    };
};















const $c1fdbc92a6c01a13$export$65addeea2c2d101e = ({ open: open, onClose: onClose, sellValue: sellValue, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = sellValue ? (0, $37bec70ed65ed924$export$21c51bc433c16634).sell_value_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_new_title;
    const { addSellValue: addSellValue } = (0, $9422bc51a61518cb$export$6e23619631a0173a)();
    const { modifySellValue: modifySellValue } = (0, $8787b074026d0989$export$bf49ef66b8b33e2d)();
    const { deleteSellValue: deleteSellValue } = (0, $4ee26d6ab3fd5b7b$export$60591af1ca4326a0)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        group: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).msv_missing_error),
        dollars: $57e52f3b537dfd4b$export$98e628dec113755e().typeError((0, $37bec70ed65ed924$export$21c51bc433c16634).not_number_error).required((0, $37bec70ed65ed924$export$21c51bc433c16634).msv_missing_error)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            group: sellValue?.group ?? "",
            dollars: sellValue?.dollars ?? 0,
            description: sellValue?.description ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ group: group, dollars: dollars, description: description })=>{
            setIsLoading(true);
            if (sellValue) {
                const { status: status, body: body } = await modifySellValue({
                    uuid: sellValue.uuid,
                    group: group,
                    dollars: dollars,
                    description: description
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_sellvalue_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addSellValue({
                    group: group,
                    dollars: dollars,
                    description: description
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_sellvalue_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!sellValue) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteSellValue({
            uuid: sellValue.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(sellValue);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            sellValue && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_group_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e841c2014238500$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "group",
                                    name: "group",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_group_placeholder,
                                    value: formik.values.group,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_dollars_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e841c2014238500$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "dollars",
                                    name: "dollars",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_dollars_placeholder,
                                    value: formik.values.dollars,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).msv_description_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e841c2014238500$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).SELL_VALUES,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};



var $31915dff37081b66$exports = {};

$parcel$export($31915dff37081b66$exports, "brand", function () { return $31915dff37081b66$export$96ff94e0adb1d772; }, function (v) { return $31915dff37081b66$export$96ff94e0adb1d772 = v; });
$parcel$export($31915dff37081b66$exports, "cardArea", function () { return $31915dff37081b66$export$37708c1ec80826a0; }, function (v) { return $31915dff37081b66$export$37708c1ec80826a0 = v; });
$parcel$export($31915dff37081b66$exports, "container", function () { return $31915dff37081b66$export$34e0f9847d4c02dd; }, function (v) { return $31915dff37081b66$export$34e0f9847d4c02dd = v; });
$parcel$export($31915dff37081b66$exports, "defaultIcon", function () { return $31915dff37081b66$export$ca2f546e21dcce87; }, function (v) { return $31915dff37081b66$export$ca2f546e21dcce87 = v; });
$parcel$export($31915dff37081b66$exports, "inactiveCard", function () { return $31915dff37081b66$export$31fcb46b29e0bdbc; }, function (v) { return $31915dff37081b66$export$31fcb46b29e0bdbc = v; });
$parcel$export($31915dff37081b66$exports, "name", function () { return $31915dff37081b66$export$a8ff84c12d48cfa6; }, function (v) { return $31915dff37081b66$export$a8ff84c12d48cfa6 = v; });
$parcel$export($31915dff37081b66$exports, "profile", function () { return $31915dff37081b66$export$4882ae973e0491e; }, function (v) { return $31915dff37081b66$export$4882ae973e0491e = v; });
$parcel$export($31915dff37081b66$exports, "rightContainer", function () { return $31915dff37081b66$export$3280a108d7f81d56; }, function (v) { return $31915dff37081b66$export$3280a108d7f81d56 = v; });
var $31915dff37081b66$export$96ff94e0adb1d772;
var $31915dff37081b66$export$37708c1ec80826a0;
var $31915dff37081b66$export$34e0f9847d4c02dd;
var $31915dff37081b66$export$ca2f546e21dcce87;
var $31915dff37081b66$export$31fcb46b29e0bdbc;
var $31915dff37081b66$export$a8ff84c12d48cfa6;
var $31915dff37081b66$export$4882ae973e0491e;
var $31915dff37081b66$export$3280a108d7f81d56;
$31915dff37081b66$export$96ff94e0adb1d772 = `_qgrLq_brand`;
$31915dff37081b66$export$37708c1ec80826a0 = `_qgrLq_cardArea`;
$31915dff37081b66$export$34e0f9847d4c02dd = `_qgrLq_container`;
$31915dff37081b66$export$ca2f546e21dcce87 = `_qgrLq_defaultIcon`;
$31915dff37081b66$export$31fcb46b29e0bdbc = `_qgrLq_inactiveCard`;
$31915dff37081b66$export$a8ff84c12d48cfa6 = `_qgrLq_name`;
$31915dff37081b66$export$4882ae973e0491e = `_qgrLq_profile`;
$31915dff37081b66$export$3280a108d7f81d56 = `_qgrLq_rightContainer`;


parcelRequire("7fPBF");




const $d417f779fef5dcb3$export$3d16b01ada12ecf9 = ({ sellValue: sellValue, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).container,
        sx: {
            height: 80
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).cardArea,
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).defaultIcon,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PriceChange
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: -2,
                                backgroundColor: theme.palette.colors.buttonBackground
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).inactiveCard,
                                children: `${currencyFormatter.format(sellValue.dollars, currentUserProfile, false, 2, "USD")}`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).rightContainer,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).name,
                            children: sellValue.group
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($31915dff37081b66$exports))).profile,
                            children: sellValue.description
                        })
                    ]
                })
            ]
        })
    });
};





var $16d2f1e5e5fce72d$exports = {};

$parcel$export($16d2f1e5e5fce72d$exports, "skeleton", function () { return $16d2f1e5e5fce72d$export$2a0674ff2eb10214; }, function (v) { return $16d2f1e5e5fce72d$export$2a0674ff2eb10214 = v; });
var $16d2f1e5e5fce72d$export$2a0674ff2eb10214;
$16d2f1e5e5fce72d$export$2a0674ff2eb10214 = `YoscdW_skeleton`;






const $70b19905e559553e$export$b70de0c9f92ac064 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onSellValueSelected: onSellValueSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [sellValues, resetSellValues, setSellValues, noMoreSellValues] = (0, $d5ab2b75dd4fca3e$export$7b284debd6c5f39a)(isPublic, setLoading);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextSellValue, setContextSellValue] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredSellValues = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return sellValues;
        return sellValues?.filter((sellValue)=>{
            return sellValue.group.toLowerCase().includes(searchText.toLowerCase()) || sellValue.dollars.toString().toLowerCase().includes(searchText.toLowerCase()) || sellValue.description.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        sellValues,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredSellValues,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SELL_VALUES],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_sell_values_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_sell_values,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sell_values_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetSellValues,
        onClearValue: onClearValue,
        children: [
            filteredSellValues?.map((sellValue)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d417f779fef5dcb3$export$3d16b01ada12ecf9), {
                        sellValue: sellValue,
                        selected: preselectedId == sellValue.uuid,
                        onClick: ()=>{
                            if (onSellValueSelected) onSellValueSelected(sellValue);
                            else openEdit(sellValue);
                        },
                        onContextMenu: (event)=>{
                            setContextSellValue(sellValue);
                            handleContextMenu(event);
                        }
                    })
                }, sellValue.uuid)),
            (loading || !noMoreSellValues) && Array.from({
                length: 40
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 80
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($16d2f1e5e5fce72d$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextSellValue);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1fdbc92a6c01a13$export$65addeea2c2d101e), {
                open: modifyDialogState.mode !== "closed",
                sellValue: modifyDialogState.item,
                onClose: closeModifyDialog,
                onNewItem: (newSellValue)=>{
                    const newSellValues = [
                        ...sellValues,
                        newSellValue
                    ];
                    newSellValues.sort((a, b)=>a.group.localeCompare(b.group, undefined, {
                            ignorePunctuation: true
                        }));
                    setSellValues(newSellValues);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newSellValue)=>{
                    const newSellValues = sellValues.map((sellValue)=>sellValue.uuid == newSellValue.uuid ? newSellValue : sellValue);
                    newSellValues.sort((a, b)=>a.group.localeCompare(b.group, undefined, {
                            ignorePunctuation: true
                        }));
                    setSellValues(newSellValues);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedSellValue)=>{
                    const newSellValues = sellValues.filter((sellValue)=>sellValue.uuid != deletedSellValue.uuid);
                    setSellValues(newSellValues);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyDialogKey)
        ]
    });
};















const $ee18455eb7f008bb$export$fbcda3e36df6b7ab = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [currentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const collectionManager = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [isStoresDialogOpen, setIsStoresDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingStore, setIsLoadingStore] = (0, $7fPBF.useState)(false);
    const { state: purchasePriceDialogState, key: purchasePriceDialogKey, openAdd: openPurchasePriceDialog, close: closePurchasePriceDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isLoadingPurchasePrice, setIsLoadingPurchasePrice] = (0, $7fPBF.useState)(false);
    const [isSellValuesDialogOpen, setIsSellValuesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingSellValue, setIsLoadingSellValue] = (0, $7fPBF.useState)(false);
    const [isPurchaseDatePickerOpen, setIsPurchaseDatePickerOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingPurchaseDate, setIsLoadingPurchaseDate] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    let isRevenueNegative = false;
    const userProfile = isPublic ? currentPublicUserProfile : currentUserProfile;
    const getRevenue = (purchasePrice, sellValue)=>{
        const revenue = sellValue - purchasePrice;
        isRevenueNegative = revenue < 0;
        return currencyFormatter.format(revenue, userProfile, isPublic, 2);
    };
    const getPurchaseDate = ()=>{
        if (album.purchaseDate) return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(album.purchaseDate * 1000, "d MMMM yyyy", {
            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
        });
        return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
    };
    const updatePurchasePrice = async (newValue)=>{
        setIsLoadingPurchasePrice(true);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            purchasePrice: newValue
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingPurchasePrice(false);
    };
    const updateSellValue = async (newValue)=>{
        setIsSellValuesDialogOpen(false);
        setIsLoadingSellValue(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            sellValueId: newValue?.uuid ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingSellValue(false);
    };
    const updateStore = async (newValue)=>{
        setIsStoresDialogOpen(false);
        setIsLoadingStore(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            storeId: newValue?.uuid ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingStore(false);
    };
    const sellValueDetail = ()=>{
        if (!album.sellValue?.pesos) return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
        const currentCollection = collectionManager.getCurrentCollection(isPublic);
        if (currentCollection && currentCollection.discount > 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8474a4292f77e225$exports))).oldPrice,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: currencyFormatter.format(album.sellValue?.pesos, userProfile, isPublic, 2)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8474a4292f77e225$exports))).newPrice,
                    children: currencyFormatter.format((album.sellValue?.pesos ?? 0) * (1 - currentCollection.discount), userProfile, isPublic, 2)
                })
            ]
        });
        else return currencyFormatter.format(album.sellValue?.pesos, userProfile, isPublic, 2);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            !(isPublic && album.purchasePrice === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                        disabled: isPublic,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_title,
                        detail: album.purchasePriceToday != null ? currencyFormatter.format(album.purchasePriceToday, userProfile, isPublic, 2) : album.purchasePrice == null ? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown : album.purchaseDate ? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown : `${(0, $37bec70ed65ed924$export$21c51bc433c16634).unknown} (${(0, $37bec70ed65ed924$export$21c51bc433c16634).missing_purchase_date})`,
                        detailBlurred: !isPublic && currentUser?.role == "guest",
                        subtitle: album.purchasePrice != null ? album.purchasePriceDollars != null ? (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_detail_dollars, currencyFormatter.format(album.purchasePrice, userProfile, isPublic, 2), currencyFormatter.format(album.purchasePriceDollars, userProfile, isPublic, 2, "USD")) : (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_detail, currencyFormatter.format(album.purchasePrice, userProfile, isPublic, 2)) : undefined,
                        isLoading: isLoadingPurchasePrice,
                        onClick: openPurchasePriceDialog
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            !(isPublic && album.sellValue === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                        disabled: isPublic,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).sell_value_title,
                        detail: sellValueDetail(),
                        detailBlurred: !isPublic && currentUser?.role == "guest",
                        subtitle: (()=>{
                            if (!album.sellValue) return undefined;
                            const currentCollection = collectionManager.getCurrentCollection(isPublic);
                            const dollars = currencyFormatter.format(album.sellValue.dollars * (1 - (currentCollection?.discount ?? 0)), userProfile, isPublic, 2, "USD");
                            return isPublic ? dollars : `${(0, $37bec70ed65ed924$export$21c51bc433c16634).msv_group} ${album.sellValue.group} (${dollars})`;
                        })(),
                        onClick: ()=>setIsSellValuesDialogOpen(true),
                        isLoading: isLoadingSellValue
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            !(isPublic && currentPublicCollection?.bannedFields?.includes("revenue")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                        disabled: isPublic,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).revenue_title,
                        detail: album.purchasePriceToday !== undefined && album.sellValue?.pesos !== undefined ? getRevenue(album.purchasePriceToday, album.sellValue?.pesos) : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                        detailBlurred: !isPublic && currentUser?.role == "guest",
                        textColor: isRevenueNegative ? theme.palette.colors?.remove : theme.palette.primary.main
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            !(isPublic && album.purchaseDate === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
                        localeText: (0, $37bec70ed65ed924$export$21c51bc433c16634).datePickerLocale.components.MuiLocalizationProvider.defaultProps.localeText,
                        dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
                        adapterLocale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $080f12ab26da8443$export$97b476d7a92fee62), {
                            slotProps: {
                                actionBar: {
                                    actions: [
                                        "clear",
                                        "cancel"
                                    ]
                                }
                            },
                            format: "d MMM yyyy",
                            value: album.purchaseDate ? album.purchaseDate * 1000 : Date.now(),
                            onAccept: async (date)=>{
                                const purchaseDate = date == null ? null : Math.trunc(date.getTime() / 1000);
                                setIsLoadingPurchaseDate(true);
                                const { body: body, status: status } = await updateAlbum({
                                    uuid: album.uuid,
                                    purchaseDate: purchaseDate
                                });
                                if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                                    setAlertMessage(body.message);
                                    setAlertIsOpen(true);
                                } else {
                                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
                                    album.purchaseDate = body.purchaseDate;
                                    album.purchasePriceDollars = body.purchasePriceDollars;
                                    album.purchasePriceToday = body.purchasePriceToday;
                                    onAttributeUpdated(album);
                                }
                                setIsLoadingPurchaseDate(false);
                            },
                            closeOnSelect: true,
                            onClose: ()=>setIsPurchaseDatePickerOpen(false),
                            open: isPurchaseDatePickerOpen,
                            slots: {
                                field: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                        disabled: isPublic,
                                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_date_title,
                                        detail: getPurchaseDate(),
                                        detailBlurred: !isPublic && currentUser?.role == "guest",
                                        onClick: ()=>setIsPurchaseDatePickerOpen(true),
                                        isLoading: isLoadingPurchaseDate
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            !(isPublic && album.store === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                disabled: isPublic,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).store_title,
                detail: album.store?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                onClick: ()=>setIsStoresDialogOpen(true),
                isLoading: isLoadingStore
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_message,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                canClear: true,
                open: purchasePriceDialogState.mode !== "closed",
                onClose: closePurchasePriceDialog,
                isNumber: true,
                value: album.purchasePrice?.toString(),
                onChange: (newValue)=>updatePurchasePrice(+newValue),
                onClearValue: ()=>updatePurchasePrice(null)
            }, purchasePriceDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSellValuesDialogOpen,
                onClose: ()=>setIsSellValuesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70b19905e559553e$export$b70de0c9f92ac064), {
                    handleClose: ()=>setIsSellValuesDialogOpen(false),
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: album.sellValue?.uuid,
                    onSellValueSelected: updateSellValue,
                    onClearValue: ()=>updateSellValue(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isStoresDialogOpen,
                onClose: ()=>setIsStoresDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c0c8fd0aacbcfe9$export$1f4e316d688f3260), {
                    handleClose: ()=>setIsStoresDialogOpen(false),
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: album.store?.uuid,
                    onStoreSelected: updateStore,
                    onClearValue: ()=>updateStore(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
var $3526fc30dd11bfd5$exports = {};

$parcel$export($3526fc30dd11bfd5$exports, "name", function () { return $3526fc30dd11bfd5$export$a8ff84c12d48cfa6; }, function (v) { return $3526fc30dd11bfd5$export$a8ff84c12d48cfa6 = v; });
$parcel$export($3526fc30dd11bfd5$exports, "skeleton", function () { return $3526fc30dd11bfd5$export$2a0674ff2eb10214; }, function (v) { return $3526fc30dd11bfd5$export$2a0674ff2eb10214 = v; });
var $3526fc30dd11bfd5$export$a8ff84c12d48cfa6;
var $3526fc30dd11bfd5$export$2a0674ff2eb10214;
$3526fc30dd11bfd5$export$a8ff84c12d48cfa6 = `P7mxZG_name`;
$3526fc30dd11bfd5$export$2a0674ff2eb10214 = `P7mxZG_skeleton`;










const $1111cb23cac5f866$export$8fadd0ba91ab2888 = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getAlbumTypes = (parameters)=>get("albumTypes", parameters);
    const getPublicAlbumTypes = (parameters)=>get("albumTypes/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).albumTypes(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicAlbumTypes : getAlbumTypes, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).albumTypeStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $bb24b03c2c53d595$exports = {};

$parcel$export($bb24b03c2c53d595$exports, "cancelButton", function () { return $bb24b03c2c53d595$export$4ededb8e5b56a6fb; }, function (v) { return $bb24b03c2c53d595$export$4ededb8e5b56a6fb = v; });
$parcel$export($bb24b03c2c53d595$exports, "loadingDiv", function () { return $bb24b03c2c53d595$export$dded2af20345efaa; }, function (v) { return $bb24b03c2c53d595$export$dded2af20345efaa = v; });
$parcel$export($bb24b03c2c53d595$exports, "textField", function () { return $bb24b03c2c53d595$export$c54b92c0bb02ba64; }, function (v) { return $bb24b03c2c53d595$export$c54b92c0bb02ba64 = v; });
$parcel$export($bb24b03c2c53d595$exports, "toggleButton", function () { return $bb24b03c2c53d595$export$c3f9788a1ddcf2d9; }, function (v) { return $bb24b03c2c53d595$export$c3f9788a1ddcf2d9 = v; });
var $bb24b03c2c53d595$export$4ededb8e5b56a6fb;
var $bb24b03c2c53d595$export$dded2af20345efaa;
var $bb24b03c2c53d595$export$c54b92c0bb02ba64;
var $bb24b03c2c53d595$export$c3f9788a1ddcf2d9;
$bb24b03c2c53d595$export$4ededb8e5b56a6fb = `_8oTNKW_cancelButton`;
$bb24b03c2c53d595$export$dded2af20345efaa = `_8oTNKW_loadingDiv`;
$bb24b03c2c53d595$export$c54b92c0bb02ba64 = `_8oTNKW_textField`;
$bb24b03c2c53d595$export$c3f9788a1ddcf2d9 = `_8oTNKW_toggleButton`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $61a81962a99659d8$export$6cd525ca707ab887 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumType = (parameters)=>post("albumTypes", parameters);
    return {
        addAlbumType: addAlbumType
    };
};



const $39ae669d585f6d38$export$a8c7979f236f240c = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyAlbumType = (parameters)=>put("albumTypes", parameters);
    return {
        modifyAlbumType: modifyAlbumType
    };
};



const $3048127144e56006$export$50944930c85cfd38 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumType = (parameters)=>deleteRequest("albumTypes", parameters);
    return {
        deleteAlbumType: deleteAlbumType
    };
};













const $93f02fe020488967$export$93bb2f04fb4d9b5 = ({ open: open, onClose: onClose, albumType: albumType, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = albumType ? (0, $37bec70ed65ed924$export$21c51bc433c16634).album_type_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).mat_new_title;
    const { addAlbumType: addAlbumType } = (0, $61a81962a99659d8$export$6cd525ca707ab887)();
    const { modifyAlbumType: modifyAlbumType } = (0, $39ae669d585f6d38$export$a8c7979f236f240c)();
    const { deleteAlbumType: deleteAlbumType } = (0, $3048127144e56006$export$50944930c85cfd38)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).mat_missing_error)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: albumType?.name ?? "",
            showOnAlbumList: albumType?.showOnAlbumList ?? true
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, showOnAlbumList: showOnAlbumList })=>{
            setIsLoading(true);
            if (albumType) {
                const { status: status, body: body } = await modifyAlbumType({
                    uuid: albumType.uuid,
                    name: name,
                    showOnAlbumList: showOnAlbumList
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_albumtype_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addAlbumType({
                    name: name,
                    showOnAlbumList: showOnAlbumList
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_albumtype_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!albumType) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteAlbumType({
            uuid: albumType.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(albumType);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            albumType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).mat_field_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bb24b03c2c53d595$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).mat_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).mat_show_on_album_list_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
                                value: formik.values.showOnAlbumList,
                                exclusive: true,
                                onChange: (_event, value)=>{
                                    if (value !== null) formik.setFieldValue("showOnAlbumList", value).then();
                                },
                                sx: {
                                    height: "30px",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bb24b03c2c53d595$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: true,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bb24b03c2c53d595$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: false,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_TYPES,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};










var $61aae0c5f807b254$exports = {};

$parcel$export($61aae0c5f807b254$exports, "defaultIcon", function () { return $61aae0c5f807b254$export$ca2f546e21dcce87; }, function (v) { return $61aae0c5f807b254$export$ca2f546e21dcce87 = v; });
$parcel$export($61aae0c5f807b254$exports, "name", function () { return $61aae0c5f807b254$export$a8ff84c12d48cfa6; }, function (v) { return $61aae0c5f807b254$export$a8ff84c12d48cfa6 = v; });
$parcel$export($61aae0c5f807b254$exports, "rightContainer", function () { return $61aae0c5f807b254$export$3280a108d7f81d56; }, function (v) { return $61aae0c5f807b254$export$3280a108d7f81d56 = v; });
$parcel$export($61aae0c5f807b254$exports, "shortName", function () { return $61aae0c5f807b254$export$f4ddcecd8b14187; }, function (v) { return $61aae0c5f807b254$export$f4ddcecd8b14187 = v; });
var $61aae0c5f807b254$export$ca2f546e21dcce87;
var $61aae0c5f807b254$export$a8ff84c12d48cfa6;
var $61aae0c5f807b254$export$3280a108d7f81d56;
var $61aae0c5f807b254$export$f4ddcecd8b14187;
$61aae0c5f807b254$export$ca2f546e21dcce87 = `KDmyCW_defaultIcon`;
$61aae0c5f807b254$export$a8ff84c12d48cfa6 = `KDmyCW_name`;
$61aae0c5f807b254$export$3280a108d7f81d56 = `KDmyCW_rightContainer`;
$61aae0c5f807b254$export$f4ddcecd8b14187 = `KDmyCW_shortName`;


parcelRequire("7fPBF");


const $d11cc82754668de1$export$9e99b9b9da603ff6 = ({ albumType: albumType, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        sx: {
            height: 64,
            borderRadius: "20px"
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($61aae0c5f807b254$exports))).defaultIcon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Album
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($61aae0c5f807b254$exports))).rightContainer,
                    spacing: 1,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($61aae0c5f807b254$exports))).name,
                        children: albumType.name
                    })
                })
            ]
        })
    });
};


const $3545f666fd578acf$export$cdc91b52c28c8fd3 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onAlbumTypeSelected: onAlbumTypeSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [albumTypes, resetAlbumTypes, setAlbumTypes, noMoreAlbumTypes] = (0, $1111cb23cac5f866$export$8fadd0ba91ab2888)(isPublic, setLoading);
    const { state: dialogState, key: dialogKey, openAdd: openAdd, openEdit: openEdit, close: closeDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextAlbumType, setContextAlbumType] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredAlbumTypes = (0, $7fPBF.useMemo)(()=>{
        if (searchText === "") return albumTypes;
        return albumTypes?.filter((albumType)=>{
            return albumType.name.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        albumTypes,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredAlbumTypes,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_TYPES],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_album_types_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_album_types,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_types_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetAlbumTypes,
        onClearValue: onClearValue,
        children: [
            filteredAlbumTypes?.map((albumType)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d11cc82754668de1$export$9e99b9b9da603ff6), {
                        albumType: albumType,
                        selected: preselectedId === albumType.uuid,
                        onClick: ()=>{
                            if (onAlbumTypeSelected) onAlbumTypeSelected(albumType);
                            else openEdit(albumType);
                        },
                        onContextMenu: (event)=>{
                            setContextAlbumType(albumType);
                            handleContextMenu(event);
                        }
                    })
                }, albumType.uuid)),
            (loading || !noMoreAlbumTypes) && Array.from({
                length: 6
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 64
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3526fc30dd11bfd5$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextAlbumType);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93f02fe020488967$export$93bb2f04fb4d9b5), {
                open: dialogState.mode !== "closed",
                onClose: closeDialog,
                albumType: dialogState.item,
                onNewItem: (newAlbumType)=>{
                    const newAlbumTypes = [
                        ...albumTypes,
                        newAlbumType
                    ];
                    newAlbumTypes.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setAlbumTypes(newAlbumTypes);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newAlbumType)=>{
                    const newAlbumTypes = albumTypes.map((albumType)=>albumType.uuid === newAlbumType.uuid ? newAlbumType : albumType);
                    newAlbumTypes.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setAlbumTypes(newAlbumTypes);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedAlbumType)=>{
                    const newAlbumTypes = albumTypes.filter((albumType)=>albumType.uuid !== deletedAlbumType.uuid);
                    setAlbumTypes(newAlbumTypes);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, dialogKey)
        ]
    });
};






parcelRequire("7fPBF");

var $c1d445509919a707$exports = {};

$parcel$export($c1d445509919a707$exports, "list", function () { return $c1d445509919a707$export$8837f4fc672e936d; }, function (v) { return $c1d445509919a707$export$8837f4fc672e936d = v; });
var $c1d445509919a707$export$8837f4fc672e936d;
$c1d445509919a707$export$8837f4fc672e936d = `u7ElCa_list`;




var $7fPBF = parcelRequire("7fPBF");

var $08b4e28e731fecac$exports = {};

$parcel$export($08b4e28e731fecac$exports, "color", function () { return $08b4e28e731fecac$export$35e9368ef982300f; }, function (v) { return $08b4e28e731fecac$export$35e9368ef982300f = v; });
$parcel$export($08b4e28e731fecac$exports, "container", function () { return $08b4e28e731fecac$export$34e0f9847d4c02dd; }, function (v) { return $08b4e28e731fecac$export$34e0f9847d4c02dd = v; });
$parcel$export($08b4e28e731fecac$exports, "description", function () { return $08b4e28e731fecac$export$6d59db4903f20f7d; }, function (v) { return $08b4e28e731fecac$export$6d59db4903f20f7d = v; });
$parcel$export($08b4e28e731fecac$exports, "hoverButton", function () { return $08b4e28e731fecac$export$b0260c0afbf48c57; }, function (v) { return $08b4e28e731fecac$export$b0260c0afbf48c57 = v; });
$parcel$export($08b4e28e731fecac$exports, "hoverButtonIcon", function () { return $08b4e28e731fecac$export$2a797adc03a2480; }, function (v) { return $08b4e28e731fecac$export$2a797adc03a2480 = v; });
$parcel$export($08b4e28e731fecac$exports, "hoverButtonsStack", function () { return $08b4e28e731fecac$export$a8eacba2c33c9f28; }, function (v) { return $08b4e28e731fecac$export$a8eacba2c33c9f28 = v; });
$parcel$export($08b4e28e731fecac$exports, "name", function () { return $08b4e28e731fecac$export$a8ff84c12d48cfa6; }, function (v) { return $08b4e28e731fecac$export$a8ff84c12d48cfa6 = v; });
$parcel$export($08b4e28e731fecac$exports, "playbackSpeed", function () { return $08b4e28e731fecac$export$25924b6fe75dd100; }, function (v) { return $08b4e28e731fecac$export$25924b6fe75dd100 = v; });
$parcel$export($08b4e28e731fecac$exports, "quantity", function () { return $08b4e28e731fecac$export$82dd68b83a44b253; }, function (v) { return $08b4e28e731fecac$export$82dd68b83a44b253 = v; });
var $08b4e28e731fecac$export$35e9368ef982300f;
var $08b4e28e731fecac$export$34e0f9847d4c02dd;
var $08b4e28e731fecac$export$6d59db4903f20f7d;
var $08b4e28e731fecac$export$b0260c0afbf48c57;
var $08b4e28e731fecac$export$2a797adc03a2480;
var $08b4e28e731fecac$export$a8eacba2c33c9f28;
var $08b4e28e731fecac$export$a8ff84c12d48cfa6;
var $08b4e28e731fecac$export$25924b6fe75dd100;
var $08b4e28e731fecac$export$82dd68b83a44b253;
$08b4e28e731fecac$export$35e9368ef982300f = `_9F3gmW_color`;
$08b4e28e731fecac$export$34e0f9847d4c02dd = `_9F3gmW_container`;
$08b4e28e731fecac$export$6d59db4903f20f7d = `_9F3gmW_description`;
$08b4e28e731fecac$export$b0260c0afbf48c57 = `_9F3gmW_hoverButton`;
$08b4e28e731fecac$export$2a797adc03a2480 = `_9F3gmW_hoverButtonIcon`;
$08b4e28e731fecac$export$a8eacba2c33c9f28 = `_9F3gmW_hoverButtonsStack`;
$08b4e28e731fecac$export$a8ff84c12d48cfa6 = `_9F3gmW_name`;
$08b4e28e731fecac$export$25924b6fe75dd100 = `_9F3gmW_playbackSpeed`;
$08b4e28e731fecac$export$82dd68b83a44b253 = `_9F3gmW_quantity`;







const $60a360f4adcbceb4$export$cb9f4a55f39985ce = ({ isPublic: isPublic, albumContent: albumContent, onModify: onModify, canMoveDown: canMoveDown, canMoveUp: canMoveUp, onMoveDown: onMoveDown, onMoveUp: onMoveUp, onDelete: onDelete, canModify: canModify })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const { handleContextMenu: handleContextMenu, menuProps: menuProps, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    const albumContentName = ()=>{
        const defaultName = (0, $4e580a0edacd4a22$export$d07f57595c356899)((0, $37bec70ed65ed924$export$21c51bc433c16634).disc_singular);
        switch(albumContent.type){
            case "disc":
                if (albumContent.quantity > 1) return (albumContent.albumFormat?.shortName ?? defaultName) + (0, $37bec70ed65ed924$export$21c51bc433c16634).plural_indicator;
                return albumContent.albumFormat?.shortName ?? defaultName;
            case "other":
                return albumContent.name ?? defaultName;
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).container,
        onContextMenu: handleContextMenu,
        ...handleLongPress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                disableGutters: true,
                onClick: ()=>setIsExpanded((state)=>!state),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    flexGrow: 1,
                    spacing: 1,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).quantity,
                            children: albumContent.quantity ? `${albumContent.quantity}\xd7` : ""
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).name,
                                    children: albumContentName()
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).description,
                                    style: {
                                        color: theme.palette.secondary.main,
                                        WebkitLineClamp: isExpanded ? undefined : 1
                                    },
                                    children: albumContent.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        albumContent.type == "disc" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).playbackSpeed,
                                    children: albumContent.playbackSpeed?.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).color,
                                    children: albumContent.color
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>{
                            event.stopPropagation();
                            handleContextMenu(event);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($08b4e28e731fecac$exports))).hoverButtonIcon,
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    !isPublic && canModify && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            onModify();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsExpanded((state)=>!state);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: isExpanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Compress
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Expand
                                })
                            }),
                            isExpanded ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shrink : (0, $37bec70ed65ed924$export$21c51bc433c16634).expand
                        ]
                    }),
                    !isPublic && canMoveUp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onMoveUp();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowUp
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_up
                        ]
                    }),
                    !isPublic && canMoveDown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onMoveDown();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowDown
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_down
                        ]
                    }),
                    !isPublic && canModify && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onDelete();
                        },
                        sx: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_delete
                        ]
                    }, "Remove")
                ]
            })
        ]
    });
};





const $d357a7ac9f015684$export$f7a1f2f1bfad98f4 = ({ isPublic: isPublic, album: album, onModify: onModify, onMoveDown: onMoveDown, onMoveUp: onMoveUp, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c1d445509919a707$exports))).list,
        children: [
            album.isBoxSet && album.boxSetAlbums?.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60a360f4adcbceb4$export$cb9f4a55f39985ce), {
                        isPublic: isPublic,
                        albumContent: {
                            uuid: "",
                            name: album.boxSetAlbums?.length > 1 ? (0, $4e580a0edacd4a22$export$d07f57595c356899)((0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural) : (0, $37bec70ed65ed924$export$21c51bc433c16634).album_title,
                            quantity: album.boxSetAlbums?.length,
                            order: -1,
                            type: "other"
                        },
                        canMoveDown: false,
                        canMoveUp: false,
                        canModify: false
                    }),
                    album.albumContents && album.albumContents.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            album.albumContents?.map((albumContent, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60a360f4adcbceb4$export$cb9f4a55f39985ce), {
                            isPublic: isPublic,
                            albumContent: albumContent,
                            onModify: ()=>onModify(albumContent),
                            canModify: true,
                            canMoveDown: index < album.albumContents?.length - 1,
                            canMoveUp: index > 0,
                            onMoveDown: ()=>onMoveDown(index),
                            onMoveUp: ()=>onMoveUp(index),
                            onDelete: ()=>onDelete(albumContent)
                        }),
                        index < album.albumContents?.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                            color: theme.palette.background.paper
                        })
                    ]
                }, index))
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");
var $094adb6f415ae5ae$exports = {};

$parcel$export($094adb6f415ae5ae$exports, "cancelButton", function () { return $094adb6f415ae5ae$export$4ededb8e5b56a6fb; }, function (v) { return $094adb6f415ae5ae$export$4ededb8e5b56a6fb = v; });
$parcel$export($094adb6f415ae5ae$exports, "descriptionCard", function () { return $094adb6f415ae5ae$export$ea3c9f9ac820b913; }, function (v) { return $094adb6f415ae5ae$export$ea3c9f9ac820b913 = v; });
$parcel$export($094adb6f415ae5ae$exports, "loadingDiv", function () { return $094adb6f415ae5ae$export$dded2af20345efaa; }, function (v) { return $094adb6f415ae5ae$export$dded2af20345efaa = v; });
$parcel$export($094adb6f415ae5ae$exports, "selectDiscount", function () { return $094adb6f415ae5ae$export$1fab6054d6ffebee; }, function (v) { return $094adb6f415ae5ae$export$1fab6054d6ffebee = v; });
$parcel$export($094adb6f415ae5ae$exports, "subtitle", function () { return $094adb6f415ae5ae$export$c96745152eb2740f; }, function (v) { return $094adb6f415ae5ae$export$c96745152eb2740f = v; });
$parcel$export($094adb6f415ae5ae$exports, "textField", function () { return $094adb6f415ae5ae$export$c54b92c0bb02ba64; }, function (v) { return $094adb6f415ae5ae$export$c54b92c0bb02ba64 = v; });
$parcel$export($094adb6f415ae5ae$exports, "visibility", function () { return $094adb6f415ae5ae$export$91fa9ac3f4021ce4; }, function (v) { return $094adb6f415ae5ae$export$91fa9ac3f4021ce4 = v; });
var $094adb6f415ae5ae$export$4ededb8e5b56a6fb;
var $094adb6f415ae5ae$export$ea3c9f9ac820b913;
var $094adb6f415ae5ae$export$dded2af20345efaa;
var $094adb6f415ae5ae$export$1fab6054d6ffebee;
var $094adb6f415ae5ae$export$c96745152eb2740f;
var $094adb6f415ae5ae$export$c54b92c0bb02ba64;
var $094adb6f415ae5ae$export$91fa9ac3f4021ce4;
$094adb6f415ae5ae$export$4ededb8e5b56a6fb = `_0BnXka_cancelButton`;
$094adb6f415ae5ae$export$ea3c9f9ac820b913 = `_0BnXka_descriptionCard`;
$094adb6f415ae5ae$export$dded2af20345efaa = `_0BnXka_loadingDiv`;
$094adb6f415ae5ae$export$1fab6054d6ffebee = `_0BnXka_selectDiscount`;
$094adb6f415ae5ae$export$c96745152eb2740f = `_0BnXka_subtitle`;
$094adb6f415ae5ae$export$c54b92c0bb02ba64 = `_0BnXka_textField`;
$094adb6f415ae5ae$export$91fa9ac3f4021ce4 = `_0BnXka_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");








const $de155f6604fc04cd$export$5d6e92469ff1ed2b = {
    getNameById: (id)=>{
        switch(id){
            case 0:
                return "33\u2153 rpm";
            case 1:
                return "45 rpm";
            case 2:
                return "78 rpm";
            default:
                return "-";
        }
    }
};




var $7fPBF = parcelRequire("7fPBF");








const $dc2b618ecc79fb97$export$c1f0691d7438898f = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getAlbumFormats = (parameters)=>get("albumFormats", parameters);
    const getPublicAlbumFormats = (parameters)=>get("albumFormats/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).albumFormats(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicAlbumFormats : getAlbumFormats, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).albumFormatStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};







var $7fPBF = parcelRequire("7fPBF");
var $969913c34bbfb889$exports = {};

$parcel$export($969913c34bbfb889$exports, "cancelButton", function () { return $969913c34bbfb889$export$4ededb8e5b56a6fb; }, function (v) { return $969913c34bbfb889$export$4ededb8e5b56a6fb = v; });
$parcel$export($969913c34bbfb889$exports, "loadingDiv", function () { return $969913c34bbfb889$export$dded2af20345efaa; }, function (v) { return $969913c34bbfb889$export$dded2af20345efaa = v; });
$parcel$export($969913c34bbfb889$exports, "textField", function () { return $969913c34bbfb889$export$c54b92c0bb02ba64; }, function (v) { return $969913c34bbfb889$export$c54b92c0bb02ba64 = v; });
var $969913c34bbfb889$export$4ededb8e5b56a6fb;
var $969913c34bbfb889$export$dded2af20345efaa;
var $969913c34bbfb889$export$c54b92c0bb02ba64;
$969913c34bbfb889$export$4ededb8e5b56a6fb = `DhYa1G_cancelButton`;
$969913c34bbfb889$export$dded2af20345efaa = `DhYa1G_loadingDiv`;
$969913c34bbfb889$export$c54b92c0bb02ba64 = `DhYa1G_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $eafc161e565c67b7$export$3472549fe9edccf1 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumFormat = (parameters)=>post("albumFormats", parameters);
    return {
        addAlbumFormat: addAlbumFormat
    };
};



const $3ec0a26a78bb10b5$export$8f4a4ba6c0650879 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyAlbumFormat = (parameters)=>put("albumFormats", parameters);
    return {
        modifyAlbumFormat: modifyAlbumFormat
    };
};



const $a9ec24706a486a5f$export$7c3870bc1d269567 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumFormat = (parameters)=>deleteRequest("albumFormats", parameters);
    return {
        deleteAlbumFormat: deleteAlbumFormat
    };
};













const $f2b6bef24df1d427$export$cbb2a64ac95ed7e4 = ({ open: open, onClose: onClose, albumFormat: albumFormat, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = albumFormat ? (0, $37bec70ed65ed924$export$21c51bc433c16634).album_format_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_new_title;
    const { addAlbumFormat: addAlbumFormat } = (0, $eafc161e565c67b7$export$3472549fe9edccf1)();
    const { modifyAlbumFormat: modifyAlbumFormat } = (0, $3ec0a26a78bb10b5$export$8f4a4ba6c0650879)();
    const { deleteAlbumFormat: deleteAlbumFormat } = (0, $a9ec24706a486a5f$export$7c3870bc1d269567)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing_short),
        shortName: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing_short)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: albumFormat?.name ?? "",
            shortName: albumFormat?.shortName ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, shortName: shortName })=>{
            setIsLoading(true);
            if (albumFormat) {
                const { status: status, body: body } = await modifyAlbumFormat({
                    uuid: albumFormat.uuid,
                    name: name,
                    shortName: shortName
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_format_action", {
                        isNew: true
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addAlbumFormat({
                    name: name,
                    shortName: shortName
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_format_action", {
                        isNew: false
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!albumFormat) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteAlbumFormat({
            uuid: albumFormat.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(albumFormat);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            albumFormat && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($969913c34bbfb889$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_name_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_short_name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($969913c34bbfb889$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "shortName",
                                    name: "shortName",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_short_name_placeholder,
                                    value: formik.values.shortName,
                                    onChange: formik.handleChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_FORMATS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};





var $0407207274b0cdb7$exports = {};

$parcel$export($0407207274b0cdb7$exports, "defaultIcon", function () { return $0407207274b0cdb7$export$ca2f546e21dcce87; }, function (v) { return $0407207274b0cdb7$export$ca2f546e21dcce87 = v; });
$parcel$export($0407207274b0cdb7$exports, "name", function () { return $0407207274b0cdb7$export$a8ff84c12d48cfa6; }, function (v) { return $0407207274b0cdb7$export$a8ff84c12d48cfa6 = v; });
$parcel$export($0407207274b0cdb7$exports, "rightContainer", function () { return $0407207274b0cdb7$export$3280a108d7f81d56; }, function (v) { return $0407207274b0cdb7$export$3280a108d7f81d56 = v; });
$parcel$export($0407207274b0cdb7$exports, "shortName", function () { return $0407207274b0cdb7$export$f4ddcecd8b14187; }, function (v) { return $0407207274b0cdb7$export$f4ddcecd8b14187 = v; });
var $0407207274b0cdb7$export$ca2f546e21dcce87;
var $0407207274b0cdb7$export$a8ff84c12d48cfa6;
var $0407207274b0cdb7$export$3280a108d7f81d56;
var $0407207274b0cdb7$export$f4ddcecd8b14187;
$0407207274b0cdb7$export$ca2f546e21dcce87 = `q3gNFG_defaultIcon`;
$0407207274b0cdb7$export$a8ff84c12d48cfa6 = `q3gNFG_name`;
$0407207274b0cdb7$export$3280a108d7f81d56 = `q3gNFG_rightContainer`;
$0407207274b0cdb7$export$f4ddcecd8b14187 = `q3gNFG_shortName`;


parcelRequire("7fPBF");


const $84c9dec4e5e9f6ee$export$499c34daf355389f = ({ albumFormat: albumFormat, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        sx: {
            height: 64,
            borderRadius: "20px"
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0407207274b0cdb7$exports))).defaultIcon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ControlCamera
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0407207274b0cdb7$exports))).rightContainer,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0407207274b0cdb7$exports))).name,
                            children: albumFormat.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                    sx: {
                                        padding: 0.5
                                    },
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0407207274b0cdb7$exports))).shortName,
                                        children: albumFormat.shortName
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


var $d52e1c919679775d$exports = {};

$parcel$export($d52e1c919679775d$exports, "name", function () { return $d52e1c919679775d$export$a8ff84c12d48cfa6; }, function (v) { return $d52e1c919679775d$export$a8ff84c12d48cfa6 = v; });
$parcel$export($d52e1c919679775d$exports, "skeleton", function () { return $d52e1c919679775d$export$2a0674ff2eb10214; }, function (v) { return $d52e1c919679775d$export$2a0674ff2eb10214 = v; });
var $d52e1c919679775d$export$a8ff84c12d48cfa6;
var $d52e1c919679775d$export$2a0674ff2eb10214;
$d52e1c919679775d$export$a8ff84c12d48cfa6 = `Qd3X3q_name`;
$d52e1c919679775d$export$2a0674ff2eb10214 = `Qd3X3q_skeleton`;







const $8eaae7a275eb790c$export$aab348bda21f9238 = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedId: preselectedId, onAlbumFormatSelected: onAlbumFormatSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [contextMenuAlbumFormat, setContextMenuAlbumFormat] = (0, $7fPBF.useState)();
    const [albumFormats, resetAlbumFormats, setAlbumFormats, noMoreAlbumFormats] = (0, $dc2b618ecc79fb97$export$c1f0691d7438898f)(isPublic, setLoading);
    const filteredAlbumFormats = (0, $7fPBF.useMemo)(()=>{
        if (searchText === "") return albumFormats;
        return albumFormats?.filter((albumFormat)=>{
            return albumFormat.name.toLowerCase().includes(searchText.toLowerCase()) || albumFormat.shortName.toString().toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        albumFormats,
        searchText
    ]);
    const { state: dialogState, key: dialogKey, openAdd: openAdd, openEdit: openEdit, close: closeDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredAlbumFormats,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_FORMATS],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_album_formats_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_album_formats,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_formats_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetAlbumFormats,
        onClearValue: onClearValue,
        children: [
            filteredAlbumFormats?.map((albumFormat)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84c9dec4e5e9f6ee$export$499c34daf355389f), {
                        albumFormat: albumFormat,
                        onClick: ()=>{
                            if (onAlbumFormatSelected) onAlbumFormatSelected(albumFormat);
                            else openEdit(albumFormat);
                        },
                        onContextMenu: (event)=>{
                            setContextMenuAlbumFormat(albumFormat);
                            handleContextMenu(event);
                        },
                        selected: preselectedId === albumFormat.uuid
                    })
                }, albumFormat.uuid)),
            (loading || !noMoreAlbumFormats) && Array.from({
                length: 6
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 64
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d52e1c919679775d$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextMenuAlbumFormat);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2b6bef24df1d427$export$cbb2a64ac95ed7e4), {
                open: dialogState.mode !== "closed",
                onClose: closeDialog,
                albumFormat: dialogState.item,
                onNewItem: (newAlbumFormat)=>{
                    const newAlbumFormats = [
                        ...albumFormats,
                        newAlbumFormat
                    ];
                    newAlbumFormats.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setAlbumFormats(newAlbumFormats);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newAlbumFormat)=>{
                    const newAlbumFormats = albumFormats.map((albumFormat)=>albumFormat.uuid === newAlbumFormat.uuid ? newAlbumFormat : albumFormat);
                    newAlbumFormats.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setAlbumFormats(newAlbumFormats);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedAlbumFormat)=>{
                    const newAlbumFormats = albumFormats.filter((albumFormat)=>albumFormat.uuid !== deletedAlbumFormat.uuid);
                    setAlbumFormats(newAlbumFormats);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, dialogKey)
        ]
    });
};



var $1ba01a975db46180$exports = {};

$parcel$export($1ba01a975db46180$exports, "incrementalButton", function () { return $1ba01a975db46180$export$a2c754d66c26d700; }, function (v) { return $1ba01a975db46180$export$a2c754d66c26d700 = v; });
$parcel$export($1ba01a975db46180$exports, "number", function () { return $1ba01a975db46180$export$98e628dec113755e; }, function (v) { return $1ba01a975db46180$export$98e628dec113755e = v; });
var $1ba01a975db46180$export$a2c754d66c26d700;
var $1ba01a975db46180$export$98e628dec113755e;
$1ba01a975db46180$export$a2c754d66c26d700 = `_5pIFuW_incrementalButton`;
$1ba01a975db46180$export$98e628dec113755e = `_5pIFuW_number`;





var $7fPBF = parcelRequire("7fPBF");










function $94403c25c532988f$export$b85c003f960b1f3a(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $94403c25c532988f$var$buttonGroupClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'vertical',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $94403c25c532988f$export$2e2bcd8739ae039 = $94403c25c532988f$var$buttonGroupClasses;





'use client';
const $078cc07d54c9b00d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $078cc07d54c9b00d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $078cc07d54c9b00d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $94403c25c532988f$export$b85c003f960b1f3a), classes);
};
const $078cc07d54c9b00d$var$ButtonGroupRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $078cc07d54c9b00d$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === 'contained' && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: 'none'
    }, ownerState.fullWidth && {
        width: '100%'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, {
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            minWidth: 40,
            '&:hover': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.variant === 'contained' && {
                boxShadow: 'none'
            })
        }, ownerState.variant === 'contained' && {
            boxShadow: 'none'
        }),
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.orientation === 'horizontal' && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            borderRightColor: 'transparent'
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            borderBottomColor: 'transparent'
        }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            '&:hover': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
                borderRightColor: 'currentColor'
            }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
                borderBottomColor: 'currentColor'
            })
        }),
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState.orientation === 'horizontal' && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            marginLeft: -1
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            marginTop: -1
        })
    }));
const $078cc07d54c9b00d$var$ButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $078cc07d54c9b00d$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $078cc07d54c9b00d$var$useUtilityClasses(ownerState);
    const context = $7fPBF.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $c3429429cdbbe82f$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($078cc07d54c9b00d$var$ButtonGroupRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        as: component,
        role: "group",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40ed7573a59c2be9$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e319f5c3a4402058$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $078cc07d54c9b00d$export$2e2bcd8739ae039 = $078cc07d54c9b00d$var$ButtonGroup;



var $7fPBF = parcelRequire("7fPBF");

const $ce83a575e7610c25$export$1b74141c5fe63a28 = ({ className: className, initialValue: initialValue, minimumValue: minimumValue, maximumValue: maximumValue, nullable: nullable, disabled: disabled, onValueChanged: onValueChanged })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [incrementalNumber, setIncrementalNumber] = (0, $7fPBF.useState)(initialValue);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        className: className,
        direction: "row",
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1ba01a975db46180$exports))).number,
                children: incrementalNumber >= minimumValue ? incrementalNumber : "-"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $078cc07d54c9b00d$export$2e2bcd8739ae039), {
                variant: "contained",
                disabled: disabled,
                size: "medium",
                sx: {
                    height: "36px",
                    borderRadius: "12px"
                },
                color: "secondary",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1ba01a975db46180$exports))).incrementalButton,
                        sx: {
                            color: `${theme.palette.primary.main} !important`,
                            backgroundColor: `${theme.palette.colors?.counterBackground} !important`,
                            borderRadius: "12px"
                        },
                        onClick: ()=>{
                            if (incrementalNumber > minimumValue) {
                                onValueChanged(incrementalNumber - 1);
                                setIncrementalNumber(incrementalNumber - 1);
                            } else if (nullable) {
                                onValueChanged(null);
                                setIncrementalNumber(minimumValue - 1);
                            }
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Remove
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1ba01a975db46180$exports))).incrementalButton,
                        sx: {
                            color: `${theme.palette.primary.main} !important`,
                            backgroundColor: `${theme.palette.colors?.counterBackground} !important`,
                            borderRadius: "12px"
                        },
                        onClick: ()=>{
                            if (incrementalNumber < (maximumValue ?? Number.MAX_SAFE_INTEGER)) {
                                onValueChanged(incrementalNumber + 1);
                                setIncrementalNumber(incrementalNumber + 1);
                            }
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Add
                        })
                    })
                ]
            })
        ]
    });
};





const $aa0196ded690d0e7$export$88a074929bd53fa4 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumContent = (parameters)=>post("albumContents", parameters);
    return {
        addAlbumContent: addAlbumContent
    };
};



const $8663458bf410dbb7$export$4f7e019efe9294c4 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyAlbumContent = (parameters)=>put("albumContents", parameters);
    return {
        modifyAlbumContent: modifyAlbumContent
    };
};







const $657d234e76a51d66$export$27da38f499e74ca3 = ({ albumId: albumId, open: open, onClose: onClose, albumContent: albumContent, onUpdate: onUpdate })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumFormatDesktopOpen, setIsAlbumFormatDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const { addAlbumContent: addAlbumContent } = (0, $aa0196ded690d0e7$export$88a074929bd53fa4)();
    const { modifyAlbumContent: modifyAlbumContent } = (0, $8663458bf410dbb7$export$4f7e019efe9294c4)();
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const possiblePlaybackSpeeds = [
        0,
        1,
        2
    ];
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: albumContent?.name ?? "",
            quantity: albumContent?.quantity,
            color: albumContent?.color ?? "",
            type: albumContent?.type ?? "disc",
            playbackSpeedId: albumContent?.playbackSpeed?.id,
            albumFormat: albumContent?.albumFormat,
            description: albumContent?.description ?? ""
        },
        enableReinitialize: true,
        onSubmit: async ({ name: name, quantity: quantity, color: color, playbackSpeedId: playbackSpeedId, albumFormat: albumFormat, description: description, type: type })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (albumContent) {
                const { status: status, body: body } = await modifyAlbumContent({
                    uuid: albumContent.uuid,
                    albumId: albumId,
                    name: name,
                    quantity: quantity,
                    color: color,
                    playbackSpeedId: playbackSpeedId,
                    description: description,
                    order: albumContent.order,
                    type: type,
                    albumFormatId: type == "disc" ? albumFormat?.uuid ?? null : undefined
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addAlbumContent({
                    albumId: albumId,
                    name: name,
                    quantity: quantity,
                    color: color,
                    playbackSpeedId: playbackSpeedId,
                    description: description,
                    albumFormatId: albumFormat?.uuid,
                    type: type
                });
                statusCode = status;
                responseBody = body;
            }
            if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            } else {
                onUpdate(responseBody);
                onClose();
                formik.resetForm();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            }
            setIsLoading(false);
        }
    });
    const handleTypeChange = (_event, type)=>{
        if (type !== null) formik.setFieldValue("type", type).then();
    };
    const handlePlaybackSpeedChange = (_event, playbackSpeedId)=>{
        formik.setFieldValue("playbackSpeedId", playbackSpeedId).then();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_contents_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_content_type
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).visibility,
                                labels: [
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_content_disc,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_content_other
                                ],
                                values: [
                                    "disc",
                                    "other"
                                ],
                                value: formik.values.type,
                                disabled: isLoading,
                                fullWidth: true,
                                disableGutters: true,
                                handleChange: handleTypeChange
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).itemTitle,
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_content_quantity
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce83a575e7610c25$export$1b74141c5fe63a28), {
                                initialValue: albumContent?.quantity ?? 0,
                                minimumValue: 1,
                                nullable: true,
                                disabled: isLoading,
                                onValueChanged: (newValue)=>formik.setFieldValue("quantity", newValue)
                            }),
                            formik.values.type == "other" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).textField,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                            id: "name",
                                            name: "name",
                                            size: "small",
                                            autoFocus: !isMobile,
                                            disabled: isLoading,
                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title,
                                            value: formik.values.name,
                                            onChange: formik.handleChange,
                                            enterAction: formik.submitForm
                                        })
                                    })
                                ]
                            }),
                            formik.values.type == "disc" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_format_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).textField,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                            id: "albumFormat",
                                            name: "albumFormat",
                                            size: "small",
                                            readOnly: true,
                                            disabled: isLoading,
                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_short_name_placeholder,
                                            value: formik.values.albumFormat?.name ?? "",
                                            onClick: ()=>setIsAlbumFormatDesktopOpen(true),
                                            enterAction: ()=>setIsAlbumFormatDesktopOpen(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).playback_speed
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).visibility,
                                        labels: possiblePlaybackSpeeds.map((value)=>(0, $de155f6604fc04cd$export$5d6e92469ff1ed2b).getNameById(value)),
                                        values: possiblePlaybackSpeeds,
                                        value: formik.values.playbackSpeedId,
                                        fullWidth: true,
                                        disableGutters: true,
                                        handleChange: handlePlaybackSpeedChange,
                                        disabled: isLoading
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: formik.values.quantity > 1 ? (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_plural_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_singular_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).textField,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                            id: "color",
                                            name: "color",
                                            size: "small",
                                            disabled: isLoading,
                                            placeholder: formik.values.quantity > 1 ? (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_plural_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_singular_title,
                                            value: formik.values.color,
                                            onChange: formik.handleChange,
                                            enterAction: formik.submitForm
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($094adb6f415ae5ae$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    disabled: isLoading,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            disabled: isLoading,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumFormatDesktopOpen,
                onClose: ()=>setIsAlbumFormatDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8eaae7a275eb790c$export$aab348bda21f9238), {
                    handleClose: ()=>{
                        setIsAlbumFormatDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: formik.values.albumFormat?.uuid,
                    onAlbumFormatSelected: async (albumFormat)=>{
                        setIsAlbumFormatDesktopOpen(false);
                        await formik.setFieldValue("albumFormat", albumFormat);
                    },
                    onClearValue: async ()=>{
                        setIsAlbumFormatDesktopOpen(false);
                        await formik.setFieldValue("albumFormat", null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: ()=>{
                    formik.resetForm();
                    onClose();
                },
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




const $7e63b2608081d5fd$export$d327a493398dab5a = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderAlbumContents = (albumContents)=>{
        const sortedUuids = albumContents.map((albumContent)=>albumContent.uuid);
        return post("albumContents/reorder", {
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderAlbumContents: reorderAlbumContents
    };
};



const $3894d3bcc5a82b2b$export$43b1a606e5e1c742 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumContent = (parameters)=>deleteRequest("albumContents", parameters);
    return {
        deleteAlbumContent: deleteAlbumContent
    };
};





var $7fPBF = parcelRequire("7fPBF");
var $763293a7d490c668$exports = {};

$parcel$export($763293a7d490c668$exports, "name", function () { return $763293a7d490c668$export$a8ff84c12d48cfa6; }, function (v) { return $763293a7d490c668$export$a8ff84c12d48cfa6 = v; });
$parcel$export($763293a7d490c668$exports, "skeleton", function () { return $763293a7d490c668$export$2a0674ff2eb10214; }, function (v) { return $763293a7d490c668$export$2a0674ff2eb10214 = v; });
var $763293a7d490c668$export$a8ff84c12d48cfa6;
var $763293a7d490c668$export$2a0674ff2eb10214;
$763293a7d490c668$export$a8ff84c12d48cfa6 = `FdV-bG_name`;
$763293a7d490c668$export$2a0674ff2eb10214 = `FdV-bG_skeleton`;






var $7fPBF = parcelRequire("7fPBF");
var $ff973bb242c36378$exports = {};

$parcel$export($ff973bb242c36378$exports, "cancelButton", function () { return $ff973bb242c36378$export$4ededb8e5b56a6fb; }, function (v) { return $ff973bb242c36378$export$4ededb8e5b56a6fb = v; });
$parcel$export($ff973bb242c36378$exports, "loadingDiv", function () { return $ff973bb242c36378$export$dded2af20345efaa; }, function (v) { return $ff973bb242c36378$export$dded2af20345efaa = v; });
$parcel$export($ff973bb242c36378$exports, "profileCard", function () { return $ff973bb242c36378$export$56d7158379169459; }, function (v) { return $ff973bb242c36378$export$56d7158379169459 = v; });
$parcel$export($ff973bb242c36378$exports, "textField", function () { return $ff973bb242c36378$export$c54b92c0bb02ba64; }, function (v) { return $ff973bb242c36378$export$c54b92c0bb02ba64 = v; });
var $ff973bb242c36378$export$4ededb8e5b56a6fb;
var $ff973bb242c36378$export$dded2af20345efaa;
var $ff973bb242c36378$export$56d7158379169459;
var $ff973bb242c36378$export$c54b92c0bb02ba64;
$ff973bb242c36378$export$4ededb8e5b56a6fb = `ORvlLq_cancelButton`;
$ff973bb242c36378$export$dded2af20345efaa = `ORvlLq_loadingDiv`;
$ff973bb242c36378$export$56d7158379169459 = `ORvlLq_profileCard`;
$ff973bb242c36378$export$c54b92c0bb02ba64 = `ORvlLq_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");










const $1674b0319e6c55b7$export$b2feaaa5142e0446 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addTag = (parameters)=>post("tags", parameters);
    return {
        addTag: addTag
    };
};



const $aaed2e7de9dee4c8$export$81026afbbd1354d5 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyTag = (parameters)=>put("tags", parameters);
    return {
        modifyTag: modifyTag
    };
};



const $866d9db339c8d3f0$export$b62c4ec00e56f561 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteTag = (parameters)=>deleteRequest("tags", parameters);
    return {
        deleteTag: deleteTag
    };
};







const $da8fb6a114cfefbf$export$6ae755583728ca09 = ({ open: open, onClose: onClose, tag: tag, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = tag ? (0, $37bec70ed65ed924$export$21c51bc433c16634).tag_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).new_tag_title;
    const { addTag: addTag } = (0, $1674b0319e6c55b7$export$b2feaaa5142e0446)();
    const { modifyTag: modifyTag } = (0, $aaed2e7de9dee4c8$export$81026afbbd1354d5)();
    const { deleteTag: deleteTag } = (0, $866d9db339c8d3f0$export$b62c4ec00e56f561)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: tag?.name ?? "",
            description: tag?.description ?? ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async ({ name: name, description: description })=>{
            setIsLoading(true);
            if (tag) {
                const { status: status, body: body } = await modifyTag({
                    uuid: tag.uuid,
                    name: name,
                    description: description
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_tag_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addTag({
                    name: name,
                    description: description
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_tag_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!tag) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteTag({
            uuid: tag.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem(tag);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            tag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ff973bb242c36378$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title,
                                    value: formik.values.name,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ff973bb242c36378$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).TAGS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};














const $4d5347e619baaf9f$export$4d62ffaf784e6f06 = (isPublic, setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const { getCurrentCollection: getCurrentCollection } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getTags = (parameters)=>get("tags", parameters);
    const getPublicTags = (parameters)=>get("tags/shared/public", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).tags(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), isPublic ? getPublicTags : getTags, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).tagStorage, isPublic, true, getCurrentCollection(isPublic)?.uuid);
};





var $4819d9e709627287$exports = {};

$parcel$export($4819d9e709627287$exports, "container", function () { return $4819d9e709627287$export$34e0f9847d4c02dd; }, function (v) { return $4819d9e709627287$export$34e0f9847d4c02dd = v; });
$parcel$export($4819d9e709627287$exports, "defaultIcon", function () { return $4819d9e709627287$export$ca2f546e21dcce87; }, function (v) { return $4819d9e709627287$export$ca2f546e21dcce87 = v; });
$parcel$export($4819d9e709627287$exports, "description", function () { return $4819d9e709627287$export$6d59db4903f20f7d; }, function (v) { return $4819d9e709627287$export$6d59db4903f20f7d = v; });
$parcel$export($4819d9e709627287$exports, "hoverButton", function () { return $4819d9e709627287$export$b0260c0afbf48c57; }, function (v) { return $4819d9e709627287$export$b0260c0afbf48c57 = v; });
$parcel$export($4819d9e709627287$exports, "hoverButtonIcon", function () { return $4819d9e709627287$export$2a797adc03a2480; }, function (v) { return $4819d9e709627287$export$2a797adc03a2480 = v; });
$parcel$export($4819d9e709627287$exports, "hoverButtonsStack", function () { return $4819d9e709627287$export$a8eacba2c33c9f28; }, function (v) { return $4819d9e709627287$export$a8eacba2c33c9f28 = v; });
$parcel$export($4819d9e709627287$exports, "name", function () { return $4819d9e709627287$export$a8ff84c12d48cfa6; }, function (v) { return $4819d9e709627287$export$a8ff84c12d48cfa6 = v; });
$parcel$export($4819d9e709627287$exports, "rightContainer", function () { return $4819d9e709627287$export$3280a108d7f81d56; }, function (v) { return $4819d9e709627287$export$3280a108d7f81d56 = v; });
var $4819d9e709627287$export$34e0f9847d4c02dd;
var $4819d9e709627287$export$ca2f546e21dcce87;
var $4819d9e709627287$export$6d59db4903f20f7d;
var $4819d9e709627287$export$b0260c0afbf48c57;
var $4819d9e709627287$export$2a797adc03a2480;
var $4819d9e709627287$export$a8eacba2c33c9f28;
var $4819d9e709627287$export$a8ff84c12d48cfa6;
var $4819d9e709627287$export$3280a108d7f81d56;
$4819d9e709627287$export$34e0f9847d4c02dd = `zBeqYq_container`;
$4819d9e709627287$export$ca2f546e21dcce87 = `zBeqYq_defaultIcon`;
$4819d9e709627287$export$6d59db4903f20f7d = `zBeqYq_description`;
$4819d9e709627287$export$b0260c0afbf48c57 = `zBeqYq_hoverButton`;
$4819d9e709627287$export$2a797adc03a2480 = `zBeqYq_hoverButtonIcon`;
$4819d9e709627287$export$a8eacba2c33c9f28 = `zBeqYq_hoverButtonsStack`;
$4819d9e709627287$export$a8ff84c12d48cfa6 = `zBeqYq_name`;
$4819d9e709627287$export$3280a108d7f81d56 = `zBeqYq_rightContainer`;


parcelRequire("7fPBF");


const $26cc5ca8278fee97$export$7c90d956f54b7979 = ({ tag: tag, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4819d9e709627287$exports))).container,
        sx: {
            height: 60
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onContextMenu: onContextMenu,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4819d9e709627287$exports))).defaultIcon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Sell
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4819d9e709627287$exports))).rightContainer,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4819d9e709627287$exports))).name,
                            children: tag.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4819d9e709627287$exports))).description,
                            children: tag.description
                        })
                    ]
                })
            ]
        })
    });
};




const $cce4818f9f0c650e$export$cb8904e0fef9e4cd = ({ handleClose: handleClose, isPublic: isPublic, columnWidth: columnWidth, preselectedIds: preselectedIds, onTagSelected: onTagSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [tags, resetTags, setTags, noMoreTags] = (0, $4d5347e619baaf9f$export$4d62ffaf784e6f06)(isPublic, setLoading);
    const { state: modifyTagDialogState, key: modifyTagDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyTagDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextTag, setContextTag] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredTags = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return tags;
        return tags?.filter((tag)=>{
            return tag.name.toLowerCase().includes(searchText.toLowerCase()) || tag.description?.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        tags,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: isPublic,
        items: filteredTags,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).TAGS],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_tags_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_tags,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetTags,
        onClearValue: onClearValue,
        children: [
            filteredTags?.map((tag)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26cc5ca8278fee97$export$7c90d956f54b7979), {
                        tag: tag,
                        onClick: ()=>{
                            if (onTagSelected) onTagSelected(tag);
                            else openEdit(tag);
                        },
                        onContextMenu: (event)=>{
                            setContextTag(tag);
                            handleContextMenu(event);
                        },
                        selected: preselectedIds?.includes(tag.uuid)
                    })
                }, tag.uuid)),
            (loading || !noMoreTags) && Array.from({
                length: 20
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 60
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($763293a7d490c668$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextTag);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $da8fb6a114cfefbf$export$6ae755583728ca09), {
                open: modifyTagDialogState.mode !== "closed",
                onClose: closeModifyTagDialog,
                tag: modifyTagDialogState.item,
                onNewItem: (newTag)=>{
                    const newTags = [
                        ...tags,
                        newTag
                    ];
                    newTags.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setTags(newTags);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newTag)=>{
                    const newTags = tags.map((tag)=>tag.uuid == newTag.uuid ? newTag : tag);
                    newTags.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setTags(newTags);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedTag)=>{
                    const newTags = tags.filter((tag)=>tag.uuid != deletedTag.uuid);
                    setTags(newTags);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyTagDialogKey)
        ]
    });
};



const $e3cccf3b14720ac1$export$350715167af5216e = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const assignTagToAlbum = (parameters)=>post("albums/assignTag", parameters);
    return {
        assignTagToAlbum: assignTagToAlbum
    };
};



const $20b71cdba58e39c5$export$bb3cdcaa7f836586 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const unassignTagFromAlbum = (parameters)=>deleteRequest("albums/assignTag", parameters);
    return {
        unassignTagFromAlbum: unassignTagFromAlbum
    };
};





const $73441e452e2f1a8d$export$ef64003eecb70263 = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const { reorderAlbumContents: reorderAlbumContents } = (0, $7e63b2608081d5fd$export$d327a493398dab5a)();
    const { deleteAlbumContent: deleteAlbumContent } = (0, $3894d3bcc5a82b2b$export$43b1a606e5e1c742)();
    const { assignTagToAlbum: assignTagToAlbum } = (0, $e3cccf3b14720ac1$export$350715167af5216e)();
    const { unassignTagFromAlbum: unassignTagFromAlbum } = (0, $20b71cdba58e39c5$export$bb3cdcaa7f836586)();
    const [selectedAlbumContent, setSelectedAlbumContent] = (0, $7fPBF.useState)();
    const [isLoadingAlbumContents, setIsLoadingAlbumContents] = (0, $7fPBF.useState)(false);
    const [isLoadingTags, setIsLoadingTags] = (0, $7fPBF.useState)(false);
    const [isAlbumTypesDialogOpen, setIsAlbumTypesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isTagsDialogOpen, setIsTagsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumContentDeleteConfirmationAlertOpen, setIsAlbumContentDeleteConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    const [albumContentDialogState, setAlbumContentDialogState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const [isLoadingAlbumType, setIsLoadingAlbumType] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const createAlbumContent = (newAlbumContent)=>{
        album.albumContents = [
            ...album.albumContents,
            newAlbumContent
        ];
        onAttributeUpdated(album);
    };
    const updateAlbumContent = (newAlbumContent)=>{
        album.albumContents = album.albumContents?.map((albumContent)=>albumContent.uuid == newAlbumContent.uuid ? newAlbumContent : albumContent);
        onAttributeUpdated(album);
    };
    const removeAlbumContent = async ()=>{
        setIsLoadingAlbumContents(true);
        const { status: status, body: body } = await deleteAlbumContent({
            uuid: selectedAlbumContent.uuid
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            album.albumContents = album.albumContents?.filter((albumContent)=>selectedAlbumContent.uuid != albumContent.uuid);
            onAttributeUpdated(album);
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
        }
        setIsLoadingAlbumContents(false);
    };
    const moveAlbumContents = async (fromIndex, toIndex)=>{
        const newlyOrderedAlbumContents = (0, $3c32b049e9065866$export$874a2b636708da2d)(album.albumContents, fromIndex, toIndex);
        setIsLoadingAlbumContents(true);
        const { status: status, body: body } = await reorderAlbumContents(newlyOrderedAlbumContents);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            album.albumContents = newlyOrderedAlbumContents;
            onAttributeUpdated(album);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingAlbumContents(false);
    };
    const updateAlbumType = async (newValue)=>{
        setIsAlbumTypesDialogOpen(false);
        setIsLoadingAlbumType(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            albumTypeId: newValue?.uuid ?? null
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingAlbumType(false);
    };
    const addTag = async (tagId)=>{
        setIsTagsDialogOpen(false);
        setIsLoadingTags(true);
        const { status: status, body: body } = await assignTagToAlbum({
            uuid: album.uuid,
            tagId: tagId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingTags(false);
    };
    const removeTag = async (tagId)=>{
        setIsTagsDialogOpen(false);
        setIsLoadingTags(true);
        const { status: status, body: body } = await unassignTagFromAlbum({
            uuid: album.uuid,
            tagId: tagId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingTags(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            !(isPublic && album.albumContents === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).tableDiv,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).header,
                        direction: "row",
                        spacing: 2,
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).title,
                                secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_contents_title,
                                sx: {
                                    flexGrow: 0
                                }
                            }),
                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_content,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle,
                                loading: isLoadingAlbumContents,
                                onClick: ()=>setAlbumContentDialogState({
                                        mode: "add"
                                    })
                            })
                        ]
                    }),
                    album.albumContents && album.albumContents.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        sx: {
                            width: "100%",
                            borderWidth: "1.5px",
                            borderColor: theme.palette.background.paper,
                            borderStyle: "solid"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d357a7ac9f015684$export$f7a1f2f1bfad98f4), {
                            isPublic: isPublic,
                            album: album,
                            onModify: (albumContent)=>setAlbumContentDialogState({
                                    mode: "edit",
                                    item: albumContent
                                }),
                            onMoveUp: (index)=>moveAlbumContents(index, index - 1),
                            onMoveDown: (index)=>moveAlbumContents(index, index + 1),
                            onDelete: (albumContent)=>{
                                setSelectedAlbumContent(albumContent);
                                setIsAlbumContentDeleteConfirmationAlertOpen(true);
                            }
                        })
                    })
                ]
            }),
            !(isPublic && album.albumContents === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            !(isPublic && album.tags === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ebf0d484b95486c$exports))).switchListItem,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title,
                        chips: album.tags?.map((tag)=>({
                                id: tag.uuid,
                                name: tag.name,
                                description: tag.description
                            })),
                        isLoading: isLoadingTags,
                        onAdd: ()=>setIsTagsDialogOpen(true),
                        onDelete: (_index, chip)=>removeTag(chip.id),
                        addDisabled: isPublic,
                        removeDisabled: isPublic
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                disabled: isPublic,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_type_title,
                detail: album.albumType ? album.albumType.name : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                onClick: ()=>setIsAlbumTypesDialogOpen(true),
                isLoading: isLoadingAlbumType
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $657d234e76a51d66$export$27da38f499e74ca3), {
                albumId: album.uuid,
                albumContent: albumContentDialogState.item,
                open: albumContentDialogState.mode !== "closed",
                onClose: ()=>setAlbumContentDialogState({
                        mode: "closed",
                        item: albumContentDialogState.item
                    }),
                onUpdate: albumContentDialogState.mode === "add" ? createAlbumContent : updateAlbumContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumTypesDialogOpen,
                onClose: ()=>setIsAlbumTypesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3545f666fd578acf$export$cdc91b52c28c8fd3), {
                    handleClose: ()=>setIsAlbumTypesDialogOpen(false),
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: album.albumType?.uuid,
                    onAlbumTypeSelected: updateAlbumType,
                    onClearValue: ()=>updateAlbumType(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isTagsDialogOpen,
                onClose: ()=>setIsTagsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cce4818f9f0c650e$export$cb8904e0fef9e4cd), {
                    handleClose: ()=>setIsTagsDialogOpen(false),
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    onTagSelected: (tag)=>addTag(tag.uuid),
                    preselectedIds: album.tags?.map((tag)=>tag.uuid)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_content_delete_confirmation,
                open: isAlbumContentDeleteConfirmationAlertOpen,
                setOpen: setIsAlbumContentDeleteConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: removeAlbumContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
var $6de40d052ab54451$exports = {};

$parcel$export($6de40d052ab54451$exports, "name", function () { return $6de40d052ab54451$export$a8ff84c12d48cfa6; }, function (v) { return $6de40d052ab54451$export$a8ff84c12d48cfa6 = v; });
$parcel$export($6de40d052ab54451$exports, "skeleton", function () { return $6de40d052ab54451$export$2a0674ff2eb10214; }, function (v) { return $6de40d052ab54451$export$2a0674ff2eb10214 = v; });
var $6de40d052ab54451$export$a8ff84c12d48cfa6;
var $6de40d052ab54451$export$2a0674ff2eb10214;
$6de40d052ab54451$export$a8ff84c12d48cfa6 = `lsv8uW_name`;
$6de40d052ab54451$export$2a0674ff2eb10214 = `lsv8uW_skeleton`;






var $7fPBF = parcelRequire("7fPBF");



const $b3e4bc8551a357ec$export$1b9cc50fc5d0a1ba = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).impactsStorage;
    const [impacts, setImpacts] = (0, $7fPBF.useState)(storage.getData(false, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (impacts && impacts.length > 0) return;
        setLoading(true);
        get("impacts").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setImpacts(body);
                storage.setData(body, false, "");
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
            setLoading(false);
        });
    }, dependencies);
    return impacts;
};











var $ef83eb150ef9d8f5$exports = {};

$parcel$export($ef83eb150ef9d8f5$exports, "icon", function () { return $ef83eb150ef9d8f5$export$1ca1ec8b29a4ce27; }, function (v) { return $ef83eb150ef9d8f5$export$1ca1ec8b29a4ce27 = v; });
var $ef83eb150ef9d8f5$export$1ca1ec8b29a4ce27;
$ef83eb150ef9d8f5$export$1ca1ec8b29a4ce27 = `a1cMJG_icon`;


const $928fe652c90f9927$export$fc62ba923d2898ab = ({ value: value })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: "-4px",
        children: Array.from({
            length: 5
        }, (_, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef83eb150ef9d8f5$exports))).icon,
                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Star,
                filled: i <= value
            }, i))
    });
};


const $970fe01944d5ec2f$export$6c19d36d9b1bbf40 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedId: preselectedId, onImpactSelected: onImpactSelected, onClearValue: onClearValue })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const impacts = (0, $b3e4bc8551a357ec$export$1b9cc50fc5d0a1ba)(setLoading, []);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const filteredImpacts = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return impacts;
        return impacts?.filter((impact)=>{
            return impact.description.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        impacts,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredImpacts,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).IMPACTS],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_impacts,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_impacts_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        onClearValue: onClearValue,
        children: [
            filteredImpacts?.map((impact)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        sx: {
                            height: 80,
                            borderRadius: "20px"
                        },
                        elevation: 5,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                            sx: {
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            style: {
                                borderColor: theme.palette.colors?.highlightBorder,
                                borderWidth: 4,
                                borderStyle: preselectedId == impact.id ? "double" : "none"
                            },
                            onClick: ()=>onImpactSelected?.(impact),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $928fe652c90f9927$export$fc62ba923d2898ab), {
                                    value: impact.id
                                }),
                                currentUserProfile?.shouldShowImpactDescriptions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6de40d052ab54451$exports))).name,
                                    children: impact.description
                                })
                            ]
                        })
                    })
                }, impact.id)),
            loading && Array.from({
                length: 6
            }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 80
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6de40d052ab54451$exports))).skeleton
                    })
                }, index))
        ]
    });
};









var $10e5fd1d1fe261f8$exports = {};

$parcel$export($10e5fd1d1fe261f8$exports, "impactStack", function () { return $10e5fd1d1fe261f8$export$a4d20d45f96a7198; }, function (v) { return $10e5fd1d1fe261f8$export$a4d20d45f96a7198 = v; });
var $10e5fd1d1fe261f8$export$a4d20d45f96a7198;
$10e5fd1d1fe261f8$export$a4d20d45f96a7198 = `OyAnRW_impactStack`;


const $3439dd4b1f1a51bf$export$424e5f51baecfe5b = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [isImpactsDialogOpen, setIsImpactsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingImpact, setIsLoadingImpact] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const updateImpact = async (newValue)=>{
        setIsLoadingImpact(true);
        setIsImpactsDialogOpen(false);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            impactId: newValue?.id ?? null
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoadingImpact(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                disabled: isPublic,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).impact_title,
                detail: album.impact ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($10e5fd1d1fe261f8$exports))).impactStack,
                    direction: "row",
                    spacing: 2,
                    children: [
                        currentUserProfile?.shouldShowImpactDescriptions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: album.impact.description
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $928fe652c90f9927$export$fc62ba923d2898ab), {
                            value: album.impact.id
                        })
                    ]
                }) : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
                onClick: ()=>setIsImpactsDialogOpen(true),
                isLoading: isLoadingImpact
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isImpactsDialogOpen,
                onClose: ()=>setIsImpactsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $970fe01944d5ec2f$export$6c19d36d9b1bbf40), {
                    handleClose: ()=>{
                        setIsImpactsDialogOpen(false);
                    },
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: album.impact?.id,
                    onImpactSelected: updateImpact,
                    onClearValue: ()=>updateImpact(undefined)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");
var $ccb35989f537c0fb$exports = {};

$parcel$export($ccb35989f537c0fb$exports, "itemDiv", function () { return $ccb35989f537c0fb$export$64c46d98173ac23d; }, function (v) { return $ccb35989f537c0fb$export$64c46d98173ac23d = v; });
$parcel$export($ccb35989f537c0fb$exports, "loadingIndicator", function () { return $ccb35989f537c0fb$export$f10e6b4aaa94c253; }, function (v) { return $ccb35989f537c0fb$export$f10e6b4aaa94c253 = v; });
$parcel$export($ccb35989f537c0fb$exports, "title", function () { return $ccb35989f537c0fb$export$fb184b623420d9be; }, function (v) { return $ccb35989f537c0fb$export$fb184b623420d9be = v; });
$parcel$export($ccb35989f537c0fb$exports, "value", function () { return $ccb35989f537c0fb$export$2ab9a8f9f1186f14; }, function (v) { return $ccb35989f537c0fb$export$2ab9a8f9f1186f14 = v; });
var $ccb35989f537c0fb$export$64c46d98173ac23d;
var $ccb35989f537c0fb$export$f10e6b4aaa94c253;
var $ccb35989f537c0fb$export$fb184b623420d9be;
var $ccb35989f537c0fb$export$2ab9a8f9f1186f14;
$ccb35989f537c0fb$export$64c46d98173ac23d = `IB0P9G_itemDiv`;
$ccb35989f537c0fb$export$f10e6b4aaa94c253 = `IB0P9G_loadingIndicator`;
$ccb35989f537c0fb$export$fb184b623420d9be = `IB0P9G_title`;
$ccb35989f537c0fb$export$2ab9a8f9f1186f14 = `IB0P9G_value`;







var $7fPBF = parcelRequire("7fPBF");
var $c60f467d050cbc51$exports = {};

$parcel$export($c60f467d050cbc51$exports, "counter", function () { return $c60f467d050cbc51$export$e575061ef2a070eb; }, function (v) { return $c60f467d050cbc51$export$e575061ef2a070eb = v; });
$parcel$export($c60f467d050cbc51$exports, "description", function () { return $c60f467d050cbc51$export$6d59db4903f20f7d; }, function (v) { return $c60f467d050cbc51$export$6d59db4903f20f7d = v; });
$parcel$export($c60f467d050cbc51$exports, "incrementalButton", function () { return $c60f467d050cbc51$export$a2c754d66c26d700; }, function (v) { return $c60f467d050cbc51$export$a2c754d66c26d700 = v; });
$parcel$export($c60f467d050cbc51$exports, "number", function () { return $c60f467d050cbc51$export$98e628dec113755e; }, function (v) { return $c60f467d050cbc51$export$98e628dec113755e = v; });
var $c60f467d050cbc51$export$e575061ef2a070eb;
var $c60f467d050cbc51$export$6d59db4903f20f7d;
var $c60f467d050cbc51$export$a2c754d66c26d700;
var $c60f467d050cbc51$export$98e628dec113755e;
$c60f467d050cbc51$export$e575061ef2a070eb = `PYkBJq_counter`;
$c60f467d050cbc51$export$6d59db4903f20f7d = `PYkBJq_description`;
$c60f467d050cbc51$export$a2c754d66c26d700 = `PYkBJq_incrementalButton`;
$c60f467d050cbc51$export$98e628dec113755e = `PYkBJq_number`;









const $91af23ad81bff193$export$182c0961afa42490 = ({ title: title, description: description, canClear: canClear, open: open, setOpen: setOpen, value: value, maxValue: maxValue, onChange: onChange })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [incrementalNumber, setIncrementalNumber] = (0, $7fPBF.useState)(value ?? 1);
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: open,
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    canClear && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>{
                            onChange(null);
                            handleClose();
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_value,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                        color: theme.palette.colors?.remove
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c60f467d050cbc51$exports))).description,
                        children: description
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce83a575e7610c25$export$1b74141c5fe63a28), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c60f467d050cbc51$exports))).counter,
                        initialValue: value ?? 1,
                        minimumValue: 1,
                        maximumValue: maxValue,
                        nullable: canClear,
                        onValueChanged: (newValue)=>setIncrementalNumber(newValue)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    type: "submit",
                    onClick: ()=>{
                        onChange(incrementalNumber);
                        handleClose();
                    },
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                })
            })
        ]
    });
};






parcelRequire("7fPBF");
var $c7abc628218a2290$exports = {};

$parcel$export($c7abc628218a2290$exports, "calculateButton", function () { return $c7abc628218a2290$export$30b30e1d9900363; }, function (v) { return $c7abc628218a2290$export$30b30e1d9900363 = v; });
$parcel$export($c7abc628218a2290$exports, "cancelButton", function () { return $c7abc628218a2290$export$4ededb8e5b56a6fb; }, function (v) { return $c7abc628218a2290$export$4ededb8e5b56a6fb = v; });
$parcel$export($c7abc628218a2290$exports, "description", function () { return $c7abc628218a2290$export$6d59db4903f20f7d; }, function (v) { return $c7abc628218a2290$export$6d59db4903f20f7d = v; });
$parcel$export($c7abc628218a2290$exports, "textField", function () { return $c7abc628218a2290$export$c54b92c0bb02ba64; }, function (v) { return $c7abc628218a2290$export$c54b92c0bb02ba64 = v; });
var $c7abc628218a2290$export$30b30e1d9900363;
var $c7abc628218a2290$export$4ededb8e5b56a6fb;
var $c7abc628218a2290$export$6d59db4903f20f7d;
var $c7abc628218a2290$export$c54b92c0bb02ba64;
$c7abc628218a2290$export$30b30e1d9900363 = `uGK2RG_calculateButton`;
$c7abc628218a2290$export$4ededb8e5b56a6fb = `uGK2RG_cancelButton`;
$c7abc628218a2290$export$6d59db4903f20f7d = `uGK2RG_description`;
$c7abc628218a2290$export$c54b92c0bb02ba64 = `uGK2RG_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");



parcelRequire("7fPBF");



const $fe9f035dcd2ab465$export$e87860770d5b0984 = ({ id: id, name: name, defaultValue: defaultValue, size: size, autoFocus: autoFocus, onChange: onChange, enterAction: enterAction })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
        id: id,
        name: name,
        defaultValue: defaultValue ? (0, $9814b23db5adb339$export$8bb95198b45adaac).toHHMMSS(defaultValue) : undefined,
        size: size,
        mask: [
            /\d/,
            /\d/,
            ":",
            /\d/,
            /\d/,
            ":",
            /\d/,
            /\d/
        ],
        placeholder: "HH:mm:ss",
        autoFocus: autoFocus,
        onChange: (event)=>{
            onChange((0, $9814b23db5adb339$export$8bb95198b45adaac).getSeconds(event.target.value));
        },
        enterAction: enterAction,
        style: {
            color: theme.palette.primary.main,
            width: "100%",
            height: "37px",
            borderRadius: "12px",
            fontWeight: "bold"
        }
    });
};









const $c3cb5763ad49778d$export$b6323b0686f678ba = ({ title: title, description: description, missingText: missingText, open: open, setOpen: setOpen, value: value, onChange: onChange, onClearValue: onClearValue, trackList: trackList })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const onCancel = ()=>{
        formik.resetForm();
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        length: $57e52f3b537dfd4b$export$98e628dec113755e().required(missingText)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            length: value ?? 0
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ length: length })=>{
            if (formik.dirty && length) {
                onChange(length);
                setOpen(false);
            }
        },
        validationSchema: validationSchema
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
            fullWidth: true,
            maxWidth: "xs",
            open: open,
            onClose: onCancel,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    onClick: ()=>{
                                        if (!trackList) return;
                                        let length = 0;
                                        trackList.forEach((track)=>{
                                            length += track.length ?? 0;
                                        });
                                        onChange(length);
                                        setOpen(false);
                                    },
                                    disabled: !trackList,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).mtl_calculate,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Calculate
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                    flexItem: true,
                                    orientation: "vertical"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    onClick: ()=>{
                                        onClearValue();
                                        formik.resetForm();
                                        setOpen(false);
                                    },
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_value,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                    color: theme.palette.colors?.remove
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: onCancel,
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                    sx: {
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7abc628218a2290$exports))).description,
                            children: description
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7abc628218a2290$exports))).textField,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe9f035dcd2ab465$export$e87860770d5b0984), {
                                id: "length",
                                name: "length",
                                size: "small",
                                defaultValue: formik.values.length,
                                autoFocus: !isMobile,
                                onChange: (newValue)=>formik.setFieldValue("length", newValue),
                                enterAction: formik.submitForm
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                        type: "submit",
                        onClick: formik.handleSubmit,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                    })
                })
            ]
        })
    });
};







const $cc717fec9921856f$export$862c6280e38b90b8 = ({ isPublic: isPublic, className: className, album: album, onDiscogsIdUpdated: onDiscogsIdUpdated, onLengthUpdated: onLengthUpdated, onTracksUpdated: onTracksUpdated, onCopy: onCopy, onDelete: onDelete, onMarkAs: onMarkAs, onPlayFromYouTube: onPlayFromYouTube })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [isTracksDialogOpen, setIsTracksDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingTracks, setIsLoadingTracks] = (0, $7fPBF.useState)(false);
    const [isLengthDialogOpen, setIsLengthDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingLength, setIsLoadingLength] = (0, $7fPBF.useState)(false);
    const { state: discogsIdDialogState, key: discogsIdDialogKey, openEdit: openDiscogsIdDialog, close: closeDiscogsIdDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isLoadingDiscogsId, setIsLoadingDiscogsId] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const updateTracks = async (newValue)=>{
        setIsLoadingTracks(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            tracks: newValue
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album.tracks = body.tracks ?? undefined;
            onTracksUpdated();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingTracks(false);
    };
    const updateLength = async (newValue)=>{
        setIsLoadingLength(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            length: newValue
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album.length = body.length;
            onLengthUpdated();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingLength(false);
    };
    const updateDiscogsId = async (newValue)=>{
        setIsLoadingDiscogsId(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            discogsReleaseId: newValue
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album.discogsReleaseId = body.discogsReleaseId;
            onDiscogsIdUpdated(body.discogsReleaseId);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingDiscogsId(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: className,
        disablePadding: true,
        disableGutters: true,
        sx: {
            padding: "0 !important"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                elevation: 5,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).itemDiv,
                style: {
                    backgroundColor: theme.palette.background.default
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    flexGrow: 1,
                    justifyContent: "space-around",
                    minHeight: 44,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                            disabled: isPublic || album.isBoxSet,
                            onClick: ()=>setIsTracksDialogOpen(true),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                margin: "2px",
                                spacing: "3px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).title,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_count_title_big
                                    }),
                                    isLoadingTracks ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).loadingIndicator
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).value,
                                        children: album.tracks ?? "-"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                            disabled: isPublic || album.isBoxSet,
                            onClick: ()=>setIsLengthDialogOpen(true),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                margin: "2px",
                                spacing: "3px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).title,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_title_big
                                    }),
                                    isLoadingLength ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).loadingIndicator
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).value,
                                        children: album.length ? (0, $9814b23db5adb339$export$8bb95198b45adaac).getStringForDisplay(album.length) : "-"
                                    })
                                ]
                            })
                        }),
                        !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                            onClick: ()=>openDiscogsIdDialog(album.discogsReleaseId),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                margin: "2px",
                                spacing: "3px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).title,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_id_title_big
                                    }),
                                    isLoadingDiscogsId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).loadingIndicator
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ccb35989f537c0fb$exports))).value,
                                        children: album.discogsReleaseId && album.discogsReleaseId != "" ? album.discogsReleaseId : "-"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31bf917e4d2874f2$export$2a7b51d5dc98980), {
                            isPublic: isPublic,
                            album: album,
                            userEvent: undefined,
                            onCopy: onCopy,
                            onPlayFromYouTube: onPlayFromYouTube,
                            onMarkAs: onMarkAs,
                            onDelete: onDelete,
                            style: {
                                width: isPublic && album.isBoxSet ? "100%" : undefined
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91af23ad81bff193$export$182c0961afa42490), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_count_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_count_message,
                value: album.tracks,
                canClear: true,
                open: isTracksDialogOpen,
                setOpen: setIsTracksDialogOpen,
                onChange: updateTracks
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3cb5763ad49778d$export$b6323b0686f678ba), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_message,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                trackList: album.trackList,
                value: album.length,
                open: isLengthDialogOpen,
                setOpen: setIsLengthDialogOpen,
                onChange: updateLength,
                onClearValue: ()=>updateLength(0)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_id_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_id_message,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: discogsIdDialogState.item,
                canClear: true,
                open: discogsIdDialogState.mode !== "closed",
                onClose: closeDiscogsIdDialog,
                isNumber: false,
                onChange: updateDiscogsId,
                onClearValue: ()=>updateDiscogsId(null)
            }, discogsIdDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $cc2e47a8d1c088cf$exports = {};

$parcel$export($cc2e47a8d1c088cf$exports, "container", function () { return $cc2e47a8d1c088cf$export$34e0f9847d4c02dd; }, function (v) { return $cc2e47a8d1c088cf$export$34e0f9847d4c02dd = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "extraArtists", function () { return $cc2e47a8d1c088cf$export$7bac52efa2fd1aca; }, function (v) { return $cc2e47a8d1c088cf$export$7bac52efa2fd1aca = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "hideOnHover", function () { return $cc2e47a8d1c088cf$export$3dc3ad78444e0321; }, function (v) { return $cc2e47a8d1c088cf$export$3dc3ad78444e0321 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "hoverButton", function () { return $cc2e47a8d1c088cf$export$b0260c0afbf48c57; }, function (v) { return $cc2e47a8d1c088cf$export$b0260c0afbf48c57 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "hoverButtonIcon", function () { return $cc2e47a8d1c088cf$export$2a797adc03a2480; }, function (v) { return $cc2e47a8d1c088cf$export$2a797adc03a2480 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "hoverButtonsStack", function () { return $cc2e47a8d1c088cf$export$a8eacba2c33c9f28; }, function (v) { return $cc2e47a8d1c088cf$export$a8eacba2c33c9f28 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "length", function () { return $cc2e47a8d1c088cf$export$f24224f1c91d8156; }, function (v) { return $cc2e47a8d1c088cf$export$f24224f1c91d8156 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "loading", function () { return $cc2e47a8d1c088cf$export$46c1c92549715335; }, function (v) { return $cc2e47a8d1c088cf$export$46c1c92549715335 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "name", function () { return $cc2e47a8d1c088cf$export$a8ff84c12d48cfa6; }, function (v) { return $cc2e47a8d1c088cf$export$a8ff84c12d48cfa6 = v; });
$parcel$export($cc2e47a8d1c088cf$exports, "position", function () { return $cc2e47a8d1c088cf$export$5880b8b5730aff45; }, function (v) { return $cc2e47a8d1c088cf$export$5880b8b5730aff45 = v; });
var $cc2e47a8d1c088cf$export$34e0f9847d4c02dd;
var $cc2e47a8d1c088cf$export$7bac52efa2fd1aca;
var $cc2e47a8d1c088cf$export$3dc3ad78444e0321;
var $cc2e47a8d1c088cf$export$b0260c0afbf48c57;
var $cc2e47a8d1c088cf$export$2a797adc03a2480;
var $cc2e47a8d1c088cf$export$a8eacba2c33c9f28;
var $cc2e47a8d1c088cf$export$f24224f1c91d8156;
var $cc2e47a8d1c088cf$export$46c1c92549715335;
var $cc2e47a8d1c088cf$export$a8ff84c12d48cfa6;
var $cc2e47a8d1c088cf$export$5880b8b5730aff45;
$cc2e47a8d1c088cf$export$34e0f9847d4c02dd = `_1pudoW_container`;
$cc2e47a8d1c088cf$export$7bac52efa2fd1aca = `_1pudoW_extraArtists`;
$cc2e47a8d1c088cf$export$3dc3ad78444e0321 = `_1pudoW_hideOnHover`;
$cc2e47a8d1c088cf$export$b0260c0afbf48c57 = `_1pudoW_hoverButton`;
$cc2e47a8d1c088cf$export$2a797adc03a2480 = `_1pudoW_hoverButtonIcon`;
$cc2e47a8d1c088cf$export$a8eacba2c33c9f28 = `_1pudoW_hoverButtonsStack`;
$cc2e47a8d1c088cf$export$f24224f1c91d8156 = `_1pudoW_length`;
$cc2e47a8d1c088cf$export$46c1c92549715335 = `_1pudoW_loading`;
$cc2e47a8d1c088cf$export$a8ff84c12d48cfa6 = `_1pudoW_name`;
$cc2e47a8d1c088cf$export$5880b8b5730aff45 = `_1pudoW_position`;















const $316fdca5620b3667$export$66c5c8c1442de7b8 = ({ track: track, artistName: artistName, albumName: albumName, onPlayFromYouTube: onPlayFromYouTube })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const getVideoId = (0, $af828632625b31bb$export$64a84caa05affe34)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    const playFromYouTube = async ()=>{
        setIsLoading(true);
        const videoId = await getVideoId(`${artistName} ${albumName} ${track.name}`);
        if (videoId) onPlayFromYouTube(videoId);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).player_unknown_error);
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).container,
        onContextMenu: handleContextMenu,
        ...handleLongPress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                disableGutters: true,
                onClick: ()=>setIsExpanded((state)=>!state),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    flexGrow: 1,
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).position,
                            children: track.position
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).name,
                                    children: track.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).extraArtists,
                                    style: {
                                        color: theme.palette.secondary.main,
                                        WebkitLineClamp: isExpanded ? undefined : 1
                                    },
                                    children: track.extraArtists?.join("\r\n")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).loading
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).length, (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).hideOnHover),
                            children: track.length ? (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(track.length) : undefined
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>{
                            event.stopPropagation();
                            handleContextMenu(event);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2e47a8d1c088cf$exports))).hoverButtonIcon,
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await playFromYouTube();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PlayCircle
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).play_from_youtube
                        ]
                    }),
                    track.extraArtists && track.extraArtists.length > 0 && track.extraArtists[0] != "" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsExpanded((state)=>!state);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: isExpanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Compress
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Expand
                                })
                            }),
                            isExpanded ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shrink : (0, $37bec70ed65ed924$export$21c51bc433c16634).expand
                        ]
                    })
                ]
            })
        ]
    });
};



var $614477509bb557ed$exports = {};

$parcel$export($614477509bb557ed$exports, "list", function () { return $614477509bb557ed$export$8837f4fc672e936d; }, function (v) { return $614477509bb557ed$export$8837f4fc672e936d = v; });
$parcel$export($614477509bb557ed$exports, "loadingIndicator", function () { return $614477509bb557ed$export$f10e6b4aaa94c253; }, function (v) { return $614477509bb557ed$export$f10e6b4aaa94c253 = v; });
$parcel$export($614477509bb557ed$exports, "playButton", function () { return $614477509bb557ed$export$73e4574fc43cf3a2; }, function (v) { return $614477509bb557ed$export$73e4574fc43cf3a2 = v; });
$parcel$export($614477509bb557ed$exports, "title", function () { return $614477509bb557ed$export$fb184b623420d9be; }, function (v) { return $614477509bb557ed$export$fb184b623420d9be = v; });
$parcel$export($614477509bb557ed$exports, "trackListTitle", function () { return $614477509bb557ed$export$6e58acce95ed6f84; }, function (v) { return $614477509bb557ed$export$6e58acce95ed6f84 = v; });
var $614477509bb557ed$export$8837f4fc672e936d;
var $614477509bb557ed$export$f10e6b4aaa94c253;
var $614477509bb557ed$export$73e4574fc43cf3a2;
var $614477509bb557ed$export$fb184b623420d9be;
var $614477509bb557ed$export$6e58acce95ed6f84;
$614477509bb557ed$export$8837f4fc672e936d = `zihLOq_list`;
$614477509bb557ed$export$f10e6b4aaa94c253 = `zihLOq_loadingIndicator`;
$614477509bb557ed$export$73e4574fc43cf3a2 = `zihLOq_playButton`;
$614477509bb557ed$export$fb184b623420d9be = `zihLOq_title`;
$614477509bb557ed$export$6e58acce95ed6f84 = `zihLOq_trackListTitle`;





var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
var $2d39fb7935ef1440$exports = {};

$parcel$export($2d39fb7935ef1440$exports, "actionArea", function () { return $2d39fb7935ef1440$export$746dc5cb6bd7e71f; }, function (v) { return $2d39fb7935ef1440$export$746dc5cb6bd7e71f = v; });
$parcel$export($2d39fb7935ef1440$exports, "container", function () { return $2d39fb7935ef1440$export$34e0f9847d4c02dd; }, function (v) { return $2d39fb7935ef1440$export$34e0f9847d4c02dd = v; });
$parcel$export($2d39fb7935ef1440$exports, "deleteButton", function () { return $2d39fb7935ef1440$export$62f325dbfbc8f81; }, function (v) { return $2d39fb7935ef1440$export$62f325dbfbc8f81 = v; });
$parcel$export($2d39fb7935ef1440$exports, "dragIcon", function () { return $2d39fb7935ef1440$export$57b20f32f7ac9ff6; }, function (v) { return $2d39fb7935ef1440$export$57b20f32f7ac9ff6 = v; });
$parcel$export($2d39fb7935ef1440$exports, "extraArtists", function () { return $2d39fb7935ef1440$export$7bac52efa2fd1aca; }, function (v) { return $2d39fb7935ef1440$export$7bac52efa2fd1aca = v; });
$parcel$export($2d39fb7935ef1440$exports, "length", function () { return $2d39fb7935ef1440$export$f24224f1c91d8156; }, function (v) { return $2d39fb7935ef1440$export$f24224f1c91d8156 = v; });
$parcel$export($2d39fb7935ef1440$exports, "lengthContainer", function () { return $2d39fb7935ef1440$export$ed5584daca84d33d; }, function (v) { return $2d39fb7935ef1440$export$ed5584daca84d33d = v; });
$parcel$export($2d39fb7935ef1440$exports, "name", function () { return $2d39fb7935ef1440$export$a8ff84c12d48cfa6; }, function (v) { return $2d39fb7935ef1440$export$a8ff84c12d48cfa6 = v; });
$parcel$export($2d39fb7935ef1440$exports, "position", function () { return $2d39fb7935ef1440$export$5880b8b5730aff45; }, function (v) { return $2d39fb7935ef1440$export$5880b8b5730aff45 = v; });
$parcel$export($2d39fb7935ef1440$exports, "positionContainer", function () { return $2d39fb7935ef1440$export$4b16a1eee4ce71f1; }, function (v) { return $2d39fb7935ef1440$export$4b16a1eee4ce71f1 = v; });
var $2d39fb7935ef1440$export$746dc5cb6bd7e71f;
var $2d39fb7935ef1440$export$34e0f9847d4c02dd;
var $2d39fb7935ef1440$export$62f325dbfbc8f81;
var $2d39fb7935ef1440$export$57b20f32f7ac9ff6;
var $2d39fb7935ef1440$export$7bac52efa2fd1aca;
var $2d39fb7935ef1440$export$f24224f1c91d8156;
var $2d39fb7935ef1440$export$ed5584daca84d33d;
var $2d39fb7935ef1440$export$a8ff84c12d48cfa6;
var $2d39fb7935ef1440$export$5880b8b5730aff45;
var $2d39fb7935ef1440$export$4b16a1eee4ce71f1;
$2d39fb7935ef1440$export$746dc5cb6bd7e71f = `VHBDCq_actionArea`;
$2d39fb7935ef1440$export$34e0f9847d4c02dd = `VHBDCq_container`;
$2d39fb7935ef1440$export$62f325dbfbc8f81 = `VHBDCq_deleteButton`;
$2d39fb7935ef1440$export$57b20f32f7ac9ff6 = `VHBDCq_dragIcon`;
$2d39fb7935ef1440$export$7bac52efa2fd1aca = `VHBDCq_extraArtists`;
$2d39fb7935ef1440$export$f24224f1c91d8156 = `VHBDCq_length`;
$2d39fb7935ef1440$export$ed5584daca84d33d = `VHBDCq_lengthContainer`;
$2d39fb7935ef1440$export$a8ff84c12d48cfa6 = `VHBDCq_name`;
$2d39fb7935ef1440$export$5880b8b5730aff45 = `VHBDCq_position`;
$2d39fb7935ef1440$export$4b16a1eee4ce71f1 = `VHBDCq_positionContainer`;












const $5762d87c42508362$export$8a38918016142bff = ({ track: track, onUpdate: onUpdate, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [name, setName] = (0, $7fPBF.useState)(track.name);
    const { state: trackNameDialogState, key: trackNameDialogKey, openEdit: openTrackNameDialog, close: closeTrackNameDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [position, setPosition] = (0, $7fPBF.useState)(track.position);
    const { state: trackPositionDialogState, key: trackPositionDialogKey, openEdit: openTrackPositionDialog, close: closeTrackPositionDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [length, setLength] = (0, $7fPBF.useState)(track.length);
    const [isOpenTrackLengthDialog, setIsOpenTrackLengthDialog] = (0, $7fPBF.useState)(false);
    const [extraArtists, setExtraArtists] = (0, $7fPBF.useState)(track.extraArtists);
    const [isOpenTrackExtraArtistsDialog, setIsOpenTrackExtraArtistsDialog] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).container,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).dragIcon,
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).actionArea, (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).positionContainer),
                                            onClick: ()=>openTrackPositionDialog(position),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).position,
                                                children: position ?? "##"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).actionArea,
                                            onClick: ()=>openTrackNameDialog(name),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).name,
                                                children: name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).actionArea, (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).lengthContainer),
                                            onClick: ()=>setIsOpenTrackLengthDialog(true),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).length,
                                                children: (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(length ?? 0)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).actionArea,
                                            onClick: ()=>setIsOpenTrackExtraArtistsDialog(true),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).extraArtists,
                                                style: {
                                                    color: extraArtists ? theme.palette.primary.main : theme.palette.primary.subtitle
                                                },
                                                children: extraArtists?.join("\r\n") ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).track_extra_artists_placeholder
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2d39fb7935ef1440$exports))).deleteButton,
                                            onClick: onDelete,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_name_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_name_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_name_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: trackNameDialogState.item,
                canClear: false,
                open: trackNameDialogState.mode !== "closed",
                onClose: closeTrackNameDialog,
                isNumber: false,
                onChange: (newValue)=>{
                    setName(newValue);
                    track.name = newValue;
                    onUpdate();
                }
            }, trackNameDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_position_title,
                description: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).track_position_description, name),
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_position_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: trackPositionDialogState.item,
                canClear: true,
                open: trackPositionDialogState.mode !== "closed",
                onClose: closeTrackPositionDialog,
                isNumber: false,
                onChange: (newValue)=>{
                    setPosition(newValue);
                    track.position = newValue;
                    onUpdate();
                },
                onClearValue: ()=>{
                    setPosition(undefined);
                    track.position = undefined;
                    onUpdate();
                }
            }, trackPositionDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3cb5763ad49778d$export$b6323b0686f678ba), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_length_title,
                description: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).track_length_description, name),
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: length,
                open: isOpenTrackLengthDialog,
                setOpen: setIsOpenTrackLengthDialog,
                onChange: (newValue)=>{
                    setLength(newValue);
                    track.length = newValue;
                    onUpdate();
                },
                onClearValue: ()=>{
                    setLength(undefined);
                    track.length = undefined;
                    onUpdate();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_extra_artists_title,
                description: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).track_extra_artists_description, name),
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_extra_artists_placeholder,
                value: extraArtists?.join("\r\n"),
                open: isOpenTrackExtraArtistsDialog,
                onClose: ()=>setIsOpenTrackExtraArtistsDialog(false),
                onChange: (newValue)=>{
                    const newExtraArtists = newValue.split("\r\n");
                    setExtraArtists(newExtraArtists);
                    track.extraArtists = newExtraArtists;
                    onUpdate();
                },
                onClearValue: ()=>{
                    setExtraArtists(undefined);
                    track.extraArtists = undefined;
                    onUpdate();
                }
            })
        ]
    });
};







const $fadcf04f5e0ec6ac$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fadcf04f5e0ec6ac$export$2e2bcd8739ae039 = {
    randomUUID: $fadcf04f5e0ec6ac$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $2bcaa466815aa8a5$var$getRandomValues;
const $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $2bcaa466815aa8a5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$2bcaa466815aa8a5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $ee13ceee8d9f46c4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ee13ceee8d9f46c4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]];
}
function $ee13ceee8d9f46c4$var$stringify(arr, offset = 0) {
    const uuid = $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    if ((0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;





var $fw0lo = parcelRequire("fw0lo");

const $7c21966a04e1eba4$export$db4c01b6f2280036 = ({ trackList: trackList, open: open, setOpen: setOpen, fetchFromDiscogsEnabled: fetchFromDiscogsEnabled, onChange: onChange, onFetchFromDiscogs: onFetchFromDiscogs })=>{
    const [tracks, setTracks] = (0, $7fPBF.useState)(trackList ?? []);
    const [didMakeUpdates, setDidMakeUpdates] = (0, $7fPBF.useState)(false);
    const bottomReference = (0, $7fPBF.useRef)(null);
    const [isOpenFetchFromDiscogsConfirmationAlert, setIsOpenFetchFromDiscogsConfirmationAlert] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const scrollToBottom = ()=>{
        bottomReference.current?.scrollIntoView({
            behavior: "smooth"
        });
    };
    const resetData = ()=>{
        setTracks(trackList ?? []);
    };
    const onCancel = ()=>{
        if (didMakeUpdates) setIsConfirmCloseAlertOpen(true);
        else handleClose();
    };
    const handleClose = ()=>{
        setDidMakeUpdates(false);
        setOpen(false);
    };
    const onSubmit = ()=>{
        onChange(tracks);
        handleClose();
    };
    const addTrack = ()=>{
        (0, $fw0lo.flushSync)(()=>{
            setTracks((tracks)=>[
                    ...tracks,
                    {
                        order: -1,
                        name: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_track_name
                    }
                ]);
        });
        setDidMakeUpdates(true);
        scrollToBottom();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "md",
        open: open,
        onClose: onCancel,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                style: {
                    zIndex: 1000
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        style: {
                            marginRight: 8
                        },
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_list_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        disabled: !fetchFromDiscogsEnabled,
                        onClick: ()=>setIsOpenFetchFromDiscogsConfirmationAlert(true),
                        tooltip: fetchFromDiscogsEnabled ? (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_from_discogs : (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_from_discogs_disabled,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Download
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: addTrack,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_track,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: onCancel,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$237bd83162c14364), {
                onDragEnd: (result)=>{
                    if (!result.destination || result.source.index == result.destination.index) return;
                    (0, $3c32b049e9065866$export$79f3cf326dbd2413)(tracks, result.source.index, result.destination.index);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                    dividers: true,
                    children: tracks.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$423ec2075359570a), {
                        droppableId: "trackList",
                        children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                ref: provided.innerRef,
                                ...provided.droppableProps,
                                children: [
                                    tracks.map((track, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
                                            draggableId: `draggable.${index}`,
                                            index: index,
                                            children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ac3a4be76d66fd9b$exports))).albumItemContainer,
                                                    ref: provided.innerRef,
                                                    ...provided.draggableProps,
                                                    ...provided.dragHandleProps,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5762d87c42508362$export$8a38918016142bff), {
                                                        track: track,
                                                        onUpdate: ()=>setDidMakeUpdates(true),
                                                        onDelete: ()=>{
                                                            const newTracks = tracks.filter((_, i)=>i !== index);
                                                            setTracks(newTracks);
                                                            setDidMakeUpdates(true);
                                                        }
                                                    })
                                                })
                                        }, (0, $6810e10b84975c3e$export$2e2bcd8739ae039)())),
                                    provided.placeholder,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        ref: bottomReference
                                    })
                                ]
                            })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: false,
                        items: tracks,
                        emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Genres,
                        emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_tracklist,
                        emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_attribute_description,
                        searchText: undefined,
                        canAdd: true,
                        addButtonTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_track,
                        onAddItem: addTrack
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    type: "submit",
                    onClick: onSubmit,
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).save
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_tracks_from_discogs_confirmation,
                open: isOpenFetchFromDiscogsConfirmationAlert,
                setOpen: setIsOpenFetchFromDiscogsConfirmationAlert,
                isConfirm: true,
                onConfirm: ()=>{
                    onFetchFromDiscogs();
                    handleClose();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: ()=>{
                    resetData();
                    handleClose();
                },
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            })
        ]
    });
};







const $c900586d38c94b37$export$2c37cd9700e5dda3 = ({ isPublic: isPublic, className: className, album: album, artistName: artistName, albumName: albumName, fetchFromDiscogsEnabled: fetchFromDiscogsEnabled, isLoading: isLoading, onChange: onChange, onPlayFromYouTube: onPlayFromYouTube, onFetchTrackListFromDiscogs: onFetchTrackListFromDiscogs })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const getVideoIds = (0, $935530e1b4d603d2$export$3a220a9dac4bee11)();
    const [isFetchingVideoIds, setIsFetchingVideoIds] = (0, $7fPBF.useState)(false);
    const [isTrackListDialogOpen, setIsTrackListDialogOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        elevation: 5,
        className: className,
        sx: {
            display: "flex",
            flexDirection: "column",
            alignSelf: isMobile ? "center" : "stretch"
        },
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                style: {
                    width: "100%",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).trackListTitle,
                        disabled: isPublic || isLoading,
                        onClick: ()=>{
                            setIsTrackListDialogOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).title,
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_list_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            })
                        ]
                    }),
                    isFetchingVideoIds || isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).playButton,
                        disabled: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).loadingIndicator
                        })
                    }) : !isMobile && album.trackList && album.trackList.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).play_from_youtube,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).playButton,
                            onClick: async ()=>{
                                setIsFetchingVideoIds(true);
                                const videoIds = await getVideoIds(album.trackList, albumName, artistName);
                                setIsFetchingVideoIds(false);
                                if (videoIds.length > 0) onPlayFromYouTube(videoIds);
                                else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).player_unknown_error);
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PlayCircle
                            })
                        })
                    })
                ]
            }),
            album.trackList && album.trackList.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($614477509bb557ed$exports))).list,
                disablePadding: true,
                children: !isLoading && album.trackList?.map((track, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $316fdca5620b3667$export$66c5c8c1442de7b8), {
                                track: track,
                                artistName: artistName,
                                albumName: albumName,
                                onPlayFromYouTube: (videoId)=>onPlayFromYouTube([
                                        videoId
                                    ])
                            }, `${album.uuid}_${index}`),
                            index < album.trackList.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                                color: theme.palette.background.paper
                            })
                        ]
                    }, index))
            }),
            !isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c21966a04e1eba4$export$db4c01b6f2280036), {
                open: isTrackListDialogOpen,
                setOpen: setIsTrackListDialogOpen,
                trackList: album.trackList,
                fetchFromDiscogsEnabled: fetchFromDiscogsEnabled,
                onChange: (newTrackList)=>onChange(newTrackList),
                onFetchFromDiscogs: ()=>onFetchTrackListFromDiscogs()
            }, album.uuid)
        ]
    });
};



const $a4cfc2af9eed3279$export$f286195870dcd4f8 = ()=>{
    const { patch: patch } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const fetchTracks = (albumUuid)=>patch(`albums/${albumUuid}`);
    return {
        fetchTracks: fetchTracks
    };
};







var $7fPBF = parcelRequire("7fPBF");







const $d183a274fd419e00$export$677c1b206168cc7a = ({ isPublic: isPublic, album: album, onAttributeUpdated: onAttributeUpdated })=>{
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const [isNotesDialogOpen, setIsNotesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const updateNotes = async (newValue)=>{
        setIsLoading(true);
        const { body: body, status: status } = await updateAlbum({
            uuid: album.uuid,
            notes: newValue
        });
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            onAttributeUpdated(body);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                disabled: isPublic,
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).notes_title,
                detail: album.notes ? album.notes : "--",
                onClick: ()=>setIsNotesDialogOpen(true),
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).notes_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).notes_detail,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).notes_placeholder,
                open: isNotesDialogOpen,
                onClose: ()=>setIsNotesDialogOpen(false),
                value: album.notes,
                onChange: updateNotes,
                onClearValue: ()=>updateNotes("")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};






var $7fPBF = parcelRequire("7fPBF");



var $4da058ffa0b34a43$exports = {};

$parcel$export($4da058ffa0b34a43$exports, "collectionCard", function () { return $4da058ffa0b34a43$export$63ab7202a5c80ed; }, function (v) { return $4da058ffa0b34a43$export$63ab7202a5c80ed = v; });
$parcel$export($4da058ffa0b34a43$exports, "header", function () { return $4da058ffa0b34a43$export$38e42c68cf43b5d4; }, function (v) { return $4da058ffa0b34a43$export$38e42c68cf43b5d4 = v; });
$parcel$export($4da058ffa0b34a43$exports, "hoverButton", function () { return $4da058ffa0b34a43$export$b0260c0afbf48c57; }, function (v) { return $4da058ffa0b34a43$export$b0260c0afbf48c57 = v; });
$parcel$export($4da058ffa0b34a43$exports, "hoverButtonsStack", function () { return $4da058ffa0b34a43$export$a8eacba2c33c9f28; }, function (v) { return $4da058ffa0b34a43$export$a8eacba2c33c9f28 = v; });
$parcel$export($4da058ffa0b34a43$exports, "itemDiv", function () { return $4da058ffa0b34a43$export$64c46d98173ac23d; }, function (v) { return $4da058ffa0b34a43$export$64c46d98173ac23d = v; });
$parcel$export($4da058ffa0b34a43$exports, "noCollectionText", function () { return $4da058ffa0b34a43$export$d5652829e27db078; }, function (v) { return $4da058ffa0b34a43$export$d5652829e27db078 = v; });
$parcel$export($4da058ffa0b34a43$exports, "skeleton", function () { return $4da058ffa0b34a43$export$2a0674ff2eb10214; }, function (v) { return $4da058ffa0b34a43$export$2a0674ff2eb10214 = v; });
$parcel$export($4da058ffa0b34a43$exports, "skeletonCollection", function () { return $4da058ffa0b34a43$export$22468d3b607a3b0f; }, function (v) { return $4da058ffa0b34a43$export$22468d3b607a3b0f = v; });
$parcel$export($4da058ffa0b34a43$exports, "title", function () { return $4da058ffa0b34a43$export$fb184b623420d9be; }, function (v) { return $4da058ffa0b34a43$export$fb184b623420d9be = v; });
var $4da058ffa0b34a43$export$63ab7202a5c80ed;
var $4da058ffa0b34a43$export$38e42c68cf43b5d4;
var $4da058ffa0b34a43$export$b0260c0afbf48c57;
var $4da058ffa0b34a43$export$a8eacba2c33c9f28;
var $4da058ffa0b34a43$export$64c46d98173ac23d;
var $4da058ffa0b34a43$export$d5652829e27db078;
var $4da058ffa0b34a43$export$2a0674ff2eb10214;
var $4da058ffa0b34a43$export$22468d3b607a3b0f;
var $4da058ffa0b34a43$export$fb184b623420d9be;
$4da058ffa0b34a43$export$63ab7202a5c80ed = `_3zLLkG_collectionCard`;
$4da058ffa0b34a43$export$38e42c68cf43b5d4 = `_3zLLkG_header`;
$4da058ffa0b34a43$export$b0260c0afbf48c57 = `_3zLLkG_hoverButton`;
$4da058ffa0b34a43$export$a8eacba2c33c9f28 = `_3zLLkG_hoverButtonsStack`;
$4da058ffa0b34a43$export$64c46d98173ac23d = `_3zLLkG_itemDiv`;
$4da058ffa0b34a43$export$d5652829e27db078 = `_3zLLkG_noCollectionText`;
$4da058ffa0b34a43$export$2a0674ff2eb10214 = `_3zLLkG_skeleton`;
$4da058ffa0b34a43$export$22468d3b607a3b0f = `_3zLLkG_skeletonCollection`;
$4da058ffa0b34a43$export$fb184b623420d9be = `_3zLLkG_title`;






const $680431c45f15f2bf$export$64e1657949ce092c = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const assignAlbumToCollection = (parameters)=>post("albums/assignToCollection", parameters);
    return {
        assignAlbumToCollection: assignAlbumToCollection
    };
};



const $b2279b228dab1ad7$export$d3704a66bd5c2ed5 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const unassignAlbumFromCollection = (parameters)=>deleteRequest("albums/assignToCollection", parameters);
    return {
        unassignAlbumFromCollection: unassignAlbumFromCollection
    };
};















const $ef60c523474c6bc2$export$49aae62b63927b74 = ({ album: album })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [collections, setCollections] = (0, $7fPBF.useState)(album.collections);
    const [selectedCollection, setSelectedCollection] = (0, $7fPBF.useState)();
    const [, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [, setCurrentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const { assignAlbumToCollection: assignAlbumToCollection } = (0, $680431c45f15f2bf$export$64e1657949ce092c)();
    const { unassignAlbumFromCollection: unassignAlbumFromCollection } = (0, $b2279b228dab1ad7$export$d3704a66bd5c2ed5)();
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isUnassignAlertOpen, setIsUnassignAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [shareLinkComponents, fetchShareLink, , ] = (0, $bed6df3ee0929f14$export$cc4cb9d785f3b827)(album.name);
    const { openInNewTab: openInNewTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const showAlbum = async (collectionId)=>{
        setIsLoading(true);
        const { status: status, body: body } = await getShareLink({
            albumId: album.uuid,
            collectionId: collectionId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setCurrentPublicUserProfile(undefined);
            setCurrentPublicCollection(undefined);
            openInNewTab(body.shareLink);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        setIsLoading(album.collections === undefined);
        setCollections(album.collections);
    }, [
        album.collections
    ]);
    const onCollectionSelected = (collection, event)=>{
        if (isLoading) return;
        setSelectedCollection(collection);
        handleContextMenu(event);
    };
    const onAssignToCollection = async (collection)=>{
        setIsLoading(true);
        const albumId = album.uuid;
        const { status: status, body: body } = await assignAlbumToCollection({
            uuid: album.uuid,
            collectionId: collection.uuid
        });
        setIsLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            if (album.uuid == albumId) setCollections(body.collections);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const onUnassignCollection = async ()=>{
        if (!selectedCollection) return;
        setIsLoading(true);
        const albumId = album.uuid;
        const { status: status, body: body } = await unassignAlbumFromCollection({
            uuid: album.uuid,
            collectionId: selectedCollection.uuid
        });
        setIsLoading(false);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            if (albumId == album.uuid) setCollections(body.collections);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).itemDiv,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).header,
                direction: "row",
                spacing: 2,
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                        disableTypography: true,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).title,
                        secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_title,
                        sx: {
                            flexGrow: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_associate,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LibraryAdd,
                        onClick: ()=>setIsCollectionsDialogOpen(true),
                        loading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    minHeight: 136
                },
                children: collections && collections.length > 0 ? collections.map((collection)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: isMobile ? 12 : 6,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3b08aef6576b6da$export$d5597bfe96a524db), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).collectionCard,
                            disabled: isLoading,
                            collection: collection,
                            onClick: (event)=>onCollectionSelected(collection, event),
                            onContextMenu: (event)=>onCollectionSelected(collection, event),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).hoverButtonsStack,
                                direction: "row",
                                spacing: 1,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                                    arrow: true,
                                    disableInteractive: true,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).hoverButton,
                                            style: {
                                                backgroundColor: theme.palette.colors?.counterBackground
                                            },
                                            disabled: isLoading,
                                            onClick: (event)=>{
                                                event.stopPropagation();
                                                setSelectedCollection(collection);
                                                handleContextMenu(event);
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                                            })
                                        })
                                    })
                                })
                            })
                        }, collection.uuid)
                    }, collection.uuid)) : isLoading ? Array.from({
                    length: isMobile ? 1 : 2
                }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                        item: true,
                        xs: isMobile ? 12 : 6,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).skeletonCollection,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                            variant: "rectangular",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).skeleton
                        })
                    }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4da058ffa0b34a43$exports))).noCollectionText,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_no_collections
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    selectedCollection?.visibility == "public" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await showAlbum(selectedCollection?.uuid);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Public
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).album_view_on_exhibition
                        ]
                    }),
                    selectedCollection?.visibility == "public" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await fetchShareLink(selectedCollection?.uuid, album.uuid);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Share
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).share_album
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setSelectedCollection(selectedCollection);
                            setIsUnassignAlertOpen(true);
                        },
                        style: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LayersClear,
                                    style: {
                                        color: theme.palette.colors?.remove
                                    }
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_disassociate
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: false,
                canModifyCollections: false,
                displayStandardCollections: false,
                onCollectionSelected: onAssignToCollection,
                selectedCollections: collections?.map((collection)=>collection.uuid) ?? [],
                forceLoading: false,
                canNegate: false
            }),
            shareLinkComponents(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).collection_disassociate_confirmation, selectedCollection ? selectedCollection.name : ""),
                open: isUnassignAlertOpen,
                setOpen: setIsUnassignAlertOpen,
                isConfirm: true,
                onConfirm: onUnassignCollection
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};










var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");













function $f1998ac7e19a4022$export$5162da8f798e0959(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCollapse', slot);
}
const $f1998ac7e19a4022$var$collapseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $f1998ac7e19a4022$export$2e2bcd8739ae039 = $f1998ac7e19a4022$var$collapseClasses;



'use client';
const $6207032cc256a7e6$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6207032cc256a7e6$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $f1998ac7e19a4022$export$5162da8f798e0959), classes);
};
const $6207032cc256a7e6$var$CollapseRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $6207032cc256a7e6$var$CollapseWrapper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $6207032cc256a7e6$var$CollapseWrapperInner = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6207032cc256a7e6$var$Collapse = /*#__PURE__*/ $7fPBF.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $ec94076b9ecccee1$export$1f34108aa9eb96ab).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $6207032cc256a7e6$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $6207032cc256a7e6$var$useUtilityClasses(ownerState);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const timer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const wrapperRef = $7fPBF.useRef(null);
    const autoTransitionDuration = $7fPBF.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6207032cc256a7e6$var$CollapseRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                as: component,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6207032cc256a7e6$var$CollapseWrapper, {
                    ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6207032cc256a7e6$var$CollapseWrapperInner, {
                        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$6207032cc256a7e6$var$Collapse.muiSupportAuto = true;
var $6207032cc256a7e6$export$2e2bcd8739ae039 = $6207032cc256a7e6$var$Collapse;


var $de51794dfc0f55c6$exports = {};

$parcel$export($de51794dfc0f55c6$exports, "item", function () { return $de51794dfc0f55c6$export$7061c75fc5af8b7e; }, function (v) { return $de51794dfc0f55c6$export$7061c75fc5af8b7e = v; });
$parcel$export($de51794dfc0f55c6$exports, "skeleton", function () { return $de51794dfc0f55c6$export$2a0674ff2eb10214; }, function (v) { return $de51794dfc0f55c6$export$2a0674ff2eb10214 = v; });
$parcel$export($de51794dfc0f55c6$exports, "threeDimensionalPanel", function () { return $de51794dfc0f55c6$export$ec9953ad70f45687; }, function (v) { return $de51794dfc0f55c6$export$ec9953ad70f45687 = v; });
var $de51794dfc0f55c6$export$7061c75fc5af8b7e;
var $de51794dfc0f55c6$export$2a0674ff2eb10214;
var $de51794dfc0f55c6$export$ec9953ad70f45687;
$de51794dfc0f55c6$export$7061c75fc5af8b7e = `_4CNWTW_item`;
$de51794dfc0f55c6$export$2a0674ff2eb10214 = `_4CNWTW_skeleton`;
$de51794dfc0f55c6$export$ec9953ad70f45687 = `_4CNWTW_threeDimensionalPanel`;



var $3fd968034d831385$exports = {};

$parcel$export($3fd968034d831385$exports, "albumImage", function () { return $3fd968034d831385$export$24acac6e69ce1287; }, function (v) { return $3fd968034d831385$export$24acac6e69ce1287 = v; });
$parcel$export($3fd968034d831385$exports, "artistName", function () { return $3fd968034d831385$export$c1eadcaec78a8338; }, function (v) { return $3fd968034d831385$export$c1eadcaec78a8338 = v; });
$parcel$export($3fd968034d831385$exports, "avatar", function () { return $3fd968034d831385$export$345c5736c8054f22; }, function (v) { return $3fd968034d831385$export$345c5736c8054f22 = v; });
$parcel$export($3fd968034d831385$exports, "card", function () { return $3fd968034d831385$export$aa3e815946b80764; }, function (v) { return $3fd968034d831385$export$aa3e815946b80764 = v; });
$parcel$export($3fd968034d831385$exports, "hoverButton", function () { return $3fd968034d831385$export$b0260c0afbf48c57; }, function (v) { return $3fd968034d831385$export$b0260c0afbf48c57 = v; });
$parcel$export($3fd968034d831385$exports, "hoverButtonsStack", function () { return $3fd968034d831385$export$a8eacba2c33c9f28; }, function (v) { return $3fd968034d831385$export$a8eacba2c33c9f28 = v; });
$parcel$export($3fd968034d831385$exports, "image", function () { return $3fd968034d831385$export$5c452ff88e35e47d; }, function (v) { return $3fd968034d831385$export$5c452ff88e35e47d = v; });
$parcel$export($3fd968034d831385$exports, "loadingDescription", function () { return $3fd968034d831385$export$6be35e9daa22c56a; }, function (v) { return $3fd968034d831385$export$6be35e9daa22c56a = v; });
$parcel$export($3fd968034d831385$exports, "mainStack", function () { return $3fd968034d831385$export$a83027cea355fe97; }, function (v) { return $3fd968034d831385$export$a83027cea355fe97 = v; });
$parcel$export($3fd968034d831385$exports, "name", function () { return $3fd968034d831385$export$a8ff84c12d48cfa6; }, function (v) { return $3fd968034d831385$export$a8ff84c12d48cfa6 = v; });
$parcel$export($3fd968034d831385$exports, "nameCard", function () { return $3fd968034d831385$export$f0fb2a4fa878ab69; }, function (v) { return $3fd968034d831385$export$f0fb2a4fa878ab69 = v; });
$parcel$export($3fd968034d831385$exports, "subtitle", function () { return $3fd968034d831385$export$c96745152eb2740f; }, function (v) { return $3fd968034d831385$export$c96745152eb2740f = v; });
$parcel$export($3fd968034d831385$exports, "username", function () { return $3fd968034d831385$export$5e1be761f603d585; }, function (v) { return $3fd968034d831385$export$5e1be761f603d585 = v; });
var $3fd968034d831385$export$24acac6e69ce1287;
var $3fd968034d831385$export$c1eadcaec78a8338;
var $3fd968034d831385$export$345c5736c8054f22;
var $3fd968034d831385$export$aa3e815946b80764;
var $3fd968034d831385$export$b0260c0afbf48c57;
var $3fd968034d831385$export$a8eacba2c33c9f28;
var $3fd968034d831385$export$5c452ff88e35e47d;
var $3fd968034d831385$export$6be35e9daa22c56a;
var $3fd968034d831385$export$a83027cea355fe97;
var $3fd968034d831385$export$a8ff84c12d48cfa6;
var $3fd968034d831385$export$f0fb2a4fa878ab69;
var $3fd968034d831385$export$c96745152eb2740f;
var $3fd968034d831385$export$5e1be761f603d585;
$3fd968034d831385$export$24acac6e69ce1287 = `_2EE5Sa_albumImage`;
$3fd968034d831385$export$c1eadcaec78a8338 = `_2EE5Sa_artistName`;
$3fd968034d831385$export$345c5736c8054f22 = `_2EE5Sa_avatar`;
$3fd968034d831385$export$aa3e815946b80764 = `_2EE5Sa_card`;
$3fd968034d831385$export$b0260c0afbf48c57 = `_2EE5Sa_hoverButton`;
$3fd968034d831385$export$a8eacba2c33c9f28 = `_2EE5Sa_hoverButtonsStack`;
$3fd968034d831385$export$5c452ff88e35e47d = `_2EE5Sa_image`;
$3fd968034d831385$export$6be35e9daa22c56a = `_2EE5Sa_loadingDescription`;
$3fd968034d831385$export$a83027cea355fe97 = `_2EE5Sa_mainStack`;
$3fd968034d831385$export$a8ff84c12d48cfa6 = `_2EE5Sa_name`;
$3fd968034d831385$export$f0fb2a4fa878ab69 = `_2EE5Sa_nameCard`;
$3fd968034d831385$export$c96745152eb2740f = `_2EE5Sa_subtitle`;
$3fd968034d831385$export$5e1be761f603d585 = `_2EE5Sa_username`;



var $7fPBF = parcelRequire("7fPBF");






const $5c850a8c63c23500$export$dae39864ecf8d0fc = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumImage = (parameters)=>post("albumImages", parameters);
    return {
        addAlbumImage: addAlbumImage
    };
};






const $25539dbff41864c1$export$ca7ac475a8cede2f = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyAlbumImage = (parameters)=>put("albumImages", parameters);
    return {
        modifyAlbumImage: modifyAlbumImage
    };
};





const $8cf84f9c5256bd59$export$697d0567e7151b2e = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumImage = (parameters)=>deleteRequest("albumImages", parameters);
    return {
        deleteAlbumImage: deleteAlbumImage
    };
};







const $d9f301eae0e595a9$export$5381c9f9836cd8ab = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const uploadFrontImageFromDiscogs = async (albumUuid)=>{
        const { status: status, body: body } = await post("albums/uploadImageFromDiscogs", {
            uuid: albumUuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.removeImage(`${albumUuid}_${(0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize}_${(0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize}`);
            await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.removeImage(`${albumUuid}_${(0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize}_${(0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize}`);
        }
        return {
            status: status,
            body: body
        };
    };
    return {
        uploadFrontImageFromDiscogs: uploadFrontImageFromDiscogs
    };
};





const $cb6d7da2e544f858$export$d3f454c65563ffe3 = ({ isPublic: isPublic, album: album, albumImage: albumImage, genericImage: genericImage, kind: kind, description: description, index: index, onAlbumImageUploaded: onAlbumImageUploaded, onAlbumImageDeleted: onAlbumImageDeleted, onOpenImageDetail: onOpenImageDetail, canMoveLeft: canMoveLeft, canMoveRight: canMoveRight, onMoveLeft: onMoveLeft, onMoveRight: onMoveRight, isLoadingMove: isLoadingMove, setIsLoading: setIsLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const { addAlbumImage: addAlbumImage } = (0, $5c850a8c63c23500$export$dae39864ecf8d0fc)();
    const { modifyAlbumImage: modifyAlbumImage } = (0, $25539dbff41864c1$export$ca7ac475a8cede2f)();
    const { deleteAlbumImage: deleteAlbumImage } = (0, $8cf84f9c5256bd59$export$697d0567e7151b2e)();
    const { uploadFrontImageFromDiscogs: uploadFrontImageFromDiscogs } = (0, $d9f301eae0e595a9$export$5381c9f9836cd8ab)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const { state: descriptionDialogState, key: descriptionDialogKey, openAdd: openDescriptionDialog, close: closeDescriptionDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [shouldOpenFileDialog, setShouldOpenFileDialog] = (0, $7fPBF.useState)(false);
    const [isLoadingImage, setIsLoadingImage] = (0, $7fPBF.useState)(false);
    const [isLoadingDescription, setIsLoadingDescription] = (0, $7fPBF.useState)(false);
    const [isDeleteConfirmationAlertOpen, setIsDeleteConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    const [isFetchImageConfirmationAlertOpen, setIsFetchImageConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const setLoading = (loading)=>{
        setIsLoadingImage(loading);
        setIsLoading?.(loading);
    };
    const fetchImage = async ()=>{
        if (!albumImage || !albumImage.hasImage) {
            setImage(undefined);
            return;
        }
        setLoading(true);
        const response = await getImage({
            name: albumImage.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
        setLoading(false);
    };
    const createAlbumImage = async (file)=>{
        const { status: status, body: body } = await addAlbumImage({
            albumId: album.uuid,
            kind: kind,
            description: "",
            order: index
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) await uploadAlbumImage(body, file);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const uploadAlbumImage = async (albumImage, file)=>{
        const newThumbnail = await uploadImage({
            name: albumImage.uuid,
            file: file
        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize);
        if (newThumbnail) {
            setImage(undefined);
            albumImage.hasImage = true;
            albumImage.thumbnail = newThumbnail;
            if (onAlbumImageUploaded) onAlbumImageUploaded(albumImage);
            await fetchImage();
        }
    };
    const removeAlbumImage = async ()=>{
        if (!albumImage) return;
        setIsLoadingDescription(true);
        const { status: status, body: body } = await deleteAlbumImage({
            uuid: albumImage.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            if (onAlbumImageDeleted) onAlbumImageDeleted();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingDescription(false);
    };
    const updateDescription = async (newValue)=>{
        if (!albumImage) return;
        setIsLoadingDescription(true);
        const { status: status, body: body } = await modifyAlbumImage({
            uuid: albumImage.uuid,
            description: newValue
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            if (onAlbumImageUploaded) onAlbumImageUploaded(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingDescription(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchImage().then();
    }, [
        albumImage
    ]);
    const openImageDetail = ()=>{
        if (isLoadingImage) return;
        if (!image) {
            if (isPublic) return;
            setShouldOpenFileDialog((state)=>!state);
            return;
        }
        onOpenImageDetail(albumImage.uuid, image, description, `${album.name} ${description}`);
    };
    const willFetchImageFromDiscogs = async ()=>{
        if (album.hasImage) setIsFetchImageConfirmationAlertOpen(true);
        else await fetchImageFromDiscogs();
    };
    const fetchImageFromDiscogs = async ()=>{
        if (isLoadingImage) return;
        setLoading(true);
        const { status: status, body: body } = await uploadFrontImageFromDiscogs(album.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setImage(undefined);
            albumImage.hasImage = true;
            albumImage.thumbnail = body;
            if (onAlbumImageUploaded) onAlbumImageUploaded(albumImage);
            await fetchImage();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setLoading(false);
    };
    const { checkDiscogsAccess: checkDiscogsAccess } = (0, $80d0eef5d5d87b2a$export$f0302bce0203d803)(setAlertMessage, setIsAlertOpen, setLoading, willFetchImageFromDiscogs);
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).card,
        sx: {
            display: "flex",
            backgroundColor: theme.palette.background.default
        },
        onContextMenu: handleContextMenu,
        ...handleLongPress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).image,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).albumImage,
                            disabled: isPublic || isLoadingDescription || isLoadingImage,
                            onImageChanged: async (file)=>{
                                setLoading(true);
                                if (!albumImage) await createAlbumImage(file);
                                else await uploadAlbumImage(albumImage, file);
                                setLoading(false);
                            },
                            placeholderImage: genericImage,
                            isLoading: isLoadingImage,
                            initialImage: image ? `data:image/png;base64,${image}` : albumImage?.thumbnail ? `data:image/png;base64,${albumImage.thumbnail}` : undefined,
                            shouldOpenFileDialog: shouldOpenFileDialog,
                            onClick: openImageDetail
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).nameCard,
                        disabled: isPublic || kind != "additional" || isLoadingDescription || isLoadingImage,
                        onClick: openDescriptionDialog,
                        children: isLoadingDescription ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).loadingDescription
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).name,
                            children: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_name,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_name_message,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_name_placeholder,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                value: description,
                canClear: true,
                open: descriptionDialogState.mode !== "closed",
                onClose: closeDescriptionDialog,
                isNumber: false,
                onChange: updateDescription,
                onClearValue: ()=>updateDescription("")
            }, descriptionDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    image && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openImageDetail();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ImageSearch
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).option_view_image
                        ]
                    }),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setShouldOpenFileDialog((state)=>!state);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).modify_image
                        ]
                    }),
                    !isPublic && kind == "front" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            checkDiscogsAccess().then();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_image_from_discogs
                        ]
                    }),
                    !isPublic && canMoveLeft && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            if (onMoveLeft) onMoveLeft();
                        },
                        disabled: isLoadingMove,
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowLeft
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_left
                        ]
                    }),
                    !isPublic && canMoveRight && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            if (onMoveRight) onMoveRight();
                        },
                        disabled: isLoadingMove,
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowRight
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).move_right
                        ]
                    }),
                    !isPublic && kind == "additional" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    handleMenuClose();
                                    openDescriptionDialog();
                                },
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                        })
                                    }),
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_image_name
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                onClick: async ()=>{
                                    handleMenuClose();
                                    setIsDeleteConfirmationAlertOpen(true);
                                },
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        sx: {
                                            color: theme.palette.colors?.remove
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                        })
                                    }),
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).delete
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButtonsStack,
                spacing: 1,
                children: [
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).modify_image,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButton,
                            style: {
                                backgroundColor: theme.palette.colors?.counterBackground
                            },
                            onClick: ()=>setShouldOpenFileDialog((state)=>!state),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        })
                    }),
                    !isPublic && kind == "front" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_image_from_discogs,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButton,
                            style: {
                                backgroundColor: theme.palette.colors?.counterBackground
                            },
                            onClick: checkDiscogsAccess,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload
                            })
                        })
                    }),
                    !isPublic && canMoveLeft && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).move_left,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButton,
                                style: {
                                    backgroundColor: theme.palette.colors?.counterBackground
                                },
                                onClick: ()=>{
                                    if (onMoveLeft) onMoveLeft();
                                },
                                disabled: isLoadingMove,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowLeft
                                })
                            })
                        })
                    }),
                    !isPublic && canMoveRight && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).move_right,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButton,
                                style: {
                                    backgroundColor: theme.palette.colors?.counterBackground
                                },
                                onClick: ()=>{
                                    if (onMoveRight) onMoveRight();
                                },
                                disabled: isLoadingMove,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowRight
                                })
                            })
                        })
                    }),
                    !isPublic && kind == "additional" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3fd968034d831385$exports))).hoverButton,
                            style: {
                                backgroundColor: theme.palette.colors?.counterBackground
                            },
                            onClick: ()=>setIsDeleteConfirmationAlertOpen(true),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                style: {
                                    color: theme.palette.colors?.remove
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_delete_confirmation,
                open: isDeleteConfirmationAlertOpen,
                setOpen: setIsDeleteConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: removeAlbumImage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_fetch_confirmation,
                open: isFetchImageConfirmationAlertOpen,
                setOpen: setIsFetchImageConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: fetchImageFromDiscogs
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};



const $7334d06cbe1ce63a$export$e8e6e7d723df6524 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getAlbumImages = (parameters)=>get("albumImages", parameters);
    return {
        getAlbumImages: getAlbumImages
    };
};











const $91f360a362d5ae9d$export$86ba8821fff7c20a = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderAlbumImages = (albumImages)=>{
        const sortedUuids = albumImages.map((albumImage)=>albumImage.uuid);
        return post("albumImages/reorder", {
            sortedUuids: sortedUuids
        });
    };
    return {
        reorderAlbumImages: reorderAlbumImages
    };
};



const $b09dbc49024ec7d9$export$1ccb383977f3c96c = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getPublicAlbumImages = (parameters)=>get("albumImages/shared/public", parameters);
    return {
        getPublicAlbumImages: getPublicAlbumImages
    };
};








var $7fPBF = parcelRequire("7fPBF");
var $ec2a0c29acdd9049$exports = {};

$parcel$export($ec2a0c29acdd9049$exports, "backImage", function () { return $ec2a0c29acdd9049$export$4cc4c00ad782f77a; }, function (v) { return $ec2a0c29acdd9049$export$4cc4c00ad782f77a = v; });
$parcel$export($ec2a0c29acdd9049$exports, "blurDiv", function () { return $ec2a0c29acdd9049$export$d0ef6d37ab768eb4; }, function (v) { return $ec2a0c29acdd9049$export$d0ef6d37ab768eb4 = v; });
$parcel$export($ec2a0c29acdd9049$exports, "container", function () { return $ec2a0c29acdd9049$export$34e0f9847d4c02dd; }, function (v) { return $ec2a0c29acdd9049$export$34e0f9847d4c02dd = v; });
$parcel$export($ec2a0c29acdd9049$exports, "face", function () { return $ec2a0c29acdd9049$export$cce012181fa841df; }, function (v) { return $ec2a0c29acdd9049$export$cce012181fa841df = v; });
$parcel$export($ec2a0c29acdd9049$exports, "image", function () { return $ec2a0c29acdd9049$export$5c452ff88e35e47d; }, function (v) { return $ec2a0c29acdd9049$export$5c452ff88e35e47d = v; });
var $ec2a0c29acdd9049$export$4cc4c00ad782f77a;
var $ec2a0c29acdd9049$export$d0ef6d37ab768eb4;
var $ec2a0c29acdd9049$export$34e0f9847d4c02dd;
var $ec2a0c29acdd9049$export$cce012181fa841df;
var $ec2a0c29acdd9049$export$5c452ff88e35e47d;
$ec2a0c29acdd9049$export$4cc4c00ad782f77a = `JE-2Fa_backImage`;
$ec2a0c29acdd9049$export$d0ef6d37ab768eb4 = `JE-2Fa_blurDiv`;
$ec2a0c29acdd9049$export$34e0f9847d4c02dd = `JE-2Fa_container`;
$ec2a0c29acdd9049$export$cce012181fa841df = `JE-2Fa_face`;
$ec2a0c29acdd9049$export$5c452ff88e35e47d = `JE-2Fa_image`;




var $7fPBF = parcelRequire("7fPBF");



const $81117c052a4b735e$export$f82d510d52fac13 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ frontCover: frontCover, backCover: backCover, spine: spine, frontThumbnail: frontThumbnail, backThumbnail: backThumbnail, spineThumbnail: spineThumbnail, defaultCover: defaultCover, defaultBack: defaultBack, defaultSpine: defaultSpine, initialRotation: initialRotation, isLoadingFrontCover: isLoadingFrontCover, size: size, setIsDraggingExternal: setIsDraggingExternal }, ref)=>{
    const [isDragging, setIsDragging] = (0, $7fPBF.useState)(false);
    const drag = (0, $7fPBF.useRef)({
        active: false,
        lastX: 0,
        lastY: 0
    });
    (0, $7fPBF.useImperativeHandle)(ref, ()=>({
            reset: ()=>{
                setRotX(0);
                setRotY(0);
            }
        }));
    (0, $7fPBF.useEffect)(()=>{
        if (setIsDraggingExternal) setIsDraggingExternal(isDragging);
    }, [
        isDragging
    ]);
    const [rotX, setRotX] = (0, $7fPBF.useState)(0);
    const [rotY, setRotY] = (0, $7fPBF.useState)(initialRotation ?? 0);
    const [fillColor, setFillColor] = (0, $7fPBF.useState)("#000");
    const [width, setWidth] = (0, $7fPBF.useState)(size);
    const [height, setHeight] = (0, $7fPBF.useState)(size);
    (0, $7fPBF.useEffect)(()=>{
        const imageData = frontCover ? `data:image/png;base64,${frontCover}` : undefined;
        const thumbnailData = frontThumbnail ? `data:image/png;base64,${frontThumbnail}` : undefined;
        const image = new Image();
        image.src = imageData ?? thumbnailData ?? defaultCover;
        image.onload = function() {
            const reference = Math.max(image.width, image.height);
            const scale = size / reference;
            const finalHeight = image.height * scale;
            setWidth(image.width * scale);
            setHeight(finalHeight);
            setFillColor((0, $74a5752378f7da5e$export$734d4481083c9058).getDominantColor(image));
            calculateDepth(finalHeight);
        };
    }, [
        frontCover,
        spine
    ]);
    const DEPTH_RATIO = 0.03;
    const [depth, setDepth] = (0, $7fPBF.useState)(Math.round(size * DEPTH_RATIO));
    const calculateDepth = (reference)=>{
        const imageData = spine ? `data:image/png;base64,${spine}` : undefined;
        const thumbnailData = spineThumbnail ? `data:image/png;base64,${spineThumbnail}` : undefined;
        const image = new Image();
        image.src = imageData ?? thumbnailData ?? defaultSpine;
        image.onload = function() {
            const scale = reference / Math.max(image.width, image.height);
            setDepth(Math.min(image.width, image.height) * scale);
        };
    };
    // ── pointer handlers ──────────────────────────────────────────────────────
    const onPointerDown = (0, $7fPBF.useCallback)((e)=>{
        e.target.setPointerCapture(e.pointerId);
        drag.current = {
            active: true,
            lastX: e.clientX,
            lastY: e.clientY
        };
        setIsDragging(true);
    }, []);
    const onPointerMove = (0, $7fPBF.useCallback)((e)=>{
        if (!drag.current.active) return;
        const dx = e.clientX - drag.current.lastX;
        const dy = e.clientY - drag.current.lastY;
        drag.current.lastX = e.clientX;
        drag.current.lastY = e.clientY;
        setRotY((prev)=>prev + dx * 0.45);
        setRotX((prev)=>prev - dy * 0.45);
    }, []);
    const onPointerUp = (0, $7fPBF.useCallback)(()=>{
        setIsDragging(false);
        drag.current.active = false;
    }, []);
    // ── touch handlers (mobile) ───────────────────────────────────────────────
    const lastTouch = (0, $7fPBF.useRef)(null);
    const onTouchStart = (0, $7fPBF.useCallback)((e)=>{
        const t = e.touches[0];
        lastTouch.current = {
            x: t.clientX,
            y: t.clientY
        };
    }, []);
    const onTouchMove = (0, $7fPBF.useCallback)((e)=>{
        if (!lastTouch.current) return;
        const t = e.touches[0];
        const dx = t.clientX - lastTouch.current.x;
        const dy = t.clientY - lastTouch.current.y;
        lastTouch.current = {
            x: t.clientX,
            y: t.clientY
        };
        setRotY((prev)=>prev + dx * 0.45);
        setRotX((prev)=>prev - dy * 0.45);
    }, []);
    const halfW = width / 2;
    const halfH = height / 2;
    const halfD = depth / 2;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: isDragging ? "grabbing" : "grab",
            userSelect: "none",
            touchAction: "none"
        },
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerUp: onPointerUp,
        onPointerCancel: onPointerUp,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: ()=>lastTouch.current = null,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                perspective: size * 3.5,
                perspectiveOrigin: "50% 50%"
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    width: width,
                    height: height,
                    position: "relative",
                    transformStyle: "preserve-3d",
                    transform: `rotateX(${rotX}deg) rotateY(${rotY}deg)`,
                    transition: isDragging ? "none" : "transform 0.05s linear"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: width,
                            height: height,
                            top: 0,
                            left: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).image,
                                image: frontCover,
                                thumbnail: frontThumbnail,
                                defaultImage: defaultCover,
                                alt: "Front cover"
                            }),
                            isLoadingFrontCover && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).blurDiv
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: width,
                            height: height,
                            top: 0,
                            left: 0,
                            transform: `translateZ(${-depth}px) rotateY(180deg)`
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).image,
                            imageClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).backImage,
                            image: backCover,
                            thumbnail: backThumbnail,
                            defaultImage: defaultBack,
                            alt: "Back cover"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: depth,
                            height: height,
                            top: 0,
                            left: halfW - halfD,
                            transform: `translateX(${-halfW - halfD}px) rotateY(-90deg)`,
                            transformOrigin: "right center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).image,
                                image: spine,
                                thumbnail: spineThumbnail,
                                defaultImage: defaultSpine,
                                forceVertical: true,
                                alt: "Spine"
                            }),
                            frontCover && !spine && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: fillColor,
                                    opacity: 0.5,
                                    top: 0
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: depth,
                            height: height,
                            top: 0,
                            left: halfW - halfD,
                            background: fillColor,
                            transform: `translateX(${halfW + halfD}px) rotateY(90deg)`,
                            transformOrigin: "left center"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: width,
                            height: depth,
                            top: halfH - halfD,
                            left: 0,
                            background: fillColor,
                            transform: `translateY(${-halfH - halfD}px) rotateX(90deg)`,
                            transformOrigin: "center bottom"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).face,
                        style: {
                            width: width,
                            height: depth,
                            top: halfH - halfD,
                            left: 0,
                            background: fillColor,
                            transform: `translateY(${halfH + halfD}px) rotateX(-90deg)`,
                            transformOrigin: "center top"
                        }
                    })
                ]
            })
        })
    });
});





var $dd445165f8f6eeb4$exports = {};
$dd445165f8f6eeb4$exports = $parcel$resolve("7ogYR");




const $182235c40d2387e4$export$ac8c3b10d6fd5a3a = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ frontCover: frontCover, defaultFrontImage: defaultFrontImage, backCover: backCover, spine: spine, size: size, initialRotation: initialRotation, isLoadingFrontCover: isLoadingFrontCover, setIsLoadingFrontCover: setIsLoadingFrontCover, setIsDragging: setIsDragging }, ref)=>{
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [frontImage, setFrontImage] = (0, $7fPBF.useState)(defaultFrontImage);
    const [backImage, setBackImage] = (0, $7fPBF.useState)();
    const [spineImage, setSpineImage] = (0, $7fPBF.useState)();
    const fetchFrontImageCount = (0, $7fPBF.useRef)(0);
    const fetchBackImageCount = (0, $7fPBF.useRef)(0);
    const fetchSpineImageCount = (0, $7fPBF.useRef)(0);
    const genericBackImage = new URL($dd445165f8f6eeb4$exports).href;
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    const genericSpineImage = new URL($2b6aa9ce287cc06c$exports).href;
    const setImage = (image, type)=>{
        switch(type){
            case "front":
                setFrontImage(image);
                break;
            case "back":
                setBackImage(image);
                break;
            case "spine":
                setSpineImage(image);
                break;
        }
    };
    const incrementFetchImageCount = (type)=>{
        switch(type){
            case "front":
                fetchFrontImageCount.current += 1;
                break;
            case "back":
                fetchBackImageCount.current += 1;
                break;
            case "spine":
                fetchSpineImageCount.current += 1;
                break;
        }
    };
    const getFetchImageCount = (type)=>{
        switch(type){
            case "front":
                return fetchFrontImageCount.current;
            case "back":
                return fetchBackImageCount.current;
            case "spine":
                return fetchSpineImageCount.current;
        }
    };
    const fetchImage = async (albumImage, type)=>{
        incrementFetchImageCount(type);
        if (!albumImage || !albumImage.hasImage) {
            setImage(undefined, type);
            if (type === "front") setIsLoadingFrontCover(false);
            return;
        }
        if (type === "front") setIsLoadingFrontCover(true);
        const fetchCount = getFetchImageCount(type);
        const response = await getImage({
            name: albumImage.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize
        });
        // Discard if albumImage changed
        if (getFetchImageCount(type) !== fetchCount) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body, type);
        if (type === "front") setIsLoadingFrontCover(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchImage(frontCover, "front").then();
    }, [
        frontCover
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchImage(backCover, "back").then();
    }, [
        backCover
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchImage(spine, "spine").then();
    }, [
        spine
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setFrontImage(defaultFrontImage);
    }, [
        defaultFrontImage
    ]);
    const album3DRepresentationRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>({
            reset: ()=>{
                album3DRepresentationRef.current?.reset();
            },
            refreshImages: ()=>{
                fetchImage(frontCover, "front").then();
                fetchImage(backCover, "back").then();
                fetchImage(spine, "spine").then();
            }
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec2a0c29acdd9049$exports))).container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81117c052a4b735e$export$f82d510d52fac13), {
            ref: album3DRepresentationRef,
            frontCover: frontImage,
            backCover: backImage,
            spine: spineImage,
            frontThumbnail: frontCover?.thumbnail,
            backThumbnail: backCover?.thumbnail,
            spineThumbnail: spine?.thumbnail,
            defaultCover: genericSleeveImage,
            defaultBack: genericBackImage,
            defaultSpine: genericSpineImage,
            isLoadingFrontCover: isLoadingFrontCover,
            size: size,
            initialRotation: initialRotation,
            setIsDraggingExternal: setIsDragging
        })
    });
});



var $fw0lo = parcelRequire("fw0lo");



const $beaeb73e6622ec48$export$9357da8826bd187d = ({ album: album, isPublic: isPublic, isOpen: isOpen, setIsOpen: setIsOpen, onAlbumImageUpdated: onAlbumImageUpdated, onAdditionalAlbumImageUpdated: onAdditionalAlbumImageUpdated, onOpenImageDetail: onOpenImageDetail })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { getAlbumImages: getAlbumImages } = (0, $7334d06cbe1ce63a$export$e8e6e7d723df6524)();
    const { getPublicAlbumImages: getPublicAlbumImages } = (0, $b09dbc49024ec7d9$export$1ccb383977f3c96c)();
    const { addAlbumImage: addAlbumImage } = (0, $5c850a8c63c23500$export$dae39864ecf8d0fc)();
    const { reorderAlbumImages: reorderAlbumImages } = (0, $91f360a362d5ae9d$export$86ba8821fff7c20a)();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [frontAlbumImage, setFrontAlbumImage] = (0, $7fPBF.useState)();
    const [albumImages, setAlbumImages] = (0, $7fPBF.useState)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAddLoading, setIsAddLoading] = (0, $7fPBF.useState)(false);
    const [isLoadingFrontImage, setIsLoadingFrontImage] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const bottomReference = (0, $7fPBF.useRef)(null);
    const [isThreeDimensionalPanelExpanded, setIsThreeDimensionalPanelExpanded] = (0, $7fPBF.useState)(false);
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    const genericBackImage = new URL($dd445165f8f6eeb4$exports).href;
    const genericSpineImage = new URL($2b6aa9ce287cc06c$exports).href;
    const scrollToBottom = ()=>{
        bottomReference.current?.scrollIntoView({
            behavior: "smooth"
        });
    };
    const fetchAlbumImages = async ()=>{
        setIsLoading(true);
        setAlbumImages(undefined);
        const { status: status, body: body } = await getAlbumImages({
            albumId: album.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlbumImages(body);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
        setIsLoading(false);
    };
    const fetchPublicAlbumImages = async ()=>{
        if (!currentPublicCollection) return;
        setIsLoading(true);
        setAlbumImages(undefined);
        const { status: status, body: body } = await getPublicAlbumImages({
            albumId: album.uuid,
            collectionId: currentPublicCollection.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlbumImages(body);
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen) return;
        if (isPublic) fetchPublicAlbumImages().then();
        else fetchAlbumImages().then();
    }, [
        isOpen
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setFrontAlbumImage({
            uuid: album.uuid,
            kind: "additional",
            description: "",
            thumbnail: album.thumbnail,
            hasImage: album.hasImage
        });
    }, [
        album.uuid,
        album.hasImage,
        album.thumbnail
    ]);
    const addNewAlbumImage = async ()=>{
        if (!albumImages) return;
        setIsAddLoading(true);
        const { status: status, body: body } = await addAlbumImage({
            albumId: album.uuid,
            kind: "additional",
            description: "",
            order: albumImages.additional.length
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $fw0lo.flushSync)(()=>{
                setAlbumImages((albumImages)=>{
                    if (!albumImages) return;
                    return {
                        ...albumImages,
                        additional: [
                            ...albumImages.additional,
                            body
                        ]
                    };
                });
            });
            scrollToBottom();
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsAddLoading(false);
    };
    const reorderImages = async (newlyOrderedAlbumImages)=>{
        setIsAddLoading(true);
        const { status: status, body: body } = await reorderAlbumImages(newlyOrderedAlbumImages);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setAlbumImages((albumImages)=>{
                if (!albumImages) return;
                return {
                    ...albumImages,
                    additional: newlyOrderedAlbumImages
                };
            });
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsAddLoading(false);
    };
    const album3DRepresentationRef = (0, $7fPBF.useRef)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "lg",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        style: {
                            marginRight: 8
                        },
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_gallery
                    }),
                    !isPublic && albumImages && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_new_image,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle,
                        disabled: isAddLoading || albumImages.additional.length >= 50,
                        loading: isAddLoading,
                        onClick: addNewAlbumImage
                    }),
                    albumImages && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_3d_model,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ThreeDimensionalRotation,
                        highlighted: isThreeDimensionalPanelExpanded,
                        onClick: ()=>setIsThreeDimensionalPanelExpanded(!isThreeDimensionalPanelExpanded)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.imageGallery()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>setIsOpen(false),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                        loading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: [
                    albumImages && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
                        in: isThreeDimensionalPanelExpanded,
                        timeout: "auto",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($de51794dfc0f55c6$exports))).threeDimensionalPanel,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $182235c40d2387e4$export$ac8c3b10d6fd5a3a), {
                                ref: album3DRepresentationRef,
                                frontCover: frontAlbumImage,
                                backCover: albumImages.back[0],
                                spine: albumImages.spine[0],
                                size: 320,
                                initialRotation: 28,
                                isLoadingFrontCover: isLoadingFrontImage,
                                setIsLoadingFrontCover: setIsLoadingFrontImage
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        sx: {
                            padding: 2
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                isLoading ? Array.from({
                                    length: 3
                                }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: isMobile ? 12 : 3,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($de51794dfc0f55c6$exports))).item,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                            variant: "rectangular",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($de51794dfc0f55c6$exports))).skeleton
                                        })
                                    }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: isMobile ? 12 : 3,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6d7da2e544f858$export$d3f454c65563ffe3), {
                                                isPublic: isPublic,
                                                album: album,
                                                albumImage: frontAlbumImage,
                                                genericImage: genericSleeveImage,
                                                kind: "front",
                                                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).front_cover,
                                                index: -1,
                                                onAlbumImageUploaded: (albumImage)=>{
                                                    setFrontAlbumImage(albumImage);
                                                    onAlbumImageUpdated(albumImage);
                                                },
                                                onOpenImageDetail: onOpenImageDetail,
                                                canMoveLeft: false,
                                                canMoveRight: false,
                                                setIsLoading: setIsLoadingFrontImage
                                            })
                                        }, "front"),
                                        (!isPublic || albumImages?.back[0]) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: isMobile ? 12 : 3,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6d7da2e544f858$export$d3f454c65563ffe3), {
                                                isPublic: isPublic,
                                                album: album,
                                                albumImage: albumImages?.back[0],
                                                genericImage: genericBackImage,
                                                kind: "back",
                                                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).back_cover,
                                                index: -1,
                                                onAlbumImageUploaded: (albumImage)=>{
                                                    setAlbumImages((albumImages)=>{
                                                        if (!albumImages) return;
                                                        return {
                                                            ...albumImages,
                                                            back: [
                                                                albumImage
                                                            ]
                                                        };
                                                    });
                                                    album3DRepresentationRef.current?.refreshImages();
                                                    onAdditionalAlbumImageUpdated();
                                                },
                                                onOpenImageDetail: onOpenImageDetail,
                                                canMoveLeft: false,
                                                canMoveRight: false
                                            })
                                        }, "back"),
                                        (!isPublic || albumImages?.spine[0]) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: isMobile ? 12 : 3,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6d7da2e544f858$export$d3f454c65563ffe3), {
                                                isPublic: isPublic,
                                                album: album,
                                                albumImage: albumImages?.spine[0],
                                                genericImage: genericSpineImage,
                                                kind: "spine",
                                                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).spine,
                                                index: -1,
                                                onAlbumImageUploaded: (albumImage)=>{
                                                    setAlbumImages((albumImages)=>{
                                                        if (!albumImages) return;
                                                        return {
                                                            ...albumImages,
                                                            spine: [
                                                                albumImage
                                                            ]
                                                        };
                                                    });
                                                    album3DRepresentationRef.current?.refreshImages();
                                                    onAdditionalAlbumImageUpdated();
                                                },
                                                onOpenImageDetail: onOpenImageDetail,
                                                canMoveLeft: false,
                                                canMoveRight: false
                                            })
                                        }, "spine"),
                                        albumImages && albumImages.additional.length > 0 && albumImages.additional.map((albumImage, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: isMobile ? 12 : 3,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6d7da2e544f858$export$d3f454c65563ffe3), {
                                                    isPublic: isPublic,
                                                    album: album,
                                                    albumImage: albumImage,
                                                    genericImage: genericSleeveImage,
                                                    kind: albumImage.kind,
                                                    description: albumImage.description,
                                                    index: index,
                                                    onAlbumImageUploaded: (albumImage)=>setAlbumImages((albumImages)=>{
                                                            if (!albumImages) return;
                                                            const additionalImages = albumImages.additional.map((image)=>{
                                                                return image.uuid == albumImage.uuid ? albumImage : image;
                                                            });
                                                            return {
                                                                ...albumImages,
                                                                additional: additionalImages
                                                            };
                                                        }),
                                                    onAlbumImageDeleted: ()=>setAlbumImages((albumImages)=>{
                                                            if (!albumImages) return;
                                                            return {
                                                                ...albumImages,
                                                                additional: albumImages.additional.filter((image)=>image.uuid != albumImage.uuid)
                                                            };
                                                        }),
                                                    onOpenImageDetail: onOpenImageDetail,
                                                    canMoveLeft: index > 0,
                                                    canMoveRight: index < albumImages.additional.length - 1,
                                                    onMoveLeft: async ()=>{
                                                        const newlyOrderedAlbumImages = (0, $3c32b049e9065866$export$874a2b636708da2d)(albumImages.additional, index, index - 1);
                                                        await reorderImages(newlyOrderedAlbumImages);
                                                    },
                                                    onMoveRight: async ()=>{
                                                        const newlyOrderedAlbumImages = (0, $3c32b049e9065866$export$874a2b636708da2d)(albumImages.additional, index, index + 1);
                                                        await reorderImages(newlyOrderedAlbumImages);
                                                    },
                                                    isLoadingMove: isAddLoading
                                                })
                                            }, index))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    ref: bottomReference
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};






var $7fPBF = parcelRequire("7fPBF");

var $bac9ba5fe3edcd59$exports = {};

$parcel$export($bac9ba5fe3edcd59$exports, "addButton", function () { return $bac9ba5fe3edcd59$export$76174c80c75f9baa; }, function (v) { return $bac9ba5fe3edcd59$export$76174c80c75f9baa = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "badge", function () { return $bac9ba5fe3edcd59$export$4aebd143f31d0c0d; }, function (v) { return $bac9ba5fe3edcd59$export$4aebd143f31d0c0d = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "collapse", function () { return $bac9ba5fe3edcd59$export$ec45920981e0ca9b; }, function (v) { return $bac9ba5fe3edcd59$export$ec45920981e0ca9b = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "container", function () { return $bac9ba5fe3edcd59$export$34e0f9847d4c02dd; }, function (v) { return $bac9ba5fe3edcd59$export$34e0f9847d4c02dd = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "loadingDiv", function () { return $bac9ba5fe3edcd59$export$dded2af20345efaa; }, function (v) { return $bac9ba5fe3edcd59$export$dded2af20345efaa = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "mainDiv", function () { return $bac9ba5fe3edcd59$export$16666caf1c4e1af1; }, function (v) { return $bac9ba5fe3edcd59$export$16666caf1c4e1af1 = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "notice", function () { return $bac9ba5fe3edcd59$export$b31f6ae88848cf15; }, function (v) { return $bac9ba5fe3edcd59$export$b31f6ae88848cf15 = v; });
$parcel$export($bac9ba5fe3edcd59$exports, "title", function () { return $bac9ba5fe3edcd59$export$fb184b623420d9be; }, function (v) { return $bac9ba5fe3edcd59$export$fb184b623420d9be = v; });
var $bac9ba5fe3edcd59$export$76174c80c75f9baa;
var $bac9ba5fe3edcd59$export$4aebd143f31d0c0d;
var $bac9ba5fe3edcd59$export$ec45920981e0ca9b;
var $bac9ba5fe3edcd59$export$34e0f9847d4c02dd;
var $bac9ba5fe3edcd59$export$dded2af20345efaa;
var $bac9ba5fe3edcd59$export$16666caf1c4e1af1;
var $bac9ba5fe3edcd59$export$b31f6ae88848cf15;
var $bac9ba5fe3edcd59$export$fb184b623420d9be;
$bac9ba5fe3edcd59$export$76174c80c75f9baa = `MuMFsa_addButton`;
$bac9ba5fe3edcd59$export$4aebd143f31d0c0d = `MuMFsa_badge`;
$bac9ba5fe3edcd59$export$ec45920981e0ca9b = `MuMFsa_collapse`;
$bac9ba5fe3edcd59$export$34e0f9847d4c02dd = `MuMFsa_container`;
$bac9ba5fe3edcd59$export$dded2af20345efaa = `MuMFsa_loadingDiv`;
$bac9ba5fe3edcd59$export$16666caf1c4e1af1 = `MuMFsa_mainDiv`;
$bac9ba5fe3edcd59$export$b31f6ae88848cf15 = `MuMFsa_notice`;
$bac9ba5fe3edcd59$export$fb184b623420d9be = `MuMFsa_title`;






var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

var $ca20729c3c4224ab$exports = {};

$parcel$export($ca20729c3c4224ab$exports, "avatar", function () { return $ca20729c3c4224ab$export$345c5736c8054f22; }, function (v) { return $ca20729c3c4224ab$export$345c5736c8054f22 = v; });
$parcel$export($ca20729c3c4224ab$exports, "body", function () { return $ca20729c3c4224ab$export$32180ef41b15b513; }, function (v) { return $ca20729c3c4224ab$export$32180ef41b15b513 = v; });
$parcel$export($ca20729c3c4224ab$exports, "borderBox", function () { return $ca20729c3c4224ab$export$ed32643c9618a26; }, function (v) { return $ca20729c3c4224ab$export$ed32643c9618a26 = v; });
$parcel$export($ca20729c3c4224ab$exports, "button", function () { return $ca20729c3c4224ab$export$2ba01fb71ed41cb6; }, function (v) { return $ca20729c3c4224ab$export$2ba01fb71ed41cb6 = v; });
$parcel$export($ca20729c3c4224ab$exports, "buttonsStack", function () { return $ca20729c3c4224ab$export$5b7d26a797fc296e; }, function (v) { return $ca20729c3c4224ab$export$5b7d26a797fc296e = v; });
$parcel$export($ca20729c3c4224ab$exports, "date", function () { return $ca20729c3c4224ab$export$324d90190a8b822a; }, function (v) { return $ca20729c3c4224ab$export$324d90190a8b822a = v; });
$parcel$export($ca20729c3c4224ab$exports, "divider", function () { return $ca20729c3c4224ab$export$e8c9778bf415dd08; }, function (v) { return $ca20729c3c4224ab$export$e8c9778bf415dd08 = v; });
$parcel$export($ca20729c3c4224ab$exports, "listItem", function () { return $ca20729c3c4224ab$export$76c7e83ecc9cdf05; }, function (v) { return $ca20729c3c4224ab$export$76c7e83ecc9cdf05 = v; });
$parcel$export($ca20729c3c4224ab$exports, "moreButton", function () { return $ca20729c3c4224ab$export$3e7031ca536abc2e; }, function (v) { return $ca20729c3c4224ab$export$3e7031ca536abc2e = v; });
$parcel$export($ca20729c3c4224ab$exports, "moreButtonIcon", function () { return $ca20729c3c4224ab$export$e7e84e367858a20c; }, function (v) { return $ca20729c3c4224ab$export$e7e84e367858a20c = v; });
$parcel$export($ca20729c3c4224ab$exports, "partialBorderBox", function () { return $ca20729c3c4224ab$export$129a05c788b7ba6c; }, function (v) { return $ca20729c3c4224ab$export$129a05c788b7ba6c = v; });
$parcel$export($ca20729c3c4224ab$exports, "repliesList", function () { return $ca20729c3c4224ab$export$8d43c176614b9564; }, function (v) { return $ca20729c3c4224ab$export$8d43c176614b9564 = v; });
$parcel$export($ca20729c3c4224ab$exports, "spaceBox", function () { return $ca20729c3c4224ab$export$c25edd3f8a7cbd36; }, function (v) { return $ca20729c3c4224ab$export$c25edd3f8a7cbd36 = v; });
$parcel$export($ca20729c3c4224ab$exports, "userStack", function () { return $ca20729c3c4224ab$export$2aba8ec176b444af; }, function (v) { return $ca20729c3c4224ab$export$2aba8ec176b444af = v; });
$parcel$export($ca20729c3c4224ab$exports, "username", function () { return $ca20729c3c4224ab$export$5e1be761f603d585; }, function (v) { return $ca20729c3c4224ab$export$5e1be761f603d585 = v; });
var $ca20729c3c4224ab$export$345c5736c8054f22;
var $ca20729c3c4224ab$export$32180ef41b15b513;
var $ca20729c3c4224ab$export$ed32643c9618a26;
var $ca20729c3c4224ab$export$2ba01fb71ed41cb6;
var $ca20729c3c4224ab$export$5b7d26a797fc296e;
var $ca20729c3c4224ab$export$324d90190a8b822a;
var $ca20729c3c4224ab$export$e8c9778bf415dd08;
var $ca20729c3c4224ab$export$76c7e83ecc9cdf05;
var $ca20729c3c4224ab$export$3e7031ca536abc2e;
var $ca20729c3c4224ab$export$e7e84e367858a20c;
var $ca20729c3c4224ab$export$129a05c788b7ba6c;
var $ca20729c3c4224ab$export$8d43c176614b9564;
var $ca20729c3c4224ab$export$c25edd3f8a7cbd36;
var $ca20729c3c4224ab$export$2aba8ec176b444af;
var $ca20729c3c4224ab$export$5e1be761f603d585;
$ca20729c3c4224ab$export$345c5736c8054f22 = `j8901q_avatar`;
$ca20729c3c4224ab$export$32180ef41b15b513 = `j8901q_body`;
$ca20729c3c4224ab$export$ed32643c9618a26 = `j8901q_borderBox`;
$ca20729c3c4224ab$export$2ba01fb71ed41cb6 = `j8901q_button`;
$ca20729c3c4224ab$export$5b7d26a797fc296e = `j8901q_buttonsStack`;
$ca20729c3c4224ab$export$324d90190a8b822a = `j8901q_date`;
$ca20729c3c4224ab$export$e8c9778bf415dd08 = `j8901q_divider`;
$ca20729c3c4224ab$export$76c7e83ecc9cdf05 = `j8901q_listItem`;
$ca20729c3c4224ab$export$3e7031ca536abc2e = `j8901q_moreButton`;
$ca20729c3c4224ab$export$e7e84e367858a20c = `j8901q_moreButtonIcon`;
$ca20729c3c4224ab$export$129a05c788b7ba6c = `j8901q_partialBorderBox`;
$ca20729c3c4224ab$export$8d43c176614b9564 = `j8901q_repliesList`;
$ca20729c3c4224ab$export$c25edd3f8a7cbd36 = `j8901q_spaceBox`;
$ca20729c3c4224ab$export$2aba8ec176b444af = `j8901q_userStack`;
$ca20729c3c4224ab$export$5e1be761f603d585 = `j8901q_username`;







const $1cb6fc199fdf5181$export$2f838cddaa674f1c = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addMessageForAlbum = (parameters)=>post("messages/album", parameters);
    return {
        addMessageForAlbum: addMessageForAlbum
    };
};






var $7fPBF = parcelRequire("7fPBF");

var $576ad18f02bef09b$exports = {};

$parcel$export($576ad18f02bef09b$exports, "avatar", function () { return $576ad18f02bef09b$export$345c5736c8054f22; }, function (v) { return $576ad18f02bef09b$export$345c5736c8054f22 = v; });
$parcel$export($576ad18f02bef09b$exports, "collectionsTitle", function () { return $576ad18f02bef09b$export$db72be92097ccd06; }, function (v) { return $576ad18f02bef09b$export$db72be92097ccd06 = v; });
$parcel$export($576ad18f02bef09b$exports, "publicCollectionsCard", function () { return $576ad18f02bef09b$export$ef035b8e61007418; }, function (v) { return $576ad18f02bef09b$export$ef035b8e61007418 = v; });
$parcel$export($576ad18f02bef09b$exports, "section", function () { return $576ad18f02bef09b$export$fe2e36411d703b3d; }, function (v) { return $576ad18f02bef09b$export$fe2e36411d703b3d = v; });
$parcel$export($576ad18f02bef09b$exports, "title", function () { return $576ad18f02bef09b$export$fb184b623420d9be; }, function (v) { return $576ad18f02bef09b$export$fb184b623420d9be = v; });
var $576ad18f02bef09b$export$345c5736c8054f22;
var $576ad18f02bef09b$export$db72be92097ccd06;
var $576ad18f02bef09b$export$ef035b8e61007418;
var $576ad18f02bef09b$export$fe2e36411d703b3d;
var $576ad18f02bef09b$export$fb184b623420d9be;
$576ad18f02bef09b$export$345c5736c8054f22 = `_36deeq_avatar`;
$576ad18f02bef09b$export$db72be92097ccd06 = `_36deeq_collectionsTitle`;
$576ad18f02bef09b$export$ef035b8e61007418 = `_36deeq_publicCollectionsCard`;
$576ad18f02bef09b$export$fe2e36411d703b3d = `_36deeq_section`;
$576ad18f02bef09b$export$fb184b623420d9be = `_36deeq_title`;












parcelRequire("7fPBF");


var $816cf03fdb3b8fcb$exports = {};

$parcel$export($816cf03fdb3b8fcb$exports, "avatar", function () { return $816cf03fdb3b8fcb$export$345c5736c8054f22; }, function (v) { return $816cf03fdb3b8fcb$export$345c5736c8054f22 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "bottomStack", function () { return $816cf03fdb3b8fcb$export$c5901e776af18f46; }, function (v) { return $816cf03fdb3b8fcb$export$c5901e776af18f46 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "card", function () { return $816cf03fdb3b8fcb$export$aa3e815946b80764; }, function (v) { return $816cf03fdb3b8fcb$export$aa3e815946b80764 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "collectionStats", function () { return $816cf03fdb3b8fcb$export$1e5ecdb191a1c515; }, function (v) { return $816cf03fdb3b8fcb$export$1e5ecdb191a1c515 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "description", function () { return $816cf03fdb3b8fcb$export$6d59db4903f20f7d; }, function (v) { return $816cf03fdb3b8fcb$export$6d59db4903f20f7d = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "discountBox", function () { return $816cf03fdb3b8fcb$export$846ba29c579fca64; }, function (v) { return $816cf03fdb3b8fcb$export$846ba29c579fca64 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "image", function () { return $816cf03fdb3b8fcb$export$5c452ff88e35e47d; }, function (v) { return $816cf03fdb3b8fcb$export$5c452ff88e35e47d = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "name", function () { return $816cf03fdb3b8fcb$export$a8ff84c12d48cfa6; }, function (v) { return $816cf03fdb3b8fcb$export$a8ff84c12d48cfa6 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "nameContainer", function () { return $816cf03fdb3b8fcb$export$3b9d909fcd39d8ae; }, function (v) { return $816cf03fdb3b8fcb$export$3b9d909fcd39d8ae = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "nameStack", function () { return $816cf03fdb3b8fcb$export$540cccdef47139d3; }, function (v) { return $816cf03fdb3b8fcb$export$540cccdef47139d3 = v; });
$parcel$export($816cf03fdb3b8fcb$exports, "username", function () { return $816cf03fdb3b8fcb$export$5e1be761f603d585; }, function (v) { return $816cf03fdb3b8fcb$export$5e1be761f603d585 = v; });
var $816cf03fdb3b8fcb$export$345c5736c8054f22;
var $816cf03fdb3b8fcb$export$c5901e776af18f46;
var $816cf03fdb3b8fcb$export$aa3e815946b80764;
var $816cf03fdb3b8fcb$export$1e5ecdb191a1c515;
var $816cf03fdb3b8fcb$export$6d59db4903f20f7d;
var $816cf03fdb3b8fcb$export$846ba29c579fca64;
var $816cf03fdb3b8fcb$export$5c452ff88e35e47d;
var $816cf03fdb3b8fcb$export$a8ff84c12d48cfa6;
var $816cf03fdb3b8fcb$export$3b9d909fcd39d8ae;
var $816cf03fdb3b8fcb$export$540cccdef47139d3;
var $816cf03fdb3b8fcb$export$5e1be761f603d585;
$816cf03fdb3b8fcb$export$345c5736c8054f22 = `XW_Hna_avatar`;
$816cf03fdb3b8fcb$export$c5901e776af18f46 = `XW_Hna_bottomStack`;
$816cf03fdb3b8fcb$export$aa3e815946b80764 = `XW_Hna_card`;
$816cf03fdb3b8fcb$export$1e5ecdb191a1c515 = `XW_Hna_collectionStats`;
$816cf03fdb3b8fcb$export$6d59db4903f20f7d = `XW_Hna_description`;
$816cf03fdb3b8fcb$export$846ba29c579fca64 = `XW_Hna_discountBox`;
$816cf03fdb3b8fcb$export$5c452ff88e35e47d = `XW_Hna_image`;
$816cf03fdb3b8fcb$export$a8ff84c12d48cfa6 = `XW_Hna_name`;
$816cf03fdb3b8fcb$export$3b9d909fcd39d8ae = `XW_Hna_nameContainer`;
$816cf03fdb3b8fcb$export$540cccdef47139d3 = `XW_Hna_nameStack`;
$816cf03fdb3b8fcb$export$5e1be761f603d585 = `XW_Hna_username`;



var $7fPBF = parcelRequire("7fPBF");









const $758523eb9a5d6b8e$export$257e12488b20e43c = ({ publicCollection: publicCollection, onClick: onClick, showUser: showUser })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($a535e2e83d1fcdca$exports).href;
    const fetchImage = async ()=>{
        if (!publicCollection.collection.hasImage) return;
        const response = await getImage({
            name: publicCollection.collection.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageWidth,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallCollectionImageHeight
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        publicCollection
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).card,
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                justifyContent: "flex-start"
            },
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).image,
                    image: image,
                    thumbnail: publicCollection.collection.thumbnail,
                    defaultImage: genericImage,
                    beforeLoad: fetchImage,
                    alt: publicCollection.collection.name
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).nameContainer
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).nameStack,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).name,
                            children: publicCollection.collection.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        publicCollection.collection.discount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed350f6794f06f61$export$3229296aace3d746), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).discountBox,
                            percentage: publicCollection.collection.discount
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).description,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: publicCollection.collection.description
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    flexGrow: 1
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).bottomStack,
                    children: [
                        showUser && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignSelf: "end",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).avatar,
                                    userProfile: publicCollection.userProfile
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).username,
                                    children: publicCollection.userProfile.username
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0ac51b8e7d1288b$export$6e86a3ec2d30d952), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($816cf03fdb3b8fcb$exports))).collectionStats,
                            collection: publicCollection.collection
                        })
                    ]
                })
            ]
        })
    });
};


var $261a01c6fa059cdc$exports = {};

$parcel$export($261a01c6fa059cdc$exports, "item", function () { return $261a01c6fa059cdc$export$7061c75fc5af8b7e; }, function (v) { return $261a01c6fa059cdc$export$7061c75fc5af8b7e = v; });
$parcel$export($261a01c6fa059cdc$exports, "noItemsText", function () { return $261a01c6fa059cdc$export$aa72794302c95b91; }, function (v) { return $261a01c6fa059cdc$export$aa72794302c95b91 = v; });
$parcel$export($261a01c6fa059cdc$exports, "skeleton", function () { return $261a01c6fa059cdc$export$2a0674ff2eb10214; }, function (v) { return $261a01c6fa059cdc$export$2a0674ff2eb10214 = v; });
var $261a01c6fa059cdc$export$7061c75fc5af8b7e;
var $261a01c6fa059cdc$export$aa72794302c95b91;
var $261a01c6fa059cdc$export$2a0674ff2eb10214;
$261a01c6fa059cdc$export$7061c75fc5af8b7e = `VDrt7W_item`;
$261a01c6fa059cdc$export$aa72794302c95b91 = `VDrt7W_noItemsText`;
$261a01c6fa059cdc$export$2a0674ff2eb10214 = `VDrt7W_skeleton`;



const $06f7abb9506f3e42$export$e0a080237481d5b1 = ({ isLoading: isLoading, publicCollections: publicCollections, onCollectionSelected: onCollectionSelected, columnWidth: columnWidth, skeletonCount: skeletonCount, showUser: showUser })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: publicCollections && publicCollections.length > 0 ? publicCollections?.map((publicCollection, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: columnWidth,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $758523eb9a5d6b8e$export$257e12488b20e43c), {
                    publicCollection: publicCollection,
                    onClick: ()=>onCollectionSelected(publicCollection),
                    showUser: showUser
                })
            }, index)) : isLoading ? Array.from({
            length: skeletonCount
        }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: columnWidth,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($261a01c6fa059cdc$exports))).item,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($261a01c6fa059cdc$exports))).skeleton
                })
            }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($261a01c6fa059cdc$exports))).noItemsText,
            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).no_public_collections
        })
    });
};





const $facfcdb3f749c904$export$8bdde12dda791bc2 = (userId, setLoading, isEnabled)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getPublicCollections = (parameters)=>get("collections/public", {
            userId: userId,
            ...parameters
        });
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)(20, getPublicCollections, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).publicCollectionStorage, true, isEnabled, userId);
};












const $00fb49d9eec338cb$export$9bba71c7759c348b = ({ userProfile: userProfile, isOpen: isOpen, setIsOpen: setIsOpen, onPublicCollectionChanged: onPublicCollectionChanged, showCollectionInfo: showCollectionInfo })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const [, setCurrentUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const [currentPublicCollection, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [publicCollections, resetPublicCollections] = (0, $facfcdb3f749c904$export$8bdde12dda791bc2)(userProfile.userId, setIsLoading, isMounted.current);
    const placeholderAvatar = new URL($f3dc95464e643b42$exports).href;
    const fetchImage = async ()=>{
        setImage(undefined);
        if (!userProfile.hasImage) return;
        const response = await getImage({
            name: userProfile.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAvatarImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAvatarImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen) return;
        fetchImage().then();
    }, [
        isOpen
    ]);
    (0, $7fPBF.useEffect)(()=>{
        resetPublicCollections();
    }, [
        userProfile
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "md",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $772e96a1af9615ac$export$2e2bcd8739ae039), {
                        sx: {
                            width: isMobile ? 36 : 50,
                            height: isMobile ? 36 : 50,
                            marginRight: 2,
                            borderWidth: 2,
                            borderColor: theme.palette.primary.main,
                            borderStyle: "solid"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).avatar,
                            defaultImage: placeholderAvatar,
                            thumbnail: userProfile.thumbnail,
                            image: image,
                            alt: "Avatar"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).title,
                        children: userProfile.username
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>setIsOpen(false),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                        loading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                style: {
                    paddingLeft: 0,
                    paddingRight: 0
                },
                dividers: true,
                children: [
                    showCollectionInfo && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).section,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Article,
                            title: currentPublicCollection?.name,
                            detail: currentPublicCollection?.description ?? "--"
                        }, "description")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).section,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Today,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).user_since_title,
                                detail: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(userProfile.createdUnixTimestamp * 1000, "d MMMM yyyy", {
                                    locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                })
                            }, "user_since"),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).HistoryEdu,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).bio_title,
                                detail: userProfile.bio ?? "--"
                            }, "bio")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).section,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Paid,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).currency_title,
                            detail: userProfile.currency.code ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                        }, "currency")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).collectionsTitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($576ad18f02bef09b$exports))).publicCollectionsCard,
                        sx: {
                            marginBottom: 4
                        },
                        elevation: 15,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06f7abb9506f3e42$export$e0a080237481d5b1), {
                            isLoading: isLoading,
                            publicCollections: publicCollections.map((publicCollection)=>({
                                    collection: publicCollection.collection,
                                    userProfile: publicCollection.userProfile
                                })),
                            showUser: false,
                            columnWidth: isMobile ? 12 : 6,
                            skeletonCount: 2,
                            onCollectionSelected: async (publicCollection)=>{
                                setIsLoading(true);
                                const { status: status, body: body } = await getShareLink({
                                    collectionId: publicCollection.collection.uuid
                                });
                                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                                    setCurrentUserProfile(publicCollection.userProfile);
                                    setCurrentPublicCollection(publicCollection.collection);
                                    navigate(body.relativeShareLink);
                                    if (onPublicCollectionChanged) onPublicCollectionChanged();
                                }
                                setIsLoading(false);
                            }
                        })
                    })
                ]
            })
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");
function $8a40331a8abc3df6$export$2e2bcd8739ae039(date) {
    const parsed = new Date(date);
    if (!Number.isNaN(parsed.valueOf())) return parsed;
    const parts = String(date).match(/\d+/g);
    if (parts == null || parts.length <= 2) return parsed;
    else {
        const [firstP, secondP, ...restPs] = parts.map((x)=>parseInt(x));
        const correctedParts = [
            firstP,
            secondP - 1,
            ...restPs
        ];
        const isoDate = new Date(Date.UTC(...correctedParts));
        return isoDate;
    }
}


function $a25fdcba68d2c49c$export$2e2bcd8739ae039(value, _unit, suffix) {
    const unit = value !== 1 ? _unit + 's' : _unit;
    return value + ' ' + unit + ' ' + suffix;
}


function $d5eb2ef73d71ee8c$var$_extends() {
    $d5eb2ef73d71ee8c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5eb2ef73d71ee8c$var$_extends.apply(this, arguments);
}
// Just some simple constants for readability
const $d5eb2ef73d71ee8c$var$MINUTE = 60;
const $d5eb2ef73d71ee8c$var$HOUR = $d5eb2ef73d71ee8c$var$MINUTE * 60;
const $d5eb2ef73d71ee8c$var$DAY = $d5eb2ef73d71ee8c$var$HOUR * 24;
const $d5eb2ef73d71ee8c$var$WEEK = $d5eb2ef73d71ee8c$var$DAY * 7;
const $d5eb2ef73d71ee8c$var$MONTH = $d5eb2ef73d71ee8c$var$DAY * 30;
const $d5eb2ef73d71ee8c$var$YEAR = $d5eb2ef73d71ee8c$var$DAY * 365;
const $d5eb2ef73d71ee8c$var$defaultNow = ()=>Date.now();
function $d5eb2ef73d71ee8c$export$2e2bcd8739ae039({ date: date, formatter: formatter = (0, $a25fdcba68d2c49c$export$2e2bcd8739ae039), component: component = 'time', live: live = true, minPeriod: minPeriod = 0, maxPeriod: maxPeriod = $d5eb2ef73d71ee8c$var$WEEK, title: title, now: now = $d5eb2ef73d71ee8c$var$defaultNow, ...passDownProps }) {
    const [timeNow, setTimeNow] = (0, $7fPBF.useState)(now());
    (0, $7fPBF.useEffect)(()=>{
        if (!live) return;
        const tick = ()=>{
            const then = (0, $8a40331a8abc3df6$export$2e2bcd8739ae039)(date).valueOf();
            if (!then) {
                console.warn('[react-timeago] Invalid Date provided');
                return 0;
            }
            const seconds = Math.round(Math.abs(timeNow - then) / 1000);
            const unboundPeriod = seconds < $d5eb2ef73d71ee8c$var$MINUTE ? 1000 : seconds < $d5eb2ef73d71ee8c$var$HOUR ? 1000 * $d5eb2ef73d71ee8c$var$MINUTE : seconds < $d5eb2ef73d71ee8c$var$DAY ? 1000 * $d5eb2ef73d71ee8c$var$HOUR : 1000 * $d5eb2ef73d71ee8c$var$WEEK;
            const period = Math.min(Math.max(unboundPeriod, minPeriod * 1000), maxPeriod * 1000);
            if (period) return setTimeout(()=>{
                setTimeNow(now());
            }, period);
            return 0;
        };
        const timeoutId = tick();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        date,
        live,
        maxPeriod,
        minPeriod,
        now,
        timeNow
    ]);
    const Komponent = component;
    const then = (0, $8a40331a8abc3df6$export$2e2bcd8739ae039)(date).valueOf();
    if (!then) return null;
    const seconds = Math.round(Math.abs(timeNow - then) / 1000);
    const suffix = then < timeNow ? 'ago' : 'from now';
    const [value, unit] = seconds < $d5eb2ef73d71ee8c$var$MINUTE ? [
        Math.round(seconds),
        'second'
    ] : seconds < $d5eb2ef73d71ee8c$var$HOUR ? [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$MINUTE),
        'minute'
    ] : seconds < $d5eb2ef73d71ee8c$var$DAY ? [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$HOUR),
        'hour'
    ] : seconds < $d5eb2ef73d71ee8c$var$WEEK ? [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$DAY),
        'day'
    ] : seconds < $d5eb2ef73d71ee8c$var$MONTH ? [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$WEEK),
        'week'
    ] : seconds < $d5eb2ef73d71ee8c$var$YEAR ? [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$MONTH),
        'month'
    ] : [
        Math.round(seconds / $d5eb2ef73d71ee8c$var$YEAR),
        'year'
    ];
    const passDownTitle = typeof title === 'undefined' ? typeof date === 'string' ? date : (0, $8a40331a8abc3df6$export$2e2bcd8739ae039)(date).toISOString().substr(0, 16).replace('T', ' ') : title;
    const spreadProps = Komponent === 'time' ? {
        ...passDownProps,
        dateTime: (0, $8a40331a8abc3df6$export$2e2bcd8739ae039)(date).toISOString()
    } : passDownProps;
    const nextFormatter = (0, $a25fdcba68d2c49c$export$2e2bcd8739ae039).bind(null, value, unit, suffix);
    return /*#__PURE__*/ $7fPBF.createElement(Komponent, $d5eb2ef73d71ee8c$var$_extends({}, spreadProps, {
        title: passDownTitle
    }), formatter(value, unit, suffix, then, nextFormatter, now));
}


var $92434b9608c24837$exports = {};
"use strict";
Object.defineProperty($92434b9608c24837$exports, "__esModule", {
    value: true
});
$92434b9608c24837$exports["default"] = void 0;
// English (Template)
var $92434b9608c24837$var$strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'ago',
    suffixFromNow: 'from now',
    seconds: 'less than a minute',
    minute: 'about a minute',
    minutes: '%d minutes',
    hour: 'about an hour',
    hours: 'about %d hours',
    day: 'a day',
    days: '%d days',
    month: 'about a month',
    months: '%d months',
    year: 'about a year',
    years: '%d years',
    wordSeparator: ' '
};
var $92434b9608c24837$var$_default = $92434b9608c24837$var$strings;
$92434b9608c24837$exports["default"] = $92434b9608c24837$var$_default;


var $d6591d851138e77b$exports = {};
"use strict";
Object.defineProperty($d6591d851138e77b$exports, "__esModule", {
    value: true
});
$d6591d851138e77b$exports["default"] = void 0;
// Spanish
var $d6591d851138e77b$var$strings = {
    prefixAgo: 'hace',
    prefixFromNow: 'dentro de',
    suffixAgo: '',
    suffixFromNow: '',
    seconds: 'menos de un minuto',
    minute: 'un minuto',
    minutes: 'unos %d minutos',
    hour: 'una hora',
    hours: '%d horas',
    day: "un d\xeda",
    days: "%d d\xedas",
    month: 'un mes',
    months: '%d meses',
    year: "un a\xf1o",
    years: "%d a\xf1os"
};
var $d6591d851138e77b$var$_default = $d6591d851138e77b$var$strings;
$d6591d851138e77b$exports["default"] = $d6591d851138e77b$var$_default;


var $770b3f396724c1cb$exports = {};
"use strict";
function $770b3f396724c1cb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $770b3f396724c1cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $770b3f396724c1cb$var$_typeof(o);
}
Object.defineProperty($770b3f396724c1cb$exports, "__esModule", {
    value: true
});
$770b3f396724c1cb$exports["default"] = $770b3f396724c1cb$var$buildFormatter;

var $770b3f396724c1cb$var$React = $770b3f396724c1cb$var$_interopRequireWildcard((parcelRequire("7fPBF")));
function $770b3f396724c1cb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($770b3f396724c1cb$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $770b3f396724c1cb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $770b3f396724c1cb$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $770b3f396724c1cb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// If the numbers array is present, format numbers with it,
// otherwise just cast the number to a string and return it
var $770b3f396724c1cb$var$normalizeNumber = function normalizeNumber(numbers, value) {
    return numbers && numbers.length === 10 ? String(value).split('').map(function(digit) {
        return digit.match(/^[0-9]$/) ? numbers[parseInt(digit)] : digit;
    }).join('') : String(value);
};
// Take a string or a function that takes number of days and returns a string
// and provide a uniform API to create string parts
var $770b3f396724c1cb$var$normalizeFn = function normalizeFn(value, distanceMillis, numbers) {
    return function(stringOrFn) {
        return typeof stringOrFn === 'function' ? stringOrFn(value, distanceMillis).replace(/%d/g, $770b3f396724c1cb$var$normalizeNumber(numbers, value)) : stringOrFn.replace(/%d/g, $770b3f396724c1cb$var$normalizeNumber(numbers, value));
    };
};
function $770b3f396724c1cb$var$buildFormatter(strings) {
    return function formatter(_value, _unit, suffix, epochMilliseconds, _nextFormmater, now) {
        var current = now();
        var value = _value;
        var unit = _unit;
        // convert weeks to days if strings don't handle weeks
        if (unit === 'week' && !strings.week && !strings.weeks) {
            var days = Math.round(Math.abs(epochMilliseconds - current) / 86400000);
            value = days;
            unit = 'day';
        }
        // create a normalize function for given value
        var normalize = $770b3f396724c1cb$var$normalizeFn(value, current - epochMilliseconds, strings.numbers != null ? strings.numbers : undefined);
        // The eventual return value stored in an array so that the wordSeparator can be used
        var dateString = [];
        // handle prefixes
        if (suffix === 'ago' && strings.prefixAgo) dateString.push(normalize(strings.prefixAgo));
        if (suffix === 'from now' && strings.prefixFromNow) dateString.push(normalize(strings.prefixFromNow));
        // Handle Main number and unit
        var isPlural = value > 1;
        if (isPlural) {
            var stringFn = strings[unit + 's'] || strings[unit] || '%d ' + unit;
            dateString.push(normalize(stringFn));
        } else {
            var _stringFn = strings[unit] || strings[unit + 's'] || '%d ' + unit;
            dateString.push(normalize(_stringFn));
        }
        // Handle Suffixes
        if (suffix === 'ago' && strings.suffixAgo) dateString.push(normalize(strings.suffixAgo));
        if (suffix === 'from now' && strings.suffixFromNow) dateString.push(normalize(strings.suffixFromNow));
        // join the array into a string and return it
        var wordSeparator = typeof strings.wordSeparator === 'string' ? strings.wordSeparator : ' ';
        return dateString.join(wordSeparator);
    };
}





const $2e6fb9e4245c1330$export$9aa2f08eb6218bc6 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteMessage = (parameters)=>deleteRequest("messages", parameters);
    return {
        deleteMessage: deleteMessage
    };
};



const $cd3251c28d855153$export$eea99638b7923798 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addReportForMessage = (parameters)=>post("reports/message", parameters);
    return {
        addReportForMessage: addReportForMessage
    };
};




const $9873335f494656cc$export$5d387b3cd0a254bc = ({ isPublic: isPublic, album: album, message: message, isLoading: isLoading, setIsLoading: setIsLoading, onMessageRemoved: onMessageRemoved })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const userProfile = message.authorUserProfile;
    const createdDate = new Date(message.createdUnixTimestamp * 1000);
    const formatter = (0, (/*@__PURE__*/$parcel$interopDefault($770b3f396724c1cb$exports)))((0, $37bec70ed65ed924$export$21c51bc433c16634).locale == "en-US" ? (0, (/*@__PURE__*/$parcel$interopDefault($92434b9608c24837$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d6591d851138e77b$exports))));
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [isRepliesExpanded, setIsRepliesExpanded] = (0, $7fPBF.useState)(false);
    const [isUserProfileDialogOpen, setIsUserProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const { addMessageForAlbum: addMessageForAlbum } = (0, $1cb6fc199fdf5181$export$2f838cddaa674f1c)();
    const { deleteMessage: deleteMessage } = (0, $2e6fb9e4245c1330$export$9aa2f08eb6218bc6)();
    const { addReportForMessage: addReportForMessage } = (0, $cd3251c28d855153$export$eea99638b7923798)();
    const [isReportMessageAlertOpen, setIsReportMessageAlertOpen] = (0, $7fPBF.useState)(false);
    const [isRemoveMessageAlertOpen, setIsRemoveMessageAlertOpen] = (0, $7fPBF.useState)(false);
    const [isNewMessageDialogOpen, setIsNewMessageDialogOpen] = (0, $7fPBF.useState)(false);
    const [newMessage, setNewMessage] = (0, $7fPBF.useState)();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [numberOfReplies, setNumberOfReplies] = (0, $7fPBF.useState)(message.numberOfReplies);
    const { handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose, menuProps: menuProps } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const onNewMessage = async (messageBody)=>{
        setIsLoading(true);
        const { status: status, body: body } = await addMessageForAlbum({
            albumId: album.uuid,
            collectionId: isPublic ? currentPublicCollection?.uuid : undefined,
            body: messageBody,
            replyToMessageId: message.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setNewMessage(body);
            message.numberOfReplies = numberOfReplies + 1;
            setNumberOfReplies((numberOfReplies)=>numberOfReplies + 1);
            setIsRepliesExpanded(true);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const onReportMessage = async (reportBody)=>{
        setIsLoading(true);
        const { status: status, body: body } = await addReportForMessage({
            messageId: message.uuid,
            body: reportBody
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).report_success);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const onRemoveMessage = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteMessage({
            uuid: message.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) onMessageRemoved();
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).listItem,
        children: [
            message.replyToMessageId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).partialBorderBox,
                style: {
                    borderColor: theme.palette.colors?.disabled
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).borderBox,
                style: {
                    borderColor: theme.palette.colors?.disabled
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).userStack,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).avatar,
                                style: {
                                    borderColor: theme.palette.colors?.disabled
                                },
                                userProfile: userProfile,
                                onClick: ()=>setIsUserProfileDialogOpen(true)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).username,
                                onClick: ()=>setIsUserProfileDialogOpen(true),
                                children: userProfile.username
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).date,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: " \u2022"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5eb2ef73d71ee8c$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).date,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                date: createdDate,
                                formatter: formatter
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).body,
                        style: {
                            fontStyle: message.isRemoved ? "italic" : "normal",
                            color: message.isRemoved ? theme.palette.secondary.main : theme.palette.primary.main
                        },
                        children: message.body
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).buttonsStack,
                        direction: "row",
                        spacing: isMobile ? 1 : 2,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).spaceBox
                            }),
                            numberOfReplies > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                disabled: isLoading,
                                startIcon: isRepliesExpanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowUp
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                                }),
                                size: "small",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).button,
                                onClick: ()=>setIsRepliesExpanded((state)=>!state),
                                children: numberOfReplies > 1 ? (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).messages_replies_more, String(numberOfReplies)) : (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_reply_more
                            }),
                            !message.isRemoved && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                disabled: isLoading,
                                startIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Reply
                                }),
                                size: "small",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).button,
                                onClick: ()=>setIsNewMessageDialogOpen(true),
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_reply
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            !message.isRemoved && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                disabled: isLoading,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).moreButton,
                                style: {
                                    backgroundColor: theme.palette.colors?.buttonBackground
                                },
                                onClick: handleContextMenu,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).moreButtonIcon,
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
                        in: isRepliesExpanded,
                        timeout: "auto",
                        children: isRepliesExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eea340c090eae092$export$3c16eecaa826a9be), {
                            isPublic: isPublic,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ca20729c3c4224ab$exports))).repliesList,
                            album: album,
                            parentMessage: message,
                            isLoading: isLoading,
                            setIsLoading: setIsLoading,
                            newMessage: newMessage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsReportMessageAlertOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Campaign
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_report
                        ]
                    }),
                    (currentUser?.role == "admin" || album.userId == currentUser?.uuid || message.authorUserProfile.userId == currentUser?.uuid) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsRemoveMessageAlertOpen(true);
                        },
                        style: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    style: {
                                        color: theme.palette.colors?.remove
                                    },
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).delete
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00fb49d9eec338cb$export$9bba71c7759c348b), {
                userProfile: message.authorUserProfile,
                isOpen: isUserProfileDialogOpen,
                setIsOpen: setIsUserProfileDialogOpen,
                showCollectionInfo: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_new_title,
                description: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).messages_replying_to, message.authorUserProfile.username),
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_new_title,
                open: isNewMessageDialogOpen,
                onClose: ()=>setIsNewMessageDialogOpen(false),
                onChange: onNewMessage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).report_new,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).report_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).report_new,
                open: isReportMessageAlertOpen,
                onClose: ()=>setIsReportMessageAlertOpen(false),
                onChange: onReportMessage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).messages_confirm_removal, message.authorUserProfile.username, message.body),
                open: isRemoveMessageAlertOpen,
                setOpen: setIsRemoveMessageAlertOpen,
                onConfirm: onRemoveMessage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");



var $gSkQi = parcelRequire("gSkQi");
const $b402e72ad74a3161$export$6f5d27dbb73ca5a2 = (pageSize, parameters, backendRequest, setLoading, isEnabled, invertedOrder, dependencies = [])=>{
    const [items, setItems] = (0, $7fPBF.useState)([]);
    const [lastUuid, setLastUuid] = (0, $7fPBF.useState)();
    const [noMoreItems, setNoMoreItems] = (0, $7fPBF.useState)(false);
    const [isFetching, setIsFetching] = (0, $7fPBF.useState)(false);
    const fetchItems = ()=>{
        let ignoreResponse = false;
        setLoading(true);
        setIsFetching(true);
        const oldParameters = parameters;
        backendRequest({
            pageSize: pageSize,
            lastUuid: lastUuid,
            ...parameters
        }).then(({ body: body, status: status })=>{
            if (ignoreResponse || !(0, $gSkQi.isEqual)(oldParameters, parameters)) return;
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setNoMoreItems(body.length < pageSize);
                if (body.length >= 0) {
                    setItems((oldArray)=>invertedOrder ? [
                            ...body,
                            ...oldArray
                        ] : [
                            ...oldArray,
                            ...body
                        ]);
                    if (body.length > 0) setLastUuid(invertedOrder ? body[0].uuid : body.slice(-1)[0].uuid);
                }
            } else if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSessionExpired(status)) {
                setNoMoreItems(true);
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
            }
            setLoading(false);
            setIsFetching(false);
        });
        return ()=>{
            ignoreResponse = true;
        };
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isFetching || noMoreItems || !isEnabled) return;
        fetchItems();
    }, dependencies);
    const resetItems = ()=>{
        setItems([]);
        setNoMoreItems(false);
        setLastUuid(undefined);
    };
    return [
        items,
        setItems,
        resetItems,
        noMoreItems
    ];
};


const $108de773e117e19f$export$b3e7990f6f407138 = (albumId, replyToMessageId, setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getMessages = (parameters)=>get("messages/album", parameters);
    return (0, $b402e72ad74a3161$export$6f5d27dbb73ca5a2)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).messages(), {
        albumId: albumId,
        replyToMessageId: replyToMessageId
    }, getMessages, setLoading, true, false, dependencies);
};



var $9c2bffaa070cafe9$exports = {};

$parcel$export($9c2bffaa070cafe9$exports, "button", function () { return $9c2bffaa070cafe9$export$2ba01fb71ed41cb6; }, function (v) { return $9c2bffaa070cafe9$export$2ba01fb71ed41cb6 = v; });
$parcel$export($9c2bffaa070cafe9$exports, "noMessagesText", function () { return $9c2bffaa070cafe9$export$28f9a89eb279b6b4; }, function (v) { return $9c2bffaa070cafe9$export$28f9a89eb279b6b4 = v; });
var $9c2bffaa070cafe9$export$2ba01fb71ed41cb6;
var $9c2bffaa070cafe9$export$28f9a89eb279b6b4;
$9c2bffaa070cafe9$export$2ba01fb71ed41cb6 = `rw4cLW_button`;
$9c2bffaa070cafe9$export$28f9a89eb279b6b4 = `rw4cLW_noMessagesText`;



const $eea340c090eae092$export$3c16eecaa826a9be = ({ isPublic: isPublic, className: className, style: style, album: album, parentMessage: parentMessage, isLoading: isLoading, setIsLoading: setIsLoading, newMessage: newMessage })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [fetchMoreMessages, setFetchMoreMessages] = (0, $7fPBF.useState)(false);
    const [messages, setMessages, resetMessages, noMoreMessages] = (0, $108de773e117e19f$export$b3e7990f6f407138)(album.uuid, parentMessage?.uuid, setIsLoading, [
        fetchMoreMessages
    ]);
    (0, $7fPBF.useEffect)(()=>{
        resetMessages();
        setFetchMoreMessages((state)=>!state);
    }, [
        album.uuid,
        parentMessage?.uuid
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (newMessage) setMessages((messages)=>[
                newMessage,
                ...messages
            ]);
    }, [
        newMessage
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        className: className,
        style: style,
        children: [
            messages.map((message)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9873335f494656cc$export$5d387b3cd0a254bc), {
                    isPublic: isPublic,
                    album: album,
                    message: message,
                    isLoading: isLoading,
                    setIsLoading: setIsLoading,
                    onMessageRemoved: ()=>{
                        message.isRemoved = true;
                        message.body = (0, $37bec70ed65ed924$export$21c51bc433c16634).message_removed;
                        setMessages((messages)=>messages.map((otherMessage)=>otherMessage.uuid == message.uuid ? message : otherMessage));
                    }
                }, message.uuid)),
            messages.length == 0 && !isLoading && !parentMessage && noMoreMessages && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9c2bffaa070cafe9$exports))).noMessagesText,
                style: {
                    color: theme.palette.secondary.main
                },
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_no_messages
            }),
            !noMoreMessages && !isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                startIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                }),
                size: "small",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9c2bffaa070cafe9$exports))).button,
                onClick: ()=>setFetchMoreMessages((state)=>!state),
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_more
            })
        ]
    });
};









const $726ce6f6af8bd5b7$export$878931e303b73396 = ({ isPublic: isPublic, album: album })=>{
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const [wasExpanded, setWasExpanded] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const { addMessageForAlbum: addMessageForAlbum } = (0, $1cb6fc199fdf5181$export$2f838cddaa674f1c)();
    const [isNewMessageDialogOpen, setIsNewMessageDialogOpen] = (0, $7fPBF.useState)(false);
    const [newMessage, setNewMessage] = (0, $7fPBF.useState)();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const onNewMessage = async (messageBody)=>{
        setIsLoading(true);
        const { status: status, body: body } = await addMessageForAlbum({
            albumId: album.uuid,
            collectionId: currentPublicCollection?.uuid,
            body: messageBody
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            if (wasExpanded) setNewMessage(body);
            else {
                setIsExpanded(true);
                setWasExpanded(true);
            }
            album.messagesCount = album.messagesCount ? album.messagesCount + 1 : 1;
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        setIsExpanded(true);
        setWasExpanded(true);
    }, [
        newMessage
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setIsExpanded(false);
        setWasExpanded(false);
        setNewMessage(undefined);
    }, [
        album.uuid
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setIsLoading(album.messagesCount === undefined);
    }, [
        album.messagesCount
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).mainDiv,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).container,
                onClick: ()=>{
                    setIsExpanded((state)=>!state);
                    setWasExpanded(true);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                            disableTypography: true,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).title,
                            secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_title,
                            sx: {
                                flexGrow: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).badge,
                            badgeContent: album.messagesCount,
                            color: "primary"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).loadingDiv,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: isExpanded ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowUp : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).addButton,
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_new_title,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ChatAddOn,
                loading: isLoading,
                onClick: ()=>setIsNewMessageDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
                in: isExpanded,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bac9ba5fe3edcd59$exports))).collapse,
                children: (isExpanded || wasExpanded) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eea340c090eae092$export$3c16eecaa826a9be), {
                    isPublic: isPublic,
                    album: album,
                    style: {
                        width: "100%",
                        boxSizing: "border-box",
                        paddingRight: 12
                    },
                    isLoading: isLoading,
                    setIsLoading: setIsLoading,
                    newMessage: newMessage
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_new_title,
                description: "",
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).messages_new_title,
                open: isNewMessageDialogOpen,
                onClose: ()=>setIsNewMessageDialogOpen(false),
                onChange: onNewMessage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




parcelRequire("7fPBF");


var $39a72bee5189ae5d$exports = {};

$parcel$export($39a72bee5189ae5d$exports, "header", function () { return $39a72bee5189ae5d$export$38e42c68cf43b5d4; }, function (v) { return $39a72bee5189ae5d$export$38e42c68cf43b5d4 = v; });
$parcel$export($39a72bee5189ae5d$exports, "noLocationText", function () { return $39a72bee5189ae5d$export$1f32426fa6277a1a; }, function (v) { return $39a72bee5189ae5d$export$1f32426fa6277a1a = v; });
$parcel$export($39a72bee5189ae5d$exports, "skeleton", function () { return $39a72bee5189ae5d$export$2a0674ff2eb10214; }, function (v) { return $39a72bee5189ae5d$export$2a0674ff2eb10214 = v; });
$parcel$export($39a72bee5189ae5d$exports, "tableDiv", function () { return $39a72bee5189ae5d$export$55f8f55da585078f; }, function (v) { return $39a72bee5189ae5d$export$55f8f55da585078f = v; });
$parcel$export($39a72bee5189ae5d$exports, "title", function () { return $39a72bee5189ae5d$export$fb184b623420d9be; }, function (v) { return $39a72bee5189ae5d$export$fb184b623420d9be = v; });
var $39a72bee5189ae5d$export$38e42c68cf43b5d4;
var $39a72bee5189ae5d$export$1f32426fa6277a1a;
var $39a72bee5189ae5d$export$2a0674ff2eb10214;
var $39a72bee5189ae5d$export$55f8f55da585078f;
var $39a72bee5189ae5d$export$fb184b623420d9be;
$39a72bee5189ae5d$export$38e42c68cf43b5d4 = `mbNWgW_header`;
$39a72bee5189ae5d$export$1f32426fa6277a1a = `mbNWgW_noLocationText`;
$39a72bee5189ae5d$export$2a0674ff2eb10214 = `mbNWgW_skeleton`;
$39a72bee5189ae5d$export$55f8f55da585078f = `mbNWgW_tableDiv`;
$39a72bee5189ae5d$export$fb184b623420d9be = `mbNWgW_title`;





var $7fPBF = parcelRequire("7fPBF");

var $e8b643777b4e29c2$exports = {};

$parcel$export($e8b643777b4e29c2$exports, "list", function () { return $e8b643777b4e29c2$export$8837f4fc672e936d; }, function (v) { return $e8b643777b4e29c2$export$8837f4fc672e936d = v; });
var $e8b643777b4e29c2$export$8837f4fc672e936d;
$e8b643777b4e29c2$export$8837f4fc672e936d = `_9BEI3q_list`;



parcelRequire("7fPBF");

var $6c2fcedf5a9fa446$exports = {};

$parcel$export($6c2fcedf5a9fa446$exports, "bottomLabel", function () { return $6c2fcedf5a9fa446$export$4f30d68a1d90a362; }, function (v) { return $6c2fcedf5a9fa446$export$4f30d68a1d90a362 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "container", function () { return $6c2fcedf5a9fa446$export$34e0f9847d4c02dd; }, function (v) { return $6c2fcedf5a9fa446$export$34e0f9847d4c02dd = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "hoverButton", function () { return $6c2fcedf5a9fa446$export$b0260c0afbf48c57; }, function (v) { return $6c2fcedf5a9fa446$export$b0260c0afbf48c57 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "hoverButtonIcon", function () { return $6c2fcedf5a9fa446$export$2a797adc03a2480; }, function (v) { return $6c2fcedf5a9fa446$export$2a797adc03a2480 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "hoverButtonsStack", function () { return $6c2fcedf5a9fa446$export$a8eacba2c33c9f28; }, function (v) { return $6c2fcedf5a9fa446$export$a8eacba2c33c9f28 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "labelStack", function () { return $6c2fcedf5a9fa446$export$9b02cbf662e15740; }, function (v) { return $6c2fcedf5a9fa446$export$9b02cbf662e15740 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "position", function () { return $6c2fcedf5a9fa446$export$5880b8b5730aff45; }, function (v) { return $6c2fcedf5a9fa446$export$5880b8b5730aff45 = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "shelving", function () { return $6c2fcedf5a9fa446$export$90cbd767c1007fee; }, function (v) { return $6c2fcedf5a9fa446$export$90cbd767c1007fee = v; });
$parcel$export($6c2fcedf5a9fa446$exports, "topLabel", function () { return $6c2fcedf5a9fa446$export$ca336363f4c2a3b9; }, function (v) { return $6c2fcedf5a9fa446$export$ca336363f4c2a3b9 = v; });
var $6c2fcedf5a9fa446$export$4f30d68a1d90a362;
var $6c2fcedf5a9fa446$export$34e0f9847d4c02dd;
var $6c2fcedf5a9fa446$export$b0260c0afbf48c57;
var $6c2fcedf5a9fa446$export$2a797adc03a2480;
var $6c2fcedf5a9fa446$export$a8eacba2c33c9f28;
var $6c2fcedf5a9fa446$export$9b02cbf662e15740;
var $6c2fcedf5a9fa446$export$5880b8b5730aff45;
var $6c2fcedf5a9fa446$export$90cbd767c1007fee;
var $6c2fcedf5a9fa446$export$ca336363f4c2a3b9;
$6c2fcedf5a9fa446$export$4f30d68a1d90a362 = `Oqe4Na_bottomLabel`;
$6c2fcedf5a9fa446$export$34e0f9847d4c02dd = `Oqe4Na_container`;
$6c2fcedf5a9fa446$export$b0260c0afbf48c57 = `Oqe4Na_hoverButton`;
$6c2fcedf5a9fa446$export$2a797adc03a2480 = `Oqe4Na_hoverButtonIcon`;
$6c2fcedf5a9fa446$export$a8eacba2c33c9f28 = `Oqe4Na_hoverButtonsStack`;
$6c2fcedf5a9fa446$export$9b02cbf662e15740 = `Oqe4Na_labelStack`;
$6c2fcedf5a9fa446$export$5880b8b5730aff45 = `Oqe4Na_position`;
$6c2fcedf5a9fa446$export$90cbd767c1007fee = `Oqe4Na_shelving`;
$6c2fcedf5a9fa446$export$ca336363f4c2a3b9 = `Oqe4Na_topLabel`;



const $ff37b8d029a5fd73$export$e5a116ed0239de1e = ({ shelfSegmentAlbum: shelfSegmentAlbum, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
            disableGutters: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                flexGrow: 1,
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).shelving,
                        children: shelfSegmentAlbum.shelfSegment.shelf.shelving.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).labelStack,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).topLabel,
                                style: {
                                    color: theme.palette.secondary.main,
                                    fontStyle: "italic"
                                },
                                children: `${(0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_title} ${shelfSegmentAlbum.shelfSegment.shelf.order + 1}`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).bottomLabel,
                                children: shelfSegmentAlbum.shelfSegment.shelf.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).labelStack,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).topLabel,
                                style: {
                                    color: theme.palette.secondary.main,
                                    fontStyle: "italic"
                                },
                                children: `${(0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_title} ${shelfSegmentAlbum.shelfSegment.order + 1}`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).bottomLabel,
                                children: shelfSegmentAlbum.shelfSegment.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).labelStack,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).topLabel,
                                style: {
                                    color: theme.palette.secondary.main,
                                    textAlign: "center"
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_position_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6c2fcedf5a9fa446$exports))).bottomLabel,
                                style: {
                                    textAlign: "center"
                                },
                                children: shelfSegmentAlbum.order + 1
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
const $3af1e05012cfa2ee$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $3af1e05012cfa2ee$export$2e2bcd8739ae039 = $3af1e05012cfa2ee$var$visuallyHidden;


function $d54a35b23c320444$export$94fd53d40f0652a(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}


'use client';
const $4a24c0cde13ac1af$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $4a24c0cde13ac1af$var$asc(a, b) {
    return a - b;
}
function $4a24c0cde13ac1af$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $4a24c0cde13ac1af$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $4a24c0cde13ac1af$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $4a24c0cde13ac1af$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $4a24c0cde13ac1af$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $4a24c0cde13ac1af$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($4a24c0cde13ac1af$var$getDecimalPrecision(step)));
}
function $4a24c0cde13ac1af$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($4a24c0cde13ac1af$var$asc);
}
function $4a24c0cde13ac1af$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $4a24c0cde13ac1af$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $d54a35b23c320444$export$94fd53d40f0652a)(newValue, oldValue);
    return false;
}
const $4a24c0cde13ac1af$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $4a24c0cde13ac1af$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $4a24c0cde13ac1af$var$cachedSupportsTouchActionNone;
function $4a24c0cde13ac1af$var$doesSupportTouchActionNone() {
    if ($4a24c0cde13ac1af$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $4a24c0cde13ac1af$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $4a24c0cde13ac1af$var$cachedSupportsTouchActionNone = true;
    }
    return $4a24c0cde13ac1af$var$cachedSupportsTouchActionNone;
}
function $4a24c0cde13ac1af$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $4a24c0cde13ac1af$export$544bf02140fa9a77, step: step = 1, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $7fPBF.useRef();
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $7fPBF.useState(-1);
    const [open, setOpen] = $7fPBF.useState(-1);
    const [dragging, setDragging] = $7fPBF.useState(false);
    const moveCount = $7fPBF.useRef(0);
    const [valueDerived, setValueState] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($4a24c0cde13ac1af$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $52b16131f46e7800$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $7fPBF.useState(-1);
    const sliderRef = $7fPBF.useRef();
    const handleFocusRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            const value = values[index];
            const marksIndex = marksValues.indexOf(value);
            // @ts-ignore
            let newValue = event.target.valueAsNumber;
            if (marks && step == null) {
                const maxMarksValue = marksValues[marksValues.length - 1];
                if (newValue > maxMarksValue) newValue = maxMarksValue;
                else if (newValue < marksValues[0]) newValue = marksValues[0];
                else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
            }
            newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, min, max);
            if (range) {
                // Bound the new value to the thumb's neighbours.
                if (disableSwap) newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
                const previousValue = newValue;
                newValue = $4a24c0cde13ac1af$var$setValueIndex({
                    values: values,
                    newValue: newValue,
                    index: index
                });
                let activeIndex = index;
                // Potentially swap the index if needed.
                if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
                $4a24c0cde13ac1af$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex
                });
            }
            setValueState(newValue);
            setFocusedThumbIndex(index);
            if (handleChange && !$4a24c0cde13ac1af$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
            if (onChangeCommitted) onChangeCommitted(event, newValue);
        };
    const previousIndex = $7fPBF.useRef();
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $4a24c0cde13ac1af$var$percentToValue(percent, min, max);
        if (step) newValue = $4a24c0cde13ac1af$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $4a24c0cde13ac1af$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $4a24c0cde13ac1af$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $3e74852d812b8b64$export$2e2bcd8739ae039)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $4a24c0cde13ac1af$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $4a24c0cde13ac1af$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $4a24c0cde13ac1af$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $4a24c0cde13ac1af$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$4a24c0cde13ac1af$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $4a24c0cde13ac1af$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$4a24c0cde13ac1af$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $4a24c0cde13ac1af$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $4a24c0cde13ac1af$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$4a24c0cde13ac1af$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $7fPBF.useCallback(()=>{
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $7fPBF.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $4a24c0cde13ac1af$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $7fPBF.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $4a24c0cde13ac1af$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $4a24c0cde13ac1af$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$4a24c0cde13ac1af$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $4a24c0cde13ac1af$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $4a24c0cde13ac1af$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalHandlers, ownEventHandlers);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalHandlers, ownEventHandlers);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $3af1e05012cfa2ee$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $4a24c0cde13ac1af$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}







const $2e9e574fd19888e1$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $59c589404b20ab2d$export$e28348cc2430497)(Slot);
};
var $2e9e574fd19888e1$export$2e2bcd8739ae039 = $2e9e574fd19888e1$var$shouldSpreadAdditionalProps;




var $7fPBF = parcelRequire("7fPBF");




function $1bfdb8c086e1325d$export$9f59f2622d5cbc2a(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSlider', slot);
}
const $1bfdb8c086e1325d$var$sliderClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $1bfdb8c086e1325d$export$2e2bcd8739ae039 = $1bfdb8c086e1325d$var$sliderClasses;



'use client';
const $cbbb03245ede8542$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(open && (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $cbbb03245ede8542$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $cbbb03245ede8542$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $7fPBF.cloneElement(children, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(children.props.className)
    }, /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




'use client';
const $3f15ab21d190f284$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $3f15ab21d190f284$var$Identity(x) {
    return x;
}
const $3f15ab21d190f284$export$c1a21b3b4da66aa1 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        color: (theme.vars || theme).palette[ownerState.color].main,
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.orientation === 'horizontal' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: 4,
        width: '100%',
        padding: '13px 0',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
            // Reach 42px touch target, about ~8mm on screen.
            padding: '20px 0'
        }
    }, ownerState.size === 'small' && {
        height: 2
    }, ownerState.marked && {
        marginBottom: 20
    }), ownerState.orientation === 'vertical' && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: '100%',
        width: 4,
        padding: '0 13px',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
            // Reach 42px touch target, about ~8mm on screen.
            padding: '0 20px'
        }
    }, ownerState.size === 'small' && {
        width: 2
    }, ownerState.marked && {
        marginRight: 44
    }), {
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).thumb}, & .${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        }
    }));
const $3f15ab21d190f284$export$b02fde61a3559c2 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})(({ ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        backgroundColor: 'currentColor',
        opacity: 0.38
    }, ownerState.orientation === 'horizontal' && {
        width: '100%',
        height: 'inherit',
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        width: 'inherit',
        left: '50%',
        transform: 'translateX(-50%)'
    }, ownerState.track === 'inverted' && {
        opacity: 1
    }));
const $3f15ab21d190f284$export$105594979f116971 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme, ownerState: ownerState })=>{
    const color = // Same logic as the LinearProgress track color
    theme.palette.mode === 'light' ? (0, $92041da11764723e$export$c0816ed86df316af)(theme.palette[ownerState.color].main, 0.62) : (0, $92041da11764723e$export$4b073707ff63303)(theme.palette[ownerState.color].main, 0.5);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.size === 'small' && {
        border: 'none'
    }, ownerState.orientation === 'horizontal' && {
        height: 'inherit',
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.orientation === 'vertical' && {
        width: 'inherit',
        left: '50%',
        transform: 'translateX(-50%)'
    }, ownerState.track === false && {
        display: 'none'
    }, ownerState.track === 'inverted' && {
        backgroundColor: theme.vars ? theme.vars.palette.Slider[`${ownerState.color}Track`] : color,
        borderColor: theme.vars ? theme.vars.palette.Slider[`${ownerState.color}Track`] : color
    });
});
const $3f15ab21d190f284$export$2c1b491743890dec = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.size === 'small' && {
        width: 12,
        height: 12
    }, ownerState.orientation === 'horizontal' && {
        top: '50%',
        transform: 'translate(-50%, -50%)'
    }, ownerState.orientation === 'vertical' && {
        left: '50%',
        transform: 'translate(-50%, 50%)'
    }, {
        '&::before': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        }, ownerState.size === 'small' && {
            boxShadow: 'none'
        }),
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&:hover, &.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: `0px 0px 0px 8px ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.16)}`,
            '@media (hover: none)': {
                boxShadow: 'none'
            }
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).active}`]: {
            boxShadow: `0px 0px 0px 14px ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.16)}`
        },
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        }
    }));
const $3f15ab21d190f284$export$6453176f504d54f0 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $cbbb03245ede8542$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme, ownerState: ownerState })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        [`&.${(0, $1bfdb8c086e1325d$export$2e2bcd8739ae039).valueLabelOpen}`]: {
            transform: `${ownerState.orientation === 'vertical' ? 'translateY(-50%)' : 'translateY(-100%)'} scale(1)`
        },
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        transform: `${ownerState.orientation === 'vertical' ? 'translateY(-50%)' : 'translateY(-100%)'} scale(0)`,
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem'
    }, ownerState.orientation === 'horizontal' && {
        top: '-10px',
        transformOrigin: 'bottom center',
        '&::before': {
            position: 'absolute',
            content: '""',
            width: 8,
            height: 8,
            transform: 'translate(-50%, 50%) rotate(45deg)',
            backgroundColor: 'inherit',
            bottom: 0,
            left: '50%'
        }
    }, ownerState.orientation === 'vertical' && {
        right: ownerState.size === 'small' ? '20px' : '30px',
        top: '50%',
        transformOrigin: 'right center',
        '&::before': {
            position: 'absolute',
            content: '""',
            width: 8,
            height: 8,
            transform: 'translate(-50%, -50%) rotate(45deg)',
            backgroundColor: 'inherit',
            right: -8,
            top: '50%'
        }
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(12),
        padding: '0.25rem 0.5rem'
    }));
const $3f15ab21d190f284$export$6f85f6a3c5da6f62 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$f10c5a10d27438e5)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme, ownerState: ownerState, markActive: markActive })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor'
    }, ownerState.orientation === 'horizontal' && {
        top: '50%',
        transform: 'translate(-1px, -50%)'
    }, ownerState.orientation === 'vertical' && {
        left: '50%',
        transform: 'translate(-50%, 1px)'
    }, markActive && {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        opacity: 0.8
    }));
const $3f15ab21d190f284$export$e6cd369965e5aa95 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $f0645ef192f222f7$export$f10c5a10d27438e5)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme, ownerState: ownerState, markLabelActive: markLabelActive })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap'
    }, ownerState.orientation === 'horizontal' && {
        top: 30,
        transform: 'translateX(-50%)',
        '@media (pointer: coarse)': {
            top: 40
        }
    }, ownerState.orientation === 'vertical' && {
        left: 36,
        transform: 'translateY(50%)',
        '@media (pointer: coarse)': {
            left: 44
        }
    }, markLabelActive && {
        color: (theme.vars || theme).palette.text.primary
    }));
const $3f15ab21d190f284$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            color && `thumbColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1bfdb8c086e1325d$export$9f59f2622d5cbc2a), classes);
};
const $3f15ab21d190f284$var$Forward = ({ children: children })=>children;
const $3f15ab21d190f284$var$Slider = /*#__PURE__*/ $7fPBF.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', size: size = 'medium', step: step = 1, scale: scale = $3f15ab21d190f284$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $3f15ab21d190f284$var$Identity } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $3f15ab21d190f284$var$_excluded);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $4a24c0cde13ac1af$export$56b2c08e277f365)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $3f15ab21d190f284$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3f15ab21d190f284$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $3f15ab21d190f284$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $3f15ab21d190f284$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $3f15ab21d190f284$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $3f15ab21d190f284$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $3f15ab21d190f284$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $3f15ab21d190f284$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $2e9e574fd19888e1$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RailSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, railProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TrackSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $4a24c0cde13ac1af$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            "data-index": index
                        }, markProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, style, markProps.style),
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkLabelSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, style, markLabelProps.style),
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $4a24c0cde13ac1af$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $3f15ab21d190f284$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $824c049f32d4395d$exports.jsx)(ValueLabelComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, !(0, $59c589404b20ab2d$export$e28348cc2430497)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ThumbSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $3f15ab21d190f284$export$2e2bcd8739ae039 = $3f15ab21d190f284$var$Slider;







const $effa6df78a1ddf8e$export$325b7b146b41f99 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getShelving = (uuid)=>get(`shelvings/${uuid}`);
    return {
        getShelving: getShelving
    };
};



parcelRequire("7fPBF");

parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");








const $314efd7a27edc986$export$d1ccba150acbb675 = ({ shelving: shelving, shelfSegmentAlbum: shelfSegmentAlbum, isHighlighted: isHighlighted })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const genericSpine = new URL($2b6aa9ce287cc06c$exports).href;
    const fetchImage = async ()=>{
        const spineImage = (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSpineImage(shelfSegmentAlbum.album);
        if (!spineImage) return;
        const response = await getImage({
            name: spineImage.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        const thumbnail = shelfSegmentAlbum.album.thumbnail;
        if (!thumbnail) setTintColor(undefined);
        const image = new Image();
        image.src = `data:image/png;base64,${thumbnail}`;
        image.onload = function() {
            setTintColor((0, $74a5752378f7da5e$export$734d4481083c9058).getDominantColor(image));
        };
    }, [
        shelfSegmentAlbum.album.thumbnail
    ]);
    const [tintColor, setTintColor] = (0, $7fPBF.useState)();
    (0, $7fPBF.useEffect)(()=>{
        fetchImage().then();
    }, [
        shelfSegmentAlbum.album.uuid
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
        style: {
            height: shelving.orientation == "horizontal" ? shelving.everyAlbumHasSameSize ? "96%" : (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getShapeRelativeSize(shelfSegmentAlbum.shape) : "fit-content",
            width: shelving.orientation == "horizontal" ? "fit-content" : shelving.everyAlbumHasSameSize ? "96%" : (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getShapeRelativeSize(shelfSegmentAlbum.shape),
            borderStyle: "solid",
            borderRadius: "4px",
            borderWidth: isHighlighted ? "3px" : "0",
            borderColor: isHighlighted ? theme.palette.colors?.highlightSpine : "transparent",
            pointerEvents: "none"
        },
        image: image,
        thumbnail: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSpineImage(shelfSegmentAlbum.album)?.thumbnail,
        defaultImage: genericSpine,
        beforeLoad: fetchImage,
        alt: shelfSegmentAlbum.album.name,
        forceVertical: shelving.orientation == "horizontal",
        forceHorizontal: shelving.orientation == "vertical",
        tintColor: image !== undefined ? undefined : tintColor,
        waitUntilImageIsFinal: true
    });
};


var $a9ab9d31e3a7e986$exports = {};

$parcel$export($a9ab9d31e3a7e986$exports, "albumContainerHorizontal", function () { return $a9ab9d31e3a7e986$export$72feede97ff81d1c; }, function (v) { return $a9ab9d31e3a7e986$export$72feede97ff81d1c = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "albumContainerVertical", function () { return $a9ab9d31e3a7e986$export$12a7ab08771ab1ee; }, function (v) { return $a9ab9d31e3a7e986$export$12a7ab08771ab1ee = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "albumsContainer", function () { return $a9ab9d31e3a7e986$export$a3a3115420cce3e0; }, function (v) { return $a9ab9d31e3a7e986$export$a3a3115420cce3e0 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "albumsDiv", function () { return $a9ab9d31e3a7e986$export$c0258fece8c96b3d; }, function (v) { return $a9ab9d31e3a7e986$export$c0258fece8c96b3d = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "backgroundImage", function () { return $a9ab9d31e3a7e986$export$586b24dc092f3131; }, function (v) { return $a9ab9d31e3a7e986$export$586b24dc092f3131 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "hoverButton", function () { return $a9ab9d31e3a7e986$export$b0260c0afbf48c57; }, function (v) { return $a9ab9d31e3a7e986$export$b0260c0afbf48c57 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "hoverButtonRadius", function () { return $a9ab9d31e3a7e986$export$68d9146667c74d00; }, function (v) { return $a9ab9d31e3a7e986$export$68d9146667c74d00 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "hoverButtonsStack", function () { return $a9ab9d31e3a7e986$export$a8eacba2c33c9f28; }, function (v) { return $a9ab9d31e3a7e986$export$a8eacba2c33c9f28 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "loadingIndicator", function () { return $a9ab9d31e3a7e986$export$f10e6b4aaa94c253; }, function (v) { return $a9ab9d31e3a7e986$export$f10e6b4aaa94c253 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "segment", function () { return $a9ab9d31e3a7e986$export$6519c25590136c5e; }, function (v) { return $a9ab9d31e3a7e986$export$6519c25590136c5e = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "tooltipAlbumName", function () { return $a9ab9d31e3a7e986$export$5062d43f7880287b; }, function (v) { return $a9ab9d31e3a7e986$export$5062d43f7880287b = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "tooltipArtistName", function () { return $a9ab9d31e3a7e986$export$9980b192e710d996; }, function (v) { return $a9ab9d31e3a7e986$export$9980b192e710d996 = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "tooltipDiv", function () { return $a9ab9d31e3a7e986$export$99457b17a23e021d; }, function (v) { return $a9ab9d31e3a7e986$export$99457b17a23e021d = v; });
$parcel$export($a9ab9d31e3a7e986$exports, "tooltipSubtitle", function () { return $a9ab9d31e3a7e986$export$1ccb8483ebbce678; }, function (v) { return $a9ab9d31e3a7e986$export$1ccb8483ebbce678 = v; });
var $a9ab9d31e3a7e986$export$72feede97ff81d1c;
var $a9ab9d31e3a7e986$export$12a7ab08771ab1ee;
var $a9ab9d31e3a7e986$export$a3a3115420cce3e0;
var $a9ab9d31e3a7e986$export$c0258fece8c96b3d;
var $a9ab9d31e3a7e986$export$586b24dc092f3131;
var $a9ab9d31e3a7e986$export$b0260c0afbf48c57;
var $a9ab9d31e3a7e986$export$68d9146667c74d00;
var $a9ab9d31e3a7e986$export$a8eacba2c33c9f28;
var $a9ab9d31e3a7e986$export$f10e6b4aaa94c253;
var $a9ab9d31e3a7e986$export$6519c25590136c5e;
var $a9ab9d31e3a7e986$export$5062d43f7880287b;
var $a9ab9d31e3a7e986$export$9980b192e710d996;
var $a9ab9d31e3a7e986$export$99457b17a23e021d;
var $a9ab9d31e3a7e986$export$1ccb8483ebbce678;
$a9ab9d31e3a7e986$export$72feede97ff81d1c = `DQMOna_albumContainerHorizontal`;
$a9ab9d31e3a7e986$export$12a7ab08771ab1ee = `DQMOna_albumContainerVertical`;
$a9ab9d31e3a7e986$export$a3a3115420cce3e0 = `DQMOna_albumsContainer`;
$a9ab9d31e3a7e986$export$c0258fece8c96b3d = `DQMOna_albumsDiv`;
$a9ab9d31e3a7e986$export$586b24dc092f3131 = `DQMOna_backgroundImage`;
$a9ab9d31e3a7e986$export$b0260c0afbf48c57 = `DQMOna_hoverButton`;
$a9ab9d31e3a7e986$export$68d9146667c74d00 = `DQMOna_hoverButtonRadius`;
$a9ab9d31e3a7e986$export$a8eacba2c33c9f28 = `DQMOna_hoverButtonsStack`;
$a9ab9d31e3a7e986$export$f10e6b4aaa94c253 = `DQMOna_loadingIndicator`;
$a9ab9d31e3a7e986$export$6519c25590136c5e = `DQMOna_segment`;
$a9ab9d31e3a7e986$export$5062d43f7880287b = `DQMOna_tooltipAlbumName`;
$a9ab9d31e3a7e986$export$9980b192e710d996 = `DQMOna_tooltipArtistName`;
$a9ab9d31e3a7e986$export$99457b17a23e021d = `DQMOna_tooltipDiv`;
$a9ab9d31e3a7e986$export$1ccb8483ebbce678 = `DQMOna_tooltipSubtitle`;











var $22fc8c30969641ce$exports = {};
$22fc8c30969641ce$exports = $parcel$resolve("iQT4v");


const $36b1843853ab03b4$var$cedarImage = new URL($22fc8c30969641ce$exports).href;
var $96c98f35edfaf647$exports = {};
$96c98f35edfaf647$exports = $parcel$resolve("dFx9T");


const $36b1843853ab03b4$var$oakImage = new URL($96c98f35edfaf647$exports).href;
var $146a82a53319cd36$exports = {};
$146a82a53319cd36$exports = $parcel$resolve("aluYv");


const $36b1843853ab03b4$var$ebonyImage = new URL($146a82a53319cd36$exports).href;
var $01b16688bab293bd$exports = {};
$01b16688bab293bd$exports = $parcel$resolve("6J1M0");


const $36b1843853ab03b4$var$walnutImage = new URL($01b16688bab293bd$exports).href;
var $a653c194e6d707f7$exports = {};
$a653c194e6d707f7$exports = $parcel$resolve("2j2Zy");


const $36b1843853ab03b4$var$blueImage = new URL($a653c194e6d707f7$exports).href;
const $36b1843853ab03b4$export$76250962427778b = {
    getThemeString: (theme)=>{
        switch(theme){
            case "cedar":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_cedar;
            case "oak":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_oak;
            case "ebony":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_ebony;
            case "walnut":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_walnut;
            case "blue":
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_blue;
        }
    },
    getThemeImage: (theme)=>{
        switch(theme){
            case "cedar":
                return $36b1843853ab03b4$var$cedarImage;
            case "oak":
                return $36b1843853ab03b4$var$oakImage;
            case "ebony":
                return $36b1843853ab03b4$var$ebonyImage;
            case "walnut":
                return $36b1843853ab03b4$var$walnutImage;
            case "blue":
                return $36b1843853ab03b4$var$blueImage;
        }
    }
};



const $9d893cf052e903c1$export$8ceaf7e95627b7fd = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getShelfSegment = (parameters)=>get("shelfSegments", parameters);
    return {
        getShelfSegment: getShelfSegment
    };
};









var $7fPBF = parcelRequire("7fPBF");




var $a140aa18b44c98b0$exports = {};

$parcel$export($a140aa18b44c98b0$exports, "icon", function () { return $a140aa18b44c98b0$export$1ca1ec8b29a4ce27; }, function (v) { return $a140aa18b44c98b0$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($a140aa18b44c98b0$exports, "tooltipDiv", function () { return $a140aa18b44c98b0$export$99457b17a23e021d; }, function (v) { return $a140aa18b44c98b0$export$99457b17a23e021d = v; });
$parcel$export($a140aa18b44c98b0$exports, "tooltipName", function () { return $a140aa18b44c98b0$export$554e439077446571; }, function (v) { return $a140aa18b44c98b0$export$554e439077446571 = v; });
$parcel$export($a140aa18b44c98b0$exports, "tooltipSubtitle", function () { return $a140aa18b44c98b0$export$1ccb8483ebbce678; }, function (v) { return $a140aa18b44c98b0$export$1ccb8483ebbce678 = v; });
var $a140aa18b44c98b0$export$1ca1ec8b29a4ce27;
var $a140aa18b44c98b0$export$99457b17a23e021d;
var $a140aa18b44c98b0$export$554e439077446571;
var $a140aa18b44c98b0$export$1ccb8483ebbce678;
$a140aa18b44c98b0$export$1ca1ec8b29a4ce27 = `fW0kiq_icon`;
$a140aa18b44c98b0$export$99457b17a23e021d = `fW0kiq_tooltipDiv`;
$a140aa18b44c98b0$export$554e439077446571 = `fW0kiq_tooltipName`;
$a140aa18b44c98b0$export$1ccb8483ebbce678 = `fW0kiq_tooltipSubtitle`;






const $50540355ae139a02$export$d9f7f709f08be2e = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const removeAllAlbumsFromShelfSegment = (parameters)=>deleteRequest("shelfSegments/allAlbums", parameters);
    return {
        removeAllAlbumsFromShelfSegment: removeAllAlbumsFromShelfSegment
    };
};




const $eeaf0ae78a579fae$export$dd95e972bd94f841 = ({ className: className, style: style, buttonClassName: buttonClassName, shelvings: shelvings, setShelvings: setShelvings, shelving: shelving, shelf: shelf, shelfSegment: shelfSegment, setIsLoading: setIsLoading, onModifyShelving: onModifyShelving, onModifyShelf: onModifyShelf, onModifyShelfSegment: onModifyShelfSegment, onFocus: onFocus, onStats: onStats, onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [loading] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const { removeAllAlbumsFromShelfSegment: removeAllAlbumsFromShelfSegment } = (0, $50540355ae139a02$export$d9f7f709f08be2e)();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const onRemoveAllAlbumsFromShelfSegment = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await removeAllAlbumsFromShelfSegment({
            uuid: shelfSegment.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setShelvings(shelvings.map((auxShelving)=>{
                if (shelving.uuid == auxShelving.uuid) auxShelving.shelves = auxShelving.shelves.map((auxShelf)=>{
                    if (shelf.uuid == auxShelf.uuid) auxShelf.segments = auxShelf.segments.map((auxSegment)=>{
                        if (shelfSegment.uuid == auxSegment.uuid) auxSegment.albums = [];
                        return auxSegment;
                    });
                    return auxShelf;
                });
                return auxShelving;
            }));
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical,
                onClick: handleContextMenu,
                loading: loading,
                buttonClassName: buttonClassName,
                iconClassName: (0, (/*@__PURE__*/$parcel$interopDefault($a140aa18b44c98b0$exports))).icon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a140aa18b44c98b0$exports))).tooltipDiv,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a140aa18b44c98b0$exports))).tooltipName,
                                children: shelfSegment?.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a140aa18b44c98b0$exports))).tooltipSubtitle,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: shelfSegment?.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                        style: {
                            marginTop: "6px",
                            marginBottom: "4px"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onFocus(shelf, shelfSegment);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_focus_option
                        ]
                    }, "Focus"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onStats(shelfSegment);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AreaChart
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats
                        ]
                    }, "Stats"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onModifyShelving(shelving);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_edit_title
                        ]
                    }, "EditShelving"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onModifyShelf(shelf);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_edit_title
                        ]
                    }, "EditShelf"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onModifyShelfSegment(shelf, shelfSegment);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_edit_title
                        ]
                    }, "EditShefSegment"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onAssignAlbumsToShelfSegmentByFilter(shelfSegment);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PlaylistAdd
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_assign_filtered_albums
                        ]
                    }, "AddFilteredAlbums"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onRemoveAllAlbumsFromShelfSegment().then();
                        },
                        sx: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_remove_all_albums
                        ]
                    }, "RemoveAllAlbums")
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};





parcelRequire("7fPBF");





var $d315ce73f1d845e4$exports = {};

$parcel$export($d315ce73f1d845e4$exports, "cardDiv", function () { return $d315ce73f1d845e4$export$5b6b191f3c2fe4d2; }, function (v) { return $d315ce73f1d845e4$export$5b6b191f3c2fe4d2 = v; });
$parcel$export($d315ce73f1d845e4$exports, "graphsDiv", function () { return $d315ce73f1d845e4$export$7f9e75aa60d230f3; }, function (v) { return $d315ce73f1d845e4$export$7f9e75aa60d230f3 = v; });
$parcel$export($d315ce73f1d845e4$exports, "graphsDivMobile", function () { return $d315ce73f1d845e4$export$2d8a3278abf5949e; }, function (v) { return $d315ce73f1d845e4$export$2d8a3278abf5949e = v; });
$parcel$export($d315ce73f1d845e4$exports, "itemCard", function () { return $d315ce73f1d845e4$export$e0be3821d621a3a0; }, function (v) { return $d315ce73f1d845e4$export$e0be3821d621a3a0 = v; });
$parcel$export($d315ce73f1d845e4$exports, "itemCardMobile", function () { return $d315ce73f1d845e4$export$20450404b102fd6c; }, function (v) { return $d315ce73f1d845e4$export$20450404b102fd6c = v; });
$parcel$export($d315ce73f1d845e4$exports, "list", function () { return $d315ce73f1d845e4$export$8837f4fc672e936d; }, function (v) { return $d315ce73f1d845e4$export$8837f4fc672e936d = v; });
$parcel$export($d315ce73f1d845e4$exports, "loadingStack", function () { return $d315ce73f1d845e4$export$5b8225885d80bccc; }, function (v) { return $d315ce73f1d845e4$export$5b8225885d80bccc = v; });
$parcel$export($d315ce73f1d845e4$exports, "mainContainer", function () { return $d315ce73f1d845e4$export$eccb60d5692f3f7d; }, function (v) { return $d315ce73f1d845e4$export$eccb60d5692f3f7d = v; });
$parcel$export($d315ce73f1d845e4$exports, "mainDiv", function () { return $d315ce73f1d845e4$export$16666caf1c4e1af1; }, function (v) { return $d315ce73f1d845e4$export$16666caf1c4e1af1 = v; });
$parcel$export($d315ce73f1d845e4$exports, "progressBar", function () { return $d315ce73f1d845e4$export$9d1298853f0e77f7; }, function (v) { return $d315ce73f1d845e4$export$9d1298853f0e77f7 = v; });
$parcel$export($d315ce73f1d845e4$exports, "resizeHandle", function () { return $d315ce73f1d845e4$export$8e36b812ea421d73; }, function (v) { return $d315ce73f1d845e4$export$8e36b812ea421d73 = v; });
$parcel$export($d315ce73f1d845e4$exports, "sectionTitle", function () { return $d315ce73f1d845e4$export$1a952fe22cdce89e; }, function (v) { return $d315ce73f1d845e4$export$1a952fe22cdce89e = v; });
var $d315ce73f1d845e4$export$5b6b191f3c2fe4d2;
var $d315ce73f1d845e4$export$7f9e75aa60d230f3;
var $d315ce73f1d845e4$export$2d8a3278abf5949e;
var $d315ce73f1d845e4$export$e0be3821d621a3a0;
var $d315ce73f1d845e4$export$20450404b102fd6c;
var $d315ce73f1d845e4$export$8837f4fc672e936d;
var $d315ce73f1d845e4$export$5b8225885d80bccc;
var $d315ce73f1d845e4$export$eccb60d5692f3f7d;
var $d315ce73f1d845e4$export$16666caf1c4e1af1;
var $d315ce73f1d845e4$export$9d1298853f0e77f7;
var $d315ce73f1d845e4$export$8e36b812ea421d73;
var $d315ce73f1d845e4$export$1a952fe22cdce89e;
$d315ce73f1d845e4$export$5b6b191f3c2fe4d2 = `pP1R9W_cardDiv`;
$d315ce73f1d845e4$export$7f9e75aa60d230f3 = `pP1R9W_graphsDiv`;
$d315ce73f1d845e4$export$2d8a3278abf5949e = `pP1R9W_graphsDivMobile`;
$d315ce73f1d845e4$export$e0be3821d621a3a0 = `pP1R9W_itemCard`;
$d315ce73f1d845e4$export$20450404b102fd6c = `pP1R9W_itemCardMobile`;
$d315ce73f1d845e4$export$8837f4fc672e936d = `pP1R9W_list`;
$d315ce73f1d845e4$export$5b8225885d80bccc = `pP1R9W_loadingStack`;
$d315ce73f1d845e4$export$eccb60d5692f3f7d = `pP1R9W_mainContainer`;
$d315ce73f1d845e4$export$16666caf1c4e1af1 = `pP1R9W_mainDiv`;
$d315ce73f1d845e4$export$9d1298853f0e77f7 = `pP1R9W_progressBar`;
$d315ce73f1d845e4$export$8e36b812ea421d73 = `pP1R9W_resizeHandle`;
$d315ce73f1d845e4$export$1a952fe22cdce89e = `pP1R9W_sectionTitle`;



const $554943cc4b1d8022$export$437131e9f7cde841 = ()=>{
    const shelvingAlbumCount = (shelving)=>shelving.shelves?.reduce((value, shelf)=>value + shelfAlbumCount(shelf), 0);
    const shelfAlbumCount = (shelf)=>shelf.segments?.reduce((value, segment)=>value + shelfSegmentAlbumCount(segment), 0);
    const shelfSegmentAlbumCount = (shelfSegment)=>shelfSegment.albums?.length ?? 0;
    return {
        shelvingAlbumCount: shelvingAlbumCount,
        shelfAlbumCount: shelfAlbumCount,
        shelfSegmentAlbumCount: shelfSegmentAlbumCount
    };
};



const $ccc334ca611084ca$export$dbf8ababda40e4fe = ({ open: open, setOpen: setOpen, shelfSegment: shelfSegment, shelf: shelf, shelving: shelving })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { shelvingAlbumCount: shelvingAlbumCount, shelfAlbumCount: shelfAlbumCount, shelfSegmentAlbumCount: shelfSegmentAlbumCount } = (0, $554943cc4b1d8022$export$437131e9f7cde841)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: open,
        onClose: ()=>setOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>setOpen(false),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCard,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        shelving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_albums_stats_title,
                            detail: shelvingAlbumCount(shelving)
                        }),
                        shelf && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_albums_stats_title,
                                    detail: shelfAlbumCount(shelf)
                                })
                            ]
                        }),
                        shelfSegment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_albums_stats_title,
                                    detail: shelfSegmentAlbumCount(shelfSegment)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



const $49cdbaed780e5b41$export$53c12b3445672e89 = ({ shelving: shelving, shelvings: shelvings, setShelvings: setShelvings, shelf: shelf, shelfSegmentId: shelfSegmentId, overrideShelfSegment: overrideShelfSegment, selectedAlbumIds: selectedAlbumIds, isLoading: isLoading, setIsLoading: setIsLoading, onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected, onShelfSegmentFetched: onShelfSegmentFetched, onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment, shelvingIndex: shelvingIndex, shelfIndex: shelfIndex, segmentIndex: segmentIndex, canRemove: canRemove, onModifyShelving: onModifyShelving, onModifyShelf: onModifyShelf, onModifyShelfSegment: onModifyShelfSegment, onFocus: onFocus, onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter, showOptions: showOptions })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [shelfSegment, setShelfSegment] = (0, $7fPBF.useState)();
    const [selectedAlbum, setSelectedAlbum] = (0, $7fPBF.useState)();
    const [selectedSegmentIndex, setSelectedSegmentIndex] = (0, $7fPBF.useState)();
    const [selectedAlbumIndex, setSelectedAlbumIndex] = (0, $7fPBF.useState)();
    const { getShelfSegment: getShelfSegment } = (0, $9d893cf052e903c1$export$8ceaf7e95627b7fd)();
    const { getPrivateLink: getPrivateLink } = (0, $19e5276cf99ccb6e$export$2c6b92c80f456539)();
    const [isLoadingShelfSegment, setIsLoadingShelfSegment] = (0, $7fPBF.useState)(false);
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const [isStatsDialogOpen, setIsStatsDialogOpen] = (0, $7fPBF.useState)(false);
    const fetchShelfSegment = async ()=>{
        setIsLoadingShelfSegment(true);
        const { status: status, body: body } = await getShelfSegment({
            uuid: shelfSegmentId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setShelfSegment(body);
            onShelfSegmentFetched(body, segmentIndex);
        }
        setIsLoadingShelfSegment(false);
    };
    const { openInNewTab: openInNewTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const openOnPrivateCollection = async ()=>{
        if (!selectedAlbum) return;
        setIsLoading(true);
        const { status: status, body: body } = await getPrivateLink({
            albumId: selectedAlbum.album.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) openInNewTab(body.shareLink);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
        setIsLoading(false);
    };
    const albumDetail = (album)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).tooltipDiv,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).tooltipAlbumName,
                    children: album.name
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).tooltipArtistName,
                    children: album.artist?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).tooltipSubtitle,
                    style: {
                        color: theme.palette.primary.subtitle
                    },
                    children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSubtitle(album)
                })
            ]
        });
    (0, $7fPBF.useEffect)(()=>{
        if (!overrideShelfSegment.albums) {
            setShelfSegment(undefined);
            fetchShelfSegment().then();
        }
    }, [
        shelfSegmentId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (overrideShelfSegment) setShelfSegment(overrideShelfSegment);
    }, [
        overrideShelfSegment
    ]);
    const fetchImage = async ()=>{
        if (!shelfSegment || !shelfSegment.hasImage) return;
        const response = await getImage({
            name: shelfSegment.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageWidth,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageHeight
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        shelfSegmentId,
        shelfSegment?.hasImage,
        shelfSegment?.thumbnail
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).segment,
        style: {
            border: "5px solid transparent",
            borderImage: `url(${(0, $36b1843853ab03b4$export$76250962427778b).getThemeImage(shelving.theme)}) 100`,
            flexDirection: shelving.orientation == "horizontal" ? "column" : "row",
            backgroundImage: `url(${(0, $36b1843853ab03b4$export$76250962427778b).getThemeImage(shelving.theme)})`,
            backgroundColor: "rgba(0,0,0,0.7)",
            backgroundBlendMode: "darken",
            backgroundRepeat: "repeat",
            justifyContent: isLoading ? "center" : "normal",
            height: shelving.orientation == "horizontal" ? "auto" : "100%",
            width: shelving.orientation == "horizontal" ? "100%" : "auto"
        },
        children: [
            shelfSegment?.hasImage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).backgroundImage,
                image: image,
                thumbnail: shelfSegment?.thumbnail,
                defaultImage: undefined,
                beforeLoad: fetchImage,
                alt: ""
            }),
            !isLoadingShelfSegment ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$423ec2075359570a), {
                droppableId: `shelf_${shelfSegmentId}_${shelvingIndex}_${shelfIndex}_${segmentIndex}`,
                direction: shelving.orientation,
                children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).segment,
                        style: {
                            borderColor: theme.palette.colors?.highlightSpine
                        },
                        direction: shelving.orientation == "horizontal" ? "row" : "column",
                        ref: provided.innerRef,
                        ...provided.droppableProps,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).albumsContainer,
                                style: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    marginTop: "auto",
                                    width: shelving.orientation == "horizontal" ? undefined : "100%",
                                    height: shelving.orientation == "horizontal" ? "100%" : undefined,
                                    minWidth: shelving.orientation == "horizontal" ? "120px" : undefined,
                                    minHeight: shelving.orientation == "horizontal" ? undefined : "120px"
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).albumsDiv,
                                    style: {
                                        width: shelving.orientation == "horizontal" ? undefined : "100%",
                                        height: shelving.orientation == "horizontal" ? "100%" : undefined,
                                        padding: isMobile ? "0" : shelving.orientation == "horizontal" ? "0 2px 0 2px" : "2px 0 2px 0"
                                    },
                                    direction: shelving.orientation == "horizontal" ? "row" : "column",
                                    spacing: 0.07,
                                    children: shelfSegment?.albums?.sort((a, b)=>a.order - b.order).map((shelfSegmentAlbum, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
                                            draggableId: `drag_${shelfSegmentId}_${shelfSegmentAlbum.album.uuid}_${shelvingIndex}_${shelfIndex}_${segmentIndex}_${index}`,
                                            index: index,
                                            isDragDisabled: isLoading,
                                            children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                    title: albumDetail(shelfSegmentAlbum.album),
                                                    disableInteractive: true,
                                                    followCursor: true,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: shelving.orientation == "horizontal" ? (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).albumContainerHorizontal : (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).albumContainerVertical,
                                                        onContextMenu: (event)=>{
                                                            setSelectedAlbum(shelfSegmentAlbum);
                                                            setSelectedSegmentIndex(segmentIndex);
                                                            setSelectedAlbumIndex(index);
                                                            handleContextMenu(event);
                                                        },
                                                        ref: provided.innerRef,
                                                        ...provided.draggableProps,
                                                        ...provided.dragHandleProps,
                                                        onClick: ()=>{
                                                            setSelectedAlbum(shelfSegmentAlbum);
                                                            setSelectedSegmentIndex(segmentIndex);
                                                            setSelectedAlbumIndex(index);
                                                            if (selectedAlbumIds.length == 1 && selectedAlbumIds[0] == shelfSegmentAlbum.album.uuid) onShelfSegmentAlbumSelected(undefined);
                                                            else onShelfSegmentAlbumSelected(shelfSegmentAlbum);
                                                        },
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $314efd7a27edc986$export$d1ccba150acbb675), {
                                                            shelving: shelving,
                                                            shelfSegmentAlbum: shelfSegmentAlbum,
                                                            isHighlighted: selectedAlbumIds.includes(shelfSegmentAlbum.album.uuid)
                                                        })
                                                    })
                                                })
                                        }, `seg_${shelfSegmentId}_${shelfSegmentAlbum.album.uuid}_${index}`))
                                })
                            }),
                            provided.placeholder
                        ]
                    })
            }, `st_${shelfSegmentId}`) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                animation: "wave",
                style: {
                    height: "100%",
                    width: "100%",
                    transform: "none"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    selectedAlbum && albumDetail(selectedAlbum.album),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                        style: {
                            marginTop: "6px",
                            marginBottom: "4px"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await openOnPrivateCollection();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FeatureSearch
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).option_view_detail
                        ]
                    }, "OpenOnPrivateCollection"),
                    canRemove && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onRemoveAlbumFromShelfSegment(selectedAlbum, selectedSegmentIndex, selectedAlbumIndex);
                        },
                        style: {
                            color: theme.palette.colors?.remove
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    style: {
                                        color: theme.palette.colors?.remove
                                    },
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_remove_album
                        ]
                    }, "Remove")
                ]
            }),
            showOptions && !isLoadingShelfSegment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eeaf0ae78a579fae$export$dd95e972bd94f841), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).hoverButton, (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).hoverButtonRadius),
                    buttonClassName: (0, (/*@__PURE__*/$parcel$interopDefault($a9ab9d31e3a7e986$exports))).hoverButtonRadius,
                    style: {
                        backgroundColor: theme.palette.colors?.counterBackground
                    },
                    shelvings: shelvings,
                    setShelvings: setShelvings,
                    shelving: shelving,
                    shelf: shelf,
                    shelfSegment: shelfSegment,
                    setIsLoading: setIsLoading,
                    onModifyShelf: onModifyShelf,
                    onModifyShelfSegment: onModifyShelfSegment,
                    onModifyShelving: onModifyShelving,
                    onFocus: onFocus,
                    onStats: ()=>setIsStatsDialogOpen(true),
                    onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccc334ca611084ca$export$dbf8ababda40e4fe), {
                open: isStatsDialogOpen,
                setOpen: setIsStatsDialogOpen,
                shelfSegment: shelfSegment,
                shelf: shelf,
                shelving: shelving
            })
        ]
    }, `li_segment_${shelfSegmentId}`);
};


var $def35040cef6f203$exports = {};

$parcel$export($def35040cef6f203$exports, "shelf", function () { return $def35040cef6f203$export$28d1ddf33b35a9fb; }, function (v) { return $def35040cef6f203$export$28d1ddf33b35a9fb = v; });
var $def35040cef6f203$export$28d1ddf33b35a9fb;
$def35040cef6f203$export$28d1ddf33b35a9fb = `_97C4Qa_shelf`;


const $2e143bb5b2c35cb3$export$9449aee23f68efbd = ({ shelving: shelving, shelvings: shelvings, setShelvings: setShelvings, shelf: shelf, selectedShelfSegment: selectedShelfSegment, selectedAlbumIds: selectedAlbumIds, isLoading: isLoading, setIsLoading: setIsLoading, onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected, onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment, onShelfSegmentFetched: onShelfSegmentFetched, shelvingIndex: shelvingIndex, shelfIndex: shelfIndex, zoom: zoom, canRemove: canRemove, onModifyShelf: onModifyShelf, onModifyShelfSegment: onModifyShelfSegment, onModifyShelving: onModifyShelving, onFocus: onFocus, onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter, isMinimalist: isMinimalist })=>{
    const shelfSegmentRepresentation = (segment, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49cdbaed780e5b41$export$53c12b3445672e89), {
            shelving: shelving,
            shelvings: shelvings,
            setShelvings: setShelvings,
            shelf: shelf,
            shelfSegmentId: segment.uuid,
            overrideShelfSegment: segment,
            selectedAlbumIds: selectedAlbumIds,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected,
            onRemoveAlbumFromShelfSegment: (album, segmentIndex, albumIndex)=>onRemoveAlbumFromShelfSegment(album, shelfIndex, segmentIndex, albumIndex),
            onShelfSegmentFetched: (shelfSegment, segmentIndex)=>onShelfSegmentFetched(shelfSegment, shelfIndex, segmentIndex),
            shelvingIndex: shelvingIndex,
            shelfIndex: shelfIndex,
            segmentIndex: index,
            canRemove: canRemove,
            onModifyShelfSegment: onModifyShelfSegment,
            onModifyShelving: onModifyShelving,
            onModifyShelf: onModifyShelf,
            onFocus: onFocus,
            onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter,
            showOptions: !isMinimalist
        }, segment.uuid);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($def35040cef6f203$exports))).shelf,
        style: {
            width: shelving.orientation == "horizontal" ? "100%" : `${540 * zoom}px`,
            height: shelving.orientation == "horizontal" ? `${540 * zoom}px` : "100%",
            flexDirection: shelving.orientation == "horizontal" ? "row" : "column"
        },
        children: selectedShelfSegment ? shelfSegmentRepresentation(selectedShelfSegment, shelf.segments.map((segment)=>segment.uuid).indexOf(selectedShelfSegment.uuid)) : shelf.segments?.sort((a, b)=>a.order - b.order).map((segment, index)=>shelfSegmentRepresentation(segment, index))
    }, shelf.uuid);
};


var $2a83581d3646e374$exports = {};

$parcel$export($2a83581d3646e374$exports, "cabinet", function () { return $2a83581d3646e374$export$225c5bbdbed8c70f; }, function (v) { return $2a83581d3646e374$export$225c5bbdbed8c70f = v; });
$parcel$export($2a83581d3646e374$exports, "piperLogo", function () { return $2a83581d3646e374$export$8cacecdcbcc49d33; }, function (v) { return $2a83581d3646e374$export$8cacecdcbcc49d33 = v; });
var $2a83581d3646e374$export$225c5bbdbed8c70f;
var $2a83581d3646e374$export$8cacecdcbcc49d33;
$2a83581d3646e374$export$225c5bbdbed8c70f = `b2Oq3W_cabinet`;
$2a83581d3646e374$export$8cacecdcbcc49d33 = `b2Oq3W_piperLogo`;




const $8fbf35e241e47f55$export$99c7b0e6011ce70a = ({ shelving: shelving, shelvings: shelvings, setShelvings: setShelvings, selectedShelf: selectedShelf, selectedShelfSegment: selectedShelfSegment, selectedAlbumIds: selectedAlbumIds, isLoading: isLoading, setIsLoading: setIsLoading, onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected, onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment, onShelfSegmentFetched: onShelfSegmentFetched, shelvingIndex: shelvingIndex, zoom: zoom, onModifyShelf: onModifyShelf, onModifyShelfSegment: onModifyShelfSegment, onModifyShelving: onModifyShelving, onFocus: onFocus, onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter, isMinimalist: isMinimalist })=>{
    const piperLogo = new URL($3e80ee69e0c45c78$exports).href;
    const shelfRepresentation = (shelf, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e143bb5b2c35cb3$export$9449aee23f68efbd), {
            shelving: shelving,
            shelvings: shelvings,
            setShelvings: setShelvings,
            shelf: shelf,
            selectedShelfSegment: selectedShelfSegment,
            selectedAlbumIds: selectedAlbumIds,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            onShelfSegmentAlbumSelected: (shelfSegmentAlbum)=>{
                if (onShelfSegmentAlbumSelected) onShelfSegmentAlbumSelected(shelfSegmentAlbum);
            },
            onRemoveAlbumFromShelfSegment: (album, shelfIndex, segmentIndex, albumIndex)=>onRemoveAlbumFromShelfSegment(album, shelvingIndex, shelfIndex, segmentIndex, albumIndex),
            onShelfSegmentFetched: (shelfSegment, shelfIndex, shelfSegmentIndex)=>{
                if (onShelfSegmentFetched) onShelfSegmentFetched(shelfSegment, shelvingIndex, shelfIndex, shelfSegmentIndex);
            },
            shelvingIndex: shelvingIndex,
            shelfIndex: index,
            zoom: zoom,
            canRemove: onRemoveAlbumFromShelfSegment !== undefined,
            onModifyShelf: onModifyShelf,
            onModifyShelving: onModifyShelving,
            onModifyShelfSegment: onModifyShelfSegment,
            onFocus: onFocus,
            onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter,
            isMinimalist: isMinimalist
        }, shelf.uuid);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2a83581d3646e374$exports))).cabinet,
        style: {
            borderImage: `url(${(0, $36b1843853ab03b4$export$76250962427778b).getThemeImage(shelving.theme)}) 100`,
            flexDirection: shelving.orientation == "horizontal" ? "column" : "row",
            height: shelving.orientation == "horizontal" ? "fit-content" : "100%",
            width: shelving.orientation == "horizontal" ? "100%" : "fit-content"
        },
        children: [
            selectedShelf ? shelfRepresentation(selectedShelf, shelving?.shelves?.map((shelf)=>shelf.uuid).indexOf(selectedShelf.uuid)) : shelving?.shelves?.sort((a, b)=>a.order - b.order).map((shelf, index)=>shelfRepresentation(shelf, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2a83581d3646e374$exports))).piperLogo,
                src: piperLogo,
                alt: "piper"
            })
        ]
    });
};



var $0e45c3b04f9570ed$exports = {};

$parcel$export($0e45c3b04f9570ed$exports, "dialog", function () { return $0e45c3b04f9570ed$export$518824cf31321346; }, function (v) { return $0e45c3b04f9570ed$export$518824cf31321346 = v; });
$parcel$export($0e45c3b04f9570ed$exports, "shelving", function () { return $0e45c3b04f9570ed$export$90cbd767c1007fee; }, function (v) { return $0e45c3b04f9570ed$export$90cbd767c1007fee = v; });
$parcel$export($0e45c3b04f9570ed$exports, "shelvingDiv", function () { return $0e45c3b04f9570ed$export$40a4e5bfc0ee068f; }, function (v) { return $0e45c3b04f9570ed$export$40a4e5bfc0ee068f = v; });
$parcel$export($0e45c3b04f9570ed$exports, "zoomSlider", function () { return $0e45c3b04f9570ed$export$914596ab2d436db; }, function (v) { return $0e45c3b04f9570ed$export$914596ab2d436db = v; });
var $0e45c3b04f9570ed$export$518824cf31321346;
var $0e45c3b04f9570ed$export$90cbd767c1007fee;
var $0e45c3b04f9570ed$export$40a4e5bfc0ee068f;
var $0e45c3b04f9570ed$export$914596ab2d436db;
$0e45c3b04f9570ed$export$518824cf31321346 = `_80B-Fa_dialog`;
$0e45c3b04f9570ed$export$90cbd767c1007fee = `_80B-Fa_shelving`;
$0e45c3b04f9570ed$export$40a4e5bfc0ee068f = `_80B-Fa_shelvingDiv`;
$0e45c3b04f9570ed$export$914596ab2d436db = `_80B-Fa_zoomSlider`;




const $b0aa2a33e40c2b13$export$440f41a6564a1a83 = ({ album: album, shelfSegmentAlbum: shelfSegmentAlbum, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getShelving: getShelving } = (0, $effa6df78a1ddf8e$export$325b7b146b41f99)();
    const [shelving, setShelving] = (0, $7fPBF.useState)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [didMakeMove, setDidMakeMove] = (0, $7fPBF.useState)(false);
    const [zoom, setZoom] = (0, $7fPBF.useState)(0.5);
    (0, $7fPBF.useEffect)(()=>{
        if (!shelfSegmentAlbum) return;
        setShelving(undefined);
        fetchShelving().then();
    }, [
        shelfSegmentAlbum
    ]);
    const fetchShelving = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await getShelving(shelfSegmentAlbum.shelfSegment.shelf.shelving.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setShelving(body);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "lg",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        style: {
                            marginRight: 8
                        },
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_location_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0e45c3b04f9570ed$exports))).zoomSlider,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            spacing: 1,
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ZoomIn
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                    value: zoom,
                                    min: 0.23,
                                    max: 1.2,
                                    step: 0.01,
                                    onChange: (event, newValue)=>setZoom(newValue)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>setIsOpen(false),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                        loading: isLoading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$237bd83162c14364), {
                onDragEnd: ()=>{
                    if (didMakeMove) return;
                    setDidMakeMove(true);
                    setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).layout_cannot_move_message);
                    setIsAlertOpen(true);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0e45c3b04f9570ed$exports))).dialog,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        elevation: 15,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0e45c3b04f9570ed$exports))).shelving,
                        style: {
                            backgroundColor: theme.palette.background.default
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0e45c3b04f9570ed$exports))).shelvingDiv,
                            children: shelving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fbf35e241e47f55$export$99c7b0e6011ce70a), {
                                shelving: shelving,
                                shelvings: [
                                    shelving
                                ],
                                selectedShelf: undefined,
                                selectedShelfSegment: undefined,
                                selectedAlbumIds: [
                                    album.uuid
                                ],
                                isLoading: isLoading,
                                setIsLoading: setIsLoading,
                                shelvingIndex: 0,
                                zoom: zoom,
                                isMinimalist: true
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};



const $b39cc81912860b93$export$10f6cfa6df5f2a3a = ({ album: album, onLocationSelected: onLocationSelected })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [selectedShelfSegmentAlbum, setSelectedShelfSegmentAlbum] = (0, $7fPBF.useState)();
    const [isLocationDialogOpen, setIsLocationDialogOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e8b643777b4e29c2$exports))).list,
        children: [
            album.shelfSegments?.map((shelfSegmentAlbum, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ff37b8d029a5fd73$export$e5a116ed0239de1e), {
                            shelfSegmentAlbum: shelfSegmentAlbum,
                            onClick: ()=>{
                                if (onLocationSelected) onLocationSelected(shelfSegmentAlbum);
                                else {
                                    setSelectedShelfSegmentAlbum(shelfSegmentAlbum);
                                    setIsLocationDialogOpen(true);
                                }
                            }
                        }),
                        index < album.shelfSegments?.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                            color: theme.palette.background.paper
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0aa2a33e40c2b13$export$440f41a6564a1a83), {
                album: album,
                shelfSegmentAlbum: selectedShelfSegmentAlbum,
                isOpen: isLocationDialogOpen,
                setIsOpen: setIsLocationDialogOpen
            })
        ]
    });
};




parcelRequire("7fPBF");

var $fb4140811fdf7dc8$exports = {};

$parcel$export($fb4140811fdf7dc8$exports, "boxSet", function () { return $fb4140811fdf7dc8$export$6c9c7727542f24f0; }, function (v) { return $fb4140811fdf7dc8$export$6c9c7727542f24f0 = v; });
$parcel$export($fb4140811fdf7dc8$exports, "container", function () { return $fb4140811fdf7dc8$export$34e0f9847d4c02dd; }, function (v) { return $fb4140811fdf7dc8$export$34e0f9847d4c02dd = v; });
$parcel$export($fb4140811fdf7dc8$exports, "name", function () { return $fb4140811fdf7dc8$export$a8ff84c12d48cfa6; }, function (v) { return $fb4140811fdf7dc8$export$a8ff84c12d48cfa6 = v; });
var $fb4140811fdf7dc8$export$6c9c7727542f24f0;
var $fb4140811fdf7dc8$export$34e0f9847d4c02dd;
var $fb4140811fdf7dc8$export$a8ff84c12d48cfa6;
$fb4140811fdf7dc8$export$6c9c7727542f24f0 = `h39kaW_boxSet`;
$fb4140811fdf7dc8$export$34e0f9847d4c02dd = `h39kaW_container`;
$fb4140811fdf7dc8$export$a8ff84c12d48cfa6 = `h39kaW_name`;



const $1fe3e87c1121b248$export$24de6944b1cd6b7e = ({ boxSet: boxSet, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
        disableGutters: true,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            direction: "row",
            flexGrow: 1,
            spacing: 1,
            alignItems: "center",
            paddingRight: 1,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fb4140811fdf7dc8$exports))).name,
                    children: boxSet.name
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fb4140811fdf7dc8$exports))).boxSet,
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_title
                })
            ]
        })
    });
};





const $b5e05a68d4a8dd18$export$51461c925a272d78 = ({ album: album, onBoxSetSelected: onBoxSetSelected, onLocationSelected: onLocationSelected, hideHeader: hideHeader })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isLoading = album?.shelfSegments === undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($39a72bee5189ae5d$exports))).tableDiv,
            children: [
                !hideHeader && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($39a72bee5189ae5d$exports))).header,
                    direction: "row",
                    spacing: 2,
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                            disableTypography: true,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($39a72bee5189ae5d$exports))).title,
                            secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_location_title,
                            sx: {
                                flexGrow: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_layout,
                            iconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS],
                            loading: isLoading,
                            href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).layout()}`,
                            target: "_blank"
                        })
                    ]
                }),
                album && album.shelfSegments && album.shelfSegments.length > 0 || album && album.isInsideBoxSet && album.boxSet ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%",
                        borderWidth: "1.5px",
                        borderColor: theme.palette.background.paper,
                        borderStyle: "solid"
                    },
                    children: [
                        album.isInsideBoxSet && album.boxSet && !hideHeader && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1fe3e87c1121b248$export$24de6944b1cd6b7e), {
                                    boxSet: album.boxSet,
                                    onClick: onBoxSetSelected
                                }),
                                album.shelfSegments && album.shelfSegments.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                                    color: theme.palette.background.paper
                                })
                            ]
                        }),
                        album.shelfSegments && album.shelfSegments.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b39cc81912860b93$export$10f6cfa6df5f2a3a), {
                            album: album,
                            onLocationSelected: onLocationSelected
                        })
                    ]
                }) : isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($39a72bee5189ae5d$exports))).skeleton
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($39a72bee5189ae5d$exports))).noLocationText,
                    style: {
                        color: theme.palette.secondary.main
                    },
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_no_location
                })
            ]
        })
    });
};




var $7fPBF = parcelRequire("7fPBF");







var $f289aef4e91051fa$exports = {};

$parcel$export($f289aef4e91051fa$exports, "albumsText", function () { return $f289aef4e91051fa$export$8f134acaced3ad9b; }, function (v) { return $f289aef4e91051fa$export$8f134acaced3ad9b = v; });
$parcel$export($f289aef4e91051fa$exports, "albumsTitle", function () { return $f289aef4e91051fa$export$210ab402a6395edf; }, function (v) { return $f289aef4e91051fa$export$210ab402a6395edf = v; });
var $f289aef4e91051fa$export$8f134acaced3ad9b;
var $f289aef4e91051fa$export$210ab402a6395edf;
$f289aef4e91051fa$export$8f134acaced3ad9b = `PypZCq_albumsText`;
$f289aef4e91051fa$export$210ab402a6395edf = `PypZCq_albumsTitle`;






var $7fPBF = parcelRequire("7fPBF");



var $28267c49950cc37d$exports = {};

$parcel$export($28267c49950cc37d$exports, "cardContainer", function () { return $28267c49950cc37d$export$6b2d426110a11d7a; }, function (v) { return $28267c49950cc37d$export$6b2d426110a11d7a = v; });
$parcel$export($28267c49950cc37d$exports, "collectionCard", function () { return $28267c49950cc37d$export$63ab7202a5c80ed; }, function (v) { return $28267c49950cc37d$export$63ab7202a5c80ed = v; });
$parcel$export($28267c49950cc37d$exports, "collectionCardSkeleton", function () { return $28267c49950cc37d$export$40ce61452aefd388; }, function (v) { return $28267c49950cc37d$export$40ce61452aefd388 = v; });
$parcel$export($28267c49950cc37d$exports, "contentCard", function () { return $28267c49950cc37d$export$9261782d08389607; }, function (v) { return $28267c49950cc37d$export$9261782d08389607 = v; });
$parcel$export($28267c49950cc37d$exports, "hoverButton", function () { return $28267c49950cc37d$export$b0260c0afbf48c57; }, function (v) { return $28267c49950cc37d$export$b0260c0afbf48c57 = v; });
$parcel$export($28267c49950cc37d$exports, "hoverButtonsStack", function () { return $28267c49950cc37d$export$a8eacba2c33c9f28; }, function (v) { return $28267c49950cc37d$export$a8eacba2c33c9f28 = v; });
$parcel$export($28267c49950cc37d$exports, "loadingDiv", function () { return $28267c49950cc37d$export$dded2af20345efaa; }, function (v) { return $28267c49950cc37d$export$dded2af20345efaa = v; });
$parcel$export($28267c49950cc37d$exports, "searchBar", function () { return $28267c49950cc37d$export$f2ea4ab276c3e3fa; }, function (v) { return $28267c49950cc37d$export$f2ea4ab276c3e3fa = v; });
$parcel$export($28267c49950cc37d$exports, "toolbarBox", function () { return $28267c49950cc37d$export$6e129a9598cc724e; }, function (v) { return $28267c49950cc37d$export$6e129a9598cc724e = v; });
var $28267c49950cc37d$export$6b2d426110a11d7a;
var $28267c49950cc37d$export$63ab7202a5c80ed;
var $28267c49950cc37d$export$40ce61452aefd388;
var $28267c49950cc37d$export$9261782d08389607;
var $28267c49950cc37d$export$b0260c0afbf48c57;
var $28267c49950cc37d$export$a8eacba2c33c9f28;
var $28267c49950cc37d$export$dded2af20345efaa;
var $28267c49950cc37d$export$f2ea4ab276c3e3fa;
var $28267c49950cc37d$export$6e129a9598cc724e;
$28267c49950cc37d$export$6b2d426110a11d7a = `DOpOxa_cardContainer`;
$28267c49950cc37d$export$63ab7202a5c80ed = `DOpOxa_collectionCard`;
$28267c49950cc37d$export$40ce61452aefd388 = `DOpOxa_collectionCardSkeleton`;
$28267c49950cc37d$export$9261782d08389607 = `DOpOxa_contentCard`;
$28267c49950cc37d$export$b0260c0afbf48c57 = `DOpOxa_hoverButton`;
$28267c49950cc37d$export$a8eacba2c33c9f28 = `DOpOxa_hoverButtonsStack`;
$28267c49950cc37d$export$dded2af20345efaa = `DOpOxa_loadingDiv`;
$28267c49950cc37d$export$f2ea4ab276c3e3fa = `DOpOxa_searchBar`;
$28267c49950cc37d$export$6e129a9598cc724e = `DOpOxa_toolbarBox`;














var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");


var $539cda5b5616d55c$exports = {};

$parcel$export($539cda5b5616d55c$exports, "applyButton", function () { return $539cda5b5616d55c$export$2e26e6aca1d217d1; }, function (v) { return $539cda5b5616d55c$export$2e26e6aca1d217d1 = v; });
$parcel$export($539cda5b5616d55c$exports, "boxHeader", function () { return $539cda5b5616d55c$export$67350385bd9f1355; }, function (v) { return $539cda5b5616d55c$export$67350385bd9f1355 = v; });
$parcel$export($539cda5b5616d55c$exports, "container", function () { return $539cda5b5616d55c$export$34e0f9847d4c02dd; }, function (v) { return $539cda5b5616d55c$export$34e0f9847d4c02dd = v; });
$parcel$export($539cda5b5616d55c$exports, "description", function () { return $539cda5b5616d55c$export$6d59db4903f20f7d; }, function (v) { return $539cda5b5616d55c$export$6d59db4903f20f7d = v; });
$parcel$export($539cda5b5616d55c$exports, "filterComponent", function () { return $539cda5b5616d55c$export$e24197d2306a0970; }, function (v) { return $539cda5b5616d55c$export$e24197d2306a0970 = v; });
$parcel$export($539cda5b5616d55c$exports, "filterComponentTitle", function () { return $539cda5b5616d55c$export$1ee60884175a01e7; }, function (v) { return $539cda5b5616d55c$export$1ee60884175a01e7 = v; });
$parcel$export($539cda5b5616d55c$exports, "filterElementTitle", function () { return $539cda5b5616d55c$export$3fea2d6a22985afe; }, function (v) { return $539cda5b5616d55c$export$3fea2d6a22985afe = v; });
$parcel$export($539cda5b5616d55c$exports, "filterToggle", function () { return $539cda5b5616d55c$export$7b9da3cb826c471e; }, function (v) { return $539cda5b5616d55c$export$7b9da3cb826c471e = v; });
$parcel$export($539cda5b5616d55c$exports, "genericFilterTitle", function () { return $539cda5b5616d55c$export$18073cee17885796; }, function (v) { return $539cda5b5616d55c$export$18073cee17885796 = v; });
$parcel$export($539cda5b5616d55c$exports, "itemIcon", function () { return $539cda5b5616d55c$export$cfa784b45fc7b21d; }, function (v) { return $539cda5b5616d55c$export$cfa784b45fc7b21d = v; });
$parcel$export($539cda5b5616d55c$exports, "itemTitleStack", function () { return $539cda5b5616d55c$export$9de6d923ca1f3fbb; }, function (v) { return $539cda5b5616d55c$export$9de6d923ca1f3fbb = v; });
$parcel$export($539cda5b5616d55c$exports, "listItem", function () { return $539cda5b5616d55c$export$76c7e83ecc9cdf05; }, function (v) { return $539cda5b5616d55c$export$76c7e83ecc9cdf05 = v; });
$parcel$export($539cda5b5616d55c$exports, "loadingDiv", function () { return $539cda5b5616d55c$export$dded2af20345efaa; }, function (v) { return $539cda5b5616d55c$export$dded2af20345efaa = v; });
$parcel$export($539cda5b5616d55c$exports, "nameField", function () { return $539cda5b5616d55c$export$b6f1a49de680b8fc; }, function (v) { return $539cda5b5616d55c$export$b6f1a49de680b8fc = v; });
$parcel$export($539cda5b5616d55c$exports, "orderByCard", function () { return $539cda5b5616d55c$export$da90090447de5980; }, function (v) { return $539cda5b5616d55c$export$da90090447de5980 = v; });
$parcel$export($539cda5b5616d55c$exports, "orderTitle", function () { return $539cda5b5616d55c$export$ad0c1e4b8218a6aa; }, function (v) { return $539cda5b5616d55c$export$ad0c1e4b8218a6aa = v; });
$parcel$export($539cda5b5616d55c$exports, "toolbar", function () { return $539cda5b5616d55c$export$f727f52c778e92d5; }, function (v) { return $539cda5b5616d55c$export$f727f52c778e92d5 = v; });
var $539cda5b5616d55c$export$2e26e6aca1d217d1;
var $539cda5b5616d55c$export$67350385bd9f1355;
var $539cda5b5616d55c$export$34e0f9847d4c02dd;
var $539cda5b5616d55c$export$6d59db4903f20f7d;
var $539cda5b5616d55c$export$e24197d2306a0970;
var $539cda5b5616d55c$export$1ee60884175a01e7;
var $539cda5b5616d55c$export$3fea2d6a22985afe;
var $539cda5b5616d55c$export$7b9da3cb826c471e;
var $539cda5b5616d55c$export$18073cee17885796;
var $539cda5b5616d55c$export$cfa784b45fc7b21d;
var $539cda5b5616d55c$export$9de6d923ca1f3fbb;
var $539cda5b5616d55c$export$76c7e83ecc9cdf05;
var $539cda5b5616d55c$export$dded2af20345efaa;
var $539cda5b5616d55c$export$b6f1a49de680b8fc;
var $539cda5b5616d55c$export$da90090447de5980;
var $539cda5b5616d55c$export$ad0c1e4b8218a6aa;
var $539cda5b5616d55c$export$f727f52c778e92d5;
$539cda5b5616d55c$export$2e26e6aca1d217d1 = `Ot2KFW_applyButton`;
$539cda5b5616d55c$export$67350385bd9f1355 = `Ot2KFW_boxHeader`;
$539cda5b5616d55c$export$34e0f9847d4c02dd = `Ot2KFW_container`;
$539cda5b5616d55c$export$6d59db4903f20f7d = `Ot2KFW_description`;
$539cda5b5616d55c$export$e24197d2306a0970 = `Ot2KFW_filterComponent`;
$539cda5b5616d55c$export$1ee60884175a01e7 = `Ot2KFW_filterComponentTitle`;
$539cda5b5616d55c$export$3fea2d6a22985afe = `Ot2KFW_filterElementTitle`;
$539cda5b5616d55c$export$7b9da3cb826c471e = `Ot2KFW_filterToggle`;
$539cda5b5616d55c$export$18073cee17885796 = `Ot2KFW_genericFilterTitle`;
$539cda5b5616d55c$export$cfa784b45fc7b21d = `Ot2KFW_itemIcon`;
$539cda5b5616d55c$export$9de6d923ca1f3fbb = `Ot2KFW_itemTitleStack`;
$539cda5b5616d55c$export$76c7e83ecc9cdf05 = `Ot2KFW_listItem`;
$539cda5b5616d55c$export$dded2af20345efaa = `Ot2KFW_loadingDiv`;
$539cda5b5616d55c$export$b6f1a49de680b8fc = `Ot2KFW_nameField`;
$539cda5b5616d55c$export$da90090447de5980 = `Ot2KFW_orderByCard`;
$539cda5b5616d55c$export$ad0c1e4b8218a6aa = `Ot2KFW_orderTitle`;
$539cda5b5616d55c$export$f727f52c778e92d5 = `Ot2KFW_toolbar`;


const $c2b791cad8f6fb6e$export$2287ef8063e001a5 = ({ value: value, onChange: onChange })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isActive, setIsActive] = (0, $7fPBF.useState)(value);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
        value: isActive,
        exclusive: true,
        sx: {
            height: "30px",
            width: "100%"
        },
        onChange: (event, newValue)=>{
            if (newValue !== null) {
                if (value !== undefined) setIsActive(newValue);
                onChange(newValue);
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).filterToggle,
                sx: {
                    color: theme.palette.colors?.disabled,
                    width: "50%"
                },
                value: true,
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).filterToggle,
                sx: {
                    color: theme.palette.colors?.disabled,
                    width: "50%"
                },
                value: false,
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
            })
        ]
    });
};















parcelRequire("7fPBF");







const $5c7005bb835b2c46$export$96b51bdea54036ff = ({ filterElement: filterElement, isNegated: isNegated, onClick: onClick, onNegatedChange: onNegatedChange })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        justifyContent: "center",
        children: [
            filterElement.canBeNegated && onNegatedChange && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                onClick: ()=>onNegatedChange(!isNegated),
                sx: {
                    fontSize: "15px",
                    fontWeight: "normal",
                    padding: 0,
                    borderWidth: 1,
                    borderColor: theme.palette.colors?.border,
                    borderStyle: "solid",
                    borderRadius: "12px",
                    color: isNegated ? theme.palette.colors.remove : undefined,
                    height: "30px !important"
                },
                children: isNegated ? (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_is_not : (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_is
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).filterComponentTitle,
                sx: {
                    borderRadius: "12px !important",
                    borderWidth: 1,
                    borderColor: theme.palette.colors?.border,
                    borderStyle: "solid",
                    minHeight: "30px !important"
                },
                onClick: onClick,
                children: filterElement.filterType == (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IMPACT && filterElement.textValue ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        paddingLeft: 8
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $928fe652c90f9927$export$fc62ba923d2898ab), {
                        value: +filterElement.elementId
                    })
                }) : (filterElement.filterType == (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SLEEVE_GRADE || filterElement.filterType == (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).MEDIA_GRADE) && filterElement.textValue ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    style: {
                        paddingLeft: 8,
                        alignItems: "center"
                    },
                    direction: "row",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: (0, $b62e530123cc4921$export$465c3b2548d10f1a).getGoldmineGradePoints(+filterElement.elementId + 1)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c0a3cf7f5050c0a$export$c76d9c7d80725567), {
                            points: +filterElement.elementId + 1,
                            goldmineGrading: filterElement.textValue
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).genericFilterTitle,
                    style: {
                        color: filterElement.textValue ? theme.palette.primary.main : theme.palette.colors?.disabled
                    },
                    children: filterElement.textValue ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).no_value
                })
            })
        ]
    });
};














const $c16acc647c8c31a5$export$bac76f7af863918c = ({ isPublic: isPublic, initialFilterElements: initialFilterElements, initialIsNegated: initialIsNegated, onFilterChanged: onFilterChanged })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [leftChecked, setLeftChecked] = (0, $7fPBF.useState)([]);
    const [rightChecked, setRightChecked] = (0, $7fPBF.useState)([]);
    const [left, setLeft] = (0, $7fPBF.useState)([
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_artist_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ARTIST, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_album_format_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_FORMAT, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_sleeve_grade_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SLEEVE_GRADE, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_media_grade_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).MEDIA_GRADE, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_tag_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).TAG, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_sell_status_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_STATUS, true, true, undefined, undefined, (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_sell_status_title),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_label_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).LABEL, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_box_set_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).BOX_SET, true, false, "0"),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_clean_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_CLEAN, true, false, "0"),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_insert_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_INSERT, true, false, "0"),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_lyrics_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_LYRICS, true, false, "0"),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_gatefold_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_GATEFOLD, true, false, "0"),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_album_type_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_TYPE, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_store_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).STORE, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_impact_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IMPACT, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_sell_value_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_VALUE, true, true),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_country_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).COUNTRY, true, true, undefined, undefined, (0, $37bec70ed65ed924$export$21c51bc433c16634).country_placeholder),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_original_year_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ORIGINAL_YEAR, true, true, undefined, undefined, (0, $37bec70ed65ed924$export$21c51bc433c16634).original_year_placeholder),
        new (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942)((0, $37bec70ed65ed924$export$21c51bc433c16634).filter_release_year_title, (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).RELEASE_YEAR, true, true, undefined, undefined, (0, $37bec70ed65ed924$export$21c51bc433c16634).release_year_placeholder)
    ]);
    const [filterElements] = (0, $7fPBF.useState)(initialFilterElements);
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)(initialIsNegated);
    const [right, setRight] = (0, $7fPBF.useState)(initialFilterElements);
    const [selectedFilterElement, setSelectedFilterElement] = (0, $7fPBF.useState)();
    const [isAlbumFormatsDialogOpen, setIsAlbumFormatsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumTypesDialogOpen, setIsAlbumTypesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isTagsDialogOpen, setIsTagsDialogOpen] = (0, $7fPBF.useState)(false);
    const { state: genericAttributeDialogState, key: genericAttributeDialogKey, openAdd: openAddGenericAttributeDialog, close: closeGenericAttributeDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isArtistsDialogOpen, setIsArtistsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isStoresDialogOpen, setIsStoresDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLabelsDialogOpen, setIsLabelsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isImpactsDialogOpen, setIsImpactsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSleeveGradesDialogOpen, setIsSleeveGradesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isMediaGradesDialogOpen, setIsMediaGradesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSellValuesDialogOpen, setIsSellValuesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isOriginCountriesDialogOpen, setIsOriginCountriesDialogOpen] = (0, $7fPBF.useState)(false);
    const initializeCatering = ()=>{
        if (!isPublic || !currentPublicCollection) return;
        let newLeft = left;
        if (currentPublicCollection.bannedFields?.includes("label")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).LABEL);
        if (currentPublicCollection.bannedFields?.includes("isGatefold")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_GATEFOLD);
        if (currentPublicCollection.bannedFields?.includes("isClean")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_CLEAN);
        if (currentPublicCollection.bannedFields?.includes("store")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).STORE);
        if (currentPublicCollection.bannedFields?.includes("impact")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IMPACT);
        if (currentPublicCollection.bannedFields?.includes("sellValue")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_VALUE);
        if (currentPublicCollection.bannedFields?.includes("tags")) newLeft = newLeft.filter((element)=>element.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).TAG);
        setLeft(newLeft);
    };
    (0, $7fPBF.useEffect)(()=>{
        onFilterChanged(right, isNegated);
    }, [
        right,
        isNegated,
        selectedFilterElement
    ]);
    (0, $7fPBF.useEffect)(()=>{
        initializeCatering();
        setRight(filterElements);
    }, []);
    const handleToggle = (index, isLeft)=>()=>{
            const currentIndex = isLeft ? leftChecked.indexOf(index) : rightChecked.indexOf(index);
            const newChecked = isLeft ? [
                ...leftChecked
            ] : [
                ...rightChecked
            ];
            if (currentIndex === -1) newChecked.push(index);
            else newChecked.splice(currentIndex, 1);
            if (isLeft) setLeftChecked(newChecked);
            else setRightChecked(newChecked);
        };
    const handleCheckedRight = ()=>{
        leftChecked.forEach((index)=>{
            copyFilterElementFromCatering(left[index], left[index].elementId);
        });
        setLeftChecked([]);
    };
    const handleCheckedLeft = ()=>{
        setRight((right)=>right.filter((_filterElement, i)=>!rightChecked.includes(i)));
        setRightChecked([]);
    };
    const copyFilterElementFromCatering = (filterElement, elementId, textValue)=>{
        const newFilterElement = (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942).copy(filterElement);
        newFilterElement.elementId = elementId;
        newFilterElement.textValue = textValue;
        setRight((right)=>[
                ...right,
                newFilterElement
            ]);
    };
    const genericFilterComponent = (filterElement, isNegated, onClick)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c7005bb835b2c46$export$96b51bdea54036ff), {
            filterElement: filterElement,
            isNegated: isNegated,
            onClick: (event)=>{
                setSelectedFilterElement(filterElement);
                onClick(event);
            },
            onNegatedChange: (value)=>{
                switch(filterElement.filterType){
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_GATEFOLD:
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_INSERT:
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_LYRICS:
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_CLEAN:
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).BOX_SET:
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).STORE:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                storeId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).LABEL:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                labelId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IMPACT:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                impactId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SLEEVE_GRADE:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                sleeveGradeId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).MEDIA_GRADE:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                mediaGradeId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_VALUE:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                sellValueId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ARTIST:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                artistId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_TYPE:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                albumTypeId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_FORMAT:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                albumFormatId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).COUNTRY:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                originCountryId: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).RELEASE_YEAR:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                releaseYear: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ORIGINAL_YEAR:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                originalYear: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_STATUS:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                sellStatus: value
                            }));
                        break;
                    case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).TAG:
                        setIsNegated((isNegated)=>({
                                ...isNegated,
                                tagId: value
                            }));
                        break;
                }
            }
        });
    const filterElementComponent = (filterElement)=>{
        switch(filterElement.filterType){
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_GATEFOLD:
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_INSERT:
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).HAS_LYRICS:
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IS_CLEAN:
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).BOX_SET:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2b791cad8f6fb6e$export$2287ef8063e001a5), {
                    value: filterElement.isFromCatering ? undefined : filterElement.elementId == "1",
                    onChange: (newValue)=>{
                        if (filterElement.isFromCatering) copyFilterElementFromCatering(filterElement, newValue ? "1" : "0");
                        else setRight((right)=>right.map((rightFilterElement)=>{
                                if (rightFilterElement.filterType == filterElement.filterType) return {
                                    ...rightFilterElement,
                                    elementId: newValue ? "1" : "0"
                                };
                                else return rightFilterElement;
                            }));
                    }
                });
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ARTIST:
                return genericFilterComponent(filterElement, isNegated.artistId, ()=>setIsArtistsDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_FORMAT:
                return genericFilterComponent(filterElement, isNegated.albumFormatId, ()=>setIsAlbumFormatsDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ALBUM_TYPE:
                return genericFilterComponent(filterElement, isNegated.albumTypeId, ()=>setIsAlbumTypesDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).TAG:
                return genericFilterComponent(filterElement, isNegated.tagId, ()=>setIsTagsDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).STORE:
                return genericFilterComponent(filterElement, isNegated.storeId, ()=>setIsStoresDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).LABEL:
                return genericFilterComponent(filterElement, isNegated.labelId, ()=>setIsLabelsDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).IMPACT:
                return genericFilterComponent(filterElement, isNegated.impactId, ()=>setIsImpactsDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SLEEVE_GRADE:
                return genericFilterComponent(filterElement, isNegated.sleeveGradeId, ()=>setIsSleeveGradesDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).MEDIA_GRADE:
                return genericFilterComponent(filterElement, isNegated.mediaGradeId, ()=>setIsMediaGradesDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_VALUE:
                return genericFilterComponent(filterElement, isNegated.sellValueId, ()=>setIsSellValuesDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).COUNTRY:
                return genericFilterComponent(filterElement, isNegated.originCountryId, ()=>setIsOriginCountriesDialogOpen(true));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ORIGINAL_YEAR:
                return genericFilterComponent(filterElement, isNegated.originalYear, ()=>openAddGenericAttributeDialog());
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).RELEASE_YEAR:
                return genericFilterComponent(filterElement, isNegated.releaseYear, ()=>openAddGenericAttributeDialog());
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SELL_STATUS:
                return genericFilterComponent(filterElement, isNegated.sellStatus, (event)=>sellStatusHandleContextMenu(event));
            case (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).SEARCH_TEXT:
                return genericFilterComponent(filterElement, false, ()=>openAddGenericAttributeDialog());
        }
    };
    const customList = (items, isLeft)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
            sx: {
                flexGrow: 1,
                height: "100%",
                overflow: "auto",
                borderRadius: "12px"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).boxHeader,
                    style: {
                        backgroundColor: theme.palette.colors.filterHeaderBackground
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: isLeft ? (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_left_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_right_title
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                    dense: true,
                    component: "div",
                    role: "list",
                    children: items.map((filterElement, index)=>{
                        const labelId = `transfer-list-item-${index}-label`;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).listItem,
                                    role: "listitem",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                            onClick: handleToggle(index, isLeft),
                                            checked: isLeft ? leftChecked.indexOf(index) !== -1 : rightChecked.indexOf(index) !== -1,
                                            tabIndex: -1,
                                            size: "small",
                                            inputProps: {
                                                "aria-labelledby": labelId
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).filterComponent,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).itemTitleStack,
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: "6px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).itemIcon,
                                                            type: filterElement.iconType
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            id: labelId,
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).filterElementTitle,
                                                            style: {
                                                                color: theme.palette.primary.main
                                                            },
                                                            children: filterElement.title
                                                        })
                                                    ]
                                                }),
                                                filterElementComponent(filterElement)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, labelId);
                    })
                })
            ]
        });
    const updateSelectedFilterElement = (elementId, textValue)=>{
        if (selectedFilterElement) {
            if (selectedFilterElement.isFromCatering) copyFilterElementFromCatering(selectedFilterElement, elementId, textValue);
            else setRight((right)=>right.map((filterElement)=>{
                    if (filterElement == selectedFilterElement) return {
                        ...filterElement,
                        elementId: elementId,
                        textValue: textValue
                    };
                    else return filterElement;
                }));
        }
    };
    const switchButtons = (direction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: true,
            sx: {
                flexGrow: "0 !important",
                margin: "10px"
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: direction,
                alignItems: "center",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_to_filter,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                            sx: {
                                color: leftChecked.length === 0 ? theme.palette.colors?.disabled : theme.palette.primary.main,
                                backgroundColor: leftChecked.length === 0 ? theme.palette.colors?.appBar : theme.palette.background.paper
                            },
                            size: "small",
                            onClick: handleCheckedRight,
                            "aria-label": "move selected right",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: isMobile ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowDown : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowRight
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_from_filter,
                        arrow: true,
                        disableInteractive: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                            sx: {
                                color: rightChecked.length === 0 ? theme.palette.colors?.disabled : theme.palette.primary.main,
                                backgroundColor: rightChecked.length === 0 ? theme.palette.colors?.appBar : theme.palette.background.paper
                            },
                            size: "small",
                            onClick: handleCheckedLeft,
                            "aria-label": "move selected left",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: isMobile ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowUp : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardDoubleArrowLeft
                            })
                        })
                    })
                ]
            })
        });
    const { menuProps: sellStatusMenuProps, handleContextMenu: sellStatusHandleContextMenu, handleMenuClose: sellStatusHandleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 0,
        justifyContent: "center",
        alignItems: "center",
        sx: {
            height: "100%",
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                md: true,
                sx: {
                    height: isMobile ? 300 : "100%",
                    width: isMobile ? "100%" : "auto",
                    flexGrow: 1
                },
                children: customList(left, true)
            }),
            switchButtons(isMobile ? "row" : "column"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                md: true,
                sx: {
                    height: isMobile ? 300 : "100%",
                    width: isMobile ? "100%" : "auto",
                    flexGrow: 1
                },
                children: customList(right, false)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isArtistsDialogOpen,
                onClose: ()=>setIsArtistsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d963a2e56ac79bd1$export$c45b630b80b4cbe8), {
                    handleClose: ()=>{
                        setIsArtistsDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: selectedFilterElement?.elementId,
                    onArtistSelected: async (artist)=>{
                        setIsArtistsDialogOpen(false);
                        updateSelectedFilterElement(artist.uuid, artist.name);
                    },
                    onClearValue: ()=>{
                        setIsArtistsDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumFormatsDialogOpen,
                onClose: ()=>setIsAlbumFormatsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8eaae7a275eb790c$export$aab348bda21f9238), {
                    handleClose: ()=>{
                        setIsAlbumFormatsDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: selectedFilterElement?.elementId,
                    onAlbumFormatSelected: (albumFormat)=>{
                        setIsAlbumFormatsDialogOpen(false);
                        updateSelectedFilterElement(albumFormat.uuid, albumFormat.name);
                    },
                    onClearValue: ()=>{
                        setIsAlbumFormatsDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumTypesDialogOpen,
                onClose: ()=>setIsAlbumTypesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3545f666fd578acf$export$cdc91b52c28c8fd3), {
                    handleClose: ()=>{
                        setIsAlbumTypesDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: selectedFilterElement?.elementId,
                    onAlbumTypeSelected: (albumType)=>{
                        setIsAlbumTypesDialogOpen(false);
                        updateSelectedFilterElement(albumType.uuid, albumType.name);
                    },
                    onClearValue: ()=>{
                        setIsAlbumTypesDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isTagsDialogOpen,
                onClose: ()=>setIsTagsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cce4818f9f0c650e$export$cb8904e0fef9e4cd), {
                    handleClose: ()=>{
                        setIsTagsDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedIds: selectedFilterElement?.elementId ? [
                        selectedFilterElement.elementId
                    ] : undefined,
                    onTagSelected: (tag)=>{
                        setIsTagsDialogOpen(false);
                        updateSelectedFilterElement(tag.uuid, tag.name);
                    },
                    onClearValue: ()=>{
                        setIsTagsDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isStoresDialogOpen,
                onClose: ()=>setIsStoresDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c0c8fd0aacbcfe9$export$1f4e316d688f3260), {
                    handleClose: ()=>{
                        setIsStoresDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: selectedFilterElement?.elementId,
                    onStoreSelected: async (store)=>{
                        setIsStoresDialogOpen(false);
                        updateSelectedFilterElement(store.uuid, store.name);
                    },
                    onClearValue: async ()=>{
                        setIsStoresDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isLabelsDialogOpen,
                onClose: ()=>setIsLabelsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f56ce92a8b7d721$export$9451b0ecafcfb0be), {
                    handleClose: ()=>{
                        setIsLabelsDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: selectedFilterElement?.elementId,
                    onLabelSelected: async (label)=>{
                        setIsLabelsDialogOpen(false);
                        updateSelectedFilterElement(label.uuid, label.name);
                    },
                    onClearValue: async ()=>{
                        setIsLabelsDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isImpactsDialogOpen,
                onClose: ()=>setIsImpactsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $970fe01944d5ec2f$export$6c19d36d9b1bbf40), {
                    handleClose: ()=>{
                        setIsImpactsDialogOpen(false);
                    },
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: selectedFilterElement?.elementId ? +selectedFilterElement.elementId : undefined,
                    onImpactSelected: async (impact)=>{
                        setIsImpactsDialogOpen(false);
                        updateSelectedFilterElement(`${impact.id}`, impact.description);
                    },
                    onClearValue: ()=>{
                        setIsImpactsDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSleeveGradesDialogOpen,
                onClose: ()=>setIsSleeveGradesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c47ca10f45510f06$export$95ad13dd87903477), {
                    handleClose: ()=>{
                        setIsSleeveGradesDialogOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: selectedFilterElement?.elementId ? +selectedFilterElement.elementId : undefined,
                    onSleeveGradeSelected: async (sleeveGrade)=>{
                        setIsSleeveGradesDialogOpen(false);
                        updateSelectedFilterElement(`${sleeveGrade.id}`, sleeveGrade.goldmineGrade);
                    },
                    onClearValue: async ()=>{
                        setIsSleeveGradesDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isMediaGradesDialogOpen,
                onClose: ()=>setIsMediaGradesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46069ed848225382$export$4360e90a91115162), {
                    handleClose: ()=>{
                        setIsMediaGradesDialogOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: selectedFilterElement?.elementId ? +selectedFilterElement.elementId : undefined,
                    onMediaGradeSelected: async (mediaGrade)=>{
                        setIsMediaGradesDialogOpen(false);
                        updateSelectedFilterElement(`${mediaGrade.id}`, mediaGrade.goldmineGrade);
                    },
                    onClearValue: async ()=>{
                        setIsMediaGradesDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSellValuesDialogOpen,
                onClose: ()=>setIsSellValuesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70b19905e559553e$export$b70de0c9f92ac064), {
                    handleClose: ()=>{
                        setIsSellValuesDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: selectedFilterElement?.elementId,
                    onSellValueSelected: async (sellValue)=>{
                        setIsSellValuesDialogOpen(false);
                        updateSelectedFilterElement(sellValue.uuid, `(${sellValue.group}) ${currencyFormatter.format(sellValue.dollars, currentUserProfile, false, 2, "USD")}`);
                    },
                    onClearValue: async ()=>{
                        setIsSellValuesDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isOriginCountriesDialogOpen,
                onClose: ()=>setIsOriginCountriesDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c3726884ef77bb$export$7dfca6319ee13087), {
                    handleClose: ()=>{
                        setIsOriginCountriesDialogOpen(false);
                    },
                    isPublic: isPublic,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: selectedFilterElement?.elementId,
                    onOriginCountrySelected: async (originCountry)=>{
                        setIsOriginCountriesDialogOpen(false);
                        updateSelectedFilterElement(originCountry.uuid, originCountry.name);
                    },
                    onClearValue: async ()=>{
                        setIsOriginCountriesDialogOpen(false);
                        updateSelectedFilterElement(undefined, undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                title: (0, $4e580a0edacd4a22$export$d07f57595c356899)(selectedFilterElement?.title.toLowerCase() ?? ""),
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).generic_attribute_filter_description,
                placeholder: selectedFilterElement?.placeholder ?? "",
                value: selectedFilterElement?.textValue,
                missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                canClear: false,
                open: genericAttributeDialogState.mode !== "closed",
                onClose: closeGenericAttributeDialog,
                isNumber: false,
                onChange: (newValue)=>{
                    updateSelectedFilterElement(newValue, newValue);
                }
            }, genericAttributeDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...sellStatusMenuProps,
                children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getAllSellStatuses().map((sellStatus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            sellStatusHandleMenuClose();
                            updateSelectedFilterElement(sellStatus, (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(sellStatus));
                        },
                        dense: true,
                        children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(sellStatus)
                    }, sellStatus))
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
















const $d770713ca8a8afe1$export$1737516aa6af7a33 = ({ isPublic: isPublic, isOpen: isOpen, setIsOpen: setIsOpen, initialFilterElements: initialFilterElements, initialIsNegated: initialIsNegated, initialSortOption: initialSortOption, initialSortOrder: initialSortOrder, onFilterApplied: onFilterApplied })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [filterElements, setFilterElements] = (0, $7fPBF.useState)(initialFilterElements);
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)(initialIsNegated);
    const [sortOption, setSortOption] = (0, $7fPBF.useState)(initialSortOption);
    const [sortOrder, setSortOrder] = (0, $7fPBF.useState)(initialSortOrder);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [loading] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setFilterElements(initialFilterElements);
        setIsNegated(initialIsNegated);
        setSortOption(initialSortOption);
        setSortOrder(initialSortOrder);
    }, [
        isOpen,
        isPublic
    ]);
    const didMakeChanges = ()=>{
        return filterElements != initialFilterElements || isNegated != initialIsNegated || sortOption != initialSortOption || sortOrder != initialSortOrder;
    };
    const handleClose = ()=>{
        if (didMakeChanges()) {
            setIsConfirmCloseAlertOpen(true);
            return;
        }
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "md",
        open: isOpen,
        onClose: handleClose,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).container,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).toolbar,
                        sx: {
                            marginBottom: "0 !important"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                style: {
                                    color: theme.palette.primary.main
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_filter_albums
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.filterAlbums()}`,
                                target: "_blank",
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: loading,
                                onClick: handleClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).orderByCard,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: isMobile ? "column" : "row",
                            spacing: isMobile ? 1 : 2,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).orderTitle,
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).order_by_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                            value: sortOption,
                                            sx: {
                                                height: "36px",
                                                "& .MuiSelect-select": {
                                                    display: "flex",
                                                    alignItems: "center"
                                                }
                                            },
                                            size: "small",
                                            onChange: (event)=>setSortOption(event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ARTISTS]
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_title
                                                    ]
                                                }),
                                                (!isPublic || !currentPublicCollection?.bannedFields?.includes("label")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LABEL,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).LABELS]
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ORIGINAL_YEAR,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Event
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).original_year_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RELEASE_YEAR,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Event
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).release_year_title
                                                    ]
                                                }),
                                                (!isPublic || !currentPublicCollection?.bannedFields?.includes("store")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).STORE,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).STORES]
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).store_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).COUNTRY,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES]
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_title
                                                    ]
                                                }),
                                                currentUser?.role != "guest" && (!isPublic || !currentPublicCollection?.bannedFields?.includes("purchasePrice")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_PRICE,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Paid
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_title
                                                    ]
                                                }),
                                                currentUser?.role != "guest" && (!isPublic || !currentPublicCollection?.bannedFields?.includes("sellValue")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FinanceChip
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).sort_by_sell_value
                                                    ]
                                                }),
                                                currentUser?.role != "guest" && (!isPublic || !currentPublicCollection?.bannedFields?.includes("sellValue")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).SELL_VALUE_DOLLARS,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Paid
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).sort_by_sell_value_dollars
                                                    ]
                                                }),
                                                currentUser?.role != "guest" && (!isPublic || !currentPublicCollection?.bannedFields?.includes("revenue")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).REVENUE,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Wallet
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).revenue_title
                                                    ]
                                                }),
                                                currentUser?.role != "guest" && (!isPublic || !currentPublicCollection?.bannedFields?.includes("purchaseDate")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).PURCHASE_DATE,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CalendarMonth
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_date_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).TRACK_COUNT,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FormatListNumbered
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).track_count_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).LENGTH,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Timer
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Die
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).random_title
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).orderTitle,
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).order_direction_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                            value: sortOrder,
                                            sx: {
                                                height: "36px",
                                                "& .MuiSelect-select": {
                                                    display: "flex",
                                                    alignItems: "center"
                                                }
                                            },
                                            size: "small",
                                            disabled: sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM,
                                            onChange: (event)=>setSortOrder(event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ArrowUpwardAlt
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).order_asc_title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                    value: (0, $6768c4f2093234f5$export$145a24076dc97919).DESCENDANT,
                                                    dense: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ArrowDownwardAlt
                                                            })
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).order_desc_title
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c16acc647c8c31a5$export$bac76f7af863918c), {
                            isPublic: isPublic,
                            initialFilterElements: initialFilterElements,
                            initialIsNegated: initialIsNegated,
                            onFilterChanged: (filterElements, isNegated)=>{
                                setFilterElements(filterElements);
                                setIsNegated(isNegated);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($539cda5b5616d55c$exports))).applyButton,
                            onClick: ()=>{
                                setIsOpen(false);
                                if (didMakeChanges()) onFilterApplied(filterElements, isNegated, sortOption, sortOrder);
                            },
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).filter_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: ()=>setIsOpen(false),
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            })
        ]
    });
};







const $f815623831676d74$export$4ece8cf77fd0f980 = ({ open: open, onClose: onClose, onAlbumSelected: onAlbumSelected })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [filterElements, setFilterElements] = (0, $7fPBF.useState)([]);
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)((0, $c4f51e0bfb342785$export$83592602d06445ed)());
    const [sortOption, setSortOption] = (0, $7fPBF.useState)((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
    const [sortOrder, setSortOrder] = (0, $7fPBF.useState)((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
    const [isAlbumsFilterDialogOpen, setIsAlbumsFilterDialogOpen] = (0, $7fPBF.useState)(false);
    const [needMoreAlbums, setNeedMoreAlbums] = (0, $7fPBF.useState)(false);
    const { getSearchText: getSearchText, getFilterElementsWithSearchText: getFilterElementsWithSearchText } = (0, $228a7d38c61fd0fd$export$1fa08d0344d4319f)(false);
    const onError = (body)=>{
        setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    const isFilterUnapplied = ()=>{
        return (!filterElements || filterElements.length == 0) && sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST && sortOrder == (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT;
    };
    const [albums, , resetAlbumStorage, , , noMoreAlbums, isFetchingAlbums] = (0, $2738696e81957cce$export$93582110ed982a24)(open, "desktop", !isFilterUnapplied(), isNegated, (0, $024c4fa431281881$export$bda6e9c83e7e0f97).albums(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), setLoading, onError, undefined, filterElements, sortOption, sortOrder, [
        needMoreAlbums
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (open) {
            resetAlbumStorage();
            setNeedMoreAlbums((state)=>!state);
        }
    }, [
        open
    ]);
    const searchBar = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            direction: "row",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($28267c49950cc37d$exports))).searchBar,
                forceThisText: getSearchText(filterElements),
                onSearchRequested: (searchText)=>{
                    setFilterElements(getFilterElementsWithSearchText(searchText, filterElements));
                    resetAlbumStorage();
                    setNeedMoreAlbums((state)=>!state);
                },
                onSearchDismissed: ()=>{
                    setFilterElements(getFilterElementsWithSearchText("", filterElements));
                    resetAlbumStorage();
                    setNeedMoreAlbums((state)=>!state);
                },
                timed: true
            })
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: open,
        onClose: onClose,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                style: {
                    minHeight: "unset"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    style: {
                                        marginRight: 8
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural_title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($28267c49950cc37d$exports))).toolbarBox,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                            onClick: ()=>setIsAlbumsFilterDialogOpen(true),
                                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_filter_albums,
                                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAlt,
                                            highlighted: !isFilterUnapplied(),
                                            disabled: isFetchingAlbums
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                            orientation: "vertical",
                                            flexItem: true
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                            onClick: ()=>{
                                                setSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
                                                setSortOrder((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
                                                setFilterElements([]);
                                                resetAlbumStorage();
                                                setNeedMoreAlbums((state)=>!state);
                                            },
                                            disabled: isFilterUnapplied() || loading,
                                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_filter,
                                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAltOff,
                                            color: theme.palette.colors?.remove
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    loading: loading || isFetchingAlbums,
                                    onClick: onClose,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                })
                            ]
                        }),
                        searchBar()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($28267c49950cc37d$exports))).contentCard,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                    sx: {
                        padding: 0,
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf9b4cecdde85ae$export$ea09568aab55509f), {
                        albums: albums,
                        dragDropId: "",
                        isPublic: false,
                        sortOption: sortOption,
                        canMoveAlbums: false,
                        canDropAlbums: false,
                        canLoadMoreAlbums: true,
                        noMoreAlbums: noMoreAlbums,
                        setNeedMoreAlbums: ()=>setNeedMoreAlbums((state)=>!state),
                        onAlbumSelected: (album)=>{
                            onAlbumSelected(album);
                            onClose();
                        },
                        scrollToTopTrigger: false,
                        isForLayout: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d770713ca8a8afe1$export$1737516aa6af7a33), {
                isPublic: false,
                isOpen: isAlbumsFilterDialogOpen,
                setIsOpen: setIsAlbumsFilterDialogOpen,
                initialFilterElements: filterElements,
                initialIsNegated: isNegated,
                initialSortOption: sortOption,
                initialSortOrder: sortOrder,
                onFilterApplied: (filterElements, isNegated, sortOption, sortOrder)=>{
                    setIsNegated(isNegated);
                    setSortOption(sortOption);
                    setSortOrder(sortOrder);
                    setFilterElements(filterElements);
                    resetAlbumStorage();
                    setNeedMoreAlbums((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};


const $af80da7e8bdcf3c1$export$5cc9e77e228142db = ({ isPublic: isPublic, className: className, boxSet: boxSet, onDeleteFromBoxSet: onDeleteFromBoxSet, onAddAlbum: onAddAlbum, onAlbumSelected: onAlbumSelected, setLoading: setLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isAlbumsDesktopOpen, setIsAlbumsDesktopOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        elevation: 5,
        className: className,
        sx: {
            position: "relative",
            display: "flex",
            height: boxSet.boxSetAlbums.length > 0 ? "auto" : "100%",
            flexDirection: "column",
            alignSelf: isMobile ? "center" : "stretch"
        },
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f289aef4e91051fa$exports))).albumsTitle,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f289aef4e91051fa$exports))).albumsText,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_albums_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_album,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle,
                        onClick: ()=>setIsAlbumsDesktopOpen(true),
                        loading: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf9b4cecdde85ae$export$ea09568aab55509f), {
                dragDropId: "box",
                isBoxSetList: true,
                boxSetAlbumId: boxSet.uuid,
                albums: boxSet.boxSetAlbums ? [
                    boxSet.boxSetAlbums?.map((boxSetAlbum)=>boxSetAlbum.album) ?? []
                ] : undefined,
                isPublic: isPublic,
                sortOption: (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST,
                canMoveAlbums: true,
                canDropAlbums: true,
                canLoadMoreAlbums: false,
                noMoreAlbums: true,
                setNeedMoreAlbums: ()=>{
                //
                },
                onAlbumSelected: onAlbumSelected,
                onAlbumDeletedFromBoxSet: onDeleteFromBoxSet,
                scrollToTopTrigger: false,
                isForLayout: false,
                setLoading: setLoading
            }),
            boxSet.boxSetAlbums && boxSet.boxSetAlbums.length == 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                isLoading: false,
                items: [],
                emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ListAlt,
                emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_no_albums_title,
                emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_no_albums_description,
                searchText: "",
                canAdd: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f815623831676d74$export$4ece8cf77fd0f980), {
                open: isAlbumsDesktopOpen,
                onClose: ()=>setIsAlbumsDesktopOpen(false),
                onAlbumSelected: onAddAlbum
            }, `albums_desktop_${boxSet.uuid}`)
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");

var $733ac3966d47b3e1$exports = {};

$parcel$export($733ac3966d47b3e1$exports, "chips", function () { return $733ac3966d47b3e1$export$9f51660fd8227d80; }, function (v) { return $733ac3966d47b3e1$export$9f51660fd8227d80 = v; });
$parcel$export($733ac3966d47b3e1$exports, "collapse", function () { return $733ac3966d47b3e1$export$ec45920981e0ca9b; }, function (v) { return $733ac3966d47b3e1$export$ec45920981e0ca9b = v; });
$parcel$export($733ac3966d47b3e1$exports, "container", function () { return $733ac3966d47b3e1$export$34e0f9847d4c02dd; }, function (v) { return $733ac3966d47b3e1$export$34e0f9847d4c02dd = v; });
$parcel$export($733ac3966d47b3e1$exports, "insightDate", function () { return $733ac3966d47b3e1$export$678b62640ebab77f; }, function (v) { return $733ac3966d47b3e1$export$678b62640ebab77f = v; });
$parcel$export($733ac3966d47b3e1$exports, "insightDisclaimer", function () { return $733ac3966d47b3e1$export$3318fd4ba5c64f82; }, function (v) { return $733ac3966d47b3e1$export$3318fd4ba5c64f82 = v; });
$parcel$export($733ac3966d47b3e1$exports, "insightText", function () { return $733ac3966d47b3e1$export$10e3e5f979e292c0; }, function (v) { return $733ac3966d47b3e1$export$10e3e5f979e292c0 = v; });
$parcel$export($733ac3966d47b3e1$exports, "insightTitle", function () { return $733ac3966d47b3e1$export$64d0f4734c6de765; }, function (v) { return $733ac3966d47b3e1$export$64d0f4734c6de765 = v; });
$parcel$export($733ac3966d47b3e1$exports, "insightsStack", function () { return $733ac3966d47b3e1$export$9d8e6891aef87022; }, function (v) { return $733ac3966d47b3e1$export$9d8e6891aef87022 = v; });
$parcel$export($733ac3966d47b3e1$exports, "loadingDiv", function () { return $733ac3966d47b3e1$export$dded2af20345efaa; }, function (v) { return $733ac3966d47b3e1$export$dded2af20345efaa = v; });
$parcel$export($733ac3966d47b3e1$exports, "mainDiv", function () { return $733ac3966d47b3e1$export$16666caf1c4e1af1; }, function (v) { return $733ac3966d47b3e1$export$16666caf1c4e1af1 = v; });
$parcel$export($733ac3966d47b3e1$exports, "priceCard", function () { return $733ac3966d47b3e1$export$d1d20cf96520278; }, function (v) { return $733ac3966d47b3e1$export$d1d20cf96520278 = v; });
$parcel$export($733ac3966d47b3e1$exports, "priceText", function () { return $733ac3966d47b3e1$export$34f1a919494d5566; }, function (v) { return $733ac3966d47b3e1$export$34f1a919494d5566 = v; });
$parcel$export($733ac3966d47b3e1$exports, "refreshButton", function () { return $733ac3966d47b3e1$export$9e24a581e0b2a91f; }, function (v) { return $733ac3966d47b3e1$export$9e24a581e0b2a91f = v; });
$parcel$export($733ac3966d47b3e1$exports, "title", function () { return $733ac3966d47b3e1$export$fb184b623420d9be; }, function (v) { return $733ac3966d47b3e1$export$fb184b623420d9be = v; });
var $733ac3966d47b3e1$export$9f51660fd8227d80;
var $733ac3966d47b3e1$export$ec45920981e0ca9b;
var $733ac3966d47b3e1$export$34e0f9847d4c02dd;
var $733ac3966d47b3e1$export$678b62640ebab77f;
var $733ac3966d47b3e1$export$3318fd4ba5c64f82;
var $733ac3966d47b3e1$export$10e3e5f979e292c0;
var $733ac3966d47b3e1$export$64d0f4734c6de765;
var $733ac3966d47b3e1$export$9d8e6891aef87022;
var $733ac3966d47b3e1$export$dded2af20345efaa;
var $733ac3966d47b3e1$export$16666caf1c4e1af1;
var $733ac3966d47b3e1$export$d1d20cf96520278;
var $733ac3966d47b3e1$export$34f1a919494d5566;
var $733ac3966d47b3e1$export$9e24a581e0b2a91f;
var $733ac3966d47b3e1$export$fb184b623420d9be;
$733ac3966d47b3e1$export$9f51660fd8227d80 = `ZlIeGa_chips`;
$733ac3966d47b3e1$export$ec45920981e0ca9b = `ZlIeGa_collapse`;
$733ac3966d47b3e1$export$34e0f9847d4c02dd = `ZlIeGa_container`;
$733ac3966d47b3e1$export$678b62640ebab77f = `ZlIeGa_insightDate`;
$733ac3966d47b3e1$export$3318fd4ba5c64f82 = `ZlIeGa_insightDisclaimer`;
$733ac3966d47b3e1$export$10e3e5f979e292c0 = `ZlIeGa_insightText`;
$733ac3966d47b3e1$export$64d0f4734c6de765 = `ZlIeGa_insightTitle`;
$733ac3966d47b3e1$export$9d8e6891aef87022 = `ZlIeGa_insightsStack`;
$733ac3966d47b3e1$export$dded2af20345efaa = `ZlIeGa_loadingDiv`;
$733ac3966d47b3e1$export$16666caf1c4e1af1 = `ZlIeGa_mainDiv`;
$733ac3966d47b3e1$export$d1d20cf96520278 = `ZlIeGa_priceCard`;
$733ac3966d47b3e1$export$34f1a919494d5566 = `ZlIeGa_priceText`;
$733ac3966d47b3e1$export$9e24a581e0b2a91f = `ZlIeGa_refreshButton`;
$733ac3966d47b3e1$export$fb184b623420d9be = `ZlIeGa_title`;







const $5900b53010852449$export$1343704530d38b93 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (albumId, force)=>{
        let url = `ai/insights/album/${albumId}`;
        if (force) url = url.concat("?force=1");
        return await get(url);
    };
};






const $3641bda991b03726$export$72af407c9a24a863 = ({ album: album })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const getAlbumInsights = (0, $5900b53010852449$export$1343704530d38b93)();
    const [insights, setInsights] = (0, $7fPBF.useState)(undefined);
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const currentAlbumUuid = (0, $7fPBF.useRef)("");
    const fetchAlbumInsights = async (force)=>{
        setIsLoading(true);
        const albumId = album.uuid;
        const { status: status, body: body } = await getAlbumInsights(album.uuid, force);
        // Discard result if album changed
        if (albumId !== currentAlbumUuid.current) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setInsights(body);
            setIsExpanded(true);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        currentAlbumUuid.current = album.uuid;
        setInsights(undefined);
        setIsLoading(false);
        setIsExpanded(false);
    }, [
        album.uuid
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).mainDiv,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).container,
                onClick: ()=>{
                    if (isLoading) return;
                    if (!insights) fetchAlbumInsights(false).then();
                    else setIsExpanded(!isExpanded);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                    disableTypography: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).title,
                                    secondary: (0, $37bec70ed65ed924$export$21c51bc433c16634).insights_title,
                                    sx: {
                                        flexGrow: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightDisclaimer,
                                    style: {
                                        color: theme.palette.primary.subtitle
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).insights_disclaimer
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).loadingDiv,
                            children: isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: isExpanded ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowUp : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                            })
                        })
                    ]
                })
            }),
            insights && isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightsStack,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightText,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: insights.description
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightTitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).credits_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightText,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: insights.credits ?? "--"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightTitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).suggested_price_title
                    }),
                    insights.suggestedPrice && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        elevation: 2,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).priceCard,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).priceText,
                            style: {
                                fontWeight: "bold"
                            },
                            children: [
                                insights.suggestedPrice,
                                " USD"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightText,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: insights.suggestedPriceExplanation ?? "--"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).chips,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).genres_title,
                        chips: insights.musicGenres?.split(",").map((genre, index)=>{
                            return {
                                id: String(index),
                                name: genre
                            };
                        }),
                        addDisabled: true,
                        removeDisabled: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).chips,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).insights_tags_title,
                        chips: insights.tags?.split(",").map((tag, index)=>{
                            return {
                                id: String(index),
                                name: tag
                            };
                        }),
                        addDisabled: true,
                        removeDisabled: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightTitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).rarity_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightText,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: insights.rarity ?? "--"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).insightDate,
                        style: {
                            color: theme.palette.primary.subtitle
                        },
                        children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(insights.createdUnixTimestamp * 1000, "d MMMM yyyy, HH:mm", {
                            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                        })
                    })
                ]
            }),
            insights && isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($733ac3966d47b3e1$exports))).refreshButton,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ModelTraining,
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).insights_refresh,
                onClick: ()=>{
                    setInsights(undefined);
                    fetchAlbumInsights(true).then();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};







var $7fPBF = parcelRequire("7fPBF");









const $708552cad9964331$export$56ecdb9b07d333a7 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ album: album, defaultFrontImage: defaultFrontImage, isPublic: isPublic, size: size, disabled: disabled, onImageChanged: onImageChanged, isLoading: isLoading, setIsLoading: setIsLoading, setIsDragging: setIsDragging, shouldOpenFileDialog: shouldOpenFileDialog }, ref)=>{
    const [frontAlbumImage, setFrontAlbumImage] = (0, $7fPBF.useState)();
    const [albumImages, setAlbumImages] = (0, $7fPBF.useState)();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const { getAlbumImages: getAlbumImages } = (0, $7334d06cbe1ce63a$export$e8e6e7d723df6524)();
    const { getPublicAlbumImages: getPublicAlbumImages } = (0, $b09dbc49024ec7d9$export$1ccb383977f3c96c)();
    const firstRender = (0, $ee02f4605e174339$export$c5623aa1c38918b6)();
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    (0, $7fPBF.useEffect)(()=>{
        setImageFile(undefined);
    }, [
        isLoading
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, open: open } = (0, $c08bbb67d1713114$export$cd49c0ecc5be9f36)({
        accept: {
            "image/*": []
        },
        disabled: disabled,
        noClick: true,
        maxFiles: 1,
        onDrop: (acceptedFiles, filesRejection)=>{
            if (filesRejection.length > 0) {
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).upload_multiple_images_error);
                return;
            }
            const file = Object.assign(acceptedFiles[0], {
                preview: URL.createObjectURL(acceptedFiles[0])
            });
            setImageFile(file);
            onImageChanged(file);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (firstRender) return;
        open();
    }, [
        shouldOpenFileDialog
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (imageFile) return ()=>URL.revokeObjectURL(imageFile.preview);
    }, [
        imageFile
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setFrontAlbumImage({
            uuid: album.uuid,
            kind: "additional",
            description: "",
            thumbnail: album.thumbnail,
            hasImage: album.hasImage
        });
    }, [
        album.uuid,
        album.hasImage,
        album.thumbnail
    ]);
    const fetchCounter = (0, $7fPBF.useRef)(0);
    const fetchAlbumImages = async ()=>{
        const fetchId = ++fetchCounter.current;
        setAlbumImages(undefined);
        const { status: status, body: body } = await getAlbumImages({
            albumId: album.uuid
        });
        // A newer call has started since we did — discard unconditionally
        if (fetchId !== fetchCounter.current) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlbumImages(body);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
    };
    const fetchPublicAlbumImages = async ()=>{
        if (!currentPublicCollection) return;
        setAlbumImages(undefined);
        const { status: status, body: body } = await getPublicAlbumImages({
            albumId: album.uuid,
            collectionId: currentPublicCollection.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlbumImages(body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isPublic) fetchPublicAlbumImages().then();
        else fetchAlbumImages().then();
    }, [
        album.uuid
    ]);
    const album3DRepresentationRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>({
            reset: ()=>{
                album3DRepresentationRef.current?.reset();
            },
            refreshImages: ()=>{
                fetchAlbumImages().then(album3DRepresentationRef.current?.refreshImages);
            }
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        ...getRootProps(),
        style: {
            display: "flex",
            width: "100%",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $182235c40d2387e4$export$ac8c3b10d6fd5a3a), {
                ref: album3DRepresentationRef,
                frontCover: frontAlbumImage,
                backCover: albumImages?.back[0],
                spine: albumImages?.spine[0],
                size: size,
                defaultFrontImage: defaultFrontImage,
                isLoadingFrontCover: isLoading,
                setIsLoadingFrontCover: setIsLoading,
                setIsDragging: setIsDragging
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                ...getInputProps()
            })
        ]
    });
});



const $0f7fcbfd922a22ac$export$24c4ce0a92786a82 = ({ isPublic: isPublic, isLoadingSharedAlbum: isLoadingSharedAlbum, album: album, onAttributeUpdated: onAttributeUpdated, onArtistUpdated: onArtistUpdated, onPlayFromYouTube: onPlayFromYouTube, onNewAlbum: onNewAlbum, onScanBarcode: onScanBarcode, onImportFromDiscogs: onImportFromDiscogs, onImportFromExcel: onImportFromExcel, onFilterAlbums: onFilterAlbums, onRandomAlbums: onRandomAlbums, onChangeCollection: onChangeCollection, onEditProfile: onEditProfile, onCopy: onCopy, onDelete: onDelete, onMarkAs: onMarkAs, onDeleteFromBoxSet: onDeleteFromBoxSet, onAddAlbumToBoxSet: onAddAlbumToBoxSet, onAlbumSelected: onAlbumSelected, onBoxSetSelected: onBoxSetSelected, setLoading: setLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [currentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const { fetchTracks: fetchTracks } = (0, $a4cfc2af9eed3279$export$f286195870dcd4f8)();
    const { uploadFrontImageFromDiscogs: uploadFrontImageFromDiscogs } = (0, $d9f301eae0e595a9$export$5381c9f9836cd8ab)();
    const [isLoadingTrackList, setIsLoadingTrackList] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [albumImage, setAlbumImage] = (0, $7fPBF.useState)();
    const [isLoadingImage, setIsLoadingImage] = (0, $7fPBF.useState)(false);
    const [shouldOpenFileDialog, setShouldOpenFileDialog] = (0, $7fPBF.useState)(false);
    const [isImageGalleryDialogOpen, setIsImageGalleryDialogOpen] = (0, $7fPBF.useState)(false);
    const [isImageDetailDialogOpen, setIsImageDetailDialogOpen] = (0, $7fPBF.useState)(false);
    const [detailImageId, setDetailImageId] = (0, $7fPBF.useState)();
    const [detailImage, setDetailImage] = (0, $7fPBF.useState)();
    const [detailImageTitle, setDetailImageTitle] = (0, $7fPBF.useState)("");
    const [detailImageFilename, setDetailImageFilename] = (0, $7fPBF.useState)("");
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isDraggingImage, setIsDraggingImage] = (0, $7fPBF.useState)(false);
    const [isFetchImageConfirmationAlertOpen, setIsFetchImageConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    const currentAlbumUuid = (0, $7fPBF.useRef)("");
    const fetchAlbumImage = async ()=>{
        currentAlbumUuid.current = album?.uuid;
        setAlbumImage(undefined);
        if (album === undefined || !album.hasImage) {
            setIsLoadingImage(false);
            return;
        }
        setIsLoadingImage(true);
        const response = await getImage({
            name: album.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize
        });
        // Discard image if album changed
        if (currentAlbumUuid.current != album?.uuid) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setAlbumImage(response.body);
        else setAlbumImage(undefined);
        setIsLoadingImage(false);
    };
    const fetchTrackListFromDiscogs = async ()=>{
        if (album === undefined) return;
        setIsLoadingTrackList(true);
        const { status: status, body: body } = await fetchTracks(album.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album = body;
            onAttributeUpdated(body);
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).UNPROCESSABLE_ENTITY) {
            album.trackList = [];
            onAttributeUpdated(album);
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoadingTrackList(false);
    };
    const updateTrackList = async (newTrackList)=>{
        if (album === undefined) return;
        setIsLoadingTrackList(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            albumTracks: newTrackList
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_success);
            album.trackList = newTrackList;
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoadingTrackList(false);
    };
    const onOpenImageDetail = (id, image, title, filename)=>{
        setDetailImageId(id);
        setDetailImage(image);
        setDetailImageTitle(title);
        setDetailImageFilename(filename);
        setIsImageDetailDialogOpen(true);
    };
    const onImageFileChanged = async (file)=>{
        album3DRepresentationRef.current?.reset();
        setIsLoadingImage(true);
        const newThumbnail = await uploadImage({
            name: album.uuid,
            file: file
        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize);
        if (newThumbnail) {
            album.hasImage = true;
            album.thumbnail = newThumbnail;
            onAttributeUpdated(album);
            await fetchAlbumImage();
        }
        setIsLoadingImage(false);
    };
    const willFetchImageFromDiscogs = async ()=>{
        if (album.hasImage) setIsFetchImageConfirmationAlertOpen(true);
        else await fetchImageFromDiscogs();
    };
    const fetchImageFromDiscogs = async ()=>{
        if (isLoadingImage) return;
        setIsLoadingImage(true);
        const { status: status, body: body } = await uploadFrontImageFromDiscogs(album.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            album.hasImage = true;
            album.thumbnail = body;
            onAttributeUpdated(album);
            await fetchAlbumImage();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoadingImage(false);
    };
    const { checkDiscogsAccess: checkDiscogsAccess } = (0, $80d0eef5d5d87b2a$export$f0302bce0203d803)(setAlertMessage, setAlertIsOpen, setIsLoadingImage, willFetchImageFromDiscogs);
    (0, $7fPBF.useEffect)(()=>{
        fetchAlbumImage().then();
    }, [
        album?.uuid
    ]);
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    const album3DRepresentationRef = (0, $7fPBF.useRef)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).mainContainer,
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: [
            isLoadingSharedAlbum ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
                in: true,
                unmountOnExit: true,
                style: {
                    transitionDelay: "1000ms"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).loadingStack,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_shared_loading
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).progressBar,
                            variant: "indeterminate"
                        })
                    ]
                })
            }) : !album ? currentUser && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).noSelectionDiv,
                children: [
                    isPublic && currentPublicCollection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).publicCollectionCard,
                        elevation: 4,
                        style: {
                            backgroundColor: theme.palette.background.default
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).publicCollectionName,
                                children: currentPublicCollection.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).publicCollectionDescription,
                                style: {
                                    color: theme.palette.primary.subtitle
                                },
                                children: currentPublicCollection.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).shortcutsTitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $306f2255f4891854$export$408295e78e243e4b), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).shortcutsGrid,
                        isPublic: isPublic,
                        showAttributesShortcut: true,
                        onNewAlbum: onNewAlbum,
                        onScanBarcode: onScanBarcode,
                        onImportFromDiscogs: onImportFromDiscogs,
                        onImportFromExcel: onImportFromExcel,
                        onFilterAlbums: onFilterAlbums,
                        onRandomAlbums: onRandomAlbums,
                        onChangeCollection: onChangeCollection,
                        onEditProfile: onEditProfile
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).mainDiv,
                direction: isMobile ? "column" : "row",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        display: "flex",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).albumImageCard,
                                style: {
                                    width: isMobile ? "100%" : 360
                                },
                                onContextMenu: handleContextMenu,
                                ...handleLongPress,
                                children: [
                                    album.sellStatus && ![
                                        "new",
                                        "highlighted"
                                    ].includes(album.sellStatus) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).reservedBox,
                                        style: {
                                            width: currentUserProfile?.show3DModel ? "200px" : "100%",
                                            height: currentUserProfile?.show3DModel ? "80px" : "100%",
                                            borderRadius: currentUserProfile?.show3DModel ? "10px" : undefined,
                                            backgroundColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus)
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).reservedText,
                                            children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(album.sellStatus)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButtonsStack,
                                        style: {
                                            visibility: isDraggingImage ? "hidden" : undefined
                                        },
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_gallery,
                                                arrow: true,
                                                disableInteractive: true,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButton,
                                                    style: {
                                                        backgroundColor: theme.palette.colors?.counterBackground
                                                    },
                                                    onClick: ()=>setIsImageGalleryDialogOpen(true),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).GalleryThumbnail
                                                    })
                                                })
                                            }),
                                            albumImage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_view_image,
                                                arrow: true,
                                                disableInteractive: true,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButton,
                                                    style: {
                                                        backgroundColor: theme.palette.colors?.counterBackground
                                                    },
                                                    onClick: ()=>onOpenImageDetail(album.uuid, albumImage, album.name, album.name),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ImageSearch
                                                    })
                                                })
                                            }),
                                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).modify_front_image,
                                                arrow: true,
                                                disableInteractive: true,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButton,
                                                    style: {
                                                        backgroundColor: theme.palette.colors?.counterBackground
                                                    },
                                                    onClick: ()=>setShouldOpenFileDialog((state)=>!state),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                                    })
                                                })
                                            }),
                                            !isPublic && album?.discogsReleaseId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_image_from_discogs,
                                                arrow: true,
                                                disableInteractive: true,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButton,
                                                    style: {
                                                        backgroundColor: theme.palette.colors?.counterBackground
                                                    },
                                                    onClick: checkDiscogsAccess,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload
                                                    })
                                                })
                                            }),
                                            currentUserProfile?.show3DModel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).rotation_reset,
                                                arrow: true,
                                                disableInteractive: true,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).hoverButton,
                                                    style: {
                                                        backgroundColor: theme.palette.colors?.counterBackground
                                                    },
                                                    onClick: ()=>album3DRepresentationRef.current?.reset(),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Rotate90DegreesCcw
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !currentUserProfile?.show3DModel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                        disabled: isPublic || isLoadingImage,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).albumImage,
                                        onImageChanged: onImageFileChanged,
                                        placeholderImage: genericSleeveImage,
                                        isLoading: isLoadingImage,
                                        initialImage: albumImage ? `data:image/png;base64,${albumImage}` : album.thumbnail ? `data:image/png;base64,${album.thumbnail}` : undefined,
                                        shouldOpenFileDialog: shouldOpenFileDialog,
                                        onClick: ()=>setIsImageGalleryDialogOpen(true)
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $708552cad9964331$export$56ecdb9b07d333a7), {
                                        ref: album3DRepresentationRef,
                                        album: album,
                                        defaultFrontImage: albumImage ?? album.thumbnail,
                                        isPublic: isPublic,
                                        size: 360,
                                        disabled: isPublic || isLoadingImage,
                                        onImageChanged: onImageFileChanged,
                                        isLoading: isLoadingImage,
                                        setIsLoading: setIsLoadingImage,
                                        shouldOpenFileDialog: shouldOpenFileDialog,
                                        setIsDragging: setIsDraggingImage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cc717fec9921856f$export$862c6280e38b90b8), {
                                isPublic: isPublic,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).tracksHeader,
                                album: album,
                                onDiscogsIdUpdated: async (newValue)=>{
                                    if (newValue !== null && (album?.trackList == undefined || album?.trackList?.length == 0) && !album.isBoxSet) await fetchTrackListFromDiscogs();
                                    onAttributeUpdated(album);
                                },
                                onLengthUpdated: ()=>onAttributeUpdated(album),
                                onTracksUpdated: ()=>onAttributeUpdated(album),
                                onCopy: onCopy,
                                onMarkAs: onMarkAs,
                                onDelete: onDelete,
                                onPlayFromYouTube: (videoIds)=>onPlayFromYouTube(album.name, videoIds)
                            }),
                            !(isPublic && !album.trackList) && !album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c900586d38c94b37$export$2c37cd9700e5dda3), {
                                isPublic: isPublic,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).trackListMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).trackList,
                                album: album,
                                artistName: album.artist?.name,
                                albumName: album.name,
                                fetchFromDiscogsEnabled: album.discogsReleaseId !== undefined && album.discogsReleaseId != "",
                                isLoading: isLoadingTrackList,
                                onChange: async (newTrackList)=>{
                                    await updateTrackList(newTrackList);
                                    onAttributeUpdated(album);
                                },
                                onPlayFromYouTube: (videoIds)=>onPlayFromYouTube(album.name, videoIds),
                                onFetchTrackListFromDiscogs: fetchTrackListFromDiscogs
                            }, album.uuid),
                            album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af80da7e8bdcf3c1$export$5cc9e77e228142db), {
                                isPublic: isPublic,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).trackListMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).trackList,
                                boxSet: album,
                                onDeleteFromBoxSet: onDeleteFromBoxSet,
                                onAlbumSelected: onAlbumSelected,
                                setLoading: setLoading,
                                onAddAlbum: onAddAlbumToBoxSet
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                        disablePadding: true,
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).mobileList : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).list,
                        style: {
                            overflow: isMobile ? "unset" : "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).firstItemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).firstItemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25855f1c176c9751$export$d8d2a58d08eff6f8), {
                                    isPublic: isPublic,
                                    album: album,
                                    onNameUpdated: onAttributeUpdated,
                                    onArtistUpdated: onArtistUpdated
                                }, "header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $57fc72a256f9b57a$export$6cbc0d108846f901), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb3b592d5ad813c9$export$ed5201021402c0b5), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "year")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73441e452e2f1a8d$export$ef64003eecb70263), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "format")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ceb466222f534ad1$export$84cfd20e202eb3e8), {
                                    isPublic: isPublic,
                                    isMobile: isMobile,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "grades")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee18455eb7f008bb$export$fbcda3e36df6b7ab), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "financials")
                            }),
                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b5e05a68d4a8dd18$export$51461c925a272d78), {
                                    album: album,
                                    onBoxSetSelected: onBoxSetSelected
                                }, "location")
                            }),
                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef60c523474c6bc2$export$49aae62b63927b74), {
                                    album: album
                                }, "collections")
                            }),
                            !(isPublic && album.impact === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3439dd4b1f1a51bf$export$424e5f51baecfe5b), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "impact")
                            }),
                            !(isPublic && album.notes === undefined) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d183a274fd419e00$export$677c1b206168cc7a), {
                                    isPublic: isPublic,
                                    album: album,
                                    onAttributeUpdated: onAttributeUpdated
                                }, "notes")
                            }),
                            !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).itemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3641bda991b03726$export$72af407c9a24a863), {
                                    album: album
                                }, "insights")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                elevation: 5,
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).lastItemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).lastItemCard,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $726ce6f6af8bd5b7$export$878931e303b73396), {
                                    isPublic: isPublic,
                                    album: album
                                }, "messages")
                            }),
                            currentUserProfile?.shouldShowAlbumId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4e96c325254013e2$exports))).albumId,
                                style: {
                                    color: theme.palette.secondary.main
                                },
                                children: [
                                    "ID: ",
                                    album.uuid
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setIsImageGalleryDialogOpen(true);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).GalleryThumbnail
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).image_gallery
                        ]
                    }),
                    album && albumImage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                handleMenuClose();
                                onOpenImageDetail(album.uuid, albumImage, album.name, album.name);
                            },
                            dense: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ImageSearch
                                    })
                                }),
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).option_view_image
                            ]
                        })
                    }),
                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            setShouldOpenFileDialog((state)=>!state);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).modify_front_image
                        ]
                    }),
                    !isPublic && album?.discogsReleaseId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            await checkDiscogsAccess();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CloudDownload
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).fetch_image_from_discogs
                        ]
                    }),
                    currentUserProfile?.show3DModel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            album3DRepresentationRef.current?.reset();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Rotate90DegreesCcw
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).rotation_reset
                        ]
                    }),
                    !isPublic && album?.sellStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            handleMenuClose();
                            onMarkAs(null);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeepOff
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).remove_mark_title
                        ]
                    }, "RemoveMark")
                ]
            }),
            album && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $beaeb73e6622ec48$export$9357da8826bd187d), {
                isPublic: isPublic,
                album: album,
                isOpen: isImageGalleryDialogOpen,
                setIsOpen: setIsImageGalleryDialogOpen,
                onAlbumImageUpdated: async (albumImage)=>{
                    album.hasImage = true;
                    album.thumbnail = albumImage.thumbnail;
                    onAttributeUpdated(album);
                    await fetchAlbumImage();
                },
                onAdditionalAlbumImageUpdated: ()=>album3DRepresentationRef.current?.refreshImages(),
                onOpenImageDetail: onOpenImageDetail
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b13b03cfea5b48d2$export$688f021bd576577), {
                isPublic: isPublic,
                uuid: detailImageId,
                title: detailImageTitle,
                isOpen: isImageDetailDialogOpen,
                setIsOpen: setIsImageDetailDialogOpen,
                filename: detailImageFilename,
                image: detailImage
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).image_fetch_confirmation,
                open: isFetchImageConfirmationAlertOpen,
                setOpen: setIsFetchImageConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: fetchImageFromDiscogs
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $031f736f634066ca$exports = {};

$parcel$export($031f736f634066ca$exports, "booleansSection", function () { return $031f736f634066ca$export$9dc0f9268caf858; }, function (v) { return $031f736f634066ca$export$9dc0f9268caf858 = v; });
$parcel$export($031f736f634066ca$exports, "cancelButton", function () { return $031f736f634066ca$export$4ededb8e5b56a6fb; }, function (v) { return $031f736f634066ca$export$4ededb8e5b56a6fb = v; });
$parcel$export($031f736f634066ca$exports, "counter", function () { return $031f736f634066ca$export$e575061ef2a070eb; }, function (v) { return $031f736f634066ca$export$e575061ef2a070eb = v; });
$parcel$export($031f736f634066ca$exports, "dropzone", function () { return $031f736f634066ca$export$585d0a7a39ed94ea; }, function (v) { return $031f736f634066ca$export$585d0a7a39ed94ea = v; });
$parcel$export($031f736f634066ca$exports, "expandIconDiv", function () { return $031f736f634066ca$export$1c69b9f373ff3924; }, function (v) { return $031f736f634066ca$export$1c69b9f373ff3924 = v; });
$parcel$export($031f736f634066ca$exports, "itemContainer", function () { return $031f736f634066ca$export$23f0e7c6834ceacd; }, function (v) { return $031f736f634066ca$export$23f0e7c6834ceacd = v; });
$parcel$export($031f736f634066ca$exports, "itemTitle", function () { return $031f736f634066ca$export$19d20253129869a; }, function (v) { return $031f736f634066ca$export$19d20253129869a = v; });
$parcel$export($031f736f634066ca$exports, "loadingDiv", function () { return $031f736f634066ca$export$dded2af20345efaa; }, function (v) { return $031f736f634066ca$export$dded2af20345efaa = v; });
$parcel$export($031f736f634066ca$exports, "textField", function () { return $031f736f634066ca$export$c54b92c0bb02ba64; }, function (v) { return $031f736f634066ca$export$c54b92c0bb02ba64 = v; });
var $031f736f634066ca$export$9dc0f9268caf858;
var $031f736f634066ca$export$4ededb8e5b56a6fb;
var $031f736f634066ca$export$e575061ef2a070eb;
var $031f736f634066ca$export$585d0a7a39ed94ea;
var $031f736f634066ca$export$1c69b9f373ff3924;
var $031f736f634066ca$export$23f0e7c6834ceacd;
var $031f736f634066ca$export$19d20253129869a;
var $031f736f634066ca$export$dded2af20345efaa;
var $031f736f634066ca$export$c54b92c0bb02ba64;
$031f736f634066ca$export$9dc0f9268caf858 = `r3228G_booleansSection`;
$031f736f634066ca$export$4ededb8e5b56a6fb = `r3228G_cancelButton`;
$031f736f634066ca$export$e575061ef2a070eb = `r3228G_counter`;
$031f736f634066ca$export$585d0a7a39ed94ea = `r3228G_dropzone`;
$031f736f634066ca$export$1c69b9f373ff3924 = `r3228G_expandIconDiv`;
$031f736f634066ca$export$23f0e7c6834ceacd = `r3228G_itemContainer`;
$031f736f634066ca$export$19d20253129869a = `r3228G_itemTitle`;
$031f736f634066ca$export$dded2af20345efaa = `r3228G_loadingDiv`;
$031f736f634066ca$export$c54b92c0bb02ba64 = `r3228G_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");






const $5dbf7db1b02fd0a2$export$ef300a5e723fa926 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbum = (parameters)=>post("albums", parameters);
    return {
        addAlbum: addAlbum
    };
};



































const $5c808fedb1be9403$export$3680ec4d69de4745 = ({ open: open, setOpen: setOpen, callback: callback, isBoxSet: isBoxSet })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const { addAlbum: addAlbum } = (0, $5dbf7db1b02fd0a2$export$ef300a5e723fa926)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const { addAlbumContent: addAlbumContent } = (0, $aa0196ded690d0e7$export$88a074929bd53fa4)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isArtistDesktopOpen, setIsArtistDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isLabelDesktopOpen, setIsLabelDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumFormatDesktopOpen, setIsAlbumFormatDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumTypeDesktopOpen, setIsAlbumTypeDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isStoreDesktopOpen, setIsStoreDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isSellValueDesktopOpen, setIsSellValueDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isSleeveGradeDesktopOpen, setIsSleeveGradeDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isMediaGradeDesktopOpen, setIsMediaGradeDesktopOpen] = (0, $7fPBF.useState)(false);
    const [isOriginCountriesDesktopOpen, setIsOriginCountriesDesktopOpen] = (0, $7fPBF.useState)(false);
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else handleClose();
    };
    const handleClose = ()=>{
        setOpen(false);
        setImageFile(undefined);
        formik.resetForm();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing_short),
        purchasePrice: $57e52f3b537dfd4b$export$98e628dec113755e().typeError((0, $37bec70ed65ed924$export$21c51bc433c16634).field_invalid)
    });
    const initialValues = {
        name: "",
        artist: undefined,
        originCountry: undefined,
        originalYear: "",
        releaseYear: "",
        label: undefined,
        catalogueNumber: "",
        albumFormat: undefined,
        albumType: undefined,
        color: "",
        discCount: undefined,
        store: undefined,
        discogsId: "",
        length: undefined,
        trackCount: undefined,
        collection: undefined,
        isClean: false,
        hasLyrics: false,
        hasInsert: false,
        isGatefold: false,
        purchasePrice: "",
        sellValue: undefined,
        sleeveGrade: undefined,
        mediaGrade: undefined,
        purchaseDate: new Date()
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: initialValues,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async (values)=>{
            setIsLoading(true);
            let uuid = undefined;
            const { status: status, body: body } = await addAlbum({
                name: values.name,
                albumTypeId: values.albumType?.uuid,
                artistId: values.artist?.uuid,
                catalogueNumber: values.catalogueNumber,
                collections: values.collection ? [
                    values.collection
                ] : undefined,
                originCountryId: values.originCountry?.uuid,
                discogsReleaseId: values.discogsId,
                hasInsert: values.hasInsert,
                hasLyrics: values.hasLyrics,
                impactId: undefined,
                isClean: values.isClean,
                isGatefold: values.isGatefold,
                labelId: values.label?.uuid,
                length: values.length,
                mediaGradeId: values.mediaGrade?.id,
                order: -1,
                originalYear: values.originalYear == "" ? undefined : values.originalYear,
                purchaseDate: values.purchaseDate ? Math.floor(values.purchaseDate.getTime() / 1000) : undefined,
                purchasePrice: values.purchasePrice ? +values.purchasePrice : undefined,
                releaseYear: values.releaseYear == "" ? undefined : values.releaseYear,
                sellValueId: values.sellValue?.uuid,
                sleeveGradeId: values.sleeveGrade?.id,
                storeId: values.store?.uuid,
                tracks: values.trackCount,
                isBoxSet: isBoxSet
            });
            if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).CREATED) {
                uuid = body.uuid;
                if (didChangeImage && imageFile && uuid) {
                    const thumbnail = await uploadImage({
                        name: uuid,
                        file: imageFile
                    }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAlbumImageSize);
                    if (thumbnail) {
                        body.hasImage = true;
                        body.thumbnail = thumbnail;
                    }
                }
                if (values.discCount || values.albumFormat || values.color) // Create an album content
                await addAlbumContent({
                    albumId: uuid,
                    albumFormatId: values.albumFormat?.uuid,
                    color: values.color,
                    quantity: values.discCount,
                    type: "disc"
                });
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_created);
                (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("new_album_manual", {
                    user_id: currentUserProfile.userId,
                    album_id: uuid
                });
                callback?.(body);
                handleClose();
            } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                setAlertMessage(body.message);
                setIsPurchaseAlertOpen(true);
            } else {
                setAlertMessage(body.message);
                setIsAlertOpen(true);
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                open: open,
                onClose: tryToClose,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).new_box_set_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).ca_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.home("create")}`,
                                target: "_blank",
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        dividers: true,
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingLeft: isMobile ? 1 : 2,
                            paddingRight: isMobile ? 1 : 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 3,
                                sx: {
                                    marginTop: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).front_cover
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).dropzone,
                                                placeholderImage: genericSleeveImage,
                                                onImageChanged: (file)=>{
                                                    setImageFile(file);
                                                    setDidChangeImage(true);
                                                },
                                                isLoading: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                children: [
                                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title,
                                                    "*"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "name",
                                                    name: "name",
                                                    size: "small",
                                                    autoComplete: "albumName",
                                                    placeholder: isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_name_placeholder : (0, $37bec70ed65ed924$export$21c51bc433c16634).name_placeholder,
                                                    value: formik.values.name,
                                                    onChange: formik.handleChange,
                                                    autoFocus: !isMobile
                                                })
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "artist",
                                                            name: "artist",
                                                            size: "small",
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).artist_placeholder,
                                                            value: formik.values.artist?.name ?? "",
                                                            readOnly: true,
                                                            onClick: ()=>setIsArtistDesktopOpen(true),
                                                            enterAction: ()=>setIsArtistDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
                                in: isExpanded,
                                timeout: "auto",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "country",
                                                            name: "country",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_country_title,
                                                            value: formik.values.originCountry?.name ?? "",
                                                            onClick: ()=>setIsOriginCountriesDesktopOpen(true),
                                                            enterAction: ()=>setIsOriginCountriesDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).original_year_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).original_year_title,
                                                            value: formik.values.originalYear ? new Date(`${formik.values.originalYear}-06`) : null,
                                                            onChange: (date)=>{
                                                                const originalYear = date == null ? null : date.getFullYear();
                                                                formik.setFieldValue("originalYear", originalYear ? String(originalYear) : null).then();
                                                            },
                                                            format: "yyyy",
                                                            views: [
                                                                "year"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).release_year_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).release_year_title,
                                                            value: formik.values.releaseYear ? new Date(`${formik.values.releaseYear}-06`) : null,
                                                            onChange: (date)=>{
                                                                const releaseYear = date == null ? null : date.getFullYear();
                                                                formik.setFieldValue("releaseYear", releaseYear ? String(releaseYear) : null).then();
                                                            },
                                                            format: "yyyy",
                                                            views: [
                                                                "year"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).label_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "label",
                                                            name: "label",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ml_placeholder,
                                                            value: formik.values.label?.name ?? "",
                                                            onClick: ()=>setIsLabelDesktopOpen(true),
                                                            enterAction: ()=>setIsLabelDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).catalogue_number_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "catalogueNumber",
                                                            name: "catalogueNumber",
                                                            size: "small",
                                                            autoComplete: "catalogueNumber",
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).catalogue_number_placeholder,
                                                            value: formik.values.catalogueNumber,
                                                            onChange: formik.handleChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_format_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "albumFormat",
                                                            name: "albumFormat",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).maf_short_name_placeholder,
                                                            value: formik.values.albumFormat?.name ?? "",
                                                            onClick: ()=>setIsAlbumFormatDesktopOpen(true),
                                                            enterAction: ()=>setIsAlbumFormatDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_type_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "albumType",
                                                            name: "albumType",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).mat_placeholder,
                                                            value: formik.values.albumType?.name ?? "",
                                                            onClick: ()=>setIsAlbumTypeDesktopOpen(true),
                                                            enterAction: ()=>setIsAlbumTypeDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_singular_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "color",
                                                            name: "color",
                                                            size: "small",
                                                            autoComplete: "color",
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_placeholder,
                                                            value: formik.values.color,
                                                            onChange: formik.handleChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_count_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce83a575e7610c25$export$1b74141c5fe63a28), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).counter,
                                                        initialValue: 0,
                                                        minimumValue: 1,
                                                        nullable: true,
                                                        onValueChanged: (newValue)=>formik.setFieldValue("discCount", newValue)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).store_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "store",
                                                            name: "store",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ms_placeholder,
                                                            value: formik.values.store?.name ?? "",
                                                            onClick: ()=>setIsStoreDesktopOpen(true),
                                                            enterAction: ()=>setIsStoreDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_id_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "discogsId",
                                                            name: "discogsId",
                                                            autoComplete: "discogsId",
                                                            size: "small",
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).ma_discogs_id_placeholder,
                                                            value: formik.values.discogsId,
                                                            onChange: formik.handleChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_date_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_date_title,
                                                            value: formik.values.purchaseDate ?? null,
                                                            onChange: (newValue)=>formik.setFieldValue("purchaseDate", newValue)
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).track_count_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce83a575e7610c25$export$1b74141c5fe63a28), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).counter,
                                                        initialValue: 0,
                                                        minimumValue: 1,
                                                        nullable: true,
                                                        onValueChanged: (newValue)=>formik.setFieldValue("trackCount", newValue)
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe9f035dcd2ab465$export$e87860770d5b0984), {
                                                            id: "length",
                                                            name: "length",
                                                            size: "small",
                                                            onChange: (newValue)=>formik.setFieldValue("length", newValue),
                                                            defaultValue: formik.values.length
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                sm: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: isBoxSet ? (0, $37bec70ed65ed924$export$21c51bc433c16634).sleeve_grade_box_set_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).sleeve_grade_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "sleeveGrade",
                                                            name: "sleeveGrade",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).sleeve_grade_placeholder,
                                                            value: formik.values.sleeveGrade?.goldmineGrade ?? "",
                                                            onClick: ()=>setIsSleeveGradeDesktopOpen(true),
                                                            enterAction: ()=>setIsSleeveGradeDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                sm: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).media_grade_singular_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "mediaGrade",
                                                            name: "mediaGrade",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).media_grade_placeholder,
                                                            value: formik.values.mediaGrade?.goldmineGrade ?? "",
                                                            onClick: ()=>setIsMediaGradeDesktopOpen(true),
                                                            enterAction: ()=>setIsMediaGradeDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "collection",
                                                            name: "collection",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_name_placeholder,
                                                            value: formik.values.collection?.name ?? "",
                                                            onClick: ()=>setIsCollectionsDialogOpen(true),
                                                            enterAction: ()=>setIsCollectionsDialogOpen(true)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dabf552c7b045a24$export$171c84513d3b85f9), {
                                        isPublic: false,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).booleansSection,
                                        titleWeight: "bold",
                                        hideIsGatefold: isBoxSet,
                                        hideIsClean: false,
                                        isCleanLoading: false,
                                        isGatefoldLoading: false,
                                        hasLyricsLoading: false,
                                        hasInsertLoading: false,
                                        isGatefold: formik.values.isGatefold,
                                        hasInsert: formik.values.hasInsert,
                                        hasLyrics: formik.values.hasLyrics,
                                        isClean: formik.values.isClean,
                                        onIsGatefoldChanged: (newValue)=>formik.setFieldValue("isGatefold", newValue),
                                        onHasInsertChanged: (newValue)=>formik.setFieldValue("hasInsert", newValue),
                                        onHasLyricsChanged: (newValue)=>formik.setFieldValue("hasLyrics", newValue),
                                        onIsCleanChanged: (newValue)=>formik.setFieldValue("isClean", newValue)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "purchasePrice",
                                                            name: "purchasePrice",
                                                            size: "small",
                                                            autoComplete: "purchasePrice",
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_price_placeholder,
                                                            value: formik.values.purchasePrice,
                                                            onChange: formik.handleChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: true,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).itemTitle,
                                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).sell_value_title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).textField,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                            id: "sellValue",
                                                            name: "sellValue",
                                                            size: "small",
                                                            readOnly: true,
                                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).sell_value_title,
                                                            value: formik.values.sellValue?.group ?? "",
                                                            onClick: ()=>setIsSellValueDesktopOpen(true),
                                                            enterAction: ()=>setIsSellValueDesktopOpen(true)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($031f736f634066ca$exports))).expandIconDiv,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                    title: isExpanded ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shrink : (0, $37bec70ed65ed924$export$21c51bc433c16634).optional_attributes,
                                    arrow: true,
                                    disableInteractive: true,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                        onClick: ()=>setIsExpanded((state)=>!state),
                                        children: isExpanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowUp
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isArtistDesktopOpen,
                onClose: ()=>setIsArtistDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d963a2e56ac79bd1$export$c45b630b80b4cbe8), {
                    handleClose: ()=>{
                        setIsArtistDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: formik.values.artist?.uuid,
                    onArtistSelected: async (artist)=>{
                        setIsArtistDesktopOpen(false);
                        await formik.setFieldValue("artist", artist);
                    },
                    onClearValue: async ()=>{
                        setIsArtistDesktopOpen(false);
                        await formik.setFieldValue("artist", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isLabelDesktopOpen,
                onClose: ()=>setIsLabelDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f56ce92a8b7d721$export$9451b0ecafcfb0be), {
                    handleClose: ()=>{
                        setIsLabelDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: formik.values.label?.uuid,
                    onLabelSelected: async (label)=>{
                        setIsLabelDesktopOpen(false);
                        await formik.setFieldValue("label", label);
                    },
                    onClearValue: async ()=>{
                        setIsLabelDesktopOpen(false);
                        await formik.setFieldValue("label", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumFormatDesktopOpen,
                onClose: ()=>setIsAlbumFormatDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8eaae7a275eb790c$export$aab348bda21f9238), {
                    handleClose: ()=>{
                        setIsAlbumFormatDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: formik.values.albumFormat?.uuid,
                    onAlbumFormatSelected: async (albumFormat)=>{
                        setIsAlbumFormatDesktopOpen(false);
                        await formik.setFieldValue("albumFormat", albumFormat);
                    },
                    onClearValue: async ()=>{
                        setIsAlbumFormatDesktopOpen(false);
                        await formik.setFieldValue("albumFormat", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isAlbumTypeDesktopOpen,
                onClose: ()=>setIsAlbumTypeDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3545f666fd578acf$export$cdc91b52c28c8fd3), {
                    handleClose: ()=>{
                        setIsAlbumTypeDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4,
                    preselectedId: formik.values.albumType?.uuid,
                    onAlbumTypeSelected: async (albumType)=>{
                        setIsAlbumTypeDesktopOpen(false);
                        await formik.setFieldValue("albumType", albumType);
                    },
                    onClearValue: async ()=>{
                        setIsAlbumTypeDesktopOpen(false);
                        await formik.setFieldValue("albumType", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isStoreDesktopOpen,
                onClose: ()=>setIsStoreDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c0c8fd0aacbcfe9$export$1f4e316d688f3260), {
                    handleClose: ()=>{
                        setIsStoreDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: formik.values.store?.uuid,
                    onStoreSelected: async (store)=>{
                        setIsStoreDesktopOpen(false);
                        await formik.setFieldValue("store", store);
                    },
                    onClearValue: async ()=>{
                        setIsStoreDesktopOpen(false);
                        await formik.setFieldValue("store", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isOriginCountriesDesktopOpen,
                onClose: ()=>setIsOriginCountriesDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c3726884ef77bb$export$7dfca6319ee13087), {
                    handleClose: ()=>{
                        setIsOriginCountriesDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: formik.values.originCountry?.uuid,
                    onOriginCountrySelected: async (originCountry)=>{
                        setIsOriginCountriesDesktopOpen(false);
                        await formik.setFieldValue("originCountry", originCountry);
                    },
                    onClearValue: async ()=>{
                        setIsOriginCountriesDesktopOpen(false);
                        await formik.setFieldValue("originCountry", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSellValueDesktopOpen,
                onClose: ()=>setIsSellValueDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70b19905e559553e$export$b70de0c9f92ac064), {
                    handleClose: ()=>{
                        setIsSellValueDesktopOpen(false);
                    },
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4,
                    preselectedId: formik.values.sellValue?.uuid,
                    onSellValueSelected: async (sellValue)=>{
                        setIsSellValueDesktopOpen(false);
                        await formik.setFieldValue("sellValue", sellValue);
                    },
                    onClearValue: async ()=>{
                        setIsSellValueDesktopOpen(false);
                        await formik.setFieldValue("sellValue", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isSleeveGradeDesktopOpen,
                onClose: ()=>setIsSleeveGradeDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c47ca10f45510f06$export$95ad13dd87903477), {
                    handleClose: ()=>{
                        setIsSleeveGradeDesktopOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: formik.values.sleeveGrade?.id,
                    onSleeveGradeSelected: async (sleeveGrade)=>{
                        setIsSleeveGradeDesktopOpen(false);
                        await formik.setFieldValue("sleeveGrade", sleeveGrade);
                    },
                    onClearValue: async ()=>{
                        setIsSleeveGradeDesktopOpen(false);
                        await formik.setFieldValue("sleeveGrade", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isMediaGradeDesktopOpen,
                onClose: ()=>setIsMediaGradeDesktopOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46069ed848225382$export$4360e90a91115162), {
                    handleClose: ()=>{
                        setIsMediaGradeDesktopOpen(false);
                    },
                    columnWidth: isMobile ? 12 : 6,
                    preselectedId: formik.values.mediaGrade?.id,
                    onMediaGradeSelected: async (mediaGrade)=>{
                        setIsMediaGradeDesktopOpen(false);
                        await formik.setFieldValue("mediaGrade", mediaGrade);
                    },
                    onClearValue: async ()=>{
                        setIsMediaGradeDesktopOpen(false);
                        await formik.setFieldValue("mediaGrade", undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: false,
                canModifyCollections: false,
                displayStandardCollections: false,
                onCollectionSelected: async (collection)=>{
                    await formik.setFieldValue("collection", collection);
                },
                selectedCollections: [],
                forceLoading: false,
                canNegate: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: handleClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};














const $634bd4e2c1d0f775$export$ed78f3fcf760f407 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getSharedContent = (parameters)=>get("share/sharedContent", parameters);
    return {
        getSharedContent: getSharedContent
    };
};




var $7fPBF = parcelRequire("7fPBF");
"use client";
function $c48912b423983456$var$St(e, t) {
    const n = getComputedStyle(e), o = parseFloat(n.fontSize);
    return t * o;
}
function $c48912b423983456$var$vt(e, t) {
    const n = getComputedStyle(e.ownerDocument.documentElement), o = parseFloat(n.fontSize);
    return t * o;
}
function $c48912b423983456$var$bt(e) {
    return e / 100 * window.innerHeight;
}
function $c48912b423983456$var$zt(e) {
    return e / 100 * window.innerWidth;
}
function $c48912b423983456$var$xt(e) {
    switch(typeof e){
        case "number":
            return [
                e,
                "px"
            ];
        case "string":
            {
                const t = parseFloat(e);
                return e.endsWith("%") ? [
                    t,
                    "%"
                ] : e.endsWith("px") ? [
                    t,
                    "px"
                ] : e.endsWith("rem") ? [
                    t,
                    "rem"
                ] : e.endsWith("em") ? [
                    t,
                    "em"
                ] : e.endsWith("vh") ? [
                    t,
                    "vh"
                ] : e.endsWith("vw") ? [
                    t,
                    "vw"
                ] : [
                    t,
                    "%"
                ];
            }
    }
}
function $c48912b423983456$var$ie({ groupSize: e, panelElement: t, styleProp: n }) {
    let o;
    const [i, s] = $c48912b423983456$var$xt(n);
    switch(s){
        case "%":
            o = i / 100 * e;
            break;
        case "px":
            o = i;
            break;
        case "rem":
            o = $c48912b423983456$var$vt(t, i);
            break;
        case "em":
            o = $c48912b423983456$var$St(t, i);
            break;
        case "vh":
            o = $c48912b423983456$var$bt(i);
            break;
        case "vw":
            o = $c48912b423983456$var$zt(i);
            break;
    }
    return o;
}
function $c48912b423983456$var$T(e) {
    return parseFloat(e.toFixed(3));
}
function $c48912b423983456$var$ne({ group: e }) {
    const { orientation: t, panels: n } = e;
    return n.reduce((o, i)=>(o += t === "horizontal" ? i.element.offsetWidth : i.element.offsetHeight, o), 0);
}
function $c48912b423983456$var$ve(e) {
    const { panels: t } = e, n = $c48912b423983456$var$ne({
        group: e
    });
    return n === 0 ? t.map((o)=>({
            groupResizeBehavior: o.panelConstraints.groupResizeBehavior,
            collapsedSize: 0,
            collapsible: o.panelConstraints.collapsible === !0,
            defaultSize: void 0,
            disabled: o.panelConstraints.disabled,
            minSize: 0,
            maxSize: 100,
            panelId: o.id
        })) : t.map((o)=>{
        const { element: i, panelConstraints: s } = o;
        let u = 0;
        if (s.collapsedSize !== void 0) {
            const c = $c48912b423983456$var$ie({
                groupSize: n,
                panelElement: i,
                styleProp: s.collapsedSize
            });
            u = $c48912b423983456$var$T(c / n * 100);
        }
        let a;
        if (s.defaultSize !== void 0) {
            const c = $c48912b423983456$var$ie({
                groupSize: n,
                panelElement: i,
                styleProp: s.defaultSize
            });
            a = $c48912b423983456$var$T(c / n * 100);
        }
        let r = 0;
        if (s.minSize !== void 0) {
            const c = $c48912b423983456$var$ie({
                groupSize: n,
                panelElement: i,
                styleProp: s.minSize
            });
            r = $c48912b423983456$var$T(c / n * 100);
        }
        let l = 100;
        if (s.maxSize !== void 0) {
            const c = $c48912b423983456$var$ie({
                groupSize: n,
                panelElement: i,
                styleProp: s.maxSize
            });
            l = $c48912b423983456$var$T(c / n * 100);
        }
        return {
            groupResizeBehavior: s.groupResizeBehavior,
            collapsedSize: u,
            collapsible: s.collapsible === !0,
            defaultSize: a,
            disabled: s.disabled,
            minSize: r,
            maxSize: l,
            panelId: o.id
        };
    });
}
function $c48912b423983456$var$C(e, t = "Assertion error") {
    if (!e) throw Error(t);
}
function $c48912b423983456$var$be(e, t) {
    return Array.from(t).sort(e === "horizontal" ? $c48912b423983456$var$Pt : $c48912b423983456$var$wt);
}
function $c48912b423983456$var$Pt(e, t) {
    const n = e.element.offsetLeft - t.element.offsetLeft;
    return n !== 0 ? n : e.element.offsetWidth - t.element.offsetWidth;
}
function $c48912b423983456$var$wt(e, t) {
    const n = e.element.offsetTop - t.element.offsetTop;
    return n !== 0 ? n : e.element.offsetHeight - t.element.offsetHeight;
}
function $c48912b423983456$var$Ye(e) {
    return e !== null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function $c48912b423983456$var$Je(e, t) {
    return {
        x: e.x >= t.left && e.x <= t.right ? 0 : Math.min(Math.abs(e.x - t.left), Math.abs(e.x - t.right)),
        y: e.y >= t.top && e.y <= t.bottom ? 0 : Math.min(Math.abs(e.y - t.top), Math.abs(e.y - t.bottom))
    };
}
function $c48912b423983456$var$Lt({ orientation: e, rects: t, targetRect: n }) {
    const o = {
        x: n.x + n.width / 2,
        y: n.y + n.height / 2
    };
    let i, s = Number.MAX_VALUE;
    for (const u of t){
        const { x: a, y: r } = $c48912b423983456$var$Je(o, u), l = e === "horizontal" ? a : r;
        l < s && (s = l, i = u);
    }
    return $c48912b423983456$var$C(i, "No rect found"), i;
}
let $c48912b423983456$var$fe;
function $c48912b423983456$export$19f40a8263c07ba7() {
    return $c48912b423983456$var$fe === void 0 && (typeof matchMedia == "function" ? $c48912b423983456$var$fe = !!matchMedia("(pointer:coarse)").matches : $c48912b423983456$var$fe = !1), $c48912b423983456$var$fe;
}
function $c48912b423983456$var$Ze(e) {
    const { element: t, orientation: n, panels: o, separators: i } = e, s = $c48912b423983456$var$be(n, Array.from(t.children).filter($c48912b423983456$var$Ye).map((z)=>({
            element: z
        }))).map(({ element: z })=>z), u = [];
    let a = !1, r = !1, l = -1, c = -1, m = 0, p, S = [];
    {
        let z = -1;
        for (const f of s)f.hasAttribute("data-panel") && (z++, f.hasAttribute("data-disabled") || (m++, l === -1 && (l = z), c = z));
    }
    if (m > 1) {
        let z = -1;
        for (const f of s)if (f.hasAttribute("data-panel")) {
            z++;
            const d = o.find((h)=>h.element === f);
            if (d) {
                if (p) {
                    const h = p.element.getBoundingClientRect(), y = f.getBoundingClientRect();
                    let b;
                    if (r) {
                        const v = n === "horizontal" ? new DOMRect(h.right, h.top, 0, h.height) : new DOMRect(h.left, h.bottom, h.width, 0), g = n === "horizontal" ? new DOMRect(y.left, y.top, 0, y.height) : new DOMRect(y.left, y.top, y.width, 0);
                        switch(S.length){
                            case 0:
                                b = [
                                    v,
                                    g
                                ];
                                break;
                            case 1:
                                {
                                    const w = S[0], E = $c48912b423983456$var$Lt({
                                        orientation: n,
                                        rects: [
                                            h,
                                            y
                                        ],
                                        targetRect: w.element.getBoundingClientRect()
                                    });
                                    b = [
                                        w,
                                        E === h ? g : v
                                    ];
                                    break;
                                }
                            default:
                                b = S;
                                break;
                        }
                    } else S.length ? b = S : b = [
                        n === "horizontal" ? new DOMRect(h.right, y.top, y.left - h.right, y.height) : new DOMRect(y.left, h.bottom, y.width, y.top - h.bottom)
                    ];
                    for (const v of b){
                        let g = "width" in v ? v : v.element.getBoundingClientRect();
                        const w = $c48912b423983456$export$19f40a8263c07ba7() ? e.resizeTargetMinimumSize.coarse : e.resizeTargetMinimumSize.fine;
                        if (g.width < w) {
                            const L = w - g.width;
                            g = new DOMRect(g.x - L / 2, g.y, g.width + L, g.height);
                        }
                        if (g.height < w) {
                            const L = w - g.height;
                            g = new DOMRect(g.x, g.y - L / 2, g.width, g.height + L);
                        }
                        const E = z <= l || z > c;
                        !a && !E && u.push({
                            group: e,
                            groupSize: $c48912b423983456$var$ne({
                                group: e
                            }),
                            panels: [
                                p,
                                d
                            ],
                            separator: "width" in v ? void 0 : v,
                            rect: g
                        }), a = !1;
                    }
                }
                r = !1, p = d, S = [];
            }
        } else if (f.hasAttribute("data-separator")) {
            f.ariaDisabled !== null && (a = !0);
            const d = i.find((h)=>h.element === f);
            d ? S.push(d) : (p = void 0, S = []);
        } else r = !0;
    }
    return u;
}
class $c48912b423983456$var$Qe {
    #e = {};
    addListener(t, n) {
        const o = this.#e[t];
        return o === void 0 ? this.#e[t] = [
            n
        ] : o.includes(n) || o.push(n), ()=>{
            this.removeListener(t, n);
        };
    }
    emit(t, n) {
        const o = this.#e[t];
        if (o !== void 0) {
            if (o.length === 1) o[0].call(null, n);
            else {
                let i = !1, s = null;
                const u = Array.from(o);
                for(let a = 0; a < u.length; a++){
                    const r = u[a];
                    try {
                        r.call(null, n);
                    } catch (l) {
                        s === null && (i = !0, s = l);
                    }
                }
                if (i) throw s;
            }
        }
    }
    removeAllListeners() {
        this.#e = {};
    }
    removeListener(t, n) {
        const o = this.#e[t];
        if (o !== void 0) {
            const i = o.indexOf(n);
            i >= 0 && o.splice(i, 1);
        }
    }
}
let $c48912b423983456$var$ee = {
    cursorFlags: 0,
    state: "inactive"
};
const $c48912b423983456$var$ze = new $c48912b423983456$var$Qe();
function $c48912b423983456$var$W() {
    return $c48912b423983456$var$ee;
}
function $c48912b423983456$var$Rt(e) {
    return $c48912b423983456$var$ze.addListener("change", e);
}
function $c48912b423983456$var$Et(e) {
    const t = $c48912b423983456$var$ee, n = {
        ...$c48912b423983456$var$ee
    };
    n.cursorFlags = e, $c48912b423983456$var$ee = n, $c48912b423983456$var$ze.emit("change", {
        prev: t,
        next: n
    });
}
function $c48912b423983456$var$te(e) {
    const t = $c48912b423983456$var$ee;
    $c48912b423983456$var$ee = e, $c48912b423983456$var$ze.emit("change", {
        prev: t,
        next: e
    });
}
const $c48912b423983456$var$Mt = (e)=>e, $c48912b423983456$var$ye = ()=>{}, $c48912b423983456$var$et = 1, $c48912b423983456$var$tt = 2, $c48912b423983456$var$nt = 4, $c48912b423983456$var$ot = 8, $c48912b423983456$var$Ie = 3, $c48912b423983456$var$ke = 12;
let $c48912b423983456$var$de;
function $c48912b423983456$var$De() {
    return $c48912b423983456$var$de === void 0 && ($c48912b423983456$var$de = !1, typeof window < "u" && (window.navigator.userAgent.includes("Chrome") || window.navigator.userAgent.includes("Firefox")) && ($c48912b423983456$var$de = !0)), $c48912b423983456$var$de;
}
function $c48912b423983456$var$It({ cursorFlags: e, groups: t, state: n }) {
    let o = 0, i = 0;
    switch(n){
        case "active":
        case "hover":
            t.forEach((s)=>{
                if (!s.mutableState.disableCursor) switch(s.orientation){
                    case "horizontal":
                        o++;
                        break;
                    case "vertical":
                        i++;
                        break;
                }
            });
    }
    if (!(o === 0 && i === 0)) {
        switch(n){
            case "active":
                if (e && $c48912b423983456$var$De()) {
                    const s = (e & $c48912b423983456$var$et) !== 0, u = (e & $c48912b423983456$var$tt) !== 0, a = (e & $c48912b423983456$var$nt) !== 0, r = (e & $c48912b423983456$var$ot) !== 0;
                    if (s) return a ? "se-resize" : r ? "ne-resize" : "e-resize";
                    if (u) return a ? "sw-resize" : r ? "nw-resize" : "w-resize";
                    if (a) return "s-resize";
                    if (r) return "n-resize";
                }
                break;
        }
        return $c48912b423983456$var$De() ? o > 0 && i > 0 ? "move" : o > 0 ? "ew-resize" : "ns-resize" : o > 0 && i > 0 ? "grab" : o > 0 ? "col-resize" : "row-resize";
    }
}
const $c48912b423983456$var$Te = /* @__PURE__ */ new WeakMap();
function $c48912b423983456$var$xe(e) {
    if (!e.defaultView || !e.adoptedStyleSheets) return;
    let { prevStyle: t, styleSheet: n } = $c48912b423983456$var$Te.get(e) ?? {};
    n === void 0 && (n = new e.defaultView.CSSStyleSheet(), e.adoptedStyleSheets && (Object.isExtensible(e.adoptedStyleSheets) ? e.adoptedStyleSheets.push(n) : e.adoptedStyleSheets = [
        ...e.adoptedStyleSheets,
        n
    ]));
    const o = $c48912b423983456$var$W();
    switch(o.state){
        case "active":
        case "hover":
            {
                const i = $c48912b423983456$var$It({
                    cursorFlags: o.cursorFlags,
                    groups: o.hitRegions.map((u)=>u.group),
                    state: o.state
                }), s = `*, *:hover {cursor: ${i} !important; }`;
                if (t === s) return;
                t = s, i ? n.cssRules.length === 0 ? n.insertRule(s) : n.replaceSync(s) : n.cssRules.length === 1 && n.deleteRule(0);
                break;
            }
        case "inactive":
            t = void 0, n.cssRules.length === 1 && n.deleteRule(0);
            break;
    }
    $c48912b423983456$var$Te.set(e, {
        prevStyle: t,
        styleSheet: n
    });
}
let $c48912b423983456$var$F = /* @__PURE__ */ new Map();
const $c48912b423983456$var$it = new $c48912b423983456$var$Qe();
function $c48912b423983456$var$kt(e) {
    $c48912b423983456$var$F = new Map($c48912b423983456$var$F), $c48912b423983456$var$F.delete(e);
}
function $c48912b423983456$var$Oe(e, t) {
    for (const [n] of $c48912b423983456$var$F)if (n.id === e) return n;
}
function $c48912b423983456$var$H(e, t) {
    for (const [n, o] of $c48912b423983456$var$F)if (n.id === e) return o;
    if (t) throw Error(`Could not find data for Group with id ${e}`);
}
function $c48912b423983456$var$V() {
    return $c48912b423983456$var$F;
}
function $c48912b423983456$var$Pe(e, t) {
    return $c48912b423983456$var$it.addListener("groupChange", (n)=>{
        n.group.id === e && t(n);
    });
}
function $c48912b423983456$var$j(e, t, n) {
    const o = $c48912b423983456$var$F.get(e);
    $c48912b423983456$var$F = new Map($c48912b423983456$var$F), $c48912b423983456$var$F.set(e, t), $c48912b423983456$var$it.emit("groupChange", {
        group: e,
        isUserInteraction: n?.isUserInteraction === !0,
        prev: o,
        next: t
    });
}
function $c48912b423983456$var$rt(e) {
    const t = $c48912b423983456$var$W(), n = $c48912b423983456$var$V();
    let o = !1;
    switch(t.state){
        case "active":
            $c48912b423983456$var$te({
                cursorFlags: 0,
                state: "inactive"
            }), t.hitRegions.length > 0 && ($c48912b423983456$var$xe(e), o = !0, t.hitRegions.forEach((i)=>{
                if (!n.has(i.group)) return;
                const s = $c48912b423983456$var$H(i.group.id, !0);
                $c48912b423983456$var$j(i.group, s, {
                    isUserInteraction: !0
                });
            }));
    }
    return o;
}
function $c48912b423983456$var$Ge(e) {
    e.defaultPrevented || $c48912b423983456$var$rt(e.currentTarget);
}
function $c48912b423983456$var$Dt(e, t, n) {
    let o, i = {
        x: 1 / 0,
        y: 1 / 0
    };
    for (const s of t){
        const u = $c48912b423983456$var$Je(n, s.rect);
        switch(e){
            case "horizontal":
                u.x <= i.x && (o = s, i = u);
                break;
            case "vertical":
                u.y <= i.y && (o = s, i = u);
                break;
        }
    }
    return o ? {
        distance: i,
        hitRegion: o
    } : void 0;
}
function $c48912b423983456$var$Tt(e) {
    return e !== null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
function $c48912b423983456$var$Ot(e, t) {
    if (e === t) throw new Error("Cannot compare node with itself");
    const n = {
        a: $c48912b423983456$var$Ne(e),
        b: $c48912b423983456$var$Ne(t)
    };
    let o;
    for(; n.a.at(-1) === n.b.at(-1);)o = n.a.pop(), n.b.pop();
    $c48912b423983456$var$C(o, "Stacking order can only be calculated for elements with a common ancestor");
    const i = {
        a: $c48912b423983456$var$Fe($c48912b423983456$var$Ae(n.a)),
        b: $c48912b423983456$var$Fe($c48912b423983456$var$Ae(n.b))
    };
    if (i.a === i.b) {
        const s = o.childNodes, u = {
            a: n.a.at(-1),
            b: n.b.at(-1)
        };
        let a = s.length;
        for(; a--;){
            const r = s[a];
            if (r === u.a) return 1;
            if (r === u.b) return -1;
        }
    }
    return Math.sign(i.a - i.b);
}
const $c48912b423983456$var$Gt = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function $c48912b423983456$var$At(e) {
    const t = getComputedStyle($c48912b423983456$var$st(e) ?? e).display;
    return t === "flex" || t === "inline-flex";
}
function $c48912b423983456$var$Ft(e) {
    const t = getComputedStyle(e);
    return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || $c48912b423983456$var$At(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || $c48912b423983456$var$Gt.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function $c48912b423983456$var$Ae(e) {
    let t = e.length;
    for(; t--;){
        const n = e[t];
        if ($c48912b423983456$var$C(n, "Missing node"), $c48912b423983456$var$Ft(n)) return n;
    }
    return null;
}
function $c48912b423983456$var$Fe(e) {
    return e && Number(getComputedStyle(e).zIndex) || 0;
}
function $c48912b423983456$var$Ne(e) {
    const t = [];
    for(; e;)t.push(e), e = $c48912b423983456$var$st(e);
    return t;
}
function $c48912b423983456$var$st(e) {
    const { parentNode: t } = e;
    return $c48912b423983456$var$Tt(t) ? t.host : t;
}
function $c48912b423983456$var$Nt(e, t) {
    return e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y;
}
function $c48912b423983456$var$_t({ groupElement: e, hitRegion: t, pointerEventTarget: n }) {
    if (!$c48912b423983456$var$Ye(n) || n.contains(e) || e.contains(n)) return !0;
    if ($c48912b423983456$var$Ot(n, e) > 0) {
        let o = n;
        for(; o;){
            if (o.contains(e)) return !0;
            if ($c48912b423983456$var$Nt(o.getBoundingClientRect(), t)) return !1;
            o = o.parentElement;
        }
    }
    return !0;
}
function $c48912b423983456$var$we(e, t) {
    const n = [];
    return t.forEach((o, i)=>{
        if (i.disabled) return;
        const s = $c48912b423983456$var$Ze(i), u = $c48912b423983456$var$Dt(i.orientation, s, {
            x: e.clientX,
            y: e.clientY
        });
        u && u.distance.x <= 0 && u.distance.y <= 0 && $c48912b423983456$var$_t({
            groupElement: i.element,
            hitRegion: u.hitRegion.rect,
            pointerEventTarget: e.target
        }) && n.push(u.hitRegion);
    }), n;
}
function $c48912b423983456$var$$t(e, t) {
    if (e.length !== t.length) return !1;
    for(let n = 0; n < e.length; n++)if (e[n] != t[n]) return !1;
    return !0;
}
function $c48912b423983456$var$k(e, t, n = 0) {
    return Math.abs($c48912b423983456$var$T(e) - $c48912b423983456$var$T(t)) <= n;
}
function $c48912b423983456$var$A(e, t) {
    return $c48912b423983456$var$k(e, t) ? 0 : e > t ? 1 : -1;
}
function $c48912b423983456$var$Z({ overrideDisabledPanels: e, panelConstraints: t, prevSize: n, size: o }) {
    const { collapsedSize: i = 0, collapsible: s, disabled: u, maxSize: a = 100, minSize: r = 0 } = t;
    if (u && !e) return n;
    if ($c48912b423983456$var$A(o, r) < 0) {
        if (s) {
            const l = (i + r) / 2;
            $c48912b423983456$var$A(o, l) < 0 ? o = i : o = r;
        } else o = r;
    }
    return o = Math.min(a, o), o = $c48912b423983456$var$T(o), o;
}
function $c48912b423983456$var$le({ delta: e, initialLayout: t, panelConstraints: n, pivotIndices: o, prevLayout: i, trigger: s }) {
    if ($c48912b423983456$var$k(e, 0)) return t;
    const u = s === "imperative-api", a = Object.values(t), r = Object.values(i), l = [
        ...a
    ], [c, m] = o;
    $c48912b423983456$var$C(c != null, "Invalid first pivot index"), $c48912b423983456$var$C(m != null, "Invalid second pivot index");
    let p = 0;
    switch(s){
        case "keyboard":
            {
                const f = e < 0 ? m : c, d = n[f];
                $c48912b423983456$var$C(d, `Panel constraints not found for index ${f}`);
                const { collapsedSize: h = 0, collapsible: y, minSize: b = 0 } = d;
                if (y) {
                    const v = a[f];
                    if ($c48912b423983456$var$C(v != null, `Previous layout not found for panel index ${f}`), $c48912b423983456$var$k(v, h)) {
                        const g = b - v;
                        $c48912b423983456$var$A(g, Math.abs(e)) > 0 && (e = e < 0 ? 0 - g : g);
                    }
                }
            }
            {
                const f = e < 0 ? c : m, d = n[f];
                $c48912b423983456$var$C(d, `No panel constraints found for index ${f}`);
                const { collapsedSize: h = 0, collapsible: y, minSize: b = 0 } = d;
                if (y) {
                    const v = a[f];
                    if ($c48912b423983456$var$C(v != null, `Previous layout not found for panel index ${f}`), $c48912b423983456$var$k(v, b)) {
                        const g = v - h;
                        $c48912b423983456$var$A(g, Math.abs(e)) > 0 && (e = e < 0 ? 0 - g : g);
                    }
                }
            }
            break;
        default:
            {
                const f = e < 0 ? m : c, d = n[f];
                $c48912b423983456$var$C(d, `Panel constraints not found for index ${f}`);
                const h = a[f], { collapsible: y, collapsedSize: b, minSize: v } = d;
                if (y && $c48912b423983456$var$A(h, v) < 0) {
                    if (e > 0) {
                        const g = v - b, w = g / 2, E = h + e;
                        $c48912b423983456$var$A(E, v) < 0 && (e = $c48912b423983456$var$A(e, w) <= 0 ? 0 : g);
                    } else {
                        const g = v - b, w = 100 - g / 2, E = h - e;
                        $c48912b423983456$var$A(E, v) < 0 && (e = $c48912b423983456$var$A(100 + e, w) > 0 ? 0 : -g);
                    }
                }
                break;
            }
    }
    {
        const f = e < 0 ? 1 : -1;
        let d = e < 0 ? m : c, h = 0;
        for(;;){
            const b = a[d];
            $c48912b423983456$var$C(b != null, `Previous layout not found for panel index ${d}`);
            const g = $c48912b423983456$var$Z({
                overrideDisabledPanels: u,
                panelConstraints: n[d],
                prevSize: b,
                size: 100
            }) - b;
            if (h += g, d += f, d < 0 || d >= n.length) break;
        }
        const y = Math.min(Math.abs(e), Math.abs(h));
        e = e < 0 ? 0 - y : y;
    }
    {
        let d = e < 0 ? c : m;
        for(; d >= 0 && d < n.length;){
            const h = Math.abs(e) - Math.abs(p), y = a[d];
            $c48912b423983456$var$C(y != null, `Previous layout not found for panel index ${d}`);
            const b = y - h, v = $c48912b423983456$var$Z({
                overrideDisabledPanels: u,
                panelConstraints: n[d],
                prevSize: y,
                size: b
            });
            if (!$c48912b423983456$var$k(y, v) && (p += y - v, l[d] = v, p.toFixed(3).localeCompare(Math.abs(e).toFixed(3), void 0, {
                numeric: !0
            }) >= 0)) break;
            e < 0 ? d-- : d++;
        }
    }
    if ($c48912b423983456$var$$t(r, l)) return i;
    {
        const f = e < 0 ? m : c, d = a[f];
        $c48912b423983456$var$C(d != null, `Previous layout not found for panel index ${f}`);
        const h = d + p, y = $c48912b423983456$var$Z({
            overrideDisabledPanels: u,
            panelConstraints: n[f],
            prevSize: d,
            size: h
        });
        if (l[f] = y, !$c48912b423983456$var$k(y, h)) {
            let b = h - y, g = e < 0 ? m : c;
            for(; g >= 0 && g < n.length;){
                const w = l[g];
                $c48912b423983456$var$C(w != null, `Previous layout not found for panel index ${g}`);
                const E = w + b, L = $c48912b423983456$var$Z({
                    overrideDisabledPanels: u,
                    panelConstraints: n[g],
                    prevSize: w,
                    size: E
                });
                if ($c48912b423983456$var$k(w, L) || (b -= L - w, l[g] = L), $c48912b423983456$var$k(b, 0)) break;
                e > 0 ? g-- : g++;
            }
        }
    }
    const S = Object.values(l).reduce((f, d)=>d + f, 0);
    if (!$c48912b423983456$var$k(S, 100, 0.1)) return i;
    const z = Object.keys(i);
    return l.reduce((f, d, h)=>(f[z[h]] = d, f), {});
}
function $c48912b423983456$var$K(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(const n in e)if (t[n] === void 0 || $c48912b423983456$var$A(e[n], t[n]) !== 0) return !1;
    return !0;
}
function $c48912b423983456$var$X({ layout: e, panelConstraints: t }) {
    const n = Object.values(e), o = [
        ...n
    ], i = o.reduce((a, r)=>a + r, 0);
    if (o.length !== t.length) throw Error(`Invalid ${t.length} panel layout: ${o.map((a)=>`${a}%`).join(", ")}`);
    if (!$c48912b423983456$var$k(i, 100) && o.length > 0) for(let a = 0; a < t.length; a++){
        const r = o[a];
        $c48912b423983456$var$C(r != null, `No layout data found for index ${a}`);
        const l = 100 / i * r;
        o[a] = l;
    }
    let s = 0;
    for(let a = 0; a < t.length; a++){
        const r = n[a];
        $c48912b423983456$var$C(r != null, `No layout data found for index ${a}`);
        const l = o[a];
        $c48912b423983456$var$C(l != null, `No layout data found for index ${a}`);
        const c = $c48912b423983456$var$Z({
            overrideDisabledPanels: !0,
            panelConstraints: t[a],
            prevSize: r,
            size: l
        });
        l != c && (s += l - c, o[a] = c);
    }
    if (!$c48912b423983456$var$k(s, 0)) for(let a = 0; a < t.length; a++){
        const r = o[a];
        $c48912b423983456$var$C(r != null, `No layout data found for index ${a}`);
        const l = r + s, c = $c48912b423983456$var$Z({
            overrideDisabledPanels: !0,
            panelConstraints: t[a],
            prevSize: r,
            size: l
        });
        if (r !== c && (s -= c - r, o[a] = c, $c48912b423983456$var$k(s, 0))) break;
    }
    const u = Object.keys(e);
    return o.reduce((a, r, l)=>(a[u[l]] = r, a), {});
}
function $c48912b423983456$var$at({ groupId: e, panelId: t }) {
    const n = ()=>{
        const r = $c48912b423983456$var$V();
        for (const [l, { defaultLayoutDeferred: c, derivedPanelConstraints: m, layout: p, groupSize: S, separatorToPanels: z }] of r)if (l.id === e) return {
            defaultLayoutDeferred: c,
            derivedPanelConstraints: m,
            group: l,
            groupSize: S,
            layout: p,
            separatorToPanels: z
        };
        throw Error(`Group ${e} not found`);
    }, o = ()=>{
        const r = n().derivedPanelConstraints.find((l)=>l.panelId === t);
        if (r !== void 0) return r;
        throw Error(`Panel constraints not found for Panel ${t}`);
    }, i = ()=>{
        const r = n().group.panels.find((l)=>l.id === t);
        if (r !== void 0) return r;
        throw Error(`Layout not found for Panel ${t}`);
    }, s = ()=>{
        const r = n().layout[t];
        if (r !== void 0) return r;
        throw Error(`Layout not found for Panel ${t}`);
    }, u = ({ nextSize: r, panels: l, prevLayout: c, derivedPanelConstraints: m })=>{
        const p = s(), S = l.findIndex((h)=>h.id === t), z = S === 0, f = S === l.length - 1;
        if (f && r < p && (z || l.slice(0, S).every((h, y)=>{
            const b = m[y];
            return b?.collapsible && $c48912b423983456$var$k(b.collapsedSize, c[b.panelId]);
        }))) {
            const h = l.slice(0, S).reduce((y, b)=>y + c[b.id], 0);
            return {
                ...c,
                [t]: $c48912b423983456$var$T(100 - h)
            };
        }
        return $c48912b423983456$var$le({
            delta: f ? p - r : r - p,
            initialLayout: c,
            panelConstraints: m,
            pivotIndices: f ? [
                S - 1,
                S
            ] : [
                S,
                S + 1
            ],
            prevLayout: c,
            trigger: "imperative-api"
        });
    }, a = (r)=>{
        const l = s();
        if (r === l) return;
        const { defaultLayoutDeferred: c, derivedPanelConstraints: m, group: p, groupSize: S, layout: z, separatorToPanels: f } = n(), d = u({
            nextSize: r,
            panels: p.panels,
            prevLayout: z,
            derivedPanelConstraints: m
        }), h = $c48912b423983456$var$X({
            layout: d,
            panelConstraints: m
        });
        $c48912b423983456$var$K(z, h) || $c48912b423983456$var$j(p, {
            defaultLayoutDeferred: c,
            derivedPanelConstraints: m,
            groupSize: S,
            layout: h,
            separatorToPanels: f
        });
    };
    return {
        collapse: ()=>{
            const { collapsible: r, collapsedSize: l } = o(), { mutableValues: c } = i(), m = s();
            r && m !== l && (c.expandToSize = m, a(l));
        },
        expand: ()=>{
            const { collapsible: r, collapsedSize: l, minSize: c } = o(), { mutableValues: m } = i(), p = s();
            if (r && p === l) {
                let S = m.expandToSize ?? c;
                S === 0 && (S = 1), a(S);
            }
        },
        getSize: ()=>{
            const { group: r } = n(), l = s(), { element: c } = i(), m = r.orientation === "horizontal" ? c.offsetWidth : c.offsetHeight;
            return {
                asPercentage: l,
                inPixels: m
            };
        },
        isCollapsed: ()=>{
            const { collapsible: r, collapsedSize: l } = o(), c = s();
            return r && $c48912b423983456$var$k(l, c);
        },
        resize: (r)=>{
            const { group: l } = n(), { element: c } = i(), m = $c48912b423983456$var$ne({
                group: l
            }), p = $c48912b423983456$var$ie({
                groupSize: m,
                panelElement: c,
                styleProp: r
            }), S = $c48912b423983456$var$T(p / m * 100);
            a(S);
        }
    };
}
function $c48912b423983456$var$_e(e) {
    if (e.defaultPrevented) return;
    const t = $c48912b423983456$var$V();
    $c48912b423983456$var$we(e, t).forEach((o)=>{
        if (o.separator && !o.separator.disableDoubleClick) {
            const i = o.panels.find((s)=>s.panelConstraints.defaultSize !== void 0);
            if (i) {
                const s = i.panelConstraints.defaultSize, u = $c48912b423983456$var$at({
                    groupId: o.group.id,
                    panelId: i.id
                });
                u && s !== void 0 && (u.resize(s), e.preventDefault());
            }
        }
    });
}
function $c48912b423983456$var$pe(e) {
    const t = $c48912b423983456$var$V();
    for (const [n] of t)if (n.separators.some((o)=>o.element === e)) return n;
    throw Error("Could not find parent Group for separator element");
}
function $c48912b423983456$var$lt({ groupId: e }) {
    const t = ()=>{
        const n = $c48912b423983456$var$V();
        for (const [o, i] of n)if (o.id === e) return {
            group: o,
            ...i
        };
        throw Error(`Could not find Group with id "${e}"`);
    };
    return {
        getLayout () {
            const { defaultLayoutDeferred: n, layout: o } = t();
            return n ? {} : o;
        },
        setLayout (n) {
            const { defaultLayoutDeferred: o, derivedPanelConstraints: i, group: s, groupSize: u, layout: a, separatorToPanels: r } = t(), l = $c48912b423983456$var$X({
                layout: n,
                panelConstraints: i
            });
            return o ? a : ($c48912b423983456$var$K(a, l) || $c48912b423983456$var$j(s, {
                defaultLayoutDeferred: o,
                derivedPanelConstraints: i,
                groupSize: u,
                layout: l,
                separatorToPanels: r
            }), l);
        }
    };
}
function $c48912b423983456$var$B(e, t) {
    const n = $c48912b423983456$var$pe(e), o = $c48912b423983456$var$H(n.id, !0), i = n.separators.find((m)=>m.element === e);
    $c48912b423983456$var$C(i, "Matching separator not found");
    const s = o.separatorToPanels.get(i);
    $c48912b423983456$var$C(s, "Matching panels not found");
    const u = s.map((m)=>n.panels.indexOf(m)), r = $c48912b423983456$var$lt({
        groupId: n.id
    }).getLayout(), l = $c48912b423983456$var$le({
        delta: t,
        initialLayout: r,
        panelConstraints: o.derivedPanelConstraints,
        pivotIndices: u,
        prevLayout: r,
        trigger: "keyboard"
    }), c = $c48912b423983456$var$X({
        layout: l,
        panelConstraints: o.derivedPanelConstraints
    });
    $c48912b423983456$var$K(r, c) || $c48912b423983456$var$j(n, {
        defaultLayoutDeferred: o.defaultLayoutDeferred,
        derivedPanelConstraints: o.derivedPanelConstraints,
        groupSize: o.groupSize,
        layout: c,
        separatorToPanels: o.separatorToPanels
    }, // Keyboard resizes (arrow keys, Home/End, Enter collapse/expand) originate
    // from a real DOM event on the separator, so they are user interactions
    // just like pointer drags. This function is only reached from
    // onDocumentKeyDown. See #716.
    {
        isUserInteraction: !0
    });
}
function $c48912b423983456$var$$e(e) {
    if (e.defaultPrevented) return;
    const t = e.currentTarget, n = $c48912b423983456$var$pe(t);
    if (!n.disabled) switch(e.key){
        case "ArrowDown":
            e.preventDefault(), n.orientation === "vertical" && $c48912b423983456$var$B(t, 5);
            break;
        case "ArrowLeft":
            e.preventDefault(), n.orientation === "horizontal" && $c48912b423983456$var$B(t, -5);
            break;
        case "ArrowRight":
            e.preventDefault(), n.orientation === "horizontal" && $c48912b423983456$var$B(t, 5);
            break;
        case "ArrowUp":
            e.preventDefault(), n.orientation === "vertical" && $c48912b423983456$var$B(t, -5);
            break;
        case "End":
            e.preventDefault(), $c48912b423983456$var$B(t, 100);
            break;
        case "Enter":
            {
                e.preventDefault();
                const o = $c48912b423983456$var$pe(t), i = $c48912b423983456$var$H(o.id, !0), { derivedPanelConstraints: s, layout: u, separatorToPanels: a } = i, r = o.separators.find((p)=>p.element === t);
                $c48912b423983456$var$C(r, "Matching separator not found");
                const l = a.get(r);
                $c48912b423983456$var$C(l, "Matching panels not found");
                const c = l[0], m = s.find((p)=>p.panelId === c.id);
                if ($c48912b423983456$var$C(m, "Panel metadata not found"), m.collapsible) {
                    const p = u[c.id], S = m.collapsedSize === p ? o.mutableState.expandedPanelSizes[c.id] ?? m.minSize : m.collapsedSize;
                    $c48912b423983456$var$B(t, S - p);
                }
                break;
            }
        case "F6":
            {
                e.preventDefault();
                const i = $c48912b423983456$var$pe(t).separators.map((r)=>r.element), s = Array.from(i).findIndex((r)=>r === e.currentTarget);
                $c48912b423983456$var$C(s !== null, "Index not found");
                const u = e.shiftKey ? s > 0 ? s - 1 : i.length - 1 : s + 1 < i.length ? s + 1 : 0;
                i[u].focus({
                    preventScroll: !0
                });
                break;
            }
        case "Home":
            e.preventDefault(), $c48912b423983456$var$B(t, -100);
            break;
    }
}
function $c48912b423983456$var$je(e) {
    if (e.defaultPrevented) return;
    if (e.pointerType === "mouse" && e.button > 0) return;
    const t = $c48912b423983456$var$V(), n = $c48912b423983456$var$we(e, t), o = /* @__PURE__ */ new Map();
    let i = !1;
    n.forEach((s)=>{
        s.separator && (i || (i = !0, s.separator.element.focus({
            // @ts-expect-error https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#browser_compatibility
            focusVisible: !1,
            preventScroll: !0
        })));
        const u = t.get(s.group);
        u && o.set(s.group, u.layout);
    }), $c48912b423983456$var$te({
        cursorFlags: 0,
        hitRegions: n,
        initialLayoutMap: o,
        pointerDownAtPoint: {
            x: e.clientX,
            y: e.clientY
        },
        state: "active"
    }), n.length && e.preventDefault();
}
function $c48912b423983456$var$ut({ document: e, event: t, hitRegions: n, initialLayoutMap: o, mountedGroups: i, pointerDownAtPoint: s, prevCursorFlags: u }) {
    let a = 0;
    n.forEach((l)=>{
        const { group: c, groupSize: m } = l, { orientation: p, panels: S } = c, { disableCursor: z } = c.mutableState;
        let f = 0;
        s ? p === "horizontal" ? f = (t.clientX - s.x) / m * 100 : f = (t.clientY - s.y) / m * 100 : p === "horizontal" ? f = t.clientX < 0 ? -100 : 100 : f = t.clientY < 0 ? -100 : 100;
        const d = o.get(c), h = i.get(c);
        if (!d || !h) return;
        const { defaultLayoutDeferred: y, derivedPanelConstraints: b, groupSize: v, layout: g, separatorToPanels: w } = h;
        if (b && g && w) {
            const E = $c48912b423983456$var$le({
                delta: f,
                initialLayout: d,
                panelConstraints: b,
                pivotIndices: l.panels.map((L)=>S.indexOf(L)),
                prevLayout: g,
                trigger: "mouse-or-touch"
            });
            if ($c48912b423983456$var$K(E, g)) {
                if (f !== 0 && !z) switch(p){
                    case "horizontal":
                        a |= f < 0 ? $c48912b423983456$var$et : $c48912b423983456$var$tt;
                        break;
                    case "vertical":
                        a |= f < 0 ? $c48912b423983456$var$nt : $c48912b423983456$var$ot;
                        break;
                }
            } else $c48912b423983456$var$j(l.group, {
                defaultLayoutDeferred: y,
                derivedPanelConstraints: b,
                groupSize: v,
                layout: E,
                separatorToPanels: w
            });
        }
    });
    let r = 0;
    t.movementX === 0 ? r |= u & $c48912b423983456$var$Ie : r |= a & $c48912b423983456$var$Ie, t.movementY === 0 ? r |= u & $c48912b423983456$var$ke : r |= a & $c48912b423983456$var$ke, $c48912b423983456$var$Et(r), $c48912b423983456$var$xe(e);
}
function $c48912b423983456$var$He(e) {
    const t = $c48912b423983456$var$V(), n = $c48912b423983456$var$W();
    switch(n.state){
        case "active":
            $c48912b423983456$var$ut({
                document: e.currentTarget,
                event: e,
                hitRegions: n.hitRegions,
                initialLayoutMap: n.initialLayoutMap,
                mountedGroups: t,
                prevCursorFlags: n.cursorFlags
            });
    }
}
function $c48912b423983456$var$Ve(e) {
    if (e.defaultPrevented) return;
    const t = $c48912b423983456$var$W(), n = $c48912b423983456$var$V();
    switch(t.state){
        case "active":
            if (// Skip this check for "pointerleave" events, else Firefox triggers a false positive (see #514)
            e.buttons === 0) {
                $c48912b423983456$var$te({
                    cursorFlags: 0,
                    state: "inactive"
                }), t.hitRegions.forEach((o)=>{
                    if (!n.has(o.group)) return;
                    const i = $c48912b423983456$var$H(o.group.id, !0);
                    $c48912b423983456$var$j(o.group, i, {
                        isUserInteraction: !0
                    });
                });
                return;
            }
            for (const o of t.hitRegions)if (o.separator) {
                const { element: i } = o.separator;
                i.hasPointerCapture?.(e.pointerId) || i.setPointerCapture?.(e.pointerId);
            }
            $c48912b423983456$var$ut({
                document: e.currentTarget,
                event: e,
                hitRegions: t.hitRegions,
                initialLayoutMap: t.initialLayoutMap,
                mountedGroups: n,
                pointerDownAtPoint: t.pointerDownAtPoint,
                prevCursorFlags: t.cursorFlags
            });
            break;
        default:
            {
                const o = $c48912b423983456$var$we(e, n);
                o.length === 0 ? t.state !== "inactive" && $c48912b423983456$var$te({
                    cursorFlags: 0,
                    state: "inactive"
                }) : $c48912b423983456$var$te({
                    cursorFlags: 0,
                    hitRegions: o,
                    state: "hover"
                }), $c48912b423983456$var$xe(e.currentTarget);
                break;
            }
    }
}
function $c48912b423983456$var$Ue(e) {
    if (e.relatedTarget instanceof HTMLIFrameElement) switch($c48912b423983456$var$W().state){
        case "hover":
            $c48912b423983456$var$te({
                cursorFlags: 0,
                state: "inactive"
            });
    }
}
function $c48912b423983456$var$Be(e) {
    if (e.defaultPrevented) return;
    if (e.pointerType === "mouse" && e.button > 0) return;
    $c48912b423983456$var$rt(e.currentTarget) && e.preventDefault();
}
function $c48912b423983456$var$We(e) {
    let t = 0, n = 0;
    const o = {};
    for (const s of e)if (s.defaultSize !== void 0) {
        t++;
        const u = $c48912b423983456$var$T(s.defaultSize);
        n += u, o[s.panelId] = u;
    } else o[s.panelId] = void 0;
    const i = e.length - t;
    if (i !== 0) {
        const s = $c48912b423983456$var$T((100 - n) / i);
        for (const u of e)u.defaultSize === void 0 && (o[u.panelId] = s);
    }
    return o;
}
function $c48912b423983456$var$jt(e, t, n) {
    if (!n[0]) return;
    const i = e.panels.find((l)=>l.element === t);
    if (!i || !i.onResize) return;
    const s = $c48912b423983456$var$ne({
        group: e
    }), u = e.orientation === "horizontal" ? i.element.offsetWidth : i.element.offsetHeight, a = i.mutableValues.prevSize, r = {
        asPercentage: $c48912b423983456$var$T(u / s * 100),
        inPixels: u
    };
    i.mutableValues.prevSize = r, i.onResize(r, i.id, a);
}
function $c48912b423983456$var$Ht(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(const o in e)if (e[o] !== t[o]) return !1;
    return !0;
}
function $c48912b423983456$var$Vt(e, t) {
    return e.length !== t.length ? !1 : e.every((n, o)=>$c48912b423983456$var$Ht(n, t[o]));
}
function $c48912b423983456$var$Ut({ group: e, nextGroupSize: t, prevGroupSize: n, prevLayout: o }) {
    if (n <= 0 || t <= 0 || n === t) return o;
    let i = 0, s = 0, u = !1;
    const a = /* @__PURE__ */ new Map(), r = [];
    for (const m of e.panels){
        const p = o[m.id] ?? 0;
        switch(m.panelConstraints.groupResizeBehavior){
            case "preserve-pixel-size":
                {
                    u = !0;
                    const S = p / 100 * n, z = $c48912b423983456$var$T(S / t * 100);
                    a.set(m.id, z), i += z;
                    break;
                }
            case "preserve-relative-size":
            default:
                r.push(m.id), s += p;
                break;
        }
    }
    if (!u || r.length === 0) return o;
    const l = 100 - i, c = {
        ...o
    };
    if (a.forEach((m, p)=>{
        c[p] = m;
    }), s > 0) for (const m of r){
        const p = o[m] ?? 0;
        c[m] = $c48912b423983456$var$T(p / s * l);
    }
    else {
        const m = $c48912b423983456$var$T(l / r.length);
        for (const p of r)c[p] = m;
    }
    return c;
}
function $c48912b423983456$var$Bt(e, t) {
    const n = e.map((i)=>i.id), o = Object.keys(t);
    if (n.length !== o.length) return !1;
    for (const i of n)if (!o.includes(i)) return !1;
    return !0;
}
const $c48912b423983456$var$J = /* @__PURE__ */ new Map();
function $c48912b423983456$var$Wt(e) {
    let t = !0;
    $c48912b423983456$var$C(e.element.ownerDocument.defaultView, "Cannot register an unmounted Group");
    const n = e.element.ownerDocument.defaultView.ResizeObserver, o = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = new n((f)=>{
        for (const d of f){
            const { borderBoxSize: h, target: y } = d;
            if (y === e.element) {
                if (t) {
                    const b = $c48912b423983456$var$ne({
                        group: e
                    });
                    if (b === 0) return;
                    const v = $c48912b423983456$var$H(e.id);
                    if (!v) return;
                    const g = $c48912b423983456$var$ve(e), w = v.defaultLayoutDeferred ? $c48912b423983456$var$We(g) : v.layout, E = $c48912b423983456$var$Ut({
                        group: e,
                        nextGroupSize: b,
                        prevGroupSize: v.groupSize,
                        prevLayout: w
                    }), L = $c48912b423983456$var$X({
                        layout: E,
                        panelConstraints: g
                    });
                    if (!v.defaultLayoutDeferred && $c48912b423983456$var$K(v.layout, L) && $c48912b423983456$var$Vt(v.derivedPanelConstraints, g) && v.groupSize === b) continue;
                    $c48912b423983456$var$j(e, {
                        defaultLayoutDeferred: !1,
                        derivedPanelConstraints: g,
                        groupSize: b,
                        layout: L,
                        separatorToPanels: v.separatorToPanels
                    });
                }
            } else $c48912b423983456$var$jt(e, y, h);
        }
    });
    s.observe(e.element), e.panels.forEach((f)=>{
        $c48912b423983456$var$C(!o.has(f.id), `Panel ids must be unique; id "${f.id}" was used more than once`), o.add(f.id), f.onResize && s.observe(f.element);
    });
    const u = $c48912b423983456$var$ne({
        group: e
    }), a = $c48912b423983456$var$ve(e), r = e.panels.map(({ id: f })=>f).join(",");
    let l = e.mutableState.defaultLayout;
    l && ($c48912b423983456$var$Bt(e.panels, l) || (l = void 0));
    const c = e.mutableState.layouts[r] ?? l ?? $c48912b423983456$var$We(a), m = $c48912b423983456$var$X({
        layout: c,
        panelConstraints: a
    }), p = e.element.ownerDocument;
    $c48912b423983456$var$J.set(p, ($c48912b423983456$var$J.get(p) ?? 0) + 1);
    const S = /* @__PURE__ */ new Map();
    return $c48912b423983456$var$Ze(e).forEach((f)=>{
        f.separator && S.set(f.separator, f.panels);
    }), $c48912b423983456$var$j(e, {
        defaultLayoutDeferred: u === 0,
        derivedPanelConstraints: a,
        groupSize: u,
        layout: m,
        separatorToPanels: S
    }), e.separators.forEach((f)=>{
        $c48912b423983456$var$C(!i.has(f.id), `Separator ids must be unique; id "${f.id}" was used more than once`), i.add(f.id), f.element.addEventListener("keydown", $c48912b423983456$var$$e);
    }), $c48912b423983456$var$J.get(p) === 1 && (p.addEventListener("contextmenu", $c48912b423983456$var$Ge, !0), p.addEventListener("dblclick", $c48912b423983456$var$_e, !0), p.addEventListener("pointerdown", $c48912b423983456$var$je, !0), p.addEventListener("pointerleave", $c48912b423983456$var$He), p.addEventListener("pointermove", $c48912b423983456$var$Ve), p.addEventListener("pointerout", $c48912b423983456$var$Ue), p.addEventListener("pointerup", $c48912b423983456$var$Be, !0)), function() {
        t = !1, $c48912b423983456$var$J.set(p, Math.max(0, ($c48912b423983456$var$J.get(p) ?? 0) - 1)), $c48912b423983456$var$kt(e), e.separators.forEach((d)=>{
            d.element.removeEventListener("keydown", $c48912b423983456$var$$e);
        }), $c48912b423983456$var$J.get(p) || (p.removeEventListener("contextmenu", $c48912b423983456$var$Ge, !0), p.removeEventListener("dblclick", $c48912b423983456$var$_e, !0), p.removeEventListener("pointerdown", $c48912b423983456$var$je, !0), p.removeEventListener("pointerleave", $c48912b423983456$var$He), p.removeEventListener("pointermove", $c48912b423983456$var$Ve), p.removeEventListener("pointerout", $c48912b423983456$var$Ue), p.removeEventListener("pointerup", $c48912b423983456$var$Be, !0)), s.disconnect();
    };
}
function $c48912b423983456$var$Kt() {
    const [e, t] = (0, $7fPBF.useState)({}), n = (0, $7fPBF.useCallback)(()=>t({}), []);
    return [
        e,
        n
    ];
}
function $c48912b423983456$var$Le(e) {
    const t = (0, $7fPBF.useId)();
    return `${e ?? t}`;
}
const $c48912b423983456$var$q = typeof window < "u" ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $c48912b423983456$var$se(e) {
    const t = (0, $7fPBF.useRef)(e);
    return $c48912b423983456$var$q(()=>{
        t.current = e;
    }, [
        e
    ]), (0, $7fPBF.useCallback)((...n)=>t.current?.(...n), [
        t
    ]);
}
function $c48912b423983456$var$Ce(...e) {
    return $c48912b423983456$var$se((t)=>{
        e.forEach((n)=>{
            if (n) switch(typeof n){
                case "function":
                    n(t);
                    break;
                case "object":
                    n.current = t;
                    break;
            }
        });
    });
}
function $c48912b423983456$var$Re(e) {
    const t = (0, $7fPBF.useRef)({
        ...e
    });
    return $c48912b423983456$var$q(()=>{
        for(const n in e)t.current[n] = e[n];
    }, [
        e
    ]), t.current;
}
const $c48912b423983456$var$ct = (0, $7fPBF.createContext)(null);
function $c48912b423983456$var$Xt(e, t) {
    const n = (0, $7fPBF.useRef)({
        getLayout: ()=>({}),
        setLayout: $c48912b423983456$var$Mt
    });
    (0, $7fPBF.useImperativeHandle)(t, ()=>n.current, []), $c48912b423983456$var$q(()=>{
        Object.assign(n.current, $c48912b423983456$var$lt({
            groupId: e
        }));
    });
}
function $c48912b423983456$export$eb2fcfdbd7ba97d4({ children: e, className: t, defaultLayout: n, disableCursor: o, disabled: i, elementRef: s, groupRef: u, id: a, onLayoutChange: r, onLayoutChanged: l, orientation: c = "horizontal", resizeTargetMinimumSize: m = {
    coarse: 20,
    fine: 10
}, style: p, ...S }) {
    const z = (0, $7fPBF.useRef)({
        onLayoutChange: {},
        onLayoutChanged: {}
    }), f = $c48912b423983456$var$se((x)=>{
        $c48912b423983456$var$K(z.current.onLayoutChange, x) || (z.current.onLayoutChange = x, r?.(x));
    }), d = $c48912b423983456$var$se((x, P)=>{
        $c48912b423983456$var$K(z.current.onLayoutChanged, x) || (z.current.onLayoutChanged = x, l?.(x, {
            isUserInteraction: P
        }));
    }), h = $c48912b423983456$var$Le(a), y = (0, $7fPBF.useRef)(null), [b, v] = $c48912b423983456$var$Kt(), g = (0, $7fPBF.useRef)({
        lastExpandedPanelSizes: {},
        layouts: {},
        panels: [],
        resizeTargetMinimumSize: m,
        separators: []
    }), w = $c48912b423983456$var$Ce(y, s);
    $c48912b423983456$var$Xt(h, u);
    const E = $c48912b423983456$var$se((x, P)=>{
        const I = $c48912b423983456$var$W(), R = $c48912b423983456$var$Oe(x), M = $c48912b423983456$var$H(x);
        if (M) {
            let D = !1;
            switch(I.state){
                case "active":
                    D = I.hitRegions.some((U)=>U.group === R);
                    break;
            }
            return {
                flexGrow: M.layout[P] ?? 1,
                pointerEvents: D ? "none" : void 0
            };
        }
        if (n?.[P]) return {
            flexGrow: n?.[P]
        };
    }), L = $c48912b423983456$var$Re({
        defaultLayout: n,
        disableCursor: o
    }), G = (0, $7fPBF.useMemo)(()=>({
            get disableCursor () {
                return !!L.disableCursor;
            },
            getPanelStyles: E,
            id: h,
            orientation: c,
            registerPanel: (x)=>{
                const P = g.current;
                return P.panels = $c48912b423983456$var$be(c, [
                    ...P.panels,
                    x
                ]), v(), ()=>{
                    P.panels = P.panels.filter((I)=>I !== x), v();
                };
            },
            registerSeparator: (x)=>{
                const P = g.current;
                return P.separators = $c48912b423983456$var$be(c, [
                    ...P.separators,
                    x
                ]), v(), ()=>{
                    P.separators = P.separators.filter((I)=>I !== x), v();
                };
            },
            updatePanelProps: (x, { disabled: P })=>{
                const R = g.current.panels.find((U)=>U.id === x);
                R && (R.panelConstraints.disabled = P);
                const M = $c48912b423983456$var$Oe(h), D = $c48912b423983456$var$H(h);
                M && D && $c48912b423983456$var$j(M, {
                    ...D,
                    derivedPanelConstraints: $c48912b423983456$var$ve(M)
                });
            },
            updateSeparatorProps: (x, { disabled: P, disableDoubleClick: I })=>{
                const M = g.current.separators.find((D)=>D.id === x);
                M && (M.disabled = P, M.disableDoubleClick = I);
            }
        }), [
        E,
        h,
        v,
        c,
        L
    ]), N = (0, $7fPBF.useRef)(null);
    return $c48912b423983456$var$q(()=>{
        const x = y.current;
        if (x === null) return;
        const P = g.current;
        let I;
        if (L.defaultLayout !== void 0 && Object.keys(L.defaultLayout).length === P.panels.length) {
            I = {};
            for (const _ of P.panels){
                const Y = L.defaultLayout[_.id];
                Y !== void 0 && (I[_.id] = Y);
            }
        }
        const R = {
            disabled: !!i,
            element: x,
            id: h,
            mutableState: {
                defaultLayout: I,
                disableCursor: !!L.disableCursor,
                expandedPanelSizes: g.current.lastExpandedPanelSizes,
                layouts: g.current.layouts
            },
            orientation: c,
            panels: P.panels,
            resizeTargetMinimumSize: P.resizeTargetMinimumSize,
            separators: P.separators
        };
        N.current = R;
        const M = $c48912b423983456$var$Wt(R), { defaultLayoutDeferred: D, derivedPanelConstraints: U, layout: ue } = $c48912b423983456$var$H(R.id, !0);
        !D && U.length > 0 && (f(ue), d(ue, !1));
        const oe = $c48912b423983456$var$Pe(h, (_)=>{
            const { defaultLayoutDeferred: Y, derivedPanelConstraints: Me, layout: ce } = _.next;
            if (Y || Me.length === 0) return;
            const ft = R.panels.map(({ id: $ })=>$).join(",");
            R.mutableState.layouts[ft] = ce, Me.forEach(($)=>{
                if ($.collapsible) {
                    const { layout: ge } = _.prev ?? {};
                    if (ge) {
                        const pt = $c48912b423983456$var$k($.collapsedSize, ce[$.panelId]), ht = $c48912b423983456$var$k($.collapsedSize, ge[$.panelId]);
                        pt && !ht && (R.mutableState.expandedPanelSizes[$.panelId] = ge[$.panelId]);
                    }
                }
            });
            const dt = $c48912b423983456$var$W().state !== "active";
            f(ce), dt && d(ce, _.isUserInteraction);
        });
        return ()=>{
            N.current = null, M(), oe();
        };
    }, [
        i,
        h,
        d,
        f,
        c,
        b,
        L
    ]), (0, $7fPBF.useEffect)(()=>{
        const x = N.current;
        x && (x.mutableState.defaultLayout = n, x.mutableState.disableCursor = !!o);
    }), /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($c48912b423983456$var$ct.Provider, {
        value: G,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
            ...S,
            className: t,
            "data-group": !0,
            "data-testid": h,
            id: h,
            ref: w,
            style: {
                height: "100%",
                width: "100%",
                overflow: "hidden",
                ...p,
                display: "flex",
                flexDirection: c === "horizontal" ? "row" : "column",
                flexWrap: "nowrap",
                // Inform the browser that the library is handling touch events for this element
                // but still allow users to scroll content within panels in the non-resizing direction
                // NOTE This is not an inherited style
                // See github.com/bvaughn/react-resizable-panels/issues/662
                touchAction: c === "horizontal" ? "pan-y" : "pan-x"
            },
            children: e
        })
    });
}
$c48912b423983456$export$eb2fcfdbd7ba97d4.displayName = "Group";
function $c48912b423983456$var$he(e, t) {
    return `react-resizable-panels:${[
        e,
        ...t
    ].join(":")}`;
}
function $c48912b423983456$var$Yt({ id: e, panelIds: t, storage: n }) {
    const o = $c48912b423983456$var$he(e, []), i = n.getItem(o);
    if (i) try {
        const s = JSON.parse(i);
        if (t) {
            const u = t.join(","), a = s[u];
            if (a && Array.isArray(a.layout) && t.length === a.layout.length) {
                const r = {};
                for(let l = 0; l < t.length; l++)r[t[l]] = a.layout[l];
                return r;
            }
        } else {
            const u = Object.keys(s);
            if (u.length === 1) {
                const a = s[u[0]];
                if (a && Array.isArray(a.layout)) {
                    const r = u[0].split(",");
                    if (r.length === a.layout.length) {
                        const l = {};
                        for(let c = 0; c < r.length; c++)l[r[c]] = a.layout[c];
                        return l;
                    }
                }
            }
        }
    } catch  {}
}
function $c48912b423983456$export$2bb3f65002f7b42d({ debounceSaveMs: e = 100, onlySaveAfterUserInteractions: t, panelIds: n, storage: o = localStorage, ...i }) {
    const s = n !== void 0, u = "id" in i ? i.id : i.groupId, a = $c48912b423983456$var$he(u, n ?? []), r = (0, $7fPBF.useSyncExternalStore)($c48912b423983456$var$Jt, ()=>o.getItem(a), ()=>o.getItem(a)), l = (0, $7fPBF.useMemo)(()=>{
        if (r) {
            const d = JSON.parse(r), h = Object.values(d);
            if (Array.from(h).every((y)=>typeof y == "number")) return d;
        }
    }, [
        r
    ]), c = (0, $7fPBF.useMemo)(()=>{
        if (!l) return $c48912b423983456$var$Yt({
            id: u,
            panelIds: n,
            storage: o
        });
    }, [
        l,
        u,
        n,
        o
    ]), m = l ?? c, p = (0, $7fPBF.useRef)(null), S = (0, $7fPBF.useCallback)(()=>{
        const d = p.current;
        d && (p.current = null, clearTimeout(d));
    }, []);
    (0, $7fPBF.useLayoutEffect)(()=>()=>{
            S();
        }, [
        S
    ]);
    const z = (0, $7fPBF.useCallback)(// The hook persists every layout commit -- including library-driven ones --
    // because it owns its own storage and the goal is to remember whatever
    // layout the user is currently looking at. Consumers that only want to
    // persist on user interaction should branch on `isUserInteraction` in
    // their own callback (see #716) rather than via this hook.
    (d, h)=>{
        if (t && !h.isUserInteraction) return;
        S();
        let y;
        s ? y = $c48912b423983456$var$he(u, Object.keys(d)) : y = $c48912b423983456$var$he(u, []);
        try {
            o.setItem(y, JSON.stringify(d));
        } catch (b) {
            console.error(b);
        }
    }, [
        S,
        s,
        u,
        t,
        o
    ]), f = (0, $7fPBF.useCallback)((d)=>{
        S(), e === 0 ? z(d, {
            isUserInteraction: !1
        }) : p.current = setTimeout(()=>{
            z(d, {
                isUserInteraction: !1
            });
        }, e);
    }, [
        S,
        e,
        z
    ]);
    return {
        /**
     * Pass this value to `Group` as the `defaultLayout` prop.
     */ defaultLayout: m,
        /**
     * Attach this callback on the `Group` as the `onLayoutChange` prop.
     *
     * @deprecated Use the {@link onLayoutChanged} prop instead.
     */ onLayoutChange: f,
        /**
     * Attach this callback on the `Group` as the `onLayoutChanged` prop.
     */ onLayoutChanged: z
    };
}
function $c48912b423983456$var$Jt() {
    return function() {};
}
function $c48912b423983456$export$c264dd47f77a0c9f() {
    return (0, $7fPBF.useState)(null);
}
function $c48912b423983456$export$de79cd28fc663c83() {
    return (0, $7fPBF.useRef)(null);
}
function $c48912b423983456$var$Ee() {
    const e = (0, $7fPBF.useContext)($c48912b423983456$var$ct);
    return $c48912b423983456$var$C(e, "Group Context not found; did you render a Panel or Separator outside of a Group?"), e;
}
function $c48912b423983456$var$Zt(e, t) {
    const { id: n } = $c48912b423983456$var$Ee(), o = (0, $7fPBF.useRef)({
        collapse: $c48912b423983456$var$ye,
        expand: $c48912b423983456$var$ye,
        getSize: ()=>({
                asPercentage: 0,
                inPixels: 0
            }),
        isCollapsed: ()=>!1,
        resize: $c48912b423983456$var$ye
    });
    (0, $7fPBF.useImperativeHandle)(t, ()=>o.current, []), $c48912b423983456$var$q(()=>{
        Object.assign(o.current, $c48912b423983456$var$at({
            groupId: n,
            panelId: e
        }));
    });
}
function $c48912b423983456$export$2ddb90ad54e5f587({ children: e, className: t, collapsedSize: n = "0%", collapsible: o = !1, defaultSize: i, disabled: s, elementRef: u, groupResizeBehavior: a = "preserve-relative-size", id: r, maxSize: l = "100%", minSize: c = "0%", onResize: m, panelRef: p, style: S, ...z }) {
    const f = !!r, d = $c48912b423983456$var$Le(r), h = $c48912b423983456$var$Re({
        disabled: s
    }), y = (0, $7fPBF.useRef)(null), b = $c48912b423983456$var$Ce(y, u), { getPanelStyles: v, id: g, orientation: w, registerPanel: E, updatePanelProps: L } = $c48912b423983456$var$Ee(), G = m !== null, N = $c48912b423983456$var$se((R, M, D)=>{
        m?.(R, r, D);
    });
    $c48912b423983456$var$q(()=>{
        const R = y.current;
        if (R !== null) {
            const M = {
                element: R,
                id: d,
                idIsStable: f,
                mutableValues: {
                    expandToSize: void 0,
                    prevSize: void 0
                },
                onResize: G ? N : void 0,
                panelConstraints: {
                    groupResizeBehavior: a,
                    collapsedSize: n,
                    collapsible: o,
                    defaultSize: i,
                    disabled: h.disabled,
                    maxSize: l,
                    minSize: c
                }
            };
            return E(M);
        }
    }, [
        a,
        n,
        o,
        i,
        G,
        d,
        f,
        l,
        c,
        N,
        E,
        h
    ]), (0, $7fPBF.useEffect)(()=>{
        L(d, {
            disabled: s
        });
    }, [
        s,
        d,
        L
    ]), $c48912b423983456$var$Zt(d, p);
    const x = ()=>{
        const R = v(g, d);
        if (R) return JSON.stringify(R);
    }, P = (0, $7fPBF.useSyncExternalStore)((R)=>$c48912b423983456$var$Pe(g, R), x, x);
    let I;
    return P ? I = JSON.parse(P) : i !== void 0 ? I = {
        flexGrow: void 0,
        flexShrink: void 0,
        flexBasis: i
    } : I = {
        flexGrow: 1
    }, /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ...z,
        "data-disabled": s || void 0,
        "data-panel": !0,
        "data-testid": d,
        id: d,
        ref: b,
        style: {
            ...$c48912b423983456$var$en,
            display: "flex",
            flexBasis: 0,
            flexShrink: 1,
            overflow: "visible",
            ...I
        },
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: t,
            style: {
                maxHeight: "100%",
                maxWidth: "100%",
                flexGrow: 1,
                overflow: "auto",
                ...S,
                // Inform the browser that the library is handling touch events for this element
                // but still allow users to scroll content within panels in the non-resizing direction
                // NOTE This is not an inherited style
                // See github.com/bvaughn/react-resizable-panels/issues/662
                touchAction: w === "horizontal" ? "pan-y" : "pan-x"
            },
            children: e
        })
    });
}
$c48912b423983456$export$2ddb90ad54e5f587.displayName = "Panel";
const $c48912b423983456$var$en = {
    minHeight: 0,
    maxHeight: "100%",
    height: "auto",
    minWidth: 0,
    maxWidth: "100%",
    width: "auto",
    border: "none",
    borderWidth: 0,
    padding: 0,
    margin: 0
};
function $c48912b423983456$export$acc55051a2413889() {
    return (0, $7fPBF.useState)(null);
}
function $c48912b423983456$export$94ab53417567be34() {
    return (0, $7fPBF.useRef)(null);
}
function $c48912b423983456$var$tn({ layout: e, panelConstraints: t, panelId: n, panelIndex: o }) {
    let i, s;
    const u = e[n], a = t.find((r)=>r.panelId === n);
    if (a) {
        const r = a.maxSize, l = a.collapsible ? a.collapsedSize : a.minSize, c = [
            o,
            o + 1
        ];
        s = $c48912b423983456$var$X({
            layout: $c48912b423983456$var$le({
                delta: l - u,
                initialLayout: e,
                panelConstraints: t,
                pivotIndices: c,
                prevLayout: e
            }),
            panelConstraints: t
        })[n], i = $c48912b423983456$var$X({
            layout: $c48912b423983456$var$le({
                delta: r - u,
                initialLayout: e,
                panelConstraints: t,
                pivotIndices: c,
                prevLayout: e
            }),
            panelConstraints: t
        })[n];
    }
    return {
        valueControls: n,
        valueMax: i,
        valueMin: s,
        valueNow: u
    };
}
function $c48912b423983456$export$1ff3c3f08ae963c0({ children: e, className: t, disabled: n, disableDoubleClick: o, elementRef: i, id: s, style: u, ...a }) {
    const r = $c48912b423983456$var$Le(s), l = $c48912b423983456$var$Re({
        disabled: n,
        disableDoubleClick: o
    }), [c, m] = (0, $7fPBF.useState)({}), [p, S] = (0, $7fPBF.useState)("inactive"), [z, f] = (0, $7fPBF.useState)(!1), d = (0, $7fPBF.useRef)(null), h = $c48912b423983456$var$Ce(d, i), { disableCursor: y, id: b, orientation: v, registerSeparator: g, updateSeparatorProps: w } = $c48912b423983456$var$Ee(), E = v === "horizontal" ? "vertical" : "horizontal";
    $c48912b423983456$var$q(()=>{
        const N = d.current;
        if (N !== null) {
            const x = {
                disabled: l.disabled,
                disableDoubleClick: l.disableDoubleClick,
                element: N,
                id: r
            }, P = g(x), I = $c48912b423983456$var$Rt((M)=>{
                S(M.next.state !== "inactive" && M.next.hitRegions.some((D)=>D.separator === x) ? M.next.state : "inactive");
            }), R = $c48912b423983456$var$Pe(b, (M)=>{
                const { derivedPanelConstraints: D, layout: U, separatorToPanels: ue } = M.next, oe = ue.get(x);
                if (oe) {
                    const _ = oe[0], Y = oe.indexOf(_);
                    m($c48912b423983456$var$tn({
                        layout: U,
                        panelConstraints: D,
                        panelId: _.id,
                        panelIndex: Y
                    }));
                }
            });
            return ()=>{
                I(), R(), P();
            };
        }
    }, [
        b,
        r,
        g,
        l
    ]), (0, $7fPBF.useEffect)(()=>{
        w(r, {
            disabled: n,
            disableDoubleClick: o
        });
    }, [
        n,
        o,
        r,
        w
    ]);
    let L;
    n && !y && (L = "not-allowed");
    let G;
    if (n) G = "disabled";
    else switch(p){
        case "active":
            G = "active";
            break;
        default:
            z ? G = "focus" : G = p;
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ...a,
        "aria-controls": c.valueControls,
        "aria-disabled": n || void 0,
        "aria-orientation": E,
        "aria-valuemax": c.valueMax,
        "aria-valuemin": c.valueMin,
        "aria-valuenow": c.valueNow,
        children: e,
        className: t,
        "data-separator": G,
        "data-testid": r,
        id: r,
        onBlur: ()=>f(!1),
        onFocus: ()=>f(!0),
        ref: h,
        role: "separator",
        style: {
            flexBasis: "auto",
            cursor: L,
            ...u,
            flexGrow: 0,
            flexShrink: 0,
            // Inform the browser that the library is handling touch events for this element
            // See github.com/bvaughn/react-resizable-panels/issues/662
            touchAction: "none"
        },
        tabIndex: n ? void 0 : 0
    });
}
$c48912b423983456$export$1ff3c3f08ae963c0.displayName = "Separator";





var $7fPBF = parcelRequire("7fPBF");




const $79081da09985f2e4$export$611c90aeaea4f22e = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [, setUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const getUserProfile = async ()=>{
        const { status: status, body: body } = await get("userProfiles");
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setUserProfile(body);
    };
    return {
        getUserProfile: getUserProfile
    };
};



const $c9f68c5c1e8b930f$export$51e0836025131fe2 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyUserProfile = (parameters)=>put("userProfiles", parameters);
    return {
        modifyUserProfile: modifyUserProfile
    };
};





var $cd9230521fc602dd$exports = {};

$parcel$export($cd9230521fc602dd$exports, "MuiBadge-badge", function () { return $cd9230521fc602dd$export$26bda09a57fe432d; }, function (v) { return $cd9230521fc602dd$export$26bda09a57fe432d = v; });
$parcel$export($cd9230521fc602dd$exports, "avatar", function () { return $cd9230521fc602dd$export$345c5736c8054f22; }, function (v) { return $cd9230521fc602dd$export$345c5736c8054f22 = v; });
$parcel$export($cd9230521fc602dd$exports, "publicUsernamePrefix", function () { return $cd9230521fc602dd$export$1521c2e3bff52fb8; }, function (v) { return $cd9230521fc602dd$export$1521c2e3bff52fb8 = v; });
$parcel$export($cd9230521fc602dd$exports, "role", function () { return $cd9230521fc602dd$export$3100efae45e879; }, function (v) { return $cd9230521fc602dd$export$3100efae45e879 = v; });
$parcel$export($cd9230521fc602dd$exports, "skeletonSubtitle", function () { return $cd9230521fc602dd$export$9c1a2f1d94e23ae4; }, function (v) { return $cd9230521fc602dd$export$9c1a2f1d94e23ae4 = v; });
$parcel$export($cd9230521fc602dd$exports, "skeletonText", function () { return $cd9230521fc602dd$export$82a82a627ca43089; }, function (v) { return $cd9230521fc602dd$export$82a82a627ca43089 = v; });
$parcel$export($cd9230521fc602dd$exports, "stack", function () { return $cd9230521fc602dd$export$a57ab32f40f83ea9; }, function (v) { return $cd9230521fc602dd$export$a57ab32f40f83ea9 = v; });
$parcel$export($cd9230521fc602dd$exports, "username", function () { return $cd9230521fc602dd$export$5e1be761f603d585; }, function (v) { return $cd9230521fc602dd$export$5e1be761f603d585 = v; });
var $cd9230521fc602dd$export$26bda09a57fe432d;
var $cd9230521fc602dd$export$345c5736c8054f22;
var $cd9230521fc602dd$export$1521c2e3bff52fb8;
var $cd9230521fc602dd$export$3100efae45e879;
var $cd9230521fc602dd$export$9c1a2f1d94e23ae4;
var $cd9230521fc602dd$export$82a82a627ca43089;
var $cd9230521fc602dd$export$a57ab32f40f83ea9;
var $cd9230521fc602dd$export$5e1be761f603d585;
$cd9230521fc602dd$export$26bda09a57fe432d = `_5jXPja_MuiBadge-badge`;
$cd9230521fc602dd$export$345c5736c8054f22 = `_5jXPja_avatar`;
$cd9230521fc602dd$export$1521c2e3bff52fb8 = `_5jXPja_publicUsernamePrefix`;
$cd9230521fc602dd$export$3100efae45e879 = `_5jXPja_role`;
$cd9230521fc602dd$export$9c1a2f1d94e23ae4 = `_5jXPja_skeletonSubtitle`;
$cd9230521fc602dd$export$82a82a627ca43089 = `_5jXPja_skeletonText`;
$cd9230521fc602dd$export$a57ab32f40f83ea9 = `_5jXPja_stack`;
$cd9230521fc602dd$export$5e1be761f603d585 = `_5jXPja_username`;









const $9715c44d9964b1ed$export$7fc422f6ed9d34ba = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [, setUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getUser = async ()=>{
        const { body: body, status: status } = await get("user");
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setUser(body);
            if ((0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.isCacheOlderThan(body.lastImageUpdateUnixTimestamp)) await (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).shared.clear();
        }
        return {
            body: body,
            status: status
        };
    };
    return {
        getUser: getUser
    };
};




const $7c2c0ada8130752a$export$4ad5a58f9467cba5 = {
    roleName: (role)=>{
        switch(role){
            case (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).admin:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).role_admin;
            case (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).role_common;
            case (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).collector:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).role_collector;
            case (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).role_premium;
            case (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).guest:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).role_guest;
            default:
                return (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown;
        }
    }
};


const $921bd0ad6d18d264$export$7bf40cd2a197df2d = ({ isPublic: isPublic, userProfile: userProfile, onClick: onClick })=>{
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { getUser: getUser } = (0, $9715c44d9964b1ed$export$7fc422f6ed9d34ba)();
    const { getUserProfile: getUserProfile } = (0, $79081da09985f2e4$export$611c90aeaea4f22e)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const username = ()=>{
        if (isPublic) return userProfile?.username;
        if (currentUser?.role == "guest") return (0, $37bec70ed65ed924$export$21c51bc433c16634).guest_title;
        return userProfile?.username;
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!currentUser) getUser().then();
        getUserProfile().then();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        sx: {
            flexShrink: 0,
            height: isMobile ? 42 : undefined,
            overflow: "visible",
            borderRadius: "20px"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                paddingLeft: "2px",
                paddingRight: isMobile ? "2px" : 1
            },
            onClick: onClick,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 1,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).stack,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039), {
                        overlap: "circular",
                        badgeContent: userProfile?.unreadNotifications,
                        color: "error",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).avatar,
                            style: {
                                width: isMobile ? 30 : 38,
                                height: isMobile ? 30 : 38
                            },
                            userProfile: userProfile
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center"
                        },
                        children: [
                            isPublic && currentUser && userProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).publicUsernamePrefix,
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).public_username_prefix
                            }),
                            userProfile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).username,
                                        children: username()
                                    }),
                                    !isPublic && currentUser && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).role,
                                        children: (0, $7c2c0ada8130752a$export$4ad5a58f9467cba5).roleName(currentUser.role)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).skeletonText
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cd9230521fc602dd$exports))).skeletonSubtitle
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};




parcelRequire("7fPBF");


var $c8553dd9b3cff4d7$exports = {};

$parcel$export($c8553dd9b3cff4d7$exports, "button", function () { return $c8553dd9b3cff4d7$export$2ba01fb71ed41cb6; }, function (v) { return $c8553dd9b3cff4d7$export$2ba01fb71ed41cb6 = v; });
$parcel$export($c8553dd9b3cff4d7$exports, "icon", function () { return $c8553dd9b3cff4d7$export$1ca1ec8b29a4ce27; }, function (v) { return $c8553dd9b3cff4d7$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($c8553dd9b3cff4d7$exports, "menuText", function () { return $c8553dd9b3cff4d7$export$181e246d02dce226; }, function (v) { return $c8553dd9b3cff4d7$export$181e246d02dce226 = v; });
var $c8553dd9b3cff4d7$export$2ba01fb71ed41cb6;
var $c8553dd9b3cff4d7$export$1ca1ec8b29a4ce27;
var $c8553dd9b3cff4d7$export$181e246d02dce226;
$c8553dd9b3cff4d7$export$2ba01fb71ed41cb6 = `T-7ela_button`;
$c8553dd9b3cff4d7$export$1ca1ec8b29a4ce27 = `T-7ela_icon`;
$c8553dd9b3cff4d7$export$181e246d02dce226 = `T-7ela_menuText`;





const $5933a8e70bcb89c0$export$9b061f1a40109870 = ({ className: className, style: style, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
        title: isMobile ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).open_drawer,
        arrow: true,
        disableInteractive: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($c8553dd9b3cff4d7$exports))).button),
            style: {
                ...style,
                height: isMobile ? 38 : 44,
                width: isMobile ? 38 : 92,
                minWidth: 0,
                borderRadius: 10,
                backgroundColor: theme.palette.background.default
            },
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c8553dd9b3cff4d7$exports))).icon,
                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Menu
                }),
                !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    style: {
                        maxWidth: "100%",
                        maxHeight: "100%"
                    },
                    src: piperTextImage,
                    alt: "Piper"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c8553dd9b3cff4d7$exports))).menuText,
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).menu
                })
            ]
        })
    });
};










const $75a27fb32476e886$export$76e455b2766b00bd = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getPrivateContent = (parameters)=>get("share/privateContent", parameters);
    return {
        getPrivateContent: getPrivateContent
    };
};




var $7fPBF = parcelRequire("7fPBF");

var $a0061c129e65f3f2$exports = {};

$parcel$export($a0061c129e65f3f2$exports, "checkboxHelpText", function () { return $a0061c129e65f3f2$export$330001811d8770b3; }, function (v) { return $a0061c129e65f3f2$export$330001811d8770b3 = v; });
$parcel$export($a0061c129e65f3f2$exports, "description", function () { return $a0061c129e65f3f2$export$6d59db4903f20f7d; }, function (v) { return $a0061c129e65f3f2$export$6d59db4903f20f7d = v; });
$parcel$export($a0061c129e65f3f2$exports, "gridCard", function () { return $a0061c129e65f3f2$export$338e99bce4214043; }, function (v) { return $a0061c129e65f3f2$export$338e99bce4214043 = v; });
$parcel$export($a0061c129e65f3f2$exports, "searchBar", function () { return $a0061c129e65f3f2$export$f2ea4ab276c3e3fa; }, function (v) { return $a0061c129e65f3f2$export$f2ea4ab276c3e3fa = v; });
var $a0061c129e65f3f2$export$330001811d8770b3;
var $a0061c129e65f3f2$export$6d59db4903f20f7d;
var $a0061c129e65f3f2$export$338e99bce4214043;
var $a0061c129e65f3f2$export$f2ea4ab276c3e3fa;
$a0061c129e65f3f2$export$330001811d8770b3 = `ESeprG_checkboxHelpText`;
$a0061c129e65f3f2$export$6d59db4903f20f7d = `ESeprG_description`;
$a0061c129e65f3f2$export$338e99bce4214043 = `ESeprG_gridCard`;
$a0061c129e65f3f2$export$f2ea4ab276c3e3fa = `ESeprG_searchBar`;









const $077dae512f6645b2$export$d4d8dffaf282d15e = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (query)=>{
        return await get(`discogs/search?query=${query}`);
    };
};



parcelRequire("7fPBF");
var $90a225e3c976493d$exports = {};

$parcel$export($90a225e3c976493d$exports, "albumImage", function () { return $90a225e3c976493d$export$24acac6e69ce1287; }, function (v) { return $90a225e3c976493d$export$24acac6e69ce1287 = v; });
$parcel$export($90a225e3c976493d$exports, "card", function () { return $90a225e3c976493d$export$aa3e815946b80764; }, function (v) { return $90a225e3c976493d$export$aa3e815946b80764 = v; });
$parcel$export($90a225e3c976493d$exports, "container", function () { return $90a225e3c976493d$export$34e0f9847d4c02dd; }, function (v) { return $90a225e3c976493d$export$34e0f9847d4c02dd = v; });
$parcel$export($90a225e3c976493d$exports, "name", function () { return $90a225e3c976493d$export$a8ff84c12d48cfa6; }, function (v) { return $90a225e3c976493d$export$a8ff84c12d48cfa6 = v; });
$parcel$export($90a225e3c976493d$exports, "rightContainer", function () { return $90a225e3c976493d$export$3280a108d7f81d56; }, function (v) { return $90a225e3c976493d$export$3280a108d7f81d56 = v; });
$parcel$export($90a225e3c976493d$exports, "subtitle", function () { return $90a225e3c976493d$export$c96745152eb2740f; }, function (v) { return $90a225e3c976493d$export$c96745152eb2740f = v; });
var $90a225e3c976493d$export$24acac6e69ce1287;
var $90a225e3c976493d$export$aa3e815946b80764;
var $90a225e3c976493d$export$34e0f9847d4c02dd;
var $90a225e3c976493d$export$a8ff84c12d48cfa6;
var $90a225e3c976493d$export$3280a108d7f81d56;
var $90a225e3c976493d$export$c96745152eb2740f;
$90a225e3c976493d$export$24acac6e69ce1287 = `icka_q_albumImage`;
$90a225e3c976493d$export$aa3e815946b80764 = `icka_q_card`;
$90a225e3c976493d$export$34e0f9847d4c02dd = `icka_q_container`;
$90a225e3c976493d$export$a8ff84c12d48cfa6 = `icka_q_name`;
$90a225e3c976493d$export$3280a108d7f81d56 = `icka_q_rightContainer`;
$90a225e3c976493d$export$c96745152eb2740f = `icka_q_subtitle`;








const $d2b72821d827c061$export$e2185054f8700420 = ({ release: release, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const handleLongPress = (0, $491ef7492701bdf5$export$2e2bcd8739ae039)({
        onLongPress: handleContextMenu
    });
    const genericSleeveImage = new URL($f3dc95464e643b42$exports).href;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        md: 12,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                elevation: 3,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($90a225e3c976493d$exports))).card,
                    onClick: handleContextMenu,
                    onContextMenu: handleContextMenu,
                    ...handleLongPress,
                    sx: {
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($90a225e3c976493d$exports))).albumImage,
                            src: release.cover_image,
                            alt: release.title,
                            onError: (event)=>{
                                event.target.src = genericSleeveImage;
                                event.onerror = null;
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($90a225e3c976493d$exports))).rightContainer,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($90a225e3c976493d$exports))).name,
                                    style: {
                                        color: theme.palette.primary.main
                                    },
                                    children: release.title
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($90a225e3c976493d$exports))).subtitle,
                                    style: {
                                        color: theme.palette.primary.subtitle
                                    },
                                    children: [
                                        release.format_quantity,
                                        "\xd7",
                                        release.format[0] ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural,
                                        " \u2022",
                                        " ",
                                        release.year ?? "----",
                                        " \u2022 ",
                                        release.country
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            onClick();
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddAd
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).add_album
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: `https://www.discogs.com/release/${release.id}`,
                        target: "_blank",
                        style: {
                            textDecoration: "none",
                            color: theme.palette.primary.main,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                            onClick: ()=>handleMenuClose(),
                            dense: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).OpenInNew
                                    })
                                }),
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_discogs
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



const $875c05cc6cad5add$export$92d4b7f9aa493bb1 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumFromDiscogsRelease = (parameters)=>post("albums/discogs", parameters);
    return {
        addAlbumFromDiscogsRelease: addAlbumFromDiscogsRelease
    };
};








var $7fPBF = parcelRequire("7fPBF");
var $849102574a83a574$var$s = function() {
    return $849102574a83a574$var$s = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $849102574a83a574$var$s.apply(this, arguments);
};
function $849102574a83a574$var$u(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                u(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                u(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, s);
        }
        u((n = n.apply(t, e || [])).next());
    });
}
function $849102574a83a574$var$c(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(s) {
        return function(u) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; i && (i = 0, s[0] && (a = 0)), a;)try {
                    if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;
                    switch(n = 0, o && (s = [
                        2 & s[0],
                        o.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            o = s;
                            break;
                        case 4:
                            return a.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                                a.label = s[1];
                                break;
                            }
                            if (6 === s[0] && a.label < o[1]) {
                                a.label = o[1], o = s;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(s);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    s = e.call(t, a);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                u
            ]);
        };
    }
}
"function" == typeof SuppressedError && SuppressedError;
var $849102574a83a574$var$f = {
    facingMode: "environment",
    width: {
        min: 640,
        ideal: 720,
        max: 1920
    },
    height: {
        min: 640,
        ideal: 720,
        max: 1080
    }
}, $849102574a83a574$export$6aa26f5ebe6471fc = "undefined" != typeof navigator && navigator.mediaDevices ? function(t) {
    var n = (0, $7fPBF.useState)([]), o = n[0], i = n[1];
    return (0, $7fPBF.useEffect)(function() {
        var e, r = {
            audio: !1,
            video: null != t ? t : $849102574a83a574$var$f
        }, n = function() {
            navigator.mediaDevices.getUserMedia(r).then(function(t) {
                var r = [];
                e = t, t.getVideoTracks().forEach(function(t) {
                    r.push(t.getSettings());
                }), i(r);
            }).catch(function(t) {
                return console.log(t);
            });
        };
        return function(t) {
            for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
            t && t.addEventListener && t.addEventListener.apply(t, e);
        }(navigator.mediaDevices, "devicechange", n), n(), function() {
            !function(t) {
                for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                t && t.removeEventListener && t.removeEventListener.apply(t, e);
            }(navigator.mediaDevices, "devicechange", n), void 0 !== e && e.getVideoTracks().forEach(function(t) {
                t.stop();
            });
        };
    }, []), o;
} : function() {
    return [];
}, $849102574a83a574$var$l = function(e) {
    var o, i, a = e.result, s = e.video, u = e.constraints, c = e.deviceId, f = e.scanDelay, l = (0, $7fPBF.useRef)(null), d = $849102574a83a574$export$6aa26f5ebe6471fc(u);
    return (0, $7fPBF.useEffect)(function() {
        if (void 0 !== a && null !== l.current && null !== s && 11 === a.getBarcodeFormat()) {
            var t = d[0];
            if (void 0 !== c && d.length > 1) {
                var e = d.find(function(t) {
                    return t.deviceId === c;
                });
                void 0 !== e && (t = e);
            }
            if (void 0 !== t && void 0 !== t.width) {
                var r = t.width / s.clientWidth, n = l.current, o = n.getContext("2d");
                if (null !== o) {
                    var i = setTimeout(function() {
                        o.clearRect(0, 0, n.width, n.height);
                    }, f);
                    o.strokeStyle = "rgba(0, 255, 0, 0.5)", o.lineWidth = 4;
                    var u = a.getResultPoints()[0];
                    o.beginPath(), o.arc(u.getX() / r, u.getY() / r, u.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    var h = a.getResultPoints()[1];
                    o.beginPath(), o.arc(h.getX() / r, h.getY() / r, h.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    var p = a.getResultPoints()[2];
                    if (o.beginPath(), o.arc(p.getX() / r, p.getY() / r, p.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath(), a.getResultPoints().length >= 4) {
                        var g = a.getResultPoints()[3];
                        o.beginPath(), o.arc(g.getX() / r, g.getY() / r, g.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    }
                    return function() {
                        return clearTimeout(i);
                    };
                }
            }
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("canvas", {
        ref: l,
        width: null !== (o = null == s ? void 0 : s.clientWidth) && void 0 !== o ? o : 0,
        height: null !== (i = null == s ? void 0 : s.clientHeight) && void 0 !== i ? i : 0,
        style: {
            position: "absolute",
            top: 0,
            zIndex: 2
        }
    });
}, $849102574a83a574$var$d = {
    count: {
        bottom: 0,
        right: 5,
        fontSize: 30,
        color: "#fff",
        position: "absolute",
        zIndex: 1
    }
}, $849102574a83a574$var$p = function(e) {
    var r = e.scanCount;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: $849102574a83a574$var$d.count
    }, r);
}, $849102574a83a574$var$g = function(n) {
    var i = n.scanCount, a = n.hideCount, s = n.tracker, u = n.border, c = void 0 === u ? 80 : u, f = n.result, h = n.video, d = n.constraints, g = n.deviceId, y = n.scanDelay, w = (0, $7fPBF.useState)("rgba(255, 0, 0, 0.5)"), v = w[0], _ = w[1];
    return (0, $7fPBF.useEffect)(function() {
        if (11 != (null == f ? void 0 : f.getBarcodeFormat()) || !s) {
            _("rgba(0, 255, 0, 0.5)");
            var t = setTimeout(function() {
                _("rgba(255, 0, 0, 0.5)");
            }, y);
            return function() {
                clearTimeout(t);
            };
        }
        _("rgba(255, 0, 0, 0.5)");
    }, [
        i
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, !a && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$p, {
        scanCount: i
    }), s && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$l, {
        video: h,
        result: f,
        constraints: d,
        deviceId: g,
        scanDelay: y
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 100 100",
        style: {
            top: 0,
            left: 0,
            zIndex: 1,
            boxSizing: "border-box",
            border: "".concat(c, "px solid rgba(0, 0, 0, 0.1)"),
            position: "absolute",
            width: "100%",
            height: "100%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M23,0 L0,0 L0,23",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M0,77 L0,100 L23,100",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M77,100 L100,100 L100,77",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M100,23 L100,0 77,0",
        stroke: v,
        strokeWidth: "5"
    })));
};
var $849102574a83a574$var$y, $849102574a83a574$var$w, $849102574a83a574$var$v, $849102574a83a574$var$_ = ($849102574a83a574$var$y = function(t, e) {
    return $849102574a83a574$var$y = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $849102574a83a574$var$y(t, e);
}, function(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $849102574a83a574$var$y(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $849102574a83a574$var$A = function(t) {
    function e(e, r) {
        var n, o, i, a = this.constructor, s = t.call(this, e, r) || this;
        return Object.defineProperty(s, "name", {
            value: a.name,
            enumerable: !1,
            configurable: !0
        }), n = s, o = a.prototype, (i = Object.setPrototypeOf) ? i(n, o) : n.__proto__ = o, function(t, e) {
            void 0 === e && (e = t.constructor);
            var r = Error.captureStackTrace;
            r && r(t, e);
        }(s), s;
    }
    return $849102574a83a574$var$_(e, t), e;
}(Error), $849102574a83a574$var$C = ($849102574a83a574$var$w = function(t, e) {
    return $849102574a83a574$var$w = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
    }, $849102574a83a574$var$w(t, e);
}, function(t, e) {
    function r() {
        this.constructor = t;
    }
    $849102574a83a574$var$w(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $849102574a83a574$var$m = function(t) {
    function e(e) {
        void 0 === e && (e = void 0);
        var r = t.call(this, e) || this;
        return r.message = e, r;
    }
    return $849102574a83a574$var$C(e, t), e.prototype.getKind = function() {
        return this.constructor.kind;
    }, e.kind = "Exception", e;
}($849102574a83a574$var$A), $849102574a83a574$var$E = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$I = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$E(e, t), e.kind = "ArgumentException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$S = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$T = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$S(e, t), e.kind = "IllegalArgumentException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$O = function() {
    function t(t) {
        if (this.binarizer = t, null === t) throw new $849102574a83a574$var$T("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(t, e) {
        return this.binarizer.getBlackRow(t, e);
    }, t.prototype.getBlackMatrix = function() {
        return null !== this.matrix && void 0 !== this.matrix || (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, r, n, o) {
        var i = this.binarizer.getLuminanceSource().crop(e, r, n, o);
        return new t(this.binarizer.createBinarizer(i));
    }, t.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (t) {
            return "";
        }
    }, t;
}(), $849102574a83a574$var$b = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$R = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$b(e, t), e.getChecksumInstance = function() {
        return new e;
    }, e.kind = "ChecksumException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$N = function() {
    function t(t) {
        this.source = t;
    }
    return t.prototype.getLuminanceSource = function() {
        return this.source;
    }, t.prototype.getWidth = function() {
        return this.source.getWidth();
    }, t.prototype.getHeight = function() {
        return this.source.getHeight();
    }, t;
}(), $849102574a83a574$var$D = function() {
    function t() {}
    return t.arraycopy = function(t, e, r, n, o) {
        for(; o--;)r[n++] = t[e++];
    }, t.currentTimeMillis = function() {
        return Date.now();
    }, t;
}(), $849102574a83a574$var$M = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$P = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$M(e, t), e.kind = "IndexOutOfBoundsException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$B = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$L = function(t) {
    function e(e, r) {
        void 0 === e && (e = void 0), void 0 === r && (r = void 0);
        var n = t.call(this, r) || this;
        return n.index = e, n.message = r, n;
    }
    return $849102574a83a574$var$B(e, t), e.kind = "ArrayIndexOutOfBoundsException", e;
}($849102574a83a574$var$P), $849102574a83a574$var$F = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$k = function() {
    function t() {}
    return t.fill = function(t, e) {
        for(var r = 0, n = t.length; r < n; r++)t[r] = e;
    }, t.fillWithin = function(e, r, n, o) {
        t.rangeCheck(e.length, r, n);
        for(var i = r; i < n; i++)e[i] = o;
    }, t.rangeCheck = function(t, e, r) {
        if (e > r) throw new $849102574a83a574$var$T("fromIndex(" + e + ") > toIndex(" + r + ")");
        if (e < 0) throw new $849102574a83a574$var$L(e);
        if (r > t) throw new $849102574a83a574$var$L(r);
    }, t.asList = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return t;
    }, t.create = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Array.from({
                length: e
            }).fill(r);
        });
    }, t.createInt32Array = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Int32Array.from({
                length: e
            }).fill(r);
        });
    }, t.equals = function(t, e) {
        if (!t) return !1;
        if (!e) return !1;
        if (!t.length) return !1;
        if (!e.length) return !1;
        if (t.length !== e.length) return !1;
        for(var r = 0, n = t.length; r < n; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, t.hashCode = function(t) {
        var e, r;
        if (null === t) return 0;
        var n = 1;
        try {
            for(var o = $849102574a83a574$var$F(t), i = o.next(); !i.done; i = o.next())n = 31 * n + i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.fillUint8Array = function(t, e) {
        for(var r = 0; r !== t.length; r++)t[r] = e;
    }, t.copyOf = function(t, e) {
        return t.slice(0, e);
    }, t.copyOfUint8Array = function(t, e) {
        if (t.length <= e) {
            var r = new Uint8Array(e);
            return r.set(t), r;
        }
        return t.slice(0, e);
    }, t.copyOfRange = function(t, e, r) {
        var n = r - e, o = new Int32Array(n);
        return $849102574a83a574$var$D.arraycopy(t, e, o, 0, n), o;
    }, t.binarySearch = function(e, r, n) {
        void 0 === n && (n = t.numberComparator);
        for(var o = 0, i = e.length - 1; o <= i;){
            var a = i + o >> 1, s = n(r, e[a]);
            if (s > 0) o = a + 1;
            else {
                if (!(s < 0)) return a;
                i = a - 1;
            }
        }
        return -o - 1;
    }, t.numberComparator = function(t, e) {
        return t - e;
    }, t;
}(), $849102574a83a574$var$x = function() {
    function t() {}
    return t.numberOfTrailingZeros = function(t) {
        var e;
        if (0 === t) return 32;
        var r = 31;
        return 0 !== (e = t << 16) && (r -= 16, t = e), 0 !== (e = t << 8) && (r -= 8, t = e), 0 !== (e = t << 4) && (r -= 4, t = e), 0 !== (e = t << 2) && (r -= 2, t = e), r - (t << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(t) {
        if (0 === t) return 32;
        var e = 1;
        return t >>> 16 == 0 && (e += 16, t <<= 16), t >>> 24 == 0 && (e += 8, t <<= 8), t >>> 28 == 0 && (e += 4, t <<= 4), t >>> 30 == 0 && (e += 2, t <<= 2), e -= t >>> 31;
    }, t.toHexString = function(t) {
        return t.toString(16);
    }, t.toBinaryString = function(t) {
        return String(parseInt(String(t), 2));
    }, t.bitCount = function(t) {
        return t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135, t += t >>> 8, 63 & (t += t >>> 16);
    }, t.truncDivision = function(t, e) {
        return Math.trunc(t / e);
    }, t.parseInt = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $849102574a83a574$var$V = function() {
    function t(e, r) {
        void 0 === e ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, this.bits = null == r ? t.makeArray(e) : r);
    }
    return t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
        if (e > 32 * this.bits.length) {
            var r = t.makeArray(e);
            $849102574a83a574$var$D.arraycopy(this.bits, 0, r, 0, this.bits.length), this.bits = r;
        }
    }, t.prototype.get = function(t) {
        return 0 != (this.bits[Math.floor(t / 32)] & 1 << (31 & t));
    }, t.prototype.set = function(t) {
        this.bits[Math.floor(t / 32)] |= 1 << (31 & t);
    }, t.prototype.flip = function(t) {
        this.bits[Math.floor(t / 32)] ^= 1 << (31 & t);
    }, t.prototype.getNextSet = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = r[n];
        }
        var a = 32 * n + $849102574a83a574$var$x.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.getNextUnset = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = ~r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = ~r[n];
        }
        var a = 32 * n + $849102574a83a574$var$x.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.setBulk = function(t, e) {
        this.bits[Math.floor(t / 32)] = e;
    }, t.prototype.setRange = function(t, e) {
        if (e < t || t < 0 || e > this.size) throw new $849102574a83a574$var$T;
        if (e !== t) {
            e--;
            for(var r = Math.floor(t / 32), n = Math.floor(e / 32), o = this.bits, i = r; i <= n; i++){
                var a = (2 << (i < n ? 31 : 31 & e)) - (1 << (i > r ? 0 : 31 & t));
                o[i] |= a;
            }
        }
    }, t.prototype.clear = function() {
        for(var t = this.bits.length, e = this.bits, r = 0; r < t; r++)e[r] = 0;
    }, t.prototype.isRange = function(t, e, r) {
        if (e < t || t < 0 || e > this.size) throw new $849102574a83a574$var$T;
        if (e === t) return !0;
        e--;
        for(var n = Math.floor(t / 32), o = Math.floor(e / 32), i = this.bits, a = n; a <= o; a++){
            var s = (2 << (a < o ? 31 : 31 & e)) - (1 << (a > n ? 0 : 31 & t)) & 4294967295;
            if ((i[a] & s) !== (r ? s : 0)) return !1;
        }
        return !0;
    }, t.prototype.appendBit = function(t) {
        this.ensureCapacity(this.size + 1), t && (this.bits[Math.floor(this.size / 32)] |= 1 << (31 & this.size)), this.size++;
    }, t.prototype.appendBits = function(t, e) {
        if (e < 0 || e > 32) throw new $849102574a83a574$var$T("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + e);
        for(var r = e; r > 0; r--)this.appendBit(1 == (t >> r - 1 & 1));
    }, t.prototype.appendBitArray = function(t) {
        var e = t.size;
        this.ensureCapacity(this.size + e);
        for(var r = 0; r < e; r++)this.appendBit(t.get(r));
    }, t.prototype.xor = function(t) {
        if (this.size !== t.size) throw new $849102574a83a574$var$T("Sizes don't match");
        for(var e = this.bits, r = 0, n = e.length; r < n; r++)e[r] ^= t.bits[r];
    }, t.prototype.toBytes = function(t, e, r, n) {
        for(var o = 0; o < n; o++){
            for(var i = 0, a = 0; a < 8; a++)this.get(t) && (i |= 1 << 7 - a), t++;
            e[r + o] = i;
        }
    }, t.prototype.getBitArray = function() {
        return this.bits;
    }, t.prototype.reverse = function() {
        for(var t = new Int32Array(this.bits.length), e = Math.floor((this.size - 1) / 32), r = e + 1, n = this.bits, o = 0; o < r; o++){
            var i = n[o];
            i = (i = (i = (i = (i = i >> 1 & 1431655765 | (1431655765 & i) << 1) >> 2 & 858993459 | (858993459 & i) << 2) >> 4 & 252645135 | (252645135 & i) << 4) >> 8 & 16711935 | (16711935 & i) << 8) >> 16 & 65535 | (65535 & i) << 16, t[e - o] = i;
        }
        if (this.size !== 32 * r) {
            var a = 32 * r - this.size, s = t[0] >>> a;
            for(o = 1; o < r; o++){
                var u = t[o];
                s |= u << 32 - a, t[o - 1] = s, s = u >>> a;
            }
            t[r - 1] = s;
        }
        this.bits = t;
    }, t.makeArray = function(t) {
        return new Int32Array(Math.floor((t + 31) / 32));
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.size === r.size && $849102574a83a574$var$k.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        return 31 * this.size + $849102574a83a574$var$k.hashCode(this.bits);
    }, t.prototype.toString = function() {
        for(var t = "", e = 0, r = this.size; e < r; e++)0 == (7 & e) && (t += " "), t += this.get(e) ? "X" : ".";
        return t;
    }, t.prototype.clone = function() {
        return new t(this.size, this.bits.slice());
    }, t.prototype.toArray = function() {
        for(var t = [], e = 0, r = this.size; e < r; e++)t.push(this.get(e));
        return t;
    }, t;
}();
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
}($849102574a83a574$var$v || ($849102574a83a574$var$v = {}));
var $849102574a83a574$var$H, $849102574a83a574$var$U = $849102574a83a574$var$v, $849102574a83a574$var$X = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$G = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$X(e, t), e.getFormatInstance = function() {
        return new e;
    }, e.kind = "FormatException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$W = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
}($849102574a83a574$var$H || ($849102574a83a574$var$H = {}));
var $849102574a83a574$var$z, $849102574a83a574$var$j = function() {
    function t(e, r, n) {
        for(var o, i, a = [], s = 3; s < arguments.length; s++)a[s - 3] = arguments[s];
        this.valueIdentifier = e, this.name = n, this.values = "number" == typeof r ? Int32Array.from([
            r
        ]) : r, this.otherEncodingNames = a, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(n, this);
        for(var u = this.values, c = 0, f = u.length; c !== f; c++){
            var h = u[c];
            t.VALUES_TO_ECI.set(h, this);
        }
        try {
            for(var l = $849102574a83a574$var$W(a), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                t.NAME_TO_ECI.set(p, this);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
    }
    return t.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    }, t.prototype.getName = function() {
        return this.name;
    }, t.prototype.getValue = function() {
        return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
        if (e < 0 || e >= 900) throw new $849102574a83a574$var$G("incorect value");
        var r = t.VALUES_TO_ECI.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$G("incorect value");
        return r;
    }, t.getCharacterSetECIByName = function(e) {
        var r = t.NAME_TO_ECI.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$G("incorect value");
        return r;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.getName() === r.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = new Map, t.VALUES_TO_ECI = new Map, t.NAME_TO_ECI = new Map, t.Cp437 = new t($849102574a83a574$var$H.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437"), t.ISO8859_1 = new t($849102574a83a574$var$H.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t($849102574a83a574$var$H.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t($849102574a83a574$var$H.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t($849102574a83a574$var$H.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t($849102574a83a574$var$H.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t($849102574a83a574$var$H.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t($849102574a83a574$var$H.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t($849102574a83a574$var$H.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t($849102574a83a574$var$H.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t($849102574a83a574$var$H.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t($849102574a83a574$var$H.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t($849102574a83a574$var$H.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t($849102574a83a574$var$H.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t($849102574a83a574$var$H.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t($849102574a83a574$var$H.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t($849102574a83a574$var$H.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t($849102574a83a574$var$H.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t($849102574a83a574$var$H.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t($849102574a83a574$var$H.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t($849102574a83a574$var$H.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t($849102574a83a574$var$H.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t($849102574a83a574$var$H.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t($849102574a83a574$var$H.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII"), t.Big5 = new t($849102574a83a574$var$H.Big5, 28, "Big5"), t.GB18030 = new t($849102574a83a574$var$H.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t($849102574a83a574$var$H.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
}(), $849102574a83a574$var$Y = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Z = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Y(e, t), e.kind = "UnsupportedOperationException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$K = function() {
    function t() {}
    return t.decode = function(t, e) {
        var r = this.encodingName(e);
        return this.customDecoder ? this.customDecoder(t, r) : "undefined" == typeof TextDecoder || this.shouldDecodeOnFallback(r) ? this.decodeFallback(t, r) : new TextDecoder(r).decode(t);
    }, t.shouldDecodeOnFallback = function(e) {
        return !t.isBrowser() && "ISO-8859-1" === e;
    }, t.encode = function(t, e) {
        var r = this.encodingName(e);
        return this.customEncoder ? this.customEncoder(t, r) : "undefined" == typeof TextEncoder ? this.encodeFallback(t) : (new TextEncoder).encode(t);
    }, t.isBrowser = function() {
        return "undefined" != typeof window && "[object Window]" === ({}).toString.call(window);
    }, t.encodingName = function(t) {
        return "string" == typeof t ? t : t.getName();
    }, t.encodingCharacterSet = function(t) {
        return t instanceof $849102574a83a574$var$j ? t : $849102574a83a574$var$j.getCharacterSetECIByName(t);
    }, t.decodeFallback = function(e, r) {
        var n = this.encodingCharacterSet(r);
        if (t.isDecodeFallbackSupported(n)) {
            for(var o = "", i = 0, a = e.length; i < a; i++){
                var s = e[i].toString(16);
                s.length < 2 && (s = "0" + s), o += "%" + s;
            }
            return decodeURIComponent(o);
        }
        if (n.equals($849102574a83a574$var$j.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        throw new $849102574a83a574$var$Z("Encoding " + this.encodingName(r) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(t) {
        return t.equals($849102574a83a574$var$j.UTF8) || t.equals($849102574a83a574$var$j.ISO8859_1) || t.equals($849102574a83a574$var$j.ASCII);
    }, t.encodeFallback = function(t) {
        for(var e = btoa(unescape(encodeURIComponent(t))).split(""), r = [], n = 0; n < e.length; n++)r.push(e[n].charCodeAt(0));
        return new Uint8Array(r);
    }, t;
}(), $849102574a83a574$var$q = function() {
    function t() {}
    return t.castAsNonUtf8Char = function(t, e) {
        void 0 === e && (e = null);
        var r = e ? e.getName() : this.ISO88591;
        return $849102574a83a574$var$K.decode(new Uint8Array([
            t
        ]), r);
    }, t.guessEncoding = function(e, r) {
        if (null != r && void 0 !== r.get($849102574a83a574$var$U.CHARACTER_SET)) return r.get($849102574a83a574$var$U.CHARACTER_SET).toString();
        for(var n = e.length, o = !0, i = !0, a = !0, s = 0, u = 0, c = 0, f = 0, h = 0, l = 0, d = 0, p = 0, g = 0, y = 0, w = 0, v = e.length > 3 && 239 === e[0] && 187 === e[1] && 191 === e[2], _ = 0; _ < n && (o || i || a); _++){
            var A = 255 & e[_];
            a && (s > 0 ? 0 == (128 & A) ? a = !1 : s-- : 0 != (128 & A) && (0 == (64 & A) ? a = !1 : (s++, 0 == (32 & A) ? u++ : (s++, 0 == (16 & A) ? c++ : (s++, 0 == (8 & A) ? f++ : a = !1))))), o && (A > 127 && A < 160 ? o = !1 : A > 159 && (A < 192 || 215 === A || 247 === A) && w++), i && (h > 0 ? A < 64 || 127 === A || A > 252 ? i = !1 : h-- : 128 === A || 160 === A || A > 239 ? i = !1 : A > 160 && A < 224 ? (l++, p = 0, ++d > g && (g = d)) : A > 127 ? (h++, d = 0, ++p > y && (y = p)) : (d = 0, p = 0));
        }
        return a && s > 0 && (a = !1), i && h > 0 && (i = !1), a && (v || u + c + f > 0) ? t.UTF8 : i && (t.ASSUME_SHIFT_JIS || g >= 3 || y >= 3) ? t.SHIFT_JIS : o && i ? 2 === g && 2 === l || 10 * w >= n ? t.SHIFT_JIS : t.ISO88591 : o ? t.ISO88591 : i ? t.SHIFT_JIS : a ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        var n = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, r, o, i, a, s) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++n]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var u, c = a ? parseInt(a.substr(1)) : void 0;
                switch(s){
                    case "s":
                        u = e[n];
                        break;
                    case "c":
                        u = e[n][0];
                        break;
                    case "f":
                        u = parseFloat(e[n]).toFixed(t);
                        break;
                    case "p":
                        u = parseFloat(e[n]).toPrecision(t);
                        break;
                    case "e":
                        u = parseFloat(e[n]).toExponential(t);
                        break;
                    case "x":
                        u = parseInt(e[n]).toString(c || 16);
                        break;
                    case "d":
                        u = parseFloat(parseInt(e[n], c || 10).toPrecision(t)).toFixed(0);
                }
                u = "object" == typeof u ? JSON.stringify(u) : (+u).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; u.length < f;)u = void 0 !== r ? u + h : h + u;
                return u;
            }
        });
    }, t.getBytes = function(t, e) {
        return $849102574a83a574$var$K.encode(t, e);
    }, t.getCharCode = function(t, e) {
        return void 0 === e && (e = 0), t.charCodeAt(e);
    }, t.getCharAt = function(t) {
        return String.fromCharCode(t);
    }, t.SHIFT_JIS = $849102574a83a574$var$j.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = $849102574a83a574$var$j.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = $849102574a83a574$var$j.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
}(), $849102574a83a574$var$Q = function() {
    function t(t) {
        void 0 === t && (t = ""), this.value = t;
    }
    return t.prototype.enableDecoding = function(t) {
        return this.encoding = t, this;
    }, t.prototype.append = function(t) {
        return "string" == typeof t ? this.value += t.toString() : this.encoding ? this.value += $849102574a83a574$var$q.castAsNonUtf8Char(t, this.encoding) : this.value += String.fromCharCode(t), this;
    }, t.prototype.appendChars = function(t, e, r) {
        for(var n = e; e < e + r; n++)this.append(t[n]);
        return this;
    }, t.prototype.length = function() {
        return this.value.length;
    }, t.prototype.charAt = function(t) {
        return this.value.charAt(t);
    }, t.prototype.deleteCharAt = function(t) {
        this.value = this.value.substr(0, t) + this.value.substring(t + 1);
    }, t.prototype.setCharAt = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + 1);
    }, t.prototype.substring = function(t, e) {
        return this.value.substring(t, e);
    }, t.prototype.setLengthToZero = function() {
        this.value = "";
    }, t.prototype.toString = function() {
        return this.value;
    }, t.prototype.insert = function(t, e) {
        this.value = this.value.substring(0, t) + e + this.value.substring(t);
    }, t;
}(), $849102574a83a574$var$J = function() {
    function t(t, e, r, n) {
        if (this.width = t, this.height = e, this.rowSize = r, this.bits = n, null == e && (e = t), this.height = e, t < 1 || e < 1) throw new $849102574a83a574$var$T("Both dimensions must be greater than 0");
        null == r && (r = Math.floor((t + 31) / 32)), this.rowSize = r, null == n && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
        for(var r = e.length, n = e[0].length, o = new t(n, r), i = 0; i < r; i++)for(var a = e[i], s = 0; s < n; s++)a[s] && o.set(s, i);
        return o;
    }, t.parseFromString = function(e, r, n) {
        if (null === e) throw new $849102574a83a574$var$T("stringRepresentation cannot be null");
        for(var o = new Array(e.length), i = 0, a = 0, s = -1, u = 0, c = 0; c < e.length;)if ("\n" === e.charAt(c) || "\r" === e.charAt(c)) {
            if (i > a) {
                if (-1 === s) s = i - a;
                else if (i - a !== s) throw new $849102574a83a574$var$T("row lengths do not match");
                a = i, u++;
            }
            c++;
        } else if (e.substring(c, c + r.length) === r) c += r.length, o[i] = !0, i++;
        else {
            if (e.substring(c, c + n.length) !== n) throw new $849102574a83a574$var$T("illegal character encountered: " + e.substring(c));
            c += n.length, o[i] = !1, i++;
        }
        if (i > a) {
            if (-1 === s) s = i - a;
            else if (i - a !== s) throw new $849102574a83a574$var$T("row lengths do not match");
            u++;
        }
        for(var f = new t(s, u), h = 0; h < i; h++)o[h] && f.set(Math.floor(h % s), Math.floor(h / s));
        return f;
    }, t.prototype.get = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        return 0 != (this.bits[r] >>> (31 & t) & 1);
    }, t.prototype.set = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] |= 1 << (31 & t) & 4294967295;
    }, t.prototype.unset = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] &= ~(1 << (31 & t) & 4294967295);
    }, t.prototype.flip = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] ^= 1 << (31 & t) & 4294967295;
    }, t.prototype.xor = function(t) {
        if (this.width !== t.getWidth() || this.height !== t.getHeight() || this.rowSize !== t.getRowSize()) throw new $849102574a83a574$var$T("input matrix dimensions do not match");
        for(var e = new $849102574a83a574$var$V(Math.floor(this.width / 32) + 1), r = this.rowSize, n = this.bits, o = 0, i = this.height; o < i; o++)for(var a = o * r, s = t.getRow(o, e).getBitArray(), u = 0; u < r; u++)n[a + u] ^= s[u];
    }, t.prototype.clear = function() {
        for(var t = this.bits, e = t.length, r = 0; r < e; r++)t[r] = 0;
    }, t.prototype.setRegion = function(t, e, r, n) {
        if (e < 0 || t < 0) throw new $849102574a83a574$var$T("Left and top must be nonnegative");
        if (n < 1 || r < 1) throw new $849102574a83a574$var$T("Height and width must be at least 1");
        var o = t + r, i = e + n;
        if (i > this.height || o > this.width) throw new $849102574a83a574$var$T("The region must fit inside the matrix");
        for(var a = this.rowSize, s = this.bits, u = e; u < i; u++)for(var c = u * a, f = t; f < o; f++)s[c + Math.floor(f / 32)] |= 1 << (31 & f) & 4294967295;
    }, t.prototype.getRow = function(t, e) {
        null == e || e.getSize() < this.width ? e = new $849102574a83a574$var$V(this.width) : e.clear();
        for(var r = this.rowSize, n = this.bits, o = t * r, i = 0; i < r; i++)e.setBulk(32 * i, n[o + i]);
        return e;
    }, t.prototype.setRow = function(t, e) {
        $849102574a83a574$var$D.arraycopy(e.getBitArray(), 0, this.bits, t * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
        for(var t = this.getWidth(), e = this.getHeight(), r = new $849102574a83a574$var$V(t), n = new $849102574a83a574$var$V(t), o = 0, i = Math.floor((e + 1) / 2); o < i; o++)r = this.getRow(o, r), n = this.getRow(e - 1 - o, n), r.reverse(), n.reverse(), this.setRow(o, n), this.setRow(e - 1 - o, r);
    }, t.prototype.getEnclosingRectangle = function() {
        for(var t = this.width, e = this.height, r = this.rowSize, n = this.bits, o = t, i = e, a = -1, s = -1, u = 0; u < e; u++)for(var c = 0; c < r; c++){
            var f = n[u * r + c];
            if (0 !== f) {
                if (u < i && (i = u), u > s && (s = u), 32 * c < o) {
                    for(var h = 0; 0 == (f << 31 - h & 4294967295);)h++;
                    32 * c + h < o && (o = 32 * c + h);
                }
                if (32 * c + 31 > a) {
                    for(h = 31; f >>> h == 0;)h--;
                    32 * c + h > a && (a = 32 * c + h);
                }
            }
        }
        return a < o || s < i ? null : Int32Array.from([
            o,
            i,
            a - o + 1,
            s - i + 1
        ]);
    }, t.prototype.getTopLeftOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = 0; r < e.length && 0 === e[r];)r++;
        if (r === e.length) return null;
        for(var n = r / t, o = r % t * 32, i = e[r], a = 0; 0 == (i << 31 - a & 4294967295);)a++;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getBottomRightOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = e.length - 1; r >= 0 && 0 === e[r];)r--;
        if (r < 0) return null;
        for(var n = Math.floor(r / t), o = 32 * Math.floor(r % t), i = e[r], a = 31; i >>> a == 0;)a--;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getRowSize = function() {
        return this.rowSize;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.width === r.width && this.height === r.height && this.rowSize === r.rowSize && $849102574a83a574$var$k.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        var t = this.width;
        return t = 31 * (t = 31 * (t = 31 * (t = 31 * t + this.width) + this.height) + this.rowSize) + $849102574a83a574$var$k.hashCode(this.bits);
    }, t.prototype.toString = function(t, e, r) {
        return void 0 === t && (t = "X "), void 0 === e && (e = "  "), void 0 === r && (r = "\n"), this.buildToString(t, e, r);
    }, t.prototype.buildToString = function(t, e, r) {
        for(var n = new $849102574a83a574$var$Q, o = 0, i = this.height; o < i; o++){
            for(var a = 0, s = this.width; a < s; a++)n.append(this.get(a, o) ? t : e);
            n.append(r);
        }
        return n.toString();
    }, t.prototype.clone = function() {
        return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
}(), $849102574a83a574$var$$ = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$tt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$$(e, t), e.getNotFoundInstance = function() {
        return new e;
    }, e.kind = "NotFoundException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$et = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$rt = function(t) {
    function e(r) {
        var n = t.call(this, r) || this;
        return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return $849102574a83a574$var$et(e, t), e.prototype.getBlackRow = function(t, r) {
        var n = this.getLuminanceSource(), o = n.getWidth();
        null == r || r.getSize() < o ? r = new $849102574a83a574$var$V(o) : r.clear(), this.initArrays(o);
        for(var i = n.getRow(t, this.luminances), a = this.buckets, s = 0; s < o; s++)a[(255 & i[s]) >> e.LUMINANCE_SHIFT]++;
        var u = e.estimateBlackPoint(a);
        if (o < 3) for(s = 0; s < o; s++)(255 & i[s]) < u && r.set(s);
        else {
            var c = 255 & i[0], f = 255 & i[1];
            for(s = 1; s < o - 1; s++){
                var h = 255 & i[s + 1];
                (4 * f - c - h) / 2 < u && r.set(s), c = f, f = h;
            }
        }
        return r;
    }, e.prototype.getBlackMatrix = function() {
        var t = this.getLuminanceSource(), r = t.getWidth(), n = t.getHeight(), o = new $849102574a83a574$var$J(r, n);
        this.initArrays(r);
        for(var i = this.buckets, a = 1; a < 5; a++)for(var s = Math.floor(n * a / 5), u = t.getRow(s, this.luminances), c = Math.floor(4 * r / 5), f = Math.floor(r / 5); f < c; f++)i[(255 & u[f]) >> e.LUMINANCE_SHIFT]++;
        var h = e.estimateBlackPoint(i), l = t.getMatrix();
        for(a = 0; a < n; a++){
            var d = a * r;
            for(f = 0; f < r; f++)(255 & l[d + f]) < h && o.set(f, a);
        }
        return o;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.prototype.initArrays = function(t) {
        this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
        for(var r = this.buckets, n = 0; n < e.LUMINANCE_BUCKETS; n++)r[n] = 0;
    }, e.estimateBlackPoint = function(t) {
        for(var r = t.length, n = 0, o = 0, i = 0, a = 0; a < r; a++)t[a] > i && (o = a, i = t[a]), t[a] > n && (n = t[a]);
        var s = 0, u = 0;
        for(a = 0; a < r; a++){
            var c = a - o;
            (d = t[a] * c * c) > u && (s = a, u = d);
        }
        if (o > s) {
            var f = o;
            o = s, s = f;
        }
        if (s - o <= r / 16) throw new $849102574a83a574$var$tt;
        var h = s - 1, l = -1;
        for(a = s - 1; a > o; a--){
            var d, p = a - o;
            (d = p * p * (s - a) * (n - t[a])) > l && (h = a, l = d);
        }
        return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([
        0
    ]), e;
}($849102574a83a574$var$N), $849102574a83a574$var$nt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ot = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.matrix = null, r;
    }
    return $849102574a83a574$var$nt(e, t), e.prototype.getBlackMatrix = function() {
        if (null !== this.matrix) return this.matrix;
        var r = this.getLuminanceSource(), n = r.getWidth(), o = r.getHeight();
        if (n >= e.MINIMUM_DIMENSION && o >= e.MINIMUM_DIMENSION) {
            var i = r.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
            0 != (n & e.BLOCK_SIZE_MASK) && a++;
            var s = o >> e.BLOCK_SIZE_POWER;
            0 != (o & e.BLOCK_SIZE_MASK) && s++;
            var u = e.calculateBlackPoints(i, a, s, n, o), c = new $849102574a83a574$var$J(n, o);
            e.calculateThresholdForBlock(i, a, s, n, o, u, c), this.matrix = c;
        } else this.matrix = t.prototype.getBlackMatrix.call(this);
        return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.calculateThresholdForBlock = function(t, r, n, o, i, a, s) {
        for(var u = i - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, f = 0; f < n; f++){
            var h = f << e.BLOCK_SIZE_POWER;
            h > u && (h = u);
            for(var l = e.cap(f, 2, n - 3), d = 0; d < r; d++){
                var p = d << e.BLOCK_SIZE_POWER;
                p > c && (p = c);
                for(var g = e.cap(d, 2, r - 3), y = 0, w = -2; w <= 2; w++){
                    var v = a[l + w];
                    y += v[g - 2] + v[g - 1] + v[g] + v[g + 1] + v[g + 2];
                }
                var _ = y / 25;
                e.thresholdBlock(t, p, h, _, o, s);
            }
        }
    }, e.cap = function(t, e, r) {
        return t < e ? e : t > r ? r : t;
    }, e.thresholdBlock = function(t, r, n, o, i, a) {
        for(var s = 0, u = n * i + r; s < e.BLOCK_SIZE; s++, u += i)for(var c = 0; c < e.BLOCK_SIZE; c++)(255 & t[u + c]) <= o && a.set(r + c, n + s);
    }, e.calculateBlackPoints = function(t, r, n, o, i) {
        for(var a = i - e.BLOCK_SIZE, s = o - e.BLOCK_SIZE, u = new Array(n), c = 0; c < n; c++){
            u[c] = new Int32Array(r);
            var f = c << e.BLOCK_SIZE_POWER;
            f > a && (f = a);
            for(var h = 0; h < r; h++){
                var l = h << e.BLOCK_SIZE_POWER;
                l > s && (l = s);
                for(var d = 0, p = 255, g = 0, y = 0, w = f * o + l; y < e.BLOCK_SIZE; y++, w += o){
                    for(var v = 0; v < e.BLOCK_SIZE; v++){
                        var _ = 255 & t[w + v];
                        d += _, _ < p && (p = _), _ > g && (g = _);
                    }
                    if (g - p > e.MIN_DYNAMIC_RANGE) for(y++, w += o; y < e.BLOCK_SIZE; y++, w += o)for(v = 0; v < e.BLOCK_SIZE; v++)d += 255 & t[w + v];
                }
                var A = d >> 2 * e.BLOCK_SIZE_POWER;
                if (g - p <= e.MIN_DYNAMIC_RANGE && (A = p / 2, c > 0 && h > 0)) {
                    var C = (u[c - 1][h] + 2 * u[c][h - 1] + u[c - 1][h - 1]) / 4;
                    p < C && (A = C);
                }
                u[c][h] = A;
            }
        }
        return u;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = 5 * e.BLOCK_SIZE, e.MIN_DYNAMIC_RANGE = 24, e;
}($849102574a83a574$var$rt), $849102574a83a574$var$it = function() {
    function t(t, e) {
        this.width = t, this.height = e;
    }
    return t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.isCropSupported = function() {
        return !1;
    }, t.prototype.crop = function(t, e, r, n) {
        throw new $849102574a83a574$var$Z("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
        return !1;
    }, t.prototype.rotateCounterClockwise = function() {
        throw new $849102574a83a574$var$Z("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
        throw new $849102574a83a574$var$Z("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
        for(var t = new Uint8ClampedArray(this.width), e = new $849102574a83a574$var$Q, r = 0; r < this.height; r++){
            for(var n = this.getRow(r, t), o = 0; o < this.width; o++){
                var i = 255 & n[o], a = void 0;
                a = i < 64 ? "#" : i < 128 ? "+" : i < 192 ? "." : " ", e.append(a);
            }
            e.append("\n");
        }
        return e.toString();
    }, t;
}(), $849102574a83a574$var$at = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$st = function(t) {
    function e(e) {
        var r = t.call(this, e.getWidth(), e.getHeight()) || this;
        return r.delegate = e, r;
    }
    return $849102574a83a574$var$at(e, t), e.prototype.getRow = function(t, e) {
        for(var r = this.delegate.getRow(t, e), n = this.getWidth(), o = 0; o < n; o++)r[o] = 255 - (255 & r[o]);
        return r;
    }, e.prototype.getMatrix = function() {
        for(var t = this.delegate.getMatrix(), e = this.getWidth() * this.getHeight(), r = new Uint8ClampedArray(e), n = 0; n < e; n++)r[n] = 255 - (255 & t[n]);
        return r;
    }, e.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.delegate.crop(t, r, n, o));
    }, e.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
        return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
        return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
        return new e(this.delegate.rotateCounterClockwise45());
    }, e;
}($849102574a83a574$var$it), $849102574a83a574$var$ut = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ct = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $849102574a83a574$var$ut(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d").getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(r.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, r, n) {
        var o = new Uint8ClampedArray(r * n);
        if (e.FRAME_INDEX = !e.FRAME_INDEX, e.FRAME_INDEX) for(var i = 0, a = 0, s = t.length; i < s; i += 4, a++){
            var u = void 0;
            if (0 === t[i + 3]) u = 255;
            else u = 306 * t[i] + 601 * t[i + 1] + 117 * t[i + 2] + 512 >> 10;
            o[a] = u;
        }
        else {
            i = 0, a = 0;
            for(var c = t.length; i < c; i += 4, a++){
                u = void 0;
                if (0 === t[i + 3]) u = 255;
                else u = 306 * t[i] + 601 * t[i + 1] + 117 * t[i + 2] + 512 >> 10;
                o[a] = 255 - u;
            }
        }
        return o;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement(), n = r.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, i = this.canvas.width, a = this.canvas.height, s = Math.ceil(Math.abs(Math.cos(o)) * i + Math.abs(Math.sin(o)) * a), u = Math.ceil(Math.abs(Math.sin(o)) * i + Math.abs(Math.cos(o)) * a);
        return r.width = s, r.height = u, n.translate(s / 2, u / 2), n.rotate(o), n.drawImage(this.canvas, i / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e.FRAME_INDEX = !0, e;
}($849102574a83a574$var$it), $849102574a83a574$var$ft = function() {
    function t(t, e, r) {
        this.deviceId = t, this.label = e, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    }, t;
}(), $849102574a83a574$var$ht = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                u(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                u(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, s);
        }
        u((n = n.apply(t, e || [])).next());
    });
}, $849102574a83a574$var$lt = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(i) {
        return function(s) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                s
            ]);
        };
    }
}, $849102574a83a574$var$dt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$pt = function() {
    function t(t, e, r) {
        void 0 === e && (e = 500), this.reader = t, this.timeBetweenScansMillis = e, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
        get: function() {
            return "undefined" != typeof navigator;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
        get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
        get: function() {
            return !(!this.isMediaDevicesSuported || !navigator.mediaDevices.enumerateDevices);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
        get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        set: function(t) {
            this._timeBetweenDecodingAttempts = t < 0 ? 0 : t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
        get: function() {
            return this._hints;
        },
        set: function(t) {
            this._hints = t || null;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, s, u, c, f, h;
            return $849102574a83a574$var$lt(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $849102574a83a574$var$dt(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, s = o.label || "Video device " + (e.length + 1), u = o.groupId, c = {
                                deviceId: a,
                                label: s,
                                kind: i,
                                groupId: u
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.getVideoInputDevices = function() {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return [
                            2,
                            t.sent().map(function(t) {
                                return new $849102574a83a574$var$ft(t.deviceId, t.label);
                            })
                        ];
                }
            });
        });
    }, t.prototype.findDeviceById = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var e;
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return (e = r.sent()) ? [
                            2,
                            e.find(function(e) {
                                return e.deviceId === t;
                            })
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDevice = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.decodeOnceFromVideoDevice(t, e)
                        ];
                    case 1:
                        return [
                            2,
                            r.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnce(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.decodeFromVideoDevice(t, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(n, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeFromStream(n, e, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeContinuously(n, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this.prepareVideoElement(e), this.addVideoSource(r, t), this.videoElement = r, this.stream = t, [
                            4,
                            this.playVideoOnLoadAsync(r)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.playVideoOnLoadAsync = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            return e.playVideoOnLoad(t, function() {
                return r();
            });
        });
    }, t.prototype.playVideoOnLoad = function(t, e) {
        var r = this;
        this.videoEndedListener = function() {
            return r.stopStreams();
        }, this.videoCanPlayListener = function() {
            return r.tryPlayVideo(t);
        }, t.addEventListener("ended", this.videoEndedListener), t.addEventListener("canplay", this.videoCanPlayListener), t.addEventListener("playing", e), this.tryPlayVideo(t);
    }, t.prototype.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && !t.ended && t.readyState > 2;
    }, t.prototype.tryPlayVideo = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.isVideoPlaying(t)) return console.warn("Trying to play video that is already playing."), [
                            2
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            t.play()
                        ];
                    case 2:
                        return e.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return e.sent(), console.warn("It was not possible to play the video."), [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $849102574a83a574$var$I("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $849102574a83a574$var$I("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.prototype.decodeFromImage = function(t, e) {
        if (!t && !e) throw new $849102574a83a574$var$I("either imageElement with a src set or an url must be provided");
        return e && !t ? this.decodeFromImageUrl(e) : this.decodeFromImageElement(t);
    }, t.prototype.decodeFromVideo = function(t, e) {
        if (!t && !e) throw new $849102574a83a574$var$I("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrl(e) : this.decodeFromVideoElement(t);
    }, t.prototype.decodeFromVideoContinuously = function(t, e, r) {
        if (void 0 === t && void 0 === e) throw new $849102574a83a574$var$I("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrlContinuously(e, r) : this.decodeFromVideoElementContinuously(t, r);
    }, t.prototype.decodeFromImageElement = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An image element must be provided.");
        this.reset();
        var e = this.prepareImageElement(t);
        return this.imageElement = e, this.isImageLoaded(e) ? this.decodeOnce(e, !1, !0) : this._decodeOnLoadImage(e);
    }, t.prototype.decodeFromVideoElement = function(t) {
        var e = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideo(e);
    }, t.prototype.decodeFromVideoElementContinuously = function(t, e) {
        var r = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideoContinuously(r, e);
    }, t.prototype._decodeFromVideoElementSetup = function(t) {
        if (!t) throw new $849102574a83a574$var$I("A video element must be provided.");
        this.reset();
        var e = this.prepareVideoElement(t);
        return this.videoElement = e, e;
    }, t.prototype.decodeFromImageUrl = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var e = this.prepareImageElement();
        this.imageElement = e;
        var r = this._decodeOnLoadImage(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrl = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var e = this.prepareVideoElement(), r = this.decodeFromVideoElement(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(t, e) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var r = this.prepareVideoElement(), n = this.decodeFromVideoElementContinuously(r, e);
        return r.src = t, n;
    }, t.prototype._decodeOnLoadImage = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            e.imageLoadedListener = function() {
                return e.decodeOnce(t, !1, !0).then(r, n);
            }, t.addEventListener("load", e.imageLoadedListener);
        });
    }, t.prototype._decodeOnLoadVideo = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.decodeOnce(t)
                        ];
                    case 2:
                        return [
                            2,
                            e.sent()
                        ];
                }
            });
        });
    }, t.prototype._decodeOnLoadVideoContinuously = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return r.sent(), this.decodeContinuously(t, e), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.prototype.prepareImageElement = function(t) {
        var e;
        return void 0 === t && ((e = document.createElement("img")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "img")), t instanceof HTMLImageElement && (e = t), e;
    }, t.prototype.prepareVideoElement = function(t) {
        var e;
        return t || "undefined" == typeof document || ((e = document.createElement("video")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "video")), t instanceof HTMLVideoElement && (e = t), e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e;
    }, t.prototype.decodeOnce = function(t, e, r) {
        var n = this;
        void 0 === e && (e = !0), void 0 === r && (r = !0), this._stopAsyncDecode = !1;
        var o = function(i, a) {
            if (n._stopAsyncDecode) return a(new $849102574a83a574$var$tt("Video stream has ended before any code could be detected.")), void (n._stopAsyncDecode = void 0);
            try {
                i(n.decode(t));
            } catch (t) {
                if (e && t instanceof $849102574a83a574$var$tt || (t instanceof $849102574a83a574$var$R || t instanceof $849102574a83a574$var$G) && r) return setTimeout(o, n._timeBetweenDecodingAttempts, i, a);
                a(t);
            }
        };
        return new Promise(function(t, e) {
            return o(t, e);
        });
    }, t.prototype.decodeContinuously = function(t, e) {
        var r = this;
        this._stopContinuousDecode = !1;
        var n = function() {
            if (r._stopContinuousDecode) r._stopContinuousDecode = void 0;
            else try {
                var o = r.decode(t);
                e(o, null), setTimeout(n, r.timeBetweenScansMillis);
            } catch (t) {
                e(null, t), (t instanceof $849102574a83a574$var$R || t instanceof $849102574a83a574$var$G || t instanceof $849102574a83a574$var$tt) && setTimeout(n, r._timeBetweenDecodingAttempts);
            }
        };
        n();
    }, t.prototype.decode = function(t) {
        var e = this.createBinaryBitmap(t);
        return this.decodeBitmap(e);
    }, t.prototype.createBinaryBitmap = function(t) {
        this.getCaptureCanvasContext(t), t instanceof HTMLVideoElement ? this.drawFrameOnCanvas(t) : this.drawImageOnCanvas(t);
        var e = this.getCaptureCanvas(t), r = new $849102574a83a574$var$ct(e), n = new $849102574a83a574$var$ot(r);
        return new $849102574a83a574$var$O(n);
    }, t.prototype.getCaptureCanvasContext = function(t) {
        if (!this.captureCanvasContext) {
            var e = this.getCaptureCanvas(t), r = void 0;
            try {
                r = e.getContext("2d", {
                    willReadFrequently: !0
                });
            } catch (t) {
                r = e.getContext("2d");
            }
            this.captureCanvasContext = r;
        }
        return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(t) {
        if (!this.captureCanvas) {
            var e = this.createCaptureCanvas(t);
            this.captureCanvas = e;
        }
        return this.captureCanvas;
    }, t.prototype.drawFrameOnCanvas = function(t, e, r) {
        void 0 === e && (e = {
            sx: 0,
            sy: 0,
            sWidth: t.videoWidth,
            sHeight: t.videoHeight,
            dx: 0,
            dy: 0,
            dWidth: t.videoWidth,
            dHeight: t.videoHeight
        }), void 0 === r && (r = this.captureCanvasContext), r.drawImage(t, e.sx, e.sy, e.sWidth, e.sHeight, e.dx, e.dy, e.dWidth, e.dHeight);
    }, t.prototype.drawImageOnCanvas = function(t, e, r) {
        void 0 === e && (e = {
            sx: 0,
            sy: 0,
            sWidth: t.naturalWidth,
            sHeight: t.naturalHeight,
            dx: 0,
            dy: 0,
            dWidth: t.naturalWidth,
            dHeight: t.naturalHeight
        }), void 0 === r && (r = this.captureCanvasContext), r.drawImage(t, e.sx, e.sy, e.sWidth, e.sHeight, e.dx, e.dy, e.dWidth, e.dHeight);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this._hints);
    }, t.prototype.createCaptureCanvas = function(t) {
        if ("undefined" == typeof document) return this._destroyCaptureCanvas(), null;
        var e, r, n = document.createElement("canvas");
        return void 0 !== t && (t instanceof HTMLVideoElement ? (e = t.videoWidth, r = t.videoHeight) : t instanceof HTMLImageElement && (e = t.naturalWidth || t.width, r = t.naturalHeight || t.height)), n.style.width = e + "px", n.style.height = r + "px", n.width = e, n.height = r, n;
    }, t.prototype.stopStreams = function() {
        this.stream && (this.stream.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), this.stream = void 0), !1 === this._stopAsyncDecode && this.stopAsyncDecode(), !1 === this._stopContinuousDecode && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
        this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
        this.videoElement && (void 0 !== this.videoEndedListener && this.videoElement.removeEventListener("ended", this.videoEndedListener), void 0 !== this.videoPlayingEventListener && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), void 0 !== this.videoCanPlayListener && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
        this.imageElement && (void 0 !== this.imageLoadedListener && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
        this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.prototype.cleanVideoSource = function(t) {
        try {
            t.srcObject = null;
        } catch (e) {
            t.src = "";
        }
        this.videoElement.removeAttribute("src");
    }, t;
}(), $849102574a83a574$var$gt = function() {
    function t(t, e, r, n, o, i) {
        void 0 === r && (r = null == e ? 0 : 8 * e.length), void 0 === i && (i = $849102574a83a574$var$D.currentTimeMillis()), this.text = t, this.rawBytes = e, this.numBits = r, this.resultPoints = n, this.format = o, this.timestamp = i, this.text = t, this.rawBytes = e, this.numBits = null == r ? null == e ? 0 : 8 * e.length : r, this.resultPoints = n, this.format = o, this.resultMetadata = null, this.timestamp = null == i ? $849102574a83a574$var$D.currentTimeMillis() : i;
    }
    return t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
        return this.format;
    }, t.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    }, t.prototype.putMetadata = function(t, e) {
        null === this.resultMetadata && (this.resultMetadata = new Map), this.resultMetadata.set(t, e);
    }, t.prototype.putAllMetadata = function(t) {
        null !== t && (null === this.resultMetadata ? this.resultMetadata = t : this.resultMetadata = new Map(t));
    }, t.prototype.addResultPoints = function(t) {
        var e = this.resultPoints;
        if (null === e) this.resultPoints = t;
        else if (null !== t && t.length > 0) {
            var r = new Array(e.length + t.length);
            $849102574a83a574$var$D.arraycopy(e, 0, r, 0, e.length), $849102574a83a574$var$D.arraycopy(t, 0, r, e.length, t.length), this.resultPoints = r;
        }
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.toString = function() {
        return this.text;
    }, t;
}();
!function(t) {
    t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
}($849102574a83a574$var$z || ($849102574a83a574$var$z = {}));
var $849102574a83a574$var$yt, $849102574a83a574$var$wt = $849102574a83a574$var$z;
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
}($849102574a83a574$var$yt || ($849102574a83a574$var$yt = {}));
var $849102574a83a574$var$vt, $849102574a83a574$var$_t = $849102574a83a574$var$yt, $849102574a83a574$var$At = function() {
    function t(t, e, r, n, o, i) {
        void 0 === o && (o = -1), void 0 === i && (i = -1), this.rawBytes = t, this.text = e, this.byteSegments = r, this.ecLevel = n, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = i, this.numBits = null == t ? 0 : 8 * t.length;
    }
    return t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.setNumBits = function(t) {
        this.numBits = t;
    }, t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getByteSegments = function() {
        return this.byteSegments;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(t) {
        this.errorsCorrected = t;
    }, t.prototype.getErasures = function() {
        return this.erasures;
    }, t.prototype.setErasures = function(t) {
        this.erasures = t;
    }, t.prototype.getOther = function() {
        return this.other;
    }, t.prototype.setOther = function(t) {
        this.other = t;
    }, t.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    }, t;
}(), $849102574a83a574$var$Ct = function() {
    function t() {}
    return t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $849102574a83a574$var$T;
        return this.logTable[t];
    }, t.addOrSubtract = function(t, e) {
        return t ^ e;
    }, t;
}(), $849102574a83a574$var$mt = function() {
    function t(t, e) {
        if (0 === e.length) throw new $849102574a83a574$var$T;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = Int32Array.from([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $849102574a83a574$var$D.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        if (0 === t) return this.getCoefficient(0);
        var e, r = this.coefficients;
        if (1 === t) {
            e = 0;
            for(var n = 0, o = r.length; n !== o; n++){
                var i = r[n];
                e = $849102574a83a574$var$Ct.addOrSubtract(e, i);
            }
            return e;
        }
        e = r[0];
        var a = r.length, s = this.field;
        for(n = 1; n < a; n++)e = $849102574a83a574$var$Ct.addOrSubtract(s.multiply(t, e), r[n]);
        return e;
    }, t.prototype.addOrSubtract = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $849102574a83a574$var$D.arraycopy(n, 0, i, 0, a);
        for(var s = a; s < n.length; s++)i[s] = $849102574a83a574$var$Ct.addOrSubtract(r[s - a], n[s]);
        return new t(this.field, i);
    }, t.prototype.multiply = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || e.isZero()) return this.field.getZero();
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), s = this.field, u = 0; u < n; u++)for(var c = r[u], f = 0; f < i; f++)a[u + f] = $849102574a83a574$var$Ct.addOrSubtract(a[u + f], s.multiply(c, o[f]));
        return new t(s, a);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return this.field.getZero();
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = this.field, o = new Int32Array(r), i = this.coefficients, a = 0; a < r; a++)o[a] = n.multiply(i[a], e);
        return new t(n, o);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $849102574a83a574$var$T;
        if (0 === r) return this.field.getZero();
        for(var n = this.coefficients, o = n.length, i = new Int32Array(o + e), a = this.field, s = 0; s < o; s++)i[s] = a.multiply(n[s], r);
        return new t(a, i);
    }, t.prototype.divide = function(t) {
        if (!this.field.equals(t.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (t.isZero()) throw new $849102574a83a574$var$T("Divide by 0");
        for(var e = this.field, r = e.getZero(), n = this, o = t.getCoefficient(t.getDegree()), i = e.inverse(o); n.getDegree() >= t.getDegree() && !n.isZero();){
            var a = n.getDegree() - t.getDegree(), s = e.multiply(n.getCoefficient(n.getDegree()), i), u = t.multiplyByMonomial(a, s), c = e.buildMonomial(a, s);
            r = r.addOrSubtract(c), n = n.addOrSubtract(u);
        }
        return [
            r,
            n
        ];
    }, t.prototype.toString = function() {
        for(var t = "", e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            if (0 !== r) {
                if (r < 0 ? (t += " - ", r = -r) : t.length > 0 && (t += " + "), 0 === e || 1 !== r) {
                    var n = this.field.log(r);
                    0 === n ? t += "1" : 1 === n ? t += "a" : (t += "a^", t += n);
                }
                0 !== e && (1 === e ? t += "x" : (t += "x^", t += e));
            }
        }
        return t;
    }, t;
}(), $849102574a83a574$var$Et = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$It = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Et(e, t), e.kind = "ArithmeticException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$St = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Tt = function(t) {
    function e(e, r, n) {
        var o = t.call(this) || this;
        o.primitive = e, o.size = r, o.generatorBase = n;
        for(var i = new Int32Array(r), a = 1, s = 0; s < r; s++)i[s] = a, (a *= 2) >= r && (a ^= e, a &= r - 1);
        o.expTable = i;
        var u = new Int32Array(r);
        for(s = 0; s < r - 1; s++)u[i[s]] = s;
        return o.logTable = u, o.zero = new $849102574a83a574$var$mt(o, Int32Array.from([
            0
        ])), o.one = new $849102574a83a574$var$mt(o, Int32Array.from([
            1
        ])), o;
    }
    return $849102574a83a574$var$St(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $849102574a83a574$var$T;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $849102574a83a574$var$mt(this, r);
    }, e.prototype.inverse = function(t) {
        if (0 === t) throw new $849102574a83a574$var$It;
        return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
        return this.size;
    }, e.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    }, e.prototype.toString = function() {
        return "GF(0x" + $849102574a83a574$var$x.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
        return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
}($849102574a83a574$var$Ct), $849102574a83a574$var$Ot = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$bt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Ot(e, t), e.kind = "ReedSolomonException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Rt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Nt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Rt(e, t), e.kind = "IllegalStateException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Dt = function() {
    function t(t) {
        this.field = t;
    }
    return t.prototype.decode = function(t, e) {
        for(var r = this.field, n = new $849102574a83a574$var$mt(r, t), o = new Int32Array(e), i = !0, a = 0; a < e; a++){
            var s = n.evaluateAt(r.exp(a + r.getGeneratorBase()));
            o[o.length - 1 - a] = s, 0 !== s && (i = !1);
        }
        if (!i) {
            var u = new $849102574a83a574$var$mt(r, o), c = this.runEuclideanAlgorithm(r.buildMonomial(e, 1), u, e), f = c[0], h = c[1], l = this.findErrorLocations(f), d = this.findErrorMagnitudes(h, l);
            for(a = 0; a < l.length; a++){
                var p = t.length - 1 - r.log(l[a]);
                if (p < 0) throw new $849102574a83a574$var$bt("Bad error location");
                t[p] = $849102574a83a574$var$Tt.addOrSubtract(t[p], d[a]);
            }
        }
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = this.field, i = t, a = e, s = o.getZero(), u = o.getOne(); a.getDegree() >= (r / 2 | 0);){
            var c = i, f = s;
            if (s = u, (i = a).isZero()) throw new $849102574a83a574$var$bt("r_{i-1} was zero");
            a = c;
            for(var h = o.getZero(), l = i.getCoefficient(i.getDegree()), d = o.inverse(l); a.getDegree() >= i.getDegree() && !a.isZero();){
                var p = a.getDegree() - i.getDegree(), g = o.multiply(a.getCoefficient(a.getDegree()), d);
                h = h.addOrSubtract(o.buildMonomial(p, g)), a = a.addOrSubtract(i.multiplyByMonomial(p, g));
            }
            if (u = h.multiply(s).addOrSubtract(f), a.getDegree() >= i.getDegree()) throw new $849102574a83a574$var$Nt("Division algorithm failed to reduce polynomial?");
        }
        var y = u.getCoefficient(0);
        if (0 === y) throw new $849102574a83a574$var$bt("sigmaTilde(0) was zero");
        var w = o.inverse(y);
        return [
            u.multiplyScalar(w),
            a.multiplyScalar(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        var e = t.getDegree();
        if (1 === e) return Int32Array.from([
            t.getCoefficient(1)
        ]);
        for(var r = new Int32Array(e), n = 0, o = this.field, i = 1; i < o.getSize() && n < e; i++)0 === t.evaluateAt(i) && (r[n] = o.inverse(i), n++);
        if (n !== e) throw new $849102574a83a574$var$bt("Error locator degree does not match number of roots");
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e) {
        for(var r = e.length, n = new Int32Array(r), o = this.field, i = 0; i < r; i++){
            for(var a = o.inverse(e[i]), s = 1, u = 0; u < r; u++)if (i !== u) {
                var c = o.multiply(e[u], a), f = 0 == (1 & c) ? 1 | c : -2 & c;
                s = o.multiply(s, f);
            }
            n[i] = o.multiply(t.evaluateAt(a), o.inverse(s)), 0 !== o.getGeneratorBase() && (n[i] = o.multiply(n[i], a));
        }
        return n;
    }, t;
}();
!function(t) {
    t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
}($849102574a83a574$var$vt || ($849102574a83a574$var$vt = {}));
var $849102574a83a574$var$Mt = function() {
    function t() {}
    return t.prototype.decode = function(e) {
        this.ddata = e;
        var r = e.getBits(), n = this.extractBits(r), o = this.correctBits(n), i = t.convertBoolArrayToByteArray(o), a = t.getEncodedData(o), s = new $849102574a83a574$var$At(i, a, null, null);
        return s.setNumBits(o.length), s;
    }, t.highLevelDecode = function(t) {
        return this.getEncodedData(t);
    }, t.getEncodedData = function(e) {
        for(var r = e.length, n = $849102574a83a574$var$vt.UPPER, o = $849102574a83a574$var$vt.UPPER, i = "", a = 0; a < r;)if (o === $849102574a83a574$var$vt.BINARY) {
            if (r - a < 5) break;
            var s = t.readCode(e, a, 5);
            if (a += 5, 0 === s) {
                if (r - a < 11) break;
                s = t.readCode(e, a, 11) + 31, a += 11;
            }
            for(var u = 0; u < s; u++){
                if (r - a < 8) {
                    a = r;
                    break;
                }
                var c = t.readCode(e, a, 8);
                i += $849102574a83a574$var$q.castAsNonUtf8Char(c), a += 8;
            }
            o = n;
        } else {
            var f = o === $849102574a83a574$var$vt.DIGIT ? 4 : 5;
            if (r - a < f) break;
            c = t.readCode(e, a, f);
            a += f;
            var h = t.getCharacter(o, c);
            h.startsWith("CTRL_") ? (n = o, o = t.getTable(h.charAt(5)), "L" === h.charAt(6) && (n = o)) : (i += h, o = n);
        }
        return i;
    }, t.getTable = function(t) {
        switch(t){
            case "L":
                return $849102574a83a574$var$vt.LOWER;
            case "P":
                return $849102574a83a574$var$vt.PUNCT;
            case "M":
                return $849102574a83a574$var$vt.MIXED;
            case "D":
                return $849102574a83a574$var$vt.DIGIT;
            case "B":
                return $849102574a83a574$var$vt.BINARY;
            default:
                return $849102574a83a574$var$vt.UPPER;
        }
    }, t.getCharacter = function(e, r) {
        switch(e){
            case $849102574a83a574$var$vt.UPPER:
                return t.UPPER_TABLE[r];
            case $849102574a83a574$var$vt.LOWER:
                return t.LOWER_TABLE[r];
            case $849102574a83a574$var$vt.MIXED:
                return t.MIXED_TABLE[r];
            case $849102574a83a574$var$vt.PUNCT:
                return t.PUNCT_TABLE[r];
            case $849102574a83a574$var$vt.DIGIT:
                return t.DIGIT_TABLE[r];
            default:
                throw new $849102574a83a574$var$Nt("Bad table");
        }
    }, t.prototype.correctBits = function(e) {
        var r, n;
        this.ddata.getNbLayers() <= 2 ? (n = 6, r = $849102574a83a574$var$Tt.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, r = $849102574a83a574$var$Tt.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, r = $849102574a83a574$var$Tt.AZTEC_DATA_10) : (n = 12, r = $849102574a83a574$var$Tt.AZTEC_DATA_12);
        var o = this.ddata.getNbDatablocks(), i = e.length / n;
        if (i < o) throw new $849102574a83a574$var$G;
        for(var a = e.length % n, s = new Int32Array(i), u = 0; u < i; u++, a += n)s[u] = t.readCode(e, a, n);
        try {
            new $849102574a83a574$var$Dt(r).decode(s, i - o);
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
        var c = (1 << n) - 1, f = 0;
        for(u = 0; u < o; u++){
            if (0 === (d = s[u]) || d === c) throw new $849102574a83a574$var$G;
            1 !== d && d !== c - 1 || f++;
        }
        var h = new Array(o * n - f), l = 0;
        for(u = 0; u < o; u++){
            var d;
            if (1 === (d = s[u]) || d === c - 1) h.fill(d > 1, l, l + n - 1), l += n - 1;
            else for(var p = n - 1; p >= 0; --p)h[l++] = 0 != (d & 1 << p);
        }
        return h;
    }, t.prototype.extractBits = function(t) {
        var e = this.ddata.isCompact(), r = this.ddata.getNbLayers(), n = (e ? 11 : 14) + 4 * r, o = new Int32Array(n), i = new Array(this.totalBitsInLayer(r, e));
        if (e) for(var a = 0; a < o.length; a++)o[a] = a;
        else {
            var s = n + 1 + 2 * $849102574a83a574$var$x.truncDivision($849102574a83a574$var$x.truncDivision(n, 2) - 1, 15), u = n / 2, c = $849102574a83a574$var$x.truncDivision(s, 2);
            for(a = 0; a < u; a++){
                var f = a + $849102574a83a574$var$x.truncDivision(a, 15);
                o[u - a - 1] = c - f - 1, o[u + a] = c + f + 1;
            }
        }
        a = 0;
        for(var h = 0; a < r; a++){
            for(var l = 4 * (r - a) + (e ? 9 : 12), d = 2 * a, p = n - 1 - d, g = 0; g < l; g++)for(var y = 2 * g, w = 0; w < 2; w++)i[h + y + w] = t.get(o[d + w], o[d + g]), i[h + 2 * l + y + w] = t.get(o[d + g], o[p - w]), i[h + 4 * l + y + w] = t.get(o[p - w], o[p - g]), i[h + 6 * l + y + w] = t.get(o[p - g], o[d + w]);
            h += 8 * l;
        }
        return i;
    }, t.readCode = function(t, e, r) {
        for(var n = 0, o = e; o < e + r; o++)n <<= 1, t[o] && (n |= 1);
        return n;
    }, t.readByte = function(e, r) {
        var n = e.length - r;
        return n >= 8 ? t.readCode(e, r, 8) : t.readCode(e, r, n) << 8 - n;
    }, t.convertBoolArrayToByteArray = function(e) {
        for(var r = new Uint8Array((e.length + 7) / 8), n = 0; n < r.length; n++)r[n] = t.readByte(e, 8 * n);
        return r;
    }, t.prototype.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "\t",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ], t.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ], t.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ], t;
}(), $849102574a83a574$var$Pt = function() {
    function t() {}
    return t.round = function(t) {
        return isNaN(t) ? 0 : t <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : t >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t + (t < 0 ? -0.5 : .5) | 0;
    }, t.distance = function(t, e, r, n) {
        var o = t - r, i = e - n;
        return Math.sqrt(o * o + i * i);
    }, t.sum = function(t) {
        for(var e = 0, r = 0, n = t.length; r !== n; r++)e += t[r];
        return e;
    }, t;
}(), $849102574a83a574$var$Bt = function() {
    function t() {}
    return t.floatToIntBits = function(t) {
        return t;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $849102574a83a574$var$Lt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t.prototype.equals = function(e) {
        if (e instanceof t) {
            var r = e;
            return this.x === r.x && this.y === r.y;
        }
        return !1;
    }, t.prototype.hashCode = function() {
        return 31 * $849102574a83a574$var$Bt.floatToIntBits(this.x) + $849102574a83a574$var$Bt.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(t) {
        var e, r, n, o = this.distance(t[0], t[1]), i = this.distance(t[1], t[2]), a = this.distance(t[0], t[2]);
        if (i >= o && i >= a ? (r = t[0], e = t[1], n = t[2]) : a >= i && a >= o ? (r = t[1], e = t[0], n = t[2]) : (r = t[2], e = t[0], n = t[1]), this.crossProductZ(e, r, n) < 0) {
            var s = e;
            e = n, n = s;
        }
        t[0] = e, t[1] = r, t[2] = n;
    }, t.distance = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.x, t.y, e.x, e.y);
    }, t.crossProductZ = function(t, e, r) {
        var n = e.x, o = e.y;
        return (r.x - n) * (t.y - o) - (r.y - o) * (t.x - n);
    }, t;
}(), $849102574a83a574$var$Ft = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $849102574a83a574$var$kt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$xt = function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r) || this;
        return a.compact = n, a.nbDatablocks = o, a.nbLayers = i, a;
    }
    return $849102574a83a574$var$kt(e, t), e.prototype.getNbLayers = function() {
        return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
        return this.compact;
    }, e;
}($849102574a83a574$var$Ft), $849102574a83a574$var$Vt = function() {
    function t(e, r, n, o) {
        this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), null == r && (r = t.INIT_SIZE), null == n && (n = e.getWidth() / 2 | 0), null == o && (o = e.getHeight() / 2 | 0);
        var i = r / 2 | 0;
        if (this.leftInit = n - i, this.rightInit = n + i, this.upInit = o - i, this.downInit = o + i, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new $849102574a83a574$var$tt;
    }
    return t.prototype.detect = function() {
        for(var t = this.leftInit, e = this.rightInit, r = this.upInit, n = this.downInit, o = !1, i = !0, a = !1, s = !1, u = !1, c = !1, f = !1, h = this.width, l = this.height; i;){
            i = !1;
            for(var d = !0; (d || !s) && e < h;)(d = this.containsBlackPoint(r, n, e, !1)) ? (e++, i = !0, s = !0) : s || e++;
            if (e >= h) {
                o = !0;
                break;
            }
            for(var p = !0; (p || !u) && n < l;)(p = this.containsBlackPoint(t, e, n, !0)) ? (n++, i = !0, u = !0) : u || n++;
            if (n >= l) {
                o = !0;
                break;
            }
            for(var g = !0; (g || !c) && t >= 0;)(g = this.containsBlackPoint(r, n, t, !1)) ? (t--, i = !0, c = !0) : c || t--;
            if (t < 0) {
                o = !0;
                break;
            }
            for(var y = !0; (y || !f) && r >= 0;)(y = this.containsBlackPoint(t, e, r, !0)) ? (r--, i = !0, f = !0) : f || r--;
            if (r < 0) {
                o = !0;
                break;
            }
            i && (a = !0);
        }
        if (!o && a) {
            for(var w = e - t, v = null, _ = 1; null === v && _ < w; _++)v = this.getBlackPointOnSegment(t, n - _, t + _, n);
            if (null == v) throw new $849102574a83a574$var$tt;
            var A = null;
            for(_ = 1; null === A && _ < w; _++)A = this.getBlackPointOnSegment(t, r + _, t + _, r);
            if (null == A) throw new $849102574a83a574$var$tt;
            var C = null;
            for(_ = 1; null === C && _ < w; _++)C = this.getBlackPointOnSegment(e, r + _, e - _, r);
            if (null == C) throw new $849102574a83a574$var$tt;
            var m = null;
            for(_ = 1; null === m && _ < w; _++)m = this.getBlackPointOnSegment(e, n - _, e - _, n);
            if (null == m) throw new $849102574a83a574$var$tt;
            return this.centerEdges(m, v, C, A);
        }
        throw new $849102574a83a574$var$tt;
    }, t.prototype.getBlackPointOnSegment = function(t, e, r, n) {
        for(var o = $849102574a83a574$var$Pt.round($849102574a83a574$var$Pt.distance(t, e, r, n)), i = (r - t) / o, a = (n - e) / o, s = this.image, u = 0; u < o; u++){
            var c = $849102574a83a574$var$Pt.round(t + u * i), f = $849102574a83a574$var$Pt.round(e + u * a);
            if (s.get(c, f)) return new $849102574a83a574$var$Lt(c, f);
        }
        return null;
    }, t.prototype.centerEdges = function(e, r, n, o) {
        var i = e.getX(), a = e.getY(), s = r.getX(), u = r.getY(), c = n.getX(), f = n.getY(), h = o.getX(), l = o.getY(), d = t.CORR;
        return i < this.width / 2 ? [
            new $849102574a83a574$var$Lt(h - d, l + d),
            new $849102574a83a574$var$Lt(s + d, u + d),
            new $849102574a83a574$var$Lt(c - d, f - d),
            new $849102574a83a574$var$Lt(i + d, a - d)
        ] : [
            new $849102574a83a574$var$Lt(h + d, l + d),
            new $849102574a83a574$var$Lt(s + d, u - d),
            new $849102574a83a574$var$Lt(c - d, f + d),
            new $849102574a83a574$var$Lt(i - d, a - d)
        ];
    }, t.prototype.containsBlackPoint = function(t, e, r, n) {
        var o = this.image;
        if (n) {
            for(var i = t; i <= e; i++)if (o.get(i, r)) return !0;
        } else for(var a = t; a <= e; a++)if (o.get(r, a)) return !0;
        return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
}(), $849102574a83a574$var$Ht = function() {
    function t() {}
    return t.checkAndNudgePoints = function(t, e) {
        for(var r = t.getWidth(), n = t.getHeight(), o = !0, i = 0; i < e.length && o; i += 2){
            var a = Math.floor(e[i]), s = Math.floor(e[i + 1]);
            if (a < -1 || a > r || s < -1 || s > n) throw new $849102574a83a574$var$tt;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === s ? (e[i + 1] = 0, o = !0) : s === n && (e[i + 1] = n - 1, o = !0);
        }
        o = !0;
        for(i = e.length - 2; i >= 0 && o; i -= 2){
            a = Math.floor(e[i]), s = Math.floor(e[i + 1]);
            if (a < -1 || a > r || s < -1 || s > n) throw new $849102574a83a574$var$tt;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === s ? (e[i + 1] = 0, o = !0) : s === n && (e[i + 1] = n - 1, o = !0);
        }
    }, t;
}(), $849102574a83a574$var$Ut = function() {
    function t(t, e, r, n, o, i, a, s, u) {
        this.a11 = t, this.a21 = e, this.a31 = r, this.a12 = n, this.a22 = o, this.a32 = i, this.a13 = a, this.a23 = s, this.a33 = u;
    }
    return t.quadrilateralToQuadrilateral = function(e, r, n, o, i, a, s, u, c, f, h, l, d, p, g, y) {
        var w = t.quadrilateralToSquare(e, r, n, o, i, a, s, u);
        return t.squareToQuadrilateral(c, f, h, l, d, p, g, y).times(w);
    }, t.prototype.transformPoints = function(t) {
        for(var e = t.length, r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, s = this.a23, u = this.a31, c = this.a32, f = this.a33, h = 0; h < e; h += 2){
            var l = t[h], d = t[h + 1], p = o * l + s * d + f;
            t[h] = (r * l + i * d + u) / p, t[h + 1] = (n * l + a * d + c) / p;
        }
    }, t.prototype.transformPointsWithValues = function(t, e) {
        for(var r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, s = this.a23, u = this.a31, c = this.a32, f = this.a33, h = t.length, l = 0; l < h; l++){
            var d = t[l], p = e[l], g = o * d + s * p + f;
            t[l] = (r * d + i * p + u) / g, e[l] = (n * d + a * p + c) / g;
        }
    }, t.squareToQuadrilateral = function(e, r, n, o, i, a, s, u) {
        var c = e - n + i - s, f = r - o + a - u;
        if (0 === c && 0 === f) return new t(n - e, i - n, e, o - r, a - o, r, 0, 0, 1);
        var h = n - i, l = s - i, d = o - a, p = u - a, g = h * p - l * d, y = (c * p - l * f) / g, w = (h * f - c * d) / g;
        return new t(n - e + y * n, s - e + w * s, e, o - r + y * o, u - r + w * u, r, y, w, 1);
    }, t.quadrilateralToSquare = function(e, r, n, o, i, a, s, u) {
        return t.squareToQuadrilateral(e, r, n, o, i, a, s, u).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
        return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
        return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
}(), $849102574a83a574$var$Xt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Gt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Xt(e, t), e.prototype.sampleGrid = function(t, e, r, n, o, i, a, s, u, c, f, h, l, d, p, g, y, w, v) {
        var _ = $849102574a83a574$var$Ut.quadrilateralToQuadrilateral(n, o, i, a, s, u, c, f, h, l, d, p, g, y, w, v);
        return this.sampleGridWithTransform(t, e, r, _);
    }, e.prototype.sampleGridWithTransform = function(t, e, r, n) {
        if (e <= 0 || r <= 0) throw new $849102574a83a574$var$tt;
        for(var o = new $849102574a83a574$var$J(e, r), i = new Float32Array(2 * e), a = 0; a < r; a++){
            for(var s = i.length, u = a + .5, c = 0; c < s; c += 2)i[c] = c / 2 + .5, i[c + 1] = u;
            n.transformPoints(i), $849102574a83a574$var$Ht.checkAndNudgePoints(t, i);
            try {
                for(c = 0; c < s; c += 2)t.get(Math.floor(i[c]), Math.floor(i[c + 1])) && o.set(c / 2, a);
            } catch (t) {
                throw new $849102574a83a574$var$tt;
            }
        }
        return o;
    }, e;
}($849102574a83a574$var$Ht), $849102574a83a574$var$Wt = function() {
    function t() {}
    return t.setGridSampler = function(e) {
        t.gridSampler = e;
    }, t.getInstance = function() {
        return t.gridSampler;
    }, t.gridSampler = new $849102574a83a574$var$Gt, t;
}(), $849102574a83a574$var$zt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.toResultPoint = function() {
        return new $849102574a83a574$var$Lt(this.getX(), this.getY());
    }, t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t;
}(), $849102574a83a574$var$jt = function() {
    function t(t) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            3808,
            476,
            2107,
            1799
        ]), this.image = t;
    }
    return t.prototype.detect = function() {
        return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(t) {
        var e = this.getMatrixCenter(), r = this.getBullsEyeCorners(e);
        if (t) {
            var n = r[0];
            r[0] = r[2], r[2] = n;
        }
        this.extractParameters(r);
        var o = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), i = this.getMatrixCornerPoints(r);
        return new $849102574a83a574$var$xt(o, i, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(t) {
        if (!(this.isValidPoint(t[0]) && this.isValidPoint(t[1]) && this.isValidPoint(t[2]) && this.isValidPoint(t[3]))) throw new $849102574a83a574$var$tt;
        var e = 2 * this.nbCenterLayers, r = new Int32Array([
            this.sampleLine(t[0], t[1], e),
            this.sampleLine(t[1], t[2], e),
            this.sampleLine(t[2], t[3], e),
            this.sampleLine(t[3], t[0], e)
        ]);
        this.shift = this.getRotation(r, e);
        for(var n = 0, o = 0; o < 4; o++){
            var i = r[(this.shift + o) % 4];
            this.compact ? (n <<= 7, n += i >> 1 & 127) : (n <<= 10, n += (i >> 2 & 992) + (i >> 1 & 31));
        }
        var a = this.getCorrectedParameterData(n, this.compact);
        this.compact ? (this.nbLayers = 1 + (a >> 6), this.nbDataBlocks = 1 + (63 & a)) : (this.nbLayers = 1 + (a >> 11), this.nbDataBlocks = 1 + (2047 & a));
    }, t.prototype.getRotation = function(t, e) {
        var r = 0;
        t.forEach(function(t, n, o) {
            r = (r << 3) + ((t >> e - 2 << 1) + (1 & t));
        }), r = ((1 & r) << 11) + (r >> 1);
        for(var n = 0; n < 4; n++)if ($849102574a83a574$var$x.bitCount(r ^ this.EXPECTED_CORNER_BITS[n]) <= 2) return n;
        throw new $849102574a83a574$var$tt;
    }, t.prototype.getCorrectedParameterData = function(t, e) {
        var r, n;
        e ? (r = 7, n = 2) : (r = 10, n = 4);
        for(var o = r - n, i = new Int32Array(r), a = r - 1; a >= 0; --a)i[a] = 15 & t, t >>= 4;
        try {
            new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.AZTEC_PARAM).decode(i, o);
        } catch (t) {
            throw new $849102574a83a574$var$tt;
        }
        var s = 0;
        for(a = 0; a < n; a++)s = (s << 4) + i[a];
        return s;
    }, t.prototype.getBullsEyeCorners = function(t) {
        var e = t, r = t, n = t, o = t, i = !0;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var a = this.getFirstDifferent(e, i, 1, -1), s = this.getFirstDifferent(r, i, 1, 1), u = this.getFirstDifferent(n, i, -1, 1), c = this.getFirstDifferent(o, i, -1, -1);
            if (this.nbCenterLayers > 2) {
                var f = this.distancePoint(c, a) * this.nbCenterLayers / (this.distancePoint(o, e) * (this.nbCenterLayers + 2));
                if (f < .75 || f > 1.25 || !this.isWhiteOrBlackRectangle(a, s, u, c)) break;
            }
            e = a, r = s, n = u, o = c, i = !i;
        }
        if (5 !== this.nbCenterLayers && 7 !== this.nbCenterLayers) throw new $849102574a83a574$var$tt;
        this.compact = 5 === this.nbCenterLayers;
        var h = new $849102574a83a574$var$Lt(e.getX() + .5, e.getY() - .5), l = new $849102574a83a574$var$Lt(r.getX() + .5, r.getY() + .5), d = new $849102574a83a574$var$Lt(n.getX() - .5, n.getY() + .5), p = new $849102574a83a574$var$Lt(o.getX() - .5, o.getY() - .5);
        return this.expandSquare([
            h,
            l,
            d,
            p
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
        var t, e, r, n;
        try {
            t = (u = new $849102574a83a574$var$Vt(this.image).detect())[0], e = u[1], r = u[2], n = u[3];
        } catch (a) {
            var o = this.image.getWidth() / 2, i = this.image.getHeight() / 2;
            t = this.getFirstDifferent(new $849102574a83a574$var$zt(o + 7, i - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $849102574a83a574$var$zt(o + 7, i + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $849102574a83a574$var$zt(o - 7, i + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $849102574a83a574$var$zt(o - 7, i - 7), !1, -1, -1).toResultPoint();
        }
        var a = $849102574a83a574$var$Pt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), s = $849102574a83a574$var$Pt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4);
        try {
            var u;
            t = (u = new $849102574a83a574$var$Vt(this.image, 15, a, s).detect())[0], e = u[1], r = u[2], n = u[3];
        } catch (o) {
            t = this.getFirstDifferent(new $849102574a83a574$var$zt(a + 7, s - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $849102574a83a574$var$zt(a + 7, s + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $849102574a83a574$var$zt(a - 7, s + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $849102574a83a574$var$zt(a - 7, s - 7), !1, -1, -1).toResultPoint();
        }
        return a = $849102574a83a574$var$Pt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), s = $849102574a83a574$var$Pt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4), new $849102574a83a574$var$zt(a, s);
    }, t.prototype.getMatrixCornerPoints = function(t) {
        return this.expandSquare(t, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(t, e, r, n, o) {
        var i = $849102574a83a574$var$Wt.getInstance(), a = this.getDimension(), s = a / 2 - this.nbCenterLayers, u = a / 2 + this.nbCenterLayers;
        return i.sampleGrid(t, a, a, s, s, u, s, u, u, s, u, e.getX(), e.getY(), r.getX(), r.getY(), n.getX(), n.getY(), o.getX(), o.getY());
    }, t.prototype.sampleLine = function(t, e, r) {
        for(var n = 0, o = this.distanceResultPoint(t, e), i = o / r, a = t.getX(), s = t.getY(), u = i * (e.getX() - t.getX()) / o, c = i * (e.getY() - t.getY()) / o, f = 0; f < r; f++)this.image.get($849102574a83a574$var$Pt.round(a + f * u), $849102574a83a574$var$Pt.round(s + f * c)) && (n |= 1 << r - f - 1);
        return n;
    }, t.prototype.isWhiteOrBlackRectangle = function(t, e, r, n) {
        t = new $849102574a83a574$var$zt(t.getX() - 3, t.getY() + 3), e = new $849102574a83a574$var$zt(e.getX() - 3, e.getY() - 3), r = new $849102574a83a574$var$zt(r.getX() + 3, r.getY() - 3), n = new $849102574a83a574$var$zt(n.getX() + 3, n.getY() + 3);
        var o = this.getColor(n, t);
        if (0 === o) return !1;
        var i = this.getColor(t, e);
        return i === o && (i = this.getColor(e, r)) === o && (i = this.getColor(r, n)) === o;
    }, t.prototype.getColor = function(t, e) {
        for(var r = this.distancePoint(t, e), n = (e.getX() - t.getX()) / r, o = (e.getY() - t.getY()) / r, i = 0, a = t.getX(), s = t.getY(), u = this.image.get(t.getX(), t.getY()), c = Math.ceil(r), f = 0; f < c; f++)a += n, s += o, this.image.get($849102574a83a574$var$Pt.round(a), $849102574a83a574$var$Pt.round(s)) !== u && i++;
        var h = i / r;
        return h > .1 && h < .9 ? 0 : h <= .1 === u ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(t, e, r, n) {
        for(var o = t.getX() + r, i = t.getY() + n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r, i += n;
        for(o -= r, i -= n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r;
        for(o -= r; this.isValid(o, i) && this.image.get(o, i) === e;)i += n;
        return new $849102574a83a574$var$zt(o, i -= n);
    }, t.prototype.expandSquare = function(t, e, r) {
        var n = r / (2 * e), o = t[0].getX() - t[2].getX(), i = t[0].getY() - t[2].getY(), a = (t[0].getX() + t[2].getX()) / 2, s = (t[0].getY() + t[2].getY()) / 2, u = new $849102574a83a574$var$Lt(a + n * o, s + n * i), c = new $849102574a83a574$var$Lt(a - n * o, s - n * i);
        return o = t[1].getX() - t[3].getX(), i = t[1].getY() - t[3].getY(), a = (t[1].getX() + t[3].getX()) / 2, s = (t[1].getY() + t[3].getY()) / 2, [
            u,
            new $849102574a83a574$var$Lt(a + n * o, s + n * i),
            c,
            new $849102574a83a574$var$Lt(a - n * o, s - n * i)
        ];
    }, t.prototype.isValid = function(t, e) {
        return t >= 0 && t < this.image.getWidth() && e > 0 && e < this.image.getHeight();
    }, t.prototype.isValidPoint = function(t) {
        var e = $849102574a83a574$var$Pt.round(t.getX()), r = $849102574a83a574$var$Pt.round(t.getY());
        return this.isValid(e, r);
    }, t.prototype.distancePoint = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.distanceResultPoint = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.getDimension = function() {
        return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * ($849102574a83a574$var$x.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
}(), $849102574a83a574$var$Yt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        void 0 === e && (e = null);
        var r = null, n = new $849102574a83a574$var$jt(t.getBlackMatrix()), o = null, i = null;
        try {
            o = (a = n.detectMirror(!1)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $849102574a83a574$var$Mt).decode(a);
        } catch (t) {
            r = t;
        }
        if (null == i) try {
            var a;
            o = (a = n.detectMirror(!0)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $849102574a83a574$var$Mt).decode(a);
        } catch (t) {
            if (null != r) throw r;
            throw t;
        }
        var s = new $849102574a83a574$var$gt(i.getText(), i.getRawBytes(), i.getNumBits(), o, $849102574a83a574$var$wt.AZTEC, $849102574a83a574$var$D.currentTimeMillis()), u = i.getByteSegments();
        null != u && s.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, u);
        var c = i.getECLevel();
        return null != c && s.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, c), s;
    }, t.prototype.reportFoundResultPoints = function(t, e) {
        if (null != t) {
            var r = t.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
            null != r && e.forEach(function(t, e, n) {
                r.foundPossibleResultPoint(t);
            });
        }
    }, t.prototype.reset = function() {}, t;
}(), $849102574a83a574$var$Zt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Yt, e) || this;
    }
    $849102574a83a574$var$Zt(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Kt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        try {
            return this.doDecode(t, e);
        } catch (c) {
            if (e && !0 === e.get($849102574a83a574$var$U.TRY_HARDER) && t.isRotateSupported()) {
                var r = t.rotateCounterClockwise(), n = this.doDecode(r, e), o = n.getResultMetadata(), i = 270;
                null !== o && !0 === o.get($849102574a83a574$var$_t.ORIENTATION) && (i += o.get($849102574a83a574$var$_t.ORIENTATION) % 360), n.putMetadata($849102574a83a574$var$_t.ORIENTATION, i);
                var a = n.getResultPoints();
                if (null !== a) for(var s = r.getHeight(), u = 0; u < a.length; u++)a[u] = new $849102574a83a574$var$Lt(s - a[u].getY() - 1, a[u].getX());
                return n;
            }
            throw new $849102574a83a574$var$tt;
        }
    }, t.prototype.reset = function() {}, t.prototype.doDecode = function(t, e) {
        var r, n = t.getWidth(), o = t.getHeight(), i = new $849102574a83a574$var$V(n), a = e && !0 === e.get($849102574a83a574$var$U.TRY_HARDER), s = Math.max(1, o >> (a ? 8 : 5));
        r = a ? o : 15;
        for(var u = Math.trunc(o / 2), c = 0; c < r; c++){
            var f = Math.trunc((c + 1) / 2), h = u + s * (0 == (1 & c) ? f : -f);
            if (h < 0 || h >= o) break;
            try {
                i = t.getBlackRow(h, i);
            } catch (t) {
                continue;
            }
            for(var l = function(t) {
                if (1 === t && (i.reverse(), e && !0 === e.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK))) {
                    var r = new Map;
                    e.forEach(function(t, e) {
                        return r.set(e, t);
                    }), r.delete($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK), e = r;
                }
                try {
                    var o = d.decodeRow(h, i, e);
                    if (1 === t) {
                        o.putMetadata($849102574a83a574$var$_t.ORIENTATION, 180);
                        var a = o.getResultPoints();
                        null !== a && (a[0] = new $849102574a83a574$var$Lt(n - a[0].getX() - 1, a[0].getY()), a[1] = new $849102574a83a574$var$Lt(n - a[1].getX() - 1, a[1].getY()));
                    }
                    return {
                        value: o
                    };
                } catch (t) {}
            }, d = this, p = 0; p < 2; p++){
                var g = l(p);
                if ("object" == typeof g) return g.value;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, t.recordPattern = function(t, e, r) {
        for(var n = r.length, o = 0; o < n; o++)r[o] = 0;
        var i = t.getSize();
        if (e >= i) throw new $849102574a83a574$var$tt;
        for(var a = !t.get(e), s = 0, u = e; u < i;){
            if (t.get(u) !== a) r[s]++;
            else {
                if (++s === n) break;
                r[s] = 1, a = !a;
            }
            u++;
        }
        if (s !== n && (s !== n - 1 || u !== i)) throw new $849102574a83a574$var$tt;
    }, t.recordPatternInReverse = function(e, r, n) {
        for(var o = n.length, i = e.get(r); r > 0 && o >= 0;)e.get(--r) !== i && (o--, i = !i);
        if (o >= 0) throw new $849102574a83a574$var$tt;
        t.recordPattern(e, r + 1, n);
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return Number.POSITIVE_INFINITY;
        var s = o / i;
        r *= s;
        for(var u = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * s, l = f > h ? f - h : h - f;
            if (l > r) return Number.POSITIVE_INFINITY;
            u += l;
        }
        return u / o;
    }, t;
}(), $849102574a83a574$var$qt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Qt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$qt(e, t), e.findStartPattern = function(t) {
        for(var r = t.getSize(), n = t.getNextSet(0), o = 0, i = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), a = n, s = !1, u = n; u < r; u++)if (t.get(u) !== s) i[o]++;
        else {
            if (5 === o) {
                for(var c = e.MAX_AVG_VARIANCE, f = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++){
                    var l = $849102574a83a574$var$Kt.patternMatchVariance(i, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
                    l < c && (c = l, f = h);
                }
                if (f >= 0 && t.isRange(Math.max(0, a - (u - a) / 2), a, !1)) return Int32Array.from([
                    a,
                    u,
                    f
                ]);
                a += i[0] + i[1], (i = i.slice(2, i.length - 1))[o - 1] = 0, i[o] = 0, o--;
            } else o++;
            i[o] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeCode = function(t, r, n) {
        $849102574a83a574$var$Kt.recordPattern(t, n, r);
        for(var o = e.MAX_AVG_VARIANCE, i = -1, a = 0; a < e.CODE_PATTERNS.length; a++){
            var s = e.CODE_PATTERNS[a], u = this.patternMatchVariance(r, s, e.MAX_INDIVIDUAL_VARIANCE);
            u < o && (o = u, i = a);
        }
        if (i >= 0) return i;
        throw new $849102574a83a574$var$tt;
    }, e.prototype.decodeRow = function(t, r, n) {
        var o, i = n && !0 === n.get($849102574a83a574$var$U.ASSUME_GS1), a = e.findStartPattern(r), s = a[2], u = 0, c = new Uint8Array(20);
        switch(c[u++] = s, s){
            case e.CODE_START_A:
                o = e.CODE_CODE_A;
                break;
            case e.CODE_START_B:
                o = e.CODE_CODE_B;
                break;
            case e.CODE_START_C:
                o = e.CODE_CODE_C;
                break;
            default:
                throw new $849102574a83a574$var$G;
        }
        for(var f = !1, h = !1, l = "", d = a[0], p = a[1], g = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), y = 0, w = 0, v = s, _ = 0, A = !0, C = !1, m = !1; !f;){
            var E = h;
            switch(h = !1, y = w, w = e.decodeCode(r, g, p), c[u++] = w, w !== e.CODE_STOP && (A = !0), w !== e.CODE_STOP && (v += ++_ * w), d = p, p += g.reduce(function(t, e) {
                return t + e;
            }, 0), w){
                case e.CODE_START_A:
                case e.CODE_START_B:
                case e.CODE_START_C:
                    throw new $849102574a83a574$var$G;
            }
            switch(o){
                case e.CODE_CODE_A:
                    if (w < 64) l += m === C ? String.fromCharCode(" ".charCodeAt(0) + w) : String.fromCharCode(" ".charCodeAt(0) + w + 128), m = !1;
                    else if (w < 96) l += m === C ? String.fromCharCode(w - 64) : String.fromCharCode(w + 64), m = !1;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_A:
                            !C && m ? (C = !0, m = !1) : C && m ? (C = !1, m = !1) : m = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_B:
                    if (w < 96) l += m === C ? String.fromCharCode(" ".charCodeAt(0) + w) : String.fromCharCode(" ".charCodeAt(0) + w + 128), m = !1;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_B:
                            !C && m ? (C = !0, m = !1) : C && m ? (C = !1, m = !1) : m = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_C:
                    if (w < 100) w < 10 && (l += "0"), l += w;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
            }
            E && (o = o === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
        }
        var I = p - d;
        if (p = r.getNextUnset(p), !r.isRange(p, Math.min(r.getSize(), p + (p - d) / 2), !1)) throw new $849102574a83a574$var$tt;
        if ((v -= _ * y) % 103 !== y) throw new $849102574a83a574$var$R;
        var S = l.length;
        if (0 === S) throw new $849102574a83a574$var$tt;
        S > 0 && A && (l = o === e.CODE_CODE_C ? l.substring(0, S - 2) : l.substring(0, S - 1));
        for(var T = (a[1] + a[0]) / 2, O = d + I / 2, b = c.length, N = new Uint8Array(b), D = 0; D < b; D++)N[D] = c[D];
        var M = [
            new $849102574a83a574$var$Lt(T, t),
            new $849102574a83a574$var$Lt(O, t)
        ];
        return new $849102574a83a574$var$gt(l, N, 0, M, $849102574a83a574$var$wt.CODE_128, (new Date).getTime());
    }, e.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ], e.MAX_AVG_VARIANCE = .25, e.MAX_INDIVIDUAL_VARIANCE = .7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Jt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$$t = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$te = function(t) {
    function e(e, r) {
        void 0 === e && (e = !1), void 0 === r && (r = !1);
        var n = t.call(this) || this;
        return n.usingCheckDigit = e, n.extendedMode = r, n.decodeRowResult = "", n.counters = new Int32Array(9), n;
    }
    return $849102574a83a574$var$Jt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u = this.counters;
        u.fill(0), this.decodeRowResult = "";
        var c, f, h = e.findAsteriskPattern(r, u), l = r.getNextSet(h[1]), d = r.getSize();
        do {
            e.recordPattern(r, l, u);
            var p = e.toNarrowWidePattern(u);
            if (p < 0) throw new $849102574a83a574$var$tt;
            c = e.patternToChar(p), this.decodeRowResult += c, f = l;
            try {
                for(var g = (o = void 0, $849102574a83a574$var$$t(u)), y = g.next(); !y.done; y = g.next())l += y.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    y && !y.done && (i = g.return) && i.call(g);
                } finally{
                    if (o) throw o.error;
                }
            }
            l = r.getNextSet(l);
        }while ("*" !== c);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var w, v = 0;
        try {
            for(var _ = $849102574a83a574$var$$t(u), A = _.next(); !A.done; A = _.next())v += A.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (s = _.return) && s.call(_);
            } finally{
                if (a) throw a.error;
            }
        }
        if (l !== d && 2 * (l - f - v) < v) throw new $849102574a83a574$var$tt;
        if (this.usingCheckDigit) {
            for(var C = this.decodeRowResult.length - 1, m = 0, E = 0; E < C; E++)m += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(E));
            if (this.decodeRowResult.charAt(C) !== e.ALPHABET_STRING.charAt(m % 43)) throw new $849102574a83a574$var$R;
            this.decodeRowResult = this.decodeRowResult.substring(0, C);
        }
        if (0 === this.decodeRowResult.length) throw new $849102574a83a574$var$tt;
        w = this.extendedMode ? e.decodeExtended(this.decodeRowResult) : this.decodeRowResult;
        var I = (h[1] + h[0]) / 2, S = f + v / 2;
        return new $849102574a83a574$var$gt(w, null, 0, [
            new $849102574a83a574$var$Lt(I, t),
            new $849102574a83a574$var$Lt(S, t)
        ], $849102574a83a574$var$wt.CODE_39, (new Date).getTime());
    }, e.findAsteriskPattern = function(t, r) {
        for(var n = t.getSize(), o = t.getNextSet(0), i = 0, a = o, s = !1, u = r.length, c = o; c < n; c++)if (t.get(c) !== s) r[i]++;
        else {
            if (i === u - 1) {
                if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, a - Math.floor((c - a) / 2)), a, !1)) return [
                    a,
                    c
                ];
                a += r[0] + r[1], r.copyWithin(0, 2, 2 + i - 1), r[i - 1] = 0, r[i] = 0, i--;
            } else i++;
            r[i] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.toNarrowWidePattern = function(t) {
        var e, r, n, o = t.length, i = 0;
        do {
            var a = 2147483647;
            try {
                for(var s = (e = void 0, $849102574a83a574$var$$t(t)), u = s.next(); !u.done; u = s.next())(l = u.value) < a && l > i && (a = l);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    u && !u.done && (r = s.return) && r.call(s);
                } finally{
                    if (e) throw e.error;
                }
            }
            i = a, n = 0;
            for(var c = 0, f = 0, h = 0; h < o; h++)(l = t[h]) > i && (f |= 1 << o - 1 - h, n++, c += l);
            if (3 === n) {
                for(h = 0; h < o && n > 0; h++){
                    var l;
                    if ((l = t[h]) > i && (n--, 2 * l >= c)) return -1;
                }
                return f;
            }
        }while (n > 3);
        return -1;
    }, e.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        if (t === e.ASTERISK_ENCODING) return "*";
        throw new $849102574a83a574$var$tt;
    }, e.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if ("+" === o || "$" === o || "%" === o || "/" === o) {
                var i = t.charAt(n + 1), a = "\0";
                switch(o){
                    case "+":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "$":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "%":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\0";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if ("X" !== i && "Y" !== i && "Z" !== i) throw new $849102574a83a574$var$G;
                            a = "";
                        }
                        break;
                    case "/":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $849102574a83a574$var$G;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
        52,
        289,
        97,
        352,
        49,
        304,
        112,
        37,
        292,
        100,
        265,
        73,
        328,
        25,
        280,
        88,
        13,
        268,
        76,
        28,
        259,
        67,
        322,
        19,
        274,
        82,
        7,
        262,
        70,
        22,
        385,
        193,
        448,
        145,
        400,
        208,
        133,
        388,
        196,
        168,
        162,
        138,
        42
    ], e.ASTERISK_ENCODING = 148, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$ee = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$re = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ne = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeRowResult = "", e.counters = new Int32Array(6), e;
    }
    return $849102574a83a574$var$ee(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u, c, f = this.findAsteriskPattern(r), h = r.getNextSet(f[1]), l = r.getSize(), d = this.counters;
        d.fill(0), this.decodeRowResult = "";
        do {
            e.recordPattern(r, h, d);
            var p = this.toPattern(d);
            if (p < 0) throw new $849102574a83a574$var$tt;
            u = this.patternToChar(p), this.decodeRowResult += u, c = h;
            try {
                for(var g = (o = void 0, $849102574a83a574$var$re(d)), y = g.next(); !y.done; y = g.next())h += y.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    y && !y.done && (i = g.return) && i.call(g);
                } finally{
                    if (o) throw o.error;
                }
            }
            h = r.getNextSet(h);
        }while ("*" !== u);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var w = 0;
        try {
            for(var v = $849102574a83a574$var$re(d), _ = v.next(); !_.done; _ = v.next())w += _.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                _ && !_.done && (s = v.return) && s.call(v);
            } finally{
                if (a) throw a.error;
            }
        }
        if (h === l || !r.get(h)) throw new $849102574a83a574$var$tt;
        if (this.decodeRowResult.length < 2) throw new $849102574a83a574$var$tt;
        this.checkChecksums(this.decodeRowResult), this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
        var A = this.decodeExtended(this.decodeRowResult), C = (f[1] + f[0]) / 2, m = c + w / 2;
        return new $849102574a83a574$var$gt(A, null, 0, [
            new $849102574a83a574$var$Lt(C, t),
            new $849102574a83a574$var$Lt(m, t)
        ], $849102574a83a574$var$wt.CODE_93, (new Date).getTime());
    }, e.prototype.findAsteriskPattern = function(t) {
        var r = t.getSize(), n = t.getNextSet(0);
        this.counters.fill(0);
        for(var o = this.counters, i = n, a = !1, s = o.length, u = 0, c = n; c < r; c++)if (t.get(c) !== a) o[u]++;
        else {
            if (u === s - 1) {
                if (this.toPattern(o) === e.ASTERISK_ENCODING) return new Int32Array([
                    i,
                    c
                ]);
                i += o[0] + o[1], o.copyWithin(0, 2, 2 + u - 1), o[u - 1] = 0, o[u] = 0, u--;
            } else u++;
            o[u] = 1, a = !a;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.toPattern = function(t) {
        var e, r, n = 0;
        try {
            for(var o = $849102574a83a574$var$re(t), i = o.next(); !i.done; i = o.next())n += i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var a = 0, s = t.length, u = 0; u < s; u++){
            var c = Math.round(9 * t[u] / n);
            if (c < 1 || c > 4) return -1;
            if (0 == (1 & u)) for(var f = 0; f < c; f++)a = a << 1 | 1;
            else a <<= c;
        }
        return a;
    }, e.prototype.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        throw new $849102574a83a574$var$tt;
    }, e.prototype.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if (o >= "a" && o <= "d") {
                if (n >= e - 1) throw new $849102574a83a574$var$G;
                var i = t.charAt(n + 1), a = "\0";
                switch(o){
                    case "d":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "a":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "b":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\0";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if (!(i >= "X" && i <= "Z")) throw new $849102574a83a574$var$G;
                            a = String.fromCharCode(127);
                        }
                        break;
                    case "c":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $849102574a83a574$var$G;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.prototype.checkChecksums = function(t) {
        var e = t.length;
        this.checkOneChecksum(t, e - 2, 20), this.checkOneChecksum(t, e - 1, 15);
    }, e.prototype.checkOneChecksum = function(t, r, n) {
        for(var o = 1, i = 0, a = r - 1; a >= 0; a--)i += o * e.ALPHABET_STRING.indexOf(t.charAt(a)), ++o > n && (o = 1);
        if (t.charAt(r) !== e.ALPHABET_STRING[i % 47]) throw new $849102574a83a574$var$R;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*", e.CHARACTER_ENCODINGS = [
        276,
        328,
        324,
        322,
        296,
        292,
        290,
        336,
        274,
        266,
        424,
        420,
        418,
        404,
        402,
        394,
        360,
        356,
        354,
        308,
        282,
        344,
        332,
        326,
        300,
        278,
        436,
        434,
        428,
        422,
        406,
        410,
        364,
        358,
        310,
        314,
        302,
        468,
        466,
        458,
        366,
        374,
        430,
        294,
        474,
        470,
        306,
        350
    ], e.ASTERISK_ENCODING = e.CHARACTER_ENCODINGS[47], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$oe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ie = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ae = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.narrowLineWidth = -1, e;
    }
    return $849102574a83a574$var$oe(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a = this.decodeStart(r), s = this.decodeEnd(r), u = new $849102574a83a574$var$Q;
        e.decodeMiddle(r, a[1], s[0], u);
        var c = u.toString(), f = null;
        null != n && (f = n.get($849102574a83a574$var$U.ALLOWED_LENGTHS)), null == f && (f = e.DEFAULT_ALLOWED_LENGTHS);
        var h = c.length, l = !1, d = 0;
        try {
            for(var p = $849102574a83a574$var$ie(f), g = p.next(); !g.done; g = p.next()){
                var y = g.value;
                if (h === y) {
                    l = !0;
                    break;
                }
                y > d && (d = y);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        if (!l && h > d && (l = !0), !l) throw new $849102574a83a574$var$G;
        var w = [
            new $849102574a83a574$var$Lt(a[1], t),
            new $849102574a83a574$var$Lt(s[0], t)
        ];
        return new $849102574a83a574$var$gt(c, null, 0, w, $849102574a83a574$var$wt.ITF, (new Date).getTime());
    }, e.decodeMiddle = function(t, r, n, o) {
        var i = new Int32Array(10), a = new Int32Array(5), s = new Int32Array(5);
        for(i.fill(0), a.fill(0), s.fill(0); r < n;){
            $849102574a83a574$var$Kt.recordPattern(t, r, i);
            for(var u = 0; u < 5; u++){
                var c = 2 * u;
                a[u] = i[c], s[u] = i[c + 1];
            }
            var f = e.decodeDigit(a);
            o.append(f.toString()), f = this.decodeDigit(s), o.append(f.toString()), i.forEach(function(t) {
                r += t;
            });
        }
    }, e.prototype.decodeStart = function(t) {
        var r = e.skipWhiteSpace(t), n = e.findGuardPattern(t, r, e.START_PATTERN);
        return this.narrowLineWidth = (n[1] - n[0]) / 4, this.validateQuietZone(t, n[0]), n;
    }, e.prototype.validateQuietZone = function(t, e) {
        var r = 10 * this.narrowLineWidth;
        r = r < e ? r : e;
        for(var n = e - 1; r > 0 && n >= 0 && !t.get(n); n--)r--;
        if (0 !== r) throw new $849102574a83a574$var$tt;
    }, e.skipWhiteSpace = function(t) {
        var e = t.getSize(), r = t.getNextSet(0);
        if (r === e) throw new $849102574a83a574$var$tt;
        return r;
    }, e.prototype.decodeEnd = function(t) {
        t.reverse();
        try {
            var r = e.skipWhiteSpace(t), n = void 0;
            try {
                n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[0]);
            } catch (o) {
                o instanceof $849102574a83a574$var$tt && (n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[1]));
            }
            this.validateQuietZone(t, n[0]);
            var o = n[0];
            return n[0] = t.getSize() - n[1], n[1] = t.getSize() - o, n;
        } finally{
            t.reverse();
        }
    }, e.findGuardPattern = function(t, r, n) {
        var o = n.length, i = new Int32Array(o), a = t.getSize(), s = !1, u = 0, c = r;
        i.fill(0);
        for(var f = r; f < a; f++)if (t.get(f) !== s) i[u]++;
        else {
            if (u === o - 1) {
                if ($849102574a83a574$var$Kt.patternMatchVariance(i, n, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return [
                    c,
                    f
                ];
                c += i[0] + i[1], $849102574a83a574$var$D.arraycopy(i, 2, i, 0, u - 1), i[u - 1] = 0, i[u] = 0, u--;
            } else u++;
            i[u] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeDigit = function(t) {
        for(var r = e.MAX_AVG_VARIANCE, n = -1, o = e.PATTERNS.length, i = 0; i < o; i++){
            var a = e.PATTERNS[i], s = $849102574a83a574$var$Kt.patternMatchVariance(t, a, e.MAX_INDIVIDUAL_VARIANCE);
            s < r ? (r = s, n = i) : s === r && (n = -1);
        }
        if (n >= 0) return n % 10;
        throw new $849102574a83a574$var$tt;
    }, e.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ])
    ], e.MAX_AVG_VARIANCE = .38, e.MAX_INDIVIDUAL_VARIANCE = .5, e.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ], e.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]), e.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ])
    ], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$se = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ue = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.decodeRowStringBuffer = "", e;
    }
    return $849102574a83a574$var$se(e, t), e.findStartGuardPattern = function(t) {
        for(var r, n = !1, o = 0, i = Int32Array.from([
            0,
            0,
            0
        ]); !n;){
            i = Int32Array.from([
                0,
                0,
                0
            ]);
            var a = (r = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, i))[0], s = a - ((o = r[1]) - a);
            s >= 0 && (n = t.isRange(s, a, !1));
        }
        return r;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, e, r, n) {
        return this.findGuardPattern(t, e, r, n, new Int32Array(n.length));
    }, e.findGuardPattern = function(t, r, n, o, i) {
        for(var a = t.getSize(), s = 0, u = r = n ? t.getNextUnset(r) : t.getNextSet(r), c = o.length, f = n, h = r; h < a; h++)if (t.get(h) !== f) i[s]++;
        else {
            if (s === c - 1) {
                if ($849102574a83a574$var$Kt.patternMatchVariance(i, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return Int32Array.from([
                    u,
                    h
                ]);
                u += i[0] + i[1];
                for(var l = i.slice(2, i.length), d = 0; d < s - 1; d++)i[d] = l[d];
                i[s - 1] = 0, i[s] = 0, s--;
            } else s++;
            i[s] = 1, f = !f;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeDigit = function(t, r, n, o) {
        this.recordPattern(t, n, r);
        for(var i = this.MAX_AVG_VARIANCE, a = -1, s = o.length, u = 0; u < s; u++){
            var c = o[u], f = $849102574a83a574$var$Kt.patternMatchVariance(r, c, e.MAX_INDIVIDUAL_VARIANCE);
            f < i && (i = f, a = u);
        }
        if (a >= 0) return a;
        throw new $849102574a83a574$var$tt;
    }, e.MAX_AVG_VARIANCE = .48, e.MAX_INDIVIDUAL_VARIANCE = .7, e.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]), e.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]), e.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$ce = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$fe = function() {
    function t() {
        this.CHECK_DIGIT_ENCODINGS = [
            24,
            20,
            18,
            17,
            12,
            6,
            3,
            10,
            9,
            5
        ], this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), s = t.parseExtensionString(a), u = [
            new $849102574a83a574$var$Lt((n[0] + n[1]) / 2, e),
            new $849102574a83a574$var$Lt(i, e)
        ], c = new $849102574a83a574$var$gt(a, null, 0, u, $849102574a83a574$var$wt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != s && c.putAllMetadata(s), c;
    }, t.prototype.decodeMiddle = function(e, r, n) {
        var o, i, a = this.decodeMiddleCounters;
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var s = e.getSize(), u = r[1], c = 0, f = 0; f < 5 && u < s; f++){
            var h = $849102574a83a574$var$ue.decodeDigit(e, a, u, $849102574a83a574$var$ue.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $849102574a83a574$var$ce(a)), d = l.next(); !d.done; d = l.next())u += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 4 - f), 4 !== f && (u = e.getNextSet(u), u = e.getNextUnset(u));
        }
        if (5 !== n.length) throw new $849102574a83a574$var$tt;
        var p = this.determineCheckDigit(c);
        if (t.extensionChecksum(n.toString()) !== p) throw new $849102574a83a574$var$tt;
        return u;
    }, t.extensionChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 2; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        r *= 3;
        for(n = e - 1; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        return (r *= 3) % 10;
    }, t.prototype.determineCheckDigit = function(t) {
        for(var e = 0; e < 10; e++)if (t === this.CHECK_DIGIT_ENCODINGS[e]) return e;
        throw new $849102574a83a574$var$tt;
    }, t.parseExtensionString = function(e) {
        if (5 !== e.length) return null;
        var r = t.parseExtension5String(e);
        return null == r ? null : new Map([
            [
                $849102574a83a574$var$_t.SUGGESTED_PRICE,
                r
            ]
        ]);
    }, t.parseExtension5String = function(t) {
        var e;
        switch(t.charAt(0)){
            case "0":
                e = "\xa3";
                break;
            case "5":
                e = "$";
                break;
            case "9":
                switch(t){
                    case "90000":
                        return null;
                    case "99991":
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                e = "";
                break;
            default:
                e = "";
        }
        var r = parseInt(t.substring(1)), n = r % 100;
        return e + (r / 100).toString() + "." + (n < 10 ? "0" + n : n.toString());
    }, t;
}(), $849102574a83a574$var$he = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$le = function() {
    function t() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), s = t.parseExtensionString(a), u = [
            new $849102574a83a574$var$Lt((n[0] + n[1]) / 2, e),
            new $849102574a83a574$var$Lt(i, e)
        ], c = new $849102574a83a574$var$gt(a, null, 0, u, $849102574a83a574$var$wt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != s && c.putAllMetadata(s), c;
    }, t.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i = this.decodeMiddleCounters;
        i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
        for(var a = t.getSize(), s = e[1], u = 0, c = 0; c < 2 && s < a; c++){
            var f = $849102574a83a574$var$ue.decodeDigit(t, i, s, $849102574a83a574$var$ue.L_AND_G_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + f % 10);
            try {
                for(var h = (n = void 0, $849102574a83a574$var$he(i)), l = h.next(); !l.done; l = h.next())s += l.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    l && !l.done && (o = h.return) && o.call(h);
                } finally{
                    if (n) throw n.error;
                }
            }
            f >= 10 && (u |= 1 << 1 - c), 1 !== c && (s = t.getNextSet(s), s = t.getNextUnset(s));
        }
        if (2 !== r.length) throw new $849102574a83a574$var$tt;
        if (parseInt(r.toString()) % 4 !== u) throw new $849102574a83a574$var$tt;
        return s;
    }, t.parseExtensionString = function(t) {
        return 2 !== t.length ? null : new Map([
            [
                $849102574a83a574$var$_t.ISSUE_NUMBER,
                parseInt(t)
            ]
        ]);
    }, t;
}(), $849102574a83a574$var$de = function() {
    function t() {}
    return t.decodeRow = function(t, e, r) {
        var n = $849102574a83a574$var$ue.findGuardPattern(e, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            return (new $849102574a83a574$var$fe).decodeRow(t, e, n);
        } catch (r) {
            return (new $849102574a83a574$var$le).decodeRow(t, e, n);
        }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]), t;
}(), $849102574a83a574$var$pe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ge = function(t) {
    function e() {
        var r = t.call(this) || this;
        r.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(t) {
            return Int32Array.from(t);
        });
        for(var n = 10; n < 20; n++){
            for(var o = e.L_PATTERNS[n - 10], i = new Int32Array(o.length), a = 0; a < o.length; a++)i[a] = o[o.length - a - 1];
            e.L_AND_G_PATTERNS[n] = i;
        }
        return r;
    }
    return $849102574a83a574$var$pe(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o = e.findStartGuardPattern(r), i = null == n ? null : n.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
        if (null != i) {
            var a = new $849102574a83a574$var$Lt((o[0] + o[1]) / 2, t);
            i.foundPossibleResultPoint(a);
        }
        var s = this.decodeMiddle(r, o, this.decodeRowStringBuffer), u = s.rowOffset, c = s.resultString;
        if (null != i) {
            var f = new $849102574a83a574$var$Lt(u, t);
            i.foundPossibleResultPoint(f);
        }
        var h = e.decodeEnd(r, u);
        if (null != i) {
            var l = new $849102574a83a574$var$Lt((h[0] + h[1]) / 2, t);
            i.foundPossibleResultPoint(l);
        }
        var d = h[1], p = d + (d - h[0]);
        if (p >= r.getSize() || !r.isRange(d, p, !1)) throw new $849102574a83a574$var$tt;
        var g = c.toString();
        if (g.length < 8) throw new $849102574a83a574$var$G;
        if (!e.checkChecksum(g)) throw new $849102574a83a574$var$R;
        var y = (o[1] + o[0]) / 2, w = (h[1] + h[0]) / 2, v = this.getBarcodeFormat(), _ = [
            new $849102574a83a574$var$Lt(y, t),
            new $849102574a83a574$var$Lt(w, t)
        ], A = new $849102574a83a574$var$gt(g, null, 0, _, v, (new Date).getTime()), C = 0;
        try {
            var m = $849102574a83a574$var$de.decodeRow(t, r, h[1]);
            A.putMetadata($849102574a83a574$var$_t.UPC_EAN_EXTENSION, m.getText()), A.putAllMetadata(m.getResultMetadata()), A.addResultPoints(m.getResultPoints()), C = m.getText().length;
        } catch (t) {}
        var E = null == n ? null : n.get($849102574a83a574$var$U.ALLOWED_EAN_EXTENSIONS);
        if (null != E) {
            var I = !1;
            for(var S in E)if (C.toString() === S) {
                I = !0;
                break;
            }
            if (!I) throw new $849102574a83a574$var$tt;
        }
        return v === $849102574a83a574$var$wt.EAN_13 || $849102574a83a574$var$wt.UPC_A, A;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
}($849102574a83a574$var$ue), $849102574a83a574$var$ye = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$we = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ve = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $849102574a83a574$var$ye(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a, s, u = this.decodeMiddleCounters;
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
        for(var c = t.getSize(), f = r[1], h = 0, l = 0; l < 6 && f < c; l++){
            var d = $849102574a83a574$var$ge.decodeDigit(t, u, f, $849102574a83a574$var$ge.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d % 10);
            try {
                for(var p = (o = void 0, $849102574a83a574$var$we(u)), g = p.next(); !g.done; g = p.next())f += g.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (i = p.return) && i.call(p);
                } finally{
                    if (o) throw o.error;
                }
            }
            d >= 10 && (h |= 1 << 5 - l);
        }
        n = e.determineFirstDigit(n, h), f = $849102574a83a574$var$ge.findGuardPattern(t, f, !0, $849102574a83a574$var$ge.MIDDLE_PATTERN, new Int32Array($849102574a83a574$var$ge.MIDDLE_PATTERN.length).fill(0))[1];
        for(l = 0; l < 6 && f < c; l++){
            d = $849102574a83a574$var$ge.decodeDigit(t, u, f, $849102574a83a574$var$ge.L_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d);
            try {
                for(var y = (a = void 0, $849102574a83a574$var$we(u)), w = y.next(); !w.done; w = y.next())f += w.value;
            } catch (t) {
                a = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (s = y.return) && s.call(y);
                } finally{
                    if (a) throw a.error;
                }
            }
        }
        return {
            rowOffset: f,
            resultString: n
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.EAN_13;
    }, e.determineFirstDigit = function(t, e) {
        for(var r = 0; r < 10; r++)if (e === this.FIRST_DIGIT_ENCODINGS[r]) return t = String.fromCharCode("0".charCodeAt(0) + r) + t;
        throw new $849102574a83a574$var$tt;
    }, e.FIRST_DIGIT_ENCODINGS = [
        0,
        11,
        13,
        14,
        19,
        25,
        28,
        21,
        22,
        26
    ], e;
}($849102574a83a574$var$ge), $849102574a83a574$var$_e = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ae = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ce = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $849102574a83a574$var$_e(e, t), e.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i, a, s = this.decodeMiddleCounters;
        s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
        for(var u = t.getSize(), c = e[1], f = 0; f < 4 && c < u; f++){
            var h = $849102574a83a574$var$ge.decodeDigit(t, s, c, $849102574a83a574$var$ge.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var l = (n = void 0, $849102574a83a574$var$Ae(s)), d = l.next(); !d.done; d = l.next())c += d.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (o = l.return) && o.call(l);
                } finally{
                    if (n) throw n.error;
                }
            }
        }
        c = $849102574a83a574$var$ge.findGuardPattern(t, c, !0, $849102574a83a574$var$ge.MIDDLE_PATTERN, new Int32Array($849102574a83a574$var$ge.MIDDLE_PATTERN.length).fill(0))[1];
        for(f = 0; f < 4 && c < u; f++){
            h = $849102574a83a574$var$ge.decodeDigit(t, s, c, $849102574a83a574$var$ge.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var p = (i = void 0, $849102574a83a574$var$Ae(s)), g = p.next(); !g.done; g = p.next())c += g.value;
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (a = p.return) && a.call(p);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return {
            rowOffset: c,
            resultString: r
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.EAN_8;
    }, e;
}($849102574a83a574$var$ge), $849102574a83a574$var$me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ee = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.ean13Reader = new $849102574a83a574$var$ve, e;
    }
    return $849102574a83a574$var$me(e, t), e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.UPC_A;
    }, e.prototype.decode = function(t, e) {
        return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, e, r) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(t, e, r));
    }, e.prototype.decodeMiddle = function(t, e, r) {
        return this.ean13Reader.decodeMiddle(t, e, r);
    }, e.prototype.maybeReturnResult = function(t) {
        var e = t.getText();
        if ("0" === e.charAt(0)) {
            var r = new $849102574a83a574$var$gt(e.substring(1), null, null, t.getResultPoints(), $849102574a83a574$var$wt.UPC_A);
            return null != t.getResultMetadata() && r.putAllMetadata(t.getResultMetadata()), r;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        this.ean13Reader.reset();
    }, e;
}($849102574a83a574$var$ge), $849102574a83a574$var$Ie = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Se = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Te = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = new Int32Array(4), e;
    }
    return $849102574a83a574$var$Ie(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a = this.decodeMiddleCounters.map(function(t) {
            return t;
        });
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var s = t.getSize(), u = r[1], c = 0, f = 0; f < 6 && u < s; f++){
            var h = e.decodeDigit(t, a, u, e.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $849102574a83a574$var$Se(a)), d = l.next(); !d.done; d = l.next())u += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 5 - f);
        }
        return e.determineNumSysAndCheckDigit(new $849102574a83a574$var$Q(n), c), u;
    }, e.prototype.decodeEnd = function(t, r) {
        return e.findGuardPatternWithoutCounters(t, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
        return $849102574a83a574$var$ge.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, e) {
        for(var r = 0; r <= 1; r++)for(var n = 0; n < 10; n++)if (e === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n]) return t.insert(0, "0" + r), void t.append("0" + n);
        throw $849102574a83a574$var$tt.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
        var e = t.slice(1, 7).split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $849102574a83a574$var$Q;
        r.append(t.charAt(0));
        var n = e[5];
        switch(n){
            case 0:
            case 1:
            case 2:
                r.appendChars(e, 0, 2), r.append(n), r.append("0000"), r.appendChars(e, 2, 3);
                break;
            case 3:
                r.appendChars(e, 0, 3), r.append("00000"), r.appendChars(e, 3, 2);
                break;
            case 4:
                r.appendChars(e, 0, 4), r.append("00000"), r.append(e[4]);
                break;
            default:
                r.appendChars(e, 0, 5), r.append("0000"), r.append(n);
        }
        return t.length >= 8 && r.append(t.charAt(7)), r.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            56,
            52,
            50,
            49,
            44,
            38,
            35,
            42,
            41,
            37
        ]),
        Int32Array.from([
            7,
            11,
            13,
            14,
            19,
            25,
            28,
            21,
            22,
            1
        ])
    ], e;
}($849102574a83a574$var$ge), $849102574a83a574$var$Oe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$be = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Re = function(t) {
    function e(e) {
        var r = t.call(this) || this, n = null == e ? null : e.get($849102574a83a574$var$U.POSSIBLE_FORMATS), o = [];
        return null != n && (n.indexOf($849102574a83a574$var$wt.EAN_13) > -1 && o.push(new $849102574a83a574$var$ve), n.indexOf($849102574a83a574$var$wt.UPC_A) > -1 && o.push(new $849102574a83a574$var$Ee), n.indexOf($849102574a83a574$var$wt.EAN_8) > -1 && o.push(new $849102574a83a574$var$Ce), n.indexOf($849102574a83a574$var$wt.UPC_E) > -1 && o.push(new $849102574a83a574$var$Te)), 0 === o.length && (o.push(new $849102574a83a574$var$ve), o.push(new $849102574a83a574$var$Ee), o.push(new $849102574a83a574$var$Ce), o.push(new $849102574a83a574$var$Te)), r.readers = o, r;
    }
    return $849102574a83a574$var$Oe(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n, o;
        try {
            for(var i = $849102574a83a574$var$be(this.readers), a = i.next(); !a.done; a = i.next()){
                var s = a.value;
                try {
                    var u = s.decodeRow(t, e, r), c = u.getBarcodeFormat() === $849102574a83a574$var$wt.EAN_13 && "0" === u.getText().charAt(0), f = null == r ? null : r.get($849102574a83a574$var$U.POSSIBLE_FORMATS), h = null == f || f.includes($849102574a83a574$var$wt.UPC_A);
                    if (c && h) {
                        var l = u.getRawBytes(), d = new $849102574a83a574$var$gt(u.getText().substring(1), l, l ? l.length : null, u.getResultPoints(), $849102574a83a574$var$wt.UPC_A);
                        return d.putAllMetadata(u.getResultMetadata()), d;
                    }
                    return u;
                } catch (t) {}
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        var t, e;
        try {
            for(var r = $849102574a83a574$var$be(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Ne = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$De = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.CODA_BAR_CHAR_SET = {
            nnnnnww: "0",
            nnnnwwn: "1",
            nnnwnnw: "2",
            wwnnnnn: "3",
            nnwnnwn: "4",
            wnnnnwn: "5",
            nwnnnnw: "6",
            nwnnwnn: "7",
            nwwnnnn: "8",
            wnnwnnn: "9",
            nnnwwnn: "-",
            nnwwnnn: "$",
            wnnnwnw: ":",
            wnwnnnw: "/",
            wnwnwnn: ".",
            nnwwwww: "+",
            nnwwnwn: "A",
            nwnwnnw: "B",
            nnnwnww: "C",
            nnnwwwn: "D"
        }, e;
    }
    return $849102574a83a574$var$Ne(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n = this.getValidRowData(e);
        if (!n) throw new $849102574a83a574$var$tt;
        var o = this.codaBarDecodeRow(n.row);
        if (!o) throw new $849102574a83a574$var$tt;
        return new $849102574a83a574$var$gt(o, null, 0, [
            new $849102574a83a574$var$Lt(n.left, t),
            new $849102574a83a574$var$Lt(n.right, t)
        ], $849102574a83a574$var$wt.CODABAR, (new Date).getTime());
    }, e.prototype.getValidRowData = function(t) {
        var e = t.toArray(), r = e.indexOf(!0);
        if (-1 === r) return null;
        var n = e.lastIndexOf(!0);
        if (n <= r) return null;
        for(var o = [], i = (e = e.slice(r, n + 1))[0], a = 1, s = 1; s < e.length; s++)e[s] === i ? a++ : (i = e[s], o.push(a), a = 1);
        return o.push(a), o.length < 23 && (o.length + 1) % 8 != 0 ? null : {
            row: o,
            left: r,
            right: n
        };
    }, e.prototype.codaBarDecodeRow = function(t) {
        for(var e = [], r = Math.ceil(t.reduce(function(t, e) {
            return (t + e) / 2;
        }, 0)); t.length > 0;){
            var n = t.splice(0, 8).splice(0, 7).map(function(t) {
                return t < r ? "n" : "w";
            }).join("");
            if (void 0 === this.CODA_BAR_CHAR_SET[n]) return null;
            e.push(this.CODA_BAR_CHAR_SET[n]);
        }
        var o = e.join("");
        return this.validCodaBarString(o) ? o : null;
    }, e.prototype.validCodaBarString = function(t) {
        return /^[A-D].{1,}[A-D]$/.test(t);
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Pe = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Be = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeFinderCounters = new Int32Array(4), e.dataCharacterCounters = new Int32Array(8), e.oddRoundingErrors = new Array(4), e.evenRoundingErrors = new Array(4), e.oddCounts = new Array(e.dataCharacterCounters.length / 2), e.evenCounts = new Array(e.dataCharacterCounters.length / 2), e;
    }
    return $849102574a83a574$var$Me(e, t), e.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
        return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
        return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, r) {
        for(var n = 0; n < r.length; n++)if ($849102574a83a574$var$Kt.patternMatchVariance(t, r[n], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return n;
        throw new $849102574a83a574$var$tt;
    }, e.count = function(t) {
        return $849102574a83a574$var$Pt.sum(new Int32Array(t));
    }, e.increment = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] > n && (n = e[o], r = o);
        t[r]++;
    }, e.decrement = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] < n && (n = e[o], r = o);
        t[r]--;
    }, e.isFinderPattern = function(t) {
        var r, n, o = t[0] + t[1], i = o / (o + t[2] + t[3]);
        if (i >= e.MIN_FINDER_PATTERN_RATIO && i <= e.MAX_FINDER_PATTERN_RATIO) {
            var a = Number.MAX_SAFE_INTEGER, s = Number.MIN_SAFE_INTEGER;
            try {
                for(var u = $849102574a83a574$var$Pe(t), c = u.next(); !c.done; c = u.next()){
                    var f = c.value;
                    f > s && (s = f), f < a && (a = f);
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    c && !c.done && (n = u.return) && n.call(u);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s < 10 * a;
        }
        return !1;
    }, e.MAX_AVG_VARIANCE = .2, e.MAX_INDIVIDUAL_VARIANCE = .45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Le = function() {
    function t(t, e) {
        this.value = t, this.checksumPortion = e;
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    }, t.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value && this.checksumPortion === r.checksumPortion;
    }, t.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    }, t;
}(), $849102574a83a574$var$Fe = function() {
    function t(t, e, r, n, o) {
        this.value = t, this.startEnd = e, this.value = t, this.startEnd = e, this.resultPoints = new Array, this.resultPoints.push(new $849102574a83a574$var$Lt(r, o)), this.resultPoints.push(new $849102574a83a574$var$Lt(n, o));
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getStartEnd = function() {
        return this.startEnd;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.hashCode = function() {
        return this.value;
    }, t;
}(), $849102574a83a574$var$ke = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$xe = function() {
    function t() {}
    return t.getRSSvalue = function(e, r, n) {
        var o, i, a = 0;
        try {
            for(var s = $849102574a83a574$var$ke(e), u = s.next(); !u.done; u = s.next())a += u.value;
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (i = s.return) && i.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        for(var c = 0, f = 0, h = e.length, l = 0; l < h - 1; l++){
            var d = void 0;
            for(d = 1, f |= 1 << l; d < e[l]; d++, f &= ~(1 << l)){
                var p = t.combins(a - d - 1, h - l - 2);
                if (n && 0 === f && a - d - (h - l - 1) >= h - l - 1 && (p -= t.combins(a - d - (h - l), h - l - 2)), h - l - 1 > 1) {
                    for(var g = 0, y = a - d - (h - l - 2); y > r; y--)g += t.combins(a - d - y - 1, h - l - 3);
                    p -= g * (h - 1 - l);
                } else a - d > r && p--;
                c += p;
            }
            a -= d;
        }
        return c;
    }, t.combins = function(t, e) {
        var r, n;
        t - e > e ? (n = e, r = t - e) : (n = t - e, r = e);
        for(var o = 1, i = 1, a = t; a > r; a--)o *= a, i <= n && (o /= i, i++);
        for(; i <= n;)o /= i, i++;
        return o;
    }, t;
}(), $849102574a83a574$var$Ve = function() {
    function t() {}
    return t.buildBitArray = function(t) {
        var e = 2 * t.length - 1;
        null == t[t.length - 1].getRightChar() && (e -= 1);
        for(var r = new $849102574a83a574$var$V(12 * e), n = 0, o = t[0].getRightChar().getValue(), i = 11; i >= 0; --i)0 != (o & 1 << i) && r.set(n), n++;
        for(i = 1; i < t.length; ++i){
            for(var a = t[i], s = a.getLeftChar().getValue(), u = 11; u >= 0; --u)0 != (s & 1 << u) && r.set(n), n++;
            if (null !== a.getRightChar()) {
                var c = a.getRightChar().getValue();
                for(u = 11; u >= 0; --u)0 != (c & 1 << u) && r.set(n), n++;
            }
        }
        return r;
    }, t;
}(), $849102574a83a574$var$He = function() {
    function t(t, e) {
        e ? this.decodedInformation = null : (this.finished = t, this.decodedInformation = e);
    }
    return t.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    }, t.prototype.isFinished = function() {
        return this.finished;
    }, t;
}(), $849102574a83a574$var$Ue = function() {
    function t(t) {
        this.newPosition = t;
    }
    return t.prototype.getNewPosition = function() {
        return this.newPosition;
    }, t;
}(), $849102574a83a574$var$Xe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ge = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n.value = r, n;
    }
    return $849102574a83a574$var$Xe(e, t), e.prototype.getValue = function() {
        return this.value;
    }, e.prototype.isFNC1 = function() {
        return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$We = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ze = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return n ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = r, o;
    }
    return $849102574a83a574$var$We(e, t), e.prototype.getNewString = function() {
        return this.newString;
    }, e.prototype.isRemaining = function() {
        return this.remaining;
    }, e.prototype.getRemainingValue = function() {
        return this.remainingValue;
    }, e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ye = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        if (r < 0 || r > 10 || n < 0 || n > 10) throw new $849102574a83a574$var$G;
        return o.firstDigit = r, o.secondDigit = n, o;
    }
    return $849102574a83a574$var$je(e, t), e.prototype.getFirstDigit = function() {
        return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
        return this.secondDigit;
    }, e.prototype.getValue = function() {
        return 10 * this.firstDigit + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
        return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$Ze = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ke = function() {
    function t() {}
    return t.parseFieldsInGeneralPurpose = function(e) {
        var r, n, o, i, a, s, u, c;
        if (!e) return null;
        if (e.length < 2) throw new $849102574a83a574$var$tt;
        var f = e.substring(0, 2);
        try {
            for(var h = $849102574a83a574$var$Ze(t.TWO_DIGIT_DATA_LENGTH), l = h.next(); !l.done; l = h.next()){
                if ((C = l.value)[0] === f) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, C[2], e) : t.processFixedAI(2, C[1], e);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        if (e.length < 3) throw new $849102574a83a574$var$tt;
        var d = e.substring(0, 3);
        try {
            for(var p = $849102574a83a574$var$Ze(t.THREE_DIGIT_DATA_LENGTH), g = p.next(); !g.done; g = p.next()){
                if ((C = g.value)[0] === d) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, C[2], e) : t.processFixedAI(3, C[1], e);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        try {
            for(var y = $849102574a83a574$var$Ze(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), w = y.next(); !w.done; w = y.next()){
                if ((C = w.value)[0] === d) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, C[2], e) : t.processFixedAI(4, C[1], e);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (s = y.return) && s.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        if (e.length < 4) throw new $849102574a83a574$var$tt;
        var v = e.substring(0, 4);
        try {
            for(var _ = $849102574a83a574$var$Ze(t.FOUR_DIGIT_DATA_LENGTH), A = _.next(); !A.done; A = _.next()){
                var C;
                if ((C = A.value)[0] === v) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, C[2], e) : t.processFixedAI(4, C[1], e);
            }
        } catch (t) {
            u = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (c = _.return) && c.call(_);
            } finally{
                if (u) throw u.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, t.processFixedAI = function(e, r, n) {
        if (n.length < e) throw new $849102574a83a574$var$tt;
        var o = n.substring(0, e);
        if (n.length < e + r) throw new $849102574a83a574$var$tt;
        var i = n.substring(e, e + r), a = n.substring(e + r), s = "(" + o + ")" + i, u = t.parseFieldsInGeneralPurpose(a);
        return null == u ? s : s + u;
    }, t.processVariableAI = function(e, r, n) {
        var o, i = n.substring(0, e);
        o = n.length < e + r ? n.length : e + r;
        var a = n.substring(e, o), s = n.substring(o), u = "(" + i + ")" + a, c = t.parseFieldsInGeneralPurpose(s);
        return null == c ? u : u + c;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            t.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "90",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            t.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.THREE_DIGIT_DATA_LENGTH = [
        [
            "240",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            t.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            t.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
        [
            "7001",
            13
        ],
        [
            "7002",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            t.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            t.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            t.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            t.VARIABLE_LENGTH,
            70
        ]
    ], t;
}(), $849102574a83a574$var$qe = function() {
    function t(t) {
        this.buffer = new $849102574a83a574$var$Q, this.information = t;
    }
    return t.prototype.decodeAllCodes = function(t, e) {
        for(var r = e, n = null;;){
            var o = this.decodeGeneralPurposeField(r, n), i = $849102574a83a574$var$Ke.parseFieldsInGeneralPurpose(o.getNewString());
            if (null != i && t.append(i), n = o.isRemaining() ? "" + o.getRemainingValue() : null, r === o.getNewPosition()) break;
            r = o.getNewPosition();
        }
        return t.toString();
    }, t.prototype.isStillNumeric = function(t) {
        if (t + 7 > this.information.getSize()) return t + 4 <= this.information.getSize();
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !0;
        return this.information.get(t + 3);
    }, t.prototype.decodeNumeric = function(t) {
        if (t + 7 > this.information.getSize()) {
            var e = this.extractNumericValueFromBitArray(t, 4);
            return new $849102574a83a574$var$Ye(this.information.getSize(), 0 === e ? $849102574a83a574$var$Ye.FNC1 : e - 1, $849102574a83a574$var$Ye.FNC1);
        }
        var r = this.extractNumericValueFromBitArray(t, 7);
        return new $849102574a83a574$var$Ye(t + 7, (r - 8) / 11, (r - 8) % 11);
    }, t.prototype.extractNumericValueFromBitArray = function(e, r) {
        return t.extractNumericValueFromBitArray(this.information, e, r);
    }, t.extractNumericValueFromBitArray = function(t, e, r) {
        for(var n = 0, o = 0; o < r; ++o)t.get(e + o) && (n |= 1 << r - o - 1);
        return n;
    }, t.prototype.decodeGeneralPurposeField = function(t, e) {
        this.buffer.setLengthToZero(), null != e && this.buffer.append(e), this.current.setPosition(t);
        var r = this.parseBlocks();
        return null != r && r.isRemaining() ? new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
        var t, e;
        do {
            var r = this.current.getPosition();
            if (t = this.current.isAlpha() ? (e = this.parseAlphaBlock()).isFinished() : this.current.isIsoIec646() ? (e = this.parseIsoIec646Block()).isFinished() : (e = this.parseNumericBlock()).isFinished(), !(r !== this.current.getPosition()) && !t) break;
        }while (!t);
        return e.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
        for(; this.isStillNumeric(this.current.getPosition());){
            var t = this.decodeNumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFirstDigitFNC1()) {
                var e = void 0;
                return e = t.isSecondDigitFNC1() ? new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString()) : new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString(), t.getSecondDigit()), new $849102574a83a574$var$He(!0, e);
            }
            if (this.buffer.append(t.getFirstDigit()), t.isSecondDigitFNC1()) {
                e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getSecondDigit());
        }
        return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $849102574a83a574$var$He(!1);
    }, t.prototype.parseIsoIec646Block = function() {
        for(; this.isStillIsoIec646(this.current.getPosition());){
            var t = this.decodeIsoIec646(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $849102574a83a574$var$He(!1);
    }, t.prototype.parseAlphaBlock = function() {
        for(; this.isStillAlpha(this.current.getPosition());){
            var t = this.decodeAlphanumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $849102574a83a574$var$He(!1);
    }, t.prototype.isStillIsoIec646 = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 7 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 7);
        if (r >= 64 && r < 116) return !0;
        if (t + 8 > this.information.getSize()) return !1;
        var n = this.extractNumericValueFromBitArray(t, 8);
        return n >= 232 && n < 253;
    }, t.prototype.decodeIsoIec646 = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $849102574a83a574$var$Ge(t + 5, $849102574a83a574$var$Ge.FNC1);
        if (e >= 5 && e < 15) return new $849102574a83a574$var$Ge(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 7);
        if (n >= 64 && n < 90) return new $849102574a83a574$var$Ge(t + 7, "" + (n + 1));
        if (n >= 90 && n < 116) return new $849102574a83a574$var$Ge(t + 7, "" + (n + 7));
        switch(this.extractNumericValueFromBitArray(t, 8)){
            case 232:
                r = "!";
                break;
            case 233:
                r = '"';
                break;
            case 234:
                r = "%";
                break;
            case 235:
                r = "&";
                break;
            case 236:
                r = "'";
                break;
            case 237:
                r = "(";
                break;
            case 238:
                r = ")";
                break;
            case 239:
                r = "*";
                break;
            case 240:
                r = "+";
                break;
            case 241:
                r = ",";
                break;
            case 242:
                r = "-";
                break;
            case 243:
                r = ".";
                break;
            case 244:
                r = "/";
                break;
            case 245:
                r = ":";
                break;
            case 246:
                r = ";";
                break;
            case 247:
                r = "<";
                break;
            case 248:
                r = "=";
                break;
            case 249:
                r = ">";
                break;
            case 250:
                r = "?";
                break;
            case 251:
                r = "_";
                break;
            case 252:
                r = " ";
                break;
            default:
                throw new $849102574a83a574$var$G;
        }
        return new $849102574a83a574$var$Ge(t + 8, r);
    }, t.prototype.isStillAlpha = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 6 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 6);
        return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $849102574a83a574$var$Ge(t + 5, $849102574a83a574$var$Ge.FNC1);
        if (e >= 5 && e < 15) return new $849102574a83a574$var$Ge(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 6);
        if (n >= 32 && n < 58) return new $849102574a83a574$var$Ge(t + 6, "" + (n + 33));
        switch(n){
            case 58:
                r = "*";
                break;
            case 59:
                r = ",";
                break;
            case 60:
                r = "-";
                break;
            case 61:
                r = ".";
                break;
            case 62:
                r = "/";
                break;
            default:
                throw new $849102574a83a574$var$Nt("Decoding invalid alphanumeric value: " + n);
        }
        return new $849102574a83a574$var$Ge(t + 6, r);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 5 && e + t < this.information.getSize(); ++e)if (2 === e) {
            if (!this.information.get(t + 2)) return !1;
        } else if (this.information.get(t + e)) return !1;
        return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(t) {
        if (t + 3 > this.information.getSize()) return !1;
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !1;
        return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 4 && e + t < this.information.getSize(); ++e)if (this.information.get(t + e)) return !1;
        return !0;
    }, t;
}(), $849102574a83a574$var$Qe = function() {
    function t(t) {
        this.information = t, this.generalDecoder = new $849102574a83a574$var$qe(t);
    }
    return t.prototype.getInformation = function() {
        return this.information;
    }, t.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    }, t;
}(), $849102574a83a574$var$Je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$$e = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$Je(e, t), e.prototype.encodeCompressedGtin = function(t, e) {
        t.append("(01)");
        var r = t.length();
        t.append("9"), this.encodeCompressedGtinWithoutAI(t, e, r);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, r, n) {
        for(var o = 0; o < 4; ++o){
            var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * o, 10);
            i / 100 == 0 && t.append("0"), i / 10 == 0 && t.append("0"), t.append(i);
        }
        e.appendCheckDigit(t, n);
    }, e.appendCheckDigit = function(t, e) {
        for(var r = 0, n = 0; n < 13; n++){
            var o = t.charAt(n + e).charCodeAt(0) - "0".charCodeAt(0);
            r += 0 == (1 & n) ? 3 * o : o;
        }
        10 === (r = 10 - r % 10) && (r = 0), t.append(r);
    }, e.GTIN_SIZE = 40, e;
}($849102574a83a574$var$Qe), $849102574a83a574$var$tr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$er = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$tr(e, t), e.prototype.parseInformation = function() {
        var t = new $849102574a83a574$var$Q;
        t.append("(01)");
        var r = t.length(), n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
        return t.append(n), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$rr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$nr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$rr(e, t), e.prototype.parseInformation = function() {
        var t = new $849102574a83a574$var$Q;
        return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
}($849102574a83a574$var$Qe), $849102574a83a574$var$or = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ir = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$or(e, t), e.prototype.encodeCompressedWeight = function(t, e, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e, r);
        this.addWeightCode(t, n);
        for(var o = this.checkWeight(n), i = 1e5, a = 0; a < 5; ++a)o / i == 0 && t.append("0"), i /= 10;
        t.append(o);
    }, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$sr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$ar(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== e.HEADER_SIZE + $849102574a83a574$var$ir.GTIN_SIZE + e.WEIGHT_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + $849102574a83a574$var$ir.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
}($849102574a83a574$var$ir), $849102574a83a574$var$ur = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$cr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$ur(e, t), e.prototype.addWeightCode = function(t, e) {
        t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
        return t;
    }, e;
}($849102574a83a574$var$sr), $849102574a83a574$var$fr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$hr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$fr(e, t), e.prototype.addWeightCode = function(t, e) {
        e < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
        return t < 1e4 ? t : t - 1e4;
    }, e;
}($849102574a83a574$var$sr), $849102574a83a574$var$lr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$dr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$lr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(392"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
        return t.append(n.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$pr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$gr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$pr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(393"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
        n / 100 == 0 && t.append("0"), n / 10 == 0 && t.append("0"), t.append(n);
        var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
        return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$yr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$wr = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.dateCode = n, o.firstAIdigits = r, o;
    }
    return $849102574a83a574$var$yr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
        if (38400 !== n) {
            t.append("("), t.append(this.dateCode), t.append(")");
            var o = n % 32, i = (n /= 32) % 12 + 1, a = n /= 12;
            a / 10 == 0 && t.append("0"), t.append(a), i / 10 == 0 && t.append("0"), t.append(i), o / 10 == 0 && t.append("0"), t.append(o);
        }
    }, e.prototype.addWeightCode = function(t, e) {
        t.append("("), t.append(this.firstAIdigits), t.append(e / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
        return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
}($849102574a83a574$var$ir);
var $849102574a83a574$var$vr = function() {
    function t(t, e, r, n) {
        this.leftchar = t, this.rightchar = e, this.finderpattern = r, this.maybeLast = n;
    }
    return t.prototype.mayBeLast = function() {
        return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
        return this.leftchar;
    }, t.prototype.getRightChar = function() {
        return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
        return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
        return null == this.rightchar;
    }, t.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (null == this.finderpattern ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, r) {
        return e instanceof t && t.equalsOrNull(e.leftchar, r.leftchar) && t.equalsOrNull(e.rightchar, r.rightchar) && t.equalsOrNull(e.finderpattern, r.finderpattern);
    }, t.equalsOrNull = function(e, r) {
        return null === e ? null === r : t.equals(e, r);
    }, t.prototype.hashCode = function() {
        return this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
    }, t;
}(), $849102574a83a574$var$_r = function() {
    function t(t, e, r) {
        this.pairs = t, this.rowNumber = e, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
        return this.pairs;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.isReversed = function() {
        return this.wasReversed;
    }, t.prototype.isEquivalent = function(t) {
        return this.checkEqualitity(this, t);
    }, t.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, r) {
        return e instanceof t && this.checkEqualitity(e, r) && e.wasReversed === r.wasReversed;
    }, t.prototype.checkEqualitity = function(t, e) {
        var r;
        if (t && e) return t.forEach(function(t, n) {
            e.forEach(function(e) {
                t.getLeftChar().getValue() === e.getLeftChar().getValue() && t.getRightChar().getValue() === e.getRightChar().getValue() && t.getFinderPatter().getValue() === e.getFinderPatter().getValue() && (r = !0);
            });
        }), r;
    }, t;
}(), $849102574a83a574$var$Ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Cr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$mr = function(t) {
    function e() {
        var r = null !== t && t.apply(this, arguments) || this;
        return r.pairs = new Array(e.MAX_PAIRS), r.rows = new Array, r.startEnd = [
            2
        ], r;
    }
    return $849102574a83a574$var$Ar(e, t), e.prototype.decodeRow = function(t, r, n) {
        this.pairs.length = 0, this.startFromEven = !1;
        try {
            return e.constructResult(this.decodeRow2pairs(t, r));
        } catch (t) {}
        return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, r));
    }, e.prototype.reset = function() {
        this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, e) {
        for(var r, n = !1; !n;)try {
            this.pairs.push(this.retrieveNextPair(e, this.pairs, t));
        } catch (t) {
            if (t instanceof $849102574a83a574$var$tt) {
                if (!this.pairs.length) throw new $849102574a83a574$var$tt;
                n = !0;
            }
        }
        if (this.checkChecksum()) return this.pairs;
        if (r = !!this.rows.length, this.storeRow(t, !1), r) {
            var o = this.checkRowsBoolean(!1);
            if (null != o) return o;
            if (null != (o = this.checkRowsBoolean(!0))) return o;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.checkRowsBoolean = function(t) {
        if (this.rows.length > 25) return this.rows.length = 0, null;
        this.pairs.length = 0, t && (this.rows = this.rows.reverse());
        var e = null;
        try {
            e = this.checkRows(new Array, 0);
        } catch (t) {
            console.log(t);
        }
        return t && (this.rows = this.rows.reverse()), e;
    }, e.prototype.checkRows = function(t, r) {
        for(var n, o, i = r; i < this.rows.length; i++){
            var a = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var s = (n = void 0, $849102574a83a574$var$Cr(t)), u = s.next(); !u.done; u = s.next()){
                    var c = u.value;
                    this.pairs.push(c.getPairs());
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    u && !u.done && (o = s.return) && o.call(s);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (this.pairs.push(a.getPairs()), e.isValidSequence(this.pairs)) {
                if (this.checkChecksum()) return this.pairs;
                var f = new Array(t);
                f.push(a);
                try {
                    return this.checkRows(f, i + 1);
                } catch (t) {
                    console.log(t);
                }
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.isValidSequence = function(t) {
        var r, n;
        try {
            for(var o = $849102574a83a574$var$Cr(e.FINDER_PATTERN_SEQUENCES), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (!(t.length > a.length)) {
                    for(var s = !0, u = 0; u < t.length; u++)if (t[u].getFinderPattern().getValue() !== a[u]) {
                        s = !1;
                        break;
                    }
                    if (s) return !0;
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.storeRow = function(t, r) {
        for(var n = 0, o = !1, i = !1; n < this.rows.length;){
            var a = this.rows[n];
            if (a.getRowNumber() > t) {
                i = a.isEquivalent(this.pairs);
                break;
            }
            o = a.isEquivalent(this.pairs), n++;
        }
        i || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(n, new $849102574a83a574$var$_r(this.pairs, t, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, e) {
        var r, n, o, i, a, s;
        try {
            for(var u = $849102574a83a574$var$Cr(e), c = u.next(); !c.done; c = u.next()){
                var f = c.value;
                if (f.getPairs().length !== t.length) try {
                    for(var h = (o = void 0, $849102574a83a574$var$Cr(f.getPairs())), l = h.next(); !l.done; l = h.next()){
                        var d = l.value, p = !1;
                        try {
                            for(var g = (a = void 0, $849102574a83a574$var$Cr(t)), y = g.next(); !y.done; y = g.next()){
                                var w = y.value;
                                if ($849102574a83a574$var$vr.equals(d, w)) {
                                    p = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                y && !y.done && (s = g.return) && s.call(g);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        p;
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (i = h.return) && i.call(h);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.isPartialRow = function(t, e) {
        var r, n, o, i, a, s;
        try {
            for(var u = $849102574a83a574$var$Cr(e), c = u.next(); !c.done; c = u.next()){
                var f = c.value, h = !0;
                try {
                    for(var l = (o = void 0, $849102574a83a574$var$Cr(t)), d = l.next(); !d.done; d = l.next()){
                        var p = d.value, g = !1;
                        try {
                            for(var y = (a = void 0, $849102574a83a574$var$Cr(f.getPairs())), w = y.next(); !w.done; w = y.next()){
                                var v = w.value;
                                if (p.equals(v)) {
                                    g = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                w && !w.done && (s = y.return) && s.call(y);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        if (!g) {
                            h = !1;
                            break;
                        }
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (i = l.return) && i.call(l);
                    } finally{
                        if (o) throw o.error;
                    }
                }
                if (h) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.getRows = function() {
        return this.rows;
    }, e.constructResult = function(t) {
        var e = (function(t) {
            try {
                if (t.get(1)) return new $849102574a83a574$var$er(t);
                if (!t.get(2)) return new $849102574a83a574$var$nr(t);
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 4)){
                    case 4:
                        return new $849102574a83a574$var$cr(t);
                    case 5:
                        return new $849102574a83a574$var$hr(t);
                }
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 5)){
                    case 12:
                        return new $849102574a83a574$var$dr(t);
                    case 13:
                        return new $849102574a83a574$var$gr(t);
                }
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 7)){
                    case 56:
                        return new $849102574a83a574$var$wr(t, "310", "11");
                    case 57:
                        return new $849102574a83a574$var$wr(t, "320", "11");
                    case 58:
                        return new $849102574a83a574$var$wr(t, "310", "13");
                    case 59:
                        return new $849102574a83a574$var$wr(t, "320", "13");
                    case 60:
                        return new $849102574a83a574$var$wr(t, "310", "15");
                    case 61:
                        return new $849102574a83a574$var$wr(t, "320", "15");
                    case 62:
                        return new $849102574a83a574$var$wr(t, "310", "17");
                    case 63:
                        return new $849102574a83a574$var$wr(t, "320", "17");
                }
            } catch (e) {
                throw console.log(e), new $849102574a83a574$var$Nt("unknown decoder: " + t);
            }
        })($849102574a83a574$var$Ve.buildBitArray(t)).parseInformation(), r = t[0].getFinderPattern().getResultPoints(), n = t[t.length - 1].getFinderPattern().getResultPoints(), o = [
            r[0],
            r[1],
            n[0],
            n[1]
        ];
        return new $849102574a83a574$var$gt(e, null, null, o, $849102574a83a574$var$wt.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
        var t = this.pairs.get(0), e = t.getLeftChar(), r = t.getRightChar();
        if (null === r) return !1;
        for(var n = r.getChecksumPortion(), o = 2, i = 1; i < this.pairs.size(); ++i){
            var a = this.pairs.get(i);
            n += a.getLeftChar().getChecksumPortion(), o++;
            var s = a.getRightChar();
            null != s && (n += s.getChecksumPortion(), o++);
        }
        return 211 * (o - 4) + (n %= 211) === e.getValue();
    }, e.getNextSecondBar = function(t, e) {
        var r;
        return t.get(e) ? (r = t.getNextUnset(e), r = t.getNextSet(r)) : (r = t.getNextSet(e), r = t.getNextUnset(r)), r;
    }, e.prototype.retrieveNextPair = function(t, r, n) {
        var o, i = r.length % 2 == 0;
        this.startFromEven && (i = !i);
        var a = !0, s = -1;
        do this.findNextPair(t, r, s), null === (o = this.parseFoundFinderPattern(t, n, i)) ? s = e.getNextSecondBar(t, this.startEnd[0]) : a = !1;
        while (a);
        var u, c = this.decodeDataCharacter(t, o, i, !0);
        if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast()) throw new $849102574a83a574$var$tt;
        try {
            u = this.decodeDataCharacter(t, o, i, !1);
        } catch (t) {
            u = null, console.log(t);
        }
        return new $849102574a83a574$var$vr(c, u, o, !0);
    }, e.prototype.isEmptyPair = function(t) {
        return 0 === t.length;
    }, e.prototype.findNextPair = function(t, r, n) {
        var o = this.getDecodeFinderCounters();
        o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
        var i, a = t.getSize();
        if (n >= 0) i = n;
        else if (this.isEmptyPair(r)) i = 0;
        else i = r[r.length - 1].getFinderPattern().getStartEnd()[1];
        var s = r.length % 2 != 0;
        this.startFromEven && (s = !s);
        for(var u = !1; i < a && (u = !t.get(i));)i++;
        for(var c = 0, f = i, h = i; h < a; h++)if (t.get(h) !== u) o[c]++;
        else {
            if (3 === c) {
                if (s && e.reverseCounters(o), e.isFinderPattern(o)) return this.startEnd[0] = f, void (this.startEnd[1] = h);
                s && e.reverseCounters(o), f += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, c--;
            } else c++;
            o[c] = 1, u = !u;
        }
        throw new $849102574a83a574$var$tt;
    }, e.reverseCounters = function(t) {
        for(var e = t.length, r = 0; r < e / 2; ++r){
            var n = t[r];
            t[r] = t[e - r - 1], t[e - r - 1] = n;
        }
    }, e.prototype.parseFoundFinderPattern = function(t, r, n) {
        var o, i, a;
        if (n) {
            for(var s = this.startEnd[0] - 1; s >= 0 && !t.get(s);)s--;
            s++, o = this.startEnd[0] - s, i = s, a = this.startEnd[1];
        } else i = this.startEnd[0], o = (a = t.getNextUnset(this.startEnd[1] + 1)) - this.startEnd[1];
        var u, c = this.getDecodeFinderCounters();
        $849102574a83a574$var$D.arraycopy(c, 0, c, 1, c.length - 1), c[0] = o;
        try {
            u = this.parseFinderValue(c, e.FINDER_PATTERNS);
        } catch (t) {
            return null;
        }
        return new $849102574a83a574$var$Fe(u, [
            i,
            a
        ], i, a, r);
    }, e.prototype.decodeDataCharacter = function(t, r, n, o) {
        for(var i = this.getDataCharacterCounters(), a = 0; a < i.length; a++)i[a] = 0;
        if (o) e.recordPatternInReverse(t, r.getStartEnd()[0], i);
        else {
            e.recordPattern(t, r.getStartEnd()[1], i);
            for(var s = 0, u = i.length - 1; s < u; s++, u--){
                var c = i[s];
                i[s] = i[u], i[u] = c;
            }
        }
        var f = $849102574a83a574$var$Pt.sum(new Int32Array(i)) / 17, h = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
        if (Math.abs(f - h) / h > .3) throw new $849102574a83a574$var$tt;
        var l = this.getOddCounts(), d = this.getEvenCounts(), p = this.getOddRoundingErrors(), g = this.getEvenRoundingErrors();
        for(s = 0; s < i.length; s++){
            var y = 1 * i[s] / f, w = y + .5;
            if (w < 1) {
                if (y < .3) throw new $849102574a83a574$var$tt;
                w = 1;
            } else if (w > 8) {
                if (y > 8.7) throw new $849102574a83a574$var$tt;
                w = 8;
            }
            var v = s / 2;
            0 == (1 & s) ? (l[v] = w, p[v] = y - w) : (d[v] = w, g[v] = y - w);
        }
        this.adjustOddEvenCounts(17);
        var _ = 4 * r.getValue() + (n ? 0 : 2) + (o ? 0 : 1) - 1, A = 0, C = 0;
        for(s = l.length - 1; s >= 0; s--){
            if (e.isNotA1left(r, n, o)) {
                var m = e.WEIGHTS[_][2 * s];
                C += l[s] * m;
            }
            A += l[s];
        }
        var E = 0;
        for(s = d.length - 1; s >= 0; s--)if (e.isNotA1left(r, n, o)) {
            m = e.WEIGHTS[_][2 * s + 1];
            E += d[s] * m;
        }
        var I = C + E;
        if (0 != (1 & A) || A > 13 || A < 4) throw new $849102574a83a574$var$tt;
        var S = (13 - A) / 2, T = e.SYMBOL_WIDEST[S], O = 9 - T, b = $849102574a83a574$var$xe.getRSSvalue(l, T, !0), R = $849102574a83a574$var$xe.getRSSvalue(d, O, !1), N = e.EVEN_TOTAL_SUBSET[S], D = e.GSUM[S];
        return new $849102574a83a574$var$Le(b * N + R + D, I);
    }, e.isNotA1left = function(t, e, r) {
        return !(0 === t.getValue() && e && r);
    }, e.prototype.adjustOddEvenCounts = function(t) {
        var r = $849102574a83a574$var$Pt.sum(new Int32Array(this.getOddCounts())), n = $849102574a83a574$var$Pt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1;
        r > 13 ? i = !0 : r < 4 && (o = !0);
        var a = !1, s = !1;
        n > 13 ? s = !0 : n < 4 && (a = !0);
        var u = r + n - t, c = 1 == (1 & r), f = 0 == (1 & n);
        if (1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                i = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                s = !0;
            }
        } else if (-1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                o = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                a = !0;
            }
        } else {
            if (0 !== u) throw new $849102574a83a574$var$tt;
            if (c) {
                if (!f) throw new $849102574a83a574$var$tt;
                r < n ? (o = !0, s = !0) : (i = !0, a = !0);
            } else if (f) throw new $849102574a83a574$var$tt;
        }
        if (o) {
            if (i) throw new $849102574a83a574$var$tt;
            e.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (s) throw new $849102574a83a574$var$tt;
            e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        s && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ], e.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ], e.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ], e.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_C,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_C
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ]
    ], e.MAX_PAIRS = 11, e;
}($849102574a83a574$var$Be), $849102574a83a574$var$Er = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ir = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.count = 0, o.finderPattern = n, o;
    }
    return $849102574a83a574$var$Er(e, t), e.prototype.getFinderPattern = function() {
        return this.finderPattern;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.incrementCount = function() {
        this.count++;
    }, e;
}($849102574a83a574$var$Le), $849102574a83a574$var$Sr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Tr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Or = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.possibleLeftPairs = [], e.possibleRightPairs = [], e;
    }
    return $849102574a83a574$var$Sr(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u = this.decodePair(r, !1, t, n);
        e.addOrTally(this.possibleLeftPairs, u), r.reverse();
        var c = this.decodePair(r, !0, t, n);
        e.addOrTally(this.possibleRightPairs, c), r.reverse();
        try {
            for(var f = $849102574a83a574$var$Tr(this.possibleLeftPairs), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (l.getCount() > 1) try {
                    for(var d = (a = void 0, $849102574a83a574$var$Tr(this.possibleRightPairs)), p = d.next(); !p.done; p = d.next()){
                        var g = p.value;
                        if (g.getCount() > 1 && e.checkChecksum(l, g)) return e.constructResult(l, g);
                    }
                } catch (t) {
                    a = {
                        error: t
                    };
                } finally{
                    try {
                        p && !p.done && (s = d.return) && s.call(d);
                    } finally{
                        if (a) throw a.error;
                    }
                }
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.addOrTally = function(t, e) {
        var r, n;
        if (null != e) {
            var o = !1;
            try {
                for(var i = $849102574a83a574$var$Tr(t), a = i.next(); !a.done; a = i.next()){
                    var s = a.value;
                    if (s.getValue() === e.getValue()) {
                        s.incrementCount(), o = !0;
                        break;
                    }
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    a && !a.done && (n = i.return) && n.call(i);
                } finally{
                    if (r) throw r.error;
                }
            }
            o || t.push(e);
        }
    }, e.prototype.reset = function() {
        this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, e) {
        for(var r = 4537077 * t.getValue() + e.getValue(), n = new String(r).toString(), o = new $849102574a83a574$var$Q, i = 13 - n.length; i > 0; i--)o.append("0");
        o.append(n);
        var a = 0;
        for(i = 0; i < 13; i++){
            var s = o.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            a += 0 == (1 & i) ? 3 * s : s;
        }
        10 === (a = 10 - a % 10) && (a = 0), o.append(a.toString());
        var u = t.getFinderPattern().getResultPoints(), c = e.getFinderPattern().getResultPoints();
        return new $849102574a83a574$var$gt(o.toString(), null, 0, [
            u[0],
            u[1],
            c[0],
            c[1]
        ], $849102574a83a574$var$wt.RSS_14, (new Date).getTime());
    }, e.checkChecksum = function(t, e) {
        var r = (t.getChecksumPortion() + 16 * e.getChecksumPortion()) % 79, n = 9 * t.getFinderPattern().getValue() + e.getFinderPattern().getValue();
        return n > 72 && n--, n > 8 && n--, r === n;
    }, e.prototype.decodePair = function(t, e, r, n) {
        try {
            var o = this.findFinderPattern(t, e), i = this.parseFoundFinderPattern(t, r, e, o), a = null == n ? null : n.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
            if (null != a) {
                var s = (o[0] + o[1]) / 2;
                e && (s = t.getSize() - 1 - s), a.foundPossibleResultPoint(new $849102574a83a574$var$Lt(s, r));
            }
            var u = this.decodeDataCharacter(t, i, !0), c = this.decodeDataCharacter(t, i, !1);
            return new $849102574a83a574$var$Ir(1597 * u.getValue() + c.getValue(), u.getChecksumPortion() + 4 * c.getChecksumPortion(), i);
        } catch (t) {
            return null;
        }
    }, e.prototype.decodeDataCharacter = function(t, r, n) {
        for(var o = this.getDataCharacterCounters(), i = 0; i < o.length; i++)o[i] = 0;
        if (n) $849102574a83a574$var$Kt.recordPatternInReverse(t, r.getStartEnd()[0], o);
        else {
            $849102574a83a574$var$Kt.recordPattern(t, r.getStartEnd()[1] + 1, o);
            for(var a = 0, s = o.length - 1; a < s; a++, s--){
                var u = o[a];
                o[a] = o[s], o[s] = u;
            }
        }
        var c = n ? 16 : 15, f = $849102574a83a574$var$Pt.sum(new Int32Array(o)) / c, h = this.getOddCounts(), l = this.getEvenCounts(), d = this.getOddRoundingErrors(), p = this.getEvenRoundingErrors();
        for(a = 0; a < o.length; a++){
            var g = o[a] / f, y = Math.floor(g + .5);
            y < 1 ? y = 1 : y > 8 && (y = 8);
            var w = Math.floor(a / 2);
            0 == (1 & a) ? (h[w] = y, d[w] = g - y) : (l[w] = y, p[w] = g - y);
        }
        this.adjustOddEvenCounts(n, c);
        var v = 0, _ = 0;
        for(a = h.length - 1; a >= 0; a--)_ *= 9, _ += h[a], v += h[a];
        var A = 0, C = 0;
        for(a = l.length - 1; a >= 0; a--)A *= 9, A += l[a], C += l[a];
        var m = _ + 3 * A;
        if (n) {
            if (0 != (1 & v) || v > 12 || v < 4) throw new $849102574a83a574$var$tt;
            var E = (12 - v) / 2, I = 9 - (R = e.OUTSIDE_ODD_WIDEST[E]), S = $849102574a83a574$var$xe.getRSSvalue(h, R, !1), T = $849102574a83a574$var$xe.getRSSvalue(l, I, !0), O = e.OUTSIDE_EVEN_TOTAL_SUBSET[E], b = e.OUTSIDE_GSUM[E];
            return new $849102574a83a574$var$Le(S * O + T + b, m);
        }
        if (0 != (1 & C) || C > 10 || C < 4) throw new $849102574a83a574$var$tt;
        E = (10 - C) / 2, I = 9 - (R = e.INSIDE_ODD_WIDEST[E]), S = $849102574a83a574$var$xe.getRSSvalue(h, R, !0), T = $849102574a83a574$var$xe.getRSSvalue(l, I, !1);
        var R, N = e.INSIDE_ODD_TOTAL_SUBSET[E];
        b = e.INSIDE_GSUM[E];
        return new $849102574a83a574$var$Le(T * N + S + b, m);
    }, e.prototype.findFinderPattern = function(t, e) {
        var r = this.getDecodeFinderCounters();
        r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0;
        for(var n = t.getSize(), o = !1, i = 0; i < n && e !== (o = !t.get(i));)i++;
        for(var a = 0, s = i, u = i; u < n; u++)if (t.get(u) !== o) r[a]++;
        else {
            if (3 === a) {
                if ($849102574a83a574$var$Be.isFinderPattern(r)) return [
                    s,
                    u
                ];
                s += r[0] + r[1], r[0] = r[2], r[1] = r[3], r[2] = 0, r[3] = 0, a--;
            } else a++;
            r[a] = 1, o = !o;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.parseFoundFinderPattern = function(t, r, n, o) {
        for(var i = t.get(o[0]), a = o[0] - 1; a >= 0 && i !== t.get(a);)a--;
        a++;
        var s = o[0] - a, u = this.getDecodeFinderCounters(), c = new Int32Array(u.length);
        $849102574a83a574$var$D.arraycopy(u, 0, c, 1, u.length - 1), c[0] = s;
        var f = this.parseFinderValue(c, e.FINDER_PATTERNS), h = a, l = o[1];
        return n && (h = t.getSize() - 1 - h, l = t.getSize() - 1 - l), new $849102574a83a574$var$Fe(f, [
            a,
            o[1]
        ], h, l, r);
    }, e.prototype.adjustOddEvenCounts = function(t, e) {
        var r = $849102574a83a574$var$Pt.sum(new Int32Array(this.getOddCounts())), n = $849102574a83a574$var$Pt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1, a = !1, s = !1;
        t ? (r > 12 ? i = !0 : r < 4 && (o = !0), n > 12 ? s = !0 : n < 4 && (a = !0)) : (r > 11 ? i = !0 : r < 5 && (o = !0), n > 10 ? s = !0 : n < 4 && (a = !0));
        var u = r + n - e, c = (1 & r) == (t ? 1 : 0), f = 1 == (1 & n);
        if (1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                i = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                s = !0;
            }
        } else if (-1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                o = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                a = !0;
            }
        } else {
            if (0 !== u) throw new $849102574a83a574$var$tt;
            if (c) {
                if (!f) throw new $849102574a83a574$var$tt;
                r < n ? (o = !0, s = !0) : (i = !0, a = !0);
            } else if (f) throw new $849102574a83a574$var$tt;
        }
        if (o) {
            if (i) throw new $849102574a83a574$var$tt;
            $849102574a83a574$var$Be.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && $849102574a83a574$var$Be.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (s) throw new $849102574a83a574$var$tt;
            $849102574a83a574$var$Be.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        s && $849102574a83a574$var$Be.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ], e.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ], e.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ], e.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ], e.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ], e.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ], e;
}($849102574a83a574$var$Be), $849102574a83a574$var$br = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Rr = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        r.readers = [];
        var n = e ? e.get($849102574a83a574$var$U.POSSIBLE_FORMATS) : null, o = e && void 0 !== e.get($849102574a83a574$var$U.ASSUME_CODE_39_CHECK_DIGIT);
        return n && ((n.includes($849102574a83a574$var$wt.EAN_13) || n.includes($849102574a83a574$var$wt.UPC_A) || n.includes($849102574a83a574$var$wt.EAN_8) || n.includes($849102574a83a574$var$wt.UPC_E)) && r.readers.push(new $849102574a83a574$var$Re(e)), n.includes($849102574a83a574$var$wt.CODE_39) && r.readers.push(new $849102574a83a574$var$te(o)), n.includes($849102574a83a574$var$wt.CODE_93) && r.readers.push(new $849102574a83a574$var$ne), n.includes($849102574a83a574$var$wt.CODE_128) && r.readers.push(new $849102574a83a574$var$Qt), n.includes($849102574a83a574$var$wt.ITF) && r.readers.push(new $849102574a83a574$var$ae), n.includes($849102574a83a574$var$wt.CODABAR) && r.readers.push(new $849102574a83a574$var$De), n.includes($849102574a83a574$var$wt.RSS_14) && r.readers.push(new $849102574a83a574$var$Or), n.includes($849102574a83a574$var$wt.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new $849102574a83a574$var$mr))), 0 === r.readers.length && (r.readers.push(new $849102574a83a574$var$Re(e)), r.readers.push(new $849102574a83a574$var$te), r.readers.push(new $849102574a83a574$var$ne), r.readers.push(new $849102574a83a574$var$Re(e)), r.readers.push(new $849102574a83a574$var$Qt), r.readers.push(new $849102574a83a574$var$ae), r.readers.push(new $849102574a83a574$var$Or)), r;
    }
    return $849102574a83a574$var$br(e, t), e.prototype.decodeRow = function(t, e, r) {
        for(var n = 0; n < this.readers.length; n++)try {
            return this.readers[n].decodeRow(t, e, r);
        } catch (t) {}
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        this.readers.forEach(function(t) {
            return t.reset();
        });
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Nr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Rr(r), e, r) || this;
    }
    $849102574a83a574$var$Nr(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Dr, $849102574a83a574$var$Mr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Pr = function() {
    function t(t, e, r) {
        this.ecCodewords = t, this.ecBlocks = [
            e
        ], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
        return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $849102574a83a574$var$Br = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $849102574a83a574$var$Lr = function() {
    function t(t, e, r, n, o, i) {
        var a, s;
        this.versionNumber = t, this.symbolSizeRows = e, this.symbolSizeColumns = r, this.dataRegionSizeRows = n, this.dataRegionSizeColumns = o, this.ecBlocks = i;
        var u = 0, c = i.getECCodewords(), f = i.getECBlocks();
        try {
            for(var h = $849102574a83a574$var$Mr(f), l = h.next(); !l.done; l = h.next()){
                var d = l.value;
                u += d.getCount() * (d.getDataCodewords() + c);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (s = h.return) && s.call(h);
            } finally{
                if (a) throw a.error;
            }
        }
        this.totalCodewords = u;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, r) {
        var n, o;
        if (0 != (1 & e) || 0 != (1 & r)) throw new $849102574a83a574$var$G;
        try {
            for(var i = $849102574a83a574$var$Mr(t.VERSIONS), a = i.next(); !a.done; a = i.next()){
                var s = a.value;
                if (s.symbolSizeRows === e && s.symbolSizeColumns === r) return s;
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $849102574a83a574$var$G;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.buildVersions = function() {
        return [
            new t(1, 10, 10, 8, 8, new $849102574a83a574$var$Pr(5, new $849102574a83a574$var$Br(1, 3))),
            new t(2, 12, 12, 10, 10, new $849102574a83a574$var$Pr(7, new $849102574a83a574$var$Br(1, 5))),
            new t(3, 14, 14, 12, 12, new $849102574a83a574$var$Pr(10, new $849102574a83a574$var$Br(1, 8))),
            new t(4, 16, 16, 14, 14, new $849102574a83a574$var$Pr(12, new $849102574a83a574$var$Br(1, 12))),
            new t(5, 18, 18, 16, 16, new $849102574a83a574$var$Pr(14, new $849102574a83a574$var$Br(1, 18))),
            new t(6, 20, 20, 18, 18, new $849102574a83a574$var$Pr(18, new $849102574a83a574$var$Br(1, 22))),
            new t(7, 22, 22, 20, 20, new $849102574a83a574$var$Pr(20, new $849102574a83a574$var$Br(1, 30))),
            new t(8, 24, 24, 22, 22, new $849102574a83a574$var$Pr(24, new $849102574a83a574$var$Br(1, 36))),
            new t(9, 26, 26, 24, 24, new $849102574a83a574$var$Pr(28, new $849102574a83a574$var$Br(1, 44))),
            new t(10, 32, 32, 14, 14, new $849102574a83a574$var$Pr(36, new $849102574a83a574$var$Br(1, 62))),
            new t(11, 36, 36, 16, 16, new $849102574a83a574$var$Pr(42, new $849102574a83a574$var$Br(1, 86))),
            new t(12, 40, 40, 18, 18, new $849102574a83a574$var$Pr(48, new $849102574a83a574$var$Br(1, 114))),
            new t(13, 44, 44, 20, 20, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(1, 144))),
            new t(14, 48, 48, 22, 22, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(1, 174))),
            new t(15, 52, 52, 24, 24, new $849102574a83a574$var$Pr(42, new $849102574a83a574$var$Br(2, 102))),
            new t(16, 64, 64, 14, 14, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(2, 140))),
            new t(17, 72, 72, 16, 16, new $849102574a83a574$var$Pr(36, new $849102574a83a574$var$Br(4, 92))),
            new t(18, 80, 80, 18, 18, new $849102574a83a574$var$Pr(48, new $849102574a83a574$var$Br(4, 114))),
            new t(19, 88, 88, 20, 20, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(4, 144))),
            new t(20, 96, 96, 22, 22, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(4, 174))),
            new t(21, 104, 104, 24, 24, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(6, 136))),
            new t(22, 120, 120, 18, 18, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(6, 175))),
            new t(23, 132, 132, 20, 20, new $849102574a83a574$var$Pr(62, new $849102574a83a574$var$Br(8, 163))),
            new t(24, 144, 144, 22, 22, new $849102574a83a574$var$Pr(62, new $849102574a83a574$var$Br(8, 156), new $849102574a83a574$var$Br(2, 155))),
            new t(25, 8, 18, 6, 16, new $849102574a83a574$var$Pr(7, new $849102574a83a574$var$Br(1, 5))),
            new t(26, 8, 32, 6, 14, new $849102574a83a574$var$Pr(11, new $849102574a83a574$var$Br(1, 10))),
            new t(27, 12, 26, 10, 24, new $849102574a83a574$var$Pr(14, new $849102574a83a574$var$Br(1, 16))),
            new t(28, 12, 36, 10, 16, new $849102574a83a574$var$Pr(18, new $849102574a83a574$var$Br(1, 22))),
            new t(29, 16, 36, 14, 16, new $849102574a83a574$var$Pr(24, new $849102574a83a574$var$Br(1, 32))),
            new t(30, 16, 48, 14, 22, new $849102574a83a574$var$Pr(28, new $849102574a83a574$var$Br(1, 49)))
        ];
    }, t.VERSIONS = t.buildVersions(), t;
}(), $849102574a83a574$var$Fr = function() {
    function t(e) {
        var r = e.getHeight();
        if (r < 8 || r > 144 || 0 != (1 & r)) throw new $849102574a83a574$var$G;
        this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new $849102574a83a574$var$J(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
        return this.version;
    }, t.readVersion = function(t) {
        var e = t.getHeight(), r = t.getWidth();
        return $849102574a83a574$var$Lr.getVersionForDimensions(e, r);
    }, t.prototype.readCodewords = function() {
        var t = new Int8Array(this.version.getTotalCodewords()), e = 0, r = 4, n = 0, o = this.mappingBitMatrix.getHeight(), i = this.mappingBitMatrix.getWidth(), a = !1, s = !1, u = !1, c = !1;
        do if (r !== o || 0 !== n || a) {
            if (r !== o - 2 || 0 !== n || 0 == (3 & i) || s) {
                if (r !== o + 4 || 2 !== n || 0 != (7 & i) || u) {
                    if (r !== o - 2 || 0 !== n || 4 != (7 & i) || c) {
                        do r < o && n >= 0 && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r -= 2, n += 2;
                        while (r >= 0 && n < i);
                        r += 1, n += 3;
                        do r >= 0 && n < i && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r += 2, n -= 2;
                        while (r < o && n >= 0);
                        r += 3, n += 1;
                    } else t[e++] = 255 & this.readCorner4(o, i), r -= 2, n += 2, c = !0;
                } else t[e++] = 255 & this.readCorner3(o, i), r -= 2, n += 2, u = !0;
            } else t[e++] = 255 & this.readCorner2(o, i), r -= 2, n += 2, s = !0;
        } else t[e++] = 255 & this.readCorner1(o, i), r -= 2, n += 2, a = !0;
        while (r < o || n < i);
        if (e !== this.version.getTotalCodewords()) throw new $849102574a83a574$var$G;
        return t;
    }, t.prototype.readModule = function(t, e, r, n) {
        return t < 0 && (t += r, e += 4 - (r + 4 & 7)), e < 0 && (e += n, t += 4 - (n + 4 & 7)), this.readMappingMatrix.set(e, t), this.mappingBitMatrix.get(e, t);
    }, t.prototype.readUtah = function(t, e, r, n) {
        var o = 0;
        return this.readModule(t - 2, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 2, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t, e, r, n) && (o |= 1), o;
    }, t.prototype.readCorner1 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 1, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 4, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(t) {
        var e = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
        if (t.getHeight() !== e) throw new $849102574a83a574$var$T("Dimension of bitMatrix must match the version size");
        for(var n = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), i = e / n | 0, a = r / o | 0, s = new $849102574a83a574$var$J(a * o, i * n), u = 0; u < i; ++u)for(var c = u * n, f = 0; f < a; ++f)for(var h = f * o, l = 0; l < n; ++l)for(var d = u * (n + 2) + 1 + l, p = c + l, g = 0; g < o; ++g){
            var y = f * (o + 2) + 1 + g;
            if (t.get(y, d)) {
                var w = h + g;
                s.set(w, p);
            }
        }
        return s;
    }, t;
}(), $849102574a83a574$var$kr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$xr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r) {
        var n, o, i, a, s = r.getECBlocks(), u = 0, c = s.getECBlocks();
        try {
            for(var f = $849102574a83a574$var$kr(c), h = f.next(); !h.done; h = f.next())u += (y = h.value).getCount();
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (o = f.return) && o.call(f);
            } finally{
                if (n) throw n.error;
            }
        }
        var l = new Array(u), d = 0;
        try {
            for(var p = $849102574a83a574$var$kr(c), g = p.next(); !g.done; g = p.next())for(var y = g.value, w = 0; w < y.getCount(); w++){
                var v = y.getDataCodewords(), _ = s.getECCodewords() + v;
                l[d++] = new t(v, new Uint8Array(_));
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (a = p.return) && a.call(p);
            } finally{
                if (i) throw i.error;
            }
        }
        var A = l[0].codewords.length - s.getECCodewords(), C = A - 1, m = 0;
        for(w = 0; w < C; w++)for(var E = 0; E < d; E++)l[E].codewords[w] = e[m++];
        var I = 24 === r.getVersionNumber(), S = I ? 8 : d;
        for(E = 0; E < S; E++)l[E].codewords[A - 1] = e[m++];
        var O = l[0].codewords.length;
        for(w = A; w < O; w++)for(E = 0; E < d; E++){
            var b = I ? (E + 8) % d : E, R = I && b > 7 ? w - 1 : w;
            l[b].codewords[R] = e[m++];
        }
        if (m !== e.length) throw new $849102574a83a574$var$T;
        return l;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}(), $849102574a83a574$var$Vr = function() {
    function t(t) {
        this.bytes = t, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
        return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
        return this.byteOffset;
    }, t.prototype.readBits = function(t) {
        if (t < 1 || t > 32 || t > this.available()) throw new $849102574a83a574$var$T("" + t);
        var e = 0, r = this.bitOffset, n = this.byteOffset, o = this.bytes;
        if (r > 0) {
            var i = 8 - r, a = t < i ? t : i, s = 255 >> 8 - a << (u = i - a);
            e = (o[n] & s) >> u, t -= a, 8 === (r += a) && (r = 0, n++);
        }
        if (t > 0) {
            for(; t >= 8;)e = e << 8 | 255 & o[n], n++, t -= 8;
            if (t > 0) {
                var u;
                s = 255 >> (u = 8 - t) << u;
                e = e << t | (o[n] & s) >> u, r += t;
            }
        }
        return this.bitOffset = r, this.byteOffset = n, e;
    }, t.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
}();
!function(t) {
    t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
}($849102574a83a574$var$Dr || ($849102574a83a574$var$Dr = {}));
var $849102574a83a574$var$Hr, $849102574a83a574$var$Ur = function() {
    function t() {}
    return t.decode = function(t) {
        var e = new $849102574a83a574$var$Vr(t), r = new $849102574a83a574$var$Q, n = new $849102574a83a574$var$Q, o = new Array, i = $849102574a83a574$var$Dr.ASCII_ENCODE;
        do if (i === $849102574a83a574$var$Dr.ASCII_ENCODE) i = this.decodeAsciiSegment(e, r, n);
        else {
            switch(i){
                case $849102574a83a574$var$Dr.C40_ENCODE:
                    this.decodeC40Segment(e, r);
                    break;
                case $849102574a83a574$var$Dr.TEXT_ENCODE:
                    this.decodeTextSegment(e, r);
                    break;
                case $849102574a83a574$var$Dr.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(e, r);
                    break;
                case $849102574a83a574$var$Dr.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(e, r);
                    break;
                case $849102574a83a574$var$Dr.BASE256_ENCODE:
                    this.decodeBase256Segment(e, r, o);
                    break;
                default:
                    throw new $849102574a83a574$var$G;
            }
            i = $849102574a83a574$var$Dr.ASCII_ENCODE;
        }
        while (i !== $849102574a83a574$var$Dr.PAD_ENCODE && e.available() > 0);
        return n.length() > 0 && r.append(n.toString()), new $849102574a83a574$var$At(t, r.toString(), 0 === o.length ? null : o, null);
    }, t.decodeAsciiSegment = function(t, e, r) {
        var n = !1;
        do {
            var o = t.readBits(8);
            if (0 === o) throw new $849102574a83a574$var$G;
            if (o <= 128) return n && (o += 128), e.append(String.fromCharCode(o - 1)), $849102574a83a574$var$Dr.ASCII_ENCODE;
            if (129 === o) return $849102574a83a574$var$Dr.PAD_ENCODE;
            if (o <= 229) {
                var i = o - 130;
                i < 10 && e.append("0"), e.append("" + i);
            } else switch(o){
                case 230:
                    return $849102574a83a574$var$Dr.C40_ENCODE;
                case 231:
                    return $849102574a83a574$var$Dr.BASE256_ENCODE;
                case 232:
                    e.append(String.fromCharCode(29));
                    break;
                case 233:
                case 234:
                case 241:
                    break;
                case 235:
                    n = !0;
                    break;
                case 236:
                    e.append("[)>05"), r.insert(0, "");
                    break;
                case 237:
                    e.append("[)>06"), r.insert(0, "");
                    break;
                case 238:
                    return $849102574a83a574$var$Dr.ANSIX12_ENCODE;
                case 239:
                    return $849102574a83a574$var$Dr.TEXT_ENCODE;
                case 240:
                    return $849102574a83a574$var$Dr.EDIFACT_ENCODE;
                default:
                    if (254 !== o || 0 !== t.available()) throw new $849102574a83a574$var$G;
            }
        }while (t.available() > 0);
        return $849102574a83a574$var$Dr.ASCII_ENCODE;
    }, t.decodeC40Segment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var s = n[a];
                switch(o){
                    case 0:
                        if (s < 3) o = s + 1;
                        else {
                            if (!(s < this.C40_BASIC_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                            var u = this.C40_BASIC_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(s + 128)), r = !1) : e.append(String.fromCharCode(s)), o = 0;
                        break;
                    case 2:
                        if (s < this.C40_SHIFT2_SET_CHARS.length) {
                            u = this.C40_SHIFT2_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        } else switch(s){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                        o = 0;
                        break;
                    case 3:
                        r ? (e.append(String.fromCharCode(s + 224)), r = !1) : e.append(String.fromCharCode(s + 96)), o = 0;
                        break;
                    default:
                        throw new $849102574a83a574$var$G;
                }
            }
        }while (t.available() > 0);
    }, t.decodeTextSegment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var s = n[a];
                switch(o){
                    case 0:
                        if (s < 3) o = s + 1;
                        else {
                            if (!(s < this.TEXT_BASIC_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                            var u = this.TEXT_BASIC_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(s + 128)), r = !1) : e.append(String.fromCharCode(s)), o = 0;
                        break;
                    case 2:
                        if (s < this.TEXT_SHIFT2_SET_CHARS.length) {
                            u = this.TEXT_SHIFT2_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        } else switch(s){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                        o = 0;
                        break;
                    case 3:
                        if (!(s < this.TEXT_SHIFT3_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                        u = this.TEXT_SHIFT3_SET_CHARS[s];
                        r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u), o = 0;
                        break;
                    default:
                        throw new $849102574a83a574$var$G;
                }
            }
        }while (t.available() > 0);
    }, t.decodeAnsiX12Segment = function(t, e) {
        var r = [];
        do {
            if (8 === t.available()) return;
            var n = t.readBits(8);
            if (254 === n) return;
            this.parseTwoBytes(n, t.readBits(8), r);
            for(var o = 0; o < 3; o++){
                var i = r[o];
                switch(i){
                    case 0:
                        e.append("\r");
                        break;
                    case 1:
                        e.append("*");
                        break;
                    case 2:
                        e.append(">");
                        break;
                    case 3:
                        e.append(" ");
                        break;
                    default:
                        if (i < 14) e.append(String.fromCharCode(i + 44));
                        else {
                            if (!(i < 40)) throw new $849102574a83a574$var$G;
                            e.append(String.fromCharCode(i + 51));
                        }
                }
            }
        }while (t.available() > 0);
    }, t.parseTwoBytes = function(t, e, r) {
        var n = (t << 8) + e - 1, o = Math.floor(n / 1600);
        r[0] = o, n -= 1600 * o, o = Math.floor(n / 40), r[1] = o, r[2] = n - 40 * o;
    }, t.decodeEdifactSegment = function(t, e) {
        do {
            if (t.available() <= 16) return;
            for(var r = 0; r < 4; r++){
                var n = t.readBits(6);
                if (31 === n) {
                    var o = 8 - t.getBitOffset();
                    return void (8 !== o && t.readBits(o));
                }
                0 == (32 & n) && (n |= 64), e.append(String.fromCharCode(n));
            }
        }while (t.available() > 0);
    }, t.decodeBase256Segment = function(t, e, r) {
        var n, o = 1 + t.getByteOffset(), i = this.unrandomize255State(t.readBits(8), o++);
        if ((n = 0 === i ? t.available() / 8 | 0 : i < 250 ? i : 250 * (i - 249) + this.unrandomize255State(t.readBits(8), o++)) < 0) throw new $849102574a83a574$var$G;
        for(var a = new Uint8Array(n), s = 0; s < n; s++){
            if (t.available() < 8) throw new $849102574a83a574$var$G;
            a[s] = this.unrandomize255State(t.readBits(8), o++);
        }
        r.push(a);
        try {
            e.append($849102574a83a574$var$K.decode(a, $849102574a83a574$var$q.ISO88591));
        } catch (t) {
            throw new $849102574a83a574$var$Nt("Platform does not support required encoding: " + t.message);
        }
    }, t.unrandomize255State = function(t, e) {
        var r = t - (149 * e % 255 + 1);
        return r >= 0 ? r : r + 256;
    }, t.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ], t.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ], t;
}(), $849102574a83a574$var$Xr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Gr = function() {
    function t() {
        this.rsDecoder = new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(t) {
        var e, r, n = new $849102574a83a574$var$Fr(t), o = n.getVersion(), i = n.readCodewords(), a = $849102574a83a574$var$xr.getDataBlocks(i, o), s = 0;
        try {
            for(var u = $849102574a83a574$var$Xr(a), c = u.next(); !c.done; c = u.next())s += c.value.getNumDataCodewords();
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = u.return) && r.call(u);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var f = new Uint8Array(s), h = a.length, l = 0; l < h; l++){
            var d = a[l], p = d.getCodewords(), g = d.getNumDataCodewords();
            this.correctErrors(p, g);
            for(var y = 0; y < g; y++)f[y * h + l] = p[y];
        }
        return $849102574a83a574$var$Ur.decode(f);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $849102574a83a574$var$R;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $849102574a83a574$var$Wr = function() {
    function t(t) {
        this.image = t, this.rectangleDetector = new $849102574a83a574$var$Vt(this.image);
    }
    return t.prototype.detect = function() {
        var e = this.rectangleDetector.detect(), r = this.detectSolid1(e);
        if ((r = this.detectSolid2(r))[3] = this.correctTopRight(r), !r[3]) throw new $849102574a83a574$var$tt;
        var n = (r = this.shiftToModuleCenter(r))[0], o = r[1], i = r[2], a = r[3], s = this.transitionsBetween(n, a) + 1, u = this.transitionsBetween(i, a) + 1;
        1 == (1 & s) && (s += 1), 1 == (1 & u) && (u += 1), 4 * s < 7 * u && 4 * u < 7 * s && (s = u = Math.max(s, u));
        var c = t.sampleGrid(this.image, n, o, i, a, s, u);
        return new $849102574a83a574$var$Ft(c, [
            n,
            o,
            i,
            a
        ]);
    }, t.shiftPoint = function(t, e, r) {
        var n = (e.getX() - t.getX()) / (r + 1), o = (e.getY() - t.getY()) / (r + 1);
        return new $849102574a83a574$var$Lt(t.getX() + n, t.getY() + o);
    }, t.moveAway = function(t, e, r) {
        var n = t.getX(), o = t.getY();
        return n < e ? n -= 1 : n += 1, o < r ? o -= 1 : o += 1, new $849102574a83a574$var$Lt(n, o);
    }, t.prototype.detectSolid1 = function(t) {
        var e = t[0], r = t[1], n = t[3], o = t[2], i = this.transitionsBetween(e, r), a = this.transitionsBetween(r, n), s = this.transitionsBetween(n, o), u = this.transitionsBetween(o, e), c = i, f = [
            o,
            e,
            r,
            n
        ];
        return c > a && (c = a, f[0] = e, f[1] = r, f[2] = n, f[3] = o), c > s && (c = s, f[0] = r, f[1] = n, f[2] = o, f[3] = e), c > u && (f[0] = n, f[1] = o, f[2] = e, f[3] = r), f;
    }, t.prototype.detectSolid2 = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), s = t.shiftPoint(n, o, 4 * (a + 1)), u = t.shiftPoint(o, n, 4 * (a + 1));
        return this.transitionsBetween(s, r) < this.transitionsBetween(u, i) ? (e[0] = r, e[1] = n, e[2] = o, e[3] = i) : (e[0] = n, e[1] = o, e[2] = i, e[3] = r), e;
    }, t.prototype.correctTopRight = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), s = this.transitionsBetween(n, i), u = t.shiftPoint(r, n, 4 * (s + 1)), c = t.shiftPoint(o, n, 4 * (a + 1));
        a = this.transitionsBetween(u, i), s = this.transitionsBetween(c, i);
        var f = new $849102574a83a574$var$Lt(i.getX() + (o.getX() - n.getX()) / (a + 1), i.getY() + (o.getY() - n.getY()) / (a + 1)), h = new $849102574a83a574$var$Lt(i.getX() + (r.getX() - n.getX()) / (s + 1), i.getY() + (r.getY() - n.getY()) / (s + 1));
        return this.isValid(f) ? this.isValid(h) ? this.transitionsBetween(u, f) + this.transitionsBetween(c, f) > this.transitionsBetween(u, h) + this.transitionsBetween(c, h) ? f : h : f : this.isValid(h) ? h : null;
    }, t.prototype.shiftToModuleCenter = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i) + 1, s = this.transitionsBetween(o, i) + 1, u = t.shiftPoint(r, n, 4 * s), c = t.shiftPoint(o, n, 4 * a);
        1 == (1 & (a = this.transitionsBetween(u, i) + 1)) && (a += 1), 1 == (1 & (s = this.transitionsBetween(c, i) + 1)) && (s += 1);
        var f, h, l = (r.getX() + n.getX() + o.getX() + i.getX()) / 4, d = (r.getY() + n.getY() + o.getY() + i.getY()) / 4;
        return r = t.moveAway(r, l, d), n = t.moveAway(n, l, d), o = t.moveAway(o, l, d), i = t.moveAway(i, l, d), u = t.shiftPoint(r, n, 4 * s), u = t.shiftPoint(u, i, 4 * a), f = t.shiftPoint(n, r, 4 * s), f = t.shiftPoint(f, o, 4 * a), c = t.shiftPoint(o, i, 4 * s), c = t.shiftPoint(c, n, 4 * a), h = t.shiftPoint(i, o, 4 * s), [
            u,
            f,
            c,
            h = t.shiftPoint(h, r, 4 * a)
        ];
    }, t.prototype.isValid = function(t) {
        return t.getX() >= 0 && t.getX() < this.image.getWidth() && t.getY() > 0 && t.getY() < this.image.getHeight();
    }, t.sampleGrid = function(t, e, r, n, o, i, a) {
        return $849102574a83a574$var$Wt.getInstance().sampleGrid(t, i, a, .5, .5, i - .5, .5, i - .5, a - .5, .5, a - .5, e.getX(), e.getY(), o.getX(), o.getY(), n.getX(), n.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(t, e) {
        var r = Math.trunc(t.getX()), n = Math.trunc(t.getY()), o = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.abs(i - n) > Math.abs(o - r);
        if (a) {
            var s = r;
            r = n, n = s, s = o, o = i, i = s;
        }
        for(var u = Math.abs(o - r), c = Math.abs(i - n), f = -u / 2, h = n < i ? 1 : -1, l = r < o ? 1 : -1, d = 0, p = this.image.get(a ? n : r, a ? r : n), g = r, y = n; g !== o; g += l){
            var w = this.image.get(a ? y : g, a ? g : y);
            if (w !== p && (d++, p = w), (f += c) > 0) {
                if (y === i) break;
                y += h, f -= u;
            }
        }
        return d;
    }, t;
}(), $849102574a83a574$var$zr = function() {
    function t() {
        this.decoder = new $849102574a83a574$var$Gr;
    }
    return t.prototype.decode = function(e, r) {
        var n, o;
        if (void 0 === r && (r = null), null != r && r.has($849102574a83a574$var$U.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decode(i), o = t.NO_POINTS;
        } else {
            var a = new $849102574a83a574$var$Wr(e.getBlackMatrix()).detect();
            n = this.decoder.decode(a.getBits()), o = a.getPoints();
        }
        var s = n.getRawBytes(), u = new $849102574a83a574$var$gt(n.getText(), s, 8 * s.length, o, $849102574a83a574$var$wt.DATA_MATRIX, $849102574a83a574$var$D.currentTimeMillis()), c = n.getByteSegments();
        null != c && u.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, c);
        var f = n.getECLevel();
        return null != f && u.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, f), u;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null == e || null == r) throw new $849102574a83a574$var$tt;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], s = (r[0] - a + 1) / n, u = (i - o + 1) / n;
        if (s <= 0 || u <= 0) throw new $849102574a83a574$var$tt;
        var c = n / 2;
        o += c, a += c;
        for(var f = new $849102574a83a574$var$J(s, u), h = 0; h < u; h++)for(var l = o + h * n, d = 0; d < s; d++)t.get(a + d * n, l) && f.set(d, h);
        return f;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getWidth(), n = t[0], o = t[1]; n < r && e.get(n, o);)n++;
        if (n === r) throw new $849102574a83a574$var$tt;
        var i = n - t[0];
        if (0 === i) throw new $849102574a83a574$var$tt;
        return i;
    }, t.NO_POINTS = [], t;
}(), $849102574a83a574$var$jr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$zr, e) || this;
    }
    $849102574a83a574$var$jr(e, t);
}($849102574a83a574$var$pt), function(t) {
    t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
}($849102574a83a574$var$Hr || ($849102574a83a574$var$Hr = {}));
var $849102574a83a574$var$Yr, $849102574a83a574$var$Zr = function() {
    function t(e, r, n) {
        this.value = e, this.stringValue = r, this.bits = n, t.FOR_BITS.set(n, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.fromString = function(e) {
        switch(e){
            case "L":
                return t.L;
            case "M":
                return t.M;
            case "Q":
                return t.Q;
            case "H":
                return t.H;
            default:
                throw new $849102574a83a574$var$I(e + "not available");
        }
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.forBits = function(e) {
        if (e < 0 || e >= t.FOR_BITS.size) throw new $849102574a83a574$var$T;
        return t.FOR_BITS.get(e);
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.L = new t($849102574a83a574$var$Hr.L, "L", 1), t.M = new t($849102574a83a574$var$Hr.M, "M", 0), t.Q = new t($849102574a83a574$var$Hr.Q, "Q", 3), t.H = new t($849102574a83a574$var$Hr.H, "H", 2), t;
}(), $849102574a83a574$var$Kr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$qr = function() {
    function t(t) {
        this.errorCorrectionLevel = $849102574a83a574$var$Zr.forBits(t >> 3 & 3), this.dataMask = 7 & t;
    }
    return t.numBitsDiffering = function(t, e) {
        return $849102574a83a574$var$x.bitCount(t ^ e);
    }, t.decodeFormatInformation = function(e, r) {
        var n = t.doDecodeFormatInformation(e, r);
        return null !== n ? n : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, r ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, r) {
        var n, o, i = Number.MAX_SAFE_INTEGER, a = 0;
        try {
            for(var s = $849102574a83a574$var$Kr(t.FORMAT_INFO_DECODE_LOOKUP), u = s.next(); !u.done; u = s.next()){
                var c = u.value, f = c[0];
                if (f === e || f === r) return new t(c[1]);
                var h = t.numBitsDiffering(e, f);
                h < i && (a = c[1], i = h), e !== r && (h = t.numBitsDiffering(r, f)) < i && (a = c[1], i = h);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (o = s.return) && o.call(s);
            } finally{
                if (n) throw n.error;
            }
        }
        return i <= 3 ? new t(a) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
        return this.dataMask;
    }, t.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.errorCorrectionLevel === r.errorCorrectionLevel && this.dataMask === r.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            21522,
            0
        ]),
        Int32Array.from([
            20773,
            1
        ]),
        Int32Array.from([
            24188,
            2
        ]),
        Int32Array.from([
            23371,
            3
        ]),
        Int32Array.from([
            17913,
            4
        ]),
        Int32Array.from([
            16590,
            5
        ]),
        Int32Array.from([
            20375,
            6
        ]),
        Int32Array.from([
            19104,
            7
        ]),
        Int32Array.from([
            30660,
            8
        ]),
        Int32Array.from([
            29427,
            9
        ]),
        Int32Array.from([
            32170,
            10
        ]),
        Int32Array.from([
            30877,
            11
        ]),
        Int32Array.from([
            26159,
            12
        ]),
        Int32Array.from([
            25368,
            13
        ]),
        Int32Array.from([
            27713,
            14
        ]),
        Int32Array.from([
            26998,
            15
        ]),
        Int32Array.from([
            5769,
            16
        ]),
        Int32Array.from([
            5054,
            17
        ]),
        Int32Array.from([
            7399,
            18
        ]),
        Int32Array.from([
            6608,
            19
        ]),
        Int32Array.from([
            1890,
            20
        ]),
        Int32Array.from([
            597,
            21
        ]),
        Int32Array.from([
            3340,
            22
        ]),
        Int32Array.from([
            2107,
            23
        ]),
        Int32Array.from([
            13663,
            24
        ]),
        Int32Array.from([
            12392,
            25
        ]),
        Int32Array.from([
            16177,
            26
        ]),
        Int32Array.from([
            14854,
            27
        ]),
        Int32Array.from([
            9396,
            28
        ]),
        Int32Array.from([
            8579,
            29
        ]),
        Int32Array.from([
            11994,
            30
        ]),
        Int32Array.from([
            11245,
            31
        ])
    ], t;
}(), $849102574a83a574$var$Qr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Jr = function() {
    function t(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        this.ecCodewordsPerBlock = t, this.ecBlocks = e;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
        var t, e, r = 0, n = this.ecBlocks;
        try {
            for(var o = $849102574a83a574$var$Qr(n), i = o.next(); !i.done; i = o.next())r += i.value.getCount();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }, t.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $849102574a83a574$var$$r = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $849102574a83a574$var$tn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$en = function() {
    function t(t, e) {
        for(var r, n, o = [], i = 2; i < arguments.length; i++)o[i - 2] = arguments[i];
        this.versionNumber = t, this.alignmentPatternCenters = e, this.ecBlocks = o;
        var a = 0, s = o[0].getECCodewordsPerBlock(), u = o[0].getECBlocks();
        try {
            for(var c = $849102574a83a574$var$tn(u), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                a += h.getCount() * (h.getDataCodewords() + s);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (n = c.return) && n.call(c);
            } finally{
                if (r) throw r.error;
            }
        }
        this.totalCodewords = a;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(t) {
        return this.ecBlocks[t.getValue()];
    }, t.getProvisionalVersionForDimension = function(t) {
        if (t % 4 != 1) throw new $849102574a83a574$var$G;
        try {
            return this.getVersionForNumber((t - 17) / 4);
        } catch (t) {
            throw new $849102574a83a574$var$G;
        }
    }, t.getVersionForNumber = function(e) {
        if (e < 1 || e > 40) throw new $849102574a83a574$var$T;
        return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
        for(var r = Number.MAX_SAFE_INTEGER, n = 0, o = 0; o < t.VERSION_DECODE_INFO.length; o++){
            var i = t.VERSION_DECODE_INFO[o];
            if (i === e) return t.getVersionForNumber(o + 7);
            var a = $849102574a83a574$var$qr.numBitsDiffering(e, i);
            a < r && (n = o + 7, r = a);
        }
        return r <= 3 ? t.getVersionForNumber(n) : null;
    }, t.prototype.buildFunctionPattern = function() {
        var t = this.getDimensionForVersion(), e = new $849102574a83a574$var$J(t);
        e.setRegion(0, 0, 9, 9), e.setRegion(t - 8, 0, 8, 9), e.setRegion(0, t - 8, 9, 8);
        for(var r = this.alignmentPatternCenters.length, n = 0; n < r; n++)for(var o = this.alignmentPatternCenters[n] - 2, i = 0; i < r; i++)0 === n && (0 === i || i === r - 1) || n === r - 1 && 0 === i || e.setRegion(this.alignmentPatternCenters[i] - 2, o, 5, 5);
        return e.setRegion(6, 9, 1, t - 17), e.setRegion(9, 6, t - 17, 1), this.versionNumber > 6 && (e.setRegion(t - 11, 0, 3, 6), e.setRegion(0, t - 11, 6, 3)), e;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
        31892,
        34236,
        39577,
        42195,
        48118,
        51042,
        55367,
        58893,
        63784,
        68472,
        70749,
        76311,
        79154,
        84390,
        87683,
        92361,
        96236,
        102084,
        102881,
        110507,
        110734,
        117786,
        119615,
        126325,
        127568,
        133589,
        136944,
        141498,
        145311,
        150283,
        152622,
        158308,
        161089,
        167017
    ]), t.VERSIONS = [
        new t(1, new Int32Array(0), new $849102574a83a574$var$Jr(7, new $849102574a83a574$var$$r(1, 19)), new $849102574a83a574$var$Jr(10, new $849102574a83a574$var$$r(1, 16)), new $849102574a83a574$var$Jr(13, new $849102574a83a574$var$$r(1, 13)), new $849102574a83a574$var$Jr(17, new $849102574a83a574$var$$r(1, 9))),
        new t(2, Int32Array.from([
            6,
            18
        ]), new $849102574a83a574$var$Jr(10, new $849102574a83a574$var$$r(1, 34)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(1, 28)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(1, 22)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 16))),
        new t(3, Int32Array.from([
            6,
            22
        ]), new $849102574a83a574$var$Jr(15, new $849102574a83a574$var$$r(1, 55)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(1, 44)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 17)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 13))),
        new t(4, Int32Array.from([
            6,
            26
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(1, 80)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 32)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(2, 24)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(4, 9))),
        new t(5, Int32Array.from([
            6,
            30
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(1, 108)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 43)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 15), new $849102574a83a574$var$$r(2, 16)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 11), new $849102574a83a574$var$$r(2, 12))),
        new t(6, Int32Array.from([
            6,
            34
        ]), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 68)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(4, 27)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 19)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 15))),
        new t(7, Int32Array.from([
            6,
            22,
            38
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(2, 78)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(4, 31)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(4, 15)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 13), new $849102574a83a574$var$$r(1, 14))),
        new t(8, Int32Array.from([
            6,
            24,
            42
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 97)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 38), new $849102574a83a574$var$$r(2, 39)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(4, 18), new $849102574a83a574$var$$r(2, 19)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 14), new $849102574a83a574$var$$r(2, 15))),
        new t(9, Int32Array.from([
            6,
            26,
            46
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(2, 116)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(3, 36), new $849102574a83a574$var$$r(2, 37)), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(4, 16), new $849102574a83a574$var$$r(4, 17)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 12), new $849102574a83a574$var$$r(4, 13))),
        new t(10, Int32Array.from([
            6,
            28,
            50
        ]), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 68), new $849102574a83a574$var$$r(2, 69)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 43), new $849102574a83a574$var$$r(1, 44)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(6, 19), new $849102574a83a574$var$$r(2, 20)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 15), new $849102574a83a574$var$$r(2, 16))),
        new t(11, Int32Array.from([
            6,
            30,
            54
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(4, 81)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(1, 50), new $849102574a83a574$var$$r(4, 51)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 22), new $849102574a83a574$var$$r(4, 23)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(3, 12), new $849102574a83a574$var$$r(8, 13))),
        new t(12, Int32Array.from([
            6,
            32,
            58
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 92), new $849102574a83a574$var$$r(2, 93)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(6, 36), new $849102574a83a574$var$$r(2, 37)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 20), new $849102574a83a574$var$$r(6, 21)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(7, 14), new $849102574a83a574$var$$r(4, 15))),
        new t(13, Int32Array.from([
            6,
            34,
            62
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 107)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(8, 37), new $849102574a83a574$var$$r(1, 38)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(8, 20), new $849102574a83a574$var$$r(4, 21)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(12, 11), new $849102574a83a574$var$$r(4, 12))),
        new t(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 115), new $849102574a83a574$var$$r(1, 116)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 40), new $849102574a83a574$var$$r(5, 41)), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(11, 16), new $849102574a83a574$var$$r(5, 17)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(11, 12), new $849102574a83a574$var$$r(5, 13))),
        new t(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(5, 87), new $849102574a83a574$var$$r(1, 88)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(5, 41), new $849102574a83a574$var$$r(5, 42)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 24), new $849102574a83a574$var$$r(7, 25)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(11, 12), new $849102574a83a574$var$$r(7, 13))),
        new t(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(5, 98), new $849102574a83a574$var$$r(1, 99)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(7, 45), new $849102574a83a574$var$$r(3, 46)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(15, 19), new $849102574a83a574$var$$r(2, 20)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 15), new $849102574a83a574$var$$r(13, 16))),
        new t(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 107), new $849102574a83a574$var$$r(5, 108)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 46), new $849102574a83a574$var$$r(1, 47)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 22), new $849102574a83a574$var$$r(15, 23)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(17, 15))),
        new t(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 120), new $849102574a83a574$var$$r(1, 121)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(9, 43), new $849102574a83a574$var$$r(4, 44)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 22), new $849102574a83a574$var$$r(1, 23)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(19, 15))),
        new t(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 113), new $849102574a83a574$var$$r(4, 114)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(3, 44), new $849102574a83a574$var$$r(11, 45)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(17, 21), new $849102574a83a574$var$$r(4, 22)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(9, 13), new $849102574a83a574$var$$r(16, 14))),
        new t(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 107), new $849102574a83a574$var$$r(5, 108)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(3, 41), new $849102574a83a574$var$$r(13, 42)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(15, 24), new $849102574a83a574$var$$r(5, 25)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(15, 15), new $849102574a83a574$var$$r(10, 16))),
        new t(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 116), new $849102574a83a574$var$$r(4, 117)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(17, 42)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 22), new $849102574a83a574$var$$r(6, 23)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 16), new $849102574a83a574$var$$r(6, 17))),
        new t(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 111), new $849102574a83a574$var$$r(7, 112)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 24), new $849102574a83a574$var$$r(16, 25)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(34, 13))),
        new t(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 121), new $849102574a83a574$var$$r(5, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 47), new $849102574a83a574$var$$r(14, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(16, 15), new $849102574a83a574$var$$r(14, 16))),
        new t(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(6, 117), new $849102574a83a574$var$$r(4, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 45), new $849102574a83a574$var$$r(14, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 24), new $849102574a83a574$var$$r(16, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(30, 16), new $849102574a83a574$var$$r(2, 17))),
        new t(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(8, 106), new $849102574a83a574$var$$r(4, 107)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(8, 47), new $849102574a83a574$var$$r(13, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 24), new $849102574a83a574$var$$r(22, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(22, 15), new $849102574a83a574$var$$r(13, 16))),
        new t(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 114), new $849102574a83a574$var$$r(2, 115)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(19, 46), new $849102574a83a574$var$$r(4, 47)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(28, 22), new $849102574a83a574$var$$r(6, 23)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(33, 16), new $849102574a83a574$var$$r(4, 17))),
        new t(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(8, 122), new $849102574a83a574$var$$r(4, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(22, 45), new $849102574a83a574$var$$r(3, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(8, 23), new $849102574a83a574$var$$r(26, 24)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(12, 15), new $849102574a83a574$var$$r(28, 16))),
        new t(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 117), new $849102574a83a574$var$$r(10, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 45), new $849102574a83a574$var$$r(23, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 24), new $849102574a83a574$var$$r(31, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 15), new $849102574a83a574$var$$r(31, 16))),
        new t(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 116), new $849102574a83a574$var$$r(7, 117)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(21, 45), new $849102574a83a574$var$$r(7, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(1, 23), new $849102574a83a574$var$$r(37, 24)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 15), new $849102574a83a574$var$$r(26, 16))),
        new t(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 115), new $849102574a83a574$var$$r(10, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(19, 47), new $849102574a83a574$var$$r(10, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(15, 24), new $849102574a83a574$var$$r(25, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(23, 15), new $849102574a83a574$var$$r(25, 16))),
        new t(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(13, 115), new $849102574a83a574$var$$r(3, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 46), new $849102574a83a574$var$$r(29, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(42, 24), new $849102574a83a574$var$$r(1, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(23, 15), new $849102574a83a574$var$$r(28, 16))),
        new t(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 115)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 46), new $849102574a83a574$var$$r(23, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(10, 24), new $849102574a83a574$var$$r(35, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 15), new $849102574a83a574$var$$r(35, 16))),
        new t(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 115), new $849102574a83a574$var$$r(1, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(14, 46), new $849102574a83a574$var$$r(21, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(29, 24), new $849102574a83a574$var$$r(19, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 15), new $849102574a83a574$var$$r(46, 16))),
        new t(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(13, 115), new $849102574a83a574$var$$r(6, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(14, 46), new $849102574a83a574$var$$r(23, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(44, 24), new $849102574a83a574$var$$r(7, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(59, 16), new $849102574a83a574$var$$r(1, 17))),
        new t(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(12, 121), new $849102574a83a574$var$$r(7, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(12, 47), new $849102574a83a574$var$$r(26, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(39, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(22, 15), new $849102574a83a574$var$$r(41, 16))),
        new t(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(6, 121), new $849102574a83a574$var$$r(14, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 47), new $849102574a83a574$var$$r(34, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(46, 24), new $849102574a83a574$var$$r(10, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(2, 15), new $849102574a83a574$var$$r(64, 16))),
        new t(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 122), new $849102574a83a574$var$$r(4, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(29, 46), new $849102574a83a574$var$$r(14, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(49, 24), new $849102574a83a574$var$$r(10, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(24, 15), new $849102574a83a574$var$$r(46, 16))),
        new t(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 122), new $849102574a83a574$var$$r(18, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(13, 46), new $849102574a83a574$var$$r(32, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(48, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(42, 15), new $849102574a83a574$var$$r(32, 16))),
        new t(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(20, 117), new $849102574a83a574$var$$r(4, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(40, 47), new $849102574a83a574$var$$r(7, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(43, 24), new $849102574a83a574$var$$r(22, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(10, 15), new $849102574a83a574$var$$r(67, 16))),
        new t(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 118), new $849102574a83a574$var$$r(6, 119)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(18, 47), new $849102574a83a574$var$$r(31, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(34, 24), new $849102574a83a574$var$$r(34, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(20, 15), new $849102574a83a574$var$$r(61, 16)))
    ], t;
}();
!function(t) {
    t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
}($849102574a83a574$var$Yr || ($849102574a83a574$var$Yr = {}));
var $849102574a83a574$var$rn, $849102574a83a574$var$nn = function() {
    function t(t, e) {
        this.value = t, this.isMasked = e;
    }
    return t.prototype.unmaskBitMatrix = function(t, e) {
        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)this.isMasked(r, n) && t.flip(n, r);
    }, t.values = new Map([
        [
            $849102574a83a574$var$Yr.DATA_MASK_000,
            new t($849102574a83a574$var$Yr.DATA_MASK_000, function(t, e) {
                return 0 == (t + e & 1);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_001,
            new t($849102574a83a574$var$Yr.DATA_MASK_001, function(t, e) {
                return 0 == (1 & t);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_010,
            new t($849102574a83a574$var$Yr.DATA_MASK_010, function(t, e) {
                return e % 3 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_011,
            new t($849102574a83a574$var$Yr.DATA_MASK_011, function(t, e) {
                return (t + e) % 3 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_100,
            new t($849102574a83a574$var$Yr.DATA_MASK_100, function(t, e) {
                return 0 == (Math.floor(t / 2) + Math.floor(e / 3) & 1);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_101,
            new t($849102574a83a574$var$Yr.DATA_MASK_101, function(t, e) {
                return t * e % 6 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_110,
            new t($849102574a83a574$var$Yr.DATA_MASK_110, function(t, e) {
                return t * e % 6 < 3;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_111,
            new t($849102574a83a574$var$Yr.DATA_MASK_111, function(t, e) {
                return 0 == (t + e + t * e % 3 & 1);
            })
        ]
    ]), t;
}(), $849102574a83a574$var$on = function() {
    function t(t) {
        var e = t.getHeight();
        if (e < 21 || 1 != (3 & e)) throw new $849102574a83a574$var$G;
        this.bitMatrix = t;
    }
    return t.prototype.readFormatInformation = function() {
        if (null !== this.parsedFormatInfo && void 0 !== this.parsedFormatInfo) return this.parsedFormatInfo;
        for(var t = 0, e = 0; e < 6; e++)t = this.copyBit(e, 8, t);
        t = this.copyBit(7, 8, t), t = this.copyBit(8, 8, t), t = this.copyBit(8, 7, t);
        for(var r = 5; r >= 0; r--)t = this.copyBit(8, r, t);
        var n = this.bitMatrix.getHeight(), o = 0, i = n - 7;
        for(r = n - 1; r >= i; r--)o = this.copyBit(8, r, o);
        for(e = n - 8; e < n; e++)o = this.copyBit(e, 8, o);
        if (this.parsedFormatInfo = $849102574a83a574$var$qr.decodeFormatInformation(t, o), null !== this.parsedFormatInfo) return this.parsedFormatInfo;
        throw new $849102574a83a574$var$G;
    }, t.prototype.readVersion = function() {
        if (null !== this.parsedVersion && void 0 !== this.parsedVersion) return this.parsedVersion;
        var t = this.bitMatrix.getHeight(), e = Math.floor((t - 17) / 4);
        if (e <= 6) return $849102574a83a574$var$en.getVersionForNumber(e);
        for(var r = 0, n = t - 11, o = 5; o >= 0; o--)for(var i = t - 9; i >= n; i--)r = this.copyBit(i, o, r);
        var a = $849102574a83a574$var$en.decodeVersionInformation(r);
        if (null !== a && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        r = 0;
        for(i = 5; i >= 0; i--)for(o = t - 9; o >= n; o--)r = this.copyBit(i, o, r);
        if (null !== (a = $849102574a83a574$var$en.decodeVersionInformation(r)) && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        throw new $849102574a83a574$var$G;
    }, t.prototype.copyBit = function(t, e, r) {
        return (this.isMirror ? this.bitMatrix.get(e, t) : this.bitMatrix.get(t, e)) ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
        var t = this.readFormatInformation(), e = this.readVersion(), r = $849102574a83a574$var$nn.values.get(t.getDataMask()), n = this.bitMatrix.getHeight();
        r.unmaskBitMatrix(this.bitMatrix, n);
        for(var o = e.buildFunctionPattern(), i = !0, a = new Uint8Array(e.getTotalCodewords()), s = 0, u = 0, c = 0, f = n - 1; f > 0; f -= 2){
            6 === f && f--;
            for(var h = 0; h < n; h++)for(var l = i ? n - 1 - h : h, d = 0; d < 2; d++)o.get(f - d, l) || (c++, u <<= 1, this.bitMatrix.get(f - d, l) && (u |= 1), 8 === c && (a[s++] = u, c = 0, u = 0));
            i = !i;
        }
        if (s !== e.getTotalCodewords()) throw new $849102574a83a574$var$G;
        return a;
    }, t.prototype.remask = function() {
        if (null !== this.parsedFormatInfo) {
            var t = $849102574a83a574$var$nn.values[this.parsedFormatInfo.getDataMask()], e = this.bitMatrix.getHeight();
            t.unmaskBitMatrix(this.bitMatrix, e);
        }
    }, t.prototype.setMirror = function(t) {
        this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = t;
    }, t.prototype.mirror = function() {
        for(var t = this.bitMatrix, e = 0, r = t.getWidth(); e < r; e++)for(var n = e + 1, o = t.getHeight(); n < o; n++)t.get(e, n) !== t.get(n, e) && (t.flip(n, e), t.flip(e, n));
    }, t;
}(), $849102574a83a574$var$an = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$sn = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r, n) {
        var o, i, a, s;
        if (e.length !== r.getTotalCodewords()) throw new $849102574a83a574$var$T;
        var u = r.getECBlocksForLevel(n), c = 0, f = u.getECBlocks();
        try {
            for(var h = $849102574a83a574$var$an(f), l = h.next(); !l.done; l = h.next())c += (w = l.value).getCount();
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (i = h.return) && i.call(h);
            } finally{
                if (o) throw o.error;
            }
        }
        var d = new Array(c), p = 0;
        try {
            for(var g = $849102574a83a574$var$an(f), y = g.next(); !y.done; y = g.next())for(var w = y.value, v = 0; v < w.getCount(); v++){
                var _ = w.getDataCodewords(), A = u.getECCodewordsPerBlock() + _;
                d[p++] = new t(_, new Uint8Array(A));
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (s = g.return) && s.call(g);
            } finally{
                if (a) throw a.error;
            }
        }
        for(var C = d[0].codewords.length, m = d.length - 1; m >= 0;){
            if (d[m].codewords.length === C) break;
            m--;
        }
        m++;
        var E = C - u.getECCodewordsPerBlock(), I = 0;
        for(v = 0; v < E; v++)for(var S = 0; S < p; S++)d[S].codewords[v] = e[I++];
        for(S = m; S < p; S++)d[S].codewords[E] = e[I++];
        var O = d[0].codewords.length;
        for(v = E; v < O; v++)for(S = 0; S < p; S++){
            var b = S < m ? v : v + 1;
            d[S].codewords[b] = e[I++];
        }
        return d;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}();
!function(t) {
    t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
}($849102574a83a574$var$rn || ($849102574a83a574$var$rn = {}));
var $849102574a83a574$var$un, $849102574a83a574$var$cn, $849102574a83a574$var$fn = function() {
    function t(e, r, n, o) {
        this.value = e, this.stringValue = r, this.characterCountBitsForVersions = n, this.bits = o, t.FOR_BITS.set(o, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
        var r = t.FOR_BITS.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$T;
        return r;
    }, t.prototype.getCharacterCountBits = function(t) {
        var e, r = t.getVersionNumber();
        return e = r <= 9 ? 0 : r <= 26 ? 1 : 2, this.characterCountBitsForVersions[e];
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.TERMINATOR = new t($849102574a83a574$var$rn.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0), t.NUMERIC = new t($849102574a83a574$var$rn.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 1), t.ALPHANUMERIC = new t($849102574a83a574$var$rn.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 2), t.STRUCTURED_APPEND = new t($849102574a83a574$var$rn.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 3), t.BYTE = new t($849102574a83a574$var$rn.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 4), t.ECI = new t($849102574a83a574$var$rn.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 7), t.KANJI = new t($849102574a83a574$var$rn.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 8), t.FNC1_FIRST_POSITION = new t($849102574a83a574$var$rn.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 5), t.FNC1_SECOND_POSITION = new t($849102574a83a574$var$rn.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 9), t.HANZI = new t($849102574a83a574$var$rn.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 13), t;
}(), $849102574a83a574$var$hn = function() {
    function t() {}
    return t.decode = function(e, r, n, o) {
        var i = new $849102574a83a574$var$Vr(e), a = new $849102574a83a574$var$Q, s = new Array, u = -1, c = -1;
        try {
            var f = null, h = !1, l = void 0;
            do {
                if (i.available() < 4) l = $849102574a83a574$var$fn.TERMINATOR;
                else {
                    var d = i.readBits(4);
                    l = $849102574a83a574$var$fn.forBits(d);
                }
                switch(l){
                    case $849102574a83a574$var$fn.TERMINATOR:
                        break;
                    case $849102574a83a574$var$fn.FNC1_FIRST_POSITION:
                    case $849102574a83a574$var$fn.FNC1_SECOND_POSITION:
                        h = !0;
                        break;
                    case $849102574a83a574$var$fn.STRUCTURED_APPEND:
                        if (i.available() < 16) throw new $849102574a83a574$var$G;
                        u = i.readBits(8), c = i.readBits(8);
                        break;
                    case $849102574a83a574$var$fn.ECI:
                        var p = t.parseECIValue(i);
                        if (null === (f = $849102574a83a574$var$j.getCharacterSetECIByValue(p))) throw new $849102574a83a574$var$G;
                        break;
                    case $849102574a83a574$var$fn.HANZI:
                        var g = i.readBits(4), y = i.readBits(l.getCharacterCountBits(r));
                        g === t.GB2312_SUBSET && t.decodeHanziSegment(i, a, y);
                        break;
                    default:
                        var w = i.readBits(l.getCharacterCountBits(r));
                        switch(l){
                            case $849102574a83a574$var$fn.NUMERIC:
                                t.decodeNumericSegment(i, a, w);
                                break;
                            case $849102574a83a574$var$fn.ALPHANUMERIC:
                                t.decodeAlphanumericSegment(i, a, w, h);
                                break;
                            case $849102574a83a574$var$fn.BYTE:
                                t.decodeByteSegment(i, a, w, f, s, o);
                                break;
                            case $849102574a83a574$var$fn.KANJI:
                                t.decodeKanjiSegment(i, a, w);
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                }
            }while (l !== $849102574a83a574$var$fn.TERMINATOR);
        } catch (t) {
            throw new $849102574a83a574$var$G;
        }
        return new $849102574a83a574$var$At(e, a.toString(), 0 === s.length ? null : s, null === n ? null : n.toString(), u, c);
    }, t.decodeHanziSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 96 << 8 & 4294967295 | i % 96;
            a += a < 959 ? 41377 : 42657, n[o] = a >> 8 & 255, n[o + 1] = 255 & a, o += 2, r--;
        }
        try {
            e.append($849102574a83a574$var$K.decode(n, $849102574a83a574$var$q.GB2312));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
    }, t.decodeKanjiSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 192 << 8 & 4294967295 | i % 192;
            a += a < 7936 ? 33088 : 49472, n[o] = a >> 8, n[o + 1] = a, o += 2, r--;
        }
        try {
            e.append($849102574a83a574$var$K.decode(n, $849102574a83a574$var$q.SHIFT_JIS));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
    }, t.decodeByteSegment = function(t, e, r, n, o, i) {
        if (8 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var a, s = new Uint8Array(r), u = 0; u < r; u++)s[u] = t.readBits(8);
        a = null === n ? $849102574a83a574$var$q.guessEncoding(s, i) : n.getName();
        try {
            e.append($849102574a83a574$var$K.decode(s, a));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
        o.push(s);
    }, t.toAlphaNumericChar = function(e) {
        if (e >= t.ALPHANUMERIC_CHARS.length) throw new $849102574a83a574$var$G;
        return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, r, n, o) {
        for(var i = r.length(); n > 1;){
            if (e.available() < 11) throw new $849102574a83a574$var$G;
            var a = e.readBits(11);
            r.append(t.toAlphaNumericChar(Math.floor(a / 45))), r.append(t.toAlphaNumericChar(a % 45)), n -= 2;
        }
        if (1 === n) {
            if (e.available() < 6) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(e.readBits(6)));
        }
        if (o) for(var s = i; s < r.length(); s++)"%" === r.charAt(s) && (s < r.length() - 1 && "%" === r.charAt(s + 1) ? r.deleteCharAt(s + 1) : r.setCharAt(s, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, r, n) {
        for(; n >= 3;){
            if (e.available() < 10) throw new $849102574a83a574$var$G;
            var o = e.readBits(10);
            if (o >= 1e3) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(Math.floor(o / 100))), r.append(t.toAlphaNumericChar(Math.floor(o / 10) % 10)), r.append(t.toAlphaNumericChar(o % 10)), n -= 3;
        }
        if (2 === n) {
            if (e.available() < 7) throw new $849102574a83a574$var$G;
            var i = e.readBits(7);
            if (i >= 100) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(Math.floor(i / 10))), r.append(t.toAlphaNumericChar(i % 10));
        } else if (1 === n) {
            if (e.available() < 4) throw new $849102574a83a574$var$G;
            var a = e.readBits(4);
            if (a >= 10) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(a));
        }
    }, t.parseECIValue = function(t) {
        var e = t.readBits(8);
        if (0 == (128 & e)) return 127 & e;
        if (128 == (192 & e)) return (63 & e) << 8 & 4294967295 | t.readBits(8);
        if (192 == (224 & e)) return (31 & e) << 16 & 4294967295 | t.readBits(16);
        throw new $849102574a83a574$var$G;
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
}(), $849102574a83a574$var$ln = function() {
    function t(t) {
        this.mirrored = t;
    }
    return t.prototype.isMirrored = function() {
        return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(t) {
        if (this.mirrored && null !== t && !(t.length < 3)) {
            var e = t[0];
            t[0] = t[2], t[2] = e;
        }
    }, t;
}(), $849102574a83a574$var$dn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$pn = function() {
    function t() {
        this.rsDecoder = new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(t, e) {
        return this.decodeBitMatrix($849102574a83a574$var$J.parseFromBooleanArray(t), e);
    }, t.prototype.decodeBitMatrix = function(t, e) {
        var r = new $849102574a83a574$var$on(t), n = null;
        try {
            return this.decodeBitMatrixParser(r, e);
        } catch (t) {
            n = t;
        }
        try {
            r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
            var o = this.decodeBitMatrixParser(r, e);
            return o.setOther(new $849102574a83a574$var$ln(!0)), o;
        } catch (t) {
            if (null !== n) throw n;
            throw t;
        }
    }, t.prototype.decodeBitMatrixParser = function(t, e) {
        var r, n, o, i, a = t.readVersion(), s = t.readFormatInformation().getErrorCorrectionLevel(), u = t.readCodewords(), c = $849102574a83a574$var$sn.getDataBlocks(u, a, s), f = 0;
        try {
            for(var h = $849102574a83a574$var$dn(c), l = h.next(); !l.done; l = h.next())f += (w = l.value).getNumDataCodewords();
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        var d = new Uint8Array(f), p = 0;
        try {
            for(var g = $849102574a83a574$var$dn(c), y = g.next(); !y.done; y = g.next()){
                var w, v = (w = y.value).getCodewords(), _ = w.getNumDataCodewords();
                this.correctErrors(v, _);
                for(var A = 0; A < _; A++)d[p++] = v[A];
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (i = g.return) && i.call(g);
            } finally{
                if (o) throw o.error;
            }
        }
        return $849102574a83a574$var$hn.decode(d, a, s, e);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $849102574a83a574$var$R;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $849102574a83a574$var$gn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$yn = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.estimatedModuleSize = n, o;
    }
    return $849102574a83a574$var$gn(e, t), e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        return new e((this.getX() + r) / 2, (this.getY() + t) / 2, (this.estimatedModuleSize + n) / 2);
    }, e;
}($849102574a83a574$var$Lt), $849102574a83a574$var$wn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$vn = function() {
    function t(t, e, r, n, o, i, a) {
        this.image = t, this.startX = e, this.startY = r, this.width = n, this.height = o, this.moduleSize = i, this.resultPointCallback = a, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
        for(var t = this.startX, e = this.height, r = t + this.width, n = this.startY + e / 2, o = new Int32Array(3), i = this.image, a = 0; a < e; a++){
            var s = n + (0 == (1 & a) ? Math.floor((a + 1) / 2) : -Math.floor((a + 1) / 2));
            o[0] = 0, o[1] = 0, o[2] = 0;
            for(var u = t; u < r && !i.get(u, s);)u++;
            for(var c = 0; u < r;){
                if (i.get(u, s)) {
                    if (1 === c) o[1]++;
                    else if (2 === c) {
                        var f;
                        if (this.foundPatternCross(o)) {
                            if (null !== (f = this.handlePossibleCenter(o, s, u))) return f;
                        }
                        o[0] = o[2], o[1] = 1, o[2] = 0, c = 1;
                    } else o[++c]++;
                } else 1 === c && c++, o[c]++;
                u++;
            }
            if (this.foundPatternCross(o)) {
                if (null !== (f = this.handlePossibleCenter(o, s, r))) return f;
            }
        }
        if (0 !== this.possibleCenters.length) return this.possibleCenters[0];
        throw new $849102574a83a574$var$tt;
    }, t.centerFromEnd = function(t, e) {
        return e - t[2] - t[1] / 2;
    }, t.prototype.foundPatternCross = function(t) {
        for(var e = this.moduleSize, r = e / 2, n = 0; n < 3; n++)if (Math.abs(e - t[n]) >= r) return !1;
        return !0;
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        var i = this.image, a = i.getHeight(), s = this.crossCheckStateCount;
        s[0] = 0, s[1] = 0, s[2] = 0;
        for(var u = e; u >= 0 && i.get(r, u) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && !i.get(r, u) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(r, u) && s[1] <= n;)s[1]++, u++;
        if (u === a || s[1] > n) return NaN;
        for(; u < a && !i.get(r, u) && s[2] <= n;)s[2]++, u++;
        if (s[2] > n) return NaN;
        var c = s[0] + s[1] + s[2];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : this.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n) {
        var o, i, a = e[0] + e[1] + e[2], s = t.centerFromEnd(e, n), u = this.crossCheckVertical(r, s, 2 * e[1], a);
        if (!isNaN(u)) {
            var c = (e[0] + e[1] + e[2]) / 3;
            try {
                for(var f = $849102574a83a574$var$wn(this.possibleCenters), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (l.aboutEquals(c, u, s)) return l.combineEstimate(u, s, c);
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
            var d = new $849102574a83a574$var$yn(s, u, c);
            this.possibleCenters.push(d), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(d);
        }
        return null;
    }, t;
}(), $849102574a83a574$var$_n = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$An = function(t) {
    function e(e, r, n, o) {
        var i = t.call(this, e, r) || this;
        return i.estimatedModuleSize = n, i.count = o, void 0 === o && (i.count = 1), i;
    }
    return $849102574a83a574$var$_n(e, t), e.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        var o = this.count + 1;
        return new e((this.count * this.getX() + r) / o, (this.count * this.getY() + t) / o, (this.count * this.estimatedModuleSize + n) / o, o);
    }, e;
}($849102574a83a574$var$Lt), $849102574a83a574$var$Cn = function() {
    function t(t) {
        this.bottomLeft = t[0], this.topLeft = t[1], this.topRight = t[2];
    }
    return t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t;
}(), $849102574a83a574$var$mn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$En = function() {
    function t(t, e) {
        this.image = t, this.resultPointCallback = e, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = e;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    }, t.prototype.find = function(e) {
        var r = null != e && void 0 !== e.get($849102574a83a574$var$U.TRY_HARDER), n = null != e && void 0 !== e.get($849102574a83a574$var$U.PURE_BARCODE), o = this.image, i = o.getHeight(), a = o.getWidth(), s = Math.floor(3 * i / (4 * t.MAX_MODULES));
        (s < t.MIN_SKIP || r) && (s = t.MIN_SKIP);
        for(var u = !1, c = new Int32Array(5), f = s - 1; f < i && !u; f += s){
            c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
            for(var h = 0, l = 0; l < a; l++)if (o.get(l, f)) 1 == (1 & h) && h++, c[h]++;
            else if (0 == (1 & h)) {
                if (4 === h) {
                    if (t.foundPatternCross(c)) {
                        if (!0 !== this.handlePossibleCenter(c, f, l, n)) {
                            c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                            continue;
                        }
                        if (s = 2, !0 === this.hasSkipped) u = this.haveMultiplyConfirmedCenters();
                        else {
                            var d = this.findRowSkip();
                            d > c[2] && (f += d - c[2] - s, l = a - 1);
                        }
                        h = 0, c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
                    } else c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                } else c[++h]++;
            } else c[h]++;
            if (t.foundPatternCross(c)) !0 === this.handlePossibleCenter(c, f, a, n) && (s = c[0], this.hasSkipped && (u = this.haveMultiplyConfirmedCenters()));
        }
        var p = this.selectBestPatterns();
        return $849102574a83a574$var$Lt.orderBestPatterns(p), new $849102574a83a574$var$Cn(p);
    }, t.centerFromEnd = function(t, e) {
        return e - t[4] - t[3] - t[2] / 2;
    }, t.foundPatternCross = function(t) {
        for(var e = 0, r = 0; r < 5; r++){
            var n = t[r];
            if (0 === n) return !1;
            e += n;
        }
        if (e < 7) return !1;
        var o = e / 7, i = o / 2;
        return Math.abs(o - t[0]) < i && Math.abs(o - t[1]) < i && Math.abs(3 * o - t[2]) < 3 * i && Math.abs(o - t[3]) < i && Math.abs(o - t[4]) < i;
    }, t.prototype.getCrossCheckStateCount = function() {
        var t = this.crossCheckStateCount;
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t;
    }, t.prototype.crossCheckDiagonal = function(e, r, n, o) {
        for(var i = this.getCrossCheckStateCount(), a = 0, s = this.image; e >= a && r >= a && s.get(r - a, e - a);)i[2]++, a++;
        if (e < a || r < a) return !1;
        for(; e >= a && r >= a && !s.get(r - a, e - a) && i[1] <= n;)i[1]++, a++;
        if (e < a || r < a || i[1] > n) return !1;
        for(; e >= a && r >= a && s.get(r - a, e - a) && i[0] <= n;)i[0]++, a++;
        if (i[0] > n) return !1;
        var u = s.getHeight(), c = s.getWidth();
        for(a = 1; e + a < u && r + a < c && s.get(r + a, e + a);)i[2]++, a++;
        if (e + a >= u || r + a >= c) return !1;
        for(; e + a < u && r + a < c && !s.get(r + a, e + a) && i[3] < n;)i[3]++, a++;
        if (e + a >= u || r + a >= c || i[3] >= n) return !1;
        for(; e + a < u && r + a < c && s.get(r + a, e + a) && i[4] < n;)i[4]++, a++;
        if (i[4] >= n) return !1;
        var f = i[0] + i[1] + i[2] + i[3] + i[4];
        return Math.abs(f - o) < 2 * o && t.foundPatternCross(i);
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        for(var i = this.image, a = i.getHeight(), s = this.getCrossCheckStateCount(), u = e; u >= 0 && i.get(r, u);)s[2]++, u--;
        if (u < 0) return NaN;
        for(; u >= 0 && !i.get(r, u) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && i.get(r, u) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(r, u);)s[2]++, u++;
        if (u === a) return NaN;
        for(; u < a && !i.get(r, u) && s[3] < n;)s[3]++, u++;
        if (u === a || s[3] >= n) return NaN;
        for(; u < a && i.get(r, u) && s[4] < n;)s[4]++, u++;
        if (s[4] >= n) return NaN;
        var c = s[0] + s[1] + s[2] + s[3] + s[4];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : t.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, r, n, o) {
        for(var i = this.image, a = i.getWidth(), s = this.getCrossCheckStateCount(), u = e; u >= 0 && i.get(u, r);)s[2]++, u--;
        if (u < 0) return NaN;
        for(; u >= 0 && !i.get(u, r) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && i.get(u, r) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(u, r);)s[2]++, u++;
        if (u === a) return NaN;
        for(; u < a && !i.get(u, r) && s[3] < n;)s[3]++, u++;
        if (u === a || s[3] >= n) return NaN;
        for(; u < a && i.get(u, r) && s[4] < n;)s[4]++, u++;
        if (s[4] >= n) return NaN;
        var c = s[0] + s[1] + s[2] + s[3] + s[4];
        return 5 * Math.abs(c - o) >= o ? NaN : t.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n, o) {
        var i = e[0] + e[1] + e[2] + e[3] + e[4], a = t.centerFromEnd(e, n), s = this.crossCheckVertical(r, Math.floor(a), e[2], i);
        if (!isNaN(s) && (a = this.crossCheckHorizontal(Math.floor(a), Math.floor(s), e[2], i), !isNaN(a) && (!o || this.crossCheckDiagonal(Math.floor(s), Math.floor(a), e[2], i)))) {
            for(var u = i / 7, c = !1, f = this.possibleCenters, h = 0, l = f.length; h < l; h++){
                var d = f[h];
                if (d.aboutEquals(u, s, a)) {
                    f[h] = d.combineEstimate(s, a, u), c = !0;
                    break;
                }
            }
            if (!c) {
                var p = new $849102574a83a574$var$An(a, s, u);
                f.push(p), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(p);
            }
            return !0;
        }
        return !1;
    }, t.prototype.findRowSkip = function() {
        var e, r;
        if (this.possibleCenters.length <= 1) return 0;
        var n = null;
        try {
            for(var o = $849102574a83a574$var$mn(this.possibleCenters), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (a.getCount() >= t.CENTER_QUORUM) {
                    if (null != n) return this.hasSkipped = !0, Math.floor((Math.abs(n.getX() - a.getX()) - Math.abs(n.getY() - a.getY())) / 2);
                    n = a;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
        var e, r, n, o, i = 0, a = 0, s = this.possibleCenters.length;
        try {
            for(var u = $849102574a83a574$var$mn(this.possibleCenters), c = u.next(); !c.done; c = u.next())(p = c.value).getCount() >= t.CENTER_QUORUM && (i++, a += p.getEstimatedModuleSize());
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = u.return) && r.call(u);
            } finally{
                if (e) throw e.error;
            }
        }
        if (i < 3) return !1;
        var f = a / s, h = 0;
        try {
            for(var l = $849102574a83a574$var$mn(this.possibleCenters), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h += Math.abs(p.getEstimatedModuleSize() - f);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (o = l.return) && o.call(l);
            } finally{
                if (n) throw n.error;
            }
        }
        return h <= .05 * a;
    }, t.prototype.selectBestPatterns = function() {
        var t, e, r, n, o = this.possibleCenters.length;
        if (o < 3) throw new $849102574a83a574$var$tt;
        var i, a = this.possibleCenters;
        if (o > 3) {
            var s = 0, u = 0;
            try {
                for(var c = $849102574a83a574$var$mn(this.possibleCenters), f = c.next(); !f.done; f = c.next()){
                    var h = f.value.getEstimatedModuleSize();
                    s += h, u += h * h;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    f && !f.done && (e = c.return) && e.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            i = s / o;
            var l = Math.sqrt(u / o - i * i);
            a.sort(function(t, e) {
                var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                return r < n ? -1 : r > n ? 1 : 0;
            });
            for(var d = Math.max(.2 * i, l), p = 0; p < a.length && a.length > 3; p++){
                var g = a[p];
                Math.abs(g.getEstimatedModuleSize() - i) > d && (a.splice(p, 1), p--);
            }
        }
        if (a.length > 3) {
            s = 0;
            try {
                for(var y = $849102574a83a574$var$mn(a), w = y.next(); !w.done; w = y.next())s += w.value.getEstimatedModuleSize();
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (n = y.return) && n.call(y);
                } finally{
                    if (r) throw r.error;
                }
            }
            i = s / a.length, a.sort(function(t, e) {
                if (e.getCount() === t.getCount()) {
                    var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                    return r < n ? 1 : r > n ? -1 : 0;
                }
                return e.getCount() - t.getCount();
            }), a.splice(3);
        }
        return [
            a[0],
            a[1],
            a[2]
        ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
}(), $849102574a83a574$var$In = function() {
    function t(t) {
        this.image = t;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    }, t.prototype.detect = function(t) {
        this.resultPointCallback = null == t ? null : t.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
        var e = new $849102574a83a574$var$En(this.image, this.resultPointCallback).find(t);
        return this.processFinderPatternInfo(e);
    }, t.prototype.processFinderPatternInfo = function(e) {
        var r = e.getTopLeft(), n = e.getTopRight(), o = e.getBottomLeft(), i = this.calculateModuleSize(r, n, o);
        if (i < 1) throw new $849102574a83a574$var$tt("No pattern found in proccess finder.");
        var a = t.computeDimension(r, n, o, i), s = $849102574a83a574$var$en.getProvisionalVersionForDimension(a), u = s.getDimensionForVersion() - 7, c = null;
        if (s.getAlignmentPatternCenters().length > 0) for(var f = n.getX() - r.getX() + o.getX(), h = n.getY() - r.getY() + o.getY(), l = 1 - 3 / u, d = Math.floor(r.getX() + l * (f - r.getX())), p = Math.floor(r.getY() + l * (h - r.getY())), g = 4; g <= 16; g <<= 1)try {
            c = this.findAlignmentInRegion(i, d, p, g);
            break;
        } catch (t) {
            if (!(t instanceof $849102574a83a574$var$tt)) throw t;
        }
        var y = t.createTransform(r, n, o, c, a), w = t.sampleGrid(this.image, y, a);
        return new $849102574a83a574$var$Ft(w, null === c ? [
            o,
            r,
            n
        ] : [
            o,
            r,
            n,
            c
        ]);
    }, t.createTransform = function(t, e, r, n, o) {
        var i, a, s, u, c = o - 3.5;
        return null !== n ? (i = n.getX(), a = n.getY(), u = s = c - 3) : (i = e.getX() - t.getX() + r.getX(), a = e.getY() - t.getY() + r.getY(), s = c, u = c), $849102574a83a574$var$Ut.quadrilateralToQuadrilateral(3.5, 3.5, c, 3.5, s, u, 3.5, c, t.getX(), t.getY(), e.getX(), e.getY(), i, a, r.getX(), r.getY());
    }, t.sampleGrid = function(t, e, r) {
        return $849102574a83a574$var$Wt.getInstance().sampleGridWithTransform(t, r, r, e);
    }, t.computeDimension = function(t, e, r, n) {
        var o = $849102574a83a574$var$Pt.round($849102574a83a574$var$Lt.distance(t, e) / n), i = $849102574a83a574$var$Pt.round($849102574a83a574$var$Lt.distance(t, r) / n), a = Math.floor((o + i) / 2) + 7;
        switch(3 & a){
            case 0:
                a++;
                break;
            case 2:
                a--;
                break;
            case 3:
                throw new $849102574a83a574$var$tt("Dimensions could be not found.");
        }
        return a;
    }, t.prototype.calculateModuleSize = function(t, e, r) {
        return (this.calculateModuleSizeOneWay(t, e) + this.calculateModuleSizeOneWay(t, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(t, e) {
        var r = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()), Math.floor(t.getY()), Math.floor(e.getX()), Math.floor(e.getY())), n = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()), Math.floor(e.getY()), Math.floor(t.getX()), Math.floor(t.getY()));
        return isNaN(r) ? n / 7 : isNaN(n) ? r / 7 : (r + n) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(t, e, r, n) {
        var o = this.sizeOfBlackWhiteBlackRun(t, e, r, n), i = 1, a = t - (r - t);
        a < 0 ? (i = t / (t - a), a = 0) : a >= this.image.getWidth() && (i = (this.image.getWidth() - 1 - t) / (a - t), a = this.image.getWidth() - 1);
        var s = Math.floor(e - (n - e) * i);
        return i = 1, s < 0 ? (i = e / (e - s), s = 0) : s >= this.image.getHeight() && (i = (this.image.getHeight() - 1 - e) / (s - e), s = this.image.getHeight() - 1), a = Math.floor(t + (a - t) * i), (o += this.sizeOfBlackWhiteBlackRun(t, e, a, s)) - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(t, e, r, n) {
        var o = Math.abs(n - e) > Math.abs(r - t);
        if (o) {
            var i = t;
            t = e, e = i, i = r, r = n, n = i;
        }
        for(var a = Math.abs(r - t), s = Math.abs(n - e), u = -a / 2, c = t < r ? 1 : -1, f = e < n ? 1 : -1, h = 0, l = r + c, d = t, p = e; d !== l; d += c){
            var g = o ? p : d, y = o ? d : p;
            if (1 === h === this.image.get(g, y)) {
                if (2 === h) return $849102574a83a574$var$Pt.distance(d, p, t, e);
                h++;
            }
            if ((u += s) > 0) {
                if (p === n) break;
                p += f, u -= a;
            }
        }
        return 2 === h ? $849102574a83a574$var$Pt.distance(r + c, n, t, e) : NaN;
    }, t.prototype.findAlignmentInRegion = function(t, e, r, n) {
        var o = Math.floor(n * t), i = Math.max(0, e - o), a = Math.min(this.image.getWidth() - 1, e + o);
        if (a - i < 3 * t) throw new $849102574a83a574$var$tt("Alignment top exceeds estimated module size.");
        var s = Math.max(0, r - o), u = Math.min(this.image.getHeight() - 1, r + o);
        if (u - s < 3 * t) throw new $849102574a83a574$var$tt("Alignment bottom exceeds estimated module size.");
        return new $849102574a83a574$var$vn(this.image, i, s, a - i, u - s, t, this.resultPointCallback).find();
    }, t;
}(), $849102574a83a574$var$Sn = function() {
    function t() {
        this.decoder = new $849102574a83a574$var$pn;
    }
    return t.prototype.getDecoder = function() {
        return this.decoder;
    }, t.prototype.decode = function(e, r) {
        var n, o;
        if (null != r && void 0 !== r.get($849102574a83a574$var$U.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decodeBitMatrix(i, r), o = t.NO_POINTS;
        } else {
            var a = new $849102574a83a574$var$In(e.getBlackMatrix()).detect(r);
            n = this.decoder.decodeBitMatrix(a.getBits(), r), o = a.getPoints();
        }
        n.getOther() instanceof $849102574a83a574$var$ln && n.getOther().applyMirroredCorrection(o);
        var s = new $849102574a83a574$var$gt(n.getText(), n.getRawBytes(), void 0, o, $849102574a83a574$var$wt.QR_CODE, void 0), u = n.getByteSegments();
        null !== u && s.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, u);
        var c = n.getECLevel();
        return null !== c && s.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, c), n.hasStructuredAppend() && (s.putMetadata($849102574a83a574$var$_t.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), s.putMetadata($849102574a83a574$var$_t.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), s;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null === e || null === r) throw new $849102574a83a574$var$tt;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], s = r[0];
        if (a >= s || o >= i) throw new $849102574a83a574$var$tt;
        if (i - o != s - a && (s = a + (i - o)) >= t.getWidth()) throw new $849102574a83a574$var$tt;
        var u = Math.round((s - a + 1) / n), c = Math.round((i - o + 1) / n);
        if (u <= 0 || c <= 0) throw new $849102574a83a574$var$tt;
        if (c !== u) throw new $849102574a83a574$var$tt;
        var f = Math.floor(n / 2);
        o += f;
        var h = (a += f) + Math.floor((u - 1) * n) - s;
        if (h > 0) {
            if (h > f) throw new $849102574a83a574$var$tt;
            a -= h;
        }
        var l = o + Math.floor((c - 1) * n) - i;
        if (l > 0) {
            if (l > f) throw new $849102574a83a574$var$tt;
            o -= l;
        }
        for(var d = new $849102574a83a574$var$J(u, c), p = 0; p < c; p++)for(var g = o + Math.floor(p * n), y = 0; y < u; y++)t.get(a + Math.floor(y * n), g) && d.set(y, p);
        return d;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getHeight(), n = e.getWidth(), o = t[0], i = t[1], a = !0, s = 0; o < n && i < r;){
            if (a !== e.get(o, i)) {
                if (5 == ++s) break;
                a = !a;
            }
            o++, i++;
        }
        if (o === n || i === r) throw new $849102574a83a574$var$tt;
        return (o - t[0]) / 7;
    }, t.NO_POINTS = new Array, t;
}(), $849102574a83a574$var$Tn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$On = function() {
    function t() {}
    return t.prototype.PDF417Common = function() {}, t.getBitCountSum = function(t) {
        return $849102574a83a574$var$Pt.sum(t);
    }, t.toIntArray = function(e) {
        var r, n;
        if (null == e || !e.length) return t.EMPTY_INT_ARRAY;
        var o = new Int32Array(e.length), i = 0;
        try {
            for(var a = $849102574a83a574$var$Tn(e), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                o[i++] = u;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (n = a.return) && n.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return o;
    }, t.getCodeword = function(e) {
        var r = $849102574a83a574$var$k.binarySearch(t.SYMBOL_TABLE, 262143 & e);
        return r < 0 ? -1 : (t.CODEWORD_TABLE[r] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
        66142,
        66170,
        66206,
        66236,
        66290,
        66292,
        66350,
        66382,
        66396,
        66454,
        66470,
        66476,
        66594,
        66600,
        66614,
        66626,
        66628,
        66632,
        66640,
        66654,
        66662,
        66668,
        66682,
        66690,
        66718,
        66720,
        66748,
        66758,
        66776,
        66798,
        66802,
        66804,
        66820,
        66824,
        66832,
        66846,
        66848,
        66876,
        66880,
        66936,
        66950,
        66956,
        66968,
        66992,
        67006,
        67022,
        67036,
        67042,
        67044,
        67048,
        67062,
        67118,
        67150,
        67164,
        67214,
        67228,
        67256,
        67294,
        67322,
        67350,
        67366,
        67372,
        67398,
        67404,
        67416,
        67438,
        67474,
        67476,
        67490,
        67492,
        67496,
        67510,
        67618,
        67624,
        67650,
        67656,
        67664,
        67678,
        67686,
        67692,
        67706,
        67714,
        67716,
        67728,
        67742,
        67744,
        67772,
        67782,
        67788,
        67800,
        67822,
        67826,
        67828,
        67842,
        67848,
        67870,
        67872,
        67900,
        67904,
        67960,
        67974,
        67992,
        68016,
        68030,
        68046,
        68060,
        68066,
        68068,
        68072,
        68086,
        68104,
        68112,
        68126,
        68128,
        68156,
        68160,
        68216,
        68336,
        68358,
        68364,
        68376,
        68400,
        68414,
        68448,
        68476,
        68494,
        68508,
        68536,
        68546,
        68548,
        68552,
        68560,
        68574,
        68582,
        68588,
        68654,
        68686,
        68700,
        68706,
        68708,
        68712,
        68726,
        68750,
        68764,
        68792,
        68802,
        68804,
        68808,
        68816,
        68830,
        68838,
        68844,
        68858,
        68878,
        68892,
        68920,
        68976,
        68990,
        68994,
        68996,
        69e3,
        69008,
        69022,
        69024,
        69052,
        69062,
        69068,
        69080,
        69102,
        69106,
        69108,
        69142,
        69158,
        69164,
        69190,
        69208,
        69230,
        69254,
        69260,
        69272,
        69296,
        69310,
        69326,
        69340,
        69386,
        69394,
        69396,
        69410,
        69416,
        69430,
        69442,
        69444,
        69448,
        69456,
        69470,
        69478,
        69484,
        69554,
        69556,
        69666,
        69672,
        69698,
        69704,
        69712,
        69726,
        69754,
        69762,
        69764,
        69776,
        69790,
        69792,
        69820,
        69830,
        69836,
        69848,
        69870,
        69874,
        69876,
        69890,
        69918,
        69920,
        69948,
        69952,
        70008,
        70022,
        70040,
        70064,
        70078,
        70094,
        70108,
        70114,
        70116,
        70120,
        70134,
        70152,
        70174,
        70176,
        70264,
        70384,
        70412,
        70448,
        70462,
        70496,
        70524,
        70542,
        70556,
        70584,
        70594,
        70600,
        70608,
        70622,
        70630,
        70636,
        70664,
        70672,
        70686,
        70688,
        70716,
        70720,
        70776,
        70896,
        71136,
        71180,
        71192,
        71216,
        71230,
        71264,
        71292,
        71360,
        71416,
        71452,
        71480,
        71536,
        71550,
        71554,
        71556,
        71560,
        71568,
        71582,
        71584,
        71612,
        71622,
        71628,
        71640,
        71662,
        71726,
        71732,
        71758,
        71772,
        71778,
        71780,
        71784,
        71798,
        71822,
        71836,
        71864,
        71874,
        71880,
        71888,
        71902,
        71910,
        71916,
        71930,
        71950,
        71964,
        71992,
        72048,
        72062,
        72066,
        72068,
        72080,
        72094,
        72096,
        72124,
        72134,
        72140,
        72152,
        72174,
        72178,
        72180,
        72206,
        72220,
        72248,
        72304,
        72318,
        72416,
        72444,
        72456,
        72464,
        72478,
        72480,
        72508,
        72512,
        72568,
        72588,
        72600,
        72624,
        72638,
        72654,
        72668,
        72674,
        72676,
        72680,
        72694,
        72726,
        72742,
        72748,
        72774,
        72780,
        72792,
        72814,
        72838,
        72856,
        72880,
        72894,
        72910,
        72924,
        72930,
        72932,
        72936,
        72950,
        72966,
        72972,
        72984,
        73008,
        73022,
        73056,
        73084,
        73102,
        73116,
        73144,
        73156,
        73160,
        73168,
        73182,
        73190,
        73196,
        73210,
        73226,
        73234,
        73236,
        73250,
        73252,
        73256,
        73270,
        73282,
        73284,
        73296,
        73310,
        73318,
        73324,
        73346,
        73348,
        73352,
        73360,
        73374,
        73376,
        73404,
        73414,
        73420,
        73432,
        73454,
        73498,
        73518,
        73522,
        73524,
        73550,
        73564,
        73570,
        73572,
        73576,
        73590,
        73800,
        73822,
        73858,
        73860,
        73872,
        73886,
        73888,
        73916,
        73944,
        73970,
        73972,
        73992,
        74014,
        74016,
        74044,
        74048,
        74104,
        74118,
        74136,
        74160,
        74174,
        74210,
        74212,
        74216,
        74230,
        74244,
        74256,
        74270,
        74272,
        74360,
        74480,
        74502,
        74508,
        74544,
        74558,
        74592,
        74620,
        74638,
        74652,
        74680,
        74690,
        74696,
        74704,
        74726,
        74732,
        74782,
        74784,
        74812,
        74992,
        75232,
        75288,
        75326,
        75360,
        75388,
        75456,
        75512,
        75576,
        75632,
        75646,
        75650,
        75652,
        75664,
        75678,
        75680,
        75708,
        75718,
        75724,
        75736,
        75758,
        75808,
        75836,
        75840,
        75896,
        76016,
        76256,
        76736,
        76824,
        76848,
        76862,
        76896,
        76924,
        76992,
        77048,
        77296,
        77340,
        77368,
        77424,
        77438,
        77536,
        77564,
        77572,
        77576,
        77584,
        77600,
        77628,
        77632,
        77688,
        77702,
        77708,
        77720,
        77744,
        77758,
        77774,
        77788,
        77870,
        77902,
        77916,
        77922,
        77928,
        77966,
        77980,
        78008,
        78018,
        78024,
        78032,
        78046,
        78060,
        78074,
        78094,
        78136,
        78192,
        78206,
        78210,
        78212,
        78224,
        78238,
        78240,
        78268,
        78278,
        78284,
        78296,
        78322,
        78324,
        78350,
        78364,
        78448,
        78462,
        78560,
        78588,
        78600,
        78622,
        78624,
        78652,
        78656,
        78712,
        78726,
        78744,
        78768,
        78782,
        78798,
        78812,
        78818,
        78820,
        78824,
        78838,
        78862,
        78876,
        78904,
        78960,
        78974,
        79072,
        79100,
        79296,
        79352,
        79368,
        79376,
        79390,
        79392,
        79420,
        79424,
        79480,
        79600,
        79628,
        79640,
        79664,
        79678,
        79712,
        79740,
        79772,
        79800,
        79810,
        79812,
        79816,
        79824,
        79838,
        79846,
        79852,
        79894,
        79910,
        79916,
        79942,
        79948,
        79960,
        79982,
        79988,
        80006,
        80024,
        80048,
        80062,
        80078,
        80092,
        80098,
        80100,
        80104,
        80134,
        80140,
        80176,
        80190,
        80224,
        80252,
        80270,
        80284,
        80312,
        80328,
        80336,
        80350,
        80358,
        80364,
        80378,
        80390,
        80396,
        80408,
        80432,
        80446,
        80480,
        80508,
        80576,
        80632,
        80654,
        80668,
        80696,
        80752,
        80766,
        80776,
        80784,
        80798,
        80800,
        80828,
        80844,
        80856,
        80878,
        80882,
        80884,
        80914,
        80916,
        80930,
        80932,
        80936,
        80950,
        80962,
        80968,
        80976,
        80990,
        80998,
        81004,
        81026,
        81028,
        81040,
        81054,
        81056,
        81084,
        81094,
        81100,
        81112,
        81134,
        81154,
        81156,
        81160,
        81168,
        81182,
        81184,
        81212,
        81216,
        81272,
        81286,
        81292,
        81304,
        81328,
        81342,
        81358,
        81372,
        81380,
        81384,
        81398,
        81434,
        81454,
        81458,
        81460,
        81486,
        81500,
        81506,
        81508,
        81512,
        81526,
        81550,
        81564,
        81592,
        81602,
        81604,
        81608,
        81616,
        81630,
        81638,
        81644,
        81702,
        81708,
        81722,
        81734,
        81740,
        81752,
        81774,
        81778,
        81780,
        82050,
        82078,
        82080,
        82108,
        82180,
        82184,
        82192,
        82206,
        82208,
        82236,
        82240,
        82296,
        82316,
        82328,
        82352,
        82366,
        82402,
        82404,
        82408,
        82440,
        82448,
        82462,
        82464,
        82492,
        82496,
        82552,
        82672,
        82694,
        82700,
        82712,
        82736,
        82750,
        82784,
        82812,
        82830,
        82882,
        82884,
        82888,
        82896,
        82918,
        82924,
        82952,
        82960,
        82974,
        82976,
        83004,
        83008,
        83064,
        83184,
        83424,
        83468,
        83480,
        83504,
        83518,
        83552,
        83580,
        83648,
        83704,
        83740,
        83768,
        83824,
        83838,
        83842,
        83844,
        83848,
        83856,
        83872,
        83900,
        83910,
        83916,
        83928,
        83950,
        83984,
        84e3,
        84028,
        84032,
        84088,
        84208,
        84448,
        84928,
        85040,
        85054,
        85088,
        85116,
        85184,
        85240,
        85488,
        85560,
        85616,
        85630,
        85728,
        85756,
        85764,
        85768,
        85776,
        85790,
        85792,
        85820,
        85824,
        85880,
        85894,
        85900,
        85912,
        85936,
        85966,
        85980,
        86048,
        86080,
        86136,
        86256,
        86496,
        86976,
        88160,
        88188,
        88256,
        88312,
        88560,
        89056,
        89200,
        89214,
        89312,
        89340,
        89536,
        89592,
        89608,
        89616,
        89632,
        89664,
        89720,
        89840,
        89868,
        89880,
        89904,
        89952,
        89980,
        89998,
        90012,
        90040,
        90190,
        90204,
        90254,
        90268,
        90296,
        90306,
        90308,
        90312,
        90334,
        90382,
        90396,
        90424,
        90480,
        90494,
        90500,
        90504,
        90512,
        90526,
        90528,
        90556,
        90566,
        90572,
        90584,
        90610,
        90612,
        90638,
        90652,
        90680,
        90736,
        90750,
        90848,
        90876,
        90884,
        90888,
        90896,
        90910,
        90912,
        90940,
        90944,
        91e3,
        91014,
        91020,
        91032,
        91056,
        91070,
        91086,
        91100,
        91106,
        91108,
        91112,
        91126,
        91150,
        91164,
        91192,
        91248,
        91262,
        91360,
        91388,
        91584,
        91640,
        91664,
        91678,
        91680,
        91708,
        91712,
        91768,
        91888,
        91928,
        91952,
        91966,
        92e3,
        92028,
        92046,
        92060,
        92088,
        92098,
        92100,
        92104,
        92112,
        92126,
        92134,
        92140,
        92188,
        92216,
        92272,
        92384,
        92412,
        92608,
        92664,
        93168,
        93200,
        93214,
        93216,
        93244,
        93248,
        93304,
        93424,
        93664,
        93720,
        93744,
        93758,
        93792,
        93820,
        93888,
        93944,
        93980,
        94008,
        94064,
        94078,
        94084,
        94088,
        94096,
        94110,
        94112,
        94140,
        94150,
        94156,
        94168,
        94246,
        94252,
        94278,
        94284,
        94296,
        94318,
        94342,
        94348,
        94360,
        94384,
        94398,
        94414,
        94428,
        94440,
        94470,
        94476,
        94488,
        94512,
        94526,
        94560,
        94588,
        94606,
        94620,
        94648,
        94658,
        94660,
        94664,
        94672,
        94686,
        94694,
        94700,
        94714,
        94726,
        94732,
        94744,
        94768,
        94782,
        94816,
        94844,
        94912,
        94968,
        94990,
        95004,
        95032,
        95088,
        95102,
        95112,
        95120,
        95134,
        95136,
        95164,
        95180,
        95192,
        95214,
        95218,
        95220,
        95244,
        95256,
        95280,
        95294,
        95328,
        95356,
        95424,
        95480,
        95728,
        95758,
        95772,
        95800,
        95856,
        95870,
        95968,
        95996,
        96008,
        96016,
        96030,
        96032,
        96060,
        96064,
        96120,
        96152,
        96176,
        96190,
        96220,
        96226,
        96228,
        96232,
        96290,
        96292,
        96296,
        96310,
        96322,
        96324,
        96328,
        96336,
        96350,
        96358,
        96364,
        96386,
        96388,
        96392,
        96400,
        96414,
        96416,
        96444,
        96454,
        96460,
        96472,
        96494,
        96498,
        96500,
        96514,
        96516,
        96520,
        96528,
        96542,
        96544,
        96572,
        96576,
        96632,
        96646,
        96652,
        96664,
        96688,
        96702,
        96718,
        96732,
        96738,
        96740,
        96744,
        96758,
        96772,
        96776,
        96784,
        96798,
        96800,
        96828,
        96832,
        96888,
        97008,
        97030,
        97036,
        97048,
        97072,
        97086,
        97120,
        97148,
        97166,
        97180,
        97208,
        97220,
        97224,
        97232,
        97246,
        97254,
        97260,
        97326,
        97330,
        97332,
        97358,
        97372,
        97378,
        97380,
        97384,
        97398,
        97422,
        97436,
        97464,
        97474,
        97476,
        97480,
        97488,
        97502,
        97510,
        97516,
        97550,
        97564,
        97592,
        97648,
        97666,
        97668,
        97672,
        97680,
        97694,
        97696,
        97724,
        97734,
        97740,
        97752,
        97774,
        97830,
        97836,
        97850,
        97862,
        97868,
        97880,
        97902,
        97906,
        97908,
        97926,
        97932,
        97944,
        97968,
        97998,
        98012,
        98018,
        98020,
        98024,
        98038,
        98618,
        98674,
        98676,
        98838,
        98854,
        98874,
        98892,
        98904,
        98926,
        98930,
        98932,
        98968,
        99006,
        99042,
        99044,
        99048,
        99062,
        99166,
        99194,
        99246,
        99286,
        99350,
        99366,
        99372,
        99386,
        99398,
        99416,
        99438,
        99442,
        99444,
        99462,
        99504,
        99518,
        99534,
        99548,
        99554,
        99556,
        99560,
        99574,
        99590,
        99596,
        99608,
        99632,
        99646,
        99680,
        99708,
        99726,
        99740,
        99768,
        99778,
        99780,
        99784,
        99792,
        99806,
        99814,
        99820,
        99834,
        99858,
        99860,
        99874,
        99880,
        99894,
        99906,
        99920,
        99934,
        99962,
        99970,
        99972,
        99976,
        99984,
        99998,
        1e5,
        100028,
        100038,
        100044,
        100056,
        100078,
        100082,
        100084,
        100142,
        100174,
        100188,
        100246,
        100262,
        100268,
        100306,
        100308,
        100390,
        100396,
        100410,
        100422,
        100428,
        100440,
        100462,
        100466,
        100468,
        100486,
        100504,
        100528,
        100542,
        100558,
        100572,
        100578,
        100580,
        100584,
        100598,
        100620,
        100656,
        100670,
        100704,
        100732,
        100750,
        100792,
        100802,
        100808,
        100816,
        100830,
        100838,
        100844,
        100858,
        100888,
        100912,
        100926,
        100960,
        100988,
        101056,
        101112,
        101148,
        101176,
        101232,
        101246,
        101250,
        101252,
        101256,
        101264,
        101278,
        101280,
        101308,
        101318,
        101324,
        101336,
        101358,
        101362,
        101364,
        101410,
        101412,
        101416,
        101430,
        101442,
        101448,
        101456,
        101470,
        101478,
        101498,
        101506,
        101508,
        101520,
        101534,
        101536,
        101564,
        101580,
        101618,
        101620,
        101636,
        101640,
        101648,
        101662,
        101664,
        101692,
        101696,
        101752,
        101766,
        101784,
        101838,
        101858,
        101860,
        101864,
        101934,
        101938,
        101940,
        101966,
        101980,
        101986,
        101988,
        101992,
        102030,
        102044,
        102072,
        102082,
        102084,
        102088,
        102096,
        102138,
        102166,
        102182,
        102188,
        102214,
        102220,
        102232,
        102254,
        102282,
        102290,
        102292,
        102306,
        102308,
        102312,
        102326,
        102444,
        102458,
        102470,
        102476,
        102488,
        102514,
        102516,
        102534,
        102552,
        102576,
        102590,
        102606,
        102620,
        102626,
        102632,
        102646,
        102662,
        102668,
        102704,
        102718,
        102752,
        102780,
        102798,
        102812,
        102840,
        102850,
        102856,
        102864,
        102878,
        102886,
        102892,
        102906,
        102936,
        102974,
        103008,
        103036,
        103104,
        103160,
        103224,
        103280,
        103294,
        103298,
        103300,
        103312,
        103326,
        103328,
        103356,
        103366,
        103372,
        103384,
        103406,
        103410,
        103412,
        103472,
        103486,
        103520,
        103548,
        103616,
        103672,
        103920,
        103992,
        104048,
        104062,
        104160,
        104188,
        104194,
        104196,
        104200,
        104208,
        104224,
        104252,
        104256,
        104312,
        104326,
        104332,
        104344,
        104368,
        104382,
        104398,
        104412,
        104418,
        104420,
        104424,
        104482,
        104484,
        104514,
        104520,
        104528,
        104542,
        104550,
        104570,
        104578,
        104580,
        104592,
        104606,
        104608,
        104636,
        104652,
        104690,
        104692,
        104706,
        104712,
        104734,
        104736,
        104764,
        104768,
        104824,
        104838,
        104856,
        104910,
        104930,
        104932,
        104936,
        104968,
        104976,
        104990,
        104992,
        105020,
        105024,
        105080,
        105200,
        105240,
        105278,
        105312,
        105372,
        105410,
        105412,
        105416,
        105424,
        105446,
        105518,
        105524,
        105550,
        105564,
        105570,
        105572,
        105576,
        105614,
        105628,
        105656,
        105666,
        105672,
        105680,
        105702,
        105722,
        105742,
        105756,
        105784,
        105840,
        105854,
        105858,
        105860,
        105864,
        105872,
        105888,
        105932,
        105970,
        105972,
        106006,
        106022,
        106028,
        106054,
        106060,
        106072,
        106100,
        106118,
        106124,
        106136,
        106160,
        106174,
        106190,
        106210,
        106212,
        106216,
        106250,
        106258,
        106260,
        106274,
        106276,
        106280,
        106306,
        106308,
        106312,
        106320,
        106334,
        106348,
        106394,
        106414,
        106418,
        106420,
        106566,
        106572,
        106610,
        106612,
        106630,
        106636,
        106648,
        106672,
        106686,
        106722,
        106724,
        106728,
        106742,
        106758,
        106764,
        106776,
        106800,
        106814,
        106848,
        106876,
        106894,
        106908,
        106936,
        106946,
        106948,
        106952,
        106960,
        106974,
        106982,
        106988,
        107032,
        107056,
        107070,
        107104,
        107132,
        107200,
        107256,
        107292,
        107320,
        107376,
        107390,
        107394,
        107396,
        107400,
        107408,
        107422,
        107424,
        107452,
        107462,
        107468,
        107480,
        107502,
        107506,
        107508,
        107544,
        107568,
        107582,
        107616,
        107644,
        107712,
        107768,
        108016,
        108060,
        108088,
        108144,
        108158,
        108256,
        108284,
        108290,
        108292,
        108296,
        108304,
        108318,
        108320,
        108348,
        108352,
        108408,
        108422,
        108428,
        108440,
        108464,
        108478,
        108494,
        108508,
        108514,
        108516,
        108520,
        108592,
        108640,
        108668,
        108736,
        108792,
        109040,
        109536,
        109680,
        109694,
        109792,
        109820,
        110016,
        110072,
        110084,
        110088,
        110096,
        110112,
        110140,
        110144,
        110200,
        110320,
        110342,
        110348,
        110360,
        110384,
        110398,
        110432,
        110460,
        110478,
        110492,
        110520,
        110532,
        110536,
        110544,
        110558,
        110658,
        110686,
        110714,
        110722,
        110724,
        110728,
        110736,
        110750,
        110752,
        110780,
        110796,
        110834,
        110836,
        110850,
        110852,
        110856,
        110864,
        110878,
        110880,
        110908,
        110912,
        110968,
        110982,
        111e3,
        111054,
        111074,
        111076,
        111080,
        111108,
        111112,
        111120,
        111134,
        111136,
        111164,
        111168,
        111224,
        111344,
        111372,
        111422,
        111456,
        111516,
        111554,
        111556,
        111560,
        111568,
        111590,
        111632,
        111646,
        111648,
        111676,
        111680,
        111736,
        111856,
        112096,
        112152,
        112224,
        112252,
        112320,
        112440,
        112514,
        112516,
        112520,
        112528,
        112542,
        112544,
        112588,
        112686,
        112718,
        112732,
        112782,
        112796,
        112824,
        112834,
        112836,
        112840,
        112848,
        112870,
        112890,
        112910,
        112924,
        112952,
        113008,
        113022,
        113026,
        113028,
        113032,
        113040,
        113054,
        113056,
        113100,
        113138,
        113140,
        113166,
        113180,
        113208,
        113264,
        113278,
        113376,
        113404,
        113416,
        113424,
        113440,
        113468,
        113472,
        113560,
        113614,
        113634,
        113636,
        113640,
        113686,
        113702,
        113708,
        113734,
        113740,
        113752,
        113778,
        113780,
        113798,
        113804,
        113816,
        113840,
        113854,
        113870,
        113890,
        113892,
        113896,
        113926,
        113932,
        113944,
        113968,
        113982,
        114016,
        114044,
        114076,
        114114,
        114116,
        114120,
        114128,
        114150,
        114170,
        114194,
        114196,
        114210,
        114212,
        114216,
        114242,
        114244,
        114248,
        114256,
        114270,
        114278,
        114306,
        114308,
        114312,
        114320,
        114334,
        114336,
        114364,
        114380,
        114420,
        114458,
        114478,
        114482,
        114484,
        114510,
        114524,
        114530,
        114532,
        114536,
        114842,
        114866,
        114868,
        114970,
        114994,
        114996,
        115042,
        115044,
        115048,
        115062,
        115130,
        115226,
        115250,
        115252,
        115278,
        115292,
        115298,
        115300,
        115304,
        115318,
        115342,
        115394,
        115396,
        115400,
        115408,
        115422,
        115430,
        115436,
        115450,
        115478,
        115494,
        115514,
        115526,
        115532,
        115570,
        115572,
        115738,
        115758,
        115762,
        115764,
        115790,
        115804,
        115810,
        115812,
        115816,
        115830,
        115854,
        115868,
        115896,
        115906,
        115912,
        115920,
        115934,
        115942,
        115948,
        115962,
        115996,
        116024,
        116080,
        116094,
        116098,
        116100,
        116104,
        116112,
        116126,
        116128,
        116156,
        116166,
        116172,
        116184,
        116206,
        116210,
        116212,
        116246,
        116262,
        116268,
        116282,
        116294,
        116300,
        116312,
        116334,
        116338,
        116340,
        116358,
        116364,
        116376,
        116400,
        116414,
        116430,
        116444,
        116450,
        116452,
        116456,
        116498,
        116500,
        116514,
        116520,
        116534,
        116546,
        116548,
        116552,
        116560,
        116574,
        116582,
        116588,
        116602,
        116654,
        116694,
        116714,
        116762,
        116782,
        116786,
        116788,
        116814,
        116828,
        116834,
        116836,
        116840,
        116854,
        116878,
        116892,
        116920,
        116930,
        116936,
        116944,
        116958,
        116966,
        116972,
        116986,
        117006,
        117048,
        117104,
        117118,
        117122,
        117124,
        117136,
        117150,
        117152,
        117180,
        117190,
        117196,
        117208,
        117230,
        117234,
        117236,
        117304,
        117360,
        117374,
        117472,
        117500,
        117506,
        117508,
        117512,
        117520,
        117536,
        117564,
        117568,
        117624,
        117638,
        117644,
        117656,
        117680,
        117694,
        117710,
        117724,
        117730,
        117732,
        117736,
        117750,
        117782,
        117798,
        117804,
        117818,
        117830,
        117848,
        117874,
        117876,
        117894,
        117936,
        117950,
        117966,
        117986,
        117988,
        117992,
        118022,
        118028,
        118040,
        118064,
        118078,
        118112,
        118140,
        118172,
        118210,
        118212,
        118216,
        118224,
        118238,
        118246,
        118266,
        118306,
        118312,
        118338,
        118352,
        118366,
        118374,
        118394,
        118402,
        118404,
        118408,
        118416,
        118430,
        118432,
        118460,
        118476,
        118514,
        118516,
        118574,
        118578,
        118580,
        118606,
        118620,
        118626,
        118628,
        118632,
        118678,
        118694,
        118700,
        118730,
        118738,
        118740,
        118830,
        118834,
        118836,
        118862,
        118876,
        118882,
        118884,
        118888,
        118902,
        118926,
        118940,
        118968,
        118978,
        118980,
        118984,
        118992,
        119006,
        119014,
        119020,
        119034,
        119068,
        119096,
        119152,
        119166,
        119170,
        119172,
        119176,
        119184,
        119198,
        119200,
        119228,
        119238,
        119244,
        119256,
        119278,
        119282,
        119284,
        119324,
        119352,
        119408,
        119422,
        119520,
        119548,
        119554,
        119556,
        119560,
        119568,
        119582,
        119584,
        119612,
        119616,
        119672,
        119686,
        119692,
        119704,
        119728,
        119742,
        119758,
        119772,
        119778,
        119780,
        119784,
        119798,
        119920,
        119934,
        120032,
        120060,
        120256,
        120312,
        120324,
        120328,
        120336,
        120352,
        120384,
        120440,
        120560,
        120582,
        120588,
        120600,
        120624,
        120638,
        120672,
        120700,
        120718,
        120732,
        120760,
        120770,
        120772,
        120776,
        120784,
        120798,
        120806,
        120812,
        120870,
        120876,
        120890,
        120902,
        120908,
        120920,
        120946,
        120948,
        120966,
        120972,
        120984,
        121008,
        121022,
        121038,
        121058,
        121060,
        121064,
        121078,
        121100,
        121112,
        121136,
        121150,
        121184,
        121212,
        121244,
        121282,
        121284,
        121288,
        121296,
        121318,
        121338,
        121356,
        121368,
        121392,
        121406,
        121440,
        121468,
        121536,
        121592,
        121656,
        121730,
        121732,
        121736,
        121744,
        121758,
        121760,
        121804,
        121842,
        121844,
        121890,
        121922,
        121924,
        121928,
        121936,
        121950,
        121958,
        121978,
        121986,
        121988,
        121992,
        122e3,
        122014,
        122016,
        122044,
        122060,
        122098,
        122100,
        122116,
        122120,
        122128,
        122142,
        122144,
        122172,
        122176,
        122232,
        122246,
        122264,
        122318,
        122338,
        122340,
        122344,
        122414,
        122418,
        122420,
        122446,
        122460,
        122466,
        122468,
        122472,
        122510,
        122524,
        122552,
        122562,
        122564,
        122568,
        122576,
        122598,
        122618,
        122646,
        122662,
        122668,
        122694,
        122700,
        122712,
        122738,
        122740,
        122762,
        122770,
        122772,
        122786,
        122788,
        122792,
        123018,
        123026,
        123028,
        123042,
        123044,
        123048,
        123062,
        123098,
        123146,
        123154,
        123156,
        123170,
        123172,
        123176,
        123190,
        123202,
        123204,
        123208,
        123216,
        123238,
        123244,
        123258,
        123290,
        123314,
        123316,
        123402,
        123410,
        123412,
        123426,
        123428,
        123432,
        123446,
        123458,
        123464,
        123472,
        123486,
        123494,
        123500,
        123514,
        123522,
        123524,
        123528,
        123536,
        123552,
        123580,
        123590,
        123596,
        123608,
        123630,
        123634,
        123636,
        123674,
        123698,
        123700,
        123740,
        123746,
        123748,
        123752,
        123834,
        123914,
        123922,
        123924,
        123938,
        123944,
        123958,
        123970,
        123976,
        123984,
        123998,
        124006,
        124012,
        124026,
        124034,
        124036,
        124048,
        124062,
        124064,
        124092,
        124102,
        124108,
        124120,
        124142,
        124146,
        124148,
        124162,
        124164,
        124168,
        124176,
        124190,
        124192,
        124220,
        124224,
        124280,
        124294,
        124300,
        124312,
        124336,
        124350,
        124366,
        124380,
        124386,
        124388,
        124392,
        124406,
        124442,
        124462,
        124466,
        124468,
        124494,
        124508,
        124514,
        124520,
        124558,
        124572,
        124600,
        124610,
        124612,
        124616,
        124624,
        124646,
        124666,
        124694,
        124710,
        124716,
        124730,
        124742,
        124748,
        124760,
        124786,
        124788,
        124818,
        124820,
        124834,
        124836,
        124840,
        124854,
        124946,
        124948,
        124962,
        124964,
        124968,
        124982,
        124994,
        124996,
        125e3,
        125008,
        125022,
        125030,
        125036,
        125050,
        125058,
        125060,
        125064,
        125072,
        125086,
        125088,
        125116,
        125126,
        125132,
        125144,
        125166,
        125170,
        125172,
        125186,
        125188,
        125192,
        125200,
        125216,
        125244,
        125248,
        125304,
        125318,
        125324,
        125336,
        125360,
        125374,
        125390,
        125404,
        125410,
        125412,
        125416,
        125430,
        125444,
        125448,
        125456,
        125472,
        125504,
        125560,
        125680,
        125702,
        125708,
        125720,
        125744,
        125758,
        125792,
        125820,
        125838,
        125852,
        125880,
        125890,
        125892,
        125896,
        125904,
        125918,
        125926,
        125932,
        125978,
        125998,
        126002,
        126004,
        126030,
        126044,
        126050,
        126052,
        126056,
        126094,
        126108,
        126136,
        126146,
        126148,
        126152,
        126160,
        126182,
        126202,
        126222,
        126236,
        126264,
        126320,
        126334,
        126338,
        126340,
        126344,
        126352,
        126366,
        126368,
        126412,
        126450,
        126452,
        126486,
        126502,
        126508,
        126522,
        126534,
        126540,
        126552,
        126574,
        126578,
        126580,
        126598,
        126604,
        126616,
        126640,
        126654,
        126670,
        126684,
        126690,
        126692,
        126696,
        126738,
        126754,
        126756,
        126760,
        126774,
        126786,
        126788,
        126792,
        126800,
        126814,
        126822,
        126828,
        126842,
        126894,
        126898,
        126900,
        126934,
        127126,
        127142,
        127148,
        127162,
        127178,
        127186,
        127188,
        127254,
        127270,
        127276,
        127290,
        127302,
        127308,
        127320,
        127342,
        127346,
        127348,
        127370,
        127378,
        127380,
        127394,
        127396,
        127400,
        127450,
        127510,
        127526,
        127532,
        127546,
        127558,
        127576,
        127598,
        127602,
        127604,
        127622,
        127628,
        127640,
        127664,
        127678,
        127694,
        127708,
        127714,
        127716,
        127720,
        127734,
        127754,
        127762,
        127764,
        127778,
        127784,
        127810,
        127812,
        127816,
        127824,
        127838,
        127846,
        127866,
        127898,
        127918,
        127922,
        127924,
        128022,
        128038,
        128044,
        128058,
        128070,
        128076,
        128088,
        128110,
        128114,
        128116,
        128134,
        128140,
        128152,
        128176,
        128190,
        128206,
        128220,
        128226,
        128228,
        128232,
        128246,
        128262,
        128268,
        128280,
        128304,
        128318,
        128352,
        128380,
        128398,
        128412,
        128440,
        128450,
        128452,
        128456,
        128464,
        128478,
        128486,
        128492,
        128506,
        128522,
        128530,
        128532,
        128546,
        128548,
        128552,
        128566,
        128578,
        128580,
        128584,
        128592,
        128606,
        128614,
        128634,
        128642,
        128644,
        128648,
        128656,
        128670,
        128672,
        128700,
        128716,
        128754,
        128756,
        128794,
        128814,
        128818,
        128820,
        128846,
        128860,
        128866,
        128868,
        128872,
        128886,
        128918,
        128934,
        128940,
        128954,
        128978,
        128980,
        129178,
        129198,
        129202,
        129204,
        129238,
        129258,
        129306,
        129326,
        129330,
        129332,
        129358,
        129372,
        129378,
        129380,
        129384,
        129398,
        129430,
        129446,
        129452,
        129466,
        129482,
        129490,
        129492,
        129562,
        129582,
        129586,
        129588,
        129614,
        129628,
        129634,
        129636,
        129640,
        129654,
        129678,
        129692,
        129720,
        129730,
        129732,
        129736,
        129744,
        129758,
        129766,
        129772,
        129814,
        129830,
        129836,
        129850,
        129862,
        129868,
        129880,
        129902,
        129906,
        129908,
        129930,
        129938,
        129940,
        129954,
        129956,
        129960,
        129974,
        130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2e3,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1e3,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]), t;
}(), $849102574a83a574$var$bn = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $849102574a83a574$var$Rn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Nn = function() {
    function t() {}
    return t.detectMultiple = function(e, r, n) {
        var o = e.getBlackMatrix(), i = t.detect(n, o);
        return i.length || ((o = o.clone()).rotate180(), i = t.detect(n, o)), new $849102574a83a574$var$bn(o, i);
    }, t.detect = function(e, r) {
        for(var n, o, i = new Array, a = 0, s = 0, u = !1; a < r.getHeight();){
            var c = t.findVertices(r, a, s);
            if (null != c[0] || null != c[3]) {
                if (u = !0, i.push(c), !e) break;
                null != c[2] ? (s = Math.trunc(c[2].getX()), a = Math.trunc(c[2].getY())) : (s = Math.trunc(c[4].getX()), a = Math.trunc(c[4].getY()));
            } else {
                if (!u) break;
                u = !1, s = 0;
                try {
                    for(var f = (n = void 0, $849102574a83a574$var$Rn(i)), h = f.next(); !h.done; h = f.next()){
                        var l = h.value;
                        null != l[1] && (a = Math.trunc(Math.max(a, l[1].getY()))), null != l[3] && (a = Math.max(a, Math.trunc(l[3].getY())));
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                a += t.ROW_STEP;
            }
        }
        return i;
    }, t.findVertices = function(e, r, n) {
        var o = e.getHeight(), i = e.getWidth(), a = new Array(8);
        return t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.START_PATTERN), t.INDEXES_START_PATTERN), null != a[4] && (n = Math.trunc(a[4].getX()), r = Math.trunc(a[4].getY())), t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), a;
    }, t.copyToResult = function(t, e, r) {
        for(var n = 0; n < r.length; n++)t[r[n]] = e[n];
    }, t.findRowsWithPattern = function(e, r, n, o, i, a) {
        for(var s = new Array(4), u = !1, c = new Int32Array(a.length); o < r; o += t.ROW_STEP)if (null != (d = t.findGuardPattern(e, i, o, n, !1, a, c))) {
            for(; o > 0;){
                if (null == (l = t.findGuardPattern(e, i, --o, n, !1, a, c))) {
                    o++;
                    break;
                }
                d = l;
            }
            s[0] = new $849102574a83a574$var$Lt(d[0], o), s[1] = new $849102574a83a574$var$Lt(d[1], o), u = !0;
            break;
        }
        var f = o + 1;
        if (u) {
            for(var h = 0, l = Int32Array.from([
                Math.trunc(s[0].getX()),
                Math.trunc(s[1].getX())
            ]); f < r; f++){
                var d;
                if (null != (d = t.findGuardPattern(e, l[0], f, n, !1, a, c)) && Math.abs(l[0] - d[0]) < t.MAX_PATTERN_DRIFT && Math.abs(l[1] - d[1]) < t.MAX_PATTERN_DRIFT) l = d, h = 0;
                else {
                    if (h > t.SKIPPED_ROW_COUNT_MAX) break;
                    h++;
                }
            }
            f -= h + 1, s[2] = new $849102574a83a574$var$Lt(l[0], f), s[3] = new $849102574a83a574$var$Lt(l[1], f);
        }
        return f - o < t.BARCODE_MIN_HEIGHT && $849102574a83a574$var$k.fill(s, null), s;
    }, t.findGuardPattern = function(e, r, n, o, i, a, s) {
        $849102574a83a574$var$k.fillWithin(s, 0, s.length, 0);
        for(var u = r, c = 0; e.get(u, n) && u > 0 && c++ < t.MAX_PIXEL_DRIFT;)u--;
        for(var f = u, h = 0, l = a.length, d = i; f < o; f++)if (e.get(f, n) !== d) s[h]++;
        else {
            if (h === l - 1) {
                if (t.patternMatchVariance(s, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE) return new Int32Array([
                    u,
                    f
                ]);
                u += s[0] + s[1], $849102574a83a574$var$D.arraycopy(s, 2, s, 0, h - 1), s[h - 1] = 0, s[h] = 0, h--;
            } else h++;
            s[h] = 1, d = !d;
        }
        return h === l - 1 && t.patternMatchVariance(s, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([
            u,
            f - 1
        ]) : null;
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return 1 / 0;
        var s = o / i;
        r *= s;
        for(var u = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * s, l = f > h ? f - h : h - f;
            if (l > r) return 1 / 0;
            u += l;
        }
        return u / o;
    }, t.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]), t.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]), t.MAX_AVG_VARIANCE = .42, t.MAX_INDIVIDUAL_VARIANCE = .8, t.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]), t.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
}(), $849102574a83a574$var$Dn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Mn = function() {
    function t(t, e) {
        if (0 === e.length) throw new $849102574a83a574$var$T;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = new Int32Array([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $849102574a83a574$var$D.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        var e, r;
        if (0 === t) return this.getCoefficient(0);
        if (1 === t) {
            var n = 0;
            try {
                for(var o = $849102574a83a574$var$Dn(this.coefficients), i = o.next(); !i.done; i = o.next()){
                    var a = i.value;
                    n = this.field.add(n, a);
                }
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    i && !i.done && (r = o.return) && r.call(o);
                } finally{
                    if (e) throw e.error;
                }
            }
            return n;
        }
        for(var s = this.coefficients[0], u = this.coefficients.length, c = 1; c < u; c++)s = this.field.add(this.field.multiply(t, s), this.coefficients[c]);
        return s;
    }, t.prototype.add = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $849102574a83a574$var$D.arraycopy(n, 0, i, 0, a);
        for(var s = a; s < n.length; s++)i[s] = this.field.add(r[s - a], n[s]);
        return new t(this.field, i);
    }, t.prototype.subtract = function(t) {
        if (!this.field.equals(t.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        return t.isZero() ? this : this.add(t.negative());
    }, t.prototype.multiply = function(e) {
        return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || e.isZero()) return new t(this.field, new Int32Array([
            0
        ]));
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), s = 0; s < n; s++)for(var u = r[s], c = 0; c < i; c++)a[s + c] = this.field.add(a[s + c], this.field.multiply(u, o[c]));
        return new t(this.field, a);
    }, t.prototype.negative = function() {
        for(var e = this.coefficients.length, r = new Int32Array(e), n = 0; n < e; n++)r[n] = this.field.subtract(0, this.coefficients[n]);
        return new t(this.field, r);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return new t(this.field, new Int32Array([
            0
        ]));
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = new Int32Array(r), o = 0; o < r; o++)n[o] = this.field.multiply(this.coefficients[o], e);
        return new t(this.field, n);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $849102574a83a574$var$T;
        if (0 === r) return new t(this.field, new Int32Array([
            0
        ]));
        for(var n = this.coefficients.length, o = new Int32Array(n + e), i = 0; i < n; i++)o[i] = this.field.multiply(this.coefficients[i], r);
        return new t(this.field, o);
    }, t.prototype.toString = function() {
        for(var t = new $849102574a83a574$var$Q, e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            0 !== r && (r < 0 ? (t.append(" - "), r = -r) : t.length() > 0 && t.append(" + "), 0 !== e && 1 === r || t.append(r), 0 !== e && (1 === e ? t.append("x") : (t.append("x^"), t.append(e))));
        }
        return t.toString();
    }, t;
}(), $849102574a83a574$var$Pn = function() {
    function t() {}
    return t.prototype.add = function(t, e) {
        return (t + e) % this.modulus;
    }, t.prototype.subtract = function(t, e) {
        return (this.modulus + t - e) % this.modulus;
    }, t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $849102574a83a574$var$T;
        return this.logTable[t];
    }, t.prototype.inverse = function(t) {
        if (0 === t) throw new $849102574a83a574$var$It;
        return this.expTable[this.modulus - this.logTable[t] - 1];
    }, t.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
        return this.modulus;
    }, t.prototype.equals = function(t) {
        return t === this;
    }, t;
}(), $849102574a83a574$var$Bn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ln = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        n.modulus = e, n.expTable = new Int32Array(e), n.logTable = new Int32Array(e);
        for(var o = 1, i = 0; i < e; i++)n.expTable[i] = o, o = o * r % e;
        for(i = 0; i < e - 1; i++)n.logTable[n.expTable[i]] = i;
        return n.zero = new $849102574a83a574$var$Mn(n, new Int32Array([
            0
        ])), n.one = new $849102574a83a574$var$Mn(n, new Int32Array([
            1
        ])), n;
    }
    return $849102574a83a574$var$Bn(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $849102574a83a574$var$T;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $849102574a83a574$var$Mn(this, r);
    }, e.PDF417_GF = new e($849102574a83a574$var$On.NUMBER_OF_CODEWORDS, 3), e;
}($849102574a83a574$var$Pn), $849102574a83a574$var$Fn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$kn = function() {
    function t() {
        this.field = $849102574a83a574$var$Ln.PDF417_GF;
    }
    return t.prototype.decode = function(t, e, r) {
        for(var n, o, i = new $849102574a83a574$var$Mn(this.field, t), a = new Int32Array(e), s = !1, u = e; u > 0; u--){
            var c = i.evaluateAt(this.field.exp(u));
            a[e - u] = c, 0 !== c && (s = !0);
        }
        if (!s) return 0;
        var f = this.field.getOne();
        if (null != r) try {
            for(var h = $849102574a83a574$var$Fn(r), l = h.next(); !l.done; l = h.next()){
                var d = l.value, p = this.field.exp(t.length - 1 - d), g = new $849102574a83a574$var$Mn(this.field, new Int32Array([
                    this.field.subtract(0, p),
                    1
                ]));
                f = f.multiply(g);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (o = h.return) && o.call(h);
            } finally{
                if (n) throw n.error;
            }
        }
        var y = new $849102574a83a574$var$Mn(this.field, a), w = this.runEuclideanAlgorithm(this.field.buildMonomial(e, 1), y, e), v = w[0], _ = w[1], A = this.findErrorLocations(v), C = this.findErrorMagnitudes(_, v, A);
        for(u = 0; u < A.length; u++){
            var m = t.length - 1 - this.field.log(A[u]);
            if (m < 0) throw $849102574a83a574$var$R.getChecksumInstance();
            t[m] = this.field.subtract(t[m], C[u]);
        }
        return A.length;
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = t, i = e, a = this.field.getZero(), s = this.field.getOne(); i.getDegree() >= Math.round(r / 2);){
            var u = o, c = a;
            if (a = s, (o = i).isZero()) throw $849102574a83a574$var$R.getChecksumInstance();
            i = u;
            for(var f = this.field.getZero(), h = o.getCoefficient(o.getDegree()), l = this.field.inverse(h); i.getDegree() >= o.getDegree() && !i.isZero();){
                var d = i.getDegree() - o.getDegree(), p = this.field.multiply(i.getCoefficient(i.getDegree()), l);
                f = f.add(this.field.buildMonomial(d, p)), i = i.subtract(o.multiplyByMonomial(d, p));
            }
            s = f.multiply(a).subtract(c).negative();
        }
        var g = s.getCoefficient(0);
        if (0 === g) throw $849102574a83a574$var$R.getChecksumInstance();
        var y = this.field.inverse(g);
        return [
            s.multiply(y),
            i.multiply(y)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        for(var e = t.getDegree(), r = new Int32Array(e), n = 0, o = 1; o < this.field.getSize() && n < e; o++)0 === t.evaluateAt(o) && (r[n] = this.field.inverse(o), n++);
        if (n !== e) throw $849102574a83a574$var$R.getChecksumInstance();
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e, r) {
        for(var n = e.getDegree(), o = new Int32Array(n), i = 1; i <= n; i++)o[n - i] = this.field.multiply(i, e.getCoefficient(i));
        var a = new $849102574a83a574$var$Mn(this.field, o), s = r.length, u = new Int32Array(s);
        for(i = 0; i < s; i++){
            var c = this.field.inverse(r[i]), f = this.field.subtract(0, t.evaluateAt(c)), h = this.field.inverse(a.evaluateAt(c));
            u[i] = this.field.multiply(f, h);
        }
        return u;
    }, t;
}(), $849102574a83a574$var$xn = function() {
    function t(e, r, n, o, i) {
        e instanceof t ? this.constructor_2(e) : this.constructor_1(e, r, n, o, i);
    }
    return t.prototype.constructor_1 = function(t, e, r, n, o) {
        var i = null == e || null == r, a = null == n || null == o;
        if (i && a) throw new $849102574a83a574$var$tt;
        i ? (e = new $849102574a83a574$var$Lt(0, n.getY()), r = new $849102574a83a574$var$Lt(0, o.getY())) : a && (n = new $849102574a83a574$var$Lt(t.getWidth() - 1, e.getY()), o = new $849102574a83a574$var$Lt(t.getWidth() - 1, r.getY())), this.image = t, this.topLeft = e, this.bottomLeft = r, this.topRight = n, this.bottomRight = o, this.minX = Math.trunc(Math.min(e.getX(), r.getX())), this.maxX = Math.trunc(Math.max(n.getX(), o.getX())), this.minY = Math.trunc(Math.min(e.getY(), n.getY())), this.maxY = Math.trunc(Math.max(r.getY(), o.getY()));
    }, t.prototype.constructor_2 = function(t) {
        this.image = t.image, this.topLeft = t.getTopLeft(), this.bottomLeft = t.getBottomLeft(), this.topRight = t.getTopRight(), this.bottomRight = t.getBottomRight(), this.minX = t.getMinX(), this.maxX = t.getMaxX(), this.minY = t.getMinY(), this.maxY = t.getMaxY();
    }, t.merge = function(e, r) {
        return null == e ? r : null == r ? e : new t(e.image, e.topLeft, e.bottomLeft, r.topRight, r.bottomRight);
    }, t.prototype.addMissingRows = function(e, r, n) {
        var o = this.topLeft, i = this.bottomLeft, a = this.topRight, s = this.bottomRight;
        if (e > 0) {
            var u = n ? this.topLeft : this.topRight, c = Math.trunc(u.getY() - e);
            c < 0 && (c = 0);
            var f = new $849102574a83a574$var$Lt(u.getX(), c);
            n ? o = f : a = f;
        }
        if (r > 0) {
            var h = n ? this.bottomLeft : this.bottomRight, l = Math.trunc(h.getY() + r);
            l >= this.image.getHeight() && (l = this.image.getHeight() - 1);
            var d = new $849102574a83a574$var$Lt(h.getX(), l);
            n ? i = d : s = d;
        }
        return new t(this.image, o, i, a, s);
    }, t.prototype.getMinX = function() {
        return this.minX;
    }, t.prototype.getMaxX = function() {
        return this.maxX;
    }, t.prototype.getMinY = function() {
        return this.minY;
    }, t.prototype.getMaxY = function() {
        return this.maxY;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
        return this.bottomRight;
    }, t;
}(), $849102574a83a574$var$Vn = function() {
    function t(t, e, r, n) {
        this.columnCount = t, this.errorCorrectionLevel = n, this.rowCountUpperPart = e, this.rowCountLowerPart = r, this.rowCount = e + r;
    }
    return t.prototype.getColumnCount = function() {
        return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
        return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    }, t;
}(), $849102574a83a574$var$Hn = function() {
    function t() {
        this.buffer = "";
    }
    return t.form = function(t, e) {
        var r = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, n, o, i, a, s) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++r]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var u, c = a ? parseInt(a.substr(1)) : void 0;
                switch(s){
                    case "s":
                        u = e[r];
                        break;
                    case "c":
                        u = e[r][0];
                        break;
                    case "f":
                        u = parseFloat(e[r]).toFixed(t);
                        break;
                    case "p":
                        u = parseFloat(e[r]).toPrecision(t);
                        break;
                    case "e":
                        u = parseFloat(e[r]).toExponential(t);
                        break;
                    case "x":
                        u = parseInt(e[r]).toString(c || 16);
                        break;
                    case "d":
                        u = parseFloat(parseInt(e[r], c || 10).toPrecision(t)).toFixed(0);
                }
                u = "object" == typeof u ? JSON.stringify(u) : (+u).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; u.length < f;)u = void 0 !== n ? u + h : h + u;
                return u;
            }
        });
    }, t.prototype.format = function(e) {
        for(var r = [], n = 1; n < arguments.length; n++)r[n - 1] = arguments[n];
        this.buffer += t.form(e, r);
    }, t.prototype.toString = function() {
        return this.buffer;
    }, t;
}(), $849102574a83a574$var$Un = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Xn = function() {
    function t(t) {
        this.boundingBox = new $849102574a83a574$var$xn(t), this.codewords = new Array(t.getMaxY() - t.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
        var r = this.getCodeword(e);
        if (null != r) return r;
        for(var n = 1; n < t.MAX_NEARBY_DISTANCE; n++){
            var o = this.imageRowToCodewordIndex(e) - n;
            if (o >= 0 && null != (r = this.codewords[o])) return r;
            if ((o = this.imageRowToCodewordIndex(e) + n) < this.codewords.length && null != (r = this.codewords[o])) return r;
        }
        return null;
    }, t.prototype.imageRowToCodewordIndex = function(t) {
        return t - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(t, e) {
        this.codewords[this.imageRowToCodewordIndex(t)] = e;
    }, t.prototype.getCodeword = function(t) {
        return this.codewords[this.imageRowToCodewordIndex(t)];
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.toString = function() {
        var t, e, r = new $849102574a83a574$var$Hn, n = 0;
        try {
            for(var o = $849102574a83a574$var$Un(this.codewords), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                null != a ? r.format("%3d: %3d|%3d%n", n++, a.getRowNumber(), a.getValue()) : r.format("%3d:    |   %n", n++);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
}(), $849102574a83a574$var$Gn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Wn = function(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n, o, i = r.call(t), a = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(n = i.next()).done;)a.push(n.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            n && !n.done && (r = i.return) && r.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}, $849102574a83a574$var$zn = function() {
    function t() {
        this.values = new Map;
    }
    return t.prototype.setValue = function(t) {
        t = Math.trunc(t);
        var e = this.values.get(t);
        null == e && (e = 0), e++, this.values.set(t, e);
    }, t.prototype.getValue = function() {
        var t, e, r = -1, n = new Array, o = function(t, e) {
            var o = function() {
                return t;
            }, i = function() {
                return e;
            };
            i() > r ? (r = i(), (n = []).push(o())) : i() === r && n.push(o());
        };
        try {
            for(var i = $849102574a83a574$var$Gn(this.values.entries()), a = i.next(); !a.done; a = i.next()){
                var s = $849102574a83a574$var$Wn(a.value, 2);
                o(s[0], s[1]);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (e = i.return) && e.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return $849102574a83a574$var$On.toIntArray(n);
    }, t.prototype.getConfidence = function(t) {
        return this.values.get(t);
    }, t;
}(), $849102574a83a574$var$jn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Yn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Zn = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n._isLeft = r, n;
    }
    return $849102574a83a574$var$jn(e, t), e.prototype.setRowNumbers = function() {
        var t, e;
        try {
            for(var r = $849102574a83a574$var$Yn(this.getCodewords()), n = r.next(); !n.done; n = r.next()){
                var o = n.value;
                null != o && o.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
        var e = this.getCodewords();
        this.setRowNumbers(), this.removeIncorrectCodewords(e, t);
        for(var r = this.getBoundingBox(), n = this._isLeft ? r.getTopLeft() : r.getTopRight(), o = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.imageRowToCodewordIndex(Math.trunc(o.getY())), s = -1, u = 1, c = 0, f = i; f < a; f++)if (null != e[f]) {
            var h = e[f], l = h.getRowNumber() - s;
            if (0 === l) c++;
            else if (1 === l) u = Math.max(u, c), c = 1, s = h.getRowNumber();
            else if (l < 0 || h.getRowNumber() >= t.getRowCount() || l > f) e[f] = null;
            else {
                for(var d = void 0, p = (d = u > 2 ? (u - 2) * l : l) >= f, g = 1; g <= d && !p; g++)p = null != e[f - g];
                p ? e[f] = null : (s = h.getRowNumber(), c = 1);
            }
        }
    }, e.prototype.getRowHeights = function() {
        var t, e, r = this.getBarcodeMetadata();
        if (null == r) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(r);
        var n = new Int32Array(r.getRowCount());
        try {
            for(var o = $849102574a83a574$var$Yn(this.getCodewords()), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (null != a) {
                    var s = a.getRowNumber();
                    if (s >= n.length) continue;
                    n[s]++;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
        for(var e = this.getBoundingBox(), r = this._isLeft ? e.getTopLeft() : e.getTopRight(), n = this._isLeft ? e.getBottomLeft() : e.getBottomRight(), o = this.imageRowToCodewordIndex(Math.trunc(r.getY())), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.getCodewords(), s = -1, u = o; u < i; u++)if (null != a[u]) {
            var c = a[u];
            c.setRowNumberAsRowIndicatorColumn();
            var f = c.getRowNumber() - s;
            0 === f || (1 === f ? s = c.getRowNumber() : c.getRowNumber() >= t.getRowCount() ? a[u] = null : s = c.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
        var t, e, r = this.getCodewords(), n = new $849102574a83a574$var$zn, o = new $849102574a83a574$var$zn, i = new $849102574a83a574$var$zn, a = new $849102574a83a574$var$zn;
        try {
            for(var s = $849102574a83a574$var$Yn(r), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if (null != c) {
                    c.setRowNumberAsRowIndicatorColumn();
                    var f = c.getValue() % 30, h = c.getRowNumber();
                    switch(this._isLeft || (h += 2), h % 3){
                        case 0:
                            o.setValue(3 * f + 1);
                            break;
                        case 1:
                            a.setValue(f / 3), i.setValue(f % 3);
                            break;
                        case 2:
                            n.setValue(f + 1);
                    }
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                u && !u.done && (e = s.return) && e.call(s);
            } finally{
                if (t) throw t.error;
            }
        }
        if (0 === n.getValue().length || 0 === o.getValue().length || 0 === i.getValue().length || 0 === a.getValue().length || n.getValue()[0] < 1 || o.getValue()[0] + i.getValue()[0] < $849102574a83a574$var$On.MIN_ROWS_IN_BARCODE || o.getValue()[0] + i.getValue()[0] > $849102574a83a574$var$On.MAX_ROWS_IN_BARCODE) return null;
        var l = new $849102574a83a574$var$Vn(n.getValue()[0], o.getValue()[0], i.getValue()[0], a.getValue()[0]);
        return this.removeIncorrectCodewords(r, l), l;
    }, e.prototype.removeIncorrectCodewords = function(t, e) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            if (null != t[r]) {
                var o = n.getValue() % 30, i = n.getRowNumber();
                if (i > e.getRowCount()) t[r] = null;
                else switch(this._isLeft || (i += 2), i % 3){
                    case 0:
                        3 * o + 1 !== e.getRowCountUpperPart() && (t[r] = null);
                        break;
                    case 1:
                        Math.trunc(o / 3) === e.getErrorCorrectionLevel() && o % 3 === e.getRowCountLowerPart() || (t[r] = null);
                        break;
                    case 2:
                        o + 1 !== e.getColumnCount() && (t[r] = null);
                }
            }
        }
    }, e.prototype.isLeft = function() {
        return this._isLeft;
    }, e.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + t.prototype.toString.call(this);
    }, e;
}($849102574a83a574$var$Xn), $849102574a83a574$var$Kn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$qn = function() {
    function t(t, e) {
        this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = t, this.barcodeColumnCount = t.getColumnCount(), this.boundingBox = e, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var t, e = $849102574a83a574$var$On.MAX_CODEWORDS_IN_BARCODE;
        do t = e, e = this.adjustRowNumbersAndGetCount();
        while (e > 0 && e < t);
        return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(t) {
        null != t && t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
        var t = this.adjustRowNumbersByRow();
        if (0 === t) return 0;
        for(var e = 1; e < this.barcodeColumnCount + 1; e++)for(var r = this.detectionResultColumns[e].getCodewords(), n = 0; n < r.length; n++)null != r[n] && (r[n].hasValidRowNumber() || this.adjustRowNumbers(e, n, r));
        return t;
    }, t.prototype.adjustRowNumbersByRow = function() {
        return this.adjustRowNumbersFromBothRI(), this.adjustRowNumbersFromLRI() + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
        if (null != this.detectionResultColumns[0] && null != this.detectionResultColumns[this.barcodeColumnCount + 1]) {
            for(var t = this.detectionResultColumns[0].getCodewords(), e = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < t.length; r++)if (null != t[r] && null != e[r] && t[r].getRowNumber() === e[r].getRowNumber()) for(var n = 1; n <= this.barcodeColumnCount; n++){
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o && (o.setRowNumber(t[r].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[n].getCodewords()[r] = null));
            }
        }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
        if (null == this.detectionResultColumns[this.barcodeColumnCount + 1]) return 0;
        for(var e = 0, r = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = this.barcodeColumnCount + 1; a > 0 && i < this.ADJUST_ROW_NUMBER_SKIP; a--){
            var s = this.detectionResultColumns[a].getCodewords()[n];
            null != s && (i = t.adjustRowNumberIfValid(o, i, s), s.hasValidRowNumber() || e++);
        }
        return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
        if (null == this.detectionResultColumns[0]) return 0;
        for(var e = 0, r = this.detectionResultColumns[0].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = 1; a < this.barcodeColumnCount + 1 && i < this.ADJUST_ROW_NUMBER_SKIP; a++){
            var s = this.detectionResultColumns[a].getCodewords()[n];
            null != s && (i = t.adjustRowNumberIfValid(o, i, s), s.hasValidRowNumber() || e++);
        }
        return e;
    }, t.adjustRowNumberIfValid = function(t, e, r) {
        return null == r || r.hasValidRowNumber() || (r.isValidRowNumber(t) ? (r.setRowNumber(t), e = 0) : ++e), e;
    }, t.prototype.adjustRowNumbers = function(e, r, n) {
        var o, i;
        if (null != this.detectionResultColumns[e - 1]) {
            var a = n[r], s = this.detectionResultColumns[e - 1].getCodewords(), u = s;
            null != this.detectionResultColumns[e + 1] && (u = this.detectionResultColumns[e + 1].getCodewords());
            var c = new Array(14);
            c[2] = s[r], c[3] = u[r], r > 0 && (c[0] = n[r - 1], c[4] = s[r - 1], c[5] = u[r - 1]), r > 1 && (c[8] = n[r - 2], c[10] = s[r - 2], c[11] = u[r - 2]), r < n.length - 1 && (c[1] = n[r + 1], c[6] = s[r + 1], c[7] = u[r + 1]), r < n.length - 2 && (c[9] = n[r + 2], c[12] = s[r + 2], c[13] = u[r + 2]);
            try {
                for(var f = $849102574a83a574$var$Kn(c), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (t.adjustRowNumber(a, l)) return;
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
        }
    }, t.adjustRowNumber = function(t, e) {
        return null != e && !(!e.hasValidRowNumber() || e.getBucket() !== t.getBucket()) && (t.setRowNumber(e.getRowNumber()), !0);
    }, t.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(t) {
        this.boundingBox = t;
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(t, e) {
        this.detectionResultColumns[t] = e;
    }, t.prototype.getDetectionResultColumn = function(t) {
        return this.detectionResultColumns[t];
    }, t.prototype.toString = function() {
        var t = this.detectionResultColumns[0];
        null == t && (t = this.detectionResultColumns[this.barcodeColumnCount + 1]);
        for(var e = new $849102574a83a574$var$Hn, r = 0; r < t.getCodewords().length; r++){
            e.format("CW %3d:", r);
            for(var n = 0; n < this.barcodeColumnCount + 2; n++)if (null != this.detectionResultColumns[n]) {
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o ? e.format(" %3d|%3d", o.getRowNumber(), o.getValue()) : e.format("    |   ");
            } else e.format("    |   ");
            e.format("%n");
        }
        return e.toString();
    }, t;
}(), $849102574a83a574$var$Qn = function() {
    function t(e, r, n, o) {
        this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(r), this.bucket = Math.trunc(n), this.value = Math.trunc(o);
    }
    return t.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
        return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(3 * Math.trunc(this.value / 30) + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
        return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
        return this.startX;
    }, t.prototype.getEndX = function() {
        return this.endX;
    }, t.prototype.getBucket = function() {
        return this.bucket;
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.setRowNumber = function(t) {
        this.rowNumber = t;
    }, t.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
}(), $849102574a83a574$var$Jn = function() {
    function t() {}
    return t.initialize = function() {
        for(var e = 0; e < $849102574a83a574$var$On.SYMBOL_TABLE.length; e++)for(var r = $849102574a83a574$var$On.SYMBOL_TABLE[e], n = 1 & r, o = 0; o < $849102574a83a574$var$On.BARS_IN_MODULE; o++){
            for(var i = 0; (1 & r) === n;)i += 1, r >>= 1;
            n = 1 & r, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array($849102574a83a574$var$On.BARS_IN_MODULE)), t.RATIOS_TABLE[e][$849102574a83a574$var$On.BARS_IN_MODULE - o - 1] = Math.fround(i / $849102574a83a574$var$On.MODULES_IN_CODEWORD);
        }
        this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
        var r = t.getDecodedCodewordValue(t.sampleBitCounts(e));
        return -1 !== r ? r : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(t) {
        for(var e = $849102574a83a574$var$Pt.sum(t), r = new Int32Array($849102574a83a574$var$On.BARS_IN_MODULE), n = 0, o = 0, i = 0; i < $849102574a83a574$var$On.MODULES_IN_CODEWORD; i++){
            var a = e / (2 * $849102574a83a574$var$On.MODULES_IN_CODEWORD) + i * e / $849102574a83a574$var$On.MODULES_IN_CODEWORD;
            o + t[n] <= a && (o += t[n], n++), r[n]++;
        }
        return r;
    }, t.getDecodedCodewordValue = function(e) {
        var r = t.getBitValue(e);
        return -1 === $849102574a83a574$var$On.getCodeword(r) ? -1 : r;
    }, t.getBitValue = function(t) {
        for(var e = 0, r = 0; r < t.length; r++)for(var n = 0; n < t[r]; n++)e = e << 1 | (r % 2 == 0 ? 1 : 0);
        return Math.trunc(e);
    }, t.getClosestDecodedValue = function(e) {
        var r = $849102574a83a574$var$Pt.sum(e), n = new Array($849102574a83a574$var$On.BARS_IN_MODULE);
        if (r > 1) for(var o = 0; o < n.length; o++)n[o] = Math.fround(e[o] / r);
        var i = $849102574a83a574$var$Bt.MAX_VALUE, a = -1;
        this.bSymbolTableReady || t.initialize();
        for(var s = 0; s < t.RATIOS_TABLE.length; s++){
            for(var u = 0, c = t.RATIOS_TABLE[s], f = 0; f < $849102574a83a574$var$On.BARS_IN_MODULE; f++){
                var h = Math.fround(c[f] - n[f]);
                if ((u += Math.fround(h * h)) >= i) break;
            }
            u < i && (i = u, a = $849102574a83a574$var$On.SYMBOL_TABLE[s]);
        }
        return a;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array($849102574a83a574$var$On.SYMBOL_TABLE.length).map(function(t) {
        return new Array($849102574a83a574$var$On.BARS_IN_MODULE);
    }), t;
}(), $849102574a83a574$var$$n = function() {
    function t() {
        this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(t) {
        this.segmentIndex = t;
    }, t.prototype.getFileId = function() {
        return this.fileId;
    }, t.prototype.setFileId = function(t) {
        this.fileId = t;
    }, t.prototype.getOptionalData = function() {
        return this.optionalData;
    }, t.prototype.setOptionalData = function(t) {
        this.optionalData = t;
    }, t.prototype.isLastSegment = function() {
        return this.lastSegment;
    }, t.prototype.setLastSegment = function(t) {
        this.lastSegment = t;
    }, t.prototype.getSegmentCount = function() {
        return this.segmentCount;
    }, t.prototype.setSegmentCount = function(t) {
        this.segmentCount = t;
    }, t.prototype.getSender = function() {
        return this.sender || null;
    }, t.prototype.setSender = function(t) {
        this.sender = t;
    }, t.prototype.getAddressee = function() {
        return this.addressee || null;
    }, t.prototype.setAddressee = function(t) {
        this.addressee = t;
    }, t.prototype.getFileName = function() {
        return this.fileName;
    }, t.prototype.setFileName = function(t) {
        this.fileName = t;
    }, t.prototype.getFileSize = function() {
        return this.fileSize;
    }, t.prototype.setFileSize = function(t) {
        this.fileSize = t;
    }, t.prototype.getChecksum = function() {
        return this.checksum;
    }, t.prototype.setChecksum = function(t) {
        this.checksum = t;
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.setTimestamp = function(t) {
        this.timestamp = t;
    }, t;
}(), $849102574a83a574$var$to = function() {
    function t() {}
    return t.parseLong = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t;
}(), $849102574a83a574$var$eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ro = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$eo(e, t), e.kind = "NullPointerException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$no = function() {
    function t() {}
    return t.prototype.writeBytes = function(t) {
        this.writeBytesOffset(t, 0, t.length);
    }, t.prototype.writeBytesOffset = function(t, e, r) {
        if (null == t) throw new $849102574a83a574$var$ro;
        if (e < 0 || e > t.length || r < 0 || e + r > t.length || e + r < 0) throw new $849102574a83a574$var$P;
        if (0 !== r) for(var n = 0; n < r; n++)this.write(t[e + n]);
    }, t.prototype.flush = function() {}, t.prototype.close = function() {}, t;
}(), $849102574a83a574$var$oo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$io = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$oo(e, t), e;
}($849102574a83a574$var$m), $849102574a83a574$var$ao = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$so = function(t) {
    function e(e) {
        void 0 === e && (e = 32);
        var r = t.call(this) || this;
        if (r.count = 0, e < 0) throw new $849102574a83a574$var$T("Negative initial size: " + e);
        return r.buf = new Uint8Array(e), r;
    }
    return $849102574a83a574$var$ao(e, t), e.prototype.ensureCapacity = function(t) {
        t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
        var e = this.buf.length << 1;
        if (e - t < 0 && (e = t), e < 0) {
            if (t < 0) throw new $849102574a83a574$var$io;
            e = $849102574a83a574$var$x.MAX_VALUE;
        }
        this.buf = $849102574a83a574$var$k.copyOfUint8Array(this.buf, e);
    }, e.prototype.write = function(t) {
        this.ensureCapacity(this.count + 1), this.buf[this.count] = t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, e, r) {
        if (e < 0 || e > t.length || r < 0 || e + r - t.length > 0) throw new $849102574a83a574$var$P;
        this.ensureCapacity(this.count + r), $849102574a83a574$var$D.arraycopy(t, e, this.buf, this.count, r), this.count += r;
    }, e.prototype.writeTo = function(t) {
        t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
        this.count = 0;
    }, e.prototype.toByteArray = function() {
        return $849102574a83a574$var$k.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
        return this.count;
    }, e.prototype.toString = function(t) {
        return t ? "string" == typeof t ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
        return new String(this.buf).toString();
    }, e.prototype.toString_string = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.toString_number = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.close = function() {}, e;
}($849102574a83a574$var$no);
function $849102574a83a574$var$uo() {
    if ("undefined" != typeof window) return window.BigInt || null;
    if ("undefined" != typeof $parcel$global) return $parcel$global.BigInt || null;
    if ("undefined" != typeof self) return self.BigInt || null;
    throw new Error("Can't search globals for BigInt!");
}
function $849102574a83a574$var$co(t) {
    if (void 0 === $849102574a83a574$var$cn && ($849102574a83a574$var$cn = $849102574a83a574$var$uo()), null === $849102574a83a574$var$cn) throw new Error("BigInt is not supported!");
    return $849102574a83a574$var$cn(t);
}
!function(t) {
    t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
}($849102574a83a574$var$un || ($849102574a83a574$var$un = {}));
var $849102574a83a574$var$fo = function() {
    function t() {}
    return t.decode = function(e, r) {
        var n = new $849102574a83a574$var$Q(""), o = $849102574a83a574$var$j.ISO8859_1;
        n.enableDecoding(o);
        for(var i = 1, a = e[i++], s = new $849102574a83a574$var$$n; i < e[0];){
            switch(a){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    i = t.textCompaction(e, i, n);
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                    i = t.byteCompaction(a, e, o, i, n);
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    n.append(e[i++]);
                    break;
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                    i = t.numericCompaction(e, i, n);
                    break;
                case t.ECI_CHARSET:
                    $849102574a83a574$var$j.getCharacterSetECIByValue(e[i++]);
                    break;
                case t.ECI_GENERAL_PURPOSE:
                    i += 2;
                    break;
                case t.ECI_USER_DEFINED:
                    i++;
                    break;
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    i = t.decodeMacroBlock(e, i, s);
                    break;
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    throw new $849102574a83a574$var$G;
                default:
                    i--, i = t.textCompaction(e, i, n);
            }
            if (!(i < e.length)) throw $849102574a83a574$var$G.getFormatInstance();
            a = e[i++];
        }
        if (0 === n.length()) throw $849102574a83a574$var$G.getFormatInstance();
        var u = new $849102574a83a574$var$At(null, n.toString(), null, r);
        return u.setOther(s), u;
    }, t.decodeMacroBlock = function(e, r, n) {
        if (r + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0]) throw $849102574a83a574$var$G.getFormatInstance();
        for(var o = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), i = 0; i < t.NUMBER_OF_SEQUENCE_CODEWORDS; i++, r++)o[i] = e[r];
        n.setSegmentIndex($849102574a83a574$var$x.parseInt(t.decodeBase900toBase10(o, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var a = new $849102574a83a574$var$Q;
        r = t.textCompaction(e, r, a), n.setFileId(a.toString());
        var s = -1;
        for(e[r] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (s = r + 1); r < e[0];)switch(e[r]){
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                switch(e[++r]){
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var u = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, u), n.setFileName(u.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var c = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, c), n.setSender(c.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var f = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, f), n.setAddressee(f.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var h = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, h), n.setSegmentCount($849102574a83a574$var$x.parseInt(h.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var l = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, l), n.setTimestamp($849102574a83a574$var$to.parseLong(l.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var d = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, d), n.setChecksum($849102574a83a574$var$x.parseInt(d.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var p = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, p), n.setFileSize($849102574a83a574$var$to.parseLong(p.toString()));
                        break;
                    default:
                        throw $849102574a83a574$var$G.getFormatInstance();
                }
                break;
            case t.MACRO_PDF417_TERMINATOR:
                r++, n.setLastSegment(!0);
                break;
            default:
                throw $849102574a83a574$var$G.getFormatInstance();
        }
        if (-1 !== s) {
            var g = r - s;
            n.isLastSegment() && g--, n.setOptionalData($849102574a83a574$var$k.copyOfRange(e, s, s + g));
        }
        return r;
    }, t.textCompaction = function(e, r, n) {
        for(var o = new Int32Array(2 * (e[0] - r)), i = new Int32Array(2 * (e[0] - r)), a = 0, s = !1; r < e[0] && !s;){
            var u = e[r++];
            if (u < t.TEXT_COMPACTION_MODE_LATCH) o[a] = u / 30, o[a + 1] = u % 30, a += 2;
            else switch(u){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    o[a++] = t.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, s = !0;
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    o[a] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, u = e[r++], i[a] = u, a++;
            }
        }
        return t.decodeTextCompaction(o, i, a, n), r;
    }, t.decodeTextCompaction = function(e, r, n, o) {
        for(var i = $849102574a83a574$var$un.ALPHA, a = $849102574a83a574$var$un.ALPHA, s = 0; s < n;){
            var u = e[s], c = "";
            switch(i){
                case $849102574a83a574$var$un.ALPHA:
                    if (u < 26) c = String.fromCharCode(65 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $849102574a83a574$var$un.LOWER;
                            break;
                        case t.ML:
                            i = $849102574a83a574$var$un.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.LOWER:
                    if (u < 26) c = String.fromCharCode(97 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.AS:
                            a = i, i = $849102574a83a574$var$un.ALPHA_SHIFT;
                            break;
                        case t.ML:
                            i = $849102574a83a574$var$un.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.MIXED:
                    if (u < t.PL) c = t.MIXED_CHARS[u];
                    else switch(u){
                        case t.PL:
                            i = $849102574a83a574$var$un.PUNCT;
                            break;
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $849102574a83a574$var$un.LOWER;
                            break;
                        case t.AL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.PUNCT:
                    if (u < t.PAL) c = t.PUNCT_CHARS[u];
                    else switch(u){
                        case t.PAL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.ALPHA_SHIFT:
                    if (i = a, u < 26) c = String.fromCharCode(65 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.PUNCT_SHIFT:
                    if (i = a, u < t.PAL) c = t.PUNCT_CHARS[u];
                    else switch(u){
                        case t.PAL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
            }
            "" !== c && o.append(c), s++;
        }
    }, t.byteCompaction = function(e, r, n, o, i) {
        var a = new $849102574a83a574$var$so, s = 0, u = 0, c = !1;
        switch(e){
            case t.BYTE_COMPACTION_MODE_LATCH:
                for(var f = new Int32Array(6), h = r[o++]; o < r[0] && !c;)switch(f[s++] = h, u = 900 * u + h, h = r[o++]){
                    case t.TEXT_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH:
                    case t.NUMERIC_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH_6:
                    case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case t.MACRO_PDF417_TERMINATOR:
                        o--, c = !0;
                        break;
                    default:
                        if (s % 5 == 0 && s > 0) {
                            for(var l = 0; l < 6; ++l)a.write(Number($849102574a83a574$var$co(u) >> $849102574a83a574$var$co(8 * (5 - l))));
                            u = 0, s = 0;
                        }
                }
                o === r[0] && h < t.TEXT_COMPACTION_MODE_LATCH && (f[s++] = h);
                for(var d = 0; d < s; d++)a.write(f[d]);
                break;
            case t.BYTE_COMPACTION_MODE_LATCH_6:
                for(; o < r[0] && !c;){
                    var p = r[o++];
                    if (p < t.TEXT_COMPACTION_MODE_LATCH) s++, u = 900 * u + p;
                    else switch(p){
                        case t.TEXT_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH:
                        case t.NUMERIC_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH_6:
                        case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case t.MACRO_PDF417_TERMINATOR:
                            o--, c = !0;
                    }
                    if (s % 5 == 0 && s > 0) {
                        for(l = 0; l < 6; ++l)a.write(Number($849102574a83a574$var$co(u) >> $849102574a83a574$var$co(8 * (5 - l))));
                        u = 0, s = 0;
                    }
                }
        }
        return i.append($849102574a83a574$var$K.decode(a.toByteArray(), n)), o;
    }, t.numericCompaction = function(e, r, n) {
        for(var o = 0, i = !1, a = new Int32Array(t.MAX_NUMERIC_CODEWORDS); r < e[0] && !i;){
            var s = e[r++];
            if (r === e[0] && (i = !0), s < t.TEXT_COMPACTION_MODE_LATCH) a[o] = s, o++;
            else switch(s){
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, i = !0;
            }
            (o % t.MAX_NUMERIC_CODEWORDS == 0 || s === t.NUMERIC_COMPACTION_MODE_LATCH || i) && o > 0 && (n.append(t.decodeBase900toBase10(a, o)), o = 0);
        }
        return r;
    }, t.decodeBase900toBase10 = function(e, r) {
        for(var n = $849102574a83a574$var$co(0), o = 0; o < r; o++)n += t.EXP900[r - o - 1] * $849102574a83a574$var$co(e[o]);
        var i = n.toString();
        if ("1" !== i.charAt(0)) throw new $849102574a83a574$var$G;
        return i.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = ";<>@[\\]_`~!\r\t,:\n-.$/\"|*()?{}'", t.MIXED_CHARS = "0123456789&\r\t,:#-.$/+%*=^", t.EXP900 = $849102574a83a574$var$uo() ? function() {
        var t = [];
        t[0] = $849102574a83a574$var$co(1);
        var e = $849102574a83a574$var$co(900);
        t[1] = e;
        for(var r = 2; r < 16; r++)t[r] = t[r - 1] * e;
        return t;
    }() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
}(), $849102574a83a574$var$ho = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$lo = function() {
    function t() {}
    return t.decode = function(e, r, n, o, i, a, s) {
        for(var u, c = new $849102574a83a574$var$xn(e, r, n, o, i), f = null, h = null, l = !0;; l = !1){
            if (null != r && (f = t.getRowIndicatorColumn(e, c, r, !0, a, s)), null != o && (h = t.getRowIndicatorColumn(e, c, o, !1, a, s)), null == (u = t.merge(f, h))) throw $849102574a83a574$var$tt.getNotFoundInstance();
            var d = u.getBoundingBox();
            if (!l || null == d || !(d.getMinY() < c.getMinY() || d.getMaxY() > c.getMaxY())) break;
            c = d;
        }
        u.setBoundingBox(c);
        var p = u.getBarcodeColumnCount() + 1;
        u.setDetectionResultColumn(0, f), u.setDetectionResultColumn(p, h);
        for(var g = null != f, y = 1; y <= p; y++){
            var w = g ? y : p - y;
            if (void 0 === u.getDetectionResultColumn(w)) {
                var v = void 0;
                v = 0 === w || w === p ? new $849102574a83a574$var$Zn(c, 0 === w) : new $849102574a83a574$var$Xn(c), u.setDetectionResultColumn(w, v);
                for(var _ = -1, A = _, C = c.getMinY(); C <= c.getMaxY(); C++){
                    if ((_ = t.getStartColumn(u, w, C, g)) < 0 || _ > c.getMaxX()) {
                        if (-1 === A) continue;
                        _ = A;
                    }
                    var m = t.detectCodeword(e, c.getMinX(), c.getMaxX(), g, _, C, a, s);
                    null != m && (v.setCodeword(C, m), A = _, a = Math.min(a, m.getWidth()), s = Math.max(s, m.getWidth()));
                }
            }
        }
        return t.createDecoderResult(u);
    }, t.merge = function(e, r) {
        if (null == e && null == r) return null;
        var n = t.getBarcodeMetadata(e, r);
        if (null == n) return null;
        var o = $849102574a83a574$var$xn.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(r));
        return new $849102574a83a574$var$qn(n, o);
    }, t.adjustBoundingBox = function(e) {
        var r, n;
        if (null == e) return null;
        var o = e.getRowHeights();
        if (null == o) return null;
        var i = t.getMax(o), a = 0;
        try {
            for(var s = $849102574a83a574$var$ho(o), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if (a += i - c, c > 0) break;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        for(var f = e.getCodewords(), h = 0; a > 0 && null == f[h]; h++)a--;
        var l = 0;
        for(h = o.length - 1; h >= 0 && (l += i - o[h], !(o[h] > 0)); h--);
        for(h = f.length - 1; l > 0 && null == f[h]; h--)l--;
        return e.getBoundingBox().addMissingRows(a, l, e.isLeft());
    }, t.getMax = function(t) {
        var e, r, n = -1;
        try {
            for(var o = $849102574a83a574$var$ho(t), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                n = Math.max(n, a);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.getBarcodeMetadata = function(t, e) {
        var r, n;
        return null == t || null == (r = t.getBarcodeMetadata()) ? null == e ? null : e.getBarcodeMetadata() : null == e || null == (n = e.getBarcodeMetadata()) ? r : r.getColumnCount() !== n.getColumnCount() && r.getErrorCorrectionLevel() !== n.getErrorCorrectionLevel() && r.getRowCount() !== n.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, r, n, o, i, a) {
        for(var s = new $849102574a83a574$var$Zn(r, o), u = 0; u < 2; u++)for(var c = 0 === u ? 1 : -1, f = Math.trunc(Math.trunc(n.getX())), h = Math.trunc(Math.trunc(n.getY())); h <= r.getMaxY() && h >= r.getMinY(); h += c){
            var l = t.detectCodeword(e, 0, e.getWidth(), o, f, h, i, a);
            null != l && (s.setCodeword(h, l), f = o ? l.getStartX() : l.getEndX());
        }
        return s;
    }, t.adjustCodewordCount = function(e, r) {
        var n = r[0][1], o = n.getValue(), i = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
        if (0 === o.length) {
            if (i < 1 || i > $849102574a83a574$var$On.MAX_CODEWORDS_IN_BARCODE) throw $849102574a83a574$var$tt.getNotFoundInstance();
            n.setValue(i);
        } else o[0] !== i && n.setValue(i);
    }, t.createDecoderResult = function(e) {
        var r = t.createBarcodeMatrix(e);
        t.adjustCodewordCount(e, r);
        for(var n = new Array, o = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), i = [], a = new Array, s = 0; s < e.getBarcodeRowCount(); s++)for(var u = 0; u < e.getBarcodeColumnCount(); u++){
            var c = r[s][u + 1].getValue(), f = s * e.getBarcodeColumnCount() + u;
            0 === c.length ? n.push(f) : 1 === c.length ? o[f] = c[0] : (a.push(f), i.push(c));
        }
        for(var h = new Array(i.length), l = 0; l < h.length; l++)h[l] = i[l];
        return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), o, $849102574a83a574$var$On.toIntArray(n), $849102574a83a574$var$On.toIntArray(a), h);
    }, t.createDecoderResultFromAmbiguousValues = function(e, r, n, o, i) {
        for(var a = new Int32Array(o.length), s = 100; s-- > 0;){
            for(var u = 0; u < a.length; u++)r[o[u]] = i[u][a[u]];
            try {
                return t.decodeCodewords(r, e, n);
            } catch (t) {
                if (!(t instanceof $849102574a83a574$var$R)) throw t;
            }
            if (0 === a.length) throw $849102574a83a574$var$R.getChecksumInstance();
            for(u = 0; u < a.length; u++){
                if (a[u] < i[u].length - 1) {
                    a[u]++;
                    break;
                }
                if (a[u] = 0, u === a.length - 1) throw $849102574a83a574$var$R.getChecksumInstance();
            }
        }
        throw $849102574a83a574$var$R.getChecksumInstance();
    }, t.createBarcodeMatrix = function(t) {
        for(var e, r, n, o, i = Array.from({
            length: t.getBarcodeRowCount()
        }, function() {
            return new Array(t.getBarcodeColumnCount() + 2);
        }), a = 0; a < i.length; a++)for(var s = 0; s < i[a].length; s++)i[a][s] = new $849102574a83a574$var$zn;
        var u = 0;
        try {
            for(var c = $849102574a83a574$var$ho(t.getDetectionResultColumns()), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                if (null != h) try {
                    for(var l = (n = void 0, $849102574a83a574$var$ho(h.getCodewords())), d = l.next(); !d.done; d = l.next()){
                        var p = d.value;
                        if (null != p) {
                            var g = p.getRowNumber();
                            if (g >= 0) {
                                if (g >= i.length) continue;
                                i[g][u].setValue(p.getValue());
                            }
                        }
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (o = l.return) && o.call(l);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                u++;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (r = c.return) && r.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.isValidBarcodeColumn = function(t, e) {
        return e >= 0 && e <= t.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, r, n, o) {
        var i, a, s = o ? 1 : -1, u = null;
        if (t.isValidBarcodeColumn(e, r - s) && (u = e.getDetectionResultColumn(r - s).getCodeword(n)), null != u) return o ? u.getEndX() : u.getStartX();
        if (null != (u = e.getDetectionResultColumn(r).getCodewordNearby(n))) return o ? u.getStartX() : u.getEndX();
        if (t.isValidBarcodeColumn(e, r - s) && (u = e.getDetectionResultColumn(r - s).getCodewordNearby(n)), null != u) return o ? u.getEndX() : u.getStartX();
        for(var c = 0; t.isValidBarcodeColumn(e, r - s);){
            r -= s;
            try {
                for(var f = (i = void 0, $849102574a83a574$var$ho(e.getDetectionResultColumn(r).getCodewords())), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (null != l) return (o ? l.getEndX() : l.getStartX()) + s * c * (l.getEndX() - l.getStartX());
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (a = f.return) && a.call(f);
                } finally{
                    if (i) throw i.error;
                }
            }
            c++;
        }
        return o ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, r, n, o, i, a, s, u) {
        i = t.adjustCodewordStartColumn(e, r, n, o, i, a);
        var c, f = t.getModuleBitCount(e, r, n, o, i, a);
        if (null == f) return null;
        var h = $849102574a83a574$var$Pt.sum(f);
        if (o) c = i + h;
        else {
            for(var l = 0; l < f.length / 2; l++){
                var d = f[l];
                f[l] = f[f.length - 1 - l], f[f.length - 1 - l] = d;
            }
            i = (c = i) - h;
        }
        if (!t.checkCodewordSkew(h, s, u)) return null;
        var p = $849102574a83a574$var$Jn.getDecodedValue(f), g = $849102574a83a574$var$On.getCodeword(p);
        return -1 === g ? null : new $849102574a83a574$var$Qn(i, c, t.getCodewordBucketNumber(p), g);
    }, t.getModuleBitCount = function(t, e, r, n, o, i) {
        for(var a = o, s = new Int32Array(8), u = 0, c = n ? 1 : -1, f = n; (n ? a < r : a >= e) && u < s.length;)t.get(a, i) === f ? (s[u]++, a += c) : (u++, f = !f);
        return u === s.length || a === (n ? r : e) && u === s.length - 1 ? s : null;
    }, t.getNumberOfECCodeWords = function(t) {
        return 2 << t;
    }, t.adjustCodewordStartColumn = function(e, r, n, o, i, a) {
        for(var s = i, u = o ? -1 : 1, c = 0; c < 2; c++){
            for(; (o ? s >= r : s < n) && o === e.get(s, a);){
                if (Math.abs(i - s) > t.CODEWORD_SKEW_SIZE) return i;
                s += u;
            }
            u = -u, o = !o;
        }
        return s;
    }, t.checkCodewordSkew = function(e, r, n) {
        return r - t.CODEWORD_SKEW_SIZE <= e && e <= n + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, r, n) {
        if (0 === e.length) throw $849102574a83a574$var$G.getFormatInstance();
        var o = 1 << r + 1, i = t.correctErrors(e, n, o);
        t.verifyCodewordCount(e, o);
        var a = $849102574a83a574$var$fo.decode(e, "" + r);
        return a.setErrorsCorrected(i), a.setErasures(n.length), a;
    }, t.correctErrors = function(e, r, n) {
        if (null != r && r.length > n / 2 + t.MAX_ERRORS || n < 0 || n > t.MAX_EC_CODEWORDS) throw $849102574a83a574$var$R.getChecksumInstance();
        return t.errorCorrection.decode(e, n, r);
    }, t.verifyCodewordCount = function(t, e) {
        if (t.length < 4) throw $849102574a83a574$var$G.getFormatInstance();
        var r = t[0];
        if (r > t.length) throw $849102574a83a574$var$G.getFormatInstance();
        if (0 === r) {
            if (!(e < t.length)) throw $849102574a83a574$var$G.getFormatInstance();
            t[0] = t.length - e;
        }
    }, t.getBitCountForCodeword = function(t) {
        for(var e = new Int32Array(8), r = 0, n = e.length - 1; !((1 & t) !== r && (r = 1 & t, --n < 0));)e[n]++, t >>= 1;
        return e;
    }, t.getCodewordBucketNumber = function(t) {
        return t instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(t) : this.getCodewordBucketNumber_number(t);
    }, t.getCodewordBucketNumber_number = function(e) {
        return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(t) {
        return (t[0] - t[2] + t[4] - t[6] + 9) % 9;
    }, t.toString = function(t) {
        for(var e = new $849102574a83a574$var$Hn, r = 0; r < t.length; r++){
            e.format("Row %2d: ", r);
            for(var n = 0; n < t[r].length; n++){
                var o = t[r][n];
                0 === o.getValue().length ? e.format("        ", null) : e.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
            }
            e.format("%n");
        }
        return e.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new $849102574a83a574$var$kn, t;
}(), $849102574a83a574$var$po = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$go = function() {
    function t() {}
    return t.prototype.decode = function(e, r) {
        void 0 === r && (r = null);
        var n = t.decode(e, r, !1);
        if (null == n || 0 === n.length || null == n[0]) throw $849102574a83a574$var$tt.getNotFoundInstance();
        return n[0];
    }, t.prototype.decodeMultiple = function(e, r) {
        void 0 === r && (r = null);
        try {
            return t.decode(e, r, !0);
        } catch (t) {
            if (t instanceof $849102574a83a574$var$G || t instanceof $849102574a83a574$var$R) throw $849102574a83a574$var$tt.getNotFoundInstance();
            throw t;
        }
    }, t.decode = function(e, r, n) {
        var o, i, a = new Array, s = $849102574a83a574$var$Nn.detectMultiple(e, r, n);
        try {
            for(var u = $849102574a83a574$var$po(s.getPoints()), c = u.next(); !c.done; c = u.next()){
                var f = c.value, h = $849102574a83a574$var$lo.decode(s.getBits(), f[4], f[5], f[6], f[7], t.getMinCodewordWidth(f), t.getMaxCodewordWidth(f)), l = new $849102574a83a574$var$gt(h.getText(), h.getRawBytes(), void 0, f, $849102574a83a574$var$wt.PDF_417);
                l.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, h.getECLevel());
                var d = h.getOther();
                null != d && l.putMetadata($849102574a83a574$var$_t.PDF417_EXTRA_METADATA, d), a.push(l);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (i = u.return) && i.call(u);
            } finally{
                if (o) throw o.error;
            }
        }
        return a.map(function(t) {
            return t;
        });
    }, t.getMaxWidth = function(t, e) {
        return null == t || null == e ? 0 : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMinWidth = function(t, e) {
        return null == t || null == e ? $849102574a83a574$var$x.MAX_VALUE : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMaxCodewordWidth = function(e) {
        return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
        return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {}, t;
}(), $849102574a83a574$var$yo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$wo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$yo(e, t), e.kind = "ReaderException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$vo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$_o = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        return this.setHints(e), this.decodeInternal(t);
    }, t.prototype.decodeWithState = function(t) {
        return null !== this.readers && void 0 !== this.readers || this.setHints(null), this.decodeInternal(t);
    }, t.prototype.setHints = function(t) {
        this.hints = t;
        var e = null != t && void 0 !== t.get($849102574a83a574$var$U.TRY_HARDER), r = null == t ? null : t.get($849102574a83a574$var$U.POSSIBLE_FORMATS), n = new Array;
        if (null != r) {
            var o = r.some(function(t) {
                return t === $849102574a83a574$var$wt.UPC_A || t === $849102574a83a574$var$wt.UPC_E || t === $849102574a83a574$var$wt.EAN_13 || t === $849102574a83a574$var$wt.EAN_8 || t === $849102574a83a574$var$wt.CODABAR || t === $849102574a83a574$var$wt.CODE_39 || t === $849102574a83a574$var$wt.CODE_93 || t === $849102574a83a574$var$wt.CODE_128 || t === $849102574a83a574$var$wt.ITF || t === $849102574a83a574$var$wt.RSS_14 || t === $849102574a83a574$var$wt.RSS_EXPANDED;
            });
            o && !e && n.push(new $849102574a83a574$var$Rr(t)), r.includes($849102574a83a574$var$wt.QR_CODE) && n.push(new $849102574a83a574$var$Sn), r.includes($849102574a83a574$var$wt.DATA_MATRIX) && n.push(new $849102574a83a574$var$zr), r.includes($849102574a83a574$var$wt.AZTEC) && n.push(new $849102574a83a574$var$Yt), r.includes($849102574a83a574$var$wt.PDF_417) && n.push(new $849102574a83a574$var$go), o && e && n.push(new $849102574a83a574$var$Rr(t));
        }
        0 === n.length && (e || n.push(new $849102574a83a574$var$Rr(t)), n.push(new $849102574a83a574$var$Sn), n.push(new $849102574a83a574$var$zr), n.push(new $849102574a83a574$var$Yt), n.push(new $849102574a83a574$var$go), e && n.push(new $849102574a83a574$var$Rr(t))), this.readers = n;
    }, t.prototype.reset = function() {
        var t, e;
        if (null !== this.readers) try {
            for(var r = $849102574a83a574$var$vo(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype.decodeInternal = function(t) {
        var e, r;
        if (null === this.readers) throw new $849102574a83a574$var$wo("No readers where selected, nothing can be read.");
        try {
            for(var n = $849102574a83a574$var$vo(this.readers), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                try {
                    return i.decode(t, this.hints);
                } catch (t) {
                    if (t instanceof $849102574a83a574$var$wo) continue;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
        throw new $849102574a83a574$var$tt("No MultiFormat Readers were able to detect the code.");
    }, t;
}(), $849102574a83a574$var$Ao = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Co = function(t) {
    function e(e, r) {
        void 0 === e && (e = null), void 0 === r && (r = 500);
        var n = new $849102574a83a574$var$_o;
        return n.setHints(e), t.call(this, n, r) || this;
    }
    return $849102574a83a574$var$Ao(e, t), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    }, e;
}($849102574a83a574$var$pt), $849102574a83a574$var$mo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$go, e) || this;
    }
    $849102574a83a574$var$mo(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Eo, $849102574a83a574$var$Io = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Sn, e) || this;
    }
    $849102574a83a574$var$Io(e, t);
}($849102574a83a574$var$pt), function(t) {
    t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.DATA_MATRIX_COMPACT = 3] = "DATA_MATRIX_COMPACT", t[t.MIN_SIZE = 4] = "MIN_SIZE", t[t.MAX_SIZE = 5] = "MAX_SIZE", t[t.MARGIN = 6] = "MARGIN", t[t.PDF417_COMPACT = 7] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 8] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 9] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 10] = "AZTEC_LAYERS", t[t.QR_VERSION = 11] = "QR_VERSION", t[t.GS1_FORMAT = 12] = "GS1_FORMAT", t[t.FORCE_C40 = 13] = "FORCE_C40";
}($849102574a83a574$var$Eo || ($849102574a83a574$var$Eo = {}));
var $849102574a83a574$var$So = $849102574a83a574$var$Eo, $849102574a83a574$var$To = function() {
    function t(t) {
        this.field = t, this.cachedGenerators = [], this.cachedGenerators.push(new $849102574a83a574$var$mt(t, Int32Array.from([
            1
        ])));
    }
    return t.prototype.buildGenerator = function(t) {
        var e = this.cachedGenerators;
        if (t >= e.length) for(var r = e[e.length - 1], n = this.field, o = e.length; o <= t; o++){
            var i = r.multiply(new $849102574a83a574$var$mt(n, Int32Array.from([
                1,
                n.exp(o - 1 + n.getGeneratorBase())
            ])));
            e.push(i), r = i;
        }
        return e[t];
    }, t.prototype.encode = function(t, e) {
        if (0 === e) throw new $849102574a83a574$var$T("No error correction bytes");
        var r = t.length - e;
        if (r <= 0) throw new $849102574a83a574$var$T("No data bytes provided");
        var n = this.buildGenerator(e), o = new Int32Array(r);
        $849102574a83a574$var$D.arraycopy(t, 0, o, 0, r);
        for(var i = new $849102574a83a574$var$mt(this.field, o), a = (i = i.multiplyByMonomial(e, 1)).divide(n)[1].getCoefficients(), s = e - a.length, u = 0; u < s; u++)t[r + u] = 0;
        $849102574a83a574$var$D.arraycopy(a, 0, t, r + s, a.length);
    }, t;
}(), $849102574a83a574$var$Oo = function() {
    function t() {}
    return t.applyMaskPenaltyRule1 = function(e) {
        return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i - 1; a++)for(var s = n[a], u = 0; u < o - 1; u++){
            var c = s[u];
            c === s[u + 1] && c === n[a + 1][u] && c === n[a + 1][u + 1] && r++;
        }
        return t.N2 * r;
    }, t.applyMaskPenaltyRule3 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var s = 0; s < o; s++){
            var u = n[a];
            s + 6 < o && 1 === u[s] && 0 === u[s + 1] && 1 === u[s + 2] && 1 === u[s + 3] && 1 === u[s + 4] && 0 === u[s + 5] && 1 === u[s + 6] && (t.isWhiteHorizontal(u, s - 4, s) || t.isWhiteHorizontal(u, s + 7, s + 11)) && r++, a + 6 < i && 1 === n[a][s] && 0 === n[a + 1][s] && 1 === n[a + 2][s] && 1 === n[a + 3][s] && 1 === n[a + 4][s] && 0 === n[a + 5][s] && 1 === n[a + 6][s] && (t.isWhiteVertical(n, s, a - 4, a) || t.isWhiteVertical(n, s, a + 7, a + 11)) && r++;
        }
        return r * t.N3;
    }, t.isWhiteHorizontal = function(t, e, r) {
        e = Math.max(e, 0), r = Math.min(r, t.length);
        for(var n = e; n < r; n++)if (1 === t[n]) return !1;
        return !0;
    }, t.isWhiteVertical = function(t, e, r, n) {
        r = Math.max(r, 0), n = Math.min(n, t.length);
        for(var o = r; o < n; o++)if (1 === t[o][e]) return !1;
        return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var s = n[a], u = 0; u < o; u++)1 === s[u] && r++;
        var c = e.getHeight() * e.getWidth();
        return Math.floor(10 * Math.abs(2 * r - c) / c) * t.N4;
    }, t.getDataMaskBit = function(t, e, r) {
        var n, o;
        switch(t){
            case 0:
                n = r + e & 1;
                break;
            case 1:
                n = 1 & r;
                break;
            case 2:
                n = e % 3;
                break;
            case 3:
                n = (r + e) % 3;
                break;
            case 4:
                n = Math.floor(r / 2) + Math.floor(e / 3) & 1;
                break;
            case 5:
                n = (1 & (o = r * e)) + o % 3;
                break;
            case 6:
                n = (1 & (o = r * e)) + o % 3 & 1;
                break;
            case 7:
                n = (o = r * e) % 3 + (r + e & 1) & 1;
                break;
            default:
                throw new $849102574a83a574$var$T("Invalid mask pattern: " + t);
        }
        return 0 === n;
    }, t.applyMaskPenaltyRule1Internal = function(e, r) {
        for(var n = 0, o = r ? e.getHeight() : e.getWidth(), i = r ? e.getWidth() : e.getHeight(), a = e.getArray(), s = 0; s < o; s++){
            for(var u = 0, c = -1, f = 0; f < i; f++){
                var h = r ? a[s][f] : a[f][s];
                h === c ? u++ : (u >= 5 && (n += t.N1 + (u - 5)), u = 1, c = h);
            }
            u >= 5 && (n += t.N1 + (u - 5));
        }
        return n;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
}(), $849102574a83a574$var$bo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ro = function() {
    function t(t, e) {
        this.width = t, this.height = e;
        for(var r = new Array(e), n = 0; n !== e; n++)r[n] = new Uint8Array(t);
        this.bytes = r;
    }
    return t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.get = function(t, e) {
        return this.bytes[e][t];
    }, t.prototype.getArray = function() {
        return this.bytes;
    }, t.prototype.setNumber = function(t, e, r) {
        this.bytes[e][t] = r;
    }, t.prototype.setBoolean = function(t, e, r) {
        this.bytes[e][t] = r ? 1 : 0;
    }, t.prototype.clear = function(t) {
        var e, r;
        try {
            for(var n = $849102574a83a574$var$bo(this.bytes), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                $849102574a83a574$var$k.fill(i, t);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        if (this.width !== r.width) return !1;
        if (this.height !== r.height) return !1;
        for(var n = 0, o = this.height; n < o; ++n)for(var i = this.bytes[n], a = r.bytes[n], s = 0, u = this.width; s < u; ++s)if (i[s] !== a[s]) return !1;
        return !0;
    }, t.prototype.toString = function() {
        for(var t = new $849102574a83a574$var$Q, e = 0, r = this.height; e < r; ++e){
            for(var n = this.bytes[e], o = 0, i = this.width; o < i; ++o)switch(n[o]){
                case 0:
                    t.append(" 0");
                    break;
                case 1:
                    t.append(" 1");
                    break;
                default:
                    t.append("  ");
            }
            t.append("\n");
        }
        return t.toString();
    }, t;
}(), $849102574a83a574$var$No = function() {
    function t() {
        this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getVersion = function() {
        return this.version;
    }, t.prototype.getMaskPattern = function() {
        return this.maskPattern;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.toString = function() {
        var t = new $849102574a83a574$var$Q;
        return t.append("<<\n"), t.append(" mode: "), t.append(this.mode ? this.mode.toString() : "null"), t.append("\n ecLevel: "), t.append(this.ecLevel ? this.ecLevel.toString() : "null"), t.append("\n version: "), t.append(this.version ? this.version.toString() : "null"), t.append("\n maskPattern: "), t.append(this.maskPattern.toString()), this.matrix ? (t.append("\n matrix:\n"), t.append(this.matrix.toString())) : t.append("\n matrix: null\n"), t.append(">>\n"), t.toString();
    }, t.prototype.setMode = function(t) {
        this.mode = t;
    }, t.prototype.setECLevel = function(t) {
        this.ecLevel = t;
    }, t.prototype.setVersion = function(t) {
        this.version = t;
    }, t.prototype.setMaskPattern = function(t) {
        this.maskPattern = t;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t.isValidMaskPattern = function(e) {
        return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
}(), $849102574a83a574$var$Do = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Mo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Do(e, t), e.kind = "WriterException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Po = function() {
    function t() {}
    return t.clearMatrix = function(t) {
        t.clear(255);
    }, t.buildMatrix = function(e, r, n, o, i) {
        t.clearMatrix(i), t.embedBasicPatterns(n, i), t.embedTypeInfo(r, o, i), t.maybeEmbedVersionInfo(n, i), t.embedDataBits(e, o, i);
    }, t.embedBasicPatterns = function(e, r) {
        t.embedPositionDetectionPatternsAndSeparators(r), t.embedDarkDotAtLeftBottomCorner(r), t.maybeEmbedPositionAdjustmentPatterns(e, r), t.embedTimingPatterns(r);
    }, t.embedTypeInfo = function(e, r, n) {
        var o = new $849102574a83a574$var$V;
        t.makeTypeInfoBits(e, r, o);
        for(var i = 0, a = o.getSize(); i < a; ++i){
            var s = o.get(o.getSize() - 1 - i), u = t.TYPE_INFO_COORDINATES[i], c = u[0], f = u[1];
            if (n.setBoolean(c, f, s), i < 8) {
                var h = n.getWidth() - i - 1, l = 8;
                n.setBoolean(h, l, s);
            } else {
                h = 8, l = n.getHeight() - 7 + (i - 8);
                n.setBoolean(h, l, s);
            }
        }
    }, t.maybeEmbedVersionInfo = function(e, r) {
        if (!(e.getVersionNumber() < 7)) {
            var n = new $849102574a83a574$var$V;
            t.makeVersionInfoBits(e, n);
            for(var o = 17, i = 0; i < 6; ++i)for(var a = 0; a < 3; ++a){
                var s = n.get(o);
                o--, r.setBoolean(i, r.getHeight() - 11 + a, s), r.setBoolean(r.getHeight() - 11 + a, i, s);
            }
        }
    }, t.embedDataBits = function(e, r, n) {
        for(var o = 0, i = -1, a = n.getWidth() - 1, s = n.getHeight() - 1; a > 0;){
            for(6 === a && (a -= 1); s >= 0 && s < n.getHeight();){
                for(var u = 0; u < 2; ++u){
                    var c = a - u;
                    if (t.isEmpty(n.get(c, s))) {
                        var f = void 0;
                        o < e.getSize() ? (f = e.get(o), ++o) : f = !1, 255 !== r && $849102574a83a574$var$Oo.getDataMaskBit(r, c, s) && (f = !f), n.setBoolean(c, s, f);
                    }
                }
                s += i;
            }
            s += i = -i, a -= 2;
        }
        if (o !== e.getSize()) throw new $849102574a83a574$var$Mo("Not all bits consumed: " + o + "/" + e.getSize());
    }, t.findMSBSet = function(t) {
        return 32 - $849102574a83a574$var$x.numberOfLeadingZeros(t);
    }, t.calculateBCHCode = function(e, r) {
        if (0 === r) throw new $849102574a83a574$var$T("0 polynomial");
        var n = t.findMSBSet(r);
        for(e <<= n - 1; t.findMSBSet(e) >= n;)e ^= r << t.findMSBSet(e) - n;
        return e;
    }, t.makeTypeInfoBits = function(e, r, n) {
        if (!$849102574a83a574$var$No.isValidMaskPattern(r)) throw new $849102574a83a574$var$Mo("Invalid mask pattern");
        var o = e.getBits() << 3 | r;
        n.appendBits(o, 5);
        var i = t.calculateBCHCode(o, t.TYPE_INFO_POLY);
        n.appendBits(i, 10);
        var a = new $849102574a83a574$var$V;
        if (a.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), 15 !== n.getSize()) throw new $849102574a83a574$var$Mo("should not happen but we got: " + n.getSize());
    }, t.makeVersionInfoBits = function(e, r) {
        r.appendBits(e.getVersionNumber(), 6);
        var n = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
        if (r.appendBits(n, 12), 18 !== r.getSize()) throw new $849102574a83a574$var$Mo("should not happen but we got: " + r.getSize());
    }, t.isEmpty = function(t) {
        return 255 === t;
    }, t.embedTimingPatterns = function(e) {
        for(var r = 8; r < e.getWidth() - 8; ++r){
            var n = (r + 1) % 2;
            t.isEmpty(e.get(r, 6)) && e.setNumber(r, 6, n), t.isEmpty(e.get(6, r)) && e.setNumber(6, r, n);
        }
    }, t.embedDarkDotAtLeftBottomCorner = function(t) {
        if (0 === t.get(8, t.getHeight() - 8)) throw new $849102574a83a574$var$Mo;
        t.setNumber(8, t.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 8; ++o){
            if (!t.isEmpty(n.get(e + o, r))) throw new $849102574a83a574$var$Mo;
            n.setNumber(e + o, r, 0);
        }
    }, t.embedVerticalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o){
            if (!t.isEmpty(n.get(e, r + o))) throw new $849102574a83a574$var$Mo;
            n.setNumber(e, r + o, 0);
        }
    }, t.embedPositionAdjustmentPattern = function(e, r, n) {
        for(var o = 0; o < 5; ++o)for(var i = t.POSITION_ADJUSTMENT_PATTERN[o], a = 0; a < 5; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o)for(var i = t.POSITION_DETECTION_PATTERN[o], a = 0; a < 7; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
        var r = t.POSITION_DETECTION_PATTERN[0].length;
        t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - r, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - r, e);
        t.embedHorizontalSeparationPattern(0, 7, e), t.embedHorizontalSeparationPattern(e.getWidth() - 8, 7, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - 8, e);
        t.embedVerticalSeparationPattern(7, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - 7 - 1, 0, e), t.embedVerticalSeparationPattern(7, e.getHeight() - 7, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, r) {
        if (!(e.getVersionNumber() < 2)) for(var n = e.getVersionNumber() - 1, o = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], i = 0, a = o.length; i !== a; i++){
            var s = o[i];
            if (s >= 0) for(var u = 0; u !== a; u++){
                var c = o[u];
                c >= 0 && t.isEmpty(r.get(c, s)) && t.embedPositionAdjustmentPattern(c - 2, s - 2, r);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
}(), $849102574a83a574$var$Bo = function() {
    function t(t, e) {
        this.dataBytes = t, this.errorCorrectionBytes = e;
    }
    return t.prototype.getDataBytes = function() {
        return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    }, t;
}(), $849102574a83a574$var$Lo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.calculateMaskPenalty = function(t) {
        return $849102574a83a574$var$Oo.applyMaskPenaltyRule1(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule2(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule3(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule4(t);
    }, t.encode = function(e, r, n) {
        void 0 === n && (n = null);
        var o = t.DEFAULT_BYTE_MODE_ENCODING, i = null !== n && void 0 !== n.get($849102574a83a574$var$So.CHARACTER_SET);
        i && (o = n.get($849102574a83a574$var$So.CHARACTER_SET).toString());
        var a = this.chooseMode(e, o), s = new $849102574a83a574$var$V;
        if (a === $849102574a83a574$var$fn.BYTE && (i || t.DEFAULT_BYTE_MODE_ENCODING !== o)) {
            var u = $849102574a83a574$var$j.getCharacterSetECIByName(o);
            void 0 !== u && this.appendECI(u, s);
        }
        this.appendModeInfo(a, s);
        var c, f = new $849102574a83a574$var$V;
        if (this.appendBytes(e, a, f, o), null !== n && void 0 !== n.get($849102574a83a574$var$So.QR_VERSION)) {
            var h = Number.parseInt(n.get($849102574a83a574$var$So.QR_VERSION).toString(), 10);
            c = $849102574a83a574$var$en.getVersionForNumber(h);
            var l = this.calculateBitsNeeded(a, s, f, c);
            if (!this.willFit(l, c, r)) throw new $849102574a83a574$var$Mo("Data too big for requested version");
        } else c = this.recommendVersion(r, a, s, f);
        var d = new $849102574a83a574$var$V;
        d.appendBitArray(s);
        var p = a === $849102574a83a574$var$fn.BYTE ? f.getSizeInBytes() : e.length;
        this.appendLengthInfo(p, c, a, d), d.appendBitArray(f);
        var g = c.getECBlocksForLevel(r), y = c.getTotalCodewords() - g.getTotalECCodewords();
        this.terminateBits(y, d);
        var w = this.interleaveWithECBytes(d, c.getTotalCodewords(), y, g.getNumBlocks()), v = new $849102574a83a574$var$No;
        v.setECLevel(r), v.setMode(a), v.setVersion(c);
        var _ = c.getDimensionForVersion(), A = new $849102574a83a574$var$Ro(_, _), C = this.chooseMaskPattern(w, r, c, A);
        return v.setMaskPattern(C), $849102574a83a574$var$Po.buildMatrix(w, r, c, C, A), v.setMatrix(A), v;
    }, t.recommendVersion = function(t, e, r, n) {
        var o = this.calculateBitsNeeded(e, r, n, $849102574a83a574$var$en.getVersionForNumber(1)), i = this.chooseVersion(o, t), a = this.calculateBitsNeeded(e, r, n, i);
        return this.chooseVersion(a, t);
    }, t.calculateBitsNeeded = function(t, e, r, n) {
        return e.getSize() + t.getCharacterCountBits(n) + r.getSize();
    }, t.getAlphanumericCode = function(e) {
        return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
    }, t.chooseMode = function(e, r) {
        if (void 0 === r && (r = null), $849102574a83a574$var$j.SJIS.getName() === r && this.isOnlyDoubleByteKanji(e)) return $849102574a83a574$var$fn.KANJI;
        for(var n = !1, o = !1, i = 0, a = e.length; i < a; ++i){
            var s = e.charAt(i);
            if (t.isDigit(s)) n = !0;
            else {
                if (-1 === this.getAlphanumericCode(s.charCodeAt(0))) return $849102574a83a574$var$fn.BYTE;
                o = !0;
            }
        }
        return o ? $849102574a83a574$var$fn.ALPHANUMERIC : n ? $849102574a83a574$var$fn.NUMERIC : $849102574a83a574$var$fn.BYTE;
    }, t.isOnlyDoubleByteKanji = function(t) {
        var e;
        try {
            e = $849102574a83a574$var$K.encode(t, $849102574a83a574$var$j.SJIS);
        } catch (t) {
            return !1;
        }
        var r = e.length;
        if (r % 2 != 0) return !1;
        for(var n = 0; n < r; n += 2){
            var o = 255 & e[n];
            if ((o < 129 || o > 159) && (o < 224 || o > 235)) return !1;
        }
        return !0;
    }, t.chooseMaskPattern = function(t, e, r, n) {
        for(var o = Number.MAX_SAFE_INTEGER, i = -1, a = 0; a < $849102574a83a574$var$No.NUM_MASK_PATTERNS; a++){
            $849102574a83a574$var$Po.buildMatrix(t, e, r, a, n);
            var s = this.calculateMaskPenalty(n);
            s < o && (o = s, i = a);
        }
        return i;
    }, t.chooseVersion = function(e, r) {
        for(var n = 1; n <= 40; n++){
            var o = $849102574a83a574$var$en.getVersionForNumber(n);
            if (t.willFit(e, o, r)) return o;
        }
        throw new $849102574a83a574$var$Mo("Data too big");
    }, t.willFit = function(t, e, r) {
        return e.getTotalCodewords() - e.getECBlocksForLevel(r).getTotalECCodewords() >= (t + 7) / 8;
    }, t.terminateBits = function(t, e) {
        var r = 8 * t;
        if (e.getSize() > r) throw new $849102574a83a574$var$Mo("data bits cannot fit in the QR Code" + e.getSize() + " > " + r);
        for(var n = 0; n < 4 && e.getSize() < r; ++n)e.appendBit(!1);
        var o = 7 & e.getSize();
        if (o > 0) for(n = o; n < 8; n++)e.appendBit(!1);
        var i = t - e.getSizeInBytes();
        for(n = 0; n < i; ++n)e.appendBits(0 == (1 & n) ? 236 : 17, 8);
        if (e.getSize() !== r) throw new $849102574a83a574$var$Mo("Bits size does not equal capacity");
    }, t.getNumDataBytesAndNumECBytesForBlockID = function(t, e, r, n, o, i) {
        if (n >= r) throw new $849102574a83a574$var$Mo("Block ID too large");
        var a = t % r, s = r - a, u = Math.floor(t / r), c = u + 1, f = Math.floor(e / r), h = f + 1, l = u - f, d = c - h;
        if (l !== d) throw new $849102574a83a574$var$Mo("EC bytes mismatch");
        if (r !== s + a) throw new $849102574a83a574$var$Mo("RS blocks mismatch");
        if (t !== (f + l) * s + (h + d) * a) throw new $849102574a83a574$var$Mo("Total bytes mismatch");
        n < s ? (o[0] = f, i[0] = l) : (o[0] = h, i[0] = d);
    }, t.interleaveWithECBytes = function(e, r, n, o) {
        var i, a, s, u;
        if (e.getSizeInBytes() !== n) throw new $849102574a83a574$var$Mo("Number of bits and data bytes does not match");
        for(var c = 0, f = 0, h = 0, l = new Array, d = 0; d < o; ++d){
            var p = new Int32Array(1), g = new Int32Array(1);
            t.getNumDataBytesAndNumECBytesForBlockID(r, n, o, d, p, g);
            var y = p[0], w = new Uint8Array(y);
            e.toBytes(8 * c, w, 0, y);
            var v = t.generateECBytes(w, g[0]);
            l.push(new $849102574a83a574$var$Bo(w, v)), f = Math.max(f, y), h = Math.max(h, v.length), c += p[0];
        }
        if (n !== c) throw new $849102574a83a574$var$Mo("Data bytes does not match offset");
        var _ = new $849102574a83a574$var$V;
        for(d = 0; d < f; ++d)try {
            for(var A = (i = void 0, $849102574a83a574$var$Lo(l)), C = A.next(); !C.done; C = A.next())d < (w = C.value.getDataBytes()).length && _.appendBits(w[d], 8);
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                C && !C.done && (a = A.return) && a.call(A);
            } finally{
                if (i) throw i.error;
            }
        }
        for(d = 0; d < h; ++d)try {
            for(var m = (s = void 0, $849102574a83a574$var$Lo(l)), E = m.next(); !E.done; E = m.next())d < (v = E.value.getErrorCorrectionBytes()).length && _.appendBits(v[d], 8);
        } catch (t) {
            s = {
                error: t
            };
        } finally{
            try {
                E && !E.done && (u = m.return) && u.call(m);
            } finally{
                if (s) throw s.error;
            }
        }
        if (r !== _.getSizeInBytes()) throw new $849102574a83a574$var$Mo("Interleaving error: " + r + " and " + _.getSizeInBytes() + " differ.");
        return _;
    }, t.generateECBytes = function(t, e) {
        for(var r = t.length, n = new Int32Array(r + e), o = 0; o < r; o++)n[o] = 255 & t[o];
        new $849102574a83a574$var$To($849102574a83a574$var$Tt.QR_CODE_FIELD_256).encode(n, e);
        var i = new Uint8Array(e);
        for(o = 0; o < e; o++)i[o] = n[r + o];
        return i;
    }, t.appendModeInfo = function(t, e) {
        e.appendBits(t.getBits(), 4);
    }, t.appendLengthInfo = function(t, e, r, n) {
        var o = r.getCharacterCountBits(e);
        if (t >= 1 << o) throw new $849102574a83a574$var$Mo(t + " is bigger than " + ((1 << o) - 1));
        n.appendBits(t, o);
    }, t.appendBytes = function(e, r, n, o) {
        switch(r){
            case $849102574a83a574$var$fn.NUMERIC:
                t.appendNumericBytes(e, n);
                break;
            case $849102574a83a574$var$fn.ALPHANUMERIC:
                t.appendAlphanumericBytes(e, n);
                break;
            case $849102574a83a574$var$fn.BYTE:
                t.append8BitBytes(e, n, o);
                break;
            case $849102574a83a574$var$fn.KANJI:
                t.appendKanjiBytes(e, n);
                break;
            default:
                throw new $849102574a83a574$var$Mo("Invalid mode: " + r);
        }
    }, t.getDigit = function(t) {
        return t.charCodeAt(0) - 48;
    }, t.isDigit = function(e) {
        var r = t.getDigit(e);
        return r >= 0 && r <= 9;
    }, t.appendNumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getDigit(e.charAt(o));
            if (o + 2 < n) {
                var a = t.getDigit(e.charAt(o + 1)), s = t.getDigit(e.charAt(o + 2));
                r.appendBits(100 * i + 10 * a + s, 10), o += 3;
            } else if (o + 1 < n) {
                a = t.getDigit(e.charAt(o + 1));
                r.appendBits(10 * i + a, 7), o += 2;
            } else r.appendBits(i, 4), o++;
        }
    }, t.appendAlphanumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getAlphanumericCode(e.charCodeAt(o));
            if (-1 === i) throw new $849102574a83a574$var$Mo;
            if (o + 1 < n) {
                var a = t.getAlphanumericCode(e.charCodeAt(o + 1));
                if (-1 === a) throw new $849102574a83a574$var$Mo;
                r.appendBits(45 * i + a, 11), o += 2;
            } else r.appendBits(i, 6), o++;
        }
    }, t.append8BitBytes = function(t, e, r) {
        var n;
        try {
            n = $849102574a83a574$var$K.encode(t, r);
        } catch (t) {
            throw new $849102574a83a574$var$Mo(t);
        }
        for(var o = 0, i = n.length; o !== i; o++){
            var a = n[o];
            e.appendBits(a, 8);
        }
    }, t.appendKanjiBytes = function(t, e) {
        var r;
        try {
            r = $849102574a83a574$var$K.encode(t, $849102574a83a574$var$j.SJIS);
        } catch (t) {
            throw new $849102574a83a574$var$Mo(t);
        }
        for(var n = r.length, o = 0; o < n; o += 2){
            var i = (255 & r[o]) << 8 & 4294967295 | 255 & r[o + 1], a = -1;
            if (i >= 33088 && i <= 40956 ? a = i - 33088 : i >= 57408 && i <= 60351 && (a = i - 49472), -1 === a) throw new $849102574a83a574$var$Mo("Invalid byte sequence");
            var s = 192 * (a >> 8) + (255 & a);
            e.appendBits(s, 13);
        }
    }, t.appendECI = function(t, e) {
        e.appendBits($849102574a83a574$var$fn.ECI.getBits(), 4), e.appendBits(t.getValue(), 8);
    }, t.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]), t.DEFAULT_BYTE_MODE_ENCODING = $849102574a83a574$var$j.UTF8.getName();
}();
var $849102574a83a574$var$Fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, s, u) {
        var c = t.call(this, a, s) || this;
        if (c.yuvData = e, c.dataWidth = r, c.dataHeight = n, c.left = o, c.top = i, o + a > r || i + s > n) throw new $849102574a83a574$var$T("Crop rectangle does not fit within image data.");
        return u && c.reverseHorizontal(a, s), c;
    }
    $849102574a83a574$var$Fo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $849102574a83a574$var$D.arraycopy(this.yuvData, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.yuvData;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $849102574a83a574$var$D.arraycopy(this.yuvData, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $849102574a83a574$var$D.arraycopy(this.yuvData, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + r, n, o, !1);
    }, e.prototype.renderThumbnail = function() {
        for(var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, n = new Int32Array(t * r), o = this.yuvData, i = this.top * this.dataWidth + this.left, a = 0; a < r; a++){
            for(var s = a * t, u = 0; u < t; u++){
                var c = 255 & o[i + u * e.THUMBNAIL_SCALE_FACTOR];
                n[s + u] = 4278190080 | 65793 * c;
            }
            i += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
        }
        return n;
    }, e.prototype.getThumbnailWidth = function() {
        return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.getThumbnailHeight = function() {
        return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.reverseHorizontal = function(t, e) {
        for(var r = this.yuvData, n = 0, o = this.top * this.dataWidth + this.left; n < e; n++, o += this.dataWidth)for(var i = o + t / 2, a = o, s = o + t - 1; a < i; a++, s--){
            var u = r[a];
            r[a] = r[s], r[s] = u;
        }
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    }, e.THUMBNAIL_SCALE_FACTOR = 2;
}($849102574a83a574$var$it);
var $849102574a83a574$var$ko = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, s) {
        var u = t.call(this, r, n) || this;
        if (u.dataWidth = o, u.dataHeight = i, u.left = a, u.top = s, 4 === e.BYTES_PER_ELEMENT) {
            for(var c = r * n, f = new Uint8ClampedArray(c), h = 0; h < c; h++){
                var l = e[h], d = l >> 16 & 255, p = l >> 7 & 510, g = 255 & l;
                f[h] = (d + p + g) / 4 & 255;
            }
            u.luminances = f;
        } else u.luminances = e;
        if (void 0 === o && (u.dataWidth = r), void 0 === i && (u.dataHeight = n), void 0 === a && (u.left = 0), void 0 === s && (u.top = 0), u.left + r > u.dataWidth || u.top + n > u.dataHeight) throw new $849102574a83a574$var$T("Crop rectangle does not fit within image data.");
        return u;
    }
    $849102574a83a574$var$ko(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $849102574a83a574$var$D.arraycopy(this.luminances, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.luminances;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $849102574a83a574$var$D.arraycopy(this.luminances, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $849102574a83a574$var$D.arraycopy(this.luminances, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.luminances, n, o, this.dataWidth, this.dataHeight, this.left + t, this.top + r);
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    };
}($849102574a83a574$var$it);
var $849102574a83a574$var$xo, $849102574a83a574$var$Vo, $849102574a83a574$var$Ho = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Uo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Ho(e, t), e.forName = function(t) {
        return this.getCharacterSetECIByName(t);
    }, e;
}($849102574a83a574$var$j), $849102574a83a574$var$Xo = function() {
    function t() {}
    return t.ISO_8859_1 = $849102574a83a574$var$j.ISO8859_1, t;
}();
($849102574a83a574$var$xo = function(t, e) {
    for(var r = 1, n = 0; n < 255; n++)e[n] = r, t[r] = n, (r *= 2) >= 256 && (r ^= 301);
    return {
        LOG: t,
        ALOG: e
    };
}([], [])).LOG, $849102574a83a574$var$xo.ALOG, function(t) {
    t[t.FORCE_NONE = 0] = "FORCE_NONE", t[t.FORCE_SQUARE = 1] = "FORCE_SQUARE", t[t.FORCE_RECTANGLE = 2] = "FORCE_RECTANGLE";
}($849102574a83a574$var$Vo || ($849102574a83a574$var$Vo = {}));
var $849102574a83a574$var$Go, $849102574a83a574$var$Wo = "[)>05", $849102574a83a574$var$zo = "[)>06", $849102574a83a574$var$jo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 0;
    }, t.prototype.encode = function(t) {
        if ($849102574a83a574$var$si.determineConsecutiveDigitCount(t.getMessage(), t.pos) >= 2) t.writeCodeword(this.encodeASCIIDigits(t.getMessage().charCodeAt(t.pos), t.getMessage().charCodeAt(t.pos + 1))), t.pos += 2;
        else {
            var e = t.getCurrentChar(), r = $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode());
            if (r !== this.getEncodingMode()) switch(r){
                case 5:
                    return t.writeCodeword(231), void t.signalEncoderChange(5);
                case 1:
                    return t.writeCodeword(230), void t.signalEncoderChange(1);
                case 3:
                    t.writeCodeword(238), t.signalEncoderChange(3);
                    break;
                case 2:
                    t.writeCodeword(239), t.signalEncoderChange(2);
                    break;
                case 4:
                    t.writeCodeword(240), t.signalEncoderChange(4);
                    break;
                default:
                    throw new Error("Illegal mode: " + r);
            }
            else $849102574a83a574$var$si.isExtendedASCII(e) ? (t.writeCodeword(235), t.writeCodeword(e - 128 + 1), t.pos++) : (t.writeCodeword(e + 1), t.pos++);
        }
    }, t.prototype.encodeASCIIDigits = function(t, e) {
        if ($849102574a83a574$var$si.isDigit(t) && $849102574a83a574$var$si.isDigit(e)) return 10 * (t - 48) + (e - 48) + 130;
        throw new Error("not digits: " + t + e);
    }, t;
}(), $849102574a83a574$var$Yo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 5;
    }, t.prototype.encode = function(t) {
        var e = new $849102574a83a574$var$Q;
        for(e.append(0); t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (e.append(r), t.pos++, $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                t.signalEncoderChange(0);
                break;
            }
        }
        var n = e.length() - 1, o = t.getCodewordCount() + n + 1;
        t.updateSymbolInfo(o);
        var i = t.getSymbolInfo().getDataCapacity() - o > 0;
        if (t.hasMoreCharacters() || i) {
            if (n <= 249) e.setCharAt(0, $849102574a83a574$var$q.getCharAt(n));
            else {
                if (!(n <= 1555)) throw new Error("Message length not in valid ranges: " + n);
                e.setCharAt(0, $849102574a83a574$var$q.getCharAt(Math.floor(n / 250) + 249)), e.insert(1, $849102574a83a574$var$q.getCharAt(n % 250));
            }
        }
        var a = 0;
        for(r = e.length(); a < r; a++)t.writeCodeword(this.randomize255State(e.charAt(a).charCodeAt(0), t.getCodewordCount() + 1));
    }, t.prototype.randomize255State = function(t, e) {
        var r = t + (149 * e % 255 + 1);
        return r <= 255 ? r : r - 256;
    }, t;
}(), $849102574a83a574$var$Zo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 1;
    }, t.prototype.encodeMaximal = function(t) {
        for(var e = new $849102574a83a574$var$Q, r = 0, n = t.pos, o = 0; t.hasMoreCharacters();){
            var i = t.getCurrentChar();
            t.pos++, r = this.encodeChar(i, e), e.length() % 3 == 0 && (n = t.pos, o = e.length());
        }
        if (o !== e.length()) {
            var a = Math.floor(e.length() / 3 * 2), s = Math.floor(t.getCodewordCount() + a + 1);
            t.updateSymbolInfo(s);
            var u = t.getSymbolInfo().getDataCapacity() - s, c = Math.floor(e.length() % 3);
            (2 === c && 2 !== u || 1 === c && (r > 3 || 1 !== u)) && (t.pos = n);
        }
        e.length() > 0 && t.writeCodeword(230), this.handleEOD(t, e);
    }, t.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            t.pos++;
            var n = this.encodeChar(r, e), o = 2 * Math.floor(e.length() / 3), i = t.getCodewordCount() + o;
            t.updateSymbolInfo(i);
            var a = t.getSymbolInfo().getDataCapacity() - i;
            if (!t.hasMoreCharacters()) {
                var s = new $849102574a83a574$var$Q;
                for(e.length() % 3 == 2 && 2 !== a && (n = this.backtrackOneCharacter(t, e, s, n)); e.length() % 3 == 1 && (n > 3 || 1 !== a);)n = this.backtrackOneCharacter(t, e, s, n);
                break;
            }
            if (e.length() % 3 == 0) {
                if ($849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        this.handleEOD(t, e);
    }, t.prototype.backtrackOneCharacter = function(t, e, r, n) {
        var o = e.length(), i = e.toString().substring(0, o - n);
        e.setLengthToZero(), e.append(i), t.pos--;
        var a = t.getCurrentChar();
        return n = this.encodeChar(a, r), t.resetSymbolInfo(), n;
    }, t.prototype.writeNextTriplet = function(t, e) {
        t.writeCodewords(this.encodeToCodewords(e.toString()));
        var r = e.toString().substring(3);
        e.setLengthToZero(), e.append(r);
    }, t.prototype.handleEOD = function(t, e) {
        var r = Math.floor(e.length() / 3 * 2), n = e.length() % 3, o = t.getCodewordCount() + r;
        t.updateSymbolInfo(o);
        var i = t.getSymbolInfo().getDataCapacity() - o;
        if (2 === n) {
            for(e.append("\0"); e.length() >= 3;)this.writeNextTriplet(t, e);
            t.hasMoreCharacters() && t.writeCodeword(254);
        } else if (1 === i && 1 === n) {
            for(; e.length() >= 3;)this.writeNextTriplet(t, e);
            t.hasMoreCharacters() && t.writeCodeword(254), t.pos--;
        } else {
            if (0 !== n) throw new Error("Unexpected case. Please report!");
            for(; e.length() >= 3;)this.writeNextTriplet(t, e);
            (i > 0 || t.hasMoreCharacters()) && t.writeCodeword(254);
        }
        t.signalEncoderChange(0);
    }, t.prototype.encodeChar = function(t, e) {
        if (t === " ".charCodeAt(0)) return e.append(3), 1;
        if (t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0)) return e.append(t - 48 + 4), 1;
        if (t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0)) return e.append(t - 65 + 14), 1;
        if (t < " ".charCodeAt(0)) return e.append(0), e.append(t), 2;
        if (t <= "/".charCodeAt(0)) return e.append(1), e.append(t - 33), 2;
        if (t <= "@".charCodeAt(0)) return e.append(1), e.append(t - 58 + 15), 2;
        if (t <= "_".charCodeAt(0)) return e.append(1), e.append(t - 91 + 22), 2;
        if (t <= 127) return e.append(2), e.append(t - 96), 2;
        e.append("1");
        var r = 2;
        return r += this.encodeChar(t - 128, e);
    }, t.prototype.encodeToCodewords = function(t) {
        var e = 1600 * t.charCodeAt(0) + 40 * t.charCodeAt(1) + t.charCodeAt(2) + 1, r = e / 256, n = e % 256, o = new $849102574a83a574$var$Q;
        return o.append(r), o.append(n), o.toString();
    }, t;
}(), $849102574a83a574$var$Ko = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 4;
    }, t.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (this.encodeChar(r, e), t.pos++, e.length() >= 4) {
                t.writeCodewords(this.encodeToCodewords(e.toString()));
                var n = e.toString().substring(4);
                if (e.setLengthToZero(), e.append(n), $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        e.append($849102574a83a574$var$q.getCharAt(31)), this.handleEOD(t, e);
    }, t.prototype.handleEOD = function(t, e) {
        try {
            var r = e.length();
            if (0 === r) return;
            if (1 === r) {
                t.updateSymbolInfo();
                var n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount(), o = t.getRemainingCharacters();
                if (o > n && (t.updateSymbolInfo(t.getCodewordCount() + 1), n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount()), o <= n && n <= 2) return;
            }
            if (r > 4) throw new Error("Count must not exceed 4");
            var i = r - 1, a = this.encodeToCodewords(e.toString()), s = !t.hasMoreCharacters() && i <= 2;
            if (i <= 2) t.updateSymbolInfo(t.getCodewordCount() + i), (n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount()) >= 3 && (s = !1, t.updateSymbolInfo(t.getCodewordCount() + a.length));
            s ? (t.resetSymbolInfo(), t.pos -= i) : t.writeCodewords(a);
        } finally{
            t.signalEncoderChange(0);
        }
    }, t.prototype.encodeChar = function(t, e) {
        t >= " ".charCodeAt(0) && t <= "?".charCodeAt(0) ? e.append(t) : t >= "@".charCodeAt(0) && t <= "^".charCodeAt(0) ? e.append($849102574a83a574$var$q.getCharAt(t - 64)) : $849102574a83a574$var$si.illegalCharacter($849102574a83a574$var$q.getCharAt(t));
    }, t.prototype.encodeToCodewords = function(t) {
        var e = t.length;
        if (0 === e) throw new Error("StringBuilder must not be empty");
        var r = (t.charAt(0).charCodeAt(0) << 18) + ((e >= 2 ? t.charAt(1).charCodeAt(0) : 0) << 12) + ((e >= 3 ? t.charAt(2).charCodeAt(0) : 0) << 6) + (e >= 4 ? t.charAt(3).charCodeAt(0) : 0), n = r >> 16 & 255, o = r >> 8 & 255, i = 255 & r, a = new $849102574a83a574$var$Q;
        return a.append(n), e >= 2 && a.append(o), e >= 3 && a.append(i), a.toString();
    }, t;
}(), $849102574a83a574$var$qo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Qo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Jo = function() {
    function t(t, e, r, n, o, i, a, s) {
        void 0 === a && (a = 0), void 0 === s && (s = 0), this.rectangular = t, this.dataCapacity = e, this.errorCodewords = r, this.matrixWidth = n, this.matrixHeight = o, this.dataRegions = i, this.rsBlockData = a, this.rsBlockError = s;
    }
    return t.lookup = function(t, e, r, n, o) {
        var i, a;
        void 0 === e && (e = 0), void 0 === r && (r = null), void 0 === n && (n = null), void 0 === o && (o = !0);
        try {
            for(var s = $849102574a83a574$var$Qo($849102574a83a574$var$ti), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if ((1 !== e || !c.rectangular) && (2 !== e || c.rectangular) && (null == r || !(c.getSymbolWidth() < r.getWidth() || c.getSymbolHeight() < r.getHeight())) && (null == n || !(c.getSymbolWidth() > n.getWidth() || c.getSymbolHeight() > n.getHeight())) && t <= c.dataCapacity) return c;
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (a = s.return) && a.call(s);
            } finally{
                if (i) throw i.error;
            }
        }
        if (o) throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + t);
        return null;
    }, t.prototype.getHorizontalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
                return 1;
            case 2:
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    }, t.prototype.getVerticalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
            case 2:
                return 1;
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    }, t.prototype.getSymbolDataWidth = function() {
        return this.getHorizontalDataRegions() * this.matrixWidth;
    }, t.prototype.getSymbolDataHeight = function() {
        return this.getVerticalDataRegions() * this.matrixHeight;
    }, t.prototype.getSymbolWidth = function() {
        return this.getSymbolDataWidth() + 2 * this.getHorizontalDataRegions();
    }, t.prototype.getSymbolHeight = function() {
        return this.getSymbolDataHeight() + 2 * this.getVerticalDataRegions();
    }, t.prototype.getCodewordCount = function() {
        return this.dataCapacity + this.errorCodewords;
    }, t.prototype.getInterleavedBlockCount = function() {
        return this.rsBlockData ? this.dataCapacity / this.rsBlockData : 1;
    }, t.prototype.getDataCapacity = function() {
        return this.dataCapacity;
    }, t.prototype.getErrorCodewords = function() {
        return this.errorCodewords;
    }, t.prototype.getDataLengthForInterleavedBlock = function(t) {
        return this.rsBlockData;
    }, t.prototype.getErrorLengthForInterleavedBlock = function(t) {
        return this.rsBlockError;
    }, t;
}(), $849102574a83a574$var$$o = function(t) {
    function e() {
        return t.call(this, !1, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    return $849102574a83a574$var$qo(e, t), e.prototype.getInterleavedBlockCount = function() {
        return 10;
    }, e.prototype.getDataLengthForInterleavedBlock = function(t) {
        return t <= 8 ? 156 : 155;
    }, e;
}($849102574a83a574$var$Jo), $849102574a83a574$var$ti = [
    new $849102574a83a574$var$Jo(!1, 3, 5, 8, 8, 1),
    new $849102574a83a574$var$Jo(!1, 5, 7, 10, 10, 1),
    new $849102574a83a574$var$Jo(!0, 5, 7, 16, 6, 1),
    new $849102574a83a574$var$Jo(!1, 8, 10, 12, 12, 1),
    new $849102574a83a574$var$Jo(!0, 10, 11, 14, 6, 2),
    new $849102574a83a574$var$Jo(!1, 12, 12, 14, 14, 1),
    new $849102574a83a574$var$Jo(!0, 16, 14, 24, 10, 1),
    new $849102574a83a574$var$Jo(!1, 18, 14, 16, 16, 1),
    new $849102574a83a574$var$Jo(!1, 22, 18, 18, 18, 1),
    new $849102574a83a574$var$Jo(!0, 22, 18, 16, 10, 2),
    new $849102574a83a574$var$Jo(!1, 30, 20, 20, 20, 1),
    new $849102574a83a574$var$Jo(!0, 32, 24, 16, 14, 2),
    new $849102574a83a574$var$Jo(!1, 36, 24, 22, 22, 1),
    new $849102574a83a574$var$Jo(!1, 44, 28, 24, 24, 1),
    new $849102574a83a574$var$Jo(!0, 49, 28, 22, 14, 2),
    new $849102574a83a574$var$Jo(!1, 62, 36, 14, 14, 4),
    new $849102574a83a574$var$Jo(!1, 86, 42, 16, 16, 4),
    new $849102574a83a574$var$Jo(!1, 114, 48, 18, 18, 4),
    new $849102574a83a574$var$Jo(!1, 144, 56, 20, 20, 4),
    new $849102574a83a574$var$Jo(!1, 174, 68, 22, 22, 4),
    new $849102574a83a574$var$Jo(!1, 204, 84, 24, 24, 4, 102, 42),
    new $849102574a83a574$var$Jo(!1, 280, 112, 14, 14, 16, 140, 56),
    new $849102574a83a574$var$Jo(!1, 368, 144, 16, 16, 16, 92, 36),
    new $849102574a83a574$var$Jo(!1, 456, 192, 18, 18, 16, 114, 48),
    new $849102574a83a574$var$Jo(!1, 576, 224, 20, 20, 16, 144, 56),
    new $849102574a83a574$var$Jo(!1, 696, 272, 22, 22, 16, 174, 68),
    new $849102574a83a574$var$Jo(!1, 816, 336, 24, 24, 16, 136, 56),
    new $849102574a83a574$var$Jo(!1, 1050, 408, 18, 18, 36, 175, 68),
    new $849102574a83a574$var$Jo(!1, 1304, 496, 20, 20, 36, 163, 62),
    new $849102574a83a574$var$$o
], $849102574a83a574$var$ei = function() {
    function t(t) {
        this.msg = t, this.pos = 0, this.skipAtEnd = 0;
        for(var e = t.split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $849102574a83a574$var$Q, n = 0, o = e.length; n < o; n++){
            var i = String.fromCharCode(255 & e[n]);
            if ("?" === i && "?" !== t.charAt(n)) throw new Error("Message contains characters outside ISO-8859-1 encoding.");
            r.append(i);
        }
        this.msg = r.toString(), this.shape = 0, this.codewords = new $849102574a83a574$var$Q, this.newEncoding = -1;
    }
    return t.prototype.setSymbolShape = function(t) {
        this.shape = t;
    }, t.prototype.setSizeConstraints = function(t, e) {
        this.minSize = t, this.maxSize = e;
    }, t.prototype.getMessage = function() {
        return this.msg;
    }, t.prototype.setSkipAtEnd = function(t) {
        this.skipAtEnd = t;
    }, t.prototype.getCurrentChar = function() {
        return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCurrent = function() {
        return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.writeCodewords = function(t) {
        this.codewords.append(t);
    }, t.prototype.writeCodeword = function(t) {
        this.codewords.append(t);
    }, t.prototype.getCodewordCount = function() {
        return this.codewords.length();
    }, t.prototype.getNewEncoding = function() {
        return this.newEncoding;
    }, t.prototype.signalEncoderChange = function(t) {
        this.newEncoding = t;
    }, t.prototype.resetEncoderSignal = function() {
        this.newEncoding = -1;
    }, t.prototype.hasMoreCharacters = function() {
        return this.pos < this.getTotalMessageCharCount();
    }, t.prototype.getTotalMessageCharCount = function() {
        return this.msg.length - this.skipAtEnd;
    }, t.prototype.getRemainingCharacters = function() {
        return this.getTotalMessageCharCount() - this.pos;
    }, t.prototype.getSymbolInfo = function() {
        return this.symbolInfo;
    }, t.prototype.updateSymbolInfo = function(t) {
        void 0 === t && (t = this.getCodewordCount()), (null == this.symbolInfo || t > this.symbolInfo.getDataCapacity()) && (this.symbolInfo = $849102574a83a574$var$Jo.lookup(t, this.shape, this.minSize, this.maxSize, !0));
    }, t.prototype.resetSymbolInfo = function() {
        this.symbolInfo = null;
    }, t;
}(), $849102574a83a574$var$ri = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ni = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$ri(e, t), e.prototype.getEncodingMode = function() {
        return 3;
    }, e.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (t.pos++, this.encodeChar(r, e), e.length() % 3 == 0) {
                if (this.writeNextTriplet(t, e), $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        this.handleEOD(t, e);
    }, e.prototype.encodeChar = function(t, e) {
        switch(t){
            case 13:
                e.append(0);
                break;
            case "*".charCodeAt(0):
                e.append(1);
                break;
            case ">".charCodeAt(0):
                e.append(2);
                break;
            case " ".charCodeAt(0):
                e.append(3);
                break;
            default:
                t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) ? e.append(t - 48 + 4) : t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0) ? e.append(t - 65 + 14) : $849102574a83a574$var$si.illegalCharacter($849102574a83a574$var$q.getCharAt(t));
        }
        return 1;
    }, e.prototype.handleEOD = function(t, e) {
        t.updateSymbolInfo();
        var r = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount(), n = e.length();
        t.pos -= n, (t.getRemainingCharacters() > 1 || r > 1 || t.getRemainingCharacters() !== r) && t.writeCodeword(254), t.getNewEncoding() < 0 && t.signalEncoderChange(0);
    }, e;
}($849102574a83a574$var$Zo), $849102574a83a574$var$oi = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ii = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$oi(e, t), e.prototype.getEncodingMode = function() {
        return 2;
    }, e.prototype.encodeChar = function(t, e) {
        if (t === " ".charCodeAt(0)) return e.append(3), 1;
        if (t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0)) return e.append(t - 48 + 4), 1;
        if (t >= "a".charCodeAt(0) && t <= "z".charCodeAt(0)) return e.append(t - 97 + 14), 1;
        if (t < " ".charCodeAt(0)) return e.append(0), e.append(t), 2;
        if (t <= "/".charCodeAt(0)) return e.append(1), e.append(t - 33), 2;
        if (t <= "@".charCodeAt(0)) return e.append(1), e.append(t - 58 + 15), 2;
        if (t >= "[".charCodeAt(0) && t <= "_".charCodeAt(0)) return e.append(1), e.append(t - 91 + 22), 2;
        if (t === "`".charCodeAt(0)) return e.append(2), e.append(0), 2;
        if (t <= "Z".charCodeAt(0)) return e.append(2), e.append(t - 65 + 1), 2;
        if (t <= 127) return e.append(2), e.append(t - 123 + 27), 2;
        e.append("1");
        var r = 2;
        return r += this.encodeChar(t - 128, e);
    }, e;
}($849102574a83a574$var$Zo), $849102574a83a574$var$ai = function() {
    function t() {}
    return t.randomize253State = function(t) {
        var e = 129 + (149 * t % 253 + 1);
        return e <= 254 ? e : e - 254;
    }, t.encodeHighLevel = function(t, e, r, n, o) {
        void 0 === e && (e = 0), void 0 === r && (r = null), void 0 === n && (n = null), void 0 === o && (o = !1);
        var i = new $849102574a83a574$var$Zo, a = [
            new $849102574a83a574$var$jo,
            i,
            new $849102574a83a574$var$ii,
            new $849102574a83a574$var$ni,
            new $849102574a83a574$var$Ko,
            new $849102574a83a574$var$Yo
        ], s = new $849102574a83a574$var$ei(t);
        s.setSymbolShape(e), s.setSizeConstraints(r, n), t.startsWith($849102574a83a574$var$Wo) && t.endsWith("") ? (s.writeCodeword(236), s.setSkipAtEnd(2), s.pos += 7) : t.startsWith($849102574a83a574$var$zo) && t.endsWith("") && (s.writeCodeword(237), s.setSkipAtEnd(2), s.pos += 7);
        var u = 0;
        for(o && (i.encodeMaximal(s), u = s.getNewEncoding(), s.resetEncoderSignal()); s.hasMoreCharacters();)a[u].encode(s), s.getNewEncoding() >= 0 && (u = s.getNewEncoding(), s.resetEncoderSignal());
        var c = s.getCodewordCount();
        s.updateSymbolInfo();
        var f = s.getSymbolInfo().getDataCapacity();
        c < f && 0 !== u && 5 !== u && 4 !== u && s.writeCodeword("\xfe");
        var h = s.getCodewords();
        for(h.length() < f && h.append(129); h.length() < f;)h.append(this.randomize253State(h.length() + 1));
        return s.getCodewords().toString();
    }, t.lookAheadTest = function(t, e, r) {
        var n = this.lookAheadTestIntern(t, e, r);
        if (3 === r && 3 === n) {
            for(var o = Math.min(e + 3, t.length), i = e; i < o; i++)if (!this.isNativeX12(t.charCodeAt(i))) return 0;
        } else if (4 === r && 4 === n) {
            for(o = Math.min(e + 4, t.length), i = e; i < o; i++)if (!this.isNativeEDIFACT(t.charCodeAt(i))) return 0;
        }
        return n;
    }, t.lookAheadTestIntern = function(t, e, r) {
        if (e >= t.length) return r;
        var n;
        0 === r ? n = [
            0,
            1,
            1,
            1,
            1,
            1.25
        ] : (n = [
            1,
            2,
            2,
            2,
            2,
            2.25
        ])[r] = 0;
        for(var o = 0, i = new Uint8Array(6), a = [];;){
            if (e + o === t.length) {
                $849102574a83a574$var$k.fill(i, 0), $849102574a83a574$var$k.fill(a, 0);
                var s = this.findMinimums(n, a, $849102574a83a574$var$x.MAX_VALUE, i), u = this.getMinimumCount(i);
                if (a[0] === s) return 0;
                if (1 === u) {
                    if (i[5] > 0) return 5;
                    if (i[4] > 0) return 4;
                    if (i[2] > 0) return 2;
                    if (i[3] > 0) return 3;
                }
                return 1;
            }
            var c = t.charCodeAt(e + o);
            if (o++, this.isDigit(c) ? n[0] += .5 : this.isExtendedASCII(c) ? (n[0] = Math.ceil(n[0]), n[0] += 2) : (n[0] = Math.ceil(n[0]), n[0]++), this.isNativeC40(c) ? n[1] += 2 / 3 : this.isExtendedASCII(c) ? n[1] += 8 / 3 : n[1] += 4 / 3, this.isNativeText(c) ? n[2] += 2 / 3 : this.isExtendedASCII(c) ? n[2] += 8 / 3 : n[2] += 4 / 3, this.isNativeX12(c) ? n[3] += 2 / 3 : this.isExtendedASCII(c) ? n[3] += 13 / 3 : n[3] += 10 / 3, this.isNativeEDIFACT(c) ? n[4] += 3 / 4 : this.isExtendedASCII(c) ? n[4] += 4.25 : n[4] += 3.25, this.isSpecialB256(c) ? n[5] += 4 : n[5]++, o >= 4) {
                if ($849102574a83a574$var$k.fill(i, 0), $849102574a83a574$var$k.fill(a, 0), this.findMinimums(n, a, $849102574a83a574$var$x.MAX_VALUE, i), a[0] < this.min(a[5], a[1], a[2], a[3], a[4])) return 0;
                if (a[5] < a[0] || a[5] + 1 < this.min(a[1], a[2], a[3], a[4])) return 5;
                if (a[4] + 1 < this.min(a[5], a[1], a[2], a[3], a[0])) return 4;
                if (a[2] + 1 < this.min(a[5], a[1], a[4], a[3], a[0])) return 2;
                if (a[3] + 1 < this.min(a[5], a[1], a[4], a[2], a[0])) return 3;
                if (a[1] + 1 < this.min(a[0], a[5], a[4], a[2])) {
                    if (a[1] < a[3]) return 1;
                    if (a[1] === a[3]) {
                        for(var f = e + o + 1; f < t.length;){
                            var h = t.charCodeAt(f);
                            if (this.isX12TermSep(h)) return 3;
                            if (!this.isNativeX12(h)) break;
                            f++;
                        }
                        return 1;
                    }
                }
            }
        }
    }, t.min = function(t, e, r, n, o) {
        var i = Math.min(t, Math.min(e, Math.min(r, n)));
        return void 0 === o ? i : Math.min(i, o);
    }, t.findMinimums = function(t, e, r, n) {
        for(var o = 0; o < 6; o++){
            var i = e[o] = Math.ceil(t[o]);
            r > i && (r = i, $849102574a83a574$var$k.fill(n, 0)), r === i && (n[o] = n[o] + 1);
        }
        return r;
    }, t.getMinimumCount = function(t) {
        for(var e = 0, r = 0; r < 6; r++)e += t[r];
        return e || 0;
    }, t.isDigit = function(t) {
        return t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0);
    }, t.isExtendedASCII = function(t) {
        return t >= 128 && t <= 255;
    }, t.isNativeC40 = function(t) {
        return t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0);
    }, t.isNativeText = function(t) {
        return t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "a".charCodeAt(0) && t <= "z".charCodeAt(0);
    }, t.isNativeX12 = function(t) {
        return this.isX12TermSep(t) || t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0);
    }, t.isX12TermSep = function(t) {
        return 13 === t || t === "*".charCodeAt(0) || t === ">".charCodeAt(0);
    }, t.isNativeEDIFACT = function(t) {
        return t >= " ".charCodeAt(0) && t <= "^".charCodeAt(0);
    }, t.isSpecialB256 = function(t) {
        return !1;
    }, t.determineConsecutiveDigitCount = function(t, e) {
        void 0 === e && (e = 0);
        for(var r = t.length, n = e; n < r && this.isDigit(t.charCodeAt(n));)n++;
        return n - e;
    }, t.illegalCharacter = function(t) {
        var e = $849102574a83a574$var$x.toHexString(t.charCodeAt(0));
        throw e = "0000".substring(0, 4 - e.length) + e, new Error("Illegal character: " + t + " (0x" + e + ")");
    }, t;
}(), $849102574a83a574$var$si = $849102574a83a574$var$ai, $849102574a83a574$var$ui = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ci = function() {
    function t(t) {
        this.charset = t, this.name = t.name;
    }
    return t.prototype.canEncode = function(t) {
        try {
            return null != $849102574a83a574$var$K.encode(t, this.charset);
        } catch (t) {
            return !1;
        }
    }, t;
}(), $849102574a83a574$var$fi = function() {
    function t(t, e, r) {
        var n, o, i, a, s, u;
        this.ENCODERS = [
            "IBM437",
            "ISO-8859-2",
            "ISO-8859-3",
            "ISO-8859-4",
            "ISO-8859-5",
            "ISO-8859-6",
            "ISO-8859-7",
            "ISO-8859-8",
            "ISO-8859-9",
            "ISO-8859-10",
            "ISO-8859-11",
            "ISO-8859-13",
            "ISO-8859-14",
            "ISO-8859-15",
            "ISO-8859-16",
            "windows-1250",
            "windows-1251",
            "windows-1252",
            "windows-1256",
            "Shift_JIS"
        ].map(function(t) {
            return new $849102574a83a574$var$ci($849102574a83a574$var$Uo.forName(t));
        }), this.encoders = [];
        var c = [];
        c.push(new $849102574a83a574$var$ci($849102574a83a574$var$Xo.ISO_8859_1));
        for(var f = null != e && e.name.startsWith("UTF"), h = 0; h < t.length; h++){
            var l = !1;
            try {
                for(var d = (n = void 0, $849102574a83a574$var$ui(c)), p = d.next(); !p.done; p = d.next()){
                    var g = p.value, y = t.charAt(h);
                    if (y.charCodeAt(0) === r || g.canEncode(y)) {
                        l = !0;
                        break;
                    }
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    p && !p.done && (o = d.return) && o.call(d);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (!l) try {
                for(var w = (i = void 0, $849102574a83a574$var$ui(this.ENCODERS)), v = w.next(); !v.done; v = w.next())if ((g = v.value).canEncode(t.charAt(h))) {
                    c.push(g), l = !0;
                    break;
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    v && !v.done && (a = w.return) && a.call(w);
                } finally{
                    if (i) throw i.error;
                }
            }
            l || (f = !0);
        }
        if (1 !== c.length || f) {
            this.encoders = [];
            var _ = 0;
            try {
                for(var A = $849102574a83a574$var$ui(c), C = A.next(); !C.done; C = A.next()){
                    g = C.value;
                    this.encoders[_++] = g;
                }
            } catch (t) {
                s = {
                    error: t
                };
            } finally{
                try {
                    C && !C.done && (u = A.return) && u.call(A);
                } finally{
                    if (s) throw s.error;
                }
            }
        } else this.encoders = [
            c[0]
        ];
        var m = -1;
        if (null != e) {
            for(h = 0; h < this.encoders.length; h++)if (null != this.encoders[h] && e.name === this.encoders[h].name) {
                m = h;
                break;
            }
        }
        this.priorityEncoderIndex = m;
    }
    return t.prototype.length = function() {
        return this.encoders.length;
    }, t.prototype.getCharsetName = function(t) {
        if (!(t < this.length())) throw new Error("index must be less than length");
        return this.encoders[t].name;
    }, t.prototype.getCharset = function(t) {
        if (!(t < this.length())) throw new Error("index must be less than length");
        return this.encoders[t].charset;
    }, t.prototype.getECIValue = function(t) {
        return this.encoders[t].charset.getValueIdentifier();
    }, t.prototype.getPriorityEncoderIndex = function() {
        return this.priorityEncoderIndex;
    }, t.prototype.canEncode = function(t, e) {
        if (!(e < this.length())) throw new Error("index must be less than length");
        return !0;
    }, t.prototype.encode = function(t, e) {
        if (!(e < this.length())) throw new Error("index must be less than length");
        return $849102574a83a574$var$K.encode($849102574a83a574$var$q.getCharAt(t), this.encoders[e].name);
    }, t;
}(), $849102574a83a574$var$hi = function() {
    function t(t, e, r) {
        this.fnc1 = r;
        var n = new $849102574a83a574$var$fi(t, e, r);
        if (1 === n.length()) for(var o = 0; o < this.bytes.length; o++){
            var i = t.charAt(o).charCodeAt(0);
            this.bytes[o] = i === r ? 1e3 : i;
        }
        else this.bytes = this.encodeMinimally(t, n, r);
    }
    return t.prototype.getFNC1Character = function() {
        return this.fnc1;
    }, t.prototype.length = function() {
        return this.bytes.length;
    }, t.prototype.haveNCharacters = function(t, e) {
        if (t + e - 1 >= this.bytes.length) return !1;
        for(var r = 0; r < e; r++)if (this.isECI(t + r)) return !1;
        return !0;
    }, t.prototype.charAt = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        if (this.isECI(t)) throw new Error("value at " + t + " is not a character but an ECI");
        return this.isFNC1(t) ? this.fnc1 : this.bytes[t];
    }, t.prototype.subSequence = function(t, e) {
        if (t < 0 || t > e || e > this.length()) throw new Error("" + t);
        for(var r = new $849102574a83a574$var$Q, n = t; n < e; n++){
            if (this.isECI(n)) throw new Error("value at " + n + " is not a character but an ECI");
            r.append(this.charAt(n));
        }
        return r.toString();
    }, t.prototype.isECI = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        return this.bytes[t] > 255 && this.bytes[t] <= 999;
    }, t.prototype.isFNC1 = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        return 1e3 === this.bytes[t];
    }, t.prototype.getECIValue = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        if (!this.isECI(t)) throw new Error("value at " + t + " is not an ECI but a character");
        return this.bytes[t] - 256;
    }, t.prototype.addEdge = function(t, e, r) {
        (null == t[e][r.encoderIndex] || t[e][r.encoderIndex].cachedTotalSize > r.cachedTotalSize) && (t[e][r.encoderIndex] = r);
    }, t.prototype.addEdges = function(t, e, r, n, o, i) {
        var a = t.charAt(n).charCodeAt(0), s = 0, u = e.length();
        e.getPriorityEncoderIndex() >= 0 && (a === i || e.canEncode(a, e.getPriorityEncoderIndex())) && (u = (s = e.getPriorityEncoderIndex()) + 1);
        for(var c = s; c < u; c++)(a === i || e.canEncode(a, c)) && this.addEdge(r, n + 1, new $849102574a83a574$var$li(a, e, c, o, i));
    }, t.prototype.encodeMinimally = function(t, e, r) {
        var n = t.length, o = new $849102574a83a574$var$li[n + 1][e.length()];
        this.addEdges(t, e, o, 0, null, r);
        for(var i = 1; i <= n; i++){
            for(var a = 0; a < e.length(); a++)null != o[i][a] && i < n && this.addEdges(t, e, o, i, o[i][a], r);
            for(a = 0; a < e.length(); a++)o[i - 1][a] = null;
        }
        var s = -1, u = $849102574a83a574$var$x.MAX_VALUE;
        for(a = 0; a < e.length(); a++)if (null != o[n][a]) {
            var c = o[n][a];
            c.cachedTotalSize < u && (u = c.cachedTotalSize, s = a);
        }
        if (s < 0) throw new Error('Failed to encode "' + t + '"');
        for(var f = [], h = o[n][s]; null != h;){
            if (h.isFNC1()) f.unshift(1e3);
            else {
                var l = e.encode(h.c, h.encoderIndex);
                for(i = l.length - 1; i >= 0; i--)f.unshift(255 & l[i]);
            }
            (null === h.previous ? 0 : h.previous.encoderIndex) !== h.encoderIndex && f.unshift(256 + e.getECIValue(h.encoderIndex)), h = h.previous;
        }
        var d = [];
        for(i = 0; i < d.length; i++)d[i] = f[i];
        return d;
    }, t;
}(), $849102574a83a574$var$li = function() {
    function t(t, e, r, n, o) {
        this.c = t, this.encoderSet = e, this.encoderIndex = r, this.previous = n, this.fnc1 = o, this.c = t === o ? 1e3 : t;
        var i = this.isFNC1() ? 1 : e.encode(t, r).length;
        (null === n ? 0 : n.encoderIndex) !== r && (i += 3), null != n && (i += n.cachedTotalSize), this.cachedTotalSize = i;
    }
    return t.prototype.isFNC1 = function() {
        return 1e3 === this.c;
    }, t;
}(), $849102574a83a574$var$di = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    t[t.ASCII = 0] = "ASCII", t[t.C40 = 1] = "C40", t[t.TEXT = 2] = "TEXT", t[t.X12 = 3] = "X12", t[t.EDF = 4] = "EDF", t[t.B256 = 5] = "B256";
}($849102574a83a574$var$Go || ($849102574a83a574$var$Go = {})), function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r, n) || this;
        return a.shape = o, a.macroId = i, a;
    }
    $849102574a83a574$var$di(e, t), e.prototype.getMacroId = function() {
        return this.macroId;
    }, e.prototype.getShapeHint = function() {
        return this.shape;
    };
}($849102574a83a574$var$hi);
var $849102574a83a574$var$pi = function() {
    function t() {}
    return t.prototype.isCompact = function() {
        return this.compact;
    }, t.prototype.setCompact = function(t) {
        this.compact = t;
    }, t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.setSize = function(t) {
        this.size = t;
    }, t.prototype.getLayers = function() {
        return this.layers;
    }, t.prototype.setLayers = function(t) {
        this.layers = t;
    }, t.prototype.getCodeWords = function() {
        return this.codeWords;
    }, t.prototype.setCodeWords = function(t) {
        this.codeWords = t;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t;
}(), $849102574a83a574$var$gi = function() {
    function t() {}
    return t.singletonList = function(t) {
        return [
            t
        ];
    }, t.min = function(t, e) {
        return t.sort(e)[0];
    }, t;
}(), $849102574a83a574$var$yi = function() {
    function t(t) {
        this.previous = t;
    }
    return t.prototype.getPrevious = function() {
        return this.previous;
    }, t;
}(), $849102574a83a574$var$wi = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$vi = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.value = r, o.bitCount = n, o;
    }
    return $849102574a83a574$var$wi(e, t), e.prototype.appendTo = function(t, e) {
        t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.addBinaryShift = function(t, r) {
        return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, r);
    }, e.prototype.toString = function() {
        var t = this.value & (1 << this.bitCount) - 1;
        return t |= 1 << this.bitCount, "<" + $849102574a83a574$var$x.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
}($849102574a83a574$var$yi), $849102574a83a574$var$_i = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ai = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, 0, 0) || this;
        return o.binaryShiftStart = r, o.binaryShiftByteCount = n, o;
    }
    return $849102574a83a574$var$_i(e, t), e.prototype.appendTo = function(t, e) {
        for(var r = 0; r < this.binaryShiftByteCount; r++)(0 === r || 31 === r && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : 0 === r ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(e[this.binaryShiftStart + r], 8);
    }, e.prototype.addBinaryShift = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    }, e;
}($849102574a83a574$var$vi);
function $849102574a83a574$var$Ci(t, e, r) {
    return new $849102574a83a574$var$vi(t, e, r);
}
var $849102574a83a574$var$mi = [
    "UPPER",
    "LOWER",
    "DIGIT",
    "MIXED",
    "PUNCT"
], $849102574a83a574$var$Ei = new $849102574a83a574$var$vi(null, 0, 0), $849102574a83a574$var$Ii = [
    Int32Array.from([
        0,
        327708,
        327710,
        327709,
        656318
    ]),
    Int32Array.from([
        590318,
        0,
        327710,
        327709,
        656318
    ]),
    Int32Array.from([
        262158,
        590300,
        0,
        590301,
        932798
    ]),
    Int32Array.from([
        327709,
        327708,
        656318,
        0,
        327710
    ]),
    Int32Array.from([
        327711,
        656380,
        656382,
        656381,
        0
    ])
], $849102574a83a574$var$Si = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $849102574a83a574$var$Ti = function(t) {
    var e, r;
    try {
        for(var n = $849102574a83a574$var$Si(t), o = n.next(); !o.done; o = n.next()){
            var i = o.value;
            $849102574a83a574$var$k.fill(i, -1);
        }
    } catch (t) {
        e = {
            error: t
        };
    } finally{
        try {
            o && !o.done && (r = n.return) && r.call(n);
        } finally{
            if (e) throw e.error;
        }
    }
    return t[0][4] = 0, t[1][4] = 0, t[1][0] = 28, t[3][4] = 0, t[2][4] = 0, t[2][0] = 15, t;
}($849102574a83a574$var$k.createInt32Array(6, 6)), $849102574a83a574$var$Oi = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$bi = function() {
    function t(t, e, r, n) {
        this.token = t, this.mode = e, this.binaryShiftByteCount = r, this.bitCount = n;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getToken = function() {
        return this.token;
    }, t.prototype.getBinaryShiftByteCount = function() {
        return this.binaryShiftByteCount;
    }, t.prototype.getBitCount = function() {
        return this.bitCount;
    }, t.prototype.latchAndAppend = function(e, r) {
        var n = this.bitCount, o = this.token;
        if (e !== this.mode) {
            var i = $849102574a83a574$var$Ii[this.mode][e];
            o = $849102574a83a574$var$Ci(o, 65535 & i, i >> 16), n += i >> 16;
        }
        var a = 2 === e ? 4 : 5;
        return new t(o = $849102574a83a574$var$Ci(o, r, a), e, 0, n + a);
    }, t.prototype.shiftAndAppend = function(e, r) {
        var n = this.token, o = 2 === this.mode ? 4 : 5;
        return n = $849102574a83a574$var$Ci(n, $849102574a83a574$var$Ti[this.mode][e], o), new t(n = $849102574a83a574$var$Ci(n, r, 5), this.mode, 0, this.bitCount + o + 5);
    }, t.prototype.addBinaryShiftChar = function(e) {
        var r = this.token, n = this.mode, o = this.bitCount;
        if (4 === this.mode || 2 === this.mode) {
            var i = $849102574a83a574$var$Ii[n][0];
            r = $849102574a83a574$var$Ci(r, 65535 & i, i >> 16), o += i >> 16, n = 0;
        }
        var a = 0 === this.binaryShiftByteCount || 31 === this.binaryShiftByteCount ? 18 : 62 === this.binaryShiftByteCount ? 9 : 8, s = new t(r, n, this.binaryShiftByteCount + 1, o + a);
        return 2078 === s.binaryShiftByteCount && (s = s.endBinaryShift(e + 1)), s;
    }, t.prototype.endBinaryShift = function(e) {
        if (0 === this.binaryShiftByteCount) return this;
        var r = this.token;
        return new t(r = function(t, e, r) {
            return new $849102574a83a574$var$Ai(t, e, r);
        }(r, e - this.binaryShiftByteCount, this.binaryShiftByteCount), this.mode, 0, this.bitCount);
    }, t.prototype.isBetterThanOrEqualTo = function(e) {
        var r = this.bitCount + ($849102574a83a574$var$Ii[this.mode][e.mode] >> 16);
        return this.binaryShiftByteCount < e.binaryShiftByteCount ? r += t.calculateBinaryShiftCost(e) - t.calculateBinaryShiftCost(this) : this.binaryShiftByteCount > e.binaryShiftByteCount && e.binaryShiftByteCount > 0 && (r += 10), r <= e.bitCount;
    }, t.prototype.toBitArray = function(t) {
        for(var e, r, n = [], o = this.endBinaryShift(t.length).token; null !== o; o = o.getPrevious())n.unshift(o);
        var i = new $849102574a83a574$var$V;
        try {
            for(var a = $849102574a83a574$var$Oi(n), s = a.next(); !s.done; s = a.next())s.value.appendTo(i, t);
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (r = a.return) && r.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.prototype.toString = function() {
        return $849102574a83a574$var$q.format("%s bits=%d bytes=%d", $849102574a83a574$var$mi[this.mode], this.bitCount, this.binaryShiftByteCount);
    }, t.calculateBinaryShiftCost = function(t) {
        return t.binaryShiftByteCount > 62 ? 21 : t.binaryShiftByteCount > 31 ? 20 : t.binaryShiftByteCount > 0 ? 10 : 0;
    }, t.INITIAL_STATE = new t($849102574a83a574$var$Ei, 0, 0, 0), t;
}();
var $849102574a83a574$var$Ri = function(t) {
    var e = $849102574a83a574$var$q.getCharCode(" "), r = $849102574a83a574$var$q.getCharCode("."), n = $849102574a83a574$var$q.getCharCode(",");
    t[0][e] = 1;
    for(var o = $849102574a83a574$var$q.getCharCode("Z"), i = $849102574a83a574$var$q.getCharCode("A"), a = i; a <= o; a++)t[0][a] = a - i + 2;
    t[1][e] = 1;
    var s = $849102574a83a574$var$q.getCharCode("z"), u = $849102574a83a574$var$q.getCharCode("a");
    for(a = u; a <= s; a++)t[1][a] = a - u + 2;
    t[2][e] = 1;
    var c = $849102574a83a574$var$q.getCharCode("9"), f = $849102574a83a574$var$q.getCharCode("0");
    for(a = f; a <= c; a++)t[2][a] = a - f + 2;
    t[2][n] = 12, t[2][r] = 13;
    for(var h = [
        "\0",
        " ",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "\b",
        "\t",
        "\n",
        "\v",
        "\f",
        "\r",
        "",
        "",
        "",
        "",
        "",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        ""
    ], l = 0; l < h.length; l++)t[3][$849102574a83a574$var$q.getCharCode(h[l])] = l;
    var d = [
        "\0",
        "\r",
        "\0",
        "\0",
        "\0",
        "\0",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(l = 0; l < d.length; l++)$849102574a83a574$var$q.getCharCode(d[l]) > 0 && (t[4][$849102574a83a574$var$q.getCharCode(d[l])] = l);
    return t;
}($849102574a83a574$var$k.createInt32Array(5, 256)), $849102574a83a574$var$Ni = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Di = function() {
    function t(t) {
        this.text = t;
    }
    return t.prototype.encode = function() {
        for(var e = $849102574a83a574$var$q.getCharCode(" "), r = $849102574a83a574$var$q.getCharCode("\n"), n = $849102574a83a574$var$gi.singletonList($849102574a83a574$var$bi.INITIAL_STATE), o = 0; o < this.text.length; o++){
            var i = void 0, a = o + 1 < this.text.length ? this.text[o + 1] : 0;
            switch(this.text[o]){
                case $849102574a83a574$var$q.getCharCode("\r"):
                    i = a === r ? 2 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode("."):
                    i = a === e ? 3 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode(","):
                    i = a === e ? 4 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode(":"):
                    i = a === e ? 5 : 0;
                    break;
                default:
                    i = 0;
            }
            i > 0 ? (n = t.updateStateListForPair(n, o, i), o++) : n = this.updateStateListForChar(n, o);
        }
        return $849102574a83a574$var$gi.min(n, function(t, e) {
            return t.getBitCount() - e.getBitCount();
        }).toBitArray(this.text);
    }, t.prototype.updateStateListForChar = function(e, r) {
        var n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(e), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                this.updateStateForChar(u, r, i);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = a.return) && o.call(a);
            } finally{
                if (n) throw n.error;
            }
        }
        return t.simplifyStates(i);
    }, t.prototype.updateStateForChar = function(t, e, r) {
        for(var n = 255 & this.text[e], o = $849102574a83a574$var$Ri[t.getMode()][n] > 0, i = null, a = 0; a <= 4; a++){
            var s = $849102574a83a574$var$Ri[a][n];
            if (s > 0) {
                if (null == i && (i = t.endBinaryShift(e)), !o || a === t.getMode() || 2 === a) {
                    var u = i.latchAndAppend(a, s);
                    r.push(u);
                }
                if (!o && $849102574a83a574$var$Ti[t.getMode()][a] >= 0) {
                    var c = i.shiftAndAppend(a, s);
                    r.push(c);
                }
            }
        }
        if (t.getBinaryShiftByteCount() > 0 || 0 === $849102574a83a574$var$Ri[t.getMode()][n]) {
            var f = t.addBinaryShiftChar(e);
            r.push(f);
        }
    }, t.updateStateListForPair = function(t, e, r) {
        var n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(t), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                this.updateStateForPair(u, e, r, i);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = a.return) && o.call(a);
            } finally{
                if (n) throw n.error;
            }
        }
        return this.simplifyStates(i);
    }, t.updateStateForPair = function(t, e, r, n) {
        var o = t.endBinaryShift(e);
        if (n.push(o.latchAndAppend(4, r)), 4 !== t.getMode() && n.push(o.shiftAndAppend(4, r)), 3 === r || 4 === r) {
            var i = o.latchAndAppend(2, 16 - r).latchAndAppend(2, 1);
            n.push(i);
        }
        if (t.getBinaryShiftByteCount() > 0) {
            var a = t.addBinaryShiftChar(e).addBinaryShiftChar(e + 1);
            n.push(a);
        }
    }, t.simplifyStates = function(t) {
        var e, r, n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(t), s = a.next(); !s.done; s = a.next()){
                var u = s.value, c = !0, f = function(t) {
                    if (t.isBetterThanOrEqualTo(u)) return c = !1, "break";
                    u.isBetterThanOrEqualTo(t) && (i = i.filter(function(e) {
                        return e !== t;
                    }));
                };
                try {
                    for(var h = (n = void 0, $849102574a83a574$var$Ni(i)), l = h.next(); !l.done; l = h.next()){
                        if ("break" === f(l.value)) break;
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (o = h.return) && o.call(h);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                c && i.push(u);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (r = a.return) && r.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t;
}(), $849102574a83a574$var$Mi = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.encodeBytes = function(e) {
        return t.encode(e, t.DEFAULT_EC_PERCENT, t.DEFAULT_AZTEC_LAYERS);
    }, t.encode = function(e, r, n) {
        var o, i, a, s, u, c = new $849102574a83a574$var$Di(e).encode(), f = $849102574a83a574$var$x.truncDivision(c.getSize() * r, 100) + 11, h = c.getSize() + f;
        if (n !== t.DEFAULT_AZTEC_LAYERS) {
            if (o = n < 0, (i = Math.abs(n)) > (o ? t.MAX_NB_BITS_COMPACT : t.MAX_NB_BITS)) throw new $849102574a83a574$var$T($849102574a83a574$var$q.format("Illegal value %s for layers", n));
            var l = (a = t.totalBitsInLayer(i, o)) - a % (s = t.WORD_SIZE[i]);
            if ((u = t.stuffBits(c, s)).getSize() + f > l) throw new $849102574a83a574$var$T("Data to large for user specified layer");
            if (o && u.getSize() > 64 * s) throw new $849102574a83a574$var$T("Data to large for user specified layer");
        } else {
            s = 0, u = null;
            for(var d = 0;; d++){
                if (d > t.MAX_NB_BITS) throw new $849102574a83a574$var$T("Data too large for an Aztec code");
                if (i = (o = d <= 3) ? d + 1 : d, !(h > (a = t.totalBitsInLayer(i, o)))) {
                    null != u && s === t.WORD_SIZE[i] || (s = t.WORD_SIZE[i], u = t.stuffBits(c, s));
                    l = a - a % s;
                    if (!(o && u.getSize() > 64 * s) && u.getSize() + f <= l) break;
                }
            }
        }
        var p, g = t.generateCheckWords(u, a, s), y = u.getSize() / s, w = t.generateModeMessage(o, i, y), v = (o ? 11 : 14) + 4 * i, _ = new Int32Array(v);
        if (o) {
            p = v;
            for(d = 0; d < _.length; d++)_[d] = d;
        } else {
            p = v + 1 + 2 * $849102574a83a574$var$x.truncDivision($849102574a83a574$var$x.truncDivision(v, 2) - 1, 15);
            var A = $849102574a83a574$var$x.truncDivision(v, 2), C = $849102574a83a574$var$x.truncDivision(p, 2);
            for(d = 0; d < A; d++){
                var m = d + $849102574a83a574$var$x.truncDivision(d, 15);
                _[A - d - 1] = C - m - 1, _[A + d] = C + m + 1;
            }
        }
        for(var E = new $849102574a83a574$var$J(p), I = (d = 0, 0); d < i; d++){
            for(var S = 4 * (i - d) + (o ? 9 : 12), O = 0; O < S; O++)for(var b = 2 * O, R = 0; R < 2; R++)g.get(I + b + R) && E.set(_[2 * d + R], _[2 * d + O]), g.get(I + 2 * S + b + R) && E.set(_[2 * d + O], _[v - 1 - 2 * d - R]), g.get(I + 4 * S + b + R) && E.set(_[v - 1 - 2 * d - R], _[v - 1 - 2 * d - O]), g.get(I + 6 * S + b + R) && E.set(_[v - 1 - 2 * d - O], _[2 * d + R]);
            I += 8 * S;
        }
        if (t.drawModeMessage(E, o, p, w), o) t.drawBullsEye(E, $849102574a83a574$var$x.truncDivision(p, 2), 5);
        else {
            t.drawBullsEye(E, $849102574a83a574$var$x.truncDivision(p, 2), 7);
            for(d = 0, O = 0; d < $849102574a83a574$var$x.truncDivision(v, 2) - 1; d += 15, O += 16)for(R = 1 & $849102574a83a574$var$x.truncDivision(p, 2); R < p; R += 2)E.set($849102574a83a574$var$x.truncDivision(p, 2) - O, R), E.set($849102574a83a574$var$x.truncDivision(p, 2) + O, R), E.set(R, $849102574a83a574$var$x.truncDivision(p, 2) - O), E.set(R, $849102574a83a574$var$x.truncDivision(p, 2) + O);
        }
        var N = new $849102574a83a574$var$pi;
        return N.setCompact(o), N.setSize(p), N.setLayers(i), N.setCodeWords(y), N.setMatrix(E), N;
    }, t.drawBullsEye = function(t, e, r) {
        for(var n = 0; n < r; n += 2)for(var o = e - n; o <= e + n; o++)t.set(o, e - n), t.set(o, e + n), t.set(e - n, o), t.set(e + n, o);
        t.set(e - r, e - r), t.set(e - r + 1, e - r), t.set(e - r, e - r + 1), t.set(e + r, e - r), t.set(e + r, e - r + 1), t.set(e + r, e + r - 1);
    }, t.generateModeMessage = function(e, r, n) {
        var o = new $849102574a83a574$var$V;
        return e ? (o.appendBits(r - 1, 2), o.appendBits(n - 1, 6), o = t.generateCheckWords(o, 28, 4)) : (o.appendBits(r - 1, 5), o.appendBits(n - 1, 11), o = t.generateCheckWords(o, 40, 4)), o;
    }, t.drawModeMessage = function(t, e, r, n) {
        var o = $849102574a83a574$var$x.truncDivision(r, 2);
        if (e) for(var i = 0; i < 7; i++){
            var a = o - 3 + i;
            n.get(i) && t.set(a, o - 5), n.get(i + 7) && t.set(o + 5, a), n.get(20 - i) && t.set(a, o + 5), n.get(27 - i) && t.set(o - 5, a);
        }
        else for(i = 0; i < 10; i++){
            a = o - 5 + i + $849102574a83a574$var$x.truncDivision(i, 5);
            n.get(i) && t.set(a, o - 7), n.get(i + 10) && t.set(o + 7, a), n.get(29 - i) && t.set(a, o + 7), n.get(39 - i) && t.set(o - 7, a);
        }
    }, t.generateCheckWords = function(e, r, n) {
        var o, i, a = e.getSize() / n, s = new $849102574a83a574$var$To(t.getGF(n)), u = $849102574a83a574$var$x.truncDivision(r, n), c = t.bitsToWords(e, n, u);
        s.encode(c, u - a);
        var f = r % n, h = new $849102574a83a574$var$V;
        h.appendBits(0, f);
        try {
            for(var l = $849102574a83a574$var$Mi(Array.from(c)), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h.appendBits(p, n);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
        return h;
    }, t.bitsToWords = function(t, e, r) {
        var n, o, i = new Int32Array(r);
        for(n = 0, o = t.getSize() / e; n < o; n++){
            for(var a = 0, s = 0; s < e; s++)a |= t.get(n * e + s) ? 1 << e - s - 1 : 0;
            i[n] = a;
        }
        return i;
    }, t.getGF = function(t) {
        switch(t){
            case 4:
                return $849102574a83a574$var$Tt.AZTEC_PARAM;
            case 6:
                return $849102574a83a574$var$Tt.AZTEC_DATA_6;
            case 8:
                return $849102574a83a574$var$Tt.AZTEC_DATA_8;
            case 10:
                return $849102574a83a574$var$Tt.AZTEC_DATA_10;
            case 12:
                return $849102574a83a574$var$Tt.AZTEC_DATA_12;
            default:
                throw new $849102574a83a574$var$T("Unsupported word size " + t);
        }
    }, t.stuffBits = function(t, e) {
        for(var r = new $849102574a83a574$var$V, n = t.getSize(), o = (1 << e) - 2, i = 0; i < n; i += e){
            for(var a = 0, s = 0; s < e; s++)(i + s >= n || t.get(i + s)) && (a |= 1 << e - 1 - s);
            (a & o) === o ? (r.appendBits(a & o, e), i--) : 0 == (a & o) ? (r.appendBits(1 | a, e), i--) : r.appendBits(a, e);
        }
        return r;
    }, t.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.DEFAULT_EC_PERCENT = 33, t.DEFAULT_AZTEC_LAYERS = 0, t.MAX_NB_BITS = 32, t.MAX_NB_BITS_COMPACT = 4, t.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
}();
var $849102574a83a574$var$Pi = function(t) {
    return t instanceof Date;
}, $849102574a83a574$var$Bi = function(t) {
    return null == t;
}, $849102574a83a574$var$Li = function(t) {
    return "object" == typeof t;
}, $849102574a83a574$var$Fi = function(t) {
    return !$849102574a83a574$var$Bi(t) && !Array.isArray(t) && $849102574a83a574$var$Li(t) && !$849102574a83a574$var$Pi(t);
}, $849102574a83a574$var$ki = function(t) {
    return $849102574a83a574$var$Bi(t) || !$849102574a83a574$var$Li(t);
};
function $849102574a83a574$var$xi(t, e) {
    if ($849102574a83a574$var$ki(t) || $849102574a83a574$var$ki(e)) return t === e;
    if ($849102574a83a574$var$Pi(t) && $849102574a83a574$var$Pi(e)) return t.getTime() === e.getTime();
    var r = Object.keys(t), n = Object.keys(e);
    if (r.length !== n.length) return !1;
    for(var o = 0, i = r; o < i.length; o++){
        var a = i[o], s = t[a];
        if (!n.includes(a)) return !1;
        if ("ref" !== a) {
            var u = e[a];
            if ($849102574a83a574$var$Pi(s) && $849102574a83a574$var$Pi(u) || $849102574a83a574$var$Fi(s) && $849102574a83a574$var$Fi(u) || Array.isArray(s) && Array.isArray(u) ? !$849102574a83a574$var$xi(s, u) : s !== u) return !1;
        }
    }
    return !0;
}
var $849102574a83a574$var$Vi = function(t) {
    var o = t.onResult, s = t.onError, f = t.scanDelay, h = t.hints, l = t.deviceId, d = t.stopDecoding, p = (0, $7fPBF.useRef)(!1), g = (0, $7fPBF.useRef)(o), y = (0, $7fPBF.useRef)(s), w = (0, $7fPBF.useRef)(null), v = (0, $7fPBF.useState)(t.constraints), _ = v[0], A = v[1], C = (0, $7fPBF.useMemo)(function() {
        return new $849102574a83a574$var$Co(h, f);
    }, []), m = (0, $7fPBF.useCallback)(function(t, e) {
        if (t && g.current(t), e) {
            if (e instanceof $849102574a83a574$var$tt) return;
            if (e instanceof DOMException && "IndexSizeError" === e.name) return;
            y.current(e);
        }
    }, []), E = (0, $7fPBF.useCallback)(function() {
        C.reset();
    }, [
        C
    ]), I = (0, $7fPBF.useCallback)(function() {
        C.stopAsyncDecode();
    }, [
        C
    ]), S = (0, $7fPBF.useCallback)(function() {
        return $849102574a83a574$var$u(void 0, void 0, void 0, function() {
            var t, e;
            return $849102574a83a574$var$c(this, function(r) {
                switch(r.label){
                    case 0:
                        if (!w.current) return [
                            2
                        ];
                        r.label = 1;
                    case 1:
                        return r.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]), l ? [
                            4,
                            C.decodeFromVideoDevice(l, w.current, m)
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        return r.sent(), [
                            3,
                            5
                        ];
                    case 3:
                        return t = {
                            audio: !1,
                            video: _
                        }, [
                            4,
                            C.decodeFromConstraints(t, w.current, m)
                        ];
                    case 4:
                        r.sent(), r.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        return e = r.sent(), y.current(e), [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        C,
        l,
        _,
        m
    ]);
    return (0, $7fPBF.useEffect)(function() {
        if (p.current = !0, !d) return $849102574a83a574$var$u(void 0, void 0, void 0, function() {
            return $849102574a83a574$var$c(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            S()
                        ];
                    case 1:
                        return t.sent(), p.current || E(), [
                            2
                        ];
                }
            });
        }), function() {
            p.current = !1, E();
        };
        I();
    }, [
        S,
        E,
        d
    ]), (0, $7fPBF.useEffect)(function() {
        $849102574a83a574$var$xi(t.constraints, _) || A(t.constraints);
    }, [
        t.constraints
    ]), (0, $7fPBF.useEffect)(function() {
        g.current = o;
    }, [
        o
    ]), (0, $7fPBF.useEffect)(function() {
        y.current = s;
    }, [
        s
    ]), {
        ref: w,
        start: S,
        stop: d
    };
}, $849102574a83a574$var$Hi = {
    width: "100%",
    paddingTop: "100%",
    overflow: "hidden",
    position: "relative"
}, $849102574a83a574$var$Ui = {
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "block",
    overflow: "hidden",
    position: "absolute"
}, $849102574a83a574$export$646b390d8bcaeffa = function(r) {
    var n = r.containerStyle, o = r.videoStyle, i = r.constraints, a = void 0 === i ? $849102574a83a574$var$f : i, u = r.onResult, c = r.onDecode, h = r.viewFinder, l = r.hideCount, d = void 0 === l || l, p = r.tracker, y = void 0 !== p && p, w = r.viewFinderBorder, v = r.deviceId, _ = r.scanDelay, A = void 0 === _ ? 100 : _, C = function(t, e) {
        var r = {};
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for(n = Object.getOwnPropertySymbols(t); o < n.length; o++)e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
        }
        return r;
    }(r, [
        "containerStyle",
        "videoStyle",
        "constraints",
        "onResult",
        "onDecode",
        "viewFinder",
        "hideCount",
        "tracker",
        "viewFinderBorder",
        "deviceId",
        "scanDelay"
    ]), m = (0, $7fPBF.useState)(0), E = m[0], I = m[1], S = (0, $7fPBF.useState)(), T = S[0], O = S[1], b = $849102574a83a574$var$Vi($849102574a83a574$var$s({
        onResult: function(t) {
            O(t), u && u(t), c && c(t.getText()), I(function(t) {
                return t + 1;
            });
        },
        constraints: a,
        deviceId: v,
        scanDelay: A
    }, C)).ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: $849102574a83a574$var$s($849102574a83a574$var$s({}, $849102574a83a574$var$Hi), n)
    }, h ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(h, null) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$g, {
        video: b.current,
        result: T,
        scanCount: E,
        hideCount: d,
        tracker: y,
        border: w,
        constraints: a,
        deviceId: v,
        scanDelay: A
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("video", {
        ref: b,
        muted: !0,
        playsInline: !0,
        style: $849102574a83a574$var$s($849102574a83a574$var$s({}, $849102574a83a574$var$Ui), o)
    }));
};










const $2c83668c7225148c$export$c09d334c0c34284f = ({ isOpen: isOpen, setIsOpen: setIsOpen, onNewAlbum: onNewAlbum })=>{
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const searchDiscogsReleases = (0, $077dae512f6645b2$export$d4d8dffaf282d15e)();
    const { addAlbumFromDiscogsRelease: addAlbumFromDiscogsRelease } = (0, $875c05cc6cad5add$export$92d4b7f9aa493bb1)();
    const [releases, setReleases] = (0, $7fPBF.useState)([]);
    const [shouldUploadImage, setShouldUploadImage] = (0, $7fPBF.useState)(false);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [isBackCamera, setIsBackCamera] = (0, $7fPBF.useState)(true);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isCameraOpen, setIsCameraOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [noResultsText, setNoResultsText] = (0, $7fPBF.useState)("");
    const { checkDiscogsAccess: checkDiscogsAccess } = (0, $80d0eef5d5d87b2a$export$f0302bce0203d803)(setAlertMessage, setIsAlertOpen, setIsLoading, ()=>{});
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const performSearch = async (query)=>{
        if (query == "") return;
        // Remove leading zeroes
        query = query.replace(/^0+/, "");
        setNoResultsText("");
        setIsLoading(true);
        const { status: status, body: body } = await searchDiscogsReleases(query);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setReleases(body);
            if (!body || body.length == 0) setNoResultsText(searchText);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const addAlbum = async (release)=>{
        setIsLoading(true);
        const { status: status, body: body } = await addAlbumFromDiscogsRelease({
            releaseId: release.id,
            shouldUploadImage: shouldUploadImage
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_created);
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("new_album_manual", {
                user_id: currentUser.uuid,
                album_id: body.uuid
            });
            (0, $a8465eea29ce6625$export$e95767ffe2e60cec).resetAttributeData();
            onNewAlbum(body);
            setIsOpen(false);
        } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
            setAlertMessage(body.message);
            setIsPurchaseAlertOpen(true);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen || currentUser?.role == "guest") return;
        checkDiscogsAccess().then();
    }, [
        isOpen
    ]);
    const handleClose = async ()=>{
        if (isLoading) return;
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        open: isOpen,
        onClose: handleClose,
        PaperProps: {
            style: {
                height: "100%"
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_scan_barcode
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.scanBarcode()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: isLoading,
                        onClick: handleClose,
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    spacing: 2,
                    sx: {
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_camera,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).PhotoCamera,
                                    highlighted: isCameraOpen,
                                    onClick: ()=>setIsCameraOpen((state)=>!state)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a0061c129e65f3f2$exports))).searchBar,
                                    onSearchRequested: (text)=>setSearchText(text),
                                    onSearchDismissed: ()=>setSearchText(""),
                                    forceThisText: searchText
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_search_albums,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).TravelExplore,
                                    disabled: searchText == "",
                                    onClick: ()=>performSearch(searchText)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                            sx: {
                                width: "100%"
                            },
                            disabled: currentUser?.role != (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium,
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                checked: shouldUploadImage,
                                onChange: ()=>setShouldUploadImage((state)=>!state)
                            }),
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a0061c129e65f3f2$exports))).checkboxHelpText,
                                        style: {
                                            color: theme.palette.primary.subtitle
                                        },
                                        children: currentUser?.role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).premium ? (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image_help : (0, $37bec70ed65ed924$export$21c51bc433c16634).discogs_should_upload_image_non_premium
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a0061c129e65f3f2$exports))).gridCard,
                            children: [
                                releases && releases.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 2,
                                    children: releases.map((release)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d2b72821d827c061$export$e2185054f8700420), {
                                            release: release,
                                            disabled: isLoading,
                                            onClick: ()=>addAlbum(release)
                                        }, release.id))
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                                    isLoading: isLoading,
                                    items: releases,
                                    emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2Add,
                                    emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).scan_barcode_title,
                                    emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).scan_barcode_description,
                                    searchText: noResultsText,
                                    canAdd: false
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                maxWidth: "md",
                open: isCameraOpen,
                onClose: ()=>setIsCameraOpen(false),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).camera_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).switch_camera,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CameraSwitch,
                                    highlighted: !isBackCamera,
                                    onClick: ()=>setIsBackCamera((state)=>!state)
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close,
                                onClick: ()=>setIsCameraOpen(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $849102574a83a574$export$646b390d8bcaeffa), {
                        onDecode: (result)=>{
                            setSearchText(result);
                            performSearch(result).then();
                            setIsCameraOpen(false);
                        },
                        onError: undefined,
                        constraints: {
                            facingMode: isBackCamera ? "environment" : "user"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};






const $29037ddeb6b216aa$export$b06a74b95a60638c = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const starCollection = (parameters)=>post("user/starCollection", parameters);
    return {
        starCollection: starCollection
    };
};



const $8502e866088b39b5$export$905187e34d047bf7 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const unstarCollection = (parameters)=>deleteRequest("user/starCollection", parameters);
    return {
        unstarCollection: unstarCollection
    };
};



const $a666711d4d5e3e38$export$676c84e8e9ddef64 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const incrementCollectionVisits = (collectionId)=>post("collections/visits", {
            collectionId: collectionId
        });
    return {
        incrementCollectionVisits: incrementCollectionVisits
    };
};





const $53c271ac6a38a71b$export$b8aada1353c6b9f5 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteAlbumsByFilter = (collectionId, sortOption, sortOrder, filterElements)=>{
        const filters = (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942).queryItems(filterElements);
        return deleteRequest("albums/all", {
            ...filters,
            collectionId: collectionId,
            sortOption: sortOption,
            sortOrder: sortOrder
        });
    };
    return {
        deleteAlbumsByFilter: deleteAlbumsByFilter
    };
};





const $e62ae314963e62ed$export$968a2ae1788e4250 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const copyPublicAlbum = (parameters)=>post("albums/copyPublic", parameters);
    return {
        copyPublicAlbum: copyPublicAlbum
    };
};







const $6c0e42cbfa296b17$export$c863d64da666ba67 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const copyImage = async (parameters)=>{
        const { status: status, body: body } = await post("images/copy", parameters);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) return body.thumbnail;
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).image_upload_error);
        return undefined;
    };
    return {
        copyImage: copyImage
    };
};












const $7894c1810ba19017$export$8d60e69bec6a4ed8 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getPasskeys = ()=>get("passkeys");
    return {
        getPasskeys: getPasskeys
    };
};


const $f60096ac8916eb37$export$ab7cbdc6c8c8d55c = ({ isPublic: isPublic, onPlayFromYouTube: onPlayFromYouTube })=>{
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [currentPublicUserProfile, setCurrentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const [needMoreAllAlbums, setNeedMoreAllAlbums] = (0, $7fPBF.useState)(false);
    const { getCurrentFilterElements: getCurrentFilterElements, getCurrentIsNegated: getCurrentIsNegated, getCurrentFilterSortOption: getCurrentFilterSortOption, getCurrentFilterSortOrder: getCurrentFilterSortOrder, getFilterElementsWithSearchText: getFilterElementsWithSearchText, getSearchText: getSearchText } = (0, $228a7d38c61fd0fd$export$1fa08d0344d4319f)(false);
    const initialFilterElements = ()=>isPublic ? [] : getCurrentFilterElements();
    const initialIsNegated = ()=>isPublic ? (0, $c4f51e0bfb342785$export$83592602d06445ed)() : getCurrentIsNegated();
    const initialFilterSortOption = ()=>isPublic ? (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST : getCurrentFilterSortOption();
    const initialFilterSortOrder = ()=>isPublic ? (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT : getCurrentFilterSortOrder();
    const [, setCurrentPrivateFilterElements] = (0, $228a7d38c61fd0fd$export$a0e69501e318daaa).useState();
    const [filterElements, setFilterElements] = (0, $7fPBF.useState)(initialFilterElements());
    const [, setCurrentPrivateIsNegated] = (0, $228a7d38c61fd0fd$export$4c3e6e907095cf64).useState();
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)(initialIsNegated());
    const [, setCurrentPrivateFilterSortOption] = (0, $228a7d38c61fd0fd$export$8c2d3154064d3bf7).useState();
    const [sortOption, setSortOption] = (0, $7fPBF.useState)(initialFilterSortOption());
    const [, setCurrentPrivateFilterSortOrder] = (0, $228a7d38c61fd0fd$export$3f798b32817b3210).useState();
    const [sortOrder, setSortOrder] = (0, $7fPBF.useState)(initialFilterSortOrder());
    const [isDragging, setIsDragging] = (0, $7fPBF.useState)(false);
    const [isAddingBoxSet, setIsAddingBoxSet] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isLoadingSharedAlbum, setIsLoadingSharedAlbum] = (0, $7fPBF.useState)(false);
    const [isStarLoading, setIsStarLoading] = (0, $7fPBF.useState)(false);
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [isAlbumListDrawerOpen, setIsAlbumListDrawerOpen] = (0, $7fPBF.useState)(isMobile);
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    const [randomAlbumQuantity, setRandomAlbumQuantity] = (0, $7fPBF.useState)(10);
    const [isRandomAlbumsAlertOpen, setIsRandomAlbumsAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAlbumsFilterDialogOpen, setIsAlbumsFilterDialogOpen] = (0, $7fPBF.useState)(false);
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteAlbumsDialogOpen, setIsDeleteAlbumsDialogOpen] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const { addAlbum: addAlbum } = (0, $5dbf7db1b02fd0a2$export$ef300a5e723fa926)();
    const { copyPublicAlbum: copyPublicAlbum } = (0, $e62ae314963e62ed$export$968a2ae1788e4250)();
    const { copyImage: copyImage } = (0, $6c0e42cbfa296b17$export$c863d64da666ba67)();
    const { getAlbum: getAlbum } = (0, $3e1655feb131ddb8$export$9d3256d72c51d563)();
    const { updateAlbum: updateAlbum } = (0, $344d6f8e57c6af94$export$1675ec48d869475b)();
    const { reorderBoxSetAlbums: reorderBoxSetAlbums } = (0, $2e8286f94e8feada$export$707988506c253900)();
    const { addAlbumToBoxSet: addAlbumToBoxSet } = (0, $a41b2b51b84e686f$export$6e059a7e11b5975e)();
    const [selectedAlbum, setSelectedAlbum] = (0, $7fPBF.useState)();
    const { deleteAlbumsByFilter: deleteAlbumsByFilter } = (0, $53c271ac6a38a71b$export$b8aada1353c6b9f5)();
    const { getCurrentCollection: getCurrentCollection, isCurrentCollectionShareable: isCurrentCollectionShareable } = (0, $6e65290b51df31d1$export$1da6a00f03e1826a)();
    const [currentPublicCollection, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [currentPrivateCollection, setCurrentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const [scrollToTopAlbumList, setScrollToTopAlbumList] = (0, $7fPBF.useState)(false);
    const { getSharedContent: getSharedContent } = (0, $634bd4e2c1d0f775$export$ed78f3fcf760f407)();
    const { incrementCollectionVisits: incrementCollectionVisits } = (0, $a666711d4d5e3e38$export$676c84e8e9ddef64)();
    const { getPrivateContent: getPrivateContent } = (0, $75a27fb32476e886$export$76e455b2766b00bd)();
    const { starCollection: starCollection } = (0, $29037ddeb6b216aa$export$b06a74b95a60638c)();
    const { unstarCollection: unstarCollection } = (0, $8502e866088b39b5$export$905187e34d047bf7)();
    const [isAddAlbumDialogOpen, setIsAddAlbumDialogOpen] = (0, $7fPBF.useState)(false);
    const [isBarcodeScannerDialogOpen, setIsBarcodeScannerDialogOpen] = (0, $7fPBF.useState)(false);
    const [shareLinkComponents, fetchShareLink, , isShareLoading] = (0, $bed6df3ee0929f14$export$cc4cb9d785f3b827)(getCurrentCollection(isPublic)?.name);
    const [isPublicUserProfileDialogOpen, setIsPublicUserProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const location = (0, $d42da6e692e216cc$export$45d76561a5302f2b)();
    const { registerPasskey: registerPasskey } = (0, $de36d9deb0a855aa$export$60838eccc434628e)();
    const { getPasskeys: getPasskeys } = (0, $7894c1810ba19017$export$8d60e69bec6a4ed8)();
    (0, $7fPBF.useEffect)(()=>{
        if (!localStorage.getItem("shownPasskeyAlert")) {
            localStorage.setItem("shownPasskeyAlert", "x");
            checkPasskey().then();
        }
    }, []);
    const checkPasskey = async ()=>{
        const { status: status, body: body } = await getPasskeys();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status) && body.length == 0) await registerPasskey(()=>{
            setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).passkey_register_success);
            setIsAlertOpen(true);
        }, (message)=>{
            setAlertMessage(message);
            setIsAlertOpen(true);
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const mainTitle = isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).option_marketplace : (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_title;
        if (!selectedAlbum) document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${mainTitle}`;
        else document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${selectedAlbum.name}`;
    }, [
        isPublic,
        selectedAlbum
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isPublic) setCurrentPrivateFilterElements(filterElements);
    }, [
        filterElements
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isPublic) setCurrentPrivateIsNegated(isNegated);
    }, [
        isNegated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isPublic) setCurrentPrivateFilterSortOption(sortOption);
    }, [
        sortOption
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isPublic) setCurrentPrivateFilterSortOrder(sortOrder);
    }, [
        sortOrder
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setFilterElements(initialFilterElements());
        setIsNegated(initialIsNegated());
        setSortOption(initialFilterSortOption());
        setSortOrder(initialFilterSortOrder());
    }, [
        isPublic
    ]);
    const onError = (body)=>{
        if (isMounted.current) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const onLoading = (isLoading)=>{
        if (isMounted.current) setIsLoading(isLoading);
    };
    const isFilterUnapplied = ()=>{
        return (!filterElements || filterElements.length == 0) && sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST && sortOrder == (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT;
    };
    const { defaultLayout: defaultLayout, onLayoutChanged: onLayoutChanged } = (0, $c48912b423983456$export$2bb3f65002f7b42d)({
        groupId: "albums-page",
        storage: localStorage
    });
    const [albums, setAlbumsOnStorage, resetAlbumsStorage, moveAlbums, deleteAlbumFromStorage, noMoreAlbums, isFetchingAlbums] = (0, $2738696e81957cce$export$93582110ed982a24)(true, isPublic ? "public" : "private", !isFilterUnapplied(), isNegated, sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM ? randomAlbumQuantity : (0, $024c4fa431281881$export$bda6e9c83e7e0f97).albums(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), onLoading, onError, (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search).link, filterElements, sortOption, sortOrder, [
        needMoreAllAlbums
    ]);
    const resetAlbumStorage = ()=>{
        setScrollToTopAlbumList((state)=>!state);
        resetAlbumsStorage();
    };
    const getNewAlbums = (albums, newAlbum)=>{
        if (!albums) return undefined;
        return albums.map((section)=>{
            return section.map((album)=>album.uuid == newAlbum.uuid ? newAlbum : album);
        });
    };
    const setAlbums = (newAlbum)=>{
        if (!selectedAlbum || selectedAlbum.uuid === newAlbum.uuid) setSelectedAlbum(newAlbum);
        setAlbumsOnStorage(getNewAlbums(albums, newAlbum));
    };
    const setNeedMoreAlbums = ()=>{
        if (isMounted.current) setNeedMoreAllAlbums((state)=>!state);
    };
    const isThereNoMoreAlbums = ()=>{
        if (isMounted.current) return noMoreAlbums;
    };
    (0, $7fPBF.useEffect)(()=>{
        resetAlbumStorage();
        setNeedMoreAlbums();
    }, [
        isPublic,
        isMobile,
        currentPrivateCollection,
        currentPublicCollection?.uuid,
        isNegated.collectionId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setSelectedAlbum(undefined);
    }, [
        isPublic
    ]);
    const isFilteredOnlyByArtists = ()=>{
        if (!filterElements || sortOption != (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST) return false;
        for (const filterElement of filterElements){
            if (filterElement.filterType != (0, $6768c4f2093234f5$export$c67e46de1ec7dfa6).ARTIST) return false;
        }
        return true;
    };
    const canMoveAlbums = ()=>{
        return !isMobile && !isLoading && !isPublic && (currentPrivateCollection === undefined || currentPrivateCollection?.uuid === undefined) && (isFilterUnapplied() || isFilteredOnlyByArtists());
    };
    const onAlbumDeleted = (deletedAlbum, section, index)=>{
        if (section && index) deleteAlbumFromStorage(section, index);
        if (selectedAlbum?.uuid == deletedAlbum.uuid || selectedAlbum?.isBoxSet) setSelectedAlbum(undefined);
        resetAlbumStorage();
        setNeedMoreAlbums();
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_deleted);
    };
    const onAlbumCopy = async (album)=>{
        setIsLoading(true);
        const { status: status, body: body } = await addAlbum({
            ...album,
            artistId: album.artist?.uuid,
            collections: undefined
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            if (album.hasImage) {
                const thumbnail = await copyImage({
                    source: album.uuid,
                    destination: body.uuid
                });
                if (thumbnail) {
                    body.hasImage = true;
                    body.thumbnail = thumbnail;
                }
            }
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_created);
            setSelectedAlbum(body);
            resetAlbumStorage();
            setNeedMoreAlbums();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const onAlbumCopyPublic = async (album)=>{
        setIsLoading(true);
        const { status: status, body: body } = await copyPublicAlbum({
            ...album,
            artistName: album.artist?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown,
            labelName: album.label?.name,
            albumTypeName: album.albumType?.name
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("copy_album", {
                user_id: currentUserProfile.userId,
                album_id: album.uuid
            });
            if (album.hasImage) await copyImage({
                source: album.uuid,
                destination: body.uuid
            });
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).album_created);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const onAlbumMarkAs = async (album, sellStatus)=>{
        setIsLoading(true);
        const { status: status, body: body } = await updateAlbum({
            uuid: album.uuid,
            sellStatus: sellStatus
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            album.sellStatus = sellStatus ?? undefined;
            if (selectedAlbum?.uuid == album.uuid) setSelectedAlbum(body);
            setAlbums(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const moveBoxSetAlbums = async (source, destination)=>{
        (0, $3c32b049e9065866$export$79f3cf326dbd2413)(selectedAlbum.boxSetAlbums, source, destination);
        setIsLoading(true);
        const { status: status } = await reorderBoxSetAlbums(selectedAlbum.uuid, selectedAlbum.boxSetAlbums);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            selectedAlbum.boxSetAlbums.forEach((album, index)=>album.order = index);
        } else {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).album_update_error);
            (0, $3c32b049e9065866$export$79f3cf326dbd2413)(selectedAlbum.boxSetAlbums, destination, source);
        }
        setIsLoading(false);
    };
    const addAlbumToCurrentBoxSet = async (sourceAlbum, destinationIndex)=>{
        setIsLoading(true);
        const oldArtist = selectedAlbum.artist;
        const { status: status, body: body } = await addAlbumToBoxSet({
            boxSetAlbumId: selectedAlbum.uuid,
            albumId: sourceAlbum.uuid,
            order: destinationIndex
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setSelectedAlbum(body);
            if (oldArtist?.uuid != body.artist?.uuid) {
                resetAlbumStorage();
                setNeedMoreAlbums();
            }
        } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isDuplicatedResource(status)) (0, $040541d7bfcee3b2$export$b410431fab84fa58).error((0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_unique_error);
        else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
        setIsLoading(false);
    };
    const onDragEnd = async (result)=>{
        if (!result.destination) return;
        setIsDragging(false);
        const sourceListId = result.draggableId.split("_")[2];
        const destinationListId = result.destination.droppableId.split("_")[2];
        const sourceSection = +result.draggableId.split("_")[0];
        if (destinationListId == "box") {
            if (sourceListId == destinationListId) {
                if (result.source.index == result.destination.index) return;
                await moveBoxSetAlbums(result.source.index, result.destination.index);
            } else {
                const sourceAlbum = albums[sourceSection][result.source.index];
                await addAlbumToCurrentBoxSet(sourceAlbum, result.destination.index);
            }
        } else if (sourceListId != "box") {
            const destinationSection = +result.destination.droppableId.split("_")[1];
            if (result.source.index == result.destination.index || sourceSection !== destinationSection) return;
            await moveAlbums(sourceSection, result.source.index, result.destination.index);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        const queryParams = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search);
        if (queryParams.oauth_token && queryParams.oauth_verifier) setIsOpenDiscogsImport(true);
        if (window.location.pathname == (0, $5ac8335867650de3$export$12d836cf94aabb97).share()) {
            const shareLink = queryParams.link;
            if (typeof shareLink == "string") fetchSharedContent(shareLink).then();
            else navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list());
        } else if (window.location.pathname == (0, $5ac8335867650de3$export$12d836cf94aabb97).private()) {
            const privateLink = queryParams.link;
            if (typeof privateLink == "string") fetchPrivateContent(privateLink).then();
            else navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list());
        }
    }, []);
    const fetchSharedContent = async (shareLink)=>{
        setIsLoadingSharedAlbum(true);
        const { status: status, body: body } = await getSharedContent({
            shareLink: shareLink
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            incrementCollectionVisits(body.collection.uuid).then();
            setCurrentPublicCollection(body.collection);
            setCurrentPublicUserProfile(body.userProfile);
            if (body.album) setSelectedAlbum(body.album);
        } else navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).notFound());
        setIsLoadingSharedAlbum(false);
    };
    const fetchPrivateContent = async (privateLink)=>{
        setIsLoadingSharedAlbum(true);
        const { status: status, body: body } = await getPrivateContent({
            privateLink: privateLink
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setSelectedAlbum(body.album);
        else navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).notFound());
        setIsLoadingSharedAlbum(false);
    };
    const currentAlbumUuid = (0, $7fPBF.useRef)("");
    const getAlbumDetails = async ()=>{
        currentAlbumUuid.current = selectedAlbum?.uuid;
        if (!selectedAlbum) return;
        const { status: status, body: body } = await getAlbum(selectedAlbum.uuid);
        // Discard result if album changed
        if (currentAlbumUuid.current !== selectedAlbum?.uuid) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setSelectedAlbum(body);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const onNewAlbum = (newAlbum)=>{
        resetAlbumStorage();
        setNeedMoreAlbums();
        setSelectedAlbum(newAlbum);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isPublic) return;
        getAlbumDetails().then();
    }, [
        selectedAlbum?.uuid
    ]);
    const goToUserProfile = ()=>{
        navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile());
    };
    const processStarResponse = (status, body)=>{
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            if (currentPublicCollection?.uuid) setCurrentPublicCollection({
                ...currentPublicCollection,
                isStarred: !currentPublicCollection?.isStarred
            });
        } else (0, $040541d7bfcee3b2$export$b410431fab84fa58).error(body.message);
        setIsStarLoading(false);
    };
    const deleteAlbums = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteAlbumsByFilter(currentPrivateCollection?.uuid, sortOption, sortOrder, filterElements);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            resetAlbumStorage();
            setNeedMoreAlbums();
            setSelectedAlbum(undefined);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const albumList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf9b4cecdde85ae$export$ea09568aab55509f), {
            dragDropId: "main",
            isPublic: isPublic,
            albums: albums,
            selectedAlbumId: selectedAlbum?.uuid,
            sortOption: sortOption,
            canMoveAlbums: true,
            canDropAlbums: canMoveAlbums(),
            canLoadMoreAlbums: !isDragging,
            setNeedMoreAlbums: setNeedMoreAlbums,
            onAlbumSelected: (album)=>{
                setIsAlbumListDrawerOpen(false);
                if (selectedAlbum?.uuid != album.uuid) setSelectedAlbum(album);
                else setSelectedAlbum(undefined);
            },
            onAlbumDeleted: onAlbumDeleted,
            onAlbumCopy: isPublic ? onAlbumCopyPublic : onAlbumCopy,
            onAlbumMarkAs: onAlbumMarkAs,
            noMoreAlbums: isThereNoMoreAlbums(),
            albumCount: sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM ? randomAlbumQuantity : undefined,
            onNewAlbum: ()=>{
                setIsAddingBoxSet(false);
                setIsAddAlbumDialogOpen(true);
            },
            onScanBarcode: ()=>setIsBarcodeScannerDialogOpen(true),
            onImportFromDiscogs: ()=>setIsOpenDiscogsImport(true),
            onImportFromExcel: ()=>setIsOpenExcelImport(true),
            onFilterAlbums: ()=>setIsAlbumsFilterDialogOpen(true),
            onChangeCollection: ()=>setIsCollectionsDialogOpen(true),
            onEditProfile: goToUserProfile,
            onPlayFromYouTube: onPlayFromYouTube,
            scrollToTopTrigger: scrollToTopAlbumList,
            isForLayout: false,
            setLoading: setIsLoading
        });
    const toolbarButtons = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            direction: "row",
            style: {
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                    style: {
                        marginLeft: isMobile ? 0 : undefined,
                        marginRight: isMobile ? 0 : undefined,
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                            onClick: ()=>{
                                if (isLoading) return;
                                resetAlbumStorage();
                                setNeedMoreAlbums();
                            },
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).refresh_list,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Refresh,
                            disabled: isFetchingAlbums
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                            orientation: "vertical",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                            onClick: ()=>setIsAlbumsFilterDialogOpen(true),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_filter_albums,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAlt,
                            highlighted: !isFilterUnapplied(),
                            disabled: isFetchingAlbums
                        }),
                        !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                    orientation: "vertical",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f60096ac8916eb37$var$StyledBadge, {
                                    overlap: "circular",
                                    badgeContent: sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM ? randomAlbumQuantity : 0,
                                    color: "error",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                        onClick: ()=>setIsRandomAlbumsAlertOpen(true),
                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_random_albums,
                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Die,
                                        highlighted: sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM,
                                        disabled: isFetchingAlbums
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).searchBar,
                    onSearchRequested: (searchText)=>{
                        setFilterElements(getFilterElementsWithSearchText(searchText, filterElements));
                        resetAlbumStorage();
                        setNeedMoreAlbums();
                    },
                    onSearchDismissed: ()=>{
                        setFilterElements(getFilterElementsWithSearchText("", filterElements));
                        resetAlbumStorage();
                        setNeedMoreAlbums();
                    },
                    timed: true,
                    onLoading: onLoading,
                    forceThisText: getSearchText(filterElements),
                    disabled: isFetchingAlbums
                })
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).piperLogo,
                            onClick: ()=>{
                                setIsDrawerOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                            currentPage: isPublic ? "publicAlbums" : "albums",
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            isLayout: false,
                            isOpenDiscogsImport: isOpenDiscogsImport,
                            setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                            isOpenExcelImport: isOpenExcelImport,
                            setIsOpenExcelImport: setIsOpenExcelImport,
                            onFilterAlbumsClicked: ()=>{
                                if (isFetchingAlbums) return;
                                setIsAlbumsFilterDialogOpen(true);
                            },
                            onRandomAlbumsClicked: ()=>{
                                if (isFetchingAlbums) return;
                                setIsRandomAlbumsAlertOpen(true);
                            },
                            onNewAlbumClicked: ()=>{
                                setIsAddingBoxSet(false);
                                setIsAddAlbumDialogOpen(true);
                            },
                            onNewBoxSetClicked: ()=>{
                                setIsAddingBoxSet(true);
                                setIsAddAlbumDialogOpen(true);
                            },
                            onBarcodeScanClicked: ()=>setIsBarcodeScannerDialogOpen(true)
                        }),
                        isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>setIsAlbumListDrawerOpen(true),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_albums_list,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ListAlt
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            style: {
                                marginLeft: isMobile ? 0 : 8,
                                marginRight: isMobile ? 0 : undefined
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                sx: {
                                    maxHeight: 36
                                },
                                onClick: ()=>{
                                    if (isPublic) {
                                        if (!currentPublicUserProfile) return;
                                        setIsPublicUserProfileDialogOpen(true);
                                    } else setIsCollectionsDialogOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        sx: {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).collectionTitle,
                                            children: getCurrentCollection(isPublic) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).collectionTitleText,
                                                children: [
                                                    isNegated.collectionId && getCurrentCollection(isPublic)?.uuid && `(${(0, $37bec70ed65ed924$export$21c51bc433c16634).not_in}) `,
                                                    getCurrentCollection(isPublic)?.name
                                                ]
                                            }) : isPublic ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).collectionTitleText,
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_all_albums
                                            })
                                        })
                                    }),
                                    !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).expandIcon,
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ExpandAll
                                    })
                                ]
                            })
                        }),
                        (!isMobile || isPublic) && isCurrentCollectionShareable(isPublic) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).shareBox,
                            children: [
                                isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                            onClick: ()=>{
                                                const collectionId = currentPublicCollection?.uuid;
                                                if (!collectionId) return;
                                                setIsStarLoading(true);
                                                if (currentPublicCollection?.isStarred) unstarCollection({
                                                    collectionId: collectionId
                                                }).then((response)=>processStarResponse(response.status, response.body));
                                                else starCollection({
                                                    collectionId: collectionId
                                                }).then((response)=>processStarResponse(response.status, response.body));
                                            },
                                            tooltip: currentPublicCollection?.isStarred ? (0, $37bec70ed65ed924$export$21c51bc433c16634).unstar_collection : (0, $37bec70ed65ed924$export$21c51bc433c16634).star_collection,
                                            loading: isStarLoading,
                                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KidStar,
                                            filled: currentPublicCollection?.isStarred
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                            flexItem: true,
                                            orientation: "vertical"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    onClick: ()=>{
                                        const collectionId = getCurrentCollection(isPublic)?.uuid;
                                        if (!collectionId) return;
                                        fetchShareLink(collectionId, undefined).then();
                                    },
                                    loading: isShareLoading,
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).share_collection,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Share,
                                    iconClassName: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).shareButtonIcon
                                })
                            ]
                        }),
                        !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            style: {
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    onClick: ()=>{
                                        setIsAddingBoxSet(false);
                                        setIsAddAlbumDialogOpen(true);
                                    },
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_album,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddAd
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                    flexItem: true,
                                    orientation: "vertical"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_scan_barcode,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).QRCode2Add,
                                    onClick: ()=>setIsBarcodeScannerDialogOpen(true)
                                }),
                                !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                                            flexItem: true,
                                            orientation: "vertical"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                                            onClick: ()=>{
                                                setIsAddingBoxSet(true);
                                                setIsAddAlbumDialogOpen(true);
                                            },
                                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_box_set,
                                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).BoxAdd
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isMobile && toolbarButtons(),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            style: {
                                marginLeft: isMobile ? 0 : undefined
                            },
                            onClick: ()=>{
                                setSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
                                setSortOrder((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
                                setFilterElements([]);
                                resetAlbumStorage();
                                setNeedMoreAlbums();
                            },
                            onContextMenu: handleContextMenu,
                            disabled: isFilterUnapplied() || isLoading,
                            loading: isLoading,
                            tooltip: isLoading ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_filter,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAltOff,
                            color: theme.palette.colors?.remove
                        }),
                        !isPublic && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                            ...menuProps,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                disabled: isLoading,
                                onClick: ()=>{
                                    handleMenuClose();
                                    setIsDeleteAlbumsDialogOpen(true);
                                },
                                sx: {
                                    color: theme.palette.colors?.remove
                                },
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                        sx: {
                                            color: theme.palette.colors?.remove
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteSweep
                                        })
                                    }),
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all,
                            description: filterElements ? (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all_filter_confirmation_message : (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all_confirmation_message,
                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all_placeholder,
                            missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing_short,
                            canClear: false,
                            open: isDeleteAlbumsDialogOpen,
                            onClose: ()=>setIsDeleteAlbumsDialogOpen(false),
                            isNumber: false,
                            onChange: deleteAlbums,
                            matchText: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_delete_all_placeholder
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $921bd0ad6d18d264$export$7bf40cd2a197df2d), {
                            isPublic: isPublic,
                            userProfile: isPublic ? currentPublicUserProfile : currentUserProfile,
                            onClick: ()=>{
                                if (!isPublic) {
                                    if (!currentUserProfile || currentUser?.role == "guest") return;
                                    goToUserProfile();
                                } else {
                                    if (!currentPublicUserProfile) return;
                                    setIsPublicUserProfileDialogOpen(true);
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e69fa77bf557686c$export$237bd83162c14364), {
                onDragStart: ()=>setIsDragging(true),
                onDragEnd: onDragEnd,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$eb2fcfdbd7ba97d4), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).mainBody,
                        defaultLayout: defaultLayout,
                        onLayoutChanged: onLayoutChanged,
                        orientation: "horizontal",
                        children: [
                            !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                id: "left",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).albumListContainer,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                minSize: "6",
                                defaultSize: "28",
                                maxSize: "40",
                                children: albumList()
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$1ff3c3f08ae963c0), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).resizeHandle,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                                    style: {
                                        alignSelf: "center",
                                        color: theme.palette.secondary.main,
                                        fontSize: 14
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                id: "right",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).albumDetail,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f7fcbfd922a22ac$export$24c4ce0a92786a82), {
                                        isPublic: isPublic,
                                        isLoadingSharedAlbum: isLoadingSharedAlbum,
                                        album: selectedAlbum,
                                        onAttributeUpdated: setAlbums,
                                        onArtistUpdated: ()=>{
                                            resetAlbumStorage();
                                            setNeedMoreAlbums();
                                        },
                                        onPlayFromYouTube: onPlayFromYouTube,
                                        onNewAlbum: ()=>{
                                            setIsAddingBoxSet(false);
                                            setIsAddAlbumDialogOpen(true);
                                        },
                                        onScanBarcode: ()=>setIsBarcodeScannerDialogOpen(true),
                                        onImportFromDiscogs: ()=>setIsOpenDiscogsImport(true),
                                        onImportFromExcel: ()=>setIsOpenExcelImport(true),
                                        onFilterAlbums: ()=>setIsAlbumsFilterDialogOpen(true),
                                        onRandomAlbums: ()=>setIsRandomAlbumsAlertOpen(true),
                                        onChangeCollection: ()=>setIsCollectionsDialogOpen(true),
                                        onEditProfile: goToUserProfile,
                                        onCopy: async ()=>{
                                            if (!selectedAlbum) return;
                                            await onAlbumCopy(selectedAlbum);
                                        },
                                        onDelete: async ()=>{
                                            if (!selectedAlbum) return;
                                            onAlbumDeleted(selectedAlbum);
                                        },
                                        onMarkAs: async (sellStatus)=>{
                                            if (!selectedAlbum) return;
                                            await onAlbumMarkAs(selectedAlbum, sellStatus);
                                        },
                                        onDeleteFromBoxSet: (newBoxSet)=>{
                                            if (selectedAlbum.artist?.uuid != newBoxSet.artist?.uuid) {
                                                resetAlbumStorage();
                                                setNeedMoreAlbums();
                                            }
                                            setSelectedAlbum(newBoxSet);
                                        },
                                        onAddAlbumToBoxSet: (album)=>addAlbumToCurrentBoxSet(album, selectedAlbum.boxSetAlbums?.length),
                                        onAlbumSelected: setSelectedAlbum,
                                        onBoxSetSelected: ()=>setSelectedAlbum(selectedAlbum.boxSet),
                                        setLoading: setIsLoading
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
                                ]
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a2822b215697a959$export$2e2bcd8739ae039), {
                        PaperProps: {
                            sx: {
                                backgroundColor: theme.palette.background.default
                            }
                        },
                        ModalProps: {
                            keepMounted: true
                        },
                        anchor: "left",
                        open: isAlbumListDrawerOpen,
                        onOpen: ()=>setIsAlbumListDrawerOpen(true),
                        onClose: ()=>setIsAlbumListDrawerOpen(false),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                width: "80vw",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                                    position: "sticky",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($41963598944a220e$exports))).toolbar,
                                        disableGutters: true,
                                        children: [
                                            toolbarButtons(),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                flexGrow: 1
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                                style: {
                                                    marginLeft: isMobile ? 0 : undefined,
                                                    marginRight: isMobile ? 0 : undefined
                                                },
                                                loading: isLoading,
                                                onClick: ()=>setIsAlbumListDrawerOpen(false),
                                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                            })
                                        ]
                                    })
                                }),
                                albumList()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c808fedb1be9403$export$3680ec4d69de4745), {
                open: isAddAlbumDialogOpen,
                setOpen: setIsAddAlbumDialogOpen,
                callback: onNewAlbum,
                isBoxSet: isAddingBoxSet
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91af23ad81bff193$export$182c0961afa42490), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_random_albums,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).random_albums_message,
                canClear: false,
                open: isRandomAlbumsAlertOpen,
                setOpen: setIsRandomAlbumsAlertOpen,
                value: randomAlbumQuantity,
                maxValue: 30,
                onChange: (quantity)=>{
                    if (!quantity) return;
                    setRandomAlbumQuantity(quantity);
                    setSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).RANDOM);
                    resetAlbumStorage();
                    setNeedMoreAlbums();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d770713ca8a8afe1$export$1737516aa6af7a33), {
                isPublic: isPublic,
                isOpen: isAlbumsFilterDialogOpen,
                setIsOpen: setIsAlbumsFilterDialogOpen,
                initialFilterElements: filterElements,
                initialIsNegated: isNegated,
                initialSortOption: sortOption,
                initialSortOrder: sortOrder,
                onFilterApplied: (filterElements, isNegated, sortOption, sortOrder)=>{
                    setIsNegated(isNegated);
                    setSortOption(sortOption);
                    setSortOrder(sortOrder);
                    setFilterElements(filterElements);
                    resetAlbumStorage();
                    setNeedMoreAlbums();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: false,
                canModifyCollections: false,
                displayStandardCollections: true,
                onCollectionSelected: (collection, isNegated)=>{
                    setCurrentPrivateCollection(collection);
                    setIsNegated(isNegated);
                    setSelectedAlbum(undefined);
                    setIsAlbumListDrawerOpen(true);
                },
                selectedCollections: [
                    currentPrivateCollection?.uuid
                ],
                forceLoading: isLoading,
                canNegate: true
            }),
            shareLinkComponents(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c83668c7225148c$export$c09d334c0c34284f), {
                isOpen: isBarcodeScannerDialogOpen,
                setIsOpen: setIsBarcodeScannerDialogOpen,
                onNewAlbum: onNewAlbum
            }),
            currentPublicUserProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00fb49d9eec338cb$export$9bba71c7759c348b), {
                userProfile: currentPublicUserProfile,
                isOpen: isPublicUserProfileDialogOpen,
                setIsOpen: setIsPublicUserProfileDialogOpen,
                onPublicCollectionChanged: ()=>{
                    setIsPublicUserProfileDialogOpen(false);
                    setSelectedAlbum(undefined);
                },
                showCollectionInfo: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};
const $f60096ac8916eb37$var$StyledBadge = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039))(()=>({
        "& .MuiBadge-badge": {
            right: 12,
            top: 9
        }
    }));


const $dc9cae3c17fe3491$export$5cc8a80f4112c6ed = ({ isPublic: isPublic, onPlayFromYouTube: onPlayFromYouTube })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f60096ac8916eb37$export$ab7cbdc6c8c8d55c), {
        isPublic: isPublic,
        onPlayFromYouTube: onPlayFromYouTube
    });
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $8909c318ea8e18cb$exports = {};

$parcel$export($8909c318ea8e18cb$exports, "appBar", function () { return $8909c318ea8e18cb$export$d0a9b8580e71599c; }, function (v) { return $8909c318ea8e18cb$export$d0a9b8580e71599c = v; });
$parcel$export($8909c318ea8e18cb$exports, "attributeDetail", function () { return $8909c318ea8e18cb$export$92fc499ca604799e; }, function (v) { return $8909c318ea8e18cb$export$92fc499ca604799e = v; });
$parcel$export($8909c318ea8e18cb$exports, "attributeListContainer", function () { return $8909c318ea8e18cb$export$abd6b95c03af1012; }, function (v) { return $8909c318ea8e18cb$export$abd6b95c03af1012 = v; });
$parcel$export($8909c318ea8e18cb$exports, "credits", function () { return $8909c318ea8e18cb$export$68c7321cb43cac49; }, function (v) { return $8909c318ea8e18cb$export$68c7321cb43cac49 = v; });
$parcel$export($8909c318ea8e18cb$exports, "mainBody", function () { return $8909c318ea8e18cb$export$f239b04fc1a0c7e1; }, function (v) { return $8909c318ea8e18cb$export$f239b04fc1a0c7e1 = v; });
$parcel$export($8909c318ea8e18cb$exports, "mainContent", function () { return $8909c318ea8e18cb$export$ad430d422a89f9f0; }, function (v) { return $8909c318ea8e18cb$export$ad430d422a89f9f0 = v; });
$parcel$export($8909c318ea8e18cb$exports, "noSelectionDiv", function () { return $8909c318ea8e18cb$export$47d0c9314a8d5020; }, function (v) { return $8909c318ea8e18cb$export$47d0c9314a8d5020 = v; });
$parcel$export($8909c318ea8e18cb$exports, "shortcutsGrid", function () { return $8909c318ea8e18cb$export$c0d082e4d02b6893; }, function (v) { return $8909c318ea8e18cb$export$c0d082e4d02b6893 = v; });
$parcel$export($8909c318ea8e18cb$exports, "shortcutsTitle", function () { return $8909c318ea8e18cb$export$a181c7b826173297; }, function (v) { return $8909c318ea8e18cb$export$a181c7b826173297 = v; });
$parcel$export($8909c318ea8e18cb$exports, "title", function () { return $8909c318ea8e18cb$export$fb184b623420d9be; }, function (v) { return $8909c318ea8e18cb$export$fb184b623420d9be = v; });
$parcel$export($8909c318ea8e18cb$exports, "toolbar", function () { return $8909c318ea8e18cb$export$f727f52c778e92d5; }, function (v) { return $8909c318ea8e18cb$export$f727f52c778e92d5 = v; });
var $8909c318ea8e18cb$export$d0a9b8580e71599c;
var $8909c318ea8e18cb$export$92fc499ca604799e;
var $8909c318ea8e18cb$export$abd6b95c03af1012;
var $8909c318ea8e18cb$export$68c7321cb43cac49;
var $8909c318ea8e18cb$export$f239b04fc1a0c7e1;
var $8909c318ea8e18cb$export$ad430d422a89f9f0;
var $8909c318ea8e18cb$export$47d0c9314a8d5020;
var $8909c318ea8e18cb$export$c0d082e4d02b6893;
var $8909c318ea8e18cb$export$a181c7b826173297;
var $8909c318ea8e18cb$export$fb184b623420d9be;
var $8909c318ea8e18cb$export$f727f52c778e92d5;
$8909c318ea8e18cb$export$d0a9b8580e71599c = `_1Hs_Ca_appBar`;
$8909c318ea8e18cb$export$92fc499ca604799e = `_1Hs_Ca_attributeDetail`;
$8909c318ea8e18cb$export$abd6b95c03af1012 = `_1Hs_Ca_attributeListContainer`;
$8909c318ea8e18cb$export$68c7321cb43cac49 = `_1Hs_Ca_credits`;
$8909c318ea8e18cb$export$f239b04fc1a0c7e1 = `_1Hs_Ca_mainBody`;
$8909c318ea8e18cb$export$ad430d422a89f9f0 = `_1Hs_Ca_mainContent`;
$8909c318ea8e18cb$export$47d0c9314a8d5020 = `_1Hs_Ca_noSelectionDiv`;
$8909c318ea8e18cb$export$c0d082e4d02b6893 = `_1Hs_Ca_shortcutsGrid`;
$8909c318ea8e18cb$export$a181c7b826173297 = `_1Hs_Ca_shortcutsTitle`;
$8909c318ea8e18cb$export$fb184b623420d9be = `_1Hs_Ca_title`;
$8909c318ea8e18cb$export$f727f52c778e92d5 = `_1Hs_Ca_toolbar`;


















var $7fPBF = parcelRequire("7fPBF");







const $8bc7108f868acbb7$export$c2e16e3a65c471b0 = (setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getExchangeRates = (parameters)=>get("exchangeRates", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).exchangeRates(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), getExchangeRates, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).exchangeRateStorage, false, true);
};







var $7fPBF = parcelRequire("7fPBF");
var $9925272a533c7e7d$exports = {};

$parcel$export($9925272a533c7e7d$exports, "cancelButton", function () { return $9925272a533c7e7d$export$4ededb8e5b56a6fb; }, function (v) { return $9925272a533c7e7d$export$4ededb8e5b56a6fb = v; });
$parcel$export($9925272a533c7e7d$exports, "datePicker", function () { return $9925272a533c7e7d$export$a727d6cd3f21b50b; }, function (v) { return $9925272a533c7e7d$export$a727d6cd3f21b50b = v; });
$parcel$export($9925272a533c7e7d$exports, "loadingDiv", function () { return $9925272a533c7e7d$export$dded2af20345efaa; }, function (v) { return $9925272a533c7e7d$export$dded2af20345efaa = v; });
$parcel$export($9925272a533c7e7d$exports, "textField", function () { return $9925272a533c7e7d$export$c54b92c0bb02ba64; }, function (v) { return $9925272a533c7e7d$export$c54b92c0bb02ba64 = v; });
var $9925272a533c7e7d$export$4ededb8e5b56a6fb;
var $9925272a533c7e7d$export$a727d6cd3f21b50b;
var $9925272a533c7e7d$export$dded2af20345efaa;
var $9925272a533c7e7d$export$c54b92c0bb02ba64;
$9925272a533c7e7d$export$4ededb8e5b56a6fb = `n9QuVW_cancelButton`;
$9925272a533c7e7d$export$a727d6cd3f21b50b = `n9QuVW_datePicker`;
$9925272a533c7e7d$export$dded2af20345efaa = `n9QuVW_loadingDiv`;
$9925272a533c7e7d$export$c54b92c0bb02ba64 = `n9QuVW_textField`;






var $1ZNeQ = parcelRequire("1ZNeQ");


const $c817696a2f613b7d$export$c16261128452a0f7 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addExchangeRate = (parameters)=>post("exchangeRates", parameters);
    return {
        addExchangeRate: addExchangeRate
    };
};



const $7a03aa27cad466a4$export$c54abdb6a4fb25d8 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyExchangeRate = (parameters)=>put("exchangeRates", parameters);
    return {
        modifyExchangeRate: modifyExchangeRate
    };
};



const $3836cf7ab7b4cc97$export$b3cd26118743fe0b = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteExchangeRate = (parameters)=>deleteRequest("exchangeRates", parameters);
    return {
        deleteExchangeRate: deleteExchangeRate
    };
};
















const $4dc46ebc86123311$export$971251cd2d84b8e4 = ({ open: open, onClose: onClose, exchangeRate: exchangeRate, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const dialogTitle = exchangeRate ? (0, $37bec70ed65ed924$export$21c51bc433c16634).exchange_rate_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).mer_new_title;
    const { addExchangeRate: addExchangeRate } = (0, $c817696a2f613b7d$export$c16261128452a0f7)();
    const { modifyExchangeRate: modifyExchangeRate } = (0, $7a03aa27cad466a4$export$c54abdb6a4fb25d8)();
    const { deleteExchangeRate: deleteExchangeRate } = (0, $3836cf7ab7b4cc97$export$b3cd26118743fe0b)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseAlertOpen, setIsPurchaseAlertOpen] = (0, $7fPBF.useState)(false);
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        rate: $57e52f3b537dfd4b$export$98e628dec113755e().typeError((0, $37bec70ed65ed924$export$21c51bc433c16634).mer_format_error).required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing).positive((0, $37bec70ed65ed924$export$21c51bc433c16634).mer_format_error),
        date: $57e52f3b537dfd4b$export$324d90190a8b822a().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            rate: exchangeRate?.rate ?? 1,
            date: exchangeRate ? new Date(exchangeRate.unixTimestamp * 1000) : undefined
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ rate: rate, date: date })=>{
            if (rate == undefined || date == undefined) return;
            setIsLoading(true);
            if (exchangeRate) {
                const { status: status, body: body } = await modifyExchangeRate({
                    uuid: exchangeRate.uuid,
                    unixTimestamp: date.getTime() / 1000,
                    rate: rate
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_exchangerate_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addExchangeRate({
                    unixTimestamp: date.getTime() / 1000,
                    rate: rate
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_exchangerate_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(status)) {
                    setAlertMessage(body.message);
                    setIsPurchaseAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!exchangeRate) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteExchangeRate({
            uuid: exchangeRate.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(exchangeRate);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            exchangeRate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).mer_rate_title, currentUserProfile?.currency.code ?? "")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9925272a533c7e7d$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "rate",
                                    name: "rate",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).mer_rate_placeholder, currentUserProfile?.currency.code ?? ""),
                                    value: formik.values.rate,
                                    onChange: formik.handleChange,
                                    enterAction: formik.submitForm
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).mer_date_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $513dd6ab73816bf5$export$34dc4cfa15ead1), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9925272a533c7e7d$exports))).datePicker,
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).mer_date_title,
                                value: formik.values.date ?? null,
                                onChange: (newValue)=>formik.setFieldValue("date", newValue),
                                disabled: exchangeRate !== undefined
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isPurchaseAlertOpen,
                setOpen: setIsPurchaseAlertOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).EXCHANGE_RATES,
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen
            })
        ]
    });
};



var $a30362a3d7a8a456$exports = {};

$parcel$export($a30362a3d7a8a456$exports, "date", function () { return $a30362a3d7a8a456$export$324d90190a8b822a; }, function (v) { return $a30362a3d7a8a456$export$324d90190a8b822a = v; });
$parcel$export($a30362a3d7a8a456$exports, "defaultIcon", function () { return $a30362a3d7a8a456$export$ca2f546e21dcce87; }, function (v) { return $a30362a3d7a8a456$export$ca2f546e21dcce87 = v; });
$parcel$export($a30362a3d7a8a456$exports, "rate", function () { return $a30362a3d7a8a456$export$e8435ed7e8ba58fa; }, function (v) { return $a30362a3d7a8a456$export$e8435ed7e8ba58fa = v; });
$parcel$export($a30362a3d7a8a456$exports, "rateCard", function () { return $a30362a3d7a8a456$export$e4ea29d471b0682d; }, function (v) { return $a30362a3d7a8a456$export$e4ea29d471b0682d = v; });
$parcel$export($a30362a3d7a8a456$exports, "rightContainer", function () { return $a30362a3d7a8a456$export$3280a108d7f81d56; }, function (v) { return $a30362a3d7a8a456$export$3280a108d7f81d56 = v; });
var $a30362a3d7a8a456$export$324d90190a8b822a;
var $a30362a3d7a8a456$export$ca2f546e21dcce87;
var $a30362a3d7a8a456$export$e8435ed7e8ba58fa;
var $a30362a3d7a8a456$export$e4ea29d471b0682d;
var $a30362a3d7a8a456$export$3280a108d7f81d56;
$a30362a3d7a8a456$export$324d90190a8b822a = `n4zMCW_date`;
$a30362a3d7a8a456$export$ca2f546e21dcce87 = `n4zMCW_defaultIcon`;
$a30362a3d7a8a456$export$e8435ed7e8ba58fa = `n4zMCW_rate`;
$a30362a3d7a8a456$export$e4ea29d471b0682d = `n4zMCW_rateCard`;
$a30362a3d7a8a456$export$3280a108d7f81d56 = `n4zMCW_rightContainer`;


parcelRequire("7fPBF");






const $7537fd3be12216d5$export$924486b540269c1b = ({ exchangeRate: exchangeRate, onClick: onClick, onContextMenu: onContextMenu })=>{
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const getDate = ()=>{
        const date = new Date(exchangeRate.unixTimestamp * 1000);
        return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(date, "d MMM yyyy", {
            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        sx: {
            height: 70,
            borderRadius: "20px"
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a30362a3d7a8a456$exports))).defaultIcon,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).CurrencyExchange
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a30362a3d7a8a456$exports))).rightContainer,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a30362a3d7a8a456$exports))).rateCard,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a30362a3d7a8a456$exports))).rate,
                                        children: currencyFormatter.format(exchangeRate.rate, currentUserProfile, false, 2)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a30362a3d7a8a456$exports))).date,
                            children: getDate()
                        })
                    ]
                })
            ]
        })
    });
};





var $0cff27ca57f43dec$exports = {};

$parcel$export($0cff27ca57f43dec$exports, "skeleton", function () { return $0cff27ca57f43dec$export$2a0674ff2eb10214; }, function (v) { return $0cff27ca57f43dec$export$2a0674ff2eb10214 = v; });
var $0cff27ca57f43dec$export$2a0674ff2eb10214;
$0cff27ca57f43dec$export$2a0674ff2eb10214 = `Vs8BBq_skeleton`;






const $08bc61c8814c0132$export$9df0037d8de6e571 = ({ isPublic: isPublic, handleClose: handleClose, columnWidth: columnWidth, onExchangeRateSelected: onExchangeRateSelected })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [exchangeRates, resetExchangeRates, setExchangeRates, noMoreExchangeRates] = (0, $8bc7108f868acbb7$export$c2e16e3a65c471b0)(setLoading);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextExchangeRate, setContextExchangeRate] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredExchangeRates = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return exchangeRates;
        return exchangeRates?.filter((exchangeRate)=>{
            return exchangeRate.rate.toString().includes(searchText.toLowerCase());
        });
    }, [
        exchangeRates,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredExchangeRates,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EXCHANGE_RATES],
        emptyString: isPublic ? (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_exchange_rates_public : (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_exchange_rates,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_exchange_rates_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetExchangeRates,
        children: [
            filteredExchangeRates?.map((exchangeRate)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7537fd3be12216d5$export$924486b540269c1b), {
                        exchangeRate: exchangeRate,
                        onClick: ()=>{
                            if (onExchangeRateSelected) onExchangeRateSelected(exchangeRate);
                            else openEdit(exchangeRate);
                        },
                        onContextMenu: (event)=>{
                            setContextExchangeRate(exchangeRate);
                            handleContextMenu(event);
                        }
                    })
                }, exchangeRate.uuid)),
            (loading || !noMoreExchangeRates) && Array.from({
                length: 40
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 70
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0cff27ca57f43dec$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextExchangeRate);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4dc46ebc86123311$export$971251cd2d84b8e4), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                exchangeRate: modifyDialogState.item,
                onNewItem: (newExchangeRate)=>{
                    const newExchangeRates = [
                        ...exchangeRates,
                        newExchangeRate
                    ];
                    newExchangeRates.sort((a, b)=>b.unixTimestamp - a.unixTimestamp);
                    setExchangeRates(newExchangeRates);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newExchangeRate)=>{
                    const newExchangeRates = exchangeRates.map((exchangeRate)=>exchangeRate.uuid == newExchangeRate.uuid ? newExchangeRate : exchangeRate);
                    newExchangeRates.sort((a, b)=>b.unixTimestamp - a.unixTimestamp);
                    setExchangeRates(newExchangeRates);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedExchangeRate)=>{
                    const newExchangeRates = exchangeRates.filter((exchangeRate)=>exchangeRate.uuid != deletedExchangeRate.uuid);
                    setExchangeRates(newExchangeRates);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyDialogKey)
        ]
    });
};

















var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
var $6a13d5933d6d6ff9$exports = {};

$parcel$export($6a13d5933d6d6ff9$exports, "cancelButton", function () { return $6a13d5933d6d6ff9$export$4ededb8e5b56a6fb; }, function (v) { return $6a13d5933d6d6ff9$export$4ededb8e5b56a6fb = v; });
$parcel$export($6a13d5933d6d6ff9$exports, "dropzone", function () { return $6a13d5933d6d6ff9$export$585d0a7a39ed94ea; }, function (v) { return $6a13d5933d6d6ff9$export$585d0a7a39ed94ea = v; });
$parcel$export($6a13d5933d6d6ff9$exports, "loadingDiv", function () { return $6a13d5933d6d6ff9$export$dded2af20345efaa; }, function (v) { return $6a13d5933d6d6ff9$export$dded2af20345efaa = v; });
$parcel$export($6a13d5933d6d6ff9$exports, "profileCard", function () { return $6a13d5933d6d6ff9$export$56d7158379169459; }, function (v) { return $6a13d5933d6d6ff9$export$56d7158379169459 = v; });
$parcel$export($6a13d5933d6d6ff9$exports, "textField", function () { return $6a13d5933d6d6ff9$export$c54b92c0bb02ba64; }, function (v) { return $6a13d5933d6d6ff9$export$c54b92c0bb02ba64 = v; });
$parcel$export($6a13d5933d6d6ff9$exports, "toggleButton", function () { return $6a13d5933d6d6ff9$export$c3f9788a1ddcf2d9; }, function (v) { return $6a13d5933d6d6ff9$export$c3f9788a1ddcf2d9 = v; });
var $6a13d5933d6d6ff9$export$4ededb8e5b56a6fb;
var $6a13d5933d6d6ff9$export$585d0a7a39ed94ea;
var $6a13d5933d6d6ff9$export$dded2af20345efaa;
var $6a13d5933d6d6ff9$export$56d7158379169459;
var $6a13d5933d6d6ff9$export$c54b92c0bb02ba64;
var $6a13d5933d6d6ff9$export$c3f9788a1ddcf2d9;
$6a13d5933d6d6ff9$export$4ededb8e5b56a6fb = `wGOjHq_cancelButton`;
$6a13d5933d6d6ff9$export$585d0a7a39ed94ea = `wGOjHq_dropzone`;
$6a13d5933d6d6ff9$export$dded2af20345efaa = `wGOjHq_loadingDiv`;
$6a13d5933d6d6ff9$export$56d7158379169459 = `wGOjHq_profileCard`;
$6a13d5933d6d6ff9$export$c54b92c0bb02ba64 = `wGOjHq_textField`;
$6a13d5933d6d6ff9$export$c3f9788a1ddcf2d9 = `wGOjHq_toggleButton`;






var $1ZNeQ = parcelRequire("1ZNeQ");
















const $73615585d4d7ff11$export$20651a4551311935 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addGearItem = (parameters)=>post("gearItems", parameters);
    return {
        addGearItem: addGearItem
    };
};



const $7442e076a9a159ca$export$eee96ab0ed881b40 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyGearItem = (parameters)=>put("gearItems", parameters);
    return {
        modifyGearItem: modifyGearItem
    };
};



const $eeb69358fc4a13f9$export$1d3a8246752a6711 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteGearItem = (parameters)=>deleteRequest("gearItems", parameters);
    return {
        deleteGearItem: deleteGearItem
    };
};



const $1aad43c1c3f0a974$export$a1625575463601c4 = ({ open: open, onClose: onClose, gearItem: gearItem, originalImageData: originalImageData, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = gearItem ? (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).new_gear_item_title;
    const { addGearItem: addGearItem } = (0, $73615585d4d7ff11$export$20651a4551311935)();
    const { modifyGearItem: modifyGearItem } = (0, $7442e076a9a159ca$export$eee96ab0ed881b40)();
    const { deleteGearItem: deleteGearItem } = (0, $eeb69358fc4a13f9$export$1d3a8246752a6711)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [isModifyProfileDialogOpen, setIsModifyProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const genericImage = new URL($95e659af2867daac$exports).href;
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: gearItem?.name ?? "",
            description: gearItem?.description ?? "",
            brand: gearItem?.brand ?? "",
            gearItemStatus: gearItem?.status ?? "active"
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, description: description, brand: brand, gearItemStatus: gearItemStatus })=>{
            setIsLoading(true);
            if (gearItem) {
                const { status: status, body: body } = await modifyGearItem({
                    uuid: gearItem.uuid,
                    name: name,
                    hasImage: gearItem.hasImage,
                    description: description,
                    brand: brand,
                    status: gearItemStatus
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_gear_item_action", {
                        isNew: false
                    });
                    if (didChangeImage && imageFile && gearItem.uuid) {
                        const newThumbnail = await uploadImage({
                            name: gearItem.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addGearItem({
                    name: name,
                    description: description,
                    brand: brand,
                    status: gearItemStatus
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_gear_item_action", {
                        isNew: true
                    });
                    if (didChangeImage && imageFile && body.uuid) {
                        const newThumbnail = await uploadImage({
                            name: body.uuid,
                            file: imageFile
                        }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallLabelImageSize);
                        if (newThumbnail) {
                            body.hasImage = true;
                            body.thumbnail = newThumbnail;
                        }
                    }
                    onNewItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!gearItem?.uuid) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteGearItem({
            uuid: gearItem.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(gearItem);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setImageFile(undefined);
        setDidChangeImage(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            gearItem && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_image_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).dropzone,
                                                onImageChanged: (file)=>{
                                                    setImageFile(file);
                                                    setDidChangeImage(true);
                                                },
                                                placeholderImage: genericImage,
                                                initialImage: originalImageData ? `data:image/png;base64,${originalImageData}` : gearItem?.thumbnail ? `data:image/png;base64,${gearItem.thumbnail}` : undefined,
                                                isLoading: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_name_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "name",
                                                    name: "name",
                                                    size: "small",
                                                    autoFocus: !isMobile,
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_name_placeholder,
                                                    value: formik.values.name,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_brand_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).textField,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                    id: "brand",
                                                    name: "brand",
                                                    size: "small",
                                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_brand_placeholder,
                                                    value: formik.values.brand,
                                                    onChange: formik.handleChange,
                                                    enterAction: formik.submitForm
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).profileCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyProfileDialogOpen(true)
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
                                value: formik.values.gearItemStatus,
                                exclusive: true,
                                onChange: (_event, value)=>{
                                    if (value !== null) formik.setFieldValue("gearItemStatus", value).then();
                                },
                                sx: {
                                    height: "30px",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: "active",
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_active
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6a13d5933d6d6ff9$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: "inactive",
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_inactive
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title,
                value: formik.values.description,
                open: isModifyProfileDialogOpen,
                onClose: ()=>setIsModifyProfileDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};





var $20a01ce44c8e813b$exports = {};

$parcel$export($20a01ce44c8e813b$exports, "brand", function () { return $20a01ce44c8e813b$export$96ff94e0adb1d772; }, function (v) { return $20a01ce44c8e813b$export$96ff94e0adb1d772 = v; });
$parcel$export($20a01ce44c8e813b$exports, "container", function () { return $20a01ce44c8e813b$export$34e0f9847d4c02dd; }, function (v) { return $20a01ce44c8e813b$export$34e0f9847d4c02dd = v; });
$parcel$export($20a01ce44c8e813b$exports, "defaultIcon", function () { return $20a01ce44c8e813b$export$ca2f546e21dcce87; }, function (v) { return $20a01ce44c8e813b$export$ca2f546e21dcce87 = v; });
$parcel$export($20a01ce44c8e813b$exports, "hoverButton", function () { return $20a01ce44c8e813b$export$b0260c0afbf48c57; }, function (v) { return $20a01ce44c8e813b$export$b0260c0afbf48c57 = v; });
$parcel$export($20a01ce44c8e813b$exports, "hoverButtonsStack", function () { return $20a01ce44c8e813b$export$a8eacba2c33c9f28; }, function (v) { return $20a01ce44c8e813b$export$a8eacba2c33c9f28 = v; });
$parcel$export($20a01ce44c8e813b$exports, "image", function () { return $20a01ce44c8e813b$export$5c452ff88e35e47d; }, function (v) { return $20a01ce44c8e813b$export$5c452ff88e35e47d = v; });
$parcel$export($20a01ce44c8e813b$exports, "inactiveCard", function () { return $20a01ce44c8e813b$export$31fcb46b29e0bdbc; }, function (v) { return $20a01ce44c8e813b$export$31fcb46b29e0bdbc = v; });
$parcel$export($20a01ce44c8e813b$exports, "name", function () { return $20a01ce44c8e813b$export$a8ff84c12d48cfa6; }, function (v) { return $20a01ce44c8e813b$export$a8ff84c12d48cfa6 = v; });
$parcel$export($20a01ce44c8e813b$exports, "profile", function () { return $20a01ce44c8e813b$export$4882ae973e0491e; }, function (v) { return $20a01ce44c8e813b$export$4882ae973e0491e = v; });
$parcel$export($20a01ce44c8e813b$exports, "rightContainer", function () { return $20a01ce44c8e813b$export$3280a108d7f81d56; }, function (v) { return $20a01ce44c8e813b$export$3280a108d7f81d56 = v; });
var $20a01ce44c8e813b$export$96ff94e0adb1d772;
var $20a01ce44c8e813b$export$34e0f9847d4c02dd;
var $20a01ce44c8e813b$export$ca2f546e21dcce87;
var $20a01ce44c8e813b$export$b0260c0afbf48c57;
var $20a01ce44c8e813b$export$a8eacba2c33c9f28;
var $20a01ce44c8e813b$export$5c452ff88e35e47d;
var $20a01ce44c8e813b$export$31fcb46b29e0bdbc;
var $20a01ce44c8e813b$export$a8ff84c12d48cfa6;
var $20a01ce44c8e813b$export$4882ae973e0491e;
var $20a01ce44c8e813b$export$3280a108d7f81d56;
$20a01ce44c8e813b$export$96ff94e0adb1d772 = `_7K9hNW_brand`;
$20a01ce44c8e813b$export$34e0f9847d4c02dd = `_7K9hNW_container`;
$20a01ce44c8e813b$export$ca2f546e21dcce87 = `_7K9hNW_defaultIcon`;
$20a01ce44c8e813b$export$b0260c0afbf48c57 = `_7K9hNW_hoverButton`;
$20a01ce44c8e813b$export$a8eacba2c33c9f28 = `_7K9hNW_hoverButtonsStack`;
$20a01ce44c8e813b$export$5c452ff88e35e47d = `_7K9hNW_image`;
$20a01ce44c8e813b$export$31fcb46b29e0bdbc = `_7K9hNW_inactiveCard`;
$20a01ce44c8e813b$export$a8ff84c12d48cfa6 = `_7K9hNW_name`;
$20a01ce44c8e813b$export$4882ae973e0491e = `_7K9hNW_profile`;
$20a01ce44c8e813b$export$3280a108d7f81d56 = `_7K9hNW_rightContainer`;



var $7fPBF = parcelRequire("7fPBF");








const $74a7da8a712d70ce$export$63cf513f9572e111 = ({ gearItem: gearItem, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($7669f0eb53d19f41$exports).href;
    const fetchImage = async ()=>{
        if (!gearItem.hasImage) return;
        const response = await getImage({
            name: gearItem.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        gearItem
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).container,
        sx: {
            height: 80
        },
        elevation: 5,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "row"
                },
                style: {
                    borderColor: theme.palette.colors?.highlightBorder,
                    borderWidth: 4,
                    borderStyle: selected ? "double" : "none"
                },
                onContextMenu: (event)=>onContextMenu(event, image),
                onClick: (event)=>onClick(event, image),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        children: [
                            gearItem.hasImage ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).image,
                                imageStyle: {
                                    borderRadius: "16px"
                                },
                                image: image,
                                thumbnail: gearItem.thumbnail,
                                defaultImage: genericImage,
                                beforeLoad: fetchImage,
                                alt: gearItem.name
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).defaultIcon,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AudioVideoReceiver
                                })
                            }),
                            gearItem.status === "inactive" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: -2,
                                    backgroundColor: theme.palette.colors.goldmineGray
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).inactiveCard,
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_inactive
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).rightContainer,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).name,
                                children: gearItem.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).brand,
                                children: gearItem.brand
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).profile,
                                children: gearItem.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).hoverButtonsStack,
                direction: "row",
                spacing: 1,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).options,
                    arrow: true,
                    disableInteractive: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($20a01ce44c8e813b$exports))).hoverButton,
                        style: {
                            backgroundColor: theme.palette.colors?.counterBackground
                        },
                        onClick: (event)=>onContextMenu(event, image),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MoreVertical
                        })
                    })
                })
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");

var $9b389a480fc05e49$exports = {};

$parcel$export($9b389a480fc05e49$exports, "artistDates", function () { return $9b389a480fc05e49$export$3f899b467dbac2d; }, function (v) { return $9b389a480fc05e49$export$3f899b467dbac2d = v; });
$parcel$export($9b389a480fc05e49$exports, "dialog", function () { return $9b389a480fc05e49$export$518824cf31321346; }, function (v) { return $9b389a480fc05e49$export$518824cf31321346 = v; });
$parcel$export($9b389a480fc05e49$exports, "image", function () { return $9b389a480fc05e49$export$5c452ff88e35e47d; }, function (v) { return $9b389a480fc05e49$export$5c452ff88e35e47d = v; });
$parcel$export($9b389a480fc05e49$exports, "loadingDiv", function () { return $9b389a480fc05e49$export$dded2af20345efaa; }, function (v) { return $9b389a480fc05e49$export$dded2af20345efaa = v; });
$parcel$export($9b389a480fc05e49$exports, "profile", function () { return $9b389a480fc05e49$export$4882ae973e0491e; }, function (v) { return $9b389a480fc05e49$export$4882ae973e0491e = v; });
$parcel$export($9b389a480fc05e49$exports, "realName", function () { return $9b389a480fc05e49$export$6d354f2c918c5662; }, function (v) { return $9b389a480fc05e49$export$6d354f2c918c5662 = v; });
$parcel$export($9b389a480fc05e49$exports, "redirectButton", function () { return $9b389a480fc05e49$export$1459b0652d8256be; }, function (v) { return $9b389a480fc05e49$export$1459b0652d8256be = v; });
$parcel$export($9b389a480fc05e49$exports, "redirectGridItem", function () { return $9b389a480fc05e49$export$45fc42605641ab16; }, function (v) { return $9b389a480fc05e49$export$45fc42605641ab16 = v; });
$parcel$export($9b389a480fc05e49$exports, "title", function () { return $9b389a480fc05e49$export$fb184b623420d9be; }, function (v) { return $9b389a480fc05e49$export$fb184b623420d9be = v; });
var $9b389a480fc05e49$export$3f899b467dbac2d;
var $9b389a480fc05e49$export$518824cf31321346;
var $9b389a480fc05e49$export$5c452ff88e35e47d;
var $9b389a480fc05e49$export$dded2af20345efaa;
var $9b389a480fc05e49$export$4882ae973e0491e;
var $9b389a480fc05e49$export$6d354f2c918c5662;
var $9b389a480fc05e49$export$1459b0652d8256be;
var $9b389a480fc05e49$export$45fc42605641ab16;
var $9b389a480fc05e49$export$fb184b623420d9be;
$9b389a480fc05e49$export$3f899b467dbac2d = `Vr-54W_artistDates`;
$9b389a480fc05e49$export$518824cf31321346 = `Vr-54W_dialog`;
$9b389a480fc05e49$export$5c452ff88e35e47d = `Vr-54W_image`;
$9b389a480fc05e49$export$dded2af20345efaa = `Vr-54W_loadingDiv`;
$9b389a480fc05e49$export$4882ae973e0491e = `Vr-54W_profile`;
$9b389a480fc05e49$export$6d354f2c918c5662 = `Vr-54W_realName`;
$9b389a480fc05e49$export$1459b0652d8256be = `Vr-54W_redirectButton`;
$9b389a480fc05e49$export$45fc42605641ab16 = `Vr-54W_redirectGridItem`;
$9b389a480fc05e49$export$fb184b623420d9be = `Vr-54W_title`;













const $f3024ddabb644590$export$719c7ceec528f838 = ({ gearItem: gearItem, isOpen: isOpen, onClose: onClose, canEdit: canEdit, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [myGearItem, setMyGearItem] = (0, $7fPBF.useState)(gearItem);
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [thumbnail, setThumbnail] = (0, $7fPBF.useState)(gearItem.thumbnail);
    const [modifyDialogState, setModifyDialogState] = (0, $7fPBF.useState)({
        mode: "closed"
    });
    const genericImage = new URL($7669f0eb53d19f41$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        setThumbnail(myGearItem.thumbnail);
        fetchImage().then();
    }, [
        myGearItem.uuid,
        myGearItem.hasImage,
        myGearItem.thumbnail
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setMyGearItem(gearItem);
    }, [
        gearItem
    ]);
    const currentGearItemUuid = (0, $7fPBF.useRef)("");
    const fetchImage = async ()=>{
        currentGearItemUuid.current = myGearItem.uuid;
        setImage(undefined);
        if (!myGearItem.hasImage) return;
        const response = await getImage({
            name: myGearItem.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize
        });
        // Discard image if label changed
        if (currentGearItemUuid.current != myGearItem.uuid) return;
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9b389a480fc05e49$exports))).dialog,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: myGearItem.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        canEdit && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>setModifyDialogState({
                                    mode: "edit",
                                    item: gearItem
                                }),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_edit,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: onClose,
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                dividers: true,
                children: myGearItem ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: isMobile ? "column" : "row",
                            spacing: 2,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9b389a480fc05e49$exports))).image,
                                style: {
                                    width: isMobile ? "100%" : "50%"
                                },
                                imageStyle: {
                                    borderRadius: "6%"
                                },
                                image: image,
                                thumbnail: thumbnail,
                                defaultImage: genericImage,
                                alt: myGearItem.name
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9b389a480fc05e49$exports))).profile,
                            children: myGearItem.description
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    sx: {
                        height: 200
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1aad43c1c3f0a974$export$a1625575463601c4), {
                open: modifyDialogState.mode !== "closed",
                onClose: ()=>setModifyDialogState({
                        mode: "closed",
                        item: modifyDialogState.item
                    }),
                gearItem: modifyDialogState.item,
                originalImageData: image,
                onModifiedItem: (newItem)=>{
                    onModifiedItem?.(newItem);
                    setMyGearItem(newItem);
                },
                onDeletedItem: onDeletedItem
            }, modifyDialogState.item?.uuid)
        ]
    });
};



var $7106d4ac518c809b$exports = {};

$parcel$export($7106d4ac518c809b$exports, "skeleton", function () { return $7106d4ac518c809b$export$2a0674ff2eb10214; }, function (v) { return $7106d4ac518c809b$export$2a0674ff2eb10214 = v; });
var $7106d4ac518c809b$export$2a0674ff2eb10214;
$7106d4ac518c809b$export$2a0674ff2eb10214 = `vLozOq_skeleton`;












const $549db86585c4cb87$export$4ac4eb828b63ce20 = (setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getGearItems = (parameters)=>get("gearItems", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).gearItems(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), getGearItems, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).gearItemStorage, false, true, undefined);
};


const $61fac90fb5085076$export$f940c123e92a8996 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedIds: preselectedIds, onGearItemSelected: onGearItemSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [gearItems, resetGearItems, setGearItems, noMoreGearItems] = (0, $549db86585c4cb87$export$4ac4eb828b63ce20)(setLoading);
    const [imageData, setImageData] = (0, $7fPBF.useState)();
    const { state: gearItemDialogState, key: gearItemDialogKey, openEdit: openGearItemDialog, close: closeGearItemDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const { state: modifyGearItemDialogState, key: modifyGearItemDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyGearItemDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextGearItem, setContextGearItem] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredGearItems = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return gearItems;
        return gearItems?.filter((gearItem)=>{
            return gearItem.name.toLowerCase().includes(searchText.toLowerCase()) || gearItem.brand.toLowerCase().includes(searchText.toLowerCase()) || gearItem.description.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        gearItems,
        searchText
    ]);
    const onModifiedGearItem = (newGearItem)=>{
        const newGearItems = gearItems.map((gearItem)=>gearItem.uuid == newGearItem.uuid ? newGearItem : gearItem);
        newGearItems.sort((a, b)=>a.status.localeCompare(b.status, undefined, {
                ignorePunctuation: true
            }) || a.name.localeCompare(b.name, undefined, {
                ignorePunctuation: true
            }));
        setGearItems(newGearItems);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    const onDeletedGearItem = (deletedGearItem)=>{
        const newGearItems = gearItems.filter((gearItem)=>gearItem.uuid != deletedGearItem.uuid);
        setGearItems(newGearItems);
        (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredGearItems,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).GEAR_ITEMS],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_gear_items,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_items_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: ()=>{
            setImageData(undefined);
            openAdd();
        },
        refreshAction: resetGearItems,
        onClearValue: onClearValue,
        children: [
            filteredGearItems?.map((gearItem)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74a7da8a712d70ce$export$63cf513f9572e111), {
                        gearItem: gearItem,
                        selected: preselectedIds?.includes(gearItem.uuid),
                        onClick: (_event, imageData)=>{
                            setImageData(imageData);
                            if (onGearItemSelected) onGearItemSelected(gearItem);
                            else openEdit(gearItem);
                        },
                        onContextMenu: (event, imageData)=>{
                            setImageData(imageData);
                            setContextGearItem(gearItem);
                            handleContextMenu(event);
                        }
                    })
                }, gearItem.uuid)),
            (loading || !noMoreGearItems) && Array.from({
                length: 40
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 80
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7106d4ac518c809b$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1aad43c1c3f0a974$export$a1625575463601c4), {
                open: modifyGearItemDialogState.mode !== "closed",
                onClose: closeModifyGearItemDialog,
                gearItem: modifyGearItemDialogState.item,
                originalImageData: imageData,
                onNewItem: (newGearItem)=>{
                    const newGearItems = [
                        ...gearItems,
                        newGearItem
                    ];
                    newGearItems.sort((a, b)=>a.status.localeCompare(b.status, undefined, {
                            ignorePunctuation: true
                        }) || a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setGearItems(newGearItems);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: onModifiedGearItem,
                onDeletedItem: onDeletedGearItem
            }, modifyGearItemDialogKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openGearItemDialog(contextGearItem);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FrameInspect
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_view
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleMenuClose();
                            openEdit(contextGearItem);
                        },
                        dense: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                })
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_item_edit
                        ]
                    })
                ]
            }),
            gearItemDialogState.item && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3024ddabb644590$export$719c7ceec528f838), {
                gearItem: gearItemDialogState.item,
                isOpen: gearItemDialogState.mode !== "closed",
                onClose: closeGearItemDialog,
                canEdit: true,
                onModifiedItem: onModifiedGearItem,
                onDeletedItem: (deletedItem)=>{
                    closeGearItemDialog();
                    onDeletedGearItem(deletedItem);
                }
            }, gearItemDialogKey)
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $9f760290fea1a7f5$exports = {};

$parcel$export($9f760290fea1a7f5$exports, "name", function () { return $9f760290fea1a7f5$export$a8ff84c12d48cfa6; }, function (v) { return $9f760290fea1a7f5$export$a8ff84c12d48cfa6 = v; });
$parcel$export($9f760290fea1a7f5$exports, "skeleton", function () { return $9f760290fea1a7f5$export$2a0674ff2eb10214; }, function (v) { return $9f760290fea1a7f5$export$2a0674ff2eb10214 = v; });
var $9f760290fea1a7f5$export$a8ff84c12d48cfa6;
var $9f760290fea1a7f5$export$2a0674ff2eb10214;
$9f760290fea1a7f5$export$a8ff84c12d48cfa6 = `Kcz7ma_name`;
$9f760290fea1a7f5$export$2a0674ff2eb10214 = `Kcz7ma_skeleton`;






var $7fPBF = parcelRequire("7fPBF");
var $edb866787a5ead35$exports = {};

$parcel$export($edb866787a5ead35$exports, "cancelButton", function () { return $edb866787a5ead35$export$4ededb8e5b56a6fb; }, function (v) { return $edb866787a5ead35$export$4ededb8e5b56a6fb = v; });
$parcel$export($edb866787a5ead35$exports, "gearItemsList", function () { return $edb866787a5ead35$export$bb4efec150feb193; }, function (v) { return $edb866787a5ead35$export$bb4efec150feb193 = v; });
$parcel$export($edb866787a5ead35$exports, "loadingDiv", function () { return $edb866787a5ead35$export$dded2af20345efaa; }, function (v) { return $edb866787a5ead35$export$dded2af20345efaa = v; });
$parcel$export($edb866787a5ead35$exports, "profileCard", function () { return $edb866787a5ead35$export$56d7158379169459; }, function (v) { return $edb866787a5ead35$export$56d7158379169459 = v; });
$parcel$export($edb866787a5ead35$exports, "statusToggle", function () { return $edb866787a5ead35$export$b8396fa1d899ca98; }, function (v) { return $edb866787a5ead35$export$b8396fa1d899ca98 = v; });
$parcel$export($edb866787a5ead35$exports, "textField", function () { return $edb866787a5ead35$export$c54b92c0bb02ba64; }, function (v) { return $edb866787a5ead35$export$c54b92c0bb02ba64 = v; });
$parcel$export($edb866787a5ead35$exports, "toggleButton", function () { return $edb866787a5ead35$export$c3f9788a1ddcf2d9; }, function (v) { return $edb866787a5ead35$export$c3f9788a1ddcf2d9 = v; });
var $edb866787a5ead35$export$4ededb8e5b56a6fb;
var $edb866787a5ead35$export$bb4efec150feb193;
var $edb866787a5ead35$export$dded2af20345efaa;
var $edb866787a5ead35$export$56d7158379169459;
var $edb866787a5ead35$export$b8396fa1d899ca98;
var $edb866787a5ead35$export$c54b92c0bb02ba64;
var $edb866787a5ead35$export$c3f9788a1ddcf2d9;
$edb866787a5ead35$export$4ededb8e5b56a6fb = `_2cjmIa_cancelButton`;
$edb866787a5ead35$export$bb4efec150feb193 = `_2cjmIa_gearItemsList`;
$edb866787a5ead35$export$dded2af20345efaa = `_2cjmIa_loadingDiv`;
$edb866787a5ead35$export$56d7158379169459 = `_2cjmIa_profileCard`;
$edb866787a5ead35$export$b8396fa1d899ca98 = `_2cjmIa_statusToggle`;
$edb866787a5ead35$export$c54b92c0bb02ba64 = `_2cjmIa_textField`;
$edb866787a5ead35$export$c3f9788a1ddcf2d9 = `_2cjmIa_toggleButton`;






var $1ZNeQ = parcelRequire("1ZNeQ");













const $667a98f33d0dfbcb$export$6cb944ce15537742 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addEquipment = (parameters)=>post("equipments", parameters);
    return {
        addEquipment: addEquipment
    };
};



const $baf5c7b1b3b8ea72$export$9a7a45d4b43069a1 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyEquipment = (parameters)=>put("equipments", parameters);
    return {
        modifyEquipment: modifyEquipment
    };
};



const $2bb3564ac7980275$export$94839563e9a521c4 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteEquipment = (parameters)=>deleteRequest("equipments", parameters);
    return {
        deleteEquipment: deleteEquipment
    };
};



parcelRequire("7fPBF");

var $202a3424b114dc75$exports = {};

$parcel$export($202a3424b114dc75$exports, "list", function () { return $202a3424b114dc75$export$8837f4fc672e936d; }, function (v) { return $202a3424b114dc75$export$8837f4fc672e936d = v; });
$parcel$export($202a3424b114dc75$exports, "loadingIndicator", function () { return $202a3424b114dc75$export$f10e6b4aaa94c253; }, function (v) { return $202a3424b114dc75$export$f10e6b4aaa94c253 = v; });
$parcel$export($202a3424b114dc75$exports, "playButton", function () { return $202a3424b114dc75$export$73e4574fc43cf3a2; }, function (v) { return $202a3424b114dc75$export$73e4574fc43cf3a2 = v; });
$parcel$export($202a3424b114dc75$exports, "title", function () { return $202a3424b114dc75$export$fb184b623420d9be; }, function (v) { return $202a3424b114dc75$export$fb184b623420d9be = v; });
$parcel$export($202a3424b114dc75$exports, "trackListTitle", function () { return $202a3424b114dc75$export$6e58acce95ed6f84; }, function (v) { return $202a3424b114dc75$export$6e58acce95ed6f84 = v; });
var $202a3424b114dc75$export$8837f4fc672e936d;
var $202a3424b114dc75$export$f10e6b4aaa94c253;
var $202a3424b114dc75$export$73e4574fc43cf3a2;
var $202a3424b114dc75$export$fb184b623420d9be;
var $202a3424b114dc75$export$6e58acce95ed6f84;
$202a3424b114dc75$export$8837f4fc672e936d = `loVU4W_list`;
$202a3424b114dc75$export$f10e6b4aaa94c253 = `loVU4W_loadingIndicator`;
$202a3424b114dc75$export$73e4574fc43cf3a2 = `loVU4W_playButton`;
$202a3424b114dc75$export$fb184b623420d9be = `loVU4W_title`;
$202a3424b114dc75$export$6e58acce95ed6f84 = `loVU4W_trackListTitle`;




var $903ba1485158ed40$exports = {};

$parcel$export($903ba1485158ed40$exports, "brand", function () { return $903ba1485158ed40$export$96ff94e0adb1d772; }, function (v) { return $903ba1485158ed40$export$96ff94e0adb1d772 = v; });
$parcel$export($903ba1485158ed40$exports, "container", function () { return $903ba1485158ed40$export$34e0f9847d4c02dd; }, function (v) { return $903ba1485158ed40$export$34e0f9847d4c02dd = v; });
$parcel$export($903ba1485158ed40$exports, "defaultIcon", function () { return $903ba1485158ed40$export$ca2f546e21dcce87; }, function (v) { return $903ba1485158ed40$export$ca2f546e21dcce87 = v; });
$parcel$export($903ba1485158ed40$exports, "dragIcon", function () { return $903ba1485158ed40$export$57b20f32f7ac9ff6; }, function (v) { return $903ba1485158ed40$export$57b20f32f7ac9ff6 = v; });
$parcel$export($903ba1485158ed40$exports, "hoverButton", function () { return $903ba1485158ed40$export$b0260c0afbf48c57; }, function (v) { return $903ba1485158ed40$export$b0260c0afbf48c57 = v; });
$parcel$export($903ba1485158ed40$exports, "image", function () { return $903ba1485158ed40$export$5c452ff88e35e47d; }, function (v) { return $903ba1485158ed40$export$5c452ff88e35e47d = v; });
$parcel$export($903ba1485158ed40$exports, "imageStack", function () { return $903ba1485158ed40$export$de78616045779f3d; }, function (v) { return $903ba1485158ed40$export$de78616045779f3d = v; });
$parcel$export($903ba1485158ed40$exports, "inactiveCard", function () { return $903ba1485158ed40$export$31fcb46b29e0bdbc; }, function (v) { return $903ba1485158ed40$export$31fcb46b29e0bdbc = v; });
$parcel$export($903ba1485158ed40$exports, "name", function () { return $903ba1485158ed40$export$a8ff84c12d48cfa6; }, function (v) { return $903ba1485158ed40$export$a8ff84c12d48cfa6 = v; });
$parcel$export($903ba1485158ed40$exports, "profile", function () { return $903ba1485158ed40$export$4882ae973e0491e; }, function (v) { return $903ba1485158ed40$export$4882ae973e0491e = v; });
$parcel$export($903ba1485158ed40$exports, "rightContainer", function () { return $903ba1485158ed40$export$3280a108d7f81d56; }, function (v) { return $903ba1485158ed40$export$3280a108d7f81d56 = v; });
var $903ba1485158ed40$export$96ff94e0adb1d772;
var $903ba1485158ed40$export$34e0f9847d4c02dd;
var $903ba1485158ed40$export$ca2f546e21dcce87;
var $903ba1485158ed40$export$57b20f32f7ac9ff6;
var $903ba1485158ed40$export$b0260c0afbf48c57;
var $903ba1485158ed40$export$5c452ff88e35e47d;
var $903ba1485158ed40$export$de78616045779f3d;
var $903ba1485158ed40$export$31fcb46b29e0bdbc;
var $903ba1485158ed40$export$a8ff84c12d48cfa6;
var $903ba1485158ed40$export$4882ae973e0491e;
var $903ba1485158ed40$export$3280a108d7f81d56;
$903ba1485158ed40$export$96ff94e0adb1d772 = `EpCORa_brand`;
$903ba1485158ed40$export$34e0f9847d4c02dd = `EpCORa_container`;
$903ba1485158ed40$export$ca2f546e21dcce87 = `EpCORa_defaultIcon`;
$903ba1485158ed40$export$57b20f32f7ac9ff6 = `EpCORa_dragIcon`;
$903ba1485158ed40$export$b0260c0afbf48c57 = `EpCORa_hoverButton`;
$903ba1485158ed40$export$5c452ff88e35e47d = `EpCORa_image`;
$903ba1485158ed40$export$de78616045779f3d = `EpCORa_imageStack`;
$903ba1485158ed40$export$31fcb46b29e0bdbc = `EpCORa_inactiveCard`;
$903ba1485158ed40$export$a8ff84c12d48cfa6 = `EpCORa_name`;
$903ba1485158ed40$export$4882ae973e0491e = `EpCORa_profile`;
$903ba1485158ed40$export$3280a108d7f81d56 = `EpCORa_rightContainer`;



var $7fPBF = parcelRequire("7fPBF");









const $602a27d1f453e710$export$88d091b31c7762dd = ({ gearItem: gearItem, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [imageUpdateCount, setImageUpdateCount] = (0, $7fPBF.useState)(0);
    const genericImage = new URL($7669f0eb53d19f41$exports).href;
    const fetchImage = async ()=>{
        if (!gearItem.hasImage) return;
        const response = await getImage({
            name: gearItem.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigLabelImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (imageUpdateCount > 0) {
            setImage(undefined);
            fetchImage().then();
        } else setImageUpdateCount((state)=>state + 1);
    }, [
        gearItem
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).container,
        style: {
            height: 60,
            display: "flex",
            flexDirection: "row",
            backgroundColor: theme.palette.colors.buttonBackground
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).dragIcon,
                style: {
                    color: theme.palette.secondary.main
                },
                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).imageStack,
                alignItems: "center",
                justifyContent: "center",
                children: [
                    gearItem.hasImage ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).image,
                        imageStyle: {
                            borderRadius: "16px"
                        },
                        image: image,
                        thumbnail: gearItem.thumbnail,
                        defaultImage: genericImage,
                        beforeLoad: fetchImage,
                        alt: gearItem.name
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).defaultIcon,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AudioVideoReceiver
                        })
                    }),
                    gearItem.status === "inactive" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: -2,
                            backgroundColor: theme.palette.colors.goldmineGray
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).inactiveCard,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_inactive
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).rightContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).name,
                        children: gearItem.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).brand,
                        children: gearItem.brand
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($903ba1485158ed40$exports))).profile,
                        children: gearItem.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                onClick: onDelete,
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                color: theme.palette.colors?.remove
            })
        ]
    });
};







const $01582792f4d803ff$export$2a87eb5c378c1c07 = ({ className: className, gearItems: gearItems, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: className,
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$237bd83162c14364), {
            onDragEnd: (result)=>{
                if (!gearItems || !result.destination || result.source.index === result.destination.index) return;
                (0, $3c32b049e9065866$export$79f3cf326dbd2413)(gearItems, result.source.index, result.destination.index);
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$423ec2075359570a), {
                droppableId: "gear_items_droppable",
                children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($202a3424b114dc75$exports))).list,
                        disablePadding: true,
                        ref: provided.innerRef,
                        ...provided.droppableProps,
                        children: [
                            gearItems.map((equipmentGearItem)=>equipmentGearItem.gearItem).map((gearItem, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e69fa77bf557686c$export$f2a139e5d18b9882), {
                                    draggableId: `${gearItem.uuid}_draggable`,
                                    index: index,
                                    children: (provided)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            ref: provided.innerRef,
                                            ...provided.draggableProps,
                                            ...provided.dragHandleProps,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $602a27d1f453e710$export$88d091b31c7762dd), {
                                                    gearItem: gearItem,
                                                    onDelete: ()=>onDelete(gearItem, index)
                                                }),
                                                index < gearItems.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {
                                                    color: theme.palette.background.paper
                                                })
                                            ]
                                        }, `${gearItem.uuid}_item`)
                                }, `${gearItem.uuid}_draggable_div`)),
                            provided.placeholder,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                                isLoading: false,
                                items: gearItems,
                                emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AudioVideoReceiver,
                                emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_equipment_gear_items,
                                emptyDescription: "",
                                searchText: "",
                                canAdd: false
                            })
                        ]
                    }, "gear_items_droppable")
            })
        })
    });
};




const $97c80c478fe15f45$export$2049f968ad03478 = ({ open: open, onClose: onClose, equipment: equipment, onNewItem: onNewItem, onModifiedItem: onModifiedItem, onDeletedItem: onDeletedItem })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const dialogTitle = equipment ? (0, $37bec70ed65ed924$export$21c51bc433c16634).equipment_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).new_equipment_title;
    const { addEquipment: addEquipment } = (0, $667a98f33d0dfbcb$export$6cb944ce15537742)();
    const { modifyEquipment: modifyEquipment } = (0, $baf5c7b1b3b8ea72$export$9a7a45d4b43069a1)();
    const { deleteEquipment: deleteEquipment } = (0, $2bb3564ac7980275$export$94839563e9a521c4)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isModifyProfileDialogOpen, setIsModifyProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isGearItemsDialogOpen, setIsGearItemsDialogOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        if (isLoading) return;
        if (formik.dirty) setIsConfirmCloseAlertOpen(true);
        else onClose();
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: equipment?.name ?? "",
            description: equipment?.description ?? "",
            equipmentStatus: equipment?.status ?? "active",
            gearItems: equipment?.gearItems ?? []
        },
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async ({ name: name, description: description, equipmentStatus: equipmentStatus, gearItems: gearItems })=>{
            setIsLoading(true);
            const orderedGearItems = gearItems.map((gearItem, index)=>({
                    ...gearItem,
                    order: index
                }));
            if (equipment) {
                const { status: status, body: body } = await modifyEquipment({
                    uuid: equipment.uuid,
                    name: name,
                    description: description,
                    status: equipmentStatus,
                    gearItems: orderedGearItems
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_store_action", {
                        isNew: false
                    });
                    onModifiedItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            } else {
                const { status: status, body: body } = await addEquipment({
                    name: name,
                    description: description,
                    status: equipmentStatus,
                    gearItems: orderedGearItems
                });
                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                    (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("attribute_equipment_action", {
                        isNew: true
                    });
                    onNewItem?.(body);
                    onClose();
                } else {
                    setAlertMessage(body.message);
                    setAlertIsOpen(true);
                }
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    const onDelete = async ()=>{
        if (!equipment) return;
        setIsLoading(true);
        const { status: status, body: body } = await deleteEquipment({
            uuid: equipment.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            onDeletedItem?.(equipment);
            onClose();
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "md",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            equipment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: isMobile ? "column" : "row",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    style: {
                                        width: isMobile ? "auto" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).equipment_name_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).textField,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                id: "name",
                                                name: "name",
                                                size: "small",
                                                autoFocus: !isMobile,
                                                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).equipment_name_placeholder,
                                                value: formik.values.name,
                                                onChange: formik.handleChange,
                                                enterAction: formik.submitForm
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).profileCard,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                hideTitle: true,
                                                detail: formik.values.description ?? "--",
                                                maxLines: 4,
                                                onClick: ()=>setIsModifyProfileDialogOpen(true)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_title
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).statusToggle,
                                            value: formik.values.equipmentStatus,
                                            exclusive: true,
                                            onChange: (_event, value)=>{
                                                if (value !== null) formik.setFieldValue("equipmentStatus", value).then();
                                            },
                                            sx: {
                                                height: "30px",
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).toggleButton,
                                                    sx: {
                                                        color: theme.palette.colors?.disabled
                                                    },
                                                    value: "active",
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_active
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).toggleButton,
                                                    sx: {
                                                        color: theme.palette.colors?.disabled
                                                    },
                                                    value: "inactive",
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).status_inactive
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    style: {
                                        width: isMobile ? "auto" : "50%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                            direction: "row",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).gear_items_title
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                    flexGrow: 1
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_gear_item,
                                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LibraryAdd,
                                                    onClick: ()=>setIsGearItemsDialogOpen(true)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01582792f4d803ff$export$2a87eb5c378c1c07), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($edb866787a5ead35$exports))).gearItemsList,
                                            gearItems: formik.values.gearItems,
                                            onDelete: (gearItem)=>formik.setFieldValue("gearItems", formik.values.gearItems.filter((g)=>g.gearItemId !== gearItem.uuid))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).description_title,
                value: formik.values.description,
                open: isModifyProfileDialogOpen,
                onClose: ()=>setIsModifyProfileDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a824bccb85d63e7$export$517a01c14baeae37), {
                open: isGearItemsDialogOpen,
                onClose: ()=>setIsGearItemsDialogOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61fac90fb5085076$export$f940c123e92a8996), {
                    handleClose: ()=>setIsGearItemsDialogOpen(false),
                    columnWidth: isMobile ? 12 : 6,
                    preselectedIds: formik.values.gearItems.map((equipmentGearItem)=>equipmentGearItem.gearItemId),
                    onGearItemSelected: (gearItem)=>{
                        setIsGearItemsDialogOpen(false);
                        if (!formik.values.gearItems.map((equipmentGearItem)=>equipmentGearItem.gearItemId).includes(gearItem.uuid)) formik.setFieldValue("gearItems", [
                            ...formik.values.gearItems,
                            {
                                equipmentId: equipment?.uuid,
                                gearItemId: gearItem.uuid,
                                gearItem: gearItem,
                                order: formik.values.gearItems.length
                            }
                        ]).then();
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: onClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};










var $b0f2c5b51e98bfe2$exports = {};

$parcel$export($b0f2c5b51e98bfe2$exports, "container", function () { return $b0f2c5b51e98bfe2$export$34e0f9847d4c02dd; }, function (v) { return $b0f2c5b51e98bfe2$export$34e0f9847d4c02dd = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "defaultIcon", function () { return $b0f2c5b51e98bfe2$export$ca2f546e21dcce87; }, function (v) { return $b0f2c5b51e98bfe2$export$ca2f546e21dcce87 = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "description", function () { return $b0f2c5b51e98bfe2$export$6d59db4903f20f7d; }, function (v) { return $b0f2c5b51e98bfe2$export$6d59db4903f20f7d = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "hoverButton", function () { return $b0f2c5b51e98bfe2$export$b0260c0afbf48c57; }, function (v) { return $b0f2c5b51e98bfe2$export$b0260c0afbf48c57 = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "hoverButtonIcon", function () { return $b0f2c5b51e98bfe2$export$2a797adc03a2480; }, function (v) { return $b0f2c5b51e98bfe2$export$2a797adc03a2480 = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "hoverButtonsStack", function () { return $b0f2c5b51e98bfe2$export$a8eacba2c33c9f28; }, function (v) { return $b0f2c5b51e98bfe2$export$a8eacba2c33c9f28 = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "name", function () { return $b0f2c5b51e98bfe2$export$a8ff84c12d48cfa6; }, function (v) { return $b0f2c5b51e98bfe2$export$a8ff84c12d48cfa6 = v; });
$parcel$export($b0f2c5b51e98bfe2$exports, "rightContainer", function () { return $b0f2c5b51e98bfe2$export$3280a108d7f81d56; }, function (v) { return $b0f2c5b51e98bfe2$export$3280a108d7f81d56 = v; });
var $b0f2c5b51e98bfe2$export$34e0f9847d4c02dd;
var $b0f2c5b51e98bfe2$export$ca2f546e21dcce87;
var $b0f2c5b51e98bfe2$export$6d59db4903f20f7d;
var $b0f2c5b51e98bfe2$export$b0260c0afbf48c57;
var $b0f2c5b51e98bfe2$export$2a797adc03a2480;
var $b0f2c5b51e98bfe2$export$a8eacba2c33c9f28;
var $b0f2c5b51e98bfe2$export$a8ff84c12d48cfa6;
var $b0f2c5b51e98bfe2$export$3280a108d7f81d56;
$b0f2c5b51e98bfe2$export$34e0f9847d4c02dd = `bMDv8G_container`;
$b0f2c5b51e98bfe2$export$ca2f546e21dcce87 = `bMDv8G_defaultIcon`;
$b0f2c5b51e98bfe2$export$6d59db4903f20f7d = `bMDv8G_description`;
$b0f2c5b51e98bfe2$export$b0260c0afbf48c57 = `bMDv8G_hoverButton`;
$b0f2c5b51e98bfe2$export$2a797adc03a2480 = `bMDv8G_hoverButtonIcon`;
$b0f2c5b51e98bfe2$export$a8eacba2c33c9f28 = `bMDv8G_hoverButtonsStack`;
$b0f2c5b51e98bfe2$export$a8ff84c12d48cfa6 = `bMDv8G_name`;
$b0f2c5b51e98bfe2$export$3280a108d7f81d56 = `bMDv8G_rightContainer`;


parcelRequire("7fPBF");


const $2f6acd538f745078$export$f51d7e47b05e4752 = ({ equipment: equipment, selected: selected, onClick: onClick, onContextMenu: onContextMenu })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b0f2c5b51e98bfe2$exports))).container,
        sx: {
            height: 70
        },
        elevation: 5,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "row"
            },
            style: {
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: selected ? "double" : "none"
            },
            onContextMenu: onContextMenu,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b0f2c5b51e98bfe2$exports))).defaultIcon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).SpeakerGroup
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b0f2c5b51e98bfe2$exports))).rightContainer,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b0f2c5b51e98bfe2$exports))).name,
                            children: equipment.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b0f2c5b51e98bfe2$exports))).description,
                            children: equipment.description
                        })
                    ]
                })
            ]
        })
    });
};








const $36401b58b278b21b$export$fceef9c8ae7d9595 = (setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getEquipments = (parameters)=>get("equipments", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).equipments(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), getEquipments, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).equipmentsStorage, false, true, undefined);
};


const $082dce7320d7f06d$export$3f6541da14581162 = ({ handleClose: handleClose, columnWidth: columnWidth, preselectedId: preselectedId, onEquipmentSelected: onEquipmentSelected, onClearValue: onClearValue })=>{
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [equipments, resetEquipments, setEquipments, noMoreEquipments] = (0, $36401b58b278b21b$export$fceef9c8ae7d9595)(setLoading);
    const { state: modifyDialogState, key: modifyDialogKey, openAdd: openAdd, openEdit: openEdit, close: closeModifyDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [contextEquipment, setContextEquipment] = (0, $7fPBF.useState)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const filteredEquipments = (0, $7fPBF.useMemo)(()=>{
        if (searchText == "") return equipments;
        return equipments?.filter((equipment)=>{
            return equipment.name.toLowerCase().includes(searchText.toLowerCase()) || equipment.description.toLowerCase().includes(searchText.toLowerCase());
        });
    }, [
        equipments,
        searchText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $405aa383e1a6b7c5$export$bcf6a3aec37d1871), {
        handleClose: handleClose,
        isPublic: false,
        items: filteredEquipments,
        emptyIconType: (0, $b62e530123cc4921$export$99fb0c285980a809)[(0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EQUIPMENTS],
        emptyString: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_equipments,
        addItemString: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).equipments_title,
        loading: loading,
        setLoading: setLoading,
        onSearchRequested: (searchText)=>setSearchText(searchText),
        addAction: openAdd,
        refreshAction: resetEquipments,
        onClearValue: onClearValue,
        children: [
            filteredEquipments?.map((equipment)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f6acd538f745078$export$f51d7e47b05e4752), {
                        equipment: equipment,
                        selected: preselectedId === equipment.uuid,
                        onClick: ()=>{
                            if (onEquipmentSelected) onEquipmentSelected(equipment);
                            else openEdit(equipment);
                        },
                        onContextMenu: (event)=>{
                            setContextEquipment(equipment);
                            handleContextMenu(event);
                        }
                    })
                }, equipment.uuid)),
            (loading || !noMoreEquipments) && Array.from({
                length: 20
            }, (_value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                    item: true,
                    xs: columnWidth,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                        variant: "rectangular",
                        sx: {
                            height: 70
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9f760290fea1a7f5$exports))).skeleton
                    })
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        openEdit(contextEquipment);
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97c80c478fe15f45$export$2049f968ad03478), {
                open: modifyDialogState.mode !== "closed",
                onClose: closeModifyDialog,
                equipment: modifyDialogState.item,
                onNewItem: (newEquipment)=>{
                    const newEquipments = [
                        ...equipments,
                        newEquipment
                    ];
                    newEquipments.sort((a, b)=>a.status.localeCompare(b.status, undefined, {
                            ignorePunctuation: true
                        }) || a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setEquipments(newEquipments);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onModifiedItem: (newEquipment)=>{
                    const newEquipments = equipments.map((equipment)=>equipment.uuid == newEquipment.uuid ? newEquipment : equipment);
                    newEquipments.sort((a, b)=>a.status.localeCompare(b.status, undefined, {
                            ignorePunctuation: true
                        }) || a.name.localeCompare(b.name, undefined, {
                            ignorePunctuation: true
                        }));
                    setEquipments(newEquipments);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                },
                onDeletedItem: (deletedEquipment)=>{
                    const newEquipments = equipments.filter((equipment)=>equipment.uuid != deletedEquipment.uuid);
                    setEquipments(newEquipments);
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                }
            }, modifyDialogKey)
        ]
    });
};


const $0d3cc3d9c2471161$export$21991851b0bb231f = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).attributes_title}`;
    }, []);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [selectedAttribute, setSelectedAttribute] = (0, $7fPBF.useState)();
    const [isAttributeListDrawerOpen, setIsAttributeListDrawerOpen] = (0, $7fPBF.useState)(isMobile);
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    const getAttributeDesktop = ()=>{
        switch(selectedAttribute){
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ARTISTS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d963a2e56ac79bd1$export$c45b630b80b4cbe8), {
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 3
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).STORES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c0c8fd0aacbcfe9$export$1f4e316d688f3260), {
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).LABELS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f56ce92a8b7d721$export$9451b0ecafcfb0be), {
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_FORMATS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8eaae7a275eb790c$export$aab348bda21f9238), {
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ALBUM_TYPES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3545f666fd578acf$export$cdc91b52c28c8fd3), {
                    isPublic: false,
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SLEEVE_GRADES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c47ca10f45510f06$export$95ad13dd87903477), {
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).MEDIA_GRADES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46069ed848225382$export$4360e90a91115162), {
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).SELL_VALUES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70b19905e559553e$export$b70de0c9f92ac064), {
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 3
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).IMPACTS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $970fe01944d5ec2f$export$6c19d36d9b1bbf40), {
                    columnWidth: isMobile ? 6 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EXCHANGE_RATES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08bc61c8814c0132$export$9df0037d8de6e571), {
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).TAGS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cce4818f9f0c650e$export$cb8904e0fef9e4cd), {
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).ORIGIN_COUNTRIES:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c3726884ef77bb$export$7dfca6319ee13087), {
                    isPublic: false,
                    columnWidth: isMobile ? 6 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).GEAR_ITEMS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61fac90fb5085076$export$f940c123e92a8996), {
                    columnWidth: isMobile ? 12 : 4
                });
            case (0, $aca3ef2e377cd341$export$d31c6c64cddbeeac).EQUIPMENTS:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082dce7320d7f06d$export$3f6541da14581162), {
                    columnWidth: isMobile ? 12 : 4
                });
            default:
                return currentUser && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).noSelectionDiv,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).shortcutsTitle,
                            style: {
                                color: theme.palette.primary.main
                            },
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shortcuts_title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $306f2255f4891854$export$408295e78e243e4b), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).shortcutsGrid,
                            isPublic: false,
                            showAttributesShortcut: false,
                            onImportFromDiscogs: ()=>setIsOpenDiscogsImport(true),
                            onImportFromExcel: ()=>setIsOpenExcelImport(true),
                            onEditProfile: goToUserProfile
                        })
                    ]
                });
        }
    };
    const attributeList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).attributeListContainer,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aca3ef2e377cd341$export$f632a70b7942a9ca), {
                onAttributeSelected: (attributeType)=>{
                    setIsAttributeListDrawerOpen(false);
                    setSelectedAttribute(attributeType);
                }
            })
        });
    const goToUserProfile = ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile());
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            style: {
                                marginRight: isMobile ? 0 : 8
                            },
                            onClick: ()=>{
                                setIsDrawerOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                            currentPage: "attributes",
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            isLayout: false,
                            isOpenDiscogsImport: isOpenDiscogsImport,
                            setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                            isOpenExcelImport: isOpenExcelImport,
                            setIsOpenExcelImport: setIsOpenExcelImport
                        }),
                        isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>{
                                setIsAttributeListDrawerOpen(true);
                            },
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_attributes_list,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ListAlt
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).title,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_attributes
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $921bd0ad6d18d264$export$7bf40cd2a197df2d), {
                            isPublic: false,
                            userProfile: currentUserProfile,
                            onClick: ()=>{
                                if (!currentUserProfile || currentUser?.role == "guest") return;
                                goToUserProfile();
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).mainBody,
                children: [
                    !isMobile && attributeList(),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).attributeDetail,
                        style: {
                            backgroundColor: theme.palette.background.default
                        },
                        children: [
                            getAttributeDesktop(),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8909c318ea8e18cb$exports))).credits
                            })
                        ]
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fc202f2249b2dd6f$export$2e2bcd8739ae039), {
                anchor: "left",
                open: isAttributeListDrawerOpen,
                onClose: ()=>setIsAttributeListDrawerOpen(false),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        backgroundColor: theme.palette.background.default,
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                            position: "sticky",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).attributes_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        flexGrow: 1
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                        onClick: ()=>setIsAttributeListDrawerOpen(false),
                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                    })
                                ]
                            })
                        }),
                        attributeList()
                    ]
                })
            })
        ]
    });
};


const $a676f2de7f666b38$export$e4f5f4286439c585 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0d3cc3d9c2471161$export$21991851b0bb231f), {});
};







parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $d0aed7f81db8905a$exports = {};

$parcel$export($d0aed7f81db8905a$exports, "appBar", function () { return $d0aed7f81db8905a$export$d0a9b8580e71599c; }, function (v) { return $d0aed7f81db8905a$export$d0a9b8580e71599c = v; });
$parcel$export($d0aed7f81db8905a$exports, "collectionTitle", function () { return $d0aed7f81db8905a$export$eb877aaaf03a6de7; }, function (v) { return $d0aed7f81db8905a$export$eb877aaaf03a6de7 = v; });
$parcel$export($d0aed7f81db8905a$exports, "detailBody", function () { return $d0aed7f81db8905a$export$53b275054013afb6; }, function (v) { return $d0aed7f81db8905a$export$53b275054013afb6 = v; });
$parcel$export($d0aed7f81db8905a$exports, "expandIcon", function () { return $d0aed7f81db8905a$export$577bdbd696b473b5; }, function (v) { return $d0aed7f81db8905a$export$577bdbd696b473b5 = v; });
$parcel$export($d0aed7f81db8905a$exports, "lastUpdated", function () { return $d0aed7f81db8905a$export$c60d1a715a48771d; }, function (v) { return $d0aed7f81db8905a$export$c60d1a715a48771d = v; });
$parcel$export($d0aed7f81db8905a$exports, "lastUpdatedDate", function () { return $d0aed7f81db8905a$export$9053d3ed35b7fcd9; }, function (v) { return $d0aed7f81db8905a$export$9053d3ed35b7fcd9 = v; });
$parcel$export($d0aed7f81db8905a$exports, "mainBody", function () { return $d0aed7f81db8905a$export$f239b04fc1a0c7e1; }, function (v) { return $d0aed7f81db8905a$export$f239b04fc1a0c7e1 = v; });
$parcel$export($d0aed7f81db8905a$exports, "mainContent", function () { return $d0aed7f81db8905a$export$ad430d422a89f9f0; }, function (v) { return $d0aed7f81db8905a$export$ad430d422a89f9f0 = v; });
$parcel$export($d0aed7f81db8905a$exports, "title", function () { return $d0aed7f81db8905a$export$fb184b623420d9be; }, function (v) { return $d0aed7f81db8905a$export$fb184b623420d9be = v; });
$parcel$export($d0aed7f81db8905a$exports, "toolbar", function () { return $d0aed7f81db8905a$export$f727f52c778e92d5; }, function (v) { return $d0aed7f81db8905a$export$f727f52c778e92d5 = v; });
var $d0aed7f81db8905a$export$d0a9b8580e71599c;
var $d0aed7f81db8905a$export$eb877aaaf03a6de7;
var $d0aed7f81db8905a$export$53b275054013afb6;
var $d0aed7f81db8905a$export$577bdbd696b473b5;
var $d0aed7f81db8905a$export$c60d1a715a48771d;
var $d0aed7f81db8905a$export$9053d3ed35b7fcd9;
var $d0aed7f81db8905a$export$f239b04fc1a0c7e1;
var $d0aed7f81db8905a$export$ad430d422a89f9f0;
var $d0aed7f81db8905a$export$fb184b623420d9be;
var $d0aed7f81db8905a$export$f727f52c778e92d5;
$d0aed7f81db8905a$export$d0a9b8580e71599c = `fHKz5W_appBar`;
$d0aed7f81db8905a$export$eb877aaaf03a6de7 = `fHKz5W_collectionTitle`;
$d0aed7f81db8905a$export$53b275054013afb6 = `fHKz5W_detailBody`;
$d0aed7f81db8905a$export$577bdbd696b473b5 = `fHKz5W_expandIcon`;
$d0aed7f81db8905a$export$c60d1a715a48771d = `fHKz5W_lastUpdated`;
$d0aed7f81db8905a$export$9053d3ed35b7fcd9 = `fHKz5W_lastUpdatedDate`;
$d0aed7f81db8905a$export$f239b04fc1a0c7e1 = `fHKz5W_mainBody`;
$d0aed7f81db8905a$export$ad430d422a89f9f0 = `fHKz5W_mainContent`;
$d0aed7f81db8905a$export$fb184b623420d9be = `fHKz5W_title`;
$d0aed7f81db8905a$export$f727f52c778e92d5 = `fHKz5W_toolbar`;









parcelRequire("7fPBF");






parcelRequire("7fPBF");
var $6119913b7238aea6$exports = {};

$parcel$export($6119913b7238aea6$exports, "cardDiv", function () { return $6119913b7238aea6$export$5b6b191f3c2fe4d2; }, function (v) { return $6119913b7238aea6$export$5b6b191f3c2fe4d2 = v; });
$parcel$export($6119913b7238aea6$exports, "firstItemCard", function () { return $6119913b7238aea6$export$f02f6ed487d8e098; }, function (v) { return $6119913b7238aea6$export$f02f6ed487d8e098 = v; });
$parcel$export($6119913b7238aea6$exports, "graphsDiv", function () { return $6119913b7238aea6$export$7f9e75aa60d230f3; }, function (v) { return $6119913b7238aea6$export$7f9e75aa60d230f3 = v; });
$parcel$export($6119913b7238aea6$exports, "itemCard", function () { return $6119913b7238aea6$export$e0be3821d621a3a0; }, function (v) { return $6119913b7238aea6$export$e0be3821d621a3a0 = v; });
$parcel$export($6119913b7238aea6$exports, "lastItemCard", function () { return $6119913b7238aea6$export$90787174b10be177; }, function (v) { return $6119913b7238aea6$export$90787174b10be177 = v; });
$parcel$export($6119913b7238aea6$exports, "list", function () { return $6119913b7238aea6$export$8837f4fc672e936d; }, function (v) { return $6119913b7238aea6$export$8837f4fc672e936d = v; });
$parcel$export($6119913b7238aea6$exports, "mainContainer", function () { return $6119913b7238aea6$export$eccb60d5692f3f7d; }, function (v) { return $6119913b7238aea6$export$eccb60d5692f3f7d = v; });
$parcel$export($6119913b7238aea6$exports, "mainDiv", function () { return $6119913b7238aea6$export$16666caf1c4e1af1; }, function (v) { return $6119913b7238aea6$export$16666caf1c4e1af1 = v; });
var $6119913b7238aea6$export$5b6b191f3c2fe4d2;
var $6119913b7238aea6$export$f02f6ed487d8e098;
var $6119913b7238aea6$export$7f9e75aa60d230f3;
var $6119913b7238aea6$export$e0be3821d621a3a0;
var $6119913b7238aea6$export$90787174b10be177;
var $6119913b7238aea6$export$8837f4fc672e936d;
var $6119913b7238aea6$export$eccb60d5692f3f7d;
var $6119913b7238aea6$export$16666caf1c4e1af1;
$6119913b7238aea6$export$5b6b191f3c2fe4d2 = `_6rnkSq_cardDiv`;
$6119913b7238aea6$export$f02f6ed487d8e098 = `_6rnkSq_firstItemCard`;
$6119913b7238aea6$export$7f9e75aa60d230f3 = `_6rnkSq_graphsDiv`;
$6119913b7238aea6$export$e0be3821d621a3a0 = `_6rnkSq_itemCard`;
$6119913b7238aea6$export$90787174b10be177 = `_6rnkSq_lastItemCard`;
$6119913b7238aea6$export$8837f4fc672e936d = `_6rnkSq_list`;
$6119913b7238aea6$export$eccb60d5692f3f7d = `_6rnkSq_mainContainer`;
$6119913b7238aea6$export$16666caf1c4e1af1 = `_6rnkSq_mainDiv`;




parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $e8db97472bada25e$exports = {};
(function(global, factory) {
    factory($e8db97472bada25e$exports);
})($e8db97472bada25e$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $489bbef2f916bf69$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $489bbef2f916bf69$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $489bbef2f916bf69$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $788a34246aa3a492$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $788a34246aa3a492$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $788a34246aa3a492$var$_typeof(obj);
}
function $788a34246aa3a492$var$_toArray(arr) {
    return $788a34246aa3a492$var$_arrayWithHoles(arr) || $788a34246aa3a492$var$_iterableToArray(arr) || $788a34246aa3a492$var$_unsupportedIterableToArray(arr) || $788a34246aa3a492$var$_nonIterableRest();
}
function $788a34246aa3a492$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $788a34246aa3a492$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $788a34246aa3a492$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $788a34246aa3a492$var$_arrayLikeToArray(o, minLen);
}
function $788a34246aa3a492$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $788a34246aa3a492$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $788a34246aa3a492$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $788a34246aa3a492$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $788a34246aa3a492$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $489bbef2f916bf69$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $489bbef2f916bf69$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($788a34246aa3a492$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $f984d770f53b3c67$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f984d770f53b3c67$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f984d770f53b3c67$var$_typeof(obj);
}
function $f984d770f53b3c67$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f984d770f53b3c67$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f984d770f53b3c67$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f984d770f53b3c67$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f984d770f53b3c67$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f984d770f53b3c67$var$_defineProperty(obj, key, value) {
    key = $f984d770f53b3c67$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f984d770f53b3c67$var$_toPropertyKey(arg) {
    var key = $f984d770f53b3c67$var$_toPrimitive(arg, "string");
    return $f984d770f53b3c67$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f984d770f53b3c67$var$_toPrimitive(input, hint) {
    if ($f984d770f53b3c67$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f984d770f53b3c67$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $f984d770f53b3c67$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $f984d770f53b3c67$var$IN_LINE_PREFIX_LIST = [
    '-webkit-',
    '-moz-',
    '-o-',
    '-ms-'
];
var $f984d770f53b3c67$var$IN_COMPATIBLE_PROPERTY = [
    'transform',
    'transformOrigin',
    'transition'
];
var $f984d770f53b3c67$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $f984d770f53b3c67$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $f984d770f53b3c67$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $f984d770f53b3c67$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($f984d770f53b3c67$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $f984d770f53b3c67$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === 'transition';
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $f984d770f53b3c67$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($f984d770f53b3c67$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $f984d770f53b3c67$var$_objectSpread($f984d770f53b3c67$var$_objectSpread({}, result), {}, $f984d770f53b3c67$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $f984d770f53b3c67$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $f984d770f53b3c67$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $f984d770f53b3c67$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $f984d770f53b3c67$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $f984d770f53b3c67$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $f984d770f53b3c67$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $f984d770f53b3c67$var$_objectSpread($f984d770f53b3c67$var$_objectSpread({}, res), {}, $f984d770f53b3c67$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $f984d770f53b3c67$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $f984d770f53b3c67$var$_objectSpread($f984d770f53b3c67$var$_objectSpread({}, res), $f984d770f53b3c67$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $f984d770f53b3c67$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $f984d770f53b3c67$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $f984d770f53b3c67$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($f984d770f53b3c67$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $f984d770f53b3c67$var$isDev = false;
var $f984d770f53b3c67$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($f984d770f53b3c67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $204c638eabc16c7c$var$_slicedToArray(arr, i) {
    return $204c638eabc16c7c$var$_arrayWithHoles(arr) || $204c638eabc16c7c$var$_iterableToArrayLimit(arr, i) || $204c638eabc16c7c$var$_unsupportedIterableToArray(arr, i) || $204c638eabc16c7c$var$_nonIterableRest();
}
function $204c638eabc16c7c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $204c638eabc16c7c$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $204c638eabc16c7c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $204c638eabc16c7c$var$_toConsumableArray(arr) {
    return $204c638eabc16c7c$var$_arrayWithoutHoles(arr) || $204c638eabc16c7c$var$_iterableToArray(arr) || $204c638eabc16c7c$var$_unsupportedIterableToArray(arr) || $204c638eabc16c7c$var$_nonIterableSpread();
}
function $204c638eabc16c7c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $204c638eabc16c7c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $204c638eabc16c7c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $204c638eabc16c7c$var$_arrayLikeToArray(o, minLen);
}
function $204c638eabc16c7c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $204c638eabc16c7c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $204c638eabc16c7c$var$_arrayLikeToArray(arr);
}
function $204c638eabc16c7c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $204c638eabc16c7c$var$ACCURACY = 1e-4;
var $204c638eabc16c7c$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $204c638eabc16c7c$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $204c638eabc16c7c$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $204c638eabc16c7c$var$cubicBezierFactor(c1, c2);
        return $204c638eabc16c7c$var$multyTime(params, t);
    };
};
var $204c638eabc16c7c$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $204c638eabc16c7c$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($204c638eabc16c7c$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $204c638eabc16c7c$var$multyTime(newParams, t);
    };
};
var $204c638eabc16c7c$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $204c638eabc16c7c$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $204c638eabc16c7c$var$cubicBezier(x1, x2);
    var curveY = $204c638eabc16c7c$var$cubicBezier(y1, y2);
    var derCurveX = $204c638eabc16c7c$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $204c638eabc16c7c$var$ACCURACY || derVal < $204c638eabc16c7c$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $204c638eabc16c7c$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $204c638eabc16c7c$var$ACCURACY && Math.abs(newV) < $204c638eabc16c7c$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $204c638eabc16c7c$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $204c638eabc16c7c$export$56c51296f72f0592(easing);
        case 'spring':
            return $204c638eabc16c7c$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $204c638eabc16c7c$export$56c51296f72f0592(easing);
            (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $c51ac03d54a173a9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c51ac03d54a173a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c51ac03d54a173a9$var$_typeof(obj);
}
function $c51ac03d54a173a9$var$_toConsumableArray(arr) {
    return $c51ac03d54a173a9$var$_arrayWithoutHoles(arr) || $c51ac03d54a173a9$var$_iterableToArray(arr) || $c51ac03d54a173a9$var$_unsupportedIterableToArray(arr) || $c51ac03d54a173a9$var$_nonIterableSpread();
}
function $c51ac03d54a173a9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c51ac03d54a173a9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c51ac03d54a173a9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c51ac03d54a173a9$var$_arrayLikeToArray(arr);
}
function $c51ac03d54a173a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c51ac03d54a173a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c51ac03d54a173a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c51ac03d54a173a9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c51ac03d54a173a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c51ac03d54a173a9$var$_defineProperty(obj, key, value) {
    key = $c51ac03d54a173a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c51ac03d54a173a9$var$_toPropertyKey(arg) {
    var key = $c51ac03d54a173a9$var$_toPrimitive(arg, "string");
    return $c51ac03d54a173a9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c51ac03d54a173a9$var$_toPrimitive(input, hint) {
    if ($c51ac03d54a173a9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c51ac03d54a173a9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c51ac03d54a173a9$var$_slicedToArray(arr, i) {
    return $c51ac03d54a173a9$var$_arrayWithHoles(arr) || $c51ac03d54a173a9$var$_iterableToArrayLimit(arr, i) || $c51ac03d54a173a9$var$_unsupportedIterableToArray(arr, i) || $c51ac03d54a173a9$var$_nonIterableRest();
}
function $c51ac03d54a173a9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c51ac03d54a173a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c51ac03d54a173a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c51ac03d54a173a9$var$_arrayLikeToArray(o, minLen);
}
function $c51ac03d54a173a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c51ac03d54a173a9$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c51ac03d54a173a9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c51ac03d54a173a9$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $c51ac03d54a173a9$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $c51ac03d54a173a9$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
        if ($c51ac03d54a173a9$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $c51ac03d54a173a9$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
        if ($c51ac03d54a173a9$var$needContinue(val)) return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, val), {}, {
            velocity: $c51ac03d54a173a9$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $c51ac03d54a173a9$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$c51ac03d54a173a9$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $f984d770f53b3c67$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, res), {}, $c51ac03d54a173a9$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, res), {}, $c51ac03d54a173a9$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($c51ac03d54a173a9$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $c51ac03d54a173a9$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
            return $c51ac03d54a173a9$var$alpha.apply(void 0, $c51ac03d54a173a9$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
                return $c51ac03d54a173a9$var$alpha.apply(void 0, $c51ac03d54a173a9$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $c2acdb38c69c603a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c2acdb38c69c603a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c2acdb38c69c603a$var$_typeof(obj);
}
var $c2acdb38c69c603a$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $c2acdb38c69c603a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c2acdb38c69c603a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c2acdb38c69c603a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c2acdb38c69c603a$var$_toConsumableArray(arr) {
    return $c2acdb38c69c603a$var$_arrayWithoutHoles(arr) || $c2acdb38c69c603a$var$_iterableToArray(arr) || $c2acdb38c69c603a$var$_unsupportedIterableToArray(arr) || $c2acdb38c69c603a$var$_nonIterableSpread();
}
function $c2acdb38c69c603a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c2acdb38c69c603a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c2acdb38c69c603a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c2acdb38c69c603a$var$_arrayLikeToArray(o, minLen);
}
function $c2acdb38c69c603a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c2acdb38c69c603a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c2acdb38c69c603a$var$_arrayLikeToArray(arr);
}
function $c2acdb38c69c603a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c2acdb38c69c603a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c2acdb38c69c603a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c2acdb38c69c603a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c2acdb38c69c603a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c2acdb38c69c603a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c2acdb38c69c603a$var$_defineProperty(obj, key, value) {
    key = $c2acdb38c69c603a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2acdb38c69c603a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c2acdb38c69c603a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c2acdb38c69c603a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c2acdb38c69c603a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c2acdb38c69c603a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2acdb38c69c603a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c2acdb38c69c603a$var$_toPropertyKey(arg) {
    var key = $c2acdb38c69c603a$var$_toPrimitive(arg, "string");
    return $c2acdb38c69c603a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c2acdb38c69c603a$var$_toPrimitive(input, hint) {
    if ($c2acdb38c69c603a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c2acdb38c69c603a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c2acdb38c69c603a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c2acdb38c69c603a$var$_setPrototypeOf(subClass, superClass);
}
function $c2acdb38c69c603a$var$_setPrototypeOf(o, p) {
    $c2acdb38c69c603a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c2acdb38c69c603a$var$_setPrototypeOf(o, p);
}
function $c2acdb38c69c603a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c2acdb38c69c603a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c2acdb38c69c603a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c2acdb38c69c603a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c2acdb38c69c603a$var$_possibleConstructorReturn(this, result);
    };
}
function $c2acdb38c69c603a$var$_possibleConstructorReturn(self, call) {
    if (call && ($c2acdb38c69c603a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c2acdb38c69c603a$var$_assertThisInitialized(self);
}
function $c2acdb38c69c603a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c2acdb38c69c603a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c2acdb38c69c603a$var$_getPrototypeOf(o) {
    $c2acdb38c69c603a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c2acdb38c69c603a$var$_getPrototypeOf(o);
}
var $c2acdb38c69c603a$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $c2acdb38c69c603a$var$_inherits(Animate, _PureComponent);
    var _super = $c2acdb38c69c603a$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $c2acdb38c69c603a$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($c2acdb38c69c603a$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($c2acdb38c69c603a$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $c2acdb38c69c603a$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $c2acdb38c69c603a$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $c2acdb38c69c603a$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $e8db97472bada25e$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $c51ac03d54a173a9$export$2e2bcd8739ae039)(from, to, (0, $204c638eabc16c7c$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($c2acdb38c69c603a$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $f984d770f53b3c67$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($c2acdb38c69c603a$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $f984d770f53b3c67$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($c2acdb38c69c603a$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $788a34246aa3a492$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $f984d770f53b3c67$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $c2acdb38c69c603a$var$_objectWithoutProperties(_this$props4, $c2acdb38c69c603a$var$_excluded);
                var count = (0, $7fPBF.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $f984d770f53b3c67$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $7fPBF.cloneElement)(container, $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, others), {}, {
                        style: $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $7fPBF.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, (0, $7fPBF.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $7fPBF.PureComponent));
$c2acdb38c69c603a$var$Animate.displayName = 'Animate';
$c2acdb38c69c603a$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$c2acdb38c69c603a$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $c2acdb38c69c603a$export$2e2bcd8739ae039 = $c2acdb38c69c603a$var$Animate;





var $7fPBF = parcelRequire("7fPBF");
var $07170f44e87d5bd3$exports = {};
"use strict";

var $07170f44e87d5bd3$var$_CSSTransition = $07170f44e87d5bd3$var$_interopRequireDefault((parcelRequire("SlX8h")));

var $07170f44e87d5bd3$var$_ReplaceTransition = $07170f44e87d5bd3$var$_interopRequireDefault((parcelRequire("er0Gn")));

var $07170f44e87d5bd3$var$_TransitionGroup = $07170f44e87d5bd3$var$_interopRequireDefault((parcelRequire("3heAx")));

var $07170f44e87d5bd3$var$_Transition = $07170f44e87d5bd3$var$_interopRequireDefault((parcelRequire("a9NWs")));
function $07170f44e87d5bd3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$07170f44e87d5bd3$exports = {
    Transition: $07170f44e87d5bd3$var$_Transition.default,
    TransitionGroup: $07170f44e87d5bd3$var$_TransitionGroup.default,
    ReplaceTransition: $07170f44e87d5bd3$var$_ReplaceTransition.default,
    CSSTransition: $07170f44e87d5bd3$var$_CSSTransition.default
};




var $7fPBF = parcelRequire("7fPBF");



var $7581110a1fad8d4b$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $7581110a1fad8d4b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7581110a1fad8d4b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7581110a1fad8d4b$var$_typeof(obj);
}
function $7581110a1fad8d4b$var$_extends() {
    $7581110a1fad8d4b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7581110a1fad8d4b$var$_extends.apply(this, arguments);
}
function $7581110a1fad8d4b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7581110a1fad8d4b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7581110a1fad8d4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7581110a1fad8d4b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7581110a1fad8d4b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7581110a1fad8d4b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7581110a1fad8d4b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7581110a1fad8d4b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7581110a1fad8d4b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7581110a1fad8d4b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7581110a1fad8d4b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7581110a1fad8d4b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7581110a1fad8d4b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7581110a1fad8d4b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7581110a1fad8d4b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7581110a1fad8d4b$var$_setPrototypeOf(subClass, superClass);
}
function $7581110a1fad8d4b$var$_setPrototypeOf(o, p) {
    $7581110a1fad8d4b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7581110a1fad8d4b$var$_setPrototypeOf(o, p);
}
function $7581110a1fad8d4b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7581110a1fad8d4b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7581110a1fad8d4b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7581110a1fad8d4b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7581110a1fad8d4b$var$_possibleConstructorReturn(this, result);
    };
}
function $7581110a1fad8d4b$var$_possibleConstructorReturn(self, call) {
    if (call && ($7581110a1fad8d4b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7581110a1fad8d4b$var$_assertThisInitialized(self);
}
function $7581110a1fad8d4b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7581110a1fad8d4b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7581110a1fad8d4b$var$_getPrototypeOf(o) {
    $7581110a1fad8d4b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7581110a1fad8d4b$var$_getPrototypeOf(o);
}
function $7581110a1fad8d4b$var$_defineProperty(obj, key, value) {
    key = $7581110a1fad8d4b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7581110a1fad8d4b$var$_toPropertyKey(arg) {
    var key = $7581110a1fad8d4b$var$_toPrimitive(arg, "string");
    return $7581110a1fad8d4b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7581110a1fad8d4b$var$_toPrimitive(input, hint) {
    if ($7581110a1fad8d4b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7581110a1fad8d4b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $7581110a1fad8d4b$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $7581110a1fad8d4b$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $7581110a1fad8d4b$var$_inherits(AnimateGroupChild, _Component);
    var _super = $7581110a1fad8d4b$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $7581110a1fad8d4b$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $7581110a1fad8d4b$var$_defineProperty($7581110a1fad8d4b$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $7581110a1fad8d4b$var$_defineProperty($7581110a1fad8d4b$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $7581110a1fad8d4b$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($7581110a1fad8d4b$var$_objectSpread($7581110a1fad8d4b$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $7581110a1fad8d4b$var$parseDurationOfSingleTransition(appearOptions) + $7581110a1fad8d4b$var$parseDurationOfSingleTransition(enterOptions) + $7581110a1fad8d4b$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $7581110a1fad8d4b$var$_objectWithoutProperties(_this$props3, $7581110a1fad8d4b$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $07170f44e87d5bd3$exports.Transition), $7581110a1fad8d4b$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c2acdb38c69c603a$export$2e2bcd8739ae039), _this2.state, (0, $7fPBF.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $7fPBF.Component));
$7581110a1fad8d4b$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).element
};
var $7581110a1fad8d4b$export$2e2bcd8739ae039 = $7581110a1fad8d4b$var$AnimateGroupChild;


function $70bf7b3c1069a567$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $07170f44e87d5bd3$exports.TransitionGroup), {
        component: component
    }, (0, $7fPBF.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7581110a1fad8d4b$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$70bf7b3c1069a567$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
$70bf7b3c1069a567$var$AnimateGroup.defaultProps = {
    component: 'span'
};
var $70bf7b3c1069a567$export$2e2bcd8739ae039 = $70bf7b3c1069a567$var$AnimateGroup;


var $36c7fa330327890a$export$2e2bcd8739ae039 = (0, $c2acdb38c69c603a$export$2e2bcd8739ae039);


var $b2b661eb4d0f23aa$exports = {};
var $56884261d61a9b08$exports = {};
var $62565b4461be49e6$exports = {};
var $2748937caa067712$exports = {};
var $9303d288a5074dfa$exports = {};
var $0d19333d185b6450$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $0d19333d185b6450$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$0d19333d185b6450$exports = $0d19333d185b6450$var$listCacheClear;


var $6765df0399b7dc5f$exports = {};
var $7ad97716a5527360$exports = {};
var $5a333cb39ab72c13$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $5a333cb39ab72c13$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$5a333cb39ab72c13$exports = $5a333cb39ab72c13$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7ad97716a5527360$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($5a333cb39ab72c13$exports(array[length][0], key)) return length;
    }
    return -1;
}
$7ad97716a5527360$exports = $7ad97716a5527360$var$assocIndexOf;


/** Used for built-in method references. */ var $6765df0399b7dc5f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6765df0399b7dc5f$var$splice = $6765df0399b7dc5f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6765df0399b7dc5f$var$listCacheDelete(key) {
    var data = this.__data__, index = $7ad97716a5527360$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6765df0399b7dc5f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$6765df0399b7dc5f$exports = $6765df0399b7dc5f$var$listCacheDelete;


var $e1e9cc381701d2de$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1e9cc381701d2de$var$listCacheGet(key) {
    var data = this.__data__, index = $7ad97716a5527360$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e1e9cc381701d2de$exports = $e1e9cc381701d2de$var$listCacheGet;


var $aca6db7c3805eb9f$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $aca6db7c3805eb9f$var$listCacheHas(key) {
    return $7ad97716a5527360$exports(this.__data__, key) > -1;
}
$aca6db7c3805eb9f$exports = $aca6db7c3805eb9f$var$listCacheHas;


var $735dda68143a53e8$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $735dda68143a53e8$var$listCacheSet(key, value) {
    var data = this.__data__, index = $7ad97716a5527360$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$735dda68143a53e8$exports = $735dda68143a53e8$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9303d288a5074dfa$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9303d288a5074dfa$var$ListCache.prototype.clear = $0d19333d185b6450$exports;
$9303d288a5074dfa$var$ListCache.prototype['delete'] = $6765df0399b7dc5f$exports;
$9303d288a5074dfa$var$ListCache.prototype.get = $e1e9cc381701d2de$exports;
$9303d288a5074dfa$var$ListCache.prototype.has = $aca6db7c3805eb9f$exports;
$9303d288a5074dfa$var$ListCache.prototype.set = $735dda68143a53e8$exports;
$9303d288a5074dfa$exports = $9303d288a5074dfa$var$ListCache;


var $19336b505cd2619e$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $19336b505cd2619e$var$stackClear() {
    this.__data__ = new $9303d288a5074dfa$exports;
    this.size = 0;
}
$19336b505cd2619e$exports = $19336b505cd2619e$var$stackClear;


var $051a7b56eee0864f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $051a7b56eee0864f$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$051a7b56eee0864f$exports = $051a7b56eee0864f$var$stackDelete;


var $affc579cd0cbceb0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $affc579cd0cbceb0$var$stackGet(key) {
    return this.__data__.get(key);
}
$affc579cd0cbceb0$exports = $affc579cd0cbceb0$var$stackGet;


var $adcc3aa568291406$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $adcc3aa568291406$var$stackHas(key) {
    return this.__data__.has(key);
}
$adcc3aa568291406$exports = $adcc3aa568291406$var$stackHas;


var $eafcbf77ceda6f19$exports = {};

var $3f400000bf5e8247$exports = {};
var $89b1ca2cc85531fb$exports = {};
var $b4640d6b6191eae0$exports = {};
var $fcbbb7ef85cdd01b$exports = {};
var $e95a344dcaa52f73$exports = {};
var $0962998ca792683c$exports = {};

var $2Znjj = parcelRequire("2Znjj");
/** Built-in value references. */ var $0962998ca792683c$var$Symbol = $2Znjj.Symbol;
$0962998ca792683c$exports = $0962998ca792683c$var$Symbol;


var $93cfb5d21a3ece12$exports = {};

/** Used for built-in method references. */ var $93cfb5d21a3ece12$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $93cfb5d21a3ece12$var$hasOwnProperty = $93cfb5d21a3ece12$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $93cfb5d21a3ece12$var$nativeObjectToString = $93cfb5d21a3ece12$var$objectProto.toString;
/** Built-in value references. */ var $93cfb5d21a3ece12$var$symToStringTag = $0962998ca792683c$exports ? $0962998ca792683c$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $93cfb5d21a3ece12$var$getRawTag(value) {
    var isOwn = $93cfb5d21a3ece12$var$hasOwnProperty.call(value, $93cfb5d21a3ece12$var$symToStringTag), tag = value[$93cfb5d21a3ece12$var$symToStringTag];
    try {
        value[$93cfb5d21a3ece12$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $93cfb5d21a3ece12$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$93cfb5d21a3ece12$var$symToStringTag] = tag;
        else delete value[$93cfb5d21a3ece12$var$symToStringTag];
    }
    return result;
}
$93cfb5d21a3ece12$exports = $93cfb5d21a3ece12$var$getRawTag;


var $d4294151676346ac$exports = {};
/** Used for built-in method references. */ var $d4294151676346ac$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d4294151676346ac$var$nativeObjectToString = $d4294151676346ac$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d4294151676346ac$var$objectToString(value) {
    return $d4294151676346ac$var$nativeObjectToString.call(value);
}
$d4294151676346ac$exports = $d4294151676346ac$var$objectToString;


/** `Object#toString` result references. */ var $e95a344dcaa52f73$var$nullTag = '[object Null]', $e95a344dcaa52f73$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e95a344dcaa52f73$var$symToStringTag = $0962998ca792683c$exports ? $0962998ca792683c$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e95a344dcaa52f73$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e95a344dcaa52f73$var$undefinedTag : $e95a344dcaa52f73$var$nullTag;
    return $e95a344dcaa52f73$var$symToStringTag && $e95a344dcaa52f73$var$symToStringTag in Object(value) ? $93cfb5d21a3ece12$exports(value) : $d4294151676346ac$exports(value);
}
$e95a344dcaa52f73$exports = $e95a344dcaa52f73$var$baseGetTag;


var $7aa8549693d433a8$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7aa8549693d433a8$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$7aa8549693d433a8$exports = $7aa8549693d433a8$var$isObject;


/** `Object#toString` result references. */ var $fcbbb7ef85cdd01b$var$asyncTag = '[object AsyncFunction]', $fcbbb7ef85cdd01b$var$funcTag = '[object Function]', $fcbbb7ef85cdd01b$var$genTag = '[object GeneratorFunction]', $fcbbb7ef85cdd01b$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $fcbbb7ef85cdd01b$var$isFunction(value) {
    if (!$7aa8549693d433a8$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $e95a344dcaa52f73$exports(value);
    return tag == $fcbbb7ef85cdd01b$var$funcTag || tag == $fcbbb7ef85cdd01b$var$genTag || tag == $fcbbb7ef85cdd01b$var$asyncTag || tag == $fcbbb7ef85cdd01b$var$proxyTag;
}
$fcbbb7ef85cdd01b$exports = $fcbbb7ef85cdd01b$var$isFunction;


var $9c16e5249fdc4b8d$exports = {};
var $2c3c53fc4bdd5dc4$exports = {};

var $2Znjj = parcelRequire("2Znjj");
/** Used to detect overreaching core-js shims. */ var $2c3c53fc4bdd5dc4$var$coreJsData = $2Znjj["__core-js_shared__"];
$2c3c53fc4bdd5dc4$exports = $2c3c53fc4bdd5dc4$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $9c16e5249fdc4b8d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($2c3c53fc4bdd5dc4$exports && $2c3c53fc4bdd5dc4$exports.keys && $2c3c53fc4bdd5dc4$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9c16e5249fdc4b8d$var$isMasked(func) {
    return !!$9c16e5249fdc4b8d$var$maskSrcKey && $9c16e5249fdc4b8d$var$maskSrcKey in func;
}
$9c16e5249fdc4b8d$exports = $9c16e5249fdc4b8d$var$isMasked;



var $3044b8f0dbd34e19$exports = {};
/** Used for built-in method references. */ var $3044b8f0dbd34e19$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3044b8f0dbd34e19$var$funcToString = $3044b8f0dbd34e19$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3044b8f0dbd34e19$var$toSource(func) {
    if (func != null) {
        try {
            return $3044b8f0dbd34e19$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$3044b8f0dbd34e19$exports = $3044b8f0dbd34e19$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b4640d6b6191eae0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b4640d6b6191eae0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b4640d6b6191eae0$var$funcProto = Function.prototype, $b4640d6b6191eae0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b4640d6b6191eae0$var$funcToString = $b4640d6b6191eae0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b4640d6b6191eae0$var$hasOwnProperty = $b4640d6b6191eae0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b4640d6b6191eae0$var$reIsNative = RegExp('^' + $b4640d6b6191eae0$var$funcToString.call($b4640d6b6191eae0$var$hasOwnProperty).replace($b4640d6b6191eae0$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b4640d6b6191eae0$var$baseIsNative(value) {
    if (!$7aa8549693d433a8$exports(value) || $9c16e5249fdc4b8d$exports(value)) return false;
    var pattern = $fcbbb7ef85cdd01b$exports(value) ? $b4640d6b6191eae0$var$reIsNative : $b4640d6b6191eae0$var$reIsHostCtor;
    return pattern.test($3044b8f0dbd34e19$exports(value));
}
$b4640d6b6191eae0$exports = $b4640d6b6191eae0$var$baseIsNative;


var $05a658754a1fc18f$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $05a658754a1fc18f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$05a658754a1fc18f$exports = $05a658754a1fc18f$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $89b1ca2cc85531fb$var$getNative(object, key) {
    var value = $05a658754a1fc18f$exports(object, key);
    return $b4640d6b6191eae0$exports(value) ? value : undefined;
}
$89b1ca2cc85531fb$exports = $89b1ca2cc85531fb$var$getNative;



var $2Znjj = parcelRequire("2Znjj");
/* Built-in method references that are verified to be native. */ var $3f400000bf5e8247$var$Map = $89b1ca2cc85531fb$exports($2Znjj, 'Map');
$3f400000bf5e8247$exports = $3f400000bf5e8247$var$Map;


var $def09d7a5bbf6d67$exports = {};
var $0a80e2824dc54df1$exports = {};
var $3f64f0bd45b8d379$exports = {};
var $d4e95a893f5d4453$exports = {};
var $64a97d3276f1682f$exports = {};

/* Built-in method references that are verified to be native. */ var $64a97d3276f1682f$var$nativeCreate = $89b1ca2cc85531fb$exports(Object, 'create');
$64a97d3276f1682f$exports = $64a97d3276f1682f$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $d4e95a893f5d4453$var$hashClear() {
    this.__data__ = $64a97d3276f1682f$exports ? $64a97d3276f1682f$exports(null) : {};
    this.size = 0;
}
$d4e95a893f5d4453$exports = $d4e95a893f5d4453$var$hashClear;


var $17531fa8d23c3276$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $17531fa8d23c3276$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$17531fa8d23c3276$exports = $17531fa8d23c3276$var$hashDelete;


var $db4da686bd6692ba$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $db4da686bd6692ba$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $db4da686bd6692ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $db4da686bd6692ba$var$hasOwnProperty = $db4da686bd6692ba$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $db4da686bd6692ba$var$hashGet(key) {
    var data = this.__data__;
    if ($64a97d3276f1682f$exports) {
        var result = data[key];
        return result === $db4da686bd6692ba$var$HASH_UNDEFINED ? undefined : result;
    }
    return $db4da686bd6692ba$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$db4da686bd6692ba$exports = $db4da686bd6692ba$var$hashGet;


var $b07a39f7650b2376$exports = {};

/** Used for built-in method references. */ var $b07a39f7650b2376$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b07a39f7650b2376$var$hasOwnProperty = $b07a39f7650b2376$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b07a39f7650b2376$var$hashHas(key) {
    var data = this.__data__;
    return $64a97d3276f1682f$exports ? data[key] !== undefined : $b07a39f7650b2376$var$hasOwnProperty.call(data, key);
}
$b07a39f7650b2376$exports = $b07a39f7650b2376$var$hashHas;


var $636495200f26a2ae$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $636495200f26a2ae$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $636495200f26a2ae$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $64a97d3276f1682f$exports && value === undefined ? $636495200f26a2ae$var$HASH_UNDEFINED : value;
    return this;
}
$636495200f26a2ae$exports = $636495200f26a2ae$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3f64f0bd45b8d379$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3f64f0bd45b8d379$var$Hash.prototype.clear = $d4e95a893f5d4453$exports;
$3f64f0bd45b8d379$var$Hash.prototype['delete'] = $17531fa8d23c3276$exports;
$3f64f0bd45b8d379$var$Hash.prototype.get = $db4da686bd6692ba$exports;
$3f64f0bd45b8d379$var$Hash.prototype.has = $b07a39f7650b2376$exports;
$3f64f0bd45b8d379$var$Hash.prototype.set = $636495200f26a2ae$exports;
$3f64f0bd45b8d379$exports = $3f64f0bd45b8d379$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0a80e2824dc54df1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $3f64f0bd45b8d379$exports,
        'map': new ($3f400000bf5e8247$exports || $9303d288a5074dfa$exports),
        'string': new $3f64f0bd45b8d379$exports
    };
}
$0a80e2824dc54df1$exports = $0a80e2824dc54df1$var$mapCacheClear;


var $4cc35cce264a8207$exports = {};
var $910792839453534e$exports = {};
var $40bd948f3fd847b2$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $40bd948f3fd847b2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$40bd948f3fd847b2$exports = $40bd948f3fd847b2$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $910792839453534e$var$getMapData(map, key) {
    var data = map.__data__;
    return $40bd948f3fd847b2$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$910792839453534e$exports = $910792839453534e$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4cc35cce264a8207$var$mapCacheDelete(key) {
    var result = $910792839453534e$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$4cc35cce264a8207$exports = $4cc35cce264a8207$var$mapCacheDelete;


var $fb19f00b62173935$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb19f00b62173935$var$mapCacheGet(key) {
    return $910792839453534e$exports(this, key).get(key);
}
$fb19f00b62173935$exports = $fb19f00b62173935$var$mapCacheGet;


var $25a472879ea6d2a0$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $25a472879ea6d2a0$var$mapCacheHas(key) {
    return $910792839453534e$exports(this, key).has(key);
}
$25a472879ea6d2a0$exports = $25a472879ea6d2a0$var$mapCacheHas;


var $a6a9a2fde5f6a0b1$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a6a9a2fde5f6a0b1$var$mapCacheSet(key, value) {
    var data = $910792839453534e$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a6a9a2fde5f6a0b1$exports = $a6a9a2fde5f6a0b1$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $def09d7a5bbf6d67$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$def09d7a5bbf6d67$var$MapCache.prototype.clear = $0a80e2824dc54df1$exports;
$def09d7a5bbf6d67$var$MapCache.prototype['delete'] = $4cc35cce264a8207$exports;
$def09d7a5bbf6d67$var$MapCache.prototype.get = $fb19f00b62173935$exports;
$def09d7a5bbf6d67$var$MapCache.prototype.has = $25a472879ea6d2a0$exports;
$def09d7a5bbf6d67$var$MapCache.prototype.set = $a6a9a2fde5f6a0b1$exports;
$def09d7a5bbf6d67$exports = $def09d7a5bbf6d67$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $eafcbf77ceda6f19$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $eafcbf77ceda6f19$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9303d288a5074dfa$exports) {
        var pairs = data.__data__;
        if (!$3f400000bf5e8247$exports || pairs.length < $eafcbf77ceda6f19$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $def09d7a5bbf6d67$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$eafcbf77ceda6f19$exports = $eafcbf77ceda6f19$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2748937caa067712$var$Stack(entries) {
    var data = this.__data__ = new $9303d288a5074dfa$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$2748937caa067712$var$Stack.prototype.clear = $19336b505cd2619e$exports;
$2748937caa067712$var$Stack.prototype['delete'] = $051a7b56eee0864f$exports;
$2748937caa067712$var$Stack.prototype.get = $affc579cd0cbceb0$exports;
$2748937caa067712$var$Stack.prototype.has = $adcc3aa568291406$exports;
$2748937caa067712$var$Stack.prototype.set = $eafcbf77ceda6f19$exports;
$2748937caa067712$exports = $2748937caa067712$var$Stack;


var $893babde388ca56a$exports = {};
var $bc247c70e6ef02ba$exports = {};

var $4b87fdba1a50f43b$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $4b87fdba1a50f43b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $4b87fdba1a50f43b$var$setCacheAdd(value) {
    this.__data__.set(value, $4b87fdba1a50f43b$var$HASH_UNDEFINED);
    return this;
}
$4b87fdba1a50f43b$exports = $4b87fdba1a50f43b$var$setCacheAdd;


var $0b840f9f2e52ad42$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0b840f9f2e52ad42$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$0b840f9f2e52ad42$exports = $0b840f9f2e52ad42$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $bc247c70e6ef02ba$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $def09d7a5bbf6d67$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$bc247c70e6ef02ba$var$SetCache.prototype.add = $bc247c70e6ef02ba$var$SetCache.prototype.push = $4b87fdba1a50f43b$exports;
$bc247c70e6ef02ba$var$SetCache.prototype.has = $0b840f9f2e52ad42$exports;
$bc247c70e6ef02ba$exports = $bc247c70e6ef02ba$var$SetCache;


var $cf770c9228073fc0$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $cf770c9228073fc0$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$cf770c9228073fc0$exports = $cf770c9228073fc0$var$arraySome;


var $94650024ba6b2b85$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $94650024ba6b2b85$var$cacheHas(cache, key) {
    return cache.has(key);
}
$94650024ba6b2b85$exports = $94650024ba6b2b85$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $893babde388ca56a$var$COMPARE_PARTIAL_FLAG = 1, $893babde388ca56a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $893babde388ca56a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $893babde388ca56a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $893babde388ca56a$var$COMPARE_UNORDERED_FLAG ? new $bc247c70e6ef02ba$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$cf770c9228073fc0$exports(other, function(othValue, othIndex) {
                if (!$94650024ba6b2b85$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$893babde388ca56a$exports = $893babde388ca56a$var$equalArrays;


var $65869f4a1ae7f1ad$exports = {};

var $8bb09d77e44c2fa3$exports = {};

var $2Znjj = parcelRequire("2Znjj");
/** Built-in value references. */ var $8bb09d77e44c2fa3$var$Uint8Array = $2Znjj.Uint8Array;
$8bb09d77e44c2fa3$exports = $8bb09d77e44c2fa3$var$Uint8Array;




var $b5427e536cab0671$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $b5427e536cab0671$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$b5427e536cab0671$exports = $b5427e536cab0671$var$mapToArray;


var $74670b58ce191e08$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $74670b58ce191e08$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$74670b58ce191e08$exports = $74670b58ce191e08$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $65869f4a1ae7f1ad$var$COMPARE_PARTIAL_FLAG = 1, $65869f4a1ae7f1ad$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $65869f4a1ae7f1ad$var$boolTag = '[object Boolean]', $65869f4a1ae7f1ad$var$dateTag = '[object Date]', $65869f4a1ae7f1ad$var$errorTag = '[object Error]', $65869f4a1ae7f1ad$var$mapTag = '[object Map]', $65869f4a1ae7f1ad$var$numberTag = '[object Number]', $65869f4a1ae7f1ad$var$regexpTag = '[object RegExp]', $65869f4a1ae7f1ad$var$setTag = '[object Set]', $65869f4a1ae7f1ad$var$stringTag = '[object String]', $65869f4a1ae7f1ad$var$symbolTag = '[object Symbol]';
var $65869f4a1ae7f1ad$var$arrayBufferTag = '[object ArrayBuffer]', $65869f4a1ae7f1ad$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $65869f4a1ae7f1ad$var$symbolProto = $0962998ca792683c$exports ? $0962998ca792683c$exports.prototype : undefined, $65869f4a1ae7f1ad$var$symbolValueOf = $65869f4a1ae7f1ad$var$symbolProto ? $65869f4a1ae7f1ad$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $65869f4a1ae7f1ad$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $65869f4a1ae7f1ad$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $65869f4a1ae7f1ad$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $8bb09d77e44c2fa3$exports(object), new $8bb09d77e44c2fa3$exports(other))) return false;
            return true;
        case $65869f4a1ae7f1ad$var$boolTag:
        case $65869f4a1ae7f1ad$var$dateTag:
        case $65869f4a1ae7f1ad$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $5a333cb39ab72c13$exports(+object, +other);
        case $65869f4a1ae7f1ad$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $65869f4a1ae7f1ad$var$regexpTag:
        case $65869f4a1ae7f1ad$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $65869f4a1ae7f1ad$var$mapTag:
            var convert = $b5427e536cab0671$exports;
        case $65869f4a1ae7f1ad$var$setTag:
            var isPartial = bitmask & $65869f4a1ae7f1ad$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $74670b58ce191e08$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $65869f4a1ae7f1ad$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $893babde388ca56a$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $65869f4a1ae7f1ad$var$symbolTag:
            if ($65869f4a1ae7f1ad$var$symbolValueOf) return $65869f4a1ae7f1ad$var$symbolValueOf.call(object) == $65869f4a1ae7f1ad$var$symbolValueOf.call(other);
    }
    return false;
}
$65869f4a1ae7f1ad$exports = $65869f4a1ae7f1ad$var$equalByTag;


var $0bf1af7acf94ca3a$exports = {};
var $d4f2240f262a0bb5$exports = {};
var $04d9bc25c024b8d0$exports = {};
var $ab8eff254b9814bf$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ab8eff254b9814bf$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ab8eff254b9814bf$exports = $ab8eff254b9814bf$var$arrayPush;


var $e5a6efdaaf0e5707$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e5a6efdaaf0e5707$var$isArray = Array.isArray;
$e5a6efdaaf0e5707$exports = $e5a6efdaaf0e5707$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04d9bc25c024b8d0$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $e5a6efdaaf0e5707$exports(object) ? result : $ab8eff254b9814bf$exports(result, symbolsFunc(object));
}
$04d9bc25c024b8d0$exports = $04d9bc25c024b8d0$var$baseGetAllKeys;


var $dc6372c7e3b3fa5f$exports = {};
var $a025e9cac0b18f1f$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a025e9cac0b18f1f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$a025e9cac0b18f1f$exports = $a025e9cac0b18f1f$var$arrayFilter;


var $898961e8a5475c9b$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $898961e8a5475c9b$var$stubArray() {
    return [];
}
$898961e8a5475c9b$exports = $898961e8a5475c9b$var$stubArray;


/** Used for built-in method references. */ var $dc6372c7e3b3fa5f$var$objectProto = Object.prototype;
/** Built-in value references. */ var $dc6372c7e3b3fa5f$var$propertyIsEnumerable = $dc6372c7e3b3fa5f$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc6372c7e3b3fa5f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $dc6372c7e3b3fa5f$var$getSymbols = !$dc6372c7e3b3fa5f$var$nativeGetSymbols ? $898961e8a5475c9b$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $a025e9cac0b18f1f$exports($dc6372c7e3b3fa5f$var$nativeGetSymbols(object), function(symbol) {
        return $dc6372c7e3b3fa5f$var$propertyIsEnumerable.call(object, symbol);
    });
};
$dc6372c7e3b3fa5f$exports = $dc6372c7e3b3fa5f$var$getSymbols;


var $09f6a70b406610c7$exports = {};
var $f1b36cf65a3b66d7$exports = {};
var $4c4ff588fbfe0fbb$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4c4ff588fbfe0fbb$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$4c4ff588fbfe0fbb$exports = $4c4ff588fbfe0fbb$var$baseTimes;


var $e5fbf615cd1dfca5$exports = {};
var $545339b3919b4eb8$exports = {};

var $e066a98c24dd369b$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e066a98c24dd369b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$e066a98c24dd369b$exports = $e066a98c24dd369b$var$isObjectLike;


/** `Object#toString` result references. */ var $545339b3919b4eb8$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $545339b3919b4eb8$var$baseIsArguments(value) {
    return $e066a98c24dd369b$exports(value) && $e95a344dcaa52f73$exports(value) == $545339b3919b4eb8$var$argsTag;
}
$545339b3919b4eb8$exports = $545339b3919b4eb8$var$baseIsArguments;



/** Used for built-in method references. */ var $e5fbf615cd1dfca5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e5fbf615cd1dfca5$var$hasOwnProperty = $e5fbf615cd1dfca5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e5fbf615cd1dfca5$var$propertyIsEnumerable = $e5fbf615cd1dfca5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e5fbf615cd1dfca5$var$isArguments = $545339b3919b4eb8$exports(function() {
    return arguments;
}()) ? $545339b3919b4eb8$exports : function(value) {
    return $e066a98c24dd369b$exports(value) && $e5fbf615cd1dfca5$var$hasOwnProperty.call(value, 'callee') && !$e5fbf615cd1dfca5$var$propertyIsEnumerable.call(value, 'callee');
};
$e5fbf615cd1dfca5$exports = $e5fbf615cd1dfca5$var$isArguments;




var $3oOYd = parcelRequire("3oOYd");
var $80885d4846778e3c$exports = {};
/** Used as references for various `Number` constants. */ var $80885d4846778e3c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $80885d4846778e3c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $80885d4846778e3c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $80885d4846778e3c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $80885d4846778e3c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$80885d4846778e3c$exports = $80885d4846778e3c$var$isIndex;


var $6451227988786993$exports = {};
var $88084ed14a9605f0$exports = {};

var $6591f2927c7926d5$exports = {};
/** Used as references for various `Number` constants. */ var $6591f2927c7926d5$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6591f2927c7926d5$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $6591f2927c7926d5$var$MAX_SAFE_INTEGER;
}
$6591f2927c7926d5$exports = $6591f2927c7926d5$var$isLength;



/** `Object#toString` result references. */ var $88084ed14a9605f0$var$argsTag = '[object Arguments]', $88084ed14a9605f0$var$arrayTag = '[object Array]', $88084ed14a9605f0$var$boolTag = '[object Boolean]', $88084ed14a9605f0$var$dateTag = '[object Date]', $88084ed14a9605f0$var$errorTag = '[object Error]', $88084ed14a9605f0$var$funcTag = '[object Function]', $88084ed14a9605f0$var$mapTag = '[object Map]', $88084ed14a9605f0$var$numberTag = '[object Number]', $88084ed14a9605f0$var$objectTag = '[object Object]', $88084ed14a9605f0$var$regexpTag = '[object RegExp]', $88084ed14a9605f0$var$setTag = '[object Set]', $88084ed14a9605f0$var$stringTag = '[object String]', $88084ed14a9605f0$var$weakMapTag = '[object WeakMap]';
var $88084ed14a9605f0$var$arrayBufferTag = '[object ArrayBuffer]', $88084ed14a9605f0$var$dataViewTag = '[object DataView]', $88084ed14a9605f0$var$float32Tag = '[object Float32Array]', $88084ed14a9605f0$var$float64Tag = '[object Float64Array]', $88084ed14a9605f0$var$int8Tag = '[object Int8Array]', $88084ed14a9605f0$var$int16Tag = '[object Int16Array]', $88084ed14a9605f0$var$int32Tag = '[object Int32Array]', $88084ed14a9605f0$var$uint8Tag = '[object Uint8Array]', $88084ed14a9605f0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $88084ed14a9605f0$var$uint16Tag = '[object Uint16Array]', $88084ed14a9605f0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $88084ed14a9605f0$var$typedArrayTags = {};
$88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$float32Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$float64Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$int8Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$int16Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$int32Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$uint8Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$uint8ClampedTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$uint16Tag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$uint32Tag] = true;
$88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$argsTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$arrayTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$arrayBufferTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$boolTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$dataViewTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$dateTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$errorTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$funcTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$mapTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$numberTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$objectTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$regexpTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$setTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$stringTag] = $88084ed14a9605f0$var$typedArrayTags[$88084ed14a9605f0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $88084ed14a9605f0$var$baseIsTypedArray(value) {
    return $e066a98c24dd369b$exports(value) && $6591f2927c7926d5$exports(value.length) && !!$88084ed14a9605f0$var$typedArrayTags[$e95a344dcaa52f73$exports(value)];
}
$88084ed14a9605f0$exports = $88084ed14a9605f0$var$baseIsTypedArray;


var $2d9178b4f43ebdfe$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $2d9178b4f43ebdfe$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$2d9178b4f43ebdfe$exports = $2d9178b4f43ebdfe$var$baseUnary;



var $lpZqS = parcelRequire("lpZqS");
/* Node.js helper references. */ var $6451227988786993$var$nodeIsTypedArray = $lpZqS && $lpZqS.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $6451227988786993$var$isTypedArray = $6451227988786993$var$nodeIsTypedArray ? $2d9178b4f43ebdfe$exports($6451227988786993$var$nodeIsTypedArray) : $88084ed14a9605f0$exports;
$6451227988786993$exports = $6451227988786993$var$isTypedArray;


/** Used for built-in method references. */ var $f1b36cf65a3b66d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f1b36cf65a3b66d7$var$hasOwnProperty = $f1b36cf65a3b66d7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $f1b36cf65a3b66d7$var$arrayLikeKeys(value, inherited) {
    var isArr = $e5a6efdaaf0e5707$exports(value), isArg = !isArr && $e5fbf615cd1dfca5$exports(value), isBuff = !isArr && !isArg && $3oOYd(value), isType = !isArr && !isArg && !isBuff && $6451227988786993$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $4c4ff588fbfe0fbb$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $f1b36cf65a3b66d7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $80885d4846778e3c$exports(key, length)))) result.push(key);
    return result;
}
$f1b36cf65a3b66d7$exports = $f1b36cf65a3b66d7$var$arrayLikeKeys;


var $cef55c89e8fc796b$exports = {};
var $6a3b477421d0a603$exports = {};
/** Used for built-in method references. */ var $6a3b477421d0a603$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $6a3b477421d0a603$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $6a3b477421d0a603$var$objectProto;
    return value === proto;
}
$6a3b477421d0a603$exports = $6a3b477421d0a603$var$isPrototype;


var $1e0134d52c63a10e$exports = {};
var $2071a43225f6eb14$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $2071a43225f6eb14$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$2071a43225f6eb14$exports = $2071a43225f6eb14$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e0134d52c63a10e$var$nativeKeys = $2071a43225f6eb14$exports(Object.keys, Object);
$1e0134d52c63a10e$exports = $1e0134d52c63a10e$var$nativeKeys;


/** Used for built-in method references. */ var $cef55c89e8fc796b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cef55c89e8fc796b$var$hasOwnProperty = $cef55c89e8fc796b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cef55c89e8fc796b$var$baseKeys(object) {
    if (!$6a3b477421d0a603$exports(object)) return $1e0134d52c63a10e$exports(object);
    var result = [];
    for(var key in Object(object))if ($cef55c89e8fc796b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$cef55c89e8fc796b$exports = $cef55c89e8fc796b$var$baseKeys;


var $45a6a99a8378a8ba$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $45a6a99a8378a8ba$var$isArrayLike(value) {
    return value != null && $6591f2927c7926d5$exports(value.length) && !$fcbbb7ef85cdd01b$exports(value);
}
$45a6a99a8378a8ba$exports = $45a6a99a8378a8ba$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $09f6a70b406610c7$var$keys(object) {
    return $45a6a99a8378a8ba$exports(object) ? $f1b36cf65a3b66d7$exports(object) : $cef55c89e8fc796b$exports(object);
}
$09f6a70b406610c7$exports = $09f6a70b406610c7$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d4f2240f262a0bb5$var$getAllKeys(object) {
    return $04d9bc25c024b8d0$exports(object, $09f6a70b406610c7$exports, $dc6372c7e3b3fa5f$exports);
}
$d4f2240f262a0bb5$exports = $d4f2240f262a0bb5$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $0bf1af7acf94ca3a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $0bf1af7acf94ca3a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0bf1af7acf94ca3a$var$hasOwnProperty = $0bf1af7acf94ca3a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $0bf1af7acf94ca3a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0bf1af7acf94ca3a$var$COMPARE_PARTIAL_FLAG, objProps = $d4f2240f262a0bb5$exports(object), objLength = objProps.length, othProps = $d4f2240f262a0bb5$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $0bf1af7acf94ca3a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$0bf1af7acf94ca3a$exports = $0bf1af7acf94ca3a$var$equalObjects;


var $21d0c09ec64ce7c3$exports = {};
var $0a922d66a9f3213b$exports = {};


var $2Znjj = parcelRequire("2Znjj");
/* Built-in method references that are verified to be native. */ var $0a922d66a9f3213b$var$DataView = $89b1ca2cc85531fb$exports($2Znjj, 'DataView');
$0a922d66a9f3213b$exports = $0a922d66a9f3213b$var$DataView;



var $f0d121ae7690599f$exports = {};


var $2Znjj = parcelRequire("2Znjj");
/* Built-in method references that are verified to be native. */ var $f0d121ae7690599f$var$Promise = $89b1ca2cc85531fb$exports($2Znjj, 'Promise');
$f0d121ae7690599f$exports = $f0d121ae7690599f$var$Promise;


var $605a62b994d93559$exports = {};


var $2Znjj = parcelRequire("2Znjj");
/* Built-in method references that are verified to be native. */ var $605a62b994d93559$var$Set = $89b1ca2cc85531fb$exports($2Znjj, 'Set');
$605a62b994d93559$exports = $605a62b994d93559$var$Set;


var $11be7db2b3df1c7c$exports = {};


var $2Znjj = parcelRequire("2Znjj");
/* Built-in method references that are verified to be native. */ var $11be7db2b3df1c7c$var$WeakMap = $89b1ca2cc85531fb$exports($2Znjj, 'WeakMap');
$11be7db2b3df1c7c$exports = $11be7db2b3df1c7c$var$WeakMap;




/** `Object#toString` result references. */ var $21d0c09ec64ce7c3$var$mapTag = '[object Map]', $21d0c09ec64ce7c3$var$objectTag = '[object Object]', $21d0c09ec64ce7c3$var$promiseTag = '[object Promise]', $21d0c09ec64ce7c3$var$setTag = '[object Set]', $21d0c09ec64ce7c3$var$weakMapTag = '[object WeakMap]';
var $21d0c09ec64ce7c3$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $21d0c09ec64ce7c3$var$dataViewCtorString = $3044b8f0dbd34e19$exports($0a922d66a9f3213b$exports), $21d0c09ec64ce7c3$var$mapCtorString = $3044b8f0dbd34e19$exports($3f400000bf5e8247$exports), $21d0c09ec64ce7c3$var$promiseCtorString = $3044b8f0dbd34e19$exports($f0d121ae7690599f$exports), $21d0c09ec64ce7c3$var$setCtorString = $3044b8f0dbd34e19$exports($605a62b994d93559$exports), $21d0c09ec64ce7c3$var$weakMapCtorString = $3044b8f0dbd34e19$exports($11be7db2b3df1c7c$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $21d0c09ec64ce7c3$var$getTag = $e95a344dcaa52f73$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($0a922d66a9f3213b$exports && $21d0c09ec64ce7c3$var$getTag(new $0a922d66a9f3213b$exports(new ArrayBuffer(1))) != $21d0c09ec64ce7c3$var$dataViewTag || $3f400000bf5e8247$exports && $21d0c09ec64ce7c3$var$getTag(new $3f400000bf5e8247$exports) != $21d0c09ec64ce7c3$var$mapTag || $f0d121ae7690599f$exports && $21d0c09ec64ce7c3$var$getTag($f0d121ae7690599f$exports.resolve()) != $21d0c09ec64ce7c3$var$promiseTag || $605a62b994d93559$exports && $21d0c09ec64ce7c3$var$getTag(new $605a62b994d93559$exports) != $21d0c09ec64ce7c3$var$setTag || $11be7db2b3df1c7c$exports && $21d0c09ec64ce7c3$var$getTag(new $11be7db2b3df1c7c$exports) != $21d0c09ec64ce7c3$var$weakMapTag) $21d0c09ec64ce7c3$var$getTag = function(value) {
    var result = $e95a344dcaa52f73$exports(value), Ctor = result == $21d0c09ec64ce7c3$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $3044b8f0dbd34e19$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $21d0c09ec64ce7c3$var$dataViewCtorString:
            return $21d0c09ec64ce7c3$var$dataViewTag;
        case $21d0c09ec64ce7c3$var$mapCtorString:
            return $21d0c09ec64ce7c3$var$mapTag;
        case $21d0c09ec64ce7c3$var$promiseCtorString:
            return $21d0c09ec64ce7c3$var$promiseTag;
        case $21d0c09ec64ce7c3$var$setCtorString:
            return $21d0c09ec64ce7c3$var$setTag;
        case $21d0c09ec64ce7c3$var$weakMapCtorString:
            return $21d0c09ec64ce7c3$var$weakMapTag;
    }
    return result;
};
$21d0c09ec64ce7c3$exports = $21d0c09ec64ce7c3$var$getTag;




var $3oOYd = parcelRequire("3oOYd");

/** Used to compose bitmasks for value comparisons. */ var $62565b4461be49e6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $62565b4461be49e6$var$argsTag = '[object Arguments]', $62565b4461be49e6$var$arrayTag = '[object Array]', $62565b4461be49e6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $62565b4461be49e6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62565b4461be49e6$var$hasOwnProperty = $62565b4461be49e6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $62565b4461be49e6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $e5a6efdaaf0e5707$exports(object), othIsArr = $e5a6efdaaf0e5707$exports(other), objTag = objIsArr ? $62565b4461be49e6$var$arrayTag : $21d0c09ec64ce7c3$exports(object), othTag = othIsArr ? $62565b4461be49e6$var$arrayTag : $21d0c09ec64ce7c3$exports(other);
    objTag = objTag == $62565b4461be49e6$var$argsTag ? $62565b4461be49e6$var$objectTag : objTag;
    othTag = othTag == $62565b4461be49e6$var$argsTag ? $62565b4461be49e6$var$objectTag : othTag;
    var objIsObj = objTag == $62565b4461be49e6$var$objectTag, othIsObj = othTag == $62565b4461be49e6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $3oOYd(object)) {
        if (!$3oOYd(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $2748937caa067712$exports);
        return objIsArr || $6451227988786993$exports(object) ? $893babde388ca56a$exports(object, other, bitmask, customizer, equalFunc, stack) : $65869f4a1ae7f1ad$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $62565b4461be49e6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $62565b4461be49e6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $62565b4461be49e6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $2748937caa067712$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $2748937caa067712$exports);
    return $0bf1af7acf94ca3a$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$62565b4461be49e6$exports = $62565b4461be49e6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $56884261d61a9b08$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$e066a98c24dd369b$exports(value) && !$e066a98c24dd369b$exports(other)) return value !== value && other !== other;
    return $62565b4461be49e6$exports(value, other, bitmask, customizer, $56884261d61a9b08$var$baseIsEqual, stack);
}
$56884261d61a9b08$exports = $56884261d61a9b08$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $b2b661eb4d0f23aa$var$isEqual(value, other) {
    return $56884261d61a9b08$exports(value, other);
}
$b2b661eb4d0f23aa$exports = $b2b661eb4d0f23aa$var$isEqual;


var $ba0da6b51bec2997$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $ba0da6b51bec2997$var$isNil(value) {
    return value == null;
}
$ba0da6b51bec2997$exports = $ba0da6b51bec2997$var$isNil;



var $7fPBF = parcelRequire("7fPBF");

var $7bd586c179037026$exports = {};
var $dad516edb5e02aa4$exports = {};
var $8c798992946736a0$exports = {};

var $cb70c096f393c08d$exports = {};

var $ff68483b1b673897$exports = {};


/** `Object#toString` result references. */ var $ff68483b1b673897$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ff68483b1b673897$var$isSymbol(value) {
    return typeof value == 'symbol' || $e066a98c24dd369b$exports(value) && $e95a344dcaa52f73$exports(value) == $ff68483b1b673897$var$symbolTag;
}
$ff68483b1b673897$exports = $ff68483b1b673897$var$isSymbol;


/** Used to match property names within property paths. */ var $cb70c096f393c08d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $cb70c096f393c08d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $cb70c096f393c08d$var$isKey(value, object) {
    if ($e5a6efdaaf0e5707$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $ff68483b1b673897$exports(value)) return true;
    return $cb70c096f393c08d$var$reIsPlainProp.test(value) || !$cb70c096f393c08d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$cb70c096f393c08d$exports = $cb70c096f393c08d$var$isKey;


var $e68f7a5edd4315ef$exports = {};
var $86aac1b4d16c6d03$exports = {};
var $f7c4824aff4f58af$exports = {};

/** Error message constants. */ var $f7c4824aff4f58af$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f7c4824aff4f58af$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($f7c4824aff4f58af$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f7c4824aff4f58af$var$memoize.Cache || $def09d7a5bbf6d67$exports);
    return memoized;
}
// Expose `MapCache`.
$f7c4824aff4f58af$var$memoize.Cache = $def09d7a5bbf6d67$exports;
$f7c4824aff4f58af$exports = $f7c4824aff4f58af$var$memoize;


/** Used as the maximum memoize cache size. */ var $86aac1b4d16c6d03$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $86aac1b4d16c6d03$var$memoizeCapped(func) {
    var result = $f7c4824aff4f58af$exports(func, function(key) {
        if (cache.size === $86aac1b4d16c6d03$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$86aac1b4d16c6d03$exports = $86aac1b4d16c6d03$var$memoizeCapped;


/** Used to match property names within property paths. */ var $e68f7a5edd4315ef$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e68f7a5edd4315ef$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e68f7a5edd4315ef$var$stringToPath = $86aac1b4d16c6d03$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($e68f7a5edd4315ef$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e68f7a5edd4315ef$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$e68f7a5edd4315ef$exports = $e68f7a5edd4315ef$var$stringToPath;


var $e2a64a60b09789b5$exports = {};
var $1b7fcfc38897f601$exports = {};

var $c47ae917987d873d$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c47ae917987d873d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$c47ae917987d873d$exports = $c47ae917987d873d$var$arrayMap;




/** Used as references for various `Number` constants. */ var $1b7fcfc38897f601$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $1b7fcfc38897f601$var$symbolProto = $0962998ca792683c$exports ? $0962998ca792683c$exports.prototype : undefined, $1b7fcfc38897f601$var$symbolToString = $1b7fcfc38897f601$var$symbolProto ? $1b7fcfc38897f601$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $1b7fcfc38897f601$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($e5a6efdaaf0e5707$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $c47ae917987d873d$exports(value, $1b7fcfc38897f601$var$baseToString) + '';
    if ($ff68483b1b673897$exports(value)) return $1b7fcfc38897f601$var$symbolToString ? $1b7fcfc38897f601$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$1b7fcfc38897f601$var$INFINITY ? '-0' : result;
}
$1b7fcfc38897f601$exports = $1b7fcfc38897f601$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e2a64a60b09789b5$var$toString(value) {
    return value == null ? '' : $1b7fcfc38897f601$exports(value);
}
$e2a64a60b09789b5$exports = $e2a64a60b09789b5$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $8c798992946736a0$var$castPath(value, object) {
    if ($e5a6efdaaf0e5707$exports(value)) return value;
    return $cb70c096f393c08d$exports(value, object) ? [
        value
    ] : $e68f7a5edd4315ef$exports($e2a64a60b09789b5$exports(value));
}
$8c798992946736a0$exports = $8c798992946736a0$var$castPath;


var $f891233344005efc$exports = {};

/** Used as references for various `Number` constants. */ var $f891233344005efc$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f891233344005efc$var$toKey(value) {
    if (typeof value == 'string' || $ff68483b1b673897$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$f891233344005efc$var$INFINITY ? '-0' : result;
}
$f891233344005efc$exports = $f891233344005efc$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $dad516edb5e02aa4$var$baseGet(object, path) {
    path = $8c798992946736a0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$f891233344005efc$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$dad516edb5e02aa4$exports = $dad516edb5e02aa4$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $7bd586c179037026$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $dad516edb5e02aa4$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$7bd586c179037026$exports = $7bd586c179037026$var$get;



var $1ca3e17f8f074468$exports = {};



/** `Object#toString` result references. */ var $1ca3e17f8f074468$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $1ca3e17f8f074468$var$isString(value) {
    return typeof value == 'string' || !$e5a6efdaaf0e5707$exports(value) && $e066a98c24dd369b$exports(value) && $e95a344dcaa52f73$exports(value) == $1ca3e17f8f074468$var$stringTag;
}
$1ca3e17f8f074468$exports = $1ca3e17f8f074468$var$isString;





var $7fPBF = parcelRequire("7fPBF");

var $j2VHG = parcelRequire("j2VHG");

var $8fd9681e324ea785$exports = {};
var $16d5099af764037a$exports = {};


/** `Object#toString` result references. */ var $16d5099af764037a$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $16d5099af764037a$var$isNumber(value) {
    return typeof value == 'number' || $e066a98c24dd369b$exports(value) && $e95a344dcaa52f73$exports(value) == $16d5099af764037a$var$numberTag;
}
$16d5099af764037a$exports = $16d5099af764037a$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $8fd9681e324ea785$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $16d5099af764037a$exports(value) && value != +value;
}
$8fd9681e324ea785$exports = $8fd9681e324ea785$var$isNaN;




var $ddf2636240ab70e2$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $ddf2636240ab70e2$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ca3e17f8f074468$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $ddf2636240ab70e2$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($16d5099af764037a$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($8fd9681e324ea785$exports)))(value);
};
var $ddf2636240ab70e2$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $ddf2636240ab70e2$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1ca3e17f8f074468$exports)))(value);
};
var $ddf2636240ab70e2$var$idCounter = 0;
var $ddf2636240ab70e2$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$ddf2636240ab70e2$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $ddf2636240ab70e2$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$ddf2636240ab70e2$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($1ca3e17f8f074468$exports)))(percent)) return defaultValue;
    var value;
    if ($ddf2636240ab70e2$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8fd9681e324ea785$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $ddf2636240ab70e2$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $ddf2636240ab70e2$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $ddf2636240ab70e2$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($ddf2636240ab70e2$export$7e4aa119212bc614(numberA) && $ddf2636240ab70e2$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $ddf2636240ab70e2$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $ddf2636240ab70e2$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $12af98dbc8c7996a$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $7fPBF = parcelRequire("7fPBF");

function $eb7294e7865e616e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb7294e7865e616e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb7294e7865e616e$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $eb7294e7865e616e$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $eb7294e7865e616e$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $eb7294e7865e616e$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $eb7294e7865e616e$export$2b22758266a6fa48 = {
    svg: $eb7294e7865e616e$var$SVGContainerPropKeys,
    polygon: $eb7294e7865e616e$var$PolyElementKeys,
    polyline: $eb7294e7865e616e$var$PolyElementKeys
};
var $eb7294e7865e616e$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $eb7294e7865e616e$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($eb7294e7865e616e$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $eb7294e7865e616e$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $eb7294e7865e616e$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(props) || $eb7294e7865e616e$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($eb7294e7865e616e$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $eb7294e7865e616e$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $86b14aaa4b2f228f$var$_excluded = [
    "children"
], $86b14aaa4b2f228f$var$_excluded2 = [
    "children"
];
function $86b14aaa4b2f228f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $86b14aaa4b2f228f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $86b14aaa4b2f228f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $86b14aaa4b2f228f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $86b14aaa4b2f228f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $86b14aaa4b2f228f$var$_typeof(o);
}
var $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var $86b14aaa4b2f228f$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $86b14aaa4b2f228f$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $86b14aaa4b2f228f$export$59a4d7d024cf1025 = [
    'none'
];
var $86b14aaa4b2f228f$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $86b14aaa4b2f228f$var$lastChildren = null;
var $86b14aaa4b2f228f$var$lastResult = null;
var $86b14aaa4b2f228f$export$45b10814cc054894 = function toArray(children) {
    if (children === $86b14aaa4b2f228f$var$lastChildren && Array.isArray($86b14aaa4b2f228f$var$lastResult)) return $86b14aaa4b2f228f$var$lastResult;
    var result = [];
    (0, $7fPBF.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(child)) return;
        if ((0, $j2VHG.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $86b14aaa4b2f228f$var$lastResult = result;
    $86b14aaa4b2f228f$var$lastChildren = children;
    return result;
};
function $86b14aaa4b2f228f$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $86b14aaa4b2f228f$export$be63e0664592e141(t);
    });
    else types = [
        $86b14aaa4b2f228f$export$be63e0664592e141(type)
    ];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $86b14aaa4b2f228f$export$64c61536a2b72e0f(children, type) {
    var result = $86b14aaa4b2f228f$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $86b14aaa4b2f228f$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $86b14aaa4b2f228f$export$be63e0664592e141(t);
    });
    else types = [
        $86b14aaa4b2f228f$export$be63e0664592e141(type)
    ];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $86b14aaa4b2f228f$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $86b14aaa4b2f228f$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $86b14aaa4b2f228f$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($1ca3e17f8f074468$exports)))(child.type) && $86b14aaa4b2f228f$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $86b14aaa4b2f228f$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $86b14aaa4b2f228f$var$_typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var $86b14aaa4b2f228f$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $eb7294e7865e616e$export$2b22758266a6fa48) === null || (0, $eb7294e7865e616e$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $eb7294e7865e616e$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $eb7294e7865e616e$export$190f430946f96110).includes(key)) || includeEvents && (0, $eb7294e7865e616e$export$f30789245f2c4d11).includes(key);
};
var $86b14aaa4b2f228f$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(entry) {
        if ($86b14aaa4b2f228f$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $86b14aaa4b2f228f$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($86b14aaa4b2f228f$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $86b14aaa4b2f228f$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $7fPBF.Children).count(nextChildren);
    if (count !== (0, $7fPBF.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $86b14aaa4b2f228f$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$86b14aaa4b2f228f$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $86b14aaa4b2f228f$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $86b14aaa4b2f228f$var$_objectWithoutProperties(_ref, $86b14aaa4b2f228f$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $86b14aaa4b2f228f$var$_objectWithoutProperties(_ref2, $86b14aaa4b2f228f$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextProps, prevProps) && $86b14aaa4b2f228f$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $86b14aaa4b2f228f$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($86b14aaa4b2f228f$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $86b14aaa4b2f228f$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $86b14aaa4b2f228f$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP[type]) return $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $86b14aaa4b2f228f$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $86b14aaa4b2f228f$export$45b10814cc054894(children).indexOf(child);
};


var $96829a30e4c93428$var$_excluded = [
    "children",
    "className"
];
function $96829a30e4c93428$var$_extends() {
    $96829a30e4c93428$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96829a30e4c93428$var$_extends.apply(this, arguments);
}
function $96829a30e4c93428$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $96829a30e4c93428$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $96829a30e4c93428$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $96829a30e4c93428$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $96829a30e4c93428$var$_objectWithoutProperties(props, $96829a30e4c93428$var$_excluded);
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", $96829a30e4c93428$var$_extends({
        className: layerClass
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $7fPBF = parcelRequire("7fPBF");
var $8dc350a4186296d3$var$isProduction = true;
var $8dc350a4186296d3$var$prefix = 'Invariant failed';
function $8dc350a4186296d3$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($8dc350a4186296d3$var$isProduction) throw new Error($8dc350a4186296d3$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($8dc350a4186296d3$var$prefix, ": ").concat(provided) : $8dc350a4186296d3$var$prefix;
    throw new Error(value);
}




var $d05ab0383decc723$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $d05ab0383decc723$var$_extends() {
    $d05ab0383decc723$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d05ab0383decc723$var$_extends.apply(this, arguments);
}
function $d05ab0383decc723$var$_slicedToArray(arr, i) {
    return $d05ab0383decc723$var$_arrayWithHoles(arr) || $d05ab0383decc723$var$_iterableToArrayLimit(arr, i) || $d05ab0383decc723$var$_unsupportedIterableToArray(arr, i) || $d05ab0383decc723$var$_nonIterableRest();
}
function $d05ab0383decc723$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d05ab0383decc723$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d05ab0383decc723$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d05ab0383decc723$var$_arrayLikeToArray(o, minLen);
}
function $d05ab0383decc723$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d05ab0383decc723$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d05ab0383decc723$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d05ab0383decc723$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d05ab0383decc723$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d05ab0383decc723$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d05ab0383decc723$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $d05ab0383decc723$var$_objectWithoutProperties(props, $d05ab0383decc723$var$_excluded);
    var svgProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
    !!(props.direction === 'x' && xAxis.type !== 'number') && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $d05ab0383decc723$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $d05ab0383decc723$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $d05ab0383decc723$var$_extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$d05ab0383decc723$export$4f4d7676bdf949e5.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
$d05ab0383decc723$export$4f4d7676bdf949e5.displayName = 'ErrorBar';


/**
 * @fileOverview Cross
 */ var $979e4bae4ee44f07$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$979e4bae4ee44f07$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $7fPBF = parcelRequire("7fPBF");



var $327b0cfc03620646$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $327b0cfc03620646$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$327b0cfc03620646$exports = $327b0cfc03620646$var$last;



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");



var $bdfd77d06577c8ff$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $bdfd77d06577c8ff$export$98f03c5d19621d70 = {
    isSsr: $bdfd77d06577c8ff$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $bdfd77d06577c8ff$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $bdfd77d06577c8ff$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $bdfd77d06577c8ff$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $5da910530c0379f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5da910530c0379f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5da910530c0379f8$var$_typeof(o);
}
function $5da910530c0379f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5da910530c0379f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5da910530c0379f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5da910530c0379f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5da910530c0379f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5da910530c0379f8$var$_defineProperty(obj, key, value) {
    key = $5da910530c0379f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5da910530c0379f8$var$_toPropertyKey(arg) {
    var key = $5da910530c0379f8$var$_toPrimitive(arg, "string");
    return $5da910530c0379f8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5da910530c0379f8$var$_toPrimitive(input, hint) {
    if ($5da910530c0379f8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5da910530c0379f8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5da910530c0379f8$var$_toConsumableArray(arr) {
    return $5da910530c0379f8$var$_arrayWithoutHoles(arr) || $5da910530c0379f8$var$_iterableToArray(arr) || $5da910530c0379f8$var$_unsupportedIterableToArray(arr) || $5da910530c0379f8$var$_nonIterableSpread();
}
function $5da910530c0379f8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5da910530c0379f8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5da910530c0379f8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5da910530c0379f8$var$_arrayLikeToArray(o, minLen);
}
function $5da910530c0379f8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5da910530c0379f8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5da910530c0379f8$var$_arrayLikeToArray(arr);
}
function $5da910530c0379f8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5da910530c0379f8$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $5da910530c0379f8$var$MAX_CACHE_NUM = 2000;
var $5da910530c0379f8$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $5da910530c0379f8$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $5da910530c0379f8$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $5da910530c0379f8$var$autoCompleteStyle(name, value) {
    if ($5da910530c0379f8$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $5da910530c0379f8$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($5da910530c0379f8$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($5da910530c0379f8$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $5da910530c0379f8$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($5da910530c0379f8$var$camelToMiddleLine(s), ":").concat($5da910530c0379f8$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $5da910530c0379f8$var$removeInvalidKeys(obj) {
    var copyObj = $5da910530c0379f8$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $5da910530c0379f8$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $5da910530c0379f8$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($5da910530c0379f8$var$stringCache.widthCache[cacheKey]) return $5da910530c0379f8$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($5da910530c0379f8$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $5da910530c0379f8$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $5da910530c0379f8$var$_objectSpread($5da910530c0379f8$var$_objectSpread({}, $5da910530c0379f8$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $5da910530c0379f8$var$stringCache.widthCache[cacheKey] = result;
        if (++$5da910530c0379f8$var$stringCache.cacheCount > $5da910530c0379f8$var$MAX_CACHE_NUM) {
            $5da910530c0379f8$var$stringCache.cacheCount = 0;
            $5da910530c0379f8$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $5da910530c0379f8$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $049c28fee99b53fe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $049c28fee99b53fe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $049c28fee99b53fe$var$_typeof(o);
}
function $049c28fee99b53fe$var$_slicedToArray(arr, i) {
    return $049c28fee99b53fe$var$_arrayWithHoles(arr) || $049c28fee99b53fe$var$_iterableToArrayLimit(arr, i) || $049c28fee99b53fe$var$_unsupportedIterableToArray(arr, i) || $049c28fee99b53fe$var$_nonIterableRest();
}
function $049c28fee99b53fe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $049c28fee99b53fe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $049c28fee99b53fe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $049c28fee99b53fe$var$_arrayLikeToArray(o, minLen);
}
function $049c28fee99b53fe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $049c28fee99b53fe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $049c28fee99b53fe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $049c28fee99b53fe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $049c28fee99b53fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $049c28fee99b53fe$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $049c28fee99b53fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $049c28fee99b53fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $049c28fee99b53fe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $049c28fee99b53fe$var$_toPropertyKey(arg) {
    var key = $049c28fee99b53fe$var$_toPrimitive(arg, "string");
    return $049c28fee99b53fe$var$_typeof(key) === "symbol" ? key : String(key);
}
function $049c28fee99b53fe$var$_toPrimitive(input, hint) {
    if ($049c28fee99b53fe$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($049c28fee99b53fe$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $049c28fee99b53fe$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $049c28fee99b53fe$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $049c28fee99b53fe$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $049c28fee99b53fe$var$FIXED_CSS_LENGTH_UNITS = Object.keys($049c28fee99b53fe$var$CONVERSION_RATES);
var $049c28fee99b53fe$var$STR_NAN = 'NaN';
function $049c28fee99b53fe$var$convertToPx(value, unit) {
    return value * $049c28fee99b53fe$var$CONVERSION_RATES[unit];
}
var $049c28fee99b53fe$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $049c28fee99b53fe$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$049c28fee99b53fe$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($049c28fee99b53fe$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $049c28fee99b53fe$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    $049c28fee99b53fe$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $049c28fee99b53fe$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $049c28fee99b53fe$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
    return DecimalCSS;
}();
function $049c28fee99b53fe$var$calculateArithmetic(expr) {
    if (expr.includes($049c28fee99b53fe$var$STR_NAN)) return $049c28fee99b53fe$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $049c28fee99b53fe$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $049c28fee99b53fe$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $049c28fee99b53fe$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $049c28fee99b53fe$var$STR_NAN;
        newExpr = newExpr.replace($049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $049c28fee99b53fe$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $049c28fee99b53fe$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $049c28fee99b53fe$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $049c28fee99b53fe$var$STR_NAN;
        newExpr = newExpr.replace($049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $049c28fee99b53fe$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $049c28fee99b53fe$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $049c28fee99b53fe$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $049c28fee99b53fe$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($049c28fee99b53fe$var$PARENTHESES_REGEX, $049c28fee99b53fe$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $049c28fee99b53fe$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $049c28fee99b53fe$var$calculateParentheses(newExpr);
    newExpr = $049c28fee99b53fe$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $049c28fee99b53fe$export$c891f73c9c6d00c9(expression) {
    try {
        return $049c28fee99b53fe$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $049c28fee99b53fe$var$STR_NAN;
    }
}
function $049c28fee99b53fe$export$254eac204f89fd7d(expression) {
    var result = $049c28fee99b53fe$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $049c28fee99b53fe$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $94f8473029f59671$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $94f8473029f59671$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $94f8473029f59671$var$_extends() {
    $94f8473029f59671$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $94f8473029f59671$var$_extends.apply(this, arguments);
}
function $94f8473029f59671$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $94f8473029f59671$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $94f8473029f59671$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $94f8473029f59671$var$_slicedToArray(arr, i) {
    return $94f8473029f59671$var$_arrayWithHoles(arr) || $94f8473029f59671$var$_iterableToArrayLimit(arr, i) || $94f8473029f59671$var$_unsupportedIterableToArray(arr, i) || $94f8473029f59671$var$_nonIterableRest();
}
function $94f8473029f59671$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94f8473029f59671$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94f8473029f59671$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94f8473029f59671$var$_arrayLikeToArray(o, minLen);
}
function $94f8473029f59671$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $94f8473029f59671$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $94f8473029f59671$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $94f8473029f59671$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $94f8473029f59671$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($94f8473029f59671$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $5da910530c0379f8$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $5da910530c0379f8$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $94f8473029f59671$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $94f8473029f59671$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $94f8473029f59671$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $94f8473029f59671$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $94f8473029f59671$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(children) ? children.toString().split($94f8473029f59671$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $94f8473029f59671$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $94f8473029f59671$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $94f8473029f59671$var$getWordsWithoutCalculate(children);
        return $94f8473029f59671$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $94f8473029f59671$var$getWordsWithoutCalculate(children);
};
var $94f8473029f59671$var$DEFAULT_FILL = '#808080';
var $94f8473029f59671$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $94f8473029f59671$var$DEFAULT_FILL : _ref5$fill, props = $94f8473029f59671$var$_objectWithoutProperties(_ref5, $94f8473029f59671$var$_excluded);
    var wordsByLines = (0, $7fPBF.useMemo)(function() {
        return $94f8473029f59671$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $94f8473029f59671$var$_objectWithoutProperties(props, $94f8473029f59671$var$_excluded2);
    if (!(0, $ddf2636240ab70e2$export$402a499e1ea44294)(propsX) || !(0, $ddf2636240ab70e2$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("text", $94f8473029f59671$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $94f8473029f59671$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};






var $88853d08cf75746a$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$88853d08cf75746a$exports = (parcelRequire("3kQXm"));


var $922af94be54ea802$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$922af94be54ea802$exports = (parcelRequire("7L7R7"));


var $103d2fad6c8f6f2b$exports = {};
var $dd255202df26081b$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $dd255202df26081b$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$ff68483b1b673897$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$dd255202df26081b$exports = $dd255202df26081b$var$baseExtremum;


var $1760e1589d594403$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $1760e1589d594403$var$baseGt(value, other) {
    return value > other;
}
$1760e1589d594403$exports = $1760e1589d594403$var$baseGt;


var $c1a87310b380933c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $c1a87310b380933c$var$identity(value) {
    return value;
}
$c1a87310b380933c$exports = $c1a87310b380933c$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $103d2fad6c8f6f2b$var$max(array) {
    return array && array.length ? $dd255202df26081b$exports(array, $c1a87310b380933c$exports, $1760e1589d594403$exports) : undefined;
}
$103d2fad6c8f6f2b$exports = $103d2fad6c8f6f2b$var$max;


var $f21d533eecb55ca3$exports = {};

var $4964f5a300cf055d$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $4964f5a300cf055d$var$baseLt(value, other) {
    return value < other;
}
$4964f5a300cf055d$exports = $4964f5a300cf055d$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $f21d533eecb55ca3$var$min(array) {
    return array && array.length ? $dd255202df26081b$exports(array, $c1a87310b380933c$exports, $4964f5a300cf055d$exports) : undefined;
}
$f21d533eecb55ca3$exports = $f21d533eecb55ca3$var$min;






var $70171a2be606096a$exports = {};
var $1a3e4a3527823623$exports = {};

var $14d9c3f018a90686$exports = {};



/** Built-in value references. */ var $14d9c3f018a90686$var$spreadableSymbol = $0962998ca792683c$exports ? $0962998ca792683c$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $14d9c3f018a90686$var$isFlattenable(value) {
    return $e5a6efdaaf0e5707$exports(value) || $e5fbf615cd1dfca5$exports(value) || !!($14d9c3f018a90686$var$spreadableSymbol && value && value[$14d9c3f018a90686$var$spreadableSymbol]);
}
$14d9c3f018a90686$exports = $14d9c3f018a90686$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $1a3e4a3527823623$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $14d9c3f018a90686$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $1a3e4a3527823623$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $ab8eff254b9814bf$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$1a3e4a3527823623$exports = $1a3e4a3527823623$var$baseFlatten;


var $40e33e1c844ff33c$exports = {};

var $6981623866a9ed6c$exports = {};
var $5a11780380fcd20f$exports = {};
var $36b3df2b7dfd4916$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $36b3df2b7dfd4916$var$COMPARE_PARTIAL_FLAG = 1, $36b3df2b7dfd4916$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $36b3df2b7dfd4916$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $2748937caa067712$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $56884261d61a9b08$exports(srcValue, objValue, $36b3df2b7dfd4916$var$COMPARE_PARTIAL_FLAG | $36b3df2b7dfd4916$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$36b3df2b7dfd4916$exports = $36b3df2b7dfd4916$var$baseIsMatch;


var $0e0f50914a0be9aa$exports = {};
var $1c294f4ea88ef7a1$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1c294f4ea88ef7a1$var$isStrictComparable(value) {
    return value === value && !$7aa8549693d433a8$exports(value);
}
$1c294f4ea88ef7a1$exports = $1c294f4ea88ef7a1$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $0e0f50914a0be9aa$var$getMatchData(object) {
    var result = $09f6a70b406610c7$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1c294f4ea88ef7a1$exports(value)
        ];
    }
    return result;
}
$0e0f50914a0be9aa$exports = $0e0f50914a0be9aa$var$getMatchData;


var $5fbd72a0258c4d42$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5fbd72a0258c4d42$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$5fbd72a0258c4d42$exports = $5fbd72a0258c4d42$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $5a11780380fcd20f$var$baseMatches(source) {
    var matchData = $0e0f50914a0be9aa$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $5fbd72a0258c4d42$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $36b3df2b7dfd4916$exports(object, source, matchData);
    };
}
$5a11780380fcd20f$exports = $5a11780380fcd20f$var$baseMatches;


var $a153f855f6732f0a$exports = {};


var $000e59afbb02734a$exports = {};
var $4c9aaab9e42c6f05$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $4c9aaab9e42c6f05$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$4c9aaab9e42c6f05$exports = $4c9aaab9e42c6f05$var$baseHasIn;


var $2618ab04e9319e45$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $2618ab04e9319e45$var$hasPath(object, path, hasFunc) {
    path = $8c798992946736a0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $f891233344005efc$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $6591f2927c7926d5$exports(length) && $80885d4846778e3c$exports(key, length) && ($e5a6efdaaf0e5707$exports(object) || $e5fbf615cd1dfca5$exports(object));
}
$2618ab04e9319e45$exports = $2618ab04e9319e45$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $000e59afbb02734a$var$hasIn(object, path) {
    return object != null && $2618ab04e9319e45$exports(object, path, $4c9aaab9e42c6f05$exports);
}
$000e59afbb02734a$exports = $000e59afbb02734a$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $a153f855f6732f0a$var$COMPARE_PARTIAL_FLAG = 1, $a153f855f6732f0a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a153f855f6732f0a$var$baseMatchesProperty(path, srcValue) {
    if ($cb70c096f393c08d$exports(path) && $1c294f4ea88ef7a1$exports(srcValue)) return $5fbd72a0258c4d42$exports($f891233344005efc$exports(path), srcValue);
    return function(object) {
        var objValue = $7bd586c179037026$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $000e59afbb02734a$exports(object, path) : $56884261d61a9b08$exports(srcValue, objValue, $a153f855f6732f0a$var$COMPARE_PARTIAL_FLAG | $a153f855f6732f0a$var$COMPARE_UNORDERED_FLAG);
    };
}
$a153f855f6732f0a$exports = $a153f855f6732f0a$var$baseMatchesProperty;




var $f2280b472620f2a3$exports = {};
var $e7023a1ccdc8c80a$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e7023a1ccdc8c80a$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$e7023a1ccdc8c80a$exports = $e7023a1ccdc8c80a$var$baseProperty;


var $23547e8efd7ce970$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $23547e8efd7ce970$var$basePropertyDeep(path) {
    return function(object) {
        return $dad516edb5e02aa4$exports(object, path);
    };
}
$23547e8efd7ce970$exports = $23547e8efd7ce970$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $f2280b472620f2a3$var$property(path) {
    return $cb70c096f393c08d$exports(path) ? $e7023a1ccdc8c80a$exports($f891233344005efc$exports(path)) : $23547e8efd7ce970$exports(path);
}
$f2280b472620f2a3$exports = $f2280b472620f2a3$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $6981623866a9ed6c$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $c1a87310b380933c$exports;
    if (typeof value == 'object') return $e5a6efdaaf0e5707$exports(value) ? $a153f855f6732f0a$exports(value[0], value[1]) : $5a11780380fcd20f$exports(value);
    return $f2280b472620f2a3$exports(value);
}
$6981623866a9ed6c$exports = $6981623866a9ed6c$var$baseIteratee;


var $00340b945ff5b3ac$exports = {};
var $1d1f09e624f3f9a8$exports = {};
var $1bc609cd7a6fa424$exports = {};
var $a6819c54dc0040db$exports = {};
var $ae951372b69dde5e$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ae951372b69dde5e$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$ae951372b69dde5e$exports = $ae951372b69dde5e$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a6819c54dc0040db$var$baseFor = $ae951372b69dde5e$exports();
$a6819c54dc0040db$exports = $a6819c54dc0040db$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $1bc609cd7a6fa424$var$baseForOwn(object, iteratee) {
    return object && $a6819c54dc0040db$exports(object, iteratee, $09f6a70b406610c7$exports);
}
$1bc609cd7a6fa424$exports = $1bc609cd7a6fa424$var$baseForOwn;


var $afaf90b1d4e62b8a$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $afaf90b1d4e62b8a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$45a6a99a8378a8ba$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$afaf90b1d4e62b8a$exports = $afaf90b1d4e62b8a$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $1d1f09e624f3f9a8$var$baseEach = $afaf90b1d4e62b8a$exports($1bc609cd7a6fa424$exports);
$1d1f09e624f3f9a8$exports = $1d1f09e624f3f9a8$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $00340b945ff5b3ac$var$baseMap(collection, iteratee) {
    var index = -1, result = $45a6a99a8378a8ba$exports(collection) ? Array(collection.length) : [];
    $1d1f09e624f3f9a8$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$00340b945ff5b3ac$exports = $00340b945ff5b3ac$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $40e33e1c844ff33c$var$map(collection, iteratee) {
    var func = $e5a6efdaaf0e5707$exports(collection) ? $c47ae917987d873d$exports : $00340b945ff5b3ac$exports;
    return func(collection, $6981623866a9ed6c$exports(iteratee, 3));
}
$40e33e1c844ff33c$exports = $40e33e1c844ff33c$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $70171a2be606096a$var$flatMap(collection, iteratee) {
    return $1a3e4a3527823623$exports($40e33e1c844ff33c$exports(collection, iteratee), 1);
}
$70171a2be606096a$exports = $70171a2be606096a$var$flatMap;



var $cb4a4ca6f49cb945$exports = {};
var $4c3f917f97b0c50d$exports = {};
var $1eb58da9f4cdbd48$exports = {};
var $21d5c0ef8404531d$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $21d5c0ef8404531d$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$21d5c0ef8404531d$exports = $21d5c0ef8404531d$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $1eb58da9f4cdbd48$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $21d5c0ef8404531d$exports(array, start, end);
}
$1eb58da9f4cdbd48$exports = $1eb58da9f4cdbd48$var$castSlice;


var $c87445f228c94b5b$exports = {};
/** Used to compose unicode character classes. */ var $c87445f228c94b5b$var$rsAstralRange = '\\ud800-\\udfff', $c87445f228c94b5b$var$rsComboMarksRange = '\\u0300-\\u036f', $c87445f228c94b5b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c87445f228c94b5b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c87445f228c94b5b$var$rsComboRange = $c87445f228c94b5b$var$rsComboMarksRange + $c87445f228c94b5b$var$reComboHalfMarksRange + $c87445f228c94b5b$var$rsComboSymbolsRange, $c87445f228c94b5b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c87445f228c94b5b$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $c87445f228c94b5b$var$reHasUnicode = RegExp('[' + $c87445f228c94b5b$var$rsZWJ + $c87445f228c94b5b$var$rsAstralRange + $c87445f228c94b5b$var$rsComboRange + $c87445f228c94b5b$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $c87445f228c94b5b$var$hasUnicode(string) {
    return $c87445f228c94b5b$var$reHasUnicode.test(string);
}
$c87445f228c94b5b$exports = $c87445f228c94b5b$var$hasUnicode;


var $00193df6d8f2023e$exports = {};
var $f293cf43acf0e61b$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f293cf43acf0e61b$var$asciiToArray(string) {
    return string.split('');
}
$f293cf43acf0e61b$exports = $f293cf43acf0e61b$var$asciiToArray;



var $cb30f7065da69f28$exports = {};
/** Used to compose unicode character classes. */ var $cb30f7065da69f28$var$rsAstralRange = '\\ud800-\\udfff', $cb30f7065da69f28$var$rsComboMarksRange = '\\u0300-\\u036f', $cb30f7065da69f28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $cb30f7065da69f28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $cb30f7065da69f28$var$rsComboRange = $cb30f7065da69f28$var$rsComboMarksRange + $cb30f7065da69f28$var$reComboHalfMarksRange + $cb30f7065da69f28$var$rsComboSymbolsRange, $cb30f7065da69f28$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $cb30f7065da69f28$var$rsAstral = '[' + $cb30f7065da69f28$var$rsAstralRange + ']', $cb30f7065da69f28$var$rsCombo = '[' + $cb30f7065da69f28$var$rsComboRange + ']', $cb30f7065da69f28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $cb30f7065da69f28$var$rsModifier = '(?:' + $cb30f7065da69f28$var$rsCombo + '|' + $cb30f7065da69f28$var$rsFitz + ')', $cb30f7065da69f28$var$rsNonAstral = '[^' + $cb30f7065da69f28$var$rsAstralRange + ']', $cb30f7065da69f28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $cb30f7065da69f28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $cb30f7065da69f28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $cb30f7065da69f28$var$reOptMod = $cb30f7065da69f28$var$rsModifier + '?', $cb30f7065da69f28$var$rsOptVar = '[' + $cb30f7065da69f28$var$rsVarRange + ']?', $cb30f7065da69f28$var$rsOptJoin = '(?:' + $cb30f7065da69f28$var$rsZWJ + '(?:' + [
    $cb30f7065da69f28$var$rsNonAstral,
    $cb30f7065da69f28$var$rsRegional,
    $cb30f7065da69f28$var$rsSurrPair
].join('|') + ')' + $cb30f7065da69f28$var$rsOptVar + $cb30f7065da69f28$var$reOptMod + ')*', $cb30f7065da69f28$var$rsSeq = $cb30f7065da69f28$var$rsOptVar + $cb30f7065da69f28$var$reOptMod + $cb30f7065da69f28$var$rsOptJoin, $cb30f7065da69f28$var$rsSymbol = '(?:' + [
    $cb30f7065da69f28$var$rsNonAstral + $cb30f7065da69f28$var$rsCombo + '?',
    $cb30f7065da69f28$var$rsCombo,
    $cb30f7065da69f28$var$rsRegional,
    $cb30f7065da69f28$var$rsSurrPair,
    $cb30f7065da69f28$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $cb30f7065da69f28$var$reUnicode = RegExp($cb30f7065da69f28$var$rsFitz + '(?=' + $cb30f7065da69f28$var$rsFitz + ')|' + $cb30f7065da69f28$var$rsSymbol + $cb30f7065da69f28$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cb30f7065da69f28$var$unicodeToArray(string) {
    return string.match($cb30f7065da69f28$var$reUnicode) || [];
}
$cb30f7065da69f28$exports = $cb30f7065da69f28$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $00193df6d8f2023e$var$stringToArray(string) {
    return $c87445f228c94b5b$exports(string) ? $cb30f7065da69f28$exports(string) : $f293cf43acf0e61b$exports(string);
}
$00193df6d8f2023e$exports = $00193df6d8f2023e$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $4c3f917f97b0c50d$var$createCaseFirst(methodName) {
    return function(string) {
        string = $e2a64a60b09789b5$exports(string);
        var strSymbols = $c87445f228c94b5b$exports(string) ? $00193df6d8f2023e$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $1eb58da9f4cdbd48$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$4c3f917f97b0c50d$exports = $4c3f917f97b0c50d$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cb4a4ca6f49cb945$var$upperFirst = $4c3f917f97b0c50d$exports('toUpperCase');
$cb4a4ca6f49cb945$exports = $cb4a4ca6f49cb945$var$upperFirst;



var $08c68625964a32b5$exports = {};

var $5772d2ba9c6b8f33$exports = {};




var $9e755479137d2bf8$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9e755479137d2bf8$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9e755479137d2bf8$exports = $9e755479137d2bf8$var$baseSortBy;



var $4ae299a6e1a0eadd$exports = {};
var $278816251302e9b6$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $278816251302e9b6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $ff68483b1b673897$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $ff68483b1b673897$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$278816251302e9b6$exports = $278816251302e9b6$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4ae299a6e1a0eadd$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $278816251302e9b6$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$4ae299a6e1a0eadd$exports = $4ae299a6e1a0eadd$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $5772d2ba9c6b8f33$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $c47ae917987d873d$exports(iteratees, function(iteratee) {
        if ($e5a6efdaaf0e5707$exports(iteratee)) return function(value) {
            return $dad516edb5e02aa4$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $c1a87310b380933c$exports
    ];
    var index = -1;
    iteratees = $c47ae917987d873d$exports(iteratees, $2d9178b4f43ebdfe$exports($6981623866a9ed6c$exports));
    var result = $00340b945ff5b3ac$exports(collection, function(value, key, collection) {
        var criteria = $c47ae917987d873d$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9e755479137d2bf8$exports(result, function(object, other) {
        return $4ae299a6e1a0eadd$exports(object, other, orders);
    });
}
$5772d2ba9c6b8f33$exports = $5772d2ba9c6b8f33$var$baseOrderBy;


var $e47078494566a1f4$exports = {};

var $ef05a83c3020c83c$exports = {};
var $575fd638de5494c5$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $575fd638de5494c5$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$575fd638de5494c5$exports = $575fd638de5494c5$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $ef05a83c3020c83c$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $ef05a83c3020c83c$var$overRest(func, start, transform) {
    start = $ef05a83c3020c83c$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $ef05a83c3020c83c$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $575fd638de5494c5$exports(func, this, otherArgs);
    };
}
$ef05a83c3020c83c$exports = $ef05a83c3020c83c$var$overRest;


var $4e69fa760b69dd73$exports = {};
var $edf9cdff0796c681$exports = {};
var $98c45e39b3871d83$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $98c45e39b3871d83$var$constant(value) {
    return function() {
        return value;
    };
}
$98c45e39b3871d83$exports = $98c45e39b3871d83$var$constant;


var $2ce2ab6b1fb782e5$exports = {};

var $2ce2ab6b1fb782e5$var$defineProperty = function() {
    try {
        var func = $89b1ca2cc85531fb$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$2ce2ab6b1fb782e5$exports = $2ce2ab6b1fb782e5$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $edf9cdff0796c681$var$baseSetToString = !$2ce2ab6b1fb782e5$exports ? $c1a87310b380933c$exports : function(func, string) {
    return $2ce2ab6b1fb782e5$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $98c45e39b3871d83$exports(string),
        'writable': true
    });
};
$edf9cdff0796c681$exports = $edf9cdff0796c681$var$baseSetToString;


var $75cec057466067ec$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $75cec057466067ec$var$HOT_COUNT = 800, $75cec057466067ec$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $75cec057466067ec$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $75cec057466067ec$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $75cec057466067ec$var$nativeNow(), remaining = $75cec057466067ec$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $75cec057466067ec$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$75cec057466067ec$exports = $75cec057466067ec$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4e69fa760b69dd73$var$setToString = $75cec057466067ec$exports($edf9cdff0796c681$exports);
$4e69fa760b69dd73$exports = $4e69fa760b69dd73$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $e47078494566a1f4$var$baseRest(func, start) {
    return $4e69fa760b69dd73$exports($ef05a83c3020c83c$exports(func, start, $c1a87310b380933c$exports), func + '');
}
$e47078494566a1f4$exports = $e47078494566a1f4$var$baseRest;


var $88c9cc1e8f9f4fbf$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $88c9cc1e8f9f4fbf$var$isIterateeCall(value, index, object) {
    if (!$7aa8549693d433a8$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $45a6a99a8378a8ba$exports(object) && $80885d4846778e3c$exports(index, object.length) : type == 'string' && index in object) return $5a333cb39ab72c13$exports(object[index], value);
    return false;
}
$88c9cc1e8f9f4fbf$exports = $88c9cc1e8f9f4fbf$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $08c68625964a32b5$var$sortBy = $e47078494566a1f4$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $88c9cc1e8f9f4fbf$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $88c9cc1e8f9f4fbf$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $5772d2ba9c6b8f33$exports(collection, $1a3e4a3527823623$exports(iteratees, 1), []);
});
$08c68625964a32b5$exports = $08c68625964a32b5$var$sortBy;


var $57e46f3c4239bc7f$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($57e46f3c4239bc7f$exports) $57e46f3c4239bc7f$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($57e46f3c4239bc7f$exports);


function $45a183d0c6718727$var$_toConsumableArray(arr) {
    return $45a183d0c6718727$var$_arrayWithoutHoles(arr) || $45a183d0c6718727$var$_iterableToArray(arr) || $45a183d0c6718727$var$_unsupportedIterableToArray(arr) || $45a183d0c6718727$var$_nonIterableSpread();
}
function $45a183d0c6718727$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $45a183d0c6718727$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $45a183d0c6718727$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $45a183d0c6718727$var$_arrayLikeToArray(o, minLen);
}
function $45a183d0c6718727$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $45a183d0c6718727$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $45a183d0c6718727$var$_arrayLikeToArray(arr);
}
function $45a183d0c6718727$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $45a183d0c6718727$var$identity = function identity(i) {
    return i;
};
var $45a183d0c6718727$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $45a183d0c6718727$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $45a183d0c6718727$export$ca73b6d700d0505;
};
var $45a183d0c6718727$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $45a183d0c6718727$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $45a183d0c6718727$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $45a183d0c6718727$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $45a183d0c6718727$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $45a183d0c6718727$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $45a183d0c6718727$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $45a183d0c6718727$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $45a183d0c6718727$export$c3095a23b368d1f2 = function curry(fn) {
    return $45a183d0c6718727$var$curryN(fn.length, fn);
};
var $45a183d0c6718727$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $45a183d0c6718727$export$871de8747c9eaa88 = $45a183d0c6718727$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $45a183d0c6718727$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $45a183d0c6718727$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $45a183d0c6718727$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $45a183d0c6718727$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $3bbc3a54db54bf0d$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $3bbc3a54db54bf0d$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $3bbc3a54db54bf0d$var$interpolateNumber = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $3bbc3a54db54bf0d$var$uninterpolateNumber = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $3bbc3a54db54bf0d$var$uninterpolateTruncation = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $3bbc3a54db54bf0d$export$2e2bcd8739ae039 = {
    rangeStep: $3bbc3a54db54bf0d$var$rangeStep,
    getDigitCount: $3bbc3a54db54bf0d$var$getDigitCount,
    interpolateNumber: $3bbc3a54db54bf0d$var$interpolateNumber,
    uninterpolateNumber: $3bbc3a54db54bf0d$var$uninterpolateNumber,
    uninterpolateTruncation: $3bbc3a54db54bf0d$var$uninterpolateTruncation
};


function $de63bedd203e5dd9$var$_toConsumableArray(arr) {
    return $de63bedd203e5dd9$var$_arrayWithoutHoles(arr) || $de63bedd203e5dd9$var$_iterableToArray(arr) || $de63bedd203e5dd9$var$_unsupportedIterableToArray(arr) || $de63bedd203e5dd9$var$_nonIterableSpread();
}
function $de63bedd203e5dd9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de63bedd203e5dd9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $de63bedd203e5dd9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $de63bedd203e5dd9$var$_arrayLikeToArray(arr);
}
function $de63bedd203e5dd9$var$_slicedToArray(arr, i) {
    return $de63bedd203e5dd9$var$_arrayWithHoles(arr) || $de63bedd203e5dd9$var$_iterableToArrayLimit(arr, i) || $de63bedd203e5dd9$var$_unsupportedIterableToArray(arr, i) || $de63bedd203e5dd9$var$_nonIterableRest();
}
function $de63bedd203e5dd9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de63bedd203e5dd9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de63bedd203e5dd9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de63bedd203e5dd9$var$_arrayLikeToArray(o, minLen);
}
function $de63bedd203e5dd9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de63bedd203e5dd9$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $de63bedd203e5dd9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $de63bedd203e5dd9$var$getValidInterval(_ref) {
    var _ref2 = $de63bedd203e5dd9$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $de63bedd203e5dd9$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0);
    var digitCount = (0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $de63bedd203e5dd9$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(10).pow((0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $45a183d0c6718727$export$f672e0b6f7222cd7)((0, $45a183d0c6718727$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $45a183d0c6718727$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $de63bedd203e5dd9$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $de63bedd203e5dd9$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $de63bedd203e5dd9$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $45a183d0c6718727$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $45a183d0c6718727$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $de63bedd203e5dd9$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $de63bedd203e5dd9$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getTickValuesFn(_ref5) {
    var _ref6 = $de63bedd203e5dd9$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $de63bedd203e5dd9$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $45a183d0c6718727$export$f672e0b6f7222cd7)((0, $45a183d0c6718727$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(n).mul(step)).toNumber();
    }), (0, $45a183d0c6718727$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $de63bedd203e5dd9$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
var $de63bedd203e5dd9$export$b84e75ccbfe6a612 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getNiceTickValuesFn);
var $de63bedd203e5dd9$export$4cc7a216492b1f53 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getTickValuesFn);
var $de63bedd203e5dd9$export$e9d28da780436e98 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getTickValuesFixedDomainFn);








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


/* eslint no-console: 0 */ var $7e4f89fa33734bf7$var$isDev = false;
var $7e4f89fa33734bf7$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7e4f89fa33734bf7$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $7fPBF = parcelRequire("7fPBF");


var $6a2566a000284bc9$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $6a2566a000284bc9$var$_extends() {
    $6a2566a000284bc9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a2566a000284bc9$var$_extends.apply(this, arguments);
}
function $6a2566a000284bc9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6a2566a000284bc9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6a2566a000284bc9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6a2566a000284bc9$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $6a2566a000284bc9$var$_objectWithoutProperties(props, $6a2566a000284bc9$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $6a2566a000284bc9$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("desc", null, desc), children);
}



var $7fPBF = parcelRequire("7fPBF");




function $73ec554c060060c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73ec554c060060c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73ec554c060060c3$var$_typeof(o);
}
var $73ec554c060060c3$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $73ec554c060060c3$var$_extends() {
    $73ec554c060060c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73ec554c060060c3$var$_extends.apply(this, arguments);
}
function $73ec554c060060c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73ec554c060060c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73ec554c060060c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $73ec554c060060c3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73ec554c060060c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73ec554c060060c3$var$_defineProperty(obj, key, value) {
    key = $73ec554c060060c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73ec554c060060c3$var$_toPropertyKey(arg) {
    var key = $73ec554c060060c3$var$_toPrimitive(arg, "string");
    return $73ec554c060060c3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $73ec554c060060c3$var$_toPrimitive(input, hint) {
    if ($73ec554c060060c3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($73ec554c060060c3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73ec554c060060c3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73ec554c060060c3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73ec554c060060c3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73ec554c060060c3$var$symbolFactories = {
    symbolCircle: (0, $922af94be54ea802$exports.symbolCircle),
    symbolCross: (0, $922af94be54ea802$exports.symbolCross),
    symbolDiamond: (0, $922af94be54ea802$exports.symbolDiamond),
    symbolSquare: (0, $922af94be54ea802$exports.symbolSquare),
    symbolStar: (0, $922af94be54ea802$exports.symbolStar),
    symbolTriangle: (0, $922af94be54ea802$exports.symbolTriangle),
    symbolWye: (0, $922af94be54ea802$exports.symbolWye)
};
var $73ec554c060060c3$var$RADIAN = Math.PI / 180;
var $73ec554c060060c3$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($cb4a4ca6f49cb945$exports)))(type));
    return $73ec554c060060c3$var$symbolFactories[name] || (0, $922af94be54ea802$exports.symbolCircle);
};
var $73ec554c060060c3$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $73ec554c060060c3$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $73ec554c060060c3$var$registerSymbol = function registerSymbol(key, factory) {
    $73ec554c060060c3$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($cb4a4ca6f49cb945$exports)))(key))] = factory;
};
var $73ec554c060060c3$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $73ec554c060060c3$var$_objectWithoutProperties(_ref, $73ec554c060060c3$var$_excluded);
    var props = $73ec554c060060c3$var$_objectSpread($73ec554c060060c3$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $73ec554c060060c3$var$getSymbolFactory(type);
        var symbol = (0, $922af94be54ea802$exports.symbol)().type(symbolFactory).size($73ec554c060060c3$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $73ec554c060060c3$var$_extends({}, filteredProps, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$73ec554c060060c3$export$fa456266707bf4e4.registerSymbol = $73ec554c060060c3$var$registerSymbol;



function $8b96df7c48af2c0d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b96df7c48af2c0d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b96df7c48af2c0d$var$_typeof(o);
}
function $8b96df7c48af2c0d$var$_extends() {
    $8b96df7c48af2c0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b96df7c48af2c0d$var$_extends.apply(this, arguments);
}
function $8b96df7c48af2c0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b96df7c48af2c0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b96df7c48af2c0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8b96df7c48af2c0d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b96df7c48af2c0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8b96df7c48af2c0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b96df7c48af2c0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8b96df7c48af2c0d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8b96df7c48af2c0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8b96df7c48af2c0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b96df7c48af2c0d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8b96df7c48af2c0d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8b96df7c48af2c0d$var$_setPrototypeOf(subClass, superClass);
}
function $8b96df7c48af2c0d$var$_setPrototypeOf(o, p) {
    $8b96df7c48af2c0d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8b96df7c48af2c0d$var$_setPrototypeOf(o, p);
}
function $8b96df7c48af2c0d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8b96df7c48af2c0d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8b96df7c48af2c0d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8b96df7c48af2c0d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8b96df7c48af2c0d$var$_possibleConstructorReturn(this, result);
    };
}
function $8b96df7c48af2c0d$var$_possibleConstructorReturn(self, call) {
    if (call && ($8b96df7c48af2c0d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8b96df7c48af2c0d$var$_assertThisInitialized(self);
}
function $8b96df7c48af2c0d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8b96df7c48af2c0d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8b96df7c48af2c0d$var$_getPrototypeOf(o) {
    $8b96df7c48af2c0d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8b96df7c48af2c0d$var$_getPrototypeOf(o);
}
function $8b96df7c48af2c0d$var$_defineProperty(obj, key, value) {
    key = $8b96df7c48af2c0d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b96df7c48af2c0d$var$_toPropertyKey(arg) {
    var key = $8b96df7c48af2c0d$var$_toPrimitive(arg, "string");
    return $8b96df7c48af2c0d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8b96df7c48af2c0d$var$_toPrimitive(input, hint) {
    if ($8b96df7c48af2c0d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8b96df7c48af2c0d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8b96df7c48af2c0d$var$SIZE = 32;
var $8b96df7c48af2c0d$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $8b96df7c48af2c0d$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $8b96df7c48af2c0d$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $8b96df7c48af2c0d$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $8b96df7c48af2c0d$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $8b96df7c48af2c0d$var$SIZE / 2;
                var sixthSize = $8b96df7c48af2c0d$var$SIZE / 6;
                var thirdSize = $8b96df7c48af2c0d$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $8b96df7c48af2c0d$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($8b96df7c48af2c0d$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($8b96df7c48af2c0d$var$SIZE / 8, "h").concat($8b96df7c48af2c0d$var$SIZE, "v").concat($8b96df7c48af2c0d$var$SIZE * 3 / 4, "h").concat(-$8b96df7c48af2c0d$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(data.legendIcon)) {
                    var iconProps = $8b96df7c48af2c0d$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $73ec554c060060c3$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $8b96df7c48af2c0d$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $8b96df7c48af2c0d$var$SIZE,
                    height: $8b96df7c48af2c0d$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _clsx;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((_clsx = {
                        'recharts-legend-item': true
                    }, $8b96df7c48af2c0d$var$_defineProperty(_clsx, "legend-item-".concat(i), true), $8b96df7c48af2c0d$var$_defineProperty(_clsx, "inactive", entry.inactive), _clsx));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(entry.value) ? entry.value : null;
                    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", $8b96df7c48af2c0d$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $7fPBF.PureComponent));
$8b96df7c48af2c0d$var$_defineProperty($8b96df7c48af2c0d$export$99f8d96ed0cededa, "displayName", 'Legend');
$8b96df7c48af2c0d$var$_defineProperty($8b96df7c48af2c0d$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $39015f50aafccaaa$exports = {};

var $1e01b255157bd6a3$exports = {};

var $59640191b28247a9$exports = {};
var $0a937e5cdb5b4a43$exports = {};
var $f64f1f8d62f85551$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f64f1f8d62f85551$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$f64f1f8d62f85551$exports = $f64f1f8d62f85551$var$baseFindIndex;


var $bd5d2bcb18e5539c$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $bd5d2bcb18e5539c$var$baseIsNaN(value) {
    return value !== value;
}
$bd5d2bcb18e5539c$exports = $bd5d2bcb18e5539c$var$baseIsNaN;


var $631c5bc930738269$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $631c5bc930738269$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$631c5bc930738269$exports = $631c5bc930738269$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0a937e5cdb5b4a43$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $631c5bc930738269$exports(array, value, fromIndex) : $f64f1f8d62f85551$exports(array, $bd5d2bcb18e5539c$exports, fromIndex);
}
$0a937e5cdb5b4a43$exports = $0a937e5cdb5b4a43$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $59640191b28247a9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $0a937e5cdb5b4a43$exports(array, value, 0) > -1;
}
$59640191b28247a9$exports = $59640191b28247a9$var$arrayIncludes;


var $6d8b024673245ed6$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $6d8b024673245ed6$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$6d8b024673245ed6$exports = $6d8b024673245ed6$var$arrayIncludesWith;



var $caaa0f1fac2b7876$exports = {};

var $add0935a5f1d4b98$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $add0935a5f1d4b98$var$noop() {
// No operation performed.
}
$add0935a5f1d4b98$exports = $add0935a5f1d4b98$var$noop;



/** Used as references for various `Number` constants. */ var $caaa0f1fac2b7876$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $caaa0f1fac2b7876$var$createSet = !($605a62b994d93559$exports && 1 / $74670b58ce191e08$exports(new $605a62b994d93559$exports([
    ,
    -0
]))[1] == $caaa0f1fac2b7876$var$INFINITY) ? $add0935a5f1d4b98$exports : function(values) {
    return new $605a62b994d93559$exports(values);
};
$caaa0f1fac2b7876$exports = $caaa0f1fac2b7876$var$createSet;



/** Used as the size to enable large array optimizations. */ var $1e01b255157bd6a3$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $1e01b255157bd6a3$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $59640191b28247a9$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $6d8b024673245ed6$exports;
    } else if (length >= $1e01b255157bd6a3$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $caaa0f1fac2b7876$exports(array);
        if (set) return $74670b58ce191e08$exports(set);
        isCommon = false;
        includes = $94650024ba6b2b85$exports;
        seen = new $bc247c70e6ef02ba$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$1e01b255157bd6a3$exports = $1e01b255157bd6a3$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $39015f50aafccaaa$var$uniqBy(array, iteratee) {
    return array && array.length ? $1e01b255157bd6a3$exports(array, $6981623866a9ed6c$exports(iteratee, 2)) : [];
}
$39015f50aafccaaa$exports = $39015f50aafccaaa$var$uniqBy;



function $9df57fcd3e3e7338$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($39015f50aafccaaa$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($39015f50aafccaaa$exports)))(payload, option);
    return payload;
}


function $559b693b6a1d5199$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $559b693b6a1d5199$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $559b693b6a1d5199$var$_typeof(o);
}
var $559b693b6a1d5199$var$_excluded = [
    "ref"
];
function $559b693b6a1d5199$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $559b693b6a1d5199$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $559b693b6a1d5199$var$ownKeys(Object(t), !0).forEach(function(r) {
            $559b693b6a1d5199$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $559b693b6a1d5199$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $559b693b6a1d5199$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $559b693b6a1d5199$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $559b693b6a1d5199$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $559b693b6a1d5199$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $559b693b6a1d5199$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $559b693b6a1d5199$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $559b693b6a1d5199$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $559b693b6a1d5199$var$_setPrototypeOf(subClass, superClass);
}
function $559b693b6a1d5199$var$_setPrototypeOf(o, p) {
    $559b693b6a1d5199$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $559b693b6a1d5199$var$_setPrototypeOf(o, p);
}
function $559b693b6a1d5199$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $559b693b6a1d5199$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $559b693b6a1d5199$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $559b693b6a1d5199$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $559b693b6a1d5199$var$_possibleConstructorReturn(this, result);
    };
}
function $559b693b6a1d5199$var$_possibleConstructorReturn(self, call) {
    if (call && ($559b693b6a1d5199$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $559b693b6a1d5199$var$_assertThisInitialized(self);
}
function $559b693b6a1d5199$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $559b693b6a1d5199$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $559b693b6a1d5199$var$_getPrototypeOf(o) {
    $559b693b6a1d5199$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $559b693b6a1d5199$var$_getPrototypeOf(o);
}
function $559b693b6a1d5199$var$_defineProperty(obj, key, value) {
    key = $559b693b6a1d5199$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $559b693b6a1d5199$var$_toPropertyKey(arg) {
    var key = $559b693b6a1d5199$var$_toPrimitive(arg, "string");
    return $559b693b6a1d5199$var$_typeof(key) === "symbol" ? key : String(key);
}
function $559b693b6a1d5199$var$_toPrimitive(input, hint) {
    if ($559b693b6a1d5199$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($559b693b6a1d5199$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $559b693b6a1d5199$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $559b693b6a1d5199$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $559b693b6a1d5199$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $559b693b6a1d5199$var$defaultUniqBy(entry) {
    return entry.value;
}
function $559b693b6a1d5199$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(content, props);
    var ref = props.ref, otherProps = $559b693b6a1d5199$var$_objectWithoutProperties(props, $559b693b6a1d5199$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8b96df7c48af2c0d$export$99f8d96ed0cededa), otherProps);
}
var $559b693b6a1d5199$var$EPS = 1;
var $559b693b6a1d5199$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $559b693b6a1d5199$var$_inherits(Legend, _PureComponent);
    var _super = $559b693b6a1d5199$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $559b693b6a1d5199$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $559b693b6a1d5199$var$_defineProperty($559b693b6a1d5199$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $559b693b6a1d5199$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box.width - this.lastBoundingBox.width) > $559b693b6a1d5199$var$EPS || Math.abs(_box.height - this.lastBoundingBox.height) > $559b693b6a1d5199$var$EPS) {
                        this.lastBoundingBox.width = _box.width;
                        this.lastBoundingBox.height = _box.height;
                        if (onBBoxUpdate) onBBoxUpdate(_box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $559b693b6a1d5199$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $559b693b6a1d5199$var$renderContent(content, $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $9df57fcd3e3e7338$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $559b693b6a1d5199$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $7fPBF.PureComponent));
$559b693b6a1d5199$var$_defineProperty($559b693b6a1d5199$export$ed247974535929c7, "displayName", 'Legend');
$559b693b6a1d5199$var$_defineProperty($559b693b6a1d5199$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $7bbd89b69def67ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7bbd89b69def67ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7bbd89b69def67ea$var$_typeof(o);
}
function $7bbd89b69def67ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bbd89b69def67ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bbd89b69def67ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7bbd89b69def67ea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bbd89b69def67ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7bbd89b69def67ea$var$_defineProperty(obj, key, value) {
    key = $7bbd89b69def67ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7bbd89b69def67ea$var$_toPropertyKey(arg) {
    var key = $7bbd89b69def67ea$var$_toPrimitive(arg, "string");
    return $7bbd89b69def67ea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7bbd89b69def67ea$var$_toPrimitive(input, hint) {
    if ($7bbd89b69def67ea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7bbd89b69def67ea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7bbd89b69def67ea$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $559b693b6a1d5199$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: (0, $3cf1854128f2220f$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread({}, legendItem.props), (0, $559b693b6a1d5199$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $3cf1854128f2220f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cf1854128f2220f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cf1854128f2220f$var$_typeof(o);
}
function $3cf1854128f2220f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cf1854128f2220f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cf1854128f2220f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cf1854128f2220f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cf1854128f2220f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cf1854128f2220f$var$_defineProperty(obj, key, value) {
    key = $3cf1854128f2220f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cf1854128f2220f$var$_toPropertyKey(arg) {
    var key = $3cf1854128f2220f$var$_toPrimitive(arg, "string");
    return $3cf1854128f2220f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3cf1854128f2220f$var$_toPrimitive(input, hint) {
    if ($3cf1854128f2220f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3cf1854128f2220f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3cf1854128f2220f$var$_toConsumableArray(arr) {
    return $3cf1854128f2220f$var$_arrayWithoutHoles(arr) || $3cf1854128f2220f$var$_iterableToArray(arr) || $3cf1854128f2220f$var$_unsupportedIterableToArray(arr) || $3cf1854128f2220f$var$_nonIterableSpread();
}
function $3cf1854128f2220f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cf1854128f2220f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cf1854128f2220f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cf1854128f2220f$var$_arrayLikeToArray(o, minLen);
}
function $3cf1854128f2220f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3cf1854128f2220f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3cf1854128f2220f$var$_arrayLikeToArray(arr);
}
function $3cf1854128f2220f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cf1854128f2220f$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey)) return defaultValue;
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $3cf1854128f2220f$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($70171a2be606096a$exports)))(data, function(entry) {
        return $3cf1854128f2220f$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($f21d533eecb55ca3$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($103d2fad6c8f6f2b$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $ddf2636240ab70e2$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $3cf1854128f2220f$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $ddf2636240ab70e2$export$9d334328eb75e624)(cur - before) !== (0, $ddf2636240ab70e2$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $ddf2636240ab70e2$export$9d334328eb75e624)(after - cur) === (0, $ddf2636240ab70e2$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $3cf1854128f2220f$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $3cf1854128f2220f$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $3cf1854128f2220f$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($3cf1854128f2220f$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($3cf1854128f2220f$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $3cf1854128f2220f$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $7bbd89b69def67ea$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(offset[align])) return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, offset), {}, $3cf1854128f2220f$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(offset[verticalAlign])) return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, offset), {}, $3cf1854128f2220f$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $3cf1854128f2220f$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $3cf1854128f2220f$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $d05ab0383decc723$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $3cf1854128f2220f$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $3cf1854128f2220f$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($f21d533eecb55ca3$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($103d2fad6c8f6f2b$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $3cf1854128f2220f$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $3cf1854128f2220f$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $3cf1854128f2220f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $3cf1854128f2220f$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $3cf1854128f2220f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $3cf1854128f2220f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $3cf1854128f2220f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $3cf1854128f2220f$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $3cf1854128f2220f$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $3cf1854128f2220f$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $ddf2636240ab70e2$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($8fd9681e324ea785$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $3cf1854128f2220f$var$handlerWeakMap = new WeakMap();
var $3cf1854128f2220f$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$3cf1854128f2220f$var$handlerWeakMap.has(defaultHandler)) $3cf1854128f2220f$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $3cf1854128f2220f$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $3cf1854128f2220f$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $88853d08cf75746a$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $88853d08cf75746a$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $88853d08cf75746a$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $88853d08cf75746a$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $88853d08cf75746a$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1ca3e17f8f074468$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($cb4a4ca6f49cb945$exports)))(scale));
        return {
            scale: ($88853d08cf75746a$exports[name] || $88853d08cf75746a$exports.scalePoint)(),
            realScaleType: $88853d08cf75746a$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $88853d08cf75746a$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $3cf1854128f2220f$var$EPS = 1e-4;
var $3cf1854128f2220f$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $3cf1854128f2220f$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $3cf1854128f2220f$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $3cf1854128f2220f$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $3cf1854128f2220f$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domain[0]) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $3cf1854128f2220f$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8fd9681e324ea785$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $3cf1854128f2220f$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8fd9681e324ea785$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $3cf1854128f2220f$var$STACK_OFFSET_MAP = {
    sign: $3cf1854128f2220f$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $922af94be54ea802$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $922af94be54ea802$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $922af94be54ea802$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $922af94be54ea802$exports.stackOffsetWiggle),
    positive: $3cf1854128f2220f$export$9f2c6ead70935022
};
var $3cf1854128f2220f$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $3cf1854128f2220f$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $922af94be54ea802$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$3cf1854128f2220f$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $922af94be54ea802$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $3cf1854128f2220f$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, result), {}, $3cf1854128f2220f$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, res), {}, $3cf1854128f2220f$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $3cf1854128f2220f$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, result), {}, $3cf1854128f2220f$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $3cf1854128f2220f$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $de63bedd203e5dd9$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($f21d533eecb55ca3$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($103d2fad6c8f6f2b$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $de63bedd203e5dd9$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $3cf1854128f2220f$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $3cf1854128f2220f$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(value) ? axis.scale(value) : null;
};
var $3cf1854128f2220f$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $3cf1854128f2220f$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $3cf1854128f2220f$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $3cf1854128f2220f$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $3cf1854128f2220f$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($f21d533eecb55ca3$exports)))(entry.concat([
                result[0]
            ]).filter((0, $ddf2636240ab70e2$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($103d2fad6c8f6f2b$exports)))(entry.concat([
                result[1]
            ]).filter((0, $ddf2636240ab70e2$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $3cf1854128f2220f$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $3cf1854128f2220f$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $3cf1854128f2220f$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3cf1854128f2220f$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3cf1854128f2220f$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($3cf1854128f2220f$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$3cf1854128f2220f$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($3cf1854128f2220f$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$3cf1854128f2220f$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $3cf1854128f2220f$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($08c68625964a32b5$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $3cf1854128f2220f$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b2b661eb4d0f23aa$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $3cf1854128f2220f$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType, hide = _graphicalItem$props.hide;
    return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $3cf1854128f2220f$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $3cf1854128f2220f$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $2f494a175d2955a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2f494a175d2955a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f494a175d2955a8$var$_typeof(o);
}
function $2f494a175d2955a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f494a175d2955a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f494a175d2955a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f494a175d2955a8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f494a175d2955a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f494a175d2955a8$var$_defineProperty(obj, key, value) {
    key = $2f494a175d2955a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2f494a175d2955a8$var$_toPropertyKey(arg) {
    var key = $2f494a175d2955a8$var$_toPrimitive(arg, "string");
    return $2f494a175d2955a8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2f494a175d2955a8$var$_toPrimitive(input, hint) {
    if ($2f494a175d2955a8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2f494a175d2955a8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2f494a175d2955a8$var$_slicedToArray(arr, i) {
    return $2f494a175d2955a8$var$_arrayWithHoles(arr) || $2f494a175d2955a8$var$_iterableToArrayLimit(arr, i) || $2f494a175d2955a8$var$_unsupportedIterableToArray(arr, i) || $2f494a175d2955a8$var$_nonIterableRest();
}
function $2f494a175d2955a8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2f494a175d2955a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2f494a175d2955a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2f494a175d2955a8$var$_arrayLikeToArray(o, minLen);
}
function $2f494a175d2955a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2f494a175d2955a8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2f494a175d2955a8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2f494a175d2955a8$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $2f494a175d2955a8$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $2f494a175d2955a8$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $2f494a175d2955a8$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$2f494a175d2955a8$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$2f494a175d2955a8$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $2f494a175d2955a8$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $2f494a175d2955a8$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $2f494a175d2955a8$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $2f494a175d2955a8$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $3cf1854128f2220f$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $3cf1854128f2220f$export$9d80152e23bae434)(scale);
        var ticks = (0, $3cf1854128f2220f$export$ac086aaa4358d590)(scale, $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, result), {}, $2f494a175d2955a8$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $2f494a175d2955a8$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $2f494a175d2955a8$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $2f494a175d2955a8$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $2f494a175d2955a8$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $2f494a175d2955a8$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $2f494a175d2955a8$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $2f494a175d2955a8$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $2f494a175d2955a8$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $2f494a175d2955a8$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $2f494a175d2955a8$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $41cf002e3fba69c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41cf002e3fba69c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41cf002e3fba69c7$var$_typeof(o);
}
var $41cf002e3fba69c7$var$_excluded = [
    "offset"
];
function $41cf002e3fba69c7$var$_toConsumableArray(arr) {
    return $41cf002e3fba69c7$var$_arrayWithoutHoles(arr) || $41cf002e3fba69c7$var$_iterableToArray(arr) || $41cf002e3fba69c7$var$_unsupportedIterableToArray(arr) || $41cf002e3fba69c7$var$_nonIterableSpread();
}
function $41cf002e3fba69c7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41cf002e3fba69c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41cf002e3fba69c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41cf002e3fba69c7$var$_arrayLikeToArray(o, minLen);
}
function $41cf002e3fba69c7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $41cf002e3fba69c7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $41cf002e3fba69c7$var$_arrayLikeToArray(arr);
}
function $41cf002e3fba69c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $41cf002e3fba69c7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $41cf002e3fba69c7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $41cf002e3fba69c7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $41cf002e3fba69c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41cf002e3fba69c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41cf002e3fba69c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41cf002e3fba69c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41cf002e3fba69c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41cf002e3fba69c7$var$_defineProperty(obj, key, value) {
    key = $41cf002e3fba69c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41cf002e3fba69c7$var$_toPropertyKey(arg) {
    var key = $41cf002e3fba69c7$var$_toPrimitive(arg, "string");
    return $41cf002e3fba69c7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $41cf002e3fba69c7$var$_toPrimitive(input, hint) {
    if ($41cf002e3fba69c7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($41cf002e3fba69c7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $41cf002e3fba69c7$var$_extends() {
    $41cf002e3fba69c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41cf002e3fba69c7$var$_extends.apply(this, arguments);
}
var $41cf002e3fba69c7$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(formatter)) return formatter(label);
    return label;
};
var $41cf002e3fba69c7$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $41cf002e3fba69c7$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $41cf002e3fba69c7$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(labelProps.id) ? (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("text", $41cf002e3fba69c7$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $41cf002e3fba69c7$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $41cf002e3fba69c7$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(position) && ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position.x) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(position.x)) && ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position.y) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(position.y))) return $41cf002e3fba69c7$var$_objectSpread({
        x: x + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $41cf002e3fba69c7$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(viewBox.cx);
};
function $41cf002e3fba69c7$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $41cf002e3fba69c7$var$_objectWithoutProperties(_ref4, $41cf002e3fba69c7$var$_excluded);
    var props = $41cf002e3fba69c7$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(children) && !/*#__PURE__*/ (0, $7fPBF.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(content)) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(content)) {
        label = /*#__PURE__*/ (0, $7fPBF.createElement)(content, props);
        if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(label)) return label;
    } else label = $41cf002e3fba69c7$var$getLabel(props);
    var isPolarLabel = $41cf002e3fba69c7$var$isPolar(viewBox);
    var attrs = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $41cf002e3fba69c7$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $41cf002e3fba69c7$var$getAttrsOfPolarLabel(props) : $41cf002e3fba69c7$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $41cf002e3fba69c7$var$_extends({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$41cf002e3fba69c7$export$b04be29aa201d4f5.displayName = 'Label';
var $41cf002e3fba69c7$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height)) {
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(top) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cx) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $41cf002e3fba69c7$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(label)) {
        if (label.type === $41cf002e3fba69c7$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, $41cf002e3fba69c7$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $41cf002e3fba69c7$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $41cf002e3fba69c7$var$parseViewBox(parentProps);
    var explicitChildren = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, $41cf002e3fba69c7$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $41cf002e3fba69c7$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($41cf002e3fba69c7$var$_toConsumableArray(explicitChildren));
};
$41cf002e3fba69c7$export$b04be29aa201d4f5.parseViewBox = $41cf002e3fba69c7$var$parseViewBox;
$41cf002e3fba69c7$export$b04be29aa201d4f5.renderCallByParent = $41cf002e3fba69c7$var$renderCallByParent;





function $acfa11ccf9405f16$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $acfa11ccf9405f16$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $acfa11ccf9405f16$var$_typeof(o);
}
var $acfa11ccf9405f16$var$_excluded = [
    "valueAccessor"
], $acfa11ccf9405f16$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $acfa11ccf9405f16$var$_toConsumableArray(arr) {
    return $acfa11ccf9405f16$var$_arrayWithoutHoles(arr) || $acfa11ccf9405f16$var$_iterableToArray(arr) || $acfa11ccf9405f16$var$_unsupportedIterableToArray(arr) || $acfa11ccf9405f16$var$_nonIterableSpread();
}
function $acfa11ccf9405f16$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $acfa11ccf9405f16$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $acfa11ccf9405f16$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $acfa11ccf9405f16$var$_arrayLikeToArray(o, minLen);
}
function $acfa11ccf9405f16$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $acfa11ccf9405f16$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $acfa11ccf9405f16$var$_arrayLikeToArray(arr);
}
function $acfa11ccf9405f16$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $acfa11ccf9405f16$var$_extends() {
    $acfa11ccf9405f16$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $acfa11ccf9405f16$var$_extends.apply(this, arguments);
}
function $acfa11ccf9405f16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acfa11ccf9405f16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acfa11ccf9405f16$var$ownKeys(Object(t), !0).forEach(function(r) {
            $acfa11ccf9405f16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acfa11ccf9405f16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $acfa11ccf9405f16$var$_defineProperty(obj, key, value) {
    key = $acfa11ccf9405f16$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acfa11ccf9405f16$var$_toPropertyKey(arg) {
    var key = $acfa11ccf9405f16$var$_toPrimitive(arg, "string");
    return $acfa11ccf9405f16$var$_typeof(key) === "symbol" ? key : String(key);
}
function $acfa11ccf9405f16$var$_toPrimitive(input, hint) {
    if ($acfa11ccf9405f16$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($acfa11ccf9405f16$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $acfa11ccf9405f16$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $acfa11ccf9405f16$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $acfa11ccf9405f16$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $acfa11ccf9405f16$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($327b0cfc03620646$exports)))(entry.value) : entry.value;
};
function $acfa11ccf9405f16$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $acfa11ccf9405f16$var$defaultAccessor : _ref$valueAccessor, restProps = $acfa11ccf9405f16$var$_objectWithoutProperties(_ref, $acfa11ccf9405f16$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $acfa11ccf9405f16$var$_objectWithoutProperties(restProps, $acfa11ccf9405f16$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $41cf002e3fba69c7$export$b04be29aa201d4f5), $acfa11ccf9405f16$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(clockWise) ? entry : $acfa11ccf9405f16$var$_objectSpread($acfa11ccf9405f16$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$acfa11ccf9405f16$export$835fcf23ab7bf88.displayName = 'LabelList';
function $acfa11ccf9405f16$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7aa8549693d433a8$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, $acfa11ccf9405f16$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $acfa11ccf9405f16$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, $acfa11ccf9405f16$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $acfa11ccf9405f16$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($acfa11ccf9405f16$var$_toConsumableArray(explicitChildren));
}
$acfa11ccf9405f16$export$835fcf23ab7bf88.renderCallByParent = $acfa11ccf9405f16$var$renderCallByParent;








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $b51c5b516ea8e6df$exports = {};

var $89068467bb5d3ef5$exports = {};

/** Built-in value references. */ var $89068467bb5d3ef5$var$getPrototype = $2071a43225f6eb14$exports(Object.getPrototypeOf, Object);
$89068467bb5d3ef5$exports = $89068467bb5d3ef5$var$getPrototype;



/** `Object#toString` result references. */ var $b51c5b516ea8e6df$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $b51c5b516ea8e6df$var$funcProto = Function.prototype, $b51c5b516ea8e6df$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b51c5b516ea8e6df$var$funcToString = $b51c5b516ea8e6df$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b51c5b516ea8e6df$var$hasOwnProperty = $b51c5b516ea8e6df$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b51c5b516ea8e6df$var$objectCtorString = $b51c5b516ea8e6df$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b51c5b516ea8e6df$var$isPlainObject(value) {
    if (!$e066a98c24dd369b$exports(value) || $e95a344dcaa52f73$exports(value) != $b51c5b516ea8e6df$var$objectTag) return false;
    var proto = $89068467bb5d3ef5$exports(value);
    if (proto === null) return true;
    var Ctor = $b51c5b516ea8e6df$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $b51c5b516ea8e6df$var$funcToString.call(Ctor) == $b51c5b516ea8e6df$var$objectCtorString;
}
$b51c5b516ea8e6df$exports = $b51c5b516ea8e6df$var$isPlainObject;


var $e974082861fd54a5$exports = {};


/** `Object#toString` result references. */ var $e974082861fd54a5$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $e974082861fd54a5$var$isBoolean(value) {
    return value === true || value === false || $e066a98c24dd369b$exports(value) && $e95a344dcaa52f73$exports(value) == $e974082861fd54a5$var$boolTag;
}
$e974082861fd54a5$exports = $e974082861fd54a5$var$isBoolean;




var $7fPBF = parcelRequire("7fPBF");



function $dd9e03c5c06a0d41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd9e03c5c06a0d41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd9e03c5c06a0d41$var$_typeof(o);
}
function $dd9e03c5c06a0d41$var$_extends() {
    $dd9e03c5c06a0d41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd9e03c5c06a0d41$var$_extends.apply(this, arguments);
}
function $dd9e03c5c06a0d41$var$_slicedToArray(arr, i) {
    return $dd9e03c5c06a0d41$var$_arrayWithHoles(arr) || $dd9e03c5c06a0d41$var$_iterableToArrayLimit(arr, i) || $dd9e03c5c06a0d41$var$_unsupportedIterableToArray(arr, i) || $dd9e03c5c06a0d41$var$_nonIterableRest();
}
function $dd9e03c5c06a0d41$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd9e03c5c06a0d41$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dd9e03c5c06a0d41$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dd9e03c5c06a0d41$var$_arrayLikeToArray(o, minLen);
}
function $dd9e03c5c06a0d41$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dd9e03c5c06a0d41$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dd9e03c5c06a0d41$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dd9e03c5c06a0d41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd9e03c5c06a0d41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd9e03c5c06a0d41$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd9e03c5c06a0d41$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd9e03c5c06a0d41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dd9e03c5c06a0d41$var$_defineProperty(obj, key, value) {
    key = $dd9e03c5c06a0d41$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd9e03c5c06a0d41$var$_toPropertyKey(arg) {
    var key = $dd9e03c5c06a0d41$var$_toPrimitive(arg, "string");
    return $dd9e03c5c06a0d41$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dd9e03c5c06a0d41$var$_toPrimitive(input, hint) {
    if ($dd9e03c5c06a0d41$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dd9e03c5c06a0d41$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $dd9e03c5c06a0d41$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $dd9e03c5c06a0d41$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $dd9e03c5c06a0d41$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $dd9e03c5c06a0d41$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $dd9e03c5c06a0d41$var$_objectSpread($dd9e03c5c06a0d41$var$_objectSpread({}, $dd9e03c5c06a0d41$var$defaultProps), rectangleProps);
    var pathRef = (0, $7fPBF.useRef)();
    var _useState = (0, $7fPBF.useState)(-1), _useState2 = $dd9e03c5c06a0d41$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd9e03c5c06a0d41$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $dd9e03c5c06a0d41$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd9e03c5c06a0d41$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $dd9e03c5c06a0d41$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $7fPBF = parcelRequire("7fPBF");



function $8ef28ada15db1e5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ef28ada15db1e5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ef28ada15db1e5a$var$_typeof(o);
}
function $8ef28ada15db1e5a$var$_extends() {
    $8ef28ada15db1e5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ef28ada15db1e5a$var$_extends.apply(this, arguments);
}
function $8ef28ada15db1e5a$var$_slicedToArray(arr, i) {
    return $8ef28ada15db1e5a$var$_arrayWithHoles(arr) || $8ef28ada15db1e5a$var$_iterableToArrayLimit(arr, i) || $8ef28ada15db1e5a$var$_unsupportedIterableToArray(arr, i) || $8ef28ada15db1e5a$var$_nonIterableRest();
}
function $8ef28ada15db1e5a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8ef28ada15db1e5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8ef28ada15db1e5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8ef28ada15db1e5a$var$_arrayLikeToArray(o, minLen);
}
function $8ef28ada15db1e5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8ef28ada15db1e5a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8ef28ada15db1e5a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8ef28ada15db1e5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ef28ada15db1e5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ef28ada15db1e5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ef28ada15db1e5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ef28ada15db1e5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ef28ada15db1e5a$var$_defineProperty(obj, key, value) {
    key = $8ef28ada15db1e5a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ef28ada15db1e5a$var$_toPropertyKey(arg) {
    var key = $8ef28ada15db1e5a$var$_toPrimitive(arg, "string");
    return $8ef28ada15db1e5a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8ef28ada15db1e5a$var$_toPrimitive(input, hint) {
    if ($8ef28ada15db1e5a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8ef28ada15db1e5a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8ef28ada15db1e5a$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $8ef28ada15db1e5a$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $8ef28ada15db1e5a$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $8ef28ada15db1e5a$var$_objectSpread($8ef28ada15db1e5a$var$_objectSpread({}, $8ef28ada15db1e5a$var$defaultProps), props);
    var pathRef = (0, $7fPBF.useRef)();
    var _useState = (0, $7fPBF.useState)(-1), _useState2 = $8ef28ada15db1e5a$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $8ef28ada15db1e5a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $8ef28ada15db1e5a$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $8ef28ada15db1e5a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $8ef28ada15db1e5a$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $7fPBF = parcelRequire("7fPBF");




function $dd92401041fdb928$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd92401041fdb928$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd92401041fdb928$var$_typeof(o);
}
function $dd92401041fdb928$var$_extends() {
    $dd92401041fdb928$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd92401041fdb928$var$_extends.apply(this, arguments);
}
function $dd92401041fdb928$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd92401041fdb928$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd92401041fdb928$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd92401041fdb928$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd92401041fdb928$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dd92401041fdb928$var$_defineProperty(obj, key, value) {
    key = $dd92401041fdb928$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd92401041fdb928$var$_toPropertyKey(arg) {
    var key = $dd92401041fdb928$var$_toPrimitive(arg, "string");
    return $dd92401041fdb928$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dd92401041fdb928$var$_toPrimitive(input, hint) {
    if ($dd92401041fdb928$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dd92401041fdb928$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $dd92401041fdb928$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $dd92401041fdb928$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $2f494a175d2955a8$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $2f494a175d2955a8$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $dd92401041fdb928$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $dd92401041fdb928$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $dd92401041fdb928$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $dd92401041fdb928$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $dd92401041fdb928$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $dd92401041fdb928$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $dd92401041fdb928$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $dd92401041fdb928$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $dd92401041fdb928$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $dd92401041fdb928$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $dd92401041fdb928$var$_objectSpread($dd92401041fdb928$var$_objectSpread({}, $dd92401041fdb928$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $dd92401041fdb928$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $dd92401041fdb928$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd92401041fdb928$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $afd6034f160dea85$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $afd6034f160dea85$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afd6034f160dea85$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afd6034f160dea85$var$_typeof(o);
}
function $afd6034f160dea85$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $afd6034f160dea85$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $afd6034f160dea85$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $afd6034f160dea85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afd6034f160dea85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afd6034f160dea85$var$ownKeys(Object(t), !0).forEach(function(r) {
            $afd6034f160dea85$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afd6034f160dea85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afd6034f160dea85$var$_defineProperty(obj, key, value) {
    key = $afd6034f160dea85$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afd6034f160dea85$var$_toPropertyKey(arg) {
    var key = $afd6034f160dea85$var$_toPrimitive(arg, "string");
    return $afd6034f160dea85$var$_typeof(key) === "symbol" ? key : String(key);
}
function $afd6034f160dea85$var$_toPrimitive(input, hint) {
    if ($afd6034f160dea85$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($afd6034f160dea85$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $afd6034f160dea85$var$defaultPropTransformer(option, props) {
    return $afd6034f160dea85$var$_objectSpread($afd6034f160dea85$var$_objectSpread({}, props), option);
}
function $afd6034f160dea85$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $afd6034f160dea85$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd9e03c5c06a0d41$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ef28ada15db1e5a$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd92401041fdb928$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($afd6034f160dea85$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $73ec554c060060c3$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $afd6034f160dea85$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) return option.props;
    return option;
}
function $afd6034f160dea85$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $afd6034f160dea85$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $afd6034f160dea85$var$_objectWithoutProperties(_ref2, $afd6034f160dea85$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) shape = /*#__PURE__*/ (0, $7fPBF.cloneElement)(option, $afd6034f160dea85$var$_objectSpread($afd6034f160dea85$var$_objectSpread({}, props), $afd6034f160dea85$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b51c5b516ea8e6df$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($e974082861fd54a5$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($afd6034f160dea85$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($afd6034f160dea85$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $afd6034f160dea85$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $afd6034f160dea85$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $afd6034f160dea85$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $afd6034f160dea85$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$7c9a98b3f068686f;
    else if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$b356b51e8337a02f;
    else if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$559c3a78b4889350;
    return comparison;
}
function $afd6034f160dea85$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $afd6034f160dea85$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $afd6034f160dea85$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $afd6034f160dea85$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $afd6034f160dea85$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($b2b661eb4d0f23aa$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $afd6034f160dea85$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


function $45bc2fb468e2e427$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $45bc2fb468e2e427$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $45bc2fb468e2e427$var$_typeof(o);
}
var $45bc2fb468e2e427$var$_excluded = [
    "x",
    "y"
];
function $45bc2fb468e2e427$var$_extends() {
    $45bc2fb468e2e427$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45bc2fb468e2e427$var$_extends.apply(this, arguments);
}
function $45bc2fb468e2e427$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45bc2fb468e2e427$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45bc2fb468e2e427$var$ownKeys(Object(t), !0).forEach(function(r) {
            $45bc2fb468e2e427$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45bc2fb468e2e427$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45bc2fb468e2e427$var$_defineProperty(obj, key, value) {
    key = $45bc2fb468e2e427$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $45bc2fb468e2e427$var$_toPropertyKey(arg) {
    var key = $45bc2fb468e2e427$var$_toPrimitive(arg, "string");
    return $45bc2fb468e2e427$var$_typeof(key) === "symbol" ? key : String(key);
}
function $45bc2fb468e2e427$var$_toPrimitive(input, hint) {
    if ($45bc2fb468e2e427$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($45bc2fb468e2e427$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $45bc2fb468e2e427$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $45bc2fb468e2e427$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $45bc2fb468e2e427$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, numbe, number, number]
function $45bc2fb468e2e427$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $45bc2fb468e2e427$var$_objectWithoutProperties(_ref, $45bc2fb468e2e427$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $45bc2fb468e2e427$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afd6034f160dea85$export$6428a7f2611ef1fa), $45bc2fb468e2e427$var$_extends({
        shapeType: "rectangle",
        propTransformer: $45bc2fb468e2e427$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}


var $22b628c8ce89e32e$var$_excluded = [
    "value",
    "background"
];
function $22b628c8ce89e32e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $22b628c8ce89e32e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $22b628c8ce89e32e$var$_typeof(o);
}
function $22b628c8ce89e32e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $22b628c8ce89e32e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $22b628c8ce89e32e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $22b628c8ce89e32e$var$_extends() {
    $22b628c8ce89e32e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22b628c8ce89e32e$var$_extends.apply(this, arguments);
}
function $22b628c8ce89e32e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $22b628c8ce89e32e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $22b628c8ce89e32e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $22b628c8ce89e32e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $22b628c8ce89e32e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $22b628c8ce89e32e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $22b628c8ce89e32e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $22b628c8ce89e32e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $22b628c8ce89e32e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $22b628c8ce89e32e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $22b628c8ce89e32e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $22b628c8ce89e32e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $22b628c8ce89e32e$var$_setPrototypeOf(subClass, superClass);
}
function $22b628c8ce89e32e$var$_setPrototypeOf(o, p) {
    $22b628c8ce89e32e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $22b628c8ce89e32e$var$_setPrototypeOf(o, p);
}
function $22b628c8ce89e32e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $22b628c8ce89e32e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $22b628c8ce89e32e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $22b628c8ce89e32e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $22b628c8ce89e32e$var$_possibleConstructorReturn(this, result);
    };
}
function $22b628c8ce89e32e$var$_possibleConstructorReturn(self, call) {
    if (call && ($22b628c8ce89e32e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $22b628c8ce89e32e$var$_assertThisInitialized(self);
}
function $22b628c8ce89e32e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $22b628c8ce89e32e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $22b628c8ce89e32e$var$_getPrototypeOf(o) {
    $22b628c8ce89e32e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $22b628c8ce89e32e$var$_getPrototypeOf(o);
}
function $22b628c8ce89e32e$var$_defineProperty(obj, key, value) {
    key = $22b628c8ce89e32e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22b628c8ce89e32e$var$_toPropertyKey(arg) {
    var key = $22b628c8ce89e32e$var$_toPrimitive(arg, "string");
    return $22b628c8ce89e32e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $22b628c8ce89e32e$var$_toPrimitive(input, hint) {
    if ($22b628c8ce89e32e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($22b628c8ce89e32e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $22b628c8ce89e32e$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $22b628c8ce89e32e$var$_inherits(Bar, _PureComponent);
    var _super = $22b628c8ce89e32e$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $22b628c8ce89e32e$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$var$_assertThisInitialized(_this), "id", (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-bar-'));
        $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $22b628c8ce89e32e$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $22b628c8ce89e32e$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45bc2fb468e2e427$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($b2b661eb4d0f23aa$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $22b628c8ce89e32e$var$_objectWithoutProperties(entry, $22b628c8ce89e32e$var$_excluded);
                    if (!background) return null;
                    var props = $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45bc2fb468e2e427$export$f19074a6842f9217), $22b628c8ce89e32e$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $d05ab0383decc723$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $3cf1854128f2220f$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $acfa11ccf9405f16$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $7fPBF.PureComponent));
$22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: true,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $3cf1854128f2220f$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $3cf1854128f2220f$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $3cf1854128f2220f$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $3cf1854128f2220f$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $3cf1854128f2220f$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $3cf1854128f2220f$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $22b628c8ce89e32e$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $7fPBF = parcelRequire("7fPBF");


var $d0da028ee74b26f9$exports = {};
var $45b93817b34c6273$exports = {};
var $98f335398853eaec$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $98f335398853eaec$var$nativeCeil = Math.ceil, $98f335398853eaec$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $98f335398853eaec$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $98f335398853eaec$var$nativeMax($98f335398853eaec$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$98f335398853eaec$exports = $98f335398853eaec$var$baseRange;



var $9ee486b4672c6c7a$exports = {};
var $2a055613c461e359$exports = {};
var $76bfc2718dc4d3fe$exports = {};
var $b7e64ab47e54e392$exports = {};
/** Used to match a single whitespace character. */ var $b7e64ab47e54e392$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $b7e64ab47e54e392$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $b7e64ab47e54e392$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$b7e64ab47e54e392$exports = $b7e64ab47e54e392$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $76bfc2718dc4d3fe$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $76bfc2718dc4d3fe$var$baseTrim(string) {
    return string ? string.slice(0, $b7e64ab47e54e392$exports(string) + 1).replace($76bfc2718dc4d3fe$var$reTrimStart, '') : string;
}
$76bfc2718dc4d3fe$exports = $76bfc2718dc4d3fe$var$baseTrim;




/** Used as references for various `Number` constants. */ var $2a055613c461e359$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $2a055613c461e359$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2a055613c461e359$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2a055613c461e359$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2a055613c461e359$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2a055613c461e359$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ff68483b1b673897$exports(value)) return $2a055613c461e359$var$NAN;
    if ($7aa8549693d433a8$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $7aa8549693d433a8$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $76bfc2718dc4d3fe$exports(value);
    var isBinary = $2a055613c461e359$var$reIsBinary.test(value);
    return isBinary || $2a055613c461e359$var$reIsOctal.test(value) ? $2a055613c461e359$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2a055613c461e359$var$reIsBadHex.test(value) ? $2a055613c461e359$var$NAN : +value;
}
$2a055613c461e359$exports = $2a055613c461e359$var$toNumber;


/** Used as references for various `Number` constants. */ var $9ee486b4672c6c7a$var$INFINITY = 1 / 0, $9ee486b4672c6c7a$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $9ee486b4672c6c7a$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $2a055613c461e359$exports(value);
    if (value === $9ee486b4672c6c7a$var$INFINITY || value === -$9ee486b4672c6c7a$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $9ee486b4672c6c7a$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$9ee486b4672c6c7a$exports = $9ee486b4672c6c7a$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $45b93817b34c6273$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $88c9cc1e8f9f4fbf$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $9ee486b4672c6c7a$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $9ee486b4672c6c7a$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $9ee486b4672c6c7a$exports(step);
        return $98f335398853eaec$exports(start, end, step, fromRight);
    };
}
$45b93817b34c6273$exports = $45b93817b34c6273$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d0da028ee74b26f9$var$range = $45b93817b34c6273$exports();
$d0da028ee74b26f9$exports = $d0da028ee74b26f9$var$range;




var $ec572136d1d3e1b1$exports = {};
var $0331819cee2e8d1e$exports = {};

var $a449547b9d5e1146$exports = {};

var $2Znjj = parcelRequire("2Znjj");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $a449547b9d5e1146$var$now = function() {
    return $2Znjj.Date.now();
};
$a449547b9d5e1146$exports = $a449547b9d5e1146$var$now;



/** Error message constants. */ var $0331819cee2e8d1e$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0331819cee2e8d1e$var$nativeMax = Math.max, $0331819cee2e8d1e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0331819cee2e8d1e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($0331819cee2e8d1e$var$FUNC_ERROR_TEXT);
    wait = $2a055613c461e359$exports(wait) || 0;
    if ($7aa8549693d433a8$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $0331819cee2e8d1e$var$nativeMax($2a055613c461e359$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $0331819cee2e8d1e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $a449547b9d5e1146$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($a449547b9d5e1146$exports());
    }
    function debounced() {
        var time = $a449547b9d5e1146$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$0331819cee2e8d1e$exports = $0331819cee2e8d1e$var$debounce;



/** Error message constants. */ var $ec572136d1d3e1b1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ec572136d1d3e1b1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ec572136d1d3e1b1$var$FUNC_ERROR_TEXT);
    if ($7aa8549693d433a8$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $0331819cee2e8d1e$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$ec572136d1d3e1b1$exports = $ec572136d1d3e1b1$var$throttle;


var $ae7ce9576f660715$exports = {};
var $a6cbb4c1b7988215$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a6cbb4c1b7988215$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$45a6a99a8378a8ba$exports(collection)) {
            var iteratee = $6981623866a9ed6c$exports(predicate, 3);
            collection = $09f6a70b406610c7$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$a6cbb4c1b7988215$exports = $a6cbb4c1b7988215$var$createFind;


var $87ee5a0674d683f4$exports = {};


var $35b3ea8ed6837cde$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $35b3ea8ed6837cde$var$toInteger(value) {
    var result = $9ee486b4672c6c7a$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$35b3ea8ed6837cde$exports = $35b3ea8ed6837cde$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $87ee5a0674d683f4$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $87ee5a0674d683f4$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $35b3ea8ed6837cde$exports(fromIndex);
    if (index < 0) index = $87ee5a0674d683f4$var$nativeMax(length + index, 0);
    return $f64f1f8d62f85551$exports(array, $6981623866a9ed6c$exports(predicate, 3), index);
}
$87ee5a0674d683f4$exports = $87ee5a0674d683f4$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $ae7ce9576f660715$var$find = $a6cbb4c1b7988215$exports($87ee5a0674d683f4$exports);
$ae7ce9576f660715$exports = $ae7ce9576f660715$var$find;


var $8ae190449f594000$exports = {};
var $6c2dc534910aefa8$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $6c2dc534910aefa8$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$6c2dc534910aefa8$exports = $6c2dc534910aefa8$var$arrayEvery;


var $39b5df645e80b48c$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $39b5df645e80b48c$var$baseEvery(collection, predicate) {
    var result = true;
    $1d1f09e624f3f9a8$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$39b5df645e80b48c$exports = $39b5df645e80b48c$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $8ae190449f594000$var$every(collection, predicate, guard) {
    var func = $e5a6efdaaf0e5707$exports(collection) ? $6c2dc534910aefa8$exports : $39b5df645e80b48c$exports;
    if (guard && $88c9cc1e8f9f4fbf$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6981623866a9ed6c$exports(predicate, 3));
}
$8ae190449f594000$exports = $8ae190449f594000$var$every;







var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");




function $c818619936319da7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c818619936319da7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c818619936319da7$var$_typeof(o);
}
function $c818619936319da7$var$_slicedToArray(arr, i) {
    return $c818619936319da7$var$_arrayWithHoles(arr) || $c818619936319da7$var$_iterableToArrayLimit(arr, i) || $c818619936319da7$var$_unsupportedIterableToArray(arr, i) || $c818619936319da7$var$_nonIterableRest();
}
function $c818619936319da7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c818619936319da7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c818619936319da7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c818619936319da7$var$_arrayLikeToArray(o, minLen);
}
function $c818619936319da7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c818619936319da7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c818619936319da7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c818619936319da7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c818619936319da7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c818619936319da7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c818619936319da7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c818619936319da7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c818619936319da7$var$_defineProperty(obj, key, value) {
    key = $c818619936319da7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c818619936319da7$var$_toPropertyKey(arg) {
    var key = $c818619936319da7$var$_toPrimitive(arg, "string");
    return $c818619936319da7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c818619936319da7$var$_toPrimitive(input, hint) {
    if ($c818619936319da7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c818619936319da7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c818619936319da7$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $ddf2636240ab70e2$export$402a499e1ea44294)(value[0]) && (0, $ddf2636240ab70e2$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $c818619936319da7$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($08c68625964a32b5$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $c818619936319da7$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $c818619936319da7$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c818619936319da7$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $ddf2636240ab70e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $ddf2636240ab70e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c818619936319da7$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $c818619936319da7$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $7fPBF = parcelRequire("7fPBF");




function $96e9624e62a8a593$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $96e9624e62a8a593$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $96e9624e62a8a593$var$_typeof(o);
}
function $96e9624e62a8a593$var$_defineProperty(obj, key, value) {
    key = $96e9624e62a8a593$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96e9624e62a8a593$var$_toPropertyKey(arg) {
    var key = $96e9624e62a8a593$var$_toPrimitive(arg, "string");
    return $96e9624e62a8a593$var$_typeof(key) === "symbol" ? key : String(key);
}
function $96e9624e62a8a593$var$_toPrimitive(input, hint) {
    if ($96e9624e62a8a593$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($96e9624e62a8a593$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $96e9624e62a8a593$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $96e9624e62a8a593$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $96e9624e62a8a593$export$46aee7ef09f78756(_ref) {
    var _clsx;
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $07a883fe7c352c85$export$2e2bcd8739ae039)($96e9624e62a8a593$var$CSS_CLASS_PREFIX, (_clsx = {}, $96e9624e62a8a593$var$_defineProperty(_clsx, "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-right"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $96e9624e62a8a593$var$_defineProperty(_clsx, "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-left"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $96e9624e62a8a593$var$_defineProperty(_clsx, "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-bottom"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $96e9624e62a8a593$var$_defineProperty(_clsx, "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-top"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _clsx));
}
function $96e9624e62a8a593$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $96e9624e62a8a593$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return (0, $f984d770f53b3c67$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    });
}
function $96e9624e62a8a593$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $96e9624e62a8a593$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $96e9624e62a8a593$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $96e9624e62a8a593$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $96e9624e62a8a593$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $96e9624e62a8a593$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $769d2a0825780eed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $769d2a0825780eed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $769d2a0825780eed$var$_typeof(o);
}
function $769d2a0825780eed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $769d2a0825780eed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $769d2a0825780eed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $769d2a0825780eed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $769d2a0825780eed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $769d2a0825780eed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $769d2a0825780eed$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $769d2a0825780eed$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $769d2a0825780eed$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $769d2a0825780eed$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $769d2a0825780eed$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $769d2a0825780eed$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $769d2a0825780eed$var$_setPrototypeOf(subClass, superClass);
}
function $769d2a0825780eed$var$_setPrototypeOf(o, p) {
    $769d2a0825780eed$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $769d2a0825780eed$var$_setPrototypeOf(o, p);
}
function $769d2a0825780eed$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $769d2a0825780eed$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $769d2a0825780eed$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $769d2a0825780eed$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $769d2a0825780eed$var$_possibleConstructorReturn(this, result);
    };
}
function $769d2a0825780eed$var$_possibleConstructorReturn(self, call) {
    if (call && ($769d2a0825780eed$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $769d2a0825780eed$var$_assertThisInitialized(self);
}
function $769d2a0825780eed$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $769d2a0825780eed$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $769d2a0825780eed$var$_getPrototypeOf(o) {
    $769d2a0825780eed$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $769d2a0825780eed$var$_getPrototypeOf(o);
}
function $769d2a0825780eed$var$_defineProperty(obj, key, value) {
    key = $769d2a0825780eed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $769d2a0825780eed$var$_toPropertyKey(arg) {
    var key = $769d2a0825780eed$var$_toPrimitive(arg, "string");
    return $769d2a0825780eed$var$_typeof(key) === "symbol" ? key : String(key);
}
function $769d2a0825780eed$var$_toPrimitive(input, hint) {
    if ($769d2a0825780eed$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($769d2a0825780eed$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $769d2a0825780eed$var$EPSILON = 1;
var $769d2a0825780eed$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $769d2a0825780eed$var$_inherits(TooltipBoundingBox, _PureComponent);
    var _super = $769d2a0825780eed$var$_createSuper(TooltipBoundingBox);
    function TooltipBoundingBox() {
        var _this;
        $769d2a0825780eed$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $769d2a0825780eed$var$_defineProperty($769d2a0825780eed$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $769d2a0825780eed$var$_defineProperty($769d2a0825780eed$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        $769d2a0825780eed$var$_defineProperty($769d2a0825780eed$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $769d2a0825780eed$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $769d2a0825780eed$var$EPSILON || Math.abs(box.height - this.lastBoundingBox.height) > $769d2a0825780eed$var$EPSILON) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $96e9624e62a8a593$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: {
                        height: this.lastBoundingBox.height,
                        width: this.lastBoundingBox.width
                    },
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $769d2a0825780eed$var$_objectSpread($769d2a0825780eed$var$_objectSpread($769d2a0825780eed$var$_objectSpread({}, isAnimationActive && active && (0, $f984d770f53b3c67$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    tabIndex: -1,
                    role: "dialog",
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $7fPBF.PureComponent));




function $9fa097d1de474101$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9fa097d1de474101$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9fa097d1de474101$var$_typeof(o);
}
function $9fa097d1de474101$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fa097d1de474101$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fa097d1de474101$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9fa097d1de474101$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fa097d1de474101$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fa097d1de474101$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9fa097d1de474101$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9fa097d1de474101$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9fa097d1de474101$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9fa097d1de474101$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9fa097d1de474101$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9fa097d1de474101$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9fa097d1de474101$var$_setPrototypeOf(subClass, superClass);
}
function $9fa097d1de474101$var$_setPrototypeOf(o, p) {
    $9fa097d1de474101$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9fa097d1de474101$var$_setPrototypeOf(o, p);
}
function $9fa097d1de474101$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9fa097d1de474101$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9fa097d1de474101$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9fa097d1de474101$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9fa097d1de474101$var$_possibleConstructorReturn(this, result);
    };
}
function $9fa097d1de474101$var$_possibleConstructorReturn(self, call) {
    if (call && ($9fa097d1de474101$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9fa097d1de474101$var$_assertThisInitialized(self);
}
function $9fa097d1de474101$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9fa097d1de474101$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9fa097d1de474101$var$_getPrototypeOf(o) {
    $9fa097d1de474101$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9fa097d1de474101$var$_getPrototypeOf(o);
}
function $9fa097d1de474101$var$_defineProperty(obj, key, value) {
    key = $9fa097d1de474101$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9fa097d1de474101$var$_toPropertyKey(arg) {
    var key = $9fa097d1de474101$var$_toPrimitive(arg, "string");
    return $9fa097d1de474101$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9fa097d1de474101$var$_toPrimitive(input, hint) {
    if ($9fa097d1de474101$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9fa097d1de474101$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9fa097d1de474101$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $9fa097d1de474101$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c818619936319da7$export$6fe33945eebf9ac8), props);
}
var $9fa097d1de474101$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $9fa097d1de474101$var$_inherits(Tooltip, _PureComponent);
    var _super = $9fa097d1de474101$var$_createSuper(Tooltip);
    function Tooltip() {
        $9fa097d1de474101$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $9fa097d1de474101$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $9df57fcd3e3e7338$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $9fa097d1de474101$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $769d2a0825780eed$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $9fa097d1de474101$var$renderContent(content, $9fa097d1de474101$var$_objectSpread($9fa097d1de474101$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $7fPBF.PureComponent));
$9fa097d1de474101$var$_defineProperty($9fa097d1de474101$export$28c660c63b792dea, "displayName", 'Tooltip');
$9fa097d1de474101$var$_defineProperty($9fa097d1de474101$export$28c660c63b792dea, "defaultProps", {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $7fPBF = parcelRequire("7fPBF");



function $22ef29953161e37f$var$_extends() {
    $22ef29953161e37f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22ef29953161e37f$var$_extends.apply(this, arguments);
}
var $22ef29953161e37f$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", $22ef29953161e37f$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, false), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $7fPBF = parcelRequire("7fPBF");








function $f1c27aa6db6af3a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1c27aa6db6af3a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1c27aa6db6af3a8$var$_typeof(o);
}
function $f1c27aa6db6af3a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1c27aa6db6af3a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1c27aa6db6af3a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f1c27aa6db6af3a8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1c27aa6db6af3a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1c27aa6db6af3a8$var$_defineProperty(obj, key, value) {
    key = $f1c27aa6db6af3a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f1c27aa6db6af3a8$var$_toPropertyKey(arg) {
    var key = $f1c27aa6db6af3a8$var$_toPrimitive(arg, "string");
    return $f1c27aa6db6af3a8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f1c27aa6db6af3a8$var$_toPrimitive(input, hint) {
    if ($f1c27aa6db6af3a8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f1c27aa6db6af3a8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f1c27aa6db6af3a8$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $f1c27aa6db6af3a8$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $f1c27aa6db6af3a8$var$PREFIX_LIST.reduce(function(res, entry) {
        return $f1c27aa6db6af3a8$var$_objectSpread($f1c27aa6db6af3a8$var$_objectSpread({}, res), {}, $f1c27aa6db6af3a8$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $292adb4d61b7aa4f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $292adb4d61b7aa4f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $292adb4d61b7aa4f$var$_typeof(o);
}
function $292adb4d61b7aa4f$var$_extends() {
    $292adb4d61b7aa4f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $292adb4d61b7aa4f$var$_extends.apply(this, arguments);
}
function $292adb4d61b7aa4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $292adb4d61b7aa4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $292adb4d61b7aa4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $292adb4d61b7aa4f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $292adb4d61b7aa4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $292adb4d61b7aa4f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $292adb4d61b7aa4f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $292adb4d61b7aa4f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $292adb4d61b7aa4f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $292adb4d61b7aa4f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $292adb4d61b7aa4f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $292adb4d61b7aa4f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $292adb4d61b7aa4f$var$_setPrototypeOf(subClass, superClass);
}
function $292adb4d61b7aa4f$var$_setPrototypeOf(o, p) {
    $292adb4d61b7aa4f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $292adb4d61b7aa4f$var$_setPrototypeOf(o, p);
}
function $292adb4d61b7aa4f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $292adb4d61b7aa4f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $292adb4d61b7aa4f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $292adb4d61b7aa4f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $292adb4d61b7aa4f$var$_possibleConstructorReturn(this, result);
    };
}
function $292adb4d61b7aa4f$var$_possibleConstructorReturn(self, call) {
    if (call && ($292adb4d61b7aa4f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $292adb4d61b7aa4f$var$_assertThisInitialized(self);
}
function $292adb4d61b7aa4f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $292adb4d61b7aa4f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $292adb4d61b7aa4f$var$_getPrototypeOf(o) {
    $292adb4d61b7aa4f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $292adb4d61b7aa4f$var$_getPrototypeOf(o);
}
function $292adb4d61b7aa4f$var$_defineProperty(obj, key, value) {
    key = $292adb4d61b7aa4f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $292adb4d61b7aa4f$var$_toPropertyKey(arg) {
    var key = $292adb4d61b7aa4f$var$_toPrimitive(arg, "string");
    return $292adb4d61b7aa4f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $292adb4d61b7aa4f$var$_toPrimitive(input, hint) {
    if ($292adb4d61b7aa4f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($292adb4d61b7aa4f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $292adb4d61b7aa4f$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $88853d08cf75746a$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($d0da028ee74b26f9$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $292adb4d61b7aa4f$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $292adb4d61b7aa4f$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $292adb4d61b7aa4f$var$_inherits(Brush, _PureComponent);
    var _super = $292adb4d61b7aa4f$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $292adb4d61b7aa4f$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $292adb4d61b7aa4f$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($292adb4d61b7aa4f$var$_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind($292adb4d61b7aa4f$var$_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    $292adb4d61b7aa4f$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $292adb4d61b7aa4f$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $292adb4d61b7aa4f$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $292adb4d61b7aa4f$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($292adb4d61b7aa4f$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $7fPBF.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $292adb4d61b7aa4f$var$_objectSpread($292adb4d61b7aa4f$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat(data[startIndex].name, ", Max value: ").concat(data[endIndex].name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $292adb4d61b7aa4f$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $292adb4d61b7aa4f$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.count(children) === 1;
                var style = (0, $f1c27aa6db6af3a8$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $292adb4d61b7aa4f$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $292adb4d61b7aa4f$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $7fPBF.PureComponent));
$292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$export$59bc2e3533b384a0, "displayName", 'Brush');
$292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $7fPBF = parcelRequire("7fPBF");






var $bbc849e695f215a7$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $473827dca5be40c4$exports = {};
var $f292b6a9dc727294$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f292b6a9dc727294$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2ce2ab6b1fb782e5$exports) $2ce2ab6b1fb782e5$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$f292b6a9dc727294$exports = $f292b6a9dc727294$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $473827dca5be40c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $6981623866a9ed6c$exports(iteratee, 3);
    $1bc609cd7a6fa424$exports(object, function(value, key, object) {
        $f292b6a9dc727294$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$473827dca5be40c4$exports = $473827dca5be40c4$var$mapValues;







function $251e5258b398e2e1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $251e5258b398e2e1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $251e5258b398e2e1$var$_typeof(o);
}
function $251e5258b398e2e1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $251e5258b398e2e1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $251e5258b398e2e1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $251e5258b398e2e1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $251e5258b398e2e1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $251e5258b398e2e1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $251e5258b398e2e1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $251e5258b398e2e1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $251e5258b398e2e1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $251e5258b398e2e1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $251e5258b398e2e1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $251e5258b398e2e1$var$_defineProperty(obj, key, value) {
    key = $251e5258b398e2e1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $251e5258b398e2e1$var$_toPropertyKey(arg) {
    var key = $251e5258b398e2e1$var$_toPrimitive(arg, "string");
    return $251e5258b398e2e1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $251e5258b398e2e1$var$_toPrimitive(input, hint) {
    if ($251e5258b398e2e1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($251e5258b398e2e1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $251e5258b398e2e1$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
            if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === 'no-gap') {
                var gap = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $3cf1854128f2220f$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $3cf1854128f2220f$export$9d80152e23bae434)(scale);
        var ticks = (0, $3cf1854128f2220f$export$ac086aaa4358d590)(scale, $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, result), {}, $251e5258b398e2e1$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $251e5258b398e2e1$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $251e5258b398e2e1$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $251e5258b398e2e1$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $251e5258b398e2e1$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $251e5258b398e2e1$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $251e5258b398e2e1$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$251e5258b398e2e1$var$_defineProperty($251e5258b398e2e1$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $251e5258b398e2e1$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, res), {}, $251e5258b398e2e1$var$_defineProperty({}, key, $251e5258b398e2e1$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($473827dca5be40c4$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8ae190449f594000$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $251e5258b398e2e1$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $251e5258b398e2e1$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $251e5258b398e2e1$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $f8879ac5aef728e5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f8879ac5aef728e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f8879ac5aef728e5$var$_typeof(o);
}
function $f8879ac5aef728e5$var$_extends() {
    $f8879ac5aef728e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8879ac5aef728e5$var$_extends.apply(this, arguments);
}
function $f8879ac5aef728e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8879ac5aef728e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8879ac5aef728e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f8879ac5aef728e5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8879ac5aef728e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8879ac5aef728e5$var$_defineProperty(obj, key, value) {
    key = $f8879ac5aef728e5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f8879ac5aef728e5$var$_toPropertyKey(arg) {
    var key = $f8879ac5aef728e5$var$_toPrimitive(arg, "string");
    return $f8879ac5aef728e5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f8879ac5aef728e5$var$_toPrimitive(input, hint) {
    if ($f8879ac5aef728e5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f8879ac5aef728e5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f8879ac5aef728e5$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function $f8879ac5aef728e5$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x);
    var isY = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y);
    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $f8879ac5aef728e5$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $f8879ac5aef728e5$var$_objectSpread($f8879ac5aef728e5$var$_objectSpread({
        clipPath: clipPath
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-dot', className)
    }, $f8879ac5aef728e5$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$f8879ac5aef728e5$export$aa7f0b0106bff39.displayName = 'ReferenceDot';
$f8879ac5aef728e5$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
$f8879ac5aef728e5$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), $f8879ac5aef728e5$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $7fPBF = parcelRequire("7fPBF");

var $4c52a951212eca00$exports = {};


var $77dee8425dbc99fc$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $77dee8425dbc99fc$var$baseSome(collection, predicate) {
    var result;
    $1d1f09e624f3f9a8$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$77dee8425dbc99fc$exports = $77dee8425dbc99fc$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $4c52a951212eca00$var$some(collection, predicate, guard) {
    var func = $e5a6efdaaf0e5707$exports(collection) ? $cf770c9228073fc0$exports : $77dee8425dbc99fc$exports;
    if (guard && $88c9cc1e8f9f4fbf$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6981623866a9ed6c$exports(predicate, 3));
}
$4c52a951212eca00$exports = $4c52a951212eca00$var$some;











var $7fPBF = parcelRequire("7fPBF");


var $280df0a24c8adb37$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($f7c4824aff4f58af$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});


function $d5acdec35ed0a35a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5acdec35ed0a35a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5acdec35ed0a35a$var$_typeof(o);
}
var $d5acdec35ed0a35a$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$482c85f2026f212e = /*#__PURE__*/ (0, $7fPBF.createContext)({});
var $d5acdec35ed0a35a$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$b18854f928720bc8 = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $d5acdec35ed0a35a$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $d5acdec35ed0a35a$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $280df0a24c8adb37$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $d5acdec35ed0a35a$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$e42cfe3f3988c70f);
};
function $d5acdec35ed0a35a$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $d5acdec35ed0a35a$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $d5acdec35ed0a35a$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $d5acdec35ed0a35a$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$29b7735f8b5653b2);
    return viewBox;
};
var $d5acdec35ed0a35a$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$482c85f2026f212e);
};
var $d5acdec35ed0a35a$export$8854f7ece606854b = function useChartWidth() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$3c3f0c9338cf7530);
};
var $d5acdec35ed0a35a$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$b18854f928720bc8);
};


function $bdc92f1f1adb58de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bdc92f1f1adb58de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bdc92f1f1adb58de$var$_typeof(o);
}
function $bdc92f1f1adb58de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bdc92f1f1adb58de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bdc92f1f1adb58de$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bdc92f1f1adb58de$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bdc92f1f1adb58de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bdc92f1f1adb58de$var$_defineProperty(obj, key, value) {
    key = $bdc92f1f1adb58de$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bdc92f1f1adb58de$var$_toPropertyKey(arg) {
    var key = $bdc92f1f1adb58de$var$_toPrimitive(arg, "string");
    return $bdc92f1f1adb58de$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bdc92f1f1adb58de$var$_toPrimitive(input, hint) {
    if ($bdc92f1f1adb58de$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bdc92f1f1adb58de$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bdc92f1f1adb58de$var$_slicedToArray(arr, i) {
    return $bdc92f1f1adb58de$var$_arrayWithHoles(arr) || $bdc92f1f1adb58de$var$_iterableToArrayLimit(arr, i) || $bdc92f1f1adb58de$var$_unsupportedIterableToArray(arr, i) || $bdc92f1f1adb58de$var$_nonIterableRest();
}
function $bdc92f1f1adb58de$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bdc92f1f1adb58de$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bdc92f1f1adb58de$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bdc92f1f1adb58de$var$_arrayLikeToArray(o, minLen);
}
function $bdc92f1f1adb58de$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bdc92f1f1adb58de$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bdc92f1f1adb58de$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bdc92f1f1adb58de$var$_extends() {
    $bdc92f1f1adb58de$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdc92f1f1adb58de$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $bdc92f1f1adb58de$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $bdc92f1f1adb58de$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $bdc92f1f1adb58de$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($4c52a951212eca00$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $bdc92f1f1adb58de$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $d5acdec35ed0a35a$export$71e825c43eae6ca6)();
    var xAxis = (0, $d5acdec35ed0a35a$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $d5acdec35ed0a35a$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $d5acdec35ed0a35a$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(fixedX);
    var isY = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $bdc92f1f1adb58de$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $bdc92f1f1adb58de$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $bdc92f1f1adb58de$var$_objectSpread($bdc92f1f1adb58de$var$_objectSpread({
        clipPath: clipPath
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $bdc92f1f1adb58de$var$renderLine(shape, lineProps), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(props, (0, $251e5258b398e2e1$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$bdc92f1f1adb58de$export$b2f28e248e7838eb.displayName = 'ReferenceLine';
$bdc92f1f1adb58de$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};



var $7fPBF = parcelRequire("7fPBF");










function $71c3f9de86e5dd82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71c3f9de86e5dd82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71c3f9de86e5dd82$var$_typeof(o);
}
function $71c3f9de86e5dd82$var$_extends() {
    $71c3f9de86e5dd82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71c3f9de86e5dd82$var$_extends.apply(this, arguments);
}
function $71c3f9de86e5dd82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71c3f9de86e5dd82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71c3f9de86e5dd82$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71c3f9de86e5dd82$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71c3f9de86e5dd82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71c3f9de86e5dd82$var$_defineProperty(obj, key, value) {
    key = $71c3f9de86e5dd82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71c3f9de86e5dd82$var$_toPropertyKey(arg) {
    var key = $71c3f9de86e5dd82$var$_toPrimitive(arg, "string");
    return $71c3f9de86e5dd82$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71c3f9de86e5dd82$var$_toPrimitive(input, hint) {
    if ($71c3f9de86e5dd82$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71c3f9de86e5dd82$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $71c3f9de86e5dd82$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $251e5258b398e2e1$export$c7964a5b9439ae62)(p1, p2);
};
function $71c3f9de86e5dd82$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $71c3f9de86e5dd82$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-area', className)
    }, $71c3f9de86e5dd82$export$b4ec4f050ce240b9.renderRect(shape, $71c3f9de86e5dd82$var$_objectSpread($71c3f9de86e5dd82$var$_objectSpread({
        clipPath: clipPath
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true)), rect)), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$71c3f9de86e5dd82$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';
$71c3f9de86e5dd82$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
$71c3f9de86e5dd82$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd9e03c5c06a0d41$export$4617fb02663045ef), $71c3f9de86e5dd82$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $0fbc7216156df216$var$_toConsumableArray(arr) {
    return $0fbc7216156df216$var$_arrayWithoutHoles(arr) || $0fbc7216156df216$var$_iterableToArray(arr) || $0fbc7216156df216$var$_unsupportedIterableToArray(arr) || $0fbc7216156df216$var$_nonIterableSpread();
}
function $0fbc7216156df216$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0fbc7216156df216$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0fbc7216156df216$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0fbc7216156df216$var$_arrayLikeToArray(o, minLen);
}
function $0fbc7216156df216$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0fbc7216156df216$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0fbc7216156df216$var$_arrayLikeToArray(arr);
}
function $0fbc7216156df216$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0fbc7216156df216$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $bdc92f1f1adb58de$export$b2f28e248e7838eb));
    var dots = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $f8879ac5aef728e5$export$aa7f0b0106bff39));
    var elements = [].concat($0fbc7216156df216$var$_toConsumableArray(lines), $0fbc7216156df216$var$_toConsumableArray(dots));
    var areas = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $71c3f9de86e5dd82$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $bbc849e695f215a7$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $bbc849e695f215a7$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[key1]) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $53c193f0ccf044aa$exports = {};
'use strict';
var $53c193f0ccf044aa$var$has = Object.prototype.hasOwnProperty, $53c193f0ccf044aa$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $53c193f0ccf044aa$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $53c193f0ccf044aa$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $53c193f0ccf044aa$var$Events().__proto__) $53c193f0ccf044aa$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $53c193f0ccf044aa$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $53c193f0ccf044aa$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $53c193f0ccf044aa$var$EE(fn, context || emitter, once), evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $53c193f0ccf044aa$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $53c193f0ccf044aa$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $53c193f0ccf044aa$var$EventEmitter() {
    this._events = new $53c193f0ccf044aa$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($53c193f0ccf044aa$var$has.call(events, name)) names.push($53c193f0ccf044aa$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $53c193f0ccf044aa$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $53c193f0ccf044aa$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $53c193f0ccf044aa$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $53c193f0ccf044aa$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $53c193f0ccf044aa$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
        if (this._events[evt]) $53c193f0ccf044aa$var$clearEvent(this, evt);
    } else {
        this._events = new $53c193f0ccf044aa$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$53c193f0ccf044aa$var$EventEmitter.prototype.off = $53c193f0ccf044aa$var$EventEmitter.prototype.removeListener;
$53c193f0ccf044aa$var$EventEmitter.prototype.addListener = $53c193f0ccf044aa$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$53c193f0ccf044aa$var$EventEmitter.prefixed = $53c193f0ccf044aa$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$53c193f0ccf044aa$var$EventEmitter.EventEmitter = $53c193f0ccf044aa$var$EventEmitter;
$53c193f0ccf044aa$exports = $53c193f0ccf044aa$var$EventEmitter;


var $6164c1f84130ff0f$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($53c193f0ccf044aa$exports)))();
var $6164c1f84130ff0f$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $4171429008abae73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4171429008abae73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4171429008abae73$var$_typeof(o);
}
function $4171429008abae73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4171429008abae73$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4171429008abae73$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4171429008abae73$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4171429008abae73$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4171429008abae73$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4171429008abae73$var$_defineProperty(obj, key, value) {
    key = $4171429008abae73$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4171429008abae73$var$_toPropertyKey(arg) {
    var key = $4171429008abae73$var$_toPrimitive(arg, "string");
    return $4171429008abae73$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4171429008abae73$var$_toPrimitive(input, hint) {
    if ($4171429008abae73$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4171429008abae73$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4171429008abae73$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $4171429008abae73$var$_classCallCheck(this, AccessibilityManager);
        $4171429008abae73$var$_defineProperty(this, "activeIndex", 0);
        $4171429008abae73$var$_defineProperty(this, "coordinateList", []);
        $4171429008abae73$var$_defineProperty(this, "layout", 'horizontal');
    }
    $4171429008abae73$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $d741426732739030$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domainStart) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");







function $24f9e03e793c5e59$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24f9e03e793c5e59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24f9e03e793c5e59$var$_typeof(o);
}
function $24f9e03e793c5e59$var$_extends() {
    $24f9e03e793c5e59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24f9e03e793c5e59$var$_extends.apply(this, arguments);
}
function $24f9e03e793c5e59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24f9e03e793c5e59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24f9e03e793c5e59$var$ownKeys(Object(t), !0).forEach(function(r) {
            $24f9e03e793c5e59$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24f9e03e793c5e59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24f9e03e793c5e59$var$_defineProperty(obj, key, value) {
    key = $24f9e03e793c5e59$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24f9e03e793c5e59$var$_toPropertyKey(arg) {
    var key = $24f9e03e793c5e59$var$_toPrimitive(arg, "string");
    return $24f9e03e793c5e59$var$_typeof(key) === "symbol" ? key : String(key);
}
function $24f9e03e793c5e59$var$_toPrimitive(input, hint) {
    if ($24f9e03e793c5e59$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($24f9e03e793c5e59$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $24f9e03e793c5e59$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $922af94be54ea802$exports.curveBasisClosed),
    curveBasisOpen: (0, $922af94be54ea802$exports.curveBasisOpen),
    curveBasis: (0, $922af94be54ea802$exports.curveBasis),
    curveBumpX: (0, $922af94be54ea802$exports.curveBumpX),
    curveBumpY: (0, $922af94be54ea802$exports.curveBumpY),
    curveLinearClosed: (0, $922af94be54ea802$exports.curveLinearClosed),
    curveLinear: (0, $922af94be54ea802$exports.curveLinear),
    curveMonotoneX: (0, $922af94be54ea802$exports.curveMonotoneX),
    curveMonotoneY: (0, $922af94be54ea802$exports.curveMonotoneY),
    curveNatural: (0, $922af94be54ea802$exports.curveNatural),
    curveStep: (0, $922af94be54ea802$exports.curveStep),
    curveStepAfter: (0, $922af94be54ea802$exports.curveStepAfter),
    curveStepBefore: (0, $922af94be54ea802$exports.curveStepBefore)
};
var $24f9e03e793c5e59$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $24f9e03e793c5e59$var$getX = function getX(p) {
    return p.x;
};
var $24f9e03e793c5e59$var$getY = function getY(p) {
    return p.y;
};
var $24f9e03e793c5e59$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($cb4a4ca6f49cb945$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $24f9e03e793c5e59$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $24f9e03e793c5e59$var$CURVE_FACTORIES[name] || (0, $922af94be54ea802$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $24f9e03e793c5e59$var$getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $24f9e03e793c5e59$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $24f9e03e793c5e59$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $24f9e03e793c5e59$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $24f9e03e793c5e59$var$_objectSpread($24f9e03e793c5e59$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $922af94be54ea802$exports.area)().y($24f9e03e793c5e59$var$getY).x1($24f9e03e793c5e59$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $922af94be54ea802$exports.area)().x($24f9e03e793c5e59$var$getX).y1($24f9e03e793c5e59$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($24f9e03e793c5e59$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $922af94be54ea802$exports.area)().y($24f9e03e793c5e59$var$getY).x1($24f9e03e793c5e59$var$getX).x0(baseLine);
    else if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $922af94be54ea802$exports.area)().x($24f9e03e793c5e59$var$getX).y1($24f9e03e793c5e59$var$getY).y0(baseLine);
    else lineFunction = (0, $922af94be54ea802$exports.line)().x($24f9e03e793c5e59$var$getX).y($24f9e03e793c5e59$var$getY);
    lineFunction.defined($24f9e03e793c5e59$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $24f9e03e793c5e59$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $24f9e03e793c5e59$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $24f9e03e793c5e59$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, false), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $7fPBF = parcelRequire("7fPBF");



function $4f194ae349c46227$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4f194ae349c46227$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4f194ae349c46227$var$_typeof(o);
}
var $4f194ae349c46227$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $4f194ae349c46227$var$_extends() {
    $4f194ae349c46227$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f194ae349c46227$var$_extends.apply(this, arguments);
}
function $4f194ae349c46227$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f194ae349c46227$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f194ae349c46227$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4f194ae349c46227$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f194ae349c46227$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f194ae349c46227$var$_defineProperty(obj, key, value) {
    key = $4f194ae349c46227$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f194ae349c46227$var$_toPropertyKey(arg) {
    var key = $4f194ae349c46227$var$_toPrimitive(arg, "string");
    return $4f194ae349c46227$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4f194ae349c46227$var$_toPrimitive(input, hint) {
    if ($4f194ae349c46227$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4f194ae349c46227$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4f194ae349c46227$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4f194ae349c46227$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4f194ae349c46227$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4f194ae349c46227$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $4f194ae349c46227$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $4f194ae349c46227$var$_objectWithoutProperties(_ref, $4f194ae349c46227$var$_excluded);
    var props = $4f194ae349c46227$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(top) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $4f194ae349c46227$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $4f194ae349c46227$var$getPath(x, y, width, height, top, left)
    }));
};


function $adddd1a311f8ef99$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $97c1bd3db26bd446$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $fbd7d93a2a8fab77$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $97c1bd3db26bd446$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $ec94bb69d25a9f22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec94bb69d25a9f22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec94bb69d25a9f22$var$_typeof(o);
}
function $ec94bb69d25a9f22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec94bb69d25a9f22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec94bb69d25a9f22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec94bb69d25a9f22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec94bb69d25a9f22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec94bb69d25a9f22$var$_defineProperty(obj, key, value) {
    key = $ec94bb69d25a9f22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec94bb69d25a9f22$var$_toPropertyKey(arg) {
    var key = $ec94bb69d25a9f22$var$_toPrimitive(arg, "string");
    return $ec94bb69d25a9f22$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ec94bb69d25a9f22$var$_toPrimitive(input, hint) {
    if ($ec94bb69d25a9f22$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ec94bb69d25a9f22$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ec94bb69d25a9f22$export$b6a79797ad180576(props) {
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $4f194ae349c46227$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $adddd1a311f8ef99$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $dd9e03c5c06a0d41$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $97c1bd3db26bd446$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $dd92401041fdb928$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $fbd7d93a2a8fab77$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(element.props.cursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: 'recharts-tooltip-cursor'
    });
    return /*#__PURE__*/ (0, $7fPBF.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $7fPBF.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $7fPBF.createElement)(cursorComp, cursorProps);
}



var $331f71c4500fe679$var$_excluded = [
    "item"
], $331f71c4500fe679$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $331f71c4500fe679$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $331f71c4500fe679$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $331f71c4500fe679$var$_typeof(o);
}
function $331f71c4500fe679$var$_extends() {
    $331f71c4500fe679$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $331f71c4500fe679$var$_extends.apply(this, arguments);
}
function $331f71c4500fe679$var$_slicedToArray(arr, i) {
    return $331f71c4500fe679$var$_arrayWithHoles(arr) || $331f71c4500fe679$var$_iterableToArrayLimit(arr, i) || $331f71c4500fe679$var$_unsupportedIterableToArray(arr, i) || $331f71c4500fe679$var$_nonIterableRest();
}
function $331f71c4500fe679$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $331f71c4500fe679$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $331f71c4500fe679$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $331f71c4500fe679$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $331f71c4500fe679$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $331f71c4500fe679$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $331f71c4500fe679$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $331f71c4500fe679$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $331f71c4500fe679$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $331f71c4500fe679$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $331f71c4500fe679$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $331f71c4500fe679$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $331f71c4500fe679$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $331f71c4500fe679$var$_setPrototypeOf(subClass, superClass);
}
function $331f71c4500fe679$var$_setPrototypeOf(o, p) {
    $331f71c4500fe679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $331f71c4500fe679$var$_setPrototypeOf(o, p);
}
function $331f71c4500fe679$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $331f71c4500fe679$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $331f71c4500fe679$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $331f71c4500fe679$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $331f71c4500fe679$var$_possibleConstructorReturn(this, result);
    };
}
function $331f71c4500fe679$var$_possibleConstructorReturn(self, call) {
    if (call && ($331f71c4500fe679$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $331f71c4500fe679$var$_assertThisInitialized(self);
}
function $331f71c4500fe679$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $331f71c4500fe679$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $331f71c4500fe679$var$_getPrototypeOf(o) {
    $331f71c4500fe679$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $331f71c4500fe679$var$_getPrototypeOf(o);
}
function $331f71c4500fe679$var$_toConsumableArray(arr) {
    return $331f71c4500fe679$var$_arrayWithoutHoles(arr) || $331f71c4500fe679$var$_iterableToArray(arr) || $331f71c4500fe679$var$_unsupportedIterableToArray(arr) || $331f71c4500fe679$var$_nonIterableSpread();
}
function $331f71c4500fe679$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $331f71c4500fe679$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $331f71c4500fe679$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $331f71c4500fe679$var$_arrayLikeToArray(o, minLen);
}
function $331f71c4500fe679$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $331f71c4500fe679$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $331f71c4500fe679$var$_arrayLikeToArray(arr);
}
function $331f71c4500fe679$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $331f71c4500fe679$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $331f71c4500fe679$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $331f71c4500fe679$var$ownKeys(Object(t), !0).forEach(function(r) {
            $331f71c4500fe679$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $331f71c4500fe679$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $331f71c4500fe679$var$_defineProperty(obj, key, value) {
    key = $331f71c4500fe679$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $331f71c4500fe679$var$_toPropertyKey(arg) {
    var key = $331f71c4500fe679$var$_toPrimitive(arg, "string");
    return $331f71c4500fe679$var$_typeof(key) === "symbol" ? key : String(key);
}
function $331f71c4500fe679$var$_toPrimitive(input, hint) {
    if ($331f71c4500fe679$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($331f71c4500fe679$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $331f71c4500fe679$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $331f71c4500fe679$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $331f71c4500fe679$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $331f71c4500fe679$var$renderAsIs(element) {
    return element;
}
var $331f71c4500fe679$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $331f71c4500fe679$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, rangeObj), (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, rangeObj), (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $331f71c4500fe679$var$originCoordinate;
};
var $331f71c4500fe679$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($331f71c4500fe679$var$_toConsumableArray(result), $331f71c4500fe679$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dataStartIndex) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $331f71c4500fe679$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $331f71c4500fe679$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $331f71c4500fe679$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($331f71c4500fe679$var$_toConsumableArray(result), [
            (0, $3cf1854128f2220f$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $331f71c4500fe679$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $331f71c4500fe679$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $3cf1854128f2220f$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $331f71c4500fe679$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $331f71c4500fe679$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $331f71c4500fe679$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $3cf1854128f2220f$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $d741426732739030$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $331f71c4500fe679$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $ddf2636240ab70e2$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($d0da028ee74b26f9$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $3cf1854128f2220f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($331f71c4500fe679$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $3cf1854128f2220f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(entry) ? finalDomain : [].concat($331f71c4500fe679$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $3cf1854128f2220f$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($d0da028ee74b26f9$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $3cf1854128f2220f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $3cf1854128f2220f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $331f71c4500fe679$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $3cf1854128f2220f$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $331f71c4500fe679$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($d0da028ee74b26f9$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $3cf1854128f2220f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(originalDomain, (0, $3cf1854128f2220f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))($331f71c4500fe679$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $331f71c4500fe679$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $331f71c4500fe679$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $331f71c4500fe679$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $331f71c4500fe679$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($08c68625964a32b5$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $331f71c4500fe679$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $331f71c4500fe679$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $331f71c4500fe679$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $331f71c4500fe679$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
    var legendItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $559b693b6a1d5199$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $3cf1854128f2220f$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
var $331f71c4500fe679$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $331f71c4500fe679$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $331f71c4500fe679$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $3cf1854128f2220f$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type, _objectSpread6;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $8dc350a4186296d3$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $331f71c4500fe679$var$_defineProperty(_objectSpread6, entry.axisType, axis), $331f71c4500fe679$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $3cf1854128f2220f$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $3cf1854128f2220f$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, pos), {}, {
                        position: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, composedFn($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $331f71c4500fe679$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $331f71c4500fe679$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $331f71c4500fe679$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $86b14aaa4b2f228f$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $86b14aaa4b2f228f$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $331f71c4500fe679$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $3cf1854128f2220f$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, name, $331f71c4500fe679$var$getAxisMap(props, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $331f71c4500fe679$var$calculateOffset($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $331f71c4500fe679$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $331f71c4500fe679$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $331f71c4500fe679$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $331f71c4500fe679$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $4171429008abae73$export$a2c2de1efa8671eb)());
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($331f71c4500fe679$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $331f71c4500fe679$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $86b14aaa4b2f228f$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).emit((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($331f71c4500fe679$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $331f71c4500fe679$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $331f71c4500fe679$var$originCoordinate;
                    _this.setState($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ec94bb69d25a9f22$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state4 = _this.state, xAxisMap = _this$state4.xAxisMap, yAxisMap = _this$state4.yAxisMap, offset = _this$state4.offset;
                var xAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($ae7ce9576f660715$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8ae190449f594000$exports)))(axis.domain, Number.isFinite);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    key: element.key || 'grid',
                    x: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator
                });
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state5 = _this.state, radiusAxisMap = _this$state5.radiusAxisMap, angleAxisMap = _this$state5.angleAxisMap;
                var radiusAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $7bbd89b69def67ea$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $331f71c4500fe679$var$_objectWithoutProperties(props, $331f71c4500fe679$var$_excluded);
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(item, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var children = _this.props.children;
                var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state6 = _this.state, isTooltipActive = _this$state6.isTooltipActive, activeCoordinate = _this$state6.activeCoordinate, activePayload = _this$state6.activePayload, activeLabel = _this$state6.activeLabel, offset = _this$state6.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(tooltipItem, {
                    viewBox: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state7 = _this.state, offset = _this$state7.offset, dataStartIndex = _this$state7.dataStartIndex, dataEndIndex = _this$state7.dataEndIndex, updateId = _this$state7.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $331f71c4500fe679$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state8 = _this.state, xAxisMap = _this$state8.xAxisMap, yAxisMap = _this$state8.yAxisMap, offset = _this$state8.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $3cf1854128f2220f$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(activeDot, false)), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state9 = _this.state, isTooltipActive = _this$state9.isTooltipActive, tooltipAxis = _this$state9.tooltipAxis, activeTooltipIndex = _this$state9.activeTooltipIndex, activeLabel = _this$state9.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($331f71c4500fe679$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $7fPBF.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: _this.renderGrid,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                YAxis: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ec572136d1d3e1b1$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $331f71c4500fe679$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props4 = this.props, children = _this$props4.children, data = _this$props4.data, height = _this$props4.height, layout = _this$props4.layout;
                    var tooltipElem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $331f71c4500fe679$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $86b14aaa4b2f228f$export$acdc716e08572f94)([
                        (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(prevProps.children, (0, $9fa097d1de474101$export$28c660c63b792dea))
                    ], [
                        (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(this.props.children, (0, $9fa097d1de474101$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(this.props.children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $5da910530c0379f8$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state10 = this.state, xAxisMap = _this$state10.xAxisMap, yAxisMap = _this$state10.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $331f71c4500fe679$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state11 = this.state, angleAxisMap = _this$state11.angleAxisMap, radiusAxisMap = _this$state11.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $2f494a175d2955a8$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).on((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).removeListener((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $86b14aaa4b2f228f$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $331f71c4500fe679$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, res), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $331f71c4500fe679$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, res), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state12 = this.state, formattedGraphicalItems = _this$state12.formattedGraphicalItems, activeItem = _this$state12.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $dd9e03c5c06a0d41$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $2f494a175d2955a8$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $afd6034f160dea85$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $afd6034f160dea85$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $afd6034f160dea85$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $afd6034f160dea85$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $afd6034f160dea85$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $86b14aaa4b2f228f$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, width = _this$props5.width, height = _this$props5.height, style = _this$props5.style, compact = _this$props5.compact, title = _this$props5.title, desc = _this$props5.desc, others = $331f71c4500fe679$var$_objectWithoutProperties(_this$props5, $331f71c4500fe679$var$_excluded2);
                    var attrs = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), $331f71c4500fe679$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $86b14aaa4b2f228f$export$a98d6da55570cb82)(children, this.renderMap));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'img';
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d5acdec35ed0a35a$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", $331f71c4500fe679$var$_extends({
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $331f71c4500fe679$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), $331f71c4500fe679$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $331f71c4500fe679$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $86b14aaa4b2f228f$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $7fPBF.Component)), $331f71c4500fe679$var$_defineProperty(_class, "displayName", chartName), $331f71c4500fe679$var$_defineProperty(_class, "defaultProps", $331f71c4500fe679$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), $331f71c4500fe679$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $331f71c4500fe679$export$e5182fb58612e577(nextProps);
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $331f71c4500fe679$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, $331f71c4500fe679$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $86b14aaa4b2f228f$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    }), $331f71c4500fe679$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) dot = /*#__PURE__*/ (0, $7fPBF.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");















/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $8976e8413a7e39c4$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $7f161332c72a475b$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $251e5258b398e2e1$export$3ee78d51cffc2b68)(size, angle);
}
function $7f161332c72a475b$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $7f161332c72a475b$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $7f161332c72a475b$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $8976e8413a7e39c4$export$41514b9f058a6886)(ticks, interval + 1);
}




function $68a5c6e5e64af4f0$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $8976e8413a7e39c4$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $6cb6365b5eafdfd3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6cb6365b5eafdfd3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6cb6365b5eafdfd3$var$_typeof(o);
}
function $6cb6365b5eafdfd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cb6365b5eafdfd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cb6365b5eafdfd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6cb6365b5eafdfd3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cb6365b5eafdfd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6cb6365b5eafdfd3$var$_defineProperty(obj, key, value) {
    key = $6cb6365b5eafdfd3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6cb6365b5eafdfd3$var$_toPropertyKey(arg) {
    var key = $6cb6365b5eafdfd3$var$_toPrimitive(arg, "string");
    return $6cb6365b5eafdfd3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6cb6365b5eafdfd3$var$_toPrimitive(input, hint) {
    if ($6cb6365b5eafdfd3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6cb6365b5eafdfd3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6cb6365b5eafdfd3$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $6cb6365b5eafdfd3$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $6cb6365b5eafdfd3$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(interval) || (0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) return (0, $7f161332c72a475b$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $5da910530c0379f8$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $7f161332c72a475b$export$a1966f4ad955c82b)((0, $5da910530c0379f8$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5da910530c0379f8$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $ddf2636240ab70e2$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $7f161332c72a475b$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $68a5c6e5e64af4f0$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $6cb6365b5eafdfd3$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $6cb6365b5eafdfd3$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $4c100a780d8d6a10$var$_excluded = [
    "viewBox"
], $4c100a780d8d6a10$var$_excluded2 = [
    "viewBox"
], $4c100a780d8d6a10$var$_excluded3 = [
    "ticks"
];
function $4c100a780d8d6a10$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4c100a780d8d6a10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4c100a780d8d6a10$var$_typeof(o);
}
function $4c100a780d8d6a10$var$_extends() {
    $4c100a780d8d6a10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c100a780d8d6a10$var$_extends.apply(this, arguments);
}
function $4c100a780d8d6a10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c100a780d8d6a10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c100a780d8d6a10$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4c100a780d8d6a10$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c100a780d8d6a10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4c100a780d8d6a10$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4c100a780d8d6a10$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4c100a780d8d6a10$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4c100a780d8d6a10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4c100a780d8d6a10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4c100a780d8d6a10$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4c100a780d8d6a10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4c100a780d8d6a10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4c100a780d8d6a10$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4c100a780d8d6a10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4c100a780d8d6a10$var$_setPrototypeOf(subClass, superClass);
}
function $4c100a780d8d6a10$var$_setPrototypeOf(o, p) {
    $4c100a780d8d6a10$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4c100a780d8d6a10$var$_setPrototypeOf(o, p);
}
function $4c100a780d8d6a10$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4c100a780d8d6a10$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4c100a780d8d6a10$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4c100a780d8d6a10$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4c100a780d8d6a10$var$_possibleConstructorReturn(this, result);
    };
}
function $4c100a780d8d6a10$var$_possibleConstructorReturn(self, call) {
    if (call && ($4c100a780d8d6a10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c100a780d8d6a10$var$_assertThisInitialized(self);
}
function $4c100a780d8d6a10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4c100a780d8d6a10$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4c100a780d8d6a10$var$_getPrototypeOf(o) {
    $4c100a780d8d6a10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4c100a780d8d6a10$var$_getPrototypeOf(o);
}
function $4c100a780d8d6a10$var$_defineProperty(obj, key, value) {
    key = $4c100a780d8d6a10$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4c100a780d8d6a10$var$_toPropertyKey(arg) {
    var key = $4c100a780d8d6a10$var$_toPrimitive(arg, "string");
    return $4c100a780d8d6a10$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4c100a780d8d6a10$var$_toPrimitive(input, hint) {
    if ($4c100a780d8d6a10$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4c100a780d8d6a10$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4c100a780d8d6a10$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $4c100a780d8d6a10$var$_inherits(CartesianAxis, _Component);
    var _super = $4c100a780d8d6a10$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $4c100a780d8d6a10$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $4c100a780d8d6a10$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $4c100a780d8d6a10$var$_objectWithoutProperties(_ref, $4c100a780d8d6a10$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $4c100a780d8d6a10$var$_objectWithoutProperties(_this$props, $4c100a780d8d6a10$var$_excluded2);
                return !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $4c100a780d8d6a10$var$_extends({}, props, {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $4c100a780d8d6a10$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $4c100a780d8d6a10$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $4c100a780d8d6a10$var$_objectWithoutProperties(_this$props8, $4c100a780d8d6a10$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $4c100a780d8d6a10$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $7fPBF.Component));
$4c100a780d8d6a10$var$_defineProperty($4c100a780d8d6a10$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$4c100a780d8d6a10$var$_defineProperty($4c100a780d8d6a10$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $27e86c33407ed632$var$_extends() {
    $27e86c33407ed632$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27e86c33407ed632$var$_extends.apply(this, arguments);
}
var $27e86c33407ed632$export$ea77231de273b52d = function XAxis(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var height = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var axisOptions = (0, $d5acdec35ed0a35a$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4c100a780d8d6a10$export$bdd99f2cdf352bae), $27e86c33407ed632$var$_extends({}, axisOptions, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$27e86c33407ed632$export$ea77231de273b52d.displayName = 'XAxis';
$27e86c33407ed632$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};



var $7fPBF = parcelRequire("7fPBF");




function $3a4baae21e40b313$var$_extends() {
    $3a4baae21e40b313$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a4baae21e40b313$var$_extends.apply(this, arguments);
}
var $3a4baae21e40b313$export$f96c4024c52de8f4 = function YAxis(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var height = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var axisOptions = (0, $d5acdec35ed0a35a$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4c100a780d8d6a10$export$bdd99f2cdf352bae), $3a4baae21e40b313$var$_extends({}, axisOptions, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$3a4baae21e40b313$export$f96c4024c52de8f4.displayName = 'YAxis';
$3a4baae21e40b313$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};



var $01f31af77b77addd$export$94aefc399ef206a9 = (0, $331f71c4500fe679$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $27e86c33407ed632$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $3a4baae21e40b313$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $251e5258b398e2e1$export$ece7de1383db5ac)
});


var $7fPBF = parcelRequire("7fPBF");








var $6143e12f71339f62$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $6143e12f71339f62$var$_excluded2 = [
    "offset"
];
function $6143e12f71339f62$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6143e12f71339f62$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6143e12f71339f62$var$_typeof(o);
}
function $6143e12f71339f62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6143e12f71339f62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6143e12f71339f62$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6143e12f71339f62$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6143e12f71339f62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6143e12f71339f62$var$_defineProperty(obj, key, value) {
    key = $6143e12f71339f62$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6143e12f71339f62$var$_toPropertyKey(arg) {
    var key = $6143e12f71339f62$var$_toPrimitive(arg, "string");
    return $6143e12f71339f62$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6143e12f71339f62$var$_toPrimitive(input, hint) {
    if ($6143e12f71339f62$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6143e12f71339f62$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6143e12f71339f62$var$_extends() {
    $6143e12f71339f62$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6143e12f71339f62$var$_extends.apply(this, arguments);
}
function $6143e12f71339f62$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6143e12f71339f62$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6143e12f71339f62$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6143e12f71339f62$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $6143e12f71339f62$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $6143e12f71339f62$var$_objectWithoutProperties(props, $6143e12f71339f62$var$_excluded);
        var _filterProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $6143e12f71339f62$var$_objectWithoutProperties(_filterProps, $6143e12f71339f62$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $6143e12f71339f62$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $6143e12f71339f62$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $6143e12f71339f62$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $6143e12f71339f62$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $6143e12f71339f62$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $6143e12f71339f62$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $6143e12f71339f62$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $6143e12f71339f62$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $3cf1854128f2220f$export$846dc5ac5fecff74)((0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, (0, $4c100a780d8d6a10$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $6143e12f71339f62$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $3cf1854128f2220f$export$846dc5ac5fecff74)((0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, (0, $4c100a780d8d6a10$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $6143e12f71339f62$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $6143e12f71339f62$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var chartHeight = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var offset = (0, $d5acdec35ed0a35a$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $6143e12f71339f62$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $6143e12f71339f62$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $6143e12f71339f62$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $6143e12f71339f62$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $6143e12f71339f62$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $6143e12f71339f62$var$defaultProps.verticalFill
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, xAxis = propsIncludingDefaults.xAxis, yAxis = propsIncludingDefaults.yAxis, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || x !== +x || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $6143e12f71339f62$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $6143e12f71339f62$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($6143e12f71339f62$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($6143e12f71339f62$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$HorizontalGridLines, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$VerticalGridLines, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$HorizontalStripes, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$VerticalStripes, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$6143e12f71339f62$export$6440e27b9f186856.displayName = 'CartesianGrid';



var $7fPBF = parcelRequire("7fPBF");


var $j2VHG = parcelRequire("j2VHG");



function $6ceca7e94c1e5e4b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6ceca7e94c1e5e4b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ceca7e94c1e5e4b$var$_typeof(o);
}
function $6ceca7e94c1e5e4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ceca7e94c1e5e4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ceca7e94c1e5e4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6ceca7e94c1e5e4b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ceca7e94c1e5e4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6ceca7e94c1e5e4b$var$_defineProperty(obj, key, value) {
    key = $6ceca7e94c1e5e4b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ceca7e94c1e5e4b$var$_toPropertyKey(arg) {
    var key = $6ceca7e94c1e5e4b$var$_toPrimitive(arg, "string");
    return $6ceca7e94c1e5e4b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6ceca7e94c1e5e4b$var$_toPrimitive(input, hint) {
    if ($6ceca7e94c1e5e4b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6ceca7e94c1e5e4b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6ceca7e94c1e5e4b$var$_slicedToArray(arr, i) {
    return $6ceca7e94c1e5e4b$var$_arrayWithHoles(arr) || $6ceca7e94c1e5e4b$var$_iterableToArrayLimit(arr, i) || $6ceca7e94c1e5e4b$var$_unsupportedIterableToArray(arr, i) || $6ceca7e94c1e5e4b$var$_nonIterableRest();
}
function $6ceca7e94c1e5e4b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ceca7e94c1e5e4b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ceca7e94c1e5e4b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ceca7e94c1e5e4b$var$_arrayLikeToArray(o, minLen);
}
function $6ceca7e94c1e5e4b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ceca7e94c1e5e4b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6ceca7e94c1e5e4b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6ceca7e94c1e5e4b$export$e60a4704009a0009 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $7fPBF.useRef)(null);
    var onResizeRef = (0, $7fPBF.useRef)();
    onResizeRef.current = onResize;
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return Object.assign(containerRef.current, {
            get current () {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            }
        });
    });
    var _useState = (0, $7fPBF.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $6ceca7e94c1e5e4b$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $7fPBF.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $7fPBF.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($ec572136d1d3e1b1$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $7fPBF.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)((0, $ddf2636240ab70e2$export$e50269385c77c348)(width) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $ddf2636240ab70e2$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $ddf2636240ab70e2$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $j2VHG.isElement)(children) && (0, $86b14aaa4b2f228f$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.map(children, function(child) {
            if ((0, $j2VHG.isElement)(child)) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, $6ceca7e94c1e5e4b$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $6ceca7e94c1e5e4b$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $6ceca7e94c1e5e4b$var$_objectSpread($6ceca7e94c1e5e4b$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});



var $609203c3e9cc3ccf$exports = {};

$parcel$export($609203c3e9cc3ccf$exports, "chart", function () { return $609203c3e9cc3ccf$export$8fde8ebd684d5072; }, function (v) { return $609203c3e9cc3ccf$export$8fde8ebd684d5072 = v; });
$parcel$export($609203c3e9cc3ccf$exports, "title", function () { return $609203c3e9cc3ccf$export$fb184b623420d9be; }, function (v) { return $609203c3e9cc3ccf$export$fb184b623420d9be = v; });
var $609203c3e9cc3ccf$export$8fde8ebd684d5072;
var $609203c3e9cc3ccf$export$fb184b623420d9be;
$609203c3e9cc3ccf$export$8fde8ebd684d5072 = `VQ_XgG_chart`;
$609203c3e9cc3ccf$export$fb184b623420d9be = `VQ_XgG_title`;


const $5d6d08b05a3cf04d$var$CustomTooltip = ({ active: active, payload: payload, label: label })=>{
    if (active && payload && payload.length) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            style: {
                margin: 10,
                fontWeight: "bold"
            },
            children: `${label}: ${payload[0].value}`
        })
    });
    return null;
};
const $5d6d08b05a3cf04d$export$199342868311567e = ({ title: title, data: data, dataKey: dataKey, colorForIndex: colorForIndex })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($609203c3e9cc3ccf$exports))).title,
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $01f31af77b77addd$export$94aefc399ef206a9), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($609203c3e9cc3ccf$exports))).chart,
                        data: data,
                        margin: {
                            top: 5,
                            right: 10,
                            left: -20,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6143e12f71339f62$export$6440e27b9f186856), {
                                stroke: "#808080",
                                strokeDasharray: "5 5"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e86c33407ed632$export$ea77231de273b52d), {
                                dataKey: "name",
                                stroke: theme.palette.primary.main
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a4baae21e40b313$export$f96c4024c52de8f4), {
                                stroke: theme.palette.primary.main
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {
                                content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5d6d08b05a3cf04d$var$CustomTooltip, {}),
                                cursor: false
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1), {
                                dataKey: dataKey,
                                isAnimationActive: true,
                                children: data.map((value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea), {
                                        fill: colorForIndex(index)
                                    }, `cell-${index}`))
                            })
                        ]
                    })
                })
            ]
        })
    });
};




parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");




















var $63b3d20e0a6452f7$var$_class;
function $63b3d20e0a6452f7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $63b3d20e0a6452f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $63b3d20e0a6452f7$var$_typeof(o);
}
function $63b3d20e0a6452f7$var$_extends() {
    $63b3d20e0a6452f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63b3d20e0a6452f7$var$_extends.apply(this, arguments);
}
function $63b3d20e0a6452f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63b3d20e0a6452f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63b3d20e0a6452f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $63b3d20e0a6452f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63b3d20e0a6452f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $63b3d20e0a6452f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $63b3d20e0a6452f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63b3d20e0a6452f7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63b3d20e0a6452f7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63b3d20e0a6452f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63b3d20e0a6452f7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63b3d20e0a6452f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $63b3d20e0a6452f7$var$_setPrototypeOf(subClass, superClass);
}
function $63b3d20e0a6452f7$var$_setPrototypeOf(o, p) {
    $63b3d20e0a6452f7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63b3d20e0a6452f7$var$_setPrototypeOf(o, p);
}
function $63b3d20e0a6452f7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $63b3d20e0a6452f7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $63b3d20e0a6452f7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $63b3d20e0a6452f7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $63b3d20e0a6452f7$var$_possibleConstructorReturn(this, result);
    };
}
function $63b3d20e0a6452f7$var$_possibleConstructorReturn(self, call) {
    if (call && ($63b3d20e0a6452f7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $63b3d20e0a6452f7$var$_assertThisInitialized(self);
}
function $63b3d20e0a6452f7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $63b3d20e0a6452f7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63b3d20e0a6452f7$var$_getPrototypeOf(o) {
    $63b3d20e0a6452f7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63b3d20e0a6452f7$var$_getPrototypeOf(o);
}
function $63b3d20e0a6452f7$var$_defineProperty(obj, key, value) {
    key = $63b3d20e0a6452f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $63b3d20e0a6452f7$var$_toPropertyKey(arg) {
    var key = $63b3d20e0a6452f7$var$_toPrimitive(arg, "string");
    return $63b3d20e0a6452f7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $63b3d20e0a6452f7$var$_toPrimitive(input, hint) {
    if ($63b3d20e0a6452f7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($63b3d20e0a6452f7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $63b3d20e0a6452f7$export$2ae8800cf67c848c = /*#__PURE__*/ function(_PureComponent) {
    $63b3d20e0a6452f7$var$_inherits(Pie, _PureComponent);
    var _super = $63b3d20e0a6452f7$var$_createSuper(Pie);
    function Pie(props) {
        var _this;
        $63b3d20e0a6452f7$var$_classCallCheck(this, Pie);
        _this = _super.call(this, props);
        $63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$var$_assertThisInitialized(_this), "pieRef", null);
        $63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$var$_assertThisInitialized(_this), "sectorRefs", []);
        $63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$var$_assertThisInitialized(_this), "id", (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-pie-'));
        $63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    $63b3d20e0a6452f7$var$_createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customLabelProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(label, false);
                var customLabelLineProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ],
                        key: 'line'
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(valueKey)) realDataKey = 'value';
                    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey)) realDataKey = valueKey;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps), Pie.renderLabelItem(label, labelProps, (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey)));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $63b3d20e0a6452f7$var$_extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afd6034f160dea85$export$6428a7f2611ef1fa), $63b3d20e0a6452f7$var$_extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($7bd586c179037026$exports)))(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, (/*@__PURE__*/$parcel$interopDefault($b2b661eb4d0f23aa$exports)))(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cx) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cy) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(innerRadius) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(outerRadius)) return null;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-pie', className);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, $acfa11ccf9405f16$export$835fcf23ab7bf88).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) return option(props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1), $63b3d20e0a6452f7$var$_extends({}, props, {
                    type: "linear",
                    className: "recharts-pie-label-line"
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                var label = value;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(label)) return label;
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $63b3d20e0a6452f7$var$_extends({}, props, {
                    alignmentBaseline: "middle",
                    className: "recharts-pie-label-text"
                }), label);
            }
        }
    ]);
    return Pie;
}((0, $7fPBF.PureComponent));
$63b3d20e0a6452f7$var$_class = $63b3d20e0a6452f7$export$2ae8800cf67c848c;
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "displayName", 'Pie');
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "getRealPieData", function(item) {
    var _item$props = item.props, data = _item$props.data, children = _item$props.children;
    var presentationProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(item.props, false);
    var cells = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea));
    if (data && data.length) return data.map(function(entry, index) {
        return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "parseCoordinateOfPie", function(item, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $2f494a175d2955a8$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(item.props.cx, width, width / 2);
    var cy = top + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(item.props.cy, height, height / 2);
    var innerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(item.props.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var pieData = $63b3d20e0a6452f7$var$_class.getRealPieData(item);
    if (!pieData || !pieData.length) return null;
    var _item$props2 = item.props, cornerRadius = _item$props2.cornerRadius, startAngle = _item$props2.startAngle, endAngle = _item$props2.endAngle, paddingAngle = _item$props2.paddingAngle, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, valueKey = _item$props2.valueKey, tooltipType = _item$props2.tooltipType;
    var minAngle = Math.abs(item.props.minAngle);
    var coordinate = $63b3d20e0a6452f7$var$_class.parseCoordinateOfPie(item, offset);
    var deltaAngle = $63b3d20e0a6452f7$var$_class.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(valueKey)) {
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ba0da6b51bec2997$exports)))(dataKey)) {
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0);
        return result + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0);
            var name = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, nameKey, i);
            var percent = ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

/**
 * @fileOverview Pie Chart
 */ 

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");


var $9c4bfeb35f4f0d0a$var$_excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function $9c4bfeb35f4f0d0a$var$_extends() {
    $9c4bfeb35f4f0d0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c4bfeb35f4f0d0a$var$_extends.apply(this, arguments);
}
function $9c4bfeb35f4f0d0a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9c4bfeb35f4f0d0a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9c4bfeb35f4f0d0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9c4bfeb35f4f0d0a$var$_toConsumableArray(arr) {
    return $9c4bfeb35f4f0d0a$var$_arrayWithoutHoles(arr) || $9c4bfeb35f4f0d0a$var$_iterableToArray(arr) || $9c4bfeb35f4f0d0a$var$_unsupportedIterableToArray(arr) || $9c4bfeb35f4f0d0a$var$_nonIterableSpread();
}
function $9c4bfeb35f4f0d0a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9c4bfeb35f4f0d0a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(o, minLen);
}
function $9c4bfeb35f4f0d0a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9c4bfeb35f4f0d0a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(arr);
}
function $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9c4bfeb35f4f0d0a$var$isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var $9c4bfeb35f4f0d0a$var$getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if ($9c4bfeb35f4f0d0a$var$isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if ($9c4bfeb35f4f0d0a$var$isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var $9c4bfeb35f4f0d0a$var$getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = $9c4bfeb35f4f0d0a$var$getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat($9c4bfeb35f4f0d0a$var$_toConsumableArray(res), $9c4bfeb35f4f0d0a$var$_toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var $9c4bfeb35f4f0d0a$var$getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat($9c4bfeb35f4f0d0a$var$getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var $9c4bfeb35f4f0d0a$export$7d31b617c820d435 = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = $9c4bfeb35f4f0d0a$var$_objectWithoutProperties(props, $9c4bfeb35f4f0d0a$var$_excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = $9c4bfeb35f4f0d0a$var$getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};






function $1e217e5600ea734c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e217e5600ea734c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e217e5600ea734c$var$_typeof(o);
}
function $1e217e5600ea734c$var$_extends() {
    $1e217e5600ea734c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e217e5600ea734c$var$_extends.apply(this, arguments);
}
function $1e217e5600ea734c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e217e5600ea734c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e217e5600ea734c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1e217e5600ea734c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e217e5600ea734c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1e217e5600ea734c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1e217e5600ea734c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1e217e5600ea734c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1e217e5600ea734c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1e217e5600ea734c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1e217e5600ea734c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1e217e5600ea734c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1e217e5600ea734c$var$_setPrototypeOf(subClass, superClass);
}
function $1e217e5600ea734c$var$_setPrototypeOf(o, p) {
    $1e217e5600ea734c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1e217e5600ea734c$var$_setPrototypeOf(o, p);
}
function $1e217e5600ea734c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1e217e5600ea734c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1e217e5600ea734c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1e217e5600ea734c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1e217e5600ea734c$var$_possibleConstructorReturn(this, result);
    };
}
function $1e217e5600ea734c$var$_possibleConstructorReturn(self, call) {
    if (call && ($1e217e5600ea734c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1e217e5600ea734c$var$_assertThisInitialized(self);
}
function $1e217e5600ea734c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1e217e5600ea734c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1e217e5600ea734c$var$_getPrototypeOf(o) {
    $1e217e5600ea734c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1e217e5600ea734c$var$_getPrototypeOf(o);
}
function $1e217e5600ea734c$var$_defineProperty(obj, key, value) {
    key = $1e217e5600ea734c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e217e5600ea734c$var$_toPropertyKey(arg) {
    var key = $1e217e5600ea734c$var$_toPrimitive(arg, "string");
    return $1e217e5600ea734c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1e217e5600ea734c$var$_toPrimitive(input, hint) {
    if ($1e217e5600ea734c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1e217e5600ea734c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $1e217e5600ea734c$var$RADIAN = Math.PI / 180;
var $1e217e5600ea734c$var$eps = 1e-5;
var $1e217e5600ea734c$export$67d930e793705898 = /*#__PURE__*/ function(_PureComponent) {
    $1e217e5600ea734c$var$_inherits(PolarAngleAxis, _PureComponent);
    var _super = $1e217e5600ea734c$var$_createSuper(PolarAngleAxis);
    function PolarAngleAxis() {
        $1e217e5600ea734c$var$_classCallCheck(this, PolarAngleAxis);
        return _super.apply(this, arguments);
    }
    $1e217e5600ea734c$var$_createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, data.coordinate);
                var p2 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * $1e217e5600ea734c$var$RADIAN);
                var textAnchor;
                if (cos > $1e217e5600ea734c$var$eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -$1e217e5600ea734c$var$eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), $1e217e5600ea734c$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9c4bfeb35f4f0d0a$export$7d31b617c820d435), $1e217e5600ea734c$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $1e217e5600ea734c$var$_extends({
                        className: "recharts-polar-angle-axis-tick",
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $1e217e5600ea734c$var$_extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis"
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $1e217e5600ea734c$var$_extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarAngleAxis;
}((0, $7fPBF.PureComponent));
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "displayName", 'PolarAngleAxis');
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "axisType", 'angleAxis');
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});



var $7fPBF = parcelRequire("7fPBF");
var $54b0a71187288847$exports = {};



/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $54b0a71187288847$var$maxBy(array, iteratee) {
    return array && array.length ? $dd255202df26081b$exports(array, $6981623866a9ed6c$exports(iteratee, 2), $1760e1589d594403$exports) : undefined;
}
$54b0a71187288847$exports = $54b0a71187288847$var$maxBy;


var $f4aead80378eb20e$exports = {};



/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $f4aead80378eb20e$var$minBy(array, iteratee) {
    return array && array.length ? $dd255202df26081b$exports(array, $6981623866a9ed6c$exports(iteratee, 2), $4964f5a300cf055d$exports) : undefined;
}
$f4aead80378eb20e$exports = $f4aead80378eb20e$var$minBy;









var $943b9fbe5f81a613$var$_excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], $943b9fbe5f81a613$var$_excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function $943b9fbe5f81a613$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $943b9fbe5f81a613$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $943b9fbe5f81a613$var$_typeof(o);
}
function $943b9fbe5f81a613$var$_extends() {
    $943b9fbe5f81a613$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $943b9fbe5f81a613$var$_extends.apply(this, arguments);
}
function $943b9fbe5f81a613$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $943b9fbe5f81a613$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $943b9fbe5f81a613$var$ownKeys(Object(t), !0).forEach(function(r) {
            $943b9fbe5f81a613$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $943b9fbe5f81a613$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $943b9fbe5f81a613$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $943b9fbe5f81a613$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $943b9fbe5f81a613$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $943b9fbe5f81a613$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $943b9fbe5f81a613$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $943b9fbe5f81a613$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $943b9fbe5f81a613$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $943b9fbe5f81a613$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $943b9fbe5f81a613$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $943b9fbe5f81a613$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $943b9fbe5f81a613$var$_setPrototypeOf(subClass, superClass);
}
function $943b9fbe5f81a613$var$_setPrototypeOf(o, p) {
    $943b9fbe5f81a613$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $943b9fbe5f81a613$var$_setPrototypeOf(o, p);
}
function $943b9fbe5f81a613$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $943b9fbe5f81a613$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $943b9fbe5f81a613$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $943b9fbe5f81a613$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $943b9fbe5f81a613$var$_possibleConstructorReturn(this, result);
    };
}
function $943b9fbe5f81a613$var$_possibleConstructorReturn(self, call) {
    if (call && ($943b9fbe5f81a613$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $943b9fbe5f81a613$var$_assertThisInitialized(self);
}
function $943b9fbe5f81a613$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $943b9fbe5f81a613$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $943b9fbe5f81a613$var$_getPrototypeOf(o) {
    $943b9fbe5f81a613$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $943b9fbe5f81a613$var$_getPrototypeOf(o);
}
function $943b9fbe5f81a613$var$_defineProperty(obj, key, value) {
    key = $943b9fbe5f81a613$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $943b9fbe5f81a613$var$_toPropertyKey(arg) {
    var key = $943b9fbe5f81a613$var$_toPrimitive(arg, "string");
    return $943b9fbe5f81a613$var$_typeof(key) === "symbol" ? key : String(key);
}
function $943b9fbe5f81a613$var$_toPrimitive(input, hint) {
    if ($943b9fbe5f81a613$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($943b9fbe5f81a613$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $943b9fbe5f81a613$export$d2607afddf4df58d = /*#__PURE__*/ function(_PureComponent) {
    $943b9fbe5f81a613$var$_inherits(PolarRadiusAxis, _PureComponent);
    var _super = $943b9fbe5f81a613$var$_createSuper(PolarRadiusAxis);
    function PolarRadiusAxis() {
        $943b9fbe5f81a613$var$_classCallCheck(this, PolarRadiusAxis);
        return _super.apply(this, arguments);
    }
    $943b9fbe5f81a613$var$_createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($54b0a71187288847$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($f4aead80378eb20e$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = $943b9fbe5f81a613$var$_objectWithoutProperties(_this$props3, $943b9fbe5f81a613$var$_excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, extent[0], angle);
                var point1 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, extent[1], angle);
                var props = $943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false)), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $943b9fbe5f81a613$var$_extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = $943b9fbe5f81a613$var$_objectWithoutProperties(_this$props4, $943b9fbe5f81a613$var$_excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = $943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $943b9fbe5f81a613$var$_extends({
                        className: "recharts-polar-radius-axis-tick",
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis"
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($fcbbb7ef85cdd01b$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $943b9fbe5f81a613$var$_extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarRadiusAxis;
}((0, $7fPBF.PureComponent));
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "displayName", 'PolarRadiusAxis');
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "axisType", 'radiusAxis');
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});




var $0d06d88eccf60657$export$b99d3348f709c998 = (0, $331f71c4500fe679$export$77871aede60e6838)({
    chartName: 'PieChart',
    GraphicalChild: (0, $63b3d20e0a6452f7$export$2ae8800cf67c848c),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, $1e217e5600ea734c$export$67d930e793705898)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, $943b9fbe5f81a613$export$d2607afddf4df58d)
        }
    ],
    formatAxisMap: (0, $2f494a175d2955a8$export$ece7de1383db5ac),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});



var $30252013bdc0f553$exports = {};

$parcel$export($30252013bdc0f553$exports, "chart", function () { return $30252013bdc0f553$export$8fde8ebd684d5072; }, function (v) { return $30252013bdc0f553$export$8fde8ebd684d5072 = v; });
$parcel$export($30252013bdc0f553$exports, "container", function () { return $30252013bdc0f553$export$34e0f9847d4c02dd; }, function (v) { return $30252013bdc0f553$export$34e0f9847d4c02dd = v; });
$parcel$export($30252013bdc0f553$exports, "title", function () { return $30252013bdc0f553$export$fb184b623420d9be; }, function (v) { return $30252013bdc0f553$export$fb184b623420d9be = v; });
var $30252013bdc0f553$export$8fde8ebd684d5072;
var $30252013bdc0f553$export$34e0f9847d4c02dd;
var $30252013bdc0f553$export$fb184b623420d9be;
$30252013bdc0f553$export$8fde8ebd684d5072 = `_7Jqnra_chart`;
$30252013bdc0f553$export$34e0f9847d4c02dd = `_7Jqnra_container`;
$30252013bdc0f553$export$fb184b623420d9be = `_7Jqnra_title`;


const $eac60d7f8743135e$var$CustomTooltip = ({ active: active, payload: payload })=>{
    if (active && payload && payload.length) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            style: {
                margin: 10,
                fontWeight: "bold"
            },
            children: `${payload[0].name}: ${payload[0].value}%`
        })
    });
    return null;
};
const $eac60d7f8743135e$export$581d928af160296 = ({ title: title, data: data, dataKey: dataKey, colorForIndex: colorForIndex })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: "100%",
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                height: "100%",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30252013bdc0f553$exports))).title,
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30252013bdc0f553$exports))).container,
                    width: "100%",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0d06d88eccf60657$export$b99d3348f709c998), {
                        data: data,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($30252013bdc0f553$exports))).chart,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {
                                content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eac60d7f8743135e$var$CustomTooltip, {}),
                                cursor: false
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63b3d20e0a6452f7$export$2ae8800cf67c848c), {
                                data: data,
                                dataKey: dataKey,
                                isAnimationActive: true,
                                innerRadius: "50%",
                                outerRadius: "80%",
                                paddingAngle: 5,
                                children: data.map((value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea), {
                                        fill: colorForIndex(index)
                                    }, `cell-${index}`))
                            })
                        ]
                    })
                })
            ]
        })
    });



const $43d85601ed471788$export$b2564a5c214b1303 = ({ stats: stats })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [currentProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const impactData = ()=>{
        const data = [];
        stats.impactCounts?.forEach((impactCount, index)=>{
            if (index == 0) return;
            const name = currentProfile?.shouldShowImpactDescriptions ? impactCount.grade.description : `${impactCount.grade.id + 1} \u{2605}`;
            data.push({
                name: name,
                value: impactCount.count
            });
        });
        return data;
    };
    const sleeveGradeData = ()=>{
        const data = [];
        stats.sleeveGradeCounts?.forEach((sleeveGradeCount, index)=>{
            if (index == 0) return;
            data.push({
                name: sleeveGradeCount.grade.goldmineGrade,
                value: sleeveGradeCount.count
            });
        });
        return data;
    };
    const mediaGradeData = ()=>{
        const data = [];
        stats.mediaGradeCounts?.forEach((mediaGradeCount, index)=>{
            if (index == 0) return;
            data.push({
                name: mediaGradeCount.grade.goldmineGrade,
                value: mediaGradeCount.count
            });
        });
        return data;
    };
    const percentageData = (value)=>{
        const noPercentage = stats.totalAlbumCount ? (stats.totalAlbumCount - value) / stats.totalAlbumCount : 1;
        const yesPercentage = stats.totalAlbumCount ? value / stats.totalAlbumCount : 0;
        return [
            {
                name: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes,
                value: Math.round(yesPercentage * 100)
            },
            {
                name: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no,
                value: Math.round(noPercentage * 100)
            }
        ];
    };
    const pieColor = (index)=>{
        switch(index){
            case 0:
                return theme.palette.colors?.goldmineGreen ?? "";
            default:
                return theme.palette.colors?.goldmineRed ?? "";
        }
    };
    const impactColor = (index)=>{
        switch(index){
            case 0:
                return theme.palette.colors?.goldmineGray ?? "";
            case 1:
                return theme.palette.colors?.goldmineRed ?? "";
            case 2:
                return theme.palette.colors?.goldmineGreen ?? "";
            case 3:
                return theme.palette.colors?.goldmineBlue ?? "";
            default:
                return theme.palette.colors?.goldmineMint ?? "";
        }
    };
    const gradeColor = (index)=>{
        switch(index){
            case 0:
            case 1:
            case 2:
            case 3:
                return theme.palette.colors?.goldmineRed ?? "";
            case 4:
            case 5:
            case 6:
                return theme.palette.colors?.goldmineGreen ?? "";
            case 7:
            case 8:
                return theme.palette.colors?.goldmineBlue ?? "";
            default:
                return theme.palette.colors?.goldmineMint ?? "";
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6119913b7238aea6$exports))).mainContainer,
        elevation: 5,
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
            sx: {
                overflow: "auto",
                flexGrow: 1
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%",
                        height: 190
                    },
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: "24.9%"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eac60d7f8743135e$export$581d928af160296), {
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_clean_title,
                                data: percentageData(stats.cleanCount),
                                dataKey: "value",
                                colorForIndex: pieColor
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: "24.9%"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eac60d7f8743135e$export$581d928af160296), {
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_insert_title,
                                data: percentageData(stats.insertCount),
                                dataKey: "value",
                                colorForIndex: pieColor
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: "24.9%"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eac60d7f8743135e$export$581d928af160296), {
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_lyrics_title,
                                data: percentageData(stats.lyricsCount),
                                dataKey: "value",
                                colorForIndex: pieColor
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: "24.9%"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eac60d7f8743135e$export$581d928af160296), {
                                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_gatefold_title,
                                data: percentageData(stats.gatefoldCount),
                                dataKey: "value",
                                colorForIndex: pieColor
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%",
                        height: 420
                    },
                    direction: "row",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d6d08b05a3cf04d$export$199342868311567e), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_sleeve_grades_title,
                            data: sleeveGradeData(),
                            dataKey: "value",
                            colorForIndex: gradeColor
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%",
                        height: 420
                    },
                    direction: "row",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d6d08b05a3cf04d$export$199342868311567e), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_media_grades_title,
                            data: mediaGradeData(),
                            dataKey: "value",
                            colorForIndex: gradeColor
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%",
                        height: 420
                    },
                    direction: "row",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d6d08b05a3cf04d$export$199342868311567e), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_impacts_title,
                            data: impactData(),
                            dataKey: "value",
                            colorForIndex: impactColor
                        })
                    })
                })
            ]
        })
    });
};










var $7fPBF = parcelRequire("7fPBF");
var $4a14901cd49b2610$exports = {};

$parcel$export($4a14901cd49b2610$exports, "itemCard", function () { return $4a14901cd49b2610$export$e0be3821d621a3a0; }, function (v) { return $4a14901cd49b2610$export$e0be3821d621a3a0 = v; });
$parcel$export($4a14901cd49b2610$exports, "itemCardMobile", function () { return $4a14901cd49b2610$export$20450404b102fd6c; }, function (v) { return $4a14901cd49b2610$export$20450404b102fd6c = v; });
var $4a14901cd49b2610$export$e0be3821d621a3a0;
var $4a14901cd49b2610$export$20450404b102fd6c;
$4a14901cd49b2610$export$e0be3821d621a3a0 = `wrn3bq_itemCard`;
$4a14901cd49b2610$export$20450404b102fd6c = `wrn3bq_itemCardMobile`;







const $23e58e984ca2a060$export$d3486a6a25a981ad = ({ sectionName: sectionName, title: title, children: children })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
            elevation: 5,
            className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($4a14901cd49b2610$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($4a14901cd49b2610$exports))).itemCard,
            style: {
                backgroundColor: theme.palette.background.default
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                    title: title,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    theNewIconType: isExpanded ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowUp : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown,
                    onClick: ()=>setIsExpanded((state)=>!state),
                    boldTitle: true
                }, `${sectionName}_title`),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
                    in: isExpanded,
                    timeout: "auto",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        children
                    ]
                })
            ]
        }, `${sectionName}_card`)
    }, `${sectionName}_section`);
};


const $63bff0d93da68c84$export$b517626f9ee37fd3 = ({ stats: stats, isLoading: isLoading })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const statsList = (stats)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCard,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            style: {
                                backgroundColor: theme.palette.background.default
                            },
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_general_title,
                            boldTitle: true
                        }, "general_title"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_album_total,
                            detail: String(stats.totalAlbumCount)
                        }, "general_item_1"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_box_set_total,
                            detail: String(stats.totalBoxSetCount)
                        }, "general_item_0"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_clean_total,
                            detail: String(stats.cleanCount)
                        }, "general_item_2"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_gatefold_total,
                            detail: String(stats.gatefoldCount)
                        }, "general_item_3"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_insert_total,
                            detail: String(stats.insertCount)
                        }, "general_item_4"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_lyrics_total,
                            detail: String(stats.lyricsCount)
                        }, "general_item_5"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_colored_total,
                            detail: String(stats.coloredAlbumsCount)
                        }, "general_item_6"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_average_original_year,
                            detail: String(Math.round(stats.averageOriginalYear))
                        }, "general_item_7"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_average_release_year,
                            detail: String(Math.round(stats.averageReleaseYear))
                        }, "general_item_8")
                    ]
                }, "general_card"),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCard,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            style: {
                                backgroundColor: theme.palette.background.default
                            },
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).album_length_title,
                            boldTitle: true
                        }, "length_title"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_discs_total,
                            detail: String(stats.totalDiscs)
                        }, "length_item_1"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_length_total,
                            detail: (0, $9814b23db5adb339$export$8bb95198b45adaac).toHHMMSS(stats.totalLength)
                        }, "length_item_2"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_average_album_length,
                            detail: (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(Math.round(stats.albumAverageLength))
                        }, "length_item_3"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_average_disc_length,
                            detail: stats.discAverageLength ? (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(Math.round(stats.discAverageLength)) : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                        }, "length_item_4"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_average_track_length,
                            detail: stats.trackAverageLength ? (0, $9814b23db5adb339$export$8bb95198b45adaac).toMMSS(Math.round(stats.trackAverageLength)) : (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                        }, "length_item_5"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_tracks_by_album,
                            detail: String(Math.round(stats.tracksByAlbum))
                        }, "length_item_6")
                    ]
                }, "length_card"),
                (stats.artistCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "artists",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_artists_title,
                    children: stats.artistCounts?.sort((a, b)=>b.count - a.count).map((artistCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: artistCount.grade.name,
                                    detail: String(artistCount.count)
                                }, `artist_item_${index}`),
                                index < (stats.artistCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `artist_div_${index}`))
                }),
                (stats.labelCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "labels",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_labels_title,
                    children: stats.labelCounts?.sort((a, b)=>b.count - a.count).map((labelCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: labelCount.grade.name,
                                    detail: String(labelCount.count)
                                }, `label_item_${index}`),
                                index < (stats.labelCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `label_div_${index}`))
                }),
                (stats.originCountryCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "origin_countries",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).origin_countries_title,
                    children: stats.originCountryCounts?.sort((a, b)=>b.count - a.count).map((originCountryCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: originCountryCount.grade.name,
                                    detail: String(originCountryCount.count)
                                }, `origin_country_item_${index}`),
                                index < (stats.originCountryCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `origin_country_div_${index}`))
                }),
                (stats.storeCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "stores",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_stores_title,
                    children: stats.storeCounts?.sort((a, b)=>b.count - a.count).map((storeCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: storeCount.grade.name,
                                    detail: String(storeCount.count)
                                }, `store_item_${index}`),
                                index < (stats.storeCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `store_div_${index}`))
                }),
                (stats.albumTypeCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "album_types",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_types_title,
                    children: stats.albumTypeCounts?.sort((a, b)=>b.count - a.count).map((albumTypeCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: albumTypeCount.grade.name,
                                    detail: String(albumTypeCount.count)
                                }, `album_type_item_${index}`),
                                index < (stats.albumTypeCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `album_type_div_${index}`))
                }),
                (stats.albumFormatCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "album_formats",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_formats_title,
                    children: stats.albumFormatCounts?.sort((a, b)=>b.count - a.count).map((albumFormatCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: albumFormatCount.grade.name,
                                    detail: String(albumFormatCount.count)
                                }, `album_format_item_${index}`),
                                index < (stats.albumFormatCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `album_format_div_${index}`))
                }),
                (stats.tagCounts?.length ?? 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23e58e984ca2a060$export$d3486a6a25a981ad), {
                    sectionName: "tags",
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title,
                    children: stats.tagCounts?.sort((a, b)=>b.count - a.count).map((tagCount, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                                    title: tagCount.grade.name,
                                    detail: String(tagCount.count)
                                }, `album_tag_item_${index}`),
                                index < (stats.tagCounts?.length ?? 0) - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {})
                            ]
                        }, `album_tag_div_${index}`))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCardMobile : (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).itemCard,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_financials_title,
                            style: {
                                backgroundColor: theme.palette.background.default
                            },
                            boldTitle: true
                        }, "financials_title"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_purchase_price_total,
                            detail: currencyFormatter.format(stats.totalPurchasePrice, currentUserProfile, false)
                        }, "financials_item_1"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_sell_value_total,
                            detail: currencyFormatter.format(stats.totalSellValue, currentUserProfile, false)
                        }, "financials_item_2"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_revenue_total,
                            detail: currencyFormatter.format(stats.totalSellValue - stats.totalPurchasePrice, currentUserProfile, false)
                        }, "financials_item_3")
                    ]
                }, "financials_card")
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).mainContainer,
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: stats ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$eb2fcfdbd7ba97d4), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).mainDiv,
            orientation: "horizontal",
            children: [
                !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                    minSize: "30",
                    defaultSize: "34",
                    maxSize: "48",
                    style: {
                        display: "flex",
                        overflow: "auto",
                        paddingBottom: 16
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                        disablePadding: true,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).list,
                        children: statsList(stats)
                    })
                }),
                !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$1ff3c3f08ae963c0), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).resizeHandle,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                        style: {
                            alignSelf: "center",
                            color: theme.palette.secondary.main,
                            fontSize: 14
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).graphsDivMobile : (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).graphsDiv,
                    children: [
                        isMobile && statsList(stats),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43d85601ed471788$export$b2564a5c214b1303), {
                            stats: stats
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
            in: true,
            unmountOnExit: true,
            style: {
                transitionDelay: "2000ms"
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).loadingStack,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: isLoading ? (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_loading : (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_error
                    }),
                    isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d315ce73f1d845e4$exports))).progressBar,
                        variant: "indeterminate"
                    })
                ]
            })
        })
    });
};











const $85a128088fbc4baf$export$f31b29a48a82690e = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const createStats = (parameters)=>post("conclusions", parameters);
    return {
        createStats: createStats
    };
};









const $9729dcec50158d59$export$3cdec2bba15e3523 = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats}`;
    }, []);
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const { createStats: createStats } = (0, $85a128088fbc4baf$export$f31b29a48a82690e)();
    const [stats, setStats] = (0, $7fPBF.useState)();
    const [currentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const [selectedCollection, setSelectedCollection] = (0, $7fPBF.useState)(currentPrivateCollection);
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const onError = (body)=>{
        setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    const fetchStats = async ()=>{
        setIsLoading(true);
        const { body: body, status: status } = await createStats({
            collectionId: selectedCollection?.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status) && isMounted.current) setStats(body);
        else onError(body);
        if (isMounted.current) setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        setStats(undefined);
        fetchStats().then();
    }, [
        selectedCollection
    ]);
    const goToUserProfile = ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile());
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            style: {
                                marginRight: isMobile ? 0 : 8
                            },
                            onClick: ()=>{
                                setIsDrawerOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                            currentPage: "stats",
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            isLayout: false,
                            isOpenDiscogsImport: isOpenDiscogsImport,
                            setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                            isOpenExcelImport: isOpenExcelImport,
                            setIsOpenExcelImport: setIsOpenExcelImport
                        }),
                        !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).title,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                sx: {
                                    maxHeight: 36
                                },
                                onClick: ()=>{
                                    setIsCollectionsDialogOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        sx: {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).collectionTitle,
                                            children: selectedCollection?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_all_albums
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).expandIcon,
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ExpandAll
                                    })
                                ]
                            })
                        }),
                        stats && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).lastUpdated,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_last_updated
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).lastUpdatedDate,
                                    children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(stats.createdUnixTimestamp * 1000, "d MMMM yyyy, HH:mm", {
                                        locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            sx: {
                                paddingLeft: 1,
                                width: theme.spacing(4)
                            },
                            children: isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $921bd0ad6d18d264$export$7bf40cd2a197df2d), {
                            isPublic: false,
                            userProfile: currentUserProfile,
                            onClick: ()=>{
                                if (!currentUserProfile || currentUser?.role == "guest") return;
                                goToUserProfile();
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).mainBody,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0aed7f81db8905a$exports))).detailBody,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63bff0d93da68c84$export$b517626f9ee37fd3), {
                            stats: stats,
                            isLoading: isLoading
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: false,
                canModifyCollections: false,
                displayStandardCollections: true,
                onCollectionSelected: setSelectedCollection,
                selectedCollections: [
                    currentPrivateCollection?.uuid
                ],
                forceLoading: isLoading,
                canNegate: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};


const $86417dc904115e52$export$513164e01b946703 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9729dcec50158d59$export$3cdec2bba15e3523), {});
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $0d879e31c2091b78$exports = {};

$parcel$export($0d879e31c2091b78$exports, "logoImage", function () { return $0d879e31c2091b78$export$3ba0bfd74bc3a6fe; }, function (v) { return $0d879e31c2091b78$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($0d879e31c2091b78$exports, "mainContent", function () { return $0d879e31c2091b78$export$ad430d422a89f9f0; }, function (v) { return $0d879e31c2091b78$export$ad430d422a89f9f0 = v; });
$parcel$export($0d879e31c2091b78$exports, "mainDiv", function () { return $0d879e31c2091b78$export$16666caf1c4e1af1; }, function (v) { return $0d879e31c2091b78$export$16666caf1c4e1af1 = v; });
$parcel$export($0d879e31c2091b78$exports, "subtitle", function () { return $0d879e31c2091b78$export$c96745152eb2740f; }, function (v) { return $0d879e31c2091b78$export$c96745152eb2740f = v; });
$parcel$export($0d879e31c2091b78$exports, "title", function () { return $0d879e31c2091b78$export$fb184b623420d9be; }, function (v) { return $0d879e31c2091b78$export$fb184b623420d9be = v; });
var $0d879e31c2091b78$export$3ba0bfd74bc3a6fe;
var $0d879e31c2091b78$export$ad430d422a89f9f0;
var $0d879e31c2091b78$export$16666caf1c4e1af1;
var $0d879e31c2091b78$export$c96745152eb2740f;
var $0d879e31c2091b78$export$fb184b623420d9be;
$0d879e31c2091b78$export$3ba0bfd74bc3a6fe = `_2R_M9W_logoImage`;
$0d879e31c2091b78$export$ad430d422a89f9f0 = `_2R_M9W_mainContent`;
$0d879e31c2091b78$export$16666caf1c4e1af1 = `_2R_M9W_mainDiv`;
$0d879e31c2091b78$export$c96745152eb2740f = `_2R_M9W_subtitle`;
$0d879e31c2091b78$export$fb184b623420d9be = `_2R_M9W_title`;




const $306aed7b035aa7cc$export$f34c4c5830ccad56 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getSystemStatus = async ()=>{
        return get("systemStatus");
    };
    return {
        getSystemStatus: getSystemStatus
    };
};








const $ee22b7e625fab6ba$export$9e2ed893c5429782 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const { getSystemStatus: getSystemStatus } = (0, $306aed7b035aa7cc$export$f34c4c5830ccad56)();
    const [alreadyChecked, setAlreadyChecked] = (0, $7fPBF.useState)(false);
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        document.title = (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name;
        if (!alreadyChecked) checkSystemStatus().then();
    }, []);
    const checkSystemStatus = async ()=>{
        const { status: status, body: body } = await getSystemStatus();
        if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isOnMaintenance(status) || body.isAvailableWeb) navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
        setAlreadyChecked(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d879e31c2091b78$exports))).mainDiv,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($0d879e31c2091b78$exports))).mainContent,
            showingPersistentDrawer: false,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0d879e31c2091b78$exports))).logoImage,
                    src: piperTextImage,
                    alt: "Piper"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0d879e31c2091b78$exports))).title,
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).greetings
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0d879e31c2091b78$exports))).subtitle,
                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).maintenance_message
                })
            ]
        })
    });
};


const $7b47dee627cb75dc$export$38a43a98ba521d42 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee22b7e625fab6ba$export$9e2ed893c5429782), {});
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $bc9b834667c203c1$exports = {};

$parcel$export($bc9b834667c203c1$exports, "credits", function () { return $bc9b834667c203c1$export$68c7321cb43cac49; }, function (v) { return $bc9b834667c203c1$export$68c7321cb43cac49 = v; });
$parcel$export($bc9b834667c203c1$exports, "mainCard", function () { return $bc9b834667c203c1$export$1f815cc0a0ee594c; }, function (v) { return $bc9b834667c203c1$export$1f815cc0a0ee594c = v; });
$parcel$export($bc9b834667c203c1$exports, "mainContent", function () { return $bc9b834667c203c1$export$ad430d422a89f9f0; }, function (v) { return $bc9b834667c203c1$export$ad430d422a89f9f0 = v; });
$parcel$export($bc9b834667c203c1$exports, "mainList", function () { return $bc9b834667c203c1$export$21810f025a8548aa; }, function (v) { return $bc9b834667c203c1$export$21810f025a8548aa = v; });
$parcel$export($bc9b834667c203c1$exports, "publicCollectionsCard", function () { return $bc9b834667c203c1$export$ef035b8e61007418; }, function (v) { return $bc9b834667c203c1$export$ef035b8e61007418 = v; });
$parcel$export($bc9b834667c203c1$exports, "sectionTitle", function () { return $bc9b834667c203c1$export$1a952fe22cdce89e; }, function (v) { return $bc9b834667c203c1$export$1a952fe22cdce89e = v; });
$parcel$export($bc9b834667c203c1$exports, "title", function () { return $bc9b834667c203c1$export$fb184b623420d9be; }, function (v) { return $bc9b834667c203c1$export$fb184b623420d9be = v; });
$parcel$export($bc9b834667c203c1$exports, "toolbar", function () { return $bc9b834667c203c1$export$f727f52c778e92d5; }, function (v) { return $bc9b834667c203c1$export$f727f52c778e92d5 = v; });
var $bc9b834667c203c1$export$68c7321cb43cac49;
var $bc9b834667c203c1$export$1f815cc0a0ee594c;
var $bc9b834667c203c1$export$ad430d422a89f9f0;
var $bc9b834667c203c1$export$21810f025a8548aa;
var $bc9b834667c203c1$export$ef035b8e61007418;
var $bc9b834667c203c1$export$1a952fe22cdce89e;
var $bc9b834667c203c1$export$fb184b623420d9be;
var $bc9b834667c203c1$export$f727f52c778e92d5;
$bc9b834667c203c1$export$68c7321cb43cac49 = `_8h6GiG_credits`;
$bc9b834667c203c1$export$1f815cc0a0ee594c = `_8h6GiG_mainCard`;
$bc9b834667c203c1$export$ad430d422a89f9f0 = `_8h6GiG_mainContent`;
$bc9b834667c203c1$export$21810f025a8548aa = `_8h6GiG_mainList`;
$bc9b834667c203c1$export$ef035b8e61007418 = `_8h6GiG_publicCollectionsCard`;
$bc9b834667c203c1$export$1a952fe22cdce89e = `_8h6GiG_sectionTitle`;
$bc9b834667c203c1$export$fb184b623420d9be = `_8h6GiG_title`;
$bc9b834667c203c1$export$f727f52c778e92d5 = `_8h6GiG_toolbar`;







parcelRequire("7fPBF");





var $1bf1cb3f57c06f5f$exports = {};

$parcel$export($1bf1cb3f57c06f5f$exports, "amount", function () { return $1bf1cb3f57c06f5f$export$802cfe72001a1ee; }, function (v) { return $1bf1cb3f57c06f5f$export$802cfe72001a1ee = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "avatar", function () { return $1bf1cb3f57c06f5f$export$345c5736c8054f22; }, function (v) { return $1bf1cb3f57c06f5f$export$345c5736c8054f22 = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "card", function () { return $1bf1cb3f57c06f5f$export$aa3e815946b80764; }, function (v) { return $1bf1cb3f57c06f5f$export$aa3e815946b80764 = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "image", function () { return $1bf1cb3f57c06f5f$export$5c452ff88e35e47d; }, function (v) { return $1bf1cb3f57c06f5f$export$5c452ff88e35e47d = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "mainStack", function () { return $1bf1cb3f57c06f5f$export$a83027cea355fe97; }, function (v) { return $1bf1cb3f57c06f5f$export$a83027cea355fe97 = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "name", function () { return $1bf1cb3f57c06f5f$export$a8ff84c12d48cfa6; }, function (v) { return $1bf1cb3f57c06f5f$export$a8ff84c12d48cfa6 = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "reservedBox", function () { return $1bf1cb3f57c06f5f$export$da357abc86b0c05e; }, function (v) { return $1bf1cb3f57c06f5f$export$da357abc86b0c05e = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "reservedText", function () { return $1bf1cb3f57c06f5f$export$c94b5db9c187c61a; }, function (v) { return $1bf1cb3f57c06f5f$export$c94b5db9c187c61a = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "subtitle", function () { return $1bf1cb3f57c06f5f$export$c96745152eb2740f; }, function (v) { return $1bf1cb3f57c06f5f$export$c96745152eb2740f = v; });
$parcel$export($1bf1cb3f57c06f5f$exports, "username", function () { return $1bf1cb3f57c06f5f$export$5e1be761f603d585; }, function (v) { return $1bf1cb3f57c06f5f$export$5e1be761f603d585 = v; });
var $1bf1cb3f57c06f5f$export$802cfe72001a1ee;
var $1bf1cb3f57c06f5f$export$345c5736c8054f22;
var $1bf1cb3f57c06f5f$export$aa3e815946b80764;
var $1bf1cb3f57c06f5f$export$5c452ff88e35e47d;
var $1bf1cb3f57c06f5f$export$a83027cea355fe97;
var $1bf1cb3f57c06f5f$export$a8ff84c12d48cfa6;
var $1bf1cb3f57c06f5f$export$da357abc86b0c05e;
var $1bf1cb3f57c06f5f$export$c94b5db9c187c61a;
var $1bf1cb3f57c06f5f$export$c96745152eb2740f;
var $1bf1cb3f57c06f5f$export$5e1be761f603d585;
$1bf1cb3f57c06f5f$export$802cfe72001a1ee = `SbRLYq_amount`;
$1bf1cb3f57c06f5f$export$345c5736c8054f22 = `SbRLYq_avatar`;
$1bf1cb3f57c06f5f$export$aa3e815946b80764 = `SbRLYq_card`;
$1bf1cb3f57c06f5f$export$5c452ff88e35e47d = `SbRLYq_image`;
$1bf1cb3f57c06f5f$export$a83027cea355fe97 = `SbRLYq_mainStack`;
$1bf1cb3f57c06f5f$export$a8ff84c12d48cfa6 = `SbRLYq_name`;
$1bf1cb3f57c06f5f$export$da357abc86b0c05e = `SbRLYq_reservedBox`;
$1bf1cb3f57c06f5f$export$c94b5db9c187c61a = `SbRLYq_reservedText`;
$1bf1cb3f57c06f5f$export$c96745152eb2740f = `SbRLYq_subtitle`;
$1bf1cb3f57c06f5f$export$5e1be761f603d585 = `SbRLYq_username`;



var $7fPBF = parcelRequire("7fPBF");











const $4071b1d31c0b698a$export$985ad8b5e9ffe85 = ({ album: album, collection: collection, userProfile: userProfile, onClick: onClick })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [isLoadingImage, setIsLoadingImage] = (0, $7fPBF.useState)(false);
    const [albumSubtitle, setAlbumSubtitle] = (0, $7fPBF.useState)("");
    const genericImage = new URL($f3dc95464e643b42$exports).href;
    const fetchImage = async ()=>{
        if (!album.hasImage) return;
        setIsLoadingImage(true);
        const response = await getImage({
            name: album.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAlbumImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
        setIsLoadingImage(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        const subtitle = (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSubtitle(album);
        setAlbumSubtitle(subtitle);
        fetchImage().then();
    }, [
        album
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).card,
        sx: {
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            },
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).image,
                    children: [
                        album.sellStatus && ![
                            "new",
                            "highlighted"
                        ].includes(album.sellStatus) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).reservedBox,
                            style: {
                                backgroundColor: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusBackgroundColor(theme, album.sellStatus)
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).reservedText,
                                children: (0, $ed2696669ec840aa$export$b6b6f25bf8e344eb).getSellStatusDescription(album.sellStatus)
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d382a64001e41b44$export$ecab9f5b11b61692), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).image,
                            image: image,
                            thumbnail: album.thumbnail,
                            defaultImage: genericImage,
                            beforeLoad: fetchImage,
                            alt: album.name
                        }),
                        isLoadingImage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(0, 0, 0, 0.3)",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "absolute",
                                backdropFilter: "blur(5px)",
                                WebkitBackdropFilter: "blur(5px)"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).mainStack,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).name,
                            children: album.name
                        }),
                        album.isBoxSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).subtitle,
                            style: {
                                color: theme.palette.primary.subtitle,
                                fontWeight: "bold"
                            },
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).box_set_title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).subtitle,
                            style: {
                                color: theme.palette.primary.subtitle
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                    children: album.artist?.name ?? (0, $37bec70ed65ed924$export$21c51bc433c16634).unknown
                                }),
                                ` ${albumSubtitle}`
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            children: [
                                album.sellValue?.pesos && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).amount,
                                    children: currencyFormatter.format((album.sellValue?.pesos ?? 0) * (1 - collection.discount), userProfile, true)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignSelf: "end",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).avatar,
                                            userProfile: userProfile
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bf1cb3f57c06f5f$exports))).username,
                                            children: userProfile.username
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


var $5e04a7c133ac9ef6$exports = {};

$parcel$export($5e04a7c133ac9ef6$exports, "item", function () { return $5e04a7c133ac9ef6$export$7061c75fc5af8b7e; }, function (v) { return $5e04a7c133ac9ef6$export$7061c75fc5af8b7e = v; });
$parcel$export($5e04a7c133ac9ef6$exports, "skeleton", function () { return $5e04a7c133ac9ef6$export$2a0674ff2eb10214; }, function (v) { return $5e04a7c133ac9ef6$export$2a0674ff2eb10214 = v; });
var $5e04a7c133ac9ef6$export$7061c75fc5af8b7e;
var $5e04a7c133ac9ef6$export$2a0674ff2eb10214;
$5e04a7c133ac9ef6$export$7061c75fc5af8b7e = `vTw7CW_item`;
$5e04a7c133ac9ef6$export$2a0674ff2eb10214 = `vTw7CW_skeleton`;





const $a73c266737395a35$export$240f6d11e805b92e = ({ publicAlbums: publicAlbums, setIsLoading: setIsLoading })=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const [, setCurrentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const showAlbum = async (publicAlbum)=>{
        setIsLoading(true);
        const { status: status, body: body } = await getShareLink({
            albumId: publicAlbum.album.uuid,
            collectionId: publicAlbum.collection.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setCurrentPublicUserProfile(undefined);
            setCurrentPublicCollection(undefined);
            navigate(body.relativeShareLink);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: publicAlbums && publicAlbums.length > 0 ? publicAlbums?.map((publicAlbum, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: isMobile ? 12 : 12 / 5,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4071b1d31c0b698a$export$985ad8b5e9ffe85), {
                    album: publicAlbum.album,
                    collection: publicAlbum.collection,
                    userProfile: publicAlbum.userProfile,
                    onClick: async ()=>{
                        await showAlbum(publicAlbum);
                    }
                })
            }, index)) : Array.from({
            length: 15
        }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: isMobile ? 12 : 2.4,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5e04a7c133ac9ef6$exports))).item,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5e04a7c133ac9ef6$exports))).skeleton
                })
            }, index))
    });
};












parcelRequire("7fPBF");

var $8dbad181af17da4f$exports = {};

$parcel$export($8dbad181af17da4f$exports, "item", function () { return $8dbad181af17da4f$export$7061c75fc5af8b7e; }, function (v) { return $8dbad181af17da4f$export$7061c75fc5af8b7e = v; });
$parcel$export($8dbad181af17da4f$exports, "skeleton", function () { return $8dbad181af17da4f$export$2a0674ff2eb10214; }, function (v) { return $8dbad181af17da4f$export$2a0674ff2eb10214 = v; });
var $8dbad181af17da4f$export$7061c75fc5af8b7e;
var $8dbad181af17da4f$export$2a0674ff2eb10214;
$8dbad181af17da4f$export$7061c75fc5af8b7e = `i2U8Bq_item`;
$8dbad181af17da4f$export$2a0674ff2eb10214 = `i2U8Bq_skeleton`;




var $3ecbf9cb6c3837ef$exports = {};

$parcel$export($3ecbf9cb6c3837ef$exports, "avatar", function () { return $3ecbf9cb6c3837ef$export$345c5736c8054f22; }, function (v) { return $3ecbf9cb6c3837ef$export$345c5736c8054f22 = v; });
$parcel$export($3ecbf9cb6c3837ef$exports, "card", function () { return $3ecbf9cb6c3837ef$export$aa3e815946b80764; }, function (v) { return $3ecbf9cb6c3837ef$export$aa3e815946b80764 = v; });
$parcel$export($3ecbf9cb6c3837ef$exports, "name", function () { return $3ecbf9cb6c3837ef$export$a8ff84c12d48cfa6; }, function (v) { return $3ecbf9cb6c3837ef$export$a8ff84c12d48cfa6 = v; });
var $3ecbf9cb6c3837ef$export$345c5736c8054f22;
var $3ecbf9cb6c3837ef$export$aa3e815946b80764;
var $3ecbf9cb6c3837ef$export$a8ff84c12d48cfa6;
$3ecbf9cb6c3837ef$export$345c5736c8054f22 = `SdGxiW_avatar`;
$3ecbf9cb6c3837ef$export$aa3e815946b80764 = `SdGxiW_card`;
$3ecbf9cb6c3837ef$export$a8ff84c12d48cfa6 = `SdGxiW_name`;


parcelRequire("7fPBF");


const $614cc21c2e50cff6$export$4660a20ed7458002 = ({ userProfile: userProfile, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ecbf9cb6c3837ef$exports))).card,
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                justifyContent: "flex-start"
            },
            onClick: onClick,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignSelf: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79d5f228961267fd$export$6c0524ba53950d9f), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ecbf9cb6c3837ef$exports))).avatar,
                        userProfile: userProfile
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ecbf9cb6c3837ef$exports))).name,
                        children: userProfile.username
                    })
                ]
            })
        })
    });
};


const $c3e043c8f21c0b7d$export$569eb32711693cbb = ({ userProfiles: userProfiles, onUserProfileSelected: onUserProfileSelected, skeletonCount: skeletonCount })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: userProfiles && userProfiles.length > 0 ? userProfiles?.map((userProfile, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: isMobile ? 12 : 12 / 5,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $614cc21c2e50cff6$export$4660a20ed7458002), {
                    userProfile: userProfile,
                    onClick: ()=>onUserProfileSelected(userProfile)
                })
            }, index)) : Array.from({
            length: skeletonCount
        }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: isMobile ? 12 : 2.4,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8dbad181af17da4f$exports))).item,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8dbad181af17da4f$exports))).skeleton
                })
            }, index))
    });
};



const $6e89939ba75a8320$export$51d8746bd21c589f = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const shareSearchByText = (parameters)=>get("share/query", parameters);
    return {
        shareSearchByText: shareSearchByText
    };
};





var $7fPBF = parcelRequire("7fPBF");


const $9ea27f18ebbb39e0$export$d2cd2e12decd539f = (setLoading, dependencies = [])=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const storage = (0, $a8465eea29ce6625$export$e95767ffe2e60cec).highlightedAlbumStorage;
    const [highlightedAlbums, setHighlightedAlbums] = (0, $7fPBF.useState)(storage.getData(true, ""));
    (0, $7fPBF.useEffect)(()=>{
        if (highlightedAlbums && highlightedAlbums.length > 0) return;
        setLoading(true);
        get("albums/shared/highlights").then(({ body: body, status: status })=>{
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setHighlightedAlbums(body);
                storage.setData(body, true, "");
            }
            setLoading(false);
        });
    }, dependencies);
    return highlightedAlbums;
};










const $ad1df3ac02e9fa9d$export$23615bd8bff9ec3c = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).option_marketplace}`;
    }, []);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [, setCurrentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const [, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const { shareSearchByText: shareSearchByText } = (0, $6e89939ba75a8320$export$51d8746bd21c589f)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [isLoadingSearch, setIsLoadingSearch] = (0, $7fPBF.useState)(false);
    const [isLoadingNavigation, setIsLoadingNavigation] = (0, $7fPBF.useState)(false);
    const [isLoadingCollectionHighlights, setIsLoadingCollectionHighlights] = (0, $7fPBF.useState)(false);
    const [isLoadingAlbumHighlights, setIsLoadingAlbumHighlights] = (0, $7fPBF.useState)(false);
    const highlightedCollections = (0, $b9ad2596dd9fb182$export$8477e982e5e6d50)(setIsLoadingCollectionHighlights, []);
    const [publicCollections, setPublicCollections] = (0, $7fPBF.useState)();
    const highlightedAlbums = (0, $9ea27f18ebbb39e0$export$d2cd2e12decd539f)(setIsLoadingAlbumHighlights, []);
    const [publicAlbums, setPublicAlbums] = (0, $7fPBF.useState)();
    const [userProfiles, setUserProfiles] = (0, $7fPBF.useState)();
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [selectedUserProfile, setSelectedUserProfile] = (0, $7fPBF.useState)();
    const [isPublicUserProfileDialogOpen, setIsPublicUserProfileDialogOpen] = (0, $7fPBF.useState)(false);
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const searchContentByText = async ()=>{
        setIsLoadingSearch(true);
        const { status: status, body: body } = await shareSearchByText({
            query: searchText
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setPublicCollections(body.collections);
            setPublicAlbums(body.albums);
            setUserProfiles(body.userProfiles);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingSearch(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (searchText == "") return;
        searchContentByText().then();
    }, [
        searchText
    ]);
    const showCollection = async (publicCollection)=>{
        setIsLoadingNavigation(true);
        const { status: status, body: body } = await getShareLink({
            collectionId: publicCollection.collection.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setCurrentPublicUserProfile(undefined);
            setCurrentPublicCollection(undefined);
            navigate(body.relativeShareLink);
        }
        setIsLoadingNavigation(false);
    };
    const isLoading = ()=>{
        return isLoadingContent() || isLoadingNavigation;
    };
    const isLoadingContent = ()=>{
        return isLoadingCollectionHighlights || isLoadingAlbumHighlights || isLoadingSearch;
    };
    const collectionsToShow = ()=>{
        return searchText == "" ? highlightedCollections : publicCollections;
    };
    const albumsToShow = ()=>{
        return searchText == "" ? highlightedAlbums : publicAlbums;
    };
    const haveCollections = ()=>{
        return collectionsToShow() && (collectionsToShow()?.length ?? 0) > 0;
    };
    const haveAlbums = ()=>{
        return albumsToShow() && (albumsToShow()?.length ?? 0) > 0;
    };
    const haveUserProfiles = ()=>{
        return userProfiles && userProfiles.length > 0;
    };
    const goToUserProfile = ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile());
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                sx: {
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: theme.palette.background.default
                },
                elevation: 0,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                        position: "sticky",
                        sx: {
                            color: theme.palette.primary.main,
                            backgroundColor: theme.palette.colors?.appBar
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).toolbar,
                            disableGutters: true,
                            children: [
                                (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                                    style: {
                                        marginRight: isMobile ? 0 : 8
                                    },
                                    onClick: ()=>{
                                        setIsDrawerOpen(true);
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                                    currentPage: "marketplace",
                                    isOpen: isDrawerOpen,
                                    setIsOpen: setIsDrawerOpen,
                                    isLayout: false,
                                    isOpenDiscogsImport: isOpenDiscogsImport,
                                    setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                                    isOpenExcelImport: isOpenExcelImport,
                                    setIsOpenExcelImport: setIsOpenExcelImport
                                }),
                                !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).title,
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_marketplace
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).searchBar,
                                    style: {
                                        minWidth: isMobile ? undefined : 340
                                    },
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).marketplace_search_placeholder,
                                    onSearchRequested: (searchText)=>{
                                        setSearchText(searchText);
                                        setPublicCollections(undefined);
                                        setPublicAlbums(undefined);
                                        setUserProfiles(undefined);
                                    },
                                    onSearchDismissed: ()=>{
                                        setSearchText("");
                                        setPublicCollections(undefined);
                                        setPublicAlbums(undefined);
                                        setUserProfiles(undefined);
                                    },
                                    forceThisText: searchText,
                                    timed: true
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    onClick: ()=>setSearchText(""),
                                    disabled: searchText == "",
                                    loading: isLoading(),
                                    tooltip: isLoading() ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_search,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAltOff,
                                    color: theme.palette.colors?.remove
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $921bd0ad6d18d264$export$7bf40cd2a197df2d), {
                                    isPublic: false,
                                    userProfile: currentUserProfile,
                                    onClick: ()=>{
                                        if (!currentUserProfile || currentUser?.role == "guest") return;
                                        goToUserProfile();
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).mainCard,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).mainList,
                                children: [
                                    (isLoadingContent() || haveCollections()) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                spacing: 2,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).sectionTitle,
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).highlighted_collections_title
                                                }, "highlighted_collections_title")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).publicCollectionsCard,
                                                sx: {
                                                    marginBottom: 4
                                                },
                                                elevation: 4,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06f7abb9506f3e42$export$e0a080237481d5b1), {
                                                    isLoading: isLoading(),
                                                    publicCollections: collectionsToShow(),
                                                    columnWidth: isMobile ? 12 : 2.4,
                                                    skeletonCount: 5,
                                                    onCollectionSelected: showCollection,
                                                    showUser: true
                                                })
                                            })
                                        ]
                                    }),
                                    (isLoadingContent() || haveAlbums()) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                spacing: 2,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).sectionTitle,
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).highlighted_albums_title
                                                }, "highlighted_albums_title")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).publicCollectionsCard,
                                                sx: {
                                                    marginBottom: 4
                                                },
                                                elevation: 4,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a73c266737395a35$export$240f6d11e805b92e), {
                                                    publicAlbums: albumsToShow(),
                                                    setIsLoading: setIsLoadingNavigation
                                                })
                                            })
                                        ]
                                    }),
                                    haveUserProfiles() && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                spacing: 2,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).sectionTitle,
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).highlighted_users_title
                                                }, "highlighted_users_title")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).publicCollectionsCard,
                                                elevation: 4,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3e043c8f21c0b7d$export$569eb32711693cbb), {
                                                    userProfiles: userProfiles,
                                                    onUserProfileSelected: (userProfile)=>{
                                                        setSelectedUserProfile(userProfile);
                                                        setIsPublicUserProfileDialogOpen(true);
                                                    },
                                                    skeletonCount: 5
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                                isLoading: isLoading(),
                                items: haveCollections() || haveAlbums() || haveUserProfiles() ? [
                                    ""
                                ] : [],
                                emptyIconType: undefined,
                                emptyTitle: "",
                                emptyDescription: "",
                                searchText: searchText,
                                canAdd: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bc9b834667c203c1$exports))).credits
                    })
                ]
            }),
            selectedUserProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00fb49d9eec338cb$export$9bba71c7759c348b), {
                userProfile: selectedUserProfile,
                isOpen: isPublicUserProfileDialogOpen,
                setIsOpen: setIsPublicUserProfileDialogOpen,
                showCollectionInfo: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};


const $b3dbe2788dd4c1d0$export$9ed7a22cbadcc4c8 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad1df3ac02e9fa9d$export$23615bd8bff9ec3c), {});
};






var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $99170e1e1690344b$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$99170e1e1690344b$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $e9de76e0c16d95b3$exports = {};
'use strict';
Object.defineProperty($e9de76e0c16d95b3$exports, "__esModule", {
    value: true
});
var $e9de76e0c16d95b3$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $0b5329d3a0e1df99$exports = {};
'use strict';
var $0b5329d3a0e1df99$var$Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ $0b5329d3a0e1df99$var$Sister = function() {
    var sister = {}, events = {};
    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */ /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */ sister.on = function(name, handler) {
        var listener = {
            name: name,
            handler: handler
        };
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };
    /**
     * @param {listener}
     */ sister.off = function(listener) {
        var index = events[listener.name].indexOf(listener);
        if (index !== -1) events[listener.name].splice(index, 1);
    };
    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */ sister.trigger = function(name, data) {
        var listeners = events[name], i;
        if (listeners) {
            i = listeners.length;
            while(i--)listeners[i].handler(data);
        }
    };
    return sister;
};
$0b5329d3a0e1df99$exports = $0b5329d3a0e1df99$var$Sister;


var $e9de76e0c16d95b3$var$_sister2 = $e9de76e0c16d95b3$var$_interopRequireDefault($0b5329d3a0e1df99$exports);
var $444498e470e2a907$exports = {};
'use strict';
Object.defineProperty($444498e470e2a907$exports, "__esModule", {
    value: true
});
var $9226e5a5edf91467$exports = {};
$9226e5a5edf91467$exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) $9226e5a5edf91467$var$setAttributes(script, opts.attrs);
    if (opts.text) script.text = '' + opts.text;
    var onend = 'onload' in script ? $9226e5a5edf91467$var$stdOnEnd : $9226e5a5edf91467$var$ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) $9226e5a5edf91467$var$stdOnEnd(script, cb);
    head.appendChild(script);
};
function $9226e5a5edf91467$var$setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function $9226e5a5edf91467$var$stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function $9226e5a5edf91467$var$ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}


var $444498e470e2a907$var$_loadScript2 = $444498e470e2a907$var$_interopRequireDefault($9226e5a5edf91467$exports);
function $444498e470e2a907$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$444498e470e2a907$exports.default = function(emitter) {
    /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */ var iframeAPIReady = new Promise(function(resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
            resolve(window.YT);
            return;
        } else {
            var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
            (0, $444498e470e2a907$var$_loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function(error) {
                if (error) emitter.trigger('error', error);
            });
        }
        var previous = window.onYouTubeIframeAPIReady;
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function() {
            if (previous) previous();
            resolve(window.YT);
        };
    });
    return iframeAPIReady;
};
$444498e470e2a907$exports = $444498e470e2a907$exports['default'];


var $e9de76e0c16d95b3$var$_loadYouTubeIframeApi2 = $e9de76e0c16d95b3$var$_interopRequireDefault($444498e470e2a907$exports);
var $41121a3bb736a33f$exports = {};
'use strict';
Object.defineProperty($41121a3bb736a33f$exports, "__esModule", {
    value: true
});

var $hOaao = parcelRequire("hOaao");
var $41121a3bb736a33f$var$_debug2 = $41121a3bb736a33f$var$_interopRequireDefault($hOaao);
var $9b283853a19822a1$exports = {};
'use strict';
Object.defineProperty($9b283853a19822a1$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */ $9b283853a19822a1$exports.default = [
    'cueVideoById',
    'loadVideoById',
    'cueVideoByUrl',
    'loadVideoByUrl',
    'playVideo',
    'pauseVideo',
    'stopVideo',
    'getVideoLoadedFraction',
    'cuePlaylist',
    'loadPlaylist',
    'nextVideo',
    'previousVideo',
    'playVideoAt',
    'setShuffle',
    'setLoop',
    'getPlaylist',
    'getPlaylistIndex',
    'setOption',
    'mute',
    'unMute',
    'isMuted',
    'setVolume',
    'getVolume',
    'seekTo',
    'getPlayerState',
    'getPlaybackRate',
    'setPlaybackRate',
    'getAvailablePlaybackRates',
    'getPlaybackQuality',
    'setPlaybackQuality',
    'getAvailableQualityLevels',
    'getCurrentTime',
    'getDuration',
    'removeEventListener',
    'getVideoUrl',
    'getVideoEmbedCode',
    'getOptions',
    'getOption',
    'addEventListener',
    'destroy',
    'setSize',
    'getIframe'
];
$9b283853a19822a1$exports = $9b283853a19822a1$exports['default'];


var $41121a3bb736a33f$var$_functionNames2 = $41121a3bb736a33f$var$_interopRequireDefault($9b283853a19822a1$exports);
var $c72814b2da9f1cb4$exports = {};
'use strict';
Object.defineProperty($c72814b2da9f1cb4$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */ $c72814b2da9f1cb4$exports.default = [
    'ready',
    'stateChange',
    'playbackQualityChange',
    'playbackRateChange',
    'error',
    'apiChange',
    'volumeChange'
];
$c72814b2da9f1cb4$exports = $c72814b2da9f1cb4$exports['default'];


var $41121a3bb736a33f$var$_eventNames2 = $41121a3bb736a33f$var$_interopRequireDefault($c72814b2da9f1cb4$exports);
var $06c2f8eb1b94fe6d$exports = {};
'use strict';
Object.defineProperty($06c2f8eb1b94fe6d$exports, "__esModule", {
    value: true
});
var $68255e8af56ae753$exports = {};
"use strict";
Object.defineProperty($68255e8af56ae753$exports, "__esModule", {
    value: true
});
$68255e8af56ae753$exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
};
$68255e8af56ae753$exports = $68255e8af56ae753$exports["default"];


var $06c2f8eb1b94fe6d$var$_PlayerStates2 = $06c2f8eb1b94fe6d$var$_interopRequireDefault($68255e8af56ae753$exports);
function $06c2f8eb1b94fe6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$06c2f8eb1b94fe6d$exports.default = {
    pauseVideo: {
        acceptableStates: [
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.ENDED,
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: false
    },
    playVideo: {
        acceptableStates: [
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.ENDED,
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.PLAYING
        ],
        stateChangeRequired: false
    },
    seekTo: {
        acceptableStates: [
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.ENDED,
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.PLAYING,
            $06c2f8eb1b94fe6d$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: true,
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        timeout: 3000
    }
};
$06c2f8eb1b94fe6d$exports = $06c2f8eb1b94fe6d$exports['default'];


var $41121a3bb736a33f$var$_FunctionStateMap2 = $41121a3bb736a33f$var$_interopRequireDefault($06c2f8eb1b94fe6d$exports);
function $41121a3bb736a33f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable promise/prefer-await-to-then */ var $41121a3bb736a33f$var$debug = (0, $41121a3bb736a33f$var$_debug2.default)('youtube-player');
var $41121a3bb736a33f$var$YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */ $41121a3bb736a33f$var$YouTubePlayer.proxyEvents = function(emitter) {
    var events = {};
    var _loop = function _loop(eventName) {
        var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
        events[onEventName] = function(event) {
            $41121a3bb736a33f$var$debug('event "%s"', onEventName, event);
            emitter.trigger(eventName, event);
        };
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $41121a3bb736a33f$var$_eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */ $41121a3bb736a33f$var$YouTubePlayer.promisifyPlayer = function(playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var functions = {};
    var _loop2 = function _loop2(functionName) {
        if (strictState && $41121a3bb736a33f$var$_FunctionStateMap2.default[functionName]) functions[functionName] = function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return playerAPIReady.then(function(player) {
                var stateInfo = $41121a3bb736a33f$var$_FunctionStateMap2.default[functionName];
                var playerState = player.getPlayerState();
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                var value = player[functionName].apply(player, args);
                // TRICKY: For functions like `seekTo`, a change in state must be
                // triggered given that the resulting state could match the initial
                // state.
                if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) return new Promise(function(resolve) {
                    var onPlayerStateChange = function onPlayerStateChange() {
                        var playerStateAfterChange = player.getPlayerState();
                        var timeout = void 0;
                        if (typeof stateInfo.timeout === 'number') timeout = setTimeout(function() {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            resolve();
                        }, stateInfo.timeout);
                        if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            clearTimeout(timeout);
                            resolve();
                        }
                    };
                    player.addEventListener('onStateChange', onPlayerStateChange);
                }).then(function() {
                    return value;
                });
                return value;
            });
        };
        else functions[functionName] = function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return playerAPIReady.then(function(player) {
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                return player[functionName].apply(player, args);
            });
        };
    };
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $41121a3bb736a33f$var$_functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var functionName = _step2.value;
            _loop2(functionName);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
    return functions;
};
$41121a3bb736a33f$exports.default = $41121a3bb736a33f$var$YouTubePlayer;
$41121a3bb736a33f$exports = $41121a3bb736a33f$exports['default'];


var $e9de76e0c16d95b3$var$_YouTubePlayer2 = $e9de76e0c16d95b3$var$_interopRequireDefault($41121a3bb736a33f$exports);
function $e9de76e0c16d95b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */ /**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */ var $e9de76e0c16d95b3$var$youtubeIframeAPI = void 0;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */ $e9de76e0c16d95b3$exports.default = function(maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var emitter = (0, $e9de76e0c16d95b3$var$_sister2.default)();
    if (!$e9de76e0c16d95b3$var$youtubeIframeAPI) $e9de76e0c16d95b3$var$youtubeIframeAPI = (0, $e9de76e0c16d95b3$var$_loadYouTubeIframeApi2.default)(emitter);
    if (options.events) throw new Error('Event handlers cannot be overwritten.');
    if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) throw new Error('Element "' + maybeElementId + '" does not exist.');
    options.events = $e9de76e0c16d95b3$var$_YouTubePlayer2.default.proxyEvents(emitter);
    var playerAPIReady = new Promise(function(resolve) {
        if ((typeof maybeElementId === 'undefined' ? 'undefined' : $e9de76e0c16d95b3$var$_typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
            var player = maybeElementId;
            resolve(player);
        } else // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        $e9de76e0c16d95b3$var$youtubeIframeAPI.then(function(YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
            emitter.on('ready', function() {
                resolve(player);
            });
            return null;
        });
    });
    var playerApi = $e9de76e0c16d95b3$var$_YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    playerApi.on = emitter.on;
    playerApi.off = emitter.off;
    return playerApi;
};
$e9de76e0c16d95b3$exports = $e9de76e0c16d95b3$exports['default'];


var $950f2109a927a9d5$var$__defProp = Object.defineProperty;
var $950f2109a927a9d5$var$__defProps = Object.defineProperties;
var $950f2109a927a9d5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $950f2109a927a9d5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $950f2109a927a9d5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $950f2109a927a9d5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $950f2109a927a9d5$var$__defNormalProp = (obj, key, value)=>key in obj ? $950f2109a927a9d5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $950f2109a927a9d5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($950f2109a927a9d5$var$__hasOwnProp.call(b, prop)) $950f2109a927a9d5$var$__defNormalProp(a, prop, b[prop]);
    if ($950f2109a927a9d5$var$__getOwnPropSymbols) {
        for (var prop of $950f2109a927a9d5$var$__getOwnPropSymbols(b))if ($950f2109a927a9d5$var$__propIsEnum.call(b, prop)) $950f2109a927a9d5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $950f2109a927a9d5$var$__spreadProps = (a, b)=>$950f2109a927a9d5$var$__defProps(a, $950f2109a927a9d5$var$__getOwnPropDescs(b));
var $950f2109a927a9d5$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
function $950f2109a927a9d5$var$shouldUpdateVideo(prevProps, props) {
    var _a, _b;
    if (prevProps.videoId !== props.videoId) return true;
    const prevVars = ((_a = prevProps.opts) == null ? void 0 : _a.playerVars) || {};
    const vars = ((_b = props.opts) == null ? void 0 : _b.playerVars) || {};
    return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
function $950f2109a927a9d5$var$filterResetOptions(opts = {}) {
    return $950f2109a927a9d5$var$__spreadProps($950f2109a927a9d5$var$__spreadValues({}, opts), {
        height: 0,
        width: 0,
        playerVars: $950f2109a927a9d5$var$__spreadProps($950f2109a927a9d5$var$__spreadValues({}, opts.playerVars), {
            autoplay: 0,
            start: 0,
            end: 0
        })
    });
}
function $950f2109a927a9d5$var$shouldResetPlayer(prevProps, props) {
    return prevProps.videoId !== props.videoId || !(0, (/*@__PURE__*/$parcel$interopDefault($99170e1e1690344b$exports)))($950f2109a927a9d5$var$filterResetOptions(prevProps.opts), $950f2109a927a9d5$var$filterResetOptions(props.opts));
}
function $950f2109a927a9d5$var$shouldUpdatePlayer(prevProps, props) {
    var _a, _b, _c, _d;
    return prevProps.id !== props.id || prevProps.className !== props.className || ((_a = prevProps.opts) == null ? void 0 : _a.width) !== ((_b = props.opts) == null ? void 0 : _b.width) || ((_c = prevProps.opts) == null ? void 0 : _c.height) !== ((_d = props.opts) == null ? void 0 : _d.height) || prevProps.iframeClassName !== props.iframeClassName || prevProps.title !== props.title;
}
var $950f2109a927a9d5$var$defaultProps = {
    videoId: "",
    id: "",
    className: "",
    iframeClassName: "",
    style: {},
    title: "",
    loading: void 0,
    opts: {},
    onReady: ()=>{},
    onError: ()=>{},
    onPlay: ()=>{},
    onPause: ()=>{},
    onEnd: ()=>{},
    onStateChange: ()=>{},
    onPlaybackRateChange: ()=>{},
    onPlaybackQualityChange: ()=>{}
};
var $950f2109a927a9d5$var$propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    iframeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        "lazy",
        "eager"
    ]),
    opts: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any),
    onReady: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onPlay: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onPause: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onPlaybackRateChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onPlaybackQualityChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $950f2109a927a9d5$var$_YouTube = class extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    constructor(props){
        super(props);
        this.destroyPlayerPromise = void 0;
        this.onPlayerReady = (event)=>{
            var _a, _b;
            return (_b = (_a = this.props).onReady) == null ? void 0 : _b.call(_a, event);
        };
        this.onPlayerError = (event)=>{
            var _a, _b;
            return (_b = (_a = this.props).onError) == null ? void 0 : _b.call(_a, event);
        };
        this.onPlayerStateChange = (event)=>{
            var _a, _b, _c, _d, _e, _f, _g, _h;
            (_b = (_a = this.props).onStateChange) == null || _b.call(_a, event);
            switch(event.data){
                case $950f2109a927a9d5$var$_YouTube.PlayerState.ENDED:
                    (_d = (_c = this.props).onEnd) == null || _d.call(_c, event);
                    break;
                case $950f2109a927a9d5$var$_YouTube.PlayerState.PLAYING:
                    (_f = (_e = this.props).onPlay) == null || _f.call(_e, event);
                    break;
                case $950f2109a927a9d5$var$_YouTube.PlayerState.PAUSED:
                    (_h = (_g = this.props).onPause) == null || _h.call(_g, event);
                    break;
                default:
            }
        };
        this.onPlayerPlaybackRateChange = (event)=>{
            var _a, _b;
            return (_b = (_a = this.props).onPlaybackRateChange) == null ? void 0 : _b.call(_a, event);
        };
        this.onPlayerPlaybackQualityChange = (event)=>{
            var _a, _b;
            return (_b = (_a = this.props).onPlaybackQualityChange) == null ? void 0 : _b.call(_a, event);
        };
        this.destroyPlayer = ()=>{
            if (this.internalPlayer) {
                this.destroyPlayerPromise = this.internalPlayer.destroy().then(()=>this.destroyPlayerPromise = void 0);
                return this.destroyPlayerPromise;
            }
            return Promise.resolve();
        };
        this.createPlayer = ()=>{
            if (typeof document === "undefined") return;
            if (this.destroyPlayerPromise) {
                this.destroyPlayerPromise.then(this.createPlayer);
                return;
            }
            const playerOpts = $950f2109a927a9d5$var$__spreadProps($950f2109a927a9d5$var$__spreadValues({}, this.props.opts), {
                videoId: this.props.videoId
            });
            this.internalPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($e9de76e0c16d95b3$exports)))(this.container, playerOpts);
            this.internalPlayer.on("ready", this.onPlayerReady);
            this.internalPlayer.on("error", this.onPlayerError);
            this.internalPlayer.on("stateChange", this.onPlayerStateChange);
            this.internalPlayer.on("playbackRateChange", this.onPlayerPlaybackRateChange);
            this.internalPlayer.on("playbackQualityChange", this.onPlayerPlaybackQualityChange);
            if (this.props.title || this.props.loading) this.internalPlayer.getIframe().then((iframe)=>{
                if (this.props.title) iframe.setAttribute("title", this.props.title);
                if (this.props.loading) iframe.setAttribute("loading", this.props.loading);
            });
        };
        this.resetPlayer = ()=>this.destroyPlayer().then(this.createPlayer);
        this.updatePlayer = ()=>{
            var _a;
            (_a = this.internalPlayer) == null || _a.getIframe().then((iframe)=>{
                if (this.props.id) iframe.setAttribute("id", this.props.id);
                else iframe.removeAttribute("id");
                if (this.props.iframeClassName) iframe.setAttribute("class", this.props.iframeClassName);
                else iframe.removeAttribute("class");
                if (this.props.opts && this.props.opts.width) iframe.setAttribute("width", this.props.opts.width.toString());
                else iframe.removeAttribute("width");
                if (this.props.opts && this.props.opts.height) iframe.setAttribute("height", this.props.opts.height.toString());
                else iframe.removeAttribute("height");
                if (this.props.title) iframe.setAttribute("title", this.props.title);
                else iframe.setAttribute("title", "YouTube video player");
                if (this.props.loading) iframe.setAttribute("loading", this.props.loading);
                else iframe.removeAttribute("loading");
            });
        };
        this.getInternalPlayer = ()=>{
            return this.internalPlayer;
        };
        this.updateVideo = ()=>{
            var _a, _b, _c, _d;
            if (typeof this.props.videoId === "undefined" || this.props.videoId === null) {
                (_a = this.internalPlayer) == null || _a.stopVideo();
                return;
            }
            let autoplay = false;
            const opts = {
                videoId: this.props.videoId
            };
            if ((_b = this.props.opts) == null ? void 0 : _b.playerVars) {
                autoplay = this.props.opts.playerVars.autoplay === 1;
                if ("start" in this.props.opts.playerVars) opts.startSeconds = this.props.opts.playerVars.start;
                if ("end" in this.props.opts.playerVars) opts.endSeconds = this.props.opts.playerVars.end;
            }
            if (autoplay) {
                (_c = this.internalPlayer) == null || _c.loadVideoById(opts);
                return;
            }
            (_d = this.internalPlayer) == null || _d.cueVideoById(opts);
        };
        this.refContainer = (container)=>{
            this.container = container;
        };
        this.container = null;
        this.internalPlayer = null;
    }
    componentDidMount() {
        this.createPlayer();
    }
    componentDidUpdate(prevProps) {
        return $950f2109a927a9d5$var$__async(this, null, function*() {
            if ($950f2109a927a9d5$var$shouldUpdatePlayer(prevProps, this.props)) this.updatePlayer();
            if ($950f2109a927a9d5$var$shouldResetPlayer(prevProps, this.props)) yield this.resetPlayer();
            if ($950f2109a927a9d5$var$shouldUpdateVideo(prevProps, this.props)) this.updateVideo();
        });
    }
    componentWillUnmount() {
        this.destroyPlayer();
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: this.props.className,
            style: this.props.style
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            id: this.props.id,
            className: this.props.iframeClassName,
            ref: this.refContainer
        }));
    }
};
var $950f2109a927a9d5$var$YouTube = $950f2109a927a9d5$var$_YouTube;
$950f2109a927a9d5$var$YouTube.propTypes = $950f2109a927a9d5$var$propTypes;
$950f2109a927a9d5$var$YouTube.defaultProps = $950f2109a927a9d5$var$defaultProps;
$950f2109a927a9d5$var$YouTube.PlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
};
var $950f2109a927a9d5$export$2e2bcd8739ae039 = $950f2109a927a9d5$var$YouTube;


// lib/Draggable.tsx

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");
function $72686d015f03b164$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $72686d015f03b164$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $72686d015f03b164$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $72686d015f03b164$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $72686d015f03b164$export$2e2bcd8739ae039 = $72686d015f03b164$export$4f5d2d50c9deca37;


// lib/utils/shims.ts
function $8da0932f3bdcb08f$var$findInArray(array, callback) {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $8da0932f3bdcb08f$var$isFunction(func) {
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $8da0932f3bdcb08f$var$isNum(num) {
    return typeof num === "number" && !isNaN(num);
}
function $8da0932f3bdcb08f$var$int(a) {
    return parseInt(a, 10);
}
function $8da0932f3bdcb08f$var$dontSetMe(props, propName, componentName) {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}
// lib/utils/getPrefix.ts
var $8da0932f3bdcb08f$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $8da0932f3bdcb08f$var$getPrefix(prop = "transform") {
    var _a, _b;
    if (typeof window === "undefined") return "";
    const style = (_b = (_a = window.document) == null ? void 0 : _a.documentElement) == null ? void 0 : _b.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $8da0932f3bdcb08f$var$prefixes.length; i++){
        if ($8da0932f3bdcb08f$var$browserPrefixToKey(prop, $8da0932f3bdcb08f$var$prefixes[i]) in style) return $8da0932f3bdcb08f$var$prefixes[i];
    }
    return "";
}
function $8da0932f3bdcb08f$var$browserPrefixToKey(prop, prefix) {
    return prefix ? `${prefix}${$8da0932f3bdcb08f$var$kebabToTitleCase(prop)}` : prop;
}
function $8da0932f3bdcb08f$var$kebabToTitleCase(str) {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
var $8da0932f3bdcb08f$var$getPrefix_default = $8da0932f3bdcb08f$var$getPrefix();
// lib/utils/domFns.ts
var $8da0932f3bdcb08f$var$matchesSelectorFunc = "";
function $8da0932f3bdcb08f$var$matchesSelector(el, selector) {
    var _a;
    if (!$8da0932f3bdcb08f$var$matchesSelectorFunc) $8da0932f3bdcb08f$var$matchesSelectorFunc = (_a = $8da0932f3bdcb08f$var$findInArray([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        return $8da0932f3bdcb08f$var$isFunction(el[method]);
    })) != null ? _a : "";
    const matchFn = el[$8da0932f3bdcb08f$var$matchesSelectorFunc];
    if (!$8da0932f3bdcb08f$var$isFunction(matchFn)) return false;
    return Boolean(matchFn.call(el, selector));
}
function $8da0932f3bdcb08f$var$matchesSelectorAndParentsTo(el, selector, baseNode) {
    let node = el;
    do {
        if ($8da0932f3bdcb08f$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $8da0932f3bdcb08f$var$addEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.addEventListener) el.addEventListener(event, listener, options);
    else if (el.attachEvent) el.attachEvent("on" + event, listener);
    else el["on" + event] = listener;
}
function $8da0932f3bdcb08f$var$removeEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.removeEventListener) el.removeEventListener(event, listener, options);
    else if (el.detachEvent) el.detachEvent("on" + event, listener);
    else el["on" + event] = null;
}
function $8da0932f3bdcb08f$var$outerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += $8da0932f3bdcb08f$var$int(computedStyle.borderTopWidth);
    height += $8da0932f3bdcb08f$var$int(computedStyle.borderBottomWidth);
    return height;
}
function $8da0932f3bdcb08f$var$outerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += $8da0932f3bdcb08f$var$int(computedStyle.borderLeftWidth);
    width += $8da0932f3bdcb08f$var$int(computedStyle.borderRightWidth);
    return width;
}
function $8da0932f3bdcb08f$var$innerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= $8da0932f3bdcb08f$var$int(computedStyle.paddingTop);
    height -= $8da0932f3bdcb08f$var$int(computedStyle.paddingBottom);
    return height;
}
function $8da0932f3bdcb08f$var$innerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= $8da0932f3bdcb08f$var$int(computedStyle.paddingLeft);
    width -= $8da0932f3bdcb08f$var$int(computedStyle.paddingRight);
    return width;
}
function $8da0932f3bdcb08f$var$offsetXYFromParent(evt, offsetParent, scale) {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $8da0932f3bdcb08f$var$createCSSTransform(controlPos, positionOffset) {
    const translation = $8da0932f3bdcb08f$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [$8da0932f3bdcb08f$var$browserPrefixToKey("transform", $8da0932f3bdcb08f$var$getPrefix_default)]: translation
    };
}
function $8da0932f3bdcb08f$var$createSVGTransform(controlPos, positionOffset) {
    const translation = $8da0932f3bdcb08f$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $8da0932f3bdcb08f$var$getTranslation({ x: x, y: y }, positionOffset, unitSuffix) {
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $8da0932f3bdcb08f$var$getTouch(e, identifier) {
    return e.targetTouches && $8da0932f3bdcb08f$var$findInArray(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && $8da0932f3bdcb08f$var$findInArray(e.changedTouches, (t)=>identifier === t.identifier);
}
function $8da0932f3bdcb08f$var$getTouchIdentifier(e) {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function $8da0932f3bdcb08f$var$getDefaultNonce() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : void 0;
}
function $8da0932f3bdcb08f$var$addUserSelectStyles(doc, nonce) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        const resolvedNonce = nonce != null ? nonce : $8da0932f3bdcb08f$var$getDefaultNonce();
        if (resolvedNonce) styleEl.setAttribute("nonce", resolvedNonce);
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $8da0932f3bdcb08f$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $8da0932f3bdcb08f$var$scheduleRemoveUserSelectStyles(doc) {
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $8da0932f3bdcb08f$var$removeUserSelectStyles(doc);
    });
    else $8da0932f3bdcb08f$var$removeUserSelectStyles(doc);
}
function $8da0932f3bdcb08f$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $8da0932f3bdcb08f$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        const ieSelection = doc.selection;
        if (ieSelection) ieSelection.empty();
        else {
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch  {}
}
function $8da0932f3bdcb08f$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $8da0932f3bdcb08f$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, "g"), "");
}
// lib/utils/positionFns.ts
function $8da0932f3bdcb08f$var$getBoundPosition(draggable, x, y) {
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $8da0932f3bdcb08f$var$cloneBounds(bounds);
    const node = $8da0932f3bdcb08f$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        if (!ownerWindow) throw new Error("Cannot resolve the owner window of the draggable node.");
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else {
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl = boundNode;
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        bounds = {
            left: -node.offsetLeft + $8da0932f3bdcb08f$var$int(boundNodeStyle.paddingLeft) + $8da0932f3bdcb08f$var$int(nodeStyle.marginLeft),
            top: -node.offsetTop + $8da0932f3bdcb08f$var$int(boundNodeStyle.paddingTop) + $8da0932f3bdcb08f$var$int(nodeStyle.marginTop),
            right: $8da0932f3bdcb08f$var$innerWidth(boundNodeEl) - $8da0932f3bdcb08f$var$outerWidth(node) - node.offsetLeft + $8da0932f3bdcb08f$var$int(boundNodeStyle.paddingRight) - $8da0932f3bdcb08f$var$int(nodeStyle.marginRight),
            bottom: $8da0932f3bdcb08f$var$innerHeight(boundNodeEl) - $8da0932f3bdcb08f$var$outerHeight(node) - node.offsetTop + $8da0932f3bdcb08f$var$int(boundNodeStyle.paddingBottom) - $8da0932f3bdcb08f$var$int(nodeStyle.marginBottom)
        };
    }
    if ($8da0932f3bdcb08f$var$isNum(bounds.right)) x = Math.min(x, bounds.right);
    if ($8da0932f3bdcb08f$var$isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
    if ($8da0932f3bdcb08f$var$isNum(bounds.left)) x = Math.max(x, bounds.left);
    if ($8da0932f3bdcb08f$var$isNum(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $8da0932f3bdcb08f$var$snapToGrid(grid, pendingX, pendingY) {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $8da0932f3bdcb08f$var$canDragX(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $8da0932f3bdcb08f$var$canDragY(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function $8da0932f3bdcb08f$var$getControlPosition(e, touchIdentifier, draggableCore) {
    const touchObj = typeof touchIdentifier === "number" ? $8da0932f3bdcb08f$var$getTouch(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null;
    const node = $8da0932f3bdcb08f$var$findDOMNode(draggableCore);
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return $8da0932f3bdcb08f$var$offsetXYFromParent(touchObj || e, offsetParent, draggableCore.props.scale);
}
function $8da0932f3bdcb08f$var$createCoreData(draggable, x, y) {
    const isStart = !$8da0932f3bdcb08f$var$isNum(draggable.lastX);
    const node = $8da0932f3bdcb08f$var$findDOMNode(draggable);
    if (isStart) return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
function $8da0932f3bdcb08f$var$createDraggableData(draggable, coreData) {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
function $8da0932f3bdcb08f$var$cloneBounds(bounds) {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $8da0932f3bdcb08f$var$findDOMNode(draggable) {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    return node;
}
// lib/utils/log.ts
var $8da0932f3bdcb08f$var$log = function noop() {};
var $8da0932f3bdcb08f$var$log_default = $8da0932f3bdcb08f$var$log;
// lib/DraggableCore.tsx
var $8da0932f3bdcb08f$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
var $8da0932f3bdcb08f$var$dragEventFor = $8da0932f3bdcb08f$var$eventsFor.mouse;
var $8da0932f3bdcb08f$export$512ffe43e525b6fc = class extends $7fPBF.Component {
    constructor(){
        super(...arguments);
        this.dragging = false;
        // Used while dragging to determine deltas.
        this.lastX = NaN;
        this.lastY = NaN;
        this.touchIdentifier = null;
        this.mounted = false;
        this.handleDragStart = (e)=>{
            this.props.onMouseDown(e);
            if (!this.props.allowAnyClick && (typeof e.button === "number" && e.button !== 0 || e.ctrlKey)) return false;
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !$8da0932f3bdcb08f$var$matchesSelectorAndParentsTo(e.target, this.props.handle, thisNode) || this.props.cancel && $8da0932f3bdcb08f$var$matchesSelectorAndParentsTo(e.target, this.props.cancel, thisNode)) return;
            if (e.type === "touchstart" && !this.props.allowMobileScroll) e.preventDefault();
            const touchIdentifier = $8da0932f3bdcb08f$var$getTouchIdentifier(e);
            this.touchIdentifier = touchIdentifier;
            const position = $8da0932f3bdcb08f$var$getControlPosition(e, touchIdentifier, this);
            if (position == null) return;
            const { x: x, y: y } = position;
            const coreEvent = $8da0932f3bdcb08f$var$createCoreData(this, x, y);
            $8da0932f3bdcb08f$var$log_default("DraggableCore: handleDragStart: %j", coreEvent);
            $8da0932f3bdcb08f$var$log_default("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            if (this.props.enableUserSelectHack) $8da0932f3bdcb08f$var$addUserSelectStyles(ownerDocument, this.props.nonce);
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            $8da0932f3bdcb08f$var$addEvent(ownerDocument, $8da0932f3bdcb08f$var$dragEventFor.move, this.handleDrag);
            $8da0932f3bdcb08f$var$addEvent(ownerDocument, $8da0932f3bdcb08f$var$dragEventFor.stop, this.handleDragStop);
        };
        this.handleDrag = (e)=>{
            const position = $8da0932f3bdcb08f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = $8da0932f3bdcb08f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return;
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $8da0932f3bdcb08f$var$createCoreData(this, x, y);
            $8da0932f3bdcb08f$var$log_default("DraggableCore: handleDrag: %j", coreEvent);
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch  {
                    const event = document.createEvent("MouseEvents");
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        };
        this.handleDragStop = (e)=>{
            if (!this.dragging) return;
            const position = $8da0932f3bdcb08f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = $8da0932f3bdcb08f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $8da0932f3bdcb08f$var$createCoreData(this, x, y);
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) {
                if (this.props.enableUserSelectHack) $8da0932f3bdcb08f$var$scheduleRemoveUserSelectStyles(thisNode.ownerDocument);
            }
            $8da0932f3bdcb08f$var$log_default("DraggableCore: handleDragStop: %j", coreEvent);
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                $8da0932f3bdcb08f$var$log_default("DraggableCore: Removing handlers");
                $8da0932f3bdcb08f$var$removeEvent(thisNode.ownerDocument, $8da0932f3bdcb08f$var$dragEventFor.move, this.handleDrag);
                $8da0932f3bdcb08f$var$removeEvent(thisNode.ownerDocument, $8da0932f3bdcb08f$var$dragEventFor.stop, this.handleDragStop);
            }
        };
        this.onMouseDown = (e)=>{
            $8da0932f3bdcb08f$var$dragEventFor = $8da0932f3bdcb08f$var$eventsFor.mouse;
            return this.handleDragStart(e);
        };
        this.onMouseUp = (e)=>{
            $8da0932f3bdcb08f$var$dragEventFor = $8da0932f3bdcb08f$var$eventsFor.mouse;
            return this.handleDragStop(e);
        };
        // Same as onMouseDown (start drag), but now consider this a touch device.
        this.onTouchStart = (e)=>{
            $8da0932f3bdcb08f$var$dragEventFor = $8da0932f3bdcb08f$var$eventsFor.touch;
            return this.handleDragStart(e);
        };
        this.onTouchEnd = (e)=>{
            $8da0932f3bdcb08f$var$dragEventFor = $8da0932f3bdcb08f$var$eventsFor.touch;
            return this.handleDragStop(e);
        };
    }
    componentDidMount() {
        this.mounted = true;
        const thisNode = this.findDOMNode();
        if (thisNode) $8da0932f3bdcb08f$var$addEvent(thisNode, $8da0932f3bdcb08f$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            $8da0932f3bdcb08f$var$removeEvent(ownerDocument, $8da0932f3bdcb08f$var$eventsFor.mouse.move, this.handleDrag);
            $8da0932f3bdcb08f$var$removeEvent(ownerDocument, $8da0932f3bdcb08f$var$eventsFor.touch.move, this.handleDrag);
            $8da0932f3bdcb08f$var$removeEvent(ownerDocument, $8da0932f3bdcb08f$var$eventsFor.mouse.stop, this.handleDragStop);
            $8da0932f3bdcb08f$var$removeEvent(ownerDocument, $8da0932f3bdcb08f$var$eventsFor.touch.stop, this.handleDragStop);
            $8da0932f3bdcb08f$var$removeEvent(thisNode, $8da0932f3bdcb08f$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) $8da0932f3bdcb08f$var$scheduleRemoveUserSelectStyles(ownerDocument);
        }
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        $8da0932f3bdcb08f$var$log_default("react-draggable: ReactDOM.findDOMNode is not available in React 19+. You must provide a nodeRef prop. See: https://github.com/react-grid-layout/react-draggable#noderef");
        return null;
    }
    render() {
        return $7fPBF.cloneElement($7fPBF.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
};
$8da0932f3bdcb08f$export$512ffe43e525b6fc.displayName = "DraggableCore";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/Draggable.tsx for the same guard.
$8da0932f3bdcb08f$export$512ffe43e525b6fc.propTypes = {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * `nonce` is applied to the dynamically-injected <style> element used by the
   * user-select hack, so it isn't blocked under a strict Content Security
   * Policy (`style-src` without `'unsafe-inline'`). If omitted, webpack's
   * `__webpack_nonce__` global is used when available.
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $8da0932f3bdcb08f$var$dontSetMe,
    style: $8da0932f3bdcb08f$var$dontSetMe,
    transform: $8da0932f3bdcb08f$var$dontSetMe
};
// Typed as the full `DraggableCoreProps` (not just the default-provided subset)
// so React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$8da0932f3bdcb08f$export$512ffe43e525b6fc.defaultProps = {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
};
// lib/Draggable.tsx
var $8da0932f3bdcb08f$export$f2a139e5d18b9882 = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.onDragStart = (e, coreData)=>{
            $8da0932f3bdcb08f$var$log_default("Draggable: onDragStart: %j", coreData);
            const shouldStart = this.props.onStart(e, $8da0932f3bdcb08f$var$createDraggableData(this, coreData));
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        };
        this.onDrag = (e, coreData)=>{
            if (!this.state.dragging) return false;
            $8da0932f3bdcb08f$var$log_default("Draggable: onDrag: %j", coreData);
            const uiData = $8da0932f3bdcb08f$var$createDraggableData(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            if (this.props.bounds) {
                const { x: x, y: y } = newState;
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                const [newStateX, newStateY] = $8da0932f3bdcb08f$var$getBoundPosition(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        };
        this.onDragStop = (e, coreData)=>{
            if (!this.state.dragging) return false;
            const shouldContinue = this.props.onStop(e, $8da0932f3bdcb08f$var$createDraggableData(this, coreData));
            if (shouldContinue === false) return false;
            $8da0932f3bdcb08f$var$log_default("Draggable: onDragStop: %j", coreData);
            const newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        };
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps({ position: position }, { prevPropsPosition: prevPropsPosition }) {
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            $8da0932f3bdcb08f$var$log_default("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        });
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        return null;
    }
    render() {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: $8da0932f3bdcb08f$var$canDragX(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: $8da0932f3bdcb08f$var$canDragY(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) svgTransform = $8da0932f3bdcb08f$var$createSVGTransform(transformOpts, positionOffset);
        else style = $8da0932f3bdcb08f$var$createCSSTransform(transformOpts, positionOffset);
        const onlyChild = $7fPBF.Children.only(children);
        const className = (0, $72686d015f03b164$export$4f5d2d50c9deca37)(onlyChild.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        return /* @__PURE__ */ $7fPBF.createElement($8da0932f3bdcb08f$export$512ffe43e525b6fc, {
            ...draggableCoreProps,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }, $7fPBF.cloneElement(onlyChild, {
            className: className,
            style: {
                ...onlyChild.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
};
$8da0932f3bdcb08f$export$f2a139e5d18b9882.displayName = "Draggable";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/DraggableCore.tsx for the same guard.
$8da0932f3bdcb08f$export$f2a139e5d18b9882.propTypes = {
    // Accepts all props <DraggableCore> accepts.
    ...$8da0932f3bdcb08f$export$512ffe43e525b6fc.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
            left: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
            right: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
            top: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
            false
        ])
    ]),
    defaultClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    defaultClassNameDragging: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    defaultClassNameDragged: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number
    }),
    positionOffset: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $8da0932f3bdcb08f$var$dontSetMe,
    style: $8da0932f3bdcb08f$var$dontSetMe,
    transform: $8da0932f3bdcb08f$var$dontSetMe
};
// Typed as the full `DraggableProps` (not just the default-provided subset) so
// React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$8da0932f3bdcb08f$export$f2a139e5d18b9882.defaultProps = {
    ...$8da0932f3bdcb08f$export$512ffe43e525b6fc.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
};


// lib/cjs.ts
var $6be0bfc0e3449438$export$2e2bcd8739ae039 = (0, $8da0932f3bdcb08f$export$f2a139e5d18b9882);


var $672300ea37a70229$exports = {};

$parcel$export($672300ea37a70229$exports, "title", function () { return $672300ea37a70229$export$fb184b623420d9be; }, function (v) { return $672300ea37a70229$export$fb184b623420d9be = v; });
$parcel$export($672300ea37a70229$exports, "toolbar", function () { return $672300ea37a70229$export$f727f52c778e92d5; }, function (v) { return $672300ea37a70229$export$f727f52c778e92d5 = v; });
var $672300ea37a70229$export$fb184b623420d9be;
var $672300ea37a70229$export$f727f52c778e92d5;
$672300ea37a70229$export$fb184b623420d9be = `Kl7t6G_title`;
$672300ea37a70229$export$f727f52c778e92d5 = `Kl7t6G_toolbar`;


var $fa21b90bd983ab43$exports = {};


!function(e, t) {
    $fa21b90bd983ab43$exports = t((parcelRequire("7fPBF")), (parcelRequire("fw0lo")));
}($fa21b90bd983ab43$exports, function(e, t) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var o = n(e), r = n(t);
    function i(e, t) {
        for(var n = 0; n < t.length; n++){
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
    }
    function c(e, t) {
        return c = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        }, c(e, t);
    }
    function s(e) {
        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, s(e);
    }
    function u(e, t) {
        if (t && ("object" === s(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }(e);
    }
    function l(e) {
        return l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, l(e);
    }
    var a, d, f, p, h = {
        exports: {}
    };
    function w(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var n, o = l(e);
            if (t) {
                var r = l(this).constructor;
                n = Reflect.construct(o, arguments, r);
            } else n = o.apply(this, arguments);
            return u(this, n);
        };
    }
    h.exports = (function() {
        if (p) return f;
        p = 1;
        var e = d ? a : (d = 1, a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
        function t() {}
        function n() {}
        return n.resetWarningCache = t, f = function() {
            function o(t, n, o, r, i, c) {
                if (c !== e) {
                    var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw s.name = "Invariant Violation", s;
                }
            }
            function r() {
                return o;
            }
            o.isRequired = o;
            var i = {
                array: o,
                bool: o,
                func: o,
                number: o,
                object: o,
                string: o,
                symbol: o,
                any: o,
                arrayOf: r,
                element: o,
                elementType: o,
                instanceOf: r,
                node: o,
                objectOf: r,
                oneOf: r,
                oneOfType: r,
                shape: r,
                exact: r,
                checkPropTypes: n,
                resetWarningCache: t
            };
            return i.PropTypes = i, i;
        };
    })()();
    var y, m, v, b = function(e) {
        !function(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && c(e, t);
        }(u, e);
        var t, n, o, s = w(u);
        function u(e) {
            var t;
            return function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, u), (t = s.call(this, e)).container = null, t.window = null, t.windowCheckerInterval = null, t.released = !1, t.state = {
                mounted: !1
            }, t;
        }
        return t = u, n = [
            {
                key: "render",
                value: function() {
                    return this.state.mounted ? r.default.createPortal(this.props.children, this.container) : null;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    this.window || this.container || (this.openChild(), this.setState({
                        mounted: !0
                    }));
                }
            },
            {
                key: "openChild",
                value: function() {
                    var e, t = this, n = this.props, o = n.url, r = n.title, i = n.name, c = n.features, s = n.onBlock, u = n.onOpen, l = n.center;
                    if ("string" != typeof l || void 0 !== c.width && void 0 !== c.height) {
                        if ("parent" === l) c.left = window.top.outerWidth / 2 + window.top.screenX - c.width / 2, c.top = window.top.outerHeight / 2 + window.top.screenY - c.height / 2;
                        else if ("screen" === l) {
                            var a = void 0 !== window.screenLeft ? window.screenLeft : window.screen.left, d = void 0 !== window.screenTop ? window.screenTop : window.screen.top, f = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width, p = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
                            c.left = f / 2 - c.width / 2 + a, c.top = p / 2 - c.height / 2 + d;
                        }
                    } else console.warn("width and height window features must be present when a center prop is provided");
                    if (this.window = window.open(o, i, (e = c, Object.keys(e).reduce(function(t, n) {
                        var o = e[n];
                        return "boolean" == typeof o ? t.push("".concat(n, "=").concat(o ? "yes" : "no")) : t.push("".concat(n, "=").concat(o)), t;
                    }, []).join(","))), this.container = this.window.document.createElement("div"), this.windowCheckerInterval = setInterval(function() {
                        t.window && !t.window.closed || t.release();
                    }, 50), this.window) {
                        if (this.window.document.title = r, this.container = this.window.document.getElementById("new-window-container"), null === this.container) this.container = this.window.document.createElement("div"), this.container.setAttribute("id", "new-window-container"), this.window.document.body.appendChild(this.container);
                        else {
                            var h = this.window.document.getElementById("new-window-container-static");
                            this.window.document.body.removeChild(h);
                        }
                        this.props.copyStyles && setTimeout(function() {
                            var e, n, o;
                            return e = document, n = t.window.document, o = n.createDocumentFragment(), Array.from(e.styleSheets).forEach(function(e) {
                                var t;
                                try {
                                    t = e.cssRules;
                                } catch (e) {
                                    console.error(e);
                                }
                                if (t) {
                                    var r = [];
                                    Array.from(e.cssRules).forEach(function(e) {
                                        var t = e.type;
                                        if (t !== CSSRule.UNKNOWN_RULE) {
                                            var n = "";
                                            n = t === CSSRule.KEYFRAMES_RULE ? function(e) {
                                                var t = [
                                                    "@keyframes",
                                                    e.name,
                                                    "{"
                                                ];
                                                return Array.from(e.cssRules).forEach(function(e) {
                                                    t.push(e.keyText, "{", e.style.cssText, "}");
                                                }), t.push("}"), t.join(" ");
                                            }(e) : [
                                                CSSRule.IMPORT_RULE,
                                                CSSRule.FONT_FACE_RULE
                                            ].includes(t) ? function(e) {
                                                return e.cssText.split("url(").map(function(e) {
                                                    return "/" === e[1] ? "".concat(e.slice(0, 1)).concat(window.location.origin).concat(e.slice(1)) : e;
                                                }).join("url(");
                                            }(e) : e.cssText, r.push(n);
                                        }
                                    });
                                    var i = n.createElement("style");
                                    i.textContent = r.join("\n"), o.appendChild(i);
                                } else if (e.href) {
                                    var c = n.createElement("link");
                                    c.rel = "stylesheet", c.href = e.href, o.appendChild(c);
                                }
                            }), void n.head.appendChild(o);
                        }, 0), "function" == typeof u && u(this.window), this.window.addEventListener("beforeunload", function() {
                            return t.release();
                        });
                    } else "function" == typeof s ? s(null) : console.warn("A new window could not be opened. Maybe it was blocked.");
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    if (this.state.mounted && this.window) {
                        if (this.props.closeOnUnmount) this.window.close();
                        else if (this.props.children) {
                            var e = this.container.cloneNode(!0);
                            e.setAttribute("id", "new-window-container-static"), this.window.document.body.appendChild(e);
                        }
                    }
                }
            },
            {
                key: "release",
                value: function() {
                    if (!this.released) {
                        this.released = !0, clearInterval(this.windowCheckerInterval);
                        var e = this.props.onUnload;
                        "function" == typeof e && e(null);
                    }
                }
            }
        ], i(t.prototype, n), o && i(t, o), u;
    }(o.default.PureComponent);
    return v = {
        url: "",
        name: "",
        title: "",
        features: {
            width: "600px",
            height: "640px"
        },
        onBlock: null,
        onOpen: null,
        onUnload: null,
        center: "parent",
        copyStyles: !0,
        closeOnUnmount: !0
    }, (m = "defaultProps") in (y = b) ? Object.defineProperty(y, m, {
        value: v,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : y[m] = v, b.propTypes = {
        children: h.exports.node,
        url: h.exports.string,
        name: h.exports.string,
        title: h.exports.string,
        features: h.exports.object,
        onUnload: h.exports.func,
        onBlock: h.exports.func,
        onOpen: h.exports.func,
        center: h.exports.oneOf([
            "parent",
            "screen"
        ]),
        copyStyles: h.exports.bool,
        closeOnUnmount: h.exports.bool
    }, b;
});





function $e37a2cf7859d130a$var$PaperComponent(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
        ...props,
        style: {
            margin: 0,
            maxHeight: "100%",
            backgroundColor: "black",
            backgroundImage: "none"
        }
    });
}
const $e37a2cf7859d130a$export$ae716c5c5ead198b = ({ title: title, videoIds: videoIds, open: open, setOpen: setOpen })=>{
    const [inNewWindow, setInNewWindow] = (0, $7fPBF.useState)(false);
    const opts = {
        height: "308",
        width: "526",
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
            playlist: videoIds?.join(",")
        }
    };
    const newWindowOpts = {
        height: "100%",
        width: "100%",
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
            playlist: videoIds?.join(",")
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: inNewWindow ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            children: open && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fa21b90bd983ab43$exports))), {
                copyStyles: true,
                title: title,
                center: "parent",
                onUnload: ()=>{
                    setOpen(false);
                    setInNewWindow(false);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $950f2109a927a9d5$export$2e2bcd8739ae039), {
                    opts: newWindowOpts
                })
            })
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6be0bfc0e3449438$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                open: open,
                hideBackdrop: true,
                disableEnforceFocus: true,
                disableScrollLock: true,
                PaperComponent: $e37a2cf7859d130a$var$PaperComponent,
                sx: {
                    width: "fit-content",
                    height: "fit-content"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        disableGutters: true,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($672300ea37a70229$exports))).toolbar,
                        style: {
                            cursor: "move"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($672300ea37a70229$exports))).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setInNewWindow(true);
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).OpenInNew
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setOpen(false);
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $950f2109a927a9d5$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($672300ea37a70229$exports))).player,
                        opts: opts
                    })
                ]
            })
        })
    });
};



parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $af90c3e080d12216$exports = {};

$parcel$export($af90c3e080d12216$exports, "appleButton", function () { return $af90c3e080d12216$export$41838e8fb02f6d64; }, function (v) { return $af90c3e080d12216$export$41838e8fb02f6d64 = v; });
$parcel$export($af90c3e080d12216$exports, "backButton", function () { return $af90c3e080d12216$export$8d6d009d1f06226e; }, function (v) { return $af90c3e080d12216$export$8d6d009d1f06226e = v; });
$parcel$export($af90c3e080d12216$exports, "footer", function () { return $af90c3e080d12216$export$adb608be33961c98; }, function (v) { return $af90c3e080d12216$export$adb608be33961c98 = v; });
$parcel$export($af90c3e080d12216$exports, "googleButton", function () { return $af90c3e080d12216$export$42243f34c2f401d5; }, function (v) { return $af90c3e080d12216$export$42243f34c2f401d5 = v; });
$parcel$export($af90c3e080d12216$exports, "logoImage", function () { return $af90c3e080d12216$export$3ba0bfd74bc3a6fe; }, function (v) { return $af90c3e080d12216$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($af90c3e080d12216$exports, "mainContent", function () { return $af90c3e080d12216$export$ad430d422a89f9f0; }, function (v) { return $af90c3e080d12216$export$ad430d422a89f9f0 = v; });
$parcel$export($af90c3e080d12216$exports, "mainDiv", function () { return $af90c3e080d12216$export$16666caf1c4e1af1; }, function (v) { return $af90c3e080d12216$export$16666caf1c4e1af1 = v; });
$parcel$export($af90c3e080d12216$exports, "subtitle", function () { return $af90c3e080d12216$export$c96745152eb2740f; }, function (v) { return $af90c3e080d12216$export$c96745152eb2740f = v; });
$parcel$export($af90c3e080d12216$exports, "text", function () { return $af90c3e080d12216$export$6f093cfa640b7166; }, function (v) { return $af90c3e080d12216$export$6f093cfa640b7166 = v; });
$parcel$export($af90c3e080d12216$exports, "title", function () { return $af90c3e080d12216$export$fb184b623420d9be; }, function (v) { return $af90c3e080d12216$export$fb184b623420d9be = v; });
var $af90c3e080d12216$export$41838e8fb02f6d64;
var $af90c3e080d12216$export$8d6d009d1f06226e;
var $af90c3e080d12216$export$adb608be33961c98;
var $af90c3e080d12216$export$42243f34c2f401d5;
var $af90c3e080d12216$export$3ba0bfd74bc3a6fe;
var $af90c3e080d12216$export$ad430d422a89f9f0;
var $af90c3e080d12216$export$16666caf1c4e1af1;
var $af90c3e080d12216$export$c96745152eb2740f;
var $af90c3e080d12216$export$6f093cfa640b7166;
var $af90c3e080d12216$export$fb184b623420d9be;
$af90c3e080d12216$export$41838e8fb02f6d64 = `U3_ryG_appleButton`;
$af90c3e080d12216$export$8d6d009d1f06226e = `U3_ryG_backButton`;
$af90c3e080d12216$export$adb608be33961c98 = `U3_ryG_footer`;
$af90c3e080d12216$export$42243f34c2f401d5 = `U3_ryG_googleButton`;
$af90c3e080d12216$export$3ba0bfd74bc3a6fe = `U3_ryG_logoImage`;
$af90c3e080d12216$export$ad430d422a89f9f0 = `U3_ryG_mainContent`;
$af90c3e080d12216$export$16666caf1c4e1af1 = `U3_ryG_mainDiv`;
$af90c3e080d12216$export$c96745152eb2740f = `U3_ryG_subtitle`;
$af90c3e080d12216$export$6f093cfa640b7166 = `U3_ryG_text`;
$af90c3e080d12216$export$fb184b623420d9be = `U3_ryG_title`;









const $39fbc536d74fc05b$export$31641b61980e511f = ()=>{
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        document.title = (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name;
    }, []);
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).mainDiv,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).mainContent,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).logoImage,
                        src: piperTextImage,
                        alt: "Piper"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).title,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).greetings
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).subtitle,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).not_found_subtitle
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).text,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).not_found_message
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).backButton,
                        onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home()),
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).back_to_app
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).footer,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).not_found_queries
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af90c3e080d12216$exports))).footer,
                        href: `mailto: ${(0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail}`,
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
        ]
    });
};


const $4bedca6cde600b0a$export$6ba01d3268a66fe8 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fbc536d74fc05b$export$31641b61980e511f), {});
};





parcelRequire("7fPBF");



parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $b9a7c6c1f03a36c6$exports = {};

$parcel$export($b9a7c6c1f03a36c6$exports, "breadcrumbs", function () { return $b9a7c6c1f03a36c6$export$515d2155aaad79e4; }, function (v) { return $b9a7c6c1f03a36c6$export$515d2155aaad79e4 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "container", function () { return $b9a7c6c1f03a36c6$export$34e0f9847d4c02dd; }, function (v) { return $b9a7c6c1f03a36c6$export$34e0f9847d4c02dd = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "creditsMobile", function () { return $b9a7c6c1f03a36c6$export$afcc3cebfa8978b6; }, function (v) { return $b9a7c6c1f03a36c6$export$afcc3cebfa8978b6 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "footer", function () { return $b9a7c6c1f03a36c6$export$adb608be33961c98; }, function (v) { return $b9a7c6c1f03a36c6$export$adb608be33961c98 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "header", function () { return $b9a7c6c1f03a36c6$export$38e42c68cf43b5d4; }, function (v) { return $b9a7c6c1f03a36c6$export$38e42c68cf43b5d4 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "logo", function () { return $b9a7c6c1f03a36c6$export$db3c28d99448dcff; }, function (v) { return $b9a7c6c1f03a36c6$export$db3c28d99448dcff = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "logoImage", function () { return $b9a7c6c1f03a36c6$export$3ba0bfd74bc3a6fe; }, function (v) { return $b9a7c6c1f03a36c6$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "mainContent", function () { return $b9a7c6c1f03a36c6$export$ad430d422a89f9f0; }, function (v) { return $b9a7c6c1f03a36c6$export$ad430d422a89f9f0 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "mainDiv", function () { return $b9a7c6c1f03a36c6$export$16666caf1c4e1af1; }, function (v) { return $b9a7c6c1f03a36c6$export$16666caf1c4e1af1 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "options", function () { return $b9a7c6c1f03a36c6$export$41c562ebe57d11e2; }, function (v) { return $b9a7c6c1f03a36c6$export$41c562ebe57d11e2 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "scrollReference", function () { return $b9a7c6c1f03a36c6$export$d870d4da3657fa40; }, function (v) { return $b9a7c6c1f03a36c6$export$d870d4da3657fa40 = v; });
$parcel$export($b9a7c6c1f03a36c6$exports, "text", function () { return $b9a7c6c1f03a36c6$export$6f093cfa640b7166; }, function (v) { return $b9a7c6c1f03a36c6$export$6f093cfa640b7166 = v; });
var $b9a7c6c1f03a36c6$export$515d2155aaad79e4;
var $b9a7c6c1f03a36c6$export$34e0f9847d4c02dd;
var $b9a7c6c1f03a36c6$export$afcc3cebfa8978b6;
var $b9a7c6c1f03a36c6$export$adb608be33961c98;
var $b9a7c6c1f03a36c6$export$38e42c68cf43b5d4;
var $b9a7c6c1f03a36c6$export$db3c28d99448dcff;
var $b9a7c6c1f03a36c6$export$3ba0bfd74bc3a6fe;
var $b9a7c6c1f03a36c6$export$ad430d422a89f9f0;
var $b9a7c6c1f03a36c6$export$16666caf1c4e1af1;
var $b9a7c6c1f03a36c6$export$41c562ebe57d11e2;
var $b9a7c6c1f03a36c6$export$d870d4da3657fa40;
var $b9a7c6c1f03a36c6$export$6f093cfa640b7166;
$b9a7c6c1f03a36c6$export$515d2155aaad79e4 = `D1jzaG_breadcrumbs`;
$b9a7c6c1f03a36c6$export$34e0f9847d4c02dd = `D1jzaG_container`;
$b9a7c6c1f03a36c6$export$afcc3cebfa8978b6 = `D1jzaG_creditsMobile`;
$b9a7c6c1f03a36c6$export$adb608be33961c98 = `D1jzaG_footer`;
$b9a7c6c1f03a36c6$export$38e42c68cf43b5d4 = `D1jzaG_header`;
$b9a7c6c1f03a36c6$export$db3c28d99448dcff = `D1jzaG_logo`;
$b9a7c6c1f03a36c6$export$3ba0bfd74bc3a6fe = `D1jzaG_logoImage`;
$b9a7c6c1f03a36c6$export$ad430d422a89f9f0 = `D1jzaG_mainContent`;
$b9a7c6c1f03a36c6$export$16666caf1c4e1af1 = `D1jzaG_mainDiv`;
$b9a7c6c1f03a36c6$export$41c562ebe57d11e2 = `D1jzaG_options`;
$b9a7c6c1f03a36c6$export$d870d4da3657fa40 = `D1jzaG_scrollReference`;
$b9a7c6c1f03a36c6$export$6f093cfa640b7166 = `D1jzaG_text`;







var $7fPBF = parcelRequire("7fPBF");


var $5fe7f63a06f79c4d$exports = {};

$parcel$export($5fe7f63a06f79c4d$exports, "itemTitle", function () { return $5fe7f63a06f79c4d$export$19d20253129869a; }, function (v) { return $5fe7f63a06f79c4d$export$19d20253129869a = v; });
$parcel$export($5fe7f63a06f79c4d$exports, "listButton", function () { return $5fe7f63a06f79c4d$export$20f2b929a61cd28d; }, function (v) { return $5fe7f63a06f79c4d$export$20f2b929a61cd28d = v; });
var $5fe7f63a06f79c4d$export$19d20253129869a;
var $5fe7f63a06f79c4d$export$20f2b929a61cd28d;
$5fe7f63a06f79c4d$export$19d20253129869a = `SfYHda_itemTitle`;
$5fe7f63a06f79c4d$export$20f2b929a61cd28d = `SfYHda_listButton`;






var $7fPBF = parcelRequire("7fPBF");






function $1793c5bd2348dd77$export$a9a855983a3a6110(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTreeView', slot);
}
const $1793c5bd2348dd77$export$5461f9a163854bc2 = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTreeView', [
    'root'
]);




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $09383b1f59bfc1c2$export$aefee358f9275586 = {
    instance: null,
    multiSelect: false,
    disabledItemsFocusable: false,
    treeId: undefined,
    icons: {
        defaultCollapseIcon: null,
        defaultExpandIcon: null,
        defaultParentIcon: null,
        defaultEndIcon: null
    }
};
const $09383b1f59bfc1c2$export$5e4715462ac10946 = /*#__PURE__*/ $7fPBF.createContext($09383b1f59bfc1c2$export$aefee358f9275586);




var $7fPBF = parcelRequire("7fPBF");
const $6c2b7e31c515f3c9$export$d8d5655036da9a9f = (plugins, props)=>{
    const modelsRef = $7fPBF.useRef({});
    const [modelsState, setModelsState] = $7fPBF.useState(()=>{
        const initialState = {};
        plugins.forEach((plugin)=>{
            if (plugin.models) Object.entries(plugin.models).forEach(([modelName, model])=>{
                modelsRef.current[modelName] = {
                    controlledProp: model.controlledProp,
                    defaultProp: model.defaultProp,
                    isControlled: props[model.controlledProp] !== undefined
                };
                initialState[modelName] = props[model.defaultProp];
            });
        });
        return initialState;
    });
    const models = Object.fromEntries(Object.entries(modelsRef.current).map(([modelName, model])=>{
        const value = model.isControlled ? props[model.controlledProp] : modelsState[modelName];
        return [
            modelName,
            {
                value: value,
                setValue: (newValue)=>{
                    if (!model.isControlled) setModelsState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                            [modelName]: newValue
                        }));
                }
            }
        ];
    }));
    var modelName, model;
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ return models;
};



var $7fPBF = parcelRequire("7fPBF");
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $ce172b4dc37073cf$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}


const $a9b1b07948f3a713$export$441b3b812f976516 = (instance, nodeId)=>{
    const node = instance.getNode(nodeId);
    const siblings = instance.getNavigableChildrenIds(node.parentId);
    const nodeIndex = siblings.indexOf(nodeId);
    if (nodeIndex === 0) return node.parentId;
    let currentNode = siblings[nodeIndex - 1];
    while(instance.isNodeExpanded(currentNode) && instance.getNavigableChildrenIds(currentNode).length > 0)currentNode = instance.getNavigableChildrenIds(currentNode).pop();
    return currentNode;
};
const $a9b1b07948f3a713$export$9f79023ffc34e62d = (instance, nodeId)=>{
    // If expanded get first child
    if (instance.isNodeExpanded(nodeId) && instance.getNavigableChildrenIds(nodeId).length > 0) return instance.getNavigableChildrenIds(nodeId)[0];
    let node = instance.getNode(nodeId);
    while(node != null){
        // Try to get next sibling
        const siblings = instance.getNavigableChildrenIds(node.parentId);
        const nextSibling = siblings[siblings.indexOf(node.id) + 1];
        if (nextSibling) return nextSibling;
        // If the sibling does not exist, go up a level to the parent and try again.
        node = instance.getNode(node.parentId);
    }
    return null;
};
const $a9b1b07948f3a713$export$549d8f2ade049982 = (instance)=>{
    let lastNode = instance.getNavigableChildrenIds(null).pop();
    while(instance.isNodeExpanded(lastNode))lastNode = instance.getNavigableChildrenIds(lastNode).pop();
    return lastNode;
};
const $a9b1b07948f3a713$export$217510d54aa1b77f = (instance)=>instance.getNavigableChildrenIds(null)[0];
const $a9b1b07948f3a713$export$cd92e33cfd3a0015 = (instance, methods)=>{
    Object.assign(instance, methods);
};


const $f13f30fd24cd0597$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
const $f13f30fd24cd0597$export$93654c0b7fe1355a = ({ instance: instance })=>{
    const [eventManager] = $7fPBF.useState(()=>new (0, $ce172b4dc37073cf$export$cc74486daaaef499)());
    const publishEvent = $7fPBF.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($f13f30fd24cd0597$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        eventManager.emit(name, params, event);
    }, [
        eventManager
    ]);
    const subscribeEvent = $7fPBF.useCallback((event, handler)=>{
        eventManager.on(event, handler);
        return ()=>{
            eventManager.removeListener(event, handler);
        };
    }, [
        eventManager
    ]);
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        $$publishEvent: publishEvent,
        $$subscribeEvent: subscribeEvent
    });
};


const $079d37a2785c60f7$export$bc5724d26f7fe1f8 = [
    (0, $f13f30fd24cd0597$export$93654c0b7fe1355a)
];


const $541d2bcb72d13709$export$1e79c2a653523352 = (inParams)=>{
    const plugins = [
        ...(0, $079d37a2785c60f7$export$bc5724d26f7fe1f8),
        ...inParams.plugins
    ];
    const params = plugins.reduce((acc, plugin)=>{
        if (plugin.getDefaultizedParams) return plugin.getDefaultizedParams(acc);
        return acc;
    }, inParams);
    const models = (0, $6c2b7e31c515f3c9$export$d8d5655036da9a9f)(plugins, params);
    const instanceRef = $7fPBF.useRef({});
    const instance = instanceRef.current;
    const innerRootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(innerRootRef, inParams.rootRef);
    const [state, setState] = $7fPBF.useState(()=>{
        const temp = {};
        plugins.forEach((plugin)=>{
            if (plugin.getInitialState) Object.assign(temp, plugin.getInitialState(params));
        });
        return temp;
    });
    const rootPropsGetters = [];
    let contextValue = (0, $09383b1f59bfc1c2$export$aefee358f9275586);
    const runPlugin = (plugin)=>{
        const pluginResponse = plugin({
            instance: instance,
            params: params,
            state: state,
            setState: setState,
            rootRef: innerRootRef,
            models: models
        }) || {};
        if (pluginResponse.getRootProps) rootPropsGetters.push(pluginResponse.getRootProps);
        if (pluginResponse.contextValue) contextValue = pluginResponse.contextValue;
    };
    plugins.forEach(runPlugin);
    const getRootProps = (otherHandlers = {})=>{
        const rootProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            role: 'tree',
            tabIndex: 0
        }, otherHandlers, {
            ref: handleRootRef
        });
        rootPropsGetters.forEach((rootPropsGetter)=>{
            Object.assign(rootProps, rootPropsGetter(otherHandlers));
        });
        return rootProps;
    };
    return {
        getRootProps: getRootProps,
        rootRef: handleRootRef,
        contextValue: contextValue
    };
};


parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



const $bd7175c00fc5aa5c$var$_excluded = [
    "element"
];
function $bd7175c00fc5aa5c$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
function $bd7175c00fc5aa5c$var$binaryFindElement(array, element) {
    let start = 0;
    let end = array.length - 1;
    while(start <= end){
        const middle = Math.floor((start + end) / 2);
        if (array[middle].element === element) return middle;
        // eslint-disable-next-line no-bitwise
        if (array[middle].element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) end = middle - 1;
        else start = middle + 1;
    }
    return start;
}
const $bd7175c00fc5aa5c$var$DescendantContext = /*#__PURE__*/ $7fPBF.createContext({});
function $bd7175c00fc5aa5c$var$usePrevious(value) {
    const ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
const $bd7175c00fc5aa5c$var$noop = ()=>{};
function $bd7175c00fc5aa5c$export$b7626b291207e517(descendant) {
    const [, forceUpdate] = $7fPBF.useState();
    const { registerDescendant: registerDescendant = $bd7175c00fc5aa5c$var$noop, unregisterDescendant: unregisterDescendant = $bd7175c00fc5aa5c$var$noop, descendants: descendants = [], parentId: parentId = null } = $7fPBF.useContext($bd7175c00fc5aa5c$var$DescendantContext);
    // This will initially return -1 because we haven't registered the descendant
    // on the first render. After we register, this will then return the correct
    // index on the following render, and we will re-register descendants
    // so that everything is up-to-date before the user interacts with a
    // collection.
    const index = $bd7175c00fc5aa5c$var$findIndex(descendants, (item)=>item.element === descendant.element);
    const previousDescendants = $bd7175c00fc5aa5c$var$usePrevious(descendants);
    // We also need to re-register descendants any time ANY of the other
    // descendants have changed. My brain was melting when I wrote this and it
    // feels a little off, but checking in render and using the result in the
    // effect's dependency array works well enough.
    const someDescendantsHaveChanged = descendants.some((newDescendant, position)=>{
        return previousDescendants && previousDescendants[position] && previousDescendants[position].element !== newDescendant.element;
    });
    // Prevent any flashing
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (descendant.element) {
            registerDescendant((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, descendant, {
                index: index
            }));
            return ()=>{
                unregisterDescendant(descendant.element);
            };
        }
        forceUpdate({});
        return undefined;
    }, [
        registerDescendant,
        unregisterDescendant,
        index,
        someDescendantsHaveChanged,
        descendant
    ]);
    return {
        parentId: parentId,
        index: index
    };
}
function $bd7175c00fc5aa5c$export$c46937d8801f1c9c(props) {
    const { children: children, id: id } = props;
    const [items, set] = $7fPBF.useState([]);
    const registerDescendant = $7fPBF.useCallback((_ref)=>{
        let { element: element } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $bd7175c00fc5aa5c$var$_excluded);
        set((oldItems)=>{
            if (oldItems.length === 0) // If there are no items, register at index 0 and bail.
            return [
                (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
                    element: element,
                    index: 0
                })
            ];
            const index = $bd7175c00fc5aa5c$var$binaryFindElement(oldItems, element);
            let newItems;
            if (oldItems[index] && oldItems[index].element === element) // If the element is already registered, just use the same array
            newItems = oldItems;
            else {
                // When registering a descendant, we need to make sure we insert in
                // into the array in the same order that it appears in the DOM. So as
                // new descendants are added or maybe some are removed, we always know
                // that the array is up-to-date and correct.
                //
                // So here we look at our registered descendants and see if the new
                // element we are adding appears earlier than an existing descendant's
                // DOM node via `node.compareDocumentPosition`. If it does, we insert
                // the new element at this index. Because `registerDescendant` will be
                // called in an effect every time the descendants state value changes,
                // we should be sure that this index is accurate when descendent
                // elements come or go from our component.
                const newItem = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
                    element: element,
                    index: index
                });
                // If an index is not found we will push the element to the end.
                newItems = oldItems.slice();
                newItems.splice(index, 0, newItem);
            }
            newItems.forEach((item, position)=>{
                item.index = position;
            });
            return newItems;
        });
    }, []);
    const unregisterDescendant = $7fPBF.useCallback((element)=>{
        set((oldItems)=>oldItems.filter((item)=>element !== item.element));
    }, []);
    const value = $7fPBF.useMemo(()=>({
            descendants: items,
            registerDescendant: registerDescendant,
            unregisterDescendant: unregisterDescendant,
            parentId: id
        }), [
        items,
        registerDescendant,
        unregisterDescendant,
        id
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bd7175c00fc5aa5c$var$DescendantContext.Provider, {
        value: value,
        children: children
    });
}



function $3b70addf9417c64f$export$6a399b2f7f12632c(props) {
    const { value: value, children: children } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09383b1f59bfc1c2$export$5e4715462ac10946).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd7175c00fc5aa5c$export$c46937d8801f1c9c), {
            children: children
        })
    });
}




var $7fPBF = parcelRequire("7fPBF");


const $84f62dbbba50af4b$export$d5c088e621d1d7a3 = (instance, eventName, params)=>{
    instance.$$publishEvent(eventName, params);
};


const $ff3248ced6d97573$export$dde229fbb0afd1fe = ({ instance: instance, params: params })=>{
    const nodeMap = $7fPBF.useRef({});
    const getNode = $7fPBF.useCallback((nodeId)=>nodeMap.current[nodeId], []);
    const insertNode = $7fPBF.useCallback((node)=>{
        nodeMap.current[node.id] = node;
    }, []);
    const removeNode = $7fPBF.useCallback((nodeId)=>{
        const newMap = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, nodeMap.current);
        delete newMap[nodeId];
        nodeMap.current = newMap;
        (0, $84f62dbbba50af4b$export$d5c088e621d1d7a3)(instance, 'removeNode', {
            id: nodeId
        });
    }, [
        instance
    ]);
    const isNodeDisabled = $7fPBF.useCallback((nodeId)=>{
        if (nodeId == null) return false;
        let node = instance.getNode(nodeId);
        // This can be called before the node has been added to the node map.
        if (!node) return false;
        if (node.disabled) return true;
        while(node.parentId != null){
            node = instance.getNode(node.parentId);
            if (node.disabled) return true;
        }
        return false;
    }, [
        instance
    ]);
    const getChildrenIds = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nodeId)=>Object.values(nodeMap.current).filter((node)=>node.parentId === nodeId).sort((a, b)=>a.index - b.index).map((child)=>child.id));
    const getNavigableChildrenIds = (nodeId)=>{
        let childrenIds = instance.getChildrenIds(nodeId);
        if (!params.disabledItemsFocusable) childrenIds = childrenIds.filter((node)=>!instance.isNodeDisabled(node));
        return childrenIds;
    };
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        getNode: getNode,
        updateNode: insertNode,
        removeNode: removeNode,
        getChildrenIds: getChildrenIds,
        getNavigableChildrenIds: getNavigableChildrenIds,
        isNodeDisabled: isNodeDisabled
    });
};




var $7fPBF = parcelRequire("7fPBF");


const $e583d9a82c02b374$export$f198a27ee171dd2b = ({ instance: instance, params: params, models: models })=>{
    const isNodeExpanded = $7fPBF.useCallback((nodeId)=>{
        return Array.isArray(models.expanded.value) ? models.expanded.value.indexOf(nodeId) !== -1 : false;
    }, [
        models.expanded.value
    ]);
    const isNodeExpandable = $7fPBF.useCallback((nodeId)=>{
        var _instance$getNode;
        return !!((_instance$getNode = instance.getNode(nodeId)) != null && _instance$getNode.expandable);
    }, [
        instance
    ]);
    const toggleNodeExpansion = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, nodeId)=>{
        if (nodeId == null) return;
        let newExpanded;
        if (models.expanded.value.indexOf(nodeId) !== -1) newExpanded = models.expanded.value.filter((id)=>id !== nodeId);
        else newExpanded = [
            nodeId
        ].concat(models.expanded.value);
        if (params.onNodeToggle) params.onNodeToggle(event, newExpanded);
        models.expanded.setValue(newExpanded);
    });
    const expandAllSiblings = (event, nodeId)=>{
        const node = instance.getNode(nodeId);
        const siblings = instance.getChildrenIds(node.parentId);
        const diff = siblings.filter((child)=>instance.isNodeExpandable(child) && !instance.isNodeExpanded(child));
        const newExpanded = models.expanded.value.concat(diff);
        if (diff.length > 0) {
            models.expanded.setValue(newExpanded);
            if (params.onNodeToggle) params.onNodeToggle(event, newExpanded);
        }
    };
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        isNodeExpanded: isNodeExpanded,
        isNodeExpandable: isNodeExpandable,
        toggleNodeExpansion: toggleNodeExpansion,
        expandAllSiblings: expandAllSiblings
    });
};
$e583d9a82c02b374$export$f198a27ee171dd2b.models = {
    expanded: {
        controlledProp: 'expanded',
        defaultProp: 'defaultExpanded'
    }
};
const $e583d9a82c02b374$var$DEFAULT_EXPANDED = [];
$e583d9a82c02b374$export$f198a27ee171dd2b.getDefaultizedParams = (params)=>{
    var _params$defaultExpand;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        defaultExpanded: (_params$defaultExpand = params.defaultExpanded) != null ? _params$defaultExpand : $e583d9a82c02b374$var$DEFAULT_EXPANDED
    });
};




var $7fPBF = parcelRequire("7fPBF");

/**
 * This is used to determine the start and end of a selection range so
 * we can get the nodes between the two border nodes.
 *
 * It finds the nodes' common ancestor using
 * a naive implementation of a lowest common ancestor algorithm
 * (https://en.wikipedia.org/wiki/Lowest_common_ancestor).
 * Then compares the ancestor's 2 children that are ancestors of nodeA and NodeB
 * so we can compare their indexes to work out which node comes first in a depth first search.
 * (https://en.wikipedia.org/wiki/Depth-first_search)
 *
 * Another way to put it is which node is shallower in a trémaux tree
 * https://en.wikipedia.org/wiki/Tr%C3%A9maux_tree
 */ const $d5ad12a0b51e097a$export$17d19e2e752066c5 = (instance, nodeAId, nodeBId)=>{
    if (nodeAId === nodeBId) return [
        nodeAId,
        nodeBId
    ];
    const nodeA = instance.getNode(nodeAId);
    const nodeB = instance.getNode(nodeBId);
    if (nodeA.parentId === nodeB.id || nodeB.parentId === nodeA.id) return nodeB.parentId === nodeA.id ? [
        nodeA.id,
        nodeB.id
    ] : [
        nodeB.id,
        nodeA.id
    ];
    const aFamily = [
        nodeA.id
    ];
    const bFamily = [
        nodeB.id
    ];
    let aAncestor = nodeA.parentId;
    let bAncestor = nodeB.parentId;
    let aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    let bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    let continueA = true;
    let continueB = true;
    while(!bAncestorIsCommon && !aAncestorIsCommon){
        if (continueA) {
            aFamily.push(aAncestor);
            aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
            continueA = aAncestor !== null;
            if (!aAncestorIsCommon && continueA) aAncestor = instance.getNode(aAncestor).parentId;
        }
        if (continueB && !aAncestorIsCommon) {
            bFamily.push(bAncestor);
            bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
            continueB = bAncestor !== null;
            if (!bAncestorIsCommon && continueB) bAncestor = instance.getNode(bAncestor).parentId;
        }
    }
    const commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    const ancestorFamily = instance.getChildrenIds(commonAncestor);
    const aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    const bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [
        nodeAId,
        nodeBId
    ] : [
        nodeBId,
        nodeAId
    ];
};


const $9c860af282b8d1ed$export$2e4c91cde61c8525 = ({ instance: instance, params: params, models: models })=>{
    const lastSelectedNode = $7fPBF.useRef(null);
    const lastSelectionWasRange = $7fPBF.useRef(false);
    const currentRangeSelection = $7fPBF.useRef([]);
    const isNodeSelected = (nodeId)=>Array.isArray(models.selected.value) ? models.selected.value.indexOf(nodeId) !== -1 : models.selected.value === nodeId;
    const selectNode = (event, nodeId, multiple = false)=>{
        if (params.disableSelection) return;
        if (multiple) {
            if (Array.isArray(models.selected.value)) {
                let newSelected;
                if (models.selected.value.indexOf(nodeId) !== -1) newSelected = models.selected.value.filter((id)=>id !== nodeId);
                else newSelected = [
                    nodeId
                ].concat(models.selected.value);
                if (params.onNodeSelect) params.onNodeSelect(event, newSelected);
                models.selected.setValue(newSelected);
            }
        } else {
            const newSelected = params.multiSelect ? [
                nodeId
            ] : nodeId;
            if (params.onNodeSelect) params.onNodeSelect(event, newSelected);
            models.selected.setValue(newSelected);
        }
        lastSelectedNode.current = nodeId;
        lastSelectionWasRange.current = false;
        currentRangeSelection.current = [];
    };
    const getNodesInRange = (nodeAId, nodeBId)=>{
        const [first, last] = (0, $d5ad12a0b51e097a$export$17d19e2e752066c5)(instance, nodeAId, nodeBId);
        const nodes = [
            first
        ];
        let current = first;
        while(current !== last){
            current = (0, $a9b1b07948f3a713$export$9f79023ffc34e62d)(instance, current);
            nodes.push(current);
        }
        return nodes;
    };
    const handleRangeArrowSelect = (event, nodes)=>{
        let base = models.selected.value.slice();
        const { start: start, next: next, current: current } = nodes;
        if (!next || !current) return;
        if (currentRangeSelection.current.indexOf(current) === -1) currentRangeSelection.current = [];
        if (lastSelectionWasRange.current) {
            if (currentRangeSelection.current.indexOf(next) !== -1) {
                base = base.filter((id)=>id === start || id !== current);
                currentRangeSelection.current = currentRangeSelection.current.filter((id)=>id === start || id !== current);
            } else {
                base.push(next);
                currentRangeSelection.current.push(next);
            }
        } else {
            base.push(next);
            currentRangeSelection.current.push(current, next);
        }
        if (params.onNodeSelect) params.onNodeSelect(event, base);
        models.selected.setValue(base);
    };
    const handleRangeSelect = (event, nodes)=>{
        let base = models.selected.value.slice();
        const { start: start, end: end } = nodes;
        // If last selection was a range selection ignore nodes that were selected.
        if (lastSelectionWasRange.current) base = base.filter((id)=>currentRangeSelection.current.indexOf(id) === -1);
        let range = getNodesInRange(start, end);
        range = range.filter((node)=>!instance.isNodeDisabled(node));
        currentRangeSelection.current = range;
        let newSelected = base.concat(range);
        newSelected = newSelected.filter((id, i)=>newSelected.indexOf(id) === i);
        if (params.onNodeSelect) params.onNodeSelect(event, newSelected);
        models.selected.setValue(newSelected);
    };
    const selectRange = (event, nodes, stacked = false)=>{
        if (params.disableSelection) return;
        const { start: start = lastSelectedNode.current, end: end, current: current } = nodes;
        if (stacked) handleRangeArrowSelect(event, {
            start: start,
            next: end,
            current: current
        });
        else if (start != null && end != null) handleRangeSelect(event, {
            start: start,
            end: end
        });
        lastSelectionWasRange.current = true;
    };
    const rangeSelectToFirst = (event, nodeId)=>{
        if (!lastSelectedNode.current) lastSelectedNode.current = nodeId;
        const start = lastSelectionWasRange.current ? lastSelectedNode.current : nodeId;
        instance.selectRange(event, {
            start: start,
            end: (0, $a9b1b07948f3a713$export$217510d54aa1b77f)(instance)
        });
    };
    const rangeSelectToLast = (event, nodeId)=>{
        if (!lastSelectedNode.current) lastSelectedNode.current = nodeId;
        const start = lastSelectionWasRange.current ? lastSelectedNode.current : nodeId;
        instance.selectRange(event, {
            start: start,
            end: (0, $a9b1b07948f3a713$export$549d8f2ade049982)(instance)
        });
    };
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        isNodeSelected: isNodeSelected,
        selectNode: selectNode,
        selectRange: selectRange,
        rangeSelectToLast: rangeSelectToLast,
        rangeSelectToFirst: rangeSelectToFirst
    });
    return {
        getRootProps: ()=>({
                'aria-multiselectable': params.multiSelect
            })
    };
};
$9c860af282b8d1ed$export$2e4c91cde61c8525.models = {
    selected: {
        controlledProp: 'selected',
        defaultProp: 'defaultSelected'
    }
};
const $9c860af282b8d1ed$var$DEFAULT_SELECTED = [];
$9c860af282b8d1ed$export$2e4c91cde61c8525.getDefaultizedParams = (params)=>{
    var _params$disableSelect, _params$multiSelect, _params$defaultSelect;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        disableSelection: (_params$disableSelect = params.disableSelection) != null ? _params$disableSelect : false,
        multiSelect: (_params$multiSelect = params.multiSelect) != null ? _params$multiSelect : false,
        defaultSelected: (_params$defaultSelect = params.defaultSelected) != null ? _params$defaultSelect : params.multiSelect ? $9c860af282b8d1ed$var$DEFAULT_SELECTED : null
    });
};




var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $3a176184d8496997$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $3a176184d8496997$export$c16cf791cc6bf0c7 {
    constructor(timeout = $3a176184d8496997$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $3a176184d8496997$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}


class $5b49f032f8b8911c$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}


// We use class to make it easier to detect in heap snapshots by name
class $134d24047e8fdf67$var$ObjectToBeRetainedByReact {
}
function $134d24047e8fdf67$export$7539a8c1c0de7c55(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useInstanceEventHandler(instance, eventName, handler) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $5b49f032f8b8911c$export$86b678dc9d8f7603)() : new (0, $3a176184d8496997$export$c16cf791cc6bf0c7)();
        const [objectRetainedByReact] = $7fPBF.useState(new $134d24047e8fdf67$var$ObjectToBeRetainedByReact());
        const subscription = $7fPBF.useRef(null);
        const handlerRef = $7fPBF.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = $7fPBF.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event)=>{
                if (!event.defaultMuiPrevented) {
                    var _handlerRef$current;
                    (_handlerRef$current = handlerRef.current) == null || _handlerRef$current.call(handlerRef, params, event);
                }
            };
            subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                var _subscription$current;
                (_subscription$current = subscription.current) == null || _subscription$current.call(subscription);
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $7fPBF.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event)=>{
                    if (!event.defaultMuiPrevented) {
                        var _handlerRef$current2;
                        (_handlerRef$current2 = handlerRef.current) == null || _handlerRef$current2.call(handlerRef, params, event);
                    }
                };
                subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                var _subscription$current2;
                (_subscription$current2 = subscription.current) == null || _subscription$current2.call(subscription);
                subscription.current = null;
            };
        }, [
            instance,
            eventName
        ]);
    };
}
const $134d24047e8fdf67$var$registryContainer = {
    registry: null
};
const $134d24047e8fdf67$export$c5af18cc30c6146f = ()=>{
    var _registryContainer$re;
    (_registryContainer$re = $134d24047e8fdf67$var$registryContainer.registry) == null || _registryContainer$re.reset();
    $134d24047e8fdf67$var$registryContainer.registry = null;
};
const $134d24047e8fdf67$export$5f4a1ca5563acec2 = $134d24047e8fdf67$export$7539a8c1c0de7c55($134d24047e8fdf67$var$registryContainer);


const $fc09978472b9c696$export$b5793b1aef8945ff = ({ instance: instance, params: params, state: state, setState: setState, models: models, rootRef: rootRef })=>{
    const setFocusedNodeId = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nodeId)=>{
        const cleanNodeId = typeof nodeId === 'function' ? nodeId(state.focusedNodeId) : nodeId;
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                focusedNodeId: cleanNodeId
            }));
    });
    const isNodeFocused = $7fPBF.useCallback((nodeId)=>state.focusedNodeId === nodeId, [
        state.focusedNodeId
    ]);
    const focusNode = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, nodeId)=>{
        if (nodeId) {
            setFocusedNodeId(nodeId);
            if (params.onNodeFocus) params.onNodeFocus(event, nodeId);
        }
    });
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        isNodeFocused: isNodeFocused,
        focusNode: focusNode
    });
    (0, $134d24047e8fdf67$export$5f4a1ca5563acec2)(instance, 'removeNode', ({ id: id })=>{
        setFocusedNodeId((oldFocusedNodeId)=>{
            if (oldFocusedNodeId === id && rootRef.current === (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current).activeElement) return instance.getChildrenIds(null)[0];
            return oldFocusedNodeId;
        });
    });
    const createHandleFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
            // if the event bubbled (which is React specific) we don't want to steal focus
            if (event.target === event.currentTarget) {
                const isNodeVisible = (nodeId)=>{
                    const node = instance.getNode(nodeId);
                    return node && (node.parentId == null || instance.isNodeExpanded(node.parentId));
                };
                let nodeToFocusId;
                if (Array.isArray(models.selected.value)) nodeToFocusId = models.selected.value.find(isNodeVisible);
                else if (models.selected.value != null && isNodeVisible(models.selected.value)) nodeToFocusId = models.selected.value;
                if (nodeToFocusId == null) nodeToFocusId = instance.getNavigableChildrenIds(null)[0];
                instance.focusNode(event, nodeToFocusId);
            }
        };
    const createHandleBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
            setFocusedNodeId(null);
        };
    const focusedNode = instance.getNode(state.focusedNodeId);
    const activeDescendant = focusedNode ? focusedNode.idAttribute : null;
    return {
        getRootProps: (otherHandlers)=>({
                onFocus: createHandleFocus(otherHandlers),
                onBlur: createHandleBlur(otherHandlers),
                'aria-activedescendant': activeDescendant != null ? activeDescendant : undefined
            })
    };
};
$fc09978472b9c696$export$b5793b1aef8945ff.getInitialState = ()=>({
        focusedNodeId: null
    });
$fc09978472b9c696$export$b5793b1aef8945ff.getDefaultizedParams = (params)=>{
    var _params$disabledItems;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
        disabledItemsFocusable: (_params$disabledItems = params.disabledItemsFocusable) != null ? _params$disabledItems : false
    });
};




var $7fPBF = parcelRequire("7fPBF");



function $e1e77f0eb9ebff6d$var$isPrintableCharacter(string) {
    return string && string.length === 1 && string.match(/\S/);
}
function $e1e77f0eb9ebff6d$var$findNextFirstChar(firstChars, startIndex, char) {
    for(let i = startIndex; i < firstChars.length; i += 1){
        if (char === firstChars[i]) return i;
    }
    return -1;
}
const $e1e77f0eb9ebff6d$export$70945545f32592c7 = ({ instance: instance, params: params, state: state })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const firstCharMap = $7fPBF.useRef({});
    const mapFirstChar = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((nodeId, firstChar)=>{
        firstCharMap.current[nodeId] = firstChar;
        return ()=>{
            const newMap = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, firstCharMap.current);
            delete newMap[nodeId];
            firstCharMap.current = newMap;
        };
    });
    (0, $a9b1b07948f3a713$export$cd92e33cfd3a0015)(instance, {
        mapFirstChar: mapFirstChar
    });
    const handleNextArrow = (event)=>{
        if (state.focusedNodeId != null && instance.isNodeExpandable(state.focusedNodeId)) {
            if (instance.isNodeExpanded(state.focusedNodeId)) instance.focusNode(event, (0, $a9b1b07948f3a713$export$9f79023ffc34e62d)(instance, state.focusedNodeId));
            else if (!instance.isNodeDisabled(state.focusedNodeId)) instance.toggleNodeExpansion(event, state.focusedNodeId);
        }
        return true;
    };
    const handlePreviousArrow = (event)=>{
        if (state.focusedNodeId == null) return false;
        if (instance.isNodeExpanded(state.focusedNodeId) && !instance.isNodeDisabled(state.focusedNodeId)) {
            instance.toggleNodeExpansion(event, state.focusedNodeId);
            return true;
        }
        const parent = instance.getNode(state.focusedNodeId).parentId;
        if (parent) {
            instance.focusNode(event, parent);
            return true;
        }
        return false;
    };
    const focusByFirstCharacter = (event, nodeId, firstChar)=>{
        let start;
        let index;
        const lowercaseChar = firstChar.toLowerCase();
        const firstCharIds = [];
        const firstChars = [];
        // This really only works since the ids are strings
        Object.keys(firstCharMap.current).forEach((mapNodeId)=>{
            const map = instance.getNode(mapNodeId);
            const visible = map.parentId ? instance.isNodeExpanded(map.parentId) : true;
            const shouldBeSkipped = params.disabledItemsFocusable ? false : instance.isNodeDisabled(mapNodeId);
            if (visible && !shouldBeSkipped) {
                firstCharIds.push(mapNodeId);
                firstChars.push(firstCharMap.current[mapNodeId]);
            }
        });
        // Get start index for search based on position of currentItem
        start = firstCharIds.indexOf(nodeId) + 1;
        if (start >= firstCharIds.length) start = 0;
        // Check remaining slots in the menu
        index = $e1e77f0eb9ebff6d$var$findNextFirstChar(firstChars, start, lowercaseChar);
        // If not found in remaining slots, check from beginning
        if (index === -1) index = $e1e77f0eb9ebff6d$var$findNextFirstChar(firstChars, 0, lowercaseChar);
        // If match was found...
        if (index > -1) instance.focusNode(event, firstCharIds[index]);
    };
    const selectNextNode = (event, id)=>{
        if (!instance.isNodeDisabled((0, $a9b1b07948f3a713$export$9f79023ffc34e62d)(instance, id))) instance.selectRange(event, {
            end: (0, $a9b1b07948f3a713$export$9f79023ffc34e62d)(instance, id),
            current: id
        }, true);
    };
    const selectPreviousNode = (event, nodeId)=>{
        if (!instance.isNodeDisabled((0, $a9b1b07948f3a713$export$441b3b812f976516)(instance, nodeId))) instance.selectRange(event, {
            end: (0, $a9b1b07948f3a713$export$441b3b812f976516)(instance, nodeId),
            current: nodeId
        }, true);
    };
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            let flag = false;
            const key = event.key;
            // If the tree is empty there will be no focused node
            if (event.altKey || event.currentTarget !== event.target || state.focusedNodeId == null) return;
            const ctrlPressed = event.ctrlKey || event.metaKey;
            switch(key){
                case ' ':
                    if (!params.disableSelection && !instance.isNodeDisabled(state.focusedNodeId)) {
                        flag = true;
                        if (params.multiSelect && event.shiftKey) instance.selectRange(event, {
                            end: state.focusedNodeId
                        });
                        else if (params.multiSelect) instance.selectNode(event, state.focusedNodeId, true);
                        else instance.selectNode(event, state.focusedNodeId);
                    }
                    event.stopPropagation();
                    break;
                case 'Enter':
                    if (!instance.isNodeDisabled(state.focusedNodeId)) {
                        if (instance.isNodeExpandable(state.focusedNodeId)) {
                            instance.toggleNodeExpansion(event, state.focusedNodeId);
                            flag = true;
                        } else if (!params.disableSelection) {
                            flag = true;
                            if (params.multiSelect) instance.selectNode(event, state.focusedNodeId, true);
                            else instance.selectNode(event, state.focusedNodeId);
                        }
                    }
                    event.stopPropagation();
                    break;
                case 'ArrowDown':
                    if (params.multiSelect && event.shiftKey && !params.disableSelection) selectNextNode(event, state.focusedNodeId);
                    instance.focusNode(event, (0, $a9b1b07948f3a713$export$9f79023ffc34e62d)(instance, state.focusedNodeId));
                    flag = true;
                    break;
                case 'ArrowUp':
                    if (params.multiSelect && event.shiftKey && !params.disableSelection) selectPreviousNode(event, state.focusedNodeId);
                    instance.focusNode(event, (0, $a9b1b07948f3a713$export$441b3b812f976516)(instance, state.focusedNodeId));
                    flag = true;
                    break;
                case 'ArrowRight':
                    if (isRtl) flag = handlePreviousArrow(event);
                    else flag = handleNextArrow(event);
                    break;
                case 'ArrowLeft':
                    if (isRtl) flag = handleNextArrow(event);
                    else flag = handlePreviousArrow(event);
                    break;
                case 'Home':
                    if (params.multiSelect && ctrlPressed && event.shiftKey && !params.disableSelection && !instance.isNodeDisabled(state.focusedNodeId)) instance.rangeSelectToFirst(event, state.focusedNodeId);
                    instance.focusNode(event, (0, $a9b1b07948f3a713$export$217510d54aa1b77f)(instance));
                    flag = true;
                    break;
                case 'End':
                    if (params.multiSelect && ctrlPressed && event.shiftKey && !params.disableSelection && !instance.isNodeDisabled(state.focusedNodeId)) instance.rangeSelectToLast(event, state.focusedNodeId);
                    instance.focusNode(event, (0, $a9b1b07948f3a713$export$549d8f2ade049982)(instance));
                    flag = true;
                    break;
                default:
                    if (key === '*') {
                        instance.expandAllSiblings(event, state.focusedNodeId);
                        flag = true;
                    } else if (params.multiSelect && ctrlPressed && key.toLowerCase() === 'a' && !params.disableSelection) {
                        instance.selectRange(event, {
                            start: (0, $a9b1b07948f3a713$export$217510d54aa1b77f)(instance),
                            end: (0, $a9b1b07948f3a713$export$549d8f2ade049982)(instance)
                        });
                        flag = true;
                    } else if (!ctrlPressed && !event.shiftKey && $e1e77f0eb9ebff6d$var$isPrintableCharacter(key)) {
                        focusByFirstCharacter(event, state.focusedNodeId, key);
                        flag = true;
                    }
            }
            if (flag) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    return {
        getRootProps: (otherHandlers)=>({
                onKeyDown: createHandleKeyDown(otherHandlers)
            })
    };
};



const $b72907d859a3173b$export$3f4588ee6f3eda12 = ({ instance: instance, params: params })=>{
    const treeId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(params.id);
    return {
        getRootProps: ()=>({
                id: treeId
            }),
        contextValue: {
            treeId: treeId,
            instance: instance,
            multiSelect: params.multiSelect,
            disabledItemsFocusable: params.disabledItemsFocusable,
            icons: {
                defaultCollapseIcon: params.defaultCollapseIcon,
                defaultEndIcon: params.defaultEndIcon,
                defaultExpandIcon: params.defaultExpandIcon,
                defaultParentIcon: params.defaultParentIcon
            }
        }
    };
};


const $0406b9c670db4108$export$600384edcef22719 = [
    (0, $ff3248ced6d97573$export$dde229fbb0afd1fe),
    (0, $e583d9a82c02b374$export$f198a27ee171dd2b),
    (0, $9c860af282b8d1ed$export$2e4c91cde61c8525),
    (0, $fc09978472b9c696$export$b5793b1aef8945ff),
    (0, $e1e77f0eb9ebff6d$export$70945545f32592c7),
    (0, $b72907d859a3173b$export$3f4588ee6f3eda12)
]; // We can't infer this type from the plugin, otherwise we would lose the generics.



const $0769a3f8a3c0be40$var$_excluded = [
    "disabledItemsFocusable",
    "expanded",
    "defaultExpanded",
    "onNodeToggle",
    "onNodeFocus",
    "disableSelection",
    "defaultSelected",
    "selected",
    "multiSelect",
    "onNodeSelect",
    "id",
    "defaultCollapseIcon",
    "defaultEndIcon",
    "defaultExpandIcon",
    "defaultParentIcon",
    "children"
];
const $0769a3f8a3c0be40$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1793c5bd2348dd77$export$a9a855983a3a6110), classes);
};
const $0769a3f8a3c0be40$var$TreeViewRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('ul', {
    name: 'MuiTreeView',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    outline: 0
});
/**
 *
 * Demos:
 *
 * - [Tree View](https://mui.com/x/react-tree-view/)
 *
 * API:
 *
 * - [TreeView API](https://mui.com/x/api/tree-view/tree-view/)
 */ const $0769a3f8a3c0be40$export$6940b0d9c820eca7 = /*#__PURE__*/ $7fPBF.forwardRef(function TreeView(inProps, ref) {
    const themeProps = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTreeView'
    });
    const ownerState = themeProps;
    const _ref = themeProps, { disabledItemsFocusable: // Headless implementation
    disabledItemsFocusable, expanded: expanded, defaultExpanded: defaultExpanded, onNodeToggle: onNodeToggle, onNodeFocus: onNodeFocus, disableSelection: disableSelection, defaultSelected: defaultSelected, selected: selected, multiSelect: multiSelect, onNodeSelect: onNodeSelect, id: id, defaultCollapseIcon: defaultCollapseIcon, defaultEndIcon: defaultEndIcon, defaultExpandIcon: defaultExpandIcon, defaultParentIcon: defaultParentIcon, children: // Component implementation
    children } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $0769a3f8a3c0be40$var$_excluded);
    const { getRootProps: getRootProps, contextValue: contextValue } = (0, $541d2bcb72d13709$export$1e79c2a653523352)({
        disabledItemsFocusable: disabledItemsFocusable,
        expanded: expanded,
        defaultExpanded: defaultExpanded,
        onNodeToggle: onNodeToggle,
        onNodeFocus: onNodeFocus,
        disableSelection: disableSelection,
        defaultSelected: defaultSelected,
        selected: selected,
        multiSelect: multiSelect,
        onNodeSelect: onNodeSelect,
        id: id,
        defaultCollapseIcon: defaultCollapseIcon,
        defaultEndIcon: defaultEndIcon,
        defaultExpandIcon: defaultExpandIcon,
        defaultParentIcon: defaultParentIcon,
        plugins: (0, $0406b9c670db4108$export$600384edcef22719),
        rootRef: ref
    });
    const classes = $0769a3f8a3c0be40$var$useUtilityClasses(themeProps);
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: $0769a3f8a3c0be40$var$TreeViewRoot,
        externalSlotProps: {},
        externalForwardedProps: other,
        className: classes.root,
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b70addf9417c64f$export$6a399b2f7f12632c), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0769a3f8a3c0be40$var$TreeViewRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
            children: children
        }))
    });
});







var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

const $d2584347292d3ba1$export$8a6a3e88e8e060e0 = ()=>$7fPBF.useContext((0, $09383b1f59bfc1c2$export$5e4715462ac10946));


function $1260e3e5acbffd5c$export$e4bcc4675b2b123a(nodeId) {
    const { instance: instance, multiSelect: multiSelect } = (0, $d2584347292d3ba1$export$8a6a3e88e8e060e0)();
    const expandable = instance ? instance.isNodeExpandable(nodeId) : false;
    const expanded = instance ? instance.isNodeExpanded(nodeId) : false;
    const focused = instance ? instance.isNodeFocused(nodeId) : false;
    const selected = instance ? instance.isNodeSelected(nodeId) : false;
    const disabled = instance ? instance.isNodeDisabled(nodeId) : false;
    const handleExpansion = (event)=>{
        if (instance && !disabled) {
            if (!focused) instance.focusNode(event, nodeId);
            const multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey);
            // If already expanded and trying to toggle selection don't close
            if (expandable && !(multiple && instance.isNodeExpanded(nodeId))) instance.toggleNodeExpansion(event, nodeId);
        }
    };
    const handleSelection = (event)=>{
        if (instance && !disabled) {
            if (!focused) instance.focusNode(event, nodeId);
            const multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey);
            if (multiple) {
                if (event.shiftKey) instance.selectRange(event, {
                    end: nodeId
                });
                else instance.selectNode(event, nodeId, true);
            } else instance.selectNode(event, nodeId);
        }
    };
    const preventSelection = (event)=>{
        if (event.shiftKey || event.ctrlKey || event.metaKey || disabled) // Prevent text selection
        event.preventDefault();
    };
    return {
        disabled: disabled,
        expanded: expanded,
        selected: selected,
        focused: focused,
        handleExpansion: handleExpansion,
        handleSelection: handleSelection,
        preventSelection: preventSelection
    };
}



const $b832dab343bcf87d$var$_excluded = [
    "classes",
    "className",
    "displayIcon",
    "expansionIcon",
    "icon",
    "label",
    "nodeId",
    "onClick",
    "onMouseDown"
];
/**
 * @ignore - internal component.
 */ const $b832dab343bcf87d$export$4b687e3f663d618c = /*#__PURE__*/ $7fPBF.forwardRef(function TreeItemContent(props, ref) {
    const { classes: classes, className: className, displayIcon: displayIcon, expansionIcon: expansionIcon, icon: iconProp, label: label, nodeId: nodeId, onClick: onClick, onMouseDown: onMouseDown } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b832dab343bcf87d$var$_excluded);
    const { disabled: disabled, expanded: expanded, selected: selected, focused: focused, handleExpansion: handleExpansion, handleSelection: handleSelection, preventSelection: preventSelection } = (0, $1260e3e5acbffd5c$export$e4bcc4675b2b123a)(nodeId);
    const icon = iconProp || expansionIcon || displayIcon;
    const handleMouseDown = (event)=>{
        preventSelection(event);
        if (onMouseDown) onMouseDown(event);
    };
    const handleClick = (event)=>{
        handleExpansion(event);
        handleSelection(event);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */ (0, $824c049f32d4395d$exports.jsxs)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.root, expanded && classes.expanded, selected && classes.selected, focused && classes.focused, disabled && classes.disabled),
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: classes.iconContainer,
                children: icon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: classes.label,
                children: label
            })
        ]
    }));
});




function $bb02e8b789cef52d$export$e06936b9af6d8f5b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTreeItem', slot);
}
const $bb02e8b789cef52d$export$1970fed62f74ee8d = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTreeItem', [
    'root',
    'group',
    'content',
    'expanded',
    'selected',
    'focused',
    'disabled',
    'iconContainer',
    'label'
]);




const $1f3760593754907f$var$_excluded = [
    "children",
    "className",
    "collapseIcon",
    "ContentComponent",
    "ContentProps",
    "endIcon",
    "expandIcon",
    "disabled",
    "icon",
    "id",
    "label",
    "nodeId",
    "onClick",
    "onMouseDown",
    "TransitionComponent",
    "TransitionProps"
];
const $1f3760593754907f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        expanded: [
            'expanded'
        ],
        selected: [
            'selected'
        ],
        focused: [
            'focused'
        ],
        disabled: [
            'disabled'
        ],
        iconContainer: [
            'iconContainer'
        ],
        label: [
            'label'
        ],
        group: [
            'group'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bb02e8b789cef52d$export$e06936b9af6d8f5b), classes);
};
const $1f3760593754907f$var$TreeItemRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('li', {
    name: 'MuiTreeItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    outline: 0
});
const $1f3760593754907f$var$StyledTreeItemContent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $b832dab343bcf87d$export$4b687e3f663d618c), {
    name: 'MuiTreeItem',
    slot: 'Content',
    overridesResolver: (props, styles)=>{
        return [
            styles.content,
            styles.iconContainer && {
                [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).iconContainer}`]: styles.iconContainer
            },
            styles.label && {
                [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).label}`]: styles.label
            }
        ];
    }
})(({ theme: theme })=>({
        padding: '0 8px',
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            backgroundColor: 'transparent'
        },
        [`&.${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).focused}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                }
            },
            [`&.${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).focused}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $92041da11764723e$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).iconContainer}`]: {
            marginRight: 4,
            width: 15,
            display: 'flex',
            flexShrink: 0,
            justifyContent: 'center',
            '& svg': {
                fontSize: 18
            }
        },
        [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).label}`]: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            paddingLeft: 4,
            width: '100%',
            boxSizing: 'border-box',
            // prevent width + padding to overflow
            // fixes overflow - see https://github.com/mui/material-ui/issues/27372
            minWidth: 0,
            position: 'relative'
        }, theme.typography.body1)
    }));
const $1f3760593754907f$var$TreeItemGroup = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $6207032cc256a7e6$export$2e2bcd8739ae039), {
    name: 'MuiTreeItem',
    slot: 'Group',
    overridesResolver: (props, styles)=>styles.group
})({
    margin: 0,
    padding: 0,
    marginLeft: 17
});
const $1f3760593754907f$export$53d36ab85dc89436 = /*#__PURE__*/ $7fPBF.forwardRef(function TreeItem(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTreeItem'
    });
    const { children: children, className: className, collapseIcon: collapseIcon, ContentComponent: ContentComponent = (0, $b832dab343bcf87d$export$4b687e3f663d618c), ContentProps: ContentProps, endIcon: endIcon, expandIcon: expandIcon, disabled: disabledProp, icon: icon, id: idProp, label: label, nodeId: nodeId, onClick: onClick, onMouseDown: onMouseDown, TransitionComponent: TransitionComponent = (0, $6207032cc256a7e6$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $1f3760593754907f$var$_excluded);
    const { icons: contextIcons, multiSelect: multiSelect, disabledItemsFocusable: disabledItemsFocusable, treeId: treeId, instance: instance } = (0, $d2584347292d3ba1$export$8a6a3e88e8e060e0)();
    let id;
    if (idProp != null) id = idProp;
    else if (treeId && nodeId) id = `${treeId}-${nodeId}`;
    const [treeItemElement, setTreeItemElement] = $7fPBF.useState(null);
    const contentRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(setTreeItemElement, ref);
    const descendant = $7fPBF.useMemo(()=>({
            element: treeItemElement,
            id: nodeId
        }), [
        nodeId,
        treeItemElement
    ]);
    const { index: index, parentId: parentId } = (0, $bd7175c00fc5aa5c$export$b7626b291207e517)(descendant);
    const expandable = Boolean(Array.isArray(children) ? children.length : children);
    const expanded = instance ? instance.isNodeExpanded(nodeId) : false;
    const focused = instance ? instance.isNodeFocused(nodeId) : false;
    const selected = instance ? instance.isNodeSelected(nodeId) : false;
    const disabled = instance ? instance.isNodeDisabled(nodeId) : false;
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        expanded: expanded,
        focused: focused,
        selected: selected,
        disabled: disabled
    });
    const classes = $1f3760593754907f$var$useUtilityClasses(ownerState);
    let displayIcon;
    let expansionIcon;
    if (expandable) {
        if (!expanded) expansionIcon = expandIcon || contextIcons.defaultExpandIcon;
        else expansionIcon = collapseIcon || contextIcons.defaultCollapseIcon;
    }
    if (expandable) displayIcon = contextIcons.defaultParentIcon;
    else displayIcon = endIcon || contextIcons.defaultEndIcon;
    $7fPBF.useEffect(()=>{
        // On the first render a node's index will be -1. We want to wait for the real index.
        if (instance && index !== -1) {
            instance.updateNode({
                id: nodeId,
                idAttribute: id,
                index: index,
                parentId: parentId,
                expandable: expandable,
                disabled: disabledProp
            });
            return ()=>instance.removeNode(nodeId);
        }
        return undefined;
    }, [
        instance,
        parentId,
        index,
        nodeId,
        expandable,
        disabledProp,
        id
    ]);
    $7fPBF.useEffect(()=>{
        if (instance && label) {
            var _contentRef$current$t, _contentRef$current;
            return instance.mapFirstChar(nodeId, ((_contentRef$current$t = (_contentRef$current = contentRef.current) == null ? void 0 : _contentRef$current.textContent) != null ? _contentRef$current$t : '').substring(0, 1).toLowerCase());
        }
        return undefined;
    }, [
        instance,
        nodeId,
        label
    ]);
    let ariaSelected;
    if (multiSelect) ariaSelected = selected;
    else if (selected) /* single-selection trees unset aria-selected on un-selected items.
     *
     * If the tree does not support multiple selection, aria-selected
     * is set to true for the selected node and it is not present on any other node in the tree.
     * Source: https://www.w3.org/WAI/ARIA/apg/patterns/treeview/
     */ ariaSelected = true;
    function handleFocus(event) {
        // DOM focus stays on the tree which manages focus with aria-activedescendant
        if (event.target === event.currentTarget) {
            let rootElement;
            if (typeof event.target.getRootNode === 'function') rootElement = event.target.getRootNode();
            else rootElement = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(event.target);
            rootElement.getElementById(treeId).focus({
                preventScroll: true
            });
        }
        const unfocusable = !disabledItemsFocusable && disabled;
        if (instance && !focused && event.currentTarget === event.target && !unfocusable) instance.focusNode(event, nodeId);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($1f3760593754907f$var$TreeItemRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        role: "treeitem",
        "aria-expanded": expandable ? expanded : undefined,
        "aria-selected": ariaSelected,
        "aria-disabled": disabled || undefined,
        id: id,
        tabIndex: -1
    }, other, {
        ownerState: ownerState,
        onFocus: handleFocus,
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1f3760593754907f$var$StyledTreeItemContent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                as: ContentComponent,
                ref: contentRef,
                classes: {
                    root: classes.content,
                    expanded: classes.expanded,
                    selected: classes.selected,
                    focused: classes.focused,
                    disabled: classes.disabled,
                    iconContainer: classes.iconContainer,
                    label: classes.label
                },
                label: label,
                nodeId: nodeId,
                onClick: onClick,
                onMouseDown: onMouseDown,
                icon: icon,
                expansionIcon: expansionIcon,
                displayIcon: displayIcon,
                ownerState: ownerState
            }, ContentProps)),
            children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd7175c00fc5aa5c$export$c46937d8801f1c9c), {
                id: nodeId,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1f3760593754907f$var$TreeItemGroup, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    as: TransitionComponent,
                    unmountOnExit: true,
                    className: classes.group,
                    in: expanded,
                    component: "ul",
                    role: "group"
                }, TransitionProps, {
                    children: children
                }))
            })
        ]
    }));
});



const $3c49bd95421abc9d$export$9c9f7d8e4563aed9 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $1f3760593754907f$export$53d36ab85dc89436))(()=>({
        [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).label}`]: {
            marginTop: 1,
            marginBottom: 1,
            marginRight: 12,
            padding: 4,
            maxWidth: "fit-content",
            fontWeight: "normal !important",
            "&.parent": {
                fontWeight: "bold !important"
            }
        },
        [`& .${(0, $bb02e8b789cef52d$export$1970fed62f74ee8d).content}`]: {
            borderRadius: 10
        }
    }));




var $gSkQi = parcelRequire("gSkQi");



const $28492c717b57295f$export$217a9e3a96a18b85 = ({ className: className, defaultExpanded: defaultExpanded, defaultSelected: defaultSelected, hidePreferences: hidePreferences })=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = (0, $7fPBF.useState)(false);
    const [expanded, setExpanded] = (0, $7fPBF.useState)(defaultExpanded);
    const [selected, setSelected] = (0, $7fPBF.useState)(defaultSelected);
    (0, $7fPBF.useEffect)(()=>{
        setExpanded(defaultExpanded);
        setSelected(defaultSelected);
    }, [
        defaultExpanded,
        defaultSelected
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
        className: className,
        style: {
            overflow: "auto",
            marginBottom: "12px",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                sx: {
                    margin: 2
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0769a3f8a3c0be40$export$6940b0d9c820eca7), {
                    sx: {
                        userSelect: "none"
                    },
                    expanded: expanded,
                    selected: [
                        selected
                    ],
                    defaultCollapseIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).KeyboardArrowDown
                    }),
                    defaultExpandIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ChevronRight
                    }),
                    onNodeSelect: (event, nodeIds)=>{
                        if ((0, $gSkQi.isArray)(nodeIds)) return;
                        const index = expanded.indexOf(nodeIds);
                        const copyExpanded = [
                            ...expanded
                        ];
                        if (index === -1) copyExpanded.push(nodeIds);
                        else copyExpanded.splice(index, 1);
                        setExpanded(copyExpanded);
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "about",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.title,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.about()}`),
                            classes: {
                                label: "parent"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "users_parent",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.title_users,
                            classes: {
                                label: "parent"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "users_sign_up",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.signUp()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "users_guest",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.guest()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "users_recover_password",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_recover_password.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.recoverPassword()}`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "album_parent",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.title,
                            classes: {
                                label: "parent"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_home",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.home()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_filter",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.filterAlbums()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_order",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.orderAlbums()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_marks",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.markingAlbums()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_scan_barcode",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.scanBarcode()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_import_discogs",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromDiscogs()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_import_excel",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromExcel()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_image_gallery",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_image_gallery.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.imageGallery()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_remove_filtered_albums",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.removeFilteredAlbums()}`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "album_attributes_parent",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.title,
                            classes: {
                                label: "parent"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_attributes_home",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.albumAttributes.home()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "album_attributes_artists",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_artists.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.albumAttributes.artists()}`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "collections_parent",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.title,
                            classes: {
                                label: "parent"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "collections_home",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.home()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "collections_attributes",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.attributes()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "collections_public_collections",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_public_collections.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.publicCollections()}`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "userProfile",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.title,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.userProfile()}`),
                            classes: {
                                label: "parent"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "purchases",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.title,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.purchases()}`),
                            classes: {
                                label: "parent"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "subscriptions_parent",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.title,
                            classes: {
                                label: "parent"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "subscriptions_home",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.home_title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.home()}`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                                    nodeId: "subscriptions_mercado_pago",
                                    label: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_mercado_pago_subscriptions.title,
                                    onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.mercadoPago()}`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "policy",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.policy()}`),
                            classes: {
                                label: "parent"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c49bd95421abc9d$export$9c9f7d8e4563aed9), {
                            nodeId: "terms",
                            label: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.terms()}`),
                            classes: {
                                label: "parent"
                            }
                        })
                    ]
                })
            }),
            !hidePreferences && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                sx: {
                    margin: 2
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5fe7f63a06f79c4d$exports))).listButton,
                        onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list()),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Login
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5fe7f63a06f79c4d$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_go_to_app
                            })
                        ]
                    }, "OpenApp"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5fe7f63a06f79c4d$exports))).listButton,
                        onClick: ()=>setIsPreferencesDialogOpen(true),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Settings
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5fe7f63a06f79c4d$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_preferences
                            })
                        ]
                    }, "Preferences"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6558c6f63077fa19$export$7125afe2279fb9f3), {
                        isOpen: isPreferencesDialogOpen,
                        setIsOpen: setIsPreferencesDialogOpen,
                        canRemoveAccount: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e09141a590dfb9a7$export$590eb9e8e9b3ae5e), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $960198875259ceb3$export$6ff27d755f78f4a0), {})
                ]
            })
        ]
    });
};



parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");










parcelRequire("7fPBF");



parcelRequire("7fPBF");


'use client';
var $bf5ccaae290cc05e$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');




'use client';
const $b9b83b4d3c9e8b74$var$_excluded = [
    "slots",
    "slotProps"
];
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === 'light' ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        '&:hover, &:focus': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        '&:active': (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === 'light' ? {
            backgroundColor: (0, $92041da11764723e$export$e665714f76e581fd)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $92041da11764723e$export$e665714f76e581fd)(theme.palette.grey[600], 0.12)
        })
    }));
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $bf5ccaae290cc05e$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b9b83b4d3c9e8b74$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $b9b83b4d3c9e8b74$export$2e2bcd8739ae039 = $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed;




function $e85bea44bd9c3da4$export$17261110b18c8084(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiBreadcrumbs', slot);
}
const $e85bea44bd9c3da4$var$breadcrumbsClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $e85bea44bd9c3da4$export$2e2bcd8739ae039 = $e85bea44bd9c3da4$var$breadcrumbsClasses;



'use client';
const $9d7afcdf99dc1f56$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $9d7afcdf99dc1f56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $e85bea44bd9c3da4$export$17261110b18c8084), classes);
};
const $9d7afcdf99dc1f56$var$BreadcrumbsRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $e85bea44bd9c3da4$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $9d7afcdf99dc1f56$var$BreadcrumbsOl = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol',
    overridesResolver: (props, styles)=>styles.ol
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $9d7afcdf99dc1f56$var$BreadcrumbsSeparator = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $9d7afcdf99dc1f56$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $9d7afcdf99dc1f56$var$Breadcrumbs = /*#__PURE__*/ $7fPBF.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $3dd0e9417d40119e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $9d7afcdf99dc1f56$var$_excluded);
    const [expanded, setExpanded] = $7fPBF.useState(false);
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $9d7afcdf99dc1f56$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $7fPBF.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9b83b4d3c9e8b74$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $7fPBF.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $7fPBF.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $9d7afcdf99dc1f56$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $9d7afcdf99dc1f56$export$2e2bcd8739ae039 = $9d7afcdf99dc1f56$var$Breadcrumbs;





const $27ee9719e73d58a0$export$23c392ca2906bb1 = ()=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const location = (0, $d42da6e692e216cc$export$45d76561a5302f2b)();
    const pathNames = location.pathname.split("/").filter((x)=>x);
    const breadcrumbNameMap = {
        "/doc": (0, $37bec70ed65ed924$export$21c51bc433c16634).documentation,
        "/doc/about": (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.title,
        "/doc/users": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.title_users,
        "/doc/users/signUp": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.home_title,
        "/doc/users/guest": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.title,
        "/doc/users/recoverPassword": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_recover_password.title,
        "/doc/album": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.title,
        "/doc/album/filter": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.title,
        "/doc/album/order": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.title,
        "/doc/album/scanBarcode": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.title,
        "/doc/album/importFromDiscogs": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.title,
        "/doc/album/importFromSpreadsheet": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.title,
        "/doc/album/imageGallery": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_image_gallery.title,
        "/doc/album/removeFiltered": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.title,
        "/doc/album/marks": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.title,
        "/doc/albumAttributes": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.title,
        "/doc/albumAttributes/artists": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_artists.title,
        "/doc/collections": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.title,
        "/doc/collections/attributes": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.home_title,
        "/doc/collections/public": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_public_collections.title,
        "/doc/userProfile": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.title,
        "/doc/purchases": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.title,
        "/doc/subscriptions": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.title,
        "/doc/subscriptions/mercadoPago": (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_mercado_pago_subscriptions.title,
        "/doc/policy": (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title,
        "/doc/terms": (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d7afcdf99dc1f56$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).breadcrumbs,
        separator: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
            style: {
                color: theme.palette.primary.main
            },
            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ChevronRight
        }),
        maxItems: isMobile ? 1 : 4,
        children: pathNames.map((value, index)=>{
            const last = index === pathNames.length - 1;
            const to = `/${pathNames.slice(0, index + 1).join("/")}`;
            return last ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                style: {
                    color: "white"
                },
                children: breadcrumbNameMap[to]
            }, to) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$a6c7ac8248d6e38a), {
                style: {
                    color: theme.palette.colors?.breadcrumb
                },
                to: to,
                children: breadcrumbNameMap[to]
            }, to);
        })
    });
};






const $b8b878d338458fb6$export$c02fd77fbe89d29f = ({ defaultExpanded: defaultExpanded, defaultSelected: defaultSelected, children: children })=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).documentation}`;
    }, []);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const isIosApp = (0, $e0f71d8009cff55c$export$5d9aa80f0e322840)();
    const topReference = (0, $7fPBF.useRef)(null);
    const piperTextImage = new URL($3e80ee69e0c45c78$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        topReference.current?.scrollIntoView({
            behavior: "smooth"
        });
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).mainDiv,
        children: [
            !isIosApp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).header,
                style: {
                    height: "10%"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).logo,
                        disableRipple: true,
                        onClick: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list()),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).logoImage,
                            style: {
                                maxWidth: "100%",
                                maxHeight: "100%"
                            },
                            src: piperTextImage,
                            alt: "Piper"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27ee9719e73d58a0$export$23c392ca2906bb1), {})
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).container,
                style: {
                    height: isIosApp ? "100vh" : "90%",
                    backgroundColor: theme.palette.background.default
                },
                children: [
                    !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28492c717b57295f$export$217a9e3a96a18b85), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).options,
                        defaultExpanded: defaultExpanded,
                        defaultSelected: defaultSelected
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).mainContent,
                        style: {
                            width: isMobile ? "100%" : "78%",
                            color: theme.palette.primary.main
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                ref: topReference,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).scrollReference
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).text,
                                children: children
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).footer,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).general_queries
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                        href: `mailto: ${(0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail}`,
                                        style: {
                                            color: theme.palette.secondary.main
                                        },
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).support_mail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($b9a7c6c1f03a36c6$exports))).creditsMobile : undefined
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $a0a7f8ff26518012$export$d1864b4ff29f6561 = ({ defaultExpanded: defaultExpanded, defaultSelected: defaultSelected, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8b878d338458fb6$export$c02fd77fbe89d29f), {
        defaultExpanded: defaultExpanded,
        defaultSelected: defaultSelected,
        children: children
    });
};





parcelRequire("7fPBF");



parcelRequire("7fPBF");

var $2bbdd50529e0bd64$exports = {};

$parcel$export($2bbdd50529e0bd64$exports, "appStoreButton", function () { return $2bbdd50529e0bd64$export$751fd1e782c48928; }, function (v) { return $2bbdd50529e0bd64$export$751fd1e782c48928 = v; });
$parcel$export($2bbdd50529e0bd64$exports, "image", function () { return $2bbdd50529e0bd64$export$5c452ff88e35e47d; }, function (v) { return $2bbdd50529e0bd64$export$5c452ff88e35e47d = v; });
$parcel$export($2bbdd50529e0bd64$exports, "iosShare", function () { return $2bbdd50529e0bd64$export$1d31889a7aa37077; }, function (v) { return $2bbdd50529e0bd64$export$1d31889a7aa37077 = v; });
$parcel$export($2bbdd50529e0bd64$exports, "qrAppStore", function () { return $2bbdd50529e0bd64$export$c494f990918b7721; }, function (v) { return $2bbdd50529e0bd64$export$c494f990918b7721 = v; });
$parcel$export($2bbdd50529e0bd64$exports, "videoDiv", function () { return $2bbdd50529e0bd64$export$77238ba34374270; }, function (v) { return $2bbdd50529e0bd64$export$77238ba34374270 = v; });
var $2bbdd50529e0bd64$export$751fd1e782c48928;
var $2bbdd50529e0bd64$export$5c452ff88e35e47d;
var $2bbdd50529e0bd64$export$1d31889a7aa37077;
var $2bbdd50529e0bd64$export$c494f990918b7721;
var $2bbdd50529e0bd64$export$77238ba34374270;
$2bbdd50529e0bd64$export$751fd1e782c48928 = `Nyf6Ua_appStoreButton`;
$2bbdd50529e0bd64$export$5c452ff88e35e47d = `Nyf6Ua_image`;
$2bbdd50529e0bd64$export$1d31889a7aa37077 = `Nyf6Ua_iosShare`;
$2bbdd50529e0bd64$export$c494f990918b7721 = `Nyf6Ua_qrAppStore`;
$2bbdd50529e0bd64$export$77238ba34374270 = `Nyf6Ua_videoDiv`;



var $9050db599c01faa1$exports = {};
$9050db599c01faa1$exports = $parcel$resolve("2h11H");


var $a679ada1f671f9b3$exports = {};
$a679ada1f671f9b3$exports = $parcel$resolve("iMG6b");


const $720a9af6623747c9$export$9aa9c4b44ee7c26f = ()=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const QRAppStoreBlack = new URL($9050db599c01faa1$exports).href;
    const QRAppStoreWhite = new URL($a679ada1f671f9b3$exports).href;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.block1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdd50529e0bd64$exports))).videoDiv,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("iframe", {
                    height: 300,
                    width: 532,
                    style: {
                        border: "none"
                    },
                    src: `https://www.youtube.com/embed/${(0, $37bec70ed65ed924$export$21c51bc433c16634).tutorial_video_id}`,
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true,
                    title: "Tutorial video"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.block2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdd50529e0bd64$exports))).image,
                alt: "Album List",
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.album_list_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "mobile"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.mobile_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.mobile_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "android"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.android_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                style: {
                    whiteSpace: "pre-wrap"
                },
                children: [
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.android_description_1,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        target: "_blank",
                        href: "https://www.piper.ldelosheros.com",
                        children: "https://piper.ldelosheros.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.android_description_2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "ios"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.ios_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.ios_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdd50529e0bd64$exports))).iosShare,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdd50529e0bd64$exports))).qrAppStore,
                        alt: "QR Code",
                        src: theme.palette.mode == "light" ? QRAppStoreWhite : QRAppStoreBlack
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        target: "_blank",
                        href: "https://apple.co/3P2tpt7",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdd50529e0bd64$exports))).appStoreButton,
                            alt: "App Store",
                            src: (0, $37bec70ed65ed924$export$21c51bc433c16634).about_piper.app_store_button
                        })
                    })
                ]
            })
        ]
    });
};


const $e61fc02a53f54870$export$84473329c07819ac = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_home.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28492c717b57295f$export$217a9e3a96a18b85), {
                defaultExpanded: [
                    ""
                ],
                defaultSelected: "",
                hidePreferences: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $720a9af6623747c9$export$9aa9c4b44ee7c26f), {})
        ]
    });
};



parcelRequire("7fPBF");

var $143af47e7f26be9e$exports = {};

$parcel$export($143af47e7f26be9e$exports, "indentedText", function () { return $143af47e7f26be9e$export$11595878ec615630; }, function (v) { return $143af47e7f26be9e$export$11595878ec615630 = v; });
$parcel$export($143af47e7f26be9e$exports, "itemTitle", function () { return $143af47e7f26be9e$export$19d20253129869a; }, function (v) { return $143af47e7f26be9e$export$19d20253129869a = v; });
$parcel$export($143af47e7f26be9e$exports, "listItem", function () { return $143af47e7f26be9e$export$76c7e83ecc9cdf05; }, function (v) { return $143af47e7f26be9e$export$76c7e83ecc9cdf05 = v; });
var $143af47e7f26be9e$export$11595878ec615630;
var $143af47e7f26be9e$export$19d20253129869a;
var $143af47e7f26be9e$export$76c7e83ecc9cdf05;
$143af47e7f26be9e$export$11595878ec615630 = `Efr2Qq_indentedText`;
$143af47e7f26be9e$export$19d20253129869a = `Efr2Qq_itemTitle`;
$143af47e7f26be9e$export$76c7e83ecc9cdf05 = `Efr2Qq_listItem`;


const $3a2ca1737637f281$export$f37ec6636ba46d53 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.block1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "consent"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.consent_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.consent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "info-collect"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_collect_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_collect
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "info-sensitive"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.sensitive_info_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.sensitive_info_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "info-use"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_3
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_4
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_5
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_6
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.info_use_7
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "log-files"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.log_files_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.log_files
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "cookies"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.cookies_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.cookies
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "third-parties"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.third_parties_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.third_parties
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "ai-info"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ai_info_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ai_info
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "ccpa-rights"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights_3
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.ccpa_rights_end
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "gdpr-rights"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_3
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_4
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_5
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_6
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.gdpr_rights_end
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "changes"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.changes_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.changes
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "contact"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.contact_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.contact
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                style: {
                    fontWeight: "bold"
                },
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).privacy_policy.last_update
            })
        ]
    });
};



parcelRequire("7fPBF");


const $ab5784abf2bdde2a$export$71407bb9bba1ac12 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.block1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "consent"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.consent_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.consent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "service"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.service_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.service
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "data"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.data_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.data
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "ai"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.ai_info_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.ai_info
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "subscriptions"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.subscriptions_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.subscriptions
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "users"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_3
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_4
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_5
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_6
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_7
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_8
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_9
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_10
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.users_11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "warranties"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_3
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_4
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.warranties_5
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "rights"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.rights_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.rights
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "maintenance"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.maintenance_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.maintenance
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "links"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.links_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                children: [
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.links_description,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        target: "_blank",
                        href: "https://www.youtube.com/t/terms",
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.links_youtube_terms
                    }),
                    ".\n\n"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "changes"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.changes_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.changes
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "contact"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.contact_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.contact
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                style: {
                    fontWeight: "bold"
                },
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).terms.last_update
            })
        ]
    });
};



parcelRequire("7fPBF");

var $7bfab2f278e9f823$exports = {};

$parcel$export($7bfab2f278e9f823$exports, "image", function () { return $7bfab2f278e9f823$export$5c452ff88e35e47d; }, function (v) { return $7bfab2f278e9f823$export$5c452ff88e35e47d = v; });
var $7bfab2f278e9f823$export$5c452ff88e35e47d;
$7bfab2f278e9f823$export$5c452ff88e35e47d = `yNFEcG_image`;


const $6ee517ac14a3394a$export$80fc0ec805151b01 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7bfab2f278e9f823$exports))).image,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.import_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $571abc4c1d6e7232$exports = {};

$parcel$export($571abc4c1d6e7232$exports, "imageCreate", function () { return $571abc4c1d6e7232$export$1c3c10e99aca078d; }, function (v) { return $571abc4c1d6e7232$export$1c3c10e99aca078d = v; });
$parcel$export($571abc4c1d6e7232$exports, "imageFloatRight", function () { return $571abc4c1d6e7232$export$40b0ed3b80d7f711; }, function (v) { return $571abc4c1d6e7232$export$40b0ed3b80d7f711 = v; });
$parcel$export($571abc4c1d6e7232$exports, "itemTitle", function () { return $571abc4c1d6e7232$export$19d20253129869a; }, function (v) { return $571abc4c1d6e7232$export$19d20253129869a = v; });
$parcel$export($571abc4c1d6e7232$exports, "listItem", function () { return $571abc4c1d6e7232$export$76c7e83ecc9cdf05; }, function (v) { return $571abc4c1d6e7232$export$76c7e83ecc9cdf05 = v; });
var $571abc4c1d6e7232$export$1c3c10e99aca078d;
var $571abc4c1d6e7232$export$40b0ed3b80d7f711;
var $571abc4c1d6e7232$export$19d20253129869a;
var $571abc4c1d6e7232$export$76c7e83ecc9cdf05;
$571abc4c1d6e7232$export$1c3c10e99aca078d = `Q63lOa_imageCreate`;
$571abc4c1d6e7232$export$40b0ed3b80d7f711 = `Q63lOa_imageFloatRight`;
$571abc4c1d6e7232$export$19d20253129869a = `Q63lOa_itemTitle`;
$571abc4c1d6e7232$export$76c7e83ecc9cdf05 = `Q63lOa_listItem`;






const $d58e30dd757e1dc6$export$c9896c9aa786001 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.create_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).imageCreate,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.create_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.create_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "delete"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.delete_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).imageFloatRight,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.delete_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums.delete_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "more"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_more_options_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).list,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    sx: {
                        margin: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.filterAlbums()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.home_title
                            })
                        }, "FilterAlbums"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.orderAlbums()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.home_title
                            })
                        }, "OrderAlbums"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.markingAlbums()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.title
                            })
                        }, "MarkingAlbums"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.scanBarcode()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.home_title
                            })
                        }, "ScanBarcode"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromDiscogs()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_discogs.title
                            })
                        }, "ImportFromDiscogs"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromExcel()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.title
                            })
                        }, "ImportFromExcel"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.imageGallery()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_image_gallery.title
                            })
                        }, "ImageGallery"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.removeFilteredAlbums()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.title
                            })
                        }, "RemoveFiltered")
                    ]
                })
            })
        ]
    });
};




parcelRequire("7fPBF");

var $47dd5ffc38eccf61$exports = {};

$parcel$export($47dd5ffc38eccf61$exports, "image", function () { return $47dd5ffc38eccf61$export$5c452ff88e35e47d; }, function (v) { return $47dd5ffc38eccf61$export$5c452ff88e35e47d = v; });
$parcel$export($47dd5ffc38eccf61$exports, "imageFloatRight", function () { return $47dd5ffc38eccf61$export$40b0ed3b80d7f711; }, function (v) { return $47dd5ffc38eccf61$export$40b0ed3b80d7f711 = v; });
$parcel$export($47dd5ffc38eccf61$exports, "imageOrder", function () { return $47dd5ffc38eccf61$export$dacf7426b9362e47; }, function (v) { return $47dd5ffc38eccf61$export$dacf7426b9362e47 = v; });
var $47dd5ffc38eccf61$export$5c452ff88e35e47d;
var $47dd5ffc38eccf61$export$40b0ed3b80d7f711;
var $47dd5ffc38eccf61$export$dacf7426b9362e47;
$47dd5ffc38eccf61$export$5c452ff88e35e47d = `nLwIWq_image`;
$47dd5ffc38eccf61$export$40b0ed3b80d7f711 = `nLwIWq_imageFloatRight`;
$47dd5ffc38eccf61$export$dacf7426b9362e47 = `nLwIWq_imageOrder`;


const $80364055e7e888a4$export$6f222a0c87c92fc0 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($47dd5ffc38eccf61$exports))).image,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.bar_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.order_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($47dd5ffc38eccf61$exports))).imageOrder,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.order_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($47dd5ffc38eccf61$exports))).imageFloatRight,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.elements_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_filter_albums.elements_description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $e9ac502956282b04$exports = {};

$parcel$export($e9ac502956282b04$exports, "image", function () { return $e9ac502956282b04$export$5c452ff88e35e47d; }, function (v) { return $e9ac502956282b04$export$5c452ff88e35e47d = v; });
$parcel$export($e9ac502956282b04$exports, "imageOrder", function () { return $e9ac502956282b04$export$dacf7426b9362e47; }, function (v) { return $e9ac502956282b04$export$dacf7426b9362e47 = v; });
var $e9ac502956282b04$export$5c452ff88e35e47d;
var $e9ac502956282b04$export$dacf7426b9362e47;
$e9ac502956282b04$export$5c452ff88e35e47d = `mPOidq_image`;
$e9ac502956282b04$export$dacf7426b9362e47 = `mPOidq_imageOrder`;


const $2b6c9d2bd28e2692$export$9aaad60b6a9f4e35 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e9ac502956282b04$exports))).image,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.prefs_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e9ac502956282b04$exports))).imageOrder,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.album_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_order_albums.drag_description
            })
        ]
    });
};



parcelRequire("7fPBF");





const $a08638cf2f46c77f$export$d102eea4d9f276d2 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.free_plan
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.free_plan_description
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.collector_plan
                            }),
                            (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.collector_plan_description
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.premium_plan
                                }),
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.premium_plan_description
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.premium_plan_body_1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.premium_plan_body_2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.premium_plan_end
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_subscriptions.access
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "more"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_more_options_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    sx: {
                        margin: 2
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).listItem,
                        onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.mercadoPago()}`),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                            disableTypography: true,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).itemTitle,
                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_mercado_pago_subscriptions.title
                        })
                    }, "MercadoPago")
                })
            })
        ]
    });
};



parcelRequire("7fPBF");

const $29786476d85b546c$export$e79d589672568c69 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_mercado_pago_subscriptions.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_mercado_pago_subscriptions.description
            })
        ]
    });
};




parcelRequire("7fPBF");

var $1b4995625653f3d5$exports = {};

$parcel$export($1b4995625653f3d5$exports, "imageFloatRight", function () { return $1b4995625653f3d5$export$40b0ed3b80d7f711; }, function (v) { return $1b4995625653f3d5$export$40b0ed3b80d7f711 = v; });
$parcel$export($1b4995625653f3d5$exports, "indentedText", function () { return $1b4995625653f3d5$export$11595878ec615630; }, function (v) { return $1b4995625653f3d5$export$11595878ec615630 = v; });
var $1b4995625653f3d5$export$40b0ed3b80d7f711;
var $1b4995625653f3d5$export$11595878ec615630;
$1b4995625653f3d5$export$40b0ed3b80d7f711 = `Z18lBa_imageFloatRight`;
$1b4995625653f3d5$export$11595878ec615630 = `Z18lBa_indentedText`;


const $25d834daba3a36a2$export$8cbaab782a1d83f9 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1b4995625653f3d5$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.description_1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.description_2
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.description_3
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "signUpThirdParty"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_third_party_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1b4995625653f3d5$exports))).imageFloatRight,
                style: {
                    maxWidth: "24%"
                },
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_third_party_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_third_party_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "signUpWithPiper"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_piper_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1b4995625653f3d5$exports))).imageFloatRight,
                style: {
                    maxWidth: "40%"
                },
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_piper_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_sign_up.sign_up_piper_description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $0617f43d929b48e9$exports = {};

$parcel$export($0617f43d929b48e9$exports, "imageFloatLeft", function () { return $0617f43d929b48e9$export$da87c30f5ff40adc; }, function (v) { return $0617f43d929b48e9$export$da87c30f5ff40adc = v; });
var $0617f43d929b48e9$export$da87c30f5ff40adc;
$0617f43d929b48e9$export$da87c30f5ff40adc = `gt9UvG_imageFloatLeft`;


const $4e17709aadc06eea$export$d62d86b457b9cf50 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0617f43d929b48e9$exports))).imageFloatLeft,
                style: {
                    maxWidth: "16%"
                },
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.options_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0617f43d929b48e9$exports))).imageFloatLeft,
                style: {
                    maxWidth: "32%"
                },
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_guest.drawer_image
            })
        ]
    });
};



parcelRequire("7fPBF");

const $fd2b2988913f4f69$export$56e1b3dfb0093889 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_recover_password.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_users_recover_password.description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $02dfa8f3cb0c3cf1$exports = {};

$parcel$export($02dfa8f3cb0c3cf1$exports, "imageCreate", function () { return $02dfa8f3cb0c3cf1$export$1c3c10e99aca078d; }, function (v) { return $02dfa8f3cb0c3cf1$export$1c3c10e99aca078d = v; });
var $02dfa8f3cb0c3cf1$export$1c3c10e99aca078d;
$02dfa8f3cb0c3cf1$export$1c3c10e99aca078d = `FPIOHW_imageCreate`;


const $d393acaf50f50b5b$export$1ee12e5d49a4aea6 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($02dfa8f3cb0c3cf1$exports))).imageCreate,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.main_buttons_toolbar_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "scan"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.scan_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.scan_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "search"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.search_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_albums_add_barcode.search_description
            })
        ]
    });
};



parcelRequire("7fPBF");

const $376a6929e2bcc92d$export$db3d3f308a619bef = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_image_gallery.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_image_gallery.description
            })
        ]
    });
};



parcelRequire("7fPBF");

const $f1133232e360eb6b$export$a504e6df849ca8f = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "notifications"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.notifications_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.notifications_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "avatar"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.update_avatar_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.update_avatar_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "username"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.username_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.username_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "email"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.email_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.email_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "password"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.password_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.password_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "bio"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.bio_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.bio_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "currency"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.currency_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.currency_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "decimals"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.decimals_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.decimals_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "ratingDescriptions"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.impacts_description_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.impacts_description_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "albumId"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.album_id_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.album_id_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "colors"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.colors_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_user_profile.colors_description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $367120493fc51355$exports = {};

$parcel$export($367120493fc51355$exports, "listItem", function () { return $367120493fc51355$export$76c7e83ecc9cdf05; }, function (v) { return $367120493fc51355$export$76c7e83ecc9cdf05 = v; });
$parcel$export($367120493fc51355$exports, "normalText", function () { return $367120493fc51355$export$7040f980bc8fd76b; }, function (v) { return $367120493fc51355$export$7040f980bc8fd76b = v; });
$parcel$export($367120493fc51355$exports, "templateButton", function () { return $367120493fc51355$export$539825656abb49f8; }, function (v) { return $367120493fc51355$export$539825656abb49f8 = v; });
var $367120493fc51355$export$76c7e83ecc9cdf05;
var $367120493fc51355$export$7040f980bc8fd76b;
var $367120493fc51355$export$539825656abb49f8;
$367120493fc51355$export$76c7e83ecc9cdf05 = `QYzFLa_listItem`;
$367120493fc51355$export$7040f980bc8fd76b = `QYzFLa_normalText`;
$367120493fc51355$export$539825656abb49f8 = `QYzFLa_templateButton`;



const $a39c5bbfff444133$export$869f01f7d1075ef4 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.description_1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).templateButton,
                href: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_template_url,
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).excel_import_download_template
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.description_2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_1
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_2
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_3
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_4
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_5
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_6
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_7
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_8
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_9
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_10
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_11
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_12
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_13
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_14
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_15
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_16
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_17
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_18
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_19
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_20
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_21
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_22
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_23
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_24
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).listItem,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($367120493fc51355$exports))).normalText,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_import_from_excel.column_25
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("7fPBF");


const $0b65259cc47bcffd$export$45c46074c8072d95 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                alt: "Remove filtered albums",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e9ac502956282b04$exports))).image,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.option_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_remove_filtered_albums.description
            })
        ]
    });
};



parcelRequire("7fPBF");

var $2efee824d9ae899f$exports = {};

$parcel$export($2efee824d9ae899f$exports, "imageCreate", function () { return $2efee824d9ae899f$export$1c3c10e99aca078d; }, function (v) { return $2efee824d9ae899f$export$1c3c10e99aca078d = v; });
$parcel$export($2efee824d9ae899f$exports, "imageFloatRight", function () { return $2efee824d9ae899f$export$40b0ed3b80d7f711; }, function (v) { return $2efee824d9ae899f$export$40b0ed3b80d7f711 = v; });
$parcel$export($2efee824d9ae899f$exports, "itemTitle", function () { return $2efee824d9ae899f$export$19d20253129869a; }, function (v) { return $2efee824d9ae899f$export$19d20253129869a = v; });
$parcel$export($2efee824d9ae899f$exports, "listItem", function () { return $2efee824d9ae899f$export$76c7e83ecc9cdf05; }, function (v) { return $2efee824d9ae899f$export$76c7e83ecc9cdf05 = v; });
var $2efee824d9ae899f$export$1c3c10e99aca078d;
var $2efee824d9ae899f$export$40b0ed3b80d7f711;
var $2efee824d9ae899f$export$19d20253129869a;
var $2efee824d9ae899f$export$76c7e83ecc9cdf05;
$2efee824d9ae899f$export$1c3c10e99aca078d = `NIAwuG_imageCreate`;
$2efee824d9ae899f$export$40b0ed3b80d7f711 = `NIAwuG_imageFloatRight`;
$2efee824d9ae899f$export$19d20253129869a = `NIAwuG_itemTitle`;
$2efee824d9ae899f$export$76c7e83ecc9cdf05 = `NIAwuG_listItem`;






const $af34102503af929e$export$d3445568dc41c34 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).imageCreate,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.create_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.create_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "delete"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.delete_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).imageFloatRight,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.delete_image
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections.delete_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "more"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_more_options_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    sx: {
                        margin: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.attributes()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.title
                            })
                        }, "Attributes"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).listItem,
                            onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.publicCollections()}`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                                disableTypography: true,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2efee824d9ae899f$exports))).itemTitle,
                                primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_public_collections.title
                            })
                        }, "PublicCollections")
                    ]
                })
            })
        ]
    });
};



parcelRequire("7fPBF");

const $eaed737ee084e807$export$758e6c18eabb63b6 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_public_collections.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_public_collections.description
            })
        ]
    });
};



parcelRequire("7fPBF");

const $6ba7870b05dcae1c$export$528fa3e36182fe6e = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "name"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.name_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.name_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "image"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.image_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.image_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "visibility"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.visibility_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.visibility_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "bannedFields"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.banned_fields_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.banned_fields_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "discount"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.discount_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.discount_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "description"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.description_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_collections_attributes.description_description
            })
        ]
    });
};



parcelRequire("7fPBF");

const $58269cc05b6839eb$export$f5a0ffe61728b79a = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_artists.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_artists.description
            })
        ]
    });
};



parcelRequire("7fPBF");





const $08c4b303548168c1$export$3672607fc8546e30 = ()=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "name"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.name_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.name_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "image"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.image_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.image_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "country"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.country_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.country_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "originalYear"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.original_year_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.original_year_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "releaseYear"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.release_year_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.release_year_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "catalogueNumber"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.catalogue_number_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.catalogue_number_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "discogsId"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.discogs_id_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.discogs_id_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "purchaseDate"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.purchase_date_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.purchase_date_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "purchasePrice"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.purchase_price_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.purchase_price_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "trackCount"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.track_count_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.track_count_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "length"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.length_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.length_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "collections"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.collections_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.collections_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "played"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.played_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.played_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "insert"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.has_insert_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.has_insert_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "lyrics"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.has_lyrics_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.has_lyrics_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "gatefold"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.gatefold_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.gatefold_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "jacketGrade"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.sleeve_grade_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.sleeve_grade_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "mediaGrade"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.media_grade_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.media_grade_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "rating"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.impact_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.impact_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "notes"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.notes_title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.notes_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "more"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_album_attributes.more_attributes
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    sx: {
                        margin: 2
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).listItem,
                        onClick: ()=>navigate(`${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.albumAttributes.artists()}`),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                            disableTypography: true,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($571abc4c1d6e7232$exports))).itemTitle,
                            primary: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_artists.title
                        })
                    }, "Artists")
                })
            })
        ]
    });
};



parcelRequire("7fPBF");


const $bae9fde938a87fc3$export$1fb2c00a31a77000 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($47dd5ffc38eccf61$exports))).image,
                src: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_marking_albums.image
            })
        ]
    });
};



parcelRequire("7fPBF");


const $e3c17bd689e4da26$export$39894cd540759b24 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                id: "title"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.description_1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($143af47e7f26be9e$exports))).indentedText,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_albums
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_collections
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_shelvings
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_artists
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_labels
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_album_formats
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_album_types
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_tags
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_stores
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_sell_values
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.limit_exchange_rates
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).doc_purchases.description_2
            })
        ]
    });
};


const $11ee0d67da937970$export$e7e6be814875dfe1 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d42da6e692e216cc$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        ""
                    ],
                    defaultSelected: "",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e61fc02a53f54870$export$84473329c07819ac), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.about(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "about"
                    ],
                    defaultSelected: "about",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $720a9af6623747c9$export$9aa9c4b44ee7c26f), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.home(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "users_parent"
                    ],
                    defaultSelected: "users_sign_up",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25d834daba3a36a2$export$8cbaab782a1d83f9), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.signUp(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "users_parent"
                    ],
                    defaultSelected: "users_sign_up",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25d834daba3a36a2$export$8cbaab782a1d83f9), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.guest(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "users_parent"
                    ],
                    defaultSelected: "users_guest",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e17709aadc06eea$export$d62d86b457b9cf50), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.users.recoverPassword(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "users_parent"
                    ],
                    defaultSelected: "users_recover_password",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd2b2988913f4f69$export$56e1b3dfb0093889), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.home(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_home",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d58e30dd757e1dc6$export$c9896c9aa786001), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.filterAlbums(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_filter",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $80364055e7e888a4$export$6f222a0c87c92fc0), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.orderAlbums(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_order",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b6c9d2bd28e2692$export$9aaad60b6a9f4e35), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.markingAlbums(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_marks",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bae9fde938a87fc3$export$1fb2c00a31a77000), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.scanBarcode(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_scan_barcode",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d393acaf50f50b5b$export$1ee12e5d49a4aea6), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromDiscogs(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_import_discogs",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ee517ac14a3394a$export$80fc0ec805151b01), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.importFromExcel(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_import_excel",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a39c5bbfff444133$export$869f01f7d1075ef4), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.imageGallery(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_image_gallery",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $376a6929e2bcc92d$export$db3d3f308a619bef), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.removeFilteredAlbums(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_parent"
                    ],
                    defaultSelected: "album_remove_filtered_albums",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b65259cc47bcffd$export$45c46074c8072d95), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.albumAttributes.home(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_attributes_parent"
                    ],
                    defaultSelected: "album_attributes_home",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08c4b303548168c1$export$3672607fc8546e30), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.albumAttributes.artists(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "album_attributes_parent"
                    ],
                    defaultSelected: "album_attributes_artists",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $58269cc05b6839eb$export$f5a0ffe61728b79a), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.home(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "collections_parent"
                    ],
                    defaultSelected: "collections_home",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af34102503af929e$export$d3445568dc41c34), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.attributes(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "collections_parent"
                    ],
                    defaultSelected: "collections_attributes",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ba7870b05dcae1c$export$528fa3e36182fe6e), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.collections.publicCollections(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "collections_parent"
                    ],
                    defaultSelected: "collections_public_collections",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eaed737ee084e807$export$758e6c18eabb63b6), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.userProfile(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "userProfile"
                    ],
                    defaultSelected: "userProfile",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1133232e360eb6b$export$a504e6df849ca8f), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.purchases(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "purchases_parent"
                    ],
                    defaultSelected: "purchases_home",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3c17bd689e4da26$export$39894cd540759b24), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.home(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "subscriptions_parent"
                    ],
                    defaultSelected: "subscriptions_home",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a08638cf2f46c77f$export$d102eea4d9f276d2), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.mercadoPago(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "subscriptions_parent"
                    ],
                    defaultSelected: "subscriptions_mercado_pago",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29786476d85b546c$export$e79d589672568c69), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.policy(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "policy"
                    ],
                    defaultSelected: "policy",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a2ca1737637f281$export$f37ec6636ba46d53), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: (0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.terms(),
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0a7f8ff26518012$export$d1864b4ff29f6561), {
                    defaultExpanded: [
                        "terms"
                    ],
                    defaultSelected: "terms",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab5784abf2bdde2a$export$71407bb9bba1ac12), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bedca6cde600b0a$export$6ba01d3268a66fe8), {})
            }, "not_found")
        ]
    });
};



parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $fd0fbbd2e7ec32a5$exports = {};

$parcel$export($fd0fbbd2e7ec32a5$exports, "backdrop", function () { return $fd0fbbd2e7ec32a5$export$48e901322468f6d5; }, function (v) { return $fd0fbbd2e7ec32a5$export$48e901322468f6d5 = v; });
var $fd0fbbd2e7ec32a5$export$48e901322468f6d5;
$fd0fbbd2e7ec32a5$export$48e901322468f6d5 = `Ann1bG_backdrop`;






const $c1f42410578f8f42$export$db7c71cad2c61286 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const processMercadoPagoSubscription = async (parameters)=>{
        return put("mercadopago/subscription", parameters);
    };
    return {
        processMercadoPagoSubscription: processMercadoPagoSubscription
    };
};









const $c0ea0a5f3b115f16$export$45da7b014b1dda4d = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const createMercadoPagoPurchase = async (parameters)=>{
        return post("mercadopago/purchase", parameters);
    };
    return {
        createMercadoPagoPurchase: createMercadoPagoPurchase
    };
};



const $4e1ab315544addf0$export$e8e84ccd09fbede1 = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name;
    }, []);
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const { processMercadoPagoSubscription: processMercadoPagoSubscription } = (0, $c1f42410578f8f42$export$db7c71cad2c61286)();
    const { createMercadoPagoPurchase: createMercadoPagoPurchase } = (0, $c0ea0a5f3b115f16$export$45da7b014b1dda4d)();
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [shouldCloseSession, setShouldCloseSession] = (0, $7fPBF.useState)(false);
    const processPayment = ()=>{
        const queryParams = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search);
        const subscriptionId = queryParams.preapproval_id;
        if (typeof subscriptionId != "string") processPurchase();
        else processPaymentFromMercadoPago(subscriptionId).then();
    };
    const processPurchase = ()=>{
        const queryParams = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search);
        const paymentId = queryParams.payment_id;
        if (typeof paymentId != "string") navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
        else createPurchaseFromMercadoPago(paymentId).then();
    };
    (0, $7fPBF.useEffect)(()=>{
        processPayment();
    }, []);
    const processPaymentFromMercadoPago = async (subscriptionId)=>{
        setShouldCloseSession(true);
        const { status: status, body: body } = await processMercadoPagoSubscription({
            externalSubscriptionId: subscriptionId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_success);
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("payment_subscription", {
                externalSubscriptionId: subscriptionId
            });
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    const createPurchaseFromMercadoPago = async (paymentId)=>{
        setShouldCloseSession(false);
        const { status: status, body: body } = await createMercadoPagoPurchase({
            paymentId: paymentId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_success);
            (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("payment_purchase", {
                paymentId: paymentId
            });
        } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fd0fbbd2e7ec32a5$exports))).backdrop,
        open: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                closeOnTouch: false,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    processPayment();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name,
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen,
                onConfirm: ()=>{
                    if (shouldCloseSession) closeSession();
                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
                }
            })
        ]
    });
};


const $47b6cfa39ea1f323$export$cf5a111a9e94a929 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e1ab315544addf0$export$e8e84ccd09fbede1), {});
};






parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $6707c90cff925bc3$exports = {};

$parcel$export($6707c90cff925bc3$exports, "appBar", function () { return $6707c90cff925bc3$export$d0a9b8580e71599c; }, function (v) { return $6707c90cff925bc3$export$d0a9b8580e71599c = v; });
$parcel$export($6707c90cff925bc3$exports, "button", function () { return $6707c90cff925bc3$export$2ba01fb71ed41cb6; }, function (v) { return $6707c90cff925bc3$export$2ba01fb71ed41cb6 = v; });
$parcel$export($6707c90cff925bc3$exports, "buttonsDiv", function () { return $6707c90cff925bc3$export$f08d8e7ed913fbf; }, function (v) { return $6707c90cff925bc3$export$f08d8e7ed913fbf = v; });
$parcel$export($6707c90cff925bc3$exports, "buttonsDivMobile", function () { return $6707c90cff925bc3$export$e4021eacf34ba55b; }, function (v) { return $6707c90cff925bc3$export$e4021eacf34ba55b = v; });
$parcel$export($6707c90cff925bc3$exports, "detailBody", function () { return $6707c90cff925bc3$export$53b275054013afb6; }, function (v) { return $6707c90cff925bc3$export$53b275054013afb6 = v; });
$parcel$export($6707c90cff925bc3$exports, "list", function () { return $6707c90cff925bc3$export$8837f4fc672e936d; }, function (v) { return $6707c90cff925bc3$export$8837f4fc672e936d = v; });
$parcel$export($6707c90cff925bc3$exports, "mainBody", function () { return $6707c90cff925bc3$export$f239b04fc1a0c7e1; }, function (v) { return $6707c90cff925bc3$export$f239b04fc1a0c7e1 = v; });
$parcel$export($6707c90cff925bc3$exports, "mainContainer", function () { return $6707c90cff925bc3$export$eccb60d5692f3f7d; }, function (v) { return $6707c90cff925bc3$export$eccb60d5692f3f7d = v; });
$parcel$export($6707c90cff925bc3$exports, "piperLogo", function () { return $6707c90cff925bc3$export$8cacecdcbcc49d33; }, function (v) { return $6707c90cff925bc3$export$8cacecdcbcc49d33 = v; });
$parcel$export($6707c90cff925bc3$exports, "resizeHandle", function () { return $6707c90cff925bc3$export$8e36b812ea421d73; }, function (v) { return $6707c90cff925bc3$export$8e36b812ea421d73 = v; });
$parcel$export($6707c90cff925bc3$exports, "title", function () { return $6707c90cff925bc3$export$fb184b623420d9be; }, function (v) { return $6707c90cff925bc3$export$fb184b623420d9be = v; });
$parcel$export($6707c90cff925bc3$exports, "toolbar", function () { return $6707c90cff925bc3$export$f727f52c778e92d5; }, function (v) { return $6707c90cff925bc3$export$f727f52c778e92d5 = v; });
var $6707c90cff925bc3$export$d0a9b8580e71599c;
var $6707c90cff925bc3$export$2ba01fb71ed41cb6;
var $6707c90cff925bc3$export$f08d8e7ed913fbf;
var $6707c90cff925bc3$export$e4021eacf34ba55b;
var $6707c90cff925bc3$export$53b275054013afb6;
var $6707c90cff925bc3$export$8837f4fc672e936d;
var $6707c90cff925bc3$export$f239b04fc1a0c7e1;
var $6707c90cff925bc3$export$eccb60d5692f3f7d;
var $6707c90cff925bc3$export$8cacecdcbcc49d33;
var $6707c90cff925bc3$export$8e36b812ea421d73;
var $6707c90cff925bc3$export$fb184b623420d9be;
var $6707c90cff925bc3$export$f727f52c778e92d5;
$6707c90cff925bc3$export$d0a9b8580e71599c = `W0VTha_appBar`;
$6707c90cff925bc3$export$2ba01fb71ed41cb6 = `W0VTha_button`;
$6707c90cff925bc3$export$f08d8e7ed913fbf = `W0VTha_buttonsDiv`;
$6707c90cff925bc3$export$e4021eacf34ba55b = `W0VTha_buttonsDivMobile`;
$6707c90cff925bc3$export$53b275054013afb6 = `W0VTha_detailBody`;
$6707c90cff925bc3$export$8837f4fc672e936d = `W0VTha_list`;
$6707c90cff925bc3$export$f239b04fc1a0c7e1 = `W0VTha_mainBody`;
$6707c90cff925bc3$export$eccb60d5692f3f7d = `W0VTha_mainContainer`;
$6707c90cff925bc3$export$8cacecdcbcc49d33 = `W0VTha_piperLogo`;
$6707c90cff925bc3$export$8e36b812ea421d73 = `W0VTha_resizeHandle`;
$6707c90cff925bc3$export$fb184b623420d9be = `W0VTha_title`;
$6707c90cff925bc3$export$f727f52c778e92d5 = `W0VTha_toolbar`;













var $1ZNeQ = parcelRequire("1ZNeQ");



const $2455ae2c553c845f$export$96a7af2ec75368f8 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>post("admin/collections/highlights", props);
};
const $2455ae2c553c845f$export$bf795c53e9b5b601 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/albums/highlights", undefined);
};



const $e53f87c874db95e6$export$28585c5bcf1991d7 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/backupDatabase", {});
};



const $8c3ae233f52d4692$export$a0fc2c101aeb90be = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/updateMercadoPagoPayments", {});
};



const $08bcf44ea7d36727$export$97622ceffe8999e9 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/updateApplePayments", {});
};



const $2011f486ca59c438$export$7b6bdda843e243e5 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>deleteRequest("admin/clearThumbnails", {});
};



const $6381d5a7cff05c60$export$7058eedf31a8419d = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>get("admin/subscription/mercadoPago", props);
};



const $01bff5e6fe337a0f$export$fab0a9bccc7a3ff4 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>post("admin/createUserNotification", props);
};



const $519d069b893d11f4$export$9fdf8117185fab22 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>post("admin/sendEmail", props);
};



const $9b33c5eae90f770e$export$58aac9ecd9d633fe = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>post("admin/sendTestEmail", props);
};






const $84aa360eb7904246$export$e378bdf609b80aec = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (props)=>get("admin/subscription/apple", props);
};



const $b24a3818021c2a7f$export$bed41053ac5c061c = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/sendNotificationEmails", {});
};



const $f856f24836f145f2$export$d6bb682f4fe0ca0f = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/createChatNotifications", {});
};



const $7ab461b84fbf56d7$export$fea1bdd436d5d0f0 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>post("admin/resetAllAlbumsClosestExchangeRate", {});
};



const $f62d164cfe46c8d4$export$a70e87e4c1258e9d = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ADMIN`;
    }, []);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [isLocked, setIsLocked] = (0, $7fPBF.useState)(true);
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            to: undefined,
            subject: undefined,
            body: undefined,
            messageEs: undefined,
            messageEn: undefined,
            severity: undefined,
            link: undefined,
            imageUrl: undefined,
            silent: undefined
        },
        onSubmit: ()=>{
        // Do nothing
        }
    });
    const [isFreeTextDialogOpen, setIsFreeTextDialogOpen] = (0, $7fPBF.useState)(false);
    const [currentField, setCurrentField] = (0, $7fPBF.useState)("to");
    const [currentFieldValue, setCurrentFieldValue] = (0, $7fPBF.useState)();
    const refreshCollectionHighlights = (0, $2455ae2c553c845f$export$96a7af2ec75368f8)();
    const refreshAlbumHighlights = (0, $2455ae2c553c845f$export$bf795c53e9b5b601)();
    const backupDatabase = (0, $e53f87c874db95e6$export$28585c5bcf1991d7)();
    const clearThumbnails = (0, $2011f486ca59c438$export$7b6bdda843e243e5)();
    const resetAllAlbumsClosestExchangeRate = (0, $7ab461b84fbf56d7$export$fea1bdd436d5d0f0)();
    const updateMercadoPagoPayments = (0, $8c3ae233f52d4692$export$a0fc2c101aeb90be)();
    const updateApplePayments = (0, $08bcf44ea7d36727$export$97622ceffe8999e9)();
    const getMercadoPagoSubscriptionByEmail = (0, $6381d5a7cff05c60$export$7058eedf31a8419d)();
    const getAppleSubscriptionByEmail = (0, $84aa360eb7904246$export$e378bdf609b80aec)();
    const createUserNotification = (0, $01bff5e6fe337a0f$export$fab0a9bccc7a3ff4)();
    const createChatNotifications = (0, $f856f24836f145f2$export$d6bb682f4fe0ca0f)();
    const sendEmail = (0, $519d069b893d11f4$export$9fdf8117185fab22)();
    const sendTestEmail = (0, $9b33c5eae90f770e$export$58aac9ecd9d633fe)();
    const sendNotificationEmails = (0, $b24a3818021c2a7f$export$bed41053ac5c061c)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const processResponse = (status, body)=>{
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setAlertMessage(JSON.stringify(body));
        else setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    const buttonsList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                width: "97%"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        if (!formik.values.subject || !formik.values.body || !formik.values.severity || !formik.values.messageEs || !formik.values.messageEn) return;
                        setIsLoading(true);
                        const { status: status, body: body } = await createUserNotification({
                            messageEn: formik.values.messageEn,
                            messageEs: formik.values.messageEs,
                            severity: formik.values.severity,
                            titleEn: formik.values.body,
                            titleEs: formik.values.subject,
                            userId: formik.values.to,
                            link: formik.values.link,
                            imageUrl: formik.values.imageUrl,
                            silent: formik.values.silent == "yes"
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Send notification"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        if (!formik.values.to || !formik.values.subject || !formik.values.body) return;
                        setIsLoading(true);
                        const { status: status, body: body } = await sendEmail({
                            to: formik.values.to,
                            subject: formik.values.subject,
                            body: formik.values.body
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Send email"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        if (!formik.values.body) return;
                        setIsLoading(true);
                        const { status: status, body: body } = await sendTestEmail({
                            body: formik.values.body
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Send TEST email"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await sendNotificationEmails();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Send daily notification emails"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await createChatNotifications();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Create chat notifications"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await refreshCollectionHighlights({
                            quantity: 5
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Refresh collection highlights"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await refreshAlbumHighlights();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Refresh album highlights"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await backupDatabase();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Backup Database"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await updateMercadoPagoPayments();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Update Mercado Pago payments"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await updateApplePayments();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Update Apple payments"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await clearThumbnails();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Clear thumbnails"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        if (!formik.values.to) return;
                        setIsLoading(true);
                        const { status: status, body: body } = await getMercadoPagoSubscriptionByEmail({
                            email: formik.values.to
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Get MercadoPago subscription by email"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        if (!formik.values.to) return;
                        setIsLoading(true);
                        const { status: status, body: body } = await getAppleSubscriptionByEmail({
                            email: formik.values.to
                        });
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Get Apple subscription by email"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).button,
                    disabled: isLocked,
                    onClick: async ()=>{
                        setIsLoading(true);
                        const { status: status, body: body } = await resetAllAlbumsClosestExchangeRate();
                        processResponse(status, body);
                        setIsLoading(false);
                    },
                    children: "Reset all albums closest exchange rate"
                })
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: false,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).piperLogo,
                            onClick: ()=>{
                            //
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).title,
                            children: "Admin console"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            sx: {
                                paddingLeft: 1,
                                width: theme.spacing(4)
                            },
                            children: isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            onClick: ()=>setIsLocked((state)=>!state),
                            children: "Lock"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
                value: formik,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).mainBody,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).detailBody,
                            style: {
                                backgroundColor: theme.palette.background.default
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).mainContainer,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$eb2fcfdbd7ba97d4), {
                                        orientation: "horizontal",
                                        children: [
                                            !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                                minSize: "30",
                                                defaultSize: "34",
                                                maxSize: "48",
                                                style: {
                                                    display: "flex",
                                                    overflow: "auto",
                                                    paddingBottom: 16
                                                },
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).list,
                                                    children: buttonsList()
                                                })
                                            }),
                                            !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$1ff3c3f08ae963c0), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).resizeHandle,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                                                    style: {
                                                        alignSelf: "center",
                                                        color: theme.palette.secondary.main,
                                                        fontSize: 14
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).buttonsDivMobile : (0, (/*@__PURE__*/$parcel$interopDefault($6707c90cff925bc3$exports))).buttonsDiv,
                                                children: [
                                                    isMobile && buttonsList(),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.to ?? "TO / EMAIL / USER ID",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("to");
                                                                        setCurrentFieldValue(formik.values.to);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.subject ?? "SUBJECT / TITLE ES",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("subject");
                                                                        setCurrentFieldValue(formik.values.subject);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.body ?? "BODY / TITLE EN",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("body");
                                                                        setCurrentFieldValue(formik.values.body);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.messageEs ?? "MESSAGE ES",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("messageEs");
                                                                        setCurrentFieldValue(formik.values.messageEs);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.messageEn ?? "MESSAGE EN",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("messageEn");
                                                                        setCurrentFieldValue(formik.values.messageEn);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.severity ?? "SEVERITY: info | pricing | critical | message",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("severity");
                                                                        setCurrentFieldValue(formik.values.severity);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.link ?? "LINK",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("link");
                                                                        setCurrentFieldValue(formik.values.link);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.imageUrl ?? "IMAGE URL",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("imageUrl");
                                                                        setCurrentFieldValue(formik.values.imageUrl);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                                                    hideTitle: true,
                                                                    detail: formik.values.silent ?? "IS SILENT (ENTER 'yes')",
                                                                    maxLines: 4,
                                                                    onClick: ()=>{
                                                                        setCurrentField("silent");
                                                                        setCurrentFieldValue(formik.values.silent);
                                                                        setIsFreeTextDialogOpen(true);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                        title: currentField,
                        description: "",
                        placeholder: "--",
                        value: currentFieldValue,
                        open: isFreeTextDialogOpen,
                        onClose: ()=>setIsFreeTextDialogOpen(false),
                        onChange: (newValue)=>formik.setFieldValue(currentField, newValue),
                        onClearValue: ()=>formik.setFieldValue(currentField, undefined)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




const $2f1e5139cf9a6f5e$export$7788d4c00e438b6e = ()=>{
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    return currentUser?.role == "admin" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f62d164cfe46c8d4$export$a70e87e4c1258e9d), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bedca6cde600b0a$export$6ba01d3268a66fe8), {});
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $7122f5b41a04d9b5$exports = {};

$parcel$export($7122f5b41a04d9b5$exports, "appBar", function () { return $7122f5b41a04d9b5$export$d0a9b8580e71599c; }, function (v) { return $7122f5b41a04d9b5$export$d0a9b8580e71599c = v; });
$parcel$export($7122f5b41a04d9b5$exports, "collectionTitle", function () { return $7122f5b41a04d9b5$export$eb877aaaf03a6de7; }, function (v) { return $7122f5b41a04d9b5$export$eb877aaaf03a6de7 = v; });
$parcel$export($7122f5b41a04d9b5$exports, "detailBody", function () { return $7122f5b41a04d9b5$export$53b275054013afb6; }, function (v) { return $7122f5b41a04d9b5$export$53b275054013afb6 = v; });
$parcel$export($7122f5b41a04d9b5$exports, "lastUpdated", function () { return $7122f5b41a04d9b5$export$c60d1a715a48771d; }, function (v) { return $7122f5b41a04d9b5$export$c60d1a715a48771d = v; });
$parcel$export($7122f5b41a04d9b5$exports, "lastUpdatedDate", function () { return $7122f5b41a04d9b5$export$9053d3ed35b7fcd9; }, function (v) { return $7122f5b41a04d9b5$export$9053d3ed35b7fcd9 = v; });
$parcel$export($7122f5b41a04d9b5$exports, "mainBody", function () { return $7122f5b41a04d9b5$export$f239b04fc1a0c7e1; }, function (v) { return $7122f5b41a04d9b5$export$f239b04fc1a0c7e1 = v; });
$parcel$export($7122f5b41a04d9b5$exports, "title", function () { return $7122f5b41a04d9b5$export$fb184b623420d9be; }, function (v) { return $7122f5b41a04d9b5$export$fb184b623420d9be = v; });
$parcel$export($7122f5b41a04d9b5$exports, "toolbar", function () { return $7122f5b41a04d9b5$export$f727f52c778e92d5; }, function (v) { return $7122f5b41a04d9b5$export$f727f52c778e92d5 = v; });
var $7122f5b41a04d9b5$export$d0a9b8580e71599c;
var $7122f5b41a04d9b5$export$eb877aaaf03a6de7;
var $7122f5b41a04d9b5$export$53b275054013afb6;
var $7122f5b41a04d9b5$export$c60d1a715a48771d;
var $7122f5b41a04d9b5$export$9053d3ed35b7fcd9;
var $7122f5b41a04d9b5$export$f239b04fc1a0c7e1;
var $7122f5b41a04d9b5$export$fb184b623420d9be;
var $7122f5b41a04d9b5$export$f727f52c778e92d5;
$7122f5b41a04d9b5$export$d0a9b8580e71599c = `_4geoxq_appBar`;
$7122f5b41a04d9b5$export$eb877aaaf03a6de7 = `_4geoxq_collectionTitle`;
$7122f5b41a04d9b5$export$53b275054013afb6 = `_4geoxq_detailBody`;
$7122f5b41a04d9b5$export$c60d1a715a48771d = `_4geoxq_lastUpdated`;
$7122f5b41a04d9b5$export$9053d3ed35b7fcd9 = `_4geoxq_lastUpdatedDate`;
$7122f5b41a04d9b5$export$f239b04fc1a0c7e1 = `_4geoxq_mainBody`;
$7122f5b41a04d9b5$export$fb184b623420d9be = `_4geoxq_title`;
$7122f5b41a04d9b5$export$f727f52c778e92d5 = `_4geoxq_toolbar`;













const $bc819c2594c6df0b$export$946d560c3f7a7be4 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039))(()=>({
        "& .MuiBadge-badge": {
            right: 12,
            top: 12,
            padding: "0 4px"
        }
    }));




var $7fPBF = parcelRequire("7fPBF");



var $ef02a626db2a8cce$exports = {};

$parcel$export($ef02a626db2a8cce$exports, "cardContainer", function () { return $ef02a626db2a8cce$export$6b2d426110a11d7a; }, function (v) { return $ef02a626db2a8cce$export$6b2d426110a11d7a = v; });
$parcel$export($ef02a626db2a8cce$exports, "collectionCard", function () { return $ef02a626db2a8cce$export$63ab7202a5c80ed; }, function (v) { return $ef02a626db2a8cce$export$63ab7202a5c80ed = v; });
$parcel$export($ef02a626db2a8cce$exports, "contentCard", function () { return $ef02a626db2a8cce$export$9261782d08389607; }, function (v) { return $ef02a626db2a8cce$export$9261782d08389607 = v; });
$parcel$export($ef02a626db2a8cce$exports, "loadingDiv", function () { return $ef02a626db2a8cce$export$dded2af20345efaa; }, function (v) { return $ef02a626db2a8cce$export$dded2af20345efaa = v; });
$parcel$export($ef02a626db2a8cce$exports, "searchBar", function () { return $ef02a626db2a8cce$export$f2ea4ab276c3e3fa; }, function (v) { return $ef02a626db2a8cce$export$f2ea4ab276c3e3fa = v; });
var $ef02a626db2a8cce$export$6b2d426110a11d7a;
var $ef02a626db2a8cce$export$63ab7202a5c80ed;
var $ef02a626db2a8cce$export$9261782d08389607;
var $ef02a626db2a8cce$export$dded2af20345efaa;
var $ef02a626db2a8cce$export$f2ea4ab276c3e3fa;
$ef02a626db2a8cce$export$6b2d426110a11d7a = `_7nkIOW_cardContainer`;
$ef02a626db2a8cce$export$63ab7202a5c80ed = `_7nkIOW_collectionCard`;
$ef02a626db2a8cce$export$9261782d08389607 = `_7nkIOW_contentCard`;
$ef02a626db2a8cce$export$dded2af20345efaa = `_7nkIOW_loadingDiv`;
$ef02a626db2a8cce$export$f2ea4ab276c3e3fa = `_7nkIOW_searchBar`;









const $b37a75f5fba7070c$export$89991d3c41b694bc = (setLoading, isEnabled)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getUserNotifications = (parameters)=>get("userNotifications", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).userNotifications(), getUserNotifications, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).userNotificationStorage, false, isEnabled, undefined);
};






var $7fPBF = parcelRequire("7fPBF");
var $5108b4a30b367fce$exports = {};

$parcel$export($5108b4a30b367fce$exports, "actionArea", function () { return $5108b4a30b367fce$export$746dc5cb6bd7e71f; }, function (v) { return $5108b4a30b367fce$export$746dc5cb6bd7e71f = v; });
$parcel$export($5108b4a30b367fce$exports, "container", function () { return $5108b4a30b367fce$export$34e0f9847d4c02dd; }, function (v) { return $5108b4a30b367fce$export$34e0f9847d4c02dd = v; });
$parcel$export($5108b4a30b367fce$exports, "description", function () { return $5108b4a30b367fce$export$6d59db4903f20f7d; }, function (v) { return $5108b4a30b367fce$export$6d59db4903f20f7d = v; });
$parcel$export($5108b4a30b367fce$exports, "item", function () { return $5108b4a30b367fce$export$7061c75fc5af8b7e; }, function (v) { return $5108b4a30b367fce$export$7061c75fc5af8b7e = v; });
$parcel$export($5108b4a30b367fce$exports, "name", function () { return $5108b4a30b367fce$export$a8ff84c12d48cfa6; }, function (v) { return $5108b4a30b367fce$export$a8ff84c12d48cfa6 = v; });
$parcel$export($5108b4a30b367fce$exports, "nonReadDescription", function () { return $5108b4a30b367fce$export$9e9410afe17bb941; }, function (v) { return $5108b4a30b367fce$export$9e9410afe17bb941 = v; });
$parcel$export($5108b4a30b367fce$exports, "readDescription", function () { return $5108b4a30b367fce$export$17be99b998d39247; }, function (v) { return $5108b4a30b367fce$export$17be99b998d39247 = v; });
$parcel$export($5108b4a30b367fce$exports, "readName", function () { return $5108b4a30b367fce$export$ccff49e992952c96; }, function (v) { return $5108b4a30b367fce$export$ccff49e992952c96 = v; });
$parcel$export($5108b4a30b367fce$exports, "severityMark", function () { return $5108b4a30b367fce$export$a070fdabc28e8418; }, function (v) { return $5108b4a30b367fce$export$a070fdabc28e8418 = v; });
$parcel$export($5108b4a30b367fce$exports, "visibility", function () { return $5108b4a30b367fce$export$91fa9ac3f4021ce4; }, function (v) { return $5108b4a30b367fce$export$91fa9ac3f4021ce4 = v; });
var $5108b4a30b367fce$export$746dc5cb6bd7e71f;
var $5108b4a30b367fce$export$34e0f9847d4c02dd;
var $5108b4a30b367fce$export$6d59db4903f20f7d;
var $5108b4a30b367fce$export$7061c75fc5af8b7e;
var $5108b4a30b367fce$export$a8ff84c12d48cfa6;
var $5108b4a30b367fce$export$9e9410afe17bb941;
var $5108b4a30b367fce$export$17be99b998d39247;
var $5108b4a30b367fce$export$ccff49e992952c96;
var $5108b4a30b367fce$export$a070fdabc28e8418;
var $5108b4a30b367fce$export$91fa9ac3f4021ce4;
$5108b4a30b367fce$export$746dc5cb6bd7e71f = `iCnshW_actionArea`;
$5108b4a30b367fce$export$34e0f9847d4c02dd = `iCnshW_container`;
$5108b4a30b367fce$export$6d59db4903f20f7d = `iCnshW_description`;
$5108b4a30b367fce$export$7061c75fc5af8b7e = `iCnshW_item`;
$5108b4a30b367fce$export$a8ff84c12d48cfa6 = `iCnshW_name`;
$5108b4a30b367fce$export$9e9410afe17bb941 = `iCnshW_nonReadDescription`;
$5108b4a30b367fce$export$17be99b998d39247 = `iCnshW_readDescription`;
$5108b4a30b367fce$export$ccff49e992952c96 = `iCnshW_readName`;
$5108b4a30b367fce$export$a070fdabc28e8418 = `iCnshW_severityMark`;
$5108b4a30b367fce$export$91fa9ac3f4021ce4 = `iCnshW_visibility`;







const $8302bb22764a5909$export$7e6985c083db3ddd = ()=>{
    const { patch: patch } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const markReadUserNotification = (parameters)=>patch("userNotifications", parameters);
    return {
        markReadUserNotification: markReadUserNotification
    };
};






const $3203e7af7d2118a7$export$e1722a52ab028b4 = ({ userNotification: userNotification, onClick: onClick, onUpdatedUserNotification: onUpdatedUserNotification })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const { markReadUserNotification: markReadUserNotification } = (0, $8302bb22764a5909$export$7e6985c083db3ddd)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const backgroundColor = ()=>{
        switch(userNotification.severity){
            case "info":
                return undefined;
            case "pricing":
                return theme.palette.colors?.pricingNotification;
            case "critical":
                return theme.palette.colors?.criticalNotification;
            case "message":
                return theme.palette.colors?.messageNotification;
        }
    };
    const toggleIsReadUserNotification = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await markReadUserNotification({
            uuid: userNotification.uuid,
            isRead: !userNotification.isRead
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) onUpdatedUserNotification(body);
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).item,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).container,
                elevation: userNotification.isRead ? 2 : 5,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "row",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).actionArea, (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).positionContainer),
                        onContextMenu: handleContextMenu,
                        onClick: ()=>{
                            if (!userNotification.isRead) toggleIsReadUserNotification().then();
                            onClick();
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).severityMark,
                                style: {
                                    backgroundColor: backgroundColor()
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "100%",
                                    alignItems: "center"
                                },
                                direction: "row",
                                spacing: 2,
                                children: [
                                    isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        type: userNotification.isRead ? (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Drafts : (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Mail,
                                        filled: !userNotification.isRead
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: "100%"
                                        },
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).name,
                                                        style: {
                                                            color: userNotification.isRead ? theme.palette.secondary.main : theme.palette.primary.main
                                                        },
                                                        children: userNotification.title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                        flexGrow: 1
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).visibility,
                                                        children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(userNotification.createdUnixTimestamp * 1000, "d MMMM yyyy HH:mm", {
                                                            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).description, userNotification.isRead ? (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).readDescription : (0, (/*@__PURE__*/$parcel$interopDefault($5108b4a30b367fce$exports))).nonReadDescription),
                                                style: {
                                                    color: userNotification.isRead ? theme.palette.secondary.main : theme.palette.primary.main
                                                },
                                                children: userNotification.message
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        toggleIsReadUserNotification().then();
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: userNotification.isRead ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).MarkAsUnread
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Drafts
                            })
                        }),
                        userNotification.isRead ? (0, $37bec70ed65ed924$export$21c51bc433c16634).mark_as_unread : (0, $37bec70ed65ed924$export$21c51bc433c16634).mark_as_read
                    ]
                })
            })
        ]
    });
};







const $e0ab1c8ab8461e73$export$edc2b1ff56760709 = ({ open: open, setOpen: setOpen })=>{
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [userProfile, setUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [userNotifications, resetUserNotifications, setUserNotifications] = (0, $b37a75f5fba7070c$export$89991d3c41b694bc)(setLoading, isMounted.current);
    const [selectedUserNotification, setSelectedUserNotification] = (0, $7fPBF.useState)();
    const [isUserNotificationAlertOpen, setIsUserNotificationAlertOpen] = (0, $7fPBF.useState)(false);
    const [filteredUserNotifications, setFilteredUserNotifications] = (0, $7fPBF.useState)();
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const onCancel = ()=>{
        setOpen(false);
        setSearchText("");
    };
    const refreshFilteredUserNotifications = ()=>{
        if (searchText == "") {
            setFilteredUserNotifications(userNotifications);
            return;
        }
        setFilteredUserNotifications(userNotifications?.filter((userNotification)=>{
            return userNotification.title.toLowerCase().includes(searchText.toLowerCase()) || userNotification.message.toLowerCase().includes(searchText.toLowerCase());
        }));
    };
    (0, $7fPBF.useEffect)(()=>{
        refreshFilteredUserNotifications();
    }, [
        searchText
    ]);
    (0, $7fPBF.useEffect)(()=>{
        resetUserNotifications();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        refreshFilteredUserNotifications();
        if (userNotifications.length > 0) updateUserProfileUnreadCount();
    }, [
        userNotifications
    ]);
    const updateUserProfileUnreadCount = ()=>{
        if (userProfile) {
            const newCount = userNotifications.filter((userNotification)=>!userNotification.isRead).length;
            if (newCount != userProfile.unreadNotifications) setUserProfile({
                ...userProfile,
                unreadNotifications: newCount
            });
        }
    };
    const searchBar = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef02a626db2a8cce$exports))).searchBar,
            onSearchRequested: setSearchText,
            onSearchDismissed: ()=>setSearchText(""),
            timed: false,
            minimumSearchLength: 0,
            autoFocus: !isMobile
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: open,
        onClose: onCancel,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    style: {
                                        marginRight: 8
                                    },
                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).user_notifications_title
                                }),
                                !isMobile && searchBar(),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                    loading: loading,
                                    onClick: ()=>{
                                        setOpen(false);
                                    },
                                    tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                    iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                })
                            ]
                        }),
                        isMobile && searchBar()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef02a626db2a8cce$exports))).contentCard,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            padding: isMobile ? 0 : 1
                        },
                        children: [
                            filteredUserNotifications && filteredUserNotifications.map((userNotification)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3203e7af7d2118a7$export$e1722a52ab028b4), {
                                    userNotification: userNotification,
                                    onClick: ()=>{
                                        setSelectedUserNotification(userNotification);
                                        setIsUserNotificationAlertOpen(true);
                                    },
                                    onUpdatedUserNotification: (newUserNotification)=>{
                                        const newUserNotifications = userNotifications.map((userNotification)=>newUserNotification.uuid == userNotification.uuid ? newUserNotification : userNotification);
                                        setUserNotifications(newUserNotifications);
                                    }
                                }, userNotification.uuid)),
                            loading && Array.from({
                                length: 10
                            }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ef02a626db2a8cce$exports))).cardContainer,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                        height: 60,
                                        variant: "rectangular",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef02a626db2a8cce$exports))).collectionCard
                                    })
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: loading,
                        items: filteredUserNotifications,
                        emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Inbox,
                        emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_user_notifications,
                        emptyDescription: "",
                        searchText: searchText,
                        canAdd: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: selectedUserNotification?.title,
                message: selectedUserNotification?.message ?? "",
                open: isUserNotificationAlertOpen,
                setOpen: setIsUserNotificationAlertOpen,
                link: selectedUserNotification?.link,
                imageUrl: selectedUserNotification?.imageUrl,
                linkButtonText: selectedUserNotification?.severity == "message" ? (0, $37bec70ed65ed924$export$21c51bc433c16634).view_message : undefined,
                maxWidth: "xs"
            })
        ]
    });
};





var $7fPBF = parcelRequire("7fPBF");

var $7c116cf7d2aae374$exports = {};

$parcel$export($7c116cf7d2aae374$exports, "avatar", function () { return $7c116cf7d2aae374$export$345c5736c8054f22; }, function (v) { return $7c116cf7d2aae374$export$345c5736c8054f22 = v; });
$parcel$export($7c116cf7d2aae374$exports, "avatarContainer", function () { return $7c116cf7d2aae374$export$4ea799498ef4a755; }, function (v) { return $7c116cf7d2aae374$export$4ea799498ef4a755 = v; });
$parcel$export($7c116cf7d2aae374$exports, "detailMobile", function () { return $7c116cf7d2aae374$export$304698f905009e5d; }, function (v) { return $7c116cf7d2aae374$export$304698f905009e5d = v; });
$parcel$export($7c116cf7d2aae374$exports, "dropzone", function () { return $7c116cf7d2aae374$export$585d0a7a39ed94ea; }, function (v) { return $7c116cf7d2aae374$export$585d0a7a39ed94ea = v; });
$parcel$export($7c116cf7d2aae374$exports, "graphsDiv", function () { return $7c116cf7d2aae374$export$7f9e75aa60d230f3; }, function (v) { return $7c116cf7d2aae374$export$7f9e75aa60d230f3 = v; });
$parcel$export($7c116cf7d2aae374$exports, "graphsDivMobile", function () { return $7c116cf7d2aae374$export$2d8a3278abf5949e; }, function (v) { return $7c116cf7d2aae374$export$2d8a3278abf5949e = v; });
$parcel$export($7c116cf7d2aae374$exports, "hoverButton", function () { return $7c116cf7d2aae374$export$b0260c0afbf48c57; }, function (v) { return $7c116cf7d2aae374$export$b0260c0afbf48c57 = v; });
$parcel$export($7c116cf7d2aae374$exports, "hoverButtonsStack", function () { return $7c116cf7d2aae374$export$a8eacba2c33c9f28; }, function (v) { return $7c116cf7d2aae374$export$a8eacba2c33c9f28 = v; });
$parcel$export($7c116cf7d2aae374$exports, "itemDiv", function () { return $7c116cf7d2aae374$export$64c46d98173ac23d; }, function (v) { return $7c116cf7d2aae374$export$64c46d98173ac23d = v; });
$parcel$export($7c116cf7d2aae374$exports, "limitsCard", function () { return $7c116cf7d2aae374$export$2e0a72cbbd33293; }, function (v) { return $7c116cf7d2aae374$export$2e0a72cbbd33293 = v; });
$parcel$export($7c116cf7d2aae374$exports, "list", function () { return $7c116cf7d2aae374$export$8837f4fc672e936d; }, function (v) { return $7c116cf7d2aae374$export$8837f4fc672e936d = v; });
$parcel$export($7c116cf7d2aae374$exports, "loadingDiv", function () { return $7c116cf7d2aae374$export$dded2af20345efaa; }, function (v) { return $7c116cf7d2aae374$export$dded2af20345efaa = v; });
$parcel$export($7c116cf7d2aae374$exports, "mainContainer", function () { return $7c116cf7d2aae374$export$eccb60d5692f3f7d; }, function (v) { return $7c116cf7d2aae374$export$eccb60d5692f3f7d = v; });
$parcel$export($7c116cf7d2aae374$exports, "mainDiv", function () { return $7c116cf7d2aae374$export$16666caf1c4e1af1; }, function (v) { return $7c116cf7d2aae374$export$16666caf1c4e1af1 = v; });
$parcel$export($7c116cf7d2aae374$exports, "publicCollectionsCard", function () { return $7c116cf7d2aae374$export$ef035b8e61007418; }, function (v) { return $7c116cf7d2aae374$export$ef035b8e61007418 = v; });
$parcel$export($7c116cf7d2aae374$exports, "publicCollectionsTitle", function () { return $7c116cf7d2aae374$export$bcd0ee4ee52be6f9; }, function (v) { return $7c116cf7d2aae374$export$bcd0ee4ee52be6f9 = v; });
$parcel$export($7c116cf7d2aae374$exports, "resizeHandle", function () { return $7c116cf7d2aae374$export$8e36b812ea421d73; }, function (v) { return $7c116cf7d2aae374$export$8e36b812ea421d73 = v; });
$parcel$export($7c116cf7d2aae374$exports, "section", function () { return $7c116cf7d2aae374$export$fe2e36411d703b3d; }, function (v) { return $7c116cf7d2aae374$export$fe2e36411d703b3d = v; });
$parcel$export($7c116cf7d2aae374$exports, "sectionMobile", function () { return $7c116cf7d2aae374$export$e67aaffd96faad6d; }, function (v) { return $7c116cf7d2aae374$export$e67aaffd96faad6d = v; });
$parcel$export($7c116cf7d2aae374$exports, "switchListItem", function () { return $7c116cf7d2aae374$export$187ffba5827d73c1; }, function (v) { return $7c116cf7d2aae374$export$187ffba5827d73c1 = v; });
var $7c116cf7d2aae374$export$345c5736c8054f22;
var $7c116cf7d2aae374$export$4ea799498ef4a755;
var $7c116cf7d2aae374$export$304698f905009e5d;
var $7c116cf7d2aae374$export$585d0a7a39ed94ea;
var $7c116cf7d2aae374$export$7f9e75aa60d230f3;
var $7c116cf7d2aae374$export$2d8a3278abf5949e;
var $7c116cf7d2aae374$export$b0260c0afbf48c57;
var $7c116cf7d2aae374$export$a8eacba2c33c9f28;
var $7c116cf7d2aae374$export$64c46d98173ac23d;
var $7c116cf7d2aae374$export$2e0a72cbbd33293;
var $7c116cf7d2aae374$export$8837f4fc672e936d;
var $7c116cf7d2aae374$export$dded2af20345efaa;
var $7c116cf7d2aae374$export$eccb60d5692f3f7d;
var $7c116cf7d2aae374$export$16666caf1c4e1af1;
var $7c116cf7d2aae374$export$ef035b8e61007418;
var $7c116cf7d2aae374$export$bcd0ee4ee52be6f9;
var $7c116cf7d2aae374$export$8e36b812ea421d73;
var $7c116cf7d2aae374$export$fe2e36411d703b3d;
var $7c116cf7d2aae374$export$e67aaffd96faad6d;
var $7c116cf7d2aae374$export$187ffba5827d73c1;
$7c116cf7d2aae374$export$345c5736c8054f22 = `sh1vqG_avatar`;
$7c116cf7d2aae374$export$4ea799498ef4a755 = `sh1vqG_avatarContainer`;
$7c116cf7d2aae374$export$304698f905009e5d = `sh1vqG_detailMobile`;
$7c116cf7d2aae374$export$585d0a7a39ed94ea = `sh1vqG_dropzone`;
$7c116cf7d2aae374$export$7f9e75aa60d230f3 = `sh1vqG_graphsDiv`;
$7c116cf7d2aae374$export$2d8a3278abf5949e = `sh1vqG_graphsDivMobile`;
$7c116cf7d2aae374$export$b0260c0afbf48c57 = `sh1vqG_hoverButton`;
$7c116cf7d2aae374$export$a8eacba2c33c9f28 = `sh1vqG_hoverButtonsStack`;
$7c116cf7d2aae374$export$64c46d98173ac23d = `sh1vqG_itemDiv`;
$7c116cf7d2aae374$export$2e0a72cbbd33293 = `sh1vqG_limitsCard`;
$7c116cf7d2aae374$export$8837f4fc672e936d = `sh1vqG_list`;
$7c116cf7d2aae374$export$dded2af20345efaa = `sh1vqG_loadingDiv`;
$7c116cf7d2aae374$export$eccb60d5692f3f7d = `sh1vqG_mainContainer`;
$7c116cf7d2aae374$export$16666caf1c4e1af1 = `sh1vqG_mainDiv`;
$7c116cf7d2aae374$export$ef035b8e61007418 = `sh1vqG_publicCollectionsCard`;
$7c116cf7d2aae374$export$bcd0ee4ee52be6f9 = `sh1vqG_publicCollectionsTitle`;
$7c116cf7d2aae374$export$8e36b812ea421d73 = `sh1vqG_resizeHandle`;
$7c116cf7d2aae374$export$fe2e36411d703b3d = `sh1vqG_section`;
$7c116cf7d2aae374$export$e67aaffd96faad6d = `sh1vqG_sectionMobile`;
$7c116cf7d2aae374$export$187ffba5827d73c1 = `sh1vqG_switchListItem`;







var $7fPBF = parcelRequire("7fPBF");
var $49452f7b0f954e20$exports = {};

$parcel$export($49452f7b0f954e20$exports, "cancelButton", function () { return $49452f7b0f954e20$export$4ededb8e5b56a6fb; }, function (v) { return $49452f7b0f954e20$export$4ededb8e5b56a6fb = v; });
$parcel$export($49452f7b0f954e20$exports, "description", function () { return $49452f7b0f954e20$export$6d59db4903f20f7d; }, function (v) { return $49452f7b0f954e20$export$6d59db4903f20f7d = v; });
$parcel$export($49452f7b0f954e20$exports, "loadingDiv", function () { return $49452f7b0f954e20$export$dded2af20345efaa; }, function (v) { return $49452f7b0f954e20$export$dded2af20345efaa = v; });
$parcel$export($49452f7b0f954e20$exports, "saveButton", function () { return $49452f7b0f954e20$export$3a57bbc0fbe4b744; }, function (v) { return $49452f7b0f954e20$export$3a57bbc0fbe4b744 = v; });
$parcel$export($49452f7b0f954e20$exports, "subtitle", function () { return $49452f7b0f954e20$export$c96745152eb2740f; }, function (v) { return $49452f7b0f954e20$export$c96745152eb2740f = v; });
$parcel$export($49452f7b0f954e20$exports, "textField", function () { return $49452f7b0f954e20$export$c54b92c0bb02ba64; }, function (v) { return $49452f7b0f954e20$export$c54b92c0bb02ba64 = v; });
var $49452f7b0f954e20$export$4ededb8e5b56a6fb;
var $49452f7b0f954e20$export$6d59db4903f20f7d;
var $49452f7b0f954e20$export$dded2af20345efaa;
var $49452f7b0f954e20$export$3a57bbc0fbe4b744;
var $49452f7b0f954e20$export$c96745152eb2740f;
var $49452f7b0f954e20$export$c54b92c0bb02ba64;
$49452f7b0f954e20$export$4ededb8e5b56a6fb = `Xeux7a_cancelButton`;
$49452f7b0f954e20$export$6d59db4903f20f7d = `Xeux7a_description`;
$49452f7b0f954e20$export$dded2af20345efaa = `Xeux7a_loadingDiv`;
$49452f7b0f954e20$export$3a57bbc0fbe4b744 = `Xeux7a_saveButton`;
$49452f7b0f954e20$export$c96745152eb2740f = `Xeux7a_subtitle`;
$49452f7b0f954e20$export$c54b92c0bb02ba64 = `Xeux7a_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");









const $caa85d016f204aee$export$9087bf3ba652982c = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const updateEmail = (parameters)=>put("user/email", parameters);
    return {
        updateEmail: updateEmail
    };
};



const $d9d07ca0934e965f$export$9030cdf940a7f19 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deletePendingEmail = ()=>deleteRequest("user/email");
    return {
        deletePendingEmail: deletePendingEmail
    };
};












const $32841050af960b0a$export$3bb0ea6c690cb642 = ({ open: open, setOpen: setOpen, onClose: onClose })=>{
    const [currentUser, setCurrentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { updateEmail: updateEmail } = (0, $caa85d016f204aee$export$9087bf3ba652982c)();
    const { deletePendingEmail: deletePendingEmail } = (0, $d9d07ca0934e965f$export$9030cdf940a7f19)();
    const checkEmail = (0, $ae1d7eb186718c87$export$af575fbbe23696a0)();
    const [isEmailUsed, setIsEmailUsed] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isVerifyCodeDialogOpen, setIsVerifyCodeDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    const handleClose = ()=>{
        if (onClose) onClose();
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        email: $57e52f3b537dfd4b$export$22b082955e083ec3().email((0, $37bec70ed65ed924$export$21c51bc433c16634).email_invalid).required((0, $37bec70ed65ed924$export$21c51bc433c16634).email_invalid).test("isUsed", (0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_duplicated, ()=>!isEmailUsed)
    });
    const initialValues = {
        email: ""
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: initialValues,
        validateOnBlur: false,
        onSubmit: async ({ email: email })=>{
            setIsLoading(true);
            const { body: body, status: status } = await updateEmail({
                email: email
            });
            setIsLoading(false);
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setCurrentUser(body);
                formik.resetForm();
                setAlertMessage((0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).email_pending_message, email));
                setIsAlertOpen(true);
            } else {
                if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).BAD_REQUEST) {
                    setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_invalid);
                    setIsAlertOpen(true);
                } else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
                else if (status == 520) {
                    setAlertMessage((0, $37bec70ed65ed924$export$21c51bc433c16634).email_error_duplicated);
                    setIsAlertOpen(true);
                } else {
                    setAlertMessage(body.message);
                    setIsAlertOpen(true);
                }
            }
        },
        validationSchema: validationSchema
    });
    const expiryTimestamp = ()=>{
        const date = new Date();
        date.setSeconds(date.getSeconds() + 1);
        return date;
    };
    const { pause: stopEmailTimer, restart: restartEmailTimer } = (0, $0fb6069f42f36b16$exports.useTimer)({
        expiryTimestamp: expiryTimestamp(),
        onExpire: ()=>{
            checkEmail(formik.values.email).then((isEmailUsed)=>{
                setIsEmailUsed(isEmailUsed);
            });
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        stopEmailTimer();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        setIsEmailUsed(false);
        if (formik.values.email.length < 5 || formik.errors.email != undefined) {
            stopEmailTimer();
            return;
        }
        restartEmailTimer(expiryTimestamp());
    }, [
        formik.values.email
    ]);
    const onDelete = async ()=>{
        setIsLoading(true);
        const { body: body, status: status } = await deletePendingEmail();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setCurrentUser(body);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        formik.resetForm();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).update_email_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.userProfile("email")}`,
                                target: "_blank",
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: handleClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_current_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($49452f7b0f954e20$exports))).textField,
                                style: {
                                    paddingBottom: 16
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    name: "currentEmail",
                                    readOnly: true,
                                    size: "small",
                                    value: currentUser?.email,
                                    helperText: currentUser?.isEmailConfirmed ? (0, $37bec70ed65ed924$export$21c51bc433c16634).email_confirmed : (0, $37bec70ed65ed924$export$21c51bc433c16634).email_pending
                                })
                            }),
                            currentUser?.emailPending && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_pending_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($49452f7b0f954e20$exports))).textField,
                                        style: {
                                            paddingBottom: 32
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                                name: "pendingEmail",
                                                readOnly: true,
                                                size: "small",
                                                value: currentUser?.emailPending
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                direction: "row",
                                                justifyContent: "end",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_discard_new,
                                                        disabled: isLoading,
                                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                                        onClick: onDelete
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_confirm_new,
                                                        disabled: isLoading,
                                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Check,
                                                        onClick: ()=>setIsVerifyCodeDialogOpen(true)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_new_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($49452f7b0f954e20$exports))).textField,
                                style: {
                                    paddingBottom: 16,
                                    display: "flex",
                                    flexDirection: "row"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                        id: "email",
                                        name: "email",
                                        type: "email",
                                        size: "small",
                                        placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).new_email_placeholder,
                                        value: formik.values.email,
                                        onChange: formik.handleChange
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($49452f7b0f954e20$exports))).saveButton,
                                        disabled: isLoading || !formik.isValid,
                                        onClick: ()=>{
                                            formik.handleSubmit();
                                        },
                                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).save,
                                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Save
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08c92dc36ffbc237$export$beb39e5a218dbbf2), {
                email: currentUser?.email ?? "",
                callback: ()=>{
                    (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
                    handleClose();
                },
                open: isVerifyCodeDialogOpen,
                setOpen: setIsVerifyCodeDialogOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    await formik.submitForm();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");
var $7fd0f5393e740538$exports = {};

$parcel$export($7fd0f5393e740538$exports, "cancelButton", function () { return $7fd0f5393e740538$export$4ededb8e5b56a6fb; }, function (v) { return $7fd0f5393e740538$export$4ededb8e5b56a6fb = v; });
$parcel$export($7fd0f5393e740538$exports, "loadingDiv", function () { return $7fd0f5393e740538$export$dded2af20345efaa; }, function (v) { return $7fd0f5393e740538$export$dded2af20345efaa = v; });
$parcel$export($7fd0f5393e740538$exports, "textField", function () { return $7fd0f5393e740538$export$c54b92c0bb02ba64; }, function (v) { return $7fd0f5393e740538$export$c54b92c0bb02ba64 = v; });
var $7fd0f5393e740538$export$4ededb8e5b56a6fb;
var $7fd0f5393e740538$export$dded2af20345efaa;
var $7fd0f5393e740538$export$c54b92c0bb02ba64;
$7fd0f5393e740538$export$4ededb8e5b56a6fb = `_1KvYvW_cancelButton`;
$7fd0f5393e740538$export$dded2af20345efaa = `_1KvYvW_loadingDiv`;
$7fd0f5393e740538$export$c54b92c0bb02ba64 = `_1KvYvW_textField`;




var $1ZNeQ = parcelRequire("1ZNeQ");














const $01bd913149ce3bb1$export$189867d15cbc5273 = ({ open: open, setOpen: setOpen })=>{
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { updatePassword: updatePassword } = (0, $eb25f080350ae646$export$ca21f09267ba8ef)();
    const checkPassword = (0, $f1a2075848500a5a$export$7df20d9398f482b8)();
    const [isPasswordWeak, setIsPasswordWeak] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isSuccessAlertOpen, setIsSuccessAlertOpen] = (0, $7fPBF.useState)(false);
    const handleClose = ()=>{
        if (isLoading) return;
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        oldPassword: currentUser?.isPasswordSet ? $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_update_error_current) : $57e52f3b537dfd4b$export$22b082955e083ec3().notRequired(),
        newPassword: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_update_error_new).test("isPasswordWeak", (0, $37bec70ed65ed924$export$21c51bc433c16634).password_weak, ()=>!isPasswordWeak),
        repeatPassword: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).password_update_error_repeat).oneOf([
            $57e52f3b537dfd4b$export$eff4d24c3ff7876e("newPassword"),
            ""
        ], (0, $37bec70ed65ed924$export$21c51bc433c16634).password_mismatch)
    });
    const initialValues = {
        oldPassword: "",
        newPassword: "",
        repeatPassword: ""
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: initialValues,
        validateOnBlur: false,
        onSubmit: async ({ oldPassword: oldPassword, newPassword: newPassword })=>{
            setIsLoading(true);
            const { status: status, body: body } = await updatePassword({
                oldPassword: oldPassword,
                password: newPassword
            });
            setIsLoading(false);
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
                setIsSuccessAlertOpen(true);
                if (currentUser) currentUser.isPasswordSet = true;
            } else {
                setAlertMessage(body.message);
                setIsAlertOpen(true);
            }
        },
        validationSchema: validationSchema
    });
    const expiryTimestamp = ()=>{
        const date = new Date();
        date.setSeconds(date.getSeconds() + 1);
        return date;
    };
    const { pause: stopPasswordTimer, restart: restartPasswordTimer } = (0, $0fb6069f42f36b16$exports.useTimer)({
        expiryTimestamp: expiryTimestamp(),
        onExpire: ()=>{
            checkPassword(formik.values.newPassword).then((result)=>{
                setIsPasswordWeak([
                    0,
                    1
                ].includes(result?.id ?? -1));
            });
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        stopPasswordTimer();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        setIsPasswordWeak(false);
        if (formik.values.newPassword == "" || formik.errors.newPassword != undefined) {
            stopPasswordTimer();
            return;
        }
        restartPasswordTimer(expiryTimestamp());
    }, [
        formik.values.newPassword
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        formik.resetForm();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).update_password_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: handleClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            currentUser?.isPasswordSet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).old_password_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "text",
                                        style: {
                                            display: "none"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "password",
                                        style: {
                                            display: "none"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7fd0f5393e740538$exports))).textField,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                            id: "oldPassword",
                                            name: "oldPassword",
                                            type: "password",
                                            size: "small",
                                            placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).old_password_placeholder,
                                            value: formik.values.oldPassword,
                                            onChange: formik.handleChange
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).new_password_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7fd0f5393e740538$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "newPassword",
                                    name: "newPassword",
                                    type: "password",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).new_password_placeholder,
                                    value: formik.values.newPassword,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7fd0f5393e740538$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "repeatPassword",
                                    name: "repeatPassword",
                                    type: "password",
                                    size: "small",
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).repeat_password_placeholder,
                                    value: formik.values.repeatPassword,
                                    onChange: formik.handleChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            disabled: isLoading,
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).password_update_success,
                open: isSuccessAlertOpen,
                setOpen: setIsSuccessAlertOpen,
                onConfirm: ()=>{
                    handleClose();
                }
            })
        ]
    });
};
















var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");
var $46ab31e5c5a546d1$exports = {};

$parcel$export($46ab31e5c5a546d1$exports, "actionArea", function () { return $46ab31e5c5a546d1$export$746dc5cb6bd7e71f; }, function (v) { return $46ab31e5c5a546d1$export$746dc5cb6bd7e71f = v; });
$parcel$export($46ab31e5c5a546d1$exports, "container", function () { return $46ab31e5c5a546d1$export$34e0f9847d4c02dd; }, function (v) { return $46ab31e5c5a546d1$export$34e0f9847d4c02dd = v; });
$parcel$export($46ab31e5c5a546d1$exports, "description", function () { return $46ab31e5c5a546d1$export$6d59db4903f20f7d; }, function (v) { return $46ab31e5c5a546d1$export$6d59db4903f20f7d = v; });
$parcel$export($46ab31e5c5a546d1$exports, "discountBox", function () { return $46ab31e5c5a546d1$export$846ba29c579fca64; }, function (v) { return $46ab31e5c5a546d1$export$846ba29c579fca64 = v; });
$parcel$export($46ab31e5c5a546d1$exports, "item", function () { return $46ab31e5c5a546d1$export$7061c75fc5af8b7e; }, function (v) { return $46ab31e5c5a546d1$export$7061c75fc5af8b7e = v; });
$parcel$export($46ab31e5c5a546d1$exports, "name", function () { return $46ab31e5c5a546d1$export$a8ff84c12d48cfa6; }, function (v) { return $46ab31e5c5a546d1$export$a8ff84c12d48cfa6 = v; });
$parcel$export($46ab31e5c5a546d1$exports, "newPrice", function () { return $46ab31e5c5a546d1$export$bf2b2c68f2d3892d; }, function (v) { return $46ab31e5c5a546d1$export$bf2b2c68f2d3892d = v; });
$parcel$export($46ab31e5c5a546d1$exports, "oldPrice", function () { return $46ab31e5c5a546d1$export$9853811e0e64ec55; }, function (v) { return $46ab31e5c5a546d1$export$9853811e0e64ec55 = v; });
$parcel$export($46ab31e5c5a546d1$exports, "positionContainer", function () { return $46ab31e5c5a546d1$export$4b16a1eee4ce71f1; }, function (v) { return $46ab31e5c5a546d1$export$4b16a1eee4ce71f1 = v; });
$parcel$export($46ab31e5c5a546d1$exports, "price", function () { return $46ab31e5c5a546d1$export$321c0b1a406de31f; }, function (v) { return $46ab31e5c5a546d1$export$321c0b1a406de31f = v; });
var $46ab31e5c5a546d1$export$746dc5cb6bd7e71f;
var $46ab31e5c5a546d1$export$34e0f9847d4c02dd;
var $46ab31e5c5a546d1$export$6d59db4903f20f7d;
var $46ab31e5c5a546d1$export$846ba29c579fca64;
var $46ab31e5c5a546d1$export$7061c75fc5af8b7e;
var $46ab31e5c5a546d1$export$a8ff84c12d48cfa6;
var $46ab31e5c5a546d1$export$bf2b2c68f2d3892d;
var $46ab31e5c5a546d1$export$9853811e0e64ec55;
var $46ab31e5c5a546d1$export$4b16a1eee4ce71f1;
var $46ab31e5c5a546d1$export$321c0b1a406de31f;
$46ab31e5c5a546d1$export$746dc5cb6bd7e71f = `D8t0TW_actionArea`;
$46ab31e5c5a546d1$export$34e0f9847d4c02dd = `D8t0TW_container`;
$46ab31e5c5a546d1$export$6d59db4903f20f7d = `D8t0TW_description`;
$46ab31e5c5a546d1$export$846ba29c579fca64 = `D8t0TW_discountBox`;
$46ab31e5c5a546d1$export$7061c75fc5af8b7e = `D8t0TW_item`;
$46ab31e5c5a546d1$export$a8ff84c12d48cfa6 = `D8t0TW_name`;
$46ab31e5c5a546d1$export$bf2b2c68f2d3892d = `D8t0TW_newPrice`;
$46ab31e5c5a546d1$export$9853811e0e64ec55 = `D8t0TW_oldPrice`;
$46ab31e5c5a546d1$export$4b16a1eee4ce71f1 = `D8t0TW_positionContainer`;
$46ab31e5c5a546d1$export$321c0b1a406de31f = `D8t0TW_price`;








const $705969bf7658e74e$export$ea72e39bf9f3f606 = ({ subscription: subscription, onSelection: onSelection })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).item,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).container,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb3d4480a6f47f89$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).actionArea, (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).positionContainer),
                onClick: onSelection,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    sx: {
                        width: "100%"
                    },
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).name,
                                    children: subscription.name
                                }),
                                subscription.discountARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed350f6794f06f61$export$3229296aace3d746), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).discountBox,
                                    percentage: subscription.discountARS
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                    flexGrow: 1
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).price,
                                    children: subscription.priceARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            subscription.discountARS > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).oldPrice,
                                                style: {
                                                    color: theme.palette.secondary.main
                                                },
                                                children: currencyFormatter.format((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? subscription.priceARS : subscription.priceUSD, currentUserProfile, false, 2, (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? "ARS" : "USD", (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale !== "es-AR")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9e4fb2f535b4c3$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).newPrice,
                                                variant: "outlined",
                                                label: currencyFormatter.format((0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? subscription.finalPriceARS : subscription.finalPriceUSD, currentUserProfile, false, 2, (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale == "es-AR" ? "ARS" : "USD", (0, $37bec70ed65ed924$export$21c51bc433c16634).currencyLocale !== "es-AR")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46ab31e5c5a546d1$exports))).description,
                            children: subscription.description
                        })
                    ]
                })
            })
        })
    });
};



const $6a56ccf9a5e2c243$export$5360d0d0321cd572 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getSubscriptions = ()=>get("subscriptions");
    return {
        getSubscriptions: getSubscriptions
    };
};










var $7fPBF = parcelRequire("7fPBF");




var $18bf21f697526064$exports = {};

$parcel$export($18bf21f697526064$exports, "description", function () { return $18bf21f697526064$export$6d59db4903f20f7d; }, function (v) { return $18bf21f697526064$export$6d59db4903f20f7d = v; });
$parcel$export($18bf21f697526064$exports, "price", function () { return $18bf21f697526064$export$321c0b1a406de31f; }, function (v) { return $18bf21f697526064$export$321c0b1a406de31f = v; });
$parcel$export($18bf21f697526064$exports, "textStack", function () { return $18bf21f697526064$export$f771374e88773462; }, function (v) { return $18bf21f697526064$export$f771374e88773462 = v; });
var $18bf21f697526064$export$6d59db4903f20f7d;
var $18bf21f697526064$export$321c0b1a406de31f;
var $18bf21f697526064$export$f771374e88773462;
$18bf21f697526064$export$6d59db4903f20f7d = `yRyxYW_description`;
$18bf21f697526064$export$321c0b1a406de31f = `yRyxYW_price`;
$18bf21f697526064$export$f771374e88773462 = `yRyxYW_textStack`;








const $50450f5c634debf0$export$8c1ee1956d7f855f = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async (code)=>{
        return await post("patreon/token", {
            code: code
        });
    };
};



const $3977ecf71c999531$export$50915879789a6743 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    return async ()=>{
        return await get("patreon");
    };
};







const $9fe0fc8db52b82ce$export$78610d8515ef16f8 = ({ subscription: subscription, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const getPatreonUserId = (0, $3977ecf71c999531$export$50915879789a6743)();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const { openInNewTab: openInNewTab, openInSameTab: openInSameTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const [isPayWithMercadoPagoAlertOpen, setIsPayWithMercadoPagoAlertOpen] = (0, $7fPBF.useState)(false);
    const [isSuccessAlertOpen, setIsSuccessAlertOpen] = (0, $7fPBF.useState)(false);
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: subscription.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        onClick: ()=>{
                            setIsOpen(false);
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($18bf21f697526064$exports))).textStack,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($18bf21f697526064$exports))).description,
                            children: subscription.description
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62a5eb8b234211c3$export$ccd7458029fb351d), {
                            isSubscription: true,
                            price: subscription.finalPriceARS,
                            currency: "ARS",
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/MercadoPagoLogo.jpg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_mercadopago,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_info,
                            optionText: (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option_mercado_pago,
                            onClick: ()=>setIsPayWithMercadoPagoAlertOpen(true)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62a5eb8b234211c3$export$ccd7458029fb351d), {
                            isSubscription: true,
                            price: subscription.finalPriceUSD,
                            currency: "USD",
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/PatreonLogo.png",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_patreon,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_info_patreon,
                            optionText: (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option_patreon,
                            onClick: async ()=>{
                                const { status: status } = await getPatreonUserId();
                                if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) openInSameTab("https://patreon.com/Piper107?utm_medium=piper&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink");
                                else openInSameTab(`https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${"MMi7nvnCbxJtn9dIxGiLHcfp-DsDUXlKSDPnD8LrnkQg6hiAibLdX8Q9PRaZhU3J"}&redirect_uri=${"https://www.piper.ldelosheros.com"}/paymentPatreon&state=${currentUser.uuid}`);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62a5eb8b234211c3$export$ccd7458029fb351d), {
                            isSubscription: true,
                            price: subscription.finalPriceUSD,
                            currency: "USD",
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/AppleLogo.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_apple,
                            description: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_info_apple,
                            optionText: (0, $37bec70ed65ed924$export$21c51bc433c16634).pay_option_apple,
                            onClick: ()=>openInNewTab(`https://apple.co/3P2tpt7`)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_pay_with_mercadopago_alert,
                open: isPayWithMercadoPagoAlertOpen,
                setOpen: setIsPayWithMercadoPagoAlertOpen,
                isConfirm: true,
                onConfirm: ()=>openInSameTab(`https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=${subscription.mercadoPagoPlanId}`)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name,
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_success,
                open: isSuccessAlertOpen,
                setOpen: setIsSuccessAlertOpen,
                onConfirm: ()=>{
                    closeSession();
                    navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
                }
            })
        ]
    });
};







const $49546dacaba52fc3$export$aa90fdcc84b843d2 = ({ isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const { getSubscriptions: getSubscriptions } = (0, $6a56ccf9a5e2c243$export$5360d0d0321cd572)();
    const [subscriptions, setSubscriptions] = (0, $7fPBF.useState)([]);
    const [selectedSubscription, setSelectedSubscription] = (0, $7fPBF.useState)();
    const [isSubscriptionDialogOpen, setIsSubscriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen || !isMounted.current) return;
        fetchSubscriptions().then();
    }, [
        isOpen
    ]);
    const fetchSubscriptions = async ()=>{
        setSubscriptions([]);
        setLoading(true);
        const { status: status, body: body } = await getSubscriptions();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setSubscriptions(body);
        else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).update_role_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.home()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: loading,
                        onClick: ()=>{
                            setIsOpen(false);
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                style: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), {
                    children: subscriptions.map((subscription)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $705969bf7658e74e$export$ea72e39bf9f3f606), {
                            subscription: subscription,
                            onSelection: async ()=>{
                                // Ignore click on free plan
                                if (subscription.id == 0) return;
                                setSelectedSubscription(subscription);
                                setIsSubscriptionDialogOpen(true);
                            }
                        }, String(subscription.id)))
                })
            }),
            selectedSubscription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fe0fc8db52b82ce$export$78610d8515ef16f8), {
                subscription: selectedSubscription,
                isOpen: isSubscriptionDialogOpen,
                setIsOpen: setIsSubscriptionDialogOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    await fetchSubscriptions();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};




var $7fPBF = parcelRequire("7fPBF");






const $ca7ad09c8eaa534c$export$d54623894818938b = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getLatestPayment = async ()=>{
        return get("payments");
    };
    return {
        getLatestPayment: getLatestPayment
    };
};


var $ed66cb00f873dff6$exports = {};

$parcel$export($ed66cb00f873dff6$exports, "content", function () { return $ed66cb00f873dff6$export$a7db06668cad9adb; }, function (v) { return $ed66cb00f873dff6$export$a7db06668cad9adb = v; });
$parcel$export($ed66cb00f873dff6$exports, "date", function () { return $ed66cb00f873dff6$export$324d90190a8b822a; }, function (v) { return $ed66cb00f873dff6$export$324d90190a8b822a = v; });
$parcel$export($ed66cb00f873dff6$exports, "manageButton", function () { return $ed66cb00f873dff6$export$d992296b9a725e45; }, function (v) { return $ed66cb00f873dff6$export$d992296b9a725e45 = v; });
$parcel$export($ed66cb00f873dff6$exports, "paymentStack", function () { return $ed66cb00f873dff6$export$ab5e49b4c4c893a7; }, function (v) { return $ed66cb00f873dff6$export$ab5e49b4c4c893a7 = v; });
$parcel$export($ed66cb00f873dff6$exports, "paymentStatus", function () { return $ed66cb00f873dff6$export$a18da5e670f0b062; }, function (v) { return $ed66cb00f873dff6$export$a18da5e670f0b062 = v; });
var $ed66cb00f873dff6$export$a7db06668cad9adb;
var $ed66cb00f873dff6$export$324d90190a8b822a;
var $ed66cb00f873dff6$export$d992296b9a725e45;
var $ed66cb00f873dff6$export$ab5e49b4c4c893a7;
var $ed66cb00f873dff6$export$a18da5e670f0b062;
$ed66cb00f873dff6$export$a7db06668cad9adb = `Jf6m0W_content`;
$ed66cb00f873dff6$export$324d90190a8b822a = `Jf6m0W_date`;
$ed66cb00f873dff6$export$d992296b9a725e45 = `Jf6m0W_manageButton`;
$ed66cb00f873dff6$export$ab5e49b4c4c893a7 = `Jf6m0W_paymentStack`;
$ed66cb00f873dff6$export$a18da5e670f0b062 = `Jf6m0W_paymentStatus`;



var $fdcd6fbda13b8c9b$exports = {};

$parcel$export($fdcd6fbda13b8c9b$exports, "card", function () { return $fdcd6fbda13b8c9b$export$aa3e815946b80764; }, function (v) { return $fdcd6fbda13b8c9b$export$aa3e815946b80764 = v; });
$parcel$export($fdcd6fbda13b8c9b$exports, "description", function () { return $fdcd6fbda13b8c9b$export$6d59db4903f20f7d; }, function (v) { return $fdcd6fbda13b8c9b$export$6d59db4903f20f7d = v; });
var $fdcd6fbda13b8c9b$export$aa3e815946b80764;
var $fdcd6fbda13b8c9b$export$6d59db4903f20f7d;
$fdcd6fbda13b8c9b$export$aa3e815946b80764 = `a-AR9W_card`;
$fdcd6fbda13b8c9b$export$6d59db4903f20f7d = `a-AR9W_description`;



var $7fPBF = parcelRequire("7fPBF");


const $adca5a0759107f1a$export$42c8b97a7fd796b8 = ({ status: status })=>{
    const redColor = "#ff2f00";
    const greenColor = "#10b61c";
    const yellowColor = "#fa8802";
    const [text, setText] = (0, $7fPBF.useState)("");
    const [color, setColor] = (0, $7fPBF.useState)(yellowColor);
    (0, $7fPBF.useEffect)(()=>{
        switch(status){
            case "authorized":
                setText((0, $37bec70ed65ed924$export$21c51bc433c16634).payment_authorized);
                setColor(greenColor);
                break;
            case "cancelled":
                setText((0, $37bec70ed65ed924$export$21c51bc433c16634).payment_cancelled);
                setColor(redColor);
                break;
            case "pending":
                setText((0, $37bec70ed65ed924$export$21c51bc433c16634).payment_pending);
                setColor(yellowColor);
                break;
            case "paused":
                setText((0, $37bec70ed65ed924$export$21c51bc433c16634).payment_paused);
                setColor(redColor);
                break;
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fdcd6fbda13b8c9b$exports))).card,
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: color
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fdcd6fbda13b8c9b$exports))).description,
            children: text
        })
    });
};





const $a55cca238eeef93f$export$8a8c1f465751bdf3 = {
    isAlive: (subscriptionStatus)=>{
        if (!subscriptionStatus) return true;
        return [
            "pending",
            "authorized"
        ].includes(subscriptionStatus);
    }
};









const $3eb95d2b09e39eec$export$fe2ec8f5ac2d4b1f = ({ isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const { getLatestPayment: getLatestPayment } = (0, $ca7ad09c8eaa534c$export$d54623894818938b)();
    const [payment, setPayment] = (0, $7fPBF.useState)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [isSubscriptionsDialogOpen, setIsSubscriptionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen || !isMounted.current) return;
        fetchLatestPayment().then();
    }, [
        isOpen
    ]);
    const fetchLatestPayment = async ()=>{
        setLoading(true);
        const { status: status, body: body } = await getLatestPayment();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setPayment(body);
        else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "xs",
        open: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).my_subscription_title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.subscriptions.home()}`,
                        target: "_blank",
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: loading,
                        onClick: ()=>{
                            setIsOpen(false);
                        },
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).content,
                children: [
                    payment ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStack,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStatus,
                                        children: [
                                            (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_status,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $adca5a0759107f1a$export$42c8b97a7fd796b8), {
                                        status: payment.externalSubscriptionStatus ?? "pending"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStatus,
                                        children: [
                                            (0, $37bec70ed65ed924$export$21c51bc433c16634).payment_last_status,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $adca5a0759107f1a$export$42c8b97a7fd796b8), {
                                        status: payment.status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStatus,
                                        children: [
                                            (0, $a55cca238eeef93f$export$8a8c1f465751bdf3).isAlive(payment.externalSubscriptionStatus) ? (0, $37bec70ed65ed924$export$21c51bc433c16634).payment_next_date : (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_end_date,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).date,
                                        children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(payment.expirationUnixTimestamp * 1000, "d MMMM yyyy", {
                                            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStatus,
                                        children: [
                                            (0, $37bec70ed65ed924$export$21c51bc433c16634).payment_last_update,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).date,
                                        children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(payment.updatedUnixTimestamp * 1000, "d MMMM yyyy, HH:mm", {
                                            locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : !loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStack,
                        spacing: 1,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).paymentStatus,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).payment_is_processing_message
                        })
                    }),
                    payment?.kind == "mercadoPago" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "https://www.mercadopago.com.ar/subscriptions",
                        target: "_blank",
                        style: {
                            textDecoration: "none",
                            color: theme.palette.primary.main,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).manageButton,
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/MercadoPagoLogo.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_manage_in_mercadopago
                        })
                    }) : payment?.kind == "patreon" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "https://pateron.com",
                        style: {
                            textDecoration: "none",
                            color: theme.palette.primary.main,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).manageButton,
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/PatreonLogo.png",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_manage_in_patreon
                        })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "https://apple.co/3P2tpt7",
                        style: {
                            textDecoration: "none",
                            color: theme.palette.primary.main,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a47cc4b5ddb49d26$export$27142e2581b43071), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).manageButton,
                            imageSrc: "https://piper-public-images.s3.us-east-2.amazonaws.com/AppleLogo.svg",
                            buttonText: (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_manage_in_apple
                        })
                    }),
                    payment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ed66cb00f873dff6$exports))).manageButton,
                            onClick: ()=>setIsSubscriptionsDialogOpen(true),
                            children: (0, $a55cca238eeef93f$export$8a8c1f465751bdf3).isAlive(payment.externalSubscriptionStatus) ? (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_change : (0, $37bec70ed65ed924$export$21c51bc433c16634).subscription_renew
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49546dacaba52fc3$export$aa90fdcc84b843d2), {
                isOpen: isSubscriptionsDialogOpen,
                setIsOpen: setIsSubscriptionsDialogOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    await fetchLatestPayment();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};





const $ac3b6071b537c32a$export$3165e080a1784b09 = (0, $f3eb771fc47795e7$exports.createState)(undefined);
const $ac3b6071b537c32a$export$a68d20f32479326c = ()=>{
    const [currencies] = $ac3b6071b537c32a$export$3165e080a1784b09.useState();
    const getCurrenciesStringList = ()=>{
        if (!currencies) return [];
        return currencies.map((currency)=>`${currency.code} \[${currency.symbol}\]`);
    };
    const getCurrenciesCodeList = ()=>{
        if (!currencies) return [];
        return currencies.map((currency)=>currency.code);
    };
    const getCurrency = (code)=>{
        return currencies?.find((currency)=>currency.code == code);
    };
    return {
        getCurrenciesStringList: getCurrenciesStringList,
        getCurrenciesCodeList: getCurrenciesCodeList,
        getCurrency: getCurrency
    };
};





const $e0e1d50fa166e955$export$ae4f972b0bb7ae37 = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [, setCurrencies] = (0, $ac3b6071b537c32a$export$3165e080a1784b09).useState();
    const getCurrencies = async ()=>{
        const { status: status, body: body } = await get("currencies");
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setCurrencies(body);
    };
    return {
        getCurrencies: getCurrencies
    };
};

















const $79229fc15a9b5849$export$64ec26c0e829824d = ()=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const getResourceLimits = async ()=>get("user/limits");
    return {
        getResourceLimits: getResourceLimits
    };
};




var $7fPBF = parcelRequire("7fPBF");


var $8aa317372fe7d6e6$exports = {};

$parcel$export($8aa317372fe7d6e6$exports, "bar", function () { return $8aa317372fe7d6e6$export$d927737047eb3867; }, function (v) { return $8aa317372fe7d6e6$export$d927737047eb3867 = v; });
var $8aa317372fe7d6e6$export$d927737047eb3867;
$8aa317372fe7d6e6$export$d927737047eb3867 = `TmWb5a_bar`;






const $518a2c5e41e3c8b8$export$d6bedb7bc703773f = ({ productType: productType, title: title, currentAmount: currentAmount, totalAmount: totalAmount, detailBlurred: detailBlurred })=>{
    const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = (0, $7fPBF.useState)(false);
    const currencyFormatter = (0, $2262e5d71d677a84$export$98d63ead59c21b7b)();
    const barColor = ()=>{
        if (currentAmount >= totalAmount) return "error";
        if (totalAmount - currentAmount < totalAmount * 0.1) return "warning";
        return undefined;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                iconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[productType],
                title: title,
                detailBlurred: detailBlurred,
                detail: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    direction: "column",
                    spacing: 0.5,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    style: {
                                        fontWeight: "normal",
                                        fontVariant: "tabular-nums"
                                    },
                                    children: currencyFormatter.decimalFormat(currentAmount)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    style: {
                                        fontWeight: "normal"
                                    },
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    style: {
                                        fontVariant: "tabular-nums"
                                    },
                                    children: totalAmount >= 99999999 ? "\u221E" : currencyFormatter.decimalFormat(totalAmount)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8aa317372fe7d6e6$exports))).bar,
                            variant: "determinate",
                            value: currentAmount / totalAmount * 100,
                            color: barColor()
                        })
                    ]
                }),
                rightIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ChevronRight,
                onClick: ()=>setIsPurchaseDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                open: isPurchaseDialogOpen,
                setOpen: setIsPurchaseDialogOpen,
                productType: productType
            })
        ]
    });
};









var $7fPBF = parcelRequire("7fPBF");


var $2b83331cf94051ca$exports = {};

$parcel$export($2b83331cf94051ca$exports, "cardContainer", function () { return $2b83331cf94051ca$export$6b2d426110a11d7a; }, function (v) { return $2b83331cf94051ca$export$6b2d426110a11d7a = v; });
$parcel$export($2b83331cf94051ca$exports, "contentCard", function () { return $2b83331cf94051ca$export$9261782d08389607; }, function (v) { return $2b83331cf94051ca$export$9261782d08389607 = v; });
$parcel$export($2b83331cf94051ca$exports, "description", function () { return $2b83331cf94051ca$export$6d59db4903f20f7d; }, function (v) { return $2b83331cf94051ca$export$6d59db4903f20f7d = v; });
$parcel$export($2b83331cf94051ca$exports, "loadingDiv", function () { return $2b83331cf94051ca$export$dded2af20345efaa; }, function (v) { return $2b83331cf94051ca$export$dded2af20345efaa = v; });
$parcel$export($2b83331cf94051ca$exports, "passkeyCard", function () { return $2b83331cf94051ca$export$836b63e95a21e787; }, function (v) { return $2b83331cf94051ca$export$836b63e95a21e787 = v; });
$parcel$export($2b83331cf94051ca$exports, "searchBar", function () { return $2b83331cf94051ca$export$f2ea4ab276c3e3fa; }, function (v) { return $2b83331cf94051ca$export$f2ea4ab276c3e3fa = v; });
var $2b83331cf94051ca$export$6b2d426110a11d7a;
var $2b83331cf94051ca$export$9261782d08389607;
var $2b83331cf94051ca$export$6d59db4903f20f7d;
var $2b83331cf94051ca$export$dded2af20345efaa;
var $2b83331cf94051ca$export$836b63e95a21e787;
var $2b83331cf94051ca$export$f2ea4ab276c3e3fa;
$2b83331cf94051ca$export$6b2d426110a11d7a = `xLUe_a_cardContainer`;
$2b83331cf94051ca$export$9261782d08389607 = `xLUe_a_contentCard`;
$2b83331cf94051ca$export$6d59db4903f20f7d = `xLUe_a_description`;
$2b83331cf94051ca$export$dded2af20345efaa = `xLUe_a_loadingDiv`;
$2b83331cf94051ca$export$836b63e95a21e787 = `xLUe_a_passkeyCard`;
$2b83331cf94051ca$export$f2ea4ab276c3e3fa = `xLUe_a_searchBar`;






var $7fPBF = parcelRequire("7fPBF");
var $2e203ce20420b79d$exports = {};

$parcel$export($2e203ce20420b79d$exports, "actionArea", function () { return $2e203ce20420b79d$export$746dc5cb6bd7e71f; }, function (v) { return $2e203ce20420b79d$export$746dc5cb6bd7e71f = v; });
$parcel$export($2e203ce20420b79d$exports, "container", function () { return $2e203ce20420b79d$export$34e0f9847d4c02dd; }, function (v) { return $2e203ce20420b79d$export$34e0f9847d4c02dd = v; });
$parcel$export($2e203ce20420b79d$exports, "description", function () { return $2e203ce20420b79d$export$6d59db4903f20f7d; }, function (v) { return $2e203ce20420b79d$export$6d59db4903f20f7d = v; });
$parcel$export($2e203ce20420b79d$exports, "item", function () { return $2e203ce20420b79d$export$7061c75fc5af8b7e; }, function (v) { return $2e203ce20420b79d$export$7061c75fc5af8b7e = v; });
$parcel$export($2e203ce20420b79d$exports, "name", function () { return $2e203ce20420b79d$export$a8ff84c12d48cfa6; }, function (v) { return $2e203ce20420b79d$export$a8ff84c12d48cfa6 = v; });
$parcel$export($2e203ce20420b79d$exports, "readName", function () { return $2e203ce20420b79d$export$ccff49e992952c96; }, function (v) { return $2e203ce20420b79d$export$ccff49e992952c96 = v; });
$parcel$export($2e203ce20420b79d$exports, "severityMark", function () { return $2e203ce20420b79d$export$a070fdabc28e8418; }, function (v) { return $2e203ce20420b79d$export$a070fdabc28e8418 = v; });
$parcel$export($2e203ce20420b79d$exports, "visibility", function () { return $2e203ce20420b79d$export$91fa9ac3f4021ce4; }, function (v) { return $2e203ce20420b79d$export$91fa9ac3f4021ce4 = v; });
var $2e203ce20420b79d$export$746dc5cb6bd7e71f;
var $2e203ce20420b79d$export$34e0f9847d4c02dd;
var $2e203ce20420b79d$export$6d59db4903f20f7d;
var $2e203ce20420b79d$export$7061c75fc5af8b7e;
var $2e203ce20420b79d$export$a8ff84c12d48cfa6;
var $2e203ce20420b79d$export$ccff49e992952c96;
var $2e203ce20420b79d$export$a070fdabc28e8418;
var $2e203ce20420b79d$export$91fa9ac3f4021ce4;
$2e203ce20420b79d$export$746dc5cb6bd7e71f = `RRrFfq_actionArea`;
$2e203ce20420b79d$export$34e0f9847d4c02dd = `RRrFfq_container`;
$2e203ce20420b79d$export$6d59db4903f20f7d = `RRrFfq_description`;
$2e203ce20420b79d$export$7061c75fc5af8b7e = `RRrFfq_item`;
$2e203ce20420b79d$export$a8ff84c12d48cfa6 = `RRrFfq_name`;
$2e203ce20420b79d$export$ccff49e992952c96 = `RRrFfq_readName`;
$2e203ce20420b79d$export$a070fdabc28e8418 = `RRrFfq_severityMark`;
$2e203ce20420b79d$export$91fa9ac3f4021ce4 = `RRrFfq_visibility`;










const $06f529a615d24982$export$20da576591f818b2 = ({ id: id, createdUnixTimestamp: createdUnixTimestamp, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isLoading] = (0, $7fPBF.useState)(false);
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    const [user] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).item,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).container,
                elevation: 5,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).actionArea,
                    onContextMenu: handleContextMenu,
                    direction: "row",
                    sx: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        sx: {
                            width: "100%",
                            alignItems: "center"
                        },
                        direction: "row",
                        spacing: 2,
                        children: [
                            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Passkey
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "100%"
                                },
                                spacing: 1,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).name,
                                                    style: {
                                                        color: theme.palette.primary.main
                                                    },
                                                    children: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkey_title
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).description,
                                                    children: user.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            flexGrow: 1
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2e203ce20420b79d$exports))).visibility,
                                            children: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(+createdUnixTimestamp * 1000, "d MMMM yyyy HH:mm", {
                                                locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                            onClick: ()=>onDelete(id),
                                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                            color: theme.palette.colors?.remove
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
                ...menuProps,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        handleMenuClose();
                        onDelete(id);
                    },
                    style: {
                        color: theme.palette.colors?.remove
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                style: {
                                    color: theme.palette.colors?.remove
                                },
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).delete
                    ]
                })
            })
        ]
    });
};









const $1334050e2ba2a4af$export$3ebfe572a2aab3b4 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deletePasskey = (parameters)=>deleteRequest("passkeys", parameters);
    return {
        deletePasskey: deletePasskey
    };
};




const $75f5c79fd2501161$export$29f552b39188c781 = ({ open: open, setOpen: setOpen })=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [passkeys, setPasskeys] = (0, $7fPBF.useState)();
    const { registerPasskey: registerPasskey } = (0, $de36d9deb0a855aa$export$60838eccc434628e)();
    const { getPasskeys: getPasskeys } = (0, $7894c1810ba19017$export$8d60e69bec6a4ed8)();
    const { deletePasskey: deletePasskey } = (0, $1334050e2ba2a4af$export$3ebfe572a2aab3b4)();
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [idToDelete, setIdToDelete] = (0, $7fPBF.useState)();
    const [isDeleteConfirmationAlertOpen, setIsDeleteConfirmationAlertOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        fetchPasskeys().then();
    }, [
        open
    ]);
    const fetchPasskeys = async ()=>{
        setLoading(true);
        const { status: status, body: body } = await getPasskeys();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setPasskeys(body);
        else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setLoading(false);
    };
    const removePasskey = async ()=>{
        setLoading(true);
        const { status: status, body: body } = await deletePasskey({
            id: idToDelete
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setPasskeys(undefined);
            if (typeof PublicKeyCredential.getClientCapabilities === "function") {
                const capabilities = await PublicKeyCredential.getClientCapabilities();
                if (capabilities.signalUnknownCredential) await PublicKeyCredential.signalUnknownCredential({
                    rpId: (0, $225b141716ede244$export$7dc6752a22ab011a).relyingParty,
                    credentialId: idToDelete
                });
            }
            await fetchPasskeys();
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setLoading(false);
    };
    const registerNewPasskey = async ()=>{
        await registerPasskey(()=>{
            fetchPasskeys().then();
        }, (message)=>{
            setAlertMessage(message);
            setIsAlertOpen(true);
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: open,
        onClose: ()=>setOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                style: {
                                    marginRight: 8
                                },
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkeys_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: registerNewPasskey,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_passkey,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                flexGrow: 1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: loading,
                                onClick: ()=>setOpen(false),
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2b83331cf94051ca$exports))).description,
                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkeys_description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2b83331cf94051ca$exports))).contentCard,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            padding: isMobile ? 0 : 1
                        },
                        children: [
                            passkeys && passkeys.map((passkey)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06f529a615d24982$export$20da576591f818b2), {
                                    id: passkey.id,
                                    createdUnixTimestamp: passkey.createdUnixTimestamp,
                                    onDelete: (id)=>{
                                        setIdToDelete(id);
                                        setIsDeleteConfirmationAlertOpen(true);
                                    }
                                }, passkey.id)),
                            loading && Array.from({
                                length: 3
                            }, (value, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2b83331cf94051ca$exports))).cardContainer,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                                        height: 60,
                                        variant: "rectangular",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2b83331cf94051ca$exports))).passkeyCard
                                    })
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: loading,
                        items: passkeys,
                        emptyIconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Passkey,
                        emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_passkeys,
                        emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_attribute_description,
                        searchText: undefined,
                        canAdd: true,
                        addButtonTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_passkey,
                        onAddItem: registerNewPasskey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkeys_title,
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen,
                maxWidth: "xs"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkeys_delete_confirmation_message,
                open: isDeleteConfirmationAlertOpen,
                setOpen: setIsDeleteConfirmationAlertOpen,
                isConfirm: true,
                onConfirm: removePasskey
            })
        ]
    });
};




const $44d64031cd4d2c55$export$5db094fba1bfa49d = ({ setIsLoading: setIsLoading })=>{
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { modifyUserProfile: modifyUserProfile } = (0, $c9f68c5c1e8b930f$export$51e0836025131fe2)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const [isLoadingImage, setIsLoadingImage] = (0, $7fPBF.useState)(false);
    const [currentUserProfile, setCurrentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const { getUser: getUser } = (0, $9715c44d9964b1ed$export$7fc422f6ed9d34ba)();
    const { getUserProfile: getUserProfile } = (0, $79081da09985f2e4$export$611c90aeaea4f22e)();
    const { closeSession: closeSession } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const { getCurrencies: getCurrencies } = (0, $e0e1d50fa166e955$export$ae4f972b0bb7ae37)();
    const [currencies] = (0, $ac3b6071b537c32a$export$3165e080a1784b09).useState();
    const { getCurrency: getCurrency, getCurrenciesCodeList: getCurrenciesCodeList, getCurrenciesStringList: getCurrenciesStringList } = (0, $ac3b6071b537c32a$export$a68d20f32479326c)();
    const [, setCurrentPublicUserProfile] = (0, $f3e21a44c8405b5b$export$69ba603ca46caf3c).useState();
    const [, setCurrentPublicCollection] = (0, $6e65290b51df31d1$export$e1cfc0d114fc8345).useState();
    const { getShareLink: getShareLink } = (0, $222a4bd740860170$export$6c80620349828bf)();
    const [isPurchaseBundleDialogOpen, setIsPurchaseBundleDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoadingPublicCollections, setIsLoadingPublicCollections] = (0, $7fPBF.useState)(false);
    const [publicCollections] = (0, $facfcdb3f749c904$export$8bdde12dda791bc2)(currentUserProfile?.userId, setIsLoadingPublicCollections, true);
    const [shouldOpenFileDialog, setShouldOpenFileDialog] = (0, $7fPBF.useState)(false);
    const [isUpdateUsernameDialogOpen, setIsUpdateUsernameDialogOpen] = (0, $7fPBF.useState)(false);
    const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = (0, $7fPBF.useState)(false);
    const [isUpdateEmailDialogOpen, setIsUpdateEmailDialogOpen] = (0, $7fPBF.useState)(false);
    const [isUpdatePasswordDialogOpen, setIsUpdatePasswordDialogOpen] = (0, $7fPBF.useState)(false);
    const [isPasskeysDialogOpen, setIsPasskeysDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSubscriptionsDialogOpen, setIsSubscriptionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isMySubscriptionDialogOpen, setIsMySubscriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const { state: noColorNameDialogState, key: noColorNameDialogKey, openAdd: openNoColorNameDialog, close: closeNoColorNameDialog } = (0, $7593599276fe6c36$export$80eb249dd6d36ef2)();
    const [isBioDialogOpen, setIsBioDialogOpen] = (0, $7fPBF.useState)(false);
    const { getResourceLimits: getResourceLimits } = (0, $79229fc15a9b5849$export$64ec26c0e829824d)();
    const [resourceLimits, setResourceLimits] = (0, $7fPBF.useState)();
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const placeholderAvatar = new URL($f3dc95464e643b42$exports).href;
    (0, $7fPBF.useEffect)(()=>{
        if (!currentUser) getUser().then();
        if (!currentUserProfile) getUserProfile().then();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (currentUser?.role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).guest) navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
    }, [
        currentUser
    ]);
    const fetchImage = async ()=>{
        setImage(undefined);
        if (!currentUserProfile || !currentUserProfile.hasImage) return;
        const response = await getImage({
            name: currentUserProfile.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    const getLimits = async ()=>{
        const { status: status, body: body } = await getResourceLimits();
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setResourceLimits(body);
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchImage().then();
        getLimits().then();
    }, [
        currentUserProfile
    ]);
    const showCollection = async (publicCollection)=>{
        setIsLoading(true);
        const { status: status, body: body } = await getShareLink({
            collectionId: publicCollection.collection.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setCurrentPublicUserProfile(undefined);
            setCurrentPublicCollection(undefined);
            navigate(body.relativeShareLink);
        }
        setIsLoading(false);
    };
    const updateProfile = async (newValue)=>{
        setIsLoading(true);
        const { status: status, body: body } = await modifyUserProfile(newValue);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setCurrentUserProfile(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const handleCurrencyChange = async (event)=>{
        const code = event.target.value;
        const newValue = getCurrency(code);
        setIsLoading(true);
        const { status: status, body: body } = await modifyUserProfile({
            uuid: currentUserProfile?.uuid,
            currency: newValue
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setCurrentUserProfile(body);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoading(false);
    };
    const handleOrderNewAlbumsChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            orderNewAlbums: newValue
        }).then();
    };
    const handleShouldShowImpactsDescriptionChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            shouldShowImpactDescriptions: newValue
        }).then();
    };
    const handleShouldShowAlbumIdChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            shouldShowAlbumId: newValue
        }).then();
    };
    const handleShowDecimalsChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            showDecimals: newValue
        }).then();
    };
    const handleReceiveEmailNotificationsChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            receiveEmailNotifications: newValue
        }).then();
    };
    const handleShow3DModelChange = (_event, newValue)=>{
        if (newValue !== null) updateProfile({
            uuid: currentUserProfile?.uuid,
            show3DModel: newValue
        }).then();
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!currencies) getCurrencies().then();
    }, []);
    const profileList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).list,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).avatarContainer,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $772e96a1af9615ac$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).avatar,
                        sx: {
                            marginLeft: 2,
                            marginBottom: 2,
                            borderWidth: 2,
                            borderColor: theme.palette.primary.main,
                            borderStyle: "solid"
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).dropzone,
                                disabled: isLoadingImage,
                                onImageChanged: async (file)=>{
                                    if (!currentUserProfile) return;
                                    setIsLoadingImage(true);
                                    const newThumbnail = await uploadImage({
                                        name: currentUserProfile.uuid,
                                        file: file
                                    }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAvatarImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigAvatarImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallAvatarImageSize);
                                    if (newThumbnail) {
                                        setCurrentUserProfile({
                                            ...currentUserProfile,
                                            hasImage: true,
                                            thumbnail: newThumbnail
                                        });
                                        await fetchImage();
                                    }
                                    setIsLoadingImage(false);
                                },
                                placeholderImage: placeholderAvatar,
                                isLoading: isLoadingImage,
                                shouldOpenFileDialog: shouldOpenFileDialog,
                                initialImage: image ? `data:image/png;base64,${image}` : currentUserProfile?.thumbnail ? `data:image/png;base64,${currentUserProfile?.thumbnail}` : undefined
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).hoverButtonsStack,
                                direction: "row",
                                spacing: 1,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_avatar,
                                        arrow: true,
                                        disableInteractive: true,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).hoverButton,
                                            disabled: isLoadingImage,
                                            style: {
                                                backgroundColor: theme.palette.colors?.counterBackground
                                            },
                                            onClick: ()=>setShouldOpenFileDialog((state)=>!state),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).sectionMobile : (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).section,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AccountBox,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).username_title,
                            detail: currentUserProfile?.username ?? "",
                            onClick: ()=>{
                                setIsUpdateUsernameDialogOpen(true);
                            }
                        }, "update_username"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ContactMail,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).email_title,
                            leftSubtitle: currentUser?.email ?? "",
                            onClick: ()=>{
                                setIsUpdateEmailDialogOpen(true);
                            }
                        }, "update_email"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ContactEmergency,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).update_password_title,
                            detail: "\u25CF \u25CF \u25CF \u25CF \u25CF",
                            onClick: ()=>{
                                setIsUpdatePasswordDialogOpen(true);
                            }
                        }, "update_password"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Passkey,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).passkeys_title,
                            onClick: ()=>{
                                setIsPasskeysDialogOpen(true);
                            }
                        }, "passkeys"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        currentUserProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Today,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).user_since_title,
                            detail: (0, $0918c9925a326e99$export$2e2bcd8739ae039)(currentUserProfile.createdUnixTimestamp * 1000, "d MMMM yyyy", {
                                locale: (0, $37bec70ed65ed924$export$21c51bc433c16634).fnsLocale
                            })
                        }, "user_since"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).BusinessCenter,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).update_role_title,
                            detail: (0, $7c2c0ada8130752a$export$4ad5a58f9467cba5).roleName(currentUser?.role),
                            onClick: ()=>{
                                if (currentUser?.role == (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common) setIsSubscriptionsDialogOpen(true);
                                else setIsMySubscriptionDialogOpen(true);
                            }
                        }, "update_role")
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).sectionMobile : (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).section,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).HistoryEdu,
                        title: (0, $37bec70ed65ed924$export$21c51bc433c16634).bio_title,
                        detail: currentUserProfile?.bio ?? "--",
                        maxLines: 6,
                        onClick: ()=>{
                            setIsBioDialogOpen(true);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).sectionMobile : (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).section,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81012e6d1ba93698$export$414c12bb580eacc1), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Paid,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).currency_title,
                            labels: getCurrenciesStringList(),
                            values: getCurrenciesCodeList(),
                            value: currentUserProfile?.currency.code,
                            handleChange: handleCurrencyChange
                        }, "currency"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Mail,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_receive_email_notifications,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.receiveEmailNotifications,
                            fullWidth: false,
                            handleChange: handleReceiveEmailNotificationsChange
                        }, "receive_email_notifications"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DecimalIncrease,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_show_decimals,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.showDecimals,
                            fullWidth: false,
                            handleChange: handleShowDecimalsChange
                        }, "show_decimals"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ThreeDimensionalRotation,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_show_3d_model,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.show3DModel,
                            fullWidth: false,
                            handleChange: handleShow3DModelChange
                        }, "show_3d_model"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FormatListNumbered,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_order_new_albums,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.orderNewAlbums,
                            fullWidth: false,
                            handleChange: handleOrderNewAlbumsChange,
                            helpHref: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.album.orderAlbums()}`
                        }, "order_new_albums"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Star,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_should_show_impact_descriptions,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.shouldShowImpactDescriptions,
                            fullWidth: false,
                            handleChange: handleShouldShowImpactsDescriptionChange
                        }, "show_rating_description"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Pin,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).settings_should_show_album_id,
                            labels: [
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).no,
                                (0, $37bec70ed65ed924$export$21c51bc433c16634).yes
                            ],
                            values: [
                                false,
                                true
                            ],
                            value: currentUserProfile?.shouldShowAlbumId,
                            fullWidth: false,
                            handleChange: handleShouldShowAlbumIdChange
                        }, "show_album_id"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $504a3351cc023888$export$408fe8826c07eae7), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Palette,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).switchListItem,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).no_color_names_title,
                            chips: currentUserProfile?.noColorNames?.map((color)=>({
                                    id: color,
                                    name: color
                                })),
                            helpHref: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.userProfile("colors")}`,
                            onAdd: openNoColorNameDialog,
                            onDelete: (index)=>{
                                const noColorNames = [
                                    ...currentUserProfile?.noColorNames ?? []
                                ];
                                if (index !== undefined && index >= 0) noColorNames?.splice(index, 1);
                                updateProfile({
                                    uuid: currentUserProfile?.uuid,
                                    noColorNames: noColorNames
                                }).then();
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                    elevation: 5,
                    className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).sectionMobile : (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).section,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Settings,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_preferences,
                            onClick: ()=>{
                                setIsPreferencesDialogOpen(true);
                            }
                        }, "Preferences"),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4955c42ad8c479d$export$b91134a44a869282), {
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Logout,
                            title: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_close_session,
                            onClick: ()=>{
                                closeSession();
                                navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn());
                            }
                        }, "CloseSession")
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).username_title,
                    description: (0, $37bec70ed65ed924$export$21c51bc433c16634).modify_username_message,
                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).username_title,
                    missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                    value: currentUserProfile?.username,
                    canClear: false,
                    open: isUpdateUsernameDialogOpen,
                    onClose: ()=>setIsUpdateUsernameDialogOpen(false),
                    isNumber: false,
                    onChange: (newValue)=>{
                        updateProfile({
                            uuid: currentUserProfile?.uuid,
                            username: newValue
                        }).then();
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32841050af960b0a$export$3bb0ea6c690cb642), {
                    open: isUpdateEmailDialogOpen,
                    setOpen: setIsUpdateEmailDialogOpen
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01bd913149ce3bb1$export$189867d15cbc5273), {
                    open: isUpdatePasswordDialogOpen,
                    setOpen: setIsUpdatePasswordDialogOpen
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75f5c79fd2501161$export$29f552b39188c781), {
                    open: isPasskeysDialogOpen,
                    setOpen: setIsPasskeysDialogOpen
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).bio_title,
                    description: (0, $37bec70ed65ed924$export$21c51bc433c16634).bio_message,
                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).bio_title,
                    open: isBioDialogOpen,
                    onClose: ()=>setIsBioDialogOpen(false),
                    value: currentUserProfile?.bio,
                    onChange: (newValue)=>{
                        updateProfile({
                            uuid: currentUserProfile?.uuid,
                            bio: newValue
                        }).then();
                    },
                    onClearValue: ()=>{
                        updateProfile({
                            uuid: currentUserProfile?.uuid,
                            bio: ""
                        }).then();
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e401ce2c8a9fd10$export$663fca43e57db29d), {
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).no_color_name_title,
                    description: (0, $37bec70ed65ed924$export$21c51bc433c16634).no_color_name_message,
                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).disc_color_placeholder,
                    missingText: (0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing,
                    canClear: false,
                    open: noColorNameDialogState.mode !== "closed",
                    onClose: closeNoColorNameDialog,
                    isNumber: false,
                    onChange: (newValue)=>{
                        const noColorNames = [
                            ...currentUserProfile?.noColorNames ?? []
                        ];
                        noColorNames?.push(newValue);
                        updateProfile({
                            uuid: currentUserProfile?.uuid,
                            noColorNames: noColorNames
                        }).then();
                    }
                }, noColorNameDialogKey),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49546dacaba52fc3$export$aa90fdcc84b843d2), {
                    isOpen: isSubscriptionsDialogOpen,
                    setIsOpen: setIsSubscriptionsDialogOpen
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3eb95d2b09e39eec$export$fe2ec8f5ac2d4b1f), {
                    isOpen: isMySubscriptionDialogOpen,
                    setIsOpen: setIsMySubscriptionDialogOpen
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6558c6f63077fa19$export$7125afe2279fb9f3), {
                    isOpen: isPreferencesDialogOpen,
                    setIsOpen: setIsPreferencesDialogOpen,
                    canRemoveAccount: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                    message: alertMessage,
                    open: isAlertOpen,
                    setOpen: setIsAlertOpen
                })
            ]
        });
    const resourceLimitsList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUMS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).albums_plural_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.albumCount,
                    totalAmount: resourceLimits?.limitAlbums
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ARTISTS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_artists_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.artistCount,
                    totalAmount: resourceLimits?.limitArtists
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).LABELS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_labels_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.labelCount,
                    totalAmount: resourceLimits?.limitLabels
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_FORMATS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_formats_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.albumFormatCount,
                    totalAmount: resourceLimits?.limitAlbumFormats
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).ALBUM_TYPES,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_album_types_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.albumTypeCount,
                    totalAmount: resourceLimits?.limitAlbumTypes
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).TAGS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).tags_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.tagCount,
                    totalAmount: resourceLimits?.limitTags
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).STORES,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_stores_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.storeCount,
                    totalAmount: resourceLimits?.limitStores
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).SELL_VALUES,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_sell_values_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.sellValueCount,
                    totalAmount: resourceLimits?.limitSellValues
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).EXCHANGE_RATES,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).attribute_exchange_rates_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.exchangeRateCount,
                    totalAmount: resourceLimits?.limitExchangeRates
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).COLLECTIONS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collections_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.collectionCount,
                    totalAmount: resourceLimits?.limitCollections
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbb65ef2f9a1ec09$export$675e54b3f4e1fe6d), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $518a2c5e41e3c8b8$export$d6bedb7bc703773f), {
                    productType: (0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS,
                    title: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelvings_title,
                    detailBlurred: !resourceLimits,
                    currentAmount: resourceLimits?.shelvingCount,
                    totalAmount: resourceLimits?.limitShelvings
                })
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).mainContainer,
        style: {
            backgroundColor: theme.palette.background.default
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$eb2fcfdbd7ba97d4), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).mainDiv,
                orientation: "horizontal",
                children: [
                    !isMobile && currentUserProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                        id: "left",
                        minSize: "40",
                        defaultSize: "50",
                        maxSize: "60",
                        style: {
                            display: "flex",
                            overflow: "auto"
                        },
                        children: profileList()
                    }),
                    !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$1ff3c3f08ae963c0), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).resizeHandle,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                            style: {
                                alignSelf: "center",
                                color: theme.palette.secondary.main,
                                fontSize: 14
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                        id: "right",
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).graphsDivMobile : (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).graphsDiv,
                        children: [
                            isMobile && currentUserProfile && profileList(),
                            currentUserProfile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).detailMobile : undefined,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).publicCollectionsTitle,
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).resource_limits_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                flexGrow: 1
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                                                onClick: ()=>setIsPurchaseBundleDialogOpen(true),
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                                    direction: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).LocalMall
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: "8px"
                                                            }
                                                        }),
                                                        (0, $37bec70ed65ed924$export$21c51bc433c16634).bundles_title
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                        elevation: 5,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).limitsCard,
                                        style: {
                                            backgroundColor: theme.palette.background.default
                                        },
                                        children: resourceLimitsList()
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).publicCollectionsTitle,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).public_collections_title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                        elevation: 5,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7c116cf7d2aae374$exports))).publicCollectionsCard,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06f7abb9506f3e42$export$e0a080237481d5b1), {
                                            isLoading: isLoadingPublicCollections,
                                            publicCollections: publicCollections.map((publicCollection)=>({
                                                    collection: publicCollection.collection,
                                                    userProfile: publicCollection.userProfile
                                                })),
                                            onCollectionSelected: showCollection,
                                            columnWidth: isMobile ? 12 : 6,
                                            skeletonCount: 4,
                                            showUser: false
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                open: isPurchaseBundleDialogOpen,
                setOpen: setIsPurchaseBundleDialogOpen,
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).BUNDLES
            })
        ]
    });
};




const $a19bbfb16dac7dac$export$b7b58f2e100445f7 = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).user_profile_title}`;
    }, []);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [isUserNotificationsDialogOpen, setIsUserNotificationsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7122f5b41a04d9b5$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            style: {
                                marginRight: isMobile ? 0 : 8
                            },
                            onClick: ()=>{
                                setIsDrawerOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                            currentPage: "profile",
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            isLayout: false,
                            isOpenDiscogsImport: isOpenDiscogsImport,
                            setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                            isOpenExcelImport: isOpenExcelImport,
                            setIsOpenExcelImport: setIsOpenExcelImport
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7122f5b41a04d9b5$exports))).title,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).user_profile_title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            sx: {
                                paddingLeft: 1,
                                width: theme.spacing(4)
                            },
                            children: isLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            href: `${window.location.protocol}//${window.location.host}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.userProfile()}`,
                            target: "_blank",
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).help,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Help
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc819c2594c6df0b$export$946d560c3f7a7be4), {
                            overlap: "circular",
                            badgeContent: currentUserProfile?.unreadNotifications,
                            color: "error",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).user_notifications_title,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Inbox,
                                onClick: ()=>setIsUserNotificationsDialogOpen(true)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7122f5b41a04d9b5$exports))).mainBody,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7122f5b41a04d9b5$exports))).detailBody,
                    style: {
                        backgroundColor: theme.palette.background.default
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $44d64031cd4d2c55$export$5db094fba1bfa49d), {
                            setIsLoading: setIsLoading
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0ab1c8ab8461e73$export$edc2b1ff56760709), {
                open: isUserNotificationsDialogOpen,
                setOpen: setIsUserNotificationsDialogOpen
            })
        ]
    });
};


const $48ca686d6b2bc40d$export$6c97a8e1fd3bfb81 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a19bbfb16dac7dac$export$b7b58f2e100445f7), {});
};







const $7fa32b64e6b5070b$export$341bb000d9d866bb = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const savePushNotificationToken = (parameters)=>post("pushNotificationTokens", {
            ...parameters,
            source: "Web"
        });
    return {
        savePushNotificationToken: savePushNotificationToken
    };
};






parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $84eab21e3cd425e3$exports = {};

$parcel$export($84eab21e3cd425e3$exports, "albumListContainer", function () { return $84eab21e3cd425e3$export$343bfb6a13fbcc80; }, function (v) { return $84eab21e3cd425e3$export$343bfb6a13fbcc80 = v; });
$parcel$export($84eab21e3cd425e3$exports, "appBar", function () { return $84eab21e3cd425e3$export$d0a9b8580e71599c; }, function (v) { return $84eab21e3cd425e3$export$d0a9b8580e71599c = v; });
$parcel$export($84eab21e3cd425e3$exports, "cancelButton", function () { return $84eab21e3cd425e3$export$4ededb8e5b56a6fb; }, function (v) { return $84eab21e3cd425e3$export$4ededb8e5b56a6fb = v; });
$parcel$export($84eab21e3cd425e3$exports, "collectionTitle", function () { return $84eab21e3cd425e3$export$eb877aaaf03a6de7; }, function (v) { return $84eab21e3cd425e3$export$eb877aaaf03a6de7 = v; });
$parcel$export($84eab21e3cd425e3$exports, "collectionTitleText", function () { return $84eab21e3cd425e3$export$3835f5851904f547; }, function (v) { return $84eab21e3cd425e3$export$3835f5851904f547 = v; });
$parcel$export($84eab21e3cd425e3$exports, "expandIcon", function () { return $84eab21e3cd425e3$export$577bdbd696b473b5; }, function (v) { return $84eab21e3cd425e3$export$577bdbd696b473b5 = v; });
$parcel$export($84eab21e3cd425e3$exports, "layoutDetail", function () { return $84eab21e3cd425e3$export$542cfd48855bf5dd; }, function (v) { return $84eab21e3cd425e3$export$542cfd48855bf5dd = v; });
$parcel$export($84eab21e3cd425e3$exports, "loadingIndicator", function () { return $84eab21e3cd425e3$export$f10e6b4aaa94c253; }, function (v) { return $84eab21e3cd425e3$export$f10e6b4aaa94c253 = v; });
$parcel$export($84eab21e3cd425e3$exports, "mainBody", function () { return $84eab21e3cd425e3$export$f239b04fc1a0c7e1; }, function (v) { return $84eab21e3cd425e3$export$f239b04fc1a0c7e1 = v; });
$parcel$export($84eab21e3cd425e3$exports, "mobileCloseButton", function () { return $84eab21e3cd425e3$export$bf3694b705f1b48b; }, function (v) { return $84eab21e3cd425e3$export$bf3694b705f1b48b = v; });
$parcel$export($84eab21e3cd425e3$exports, "piperLogo", function () { return $84eab21e3cd425e3$export$8cacecdcbcc49d33; }, function (v) { return $84eab21e3cd425e3$export$8cacecdcbcc49d33 = v; });
$parcel$export($84eab21e3cd425e3$exports, "resizeHandle", function () { return $84eab21e3cd425e3$export$8e36b812ea421d73; }, function (v) { return $84eab21e3cd425e3$export$8e36b812ea421d73 = v; });
$parcel$export($84eab21e3cd425e3$exports, "searchBar", function () { return $84eab21e3cd425e3$export$f2ea4ab276c3e3fa; }, function (v) { return $84eab21e3cd425e3$export$f2ea4ab276c3e3fa = v; });
$parcel$export($84eab21e3cd425e3$exports, "toolbar", function () { return $84eab21e3cd425e3$export$f727f52c778e92d5; }, function (v) { return $84eab21e3cd425e3$export$f727f52c778e92d5 = v; });
$parcel$export($84eab21e3cd425e3$exports, "toolbarIcon", function () { return $84eab21e3cd425e3$export$e23b0c89a201934e; }, function (v) { return $84eab21e3cd425e3$export$e23b0c89a201934e = v; });
var $84eab21e3cd425e3$export$343bfb6a13fbcc80;
var $84eab21e3cd425e3$export$d0a9b8580e71599c;
var $84eab21e3cd425e3$export$4ededb8e5b56a6fb;
var $84eab21e3cd425e3$export$eb877aaaf03a6de7;
var $84eab21e3cd425e3$export$3835f5851904f547;
var $84eab21e3cd425e3$export$577bdbd696b473b5;
var $84eab21e3cd425e3$export$542cfd48855bf5dd;
var $84eab21e3cd425e3$export$f10e6b4aaa94c253;
var $84eab21e3cd425e3$export$f239b04fc1a0c7e1;
var $84eab21e3cd425e3$export$bf3694b705f1b48b;
var $84eab21e3cd425e3$export$8cacecdcbcc49d33;
var $84eab21e3cd425e3$export$8e36b812ea421d73;
var $84eab21e3cd425e3$export$f2ea4ab276c3e3fa;
var $84eab21e3cd425e3$export$f727f52c778e92d5;
var $84eab21e3cd425e3$export$e23b0c89a201934e;
$84eab21e3cd425e3$export$343bfb6a13fbcc80 = `KDljYG_albumListContainer`;
$84eab21e3cd425e3$export$d0a9b8580e71599c = `KDljYG_appBar`;
$84eab21e3cd425e3$export$4ededb8e5b56a6fb = `KDljYG_cancelButton`;
$84eab21e3cd425e3$export$eb877aaaf03a6de7 = `KDljYG_collectionTitle`;
$84eab21e3cd425e3$export$3835f5851904f547 = `KDljYG_collectionTitleText`;
$84eab21e3cd425e3$export$577bdbd696b473b5 = `KDljYG_expandIcon`;
$84eab21e3cd425e3$export$542cfd48855bf5dd = `KDljYG_layoutDetail`;
$84eab21e3cd425e3$export$f10e6b4aaa94c253 = `KDljYG_loadingIndicator`;
$84eab21e3cd425e3$export$f239b04fc1a0c7e1 = `KDljYG_mainBody`;
$84eab21e3cd425e3$export$bf3694b705f1b48b = `KDljYG_mobileCloseButton`;
$84eab21e3cd425e3$export$8cacecdcbcc49d33 = `KDljYG_piperLogo`;
$84eab21e3cd425e3$export$8e36b812ea421d73 = `KDljYG_resizeHandle`;
$84eab21e3cd425e3$export$f2ea4ab276c3e3fa = `KDljYG_searchBar`;
$84eab21e3cd425e3$export$f727f52c778e92d5 = `KDljYG_toolbar`;
$84eab21e3cd425e3$export$e23b0c89a201934e = `KDljYG_toolbarIcon`;

































var $7fPBF = parcelRequire("7fPBF");
var $ca45f5b19686e5fd$exports = {};

$parcel$export($ca45f5b19686e5fd$exports, "breadcrumb", function () { return $ca45f5b19686e5fd$export$a40ebde8ba896166; }, function (v) { return $ca45f5b19686e5fd$export$a40ebde8ba896166 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "breadcrumbDiv", function () { return $ca45f5b19686e5fd$export$cb8ba0fe1dd55e74; }, function (v) { return $ca45f5b19686e5fd$export$cb8ba0fe1dd55e74 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "breadcrumbElement", function () { return $ca45f5b19686e5fd$export$b6028439df827ca6; }, function (v) { return $ca45f5b19686e5fd$export$b6028439df827ca6 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "breadcrumbStack", function () { return $ca45f5b19686e5fd$export$b7118c0d401d1537; }, function (v) { return $ca45f5b19686e5fd$export$b7118c0d401d1537 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "breadcrumbText", function () { return $ca45f5b19686e5fd$export$b2ecdc31a99b40ba; }, function (v) { return $ca45f5b19686e5fd$export$b2ecdc31a99b40ba = v; });
$parcel$export($ca45f5b19686e5fd$exports, "contentUnavailable", function () { return $ca45f5b19686e5fd$export$fe3cedd54445c035; }, function (v) { return $ca45f5b19686e5fd$export$fe3cedd54445c035 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "loadingContainer", function () { return $ca45f5b19686e5fd$export$7acf0aff43f729a5; }, function (v) { return $ca45f5b19686e5fd$export$7acf0aff43f729a5 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "loadingStack", function () { return $ca45f5b19686e5fd$export$5b8225885d80bccc; }, function (v) { return $ca45f5b19686e5fd$export$5b8225885d80bccc = v; });
$parcel$export($ca45f5b19686e5fd$exports, "mainContainer", function () { return $ca45f5b19686e5fd$export$eccb60d5692f3f7d; }, function (v) { return $ca45f5b19686e5fd$export$eccb60d5692f3f7d = v; });
$parcel$export($ca45f5b19686e5fd$exports, "progressBar", function () { return $ca45f5b19686e5fd$export$9d1298853f0e77f7; }, function (v) { return $ca45f5b19686e5fd$export$9d1298853f0e77f7 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "shelving", function () { return $ca45f5b19686e5fd$export$90cbd767c1007fee; }, function (v) { return $ca45f5b19686e5fd$export$90cbd767c1007fee = v; });
$parcel$export($ca45f5b19686e5fd$exports, "shelvingContainer", function () { return $ca45f5b19686e5fd$export$c2255feb2ff18aca; }, function (v) { return $ca45f5b19686e5fd$export$c2255feb2ff18aca = v; });
$parcel$export($ca45f5b19686e5fd$exports, "statsStack", function () { return $ca45f5b19686e5fd$export$98478a5c24e62505; }, function (v) { return $ca45f5b19686e5fd$export$98478a5c24e62505 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "tutorialText", function () { return $ca45f5b19686e5fd$export$ebf8e0ccce4dfeb6; }, function (v) { return $ca45f5b19686e5fd$export$ebf8e0ccce4dfeb6 = v; });
$parcel$export($ca45f5b19686e5fd$exports, "zoomSlider", function () { return $ca45f5b19686e5fd$export$914596ab2d436db; }, function (v) { return $ca45f5b19686e5fd$export$914596ab2d436db = v; });
var $ca45f5b19686e5fd$export$a40ebde8ba896166;
var $ca45f5b19686e5fd$export$cb8ba0fe1dd55e74;
var $ca45f5b19686e5fd$export$b6028439df827ca6;
var $ca45f5b19686e5fd$export$b7118c0d401d1537;
var $ca45f5b19686e5fd$export$b2ecdc31a99b40ba;
var $ca45f5b19686e5fd$export$fe3cedd54445c035;
var $ca45f5b19686e5fd$export$7acf0aff43f729a5;
var $ca45f5b19686e5fd$export$5b8225885d80bccc;
var $ca45f5b19686e5fd$export$eccb60d5692f3f7d;
var $ca45f5b19686e5fd$export$9d1298853f0e77f7;
var $ca45f5b19686e5fd$export$90cbd767c1007fee;
var $ca45f5b19686e5fd$export$c2255feb2ff18aca;
var $ca45f5b19686e5fd$export$98478a5c24e62505;
var $ca45f5b19686e5fd$export$ebf8e0ccce4dfeb6;
var $ca45f5b19686e5fd$export$914596ab2d436db;
$ca45f5b19686e5fd$export$a40ebde8ba896166 = `jUeBwa_breadcrumb`;
$ca45f5b19686e5fd$export$cb8ba0fe1dd55e74 = `jUeBwa_breadcrumbDiv`;
$ca45f5b19686e5fd$export$b6028439df827ca6 = `jUeBwa_breadcrumbElement`;
$ca45f5b19686e5fd$export$b7118c0d401d1537 = `jUeBwa_breadcrumbStack`;
$ca45f5b19686e5fd$export$b2ecdc31a99b40ba = `jUeBwa_breadcrumbText`;
$ca45f5b19686e5fd$export$fe3cedd54445c035 = `jUeBwa_contentUnavailable`;
$ca45f5b19686e5fd$export$7acf0aff43f729a5 = `jUeBwa_loadingContainer`;
$ca45f5b19686e5fd$export$5b8225885d80bccc = `jUeBwa_loadingStack`;
$ca45f5b19686e5fd$export$eccb60d5692f3f7d = `jUeBwa_mainContainer`;
$ca45f5b19686e5fd$export$9d1298853f0e77f7 = `jUeBwa_progressBar`;
$ca45f5b19686e5fd$export$90cbd767c1007fee = `jUeBwa_shelving`;
$ca45f5b19686e5fd$export$c2255feb2ff18aca = `jUeBwa_shelvingContainer`;
$ca45f5b19686e5fd$export$98478a5c24e62505 = `jUeBwa_statsStack`;
$ca45f5b19686e5fd$export$ebf8e0ccce4dfeb6 = `jUeBwa_tutorialText`;
$ca45f5b19686e5fd$export$914596ab2d436db = `jUeBwa_zoomSlider`;








var $7fPBF = parcelRequire("7fPBF");
var $cc2af98984d5e66a$exports = {};

$parcel$export($cc2af98984d5e66a$exports, "cancelButton", function () { return $cc2af98984d5e66a$export$4ededb8e5b56a6fb; }, function (v) { return $cc2af98984d5e66a$export$4ededb8e5b56a6fb = v; });
$parcel$export($cc2af98984d5e66a$exports, "descriptionCard", function () { return $cc2af98984d5e66a$export$ea3c9f9ac820b913; }, function (v) { return $cc2af98984d5e66a$export$ea3c9f9ac820b913 = v; });
$parcel$export($cc2af98984d5e66a$exports, "freeTextFields", function () { return $cc2af98984d5e66a$export$fc15afe0ee03b9c1; }, function (v) { return $cc2af98984d5e66a$export$fc15afe0ee03b9c1 = v; });
$parcel$export($cc2af98984d5e66a$exports, "imageDiv", function () { return $cc2af98984d5e66a$export$3739a067e202c353; }, function (v) { return $cc2af98984d5e66a$export$3739a067e202c353 = v; });
$parcel$export($cc2af98984d5e66a$exports, "loadingDiv", function () { return $cc2af98984d5e66a$export$dded2af20345efaa; }, function (v) { return $cc2af98984d5e66a$export$dded2af20345efaa = v; });
$parcel$export($cc2af98984d5e66a$exports, "orientation", function () { return $cc2af98984d5e66a$export$b363cb15cbb91a1a; }, function (v) { return $cc2af98984d5e66a$export$b363cb15cbb91a1a = v; });
$parcel$export($cc2af98984d5e66a$exports, "selectTheme", function () { return $cc2af98984d5e66a$export$21af0fc3c16183e1; }, function (v) { return $cc2af98984d5e66a$export$21af0fc3c16183e1 = v; });
$parcel$export($cc2af98984d5e66a$exports, "subtitle", function () { return $cc2af98984d5e66a$export$c96745152eb2740f; }, function (v) { return $cc2af98984d5e66a$export$c96745152eb2740f = v; });
$parcel$export($cc2af98984d5e66a$exports, "switch", function () { return $cc2af98984d5e66a$export$52002a3975269b5d; }, function (v) { return $cc2af98984d5e66a$export$52002a3975269b5d = v; });
$parcel$export($cc2af98984d5e66a$exports, "textField", function () { return $cc2af98984d5e66a$export$c54b92c0bb02ba64; }, function (v) { return $cc2af98984d5e66a$export$c54b92c0bb02ba64 = v; });
$parcel$export($cc2af98984d5e66a$exports, "toggleButton", function () { return $cc2af98984d5e66a$export$c3f9788a1ddcf2d9; }, function (v) { return $cc2af98984d5e66a$export$c3f9788a1ddcf2d9 = v; });
var $cc2af98984d5e66a$export$4ededb8e5b56a6fb;
var $cc2af98984d5e66a$export$ea3c9f9ac820b913;
var $cc2af98984d5e66a$export$fc15afe0ee03b9c1;
var $cc2af98984d5e66a$export$3739a067e202c353;
var $cc2af98984d5e66a$export$dded2af20345efaa;
var $cc2af98984d5e66a$export$b363cb15cbb91a1a;
var $cc2af98984d5e66a$export$21af0fc3c16183e1;
var $cc2af98984d5e66a$export$c96745152eb2740f;
var $cc2af98984d5e66a$export$52002a3975269b5d;
var $cc2af98984d5e66a$export$c54b92c0bb02ba64;
var $cc2af98984d5e66a$export$c3f9788a1ddcf2d9;
$cc2af98984d5e66a$export$4ededb8e5b56a6fb = `djmLna_cancelButton`;
$cc2af98984d5e66a$export$ea3c9f9ac820b913 = `djmLna_descriptionCard`;
$cc2af98984d5e66a$export$fc15afe0ee03b9c1 = `djmLna_freeTextFields`;
$cc2af98984d5e66a$export$3739a067e202c353 = `djmLna_imageDiv`;
$cc2af98984d5e66a$export$dded2af20345efaa = `djmLna_loadingDiv`;
$cc2af98984d5e66a$export$b363cb15cbb91a1a = `djmLna_orientation`;
$cc2af98984d5e66a$export$21af0fc3c16183e1 = `djmLna_selectTheme`;
$cc2af98984d5e66a$export$c96745152eb2740f = `djmLna_subtitle`;
$cc2af98984d5e66a$export$52002a3975269b5d = `djmLna_switch`;
$cc2af98984d5e66a$export$c54b92c0bb02ba64 = `djmLna_textField`;
$cc2af98984d5e66a$export$c3f9788a1ddcf2d9 = `djmLna_toggleButton`;




var $1ZNeQ = parcelRequire("1ZNeQ");














const $2e17550203298d0b$export$4e78a89ba2ae790c = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addShelving = (parameters)=>post("shelvings", parameters);
    return {
        addShelving: addShelving
    };
};



const $9abb0871685c496d$export$71ca0238b62609a1 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyShelving = (parameters)=>put("shelvings", parameters);
    return {
        modifyShelving: modifyShelving
    };
};








parcelRequire("7fPBF");



const $607491bf937a823d$export$4e5b4cc6911bd49d = ({ theme: theme })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        direction: "row",
        alignItems: "center",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).imageDiv,
                style: {
                    backgroundImage: `url(${(0, $36b1843853ab03b4$export$76250962427778b).getThemeImage(theme)})`
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: (0, $36b1843853ab03b4$export$76250962427778b).getThemeString(theme)
            })
        ]
    });
};


const $ffe1d071b3002ed9$export$900bc4422ae4adda = ({ open: open, setOpen: setOpen, shelving: shelving, callback: callback, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [dialogTitle, setDialogTitle] = (0, $7fPBF.useState)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_new_title);
    const { addShelving: addShelving } = (0, $2e17550203298d0b$export$4e78a89ba2ae790c)();
    const { modifyShelving: modifyShelving } = (0, $9abb0871685c496d$export$71ca0238b62609a1)();
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [purchaseAlertIsOpen, setPurchaseAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [purchaseDialogIsOpen, setPurchaseDialogIsOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = (event)=>{
        event.stopPropagation();
        if (isLoading) return;
        if (formik.dirty) {
            setIsConfirmCloseAlertOpen(true);
            return;
        }
        handleClose();
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: shelving?.name ?? "",
            description: shelving?.description ?? "",
            orientation: shelving?.orientation ?? "horizontal",
            theme: shelving?.theme ?? "cedar",
            everyAlbumHasSameSize: shelving?.everyAlbumHasSameSize ?? false
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, description: description, orientation: orientation, theme: theme, everyAlbumHasSameSize: everyAlbumHasSameSize })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (shelving) {
                const { status: status, body: body } = await modifyShelving({
                    uuid: shelving.uuid,
                    name: name,
                    description: description,
                    orientation: orientation,
                    theme: theme,
                    everyAlbumHasSameSize: everyAlbumHasSameSize
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addShelving({
                    name: name,
                    description: description,
                    orientation: orientation,
                    theme: theme,
                    everyAlbumHasSameSize: everyAlbumHasSameSize
                });
                statusCode = status;
                responseBody = body;
            }
            if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("shelving_action");
                if (callback != undefined) callback(responseBody);
                handleClose();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            } else if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isLimitReached(statusCode)) {
                setAlertMessage(responseBody.message);
                setPurchaseAlertIsOpen(true);
            } else {
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setDialogTitle(shelving ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_new_title);
        formik.resetForm();
    }, [
        open
    ]);
    const handleOrientationChange = (event, orientation)=>{
        if (orientation !== null) formik.setFieldValue("orientation", orientation);
    };
    const possibleThemes = [
        "cedar",
        "oak",
        "ebony",
        "walnut",
        "blue"
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            shelving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_name_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_orientation
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).orientation,
                                labels: [
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).horizontal,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).vertical
                                ],
                                values: [
                                    "horizontal",
                                    "vertical"
                                ],
                                value: formik.values.orientation,
                                fullWidth: true,
                                disableGutters: true,
                                disabled: isLoading,
                                handleChange: handleOrientationChange
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_theme
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: String(formik.values.theme),
                                renderValue: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $607491bf937a823d$export$4e5b4cc6911bd49d), {
                                        theme: formik.values.theme
                                    }),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).selectTheme,
                                onChange: (event)=>formik.setFieldValue("theme", event.target.value),
                                sx: {
                                    height: "36px"
                                },
                                children: possibleThemes.map((theme, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: theme,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $607491bf937a823d$export$4e5b4cc6911bd49d), {
                                            theme: theme
                                        })
                                    }, `item_${index}`))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_every_album_same_size
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $17ed26c1f53c62f7$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).switch,
                                value: formik.values.everyAlbumHasSameSize,
                                exclusive: true,
                                onChange: (event, value)=>{
                                    if (value !== null) formik.setFieldValue("everyAlbumHasSameSize", value);
                                },
                                sx: {
                                    height: "30px",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: true,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_yes
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e902733729c30441$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).toggleButton,
                                        sx: {
                                            color: theme.palette.colors?.disabled
                                        },
                                        value: false,
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_pie_no
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cc2af98984d5e66a$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: handleClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: purchaseAlertIsOpen,
                setOpen: setPurchaseAlertIsOpen,
                isConfirm: true,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).purchase_alert,
                onConfirm: ()=>setPurchaseDialogIsOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911a114a71cd31c6$export$5182b767b22aa742), {
                productType: (0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS,
                open: purchaseDialogIsOpen,
                setOpen: setPurchaseDialogIsOpen
            })
        ]
    });
};



const $716f697f881fd6ce$export$db4c17fbbbc72d88 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteShelving = (parameters)=>deleteRequest("shelvings", parameters);
    return {
        deleteShelving: deleteShelving
    };
};






var $7fPBF = parcelRequire("7fPBF");
var $27a6be7d6c775ba4$exports = {};

$parcel$export($27a6be7d6c775ba4$exports, "bannedFields", function () { return $27a6be7d6c775ba4$export$9c4f0dc9637ce11e; }, function (v) { return $27a6be7d6c775ba4$export$9c4f0dc9637ce11e = v; });
$parcel$export($27a6be7d6c775ba4$exports, "cancelButton", function () { return $27a6be7d6c775ba4$export$4ededb8e5b56a6fb; }, function (v) { return $27a6be7d6c775ba4$export$4ededb8e5b56a6fb = v; });
$parcel$export($27a6be7d6c775ba4$exports, "descriptionCard", function () { return $27a6be7d6c775ba4$export$ea3c9f9ac820b913; }, function (v) { return $27a6be7d6c775ba4$export$ea3c9f9ac820b913 = v; });
$parcel$export($27a6be7d6c775ba4$exports, "dropzone", function () { return $27a6be7d6c775ba4$export$585d0a7a39ed94ea; }, function (v) { return $27a6be7d6c775ba4$export$585d0a7a39ed94ea = v; });
$parcel$export($27a6be7d6c775ba4$exports, "freeTextFields", function () { return $27a6be7d6c775ba4$export$fc15afe0ee03b9c1; }, function (v) { return $27a6be7d6c775ba4$export$fc15afe0ee03b9c1 = v; });
$parcel$export($27a6be7d6c775ba4$exports, "loadingDiv", function () { return $27a6be7d6c775ba4$export$dded2af20345efaa; }, function (v) { return $27a6be7d6c775ba4$export$dded2af20345efaa = v; });
$parcel$export($27a6be7d6c775ba4$exports, "selectDiscount", function () { return $27a6be7d6c775ba4$export$1fab6054d6ffebee; }, function (v) { return $27a6be7d6c775ba4$export$1fab6054d6ffebee = v; });
$parcel$export($27a6be7d6c775ba4$exports, "subtitle", function () { return $27a6be7d6c775ba4$export$c96745152eb2740f; }, function (v) { return $27a6be7d6c775ba4$export$c96745152eb2740f = v; });
$parcel$export($27a6be7d6c775ba4$exports, "textField", function () { return $27a6be7d6c775ba4$export$c54b92c0bb02ba64; }, function (v) { return $27a6be7d6c775ba4$export$c54b92c0bb02ba64 = v; });
$parcel$export($27a6be7d6c775ba4$exports, "visibility", function () { return $27a6be7d6c775ba4$export$91fa9ac3f4021ce4; }, function (v) { return $27a6be7d6c775ba4$export$91fa9ac3f4021ce4 = v; });
var $27a6be7d6c775ba4$export$9c4f0dc9637ce11e;
var $27a6be7d6c775ba4$export$4ededb8e5b56a6fb;
var $27a6be7d6c775ba4$export$ea3c9f9ac820b913;
var $27a6be7d6c775ba4$export$585d0a7a39ed94ea;
var $27a6be7d6c775ba4$export$fc15afe0ee03b9c1;
var $27a6be7d6c775ba4$export$dded2af20345efaa;
var $27a6be7d6c775ba4$export$1fab6054d6ffebee;
var $27a6be7d6c775ba4$export$c96745152eb2740f;
var $27a6be7d6c775ba4$export$c54b92c0bb02ba64;
var $27a6be7d6c775ba4$export$91fa9ac3f4021ce4;
$27a6be7d6c775ba4$export$9c4f0dc9637ce11e = `_7iRepW_bannedFields`;
$27a6be7d6c775ba4$export$4ededb8e5b56a6fb = `_7iRepW_cancelButton`;
$27a6be7d6c775ba4$export$ea3c9f9ac820b913 = `_7iRepW_descriptionCard`;
$27a6be7d6c775ba4$export$585d0a7a39ed94ea = `_7iRepW_dropzone`;
$27a6be7d6c775ba4$export$fc15afe0ee03b9c1 = `_7iRepW_freeTextFields`;
$27a6be7d6c775ba4$export$dded2af20345efaa = `_7iRepW_loadingDiv`;
$27a6be7d6c775ba4$export$1fab6054d6ffebee = `_7iRepW_selectDiscount`;
$27a6be7d6c775ba4$export$c96745152eb2740f = `_7iRepW_subtitle`;
$27a6be7d6c775ba4$export$c54b92c0bb02ba64 = `_7iRepW_textField`;
$27a6be7d6c775ba4$export$91fa9ac3f4021ce4 = `_7iRepW_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");













const $1d51c7b5fa6907f7$export$41eb8c79310d9d54 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addShelf = (parameters)=>post("shelves", parameters);
    return {
        addShelf: addShelf
    };
};



const $1173259dd801f559$export$489c29e2a105ee14 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyShelf = (parameters)=>put("shelves", parameters);
    return {
        modifyShelf: modifyShelf
    };
};





const $85e6c9272a180c1d$export$b499bd8258f0d69a = ({ open: open, setOpen: setOpen, shelf: shelf, shelving: shelving, callback: callback, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [dialogTitle, setDialogTitle] = (0, $7fPBF.useState)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_new_title);
    const { addShelf: addShelf } = (0, $1d51c7b5fa6907f7$export$41eb8c79310d9d54)();
    const { modifyShelf: modifyShelf } = (0, $1173259dd801f559$export$489c29e2a105ee14)();
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = (event)=>{
        event.stopPropagation();
        if (isLoading) return;
        if (formik.dirty) {
            setIsConfirmCloseAlertOpen(true);
            return;
        }
        handleClose();
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: shelf?.name ?? "",
            description: shelf?.description ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, description: description })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (shelf) {
                const { status: status, body: body } = await modifyShelf({
                    uuid: shelf.uuid,
                    name: name,
                    description: description
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addShelf({
                    name: name,
                    description: description,
                    shelvingId: shelving.uuid
                });
                statusCode = status;
                responseBody = body;
            }
            if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("shelf_action");
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            } else {
                if (callback != undefined) callback(responseBody);
                handleClose();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setDialogTitle(shelf ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_new_title);
        formik.resetForm();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            shelf && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a6be7d6c775ba4$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_name_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($27a6be7d6c775ba4$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: handleClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};



const $0f753857d80008b5$export$fe90b0b946cc38e9 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteShelf = (parameters)=>deleteRequest("shelves", parameters);
    return {
        deleteShelf: deleteShelf
    };
};




var $7fPBF = parcelRequire("7fPBF");
var $1f79f84e68d49c00$exports = {};

$parcel$export($1f79f84e68d49c00$exports, "bannedFields", function () { return $1f79f84e68d49c00$export$9c4f0dc9637ce11e; }, function (v) { return $1f79f84e68d49c00$export$9c4f0dc9637ce11e = v; });
$parcel$export($1f79f84e68d49c00$exports, "cancelButton", function () { return $1f79f84e68d49c00$export$4ededb8e5b56a6fb; }, function (v) { return $1f79f84e68d49c00$export$4ededb8e5b56a6fb = v; });
$parcel$export($1f79f84e68d49c00$exports, "descriptionCard", function () { return $1f79f84e68d49c00$export$ea3c9f9ac820b913; }, function (v) { return $1f79f84e68d49c00$export$ea3c9f9ac820b913 = v; });
$parcel$export($1f79f84e68d49c00$exports, "dropzone", function () { return $1f79f84e68d49c00$export$585d0a7a39ed94ea; }, function (v) { return $1f79f84e68d49c00$export$585d0a7a39ed94ea = v; });
$parcel$export($1f79f84e68d49c00$exports, "freeTextFields", function () { return $1f79f84e68d49c00$export$fc15afe0ee03b9c1; }, function (v) { return $1f79f84e68d49c00$export$fc15afe0ee03b9c1 = v; });
$parcel$export($1f79f84e68d49c00$exports, "loadingDiv", function () { return $1f79f84e68d49c00$export$dded2af20345efaa; }, function (v) { return $1f79f84e68d49c00$export$dded2af20345efaa = v; });
$parcel$export($1f79f84e68d49c00$exports, "selectDiscount", function () { return $1f79f84e68d49c00$export$1fab6054d6ffebee; }, function (v) { return $1f79f84e68d49c00$export$1fab6054d6ffebee = v; });
$parcel$export($1f79f84e68d49c00$exports, "subtitle", function () { return $1f79f84e68d49c00$export$c96745152eb2740f; }, function (v) { return $1f79f84e68d49c00$export$c96745152eb2740f = v; });
$parcel$export($1f79f84e68d49c00$exports, "textField", function () { return $1f79f84e68d49c00$export$c54b92c0bb02ba64; }, function (v) { return $1f79f84e68d49c00$export$c54b92c0bb02ba64 = v; });
$parcel$export($1f79f84e68d49c00$exports, "visibility", function () { return $1f79f84e68d49c00$export$91fa9ac3f4021ce4; }, function (v) { return $1f79f84e68d49c00$export$91fa9ac3f4021ce4 = v; });
var $1f79f84e68d49c00$export$9c4f0dc9637ce11e;
var $1f79f84e68d49c00$export$4ededb8e5b56a6fb;
var $1f79f84e68d49c00$export$ea3c9f9ac820b913;
var $1f79f84e68d49c00$export$585d0a7a39ed94ea;
var $1f79f84e68d49c00$export$fc15afe0ee03b9c1;
var $1f79f84e68d49c00$export$dded2af20345efaa;
var $1f79f84e68d49c00$export$1fab6054d6ffebee;
var $1f79f84e68d49c00$export$c96745152eb2740f;
var $1f79f84e68d49c00$export$c54b92c0bb02ba64;
var $1f79f84e68d49c00$export$91fa9ac3f4021ce4;
$1f79f84e68d49c00$export$9c4f0dc9637ce11e = `_3qP3oa_bannedFields`;
$1f79f84e68d49c00$export$4ededb8e5b56a6fb = `_3qP3oa_cancelButton`;
$1f79f84e68d49c00$export$ea3c9f9ac820b913 = `_3qP3oa_descriptionCard`;
$1f79f84e68d49c00$export$585d0a7a39ed94ea = `_3qP3oa_dropzone`;
$1f79f84e68d49c00$export$fc15afe0ee03b9c1 = `_3qP3oa_freeTextFields`;
$1f79f84e68d49c00$export$dded2af20345efaa = `_3qP3oa_loadingDiv`;
$1f79f84e68d49c00$export$1fab6054d6ffebee = `_3qP3oa_selectDiscount`;
$1f79f84e68d49c00$export$c96745152eb2740f = `_3qP3oa_subtitle`;
$1f79f84e68d49c00$export$c54b92c0bb02ba64 = `_3qP3oa_textField`;
$1f79f84e68d49c00$export$91fa9ac3f4021ce4 = `_3qP3oa_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");













const $b50d0f7550eb8ee1$export$1a58ad8512ec281b = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addShelfSegment = (parameters)=>post("shelfSegments", parameters);
    return {
        addShelfSegment: addShelfSegment
    };
};



const $d1a3b4f32ddf7348$export$898f6979a1fc8978 = ()=>{
    const { put: put } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const modifyShelfSegment = (parameters)=>put("shelfSegments", parameters);
    return {
        modifyShelfSegment: modifyShelfSegment
    };
};








var $10e9fd8bf8e10674$exports = {};
$10e9fd8bf8e10674$exports = $parcel$resolve("9KDAZ");


const $db16f7e95ded5f9c$export$16956de635798f40 = ({ open: open, setOpen: setOpen, shelfSegment: shelfSegment, shelf: shelf, callback: callback, onDelete: onDelete })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const [dialogTitle, setDialogTitle] = (0, $7fPBF.useState)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_new_title);
    const { addShelfSegment: addShelfSegment } = (0, $b50d0f7550eb8ee1$export$1a58ad8512ec281b)();
    const { modifyShelfSegment: modifyShelfSegment } = (0, $d1a3b4f32ddf7348$export$898f6979a1fc8978)();
    const { uploadImage: uploadImage } = (0, $32bf7b326240a873$export$a470b679ab90b0b4)();
    const [isModifyDescriptionDialogOpen, setIsModifyDescriptionDialogOpen] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [imageFile, setImageFile] = (0, $7fPBF.useState)();
    const [didChangeImage, setDidChangeImage] = (0, $7fPBF.useState)(false);
    const { getImage: getImage } = (0, $823474252ad79741$export$b6122de96ced3cd9)();
    const [image, setImage] = (0, $7fPBF.useState)();
    const genericImage = new URL($10e9fd8bf8e10674$exports).href;
    const fetchImage = async ()=>{
        if (!shelfSegment?.hasImage) return;
        const response = await getImage({
            name: shelfSegment.uuid,
            width: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageWidth,
            height: (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageHeight
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(response.status)) setImage(response.body);
    };
    (0, $7fPBF.useEffect)(()=>{
        setImage(undefined);
        fetchImage().then();
    }, [
        shelfSegment
    ]);
    const tryToClose = (event)=>{
        event.stopPropagation();
        if (isLoading) return;
        if (formik.dirty) {
            setIsConfirmCloseAlertOpen(true);
            return;
        }
        handleClose();
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const validationSchema = $57e52f3b537dfd4b$export$be5493f9613cbbe({
        name: $57e52f3b537dfd4b$export$22b082955e083ec3().required((0, $37bec70ed65ed924$export$21c51bc433c16634).field_missing)
    });
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            name: shelfSegment?.name ?? "",
            description: shelfSegment?.description ?? ""
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ name: name, description: description })=>{
            setIsLoading(true);
            let statusCode, responseBody;
            if (shelfSegment) {
                const { status: status, body: body } = await modifyShelfSegment({
                    uuid: shelfSegment.uuid,
                    name: name,
                    description: description
                });
                statusCode = status;
                responseBody = body;
            } else {
                const { status: status, body: body } = await addShelfSegment({
                    name: name,
                    description: description,
                    shelfId: shelf.uuid
                });
                statusCode = status;
                responseBody = body;
            }
            if (!(0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(statusCode)) {
                (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.logFirebaseEvent("shelfsegment_action");
                setAlertMessage(responseBody.message);
                setAlertIsOpen(true);
            } else {
                if (didChangeImage && imageFile && responseBody.uuid) {
                    const newThumbnail = await uploadImage({
                        name: responseBody.uuid,
                        file: imageFile
                    }, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageWidth, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).bigShelfSegmentImageHeight, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallShelfSegmentImageWidth, (0, $b2aa90a9d667a20c$export$51adf995cb4f5799).smallShelfSegmentImageHeight);
                    if (newThumbnail) {
                        responseBody.hasImage = true;
                        responseBody.thumbnail = newThumbnail;
                    }
                }
                if (callback != undefined) callback(responseBody);
                handleClose();
                (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            }
            setIsLoading(false);
        },
        validationSchema: validationSchema
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setDialogTitle(shelfSegment ? (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_title : (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_new_title);
        formik.resetForm();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "xs",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: dialogTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            shelfSegment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                disabled: isLoading,
                                onClick: onDelete,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).delete,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever,
                                color: theme.palette.colors?.remove
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                loading: isLoading,
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_image_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b304a23afa22224$export$bdb39032c3517208), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1f79f84e68d49c00$exports))).dropzone,
                                onImageChanged: (file)=>{
                                    setImageFile(file);
                                    setDidChangeImage(true);
                                },
                                placeholderImage: genericImage,
                                initialImage: image ? `data:image/png;base64,${image}` : shelfSegment?.thumbnail ? `data:image/png;base64,${shelfSegment.thumbnail}` : undefined,
                                isLoading: false
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).name_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1f79f84e68d49c00$exports))).textField,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $120e0807a5c1834c$export$2c73285ae9390cec), {
                                    id: "name",
                                    name: "name",
                                    size: "small",
                                    autoFocus: !isMobile,
                                    placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_name_placeholder,
                                    value: formik.values.name,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1f79f84e68d49c00$exports))).descriptionCard,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af65e565b6be190c$export$2b4c8fd1120588cf), {
                                    hideTitle: true,
                                    detail: formik.values.description ?? "--",
                                    maxLines: 4,
                                    onClick: ()=>setIsModifyDescriptionDialogOpen(true)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9634a717b986bba$export$486ad2a96c15885a), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                description: (0, $37bec70ed65ed924$export$21c51bc433c16634).edit_description_description,
                placeholder: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_description,
                value: formik.values.description,
                open: isModifyDescriptionDialogOpen,
                onClose: ()=>setIsModifyDescriptionDialogOpen(false),
                onChange: (newValue)=>formik.setFieldValue("description", newValue),
                onClearValue: ()=>formik.setFieldValue("description", null)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: handleClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};



const $ef5bb08c0e96ac23$export$bf14b19ed43f5184 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const deleteShelfSegment = (parameters)=>deleteRequest("shelfSegments", parameters);
    return {
        deleteShelfSegment: deleteShelfSegment
    };
};





var $7fPBF = parcelRequire("7fPBF");
var $7dca5ccfae0e7005$exports = {};

$parcel$export($7dca5ccfae0e7005$exports, "statsLabel", function () { return $7dca5ccfae0e7005$export$31d5a9b8d93ae3f7; }, function (v) { return $7dca5ccfae0e7005$export$31d5a9b8d93ae3f7 = v; });
var $7dca5ccfae0e7005$export$31d5a9b8d93ae3f7;
$7dca5ccfae0e7005$export$31d5a9b8d93ae3f7 = `Ed4PGG_statsLabel`;








const $c0728e436d269bfa$export$c2aeb96f44648878 = ({ className: className, shelving: shelving, shelf: shelf, shelfSegment: shelfSegment })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const [isStatsDialogOpen, setIsStatsDialogOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($7dca5ccfae0e7005$exports))).statsBox),
                style: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.background.default
                },
                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_stats,
                loading: shelving === undefined,
                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AreaChart,
                onClick: ()=>setIsStatsDialogOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccc334ca611084ca$export$dbf8ababda40e4fe), {
                open: isStatsDialogOpen,
                setOpen: setIsStatsDialogOpen,
                shelfSegment: shelfSegment,
                shelf: shelf,
                shelving: shelving
            })
        ]
    });
};






parcelRequire("7fPBF");


var $19ef3c553d2f897f$exports = {};

$parcel$export($19ef3c553d2f897f$exports, "imageDiv", function () { return $19ef3c553d2f897f$export$3739a067e202c353; }, function (v) { return $19ef3c553d2f897f$export$3739a067e202c353 = v; });
$parcel$export($19ef3c553d2f897f$exports, "name", function () { return $19ef3c553d2f897f$export$a8ff84c12d48cfa6; }, function (v) { return $19ef3c553d2f897f$export$a8ff84c12d48cfa6 = v; });
var $19ef3c553d2f897f$export$3739a067e202c353;
var $19ef3c553d2f897f$export$a8ff84c12d48cfa6;
$19ef3c553d2f897f$export$3739a067e202c353 = `re8GeG_imageDiv`;
$19ef3c553d2f897f$export$a8ff84c12d48cfa6 = `re8GeG_name`;




parcelRequire("7fPBF");




const $f3ee5a99ca4bff65$export$aeedd578fb406803 = ({ menuProps: menuProps, handleMenuClose: handleMenuClose, onModify: onModify, onDelete: onDelete, setIsSelectOpen: setIsSelectOpen })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        onClick: (event)=>event.stopPropagation(),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
            ...menuProps,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: (event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        handleMenuClose();
                        setIsSelectOpen(false);
                        onModify();
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).EditSquare
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_modify
                    ]
                }, "Modify"),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                    onClick: (event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        handleMenuClose();
                        setIsSelectOpen(false);
                        onDelete();
                    },
                    sx: {
                        color: theme.palette.colors?.remove
                    },
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                            sx: {
                                color: theme.palette.colors?.remove
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DeleteForever
                            })
                        }),
                        (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_delete
                    ]
                }, "Remove")
            ]
        })
    });
};


const $13b20287e63ba48a$export$270d034cfd22f4de = ({ shelving: shelving, onModify: onModify, onDelete: onDelete, setIsSelectOpen: setIsSelectOpen, value: value, ...props })=>{
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        ...props,
        value: value,
        onContextMenu: handleContextMenu,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($19ef3c553d2f897f$exports))).imageDiv,
                        style: {
                            backgroundImage: `url(${(0, $36b1843853ab03b4$export$76250962427778b).getThemeImage(shelving.theme)})`
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($19ef3c553d2f897f$exports))).name,
                        children: shelving.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3ee5a99ca4bff65$export$aeedd578fb406803), {
                menuProps: menuProps,
                handleMenuClose: handleMenuClose,
                onModify: onModify,
                onDelete: onDelete,
                setIsSelectOpen: setIsSelectOpen
            })
        ]
    });
};



parcelRequire("7fPBF");

var $2e5adb90f0057f3a$exports = {};

$parcel$export($2e5adb90f0057f3a$exports, "button", function () { return $2e5adb90f0057f3a$export$2ba01fb71ed41cb6; }, function (v) { return $2e5adb90f0057f3a$export$2ba01fb71ed41cb6 = v; });
$parcel$export($2e5adb90f0057f3a$exports, "menuItem", function () { return $2e5adb90f0057f3a$export$c176f998e71d0f08; }, function (v) { return $2e5adb90f0057f3a$export$c176f998e71d0f08 = v; });
var $2e5adb90f0057f3a$export$2ba01fb71ed41cb6;
var $2e5adb90f0057f3a$export$c176f998e71d0f08;
$2e5adb90f0057f3a$export$2ba01fb71ed41cb6 = `J5MSfq_button`;
$2e5adb90f0057f3a$export$c176f998e71d0f08 = `J5MSfq_menuItem`;





const $adf60e83fdf52298$export$5a1ace86bf04e523 = ({ key: key, onClickCapture: onClickCapture })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e5adb90f0057f3a$exports))).menuItem,
        onClickCapture: onClickCapture,
        disableRipple: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2e5adb90f0057f3a$exports))).button,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).AddCircle
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        style: {
                            width: "6px"
                        }
                    }),
                    (0, $37bec70ed65ed924$export$21c51bc433c16634).new
                ]
            })
        })
    }, key);
};



parcelRequire("7fPBF");


var $2adee031ad5f423b$exports = {};

$parcel$export($2adee031ad5f423b$exports, "icon", function () { return $2adee031ad5f423b$export$1ca1ec8b29a4ce27; }, function (v) { return $2adee031ad5f423b$export$1ca1ec8b29a4ce27 = v; });
var $2adee031ad5f423b$export$1ca1ec8b29a4ce27;
$2adee031ad5f423b$export$1ca1ec8b29a4ce27 = `I5y-GW_icon`;



const $ef6de7d800c7479d$export$14d6f86788f3743d = ()=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        direction: "row",
        style: {
            color: theme.palette.primary.subtitle,
            minWidth: "150px"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2adee031ad5f423b$exports))).icon,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                style: {
                    width: "14px"
                }
            }),
            (0, $37bec70ed65ed924$export$21c51bc433c16634).none
        ]
    });
};



parcelRequire("7fPBF");

var $6d5856153c0c4075$exports = {};

$parcel$export($6d5856153c0c4075$exports, "badge", function () { return $6d5856153c0c4075$export$4aebd143f31d0c0d; }, function (v) { return $6d5856153c0c4075$export$4aebd143f31d0c0d = v; });
$parcel$export($6d5856153c0c4075$exports, "badgeDiv", function () { return $6d5856153c0c4075$export$99279871355d3ad7; }, function (v) { return $6d5856153c0c4075$export$99279871355d3ad7 = v; });
$parcel$export($6d5856153c0c4075$exports, "name", function () { return $6d5856153c0c4075$export$a8ff84c12d48cfa6; }, function (v) { return $6d5856153c0c4075$export$a8ff84c12d48cfa6 = v; });
var $6d5856153c0c4075$export$4aebd143f31d0c0d;
var $6d5856153c0c4075$export$99279871355d3ad7;
var $6d5856153c0c4075$export$a8ff84c12d48cfa6;
$6d5856153c0c4075$export$4aebd143f31d0c0d = `tPc7cG_badge`;
$6d5856153c0c4075$export$99279871355d3ad7 = `tPc7cG_badgeDiv`;
$6d5856153c0c4075$export$a8ff84c12d48cfa6 = `tPc7cG_name`;




const $479c1c21b8669633$export$2715fda2016e6502 = ({ name: name, index: index, onModify: onModify, onDelete: onDelete, setIsSelectOpen: setIsSelectOpen, value: value, ...props })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const { menuProps: menuProps, handleContextMenu: handleContextMenu, handleMenuClose: handleMenuClose } = (0, $b0dbf033e6a04143$export$2464060fb1e12fa6)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        ...props,
        value: value,
        onContextMenu: handleContextMenu,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d5856153c0c4075$exports))).badgeDiv,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $772e96a1af9615ac$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d5856153c0c4075$exports))).badge,
                            sx: {
                                bgcolor: theme.palette.background.default,
                                color: theme.palette.primary.main,
                                fontSize: "14px",
                                fontWeight: "bold"
                            },
                            children: index
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d5856153c0c4075$exports))).name,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3ee5a99ca4bff65$export$aeedd578fb406803), {
                menuProps: menuProps,
                handleMenuClose: handleMenuClose,
                onModify: onModify,
                onDelete: onDelete,
                setIsSelectOpen: setIsSelectOpen
            })
        ]
    });
};





const $e0f5f5a466f7eb4f$export$125afa75fbe1864c = ({ shelvings: shelvings, setShelvings: setShelvings, selectedAlbumIds: selectedAlbumIds, isLoading: isLoading, setIsLoading: setIsLoading, onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected, onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter, onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment, onSelectedShelving: onSelectedShelving, overrideShelving: overrideShelving, onShelfSegmentFetched: onShelfSegmentFetched })=>{
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { getShelving: getShelving } = (0, $effa6df78a1ddf8e$export$325b7b146b41f99)();
    const { deleteShelving: deleteShelving } = (0, $716f697f881fd6ce$export$db4c17fbbbc72d88)();
    const { deleteShelf: deleteShelf } = (0, $0f753857d80008b5$export$fe90b0b946cc38e9)();
    const { deleteShelfSegment: deleteShelfSegment } = (0, $ef5bb08c0e96ac23$export$bf14b19ed43f5184)();
    const [isLoadingShelving, setIsLoadingShelving] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [isAddShelvingDialogOpen, setIsAddShelvingDialogOpen] = (0, $7fPBF.useState)(false);
    const [isModifyShelvingDialogOpen, setIsModifyShelvingDialogOpen] = (0, $7fPBF.useState)(false);
    const [isModifyShelfDialogOpen, setIsModifyShelfDialogOpen] = (0, $7fPBF.useState)(false);
    const [isModifyShelfSegmentDialogOpen, setIsModifyShelfSegmentDialogOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteShelvingAlertOpen, setIsDeleteShelvingAlertOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteShelfAlertOpen, setIsDeleteShelfAlertOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteShelfSegmentAlertOpen, setIsDeleteShelfSegmentAlertOpen] = (0, $7fPBF.useState)(false);
    const [isAddShelfDialogOpen, setIsAddShelfDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAddShelfSegmentDialogOpen, setIsAddShelfSegmentDialogOpen] = (0, $7fPBF.useState)(false);
    const [selectedShelving, setSelectedShelving] = (0, $7fPBF.useState)();
    const [selectedShelf, setSelectedShelf] = (0, $7fPBF.useState)();
    const [selectedShelfSegment, setSelectedShelfSegment] = (0, $7fPBF.useState)();
    const [refreshSelects, setRefreshSelects] = (0, $7fPBF.useState)(false);
    const [isShelvingSelectOpen, setIsShelvingSelectOpen] = (0, $7fPBF.useState)(false);
    const [isShelfSelectOpen, setIsShelfSelectOpen] = (0, $7fPBF.useState)(false);
    const [isShelfSegmentSelectOpen, setIsShelfSegmentSelectOpen] = (0, $7fPBF.useState)(false);
    const [activeShelving, setActiveShelving] = (0, $7fPBF.useState)(null);
    const [activeShelf, setActiveShelf] = (0, $7fPBF.useState)(null);
    const [activeShelfSegment, setActiveShelfSegment] = (0, $7fPBF.useState)(null);
    const [zoom, setZoom] = (0, $7fPBF.useState)(0.5);
    (0, $7fPBF.useEffect)(()=>{
        if (!refreshSelects) return;
        setTimeout(()=>setRefreshSelects(false), 100);
    }, [
        refreshSelects
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (shelvings && shelvings.length > 0 && selectedShelving) {
            const newShelving = shelvings.filter((shelving)=>shelving.uuid == selectedShelving.uuid)[0];
            setSelectedShelving(newShelving);
            if (selectedShelf) {
                const newShelf = selectedShelving.shelves.filter((shelf)=>shelf.uuid == selectedShelf.uuid)[0];
                setSelectedShelf(newShelf);
                if (selectedShelfSegment) {
                    const newSegment = selectedShelf.segments.filter((segment)=>segment.uuid == selectedShelfSegment.uuid)[0];
                    setSelectedShelfSegment(newSegment);
                }
            }
        }
    }, [
        shelvings
    ]);
    (0, $7fPBF.useEffect)(()=>{
        onSelectedShelving(selectedShelving);
    }, [
        selectedShelving
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (overrideShelving && overrideShelving.shelves === undefined) getShelvingDetail(overrideShelving.uuid).then();
    }, [
        overrideShelving
    ]);
    const onShelvingUpdated = (newShelving)=>{
        if (shelvings.map((shelving)=>shelving.uuid).includes(newShelving.uuid)) setShelvings(shelvings.map((shelving)=>{
            if (shelving.uuid != newShelving.uuid) return shelving;
            newShelving.shelves = shelving.shelves;
            return newShelving;
        }));
        else setShelvings([
            ...shelvings,
            newShelving
        ]);
    };
    const onShelfUpdated = (newShelf)=>{
        if (selectedShelving?.shelves.map((shelf)=>shelf.uuid).includes(newShelf.uuid)) setShelvings(shelvings.map((auxShelving)=>{
            if (auxShelving.uuid == selectedShelving.uuid) auxShelving.shelves = auxShelving.shelves.map((auxShelf)=>{
                if (auxShelf.uuid != newShelf.uuid) return auxShelf;
                newShelf.segments = auxShelf.segments;
                return newShelf;
            });
            return auxShelving;
        }));
        else setShelvings(shelvings.map((auxShelving)=>{
            if (auxShelving.uuid == selectedShelving.uuid) auxShelving.shelves.push(newShelf);
            return auxShelving;
        }));
    };
    const onShelfSegmentUpdated = (shelf, newShelfSegment)=>{
        if (selectedShelf?.segments.map((segment)=>segment.uuid).includes(newShelfSegment.uuid)) setShelvings(shelvings.map((auxShelving)=>{
            if (auxShelving.uuid == selectedShelving.uuid) auxShelving.shelves = auxShelving.shelves.map((auxShelf)=>{
                if (auxShelf.uuid == shelf.uuid) auxShelf.segments = auxShelf.segments.map((segment)=>segment.uuid == newShelfSegment.uuid ? newShelfSegment : segment);
                return auxShelf;
            });
            return auxShelving;
        }));
        else setShelvings(shelvings.map((shelving)=>{
            if (shelving.uuid == selectedShelving.uuid) shelving.shelves = shelving.shelves.map((shelf)=>{
                if (shelf.uuid == selectedShelf.uuid) shelf.segments.push(newShelfSegment);
                return shelf;
            });
            return shelving;
        }));
    };
    const getShelvingDetail = async (uuid)=>{
        setIsLoading(true);
        setIsLoadingShelving(true);
        const { status: status, body: body } = await getShelving(uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            setShelvings(shelvings.map((shelving)=>shelving.uuid == body.uuid ? body : shelving));
            setSelectedShelving(body);
            setSelectedShelf(undefined);
            setSelectedShelfSegment(undefined);
            setRefreshSelects(true);
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
        setIsLoadingShelving(false);
    };
    const removeShelving = async (shelving)=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteShelving({
            uuid: shelving.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            if (selectedShelving.uuid === shelving.uuid) {
                setSelectedShelving(undefined);
                setSelectedShelf(undefined);
                setSelectedShelfSegment(undefined);
                setRefreshSelects(true);
            }
            setShelvings(shelvings.filter((auxShelving)=>auxShelving.uuid != shelving.uuid));
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    const removeShelf = async (shelf)=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteShelf({
            uuid: shelf.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setShelvings(shelvings.map((shelving)=>{
                if (shelving.uuid == selectedShelving.uuid) shelving.shelves = shelving.shelves.filter((auxShelf)=>auxShelf.uuid != shelf.uuid);
                return shelving;
            }));
            setSelectedShelf(undefined);
            setSelectedShelfSegment(undefined);
            setRefreshSelects(true);
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    const removeShelfSegment = async (shelf, shelfSegment)=>{
        setIsLoading(true);
        const { status: status, body: body } = await deleteShelfSegment({
            uuid: shelfSegment.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            setShelvings(shelvings.map((auxShelving)=>{
                if (auxShelving.uuid == selectedShelving.uuid) auxShelving.shelves.map((auxShelf)=>{
                    if (auxShelf.uuid == shelf.uuid) auxShelf.segments = auxShelf.segments.filter((segment)=>segment.uuid != shelfSegment.uuid);
                    return auxShelf;
                });
                return auxShelving;
            }));
            setSelectedShelfSegment(undefined);
            setRefreshSelects(true);
        } else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).mainContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbDiv,
                style: {
                    backgroundColor: theme.palette.background.default
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbStack,
                        direction: "row",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9d7afcdf99dc1f56$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumb,
                            separator: "\u2022",
                            children: [
                                !refreshSelects && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbElement,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        sx: {
                                            minWidth: "140px"
                                        },
                                        disabled: isLoading,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                size: "small",
                                                id: "shelving-label",
                                                sx: {
                                                    pointerEvents: "none"
                                                },
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                open: isShelvingSelectOpen,
                                                onOpen: ()=>setIsShelvingSelectOpen(true),
                                                onClose: ()=>setIsShelvingSelectOpen(false),
                                                size: "small",
                                                labelId: "shelving-label",
                                                value: selectedShelving?.uuid ?? "",
                                                label: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_title,
                                                renderValue: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbText,
                                                        children: selectedShelving?.name
                                                    }),
                                                onChange: async (event)=>{
                                                    const shelving = shelvings.filter((shelving)=>shelving.uuid == event.target.value)[0];
                                                    if (shelving?.shelves !== undefined) {
                                                        setSelectedShelf(undefined);
                                                        setSelectedShelfSegment(undefined);
                                                        setSelectedShelving(shelving);
                                                        setRefreshSelects(true);
                                                    } else if (shelving) await getShelvingDetail(shelving.uuid);
                                                    else {
                                                        setSelectedShelving(undefined);
                                                        setSelectedShelf(undefined);
                                                        setSelectedShelfSegment(undefined);
                                                        setRefreshSelects(true);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef6de7d800c7479d$export$14d6f86788f3743d), {})
                                                    }, "shelving_none"),
                                                    shelvings.map((shelving)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13b20287e63ba48a$export$270d034cfd22f4de), {
                                                            shelving: shelving,
                                                            onModify: ()=>{
                                                                setActiveShelving(shelving);
                                                                setIsModifyShelvingDialogOpen(true);
                                                            },
                                                            onDelete: ()=>{
                                                                setActiveShelving(shelving);
                                                                setIsDeleteShelvingAlertOpen(true);
                                                            },
                                                            setIsSelectOpen: setIsShelvingSelectOpen,
                                                            value: shelving.uuid
                                                        }, shelving.uuid)),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $adf60e83fdf52298$export$5a1ace86bf04e523), {
                                                        onClickCapture: (event)=>{
                                                            setIsAddShelvingDialogOpen(true);
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                        }
                                                    }, "shelving_new")
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                selectedShelving && !refreshSelects && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbElement,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        sx: {
                                            minWidth: "140px"
                                        },
                                        disabled: isLoading,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                size: "small",
                                                id: "shelf-label",
                                                sx: {
                                                    pointerEvents: "none"
                                                },
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                open: isShelfSelectOpen,
                                                onOpen: ()=>setIsShelfSelectOpen(true),
                                                onClose: ()=>setIsShelfSelectOpen(false),
                                                size: "small",
                                                labelId: "shelf-label",
                                                value: selectedShelf?.uuid ?? "",
                                                label: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_title,
                                                renderValue: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbText,
                                                        children: selectedShelf?.name
                                                    }),
                                                onChange: (event)=>{
                                                    const shelf = selectedShelving.shelves?.filter((shelf)=>shelf.uuid == event.target.value)[0];
                                                    setSelectedShelfSegment(undefined);
                                                    setSelectedShelf(shelf);
                                                    setRefreshSelects(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef6de7d800c7479d$export$14d6f86788f3743d), {})
                                                    }, "shelf_none"),
                                                    selectedShelving.shelves?.sort((a, b)=>a.order - b.order).map((shelf, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $479c1c21b8669633$export$2715fda2016e6502), {
                                                            name: shelf.name,
                                                            index: index + 1,
                                                            value: shelf.uuid,
                                                            setIsSelectOpen: setIsShelfSelectOpen,
                                                            onDelete: ()=>{
                                                                setActiveShelf(shelf);
                                                                setIsDeleteShelfAlertOpen(true);
                                                            },
                                                            onModify: ()=>{
                                                                setActiveShelf(shelf);
                                                                setIsModifyShelfDialogOpen(true);
                                                            }
                                                        }, shelf.uuid)),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $adf60e83fdf52298$export$5a1ace86bf04e523), {
                                                        onClickCapture: (event)=>{
                                                            setIsAddShelfDialogOpen(true);
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                        }
                                                    }, "shelf_new")
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                selectedShelf && !refreshSelects && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbElement,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        sx: {
                                            minWidth: "140px"
                                        },
                                        disabled: isLoading,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                size: "small",
                                                id: "shelf-segment-label",
                                                sx: {
                                                    pointerEvents: "none"
                                                },
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_title
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                open: isShelfSegmentSelectOpen,
                                                onOpen: ()=>setIsShelfSegmentSelectOpen(true),
                                                onClose: ()=>setIsShelfSegmentSelectOpen(false),
                                                size: "small",
                                                labelId: "shelf-segment-label",
                                                value: selectedShelfSegment?.uuid ?? "",
                                                label: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_title,
                                                renderValue: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).breadcrumbText,
                                                        children: selectedShelfSegment?.name
                                                    }),
                                                onChange: (event)=>{
                                                    const shelfSegment = selectedShelf.segments?.filter((shelfSegment)=>shelfSegment.uuid == event.target.value)[0];
                                                    setSelectedShelfSegment(shelfSegment);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef6de7d800c7479d$export$14d6f86788f3743d), {})
                                                    }, "segment_none"),
                                                    selectedShelf.segments?.sort((a, b)=>a.order - b.order).map((shelfSegment, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $479c1c21b8669633$export$2715fda2016e6502), {
                                                            name: shelfSegment.name,
                                                            index: index + 1,
                                                            value: shelfSegment.uuid,
                                                            setIsSelectOpen: setIsShelfSegmentSelectOpen,
                                                            onDelete: ()=>{
                                                                setActiveShelfSegment(shelfSegment);
                                                                setIsDeleteShelfSegmentAlertOpen(true);
                                                            },
                                                            onModify: ()=>{
                                                                setActiveShelfSegment(shelfSegment);
                                                                setActiveShelf(selectedShelf);
                                                                setIsModifyShelfSegmentDialogOpen(true);
                                                            }
                                                        }, shelfSegment.uuid)),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $adf60e83fdf52298$export$5a1ace86bf04e523), {
                                                        onClickCapture: (event)=>{
                                                            setIsAddShelfSegmentDialogOpen(true);
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                        }
                                                    }, "segment_new")
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    selectedShelving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).statsStack,
                        direction: "column",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).zoomSlider,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                    spacing: 1,
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                            type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ZoomIn
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f15ab21d190f284$export$2e2bcd8739ae039), {
                                            value: zoom,
                                            min: 0.23,
                                            max: 1.2,
                                            step: 0.01,
                                            onChange: (event, newValue)=>setZoom(newValue)
                                        })
                                    ]
                                })
                            }),
                            !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).tutorialText,
                                        style: {
                                            color: theme.palette.primary.subtitle
                                        },
                                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_tutorial
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0728e436d269bfa$export$c2aeb96f44648878), {
                                        shelving: selectedShelving,
                                        shelf: selectedShelf,
                                        shelfSegment: selectedShelfSegment
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isLoadingShelving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).loadingContainer,
                style: {
                    backgroundColor: theme.palette.background.default
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68214be7242cbfc8$export$2e2bcd8739ae039), {
                    in: true,
                    unmountOnExit: true,
                    style: {
                        transitionDelay: "2000ms"
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).loadingStack,
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).stats_loading
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).progressBar,
                                variant: "indeterminate"
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).shelvingContainer,
                style: {
                    backgroundColor: theme.palette.background.default
                },
                children: selectedShelving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).shelving,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fbf35e241e47f55$export$99c7b0e6011ce70a), {
                        shelving: selectedShelving,
                        shelvings: shelvings,
                        setShelvings: setShelvings,
                        selectedShelf: selectedShelf,
                        selectedShelfSegment: selectedShelfSegment,
                        selectedAlbumIds: selectedAlbumIds,
                        isLoading: isLoading,
                        setIsLoading: setIsLoading,
                        onShelfSegmentAlbumSelected: onShelfSegmentAlbumSelected,
                        onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment,
                        onShelfSegmentFetched: onShelfSegmentFetched,
                        shelvingIndex: shelvings.map((shelving)=>shelving.uuid).indexOf(selectedShelving.uuid),
                        zoom: zoom,
                        onModifyShelving: (shelving)=>{
                            setActiveShelving(shelving);
                            setIsModifyShelvingDialogOpen(true);
                        },
                        onModifyShelf: (shelf)=>{
                            setActiveShelf(shelf);
                            setIsModifyShelfDialogOpen(true);
                        },
                        onModifyShelfSegment: (shelf, shelfSegment)=>{
                            setActiveShelf(shelf);
                            setActiveShelfSegment(shelfSegment);
                            setIsModifyShelfSegmentDialogOpen(true);
                        },
                        onFocus: (shelf, segment)=>{
                            setSelectedShelf(shelf);
                            setSelectedShelfSegment(segment);
                        },
                        onAssignAlbumsToShelfSegmentByFilter: onAssignAlbumsToShelfSegmentByFilter,
                        isMinimalist: false
                    })
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ca45f5b19686e5fd$exports))).contentUnavailable,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $645e76f99719d34f$export$a665da17a0bb552f), {
                        isLoading: false,
                        items: selectedShelving ? undefined : [],
                        defaultVisible: true,
                        emptyIconType: (0, $c78153c289a31f2c$export$b5490b2533ba69dc)[(0, $bfb1968c11a59179$export$11b099a658b17995).SHELVINGS],
                        emptyTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_shelvings,
                        emptyDescription: (0, $37bec70ed65ed924$export$21c51bc433c16634).empty_shelvings_subtitle,
                        addButtonTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).add_attribute,
                        searchText: undefined,
                        onAddItem: ()=>setIsAddShelvingDialogOpen(true),
                        canAdd: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffe1d071b3002ed9$export$900bc4422ae4adda), {
                open: isAddShelvingDialogOpen,
                setOpen: setIsAddShelvingDialogOpen,
                callback: onShelvingUpdated
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffe1d071b3002ed9$export$900bc4422ae4adda), {
                open: isModifyShelvingDialogOpen,
                setOpen: setIsModifyShelvingDialogOpen,
                shelving: activeShelving,
                onDelete: ()=>setIsDeleteShelvingAlertOpen(true),
                callback: onShelvingUpdated
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85e6c9272a180c1d$export$b499bd8258f0d69a), {
                open: isAddShelfDialogOpen,
                setOpen: setIsAddShelfDialogOpen,
                callback: onShelfUpdated,
                shelving: selectedShelving
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85e6c9272a180c1d$export$b499bd8258f0d69a), {
                open: isModifyShelfDialogOpen,
                setOpen: setIsModifyShelfDialogOpen,
                shelving: selectedShelving,
                shelf: activeShelf,
                callback: onShelfUpdated,
                onDelete: ()=>setIsDeleteShelfAlertOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db16f7e95ded5f9c$export$16956de635798f40), {
                open: isAddShelfSegmentDialogOpen,
                setOpen: setIsAddShelfSegmentDialogOpen,
                callback: (shelfSegment)=>onShelfSegmentUpdated(selectedShelf, shelfSegment),
                shelf: selectedShelf
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db16f7e95ded5f9c$export$16956de635798f40), {
                open: isModifyShelfSegmentDialogOpen,
                setOpen: setIsModifyShelfSegmentDialogOpen,
                shelf: activeShelf,
                shelfSegment: activeShelfSegment,
                callback: (shelfSegment)=>onShelfSegmentUpdated(activeShelf, shelfSegment),
                onDelete: ()=>setIsDeleteShelfSegmentAlertOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelving_delete_confirmation, activeShelving?.name ?? ""),
                open: isDeleteShelvingAlertOpen,
                setOpen: setIsDeleteShelvingAlertOpen,
                onConfirm: async ()=>{
                    setIsModifyShelvingDialogOpen(false);
                    await removeShelving(activeShelving);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_delete_confirmation, activeShelf?.name ?? ""),
                open: isDeleteShelfAlertOpen,
                setOpen: setIsDeleteShelfAlertOpen,
                onConfirm: async ()=>{
                    setIsModifyShelfDialogOpen(false);
                    await removeShelf(activeShelf);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                isConfirm: true,
                message: (0, $4e580a0edacd4a22$export$f22e7fe56db8ae03)((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_delete_confirmation, activeShelfSegment?.name ?? "", activeShelf?.name ?? ""),
                open: isDeleteShelfSegmentAlertOpen,
                setOpen: setIsDeleteShelfSegmentAlertOpen,
                onConfirm: async ()=>{
                    setIsModifyShelfSegmentDialogOpen(false);
                    await removeShelfSegment(activeShelf, activeShelfSegment);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};




const $a9748a7c992a3fc2$export$b94535538a0d5515 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const addAlbumToShelfSegment = (parameters)=>post("shelfSegments/albums", parameters);
    return {
        addAlbumToShelfSegment: addAlbumToShelfSegment
    };
};










const $18c2aacb411c1095$export$3494c193c8b79bac = (setLoading)=>{
    const { get: get } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const getShelvings = (parameters)=>get("shelvings", parameters);
    return (0, $4a3a848c64aaaaed$export$45cdd786984d49e3)((0, $024c4fa431281881$export$bda6e9c83e7e0f97).shelvings(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), getShelvings, setLoading, (0, $a8465eea29ce6625$export$e95767ffe2e60cec).shelvingStorage, false, true, undefined);
};



const $8fb58283d600e24b$export$537894fa57d79d43 = ()=>{
    const { deleteRequest: deleteRequest } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const removeAlbumFromShelfSegment = (parameters)=>deleteRequest("shelfSegments/albums", parameters);
    return {
        removeAlbumFromShelfSegment: removeAlbumFromShelfSegment
    };
};



const $abec9cc589a98172$export$faeed4353c6a836 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const reorderShelfSegmentAlbums = (uuid, fromIndex, toIndex)=>{
        return post("shelfSegments/albums/reorder", {
            uuid: uuid,
            fromIndex: fromIndex,
            toIndex: toIndex
        });
    };
    return {
        reorderShelfSegmentAlbums: reorderShelfSegmentAlbums
    };
};





var $7fPBF = parcelRequire("7fPBF");
var $276540de167bfdcf$exports = {};

$parcel$export($276540de167bfdcf$exports, "bannedFields", function () { return $276540de167bfdcf$export$9c4f0dc9637ce11e; }, function (v) { return $276540de167bfdcf$export$9c4f0dc9637ce11e = v; });
$parcel$export($276540de167bfdcf$exports, "cancelButton", function () { return $276540de167bfdcf$export$4ededb8e5b56a6fb; }, function (v) { return $276540de167bfdcf$export$4ededb8e5b56a6fb = v; });
$parcel$export($276540de167bfdcf$exports, "descriptionCard", function () { return $276540de167bfdcf$export$ea3c9f9ac820b913; }, function (v) { return $276540de167bfdcf$export$ea3c9f9ac820b913 = v; });
$parcel$export($276540de167bfdcf$exports, "dropzone", function () { return $276540de167bfdcf$export$585d0a7a39ed94ea; }, function (v) { return $276540de167bfdcf$export$585d0a7a39ed94ea = v; });
$parcel$export($276540de167bfdcf$exports, "freeTextFields", function () { return $276540de167bfdcf$export$fc15afe0ee03b9c1; }, function (v) { return $276540de167bfdcf$export$fc15afe0ee03b9c1 = v; });
$parcel$export($276540de167bfdcf$exports, "loadingDiv", function () { return $276540de167bfdcf$export$dded2af20345efaa; }, function (v) { return $276540de167bfdcf$export$dded2af20345efaa = v; });
$parcel$export($276540de167bfdcf$exports, "selectDiscount", function () { return $276540de167bfdcf$export$1fab6054d6ffebee; }, function (v) { return $276540de167bfdcf$export$1fab6054d6ffebee = v; });
$parcel$export($276540de167bfdcf$exports, "subtitle", function () { return $276540de167bfdcf$export$c96745152eb2740f; }, function (v) { return $276540de167bfdcf$export$c96745152eb2740f = v; });
$parcel$export($276540de167bfdcf$exports, "textField", function () { return $276540de167bfdcf$export$c54b92c0bb02ba64; }, function (v) { return $276540de167bfdcf$export$c54b92c0bb02ba64 = v; });
$parcel$export($276540de167bfdcf$exports, "visibility", function () { return $276540de167bfdcf$export$91fa9ac3f4021ce4; }, function (v) { return $276540de167bfdcf$export$91fa9ac3f4021ce4 = v; });
var $276540de167bfdcf$export$9c4f0dc9637ce11e;
var $276540de167bfdcf$export$4ededb8e5b56a6fb;
var $276540de167bfdcf$export$ea3c9f9ac820b913;
var $276540de167bfdcf$export$585d0a7a39ed94ea;
var $276540de167bfdcf$export$fc15afe0ee03b9c1;
var $276540de167bfdcf$export$dded2af20345efaa;
var $276540de167bfdcf$export$1fab6054d6ffebee;
var $276540de167bfdcf$export$c96745152eb2740f;
var $276540de167bfdcf$export$c54b92c0bb02ba64;
var $276540de167bfdcf$export$91fa9ac3f4021ce4;
$276540de167bfdcf$export$9c4f0dc9637ce11e = `jGTpqW_bannedFields`;
$276540de167bfdcf$export$4ededb8e5b56a6fb = `jGTpqW_cancelButton`;
$276540de167bfdcf$export$ea3c9f9ac820b913 = `jGTpqW_descriptionCard`;
$276540de167bfdcf$export$585d0a7a39ed94ea = `jGTpqW_dropzone`;
$276540de167bfdcf$export$fc15afe0ee03b9c1 = `jGTpqW_freeTextFields`;
$276540de167bfdcf$export$dded2af20345efaa = `jGTpqW_loadingDiv`;
$276540de167bfdcf$export$1fab6054d6ffebee = `jGTpqW_selectDiscount`;
$276540de167bfdcf$export$c96745152eb2740f = `jGTpqW_subtitle`;
$276540de167bfdcf$export$c54b92c0bb02ba64 = `jGTpqW_textField`;
$276540de167bfdcf$export$91fa9ac3f4021ce4 = `jGTpqW_visibility`;




var $1ZNeQ = parcelRequire("1ZNeQ");








const $065b44f0f3179a57$export$e5aaff67b0f88e7f = ({ open: open, setOpen: setOpen, onSuccess: onSuccess })=>{
    const [isConfirmCloseAlertOpen, setIsConfirmCloseAlertOpen] = (0, $7fPBF.useState)(false);
    const tryToClose = ()=>{
        setIsConfirmCloseAlertOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            shape: "longPlay",
            removeFromPreviousLocations: false
        },
        enableReinitialize: true,
        validateOnBlur: false,
        validateOnChange: false,
        onSubmit: async ({ shape: shape, removeFromPreviousLocations: removeFromPreviousLocations })=>{
            handleClose();
            onSuccess(shape, removeFromPreviousLocations);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        formik.resetForm();
    }, [
        open
    ]);
    const handleShapeChange = (event, shape)=>{
        if (shape !== null) formik.setFieldValue("shape", shape);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ZNeQ.FormikProvider), {
        value: formik,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
                fullWidth: true,
                maxWidth: "sm",
                open: open,
                onClose: tryToClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_add_album_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                onClick: tryToClose,
                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        sx: {
                            paddingTop: 0,
                            paddingBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65d5f5d9a9fdc48c$export$8931f415e35c77f4), {
                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a5dc8884ed9bccb$export$2a72185d43821ea9), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($276540de167bfdcf$exports))).visibility,
                                labels: [
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_long_play,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_ten_inches,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_single,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_cd,
                                    (0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_segment_album_shape_box_set
                                ],
                                values: [
                                    "longPlay",
                                    "tenInches",
                                    "single",
                                    "compactDisc",
                                    "boxSet"
                                ],
                                value: formik.values.shape,
                                fullWidth: true,
                                disableGutters: true,
                                handleChange: handleShapeChange
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
                                sx: {
                                    width: "auto"
                                },
                                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                                    checked: formik.values.removeFromPreviousLocations,
                                    onChange: ()=>formik.setFieldValue("removeFromPreviousLocations", !formik.values.removeFromPreviousLocations)
                                }),
                                label: (0, $37bec70ed65ed924$export$21c51bc433c16634).layout_remove_from_all_segments
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c151e77ba8a9caa$export$c46226a4a6fbd741), {
                            type: "submit",
                            onClick: formik.handleSubmit,
                            children: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_confirm
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: (0, $37bec70ed65ed924$export$21c51bc433c16634).alert_cancel_confirmation,
                open: isConfirmCloseAlertOpen,
                setOpen: setIsConfirmCloseAlertOpen,
                isConfirm: true,
                onConfirm: handleClose,
                confirmTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).yes,
                cancelTitle: (0, $37bec70ed65ed924$export$21c51bc433c16634).no
            })
        ]
    });
};




const $1433858162e50b6a$export$a434829afe93c284 = ()=>{
    const { post: post } = (0, $5109476473fc2594$export$b9191a7363a9cdf8)();
    const assignAlbumsToShelfSegmentByFilter = (parameters, filterElements)=>{
        const filters = (0, $6768c4f2093234f5$export$8b8c5dbc2df0a942).queryItems(filterElements);
        if (!filters) return;
        return post("shelfSegments/albums/filter", {
            ...parameters,
            ...filters
        });
    };
    return {
        assignAlbumsToShelfSegmentByFilter: assignAlbumsToShelfSegmentByFilter
    };
};




var $7fPBF = parcelRequire("7fPBF");









const $f5cdd984a19e2fb3$export$7752361b4381293b = ({ open: open, setOpen: setOpen, album: album, callback: callback })=>{
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const [alertIsOpen, setAlertIsOpen] = (0, $7fPBF.useState)(false);
    const [myAlbum, setMyAlbum] = (0, $7fPBF.useState)(album);
    const { getAlbum: getAlbum } = (0, $3e1655feb131ddb8$export$9d3256d72c51d563)();
    const fetchAlbum = async ()=>{
        setIsLoading(true);
        const { status: status, body: body } = await getAlbum(album.uuid);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) setMyAlbum(body);
        else {
            setAlertMessage(body.message);
            setAlertIsOpen(true);
        }
        setIsLoading(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (open && album) {
            setMyAlbum(undefined);
            fetchAlbum().then();
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fdfba42518310a74$export$7e3fda4dbdd091fa), {
        fullWidth: true,
        maxWidth: "sm",
        open: open,
        onClose: ()=>setOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_layout
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                        loading: isLoading,
                        onClick: ()=>setOpen(false),
                        tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                        iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 0,
                    paddingBottom: 0
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b5e05a68d4a8dd18$export$51461c925a272d78), {
                    hideHeader: true,
                    album: myAlbum,
                    onBoxSetSelected: undefined,
                    onLocationSelected: (shelfSegmentAlbum)=>{
                        setOpen(false);
                        callback(shelfSegmentAlbum);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: alertIsOpen,
                setOpen: setAlertIsOpen
            })
        ]
    });
};



const $40428eec746e4aaf$export$c84671f46d6a1ca = ({ onPlayFromYouTube: onPlayFromYouTube })=>{
    const isMounted = (0, $09f494f72a25cae5$export$80c2a3957bcb42ea)();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const isScreenWide = (0, $e9acbcfc91ab58e9$export$94550b4bf4daa21a)();
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const isPiperiOSApp = (0, $e0f71d8009cff55c$export$5d9aa80f0e322840)();
    const [isDragging, setIsDragging] = (0, $7fPBF.useState)(false);
    const [isLoadingAlbums, setIsLoadingAlbums] = (0, $7fPBF.useState)(false);
    const [isLoadingShelvings, setIsLoadingShelvings] = (0, $7fPBF.useState)(false);
    const [highlightFilteredAlbums, setHighlightFilteredAlbums] = (0, $7fPBF.useState)(false);
    const [isAddAlbumsByFilterShapeDialogOpen, setIsAddAlbumsByFilterShapeDialogOpen] = (0, $7fPBF.useState)(false);
    const [isModifyShelfSegmentAlbumDialogOpen, setIsModifyShelfSegmentAlbumDialogOpen] = (0, $7fPBF.useState)(false);
    const [incomingAlbumId, setIncomingAlbumId] = (0, $7fPBF.useState)();
    const [incomingShelfSegmentId, setIncomingShelfSegmentId] = (0, $7fPBF.useState)();
    const [incomingIndex, setIncomingIndex] = (0, $7fPBF.useState)();
    const [shelvings, resetShelvings, setShelvings] = (0, $18c2aacb411c1095$export$3494c193c8b79bac)(setIsLoadingShelvings);
    const { addAlbumToShelfSegment: addAlbumToShelfSegment } = (0, $a9748a7c992a3fc2$export$b94535538a0d5515)();
    const { assignAlbumsToShelfSegmentByFilter: assignAlbumsToShelfSegmentByFilter } = (0, $1433858162e50b6a$export$a434829afe93c284)();
    const { removeAlbumFromShelfSegment: removeAlbumFromShelfSegment } = (0, $8fb58283d600e24b$export$537894fa57d79d43)();
    const { reorderShelfSegmentAlbums: reorderShelfSegmentAlbums } = (0, $abec9cc589a98172$export$faeed4353c6a836)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [currentUserProfile] = (0, $f3e21a44c8405b5b$export$c8308480b6dfe6db).useState();
    const [needMoreAllAlbums, setNeedMoreAllAlbums] = (0, $7fPBF.useState)(false);
    const { getCurrentFilterElements: getCurrentFilterElements, getCurrentIsNegated: getCurrentIsNegated, getCurrentFilterSortOption: getCurrentFilterSortOption, getCurrentFilterSortOrder: getCurrentFilterSortOrder, getFilterElementsWithSearchText: getFilterElementsWithSearchText, getSearchText: getSearchText } = (0, $228a7d38c61fd0fd$export$1fa08d0344d4319f)(true);
    const [, setCurrentLayoutFilterElements] = (0, $228a7d38c61fd0fd$export$8a1fe1ebdf138401).useState();
    const [filterElements, setFilterElements] = (0, $7fPBF.useState)(getCurrentFilterElements());
    const [, setCurrentLayoutIsNegated] = (0, $228a7d38c61fd0fd$export$97019f29ebdf2a0e).useState();
    const [isNegated, setIsNegated] = (0, $7fPBF.useState)(getCurrentIsNegated());
    const [, setCurrentLayoutFilterSortOption] = (0, $228a7d38c61fd0fd$export$4d06867b1d41e1a).useState();
    const [sortOption, setSortOption] = (0, $7fPBF.useState)(getCurrentFilterSortOption());
    const [, setCurrentLayoutFilterSortOrder] = (0, $228a7d38c61fd0fd$export$b6e481a7c7bbce9a).useState();
    const [sortOrder, setSortOrder] = (0, $7fPBF.useState)(getCurrentFilterSortOrder());
    const [isDrawerOpen, setIsDrawerOpen] = (0, $7fPBF.useState)(isScreenWide);
    const [isAlbumListDrawerOpen, setIsAlbumListDrawerOpen] = (0, $7fPBF.useState)(false);
    const [isOpenDiscogsImport, setIsOpenDiscogsImport] = (0, $7fPBF.useState)(false);
    const [isOpenExcelImport, setIsOpenExcelImport] = (0, $7fPBF.useState)(false);
    const [isAlbumsFilterDialogOpen, setIsAlbumsFilterDialogOpen] = (0, $7fPBF.useState)(false);
    const [isCollectionsDialogOpen, setIsCollectionsDialogOpen] = (0, $7fPBF.useState)(false);
    const [isSelectAlbumLocationDialogOpen, setIsSelectAlbumLocationDialogOpen] = (0, $7fPBF.useState)(false);
    const [selectedShelving, setSelectedShelving] = (0, $7fPBF.useState)();
    const [selectedAlbum, setSelectedAlbum] = (0, $7fPBF.useState)();
    const [currentPrivateCollection, setCurrentPrivateCollection] = (0, $6e65290b51df31d1$export$4e5a5cc2a3ddf055).useState();
    const [scrollToTopAlbumList, setScrollToTopAlbumList] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    let shouldResetSelectedShelving = false;
    (0, $7fPBF.useEffect)(()=>{
        document.title = `${(0, $37bec70ed65ed924$export$21c51bc433c16634).app_name} - ${(0, $37bec70ed65ed924$export$21c51bc433c16634).albums_title}`;
    }, []);
    const { defaultLayout: defaultLayout, onLayoutChanged: onLayoutChanged } = (0, $c48912b423983456$export$2bb3f65002f7b42d)({
        groupId: "layout-page",
        storage: localStorage
    });
    (0, $7fPBF.useEffect)(()=>{
        setFilterElements(getCurrentFilterElements());
        setIsNegated(getCurrentIsNegated());
        setSortOption(getCurrentFilterSortOption());
        setSortOrder(getCurrentFilterSortOrder());
    }, []);
    const onError = (body)=>{
        if (isMounted.current) {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
    };
    const onLoadingAlbums = (isLoading)=>{
        if (isMounted.current) setIsLoadingAlbums(isLoading);
    };
    const isFilterUnapplied = ()=>{
        return (!filterElements || filterElements.length == 0) && sortOption == (0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST && sortOrder == (0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT;
    };
    (0, $7fPBF.useEffect)(()=>{
        setCurrentLayoutFilterElements(filterElements);
    }, [
        filterElements
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setCurrentLayoutIsNegated(isNegated);
    }, [
        isNegated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setCurrentLayoutFilterSortOption(sortOption);
    }, [
        sortOption
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setCurrentLayoutFilterSortOrder(sortOrder);
    }, [
        sortOrder
    ]);
    const [albums, , resetAlbumsStorage, , , noMoreAlbums, isFetchingAlbums] = (0, $2738696e81957cce$export$93582110ed982a24)(true, "private", !isFilterUnapplied(), isNegated, (0, $024c4fa431281881$export$bda6e9c83e7e0f97).albums(currentUser?.role ?? (0, $bcf0b749eb2c1823$export$eb3485a690c2f0b8).common), onLoadingAlbums, onError, undefined, filterElements, sortOption, sortOrder, [
        needMoreAllAlbums
    ]);
    const resetAlbumStorage = ()=>{
        setScrollToTopAlbumList((state)=>!state);
        resetAlbumsStorage();
    };
    const setNeedMoreAlbums = ()=>{
        if (isMounted.current) setNeedMoreAllAlbums((state)=>!state);
    };
    const isThereNoMoreAlbums = ()=>{
        if (isMounted.current) return noMoreAlbums;
    };
    (0, $7fPBF.useEffect)(()=>{
        resetAlbumStorage();
        setNeedMoreAlbums();
    }, [
        isMobile,
        currentPrivateCollection,
        isNegated.collectionId
    ]);
    const goToUserProfile = ()=>{
        navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile());
    };
    const getAlbumIds = ()=>{
        if (!albums) return [];
        const ids = albums.map((section)=>section.map((album)=>album.uuid));
        return ids.flat(1);
    };
    const refreshAlbumsOrder = (shelvingIndex, shelfIndex, segmentIndex)=>{
        shelvings[shelvingIndex].shelves[shelfIndex].segments[segmentIndex].albums?.forEach((album, index)=>{
            album.order = index;
        });
    };
    const addAlbum = async (albumId, shelfSegmentId, shape, removeFromPreviousLocations, index)=>{
        const { status: status, body: body } = await addAlbumToShelfSegment({
            uuid: shelfSegmentId,
            albumId: albumId,
            shape: shape,
            order: index,
            removeFromPreviousLocations: removeFromPreviousLocations
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_album_added_message);
            return body;
        }
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isDuplicatedResource(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).warning((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_album_duplicate_error);
            return false;
        }
        setAlertMessage(body.message);
        setIsAlertOpen(true);
        return false;
    };
    const addAlbumsByFilter = async (shelfSegmentId, shape, removeFromPreviousLocations, index)=>{
        const { status: status, body: body } = await assignAlbumsToShelfSegmentByFilter({
            assignToShelfSegmentId: shelfSegmentId,
            shape: shape,
            removeFromPreviousLocations: removeFromPreviousLocations,
            order: index,
            collectionId: currentPrivateCollection?.uuid,
            isNegated: isNegated
        }, filterElements);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            return body;
        }
        setAlertMessage(body.message);
        setIsAlertOpen(true);
        return false;
    };
    const removeAlbum = async (albumId, shelfSegmentId)=>{
        const { status: status, body: body } = await removeAlbumFromShelfSegment({
            uuid: shelfSegmentId,
            albumId: albumId
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).shelf_album_removed_message);
            return true;
        }
        setAlertMessage(body.message);
        setIsAlertOpen(true);
        return false;
    };
    const reorderAlbums = async (shelfSegmentId, fromIndex, toIndex)=>{
        const { status: status, body: body } = await reorderShelfSegmentAlbums(shelfSegmentId, fromIndex, toIndex);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
            return true;
        }
        setAlertMessage(body.message);
        setIsAlertOpen(true);
        return false;
    };
    const moveAlbum = async (sourceSegmentId, destinationSegmentId, albumId, sourceIndex, destinationIndex, sourceShelvingIndex, sourceShelfIndex, sourceSegmentIndex, destinationShelvingIndex, destinationShelfIndex, destinationSegmentIndex)=>{
        if (sourceShelvingIndex == destinationShelvingIndex && sourceShelfIndex == destinationShelfIndex && sourceSegmentIndex == destinationSegmentIndex && sourceIndex == destinationIndex) return;
        const album = shelvings[sourceShelvingIndex].shelves[sourceShelfIndex].segments[sourceSegmentIndex].albums[sourceIndex];
        if (sourceSegmentId != destinationSegmentId) {
            shelvings[sourceShelvingIndex].shelves[sourceShelfIndex].segments[sourceSegmentIndex].albums.splice(sourceIndex, 1);
            shelvings[destinationShelvingIndex].shelves[destinationShelfIndex].segments[destinationSegmentIndex].albums.splice(destinationIndex, 0, album);
            refreshAlbumsOrder(destinationShelvingIndex, destinationShelfIndex, destinationSegmentIndex);
            let removalSuccess;
            const addSuccess = await addAlbum(albumId, destinationSegmentId, album.shape, false, destinationIndex);
            if (addSuccess) removalSuccess = await removeAlbum(albumId, sourceSegmentId);
            if (!addSuccess || !removalSuccess) {
                shelvings[sourceShelvingIndex].shelves[sourceShelfIndex].segments[sourceSegmentIndex].albums.splice(sourceIndex, 0, album);
                shelvings[destinationShelvingIndex].shelves[destinationShelfIndex].segments[destinationSegmentIndex].albums.splice(destinationIndex, 1);
                refreshAlbumsOrder(sourceShelvingIndex, sourceShelfIndex, sourceSegmentIndex);
            }
        } else {
            (0, $3c32b049e9065866$export$79f3cf326dbd2413)(shelvings[sourceShelvingIndex].shelves[sourceShelfIndex].segments[sourceSegmentIndex].albums, sourceIndex, destinationIndex);
            refreshAlbumsOrder(sourceShelvingIndex, sourceShelfIndex, sourceSegmentIndex);
            const reorderSuccess = await reorderAlbums(sourceSegmentId, sourceIndex, destinationIndex);
            if (!reorderSuccess) {
                (0, $3c32b049e9065866$export$79f3cf326dbd2413)(shelvings[sourceShelvingIndex].shelves[sourceShelfIndex].segments[sourceSegmentIndex].albums, destinationIndex, sourceIndex);
                refreshAlbumsOrder(sourceShelvingIndex, sourceShelfIndex, sourceSegmentIndex);
            }
        }
    };
    const saveNewSegment = (newSegment)=>{
        setShelvings(shelvings.map((shelving)=>{
            if (shelving.uuid == selectedShelving.uuid) shelving.shelves = shelving.shelves.map((shelf)=>{
                shelf.segments = shelf.segments.map((segment)=>segment.uuid == newSegment.uuid ? newSegment : segment);
                return shelf;
            });
            return shelving;
        }));
    };
    const onDragEnd = async (result)=>{
        setIsDragging(false);
        const destinationSplit = result.destination?.droppableId.split("_");
        if (!result.destination || destinationSplit[0] != "shelf") return;
        const split = result.draggableId.split("_");
        if (split[0] == "drag") {
            setIsLoadingShelvings(true);
            await moveAlbum(split[1], destinationSplit[1], split[2], result.source.index, result.destination.index, +split[3], +split[4], +split[5], +destinationSplit[2], +destinationSplit[3], +destinationSplit[4]);
            setIsLoadingShelvings(false);
        } else {
            const section = +split[0];
            const album = albums[section][result.source.index];
            setIncomingAlbumId(album.uuid);
            setIncomingShelfSegmentId(destinationSplit[1]);
            setIncomingIndex(result.destination.index);
            setIsModifyShelfSegmentAlbumDialogOpen(true);
        }
    };
    const onShelfSegmentFetched = async (shelfSegment, shelvingIndex, shelfIndex, shelfSegmentIndex)=>{
        setIsLoadingShelvings(true);
        shelvings[shelvingIndex].shelves[shelfIndex].segments[shelfSegmentIndex] = shelfSegment;
        // To reload stats
        setTimeout(()=>{
            setIsLoadingShelvings(false);
        }, 0);
    };
    const onRemoveAlbumFromShelfSegment = async (shelfSegmentAlbum, shelvingIndex, shelfIndex, shelfSegmentIndex, albumIndex)=>{
        const shelfSegment = shelvings[shelvingIndex].shelves[shelfIndex].segments[shelfSegmentIndex];
        if (!shelfSegment) return;
        setIsLoadingShelvings(true);
        const { status: status, body: body } = await removeAlbumFromShelfSegment({
            uuid: shelfSegment.uuid,
            albumId: shelfSegmentAlbum.album.uuid
        });
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) {
            shelvings[shelvingIndex].shelves[shelfIndex].segments[shelfSegmentIndex].albums?.splice(albumIndex, 1);
            refreshAlbumsOrder(shelvingIndex, shelfIndex, shelfSegmentIndex);
            (0, $040541d7bfcee3b2$export$b410431fab84fa58).success((0, $37bec70ed65ed924$export$21c51bc433c16634).generic_update_success);
        } else {
            setAlertMessage(body.message);
            setIsAlertOpen(true);
        }
        setIsLoadingShelvings(false);
    };
    const onOpenInLayout = async (album)=>{
        setSelectedAlbum(album);
        setIsSelectAlbumLocationDialogOpen(true);
    };
    const albumList = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf9b4cecdde85ae$export$ea09568aab55509f), {
            dragDropId: "main",
            isPublic: false,
            albums: albums,
            selectedAlbumId: selectedAlbum?.uuid,
            sortOption: sortOption,
            canMoveAlbums: !isLoadingAlbums && !isLoadingShelvings,
            canDropAlbums: false,
            canLoadMoreAlbums: !isDragging,
            setNeedMoreAlbums: setNeedMoreAlbums,
            onAlbumSelected: (album)=>{
                setIsAlbumListDrawerOpen(false);
                if (selectedAlbum?.uuid != album.uuid) setSelectedAlbum(album);
                else setSelectedAlbum(undefined);
            },
            noMoreAlbums: isThereNoMoreAlbums(),
            albumCount: undefined,
            onImportFromDiscogs: ()=>setIsOpenDiscogsImport(true),
            onImportFromExcel: ()=>setIsOpenExcelImport(true),
            onFilterAlbums: ()=>setIsAlbumsFilterDialogOpen(true),
            onChangeCollection: ()=>setIsCollectionsDialogOpen(true),
            onEditProfile: goToUserProfile,
            onPlayFromYouTube: onPlayFromYouTube,
            scrollToTopTrigger: scrollToTopAlbumList,
            isForLayout: true,
            shelving: selectedShelving,
            onOpenInLayout: onOpenInLayout,
            setLoading: setIsLoadingAlbums
        });
    const toolbarButtons = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
            direction: "row",
            style: {
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                    style: {
                        marginLeft: isMobile ? 0 : undefined,
                        marginRight: isMobile ? 0 : undefined,
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                            onClick: ()=>{
                                if (isLoadingAlbums) return;
                                resetAlbumStorage();
                                setNeedMoreAlbums();
                            },
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).refresh_list,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Refresh,
                            disabled: isFetchingAlbums
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                            orientation: "vertical",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3703c5b066166561$export$c41a54ed40f40346), {
                            onClick: ()=>setIsAlbumsFilterDialogOpen(true),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).option_filter_albums,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAlt,
                            highlighted: !isFilterUnapplied(),
                            disabled: isFetchingAlbums
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d2b2774d90ce7db$export$79d13b60110f33be), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).searchBar,
                    onSearchRequested: (searchText)=>{
                        setFilterElements(getFilterElementsWithSearchText(searchText, filterElements));
                        resetAlbumStorage();
                        setNeedMoreAlbums();
                    },
                    onSearchDismissed: ()=>{
                        setFilterElements(getFilterElementsWithSearchText("", filterElements));
                        resetAlbumStorage();
                        setNeedMoreAlbums();
                    },
                    timed: true,
                    onLoading: onLoadingAlbums,
                    forceThisText: getSearchText(filterElements),
                    disabled: isFetchingAlbums
                })
            ]
        });
    (0, $7fPBF.useEffect)(()=>{
        if (shelvings.length == 0) {
            shouldResetSelectedShelving = true;
            return;
        }
        if (selectedShelving && shouldResetSelectedShelving) {
            shouldResetSelectedShelving = false;
            const shelving = shelvings.filter((shelving)=>shelving.uuid == selectedShelving.uuid)[0];
            setSelectedShelving(shelving);
        }
    }, [
        shelvings
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9f0628080e21c26d$export$5c0547b091a4b556), {
        showingPersistentDrawer: isScreenWide && isDrawerOpen,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "sticky",
                sx: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.colors?.appBar
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).toolbar,
                    disableGutters: true,
                    children: [
                        !isPiperiOSApp && (!isScreenWide || !isDrawerOpen) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5933a8e70bcb89c0$export$9b061f1a40109870), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).piperLogo,
                            onClick: ()=>{
                                setIsDrawerOpen(true);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5cc58bd0a3c6b57$export$b04af7126011511f), {
                            currentPage: "layout",
                            isOpen: isDrawerOpen,
                            setIsOpen: setIsDrawerOpen,
                            isLayout: true,
                            isOpenDiscogsImport: isOpenDiscogsImport,
                            setIsOpenDiscogsImport: setIsOpenDiscogsImport,
                            isOpenExcelImport: isOpenExcelImport,
                            setIsOpenExcelImport: setIsOpenExcelImport
                        }),
                        isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            onClick: ()=>setIsAlbumListDrawerOpen(true),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_albums_list,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ListAlt
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a57daef9e4523bb5$export$722e774c4f28559d), {
                            style: {
                                marginLeft: isMobile ? 0 : 8
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                sx: {
                                    maxHeight: 36
                                },
                                onClick: ()=>setIsCollectionsDialogOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        sx: {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).collectionTitle,
                                            children: currentPrivateCollection ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).collectionTitleText,
                                                children: [
                                                    isNegated.collectionId && currentPrivateCollection.uuid && `(${(0, $37bec70ed65ed924$export$21c51bc433c16634).not_in}) `,
                                                    currentPrivateCollection.name
                                                ]
                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).collectionTitleText,
                                                children: (0, $37bec70ed65ed924$export$21c51bc433c16634).collection_all_albums
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).expandIcon,
                                        type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).ExpandAll
                                    })
                                ]
                            })
                        }),
                        !isMobile && toolbarButtons(),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            style: {
                                marginLeft: isMobile ? 0 : undefined,
                                marginRight: isMobile ? 0 : undefined
                            },
                            onClick: ()=>{
                                setSortOption((0, $6768c4f2093234f5$export$269d0e320e5ce63c).ARTIST);
                                setSortOrder((0, $6768c4f2093234f5$export$145a24076dc97919).ASCENDANT);
                                setFilterElements([]);
                                resetAlbumStorage();
                                setNeedMoreAlbums();
                            },
                            disabled: isFilterUnapplied() || isLoadingAlbums,
                            loading: isLoadingAlbums || isLoadingShelvings,
                            tooltip: isLoadingAlbums || isLoadingShelvings ? "" : (0, $37bec70ed65ed924$export$21c51bc433c16634).clear_filter,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).FilterAltOff,
                            color: theme.palette.colors?.remove
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            style: {
                                marginLeft: isMobile ? undefined : 0
                            },
                            onClick: ()=>setHighlightFilteredAlbums((state)=>!state),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).highlight_filtered_albums,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Flare,
                            highlighted: highlightFilteredAlbums
                        }),
                        selectedAlbum && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                            style: {
                                marginLeft: 0
                            },
                            onClick: ()=>onOpenInLayout(selectedAlbum),
                            tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).open_on_layout,
                            iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Shelves
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            flexGrow: 1
                        }),
                        !isPiperiOSApp && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $921bd0ad6d18d264$export$7bf40cd2a197df2d), {
                            isPublic: false,
                            userProfile: currentUserProfile,
                            onClick: ()=>{
                                if (!currentUserProfile || currentUser?.role == "guest") return;
                                goToUserProfile();
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e69fa77bf557686c$export$237bd83162c14364), {
                onBeforeCapture: ()=>setIsAlbumListDrawerOpen(false),
                onDragStart: ()=>setIsDragging(true),
                onDragEnd: onDragEnd,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$eb2fcfdbd7ba97d4), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).mainBody,
                        defaultLayout: defaultLayout,
                        onLayoutChanged: onLayoutChanged,
                        orientation: "horizontal",
                        children: [
                            !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                id: "left",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).albumListContainer,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                minSize: "6",
                                defaultSize: "28",
                                maxSize: "40",
                                children: albumList()
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c48912b423983456$export$1ff3c3f08ae963c0), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).resizeHandle,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: !isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16e698ac2bde8f17$export$f04a61298a47a40f), {
                                    type: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).DragIndicator,
                                    style: {
                                        alignSelf: "center",
                                        color: theme.palette.secondary.main,
                                        fontSize: 14
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c48912b423983456$export$2ddb90ad54e5f587), {
                                id: "right",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).layoutDetail,
                                style: {
                                    backgroundColor: theme.palette.background.default
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0f5f5a466f7eb4f$export$125afa75fbe1864c), {
                                        shelvings: shelvings,
                                        setShelvings: setShelvings,
                                        selectedAlbumIds: highlightFilteredAlbums ? [
                                            selectedAlbum?.uuid,
                                            ...getAlbumIds()
                                        ] : [
                                            selectedAlbum?.uuid
                                        ],
                                        isLoading: isLoadingShelvings,
                                        setIsLoading: setIsLoadingShelvings,
                                        onShelfSegmentAlbumSelected: (shelfSegmentAlbum)=>setSelectedAlbum(shelfSegmentAlbum?.album),
                                        onAssignAlbumsToShelfSegmentByFilter: (shelfSegment)=>{
                                            setIncomingShelfSegmentId(shelfSegment.uuid);
                                            setIncomingIndex(shelfSegment.albums?.length ?? 0);
                                            setIsAddAlbumsByFilterShapeDialogOpen(true);
                                        },
                                        onRemoveAlbumFromShelfSegment: onRemoveAlbumFromShelfSegment,
                                        onShelfSegmentFetched: onShelfSegmentFetched,
                                        onSelectedShelving: setSelectedShelving,
                                        overrideShelving: selectedShelving
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $068306612f3a60ef$export$f8654fb7542a0d8a), {})
                                ]
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a2822b215697a959$export$2e2bcd8739ae039), {
                        PaperProps: {
                            sx: {
                                backgroundColor: theme.palette.background.default
                            }
                        },
                        ModalProps: {
                            keepMounted: true
                        },
                        anchor: "left",
                        open: isAlbumListDrawerOpen,
                        onOpen: ()=>setIsAlbumListDrawerOpen(true),
                        onClose: ()=>setIsAlbumListDrawerOpen(false),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                width: "80vw",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                                    position: "sticky",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($84eab21e3cd425e3$exports))).toolbar,
                                        disableGutters: true,
                                        children: [
                                            toolbarButtons(),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                                flexGrow: 1
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0c3d96fa46bd11$export$e5c1a33878e86e9e), {
                                                style: {
                                                    marginLeft: isMobile ? 0 : undefined,
                                                    marginRight: isMobile ? 0 : undefined
                                                },
                                                loading: isLoadingAlbums,
                                                onClick: ()=>setIsAlbumListDrawerOpen(false),
                                                tooltip: (0, $37bec70ed65ed924$export$21c51bc433c16634).close,
                                                iconType: (0, $d46459dc9cce808d$export$13ff1290a9e22e77).Close
                                            })
                                        ]
                                    })
                                }),
                                albumList()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d770713ca8a8afe1$export$1737516aa6af7a33), {
                isPublic: false,
                isOpen: isAlbumsFilterDialogOpen,
                setIsOpen: setIsAlbumsFilterDialogOpen,
                initialFilterElements: filterElements,
                initialIsNegated: isNegated,
                initialSortOption: sortOption,
                initialSortOrder: sortOrder,
                onFilterApplied: (filterElements, isNegated, sortOption, sortOrder)=>{
                    setIsNegated(isNegated);
                    setSortOption(sortOption);
                    setSortOrder(sortOrder);
                    setFilterElements(filterElements);
                    resetAlbumStorage();
                    setNeedMoreAlbums();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b46d41cd3bcf7a1c$export$775ce5395441d9c3), {
                open: isCollectionsDialogOpen,
                setOpen: setIsCollectionsDialogOpen,
                isLayout: true,
                canModifyCollections: false,
                displayStandardCollections: true,
                onCollectionSelected: (collection, isNegated)=>{
                    setCurrentPrivateCollection(collection);
                    setIsNegated(isNegated);
                    setSelectedAlbum(undefined);
                    setIsAlbumListDrawerOpen(true);
                },
                selectedCollections: [
                    currentPrivateCollection?.uuid
                ],
                forceLoading: isLoadingAlbums,
                canNegate: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $065b44f0f3179a57$export$e5aaff67b0f88e7f), {
                open: isModifyShelfSegmentAlbumDialogOpen,
                setOpen: setIsModifyShelfSegmentAlbumDialogOpen,
                onSuccess: async (shape, removeFromPreviousLocations)=>{
                    setIsLoadingShelvings(true);
                    const newSegment = await addAlbum(incomingAlbumId, incomingShelfSegmentId, shape, removeFromPreviousLocations, incomingIndex);
                    if (removeFromPreviousLocations) resetShelvings();
                    else if (newSegment) saveNewSegment(newSegment);
                    setIsLoadingShelvings(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $065b44f0f3179a57$export$e5aaff67b0f88e7f), {
                open: isAddAlbumsByFilterShapeDialogOpen,
                setOpen: setIsAddAlbumsByFilterShapeDialogOpen,
                onSuccess: async (shape, removeFromPreviousLocations)=>{
                    setIsLoadingShelvings(true);
                    const newSegment = await addAlbumsByFilter(incomingShelfSegmentId, shape, removeFromPreviousLocations, incomingIndex);
                    if (removeFromPreviousLocations) resetShelvings();
                    else if (newSegment) saveNewSegment(newSegment);
                    setIsLoadingShelvings(false);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5cdd984a19e2fb3$export$7752361b4381293b), {
                open: isSelectAlbumLocationDialogOpen,
                setOpen: setIsSelectAlbumLocationDialogOpen,
                album: selectedAlbum,
                callback: (shelfSegmentAlbum)=>{
                    setSelectedShelving(shelfSegmentAlbum.shelfSegment.shelf.shelving);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen
            })
        ]
    });
};


const $640a8cbd15069f0d$export$faad8b178f68f912 = ({ onPlayFromYouTube: onPlayFromYouTube })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40428eec746e4aaf$export$c84671f46d6a1ca), {
        onPlayFromYouTube: onPlayFromYouTube
    });
};





parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $472c032b90d3b29b$exports = {};

$parcel$export($472c032b90d3b29b$exports, "backdrop", function () { return $472c032b90d3b29b$export$48e901322468f6d5; }, function (v) { return $472c032b90d3b29b$export$48e901322468f6d5 = v; });
var $472c032b90d3b29b$export$48e901322468f6d5;
$472c032b90d3b29b$export$48e901322468f6d5 = `CGSclG_backdrop`;












const $a0e29c1ae1488448$export$4e70b07ca9d3789a = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name;
    }, []);
    const navigate = (0, $d42da6e692e216cc$export$9770f232ac06a008)();
    const grantPatreonAccess = (0, $50450f5c634debf0$export$8c1ee1956d7f855f)();
    const [isSignInAgainDialogOpen, setIsSignInAgainDialogOpen] = (0, $7fPBF.useState)(false);
    const [isAlertOpen, setIsAlertOpen] = (0, $7fPBF.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $7fPBF.useState)("");
    const { openInSameTab: openInSameTab } = (0, $00bb9c939a9b16c4$export$44e38f87d0f6eb89)();
    const processAuth = ()=>{
        const queryParams = (0, $8cc3d14fcf9888ac$export$2e2bcd8739ae039).parse(location.search);
        const code = queryParams.code;
        if (typeof code != "string") navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home());
        else processAuthFromPatreon(code).then();
    };
    (0, $7fPBF.useEffect)(()=>{
        processAuth();
    }, []);
    const processAuthFromPatreon = async (code)=>{
        const { status: status, body: body } = await grantPatreonAccess(code);
        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) openInSameTab("https://patreon.com/Piper107?utm_medium=piper&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink");
        else if (status == (0, $74d09775b34cce5b$export$efd5569f873811b1).FORBIDDEN) setIsSignInAgainDialogOpen(true);
        else setAlertMessage(body.message);
        setIsAlertOpen(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($472c032b90d3b29b$exports))).backdrop,
        open: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd361f89d7477c83$export$9fdd0c2f06d5e539), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92691db20f9c9ecc$export$846b26828376608), {
                isOpen: isSignInAgainDialogOpen,
                setIsOpen: setIsSignInAgainDialogOpen,
                closeOnTouch: false,
                loginCallback: async ()=>{
                    setIsSignInAgainDialogOpen(false);
                    processAuth();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a4c57566cf3307e$export$de466dd8317b0b75), {
                title: (0, $37bec70ed65ed924$export$21c51bc433c16634).app_name,
                message: alertMessage,
                open: isAlertOpen,
                setOpen: setIsAlertOpen,
                onConfirm: ()=>navigate((0, $5ac8335867650de3$export$12d836cf94aabb97).home())
            })
        ]
    });
};


const $6780d50f8a8e5518$export$66de6c14ed6a3314 = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0e29c1ae1488448$export$4e70b07ca9d3789a), {});
};







const $6921d10a59af4a10$export$3565eb3d00ca5a74 = ()=>{
    const isMobile = (0, $e0f71d8009cff55c$export$2b96349243a56116)();
    const { getToken: getToken } = (0, $f3e21a44c8405b5b$export$5220458fb0348f0)();
    const { savePushNotificationToken: savePushNotificationToken } = (0, $7fa32b64e6b5070b$export$341bb000d9d866bb)();
    const [currentUser] = (0, $f3e21a44c8405b5b$export$23bbbc4533528f03).useState();
    const [videoIds, setVideoIds] = (0, $7fPBF.useState)();
    const [playerTitle, setPlayerTitle] = (0, $7fPBF.useState)("");
    const [isPlayerOpen, setIsPlayerOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const icons = Object.values((0, $d46459dc9cce808d$export$13ff1290a9e22e77));
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block&icon_names=${icons.sort().join(",")}`;
        link.onload = ()=>document.documentElement.classList.add("icons-ready");
        document.head.appendChild(link);
    }, []);
    if ((0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.messaging) (0, $5f3bee57d2d66924$export$7275a8dcb77dc20d)((0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.messaging, (payload)=>{
        (0, $040541d7bfcee3b2$export$b410431fab84fa58)(payload.notification?.body);
    });
    const language = (0, $0a3e798b1875b36f$export$f29ae926b020bfea).getLanguage();
    if (language) (0, $37bec70ed65ed924$export$21c51bc433c16634).setLanguage(language);
    if (!window.location.pathname.includes((0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()) && !window.location.pathname.includes((0, $5ac8335867650de3$export$12d836cf94aabb97).signIn()) && !window.location.pathname.includes((0, $5ac8335867650de3$export$12d836cf94aabb97).maintenance()) && !window.location.pathname.includes((0, $5ac8335867650de3$export$12d836cf94aabb97).notFound())) {
        const token = getToken();
        if (!token) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $616fd80ec2a913ff$export$dad1da3cda010137), {
            isMinimalist: false
        });
        else (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.getFCMToken((fcmToken)=>{
            if (fcmToken) {
                if (currentUser?.role != "guest") {
                    const cachedToken = localStorage.getItem("fcm_token") ?? "";
                    if (cachedToken != fcmToken) window.navigator.mediaDevices.enumerateDevices().then(async (devices)=>{
                        const { status: status } = await savePushNotificationToken({
                            token: fcmToken,
                            deviceId: devices[0].deviceId
                        });
                        if ((0, $669f05caedcc95b9$export$d0fb02d81f923119).isSuccessful(status)) localStorage.setItem("fcm_token", fcmToken);
                    });
                }
            } else if (!isMobile) (0, $040541d7bfcee3b2$export$b410431fab84fa58)((0, $37bec70ed65ed924$export$21c51bc433c16634).push_notifications_permission_notice, {
                autoClose: false,
                onClick: (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.requestPermission,
                onClose: (0, $c29a9b87accbd89a$export$447fa9cb0c946c58).shared.requestPermission,
                toastId: "firebase-messaging",
                closeOnClick: true,
                delay: 50000
            });
        });
    }
    const onPlayFromYouTube = (title, videoIds)=>{
        setPlayerTitle(title);
        setVideoIds(videoIds);
        setIsPlayerOpen(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d42da6e692e216cc$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).home(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc9cae3c17fe3491$export$5cc8a80f4112c6ed), {
                            isPublic: false,
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).guest(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc9cae3c17fe3491$export$5cc8a80f4112c6ed), {
                            isPublic: false,
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).signIn(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $616fd80ec2a913ff$export$dad1da3cda010137), {
                            isMinimalist: false
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).albums.list(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc9cae3c17fe3491$export$5cc8a80f4112c6ed), {
                            isPublic: false,
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).attributes.manage(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a676f2de7f666b38$export$e4f5f4286439c585), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).userProfile(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48ca686d6b2bc40d$export$6c97a8e1fd3bfb81), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).stats(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86417dc904115e52$export$513164e01b946703), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).marketplace(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3dbe2788dd4c1d0$export$9ed7a22cbadcc4c8), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).layout(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $640a8cbd15069f0d$export$faad8b178f68f912), {
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).admin(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f1e5139cf9a6f5e$export$7788d4c00e438b6e), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).share(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc9cae3c17fe3491$export$5cc8a80f4112c6ed), {
                            isPublic: true,
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }, "public_albums"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).private(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc9cae3c17fe3491$export$5cc8a80f4112c6ed), {
                            isPublic: false,
                            onPlayFromYouTube: onPlayFromYouTube
                        })
                    }, "private_albums"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).payment(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47b6cfa39ea1f323$export$cf5a111a9e94a929), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).paymentPatreon(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6780d50f8a8e5518$export$66de6c14ed6a3314), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: `${(0, $5ac8335867650de3$export$12d836cf94aabb97).documentation.home()}/*`,
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11ee0d67da937970$export$e7e6be814875dfe1), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: (0, $5ac8335867650de3$export$12d836cf94aabb97).maintenance(),
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7b47dee627cb75dc$export$38a43a98ba521d42), {})
                    }, "maintenance"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bedca6cde600b0a$export$6ba01d3268a66fe8), {})
                    }, "not_found")
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e37a2cf7859d130a$export$ae716c5c5ead198b), {
                title: playerTitle,
                videoIds: videoIds,
                open: isPlayerOpen,
                setOpen: setIsPlayerOpen
            })
        ]
    });
};




parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;






'use client';
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4df9e939738a7402$export$971d5caa766a69d7).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;




'use client';
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $e35ef6915a224202$export$2e2bcd8739ae039];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        themeId: scopedTheme ? (0, $e35ef6915a224202$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    }));
}






var $7fPBF = parcelRequire("7fPBF");

const $07742036260be3b5$export$9cb46aada112312d = ()=>{
    const initialTheme = (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).currentTheme();
    const [theme, setTheme] = (0, $7fPBF.useState)(initialTheme);
    (0, $7fPBF.useEffect)(()=>{
        const interval = setInterval(()=>{
            const newTheme = (0, $6b29b0e94aa6dd73$export$5510f7c459d7063c).currentTheme();
            if (theme !== newTheme) setTheme(newTheme);
        }, 1);
        return ()=>clearInterval(interval);
    }, [
        theme
    ]);
    return theme;
};




function $5c121a02b943fe91$var$App() {
    const theme = (0, $07742036260be3b5$export$9cb46aada112312d)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50d7f780bd888ae8$export$a325976a38f291f5), {
                    clientId: "264809982498-r891ifpkg4cseev0h9k7jiei016a3o0g.apps.googleusercontent.com" ?? "",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d42da6e692e216cc$export$9ba4e89fdfa1fc54), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6921d10a59af4a10$export$3565eb3d00ca5a74), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $040541d7bfcee3b2$export$f2815235e76a62b9), {
                theme: theme.palette.mode,
                position: "bottom-right",
                limit: 3,
                newestOnTop: true,
                draggablePercent: 20
            })
        ]
    });
}
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;


const $d7ff3ee147cb4273$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById("root"));
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=public.56719573.js.map
